import { GraphQLResolveInfo, GraphQLScalarType, GraphQLScalarTypeConfig } from "graphql";
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type RequireFields<T, K extends keyof T> = { [X in Exclude<keyof T, K>]?: T[X] } & { [P in K]-?: NonNullable<T[P]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
	ID: string;
	String: string;
	Boolean: boolean;
	Int: number;
	Float: number;
	/** A date, represented as a 'yyyy-mm-dd' string */
	Date: any;
	/** A date and time, represented as an ISO-8601 string */
	DateTime: any;
};

export enum ActionItemCombinationRelation {
	StartingFromOrBeforeRespectivePrescription = "AFTER_OR_BEFORE_RESPECTIVE_PRESCRIPTION",
	StartingFromRespectivePrescription = "AFTER_RESPECTIVE_PRESCRIPTION",
	BeforeRespectivePrescription = "BEFORE_RESPECTIVE_PRESCRIPTION",
}

export enum ActionItemCombinationRule {
	Independently = "INDEPENDENTLY",
	InCombinationWith = "IN_COMBINATION_WITH",
}

export enum ActionItemRangeType {
	After = "AFTER",
	Within = "WITHIN",
}

export enum ActionType {
	Apply = "APPLY",
	Deduct = "DEDUCT",
}

export type AdverseEvent = {
	__typename?: "AdverseEvent";
	TRAE?: Maybe<Scalars["Boolean"]>;
	adverseEvent?: Maybe<AdverseEventType>;
	assessmentDate?: Maybe<Scalars["Date"]>;
	doseModification?: Maybe<IrAdverseEventDoseModifications>;
	grade?: Maybe<AdverseEventGrades>;
	id: Scalars["ID"];
	initialResponse?: Maybe<InitialResponse>;
	initialResponseConnection: AdverseEventInitialResponseConnection;
	status?: Maybe<RecordStatus>;
	tenantId?: Maybe<Scalars["String"]>;
};

export type AdverseEventInitialResponseArgs = {
	options?: InputMaybe<InitialResponseOptions>;
	where?: InputMaybe<InitialResponseWhere>;
};

export type AdverseEventInitialResponseConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<AdverseEventInitialResponseConnectionSort>>;
	where?: InputMaybe<AdverseEventInitialResponseConnectionWhere>;
};

export type AdverseEventAggregateSelection = {
	__typename?: "AdverseEventAggregateSelection";
	count: Scalars["Int"];
	id: IdAggregateSelection;
	tenantId: StringAggregateSelection;
};

export type AdverseEventConnectInput = {
	initialResponse?: InputMaybe<AdverseEventInitialResponseConnectFieldInput>;
};

export type AdverseEventConnectWhere = {
	node: AdverseEventWhere;
};

export type AdverseEventCounterparties = {
	__typename?: "AdverseEventCounterparties";
	id: Scalars["String"];
	name: Scalars["String"];
	role: CounterpartyRole;
};

export type AdverseEventCounterpartiesAggregateSelection = {
	__typename?: "AdverseEventCounterpartiesAggregateSelection";
	count: Scalars["Int"];
	id: StringAggregateSelection;
	name: StringAggregateSelection;
};

export type AdverseEventCounterpartiesOptions = {
	limit?: InputMaybe<Scalars["Int"]>;
	offset?: InputMaybe<Scalars["Int"]>;
	/** Specify one or more AdverseEventCounterpartiesSort objects to sort AdverseEventCounterparties by. The sorts will be applied in the order in which they are arranged in the array. */
	sort?: InputMaybe<Array<InputMaybe<AdverseEventCounterpartiesSort>>>;
};

/** Fields to sort AdverseEventCounterparties by. The order in which sorts are applied is not guaranteed when specifying many fields in one AdverseEventCounterpartiesSort object. */
export type AdverseEventCounterpartiesSort = {
	id?: InputMaybe<SortDirection>;
	name?: InputMaybe<SortDirection>;
	role?: InputMaybe<SortDirection>;
};

export type AdverseEventCounterpartiesWhere = {
	AND?: InputMaybe<Array<AdverseEventCounterpartiesWhere>>;
	OR?: InputMaybe<Array<AdverseEventCounterpartiesWhere>>;
	id?: InputMaybe<Scalars["String"]>;
	id_CONTAINS?: InputMaybe<Scalars["String"]>;
	id_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	id_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	id_MATCHES?: InputMaybe<Scalars["String"]>;
	id_NOT?: InputMaybe<Scalars["String"]>;
	id_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	id_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	id_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	id_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	id_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	name?: InputMaybe<Scalars["String"]>;
	name_CONTAINS?: InputMaybe<Scalars["String"]>;
	name_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	name_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	name_MATCHES?: InputMaybe<Scalars["String"]>;
	name_NOT?: InputMaybe<Scalars["String"]>;
	name_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	name_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	name_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	name_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	name_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	role?: InputMaybe<CounterpartyRole>;
	role_IN?: InputMaybe<Array<InputMaybe<CounterpartyRole>>>;
	role_NOT?: InputMaybe<CounterpartyRole>;
	role_NOT_IN?: InputMaybe<Array<InputMaybe<CounterpartyRole>>>;
};

export type AdverseEventCreateInput = {
	TRAE?: InputMaybe<Scalars["Boolean"]>;
	adverseEvent?: InputMaybe<AdverseEventType>;
	assessmentDate?: InputMaybe<Scalars["Date"]>;
	doseModification?: InputMaybe<IrAdverseEventDoseModifications>;
	grade?: InputMaybe<AdverseEventGrades>;
	id: Scalars["ID"];
	initialResponse?: InputMaybe<AdverseEventInitialResponseFieldInput>;
	status?: InputMaybe<RecordStatus>;
	tenantId?: InputMaybe<Scalars["String"]>;
};

export type AdverseEventDeleteInput = {
	initialResponse?: InputMaybe<AdverseEventInitialResponseDeleteFieldInput>;
};

export type AdverseEventDisconnectInput = {
	initialResponse?: InputMaybe<AdverseEventInitialResponseDisconnectFieldInput>;
};

export enum AdverseEventGrades {
	I = "I",
	Ii = "II",
	Iii = "III",
	Iv = "IV",
}

export type AdverseEventInitialResponseAggregateInput = {
	AND?: InputMaybe<Array<AdverseEventInitialResponseAggregateInput>>;
	OR?: InputMaybe<Array<AdverseEventInitialResponseAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<AdverseEventInitialResponseNodeAggregationWhereInput>;
};

export type AdverseEventInitialResponseConnectFieldInput = {
	connect?: InputMaybe<InitialResponseConnectInput>;
	where?: InputMaybe<InitialResponseConnectWhere>;
};

export type AdverseEventInitialResponseConnection = {
	__typename?: "AdverseEventInitialResponseConnection";
	edges: Array<AdverseEventInitialResponseRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type AdverseEventInitialResponseConnectionSort = {
	node?: InputMaybe<InitialResponseSort>;
};

export type AdverseEventInitialResponseConnectionWhere = {
	AND?: InputMaybe<Array<AdverseEventInitialResponseConnectionWhere>>;
	OR?: InputMaybe<Array<AdverseEventInitialResponseConnectionWhere>>;
	node?: InputMaybe<InitialResponseWhere>;
	node_NOT?: InputMaybe<InitialResponseWhere>;
};

export type AdverseEventInitialResponseCreateFieldInput = {
	node: InitialResponseCreateInput;
};

export type AdverseEventInitialResponseDeleteFieldInput = {
	delete?: InputMaybe<InitialResponseDeleteInput>;
	where?: InputMaybe<AdverseEventInitialResponseConnectionWhere>;
};

export type AdverseEventInitialResponseDisconnectFieldInput = {
	disconnect?: InputMaybe<InitialResponseDisconnectInput>;
	where?: InputMaybe<AdverseEventInitialResponseConnectionWhere>;
};

export type AdverseEventInitialResponseFieldInput = {
	connect?: InputMaybe<AdverseEventInitialResponseConnectFieldInput>;
	create?: InputMaybe<AdverseEventInitialResponseCreateFieldInput>;
};

export type AdverseEventInitialResponseNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<AdverseEventInitialResponseNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<AdverseEventInitialResponseNodeAggregationWhereInput>>;
	createdOn_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	numberOfPrescriptionsToDate_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	numberOfPrescriptionsToDate_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	numberOfPrescriptionsToDate_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	numberOfPrescriptionsToDate_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	numberOfPrescriptionsToDate_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	numberOfPrescriptionsToDate_EQUAL?: InputMaybe<Scalars["Int"]>;
	numberOfPrescriptionsToDate_GT?: InputMaybe<Scalars["Int"]>;
	numberOfPrescriptionsToDate_GTE?: InputMaybe<Scalars["Int"]>;
	numberOfPrescriptionsToDate_LT?: InputMaybe<Scalars["Int"]>;
	numberOfPrescriptionsToDate_LTE?: InputMaybe<Scalars["Int"]>;
	numberOfPrescriptionsToDate_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	numberOfPrescriptionsToDate_MAX_GT?: InputMaybe<Scalars["Int"]>;
	numberOfPrescriptionsToDate_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	numberOfPrescriptionsToDate_MAX_LT?: InputMaybe<Scalars["Int"]>;
	numberOfPrescriptionsToDate_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	numberOfPrescriptionsToDate_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	numberOfPrescriptionsToDate_MIN_GT?: InputMaybe<Scalars["Int"]>;
	numberOfPrescriptionsToDate_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	numberOfPrescriptionsToDate_MIN_LT?: InputMaybe<Scalars["Int"]>;
	numberOfPrescriptionsToDate_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	submissionDate_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_GT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_GTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_LT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_LTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	tenantId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	tenantId_EQUAL?: InputMaybe<Scalars["String"]>;
	tenantId_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type AdverseEventInitialResponseRelationship = {
	__typename?: "AdverseEventInitialResponseRelationship";
	cursor: Scalars["String"];
	node: InitialResponse;
};

export type AdverseEventInitialResponseUpdateConnectionInput = {
	node?: InputMaybe<InitialResponseUpdateInput>;
};

export type AdverseEventInitialResponseUpdateFieldInput = {
	connect?: InputMaybe<AdverseEventInitialResponseConnectFieldInput>;
	create?: InputMaybe<AdverseEventInitialResponseCreateFieldInput>;
	delete?: InputMaybe<AdverseEventInitialResponseDeleteFieldInput>;
	disconnect?: InputMaybe<AdverseEventInitialResponseDisconnectFieldInput>;
	update?: InputMaybe<AdverseEventInitialResponseUpdateConnectionInput>;
	where?: InputMaybe<AdverseEventInitialResponseConnectionWhere>;
};

export type AdverseEventInput = {
	TRAE?: InputMaybe<Scalars["Boolean"]>;
	adverseEvent?: InputMaybe<IrAdverseEvents>;
	assessmentDate?: InputMaybe<Scalars["Date"]>;
	doseModification?: InputMaybe<IrAdverseEventDoseModifications>;
	grade?: InputMaybe<IrAdverseEventGrades>;
	id: Scalars["ID"];
};

export type AdverseEventOptions = {
	limit?: InputMaybe<Scalars["Int"]>;
	offset?: InputMaybe<Scalars["Int"]>;
	/** Specify one or more AdverseEventSort objects to sort AdverseEvents by. The sorts will be applied in the order in which they are arranged in the array. */
	sort?: InputMaybe<Array<InputMaybe<AdverseEventSort>>>;
};

export type AdverseEventReport = {
	__typename?: "AdverseEventReport";
	adverseEvents: Array<AdverseEvent>;
	agreementId?: Maybe<Scalars["String"]>;
	agreementName?: Maybe<Scalars["String"]>;
	caseId?: Maybe<Scalars["String"]>;
	diseaseName?: Maybe<Scalars["String"]>;
	formPreparationBrandName?: Maybe<Scalars["String"]>;
	id: Scalars["String"];
	indicationCode?: Maybe<Scalars["String"]>;
	initials?: Maybe<Scalars["String"]>;
	preparationBrandName?: Maybe<Scalars["String"]>;
	tags: Array<AgreementTag>;
	therapyStartDate?: Maybe<Scalars["Date"]>;
	treatingPhysician?: Maybe<TreatingPhysician>;
	yearOfBirth?: Maybe<Scalars["Int"]>;
};

export type AdverseEventReportAggregateSelection = {
	__typename?: "AdverseEventReportAggregateSelection";
	agreementId: StringAggregateSelection;
	agreementName: StringAggregateSelection;
	caseId: StringAggregateSelection;
	count: Scalars["Int"];
	diseaseName: StringAggregateSelection;
	formPreparationBrandName: StringAggregateSelection;
	id: StringAggregateSelection;
	indicationCode: StringAggregateSelection;
	initials: StringAggregateSelection;
	preparationBrandName: StringAggregateSelection;
	yearOfBirth: IntAggregateSelection;
};

export type AdverseEventReportOptions = {
	limit?: InputMaybe<Scalars["Int"]>;
	offset?: InputMaybe<Scalars["Int"]>;
	/** Specify one or more AdverseEventReportSort objects to sort AdverseEventReports by. The sorts will be applied in the order in which they are arranged in the array. */
	sort?: InputMaybe<Array<InputMaybe<AdverseEventReportSort>>>;
};

/** Fields to sort AdverseEventReports by. The order in which sorts are applied is not guaranteed when specifying many fields in one AdverseEventReportSort object. */
export type AdverseEventReportSort = {
	agreementId?: InputMaybe<SortDirection>;
	agreementName?: InputMaybe<SortDirection>;
	caseId?: InputMaybe<SortDirection>;
	diseaseName?: InputMaybe<SortDirection>;
	formPreparationBrandName?: InputMaybe<SortDirection>;
	id?: InputMaybe<SortDirection>;
	indicationCode?: InputMaybe<SortDirection>;
	initials?: InputMaybe<SortDirection>;
	preparationBrandName?: InputMaybe<SortDirection>;
	therapyStartDate?: InputMaybe<SortDirection>;
	yearOfBirth?: InputMaybe<SortDirection>;
};

export type AdverseEventReportWhere = {
	AND?: InputMaybe<Array<AdverseEventReportWhere>>;
	OR?: InputMaybe<Array<AdverseEventReportWhere>>;
	agreementId?: InputMaybe<Scalars["String"]>;
	agreementId_CONTAINS?: InputMaybe<Scalars["String"]>;
	agreementId_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	agreementId_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	agreementId_MATCHES?: InputMaybe<Scalars["String"]>;
	agreementId_NOT?: InputMaybe<Scalars["String"]>;
	agreementId_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	agreementId_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	agreementId_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	agreementId_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	agreementId_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	agreementName?: InputMaybe<Scalars["String"]>;
	agreementName_CONTAINS?: InputMaybe<Scalars["String"]>;
	agreementName_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	agreementName_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	agreementName_MATCHES?: InputMaybe<Scalars["String"]>;
	agreementName_NOT?: InputMaybe<Scalars["String"]>;
	agreementName_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	agreementName_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	agreementName_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	agreementName_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	agreementName_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	caseId?: InputMaybe<Scalars["String"]>;
	caseId_CONTAINS?: InputMaybe<Scalars["String"]>;
	caseId_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	caseId_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	caseId_MATCHES?: InputMaybe<Scalars["String"]>;
	caseId_NOT?: InputMaybe<Scalars["String"]>;
	caseId_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	caseId_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	caseId_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	caseId_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	caseId_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	diseaseName?: InputMaybe<Scalars["String"]>;
	diseaseName_CONTAINS?: InputMaybe<Scalars["String"]>;
	diseaseName_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	diseaseName_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	diseaseName_MATCHES?: InputMaybe<Scalars["String"]>;
	diseaseName_NOT?: InputMaybe<Scalars["String"]>;
	diseaseName_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	diseaseName_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	diseaseName_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	diseaseName_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	diseaseName_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	formPreparationBrandName?: InputMaybe<Scalars["String"]>;
	formPreparationBrandName_CONTAINS?: InputMaybe<Scalars["String"]>;
	formPreparationBrandName_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	formPreparationBrandName_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	formPreparationBrandName_MATCHES?: InputMaybe<Scalars["String"]>;
	formPreparationBrandName_NOT?: InputMaybe<Scalars["String"]>;
	formPreparationBrandName_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	formPreparationBrandName_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	formPreparationBrandName_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	formPreparationBrandName_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	formPreparationBrandName_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	id?: InputMaybe<Scalars["String"]>;
	id_CONTAINS?: InputMaybe<Scalars["String"]>;
	id_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	id_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	id_MATCHES?: InputMaybe<Scalars["String"]>;
	id_NOT?: InputMaybe<Scalars["String"]>;
	id_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	id_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	id_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	id_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	id_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	indicationCode?: InputMaybe<Scalars["String"]>;
	indicationCode_CONTAINS?: InputMaybe<Scalars["String"]>;
	indicationCode_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	indicationCode_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	indicationCode_MATCHES?: InputMaybe<Scalars["String"]>;
	indicationCode_NOT?: InputMaybe<Scalars["String"]>;
	indicationCode_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	indicationCode_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	indicationCode_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	indicationCode_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	indicationCode_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	initials?: InputMaybe<Scalars["String"]>;
	initials_CONTAINS?: InputMaybe<Scalars["String"]>;
	initials_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	initials_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	initials_MATCHES?: InputMaybe<Scalars["String"]>;
	initials_NOT?: InputMaybe<Scalars["String"]>;
	initials_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	initials_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	initials_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	initials_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	initials_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	preparationBrandName?: InputMaybe<Scalars["String"]>;
	preparationBrandName_CONTAINS?: InputMaybe<Scalars["String"]>;
	preparationBrandName_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	preparationBrandName_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	preparationBrandName_MATCHES?: InputMaybe<Scalars["String"]>;
	preparationBrandName_NOT?: InputMaybe<Scalars["String"]>;
	preparationBrandName_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	preparationBrandName_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	preparationBrandName_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	preparationBrandName_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	preparationBrandName_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	therapyStartDate?: InputMaybe<Scalars["Date"]>;
	therapyStartDate_GT?: InputMaybe<Scalars["Date"]>;
	therapyStartDate_GTE?: InputMaybe<Scalars["Date"]>;
	therapyStartDate_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
	therapyStartDate_LT?: InputMaybe<Scalars["Date"]>;
	therapyStartDate_LTE?: InputMaybe<Scalars["Date"]>;
	therapyStartDate_NOT?: InputMaybe<Scalars["Date"]>;
	therapyStartDate_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
	yearOfBirth?: InputMaybe<Scalars["Int"]>;
	yearOfBirth_GT?: InputMaybe<Scalars["Int"]>;
	yearOfBirth_GTE?: InputMaybe<Scalars["Int"]>;
	yearOfBirth_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	yearOfBirth_LT?: InputMaybe<Scalars["Int"]>;
	yearOfBirth_LTE?: InputMaybe<Scalars["Int"]>;
	yearOfBirth_NOT?: InputMaybe<Scalars["Int"]>;
	yearOfBirth_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
};

/** Fields to sort AdverseEvents by. The order in which sorts are applied is not guaranteed when specifying many fields in one AdverseEventSort object. */
export type AdverseEventSort = {
	TRAE?: InputMaybe<SortDirection>;
	adverseEvent?: InputMaybe<SortDirection>;
	assessmentDate?: InputMaybe<SortDirection>;
	doseModification?: InputMaybe<SortDirection>;
	grade?: InputMaybe<SortDirection>;
	id?: InputMaybe<SortDirection>;
	status?: InputMaybe<SortDirection>;
	tenantId?: InputMaybe<SortDirection>;
};

export enum AdverseEventType {
	AcuteHepatitis = "ACUTE_HEPATITIS",
	AltIncreased = "ALT_INCREASED",
	AstIncreased = "AST_INCREASED",
	Colitis = "COLITIS",
	Diarrhoea = "DIARRHOEA",
	Hypopituitarism = "HYPOPITUITARISM",
	InterstitialLungDisease = "INTERSTITIAL_LUNG_DISEASE",
	Pneumonitis = "PNEUMONITIS",
	Pyrexia = "PYREXIA",
}

export type AdverseEventUpdateInput = {
	TRAE?: InputMaybe<Scalars["Boolean"]>;
	adverseEvent?: InputMaybe<AdverseEventType>;
	assessmentDate?: InputMaybe<Scalars["Date"]>;
	doseModification?: InputMaybe<IrAdverseEventDoseModifications>;
	grade?: InputMaybe<AdverseEventGrades>;
	id?: InputMaybe<Scalars["ID"]>;
	initialResponse?: InputMaybe<AdverseEventInitialResponseUpdateFieldInput>;
	status?: InputMaybe<RecordStatus>;
	tenantId?: InputMaybe<Scalars["String"]>;
};

export type AdverseEventWhere = {
	AND?: InputMaybe<Array<AdverseEventWhere>>;
	OR?: InputMaybe<Array<AdverseEventWhere>>;
	TRAE?: InputMaybe<Scalars["Boolean"]>;
	TRAE_NOT?: InputMaybe<Scalars["Boolean"]>;
	adverseEvent?: InputMaybe<AdverseEventType>;
	adverseEvent_IN?: InputMaybe<Array<InputMaybe<AdverseEventType>>>;
	adverseEvent_NOT?: InputMaybe<AdverseEventType>;
	adverseEvent_NOT_IN?: InputMaybe<Array<InputMaybe<AdverseEventType>>>;
	assessmentDate?: InputMaybe<Scalars["Date"]>;
	assessmentDate_GT?: InputMaybe<Scalars["Date"]>;
	assessmentDate_GTE?: InputMaybe<Scalars["Date"]>;
	assessmentDate_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
	assessmentDate_LT?: InputMaybe<Scalars["Date"]>;
	assessmentDate_LTE?: InputMaybe<Scalars["Date"]>;
	assessmentDate_NOT?: InputMaybe<Scalars["Date"]>;
	assessmentDate_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
	doseModification?: InputMaybe<IrAdverseEventDoseModifications>;
	doseModification_IN?: InputMaybe<Array<InputMaybe<IrAdverseEventDoseModifications>>>;
	doseModification_NOT?: InputMaybe<IrAdverseEventDoseModifications>;
	doseModification_NOT_IN?: InputMaybe<Array<InputMaybe<IrAdverseEventDoseModifications>>>;
	grade?: InputMaybe<AdverseEventGrades>;
	grade_IN?: InputMaybe<Array<InputMaybe<AdverseEventGrades>>>;
	grade_NOT?: InputMaybe<AdverseEventGrades>;
	grade_NOT_IN?: InputMaybe<Array<InputMaybe<AdverseEventGrades>>>;
	id?: InputMaybe<Scalars["ID"]>;
	id_CONTAINS?: InputMaybe<Scalars["ID"]>;
	id_ENDS_WITH?: InputMaybe<Scalars["ID"]>;
	id_IN?: InputMaybe<Array<InputMaybe<Scalars["ID"]>>>;
	id_MATCHES?: InputMaybe<Scalars["String"]>;
	id_NOT?: InputMaybe<Scalars["ID"]>;
	id_NOT_CONTAINS?: InputMaybe<Scalars["ID"]>;
	id_NOT_ENDS_WITH?: InputMaybe<Scalars["ID"]>;
	id_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["ID"]>>>;
	id_NOT_STARTS_WITH?: InputMaybe<Scalars["ID"]>;
	id_STARTS_WITH?: InputMaybe<Scalars["ID"]>;
	initialResponse?: InputMaybe<InitialResponseWhere>;
	initialResponseAggregate?: InputMaybe<AdverseEventInitialResponseAggregateInput>;
	initialResponseConnection?: InputMaybe<AdverseEventInitialResponseConnectionWhere>;
	initialResponseConnection_NOT?: InputMaybe<AdverseEventInitialResponseConnectionWhere>;
	initialResponse_NOT?: InputMaybe<InitialResponseWhere>;
	status?: InputMaybe<RecordStatus>;
	status_IN?: InputMaybe<Array<InputMaybe<RecordStatus>>>;
	status_NOT?: InputMaybe<RecordStatus>;
	status_NOT_IN?: InputMaybe<Array<InputMaybe<RecordStatus>>>;
	tenantId?: InputMaybe<Scalars["String"]>;
	tenantId_CONTAINS?: InputMaybe<Scalars["String"]>;
	tenantId_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	tenantId_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	tenantId_MATCHES?: InputMaybe<Scalars["String"]>;
	tenantId_NOT?: InputMaybe<Scalars["String"]>;
	tenantId_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	tenantId_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	tenantId_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	tenantId_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	tenantId_STARTS_WITH?: InputMaybe<Scalars["String"]>;
};

export type AdverseEventsOccurenceReport = {
	__typename?: "AdverseEventsOccurenceReport";
	adverseEvent?: Maybe<AdverseEventType>;
	gradeICount?: Maybe<Scalars["Int"]>;
	gradeIICount?: Maybe<Scalars["Int"]>;
	gradeIIICount?: Maybe<Scalars["Int"]>;
	gradeIVCount?: Maybe<Scalars["Int"]>;
};

export type AdverseEventsOccurenceReportAggregateSelection = {
	__typename?: "AdverseEventsOccurenceReportAggregateSelection";
	count: Scalars["Int"];
	gradeICount: IntAggregateSelection;
	gradeIICount: IntAggregateSelection;
	gradeIIICount: IntAggregateSelection;
	gradeIVCount: IntAggregateSelection;
};

export type AdverseEventsOccurenceReportCreateInput = {
	adverseEvent?: InputMaybe<AdverseEventType>;
	gradeICount?: InputMaybe<Scalars["Int"]>;
	gradeIICount?: InputMaybe<Scalars["Int"]>;
	gradeIIICount?: InputMaybe<Scalars["Int"]>;
	gradeIVCount?: InputMaybe<Scalars["Int"]>;
};

export type AdverseEventsOccurenceReportOptions = {
	limit?: InputMaybe<Scalars["Int"]>;
	offset?: InputMaybe<Scalars["Int"]>;
	/** Specify one or more AdverseEventsOccurenceReportSort objects to sort AdverseEventsOccurenceReports by. The sorts will be applied in the order in which they are arranged in the array. */
	sort?: InputMaybe<Array<InputMaybe<AdverseEventsOccurenceReportSort>>>;
};

/** Fields to sort AdverseEventsOccurenceReports by. The order in which sorts are applied is not guaranteed when specifying many fields in one AdverseEventsOccurenceReportSort object. */
export type AdverseEventsOccurenceReportSort = {
	adverseEvent?: InputMaybe<SortDirection>;
	gradeICount?: InputMaybe<SortDirection>;
	gradeIICount?: InputMaybe<SortDirection>;
	gradeIIICount?: InputMaybe<SortDirection>;
	gradeIVCount?: InputMaybe<SortDirection>;
};

export type AdverseEventsOccurenceReportUpdateInput = {
	adverseEvent?: InputMaybe<AdverseEventType>;
	gradeICount?: InputMaybe<Scalars["Int"]>;
	gradeIICount?: InputMaybe<Scalars["Int"]>;
	gradeIIICount?: InputMaybe<Scalars["Int"]>;
	gradeIVCount?: InputMaybe<Scalars["Int"]>;
};

export type AdverseEventsOccurenceReportWhere = {
	AND?: InputMaybe<Array<AdverseEventsOccurenceReportWhere>>;
	OR?: InputMaybe<Array<AdverseEventsOccurenceReportWhere>>;
	adverseEvent?: InputMaybe<AdverseEventType>;
	adverseEvent_IN?: InputMaybe<Array<InputMaybe<AdverseEventType>>>;
	adverseEvent_NOT?: InputMaybe<AdverseEventType>;
	adverseEvent_NOT_IN?: InputMaybe<Array<InputMaybe<AdverseEventType>>>;
	gradeICount?: InputMaybe<Scalars["Int"]>;
	gradeICount_GT?: InputMaybe<Scalars["Int"]>;
	gradeICount_GTE?: InputMaybe<Scalars["Int"]>;
	gradeICount_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	gradeICount_LT?: InputMaybe<Scalars["Int"]>;
	gradeICount_LTE?: InputMaybe<Scalars["Int"]>;
	gradeICount_NOT?: InputMaybe<Scalars["Int"]>;
	gradeICount_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	gradeIICount?: InputMaybe<Scalars["Int"]>;
	gradeIICount_GT?: InputMaybe<Scalars["Int"]>;
	gradeIICount_GTE?: InputMaybe<Scalars["Int"]>;
	gradeIICount_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	gradeIICount_LT?: InputMaybe<Scalars["Int"]>;
	gradeIICount_LTE?: InputMaybe<Scalars["Int"]>;
	gradeIICount_NOT?: InputMaybe<Scalars["Int"]>;
	gradeIICount_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	gradeIIICount?: InputMaybe<Scalars["Int"]>;
	gradeIIICount_GT?: InputMaybe<Scalars["Int"]>;
	gradeIIICount_GTE?: InputMaybe<Scalars["Int"]>;
	gradeIIICount_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	gradeIIICount_LT?: InputMaybe<Scalars["Int"]>;
	gradeIIICount_LTE?: InputMaybe<Scalars["Int"]>;
	gradeIIICount_NOT?: InputMaybe<Scalars["Int"]>;
	gradeIIICount_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	gradeIVCount?: InputMaybe<Scalars["Int"]>;
	gradeIVCount_GT?: InputMaybe<Scalars["Int"]>;
	gradeIVCount_GTE?: InputMaybe<Scalars["Int"]>;
	gradeIVCount_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	gradeIVCount_LT?: InputMaybe<Scalars["Int"]>;
	gradeIVCount_LTE?: InputMaybe<Scalars["Int"]>;
	gradeIVCount_NOT?: InputMaybe<Scalars["Int"]>;
	gradeIVCount_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
};

export type Agreement = {
	__typename?: "Agreement";
	allowedForms?: Maybe<Array<FormType>>;
	canParticipateInApproval: Scalars["Boolean"];
	canUserViewFinancials: Scalars["Boolean"];
	counterpartyRoles: Array<Organization>;
	counterpartyRolesConnection: AgreementCounterpartyRolesConnection;
	currency?: Maybe<Currency>;
	currencyConnection: AgreementCurrencyConnection;
	description?: Maybe<Scalars["String"]>;
	deviceAlternativeSets: Array<DeviceAlternative>;
	deviceAlternativeSetsConnection: AgreementDeviceAlternativeSetsConnection;
	formattedAmount?: Maybe<Scalars["String"]>;
	formattedCounterparties?: Maybe<Scalars["String"]>;
	formattedProducts?: Maybe<Scalars["String"]>;
	formattedTags: Scalars["String"];
	formattedValidityPeriod?: Maybe<Scalars["String"]>;
	id: Scalars["ID"];
	initialVersionId: Scalars["String"];
	isApprovedByOrganization: Scalars["Boolean"];
	isArchived?: Maybe<Scalars["Boolean"]>;
	isDeleted?: Maybe<Scalars["Boolean"]>;
	isFirstVersion: Scalars["Boolean"];
	isHidden: Scalars["Boolean"];
	isInsightsAvailable?: Maybe<Scalars["Boolean"]>;
	isLastVersion: Scalars["Boolean"];
	isRatingEnabled?: Maybe<Scalars["Boolean"]>;
	isStobContract: Scalars["Boolean"];
	isTherapyDecisionEnabled?: Maybe<Scalars["Boolean"]>;
	lastVersionValidToDate?: Maybe<Scalars["Date"]>;
	name: Scalars["String"];
	status?: Maybe<ContractStatus>;
	tags: Array<AgreementTag>;
	tagsConnection: AgreementTagsConnection;
	tenantIds?: Maybe<Array<Scalars["String"]>>;
	totalAmount?: Maybe<Scalars["Float"]>;
	unlimited?: Maybe<Scalars["Int"]>;
	userOrganizationRole?: Maybe<CounterpartyRole>;
	userRoles: Array<User>;
	userRolesConnection: AgreementUserRolesConnection;
	validFromDate: Scalars["Date"];
	validToDate?: Maybe<Scalars["Date"]>;
	workflows: Array<ContractWorkflow>;
	workflowsConnection: AgreementWorkflowsConnection;
};

export type AgreementCounterpartyRolesArgs = {
	options?: InputMaybe<OrganizationOptions>;
	where?: InputMaybe<OrganizationWhere>;
};

export type AgreementCounterpartyRolesConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<AgreementCounterpartyRolesConnectionSort>>;
	where?: InputMaybe<AgreementCounterpartyRolesConnectionWhere>;
};

export type AgreementCurrencyArgs = {
	options?: InputMaybe<CurrencyOptions>;
	where?: InputMaybe<CurrencyWhere>;
};

export type AgreementCurrencyConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<AgreementCurrencyConnectionSort>>;
	where?: InputMaybe<AgreementCurrencyConnectionWhere>;
};

export type AgreementDeviceAlternativeSetsArgs = {
	options?: InputMaybe<DeviceAlternativeOptions>;
	where?: InputMaybe<DeviceAlternativeWhere>;
};

export type AgreementDeviceAlternativeSetsConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<AgreementDeviceAlternativeSetsConnectionSort>>;
	where?: InputMaybe<AgreementDeviceAlternativeSetsConnectionWhere>;
};

export type AgreementTagsArgs = {
	options?: InputMaybe<AgreementTagOptions>;
	where?: InputMaybe<AgreementTagWhere>;
};

export type AgreementTagsConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<AgreementTagsConnectionSort>>;
	where?: InputMaybe<AgreementTagsConnectionWhere>;
};

export type AgreementUserRolesArgs = {
	options?: InputMaybe<UserOptions>;
	where?: InputMaybe<UserWhere>;
};

export type AgreementUserRolesConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<AgreementUserRolesConnectionSort>>;
	where?: InputMaybe<AgreementUserRolesConnectionWhere>;
};

export type AgreementWorkflowsArgs = {
	options?: InputMaybe<ContractWorkflowOptions>;
	where?: InputMaybe<ContractWorkflowWhere>;
};

export type AgreementWorkflowsConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<AgreementWorkflowsConnectionSort>>;
	where?: InputMaybe<AgreementWorkflowsConnectionWhere>;
};

export type AgreementAggregateSelection = {
	__typename?: "AgreementAggregateSelection";
	count: Scalars["Int"];
	description: StringAggregateSelection;
	formattedAmount: StringAggregateSelection;
	formattedCounterparties: StringAggregateSelection;
	formattedProducts: StringAggregateSelection;
	formattedTags: StringAggregateSelection;
	formattedValidityPeriod: StringAggregateSelection;
	id: IdAggregateSelection;
	initialVersionId: StringAggregateSelection;
	name: StringAggregateSelection;
	totalAmount: FloatAggregateSelection;
	unlimited: IntAggregateSelection;
};

export type AgreementConnectInput = {
	counterpartyRoles?: InputMaybe<Array<AgreementCounterpartyRolesConnectFieldInput>>;
	currency?: InputMaybe<AgreementCurrencyConnectFieldInput>;
	deviceAlternativeSets?: InputMaybe<Array<AgreementDeviceAlternativeSetsConnectFieldInput>>;
	tags?: InputMaybe<Array<AgreementTagsConnectFieldInput>>;
	userRoles?: InputMaybe<Array<AgreementUserRolesConnectFieldInput>>;
	workflows?: InputMaybe<Array<AgreementWorkflowsConnectFieldInput>>;
};

export type AgreementConnectWhere = {
	node: AgreementWhere;
};

export type AgreementCounterpartyRolesAggregateInput = {
	AND?: InputMaybe<Array<AgreementCounterpartyRolesAggregateInput>>;
	OR?: InputMaybe<Array<AgreementCounterpartyRolesAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<AgreementCounterpartyRolesNodeAggregationWhereInput>;
};

export type AgreementCounterpartyRolesConnectFieldInput = {
	edge: CounterpartyRoleRelationshipCreateInput;
	where?: InputMaybe<OrganizationConnectWhere>;
};

export type AgreementCounterpartyRolesConnection = {
	__typename?: "AgreementCounterpartyRolesConnection";
	edges: Array<AgreementCounterpartyRolesRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type AgreementCounterpartyRolesConnectionSort = {
	edge?: InputMaybe<CounterpartyRoleRelationshipSort>;
	node?: InputMaybe<OrganizationSort>;
};

export type AgreementCounterpartyRolesConnectionWhere = {
	AND?: InputMaybe<Array<AgreementCounterpartyRolesConnectionWhere>>;
	OR?: InputMaybe<Array<AgreementCounterpartyRolesConnectionWhere>>;
	edge?: InputMaybe<CounterpartyRoleRelationshipWhere>;
	edge_NOT?: InputMaybe<CounterpartyRoleRelationshipWhere>;
	node?: InputMaybe<OrganizationWhere>;
	node_NOT?: InputMaybe<OrganizationWhere>;
};

export type AgreementCounterpartyRolesCreateFieldInput = {
	edge: CounterpartyRoleRelationshipCreateInput;
	node: OrganizationCreateInput;
};

export type AgreementCounterpartyRolesDeleteFieldInput = {
	where?: InputMaybe<AgreementCounterpartyRolesConnectionWhere>;
};

export type AgreementCounterpartyRolesDisconnectFieldInput = {
	where?: InputMaybe<AgreementCounterpartyRolesConnectionWhere>;
};

export type AgreementCounterpartyRolesFieldInput = {
	connect?: InputMaybe<Array<AgreementCounterpartyRolesConnectFieldInput>>;
	create?: InputMaybe<Array<AgreementCounterpartyRolesCreateFieldInput>>;
};

export type AgreementCounterpartyRolesNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<AgreementCounterpartyRolesNodeAggregationWhereInput>>;
	IBAN_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	IBAN_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	IBAN_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	IBAN_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	IBAN_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	IBAN_EQUAL?: InputMaybe<Scalars["String"]>;
	IBAN_GT?: InputMaybe<Scalars["Int"]>;
	IBAN_GTE?: InputMaybe<Scalars["Int"]>;
	IBAN_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	IBAN_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	IBAN_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	IBAN_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	IBAN_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	IBAN_LT?: InputMaybe<Scalars["Int"]>;
	IBAN_LTE?: InputMaybe<Scalars["Int"]>;
	IBAN_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	IBAN_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	IBAN_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	IBAN_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	IBAN_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	OR?: InputMaybe<Array<AgreementCounterpartyRolesNodeAggregationWhereInput>>;
	billingAddress_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	billingAddress_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	billingAddress_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	billingAddress_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	billingAddress_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	billingAddress_EQUAL?: InputMaybe<Scalars["String"]>;
	billingAddress_GT?: InputMaybe<Scalars["Int"]>;
	billingAddress_GTE?: InputMaybe<Scalars["Int"]>;
	billingAddress_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	billingAddress_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	billingAddress_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	billingAddress_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	billingAddress_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	billingAddress_LT?: InputMaybe<Scalars["Int"]>;
	billingAddress_LTE?: InputMaybe<Scalars["Int"]>;
	billingAddress_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	billingAddress_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	billingAddress_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	billingAddress_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	billingAddress_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	contactEmail_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	contactEmail_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	contactEmail_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	contactEmail_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	contactEmail_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	contactEmail_EQUAL?: InputMaybe<Scalars["String"]>;
	contactEmail_GT?: InputMaybe<Scalars["Int"]>;
	contactEmail_GTE?: InputMaybe<Scalars["Int"]>;
	contactEmail_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	contactEmail_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	contactEmail_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	contactEmail_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	contactEmail_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	contactEmail_LT?: InputMaybe<Scalars["Int"]>;
	contactEmail_LTE?: InputMaybe<Scalars["Int"]>;
	contactEmail_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	contactEmail_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	contactEmail_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	contactEmail_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	contactEmail_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	contactFirstName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	contactFirstName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	contactFirstName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	contactFirstName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	contactFirstName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	contactFirstName_EQUAL?: InputMaybe<Scalars["String"]>;
	contactFirstName_GT?: InputMaybe<Scalars["Int"]>;
	contactFirstName_GTE?: InputMaybe<Scalars["Int"]>;
	contactFirstName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	contactFirstName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	contactFirstName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	contactFirstName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	contactFirstName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	contactFirstName_LT?: InputMaybe<Scalars["Int"]>;
	contactFirstName_LTE?: InputMaybe<Scalars["Int"]>;
	contactFirstName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	contactFirstName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	contactFirstName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	contactFirstName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	contactFirstName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	contactLastName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	contactLastName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	contactLastName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	contactLastName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	contactLastName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	contactLastName_EQUAL?: InputMaybe<Scalars["String"]>;
	contactLastName_GT?: InputMaybe<Scalars["Int"]>;
	contactLastName_GTE?: InputMaybe<Scalars["Int"]>;
	contactLastName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	contactLastName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	contactLastName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	contactLastName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	contactLastName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	contactLastName_LT?: InputMaybe<Scalars["Int"]>;
	contactLastName_LTE?: InputMaybe<Scalars["Int"]>;
	contactLastName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	contactLastName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	contactLastName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	contactLastName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	contactLastName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	contactOccupation_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	contactOccupation_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	contactOccupation_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	contactOccupation_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	contactOccupation_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	contactOccupation_EQUAL?: InputMaybe<Scalars["String"]>;
	contactOccupation_GT?: InputMaybe<Scalars["Int"]>;
	contactOccupation_GTE?: InputMaybe<Scalars["Int"]>;
	contactOccupation_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	contactOccupation_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	contactOccupation_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	contactOccupation_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	contactOccupation_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	contactOccupation_LT?: InputMaybe<Scalars["Int"]>;
	contactOccupation_LTE?: InputMaybe<Scalars["Int"]>;
	contactOccupation_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	contactOccupation_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	contactOccupation_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	contactOccupation_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	contactOccupation_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	contactPhone_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	contactPhone_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	contactPhone_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	contactPhone_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	contactPhone_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	contactPhone_EQUAL?: InputMaybe<Scalars["String"]>;
	contactPhone_GT?: InputMaybe<Scalars["Int"]>;
	contactPhone_GTE?: InputMaybe<Scalars["Int"]>;
	contactPhone_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	contactPhone_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	contactPhone_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	contactPhone_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	contactPhone_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	contactPhone_LT?: InputMaybe<Scalars["Int"]>;
	contactPhone_LTE?: InputMaybe<Scalars["Int"]>;
	contactPhone_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	contactPhone_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	contactPhone_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	contactPhone_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	contactPhone_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	domicile_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	domicile_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	domicile_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	domicile_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	domicile_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	domicile_EQUAL?: InputMaybe<Scalars["String"]>;
	domicile_GT?: InputMaybe<Scalars["Int"]>;
	domicile_GTE?: InputMaybe<Scalars["Int"]>;
	domicile_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	domicile_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	domicile_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	domicile_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	domicile_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	domicile_LT?: InputMaybe<Scalars["Int"]>;
	domicile_LTE?: InputMaybe<Scalars["Int"]>;
	domicile_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	domicile_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	domicile_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	domicile_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	domicile_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	eIN_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	eIN_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	eIN_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	eIN_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	eIN_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	eIN_EQUAL?: InputMaybe<Scalars["String"]>;
	eIN_GT?: InputMaybe<Scalars["Int"]>;
	eIN_GTE?: InputMaybe<Scalars["Int"]>;
	eIN_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	eIN_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	eIN_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	eIN_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	eIN_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	eIN_LT?: InputMaybe<Scalars["Int"]>;
	eIN_LTE?: InputMaybe<Scalars["Int"]>;
	eIN_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	eIN_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	eIN_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	eIN_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	eIN_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	fax_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	fax_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	fax_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	fax_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	fax_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	fax_EQUAL?: InputMaybe<Scalars["String"]>;
	fax_GT?: InputMaybe<Scalars["Int"]>;
	fax_GTE?: InputMaybe<Scalars["Int"]>;
	fax_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	fax_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	fax_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	fax_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	fax_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	fax_LT?: InputMaybe<Scalars["Int"]>;
	fax_LTE?: InputMaybe<Scalars["Int"]>;
	fax_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	fax_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	fax_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	fax_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	fax_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	legalName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	legalName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	legalName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	legalName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	legalName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	legalName_EQUAL?: InputMaybe<Scalars["String"]>;
	legalName_GT?: InputMaybe<Scalars["Int"]>;
	legalName_GTE?: InputMaybe<Scalars["Int"]>;
	legalName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	legalName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	legalName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	legalName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	legalName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	legalName_LT?: InputMaybe<Scalars["Int"]>;
	legalName_LTE?: InputMaybe<Scalars["Int"]>;
	legalName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	legalName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	legalName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	legalName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	legalName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	logo_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	logo_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	logo_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	logo_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	logo_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	logo_EQUAL?: InputMaybe<Scalars["String"]>;
	logo_GT?: InputMaybe<Scalars["Int"]>;
	logo_GTE?: InputMaybe<Scalars["Int"]>;
	logo_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	logo_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	logo_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	logo_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	logo_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	logo_LT?: InputMaybe<Scalars["Int"]>;
	logo_LTE?: InputMaybe<Scalars["Int"]>;
	logo_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	logo_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	logo_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	logo_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	logo_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	name_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	name_EQUAL?: InputMaybe<Scalars["String"]>;
	name_GT?: InputMaybe<Scalars["Int"]>;
	name_GTE?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	name_LT?: InputMaybe<Scalars["Int"]>;
	name_LTE?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	phone_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	phone_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	phone_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	phone_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	phone_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	phone_EQUAL?: InputMaybe<Scalars["String"]>;
	phone_GT?: InputMaybe<Scalars["Int"]>;
	phone_GTE?: InputMaybe<Scalars["Int"]>;
	phone_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	phone_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	phone_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	phone_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	phone_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	phone_LT?: InputMaybe<Scalars["Int"]>;
	phone_LTE?: InputMaybe<Scalars["Int"]>;
	phone_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	phone_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	phone_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	phone_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	phone_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	tenantId_EQUAL?: InputMaybe<Scalars["String"]>;
	tenantId_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	website_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	website_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	website_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	website_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	website_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	website_EQUAL?: InputMaybe<Scalars["String"]>;
	website_GT?: InputMaybe<Scalars["Int"]>;
	website_GTE?: InputMaybe<Scalars["Int"]>;
	website_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	website_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	website_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	website_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	website_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	website_LT?: InputMaybe<Scalars["Int"]>;
	website_LTE?: InputMaybe<Scalars["Int"]>;
	website_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	website_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	website_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	website_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	website_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type AgreementCounterpartyRolesRelationship = CounterpartyRoleRelationship & {
	__typename?: "AgreementCounterpartyRolesRelationship";
	cursor: Scalars["String"];
	node: Organization;
	role: CounterpartyRole;
};

export type AgreementCounterpartyRolesUpdateConnectionInput = {
	edge?: InputMaybe<CounterpartyRoleRelationshipUpdateInput>;
	node?: InputMaybe<OrganizationUpdateInput>;
};

export type AgreementCounterpartyRolesUpdateFieldInput = {
	connect?: InputMaybe<Array<AgreementCounterpartyRolesConnectFieldInput>>;
	create?: InputMaybe<Array<AgreementCounterpartyRolesCreateFieldInput>>;
	delete?: InputMaybe<Array<AgreementCounterpartyRolesDeleteFieldInput>>;
	disconnect?: InputMaybe<Array<AgreementCounterpartyRolesDisconnectFieldInput>>;
	update?: InputMaybe<AgreementCounterpartyRolesUpdateConnectionInput>;
	where?: InputMaybe<AgreementCounterpartyRolesConnectionWhere>;
};

export type AgreementCreateInput = {
	allowedForms?: InputMaybe<Array<FormType>>;
	counterpartyRoles?: InputMaybe<AgreementCounterpartyRolesFieldInput>;
	currency?: InputMaybe<AgreementCurrencyFieldInput>;
	description?: InputMaybe<Scalars["String"]>;
	deviceAlternativeSets?: InputMaybe<AgreementDeviceAlternativeSetsFieldInput>;
	formattedAmount?: InputMaybe<Scalars["String"]>;
	formattedCounterparties?: InputMaybe<Scalars["String"]>;
	formattedProducts?: InputMaybe<Scalars["String"]>;
	formattedTags: Scalars["String"];
	formattedValidityPeriod?: InputMaybe<Scalars["String"]>;
	id: Scalars["ID"];
	initialVersionId: Scalars["String"];
	isArchived?: InputMaybe<Scalars["Boolean"]>;
	isDeleted?: InputMaybe<Scalars["Boolean"]>;
	isFirstVersion: Scalars["Boolean"];
	isHidden: Scalars["Boolean"];
	isInsightsAvailable?: InputMaybe<Scalars["Boolean"]>;
	isLastVersion: Scalars["Boolean"];
	isRatingEnabled?: InputMaybe<Scalars["Boolean"]>;
	isTherapyDecisionEnabled?: InputMaybe<Scalars["Boolean"]>;
	lastVersionValidToDate?: InputMaybe<Scalars["Date"]>;
	name: Scalars["String"];
	status?: InputMaybe<ContractStatus>;
	tags?: InputMaybe<AgreementTagsFieldInput>;
	tenantIds?: InputMaybe<Array<Scalars["String"]>>;
	totalAmount?: InputMaybe<Scalars["Float"]>;
	unlimited?: InputMaybe<Scalars["Int"]>;
	userRoles?: InputMaybe<AgreementUserRolesFieldInput>;
	validFromDate: Scalars["Date"];
	validToDate?: InputMaybe<Scalars["Date"]>;
	workflows?: InputMaybe<AgreementWorkflowsFieldInput>;
};

export type AgreementCurrencyAggregateInput = {
	AND?: InputMaybe<Array<AgreementCurrencyAggregateInput>>;
	OR?: InputMaybe<Array<AgreementCurrencyAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<AgreementCurrencyNodeAggregationWhereInput>;
};

export type AgreementCurrencyConnectFieldInput = {
	where?: InputMaybe<CurrencyConnectWhere>;
};

export type AgreementCurrencyConnection = {
	__typename?: "AgreementCurrencyConnection";
	edges: Array<AgreementCurrencyRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type AgreementCurrencyConnectionSort = {
	node?: InputMaybe<CurrencySort>;
};

export type AgreementCurrencyConnectionWhere = {
	AND?: InputMaybe<Array<AgreementCurrencyConnectionWhere>>;
	OR?: InputMaybe<Array<AgreementCurrencyConnectionWhere>>;
	node?: InputMaybe<CurrencyWhere>;
	node_NOT?: InputMaybe<CurrencyWhere>;
};

export type AgreementCurrencyCreateFieldInput = {
	node: CurrencyCreateInput;
};

export type AgreementCurrencyDeleteFieldInput = {
	where?: InputMaybe<AgreementCurrencyConnectionWhere>;
};

export type AgreementCurrencyDisconnectFieldInput = {
	where?: InputMaybe<AgreementCurrencyConnectionWhere>;
};

export type AgreementCurrencyFieldInput = {
	connect?: InputMaybe<AgreementCurrencyConnectFieldInput>;
	create?: InputMaybe<AgreementCurrencyCreateFieldInput>;
};

export type AgreementCurrencyNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<AgreementCurrencyNodeAggregationWhereInput>>;
	Code_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	Code_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	Code_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	Code_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	Code_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	Code_EQUAL?: InputMaybe<Scalars["String"]>;
	Code_GT?: InputMaybe<Scalars["Int"]>;
	Code_GTE?: InputMaybe<Scalars["Int"]>;
	Code_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Code_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	Code_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	Code_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	Code_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	Code_LT?: InputMaybe<Scalars["Int"]>;
	Code_LTE?: InputMaybe<Scalars["Int"]>;
	Code_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Code_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	Code_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	Code_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	Code_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	Name_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	Name_EQUAL?: InputMaybe<Scalars["String"]>;
	Name_GT?: InputMaybe<Scalars["Int"]>;
	Name_GTE?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	Name_LT?: InputMaybe<Scalars["Int"]>;
	Name_LTE?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	OR?: InputMaybe<Array<AgreementCurrencyNodeAggregationWhereInput>>;
	symbol_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	symbol_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	symbol_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	symbol_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	symbol_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	symbol_EQUAL?: InputMaybe<Scalars["String"]>;
	symbol_GT?: InputMaybe<Scalars["Int"]>;
	symbol_GTE?: InputMaybe<Scalars["Int"]>;
	symbol_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	symbol_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	symbol_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	symbol_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	symbol_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	symbol_LT?: InputMaybe<Scalars["Int"]>;
	symbol_LTE?: InputMaybe<Scalars["Int"]>;
	symbol_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	symbol_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	symbol_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	symbol_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	symbol_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type AgreementCurrencyRelationship = {
	__typename?: "AgreementCurrencyRelationship";
	cursor: Scalars["String"];
	node: Currency;
};

export type AgreementCurrencyUpdateConnectionInput = {
	node?: InputMaybe<CurrencyUpdateInput>;
};

export type AgreementCurrencyUpdateFieldInput = {
	connect?: InputMaybe<AgreementCurrencyConnectFieldInput>;
	create?: InputMaybe<AgreementCurrencyCreateFieldInput>;
	delete?: InputMaybe<AgreementCurrencyDeleteFieldInput>;
	disconnect?: InputMaybe<AgreementCurrencyDisconnectFieldInput>;
	update?: InputMaybe<AgreementCurrencyUpdateConnectionInput>;
	where?: InputMaybe<AgreementCurrencyConnectionWhere>;
};

export type AgreementDecision = {
	__typename?: "AgreementDecision";
	asOf: Organization;
	asOfConnection: AgreementDecisionAsOfConnection;
	createdOn: Scalars["DateTime"];
	decision: Decision;
	isArchived: Scalars["Boolean"];
	madeBy: User;
	madeByConnection: AgreementDecisionMadeByConnection;
};

export type AgreementDecisionAsOfArgs = {
	options?: InputMaybe<OrganizationOptions>;
	where?: InputMaybe<OrganizationWhere>;
};

export type AgreementDecisionAsOfConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<AgreementDecisionAsOfConnectionSort>>;
	where?: InputMaybe<AgreementDecisionAsOfConnectionWhere>;
};

export type AgreementDecisionMadeByArgs = {
	options?: InputMaybe<UserOptions>;
	where?: InputMaybe<UserWhere>;
};

export type AgreementDecisionMadeByConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<AgreementDecisionMadeByConnectionSort>>;
	where?: InputMaybe<AgreementDecisionMadeByConnectionWhere>;
};

export type AgreementDecisionAggregateSelection = {
	__typename?: "AgreementDecisionAggregateSelection";
	count: Scalars["Int"];
	createdOn: DateTimeAggregateSelection;
};

export type AgreementDecisionAsOfAggregateInput = {
	AND?: InputMaybe<Array<AgreementDecisionAsOfAggregateInput>>;
	OR?: InputMaybe<Array<AgreementDecisionAsOfAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<AgreementDecisionAsOfNodeAggregationWhereInput>;
};

export type AgreementDecisionAsOfConnectFieldInput = {
	where?: InputMaybe<OrganizationConnectWhere>;
};

export type AgreementDecisionAsOfConnection = {
	__typename?: "AgreementDecisionAsOfConnection";
	edges: Array<AgreementDecisionAsOfRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type AgreementDecisionAsOfConnectionSort = {
	node?: InputMaybe<OrganizationSort>;
};

export type AgreementDecisionAsOfConnectionWhere = {
	AND?: InputMaybe<Array<AgreementDecisionAsOfConnectionWhere>>;
	OR?: InputMaybe<Array<AgreementDecisionAsOfConnectionWhere>>;
	node?: InputMaybe<OrganizationWhere>;
	node_NOT?: InputMaybe<OrganizationWhere>;
};

export type AgreementDecisionAsOfCreateFieldInput = {
	node: OrganizationCreateInput;
};

export type AgreementDecisionAsOfDeleteFieldInput = {
	where?: InputMaybe<AgreementDecisionAsOfConnectionWhere>;
};

export type AgreementDecisionAsOfDisconnectFieldInput = {
	where?: InputMaybe<AgreementDecisionAsOfConnectionWhere>;
};

export type AgreementDecisionAsOfFieldInput = {
	connect?: InputMaybe<AgreementDecisionAsOfConnectFieldInput>;
	create?: InputMaybe<AgreementDecisionAsOfCreateFieldInput>;
};

export type AgreementDecisionAsOfNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<AgreementDecisionAsOfNodeAggregationWhereInput>>;
	IBAN_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	IBAN_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	IBAN_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	IBAN_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	IBAN_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	IBAN_EQUAL?: InputMaybe<Scalars["String"]>;
	IBAN_GT?: InputMaybe<Scalars["Int"]>;
	IBAN_GTE?: InputMaybe<Scalars["Int"]>;
	IBAN_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	IBAN_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	IBAN_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	IBAN_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	IBAN_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	IBAN_LT?: InputMaybe<Scalars["Int"]>;
	IBAN_LTE?: InputMaybe<Scalars["Int"]>;
	IBAN_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	IBAN_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	IBAN_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	IBAN_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	IBAN_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	OR?: InputMaybe<Array<AgreementDecisionAsOfNodeAggregationWhereInput>>;
	billingAddress_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	billingAddress_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	billingAddress_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	billingAddress_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	billingAddress_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	billingAddress_EQUAL?: InputMaybe<Scalars["String"]>;
	billingAddress_GT?: InputMaybe<Scalars["Int"]>;
	billingAddress_GTE?: InputMaybe<Scalars["Int"]>;
	billingAddress_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	billingAddress_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	billingAddress_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	billingAddress_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	billingAddress_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	billingAddress_LT?: InputMaybe<Scalars["Int"]>;
	billingAddress_LTE?: InputMaybe<Scalars["Int"]>;
	billingAddress_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	billingAddress_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	billingAddress_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	billingAddress_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	billingAddress_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	contactEmail_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	contactEmail_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	contactEmail_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	contactEmail_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	contactEmail_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	contactEmail_EQUAL?: InputMaybe<Scalars["String"]>;
	contactEmail_GT?: InputMaybe<Scalars["Int"]>;
	contactEmail_GTE?: InputMaybe<Scalars["Int"]>;
	contactEmail_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	contactEmail_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	contactEmail_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	contactEmail_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	contactEmail_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	contactEmail_LT?: InputMaybe<Scalars["Int"]>;
	contactEmail_LTE?: InputMaybe<Scalars["Int"]>;
	contactEmail_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	contactEmail_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	contactEmail_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	contactEmail_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	contactEmail_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	contactFirstName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	contactFirstName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	contactFirstName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	contactFirstName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	contactFirstName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	contactFirstName_EQUAL?: InputMaybe<Scalars["String"]>;
	contactFirstName_GT?: InputMaybe<Scalars["Int"]>;
	contactFirstName_GTE?: InputMaybe<Scalars["Int"]>;
	contactFirstName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	contactFirstName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	contactFirstName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	contactFirstName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	contactFirstName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	contactFirstName_LT?: InputMaybe<Scalars["Int"]>;
	contactFirstName_LTE?: InputMaybe<Scalars["Int"]>;
	contactFirstName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	contactFirstName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	contactFirstName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	contactFirstName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	contactFirstName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	contactLastName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	contactLastName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	contactLastName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	contactLastName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	contactLastName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	contactLastName_EQUAL?: InputMaybe<Scalars["String"]>;
	contactLastName_GT?: InputMaybe<Scalars["Int"]>;
	contactLastName_GTE?: InputMaybe<Scalars["Int"]>;
	contactLastName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	contactLastName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	contactLastName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	contactLastName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	contactLastName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	contactLastName_LT?: InputMaybe<Scalars["Int"]>;
	contactLastName_LTE?: InputMaybe<Scalars["Int"]>;
	contactLastName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	contactLastName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	contactLastName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	contactLastName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	contactLastName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	contactOccupation_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	contactOccupation_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	contactOccupation_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	contactOccupation_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	contactOccupation_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	contactOccupation_EQUAL?: InputMaybe<Scalars["String"]>;
	contactOccupation_GT?: InputMaybe<Scalars["Int"]>;
	contactOccupation_GTE?: InputMaybe<Scalars["Int"]>;
	contactOccupation_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	contactOccupation_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	contactOccupation_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	contactOccupation_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	contactOccupation_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	contactOccupation_LT?: InputMaybe<Scalars["Int"]>;
	contactOccupation_LTE?: InputMaybe<Scalars["Int"]>;
	contactOccupation_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	contactOccupation_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	contactOccupation_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	contactOccupation_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	contactOccupation_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	contactPhone_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	contactPhone_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	contactPhone_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	contactPhone_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	contactPhone_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	contactPhone_EQUAL?: InputMaybe<Scalars["String"]>;
	contactPhone_GT?: InputMaybe<Scalars["Int"]>;
	contactPhone_GTE?: InputMaybe<Scalars["Int"]>;
	contactPhone_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	contactPhone_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	contactPhone_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	contactPhone_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	contactPhone_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	contactPhone_LT?: InputMaybe<Scalars["Int"]>;
	contactPhone_LTE?: InputMaybe<Scalars["Int"]>;
	contactPhone_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	contactPhone_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	contactPhone_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	contactPhone_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	contactPhone_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	domicile_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	domicile_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	domicile_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	domicile_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	domicile_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	domicile_EQUAL?: InputMaybe<Scalars["String"]>;
	domicile_GT?: InputMaybe<Scalars["Int"]>;
	domicile_GTE?: InputMaybe<Scalars["Int"]>;
	domicile_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	domicile_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	domicile_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	domicile_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	domicile_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	domicile_LT?: InputMaybe<Scalars["Int"]>;
	domicile_LTE?: InputMaybe<Scalars["Int"]>;
	domicile_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	domicile_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	domicile_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	domicile_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	domicile_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	eIN_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	eIN_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	eIN_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	eIN_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	eIN_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	eIN_EQUAL?: InputMaybe<Scalars["String"]>;
	eIN_GT?: InputMaybe<Scalars["Int"]>;
	eIN_GTE?: InputMaybe<Scalars["Int"]>;
	eIN_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	eIN_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	eIN_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	eIN_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	eIN_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	eIN_LT?: InputMaybe<Scalars["Int"]>;
	eIN_LTE?: InputMaybe<Scalars["Int"]>;
	eIN_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	eIN_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	eIN_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	eIN_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	eIN_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	fax_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	fax_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	fax_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	fax_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	fax_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	fax_EQUAL?: InputMaybe<Scalars["String"]>;
	fax_GT?: InputMaybe<Scalars["Int"]>;
	fax_GTE?: InputMaybe<Scalars["Int"]>;
	fax_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	fax_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	fax_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	fax_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	fax_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	fax_LT?: InputMaybe<Scalars["Int"]>;
	fax_LTE?: InputMaybe<Scalars["Int"]>;
	fax_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	fax_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	fax_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	fax_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	fax_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	legalName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	legalName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	legalName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	legalName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	legalName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	legalName_EQUAL?: InputMaybe<Scalars["String"]>;
	legalName_GT?: InputMaybe<Scalars["Int"]>;
	legalName_GTE?: InputMaybe<Scalars["Int"]>;
	legalName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	legalName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	legalName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	legalName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	legalName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	legalName_LT?: InputMaybe<Scalars["Int"]>;
	legalName_LTE?: InputMaybe<Scalars["Int"]>;
	legalName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	legalName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	legalName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	legalName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	legalName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	logo_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	logo_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	logo_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	logo_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	logo_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	logo_EQUAL?: InputMaybe<Scalars["String"]>;
	logo_GT?: InputMaybe<Scalars["Int"]>;
	logo_GTE?: InputMaybe<Scalars["Int"]>;
	logo_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	logo_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	logo_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	logo_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	logo_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	logo_LT?: InputMaybe<Scalars["Int"]>;
	logo_LTE?: InputMaybe<Scalars["Int"]>;
	logo_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	logo_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	logo_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	logo_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	logo_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	name_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	name_EQUAL?: InputMaybe<Scalars["String"]>;
	name_GT?: InputMaybe<Scalars["Int"]>;
	name_GTE?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	name_LT?: InputMaybe<Scalars["Int"]>;
	name_LTE?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	phone_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	phone_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	phone_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	phone_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	phone_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	phone_EQUAL?: InputMaybe<Scalars["String"]>;
	phone_GT?: InputMaybe<Scalars["Int"]>;
	phone_GTE?: InputMaybe<Scalars["Int"]>;
	phone_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	phone_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	phone_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	phone_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	phone_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	phone_LT?: InputMaybe<Scalars["Int"]>;
	phone_LTE?: InputMaybe<Scalars["Int"]>;
	phone_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	phone_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	phone_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	phone_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	phone_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	tenantId_EQUAL?: InputMaybe<Scalars["String"]>;
	tenantId_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	website_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	website_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	website_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	website_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	website_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	website_EQUAL?: InputMaybe<Scalars["String"]>;
	website_GT?: InputMaybe<Scalars["Int"]>;
	website_GTE?: InputMaybe<Scalars["Int"]>;
	website_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	website_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	website_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	website_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	website_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	website_LT?: InputMaybe<Scalars["Int"]>;
	website_LTE?: InputMaybe<Scalars["Int"]>;
	website_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	website_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	website_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	website_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	website_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type AgreementDecisionAsOfRelationship = {
	__typename?: "AgreementDecisionAsOfRelationship";
	cursor: Scalars["String"];
	node: Organization;
};

export type AgreementDecisionAsOfUpdateConnectionInput = {
	node?: InputMaybe<OrganizationUpdateInput>;
};

export type AgreementDecisionAsOfUpdateFieldInput = {
	connect?: InputMaybe<AgreementDecisionAsOfConnectFieldInput>;
	create?: InputMaybe<AgreementDecisionAsOfCreateFieldInput>;
	delete?: InputMaybe<AgreementDecisionAsOfDeleteFieldInput>;
	disconnect?: InputMaybe<AgreementDecisionAsOfDisconnectFieldInput>;
	update?: InputMaybe<AgreementDecisionAsOfUpdateConnectionInput>;
	where?: InputMaybe<AgreementDecisionAsOfConnectionWhere>;
};

export type AgreementDecisionConnectInput = {
	asOf?: InputMaybe<AgreementDecisionAsOfConnectFieldInput>;
	madeBy?: InputMaybe<AgreementDecisionMadeByConnectFieldInput>;
};

export type AgreementDecisionConnectWhere = {
	node: AgreementDecisionWhere;
};

export type AgreementDecisionCreateInput = {
	asOf?: InputMaybe<AgreementDecisionAsOfFieldInput>;
	createdOn: Scalars["DateTime"];
	decision: Decision;
	isArchived: Scalars["Boolean"];
	madeBy?: InputMaybe<AgreementDecisionMadeByFieldInput>;
};

export type AgreementDecisionDeleteInput = {
	asOf?: InputMaybe<AgreementDecisionAsOfDeleteFieldInput>;
	madeBy?: InputMaybe<AgreementDecisionMadeByDeleteFieldInput>;
};

export type AgreementDecisionDisconnectInput = {
	asOf?: InputMaybe<AgreementDecisionAsOfDisconnectFieldInput>;
	madeBy?: InputMaybe<AgreementDecisionMadeByDisconnectFieldInput>;
};

export type AgreementDecisionInput = {
	agreementId: Scalars["ID"];
	decision: Decision;
};

export type AgreementDecisionMadeByAggregateInput = {
	AND?: InputMaybe<Array<AgreementDecisionMadeByAggregateInput>>;
	OR?: InputMaybe<Array<AgreementDecisionMadeByAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<AgreementDecisionMadeByNodeAggregationWhereInput>;
};

export type AgreementDecisionMadeByConnectFieldInput = {
	connect?: InputMaybe<UserConnectInput>;
	where?: InputMaybe<UserConnectWhere>;
};

export type AgreementDecisionMadeByConnection = {
	__typename?: "AgreementDecisionMadeByConnection";
	edges: Array<AgreementDecisionMadeByRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type AgreementDecisionMadeByConnectionSort = {
	node?: InputMaybe<UserSort>;
};

export type AgreementDecisionMadeByConnectionWhere = {
	AND?: InputMaybe<Array<AgreementDecisionMadeByConnectionWhere>>;
	OR?: InputMaybe<Array<AgreementDecisionMadeByConnectionWhere>>;
	node?: InputMaybe<UserWhere>;
	node_NOT?: InputMaybe<UserWhere>;
};

export type AgreementDecisionMadeByCreateFieldInput = {
	node: UserCreateInput;
};

export type AgreementDecisionMadeByDeleteFieldInput = {
	delete?: InputMaybe<UserDeleteInput>;
	where?: InputMaybe<AgreementDecisionMadeByConnectionWhere>;
};

export type AgreementDecisionMadeByDisconnectFieldInput = {
	disconnect?: InputMaybe<UserDisconnectInput>;
	where?: InputMaybe<AgreementDecisionMadeByConnectionWhere>;
};

export type AgreementDecisionMadeByFieldInput = {
	connect?: InputMaybe<AgreementDecisionMadeByConnectFieldInput>;
	create?: InputMaybe<AgreementDecisionMadeByCreateFieldInput>;
};

export type AgreementDecisionMadeByNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<AgreementDecisionMadeByNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<AgreementDecisionMadeByNodeAggregationWhereInput>>;
	email_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	email_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	email_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	email_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	email_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	email_EQUAL?: InputMaybe<Scalars["String"]>;
	email_GT?: InputMaybe<Scalars["Int"]>;
	email_GTE?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	email_LT?: InputMaybe<Scalars["Int"]>;
	email_LTE?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	firstName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	firstName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	firstName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	firstName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	firstName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	firstName_EQUAL?: InputMaybe<Scalars["String"]>;
	firstName_GT?: InputMaybe<Scalars["Int"]>;
	firstName_GTE?: InputMaybe<Scalars["Int"]>;
	firstName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	firstName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	firstName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	firstName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	firstName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	firstName_LT?: InputMaybe<Scalars["Int"]>;
	firstName_LTE?: InputMaybe<Scalars["Int"]>;
	firstName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	firstName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	firstName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	firstName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	firstName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	lastName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	lastName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	lastName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	lastName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	lastName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	lastName_EQUAL?: InputMaybe<Scalars["String"]>;
	lastName_GT?: InputMaybe<Scalars["Int"]>;
	lastName_GTE?: InputMaybe<Scalars["Int"]>;
	lastName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	lastName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	lastName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	lastName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	lastName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	lastName_LT?: InputMaybe<Scalars["Int"]>;
	lastName_LTE?: InputMaybe<Scalars["Int"]>;
	lastName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	lastName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	lastName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	lastName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	lastName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	preferredLanguage_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	preferredLanguage_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	preferredLanguage_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	preferredLanguage_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	preferredLanguage_EQUAL?: InputMaybe<Scalars["String"]>;
	preferredLanguage_GT?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_GTE?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LT?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LTE?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	tenantId_EQUAL?: InputMaybe<Scalars["String"]>;
	tenantId_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type AgreementDecisionMadeByRelationship = {
	__typename?: "AgreementDecisionMadeByRelationship";
	cursor: Scalars["String"];
	node: User;
};

export type AgreementDecisionMadeByUpdateConnectionInput = {
	node?: InputMaybe<UserUpdateInput>;
};

export type AgreementDecisionMadeByUpdateFieldInput = {
	connect?: InputMaybe<AgreementDecisionMadeByConnectFieldInput>;
	create?: InputMaybe<AgreementDecisionMadeByCreateFieldInput>;
	delete?: InputMaybe<AgreementDecisionMadeByDeleteFieldInput>;
	disconnect?: InputMaybe<AgreementDecisionMadeByDisconnectFieldInput>;
	update?: InputMaybe<AgreementDecisionMadeByUpdateConnectionInput>;
	where?: InputMaybe<AgreementDecisionMadeByConnectionWhere>;
};

export type AgreementDecisionOptions = {
	limit?: InputMaybe<Scalars["Int"]>;
	offset?: InputMaybe<Scalars["Int"]>;
	/** Specify one or more AgreementDecisionSort objects to sort AgreementDecisions by. The sorts will be applied in the order in which they are arranged in the array. */
	sort?: InputMaybe<Array<InputMaybe<AgreementDecisionSort>>>;
};

/** Fields to sort AgreementDecisions by. The order in which sorts are applied is not guaranteed when specifying many fields in one AgreementDecisionSort object. */
export type AgreementDecisionSort = {
	createdOn?: InputMaybe<SortDirection>;
	decision?: InputMaybe<SortDirection>;
	isArchived?: InputMaybe<SortDirection>;
};

export type AgreementDecisionUpdateInput = {
	asOf?: InputMaybe<AgreementDecisionAsOfUpdateFieldInput>;
	createdOn?: InputMaybe<Scalars["DateTime"]>;
	decision?: InputMaybe<Decision>;
	isArchived?: InputMaybe<Scalars["Boolean"]>;
	madeBy?: InputMaybe<AgreementDecisionMadeByUpdateFieldInput>;
};

export type AgreementDecisionWhere = {
	AND?: InputMaybe<Array<AgreementDecisionWhere>>;
	OR?: InputMaybe<Array<AgreementDecisionWhere>>;
	asOf?: InputMaybe<OrganizationWhere>;
	asOfAggregate?: InputMaybe<AgreementDecisionAsOfAggregateInput>;
	asOfConnection?: InputMaybe<AgreementDecisionAsOfConnectionWhere>;
	asOfConnection_NOT?: InputMaybe<AgreementDecisionAsOfConnectionWhere>;
	asOf_NOT?: InputMaybe<OrganizationWhere>;
	createdOn?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_IN?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]>>>;
	createdOn_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_NOT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]>>>;
	decision?: InputMaybe<Decision>;
	decision_IN?: InputMaybe<Array<InputMaybe<Decision>>>;
	decision_NOT?: InputMaybe<Decision>;
	decision_NOT_IN?: InputMaybe<Array<InputMaybe<Decision>>>;
	isArchived?: InputMaybe<Scalars["Boolean"]>;
	isArchived_NOT?: InputMaybe<Scalars["Boolean"]>;
	madeBy?: InputMaybe<UserWhere>;
	madeByAggregate?: InputMaybe<AgreementDecisionMadeByAggregateInput>;
	madeByConnection?: InputMaybe<AgreementDecisionMadeByConnectionWhere>;
	madeByConnection_NOT?: InputMaybe<AgreementDecisionMadeByConnectionWhere>;
	madeBy_NOT?: InputMaybe<UserWhere>;
};

export type AgreementDeleteInput = {
	counterpartyRoles?: InputMaybe<Array<AgreementCounterpartyRolesDeleteFieldInput>>;
	currency?: InputMaybe<AgreementCurrencyDeleteFieldInput>;
	deviceAlternativeSets?: InputMaybe<Array<AgreementDeviceAlternativeSetsDeleteFieldInput>>;
	tags?: InputMaybe<Array<AgreementTagsDeleteFieldInput>>;
	userRoles?: InputMaybe<Array<AgreementUserRolesDeleteFieldInput>>;
	workflows?: InputMaybe<Array<AgreementWorkflowsDeleteFieldInput>>;
};

export type AgreementDeviceAlternativeSetsAggregateInput = {
	AND?: InputMaybe<Array<AgreementDeviceAlternativeSetsAggregateInput>>;
	OR?: InputMaybe<Array<AgreementDeviceAlternativeSetsAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<AgreementDeviceAlternativeSetsNodeAggregationWhereInput>;
};

export type AgreementDeviceAlternativeSetsConnectFieldInput = {
	connect?: InputMaybe<Array<DeviceAlternativeConnectInput>>;
	where?: InputMaybe<DeviceAlternativeConnectWhere>;
};

export type AgreementDeviceAlternativeSetsConnection = {
	__typename?: "AgreementDeviceAlternativeSetsConnection";
	edges: Array<AgreementDeviceAlternativeSetsRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type AgreementDeviceAlternativeSetsConnectionSort = {
	node?: InputMaybe<DeviceAlternativeSort>;
};

export type AgreementDeviceAlternativeSetsConnectionWhere = {
	AND?: InputMaybe<Array<AgreementDeviceAlternativeSetsConnectionWhere>>;
	OR?: InputMaybe<Array<AgreementDeviceAlternativeSetsConnectionWhere>>;
	node?: InputMaybe<DeviceAlternativeWhere>;
	node_NOT?: InputMaybe<DeviceAlternativeWhere>;
};

export type AgreementDeviceAlternativeSetsCreateFieldInput = {
	node: DeviceAlternativeCreateInput;
};

export type AgreementDeviceAlternativeSetsDeleteFieldInput = {
	delete?: InputMaybe<DeviceAlternativeDeleteInput>;
	where?: InputMaybe<AgreementDeviceAlternativeSetsConnectionWhere>;
};

export type AgreementDeviceAlternativeSetsDisconnectFieldInput = {
	disconnect?: InputMaybe<DeviceAlternativeDisconnectInput>;
	where?: InputMaybe<AgreementDeviceAlternativeSetsConnectionWhere>;
};

export type AgreementDeviceAlternativeSetsFieldInput = {
	connect?: InputMaybe<Array<AgreementDeviceAlternativeSetsConnectFieldInput>>;
	create?: InputMaybe<Array<AgreementDeviceAlternativeSetsCreateFieldInput>>;
};

export type AgreementDeviceAlternativeSetsNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<AgreementDeviceAlternativeSetsNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<AgreementDeviceAlternativeSetsNodeAggregationWhereInput>>;
	code_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	code_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	code_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	code_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	code_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	code_EQUAL?: InputMaybe<Scalars["String"]>;
	code_GT?: InputMaybe<Scalars["Int"]>;
	code_GTE?: InputMaybe<Scalars["Int"]>;
	code_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	code_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	code_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	code_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	code_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	code_LT?: InputMaybe<Scalars["Int"]>;
	code_LTE?: InputMaybe<Scalars["Int"]>;
	code_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	code_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	code_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	code_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	code_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type AgreementDeviceAlternativeSetsRelationship = {
	__typename?: "AgreementDeviceAlternativeSetsRelationship";
	cursor: Scalars["String"];
	node: DeviceAlternative;
};

export type AgreementDeviceAlternativeSetsUpdateConnectionInput = {
	node?: InputMaybe<DeviceAlternativeUpdateInput>;
};

export type AgreementDeviceAlternativeSetsUpdateFieldInput = {
	connect?: InputMaybe<Array<AgreementDeviceAlternativeSetsConnectFieldInput>>;
	create?: InputMaybe<Array<AgreementDeviceAlternativeSetsCreateFieldInput>>;
	delete?: InputMaybe<Array<AgreementDeviceAlternativeSetsDeleteFieldInput>>;
	disconnect?: InputMaybe<Array<AgreementDeviceAlternativeSetsDisconnectFieldInput>>;
	update?: InputMaybe<AgreementDeviceAlternativeSetsUpdateConnectionInput>;
	where?: InputMaybe<AgreementDeviceAlternativeSetsConnectionWhere>;
};

export type AgreementDisconnectInput = {
	counterpartyRoles?: InputMaybe<Array<AgreementCounterpartyRolesDisconnectFieldInput>>;
	currency?: InputMaybe<AgreementCurrencyDisconnectFieldInput>;
	deviceAlternativeSets?: InputMaybe<Array<AgreementDeviceAlternativeSetsDisconnectFieldInput>>;
	tags?: InputMaybe<Array<AgreementTagsDisconnectFieldInput>>;
	userRoles?: InputMaybe<Array<AgreementUserRolesDisconnectFieldInput>>;
	workflows?: InputMaybe<Array<AgreementWorkflowsDisconnectFieldInput>>;
};

export type AgreementFinancialSummaryColumnRelationship = {
	hasHelpMessage?: Maybe<Scalars["Boolean"]>;
	isIncluded?: Maybe<Scalars["Boolean"]>;
	localizationKey?: Maybe<Scalars["String"]>;
	position?: Maybe<Scalars["Int"]>;
};

export type AgreementFinancialSummaryColumnRelationshipCreateInput = {
	hasHelpMessage?: InputMaybe<Scalars["Boolean"]>;
	isIncluded?: InputMaybe<Scalars["Boolean"]>;
	localizationKey?: InputMaybe<Scalars["String"]>;
	position?: InputMaybe<Scalars["Int"]>;
};

export type AgreementFinancialSummaryColumnRelationshipSort = {
	hasHelpMessage?: InputMaybe<SortDirection>;
	isIncluded?: InputMaybe<SortDirection>;
	localizationKey?: InputMaybe<SortDirection>;
	position?: InputMaybe<SortDirection>;
};

export type AgreementFinancialSummaryColumnRelationshipUpdateInput = {
	hasHelpMessage?: InputMaybe<Scalars["Boolean"]>;
	isIncluded?: InputMaybe<Scalars["Boolean"]>;
	localizationKey?: InputMaybe<Scalars["String"]>;
	position?: InputMaybe<Scalars["Int"]>;
};

export type AgreementFinancialSummaryColumnRelationshipWhere = {
	AND?: InputMaybe<Array<AgreementFinancialSummaryColumnRelationshipWhere>>;
	OR?: InputMaybe<Array<AgreementFinancialSummaryColumnRelationshipWhere>>;
	hasHelpMessage?: InputMaybe<Scalars["Boolean"]>;
	hasHelpMessage_NOT?: InputMaybe<Scalars["Boolean"]>;
	isIncluded?: InputMaybe<Scalars["Boolean"]>;
	isIncluded_NOT?: InputMaybe<Scalars["Boolean"]>;
	localizationKey?: InputMaybe<Scalars["String"]>;
	localizationKey_CONTAINS?: InputMaybe<Scalars["String"]>;
	localizationKey_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	localizationKey_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	localizationKey_MATCHES?: InputMaybe<Scalars["String"]>;
	localizationKey_NOT?: InputMaybe<Scalars["String"]>;
	localizationKey_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	localizationKey_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	localizationKey_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	localizationKey_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	localizationKey_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	position?: InputMaybe<Scalars["Int"]>;
	position_GT?: InputMaybe<Scalars["Int"]>;
	position_GTE?: InputMaybe<Scalars["Int"]>;
	position_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	position_LT?: InputMaybe<Scalars["Int"]>;
	position_LTE?: InputMaybe<Scalars["Int"]>;
	position_NOT?: InputMaybe<Scalars["Int"]>;
	position_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
};

export type AgreementOptions = {
	limit?: InputMaybe<Scalars["Int"]>;
	offset?: InputMaybe<Scalars["Int"]>;
	/** Specify one or more AgreementSort objects to sort Agreements by. The sorts will be applied in the order in which they are arranged in the array. */
	sort?: InputMaybe<Array<InputMaybe<AgreementSort>>>;
};

export type AgreementReport = {
	__typename?: "AgreementReport";
	discountAmount?: Maybe<Scalars["Float"]>;
	discountAmountDelta?: Maybe<Scalars["Float"]>;
	discountRatio?: Maybe<Scalars["Float"]>;
	discountRatioDelta?: Maybe<Scalars["Float"]>;
	discountsPerCase?: Maybe<Scalars["Float"]>;
	discountsPerCaseDiscontinued?: Maybe<Scalars["Float"]>;
	durationMonths?: Maybe<Scalars["Int"]>;
	durationMonthsDiscontinued?: Maybe<Scalars["Int"]>;
	financialReportDataPoints: Array<FinancialReportDataPoint>;
	financialSummaryRows: Array<FinancialSummaryRow>;
	grossAmount?: Maybe<Scalars["Float"]>;
	grossAmountDelta?: Maybe<Scalars["Float"]>;
	grossAmountPerCase?: Maybe<Scalars["Float"]>;
	grossAmountPerCaseDiscontinued?: Maybe<Scalars["Float"]>;
	netAmount?: Maybe<Scalars["Float"]>;
	netAmountPerCase?: Maybe<Scalars["Float"]>;
	netAmountPerCaseDiscontinued?: Maybe<Scalars["Float"]>;
	organizationNetRevenues: Array<NetRevenueByOrganization>;
	patientReportDataPoints: Array<PatientReportDataPoint>;
	treatmentDurationData: Array<CaseReportDataPoint>;
	treatmentPatients: Array<TreatmentPatient>;
};

export type AgreementReportAggregateSelection = {
	__typename?: "AgreementReportAggregateSelection";
	count: Scalars["Int"];
	discountAmount: FloatAggregateSelection;
	discountAmountDelta: FloatAggregateSelection;
	discountRatio: FloatAggregateSelection;
	discountRatioDelta: FloatAggregateSelection;
	discountsPerCase: FloatAggregateSelection;
	discountsPerCaseDiscontinued: FloatAggregateSelection;
	durationMonths: IntAggregateSelection;
	durationMonthsDiscontinued: IntAggregateSelection;
	grossAmount: FloatAggregateSelection;
	grossAmountDelta: FloatAggregateSelection;
	grossAmountPerCase: FloatAggregateSelection;
	grossAmountPerCaseDiscontinued: FloatAggregateSelection;
	netAmount: FloatAggregateSelection;
	netAmountPerCase: FloatAggregateSelection;
	netAmountPerCaseDiscontinued: FloatAggregateSelection;
};

export type AgreementReportOptions = {
	limit?: InputMaybe<Scalars["Int"]>;
	offset?: InputMaybe<Scalars["Int"]>;
	/** Specify one or more AgreementReportSort objects to sort AgreementReports by. The sorts will be applied in the order in which they are arranged in the array. */
	sort?: InputMaybe<Array<InputMaybe<AgreementReportSort>>>;
};

/** Fields to sort AgreementReports by. The order in which sorts are applied is not guaranteed when specifying many fields in one AgreementReportSort object. */
export type AgreementReportSort = {
	discountAmount?: InputMaybe<SortDirection>;
	discountAmountDelta?: InputMaybe<SortDirection>;
	discountRatio?: InputMaybe<SortDirection>;
	discountRatioDelta?: InputMaybe<SortDirection>;
	discountsPerCase?: InputMaybe<SortDirection>;
	discountsPerCaseDiscontinued?: InputMaybe<SortDirection>;
	durationMonths?: InputMaybe<SortDirection>;
	durationMonthsDiscontinued?: InputMaybe<SortDirection>;
	grossAmount?: InputMaybe<SortDirection>;
	grossAmountDelta?: InputMaybe<SortDirection>;
	grossAmountPerCase?: InputMaybe<SortDirection>;
	grossAmountPerCaseDiscontinued?: InputMaybe<SortDirection>;
	netAmount?: InputMaybe<SortDirection>;
	netAmountPerCase?: InputMaybe<SortDirection>;
	netAmountPerCaseDiscontinued?: InputMaybe<SortDirection>;
};

export type AgreementReportWhere = {
	AND?: InputMaybe<Array<AgreementReportWhere>>;
	OR?: InputMaybe<Array<AgreementReportWhere>>;
	discountAmount?: InputMaybe<Scalars["Float"]>;
	discountAmountDelta?: InputMaybe<Scalars["Float"]>;
	discountAmountDelta_GT?: InputMaybe<Scalars["Float"]>;
	discountAmountDelta_GTE?: InputMaybe<Scalars["Float"]>;
	discountAmountDelta_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	discountAmountDelta_LT?: InputMaybe<Scalars["Float"]>;
	discountAmountDelta_LTE?: InputMaybe<Scalars["Float"]>;
	discountAmountDelta_NOT?: InputMaybe<Scalars["Float"]>;
	discountAmountDelta_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	discountAmount_GT?: InputMaybe<Scalars["Float"]>;
	discountAmount_GTE?: InputMaybe<Scalars["Float"]>;
	discountAmount_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	discountAmount_LT?: InputMaybe<Scalars["Float"]>;
	discountAmount_LTE?: InputMaybe<Scalars["Float"]>;
	discountAmount_NOT?: InputMaybe<Scalars["Float"]>;
	discountAmount_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	discountRatio?: InputMaybe<Scalars["Float"]>;
	discountRatioDelta?: InputMaybe<Scalars["Float"]>;
	discountRatioDelta_GT?: InputMaybe<Scalars["Float"]>;
	discountRatioDelta_GTE?: InputMaybe<Scalars["Float"]>;
	discountRatioDelta_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	discountRatioDelta_LT?: InputMaybe<Scalars["Float"]>;
	discountRatioDelta_LTE?: InputMaybe<Scalars["Float"]>;
	discountRatioDelta_NOT?: InputMaybe<Scalars["Float"]>;
	discountRatioDelta_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	discountRatio_GT?: InputMaybe<Scalars["Float"]>;
	discountRatio_GTE?: InputMaybe<Scalars["Float"]>;
	discountRatio_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	discountRatio_LT?: InputMaybe<Scalars["Float"]>;
	discountRatio_LTE?: InputMaybe<Scalars["Float"]>;
	discountRatio_NOT?: InputMaybe<Scalars["Float"]>;
	discountRatio_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	discountsPerCase?: InputMaybe<Scalars["Float"]>;
	discountsPerCaseDiscontinued?: InputMaybe<Scalars["Float"]>;
	discountsPerCaseDiscontinued_GT?: InputMaybe<Scalars["Float"]>;
	discountsPerCaseDiscontinued_GTE?: InputMaybe<Scalars["Float"]>;
	discountsPerCaseDiscontinued_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	discountsPerCaseDiscontinued_LT?: InputMaybe<Scalars["Float"]>;
	discountsPerCaseDiscontinued_LTE?: InputMaybe<Scalars["Float"]>;
	discountsPerCaseDiscontinued_NOT?: InputMaybe<Scalars["Float"]>;
	discountsPerCaseDiscontinued_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	discountsPerCase_GT?: InputMaybe<Scalars["Float"]>;
	discountsPerCase_GTE?: InputMaybe<Scalars["Float"]>;
	discountsPerCase_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	discountsPerCase_LT?: InputMaybe<Scalars["Float"]>;
	discountsPerCase_LTE?: InputMaybe<Scalars["Float"]>;
	discountsPerCase_NOT?: InputMaybe<Scalars["Float"]>;
	discountsPerCase_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	durationMonths?: InputMaybe<Scalars["Int"]>;
	durationMonthsDiscontinued?: InputMaybe<Scalars["Int"]>;
	durationMonthsDiscontinued_GT?: InputMaybe<Scalars["Int"]>;
	durationMonthsDiscontinued_GTE?: InputMaybe<Scalars["Int"]>;
	durationMonthsDiscontinued_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	durationMonthsDiscontinued_LT?: InputMaybe<Scalars["Int"]>;
	durationMonthsDiscontinued_LTE?: InputMaybe<Scalars["Int"]>;
	durationMonthsDiscontinued_NOT?: InputMaybe<Scalars["Int"]>;
	durationMonthsDiscontinued_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	durationMonths_GT?: InputMaybe<Scalars["Int"]>;
	durationMonths_GTE?: InputMaybe<Scalars["Int"]>;
	durationMonths_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	durationMonths_LT?: InputMaybe<Scalars["Int"]>;
	durationMonths_LTE?: InputMaybe<Scalars["Int"]>;
	durationMonths_NOT?: InputMaybe<Scalars["Int"]>;
	durationMonths_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	grossAmount?: InputMaybe<Scalars["Float"]>;
	grossAmountDelta?: InputMaybe<Scalars["Float"]>;
	grossAmountDelta_GT?: InputMaybe<Scalars["Float"]>;
	grossAmountDelta_GTE?: InputMaybe<Scalars["Float"]>;
	grossAmountDelta_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	grossAmountDelta_LT?: InputMaybe<Scalars["Float"]>;
	grossAmountDelta_LTE?: InputMaybe<Scalars["Float"]>;
	grossAmountDelta_NOT?: InputMaybe<Scalars["Float"]>;
	grossAmountDelta_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	grossAmountPerCase?: InputMaybe<Scalars["Float"]>;
	grossAmountPerCaseDiscontinued?: InputMaybe<Scalars["Float"]>;
	grossAmountPerCaseDiscontinued_GT?: InputMaybe<Scalars["Float"]>;
	grossAmountPerCaseDiscontinued_GTE?: InputMaybe<Scalars["Float"]>;
	grossAmountPerCaseDiscontinued_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	grossAmountPerCaseDiscontinued_LT?: InputMaybe<Scalars["Float"]>;
	grossAmountPerCaseDiscontinued_LTE?: InputMaybe<Scalars["Float"]>;
	grossAmountPerCaseDiscontinued_NOT?: InputMaybe<Scalars["Float"]>;
	grossAmountPerCaseDiscontinued_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	grossAmountPerCase_GT?: InputMaybe<Scalars["Float"]>;
	grossAmountPerCase_GTE?: InputMaybe<Scalars["Float"]>;
	grossAmountPerCase_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	grossAmountPerCase_LT?: InputMaybe<Scalars["Float"]>;
	grossAmountPerCase_LTE?: InputMaybe<Scalars["Float"]>;
	grossAmountPerCase_NOT?: InputMaybe<Scalars["Float"]>;
	grossAmountPerCase_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	grossAmount_GT?: InputMaybe<Scalars["Float"]>;
	grossAmount_GTE?: InputMaybe<Scalars["Float"]>;
	grossAmount_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	grossAmount_LT?: InputMaybe<Scalars["Float"]>;
	grossAmount_LTE?: InputMaybe<Scalars["Float"]>;
	grossAmount_NOT?: InputMaybe<Scalars["Float"]>;
	grossAmount_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	netAmount?: InputMaybe<Scalars["Float"]>;
	netAmountPerCase?: InputMaybe<Scalars["Float"]>;
	netAmountPerCaseDiscontinued?: InputMaybe<Scalars["Float"]>;
	netAmountPerCaseDiscontinued_GT?: InputMaybe<Scalars["Float"]>;
	netAmountPerCaseDiscontinued_GTE?: InputMaybe<Scalars["Float"]>;
	netAmountPerCaseDiscontinued_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	netAmountPerCaseDiscontinued_LT?: InputMaybe<Scalars["Float"]>;
	netAmountPerCaseDiscontinued_LTE?: InputMaybe<Scalars["Float"]>;
	netAmountPerCaseDiscontinued_NOT?: InputMaybe<Scalars["Float"]>;
	netAmountPerCaseDiscontinued_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	netAmountPerCase_GT?: InputMaybe<Scalars["Float"]>;
	netAmountPerCase_GTE?: InputMaybe<Scalars["Float"]>;
	netAmountPerCase_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	netAmountPerCase_LT?: InputMaybe<Scalars["Float"]>;
	netAmountPerCase_LTE?: InputMaybe<Scalars["Float"]>;
	netAmountPerCase_NOT?: InputMaybe<Scalars["Float"]>;
	netAmountPerCase_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	netAmount_GT?: InputMaybe<Scalars["Float"]>;
	netAmount_GTE?: InputMaybe<Scalars["Float"]>;
	netAmount_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	netAmount_LT?: InputMaybe<Scalars["Float"]>;
	netAmount_LTE?: InputMaybe<Scalars["Float"]>;
	netAmount_NOT?: InputMaybe<Scalars["Float"]>;
	netAmount_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
};

/** Fields to sort Agreements by. The order in which sorts are applied is not guaranteed when specifying many fields in one AgreementSort object. */
export type AgreementSort = {
	description?: InputMaybe<SortDirection>;
	formattedAmount?: InputMaybe<SortDirection>;
	formattedCounterparties?: InputMaybe<SortDirection>;
	formattedProducts?: InputMaybe<SortDirection>;
	formattedTags?: InputMaybe<SortDirection>;
	formattedValidityPeriod?: InputMaybe<SortDirection>;
	id?: InputMaybe<SortDirection>;
	initialVersionId?: InputMaybe<SortDirection>;
	isArchived?: InputMaybe<SortDirection>;
	isDeleted?: InputMaybe<SortDirection>;
	isFirstVersion?: InputMaybe<SortDirection>;
	isHidden?: InputMaybe<SortDirection>;
	isInsightsAvailable?: InputMaybe<SortDirection>;
	isLastVersion?: InputMaybe<SortDirection>;
	isRatingEnabled?: InputMaybe<SortDirection>;
	isTherapyDecisionEnabled?: InputMaybe<SortDirection>;
	lastVersionValidToDate?: InputMaybe<SortDirection>;
	name?: InputMaybe<SortDirection>;
	status?: InputMaybe<SortDirection>;
	totalAmount?: InputMaybe<SortDirection>;
	unlimited?: InputMaybe<SortDirection>;
	validFromDate?: InputMaybe<SortDirection>;
	validToDate?: InputMaybe<SortDirection>;
};

export type AgreementSpecificRole = {
	__typename?: "AgreementSpecificRole";
	agreementId: Scalars["ID"];
	agreementName: Scalars["String"];
	agreementTags: Array<Scalars["String"]>;
	agreementUserRole?: Maybe<AgreementUserRole>;
};

export type AgreementSpecificRoleAggregateSelection = {
	__typename?: "AgreementSpecificRoleAggregateSelection";
	agreementId: IdAggregateSelection;
	agreementName: StringAggregateSelection;
	count: Scalars["Int"];
};

export type AgreementSpecificRoleOptions = {
	limit?: InputMaybe<Scalars["Int"]>;
	offset?: InputMaybe<Scalars["Int"]>;
	/** Specify one or more AgreementSpecificRoleSort objects to sort AgreementSpecificRoles by. The sorts will be applied in the order in which they are arranged in the array. */
	sort?: InputMaybe<Array<InputMaybe<AgreementSpecificRoleSort>>>;
};

/** Fields to sort AgreementSpecificRoles by. The order in which sorts are applied is not guaranteed when specifying many fields in one AgreementSpecificRoleSort object. */
export type AgreementSpecificRoleSort = {
	agreementId?: InputMaybe<SortDirection>;
	agreementName?: InputMaybe<SortDirection>;
	agreementUserRole?: InputMaybe<SortDirection>;
};

export type AgreementSpecificRoleWhere = {
	AND?: InputMaybe<Array<AgreementSpecificRoleWhere>>;
	OR?: InputMaybe<Array<AgreementSpecificRoleWhere>>;
	agreementId?: InputMaybe<Scalars["ID"]>;
	agreementId_CONTAINS?: InputMaybe<Scalars["ID"]>;
	agreementId_ENDS_WITH?: InputMaybe<Scalars["ID"]>;
	agreementId_IN?: InputMaybe<Array<InputMaybe<Scalars["ID"]>>>;
	agreementId_MATCHES?: InputMaybe<Scalars["String"]>;
	agreementId_NOT?: InputMaybe<Scalars["ID"]>;
	agreementId_NOT_CONTAINS?: InputMaybe<Scalars["ID"]>;
	agreementId_NOT_ENDS_WITH?: InputMaybe<Scalars["ID"]>;
	agreementId_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["ID"]>>>;
	agreementId_NOT_STARTS_WITH?: InputMaybe<Scalars["ID"]>;
	agreementId_STARTS_WITH?: InputMaybe<Scalars["ID"]>;
	agreementName?: InputMaybe<Scalars["String"]>;
	agreementName_CONTAINS?: InputMaybe<Scalars["String"]>;
	agreementName_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	agreementName_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	agreementName_MATCHES?: InputMaybe<Scalars["String"]>;
	agreementName_NOT?: InputMaybe<Scalars["String"]>;
	agreementName_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	agreementName_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	agreementName_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	agreementName_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	agreementName_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	agreementTags?: InputMaybe<Array<Scalars["String"]>>;
	agreementTags_INCLUDES?: InputMaybe<Scalars["String"]>;
	agreementTags_NOT?: InputMaybe<Array<Scalars["String"]>>;
	agreementTags_NOT_INCLUDES?: InputMaybe<Scalars["String"]>;
	agreementUserRole?: InputMaybe<AgreementUserRole>;
	agreementUserRole_IN?: InputMaybe<Array<InputMaybe<AgreementUserRole>>>;
	agreementUserRole_NOT?: InputMaybe<AgreementUserRole>;
	agreementUserRole_NOT_IN?: InputMaybe<Array<InputMaybe<AgreementUserRole>>>;
};

export type AgreementStatusTransition = {
	__typename?: "AgreementStatusTransition";
	causedBy?: Maybe<User>;
	causedByConnection: AgreementStatusTransitionCausedByConnection;
	createdOn: Scalars["DateTime"];
	from?: Maybe<ContractStatus>;
	to: ContractStatus;
};

export type AgreementStatusTransitionCausedByArgs = {
	options?: InputMaybe<UserOptions>;
	where?: InputMaybe<UserWhere>;
};

export type AgreementStatusTransitionCausedByConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<AgreementStatusTransitionCausedByConnectionSort>>;
	where?: InputMaybe<AgreementStatusTransitionCausedByConnectionWhere>;
};

export type AgreementStatusTransitionAggregateSelection = {
	__typename?: "AgreementStatusTransitionAggregateSelection";
	count: Scalars["Int"];
	createdOn: DateTimeAggregateSelection;
};

export type AgreementStatusTransitionCausedByAggregateInput = {
	AND?: InputMaybe<Array<AgreementStatusTransitionCausedByAggregateInput>>;
	OR?: InputMaybe<Array<AgreementStatusTransitionCausedByAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<AgreementStatusTransitionCausedByNodeAggregationWhereInput>;
};

export type AgreementStatusTransitionCausedByConnectFieldInput = {
	connect?: InputMaybe<UserConnectInput>;
	where?: InputMaybe<UserConnectWhere>;
};

export type AgreementStatusTransitionCausedByConnection = {
	__typename?: "AgreementStatusTransitionCausedByConnection";
	edges: Array<AgreementStatusTransitionCausedByRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type AgreementStatusTransitionCausedByConnectionSort = {
	node?: InputMaybe<UserSort>;
};

export type AgreementStatusTransitionCausedByConnectionWhere = {
	AND?: InputMaybe<Array<AgreementStatusTransitionCausedByConnectionWhere>>;
	OR?: InputMaybe<Array<AgreementStatusTransitionCausedByConnectionWhere>>;
	node?: InputMaybe<UserWhere>;
	node_NOT?: InputMaybe<UserWhere>;
};

export type AgreementStatusTransitionCausedByCreateFieldInput = {
	node: UserCreateInput;
};

export type AgreementStatusTransitionCausedByDeleteFieldInput = {
	delete?: InputMaybe<UserDeleteInput>;
	where?: InputMaybe<AgreementStatusTransitionCausedByConnectionWhere>;
};

export type AgreementStatusTransitionCausedByDisconnectFieldInput = {
	disconnect?: InputMaybe<UserDisconnectInput>;
	where?: InputMaybe<AgreementStatusTransitionCausedByConnectionWhere>;
};

export type AgreementStatusTransitionCausedByFieldInput = {
	connect?: InputMaybe<AgreementStatusTransitionCausedByConnectFieldInput>;
	create?: InputMaybe<AgreementStatusTransitionCausedByCreateFieldInput>;
};

export type AgreementStatusTransitionCausedByNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<AgreementStatusTransitionCausedByNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<AgreementStatusTransitionCausedByNodeAggregationWhereInput>>;
	email_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	email_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	email_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	email_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	email_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	email_EQUAL?: InputMaybe<Scalars["String"]>;
	email_GT?: InputMaybe<Scalars["Int"]>;
	email_GTE?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	email_LT?: InputMaybe<Scalars["Int"]>;
	email_LTE?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	firstName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	firstName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	firstName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	firstName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	firstName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	firstName_EQUAL?: InputMaybe<Scalars["String"]>;
	firstName_GT?: InputMaybe<Scalars["Int"]>;
	firstName_GTE?: InputMaybe<Scalars["Int"]>;
	firstName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	firstName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	firstName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	firstName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	firstName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	firstName_LT?: InputMaybe<Scalars["Int"]>;
	firstName_LTE?: InputMaybe<Scalars["Int"]>;
	firstName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	firstName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	firstName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	firstName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	firstName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	lastName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	lastName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	lastName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	lastName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	lastName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	lastName_EQUAL?: InputMaybe<Scalars["String"]>;
	lastName_GT?: InputMaybe<Scalars["Int"]>;
	lastName_GTE?: InputMaybe<Scalars["Int"]>;
	lastName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	lastName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	lastName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	lastName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	lastName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	lastName_LT?: InputMaybe<Scalars["Int"]>;
	lastName_LTE?: InputMaybe<Scalars["Int"]>;
	lastName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	lastName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	lastName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	lastName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	lastName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	preferredLanguage_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	preferredLanguage_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	preferredLanguage_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	preferredLanguage_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	preferredLanguage_EQUAL?: InputMaybe<Scalars["String"]>;
	preferredLanguage_GT?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_GTE?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LT?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LTE?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	tenantId_EQUAL?: InputMaybe<Scalars["String"]>;
	tenantId_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type AgreementStatusTransitionCausedByRelationship = {
	__typename?: "AgreementStatusTransitionCausedByRelationship";
	cursor: Scalars["String"];
	node: User;
};

export type AgreementStatusTransitionCausedByUpdateConnectionInput = {
	node?: InputMaybe<UserUpdateInput>;
};

export type AgreementStatusTransitionCausedByUpdateFieldInput = {
	connect?: InputMaybe<AgreementStatusTransitionCausedByConnectFieldInput>;
	create?: InputMaybe<AgreementStatusTransitionCausedByCreateFieldInput>;
	delete?: InputMaybe<AgreementStatusTransitionCausedByDeleteFieldInput>;
	disconnect?: InputMaybe<AgreementStatusTransitionCausedByDisconnectFieldInput>;
	update?: InputMaybe<AgreementStatusTransitionCausedByUpdateConnectionInput>;
	where?: InputMaybe<AgreementStatusTransitionCausedByConnectionWhere>;
};

export type AgreementStatusTransitionConnectInput = {
	causedBy?: InputMaybe<AgreementStatusTransitionCausedByConnectFieldInput>;
};

export type AgreementStatusTransitionConnectWhere = {
	node: AgreementStatusTransitionWhere;
};

export type AgreementStatusTransitionCreateInput = {
	causedBy?: InputMaybe<AgreementStatusTransitionCausedByFieldInput>;
	createdOn: Scalars["DateTime"];
	from?: InputMaybe<ContractStatus>;
	to: ContractStatus;
};

export type AgreementStatusTransitionDeleteInput = {
	causedBy?: InputMaybe<AgreementStatusTransitionCausedByDeleteFieldInput>;
};

export type AgreementStatusTransitionDisconnectInput = {
	causedBy?: InputMaybe<AgreementStatusTransitionCausedByDisconnectFieldInput>;
};

export type AgreementStatusTransitionOptions = {
	limit?: InputMaybe<Scalars["Int"]>;
	offset?: InputMaybe<Scalars["Int"]>;
	/** Specify one or more AgreementStatusTransitionSort objects to sort AgreementStatusTransitions by. The sorts will be applied in the order in which they are arranged in the array. */
	sort?: InputMaybe<Array<InputMaybe<AgreementStatusTransitionSort>>>;
};

/** Fields to sort AgreementStatusTransitions by. The order in which sorts are applied is not guaranteed when specifying many fields in one AgreementStatusTransitionSort object. */
export type AgreementStatusTransitionSort = {
	createdOn?: InputMaybe<SortDirection>;
	from?: InputMaybe<SortDirection>;
	to?: InputMaybe<SortDirection>;
};

export type AgreementStatusTransitionUpdateInput = {
	causedBy?: InputMaybe<AgreementStatusTransitionCausedByUpdateFieldInput>;
	createdOn?: InputMaybe<Scalars["DateTime"]>;
	from?: InputMaybe<ContractStatus>;
	to?: InputMaybe<ContractStatus>;
};

export type AgreementStatusTransitionWhere = {
	AND?: InputMaybe<Array<AgreementStatusTransitionWhere>>;
	OR?: InputMaybe<Array<AgreementStatusTransitionWhere>>;
	causedBy?: InputMaybe<UserWhere>;
	causedByAggregate?: InputMaybe<AgreementStatusTransitionCausedByAggregateInput>;
	causedByConnection?: InputMaybe<AgreementStatusTransitionCausedByConnectionWhere>;
	causedByConnection_NOT?: InputMaybe<AgreementStatusTransitionCausedByConnectionWhere>;
	causedBy_NOT?: InputMaybe<UserWhere>;
	createdOn?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_IN?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]>>>;
	createdOn_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_NOT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]>>>;
	from?: InputMaybe<ContractStatus>;
	from_IN?: InputMaybe<Array<InputMaybe<ContractStatus>>>;
	from_NOT?: InputMaybe<ContractStatus>;
	from_NOT_IN?: InputMaybe<Array<InputMaybe<ContractStatus>>>;
	to?: InputMaybe<ContractStatus>;
	to_IN?: InputMaybe<Array<InputMaybe<ContractStatus>>>;
	to_NOT?: InputMaybe<ContractStatus>;
	to_NOT_IN?: InputMaybe<Array<InputMaybe<ContractStatus>>>;
};

export enum AgreementSubjectMatter {
	Devices = "DEVICES",
	Drugs = "DRUGS",
}

export type AgreementTag = {
	__typename?: "AgreementTag";
	defaultUserRoles: Array<User>;
	defaultUserRolesConnection: AgreementTagDefaultUserRolesConnection;
	id: Scalars["Int"];
	name: Scalars["String"];
	type: AgreementTagType;
};

export type AgreementTagDefaultUserRolesArgs = {
	options?: InputMaybe<UserOptions>;
	where?: InputMaybe<UserWhere>;
};

export type AgreementTagDefaultUserRolesConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<AgreementTagDefaultUserRolesConnectionSort>>;
	where?: InputMaybe<AgreementTagDefaultUserRolesConnectionWhere>;
};

export type AgreementTagAggregateSelection = {
	__typename?: "AgreementTagAggregateSelection";
	count: Scalars["Int"];
	id: IntAggregateSelection;
	name: StringAggregateSelection;
};

export type AgreementTagConnectInput = {
	defaultUserRoles?: InputMaybe<Array<AgreementTagDefaultUserRolesConnectFieldInput>>;
};

export type AgreementTagConnectWhere = {
	node: AgreementTagWhere;
};

export type AgreementTagCreateInput = {
	defaultUserRoles?: InputMaybe<AgreementTagDefaultUserRolesFieldInput>;
	id: Scalars["Int"];
	name: Scalars["String"];
	type: AgreementTagType;
};

export type AgreementTagDefaultUserRolesAggregateInput = {
	AND?: InputMaybe<Array<AgreementTagDefaultUserRolesAggregateInput>>;
	OR?: InputMaybe<Array<AgreementTagDefaultUserRolesAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<AgreementTagDefaultUserRolesNodeAggregationWhereInput>;
};

export type AgreementTagDefaultUserRolesConnectFieldInput = {
	connect?: InputMaybe<Array<UserConnectInput>>;
	edge: AgreementTagUserRoleRelationshipCreateInput;
	where?: InputMaybe<UserConnectWhere>;
};

export type AgreementTagDefaultUserRolesConnection = {
	__typename?: "AgreementTagDefaultUserRolesConnection";
	edges: Array<AgreementTagDefaultUserRolesRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type AgreementTagDefaultUserRolesConnectionSort = {
	edge?: InputMaybe<AgreementTagUserRoleRelationshipSort>;
	node?: InputMaybe<UserSort>;
};

export type AgreementTagDefaultUserRolesConnectionWhere = {
	AND?: InputMaybe<Array<AgreementTagDefaultUserRolesConnectionWhere>>;
	OR?: InputMaybe<Array<AgreementTagDefaultUserRolesConnectionWhere>>;
	edge?: InputMaybe<AgreementTagUserRoleRelationshipWhere>;
	edge_NOT?: InputMaybe<AgreementTagUserRoleRelationshipWhere>;
	node?: InputMaybe<UserWhere>;
	node_NOT?: InputMaybe<UserWhere>;
};

export type AgreementTagDefaultUserRolesCreateFieldInput = {
	edge: AgreementTagUserRoleRelationshipCreateInput;
	node: UserCreateInput;
};

export type AgreementTagDefaultUserRolesDeleteFieldInput = {
	delete?: InputMaybe<UserDeleteInput>;
	where?: InputMaybe<AgreementTagDefaultUserRolesConnectionWhere>;
};

export type AgreementTagDefaultUserRolesDisconnectFieldInput = {
	disconnect?: InputMaybe<UserDisconnectInput>;
	where?: InputMaybe<AgreementTagDefaultUserRolesConnectionWhere>;
};

export type AgreementTagDefaultUserRolesFieldInput = {
	connect?: InputMaybe<Array<AgreementTagDefaultUserRolesConnectFieldInput>>;
	create?: InputMaybe<Array<AgreementTagDefaultUserRolesCreateFieldInput>>;
};

export type AgreementTagDefaultUserRolesNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<AgreementTagDefaultUserRolesNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<AgreementTagDefaultUserRolesNodeAggregationWhereInput>>;
	email_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	email_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	email_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	email_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	email_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	email_EQUAL?: InputMaybe<Scalars["String"]>;
	email_GT?: InputMaybe<Scalars["Int"]>;
	email_GTE?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	email_LT?: InputMaybe<Scalars["Int"]>;
	email_LTE?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	firstName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	firstName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	firstName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	firstName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	firstName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	firstName_EQUAL?: InputMaybe<Scalars["String"]>;
	firstName_GT?: InputMaybe<Scalars["Int"]>;
	firstName_GTE?: InputMaybe<Scalars["Int"]>;
	firstName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	firstName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	firstName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	firstName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	firstName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	firstName_LT?: InputMaybe<Scalars["Int"]>;
	firstName_LTE?: InputMaybe<Scalars["Int"]>;
	firstName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	firstName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	firstName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	firstName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	firstName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	lastName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	lastName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	lastName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	lastName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	lastName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	lastName_EQUAL?: InputMaybe<Scalars["String"]>;
	lastName_GT?: InputMaybe<Scalars["Int"]>;
	lastName_GTE?: InputMaybe<Scalars["Int"]>;
	lastName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	lastName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	lastName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	lastName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	lastName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	lastName_LT?: InputMaybe<Scalars["Int"]>;
	lastName_LTE?: InputMaybe<Scalars["Int"]>;
	lastName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	lastName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	lastName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	lastName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	lastName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	preferredLanguage_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	preferredLanguage_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	preferredLanguage_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	preferredLanguage_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	preferredLanguage_EQUAL?: InputMaybe<Scalars["String"]>;
	preferredLanguage_GT?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_GTE?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LT?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LTE?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	tenantId_EQUAL?: InputMaybe<Scalars["String"]>;
	tenantId_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type AgreementTagDefaultUserRolesRelationship = AgreementTagUserRoleRelationship & {
	__typename?: "AgreementTagDefaultUserRolesRelationship";
	cursor: Scalars["String"];
	node: User;
	role: AgreementUserRole;
};

export type AgreementTagDefaultUserRolesUpdateConnectionInput = {
	edge?: InputMaybe<AgreementTagUserRoleRelationshipUpdateInput>;
	node?: InputMaybe<UserUpdateInput>;
};

export type AgreementTagDefaultUserRolesUpdateFieldInput = {
	connect?: InputMaybe<Array<AgreementTagDefaultUserRolesConnectFieldInput>>;
	create?: InputMaybe<Array<AgreementTagDefaultUserRolesCreateFieldInput>>;
	delete?: InputMaybe<Array<AgreementTagDefaultUserRolesDeleteFieldInput>>;
	disconnect?: InputMaybe<Array<AgreementTagDefaultUserRolesDisconnectFieldInput>>;
	update?: InputMaybe<AgreementTagDefaultUserRolesUpdateConnectionInput>;
	where?: InputMaybe<AgreementTagDefaultUserRolesConnectionWhere>;
};

export type AgreementTagDeleteInput = {
	defaultUserRoles?: InputMaybe<Array<AgreementTagDefaultUserRolesDeleteFieldInput>>;
};

export type AgreementTagDisconnectInput = {
	defaultUserRoles?: InputMaybe<Array<AgreementTagDefaultUserRolesDisconnectFieldInput>>;
};

export type AgreementTagOptions = {
	limit?: InputMaybe<Scalars["Int"]>;
	offset?: InputMaybe<Scalars["Int"]>;
	/** Specify one or more AgreementTagSort objects to sort AgreementTags by. The sorts will be applied in the order in which they are arranged in the array. */
	sort?: InputMaybe<Array<InputMaybe<AgreementTagSort>>>;
};

/** Fields to sort AgreementTags by. The order in which sorts are applied is not guaranteed when specifying many fields in one AgreementTagSort object. */
export type AgreementTagSort = {
	id?: InputMaybe<SortDirection>;
	name?: InputMaybe<SortDirection>;
	type?: InputMaybe<SortDirection>;
};

export enum AgreementTagType {
	Article_71 = "ARTICLE_71",
	Custom = "CUSTOM",
	Sll = "SLL",
	VolumeBased = "VOLUME_BASED",
}

export type AgreementTagUpdateInput = {
	defaultUserRoles?: InputMaybe<Array<AgreementTagDefaultUserRolesUpdateFieldInput>>;
	id?: InputMaybe<Scalars["Int"]>;
	name?: InputMaybe<Scalars["String"]>;
	type?: InputMaybe<AgreementTagType>;
};

export type AgreementTagUserRoleRelationship = {
	role: AgreementUserRole;
};

export type AgreementTagUserRoleRelationshipCreateInput = {
	role: AgreementUserRole;
};

export type AgreementTagUserRoleRelationshipSort = {
	role?: InputMaybe<SortDirection>;
};

export type AgreementTagUserRoleRelationshipUpdateInput = {
	role?: InputMaybe<AgreementUserRole>;
};

export type AgreementTagUserRoleRelationshipWhere = {
	AND?: InputMaybe<Array<AgreementTagUserRoleRelationshipWhere>>;
	OR?: InputMaybe<Array<AgreementTagUserRoleRelationshipWhere>>;
	role?: InputMaybe<AgreementUserRole>;
	role_IN?: InputMaybe<Array<InputMaybe<AgreementUserRole>>>;
	role_NOT?: InputMaybe<AgreementUserRole>;
	role_NOT_IN?: InputMaybe<Array<InputMaybe<AgreementUserRole>>>;
};

export type AgreementTagWhere = {
	AND?: InputMaybe<Array<AgreementTagWhere>>;
	OR?: InputMaybe<Array<AgreementTagWhere>>;
	defaultUserRoles?: InputMaybe<UserWhere>;
	defaultUserRolesAggregate?: InputMaybe<AgreementTagDefaultUserRolesAggregateInput>;
	defaultUserRolesConnection?: InputMaybe<AgreementTagDefaultUserRolesConnectionWhere>;
	defaultUserRolesConnection_NOT?: InputMaybe<AgreementTagDefaultUserRolesConnectionWhere>;
	defaultUserRoles_NOT?: InputMaybe<UserWhere>;
	id?: InputMaybe<Scalars["Int"]>;
	id_GT?: InputMaybe<Scalars["Int"]>;
	id_GTE?: InputMaybe<Scalars["Int"]>;
	id_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	id_LT?: InputMaybe<Scalars["Int"]>;
	id_LTE?: InputMaybe<Scalars["Int"]>;
	id_NOT?: InputMaybe<Scalars["Int"]>;
	id_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	name?: InputMaybe<Scalars["String"]>;
	name_CONTAINS?: InputMaybe<Scalars["String"]>;
	name_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	name_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	name_MATCHES?: InputMaybe<Scalars["String"]>;
	name_NOT?: InputMaybe<Scalars["String"]>;
	name_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	name_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	name_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	name_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	name_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	type?: InputMaybe<AgreementTagType>;
	type_IN?: InputMaybe<Array<InputMaybe<AgreementTagType>>>;
	type_NOT?: InputMaybe<AgreementTagType>;
	type_NOT_IN?: InputMaybe<Array<InputMaybe<AgreementTagType>>>;
};

export type AgreementTagsAggregateInput = {
	AND?: InputMaybe<Array<AgreementTagsAggregateInput>>;
	OR?: InputMaybe<Array<AgreementTagsAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<AgreementTagsNodeAggregationWhereInput>;
};

export type AgreementTagsConnectFieldInput = {
	connect?: InputMaybe<Array<AgreementTagConnectInput>>;
	where?: InputMaybe<AgreementTagConnectWhere>;
};

export type AgreementTagsConnection = {
	__typename?: "AgreementTagsConnection";
	edges: Array<AgreementTagsRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type AgreementTagsConnectionSort = {
	node?: InputMaybe<AgreementTagSort>;
};

export type AgreementTagsConnectionWhere = {
	AND?: InputMaybe<Array<AgreementTagsConnectionWhere>>;
	OR?: InputMaybe<Array<AgreementTagsConnectionWhere>>;
	node?: InputMaybe<AgreementTagWhere>;
	node_NOT?: InputMaybe<AgreementTagWhere>;
};

export type AgreementTagsCreateFieldInput = {
	node: AgreementTagCreateInput;
};

export type AgreementTagsDeleteFieldInput = {
	delete?: InputMaybe<AgreementTagDeleteInput>;
	where?: InputMaybe<AgreementTagsConnectionWhere>;
};

export type AgreementTagsDisconnectFieldInput = {
	disconnect?: InputMaybe<AgreementTagDisconnectInput>;
	where?: InputMaybe<AgreementTagsConnectionWhere>;
};

export type AgreementTagsFieldInput = {
	connect?: InputMaybe<Array<AgreementTagsConnectFieldInput>>;
	create?: InputMaybe<Array<AgreementTagsCreateFieldInput>>;
};

export type AgreementTagsNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<AgreementTagsNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<AgreementTagsNodeAggregationWhereInput>>;
	id_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	id_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	id_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	id_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	id_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	id_EQUAL?: InputMaybe<Scalars["Int"]>;
	id_GT?: InputMaybe<Scalars["Int"]>;
	id_GTE?: InputMaybe<Scalars["Int"]>;
	id_LT?: InputMaybe<Scalars["Int"]>;
	id_LTE?: InputMaybe<Scalars["Int"]>;
	id_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	id_MAX_GT?: InputMaybe<Scalars["Int"]>;
	id_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	id_MAX_LT?: InputMaybe<Scalars["Int"]>;
	id_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	id_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	id_MIN_GT?: InputMaybe<Scalars["Int"]>;
	id_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	id_MIN_LT?: InputMaybe<Scalars["Int"]>;
	id_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	name_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	name_EQUAL?: InputMaybe<Scalars["String"]>;
	name_GT?: InputMaybe<Scalars["Int"]>;
	name_GTE?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	name_LT?: InputMaybe<Scalars["Int"]>;
	name_LTE?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type AgreementTagsRelationship = {
	__typename?: "AgreementTagsRelationship";
	cursor: Scalars["String"];
	node: AgreementTag;
};

export type AgreementTagsUpdateConnectionInput = {
	node?: InputMaybe<AgreementTagUpdateInput>;
};

export type AgreementTagsUpdateFieldInput = {
	connect?: InputMaybe<Array<AgreementTagsConnectFieldInput>>;
	create?: InputMaybe<Array<AgreementTagsCreateFieldInput>>;
	delete?: InputMaybe<Array<AgreementTagsDeleteFieldInput>>;
	disconnect?: InputMaybe<Array<AgreementTagsDisconnectFieldInput>>;
	update?: InputMaybe<AgreementTagsUpdateConnectionInput>;
	where?: InputMaybe<AgreementTagsConnectionWhere>;
};

export type AgreementUpdateInput = {
	allowedForms?: InputMaybe<Array<FormType>>;
	counterpartyRoles?: InputMaybe<Array<AgreementCounterpartyRolesUpdateFieldInput>>;
	currency?: InputMaybe<AgreementCurrencyUpdateFieldInput>;
	description?: InputMaybe<Scalars["String"]>;
	deviceAlternativeSets?: InputMaybe<Array<AgreementDeviceAlternativeSetsUpdateFieldInput>>;
	formattedAmount?: InputMaybe<Scalars["String"]>;
	formattedCounterparties?: InputMaybe<Scalars["String"]>;
	formattedProducts?: InputMaybe<Scalars["String"]>;
	formattedTags?: InputMaybe<Scalars["String"]>;
	formattedValidityPeriod?: InputMaybe<Scalars["String"]>;
	id?: InputMaybe<Scalars["ID"]>;
	initialVersionId?: InputMaybe<Scalars["String"]>;
	isArchived?: InputMaybe<Scalars["Boolean"]>;
	isDeleted?: InputMaybe<Scalars["Boolean"]>;
	isFirstVersion?: InputMaybe<Scalars["Boolean"]>;
	isHidden?: InputMaybe<Scalars["Boolean"]>;
	isInsightsAvailable?: InputMaybe<Scalars["Boolean"]>;
	isLastVersion?: InputMaybe<Scalars["Boolean"]>;
	isRatingEnabled?: InputMaybe<Scalars["Boolean"]>;
	isTherapyDecisionEnabled?: InputMaybe<Scalars["Boolean"]>;
	lastVersionValidToDate?: InputMaybe<Scalars["Date"]>;
	name?: InputMaybe<Scalars["String"]>;
	status?: InputMaybe<ContractStatus>;
	tags?: InputMaybe<Array<AgreementTagsUpdateFieldInput>>;
	tenantIds?: InputMaybe<Array<Scalars["String"]>>;
	totalAmount?: InputMaybe<Scalars["Float"]>;
	unlimited?: InputMaybe<Scalars["Int"]>;
	userRoles?: InputMaybe<Array<AgreementUserRolesUpdateFieldInput>>;
	validFromDate?: InputMaybe<Scalars["Date"]>;
	validToDate?: InputMaybe<Scalars["Date"]>;
	workflows?: InputMaybe<Array<AgreementWorkflowsUpdateFieldInput>>;
};

export enum AgreementUserRole {
	Approver = "APPROVER",
	Editor = "EDITOR",
	FullAccessUser = "FULL_ACCESS_USER",
	LimitedAccessUser = "LIMITED_ACCESS_USER",
	Owner = "OWNER",
}

export type AgreementUserRoleRelationship = {
	canApprove: Scalars["Boolean"];
	canModifyFinancials: Scalars["Boolean"];
	canViewFinancials: Scalars["Boolean"];
	isAssignee?: Maybe<Scalars["Boolean"]>;
	role: AgreementUserRole;
};

export type AgreementUserRoleRelationshipCreateInput = {
	canApprove: Scalars["Boolean"];
	canModifyFinancials: Scalars["Boolean"];
	canViewFinancials: Scalars["Boolean"];
	isAssignee?: InputMaybe<Scalars["Boolean"]>;
	role: AgreementUserRole;
};

export type AgreementUserRoleRelationshipSort = {
	canApprove?: InputMaybe<SortDirection>;
	canModifyFinancials?: InputMaybe<SortDirection>;
	canViewFinancials?: InputMaybe<SortDirection>;
	isAssignee?: InputMaybe<SortDirection>;
	role?: InputMaybe<SortDirection>;
};

export type AgreementUserRoleRelationshipUpdateInput = {
	canApprove?: InputMaybe<Scalars["Boolean"]>;
	canModifyFinancials?: InputMaybe<Scalars["Boolean"]>;
	canViewFinancials?: InputMaybe<Scalars["Boolean"]>;
	isAssignee?: InputMaybe<Scalars["Boolean"]>;
	role?: InputMaybe<AgreementUserRole>;
};

export type AgreementUserRoleRelationshipWhere = {
	AND?: InputMaybe<Array<AgreementUserRoleRelationshipWhere>>;
	OR?: InputMaybe<Array<AgreementUserRoleRelationshipWhere>>;
	canApprove?: InputMaybe<Scalars["Boolean"]>;
	canApprove_NOT?: InputMaybe<Scalars["Boolean"]>;
	canModifyFinancials?: InputMaybe<Scalars["Boolean"]>;
	canModifyFinancials_NOT?: InputMaybe<Scalars["Boolean"]>;
	canViewFinancials?: InputMaybe<Scalars["Boolean"]>;
	canViewFinancials_NOT?: InputMaybe<Scalars["Boolean"]>;
	isAssignee?: InputMaybe<Scalars["Boolean"]>;
	isAssignee_NOT?: InputMaybe<Scalars["Boolean"]>;
	role?: InputMaybe<AgreementUserRole>;
	role_IN?: InputMaybe<Array<InputMaybe<AgreementUserRole>>>;
	role_NOT?: InputMaybe<AgreementUserRole>;
	role_NOT_IN?: InputMaybe<Array<InputMaybe<AgreementUserRole>>>;
};

export type AgreementUserRolesAggregateInput = {
	AND?: InputMaybe<Array<AgreementUserRolesAggregateInput>>;
	OR?: InputMaybe<Array<AgreementUserRolesAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<AgreementUserRolesNodeAggregationWhereInput>;
};

export type AgreementUserRolesConnectFieldInput = {
	connect?: InputMaybe<Array<UserConnectInput>>;
	edge: AgreementUserRoleRelationshipCreateInput;
	where?: InputMaybe<UserConnectWhere>;
};

export type AgreementUserRolesConnection = {
	__typename?: "AgreementUserRolesConnection";
	edges: Array<AgreementUserRolesRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type AgreementUserRolesConnectionSort = {
	edge?: InputMaybe<AgreementUserRoleRelationshipSort>;
	node?: InputMaybe<UserSort>;
};

export type AgreementUserRolesConnectionWhere = {
	AND?: InputMaybe<Array<AgreementUserRolesConnectionWhere>>;
	OR?: InputMaybe<Array<AgreementUserRolesConnectionWhere>>;
	edge?: InputMaybe<AgreementUserRoleRelationshipWhere>;
	edge_NOT?: InputMaybe<AgreementUserRoleRelationshipWhere>;
	node?: InputMaybe<UserWhere>;
	node_NOT?: InputMaybe<UserWhere>;
};

export type AgreementUserRolesCreateFieldInput = {
	edge: AgreementUserRoleRelationshipCreateInput;
	node: UserCreateInput;
};

export type AgreementUserRolesDeleteFieldInput = {
	delete?: InputMaybe<UserDeleteInput>;
	where?: InputMaybe<AgreementUserRolesConnectionWhere>;
};

export type AgreementUserRolesDisconnectFieldInput = {
	disconnect?: InputMaybe<UserDisconnectInput>;
	where?: InputMaybe<AgreementUserRolesConnectionWhere>;
};

export type AgreementUserRolesFieldInput = {
	connect?: InputMaybe<Array<AgreementUserRolesConnectFieldInput>>;
	create?: InputMaybe<Array<AgreementUserRolesCreateFieldInput>>;
};

export type AgreementUserRolesNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<AgreementUserRolesNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<AgreementUserRolesNodeAggregationWhereInput>>;
	email_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	email_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	email_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	email_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	email_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	email_EQUAL?: InputMaybe<Scalars["String"]>;
	email_GT?: InputMaybe<Scalars["Int"]>;
	email_GTE?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	email_LT?: InputMaybe<Scalars["Int"]>;
	email_LTE?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	firstName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	firstName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	firstName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	firstName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	firstName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	firstName_EQUAL?: InputMaybe<Scalars["String"]>;
	firstName_GT?: InputMaybe<Scalars["Int"]>;
	firstName_GTE?: InputMaybe<Scalars["Int"]>;
	firstName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	firstName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	firstName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	firstName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	firstName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	firstName_LT?: InputMaybe<Scalars["Int"]>;
	firstName_LTE?: InputMaybe<Scalars["Int"]>;
	firstName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	firstName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	firstName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	firstName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	firstName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	lastName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	lastName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	lastName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	lastName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	lastName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	lastName_EQUAL?: InputMaybe<Scalars["String"]>;
	lastName_GT?: InputMaybe<Scalars["Int"]>;
	lastName_GTE?: InputMaybe<Scalars["Int"]>;
	lastName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	lastName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	lastName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	lastName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	lastName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	lastName_LT?: InputMaybe<Scalars["Int"]>;
	lastName_LTE?: InputMaybe<Scalars["Int"]>;
	lastName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	lastName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	lastName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	lastName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	lastName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	preferredLanguage_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	preferredLanguage_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	preferredLanguage_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	preferredLanguage_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	preferredLanguage_EQUAL?: InputMaybe<Scalars["String"]>;
	preferredLanguage_GT?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_GTE?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LT?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LTE?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	tenantId_EQUAL?: InputMaybe<Scalars["String"]>;
	tenantId_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type AgreementUserRolesRelationship = AgreementUserRoleRelationship & {
	__typename?: "AgreementUserRolesRelationship";
	canApprove: Scalars["Boolean"];
	canModifyFinancials: Scalars["Boolean"];
	canViewFinancials: Scalars["Boolean"];
	cursor: Scalars["String"];
	isAssignee?: Maybe<Scalars["Boolean"]>;
	node: User;
	role: AgreementUserRole;
};

export type AgreementUserRolesUpdateConnectionInput = {
	edge?: InputMaybe<AgreementUserRoleRelationshipUpdateInput>;
	node?: InputMaybe<UserUpdateInput>;
};

export type AgreementUserRolesUpdateFieldInput = {
	connect?: InputMaybe<Array<AgreementUserRolesConnectFieldInput>>;
	create?: InputMaybe<Array<AgreementUserRolesCreateFieldInput>>;
	delete?: InputMaybe<Array<AgreementUserRolesDeleteFieldInput>>;
	disconnect?: InputMaybe<Array<AgreementUserRolesDisconnectFieldInput>>;
	update?: InputMaybe<AgreementUserRolesUpdateConnectionInput>;
	where?: InputMaybe<AgreementUserRolesConnectionWhere>;
};

export type AgreementWhere = {
	AND?: InputMaybe<Array<AgreementWhere>>;
	OR?: InputMaybe<Array<AgreementWhere>>;
	allowedForms?: InputMaybe<Array<FormType>>;
	allowedForms_INCLUDES?: InputMaybe<FormType>;
	allowedForms_NOT?: InputMaybe<Array<FormType>>;
	allowedForms_NOT_INCLUDES?: InputMaybe<FormType>;
	counterpartyRoles?: InputMaybe<OrganizationWhere>;
	counterpartyRolesAggregate?: InputMaybe<AgreementCounterpartyRolesAggregateInput>;
	counterpartyRolesConnection?: InputMaybe<AgreementCounterpartyRolesConnectionWhere>;
	counterpartyRolesConnection_NOT?: InputMaybe<AgreementCounterpartyRolesConnectionWhere>;
	counterpartyRoles_NOT?: InputMaybe<OrganizationWhere>;
	currency?: InputMaybe<CurrencyWhere>;
	currencyAggregate?: InputMaybe<AgreementCurrencyAggregateInput>;
	currencyConnection?: InputMaybe<AgreementCurrencyConnectionWhere>;
	currencyConnection_NOT?: InputMaybe<AgreementCurrencyConnectionWhere>;
	currency_NOT?: InputMaybe<CurrencyWhere>;
	description?: InputMaybe<Scalars["String"]>;
	description_CONTAINS?: InputMaybe<Scalars["String"]>;
	description_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	description_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	description_MATCHES?: InputMaybe<Scalars["String"]>;
	description_NOT?: InputMaybe<Scalars["String"]>;
	description_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	description_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	description_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	description_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	description_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	deviceAlternativeSets?: InputMaybe<DeviceAlternativeWhere>;
	deviceAlternativeSetsAggregate?: InputMaybe<AgreementDeviceAlternativeSetsAggregateInput>;
	deviceAlternativeSetsConnection?: InputMaybe<AgreementDeviceAlternativeSetsConnectionWhere>;
	deviceAlternativeSetsConnection_NOT?: InputMaybe<AgreementDeviceAlternativeSetsConnectionWhere>;
	deviceAlternativeSets_NOT?: InputMaybe<DeviceAlternativeWhere>;
	formattedAmount?: InputMaybe<Scalars["String"]>;
	formattedAmount_CONTAINS?: InputMaybe<Scalars["String"]>;
	formattedAmount_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	formattedAmount_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	formattedAmount_MATCHES?: InputMaybe<Scalars["String"]>;
	formattedAmount_NOT?: InputMaybe<Scalars["String"]>;
	formattedAmount_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	formattedAmount_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	formattedAmount_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	formattedAmount_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	formattedAmount_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	formattedCounterparties?: InputMaybe<Scalars["String"]>;
	formattedCounterparties_CONTAINS?: InputMaybe<Scalars["String"]>;
	formattedCounterparties_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	formattedCounterparties_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	formattedCounterparties_MATCHES?: InputMaybe<Scalars["String"]>;
	formattedCounterparties_NOT?: InputMaybe<Scalars["String"]>;
	formattedCounterparties_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	formattedCounterparties_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	formattedCounterparties_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	formattedCounterparties_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	formattedCounterparties_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	formattedProducts?: InputMaybe<Scalars["String"]>;
	formattedProducts_CONTAINS?: InputMaybe<Scalars["String"]>;
	formattedProducts_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	formattedProducts_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	formattedProducts_MATCHES?: InputMaybe<Scalars["String"]>;
	formattedProducts_NOT?: InputMaybe<Scalars["String"]>;
	formattedProducts_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	formattedProducts_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	formattedProducts_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	formattedProducts_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	formattedProducts_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	formattedTags?: InputMaybe<Scalars["String"]>;
	formattedTags_CONTAINS?: InputMaybe<Scalars["String"]>;
	formattedTags_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	formattedTags_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	formattedTags_MATCHES?: InputMaybe<Scalars["String"]>;
	formattedTags_NOT?: InputMaybe<Scalars["String"]>;
	formattedTags_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	formattedTags_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	formattedTags_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	formattedTags_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	formattedTags_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	formattedValidityPeriod?: InputMaybe<Scalars["String"]>;
	formattedValidityPeriod_CONTAINS?: InputMaybe<Scalars["String"]>;
	formattedValidityPeriod_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	formattedValidityPeriod_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	formattedValidityPeriod_MATCHES?: InputMaybe<Scalars["String"]>;
	formattedValidityPeriod_NOT?: InputMaybe<Scalars["String"]>;
	formattedValidityPeriod_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	formattedValidityPeriod_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	formattedValidityPeriod_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	formattedValidityPeriod_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	formattedValidityPeriod_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	id?: InputMaybe<Scalars["ID"]>;
	id_CONTAINS?: InputMaybe<Scalars["ID"]>;
	id_ENDS_WITH?: InputMaybe<Scalars["ID"]>;
	id_IN?: InputMaybe<Array<InputMaybe<Scalars["ID"]>>>;
	id_MATCHES?: InputMaybe<Scalars["String"]>;
	id_NOT?: InputMaybe<Scalars["ID"]>;
	id_NOT_CONTAINS?: InputMaybe<Scalars["ID"]>;
	id_NOT_ENDS_WITH?: InputMaybe<Scalars["ID"]>;
	id_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["ID"]>>>;
	id_NOT_STARTS_WITH?: InputMaybe<Scalars["ID"]>;
	id_STARTS_WITH?: InputMaybe<Scalars["ID"]>;
	initialVersionId?: InputMaybe<Scalars["String"]>;
	initialVersionId_CONTAINS?: InputMaybe<Scalars["String"]>;
	initialVersionId_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	initialVersionId_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	initialVersionId_MATCHES?: InputMaybe<Scalars["String"]>;
	initialVersionId_NOT?: InputMaybe<Scalars["String"]>;
	initialVersionId_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	initialVersionId_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	initialVersionId_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	initialVersionId_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	initialVersionId_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	isArchived?: InputMaybe<Scalars["Boolean"]>;
	isArchived_NOT?: InputMaybe<Scalars["Boolean"]>;
	isDeleted?: InputMaybe<Scalars["Boolean"]>;
	isDeleted_NOT?: InputMaybe<Scalars["Boolean"]>;
	isFirstVersion?: InputMaybe<Scalars["Boolean"]>;
	isFirstVersion_NOT?: InputMaybe<Scalars["Boolean"]>;
	isHidden?: InputMaybe<Scalars["Boolean"]>;
	isHidden_NOT?: InputMaybe<Scalars["Boolean"]>;
	isInsightsAvailable?: InputMaybe<Scalars["Boolean"]>;
	isInsightsAvailable_NOT?: InputMaybe<Scalars["Boolean"]>;
	isLastVersion?: InputMaybe<Scalars["Boolean"]>;
	isLastVersion_NOT?: InputMaybe<Scalars["Boolean"]>;
	isRatingEnabled?: InputMaybe<Scalars["Boolean"]>;
	isRatingEnabled_NOT?: InputMaybe<Scalars["Boolean"]>;
	isTherapyDecisionEnabled?: InputMaybe<Scalars["Boolean"]>;
	isTherapyDecisionEnabled_NOT?: InputMaybe<Scalars["Boolean"]>;
	lastVersionValidToDate?: InputMaybe<Scalars["Date"]>;
	lastVersionValidToDate_GT?: InputMaybe<Scalars["Date"]>;
	lastVersionValidToDate_GTE?: InputMaybe<Scalars["Date"]>;
	lastVersionValidToDate_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
	lastVersionValidToDate_LT?: InputMaybe<Scalars["Date"]>;
	lastVersionValidToDate_LTE?: InputMaybe<Scalars["Date"]>;
	lastVersionValidToDate_NOT?: InputMaybe<Scalars["Date"]>;
	lastVersionValidToDate_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
	name?: InputMaybe<Scalars["String"]>;
	name_CONTAINS?: InputMaybe<Scalars["String"]>;
	name_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	name_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	name_MATCHES?: InputMaybe<Scalars["String"]>;
	name_NOT?: InputMaybe<Scalars["String"]>;
	name_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	name_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	name_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	name_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	name_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	status?: InputMaybe<ContractStatus>;
	status_IN?: InputMaybe<Array<InputMaybe<ContractStatus>>>;
	status_NOT?: InputMaybe<ContractStatus>;
	status_NOT_IN?: InputMaybe<Array<InputMaybe<ContractStatus>>>;
	tags?: InputMaybe<AgreementTagWhere>;
	tagsAggregate?: InputMaybe<AgreementTagsAggregateInput>;
	tagsConnection?: InputMaybe<AgreementTagsConnectionWhere>;
	tagsConnection_NOT?: InputMaybe<AgreementTagsConnectionWhere>;
	tags_NOT?: InputMaybe<AgreementTagWhere>;
	tenantIds?: InputMaybe<Array<Scalars["String"]>>;
	tenantIds_INCLUDES?: InputMaybe<Scalars["String"]>;
	tenantIds_NOT?: InputMaybe<Array<Scalars["String"]>>;
	tenantIds_NOT_INCLUDES?: InputMaybe<Scalars["String"]>;
	totalAmount?: InputMaybe<Scalars["Float"]>;
	totalAmount_GT?: InputMaybe<Scalars["Float"]>;
	totalAmount_GTE?: InputMaybe<Scalars["Float"]>;
	totalAmount_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	totalAmount_LT?: InputMaybe<Scalars["Float"]>;
	totalAmount_LTE?: InputMaybe<Scalars["Float"]>;
	totalAmount_NOT?: InputMaybe<Scalars["Float"]>;
	totalAmount_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	unlimited?: InputMaybe<Scalars["Int"]>;
	unlimited_GT?: InputMaybe<Scalars["Int"]>;
	unlimited_GTE?: InputMaybe<Scalars["Int"]>;
	unlimited_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	unlimited_LT?: InputMaybe<Scalars["Int"]>;
	unlimited_LTE?: InputMaybe<Scalars["Int"]>;
	unlimited_NOT?: InputMaybe<Scalars["Int"]>;
	unlimited_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	userRoles?: InputMaybe<UserWhere>;
	userRolesAggregate?: InputMaybe<AgreementUserRolesAggregateInput>;
	userRolesConnection?: InputMaybe<AgreementUserRolesConnectionWhere>;
	userRolesConnection_NOT?: InputMaybe<AgreementUserRolesConnectionWhere>;
	userRoles_NOT?: InputMaybe<UserWhere>;
	validFromDate?: InputMaybe<Scalars["Date"]>;
	validFromDate_GT?: InputMaybe<Scalars["Date"]>;
	validFromDate_GTE?: InputMaybe<Scalars["Date"]>;
	validFromDate_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
	validFromDate_LT?: InputMaybe<Scalars["Date"]>;
	validFromDate_LTE?: InputMaybe<Scalars["Date"]>;
	validFromDate_NOT?: InputMaybe<Scalars["Date"]>;
	validFromDate_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
	validToDate?: InputMaybe<Scalars["Date"]>;
	validToDate_GT?: InputMaybe<Scalars["Date"]>;
	validToDate_GTE?: InputMaybe<Scalars["Date"]>;
	validToDate_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
	validToDate_LT?: InputMaybe<Scalars["Date"]>;
	validToDate_LTE?: InputMaybe<Scalars["Date"]>;
	validToDate_NOT?: InputMaybe<Scalars["Date"]>;
	validToDate_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
	workflows?: InputMaybe<ContractWorkflowWhere>;
	workflowsAggregate?: InputMaybe<AgreementWorkflowsAggregateInput>;
	workflowsConnection?: InputMaybe<AgreementWorkflowsConnectionWhere>;
	workflowsConnection_NOT?: InputMaybe<AgreementWorkflowsConnectionWhere>;
	workflows_NOT?: InputMaybe<ContractWorkflowWhere>;
};

export type AgreementWorkflowsAggregateInput = {
	AND?: InputMaybe<Array<AgreementWorkflowsAggregateInput>>;
	OR?: InputMaybe<Array<AgreementWorkflowsAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
};

export type AgreementWorkflowsConnectFieldInput = {
	connect?: InputMaybe<Array<ContractWorkflowConnectInput>>;
	where?: InputMaybe<ContractWorkflowConnectWhere>;
};

export type AgreementWorkflowsConnection = {
	__typename?: "AgreementWorkflowsConnection";
	edges: Array<AgreementWorkflowsRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type AgreementWorkflowsConnectionSort = {
	node?: InputMaybe<ContractWorkflowSort>;
};

export type AgreementWorkflowsConnectionWhere = {
	AND?: InputMaybe<Array<AgreementWorkflowsConnectionWhere>>;
	OR?: InputMaybe<Array<AgreementWorkflowsConnectionWhere>>;
	node?: InputMaybe<ContractWorkflowWhere>;
	node_NOT?: InputMaybe<ContractWorkflowWhere>;
};

export type AgreementWorkflowsCreateFieldInput = {
	node: ContractWorkflowCreateInput;
};

export type AgreementWorkflowsDeleteFieldInput = {
	delete?: InputMaybe<ContractWorkflowDeleteInput>;
	where?: InputMaybe<AgreementWorkflowsConnectionWhere>;
};

export type AgreementWorkflowsDisconnectFieldInput = {
	disconnect?: InputMaybe<ContractWorkflowDisconnectInput>;
	where?: InputMaybe<AgreementWorkflowsConnectionWhere>;
};

export type AgreementWorkflowsFieldInput = {
	connect?: InputMaybe<Array<AgreementWorkflowsConnectFieldInput>>;
	create?: InputMaybe<Array<AgreementWorkflowsCreateFieldInput>>;
};

export type AgreementWorkflowsRelationship = {
	__typename?: "AgreementWorkflowsRelationship";
	cursor: Scalars["String"];
	node: ContractWorkflow;
};

export type AgreementWorkflowsUpdateConnectionInput = {
	node?: InputMaybe<ContractWorkflowUpdateInput>;
};

export type AgreementWorkflowsUpdateFieldInput = {
	connect?: InputMaybe<Array<AgreementWorkflowsConnectFieldInput>>;
	create?: InputMaybe<Array<AgreementWorkflowsCreateFieldInput>>;
	delete?: InputMaybe<Array<AgreementWorkflowsDeleteFieldInput>>;
	disconnect?: InputMaybe<Array<AgreementWorkflowsDisconnectFieldInput>>;
	update?: InputMaybe<AgreementWorkflowsUpdateConnectionInput>;
	where?: InputMaybe<AgreementWorkflowsConnectionWhere>;
};

export enum ArithmeticalOperator {
	Equal = "EQUAL",
	FallsBetween = "FALLS_BETWEEN",
	GreaterThen = "GREATER_THEN",
	GreaterThenOrEqual = "GREATER_THEN_OR_EQUAL",
	LessThen = "LESS_THEN",
	LessThenOrEqual = "LESS_THEN_OR_EQUAL",
}

export type AssignInvoiceToUserInput = {
	assignee?: InputMaybe<AssigneeInput>;
	invoiceId: Scalars["ID"];
};

export type AssigneeInput = {
	email: Scalars["String"];
	tenantId: Scalars["String"];
};

export type AverageLaPressureAndLaVolumeRow = {
	__typename?: "AverageLAPressureAndLAVolumeRow";
	averageLAPressure: Scalars["Float"];
	averageLAVolume: Scalars["Float"];
	interventionType: ReportInterventionType;
	maxLAPressure: Scalars["Float"];
	maxLAVolume: Scalars["Float"];
	minLAPressure: Scalars["Float"];
	minLAVolume: Scalars["Float"];
};

export type AverageLaPressureAndLaVolumeRowAggregateSelection = {
	__typename?: "AverageLAPressureAndLAVolumeRowAggregateSelection";
	averageLAPressure: FloatAggregateSelection;
	averageLAVolume: FloatAggregateSelection;
	count: Scalars["Int"];
	maxLAPressure: FloatAggregateSelection;
	maxLAVolume: FloatAggregateSelection;
	minLAPressure: FloatAggregateSelection;
	minLAVolume: FloatAggregateSelection;
};

export type AverageLaPressureAndLaVolumeRowOptions = {
	limit?: InputMaybe<Scalars["Int"]>;
	offset?: InputMaybe<Scalars["Int"]>;
	/** Specify one or more AverageLAPressureAndLAVolumeRowSort objects to sort AverageLAPressureAndLAVolumeRows by. The sorts will be applied in the order in which they are arranged in the array. */
	sort?: InputMaybe<Array<InputMaybe<AverageLaPressureAndLaVolumeRowSort>>>;
};

/** Fields to sort AverageLAPressureAndLAVolumeRows by. The order in which sorts are applied is not guaranteed when specifying many fields in one AverageLAPressureAndLAVolumeRowSort object. */
export type AverageLaPressureAndLaVolumeRowSort = {
	averageLAPressure?: InputMaybe<SortDirection>;
	averageLAVolume?: InputMaybe<SortDirection>;
	interventionType?: InputMaybe<SortDirection>;
	maxLAPressure?: InputMaybe<SortDirection>;
	maxLAVolume?: InputMaybe<SortDirection>;
	minLAPressure?: InputMaybe<SortDirection>;
	minLAVolume?: InputMaybe<SortDirection>;
};

export type AverageLaPressureAndLaVolumeRowWhere = {
	AND?: InputMaybe<Array<AverageLaPressureAndLaVolumeRowWhere>>;
	OR?: InputMaybe<Array<AverageLaPressureAndLaVolumeRowWhere>>;
	averageLAPressure?: InputMaybe<Scalars["Float"]>;
	averageLAPressure_GT?: InputMaybe<Scalars["Float"]>;
	averageLAPressure_GTE?: InputMaybe<Scalars["Float"]>;
	averageLAPressure_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	averageLAPressure_LT?: InputMaybe<Scalars["Float"]>;
	averageLAPressure_LTE?: InputMaybe<Scalars["Float"]>;
	averageLAPressure_NOT?: InputMaybe<Scalars["Float"]>;
	averageLAPressure_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	averageLAVolume?: InputMaybe<Scalars["Float"]>;
	averageLAVolume_GT?: InputMaybe<Scalars["Float"]>;
	averageLAVolume_GTE?: InputMaybe<Scalars["Float"]>;
	averageLAVolume_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	averageLAVolume_LT?: InputMaybe<Scalars["Float"]>;
	averageLAVolume_LTE?: InputMaybe<Scalars["Float"]>;
	averageLAVolume_NOT?: InputMaybe<Scalars["Float"]>;
	averageLAVolume_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	interventionType?: InputMaybe<ReportInterventionType>;
	interventionType_IN?: InputMaybe<Array<InputMaybe<ReportInterventionType>>>;
	interventionType_NOT?: InputMaybe<ReportInterventionType>;
	interventionType_NOT_IN?: InputMaybe<Array<InputMaybe<ReportInterventionType>>>;
	maxLAPressure?: InputMaybe<Scalars["Float"]>;
	maxLAPressure_GT?: InputMaybe<Scalars["Float"]>;
	maxLAPressure_GTE?: InputMaybe<Scalars["Float"]>;
	maxLAPressure_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	maxLAPressure_LT?: InputMaybe<Scalars["Float"]>;
	maxLAPressure_LTE?: InputMaybe<Scalars["Float"]>;
	maxLAPressure_NOT?: InputMaybe<Scalars["Float"]>;
	maxLAPressure_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	maxLAVolume?: InputMaybe<Scalars["Float"]>;
	maxLAVolume_GT?: InputMaybe<Scalars["Float"]>;
	maxLAVolume_GTE?: InputMaybe<Scalars["Float"]>;
	maxLAVolume_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	maxLAVolume_LT?: InputMaybe<Scalars["Float"]>;
	maxLAVolume_LTE?: InputMaybe<Scalars["Float"]>;
	maxLAVolume_NOT?: InputMaybe<Scalars["Float"]>;
	maxLAVolume_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	minLAPressure?: InputMaybe<Scalars["Float"]>;
	minLAPressure_GT?: InputMaybe<Scalars["Float"]>;
	minLAPressure_GTE?: InputMaybe<Scalars["Float"]>;
	minLAPressure_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	minLAPressure_LT?: InputMaybe<Scalars["Float"]>;
	minLAPressure_LTE?: InputMaybe<Scalars["Float"]>;
	minLAPressure_NOT?: InputMaybe<Scalars["Float"]>;
	minLAPressure_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	minLAVolume?: InputMaybe<Scalars["Float"]>;
	minLAVolume_GT?: InputMaybe<Scalars["Float"]>;
	minLAVolume_GTE?: InputMaybe<Scalars["Float"]>;
	minLAVolume_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	minLAVolume_LT?: InputMaybe<Scalars["Float"]>;
	minLAVolume_LTE?: InputMaybe<Scalars["Float"]>;
	minLAVolume_NOT?: InputMaybe<Scalars["Float"]>;
	minLAVolume_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
};

export type BaseAgreement = {
	__typename?: "BaseAgreement";
	addedBy: User;
	addedByConnection: BaseAgreementAddedByConnection;
	allowedForms?: Maybe<Array<FormType>>;
	allowedRecords?: Maybe<Array<RecordType>>;
	canUserViewFinancials: Scalars["Boolean"];
	categories: Array<DeviceProductCategory>;
	categoriesConnection: BaseAgreementCategoriesConnection;
	counterparties: Array<Organization>;
	counterpartiesConnection: BaseAgreementCounterpartiesConnection;
	coveringFormWaitInterval?: Maybe<Scalars["Int"]>;
	createdOn: Scalars["DateTime"];
	currency?: Maybe<Currency>;
	currencyConnection: BaseAgreementCurrencyConnection;
	dataContainers: Array<DataContainer>;
	dataContainersConnection: BaseAgreementDataContainersConnection;
	dataSource: DataSource;
	dataSourceConnection: BaseAgreementDataSourceConnection;
	decisions: Array<AgreementDecision>;
	decisionsConnection: BaseAgreementDecisionsConnection;
	deviceAlternativeSets: Array<DeviceAlternative>;
	deviceAlternativeSetsConnection: BaseAgreementDeviceAlternativeSetsConnection;
	discountCapsCategories?: Maybe<Array<DeviceProductCategory>>;
	discountCapsCategoriesConnection: BaseAgreementDiscountCapsCategoriesConnection;
	discountCapsDeviceKits?: Maybe<Array<DeviceKit>>;
	discountCapsDeviceKitsConnection: BaseAgreementDiscountCapsDeviceKitsConnection;
	eligibilityConditionSets: Array<EligibilityConditionSet>;
	eligibilityConditionSetsConnection: BaseAgreementEligibilityConditionSetsConnection;
	enrollingConditionSets: Array<EnrollingConditionSet>;
	enrollingConditionSetsConnection: BaseAgreementEnrollingConditionSetsConnection;
	enrollingPeriods?: Maybe<Array<EnrollingPeriod>>;
	enrollingPeriodsConnection: BaseAgreementEnrollingPeriodsConnection;
	financialSummaryConfig: Array<FinancialSummaryColumn>;
	financialSummaryConfigConnection: BaseAgreementFinancialSummaryConfigConnection;
	firstExecutionDate?: Maybe<Scalars["DateTime"]>;
	formattedAmount?: Maybe<Scalars["String"]>;
	formattedCounterparties?: Maybe<Scalars["String"]>;
	formattedProducts?: Maybe<Scalars["String"]>;
	formattedTags: Scalars["String"];
	formattedValidityPeriod?: Maybe<Scalars["String"]>;
	id: Scalars["ID"];
	initialVersion: BaseAgreement;
	initialVersionConnection: BaseAgreementInitialVersionConnection;
	initialVersionId: Scalars["String"];
	isAllowedFormsEnabled: Scalars["Boolean"];
	isAllowedRecordsEnabled: Scalars["Boolean"];
	isCoveringIntervalEnabled: Scalars["Boolean"];
	isDeleted: Scalars["Boolean"];
	isExtended?: Maybe<Scalars["Boolean"]>;
	isFirstVersion: Scalars["Boolean"];
	isHidden: Scalars["Boolean"];
	isInsightsAvailable?: Maybe<Scalars["Boolean"]>;
	isLastVersion: Scalars["Boolean"];
	isRatingEnabled?: Maybe<Scalars["Boolean"]>;
	isRequiredFormsEnabled: Scalars["Boolean"];
	isRequiredRecordsEnabled: Scalars["Boolean"];
	isTherapyDecisionEnabled?: Maybe<Scalars["Boolean"]>;
	lastExecutionDate?: Maybe<Scalars["DateTime"]>;
	name: Scalars["String"];
	namedTimeRanges: Array<Timeframe>;
	namedTimeRangesConnection: BaseAgreementNamedTimeRangesConnection;
	nextVersions: Array<BaseAgreement>;
	nextVersionsConnection: BaseAgreementNextVersionsConnection;
	processedDeviceRecords: Array<ProcessedDeviceRecord>;
	processedDeviceRecordsConnection: BaseAgreementProcessedDeviceRecordsConnection;
	pushedBy?: Maybe<User>;
	pushedByConnection: BaseAgreementPushedByConnection;
	pushedOn?: Maybe<Scalars["DateTime"]>;
	rating?: Maybe<Array<CoverageRequestRating>>;
	requiredForms?: Maybe<Array<FormType>>;
	requiredRecords?: Maybe<Array<RecordType>>;
	scenarios: Array<Scenario>;
	scenariosConnection: BaseAgreementScenariosConnection;
	status: ContractStatus;
	statusTransitions: Array<AgreementStatusTransition>;
	statusTransitionsConnection: BaseAgreementStatusTransitionsConnection;
	subjectMatter: AgreementSubjectMatter;
	tags: Array<AgreementTag>;
	tagsConnection: BaseAgreementTagsConnection;
	tenantIds?: Maybe<Array<Scalars["String"]>>;
	therapyDecision?: Maybe<Array<CoverageRequestTherapyDecision>>;
	treatmentPrices: Array<Treatment>;
	treatmentPricesConnection: BaseAgreementTreatmentPricesConnection;
	userContexts: Array<UserContext>;
	userContextsConnection: BaseAgreementUserContextsConnection;
	userOrganizationRole?: Maybe<CounterpartyRole>;
	userRoles: Array<User>;
	userRolesConnection: BaseAgreementUserRolesConnection;
	validFromDate: Scalars["Date"];
	validToDate?: Maybe<Scalars["Date"]>;
	version: Scalars["Int"];
};

export type BaseAgreementAddedByArgs = {
	options?: InputMaybe<UserOptions>;
	where?: InputMaybe<UserWhere>;
};

export type BaseAgreementAddedByConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<BaseAgreementAddedByConnectionSort>>;
	where?: InputMaybe<BaseAgreementAddedByConnectionWhere>;
};

export type BaseAgreementCategoriesArgs = {
	options?: InputMaybe<DeviceProductCategoryOptions>;
	where?: InputMaybe<DeviceProductCategoryWhere>;
};

export type BaseAgreementCategoriesConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<BaseAgreementCategoriesConnectionSort>>;
	where?: InputMaybe<BaseAgreementCategoriesConnectionWhere>;
};

export type BaseAgreementCounterpartiesArgs = {
	options?: InputMaybe<OrganizationOptions>;
	where?: InputMaybe<OrganizationWhere>;
};

export type BaseAgreementCounterpartiesConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<BaseAgreementCounterpartiesConnectionSort>>;
	where?: InputMaybe<BaseAgreementCounterpartiesConnectionWhere>;
};

export type BaseAgreementCurrencyArgs = {
	options?: InputMaybe<CurrencyOptions>;
	where?: InputMaybe<CurrencyWhere>;
};

export type BaseAgreementCurrencyConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<BaseAgreementCurrencyConnectionSort>>;
	where?: InputMaybe<BaseAgreementCurrencyConnectionWhere>;
};

export type BaseAgreementDataContainersArgs = {
	options?: InputMaybe<DataContainerOptions>;
	where?: InputMaybe<DataContainerWhere>;
};

export type BaseAgreementDataContainersConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<BaseAgreementDataContainersConnectionSort>>;
	where?: InputMaybe<BaseAgreementDataContainersConnectionWhere>;
};

export type BaseAgreementDataSourceArgs = {
	options?: InputMaybe<DataSourceOptions>;
	where?: InputMaybe<DataSourceWhere>;
};

export type BaseAgreementDataSourceConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<BaseAgreementDataSourceConnectionSort>>;
	where?: InputMaybe<BaseAgreementDataSourceConnectionWhere>;
};

export type BaseAgreementDecisionsArgs = {
	options?: InputMaybe<AgreementDecisionOptions>;
	where?: InputMaybe<AgreementDecisionWhere>;
};

export type BaseAgreementDecisionsConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<BaseAgreementDecisionsConnectionSort>>;
	where?: InputMaybe<BaseAgreementDecisionsConnectionWhere>;
};

export type BaseAgreementDeviceAlternativeSetsArgs = {
	options?: InputMaybe<DeviceAlternativeOptions>;
	where?: InputMaybe<DeviceAlternativeWhere>;
};

export type BaseAgreementDeviceAlternativeSetsConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<BaseAgreementDeviceAlternativeSetsConnectionSort>>;
	where?: InputMaybe<BaseAgreementDeviceAlternativeSetsConnectionWhere>;
};

export type BaseAgreementDiscountCapsCategoriesArgs = {
	options?: InputMaybe<DeviceProductCategoryOptions>;
	where?: InputMaybe<DeviceProductCategoryWhere>;
};

export type BaseAgreementDiscountCapsCategoriesConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<BaseAgreementDiscountCapsCategoriesConnectionSort>>;
	where?: InputMaybe<BaseAgreementDiscountCapsCategoriesConnectionWhere>;
};

export type BaseAgreementDiscountCapsDeviceKitsArgs = {
	options?: InputMaybe<DeviceKitOptions>;
	where?: InputMaybe<DeviceKitWhere>;
};

export type BaseAgreementDiscountCapsDeviceKitsConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<BaseAgreementDiscountCapsDeviceKitsConnectionSort>>;
	where?: InputMaybe<BaseAgreementDiscountCapsDeviceKitsConnectionWhere>;
};

export type BaseAgreementEligibilityConditionSetsArgs = {
	options?: InputMaybe<EligibilityConditionSetOptions>;
	where?: InputMaybe<EligibilityConditionSetWhere>;
};

export type BaseAgreementEligibilityConditionSetsConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<BaseAgreementEligibilityConditionSetsConnectionSort>>;
	where?: InputMaybe<BaseAgreementEligibilityConditionSetsConnectionWhere>;
};

export type BaseAgreementEnrollingConditionSetsArgs = {
	options?: InputMaybe<EnrollingConditionSetOptions>;
	where?: InputMaybe<EnrollingConditionSetWhere>;
};

export type BaseAgreementEnrollingConditionSetsConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<BaseAgreementEnrollingConditionSetsConnectionSort>>;
	where?: InputMaybe<BaseAgreementEnrollingConditionSetsConnectionWhere>;
};

export type BaseAgreementEnrollingPeriodsArgs = {
	options?: InputMaybe<EnrollingPeriodOptions>;
	where?: InputMaybe<EnrollingPeriodWhere>;
};

export type BaseAgreementEnrollingPeriodsConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<BaseAgreementEnrollingPeriodsConnectionSort>>;
	where?: InputMaybe<BaseAgreementEnrollingPeriodsConnectionWhere>;
};

export type BaseAgreementFinancialSummaryConfigArgs = {
	options?: InputMaybe<FinancialSummaryColumnOptions>;
	where?: InputMaybe<FinancialSummaryColumnWhere>;
};

export type BaseAgreementFinancialSummaryConfigConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<BaseAgreementFinancialSummaryConfigConnectionSort>>;
	where?: InputMaybe<BaseAgreementFinancialSummaryConfigConnectionWhere>;
};

export type BaseAgreementInitialVersionArgs = {
	options?: InputMaybe<BaseAgreementOptions>;
	where?: InputMaybe<BaseAgreementWhere>;
};

export type BaseAgreementInitialVersionConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<BaseAgreementInitialVersionConnectionSort>>;
	where?: InputMaybe<BaseAgreementInitialVersionConnectionWhere>;
};

export type BaseAgreementNamedTimeRangesArgs = {
	options?: InputMaybe<TimeframeOptions>;
	where?: InputMaybe<TimeframeWhere>;
};

export type BaseAgreementNamedTimeRangesConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<BaseAgreementNamedTimeRangesConnectionSort>>;
	where?: InputMaybe<BaseAgreementNamedTimeRangesConnectionWhere>;
};

export type BaseAgreementNextVersionsArgs = {
	options?: InputMaybe<BaseAgreementOptions>;
	where?: InputMaybe<BaseAgreementWhere>;
};

export type BaseAgreementNextVersionsConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<BaseAgreementNextVersionsConnectionSort>>;
	where?: InputMaybe<BaseAgreementNextVersionsConnectionWhere>;
};

export type BaseAgreementProcessedDeviceRecordsArgs = {
	options?: InputMaybe<ProcessedDeviceRecordOptions>;
	where?: InputMaybe<ProcessedDeviceRecordWhere>;
};

export type BaseAgreementProcessedDeviceRecordsConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<BaseAgreementProcessedDeviceRecordsConnectionSort>>;
	where?: InputMaybe<BaseAgreementProcessedDeviceRecordsConnectionWhere>;
};

export type BaseAgreementPushedByArgs = {
	options?: InputMaybe<UserOptions>;
	where?: InputMaybe<UserWhere>;
};

export type BaseAgreementPushedByConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<BaseAgreementPushedByConnectionSort>>;
	where?: InputMaybe<BaseAgreementPushedByConnectionWhere>;
};

export type BaseAgreementScenariosArgs = {
	options?: InputMaybe<ScenarioOptions>;
	where?: InputMaybe<ScenarioWhere>;
};

export type BaseAgreementScenariosConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<BaseAgreementScenariosConnectionSort>>;
	where?: InputMaybe<BaseAgreementScenariosConnectionWhere>;
};

export type BaseAgreementStatusTransitionsArgs = {
	options?: InputMaybe<AgreementStatusTransitionOptions>;
	where?: InputMaybe<AgreementStatusTransitionWhere>;
};

export type BaseAgreementStatusTransitionsConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<BaseAgreementStatusTransitionsConnectionSort>>;
	where?: InputMaybe<BaseAgreementStatusTransitionsConnectionWhere>;
};

export type BaseAgreementTagsArgs = {
	options?: InputMaybe<AgreementTagOptions>;
	where?: InputMaybe<AgreementTagWhere>;
};

export type BaseAgreementTagsConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<BaseAgreementTagsConnectionSort>>;
	where?: InputMaybe<BaseAgreementTagsConnectionWhere>;
};

export type BaseAgreementTreatmentPricesArgs = {
	options?: InputMaybe<TreatmentOptions>;
	where?: InputMaybe<TreatmentWhere>;
};

export type BaseAgreementTreatmentPricesConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<BaseAgreementTreatmentPricesConnectionSort>>;
	where?: InputMaybe<BaseAgreementTreatmentPricesConnectionWhere>;
};

export type BaseAgreementUserContextsArgs = {
	options?: InputMaybe<UserContextOptions>;
	where?: InputMaybe<UserContextWhere>;
};

export type BaseAgreementUserContextsConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<BaseAgreementUserContextsConnectionSort>>;
	where?: InputMaybe<BaseAgreementUserContextsConnectionWhere>;
};

export type BaseAgreementUserRolesArgs = {
	options?: InputMaybe<UserOptions>;
	where?: InputMaybe<UserWhere>;
};

export type BaseAgreementUserRolesConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<BaseAgreementUserRolesConnectionSort>>;
	where?: InputMaybe<BaseAgreementUserRolesConnectionWhere>;
};

export type BaseAgreementAddedByAggregateInput = {
	AND?: InputMaybe<Array<BaseAgreementAddedByAggregateInput>>;
	OR?: InputMaybe<Array<BaseAgreementAddedByAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<BaseAgreementAddedByNodeAggregationWhereInput>;
};

export type BaseAgreementAddedByConnectFieldInput = {
	connect?: InputMaybe<UserConnectInput>;
	where?: InputMaybe<UserConnectWhere>;
};

export type BaseAgreementAddedByConnection = {
	__typename?: "BaseAgreementAddedByConnection";
	edges: Array<BaseAgreementAddedByRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type BaseAgreementAddedByConnectionSort = {
	node?: InputMaybe<UserSort>;
};

export type BaseAgreementAddedByConnectionWhere = {
	AND?: InputMaybe<Array<BaseAgreementAddedByConnectionWhere>>;
	OR?: InputMaybe<Array<BaseAgreementAddedByConnectionWhere>>;
	node?: InputMaybe<UserWhere>;
	node_NOT?: InputMaybe<UserWhere>;
};

export type BaseAgreementAddedByCreateFieldInput = {
	node: UserCreateInput;
};

export type BaseAgreementAddedByDeleteFieldInput = {
	delete?: InputMaybe<UserDeleteInput>;
	where?: InputMaybe<BaseAgreementAddedByConnectionWhere>;
};

export type BaseAgreementAddedByDisconnectFieldInput = {
	disconnect?: InputMaybe<UserDisconnectInput>;
	where?: InputMaybe<BaseAgreementAddedByConnectionWhere>;
};

export type BaseAgreementAddedByFieldInput = {
	connect?: InputMaybe<BaseAgreementAddedByConnectFieldInput>;
	create?: InputMaybe<BaseAgreementAddedByCreateFieldInput>;
};

export type BaseAgreementAddedByNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<BaseAgreementAddedByNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<BaseAgreementAddedByNodeAggregationWhereInput>>;
	email_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	email_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	email_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	email_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	email_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	email_EQUAL?: InputMaybe<Scalars["String"]>;
	email_GT?: InputMaybe<Scalars["Int"]>;
	email_GTE?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	email_LT?: InputMaybe<Scalars["Int"]>;
	email_LTE?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	firstName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	firstName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	firstName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	firstName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	firstName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	firstName_EQUAL?: InputMaybe<Scalars["String"]>;
	firstName_GT?: InputMaybe<Scalars["Int"]>;
	firstName_GTE?: InputMaybe<Scalars["Int"]>;
	firstName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	firstName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	firstName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	firstName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	firstName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	firstName_LT?: InputMaybe<Scalars["Int"]>;
	firstName_LTE?: InputMaybe<Scalars["Int"]>;
	firstName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	firstName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	firstName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	firstName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	firstName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	lastName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	lastName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	lastName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	lastName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	lastName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	lastName_EQUAL?: InputMaybe<Scalars["String"]>;
	lastName_GT?: InputMaybe<Scalars["Int"]>;
	lastName_GTE?: InputMaybe<Scalars["Int"]>;
	lastName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	lastName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	lastName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	lastName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	lastName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	lastName_LT?: InputMaybe<Scalars["Int"]>;
	lastName_LTE?: InputMaybe<Scalars["Int"]>;
	lastName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	lastName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	lastName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	lastName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	lastName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	preferredLanguage_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	preferredLanguage_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	preferredLanguage_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	preferredLanguage_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	preferredLanguage_EQUAL?: InputMaybe<Scalars["String"]>;
	preferredLanguage_GT?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_GTE?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LT?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LTE?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	tenantId_EQUAL?: InputMaybe<Scalars["String"]>;
	tenantId_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type BaseAgreementAddedByRelationship = {
	__typename?: "BaseAgreementAddedByRelationship";
	cursor: Scalars["String"];
	node: User;
};

export type BaseAgreementAddedByUpdateConnectionInput = {
	node?: InputMaybe<UserUpdateInput>;
};

export type BaseAgreementAddedByUpdateFieldInput = {
	connect?: InputMaybe<BaseAgreementAddedByConnectFieldInput>;
	create?: InputMaybe<BaseAgreementAddedByCreateFieldInput>;
	delete?: InputMaybe<BaseAgreementAddedByDeleteFieldInput>;
	disconnect?: InputMaybe<BaseAgreementAddedByDisconnectFieldInput>;
	update?: InputMaybe<BaseAgreementAddedByUpdateConnectionInput>;
	where?: InputMaybe<BaseAgreementAddedByConnectionWhere>;
};

export type BaseAgreementAggregateSelection = {
	__typename?: "BaseAgreementAggregateSelection";
	count: Scalars["Int"];
	coveringFormWaitInterval: IntAggregateSelection;
	createdOn: DateTimeAggregateSelection;
	firstExecutionDate: DateTimeAggregateSelection;
	formattedAmount: StringAggregateSelection;
	formattedCounterparties: StringAggregateSelection;
	formattedProducts: StringAggregateSelection;
	formattedTags: StringAggregateSelection;
	formattedValidityPeriod: StringAggregateSelection;
	id: IdAggregateSelection;
	initialVersionId: StringAggregateSelection;
	lastExecutionDate: DateTimeAggregateSelection;
	name: StringAggregateSelection;
	pushedOn: DateTimeAggregateSelection;
	version: IntAggregateSelection;
};

export type BaseAgreementCategoriesAggregateInput = {
	AND?: InputMaybe<Array<BaseAgreementCategoriesAggregateInput>>;
	OR?: InputMaybe<Array<BaseAgreementCategoriesAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<BaseAgreementCategoriesNodeAggregationWhereInput>;
};

export type BaseAgreementCategoriesConnectFieldInput = {
	connect?: InputMaybe<Array<DeviceProductCategoryConnectInput>>;
	where?: InputMaybe<DeviceProductCategoryConnectWhere>;
};

export type BaseAgreementCategoriesConnection = {
	__typename?: "BaseAgreementCategoriesConnection";
	edges: Array<BaseAgreementCategoriesRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type BaseAgreementCategoriesConnectionSort = {
	node?: InputMaybe<DeviceProductCategorySort>;
};

export type BaseAgreementCategoriesConnectionWhere = {
	AND?: InputMaybe<Array<BaseAgreementCategoriesConnectionWhere>>;
	OR?: InputMaybe<Array<BaseAgreementCategoriesConnectionWhere>>;
	node?: InputMaybe<DeviceProductCategoryWhere>;
	node_NOT?: InputMaybe<DeviceProductCategoryWhere>;
};

export type BaseAgreementCategoriesCreateFieldInput = {
	node: DeviceProductCategoryCreateInput;
};

export type BaseAgreementCategoriesDeleteFieldInput = {
	delete?: InputMaybe<DeviceProductCategoryDeleteInput>;
	where?: InputMaybe<BaseAgreementCategoriesConnectionWhere>;
};

export type BaseAgreementCategoriesDisconnectFieldInput = {
	disconnect?: InputMaybe<DeviceProductCategoryDisconnectInput>;
	where?: InputMaybe<BaseAgreementCategoriesConnectionWhere>;
};

export type BaseAgreementCategoriesFieldInput = {
	connect?: InputMaybe<Array<BaseAgreementCategoriesConnectFieldInput>>;
	create?: InputMaybe<Array<BaseAgreementCategoriesCreateFieldInput>>;
};

export type BaseAgreementCategoriesNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<BaseAgreementCategoriesNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<BaseAgreementCategoriesNodeAggregationWhereInput>>;
	code_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	code_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	code_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	code_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	code_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	code_EQUAL?: InputMaybe<Scalars["String"]>;
	code_GT?: InputMaybe<Scalars["Int"]>;
	code_GTE?: InputMaybe<Scalars["Int"]>;
	code_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	code_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	code_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	code_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	code_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	code_LT?: InputMaybe<Scalars["Int"]>;
	code_LTE?: InputMaybe<Scalars["Int"]>;
	code_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	code_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	code_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	code_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	code_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	level_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	level_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	level_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	level_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	level_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	level_EQUAL?: InputMaybe<Scalars["Int"]>;
	level_GT?: InputMaybe<Scalars["Int"]>;
	level_GTE?: InputMaybe<Scalars["Int"]>;
	level_LT?: InputMaybe<Scalars["Int"]>;
	level_LTE?: InputMaybe<Scalars["Int"]>;
	level_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	level_MAX_GT?: InputMaybe<Scalars["Int"]>;
	level_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	level_MAX_LT?: InputMaybe<Scalars["Int"]>;
	level_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	level_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	level_MIN_GT?: InputMaybe<Scalars["Int"]>;
	level_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	level_MIN_LT?: InputMaybe<Scalars["Int"]>;
	level_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	name_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	name_EQUAL?: InputMaybe<Scalars["String"]>;
	name_GT?: InputMaybe<Scalars["Int"]>;
	name_GTE?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	name_LT?: InputMaybe<Scalars["Int"]>;
	name_LTE?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	tenantId_EQUAL?: InputMaybe<Scalars["String"]>;
	tenantId_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type BaseAgreementCategoriesRelationship = {
	__typename?: "BaseAgreementCategoriesRelationship";
	cursor: Scalars["String"];
	node: DeviceProductCategory;
};

export type BaseAgreementCategoriesUpdateConnectionInput = {
	node?: InputMaybe<DeviceProductCategoryUpdateInput>;
};

export type BaseAgreementCategoriesUpdateFieldInput = {
	connect?: InputMaybe<Array<BaseAgreementCategoriesConnectFieldInput>>;
	create?: InputMaybe<Array<BaseAgreementCategoriesCreateFieldInput>>;
	delete?: InputMaybe<Array<BaseAgreementCategoriesDeleteFieldInput>>;
	disconnect?: InputMaybe<Array<BaseAgreementCategoriesDisconnectFieldInput>>;
	update?: InputMaybe<BaseAgreementCategoriesUpdateConnectionInput>;
	where?: InputMaybe<BaseAgreementCategoriesConnectionWhere>;
};

export type BaseAgreementCategoryDiscountCaps = {
	higherCap?: Maybe<Scalars["Int"]>;
	lowerCap?: Maybe<Scalars["Int"]>;
};

export type BaseAgreementCategoryDiscountCapsCreateInput = {
	higherCap?: InputMaybe<Scalars["Int"]>;
	lowerCap?: InputMaybe<Scalars["Int"]>;
};

export type BaseAgreementCategoryDiscountCapsSort = {
	higherCap?: InputMaybe<SortDirection>;
	lowerCap?: InputMaybe<SortDirection>;
};

export type BaseAgreementCategoryDiscountCapsUpdateInput = {
	higherCap?: InputMaybe<Scalars["Int"]>;
	lowerCap?: InputMaybe<Scalars["Int"]>;
};

export type BaseAgreementCategoryDiscountCapsWhere = {
	AND?: InputMaybe<Array<BaseAgreementCategoryDiscountCapsWhere>>;
	OR?: InputMaybe<Array<BaseAgreementCategoryDiscountCapsWhere>>;
	higherCap?: InputMaybe<Scalars["Int"]>;
	higherCap_GT?: InputMaybe<Scalars["Int"]>;
	higherCap_GTE?: InputMaybe<Scalars["Int"]>;
	higherCap_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	higherCap_LT?: InputMaybe<Scalars["Int"]>;
	higherCap_LTE?: InputMaybe<Scalars["Int"]>;
	higherCap_NOT?: InputMaybe<Scalars["Int"]>;
	higherCap_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	lowerCap?: InputMaybe<Scalars["Int"]>;
	lowerCap_GT?: InputMaybe<Scalars["Int"]>;
	lowerCap_GTE?: InputMaybe<Scalars["Int"]>;
	lowerCap_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	lowerCap_LT?: InputMaybe<Scalars["Int"]>;
	lowerCap_LTE?: InputMaybe<Scalars["Int"]>;
	lowerCap_NOT?: InputMaybe<Scalars["Int"]>;
	lowerCap_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
};

export type BaseAgreementConnectInput = {
	addedBy?: InputMaybe<BaseAgreementAddedByConnectFieldInput>;
	categories?: InputMaybe<Array<BaseAgreementCategoriesConnectFieldInput>>;
	counterparties?: InputMaybe<Array<BaseAgreementCounterpartiesConnectFieldInput>>;
	currency?: InputMaybe<BaseAgreementCurrencyConnectFieldInput>;
	dataContainers?: InputMaybe<Array<BaseAgreementDataContainersConnectFieldInput>>;
	dataSource?: InputMaybe<BaseAgreementDataSourceConnectFieldInput>;
	decisions?: InputMaybe<Array<BaseAgreementDecisionsConnectFieldInput>>;
	deviceAlternativeSets?: InputMaybe<Array<BaseAgreementDeviceAlternativeSetsConnectFieldInput>>;
	discountCapsCategories?: InputMaybe<Array<BaseAgreementDiscountCapsCategoriesConnectFieldInput>>;
	discountCapsDeviceKits?: InputMaybe<Array<BaseAgreementDiscountCapsDeviceKitsConnectFieldInput>>;
	eligibilityConditionSets?: InputMaybe<Array<BaseAgreementEligibilityConditionSetsConnectFieldInput>>;
	enrollingConditionSets?: InputMaybe<Array<BaseAgreementEnrollingConditionSetsConnectFieldInput>>;
	enrollingPeriods?: InputMaybe<Array<BaseAgreementEnrollingPeriodsConnectFieldInput>>;
	financialSummaryConfig?: InputMaybe<Array<BaseAgreementFinancialSummaryConfigConnectFieldInput>>;
	initialVersion?: InputMaybe<BaseAgreementInitialVersionConnectFieldInput>;
	namedTimeRanges?: InputMaybe<Array<BaseAgreementNamedTimeRangesConnectFieldInput>>;
	nextVersions?: InputMaybe<Array<BaseAgreementNextVersionsConnectFieldInput>>;
	processedDeviceRecords?: InputMaybe<Array<BaseAgreementProcessedDeviceRecordsConnectFieldInput>>;
	pushedBy?: InputMaybe<BaseAgreementPushedByConnectFieldInput>;
	scenarios?: InputMaybe<Array<BaseAgreementScenariosConnectFieldInput>>;
	statusTransitions?: InputMaybe<Array<BaseAgreementStatusTransitionsConnectFieldInput>>;
	tags?: InputMaybe<Array<BaseAgreementTagsConnectFieldInput>>;
	treatmentPrices?: InputMaybe<Array<BaseAgreementTreatmentPricesConnectFieldInput>>;
	userContexts?: InputMaybe<Array<BaseAgreementUserContextsConnectFieldInput>>;
	userRoles?: InputMaybe<Array<BaseAgreementUserRolesConnectFieldInput>>;
};

export type BaseAgreementConnectWhere = {
	node: BaseAgreementWhere;
};

export type BaseAgreementCounterpartiesAggregateInput = {
	AND?: InputMaybe<Array<BaseAgreementCounterpartiesAggregateInput>>;
	OR?: InputMaybe<Array<BaseAgreementCounterpartiesAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<BaseAgreementCounterpartiesNodeAggregationWhereInput>;
};

export type BaseAgreementCounterpartiesConnectFieldInput = {
	edge: BaseAgreementCounterpartyRelationshipCreateInput;
	where?: InputMaybe<OrganizationConnectWhere>;
};

export type BaseAgreementCounterpartiesConnection = {
	__typename?: "BaseAgreementCounterpartiesConnection";
	edges: Array<BaseAgreementCounterpartiesRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type BaseAgreementCounterpartiesConnectionSort = {
	edge?: InputMaybe<BaseAgreementCounterpartyRelationshipSort>;
	node?: InputMaybe<OrganizationSort>;
};

export type BaseAgreementCounterpartiesConnectionWhere = {
	AND?: InputMaybe<Array<BaseAgreementCounterpartiesConnectionWhere>>;
	OR?: InputMaybe<Array<BaseAgreementCounterpartiesConnectionWhere>>;
	edge?: InputMaybe<BaseAgreementCounterpartyRelationshipWhere>;
	edge_NOT?: InputMaybe<BaseAgreementCounterpartyRelationshipWhere>;
	node?: InputMaybe<OrganizationWhere>;
	node_NOT?: InputMaybe<OrganizationWhere>;
};

export type BaseAgreementCounterpartiesCreateFieldInput = {
	edge: BaseAgreementCounterpartyRelationshipCreateInput;
	node: OrganizationCreateInput;
};

export type BaseAgreementCounterpartiesDeleteFieldInput = {
	where?: InputMaybe<BaseAgreementCounterpartiesConnectionWhere>;
};

export type BaseAgreementCounterpartiesDisconnectFieldInput = {
	where?: InputMaybe<BaseAgreementCounterpartiesConnectionWhere>;
};

export type BaseAgreementCounterpartiesFieldInput = {
	connect?: InputMaybe<Array<BaseAgreementCounterpartiesConnectFieldInput>>;
	create?: InputMaybe<Array<BaseAgreementCounterpartiesCreateFieldInput>>;
};

export type BaseAgreementCounterpartiesNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<BaseAgreementCounterpartiesNodeAggregationWhereInput>>;
	IBAN_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	IBAN_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	IBAN_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	IBAN_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	IBAN_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	IBAN_EQUAL?: InputMaybe<Scalars["String"]>;
	IBAN_GT?: InputMaybe<Scalars["Int"]>;
	IBAN_GTE?: InputMaybe<Scalars["Int"]>;
	IBAN_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	IBAN_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	IBAN_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	IBAN_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	IBAN_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	IBAN_LT?: InputMaybe<Scalars["Int"]>;
	IBAN_LTE?: InputMaybe<Scalars["Int"]>;
	IBAN_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	IBAN_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	IBAN_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	IBAN_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	IBAN_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	OR?: InputMaybe<Array<BaseAgreementCounterpartiesNodeAggregationWhereInput>>;
	billingAddress_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	billingAddress_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	billingAddress_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	billingAddress_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	billingAddress_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	billingAddress_EQUAL?: InputMaybe<Scalars["String"]>;
	billingAddress_GT?: InputMaybe<Scalars["Int"]>;
	billingAddress_GTE?: InputMaybe<Scalars["Int"]>;
	billingAddress_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	billingAddress_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	billingAddress_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	billingAddress_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	billingAddress_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	billingAddress_LT?: InputMaybe<Scalars["Int"]>;
	billingAddress_LTE?: InputMaybe<Scalars["Int"]>;
	billingAddress_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	billingAddress_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	billingAddress_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	billingAddress_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	billingAddress_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	contactEmail_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	contactEmail_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	contactEmail_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	contactEmail_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	contactEmail_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	contactEmail_EQUAL?: InputMaybe<Scalars["String"]>;
	contactEmail_GT?: InputMaybe<Scalars["Int"]>;
	contactEmail_GTE?: InputMaybe<Scalars["Int"]>;
	contactEmail_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	contactEmail_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	contactEmail_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	contactEmail_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	contactEmail_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	contactEmail_LT?: InputMaybe<Scalars["Int"]>;
	contactEmail_LTE?: InputMaybe<Scalars["Int"]>;
	contactEmail_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	contactEmail_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	contactEmail_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	contactEmail_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	contactEmail_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	contactFirstName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	contactFirstName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	contactFirstName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	contactFirstName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	contactFirstName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	contactFirstName_EQUAL?: InputMaybe<Scalars["String"]>;
	contactFirstName_GT?: InputMaybe<Scalars["Int"]>;
	contactFirstName_GTE?: InputMaybe<Scalars["Int"]>;
	contactFirstName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	contactFirstName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	contactFirstName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	contactFirstName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	contactFirstName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	contactFirstName_LT?: InputMaybe<Scalars["Int"]>;
	contactFirstName_LTE?: InputMaybe<Scalars["Int"]>;
	contactFirstName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	contactFirstName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	contactFirstName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	contactFirstName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	contactFirstName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	contactLastName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	contactLastName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	contactLastName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	contactLastName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	contactLastName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	contactLastName_EQUAL?: InputMaybe<Scalars["String"]>;
	contactLastName_GT?: InputMaybe<Scalars["Int"]>;
	contactLastName_GTE?: InputMaybe<Scalars["Int"]>;
	contactLastName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	contactLastName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	contactLastName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	contactLastName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	contactLastName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	contactLastName_LT?: InputMaybe<Scalars["Int"]>;
	contactLastName_LTE?: InputMaybe<Scalars["Int"]>;
	contactLastName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	contactLastName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	contactLastName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	contactLastName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	contactLastName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	contactOccupation_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	contactOccupation_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	contactOccupation_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	contactOccupation_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	contactOccupation_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	contactOccupation_EQUAL?: InputMaybe<Scalars["String"]>;
	contactOccupation_GT?: InputMaybe<Scalars["Int"]>;
	contactOccupation_GTE?: InputMaybe<Scalars["Int"]>;
	contactOccupation_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	contactOccupation_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	contactOccupation_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	contactOccupation_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	contactOccupation_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	contactOccupation_LT?: InputMaybe<Scalars["Int"]>;
	contactOccupation_LTE?: InputMaybe<Scalars["Int"]>;
	contactOccupation_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	contactOccupation_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	contactOccupation_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	contactOccupation_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	contactOccupation_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	contactPhone_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	contactPhone_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	contactPhone_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	contactPhone_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	contactPhone_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	contactPhone_EQUAL?: InputMaybe<Scalars["String"]>;
	contactPhone_GT?: InputMaybe<Scalars["Int"]>;
	contactPhone_GTE?: InputMaybe<Scalars["Int"]>;
	contactPhone_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	contactPhone_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	contactPhone_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	contactPhone_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	contactPhone_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	contactPhone_LT?: InputMaybe<Scalars["Int"]>;
	contactPhone_LTE?: InputMaybe<Scalars["Int"]>;
	contactPhone_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	contactPhone_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	contactPhone_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	contactPhone_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	contactPhone_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	domicile_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	domicile_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	domicile_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	domicile_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	domicile_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	domicile_EQUAL?: InputMaybe<Scalars["String"]>;
	domicile_GT?: InputMaybe<Scalars["Int"]>;
	domicile_GTE?: InputMaybe<Scalars["Int"]>;
	domicile_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	domicile_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	domicile_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	domicile_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	domicile_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	domicile_LT?: InputMaybe<Scalars["Int"]>;
	domicile_LTE?: InputMaybe<Scalars["Int"]>;
	domicile_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	domicile_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	domicile_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	domicile_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	domicile_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	eIN_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	eIN_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	eIN_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	eIN_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	eIN_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	eIN_EQUAL?: InputMaybe<Scalars["String"]>;
	eIN_GT?: InputMaybe<Scalars["Int"]>;
	eIN_GTE?: InputMaybe<Scalars["Int"]>;
	eIN_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	eIN_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	eIN_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	eIN_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	eIN_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	eIN_LT?: InputMaybe<Scalars["Int"]>;
	eIN_LTE?: InputMaybe<Scalars["Int"]>;
	eIN_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	eIN_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	eIN_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	eIN_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	eIN_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	fax_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	fax_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	fax_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	fax_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	fax_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	fax_EQUAL?: InputMaybe<Scalars["String"]>;
	fax_GT?: InputMaybe<Scalars["Int"]>;
	fax_GTE?: InputMaybe<Scalars["Int"]>;
	fax_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	fax_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	fax_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	fax_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	fax_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	fax_LT?: InputMaybe<Scalars["Int"]>;
	fax_LTE?: InputMaybe<Scalars["Int"]>;
	fax_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	fax_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	fax_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	fax_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	fax_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	legalName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	legalName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	legalName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	legalName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	legalName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	legalName_EQUAL?: InputMaybe<Scalars["String"]>;
	legalName_GT?: InputMaybe<Scalars["Int"]>;
	legalName_GTE?: InputMaybe<Scalars["Int"]>;
	legalName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	legalName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	legalName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	legalName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	legalName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	legalName_LT?: InputMaybe<Scalars["Int"]>;
	legalName_LTE?: InputMaybe<Scalars["Int"]>;
	legalName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	legalName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	legalName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	legalName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	legalName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	logo_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	logo_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	logo_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	logo_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	logo_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	logo_EQUAL?: InputMaybe<Scalars["String"]>;
	logo_GT?: InputMaybe<Scalars["Int"]>;
	logo_GTE?: InputMaybe<Scalars["Int"]>;
	logo_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	logo_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	logo_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	logo_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	logo_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	logo_LT?: InputMaybe<Scalars["Int"]>;
	logo_LTE?: InputMaybe<Scalars["Int"]>;
	logo_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	logo_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	logo_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	logo_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	logo_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	name_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	name_EQUAL?: InputMaybe<Scalars["String"]>;
	name_GT?: InputMaybe<Scalars["Int"]>;
	name_GTE?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	name_LT?: InputMaybe<Scalars["Int"]>;
	name_LTE?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	phone_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	phone_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	phone_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	phone_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	phone_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	phone_EQUAL?: InputMaybe<Scalars["String"]>;
	phone_GT?: InputMaybe<Scalars["Int"]>;
	phone_GTE?: InputMaybe<Scalars["Int"]>;
	phone_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	phone_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	phone_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	phone_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	phone_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	phone_LT?: InputMaybe<Scalars["Int"]>;
	phone_LTE?: InputMaybe<Scalars["Int"]>;
	phone_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	phone_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	phone_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	phone_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	phone_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	tenantId_EQUAL?: InputMaybe<Scalars["String"]>;
	tenantId_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	website_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	website_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	website_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	website_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	website_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	website_EQUAL?: InputMaybe<Scalars["String"]>;
	website_GT?: InputMaybe<Scalars["Int"]>;
	website_GTE?: InputMaybe<Scalars["Int"]>;
	website_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	website_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	website_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	website_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	website_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	website_LT?: InputMaybe<Scalars["Int"]>;
	website_LTE?: InputMaybe<Scalars["Int"]>;
	website_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	website_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	website_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	website_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	website_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type BaseAgreementCounterpartiesRelationship = BaseAgreementCounterpartyRelationship & {
	__typename?: "BaseAgreementCounterpartiesRelationship";
	cursor: Scalars["String"];
	isApprovalRequired?: Maybe<Scalars["Boolean"]>;
	node: Organization;
	role: CounterpartyRole;
};

export type BaseAgreementCounterpartiesUpdateConnectionInput = {
	edge?: InputMaybe<BaseAgreementCounterpartyRelationshipUpdateInput>;
	node?: InputMaybe<OrganizationUpdateInput>;
};

export type BaseAgreementCounterpartiesUpdateFieldInput = {
	connect?: InputMaybe<Array<BaseAgreementCounterpartiesConnectFieldInput>>;
	create?: InputMaybe<Array<BaseAgreementCounterpartiesCreateFieldInput>>;
	delete?: InputMaybe<Array<BaseAgreementCounterpartiesDeleteFieldInput>>;
	disconnect?: InputMaybe<Array<BaseAgreementCounterpartiesDisconnectFieldInput>>;
	update?: InputMaybe<BaseAgreementCounterpartiesUpdateConnectionInput>;
	where?: InputMaybe<BaseAgreementCounterpartiesConnectionWhere>;
};

export type BaseAgreementCounterpartyRelationship = {
	isApprovalRequired?: Maybe<Scalars["Boolean"]>;
	role: CounterpartyRole;
};

export type BaseAgreementCounterpartyRelationshipCreateInput = {
	isApprovalRequired?: InputMaybe<Scalars["Boolean"]>;
	role: CounterpartyRole;
};

export type BaseAgreementCounterpartyRelationshipSort = {
	isApprovalRequired?: InputMaybe<SortDirection>;
	role?: InputMaybe<SortDirection>;
};

export type BaseAgreementCounterpartyRelationshipUpdateInput = {
	isApprovalRequired?: InputMaybe<Scalars["Boolean"]>;
	role?: InputMaybe<CounterpartyRole>;
};

export type BaseAgreementCounterpartyRelationshipWhere = {
	AND?: InputMaybe<Array<BaseAgreementCounterpartyRelationshipWhere>>;
	OR?: InputMaybe<Array<BaseAgreementCounterpartyRelationshipWhere>>;
	isApprovalRequired?: InputMaybe<Scalars["Boolean"]>;
	isApprovalRequired_NOT?: InputMaybe<Scalars["Boolean"]>;
	role?: InputMaybe<CounterpartyRole>;
	role_IN?: InputMaybe<Array<InputMaybe<CounterpartyRole>>>;
	role_NOT?: InputMaybe<CounterpartyRole>;
	role_NOT_IN?: InputMaybe<Array<InputMaybe<CounterpartyRole>>>;
};

export type BaseAgreementCreateInput = {
	addedBy?: InputMaybe<BaseAgreementAddedByFieldInput>;
	allowedForms?: InputMaybe<Array<FormType>>;
	allowedRecords?: InputMaybe<Array<RecordType>>;
	categories?: InputMaybe<BaseAgreementCategoriesFieldInput>;
	counterparties?: InputMaybe<BaseAgreementCounterpartiesFieldInput>;
	coveringFormWaitInterval?: InputMaybe<Scalars["Int"]>;
	createdOn: Scalars["DateTime"];
	currency?: InputMaybe<BaseAgreementCurrencyFieldInput>;
	dataContainers?: InputMaybe<BaseAgreementDataContainersFieldInput>;
	dataSource?: InputMaybe<BaseAgreementDataSourceFieldInput>;
	decisions?: InputMaybe<BaseAgreementDecisionsFieldInput>;
	deviceAlternativeSets?: InputMaybe<BaseAgreementDeviceAlternativeSetsFieldInput>;
	discountCapsCategories?: InputMaybe<BaseAgreementDiscountCapsCategoriesFieldInput>;
	discountCapsDeviceKits?: InputMaybe<BaseAgreementDiscountCapsDeviceKitsFieldInput>;
	eligibilityConditionSets?: InputMaybe<BaseAgreementEligibilityConditionSetsFieldInput>;
	enrollingConditionSets?: InputMaybe<BaseAgreementEnrollingConditionSetsFieldInput>;
	enrollingPeriods?: InputMaybe<BaseAgreementEnrollingPeriodsFieldInput>;
	financialSummaryConfig?: InputMaybe<BaseAgreementFinancialSummaryConfigFieldInput>;
	firstExecutionDate?: InputMaybe<Scalars["DateTime"]>;
	formattedAmount?: InputMaybe<Scalars["String"]>;
	formattedCounterparties?: InputMaybe<Scalars["String"]>;
	formattedProducts?: InputMaybe<Scalars["String"]>;
	formattedTags: Scalars["String"];
	formattedValidityPeriod?: InputMaybe<Scalars["String"]>;
	id: Scalars["ID"];
	initialVersion?: InputMaybe<BaseAgreementInitialVersionFieldInput>;
	initialVersionId: Scalars["String"];
	isAllowedFormsEnabled: Scalars["Boolean"];
	isAllowedRecordsEnabled: Scalars["Boolean"];
	isCoveringIntervalEnabled: Scalars["Boolean"];
	isDeleted: Scalars["Boolean"];
	isExtended?: InputMaybe<Scalars["Boolean"]>;
	isFirstVersion: Scalars["Boolean"];
	isHidden: Scalars["Boolean"];
	isInsightsAvailable?: InputMaybe<Scalars["Boolean"]>;
	isLastVersion: Scalars["Boolean"];
	isRatingEnabled?: InputMaybe<Scalars["Boolean"]>;
	isRequiredFormsEnabled: Scalars["Boolean"];
	isRequiredRecordsEnabled: Scalars["Boolean"];
	isTherapyDecisionEnabled?: InputMaybe<Scalars["Boolean"]>;
	lastExecutionDate?: InputMaybe<Scalars["DateTime"]>;
	name: Scalars["String"];
	namedTimeRanges?: InputMaybe<BaseAgreementNamedTimeRangesFieldInput>;
	nextVersions?: InputMaybe<BaseAgreementNextVersionsFieldInput>;
	processedDeviceRecords?: InputMaybe<BaseAgreementProcessedDeviceRecordsFieldInput>;
	pushedBy?: InputMaybe<BaseAgreementPushedByFieldInput>;
	pushedOn?: InputMaybe<Scalars["DateTime"]>;
	rating?: InputMaybe<Array<CoverageRequestRating>>;
	requiredForms?: InputMaybe<Array<FormType>>;
	requiredRecords?: InputMaybe<Array<RecordType>>;
	scenarios?: InputMaybe<BaseAgreementScenariosFieldInput>;
	status: ContractStatus;
	statusTransitions?: InputMaybe<BaseAgreementStatusTransitionsFieldInput>;
	subjectMatter: AgreementSubjectMatter;
	tags?: InputMaybe<BaseAgreementTagsFieldInput>;
	tenantIds?: InputMaybe<Array<Scalars["String"]>>;
	therapyDecision?: InputMaybe<Array<CoverageRequestTherapyDecision>>;
	treatmentPrices?: InputMaybe<BaseAgreementTreatmentPricesFieldInput>;
	userContexts?: InputMaybe<BaseAgreementUserContextsFieldInput>;
	userRoles?: InputMaybe<BaseAgreementUserRolesFieldInput>;
	validFromDate: Scalars["Date"];
	validToDate?: InputMaybe<Scalars["Date"]>;
	version: Scalars["Int"];
};

export type BaseAgreementCurrencyAggregateInput = {
	AND?: InputMaybe<Array<BaseAgreementCurrencyAggregateInput>>;
	OR?: InputMaybe<Array<BaseAgreementCurrencyAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<BaseAgreementCurrencyNodeAggregationWhereInput>;
};

export type BaseAgreementCurrencyConnectFieldInput = {
	where?: InputMaybe<CurrencyConnectWhere>;
};

export type BaseAgreementCurrencyConnection = {
	__typename?: "BaseAgreementCurrencyConnection";
	edges: Array<BaseAgreementCurrencyRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type BaseAgreementCurrencyConnectionSort = {
	node?: InputMaybe<CurrencySort>;
};

export type BaseAgreementCurrencyConnectionWhere = {
	AND?: InputMaybe<Array<BaseAgreementCurrencyConnectionWhere>>;
	OR?: InputMaybe<Array<BaseAgreementCurrencyConnectionWhere>>;
	node?: InputMaybe<CurrencyWhere>;
	node_NOT?: InputMaybe<CurrencyWhere>;
};

export type BaseAgreementCurrencyCreateFieldInput = {
	node: CurrencyCreateInput;
};

export type BaseAgreementCurrencyDeleteFieldInput = {
	where?: InputMaybe<BaseAgreementCurrencyConnectionWhere>;
};

export type BaseAgreementCurrencyDisconnectFieldInput = {
	where?: InputMaybe<BaseAgreementCurrencyConnectionWhere>;
};

export type BaseAgreementCurrencyFieldInput = {
	connect?: InputMaybe<BaseAgreementCurrencyConnectFieldInput>;
	create?: InputMaybe<BaseAgreementCurrencyCreateFieldInput>;
};

export type BaseAgreementCurrencyNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<BaseAgreementCurrencyNodeAggregationWhereInput>>;
	Code_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	Code_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	Code_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	Code_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	Code_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	Code_EQUAL?: InputMaybe<Scalars["String"]>;
	Code_GT?: InputMaybe<Scalars["Int"]>;
	Code_GTE?: InputMaybe<Scalars["Int"]>;
	Code_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Code_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	Code_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	Code_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	Code_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	Code_LT?: InputMaybe<Scalars["Int"]>;
	Code_LTE?: InputMaybe<Scalars["Int"]>;
	Code_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Code_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	Code_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	Code_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	Code_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	Name_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	Name_EQUAL?: InputMaybe<Scalars["String"]>;
	Name_GT?: InputMaybe<Scalars["Int"]>;
	Name_GTE?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	Name_LT?: InputMaybe<Scalars["Int"]>;
	Name_LTE?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	OR?: InputMaybe<Array<BaseAgreementCurrencyNodeAggregationWhereInput>>;
	symbol_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	symbol_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	symbol_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	symbol_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	symbol_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	symbol_EQUAL?: InputMaybe<Scalars["String"]>;
	symbol_GT?: InputMaybe<Scalars["Int"]>;
	symbol_GTE?: InputMaybe<Scalars["Int"]>;
	symbol_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	symbol_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	symbol_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	symbol_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	symbol_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	symbol_LT?: InputMaybe<Scalars["Int"]>;
	symbol_LTE?: InputMaybe<Scalars["Int"]>;
	symbol_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	symbol_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	symbol_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	symbol_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	symbol_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type BaseAgreementCurrencyRelationship = {
	__typename?: "BaseAgreementCurrencyRelationship";
	cursor: Scalars["String"];
	node: Currency;
};

export type BaseAgreementCurrencyUpdateConnectionInput = {
	node?: InputMaybe<CurrencyUpdateInput>;
};

export type BaseAgreementCurrencyUpdateFieldInput = {
	connect?: InputMaybe<BaseAgreementCurrencyConnectFieldInput>;
	create?: InputMaybe<BaseAgreementCurrencyCreateFieldInput>;
	delete?: InputMaybe<BaseAgreementCurrencyDeleteFieldInput>;
	disconnect?: InputMaybe<BaseAgreementCurrencyDisconnectFieldInput>;
	update?: InputMaybe<BaseAgreementCurrencyUpdateConnectionInput>;
	where?: InputMaybe<BaseAgreementCurrencyConnectionWhere>;
};

export type BaseAgreementDataContainersAggregateInput = {
	AND?: InputMaybe<Array<BaseAgreementDataContainersAggregateInput>>;
	OR?: InputMaybe<Array<BaseAgreementDataContainersAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<BaseAgreementDataContainersNodeAggregationWhereInput>;
};

export type BaseAgreementDataContainersConnectFieldInput = {
	connect?: InputMaybe<Array<DataContainerConnectInput>>;
	where?: InputMaybe<DataContainerConnectWhere>;
};

export type BaseAgreementDataContainersConnection = {
	__typename?: "BaseAgreementDataContainersConnection";
	edges: Array<BaseAgreementDataContainersRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type BaseAgreementDataContainersConnectionSort = {
	node?: InputMaybe<DataContainerSort>;
};

export type BaseAgreementDataContainersConnectionWhere = {
	AND?: InputMaybe<Array<BaseAgreementDataContainersConnectionWhere>>;
	OR?: InputMaybe<Array<BaseAgreementDataContainersConnectionWhere>>;
	node?: InputMaybe<DataContainerWhere>;
	node_NOT?: InputMaybe<DataContainerWhere>;
};

export type BaseAgreementDataContainersCreateFieldInput = {
	node: DataContainerCreateInput;
};

export type BaseAgreementDataContainersDeleteFieldInput = {
	delete?: InputMaybe<DataContainerDeleteInput>;
	where?: InputMaybe<BaseAgreementDataContainersConnectionWhere>;
};

export type BaseAgreementDataContainersDisconnectFieldInput = {
	disconnect?: InputMaybe<DataContainerDisconnectInput>;
	where?: InputMaybe<BaseAgreementDataContainersConnectionWhere>;
};

export type BaseAgreementDataContainersFieldInput = {
	connect?: InputMaybe<Array<BaseAgreementDataContainersConnectFieldInput>>;
	create?: InputMaybe<Array<BaseAgreementDataContainersCreateFieldInput>>;
};

export type BaseAgreementDataContainersNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<BaseAgreementDataContainersNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<BaseAgreementDataContainersNodeAggregationWhereInput>>;
	timeframeEnd_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	timeframeEnd_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	timeframeEnd_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	timeframeEnd_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	timeframeEnd_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	timeframeEnd_EQUAL?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_GT?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_GTE?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_LT?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_LTE?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_MAX_GT?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_MAX_LT?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_MIN_GT?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_MIN_LT?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	timeframeStart_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	timeframeStart_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	timeframeStart_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	timeframeStart_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	timeframeStart_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	timeframeStart_EQUAL?: InputMaybe<Scalars["Int"]>;
	timeframeStart_GT?: InputMaybe<Scalars["Int"]>;
	timeframeStart_GTE?: InputMaybe<Scalars["Int"]>;
	timeframeStart_LT?: InputMaybe<Scalars["Int"]>;
	timeframeStart_LTE?: InputMaybe<Scalars["Int"]>;
	timeframeStart_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	timeframeStart_MAX_GT?: InputMaybe<Scalars["Int"]>;
	timeframeStart_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	timeframeStart_MAX_LT?: InputMaybe<Scalars["Int"]>;
	timeframeStart_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	timeframeStart_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	timeframeStart_MIN_GT?: InputMaybe<Scalars["Int"]>;
	timeframeStart_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	timeframeStart_MIN_LT?: InputMaybe<Scalars["Int"]>;
	timeframeStart_MIN_LTE?: InputMaybe<Scalars["Int"]>;
};

export type BaseAgreementDataContainersRelationship = {
	__typename?: "BaseAgreementDataContainersRelationship";
	cursor: Scalars["String"];
	node: DataContainer;
};

export type BaseAgreementDataContainersUpdateConnectionInput = {
	node?: InputMaybe<DataContainerUpdateInput>;
};

export type BaseAgreementDataContainersUpdateFieldInput = {
	connect?: InputMaybe<Array<BaseAgreementDataContainersConnectFieldInput>>;
	create?: InputMaybe<Array<BaseAgreementDataContainersCreateFieldInput>>;
	delete?: InputMaybe<Array<BaseAgreementDataContainersDeleteFieldInput>>;
	disconnect?: InputMaybe<Array<BaseAgreementDataContainersDisconnectFieldInput>>;
	update?: InputMaybe<BaseAgreementDataContainersUpdateConnectionInput>;
	where?: InputMaybe<BaseAgreementDataContainersConnectionWhere>;
};

export type BaseAgreementDataSourceAggregateInput = {
	AND?: InputMaybe<Array<BaseAgreementDataSourceAggregateInput>>;
	OR?: InputMaybe<Array<BaseAgreementDataSourceAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<BaseAgreementDataSourceNodeAggregationWhereInput>;
};

export type BaseAgreementDataSourceConnectFieldInput = {
	where?: InputMaybe<DataSourceConnectWhere>;
};

export type BaseAgreementDataSourceConnection = {
	__typename?: "BaseAgreementDataSourceConnection";
	edges: Array<BaseAgreementDataSourceRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type BaseAgreementDataSourceConnectionSort = {
	node?: InputMaybe<DataSourceSort>;
};

export type BaseAgreementDataSourceConnectionWhere = {
	AND?: InputMaybe<Array<BaseAgreementDataSourceConnectionWhere>>;
	OR?: InputMaybe<Array<BaseAgreementDataSourceConnectionWhere>>;
	node?: InputMaybe<DataSourceWhere>;
	node_NOT?: InputMaybe<DataSourceWhere>;
};

export type BaseAgreementDataSourceCreateFieldInput = {
	node: DataSourceCreateInput;
};

export type BaseAgreementDataSourceDeleteFieldInput = {
	where?: InputMaybe<BaseAgreementDataSourceConnectionWhere>;
};

export type BaseAgreementDataSourceDisconnectFieldInput = {
	where?: InputMaybe<BaseAgreementDataSourceConnectionWhere>;
};

export type BaseAgreementDataSourceFieldInput = {
	connect?: InputMaybe<BaseAgreementDataSourceConnectFieldInput>;
	create?: InputMaybe<BaseAgreementDataSourceCreateFieldInput>;
};

export type BaseAgreementDataSourceNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<BaseAgreementDataSourceNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<BaseAgreementDataSourceNodeAggregationWhereInput>>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	name_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	name_EQUAL?: InputMaybe<Scalars["String"]>;
	name_GT?: InputMaybe<Scalars["Int"]>;
	name_GTE?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	name_LT?: InputMaybe<Scalars["Int"]>;
	name_LTE?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type BaseAgreementDataSourceRelationship = {
	__typename?: "BaseAgreementDataSourceRelationship";
	cursor: Scalars["String"];
	node: DataSource;
};

export type BaseAgreementDataSourceUpdateConnectionInput = {
	node?: InputMaybe<DataSourceUpdateInput>;
};

export type BaseAgreementDataSourceUpdateFieldInput = {
	connect?: InputMaybe<BaseAgreementDataSourceConnectFieldInput>;
	create?: InputMaybe<BaseAgreementDataSourceCreateFieldInput>;
	delete?: InputMaybe<BaseAgreementDataSourceDeleteFieldInput>;
	disconnect?: InputMaybe<BaseAgreementDataSourceDisconnectFieldInput>;
	update?: InputMaybe<BaseAgreementDataSourceUpdateConnectionInput>;
	where?: InputMaybe<BaseAgreementDataSourceConnectionWhere>;
};

export type BaseAgreementDecisionsAggregateInput = {
	AND?: InputMaybe<Array<BaseAgreementDecisionsAggregateInput>>;
	OR?: InputMaybe<Array<BaseAgreementDecisionsAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<BaseAgreementDecisionsNodeAggregationWhereInput>;
};

export type BaseAgreementDecisionsConnectFieldInput = {
	connect?: InputMaybe<Array<AgreementDecisionConnectInput>>;
	where?: InputMaybe<AgreementDecisionConnectWhere>;
};

export type BaseAgreementDecisionsConnection = {
	__typename?: "BaseAgreementDecisionsConnection";
	edges: Array<BaseAgreementDecisionsRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type BaseAgreementDecisionsConnectionSort = {
	node?: InputMaybe<AgreementDecisionSort>;
};

export type BaseAgreementDecisionsConnectionWhere = {
	AND?: InputMaybe<Array<BaseAgreementDecisionsConnectionWhere>>;
	OR?: InputMaybe<Array<BaseAgreementDecisionsConnectionWhere>>;
	node?: InputMaybe<AgreementDecisionWhere>;
	node_NOT?: InputMaybe<AgreementDecisionWhere>;
};

export type BaseAgreementDecisionsCreateFieldInput = {
	node: AgreementDecisionCreateInput;
};

export type BaseAgreementDecisionsDeleteFieldInput = {
	delete?: InputMaybe<AgreementDecisionDeleteInput>;
	where?: InputMaybe<BaseAgreementDecisionsConnectionWhere>;
};

export type BaseAgreementDecisionsDisconnectFieldInput = {
	disconnect?: InputMaybe<AgreementDecisionDisconnectInput>;
	where?: InputMaybe<BaseAgreementDecisionsConnectionWhere>;
};

export type BaseAgreementDecisionsFieldInput = {
	connect?: InputMaybe<Array<BaseAgreementDecisionsConnectFieldInput>>;
	create?: InputMaybe<Array<BaseAgreementDecisionsCreateFieldInput>>;
};

export type BaseAgreementDecisionsNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<BaseAgreementDecisionsNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<BaseAgreementDecisionsNodeAggregationWhereInput>>;
	createdOn_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
};

export type BaseAgreementDecisionsRelationship = {
	__typename?: "BaseAgreementDecisionsRelationship";
	cursor: Scalars["String"];
	node: AgreementDecision;
};

export type BaseAgreementDecisionsUpdateConnectionInput = {
	node?: InputMaybe<AgreementDecisionUpdateInput>;
};

export type BaseAgreementDecisionsUpdateFieldInput = {
	connect?: InputMaybe<Array<BaseAgreementDecisionsConnectFieldInput>>;
	create?: InputMaybe<Array<BaseAgreementDecisionsCreateFieldInput>>;
	delete?: InputMaybe<Array<BaseAgreementDecisionsDeleteFieldInput>>;
	disconnect?: InputMaybe<Array<BaseAgreementDecisionsDisconnectFieldInput>>;
	update?: InputMaybe<BaseAgreementDecisionsUpdateConnectionInput>;
	where?: InputMaybe<BaseAgreementDecisionsConnectionWhere>;
};

export type BaseAgreementDeleteInput = {
	addedBy?: InputMaybe<BaseAgreementAddedByDeleteFieldInput>;
	categories?: InputMaybe<Array<BaseAgreementCategoriesDeleteFieldInput>>;
	counterparties?: InputMaybe<Array<BaseAgreementCounterpartiesDeleteFieldInput>>;
	currency?: InputMaybe<BaseAgreementCurrencyDeleteFieldInput>;
	dataContainers?: InputMaybe<Array<BaseAgreementDataContainersDeleteFieldInput>>;
	dataSource?: InputMaybe<BaseAgreementDataSourceDeleteFieldInput>;
	decisions?: InputMaybe<Array<BaseAgreementDecisionsDeleteFieldInput>>;
	deviceAlternativeSets?: InputMaybe<Array<BaseAgreementDeviceAlternativeSetsDeleteFieldInput>>;
	discountCapsCategories?: InputMaybe<Array<BaseAgreementDiscountCapsCategoriesDeleteFieldInput>>;
	discountCapsDeviceKits?: InputMaybe<Array<BaseAgreementDiscountCapsDeviceKitsDeleteFieldInput>>;
	eligibilityConditionSets?: InputMaybe<Array<BaseAgreementEligibilityConditionSetsDeleteFieldInput>>;
	enrollingConditionSets?: InputMaybe<Array<BaseAgreementEnrollingConditionSetsDeleteFieldInput>>;
	enrollingPeriods?: InputMaybe<Array<BaseAgreementEnrollingPeriodsDeleteFieldInput>>;
	financialSummaryConfig?: InputMaybe<Array<BaseAgreementFinancialSummaryConfigDeleteFieldInput>>;
	initialVersion?: InputMaybe<BaseAgreementInitialVersionDeleteFieldInput>;
	namedTimeRanges?: InputMaybe<Array<BaseAgreementNamedTimeRangesDeleteFieldInput>>;
	nextVersions?: InputMaybe<Array<BaseAgreementNextVersionsDeleteFieldInput>>;
	processedDeviceRecords?: InputMaybe<Array<BaseAgreementProcessedDeviceRecordsDeleteFieldInput>>;
	pushedBy?: InputMaybe<BaseAgreementPushedByDeleteFieldInput>;
	scenarios?: InputMaybe<Array<BaseAgreementScenariosDeleteFieldInput>>;
	statusTransitions?: InputMaybe<Array<BaseAgreementStatusTransitionsDeleteFieldInput>>;
	tags?: InputMaybe<Array<BaseAgreementTagsDeleteFieldInput>>;
	treatmentPrices?: InputMaybe<Array<BaseAgreementTreatmentPricesDeleteFieldInput>>;
	userContexts?: InputMaybe<Array<BaseAgreementUserContextsDeleteFieldInput>>;
	userRoles?: InputMaybe<Array<BaseAgreementUserRolesDeleteFieldInput>>;
};

export type BaseAgreementDeviceAlternativeSetsAggregateInput = {
	AND?: InputMaybe<Array<BaseAgreementDeviceAlternativeSetsAggregateInput>>;
	OR?: InputMaybe<Array<BaseAgreementDeviceAlternativeSetsAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<BaseAgreementDeviceAlternativeSetsNodeAggregationWhereInput>;
};

export type BaseAgreementDeviceAlternativeSetsConnectFieldInput = {
	connect?: InputMaybe<Array<DeviceAlternativeConnectInput>>;
	where?: InputMaybe<DeviceAlternativeConnectWhere>;
};

export type BaseAgreementDeviceAlternativeSetsConnection = {
	__typename?: "BaseAgreementDeviceAlternativeSetsConnection";
	edges: Array<BaseAgreementDeviceAlternativeSetsRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type BaseAgreementDeviceAlternativeSetsConnectionSort = {
	node?: InputMaybe<DeviceAlternativeSort>;
};

export type BaseAgreementDeviceAlternativeSetsConnectionWhere = {
	AND?: InputMaybe<Array<BaseAgreementDeviceAlternativeSetsConnectionWhere>>;
	OR?: InputMaybe<Array<BaseAgreementDeviceAlternativeSetsConnectionWhere>>;
	node?: InputMaybe<DeviceAlternativeWhere>;
	node_NOT?: InputMaybe<DeviceAlternativeWhere>;
};

export type BaseAgreementDeviceAlternativeSetsCreateFieldInput = {
	node: DeviceAlternativeCreateInput;
};

export type BaseAgreementDeviceAlternativeSetsDeleteFieldInput = {
	delete?: InputMaybe<DeviceAlternativeDeleteInput>;
	where?: InputMaybe<BaseAgreementDeviceAlternativeSetsConnectionWhere>;
};

export type BaseAgreementDeviceAlternativeSetsDisconnectFieldInput = {
	disconnect?: InputMaybe<DeviceAlternativeDisconnectInput>;
	where?: InputMaybe<BaseAgreementDeviceAlternativeSetsConnectionWhere>;
};

export type BaseAgreementDeviceAlternativeSetsFieldInput = {
	connect?: InputMaybe<Array<BaseAgreementDeviceAlternativeSetsConnectFieldInput>>;
	create?: InputMaybe<Array<BaseAgreementDeviceAlternativeSetsCreateFieldInput>>;
};

export type BaseAgreementDeviceAlternativeSetsNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<BaseAgreementDeviceAlternativeSetsNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<BaseAgreementDeviceAlternativeSetsNodeAggregationWhereInput>>;
	code_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	code_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	code_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	code_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	code_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	code_EQUAL?: InputMaybe<Scalars["String"]>;
	code_GT?: InputMaybe<Scalars["Int"]>;
	code_GTE?: InputMaybe<Scalars["Int"]>;
	code_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	code_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	code_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	code_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	code_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	code_LT?: InputMaybe<Scalars["Int"]>;
	code_LTE?: InputMaybe<Scalars["Int"]>;
	code_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	code_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	code_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	code_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	code_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type BaseAgreementDeviceAlternativeSetsRelationship = {
	__typename?: "BaseAgreementDeviceAlternativeSetsRelationship";
	cursor: Scalars["String"];
	node: DeviceAlternative;
};

export type BaseAgreementDeviceAlternativeSetsUpdateConnectionInput = {
	node?: InputMaybe<DeviceAlternativeUpdateInput>;
};

export type BaseAgreementDeviceAlternativeSetsUpdateFieldInput = {
	connect?: InputMaybe<Array<BaseAgreementDeviceAlternativeSetsConnectFieldInput>>;
	create?: InputMaybe<Array<BaseAgreementDeviceAlternativeSetsCreateFieldInput>>;
	delete?: InputMaybe<Array<BaseAgreementDeviceAlternativeSetsDeleteFieldInput>>;
	disconnect?: InputMaybe<Array<BaseAgreementDeviceAlternativeSetsDisconnectFieldInput>>;
	update?: InputMaybe<BaseAgreementDeviceAlternativeSetsUpdateConnectionInput>;
	where?: InputMaybe<BaseAgreementDeviceAlternativeSetsConnectionWhere>;
};

export type BaseAgreementDeviceKitDiscountCaps = {
	higherCap?: Maybe<Scalars["Int"]>;
	lowerCap?: Maybe<Scalars["Int"]>;
};

export type BaseAgreementDeviceKitDiscountCapsCreateInput = {
	higherCap?: InputMaybe<Scalars["Int"]>;
	lowerCap?: InputMaybe<Scalars["Int"]>;
};

export type BaseAgreementDeviceKitDiscountCapsSort = {
	higherCap?: InputMaybe<SortDirection>;
	lowerCap?: InputMaybe<SortDirection>;
};

export type BaseAgreementDeviceKitDiscountCapsUpdateInput = {
	higherCap?: InputMaybe<Scalars["Int"]>;
	lowerCap?: InputMaybe<Scalars["Int"]>;
};

export type BaseAgreementDeviceKitDiscountCapsWhere = {
	AND?: InputMaybe<Array<BaseAgreementDeviceKitDiscountCapsWhere>>;
	OR?: InputMaybe<Array<BaseAgreementDeviceKitDiscountCapsWhere>>;
	higherCap?: InputMaybe<Scalars["Int"]>;
	higherCap_GT?: InputMaybe<Scalars["Int"]>;
	higherCap_GTE?: InputMaybe<Scalars["Int"]>;
	higherCap_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	higherCap_LT?: InputMaybe<Scalars["Int"]>;
	higherCap_LTE?: InputMaybe<Scalars["Int"]>;
	higherCap_NOT?: InputMaybe<Scalars["Int"]>;
	higherCap_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	lowerCap?: InputMaybe<Scalars["Int"]>;
	lowerCap_GT?: InputMaybe<Scalars["Int"]>;
	lowerCap_GTE?: InputMaybe<Scalars["Int"]>;
	lowerCap_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	lowerCap_LT?: InputMaybe<Scalars["Int"]>;
	lowerCap_LTE?: InputMaybe<Scalars["Int"]>;
	lowerCap_NOT?: InputMaybe<Scalars["Int"]>;
	lowerCap_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
};

export type BaseAgreementDisconnectInput = {
	addedBy?: InputMaybe<BaseAgreementAddedByDisconnectFieldInput>;
	categories?: InputMaybe<Array<BaseAgreementCategoriesDisconnectFieldInput>>;
	counterparties?: InputMaybe<Array<BaseAgreementCounterpartiesDisconnectFieldInput>>;
	currency?: InputMaybe<BaseAgreementCurrencyDisconnectFieldInput>;
	dataContainers?: InputMaybe<Array<BaseAgreementDataContainersDisconnectFieldInput>>;
	dataSource?: InputMaybe<BaseAgreementDataSourceDisconnectFieldInput>;
	decisions?: InputMaybe<Array<BaseAgreementDecisionsDisconnectFieldInput>>;
	deviceAlternativeSets?: InputMaybe<Array<BaseAgreementDeviceAlternativeSetsDisconnectFieldInput>>;
	discountCapsCategories?: InputMaybe<Array<BaseAgreementDiscountCapsCategoriesDisconnectFieldInput>>;
	discountCapsDeviceKits?: InputMaybe<Array<BaseAgreementDiscountCapsDeviceKitsDisconnectFieldInput>>;
	eligibilityConditionSets?: InputMaybe<Array<BaseAgreementEligibilityConditionSetsDisconnectFieldInput>>;
	enrollingConditionSets?: InputMaybe<Array<BaseAgreementEnrollingConditionSetsDisconnectFieldInput>>;
	enrollingPeriods?: InputMaybe<Array<BaseAgreementEnrollingPeriodsDisconnectFieldInput>>;
	financialSummaryConfig?: InputMaybe<Array<BaseAgreementFinancialSummaryConfigDisconnectFieldInput>>;
	initialVersion?: InputMaybe<BaseAgreementInitialVersionDisconnectFieldInput>;
	namedTimeRanges?: InputMaybe<Array<BaseAgreementNamedTimeRangesDisconnectFieldInput>>;
	nextVersions?: InputMaybe<Array<BaseAgreementNextVersionsDisconnectFieldInput>>;
	processedDeviceRecords?: InputMaybe<Array<BaseAgreementProcessedDeviceRecordsDisconnectFieldInput>>;
	pushedBy?: InputMaybe<BaseAgreementPushedByDisconnectFieldInput>;
	scenarios?: InputMaybe<Array<BaseAgreementScenariosDisconnectFieldInput>>;
	statusTransitions?: InputMaybe<Array<BaseAgreementStatusTransitionsDisconnectFieldInput>>;
	tags?: InputMaybe<Array<BaseAgreementTagsDisconnectFieldInput>>;
	treatmentPrices?: InputMaybe<Array<BaseAgreementTreatmentPricesDisconnectFieldInput>>;
	userContexts?: InputMaybe<Array<BaseAgreementUserContextsDisconnectFieldInput>>;
	userRoles?: InputMaybe<Array<BaseAgreementUserRolesDisconnectFieldInput>>;
};

export type BaseAgreementDiscountCapsCategoriesAggregateInput = {
	AND?: InputMaybe<Array<BaseAgreementDiscountCapsCategoriesAggregateInput>>;
	OR?: InputMaybe<Array<BaseAgreementDiscountCapsCategoriesAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	edge?: InputMaybe<BaseAgreementDiscountCapsCategoriesEdgeAggregationWhereInput>;
	node?: InputMaybe<BaseAgreementDiscountCapsCategoriesNodeAggregationWhereInput>;
};

export type BaseAgreementDiscountCapsCategoriesConnectFieldInput = {
	connect?: InputMaybe<Array<DeviceProductCategoryConnectInput>>;
	edge?: InputMaybe<BaseAgreementCategoryDiscountCapsCreateInput>;
	where?: InputMaybe<DeviceProductCategoryConnectWhere>;
};

export type BaseAgreementDiscountCapsCategoriesConnection = {
	__typename?: "BaseAgreementDiscountCapsCategoriesConnection";
	edges: Array<BaseAgreementDiscountCapsCategoriesRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type BaseAgreementDiscountCapsCategoriesConnectionSort = {
	edge?: InputMaybe<BaseAgreementCategoryDiscountCapsSort>;
	node?: InputMaybe<DeviceProductCategorySort>;
};

export type BaseAgreementDiscountCapsCategoriesConnectionWhere = {
	AND?: InputMaybe<Array<BaseAgreementDiscountCapsCategoriesConnectionWhere>>;
	OR?: InputMaybe<Array<BaseAgreementDiscountCapsCategoriesConnectionWhere>>;
	edge?: InputMaybe<BaseAgreementCategoryDiscountCapsWhere>;
	edge_NOT?: InputMaybe<BaseAgreementCategoryDiscountCapsWhere>;
	node?: InputMaybe<DeviceProductCategoryWhere>;
	node_NOT?: InputMaybe<DeviceProductCategoryWhere>;
};

export type BaseAgreementDiscountCapsCategoriesCreateFieldInput = {
	edge?: InputMaybe<BaseAgreementCategoryDiscountCapsCreateInput>;
	node: DeviceProductCategoryCreateInput;
};

export type BaseAgreementDiscountCapsCategoriesDeleteFieldInput = {
	delete?: InputMaybe<DeviceProductCategoryDeleteInput>;
	where?: InputMaybe<BaseAgreementDiscountCapsCategoriesConnectionWhere>;
};

export type BaseAgreementDiscountCapsCategoriesDisconnectFieldInput = {
	disconnect?: InputMaybe<DeviceProductCategoryDisconnectInput>;
	where?: InputMaybe<BaseAgreementDiscountCapsCategoriesConnectionWhere>;
};

export type BaseAgreementDiscountCapsCategoriesEdgeAggregationWhereInput = {
	AND?: InputMaybe<Array<BaseAgreementDiscountCapsCategoriesEdgeAggregationWhereInput>>;
	OR?: InputMaybe<Array<BaseAgreementDiscountCapsCategoriesEdgeAggregationWhereInput>>;
	higherCap_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	higherCap_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	higherCap_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	higherCap_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	higherCap_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	higherCap_EQUAL?: InputMaybe<Scalars["Int"]>;
	higherCap_GT?: InputMaybe<Scalars["Int"]>;
	higherCap_GTE?: InputMaybe<Scalars["Int"]>;
	higherCap_LT?: InputMaybe<Scalars["Int"]>;
	higherCap_LTE?: InputMaybe<Scalars["Int"]>;
	higherCap_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	higherCap_MAX_GT?: InputMaybe<Scalars["Int"]>;
	higherCap_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	higherCap_MAX_LT?: InputMaybe<Scalars["Int"]>;
	higherCap_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	higherCap_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	higherCap_MIN_GT?: InputMaybe<Scalars["Int"]>;
	higherCap_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	higherCap_MIN_LT?: InputMaybe<Scalars["Int"]>;
	higherCap_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	lowerCap_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	lowerCap_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	lowerCap_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	lowerCap_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	lowerCap_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	lowerCap_EQUAL?: InputMaybe<Scalars["Int"]>;
	lowerCap_GT?: InputMaybe<Scalars["Int"]>;
	lowerCap_GTE?: InputMaybe<Scalars["Int"]>;
	lowerCap_LT?: InputMaybe<Scalars["Int"]>;
	lowerCap_LTE?: InputMaybe<Scalars["Int"]>;
	lowerCap_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	lowerCap_MAX_GT?: InputMaybe<Scalars["Int"]>;
	lowerCap_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	lowerCap_MAX_LT?: InputMaybe<Scalars["Int"]>;
	lowerCap_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	lowerCap_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	lowerCap_MIN_GT?: InputMaybe<Scalars["Int"]>;
	lowerCap_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	lowerCap_MIN_LT?: InputMaybe<Scalars["Int"]>;
	lowerCap_MIN_LTE?: InputMaybe<Scalars["Int"]>;
};

export type BaseAgreementDiscountCapsCategoriesFieldInput = {
	connect?: InputMaybe<Array<BaseAgreementDiscountCapsCategoriesConnectFieldInput>>;
	create?: InputMaybe<Array<BaseAgreementDiscountCapsCategoriesCreateFieldInput>>;
};

export type BaseAgreementDiscountCapsCategoriesNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<BaseAgreementDiscountCapsCategoriesNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<BaseAgreementDiscountCapsCategoriesNodeAggregationWhereInput>>;
	code_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	code_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	code_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	code_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	code_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	code_EQUAL?: InputMaybe<Scalars["String"]>;
	code_GT?: InputMaybe<Scalars["Int"]>;
	code_GTE?: InputMaybe<Scalars["Int"]>;
	code_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	code_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	code_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	code_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	code_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	code_LT?: InputMaybe<Scalars["Int"]>;
	code_LTE?: InputMaybe<Scalars["Int"]>;
	code_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	code_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	code_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	code_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	code_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	level_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	level_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	level_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	level_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	level_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	level_EQUAL?: InputMaybe<Scalars["Int"]>;
	level_GT?: InputMaybe<Scalars["Int"]>;
	level_GTE?: InputMaybe<Scalars["Int"]>;
	level_LT?: InputMaybe<Scalars["Int"]>;
	level_LTE?: InputMaybe<Scalars["Int"]>;
	level_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	level_MAX_GT?: InputMaybe<Scalars["Int"]>;
	level_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	level_MAX_LT?: InputMaybe<Scalars["Int"]>;
	level_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	level_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	level_MIN_GT?: InputMaybe<Scalars["Int"]>;
	level_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	level_MIN_LT?: InputMaybe<Scalars["Int"]>;
	level_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	name_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	name_EQUAL?: InputMaybe<Scalars["String"]>;
	name_GT?: InputMaybe<Scalars["Int"]>;
	name_GTE?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	name_LT?: InputMaybe<Scalars["Int"]>;
	name_LTE?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	tenantId_EQUAL?: InputMaybe<Scalars["String"]>;
	tenantId_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type BaseAgreementDiscountCapsCategoriesRelationship = BaseAgreementCategoryDiscountCaps & {
	__typename?: "BaseAgreementDiscountCapsCategoriesRelationship";
	cursor: Scalars["String"];
	higherCap?: Maybe<Scalars["Int"]>;
	lowerCap?: Maybe<Scalars["Int"]>;
	node: DeviceProductCategory;
};

export type BaseAgreementDiscountCapsCategoriesUpdateConnectionInput = {
	edge?: InputMaybe<BaseAgreementCategoryDiscountCapsUpdateInput>;
	node?: InputMaybe<DeviceProductCategoryUpdateInput>;
};

export type BaseAgreementDiscountCapsCategoriesUpdateFieldInput = {
	connect?: InputMaybe<Array<BaseAgreementDiscountCapsCategoriesConnectFieldInput>>;
	create?: InputMaybe<Array<BaseAgreementDiscountCapsCategoriesCreateFieldInput>>;
	delete?: InputMaybe<Array<BaseAgreementDiscountCapsCategoriesDeleteFieldInput>>;
	disconnect?: InputMaybe<Array<BaseAgreementDiscountCapsCategoriesDisconnectFieldInput>>;
	update?: InputMaybe<BaseAgreementDiscountCapsCategoriesUpdateConnectionInput>;
	where?: InputMaybe<BaseAgreementDiscountCapsCategoriesConnectionWhere>;
};

export type BaseAgreementDiscountCapsDeviceKitsAggregateInput = {
	AND?: InputMaybe<Array<BaseAgreementDiscountCapsDeviceKitsAggregateInput>>;
	OR?: InputMaybe<Array<BaseAgreementDiscountCapsDeviceKitsAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	edge?: InputMaybe<BaseAgreementDiscountCapsDeviceKitsEdgeAggregationWhereInput>;
	node?: InputMaybe<BaseAgreementDiscountCapsDeviceKitsNodeAggregationWhereInput>;
};

export type BaseAgreementDiscountCapsDeviceKitsConnectFieldInput = {
	edge?: InputMaybe<BaseAgreementDeviceKitDiscountCapsCreateInput>;
	where?: InputMaybe<DeviceKitConnectWhere>;
};

export type BaseAgreementDiscountCapsDeviceKitsConnection = {
	__typename?: "BaseAgreementDiscountCapsDeviceKitsConnection";
	edges: Array<BaseAgreementDiscountCapsDeviceKitsRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type BaseAgreementDiscountCapsDeviceKitsConnectionSort = {
	edge?: InputMaybe<BaseAgreementDeviceKitDiscountCapsSort>;
	node?: InputMaybe<DeviceKitSort>;
};

export type BaseAgreementDiscountCapsDeviceKitsConnectionWhere = {
	AND?: InputMaybe<Array<BaseAgreementDiscountCapsDeviceKitsConnectionWhere>>;
	OR?: InputMaybe<Array<BaseAgreementDiscountCapsDeviceKitsConnectionWhere>>;
	edge?: InputMaybe<BaseAgreementDeviceKitDiscountCapsWhere>;
	edge_NOT?: InputMaybe<BaseAgreementDeviceKitDiscountCapsWhere>;
	node?: InputMaybe<DeviceKitWhere>;
	node_NOT?: InputMaybe<DeviceKitWhere>;
};

export type BaseAgreementDiscountCapsDeviceKitsCreateFieldInput = {
	edge?: InputMaybe<BaseAgreementDeviceKitDiscountCapsCreateInput>;
	node: DeviceKitCreateInput;
};

export type BaseAgreementDiscountCapsDeviceKitsDeleteFieldInput = {
	where?: InputMaybe<BaseAgreementDiscountCapsDeviceKitsConnectionWhere>;
};

export type BaseAgreementDiscountCapsDeviceKitsDisconnectFieldInput = {
	where?: InputMaybe<BaseAgreementDiscountCapsDeviceKitsConnectionWhere>;
};

export type BaseAgreementDiscountCapsDeviceKitsEdgeAggregationWhereInput = {
	AND?: InputMaybe<Array<BaseAgreementDiscountCapsDeviceKitsEdgeAggregationWhereInput>>;
	OR?: InputMaybe<Array<BaseAgreementDiscountCapsDeviceKitsEdgeAggregationWhereInput>>;
	higherCap_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	higherCap_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	higherCap_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	higherCap_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	higherCap_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	higherCap_EQUAL?: InputMaybe<Scalars["Int"]>;
	higherCap_GT?: InputMaybe<Scalars["Int"]>;
	higherCap_GTE?: InputMaybe<Scalars["Int"]>;
	higherCap_LT?: InputMaybe<Scalars["Int"]>;
	higherCap_LTE?: InputMaybe<Scalars["Int"]>;
	higherCap_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	higherCap_MAX_GT?: InputMaybe<Scalars["Int"]>;
	higherCap_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	higherCap_MAX_LT?: InputMaybe<Scalars["Int"]>;
	higherCap_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	higherCap_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	higherCap_MIN_GT?: InputMaybe<Scalars["Int"]>;
	higherCap_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	higherCap_MIN_LT?: InputMaybe<Scalars["Int"]>;
	higherCap_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	lowerCap_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	lowerCap_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	lowerCap_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	lowerCap_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	lowerCap_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	lowerCap_EQUAL?: InputMaybe<Scalars["Int"]>;
	lowerCap_GT?: InputMaybe<Scalars["Int"]>;
	lowerCap_GTE?: InputMaybe<Scalars["Int"]>;
	lowerCap_LT?: InputMaybe<Scalars["Int"]>;
	lowerCap_LTE?: InputMaybe<Scalars["Int"]>;
	lowerCap_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	lowerCap_MAX_GT?: InputMaybe<Scalars["Int"]>;
	lowerCap_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	lowerCap_MAX_LT?: InputMaybe<Scalars["Int"]>;
	lowerCap_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	lowerCap_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	lowerCap_MIN_GT?: InputMaybe<Scalars["Int"]>;
	lowerCap_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	lowerCap_MIN_LT?: InputMaybe<Scalars["Int"]>;
	lowerCap_MIN_LTE?: InputMaybe<Scalars["Int"]>;
};

export type BaseAgreementDiscountCapsDeviceKitsFieldInput = {
	connect?: InputMaybe<Array<BaseAgreementDiscountCapsDeviceKitsConnectFieldInput>>;
	create?: InputMaybe<Array<BaseAgreementDiscountCapsDeviceKitsCreateFieldInput>>;
};

export type BaseAgreementDiscountCapsDeviceKitsNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<BaseAgreementDiscountCapsDeviceKitsNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<BaseAgreementDiscountCapsDeviceKitsNodeAggregationWhereInput>>;
	name_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	name_EQUAL?: InputMaybe<Scalars["String"]>;
	name_GT?: InputMaybe<Scalars["Int"]>;
	name_GTE?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	name_LT?: InputMaybe<Scalars["Int"]>;
	name_LTE?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	ref_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	ref_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	ref_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	ref_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	ref_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	ref_EQUAL?: InputMaybe<Scalars["String"]>;
	ref_GT?: InputMaybe<Scalars["Int"]>;
	ref_GTE?: InputMaybe<Scalars["Int"]>;
	ref_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	ref_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	ref_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	ref_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	ref_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	ref_LT?: InputMaybe<Scalars["Int"]>;
	ref_LTE?: InputMaybe<Scalars["Int"]>;
	ref_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	ref_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	ref_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	ref_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	ref_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	tenantId_EQUAL?: InputMaybe<Scalars["String"]>;
	tenantId_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type BaseAgreementDiscountCapsDeviceKitsRelationship = BaseAgreementDeviceKitDiscountCaps & {
	__typename?: "BaseAgreementDiscountCapsDeviceKitsRelationship";
	cursor: Scalars["String"];
	higherCap?: Maybe<Scalars["Int"]>;
	lowerCap?: Maybe<Scalars["Int"]>;
	node: DeviceKit;
};

export type BaseAgreementDiscountCapsDeviceKitsUpdateConnectionInput = {
	edge?: InputMaybe<BaseAgreementDeviceKitDiscountCapsUpdateInput>;
	node?: InputMaybe<DeviceKitUpdateInput>;
};

export type BaseAgreementDiscountCapsDeviceKitsUpdateFieldInput = {
	connect?: InputMaybe<Array<BaseAgreementDiscountCapsDeviceKitsConnectFieldInput>>;
	create?: InputMaybe<Array<BaseAgreementDiscountCapsDeviceKitsCreateFieldInput>>;
	delete?: InputMaybe<Array<BaseAgreementDiscountCapsDeviceKitsDeleteFieldInput>>;
	disconnect?: InputMaybe<Array<BaseAgreementDiscountCapsDeviceKitsDisconnectFieldInput>>;
	update?: InputMaybe<BaseAgreementDiscountCapsDeviceKitsUpdateConnectionInput>;
	where?: InputMaybe<BaseAgreementDiscountCapsDeviceKitsConnectionWhere>;
};

export type BaseAgreementEligibilityConditionRelationship = {
	value?: Maybe<Scalars["Int"]>;
};

export type BaseAgreementEligibilityConditionRelationshipCreateInput = {
	value?: InputMaybe<Scalars["Int"]>;
};

export type BaseAgreementEligibilityConditionRelationshipSort = {
	value?: InputMaybe<SortDirection>;
};

export type BaseAgreementEligibilityConditionRelationshipUpdateInput = {
	value?: InputMaybe<Scalars["Int"]>;
};

export type BaseAgreementEligibilityConditionRelationshipWhere = {
	AND?: InputMaybe<Array<BaseAgreementEligibilityConditionRelationshipWhere>>;
	OR?: InputMaybe<Array<BaseAgreementEligibilityConditionRelationshipWhere>>;
	value?: InputMaybe<Scalars["Int"]>;
	value_GT?: InputMaybe<Scalars["Int"]>;
	value_GTE?: InputMaybe<Scalars["Int"]>;
	value_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	value_LT?: InputMaybe<Scalars["Int"]>;
	value_LTE?: InputMaybe<Scalars["Int"]>;
	value_NOT?: InputMaybe<Scalars["Int"]>;
	value_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
};

export type BaseAgreementEligibilityConditionSetsAggregateInput = {
	AND?: InputMaybe<Array<BaseAgreementEligibilityConditionSetsAggregateInput>>;
	OR?: InputMaybe<Array<BaseAgreementEligibilityConditionSetsAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	edge?: InputMaybe<BaseAgreementEligibilityConditionSetsEdgeAggregationWhereInput>;
	node?: InputMaybe<BaseAgreementEligibilityConditionSetsNodeAggregationWhereInput>;
};

export type BaseAgreementEligibilityConditionSetsConnectFieldInput = {
	edge?: InputMaybe<BaseAgreementEligibilityConditionRelationshipCreateInput>;
	where?: InputMaybe<EligibilityConditionSetConnectWhere>;
};

export type BaseAgreementEligibilityConditionSetsConnection = {
	__typename?: "BaseAgreementEligibilityConditionSetsConnection";
	edges: Array<BaseAgreementEligibilityConditionSetsRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type BaseAgreementEligibilityConditionSetsConnectionSort = {
	edge?: InputMaybe<BaseAgreementEligibilityConditionRelationshipSort>;
	node?: InputMaybe<EligibilityConditionSetSort>;
};

export type BaseAgreementEligibilityConditionSetsConnectionWhere = {
	AND?: InputMaybe<Array<BaseAgreementEligibilityConditionSetsConnectionWhere>>;
	OR?: InputMaybe<Array<BaseAgreementEligibilityConditionSetsConnectionWhere>>;
	edge?: InputMaybe<BaseAgreementEligibilityConditionRelationshipWhere>;
	edge_NOT?: InputMaybe<BaseAgreementEligibilityConditionRelationshipWhere>;
	node?: InputMaybe<EligibilityConditionSetWhere>;
	node_NOT?: InputMaybe<EligibilityConditionSetWhere>;
};

export type BaseAgreementEligibilityConditionSetsCreateFieldInput = {
	edge?: InputMaybe<BaseAgreementEligibilityConditionRelationshipCreateInput>;
	node: EligibilityConditionSetCreateInput;
};

export type BaseAgreementEligibilityConditionSetsDeleteFieldInput = {
	where?: InputMaybe<BaseAgreementEligibilityConditionSetsConnectionWhere>;
};

export type BaseAgreementEligibilityConditionSetsDisconnectFieldInput = {
	where?: InputMaybe<BaseAgreementEligibilityConditionSetsConnectionWhere>;
};

export type BaseAgreementEligibilityConditionSetsEdgeAggregationWhereInput = {
	AND?: InputMaybe<Array<BaseAgreementEligibilityConditionSetsEdgeAggregationWhereInput>>;
	OR?: InputMaybe<Array<BaseAgreementEligibilityConditionSetsEdgeAggregationWhereInput>>;
	value_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	value_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	value_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	value_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	value_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	value_EQUAL?: InputMaybe<Scalars["Int"]>;
	value_GT?: InputMaybe<Scalars["Int"]>;
	value_GTE?: InputMaybe<Scalars["Int"]>;
	value_LT?: InputMaybe<Scalars["Int"]>;
	value_LTE?: InputMaybe<Scalars["Int"]>;
	value_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	value_MAX_GT?: InputMaybe<Scalars["Int"]>;
	value_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	value_MAX_LT?: InputMaybe<Scalars["Int"]>;
	value_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	value_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	value_MIN_GT?: InputMaybe<Scalars["Int"]>;
	value_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	value_MIN_LT?: InputMaybe<Scalars["Int"]>;
	value_MIN_LTE?: InputMaybe<Scalars["Int"]>;
};

export type BaseAgreementEligibilityConditionSetsFieldInput = {
	connect?: InputMaybe<Array<BaseAgreementEligibilityConditionSetsConnectFieldInput>>;
	create?: InputMaybe<Array<BaseAgreementEligibilityConditionSetsCreateFieldInput>>;
};

export type BaseAgreementEligibilityConditionSetsNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<BaseAgreementEligibilityConditionSetsNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<BaseAgreementEligibilityConditionSetsNodeAggregationWhereInput>>;
	code_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	code_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	code_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	code_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	code_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	code_EQUAL?: InputMaybe<Scalars["String"]>;
	code_GT?: InputMaybe<Scalars["Int"]>;
	code_GTE?: InputMaybe<Scalars["Int"]>;
	code_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	code_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	code_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	code_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	code_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	code_LT?: InputMaybe<Scalars["Int"]>;
	code_LTE?: InputMaybe<Scalars["Int"]>;
	code_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	code_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	code_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	code_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	code_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	inputLabel_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	inputLabel_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	inputLabel_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	inputLabel_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	inputLabel_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	inputLabel_EQUAL?: InputMaybe<Scalars["String"]>;
	inputLabel_GT?: InputMaybe<Scalars["Int"]>;
	inputLabel_GTE?: InputMaybe<Scalars["Int"]>;
	inputLabel_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	inputLabel_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	inputLabel_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	inputLabel_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	inputLabel_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	inputLabel_LT?: InputMaybe<Scalars["Int"]>;
	inputLabel_LTE?: InputMaybe<Scalars["Int"]>;
	inputLabel_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	inputLabel_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	inputLabel_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	inputLabel_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	inputLabel_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	name_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	name_EQUAL?: InputMaybe<Scalars["String"]>;
	name_GT?: InputMaybe<Scalars["Int"]>;
	name_GTE?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	name_LT?: InputMaybe<Scalars["Int"]>;
	name_LTE?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type BaseAgreementEligibilityConditionSetsRelationship = BaseAgreementEligibilityConditionRelationship & {
	__typename?: "BaseAgreementEligibilityConditionSetsRelationship";
	cursor: Scalars["String"];
	node: EligibilityConditionSet;
	value?: Maybe<Scalars["Int"]>;
};

export type BaseAgreementEligibilityConditionSetsUpdateConnectionInput = {
	edge?: InputMaybe<BaseAgreementEligibilityConditionRelationshipUpdateInput>;
	node?: InputMaybe<EligibilityConditionSetUpdateInput>;
};

export type BaseAgreementEligibilityConditionSetsUpdateFieldInput = {
	connect?: InputMaybe<Array<BaseAgreementEligibilityConditionSetsConnectFieldInput>>;
	create?: InputMaybe<Array<BaseAgreementEligibilityConditionSetsCreateFieldInput>>;
	delete?: InputMaybe<Array<BaseAgreementEligibilityConditionSetsDeleteFieldInput>>;
	disconnect?: InputMaybe<Array<BaseAgreementEligibilityConditionSetsDisconnectFieldInput>>;
	update?: InputMaybe<BaseAgreementEligibilityConditionSetsUpdateConnectionInput>;
	where?: InputMaybe<BaseAgreementEligibilityConditionSetsConnectionWhere>;
};

export type BaseAgreementEnrollingConditionSetsAggregateInput = {
	AND?: InputMaybe<Array<BaseAgreementEnrollingConditionSetsAggregateInput>>;
	OR?: InputMaybe<Array<BaseAgreementEnrollingConditionSetsAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<BaseAgreementEnrollingConditionSetsNodeAggregationWhereInput>;
};

export type BaseAgreementEnrollingConditionSetsConnectFieldInput = {
	connect?: InputMaybe<Array<EnrollingConditionSetConnectInput>>;
	where?: InputMaybe<EnrollingConditionSetConnectWhere>;
};

export type BaseAgreementEnrollingConditionSetsConnection = {
	__typename?: "BaseAgreementEnrollingConditionSetsConnection";
	edges: Array<BaseAgreementEnrollingConditionSetsRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type BaseAgreementEnrollingConditionSetsConnectionSort = {
	node?: InputMaybe<EnrollingConditionSetSort>;
};

export type BaseAgreementEnrollingConditionSetsConnectionWhere = {
	AND?: InputMaybe<Array<BaseAgreementEnrollingConditionSetsConnectionWhere>>;
	OR?: InputMaybe<Array<BaseAgreementEnrollingConditionSetsConnectionWhere>>;
	node?: InputMaybe<EnrollingConditionSetWhere>;
	node_NOT?: InputMaybe<EnrollingConditionSetWhere>;
};

export type BaseAgreementEnrollingConditionSetsCreateFieldInput = {
	node: EnrollingConditionSetCreateInput;
};

export type BaseAgreementEnrollingConditionSetsDeleteFieldInput = {
	delete?: InputMaybe<EnrollingConditionSetDeleteInput>;
	where?: InputMaybe<BaseAgreementEnrollingConditionSetsConnectionWhere>;
};

export type BaseAgreementEnrollingConditionSetsDisconnectFieldInput = {
	disconnect?: InputMaybe<EnrollingConditionSetDisconnectInput>;
	where?: InputMaybe<BaseAgreementEnrollingConditionSetsConnectionWhere>;
};

export type BaseAgreementEnrollingConditionSetsFieldInput = {
	connect?: InputMaybe<Array<BaseAgreementEnrollingConditionSetsConnectFieldInput>>;
	create?: InputMaybe<Array<BaseAgreementEnrollingConditionSetsCreateFieldInput>>;
};

export type BaseAgreementEnrollingConditionSetsNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<BaseAgreementEnrollingConditionSetsNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<BaseAgreementEnrollingConditionSetsNodeAggregationWhereInput>>;
	code_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	code_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	code_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	code_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	code_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	code_EQUAL?: InputMaybe<Scalars["String"]>;
	code_GT?: InputMaybe<Scalars["Int"]>;
	code_GTE?: InputMaybe<Scalars["Int"]>;
	code_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	code_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	code_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	code_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	code_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	code_LT?: InputMaybe<Scalars["Int"]>;
	code_LTE?: InputMaybe<Scalars["Int"]>;
	code_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	code_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	code_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	code_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	code_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type BaseAgreementEnrollingConditionSetsRelationship = {
	__typename?: "BaseAgreementEnrollingConditionSetsRelationship";
	cursor: Scalars["String"];
	node: EnrollingConditionSet;
};

export type BaseAgreementEnrollingConditionSetsUpdateConnectionInput = {
	node?: InputMaybe<EnrollingConditionSetUpdateInput>;
};

export type BaseAgreementEnrollingConditionSetsUpdateFieldInput = {
	connect?: InputMaybe<Array<BaseAgreementEnrollingConditionSetsConnectFieldInput>>;
	create?: InputMaybe<Array<BaseAgreementEnrollingConditionSetsCreateFieldInput>>;
	delete?: InputMaybe<Array<BaseAgreementEnrollingConditionSetsDeleteFieldInput>>;
	disconnect?: InputMaybe<Array<BaseAgreementEnrollingConditionSetsDisconnectFieldInput>>;
	update?: InputMaybe<BaseAgreementEnrollingConditionSetsUpdateConnectionInput>;
	where?: InputMaybe<BaseAgreementEnrollingConditionSetsConnectionWhere>;
};

export type BaseAgreementEnrollingPeriodsAggregateInput = {
	AND?: InputMaybe<Array<BaseAgreementEnrollingPeriodsAggregateInput>>;
	OR?: InputMaybe<Array<BaseAgreementEnrollingPeriodsAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
};

export type BaseAgreementEnrollingPeriodsConnectFieldInput = {
	where?: InputMaybe<EnrollingPeriodConnectWhere>;
};

export type BaseAgreementEnrollingPeriodsConnection = {
	__typename?: "BaseAgreementEnrollingPeriodsConnection";
	edges: Array<BaseAgreementEnrollingPeriodsRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type BaseAgreementEnrollingPeriodsConnectionSort = {
	node?: InputMaybe<EnrollingPeriodSort>;
};

export type BaseAgreementEnrollingPeriodsConnectionWhere = {
	AND?: InputMaybe<Array<BaseAgreementEnrollingPeriodsConnectionWhere>>;
	OR?: InputMaybe<Array<BaseAgreementEnrollingPeriodsConnectionWhere>>;
	node?: InputMaybe<EnrollingPeriodWhere>;
	node_NOT?: InputMaybe<EnrollingPeriodWhere>;
};

export type BaseAgreementEnrollingPeriodsCreateFieldInput = {
	node: EnrollingPeriodCreateInput;
};

export type BaseAgreementEnrollingPeriodsDeleteFieldInput = {
	where?: InputMaybe<BaseAgreementEnrollingPeriodsConnectionWhere>;
};

export type BaseAgreementEnrollingPeriodsDisconnectFieldInput = {
	where?: InputMaybe<BaseAgreementEnrollingPeriodsConnectionWhere>;
};

export type BaseAgreementEnrollingPeriodsFieldInput = {
	connect?: InputMaybe<Array<BaseAgreementEnrollingPeriodsConnectFieldInput>>;
	create?: InputMaybe<Array<BaseAgreementEnrollingPeriodsCreateFieldInput>>;
};

export type BaseAgreementEnrollingPeriodsRelationship = {
	__typename?: "BaseAgreementEnrollingPeriodsRelationship";
	cursor: Scalars["String"];
	node: EnrollingPeriod;
};

export type BaseAgreementEnrollingPeriodsUpdateConnectionInput = {
	node?: InputMaybe<EnrollingPeriodUpdateInput>;
};

export type BaseAgreementEnrollingPeriodsUpdateFieldInput = {
	connect?: InputMaybe<Array<BaseAgreementEnrollingPeriodsConnectFieldInput>>;
	create?: InputMaybe<Array<BaseAgreementEnrollingPeriodsCreateFieldInput>>;
	delete?: InputMaybe<Array<BaseAgreementEnrollingPeriodsDeleteFieldInput>>;
	disconnect?: InputMaybe<Array<BaseAgreementEnrollingPeriodsDisconnectFieldInput>>;
	update?: InputMaybe<BaseAgreementEnrollingPeriodsUpdateConnectionInput>;
	where?: InputMaybe<BaseAgreementEnrollingPeriodsConnectionWhere>;
};

export type BaseAgreementFinancialSummaryConfigAggregateInput = {
	AND?: InputMaybe<Array<BaseAgreementFinancialSummaryConfigAggregateInput>>;
	OR?: InputMaybe<Array<BaseAgreementFinancialSummaryConfigAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	edge?: InputMaybe<BaseAgreementFinancialSummaryConfigEdgeAggregationWhereInput>;
	node?: InputMaybe<BaseAgreementFinancialSummaryConfigNodeAggregationWhereInput>;
};

export type BaseAgreementFinancialSummaryConfigConnectFieldInput = {
	edge?: InputMaybe<AgreementFinancialSummaryColumnRelationshipCreateInput>;
	where?: InputMaybe<FinancialSummaryColumnConnectWhere>;
};

export type BaseAgreementFinancialSummaryConfigConnection = {
	__typename?: "BaseAgreementFinancialSummaryConfigConnection";
	edges: Array<BaseAgreementFinancialSummaryConfigRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type BaseAgreementFinancialSummaryConfigConnectionSort = {
	edge?: InputMaybe<AgreementFinancialSummaryColumnRelationshipSort>;
	node?: InputMaybe<FinancialSummaryColumnSort>;
};

export type BaseAgreementFinancialSummaryConfigConnectionWhere = {
	AND?: InputMaybe<Array<BaseAgreementFinancialSummaryConfigConnectionWhere>>;
	OR?: InputMaybe<Array<BaseAgreementFinancialSummaryConfigConnectionWhere>>;
	edge?: InputMaybe<AgreementFinancialSummaryColumnRelationshipWhere>;
	edge_NOT?: InputMaybe<AgreementFinancialSummaryColumnRelationshipWhere>;
	node?: InputMaybe<FinancialSummaryColumnWhere>;
	node_NOT?: InputMaybe<FinancialSummaryColumnWhere>;
};

export type BaseAgreementFinancialSummaryConfigCreateFieldInput = {
	edge?: InputMaybe<AgreementFinancialSummaryColumnRelationshipCreateInput>;
	node: FinancialSummaryColumnCreateInput;
};

export type BaseAgreementFinancialSummaryConfigDeleteFieldInput = {
	where?: InputMaybe<BaseAgreementFinancialSummaryConfigConnectionWhere>;
};

export type BaseAgreementFinancialSummaryConfigDisconnectFieldInput = {
	where?: InputMaybe<BaseAgreementFinancialSummaryConfigConnectionWhere>;
};

export type BaseAgreementFinancialSummaryConfigEdgeAggregationWhereInput = {
	AND?: InputMaybe<Array<BaseAgreementFinancialSummaryConfigEdgeAggregationWhereInput>>;
	OR?: InputMaybe<Array<BaseAgreementFinancialSummaryConfigEdgeAggregationWhereInput>>;
	localizationKey_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	localizationKey_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	localizationKey_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	localizationKey_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	localizationKey_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	localizationKey_EQUAL?: InputMaybe<Scalars["String"]>;
	localizationKey_GT?: InputMaybe<Scalars["Int"]>;
	localizationKey_GTE?: InputMaybe<Scalars["Int"]>;
	localizationKey_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	localizationKey_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	localizationKey_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	localizationKey_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	localizationKey_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	localizationKey_LT?: InputMaybe<Scalars["Int"]>;
	localizationKey_LTE?: InputMaybe<Scalars["Int"]>;
	localizationKey_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	localizationKey_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	localizationKey_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	localizationKey_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	localizationKey_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	position_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	position_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	position_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	position_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	position_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	position_EQUAL?: InputMaybe<Scalars["Int"]>;
	position_GT?: InputMaybe<Scalars["Int"]>;
	position_GTE?: InputMaybe<Scalars["Int"]>;
	position_LT?: InputMaybe<Scalars["Int"]>;
	position_LTE?: InputMaybe<Scalars["Int"]>;
	position_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	position_MAX_GT?: InputMaybe<Scalars["Int"]>;
	position_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	position_MAX_LT?: InputMaybe<Scalars["Int"]>;
	position_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	position_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	position_MIN_GT?: InputMaybe<Scalars["Int"]>;
	position_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	position_MIN_LT?: InputMaybe<Scalars["Int"]>;
	position_MIN_LTE?: InputMaybe<Scalars["Int"]>;
};

export type BaseAgreementFinancialSummaryConfigFieldInput = {
	connect?: InputMaybe<Array<BaseAgreementFinancialSummaryConfigConnectFieldInput>>;
	create?: InputMaybe<Array<BaseAgreementFinancialSummaryConfigCreateFieldInput>>;
};

export type BaseAgreementFinancialSummaryConfigNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<BaseAgreementFinancialSummaryConfigNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<BaseAgreementFinancialSummaryConfigNodeAggregationWhereInput>>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
};

export type BaseAgreementFinancialSummaryConfigRelationship = AgreementFinancialSummaryColumnRelationship & {
	__typename?: "BaseAgreementFinancialSummaryConfigRelationship";
	cursor: Scalars["String"];
	hasHelpMessage?: Maybe<Scalars["Boolean"]>;
	isIncluded?: Maybe<Scalars["Boolean"]>;
	localizationKey?: Maybe<Scalars["String"]>;
	node: FinancialSummaryColumn;
	position?: Maybe<Scalars["Int"]>;
};

export type BaseAgreementFinancialSummaryConfigUpdateConnectionInput = {
	edge?: InputMaybe<AgreementFinancialSummaryColumnRelationshipUpdateInput>;
	node?: InputMaybe<FinancialSummaryColumnUpdateInput>;
};

export type BaseAgreementFinancialSummaryConfigUpdateFieldInput = {
	connect?: InputMaybe<Array<BaseAgreementFinancialSummaryConfigConnectFieldInput>>;
	create?: InputMaybe<Array<BaseAgreementFinancialSummaryConfigCreateFieldInput>>;
	delete?: InputMaybe<Array<BaseAgreementFinancialSummaryConfigDeleteFieldInput>>;
	disconnect?: InputMaybe<Array<BaseAgreementFinancialSummaryConfigDisconnectFieldInput>>;
	update?: InputMaybe<BaseAgreementFinancialSummaryConfigUpdateConnectionInput>;
	where?: InputMaybe<BaseAgreementFinancialSummaryConfigConnectionWhere>;
};

export type BaseAgreementInitialVersionAggregateInput = {
	AND?: InputMaybe<Array<BaseAgreementInitialVersionAggregateInput>>;
	OR?: InputMaybe<Array<BaseAgreementInitialVersionAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<BaseAgreementInitialVersionNodeAggregationWhereInput>;
};

export type BaseAgreementInitialVersionConnectFieldInput = {
	connect?: InputMaybe<BaseAgreementConnectInput>;
	where?: InputMaybe<BaseAgreementConnectWhere>;
};

export type BaseAgreementInitialVersionConnection = {
	__typename?: "BaseAgreementInitialVersionConnection";
	edges: Array<BaseAgreementInitialVersionRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type BaseAgreementInitialVersionConnectionSort = {
	node?: InputMaybe<BaseAgreementSort>;
};

export type BaseAgreementInitialVersionConnectionWhere = {
	AND?: InputMaybe<Array<BaseAgreementInitialVersionConnectionWhere>>;
	OR?: InputMaybe<Array<BaseAgreementInitialVersionConnectionWhere>>;
	node?: InputMaybe<BaseAgreementWhere>;
	node_NOT?: InputMaybe<BaseAgreementWhere>;
};

export type BaseAgreementInitialVersionCreateFieldInput = {
	node: BaseAgreementCreateInput;
};

export type BaseAgreementInitialVersionDeleteFieldInput = {
	delete?: InputMaybe<BaseAgreementDeleteInput>;
	where?: InputMaybe<BaseAgreementInitialVersionConnectionWhere>;
};

export type BaseAgreementInitialVersionDisconnectFieldInput = {
	disconnect?: InputMaybe<BaseAgreementDisconnectInput>;
	where?: InputMaybe<BaseAgreementInitialVersionConnectionWhere>;
};

export type BaseAgreementInitialVersionFieldInput = {
	connect?: InputMaybe<BaseAgreementInitialVersionConnectFieldInput>;
	create?: InputMaybe<BaseAgreementInitialVersionCreateFieldInput>;
};

export type BaseAgreementInitialVersionNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<BaseAgreementInitialVersionNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<BaseAgreementInitialVersionNodeAggregationWhereInput>>;
	coveringFormWaitInterval_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	coveringFormWaitInterval_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	coveringFormWaitInterval_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	coveringFormWaitInterval_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	coveringFormWaitInterval_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	coveringFormWaitInterval_EQUAL?: InputMaybe<Scalars["Int"]>;
	coveringFormWaitInterval_GT?: InputMaybe<Scalars["Int"]>;
	coveringFormWaitInterval_GTE?: InputMaybe<Scalars["Int"]>;
	coveringFormWaitInterval_LT?: InputMaybe<Scalars["Int"]>;
	coveringFormWaitInterval_LTE?: InputMaybe<Scalars["Int"]>;
	coveringFormWaitInterval_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	coveringFormWaitInterval_MAX_GT?: InputMaybe<Scalars["Int"]>;
	coveringFormWaitInterval_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	coveringFormWaitInterval_MAX_LT?: InputMaybe<Scalars["Int"]>;
	coveringFormWaitInterval_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	coveringFormWaitInterval_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	coveringFormWaitInterval_MIN_GT?: InputMaybe<Scalars["Int"]>;
	coveringFormWaitInterval_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	coveringFormWaitInterval_MIN_LT?: InputMaybe<Scalars["Int"]>;
	coveringFormWaitInterval_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	createdOn_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_GT?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_GTE?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_LT?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_LTE?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	formattedAmount_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	formattedAmount_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	formattedAmount_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	formattedAmount_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	formattedAmount_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	formattedAmount_EQUAL?: InputMaybe<Scalars["String"]>;
	formattedAmount_GT?: InputMaybe<Scalars["Int"]>;
	formattedAmount_GTE?: InputMaybe<Scalars["Int"]>;
	formattedAmount_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedAmount_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedAmount_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedAmount_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedAmount_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	formattedAmount_LT?: InputMaybe<Scalars["Int"]>;
	formattedAmount_LTE?: InputMaybe<Scalars["Int"]>;
	formattedAmount_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedAmount_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedAmount_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedAmount_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedAmount_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	formattedCounterparties_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	formattedCounterparties_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	formattedCounterparties_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	formattedCounterparties_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	formattedCounterparties_EQUAL?: InputMaybe<Scalars["String"]>;
	formattedCounterparties_GT?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_GTE?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_LT?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_LTE?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	formattedProducts_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	formattedProducts_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	formattedProducts_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	formattedProducts_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	formattedProducts_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	formattedProducts_EQUAL?: InputMaybe<Scalars["String"]>;
	formattedProducts_GT?: InputMaybe<Scalars["Int"]>;
	formattedProducts_GTE?: InputMaybe<Scalars["Int"]>;
	formattedProducts_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedProducts_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedProducts_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedProducts_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedProducts_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	formattedProducts_LT?: InputMaybe<Scalars["Int"]>;
	formattedProducts_LTE?: InputMaybe<Scalars["Int"]>;
	formattedProducts_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedProducts_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedProducts_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedProducts_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedProducts_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	formattedTags_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	formattedTags_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	formattedTags_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	formattedTags_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	formattedTags_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	formattedTags_EQUAL?: InputMaybe<Scalars["String"]>;
	formattedTags_GT?: InputMaybe<Scalars["Int"]>;
	formattedTags_GTE?: InputMaybe<Scalars["Int"]>;
	formattedTags_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedTags_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedTags_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedTags_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedTags_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	formattedTags_LT?: InputMaybe<Scalars["Int"]>;
	formattedTags_LTE?: InputMaybe<Scalars["Int"]>;
	formattedTags_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedTags_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedTags_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedTags_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedTags_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	formattedValidityPeriod_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	formattedValidityPeriod_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	formattedValidityPeriod_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	formattedValidityPeriod_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	formattedValidityPeriod_EQUAL?: InputMaybe<Scalars["String"]>;
	formattedValidityPeriod_GT?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_GTE?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_LT?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_LTE?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	initialVersionId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	initialVersionId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	initialVersionId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	initialVersionId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	initialVersionId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	initialVersionId_EQUAL?: InputMaybe<Scalars["String"]>;
	initialVersionId_GT?: InputMaybe<Scalars["Int"]>;
	initialVersionId_GTE?: InputMaybe<Scalars["Int"]>;
	initialVersionId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	initialVersionId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	initialVersionId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	initialVersionId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	initialVersionId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	initialVersionId_LT?: InputMaybe<Scalars["Int"]>;
	initialVersionId_LTE?: InputMaybe<Scalars["Int"]>;
	initialVersionId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	initialVersionId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	initialVersionId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	initialVersionId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	initialVersionId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	lastExecutionDate_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_GT?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_LT?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_LTE?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	name_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	name_EQUAL?: InputMaybe<Scalars["String"]>;
	name_GT?: InputMaybe<Scalars["Int"]>;
	name_GTE?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	name_LT?: InputMaybe<Scalars["Int"]>;
	name_LTE?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	pushedOn_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	pushedOn_GT?: InputMaybe<Scalars["DateTime"]>;
	pushedOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	pushedOn_LT?: InputMaybe<Scalars["DateTime"]>;
	pushedOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	pushedOn_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	pushedOn_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	pushedOn_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	pushedOn_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	pushedOn_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	pushedOn_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	pushedOn_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	pushedOn_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	pushedOn_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	pushedOn_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	version_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	version_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	version_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	version_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	version_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	version_EQUAL?: InputMaybe<Scalars["Int"]>;
	version_GT?: InputMaybe<Scalars["Int"]>;
	version_GTE?: InputMaybe<Scalars["Int"]>;
	version_LT?: InputMaybe<Scalars["Int"]>;
	version_LTE?: InputMaybe<Scalars["Int"]>;
	version_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	version_MAX_GT?: InputMaybe<Scalars["Int"]>;
	version_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	version_MAX_LT?: InputMaybe<Scalars["Int"]>;
	version_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	version_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	version_MIN_GT?: InputMaybe<Scalars["Int"]>;
	version_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	version_MIN_LT?: InputMaybe<Scalars["Int"]>;
	version_MIN_LTE?: InputMaybe<Scalars["Int"]>;
};

export type BaseAgreementInitialVersionRelationship = {
	__typename?: "BaseAgreementInitialVersionRelationship";
	cursor: Scalars["String"];
	node: BaseAgreement;
};

export type BaseAgreementInitialVersionUpdateConnectionInput = {
	node?: InputMaybe<BaseAgreementUpdateInput>;
};

export type BaseAgreementInitialVersionUpdateFieldInput = {
	connect?: InputMaybe<BaseAgreementInitialVersionConnectFieldInput>;
	create?: InputMaybe<BaseAgreementInitialVersionCreateFieldInput>;
	delete?: InputMaybe<BaseAgreementInitialVersionDeleteFieldInput>;
	disconnect?: InputMaybe<BaseAgreementInitialVersionDisconnectFieldInput>;
	update?: InputMaybe<BaseAgreementInitialVersionUpdateConnectionInput>;
	where?: InputMaybe<BaseAgreementInitialVersionConnectionWhere>;
};

export type BaseAgreementNamedTimeRangesAggregateInput = {
	AND?: InputMaybe<Array<BaseAgreementNamedTimeRangesAggregateInput>>;
	OR?: InputMaybe<Array<BaseAgreementNamedTimeRangesAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<BaseAgreementNamedTimeRangesNodeAggregationWhereInput>;
};

export type BaseAgreementNamedTimeRangesConnectFieldInput = {
	where?: InputMaybe<TimeframeConnectWhere>;
};

export type BaseAgreementNamedTimeRangesConnection = {
	__typename?: "BaseAgreementNamedTimeRangesConnection";
	edges: Array<BaseAgreementNamedTimeRangesRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type BaseAgreementNamedTimeRangesConnectionSort = {
	node?: InputMaybe<TimeframeSort>;
};

export type BaseAgreementNamedTimeRangesConnectionWhere = {
	AND?: InputMaybe<Array<BaseAgreementNamedTimeRangesConnectionWhere>>;
	OR?: InputMaybe<Array<BaseAgreementNamedTimeRangesConnectionWhere>>;
	node?: InputMaybe<TimeframeWhere>;
	node_NOT?: InputMaybe<TimeframeWhere>;
};

export type BaseAgreementNamedTimeRangesCreateFieldInput = {
	node: TimeframeCreateInput;
};

export type BaseAgreementNamedTimeRangesDeleteFieldInput = {
	where?: InputMaybe<BaseAgreementNamedTimeRangesConnectionWhere>;
};

export type BaseAgreementNamedTimeRangesDisconnectFieldInput = {
	where?: InputMaybe<BaseAgreementNamedTimeRangesConnectionWhere>;
};

export type BaseAgreementNamedTimeRangesFieldInput = {
	connect?: InputMaybe<Array<BaseAgreementNamedTimeRangesConnectFieldInput>>;
	create?: InputMaybe<Array<BaseAgreementNamedTimeRangesCreateFieldInput>>;
};

export type BaseAgreementNamedTimeRangesNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<BaseAgreementNamedTimeRangesNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<BaseAgreementNamedTimeRangesNodeAggregationWhereInput>>;
	name_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	name_EQUAL?: InputMaybe<Scalars["String"]>;
	name_GT?: InputMaybe<Scalars["Int"]>;
	name_GTE?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	name_LT?: InputMaybe<Scalars["Int"]>;
	name_LTE?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type BaseAgreementNamedTimeRangesRelationship = {
	__typename?: "BaseAgreementNamedTimeRangesRelationship";
	cursor: Scalars["String"];
	node: Timeframe;
};

export type BaseAgreementNamedTimeRangesUpdateConnectionInput = {
	node?: InputMaybe<TimeframeUpdateInput>;
};

export type BaseAgreementNamedTimeRangesUpdateFieldInput = {
	connect?: InputMaybe<Array<BaseAgreementNamedTimeRangesConnectFieldInput>>;
	create?: InputMaybe<Array<BaseAgreementNamedTimeRangesCreateFieldInput>>;
	delete?: InputMaybe<Array<BaseAgreementNamedTimeRangesDeleteFieldInput>>;
	disconnect?: InputMaybe<Array<BaseAgreementNamedTimeRangesDisconnectFieldInput>>;
	update?: InputMaybe<BaseAgreementNamedTimeRangesUpdateConnectionInput>;
	where?: InputMaybe<BaseAgreementNamedTimeRangesConnectionWhere>;
};

export type BaseAgreementNextVersionsAggregateInput = {
	AND?: InputMaybe<Array<BaseAgreementNextVersionsAggregateInput>>;
	OR?: InputMaybe<Array<BaseAgreementNextVersionsAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<BaseAgreementNextVersionsNodeAggregationWhereInput>;
};

export type BaseAgreementNextVersionsConnectFieldInput = {
	connect?: InputMaybe<Array<BaseAgreementConnectInput>>;
	where?: InputMaybe<BaseAgreementConnectWhere>;
};

export type BaseAgreementNextVersionsConnection = {
	__typename?: "BaseAgreementNextVersionsConnection";
	edges: Array<BaseAgreementNextVersionsRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type BaseAgreementNextVersionsConnectionSort = {
	node?: InputMaybe<BaseAgreementSort>;
};

export type BaseAgreementNextVersionsConnectionWhere = {
	AND?: InputMaybe<Array<BaseAgreementNextVersionsConnectionWhere>>;
	OR?: InputMaybe<Array<BaseAgreementNextVersionsConnectionWhere>>;
	node?: InputMaybe<BaseAgreementWhere>;
	node_NOT?: InputMaybe<BaseAgreementWhere>;
};

export type BaseAgreementNextVersionsCreateFieldInput = {
	node: BaseAgreementCreateInput;
};

export type BaseAgreementNextVersionsDeleteFieldInput = {
	delete?: InputMaybe<BaseAgreementDeleteInput>;
	where?: InputMaybe<BaseAgreementNextVersionsConnectionWhere>;
};

export type BaseAgreementNextVersionsDisconnectFieldInput = {
	disconnect?: InputMaybe<BaseAgreementDisconnectInput>;
	where?: InputMaybe<BaseAgreementNextVersionsConnectionWhere>;
};

export type BaseAgreementNextVersionsFieldInput = {
	connect?: InputMaybe<Array<BaseAgreementNextVersionsConnectFieldInput>>;
	create?: InputMaybe<Array<BaseAgreementNextVersionsCreateFieldInput>>;
};

export type BaseAgreementNextVersionsNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<BaseAgreementNextVersionsNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<BaseAgreementNextVersionsNodeAggregationWhereInput>>;
	coveringFormWaitInterval_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	coveringFormWaitInterval_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	coveringFormWaitInterval_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	coveringFormWaitInterval_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	coveringFormWaitInterval_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	coveringFormWaitInterval_EQUAL?: InputMaybe<Scalars["Int"]>;
	coveringFormWaitInterval_GT?: InputMaybe<Scalars["Int"]>;
	coveringFormWaitInterval_GTE?: InputMaybe<Scalars["Int"]>;
	coveringFormWaitInterval_LT?: InputMaybe<Scalars["Int"]>;
	coveringFormWaitInterval_LTE?: InputMaybe<Scalars["Int"]>;
	coveringFormWaitInterval_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	coveringFormWaitInterval_MAX_GT?: InputMaybe<Scalars["Int"]>;
	coveringFormWaitInterval_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	coveringFormWaitInterval_MAX_LT?: InputMaybe<Scalars["Int"]>;
	coveringFormWaitInterval_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	coveringFormWaitInterval_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	coveringFormWaitInterval_MIN_GT?: InputMaybe<Scalars["Int"]>;
	coveringFormWaitInterval_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	coveringFormWaitInterval_MIN_LT?: InputMaybe<Scalars["Int"]>;
	coveringFormWaitInterval_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	createdOn_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_GT?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_GTE?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_LT?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_LTE?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	formattedAmount_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	formattedAmount_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	formattedAmount_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	formattedAmount_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	formattedAmount_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	formattedAmount_EQUAL?: InputMaybe<Scalars["String"]>;
	formattedAmount_GT?: InputMaybe<Scalars["Int"]>;
	formattedAmount_GTE?: InputMaybe<Scalars["Int"]>;
	formattedAmount_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedAmount_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedAmount_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedAmount_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedAmount_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	formattedAmount_LT?: InputMaybe<Scalars["Int"]>;
	formattedAmount_LTE?: InputMaybe<Scalars["Int"]>;
	formattedAmount_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedAmount_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedAmount_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedAmount_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedAmount_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	formattedCounterparties_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	formattedCounterparties_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	formattedCounterparties_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	formattedCounterparties_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	formattedCounterparties_EQUAL?: InputMaybe<Scalars["String"]>;
	formattedCounterparties_GT?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_GTE?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_LT?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_LTE?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	formattedProducts_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	formattedProducts_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	formattedProducts_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	formattedProducts_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	formattedProducts_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	formattedProducts_EQUAL?: InputMaybe<Scalars["String"]>;
	formattedProducts_GT?: InputMaybe<Scalars["Int"]>;
	formattedProducts_GTE?: InputMaybe<Scalars["Int"]>;
	formattedProducts_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedProducts_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedProducts_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedProducts_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedProducts_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	formattedProducts_LT?: InputMaybe<Scalars["Int"]>;
	formattedProducts_LTE?: InputMaybe<Scalars["Int"]>;
	formattedProducts_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedProducts_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedProducts_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedProducts_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedProducts_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	formattedTags_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	formattedTags_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	formattedTags_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	formattedTags_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	formattedTags_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	formattedTags_EQUAL?: InputMaybe<Scalars["String"]>;
	formattedTags_GT?: InputMaybe<Scalars["Int"]>;
	formattedTags_GTE?: InputMaybe<Scalars["Int"]>;
	formattedTags_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedTags_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedTags_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedTags_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedTags_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	formattedTags_LT?: InputMaybe<Scalars["Int"]>;
	formattedTags_LTE?: InputMaybe<Scalars["Int"]>;
	formattedTags_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedTags_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedTags_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedTags_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedTags_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	formattedValidityPeriod_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	formattedValidityPeriod_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	formattedValidityPeriod_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	formattedValidityPeriod_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	formattedValidityPeriod_EQUAL?: InputMaybe<Scalars["String"]>;
	formattedValidityPeriod_GT?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_GTE?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_LT?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_LTE?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	initialVersionId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	initialVersionId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	initialVersionId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	initialVersionId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	initialVersionId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	initialVersionId_EQUAL?: InputMaybe<Scalars["String"]>;
	initialVersionId_GT?: InputMaybe<Scalars["Int"]>;
	initialVersionId_GTE?: InputMaybe<Scalars["Int"]>;
	initialVersionId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	initialVersionId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	initialVersionId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	initialVersionId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	initialVersionId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	initialVersionId_LT?: InputMaybe<Scalars["Int"]>;
	initialVersionId_LTE?: InputMaybe<Scalars["Int"]>;
	initialVersionId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	initialVersionId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	initialVersionId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	initialVersionId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	initialVersionId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	lastExecutionDate_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_GT?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_LT?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_LTE?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	name_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	name_EQUAL?: InputMaybe<Scalars["String"]>;
	name_GT?: InputMaybe<Scalars["Int"]>;
	name_GTE?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	name_LT?: InputMaybe<Scalars["Int"]>;
	name_LTE?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	pushedOn_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	pushedOn_GT?: InputMaybe<Scalars["DateTime"]>;
	pushedOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	pushedOn_LT?: InputMaybe<Scalars["DateTime"]>;
	pushedOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	pushedOn_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	pushedOn_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	pushedOn_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	pushedOn_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	pushedOn_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	pushedOn_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	pushedOn_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	pushedOn_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	pushedOn_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	pushedOn_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	version_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	version_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	version_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	version_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	version_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	version_EQUAL?: InputMaybe<Scalars["Int"]>;
	version_GT?: InputMaybe<Scalars["Int"]>;
	version_GTE?: InputMaybe<Scalars["Int"]>;
	version_LT?: InputMaybe<Scalars["Int"]>;
	version_LTE?: InputMaybe<Scalars["Int"]>;
	version_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	version_MAX_GT?: InputMaybe<Scalars["Int"]>;
	version_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	version_MAX_LT?: InputMaybe<Scalars["Int"]>;
	version_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	version_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	version_MIN_GT?: InputMaybe<Scalars["Int"]>;
	version_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	version_MIN_LT?: InputMaybe<Scalars["Int"]>;
	version_MIN_LTE?: InputMaybe<Scalars["Int"]>;
};

export type BaseAgreementNextVersionsRelationship = {
	__typename?: "BaseAgreementNextVersionsRelationship";
	cursor: Scalars["String"];
	node: BaseAgreement;
};

export type BaseAgreementNextVersionsUpdateConnectionInput = {
	node?: InputMaybe<BaseAgreementUpdateInput>;
};

export type BaseAgreementNextVersionsUpdateFieldInput = {
	connect?: InputMaybe<Array<BaseAgreementNextVersionsConnectFieldInput>>;
	create?: InputMaybe<Array<BaseAgreementNextVersionsCreateFieldInput>>;
	delete?: InputMaybe<Array<BaseAgreementNextVersionsDeleteFieldInput>>;
	disconnect?: InputMaybe<Array<BaseAgreementNextVersionsDisconnectFieldInput>>;
	update?: InputMaybe<BaseAgreementNextVersionsUpdateConnectionInput>;
	where?: InputMaybe<BaseAgreementNextVersionsConnectionWhere>;
};

export type BaseAgreementOptions = {
	limit?: InputMaybe<Scalars["Int"]>;
	offset?: InputMaybe<Scalars["Int"]>;
	/** Specify one or more BaseAgreementSort objects to sort BaseAgreements by. The sorts will be applied in the order in which they are arranged in the array. */
	sort?: InputMaybe<Array<InputMaybe<BaseAgreementSort>>>;
};

export type BaseAgreementProcessedDeviceRecordsAggregateInput = {
	AND?: InputMaybe<Array<BaseAgreementProcessedDeviceRecordsAggregateInput>>;
	OR?: InputMaybe<Array<BaseAgreementProcessedDeviceRecordsAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
};

export type BaseAgreementProcessedDeviceRecordsConnectFieldInput = {
	connect?: InputMaybe<Array<ProcessedDeviceRecordConnectInput>>;
	where?: InputMaybe<ProcessedDeviceRecordConnectWhere>;
};

export type BaseAgreementProcessedDeviceRecordsConnection = {
	__typename?: "BaseAgreementProcessedDeviceRecordsConnection";
	edges: Array<BaseAgreementProcessedDeviceRecordsRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type BaseAgreementProcessedDeviceRecordsConnectionSort = {
	node?: InputMaybe<ProcessedDeviceRecordSort>;
};

export type BaseAgreementProcessedDeviceRecordsConnectionWhere = {
	AND?: InputMaybe<Array<BaseAgreementProcessedDeviceRecordsConnectionWhere>>;
	OR?: InputMaybe<Array<BaseAgreementProcessedDeviceRecordsConnectionWhere>>;
	node?: InputMaybe<ProcessedDeviceRecordWhere>;
	node_NOT?: InputMaybe<ProcessedDeviceRecordWhere>;
};

export type BaseAgreementProcessedDeviceRecordsCreateFieldInput = {
	node: ProcessedDeviceRecordCreateInput;
};

export type BaseAgreementProcessedDeviceRecordsDeleteFieldInput = {
	delete?: InputMaybe<ProcessedDeviceRecordDeleteInput>;
	where?: InputMaybe<BaseAgreementProcessedDeviceRecordsConnectionWhere>;
};

export type BaseAgreementProcessedDeviceRecordsDisconnectFieldInput = {
	disconnect?: InputMaybe<ProcessedDeviceRecordDisconnectInput>;
	where?: InputMaybe<BaseAgreementProcessedDeviceRecordsConnectionWhere>;
};

export type BaseAgreementProcessedDeviceRecordsFieldInput = {
	connect?: InputMaybe<Array<BaseAgreementProcessedDeviceRecordsConnectFieldInput>>;
	create?: InputMaybe<Array<BaseAgreementProcessedDeviceRecordsCreateFieldInput>>;
};

export type BaseAgreementProcessedDeviceRecordsRelationship = {
	__typename?: "BaseAgreementProcessedDeviceRecordsRelationship";
	cursor: Scalars["String"];
	node: ProcessedDeviceRecord;
};

export type BaseAgreementProcessedDeviceRecordsUpdateConnectionInput = {
	node?: InputMaybe<ProcessedDeviceRecordUpdateInput>;
};

export type BaseAgreementProcessedDeviceRecordsUpdateFieldInput = {
	connect?: InputMaybe<Array<BaseAgreementProcessedDeviceRecordsConnectFieldInput>>;
	create?: InputMaybe<Array<BaseAgreementProcessedDeviceRecordsCreateFieldInput>>;
	delete?: InputMaybe<Array<BaseAgreementProcessedDeviceRecordsDeleteFieldInput>>;
	disconnect?: InputMaybe<Array<BaseAgreementProcessedDeviceRecordsDisconnectFieldInput>>;
	update?: InputMaybe<BaseAgreementProcessedDeviceRecordsUpdateConnectionInput>;
	where?: InputMaybe<BaseAgreementProcessedDeviceRecordsConnectionWhere>;
};

export type BaseAgreementPushedByAggregateInput = {
	AND?: InputMaybe<Array<BaseAgreementPushedByAggregateInput>>;
	OR?: InputMaybe<Array<BaseAgreementPushedByAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<BaseAgreementPushedByNodeAggregationWhereInput>;
};

export type BaseAgreementPushedByConnectFieldInput = {
	connect?: InputMaybe<UserConnectInput>;
	where?: InputMaybe<UserConnectWhere>;
};

export type BaseAgreementPushedByConnection = {
	__typename?: "BaseAgreementPushedByConnection";
	edges: Array<BaseAgreementPushedByRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type BaseAgreementPushedByConnectionSort = {
	node?: InputMaybe<UserSort>;
};

export type BaseAgreementPushedByConnectionWhere = {
	AND?: InputMaybe<Array<BaseAgreementPushedByConnectionWhere>>;
	OR?: InputMaybe<Array<BaseAgreementPushedByConnectionWhere>>;
	node?: InputMaybe<UserWhere>;
	node_NOT?: InputMaybe<UserWhere>;
};

export type BaseAgreementPushedByCreateFieldInput = {
	node: UserCreateInput;
};

export type BaseAgreementPushedByDeleteFieldInput = {
	delete?: InputMaybe<UserDeleteInput>;
	where?: InputMaybe<BaseAgreementPushedByConnectionWhere>;
};

export type BaseAgreementPushedByDisconnectFieldInput = {
	disconnect?: InputMaybe<UserDisconnectInput>;
	where?: InputMaybe<BaseAgreementPushedByConnectionWhere>;
};

export type BaseAgreementPushedByFieldInput = {
	connect?: InputMaybe<BaseAgreementPushedByConnectFieldInput>;
	create?: InputMaybe<BaseAgreementPushedByCreateFieldInput>;
};

export type BaseAgreementPushedByNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<BaseAgreementPushedByNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<BaseAgreementPushedByNodeAggregationWhereInput>>;
	email_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	email_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	email_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	email_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	email_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	email_EQUAL?: InputMaybe<Scalars["String"]>;
	email_GT?: InputMaybe<Scalars["Int"]>;
	email_GTE?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	email_LT?: InputMaybe<Scalars["Int"]>;
	email_LTE?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	firstName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	firstName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	firstName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	firstName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	firstName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	firstName_EQUAL?: InputMaybe<Scalars["String"]>;
	firstName_GT?: InputMaybe<Scalars["Int"]>;
	firstName_GTE?: InputMaybe<Scalars["Int"]>;
	firstName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	firstName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	firstName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	firstName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	firstName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	firstName_LT?: InputMaybe<Scalars["Int"]>;
	firstName_LTE?: InputMaybe<Scalars["Int"]>;
	firstName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	firstName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	firstName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	firstName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	firstName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	lastName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	lastName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	lastName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	lastName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	lastName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	lastName_EQUAL?: InputMaybe<Scalars["String"]>;
	lastName_GT?: InputMaybe<Scalars["Int"]>;
	lastName_GTE?: InputMaybe<Scalars["Int"]>;
	lastName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	lastName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	lastName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	lastName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	lastName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	lastName_LT?: InputMaybe<Scalars["Int"]>;
	lastName_LTE?: InputMaybe<Scalars["Int"]>;
	lastName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	lastName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	lastName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	lastName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	lastName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	preferredLanguage_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	preferredLanguage_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	preferredLanguage_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	preferredLanguage_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	preferredLanguage_EQUAL?: InputMaybe<Scalars["String"]>;
	preferredLanguage_GT?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_GTE?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LT?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LTE?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	tenantId_EQUAL?: InputMaybe<Scalars["String"]>;
	tenantId_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type BaseAgreementPushedByRelationship = {
	__typename?: "BaseAgreementPushedByRelationship";
	cursor: Scalars["String"];
	node: User;
};

export type BaseAgreementPushedByUpdateConnectionInput = {
	node?: InputMaybe<UserUpdateInput>;
};

export type BaseAgreementPushedByUpdateFieldInput = {
	connect?: InputMaybe<BaseAgreementPushedByConnectFieldInput>;
	create?: InputMaybe<BaseAgreementPushedByCreateFieldInput>;
	delete?: InputMaybe<BaseAgreementPushedByDeleteFieldInput>;
	disconnect?: InputMaybe<BaseAgreementPushedByDisconnectFieldInput>;
	update?: InputMaybe<BaseAgreementPushedByUpdateConnectionInput>;
	where?: InputMaybe<BaseAgreementPushedByConnectionWhere>;
};

export type BaseAgreementScenariosAggregateInput = {
	AND?: InputMaybe<Array<BaseAgreementScenariosAggregateInput>>;
	OR?: InputMaybe<Array<BaseAgreementScenariosAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<BaseAgreementScenariosNodeAggregationWhereInput>;
};

export type BaseAgreementScenariosConnectFieldInput = {
	connect?: InputMaybe<Array<ScenarioConnectInput>>;
	where?: InputMaybe<ScenarioConnectWhere>;
};

export type BaseAgreementScenariosConnection = {
	__typename?: "BaseAgreementScenariosConnection";
	edges: Array<BaseAgreementScenariosRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type BaseAgreementScenariosConnectionSort = {
	node?: InputMaybe<ScenarioSort>;
};

export type BaseAgreementScenariosConnectionWhere = {
	AND?: InputMaybe<Array<BaseAgreementScenariosConnectionWhere>>;
	OR?: InputMaybe<Array<BaseAgreementScenariosConnectionWhere>>;
	node?: InputMaybe<ScenarioWhere>;
	node_NOT?: InputMaybe<ScenarioWhere>;
};

export type BaseAgreementScenariosCreateFieldInput = {
	node: ScenarioCreateInput;
};

export type BaseAgreementScenariosDeleteFieldInput = {
	delete?: InputMaybe<ScenarioDeleteInput>;
	where?: InputMaybe<BaseAgreementScenariosConnectionWhere>;
};

export type BaseAgreementScenariosDisconnectFieldInput = {
	disconnect?: InputMaybe<ScenarioDisconnectInput>;
	where?: InputMaybe<BaseAgreementScenariosConnectionWhere>;
};

export type BaseAgreementScenariosFieldInput = {
	connect?: InputMaybe<Array<BaseAgreementScenariosConnectFieldInput>>;
	create?: InputMaybe<Array<BaseAgreementScenariosCreateFieldInput>>;
};

export type BaseAgreementScenariosNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<BaseAgreementScenariosNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<BaseAgreementScenariosNodeAggregationWhereInput>>;
	group_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	group_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	group_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	group_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	group_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	group_EQUAL?: InputMaybe<Scalars["Int"]>;
	group_GT?: InputMaybe<Scalars["Int"]>;
	group_GTE?: InputMaybe<Scalars["Int"]>;
	group_LT?: InputMaybe<Scalars["Int"]>;
	group_LTE?: InputMaybe<Scalars["Int"]>;
	group_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	group_MAX_GT?: InputMaybe<Scalars["Int"]>;
	group_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	group_MAX_LT?: InputMaybe<Scalars["Int"]>;
	group_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	group_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	group_MIN_GT?: InputMaybe<Scalars["Int"]>;
	group_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	group_MIN_LT?: InputMaybe<Scalars["Int"]>;
	group_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	order_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	order_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	order_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	order_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	order_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	order_EQUAL?: InputMaybe<Scalars["Int"]>;
	order_GT?: InputMaybe<Scalars["Int"]>;
	order_GTE?: InputMaybe<Scalars["Int"]>;
	order_LT?: InputMaybe<Scalars["Int"]>;
	order_LTE?: InputMaybe<Scalars["Int"]>;
	order_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	order_MAX_GT?: InputMaybe<Scalars["Int"]>;
	order_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	order_MAX_LT?: InputMaybe<Scalars["Int"]>;
	order_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	order_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	order_MIN_GT?: InputMaybe<Scalars["Int"]>;
	order_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	order_MIN_LT?: InputMaybe<Scalars["Int"]>;
	order_MIN_LTE?: InputMaybe<Scalars["Int"]>;
};

export type BaseAgreementScenariosRelationship = {
	__typename?: "BaseAgreementScenariosRelationship";
	cursor: Scalars["String"];
	node: Scenario;
};

export type BaseAgreementScenariosUpdateConnectionInput = {
	node?: InputMaybe<ScenarioUpdateInput>;
};

export type BaseAgreementScenariosUpdateFieldInput = {
	connect?: InputMaybe<Array<BaseAgreementScenariosConnectFieldInput>>;
	create?: InputMaybe<Array<BaseAgreementScenariosCreateFieldInput>>;
	delete?: InputMaybe<Array<BaseAgreementScenariosDeleteFieldInput>>;
	disconnect?: InputMaybe<Array<BaseAgreementScenariosDisconnectFieldInput>>;
	update?: InputMaybe<BaseAgreementScenariosUpdateConnectionInput>;
	where?: InputMaybe<BaseAgreementScenariosConnectionWhere>;
};

/** Fields to sort BaseAgreements by. The order in which sorts are applied is not guaranteed when specifying many fields in one BaseAgreementSort object. */
export type BaseAgreementSort = {
	coveringFormWaitInterval?: InputMaybe<SortDirection>;
	createdOn?: InputMaybe<SortDirection>;
	firstExecutionDate?: InputMaybe<SortDirection>;
	formattedAmount?: InputMaybe<SortDirection>;
	formattedCounterparties?: InputMaybe<SortDirection>;
	formattedProducts?: InputMaybe<SortDirection>;
	formattedTags?: InputMaybe<SortDirection>;
	formattedValidityPeriod?: InputMaybe<SortDirection>;
	id?: InputMaybe<SortDirection>;
	initialVersionId?: InputMaybe<SortDirection>;
	isAllowedFormsEnabled?: InputMaybe<SortDirection>;
	isAllowedRecordsEnabled?: InputMaybe<SortDirection>;
	isCoveringIntervalEnabled?: InputMaybe<SortDirection>;
	isDeleted?: InputMaybe<SortDirection>;
	isExtended?: InputMaybe<SortDirection>;
	isFirstVersion?: InputMaybe<SortDirection>;
	isHidden?: InputMaybe<SortDirection>;
	isInsightsAvailable?: InputMaybe<SortDirection>;
	isLastVersion?: InputMaybe<SortDirection>;
	isRatingEnabled?: InputMaybe<SortDirection>;
	isRequiredFormsEnabled?: InputMaybe<SortDirection>;
	isRequiredRecordsEnabled?: InputMaybe<SortDirection>;
	isTherapyDecisionEnabled?: InputMaybe<SortDirection>;
	lastExecutionDate?: InputMaybe<SortDirection>;
	name?: InputMaybe<SortDirection>;
	pushedOn?: InputMaybe<SortDirection>;
	status?: InputMaybe<SortDirection>;
	subjectMatter?: InputMaybe<SortDirection>;
	validFromDate?: InputMaybe<SortDirection>;
	validToDate?: InputMaybe<SortDirection>;
	version?: InputMaybe<SortDirection>;
};

export type BaseAgreementStatusTransitionsAggregateInput = {
	AND?: InputMaybe<Array<BaseAgreementStatusTransitionsAggregateInput>>;
	OR?: InputMaybe<Array<BaseAgreementStatusTransitionsAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<BaseAgreementStatusTransitionsNodeAggregationWhereInput>;
};

export type BaseAgreementStatusTransitionsConnectFieldInput = {
	connect?: InputMaybe<Array<AgreementStatusTransitionConnectInput>>;
	where?: InputMaybe<AgreementStatusTransitionConnectWhere>;
};

export type BaseAgreementStatusTransitionsConnection = {
	__typename?: "BaseAgreementStatusTransitionsConnection";
	edges: Array<BaseAgreementStatusTransitionsRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type BaseAgreementStatusTransitionsConnectionSort = {
	node?: InputMaybe<AgreementStatusTransitionSort>;
};

export type BaseAgreementStatusTransitionsConnectionWhere = {
	AND?: InputMaybe<Array<BaseAgreementStatusTransitionsConnectionWhere>>;
	OR?: InputMaybe<Array<BaseAgreementStatusTransitionsConnectionWhere>>;
	node?: InputMaybe<AgreementStatusTransitionWhere>;
	node_NOT?: InputMaybe<AgreementStatusTransitionWhere>;
};

export type BaseAgreementStatusTransitionsCreateFieldInput = {
	node: AgreementStatusTransitionCreateInput;
};

export type BaseAgreementStatusTransitionsDeleteFieldInput = {
	delete?: InputMaybe<AgreementStatusTransitionDeleteInput>;
	where?: InputMaybe<BaseAgreementStatusTransitionsConnectionWhere>;
};

export type BaseAgreementStatusTransitionsDisconnectFieldInput = {
	disconnect?: InputMaybe<AgreementStatusTransitionDisconnectInput>;
	where?: InputMaybe<BaseAgreementStatusTransitionsConnectionWhere>;
};

export type BaseAgreementStatusTransitionsFieldInput = {
	connect?: InputMaybe<Array<BaseAgreementStatusTransitionsConnectFieldInput>>;
	create?: InputMaybe<Array<BaseAgreementStatusTransitionsCreateFieldInput>>;
};

export type BaseAgreementStatusTransitionsNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<BaseAgreementStatusTransitionsNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<BaseAgreementStatusTransitionsNodeAggregationWhereInput>>;
	createdOn_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
};

export type BaseAgreementStatusTransitionsRelationship = {
	__typename?: "BaseAgreementStatusTransitionsRelationship";
	cursor: Scalars["String"];
	node: AgreementStatusTransition;
};

export type BaseAgreementStatusTransitionsUpdateConnectionInput = {
	node?: InputMaybe<AgreementStatusTransitionUpdateInput>;
};

export type BaseAgreementStatusTransitionsUpdateFieldInput = {
	connect?: InputMaybe<Array<BaseAgreementStatusTransitionsConnectFieldInput>>;
	create?: InputMaybe<Array<BaseAgreementStatusTransitionsCreateFieldInput>>;
	delete?: InputMaybe<Array<BaseAgreementStatusTransitionsDeleteFieldInput>>;
	disconnect?: InputMaybe<Array<BaseAgreementStatusTransitionsDisconnectFieldInput>>;
	update?: InputMaybe<BaseAgreementStatusTransitionsUpdateConnectionInput>;
	where?: InputMaybe<BaseAgreementStatusTransitionsConnectionWhere>;
};

export type BaseAgreementTagsAggregateInput = {
	AND?: InputMaybe<Array<BaseAgreementTagsAggregateInput>>;
	OR?: InputMaybe<Array<BaseAgreementTagsAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<BaseAgreementTagsNodeAggregationWhereInput>;
};

export type BaseAgreementTagsConnectFieldInput = {
	connect?: InputMaybe<Array<AgreementTagConnectInput>>;
	where?: InputMaybe<AgreementTagConnectWhere>;
};

export type BaseAgreementTagsConnection = {
	__typename?: "BaseAgreementTagsConnection";
	edges: Array<BaseAgreementTagsRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type BaseAgreementTagsConnectionSort = {
	node?: InputMaybe<AgreementTagSort>;
};

export type BaseAgreementTagsConnectionWhere = {
	AND?: InputMaybe<Array<BaseAgreementTagsConnectionWhere>>;
	OR?: InputMaybe<Array<BaseAgreementTagsConnectionWhere>>;
	node?: InputMaybe<AgreementTagWhere>;
	node_NOT?: InputMaybe<AgreementTagWhere>;
};

export type BaseAgreementTagsCreateFieldInput = {
	node: AgreementTagCreateInput;
};

export type BaseAgreementTagsDeleteFieldInput = {
	delete?: InputMaybe<AgreementTagDeleteInput>;
	where?: InputMaybe<BaseAgreementTagsConnectionWhere>;
};

export type BaseAgreementTagsDisconnectFieldInput = {
	disconnect?: InputMaybe<AgreementTagDisconnectInput>;
	where?: InputMaybe<BaseAgreementTagsConnectionWhere>;
};

export type BaseAgreementTagsFieldInput = {
	connect?: InputMaybe<Array<BaseAgreementTagsConnectFieldInput>>;
	create?: InputMaybe<Array<BaseAgreementTagsCreateFieldInput>>;
};

export type BaseAgreementTagsNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<BaseAgreementTagsNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<BaseAgreementTagsNodeAggregationWhereInput>>;
	id_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	id_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	id_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	id_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	id_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	id_EQUAL?: InputMaybe<Scalars["Int"]>;
	id_GT?: InputMaybe<Scalars["Int"]>;
	id_GTE?: InputMaybe<Scalars["Int"]>;
	id_LT?: InputMaybe<Scalars["Int"]>;
	id_LTE?: InputMaybe<Scalars["Int"]>;
	id_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	id_MAX_GT?: InputMaybe<Scalars["Int"]>;
	id_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	id_MAX_LT?: InputMaybe<Scalars["Int"]>;
	id_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	id_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	id_MIN_GT?: InputMaybe<Scalars["Int"]>;
	id_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	id_MIN_LT?: InputMaybe<Scalars["Int"]>;
	id_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	name_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	name_EQUAL?: InputMaybe<Scalars["String"]>;
	name_GT?: InputMaybe<Scalars["Int"]>;
	name_GTE?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	name_LT?: InputMaybe<Scalars["Int"]>;
	name_LTE?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type BaseAgreementTagsRelationship = {
	__typename?: "BaseAgreementTagsRelationship";
	cursor: Scalars["String"];
	node: AgreementTag;
};

export type BaseAgreementTagsUpdateConnectionInput = {
	node?: InputMaybe<AgreementTagUpdateInput>;
};

export type BaseAgreementTagsUpdateFieldInput = {
	connect?: InputMaybe<Array<BaseAgreementTagsConnectFieldInput>>;
	create?: InputMaybe<Array<BaseAgreementTagsCreateFieldInput>>;
	delete?: InputMaybe<Array<BaseAgreementTagsDeleteFieldInput>>;
	disconnect?: InputMaybe<Array<BaseAgreementTagsDisconnectFieldInput>>;
	update?: InputMaybe<BaseAgreementTagsUpdateConnectionInput>;
	where?: InputMaybe<BaseAgreementTagsConnectionWhere>;
};

export type BaseAgreementTreatmentPriceRelationship = {
	price: Scalars["Float"];
};

export type BaseAgreementTreatmentPriceRelationshipCreateInput = {
	price: Scalars["Float"];
};

export type BaseAgreementTreatmentPriceRelationshipSort = {
	price?: InputMaybe<SortDirection>;
};

export type BaseAgreementTreatmentPriceRelationshipUpdateInput = {
	price?: InputMaybe<Scalars["Float"]>;
};

export type BaseAgreementTreatmentPriceRelationshipWhere = {
	AND?: InputMaybe<Array<BaseAgreementTreatmentPriceRelationshipWhere>>;
	OR?: InputMaybe<Array<BaseAgreementTreatmentPriceRelationshipWhere>>;
	price?: InputMaybe<Scalars["Float"]>;
	price_GT?: InputMaybe<Scalars["Float"]>;
	price_GTE?: InputMaybe<Scalars["Float"]>;
	price_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	price_LT?: InputMaybe<Scalars["Float"]>;
	price_LTE?: InputMaybe<Scalars["Float"]>;
	price_NOT?: InputMaybe<Scalars["Float"]>;
	price_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
};

export type BaseAgreementTreatmentPricesAggregateInput = {
	AND?: InputMaybe<Array<BaseAgreementTreatmentPricesAggregateInput>>;
	OR?: InputMaybe<Array<BaseAgreementTreatmentPricesAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	edge?: InputMaybe<BaseAgreementTreatmentPricesEdgeAggregationWhereInput>;
	node?: InputMaybe<BaseAgreementTreatmentPricesNodeAggregationWhereInput>;
};

export type BaseAgreementTreatmentPricesConnectFieldInput = {
	connect?: InputMaybe<Array<TreatmentConnectInput>>;
	edge: BaseAgreementTreatmentPriceRelationshipCreateInput;
	where?: InputMaybe<TreatmentConnectWhere>;
};

export type BaseAgreementTreatmentPricesConnection = {
	__typename?: "BaseAgreementTreatmentPricesConnection";
	edges: Array<BaseAgreementTreatmentPricesRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type BaseAgreementTreatmentPricesConnectionSort = {
	edge?: InputMaybe<BaseAgreementTreatmentPriceRelationshipSort>;
	node?: InputMaybe<TreatmentSort>;
};

export type BaseAgreementTreatmentPricesConnectionWhere = {
	AND?: InputMaybe<Array<BaseAgreementTreatmentPricesConnectionWhere>>;
	OR?: InputMaybe<Array<BaseAgreementTreatmentPricesConnectionWhere>>;
	edge?: InputMaybe<BaseAgreementTreatmentPriceRelationshipWhere>;
	edge_NOT?: InputMaybe<BaseAgreementTreatmentPriceRelationshipWhere>;
	node?: InputMaybe<TreatmentWhere>;
	node_NOT?: InputMaybe<TreatmentWhere>;
};

export type BaseAgreementTreatmentPricesCreateFieldInput = {
	edge: BaseAgreementTreatmentPriceRelationshipCreateInput;
	node: TreatmentCreateInput;
};

export type BaseAgreementTreatmentPricesDeleteFieldInput = {
	delete?: InputMaybe<TreatmentDeleteInput>;
	where?: InputMaybe<BaseAgreementTreatmentPricesConnectionWhere>;
};

export type BaseAgreementTreatmentPricesDisconnectFieldInput = {
	disconnect?: InputMaybe<TreatmentDisconnectInput>;
	where?: InputMaybe<BaseAgreementTreatmentPricesConnectionWhere>;
};

export type BaseAgreementTreatmentPricesEdgeAggregationWhereInput = {
	AND?: InputMaybe<Array<BaseAgreementTreatmentPricesEdgeAggregationWhereInput>>;
	OR?: InputMaybe<Array<BaseAgreementTreatmentPricesEdgeAggregationWhereInput>>;
	price_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	price_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	price_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	price_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	price_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	price_EQUAL?: InputMaybe<Scalars["Float"]>;
	price_GT?: InputMaybe<Scalars["Float"]>;
	price_GTE?: InputMaybe<Scalars["Float"]>;
	price_LT?: InputMaybe<Scalars["Float"]>;
	price_LTE?: InputMaybe<Scalars["Float"]>;
	price_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	price_MAX_GT?: InputMaybe<Scalars["Float"]>;
	price_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	price_MAX_LT?: InputMaybe<Scalars["Float"]>;
	price_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	price_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	price_MIN_GT?: InputMaybe<Scalars["Float"]>;
	price_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	price_MIN_LT?: InputMaybe<Scalars["Float"]>;
	price_MIN_LTE?: InputMaybe<Scalars["Float"]>;
};

export type BaseAgreementTreatmentPricesFieldInput = {
	connect?: InputMaybe<Array<BaseAgreementTreatmentPricesConnectFieldInput>>;
	create?: InputMaybe<Array<BaseAgreementTreatmentPricesCreateFieldInput>>;
};

export type BaseAgreementTreatmentPricesNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<BaseAgreementTreatmentPricesNodeAggregationWhereInput>>;
	BagDossierNo_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	BagDossierNo_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	BagDossierNo_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	BagDossierNo_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	BagDossierNo_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	BagDossierNo_EQUAL?: InputMaybe<Scalars["String"]>;
	BagDossierNo_GT?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_GTE?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LT?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LTE?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	Code_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	Code_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	Code_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	Code_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	Code_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	Code_EQUAL?: InputMaybe<Scalars["String"]>;
	Code_GT?: InputMaybe<Scalars["Int"]>;
	Code_GTE?: InputMaybe<Scalars["Int"]>;
	Code_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Code_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	Code_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	Code_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	Code_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	Code_LT?: InputMaybe<Scalars["Int"]>;
	Code_LTE?: InputMaybe<Scalars["Int"]>;
	Code_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Code_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	Code_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	Code_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	Code_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	FlagModal_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	FlagModal_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	FlagModal_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	FlagModal_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	FlagModal_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	FlagModal_EQUAL?: InputMaybe<Scalars["String"]>;
	FlagModal_GT?: InputMaybe<Scalars["Int"]>;
	FlagModal_GTE?: InputMaybe<Scalars["Int"]>;
	FlagModal_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	FlagModal_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	FlagModal_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	FlagModal_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	FlagModal_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	FlagModal_LT?: InputMaybe<Scalars["Int"]>;
	FlagModal_LTE?: InputMaybe<Scalars["Int"]>;
	FlagModal_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	FlagModal_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	FlagModal_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	FlagModal_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	FlagModal_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	FlagNarcosis_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	FlagNarcosis_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	FlagNarcosis_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	FlagNarcosis_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	FlagNarcosis_EQUAL?: InputMaybe<Scalars["String"]>;
	FlagNarcosis_GT?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_GTE?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LT?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LTE?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	GTIN_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	GTIN_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	GTIN_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	GTIN_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	GTIN_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	GTIN_EQUAL?: InputMaybe<Scalars["String"]>;
	GTIN_GT?: InputMaybe<Scalars["Int"]>;
	GTIN_GTE?: InputMaybe<Scalars["Int"]>;
	GTIN_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	GTIN_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	GTIN_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	GTIN_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	GTIN_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	GTIN_LT?: InputMaybe<Scalars["Int"]>;
	GTIN_LTE?: InputMaybe<Scalars["Int"]>;
	GTIN_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	GTIN_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	GTIN_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	GTIN_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	GTIN_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	LOT_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	LOT_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	LOT_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	LOT_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	LOT_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	LOT_EQUAL?: InputMaybe<Scalars["String"]>;
	LOT_GT?: InputMaybe<Scalars["Int"]>;
	LOT_GTE?: InputMaybe<Scalars["Int"]>;
	LOT_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	LOT_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	LOT_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	LOT_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	LOT_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	LOT_LT?: InputMaybe<Scalars["Int"]>;
	LOT_LTE?: InputMaybe<Scalars["Int"]>;
	LOT_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	LOT_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	LOT_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	LOT_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	LOT_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	Name_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	Name_EQUAL?: InputMaybe<Scalars["String"]>;
	Name_GT?: InputMaybe<Scalars["Int"]>;
	Name_GTE?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	Name_LT?: InputMaybe<Scalars["Int"]>;
	Name_LTE?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	OR?: InputMaybe<Array<BaseAgreementTreatmentPricesNodeAggregationWhereInput>>;
	PharmaCode_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	PharmaCode_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	PharmaCode_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	PharmaCode_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	PharmaCode_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	PharmaCode_EQUAL?: InputMaybe<Scalars["String"]>;
	PharmaCode_GT?: InputMaybe<Scalars["Int"]>;
	PharmaCode_GTE?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LT?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LTE?: InputMaybe<Scalars["Int"]>;
	PharmaCode_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	PharmaCode_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	PharmaCode_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	PharmaCode_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	PharmaCode_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	PrevPharmacode_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	PrevPharmacode_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	PrevPharmacode_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	PrevPharmacode_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	PrevPharmacode_EQUAL?: InputMaybe<Scalars["String"]>;
	PrevPharmacode_GT?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_GTE?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LT?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LTE?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	REF_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	REF_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	REF_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	REF_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	REF_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	REF_EQUAL?: InputMaybe<Scalars["String"]>;
	REF_GT?: InputMaybe<Scalars["Int"]>;
	REF_GTE?: InputMaybe<Scalars["Int"]>;
	REF_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	REF_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	REF_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	REF_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	REF_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	REF_LT?: InputMaybe<Scalars["Int"]>;
	REF_LTE?: InputMaybe<Scalars["Int"]>;
	REF_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	REF_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	REF_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	REF_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	REF_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	SwissmedicCategory_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	SwissmedicCategory_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	SwissmedicCategory_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	SwissmedicCategory_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	SwissmedicCategory_EQUAL?: InputMaybe<Scalars["String"]>;
	SwissmedicCategory_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo8_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo8_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo8_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo8_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo8_EQUAL?: InputMaybe<Scalars["String"]>;
	SwissmedicNo8_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	UDI_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	UDI_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	UDI_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	UDI_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	UDI_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	UDI_EQUAL?: InputMaybe<Scalars["String"]>;
	UDI_GT?: InputMaybe<Scalars["Int"]>;
	UDI_GTE?: InputMaybe<Scalars["Int"]>;
	UDI_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	UDI_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	UDI_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	UDI_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	UDI_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	UDI_LT?: InputMaybe<Scalars["Int"]>;
	UDI_LTE?: InputMaybe<Scalars["Int"]>;
	UDI_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	UDI_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	UDI_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	UDI_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	UDI_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	classificationSystem_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	classificationSystem_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	classificationSystem_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	classificationSystem_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	classificationSystem_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	classificationSystem_EQUAL?: InputMaybe<Scalars["String"]>;
	classificationSystem_GT?: InputMaybe<Scalars["Int"]>;
	classificationSystem_GTE?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LT?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LTE?: InputMaybe<Scalars["Int"]>;
	classificationSystem_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	classificationSystem_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	classificationSystem_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	classificationSystem_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	classificationSystem_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type BaseAgreementTreatmentPricesRelationship = BaseAgreementTreatmentPriceRelationship & {
	__typename?: "BaseAgreementTreatmentPricesRelationship";
	cursor: Scalars["String"];
	node: Treatment;
	price: Scalars["Float"];
};

export type BaseAgreementTreatmentPricesUpdateConnectionInput = {
	edge?: InputMaybe<BaseAgreementTreatmentPriceRelationshipUpdateInput>;
	node?: InputMaybe<TreatmentUpdateInput>;
};

export type BaseAgreementTreatmentPricesUpdateFieldInput = {
	connect?: InputMaybe<Array<BaseAgreementTreatmentPricesConnectFieldInput>>;
	create?: InputMaybe<Array<BaseAgreementTreatmentPricesCreateFieldInput>>;
	delete?: InputMaybe<Array<BaseAgreementTreatmentPricesDeleteFieldInput>>;
	disconnect?: InputMaybe<Array<BaseAgreementTreatmentPricesDisconnectFieldInput>>;
	update?: InputMaybe<BaseAgreementTreatmentPricesUpdateConnectionInput>;
	where?: InputMaybe<BaseAgreementTreatmentPricesConnectionWhere>;
};

export type BaseAgreementUpdateInput = {
	addedBy?: InputMaybe<BaseAgreementAddedByUpdateFieldInput>;
	allowedForms?: InputMaybe<Array<FormType>>;
	allowedRecords?: InputMaybe<Array<RecordType>>;
	categories?: InputMaybe<Array<BaseAgreementCategoriesUpdateFieldInput>>;
	counterparties?: InputMaybe<Array<BaseAgreementCounterpartiesUpdateFieldInput>>;
	coveringFormWaitInterval?: InputMaybe<Scalars["Int"]>;
	createdOn?: InputMaybe<Scalars["DateTime"]>;
	currency?: InputMaybe<BaseAgreementCurrencyUpdateFieldInput>;
	dataContainers?: InputMaybe<Array<BaseAgreementDataContainersUpdateFieldInput>>;
	dataSource?: InputMaybe<BaseAgreementDataSourceUpdateFieldInput>;
	decisions?: InputMaybe<Array<BaseAgreementDecisionsUpdateFieldInput>>;
	deviceAlternativeSets?: InputMaybe<Array<BaseAgreementDeviceAlternativeSetsUpdateFieldInput>>;
	discountCapsCategories?: InputMaybe<Array<BaseAgreementDiscountCapsCategoriesUpdateFieldInput>>;
	discountCapsDeviceKits?: InputMaybe<Array<BaseAgreementDiscountCapsDeviceKitsUpdateFieldInput>>;
	eligibilityConditionSets?: InputMaybe<Array<BaseAgreementEligibilityConditionSetsUpdateFieldInput>>;
	enrollingConditionSets?: InputMaybe<Array<BaseAgreementEnrollingConditionSetsUpdateFieldInput>>;
	enrollingPeriods?: InputMaybe<Array<BaseAgreementEnrollingPeriodsUpdateFieldInput>>;
	financialSummaryConfig?: InputMaybe<Array<BaseAgreementFinancialSummaryConfigUpdateFieldInput>>;
	firstExecutionDate?: InputMaybe<Scalars["DateTime"]>;
	formattedAmount?: InputMaybe<Scalars["String"]>;
	formattedCounterparties?: InputMaybe<Scalars["String"]>;
	formattedProducts?: InputMaybe<Scalars["String"]>;
	formattedTags?: InputMaybe<Scalars["String"]>;
	formattedValidityPeriod?: InputMaybe<Scalars["String"]>;
	id?: InputMaybe<Scalars["ID"]>;
	initialVersion?: InputMaybe<BaseAgreementInitialVersionUpdateFieldInput>;
	initialVersionId?: InputMaybe<Scalars["String"]>;
	isAllowedFormsEnabled?: InputMaybe<Scalars["Boolean"]>;
	isAllowedRecordsEnabled?: InputMaybe<Scalars["Boolean"]>;
	isCoveringIntervalEnabled?: InputMaybe<Scalars["Boolean"]>;
	isDeleted?: InputMaybe<Scalars["Boolean"]>;
	isExtended?: InputMaybe<Scalars["Boolean"]>;
	isFirstVersion?: InputMaybe<Scalars["Boolean"]>;
	isHidden?: InputMaybe<Scalars["Boolean"]>;
	isInsightsAvailable?: InputMaybe<Scalars["Boolean"]>;
	isLastVersion?: InputMaybe<Scalars["Boolean"]>;
	isRatingEnabled?: InputMaybe<Scalars["Boolean"]>;
	isRequiredFormsEnabled?: InputMaybe<Scalars["Boolean"]>;
	isRequiredRecordsEnabled?: InputMaybe<Scalars["Boolean"]>;
	isTherapyDecisionEnabled?: InputMaybe<Scalars["Boolean"]>;
	lastExecutionDate?: InputMaybe<Scalars["DateTime"]>;
	name?: InputMaybe<Scalars["String"]>;
	namedTimeRanges?: InputMaybe<Array<BaseAgreementNamedTimeRangesUpdateFieldInput>>;
	nextVersions?: InputMaybe<Array<BaseAgreementNextVersionsUpdateFieldInput>>;
	processedDeviceRecords?: InputMaybe<Array<BaseAgreementProcessedDeviceRecordsUpdateFieldInput>>;
	pushedBy?: InputMaybe<BaseAgreementPushedByUpdateFieldInput>;
	pushedOn?: InputMaybe<Scalars["DateTime"]>;
	rating?: InputMaybe<Array<CoverageRequestRating>>;
	requiredForms?: InputMaybe<Array<FormType>>;
	requiredRecords?: InputMaybe<Array<RecordType>>;
	scenarios?: InputMaybe<Array<BaseAgreementScenariosUpdateFieldInput>>;
	status?: InputMaybe<ContractStatus>;
	statusTransitions?: InputMaybe<Array<BaseAgreementStatusTransitionsUpdateFieldInput>>;
	subjectMatter?: InputMaybe<AgreementSubjectMatter>;
	tags?: InputMaybe<Array<BaseAgreementTagsUpdateFieldInput>>;
	tenantIds?: InputMaybe<Array<Scalars["String"]>>;
	therapyDecision?: InputMaybe<Array<CoverageRequestTherapyDecision>>;
	treatmentPrices?: InputMaybe<Array<BaseAgreementTreatmentPricesUpdateFieldInput>>;
	userContexts?: InputMaybe<Array<BaseAgreementUserContextsUpdateFieldInput>>;
	userRoles?: InputMaybe<Array<BaseAgreementUserRolesUpdateFieldInput>>;
	validFromDate?: InputMaybe<Scalars["Date"]>;
	validToDate?: InputMaybe<Scalars["Date"]>;
	version?: InputMaybe<Scalars["Int"]>;
};

export type BaseAgreementUserContextsAggregateInput = {
	AND?: InputMaybe<Array<BaseAgreementUserContextsAggregateInput>>;
	OR?: InputMaybe<Array<BaseAgreementUserContextsAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	edge?: InputMaybe<BaseAgreementUserContextsEdgeAggregationWhereInput>;
	node?: InputMaybe<BaseAgreementUserContextsNodeAggregationWhereInput>;
};

export type BaseAgreementUserContextsConnectFieldInput = {
	connect?: InputMaybe<Array<UserContextConnectInput>>;
	edge: ScenarioInsightsUserContextCreateInput;
	where?: InputMaybe<UserContextConnectWhere>;
};

export type BaseAgreementUserContextsConnection = {
	__typename?: "BaseAgreementUserContextsConnection";
	edges: Array<BaseAgreementUserContextsRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type BaseAgreementUserContextsConnectionSort = {
	edge?: InputMaybe<ScenarioInsightsUserContextSort>;
	node?: InputMaybe<UserContextSort>;
};

export type BaseAgreementUserContextsConnectionWhere = {
	AND?: InputMaybe<Array<BaseAgreementUserContextsConnectionWhere>>;
	OR?: InputMaybe<Array<BaseAgreementUserContextsConnectionWhere>>;
	edge?: InputMaybe<ScenarioInsightsUserContextWhere>;
	edge_NOT?: InputMaybe<ScenarioInsightsUserContextWhere>;
	node?: InputMaybe<UserContextWhere>;
	node_NOT?: InputMaybe<UserContextWhere>;
};

export type BaseAgreementUserContextsCreateFieldInput = {
	edge: ScenarioInsightsUserContextCreateInput;
	node: UserContextCreateInput;
};

export type BaseAgreementUserContextsDeleteFieldInput = {
	delete?: InputMaybe<UserContextDeleteInput>;
	where?: InputMaybe<BaseAgreementUserContextsConnectionWhere>;
};

export type BaseAgreementUserContextsDisconnectFieldInput = {
	disconnect?: InputMaybe<UserContextDisconnectInput>;
	where?: InputMaybe<BaseAgreementUserContextsConnectionWhere>;
};

export type BaseAgreementUserContextsEdgeAggregationWhereInput = {
	AND?: InputMaybe<Array<BaseAgreementUserContextsEdgeAggregationWhereInput>>;
	OR?: InputMaybe<Array<BaseAgreementUserContextsEdgeAggregationWhereInput>>;
	categoryInput_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	categoryInput_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	categoryInput_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	categoryInput_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	categoryInput_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	categoryInput_EQUAL?: InputMaybe<Scalars["String"]>;
	categoryInput_GT?: InputMaybe<Scalars["Int"]>;
	categoryInput_GTE?: InputMaybe<Scalars["Int"]>;
	categoryInput_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	categoryInput_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	categoryInput_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	categoryInput_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	categoryInput_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	categoryInput_LT?: InputMaybe<Scalars["Int"]>;
	categoryInput_LTE?: InputMaybe<Scalars["Int"]>;
	categoryInput_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	categoryInput_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	categoryInput_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	categoryInput_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	categoryInput_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	rebateObjective_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	rebateObjective_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	rebateObjective_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	rebateObjective_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	rebateObjective_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	rebateObjective_EQUAL?: InputMaybe<Scalars["String"]>;
	rebateObjective_GT?: InputMaybe<Scalars["Int"]>;
	rebateObjective_GTE?: InputMaybe<Scalars["Int"]>;
	rebateObjective_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	rebateObjective_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	rebateObjective_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	rebateObjective_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	rebateObjective_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	rebateObjective_LT?: InputMaybe<Scalars["Int"]>;
	rebateObjective_LTE?: InputMaybe<Scalars["Int"]>;
	rebateObjective_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	rebateObjective_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	rebateObjective_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	rebateObjective_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	rebateObjective_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	timeframeLabel_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	timeframeLabel_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	timeframeLabel_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	timeframeLabel_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	timeframeLabel_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	timeframeLabel_EQUAL?: InputMaybe<Scalars["String"]>;
	timeframeLabel_GT?: InputMaybe<Scalars["Int"]>;
	timeframeLabel_GTE?: InputMaybe<Scalars["Int"]>;
	timeframeLabel_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	timeframeLabel_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	timeframeLabel_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	timeframeLabel_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	timeframeLabel_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	timeframeLabel_LT?: InputMaybe<Scalars["Int"]>;
	timeframeLabel_LTE?: InputMaybe<Scalars["Int"]>;
	timeframeLabel_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	timeframeLabel_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	timeframeLabel_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	timeframeLabel_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	timeframeLabel_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type BaseAgreementUserContextsFieldInput = {
	connect?: InputMaybe<Array<BaseAgreementUserContextsConnectFieldInput>>;
	create?: InputMaybe<Array<BaseAgreementUserContextsCreateFieldInput>>;
};

export type BaseAgreementUserContextsNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<BaseAgreementUserContextsNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<BaseAgreementUserContextsNodeAggregationWhereInput>>;
	email_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	email_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	email_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	email_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	email_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	email_EQUAL?: InputMaybe<Scalars["String"]>;
	email_GT?: InputMaybe<Scalars["Int"]>;
	email_GTE?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	email_LT?: InputMaybe<Scalars["Int"]>;
	email_LTE?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	filtersAgreements_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	filtersAgreements_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	filtersAgreements_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	filtersAgreements_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	filtersAgreements_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	filtersAgreements_EQUAL?: InputMaybe<Scalars["String"]>;
	filtersAgreements_GT?: InputMaybe<Scalars["Int"]>;
	filtersAgreements_GTE?: InputMaybe<Scalars["Int"]>;
	filtersAgreements_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	filtersAgreements_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	filtersAgreements_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	filtersAgreements_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	filtersAgreements_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	filtersAgreements_LT?: InputMaybe<Scalars["Int"]>;
	filtersAgreements_LTE?: InputMaybe<Scalars["Int"]>;
	filtersAgreements_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	filtersAgreements_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	filtersAgreements_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	filtersAgreements_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	filtersAgreements_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	filtersCases_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	filtersCases_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	filtersCases_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	filtersCases_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	filtersCases_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	filtersCases_EQUAL?: InputMaybe<Scalars["String"]>;
	filtersCases_GT?: InputMaybe<Scalars["Int"]>;
	filtersCases_GTE?: InputMaybe<Scalars["Int"]>;
	filtersCases_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	filtersCases_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	filtersCases_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	filtersCases_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	filtersCases_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	filtersCases_LT?: InputMaybe<Scalars["Int"]>;
	filtersCases_LTE?: InputMaybe<Scalars["Int"]>;
	filtersCases_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	filtersCases_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	filtersCases_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	filtersCases_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	filtersCases_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	filtersDataForms_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	filtersDataForms_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	filtersDataForms_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	filtersDataForms_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	filtersDataForms_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	filtersDataForms_EQUAL?: InputMaybe<Scalars["String"]>;
	filtersDataForms_GT?: InputMaybe<Scalars["Int"]>;
	filtersDataForms_GTE?: InputMaybe<Scalars["Int"]>;
	filtersDataForms_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	filtersDataForms_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	filtersDataForms_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	filtersDataForms_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	filtersDataForms_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	filtersDataForms_LT?: InputMaybe<Scalars["Int"]>;
	filtersDataForms_LTE?: InputMaybe<Scalars["Int"]>;
	filtersDataForms_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	filtersDataForms_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	filtersDataForms_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	filtersDataForms_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	filtersDataForms_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	filtersDataRecords_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	filtersDataRecords_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	filtersDataRecords_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	filtersDataRecords_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	filtersDataRecords_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	filtersDataRecords_EQUAL?: InputMaybe<Scalars["String"]>;
	filtersDataRecords_GT?: InputMaybe<Scalars["Int"]>;
	filtersDataRecords_GTE?: InputMaybe<Scalars["Int"]>;
	filtersDataRecords_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	filtersDataRecords_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	filtersDataRecords_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	filtersDataRecords_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	filtersDataRecords_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	filtersDataRecords_LT?: InputMaybe<Scalars["Int"]>;
	filtersDataRecords_LTE?: InputMaybe<Scalars["Int"]>;
	filtersDataRecords_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	filtersDataRecords_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	filtersDataRecords_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	filtersDataRecords_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	filtersDataRecords_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	filtersDocuments_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	filtersDocuments_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	filtersDocuments_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	filtersDocuments_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	filtersDocuments_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	filtersDocuments_EQUAL?: InputMaybe<Scalars["String"]>;
	filtersDocuments_GT?: InputMaybe<Scalars["Int"]>;
	filtersDocuments_GTE?: InputMaybe<Scalars["Int"]>;
	filtersDocuments_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	filtersDocuments_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	filtersDocuments_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	filtersDocuments_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	filtersDocuments_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	filtersDocuments_LT?: InputMaybe<Scalars["Int"]>;
	filtersDocuments_LTE?: InputMaybe<Scalars["Int"]>;
	filtersDocuments_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	filtersDocuments_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	filtersDocuments_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	filtersDocuments_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	filtersDocuments_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	filtersRefunds_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	filtersRefunds_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	filtersRefunds_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	filtersRefunds_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	filtersRefunds_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	filtersRefunds_EQUAL?: InputMaybe<Scalars["String"]>;
	filtersRefunds_GT?: InputMaybe<Scalars["Int"]>;
	filtersRefunds_GTE?: InputMaybe<Scalars["Int"]>;
	filtersRefunds_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	filtersRefunds_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	filtersRefunds_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	filtersRefunds_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	filtersRefunds_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	filtersRefunds_LT?: InputMaybe<Scalars["Int"]>;
	filtersRefunds_LTE?: InputMaybe<Scalars["Int"]>;
	filtersRefunds_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	filtersRefunds_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	filtersRefunds_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	filtersRefunds_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	filtersRefunds_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type BaseAgreementUserContextsRelationship = ScenarioInsightsUserContext & {
	__typename?: "BaseAgreementUserContextsRelationship";
	categoryInput?: Maybe<Scalars["String"]>;
	cursor: Scalars["String"];
	groups?: Maybe<Array<Maybe<Scalars["Int"]>>>;
	node: UserContext;
	rebateObjective?: Maybe<Scalars["String"]>;
	timeframeLabel: Scalars["String"];
};

export type BaseAgreementUserContextsUpdateConnectionInput = {
	edge?: InputMaybe<ScenarioInsightsUserContextUpdateInput>;
	node?: InputMaybe<UserContextUpdateInput>;
};

export type BaseAgreementUserContextsUpdateFieldInput = {
	connect?: InputMaybe<Array<BaseAgreementUserContextsConnectFieldInput>>;
	create?: InputMaybe<Array<BaseAgreementUserContextsCreateFieldInput>>;
	delete?: InputMaybe<Array<BaseAgreementUserContextsDeleteFieldInput>>;
	disconnect?: InputMaybe<Array<BaseAgreementUserContextsDisconnectFieldInput>>;
	update?: InputMaybe<BaseAgreementUserContextsUpdateConnectionInput>;
	where?: InputMaybe<BaseAgreementUserContextsConnectionWhere>;
};

export type BaseAgreementUserRoleRelationship = {
	canApprove: Scalars["Boolean"];
	canModifyFinancials: Scalars["Boolean"];
	canViewFinancials: Scalars["Boolean"];
	isAssignee?: Maybe<Scalars["Boolean"]>;
	role: AgreementUserRole;
};

export type BaseAgreementUserRoleRelationshipCreateInput = {
	canApprove: Scalars["Boolean"];
	canModifyFinancials: Scalars["Boolean"];
	canViewFinancials: Scalars["Boolean"];
	isAssignee?: InputMaybe<Scalars["Boolean"]>;
	role: AgreementUserRole;
};

export type BaseAgreementUserRoleRelationshipSort = {
	canApprove?: InputMaybe<SortDirection>;
	canModifyFinancials?: InputMaybe<SortDirection>;
	canViewFinancials?: InputMaybe<SortDirection>;
	isAssignee?: InputMaybe<SortDirection>;
	role?: InputMaybe<SortDirection>;
};

export type BaseAgreementUserRoleRelationshipUpdateInput = {
	canApprove?: InputMaybe<Scalars["Boolean"]>;
	canModifyFinancials?: InputMaybe<Scalars["Boolean"]>;
	canViewFinancials?: InputMaybe<Scalars["Boolean"]>;
	isAssignee?: InputMaybe<Scalars["Boolean"]>;
	role?: InputMaybe<AgreementUserRole>;
};

export type BaseAgreementUserRoleRelationshipWhere = {
	AND?: InputMaybe<Array<BaseAgreementUserRoleRelationshipWhere>>;
	OR?: InputMaybe<Array<BaseAgreementUserRoleRelationshipWhere>>;
	canApprove?: InputMaybe<Scalars["Boolean"]>;
	canApprove_NOT?: InputMaybe<Scalars["Boolean"]>;
	canModifyFinancials?: InputMaybe<Scalars["Boolean"]>;
	canModifyFinancials_NOT?: InputMaybe<Scalars["Boolean"]>;
	canViewFinancials?: InputMaybe<Scalars["Boolean"]>;
	canViewFinancials_NOT?: InputMaybe<Scalars["Boolean"]>;
	isAssignee?: InputMaybe<Scalars["Boolean"]>;
	isAssignee_NOT?: InputMaybe<Scalars["Boolean"]>;
	role?: InputMaybe<AgreementUserRole>;
	role_IN?: InputMaybe<Array<InputMaybe<AgreementUserRole>>>;
	role_NOT?: InputMaybe<AgreementUserRole>;
	role_NOT_IN?: InputMaybe<Array<InputMaybe<AgreementUserRole>>>;
};

export type BaseAgreementUserRolesAggregateInput = {
	AND?: InputMaybe<Array<BaseAgreementUserRolesAggregateInput>>;
	OR?: InputMaybe<Array<BaseAgreementUserRolesAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<BaseAgreementUserRolesNodeAggregationWhereInput>;
};

export type BaseAgreementUserRolesConnectFieldInput = {
	connect?: InputMaybe<Array<UserConnectInput>>;
	edge: BaseAgreementUserRoleRelationshipCreateInput;
	where?: InputMaybe<UserConnectWhere>;
};

export type BaseAgreementUserRolesConnection = {
	__typename?: "BaseAgreementUserRolesConnection";
	edges: Array<BaseAgreementUserRolesRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type BaseAgreementUserRolesConnectionSort = {
	edge?: InputMaybe<BaseAgreementUserRoleRelationshipSort>;
	node?: InputMaybe<UserSort>;
};

export type BaseAgreementUserRolesConnectionWhere = {
	AND?: InputMaybe<Array<BaseAgreementUserRolesConnectionWhere>>;
	OR?: InputMaybe<Array<BaseAgreementUserRolesConnectionWhere>>;
	edge?: InputMaybe<BaseAgreementUserRoleRelationshipWhere>;
	edge_NOT?: InputMaybe<BaseAgreementUserRoleRelationshipWhere>;
	node?: InputMaybe<UserWhere>;
	node_NOT?: InputMaybe<UserWhere>;
};

export type BaseAgreementUserRolesCreateFieldInput = {
	edge: BaseAgreementUserRoleRelationshipCreateInput;
	node: UserCreateInput;
};

export type BaseAgreementUserRolesDeleteFieldInput = {
	delete?: InputMaybe<UserDeleteInput>;
	where?: InputMaybe<BaseAgreementUserRolesConnectionWhere>;
};

export type BaseAgreementUserRolesDisconnectFieldInput = {
	disconnect?: InputMaybe<UserDisconnectInput>;
	where?: InputMaybe<BaseAgreementUserRolesConnectionWhere>;
};

export type BaseAgreementUserRolesFieldInput = {
	connect?: InputMaybe<Array<BaseAgreementUserRolesConnectFieldInput>>;
	create?: InputMaybe<Array<BaseAgreementUserRolesCreateFieldInput>>;
};

export type BaseAgreementUserRolesNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<BaseAgreementUserRolesNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<BaseAgreementUserRolesNodeAggregationWhereInput>>;
	email_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	email_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	email_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	email_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	email_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	email_EQUAL?: InputMaybe<Scalars["String"]>;
	email_GT?: InputMaybe<Scalars["Int"]>;
	email_GTE?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	email_LT?: InputMaybe<Scalars["Int"]>;
	email_LTE?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	firstName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	firstName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	firstName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	firstName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	firstName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	firstName_EQUAL?: InputMaybe<Scalars["String"]>;
	firstName_GT?: InputMaybe<Scalars["Int"]>;
	firstName_GTE?: InputMaybe<Scalars["Int"]>;
	firstName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	firstName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	firstName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	firstName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	firstName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	firstName_LT?: InputMaybe<Scalars["Int"]>;
	firstName_LTE?: InputMaybe<Scalars["Int"]>;
	firstName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	firstName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	firstName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	firstName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	firstName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	lastName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	lastName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	lastName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	lastName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	lastName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	lastName_EQUAL?: InputMaybe<Scalars["String"]>;
	lastName_GT?: InputMaybe<Scalars["Int"]>;
	lastName_GTE?: InputMaybe<Scalars["Int"]>;
	lastName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	lastName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	lastName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	lastName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	lastName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	lastName_LT?: InputMaybe<Scalars["Int"]>;
	lastName_LTE?: InputMaybe<Scalars["Int"]>;
	lastName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	lastName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	lastName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	lastName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	lastName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	preferredLanguage_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	preferredLanguage_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	preferredLanguage_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	preferredLanguage_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	preferredLanguage_EQUAL?: InputMaybe<Scalars["String"]>;
	preferredLanguage_GT?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_GTE?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LT?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LTE?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	tenantId_EQUAL?: InputMaybe<Scalars["String"]>;
	tenantId_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type BaseAgreementUserRolesRelationship = BaseAgreementUserRoleRelationship & {
	__typename?: "BaseAgreementUserRolesRelationship";
	canApprove: Scalars["Boolean"];
	canModifyFinancials: Scalars["Boolean"];
	canViewFinancials: Scalars["Boolean"];
	cursor: Scalars["String"];
	isAssignee?: Maybe<Scalars["Boolean"]>;
	node: User;
	role: AgreementUserRole;
};

export type BaseAgreementUserRolesUpdateConnectionInput = {
	edge?: InputMaybe<BaseAgreementUserRoleRelationshipUpdateInput>;
	node?: InputMaybe<UserUpdateInput>;
};

export type BaseAgreementUserRolesUpdateFieldInput = {
	connect?: InputMaybe<Array<BaseAgreementUserRolesConnectFieldInput>>;
	create?: InputMaybe<Array<BaseAgreementUserRolesCreateFieldInput>>;
	delete?: InputMaybe<Array<BaseAgreementUserRolesDeleteFieldInput>>;
	disconnect?: InputMaybe<Array<BaseAgreementUserRolesDisconnectFieldInput>>;
	update?: InputMaybe<BaseAgreementUserRolesUpdateConnectionInput>;
	where?: InputMaybe<BaseAgreementUserRolesConnectionWhere>;
};

export type BaseAgreementWhere = {
	AND?: InputMaybe<Array<BaseAgreementWhere>>;
	OR?: InputMaybe<Array<BaseAgreementWhere>>;
	addedBy?: InputMaybe<UserWhere>;
	addedByAggregate?: InputMaybe<BaseAgreementAddedByAggregateInput>;
	addedByConnection?: InputMaybe<BaseAgreementAddedByConnectionWhere>;
	addedByConnection_NOT?: InputMaybe<BaseAgreementAddedByConnectionWhere>;
	addedBy_NOT?: InputMaybe<UserWhere>;
	allowedForms?: InputMaybe<Array<FormType>>;
	allowedForms_INCLUDES?: InputMaybe<FormType>;
	allowedForms_NOT?: InputMaybe<Array<FormType>>;
	allowedForms_NOT_INCLUDES?: InputMaybe<FormType>;
	allowedRecords?: InputMaybe<Array<RecordType>>;
	allowedRecords_INCLUDES?: InputMaybe<RecordType>;
	allowedRecords_NOT?: InputMaybe<Array<RecordType>>;
	allowedRecords_NOT_INCLUDES?: InputMaybe<RecordType>;
	categories?: InputMaybe<DeviceProductCategoryWhere>;
	categoriesAggregate?: InputMaybe<BaseAgreementCategoriesAggregateInput>;
	categoriesConnection?: InputMaybe<BaseAgreementCategoriesConnectionWhere>;
	categoriesConnection_NOT?: InputMaybe<BaseAgreementCategoriesConnectionWhere>;
	categories_NOT?: InputMaybe<DeviceProductCategoryWhere>;
	counterparties?: InputMaybe<OrganizationWhere>;
	counterpartiesAggregate?: InputMaybe<BaseAgreementCounterpartiesAggregateInput>;
	counterpartiesConnection?: InputMaybe<BaseAgreementCounterpartiesConnectionWhere>;
	counterpartiesConnection_NOT?: InputMaybe<BaseAgreementCounterpartiesConnectionWhere>;
	counterparties_NOT?: InputMaybe<OrganizationWhere>;
	coveringFormWaitInterval?: InputMaybe<Scalars["Int"]>;
	coveringFormWaitInterval_GT?: InputMaybe<Scalars["Int"]>;
	coveringFormWaitInterval_GTE?: InputMaybe<Scalars["Int"]>;
	coveringFormWaitInterval_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	coveringFormWaitInterval_LT?: InputMaybe<Scalars["Int"]>;
	coveringFormWaitInterval_LTE?: InputMaybe<Scalars["Int"]>;
	coveringFormWaitInterval_NOT?: InputMaybe<Scalars["Int"]>;
	coveringFormWaitInterval_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	createdOn?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_IN?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]>>>;
	createdOn_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_NOT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]>>>;
	currency?: InputMaybe<CurrencyWhere>;
	currencyAggregate?: InputMaybe<BaseAgreementCurrencyAggregateInput>;
	currencyConnection?: InputMaybe<BaseAgreementCurrencyConnectionWhere>;
	currencyConnection_NOT?: InputMaybe<BaseAgreementCurrencyConnectionWhere>;
	currency_NOT?: InputMaybe<CurrencyWhere>;
	dataContainers?: InputMaybe<DataContainerWhere>;
	dataContainersAggregate?: InputMaybe<BaseAgreementDataContainersAggregateInput>;
	dataContainersConnection?: InputMaybe<BaseAgreementDataContainersConnectionWhere>;
	dataContainersConnection_NOT?: InputMaybe<BaseAgreementDataContainersConnectionWhere>;
	dataContainers_NOT?: InputMaybe<DataContainerWhere>;
	dataSource?: InputMaybe<DataSourceWhere>;
	dataSourceAggregate?: InputMaybe<BaseAgreementDataSourceAggregateInput>;
	dataSourceConnection?: InputMaybe<BaseAgreementDataSourceConnectionWhere>;
	dataSourceConnection_NOT?: InputMaybe<BaseAgreementDataSourceConnectionWhere>;
	dataSource_NOT?: InputMaybe<DataSourceWhere>;
	decisions?: InputMaybe<AgreementDecisionWhere>;
	decisionsAggregate?: InputMaybe<BaseAgreementDecisionsAggregateInput>;
	decisionsConnection?: InputMaybe<BaseAgreementDecisionsConnectionWhere>;
	decisionsConnection_NOT?: InputMaybe<BaseAgreementDecisionsConnectionWhere>;
	decisions_NOT?: InputMaybe<AgreementDecisionWhere>;
	deviceAlternativeSets?: InputMaybe<DeviceAlternativeWhere>;
	deviceAlternativeSetsAggregate?: InputMaybe<BaseAgreementDeviceAlternativeSetsAggregateInput>;
	deviceAlternativeSetsConnection?: InputMaybe<BaseAgreementDeviceAlternativeSetsConnectionWhere>;
	deviceAlternativeSetsConnection_NOT?: InputMaybe<BaseAgreementDeviceAlternativeSetsConnectionWhere>;
	deviceAlternativeSets_NOT?: InputMaybe<DeviceAlternativeWhere>;
	discountCapsCategories?: InputMaybe<DeviceProductCategoryWhere>;
	discountCapsCategoriesAggregate?: InputMaybe<BaseAgreementDiscountCapsCategoriesAggregateInput>;
	discountCapsCategoriesConnection?: InputMaybe<BaseAgreementDiscountCapsCategoriesConnectionWhere>;
	discountCapsCategoriesConnection_NOT?: InputMaybe<BaseAgreementDiscountCapsCategoriesConnectionWhere>;
	discountCapsCategories_NOT?: InputMaybe<DeviceProductCategoryWhere>;
	discountCapsDeviceKits?: InputMaybe<DeviceKitWhere>;
	discountCapsDeviceKitsAggregate?: InputMaybe<BaseAgreementDiscountCapsDeviceKitsAggregateInput>;
	discountCapsDeviceKitsConnection?: InputMaybe<BaseAgreementDiscountCapsDeviceKitsConnectionWhere>;
	discountCapsDeviceKitsConnection_NOT?: InputMaybe<BaseAgreementDiscountCapsDeviceKitsConnectionWhere>;
	discountCapsDeviceKits_NOT?: InputMaybe<DeviceKitWhere>;
	eligibilityConditionSets?: InputMaybe<EligibilityConditionSetWhere>;
	eligibilityConditionSetsAggregate?: InputMaybe<BaseAgreementEligibilityConditionSetsAggregateInput>;
	eligibilityConditionSetsConnection?: InputMaybe<BaseAgreementEligibilityConditionSetsConnectionWhere>;
	eligibilityConditionSetsConnection_NOT?: InputMaybe<BaseAgreementEligibilityConditionSetsConnectionWhere>;
	eligibilityConditionSets_NOT?: InputMaybe<EligibilityConditionSetWhere>;
	enrollingConditionSets?: InputMaybe<EnrollingConditionSetWhere>;
	enrollingConditionSetsAggregate?: InputMaybe<BaseAgreementEnrollingConditionSetsAggregateInput>;
	enrollingConditionSetsConnection?: InputMaybe<BaseAgreementEnrollingConditionSetsConnectionWhere>;
	enrollingConditionSetsConnection_NOT?: InputMaybe<BaseAgreementEnrollingConditionSetsConnectionWhere>;
	enrollingConditionSets_NOT?: InputMaybe<EnrollingConditionSetWhere>;
	enrollingPeriods?: InputMaybe<EnrollingPeriodWhere>;
	enrollingPeriodsAggregate?: InputMaybe<BaseAgreementEnrollingPeriodsAggregateInput>;
	enrollingPeriodsConnection?: InputMaybe<BaseAgreementEnrollingPeriodsConnectionWhere>;
	enrollingPeriodsConnection_NOT?: InputMaybe<BaseAgreementEnrollingPeriodsConnectionWhere>;
	enrollingPeriods_NOT?: InputMaybe<EnrollingPeriodWhere>;
	financialSummaryConfig?: InputMaybe<FinancialSummaryColumnWhere>;
	financialSummaryConfigAggregate?: InputMaybe<BaseAgreementFinancialSummaryConfigAggregateInput>;
	financialSummaryConfigConnection?: InputMaybe<BaseAgreementFinancialSummaryConfigConnectionWhere>;
	financialSummaryConfigConnection_NOT?: InputMaybe<BaseAgreementFinancialSummaryConfigConnectionWhere>;
	financialSummaryConfig_NOT?: InputMaybe<FinancialSummaryColumnWhere>;
	firstExecutionDate?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_GT?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_GTE?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_IN?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]>>>;
	firstExecutionDate_LT?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_LTE?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_NOT?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]>>>;
	formattedAmount?: InputMaybe<Scalars["String"]>;
	formattedAmount_CONTAINS?: InputMaybe<Scalars["String"]>;
	formattedAmount_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	formattedAmount_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	formattedAmount_MATCHES?: InputMaybe<Scalars["String"]>;
	formattedAmount_NOT?: InputMaybe<Scalars["String"]>;
	formattedAmount_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	formattedAmount_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	formattedAmount_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	formattedAmount_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	formattedAmount_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	formattedCounterparties?: InputMaybe<Scalars["String"]>;
	formattedCounterparties_CONTAINS?: InputMaybe<Scalars["String"]>;
	formattedCounterparties_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	formattedCounterparties_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	formattedCounterparties_MATCHES?: InputMaybe<Scalars["String"]>;
	formattedCounterparties_NOT?: InputMaybe<Scalars["String"]>;
	formattedCounterparties_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	formattedCounterparties_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	formattedCounterparties_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	formattedCounterparties_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	formattedCounterparties_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	formattedProducts?: InputMaybe<Scalars["String"]>;
	formattedProducts_CONTAINS?: InputMaybe<Scalars["String"]>;
	formattedProducts_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	formattedProducts_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	formattedProducts_MATCHES?: InputMaybe<Scalars["String"]>;
	formattedProducts_NOT?: InputMaybe<Scalars["String"]>;
	formattedProducts_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	formattedProducts_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	formattedProducts_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	formattedProducts_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	formattedProducts_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	formattedTags?: InputMaybe<Scalars["String"]>;
	formattedTags_CONTAINS?: InputMaybe<Scalars["String"]>;
	formattedTags_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	formattedTags_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	formattedTags_MATCHES?: InputMaybe<Scalars["String"]>;
	formattedTags_NOT?: InputMaybe<Scalars["String"]>;
	formattedTags_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	formattedTags_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	formattedTags_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	formattedTags_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	formattedTags_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	formattedValidityPeriod?: InputMaybe<Scalars["String"]>;
	formattedValidityPeriod_CONTAINS?: InputMaybe<Scalars["String"]>;
	formattedValidityPeriod_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	formattedValidityPeriod_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	formattedValidityPeriod_MATCHES?: InputMaybe<Scalars["String"]>;
	formattedValidityPeriod_NOT?: InputMaybe<Scalars["String"]>;
	formattedValidityPeriod_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	formattedValidityPeriod_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	formattedValidityPeriod_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	formattedValidityPeriod_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	formattedValidityPeriod_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	id?: InputMaybe<Scalars["ID"]>;
	id_CONTAINS?: InputMaybe<Scalars["ID"]>;
	id_ENDS_WITH?: InputMaybe<Scalars["ID"]>;
	id_IN?: InputMaybe<Array<InputMaybe<Scalars["ID"]>>>;
	id_MATCHES?: InputMaybe<Scalars["String"]>;
	id_NOT?: InputMaybe<Scalars["ID"]>;
	id_NOT_CONTAINS?: InputMaybe<Scalars["ID"]>;
	id_NOT_ENDS_WITH?: InputMaybe<Scalars["ID"]>;
	id_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["ID"]>>>;
	id_NOT_STARTS_WITH?: InputMaybe<Scalars["ID"]>;
	id_STARTS_WITH?: InputMaybe<Scalars["ID"]>;
	initialVersion?: InputMaybe<BaseAgreementWhere>;
	initialVersionAggregate?: InputMaybe<BaseAgreementInitialVersionAggregateInput>;
	initialVersionConnection?: InputMaybe<BaseAgreementInitialVersionConnectionWhere>;
	initialVersionConnection_NOT?: InputMaybe<BaseAgreementInitialVersionConnectionWhere>;
	initialVersionId?: InputMaybe<Scalars["String"]>;
	initialVersionId_CONTAINS?: InputMaybe<Scalars["String"]>;
	initialVersionId_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	initialVersionId_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	initialVersionId_MATCHES?: InputMaybe<Scalars["String"]>;
	initialVersionId_NOT?: InputMaybe<Scalars["String"]>;
	initialVersionId_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	initialVersionId_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	initialVersionId_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	initialVersionId_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	initialVersionId_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	initialVersion_NOT?: InputMaybe<BaseAgreementWhere>;
	isAllowedFormsEnabled?: InputMaybe<Scalars["Boolean"]>;
	isAllowedFormsEnabled_NOT?: InputMaybe<Scalars["Boolean"]>;
	isAllowedRecordsEnabled?: InputMaybe<Scalars["Boolean"]>;
	isAllowedRecordsEnabled_NOT?: InputMaybe<Scalars["Boolean"]>;
	isCoveringIntervalEnabled?: InputMaybe<Scalars["Boolean"]>;
	isCoveringIntervalEnabled_NOT?: InputMaybe<Scalars["Boolean"]>;
	isDeleted?: InputMaybe<Scalars["Boolean"]>;
	isDeleted_NOT?: InputMaybe<Scalars["Boolean"]>;
	isExtended?: InputMaybe<Scalars["Boolean"]>;
	isExtended_NOT?: InputMaybe<Scalars["Boolean"]>;
	isFirstVersion?: InputMaybe<Scalars["Boolean"]>;
	isFirstVersion_NOT?: InputMaybe<Scalars["Boolean"]>;
	isHidden?: InputMaybe<Scalars["Boolean"]>;
	isHidden_NOT?: InputMaybe<Scalars["Boolean"]>;
	isInsightsAvailable?: InputMaybe<Scalars["Boolean"]>;
	isInsightsAvailable_NOT?: InputMaybe<Scalars["Boolean"]>;
	isLastVersion?: InputMaybe<Scalars["Boolean"]>;
	isLastVersion_NOT?: InputMaybe<Scalars["Boolean"]>;
	isRatingEnabled?: InputMaybe<Scalars["Boolean"]>;
	isRatingEnabled_NOT?: InputMaybe<Scalars["Boolean"]>;
	isRequiredFormsEnabled?: InputMaybe<Scalars["Boolean"]>;
	isRequiredFormsEnabled_NOT?: InputMaybe<Scalars["Boolean"]>;
	isRequiredRecordsEnabled?: InputMaybe<Scalars["Boolean"]>;
	isRequiredRecordsEnabled_NOT?: InputMaybe<Scalars["Boolean"]>;
	isTherapyDecisionEnabled?: InputMaybe<Scalars["Boolean"]>;
	isTherapyDecisionEnabled_NOT?: InputMaybe<Scalars["Boolean"]>;
	lastExecutionDate?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_GT?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_IN?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]>>>;
	lastExecutionDate_LT?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_LTE?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_NOT?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]>>>;
	name?: InputMaybe<Scalars["String"]>;
	name_CONTAINS?: InputMaybe<Scalars["String"]>;
	name_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	name_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	name_MATCHES?: InputMaybe<Scalars["String"]>;
	name_NOT?: InputMaybe<Scalars["String"]>;
	name_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	name_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	name_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	name_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	name_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	namedTimeRanges?: InputMaybe<TimeframeWhere>;
	namedTimeRangesAggregate?: InputMaybe<BaseAgreementNamedTimeRangesAggregateInput>;
	namedTimeRangesConnection?: InputMaybe<BaseAgreementNamedTimeRangesConnectionWhere>;
	namedTimeRangesConnection_NOT?: InputMaybe<BaseAgreementNamedTimeRangesConnectionWhere>;
	namedTimeRanges_NOT?: InputMaybe<TimeframeWhere>;
	nextVersions?: InputMaybe<BaseAgreementWhere>;
	nextVersionsAggregate?: InputMaybe<BaseAgreementNextVersionsAggregateInput>;
	nextVersionsConnection?: InputMaybe<BaseAgreementNextVersionsConnectionWhere>;
	nextVersionsConnection_NOT?: InputMaybe<BaseAgreementNextVersionsConnectionWhere>;
	nextVersions_NOT?: InputMaybe<BaseAgreementWhere>;
	processedDeviceRecords?: InputMaybe<ProcessedDeviceRecordWhere>;
	processedDeviceRecordsAggregate?: InputMaybe<BaseAgreementProcessedDeviceRecordsAggregateInput>;
	processedDeviceRecordsConnection?: InputMaybe<BaseAgreementProcessedDeviceRecordsConnectionWhere>;
	processedDeviceRecordsConnection_NOT?: InputMaybe<BaseAgreementProcessedDeviceRecordsConnectionWhere>;
	processedDeviceRecords_NOT?: InputMaybe<ProcessedDeviceRecordWhere>;
	pushedBy?: InputMaybe<UserWhere>;
	pushedByAggregate?: InputMaybe<BaseAgreementPushedByAggregateInput>;
	pushedByConnection?: InputMaybe<BaseAgreementPushedByConnectionWhere>;
	pushedByConnection_NOT?: InputMaybe<BaseAgreementPushedByConnectionWhere>;
	pushedBy_NOT?: InputMaybe<UserWhere>;
	pushedOn?: InputMaybe<Scalars["DateTime"]>;
	pushedOn_GT?: InputMaybe<Scalars["DateTime"]>;
	pushedOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	pushedOn_IN?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]>>>;
	pushedOn_LT?: InputMaybe<Scalars["DateTime"]>;
	pushedOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	pushedOn_NOT?: InputMaybe<Scalars["DateTime"]>;
	pushedOn_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]>>>;
	rating?: InputMaybe<Array<CoverageRequestRating>>;
	rating_INCLUDES?: InputMaybe<CoverageRequestRating>;
	rating_NOT?: InputMaybe<Array<CoverageRequestRating>>;
	rating_NOT_INCLUDES?: InputMaybe<CoverageRequestRating>;
	requiredForms?: InputMaybe<Array<FormType>>;
	requiredForms_INCLUDES?: InputMaybe<FormType>;
	requiredForms_NOT?: InputMaybe<Array<FormType>>;
	requiredForms_NOT_INCLUDES?: InputMaybe<FormType>;
	requiredRecords?: InputMaybe<Array<RecordType>>;
	requiredRecords_INCLUDES?: InputMaybe<RecordType>;
	requiredRecords_NOT?: InputMaybe<Array<RecordType>>;
	requiredRecords_NOT_INCLUDES?: InputMaybe<RecordType>;
	scenarios?: InputMaybe<ScenarioWhere>;
	scenariosAggregate?: InputMaybe<BaseAgreementScenariosAggregateInput>;
	scenariosConnection?: InputMaybe<BaseAgreementScenariosConnectionWhere>;
	scenariosConnection_NOT?: InputMaybe<BaseAgreementScenariosConnectionWhere>;
	scenarios_NOT?: InputMaybe<ScenarioWhere>;
	status?: InputMaybe<ContractStatus>;
	statusTransitions?: InputMaybe<AgreementStatusTransitionWhere>;
	statusTransitionsAggregate?: InputMaybe<BaseAgreementStatusTransitionsAggregateInput>;
	statusTransitionsConnection?: InputMaybe<BaseAgreementStatusTransitionsConnectionWhere>;
	statusTransitionsConnection_NOT?: InputMaybe<BaseAgreementStatusTransitionsConnectionWhere>;
	statusTransitions_NOT?: InputMaybe<AgreementStatusTransitionWhere>;
	status_IN?: InputMaybe<Array<InputMaybe<ContractStatus>>>;
	status_NOT?: InputMaybe<ContractStatus>;
	status_NOT_IN?: InputMaybe<Array<InputMaybe<ContractStatus>>>;
	subjectMatter?: InputMaybe<AgreementSubjectMatter>;
	subjectMatter_IN?: InputMaybe<Array<InputMaybe<AgreementSubjectMatter>>>;
	subjectMatter_NOT?: InputMaybe<AgreementSubjectMatter>;
	subjectMatter_NOT_IN?: InputMaybe<Array<InputMaybe<AgreementSubjectMatter>>>;
	tags?: InputMaybe<AgreementTagWhere>;
	tagsAggregate?: InputMaybe<BaseAgreementTagsAggregateInput>;
	tagsConnection?: InputMaybe<BaseAgreementTagsConnectionWhere>;
	tagsConnection_NOT?: InputMaybe<BaseAgreementTagsConnectionWhere>;
	tags_NOT?: InputMaybe<AgreementTagWhere>;
	tenantIds?: InputMaybe<Array<Scalars["String"]>>;
	tenantIds_INCLUDES?: InputMaybe<Scalars["String"]>;
	tenantIds_NOT?: InputMaybe<Array<Scalars["String"]>>;
	tenantIds_NOT_INCLUDES?: InputMaybe<Scalars["String"]>;
	therapyDecision?: InputMaybe<Array<CoverageRequestTherapyDecision>>;
	therapyDecision_INCLUDES?: InputMaybe<CoverageRequestTherapyDecision>;
	therapyDecision_NOT?: InputMaybe<Array<CoverageRequestTherapyDecision>>;
	therapyDecision_NOT_INCLUDES?: InputMaybe<CoverageRequestTherapyDecision>;
	treatmentPrices?: InputMaybe<TreatmentWhere>;
	treatmentPricesAggregate?: InputMaybe<BaseAgreementTreatmentPricesAggregateInput>;
	treatmentPricesConnection?: InputMaybe<BaseAgreementTreatmentPricesConnectionWhere>;
	treatmentPricesConnection_NOT?: InputMaybe<BaseAgreementTreatmentPricesConnectionWhere>;
	treatmentPrices_NOT?: InputMaybe<TreatmentWhere>;
	userContexts?: InputMaybe<UserContextWhere>;
	userContextsAggregate?: InputMaybe<BaseAgreementUserContextsAggregateInput>;
	userContextsConnection?: InputMaybe<BaseAgreementUserContextsConnectionWhere>;
	userContextsConnection_NOT?: InputMaybe<BaseAgreementUserContextsConnectionWhere>;
	userContexts_NOT?: InputMaybe<UserContextWhere>;
	userRoles?: InputMaybe<UserWhere>;
	userRolesAggregate?: InputMaybe<BaseAgreementUserRolesAggregateInput>;
	userRolesConnection?: InputMaybe<BaseAgreementUserRolesConnectionWhere>;
	userRolesConnection_NOT?: InputMaybe<BaseAgreementUserRolesConnectionWhere>;
	userRoles_NOT?: InputMaybe<UserWhere>;
	validFromDate?: InputMaybe<Scalars["Date"]>;
	validFromDate_GT?: InputMaybe<Scalars["Date"]>;
	validFromDate_GTE?: InputMaybe<Scalars["Date"]>;
	validFromDate_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
	validFromDate_LT?: InputMaybe<Scalars["Date"]>;
	validFromDate_LTE?: InputMaybe<Scalars["Date"]>;
	validFromDate_NOT?: InputMaybe<Scalars["Date"]>;
	validFromDate_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
	validToDate?: InputMaybe<Scalars["Date"]>;
	validToDate_GT?: InputMaybe<Scalars["Date"]>;
	validToDate_GTE?: InputMaybe<Scalars["Date"]>;
	validToDate_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
	validToDate_LT?: InputMaybe<Scalars["Date"]>;
	validToDate_LTE?: InputMaybe<Scalars["Date"]>;
	validToDate_NOT?: InputMaybe<Scalars["Date"]>;
	validToDate_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
	version?: InputMaybe<Scalars["Int"]>;
	version_GT?: InputMaybe<Scalars["Int"]>;
	version_GTE?: InputMaybe<Scalars["Int"]>;
	version_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	version_LT?: InputMaybe<Scalars["Int"]>;
	version_LTE?: InputMaybe<Scalars["Int"]>;
	version_NOT?: InputMaybe<Scalars["Int"]>;
	version_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
};

export type Brand = {
	__typename?: "Brand";
	Name: Scalars["String"];
	preparations: Array<Preparation>;
	preparationsConnection: BrandPreparationsConnection;
};

export type BrandPreparationsArgs = {
	options?: InputMaybe<PreparationOptions>;
	where?: InputMaybe<PreparationWhere>;
};

export type BrandPreparationsConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<BrandPreparationsConnectionSort>>;
	where?: InputMaybe<BrandPreparationsConnectionWhere>;
};

export type BrandAggregateSelection = {
	__typename?: "BrandAggregateSelection";
	Name: StringAggregateSelection;
	count: Scalars["Int"];
};

export type BrandConnectInput = {
	preparations?: InputMaybe<Array<BrandPreparationsConnectFieldInput>>;
};

export type BrandConnectWhere = {
	node: BrandWhere;
};

export type BrandCreateInput = {
	Name: Scalars["String"];
	preparations?: InputMaybe<BrandPreparationsFieldInput>;
};

export type BrandDeleteInput = {
	preparations?: InputMaybe<Array<BrandPreparationsDeleteFieldInput>>;
};

export type BrandDisconnectInput = {
	preparations?: InputMaybe<Array<BrandPreparationsDisconnectFieldInput>>;
};

export type BrandOptions = {
	limit?: InputMaybe<Scalars["Int"]>;
	offset?: InputMaybe<Scalars["Int"]>;
	/** Specify one or more BrandSort objects to sort Brands by. The sorts will be applied in the order in which they are arranged in the array. */
	sort?: InputMaybe<Array<InputMaybe<BrandSort>>>;
};

export type BrandPreparationsAggregateInput = {
	AND?: InputMaybe<Array<BrandPreparationsAggregateInput>>;
	OR?: InputMaybe<Array<BrandPreparationsAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<BrandPreparationsNodeAggregationWhereInput>;
};

export type BrandPreparationsConnectFieldInput = {
	connect?: InputMaybe<Array<PreparationConnectInput>>;
	where?: InputMaybe<PreparationConnectWhere>;
};

export type BrandPreparationsConnection = {
	__typename?: "BrandPreparationsConnection";
	edges: Array<BrandPreparationsRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type BrandPreparationsConnectionSort = {
	node?: InputMaybe<PreparationSort>;
};

export type BrandPreparationsConnectionWhere = {
	AND?: InputMaybe<Array<BrandPreparationsConnectionWhere>>;
	OR?: InputMaybe<Array<BrandPreparationsConnectionWhere>>;
	node?: InputMaybe<PreparationWhere>;
	node_NOT?: InputMaybe<PreparationWhere>;
};

export type BrandPreparationsCreateFieldInput = {
	node: PreparationCreateInput;
};

export type BrandPreparationsDeleteFieldInput = {
	delete?: InputMaybe<PreparationDeleteInput>;
	where?: InputMaybe<BrandPreparationsConnectionWhere>;
};

export type BrandPreparationsDisconnectFieldInput = {
	disconnect?: InputMaybe<PreparationDisconnectInput>;
	where?: InputMaybe<BrandPreparationsConnectionWhere>;
};

export type BrandPreparationsFieldInput = {
	connect?: InputMaybe<Array<BrandPreparationsConnectFieldInput>>;
	create?: InputMaybe<Array<BrandPreparationsCreateFieldInput>>;
};

export type BrandPreparationsNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<BrandPreparationsNodeAggregationWhereInput>>;
	AtcCode_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	AtcCode_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	AtcCode_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	AtcCode_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	AtcCode_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	AtcCode_EQUAL?: InputMaybe<Scalars["String"]>;
	AtcCode_GT?: InputMaybe<Scalars["Int"]>;
	AtcCode_GTE?: InputMaybe<Scalars["Int"]>;
	AtcCode_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	AtcCode_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	AtcCode_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	AtcCode_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	AtcCode_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	AtcCode_LT?: InputMaybe<Scalars["Int"]>;
	AtcCode_LTE?: InputMaybe<Scalars["Int"]>;
	AtcCode_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	AtcCode_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	AtcCode_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	AtcCode_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	AtcCode_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	BrandName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	BrandName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	BrandName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	BrandName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	BrandName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	BrandName_EQUAL?: InputMaybe<Scalars["String"]>;
	BrandName_GT?: InputMaybe<Scalars["Int"]>;
	BrandName_GTE?: InputMaybe<Scalars["Int"]>;
	BrandName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	BrandName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	BrandName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	BrandName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	BrandName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	BrandName_LT?: InputMaybe<Scalars["Int"]>;
	BrandName_LTE?: InputMaybe<Scalars["Int"]>;
	BrandName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	BrandName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	BrandName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	BrandName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	BrandName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	DescriptionDe_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	DescriptionDe_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	DescriptionDe_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	DescriptionDe_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	DescriptionDe_EQUAL?: InputMaybe<Scalars["String"]>;
	DescriptionDe_GT?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_GTE?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_LT?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_LTE?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	GenericName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	GenericName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	GenericName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	GenericName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	GenericName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	GenericName_EQUAL?: InputMaybe<Scalars["String"]>;
	GenericName_GT?: InputMaybe<Scalars["Int"]>;
	GenericName_GTE?: InputMaybe<Scalars["Int"]>;
	GenericName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	GenericName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	GenericName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	GenericName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	GenericName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	GenericName_LT?: InputMaybe<Scalars["Int"]>;
	GenericName_LTE?: InputMaybe<Scalars["Int"]>;
	GenericName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	GenericName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	GenericName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	GenericName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	GenericName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	OR?: InputMaybe<Array<BrandPreparationsNodeAggregationWhereInput>>;
	SwissmedicNo5_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo5_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo5_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo5_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo5_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo5_EQUAL?: InputMaybe<Scalars["String"]>;
	SwissmedicNo5_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo5_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo5_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo5_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo5_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo5_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo5_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo5_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo5_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo5_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo5_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo5_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo5_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo5_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
};

export type BrandPreparationsRelationship = {
	__typename?: "BrandPreparationsRelationship";
	cursor: Scalars["String"];
	node: Preparation;
};

export type BrandPreparationsUpdateConnectionInput = {
	node?: InputMaybe<PreparationUpdateInput>;
};

export type BrandPreparationsUpdateFieldInput = {
	connect?: InputMaybe<Array<BrandPreparationsConnectFieldInput>>;
	create?: InputMaybe<Array<BrandPreparationsCreateFieldInput>>;
	delete?: InputMaybe<Array<BrandPreparationsDeleteFieldInput>>;
	disconnect?: InputMaybe<Array<BrandPreparationsDisconnectFieldInput>>;
	update?: InputMaybe<BrandPreparationsUpdateConnectionInput>;
	where?: InputMaybe<BrandPreparationsConnectionWhere>;
};

/** Fields to sort Brands by. The order in which sorts are applied is not guaranteed when specifying many fields in one BrandSort object. */
export type BrandSort = {
	Name?: InputMaybe<SortDirection>;
};

export type BrandUpdateInput = {
	Name?: InputMaybe<Scalars["String"]>;
	preparations?: InputMaybe<Array<BrandPreparationsUpdateFieldInput>>;
};

export type BrandWhere = {
	AND?: InputMaybe<Array<BrandWhere>>;
	Name?: InputMaybe<Scalars["String"]>;
	Name_CONTAINS?: InputMaybe<Scalars["String"]>;
	Name_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	Name_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	Name_MATCHES?: InputMaybe<Scalars["String"]>;
	Name_NOT?: InputMaybe<Scalars["String"]>;
	Name_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	Name_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	Name_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	Name_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	Name_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	OR?: InputMaybe<Array<BrandWhere>>;
	preparations?: InputMaybe<PreparationWhere>;
	preparationsAggregate?: InputMaybe<BrandPreparationsAggregateInput>;
	preparationsConnection?: InputMaybe<BrandPreparationsConnectionWhere>;
	preparationsConnection_NOT?: InputMaybe<BrandPreparationsConnectionWhere>;
	preparations_NOT?: InputMaybe<PreparationWhere>;
};

export type CaobAgreementReport = {
	__typename?: "CAOBAgreementReport";
	PIToSIRange: Array<Scalars["Float"]>;
	SICount?: Maybe<Scalars["Float"]>;
	averageMonthlyPatients?: Maybe<Scalars["Float"]>;
	averagePIToRecurrenceTime?: Maybe<Scalars["Float"]>;
	averagePIToSITime?: Maybe<Scalars["Float"]>;
	averageRecurrenceToSITime?: Maybe<Scalars["Float"]>;
	averageRefundPerSI?: Maybe<Scalars["Float"]>;
	averageTimePIRecurrenceSiCTI: Array<PiRecurrenceSiDataPoint>;
	averageTimePIRecurrenceSiLVZ: Array<PiRecurrenceSiDataPoint>;
	itemsUsed: Array<ItemUsedDataPoint>;
	monthlyPatientEnrollment: Array<PatientsPerMonthDataPoint>;
	patientCount?: Maybe<Scalars["Float"]>;
	patientCountCTILineAblated: Array<PatientCountDataPoint>;
	patientCountLVZ: Array<PatientCountDataPoint>;
	patientStatusDistribution?: Maybe<PatientStatusDistribution>;
	primaryAverageLAPressureAndLAVolume: Array<AverageLaPressureAndLaVolumeRow>;
	recurringSuccessRate?: Maybe<Scalars["Float"]>;
	refundSummaryRows: Array<CaobRefundSummaryRow>;
	secondaryAverageLAPressureAndLAVolume: AverageLaPressureAndLaVolumeRow;
};

export type CaobAgreementReportAggregateSelection = {
	__typename?: "CAOBAgreementReportAggregateSelection";
	SICount: FloatAggregateSelection;
	averageMonthlyPatients: FloatAggregateSelection;
	averagePIToRecurrenceTime: FloatAggregateSelection;
	averagePIToSITime: FloatAggregateSelection;
	averageRecurrenceToSITime: FloatAggregateSelection;
	averageRefundPerSI: FloatAggregateSelection;
	count: Scalars["Int"];
	patientCount: FloatAggregateSelection;
	recurringSuccessRate: FloatAggregateSelection;
};

export type CaobAgreementReportOptions = {
	limit?: InputMaybe<Scalars["Int"]>;
	offset?: InputMaybe<Scalars["Int"]>;
	/** Specify one or more CAOBAgreementReportSort objects to sort CAOBAgreementReports by. The sorts will be applied in the order in which they are arranged in the array. */
	sort?: InputMaybe<Array<InputMaybe<CaobAgreementReportSort>>>;
};

/** Fields to sort CAOBAgreementReports by. The order in which sorts are applied is not guaranteed when specifying many fields in one CAOBAgreementReportSort object. */
export type CaobAgreementReportSort = {
	SICount?: InputMaybe<SortDirection>;
	averageMonthlyPatients?: InputMaybe<SortDirection>;
	averagePIToRecurrenceTime?: InputMaybe<SortDirection>;
	averagePIToSITime?: InputMaybe<SortDirection>;
	averageRecurrenceToSITime?: InputMaybe<SortDirection>;
	averageRefundPerSI?: InputMaybe<SortDirection>;
	patientCount?: InputMaybe<SortDirection>;
	recurringSuccessRate?: InputMaybe<SortDirection>;
};

export type CaobAgreementReportWhere = {
	AND?: InputMaybe<Array<CaobAgreementReportWhere>>;
	OR?: InputMaybe<Array<CaobAgreementReportWhere>>;
	PIToSIRange?: InputMaybe<Array<Scalars["Float"]>>;
	PIToSIRange_INCLUDES?: InputMaybe<Scalars["Float"]>;
	PIToSIRange_NOT?: InputMaybe<Array<Scalars["Float"]>>;
	PIToSIRange_NOT_INCLUDES?: InputMaybe<Scalars["Float"]>;
	SICount?: InputMaybe<Scalars["Float"]>;
	SICount_GT?: InputMaybe<Scalars["Float"]>;
	SICount_GTE?: InputMaybe<Scalars["Float"]>;
	SICount_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	SICount_LT?: InputMaybe<Scalars["Float"]>;
	SICount_LTE?: InputMaybe<Scalars["Float"]>;
	SICount_NOT?: InputMaybe<Scalars["Float"]>;
	SICount_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	averageMonthlyPatients?: InputMaybe<Scalars["Float"]>;
	averageMonthlyPatients_GT?: InputMaybe<Scalars["Float"]>;
	averageMonthlyPatients_GTE?: InputMaybe<Scalars["Float"]>;
	averageMonthlyPatients_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	averageMonthlyPatients_LT?: InputMaybe<Scalars["Float"]>;
	averageMonthlyPatients_LTE?: InputMaybe<Scalars["Float"]>;
	averageMonthlyPatients_NOT?: InputMaybe<Scalars["Float"]>;
	averageMonthlyPatients_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	averagePIToRecurrenceTime?: InputMaybe<Scalars["Float"]>;
	averagePIToRecurrenceTime_GT?: InputMaybe<Scalars["Float"]>;
	averagePIToRecurrenceTime_GTE?: InputMaybe<Scalars["Float"]>;
	averagePIToRecurrenceTime_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	averagePIToRecurrenceTime_LT?: InputMaybe<Scalars["Float"]>;
	averagePIToRecurrenceTime_LTE?: InputMaybe<Scalars["Float"]>;
	averagePIToRecurrenceTime_NOT?: InputMaybe<Scalars["Float"]>;
	averagePIToRecurrenceTime_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	averagePIToSITime?: InputMaybe<Scalars["Float"]>;
	averagePIToSITime_GT?: InputMaybe<Scalars["Float"]>;
	averagePIToSITime_GTE?: InputMaybe<Scalars["Float"]>;
	averagePIToSITime_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	averagePIToSITime_LT?: InputMaybe<Scalars["Float"]>;
	averagePIToSITime_LTE?: InputMaybe<Scalars["Float"]>;
	averagePIToSITime_NOT?: InputMaybe<Scalars["Float"]>;
	averagePIToSITime_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	averageRecurrenceToSITime?: InputMaybe<Scalars["Float"]>;
	averageRecurrenceToSITime_GT?: InputMaybe<Scalars["Float"]>;
	averageRecurrenceToSITime_GTE?: InputMaybe<Scalars["Float"]>;
	averageRecurrenceToSITime_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	averageRecurrenceToSITime_LT?: InputMaybe<Scalars["Float"]>;
	averageRecurrenceToSITime_LTE?: InputMaybe<Scalars["Float"]>;
	averageRecurrenceToSITime_NOT?: InputMaybe<Scalars["Float"]>;
	averageRecurrenceToSITime_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	averageRefundPerSI?: InputMaybe<Scalars["Float"]>;
	averageRefundPerSI_GT?: InputMaybe<Scalars["Float"]>;
	averageRefundPerSI_GTE?: InputMaybe<Scalars["Float"]>;
	averageRefundPerSI_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	averageRefundPerSI_LT?: InputMaybe<Scalars["Float"]>;
	averageRefundPerSI_LTE?: InputMaybe<Scalars["Float"]>;
	averageRefundPerSI_NOT?: InputMaybe<Scalars["Float"]>;
	averageRefundPerSI_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	patientCount?: InputMaybe<Scalars["Float"]>;
	patientCount_GT?: InputMaybe<Scalars["Float"]>;
	patientCount_GTE?: InputMaybe<Scalars["Float"]>;
	patientCount_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	patientCount_LT?: InputMaybe<Scalars["Float"]>;
	patientCount_LTE?: InputMaybe<Scalars["Float"]>;
	patientCount_NOT?: InputMaybe<Scalars["Float"]>;
	patientCount_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	recurringSuccessRate?: InputMaybe<Scalars["Float"]>;
	recurringSuccessRate_GT?: InputMaybe<Scalars["Float"]>;
	recurringSuccessRate_GTE?: InputMaybe<Scalars["Float"]>;
	recurringSuccessRate_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	recurringSuccessRate_LT?: InputMaybe<Scalars["Float"]>;
	recurringSuccessRate_LTE?: InputMaybe<Scalars["Float"]>;
	recurringSuccessRate_NOT?: InputMaybe<Scalars["Float"]>;
	recurringSuccessRate_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
};

export enum CaobPhysician {
	OtherPhysicianOtherHospital = "OTHER_PHYSICIAN_OTHER_HOSPITAL",
	Physician_1 = "PHYSICIAN_1",
}

export type CaobRefundSummaryRow = {
	__typename?: "CAOBRefundSummaryRow";
	discountDate: Scalars["Date"];
	discountRate: Scalars["Float"];
	eligibleItems: Array<Scalars["String"]>;
	formId: Scalars["String"];
	interventionType: ReportInterventionType;
	patientId: Scalars["String"];
	status: RefundStatus;
};

export type CaobRefundSummaryRowAggregateSelection = {
	__typename?: "CAOBRefundSummaryRowAggregateSelection";
	count: Scalars["Int"];
	discountRate: FloatAggregateSelection;
	formId: StringAggregateSelection;
	patientId: StringAggregateSelection;
};

export type CaobRefundSummaryRowOptions = {
	limit?: InputMaybe<Scalars["Int"]>;
	offset?: InputMaybe<Scalars["Int"]>;
	/** Specify one or more CAOBRefundSummaryRowSort objects to sort CAOBRefundSummaryRows by. The sorts will be applied in the order in which they are arranged in the array. */
	sort?: InputMaybe<Array<InputMaybe<CaobRefundSummaryRowSort>>>;
};

/** Fields to sort CAOBRefundSummaryRows by. The order in which sorts are applied is not guaranteed when specifying many fields in one CAOBRefundSummaryRowSort object. */
export type CaobRefundSummaryRowSort = {
	discountDate?: InputMaybe<SortDirection>;
	discountRate?: InputMaybe<SortDirection>;
	formId?: InputMaybe<SortDirection>;
	interventionType?: InputMaybe<SortDirection>;
	patientId?: InputMaybe<SortDirection>;
	status?: InputMaybe<SortDirection>;
};

export type CaobRefundSummaryRowWhere = {
	AND?: InputMaybe<Array<CaobRefundSummaryRowWhere>>;
	OR?: InputMaybe<Array<CaobRefundSummaryRowWhere>>;
	discountDate?: InputMaybe<Scalars["Date"]>;
	discountDate_GT?: InputMaybe<Scalars["Date"]>;
	discountDate_GTE?: InputMaybe<Scalars["Date"]>;
	discountDate_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
	discountDate_LT?: InputMaybe<Scalars["Date"]>;
	discountDate_LTE?: InputMaybe<Scalars["Date"]>;
	discountDate_NOT?: InputMaybe<Scalars["Date"]>;
	discountDate_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
	discountRate?: InputMaybe<Scalars["Float"]>;
	discountRate_GT?: InputMaybe<Scalars["Float"]>;
	discountRate_GTE?: InputMaybe<Scalars["Float"]>;
	discountRate_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	discountRate_LT?: InputMaybe<Scalars["Float"]>;
	discountRate_LTE?: InputMaybe<Scalars["Float"]>;
	discountRate_NOT?: InputMaybe<Scalars["Float"]>;
	discountRate_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	eligibleItems?: InputMaybe<Array<Scalars["String"]>>;
	eligibleItems_INCLUDES?: InputMaybe<Scalars["String"]>;
	eligibleItems_NOT?: InputMaybe<Array<Scalars["String"]>>;
	eligibleItems_NOT_INCLUDES?: InputMaybe<Scalars["String"]>;
	formId?: InputMaybe<Scalars["String"]>;
	formId_CONTAINS?: InputMaybe<Scalars["String"]>;
	formId_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	formId_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	formId_MATCHES?: InputMaybe<Scalars["String"]>;
	formId_NOT?: InputMaybe<Scalars["String"]>;
	formId_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	formId_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	formId_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	formId_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	formId_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	interventionType?: InputMaybe<ReportInterventionType>;
	interventionType_IN?: InputMaybe<Array<InputMaybe<ReportInterventionType>>>;
	interventionType_NOT?: InputMaybe<ReportInterventionType>;
	interventionType_NOT_IN?: InputMaybe<Array<InputMaybe<ReportInterventionType>>>;
	patientId?: InputMaybe<Scalars["String"]>;
	patientId_CONTAINS?: InputMaybe<Scalars["String"]>;
	patientId_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	patientId_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	patientId_MATCHES?: InputMaybe<Scalars["String"]>;
	patientId_NOT?: InputMaybe<Scalars["String"]>;
	patientId_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	patientId_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	patientId_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	patientId_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	patientId_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	status?: InputMaybe<RefundStatus>;
	status_IN?: InputMaybe<Array<InputMaybe<RefundStatus>>>;
	status_NOT?: InputMaybe<RefundStatus>;
	status_NOT_IN?: InputMaybe<Array<InputMaybe<RefundStatus>>>;
};

export type CaobAgreementRenewalInput = {
	agreementId: Scalars["ID"];
	enrollingPeriodEnd: Scalars["Date"];
	enrollingPeriodStart: Scalars["Date"];
};

export type Case = {
	__typename?: "Case";
	actualAgreementId?: Maybe<Scalars["String"]>;
	agreement?: Maybe<Agreement>;
	agreementName?: Maybe<Scalars["String"]>;
	agreementTag?: Maybe<Array<Maybe<Scalars["String"]>>>;
	assignedTo?: Maybe<User>;
	baseAgreement?: Maybe<BaseAgreement>;
	baseAgreementConnection: CaseBaseAgreementConnection;
	canUserViewFinancials: Scalars["Boolean"];
	claims: Array<Claim>;
	claimsConnection: CaseClaimsConnection;
	cohort?: Maybe<EnrollingPeriod>;
	cohortConnection: CaseCohortConnection;
	coverageRequests: Array<CoverageRequest>;
	coverageRequestsConnection: CaseCoverageRequestsConnection;
	creationDate: Scalars["Date"];
	disease?: Maybe<Disease>;
	diseaseConnection: CaseDiseaseConnection;
	financialDataPointsConnection: CaseFinancialDataPointsConnection;
	flexEntities: Array<FlexEntity>;
	flexEntitiesConnection: CaseFlexEntitiesConnection;
	financialDataPoints: Array<FlexFinancialDataPoint>;
	flexFinancialDataPointsConnection: CaseFlexFinancialDataPointsConnection;
	id: Scalars["ID"];
	indication?: Maybe<Indication>;
	indicationConnection: CaseIndicationConnection;
	isArchived: Scalars["Boolean"];
	isDeleted: Scalars["Boolean"];
	isFormOwner?: Maybe<Scalars["Boolean"]>;
	legalEntity?: Maybe<Organization>;
	legalEntityConnection: CaseLegalEntityConnection;
	patient?: Maybe<Patient>;
	patientConnection: CasePatientConnection;
	patientInitials?: Maybe<Scalars["String"]>;
	patientInsuranceId?: Maybe<Scalars["String"]>;
	preparationBandName?: Maybe<Scalars["String"]>;
	preparationGenericName?: Maybe<Scalars["String"]>;
	preparations: Array<Preparation>;
	preparationsConnection: CasePreparationsConnection;
	primaryIntervention?: Maybe<Intervention>;
	primaryInterventionConnection: CasePrimaryInterventionConnection;
	recordBatches: Array<RecordBatch>;
	recordBatchesConnection: CaseRecordBatchesConnection;
	sharedCoverageRequests: Array<CoverageRequest>;
	sourceTenantId?: Maybe<Scalars["String"]>;
	stobContract?: Maybe<StobContract>;
	stobContractConnection: CaseStobContractConnection;
	submissionDate?: Maybe<Scalars["DateTime"]>;
	tenantIds?: Maybe<Array<Scalars["String"]>>;
	totalAmount?: Maybe<Scalars["Float"]>;
	unlimited?: Maybe<Scalars["Int"]>;
};

export type CaseBaseAgreementArgs = {
	options?: InputMaybe<BaseAgreementOptions>;
	where?: InputMaybe<BaseAgreementWhere>;
};

export type CaseBaseAgreementConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<CaseBaseAgreementConnectionSort>>;
	where?: InputMaybe<CaseBaseAgreementConnectionWhere>;
};

export type CaseClaimsArgs = {
	options?: InputMaybe<ClaimOptions>;
	where?: InputMaybe<ClaimWhere>;
};

export type CaseClaimsConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<CaseClaimsConnectionSort>>;
	where?: InputMaybe<CaseClaimsConnectionWhere>;
};

export type CaseCohortArgs = {
	options?: InputMaybe<EnrollingPeriodOptions>;
	where?: InputMaybe<EnrollingPeriodWhere>;
};

export type CaseCohortConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<CaseCohortConnectionSort>>;
	where?: InputMaybe<CaseCohortConnectionWhere>;
};

export type CaseCoverageRequestsArgs = {
	options?: InputMaybe<CoverageRequestOptions>;
	where?: InputMaybe<CoverageRequestWhere>;
};

export type CaseCoverageRequestsConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<CaseCoverageRequestsConnectionSort>>;
	where?: InputMaybe<CaseCoverageRequestsConnectionWhere>;
};

export type CaseDiseaseArgs = {
	options?: InputMaybe<DiseaseOptions>;
	where?: InputMaybe<DiseaseWhere>;
};

export type CaseDiseaseConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<CaseDiseaseConnectionSort>>;
	where?: InputMaybe<CaseDiseaseConnectionWhere>;
};

export type CaseFinancialDataPointsArgs = {
	options?: InputMaybe<FinancialDataPointOptions>;
	where?: InputMaybe<FinancialDataPointWhere>;
};

export type CaseFinancialDataPointsConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<CaseFinancialDataPointsConnectionSort>>;
	where?: InputMaybe<CaseFinancialDataPointsConnectionWhere>;
};

export type CaseFlexEntitiesArgs = {
	options?: InputMaybe<FlexEntityOptions>;
	where?: InputMaybe<FlexEntityWhere>;
};

export type CaseFlexEntitiesConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<CaseFlexEntitiesConnectionSort>>;
	where?: InputMaybe<CaseFlexEntitiesConnectionWhere>;
};

export type CaseFlexFinancialDataPointsArgs = {
	options?: InputMaybe<FlexFinancialDataPointOptions>;
	where?: InputMaybe<FlexFinancialDataPointWhere>;
};

export type CaseFlexFinancialDataPointsConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<CaseFlexFinancialDataPointsConnectionSort>>;
	where?: InputMaybe<CaseFlexFinancialDataPointsConnectionWhere>;
};

export type CaseIndicationArgs = {
	options?: InputMaybe<IndicationOptions>;
	where?: InputMaybe<IndicationWhere>;
};

export type CaseIndicationConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<CaseIndicationConnectionSort>>;
	where?: InputMaybe<CaseIndicationConnectionWhere>;
};

export type CaseLegalEntityArgs = {
	options?: InputMaybe<OrganizationOptions>;
	where?: InputMaybe<OrganizationWhere>;
};

export type CaseLegalEntityConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<CaseLegalEntityConnectionSort>>;
	where?: InputMaybe<CaseLegalEntityConnectionWhere>;
};

export type CasePatientArgs = {
	options?: InputMaybe<PatientOptions>;
	where?: InputMaybe<PatientWhere>;
};

export type CasePatientConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<CasePatientConnectionSort>>;
	where?: InputMaybe<CasePatientConnectionWhere>;
};

export type CasePreparationsArgs = {
	options?: InputMaybe<PreparationOptions>;
	where?: InputMaybe<PreparationWhere>;
};

export type CasePreparationsConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<CasePreparationsConnectionSort>>;
	where?: InputMaybe<CasePreparationsConnectionWhere>;
};

export type CasePrimaryInterventionArgs = {
	options?: InputMaybe<InterventionOptions>;
	where?: InputMaybe<InterventionWhere>;
};

export type CasePrimaryInterventionConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<CasePrimaryInterventionConnectionSort>>;
	where?: InputMaybe<CasePrimaryInterventionConnectionWhere>;
};

export type CaseRecordBatchesArgs = {
	options?: InputMaybe<RecordBatchOptions>;
	where?: InputMaybe<RecordBatchWhere>;
};

export type CaseRecordBatchesConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<CaseRecordBatchesConnectionSort>>;
	where?: InputMaybe<CaseRecordBatchesConnectionWhere>;
};

export type CaseStobContractArgs = {
	options?: InputMaybe<StobContractOptions>;
	where?: InputMaybe<StobContractWhere>;
};

export type CaseStobContractConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<CaseStobContractConnectionSort>>;
	where?: InputMaybe<CaseStobContractConnectionWhere>;
};

export type CaseAggregateSelection = {
	__typename?: "CaseAggregateSelection";
	actualAgreementId: StringAggregateSelection;
	agreementName: StringAggregateSelection;
	count: Scalars["Int"];
	id: IdAggregateSelection;
	patientInitials: StringAggregateSelection;
	patientInsuranceId: StringAggregateSelection;
	preparationBandName: StringAggregateSelection;
	preparationGenericName: StringAggregateSelection;
	sourceTenantId: StringAggregateSelection;
	submissionDate: DateTimeAggregateSelection;
	totalAmount: FloatAggregateSelection;
	unlimited: IntAggregateSelection;
};

export type CaseBaseAgreementAggregateInput = {
	AND?: InputMaybe<Array<CaseBaseAgreementAggregateInput>>;
	OR?: InputMaybe<Array<CaseBaseAgreementAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<CaseBaseAgreementNodeAggregationWhereInput>;
};

export type CaseBaseAgreementConnectFieldInput = {
	connect?: InputMaybe<BaseAgreementConnectInput>;
	where?: InputMaybe<BaseAgreementConnectWhere>;
};

export type CaseBaseAgreementConnection = {
	__typename?: "CaseBaseAgreementConnection";
	edges: Array<CaseBaseAgreementRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type CaseBaseAgreementConnectionSort = {
	node?: InputMaybe<BaseAgreementSort>;
};

export type CaseBaseAgreementConnectionWhere = {
	AND?: InputMaybe<Array<CaseBaseAgreementConnectionWhere>>;
	OR?: InputMaybe<Array<CaseBaseAgreementConnectionWhere>>;
	node?: InputMaybe<BaseAgreementWhere>;
	node_NOT?: InputMaybe<BaseAgreementWhere>;
};

export type CaseBaseAgreementCreateFieldInput = {
	node: BaseAgreementCreateInput;
};

export type CaseBaseAgreementDeleteFieldInput = {
	delete?: InputMaybe<BaseAgreementDeleteInput>;
	where?: InputMaybe<CaseBaseAgreementConnectionWhere>;
};

export type CaseBaseAgreementDisconnectFieldInput = {
	disconnect?: InputMaybe<BaseAgreementDisconnectInput>;
	where?: InputMaybe<CaseBaseAgreementConnectionWhere>;
};

export type CaseBaseAgreementFieldInput = {
	connect?: InputMaybe<CaseBaseAgreementConnectFieldInput>;
	create?: InputMaybe<CaseBaseAgreementCreateFieldInput>;
};

export type CaseBaseAgreementNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<CaseBaseAgreementNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<CaseBaseAgreementNodeAggregationWhereInput>>;
	coveringFormWaitInterval_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	coveringFormWaitInterval_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	coveringFormWaitInterval_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	coveringFormWaitInterval_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	coveringFormWaitInterval_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	coveringFormWaitInterval_EQUAL?: InputMaybe<Scalars["Int"]>;
	coveringFormWaitInterval_GT?: InputMaybe<Scalars["Int"]>;
	coveringFormWaitInterval_GTE?: InputMaybe<Scalars["Int"]>;
	coveringFormWaitInterval_LT?: InputMaybe<Scalars["Int"]>;
	coveringFormWaitInterval_LTE?: InputMaybe<Scalars["Int"]>;
	coveringFormWaitInterval_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	coveringFormWaitInterval_MAX_GT?: InputMaybe<Scalars["Int"]>;
	coveringFormWaitInterval_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	coveringFormWaitInterval_MAX_LT?: InputMaybe<Scalars["Int"]>;
	coveringFormWaitInterval_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	coveringFormWaitInterval_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	coveringFormWaitInterval_MIN_GT?: InputMaybe<Scalars["Int"]>;
	coveringFormWaitInterval_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	coveringFormWaitInterval_MIN_LT?: InputMaybe<Scalars["Int"]>;
	coveringFormWaitInterval_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	createdOn_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_GT?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_GTE?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_LT?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_LTE?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	formattedAmount_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	formattedAmount_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	formattedAmount_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	formattedAmount_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	formattedAmount_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	formattedAmount_EQUAL?: InputMaybe<Scalars["String"]>;
	formattedAmount_GT?: InputMaybe<Scalars["Int"]>;
	formattedAmount_GTE?: InputMaybe<Scalars["Int"]>;
	formattedAmount_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedAmount_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedAmount_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedAmount_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedAmount_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	formattedAmount_LT?: InputMaybe<Scalars["Int"]>;
	formattedAmount_LTE?: InputMaybe<Scalars["Int"]>;
	formattedAmount_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedAmount_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedAmount_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedAmount_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedAmount_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	formattedCounterparties_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	formattedCounterparties_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	formattedCounterparties_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	formattedCounterparties_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	formattedCounterparties_EQUAL?: InputMaybe<Scalars["String"]>;
	formattedCounterparties_GT?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_GTE?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_LT?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_LTE?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	formattedProducts_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	formattedProducts_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	formattedProducts_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	formattedProducts_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	formattedProducts_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	formattedProducts_EQUAL?: InputMaybe<Scalars["String"]>;
	formattedProducts_GT?: InputMaybe<Scalars["Int"]>;
	formattedProducts_GTE?: InputMaybe<Scalars["Int"]>;
	formattedProducts_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedProducts_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedProducts_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedProducts_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedProducts_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	formattedProducts_LT?: InputMaybe<Scalars["Int"]>;
	formattedProducts_LTE?: InputMaybe<Scalars["Int"]>;
	formattedProducts_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedProducts_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedProducts_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedProducts_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedProducts_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	formattedTags_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	formattedTags_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	formattedTags_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	formattedTags_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	formattedTags_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	formattedTags_EQUAL?: InputMaybe<Scalars["String"]>;
	formattedTags_GT?: InputMaybe<Scalars["Int"]>;
	formattedTags_GTE?: InputMaybe<Scalars["Int"]>;
	formattedTags_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedTags_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedTags_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedTags_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedTags_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	formattedTags_LT?: InputMaybe<Scalars["Int"]>;
	formattedTags_LTE?: InputMaybe<Scalars["Int"]>;
	formattedTags_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedTags_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedTags_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedTags_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedTags_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	formattedValidityPeriod_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	formattedValidityPeriod_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	formattedValidityPeriod_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	formattedValidityPeriod_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	formattedValidityPeriod_EQUAL?: InputMaybe<Scalars["String"]>;
	formattedValidityPeriod_GT?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_GTE?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_LT?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_LTE?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	initialVersionId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	initialVersionId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	initialVersionId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	initialVersionId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	initialVersionId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	initialVersionId_EQUAL?: InputMaybe<Scalars["String"]>;
	initialVersionId_GT?: InputMaybe<Scalars["Int"]>;
	initialVersionId_GTE?: InputMaybe<Scalars["Int"]>;
	initialVersionId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	initialVersionId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	initialVersionId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	initialVersionId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	initialVersionId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	initialVersionId_LT?: InputMaybe<Scalars["Int"]>;
	initialVersionId_LTE?: InputMaybe<Scalars["Int"]>;
	initialVersionId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	initialVersionId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	initialVersionId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	initialVersionId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	initialVersionId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	lastExecutionDate_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_GT?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_LT?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_LTE?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	name_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	name_EQUAL?: InputMaybe<Scalars["String"]>;
	name_GT?: InputMaybe<Scalars["Int"]>;
	name_GTE?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	name_LT?: InputMaybe<Scalars["Int"]>;
	name_LTE?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	pushedOn_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	pushedOn_GT?: InputMaybe<Scalars["DateTime"]>;
	pushedOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	pushedOn_LT?: InputMaybe<Scalars["DateTime"]>;
	pushedOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	pushedOn_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	pushedOn_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	pushedOn_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	pushedOn_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	pushedOn_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	pushedOn_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	pushedOn_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	pushedOn_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	pushedOn_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	pushedOn_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	version_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	version_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	version_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	version_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	version_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	version_EQUAL?: InputMaybe<Scalars["Int"]>;
	version_GT?: InputMaybe<Scalars["Int"]>;
	version_GTE?: InputMaybe<Scalars["Int"]>;
	version_LT?: InputMaybe<Scalars["Int"]>;
	version_LTE?: InputMaybe<Scalars["Int"]>;
	version_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	version_MAX_GT?: InputMaybe<Scalars["Int"]>;
	version_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	version_MAX_LT?: InputMaybe<Scalars["Int"]>;
	version_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	version_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	version_MIN_GT?: InputMaybe<Scalars["Int"]>;
	version_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	version_MIN_LT?: InputMaybe<Scalars["Int"]>;
	version_MIN_LTE?: InputMaybe<Scalars["Int"]>;
};

export type CaseBaseAgreementRelationship = {
	__typename?: "CaseBaseAgreementRelationship";
	cursor: Scalars["String"];
	node: BaseAgreement;
};

export type CaseBaseAgreementUpdateConnectionInput = {
	node?: InputMaybe<BaseAgreementUpdateInput>;
};

export type CaseBaseAgreementUpdateFieldInput = {
	connect?: InputMaybe<CaseBaseAgreementConnectFieldInput>;
	create?: InputMaybe<CaseBaseAgreementCreateFieldInput>;
	delete?: InputMaybe<CaseBaseAgreementDeleteFieldInput>;
	disconnect?: InputMaybe<CaseBaseAgreementDisconnectFieldInput>;
	update?: InputMaybe<CaseBaseAgreementUpdateConnectionInput>;
	where?: InputMaybe<CaseBaseAgreementConnectionWhere>;
};

export type CaseClaimsAggregateInput = {
	AND?: InputMaybe<Array<CaseClaimsAggregateInput>>;
	OR?: InputMaybe<Array<CaseClaimsAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<CaseClaimsNodeAggregationWhereInput>;
};

export type CaseClaimsConnectFieldInput = {
	connect?: InputMaybe<Array<ClaimConnectInput>>;
	where?: InputMaybe<ClaimConnectWhere>;
};

export type CaseClaimsConnection = {
	__typename?: "CaseClaimsConnection";
	edges: Array<CaseClaimsRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type CaseClaimsConnectionSort = {
	node?: InputMaybe<ClaimSort>;
};

export type CaseClaimsConnectionWhere = {
	AND?: InputMaybe<Array<CaseClaimsConnectionWhere>>;
	OR?: InputMaybe<Array<CaseClaimsConnectionWhere>>;
	node?: InputMaybe<ClaimWhere>;
	node_NOT?: InputMaybe<ClaimWhere>;
};

export type CaseClaimsCreateFieldInput = {
	node: ClaimCreateInput;
};

export type CaseClaimsDeleteFieldInput = {
	delete?: InputMaybe<ClaimDeleteInput>;
	where?: InputMaybe<CaseClaimsConnectionWhere>;
};

export type CaseClaimsDisconnectFieldInput = {
	disconnect?: InputMaybe<ClaimDisconnectInput>;
	where?: InputMaybe<CaseClaimsConnectionWhere>;
};

export type CaseClaimsFieldInput = {
	connect?: InputMaybe<Array<CaseClaimsConnectFieldInput>>;
	create?: InputMaybe<Array<CaseClaimsCreateFieldInput>>;
};

export type CaseClaimsNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<CaseClaimsNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<CaseClaimsNodeAggregationWhereInput>>;
	administrationDate_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	administrationDate_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	administrationDate_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	administrationDate_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	administrationDate_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	administrationDate_EQUAL?: InputMaybe<Scalars["String"]>;
	administrationDate_GT?: InputMaybe<Scalars["Int"]>;
	administrationDate_GTE?: InputMaybe<Scalars["Int"]>;
	administrationDate_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	administrationDate_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	administrationDate_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	administrationDate_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	administrationDate_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	administrationDate_LT?: InputMaybe<Scalars["Int"]>;
	administrationDate_LTE?: InputMaybe<Scalars["Int"]>;
	administrationDate_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	administrationDate_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	administrationDate_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	administrationDate_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	administrationDate_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	assignee_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	assignee_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	assignee_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	assignee_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	assignee_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	assignee_EQUAL?: InputMaybe<Scalars["String"]>;
	assignee_GT?: InputMaybe<Scalars["Int"]>;
	assignee_GTE?: InputMaybe<Scalars["Int"]>;
	assignee_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	assignee_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	assignee_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	assignee_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	assignee_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	assignee_LT?: InputMaybe<Scalars["Int"]>;
	assignee_LTE?: InputMaybe<Scalars["Int"]>;
	assignee_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	assignee_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	assignee_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	assignee_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	assignee_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	claimId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	claimId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	claimId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	claimId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	claimId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	claimId_EQUAL?: InputMaybe<Scalars["String"]>;
	claimId_GT?: InputMaybe<Scalars["Int"]>;
	claimId_GTE?: InputMaybe<Scalars["Int"]>;
	claimId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	claimId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	claimId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	claimId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	claimId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	claimId_LT?: InputMaybe<Scalars["Int"]>;
	claimId_LTE?: InputMaybe<Scalars["Int"]>;
	claimId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	claimId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	claimId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	claimId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	claimId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	createdOn_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	invoiceAmount_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	invoiceAmount_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	invoiceAmount_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	invoiceAmount_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	invoiceAmount_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	invoiceAmount_EQUAL?: InputMaybe<Scalars["String"]>;
	invoiceAmount_GT?: InputMaybe<Scalars["Int"]>;
	invoiceAmount_GTE?: InputMaybe<Scalars["Int"]>;
	invoiceAmount_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	invoiceAmount_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	invoiceAmount_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	invoiceAmount_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	invoiceAmount_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	invoiceAmount_LT?: InputMaybe<Scalars["Int"]>;
	invoiceAmount_LTE?: InputMaybe<Scalars["Int"]>;
	invoiceAmount_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	invoiceAmount_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	invoiceAmount_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	invoiceAmount_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	invoiceAmount_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	invoiceDate_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	invoiceDate_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	invoiceDate_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	invoiceDate_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	invoiceDate_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	invoiceDate_EQUAL?: InputMaybe<Scalars["String"]>;
	invoiceDate_GT?: InputMaybe<Scalars["Int"]>;
	invoiceDate_GTE?: InputMaybe<Scalars["Int"]>;
	invoiceDate_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	invoiceDate_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	invoiceDate_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	invoiceDate_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	invoiceDate_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	invoiceDate_LT?: InputMaybe<Scalars["Int"]>;
	invoiceDate_LTE?: InputMaybe<Scalars["Int"]>;
	invoiceDate_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	invoiceDate_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	invoiceDate_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	invoiceDate_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	invoiceDate_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	invoiceNumber_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	invoiceNumber_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	invoiceNumber_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	invoiceNumber_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	invoiceNumber_EQUAL?: InputMaybe<Scalars["String"]>;
	invoiceNumber_GT?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_GTE?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_LT?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_LTE?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationIdType_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	preparationIdType_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	preparationIdType_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	preparationIdType_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	preparationIdType_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	preparationIdType_EQUAL?: InputMaybe<Scalars["String"]>;
	preparationIdType_GT?: InputMaybe<Scalars["Int"]>;
	preparationIdType_GTE?: InputMaybe<Scalars["Int"]>;
	preparationIdType_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationIdType_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationIdType_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationIdType_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationIdType_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationIdType_LT?: InputMaybe<Scalars["Int"]>;
	preparationIdType_LTE?: InputMaybe<Scalars["Int"]>;
	preparationIdType_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationIdType_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationIdType_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationIdType_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationIdType_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	preparationId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	preparationId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	preparationId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	preparationId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	preparationId_EQUAL?: InputMaybe<Scalars["String"]>;
	preparationId_GT?: InputMaybe<Scalars["Int"]>;
	preparationId_GTE?: InputMaybe<Scalars["Int"]>;
	preparationId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationId_LT?: InputMaybe<Scalars["Int"]>;
	preparationId_LTE?: InputMaybe<Scalars["Int"]>;
	preparationId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	providerId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	providerId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	providerId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	providerId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	providerId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	providerId_EQUAL?: InputMaybe<Scalars["String"]>;
	providerId_GT?: InputMaybe<Scalars["Int"]>;
	providerId_GTE?: InputMaybe<Scalars["Int"]>;
	providerId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	providerId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	providerId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	providerId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	providerId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	providerId_LT?: InputMaybe<Scalars["Int"]>;
	providerId_LTE?: InputMaybe<Scalars["Int"]>;
	providerId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	providerId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	providerId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	providerId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	providerId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	providerName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	providerName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	providerName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	providerName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	providerName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	providerName_EQUAL?: InputMaybe<Scalars["String"]>;
	providerName_GT?: InputMaybe<Scalars["Int"]>;
	providerName_GTE?: InputMaybe<Scalars["Int"]>;
	providerName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	providerName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	providerName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	providerName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	providerName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	providerName_LT?: InputMaybe<Scalars["Int"]>;
	providerName_LTE?: InputMaybe<Scalars["Int"]>;
	providerName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	providerName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	providerName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	providerName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	providerName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	quantity_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	quantity_EQUAL?: InputMaybe<Scalars["String"]>;
	quantity_GT?: InputMaybe<Scalars["Int"]>;
	quantity_GTE?: InputMaybe<Scalars["Int"]>;
	quantity_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	quantity_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	quantity_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	quantity_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	quantity_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	quantity_LT?: InputMaybe<Scalars["Int"]>;
	quantity_LTE?: InputMaybe<Scalars["Int"]>;
	quantity_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	quantity_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	quantity_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	quantity_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	quantity_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	tenantId_EQUAL?: InputMaybe<Scalars["String"]>;
	tenantId_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type CaseClaimsRelationship = {
	__typename?: "CaseClaimsRelationship";
	cursor: Scalars["String"];
	node: Claim;
};

export type CaseClaimsUpdateConnectionInput = {
	node?: InputMaybe<ClaimUpdateInput>;
};

export type CaseClaimsUpdateFieldInput = {
	connect?: InputMaybe<Array<CaseClaimsConnectFieldInput>>;
	create?: InputMaybe<Array<CaseClaimsCreateFieldInput>>;
	delete?: InputMaybe<Array<CaseClaimsDeleteFieldInput>>;
	disconnect?: InputMaybe<Array<CaseClaimsDisconnectFieldInput>>;
	update?: InputMaybe<CaseClaimsUpdateConnectionInput>;
	where?: InputMaybe<CaseClaimsConnectionWhere>;
};

export type CaseCohortAggregateInput = {
	AND?: InputMaybe<Array<CaseCohortAggregateInput>>;
	OR?: InputMaybe<Array<CaseCohortAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
};

export type CaseCohortConnectFieldInput = {
	where?: InputMaybe<EnrollingPeriodConnectWhere>;
};

export type CaseCohortConnection = {
	__typename?: "CaseCohortConnection";
	edges: Array<CaseCohortRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type CaseCohortConnectionSort = {
	node?: InputMaybe<EnrollingPeriodSort>;
};

export type CaseCohortConnectionWhere = {
	AND?: InputMaybe<Array<CaseCohortConnectionWhere>>;
	OR?: InputMaybe<Array<CaseCohortConnectionWhere>>;
	node?: InputMaybe<EnrollingPeriodWhere>;
	node_NOT?: InputMaybe<EnrollingPeriodWhere>;
};

export type CaseCohortCreateFieldInput = {
	node: EnrollingPeriodCreateInput;
};

export type CaseCohortDeleteFieldInput = {
	where?: InputMaybe<CaseCohortConnectionWhere>;
};

export type CaseCohortDisconnectFieldInput = {
	where?: InputMaybe<CaseCohortConnectionWhere>;
};

export type CaseCohortFieldInput = {
	connect?: InputMaybe<CaseCohortConnectFieldInput>;
	create?: InputMaybe<CaseCohortCreateFieldInput>;
};

export type CaseCohortRelationship = {
	__typename?: "CaseCohortRelationship";
	cursor: Scalars["String"];
	node: EnrollingPeriod;
};

export type CaseCohortUpdateConnectionInput = {
	node?: InputMaybe<EnrollingPeriodUpdateInput>;
};

export type CaseCohortUpdateFieldInput = {
	connect?: InputMaybe<CaseCohortConnectFieldInput>;
	create?: InputMaybe<CaseCohortCreateFieldInput>;
	delete?: InputMaybe<CaseCohortDeleteFieldInput>;
	disconnect?: InputMaybe<CaseCohortDisconnectFieldInput>;
	update?: InputMaybe<CaseCohortUpdateConnectionInput>;
	where?: InputMaybe<CaseCohortConnectionWhere>;
};

export type CaseConnectInput = {
	baseAgreement?: InputMaybe<CaseBaseAgreementConnectFieldInput>;
	claims?: InputMaybe<Array<CaseClaimsConnectFieldInput>>;
	cohort?: InputMaybe<CaseCohortConnectFieldInput>;
	coverageRequests?: InputMaybe<Array<CaseCoverageRequestsConnectFieldInput>>;
	disease?: InputMaybe<CaseDiseaseConnectFieldInput>;
	flexEntities?: InputMaybe<Array<CaseFlexEntitiesConnectFieldInput>>;
	financialDataPoints?: InputMaybe<Array<CaseFlexFinancialDataPointsConnectFieldInput>>;
	indication?: InputMaybe<CaseIndicationConnectFieldInput>;
	legalEntity?: InputMaybe<CaseLegalEntityConnectFieldInput>;
	patient?: InputMaybe<CasePatientConnectFieldInput>;
	preparations?: InputMaybe<Array<CasePreparationsConnectFieldInput>>;
	primaryIntervention?: InputMaybe<CasePrimaryInterventionConnectFieldInput>;
	recordBatches?: InputMaybe<Array<CaseRecordBatchesConnectFieldInput>>;
	stobContract?: InputMaybe<CaseStobContractConnectFieldInput>;
};

export type CaseConnectWhere = {
	node: CaseWhere;
};

export type CaseCoverageRequestsAggregateInput = {
	AND?: InputMaybe<Array<CaseCoverageRequestsAggregateInput>>;
	OR?: InputMaybe<Array<CaseCoverageRequestsAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<CaseCoverageRequestsNodeAggregationWhereInput>;
};

export type CaseCoverageRequestsConnectFieldInput = {
	connect?: InputMaybe<Array<CoverageRequestConnectInput>>;
	where?: InputMaybe<CoverageRequestConnectWhere>;
};

export type CaseCoverageRequestsConnection = {
	__typename?: "CaseCoverageRequestsConnection";
	edges: Array<CaseCoverageRequestsRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type CaseCoverageRequestsConnectionSort = {
	node?: InputMaybe<CoverageRequestSort>;
};

export type CaseCoverageRequestsConnectionWhere = {
	AND?: InputMaybe<Array<CaseCoverageRequestsConnectionWhere>>;
	OR?: InputMaybe<Array<CaseCoverageRequestsConnectionWhere>>;
	node?: InputMaybe<CoverageRequestWhere>;
	node_NOT?: InputMaybe<CoverageRequestWhere>;
};

export type CaseCoverageRequestsCreateFieldInput = {
	node: CoverageRequestCreateInput;
};

export type CaseCoverageRequestsDeleteFieldInput = {
	delete?: InputMaybe<CoverageRequestDeleteInput>;
	where?: InputMaybe<CaseCoverageRequestsConnectionWhere>;
};

export type CaseCoverageRequestsDisconnectFieldInput = {
	disconnect?: InputMaybe<CoverageRequestDisconnectInput>;
	where?: InputMaybe<CaseCoverageRequestsConnectionWhere>;
};

export type CaseCoverageRequestsFieldInput = {
	connect?: InputMaybe<Array<CaseCoverageRequestsConnectFieldInput>>;
	create?: InputMaybe<Array<CaseCoverageRequestsCreateFieldInput>>;
};

export type CaseCoverageRequestsNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<CaseCoverageRequestsNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<CaseCoverageRequestsNodeAggregationWhereInput>>;
	createdOn_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	duration_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	duration_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	duration_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	duration_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	duration_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	duration_EQUAL?: InputMaybe<Scalars["Int"]>;
	duration_GT?: InputMaybe<Scalars["Int"]>;
	duration_GTE?: InputMaybe<Scalars["Int"]>;
	duration_LT?: InputMaybe<Scalars["Int"]>;
	duration_LTE?: InputMaybe<Scalars["Int"]>;
	duration_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	duration_MAX_GT?: InputMaybe<Scalars["Int"]>;
	duration_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	duration_MAX_LT?: InputMaybe<Scalars["Int"]>;
	duration_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	duration_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	duration_MIN_GT?: InputMaybe<Scalars["Int"]>;
	duration_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	duration_MIN_LT?: InputMaybe<Scalars["Int"]>;
	duration_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	lastUpdatedOn_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_GT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_LT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_GT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_GTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_LT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_LTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	tenantId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	tenantId_EQUAL?: InputMaybe<Scalars["String"]>;
	tenantId_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type CaseCoverageRequestsRelationship = {
	__typename?: "CaseCoverageRequestsRelationship";
	cursor: Scalars["String"];
	node: CoverageRequest;
};

export type CaseCoverageRequestsUpdateConnectionInput = {
	node?: InputMaybe<CoverageRequestUpdateInput>;
};

export type CaseCoverageRequestsUpdateFieldInput = {
	connect?: InputMaybe<Array<CaseCoverageRequestsConnectFieldInput>>;
	create?: InputMaybe<Array<CaseCoverageRequestsCreateFieldInput>>;
	delete?: InputMaybe<Array<CaseCoverageRequestsDeleteFieldInput>>;
	disconnect?: InputMaybe<Array<CaseCoverageRequestsDisconnectFieldInput>>;
	update?: InputMaybe<CaseCoverageRequestsUpdateConnectionInput>;
	where?: InputMaybe<CaseCoverageRequestsConnectionWhere>;
};

export type CaseCreateInput = {
	actualAgreementId?: InputMaybe<Scalars["String"]>;
	agreementName?: InputMaybe<Scalars["String"]>;
	baseAgreement?: InputMaybe<CaseBaseAgreementFieldInput>;
	claims?: InputMaybe<CaseClaimsFieldInput>;
	cohort?: InputMaybe<CaseCohortFieldInput>;
	coverageRequests?: InputMaybe<CaseCoverageRequestsFieldInput>;
	creationDate: Scalars["Date"];
	disease?: InputMaybe<CaseDiseaseFieldInput>;
	flexEntities?: InputMaybe<CaseFlexEntitiesFieldInput>;
	financialDataPoints?: InputMaybe<CaseFlexFinancialDataPointsFieldInput>;
	id: Scalars["ID"];
	indication?: InputMaybe<CaseIndicationFieldInput>;
	isArchived: Scalars["Boolean"];
	isDeleted: Scalars["Boolean"];
	legalEntity?: InputMaybe<CaseLegalEntityFieldInput>;
	patient?: InputMaybe<CasePatientFieldInput>;
	patientInitials?: InputMaybe<Scalars["String"]>;
	patientInsuranceId?: InputMaybe<Scalars["String"]>;
	preparationBandName?: InputMaybe<Scalars["String"]>;
	preparationGenericName?: InputMaybe<Scalars["String"]>;
	preparations?: InputMaybe<CasePreparationsFieldInput>;
	primaryIntervention?: InputMaybe<CasePrimaryInterventionFieldInput>;
	recordBatches?: InputMaybe<CaseRecordBatchesFieldInput>;
	sourceTenantId?: InputMaybe<Scalars["String"]>;
	stobContract?: InputMaybe<CaseStobContractFieldInput>;
	submissionDate?: InputMaybe<Scalars["DateTime"]>;
	tenantIds?: InputMaybe<Array<Scalars["String"]>>;
	totalAmount?: InputMaybe<Scalars["Float"]>;
	unlimited?: InputMaybe<Scalars["Int"]>;
};

export type CaseDeleteInput = {
	baseAgreement?: InputMaybe<CaseBaseAgreementDeleteFieldInput>;
	claims?: InputMaybe<Array<CaseClaimsDeleteFieldInput>>;
	cohort?: InputMaybe<CaseCohortDeleteFieldInput>;
	coverageRequests?: InputMaybe<Array<CaseCoverageRequestsDeleteFieldInput>>;
	disease?: InputMaybe<CaseDiseaseDeleteFieldInput>;
	flexEntities?: InputMaybe<Array<CaseFlexEntitiesDeleteFieldInput>>;
	financialDataPoints?: InputMaybe<Array<CaseFlexFinancialDataPointsDeleteFieldInput>>;
	indication?: InputMaybe<CaseIndicationDeleteFieldInput>;
	legalEntity?: InputMaybe<CaseLegalEntityDeleteFieldInput>;
	patient?: InputMaybe<CasePatientDeleteFieldInput>;
	preparations?: InputMaybe<Array<CasePreparationsDeleteFieldInput>>;
	primaryIntervention?: InputMaybe<CasePrimaryInterventionDeleteFieldInput>;
	recordBatches?: InputMaybe<Array<CaseRecordBatchesDeleteFieldInput>>;
	stobContract?: InputMaybe<CaseStobContractDeleteFieldInput>;
};

export type CaseDisconnectInput = {
	baseAgreement?: InputMaybe<CaseBaseAgreementDisconnectFieldInput>;
	claims?: InputMaybe<Array<CaseClaimsDisconnectFieldInput>>;
	cohort?: InputMaybe<CaseCohortDisconnectFieldInput>;
	coverageRequests?: InputMaybe<Array<CaseCoverageRequestsDisconnectFieldInput>>;
	disease?: InputMaybe<CaseDiseaseDisconnectFieldInput>;
	flexEntities?: InputMaybe<Array<CaseFlexEntitiesDisconnectFieldInput>>;
	financialDataPoints?: InputMaybe<Array<CaseFlexFinancialDataPointsDisconnectFieldInput>>;
	indication?: InputMaybe<CaseIndicationDisconnectFieldInput>;
	legalEntity?: InputMaybe<CaseLegalEntityDisconnectFieldInput>;
	patient?: InputMaybe<CasePatientDisconnectFieldInput>;
	preparations?: InputMaybe<Array<CasePreparationsDisconnectFieldInput>>;
	primaryIntervention?: InputMaybe<CasePrimaryInterventionDisconnectFieldInput>;
	recordBatches?: InputMaybe<Array<CaseRecordBatchesDisconnectFieldInput>>;
	stobContract?: InputMaybe<CaseStobContractDisconnectFieldInput>;
};

export type CaseDiseaseAggregateInput = {
	AND?: InputMaybe<Array<CaseDiseaseAggregateInput>>;
	OR?: InputMaybe<Array<CaseDiseaseAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<CaseDiseaseNodeAggregationWhereInput>;
};

export type CaseDiseaseConnectFieldInput = {
	where?: InputMaybe<DiseaseConnectWhere>;
};

export type CaseDiseaseConnection = {
	__typename?: "CaseDiseaseConnection";
	edges: Array<CaseDiseaseRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type CaseDiseaseConnectionSort = {
	node?: InputMaybe<DiseaseSort>;
};

export type CaseDiseaseConnectionWhere = {
	AND?: InputMaybe<Array<CaseDiseaseConnectionWhere>>;
	OR?: InputMaybe<Array<CaseDiseaseConnectionWhere>>;
	node?: InputMaybe<DiseaseWhere>;
	node_NOT?: InputMaybe<DiseaseWhere>;
};

export type CaseDiseaseCreateFieldInput = {
	node: DiseaseCreateInput;
};

export type CaseDiseaseDeleteFieldInput = {
	where?: InputMaybe<CaseDiseaseConnectionWhere>;
};

export type CaseDiseaseDisconnectFieldInput = {
	where?: InputMaybe<CaseDiseaseConnectionWhere>;
};

export type CaseDiseaseFieldInput = {
	connect?: InputMaybe<CaseDiseaseConnectFieldInput>;
	create?: InputMaybe<CaseDiseaseCreateFieldInput>;
};

export type CaseDiseaseNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<CaseDiseaseNodeAggregationWhereInput>>;
	Icd10Code_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	Icd10Code_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	Icd10Code_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	Icd10Code_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	Icd10Code_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	Icd10Code_EQUAL?: InputMaybe<Scalars["String"]>;
	Icd10Code_GT?: InputMaybe<Scalars["Int"]>;
	Icd10Code_GTE?: InputMaybe<Scalars["Int"]>;
	Icd10Code_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Icd10Code_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	Icd10Code_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	Icd10Code_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	Icd10Code_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	Icd10Code_LT?: InputMaybe<Scalars["Int"]>;
	Icd10Code_LTE?: InputMaybe<Scalars["Int"]>;
	Icd10Code_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Icd10Code_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	Icd10Code_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	Icd10Code_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	Icd10Code_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	Name_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	Name_EQUAL?: InputMaybe<Scalars["String"]>;
	Name_GT?: InputMaybe<Scalars["Int"]>;
	Name_GTE?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	Name_LT?: InputMaybe<Scalars["Int"]>;
	Name_LTE?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	OR?: InputMaybe<Array<CaseDiseaseNodeAggregationWhereInput>>;
};

export type CaseDiseaseRelationship = {
	__typename?: "CaseDiseaseRelationship";
	cursor: Scalars["String"];
	node: Disease;
};

export type CaseDiseaseUpdateConnectionInput = {
	node?: InputMaybe<DiseaseUpdateInput>;
};

export type CaseDiseaseUpdateFieldInput = {
	connect?: InputMaybe<CaseDiseaseConnectFieldInput>;
	create?: InputMaybe<CaseDiseaseCreateFieldInput>;
	delete?: InputMaybe<CaseDiseaseDeleteFieldInput>;
	disconnect?: InputMaybe<CaseDiseaseDisconnectFieldInput>;
	update?: InputMaybe<CaseDiseaseUpdateConnectionInput>;
	where?: InputMaybe<CaseDiseaseConnectionWhere>;
};

export type CaseFinancialDataPointsAggregateInput = {
	AND?: InputMaybe<Array<CaseFinancialDataPointsAggregateInput>>;
	OR?: InputMaybe<Array<CaseFinancialDataPointsAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<CaseFinancialDataPointsNodeAggregationWhereInput>;
};

export type CaseFinancialDataPointsConnectFieldInput = {
	connect?: InputMaybe<Array<FinancialDataPointConnectInput>>;
	where?: InputMaybe<FinancialDataPointConnectWhere>;
};

export type CaseFinancialDataPointsConnection = {
	__typename?: "CaseFinancialDataPointsConnection";
	edges: Array<CaseFinancialDataPointsRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type CaseFinancialDataPointsConnectionSort = {
	node?: InputMaybe<FinancialDataPointSort>;
};

export type CaseFinancialDataPointsConnectionWhere = {
	AND?: InputMaybe<Array<CaseFinancialDataPointsConnectionWhere>>;
	OR?: InputMaybe<Array<CaseFinancialDataPointsConnectionWhere>>;
	node?: InputMaybe<FinancialDataPointWhere>;
	node_NOT?: InputMaybe<FinancialDataPointWhere>;
};

export type CaseFinancialDataPointsCreateFieldInput = {
	node: FinancialDataPointCreateInput;
};

export type CaseFinancialDataPointsDeleteFieldInput = {
	delete?: InputMaybe<FinancialDataPointDeleteInput>;
	where?: InputMaybe<CaseFinancialDataPointsConnectionWhere>;
};

export type CaseFinancialDataPointsDisconnectFieldInput = {
	disconnect?: InputMaybe<FinancialDataPointDisconnectInput>;
	where?: InputMaybe<CaseFinancialDataPointsConnectionWhere>;
};

export type CaseFinancialDataPointsFieldInput = {
	connect?: InputMaybe<Array<CaseFinancialDataPointsConnectFieldInput>>;
	create?: InputMaybe<Array<CaseFinancialDataPointsCreateFieldInput>>;
};

export type CaseFinancialDataPointsNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<CaseFinancialDataPointsNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<CaseFinancialDataPointsNodeAggregationWhereInput>>;
	basePrice_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	basePrice_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	basePrice_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	basePrice_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	basePrice_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	basePrice_EQUAL?: InputMaybe<Scalars["Float"]>;
	basePrice_GT?: InputMaybe<Scalars["Float"]>;
	basePrice_GTE?: InputMaybe<Scalars["Float"]>;
	basePrice_LT?: InputMaybe<Scalars["Float"]>;
	basePrice_LTE?: InputMaybe<Scalars["Float"]>;
	basePrice_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	basePrice_MAX_GT?: InputMaybe<Scalars["Float"]>;
	basePrice_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	basePrice_MAX_LT?: InputMaybe<Scalars["Float"]>;
	basePrice_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	basePrice_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	basePrice_MIN_GT?: InputMaybe<Scalars["Float"]>;
	basePrice_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	basePrice_MIN_LT?: InputMaybe<Scalars["Float"]>;
	basePrice_MIN_LTE?: InputMaybe<Scalars["Float"]>;
	currencyCode_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	currencyCode_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	currencyCode_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	currencyCode_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	currencyCode_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	currencyCode_EQUAL?: InputMaybe<Scalars["String"]>;
	currencyCode_GT?: InputMaybe<Scalars["Int"]>;
	currencyCode_GTE?: InputMaybe<Scalars["Int"]>;
	currencyCode_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	currencyCode_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	currencyCode_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	currencyCode_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	currencyCode_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	currencyCode_LT?: InputMaybe<Scalars["Int"]>;
	currencyCode_LTE?: InputMaybe<Scalars["Int"]>;
	currencyCode_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	currencyCode_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	currencyCode_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	currencyCode_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	currencyCode_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	evaluationSnapshot_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	evaluationSnapshot_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	evaluationSnapshot_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	evaluationSnapshot_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	evaluationSnapshot_EQUAL?: InputMaybe<Scalars["String"]>;
	evaluationSnapshot_GT?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_GTE?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_LT?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_LTE?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	generatedUuid_EQUAL?: InputMaybe<Scalars["ID"]>;
	payablePercentage_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	payablePercentage_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	payablePercentage_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	payablePercentage_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	payablePercentage_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	payablePercentage_EQUAL?: InputMaybe<Scalars["Float"]>;
	payablePercentage_GT?: InputMaybe<Scalars["Float"]>;
	payablePercentage_GTE?: InputMaybe<Scalars["Float"]>;
	payablePercentage_LT?: InputMaybe<Scalars["Float"]>;
	payablePercentage_LTE?: InputMaybe<Scalars["Float"]>;
	payablePercentage_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	payablePercentage_MAX_GT?: InputMaybe<Scalars["Float"]>;
	payablePercentage_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	payablePercentage_MAX_LT?: InputMaybe<Scalars["Float"]>;
	payablePercentage_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	payablePercentage_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	payablePercentage_MIN_GT?: InputMaybe<Scalars["Float"]>;
	payablePercentage_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	payablePercentage_MIN_LT?: InputMaybe<Scalars["Float"]>;
	payablePercentage_MIN_LTE?: InputMaybe<Scalars["Float"]>;
	payable_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	payable_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	payable_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	payable_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	payable_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	payable_EQUAL?: InputMaybe<Scalars["Float"]>;
	payable_GT?: InputMaybe<Scalars["Float"]>;
	payable_GTE?: InputMaybe<Scalars["Float"]>;
	payable_LT?: InputMaybe<Scalars["Float"]>;
	payable_LTE?: InputMaybe<Scalars["Float"]>;
	payable_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	payable_MAX_GT?: InputMaybe<Scalars["Float"]>;
	payable_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	payable_MAX_LT?: InputMaybe<Scalars["Float"]>;
	payable_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	payable_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	payable_MIN_GT?: InputMaybe<Scalars["Float"]>;
	payable_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	payable_MIN_LT?: InputMaybe<Scalars["Float"]>;
	payable_MIN_LTE?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	quantity_EQUAL?: InputMaybe<Scalars["Float"]>;
	quantity_GT?: InputMaybe<Scalars["Float"]>;
	quantity_GTE?: InputMaybe<Scalars["Float"]>;
	quantity_LT?: InputMaybe<Scalars["Float"]>;
	quantity_LTE?: InputMaybe<Scalars["Float"]>;
	quantity_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	quantity_MAX_GT?: InputMaybe<Scalars["Float"]>;
	quantity_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	quantity_MAX_LT?: InputMaybe<Scalars["Float"]>;
	quantity_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	quantity_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	quantity_MIN_GT?: InputMaybe<Scalars["Float"]>;
	quantity_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	quantity_MIN_LT?: InputMaybe<Scalars["Float"]>;
	quantity_MIN_LTE?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_EQUAL?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_GT?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_GTE?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_LT?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_LTE?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_MAX_GT?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_MAX_LT?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_MIN_GT?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_MIN_LT?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_MIN_LTE?: InputMaybe<Scalars["Float"]>;
	refundable_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	refundable_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	refundable_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	refundable_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	refundable_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	refundable_EQUAL?: InputMaybe<Scalars["Float"]>;
	refundable_GT?: InputMaybe<Scalars["Float"]>;
	refundable_GTE?: InputMaybe<Scalars["Float"]>;
	refundable_LT?: InputMaybe<Scalars["Float"]>;
	refundable_LTE?: InputMaybe<Scalars["Float"]>;
	refundable_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	refundable_MAX_GT?: InputMaybe<Scalars["Float"]>;
	refundable_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	refundable_MAX_LT?: InputMaybe<Scalars["Float"]>;
	refundable_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	refundable_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	refundable_MIN_GT?: InputMaybe<Scalars["Float"]>;
	refundable_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	refundable_MIN_LT?: InputMaybe<Scalars["Float"]>;
	refundable_MIN_LTE?: InputMaybe<Scalars["Float"]>;
	uuid_EQUAL?: InputMaybe<Scalars["ID"]>;
	variablePercentage_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	variablePercentage_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	variablePercentage_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	variablePercentage_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	variablePercentage_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	variablePercentage_EQUAL?: InputMaybe<Scalars["Float"]>;
	variablePercentage_GT?: InputMaybe<Scalars["Float"]>;
	variablePercentage_GTE?: InputMaybe<Scalars["Float"]>;
	variablePercentage_LT?: InputMaybe<Scalars["Float"]>;
	variablePercentage_LTE?: InputMaybe<Scalars["Float"]>;
	variablePercentage_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	variablePercentage_MAX_GT?: InputMaybe<Scalars["Float"]>;
	variablePercentage_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	variablePercentage_MAX_LT?: InputMaybe<Scalars["Float"]>;
	variablePercentage_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	variablePercentage_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	variablePercentage_MIN_GT?: InputMaybe<Scalars["Float"]>;
	variablePercentage_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	variablePercentage_MIN_LT?: InputMaybe<Scalars["Float"]>;
	variablePercentage_MIN_LTE?: InputMaybe<Scalars["Float"]>;
	variable_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	variable_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	variable_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	variable_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	variable_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	variable_EQUAL?: InputMaybe<Scalars["Float"]>;
	variable_GT?: InputMaybe<Scalars["Float"]>;
	variable_GTE?: InputMaybe<Scalars["Float"]>;
	variable_LT?: InputMaybe<Scalars["Float"]>;
	variable_LTE?: InputMaybe<Scalars["Float"]>;
	variable_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	variable_MAX_GT?: InputMaybe<Scalars["Float"]>;
	variable_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	variable_MAX_LT?: InputMaybe<Scalars["Float"]>;
	variable_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	variable_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	variable_MIN_GT?: InputMaybe<Scalars["Float"]>;
	variable_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	variable_MIN_LT?: InputMaybe<Scalars["Float"]>;
	variable_MIN_LTE?: InputMaybe<Scalars["Float"]>;
};

export type CaseFinancialDataPointsRelationship = {
	__typename?: "CaseFinancialDataPointsRelationship";
	cursor: Scalars["String"];
	node: FinancialDataPoint;
};

export type CaseFinancialDataPointsUpdateConnectionInput = {
	node?: InputMaybe<FinancialDataPointUpdateInput>;
};

export type CaseFinancialDataPointsUpdateFieldInput = {
	connect?: InputMaybe<Array<CaseFinancialDataPointsConnectFieldInput>>;
	create?: InputMaybe<Array<CaseFinancialDataPointsCreateFieldInput>>;
	delete?: InputMaybe<Array<CaseFinancialDataPointsDeleteFieldInput>>;
	disconnect?: InputMaybe<Array<CaseFinancialDataPointsDisconnectFieldInput>>;
	update?: InputMaybe<CaseFinancialDataPointsUpdateConnectionInput>;
	where?: InputMaybe<CaseFinancialDataPointsConnectionWhere>;
};

export type CaseFlexEntitiesAggregateInput = {
	AND?: InputMaybe<Array<CaseFlexEntitiesAggregateInput>>;
	OR?: InputMaybe<Array<CaseFlexEntitiesAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<CaseFlexEntitiesNodeAggregationWhereInput>;
};

export type CaseFlexEntitiesConnectFieldInput = {
	connect?: InputMaybe<Array<FlexEntityConnectInput>>;
	where?: InputMaybe<FlexEntityConnectWhere>;
};

export type CaseFlexEntitiesConnection = {
	__typename?: "CaseFlexEntitiesConnection";
	edges: Array<CaseFlexEntitiesRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type CaseFlexEntitiesConnectionSort = {
	node?: InputMaybe<FlexEntitySort>;
};

export type CaseFlexEntitiesConnectionWhere = {
	AND?: InputMaybe<Array<CaseFlexEntitiesConnectionWhere>>;
	OR?: InputMaybe<Array<CaseFlexEntitiesConnectionWhere>>;
	node?: InputMaybe<FlexEntityWhere>;
	node_NOT?: InputMaybe<FlexEntityWhere>;
};

export type CaseFlexEntitiesCreateFieldInput = {
	node: FlexEntityCreateInput;
};

export type CaseFlexEntitiesDeleteFieldInput = {
	delete?: InputMaybe<FlexEntityDeleteInput>;
	where?: InputMaybe<CaseFlexEntitiesConnectionWhere>;
};

export type CaseFlexEntitiesDisconnectFieldInput = {
	disconnect?: InputMaybe<FlexEntityDisconnectInput>;
	where?: InputMaybe<CaseFlexEntitiesConnectionWhere>;
};

export type CaseFlexEntitiesFieldInput = {
	connect?: InputMaybe<Array<CaseFlexEntitiesConnectFieldInput>>;
	create?: InputMaybe<Array<CaseFlexEntitiesCreateFieldInput>>;
};

export type CaseFlexEntitiesNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<CaseFlexEntitiesNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<CaseFlexEntitiesNodeAggregationWhereInput>>;
	administrationDate_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_GT?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_GTE?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_LT?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_LTE?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdByName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	createdByName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	createdByName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	createdByName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	createdByName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	createdByName_EQUAL?: InputMaybe<Scalars["String"]>;
	createdByName_GT?: InputMaybe<Scalars["Int"]>;
	createdByName_GTE?: InputMaybe<Scalars["Int"]>;
	createdByName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	createdByName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	createdByName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	createdByName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	createdByName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	createdByName_LT?: InputMaybe<Scalars["Int"]>;
	createdByName_LTE?: InputMaybe<Scalars["Int"]>;
	createdByName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	createdByName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	createdByName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	createdByName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	createdByName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	createdOn_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	data_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	data_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	data_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	data_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	data_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	data_EQUAL?: InputMaybe<Scalars["String"]>;
	data_GT?: InputMaybe<Scalars["Int"]>;
	data_GTE?: InputMaybe<Scalars["Int"]>;
	data_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	data_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	data_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	data_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	data_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	data_LT?: InputMaybe<Scalars["Int"]>;
	data_LTE?: InputMaybe<Scalars["Int"]>;
	data_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	data_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	data_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	data_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	data_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	lastUpdatedOn_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_GT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_LT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	patientId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	patientId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	patientId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	patientId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	patientId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	patientId_EQUAL?: InputMaybe<Scalars["String"]>;
	patientId_GT?: InputMaybe<Scalars["Int"]>;
	patientId_GTE?: InputMaybe<Scalars["Int"]>;
	patientId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	patientId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	patientId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	patientId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	patientId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	patientId_LT?: InputMaybe<Scalars["Int"]>;
	patientId_LTE?: InputMaybe<Scalars["Int"]>;
	patientId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	patientId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	patientId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	patientId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	patientId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	preparationBrandNames_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	preparationBrandNames_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	preparationBrandNames_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	preparationBrandNames_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	preparationBrandNames_EQUAL?: InputMaybe<Scalars["String"]>;
	preparationBrandNames_GT?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_GTE?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_LT?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_LTE?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	preparationGenericNames_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	preparationGenericNames_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	preparationGenericNames_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	preparationGenericNames_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	preparationGenericNames_EQUAL?: InputMaybe<Scalars["String"]>;
	preparationGenericNames_GT?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_GTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_LT?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_LTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	quantity_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	quantity_EQUAL?: InputMaybe<Scalars["Int"]>;
	quantity_GT?: InputMaybe<Scalars["Int"]>;
	quantity_GTE?: InputMaybe<Scalars["Int"]>;
	quantity_LT?: InputMaybe<Scalars["Int"]>;
	quantity_LTE?: InputMaybe<Scalars["Int"]>;
	quantity_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	quantity_MAX_GT?: InputMaybe<Scalars["Int"]>;
	quantity_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	quantity_MAX_LT?: InputMaybe<Scalars["Int"]>;
	quantity_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	quantity_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	quantity_MIN_GT?: InputMaybe<Scalars["Int"]>;
	quantity_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	quantity_MIN_LT?: InputMaybe<Scalars["Int"]>;
	quantity_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	tenantId_EQUAL?: InputMaybe<Scalars["String"]>;
	tenantId_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	unlimited_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	unlimited_EQUAL?: InputMaybe<Scalars["Int"]>;
	unlimited_GT?: InputMaybe<Scalars["Int"]>;
	unlimited_GTE?: InputMaybe<Scalars["Int"]>;
	unlimited_LT?: InputMaybe<Scalars["Int"]>;
	unlimited_LTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_GT?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_LT?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_GT?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_LT?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	uuid_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	uuid_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	uuid_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	uuid_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	uuid_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	uuid_EQUAL?: InputMaybe<Scalars["String"]>;
	uuid_GT?: InputMaybe<Scalars["Int"]>;
	uuid_GTE?: InputMaybe<Scalars["Int"]>;
	uuid_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	uuid_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	uuid_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	uuid_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	uuid_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	uuid_LT?: InputMaybe<Scalars["Int"]>;
	uuid_LTE?: InputMaybe<Scalars["Int"]>;
	uuid_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	uuid_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	uuid_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	uuid_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	uuid_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type CaseFlexEntitiesRelationship = {
	__typename?: "CaseFlexEntitiesRelationship";
	cursor: Scalars["String"];
	node: FlexEntity;
};

export type CaseFlexEntitiesUpdateConnectionInput = {
	node?: InputMaybe<FlexEntityUpdateInput>;
};

export type CaseFlexEntitiesUpdateFieldInput = {
	connect?: InputMaybe<Array<CaseFlexEntitiesConnectFieldInput>>;
	create?: InputMaybe<Array<CaseFlexEntitiesCreateFieldInput>>;
	delete?: InputMaybe<Array<CaseFlexEntitiesDeleteFieldInput>>;
	disconnect?: InputMaybe<Array<CaseFlexEntitiesDisconnectFieldInput>>;
	update?: InputMaybe<CaseFlexEntitiesUpdateConnectionInput>;
	where?: InputMaybe<CaseFlexEntitiesConnectionWhere>;
};

export type CaseFlexFinancialDataPointsAggregateInput = {
	AND?: InputMaybe<Array<CaseFlexFinancialDataPointsAggregateInput>>;
	OR?: InputMaybe<Array<CaseFlexFinancialDataPointsAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<CaseFlexFinancialDataPointsNodeAggregationWhereInput>;
};

export type CaseFlexFinancialDataPointsConnectFieldInput = {
	connect?: InputMaybe<Array<FlexFinancialDataPointConnectInput>>;
	where?: InputMaybe<FlexFinancialDataPointConnectWhere>;
};

export type CaseFlexFinancialDataPointsConnection = {
	__typename?: "CaseFlexFinancialDataPointsConnection";
	edges: Array<CaseFlexFinancialDataPointsRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type CaseFlexFinancialDataPointsConnectionSort = {
	node?: InputMaybe<FlexFinancialDataPointSort>;
};

export type CaseFlexFinancialDataPointsConnectionWhere = {
	AND?: InputMaybe<Array<CaseFlexFinancialDataPointsConnectionWhere>>;
	OR?: InputMaybe<Array<CaseFlexFinancialDataPointsConnectionWhere>>;
	node?: InputMaybe<FlexFinancialDataPointWhere>;
	node_NOT?: InputMaybe<FlexFinancialDataPointWhere>;
};

export type CaseFlexFinancialDataPointsCreateFieldInput = {
	node: FlexFinancialDataPointCreateInput;
};

export type CaseFlexFinancialDataPointsDeleteFieldInput = {
	delete?: InputMaybe<FlexFinancialDataPointDeleteInput>;
	where?: InputMaybe<CaseFlexFinancialDataPointsConnectionWhere>;
};

export type CaseFlexFinancialDataPointsDisconnectFieldInput = {
	disconnect?: InputMaybe<FlexFinancialDataPointDisconnectInput>;
	where?: InputMaybe<CaseFlexFinancialDataPointsConnectionWhere>;
};

export type CaseFlexFinancialDataPointsFieldInput = {
	connect?: InputMaybe<Array<CaseFlexFinancialDataPointsConnectFieldInput>>;
	create?: InputMaybe<Array<CaseFlexFinancialDataPointsCreateFieldInput>>;
};

export type CaseFlexFinancialDataPointsNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<CaseFlexFinancialDataPointsNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<CaseFlexFinancialDataPointsNodeAggregationWhereInput>>;
	basePrice_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	basePrice_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	basePrice_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	basePrice_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	basePrice_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	basePrice_EQUAL?: InputMaybe<Scalars["Float"]>;
	basePrice_GT?: InputMaybe<Scalars["Float"]>;
	basePrice_GTE?: InputMaybe<Scalars["Float"]>;
	basePrice_LT?: InputMaybe<Scalars["Float"]>;
	basePrice_LTE?: InputMaybe<Scalars["Float"]>;
	basePrice_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	basePrice_MAX_GT?: InputMaybe<Scalars["Float"]>;
	basePrice_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	basePrice_MAX_LT?: InputMaybe<Scalars["Float"]>;
	basePrice_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	basePrice_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	basePrice_MIN_GT?: InputMaybe<Scalars["Float"]>;
	basePrice_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	basePrice_MIN_LT?: InputMaybe<Scalars["Float"]>;
	basePrice_MIN_LTE?: InputMaybe<Scalars["Float"]>;
	currencyCode_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	currencyCode_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	currencyCode_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	currencyCode_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	currencyCode_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	currencyCode_EQUAL?: InputMaybe<Scalars["String"]>;
	currencyCode_GT?: InputMaybe<Scalars["Int"]>;
	currencyCode_GTE?: InputMaybe<Scalars["Int"]>;
	currencyCode_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	currencyCode_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	currencyCode_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	currencyCode_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	currencyCode_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	currencyCode_LT?: InputMaybe<Scalars["Int"]>;
	currencyCode_LTE?: InputMaybe<Scalars["Int"]>;
	currencyCode_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	currencyCode_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	currencyCode_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	currencyCode_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	currencyCode_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	evaluationSnapshot_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	evaluationSnapshot_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	evaluationSnapshot_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	evaluationSnapshot_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	evaluationSnapshot_EQUAL?: InputMaybe<Scalars["String"]>;
	evaluationSnapshot_GT?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_GTE?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_LT?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_LTE?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	generatedUuid_EQUAL?: InputMaybe<Scalars["ID"]>;
	payablePercentage_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	payablePercentage_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	payablePercentage_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	payablePercentage_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	payablePercentage_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	payablePercentage_EQUAL?: InputMaybe<Scalars["Float"]>;
	payablePercentage_GT?: InputMaybe<Scalars["Float"]>;
	payablePercentage_GTE?: InputMaybe<Scalars["Float"]>;
	payablePercentage_LT?: InputMaybe<Scalars["Float"]>;
	payablePercentage_LTE?: InputMaybe<Scalars["Float"]>;
	payablePercentage_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	payablePercentage_MAX_GT?: InputMaybe<Scalars["Float"]>;
	payablePercentage_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	payablePercentage_MAX_LT?: InputMaybe<Scalars["Float"]>;
	payablePercentage_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	payablePercentage_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	payablePercentage_MIN_GT?: InputMaybe<Scalars["Float"]>;
	payablePercentage_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	payablePercentage_MIN_LT?: InputMaybe<Scalars["Float"]>;
	payablePercentage_MIN_LTE?: InputMaybe<Scalars["Float"]>;
	payable_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	payable_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	payable_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	payable_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	payable_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	payable_EQUAL?: InputMaybe<Scalars["Float"]>;
	payable_GT?: InputMaybe<Scalars["Float"]>;
	payable_GTE?: InputMaybe<Scalars["Float"]>;
	payable_LT?: InputMaybe<Scalars["Float"]>;
	payable_LTE?: InputMaybe<Scalars["Float"]>;
	payable_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	payable_MAX_GT?: InputMaybe<Scalars["Float"]>;
	payable_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	payable_MAX_LT?: InputMaybe<Scalars["Float"]>;
	payable_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	payable_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	payable_MIN_GT?: InputMaybe<Scalars["Float"]>;
	payable_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	payable_MIN_LT?: InputMaybe<Scalars["Float"]>;
	payable_MIN_LTE?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	quantity_EQUAL?: InputMaybe<Scalars["Float"]>;
	quantity_GT?: InputMaybe<Scalars["Float"]>;
	quantity_GTE?: InputMaybe<Scalars["Float"]>;
	quantity_LT?: InputMaybe<Scalars["Float"]>;
	quantity_LTE?: InputMaybe<Scalars["Float"]>;
	quantity_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	quantity_MAX_GT?: InputMaybe<Scalars["Float"]>;
	quantity_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	quantity_MAX_LT?: InputMaybe<Scalars["Float"]>;
	quantity_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	quantity_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	quantity_MIN_GT?: InputMaybe<Scalars["Float"]>;
	quantity_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	quantity_MIN_LT?: InputMaybe<Scalars["Float"]>;
	quantity_MIN_LTE?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_EQUAL?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_GT?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_GTE?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_LT?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_LTE?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_MAX_GT?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_MAX_LT?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_MIN_GT?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_MIN_LT?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_MIN_LTE?: InputMaybe<Scalars["Float"]>;
	refundable_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	refundable_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	refundable_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	refundable_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	refundable_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	refundable_EQUAL?: InputMaybe<Scalars["Float"]>;
	refundable_GT?: InputMaybe<Scalars["Float"]>;
	refundable_GTE?: InputMaybe<Scalars["Float"]>;
	refundable_LT?: InputMaybe<Scalars["Float"]>;
	refundable_LTE?: InputMaybe<Scalars["Float"]>;
	refundable_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	refundable_MAX_GT?: InputMaybe<Scalars["Float"]>;
	refundable_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	refundable_MAX_LT?: InputMaybe<Scalars["Float"]>;
	refundable_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	refundable_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	refundable_MIN_GT?: InputMaybe<Scalars["Float"]>;
	refundable_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	refundable_MIN_LT?: InputMaybe<Scalars["Float"]>;
	refundable_MIN_LTE?: InputMaybe<Scalars["Float"]>;
	uuid_EQUAL?: InputMaybe<Scalars["ID"]>;
	variablePercentage_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	variablePercentage_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	variablePercentage_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	variablePercentage_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	variablePercentage_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	variablePercentage_EQUAL?: InputMaybe<Scalars["Float"]>;
	variablePercentage_GT?: InputMaybe<Scalars["Float"]>;
	variablePercentage_GTE?: InputMaybe<Scalars["Float"]>;
	variablePercentage_LT?: InputMaybe<Scalars["Float"]>;
	variablePercentage_LTE?: InputMaybe<Scalars["Float"]>;
	variablePercentage_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	variablePercentage_MAX_GT?: InputMaybe<Scalars["Float"]>;
	variablePercentage_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	variablePercentage_MAX_LT?: InputMaybe<Scalars["Float"]>;
	variablePercentage_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	variablePercentage_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	variablePercentage_MIN_GT?: InputMaybe<Scalars["Float"]>;
	variablePercentage_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	variablePercentage_MIN_LT?: InputMaybe<Scalars["Float"]>;
	variablePercentage_MIN_LTE?: InputMaybe<Scalars["Float"]>;
	variable_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	variable_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	variable_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	variable_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	variable_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	variable_EQUAL?: InputMaybe<Scalars["Float"]>;
	variable_GT?: InputMaybe<Scalars["Float"]>;
	variable_GTE?: InputMaybe<Scalars["Float"]>;
	variable_LT?: InputMaybe<Scalars["Float"]>;
	variable_LTE?: InputMaybe<Scalars["Float"]>;
	variable_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	variable_MAX_GT?: InputMaybe<Scalars["Float"]>;
	variable_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	variable_MAX_LT?: InputMaybe<Scalars["Float"]>;
	variable_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	variable_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	variable_MIN_GT?: InputMaybe<Scalars["Float"]>;
	variable_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	variable_MIN_LT?: InputMaybe<Scalars["Float"]>;
	variable_MIN_LTE?: InputMaybe<Scalars["Float"]>;
};

export type CaseFlexFinancialDataPointsRelationship = {
	__typename?: "CaseFlexFinancialDataPointsRelationship";
	cursor: Scalars["String"];
	node: FlexFinancialDataPoint;
};

export type CaseFlexFinancialDataPointsUpdateConnectionInput = {
	node?: InputMaybe<FlexFinancialDataPointUpdateInput>;
};

export type CaseFlexFinancialDataPointsUpdateFieldInput = {
	connect?: InputMaybe<Array<CaseFlexFinancialDataPointsConnectFieldInput>>;
	create?: InputMaybe<Array<CaseFlexFinancialDataPointsCreateFieldInput>>;
	delete?: InputMaybe<Array<CaseFlexFinancialDataPointsDeleteFieldInput>>;
	disconnect?: InputMaybe<Array<CaseFlexFinancialDataPointsDisconnectFieldInput>>;
	update?: InputMaybe<CaseFlexFinancialDataPointsUpdateConnectionInput>;
	where?: InputMaybe<CaseFlexFinancialDataPointsConnectionWhere>;
};

export type CaseIndicationAggregateInput = {
	AND?: InputMaybe<Array<CaseIndicationAggregateInput>>;
	OR?: InputMaybe<Array<CaseIndicationAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<CaseIndicationNodeAggregationWhereInput>;
};

export type CaseIndicationConnectFieldInput = {
	where?: InputMaybe<IndicationConnectWhere>;
};

export type CaseIndicationConnection = {
	__typename?: "CaseIndicationConnection";
	edges: Array<CaseIndicationRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type CaseIndicationConnectionSort = {
	node?: InputMaybe<IndicationSort>;
};

export type CaseIndicationConnectionWhere = {
	AND?: InputMaybe<Array<CaseIndicationConnectionWhere>>;
	OR?: InputMaybe<Array<CaseIndicationConnectionWhere>>;
	node?: InputMaybe<IndicationWhere>;
	node_NOT?: InputMaybe<IndicationWhere>;
};

export type CaseIndicationCreateFieldInput = {
	node: IndicationCreateInput;
};

export type CaseIndicationDeleteFieldInput = {
	where?: InputMaybe<CaseIndicationConnectionWhere>;
};

export type CaseIndicationDisconnectFieldInput = {
	where?: InputMaybe<CaseIndicationConnectionWhere>;
};

export type CaseIndicationFieldInput = {
	connect?: InputMaybe<CaseIndicationConnectFieldInput>;
	create?: InputMaybe<CaseIndicationCreateFieldInput>;
};

export type CaseIndicationNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<CaseIndicationNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<CaseIndicationNodeAggregationWhereInput>>;
	bagCode_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	bagCode_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	bagCode_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	bagCode_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	bagCode_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	bagCode_EQUAL?: InputMaybe<Scalars["String"]>;
	bagCode_GT?: InputMaybe<Scalars["Int"]>;
	bagCode_GTE?: InputMaybe<Scalars["Int"]>;
	bagCode_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	bagCode_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	bagCode_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	bagCode_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	bagCode_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	bagCode_LT?: InputMaybe<Scalars["Int"]>;
	bagCode_LTE?: InputMaybe<Scalars["Int"]>;
	bagCode_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	bagCode_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	bagCode_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	bagCode_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	bagCode_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	code_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	code_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	code_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	code_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	code_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	code_EQUAL?: InputMaybe<Scalars["String"]>;
	code_GT?: InputMaybe<Scalars["Int"]>;
	code_GTE?: InputMaybe<Scalars["Int"]>;
	code_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	code_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	code_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	code_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	code_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	code_LT?: InputMaybe<Scalars["Int"]>;
	code_LTE?: InputMaybe<Scalars["Int"]>;
	code_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	code_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	code_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	code_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	code_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	intent_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	intent_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	intent_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	intent_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	intent_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	intent_EQUAL?: InputMaybe<Scalars["String"]>;
	intent_GT?: InputMaybe<Scalars["Int"]>;
	intent_GTE?: InputMaybe<Scalars["Int"]>;
	intent_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	intent_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	intent_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	intent_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	intent_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	intent_LT?: InputMaybe<Scalars["Int"]>;
	intent_LTE?: InputMaybe<Scalars["Int"]>;
	intent_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	intent_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	intent_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	intent_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	intent_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	line_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	line_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	line_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	line_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	line_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	line_EQUAL?: InputMaybe<Scalars["String"]>;
	line_GT?: InputMaybe<Scalars["Int"]>;
	line_GTE?: InputMaybe<Scalars["Int"]>;
	line_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	line_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	line_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	line_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	line_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	line_LT?: InputMaybe<Scalars["Int"]>;
	line_LTE?: InputMaybe<Scalars["Int"]>;
	line_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	line_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	line_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	line_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	line_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	mutation_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	mutation_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	mutation_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	mutation_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	mutation_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	mutation_EQUAL?: InputMaybe<Scalars["String"]>;
	mutation_GT?: InputMaybe<Scalars["Int"]>;
	mutation_GTE?: InputMaybe<Scalars["Int"]>;
	mutation_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	mutation_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	mutation_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	mutation_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	mutation_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	mutation_LT?: InputMaybe<Scalars["Int"]>;
	mutation_LTE?: InputMaybe<Scalars["Int"]>;
	mutation_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	mutation_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	mutation_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	mutation_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	mutation_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	type_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	type_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	type_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	type_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	type_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	type_EQUAL?: InputMaybe<Scalars["String"]>;
	type_GT?: InputMaybe<Scalars["Int"]>;
	type_GTE?: InputMaybe<Scalars["Int"]>;
	type_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	type_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	type_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	type_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	type_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	type_LT?: InputMaybe<Scalars["Int"]>;
	type_LTE?: InputMaybe<Scalars["Int"]>;
	type_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	type_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	type_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	type_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	type_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type CaseIndicationRelationship = {
	__typename?: "CaseIndicationRelationship";
	cursor: Scalars["String"];
	node: Indication;
};

export type CaseIndicationUpdateConnectionInput = {
	node?: InputMaybe<IndicationUpdateInput>;
};

export type CaseIndicationUpdateFieldInput = {
	connect?: InputMaybe<CaseIndicationConnectFieldInput>;
	create?: InputMaybe<CaseIndicationCreateFieldInput>;
	delete?: InputMaybe<CaseIndicationDeleteFieldInput>;
	disconnect?: InputMaybe<CaseIndicationDisconnectFieldInput>;
	update?: InputMaybe<CaseIndicationUpdateConnectionInput>;
	where?: InputMaybe<CaseIndicationConnectionWhere>;
};

export type CaseLegalEntityAggregateInput = {
	AND?: InputMaybe<Array<CaseLegalEntityAggregateInput>>;
	OR?: InputMaybe<Array<CaseLegalEntityAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<CaseLegalEntityNodeAggregationWhereInput>;
};

export type CaseLegalEntityConnectFieldInput = {
	where?: InputMaybe<OrganizationConnectWhere>;
};

export type CaseLegalEntityConnection = {
	__typename?: "CaseLegalEntityConnection";
	edges: Array<CaseLegalEntityRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type CaseLegalEntityConnectionSort = {
	node?: InputMaybe<OrganizationSort>;
};

export type CaseLegalEntityConnectionWhere = {
	AND?: InputMaybe<Array<CaseLegalEntityConnectionWhere>>;
	OR?: InputMaybe<Array<CaseLegalEntityConnectionWhere>>;
	node?: InputMaybe<OrganizationWhere>;
	node_NOT?: InputMaybe<OrganizationWhere>;
};

export type CaseLegalEntityCreateFieldInput = {
	node: OrganizationCreateInput;
};

export type CaseLegalEntityDeleteFieldInput = {
	where?: InputMaybe<CaseLegalEntityConnectionWhere>;
};

export type CaseLegalEntityDisconnectFieldInput = {
	where?: InputMaybe<CaseLegalEntityConnectionWhere>;
};

export type CaseLegalEntityFieldInput = {
	connect?: InputMaybe<CaseLegalEntityConnectFieldInput>;
	create?: InputMaybe<CaseLegalEntityCreateFieldInput>;
};

export type CaseLegalEntityNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<CaseLegalEntityNodeAggregationWhereInput>>;
	IBAN_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	IBAN_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	IBAN_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	IBAN_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	IBAN_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	IBAN_EQUAL?: InputMaybe<Scalars["String"]>;
	IBAN_GT?: InputMaybe<Scalars["Int"]>;
	IBAN_GTE?: InputMaybe<Scalars["Int"]>;
	IBAN_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	IBAN_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	IBAN_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	IBAN_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	IBAN_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	IBAN_LT?: InputMaybe<Scalars["Int"]>;
	IBAN_LTE?: InputMaybe<Scalars["Int"]>;
	IBAN_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	IBAN_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	IBAN_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	IBAN_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	IBAN_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	OR?: InputMaybe<Array<CaseLegalEntityNodeAggregationWhereInput>>;
	billingAddress_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	billingAddress_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	billingAddress_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	billingAddress_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	billingAddress_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	billingAddress_EQUAL?: InputMaybe<Scalars["String"]>;
	billingAddress_GT?: InputMaybe<Scalars["Int"]>;
	billingAddress_GTE?: InputMaybe<Scalars["Int"]>;
	billingAddress_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	billingAddress_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	billingAddress_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	billingAddress_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	billingAddress_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	billingAddress_LT?: InputMaybe<Scalars["Int"]>;
	billingAddress_LTE?: InputMaybe<Scalars["Int"]>;
	billingAddress_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	billingAddress_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	billingAddress_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	billingAddress_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	billingAddress_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	contactEmail_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	contactEmail_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	contactEmail_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	contactEmail_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	contactEmail_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	contactEmail_EQUAL?: InputMaybe<Scalars["String"]>;
	contactEmail_GT?: InputMaybe<Scalars["Int"]>;
	contactEmail_GTE?: InputMaybe<Scalars["Int"]>;
	contactEmail_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	contactEmail_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	contactEmail_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	contactEmail_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	contactEmail_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	contactEmail_LT?: InputMaybe<Scalars["Int"]>;
	contactEmail_LTE?: InputMaybe<Scalars["Int"]>;
	contactEmail_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	contactEmail_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	contactEmail_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	contactEmail_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	contactEmail_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	contactFirstName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	contactFirstName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	contactFirstName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	contactFirstName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	contactFirstName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	contactFirstName_EQUAL?: InputMaybe<Scalars["String"]>;
	contactFirstName_GT?: InputMaybe<Scalars["Int"]>;
	contactFirstName_GTE?: InputMaybe<Scalars["Int"]>;
	contactFirstName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	contactFirstName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	contactFirstName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	contactFirstName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	contactFirstName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	contactFirstName_LT?: InputMaybe<Scalars["Int"]>;
	contactFirstName_LTE?: InputMaybe<Scalars["Int"]>;
	contactFirstName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	contactFirstName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	contactFirstName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	contactFirstName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	contactFirstName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	contactLastName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	contactLastName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	contactLastName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	contactLastName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	contactLastName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	contactLastName_EQUAL?: InputMaybe<Scalars["String"]>;
	contactLastName_GT?: InputMaybe<Scalars["Int"]>;
	contactLastName_GTE?: InputMaybe<Scalars["Int"]>;
	contactLastName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	contactLastName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	contactLastName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	contactLastName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	contactLastName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	contactLastName_LT?: InputMaybe<Scalars["Int"]>;
	contactLastName_LTE?: InputMaybe<Scalars["Int"]>;
	contactLastName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	contactLastName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	contactLastName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	contactLastName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	contactLastName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	contactOccupation_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	contactOccupation_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	contactOccupation_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	contactOccupation_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	contactOccupation_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	contactOccupation_EQUAL?: InputMaybe<Scalars["String"]>;
	contactOccupation_GT?: InputMaybe<Scalars["Int"]>;
	contactOccupation_GTE?: InputMaybe<Scalars["Int"]>;
	contactOccupation_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	contactOccupation_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	contactOccupation_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	contactOccupation_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	contactOccupation_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	contactOccupation_LT?: InputMaybe<Scalars["Int"]>;
	contactOccupation_LTE?: InputMaybe<Scalars["Int"]>;
	contactOccupation_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	contactOccupation_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	contactOccupation_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	contactOccupation_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	contactOccupation_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	contactPhone_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	contactPhone_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	contactPhone_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	contactPhone_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	contactPhone_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	contactPhone_EQUAL?: InputMaybe<Scalars["String"]>;
	contactPhone_GT?: InputMaybe<Scalars["Int"]>;
	contactPhone_GTE?: InputMaybe<Scalars["Int"]>;
	contactPhone_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	contactPhone_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	contactPhone_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	contactPhone_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	contactPhone_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	contactPhone_LT?: InputMaybe<Scalars["Int"]>;
	contactPhone_LTE?: InputMaybe<Scalars["Int"]>;
	contactPhone_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	contactPhone_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	contactPhone_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	contactPhone_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	contactPhone_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	domicile_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	domicile_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	domicile_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	domicile_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	domicile_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	domicile_EQUAL?: InputMaybe<Scalars["String"]>;
	domicile_GT?: InputMaybe<Scalars["Int"]>;
	domicile_GTE?: InputMaybe<Scalars["Int"]>;
	domicile_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	domicile_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	domicile_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	domicile_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	domicile_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	domicile_LT?: InputMaybe<Scalars["Int"]>;
	domicile_LTE?: InputMaybe<Scalars["Int"]>;
	domicile_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	domicile_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	domicile_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	domicile_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	domicile_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	eIN_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	eIN_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	eIN_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	eIN_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	eIN_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	eIN_EQUAL?: InputMaybe<Scalars["String"]>;
	eIN_GT?: InputMaybe<Scalars["Int"]>;
	eIN_GTE?: InputMaybe<Scalars["Int"]>;
	eIN_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	eIN_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	eIN_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	eIN_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	eIN_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	eIN_LT?: InputMaybe<Scalars["Int"]>;
	eIN_LTE?: InputMaybe<Scalars["Int"]>;
	eIN_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	eIN_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	eIN_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	eIN_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	eIN_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	fax_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	fax_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	fax_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	fax_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	fax_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	fax_EQUAL?: InputMaybe<Scalars["String"]>;
	fax_GT?: InputMaybe<Scalars["Int"]>;
	fax_GTE?: InputMaybe<Scalars["Int"]>;
	fax_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	fax_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	fax_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	fax_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	fax_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	fax_LT?: InputMaybe<Scalars["Int"]>;
	fax_LTE?: InputMaybe<Scalars["Int"]>;
	fax_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	fax_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	fax_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	fax_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	fax_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	legalName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	legalName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	legalName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	legalName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	legalName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	legalName_EQUAL?: InputMaybe<Scalars["String"]>;
	legalName_GT?: InputMaybe<Scalars["Int"]>;
	legalName_GTE?: InputMaybe<Scalars["Int"]>;
	legalName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	legalName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	legalName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	legalName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	legalName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	legalName_LT?: InputMaybe<Scalars["Int"]>;
	legalName_LTE?: InputMaybe<Scalars["Int"]>;
	legalName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	legalName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	legalName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	legalName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	legalName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	logo_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	logo_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	logo_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	logo_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	logo_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	logo_EQUAL?: InputMaybe<Scalars["String"]>;
	logo_GT?: InputMaybe<Scalars["Int"]>;
	logo_GTE?: InputMaybe<Scalars["Int"]>;
	logo_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	logo_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	logo_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	logo_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	logo_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	logo_LT?: InputMaybe<Scalars["Int"]>;
	logo_LTE?: InputMaybe<Scalars["Int"]>;
	logo_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	logo_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	logo_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	logo_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	logo_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	name_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	name_EQUAL?: InputMaybe<Scalars["String"]>;
	name_GT?: InputMaybe<Scalars["Int"]>;
	name_GTE?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	name_LT?: InputMaybe<Scalars["Int"]>;
	name_LTE?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	phone_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	phone_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	phone_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	phone_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	phone_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	phone_EQUAL?: InputMaybe<Scalars["String"]>;
	phone_GT?: InputMaybe<Scalars["Int"]>;
	phone_GTE?: InputMaybe<Scalars["Int"]>;
	phone_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	phone_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	phone_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	phone_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	phone_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	phone_LT?: InputMaybe<Scalars["Int"]>;
	phone_LTE?: InputMaybe<Scalars["Int"]>;
	phone_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	phone_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	phone_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	phone_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	phone_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	tenantId_EQUAL?: InputMaybe<Scalars["String"]>;
	tenantId_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	website_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	website_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	website_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	website_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	website_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	website_EQUAL?: InputMaybe<Scalars["String"]>;
	website_GT?: InputMaybe<Scalars["Int"]>;
	website_GTE?: InputMaybe<Scalars["Int"]>;
	website_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	website_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	website_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	website_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	website_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	website_LT?: InputMaybe<Scalars["Int"]>;
	website_LTE?: InputMaybe<Scalars["Int"]>;
	website_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	website_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	website_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	website_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	website_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type CaseLegalEntityRelationship = {
	__typename?: "CaseLegalEntityRelationship";
	cursor: Scalars["String"];
	node: Organization;
};

export type CaseLegalEntityUpdateConnectionInput = {
	node?: InputMaybe<OrganizationUpdateInput>;
};

export type CaseLegalEntityUpdateFieldInput = {
	connect?: InputMaybe<CaseLegalEntityConnectFieldInput>;
	create?: InputMaybe<CaseLegalEntityCreateFieldInput>;
	delete?: InputMaybe<CaseLegalEntityDeleteFieldInput>;
	disconnect?: InputMaybe<CaseLegalEntityDisconnectFieldInput>;
	update?: InputMaybe<CaseLegalEntityUpdateConnectionInput>;
	where?: InputMaybe<CaseLegalEntityConnectionWhere>;
};

export type CaseOptions = {
	limit?: InputMaybe<Scalars["Int"]>;
	offset?: InputMaybe<Scalars["Int"]>;
	/** Specify one or more CaseSort objects to sort Cases by. The sorts will be applied in the order in which they are arranged in the array. */
	sort?: InputMaybe<Array<InputMaybe<CaseSort>>>;
};

export type CasePatientAggregateInput = {
	AND?: InputMaybe<Array<CasePatientAggregateInput>>;
	OR?: InputMaybe<Array<CasePatientAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<CasePatientNodeAggregationWhereInput>;
};

export type CasePatientConnectFieldInput = {
	connect?: InputMaybe<PatientConnectInput>;
	where?: InputMaybe<PatientConnectWhere>;
};

export type CasePatientConnection = {
	__typename?: "CasePatientConnection";
	edges: Array<CasePatientRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type CasePatientConnectionSort = {
	node?: InputMaybe<PatientSort>;
};

export type CasePatientConnectionWhere = {
	AND?: InputMaybe<Array<CasePatientConnectionWhere>>;
	OR?: InputMaybe<Array<CasePatientConnectionWhere>>;
	node?: InputMaybe<PatientWhere>;
	node_NOT?: InputMaybe<PatientWhere>;
};

export type CasePatientCreateFieldInput = {
	node: PatientCreateInput;
};

export type CasePatientDeleteFieldInput = {
	delete?: InputMaybe<PatientDeleteInput>;
	where?: InputMaybe<CasePatientConnectionWhere>;
};

export type CasePatientDisconnectFieldInput = {
	disconnect?: InputMaybe<PatientDisconnectInput>;
	where?: InputMaybe<CasePatientConnectionWhere>;
};

export type CasePatientFieldInput = {
	connect?: InputMaybe<CasePatientConnectFieldInput>;
	create?: InputMaybe<CasePatientCreateFieldInput>;
};

export type CasePatientNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<CasePatientNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<CasePatientNodeAggregationWhereInput>>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	initials_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	initials_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	initials_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	initials_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	initials_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	initials_EQUAL?: InputMaybe<Scalars["String"]>;
	initials_GT?: InputMaybe<Scalars["Int"]>;
	initials_GTE?: InputMaybe<Scalars["Int"]>;
	initials_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	initials_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	initials_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	initials_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	initials_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	initials_LT?: InputMaybe<Scalars["Int"]>;
	initials_LTE?: InputMaybe<Scalars["Int"]>;
	initials_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	initials_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	initials_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	initials_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	initials_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	insuranceId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	insuranceId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	insuranceId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	insuranceId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	insuranceId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	insuranceId_EQUAL?: InputMaybe<Scalars["String"]>;
	insuranceId_GT?: InputMaybe<Scalars["Int"]>;
	insuranceId_GTE?: InputMaybe<Scalars["Int"]>;
	insuranceId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	insuranceId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	insuranceId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	insuranceId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	insuranceId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	insuranceId_LT?: InputMaybe<Scalars["Int"]>;
	insuranceId_LTE?: InputMaybe<Scalars["Int"]>;
	insuranceId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	insuranceId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	insuranceId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	insuranceId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	insuranceId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	tenantId_EQUAL?: InputMaybe<Scalars["String"]>;
	tenantId_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	timeStamp_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	timeStamp_GT?: InputMaybe<Scalars["DateTime"]>;
	timeStamp_GTE?: InputMaybe<Scalars["DateTime"]>;
	timeStamp_LT?: InputMaybe<Scalars["DateTime"]>;
	timeStamp_LTE?: InputMaybe<Scalars["DateTime"]>;
	timeStamp_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	timeStamp_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	timeStamp_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	timeStamp_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	timeStamp_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	timeStamp_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	timeStamp_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	timeStamp_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	timeStamp_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	timeStamp_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	yearOfBirth_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	yearOfBirth_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	yearOfBirth_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	yearOfBirth_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	yearOfBirth_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	yearOfBirth_EQUAL?: InputMaybe<Scalars["Int"]>;
	yearOfBirth_GT?: InputMaybe<Scalars["Int"]>;
	yearOfBirth_GTE?: InputMaybe<Scalars["Int"]>;
	yearOfBirth_LT?: InputMaybe<Scalars["Int"]>;
	yearOfBirth_LTE?: InputMaybe<Scalars["Int"]>;
	yearOfBirth_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	yearOfBirth_MAX_GT?: InputMaybe<Scalars["Int"]>;
	yearOfBirth_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	yearOfBirth_MAX_LT?: InputMaybe<Scalars["Int"]>;
	yearOfBirth_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	yearOfBirth_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	yearOfBirth_MIN_GT?: InputMaybe<Scalars["Int"]>;
	yearOfBirth_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	yearOfBirth_MIN_LT?: InputMaybe<Scalars["Int"]>;
	yearOfBirth_MIN_LTE?: InputMaybe<Scalars["Int"]>;
};

export type CasePatientRelationship = {
	__typename?: "CasePatientRelationship";
	cursor: Scalars["String"];
	node: Patient;
};

export type CasePatientUpdateConnectionInput = {
	node?: InputMaybe<PatientUpdateInput>;
};

export type CasePatientUpdateFieldInput = {
	connect?: InputMaybe<CasePatientConnectFieldInput>;
	create?: InputMaybe<CasePatientCreateFieldInput>;
	delete?: InputMaybe<CasePatientDeleteFieldInput>;
	disconnect?: InputMaybe<CasePatientDisconnectFieldInput>;
	update?: InputMaybe<CasePatientUpdateConnectionInput>;
	where?: InputMaybe<CasePatientConnectionWhere>;
};

export type CasePreparationsAggregateInput = {
	AND?: InputMaybe<Array<CasePreparationsAggregateInput>>;
	OR?: InputMaybe<Array<CasePreparationsAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<CasePreparationsNodeAggregationWhereInput>;
};

export type CasePreparationsConnectFieldInput = {
	connect?: InputMaybe<Array<PreparationConnectInput>>;
	where?: InputMaybe<PreparationConnectWhere>;
};

export type CasePreparationsConnection = {
	__typename?: "CasePreparationsConnection";
	edges: Array<CasePreparationsRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type CasePreparationsConnectionSort = {
	node?: InputMaybe<PreparationSort>;
};

export type CasePreparationsConnectionWhere = {
	AND?: InputMaybe<Array<CasePreparationsConnectionWhere>>;
	OR?: InputMaybe<Array<CasePreparationsConnectionWhere>>;
	node?: InputMaybe<PreparationWhere>;
	node_NOT?: InputMaybe<PreparationWhere>;
};

export type CasePreparationsCreateFieldInput = {
	node: PreparationCreateInput;
};

export type CasePreparationsDeleteFieldInput = {
	delete?: InputMaybe<PreparationDeleteInput>;
	where?: InputMaybe<CasePreparationsConnectionWhere>;
};

export type CasePreparationsDisconnectFieldInput = {
	disconnect?: InputMaybe<PreparationDisconnectInput>;
	where?: InputMaybe<CasePreparationsConnectionWhere>;
};

export type CasePreparationsFieldInput = {
	connect?: InputMaybe<Array<CasePreparationsConnectFieldInput>>;
	create?: InputMaybe<Array<CasePreparationsCreateFieldInput>>;
};

export type CasePreparationsNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<CasePreparationsNodeAggregationWhereInput>>;
	AtcCode_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	AtcCode_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	AtcCode_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	AtcCode_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	AtcCode_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	AtcCode_EQUAL?: InputMaybe<Scalars["String"]>;
	AtcCode_GT?: InputMaybe<Scalars["Int"]>;
	AtcCode_GTE?: InputMaybe<Scalars["Int"]>;
	AtcCode_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	AtcCode_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	AtcCode_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	AtcCode_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	AtcCode_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	AtcCode_LT?: InputMaybe<Scalars["Int"]>;
	AtcCode_LTE?: InputMaybe<Scalars["Int"]>;
	AtcCode_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	AtcCode_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	AtcCode_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	AtcCode_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	AtcCode_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	BrandName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	BrandName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	BrandName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	BrandName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	BrandName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	BrandName_EQUAL?: InputMaybe<Scalars["String"]>;
	BrandName_GT?: InputMaybe<Scalars["Int"]>;
	BrandName_GTE?: InputMaybe<Scalars["Int"]>;
	BrandName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	BrandName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	BrandName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	BrandName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	BrandName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	BrandName_LT?: InputMaybe<Scalars["Int"]>;
	BrandName_LTE?: InputMaybe<Scalars["Int"]>;
	BrandName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	BrandName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	BrandName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	BrandName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	BrandName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	DescriptionDe_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	DescriptionDe_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	DescriptionDe_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	DescriptionDe_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	DescriptionDe_EQUAL?: InputMaybe<Scalars["String"]>;
	DescriptionDe_GT?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_GTE?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_LT?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_LTE?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	GenericName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	GenericName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	GenericName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	GenericName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	GenericName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	GenericName_EQUAL?: InputMaybe<Scalars["String"]>;
	GenericName_GT?: InputMaybe<Scalars["Int"]>;
	GenericName_GTE?: InputMaybe<Scalars["Int"]>;
	GenericName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	GenericName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	GenericName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	GenericName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	GenericName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	GenericName_LT?: InputMaybe<Scalars["Int"]>;
	GenericName_LTE?: InputMaybe<Scalars["Int"]>;
	GenericName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	GenericName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	GenericName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	GenericName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	GenericName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	OR?: InputMaybe<Array<CasePreparationsNodeAggregationWhereInput>>;
	SwissmedicNo5_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo5_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo5_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo5_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo5_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo5_EQUAL?: InputMaybe<Scalars["String"]>;
	SwissmedicNo5_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo5_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo5_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo5_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo5_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo5_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo5_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo5_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo5_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo5_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo5_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo5_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo5_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo5_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
};

export type CasePreparationsRelationship = {
	__typename?: "CasePreparationsRelationship";
	cursor: Scalars["String"];
	node: Preparation;
};

export type CasePreparationsUpdateConnectionInput = {
	node?: InputMaybe<PreparationUpdateInput>;
};

export type CasePreparationsUpdateFieldInput = {
	connect?: InputMaybe<Array<CasePreparationsConnectFieldInput>>;
	create?: InputMaybe<Array<CasePreparationsCreateFieldInput>>;
	delete?: InputMaybe<Array<CasePreparationsDeleteFieldInput>>;
	disconnect?: InputMaybe<Array<CasePreparationsDisconnectFieldInput>>;
	update?: InputMaybe<CasePreparationsUpdateConnectionInput>;
	where?: InputMaybe<CasePreparationsConnectionWhere>;
};

export type CasePrimaryInterventionAggregateInput = {
	AND?: InputMaybe<Array<CasePrimaryInterventionAggregateInput>>;
	OR?: InputMaybe<Array<CasePrimaryInterventionAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<CasePrimaryInterventionNodeAggregationWhereInput>;
};

export type CasePrimaryInterventionConnectFieldInput = {
	connect?: InputMaybe<InterventionConnectInput>;
	where?: InputMaybe<InterventionConnectWhere>;
};

export type CasePrimaryInterventionConnection = {
	__typename?: "CasePrimaryInterventionConnection";
	edges: Array<CasePrimaryInterventionRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type CasePrimaryInterventionConnectionSort = {
	node?: InputMaybe<InterventionSort>;
};

export type CasePrimaryInterventionConnectionWhere = {
	AND?: InputMaybe<Array<CasePrimaryInterventionConnectionWhere>>;
	OR?: InputMaybe<Array<CasePrimaryInterventionConnectionWhere>>;
	node?: InputMaybe<InterventionWhere>;
	node_NOT?: InputMaybe<InterventionWhere>;
};

export type CasePrimaryInterventionCreateFieldInput = {
	node: InterventionCreateInput;
};

export type CasePrimaryInterventionDeleteFieldInput = {
	delete?: InputMaybe<InterventionDeleteInput>;
	where?: InputMaybe<CasePrimaryInterventionConnectionWhere>;
};

export type CasePrimaryInterventionDisconnectFieldInput = {
	disconnect?: InputMaybe<InterventionDisconnectInput>;
	where?: InputMaybe<CasePrimaryInterventionConnectionWhere>;
};

export type CasePrimaryInterventionFieldInput = {
	connect?: InputMaybe<CasePrimaryInterventionConnectFieldInput>;
	create?: InputMaybe<CasePrimaryInterventionCreateFieldInput>;
};

export type CasePrimaryInterventionNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<CasePrimaryInterventionNodeAggregationWhereInput>>;
	LAPressure_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	LAPressure_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	LAPressure_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	LAPressure_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	LAPressure_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	LAPressure_EQUAL?: InputMaybe<Scalars["Int"]>;
	LAPressure_GT?: InputMaybe<Scalars["Int"]>;
	LAPressure_GTE?: InputMaybe<Scalars["Int"]>;
	LAPressure_LT?: InputMaybe<Scalars["Int"]>;
	LAPressure_LTE?: InputMaybe<Scalars["Int"]>;
	LAPressure_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	LAPressure_MAX_GT?: InputMaybe<Scalars["Int"]>;
	LAPressure_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	LAPressure_MAX_LT?: InputMaybe<Scalars["Int"]>;
	LAPressure_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	LAPressure_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	LAPressure_MIN_GT?: InputMaybe<Scalars["Int"]>;
	LAPressure_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	LAPressure_MIN_LT?: InputMaybe<Scalars["Int"]>;
	LAPressure_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	LAVolume_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	LAVolume_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	LAVolume_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	LAVolume_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	LAVolume_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	LAVolume_EQUAL?: InputMaybe<Scalars["Int"]>;
	LAVolume_GT?: InputMaybe<Scalars["Int"]>;
	LAVolume_GTE?: InputMaybe<Scalars["Int"]>;
	LAVolume_LT?: InputMaybe<Scalars["Int"]>;
	LAVolume_LTE?: InputMaybe<Scalars["Int"]>;
	LAVolume_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	LAVolume_MAX_GT?: InputMaybe<Scalars["Int"]>;
	LAVolume_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	LAVolume_MAX_LT?: InputMaybe<Scalars["Int"]>;
	LAVolume_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	LAVolume_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	LAVolume_MIN_GT?: InputMaybe<Scalars["Int"]>;
	LAVolume_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	LAVolume_MIN_LT?: InputMaybe<Scalars["Int"]>;
	LAVolume_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	OR?: InputMaybe<Array<CasePrimaryInterventionNodeAggregationWhereInput>>;
	createdOn_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	lastUpdatedOn_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_GT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_LT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_GT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_GTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_LT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_LTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	tenantId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	tenantId_EQUAL?: InputMaybe<Scalars["String"]>;
	tenantId_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type CasePrimaryInterventionRelationship = {
	__typename?: "CasePrimaryInterventionRelationship";
	cursor: Scalars["String"];
	node: Intervention;
};

export type CasePrimaryInterventionUpdateConnectionInput = {
	node?: InputMaybe<InterventionUpdateInput>;
};

export type CasePrimaryInterventionUpdateFieldInput = {
	connect?: InputMaybe<CasePrimaryInterventionConnectFieldInput>;
	create?: InputMaybe<CasePrimaryInterventionCreateFieldInput>;
	delete?: InputMaybe<CasePrimaryInterventionDeleteFieldInput>;
	disconnect?: InputMaybe<CasePrimaryInterventionDisconnectFieldInput>;
	update?: InputMaybe<CasePrimaryInterventionUpdateConnectionInput>;
	where?: InputMaybe<CasePrimaryInterventionConnectionWhere>;
};

export type CaseRecordBatchesAggregateInput = {
	AND?: InputMaybe<Array<CaseRecordBatchesAggregateInput>>;
	OR?: InputMaybe<Array<CaseRecordBatchesAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<CaseRecordBatchesNodeAggregationWhereInput>;
};

export type CaseRecordBatchesConnectFieldInput = {
	connect?: InputMaybe<Array<RecordBatchConnectInput>>;
	where?: InputMaybe<RecordBatchConnectWhere>;
};

export type CaseRecordBatchesConnection = {
	__typename?: "CaseRecordBatchesConnection";
	edges: Array<CaseRecordBatchesRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type CaseRecordBatchesConnectionSort = {
	node?: InputMaybe<RecordBatchSort>;
};

export type CaseRecordBatchesConnectionWhere = {
	AND?: InputMaybe<Array<CaseRecordBatchesConnectionWhere>>;
	OR?: InputMaybe<Array<CaseRecordBatchesConnectionWhere>>;
	node?: InputMaybe<RecordBatchWhere>;
	node_NOT?: InputMaybe<RecordBatchWhere>;
};

export type CaseRecordBatchesCreateFieldInput = {
	node: RecordBatchCreateInput;
};

export type CaseRecordBatchesDeleteFieldInput = {
	delete?: InputMaybe<RecordBatchDeleteInput>;
	where?: InputMaybe<CaseRecordBatchesConnectionWhere>;
};

export type CaseRecordBatchesDisconnectFieldInput = {
	disconnect?: InputMaybe<RecordBatchDisconnectInput>;
	where?: InputMaybe<CaseRecordBatchesConnectionWhere>;
};

export type CaseRecordBatchesFieldInput = {
	connect?: InputMaybe<Array<CaseRecordBatchesConnectFieldInput>>;
	create?: InputMaybe<Array<CaseRecordBatchesCreateFieldInput>>;
};

export type CaseRecordBatchesNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<CaseRecordBatchesNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<CaseRecordBatchesNodeAggregationWhereInput>>;
	createdOn_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	evaluationSnapshot_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	evaluationSnapshot_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	evaluationSnapshot_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	evaluationSnapshot_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	evaluationSnapshot_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	evaluationSnapshot_EQUAL?: InputMaybe<Scalars["String"]>;
	evaluationSnapshot_GT?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_GTE?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_LT?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_LTE?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type CaseRecordBatchesRelationship = {
	__typename?: "CaseRecordBatchesRelationship";
	cursor: Scalars["String"];
	node: RecordBatch;
};

export type CaseRecordBatchesUpdateConnectionInput = {
	node?: InputMaybe<RecordBatchUpdateInput>;
};

export type CaseRecordBatchesUpdateFieldInput = {
	connect?: InputMaybe<Array<CaseRecordBatchesConnectFieldInput>>;
	create?: InputMaybe<Array<CaseRecordBatchesCreateFieldInput>>;
	delete?: InputMaybe<Array<CaseRecordBatchesDeleteFieldInput>>;
	disconnect?: InputMaybe<Array<CaseRecordBatchesDisconnectFieldInput>>;
	update?: InputMaybe<CaseRecordBatchesUpdateConnectionInput>;
	where?: InputMaybe<CaseRecordBatchesConnectionWhere>;
};

export type CaseReportDataPoint = {
	__typename?: "CaseReportDataPoint";
	caseId?: Maybe<Scalars["ID"]>;
	durationMonths?: Maybe<Scalars["Int"]>;
	lastClaimReceived?: Maybe<Scalars["Date"]>;
	reasonOfDiscontinuation?: Maybe<ReasonsForDiscontinuation>;
	state?: Maybe<CaseStatus>;
};

export type CaseReportDataPointAggregateSelection = {
	__typename?: "CaseReportDataPointAggregateSelection";
	caseId: IdAggregateSelection;
	count: Scalars["Int"];
	durationMonths: IntAggregateSelection;
};

export type CaseReportDataPointOptions = {
	limit?: InputMaybe<Scalars["Int"]>;
	offset?: InputMaybe<Scalars["Int"]>;
	/** Specify one or more CaseReportDataPointSort objects to sort CaseReportDataPoints by. The sorts will be applied in the order in which they are arranged in the array. */
	sort?: InputMaybe<Array<InputMaybe<CaseReportDataPointSort>>>;
};

/** Fields to sort CaseReportDataPoints by. The order in which sorts are applied is not guaranteed when specifying many fields in one CaseReportDataPointSort object. */
export type CaseReportDataPointSort = {
	caseId?: InputMaybe<SortDirection>;
	durationMonths?: InputMaybe<SortDirection>;
	lastClaimReceived?: InputMaybe<SortDirection>;
	reasonOfDiscontinuation?: InputMaybe<SortDirection>;
	state?: InputMaybe<SortDirection>;
};

export type CaseReportDataPointWhere = {
	AND?: InputMaybe<Array<CaseReportDataPointWhere>>;
	OR?: InputMaybe<Array<CaseReportDataPointWhere>>;
	caseId?: InputMaybe<Scalars["ID"]>;
	caseId_CONTAINS?: InputMaybe<Scalars["ID"]>;
	caseId_ENDS_WITH?: InputMaybe<Scalars["ID"]>;
	caseId_IN?: InputMaybe<Array<InputMaybe<Scalars["ID"]>>>;
	caseId_MATCHES?: InputMaybe<Scalars["String"]>;
	caseId_NOT?: InputMaybe<Scalars["ID"]>;
	caseId_NOT_CONTAINS?: InputMaybe<Scalars["ID"]>;
	caseId_NOT_ENDS_WITH?: InputMaybe<Scalars["ID"]>;
	caseId_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["ID"]>>>;
	caseId_NOT_STARTS_WITH?: InputMaybe<Scalars["ID"]>;
	caseId_STARTS_WITH?: InputMaybe<Scalars["ID"]>;
	durationMonths?: InputMaybe<Scalars["Int"]>;
	durationMonths_GT?: InputMaybe<Scalars["Int"]>;
	durationMonths_GTE?: InputMaybe<Scalars["Int"]>;
	durationMonths_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	durationMonths_LT?: InputMaybe<Scalars["Int"]>;
	durationMonths_LTE?: InputMaybe<Scalars["Int"]>;
	durationMonths_NOT?: InputMaybe<Scalars["Int"]>;
	durationMonths_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	lastClaimReceived?: InputMaybe<Scalars["Date"]>;
	lastClaimReceived_GT?: InputMaybe<Scalars["Date"]>;
	lastClaimReceived_GTE?: InputMaybe<Scalars["Date"]>;
	lastClaimReceived_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
	lastClaimReceived_LT?: InputMaybe<Scalars["Date"]>;
	lastClaimReceived_LTE?: InputMaybe<Scalars["Date"]>;
	lastClaimReceived_NOT?: InputMaybe<Scalars["Date"]>;
	lastClaimReceived_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
	reasonOfDiscontinuation?: InputMaybe<ReasonsForDiscontinuation>;
	reasonOfDiscontinuation_IN?: InputMaybe<Array<InputMaybe<ReasonsForDiscontinuation>>>;
	reasonOfDiscontinuation_NOT?: InputMaybe<ReasonsForDiscontinuation>;
	reasonOfDiscontinuation_NOT_IN?: InputMaybe<Array<InputMaybe<ReasonsForDiscontinuation>>>;
	state?: InputMaybe<CaseStatus>;
	state_IN?: InputMaybe<Array<InputMaybe<CaseStatus>>>;
	state_NOT?: InputMaybe<CaseStatus>;
	state_NOT_IN?: InputMaybe<Array<InputMaybe<CaseStatus>>>;
};

/** Fields to sort Cases by. The order in which sorts are applied is not guaranteed when specifying many fields in one CaseSort object. */
export type CaseSort = {
	actualAgreementId?: InputMaybe<SortDirection>;
	agreementName?: InputMaybe<SortDirection>;
	creationDate?: InputMaybe<SortDirection>;
	id?: InputMaybe<SortDirection>;
	isArchived?: InputMaybe<SortDirection>;
	isDeleted?: InputMaybe<SortDirection>;
	patientInitials?: InputMaybe<SortDirection>;
	patientInsuranceId?: InputMaybe<SortDirection>;
	preparationBandName?: InputMaybe<SortDirection>;
	preparationGenericName?: InputMaybe<SortDirection>;
	sourceTenantId?: InputMaybe<SortDirection>;
	submissionDate?: InputMaybe<SortDirection>;
	totalAmount?: InputMaybe<SortDirection>;
	unlimited?: InputMaybe<SortDirection>;
};

export enum CaseStatus {
	Continues = "CONTINUES",
	Discontinued = "DISCONTINUED",
	Unknown = "UNKNOWN",
}

export type CaseStobContractAggregateInput = {
	AND?: InputMaybe<Array<CaseStobContractAggregateInput>>;
	OR?: InputMaybe<Array<CaseStobContractAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<CaseStobContractNodeAggregationWhereInput>;
};

export type CaseStobContractConnectFieldInput = {
	connect?: InputMaybe<StobContractConnectInput>;
	where?: InputMaybe<StobContractConnectWhere>;
};

export type CaseStobContractConnection = {
	__typename?: "CaseStobContractConnection";
	edges: Array<CaseStobContractRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type CaseStobContractConnectionSort = {
	node?: InputMaybe<StobContractSort>;
};

export type CaseStobContractConnectionWhere = {
	AND?: InputMaybe<Array<CaseStobContractConnectionWhere>>;
	OR?: InputMaybe<Array<CaseStobContractConnectionWhere>>;
	node?: InputMaybe<StobContractWhere>;
	node_NOT?: InputMaybe<StobContractWhere>;
};

export type CaseStobContractCreateFieldInput = {
	node: StobContractCreateInput;
};

export type CaseStobContractDeleteFieldInput = {
	delete?: InputMaybe<StobContractDeleteInput>;
	where?: InputMaybe<CaseStobContractConnectionWhere>;
};

export type CaseStobContractDisconnectFieldInput = {
	disconnect?: InputMaybe<StobContractDisconnectInput>;
	where?: InputMaybe<CaseStobContractConnectionWhere>;
};

export type CaseStobContractFieldInput = {
	connect?: InputMaybe<CaseStobContractConnectFieldInput>;
	create?: InputMaybe<CaseStobContractCreateFieldInput>;
};

export type CaseStobContractNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<CaseStobContractNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<CaseStobContractNodeAggregationWhereInput>>;
	adverseEventsMeasureName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	adverseEventsMeasureName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	adverseEventsMeasureName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	adverseEventsMeasureName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	adverseEventsMeasureName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	adverseEventsMeasureName_EQUAL?: InputMaybe<Scalars["String"]>;
	adverseEventsMeasureName_GT?: InputMaybe<Scalars["Int"]>;
	adverseEventsMeasureName_GTE?: InputMaybe<Scalars["Int"]>;
	adverseEventsMeasureName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	adverseEventsMeasureName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	adverseEventsMeasureName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	adverseEventsMeasureName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	adverseEventsMeasureName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	adverseEventsMeasureName_LT?: InputMaybe<Scalars["Int"]>;
	adverseEventsMeasureName_LTE?: InputMaybe<Scalars["Int"]>;
	adverseEventsMeasureName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	adverseEventsMeasureName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	adverseEventsMeasureName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	adverseEventsMeasureName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	adverseEventsMeasureName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	buyerContractNumber_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	buyerContractNumber_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	buyerContractNumber_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	buyerContractNumber_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	buyerContractNumber_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	buyerContractNumber_EQUAL?: InputMaybe<Scalars["String"]>;
	buyerContractNumber_GT?: InputMaybe<Scalars["Int"]>;
	buyerContractNumber_GTE?: InputMaybe<Scalars["Int"]>;
	buyerContractNumber_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	buyerContractNumber_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	buyerContractNumber_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	buyerContractNumber_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	buyerContractNumber_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	buyerContractNumber_LT?: InputMaybe<Scalars["Int"]>;
	buyerContractNumber_LTE?: InputMaybe<Scalars["Int"]>;
	buyerContractNumber_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	buyerContractNumber_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	buyerContractNumber_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	buyerContractNumber_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	buyerContractNumber_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	customerNumber_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	customerNumber_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	customerNumber_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	customerNumber_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	customerNumber_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	customerNumber_EQUAL?: InputMaybe<Scalars["String"]>;
	customerNumber_GT?: InputMaybe<Scalars["Int"]>;
	customerNumber_GTE?: InputMaybe<Scalars["Int"]>;
	customerNumber_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	customerNumber_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	customerNumber_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	customerNumber_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	customerNumber_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	customerNumber_LT?: InputMaybe<Scalars["Int"]>;
	customerNumber_LTE?: InputMaybe<Scalars["Int"]>;
	customerNumber_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	customerNumber_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	customerNumber_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	customerNumber_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	customerNumber_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	description_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	description_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	description_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	description_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	description_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	description_EQUAL?: InputMaybe<Scalars["String"]>;
	description_GT?: InputMaybe<Scalars["Int"]>;
	description_GTE?: InputMaybe<Scalars["Int"]>;
	description_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	description_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	description_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	description_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	description_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	description_LT?: InputMaybe<Scalars["Int"]>;
	description_LTE?: InputMaybe<Scalars["Int"]>;
	description_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	description_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	description_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	description_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	description_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	detailsUrl_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	detailsUrl_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	detailsUrl_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	detailsUrl_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	detailsUrl_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	detailsUrl_EQUAL?: InputMaybe<Scalars["String"]>;
	detailsUrl_GT?: InputMaybe<Scalars["Int"]>;
	detailsUrl_GTE?: InputMaybe<Scalars["Int"]>;
	detailsUrl_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	detailsUrl_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	detailsUrl_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	detailsUrl_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	detailsUrl_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	detailsUrl_LT?: InputMaybe<Scalars["Int"]>;
	detailsUrl_LTE?: InputMaybe<Scalars["Int"]>;
	detailsUrl_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	detailsUrl_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	detailsUrl_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	detailsUrl_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	detailsUrl_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	documentationGapDays_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	documentationGapDays_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	documentationGapDays_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	documentationGapDays_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	documentationGapDays_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	documentationGapDays_EQUAL?: InputMaybe<Scalars["Int"]>;
	documentationGapDays_GT?: InputMaybe<Scalars["Int"]>;
	documentationGapDays_GTE?: InputMaybe<Scalars["Int"]>;
	documentationGapDays_LT?: InputMaybe<Scalars["Int"]>;
	documentationGapDays_LTE?: InputMaybe<Scalars["Int"]>;
	documentationGapDays_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	documentationGapDays_MAX_GT?: InputMaybe<Scalars["Int"]>;
	documentationGapDays_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	documentationGapDays_MAX_LT?: InputMaybe<Scalars["Int"]>;
	documentationGapDays_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	documentationGapDays_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	documentationGapDays_MIN_GT?: InputMaybe<Scalars["Int"]>;
	documentationGapDays_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	documentationGapDays_MIN_LT?: InputMaybe<Scalars["Int"]>;
	documentationGapDays_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	firstExecutionDate_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_GT?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_GTE?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_LT?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_LTE?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	formattedAmount_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	formattedAmount_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	formattedAmount_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	formattedAmount_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	formattedAmount_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	formattedAmount_EQUAL?: InputMaybe<Scalars["String"]>;
	formattedAmount_GT?: InputMaybe<Scalars["Int"]>;
	formattedAmount_GTE?: InputMaybe<Scalars["Int"]>;
	formattedAmount_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedAmount_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedAmount_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedAmount_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedAmount_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	formattedAmount_LT?: InputMaybe<Scalars["Int"]>;
	formattedAmount_LTE?: InputMaybe<Scalars["Int"]>;
	formattedAmount_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedAmount_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedAmount_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedAmount_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedAmount_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	formattedCounterparties_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	formattedCounterparties_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	formattedCounterparties_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	formattedCounterparties_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	formattedCounterparties_EQUAL?: InputMaybe<Scalars["String"]>;
	formattedCounterparties_GT?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_GTE?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_LT?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_LTE?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	formattedProducts_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	formattedProducts_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	formattedProducts_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	formattedProducts_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	formattedProducts_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	formattedProducts_EQUAL?: InputMaybe<Scalars["String"]>;
	formattedProducts_GT?: InputMaybe<Scalars["Int"]>;
	formattedProducts_GTE?: InputMaybe<Scalars["Int"]>;
	formattedProducts_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedProducts_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedProducts_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedProducts_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedProducts_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	formattedProducts_LT?: InputMaybe<Scalars["Int"]>;
	formattedProducts_LTE?: InputMaybe<Scalars["Int"]>;
	formattedProducts_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedProducts_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedProducts_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedProducts_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedProducts_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	formattedTags_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	formattedTags_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	formattedTags_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	formattedTags_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	formattedTags_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	formattedTags_EQUAL?: InputMaybe<Scalars["String"]>;
	formattedTags_GT?: InputMaybe<Scalars["Int"]>;
	formattedTags_GTE?: InputMaybe<Scalars["Int"]>;
	formattedTags_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedTags_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedTags_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedTags_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedTags_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	formattedTags_LT?: InputMaybe<Scalars["Int"]>;
	formattedTags_LTE?: InputMaybe<Scalars["Int"]>;
	formattedTags_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedTags_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedTags_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedTags_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedTags_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	formattedValidityPeriod_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	formattedValidityPeriod_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	formattedValidityPeriod_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	formattedValidityPeriod_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	formattedValidityPeriod_EQUAL?: InputMaybe<Scalars["String"]>;
	formattedValidityPeriod_GT?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_GTE?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_LT?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_LTE?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	initialVersionId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	initialVersionId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	initialVersionId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	initialVersionId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	initialVersionId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	initialVersionId_EQUAL?: InputMaybe<Scalars["String"]>;
	initialVersionId_GT?: InputMaybe<Scalars["Int"]>;
	initialVersionId_GTE?: InputMaybe<Scalars["Int"]>;
	initialVersionId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	initialVersionId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	initialVersionId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	initialVersionId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	initialVersionId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	initialVersionId_LT?: InputMaybe<Scalars["Int"]>;
	initialVersionId_LTE?: InputMaybe<Scalars["Int"]>;
	initialVersionId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	initialVersionId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	initialVersionId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	initialVersionId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	initialVersionId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	lastExecutionDate_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_GT?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_LT?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_LTE?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	maxPatientNumber_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	maxPatientNumber_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	maxPatientNumber_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	maxPatientNumber_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	maxPatientNumber_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	maxPatientNumber_EQUAL?: InputMaybe<Scalars["Int"]>;
	maxPatientNumber_GT?: InputMaybe<Scalars["Int"]>;
	maxPatientNumber_GTE?: InputMaybe<Scalars["Int"]>;
	maxPatientNumber_LT?: InputMaybe<Scalars["Int"]>;
	maxPatientNumber_LTE?: InputMaybe<Scalars["Int"]>;
	maxPatientNumber_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	maxPatientNumber_MAX_GT?: InputMaybe<Scalars["Int"]>;
	maxPatientNumber_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	maxPatientNumber_MAX_LT?: InputMaybe<Scalars["Int"]>;
	maxPatientNumber_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	maxPatientNumber_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	maxPatientNumber_MIN_GT?: InputMaybe<Scalars["Int"]>;
	maxPatientNumber_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	maxPatientNumber_MIN_LT?: InputMaybe<Scalars["Int"]>;
	maxPatientNumber_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	maxTargetValue_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	maxTargetValue_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	maxTargetValue_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	maxTargetValue_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	maxTargetValue_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	maxTargetValue_EQUAL?: InputMaybe<Scalars["Float"]>;
	maxTargetValue_GT?: InputMaybe<Scalars["Float"]>;
	maxTargetValue_GTE?: InputMaybe<Scalars["Float"]>;
	maxTargetValue_LT?: InputMaybe<Scalars["Float"]>;
	maxTargetValue_LTE?: InputMaybe<Scalars["Float"]>;
	maxTargetValue_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	maxTargetValue_MAX_GT?: InputMaybe<Scalars["Float"]>;
	maxTargetValue_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	maxTargetValue_MAX_LT?: InputMaybe<Scalars["Float"]>;
	maxTargetValue_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	maxTargetValue_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	maxTargetValue_MIN_GT?: InputMaybe<Scalars["Float"]>;
	maxTargetValue_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	maxTargetValue_MIN_LT?: InputMaybe<Scalars["Float"]>;
	maxTargetValue_MIN_LTE?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	name_EQUAL?: InputMaybe<Scalars["String"]>;
	name_GT?: InputMaybe<Scalars["Int"]>;
	name_GTE?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	name_LT?: InputMaybe<Scalars["Int"]>;
	name_LTE?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	responseEvaluationMeasureName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	responseEvaluationMeasureName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	responseEvaluationMeasureName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	responseEvaluationMeasureName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	responseEvaluationMeasureName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	responseEvaluationMeasureName_EQUAL?: InputMaybe<Scalars["String"]>;
	responseEvaluationMeasureName_GT?: InputMaybe<Scalars["Int"]>;
	responseEvaluationMeasureName_GTE?: InputMaybe<Scalars["Int"]>;
	responseEvaluationMeasureName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	responseEvaluationMeasureName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	responseEvaluationMeasureName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	responseEvaluationMeasureName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	responseEvaluationMeasureName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	responseEvaluationMeasureName_LT?: InputMaybe<Scalars["Int"]>;
	responseEvaluationMeasureName_LTE?: InputMaybe<Scalars["Int"]>;
	responseEvaluationMeasureName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	responseEvaluationMeasureName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	responseEvaluationMeasureName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	responseEvaluationMeasureName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	responseEvaluationMeasureName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	treatmentBasePrice_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	treatmentBasePrice_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	treatmentBasePrice_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	treatmentBasePrice_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	treatmentBasePrice_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	treatmentBasePrice_EQUAL?: InputMaybe<Scalars["Float"]>;
	treatmentBasePrice_GT?: InputMaybe<Scalars["Float"]>;
	treatmentBasePrice_GTE?: InputMaybe<Scalars["Float"]>;
	treatmentBasePrice_LT?: InputMaybe<Scalars["Float"]>;
	treatmentBasePrice_LTE?: InputMaybe<Scalars["Float"]>;
	treatmentBasePrice_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	treatmentBasePrice_MAX_GT?: InputMaybe<Scalars["Float"]>;
	treatmentBasePrice_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	treatmentBasePrice_MAX_LT?: InputMaybe<Scalars["Float"]>;
	treatmentBasePrice_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	treatmentBasePrice_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	treatmentBasePrice_MIN_GT?: InputMaybe<Scalars["Float"]>;
	treatmentBasePrice_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	treatmentBasePrice_MIN_LT?: InputMaybe<Scalars["Float"]>;
	treatmentBasePrice_MIN_LTE?: InputMaybe<Scalars["Float"]>;
	vendorContractNumber_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	vendorContractNumber_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	vendorContractNumber_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	vendorContractNumber_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	vendorContractNumber_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	vendorContractNumber_EQUAL?: InputMaybe<Scalars["String"]>;
	vendorContractNumber_GT?: InputMaybe<Scalars["Int"]>;
	vendorContractNumber_GTE?: InputMaybe<Scalars["Int"]>;
	vendorContractNumber_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	vendorContractNumber_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	vendorContractNumber_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	vendorContractNumber_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	vendorContractNumber_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	vendorContractNumber_LT?: InputMaybe<Scalars["Int"]>;
	vendorContractNumber_LTE?: InputMaybe<Scalars["Int"]>;
	vendorContractNumber_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	vendorContractNumber_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	vendorContractNumber_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	vendorContractNumber_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	vendorContractNumber_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	vendorNumber_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	vendorNumber_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	vendorNumber_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	vendorNumber_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	vendorNumber_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	vendorNumber_EQUAL?: InputMaybe<Scalars["String"]>;
	vendorNumber_GT?: InputMaybe<Scalars["Int"]>;
	vendorNumber_GTE?: InputMaybe<Scalars["Int"]>;
	vendorNumber_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	vendorNumber_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	vendorNumber_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	vendorNumber_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	vendorNumber_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	vendorNumber_LT?: InputMaybe<Scalars["Int"]>;
	vendorNumber_LTE?: InputMaybe<Scalars["Int"]>;
	vendorNumber_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	vendorNumber_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	vendorNumber_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	vendorNumber_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	vendorNumber_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type CaseStobContractRelationship = {
	__typename?: "CaseStobContractRelationship";
	cursor: Scalars["String"];
	node: StobContract;
};

export type CaseStobContractUpdateConnectionInput = {
	node?: InputMaybe<StobContractUpdateInput>;
};

export type CaseStobContractUpdateFieldInput = {
	connect?: InputMaybe<CaseStobContractConnectFieldInput>;
	create?: InputMaybe<CaseStobContractCreateFieldInput>;
	delete?: InputMaybe<CaseStobContractDeleteFieldInput>;
	disconnect?: InputMaybe<CaseStobContractDisconnectFieldInput>;
	update?: InputMaybe<CaseStobContractUpdateConnectionInput>;
	where?: InputMaybe<CaseStobContractConnectionWhere>;
};

export type CaseTaskRelationship = {
	formDueOrOverdue?: Maybe<FormType>;
};

export type CaseTaskRelationshipCreateInput = {
	formDueOrOverdue?: InputMaybe<FormType>;
};

export type CaseTaskRelationshipSort = {
	formDueOrOverdue?: InputMaybe<SortDirection>;
};

export type CaseTaskRelationshipUpdateInput = {
	formDueOrOverdue?: InputMaybe<FormType>;
};

export type CaseTaskRelationshipWhere = {
	AND?: InputMaybe<Array<CaseTaskRelationshipWhere>>;
	OR?: InputMaybe<Array<CaseTaskRelationshipWhere>>;
	formDueOrOverdue?: InputMaybe<FormType>;
	formDueOrOverdue_IN?: InputMaybe<Array<InputMaybe<FormType>>>;
	formDueOrOverdue_NOT?: InputMaybe<FormType>;
	formDueOrOverdue_NOT_IN?: InputMaybe<Array<InputMaybe<FormType>>>;
};

export type CaseUpdateInput = {
	actualAgreementId?: InputMaybe<Scalars["String"]>;
	agreementName?: InputMaybe<Scalars["String"]>;
	baseAgreement?: InputMaybe<CaseBaseAgreementUpdateFieldInput>;
	claims?: InputMaybe<Array<CaseClaimsUpdateFieldInput>>;
	cohort?: InputMaybe<CaseCohortUpdateFieldInput>;
	coverageRequests?: InputMaybe<Array<CaseCoverageRequestsUpdateFieldInput>>;
	creationDate?: InputMaybe<Scalars["Date"]>;
	disease?: InputMaybe<CaseDiseaseUpdateFieldInput>;
	flexEntities?: InputMaybe<Array<CaseFlexEntitiesUpdateFieldInput>>;
	financialDataPoints?: InputMaybe<Array<CaseFlexFinancialDataPointsUpdateFieldInput>>;
	id?: InputMaybe<Scalars["ID"]>;
	indication?: InputMaybe<CaseIndicationUpdateFieldInput>;
	isArchived?: InputMaybe<Scalars["Boolean"]>;
	isDeleted?: InputMaybe<Scalars["Boolean"]>;
	legalEntity?: InputMaybe<CaseLegalEntityUpdateFieldInput>;
	patient?: InputMaybe<CasePatientUpdateFieldInput>;
	patientInitials?: InputMaybe<Scalars["String"]>;
	patientInsuranceId?: InputMaybe<Scalars["String"]>;
	preparationBandName?: InputMaybe<Scalars["String"]>;
	preparationGenericName?: InputMaybe<Scalars["String"]>;
	preparations?: InputMaybe<Array<CasePreparationsUpdateFieldInput>>;
	primaryIntervention?: InputMaybe<CasePrimaryInterventionUpdateFieldInput>;
	recordBatches?: InputMaybe<Array<CaseRecordBatchesUpdateFieldInput>>;
	sourceTenantId?: InputMaybe<Scalars["String"]>;
	stobContract?: InputMaybe<CaseStobContractUpdateFieldInput>;
	submissionDate?: InputMaybe<Scalars["DateTime"]>;
	tenantIds?: InputMaybe<Array<Scalars["String"]>>;
	totalAmount?: InputMaybe<Scalars["Float"]>;
	unlimited?: InputMaybe<Scalars["Int"]>;
};

export type CaseWhere = {
	counterpartyInReview_IN?: InputMaybe<Scalars["String"]>;
	AND?: InputMaybe<Array<CaseWhere>>;
	OR?: InputMaybe<Array<CaseWhere>>;
	actualAgreementId?: InputMaybe<Scalars["String"]>;
	actualAgreementId_CONTAINS?: InputMaybe<Scalars["String"]>;
	actualAgreementId_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	actualAgreementId_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	actualAgreementId_MATCHES?: InputMaybe<Scalars["String"]>;
	actualAgreementId_NOT?: InputMaybe<Scalars["String"]>;
	actualAgreementId_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	actualAgreementId_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	actualAgreementId_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	actualAgreementId_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	actualAgreementId_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	agreementName?: InputMaybe<Scalars["String"]>;
	agreementName_CONTAINS?: InputMaybe<Scalars["String"]>;
	agreementName_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	agreementName_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	agreementName_MATCHES?: InputMaybe<Scalars["String"]>;
	agreementName_NOT?: InputMaybe<Scalars["String"]>;
	agreementName_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	agreementName_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	agreementName_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	agreementName_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	agreementName_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	baseAgreement?: InputMaybe<BaseAgreementWhere>;
	baseAgreementAggregate?: InputMaybe<CaseBaseAgreementAggregateInput>;
	baseAgreementConnection?: InputMaybe<CaseBaseAgreementConnectionWhere>;
	baseAgreementConnection_NOT?: InputMaybe<CaseBaseAgreementConnectionWhere>;
	baseAgreement_NOT?: InputMaybe<BaseAgreementWhere>;
	claims?: InputMaybe<ClaimWhere>;
	claimsAggregate?: InputMaybe<CaseClaimsAggregateInput>;
	claimsConnection?: InputMaybe<CaseClaimsConnectionWhere>;
	claimsConnection_NOT?: InputMaybe<CaseClaimsConnectionWhere>;
	claims_NOT?: InputMaybe<ClaimWhere>;
	cohort?: InputMaybe<EnrollingPeriodWhere>;
	cohortAggregate?: InputMaybe<CaseCohortAggregateInput>;
	cohortConnection?: InputMaybe<CaseCohortConnectionWhere>;
	cohortConnection_NOT?: InputMaybe<CaseCohortConnectionWhere>;
	cohort_NOT?: InputMaybe<EnrollingPeriodWhere>;
	coverageRequests?: InputMaybe<CoverageRequestWhere>;
	coverageRequestsAggregate?: InputMaybe<CaseCoverageRequestsAggregateInput>;
	coverageRequestsConnection?: InputMaybe<CaseCoverageRequestsConnectionWhere>;
	coverageRequestsConnection_NOT?: InputMaybe<CaseCoverageRequestsConnectionWhere>;
	coverageRequests_NOT?: InputMaybe<CoverageRequestWhere>;
	creationDate?: InputMaybe<Scalars["Date"]>;
	creationDate_GT?: InputMaybe<Scalars["Date"]>;
	creationDate_GTE?: InputMaybe<Scalars["Date"]>;
	creationDate_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
	creationDate_LT?: InputMaybe<Scalars["Date"]>;
	creationDate_LTE?: InputMaybe<Scalars["Date"]>;
	creationDate_NOT?: InputMaybe<Scalars["Date"]>;
	creationDate_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
	disease?: InputMaybe<DiseaseWhere>;
	diseaseAggregate?: InputMaybe<CaseDiseaseAggregateInput>;
	diseaseConnection?: InputMaybe<CaseDiseaseConnectionWhere>;
	diseaseConnection_NOT?: InputMaybe<CaseDiseaseConnectionWhere>;
	disease_NOT?: InputMaybe<DiseaseWhere>;
	financialDataPointsAggregate?: InputMaybe<CaseFinancialDataPointsAggregateInput>;
	financialDataPointsConnection?: InputMaybe<CaseFinancialDataPointsConnectionWhere>;
	financialDataPointsConnection_NOT?: InputMaybe<CaseFinancialDataPointsConnectionWhere>;
	financialDataPoints_NOT?: InputMaybe<FinancialDataPointWhere>;
	flexEntities?: InputMaybe<FlexEntityWhere>;
	flexEntitiesAggregate?: InputMaybe<CaseFlexEntitiesAggregateInput>;
	flexEntitiesConnection?: InputMaybe<CaseFlexEntitiesConnectionWhere>;
	flexEntitiesConnection_NOT?: InputMaybe<CaseFlexEntitiesConnectionWhere>;
	flexEntities_NOT?: InputMaybe<FlexEntityWhere>;
	financialDataPoints?: InputMaybe<FlexFinancialDataPointWhere>;
	flexFinancialDataPointsAggregate?: InputMaybe<CaseFlexFinancialDataPointsAggregateInput>;
	flexFinancialDataPointsConnection?: InputMaybe<CaseFlexFinancialDataPointsConnectionWhere>;
	flexFinancialDataPointsConnection_NOT?: InputMaybe<CaseFlexFinancialDataPointsConnectionWhere>;
	flexFinancialDataPoints_NOT?: InputMaybe<FlexFinancialDataPointWhere>;
	id?: InputMaybe<Scalars["ID"]>;
	id_CONTAINS?: InputMaybe<Scalars["ID"]>;
	id_ENDS_WITH?: InputMaybe<Scalars["ID"]>;
	id_IN?: InputMaybe<Array<InputMaybe<Scalars["ID"]>>>;
	id_MATCHES?: InputMaybe<Scalars["String"]>;
	id_NOT?: InputMaybe<Scalars["ID"]>;
	id_NOT_CONTAINS?: InputMaybe<Scalars["ID"]>;
	id_NOT_ENDS_WITH?: InputMaybe<Scalars["ID"]>;
	id_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["ID"]>>>;
	id_NOT_STARTS_WITH?: InputMaybe<Scalars["ID"]>;
	id_STARTS_WITH?: InputMaybe<Scalars["ID"]>;
	indication?: InputMaybe<IndicationWhere>;
	indicationAggregate?: InputMaybe<CaseIndicationAggregateInput>;
	indicationConnection?: InputMaybe<CaseIndicationConnectionWhere>;
	indicationConnection_NOT?: InputMaybe<CaseIndicationConnectionWhere>;
	indication_NOT?: InputMaybe<IndicationWhere>;
	isArchived?: InputMaybe<Scalars["Boolean"]>;
	isArchived_NOT?: InputMaybe<Scalars["Boolean"]>;
	isDeleted?: InputMaybe<Scalars["Boolean"]>;
	isDeleted_NOT?: InputMaybe<Scalars["Boolean"]>;
	legalEntity?: InputMaybe<OrganizationWhere>;
	legalEntityAggregate?: InputMaybe<CaseLegalEntityAggregateInput>;
	legalEntityConnection?: InputMaybe<CaseLegalEntityConnectionWhere>;
	legalEntityConnection_NOT?: InputMaybe<CaseLegalEntityConnectionWhere>;
	legalEntity_NOT?: InputMaybe<OrganizationWhere>;
	patient?: InputMaybe<PatientWhere>;
	patientAggregate?: InputMaybe<CasePatientAggregateInput>;
	patientConnection?: InputMaybe<CasePatientConnectionWhere>;
	patientConnection_NOT?: InputMaybe<CasePatientConnectionWhere>;
	patientInitials?: InputMaybe<Scalars["String"]>;
	patientInitials_CONTAINS?: InputMaybe<Scalars["String"]>;
	patientInitials_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	patientInitials_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	patientInitials_MATCHES?: InputMaybe<Scalars["String"]>;
	patientInitials_NOT?: InputMaybe<Scalars["String"]>;
	patientInitials_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	patientInitials_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	patientInitials_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	patientInitials_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	patientInitials_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	patientInsuranceId?: InputMaybe<Scalars["String"]>;
	patientInsuranceId_CONTAINS?: InputMaybe<Scalars["String"]>;
	patientInsuranceId_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	patientInsuranceId_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	patientInsuranceId_MATCHES?: InputMaybe<Scalars["String"]>;
	patientInsuranceId_NOT?: InputMaybe<Scalars["String"]>;
	patientInsuranceId_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	patientInsuranceId_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	patientInsuranceId_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	patientInsuranceId_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	patientInsuranceId_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	patient_NOT?: InputMaybe<PatientWhere>;
	preparationBandName?: InputMaybe<Scalars["String"]>;
	preparationBandName_CONTAINS?: InputMaybe<Scalars["String"]>;
	preparationBandName_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	preparationBandName_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	preparationBandName_MATCHES?: InputMaybe<Scalars["String"]>;
	preparationBandName_NOT?: InputMaybe<Scalars["String"]>;
	preparationBandName_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	preparationBandName_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	preparationBandName_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	preparationBandName_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	preparationBandName_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	preparationGenericName?: InputMaybe<Scalars["String"]>;
	preparationGenericName_CONTAINS?: InputMaybe<Scalars["String"]>;
	preparationGenericName_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	preparationGenericName_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	preparationGenericName_MATCHES?: InputMaybe<Scalars["String"]>;
	preparationGenericName_NOT?: InputMaybe<Scalars["String"]>;
	preparationGenericName_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	preparationGenericName_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	preparationGenericName_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	preparationGenericName_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	preparationGenericName_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	preparations?: InputMaybe<PreparationWhere>;
	preparationsAggregate?: InputMaybe<CasePreparationsAggregateInput>;
	preparationsConnection?: InputMaybe<CasePreparationsConnectionWhere>;
	preparationsConnection_NOT?: InputMaybe<CasePreparationsConnectionWhere>;
	preparations_NOT?: InputMaybe<PreparationWhere>;
	primaryIntervention?: InputMaybe<InterventionWhere>;
	primaryInterventionAggregate?: InputMaybe<CasePrimaryInterventionAggregateInput>;
	primaryInterventionConnection?: InputMaybe<CasePrimaryInterventionConnectionWhere>;
	primaryInterventionConnection_NOT?: InputMaybe<CasePrimaryInterventionConnectionWhere>;
	primaryIntervention_NOT?: InputMaybe<InterventionWhere>;
	recordBatches?: InputMaybe<RecordBatchWhere>;
	recordBatchesAggregate?: InputMaybe<CaseRecordBatchesAggregateInput>;
	recordBatchesConnection?: InputMaybe<CaseRecordBatchesConnectionWhere>;
	recordBatchesConnection_NOT?: InputMaybe<CaseRecordBatchesConnectionWhere>;
	recordBatches_NOT?: InputMaybe<RecordBatchWhere>;
	sourceTenantId?: InputMaybe<Scalars["String"]>;
	sourceTenantId_CONTAINS?: InputMaybe<Scalars["String"]>;
	sourceTenantId_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	sourceTenantId_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	sourceTenantId_MATCHES?: InputMaybe<Scalars["String"]>;
	sourceTenantId_NOT?: InputMaybe<Scalars["String"]>;
	sourceTenantId_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	sourceTenantId_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	sourceTenantId_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	sourceTenantId_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	sourceTenantId_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	stobContract?: InputMaybe<StobContractWhere>;
	stobContractAggregate?: InputMaybe<CaseStobContractAggregateInput>;
	stobContractConnection?: InputMaybe<CaseStobContractConnectionWhere>;
	stobContractConnection_NOT?: InputMaybe<CaseStobContractConnectionWhere>;
	stobContract_NOT?: InputMaybe<StobContractWhere>;
	submissionDate?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_GT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_GTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_IN?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]>>>;
	submissionDate_LT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_LTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_NOT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]>>>;
	tenantIds?: InputMaybe<Array<Scalars["String"]>>;
	tenantIds_INCLUDES?: InputMaybe<Scalars["String"]>;
	tenantIds_NOT?: InputMaybe<Array<Scalars["String"]>>;
	tenantIds_NOT_INCLUDES?: InputMaybe<Scalars["String"]>;
	totalAmount?: InputMaybe<Scalars["Float"]>;
	totalAmount_GT?: InputMaybe<Scalars["Float"]>;
	totalAmount_GTE?: InputMaybe<Scalars["Float"]>;
	totalAmount_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	totalAmount_LT?: InputMaybe<Scalars["Float"]>;
	totalAmount_LTE?: InputMaybe<Scalars["Float"]>;
	totalAmount_NOT?: InputMaybe<Scalars["Float"]>;
	totalAmount_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	unlimited?: InputMaybe<Scalars["Int"]>;
	unlimited_GT?: InputMaybe<Scalars["Int"]>;
	unlimited_GTE?: InputMaybe<Scalars["Int"]>;
	unlimited_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	unlimited_LT?: InputMaybe<Scalars["Int"]>;
	unlimited_LTE?: InputMaybe<Scalars["Int"]>;
	unlimited_NOT?: InputMaybe<Scalars["Int"]>;
	unlimited_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
};

export type Claim = {
	__typename?: "Claim";
	administrationDate?: Maybe<Scalars["String"]>;
	assignee?: Maybe<Scalars["String"]>;
	cases: Array<Case>;
	casesConnection: ClaimCasesConnection;
	claimId?: Maybe<Scalars["String"]>;
	createdOn: Scalars["DateTime"];
	financialDataPoints: Array<FinancialDataPoint>;
	financialDataPointsConnection: ClaimFinancialDataPointsConnection;
	id?: Maybe<Scalars["ID"]>;
	includes: Array<Treatment>;
	includesConnection: ClaimIncludesConnection;
	invoiceAmount?: Maybe<Scalars["String"]>;
	invoiceDate?: Maybe<Scalars["String"]>;
	invoiceNumber?: Maybe<Scalars["String"]>;
	isArchived?: Maybe<Scalars["Boolean"]>;
	isDeleted?: Maybe<Scalars["Boolean"]>;
	preparationId?: Maybe<Scalars["String"]>;
	preparationIdType?: Maybe<Scalars["String"]>;
	providerId?: Maybe<Scalars["String"]>;
	providerName?: Maybe<Scalars["String"]>;
	quantity?: Maybe<Scalars["String"]>;
	receivedFromPatient?: Maybe<Patient>;
	receivedFromPatientConnection: ClaimReceivedFromPatientConnection;
	record: Record;
	recordConnection: ClaimRecordConnection;
	tenantId?: Maybe<Scalars["String"]>;
};

export type ClaimCasesArgs = {
	options?: InputMaybe<CaseOptions>;
	where?: InputMaybe<CaseWhere>;
};

export type ClaimCasesConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<ClaimCasesConnectionSort>>;
	where?: InputMaybe<ClaimCasesConnectionWhere>;
};

export type ClaimFinancialDataPointsArgs = {
	options?: InputMaybe<FinancialDataPointOptions>;
	where?: InputMaybe<FinancialDataPointWhere>;
};

export type ClaimFinancialDataPointsConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<ClaimFinancialDataPointsConnectionSort>>;
	where?: InputMaybe<ClaimFinancialDataPointsConnectionWhere>;
};

export type ClaimIncludesArgs = {
	options?: InputMaybe<TreatmentOptions>;
	where?: InputMaybe<TreatmentWhere>;
};

export type ClaimIncludesConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<ClaimIncludesConnectionSort>>;
	where?: InputMaybe<ClaimIncludesConnectionWhere>;
};

export type ClaimReceivedFromPatientArgs = {
	options?: InputMaybe<PatientOptions>;
	where?: InputMaybe<PatientWhere>;
};

export type ClaimReceivedFromPatientConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<ClaimReceivedFromPatientConnectionSort>>;
	where?: InputMaybe<ClaimReceivedFromPatientConnectionWhere>;
};

export type ClaimRecordArgs = {
	options?: InputMaybe<RecordOptions>;
	where?: InputMaybe<RecordWhere>;
};

export type ClaimRecordConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<ClaimRecordConnectionSort>>;
	where?: InputMaybe<ClaimRecordConnectionWhere>;
};

export type ClaimAggregateSelection = {
	__typename?: "ClaimAggregateSelection";
	administrationDate: StringAggregateSelection;
	assignee: StringAggregateSelection;
	claimId: StringAggregateSelection;
	count: Scalars["Int"];
	createdOn: DateTimeAggregateSelection;
	id: IdAggregateSelection;
	invoiceAmount: StringAggregateSelection;
	invoiceDate: StringAggregateSelection;
	invoiceNumber: StringAggregateSelection;
	preparationId: StringAggregateSelection;
	preparationIdType: StringAggregateSelection;
	providerId: StringAggregateSelection;
	providerName: StringAggregateSelection;
	quantity: StringAggregateSelection;
	tenantId: StringAggregateSelection;
};

export type ClaimCasesAggregateInput = {
	AND?: InputMaybe<Array<ClaimCasesAggregateInput>>;
	OR?: InputMaybe<Array<ClaimCasesAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<ClaimCasesNodeAggregationWhereInput>;
};

export type ClaimCasesConnectFieldInput = {
	connect?: InputMaybe<Array<CaseConnectInput>>;
	edge?: InputMaybe<ClaimEnrolledIntoCaseRelationshipCreateInput>;
	where?: InputMaybe<CaseConnectWhere>;
};

export type ClaimCasesConnection = {
	__typename?: "ClaimCasesConnection";
	edges: Array<ClaimCasesRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type ClaimCasesConnectionSort = {
	edge?: InputMaybe<ClaimEnrolledIntoCaseRelationshipSort>;
	node?: InputMaybe<CaseSort>;
};

export type ClaimCasesConnectionWhere = {
	AND?: InputMaybe<Array<ClaimCasesConnectionWhere>>;
	OR?: InputMaybe<Array<ClaimCasesConnectionWhere>>;
	edge?: InputMaybe<ClaimEnrolledIntoCaseRelationshipWhere>;
	edge_NOT?: InputMaybe<ClaimEnrolledIntoCaseRelationshipWhere>;
	node?: InputMaybe<CaseWhere>;
	node_NOT?: InputMaybe<CaseWhere>;
};

export type ClaimCasesCreateFieldInput = {
	edge?: InputMaybe<ClaimEnrolledIntoCaseRelationshipCreateInput>;
	node: CaseCreateInput;
};

export type ClaimCasesDeleteFieldInput = {
	delete?: InputMaybe<CaseDeleteInput>;
	where?: InputMaybe<ClaimCasesConnectionWhere>;
};

export type ClaimCasesDisconnectFieldInput = {
	disconnect?: InputMaybe<CaseDisconnectInput>;
	where?: InputMaybe<ClaimCasesConnectionWhere>;
};

export type ClaimCasesFieldInput = {
	connect?: InputMaybe<Array<ClaimCasesConnectFieldInput>>;
	create?: InputMaybe<Array<ClaimCasesCreateFieldInput>>;
};

export type ClaimCasesNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<ClaimCasesNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<ClaimCasesNodeAggregationWhereInput>>;
	actualAgreementId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	actualAgreementId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	actualAgreementId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	actualAgreementId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	actualAgreementId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	actualAgreementId_EQUAL?: InputMaybe<Scalars["String"]>;
	actualAgreementId_GT?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_GTE?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_LT?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_LTE?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	agreementName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	agreementName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	agreementName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	agreementName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	agreementName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	agreementName_EQUAL?: InputMaybe<Scalars["String"]>;
	agreementName_GT?: InputMaybe<Scalars["Int"]>;
	agreementName_GTE?: InputMaybe<Scalars["Int"]>;
	agreementName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	agreementName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	agreementName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	agreementName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	agreementName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	agreementName_LT?: InputMaybe<Scalars["Int"]>;
	agreementName_LTE?: InputMaybe<Scalars["Int"]>;
	agreementName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	agreementName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	agreementName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	agreementName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	agreementName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	patientInitials_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	patientInitials_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	patientInitials_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	patientInitials_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	patientInitials_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	patientInitials_EQUAL?: InputMaybe<Scalars["String"]>;
	patientInitials_GT?: InputMaybe<Scalars["Int"]>;
	patientInitials_GTE?: InputMaybe<Scalars["Int"]>;
	patientInitials_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	patientInitials_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	patientInitials_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	patientInitials_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	patientInitials_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	patientInitials_LT?: InputMaybe<Scalars["Int"]>;
	patientInitials_LTE?: InputMaybe<Scalars["Int"]>;
	patientInitials_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	patientInitials_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	patientInitials_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	patientInitials_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	patientInitials_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	patientInsuranceId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	patientInsuranceId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	patientInsuranceId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	patientInsuranceId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	patientInsuranceId_EQUAL?: InputMaybe<Scalars["String"]>;
	patientInsuranceId_GT?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_GTE?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_LT?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_LTE?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationBandName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	preparationBandName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	preparationBandName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	preparationBandName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	preparationBandName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	preparationBandName_EQUAL?: InputMaybe<Scalars["String"]>;
	preparationBandName_GT?: InputMaybe<Scalars["Int"]>;
	preparationBandName_GTE?: InputMaybe<Scalars["Int"]>;
	preparationBandName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationBandName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationBandName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationBandName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationBandName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationBandName_LT?: InputMaybe<Scalars["Int"]>;
	preparationBandName_LTE?: InputMaybe<Scalars["Int"]>;
	preparationBandName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationBandName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationBandName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationBandName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationBandName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	preparationGenericName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	preparationGenericName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	preparationGenericName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	preparationGenericName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	preparationGenericName_EQUAL?: InputMaybe<Scalars["String"]>;
	preparationGenericName_GT?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_GTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_LT?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_LTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	sourceTenantId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	sourceTenantId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	sourceTenantId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	sourceTenantId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	sourceTenantId_EQUAL?: InputMaybe<Scalars["String"]>;
	sourceTenantId_GT?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_GTE?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_LT?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_LTE?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	submissionDate_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_GT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_GTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_LT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_LTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	totalAmount_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	totalAmount_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	totalAmount_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	totalAmount_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	totalAmount_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	totalAmount_EQUAL?: InputMaybe<Scalars["Float"]>;
	totalAmount_GT?: InputMaybe<Scalars["Float"]>;
	totalAmount_GTE?: InputMaybe<Scalars["Float"]>;
	totalAmount_LT?: InputMaybe<Scalars["Float"]>;
	totalAmount_LTE?: InputMaybe<Scalars["Float"]>;
	totalAmount_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	totalAmount_MAX_GT?: InputMaybe<Scalars["Float"]>;
	totalAmount_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	totalAmount_MAX_LT?: InputMaybe<Scalars["Float"]>;
	totalAmount_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	totalAmount_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	totalAmount_MIN_GT?: InputMaybe<Scalars["Float"]>;
	totalAmount_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	totalAmount_MIN_LT?: InputMaybe<Scalars["Float"]>;
	totalAmount_MIN_LTE?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	unlimited_EQUAL?: InputMaybe<Scalars["Int"]>;
	unlimited_GT?: InputMaybe<Scalars["Int"]>;
	unlimited_GTE?: InputMaybe<Scalars["Int"]>;
	unlimited_LT?: InputMaybe<Scalars["Int"]>;
	unlimited_LTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_GT?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_LT?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_GT?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_LT?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_LTE?: InputMaybe<Scalars["Int"]>;
};

export type ClaimCasesRelationship = ClaimEnrolledIntoCaseRelationship & {
	__typename?: "ClaimCasesRelationship";
	cursor: Scalars["String"];
	lastProcessingDate?: Maybe<Scalars["Date"]>;
	node: Case;
};

export type ClaimCasesUpdateConnectionInput = {
	edge?: InputMaybe<ClaimEnrolledIntoCaseRelationshipUpdateInput>;
	node?: InputMaybe<CaseUpdateInput>;
};

export type ClaimCasesUpdateFieldInput = {
	connect?: InputMaybe<Array<ClaimCasesConnectFieldInput>>;
	create?: InputMaybe<Array<ClaimCasesCreateFieldInput>>;
	delete?: InputMaybe<Array<ClaimCasesDeleteFieldInput>>;
	disconnect?: InputMaybe<Array<ClaimCasesDisconnectFieldInput>>;
	update?: InputMaybe<ClaimCasesUpdateConnectionInput>;
	where?: InputMaybe<ClaimCasesConnectionWhere>;
};

export type ClaimConnectInput = {
	cases?: InputMaybe<Array<ClaimCasesConnectFieldInput>>;
	financialDataPoints?: InputMaybe<Array<ClaimFinancialDataPointsConnectFieldInput>>;
	includes?: InputMaybe<Array<ClaimIncludesConnectFieldInput>>;
	receivedFromPatient?: InputMaybe<ClaimReceivedFromPatientConnectFieldInput>;
	record?: InputMaybe<ClaimRecordConnectFieldInput>;
};

export type ClaimConnectWhere = {
	node: ClaimWhere;
};

export type ClaimCreateInput = {
	administrationDate?: InputMaybe<Scalars["String"]>;
	assignee?: InputMaybe<Scalars["String"]>;
	cases?: InputMaybe<ClaimCasesFieldInput>;
	claimId?: InputMaybe<Scalars["String"]>;
	createdOn: Scalars["DateTime"];
	financialDataPoints?: InputMaybe<ClaimFinancialDataPointsFieldInput>;
	id?: InputMaybe<Scalars["ID"]>;
	includes?: InputMaybe<ClaimIncludesFieldInput>;
	invoiceAmount?: InputMaybe<Scalars["String"]>;
	invoiceDate?: InputMaybe<Scalars["String"]>;
	invoiceNumber?: InputMaybe<Scalars["String"]>;
	isArchived?: InputMaybe<Scalars["Boolean"]>;
	isDeleted?: InputMaybe<Scalars["Boolean"]>;
	preparationId?: InputMaybe<Scalars["String"]>;
	preparationIdType?: InputMaybe<Scalars["String"]>;
	providerId?: InputMaybe<Scalars["String"]>;
	providerName?: InputMaybe<Scalars["String"]>;
	quantity?: InputMaybe<Scalars["String"]>;
	receivedFromPatient?: InputMaybe<ClaimReceivedFromPatientFieldInput>;
	record?: InputMaybe<ClaimRecordFieldInput>;
	tenantId?: InputMaybe<Scalars["String"]>;
};

export type ClaimDeleteInput = {
	cases?: InputMaybe<Array<ClaimCasesDeleteFieldInput>>;
	financialDataPoints?: InputMaybe<Array<ClaimFinancialDataPointsDeleteFieldInput>>;
	includes?: InputMaybe<Array<ClaimIncludesDeleteFieldInput>>;
	receivedFromPatient?: InputMaybe<ClaimReceivedFromPatientDeleteFieldInput>;
	record?: InputMaybe<ClaimRecordDeleteFieldInput>;
};

export type ClaimDisconnectInput = {
	cases?: InputMaybe<Array<ClaimCasesDisconnectFieldInput>>;
	financialDataPoints?: InputMaybe<Array<ClaimFinancialDataPointsDisconnectFieldInput>>;
	includes?: InputMaybe<Array<ClaimIncludesDisconnectFieldInput>>;
	receivedFromPatient?: InputMaybe<ClaimReceivedFromPatientDisconnectFieldInput>;
	record?: InputMaybe<ClaimRecordDisconnectFieldInput>;
};

export type ClaimEnrolledIntoCaseRelationship = {
	lastProcessingDate?: Maybe<Scalars["Date"]>;
};

export type ClaimEnrolledIntoCaseRelationshipCreateInput = {
	lastProcessingDate?: InputMaybe<Scalars["Date"]>;
};

export type ClaimEnrolledIntoCaseRelationshipSort = {
	lastProcessingDate?: InputMaybe<SortDirection>;
};

export type ClaimEnrolledIntoCaseRelationshipUpdateInput = {
	lastProcessingDate?: InputMaybe<Scalars["Date"]>;
};

export type ClaimEnrolledIntoCaseRelationshipWhere = {
	AND?: InputMaybe<Array<ClaimEnrolledIntoCaseRelationshipWhere>>;
	OR?: InputMaybe<Array<ClaimEnrolledIntoCaseRelationshipWhere>>;
	lastProcessingDate?: InputMaybe<Scalars["Date"]>;
	lastProcessingDate_GT?: InputMaybe<Scalars["Date"]>;
	lastProcessingDate_GTE?: InputMaybe<Scalars["Date"]>;
	lastProcessingDate_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
	lastProcessingDate_LT?: InputMaybe<Scalars["Date"]>;
	lastProcessingDate_LTE?: InputMaybe<Scalars["Date"]>;
	lastProcessingDate_NOT?: InputMaybe<Scalars["Date"]>;
	lastProcessingDate_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
};

export type ClaimFinancialDataPointsAggregateInput = {
	AND?: InputMaybe<Array<ClaimFinancialDataPointsAggregateInput>>;
	OR?: InputMaybe<Array<ClaimFinancialDataPointsAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<ClaimFinancialDataPointsNodeAggregationWhereInput>;
};

export type ClaimFinancialDataPointsConnectFieldInput = {
	connect?: InputMaybe<Array<FinancialDataPointConnectInput>>;
	where?: InputMaybe<FinancialDataPointConnectWhere>;
};

export type ClaimFinancialDataPointsConnection = {
	__typename?: "ClaimFinancialDataPointsConnection";
	edges: Array<ClaimFinancialDataPointsRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type ClaimFinancialDataPointsConnectionSort = {
	node?: InputMaybe<FinancialDataPointSort>;
};

export type ClaimFinancialDataPointsConnectionWhere = {
	AND?: InputMaybe<Array<ClaimFinancialDataPointsConnectionWhere>>;
	OR?: InputMaybe<Array<ClaimFinancialDataPointsConnectionWhere>>;
	node?: InputMaybe<FinancialDataPointWhere>;
	node_NOT?: InputMaybe<FinancialDataPointWhere>;
};

export type ClaimFinancialDataPointsCreateFieldInput = {
	node: FinancialDataPointCreateInput;
};

export type ClaimFinancialDataPointsDeleteFieldInput = {
	delete?: InputMaybe<FinancialDataPointDeleteInput>;
	where?: InputMaybe<ClaimFinancialDataPointsConnectionWhere>;
};

export type ClaimFinancialDataPointsDisconnectFieldInput = {
	disconnect?: InputMaybe<FinancialDataPointDisconnectInput>;
	where?: InputMaybe<ClaimFinancialDataPointsConnectionWhere>;
};

export type ClaimFinancialDataPointsFieldInput = {
	connect?: InputMaybe<Array<ClaimFinancialDataPointsConnectFieldInput>>;
	create?: InputMaybe<Array<ClaimFinancialDataPointsCreateFieldInput>>;
};

export type ClaimFinancialDataPointsNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<ClaimFinancialDataPointsNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<ClaimFinancialDataPointsNodeAggregationWhereInput>>;
	basePrice_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	basePrice_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	basePrice_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	basePrice_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	basePrice_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	basePrice_EQUAL?: InputMaybe<Scalars["Float"]>;
	basePrice_GT?: InputMaybe<Scalars["Float"]>;
	basePrice_GTE?: InputMaybe<Scalars["Float"]>;
	basePrice_LT?: InputMaybe<Scalars["Float"]>;
	basePrice_LTE?: InputMaybe<Scalars["Float"]>;
	basePrice_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	basePrice_MAX_GT?: InputMaybe<Scalars["Float"]>;
	basePrice_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	basePrice_MAX_LT?: InputMaybe<Scalars["Float"]>;
	basePrice_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	basePrice_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	basePrice_MIN_GT?: InputMaybe<Scalars["Float"]>;
	basePrice_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	basePrice_MIN_LT?: InputMaybe<Scalars["Float"]>;
	basePrice_MIN_LTE?: InputMaybe<Scalars["Float"]>;
	currencyCode_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	currencyCode_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	currencyCode_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	currencyCode_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	currencyCode_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	currencyCode_EQUAL?: InputMaybe<Scalars["String"]>;
	currencyCode_GT?: InputMaybe<Scalars["Int"]>;
	currencyCode_GTE?: InputMaybe<Scalars["Int"]>;
	currencyCode_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	currencyCode_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	currencyCode_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	currencyCode_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	currencyCode_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	currencyCode_LT?: InputMaybe<Scalars["Int"]>;
	currencyCode_LTE?: InputMaybe<Scalars["Int"]>;
	currencyCode_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	currencyCode_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	currencyCode_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	currencyCode_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	currencyCode_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	evaluationSnapshot_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	evaluationSnapshot_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	evaluationSnapshot_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	evaluationSnapshot_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	evaluationSnapshot_EQUAL?: InputMaybe<Scalars["String"]>;
	evaluationSnapshot_GT?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_GTE?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_LT?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_LTE?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	generatedUuid_EQUAL?: InputMaybe<Scalars["ID"]>;
	payablePercentage_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	payablePercentage_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	payablePercentage_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	payablePercentage_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	payablePercentage_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	payablePercentage_EQUAL?: InputMaybe<Scalars["Float"]>;
	payablePercentage_GT?: InputMaybe<Scalars["Float"]>;
	payablePercentage_GTE?: InputMaybe<Scalars["Float"]>;
	payablePercentage_LT?: InputMaybe<Scalars["Float"]>;
	payablePercentage_LTE?: InputMaybe<Scalars["Float"]>;
	payablePercentage_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	payablePercentage_MAX_GT?: InputMaybe<Scalars["Float"]>;
	payablePercentage_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	payablePercentage_MAX_LT?: InputMaybe<Scalars["Float"]>;
	payablePercentage_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	payablePercentage_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	payablePercentage_MIN_GT?: InputMaybe<Scalars["Float"]>;
	payablePercentage_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	payablePercentage_MIN_LT?: InputMaybe<Scalars["Float"]>;
	payablePercentage_MIN_LTE?: InputMaybe<Scalars["Float"]>;
	payable_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	payable_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	payable_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	payable_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	payable_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	payable_EQUAL?: InputMaybe<Scalars["Float"]>;
	payable_GT?: InputMaybe<Scalars["Float"]>;
	payable_GTE?: InputMaybe<Scalars["Float"]>;
	payable_LT?: InputMaybe<Scalars["Float"]>;
	payable_LTE?: InputMaybe<Scalars["Float"]>;
	payable_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	payable_MAX_GT?: InputMaybe<Scalars["Float"]>;
	payable_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	payable_MAX_LT?: InputMaybe<Scalars["Float"]>;
	payable_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	payable_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	payable_MIN_GT?: InputMaybe<Scalars["Float"]>;
	payable_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	payable_MIN_LT?: InputMaybe<Scalars["Float"]>;
	payable_MIN_LTE?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	quantity_EQUAL?: InputMaybe<Scalars["Float"]>;
	quantity_GT?: InputMaybe<Scalars["Float"]>;
	quantity_GTE?: InputMaybe<Scalars["Float"]>;
	quantity_LT?: InputMaybe<Scalars["Float"]>;
	quantity_LTE?: InputMaybe<Scalars["Float"]>;
	quantity_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	quantity_MAX_GT?: InputMaybe<Scalars["Float"]>;
	quantity_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	quantity_MAX_LT?: InputMaybe<Scalars["Float"]>;
	quantity_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	quantity_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	quantity_MIN_GT?: InputMaybe<Scalars["Float"]>;
	quantity_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	quantity_MIN_LT?: InputMaybe<Scalars["Float"]>;
	quantity_MIN_LTE?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_EQUAL?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_GT?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_GTE?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_LT?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_LTE?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_MAX_GT?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_MAX_LT?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_MIN_GT?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_MIN_LT?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_MIN_LTE?: InputMaybe<Scalars["Float"]>;
	refundable_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	refundable_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	refundable_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	refundable_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	refundable_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	refundable_EQUAL?: InputMaybe<Scalars["Float"]>;
	refundable_GT?: InputMaybe<Scalars["Float"]>;
	refundable_GTE?: InputMaybe<Scalars["Float"]>;
	refundable_LT?: InputMaybe<Scalars["Float"]>;
	refundable_LTE?: InputMaybe<Scalars["Float"]>;
	refundable_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	refundable_MAX_GT?: InputMaybe<Scalars["Float"]>;
	refundable_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	refundable_MAX_LT?: InputMaybe<Scalars["Float"]>;
	refundable_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	refundable_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	refundable_MIN_GT?: InputMaybe<Scalars["Float"]>;
	refundable_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	refundable_MIN_LT?: InputMaybe<Scalars["Float"]>;
	refundable_MIN_LTE?: InputMaybe<Scalars["Float"]>;
	uuid_EQUAL?: InputMaybe<Scalars["ID"]>;
	variablePercentage_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	variablePercentage_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	variablePercentage_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	variablePercentage_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	variablePercentage_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	variablePercentage_EQUAL?: InputMaybe<Scalars["Float"]>;
	variablePercentage_GT?: InputMaybe<Scalars["Float"]>;
	variablePercentage_GTE?: InputMaybe<Scalars["Float"]>;
	variablePercentage_LT?: InputMaybe<Scalars["Float"]>;
	variablePercentage_LTE?: InputMaybe<Scalars["Float"]>;
	variablePercentage_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	variablePercentage_MAX_GT?: InputMaybe<Scalars["Float"]>;
	variablePercentage_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	variablePercentage_MAX_LT?: InputMaybe<Scalars["Float"]>;
	variablePercentage_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	variablePercentage_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	variablePercentage_MIN_GT?: InputMaybe<Scalars["Float"]>;
	variablePercentage_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	variablePercentage_MIN_LT?: InputMaybe<Scalars["Float"]>;
	variablePercentage_MIN_LTE?: InputMaybe<Scalars["Float"]>;
	variable_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	variable_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	variable_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	variable_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	variable_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	variable_EQUAL?: InputMaybe<Scalars["Float"]>;
	variable_GT?: InputMaybe<Scalars["Float"]>;
	variable_GTE?: InputMaybe<Scalars["Float"]>;
	variable_LT?: InputMaybe<Scalars["Float"]>;
	variable_LTE?: InputMaybe<Scalars["Float"]>;
	variable_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	variable_MAX_GT?: InputMaybe<Scalars["Float"]>;
	variable_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	variable_MAX_LT?: InputMaybe<Scalars["Float"]>;
	variable_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	variable_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	variable_MIN_GT?: InputMaybe<Scalars["Float"]>;
	variable_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	variable_MIN_LT?: InputMaybe<Scalars["Float"]>;
	variable_MIN_LTE?: InputMaybe<Scalars["Float"]>;
};

export type ClaimFinancialDataPointsRelationship = {
	__typename?: "ClaimFinancialDataPointsRelationship";
	cursor: Scalars["String"];
	node: FinancialDataPoint;
};

export type ClaimFinancialDataPointsUpdateConnectionInput = {
	node?: InputMaybe<FinancialDataPointUpdateInput>;
};

export type ClaimFinancialDataPointsUpdateFieldInput = {
	connect?: InputMaybe<Array<ClaimFinancialDataPointsConnectFieldInput>>;
	create?: InputMaybe<Array<ClaimFinancialDataPointsCreateFieldInput>>;
	delete?: InputMaybe<Array<ClaimFinancialDataPointsDeleteFieldInput>>;
	disconnect?: InputMaybe<Array<ClaimFinancialDataPointsDisconnectFieldInput>>;
	update?: InputMaybe<ClaimFinancialDataPointsUpdateConnectionInput>;
	where?: InputMaybe<ClaimFinancialDataPointsConnectionWhere>;
};

export type ClaimIncludesAggregateInput = {
	AND?: InputMaybe<Array<ClaimIncludesAggregateInput>>;
	OR?: InputMaybe<Array<ClaimIncludesAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<ClaimIncludesNodeAggregationWhereInput>;
};

export type ClaimIncludesConnectFieldInput = {
	connect?: InputMaybe<Array<TreatmentConnectInput>>;
	where?: InputMaybe<TreatmentConnectWhere>;
};

export type ClaimIncludesConnection = {
	__typename?: "ClaimIncludesConnection";
	edges: Array<ClaimIncludesRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type ClaimIncludesConnectionSort = {
	node?: InputMaybe<TreatmentSort>;
};

export type ClaimIncludesConnectionWhere = {
	AND?: InputMaybe<Array<ClaimIncludesConnectionWhere>>;
	OR?: InputMaybe<Array<ClaimIncludesConnectionWhere>>;
	node?: InputMaybe<TreatmentWhere>;
	node_NOT?: InputMaybe<TreatmentWhere>;
};

export type ClaimIncludesCreateFieldInput = {
	node: TreatmentCreateInput;
};

export type ClaimIncludesDeleteFieldInput = {
	delete?: InputMaybe<TreatmentDeleteInput>;
	where?: InputMaybe<ClaimIncludesConnectionWhere>;
};

export type ClaimIncludesDisconnectFieldInput = {
	disconnect?: InputMaybe<TreatmentDisconnectInput>;
	where?: InputMaybe<ClaimIncludesConnectionWhere>;
};

export type ClaimIncludesFieldInput = {
	connect?: InputMaybe<Array<ClaimIncludesConnectFieldInput>>;
	create?: InputMaybe<Array<ClaimIncludesCreateFieldInput>>;
};

export type ClaimIncludesNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<ClaimIncludesNodeAggregationWhereInput>>;
	BagDossierNo_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	BagDossierNo_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	BagDossierNo_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	BagDossierNo_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	BagDossierNo_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	BagDossierNo_EQUAL?: InputMaybe<Scalars["String"]>;
	BagDossierNo_GT?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_GTE?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LT?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LTE?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	Code_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	Code_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	Code_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	Code_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	Code_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	Code_EQUAL?: InputMaybe<Scalars["String"]>;
	Code_GT?: InputMaybe<Scalars["Int"]>;
	Code_GTE?: InputMaybe<Scalars["Int"]>;
	Code_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Code_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	Code_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	Code_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	Code_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	Code_LT?: InputMaybe<Scalars["Int"]>;
	Code_LTE?: InputMaybe<Scalars["Int"]>;
	Code_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Code_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	Code_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	Code_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	Code_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	FlagModal_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	FlagModal_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	FlagModal_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	FlagModal_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	FlagModal_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	FlagModal_EQUAL?: InputMaybe<Scalars["String"]>;
	FlagModal_GT?: InputMaybe<Scalars["Int"]>;
	FlagModal_GTE?: InputMaybe<Scalars["Int"]>;
	FlagModal_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	FlagModal_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	FlagModal_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	FlagModal_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	FlagModal_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	FlagModal_LT?: InputMaybe<Scalars["Int"]>;
	FlagModal_LTE?: InputMaybe<Scalars["Int"]>;
	FlagModal_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	FlagModal_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	FlagModal_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	FlagModal_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	FlagModal_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	FlagNarcosis_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	FlagNarcosis_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	FlagNarcosis_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	FlagNarcosis_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	FlagNarcosis_EQUAL?: InputMaybe<Scalars["String"]>;
	FlagNarcosis_GT?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_GTE?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LT?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LTE?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	GTIN_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	GTIN_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	GTIN_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	GTIN_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	GTIN_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	GTIN_EQUAL?: InputMaybe<Scalars["String"]>;
	GTIN_GT?: InputMaybe<Scalars["Int"]>;
	GTIN_GTE?: InputMaybe<Scalars["Int"]>;
	GTIN_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	GTIN_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	GTIN_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	GTIN_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	GTIN_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	GTIN_LT?: InputMaybe<Scalars["Int"]>;
	GTIN_LTE?: InputMaybe<Scalars["Int"]>;
	GTIN_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	GTIN_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	GTIN_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	GTIN_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	GTIN_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	LOT_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	LOT_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	LOT_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	LOT_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	LOT_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	LOT_EQUAL?: InputMaybe<Scalars["String"]>;
	LOT_GT?: InputMaybe<Scalars["Int"]>;
	LOT_GTE?: InputMaybe<Scalars["Int"]>;
	LOT_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	LOT_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	LOT_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	LOT_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	LOT_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	LOT_LT?: InputMaybe<Scalars["Int"]>;
	LOT_LTE?: InputMaybe<Scalars["Int"]>;
	LOT_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	LOT_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	LOT_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	LOT_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	LOT_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	Name_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	Name_EQUAL?: InputMaybe<Scalars["String"]>;
	Name_GT?: InputMaybe<Scalars["Int"]>;
	Name_GTE?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	Name_LT?: InputMaybe<Scalars["Int"]>;
	Name_LTE?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	OR?: InputMaybe<Array<ClaimIncludesNodeAggregationWhereInput>>;
	PharmaCode_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	PharmaCode_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	PharmaCode_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	PharmaCode_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	PharmaCode_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	PharmaCode_EQUAL?: InputMaybe<Scalars["String"]>;
	PharmaCode_GT?: InputMaybe<Scalars["Int"]>;
	PharmaCode_GTE?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LT?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LTE?: InputMaybe<Scalars["Int"]>;
	PharmaCode_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	PharmaCode_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	PharmaCode_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	PharmaCode_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	PharmaCode_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	PrevPharmacode_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	PrevPharmacode_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	PrevPharmacode_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	PrevPharmacode_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	PrevPharmacode_EQUAL?: InputMaybe<Scalars["String"]>;
	PrevPharmacode_GT?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_GTE?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LT?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LTE?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	REF_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	REF_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	REF_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	REF_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	REF_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	REF_EQUAL?: InputMaybe<Scalars["String"]>;
	REF_GT?: InputMaybe<Scalars["Int"]>;
	REF_GTE?: InputMaybe<Scalars["Int"]>;
	REF_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	REF_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	REF_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	REF_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	REF_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	REF_LT?: InputMaybe<Scalars["Int"]>;
	REF_LTE?: InputMaybe<Scalars["Int"]>;
	REF_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	REF_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	REF_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	REF_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	REF_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	SwissmedicCategory_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	SwissmedicCategory_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	SwissmedicCategory_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	SwissmedicCategory_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	SwissmedicCategory_EQUAL?: InputMaybe<Scalars["String"]>;
	SwissmedicCategory_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo8_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo8_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo8_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo8_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo8_EQUAL?: InputMaybe<Scalars["String"]>;
	SwissmedicNo8_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	UDI_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	UDI_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	UDI_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	UDI_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	UDI_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	UDI_EQUAL?: InputMaybe<Scalars["String"]>;
	UDI_GT?: InputMaybe<Scalars["Int"]>;
	UDI_GTE?: InputMaybe<Scalars["Int"]>;
	UDI_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	UDI_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	UDI_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	UDI_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	UDI_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	UDI_LT?: InputMaybe<Scalars["Int"]>;
	UDI_LTE?: InputMaybe<Scalars["Int"]>;
	UDI_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	UDI_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	UDI_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	UDI_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	UDI_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	classificationSystem_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	classificationSystem_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	classificationSystem_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	classificationSystem_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	classificationSystem_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	classificationSystem_EQUAL?: InputMaybe<Scalars["String"]>;
	classificationSystem_GT?: InputMaybe<Scalars["Int"]>;
	classificationSystem_GTE?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LT?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LTE?: InputMaybe<Scalars["Int"]>;
	classificationSystem_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	classificationSystem_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	classificationSystem_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	classificationSystem_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	classificationSystem_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type ClaimIncludesRelationship = {
	__typename?: "ClaimIncludesRelationship";
	cursor: Scalars["String"];
	node: Treatment;
};

export type ClaimIncludesUpdateConnectionInput = {
	node?: InputMaybe<TreatmentUpdateInput>;
};

export type ClaimIncludesUpdateFieldInput = {
	connect?: InputMaybe<Array<ClaimIncludesConnectFieldInput>>;
	create?: InputMaybe<Array<ClaimIncludesCreateFieldInput>>;
	delete?: InputMaybe<Array<ClaimIncludesDeleteFieldInput>>;
	disconnect?: InputMaybe<Array<ClaimIncludesDisconnectFieldInput>>;
	update?: InputMaybe<ClaimIncludesUpdateConnectionInput>;
	where?: InputMaybe<ClaimIncludesConnectionWhere>;
};

export type ClaimOptions = {
	limit?: InputMaybe<Scalars["Int"]>;
	offset?: InputMaybe<Scalars["Int"]>;
	/** Specify one or more ClaimSort objects to sort Claims by. The sorts will be applied in the order in which they are arranged in the array. */
	sort?: InputMaybe<Array<InputMaybe<ClaimSort>>>;
};

export type ClaimReceivedFromPatientAggregateInput = {
	AND?: InputMaybe<Array<ClaimReceivedFromPatientAggregateInput>>;
	OR?: InputMaybe<Array<ClaimReceivedFromPatientAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<ClaimReceivedFromPatientNodeAggregationWhereInput>;
};

export type ClaimReceivedFromPatientConnectFieldInput = {
	connect?: InputMaybe<PatientConnectInput>;
	where?: InputMaybe<PatientConnectWhere>;
};

export type ClaimReceivedFromPatientConnection = {
	__typename?: "ClaimReceivedFromPatientConnection";
	edges: Array<ClaimReceivedFromPatientRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type ClaimReceivedFromPatientConnectionSort = {
	node?: InputMaybe<PatientSort>;
};

export type ClaimReceivedFromPatientConnectionWhere = {
	AND?: InputMaybe<Array<ClaimReceivedFromPatientConnectionWhere>>;
	OR?: InputMaybe<Array<ClaimReceivedFromPatientConnectionWhere>>;
	node?: InputMaybe<PatientWhere>;
	node_NOT?: InputMaybe<PatientWhere>;
};

export type ClaimReceivedFromPatientCreateFieldInput = {
	node: PatientCreateInput;
};

export type ClaimReceivedFromPatientDeleteFieldInput = {
	delete?: InputMaybe<PatientDeleteInput>;
	where?: InputMaybe<ClaimReceivedFromPatientConnectionWhere>;
};

export type ClaimReceivedFromPatientDisconnectFieldInput = {
	disconnect?: InputMaybe<PatientDisconnectInput>;
	where?: InputMaybe<ClaimReceivedFromPatientConnectionWhere>;
};

export type ClaimReceivedFromPatientFieldInput = {
	connect?: InputMaybe<ClaimReceivedFromPatientConnectFieldInput>;
	create?: InputMaybe<ClaimReceivedFromPatientCreateFieldInput>;
};

export type ClaimReceivedFromPatientNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<ClaimReceivedFromPatientNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<ClaimReceivedFromPatientNodeAggregationWhereInput>>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	initials_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	initials_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	initials_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	initials_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	initials_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	initials_EQUAL?: InputMaybe<Scalars["String"]>;
	initials_GT?: InputMaybe<Scalars["Int"]>;
	initials_GTE?: InputMaybe<Scalars["Int"]>;
	initials_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	initials_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	initials_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	initials_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	initials_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	initials_LT?: InputMaybe<Scalars["Int"]>;
	initials_LTE?: InputMaybe<Scalars["Int"]>;
	initials_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	initials_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	initials_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	initials_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	initials_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	insuranceId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	insuranceId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	insuranceId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	insuranceId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	insuranceId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	insuranceId_EQUAL?: InputMaybe<Scalars["String"]>;
	insuranceId_GT?: InputMaybe<Scalars["Int"]>;
	insuranceId_GTE?: InputMaybe<Scalars["Int"]>;
	insuranceId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	insuranceId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	insuranceId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	insuranceId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	insuranceId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	insuranceId_LT?: InputMaybe<Scalars["Int"]>;
	insuranceId_LTE?: InputMaybe<Scalars["Int"]>;
	insuranceId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	insuranceId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	insuranceId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	insuranceId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	insuranceId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	tenantId_EQUAL?: InputMaybe<Scalars["String"]>;
	tenantId_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	timeStamp_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	timeStamp_GT?: InputMaybe<Scalars["DateTime"]>;
	timeStamp_GTE?: InputMaybe<Scalars["DateTime"]>;
	timeStamp_LT?: InputMaybe<Scalars["DateTime"]>;
	timeStamp_LTE?: InputMaybe<Scalars["DateTime"]>;
	timeStamp_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	timeStamp_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	timeStamp_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	timeStamp_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	timeStamp_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	timeStamp_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	timeStamp_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	timeStamp_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	timeStamp_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	timeStamp_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	yearOfBirth_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	yearOfBirth_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	yearOfBirth_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	yearOfBirth_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	yearOfBirth_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	yearOfBirth_EQUAL?: InputMaybe<Scalars["Int"]>;
	yearOfBirth_GT?: InputMaybe<Scalars["Int"]>;
	yearOfBirth_GTE?: InputMaybe<Scalars["Int"]>;
	yearOfBirth_LT?: InputMaybe<Scalars["Int"]>;
	yearOfBirth_LTE?: InputMaybe<Scalars["Int"]>;
	yearOfBirth_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	yearOfBirth_MAX_GT?: InputMaybe<Scalars["Int"]>;
	yearOfBirth_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	yearOfBirth_MAX_LT?: InputMaybe<Scalars["Int"]>;
	yearOfBirth_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	yearOfBirth_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	yearOfBirth_MIN_GT?: InputMaybe<Scalars["Int"]>;
	yearOfBirth_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	yearOfBirth_MIN_LT?: InputMaybe<Scalars["Int"]>;
	yearOfBirth_MIN_LTE?: InputMaybe<Scalars["Int"]>;
};

export type ClaimReceivedFromPatientRelationship = {
	__typename?: "ClaimReceivedFromPatientRelationship";
	cursor: Scalars["String"];
	node: Patient;
};

export type ClaimReceivedFromPatientUpdateConnectionInput = {
	node?: InputMaybe<PatientUpdateInput>;
};

export type ClaimReceivedFromPatientUpdateFieldInput = {
	connect?: InputMaybe<ClaimReceivedFromPatientConnectFieldInput>;
	create?: InputMaybe<ClaimReceivedFromPatientCreateFieldInput>;
	delete?: InputMaybe<ClaimReceivedFromPatientDeleteFieldInput>;
	disconnect?: InputMaybe<ClaimReceivedFromPatientDisconnectFieldInput>;
	update?: InputMaybe<ClaimReceivedFromPatientUpdateConnectionInput>;
	where?: InputMaybe<ClaimReceivedFromPatientConnectionWhere>;
};

export type ClaimRecordAggregateInput = {
	AND?: InputMaybe<Array<ClaimRecordAggregateInput>>;
	OR?: InputMaybe<Array<ClaimRecordAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<ClaimRecordNodeAggregationWhereInput>;
};

export type ClaimRecordConnectFieldInput = {
	connect?: InputMaybe<RecordConnectInput>;
	where?: InputMaybe<RecordConnectWhere>;
};

export type ClaimRecordConnection = {
	__typename?: "ClaimRecordConnection";
	edges: Array<ClaimRecordRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type ClaimRecordConnectionSort = {
	node?: InputMaybe<RecordSort>;
};

export type ClaimRecordConnectionWhere = {
	AND?: InputMaybe<Array<ClaimRecordConnectionWhere>>;
	OR?: InputMaybe<Array<ClaimRecordConnectionWhere>>;
	node?: InputMaybe<RecordWhere>;
	node_NOT?: InputMaybe<RecordWhere>;
};

export type ClaimRecordCreateFieldInput = {
	node: RecordCreateInput;
};

export type ClaimRecordDeleteFieldInput = {
	delete?: InputMaybe<RecordDeleteInput>;
	where?: InputMaybe<ClaimRecordConnectionWhere>;
};

export type ClaimRecordDisconnectFieldInput = {
	disconnect?: InputMaybe<RecordDisconnectInput>;
	where?: InputMaybe<ClaimRecordConnectionWhere>;
};

export type ClaimRecordFieldInput = {
	connect?: InputMaybe<ClaimRecordConnectFieldInput>;
	create?: InputMaybe<ClaimRecordCreateFieldInput>;
};

export type ClaimRecordNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<ClaimRecordNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<ClaimRecordNodeAggregationWhereInput>>;
	administrationDate_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_GT?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_GTE?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_LT?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_LTE?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	claimId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	claimId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	claimId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	claimId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	claimId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	claimId_EQUAL?: InputMaybe<Scalars["String"]>;
	claimId_GT?: InputMaybe<Scalars["Int"]>;
	claimId_GTE?: InputMaybe<Scalars["Int"]>;
	claimId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	claimId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	claimId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	claimId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	claimId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	claimId_LT?: InputMaybe<Scalars["Int"]>;
	claimId_LTE?: InputMaybe<Scalars["Int"]>;
	claimId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	claimId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	claimId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	claimId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	claimId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	createdByName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	createdByName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	createdByName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	createdByName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	createdByName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	createdByName_EQUAL?: InputMaybe<Scalars["String"]>;
	createdByName_GT?: InputMaybe<Scalars["Int"]>;
	createdByName_GTE?: InputMaybe<Scalars["Int"]>;
	createdByName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	createdByName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	createdByName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	createdByName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	createdByName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	createdByName_LT?: InputMaybe<Scalars["Int"]>;
	createdByName_LTE?: InputMaybe<Scalars["Int"]>;
	createdByName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	createdByName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	createdByName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	createdByName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	createdByName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	createdBy_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	createdBy_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	createdBy_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	createdBy_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	createdBy_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	createdBy_EQUAL?: InputMaybe<Scalars["String"]>;
	createdBy_GT?: InputMaybe<Scalars["Int"]>;
	createdBy_GTE?: InputMaybe<Scalars["Int"]>;
	createdBy_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	createdBy_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	createdBy_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	createdBy_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	createdBy_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	createdBy_LT?: InputMaybe<Scalars["Int"]>;
	createdBy_LTE?: InputMaybe<Scalars["Int"]>;
	createdBy_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	createdBy_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	createdBy_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	createdBy_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	createdBy_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	createdOn_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	insuranceId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	insuranceId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	insuranceId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	insuranceId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	insuranceId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	insuranceId_EQUAL?: InputMaybe<Scalars["String"]>;
	insuranceId_GT?: InputMaybe<Scalars["Int"]>;
	insuranceId_GTE?: InputMaybe<Scalars["Int"]>;
	insuranceId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	insuranceId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	insuranceId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	insuranceId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	insuranceId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	insuranceId_LT?: InputMaybe<Scalars["Int"]>;
	insuranceId_LTE?: InputMaybe<Scalars["Int"]>;
	insuranceId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	insuranceId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	insuranceId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	insuranceId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	insuranceId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	invoiceDate_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	invoiceDate_GT?: InputMaybe<Scalars["DateTime"]>;
	invoiceDate_GTE?: InputMaybe<Scalars["DateTime"]>;
	invoiceDate_LT?: InputMaybe<Scalars["DateTime"]>;
	invoiceDate_LTE?: InputMaybe<Scalars["DateTime"]>;
	invoiceDate_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	invoiceDate_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	invoiceDate_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	invoiceDate_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	invoiceDate_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	invoiceDate_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	invoiceDate_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	invoiceDate_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	invoiceDate_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	invoiceDate_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	invoiceNumber_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	invoiceNumber_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	invoiceNumber_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	invoiceNumber_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	invoiceNumber_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	invoiceNumber_EQUAL?: InputMaybe<Scalars["String"]>;
	invoiceNumber_GT?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_GTE?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_LT?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_LTE?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	preparationBrandNames_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	preparationBrandNames_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	preparationBrandNames_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	preparationBrandNames_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	preparationBrandNames_EQUAL?: InputMaybe<Scalars["String"]>;
	preparationBrandNames_GT?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_GTE?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_LT?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_LTE?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	preparationGenericNames_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	preparationGenericNames_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	preparationGenericNames_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	preparationGenericNames_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	preparationGenericNames_EQUAL?: InputMaybe<Scalars["String"]>;
	preparationGenericNames_GT?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_GTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_LT?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_LTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	preparationId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	preparationId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	preparationId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	preparationId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	preparationId_EQUAL?: InputMaybe<Scalars["String"]>;
	preparationId_GT?: InputMaybe<Scalars["Int"]>;
	preparationId_GTE?: InputMaybe<Scalars["Int"]>;
	preparationId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationId_LT?: InputMaybe<Scalars["Int"]>;
	preparationId_LTE?: InputMaybe<Scalars["Int"]>;
	preparationId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	quantity_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	quantity_EQUAL?: InputMaybe<Scalars["Int"]>;
	quantity_GT?: InputMaybe<Scalars["Int"]>;
	quantity_GTE?: InputMaybe<Scalars["Int"]>;
	quantity_LT?: InputMaybe<Scalars["Int"]>;
	quantity_LTE?: InputMaybe<Scalars["Int"]>;
	quantity_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	quantity_MAX_GT?: InputMaybe<Scalars["Int"]>;
	quantity_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	quantity_MAX_LT?: InputMaybe<Scalars["Int"]>;
	quantity_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	quantity_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	quantity_MIN_GT?: InputMaybe<Scalars["Int"]>;
	quantity_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	quantity_MIN_LT?: InputMaybe<Scalars["Int"]>;
	quantity_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	tenantId_EQUAL?: InputMaybe<Scalars["String"]>;
	tenantId_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	treatmentName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	treatmentName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	treatmentName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	treatmentName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	treatmentName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	treatmentName_EQUAL?: InputMaybe<Scalars["String"]>;
	treatmentName_GT?: InputMaybe<Scalars["Int"]>;
	treatmentName_GTE?: InputMaybe<Scalars["Int"]>;
	treatmentName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	treatmentName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	treatmentName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	treatmentName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	treatmentName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	treatmentName_LT?: InputMaybe<Scalars["Int"]>;
	treatmentName_LTE?: InputMaybe<Scalars["Int"]>;
	treatmentName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	treatmentName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	treatmentName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	treatmentName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	treatmentName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	unlimited_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	unlimited_EQUAL?: InputMaybe<Scalars["Int"]>;
	unlimited_GT?: InputMaybe<Scalars["Int"]>;
	unlimited_GTE?: InputMaybe<Scalars["Int"]>;
	unlimited_LT?: InputMaybe<Scalars["Int"]>;
	unlimited_LTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_GT?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_LT?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_GT?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_LT?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	uuid_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	uuid_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	uuid_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	uuid_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	uuid_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	uuid_EQUAL?: InputMaybe<Scalars["String"]>;
	uuid_GT?: InputMaybe<Scalars["Int"]>;
	uuid_GTE?: InputMaybe<Scalars["Int"]>;
	uuid_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	uuid_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	uuid_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	uuid_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	uuid_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	uuid_LT?: InputMaybe<Scalars["Int"]>;
	uuid_LTE?: InputMaybe<Scalars["Int"]>;
	uuid_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	uuid_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	uuid_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	uuid_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	uuid_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type ClaimRecordRelationship = {
	__typename?: "ClaimRecordRelationship";
	cursor: Scalars["String"];
	node: Record;
};

export type ClaimRecordUpdateConnectionInput = {
	node?: InputMaybe<RecordUpdateInput>;
};

export type ClaimRecordUpdateFieldInput = {
	connect?: InputMaybe<ClaimRecordConnectFieldInput>;
	create?: InputMaybe<ClaimRecordCreateFieldInput>;
	delete?: InputMaybe<ClaimRecordDeleteFieldInput>;
	disconnect?: InputMaybe<ClaimRecordDisconnectFieldInput>;
	update?: InputMaybe<ClaimRecordUpdateConnectionInput>;
	where?: InputMaybe<ClaimRecordConnectionWhere>;
};

/** Fields to sort Claims by. The order in which sorts are applied is not guaranteed when specifying many fields in one ClaimSort object. */
export type ClaimSort = {
	administrationDate?: InputMaybe<SortDirection>;
	assignee?: InputMaybe<SortDirection>;
	claimId?: InputMaybe<SortDirection>;
	createdOn?: InputMaybe<SortDirection>;
	id?: InputMaybe<SortDirection>;
	invoiceAmount?: InputMaybe<SortDirection>;
	invoiceDate?: InputMaybe<SortDirection>;
	invoiceNumber?: InputMaybe<SortDirection>;
	isArchived?: InputMaybe<SortDirection>;
	isDeleted?: InputMaybe<SortDirection>;
	preparationId?: InputMaybe<SortDirection>;
	preparationIdType?: InputMaybe<SortDirection>;
	providerId?: InputMaybe<SortDirection>;
	providerName?: InputMaybe<SortDirection>;
	quantity?: InputMaybe<SortDirection>;
	tenantId?: InputMaybe<SortDirection>;
};

export type ClaimUpdateInput = {
	administrationDate?: InputMaybe<Scalars["String"]>;
	assignee?: InputMaybe<Scalars["String"]>;
	cases?: InputMaybe<Array<ClaimCasesUpdateFieldInput>>;
	claimId?: InputMaybe<Scalars["String"]>;
	createdOn?: InputMaybe<Scalars["DateTime"]>;
	financialDataPoints?: InputMaybe<Array<ClaimFinancialDataPointsUpdateFieldInput>>;
	id?: InputMaybe<Scalars["ID"]>;
	includes?: InputMaybe<Array<ClaimIncludesUpdateFieldInput>>;
	invoiceAmount?: InputMaybe<Scalars["String"]>;
	invoiceDate?: InputMaybe<Scalars["String"]>;
	invoiceNumber?: InputMaybe<Scalars["String"]>;
	isArchived?: InputMaybe<Scalars["Boolean"]>;
	isDeleted?: InputMaybe<Scalars["Boolean"]>;
	preparationId?: InputMaybe<Scalars["String"]>;
	preparationIdType?: InputMaybe<Scalars["String"]>;
	providerId?: InputMaybe<Scalars["String"]>;
	providerName?: InputMaybe<Scalars["String"]>;
	quantity?: InputMaybe<Scalars["String"]>;
	receivedFromPatient?: InputMaybe<ClaimReceivedFromPatientUpdateFieldInput>;
	record?: InputMaybe<ClaimRecordUpdateFieldInput>;
	tenantId?: InputMaybe<Scalars["String"]>;
};

export type ClaimWhere = {
	AND?: InputMaybe<Array<ClaimWhere>>;
	OR?: InputMaybe<Array<ClaimWhere>>;
	administrationDate?: InputMaybe<Scalars["String"]>;
	administrationDate_CONTAINS?: InputMaybe<Scalars["String"]>;
	administrationDate_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	administrationDate_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	administrationDate_MATCHES?: InputMaybe<Scalars["String"]>;
	administrationDate_NOT?: InputMaybe<Scalars["String"]>;
	administrationDate_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	administrationDate_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	administrationDate_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	administrationDate_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	administrationDate_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	assignee?: InputMaybe<Scalars["String"]>;
	assignee_CONTAINS?: InputMaybe<Scalars["String"]>;
	assignee_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	assignee_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	assignee_MATCHES?: InputMaybe<Scalars["String"]>;
	assignee_NOT?: InputMaybe<Scalars["String"]>;
	assignee_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	assignee_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	assignee_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	assignee_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	assignee_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	cases?: InputMaybe<CaseWhere>;
	casesAggregate?: InputMaybe<ClaimCasesAggregateInput>;
	casesConnection?: InputMaybe<ClaimCasesConnectionWhere>;
	casesConnection_NOT?: InputMaybe<ClaimCasesConnectionWhere>;
	cases_NOT?: InputMaybe<CaseWhere>;
	claimId?: InputMaybe<Scalars["String"]>;
	claimId_CONTAINS?: InputMaybe<Scalars["String"]>;
	claimId_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	claimId_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	claimId_MATCHES?: InputMaybe<Scalars["String"]>;
	claimId_NOT?: InputMaybe<Scalars["String"]>;
	claimId_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	claimId_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	claimId_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	claimId_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	claimId_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	createdOn?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_IN?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]>>>;
	createdOn_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_NOT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]>>>;
	financialDataPoints?: InputMaybe<FinancialDataPointWhere>;
	financialDataPointsAggregate?: InputMaybe<ClaimFinancialDataPointsAggregateInput>;
	financialDataPointsConnection?: InputMaybe<ClaimFinancialDataPointsConnectionWhere>;
	financialDataPointsConnection_NOT?: InputMaybe<ClaimFinancialDataPointsConnectionWhere>;
	financialDataPoints_NOT?: InputMaybe<FinancialDataPointWhere>;
	id?: InputMaybe<Scalars["ID"]>;
	id_CONTAINS?: InputMaybe<Scalars["ID"]>;
	id_ENDS_WITH?: InputMaybe<Scalars["ID"]>;
	id_IN?: InputMaybe<Array<InputMaybe<Scalars["ID"]>>>;
	id_MATCHES?: InputMaybe<Scalars["String"]>;
	id_NOT?: InputMaybe<Scalars["ID"]>;
	id_NOT_CONTAINS?: InputMaybe<Scalars["ID"]>;
	id_NOT_ENDS_WITH?: InputMaybe<Scalars["ID"]>;
	id_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["ID"]>>>;
	id_NOT_STARTS_WITH?: InputMaybe<Scalars["ID"]>;
	id_STARTS_WITH?: InputMaybe<Scalars["ID"]>;
	includes?: InputMaybe<TreatmentWhere>;
	includesAggregate?: InputMaybe<ClaimIncludesAggregateInput>;
	includesConnection?: InputMaybe<ClaimIncludesConnectionWhere>;
	includesConnection_NOT?: InputMaybe<ClaimIncludesConnectionWhere>;
	includes_NOT?: InputMaybe<TreatmentWhere>;
	invoiceAmount?: InputMaybe<Scalars["String"]>;
	invoiceAmount_CONTAINS?: InputMaybe<Scalars["String"]>;
	invoiceAmount_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	invoiceAmount_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	invoiceAmount_MATCHES?: InputMaybe<Scalars["String"]>;
	invoiceAmount_NOT?: InputMaybe<Scalars["String"]>;
	invoiceAmount_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	invoiceAmount_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	invoiceAmount_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	invoiceAmount_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	invoiceAmount_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	invoiceDate?: InputMaybe<Scalars["String"]>;
	invoiceDate_CONTAINS?: InputMaybe<Scalars["String"]>;
	invoiceDate_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	invoiceDate_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	invoiceDate_MATCHES?: InputMaybe<Scalars["String"]>;
	invoiceDate_NOT?: InputMaybe<Scalars["String"]>;
	invoiceDate_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	invoiceDate_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	invoiceDate_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	invoiceDate_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	invoiceDate_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	invoiceNumber?: InputMaybe<Scalars["String"]>;
	invoiceNumber_CONTAINS?: InputMaybe<Scalars["String"]>;
	invoiceNumber_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	invoiceNumber_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	invoiceNumber_MATCHES?: InputMaybe<Scalars["String"]>;
	invoiceNumber_NOT?: InputMaybe<Scalars["String"]>;
	invoiceNumber_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	invoiceNumber_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	invoiceNumber_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	invoiceNumber_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	invoiceNumber_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	isArchived?: InputMaybe<Scalars["Boolean"]>;
	isArchived_NOT?: InputMaybe<Scalars["Boolean"]>;
	isDeleted?: InputMaybe<Scalars["Boolean"]>;
	isDeleted_NOT?: InputMaybe<Scalars["Boolean"]>;
	preparationId?: InputMaybe<Scalars["String"]>;
	preparationIdType?: InputMaybe<Scalars["String"]>;
	preparationIdType_CONTAINS?: InputMaybe<Scalars["String"]>;
	preparationIdType_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	preparationIdType_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	preparationIdType_MATCHES?: InputMaybe<Scalars["String"]>;
	preparationIdType_NOT?: InputMaybe<Scalars["String"]>;
	preparationIdType_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	preparationIdType_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	preparationIdType_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	preparationIdType_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	preparationIdType_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	preparationId_CONTAINS?: InputMaybe<Scalars["String"]>;
	preparationId_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	preparationId_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	preparationId_MATCHES?: InputMaybe<Scalars["String"]>;
	preparationId_NOT?: InputMaybe<Scalars["String"]>;
	preparationId_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	preparationId_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	preparationId_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	preparationId_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	preparationId_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	providerId?: InputMaybe<Scalars["String"]>;
	providerId_CONTAINS?: InputMaybe<Scalars["String"]>;
	providerId_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	providerId_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	providerId_MATCHES?: InputMaybe<Scalars["String"]>;
	providerId_NOT?: InputMaybe<Scalars["String"]>;
	providerId_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	providerId_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	providerId_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	providerId_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	providerId_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	providerName?: InputMaybe<Scalars["String"]>;
	providerName_CONTAINS?: InputMaybe<Scalars["String"]>;
	providerName_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	providerName_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	providerName_MATCHES?: InputMaybe<Scalars["String"]>;
	providerName_NOT?: InputMaybe<Scalars["String"]>;
	providerName_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	providerName_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	providerName_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	providerName_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	providerName_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	quantity?: InputMaybe<Scalars["String"]>;
	quantity_CONTAINS?: InputMaybe<Scalars["String"]>;
	quantity_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	quantity_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	quantity_MATCHES?: InputMaybe<Scalars["String"]>;
	quantity_NOT?: InputMaybe<Scalars["String"]>;
	quantity_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	quantity_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	quantity_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	quantity_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	quantity_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	receivedFromPatient?: InputMaybe<PatientWhere>;
	receivedFromPatientAggregate?: InputMaybe<ClaimReceivedFromPatientAggregateInput>;
	receivedFromPatientConnection?: InputMaybe<ClaimReceivedFromPatientConnectionWhere>;
	receivedFromPatientConnection_NOT?: InputMaybe<ClaimReceivedFromPatientConnectionWhere>;
	receivedFromPatient_NOT?: InputMaybe<PatientWhere>;
	record?: InputMaybe<RecordWhere>;
	recordAggregate?: InputMaybe<ClaimRecordAggregateInput>;
	recordConnection?: InputMaybe<ClaimRecordConnectionWhere>;
	recordConnection_NOT?: InputMaybe<ClaimRecordConnectionWhere>;
	record_NOT?: InputMaybe<RecordWhere>;
	tenantId?: InputMaybe<Scalars["String"]>;
	tenantId_CONTAINS?: InputMaybe<Scalars["String"]>;
	tenantId_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	tenantId_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	tenantId_MATCHES?: InputMaybe<Scalars["String"]>;
	tenantId_NOT?: InputMaybe<Scalars["String"]>;
	tenantId_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	tenantId_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	tenantId_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	tenantId_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	tenantId_STARTS_WITH?: InputMaybe<Scalars["String"]>;
};

export enum ConditionConsideredRating {
	A = "A",
	B = "B",
	C = "C",
	D = "D",
}

export enum ConditionConsideredSecIntervention {
	PerCohort = "PER_COHORT",
}

export enum ConditionLogicalOperator {
	And = "AND",
	Or = "OR",
}

export enum ConditionType {
	AdverseEvent = "ADVERSE_EVENT",
	PrescriptionNumber = "PRESCRIPTION_NUMBER",
	Rating = "RATING",
	Response = "RESPONSE",
	SecondaryInterventionRate = "SECONDARY_INTERVENTION_RATE",
	Surgery = "SURGERY",
	TreatmentDuration = "TREATMENT_DURATION",
}

export type ContinuousBenefit = ITreatmentState & {
	__typename?: "ContinuousBenefit";
	adverseEvents: Array<AdverseEvent>;
	adverseEventsConnection: ContinuousBenefitAdverseEventsConnection;
	assessmentDate?: Maybe<Scalars["Date"]>;
	coverageRequest: CoverageRequest;
	coverageRequestConnection: ContinuousBenefitCoverageRequestConnection;
	createdOn: Scalars["DateTime"];
	financialDataPoints: Array<FinancialDataPoint>;
	financialDataPointsConnection: ContinuousBenefitFinancialDataPointsConnection;
	form?: Maybe<Form>;
	formConnection: ContinuousBenefitFormConnection;
	id: Scalars["ID"];
	initialResponse: InitialResponse;
	initialResponseConnection: ContinuousBenefitInitialResponseConnection;
	isArchived: Scalars["Boolean"];
	isDeleted: Scalars["Boolean"];
	isPatientEnrolledInTreatment: Scalars["Boolean"];
	lastPrescriptionDate?: Maybe<Scalars["String"]>;
	preparationPrescribedToAssessmentDate?: Maybe<Scalars["Boolean"]>;
	prescribedTreatments: Array<Treatment>;
	prescribedTreatmentsConnection: ContinuousBenefitPrescribedTreatmentsConnection;
	previousContinuousBenefitFormId?: Maybe<Scalars["ID"]>;
	reasonForDiscontinuation?: Maybe<ReasonsForDiscontinuation>;
	records?: Maybe<Array<Maybe<Record>>>;
	recordsConnection: ContinuousBenefitRecordsConnection;
	status?: Maybe<FormStatus>;
	submissionDate?: Maybe<Scalars["DateTime"]>;
	tenantId: Scalars["String"];
	treatingPhysician?: Maybe<TreatingPhysician>;
	treatingPhysicianConnection: ContinuousBenefitTreatingPhysicianConnection;
};

export type ContinuousBenefitAdverseEventsArgs = {
	options?: InputMaybe<AdverseEventOptions>;
	where?: InputMaybe<AdverseEventWhere>;
};

export type ContinuousBenefitAdverseEventsConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<ContinuousBenefitAdverseEventsConnectionSort>>;
	where?: InputMaybe<ContinuousBenefitAdverseEventsConnectionWhere>;
};

export type ContinuousBenefitCoverageRequestArgs = {
	options?: InputMaybe<CoverageRequestOptions>;
	where?: InputMaybe<CoverageRequestWhere>;
};

export type ContinuousBenefitCoverageRequestConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<ContinuousBenefitCoverageRequestConnectionSort>>;
	where?: InputMaybe<ContinuousBenefitCoverageRequestConnectionWhere>;
};

export type ContinuousBenefitFinancialDataPointsArgs = {
	options?: InputMaybe<FinancialDataPointOptions>;
	where?: InputMaybe<FinancialDataPointWhere>;
};

export type ContinuousBenefitFinancialDataPointsConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<ContinuousBenefitFinancialDataPointsConnectionSort>>;
	where?: InputMaybe<ContinuousBenefitFinancialDataPointsConnectionWhere>;
};

export type ContinuousBenefitFormArgs = {
	options?: InputMaybe<FormOptions>;
	where?: InputMaybe<FormWhere>;
};

export type ContinuousBenefitFormConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<ContinuousBenefitFormConnectionSort>>;
	where?: InputMaybe<ContinuousBenefitFormConnectionWhere>;
};

export type ContinuousBenefitInitialResponseArgs = {
	options?: InputMaybe<InitialResponseOptions>;
	where?: InputMaybe<InitialResponseWhere>;
};

export type ContinuousBenefitInitialResponseConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<ContinuousBenefitInitialResponseConnectionSort>>;
	where?: InputMaybe<ContinuousBenefitInitialResponseConnectionWhere>;
};

export type ContinuousBenefitPrescribedTreatmentsArgs = {
	options?: InputMaybe<TreatmentOptions>;
	where?: InputMaybe<TreatmentWhere>;
};

export type ContinuousBenefitPrescribedTreatmentsConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<ContinuousBenefitPrescribedTreatmentsConnectionSort>>;
	where?: InputMaybe<ContinuousBenefitPrescribedTreatmentsConnectionWhere>;
};

export type ContinuousBenefitRecordsArgs = {
	options?: InputMaybe<RecordOptions>;
	where?: InputMaybe<RecordWhere>;
};

export type ContinuousBenefitRecordsConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<ContinuousBenefitRecordsConnectionSort>>;
	where?: InputMaybe<ContinuousBenefitRecordsConnectionWhere>;
};

export type ContinuousBenefitTreatingPhysicianArgs = {
	options?: InputMaybe<TreatingPhysicianOptions>;
	where?: InputMaybe<TreatingPhysicianWhere>;
};

export type ContinuousBenefitTreatingPhysicianConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<ContinuousBenefitTreatingPhysicianConnectionSort>>;
	where?: InputMaybe<ContinuousBenefitTreatingPhysicianConnectionWhere>;
};

export type ContinuousBenefitAdverseEventsAggregateInput = {
	AND?: InputMaybe<Array<ContinuousBenefitAdverseEventsAggregateInput>>;
	OR?: InputMaybe<Array<ContinuousBenefitAdverseEventsAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<ContinuousBenefitAdverseEventsNodeAggregationWhereInput>;
};

export type ContinuousBenefitAdverseEventsConnectFieldInput = {
	connect?: InputMaybe<Array<AdverseEventConnectInput>>;
	where?: InputMaybe<AdverseEventConnectWhere>;
};

export type ContinuousBenefitAdverseEventsConnection = {
	__typename?: "ContinuousBenefitAdverseEventsConnection";
	edges: Array<ContinuousBenefitAdverseEventsRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type ContinuousBenefitAdverseEventsConnectionSort = {
	node?: InputMaybe<AdverseEventSort>;
};

export type ContinuousBenefitAdverseEventsConnectionWhere = {
	AND?: InputMaybe<Array<ContinuousBenefitAdverseEventsConnectionWhere>>;
	OR?: InputMaybe<Array<ContinuousBenefitAdverseEventsConnectionWhere>>;
	node?: InputMaybe<AdverseEventWhere>;
	node_NOT?: InputMaybe<AdverseEventWhere>;
};

export type ContinuousBenefitAdverseEventsCreateFieldInput = {
	node: AdverseEventCreateInput;
};

export type ContinuousBenefitAdverseEventsDeleteFieldInput = {
	delete?: InputMaybe<AdverseEventDeleteInput>;
	where?: InputMaybe<ContinuousBenefitAdverseEventsConnectionWhere>;
};

export type ContinuousBenefitAdverseEventsDisconnectFieldInput = {
	disconnect?: InputMaybe<AdverseEventDisconnectInput>;
	where?: InputMaybe<ContinuousBenefitAdverseEventsConnectionWhere>;
};

export type ContinuousBenefitAdverseEventsFieldInput = {
	connect?: InputMaybe<Array<ContinuousBenefitAdverseEventsConnectFieldInput>>;
	create?: InputMaybe<Array<ContinuousBenefitAdverseEventsCreateFieldInput>>;
};

export type ContinuousBenefitAdverseEventsNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<ContinuousBenefitAdverseEventsNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<ContinuousBenefitAdverseEventsNodeAggregationWhereInput>>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	tenantId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	tenantId_EQUAL?: InputMaybe<Scalars["String"]>;
	tenantId_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type ContinuousBenefitAdverseEventsRelationship = {
	__typename?: "ContinuousBenefitAdverseEventsRelationship";
	cursor: Scalars["String"];
	node: AdverseEvent;
};

export type ContinuousBenefitAdverseEventsUpdateConnectionInput = {
	node?: InputMaybe<AdverseEventUpdateInput>;
};

export type ContinuousBenefitAdverseEventsUpdateFieldInput = {
	connect?: InputMaybe<Array<ContinuousBenefitAdverseEventsConnectFieldInput>>;
	create?: InputMaybe<Array<ContinuousBenefitAdverseEventsCreateFieldInput>>;
	delete?: InputMaybe<Array<ContinuousBenefitAdverseEventsDeleteFieldInput>>;
	disconnect?: InputMaybe<Array<ContinuousBenefitAdverseEventsDisconnectFieldInput>>;
	update?: InputMaybe<ContinuousBenefitAdverseEventsUpdateConnectionInput>;
	where?: InputMaybe<ContinuousBenefitAdverseEventsConnectionWhere>;
};

export type ContinuousBenefitAggregateSelection = {
	__typename?: "ContinuousBenefitAggregateSelection";
	count: Scalars["Int"];
	createdOn: DateTimeAggregateSelection;
	id: IdAggregateSelection;
	submissionDate: DateTimeAggregateSelection;
	tenantId: StringAggregateSelection;
};

export type ContinuousBenefitConnectInput = {
	adverseEvents?: InputMaybe<Array<ContinuousBenefitAdverseEventsConnectFieldInput>>;
	coverageRequest?: InputMaybe<ContinuousBenefitCoverageRequestConnectFieldInput>;
	financialDataPoints?: InputMaybe<Array<ContinuousBenefitFinancialDataPointsConnectFieldInput>>;
	form?: InputMaybe<ContinuousBenefitFormConnectFieldInput>;
	initialResponse?: InputMaybe<ContinuousBenefitInitialResponseConnectFieldInput>;
	prescribedTreatments?: InputMaybe<Array<ContinuousBenefitPrescribedTreatmentsConnectFieldInput>>;
	records?: InputMaybe<Array<ContinuousBenefitRecordsConnectFieldInput>>;
	treatingPhysician?: InputMaybe<ContinuousBenefitTreatingPhysicianConnectFieldInput>;
};

export type ContinuousBenefitConnectWhere = {
	node: ContinuousBenefitWhere;
};

export type ContinuousBenefitCoverageRequestAggregateInput = {
	AND?: InputMaybe<Array<ContinuousBenefitCoverageRequestAggregateInput>>;
	OR?: InputMaybe<Array<ContinuousBenefitCoverageRequestAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<ContinuousBenefitCoverageRequestNodeAggregationWhereInput>;
};

export type ContinuousBenefitCoverageRequestConnectFieldInput = {
	connect?: InputMaybe<CoverageRequestConnectInput>;
	where?: InputMaybe<CoverageRequestConnectWhere>;
};

export type ContinuousBenefitCoverageRequestConnection = {
	__typename?: "ContinuousBenefitCoverageRequestConnection";
	edges: Array<ContinuousBenefitCoverageRequestRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type ContinuousBenefitCoverageRequestConnectionSort = {
	node?: InputMaybe<CoverageRequestSort>;
};

export type ContinuousBenefitCoverageRequestConnectionWhere = {
	AND?: InputMaybe<Array<ContinuousBenefitCoverageRequestConnectionWhere>>;
	OR?: InputMaybe<Array<ContinuousBenefitCoverageRequestConnectionWhere>>;
	node?: InputMaybe<CoverageRequestWhere>;
	node_NOT?: InputMaybe<CoverageRequestWhere>;
};

export type ContinuousBenefitCoverageRequestCreateFieldInput = {
	node: CoverageRequestCreateInput;
};

export type ContinuousBenefitCoverageRequestDeleteFieldInput = {
	delete?: InputMaybe<CoverageRequestDeleteInput>;
	where?: InputMaybe<ContinuousBenefitCoverageRequestConnectionWhere>;
};

export type ContinuousBenefitCoverageRequestDisconnectFieldInput = {
	disconnect?: InputMaybe<CoverageRequestDisconnectInput>;
	where?: InputMaybe<ContinuousBenefitCoverageRequestConnectionWhere>;
};

export type ContinuousBenefitCoverageRequestFieldInput = {
	connect?: InputMaybe<ContinuousBenefitCoverageRequestConnectFieldInput>;
	create?: InputMaybe<ContinuousBenefitCoverageRequestCreateFieldInput>;
};

export type ContinuousBenefitCoverageRequestNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<ContinuousBenefitCoverageRequestNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<ContinuousBenefitCoverageRequestNodeAggregationWhereInput>>;
	createdOn_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	duration_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	duration_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	duration_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	duration_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	duration_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	duration_EQUAL?: InputMaybe<Scalars["Int"]>;
	duration_GT?: InputMaybe<Scalars["Int"]>;
	duration_GTE?: InputMaybe<Scalars["Int"]>;
	duration_LT?: InputMaybe<Scalars["Int"]>;
	duration_LTE?: InputMaybe<Scalars["Int"]>;
	duration_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	duration_MAX_GT?: InputMaybe<Scalars["Int"]>;
	duration_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	duration_MAX_LT?: InputMaybe<Scalars["Int"]>;
	duration_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	duration_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	duration_MIN_GT?: InputMaybe<Scalars["Int"]>;
	duration_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	duration_MIN_LT?: InputMaybe<Scalars["Int"]>;
	duration_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	lastUpdatedOn_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_GT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_LT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_GT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_GTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_LT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_LTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	tenantId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	tenantId_EQUAL?: InputMaybe<Scalars["String"]>;
	tenantId_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type ContinuousBenefitCoverageRequestRelationship = {
	__typename?: "ContinuousBenefitCoverageRequestRelationship";
	cursor: Scalars["String"];
	node: CoverageRequest;
};

export type ContinuousBenefitCoverageRequestUpdateConnectionInput = {
	node?: InputMaybe<CoverageRequestUpdateInput>;
};

export type ContinuousBenefitCoverageRequestUpdateFieldInput = {
	connect?: InputMaybe<ContinuousBenefitCoverageRequestConnectFieldInput>;
	create?: InputMaybe<ContinuousBenefitCoverageRequestCreateFieldInput>;
	delete?: InputMaybe<ContinuousBenefitCoverageRequestDeleteFieldInput>;
	disconnect?: InputMaybe<ContinuousBenefitCoverageRequestDisconnectFieldInput>;
	update?: InputMaybe<ContinuousBenefitCoverageRequestUpdateConnectionInput>;
	where?: InputMaybe<ContinuousBenefitCoverageRequestConnectionWhere>;
};

export type ContinuousBenefitCreateInput = {
	adverseEvents?: InputMaybe<ContinuousBenefitAdverseEventsFieldInput>;
	assessmentDate?: InputMaybe<Scalars["Date"]>;
	coverageRequest?: InputMaybe<ContinuousBenefitCoverageRequestFieldInput>;
	createdOn: Scalars["DateTime"];
	financialDataPoints?: InputMaybe<ContinuousBenefitFinancialDataPointsFieldInput>;
	form?: InputMaybe<ContinuousBenefitFormFieldInput>;
	id: Scalars["ID"];
	initialResponse?: InputMaybe<ContinuousBenefitInitialResponseFieldInput>;
	isArchived: Scalars["Boolean"];
	isDeleted: Scalars["Boolean"];
	isPatientEnrolledInTreatment: Scalars["Boolean"];
	prescribedTreatments?: InputMaybe<ContinuousBenefitPrescribedTreatmentsFieldInput>;
	reasonForDiscontinuation?: InputMaybe<ReasonsForDiscontinuation>;
	records?: InputMaybe<ContinuousBenefitRecordsFieldInput>;
	status?: InputMaybe<FormStatus>;
	submissionDate?: InputMaybe<Scalars["DateTime"]>;
	tenantId: Scalars["String"];
	treatingPhysician?: InputMaybe<ContinuousBenefitTreatingPhysicianFieldInput>;
};

export type ContinuousBenefitDeleteInput = {
	adverseEvents?: InputMaybe<Array<ContinuousBenefitAdverseEventsDeleteFieldInput>>;
	coverageRequest?: InputMaybe<ContinuousBenefitCoverageRequestDeleteFieldInput>;
	financialDataPoints?: InputMaybe<Array<ContinuousBenefitFinancialDataPointsDeleteFieldInput>>;
	form?: InputMaybe<ContinuousBenefitFormDeleteFieldInput>;
	initialResponse?: InputMaybe<ContinuousBenefitInitialResponseDeleteFieldInput>;
	prescribedTreatments?: InputMaybe<Array<ContinuousBenefitPrescribedTreatmentsDeleteFieldInput>>;
	records?: InputMaybe<Array<ContinuousBenefitRecordsDeleteFieldInput>>;
	treatingPhysician?: InputMaybe<ContinuousBenefitTreatingPhysicianDeleteFieldInput>;
};

export type ContinuousBenefitDisconnectInput = {
	adverseEvents?: InputMaybe<Array<ContinuousBenefitAdverseEventsDisconnectFieldInput>>;
	coverageRequest?: InputMaybe<ContinuousBenefitCoverageRequestDisconnectFieldInput>;
	financialDataPoints?: InputMaybe<Array<ContinuousBenefitFinancialDataPointsDisconnectFieldInput>>;
	form?: InputMaybe<ContinuousBenefitFormDisconnectFieldInput>;
	initialResponse?: InputMaybe<ContinuousBenefitInitialResponseDisconnectFieldInput>;
	prescribedTreatments?: InputMaybe<Array<ContinuousBenefitPrescribedTreatmentsDisconnectFieldInput>>;
	records?: InputMaybe<Array<ContinuousBenefitRecordsDisconnectFieldInput>>;
	treatingPhysician?: InputMaybe<ContinuousBenefitTreatingPhysicianDisconnectFieldInput>;
};

export type ContinuousBenefitFinancialDataPointsAggregateInput = {
	AND?: InputMaybe<Array<ContinuousBenefitFinancialDataPointsAggregateInput>>;
	OR?: InputMaybe<Array<ContinuousBenefitFinancialDataPointsAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<ContinuousBenefitFinancialDataPointsNodeAggregationWhereInput>;
};

export type ContinuousBenefitFinancialDataPointsConnectFieldInput = {
	connect?: InputMaybe<Array<FinancialDataPointConnectInput>>;
	where?: InputMaybe<FinancialDataPointConnectWhere>;
};

export type ContinuousBenefitFinancialDataPointsConnection = {
	__typename?: "ContinuousBenefitFinancialDataPointsConnection";
	edges: Array<ContinuousBenefitFinancialDataPointsRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type ContinuousBenefitFinancialDataPointsConnectionSort = {
	node?: InputMaybe<FinancialDataPointSort>;
};

export type ContinuousBenefitFinancialDataPointsConnectionWhere = {
	AND?: InputMaybe<Array<ContinuousBenefitFinancialDataPointsConnectionWhere>>;
	OR?: InputMaybe<Array<ContinuousBenefitFinancialDataPointsConnectionWhere>>;
	node?: InputMaybe<FinancialDataPointWhere>;
	node_NOT?: InputMaybe<FinancialDataPointWhere>;
};

export type ContinuousBenefitFinancialDataPointsCreateFieldInput = {
	node: FinancialDataPointCreateInput;
};

export type ContinuousBenefitFinancialDataPointsDeleteFieldInput = {
	delete?: InputMaybe<FinancialDataPointDeleteInput>;
	where?: InputMaybe<ContinuousBenefitFinancialDataPointsConnectionWhere>;
};

export type ContinuousBenefitFinancialDataPointsDisconnectFieldInput = {
	disconnect?: InputMaybe<FinancialDataPointDisconnectInput>;
	where?: InputMaybe<ContinuousBenefitFinancialDataPointsConnectionWhere>;
};

export type ContinuousBenefitFinancialDataPointsFieldInput = {
	connect?: InputMaybe<Array<ContinuousBenefitFinancialDataPointsConnectFieldInput>>;
	create?: InputMaybe<Array<ContinuousBenefitFinancialDataPointsCreateFieldInput>>;
};

export type ContinuousBenefitFinancialDataPointsNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<ContinuousBenefitFinancialDataPointsNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<ContinuousBenefitFinancialDataPointsNodeAggregationWhereInput>>;
	basePrice_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	basePrice_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	basePrice_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	basePrice_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	basePrice_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	basePrice_EQUAL?: InputMaybe<Scalars["Float"]>;
	basePrice_GT?: InputMaybe<Scalars["Float"]>;
	basePrice_GTE?: InputMaybe<Scalars["Float"]>;
	basePrice_LT?: InputMaybe<Scalars["Float"]>;
	basePrice_LTE?: InputMaybe<Scalars["Float"]>;
	basePrice_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	basePrice_MAX_GT?: InputMaybe<Scalars["Float"]>;
	basePrice_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	basePrice_MAX_LT?: InputMaybe<Scalars["Float"]>;
	basePrice_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	basePrice_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	basePrice_MIN_GT?: InputMaybe<Scalars["Float"]>;
	basePrice_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	basePrice_MIN_LT?: InputMaybe<Scalars["Float"]>;
	basePrice_MIN_LTE?: InputMaybe<Scalars["Float"]>;
	currencyCode_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	currencyCode_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	currencyCode_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	currencyCode_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	currencyCode_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	currencyCode_EQUAL?: InputMaybe<Scalars["String"]>;
	currencyCode_GT?: InputMaybe<Scalars["Int"]>;
	currencyCode_GTE?: InputMaybe<Scalars["Int"]>;
	currencyCode_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	currencyCode_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	currencyCode_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	currencyCode_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	currencyCode_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	currencyCode_LT?: InputMaybe<Scalars["Int"]>;
	currencyCode_LTE?: InputMaybe<Scalars["Int"]>;
	currencyCode_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	currencyCode_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	currencyCode_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	currencyCode_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	currencyCode_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	evaluationSnapshot_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	evaluationSnapshot_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	evaluationSnapshot_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	evaluationSnapshot_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	evaluationSnapshot_EQUAL?: InputMaybe<Scalars["String"]>;
	evaluationSnapshot_GT?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_GTE?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_LT?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_LTE?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	generatedUuid_EQUAL?: InputMaybe<Scalars["ID"]>;
	payablePercentage_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	payablePercentage_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	payablePercentage_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	payablePercentage_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	payablePercentage_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	payablePercentage_EQUAL?: InputMaybe<Scalars["Float"]>;
	payablePercentage_GT?: InputMaybe<Scalars["Float"]>;
	payablePercentage_GTE?: InputMaybe<Scalars["Float"]>;
	payablePercentage_LT?: InputMaybe<Scalars["Float"]>;
	payablePercentage_LTE?: InputMaybe<Scalars["Float"]>;
	payablePercentage_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	payablePercentage_MAX_GT?: InputMaybe<Scalars["Float"]>;
	payablePercentage_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	payablePercentage_MAX_LT?: InputMaybe<Scalars["Float"]>;
	payablePercentage_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	payablePercentage_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	payablePercentage_MIN_GT?: InputMaybe<Scalars["Float"]>;
	payablePercentage_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	payablePercentage_MIN_LT?: InputMaybe<Scalars["Float"]>;
	payablePercentage_MIN_LTE?: InputMaybe<Scalars["Float"]>;
	payable_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	payable_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	payable_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	payable_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	payable_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	payable_EQUAL?: InputMaybe<Scalars["Float"]>;
	payable_GT?: InputMaybe<Scalars["Float"]>;
	payable_GTE?: InputMaybe<Scalars["Float"]>;
	payable_LT?: InputMaybe<Scalars["Float"]>;
	payable_LTE?: InputMaybe<Scalars["Float"]>;
	payable_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	payable_MAX_GT?: InputMaybe<Scalars["Float"]>;
	payable_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	payable_MAX_LT?: InputMaybe<Scalars["Float"]>;
	payable_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	payable_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	payable_MIN_GT?: InputMaybe<Scalars["Float"]>;
	payable_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	payable_MIN_LT?: InputMaybe<Scalars["Float"]>;
	payable_MIN_LTE?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	quantity_EQUAL?: InputMaybe<Scalars["Float"]>;
	quantity_GT?: InputMaybe<Scalars["Float"]>;
	quantity_GTE?: InputMaybe<Scalars["Float"]>;
	quantity_LT?: InputMaybe<Scalars["Float"]>;
	quantity_LTE?: InputMaybe<Scalars["Float"]>;
	quantity_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	quantity_MAX_GT?: InputMaybe<Scalars["Float"]>;
	quantity_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	quantity_MAX_LT?: InputMaybe<Scalars["Float"]>;
	quantity_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	quantity_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	quantity_MIN_GT?: InputMaybe<Scalars["Float"]>;
	quantity_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	quantity_MIN_LT?: InputMaybe<Scalars["Float"]>;
	quantity_MIN_LTE?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_EQUAL?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_GT?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_GTE?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_LT?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_LTE?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_MAX_GT?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_MAX_LT?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_MIN_GT?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_MIN_LT?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_MIN_LTE?: InputMaybe<Scalars["Float"]>;
	refundable_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	refundable_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	refundable_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	refundable_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	refundable_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	refundable_EQUAL?: InputMaybe<Scalars["Float"]>;
	refundable_GT?: InputMaybe<Scalars["Float"]>;
	refundable_GTE?: InputMaybe<Scalars["Float"]>;
	refundable_LT?: InputMaybe<Scalars["Float"]>;
	refundable_LTE?: InputMaybe<Scalars["Float"]>;
	refundable_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	refundable_MAX_GT?: InputMaybe<Scalars["Float"]>;
	refundable_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	refundable_MAX_LT?: InputMaybe<Scalars["Float"]>;
	refundable_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	refundable_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	refundable_MIN_GT?: InputMaybe<Scalars["Float"]>;
	refundable_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	refundable_MIN_LT?: InputMaybe<Scalars["Float"]>;
	refundable_MIN_LTE?: InputMaybe<Scalars["Float"]>;
	uuid_EQUAL?: InputMaybe<Scalars["ID"]>;
	variablePercentage_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	variablePercentage_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	variablePercentage_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	variablePercentage_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	variablePercentage_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	variablePercentage_EQUAL?: InputMaybe<Scalars["Float"]>;
	variablePercentage_GT?: InputMaybe<Scalars["Float"]>;
	variablePercentage_GTE?: InputMaybe<Scalars["Float"]>;
	variablePercentage_LT?: InputMaybe<Scalars["Float"]>;
	variablePercentage_LTE?: InputMaybe<Scalars["Float"]>;
	variablePercentage_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	variablePercentage_MAX_GT?: InputMaybe<Scalars["Float"]>;
	variablePercentage_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	variablePercentage_MAX_LT?: InputMaybe<Scalars["Float"]>;
	variablePercentage_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	variablePercentage_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	variablePercentage_MIN_GT?: InputMaybe<Scalars["Float"]>;
	variablePercentage_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	variablePercentage_MIN_LT?: InputMaybe<Scalars["Float"]>;
	variablePercentage_MIN_LTE?: InputMaybe<Scalars["Float"]>;
	variable_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	variable_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	variable_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	variable_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	variable_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	variable_EQUAL?: InputMaybe<Scalars["Float"]>;
	variable_GT?: InputMaybe<Scalars["Float"]>;
	variable_GTE?: InputMaybe<Scalars["Float"]>;
	variable_LT?: InputMaybe<Scalars["Float"]>;
	variable_LTE?: InputMaybe<Scalars["Float"]>;
	variable_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	variable_MAX_GT?: InputMaybe<Scalars["Float"]>;
	variable_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	variable_MAX_LT?: InputMaybe<Scalars["Float"]>;
	variable_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	variable_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	variable_MIN_GT?: InputMaybe<Scalars["Float"]>;
	variable_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	variable_MIN_LT?: InputMaybe<Scalars["Float"]>;
	variable_MIN_LTE?: InputMaybe<Scalars["Float"]>;
};

export type ContinuousBenefitFinancialDataPointsRelationship = {
	__typename?: "ContinuousBenefitFinancialDataPointsRelationship";
	cursor: Scalars["String"];
	node: FinancialDataPoint;
};

export type ContinuousBenefitFinancialDataPointsUpdateConnectionInput = {
	node?: InputMaybe<FinancialDataPointUpdateInput>;
};

export type ContinuousBenefitFinancialDataPointsUpdateFieldInput = {
	connect?: InputMaybe<Array<ContinuousBenefitFinancialDataPointsConnectFieldInput>>;
	create?: InputMaybe<Array<ContinuousBenefitFinancialDataPointsCreateFieldInput>>;
	delete?: InputMaybe<Array<ContinuousBenefitFinancialDataPointsDeleteFieldInput>>;
	disconnect?: InputMaybe<Array<ContinuousBenefitFinancialDataPointsDisconnectFieldInput>>;
	update?: InputMaybe<ContinuousBenefitFinancialDataPointsUpdateConnectionInput>;
	where?: InputMaybe<ContinuousBenefitFinancialDataPointsConnectionWhere>;
};

export type ContinuousBenefitFormAggregateInput = {
	AND?: InputMaybe<Array<ContinuousBenefitFormAggregateInput>>;
	OR?: InputMaybe<Array<ContinuousBenefitFormAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<ContinuousBenefitFormNodeAggregationWhereInput>;
};

export type ContinuousBenefitFormConnectFieldInput = {
	connect?: InputMaybe<FormConnectInput>;
	where?: InputMaybe<FormConnectWhere>;
};

export type ContinuousBenefitFormConnection = {
	__typename?: "ContinuousBenefitFormConnection";
	edges: Array<ContinuousBenefitFormRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type ContinuousBenefitFormConnectionSort = {
	node?: InputMaybe<FormSort>;
};

export type ContinuousBenefitFormConnectionWhere = {
	AND?: InputMaybe<Array<ContinuousBenefitFormConnectionWhere>>;
	OR?: InputMaybe<Array<ContinuousBenefitFormConnectionWhere>>;
	node?: InputMaybe<FormWhere>;
	node_NOT?: InputMaybe<FormWhere>;
};

export type ContinuousBenefitFormCreateFieldInput = {
	node: FormCreateInput;
};

export type ContinuousBenefitFormDeleteFieldInput = {
	delete?: InputMaybe<FormDeleteInput>;
	where?: InputMaybe<ContinuousBenefitFormConnectionWhere>;
};

export type ContinuousBenefitFormDisconnectFieldInput = {
	disconnect?: InputMaybe<FormDisconnectInput>;
	where?: InputMaybe<ContinuousBenefitFormConnectionWhere>;
};

export type ContinuousBenefitFormFieldInput = {
	connect?: InputMaybe<ContinuousBenefitFormConnectFieldInput>;
	create?: InputMaybe<ContinuousBenefitFormCreateFieldInput>;
};

export type ContinuousBenefitFormNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<ContinuousBenefitFormNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<ContinuousBenefitFormNodeAggregationWhereInput>>;
	createdByName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	createdByName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	createdByName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	createdByName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	createdByName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	createdByName_EQUAL?: InputMaybe<Scalars["String"]>;
	createdByName_GT?: InputMaybe<Scalars["Int"]>;
	createdByName_GTE?: InputMaybe<Scalars["Int"]>;
	createdByName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	createdByName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	createdByName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	createdByName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	createdByName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	createdByName_LT?: InputMaybe<Scalars["Int"]>;
	createdByName_LTE?: InputMaybe<Scalars["Int"]>;
	createdByName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	createdByName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	createdByName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	createdByName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	createdByName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	createdBy_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	createdBy_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	createdBy_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	createdBy_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	createdBy_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	createdBy_EQUAL?: InputMaybe<Scalars["String"]>;
	createdBy_GT?: InputMaybe<Scalars["Int"]>;
	createdBy_GTE?: InputMaybe<Scalars["Int"]>;
	createdBy_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	createdBy_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	createdBy_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	createdBy_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	createdBy_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	createdBy_LT?: InputMaybe<Scalars["Int"]>;
	createdBy_LTE?: InputMaybe<Scalars["Int"]>;
	createdBy_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	createdBy_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	createdBy_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	createdBy_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	createdBy_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	createdOn_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	insuranceId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	insuranceId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	insuranceId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	insuranceId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	insuranceId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	insuranceId_EQUAL?: InputMaybe<Scalars["String"]>;
	insuranceId_GT?: InputMaybe<Scalars["Int"]>;
	insuranceId_GTE?: InputMaybe<Scalars["Int"]>;
	insuranceId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	insuranceId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	insuranceId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	insuranceId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	insuranceId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	insuranceId_LT?: InputMaybe<Scalars["Int"]>;
	insuranceId_LTE?: InputMaybe<Scalars["Int"]>;
	insuranceId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	insuranceId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	insuranceId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	insuranceId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	insuranceId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	lastUpdatedOn_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_GT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_LT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	preparationBrandName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	preparationBrandName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	preparationBrandName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	preparationBrandName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	preparationBrandName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	preparationBrandName_EQUAL?: InputMaybe<Scalars["String"]>;
	preparationBrandName_GT?: InputMaybe<Scalars["Int"]>;
	preparationBrandName_GTE?: InputMaybe<Scalars["Int"]>;
	preparationBrandName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationBrandName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationBrandName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationBrandName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationBrandName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationBrandName_LT?: InputMaybe<Scalars["Int"]>;
	preparationBrandName_LTE?: InputMaybe<Scalars["Int"]>;
	preparationBrandName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationBrandName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationBrandName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationBrandName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationBrandName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	preparationGenericName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	preparationGenericName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	preparationGenericName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	preparationGenericName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	preparationGenericName_EQUAL?: InputMaybe<Scalars["String"]>;
	preparationGenericName_GT?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_GTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_LT?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_LTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	tenantId_EQUAL?: InputMaybe<Scalars["String"]>;
	tenantId_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	unlimited_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	unlimited_EQUAL?: InputMaybe<Scalars["Int"]>;
	unlimited_GT?: InputMaybe<Scalars["Int"]>;
	unlimited_GTE?: InputMaybe<Scalars["Int"]>;
	unlimited_LT?: InputMaybe<Scalars["Int"]>;
	unlimited_LTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_GT?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_LT?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_GT?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_LT?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	uuid_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	uuid_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	uuid_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	uuid_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	uuid_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	uuid_EQUAL?: InputMaybe<Scalars["String"]>;
	uuid_GT?: InputMaybe<Scalars["Int"]>;
	uuid_GTE?: InputMaybe<Scalars["Int"]>;
	uuid_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	uuid_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	uuid_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	uuid_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	uuid_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	uuid_LT?: InputMaybe<Scalars["Int"]>;
	uuid_LTE?: InputMaybe<Scalars["Int"]>;
	uuid_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	uuid_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	uuid_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	uuid_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	uuid_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type ContinuousBenefitFormRelationship = {
	__typename?: "ContinuousBenefitFormRelationship";
	cursor: Scalars["String"];
	node: Form;
};

export type ContinuousBenefitFormUpdateConnectionInput = {
	node?: InputMaybe<FormUpdateInput>;
};

export type ContinuousBenefitFormUpdateFieldInput = {
	connect?: InputMaybe<ContinuousBenefitFormConnectFieldInput>;
	create?: InputMaybe<ContinuousBenefitFormCreateFieldInput>;
	delete?: InputMaybe<ContinuousBenefitFormDeleteFieldInput>;
	disconnect?: InputMaybe<ContinuousBenefitFormDisconnectFieldInput>;
	update?: InputMaybe<ContinuousBenefitFormUpdateConnectionInput>;
	where?: InputMaybe<ContinuousBenefitFormConnectionWhere>;
};

export type ContinuousBenefitInitialResponseAggregateInput = {
	AND?: InputMaybe<Array<ContinuousBenefitInitialResponseAggregateInput>>;
	OR?: InputMaybe<Array<ContinuousBenefitInitialResponseAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<ContinuousBenefitInitialResponseNodeAggregationWhereInput>;
};

export type ContinuousBenefitInitialResponseConnectFieldInput = {
	connect?: InputMaybe<InitialResponseConnectInput>;
	where?: InputMaybe<InitialResponseConnectWhere>;
};

export type ContinuousBenefitInitialResponseConnection = {
	__typename?: "ContinuousBenefitInitialResponseConnection";
	edges: Array<ContinuousBenefitInitialResponseRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type ContinuousBenefitInitialResponseConnectionSort = {
	node?: InputMaybe<InitialResponseSort>;
};

export type ContinuousBenefitInitialResponseConnectionWhere = {
	AND?: InputMaybe<Array<ContinuousBenefitInitialResponseConnectionWhere>>;
	OR?: InputMaybe<Array<ContinuousBenefitInitialResponseConnectionWhere>>;
	node?: InputMaybe<InitialResponseWhere>;
	node_NOT?: InputMaybe<InitialResponseWhere>;
};

export type ContinuousBenefitInitialResponseCreateFieldInput = {
	node: InitialResponseCreateInput;
};

export type ContinuousBenefitInitialResponseDeleteFieldInput = {
	delete?: InputMaybe<InitialResponseDeleteInput>;
	where?: InputMaybe<ContinuousBenefitInitialResponseConnectionWhere>;
};

export type ContinuousBenefitInitialResponseDisconnectFieldInput = {
	disconnect?: InputMaybe<InitialResponseDisconnectInput>;
	where?: InputMaybe<ContinuousBenefitInitialResponseConnectionWhere>;
};

export type ContinuousBenefitInitialResponseFieldInput = {
	connect?: InputMaybe<ContinuousBenefitInitialResponseConnectFieldInput>;
	create?: InputMaybe<ContinuousBenefitInitialResponseCreateFieldInput>;
};

export type ContinuousBenefitInitialResponseNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<ContinuousBenefitInitialResponseNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<ContinuousBenefitInitialResponseNodeAggregationWhereInput>>;
	createdOn_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	numberOfPrescriptionsToDate_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	numberOfPrescriptionsToDate_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	numberOfPrescriptionsToDate_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	numberOfPrescriptionsToDate_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	numberOfPrescriptionsToDate_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	numberOfPrescriptionsToDate_EQUAL?: InputMaybe<Scalars["Int"]>;
	numberOfPrescriptionsToDate_GT?: InputMaybe<Scalars["Int"]>;
	numberOfPrescriptionsToDate_GTE?: InputMaybe<Scalars["Int"]>;
	numberOfPrescriptionsToDate_LT?: InputMaybe<Scalars["Int"]>;
	numberOfPrescriptionsToDate_LTE?: InputMaybe<Scalars["Int"]>;
	numberOfPrescriptionsToDate_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	numberOfPrescriptionsToDate_MAX_GT?: InputMaybe<Scalars["Int"]>;
	numberOfPrescriptionsToDate_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	numberOfPrescriptionsToDate_MAX_LT?: InputMaybe<Scalars["Int"]>;
	numberOfPrescriptionsToDate_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	numberOfPrescriptionsToDate_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	numberOfPrescriptionsToDate_MIN_GT?: InputMaybe<Scalars["Int"]>;
	numberOfPrescriptionsToDate_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	numberOfPrescriptionsToDate_MIN_LT?: InputMaybe<Scalars["Int"]>;
	numberOfPrescriptionsToDate_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	submissionDate_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_GT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_GTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_LT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_LTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	tenantId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	tenantId_EQUAL?: InputMaybe<Scalars["String"]>;
	tenantId_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type ContinuousBenefitInitialResponseRelationship = {
	__typename?: "ContinuousBenefitInitialResponseRelationship";
	cursor: Scalars["String"];
	node: InitialResponse;
};

export type ContinuousBenefitInitialResponseUpdateConnectionInput = {
	node?: InputMaybe<InitialResponseUpdateInput>;
};

export type ContinuousBenefitInitialResponseUpdateFieldInput = {
	connect?: InputMaybe<ContinuousBenefitInitialResponseConnectFieldInput>;
	create?: InputMaybe<ContinuousBenefitInitialResponseCreateFieldInput>;
	delete?: InputMaybe<ContinuousBenefitInitialResponseDeleteFieldInput>;
	disconnect?: InputMaybe<ContinuousBenefitInitialResponseDisconnectFieldInput>;
	update?: InputMaybe<ContinuousBenefitInitialResponseUpdateConnectionInput>;
	where?: InputMaybe<ContinuousBenefitInitialResponseConnectionWhere>;
};

export type ContinuousBenefitInput = {
	adverseEvents?: InputMaybe<Array<InputMaybe<AdverseEventInput>>>;
	assessmentDate?: InputMaybe<Scalars["Date"]>;
	caseId?: InputMaybe<Scalars["String"]>;
	crId?: InputMaybe<Scalars["String"]>;
	formId?: InputMaybe<Scalars["ID"]>;
	initialResponse?: InputMaybe<Scalars["String"]>;
	isPatientEnrolledInTreatment?: InputMaybe<Scalars["Boolean"]>;
	lastPrescriptionDate?: InputMaybe<Scalars["Date"]>;
	occurrence?: InputMaybe<OccurrenceEnum>;
	preparationPrescribedToAssessmentDate?: InputMaybe<Scalars["Boolean"]>;
	prescribedTreatments?: InputMaybe<Array<InputMaybe<TreatmentPrescriptionRelationshipInput>>>;
	reasonForDiscontinuation?: InputMaybe<ReasonsForDiscontinuation>;
	status?: InputMaybe<FormStatus>;
	treatingPhysician?: InputMaybe<TreatingPhysicianInput>;
};

export type ContinuousBenefitOptions = {
	limit?: InputMaybe<Scalars["Int"]>;
	offset?: InputMaybe<Scalars["Int"]>;
	/** Specify one or more ContinuousBenefitSort objects to sort ContinuousBenefits by. The sorts will be applied in the order in which they are arranged in the array. */
	sort?: InputMaybe<Array<InputMaybe<ContinuousBenefitSort>>>;
};

export type ContinuousBenefitPrescribedTreatmentsAggregateInput = {
	AND?: InputMaybe<Array<ContinuousBenefitPrescribedTreatmentsAggregateInput>>;
	OR?: InputMaybe<Array<ContinuousBenefitPrescribedTreatmentsAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	edge?: InputMaybe<ContinuousBenefitPrescribedTreatmentsEdgeAggregationWhereInput>;
	node?: InputMaybe<ContinuousBenefitPrescribedTreatmentsNodeAggregationWhereInput>;
};

export type ContinuousBenefitPrescribedTreatmentsConnectFieldInput = {
	connect?: InputMaybe<Array<TreatmentConnectInput>>;
	edge: TreatmentPrescriptionRelationshipCreateInput;
	where?: InputMaybe<TreatmentConnectWhere>;
};

export type ContinuousBenefitPrescribedTreatmentsConnection = {
	__typename?: "ContinuousBenefitPrescribedTreatmentsConnection";
	edges: Array<ContinuousBenefitPrescribedTreatmentsRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type ContinuousBenefitPrescribedTreatmentsConnectionSort = {
	edge?: InputMaybe<TreatmentPrescriptionRelationshipSort>;
	node?: InputMaybe<TreatmentSort>;
};

export type ContinuousBenefitPrescribedTreatmentsConnectionWhere = {
	AND?: InputMaybe<Array<ContinuousBenefitPrescribedTreatmentsConnectionWhere>>;
	OR?: InputMaybe<Array<ContinuousBenefitPrescribedTreatmentsConnectionWhere>>;
	edge?: InputMaybe<TreatmentPrescriptionRelationshipWhere>;
	edge_NOT?: InputMaybe<TreatmentPrescriptionRelationshipWhere>;
	node?: InputMaybe<TreatmentWhere>;
	node_NOT?: InputMaybe<TreatmentWhere>;
};

export type ContinuousBenefitPrescribedTreatmentsCreateFieldInput = {
	edge: TreatmentPrescriptionRelationshipCreateInput;
	node: TreatmentCreateInput;
};

export type ContinuousBenefitPrescribedTreatmentsDeleteFieldInput = {
	delete?: InputMaybe<TreatmentDeleteInput>;
	where?: InputMaybe<ContinuousBenefitPrescribedTreatmentsConnectionWhere>;
};

export type ContinuousBenefitPrescribedTreatmentsDisconnectFieldInput = {
	disconnect?: InputMaybe<TreatmentDisconnectInput>;
	where?: InputMaybe<ContinuousBenefitPrescribedTreatmentsConnectionWhere>;
};

export type ContinuousBenefitPrescribedTreatmentsEdgeAggregationWhereInput = {
	AND?: InputMaybe<Array<ContinuousBenefitPrescribedTreatmentsEdgeAggregationWhereInput>>;
	OR?: InputMaybe<Array<ContinuousBenefitPrescribedTreatmentsEdgeAggregationWhereInput>>;
	quantity_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	quantity_EQUAL?: InputMaybe<Scalars["Int"]>;
	quantity_GT?: InputMaybe<Scalars["Int"]>;
	quantity_GTE?: InputMaybe<Scalars["Int"]>;
	quantity_LT?: InputMaybe<Scalars["Int"]>;
	quantity_LTE?: InputMaybe<Scalars["Int"]>;
	quantity_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	quantity_MAX_GT?: InputMaybe<Scalars["Int"]>;
	quantity_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	quantity_MAX_LT?: InputMaybe<Scalars["Int"]>;
	quantity_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	quantity_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	quantity_MIN_GT?: InputMaybe<Scalars["Int"]>;
	quantity_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	quantity_MIN_LT?: InputMaybe<Scalars["Int"]>;
	quantity_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	uuid_EQUAL?: InputMaybe<Scalars["ID"]>;
};

export type ContinuousBenefitPrescribedTreatmentsFieldInput = {
	connect?: InputMaybe<Array<ContinuousBenefitPrescribedTreatmentsConnectFieldInput>>;
	create?: InputMaybe<Array<ContinuousBenefitPrescribedTreatmentsCreateFieldInput>>;
};

export type ContinuousBenefitPrescribedTreatmentsNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<ContinuousBenefitPrescribedTreatmentsNodeAggregationWhereInput>>;
	BagDossierNo_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	BagDossierNo_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	BagDossierNo_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	BagDossierNo_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	BagDossierNo_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	BagDossierNo_EQUAL?: InputMaybe<Scalars["String"]>;
	BagDossierNo_GT?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_GTE?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LT?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LTE?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	Code_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	Code_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	Code_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	Code_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	Code_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	Code_EQUAL?: InputMaybe<Scalars["String"]>;
	Code_GT?: InputMaybe<Scalars["Int"]>;
	Code_GTE?: InputMaybe<Scalars["Int"]>;
	Code_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Code_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	Code_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	Code_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	Code_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	Code_LT?: InputMaybe<Scalars["Int"]>;
	Code_LTE?: InputMaybe<Scalars["Int"]>;
	Code_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Code_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	Code_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	Code_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	Code_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	FlagModal_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	FlagModal_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	FlagModal_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	FlagModal_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	FlagModal_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	FlagModal_EQUAL?: InputMaybe<Scalars["String"]>;
	FlagModal_GT?: InputMaybe<Scalars["Int"]>;
	FlagModal_GTE?: InputMaybe<Scalars["Int"]>;
	FlagModal_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	FlagModal_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	FlagModal_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	FlagModal_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	FlagModal_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	FlagModal_LT?: InputMaybe<Scalars["Int"]>;
	FlagModal_LTE?: InputMaybe<Scalars["Int"]>;
	FlagModal_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	FlagModal_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	FlagModal_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	FlagModal_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	FlagModal_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	FlagNarcosis_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	FlagNarcosis_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	FlagNarcosis_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	FlagNarcosis_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	FlagNarcosis_EQUAL?: InputMaybe<Scalars["String"]>;
	FlagNarcosis_GT?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_GTE?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LT?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LTE?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	GTIN_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	GTIN_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	GTIN_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	GTIN_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	GTIN_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	GTIN_EQUAL?: InputMaybe<Scalars["String"]>;
	GTIN_GT?: InputMaybe<Scalars["Int"]>;
	GTIN_GTE?: InputMaybe<Scalars["Int"]>;
	GTIN_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	GTIN_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	GTIN_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	GTIN_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	GTIN_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	GTIN_LT?: InputMaybe<Scalars["Int"]>;
	GTIN_LTE?: InputMaybe<Scalars["Int"]>;
	GTIN_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	GTIN_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	GTIN_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	GTIN_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	GTIN_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	LOT_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	LOT_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	LOT_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	LOT_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	LOT_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	LOT_EQUAL?: InputMaybe<Scalars["String"]>;
	LOT_GT?: InputMaybe<Scalars["Int"]>;
	LOT_GTE?: InputMaybe<Scalars["Int"]>;
	LOT_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	LOT_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	LOT_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	LOT_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	LOT_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	LOT_LT?: InputMaybe<Scalars["Int"]>;
	LOT_LTE?: InputMaybe<Scalars["Int"]>;
	LOT_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	LOT_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	LOT_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	LOT_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	LOT_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	Name_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	Name_EQUAL?: InputMaybe<Scalars["String"]>;
	Name_GT?: InputMaybe<Scalars["Int"]>;
	Name_GTE?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	Name_LT?: InputMaybe<Scalars["Int"]>;
	Name_LTE?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	OR?: InputMaybe<Array<ContinuousBenefitPrescribedTreatmentsNodeAggregationWhereInput>>;
	PharmaCode_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	PharmaCode_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	PharmaCode_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	PharmaCode_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	PharmaCode_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	PharmaCode_EQUAL?: InputMaybe<Scalars["String"]>;
	PharmaCode_GT?: InputMaybe<Scalars["Int"]>;
	PharmaCode_GTE?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LT?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LTE?: InputMaybe<Scalars["Int"]>;
	PharmaCode_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	PharmaCode_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	PharmaCode_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	PharmaCode_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	PharmaCode_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	PrevPharmacode_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	PrevPharmacode_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	PrevPharmacode_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	PrevPharmacode_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	PrevPharmacode_EQUAL?: InputMaybe<Scalars["String"]>;
	PrevPharmacode_GT?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_GTE?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LT?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LTE?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	REF_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	REF_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	REF_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	REF_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	REF_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	REF_EQUAL?: InputMaybe<Scalars["String"]>;
	REF_GT?: InputMaybe<Scalars["Int"]>;
	REF_GTE?: InputMaybe<Scalars["Int"]>;
	REF_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	REF_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	REF_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	REF_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	REF_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	REF_LT?: InputMaybe<Scalars["Int"]>;
	REF_LTE?: InputMaybe<Scalars["Int"]>;
	REF_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	REF_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	REF_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	REF_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	REF_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	SwissmedicCategory_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	SwissmedicCategory_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	SwissmedicCategory_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	SwissmedicCategory_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	SwissmedicCategory_EQUAL?: InputMaybe<Scalars["String"]>;
	SwissmedicCategory_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo8_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo8_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo8_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo8_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo8_EQUAL?: InputMaybe<Scalars["String"]>;
	SwissmedicNo8_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	UDI_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	UDI_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	UDI_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	UDI_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	UDI_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	UDI_EQUAL?: InputMaybe<Scalars["String"]>;
	UDI_GT?: InputMaybe<Scalars["Int"]>;
	UDI_GTE?: InputMaybe<Scalars["Int"]>;
	UDI_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	UDI_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	UDI_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	UDI_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	UDI_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	UDI_LT?: InputMaybe<Scalars["Int"]>;
	UDI_LTE?: InputMaybe<Scalars["Int"]>;
	UDI_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	UDI_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	UDI_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	UDI_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	UDI_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	classificationSystem_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	classificationSystem_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	classificationSystem_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	classificationSystem_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	classificationSystem_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	classificationSystem_EQUAL?: InputMaybe<Scalars["String"]>;
	classificationSystem_GT?: InputMaybe<Scalars["Int"]>;
	classificationSystem_GTE?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LT?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LTE?: InputMaybe<Scalars["Int"]>;
	classificationSystem_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	classificationSystem_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	classificationSystem_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	classificationSystem_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	classificationSystem_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type ContinuousBenefitPrescribedTreatmentsRelationship = TreatmentPrescriptionRelationship & {
	__typename?: "ContinuousBenefitPrescribedTreatmentsRelationship";
	cursor: Scalars["String"];
	date?: Maybe<Scalars["Date"]>;
	node: Treatment;
	quantity?: Maybe<Scalars["Int"]>;
	status?: Maybe<RecordStatus>;
	uuid: Scalars["ID"];
};

export type ContinuousBenefitPrescribedTreatmentsUpdateConnectionInput = {
	edge?: InputMaybe<TreatmentPrescriptionRelationshipUpdateInput>;
	node?: InputMaybe<TreatmentUpdateInput>;
};

export type ContinuousBenefitPrescribedTreatmentsUpdateFieldInput = {
	connect?: InputMaybe<Array<ContinuousBenefitPrescribedTreatmentsConnectFieldInput>>;
	create?: InputMaybe<Array<ContinuousBenefitPrescribedTreatmentsCreateFieldInput>>;
	delete?: InputMaybe<Array<ContinuousBenefitPrescribedTreatmentsDeleteFieldInput>>;
	disconnect?: InputMaybe<Array<ContinuousBenefitPrescribedTreatmentsDisconnectFieldInput>>;
	update?: InputMaybe<ContinuousBenefitPrescribedTreatmentsUpdateConnectionInput>;
	where?: InputMaybe<ContinuousBenefitPrescribedTreatmentsConnectionWhere>;
};

export type ContinuousBenefitRecordsAggregateInput = {
	AND?: InputMaybe<Array<ContinuousBenefitRecordsAggregateInput>>;
	OR?: InputMaybe<Array<ContinuousBenefitRecordsAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<ContinuousBenefitRecordsNodeAggregationWhereInput>;
};

export type ContinuousBenefitRecordsConnectFieldInput = {
	connect?: InputMaybe<Array<RecordConnectInput>>;
	where?: InputMaybe<RecordConnectWhere>;
};

export type ContinuousBenefitRecordsConnection = {
	__typename?: "ContinuousBenefitRecordsConnection";
	edges: Array<ContinuousBenefitRecordsRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type ContinuousBenefitRecordsConnectionSort = {
	node?: InputMaybe<RecordSort>;
};

export type ContinuousBenefitRecordsConnectionWhere = {
	AND?: InputMaybe<Array<ContinuousBenefitRecordsConnectionWhere>>;
	OR?: InputMaybe<Array<ContinuousBenefitRecordsConnectionWhere>>;
	node?: InputMaybe<RecordWhere>;
	node_NOT?: InputMaybe<RecordWhere>;
};

export type ContinuousBenefitRecordsCreateFieldInput = {
	node: RecordCreateInput;
};

export type ContinuousBenefitRecordsDeleteFieldInput = {
	delete?: InputMaybe<RecordDeleteInput>;
	where?: InputMaybe<ContinuousBenefitRecordsConnectionWhere>;
};

export type ContinuousBenefitRecordsDisconnectFieldInput = {
	disconnect?: InputMaybe<RecordDisconnectInput>;
	where?: InputMaybe<ContinuousBenefitRecordsConnectionWhere>;
};

export type ContinuousBenefitRecordsFieldInput = {
	connect?: InputMaybe<Array<ContinuousBenefitRecordsConnectFieldInput>>;
	create?: InputMaybe<Array<ContinuousBenefitRecordsCreateFieldInput>>;
};

export type ContinuousBenefitRecordsNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<ContinuousBenefitRecordsNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<ContinuousBenefitRecordsNodeAggregationWhereInput>>;
	administrationDate_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_GT?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_GTE?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_LT?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_LTE?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	claimId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	claimId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	claimId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	claimId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	claimId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	claimId_EQUAL?: InputMaybe<Scalars["String"]>;
	claimId_GT?: InputMaybe<Scalars["Int"]>;
	claimId_GTE?: InputMaybe<Scalars["Int"]>;
	claimId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	claimId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	claimId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	claimId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	claimId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	claimId_LT?: InputMaybe<Scalars["Int"]>;
	claimId_LTE?: InputMaybe<Scalars["Int"]>;
	claimId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	claimId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	claimId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	claimId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	claimId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	createdByName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	createdByName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	createdByName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	createdByName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	createdByName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	createdByName_EQUAL?: InputMaybe<Scalars["String"]>;
	createdByName_GT?: InputMaybe<Scalars["Int"]>;
	createdByName_GTE?: InputMaybe<Scalars["Int"]>;
	createdByName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	createdByName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	createdByName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	createdByName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	createdByName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	createdByName_LT?: InputMaybe<Scalars["Int"]>;
	createdByName_LTE?: InputMaybe<Scalars["Int"]>;
	createdByName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	createdByName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	createdByName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	createdByName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	createdByName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	createdBy_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	createdBy_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	createdBy_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	createdBy_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	createdBy_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	createdBy_EQUAL?: InputMaybe<Scalars["String"]>;
	createdBy_GT?: InputMaybe<Scalars["Int"]>;
	createdBy_GTE?: InputMaybe<Scalars["Int"]>;
	createdBy_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	createdBy_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	createdBy_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	createdBy_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	createdBy_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	createdBy_LT?: InputMaybe<Scalars["Int"]>;
	createdBy_LTE?: InputMaybe<Scalars["Int"]>;
	createdBy_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	createdBy_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	createdBy_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	createdBy_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	createdBy_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	createdOn_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	insuranceId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	insuranceId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	insuranceId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	insuranceId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	insuranceId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	insuranceId_EQUAL?: InputMaybe<Scalars["String"]>;
	insuranceId_GT?: InputMaybe<Scalars["Int"]>;
	insuranceId_GTE?: InputMaybe<Scalars["Int"]>;
	insuranceId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	insuranceId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	insuranceId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	insuranceId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	insuranceId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	insuranceId_LT?: InputMaybe<Scalars["Int"]>;
	insuranceId_LTE?: InputMaybe<Scalars["Int"]>;
	insuranceId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	insuranceId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	insuranceId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	insuranceId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	insuranceId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	invoiceDate_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	invoiceDate_GT?: InputMaybe<Scalars["DateTime"]>;
	invoiceDate_GTE?: InputMaybe<Scalars["DateTime"]>;
	invoiceDate_LT?: InputMaybe<Scalars["DateTime"]>;
	invoiceDate_LTE?: InputMaybe<Scalars["DateTime"]>;
	invoiceDate_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	invoiceDate_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	invoiceDate_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	invoiceDate_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	invoiceDate_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	invoiceDate_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	invoiceDate_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	invoiceDate_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	invoiceDate_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	invoiceDate_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	invoiceNumber_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	invoiceNumber_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	invoiceNumber_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	invoiceNumber_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	invoiceNumber_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	invoiceNumber_EQUAL?: InputMaybe<Scalars["String"]>;
	invoiceNumber_GT?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_GTE?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_LT?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_LTE?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	preparationBrandNames_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	preparationBrandNames_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	preparationBrandNames_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	preparationBrandNames_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	preparationBrandNames_EQUAL?: InputMaybe<Scalars["String"]>;
	preparationBrandNames_GT?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_GTE?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_LT?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_LTE?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	preparationGenericNames_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	preparationGenericNames_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	preparationGenericNames_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	preparationGenericNames_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	preparationGenericNames_EQUAL?: InputMaybe<Scalars["String"]>;
	preparationGenericNames_GT?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_GTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_LT?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_LTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	preparationId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	preparationId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	preparationId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	preparationId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	preparationId_EQUAL?: InputMaybe<Scalars["String"]>;
	preparationId_GT?: InputMaybe<Scalars["Int"]>;
	preparationId_GTE?: InputMaybe<Scalars["Int"]>;
	preparationId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationId_LT?: InputMaybe<Scalars["Int"]>;
	preparationId_LTE?: InputMaybe<Scalars["Int"]>;
	preparationId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	quantity_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	quantity_EQUAL?: InputMaybe<Scalars["Int"]>;
	quantity_GT?: InputMaybe<Scalars["Int"]>;
	quantity_GTE?: InputMaybe<Scalars["Int"]>;
	quantity_LT?: InputMaybe<Scalars["Int"]>;
	quantity_LTE?: InputMaybe<Scalars["Int"]>;
	quantity_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	quantity_MAX_GT?: InputMaybe<Scalars["Int"]>;
	quantity_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	quantity_MAX_LT?: InputMaybe<Scalars["Int"]>;
	quantity_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	quantity_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	quantity_MIN_GT?: InputMaybe<Scalars["Int"]>;
	quantity_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	quantity_MIN_LT?: InputMaybe<Scalars["Int"]>;
	quantity_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	tenantId_EQUAL?: InputMaybe<Scalars["String"]>;
	tenantId_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	treatmentName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	treatmentName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	treatmentName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	treatmentName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	treatmentName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	treatmentName_EQUAL?: InputMaybe<Scalars["String"]>;
	treatmentName_GT?: InputMaybe<Scalars["Int"]>;
	treatmentName_GTE?: InputMaybe<Scalars["Int"]>;
	treatmentName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	treatmentName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	treatmentName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	treatmentName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	treatmentName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	treatmentName_LT?: InputMaybe<Scalars["Int"]>;
	treatmentName_LTE?: InputMaybe<Scalars["Int"]>;
	treatmentName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	treatmentName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	treatmentName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	treatmentName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	treatmentName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	unlimited_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	unlimited_EQUAL?: InputMaybe<Scalars["Int"]>;
	unlimited_GT?: InputMaybe<Scalars["Int"]>;
	unlimited_GTE?: InputMaybe<Scalars["Int"]>;
	unlimited_LT?: InputMaybe<Scalars["Int"]>;
	unlimited_LTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_GT?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_LT?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_GT?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_LT?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	uuid_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	uuid_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	uuid_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	uuid_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	uuid_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	uuid_EQUAL?: InputMaybe<Scalars["String"]>;
	uuid_GT?: InputMaybe<Scalars["Int"]>;
	uuid_GTE?: InputMaybe<Scalars["Int"]>;
	uuid_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	uuid_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	uuid_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	uuid_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	uuid_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	uuid_LT?: InputMaybe<Scalars["Int"]>;
	uuid_LTE?: InputMaybe<Scalars["Int"]>;
	uuid_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	uuid_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	uuid_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	uuid_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	uuid_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type ContinuousBenefitRecordsRelationship = {
	__typename?: "ContinuousBenefitRecordsRelationship";
	cursor: Scalars["String"];
	node: Record;
};

export type ContinuousBenefitRecordsUpdateConnectionInput = {
	node?: InputMaybe<RecordUpdateInput>;
};

export type ContinuousBenefitRecordsUpdateFieldInput = {
	connect?: InputMaybe<Array<ContinuousBenefitRecordsConnectFieldInput>>;
	create?: InputMaybe<Array<ContinuousBenefitRecordsCreateFieldInput>>;
	delete?: InputMaybe<Array<ContinuousBenefitRecordsDeleteFieldInput>>;
	disconnect?: InputMaybe<Array<ContinuousBenefitRecordsDisconnectFieldInput>>;
	update?: InputMaybe<ContinuousBenefitRecordsUpdateConnectionInput>;
	where?: InputMaybe<ContinuousBenefitRecordsConnectionWhere>;
};

/** Fields to sort ContinuousBenefits by. The order in which sorts are applied is not guaranteed when specifying many fields in one ContinuousBenefitSort object. */
export type ContinuousBenefitSort = {
	assessmentDate?: InputMaybe<SortDirection>;
	createdOn?: InputMaybe<SortDirection>;
	id?: InputMaybe<SortDirection>;
	isArchived?: InputMaybe<SortDirection>;
	isDeleted?: InputMaybe<SortDirection>;
	isPatientEnrolledInTreatment?: InputMaybe<SortDirection>;
	reasonForDiscontinuation?: InputMaybe<SortDirection>;
	status?: InputMaybe<SortDirection>;
	submissionDate?: InputMaybe<SortDirection>;
	tenantId?: InputMaybe<SortDirection>;
};

export type ContinuousBenefitTreatingPhysicianAggregateInput = {
	AND?: InputMaybe<Array<ContinuousBenefitTreatingPhysicianAggregateInput>>;
	OR?: InputMaybe<Array<ContinuousBenefitTreatingPhysicianAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<ContinuousBenefitTreatingPhysicianNodeAggregationWhereInput>;
};

export type ContinuousBenefitTreatingPhysicianConnectFieldInput = {
	where?: InputMaybe<TreatingPhysicianConnectWhere>;
};

export type ContinuousBenefitTreatingPhysicianConnection = {
	__typename?: "ContinuousBenefitTreatingPhysicianConnection";
	edges: Array<ContinuousBenefitTreatingPhysicianRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type ContinuousBenefitTreatingPhysicianConnectionSort = {
	node?: InputMaybe<TreatingPhysicianSort>;
};

export type ContinuousBenefitTreatingPhysicianConnectionWhere = {
	AND?: InputMaybe<Array<ContinuousBenefitTreatingPhysicianConnectionWhere>>;
	OR?: InputMaybe<Array<ContinuousBenefitTreatingPhysicianConnectionWhere>>;
	node?: InputMaybe<TreatingPhysicianWhere>;
	node_NOT?: InputMaybe<TreatingPhysicianWhere>;
};

export type ContinuousBenefitTreatingPhysicianCreateFieldInput = {
	node: TreatingPhysicianCreateInput;
};

export type ContinuousBenefitTreatingPhysicianDeleteFieldInput = {
	where?: InputMaybe<ContinuousBenefitTreatingPhysicianConnectionWhere>;
};

export type ContinuousBenefitTreatingPhysicianDisconnectFieldInput = {
	where?: InputMaybe<ContinuousBenefitTreatingPhysicianConnectionWhere>;
};

export type ContinuousBenefitTreatingPhysicianFieldInput = {
	connect?: InputMaybe<ContinuousBenefitTreatingPhysicianConnectFieldInput>;
	create?: InputMaybe<ContinuousBenefitTreatingPhysicianCreateFieldInput>;
};

export type ContinuousBenefitTreatingPhysicianNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<ContinuousBenefitTreatingPhysicianNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<ContinuousBenefitTreatingPhysicianNodeAggregationWhereInput>>;
	department_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	department_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	department_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	department_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	department_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	department_EQUAL?: InputMaybe<Scalars["String"]>;
	department_GT?: InputMaybe<Scalars["Int"]>;
	department_GTE?: InputMaybe<Scalars["Int"]>;
	department_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	department_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	department_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	department_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	department_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	department_LT?: InputMaybe<Scalars["Int"]>;
	department_LTE?: InputMaybe<Scalars["Int"]>;
	department_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	department_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	department_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	department_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	department_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	email_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	email_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	email_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	email_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	email_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	email_EQUAL?: InputMaybe<Scalars["String"]>;
	email_GT?: InputMaybe<Scalars["Int"]>;
	email_GTE?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	email_LT?: InputMaybe<Scalars["Int"]>;
	email_LTE?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	firstName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	firstName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	firstName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	firstName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	firstName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	firstName_EQUAL?: InputMaybe<Scalars["String"]>;
	firstName_GT?: InputMaybe<Scalars["Int"]>;
	firstName_GTE?: InputMaybe<Scalars["Int"]>;
	firstName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	firstName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	firstName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	firstName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	firstName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	firstName_LT?: InputMaybe<Scalars["Int"]>;
	firstName_LTE?: InputMaybe<Scalars["Int"]>;
	firstName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	firstName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	firstName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	firstName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	firstName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	hospitalName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	hospitalName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	hospitalName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	hospitalName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	hospitalName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	hospitalName_EQUAL?: InputMaybe<Scalars["String"]>;
	hospitalName_GT?: InputMaybe<Scalars["Int"]>;
	hospitalName_GTE?: InputMaybe<Scalars["Int"]>;
	hospitalName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	hospitalName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	hospitalName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	hospitalName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	hospitalName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	hospitalName_LT?: InputMaybe<Scalars["Int"]>;
	hospitalName_LTE?: InputMaybe<Scalars["Int"]>;
	hospitalName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	hospitalName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	hospitalName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	hospitalName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	hospitalName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	lastName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	lastName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	lastName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	lastName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	lastName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	lastName_EQUAL?: InputMaybe<Scalars["String"]>;
	lastName_GT?: InputMaybe<Scalars["Int"]>;
	lastName_GTE?: InputMaybe<Scalars["Int"]>;
	lastName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	lastName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	lastName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	lastName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	lastName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	lastName_LT?: InputMaybe<Scalars["Int"]>;
	lastName_LTE?: InputMaybe<Scalars["Int"]>;
	lastName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	lastName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	lastName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	lastName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	lastName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	nr_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	nr_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	nr_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	nr_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	nr_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	nr_EQUAL?: InputMaybe<Scalars["String"]>;
	nr_GT?: InputMaybe<Scalars["Int"]>;
	nr_GTE?: InputMaybe<Scalars["Int"]>;
	nr_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	nr_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	nr_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	nr_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	nr_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	nr_LT?: InputMaybe<Scalars["Int"]>;
	nr_LTE?: InputMaybe<Scalars["Int"]>;
	nr_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	nr_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	nr_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	nr_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	nr_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	phoneNo_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	phoneNo_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	phoneNo_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	phoneNo_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	phoneNo_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	phoneNo_EQUAL?: InputMaybe<Scalars["String"]>;
	phoneNo_GT?: InputMaybe<Scalars["Int"]>;
	phoneNo_GTE?: InputMaybe<Scalars["Int"]>;
	phoneNo_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	phoneNo_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	phoneNo_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	phoneNo_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	phoneNo_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	phoneNo_LT?: InputMaybe<Scalars["Int"]>;
	phoneNo_LTE?: InputMaybe<Scalars["Int"]>;
	phoneNo_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	phoneNo_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	phoneNo_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	phoneNo_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	phoneNo_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	place_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	place_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	place_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	place_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	place_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	place_EQUAL?: InputMaybe<Scalars["String"]>;
	place_GT?: InputMaybe<Scalars["Int"]>;
	place_GTE?: InputMaybe<Scalars["Int"]>;
	place_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	place_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	place_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	place_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	place_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	place_LT?: InputMaybe<Scalars["Int"]>;
	place_LTE?: InputMaybe<Scalars["Int"]>;
	place_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	place_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	place_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	place_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	place_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	postcode_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	postcode_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	postcode_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	postcode_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	postcode_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	postcode_EQUAL?: InputMaybe<Scalars["String"]>;
	postcode_GT?: InputMaybe<Scalars["Int"]>;
	postcode_GTE?: InputMaybe<Scalars["Int"]>;
	postcode_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	postcode_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	postcode_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	postcode_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	postcode_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	postcode_LT?: InputMaybe<Scalars["Int"]>;
	postcode_LTE?: InputMaybe<Scalars["Int"]>;
	postcode_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	postcode_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	postcode_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	postcode_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	postcode_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	street_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	street_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	street_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	street_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	street_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	street_EQUAL?: InputMaybe<Scalars["String"]>;
	street_GT?: InputMaybe<Scalars["Int"]>;
	street_GTE?: InputMaybe<Scalars["Int"]>;
	street_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	street_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	street_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	street_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	street_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	street_LT?: InputMaybe<Scalars["Int"]>;
	street_LTE?: InputMaybe<Scalars["Int"]>;
	street_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	street_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	street_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	street_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	street_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type ContinuousBenefitTreatingPhysicianRelationship = {
	__typename?: "ContinuousBenefitTreatingPhysicianRelationship";
	cursor: Scalars["String"];
	node: TreatingPhysician;
};

export type ContinuousBenefitTreatingPhysicianUpdateConnectionInput = {
	node?: InputMaybe<TreatingPhysicianUpdateInput>;
};

export type ContinuousBenefitTreatingPhysicianUpdateFieldInput = {
	connect?: InputMaybe<ContinuousBenefitTreatingPhysicianConnectFieldInput>;
	create?: InputMaybe<ContinuousBenefitTreatingPhysicianCreateFieldInput>;
	delete?: InputMaybe<ContinuousBenefitTreatingPhysicianDeleteFieldInput>;
	disconnect?: InputMaybe<ContinuousBenefitTreatingPhysicianDisconnectFieldInput>;
	update?: InputMaybe<ContinuousBenefitTreatingPhysicianUpdateConnectionInput>;
	where?: InputMaybe<ContinuousBenefitTreatingPhysicianConnectionWhere>;
};

export type ContinuousBenefitUpdateInput = {
	adverseEvents?: InputMaybe<Array<ContinuousBenefitAdverseEventsUpdateFieldInput>>;
	assessmentDate?: InputMaybe<Scalars["Date"]>;
	coverageRequest?: InputMaybe<ContinuousBenefitCoverageRequestUpdateFieldInput>;
	createdOn?: InputMaybe<Scalars["DateTime"]>;
	financialDataPoints?: InputMaybe<Array<ContinuousBenefitFinancialDataPointsUpdateFieldInput>>;
	form?: InputMaybe<ContinuousBenefitFormUpdateFieldInput>;
	id?: InputMaybe<Scalars["ID"]>;
	initialResponse?: InputMaybe<ContinuousBenefitInitialResponseUpdateFieldInput>;
	isArchived?: InputMaybe<Scalars["Boolean"]>;
	isDeleted?: InputMaybe<Scalars["Boolean"]>;
	isPatientEnrolledInTreatment?: InputMaybe<Scalars["Boolean"]>;
	prescribedTreatments?: InputMaybe<Array<ContinuousBenefitPrescribedTreatmentsUpdateFieldInput>>;
	reasonForDiscontinuation?: InputMaybe<ReasonsForDiscontinuation>;
	records?: InputMaybe<Array<ContinuousBenefitRecordsUpdateFieldInput>>;
	status?: InputMaybe<FormStatus>;
	submissionDate?: InputMaybe<Scalars["DateTime"]>;
	tenantId?: InputMaybe<Scalars["String"]>;
	treatingPhysician?: InputMaybe<ContinuousBenefitTreatingPhysicianUpdateFieldInput>;
};

export type ContinuousBenefitWhere = {
	AND?: InputMaybe<Array<ContinuousBenefitWhere>>;
	OR?: InputMaybe<Array<ContinuousBenefitWhere>>;
	adverseEvents?: InputMaybe<AdverseEventWhere>;
	adverseEventsAggregate?: InputMaybe<ContinuousBenefitAdverseEventsAggregateInput>;
	adverseEventsConnection?: InputMaybe<ContinuousBenefitAdverseEventsConnectionWhere>;
	adverseEventsConnection_NOT?: InputMaybe<ContinuousBenefitAdverseEventsConnectionWhere>;
	adverseEvents_NOT?: InputMaybe<AdverseEventWhere>;
	assessmentDate?: InputMaybe<Scalars["Date"]>;
	assessmentDate_GT?: InputMaybe<Scalars["Date"]>;
	assessmentDate_GTE?: InputMaybe<Scalars["Date"]>;
	assessmentDate_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
	assessmentDate_LT?: InputMaybe<Scalars["Date"]>;
	assessmentDate_LTE?: InputMaybe<Scalars["Date"]>;
	assessmentDate_NOT?: InputMaybe<Scalars["Date"]>;
	assessmentDate_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
	coverageRequest?: InputMaybe<CoverageRequestWhere>;
	coverageRequestAggregate?: InputMaybe<ContinuousBenefitCoverageRequestAggregateInput>;
	coverageRequestConnection?: InputMaybe<ContinuousBenefitCoverageRequestConnectionWhere>;
	coverageRequestConnection_NOT?: InputMaybe<ContinuousBenefitCoverageRequestConnectionWhere>;
	coverageRequest_NOT?: InputMaybe<CoverageRequestWhere>;
	createdOn?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_IN?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]>>>;
	createdOn_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_NOT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]>>>;
	financialDataPoints?: InputMaybe<FinancialDataPointWhere>;
	financialDataPointsAggregate?: InputMaybe<ContinuousBenefitFinancialDataPointsAggregateInput>;
	financialDataPointsConnection?: InputMaybe<ContinuousBenefitFinancialDataPointsConnectionWhere>;
	financialDataPointsConnection_NOT?: InputMaybe<ContinuousBenefitFinancialDataPointsConnectionWhere>;
	financialDataPoints_NOT?: InputMaybe<FinancialDataPointWhere>;
	form?: InputMaybe<FormWhere>;
	formAggregate?: InputMaybe<ContinuousBenefitFormAggregateInput>;
	formConnection?: InputMaybe<ContinuousBenefitFormConnectionWhere>;
	formConnection_NOT?: InputMaybe<ContinuousBenefitFormConnectionWhere>;
	form_NOT?: InputMaybe<FormWhere>;
	id?: InputMaybe<Scalars["ID"]>;
	id_CONTAINS?: InputMaybe<Scalars["ID"]>;
	id_ENDS_WITH?: InputMaybe<Scalars["ID"]>;
	id_IN?: InputMaybe<Array<InputMaybe<Scalars["ID"]>>>;
	id_MATCHES?: InputMaybe<Scalars["String"]>;
	id_NOT?: InputMaybe<Scalars["ID"]>;
	id_NOT_CONTAINS?: InputMaybe<Scalars["ID"]>;
	id_NOT_ENDS_WITH?: InputMaybe<Scalars["ID"]>;
	id_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["ID"]>>>;
	id_NOT_STARTS_WITH?: InputMaybe<Scalars["ID"]>;
	id_STARTS_WITH?: InputMaybe<Scalars["ID"]>;
	initialResponse?: InputMaybe<InitialResponseWhere>;
	initialResponseAggregate?: InputMaybe<ContinuousBenefitInitialResponseAggregateInput>;
	initialResponseConnection?: InputMaybe<ContinuousBenefitInitialResponseConnectionWhere>;
	initialResponseConnection_NOT?: InputMaybe<ContinuousBenefitInitialResponseConnectionWhere>;
	initialResponse_NOT?: InputMaybe<InitialResponseWhere>;
	isArchived?: InputMaybe<Scalars["Boolean"]>;
	isArchived_NOT?: InputMaybe<Scalars["Boolean"]>;
	isDeleted?: InputMaybe<Scalars["Boolean"]>;
	isDeleted_NOT?: InputMaybe<Scalars["Boolean"]>;
	isPatientEnrolledInTreatment?: InputMaybe<Scalars["Boolean"]>;
	isPatientEnrolledInTreatment_NOT?: InputMaybe<Scalars["Boolean"]>;
	prescribedTreatments?: InputMaybe<TreatmentWhere>;
	prescribedTreatmentsAggregate?: InputMaybe<ContinuousBenefitPrescribedTreatmentsAggregateInput>;
	prescribedTreatmentsConnection?: InputMaybe<ContinuousBenefitPrescribedTreatmentsConnectionWhere>;
	prescribedTreatmentsConnection_NOT?: InputMaybe<ContinuousBenefitPrescribedTreatmentsConnectionWhere>;
	prescribedTreatments_NOT?: InputMaybe<TreatmentWhere>;
	reasonForDiscontinuation?: InputMaybe<ReasonsForDiscontinuation>;
	reasonForDiscontinuation_IN?: InputMaybe<Array<InputMaybe<ReasonsForDiscontinuation>>>;
	reasonForDiscontinuation_NOT?: InputMaybe<ReasonsForDiscontinuation>;
	reasonForDiscontinuation_NOT_IN?: InputMaybe<Array<InputMaybe<ReasonsForDiscontinuation>>>;
	records?: InputMaybe<RecordWhere>;
	recordsAggregate?: InputMaybe<ContinuousBenefitRecordsAggregateInput>;
	recordsConnection?: InputMaybe<ContinuousBenefitRecordsConnectionWhere>;
	recordsConnection_NOT?: InputMaybe<ContinuousBenefitRecordsConnectionWhere>;
	records_NOT?: InputMaybe<RecordWhere>;
	status?: InputMaybe<FormStatus>;
	status_IN?: InputMaybe<Array<InputMaybe<FormStatus>>>;
	status_NOT?: InputMaybe<FormStatus>;
	status_NOT_IN?: InputMaybe<Array<InputMaybe<FormStatus>>>;
	submissionDate?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_GT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_GTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_IN?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]>>>;
	submissionDate_LT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_LTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_NOT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]>>>;
	tenantId?: InputMaybe<Scalars["String"]>;
	tenantId_CONTAINS?: InputMaybe<Scalars["String"]>;
	tenantId_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	tenantId_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	tenantId_MATCHES?: InputMaybe<Scalars["String"]>;
	tenantId_NOT?: InputMaybe<Scalars["String"]>;
	tenantId_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	tenantId_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	tenantId_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	tenantId_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	tenantId_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	treatingPhysician?: InputMaybe<TreatingPhysicianWhere>;
	treatingPhysicianAggregate?: InputMaybe<ContinuousBenefitTreatingPhysicianAggregateInput>;
	treatingPhysicianConnection?: InputMaybe<ContinuousBenefitTreatingPhysicianConnectionWhere>;
	treatingPhysicianConnection_NOT?: InputMaybe<ContinuousBenefitTreatingPhysicianConnectionWhere>;
	treatingPhysician_NOT?: InputMaybe<TreatingPhysicianWhere>;
};

export type ContractNotification = {
	__typename?: "ContractNotification";
	order: Scalars["Int"];
	triggers: Array<NotificationTrigger>;
	triggersConnection: ContractNotificationTriggersConnection;
	userEmails: Array<Maybe<Scalars["String"]>>;
};

export type ContractNotificationTriggersArgs = {
	options?: InputMaybe<NotificationTriggerOptions>;
	where?: InputMaybe<NotificationTriggerWhere>;
};

export type ContractNotificationTriggersConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<ContractNotificationTriggersConnectionSort>>;
	where?: InputMaybe<ContractNotificationTriggersConnectionWhere>;
};

export type ContractNotificationAggregateSelection = {
	__typename?: "ContractNotificationAggregateSelection";
	count: Scalars["Int"];
	order: IntAggregateSelection;
};

export type ContractNotificationConnectInput = {
	triggers?: InputMaybe<Array<ContractNotificationTriggersConnectFieldInput>>;
};

export type ContractNotificationConnectWhere = {
	node: ContractNotificationWhere;
};

export type ContractNotificationCreateInput = {
	order: Scalars["Int"];
	triggers?: InputMaybe<ContractNotificationTriggersFieldInput>;
	userEmails: Array<InputMaybe<Scalars["String"]>>;
};

export type ContractNotificationDeleteInput = {
	triggers?: InputMaybe<Array<ContractNotificationTriggersDeleteFieldInput>>;
};

export type ContractNotificationDisconnectInput = {
	triggers?: InputMaybe<Array<ContractNotificationTriggersDisconnectFieldInput>>;
};

export type ContractNotificationInput = {
	order: Scalars["Int"];
	triggers: Array<NotificationTriggerInput>;
	userEmails: Array<InputMaybe<Scalars["String"]>>;
};

export type ContractNotificationOptions = {
	limit?: InputMaybe<Scalars["Int"]>;
	offset?: InputMaybe<Scalars["Int"]>;
	/** Specify one or more ContractNotificationSort objects to sort ContractNotifications by. The sorts will be applied in the order in which they are arranged in the array. */
	sort?: InputMaybe<Array<InputMaybe<ContractNotificationSort>>>;
};

/** Fields to sort ContractNotifications by. The order in which sorts are applied is not guaranteed when specifying many fields in one ContractNotificationSort object. */
export type ContractNotificationSort = {
	order?: InputMaybe<SortDirection>;
};

export type ContractNotificationTriggersAggregateInput = {
	AND?: InputMaybe<Array<ContractNotificationTriggersAggregateInput>>;
	OR?: InputMaybe<Array<ContractNotificationTriggersAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<ContractNotificationTriggersNodeAggregationWhereInput>;
};

export type ContractNotificationTriggersConnectFieldInput = {
	where?: InputMaybe<NotificationTriggerConnectWhere>;
};

export type ContractNotificationTriggersConnection = {
	__typename?: "ContractNotificationTriggersConnection";
	edges: Array<ContractNotificationTriggersRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type ContractNotificationTriggersConnectionSort = {
	node?: InputMaybe<NotificationTriggerSort>;
};

export type ContractNotificationTriggersConnectionWhere = {
	AND?: InputMaybe<Array<ContractNotificationTriggersConnectionWhere>>;
	OR?: InputMaybe<Array<ContractNotificationTriggersConnectionWhere>>;
	node?: InputMaybe<NotificationTriggerWhere>;
	node_NOT?: InputMaybe<NotificationTriggerWhere>;
};

export type ContractNotificationTriggersCreateFieldInput = {
	node: NotificationTriggerCreateInput;
};

export type ContractNotificationTriggersDeleteFieldInput = {
	where?: InputMaybe<ContractNotificationTriggersConnectionWhere>;
};

export type ContractNotificationTriggersDisconnectFieldInput = {
	where?: InputMaybe<ContractNotificationTriggersConnectionWhere>;
};

export type ContractNotificationTriggersFieldInput = {
	connect?: InputMaybe<Array<ContractNotificationTriggersConnectFieldInput>>;
	create?: InputMaybe<Array<ContractNotificationTriggersCreateFieldInput>>;
};

export type ContractNotificationTriggersNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<ContractNotificationTriggersNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<ContractNotificationTriggersNodeAggregationWhereInput>>;
	order_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	order_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	order_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	order_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	order_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	order_EQUAL?: InputMaybe<Scalars["Int"]>;
	order_GT?: InputMaybe<Scalars["Int"]>;
	order_GTE?: InputMaybe<Scalars["Int"]>;
	order_LT?: InputMaybe<Scalars["Int"]>;
	order_LTE?: InputMaybe<Scalars["Int"]>;
	order_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	order_MAX_GT?: InputMaybe<Scalars["Int"]>;
	order_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	order_MAX_LT?: InputMaybe<Scalars["Int"]>;
	order_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	order_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	order_MIN_GT?: InputMaybe<Scalars["Int"]>;
	order_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	order_MIN_LT?: InputMaybe<Scalars["Int"]>;
	order_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	previouslyDispatchedOn_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	previouslyDispatchedOn_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	previouslyDispatchedOn_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	previouslyDispatchedOn_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	previouslyDispatchedOn_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	previouslyDispatchedOn_EQUAL?: InputMaybe<Scalars["String"]>;
	previouslyDispatchedOn_GT?: InputMaybe<Scalars["Int"]>;
	previouslyDispatchedOn_GTE?: InputMaybe<Scalars["Int"]>;
	previouslyDispatchedOn_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	previouslyDispatchedOn_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	previouslyDispatchedOn_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	previouslyDispatchedOn_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	previouslyDispatchedOn_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	previouslyDispatchedOn_LT?: InputMaybe<Scalars["Int"]>;
	previouslyDispatchedOn_LTE?: InputMaybe<Scalars["Int"]>;
	previouslyDispatchedOn_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	previouslyDispatchedOn_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	previouslyDispatchedOn_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	previouslyDispatchedOn_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	previouslyDispatchedOn_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	value_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	value_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	value_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	value_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	value_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	value_EQUAL?: InputMaybe<Scalars["String"]>;
	value_GT?: InputMaybe<Scalars["Int"]>;
	value_GTE?: InputMaybe<Scalars["Int"]>;
	value_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	value_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	value_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	value_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	value_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	value_LT?: InputMaybe<Scalars["Int"]>;
	value_LTE?: InputMaybe<Scalars["Int"]>;
	value_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	value_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	value_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	value_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	value_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type ContractNotificationTriggersRelationship = {
	__typename?: "ContractNotificationTriggersRelationship";
	cursor: Scalars["String"];
	node: NotificationTrigger;
};

export type ContractNotificationTriggersUpdateConnectionInput = {
	node?: InputMaybe<NotificationTriggerUpdateInput>;
};

export type ContractNotificationTriggersUpdateFieldInput = {
	connect?: InputMaybe<Array<ContractNotificationTriggersConnectFieldInput>>;
	create?: InputMaybe<Array<ContractNotificationTriggersCreateFieldInput>>;
	delete?: InputMaybe<Array<ContractNotificationTriggersDeleteFieldInput>>;
	disconnect?: InputMaybe<Array<ContractNotificationTriggersDisconnectFieldInput>>;
	update?: InputMaybe<ContractNotificationTriggersUpdateConnectionInput>;
	where?: InputMaybe<ContractNotificationTriggersConnectionWhere>;
};

export type ContractNotificationUpdateInput = {
	order?: InputMaybe<Scalars["Int"]>;
	triggers?: InputMaybe<Array<ContractNotificationTriggersUpdateFieldInput>>;
	userEmails?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
};

export type ContractNotificationWhere = {
	AND?: InputMaybe<Array<ContractNotificationWhere>>;
	OR?: InputMaybe<Array<ContractNotificationWhere>>;
	order?: InputMaybe<Scalars["Int"]>;
	order_GT?: InputMaybe<Scalars["Int"]>;
	order_GTE?: InputMaybe<Scalars["Int"]>;
	order_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	order_LT?: InputMaybe<Scalars["Int"]>;
	order_LTE?: InputMaybe<Scalars["Int"]>;
	order_NOT?: InputMaybe<Scalars["Int"]>;
	order_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	triggers?: InputMaybe<NotificationTriggerWhere>;
	triggersAggregate?: InputMaybe<ContractNotificationTriggersAggregateInput>;
	triggersConnection?: InputMaybe<ContractNotificationTriggersConnectionWhere>;
	triggersConnection_NOT?: InputMaybe<ContractNotificationTriggersConnectionWhere>;
	triggers_NOT?: InputMaybe<NotificationTriggerWhere>;
	userEmails?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	userEmails_INCLUDES?: InputMaybe<Scalars["String"]>;
	userEmails_NOT?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	userEmails_NOT_INCLUDES?: InputMaybe<Scalars["String"]>;
};

export type ContractNotificationsInput = {
	detailsUrl: Scalars["String"];
	id: Scalars["ID"];
	notifications: Array<ContractNotificationInput>;
};

export enum ContractPartType {
	Aggregation = "AGGREGATION",
	BasicInfo = "BASIC_INFO",
	DataGuidance = "DATA_GUIDANCE",
	Eligibility = "ELIGIBILITY",
	Measurement = "MEASUREMENT",
	Pricing = "PRICING",
	Treatment = "TREATMENT",
	TreatmentAndOutcome = "TREATMENT_AND_OUTCOME",
}

export enum ContractStatus {
	Approved = "APPROVED",
	Completed = "COMPLETED",
	Draft = "DRAFT",
	InApproval = "IN_APPROVAL",
	Open = "OPEN",
	Pending = "PENDING",
	Rejected = "REJECTED",
	Running = "RUNNING",
	Terminated = "TERMINATED",
}

export type ContractWorkflow = {
	__typename?: "ContractWorkflow";
	organization: Organization;
	organizationConnection: ContractWorkflowOrganizationConnection;
	status?: Maybe<ContractWorkflowStatus>;
	steps: Array<ContractWorkflowStep>;
	stepsAreOrdered: Scalars["Boolean"];
	stepsConnection: ContractWorkflowStepsConnection;
	workflowType: ContractWorkflowType;
};

export type ContractWorkflowOrganizationArgs = {
	options?: InputMaybe<OrganizationOptions>;
	where?: InputMaybe<OrganizationWhere>;
};

export type ContractWorkflowOrganizationConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<ContractWorkflowOrganizationConnectionSort>>;
	where?: InputMaybe<ContractWorkflowOrganizationConnectionWhere>;
};

export type ContractWorkflowStepsArgs = {
	options?: InputMaybe<ContractWorkflowStepOptions>;
	where?: InputMaybe<ContractWorkflowStepWhere>;
};

export type ContractWorkflowStepsConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<ContractWorkflowStepsConnectionSort>>;
	where?: InputMaybe<ContractWorkflowStepsConnectionWhere>;
};

export type ContractWorkflowAggregateSelection = {
	__typename?: "ContractWorkflowAggregateSelection";
	count: Scalars["Int"];
};

export type ContractWorkflowConnectInput = {
	organization?: InputMaybe<ContractWorkflowOrganizationConnectFieldInput>;
	steps?: InputMaybe<Array<ContractWorkflowStepsConnectFieldInput>>;
};

export type ContractWorkflowConnectWhere = {
	node: ContractWorkflowWhere;
};

export type ContractWorkflowCreateInput = {
	organization?: InputMaybe<ContractWorkflowOrganizationFieldInput>;
	status?: InputMaybe<ContractWorkflowStatus>;
	steps?: InputMaybe<ContractWorkflowStepsFieldInput>;
	stepsAreOrdered: Scalars["Boolean"];
	workflowType: ContractWorkflowType;
};

export type ContractWorkflowDeleteInput = {
	organization?: InputMaybe<ContractWorkflowOrganizationDeleteFieldInput>;
	steps?: InputMaybe<Array<ContractWorkflowStepsDeleteFieldInput>>;
};

export type ContractWorkflowDisconnectInput = {
	organization?: InputMaybe<ContractWorkflowOrganizationDisconnectFieldInput>;
	steps?: InputMaybe<Array<ContractWorkflowStepsDisconnectFieldInput>>;
};

export type ContractWorkflowInput = {
	organization: OrganizationInput;
	steps?: InputMaybe<Array<ContractWorkflowStepInput>>;
	stepsAreOrdered: Scalars["Boolean"];
	workflowType: ContractWorkflowType;
};

export type ContractWorkflowOptions = {
	limit?: InputMaybe<Scalars["Int"]>;
	offset?: InputMaybe<Scalars["Int"]>;
	/** Specify one or more ContractWorkflowSort objects to sort ContractWorkflows by. The sorts will be applied in the order in which they are arranged in the array. */
	sort?: InputMaybe<Array<InputMaybe<ContractWorkflowSort>>>;
};

export type ContractWorkflowOrganizationAggregateInput = {
	AND?: InputMaybe<Array<ContractWorkflowOrganizationAggregateInput>>;
	OR?: InputMaybe<Array<ContractWorkflowOrganizationAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<ContractWorkflowOrganizationNodeAggregationWhereInput>;
};

export type ContractWorkflowOrganizationConnectFieldInput = {
	where?: InputMaybe<OrganizationConnectWhere>;
};

export type ContractWorkflowOrganizationConnection = {
	__typename?: "ContractWorkflowOrganizationConnection";
	edges: Array<ContractWorkflowOrganizationRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type ContractWorkflowOrganizationConnectionSort = {
	node?: InputMaybe<OrganizationSort>;
};

export type ContractWorkflowOrganizationConnectionWhere = {
	AND?: InputMaybe<Array<ContractWorkflowOrganizationConnectionWhere>>;
	OR?: InputMaybe<Array<ContractWorkflowOrganizationConnectionWhere>>;
	node?: InputMaybe<OrganizationWhere>;
	node_NOT?: InputMaybe<OrganizationWhere>;
};

export type ContractWorkflowOrganizationCreateFieldInput = {
	node: OrganizationCreateInput;
};

export type ContractWorkflowOrganizationDeleteFieldInput = {
	where?: InputMaybe<ContractWorkflowOrganizationConnectionWhere>;
};

export type ContractWorkflowOrganizationDisconnectFieldInput = {
	where?: InputMaybe<ContractWorkflowOrganizationConnectionWhere>;
};

export type ContractWorkflowOrganizationFieldInput = {
	connect?: InputMaybe<ContractWorkflowOrganizationConnectFieldInput>;
	create?: InputMaybe<ContractWorkflowOrganizationCreateFieldInput>;
};

export type ContractWorkflowOrganizationNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<ContractWorkflowOrganizationNodeAggregationWhereInput>>;
	IBAN_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	IBAN_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	IBAN_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	IBAN_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	IBAN_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	IBAN_EQUAL?: InputMaybe<Scalars["String"]>;
	IBAN_GT?: InputMaybe<Scalars["Int"]>;
	IBAN_GTE?: InputMaybe<Scalars["Int"]>;
	IBAN_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	IBAN_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	IBAN_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	IBAN_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	IBAN_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	IBAN_LT?: InputMaybe<Scalars["Int"]>;
	IBAN_LTE?: InputMaybe<Scalars["Int"]>;
	IBAN_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	IBAN_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	IBAN_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	IBAN_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	IBAN_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	OR?: InputMaybe<Array<ContractWorkflowOrganizationNodeAggregationWhereInput>>;
	billingAddress_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	billingAddress_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	billingAddress_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	billingAddress_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	billingAddress_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	billingAddress_EQUAL?: InputMaybe<Scalars["String"]>;
	billingAddress_GT?: InputMaybe<Scalars["Int"]>;
	billingAddress_GTE?: InputMaybe<Scalars["Int"]>;
	billingAddress_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	billingAddress_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	billingAddress_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	billingAddress_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	billingAddress_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	billingAddress_LT?: InputMaybe<Scalars["Int"]>;
	billingAddress_LTE?: InputMaybe<Scalars["Int"]>;
	billingAddress_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	billingAddress_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	billingAddress_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	billingAddress_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	billingAddress_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	contactEmail_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	contactEmail_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	contactEmail_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	contactEmail_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	contactEmail_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	contactEmail_EQUAL?: InputMaybe<Scalars["String"]>;
	contactEmail_GT?: InputMaybe<Scalars["Int"]>;
	contactEmail_GTE?: InputMaybe<Scalars["Int"]>;
	contactEmail_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	contactEmail_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	contactEmail_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	contactEmail_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	contactEmail_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	contactEmail_LT?: InputMaybe<Scalars["Int"]>;
	contactEmail_LTE?: InputMaybe<Scalars["Int"]>;
	contactEmail_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	contactEmail_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	contactEmail_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	contactEmail_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	contactEmail_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	contactFirstName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	contactFirstName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	contactFirstName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	contactFirstName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	contactFirstName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	contactFirstName_EQUAL?: InputMaybe<Scalars["String"]>;
	contactFirstName_GT?: InputMaybe<Scalars["Int"]>;
	contactFirstName_GTE?: InputMaybe<Scalars["Int"]>;
	contactFirstName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	contactFirstName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	contactFirstName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	contactFirstName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	contactFirstName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	contactFirstName_LT?: InputMaybe<Scalars["Int"]>;
	contactFirstName_LTE?: InputMaybe<Scalars["Int"]>;
	contactFirstName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	contactFirstName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	contactFirstName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	contactFirstName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	contactFirstName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	contactLastName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	contactLastName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	contactLastName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	contactLastName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	contactLastName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	contactLastName_EQUAL?: InputMaybe<Scalars["String"]>;
	contactLastName_GT?: InputMaybe<Scalars["Int"]>;
	contactLastName_GTE?: InputMaybe<Scalars["Int"]>;
	contactLastName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	contactLastName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	contactLastName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	contactLastName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	contactLastName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	contactLastName_LT?: InputMaybe<Scalars["Int"]>;
	contactLastName_LTE?: InputMaybe<Scalars["Int"]>;
	contactLastName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	contactLastName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	contactLastName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	contactLastName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	contactLastName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	contactOccupation_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	contactOccupation_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	contactOccupation_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	contactOccupation_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	contactOccupation_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	contactOccupation_EQUAL?: InputMaybe<Scalars["String"]>;
	contactOccupation_GT?: InputMaybe<Scalars["Int"]>;
	contactOccupation_GTE?: InputMaybe<Scalars["Int"]>;
	contactOccupation_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	contactOccupation_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	contactOccupation_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	contactOccupation_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	contactOccupation_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	contactOccupation_LT?: InputMaybe<Scalars["Int"]>;
	contactOccupation_LTE?: InputMaybe<Scalars["Int"]>;
	contactOccupation_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	contactOccupation_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	contactOccupation_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	contactOccupation_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	contactOccupation_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	contactPhone_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	contactPhone_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	contactPhone_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	contactPhone_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	contactPhone_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	contactPhone_EQUAL?: InputMaybe<Scalars["String"]>;
	contactPhone_GT?: InputMaybe<Scalars["Int"]>;
	contactPhone_GTE?: InputMaybe<Scalars["Int"]>;
	contactPhone_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	contactPhone_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	contactPhone_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	contactPhone_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	contactPhone_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	contactPhone_LT?: InputMaybe<Scalars["Int"]>;
	contactPhone_LTE?: InputMaybe<Scalars["Int"]>;
	contactPhone_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	contactPhone_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	contactPhone_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	contactPhone_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	contactPhone_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	domicile_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	domicile_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	domicile_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	domicile_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	domicile_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	domicile_EQUAL?: InputMaybe<Scalars["String"]>;
	domicile_GT?: InputMaybe<Scalars["Int"]>;
	domicile_GTE?: InputMaybe<Scalars["Int"]>;
	domicile_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	domicile_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	domicile_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	domicile_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	domicile_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	domicile_LT?: InputMaybe<Scalars["Int"]>;
	domicile_LTE?: InputMaybe<Scalars["Int"]>;
	domicile_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	domicile_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	domicile_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	domicile_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	domicile_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	eIN_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	eIN_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	eIN_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	eIN_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	eIN_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	eIN_EQUAL?: InputMaybe<Scalars["String"]>;
	eIN_GT?: InputMaybe<Scalars["Int"]>;
	eIN_GTE?: InputMaybe<Scalars["Int"]>;
	eIN_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	eIN_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	eIN_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	eIN_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	eIN_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	eIN_LT?: InputMaybe<Scalars["Int"]>;
	eIN_LTE?: InputMaybe<Scalars["Int"]>;
	eIN_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	eIN_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	eIN_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	eIN_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	eIN_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	fax_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	fax_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	fax_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	fax_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	fax_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	fax_EQUAL?: InputMaybe<Scalars["String"]>;
	fax_GT?: InputMaybe<Scalars["Int"]>;
	fax_GTE?: InputMaybe<Scalars["Int"]>;
	fax_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	fax_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	fax_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	fax_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	fax_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	fax_LT?: InputMaybe<Scalars["Int"]>;
	fax_LTE?: InputMaybe<Scalars["Int"]>;
	fax_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	fax_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	fax_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	fax_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	fax_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	legalName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	legalName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	legalName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	legalName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	legalName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	legalName_EQUAL?: InputMaybe<Scalars["String"]>;
	legalName_GT?: InputMaybe<Scalars["Int"]>;
	legalName_GTE?: InputMaybe<Scalars["Int"]>;
	legalName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	legalName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	legalName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	legalName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	legalName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	legalName_LT?: InputMaybe<Scalars["Int"]>;
	legalName_LTE?: InputMaybe<Scalars["Int"]>;
	legalName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	legalName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	legalName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	legalName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	legalName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	logo_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	logo_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	logo_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	logo_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	logo_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	logo_EQUAL?: InputMaybe<Scalars["String"]>;
	logo_GT?: InputMaybe<Scalars["Int"]>;
	logo_GTE?: InputMaybe<Scalars["Int"]>;
	logo_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	logo_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	logo_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	logo_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	logo_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	logo_LT?: InputMaybe<Scalars["Int"]>;
	logo_LTE?: InputMaybe<Scalars["Int"]>;
	logo_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	logo_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	logo_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	logo_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	logo_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	name_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	name_EQUAL?: InputMaybe<Scalars["String"]>;
	name_GT?: InputMaybe<Scalars["Int"]>;
	name_GTE?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	name_LT?: InputMaybe<Scalars["Int"]>;
	name_LTE?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	phone_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	phone_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	phone_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	phone_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	phone_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	phone_EQUAL?: InputMaybe<Scalars["String"]>;
	phone_GT?: InputMaybe<Scalars["Int"]>;
	phone_GTE?: InputMaybe<Scalars["Int"]>;
	phone_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	phone_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	phone_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	phone_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	phone_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	phone_LT?: InputMaybe<Scalars["Int"]>;
	phone_LTE?: InputMaybe<Scalars["Int"]>;
	phone_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	phone_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	phone_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	phone_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	phone_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	tenantId_EQUAL?: InputMaybe<Scalars["String"]>;
	tenantId_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	website_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	website_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	website_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	website_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	website_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	website_EQUAL?: InputMaybe<Scalars["String"]>;
	website_GT?: InputMaybe<Scalars["Int"]>;
	website_GTE?: InputMaybe<Scalars["Int"]>;
	website_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	website_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	website_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	website_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	website_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	website_LT?: InputMaybe<Scalars["Int"]>;
	website_LTE?: InputMaybe<Scalars["Int"]>;
	website_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	website_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	website_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	website_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	website_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type ContractWorkflowOrganizationRelationship = {
	__typename?: "ContractWorkflowOrganizationRelationship";
	cursor: Scalars["String"];
	node: Organization;
};

export type ContractWorkflowOrganizationUpdateConnectionInput = {
	node?: InputMaybe<OrganizationUpdateInput>;
};

export type ContractWorkflowOrganizationUpdateFieldInput = {
	connect?: InputMaybe<ContractWorkflowOrganizationConnectFieldInput>;
	create?: InputMaybe<ContractWorkflowOrganizationCreateFieldInput>;
	delete?: InputMaybe<ContractWorkflowOrganizationDeleteFieldInput>;
	disconnect?: InputMaybe<ContractWorkflowOrganizationDisconnectFieldInput>;
	update?: InputMaybe<ContractWorkflowOrganizationUpdateConnectionInput>;
	where?: InputMaybe<ContractWorkflowOrganizationConnectionWhere>;
};

/** Fields to sort ContractWorkflows by. The order in which sorts are applied is not guaranteed when specifying many fields in one ContractWorkflowSort object. */
export type ContractWorkflowSort = {
	status?: InputMaybe<SortDirection>;
	stepsAreOrdered?: InputMaybe<SortDirection>;
	workflowType?: InputMaybe<SortDirection>;
};

export enum ContractWorkflowStatus {
	Approve = "APPROVE",
	Pending = "PENDING",
	Reject = "REJECT",
}

export type ContractWorkflowStep = {
	__typename?: "ContractWorkflowStep";
	contractPartType?: Maybe<ContractPartType>;
	contractWorkflowStepType: ContractWorkflowStepType;
	isAmended: Scalars["Boolean"];
	order: Scalars["Int"];
	responsiblePerson: User;
	responsiblePersonConnection: ContractWorkflowStepResponsiblePersonConnection;
	status?: Maybe<ContractWorkflowStatus>;
	title: Scalars["String"];
};

export type ContractWorkflowStepResponsiblePersonArgs = {
	options?: InputMaybe<UserOptions>;
	where?: InputMaybe<UserWhere>;
};

export type ContractWorkflowStepResponsiblePersonConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<ContractWorkflowStepResponsiblePersonConnectionSort>>;
	where?: InputMaybe<ContractWorkflowStepResponsiblePersonConnectionWhere>;
};

export type ContractWorkflowStepAggregateSelection = {
	__typename?: "ContractWorkflowStepAggregateSelection";
	count: Scalars["Int"];
	order: IntAggregateSelection;
	title: StringAggregateSelection;
};

export type ContractWorkflowStepConnectInput = {
	responsiblePerson?: InputMaybe<ContractWorkflowStepResponsiblePersonConnectFieldInput>;
};

export type ContractWorkflowStepConnectWhere = {
	node: ContractWorkflowStepWhere;
};

export type ContractWorkflowStepCreateInput = {
	contractPartType?: InputMaybe<ContractPartType>;
	contractWorkflowStepType: ContractWorkflowStepType;
	isAmended: Scalars["Boolean"];
	order: Scalars["Int"];
	responsiblePerson?: InputMaybe<ContractWorkflowStepResponsiblePersonFieldInput>;
	status?: InputMaybe<ContractWorkflowStatus>;
	title: Scalars["String"];
};

export type ContractWorkflowStepDeleteInput = {
	responsiblePerson?: InputMaybe<ContractWorkflowStepResponsiblePersonDeleteFieldInput>;
};

export type ContractWorkflowStepDisconnectInput = {
	responsiblePerson?: InputMaybe<ContractWorkflowStepResponsiblePersonDisconnectFieldInput>;
};

export type ContractWorkflowStepInput = {
	contractPartType?: InputMaybe<ContractPartType>;
	contractWorkflowStepType: ContractWorkflowStepType;
	order: Scalars["Int"];
	responsiblePerson: UserInput;
	title: Scalars["String"];
};

export type ContractWorkflowStepOptions = {
	limit?: InputMaybe<Scalars["Int"]>;
	offset?: InputMaybe<Scalars["Int"]>;
	/** Specify one or more ContractWorkflowStepSort objects to sort ContractWorkflowSteps by. The sorts will be applied in the order in which they are arranged in the array. */
	sort?: InputMaybe<Array<InputMaybe<ContractWorkflowStepSort>>>;
};

export type ContractWorkflowStepResponsiblePersonAggregateInput = {
	AND?: InputMaybe<Array<ContractWorkflowStepResponsiblePersonAggregateInput>>;
	OR?: InputMaybe<Array<ContractWorkflowStepResponsiblePersonAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<ContractWorkflowStepResponsiblePersonNodeAggregationWhereInput>;
};

export type ContractWorkflowStepResponsiblePersonConnectFieldInput = {
	connect?: InputMaybe<UserConnectInput>;
	where?: InputMaybe<UserConnectWhere>;
};

export type ContractWorkflowStepResponsiblePersonConnection = {
	__typename?: "ContractWorkflowStepResponsiblePersonConnection";
	edges: Array<ContractWorkflowStepResponsiblePersonRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type ContractWorkflowStepResponsiblePersonConnectionSort = {
	node?: InputMaybe<UserSort>;
};

export type ContractWorkflowStepResponsiblePersonConnectionWhere = {
	AND?: InputMaybe<Array<ContractWorkflowStepResponsiblePersonConnectionWhere>>;
	OR?: InputMaybe<Array<ContractWorkflowStepResponsiblePersonConnectionWhere>>;
	node?: InputMaybe<UserWhere>;
	node_NOT?: InputMaybe<UserWhere>;
};

export type ContractWorkflowStepResponsiblePersonCreateFieldInput = {
	node: UserCreateInput;
};

export type ContractWorkflowStepResponsiblePersonDeleteFieldInput = {
	delete?: InputMaybe<UserDeleteInput>;
	where?: InputMaybe<ContractWorkflowStepResponsiblePersonConnectionWhere>;
};

export type ContractWorkflowStepResponsiblePersonDisconnectFieldInput = {
	disconnect?: InputMaybe<UserDisconnectInput>;
	where?: InputMaybe<ContractWorkflowStepResponsiblePersonConnectionWhere>;
};

export type ContractWorkflowStepResponsiblePersonFieldInput = {
	connect?: InputMaybe<ContractWorkflowStepResponsiblePersonConnectFieldInput>;
	create?: InputMaybe<ContractWorkflowStepResponsiblePersonCreateFieldInput>;
};

export type ContractWorkflowStepResponsiblePersonNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<ContractWorkflowStepResponsiblePersonNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<ContractWorkflowStepResponsiblePersonNodeAggregationWhereInput>>;
	email_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	email_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	email_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	email_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	email_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	email_EQUAL?: InputMaybe<Scalars["String"]>;
	email_GT?: InputMaybe<Scalars["Int"]>;
	email_GTE?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	email_LT?: InputMaybe<Scalars["Int"]>;
	email_LTE?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	firstName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	firstName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	firstName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	firstName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	firstName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	firstName_EQUAL?: InputMaybe<Scalars["String"]>;
	firstName_GT?: InputMaybe<Scalars["Int"]>;
	firstName_GTE?: InputMaybe<Scalars["Int"]>;
	firstName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	firstName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	firstName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	firstName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	firstName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	firstName_LT?: InputMaybe<Scalars["Int"]>;
	firstName_LTE?: InputMaybe<Scalars["Int"]>;
	firstName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	firstName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	firstName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	firstName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	firstName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	lastName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	lastName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	lastName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	lastName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	lastName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	lastName_EQUAL?: InputMaybe<Scalars["String"]>;
	lastName_GT?: InputMaybe<Scalars["Int"]>;
	lastName_GTE?: InputMaybe<Scalars["Int"]>;
	lastName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	lastName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	lastName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	lastName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	lastName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	lastName_LT?: InputMaybe<Scalars["Int"]>;
	lastName_LTE?: InputMaybe<Scalars["Int"]>;
	lastName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	lastName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	lastName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	lastName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	lastName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	preferredLanguage_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	preferredLanguage_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	preferredLanguage_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	preferredLanguage_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	preferredLanguage_EQUAL?: InputMaybe<Scalars["String"]>;
	preferredLanguage_GT?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_GTE?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LT?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LTE?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	tenantId_EQUAL?: InputMaybe<Scalars["String"]>;
	tenantId_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type ContractWorkflowStepResponsiblePersonRelationship = {
	__typename?: "ContractWorkflowStepResponsiblePersonRelationship";
	cursor: Scalars["String"];
	node: User;
};

export type ContractWorkflowStepResponsiblePersonUpdateConnectionInput = {
	node?: InputMaybe<UserUpdateInput>;
};

export type ContractWorkflowStepResponsiblePersonUpdateFieldInput = {
	connect?: InputMaybe<ContractWorkflowStepResponsiblePersonConnectFieldInput>;
	create?: InputMaybe<ContractWorkflowStepResponsiblePersonCreateFieldInput>;
	delete?: InputMaybe<ContractWorkflowStepResponsiblePersonDeleteFieldInput>;
	disconnect?: InputMaybe<ContractWorkflowStepResponsiblePersonDisconnectFieldInput>;
	update?: InputMaybe<ContractWorkflowStepResponsiblePersonUpdateConnectionInput>;
	where?: InputMaybe<ContractWorkflowStepResponsiblePersonConnectionWhere>;
};

/** Fields to sort ContractWorkflowSteps by. The order in which sorts are applied is not guaranteed when specifying many fields in one ContractWorkflowStepSort object. */
export type ContractWorkflowStepSort = {
	contractPartType?: InputMaybe<SortDirection>;
	contractWorkflowStepType?: InputMaybe<SortDirection>;
	isAmended?: InputMaybe<SortDirection>;
	order?: InputMaybe<SortDirection>;
	status?: InputMaybe<SortDirection>;
	title?: InputMaybe<SortDirection>;
};

export enum ContractWorkflowStepType {
	Final = "FINAL",
	Initial = "INITIAL",
}

export type ContractWorkflowStepUpdateInput = {
	contractPartType?: InputMaybe<ContractPartType>;
	contractWorkflowStepType?: InputMaybe<ContractWorkflowStepType>;
	isAmended?: InputMaybe<Scalars["Boolean"]>;
	order?: InputMaybe<Scalars["Int"]>;
	responsiblePerson?: InputMaybe<ContractWorkflowStepResponsiblePersonUpdateFieldInput>;
	status?: InputMaybe<ContractWorkflowStatus>;
	title?: InputMaybe<Scalars["String"]>;
};

export type ContractWorkflowStepWhere = {
	AND?: InputMaybe<Array<ContractWorkflowStepWhere>>;
	OR?: InputMaybe<Array<ContractWorkflowStepWhere>>;
	contractPartType?: InputMaybe<ContractPartType>;
	contractPartType_IN?: InputMaybe<Array<InputMaybe<ContractPartType>>>;
	contractPartType_NOT?: InputMaybe<ContractPartType>;
	contractPartType_NOT_IN?: InputMaybe<Array<InputMaybe<ContractPartType>>>;
	contractWorkflowStepType?: InputMaybe<ContractWorkflowStepType>;
	contractWorkflowStepType_IN?: InputMaybe<Array<InputMaybe<ContractWorkflowStepType>>>;
	contractWorkflowStepType_NOT?: InputMaybe<ContractWorkflowStepType>;
	contractWorkflowStepType_NOT_IN?: InputMaybe<Array<InputMaybe<ContractWorkflowStepType>>>;
	isAmended?: InputMaybe<Scalars["Boolean"]>;
	isAmended_NOT?: InputMaybe<Scalars["Boolean"]>;
	order?: InputMaybe<Scalars["Int"]>;
	order_GT?: InputMaybe<Scalars["Int"]>;
	order_GTE?: InputMaybe<Scalars["Int"]>;
	order_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	order_LT?: InputMaybe<Scalars["Int"]>;
	order_LTE?: InputMaybe<Scalars["Int"]>;
	order_NOT?: InputMaybe<Scalars["Int"]>;
	order_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	responsiblePerson?: InputMaybe<UserWhere>;
	responsiblePersonAggregate?: InputMaybe<ContractWorkflowStepResponsiblePersonAggregateInput>;
	responsiblePersonConnection?: InputMaybe<ContractWorkflowStepResponsiblePersonConnectionWhere>;
	responsiblePersonConnection_NOT?: InputMaybe<ContractWorkflowStepResponsiblePersonConnectionWhere>;
	responsiblePerson_NOT?: InputMaybe<UserWhere>;
	status?: InputMaybe<ContractWorkflowStatus>;
	status_IN?: InputMaybe<Array<InputMaybe<ContractWorkflowStatus>>>;
	status_NOT?: InputMaybe<ContractWorkflowStatus>;
	status_NOT_IN?: InputMaybe<Array<InputMaybe<ContractWorkflowStatus>>>;
	title?: InputMaybe<Scalars["String"]>;
	title_CONTAINS?: InputMaybe<Scalars["String"]>;
	title_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	title_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	title_MATCHES?: InputMaybe<Scalars["String"]>;
	title_NOT?: InputMaybe<Scalars["String"]>;
	title_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	title_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	title_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	title_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	title_STARTS_WITH?: InputMaybe<Scalars["String"]>;
};

export type ContractWorkflowStepsAggregateInput = {
	AND?: InputMaybe<Array<ContractWorkflowStepsAggregateInput>>;
	OR?: InputMaybe<Array<ContractWorkflowStepsAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<ContractWorkflowStepsNodeAggregationWhereInput>;
};

export type ContractWorkflowStepsConnectFieldInput = {
	connect?: InputMaybe<Array<ContractWorkflowStepConnectInput>>;
	where?: InputMaybe<ContractWorkflowStepConnectWhere>;
};

export type ContractWorkflowStepsConnection = {
	__typename?: "ContractWorkflowStepsConnection";
	edges: Array<ContractWorkflowStepsRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type ContractWorkflowStepsConnectionSort = {
	node?: InputMaybe<ContractWorkflowStepSort>;
};

export type ContractWorkflowStepsConnectionWhere = {
	AND?: InputMaybe<Array<ContractWorkflowStepsConnectionWhere>>;
	OR?: InputMaybe<Array<ContractWorkflowStepsConnectionWhere>>;
	node?: InputMaybe<ContractWorkflowStepWhere>;
	node_NOT?: InputMaybe<ContractWorkflowStepWhere>;
};

export type ContractWorkflowStepsCreateFieldInput = {
	node: ContractWorkflowStepCreateInput;
};

export type ContractWorkflowStepsDeleteFieldInput = {
	delete?: InputMaybe<ContractWorkflowStepDeleteInput>;
	where?: InputMaybe<ContractWorkflowStepsConnectionWhere>;
};

export type ContractWorkflowStepsDisconnectFieldInput = {
	disconnect?: InputMaybe<ContractWorkflowStepDisconnectInput>;
	where?: InputMaybe<ContractWorkflowStepsConnectionWhere>;
};

export type ContractWorkflowStepsFieldInput = {
	connect?: InputMaybe<Array<ContractWorkflowStepsConnectFieldInput>>;
	create?: InputMaybe<Array<ContractWorkflowStepsCreateFieldInput>>;
};

export type ContractWorkflowStepsNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<ContractWorkflowStepsNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<ContractWorkflowStepsNodeAggregationWhereInput>>;
	order_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	order_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	order_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	order_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	order_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	order_EQUAL?: InputMaybe<Scalars["Int"]>;
	order_GT?: InputMaybe<Scalars["Int"]>;
	order_GTE?: InputMaybe<Scalars["Int"]>;
	order_LT?: InputMaybe<Scalars["Int"]>;
	order_LTE?: InputMaybe<Scalars["Int"]>;
	order_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	order_MAX_GT?: InputMaybe<Scalars["Int"]>;
	order_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	order_MAX_LT?: InputMaybe<Scalars["Int"]>;
	order_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	order_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	order_MIN_GT?: InputMaybe<Scalars["Int"]>;
	order_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	order_MIN_LT?: InputMaybe<Scalars["Int"]>;
	order_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	title_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	title_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	title_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	title_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	title_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	title_EQUAL?: InputMaybe<Scalars["String"]>;
	title_GT?: InputMaybe<Scalars["Int"]>;
	title_GTE?: InputMaybe<Scalars["Int"]>;
	title_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	title_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	title_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	title_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	title_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	title_LT?: InputMaybe<Scalars["Int"]>;
	title_LTE?: InputMaybe<Scalars["Int"]>;
	title_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	title_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	title_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	title_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	title_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type ContractWorkflowStepsRelationship = {
	__typename?: "ContractWorkflowStepsRelationship";
	cursor: Scalars["String"];
	node: ContractWorkflowStep;
};

export type ContractWorkflowStepsUpdateConnectionInput = {
	node?: InputMaybe<ContractWorkflowStepUpdateInput>;
};

export type ContractWorkflowStepsUpdateFieldInput = {
	connect?: InputMaybe<Array<ContractWorkflowStepsConnectFieldInput>>;
	create?: InputMaybe<Array<ContractWorkflowStepsCreateFieldInput>>;
	delete?: InputMaybe<Array<ContractWorkflowStepsDeleteFieldInput>>;
	disconnect?: InputMaybe<Array<ContractWorkflowStepsDisconnectFieldInput>>;
	update?: InputMaybe<ContractWorkflowStepsUpdateConnectionInput>;
	where?: InputMaybe<ContractWorkflowStepsConnectionWhere>;
};

export enum ContractWorkflowType {
	Approval = "APPROVAL",
	Termination = "TERMINATION",
}

export type ContractWorkflowUpdateInput = {
	organization?: InputMaybe<ContractWorkflowOrganizationUpdateFieldInput>;
	status?: InputMaybe<ContractWorkflowStatus>;
	steps?: InputMaybe<Array<ContractWorkflowStepsUpdateFieldInput>>;
	stepsAreOrdered?: InputMaybe<Scalars["Boolean"]>;
	workflowType?: InputMaybe<ContractWorkflowType>;
};

export type ContractWorkflowWhere = {
	AND?: InputMaybe<Array<ContractWorkflowWhere>>;
	OR?: InputMaybe<Array<ContractWorkflowWhere>>;
	organization?: InputMaybe<OrganizationWhere>;
	organizationAggregate?: InputMaybe<ContractWorkflowOrganizationAggregateInput>;
	organizationConnection?: InputMaybe<ContractWorkflowOrganizationConnectionWhere>;
	organizationConnection_NOT?: InputMaybe<ContractWorkflowOrganizationConnectionWhere>;
	organization_NOT?: InputMaybe<OrganizationWhere>;
	status?: InputMaybe<ContractWorkflowStatus>;
	status_IN?: InputMaybe<Array<InputMaybe<ContractWorkflowStatus>>>;
	status_NOT?: InputMaybe<ContractWorkflowStatus>;
	status_NOT_IN?: InputMaybe<Array<InputMaybe<ContractWorkflowStatus>>>;
	steps?: InputMaybe<ContractWorkflowStepWhere>;
	stepsAggregate?: InputMaybe<ContractWorkflowStepsAggregateInput>;
	stepsAreOrdered?: InputMaybe<Scalars["Boolean"]>;
	stepsAreOrdered_NOT?: InputMaybe<Scalars["Boolean"]>;
	stepsConnection?: InputMaybe<ContractWorkflowStepsConnectionWhere>;
	stepsConnection_NOT?: InputMaybe<ContractWorkflowStepsConnectionWhere>;
	steps_NOT?: InputMaybe<ContractWorkflowStepWhere>;
	workflowType?: InputMaybe<ContractWorkflowType>;
	workflowType_IN?: InputMaybe<Array<InputMaybe<ContractWorkflowType>>>;
	workflowType_NOT?: InputMaybe<ContractWorkflowType>;
	workflowType_NOT_IN?: InputMaybe<Array<InputMaybe<ContractWorkflowType>>>;
};

export enum CounterpartyRole {
	Buyer = "BUYER",
	Observer = "OBSERVER",
	Seller = "SELLER",
}

export type CounterpartyRoleRelationship = {
	role: CounterpartyRole;
};

export type CounterpartyRoleRelationshipCreateInput = {
	role: CounterpartyRole;
};

export type CounterpartyRoleRelationshipSort = {
	role?: InputMaybe<SortDirection>;
};

export type CounterpartyRoleRelationshipUpdateInput = {
	role?: InputMaybe<CounterpartyRole>;
};

export type CounterpartyRoleRelationshipWhere = {
	AND?: InputMaybe<Array<CounterpartyRoleRelationshipWhere>>;
	OR?: InputMaybe<Array<CounterpartyRoleRelationshipWhere>>;
	role?: InputMaybe<CounterpartyRole>;
	role_IN?: InputMaybe<Array<InputMaybe<CounterpartyRole>>>;
	role_NOT?: InputMaybe<CounterpartyRole>;
	role_NOT_IN?: InputMaybe<Array<InputMaybe<CounterpartyRole>>>;
};

export type CoverageRequest = {
	__typename?: "CoverageRequest";
	canBeDeleted?: Maybe<Scalars["Boolean"]>;
	case?: Maybe<Case>;
	caseConnection: CoverageRequestCaseConnection;
	continuousBenefits: Array<ContinuousBenefit>;
	continuousBenefitsWithDrafts: Array<ContinuousBenefit>;
	continuousBenefitsWithDraftsConnection: CoverageRequestContinuousBenefitsWithDraftsConnection;
	coverageEndDate?: Maybe<Scalars["Date"]>;
	coverageStartDate?: Maybe<Scalars["Date"]>;
	createdBy: User;
	createdByConnection: CoverageRequestCreatedByConnection;
	createdOn: Scalars["DateTime"];
	decisionCommunicatedOn?: Maybe<Scalars["Date"]>;
	discontinuationNote?: Maybe<DiscontinuationNote>;
	discontinuationNoteConnection: CoverageRequestDiscontinuationNoteConnection;
	disease: Disease;
	diseaseConnection: CoverageRequestDiseaseConnection;
	duration?: Maybe<Scalars["Int"]>;
	durationUom?: Maybe<DurationUom>;
	financialDataPoints: Array<FinancialDataPoint>;
	financialDataPointsConnection: CoverageRequestFinancialDataPointsConnection;
	form?: Maybe<Form>;
	formConnection: CoverageRequestFormConnection;
	id: Scalars["ID"];
	indication: Indication;
	indicationConnection: CoverageRequestIndicationConnection;
	initialResponse?: Maybe<InitialResponse>;
	initialResponseConnection: CoverageRequestInitialResponseConnection;
	intendedStartDate?: Maybe<Scalars["Date"]>;
	isArchived: Scalars["Boolean"];
	isDeleted: Scalars["Boolean"];
	isPatientEnrolledInTreatment: Scalars["Boolean"];
	lastPrescriptionDate?: Maybe<Scalars["String"]>;
	lastUpdatedOn?: Maybe<Scalars["DateTime"]>;
	legalEntity?: Maybe<Organization>;
	legalEntityConnection: CoverageRequestLegalEntityConnection;
	patient?: Maybe<Patient>;
	patientConnection: CoverageRequestPatientConnection;
	preparations: Array<Preparation>;
	preparationsConnection: CoverageRequestPreparationsConnection;
	rating?: Maybe<CoverageRequestRating>;
	requestReceiptDate: Scalars["Date"];
	status: FormStatus;
	submissionDate?: Maybe<Scalars["DateTime"]>;
	tenantId: Scalars["String"];
	therapyDecision?: Maybe<CoverageRequestTherapyDecision>;
	treatingPhysician?: Maybe<TreatingPhysician>;
	treatingPhysicianConnection: CoverageRequestTreatingPhysicianConnection;
	unsortedContinuousBenefits: Array<ContinuousBenefit>;
	unsortedContinuousBenefitsConnection: CoverageRequestUnsortedContinuousBenefitsConnection;
};

export type CoverageRequestCaseArgs = {
	options?: InputMaybe<CaseOptions>;
	where?: InputMaybe<CaseWhere>;
};

export type CoverageRequestCaseConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<CoverageRequestCaseConnectionSort>>;
	where?: InputMaybe<CoverageRequestCaseConnectionWhere>;
};

export type CoverageRequestContinuousBenefitsWithDraftsArgs = {
	options?: InputMaybe<ContinuousBenefitOptions>;
	where?: InputMaybe<ContinuousBenefitWhere>;
};

export type CoverageRequestContinuousBenefitsWithDraftsConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<CoverageRequestContinuousBenefitsWithDraftsConnectionSort>>;
	where?: InputMaybe<CoverageRequestContinuousBenefitsWithDraftsConnectionWhere>;
};

export type CoverageRequestCreatedByArgs = {
	options?: InputMaybe<UserOptions>;
	where?: InputMaybe<UserWhere>;
};

export type CoverageRequestCreatedByConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<CoverageRequestCreatedByConnectionSort>>;
	where?: InputMaybe<CoverageRequestCreatedByConnectionWhere>;
};

export type CoverageRequestDiscontinuationNoteArgs = {
	options?: InputMaybe<DiscontinuationNoteOptions>;
	where?: InputMaybe<DiscontinuationNoteWhere>;
};

export type CoverageRequestDiscontinuationNoteConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<CoverageRequestDiscontinuationNoteConnectionSort>>;
	where?: InputMaybe<CoverageRequestDiscontinuationNoteConnectionWhere>;
};

export type CoverageRequestDiseaseArgs = {
	options?: InputMaybe<DiseaseOptions>;
	where?: InputMaybe<DiseaseWhere>;
};

export type CoverageRequestDiseaseConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<CoverageRequestDiseaseConnectionSort>>;
	where?: InputMaybe<CoverageRequestDiseaseConnectionWhere>;
};

export type CoverageRequestFinancialDataPointsArgs = {
	options?: InputMaybe<FinancialDataPointOptions>;
	where?: InputMaybe<FinancialDataPointWhere>;
};

export type CoverageRequestFinancialDataPointsConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<CoverageRequestFinancialDataPointsConnectionSort>>;
	where?: InputMaybe<CoverageRequestFinancialDataPointsConnectionWhere>;
};

export type CoverageRequestFormArgs = {
	options?: InputMaybe<FormOptions>;
	where?: InputMaybe<FormWhere>;
};

export type CoverageRequestFormConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<CoverageRequestFormConnectionSort>>;
	where?: InputMaybe<CoverageRequestFormConnectionWhere>;
};

export type CoverageRequestIndicationArgs = {
	options?: InputMaybe<IndicationOptions>;
	where?: InputMaybe<IndicationWhere>;
};

export type CoverageRequestIndicationConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<CoverageRequestIndicationConnectionSort>>;
	where?: InputMaybe<CoverageRequestIndicationConnectionWhere>;
};

export type CoverageRequestInitialResponseArgs = {
	options?: InputMaybe<InitialResponseOptions>;
	where?: InputMaybe<InitialResponseWhere>;
};

export type CoverageRequestInitialResponseConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<CoverageRequestInitialResponseConnectionSort>>;
	where?: InputMaybe<CoverageRequestInitialResponseConnectionWhere>;
};

export type CoverageRequestLegalEntityArgs = {
	options?: InputMaybe<OrganizationOptions>;
	where?: InputMaybe<OrganizationWhere>;
};

export type CoverageRequestLegalEntityConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<CoverageRequestLegalEntityConnectionSort>>;
	where?: InputMaybe<CoverageRequestLegalEntityConnectionWhere>;
};

export type CoverageRequestPatientArgs = {
	options?: InputMaybe<PatientOptions>;
	where?: InputMaybe<PatientWhere>;
};

export type CoverageRequestPatientConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<CoverageRequestPatientConnectionSort>>;
	where?: InputMaybe<CoverageRequestPatientConnectionWhere>;
};

export type CoverageRequestPreparationsArgs = {
	options?: InputMaybe<PreparationOptions>;
	where?: InputMaybe<PreparationWhere>;
};

export type CoverageRequestPreparationsConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<CoverageRequestPreparationsConnectionSort>>;
	where?: InputMaybe<CoverageRequestPreparationsConnectionWhere>;
};

export type CoverageRequestTreatingPhysicianArgs = {
	options?: InputMaybe<TreatingPhysicianOptions>;
	where?: InputMaybe<TreatingPhysicianWhere>;
};

export type CoverageRequestTreatingPhysicianConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<CoverageRequestTreatingPhysicianConnectionSort>>;
	where?: InputMaybe<CoverageRequestTreatingPhysicianConnectionWhere>;
};

export type CoverageRequestUnsortedContinuousBenefitsArgs = {
	options?: InputMaybe<ContinuousBenefitOptions>;
	where?: InputMaybe<ContinuousBenefitWhere>;
};

export type CoverageRequestUnsortedContinuousBenefitsConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<CoverageRequestUnsortedContinuousBenefitsConnectionSort>>;
	where?: InputMaybe<CoverageRequestUnsortedContinuousBenefitsConnectionWhere>;
};

export type CoverageRequestAggregateSelection = {
	__typename?: "CoverageRequestAggregateSelection";
	count: Scalars["Int"];
	createdOn: DateTimeAggregateSelection;
	duration: IntAggregateSelection;
	id: IdAggregateSelection;
	lastUpdatedOn: DateTimeAggregateSelection;
	submissionDate: DateTimeAggregateSelection;
	tenantId: StringAggregateSelection;
};

export type CoverageRequestCaseAggregateInput = {
	AND?: InputMaybe<Array<CoverageRequestCaseAggregateInput>>;
	OR?: InputMaybe<Array<CoverageRequestCaseAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<CoverageRequestCaseNodeAggregationWhereInput>;
};

export type CoverageRequestCaseConnectFieldInput = {
	connect?: InputMaybe<CaseConnectInput>;
	where?: InputMaybe<CaseConnectWhere>;
};

export type CoverageRequestCaseConnection = {
	__typename?: "CoverageRequestCaseConnection";
	edges: Array<CoverageRequestCaseRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type CoverageRequestCaseConnectionSort = {
	node?: InputMaybe<CaseSort>;
};

export type CoverageRequestCaseConnectionWhere = {
	AND?: InputMaybe<Array<CoverageRequestCaseConnectionWhere>>;
	OR?: InputMaybe<Array<CoverageRequestCaseConnectionWhere>>;
	node?: InputMaybe<CaseWhere>;
	node_NOT?: InputMaybe<CaseWhere>;
};

export type CoverageRequestCaseCreateFieldInput = {
	node: CaseCreateInput;
};

export type CoverageRequestCaseDeleteFieldInput = {
	delete?: InputMaybe<CaseDeleteInput>;
	where?: InputMaybe<CoverageRequestCaseConnectionWhere>;
};

export type CoverageRequestCaseDisconnectFieldInput = {
	disconnect?: InputMaybe<CaseDisconnectInput>;
	where?: InputMaybe<CoverageRequestCaseConnectionWhere>;
};

export type CoverageRequestCaseFieldInput = {
	connect?: InputMaybe<CoverageRequestCaseConnectFieldInput>;
	create?: InputMaybe<CoverageRequestCaseCreateFieldInput>;
};

export type CoverageRequestCaseNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<CoverageRequestCaseNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<CoverageRequestCaseNodeAggregationWhereInput>>;
	actualAgreementId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	actualAgreementId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	actualAgreementId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	actualAgreementId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	actualAgreementId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	actualAgreementId_EQUAL?: InputMaybe<Scalars["String"]>;
	actualAgreementId_GT?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_GTE?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_LT?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_LTE?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	agreementName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	agreementName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	agreementName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	agreementName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	agreementName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	agreementName_EQUAL?: InputMaybe<Scalars["String"]>;
	agreementName_GT?: InputMaybe<Scalars["Int"]>;
	agreementName_GTE?: InputMaybe<Scalars["Int"]>;
	agreementName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	agreementName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	agreementName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	agreementName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	agreementName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	agreementName_LT?: InputMaybe<Scalars["Int"]>;
	agreementName_LTE?: InputMaybe<Scalars["Int"]>;
	agreementName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	agreementName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	agreementName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	agreementName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	agreementName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	patientInitials_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	patientInitials_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	patientInitials_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	patientInitials_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	patientInitials_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	patientInitials_EQUAL?: InputMaybe<Scalars["String"]>;
	patientInitials_GT?: InputMaybe<Scalars["Int"]>;
	patientInitials_GTE?: InputMaybe<Scalars["Int"]>;
	patientInitials_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	patientInitials_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	patientInitials_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	patientInitials_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	patientInitials_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	patientInitials_LT?: InputMaybe<Scalars["Int"]>;
	patientInitials_LTE?: InputMaybe<Scalars["Int"]>;
	patientInitials_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	patientInitials_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	patientInitials_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	patientInitials_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	patientInitials_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	patientInsuranceId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	patientInsuranceId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	patientInsuranceId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	patientInsuranceId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	patientInsuranceId_EQUAL?: InputMaybe<Scalars["String"]>;
	patientInsuranceId_GT?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_GTE?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_LT?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_LTE?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationBandName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	preparationBandName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	preparationBandName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	preparationBandName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	preparationBandName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	preparationBandName_EQUAL?: InputMaybe<Scalars["String"]>;
	preparationBandName_GT?: InputMaybe<Scalars["Int"]>;
	preparationBandName_GTE?: InputMaybe<Scalars["Int"]>;
	preparationBandName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationBandName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationBandName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationBandName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationBandName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationBandName_LT?: InputMaybe<Scalars["Int"]>;
	preparationBandName_LTE?: InputMaybe<Scalars["Int"]>;
	preparationBandName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationBandName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationBandName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationBandName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationBandName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	preparationGenericName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	preparationGenericName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	preparationGenericName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	preparationGenericName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	preparationGenericName_EQUAL?: InputMaybe<Scalars["String"]>;
	preparationGenericName_GT?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_GTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_LT?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_LTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	sourceTenantId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	sourceTenantId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	sourceTenantId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	sourceTenantId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	sourceTenantId_EQUAL?: InputMaybe<Scalars["String"]>;
	sourceTenantId_GT?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_GTE?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_LT?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_LTE?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	submissionDate_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_GT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_GTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_LT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_LTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	totalAmount_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	totalAmount_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	totalAmount_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	totalAmount_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	totalAmount_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	totalAmount_EQUAL?: InputMaybe<Scalars["Float"]>;
	totalAmount_GT?: InputMaybe<Scalars["Float"]>;
	totalAmount_GTE?: InputMaybe<Scalars["Float"]>;
	totalAmount_LT?: InputMaybe<Scalars["Float"]>;
	totalAmount_LTE?: InputMaybe<Scalars["Float"]>;
	totalAmount_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	totalAmount_MAX_GT?: InputMaybe<Scalars["Float"]>;
	totalAmount_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	totalAmount_MAX_LT?: InputMaybe<Scalars["Float"]>;
	totalAmount_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	totalAmount_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	totalAmount_MIN_GT?: InputMaybe<Scalars["Float"]>;
	totalAmount_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	totalAmount_MIN_LT?: InputMaybe<Scalars["Float"]>;
	totalAmount_MIN_LTE?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	unlimited_EQUAL?: InputMaybe<Scalars["Int"]>;
	unlimited_GT?: InputMaybe<Scalars["Int"]>;
	unlimited_GTE?: InputMaybe<Scalars["Int"]>;
	unlimited_LT?: InputMaybe<Scalars["Int"]>;
	unlimited_LTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_GT?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_LT?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_GT?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_LT?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_LTE?: InputMaybe<Scalars["Int"]>;
};

export type CoverageRequestCaseRelationship = {
	__typename?: "CoverageRequestCaseRelationship";
	cursor: Scalars["String"];
	node: Case;
};

export type CoverageRequestCaseUpdateConnectionInput = {
	node?: InputMaybe<CaseUpdateInput>;
};

export type CoverageRequestCaseUpdateFieldInput = {
	connect?: InputMaybe<CoverageRequestCaseConnectFieldInput>;
	create?: InputMaybe<CoverageRequestCaseCreateFieldInput>;
	delete?: InputMaybe<CoverageRequestCaseDeleteFieldInput>;
	disconnect?: InputMaybe<CoverageRequestCaseDisconnectFieldInput>;
	update?: InputMaybe<CoverageRequestCaseUpdateConnectionInput>;
	where?: InputMaybe<CoverageRequestCaseConnectionWhere>;
};

export type CoverageRequestConnectInput = {
	case?: InputMaybe<CoverageRequestCaseConnectFieldInput>;
	continuousBenefitsWithDrafts?: InputMaybe<Array<CoverageRequestContinuousBenefitsWithDraftsConnectFieldInput>>;
	createdBy?: InputMaybe<CoverageRequestCreatedByConnectFieldInput>;
	discontinuationNote?: InputMaybe<CoverageRequestDiscontinuationNoteConnectFieldInput>;
	disease?: InputMaybe<CoverageRequestDiseaseConnectFieldInput>;
	financialDataPoints?: InputMaybe<Array<CoverageRequestFinancialDataPointsConnectFieldInput>>;
	form?: InputMaybe<CoverageRequestFormConnectFieldInput>;
	indication?: InputMaybe<CoverageRequestIndicationConnectFieldInput>;
	initialResponse?: InputMaybe<CoverageRequestInitialResponseConnectFieldInput>;
	legalEntity?: InputMaybe<CoverageRequestLegalEntityConnectFieldInput>;
	patient?: InputMaybe<CoverageRequestPatientConnectFieldInput>;
	preparations?: InputMaybe<Array<CoverageRequestPreparationsConnectFieldInput>>;
	treatingPhysician?: InputMaybe<CoverageRequestTreatingPhysicianConnectFieldInput>;
	unsortedContinuousBenefits?: InputMaybe<Array<CoverageRequestUnsortedContinuousBenefitsConnectFieldInput>>;
};

export type CoverageRequestConnectWhere = {
	node: CoverageRequestWhere;
};

export type CoverageRequestContinuousBenefitsWithDraftsAggregateInput = {
	AND?: InputMaybe<Array<CoverageRequestContinuousBenefitsWithDraftsAggregateInput>>;
	OR?: InputMaybe<Array<CoverageRequestContinuousBenefitsWithDraftsAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<CoverageRequestContinuousBenefitsWithDraftsNodeAggregationWhereInput>;
};

export type CoverageRequestContinuousBenefitsWithDraftsConnectFieldInput = {
	connect?: InputMaybe<Array<ContinuousBenefitConnectInput>>;
	where?: InputMaybe<ContinuousBenefitConnectWhere>;
};

export type CoverageRequestContinuousBenefitsWithDraftsConnection = {
	__typename?: "CoverageRequestContinuousBenefitsWithDraftsConnection";
	edges: Array<CoverageRequestContinuousBenefitsWithDraftsRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type CoverageRequestContinuousBenefitsWithDraftsConnectionSort = {
	node?: InputMaybe<ContinuousBenefitSort>;
};

export type CoverageRequestContinuousBenefitsWithDraftsConnectionWhere = {
	AND?: InputMaybe<Array<CoverageRequestContinuousBenefitsWithDraftsConnectionWhere>>;
	OR?: InputMaybe<Array<CoverageRequestContinuousBenefitsWithDraftsConnectionWhere>>;
	node?: InputMaybe<ContinuousBenefitWhere>;
	node_NOT?: InputMaybe<ContinuousBenefitWhere>;
};

export type CoverageRequestContinuousBenefitsWithDraftsCreateFieldInput = {
	node: ContinuousBenefitCreateInput;
};

export type CoverageRequestContinuousBenefitsWithDraftsDeleteFieldInput = {
	delete?: InputMaybe<ContinuousBenefitDeleteInput>;
	where?: InputMaybe<CoverageRequestContinuousBenefitsWithDraftsConnectionWhere>;
};

export type CoverageRequestContinuousBenefitsWithDraftsDisconnectFieldInput = {
	disconnect?: InputMaybe<ContinuousBenefitDisconnectInput>;
	where?: InputMaybe<CoverageRequestContinuousBenefitsWithDraftsConnectionWhere>;
};

export type CoverageRequestContinuousBenefitsWithDraftsFieldInput = {
	connect?: InputMaybe<Array<CoverageRequestContinuousBenefitsWithDraftsConnectFieldInput>>;
	create?: InputMaybe<Array<CoverageRequestContinuousBenefitsWithDraftsCreateFieldInput>>;
};

export type CoverageRequestContinuousBenefitsWithDraftsNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<CoverageRequestContinuousBenefitsWithDraftsNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<CoverageRequestContinuousBenefitsWithDraftsNodeAggregationWhereInput>>;
	createdOn_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	submissionDate_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_GT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_GTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_LT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_LTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	tenantId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	tenantId_EQUAL?: InputMaybe<Scalars["String"]>;
	tenantId_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type CoverageRequestContinuousBenefitsWithDraftsRelationship = {
	__typename?: "CoverageRequestContinuousBenefitsWithDraftsRelationship";
	cursor: Scalars["String"];
	node: ContinuousBenefit;
};

export type CoverageRequestContinuousBenefitsWithDraftsUpdateConnectionInput = {
	node?: InputMaybe<ContinuousBenefitUpdateInput>;
};

export type CoverageRequestContinuousBenefitsWithDraftsUpdateFieldInput = {
	connect?: InputMaybe<Array<CoverageRequestContinuousBenefitsWithDraftsConnectFieldInput>>;
	create?: InputMaybe<Array<CoverageRequestContinuousBenefitsWithDraftsCreateFieldInput>>;
	delete?: InputMaybe<Array<CoverageRequestContinuousBenefitsWithDraftsDeleteFieldInput>>;
	disconnect?: InputMaybe<Array<CoverageRequestContinuousBenefitsWithDraftsDisconnectFieldInput>>;
	update?: InputMaybe<CoverageRequestContinuousBenefitsWithDraftsUpdateConnectionInput>;
	where?: InputMaybe<CoverageRequestContinuousBenefitsWithDraftsConnectionWhere>;
};

export type CoverageRequestCreateInput = {
	canBeDeleted?: InputMaybe<Scalars["Boolean"]>;
	case?: InputMaybe<CoverageRequestCaseFieldInput>;
	continuousBenefitsWithDrafts?: InputMaybe<CoverageRequestContinuousBenefitsWithDraftsFieldInput>;
	coverageEndDate?: InputMaybe<Scalars["Date"]>;
	coverageStartDate?: InputMaybe<Scalars["Date"]>;
	createdBy?: InputMaybe<CoverageRequestCreatedByFieldInput>;
	createdOn: Scalars["DateTime"];
	decisionCommunicatedOn?: InputMaybe<Scalars["Date"]>;
	discontinuationNote?: InputMaybe<CoverageRequestDiscontinuationNoteFieldInput>;
	disease?: InputMaybe<CoverageRequestDiseaseFieldInput>;
	duration?: InputMaybe<Scalars["Int"]>;
	durationUom?: InputMaybe<DurationUom>;
	financialDataPoints?: InputMaybe<CoverageRequestFinancialDataPointsFieldInput>;
	form?: InputMaybe<CoverageRequestFormFieldInput>;
	id: Scalars["ID"];
	indication?: InputMaybe<CoverageRequestIndicationFieldInput>;
	initialResponse?: InputMaybe<CoverageRequestInitialResponseFieldInput>;
	intendedStartDate?: InputMaybe<Scalars["Date"]>;
	isArchived: Scalars["Boolean"];
	isDeleted: Scalars["Boolean"];
	lastUpdatedOn?: InputMaybe<Scalars["DateTime"]>;
	legalEntity?: InputMaybe<CoverageRequestLegalEntityFieldInput>;
	patient?: InputMaybe<CoverageRequestPatientFieldInput>;
	preparations?: InputMaybe<CoverageRequestPreparationsFieldInput>;
	rating?: InputMaybe<CoverageRequestRating>;
	requestReceiptDate: Scalars["Date"];
	status: FormStatus;
	submissionDate?: InputMaybe<Scalars["DateTime"]>;
	tenantId: Scalars["String"];
	therapyDecision?: InputMaybe<CoverageRequestTherapyDecision>;
	treatingPhysician?: InputMaybe<CoverageRequestTreatingPhysicianFieldInput>;
	unsortedContinuousBenefits?: InputMaybe<CoverageRequestUnsortedContinuousBenefitsFieldInput>;
};

export type CoverageRequestCreatedByAggregateInput = {
	AND?: InputMaybe<Array<CoverageRequestCreatedByAggregateInput>>;
	OR?: InputMaybe<Array<CoverageRequestCreatedByAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<CoverageRequestCreatedByNodeAggregationWhereInput>;
};

export type CoverageRequestCreatedByConnectFieldInput = {
	connect?: InputMaybe<UserConnectInput>;
	where?: InputMaybe<UserConnectWhere>;
};

export type CoverageRequestCreatedByConnection = {
	__typename?: "CoverageRequestCreatedByConnection";
	edges: Array<CoverageRequestCreatedByRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type CoverageRequestCreatedByConnectionSort = {
	node?: InputMaybe<UserSort>;
};

export type CoverageRequestCreatedByConnectionWhere = {
	AND?: InputMaybe<Array<CoverageRequestCreatedByConnectionWhere>>;
	OR?: InputMaybe<Array<CoverageRequestCreatedByConnectionWhere>>;
	node?: InputMaybe<UserWhere>;
	node_NOT?: InputMaybe<UserWhere>;
};

export type CoverageRequestCreatedByCreateFieldInput = {
	node: UserCreateInput;
};

export type CoverageRequestCreatedByDeleteFieldInput = {
	delete?: InputMaybe<UserDeleteInput>;
	where?: InputMaybe<CoverageRequestCreatedByConnectionWhere>;
};

export type CoverageRequestCreatedByDisconnectFieldInput = {
	disconnect?: InputMaybe<UserDisconnectInput>;
	where?: InputMaybe<CoverageRequestCreatedByConnectionWhere>;
};

export type CoverageRequestCreatedByFieldInput = {
	connect?: InputMaybe<CoverageRequestCreatedByConnectFieldInput>;
	create?: InputMaybe<CoverageRequestCreatedByCreateFieldInput>;
};

export type CoverageRequestCreatedByNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<CoverageRequestCreatedByNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<CoverageRequestCreatedByNodeAggregationWhereInput>>;
	email_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	email_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	email_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	email_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	email_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	email_EQUAL?: InputMaybe<Scalars["String"]>;
	email_GT?: InputMaybe<Scalars["Int"]>;
	email_GTE?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	email_LT?: InputMaybe<Scalars["Int"]>;
	email_LTE?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	firstName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	firstName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	firstName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	firstName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	firstName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	firstName_EQUAL?: InputMaybe<Scalars["String"]>;
	firstName_GT?: InputMaybe<Scalars["Int"]>;
	firstName_GTE?: InputMaybe<Scalars["Int"]>;
	firstName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	firstName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	firstName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	firstName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	firstName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	firstName_LT?: InputMaybe<Scalars["Int"]>;
	firstName_LTE?: InputMaybe<Scalars["Int"]>;
	firstName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	firstName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	firstName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	firstName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	firstName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	lastName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	lastName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	lastName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	lastName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	lastName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	lastName_EQUAL?: InputMaybe<Scalars["String"]>;
	lastName_GT?: InputMaybe<Scalars["Int"]>;
	lastName_GTE?: InputMaybe<Scalars["Int"]>;
	lastName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	lastName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	lastName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	lastName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	lastName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	lastName_LT?: InputMaybe<Scalars["Int"]>;
	lastName_LTE?: InputMaybe<Scalars["Int"]>;
	lastName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	lastName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	lastName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	lastName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	lastName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	preferredLanguage_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	preferredLanguage_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	preferredLanguage_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	preferredLanguage_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	preferredLanguage_EQUAL?: InputMaybe<Scalars["String"]>;
	preferredLanguage_GT?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_GTE?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LT?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LTE?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	tenantId_EQUAL?: InputMaybe<Scalars["String"]>;
	tenantId_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type CoverageRequestCreatedByRelationship = {
	__typename?: "CoverageRequestCreatedByRelationship";
	cursor: Scalars["String"];
	node: User;
};

export type CoverageRequestCreatedByUpdateConnectionInput = {
	node?: InputMaybe<UserUpdateInput>;
};

export type CoverageRequestCreatedByUpdateFieldInput = {
	connect?: InputMaybe<CoverageRequestCreatedByConnectFieldInput>;
	create?: InputMaybe<CoverageRequestCreatedByCreateFieldInput>;
	delete?: InputMaybe<CoverageRequestCreatedByDeleteFieldInput>;
	disconnect?: InputMaybe<CoverageRequestCreatedByDisconnectFieldInput>;
	update?: InputMaybe<CoverageRequestCreatedByUpdateConnectionInput>;
	where?: InputMaybe<CoverageRequestCreatedByConnectionWhere>;
};

export type CoverageRequestDeleteInput = {
	case?: InputMaybe<CoverageRequestCaseDeleteFieldInput>;
	continuousBenefitsWithDrafts?: InputMaybe<Array<CoverageRequestContinuousBenefitsWithDraftsDeleteFieldInput>>;
	createdBy?: InputMaybe<CoverageRequestCreatedByDeleteFieldInput>;
	discontinuationNote?: InputMaybe<CoverageRequestDiscontinuationNoteDeleteFieldInput>;
	disease?: InputMaybe<CoverageRequestDiseaseDeleteFieldInput>;
	financialDataPoints?: InputMaybe<Array<CoverageRequestFinancialDataPointsDeleteFieldInput>>;
	form?: InputMaybe<CoverageRequestFormDeleteFieldInput>;
	indication?: InputMaybe<CoverageRequestIndicationDeleteFieldInput>;
	initialResponse?: InputMaybe<CoverageRequestInitialResponseDeleteFieldInput>;
	legalEntity?: InputMaybe<CoverageRequestLegalEntityDeleteFieldInput>;
	patient?: InputMaybe<CoverageRequestPatientDeleteFieldInput>;
	preparations?: InputMaybe<Array<CoverageRequestPreparationsDeleteFieldInput>>;
	treatingPhysician?: InputMaybe<CoverageRequestTreatingPhysicianDeleteFieldInput>;
	unsortedContinuousBenefits?: InputMaybe<Array<CoverageRequestUnsortedContinuousBenefitsDeleteFieldInput>>;
};

export type CoverageRequestDisconnectInput = {
	case?: InputMaybe<CoverageRequestCaseDisconnectFieldInput>;
	continuousBenefitsWithDrafts?: InputMaybe<Array<CoverageRequestContinuousBenefitsWithDraftsDisconnectFieldInput>>;
	createdBy?: InputMaybe<CoverageRequestCreatedByDisconnectFieldInput>;
	discontinuationNote?: InputMaybe<CoverageRequestDiscontinuationNoteDisconnectFieldInput>;
	disease?: InputMaybe<CoverageRequestDiseaseDisconnectFieldInput>;
	financialDataPoints?: InputMaybe<Array<CoverageRequestFinancialDataPointsDisconnectFieldInput>>;
	form?: InputMaybe<CoverageRequestFormDisconnectFieldInput>;
	indication?: InputMaybe<CoverageRequestIndicationDisconnectFieldInput>;
	initialResponse?: InputMaybe<CoverageRequestInitialResponseDisconnectFieldInput>;
	legalEntity?: InputMaybe<CoverageRequestLegalEntityDisconnectFieldInput>;
	patient?: InputMaybe<CoverageRequestPatientDisconnectFieldInput>;
	preparations?: InputMaybe<Array<CoverageRequestPreparationsDisconnectFieldInput>>;
	treatingPhysician?: InputMaybe<CoverageRequestTreatingPhysicianDisconnectFieldInput>;
	unsortedContinuousBenefits?: InputMaybe<Array<CoverageRequestUnsortedContinuousBenefitsDisconnectFieldInput>>;
};

export type CoverageRequestDiscontinuationNoteAggregateInput = {
	AND?: InputMaybe<Array<CoverageRequestDiscontinuationNoteAggregateInput>>;
	OR?: InputMaybe<Array<CoverageRequestDiscontinuationNoteAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<CoverageRequestDiscontinuationNoteNodeAggregationWhereInput>;
};

export type CoverageRequestDiscontinuationNoteConnectFieldInput = {
	connect?: InputMaybe<DiscontinuationNoteConnectInput>;
	where?: InputMaybe<DiscontinuationNoteConnectWhere>;
};

export type CoverageRequestDiscontinuationNoteConnection = {
	__typename?: "CoverageRequestDiscontinuationNoteConnection";
	edges: Array<CoverageRequestDiscontinuationNoteRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type CoverageRequestDiscontinuationNoteConnectionSort = {
	node?: InputMaybe<DiscontinuationNoteSort>;
};

export type CoverageRequestDiscontinuationNoteConnectionWhere = {
	AND?: InputMaybe<Array<CoverageRequestDiscontinuationNoteConnectionWhere>>;
	OR?: InputMaybe<Array<CoverageRequestDiscontinuationNoteConnectionWhere>>;
	node?: InputMaybe<DiscontinuationNoteWhere>;
	node_NOT?: InputMaybe<DiscontinuationNoteWhere>;
};

export type CoverageRequestDiscontinuationNoteCreateFieldInput = {
	node: DiscontinuationNoteCreateInput;
};

export type CoverageRequestDiscontinuationNoteDeleteFieldInput = {
	delete?: InputMaybe<DiscontinuationNoteDeleteInput>;
	where?: InputMaybe<CoverageRequestDiscontinuationNoteConnectionWhere>;
};

export type CoverageRequestDiscontinuationNoteDisconnectFieldInput = {
	disconnect?: InputMaybe<DiscontinuationNoteDisconnectInput>;
	where?: InputMaybe<CoverageRequestDiscontinuationNoteConnectionWhere>;
};

export type CoverageRequestDiscontinuationNoteFieldInput = {
	connect?: InputMaybe<CoverageRequestDiscontinuationNoteConnectFieldInput>;
	create?: InputMaybe<CoverageRequestDiscontinuationNoteCreateFieldInput>;
};

export type CoverageRequestDiscontinuationNoteNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<CoverageRequestDiscontinuationNoteNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<CoverageRequestDiscontinuationNoteNodeAggregationWhereInput>>;
	createdOn_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	submissionDate_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_GT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_GTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_LT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_LTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	tenantId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	tenantId_EQUAL?: InputMaybe<Scalars["String"]>;
	tenantId_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type CoverageRequestDiscontinuationNoteRelationship = {
	__typename?: "CoverageRequestDiscontinuationNoteRelationship";
	cursor: Scalars["String"];
	node: DiscontinuationNote;
};

export type CoverageRequestDiscontinuationNoteUpdateConnectionInput = {
	node?: InputMaybe<DiscontinuationNoteUpdateInput>;
};

export type CoverageRequestDiscontinuationNoteUpdateFieldInput = {
	connect?: InputMaybe<CoverageRequestDiscontinuationNoteConnectFieldInput>;
	create?: InputMaybe<CoverageRequestDiscontinuationNoteCreateFieldInput>;
	delete?: InputMaybe<CoverageRequestDiscontinuationNoteDeleteFieldInput>;
	disconnect?: InputMaybe<CoverageRequestDiscontinuationNoteDisconnectFieldInput>;
	update?: InputMaybe<CoverageRequestDiscontinuationNoteUpdateConnectionInput>;
	where?: InputMaybe<CoverageRequestDiscontinuationNoteConnectionWhere>;
};

export type CoverageRequestDiseaseAggregateInput = {
	AND?: InputMaybe<Array<CoverageRequestDiseaseAggregateInput>>;
	OR?: InputMaybe<Array<CoverageRequestDiseaseAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<CoverageRequestDiseaseNodeAggregationWhereInput>;
};

export type CoverageRequestDiseaseConnectFieldInput = {
	where?: InputMaybe<DiseaseConnectWhere>;
};

export type CoverageRequestDiseaseConnection = {
	__typename?: "CoverageRequestDiseaseConnection";
	edges: Array<CoverageRequestDiseaseRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type CoverageRequestDiseaseConnectionSort = {
	node?: InputMaybe<DiseaseSort>;
};

export type CoverageRequestDiseaseConnectionWhere = {
	AND?: InputMaybe<Array<CoverageRequestDiseaseConnectionWhere>>;
	OR?: InputMaybe<Array<CoverageRequestDiseaseConnectionWhere>>;
	node?: InputMaybe<DiseaseWhere>;
	node_NOT?: InputMaybe<DiseaseWhere>;
};

export type CoverageRequestDiseaseCreateFieldInput = {
	node: DiseaseCreateInput;
};

export type CoverageRequestDiseaseDeleteFieldInput = {
	where?: InputMaybe<CoverageRequestDiseaseConnectionWhere>;
};

export type CoverageRequestDiseaseDisconnectFieldInput = {
	where?: InputMaybe<CoverageRequestDiseaseConnectionWhere>;
};

export type CoverageRequestDiseaseFieldInput = {
	connect?: InputMaybe<CoverageRequestDiseaseConnectFieldInput>;
	create?: InputMaybe<CoverageRequestDiseaseCreateFieldInput>;
};

export type CoverageRequestDiseaseNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<CoverageRequestDiseaseNodeAggregationWhereInput>>;
	Icd10Code_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	Icd10Code_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	Icd10Code_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	Icd10Code_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	Icd10Code_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	Icd10Code_EQUAL?: InputMaybe<Scalars["String"]>;
	Icd10Code_GT?: InputMaybe<Scalars["Int"]>;
	Icd10Code_GTE?: InputMaybe<Scalars["Int"]>;
	Icd10Code_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Icd10Code_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	Icd10Code_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	Icd10Code_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	Icd10Code_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	Icd10Code_LT?: InputMaybe<Scalars["Int"]>;
	Icd10Code_LTE?: InputMaybe<Scalars["Int"]>;
	Icd10Code_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Icd10Code_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	Icd10Code_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	Icd10Code_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	Icd10Code_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	Name_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	Name_EQUAL?: InputMaybe<Scalars["String"]>;
	Name_GT?: InputMaybe<Scalars["Int"]>;
	Name_GTE?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	Name_LT?: InputMaybe<Scalars["Int"]>;
	Name_LTE?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	OR?: InputMaybe<Array<CoverageRequestDiseaseNodeAggregationWhereInput>>;
};

export type CoverageRequestDiseaseRelationship = {
	__typename?: "CoverageRequestDiseaseRelationship";
	cursor: Scalars["String"];
	node: Disease;
};

export type CoverageRequestDiseaseUpdateConnectionInput = {
	node?: InputMaybe<DiseaseUpdateInput>;
};

export type CoverageRequestDiseaseUpdateFieldInput = {
	connect?: InputMaybe<CoverageRequestDiseaseConnectFieldInput>;
	create?: InputMaybe<CoverageRequestDiseaseCreateFieldInput>;
	delete?: InputMaybe<CoverageRequestDiseaseDeleteFieldInput>;
	disconnect?: InputMaybe<CoverageRequestDiseaseDisconnectFieldInput>;
	update?: InputMaybe<CoverageRequestDiseaseUpdateConnectionInput>;
	where?: InputMaybe<CoverageRequestDiseaseConnectionWhere>;
};

export type CoverageRequestFinancialDataPointsAggregateInput = {
	AND?: InputMaybe<Array<CoverageRequestFinancialDataPointsAggregateInput>>;
	OR?: InputMaybe<Array<CoverageRequestFinancialDataPointsAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<CoverageRequestFinancialDataPointsNodeAggregationWhereInput>;
};

export type CoverageRequestFinancialDataPointsConnectFieldInput = {
	connect?: InputMaybe<Array<FinancialDataPointConnectInput>>;
	where?: InputMaybe<FinancialDataPointConnectWhere>;
};

export type CoverageRequestFinancialDataPointsConnection = {
	__typename?: "CoverageRequestFinancialDataPointsConnection";
	edges: Array<CoverageRequestFinancialDataPointsRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type CoverageRequestFinancialDataPointsConnectionSort = {
	node?: InputMaybe<FinancialDataPointSort>;
};

export type CoverageRequestFinancialDataPointsConnectionWhere = {
	AND?: InputMaybe<Array<CoverageRequestFinancialDataPointsConnectionWhere>>;
	OR?: InputMaybe<Array<CoverageRequestFinancialDataPointsConnectionWhere>>;
	node?: InputMaybe<FinancialDataPointWhere>;
	node_NOT?: InputMaybe<FinancialDataPointWhere>;
};

export type CoverageRequestFinancialDataPointsCreateFieldInput = {
	node: FinancialDataPointCreateInput;
};

export type CoverageRequestFinancialDataPointsDeleteFieldInput = {
	delete?: InputMaybe<FinancialDataPointDeleteInput>;
	where?: InputMaybe<CoverageRequestFinancialDataPointsConnectionWhere>;
};

export type CoverageRequestFinancialDataPointsDisconnectFieldInput = {
	disconnect?: InputMaybe<FinancialDataPointDisconnectInput>;
	where?: InputMaybe<CoverageRequestFinancialDataPointsConnectionWhere>;
};

export type CoverageRequestFinancialDataPointsFieldInput = {
	connect?: InputMaybe<Array<CoverageRequestFinancialDataPointsConnectFieldInput>>;
	create?: InputMaybe<Array<CoverageRequestFinancialDataPointsCreateFieldInput>>;
};

export type CoverageRequestFinancialDataPointsNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<CoverageRequestFinancialDataPointsNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<CoverageRequestFinancialDataPointsNodeAggregationWhereInput>>;
	basePrice_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	basePrice_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	basePrice_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	basePrice_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	basePrice_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	basePrice_EQUAL?: InputMaybe<Scalars["Float"]>;
	basePrice_GT?: InputMaybe<Scalars["Float"]>;
	basePrice_GTE?: InputMaybe<Scalars["Float"]>;
	basePrice_LT?: InputMaybe<Scalars["Float"]>;
	basePrice_LTE?: InputMaybe<Scalars["Float"]>;
	basePrice_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	basePrice_MAX_GT?: InputMaybe<Scalars["Float"]>;
	basePrice_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	basePrice_MAX_LT?: InputMaybe<Scalars["Float"]>;
	basePrice_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	basePrice_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	basePrice_MIN_GT?: InputMaybe<Scalars["Float"]>;
	basePrice_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	basePrice_MIN_LT?: InputMaybe<Scalars["Float"]>;
	basePrice_MIN_LTE?: InputMaybe<Scalars["Float"]>;
	currencyCode_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	currencyCode_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	currencyCode_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	currencyCode_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	currencyCode_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	currencyCode_EQUAL?: InputMaybe<Scalars["String"]>;
	currencyCode_GT?: InputMaybe<Scalars["Int"]>;
	currencyCode_GTE?: InputMaybe<Scalars["Int"]>;
	currencyCode_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	currencyCode_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	currencyCode_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	currencyCode_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	currencyCode_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	currencyCode_LT?: InputMaybe<Scalars["Int"]>;
	currencyCode_LTE?: InputMaybe<Scalars["Int"]>;
	currencyCode_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	currencyCode_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	currencyCode_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	currencyCode_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	currencyCode_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	evaluationSnapshot_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	evaluationSnapshot_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	evaluationSnapshot_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	evaluationSnapshot_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	evaluationSnapshot_EQUAL?: InputMaybe<Scalars["String"]>;
	evaluationSnapshot_GT?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_GTE?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_LT?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_LTE?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	generatedUuid_EQUAL?: InputMaybe<Scalars["ID"]>;
	payablePercentage_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	payablePercentage_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	payablePercentage_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	payablePercentage_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	payablePercentage_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	payablePercentage_EQUAL?: InputMaybe<Scalars["Float"]>;
	payablePercentage_GT?: InputMaybe<Scalars["Float"]>;
	payablePercentage_GTE?: InputMaybe<Scalars["Float"]>;
	payablePercentage_LT?: InputMaybe<Scalars["Float"]>;
	payablePercentage_LTE?: InputMaybe<Scalars["Float"]>;
	payablePercentage_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	payablePercentage_MAX_GT?: InputMaybe<Scalars["Float"]>;
	payablePercentage_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	payablePercentage_MAX_LT?: InputMaybe<Scalars["Float"]>;
	payablePercentage_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	payablePercentage_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	payablePercentage_MIN_GT?: InputMaybe<Scalars["Float"]>;
	payablePercentage_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	payablePercentage_MIN_LT?: InputMaybe<Scalars["Float"]>;
	payablePercentage_MIN_LTE?: InputMaybe<Scalars["Float"]>;
	payable_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	payable_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	payable_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	payable_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	payable_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	payable_EQUAL?: InputMaybe<Scalars["Float"]>;
	payable_GT?: InputMaybe<Scalars["Float"]>;
	payable_GTE?: InputMaybe<Scalars["Float"]>;
	payable_LT?: InputMaybe<Scalars["Float"]>;
	payable_LTE?: InputMaybe<Scalars["Float"]>;
	payable_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	payable_MAX_GT?: InputMaybe<Scalars["Float"]>;
	payable_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	payable_MAX_LT?: InputMaybe<Scalars["Float"]>;
	payable_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	payable_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	payable_MIN_GT?: InputMaybe<Scalars["Float"]>;
	payable_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	payable_MIN_LT?: InputMaybe<Scalars["Float"]>;
	payable_MIN_LTE?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	quantity_EQUAL?: InputMaybe<Scalars["Float"]>;
	quantity_GT?: InputMaybe<Scalars["Float"]>;
	quantity_GTE?: InputMaybe<Scalars["Float"]>;
	quantity_LT?: InputMaybe<Scalars["Float"]>;
	quantity_LTE?: InputMaybe<Scalars["Float"]>;
	quantity_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	quantity_MAX_GT?: InputMaybe<Scalars["Float"]>;
	quantity_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	quantity_MAX_LT?: InputMaybe<Scalars["Float"]>;
	quantity_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	quantity_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	quantity_MIN_GT?: InputMaybe<Scalars["Float"]>;
	quantity_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	quantity_MIN_LT?: InputMaybe<Scalars["Float"]>;
	quantity_MIN_LTE?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_EQUAL?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_GT?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_GTE?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_LT?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_LTE?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_MAX_GT?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_MAX_LT?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_MIN_GT?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_MIN_LT?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_MIN_LTE?: InputMaybe<Scalars["Float"]>;
	refundable_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	refundable_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	refundable_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	refundable_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	refundable_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	refundable_EQUAL?: InputMaybe<Scalars["Float"]>;
	refundable_GT?: InputMaybe<Scalars["Float"]>;
	refundable_GTE?: InputMaybe<Scalars["Float"]>;
	refundable_LT?: InputMaybe<Scalars["Float"]>;
	refundable_LTE?: InputMaybe<Scalars["Float"]>;
	refundable_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	refundable_MAX_GT?: InputMaybe<Scalars["Float"]>;
	refundable_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	refundable_MAX_LT?: InputMaybe<Scalars["Float"]>;
	refundable_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	refundable_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	refundable_MIN_GT?: InputMaybe<Scalars["Float"]>;
	refundable_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	refundable_MIN_LT?: InputMaybe<Scalars["Float"]>;
	refundable_MIN_LTE?: InputMaybe<Scalars["Float"]>;
	uuid_EQUAL?: InputMaybe<Scalars["ID"]>;
	variablePercentage_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	variablePercentage_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	variablePercentage_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	variablePercentage_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	variablePercentage_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	variablePercentage_EQUAL?: InputMaybe<Scalars["Float"]>;
	variablePercentage_GT?: InputMaybe<Scalars["Float"]>;
	variablePercentage_GTE?: InputMaybe<Scalars["Float"]>;
	variablePercentage_LT?: InputMaybe<Scalars["Float"]>;
	variablePercentage_LTE?: InputMaybe<Scalars["Float"]>;
	variablePercentage_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	variablePercentage_MAX_GT?: InputMaybe<Scalars["Float"]>;
	variablePercentage_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	variablePercentage_MAX_LT?: InputMaybe<Scalars["Float"]>;
	variablePercentage_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	variablePercentage_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	variablePercentage_MIN_GT?: InputMaybe<Scalars["Float"]>;
	variablePercentage_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	variablePercentage_MIN_LT?: InputMaybe<Scalars["Float"]>;
	variablePercentage_MIN_LTE?: InputMaybe<Scalars["Float"]>;
	variable_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	variable_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	variable_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	variable_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	variable_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	variable_EQUAL?: InputMaybe<Scalars["Float"]>;
	variable_GT?: InputMaybe<Scalars["Float"]>;
	variable_GTE?: InputMaybe<Scalars["Float"]>;
	variable_LT?: InputMaybe<Scalars["Float"]>;
	variable_LTE?: InputMaybe<Scalars["Float"]>;
	variable_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	variable_MAX_GT?: InputMaybe<Scalars["Float"]>;
	variable_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	variable_MAX_LT?: InputMaybe<Scalars["Float"]>;
	variable_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	variable_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	variable_MIN_GT?: InputMaybe<Scalars["Float"]>;
	variable_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	variable_MIN_LT?: InputMaybe<Scalars["Float"]>;
	variable_MIN_LTE?: InputMaybe<Scalars["Float"]>;
};

export type CoverageRequestFinancialDataPointsRelationship = {
	__typename?: "CoverageRequestFinancialDataPointsRelationship";
	cursor: Scalars["String"];
	node: FinancialDataPoint;
};

export type CoverageRequestFinancialDataPointsUpdateConnectionInput = {
	node?: InputMaybe<FinancialDataPointUpdateInput>;
};

export type CoverageRequestFinancialDataPointsUpdateFieldInput = {
	connect?: InputMaybe<Array<CoverageRequestFinancialDataPointsConnectFieldInput>>;
	create?: InputMaybe<Array<CoverageRequestFinancialDataPointsCreateFieldInput>>;
	delete?: InputMaybe<Array<CoverageRequestFinancialDataPointsDeleteFieldInput>>;
	disconnect?: InputMaybe<Array<CoverageRequestFinancialDataPointsDisconnectFieldInput>>;
	update?: InputMaybe<CoverageRequestFinancialDataPointsUpdateConnectionInput>;
	where?: InputMaybe<CoverageRequestFinancialDataPointsConnectionWhere>;
};

export type CoverageRequestFormAggregateInput = {
	AND?: InputMaybe<Array<CoverageRequestFormAggregateInput>>;
	OR?: InputMaybe<Array<CoverageRequestFormAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<CoverageRequestFormNodeAggregationWhereInput>;
};

export type CoverageRequestFormConnectFieldInput = {
	connect?: InputMaybe<FormConnectInput>;
	where?: InputMaybe<FormConnectWhere>;
};

export type CoverageRequestFormConnection = {
	__typename?: "CoverageRequestFormConnection";
	edges: Array<CoverageRequestFormRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type CoverageRequestFormConnectionSort = {
	node?: InputMaybe<FormSort>;
};

export type CoverageRequestFormConnectionWhere = {
	AND?: InputMaybe<Array<CoverageRequestFormConnectionWhere>>;
	OR?: InputMaybe<Array<CoverageRequestFormConnectionWhere>>;
	node?: InputMaybe<FormWhere>;
	node_NOT?: InputMaybe<FormWhere>;
};

export type CoverageRequestFormCreateFieldInput = {
	node: FormCreateInput;
};

export type CoverageRequestFormDeleteFieldInput = {
	delete?: InputMaybe<FormDeleteInput>;
	where?: InputMaybe<CoverageRequestFormConnectionWhere>;
};

export type CoverageRequestFormDisconnectFieldInput = {
	disconnect?: InputMaybe<FormDisconnectInput>;
	where?: InputMaybe<CoverageRequestFormConnectionWhere>;
};

export type CoverageRequestFormFieldInput = {
	connect?: InputMaybe<CoverageRequestFormConnectFieldInput>;
	create?: InputMaybe<CoverageRequestFormCreateFieldInput>;
};

export type CoverageRequestFormNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<CoverageRequestFormNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<CoverageRequestFormNodeAggregationWhereInput>>;
	createdByName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	createdByName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	createdByName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	createdByName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	createdByName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	createdByName_EQUAL?: InputMaybe<Scalars["String"]>;
	createdByName_GT?: InputMaybe<Scalars["Int"]>;
	createdByName_GTE?: InputMaybe<Scalars["Int"]>;
	createdByName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	createdByName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	createdByName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	createdByName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	createdByName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	createdByName_LT?: InputMaybe<Scalars["Int"]>;
	createdByName_LTE?: InputMaybe<Scalars["Int"]>;
	createdByName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	createdByName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	createdByName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	createdByName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	createdByName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	createdBy_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	createdBy_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	createdBy_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	createdBy_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	createdBy_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	createdBy_EQUAL?: InputMaybe<Scalars["String"]>;
	createdBy_GT?: InputMaybe<Scalars["Int"]>;
	createdBy_GTE?: InputMaybe<Scalars["Int"]>;
	createdBy_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	createdBy_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	createdBy_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	createdBy_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	createdBy_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	createdBy_LT?: InputMaybe<Scalars["Int"]>;
	createdBy_LTE?: InputMaybe<Scalars["Int"]>;
	createdBy_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	createdBy_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	createdBy_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	createdBy_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	createdBy_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	createdOn_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	insuranceId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	insuranceId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	insuranceId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	insuranceId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	insuranceId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	insuranceId_EQUAL?: InputMaybe<Scalars["String"]>;
	insuranceId_GT?: InputMaybe<Scalars["Int"]>;
	insuranceId_GTE?: InputMaybe<Scalars["Int"]>;
	insuranceId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	insuranceId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	insuranceId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	insuranceId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	insuranceId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	insuranceId_LT?: InputMaybe<Scalars["Int"]>;
	insuranceId_LTE?: InputMaybe<Scalars["Int"]>;
	insuranceId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	insuranceId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	insuranceId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	insuranceId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	insuranceId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	lastUpdatedOn_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_GT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_LT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	preparationBrandName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	preparationBrandName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	preparationBrandName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	preparationBrandName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	preparationBrandName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	preparationBrandName_EQUAL?: InputMaybe<Scalars["String"]>;
	preparationBrandName_GT?: InputMaybe<Scalars["Int"]>;
	preparationBrandName_GTE?: InputMaybe<Scalars["Int"]>;
	preparationBrandName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationBrandName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationBrandName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationBrandName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationBrandName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationBrandName_LT?: InputMaybe<Scalars["Int"]>;
	preparationBrandName_LTE?: InputMaybe<Scalars["Int"]>;
	preparationBrandName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationBrandName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationBrandName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationBrandName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationBrandName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	preparationGenericName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	preparationGenericName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	preparationGenericName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	preparationGenericName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	preparationGenericName_EQUAL?: InputMaybe<Scalars["String"]>;
	preparationGenericName_GT?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_GTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_LT?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_LTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	tenantId_EQUAL?: InputMaybe<Scalars["String"]>;
	tenantId_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	unlimited_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	unlimited_EQUAL?: InputMaybe<Scalars["Int"]>;
	unlimited_GT?: InputMaybe<Scalars["Int"]>;
	unlimited_GTE?: InputMaybe<Scalars["Int"]>;
	unlimited_LT?: InputMaybe<Scalars["Int"]>;
	unlimited_LTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_GT?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_LT?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_GT?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_LT?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	uuid_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	uuid_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	uuid_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	uuid_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	uuid_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	uuid_EQUAL?: InputMaybe<Scalars["String"]>;
	uuid_GT?: InputMaybe<Scalars["Int"]>;
	uuid_GTE?: InputMaybe<Scalars["Int"]>;
	uuid_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	uuid_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	uuid_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	uuid_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	uuid_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	uuid_LT?: InputMaybe<Scalars["Int"]>;
	uuid_LTE?: InputMaybe<Scalars["Int"]>;
	uuid_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	uuid_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	uuid_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	uuid_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	uuid_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type CoverageRequestFormRelationship = {
	__typename?: "CoverageRequestFormRelationship";
	cursor: Scalars["String"];
	node: Form;
};

export type CoverageRequestFormUpdateConnectionInput = {
	node?: InputMaybe<FormUpdateInput>;
};

export type CoverageRequestFormUpdateFieldInput = {
	connect?: InputMaybe<CoverageRequestFormConnectFieldInput>;
	create?: InputMaybe<CoverageRequestFormCreateFieldInput>;
	delete?: InputMaybe<CoverageRequestFormDeleteFieldInput>;
	disconnect?: InputMaybe<CoverageRequestFormDisconnectFieldInput>;
	update?: InputMaybe<CoverageRequestFormUpdateConnectionInput>;
	where?: InputMaybe<CoverageRequestFormConnectionWhere>;
};

export type CoverageRequestIndicationAggregateInput = {
	AND?: InputMaybe<Array<CoverageRequestIndicationAggregateInput>>;
	OR?: InputMaybe<Array<CoverageRequestIndicationAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<CoverageRequestIndicationNodeAggregationWhereInput>;
};

export type CoverageRequestIndicationConnectFieldInput = {
	where?: InputMaybe<IndicationConnectWhere>;
};

export type CoverageRequestIndicationConnection = {
	__typename?: "CoverageRequestIndicationConnection";
	edges: Array<CoverageRequestIndicationRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type CoverageRequestIndicationConnectionSort = {
	node?: InputMaybe<IndicationSort>;
};

export type CoverageRequestIndicationConnectionWhere = {
	AND?: InputMaybe<Array<CoverageRequestIndicationConnectionWhere>>;
	OR?: InputMaybe<Array<CoverageRequestIndicationConnectionWhere>>;
	node?: InputMaybe<IndicationWhere>;
	node_NOT?: InputMaybe<IndicationWhere>;
};

export type CoverageRequestIndicationCreateFieldInput = {
	node: IndicationCreateInput;
};

export type CoverageRequestIndicationDeleteFieldInput = {
	where?: InputMaybe<CoverageRequestIndicationConnectionWhere>;
};

export type CoverageRequestIndicationDisconnectFieldInput = {
	where?: InputMaybe<CoverageRequestIndicationConnectionWhere>;
};

export type CoverageRequestIndicationFieldInput = {
	connect?: InputMaybe<CoverageRequestIndicationConnectFieldInput>;
	create?: InputMaybe<CoverageRequestIndicationCreateFieldInput>;
};

export type CoverageRequestIndicationNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<CoverageRequestIndicationNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<CoverageRequestIndicationNodeAggregationWhereInput>>;
	bagCode_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	bagCode_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	bagCode_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	bagCode_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	bagCode_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	bagCode_EQUAL?: InputMaybe<Scalars["String"]>;
	bagCode_GT?: InputMaybe<Scalars["Int"]>;
	bagCode_GTE?: InputMaybe<Scalars["Int"]>;
	bagCode_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	bagCode_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	bagCode_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	bagCode_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	bagCode_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	bagCode_LT?: InputMaybe<Scalars["Int"]>;
	bagCode_LTE?: InputMaybe<Scalars["Int"]>;
	bagCode_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	bagCode_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	bagCode_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	bagCode_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	bagCode_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	code_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	code_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	code_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	code_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	code_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	code_EQUAL?: InputMaybe<Scalars["String"]>;
	code_GT?: InputMaybe<Scalars["Int"]>;
	code_GTE?: InputMaybe<Scalars["Int"]>;
	code_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	code_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	code_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	code_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	code_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	code_LT?: InputMaybe<Scalars["Int"]>;
	code_LTE?: InputMaybe<Scalars["Int"]>;
	code_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	code_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	code_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	code_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	code_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	intent_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	intent_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	intent_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	intent_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	intent_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	intent_EQUAL?: InputMaybe<Scalars["String"]>;
	intent_GT?: InputMaybe<Scalars["Int"]>;
	intent_GTE?: InputMaybe<Scalars["Int"]>;
	intent_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	intent_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	intent_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	intent_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	intent_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	intent_LT?: InputMaybe<Scalars["Int"]>;
	intent_LTE?: InputMaybe<Scalars["Int"]>;
	intent_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	intent_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	intent_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	intent_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	intent_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	line_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	line_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	line_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	line_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	line_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	line_EQUAL?: InputMaybe<Scalars["String"]>;
	line_GT?: InputMaybe<Scalars["Int"]>;
	line_GTE?: InputMaybe<Scalars["Int"]>;
	line_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	line_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	line_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	line_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	line_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	line_LT?: InputMaybe<Scalars["Int"]>;
	line_LTE?: InputMaybe<Scalars["Int"]>;
	line_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	line_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	line_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	line_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	line_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	mutation_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	mutation_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	mutation_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	mutation_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	mutation_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	mutation_EQUAL?: InputMaybe<Scalars["String"]>;
	mutation_GT?: InputMaybe<Scalars["Int"]>;
	mutation_GTE?: InputMaybe<Scalars["Int"]>;
	mutation_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	mutation_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	mutation_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	mutation_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	mutation_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	mutation_LT?: InputMaybe<Scalars["Int"]>;
	mutation_LTE?: InputMaybe<Scalars["Int"]>;
	mutation_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	mutation_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	mutation_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	mutation_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	mutation_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	type_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	type_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	type_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	type_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	type_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	type_EQUAL?: InputMaybe<Scalars["String"]>;
	type_GT?: InputMaybe<Scalars["Int"]>;
	type_GTE?: InputMaybe<Scalars["Int"]>;
	type_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	type_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	type_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	type_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	type_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	type_LT?: InputMaybe<Scalars["Int"]>;
	type_LTE?: InputMaybe<Scalars["Int"]>;
	type_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	type_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	type_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	type_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	type_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type CoverageRequestIndicationRelationship = {
	__typename?: "CoverageRequestIndicationRelationship";
	cursor: Scalars["String"];
	node: Indication;
};

export type CoverageRequestIndicationUpdateConnectionInput = {
	node?: InputMaybe<IndicationUpdateInput>;
};

export type CoverageRequestIndicationUpdateFieldInput = {
	connect?: InputMaybe<CoverageRequestIndicationConnectFieldInput>;
	create?: InputMaybe<CoverageRequestIndicationCreateFieldInput>;
	delete?: InputMaybe<CoverageRequestIndicationDeleteFieldInput>;
	disconnect?: InputMaybe<CoverageRequestIndicationDisconnectFieldInput>;
	update?: InputMaybe<CoverageRequestIndicationUpdateConnectionInput>;
	where?: InputMaybe<CoverageRequestIndicationConnectionWhere>;
};

export type CoverageRequestInitialResponseAggregateInput = {
	AND?: InputMaybe<Array<CoverageRequestInitialResponseAggregateInput>>;
	OR?: InputMaybe<Array<CoverageRequestInitialResponseAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<CoverageRequestInitialResponseNodeAggregationWhereInput>;
};

export type CoverageRequestInitialResponseConnectFieldInput = {
	connect?: InputMaybe<InitialResponseConnectInput>;
	where?: InputMaybe<InitialResponseConnectWhere>;
};

export type CoverageRequestInitialResponseConnection = {
	__typename?: "CoverageRequestInitialResponseConnection";
	edges: Array<CoverageRequestInitialResponseRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type CoverageRequestInitialResponseConnectionSort = {
	node?: InputMaybe<InitialResponseSort>;
};

export type CoverageRequestInitialResponseConnectionWhere = {
	AND?: InputMaybe<Array<CoverageRequestInitialResponseConnectionWhere>>;
	OR?: InputMaybe<Array<CoverageRequestInitialResponseConnectionWhere>>;
	node?: InputMaybe<InitialResponseWhere>;
	node_NOT?: InputMaybe<InitialResponseWhere>;
};

export type CoverageRequestInitialResponseCreateFieldInput = {
	node: InitialResponseCreateInput;
};

export type CoverageRequestInitialResponseDeleteFieldInput = {
	delete?: InputMaybe<InitialResponseDeleteInput>;
	where?: InputMaybe<CoverageRequestInitialResponseConnectionWhere>;
};

export type CoverageRequestInitialResponseDisconnectFieldInput = {
	disconnect?: InputMaybe<InitialResponseDisconnectInput>;
	where?: InputMaybe<CoverageRequestInitialResponseConnectionWhere>;
};

export type CoverageRequestInitialResponseFieldInput = {
	connect?: InputMaybe<CoverageRequestInitialResponseConnectFieldInput>;
	create?: InputMaybe<CoverageRequestInitialResponseCreateFieldInput>;
};

export type CoverageRequestInitialResponseNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<CoverageRequestInitialResponseNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<CoverageRequestInitialResponseNodeAggregationWhereInput>>;
	createdOn_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	numberOfPrescriptionsToDate_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	numberOfPrescriptionsToDate_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	numberOfPrescriptionsToDate_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	numberOfPrescriptionsToDate_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	numberOfPrescriptionsToDate_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	numberOfPrescriptionsToDate_EQUAL?: InputMaybe<Scalars["Int"]>;
	numberOfPrescriptionsToDate_GT?: InputMaybe<Scalars["Int"]>;
	numberOfPrescriptionsToDate_GTE?: InputMaybe<Scalars["Int"]>;
	numberOfPrescriptionsToDate_LT?: InputMaybe<Scalars["Int"]>;
	numberOfPrescriptionsToDate_LTE?: InputMaybe<Scalars["Int"]>;
	numberOfPrescriptionsToDate_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	numberOfPrescriptionsToDate_MAX_GT?: InputMaybe<Scalars["Int"]>;
	numberOfPrescriptionsToDate_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	numberOfPrescriptionsToDate_MAX_LT?: InputMaybe<Scalars["Int"]>;
	numberOfPrescriptionsToDate_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	numberOfPrescriptionsToDate_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	numberOfPrescriptionsToDate_MIN_GT?: InputMaybe<Scalars["Int"]>;
	numberOfPrescriptionsToDate_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	numberOfPrescriptionsToDate_MIN_LT?: InputMaybe<Scalars["Int"]>;
	numberOfPrescriptionsToDate_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	submissionDate_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_GT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_GTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_LT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_LTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	tenantId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	tenantId_EQUAL?: InputMaybe<Scalars["String"]>;
	tenantId_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type CoverageRequestInitialResponseRelationship = {
	__typename?: "CoverageRequestInitialResponseRelationship";
	cursor: Scalars["String"];
	node: InitialResponse;
};

export type CoverageRequestInitialResponseUpdateConnectionInput = {
	node?: InputMaybe<InitialResponseUpdateInput>;
};

export type CoverageRequestInitialResponseUpdateFieldInput = {
	connect?: InputMaybe<CoverageRequestInitialResponseConnectFieldInput>;
	create?: InputMaybe<CoverageRequestInitialResponseCreateFieldInput>;
	delete?: InputMaybe<CoverageRequestInitialResponseDeleteFieldInput>;
	disconnect?: InputMaybe<CoverageRequestInitialResponseDisconnectFieldInput>;
	update?: InputMaybe<CoverageRequestInitialResponseUpdateConnectionInput>;
	where?: InputMaybe<CoverageRequestInitialResponseConnectionWhere>;
};

export type CoverageRequestInput = {
	caseId?: InputMaybe<Scalars["ID"]>;
	coverageEndDate?: InputMaybe<Scalars["Date"]>;
	coverageStartDate?: InputMaybe<Scalars["Date"]>;
	creationDate: Scalars["DateTime"];
	decisionCommunicatedOn?: InputMaybe<Scalars["Date"]>;
	diseaseCode: Scalars["String"];
	duration?: InputMaybe<Scalars["Int"]>;
	durationUom?: InputMaybe<DurationUom>;
	evergreenCrEndDate?: InputMaybe<Scalars["Date"]>;
	evergreenCrId?: InputMaybe<Scalars["String"]>;
	indicationCode: Scalars["String"];
	intendedStartDate?: InputMaybe<Scalars["Date"]>;
	legalEntityId?: InputMaybe<Scalars["String"]>;
	patient?: InputMaybe<CoverageRequestPatientFormDataInput>;
	preparations: Array<CoverageRequestPreparationFormDataInput>;
	rating?: InputMaybe<CoverageRequestRating>;
	requestReceiptDate: Scalars["Date"];
	status?: InputMaybe<FormStatus>;
	submissionDate?: InputMaybe<Scalars["DateTime"]>;
	therapyDecision?: InputMaybe<CoverageRequestTherapyDecision>;
	treatingPhysician?: InputMaybe<TreatingPhysicianInput>;
};

export type CoverageRequestLegalEntityAggregateInput = {
	AND?: InputMaybe<Array<CoverageRequestLegalEntityAggregateInput>>;
	OR?: InputMaybe<Array<CoverageRequestLegalEntityAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<CoverageRequestLegalEntityNodeAggregationWhereInput>;
};

export type CoverageRequestLegalEntityConnectFieldInput = {
	where?: InputMaybe<OrganizationConnectWhere>;
};

export type CoverageRequestLegalEntityConnection = {
	__typename?: "CoverageRequestLegalEntityConnection";
	edges: Array<CoverageRequestLegalEntityRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type CoverageRequestLegalEntityConnectionSort = {
	node?: InputMaybe<OrganizationSort>;
};

export type CoverageRequestLegalEntityConnectionWhere = {
	AND?: InputMaybe<Array<CoverageRequestLegalEntityConnectionWhere>>;
	OR?: InputMaybe<Array<CoverageRequestLegalEntityConnectionWhere>>;
	node?: InputMaybe<OrganizationWhere>;
	node_NOT?: InputMaybe<OrganizationWhere>;
};

export type CoverageRequestLegalEntityCreateFieldInput = {
	node: OrganizationCreateInput;
};

export type CoverageRequestLegalEntityDeleteFieldInput = {
	where?: InputMaybe<CoverageRequestLegalEntityConnectionWhere>;
};

export type CoverageRequestLegalEntityDisconnectFieldInput = {
	where?: InputMaybe<CoverageRequestLegalEntityConnectionWhere>;
};

export type CoverageRequestLegalEntityFieldInput = {
	connect?: InputMaybe<CoverageRequestLegalEntityConnectFieldInput>;
	create?: InputMaybe<CoverageRequestLegalEntityCreateFieldInput>;
};

export type CoverageRequestLegalEntityNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<CoverageRequestLegalEntityNodeAggregationWhereInput>>;
	IBAN_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	IBAN_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	IBAN_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	IBAN_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	IBAN_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	IBAN_EQUAL?: InputMaybe<Scalars["String"]>;
	IBAN_GT?: InputMaybe<Scalars["Int"]>;
	IBAN_GTE?: InputMaybe<Scalars["Int"]>;
	IBAN_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	IBAN_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	IBAN_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	IBAN_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	IBAN_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	IBAN_LT?: InputMaybe<Scalars["Int"]>;
	IBAN_LTE?: InputMaybe<Scalars["Int"]>;
	IBAN_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	IBAN_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	IBAN_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	IBAN_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	IBAN_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	OR?: InputMaybe<Array<CoverageRequestLegalEntityNodeAggregationWhereInput>>;
	billingAddress_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	billingAddress_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	billingAddress_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	billingAddress_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	billingAddress_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	billingAddress_EQUAL?: InputMaybe<Scalars["String"]>;
	billingAddress_GT?: InputMaybe<Scalars["Int"]>;
	billingAddress_GTE?: InputMaybe<Scalars["Int"]>;
	billingAddress_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	billingAddress_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	billingAddress_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	billingAddress_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	billingAddress_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	billingAddress_LT?: InputMaybe<Scalars["Int"]>;
	billingAddress_LTE?: InputMaybe<Scalars["Int"]>;
	billingAddress_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	billingAddress_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	billingAddress_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	billingAddress_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	billingAddress_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	contactEmail_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	contactEmail_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	contactEmail_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	contactEmail_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	contactEmail_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	contactEmail_EQUAL?: InputMaybe<Scalars["String"]>;
	contactEmail_GT?: InputMaybe<Scalars["Int"]>;
	contactEmail_GTE?: InputMaybe<Scalars["Int"]>;
	contactEmail_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	contactEmail_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	contactEmail_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	contactEmail_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	contactEmail_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	contactEmail_LT?: InputMaybe<Scalars["Int"]>;
	contactEmail_LTE?: InputMaybe<Scalars["Int"]>;
	contactEmail_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	contactEmail_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	contactEmail_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	contactEmail_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	contactEmail_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	contactFirstName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	contactFirstName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	contactFirstName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	contactFirstName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	contactFirstName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	contactFirstName_EQUAL?: InputMaybe<Scalars["String"]>;
	contactFirstName_GT?: InputMaybe<Scalars["Int"]>;
	contactFirstName_GTE?: InputMaybe<Scalars["Int"]>;
	contactFirstName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	contactFirstName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	contactFirstName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	contactFirstName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	contactFirstName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	contactFirstName_LT?: InputMaybe<Scalars["Int"]>;
	contactFirstName_LTE?: InputMaybe<Scalars["Int"]>;
	contactFirstName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	contactFirstName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	contactFirstName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	contactFirstName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	contactFirstName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	contactLastName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	contactLastName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	contactLastName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	contactLastName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	contactLastName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	contactLastName_EQUAL?: InputMaybe<Scalars["String"]>;
	contactLastName_GT?: InputMaybe<Scalars["Int"]>;
	contactLastName_GTE?: InputMaybe<Scalars["Int"]>;
	contactLastName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	contactLastName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	contactLastName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	contactLastName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	contactLastName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	contactLastName_LT?: InputMaybe<Scalars["Int"]>;
	contactLastName_LTE?: InputMaybe<Scalars["Int"]>;
	contactLastName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	contactLastName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	contactLastName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	contactLastName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	contactLastName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	contactOccupation_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	contactOccupation_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	contactOccupation_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	contactOccupation_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	contactOccupation_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	contactOccupation_EQUAL?: InputMaybe<Scalars["String"]>;
	contactOccupation_GT?: InputMaybe<Scalars["Int"]>;
	contactOccupation_GTE?: InputMaybe<Scalars["Int"]>;
	contactOccupation_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	contactOccupation_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	contactOccupation_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	contactOccupation_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	contactOccupation_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	contactOccupation_LT?: InputMaybe<Scalars["Int"]>;
	contactOccupation_LTE?: InputMaybe<Scalars["Int"]>;
	contactOccupation_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	contactOccupation_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	contactOccupation_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	contactOccupation_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	contactOccupation_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	contactPhone_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	contactPhone_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	contactPhone_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	contactPhone_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	contactPhone_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	contactPhone_EQUAL?: InputMaybe<Scalars["String"]>;
	contactPhone_GT?: InputMaybe<Scalars["Int"]>;
	contactPhone_GTE?: InputMaybe<Scalars["Int"]>;
	contactPhone_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	contactPhone_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	contactPhone_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	contactPhone_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	contactPhone_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	contactPhone_LT?: InputMaybe<Scalars["Int"]>;
	contactPhone_LTE?: InputMaybe<Scalars["Int"]>;
	contactPhone_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	contactPhone_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	contactPhone_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	contactPhone_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	contactPhone_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	domicile_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	domicile_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	domicile_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	domicile_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	domicile_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	domicile_EQUAL?: InputMaybe<Scalars["String"]>;
	domicile_GT?: InputMaybe<Scalars["Int"]>;
	domicile_GTE?: InputMaybe<Scalars["Int"]>;
	domicile_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	domicile_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	domicile_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	domicile_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	domicile_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	domicile_LT?: InputMaybe<Scalars["Int"]>;
	domicile_LTE?: InputMaybe<Scalars["Int"]>;
	domicile_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	domicile_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	domicile_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	domicile_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	domicile_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	eIN_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	eIN_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	eIN_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	eIN_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	eIN_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	eIN_EQUAL?: InputMaybe<Scalars["String"]>;
	eIN_GT?: InputMaybe<Scalars["Int"]>;
	eIN_GTE?: InputMaybe<Scalars["Int"]>;
	eIN_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	eIN_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	eIN_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	eIN_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	eIN_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	eIN_LT?: InputMaybe<Scalars["Int"]>;
	eIN_LTE?: InputMaybe<Scalars["Int"]>;
	eIN_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	eIN_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	eIN_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	eIN_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	eIN_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	fax_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	fax_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	fax_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	fax_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	fax_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	fax_EQUAL?: InputMaybe<Scalars["String"]>;
	fax_GT?: InputMaybe<Scalars["Int"]>;
	fax_GTE?: InputMaybe<Scalars["Int"]>;
	fax_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	fax_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	fax_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	fax_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	fax_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	fax_LT?: InputMaybe<Scalars["Int"]>;
	fax_LTE?: InputMaybe<Scalars["Int"]>;
	fax_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	fax_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	fax_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	fax_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	fax_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	legalName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	legalName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	legalName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	legalName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	legalName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	legalName_EQUAL?: InputMaybe<Scalars["String"]>;
	legalName_GT?: InputMaybe<Scalars["Int"]>;
	legalName_GTE?: InputMaybe<Scalars["Int"]>;
	legalName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	legalName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	legalName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	legalName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	legalName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	legalName_LT?: InputMaybe<Scalars["Int"]>;
	legalName_LTE?: InputMaybe<Scalars["Int"]>;
	legalName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	legalName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	legalName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	legalName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	legalName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	logo_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	logo_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	logo_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	logo_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	logo_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	logo_EQUAL?: InputMaybe<Scalars["String"]>;
	logo_GT?: InputMaybe<Scalars["Int"]>;
	logo_GTE?: InputMaybe<Scalars["Int"]>;
	logo_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	logo_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	logo_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	logo_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	logo_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	logo_LT?: InputMaybe<Scalars["Int"]>;
	logo_LTE?: InputMaybe<Scalars["Int"]>;
	logo_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	logo_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	logo_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	logo_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	logo_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	name_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	name_EQUAL?: InputMaybe<Scalars["String"]>;
	name_GT?: InputMaybe<Scalars["Int"]>;
	name_GTE?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	name_LT?: InputMaybe<Scalars["Int"]>;
	name_LTE?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	phone_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	phone_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	phone_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	phone_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	phone_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	phone_EQUAL?: InputMaybe<Scalars["String"]>;
	phone_GT?: InputMaybe<Scalars["Int"]>;
	phone_GTE?: InputMaybe<Scalars["Int"]>;
	phone_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	phone_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	phone_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	phone_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	phone_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	phone_LT?: InputMaybe<Scalars["Int"]>;
	phone_LTE?: InputMaybe<Scalars["Int"]>;
	phone_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	phone_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	phone_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	phone_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	phone_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	tenantId_EQUAL?: InputMaybe<Scalars["String"]>;
	tenantId_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	website_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	website_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	website_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	website_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	website_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	website_EQUAL?: InputMaybe<Scalars["String"]>;
	website_GT?: InputMaybe<Scalars["Int"]>;
	website_GTE?: InputMaybe<Scalars["Int"]>;
	website_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	website_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	website_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	website_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	website_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	website_LT?: InputMaybe<Scalars["Int"]>;
	website_LTE?: InputMaybe<Scalars["Int"]>;
	website_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	website_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	website_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	website_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	website_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type CoverageRequestLegalEntityRelationship = {
	__typename?: "CoverageRequestLegalEntityRelationship";
	cursor: Scalars["String"];
	node: Organization;
};

export type CoverageRequestLegalEntityUpdateConnectionInput = {
	node?: InputMaybe<OrganizationUpdateInput>;
};

export type CoverageRequestLegalEntityUpdateFieldInput = {
	connect?: InputMaybe<CoverageRequestLegalEntityConnectFieldInput>;
	create?: InputMaybe<CoverageRequestLegalEntityCreateFieldInput>;
	delete?: InputMaybe<CoverageRequestLegalEntityDeleteFieldInput>;
	disconnect?: InputMaybe<CoverageRequestLegalEntityDisconnectFieldInput>;
	update?: InputMaybe<CoverageRequestLegalEntityUpdateConnectionInput>;
	where?: InputMaybe<CoverageRequestLegalEntityConnectionWhere>;
};

export type CoverageRequestOptions = {
	limit?: InputMaybe<Scalars["Int"]>;
	offset?: InputMaybe<Scalars["Int"]>;
	/** Specify one or more CoverageRequestSort objects to sort CoverageRequests by. The sorts will be applied in the order in which they are arranged in the array. */
	sort?: InputMaybe<Array<InputMaybe<CoverageRequestSort>>>;
};

export type CoverageRequestPatientAggregateInput = {
	AND?: InputMaybe<Array<CoverageRequestPatientAggregateInput>>;
	OR?: InputMaybe<Array<CoverageRequestPatientAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<CoverageRequestPatientNodeAggregationWhereInput>;
};

export type CoverageRequestPatientConnectFieldInput = {
	connect?: InputMaybe<PatientConnectInput>;
	where?: InputMaybe<PatientConnectWhere>;
};

export type CoverageRequestPatientConnection = {
	__typename?: "CoverageRequestPatientConnection";
	edges: Array<CoverageRequestPatientRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type CoverageRequestPatientConnectionSort = {
	node?: InputMaybe<PatientSort>;
};

export type CoverageRequestPatientConnectionWhere = {
	AND?: InputMaybe<Array<CoverageRequestPatientConnectionWhere>>;
	OR?: InputMaybe<Array<CoverageRequestPatientConnectionWhere>>;
	node?: InputMaybe<PatientWhere>;
	node_NOT?: InputMaybe<PatientWhere>;
};

export type CoverageRequestPatientCreateFieldInput = {
	node: PatientCreateInput;
};

export type CoverageRequestPatientDeleteFieldInput = {
	delete?: InputMaybe<PatientDeleteInput>;
	where?: InputMaybe<CoverageRequestPatientConnectionWhere>;
};

export type CoverageRequestPatientDisconnectFieldInput = {
	disconnect?: InputMaybe<PatientDisconnectInput>;
	where?: InputMaybe<CoverageRequestPatientConnectionWhere>;
};

export type CoverageRequestPatientFieldInput = {
	connect?: InputMaybe<CoverageRequestPatientConnectFieldInput>;
	create?: InputMaybe<CoverageRequestPatientCreateFieldInput>;
};

export type CoverageRequestPatientFormDataInput = {
	initials?: InputMaybe<Scalars["String"]>;
	insuranceId: Scalars["String"];
	yearOfBirth?: InputMaybe<Scalars["Int"]>;
};

export type CoverageRequestPatientNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<CoverageRequestPatientNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<CoverageRequestPatientNodeAggregationWhereInput>>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	initials_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	initials_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	initials_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	initials_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	initials_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	initials_EQUAL?: InputMaybe<Scalars["String"]>;
	initials_GT?: InputMaybe<Scalars["Int"]>;
	initials_GTE?: InputMaybe<Scalars["Int"]>;
	initials_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	initials_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	initials_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	initials_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	initials_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	initials_LT?: InputMaybe<Scalars["Int"]>;
	initials_LTE?: InputMaybe<Scalars["Int"]>;
	initials_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	initials_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	initials_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	initials_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	initials_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	insuranceId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	insuranceId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	insuranceId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	insuranceId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	insuranceId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	insuranceId_EQUAL?: InputMaybe<Scalars["String"]>;
	insuranceId_GT?: InputMaybe<Scalars["Int"]>;
	insuranceId_GTE?: InputMaybe<Scalars["Int"]>;
	insuranceId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	insuranceId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	insuranceId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	insuranceId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	insuranceId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	insuranceId_LT?: InputMaybe<Scalars["Int"]>;
	insuranceId_LTE?: InputMaybe<Scalars["Int"]>;
	insuranceId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	insuranceId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	insuranceId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	insuranceId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	insuranceId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	tenantId_EQUAL?: InputMaybe<Scalars["String"]>;
	tenantId_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	timeStamp_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	timeStamp_GT?: InputMaybe<Scalars["DateTime"]>;
	timeStamp_GTE?: InputMaybe<Scalars["DateTime"]>;
	timeStamp_LT?: InputMaybe<Scalars["DateTime"]>;
	timeStamp_LTE?: InputMaybe<Scalars["DateTime"]>;
	timeStamp_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	timeStamp_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	timeStamp_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	timeStamp_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	timeStamp_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	timeStamp_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	timeStamp_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	timeStamp_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	timeStamp_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	timeStamp_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	yearOfBirth_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	yearOfBirth_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	yearOfBirth_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	yearOfBirth_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	yearOfBirth_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	yearOfBirth_EQUAL?: InputMaybe<Scalars["Int"]>;
	yearOfBirth_GT?: InputMaybe<Scalars["Int"]>;
	yearOfBirth_GTE?: InputMaybe<Scalars["Int"]>;
	yearOfBirth_LT?: InputMaybe<Scalars["Int"]>;
	yearOfBirth_LTE?: InputMaybe<Scalars["Int"]>;
	yearOfBirth_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	yearOfBirth_MAX_GT?: InputMaybe<Scalars["Int"]>;
	yearOfBirth_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	yearOfBirth_MAX_LT?: InputMaybe<Scalars["Int"]>;
	yearOfBirth_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	yearOfBirth_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	yearOfBirth_MIN_GT?: InputMaybe<Scalars["Int"]>;
	yearOfBirth_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	yearOfBirth_MIN_LT?: InputMaybe<Scalars["Int"]>;
	yearOfBirth_MIN_LTE?: InputMaybe<Scalars["Int"]>;
};

export type CoverageRequestPatientRelationship = {
	__typename?: "CoverageRequestPatientRelationship";
	cursor: Scalars["String"];
	node: Patient;
};

export type CoverageRequestPatientUpdateConnectionInput = {
	node?: InputMaybe<PatientUpdateInput>;
};

export type CoverageRequestPatientUpdateFieldInput = {
	connect?: InputMaybe<CoverageRequestPatientConnectFieldInput>;
	create?: InputMaybe<CoverageRequestPatientCreateFieldInput>;
	delete?: InputMaybe<CoverageRequestPatientDeleteFieldInput>;
	disconnect?: InputMaybe<CoverageRequestPatientDisconnectFieldInput>;
	update?: InputMaybe<CoverageRequestPatientUpdateConnectionInput>;
	where?: InputMaybe<CoverageRequestPatientConnectionWhere>;
};

export type CoverageRequestPreparationFormDataInput = {
	brandName?: InputMaybe<Scalars["String"]>;
	genericName?: InputMaybe<Scalars["String"]>;
};

export type CoverageRequestPreparationsAggregateInput = {
	AND?: InputMaybe<Array<CoverageRequestPreparationsAggregateInput>>;
	OR?: InputMaybe<Array<CoverageRequestPreparationsAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<CoverageRequestPreparationsNodeAggregationWhereInput>;
};

export type CoverageRequestPreparationsConnectFieldInput = {
	connect?: InputMaybe<Array<PreparationConnectInput>>;
	where?: InputMaybe<PreparationConnectWhere>;
};

export type CoverageRequestPreparationsConnection = {
	__typename?: "CoverageRequestPreparationsConnection";
	edges: Array<CoverageRequestPreparationsRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type CoverageRequestPreparationsConnectionSort = {
	node?: InputMaybe<PreparationSort>;
};

export type CoverageRequestPreparationsConnectionWhere = {
	AND?: InputMaybe<Array<CoverageRequestPreparationsConnectionWhere>>;
	OR?: InputMaybe<Array<CoverageRequestPreparationsConnectionWhere>>;
	node?: InputMaybe<PreparationWhere>;
	node_NOT?: InputMaybe<PreparationWhere>;
};

export type CoverageRequestPreparationsCreateFieldInput = {
	node: PreparationCreateInput;
};

export type CoverageRequestPreparationsDeleteFieldInput = {
	delete?: InputMaybe<PreparationDeleteInput>;
	where?: InputMaybe<CoverageRequestPreparationsConnectionWhere>;
};

export type CoverageRequestPreparationsDisconnectFieldInput = {
	disconnect?: InputMaybe<PreparationDisconnectInput>;
	where?: InputMaybe<CoverageRequestPreparationsConnectionWhere>;
};

export type CoverageRequestPreparationsFieldInput = {
	connect?: InputMaybe<Array<CoverageRequestPreparationsConnectFieldInput>>;
	create?: InputMaybe<Array<CoverageRequestPreparationsCreateFieldInput>>;
};

export type CoverageRequestPreparationsNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<CoverageRequestPreparationsNodeAggregationWhereInput>>;
	AtcCode_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	AtcCode_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	AtcCode_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	AtcCode_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	AtcCode_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	AtcCode_EQUAL?: InputMaybe<Scalars["String"]>;
	AtcCode_GT?: InputMaybe<Scalars["Int"]>;
	AtcCode_GTE?: InputMaybe<Scalars["Int"]>;
	AtcCode_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	AtcCode_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	AtcCode_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	AtcCode_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	AtcCode_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	AtcCode_LT?: InputMaybe<Scalars["Int"]>;
	AtcCode_LTE?: InputMaybe<Scalars["Int"]>;
	AtcCode_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	AtcCode_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	AtcCode_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	AtcCode_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	AtcCode_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	BrandName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	BrandName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	BrandName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	BrandName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	BrandName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	BrandName_EQUAL?: InputMaybe<Scalars["String"]>;
	BrandName_GT?: InputMaybe<Scalars["Int"]>;
	BrandName_GTE?: InputMaybe<Scalars["Int"]>;
	BrandName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	BrandName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	BrandName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	BrandName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	BrandName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	BrandName_LT?: InputMaybe<Scalars["Int"]>;
	BrandName_LTE?: InputMaybe<Scalars["Int"]>;
	BrandName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	BrandName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	BrandName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	BrandName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	BrandName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	DescriptionDe_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	DescriptionDe_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	DescriptionDe_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	DescriptionDe_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	DescriptionDe_EQUAL?: InputMaybe<Scalars["String"]>;
	DescriptionDe_GT?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_GTE?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_LT?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_LTE?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	GenericName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	GenericName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	GenericName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	GenericName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	GenericName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	GenericName_EQUAL?: InputMaybe<Scalars["String"]>;
	GenericName_GT?: InputMaybe<Scalars["Int"]>;
	GenericName_GTE?: InputMaybe<Scalars["Int"]>;
	GenericName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	GenericName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	GenericName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	GenericName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	GenericName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	GenericName_LT?: InputMaybe<Scalars["Int"]>;
	GenericName_LTE?: InputMaybe<Scalars["Int"]>;
	GenericName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	GenericName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	GenericName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	GenericName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	GenericName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	OR?: InputMaybe<Array<CoverageRequestPreparationsNodeAggregationWhereInput>>;
	SwissmedicNo5_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo5_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo5_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo5_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo5_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo5_EQUAL?: InputMaybe<Scalars["String"]>;
	SwissmedicNo5_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo5_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo5_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo5_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo5_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo5_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo5_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo5_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo5_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo5_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo5_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo5_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo5_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo5_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
};

export type CoverageRequestPreparationsRelationship = {
	__typename?: "CoverageRequestPreparationsRelationship";
	cursor: Scalars["String"];
	node: Preparation;
};

export type CoverageRequestPreparationsUpdateConnectionInput = {
	node?: InputMaybe<PreparationUpdateInput>;
};

export type CoverageRequestPreparationsUpdateFieldInput = {
	connect?: InputMaybe<Array<CoverageRequestPreparationsConnectFieldInput>>;
	create?: InputMaybe<Array<CoverageRequestPreparationsCreateFieldInput>>;
	delete?: InputMaybe<Array<CoverageRequestPreparationsDeleteFieldInput>>;
	disconnect?: InputMaybe<Array<CoverageRequestPreparationsDisconnectFieldInput>>;
	update?: InputMaybe<CoverageRequestPreparationsUpdateConnectionInput>;
	where?: InputMaybe<CoverageRequestPreparationsConnectionWhere>;
};

export enum CoverageRequestRating {
	A = "A",
	B = "B",
	C = "C",
}

/** Fields to sort CoverageRequests by. The order in which sorts are applied is not guaranteed when specifying many fields in one CoverageRequestSort object. */
export type CoverageRequestSort = {
	canBeDeleted?: InputMaybe<SortDirection>;
	coverageEndDate?: InputMaybe<SortDirection>;
	coverageStartDate?: InputMaybe<SortDirection>;
	createdOn?: InputMaybe<SortDirection>;
	decisionCommunicatedOn?: InputMaybe<SortDirection>;
	duration?: InputMaybe<SortDirection>;
	durationUom?: InputMaybe<SortDirection>;
	id?: InputMaybe<SortDirection>;
	intendedStartDate?: InputMaybe<SortDirection>;
	isArchived?: InputMaybe<SortDirection>;
	isDeleted?: InputMaybe<SortDirection>;
	lastUpdatedOn?: InputMaybe<SortDirection>;
	rating?: InputMaybe<SortDirection>;
	requestReceiptDate?: InputMaybe<SortDirection>;
	status?: InputMaybe<SortDirection>;
	submissionDate?: InputMaybe<SortDirection>;
	tenantId?: InputMaybe<SortDirection>;
	therapyDecision?: InputMaybe<SortDirection>;
};

export enum CoverageRequestTherapyDecision {
	Approved = "APPROVED",
	Trial = "TRIAL",
}

export type CoverageRequestTreatingPhysicianAggregateInput = {
	AND?: InputMaybe<Array<CoverageRequestTreatingPhysicianAggregateInput>>;
	OR?: InputMaybe<Array<CoverageRequestTreatingPhysicianAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<CoverageRequestTreatingPhysicianNodeAggregationWhereInput>;
};

export type CoverageRequestTreatingPhysicianConnectFieldInput = {
	where?: InputMaybe<TreatingPhysicianConnectWhere>;
};

export type CoverageRequestTreatingPhysicianConnection = {
	__typename?: "CoverageRequestTreatingPhysicianConnection";
	edges: Array<CoverageRequestTreatingPhysicianRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type CoverageRequestTreatingPhysicianConnectionSort = {
	node?: InputMaybe<TreatingPhysicianSort>;
};

export type CoverageRequestTreatingPhysicianConnectionWhere = {
	AND?: InputMaybe<Array<CoverageRequestTreatingPhysicianConnectionWhere>>;
	OR?: InputMaybe<Array<CoverageRequestTreatingPhysicianConnectionWhere>>;
	node?: InputMaybe<TreatingPhysicianWhere>;
	node_NOT?: InputMaybe<TreatingPhysicianWhere>;
};

export type CoverageRequestTreatingPhysicianCreateFieldInput = {
	node: TreatingPhysicianCreateInput;
};

export type CoverageRequestTreatingPhysicianDeleteFieldInput = {
	where?: InputMaybe<CoverageRequestTreatingPhysicianConnectionWhere>;
};

export type CoverageRequestTreatingPhysicianDisconnectFieldInput = {
	where?: InputMaybe<CoverageRequestTreatingPhysicianConnectionWhere>;
};

export type CoverageRequestTreatingPhysicianFieldInput = {
	connect?: InputMaybe<CoverageRequestTreatingPhysicianConnectFieldInput>;
	create?: InputMaybe<CoverageRequestTreatingPhysicianCreateFieldInput>;
};

export type CoverageRequestTreatingPhysicianNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<CoverageRequestTreatingPhysicianNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<CoverageRequestTreatingPhysicianNodeAggregationWhereInput>>;
	department_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	department_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	department_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	department_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	department_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	department_EQUAL?: InputMaybe<Scalars["String"]>;
	department_GT?: InputMaybe<Scalars["Int"]>;
	department_GTE?: InputMaybe<Scalars["Int"]>;
	department_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	department_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	department_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	department_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	department_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	department_LT?: InputMaybe<Scalars["Int"]>;
	department_LTE?: InputMaybe<Scalars["Int"]>;
	department_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	department_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	department_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	department_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	department_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	email_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	email_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	email_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	email_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	email_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	email_EQUAL?: InputMaybe<Scalars["String"]>;
	email_GT?: InputMaybe<Scalars["Int"]>;
	email_GTE?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	email_LT?: InputMaybe<Scalars["Int"]>;
	email_LTE?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	firstName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	firstName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	firstName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	firstName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	firstName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	firstName_EQUAL?: InputMaybe<Scalars["String"]>;
	firstName_GT?: InputMaybe<Scalars["Int"]>;
	firstName_GTE?: InputMaybe<Scalars["Int"]>;
	firstName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	firstName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	firstName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	firstName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	firstName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	firstName_LT?: InputMaybe<Scalars["Int"]>;
	firstName_LTE?: InputMaybe<Scalars["Int"]>;
	firstName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	firstName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	firstName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	firstName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	firstName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	hospitalName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	hospitalName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	hospitalName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	hospitalName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	hospitalName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	hospitalName_EQUAL?: InputMaybe<Scalars["String"]>;
	hospitalName_GT?: InputMaybe<Scalars["Int"]>;
	hospitalName_GTE?: InputMaybe<Scalars["Int"]>;
	hospitalName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	hospitalName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	hospitalName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	hospitalName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	hospitalName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	hospitalName_LT?: InputMaybe<Scalars["Int"]>;
	hospitalName_LTE?: InputMaybe<Scalars["Int"]>;
	hospitalName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	hospitalName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	hospitalName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	hospitalName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	hospitalName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	lastName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	lastName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	lastName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	lastName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	lastName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	lastName_EQUAL?: InputMaybe<Scalars["String"]>;
	lastName_GT?: InputMaybe<Scalars["Int"]>;
	lastName_GTE?: InputMaybe<Scalars["Int"]>;
	lastName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	lastName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	lastName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	lastName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	lastName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	lastName_LT?: InputMaybe<Scalars["Int"]>;
	lastName_LTE?: InputMaybe<Scalars["Int"]>;
	lastName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	lastName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	lastName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	lastName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	lastName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	nr_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	nr_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	nr_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	nr_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	nr_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	nr_EQUAL?: InputMaybe<Scalars["String"]>;
	nr_GT?: InputMaybe<Scalars["Int"]>;
	nr_GTE?: InputMaybe<Scalars["Int"]>;
	nr_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	nr_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	nr_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	nr_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	nr_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	nr_LT?: InputMaybe<Scalars["Int"]>;
	nr_LTE?: InputMaybe<Scalars["Int"]>;
	nr_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	nr_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	nr_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	nr_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	nr_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	phoneNo_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	phoneNo_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	phoneNo_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	phoneNo_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	phoneNo_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	phoneNo_EQUAL?: InputMaybe<Scalars["String"]>;
	phoneNo_GT?: InputMaybe<Scalars["Int"]>;
	phoneNo_GTE?: InputMaybe<Scalars["Int"]>;
	phoneNo_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	phoneNo_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	phoneNo_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	phoneNo_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	phoneNo_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	phoneNo_LT?: InputMaybe<Scalars["Int"]>;
	phoneNo_LTE?: InputMaybe<Scalars["Int"]>;
	phoneNo_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	phoneNo_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	phoneNo_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	phoneNo_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	phoneNo_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	place_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	place_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	place_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	place_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	place_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	place_EQUAL?: InputMaybe<Scalars["String"]>;
	place_GT?: InputMaybe<Scalars["Int"]>;
	place_GTE?: InputMaybe<Scalars["Int"]>;
	place_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	place_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	place_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	place_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	place_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	place_LT?: InputMaybe<Scalars["Int"]>;
	place_LTE?: InputMaybe<Scalars["Int"]>;
	place_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	place_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	place_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	place_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	place_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	postcode_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	postcode_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	postcode_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	postcode_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	postcode_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	postcode_EQUAL?: InputMaybe<Scalars["String"]>;
	postcode_GT?: InputMaybe<Scalars["Int"]>;
	postcode_GTE?: InputMaybe<Scalars["Int"]>;
	postcode_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	postcode_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	postcode_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	postcode_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	postcode_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	postcode_LT?: InputMaybe<Scalars["Int"]>;
	postcode_LTE?: InputMaybe<Scalars["Int"]>;
	postcode_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	postcode_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	postcode_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	postcode_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	postcode_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	street_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	street_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	street_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	street_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	street_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	street_EQUAL?: InputMaybe<Scalars["String"]>;
	street_GT?: InputMaybe<Scalars["Int"]>;
	street_GTE?: InputMaybe<Scalars["Int"]>;
	street_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	street_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	street_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	street_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	street_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	street_LT?: InputMaybe<Scalars["Int"]>;
	street_LTE?: InputMaybe<Scalars["Int"]>;
	street_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	street_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	street_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	street_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	street_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type CoverageRequestTreatingPhysicianRelationship = {
	__typename?: "CoverageRequestTreatingPhysicianRelationship";
	cursor: Scalars["String"];
	node: TreatingPhysician;
};

export type CoverageRequestTreatingPhysicianUpdateConnectionInput = {
	node?: InputMaybe<TreatingPhysicianUpdateInput>;
};

export type CoverageRequestTreatingPhysicianUpdateFieldInput = {
	connect?: InputMaybe<CoverageRequestTreatingPhysicianConnectFieldInput>;
	create?: InputMaybe<CoverageRequestTreatingPhysicianCreateFieldInput>;
	delete?: InputMaybe<CoverageRequestTreatingPhysicianDeleteFieldInput>;
	disconnect?: InputMaybe<CoverageRequestTreatingPhysicianDisconnectFieldInput>;
	update?: InputMaybe<CoverageRequestTreatingPhysicianUpdateConnectionInput>;
	where?: InputMaybe<CoverageRequestTreatingPhysicianConnectionWhere>;
};

export type CoverageRequestUnsortedContinuousBenefitsAggregateInput = {
	AND?: InputMaybe<Array<CoverageRequestUnsortedContinuousBenefitsAggregateInput>>;
	OR?: InputMaybe<Array<CoverageRequestUnsortedContinuousBenefitsAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<CoverageRequestUnsortedContinuousBenefitsNodeAggregationWhereInput>;
};

export type CoverageRequestUnsortedContinuousBenefitsConnectFieldInput = {
	connect?: InputMaybe<Array<ContinuousBenefitConnectInput>>;
	where?: InputMaybe<ContinuousBenefitConnectWhere>;
};

export type CoverageRequestUnsortedContinuousBenefitsConnection = {
	__typename?: "CoverageRequestUnsortedContinuousBenefitsConnection";
	edges: Array<CoverageRequestUnsortedContinuousBenefitsRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type CoverageRequestUnsortedContinuousBenefitsConnectionSort = {
	node?: InputMaybe<ContinuousBenefitSort>;
};

export type CoverageRequestUnsortedContinuousBenefitsConnectionWhere = {
	AND?: InputMaybe<Array<CoverageRequestUnsortedContinuousBenefitsConnectionWhere>>;
	OR?: InputMaybe<Array<CoverageRequestUnsortedContinuousBenefitsConnectionWhere>>;
	node?: InputMaybe<ContinuousBenefitWhere>;
	node_NOT?: InputMaybe<ContinuousBenefitWhere>;
};

export type CoverageRequestUnsortedContinuousBenefitsCreateFieldInput = {
	node: ContinuousBenefitCreateInput;
};

export type CoverageRequestUnsortedContinuousBenefitsDeleteFieldInput = {
	delete?: InputMaybe<ContinuousBenefitDeleteInput>;
	where?: InputMaybe<CoverageRequestUnsortedContinuousBenefitsConnectionWhere>;
};

export type CoverageRequestUnsortedContinuousBenefitsDisconnectFieldInput = {
	disconnect?: InputMaybe<ContinuousBenefitDisconnectInput>;
	where?: InputMaybe<CoverageRequestUnsortedContinuousBenefitsConnectionWhere>;
};

export type CoverageRequestUnsortedContinuousBenefitsFieldInput = {
	connect?: InputMaybe<Array<CoverageRequestUnsortedContinuousBenefitsConnectFieldInput>>;
	create?: InputMaybe<Array<CoverageRequestUnsortedContinuousBenefitsCreateFieldInput>>;
};

export type CoverageRequestUnsortedContinuousBenefitsNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<CoverageRequestUnsortedContinuousBenefitsNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<CoverageRequestUnsortedContinuousBenefitsNodeAggregationWhereInput>>;
	createdOn_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	submissionDate_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_GT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_GTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_LT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_LTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	tenantId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	tenantId_EQUAL?: InputMaybe<Scalars["String"]>;
	tenantId_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type CoverageRequestUnsortedContinuousBenefitsRelationship = {
	__typename?: "CoverageRequestUnsortedContinuousBenefitsRelationship";
	cursor: Scalars["String"];
	node: ContinuousBenefit;
};

export type CoverageRequestUnsortedContinuousBenefitsUpdateConnectionInput = {
	node?: InputMaybe<ContinuousBenefitUpdateInput>;
};

export type CoverageRequestUnsortedContinuousBenefitsUpdateFieldInput = {
	connect?: InputMaybe<Array<CoverageRequestUnsortedContinuousBenefitsConnectFieldInput>>;
	create?: InputMaybe<Array<CoverageRequestUnsortedContinuousBenefitsCreateFieldInput>>;
	delete?: InputMaybe<Array<CoverageRequestUnsortedContinuousBenefitsDeleteFieldInput>>;
	disconnect?: InputMaybe<Array<CoverageRequestUnsortedContinuousBenefitsDisconnectFieldInput>>;
	update?: InputMaybe<CoverageRequestUnsortedContinuousBenefitsUpdateConnectionInput>;
	where?: InputMaybe<CoverageRequestUnsortedContinuousBenefitsConnectionWhere>;
};

export type CoverageRequestUpdateInput = {
	caseId?: InputMaybe<Scalars["ID"]>;
	coverageEndDate?: InputMaybe<Scalars["Date"]>;
	coverageStartDate?: InputMaybe<Scalars["Date"]>;
	decisionCommunicatedOn?: InputMaybe<Scalars["Date"]>;
	diseaseCode: Scalars["String"];
	duration?: InputMaybe<Scalars["Int"]>;
	durationUom?: InputMaybe<DurationUom>;
	evergreenCrEndDate?: InputMaybe<Scalars["Date"]>;
	evergreenCrId?: InputMaybe<Scalars["String"]>;
	formId?: InputMaybe<Scalars["ID"]>;
	indicationCode: Scalars["String"];
	intendedStartDate?: InputMaybe<Scalars["Date"]>;
	legalEntityId?: InputMaybe<Scalars["String"]>;
	patient?: InputMaybe<CoverageRequestPatientFormDataInput>;
	preparations: Array<CoverageRequestPreparationFormDataInput>;
	rating?: InputMaybe<CoverageRequestRating>;
	requestReceiptDate: Scalars["Date"];
	status?: InputMaybe<FormStatus>;
	submissionDate?: InputMaybe<Scalars["DateTime"]>;
	therapyDecision?: InputMaybe<CoverageRequestTherapyDecision>;
	treatingPhysician?: InputMaybe<TreatingPhysicianInput>;
};

export type CoverageRequestWhere = {
	AND?: InputMaybe<Array<CoverageRequestWhere>>;
	OR?: InputMaybe<Array<CoverageRequestWhere>>;
	canBeDeleted?: InputMaybe<Scalars["Boolean"]>;
	canBeDeleted_NOT?: InputMaybe<Scalars["Boolean"]>;
	case?: InputMaybe<CaseWhere>;
	caseAggregate?: InputMaybe<CoverageRequestCaseAggregateInput>;
	caseConnection?: InputMaybe<CoverageRequestCaseConnectionWhere>;
	caseConnection_NOT?: InputMaybe<CoverageRequestCaseConnectionWhere>;
	case_NOT?: InputMaybe<CaseWhere>;
	continuousBenefitsWithDrafts?: InputMaybe<ContinuousBenefitWhere>;
	continuousBenefitsWithDraftsAggregate?: InputMaybe<CoverageRequestContinuousBenefitsWithDraftsAggregateInput>;
	continuousBenefitsWithDraftsConnection?: InputMaybe<CoverageRequestContinuousBenefitsWithDraftsConnectionWhere>;
	continuousBenefitsWithDraftsConnection_NOT?: InputMaybe<CoverageRequestContinuousBenefitsWithDraftsConnectionWhere>;
	continuousBenefitsWithDrafts_NOT?: InputMaybe<ContinuousBenefitWhere>;
	coverageEndDate?: InputMaybe<Scalars["Date"]>;
	coverageEndDate_GT?: InputMaybe<Scalars["Date"]>;
	coverageEndDate_GTE?: InputMaybe<Scalars["Date"]>;
	coverageEndDate_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
	coverageEndDate_LT?: InputMaybe<Scalars["Date"]>;
	coverageEndDate_LTE?: InputMaybe<Scalars["Date"]>;
	coverageEndDate_NOT?: InputMaybe<Scalars["Date"]>;
	coverageEndDate_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
	coverageStartDate?: InputMaybe<Scalars["Date"]>;
	coverageStartDate_GT?: InputMaybe<Scalars["Date"]>;
	coverageStartDate_GTE?: InputMaybe<Scalars["Date"]>;
	coverageStartDate_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
	coverageStartDate_LT?: InputMaybe<Scalars["Date"]>;
	coverageStartDate_LTE?: InputMaybe<Scalars["Date"]>;
	coverageStartDate_NOT?: InputMaybe<Scalars["Date"]>;
	coverageStartDate_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
	createdBy?: InputMaybe<UserWhere>;
	createdByAggregate?: InputMaybe<CoverageRequestCreatedByAggregateInput>;
	createdByConnection?: InputMaybe<CoverageRequestCreatedByConnectionWhere>;
	createdByConnection_NOT?: InputMaybe<CoverageRequestCreatedByConnectionWhere>;
	createdBy_NOT?: InputMaybe<UserWhere>;
	createdOn?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_IN?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]>>>;
	createdOn_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_NOT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]>>>;
	decisionCommunicatedOn?: InputMaybe<Scalars["Date"]>;
	decisionCommunicatedOn_GT?: InputMaybe<Scalars["Date"]>;
	decisionCommunicatedOn_GTE?: InputMaybe<Scalars["Date"]>;
	decisionCommunicatedOn_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
	decisionCommunicatedOn_LT?: InputMaybe<Scalars["Date"]>;
	decisionCommunicatedOn_LTE?: InputMaybe<Scalars["Date"]>;
	decisionCommunicatedOn_NOT?: InputMaybe<Scalars["Date"]>;
	decisionCommunicatedOn_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
	discontinuationNote?: InputMaybe<DiscontinuationNoteWhere>;
	discontinuationNoteAggregate?: InputMaybe<CoverageRequestDiscontinuationNoteAggregateInput>;
	discontinuationNoteConnection?: InputMaybe<CoverageRequestDiscontinuationNoteConnectionWhere>;
	discontinuationNoteConnection_NOT?: InputMaybe<CoverageRequestDiscontinuationNoteConnectionWhere>;
	discontinuationNote_NOT?: InputMaybe<DiscontinuationNoteWhere>;
	disease?: InputMaybe<DiseaseWhere>;
	diseaseAggregate?: InputMaybe<CoverageRequestDiseaseAggregateInput>;
	diseaseConnection?: InputMaybe<CoverageRequestDiseaseConnectionWhere>;
	diseaseConnection_NOT?: InputMaybe<CoverageRequestDiseaseConnectionWhere>;
	disease_NOT?: InputMaybe<DiseaseWhere>;
	duration?: InputMaybe<Scalars["Int"]>;
	durationUom?: InputMaybe<DurationUom>;
	durationUom_IN?: InputMaybe<Array<InputMaybe<DurationUom>>>;
	durationUom_NOT?: InputMaybe<DurationUom>;
	durationUom_NOT_IN?: InputMaybe<Array<InputMaybe<DurationUom>>>;
	duration_GT?: InputMaybe<Scalars["Int"]>;
	duration_GTE?: InputMaybe<Scalars["Int"]>;
	duration_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	duration_LT?: InputMaybe<Scalars["Int"]>;
	duration_LTE?: InputMaybe<Scalars["Int"]>;
	duration_NOT?: InputMaybe<Scalars["Int"]>;
	duration_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	financialDataPoints?: InputMaybe<FinancialDataPointWhere>;
	financialDataPointsAggregate?: InputMaybe<CoverageRequestFinancialDataPointsAggregateInput>;
	financialDataPointsConnection?: InputMaybe<CoverageRequestFinancialDataPointsConnectionWhere>;
	financialDataPointsConnection_NOT?: InputMaybe<CoverageRequestFinancialDataPointsConnectionWhere>;
	financialDataPoints_NOT?: InputMaybe<FinancialDataPointWhere>;
	form?: InputMaybe<FormWhere>;
	formAggregate?: InputMaybe<CoverageRequestFormAggregateInput>;
	formConnection?: InputMaybe<CoverageRequestFormConnectionWhere>;
	formConnection_NOT?: InputMaybe<CoverageRequestFormConnectionWhere>;
	form_NOT?: InputMaybe<FormWhere>;
	id?: InputMaybe<Scalars["ID"]>;
	id_CONTAINS?: InputMaybe<Scalars["ID"]>;
	id_ENDS_WITH?: InputMaybe<Scalars["ID"]>;
	id_IN?: InputMaybe<Array<InputMaybe<Scalars["ID"]>>>;
	id_MATCHES?: InputMaybe<Scalars["String"]>;
	id_NOT?: InputMaybe<Scalars["ID"]>;
	id_NOT_CONTAINS?: InputMaybe<Scalars["ID"]>;
	id_NOT_ENDS_WITH?: InputMaybe<Scalars["ID"]>;
	id_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["ID"]>>>;
	id_NOT_STARTS_WITH?: InputMaybe<Scalars["ID"]>;
	id_STARTS_WITH?: InputMaybe<Scalars["ID"]>;
	indication?: InputMaybe<IndicationWhere>;
	indicationAggregate?: InputMaybe<CoverageRequestIndicationAggregateInput>;
	indicationConnection?: InputMaybe<CoverageRequestIndicationConnectionWhere>;
	indicationConnection_NOT?: InputMaybe<CoverageRequestIndicationConnectionWhere>;
	indication_NOT?: InputMaybe<IndicationWhere>;
	initialResponse?: InputMaybe<InitialResponseWhere>;
	initialResponseAggregate?: InputMaybe<CoverageRequestInitialResponseAggregateInput>;
	initialResponseConnection?: InputMaybe<CoverageRequestInitialResponseConnectionWhere>;
	initialResponseConnection_NOT?: InputMaybe<CoverageRequestInitialResponseConnectionWhere>;
	initialResponse_NOT?: InputMaybe<InitialResponseWhere>;
	intendedStartDate?: InputMaybe<Scalars["Date"]>;
	intendedStartDate_GT?: InputMaybe<Scalars["Date"]>;
	intendedStartDate_GTE?: InputMaybe<Scalars["Date"]>;
	intendedStartDate_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
	intendedStartDate_LT?: InputMaybe<Scalars["Date"]>;
	intendedStartDate_LTE?: InputMaybe<Scalars["Date"]>;
	intendedStartDate_NOT?: InputMaybe<Scalars["Date"]>;
	intendedStartDate_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
	isArchived?: InputMaybe<Scalars["Boolean"]>;
	isArchived_NOT?: InputMaybe<Scalars["Boolean"]>;
	isDeleted?: InputMaybe<Scalars["Boolean"]>;
	isDeleted_NOT?: InputMaybe<Scalars["Boolean"]>;
	lastUpdatedOn?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_GT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_IN?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]>>>;
	lastUpdatedOn_LT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_NOT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]>>>;
	legalEntity?: InputMaybe<OrganizationWhere>;
	legalEntityAggregate?: InputMaybe<CoverageRequestLegalEntityAggregateInput>;
	legalEntityConnection?: InputMaybe<CoverageRequestLegalEntityConnectionWhere>;
	legalEntityConnection_NOT?: InputMaybe<CoverageRequestLegalEntityConnectionWhere>;
	legalEntity_NOT?: InputMaybe<OrganizationWhere>;
	patient?: InputMaybe<PatientWhere>;
	patientAggregate?: InputMaybe<CoverageRequestPatientAggregateInput>;
	patientConnection?: InputMaybe<CoverageRequestPatientConnectionWhere>;
	patientConnection_NOT?: InputMaybe<CoverageRequestPatientConnectionWhere>;
	patient_NOT?: InputMaybe<PatientWhere>;
	preparations?: InputMaybe<PreparationWhere>;
	preparationsAggregate?: InputMaybe<CoverageRequestPreparationsAggregateInput>;
	preparationsConnection?: InputMaybe<CoverageRequestPreparationsConnectionWhere>;
	preparationsConnection_NOT?: InputMaybe<CoverageRequestPreparationsConnectionWhere>;
	preparations_NOT?: InputMaybe<PreparationWhere>;
	rating?: InputMaybe<CoverageRequestRating>;
	rating_IN?: InputMaybe<Array<InputMaybe<CoverageRequestRating>>>;
	rating_NOT?: InputMaybe<CoverageRequestRating>;
	rating_NOT_IN?: InputMaybe<Array<InputMaybe<CoverageRequestRating>>>;
	requestReceiptDate?: InputMaybe<Scalars["Date"]>;
	requestReceiptDate_GT?: InputMaybe<Scalars["Date"]>;
	requestReceiptDate_GTE?: InputMaybe<Scalars["Date"]>;
	requestReceiptDate_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
	requestReceiptDate_LT?: InputMaybe<Scalars["Date"]>;
	requestReceiptDate_LTE?: InputMaybe<Scalars["Date"]>;
	requestReceiptDate_NOT?: InputMaybe<Scalars["Date"]>;
	requestReceiptDate_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
	status?: InputMaybe<FormStatus>;
	status_IN?: InputMaybe<Array<InputMaybe<FormStatus>>>;
	status_NOT?: InputMaybe<FormStatus>;
	status_NOT_IN?: InputMaybe<Array<InputMaybe<FormStatus>>>;
	submissionDate?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_GT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_GTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_IN?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]>>>;
	submissionDate_LT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_LTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_NOT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]>>>;
	tenantId?: InputMaybe<Scalars["String"]>;
	tenantId_CONTAINS?: InputMaybe<Scalars["String"]>;
	tenantId_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	tenantId_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	tenantId_MATCHES?: InputMaybe<Scalars["String"]>;
	tenantId_NOT?: InputMaybe<Scalars["String"]>;
	tenantId_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	tenantId_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	tenantId_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	tenantId_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	tenantId_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	therapyDecision?: InputMaybe<CoverageRequestTherapyDecision>;
	therapyDecision_IN?: InputMaybe<Array<InputMaybe<CoverageRequestTherapyDecision>>>;
	therapyDecision_NOT?: InputMaybe<CoverageRequestTherapyDecision>;
	therapyDecision_NOT_IN?: InputMaybe<Array<InputMaybe<CoverageRequestTherapyDecision>>>;
	treatingPhysician?: InputMaybe<TreatingPhysicianWhere>;
	treatingPhysicianAggregate?: InputMaybe<CoverageRequestTreatingPhysicianAggregateInput>;
	treatingPhysicianConnection?: InputMaybe<CoverageRequestTreatingPhysicianConnectionWhere>;
	treatingPhysicianConnection_NOT?: InputMaybe<CoverageRequestTreatingPhysicianConnectionWhere>;
	treatingPhysician_NOT?: InputMaybe<TreatingPhysicianWhere>;
	unsortedContinuousBenefits?: InputMaybe<ContinuousBenefitWhere>;
	unsortedContinuousBenefitsAggregate?: InputMaybe<CoverageRequestUnsortedContinuousBenefitsAggregateInput>;
	unsortedContinuousBenefitsConnection?: InputMaybe<CoverageRequestUnsortedContinuousBenefitsConnectionWhere>;
	unsortedContinuousBenefitsConnection_NOT?: InputMaybe<CoverageRequestUnsortedContinuousBenefitsConnectionWhere>;
	unsortedContinuousBenefits_NOT?: InputMaybe<ContinuousBenefitWhere>;
};

export type CreateAdverseEventsOccurenceReportsMutationResponse = {
	__typename?: "CreateAdverseEventsOccurenceReportsMutationResponse";
	adverseEventsOccurenceReports: Array<AdverseEventsOccurenceReport>;
	info: CreateInfo;
};

export type CreateInfo = {
	__typename?: "CreateInfo";
	bookmark?: Maybe<Scalars["String"]>;
	nodesCreated: Scalars["Int"];
	relationshipsCreated: Scalars["Int"];
};

export type CreateInitialResponseReviewReportsMutationResponse = {
	__typename?: "CreateInitialResponseReviewReportsMutationResponse";
	info: CreateInfo;
	initialResponseReviewReports: Array<InitialResponseReviewReport>;
};

export type CreateReasonOfTreatmentDiscontinuationReportsMutationResponse = {
	__typename?: "CreateReasonOfTreatmentDiscontinuationReportsMutationResponse";
	info: CreateInfo;
	reasonOfTreatmentDiscontinuationReports: Array<ReasonOfTreatmentDiscontinuationReport>;
};

export type CreateRefundThreadMessageInput = {
	content: Scalars["String"];
	mentionsUserIds?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	refundId: Scalars["ID"];
	sentByUserId: Scalars["String"];
};

export type CreateUsersMutationResponse = {
	__typename?: "CreateUsersMutationResponse";
	info: CreateInfo;
	users: Array<User>;
};

export type Currency = {
	__typename?: "Currency";
	Code?: Maybe<Scalars["String"]>;
	Name?: Maybe<Scalars["String"]>;
	symbol?: Maybe<Scalars["String"]>;
};

export type CurrencyAggregateSelection = {
	__typename?: "CurrencyAggregateSelection";
	Code: StringAggregateSelection;
	Name: StringAggregateSelection;
	count: Scalars["Int"];
	symbol: StringAggregateSelection;
};

export type CurrencyConnectWhere = {
	node: CurrencyWhere;
};

export type CurrencyCreateInput = {
	Code?: InputMaybe<Scalars["String"]>;
	Name?: InputMaybe<Scalars["String"]>;
	symbol?: InputMaybe<Scalars["String"]>;
};

export type CurrencyInput = {
	Code: Scalars["String"];
	Name: Scalars["String"];
};

export type CurrencyOptions = {
	limit?: InputMaybe<Scalars["Int"]>;
	offset?: InputMaybe<Scalars["Int"]>;
	/** Specify one or more CurrencySort objects to sort Currencies by. The sorts will be applied in the order in which they are arranged in the array. */
	sort?: InputMaybe<Array<InputMaybe<CurrencySort>>>;
};

/** Fields to sort Currencies by. The order in which sorts are applied is not guaranteed when specifying many fields in one CurrencySort object. */
export type CurrencySort = {
	Code?: InputMaybe<SortDirection>;
	Name?: InputMaybe<SortDirection>;
	symbol?: InputMaybe<SortDirection>;
};

export type CurrencyUpdateInput = {
	Code?: InputMaybe<Scalars["String"]>;
	Name?: InputMaybe<Scalars["String"]>;
	symbol?: InputMaybe<Scalars["String"]>;
};

export type CurrencyWhere = {
	AND?: InputMaybe<Array<CurrencyWhere>>;
	Code?: InputMaybe<Scalars["String"]>;
	Code_CONTAINS?: InputMaybe<Scalars["String"]>;
	Code_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	Code_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	Code_MATCHES?: InputMaybe<Scalars["String"]>;
	Code_NOT?: InputMaybe<Scalars["String"]>;
	Code_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	Code_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	Code_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	Code_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	Code_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	Name?: InputMaybe<Scalars["String"]>;
	Name_CONTAINS?: InputMaybe<Scalars["String"]>;
	Name_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	Name_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	Name_MATCHES?: InputMaybe<Scalars["String"]>;
	Name_NOT?: InputMaybe<Scalars["String"]>;
	Name_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	Name_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	Name_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	Name_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	Name_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	OR?: InputMaybe<Array<CurrencyWhere>>;
	symbol?: InputMaybe<Scalars["String"]>;
	symbol_CONTAINS?: InputMaybe<Scalars["String"]>;
	symbol_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	symbol_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	symbol_MATCHES?: InputMaybe<Scalars["String"]>;
	symbol_NOT?: InputMaybe<Scalars["String"]>;
	symbol_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	symbol_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	symbol_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	symbol_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	symbol_STARTS_WITH?: InputMaybe<Scalars["String"]>;
};

export type DataContainer = {
	__typename?: "DataContainer";
	creationWays?: Maybe<Array<DataContainerCreationWay>>;
	isStartingPoint?: Maybe<Scalars["Boolean"]>;
	providers: Array<Organization>;
	providersConnection: DataContainerProvidersConnection;
	restrictedDataPointNames?: Maybe<Array<Scalars["String"]>>;
	sharedDataPointNames?: Maybe<Array<Scalars["String"]>>;
	sharingTrigger: DataContainerSharingTrigger;
	subType?: Maybe<DataContainerSubType>;
	timeframeEnd?: Maybe<Scalars["Int"]>;
	timeframeRangeType?: Maybe<TimeframeRangeType>;
	timeframeStart?: Maybe<Scalars["Int"]>;
	timeframeStartingPoint?: Maybe<TimeframeStartingPoint>;
	type: DataContainerType;
};

export type DataContainerProvidersArgs = {
	options?: InputMaybe<OrganizationOptions>;
	where?: InputMaybe<OrganizationWhere>;
};

export type DataContainerProvidersConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<DataContainerProvidersConnectionSort>>;
	where?: InputMaybe<DataContainerProvidersConnectionWhere>;
};

export type DataContainerAggregateSelection = {
	__typename?: "DataContainerAggregateSelection";
	count: Scalars["Int"];
	timeframeEnd: IntAggregateSelection;
	timeframeStart: IntAggregateSelection;
};

export type DataContainerConnectInput = {
	providers?: InputMaybe<Array<DataContainerProvidersConnectFieldInput>>;
};

export type DataContainerConnectWhere = {
	node: DataContainerWhere;
};

export type DataContainerCreateInput = {
	creationWays?: InputMaybe<Array<DataContainerCreationWay>>;
	isStartingPoint?: InputMaybe<Scalars["Boolean"]>;
	providers?: InputMaybe<DataContainerProvidersFieldInput>;
	restrictedDataPointNames?: InputMaybe<Array<Scalars["String"]>>;
	sharedDataPointNames?: InputMaybe<Array<Scalars["String"]>>;
	sharingTrigger: DataContainerSharingTrigger;
	subType?: InputMaybe<DataContainerSubType>;
	timeframeEnd?: InputMaybe<Scalars["Int"]>;
	timeframeRangeType?: InputMaybe<TimeframeRangeType>;
	timeframeStart?: InputMaybe<Scalars["Int"]>;
	timeframeStartingPoint?: InputMaybe<TimeframeStartingPoint>;
	type: DataContainerType;
};

export enum DataContainerCreationWay {
	Integration = "INTEGRATION",
	ManualEntry = "MANUAL_ENTRY",
	Upload = "UPLOAD",
}

export type DataContainerDeleteInput = {
	providers?: InputMaybe<Array<DataContainerProvidersDeleteFieldInput>>;
};

export type DataContainerDisconnectInput = {
	providers?: InputMaybe<Array<DataContainerProvidersDisconnectFieldInput>>;
};

export type DataContainerOptions = {
	limit?: InputMaybe<Scalars["Int"]>;
	offset?: InputMaybe<Scalars["Int"]>;
	/** Specify one or more DataContainerSort objects to sort DataContainers by. The sorts will be applied in the order in which they are arranged in the array. */
	sort?: InputMaybe<Array<InputMaybe<DataContainerSort>>>;
};

export type DataContainerProvidersAggregateInput = {
	AND?: InputMaybe<Array<DataContainerProvidersAggregateInput>>;
	OR?: InputMaybe<Array<DataContainerProvidersAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<DataContainerProvidersNodeAggregationWhereInput>;
};

export type DataContainerProvidersConnectFieldInput = {
	where?: InputMaybe<OrganizationConnectWhere>;
};

export type DataContainerProvidersConnection = {
	__typename?: "DataContainerProvidersConnection";
	edges: Array<DataContainerProvidersRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type DataContainerProvidersConnectionSort = {
	node?: InputMaybe<OrganizationSort>;
};

export type DataContainerProvidersConnectionWhere = {
	AND?: InputMaybe<Array<DataContainerProvidersConnectionWhere>>;
	OR?: InputMaybe<Array<DataContainerProvidersConnectionWhere>>;
	node?: InputMaybe<OrganizationWhere>;
	node_NOT?: InputMaybe<OrganizationWhere>;
};

export type DataContainerProvidersCreateFieldInput = {
	node: OrganizationCreateInput;
};

export type DataContainerProvidersDeleteFieldInput = {
	where?: InputMaybe<DataContainerProvidersConnectionWhere>;
};

export type DataContainerProvidersDisconnectFieldInput = {
	where?: InputMaybe<DataContainerProvidersConnectionWhere>;
};

export type DataContainerProvidersFieldInput = {
	connect?: InputMaybe<Array<DataContainerProvidersConnectFieldInput>>;
	create?: InputMaybe<Array<DataContainerProvidersCreateFieldInput>>;
};

export type DataContainerProvidersNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<DataContainerProvidersNodeAggregationWhereInput>>;
	IBAN_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	IBAN_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	IBAN_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	IBAN_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	IBAN_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	IBAN_EQUAL?: InputMaybe<Scalars["String"]>;
	IBAN_GT?: InputMaybe<Scalars["Int"]>;
	IBAN_GTE?: InputMaybe<Scalars["Int"]>;
	IBAN_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	IBAN_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	IBAN_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	IBAN_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	IBAN_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	IBAN_LT?: InputMaybe<Scalars["Int"]>;
	IBAN_LTE?: InputMaybe<Scalars["Int"]>;
	IBAN_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	IBAN_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	IBAN_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	IBAN_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	IBAN_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	OR?: InputMaybe<Array<DataContainerProvidersNodeAggregationWhereInput>>;
	billingAddress_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	billingAddress_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	billingAddress_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	billingAddress_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	billingAddress_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	billingAddress_EQUAL?: InputMaybe<Scalars["String"]>;
	billingAddress_GT?: InputMaybe<Scalars["Int"]>;
	billingAddress_GTE?: InputMaybe<Scalars["Int"]>;
	billingAddress_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	billingAddress_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	billingAddress_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	billingAddress_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	billingAddress_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	billingAddress_LT?: InputMaybe<Scalars["Int"]>;
	billingAddress_LTE?: InputMaybe<Scalars["Int"]>;
	billingAddress_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	billingAddress_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	billingAddress_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	billingAddress_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	billingAddress_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	contactEmail_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	contactEmail_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	contactEmail_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	contactEmail_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	contactEmail_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	contactEmail_EQUAL?: InputMaybe<Scalars["String"]>;
	contactEmail_GT?: InputMaybe<Scalars["Int"]>;
	contactEmail_GTE?: InputMaybe<Scalars["Int"]>;
	contactEmail_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	contactEmail_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	contactEmail_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	contactEmail_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	contactEmail_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	contactEmail_LT?: InputMaybe<Scalars["Int"]>;
	contactEmail_LTE?: InputMaybe<Scalars["Int"]>;
	contactEmail_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	contactEmail_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	contactEmail_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	contactEmail_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	contactEmail_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	contactFirstName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	contactFirstName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	contactFirstName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	contactFirstName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	contactFirstName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	contactFirstName_EQUAL?: InputMaybe<Scalars["String"]>;
	contactFirstName_GT?: InputMaybe<Scalars["Int"]>;
	contactFirstName_GTE?: InputMaybe<Scalars["Int"]>;
	contactFirstName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	contactFirstName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	contactFirstName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	contactFirstName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	contactFirstName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	contactFirstName_LT?: InputMaybe<Scalars["Int"]>;
	contactFirstName_LTE?: InputMaybe<Scalars["Int"]>;
	contactFirstName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	contactFirstName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	contactFirstName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	contactFirstName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	contactFirstName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	contactLastName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	contactLastName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	contactLastName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	contactLastName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	contactLastName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	contactLastName_EQUAL?: InputMaybe<Scalars["String"]>;
	contactLastName_GT?: InputMaybe<Scalars["Int"]>;
	contactLastName_GTE?: InputMaybe<Scalars["Int"]>;
	contactLastName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	contactLastName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	contactLastName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	contactLastName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	contactLastName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	contactLastName_LT?: InputMaybe<Scalars["Int"]>;
	contactLastName_LTE?: InputMaybe<Scalars["Int"]>;
	contactLastName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	contactLastName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	contactLastName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	contactLastName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	contactLastName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	contactOccupation_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	contactOccupation_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	contactOccupation_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	contactOccupation_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	contactOccupation_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	contactOccupation_EQUAL?: InputMaybe<Scalars["String"]>;
	contactOccupation_GT?: InputMaybe<Scalars["Int"]>;
	contactOccupation_GTE?: InputMaybe<Scalars["Int"]>;
	contactOccupation_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	contactOccupation_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	contactOccupation_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	contactOccupation_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	contactOccupation_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	contactOccupation_LT?: InputMaybe<Scalars["Int"]>;
	contactOccupation_LTE?: InputMaybe<Scalars["Int"]>;
	contactOccupation_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	contactOccupation_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	contactOccupation_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	contactOccupation_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	contactOccupation_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	contactPhone_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	contactPhone_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	contactPhone_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	contactPhone_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	contactPhone_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	contactPhone_EQUAL?: InputMaybe<Scalars["String"]>;
	contactPhone_GT?: InputMaybe<Scalars["Int"]>;
	contactPhone_GTE?: InputMaybe<Scalars["Int"]>;
	contactPhone_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	contactPhone_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	contactPhone_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	contactPhone_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	contactPhone_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	contactPhone_LT?: InputMaybe<Scalars["Int"]>;
	contactPhone_LTE?: InputMaybe<Scalars["Int"]>;
	contactPhone_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	contactPhone_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	contactPhone_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	contactPhone_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	contactPhone_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	domicile_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	domicile_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	domicile_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	domicile_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	domicile_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	domicile_EQUAL?: InputMaybe<Scalars["String"]>;
	domicile_GT?: InputMaybe<Scalars["Int"]>;
	domicile_GTE?: InputMaybe<Scalars["Int"]>;
	domicile_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	domicile_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	domicile_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	domicile_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	domicile_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	domicile_LT?: InputMaybe<Scalars["Int"]>;
	domicile_LTE?: InputMaybe<Scalars["Int"]>;
	domicile_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	domicile_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	domicile_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	domicile_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	domicile_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	eIN_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	eIN_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	eIN_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	eIN_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	eIN_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	eIN_EQUAL?: InputMaybe<Scalars["String"]>;
	eIN_GT?: InputMaybe<Scalars["Int"]>;
	eIN_GTE?: InputMaybe<Scalars["Int"]>;
	eIN_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	eIN_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	eIN_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	eIN_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	eIN_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	eIN_LT?: InputMaybe<Scalars["Int"]>;
	eIN_LTE?: InputMaybe<Scalars["Int"]>;
	eIN_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	eIN_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	eIN_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	eIN_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	eIN_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	fax_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	fax_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	fax_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	fax_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	fax_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	fax_EQUAL?: InputMaybe<Scalars["String"]>;
	fax_GT?: InputMaybe<Scalars["Int"]>;
	fax_GTE?: InputMaybe<Scalars["Int"]>;
	fax_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	fax_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	fax_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	fax_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	fax_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	fax_LT?: InputMaybe<Scalars["Int"]>;
	fax_LTE?: InputMaybe<Scalars["Int"]>;
	fax_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	fax_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	fax_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	fax_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	fax_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	legalName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	legalName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	legalName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	legalName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	legalName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	legalName_EQUAL?: InputMaybe<Scalars["String"]>;
	legalName_GT?: InputMaybe<Scalars["Int"]>;
	legalName_GTE?: InputMaybe<Scalars["Int"]>;
	legalName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	legalName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	legalName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	legalName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	legalName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	legalName_LT?: InputMaybe<Scalars["Int"]>;
	legalName_LTE?: InputMaybe<Scalars["Int"]>;
	legalName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	legalName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	legalName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	legalName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	legalName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	logo_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	logo_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	logo_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	logo_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	logo_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	logo_EQUAL?: InputMaybe<Scalars["String"]>;
	logo_GT?: InputMaybe<Scalars["Int"]>;
	logo_GTE?: InputMaybe<Scalars["Int"]>;
	logo_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	logo_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	logo_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	logo_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	logo_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	logo_LT?: InputMaybe<Scalars["Int"]>;
	logo_LTE?: InputMaybe<Scalars["Int"]>;
	logo_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	logo_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	logo_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	logo_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	logo_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	name_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	name_EQUAL?: InputMaybe<Scalars["String"]>;
	name_GT?: InputMaybe<Scalars["Int"]>;
	name_GTE?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	name_LT?: InputMaybe<Scalars["Int"]>;
	name_LTE?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	phone_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	phone_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	phone_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	phone_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	phone_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	phone_EQUAL?: InputMaybe<Scalars["String"]>;
	phone_GT?: InputMaybe<Scalars["Int"]>;
	phone_GTE?: InputMaybe<Scalars["Int"]>;
	phone_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	phone_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	phone_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	phone_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	phone_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	phone_LT?: InputMaybe<Scalars["Int"]>;
	phone_LTE?: InputMaybe<Scalars["Int"]>;
	phone_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	phone_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	phone_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	phone_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	phone_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	tenantId_EQUAL?: InputMaybe<Scalars["String"]>;
	tenantId_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	website_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	website_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	website_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	website_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	website_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	website_EQUAL?: InputMaybe<Scalars["String"]>;
	website_GT?: InputMaybe<Scalars["Int"]>;
	website_GTE?: InputMaybe<Scalars["Int"]>;
	website_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	website_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	website_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	website_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	website_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	website_LT?: InputMaybe<Scalars["Int"]>;
	website_LTE?: InputMaybe<Scalars["Int"]>;
	website_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	website_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	website_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	website_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	website_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type DataContainerProvidersRelationship = {
	__typename?: "DataContainerProvidersRelationship";
	cursor: Scalars["String"];
	node: Organization;
};

export type DataContainerProvidersUpdateConnectionInput = {
	node?: InputMaybe<OrganizationUpdateInput>;
};

export type DataContainerProvidersUpdateFieldInput = {
	connect?: InputMaybe<Array<DataContainerProvidersConnectFieldInput>>;
	create?: InputMaybe<Array<DataContainerProvidersCreateFieldInput>>;
	delete?: InputMaybe<Array<DataContainerProvidersDeleteFieldInput>>;
	disconnect?: InputMaybe<Array<DataContainerProvidersDisconnectFieldInput>>;
	update?: InputMaybe<DataContainerProvidersUpdateConnectionInput>;
	where?: InputMaybe<DataContainerProvidersConnectionWhere>;
};

export enum DataContainerSharingTrigger {
	AgreementInclusion = "AGREEMENT_INCLUSION",
	InvoiceCreation = "INVOICE_CREATION",
	Never = "NEVER",
}

/** Fields to sort DataContainers by. The order in which sorts are applied is not guaranteed when specifying many fields in one DataContainerSort object. */
export type DataContainerSort = {
	isStartingPoint?: InputMaybe<SortDirection>;
	sharingTrigger?: InputMaybe<SortDirection>;
	subType?: InputMaybe<SortDirection>;
	timeframeEnd?: InputMaybe<SortDirection>;
	timeframeRangeType?: InputMaybe<SortDirection>;
	timeframeStart?: InputMaybe<SortDirection>;
	timeframeStartingPoint?: InputMaybe<SortDirection>;
	type?: InputMaybe<SortDirection>;
};

export enum DataContainerSubType {
	Claim = "CLAIM",
	ContinuousBenefit = "CONTINUOUS_BENEFIT",
	CoverageRequest = "COVERAGE_REQUEST",
	DiscontinuationNote = "DISCONTINUATION_NOTE",
	InitialResponse = "INITIAL_RESPONSE",
	Prescription = "PRESCRIPTION",
	PrimaryIntervention = "PRIMARY_INTERVENTION",
	SubsequentIntervention = "SUBSEQUENT_INTERVENTION",
}

export enum DataContainerType {
	Form = "FORM",
	Record = "RECORD",
}

export type DataContainerUpdateInput = {
	creationWays?: InputMaybe<Array<DataContainerCreationWay>>;
	isStartingPoint?: InputMaybe<Scalars["Boolean"]>;
	providers?: InputMaybe<Array<DataContainerProvidersUpdateFieldInput>>;
	restrictedDataPointNames?: InputMaybe<Array<Scalars["String"]>>;
	sharedDataPointNames?: InputMaybe<Array<Scalars["String"]>>;
	sharingTrigger?: InputMaybe<DataContainerSharingTrigger>;
	subType?: InputMaybe<DataContainerSubType>;
	timeframeEnd?: InputMaybe<Scalars["Int"]>;
	timeframeRangeType?: InputMaybe<TimeframeRangeType>;
	timeframeStart?: InputMaybe<Scalars["Int"]>;
	timeframeStartingPoint?: InputMaybe<TimeframeStartingPoint>;
	type?: InputMaybe<DataContainerType>;
};

export type DataContainerWhere = {
	AND?: InputMaybe<Array<DataContainerWhere>>;
	OR?: InputMaybe<Array<DataContainerWhere>>;
	creationWays?: InputMaybe<Array<DataContainerCreationWay>>;
	creationWays_INCLUDES?: InputMaybe<DataContainerCreationWay>;
	creationWays_NOT?: InputMaybe<Array<DataContainerCreationWay>>;
	creationWays_NOT_INCLUDES?: InputMaybe<DataContainerCreationWay>;
	isStartingPoint?: InputMaybe<Scalars["Boolean"]>;
	isStartingPoint_NOT?: InputMaybe<Scalars["Boolean"]>;
	providers?: InputMaybe<OrganizationWhere>;
	providersAggregate?: InputMaybe<DataContainerProvidersAggregateInput>;
	providersConnection?: InputMaybe<DataContainerProvidersConnectionWhere>;
	providersConnection_NOT?: InputMaybe<DataContainerProvidersConnectionWhere>;
	providers_NOT?: InputMaybe<OrganizationWhere>;
	restrictedDataPointNames?: InputMaybe<Array<Scalars["String"]>>;
	restrictedDataPointNames_INCLUDES?: InputMaybe<Scalars["String"]>;
	restrictedDataPointNames_NOT?: InputMaybe<Array<Scalars["String"]>>;
	restrictedDataPointNames_NOT_INCLUDES?: InputMaybe<Scalars["String"]>;
	sharedDataPointNames?: InputMaybe<Array<Scalars["String"]>>;
	sharedDataPointNames_INCLUDES?: InputMaybe<Scalars["String"]>;
	sharedDataPointNames_NOT?: InputMaybe<Array<Scalars["String"]>>;
	sharedDataPointNames_NOT_INCLUDES?: InputMaybe<Scalars["String"]>;
	sharingTrigger?: InputMaybe<DataContainerSharingTrigger>;
	sharingTrigger_IN?: InputMaybe<Array<InputMaybe<DataContainerSharingTrigger>>>;
	sharingTrigger_NOT?: InputMaybe<DataContainerSharingTrigger>;
	sharingTrigger_NOT_IN?: InputMaybe<Array<InputMaybe<DataContainerSharingTrigger>>>;
	subType?: InputMaybe<DataContainerSubType>;
	subType_IN?: InputMaybe<Array<InputMaybe<DataContainerSubType>>>;
	subType_NOT?: InputMaybe<DataContainerSubType>;
	subType_NOT_IN?: InputMaybe<Array<InputMaybe<DataContainerSubType>>>;
	timeframeEnd?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_GT?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_GTE?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	timeframeEnd_LT?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_LTE?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_NOT?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	timeframeRangeType?: InputMaybe<TimeframeRangeType>;
	timeframeRangeType_IN?: InputMaybe<Array<InputMaybe<TimeframeRangeType>>>;
	timeframeRangeType_NOT?: InputMaybe<TimeframeRangeType>;
	timeframeRangeType_NOT_IN?: InputMaybe<Array<InputMaybe<TimeframeRangeType>>>;
	timeframeStart?: InputMaybe<Scalars["Int"]>;
	timeframeStart_GT?: InputMaybe<Scalars["Int"]>;
	timeframeStart_GTE?: InputMaybe<Scalars["Int"]>;
	timeframeStart_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	timeframeStart_LT?: InputMaybe<Scalars["Int"]>;
	timeframeStart_LTE?: InputMaybe<Scalars["Int"]>;
	timeframeStart_NOT?: InputMaybe<Scalars["Int"]>;
	timeframeStart_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	timeframeStartingPoint?: InputMaybe<TimeframeStartingPoint>;
	timeframeStartingPoint_IN?: InputMaybe<Array<InputMaybe<TimeframeStartingPoint>>>;
	timeframeStartingPoint_NOT?: InputMaybe<TimeframeStartingPoint>;
	timeframeStartingPoint_NOT_IN?: InputMaybe<Array<InputMaybe<TimeframeStartingPoint>>>;
	type?: InputMaybe<DataContainerType>;
	type_IN?: InputMaybe<Array<InputMaybe<DataContainerType>>>;
	type_NOT?: InputMaybe<DataContainerType>;
	type_NOT_IN?: InputMaybe<Array<InputMaybe<DataContainerType>>>;
};

export type DataSource = {
	__typename?: "DataSource";
	id: Scalars["ID"];
	name: Scalars["String"];
};

export type DataSourceAggregateSelection = {
	__typename?: "DataSourceAggregateSelection";
	count: Scalars["Int"];
	id: IdAggregateSelection;
	name: StringAggregateSelection;
};

export type DataSourceConnectWhere = {
	node: DataSourceWhere;
};

export type DataSourceCreateInput = {
	id: Scalars["ID"];
	name: Scalars["String"];
};

export type DataSourceOptions = {
	limit?: InputMaybe<Scalars["Int"]>;
	offset?: InputMaybe<Scalars["Int"]>;
	/** Specify one or more DataSourceSort objects to sort DataSources by. The sorts will be applied in the order in which they are arranged in the array. */
	sort?: InputMaybe<Array<InputMaybe<DataSourceSort>>>;
};

/** Fields to sort DataSources by. The order in which sorts are applied is not guaranteed when specifying many fields in one DataSourceSort object. */
export type DataSourceSort = {
	id?: InputMaybe<SortDirection>;
	name?: InputMaybe<SortDirection>;
};

export type DataSourceUpdateInput = {
	id?: InputMaybe<Scalars["ID"]>;
	name?: InputMaybe<Scalars["String"]>;
};

export type DataSourceWhere = {
	AND?: InputMaybe<Array<DataSourceWhere>>;
	OR?: InputMaybe<Array<DataSourceWhere>>;
	id?: InputMaybe<Scalars["ID"]>;
	id_CONTAINS?: InputMaybe<Scalars["ID"]>;
	id_ENDS_WITH?: InputMaybe<Scalars["ID"]>;
	id_IN?: InputMaybe<Array<InputMaybe<Scalars["ID"]>>>;
	id_MATCHES?: InputMaybe<Scalars["String"]>;
	id_NOT?: InputMaybe<Scalars["ID"]>;
	id_NOT_CONTAINS?: InputMaybe<Scalars["ID"]>;
	id_NOT_ENDS_WITH?: InputMaybe<Scalars["ID"]>;
	id_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["ID"]>>>;
	id_NOT_STARTS_WITH?: InputMaybe<Scalars["ID"]>;
	id_STARTS_WITH?: InputMaybe<Scalars["ID"]>;
	name?: InputMaybe<Scalars["String"]>;
	name_CONTAINS?: InputMaybe<Scalars["String"]>;
	name_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	name_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	name_MATCHES?: InputMaybe<Scalars["String"]>;
	name_NOT?: InputMaybe<Scalars["String"]>;
	name_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	name_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	name_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	name_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	name_STARTS_WITH?: InputMaybe<Scalars["String"]>;
};

export type DateTimeAggregateSelection = {
	__typename?: "DateTimeAggregateSelection";
	max: Scalars["DateTime"];
	min: Scalars["DateTime"];
};

export enum Decision {
	Approve = "APPROVE",
	Reject = "REJECT",
}

export type DefaultUserRoleUpdateInput = {
	agreementTag: AgreementTagType;
	role: Scalars["String"];
	userId: Scalars["String"];
};

export type DeleteInfo = {
	__typename?: "DeleteInfo";
	bookmark?: Maybe<Scalars["String"]>;
	nodesDeleted: Scalars["Int"];
	relationshipsDeleted: Scalars["Int"];
};

export type DeleteInvoiceInput = {
	invoiceId: Scalars["ID"];
};

export type DeleteRefundThreadMessageInput = {
	createdOn: Scalars["Float"];
	refundId: Scalars["ID"];
};

export type DeviceAlternative = {
	__typename?: "DeviceAlternative";
	alternatives: Array<Treatment>;
	alternativesConnection: DeviceAlternativeAlternativesConnection;
	code: Scalars["String"];
	deviceProduct: Treatment;
	deviceProductConnection: DeviceAlternativeDeviceProductConnection;
};

export type DeviceAlternativeAlternativesArgs = {
	options?: InputMaybe<TreatmentOptions>;
	where?: InputMaybe<TreatmentWhere>;
};

export type DeviceAlternativeAlternativesConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<DeviceAlternativeAlternativesConnectionSort>>;
	where?: InputMaybe<DeviceAlternativeAlternativesConnectionWhere>;
};

export type DeviceAlternativeDeviceProductArgs = {
	options?: InputMaybe<TreatmentOptions>;
	where?: InputMaybe<TreatmentWhere>;
};

export type DeviceAlternativeDeviceProductConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<DeviceAlternativeDeviceProductConnectionSort>>;
	where?: InputMaybe<DeviceAlternativeDeviceProductConnectionWhere>;
};

export type DeviceAlternativeAggregateSelection = {
	__typename?: "DeviceAlternativeAggregateSelection";
	code: StringAggregateSelection;
	count: Scalars["Int"];
};

export type DeviceAlternativeAlternativesAggregateInput = {
	AND?: InputMaybe<Array<DeviceAlternativeAlternativesAggregateInput>>;
	OR?: InputMaybe<Array<DeviceAlternativeAlternativesAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<DeviceAlternativeAlternativesNodeAggregationWhereInput>;
};

export type DeviceAlternativeAlternativesConnectFieldInput = {
	connect?: InputMaybe<Array<TreatmentConnectInput>>;
	where?: InputMaybe<TreatmentConnectWhere>;
};

export type DeviceAlternativeAlternativesConnection = {
	__typename?: "DeviceAlternativeAlternativesConnection";
	edges: Array<DeviceAlternativeAlternativesRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type DeviceAlternativeAlternativesConnectionSort = {
	node?: InputMaybe<TreatmentSort>;
};

export type DeviceAlternativeAlternativesConnectionWhere = {
	AND?: InputMaybe<Array<DeviceAlternativeAlternativesConnectionWhere>>;
	OR?: InputMaybe<Array<DeviceAlternativeAlternativesConnectionWhere>>;
	node?: InputMaybe<TreatmentWhere>;
	node_NOT?: InputMaybe<TreatmentWhere>;
};

export type DeviceAlternativeAlternativesCreateFieldInput = {
	node: TreatmentCreateInput;
};

export type DeviceAlternativeAlternativesDeleteFieldInput = {
	delete?: InputMaybe<TreatmentDeleteInput>;
	where?: InputMaybe<DeviceAlternativeAlternativesConnectionWhere>;
};

export type DeviceAlternativeAlternativesDisconnectFieldInput = {
	disconnect?: InputMaybe<TreatmentDisconnectInput>;
	where?: InputMaybe<DeviceAlternativeAlternativesConnectionWhere>;
};

export type DeviceAlternativeAlternativesFieldInput = {
	connect?: InputMaybe<Array<DeviceAlternativeAlternativesConnectFieldInput>>;
	create?: InputMaybe<Array<DeviceAlternativeAlternativesCreateFieldInput>>;
};

export type DeviceAlternativeAlternativesNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<DeviceAlternativeAlternativesNodeAggregationWhereInput>>;
	BagDossierNo_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	BagDossierNo_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	BagDossierNo_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	BagDossierNo_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	BagDossierNo_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	BagDossierNo_EQUAL?: InputMaybe<Scalars["String"]>;
	BagDossierNo_GT?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_GTE?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LT?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LTE?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	Code_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	Code_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	Code_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	Code_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	Code_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	Code_EQUAL?: InputMaybe<Scalars["String"]>;
	Code_GT?: InputMaybe<Scalars["Int"]>;
	Code_GTE?: InputMaybe<Scalars["Int"]>;
	Code_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Code_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	Code_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	Code_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	Code_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	Code_LT?: InputMaybe<Scalars["Int"]>;
	Code_LTE?: InputMaybe<Scalars["Int"]>;
	Code_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Code_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	Code_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	Code_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	Code_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	FlagModal_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	FlagModal_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	FlagModal_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	FlagModal_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	FlagModal_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	FlagModal_EQUAL?: InputMaybe<Scalars["String"]>;
	FlagModal_GT?: InputMaybe<Scalars["Int"]>;
	FlagModal_GTE?: InputMaybe<Scalars["Int"]>;
	FlagModal_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	FlagModal_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	FlagModal_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	FlagModal_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	FlagModal_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	FlagModal_LT?: InputMaybe<Scalars["Int"]>;
	FlagModal_LTE?: InputMaybe<Scalars["Int"]>;
	FlagModal_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	FlagModal_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	FlagModal_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	FlagModal_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	FlagModal_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	FlagNarcosis_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	FlagNarcosis_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	FlagNarcosis_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	FlagNarcosis_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	FlagNarcosis_EQUAL?: InputMaybe<Scalars["String"]>;
	FlagNarcosis_GT?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_GTE?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LT?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LTE?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	GTIN_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	GTIN_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	GTIN_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	GTIN_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	GTIN_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	GTIN_EQUAL?: InputMaybe<Scalars["String"]>;
	GTIN_GT?: InputMaybe<Scalars["Int"]>;
	GTIN_GTE?: InputMaybe<Scalars["Int"]>;
	GTIN_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	GTIN_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	GTIN_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	GTIN_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	GTIN_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	GTIN_LT?: InputMaybe<Scalars["Int"]>;
	GTIN_LTE?: InputMaybe<Scalars["Int"]>;
	GTIN_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	GTIN_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	GTIN_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	GTIN_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	GTIN_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	LOT_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	LOT_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	LOT_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	LOT_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	LOT_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	LOT_EQUAL?: InputMaybe<Scalars["String"]>;
	LOT_GT?: InputMaybe<Scalars["Int"]>;
	LOT_GTE?: InputMaybe<Scalars["Int"]>;
	LOT_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	LOT_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	LOT_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	LOT_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	LOT_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	LOT_LT?: InputMaybe<Scalars["Int"]>;
	LOT_LTE?: InputMaybe<Scalars["Int"]>;
	LOT_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	LOT_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	LOT_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	LOT_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	LOT_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	Name_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	Name_EQUAL?: InputMaybe<Scalars["String"]>;
	Name_GT?: InputMaybe<Scalars["Int"]>;
	Name_GTE?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	Name_LT?: InputMaybe<Scalars["Int"]>;
	Name_LTE?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	OR?: InputMaybe<Array<DeviceAlternativeAlternativesNodeAggregationWhereInput>>;
	PharmaCode_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	PharmaCode_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	PharmaCode_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	PharmaCode_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	PharmaCode_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	PharmaCode_EQUAL?: InputMaybe<Scalars["String"]>;
	PharmaCode_GT?: InputMaybe<Scalars["Int"]>;
	PharmaCode_GTE?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LT?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LTE?: InputMaybe<Scalars["Int"]>;
	PharmaCode_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	PharmaCode_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	PharmaCode_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	PharmaCode_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	PharmaCode_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	PrevPharmacode_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	PrevPharmacode_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	PrevPharmacode_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	PrevPharmacode_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	PrevPharmacode_EQUAL?: InputMaybe<Scalars["String"]>;
	PrevPharmacode_GT?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_GTE?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LT?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LTE?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	REF_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	REF_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	REF_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	REF_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	REF_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	REF_EQUAL?: InputMaybe<Scalars["String"]>;
	REF_GT?: InputMaybe<Scalars["Int"]>;
	REF_GTE?: InputMaybe<Scalars["Int"]>;
	REF_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	REF_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	REF_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	REF_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	REF_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	REF_LT?: InputMaybe<Scalars["Int"]>;
	REF_LTE?: InputMaybe<Scalars["Int"]>;
	REF_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	REF_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	REF_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	REF_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	REF_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	SwissmedicCategory_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	SwissmedicCategory_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	SwissmedicCategory_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	SwissmedicCategory_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	SwissmedicCategory_EQUAL?: InputMaybe<Scalars["String"]>;
	SwissmedicCategory_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo8_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo8_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo8_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo8_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo8_EQUAL?: InputMaybe<Scalars["String"]>;
	SwissmedicNo8_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	UDI_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	UDI_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	UDI_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	UDI_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	UDI_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	UDI_EQUAL?: InputMaybe<Scalars["String"]>;
	UDI_GT?: InputMaybe<Scalars["Int"]>;
	UDI_GTE?: InputMaybe<Scalars["Int"]>;
	UDI_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	UDI_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	UDI_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	UDI_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	UDI_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	UDI_LT?: InputMaybe<Scalars["Int"]>;
	UDI_LTE?: InputMaybe<Scalars["Int"]>;
	UDI_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	UDI_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	UDI_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	UDI_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	UDI_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	classificationSystem_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	classificationSystem_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	classificationSystem_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	classificationSystem_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	classificationSystem_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	classificationSystem_EQUAL?: InputMaybe<Scalars["String"]>;
	classificationSystem_GT?: InputMaybe<Scalars["Int"]>;
	classificationSystem_GTE?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LT?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LTE?: InputMaybe<Scalars["Int"]>;
	classificationSystem_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	classificationSystem_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	classificationSystem_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	classificationSystem_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	classificationSystem_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type DeviceAlternativeAlternativesRelationship = {
	__typename?: "DeviceAlternativeAlternativesRelationship";
	cursor: Scalars["String"];
	node: Treatment;
};

export type DeviceAlternativeAlternativesUpdateConnectionInput = {
	node?: InputMaybe<TreatmentUpdateInput>;
};

export type DeviceAlternativeAlternativesUpdateFieldInput = {
	connect?: InputMaybe<Array<DeviceAlternativeAlternativesConnectFieldInput>>;
	create?: InputMaybe<Array<DeviceAlternativeAlternativesCreateFieldInput>>;
	delete?: InputMaybe<Array<DeviceAlternativeAlternativesDeleteFieldInput>>;
	disconnect?: InputMaybe<Array<DeviceAlternativeAlternativesDisconnectFieldInput>>;
	update?: InputMaybe<DeviceAlternativeAlternativesUpdateConnectionInput>;
	where?: InputMaybe<DeviceAlternativeAlternativesConnectionWhere>;
};

export type DeviceAlternativeConnectInput = {
	alternatives?: InputMaybe<Array<DeviceAlternativeAlternativesConnectFieldInput>>;
	deviceProduct?: InputMaybe<DeviceAlternativeDeviceProductConnectFieldInput>;
};

export type DeviceAlternativeConnectWhere = {
	node: DeviceAlternativeWhere;
};

export type DeviceAlternativeCreateInput = {
	alternatives?: InputMaybe<DeviceAlternativeAlternativesFieldInput>;
	code: Scalars["String"];
	deviceProduct?: InputMaybe<DeviceAlternativeDeviceProductFieldInput>;
};

export type DeviceAlternativeDeleteInput = {
	alternatives?: InputMaybe<Array<DeviceAlternativeAlternativesDeleteFieldInput>>;
	deviceProduct?: InputMaybe<DeviceAlternativeDeviceProductDeleteFieldInput>;
};

export type DeviceAlternativeDeviceProductAggregateInput = {
	AND?: InputMaybe<Array<DeviceAlternativeDeviceProductAggregateInput>>;
	OR?: InputMaybe<Array<DeviceAlternativeDeviceProductAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<DeviceAlternativeDeviceProductNodeAggregationWhereInput>;
};

export type DeviceAlternativeDeviceProductConnectFieldInput = {
	connect?: InputMaybe<TreatmentConnectInput>;
	where?: InputMaybe<TreatmentConnectWhere>;
};

export type DeviceAlternativeDeviceProductConnection = {
	__typename?: "DeviceAlternativeDeviceProductConnection";
	edges: Array<DeviceAlternativeDeviceProductRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type DeviceAlternativeDeviceProductConnectionSort = {
	node?: InputMaybe<TreatmentSort>;
};

export type DeviceAlternativeDeviceProductConnectionWhere = {
	AND?: InputMaybe<Array<DeviceAlternativeDeviceProductConnectionWhere>>;
	OR?: InputMaybe<Array<DeviceAlternativeDeviceProductConnectionWhere>>;
	node?: InputMaybe<TreatmentWhere>;
	node_NOT?: InputMaybe<TreatmentWhere>;
};

export type DeviceAlternativeDeviceProductCreateFieldInput = {
	node: TreatmentCreateInput;
};

export type DeviceAlternativeDeviceProductDeleteFieldInput = {
	delete?: InputMaybe<TreatmentDeleteInput>;
	where?: InputMaybe<DeviceAlternativeDeviceProductConnectionWhere>;
};

export type DeviceAlternativeDeviceProductDisconnectFieldInput = {
	disconnect?: InputMaybe<TreatmentDisconnectInput>;
	where?: InputMaybe<DeviceAlternativeDeviceProductConnectionWhere>;
};

export type DeviceAlternativeDeviceProductFieldInput = {
	connect?: InputMaybe<DeviceAlternativeDeviceProductConnectFieldInput>;
	create?: InputMaybe<DeviceAlternativeDeviceProductCreateFieldInput>;
};

export type DeviceAlternativeDeviceProductNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<DeviceAlternativeDeviceProductNodeAggregationWhereInput>>;
	BagDossierNo_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	BagDossierNo_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	BagDossierNo_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	BagDossierNo_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	BagDossierNo_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	BagDossierNo_EQUAL?: InputMaybe<Scalars["String"]>;
	BagDossierNo_GT?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_GTE?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LT?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LTE?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	Code_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	Code_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	Code_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	Code_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	Code_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	Code_EQUAL?: InputMaybe<Scalars["String"]>;
	Code_GT?: InputMaybe<Scalars["Int"]>;
	Code_GTE?: InputMaybe<Scalars["Int"]>;
	Code_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Code_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	Code_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	Code_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	Code_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	Code_LT?: InputMaybe<Scalars["Int"]>;
	Code_LTE?: InputMaybe<Scalars["Int"]>;
	Code_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Code_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	Code_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	Code_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	Code_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	FlagModal_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	FlagModal_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	FlagModal_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	FlagModal_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	FlagModal_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	FlagModal_EQUAL?: InputMaybe<Scalars["String"]>;
	FlagModal_GT?: InputMaybe<Scalars["Int"]>;
	FlagModal_GTE?: InputMaybe<Scalars["Int"]>;
	FlagModal_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	FlagModal_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	FlagModal_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	FlagModal_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	FlagModal_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	FlagModal_LT?: InputMaybe<Scalars["Int"]>;
	FlagModal_LTE?: InputMaybe<Scalars["Int"]>;
	FlagModal_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	FlagModal_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	FlagModal_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	FlagModal_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	FlagModal_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	FlagNarcosis_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	FlagNarcosis_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	FlagNarcosis_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	FlagNarcosis_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	FlagNarcosis_EQUAL?: InputMaybe<Scalars["String"]>;
	FlagNarcosis_GT?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_GTE?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LT?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LTE?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	GTIN_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	GTIN_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	GTIN_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	GTIN_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	GTIN_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	GTIN_EQUAL?: InputMaybe<Scalars["String"]>;
	GTIN_GT?: InputMaybe<Scalars["Int"]>;
	GTIN_GTE?: InputMaybe<Scalars["Int"]>;
	GTIN_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	GTIN_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	GTIN_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	GTIN_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	GTIN_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	GTIN_LT?: InputMaybe<Scalars["Int"]>;
	GTIN_LTE?: InputMaybe<Scalars["Int"]>;
	GTIN_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	GTIN_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	GTIN_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	GTIN_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	GTIN_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	LOT_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	LOT_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	LOT_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	LOT_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	LOT_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	LOT_EQUAL?: InputMaybe<Scalars["String"]>;
	LOT_GT?: InputMaybe<Scalars["Int"]>;
	LOT_GTE?: InputMaybe<Scalars["Int"]>;
	LOT_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	LOT_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	LOT_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	LOT_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	LOT_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	LOT_LT?: InputMaybe<Scalars["Int"]>;
	LOT_LTE?: InputMaybe<Scalars["Int"]>;
	LOT_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	LOT_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	LOT_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	LOT_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	LOT_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	Name_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	Name_EQUAL?: InputMaybe<Scalars["String"]>;
	Name_GT?: InputMaybe<Scalars["Int"]>;
	Name_GTE?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	Name_LT?: InputMaybe<Scalars["Int"]>;
	Name_LTE?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	OR?: InputMaybe<Array<DeviceAlternativeDeviceProductNodeAggregationWhereInput>>;
	PharmaCode_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	PharmaCode_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	PharmaCode_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	PharmaCode_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	PharmaCode_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	PharmaCode_EQUAL?: InputMaybe<Scalars["String"]>;
	PharmaCode_GT?: InputMaybe<Scalars["Int"]>;
	PharmaCode_GTE?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LT?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LTE?: InputMaybe<Scalars["Int"]>;
	PharmaCode_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	PharmaCode_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	PharmaCode_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	PharmaCode_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	PharmaCode_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	PrevPharmacode_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	PrevPharmacode_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	PrevPharmacode_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	PrevPharmacode_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	PrevPharmacode_EQUAL?: InputMaybe<Scalars["String"]>;
	PrevPharmacode_GT?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_GTE?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LT?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LTE?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	REF_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	REF_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	REF_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	REF_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	REF_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	REF_EQUAL?: InputMaybe<Scalars["String"]>;
	REF_GT?: InputMaybe<Scalars["Int"]>;
	REF_GTE?: InputMaybe<Scalars["Int"]>;
	REF_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	REF_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	REF_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	REF_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	REF_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	REF_LT?: InputMaybe<Scalars["Int"]>;
	REF_LTE?: InputMaybe<Scalars["Int"]>;
	REF_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	REF_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	REF_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	REF_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	REF_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	SwissmedicCategory_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	SwissmedicCategory_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	SwissmedicCategory_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	SwissmedicCategory_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	SwissmedicCategory_EQUAL?: InputMaybe<Scalars["String"]>;
	SwissmedicCategory_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo8_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo8_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo8_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo8_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo8_EQUAL?: InputMaybe<Scalars["String"]>;
	SwissmedicNo8_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	UDI_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	UDI_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	UDI_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	UDI_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	UDI_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	UDI_EQUAL?: InputMaybe<Scalars["String"]>;
	UDI_GT?: InputMaybe<Scalars["Int"]>;
	UDI_GTE?: InputMaybe<Scalars["Int"]>;
	UDI_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	UDI_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	UDI_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	UDI_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	UDI_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	UDI_LT?: InputMaybe<Scalars["Int"]>;
	UDI_LTE?: InputMaybe<Scalars["Int"]>;
	UDI_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	UDI_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	UDI_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	UDI_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	UDI_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	classificationSystem_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	classificationSystem_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	classificationSystem_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	classificationSystem_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	classificationSystem_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	classificationSystem_EQUAL?: InputMaybe<Scalars["String"]>;
	classificationSystem_GT?: InputMaybe<Scalars["Int"]>;
	classificationSystem_GTE?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LT?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LTE?: InputMaybe<Scalars["Int"]>;
	classificationSystem_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	classificationSystem_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	classificationSystem_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	classificationSystem_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	classificationSystem_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type DeviceAlternativeDeviceProductRelationship = {
	__typename?: "DeviceAlternativeDeviceProductRelationship";
	cursor: Scalars["String"];
	node: Treatment;
};

export type DeviceAlternativeDeviceProductUpdateConnectionInput = {
	node?: InputMaybe<TreatmentUpdateInput>;
};

export type DeviceAlternativeDeviceProductUpdateFieldInput = {
	connect?: InputMaybe<DeviceAlternativeDeviceProductConnectFieldInput>;
	create?: InputMaybe<DeviceAlternativeDeviceProductCreateFieldInput>;
	delete?: InputMaybe<DeviceAlternativeDeviceProductDeleteFieldInput>;
	disconnect?: InputMaybe<DeviceAlternativeDeviceProductDisconnectFieldInput>;
	update?: InputMaybe<DeviceAlternativeDeviceProductUpdateConnectionInput>;
	where?: InputMaybe<DeviceAlternativeDeviceProductConnectionWhere>;
};

export type DeviceAlternativeDisconnectInput = {
	alternatives?: InputMaybe<Array<DeviceAlternativeAlternativesDisconnectFieldInput>>;
	deviceProduct?: InputMaybe<DeviceAlternativeDeviceProductDisconnectFieldInput>;
};

export type DeviceAlternativeOptions = {
	limit?: InputMaybe<Scalars["Int"]>;
	offset?: InputMaybe<Scalars["Int"]>;
	/** Specify one or more DeviceAlternativeSort objects to sort DeviceAlternatives by. The sorts will be applied in the order in which they are arranged in the array. */
	sort?: InputMaybe<Array<InputMaybe<DeviceAlternativeSort>>>;
};

/** Fields to sort DeviceAlternatives by. The order in which sorts are applied is not guaranteed when specifying many fields in one DeviceAlternativeSort object. */
export type DeviceAlternativeSort = {
	code?: InputMaybe<SortDirection>;
};

export type DeviceAlternativeUpdateInput = {
	alternatives?: InputMaybe<Array<DeviceAlternativeAlternativesUpdateFieldInput>>;
	code?: InputMaybe<Scalars["String"]>;
	deviceProduct?: InputMaybe<DeviceAlternativeDeviceProductUpdateFieldInput>;
};

export type DeviceAlternativeWhere = {
	AND?: InputMaybe<Array<DeviceAlternativeWhere>>;
	OR?: InputMaybe<Array<DeviceAlternativeWhere>>;
	alternatives?: InputMaybe<TreatmentWhere>;
	alternativesAggregate?: InputMaybe<DeviceAlternativeAlternativesAggregateInput>;
	alternativesConnection?: InputMaybe<DeviceAlternativeAlternativesConnectionWhere>;
	alternativesConnection_NOT?: InputMaybe<DeviceAlternativeAlternativesConnectionWhere>;
	alternatives_NOT?: InputMaybe<TreatmentWhere>;
	code?: InputMaybe<Scalars["String"]>;
	code_CONTAINS?: InputMaybe<Scalars["String"]>;
	code_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	code_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	code_MATCHES?: InputMaybe<Scalars["String"]>;
	code_NOT?: InputMaybe<Scalars["String"]>;
	code_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	code_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	code_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	code_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	code_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	deviceProduct?: InputMaybe<TreatmentWhere>;
	deviceProductAggregate?: InputMaybe<DeviceAlternativeDeviceProductAggregateInput>;
	deviceProductConnection?: InputMaybe<DeviceAlternativeDeviceProductConnectionWhere>;
	deviceProductConnection_NOT?: InputMaybe<DeviceAlternativeDeviceProductConnectionWhere>;
	deviceProduct_NOT?: InputMaybe<TreatmentWhere>;
};

export type DeviceFinancialDataPoint = {
	__typename?: "DeviceFinancialDataPoint";
	basePrice: Scalars["Float"];
	date: Scalars["Date"];
	evaluationSnapshot?: Maybe<Scalars["String"]>;
	isLast: Scalars["Boolean"];
	payable: Scalars["Float"];
	payablePercentage: Scalars["Float"];
	processedDeviceRecord: ProcessedDeviceRecord;
	processedDeviceRecordConnection: DeviceFinancialDataPointProcessedDeviceRecordConnection;
	quantity: Scalars["Int"];
	refundable: Scalars["Float"];
	refundablePercentage: Scalars["Float"];
	variable: Scalars["Float"];
	variablePercentage: Scalars["Float"];
};

export type DeviceFinancialDataPointProcessedDeviceRecordArgs = {
	options?: InputMaybe<ProcessedDeviceRecordOptions>;
	where?: InputMaybe<ProcessedDeviceRecordWhere>;
};

export type DeviceFinancialDataPointProcessedDeviceRecordConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<DeviceFinancialDataPointProcessedDeviceRecordConnectionSort>>;
	where?: InputMaybe<DeviceFinancialDataPointProcessedDeviceRecordConnectionWhere>;
};

export type DeviceFinancialDataPointAggregateSelection = {
	__typename?: "DeviceFinancialDataPointAggregateSelection";
	basePrice: FloatAggregateSelection;
	count: Scalars["Int"];
	evaluationSnapshot: StringAggregateSelection;
	payable: FloatAggregateSelection;
	payablePercentage: FloatAggregateSelection;
	quantity: IntAggregateSelection;
	refundable: FloatAggregateSelection;
	refundablePercentage: FloatAggregateSelection;
	variable: FloatAggregateSelection;
	variablePercentage: FloatAggregateSelection;
};

export type DeviceFinancialDataPointConnectInput = {
	processedDeviceRecord?: InputMaybe<DeviceFinancialDataPointProcessedDeviceRecordConnectFieldInput>;
};

export type DeviceFinancialDataPointConnectWhere = {
	node: DeviceFinancialDataPointWhere;
};

export type DeviceFinancialDataPointCreateInput = {
	basePrice: Scalars["Float"];
	date: Scalars["Date"];
	evaluationSnapshot?: InputMaybe<Scalars["String"]>;
	isLast: Scalars["Boolean"];
	payable: Scalars["Float"];
	payablePercentage: Scalars["Float"];
	processedDeviceRecord?: InputMaybe<DeviceFinancialDataPointProcessedDeviceRecordFieldInput>;
	quantity: Scalars["Int"];
	refundable: Scalars["Float"];
	refundablePercentage: Scalars["Float"];
	variable: Scalars["Float"];
	variablePercentage: Scalars["Float"];
};

export type DeviceFinancialDataPointDeleteInput = {
	processedDeviceRecord?: InputMaybe<DeviceFinancialDataPointProcessedDeviceRecordDeleteFieldInput>;
};

export type DeviceFinancialDataPointDisconnectInput = {
	processedDeviceRecord?: InputMaybe<DeviceFinancialDataPointProcessedDeviceRecordDisconnectFieldInput>;
};

export type DeviceFinancialDataPointOptions = {
	limit?: InputMaybe<Scalars["Int"]>;
	offset?: InputMaybe<Scalars["Int"]>;
	/** Specify one or more DeviceFinancialDataPointSort objects to sort DeviceFinancialDataPoints by. The sorts will be applied in the order in which they are arranged in the array. */
	sort?: InputMaybe<Array<InputMaybe<DeviceFinancialDataPointSort>>>;
};

export type DeviceFinancialDataPointProcessedDeviceRecordAggregateInput = {
	AND?: InputMaybe<Array<DeviceFinancialDataPointProcessedDeviceRecordAggregateInput>>;
	OR?: InputMaybe<Array<DeviceFinancialDataPointProcessedDeviceRecordAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
};

export type DeviceFinancialDataPointProcessedDeviceRecordConnectFieldInput = {
	connect?: InputMaybe<ProcessedDeviceRecordConnectInput>;
	where?: InputMaybe<ProcessedDeviceRecordConnectWhere>;
};

export type DeviceFinancialDataPointProcessedDeviceRecordConnection = {
	__typename?: "DeviceFinancialDataPointProcessedDeviceRecordConnection";
	edges: Array<DeviceFinancialDataPointProcessedDeviceRecordRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type DeviceFinancialDataPointProcessedDeviceRecordConnectionSort = {
	node?: InputMaybe<ProcessedDeviceRecordSort>;
};

export type DeviceFinancialDataPointProcessedDeviceRecordConnectionWhere = {
	AND?: InputMaybe<Array<DeviceFinancialDataPointProcessedDeviceRecordConnectionWhere>>;
	OR?: InputMaybe<Array<DeviceFinancialDataPointProcessedDeviceRecordConnectionWhere>>;
	node?: InputMaybe<ProcessedDeviceRecordWhere>;
	node_NOT?: InputMaybe<ProcessedDeviceRecordWhere>;
};

export type DeviceFinancialDataPointProcessedDeviceRecordCreateFieldInput = {
	node: ProcessedDeviceRecordCreateInput;
};

export type DeviceFinancialDataPointProcessedDeviceRecordDeleteFieldInput = {
	delete?: InputMaybe<ProcessedDeviceRecordDeleteInput>;
	where?: InputMaybe<DeviceFinancialDataPointProcessedDeviceRecordConnectionWhere>;
};

export type DeviceFinancialDataPointProcessedDeviceRecordDisconnectFieldInput = {
	disconnect?: InputMaybe<ProcessedDeviceRecordDisconnectInput>;
	where?: InputMaybe<DeviceFinancialDataPointProcessedDeviceRecordConnectionWhere>;
};

export type DeviceFinancialDataPointProcessedDeviceRecordFieldInput = {
	connect?: InputMaybe<DeviceFinancialDataPointProcessedDeviceRecordConnectFieldInput>;
	create?: InputMaybe<DeviceFinancialDataPointProcessedDeviceRecordCreateFieldInput>;
};

export type DeviceFinancialDataPointProcessedDeviceRecordRelationship = {
	__typename?: "DeviceFinancialDataPointProcessedDeviceRecordRelationship";
	cursor: Scalars["String"];
	node: ProcessedDeviceRecord;
};

export type DeviceFinancialDataPointProcessedDeviceRecordUpdateConnectionInput = {
	node?: InputMaybe<ProcessedDeviceRecordUpdateInput>;
};

export type DeviceFinancialDataPointProcessedDeviceRecordUpdateFieldInput = {
	connect?: InputMaybe<DeviceFinancialDataPointProcessedDeviceRecordConnectFieldInput>;
	create?: InputMaybe<DeviceFinancialDataPointProcessedDeviceRecordCreateFieldInput>;
	delete?: InputMaybe<DeviceFinancialDataPointProcessedDeviceRecordDeleteFieldInput>;
	disconnect?: InputMaybe<DeviceFinancialDataPointProcessedDeviceRecordDisconnectFieldInput>;
	update?: InputMaybe<DeviceFinancialDataPointProcessedDeviceRecordUpdateConnectionInput>;
	where?: InputMaybe<DeviceFinancialDataPointProcessedDeviceRecordConnectionWhere>;
};

/** Fields to sort DeviceFinancialDataPoints by. The order in which sorts are applied is not guaranteed when specifying many fields in one DeviceFinancialDataPointSort object. */
export type DeviceFinancialDataPointSort = {
	basePrice?: InputMaybe<SortDirection>;
	date?: InputMaybe<SortDirection>;
	evaluationSnapshot?: InputMaybe<SortDirection>;
	isLast?: InputMaybe<SortDirection>;
	payable?: InputMaybe<SortDirection>;
	payablePercentage?: InputMaybe<SortDirection>;
	quantity?: InputMaybe<SortDirection>;
	refundable?: InputMaybe<SortDirection>;
	refundablePercentage?: InputMaybe<SortDirection>;
	variable?: InputMaybe<SortDirection>;
	variablePercentage?: InputMaybe<SortDirection>;
};

export type DeviceFinancialDataPointUpdateInput = {
	basePrice?: InputMaybe<Scalars["Float"]>;
	date?: InputMaybe<Scalars["Date"]>;
	evaluationSnapshot?: InputMaybe<Scalars["String"]>;
	isLast?: InputMaybe<Scalars["Boolean"]>;
	payable?: InputMaybe<Scalars["Float"]>;
	payablePercentage?: InputMaybe<Scalars["Float"]>;
	processedDeviceRecord?: InputMaybe<DeviceFinancialDataPointProcessedDeviceRecordUpdateFieldInput>;
	quantity?: InputMaybe<Scalars["Int"]>;
	refundable?: InputMaybe<Scalars["Float"]>;
	refundablePercentage?: InputMaybe<Scalars["Float"]>;
	variable?: InputMaybe<Scalars["Float"]>;
	variablePercentage?: InputMaybe<Scalars["Float"]>;
};

export type DeviceFinancialDataPointWhere = {
	AND?: InputMaybe<Array<DeviceFinancialDataPointWhere>>;
	OR?: InputMaybe<Array<DeviceFinancialDataPointWhere>>;
	basePrice?: InputMaybe<Scalars["Float"]>;
	basePrice_GT?: InputMaybe<Scalars["Float"]>;
	basePrice_GTE?: InputMaybe<Scalars["Float"]>;
	basePrice_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	basePrice_LT?: InputMaybe<Scalars["Float"]>;
	basePrice_LTE?: InputMaybe<Scalars["Float"]>;
	basePrice_NOT?: InputMaybe<Scalars["Float"]>;
	basePrice_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	date?: InputMaybe<Scalars["Date"]>;
	date_GT?: InputMaybe<Scalars["Date"]>;
	date_GTE?: InputMaybe<Scalars["Date"]>;
	date_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
	date_LT?: InputMaybe<Scalars["Date"]>;
	date_LTE?: InputMaybe<Scalars["Date"]>;
	date_NOT?: InputMaybe<Scalars["Date"]>;
	date_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
	evaluationSnapshot?: InputMaybe<Scalars["String"]>;
	evaluationSnapshot_CONTAINS?: InputMaybe<Scalars["String"]>;
	evaluationSnapshot_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	evaluationSnapshot_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	evaluationSnapshot_MATCHES?: InputMaybe<Scalars["String"]>;
	evaluationSnapshot_NOT?: InputMaybe<Scalars["String"]>;
	evaluationSnapshot_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	evaluationSnapshot_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	evaluationSnapshot_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	evaluationSnapshot_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	evaluationSnapshot_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	isLast?: InputMaybe<Scalars["Boolean"]>;
	isLast_NOT?: InputMaybe<Scalars["Boolean"]>;
	payable?: InputMaybe<Scalars["Float"]>;
	payablePercentage?: InputMaybe<Scalars["Float"]>;
	payablePercentage_GT?: InputMaybe<Scalars["Float"]>;
	payablePercentage_GTE?: InputMaybe<Scalars["Float"]>;
	payablePercentage_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	payablePercentage_LT?: InputMaybe<Scalars["Float"]>;
	payablePercentage_LTE?: InputMaybe<Scalars["Float"]>;
	payablePercentage_NOT?: InputMaybe<Scalars["Float"]>;
	payablePercentage_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	payable_GT?: InputMaybe<Scalars["Float"]>;
	payable_GTE?: InputMaybe<Scalars["Float"]>;
	payable_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	payable_LT?: InputMaybe<Scalars["Float"]>;
	payable_LTE?: InputMaybe<Scalars["Float"]>;
	payable_NOT?: InputMaybe<Scalars["Float"]>;
	payable_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	processedDeviceRecord?: InputMaybe<ProcessedDeviceRecordWhere>;
	processedDeviceRecordAggregate?: InputMaybe<DeviceFinancialDataPointProcessedDeviceRecordAggregateInput>;
	processedDeviceRecordConnection?: InputMaybe<DeviceFinancialDataPointProcessedDeviceRecordConnectionWhere>;
	processedDeviceRecordConnection_NOT?: InputMaybe<DeviceFinancialDataPointProcessedDeviceRecordConnectionWhere>;
	processedDeviceRecord_NOT?: InputMaybe<ProcessedDeviceRecordWhere>;
	quantity?: InputMaybe<Scalars["Int"]>;
	quantity_GT?: InputMaybe<Scalars["Int"]>;
	quantity_GTE?: InputMaybe<Scalars["Int"]>;
	quantity_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	quantity_LT?: InputMaybe<Scalars["Int"]>;
	quantity_LTE?: InputMaybe<Scalars["Int"]>;
	quantity_NOT?: InputMaybe<Scalars["Int"]>;
	quantity_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	refundable?: InputMaybe<Scalars["Float"]>;
	refundablePercentage?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_GT?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_GTE?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	refundablePercentage_LT?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_LTE?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_NOT?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	refundable_GT?: InputMaybe<Scalars["Float"]>;
	refundable_GTE?: InputMaybe<Scalars["Float"]>;
	refundable_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	refundable_LT?: InputMaybe<Scalars["Float"]>;
	refundable_LTE?: InputMaybe<Scalars["Float"]>;
	refundable_NOT?: InputMaybe<Scalars["Float"]>;
	refundable_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	variable?: InputMaybe<Scalars["Float"]>;
	variablePercentage?: InputMaybe<Scalars["Float"]>;
	variablePercentage_GT?: InputMaybe<Scalars["Float"]>;
	variablePercentage_GTE?: InputMaybe<Scalars["Float"]>;
	variablePercentage_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	variablePercentage_LT?: InputMaybe<Scalars["Float"]>;
	variablePercentage_LTE?: InputMaybe<Scalars["Float"]>;
	variablePercentage_NOT?: InputMaybe<Scalars["Float"]>;
	variablePercentage_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	variable_GT?: InputMaybe<Scalars["Float"]>;
	variable_GTE?: InputMaybe<Scalars["Float"]>;
	variable_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	variable_LT?: InputMaybe<Scalars["Float"]>;
	variable_LTE?: InputMaybe<Scalars["Float"]>;
	variable_NOT?: InputMaybe<Scalars["Float"]>;
	variable_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
};

export type DeviceKit = {
	__typename?: "DeviceKit";
	name: Scalars["String"];
	ref: Scalars["String"];
	tenantId: Scalars["String"];
};

export type DeviceKitAggregateSelection = {
	__typename?: "DeviceKitAggregateSelection";
	count: Scalars["Int"];
	name: StringAggregateSelection;
	ref: StringAggregateSelection;
	tenantId: StringAggregateSelection;
};

export type DeviceKitConnectWhere = {
	node: DeviceKitWhere;
};

export type DeviceKitCreateInput = {
	name: Scalars["String"];
	ref: Scalars["String"];
	tenantId: Scalars["String"];
};

export type DeviceKitOptions = {
	limit?: InputMaybe<Scalars["Int"]>;
	offset?: InputMaybe<Scalars["Int"]>;
	/** Specify one or more DeviceKitSort objects to sort DeviceKits by. The sorts will be applied in the order in which they are arranged in the array. */
	sort?: InputMaybe<Array<InputMaybe<DeviceKitSort>>>;
};

/** Fields to sort DeviceKits by. The order in which sorts are applied is not guaranteed when specifying many fields in one DeviceKitSort object. */
export type DeviceKitSort = {
	name?: InputMaybe<SortDirection>;
	ref?: InputMaybe<SortDirection>;
	tenantId?: InputMaybe<SortDirection>;
};

export type DeviceKitUpdateInput = {
	name?: InputMaybe<Scalars["String"]>;
	ref?: InputMaybe<Scalars["String"]>;
	tenantId?: InputMaybe<Scalars["String"]>;
};

export type DeviceKitWhere = {
	AND?: InputMaybe<Array<DeviceKitWhere>>;
	OR?: InputMaybe<Array<DeviceKitWhere>>;
	name?: InputMaybe<Scalars["String"]>;
	name_CONTAINS?: InputMaybe<Scalars["String"]>;
	name_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	name_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	name_MATCHES?: InputMaybe<Scalars["String"]>;
	name_NOT?: InputMaybe<Scalars["String"]>;
	name_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	name_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	name_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	name_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	name_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	ref?: InputMaybe<Scalars["String"]>;
	ref_CONTAINS?: InputMaybe<Scalars["String"]>;
	ref_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	ref_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	ref_MATCHES?: InputMaybe<Scalars["String"]>;
	ref_NOT?: InputMaybe<Scalars["String"]>;
	ref_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	ref_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	ref_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	ref_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	ref_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	tenantId?: InputMaybe<Scalars["String"]>;
	tenantId_CONTAINS?: InputMaybe<Scalars["String"]>;
	tenantId_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	tenantId_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	tenantId_MATCHES?: InputMaybe<Scalars["String"]>;
	tenantId_NOT?: InputMaybe<Scalars["String"]>;
	tenantId_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	tenantId_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	tenantId_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	tenantId_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	tenantId_STARTS_WITH?: InputMaybe<Scalars["String"]>;
};

export type DeviceProductCategory = {
	__typename?: "DeviceProductCategory";
	code: Scalars["String"];
	level: Scalars["Int"];
	name: Scalars["String"];
	parent?: Maybe<DeviceProductCategory>;
	parentConnection: DeviceProductCategoryParentConnection;
	tenantId: Scalars["String"];
};

export type DeviceProductCategoryParentArgs = {
	options?: InputMaybe<DeviceProductCategoryOptions>;
	where?: InputMaybe<DeviceProductCategoryWhere>;
};

export type DeviceProductCategoryParentConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<DeviceProductCategoryParentConnectionSort>>;
	where?: InputMaybe<DeviceProductCategoryParentConnectionWhere>;
};

export type DeviceProductCategoryAggregateSelection = {
	__typename?: "DeviceProductCategoryAggregateSelection";
	code: StringAggregateSelection;
	count: Scalars["Int"];
	level: IntAggregateSelection;
	name: StringAggregateSelection;
	tenantId: StringAggregateSelection;
};

export type DeviceProductCategoryConnectInput = {
	parent?: InputMaybe<DeviceProductCategoryParentConnectFieldInput>;
};

export type DeviceProductCategoryConnectWhere = {
	node: DeviceProductCategoryWhere;
};

export type DeviceProductCategoryCreateInput = {
	code: Scalars["String"];
	level: Scalars["Int"];
	name: Scalars["String"];
	parent?: InputMaybe<DeviceProductCategoryParentFieldInput>;
	tenantId: Scalars["String"];
};

export type DeviceProductCategoryDeleteInput = {
	parent?: InputMaybe<DeviceProductCategoryParentDeleteFieldInput>;
};

export type DeviceProductCategoryDisconnectInput = {
	parent?: InputMaybe<DeviceProductCategoryParentDisconnectFieldInput>;
};

export type DeviceProductCategoryOptions = {
	limit?: InputMaybe<Scalars["Int"]>;
	offset?: InputMaybe<Scalars["Int"]>;
	/** Specify one or more DeviceProductCategorySort objects to sort DeviceProductCategories by. The sorts will be applied in the order in which they are arranged in the array. */
	sort?: InputMaybe<Array<InputMaybe<DeviceProductCategorySort>>>;
};

export type DeviceProductCategoryParentAggregateInput = {
	AND?: InputMaybe<Array<DeviceProductCategoryParentAggregateInput>>;
	OR?: InputMaybe<Array<DeviceProductCategoryParentAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<DeviceProductCategoryParentNodeAggregationWhereInput>;
};

export type DeviceProductCategoryParentConnectFieldInput = {
	connect?: InputMaybe<DeviceProductCategoryConnectInput>;
	where?: InputMaybe<DeviceProductCategoryConnectWhere>;
};

export type DeviceProductCategoryParentConnection = {
	__typename?: "DeviceProductCategoryParentConnection";
	edges: Array<DeviceProductCategoryParentRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type DeviceProductCategoryParentConnectionSort = {
	node?: InputMaybe<DeviceProductCategorySort>;
};

export type DeviceProductCategoryParentConnectionWhere = {
	AND?: InputMaybe<Array<DeviceProductCategoryParentConnectionWhere>>;
	OR?: InputMaybe<Array<DeviceProductCategoryParentConnectionWhere>>;
	node?: InputMaybe<DeviceProductCategoryWhere>;
	node_NOT?: InputMaybe<DeviceProductCategoryWhere>;
};

export type DeviceProductCategoryParentCreateFieldInput = {
	node: DeviceProductCategoryCreateInput;
};

export type DeviceProductCategoryParentDeleteFieldInput = {
	delete?: InputMaybe<DeviceProductCategoryDeleteInput>;
	where?: InputMaybe<DeviceProductCategoryParentConnectionWhere>;
};

export type DeviceProductCategoryParentDisconnectFieldInput = {
	disconnect?: InputMaybe<DeviceProductCategoryDisconnectInput>;
	where?: InputMaybe<DeviceProductCategoryParentConnectionWhere>;
};

export type DeviceProductCategoryParentFieldInput = {
	connect?: InputMaybe<DeviceProductCategoryParentConnectFieldInput>;
	create?: InputMaybe<DeviceProductCategoryParentCreateFieldInput>;
};

export type DeviceProductCategoryParentNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<DeviceProductCategoryParentNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<DeviceProductCategoryParentNodeAggregationWhereInput>>;
	code_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	code_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	code_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	code_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	code_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	code_EQUAL?: InputMaybe<Scalars["String"]>;
	code_GT?: InputMaybe<Scalars["Int"]>;
	code_GTE?: InputMaybe<Scalars["Int"]>;
	code_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	code_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	code_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	code_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	code_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	code_LT?: InputMaybe<Scalars["Int"]>;
	code_LTE?: InputMaybe<Scalars["Int"]>;
	code_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	code_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	code_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	code_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	code_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	level_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	level_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	level_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	level_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	level_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	level_EQUAL?: InputMaybe<Scalars["Int"]>;
	level_GT?: InputMaybe<Scalars["Int"]>;
	level_GTE?: InputMaybe<Scalars["Int"]>;
	level_LT?: InputMaybe<Scalars["Int"]>;
	level_LTE?: InputMaybe<Scalars["Int"]>;
	level_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	level_MAX_GT?: InputMaybe<Scalars["Int"]>;
	level_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	level_MAX_LT?: InputMaybe<Scalars["Int"]>;
	level_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	level_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	level_MIN_GT?: InputMaybe<Scalars["Int"]>;
	level_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	level_MIN_LT?: InputMaybe<Scalars["Int"]>;
	level_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	name_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	name_EQUAL?: InputMaybe<Scalars["String"]>;
	name_GT?: InputMaybe<Scalars["Int"]>;
	name_GTE?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	name_LT?: InputMaybe<Scalars["Int"]>;
	name_LTE?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	tenantId_EQUAL?: InputMaybe<Scalars["String"]>;
	tenantId_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type DeviceProductCategoryParentRelationship = {
	__typename?: "DeviceProductCategoryParentRelationship";
	cursor: Scalars["String"];
	node: DeviceProductCategory;
};

export type DeviceProductCategoryParentUpdateConnectionInput = {
	node?: InputMaybe<DeviceProductCategoryUpdateInput>;
};

export type DeviceProductCategoryParentUpdateFieldInput = {
	connect?: InputMaybe<DeviceProductCategoryParentConnectFieldInput>;
	create?: InputMaybe<DeviceProductCategoryParentCreateFieldInput>;
	delete?: InputMaybe<DeviceProductCategoryParentDeleteFieldInput>;
	disconnect?: InputMaybe<DeviceProductCategoryParentDisconnectFieldInput>;
	update?: InputMaybe<DeviceProductCategoryParentUpdateConnectionInput>;
	where?: InputMaybe<DeviceProductCategoryParentConnectionWhere>;
};

/** Fields to sort DeviceProductCategories by. The order in which sorts are applied is not guaranteed when specifying many fields in one DeviceProductCategorySort object. */
export type DeviceProductCategorySort = {
	code?: InputMaybe<SortDirection>;
	level?: InputMaybe<SortDirection>;
	name?: InputMaybe<SortDirection>;
	tenantId?: InputMaybe<SortDirection>;
};

export type DeviceProductCategoryUpdateInput = {
	code?: InputMaybe<Scalars["String"]>;
	level?: InputMaybe<Scalars["Int"]>;
	name?: InputMaybe<Scalars["String"]>;
	parent?: InputMaybe<DeviceProductCategoryParentUpdateFieldInput>;
	tenantId?: InputMaybe<Scalars["String"]>;
};

export type DeviceProductCategoryWhere = {
	AND?: InputMaybe<Array<DeviceProductCategoryWhere>>;
	OR?: InputMaybe<Array<DeviceProductCategoryWhere>>;
	code?: InputMaybe<Scalars["String"]>;
	code_CONTAINS?: InputMaybe<Scalars["String"]>;
	code_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	code_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	code_MATCHES?: InputMaybe<Scalars["String"]>;
	code_NOT?: InputMaybe<Scalars["String"]>;
	code_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	code_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	code_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	code_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	code_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	level?: InputMaybe<Scalars["Int"]>;
	level_GT?: InputMaybe<Scalars["Int"]>;
	level_GTE?: InputMaybe<Scalars["Int"]>;
	level_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	level_LT?: InputMaybe<Scalars["Int"]>;
	level_LTE?: InputMaybe<Scalars["Int"]>;
	level_NOT?: InputMaybe<Scalars["Int"]>;
	level_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	name?: InputMaybe<Scalars["String"]>;
	name_CONTAINS?: InputMaybe<Scalars["String"]>;
	name_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	name_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	name_MATCHES?: InputMaybe<Scalars["String"]>;
	name_NOT?: InputMaybe<Scalars["String"]>;
	name_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	name_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	name_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	name_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	name_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	parent?: InputMaybe<DeviceProductCategoryWhere>;
	parentAggregate?: InputMaybe<DeviceProductCategoryParentAggregateInput>;
	parentConnection?: InputMaybe<DeviceProductCategoryParentConnectionWhere>;
	parentConnection_NOT?: InputMaybe<DeviceProductCategoryParentConnectionWhere>;
	parent_NOT?: InputMaybe<DeviceProductCategoryWhere>;
	tenantId?: InputMaybe<Scalars["String"]>;
	tenantId_CONTAINS?: InputMaybe<Scalars["String"]>;
	tenantId_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	tenantId_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	tenantId_MATCHES?: InputMaybe<Scalars["String"]>;
	tenantId_NOT?: InputMaybe<Scalars["String"]>;
	tenantId_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	tenantId_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	tenantId_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	tenantId_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	tenantId_STARTS_WITH?: InputMaybe<Scalars["String"]>;
};

export type DeviceProvider = {
	__typename?: "DeviceProvider";
	id: Scalars["ID"];
	name: Scalars["String"];
};

export type DeviceProviderAggregateSelection = {
	__typename?: "DeviceProviderAggregateSelection";
	count: Scalars["Int"];
	id: IdAggregateSelection;
	name: StringAggregateSelection;
};

export type DeviceProviderConnectWhere = {
	node: DeviceProviderWhere;
};

export type DeviceProviderCreateInput = {
	id: Scalars["ID"];
	name: Scalars["String"];
};

export type DeviceProviderOptions = {
	limit?: InputMaybe<Scalars["Int"]>;
	offset?: InputMaybe<Scalars["Int"]>;
	/** Specify one or more DeviceProviderSort objects to sort DeviceProviders by. The sorts will be applied in the order in which they are arranged in the array. */
	sort?: InputMaybe<Array<InputMaybe<DeviceProviderSort>>>;
};

/** Fields to sort DeviceProviders by. The order in which sorts are applied is not guaranteed when specifying many fields in one DeviceProviderSort object. */
export type DeviceProviderSort = {
	id?: InputMaybe<SortDirection>;
	name?: InputMaybe<SortDirection>;
};

export type DeviceProviderUpdateInput = {
	id?: InputMaybe<Scalars["ID"]>;
	name?: InputMaybe<Scalars["String"]>;
};

export type DeviceProviderWhere = {
	AND?: InputMaybe<Array<DeviceProviderWhere>>;
	OR?: InputMaybe<Array<DeviceProviderWhere>>;
	id?: InputMaybe<Scalars["ID"]>;
	id_CONTAINS?: InputMaybe<Scalars["ID"]>;
	id_ENDS_WITH?: InputMaybe<Scalars["ID"]>;
	id_IN?: InputMaybe<Array<InputMaybe<Scalars["ID"]>>>;
	id_MATCHES?: InputMaybe<Scalars["String"]>;
	id_NOT?: InputMaybe<Scalars["ID"]>;
	id_NOT_CONTAINS?: InputMaybe<Scalars["ID"]>;
	id_NOT_ENDS_WITH?: InputMaybe<Scalars["ID"]>;
	id_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["ID"]>>>;
	id_NOT_STARTS_WITH?: InputMaybe<Scalars["ID"]>;
	id_STARTS_WITH?: InputMaybe<Scalars["ID"]>;
	name?: InputMaybe<Scalars["String"]>;
	name_CONTAINS?: InputMaybe<Scalars["String"]>;
	name_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	name_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	name_MATCHES?: InputMaybe<Scalars["String"]>;
	name_NOT?: InputMaybe<Scalars["String"]>;
	name_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	name_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	name_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	name_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	name_STARTS_WITH?: InputMaybe<Scalars["String"]>;
};

export type DeviceRecord = {
	__typename?: "DeviceRecord";
	category: DeviceProductCategory;
	categoryConnection: DeviceRecordCategoryConnection;
	deviceId: Scalars["String"];
	deviceRef?: Maybe<Scalars["String"]>;
	id: Scalars["ID"];
	invoicedSales: Scalars["Float"];
	orderLineNumber: Scalars["Int"];
	orderNumber: Scalars["Int"];
	price: Scalars["Float"];
	processedAs?: Maybe<ProcessedDeviceRecord>;
	processedAsConnection: DeviceRecordProcessedAsConnection;
	productName: Scalars["String"];
	provider?: Maybe<DeviceProvider>;
	providerConnection: DeviceRecordProviderConnection;
	quantity: Scalars["Int"];
	record: Record;
	recordConnection: DeviceRecordRecordConnection;
	refundPercentage?: Maybe<Scalars["Float"]>;
	saleDate: Scalars["DateTime"];
	tenantId: Scalars["String"];
};

export type DeviceRecordCategoryArgs = {
	options?: InputMaybe<DeviceProductCategoryOptions>;
	where?: InputMaybe<DeviceProductCategoryWhere>;
};

export type DeviceRecordCategoryConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<DeviceRecordCategoryConnectionSort>>;
	where?: InputMaybe<DeviceRecordCategoryConnectionWhere>;
};

export type DeviceRecordProcessedAsArgs = {
	options?: InputMaybe<ProcessedDeviceRecordOptions>;
	where?: InputMaybe<ProcessedDeviceRecordWhere>;
};

export type DeviceRecordProcessedAsConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<DeviceRecordProcessedAsConnectionSort>>;
	where?: InputMaybe<DeviceRecordProcessedAsConnectionWhere>;
};

export type DeviceRecordProviderArgs = {
	options?: InputMaybe<DeviceProviderOptions>;
	where?: InputMaybe<DeviceProviderWhere>;
};

export type DeviceRecordProviderConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<DeviceRecordProviderConnectionSort>>;
	where?: InputMaybe<DeviceRecordProviderConnectionWhere>;
};

export type DeviceRecordRecordArgs = {
	options?: InputMaybe<RecordOptions>;
	where?: InputMaybe<RecordWhere>;
};

export type DeviceRecordRecordConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<DeviceRecordRecordConnectionSort>>;
	where?: InputMaybe<DeviceRecordRecordConnectionWhere>;
};

export type DeviceRecordAggregateSelection = {
	__typename?: "DeviceRecordAggregateSelection";
	count: Scalars["Int"];
	deviceId: StringAggregateSelection;
	deviceRef: StringAggregateSelection;
	id: IdAggregateSelection;
	invoicedSales: FloatAggregateSelection;
	orderLineNumber: IntAggregateSelection;
	orderNumber: IntAggregateSelection;
	price: FloatAggregateSelection;
	productName: StringAggregateSelection;
	quantity: IntAggregateSelection;
	refundPercentage: FloatAggregateSelection;
	saleDate: DateTimeAggregateSelection;
	tenantId: StringAggregateSelection;
};

export type DeviceRecordCategoryAggregateInput = {
	AND?: InputMaybe<Array<DeviceRecordCategoryAggregateInput>>;
	OR?: InputMaybe<Array<DeviceRecordCategoryAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<DeviceRecordCategoryNodeAggregationWhereInput>;
};

export type DeviceRecordCategoryConnectFieldInput = {
	connect?: InputMaybe<DeviceProductCategoryConnectInput>;
	where?: InputMaybe<DeviceProductCategoryConnectWhere>;
};

export type DeviceRecordCategoryConnection = {
	__typename?: "DeviceRecordCategoryConnection";
	edges: Array<DeviceRecordCategoryRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type DeviceRecordCategoryConnectionSort = {
	node?: InputMaybe<DeviceProductCategorySort>;
};

export type DeviceRecordCategoryConnectionWhere = {
	AND?: InputMaybe<Array<DeviceRecordCategoryConnectionWhere>>;
	OR?: InputMaybe<Array<DeviceRecordCategoryConnectionWhere>>;
	node?: InputMaybe<DeviceProductCategoryWhere>;
	node_NOT?: InputMaybe<DeviceProductCategoryWhere>;
};

export type DeviceRecordCategoryCreateFieldInput = {
	node: DeviceProductCategoryCreateInput;
};

export type DeviceRecordCategoryDeleteFieldInput = {
	delete?: InputMaybe<DeviceProductCategoryDeleteInput>;
	where?: InputMaybe<DeviceRecordCategoryConnectionWhere>;
};

export type DeviceRecordCategoryDisconnectFieldInput = {
	disconnect?: InputMaybe<DeviceProductCategoryDisconnectInput>;
	where?: InputMaybe<DeviceRecordCategoryConnectionWhere>;
};

export type DeviceRecordCategoryFieldInput = {
	connect?: InputMaybe<DeviceRecordCategoryConnectFieldInput>;
	create?: InputMaybe<DeviceRecordCategoryCreateFieldInput>;
};

export type DeviceRecordCategoryNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<DeviceRecordCategoryNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<DeviceRecordCategoryNodeAggregationWhereInput>>;
	code_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	code_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	code_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	code_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	code_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	code_EQUAL?: InputMaybe<Scalars["String"]>;
	code_GT?: InputMaybe<Scalars["Int"]>;
	code_GTE?: InputMaybe<Scalars["Int"]>;
	code_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	code_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	code_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	code_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	code_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	code_LT?: InputMaybe<Scalars["Int"]>;
	code_LTE?: InputMaybe<Scalars["Int"]>;
	code_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	code_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	code_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	code_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	code_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	level_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	level_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	level_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	level_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	level_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	level_EQUAL?: InputMaybe<Scalars["Int"]>;
	level_GT?: InputMaybe<Scalars["Int"]>;
	level_GTE?: InputMaybe<Scalars["Int"]>;
	level_LT?: InputMaybe<Scalars["Int"]>;
	level_LTE?: InputMaybe<Scalars["Int"]>;
	level_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	level_MAX_GT?: InputMaybe<Scalars["Int"]>;
	level_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	level_MAX_LT?: InputMaybe<Scalars["Int"]>;
	level_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	level_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	level_MIN_GT?: InputMaybe<Scalars["Int"]>;
	level_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	level_MIN_LT?: InputMaybe<Scalars["Int"]>;
	level_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	name_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	name_EQUAL?: InputMaybe<Scalars["String"]>;
	name_GT?: InputMaybe<Scalars["Int"]>;
	name_GTE?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	name_LT?: InputMaybe<Scalars["Int"]>;
	name_LTE?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	tenantId_EQUAL?: InputMaybe<Scalars["String"]>;
	tenantId_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type DeviceRecordCategoryRelationship = {
	__typename?: "DeviceRecordCategoryRelationship";
	cursor: Scalars["String"];
	node: DeviceProductCategory;
};

export type DeviceRecordCategoryUpdateConnectionInput = {
	node?: InputMaybe<DeviceProductCategoryUpdateInput>;
};

export type DeviceRecordCategoryUpdateFieldInput = {
	connect?: InputMaybe<DeviceRecordCategoryConnectFieldInput>;
	create?: InputMaybe<DeviceRecordCategoryCreateFieldInput>;
	delete?: InputMaybe<DeviceRecordCategoryDeleteFieldInput>;
	disconnect?: InputMaybe<DeviceRecordCategoryDisconnectFieldInput>;
	update?: InputMaybe<DeviceRecordCategoryUpdateConnectionInput>;
	where?: InputMaybe<DeviceRecordCategoryConnectionWhere>;
};

export type DeviceRecordConnectInput = {
	category?: InputMaybe<DeviceRecordCategoryConnectFieldInput>;
	processedAs?: InputMaybe<DeviceRecordProcessedAsConnectFieldInput>;
	provider?: InputMaybe<DeviceRecordProviderConnectFieldInput>;
	record?: InputMaybe<DeviceRecordRecordConnectFieldInput>;
};

export type DeviceRecordConnectWhere = {
	node: DeviceRecordWhere;
};

export type DeviceRecordCreateInput = {
	category?: InputMaybe<DeviceRecordCategoryFieldInput>;
	deviceId: Scalars["String"];
	deviceRef?: InputMaybe<Scalars["String"]>;
	id: Scalars["ID"];
	invoicedSales: Scalars["Float"];
	orderLineNumber: Scalars["Int"];
	orderNumber: Scalars["Int"];
	price: Scalars["Float"];
	processedAs?: InputMaybe<DeviceRecordProcessedAsFieldInput>;
	productName: Scalars["String"];
	provider?: InputMaybe<DeviceRecordProviderFieldInput>;
	quantity: Scalars["Int"];
	record?: InputMaybe<DeviceRecordRecordFieldInput>;
	refundPercentage?: InputMaybe<Scalars["Float"]>;
	saleDate: Scalars["DateTime"];
	tenantId: Scalars["String"];
};

export type DeviceRecordDeleteInput = {
	category?: InputMaybe<DeviceRecordCategoryDeleteFieldInput>;
	processedAs?: InputMaybe<DeviceRecordProcessedAsDeleteFieldInput>;
	provider?: InputMaybe<DeviceRecordProviderDeleteFieldInput>;
	record?: InputMaybe<DeviceRecordRecordDeleteFieldInput>;
};

export type DeviceRecordDisconnectInput = {
	category?: InputMaybe<DeviceRecordCategoryDisconnectFieldInput>;
	processedAs?: InputMaybe<DeviceRecordProcessedAsDisconnectFieldInput>;
	provider?: InputMaybe<DeviceRecordProviderDisconnectFieldInput>;
	record?: InputMaybe<DeviceRecordRecordDisconnectFieldInput>;
};

export type DeviceRecordOptions = {
	limit?: InputMaybe<Scalars["Int"]>;
	offset?: InputMaybe<Scalars["Int"]>;
	/** Specify one or more DeviceRecordSort objects to sort DeviceRecords by. The sorts will be applied in the order in which they are arranged in the array. */
	sort?: InputMaybe<Array<InputMaybe<DeviceRecordSort>>>;
};

export type DeviceRecordProcessedAsAggregateInput = {
	AND?: InputMaybe<Array<DeviceRecordProcessedAsAggregateInput>>;
	OR?: InputMaybe<Array<DeviceRecordProcessedAsAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
};

export type DeviceRecordProcessedAsConnectFieldInput = {
	connect?: InputMaybe<ProcessedDeviceRecordConnectInput>;
	where?: InputMaybe<ProcessedDeviceRecordConnectWhere>;
};

export type DeviceRecordProcessedAsConnection = {
	__typename?: "DeviceRecordProcessedAsConnection";
	edges: Array<DeviceRecordProcessedAsRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type DeviceRecordProcessedAsConnectionSort = {
	node?: InputMaybe<ProcessedDeviceRecordSort>;
};

export type DeviceRecordProcessedAsConnectionWhere = {
	AND?: InputMaybe<Array<DeviceRecordProcessedAsConnectionWhere>>;
	OR?: InputMaybe<Array<DeviceRecordProcessedAsConnectionWhere>>;
	node?: InputMaybe<ProcessedDeviceRecordWhere>;
	node_NOT?: InputMaybe<ProcessedDeviceRecordWhere>;
};

export type DeviceRecordProcessedAsCreateFieldInput = {
	node: ProcessedDeviceRecordCreateInput;
};

export type DeviceRecordProcessedAsDeleteFieldInput = {
	delete?: InputMaybe<ProcessedDeviceRecordDeleteInput>;
	where?: InputMaybe<DeviceRecordProcessedAsConnectionWhere>;
};

export type DeviceRecordProcessedAsDisconnectFieldInput = {
	disconnect?: InputMaybe<ProcessedDeviceRecordDisconnectInput>;
	where?: InputMaybe<DeviceRecordProcessedAsConnectionWhere>;
};

export type DeviceRecordProcessedAsFieldInput = {
	connect?: InputMaybe<DeviceRecordProcessedAsConnectFieldInput>;
	create?: InputMaybe<DeviceRecordProcessedAsCreateFieldInput>;
};

export type DeviceRecordProcessedAsRelationship = {
	__typename?: "DeviceRecordProcessedAsRelationship";
	cursor: Scalars["String"];
	node: ProcessedDeviceRecord;
};

export type DeviceRecordProcessedAsUpdateConnectionInput = {
	node?: InputMaybe<ProcessedDeviceRecordUpdateInput>;
};

export type DeviceRecordProcessedAsUpdateFieldInput = {
	connect?: InputMaybe<DeviceRecordProcessedAsConnectFieldInput>;
	create?: InputMaybe<DeviceRecordProcessedAsCreateFieldInput>;
	delete?: InputMaybe<DeviceRecordProcessedAsDeleteFieldInput>;
	disconnect?: InputMaybe<DeviceRecordProcessedAsDisconnectFieldInput>;
	update?: InputMaybe<DeviceRecordProcessedAsUpdateConnectionInput>;
	where?: InputMaybe<DeviceRecordProcessedAsConnectionWhere>;
};

export type DeviceRecordProviderAggregateInput = {
	AND?: InputMaybe<Array<DeviceRecordProviderAggregateInput>>;
	OR?: InputMaybe<Array<DeviceRecordProviderAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<DeviceRecordProviderNodeAggregationWhereInput>;
};

export type DeviceRecordProviderConnectFieldInput = {
	where?: InputMaybe<DeviceProviderConnectWhere>;
};

export type DeviceRecordProviderConnection = {
	__typename?: "DeviceRecordProviderConnection";
	edges: Array<DeviceRecordProviderRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type DeviceRecordProviderConnectionSort = {
	node?: InputMaybe<DeviceProviderSort>;
};

export type DeviceRecordProviderConnectionWhere = {
	AND?: InputMaybe<Array<DeviceRecordProviderConnectionWhere>>;
	OR?: InputMaybe<Array<DeviceRecordProviderConnectionWhere>>;
	node?: InputMaybe<DeviceProviderWhere>;
	node_NOT?: InputMaybe<DeviceProviderWhere>;
};

export type DeviceRecordProviderCreateFieldInput = {
	node: DeviceProviderCreateInput;
};

export type DeviceRecordProviderDeleteFieldInput = {
	where?: InputMaybe<DeviceRecordProviderConnectionWhere>;
};

export type DeviceRecordProviderDisconnectFieldInput = {
	where?: InputMaybe<DeviceRecordProviderConnectionWhere>;
};

export type DeviceRecordProviderFieldInput = {
	connect?: InputMaybe<DeviceRecordProviderConnectFieldInput>;
	create?: InputMaybe<DeviceRecordProviderCreateFieldInput>;
};

export type DeviceRecordProviderNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<DeviceRecordProviderNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<DeviceRecordProviderNodeAggregationWhereInput>>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	name_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	name_EQUAL?: InputMaybe<Scalars["String"]>;
	name_GT?: InputMaybe<Scalars["Int"]>;
	name_GTE?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	name_LT?: InputMaybe<Scalars["Int"]>;
	name_LTE?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type DeviceRecordProviderRelationship = {
	__typename?: "DeviceRecordProviderRelationship";
	cursor: Scalars["String"];
	node: DeviceProvider;
};

export type DeviceRecordProviderUpdateConnectionInput = {
	node?: InputMaybe<DeviceProviderUpdateInput>;
};

export type DeviceRecordProviderUpdateFieldInput = {
	connect?: InputMaybe<DeviceRecordProviderConnectFieldInput>;
	create?: InputMaybe<DeviceRecordProviderCreateFieldInput>;
	delete?: InputMaybe<DeviceRecordProviderDeleteFieldInput>;
	disconnect?: InputMaybe<DeviceRecordProviderDisconnectFieldInput>;
	update?: InputMaybe<DeviceRecordProviderUpdateConnectionInput>;
	where?: InputMaybe<DeviceRecordProviderConnectionWhere>;
};

export type DeviceRecordRecordAggregateInput = {
	AND?: InputMaybe<Array<DeviceRecordRecordAggregateInput>>;
	OR?: InputMaybe<Array<DeviceRecordRecordAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<DeviceRecordRecordNodeAggregationWhereInput>;
};

export type DeviceRecordRecordConnectFieldInput = {
	connect?: InputMaybe<RecordConnectInput>;
	where?: InputMaybe<RecordConnectWhere>;
};

export type DeviceRecordRecordConnection = {
	__typename?: "DeviceRecordRecordConnection";
	edges: Array<DeviceRecordRecordRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type DeviceRecordRecordConnectionSort = {
	node?: InputMaybe<RecordSort>;
};

export type DeviceRecordRecordConnectionWhere = {
	AND?: InputMaybe<Array<DeviceRecordRecordConnectionWhere>>;
	OR?: InputMaybe<Array<DeviceRecordRecordConnectionWhere>>;
	node?: InputMaybe<RecordWhere>;
	node_NOT?: InputMaybe<RecordWhere>;
};

export type DeviceRecordRecordCreateFieldInput = {
	node: RecordCreateInput;
};

export type DeviceRecordRecordDeleteFieldInput = {
	delete?: InputMaybe<RecordDeleteInput>;
	where?: InputMaybe<DeviceRecordRecordConnectionWhere>;
};

export type DeviceRecordRecordDisconnectFieldInput = {
	disconnect?: InputMaybe<RecordDisconnectInput>;
	where?: InputMaybe<DeviceRecordRecordConnectionWhere>;
};

export type DeviceRecordRecordFieldInput = {
	connect?: InputMaybe<DeviceRecordRecordConnectFieldInput>;
	create?: InputMaybe<DeviceRecordRecordCreateFieldInput>;
};

export type DeviceRecordRecordNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<DeviceRecordRecordNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<DeviceRecordRecordNodeAggregationWhereInput>>;
	administrationDate_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_GT?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_GTE?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_LT?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_LTE?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	claimId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	claimId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	claimId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	claimId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	claimId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	claimId_EQUAL?: InputMaybe<Scalars["String"]>;
	claimId_GT?: InputMaybe<Scalars["Int"]>;
	claimId_GTE?: InputMaybe<Scalars["Int"]>;
	claimId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	claimId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	claimId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	claimId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	claimId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	claimId_LT?: InputMaybe<Scalars["Int"]>;
	claimId_LTE?: InputMaybe<Scalars["Int"]>;
	claimId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	claimId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	claimId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	claimId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	claimId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	createdByName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	createdByName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	createdByName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	createdByName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	createdByName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	createdByName_EQUAL?: InputMaybe<Scalars["String"]>;
	createdByName_GT?: InputMaybe<Scalars["Int"]>;
	createdByName_GTE?: InputMaybe<Scalars["Int"]>;
	createdByName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	createdByName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	createdByName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	createdByName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	createdByName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	createdByName_LT?: InputMaybe<Scalars["Int"]>;
	createdByName_LTE?: InputMaybe<Scalars["Int"]>;
	createdByName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	createdByName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	createdByName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	createdByName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	createdByName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	createdBy_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	createdBy_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	createdBy_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	createdBy_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	createdBy_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	createdBy_EQUAL?: InputMaybe<Scalars["String"]>;
	createdBy_GT?: InputMaybe<Scalars["Int"]>;
	createdBy_GTE?: InputMaybe<Scalars["Int"]>;
	createdBy_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	createdBy_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	createdBy_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	createdBy_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	createdBy_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	createdBy_LT?: InputMaybe<Scalars["Int"]>;
	createdBy_LTE?: InputMaybe<Scalars["Int"]>;
	createdBy_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	createdBy_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	createdBy_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	createdBy_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	createdBy_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	createdOn_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	insuranceId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	insuranceId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	insuranceId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	insuranceId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	insuranceId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	insuranceId_EQUAL?: InputMaybe<Scalars["String"]>;
	insuranceId_GT?: InputMaybe<Scalars["Int"]>;
	insuranceId_GTE?: InputMaybe<Scalars["Int"]>;
	insuranceId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	insuranceId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	insuranceId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	insuranceId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	insuranceId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	insuranceId_LT?: InputMaybe<Scalars["Int"]>;
	insuranceId_LTE?: InputMaybe<Scalars["Int"]>;
	insuranceId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	insuranceId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	insuranceId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	insuranceId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	insuranceId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	invoiceDate_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	invoiceDate_GT?: InputMaybe<Scalars["DateTime"]>;
	invoiceDate_GTE?: InputMaybe<Scalars["DateTime"]>;
	invoiceDate_LT?: InputMaybe<Scalars["DateTime"]>;
	invoiceDate_LTE?: InputMaybe<Scalars["DateTime"]>;
	invoiceDate_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	invoiceDate_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	invoiceDate_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	invoiceDate_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	invoiceDate_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	invoiceDate_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	invoiceDate_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	invoiceDate_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	invoiceDate_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	invoiceDate_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	invoiceNumber_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	invoiceNumber_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	invoiceNumber_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	invoiceNumber_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	invoiceNumber_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	invoiceNumber_EQUAL?: InputMaybe<Scalars["String"]>;
	invoiceNumber_GT?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_GTE?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_LT?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_LTE?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	preparationBrandNames_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	preparationBrandNames_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	preparationBrandNames_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	preparationBrandNames_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	preparationBrandNames_EQUAL?: InputMaybe<Scalars["String"]>;
	preparationBrandNames_GT?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_GTE?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_LT?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_LTE?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	preparationGenericNames_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	preparationGenericNames_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	preparationGenericNames_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	preparationGenericNames_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	preparationGenericNames_EQUAL?: InputMaybe<Scalars["String"]>;
	preparationGenericNames_GT?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_GTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_LT?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_LTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	preparationId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	preparationId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	preparationId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	preparationId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	preparationId_EQUAL?: InputMaybe<Scalars["String"]>;
	preparationId_GT?: InputMaybe<Scalars["Int"]>;
	preparationId_GTE?: InputMaybe<Scalars["Int"]>;
	preparationId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationId_LT?: InputMaybe<Scalars["Int"]>;
	preparationId_LTE?: InputMaybe<Scalars["Int"]>;
	preparationId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	quantity_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	quantity_EQUAL?: InputMaybe<Scalars["Int"]>;
	quantity_GT?: InputMaybe<Scalars["Int"]>;
	quantity_GTE?: InputMaybe<Scalars["Int"]>;
	quantity_LT?: InputMaybe<Scalars["Int"]>;
	quantity_LTE?: InputMaybe<Scalars["Int"]>;
	quantity_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	quantity_MAX_GT?: InputMaybe<Scalars["Int"]>;
	quantity_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	quantity_MAX_LT?: InputMaybe<Scalars["Int"]>;
	quantity_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	quantity_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	quantity_MIN_GT?: InputMaybe<Scalars["Int"]>;
	quantity_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	quantity_MIN_LT?: InputMaybe<Scalars["Int"]>;
	quantity_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	tenantId_EQUAL?: InputMaybe<Scalars["String"]>;
	tenantId_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	treatmentName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	treatmentName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	treatmentName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	treatmentName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	treatmentName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	treatmentName_EQUAL?: InputMaybe<Scalars["String"]>;
	treatmentName_GT?: InputMaybe<Scalars["Int"]>;
	treatmentName_GTE?: InputMaybe<Scalars["Int"]>;
	treatmentName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	treatmentName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	treatmentName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	treatmentName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	treatmentName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	treatmentName_LT?: InputMaybe<Scalars["Int"]>;
	treatmentName_LTE?: InputMaybe<Scalars["Int"]>;
	treatmentName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	treatmentName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	treatmentName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	treatmentName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	treatmentName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	unlimited_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	unlimited_EQUAL?: InputMaybe<Scalars["Int"]>;
	unlimited_GT?: InputMaybe<Scalars["Int"]>;
	unlimited_GTE?: InputMaybe<Scalars["Int"]>;
	unlimited_LT?: InputMaybe<Scalars["Int"]>;
	unlimited_LTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_GT?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_LT?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_GT?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_LT?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	uuid_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	uuid_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	uuid_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	uuid_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	uuid_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	uuid_EQUAL?: InputMaybe<Scalars["String"]>;
	uuid_GT?: InputMaybe<Scalars["Int"]>;
	uuid_GTE?: InputMaybe<Scalars["Int"]>;
	uuid_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	uuid_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	uuid_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	uuid_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	uuid_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	uuid_LT?: InputMaybe<Scalars["Int"]>;
	uuid_LTE?: InputMaybe<Scalars["Int"]>;
	uuid_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	uuid_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	uuid_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	uuid_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	uuid_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type DeviceRecordRecordRelationship = {
	__typename?: "DeviceRecordRecordRelationship";
	cursor: Scalars["String"];
	node: Record;
};

export type DeviceRecordRecordUpdateConnectionInput = {
	node?: InputMaybe<RecordUpdateInput>;
};

export type DeviceRecordRecordUpdateFieldInput = {
	connect?: InputMaybe<DeviceRecordRecordConnectFieldInput>;
	create?: InputMaybe<DeviceRecordRecordCreateFieldInput>;
	delete?: InputMaybe<DeviceRecordRecordDeleteFieldInput>;
	disconnect?: InputMaybe<DeviceRecordRecordDisconnectFieldInput>;
	update?: InputMaybe<DeviceRecordRecordUpdateConnectionInput>;
	where?: InputMaybe<DeviceRecordRecordConnectionWhere>;
};

/** Fields to sort DeviceRecords by. The order in which sorts are applied is not guaranteed when specifying many fields in one DeviceRecordSort object. */
export type DeviceRecordSort = {
	deviceId?: InputMaybe<SortDirection>;
	deviceRef?: InputMaybe<SortDirection>;
	id?: InputMaybe<SortDirection>;
	invoicedSales?: InputMaybe<SortDirection>;
	orderLineNumber?: InputMaybe<SortDirection>;
	orderNumber?: InputMaybe<SortDirection>;
	price?: InputMaybe<SortDirection>;
	productName?: InputMaybe<SortDirection>;
	quantity?: InputMaybe<SortDirection>;
	refundPercentage?: InputMaybe<SortDirection>;
	saleDate?: InputMaybe<SortDirection>;
	tenantId?: InputMaybe<SortDirection>;
};

export type DeviceRecordUpdateInput = {
	category?: InputMaybe<DeviceRecordCategoryUpdateFieldInput>;
	deviceId?: InputMaybe<Scalars["String"]>;
	deviceRef?: InputMaybe<Scalars["String"]>;
	id?: InputMaybe<Scalars["ID"]>;
	invoicedSales?: InputMaybe<Scalars["Float"]>;
	orderLineNumber?: InputMaybe<Scalars["Int"]>;
	orderNumber?: InputMaybe<Scalars["Int"]>;
	price?: InputMaybe<Scalars["Float"]>;
	processedAs?: InputMaybe<DeviceRecordProcessedAsUpdateFieldInput>;
	productName?: InputMaybe<Scalars["String"]>;
	provider?: InputMaybe<DeviceRecordProviderUpdateFieldInput>;
	quantity?: InputMaybe<Scalars["Int"]>;
	record?: InputMaybe<DeviceRecordRecordUpdateFieldInput>;
	refundPercentage?: InputMaybe<Scalars["Float"]>;
	saleDate?: InputMaybe<Scalars["DateTime"]>;
	tenantId?: InputMaybe<Scalars["String"]>;
};

export type DeviceRecordWhere = {
	AND?: InputMaybe<Array<DeviceRecordWhere>>;
	OR?: InputMaybe<Array<DeviceRecordWhere>>;
	category?: InputMaybe<DeviceProductCategoryWhere>;
	categoryAggregate?: InputMaybe<DeviceRecordCategoryAggregateInput>;
	categoryConnection?: InputMaybe<DeviceRecordCategoryConnectionWhere>;
	categoryConnection_NOT?: InputMaybe<DeviceRecordCategoryConnectionWhere>;
	category_NOT?: InputMaybe<DeviceProductCategoryWhere>;
	deviceId?: InputMaybe<Scalars["String"]>;
	deviceId_CONTAINS?: InputMaybe<Scalars["String"]>;
	deviceId_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	deviceId_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	deviceId_MATCHES?: InputMaybe<Scalars["String"]>;
	deviceId_NOT?: InputMaybe<Scalars["String"]>;
	deviceId_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	deviceId_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	deviceId_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	deviceId_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	deviceId_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	deviceRef?: InputMaybe<Scalars["String"]>;
	deviceRef_CONTAINS?: InputMaybe<Scalars["String"]>;
	deviceRef_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	deviceRef_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	deviceRef_MATCHES?: InputMaybe<Scalars["String"]>;
	deviceRef_NOT?: InputMaybe<Scalars["String"]>;
	deviceRef_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	deviceRef_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	deviceRef_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	deviceRef_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	deviceRef_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	id?: InputMaybe<Scalars["ID"]>;
	id_CONTAINS?: InputMaybe<Scalars["ID"]>;
	id_ENDS_WITH?: InputMaybe<Scalars["ID"]>;
	id_IN?: InputMaybe<Array<InputMaybe<Scalars["ID"]>>>;
	id_MATCHES?: InputMaybe<Scalars["String"]>;
	id_NOT?: InputMaybe<Scalars["ID"]>;
	id_NOT_CONTAINS?: InputMaybe<Scalars["ID"]>;
	id_NOT_ENDS_WITH?: InputMaybe<Scalars["ID"]>;
	id_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["ID"]>>>;
	id_NOT_STARTS_WITH?: InputMaybe<Scalars["ID"]>;
	id_STARTS_WITH?: InputMaybe<Scalars["ID"]>;
	invoicedSales?: InputMaybe<Scalars["Float"]>;
	invoicedSales_GT?: InputMaybe<Scalars["Float"]>;
	invoicedSales_GTE?: InputMaybe<Scalars["Float"]>;
	invoicedSales_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	invoicedSales_LT?: InputMaybe<Scalars["Float"]>;
	invoicedSales_LTE?: InputMaybe<Scalars["Float"]>;
	invoicedSales_NOT?: InputMaybe<Scalars["Float"]>;
	invoicedSales_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	orderLineNumber?: InputMaybe<Scalars["Int"]>;
	orderLineNumber_GT?: InputMaybe<Scalars["Int"]>;
	orderLineNumber_GTE?: InputMaybe<Scalars["Int"]>;
	orderLineNumber_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	orderLineNumber_LT?: InputMaybe<Scalars["Int"]>;
	orderLineNumber_LTE?: InputMaybe<Scalars["Int"]>;
	orderLineNumber_NOT?: InputMaybe<Scalars["Int"]>;
	orderLineNumber_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	orderNumber?: InputMaybe<Scalars["Int"]>;
	orderNumber_GT?: InputMaybe<Scalars["Int"]>;
	orderNumber_GTE?: InputMaybe<Scalars["Int"]>;
	orderNumber_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	orderNumber_LT?: InputMaybe<Scalars["Int"]>;
	orderNumber_LTE?: InputMaybe<Scalars["Int"]>;
	orderNumber_NOT?: InputMaybe<Scalars["Int"]>;
	orderNumber_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	price?: InputMaybe<Scalars["Float"]>;
	price_GT?: InputMaybe<Scalars["Float"]>;
	price_GTE?: InputMaybe<Scalars["Float"]>;
	price_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	price_LT?: InputMaybe<Scalars["Float"]>;
	price_LTE?: InputMaybe<Scalars["Float"]>;
	price_NOT?: InputMaybe<Scalars["Float"]>;
	price_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	processedAs?: InputMaybe<ProcessedDeviceRecordWhere>;
	processedAsAggregate?: InputMaybe<DeviceRecordProcessedAsAggregateInput>;
	processedAsConnection?: InputMaybe<DeviceRecordProcessedAsConnectionWhere>;
	processedAsConnection_NOT?: InputMaybe<DeviceRecordProcessedAsConnectionWhere>;
	processedAs_NOT?: InputMaybe<ProcessedDeviceRecordWhere>;
	productName?: InputMaybe<Scalars["String"]>;
	productName_CONTAINS?: InputMaybe<Scalars["String"]>;
	productName_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	productName_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	productName_MATCHES?: InputMaybe<Scalars["String"]>;
	productName_NOT?: InputMaybe<Scalars["String"]>;
	productName_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	productName_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	productName_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	productName_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	productName_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	provider?: InputMaybe<DeviceProviderWhere>;
	providerAggregate?: InputMaybe<DeviceRecordProviderAggregateInput>;
	providerConnection?: InputMaybe<DeviceRecordProviderConnectionWhere>;
	providerConnection_NOT?: InputMaybe<DeviceRecordProviderConnectionWhere>;
	provider_NOT?: InputMaybe<DeviceProviderWhere>;
	quantity?: InputMaybe<Scalars["Int"]>;
	quantity_GT?: InputMaybe<Scalars["Int"]>;
	quantity_GTE?: InputMaybe<Scalars["Int"]>;
	quantity_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	quantity_LT?: InputMaybe<Scalars["Int"]>;
	quantity_LTE?: InputMaybe<Scalars["Int"]>;
	quantity_NOT?: InputMaybe<Scalars["Int"]>;
	quantity_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	record?: InputMaybe<RecordWhere>;
	recordAggregate?: InputMaybe<DeviceRecordRecordAggregateInput>;
	recordConnection?: InputMaybe<DeviceRecordRecordConnectionWhere>;
	recordConnection_NOT?: InputMaybe<DeviceRecordRecordConnectionWhere>;
	record_NOT?: InputMaybe<RecordWhere>;
	refundPercentage?: InputMaybe<Scalars["Float"]>;
	refundPercentage_GT?: InputMaybe<Scalars["Float"]>;
	refundPercentage_GTE?: InputMaybe<Scalars["Float"]>;
	refundPercentage_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	refundPercentage_LT?: InputMaybe<Scalars["Float"]>;
	refundPercentage_LTE?: InputMaybe<Scalars["Float"]>;
	refundPercentage_NOT?: InputMaybe<Scalars["Float"]>;
	refundPercentage_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	saleDate?: InputMaybe<Scalars["DateTime"]>;
	saleDate_GT?: InputMaybe<Scalars["DateTime"]>;
	saleDate_GTE?: InputMaybe<Scalars["DateTime"]>;
	saleDate_IN?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]>>>;
	saleDate_LT?: InputMaybe<Scalars["DateTime"]>;
	saleDate_LTE?: InputMaybe<Scalars["DateTime"]>;
	saleDate_NOT?: InputMaybe<Scalars["DateTime"]>;
	saleDate_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]>>>;
	tenantId?: InputMaybe<Scalars["String"]>;
	tenantId_CONTAINS?: InputMaybe<Scalars["String"]>;
	tenantId_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	tenantId_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	tenantId_MATCHES?: InputMaybe<Scalars["String"]>;
	tenantId_NOT?: InputMaybe<Scalars["String"]>;
	tenantId_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	tenantId_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	tenantId_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	tenantId_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	tenantId_STARTS_WITH?: InputMaybe<Scalars["String"]>;
};

export type DiscontinuationNote = ITreatmentState & {
	__typename?: "DiscontinuationNote";
	assessmentDate: Scalars["Date"];
	coverageRequest?: Maybe<CoverageRequest>;
	coverageRequestConnection: DiscontinuationNoteCoverageRequestConnection;
	createdOn: Scalars["DateTime"];
	form?: Maybe<Form>;
	formConnection: DiscontinuationNoteFormConnection;
	id: Scalars["ID"];
	isArchived: Scalars["Boolean"];
	isDeleted: Scalars["Boolean"];
	isPatientEnrolledInTreatment: Scalars["Boolean"];
	reasonForDiscontinuation?: Maybe<ReasonsForDiscontinuation>;
	status?: Maybe<FormStatus>;
	submissionDate?: Maybe<Scalars["DateTime"]>;
	tenantId: Scalars["String"];
};

export type DiscontinuationNoteCoverageRequestArgs = {
	options?: InputMaybe<CoverageRequestOptions>;
	where?: InputMaybe<CoverageRequestWhere>;
};

export type DiscontinuationNoteCoverageRequestConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<DiscontinuationNoteCoverageRequestConnectionSort>>;
	where?: InputMaybe<DiscontinuationNoteCoverageRequestConnectionWhere>;
};

export type DiscontinuationNoteFormArgs = {
	options?: InputMaybe<FormOptions>;
	where?: InputMaybe<FormWhere>;
};

export type DiscontinuationNoteFormConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<DiscontinuationNoteFormConnectionSort>>;
	where?: InputMaybe<DiscontinuationNoteFormConnectionWhere>;
};

export type DiscontinuationNoteAggregateSelection = {
	__typename?: "DiscontinuationNoteAggregateSelection";
	count: Scalars["Int"];
	createdOn: DateTimeAggregateSelection;
	id: IdAggregateSelection;
	submissionDate: DateTimeAggregateSelection;
	tenantId: StringAggregateSelection;
};

export type DiscontinuationNoteConnectInput = {
	coverageRequest?: InputMaybe<DiscontinuationNoteCoverageRequestConnectFieldInput>;
	form?: InputMaybe<DiscontinuationNoteFormConnectFieldInput>;
};

export type DiscontinuationNoteConnectWhere = {
	node: DiscontinuationNoteWhere;
};

export type DiscontinuationNoteCoverageRequestAggregateInput = {
	AND?: InputMaybe<Array<DiscontinuationNoteCoverageRequestAggregateInput>>;
	OR?: InputMaybe<Array<DiscontinuationNoteCoverageRequestAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<DiscontinuationNoteCoverageRequestNodeAggregationWhereInput>;
};

export type DiscontinuationNoteCoverageRequestConnectFieldInput = {
	connect?: InputMaybe<CoverageRequestConnectInput>;
	where?: InputMaybe<CoverageRequestConnectWhere>;
};

export type DiscontinuationNoteCoverageRequestConnection = {
	__typename?: "DiscontinuationNoteCoverageRequestConnection";
	edges: Array<DiscontinuationNoteCoverageRequestRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type DiscontinuationNoteCoverageRequestConnectionSort = {
	node?: InputMaybe<CoverageRequestSort>;
};

export type DiscontinuationNoteCoverageRequestConnectionWhere = {
	AND?: InputMaybe<Array<DiscontinuationNoteCoverageRequestConnectionWhere>>;
	OR?: InputMaybe<Array<DiscontinuationNoteCoverageRequestConnectionWhere>>;
	node?: InputMaybe<CoverageRequestWhere>;
	node_NOT?: InputMaybe<CoverageRequestWhere>;
};

export type DiscontinuationNoteCoverageRequestCreateFieldInput = {
	node: CoverageRequestCreateInput;
};

export type DiscontinuationNoteCoverageRequestDeleteFieldInput = {
	delete?: InputMaybe<CoverageRequestDeleteInput>;
	where?: InputMaybe<DiscontinuationNoteCoverageRequestConnectionWhere>;
};

export type DiscontinuationNoteCoverageRequestDisconnectFieldInput = {
	disconnect?: InputMaybe<CoverageRequestDisconnectInput>;
	where?: InputMaybe<DiscontinuationNoteCoverageRequestConnectionWhere>;
};

export type DiscontinuationNoteCoverageRequestFieldInput = {
	connect?: InputMaybe<DiscontinuationNoteCoverageRequestConnectFieldInput>;
	create?: InputMaybe<DiscontinuationNoteCoverageRequestCreateFieldInput>;
};

export type DiscontinuationNoteCoverageRequestNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<DiscontinuationNoteCoverageRequestNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<DiscontinuationNoteCoverageRequestNodeAggregationWhereInput>>;
	createdOn_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	duration_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	duration_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	duration_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	duration_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	duration_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	duration_EQUAL?: InputMaybe<Scalars["Int"]>;
	duration_GT?: InputMaybe<Scalars["Int"]>;
	duration_GTE?: InputMaybe<Scalars["Int"]>;
	duration_LT?: InputMaybe<Scalars["Int"]>;
	duration_LTE?: InputMaybe<Scalars["Int"]>;
	duration_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	duration_MAX_GT?: InputMaybe<Scalars["Int"]>;
	duration_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	duration_MAX_LT?: InputMaybe<Scalars["Int"]>;
	duration_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	duration_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	duration_MIN_GT?: InputMaybe<Scalars["Int"]>;
	duration_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	duration_MIN_LT?: InputMaybe<Scalars["Int"]>;
	duration_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	lastUpdatedOn_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_GT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_LT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_GT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_GTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_LT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_LTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	tenantId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	tenantId_EQUAL?: InputMaybe<Scalars["String"]>;
	tenantId_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type DiscontinuationNoteCoverageRequestRelationship = {
	__typename?: "DiscontinuationNoteCoverageRequestRelationship";
	cursor: Scalars["String"];
	node: CoverageRequest;
};

export type DiscontinuationNoteCoverageRequestUpdateConnectionInput = {
	node?: InputMaybe<CoverageRequestUpdateInput>;
};

export type DiscontinuationNoteCoverageRequestUpdateFieldInput = {
	connect?: InputMaybe<DiscontinuationNoteCoverageRequestConnectFieldInput>;
	create?: InputMaybe<DiscontinuationNoteCoverageRequestCreateFieldInput>;
	delete?: InputMaybe<DiscontinuationNoteCoverageRequestDeleteFieldInput>;
	disconnect?: InputMaybe<DiscontinuationNoteCoverageRequestDisconnectFieldInput>;
	update?: InputMaybe<DiscontinuationNoteCoverageRequestUpdateConnectionInput>;
	where?: InputMaybe<DiscontinuationNoteCoverageRequestConnectionWhere>;
};

export type DiscontinuationNoteCreateInput = {
	assessmentDate: Scalars["Date"];
	coverageRequest?: InputMaybe<DiscontinuationNoteCoverageRequestFieldInput>;
	createdOn: Scalars["DateTime"];
	form?: InputMaybe<DiscontinuationNoteFormFieldInput>;
	id: Scalars["ID"];
	isArchived: Scalars["Boolean"];
	isDeleted: Scalars["Boolean"];
	isPatientEnrolledInTreatment: Scalars["Boolean"];
	reasonForDiscontinuation?: InputMaybe<ReasonsForDiscontinuation>;
	status?: InputMaybe<FormStatus>;
	submissionDate?: InputMaybe<Scalars["DateTime"]>;
	tenantId: Scalars["String"];
};

export type DiscontinuationNoteDeleteInput = {
	coverageRequest?: InputMaybe<DiscontinuationNoteCoverageRequestDeleteFieldInput>;
	form?: InputMaybe<DiscontinuationNoteFormDeleteFieldInput>;
};

export type DiscontinuationNoteDisconnectInput = {
	coverageRequest?: InputMaybe<DiscontinuationNoteCoverageRequestDisconnectFieldInput>;
	form?: InputMaybe<DiscontinuationNoteFormDisconnectFieldInput>;
};

export type DiscontinuationNoteFormAggregateInput = {
	AND?: InputMaybe<Array<DiscontinuationNoteFormAggregateInput>>;
	OR?: InputMaybe<Array<DiscontinuationNoteFormAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<DiscontinuationNoteFormNodeAggregationWhereInput>;
};

export type DiscontinuationNoteFormConnectFieldInput = {
	connect?: InputMaybe<FormConnectInput>;
	where?: InputMaybe<FormConnectWhere>;
};

export type DiscontinuationNoteFormConnection = {
	__typename?: "DiscontinuationNoteFormConnection";
	edges: Array<DiscontinuationNoteFormRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type DiscontinuationNoteFormConnectionSort = {
	node?: InputMaybe<FormSort>;
};

export type DiscontinuationNoteFormConnectionWhere = {
	AND?: InputMaybe<Array<DiscontinuationNoteFormConnectionWhere>>;
	OR?: InputMaybe<Array<DiscontinuationNoteFormConnectionWhere>>;
	node?: InputMaybe<FormWhere>;
	node_NOT?: InputMaybe<FormWhere>;
};

export type DiscontinuationNoteFormCreateFieldInput = {
	node: FormCreateInput;
};

export type DiscontinuationNoteFormDeleteFieldInput = {
	delete?: InputMaybe<FormDeleteInput>;
	where?: InputMaybe<DiscontinuationNoteFormConnectionWhere>;
};

export type DiscontinuationNoteFormDisconnectFieldInput = {
	disconnect?: InputMaybe<FormDisconnectInput>;
	where?: InputMaybe<DiscontinuationNoteFormConnectionWhere>;
};

export type DiscontinuationNoteFormFieldInput = {
	connect?: InputMaybe<DiscontinuationNoteFormConnectFieldInput>;
	create?: InputMaybe<DiscontinuationNoteFormCreateFieldInput>;
};

export type DiscontinuationNoteFormNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<DiscontinuationNoteFormNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<DiscontinuationNoteFormNodeAggregationWhereInput>>;
	createdByName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	createdByName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	createdByName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	createdByName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	createdByName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	createdByName_EQUAL?: InputMaybe<Scalars["String"]>;
	createdByName_GT?: InputMaybe<Scalars["Int"]>;
	createdByName_GTE?: InputMaybe<Scalars["Int"]>;
	createdByName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	createdByName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	createdByName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	createdByName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	createdByName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	createdByName_LT?: InputMaybe<Scalars["Int"]>;
	createdByName_LTE?: InputMaybe<Scalars["Int"]>;
	createdByName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	createdByName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	createdByName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	createdByName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	createdByName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	createdBy_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	createdBy_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	createdBy_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	createdBy_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	createdBy_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	createdBy_EQUAL?: InputMaybe<Scalars["String"]>;
	createdBy_GT?: InputMaybe<Scalars["Int"]>;
	createdBy_GTE?: InputMaybe<Scalars["Int"]>;
	createdBy_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	createdBy_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	createdBy_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	createdBy_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	createdBy_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	createdBy_LT?: InputMaybe<Scalars["Int"]>;
	createdBy_LTE?: InputMaybe<Scalars["Int"]>;
	createdBy_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	createdBy_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	createdBy_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	createdBy_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	createdBy_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	createdOn_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	insuranceId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	insuranceId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	insuranceId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	insuranceId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	insuranceId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	insuranceId_EQUAL?: InputMaybe<Scalars["String"]>;
	insuranceId_GT?: InputMaybe<Scalars["Int"]>;
	insuranceId_GTE?: InputMaybe<Scalars["Int"]>;
	insuranceId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	insuranceId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	insuranceId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	insuranceId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	insuranceId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	insuranceId_LT?: InputMaybe<Scalars["Int"]>;
	insuranceId_LTE?: InputMaybe<Scalars["Int"]>;
	insuranceId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	insuranceId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	insuranceId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	insuranceId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	insuranceId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	lastUpdatedOn_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_GT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_LT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	preparationBrandName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	preparationBrandName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	preparationBrandName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	preparationBrandName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	preparationBrandName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	preparationBrandName_EQUAL?: InputMaybe<Scalars["String"]>;
	preparationBrandName_GT?: InputMaybe<Scalars["Int"]>;
	preparationBrandName_GTE?: InputMaybe<Scalars["Int"]>;
	preparationBrandName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationBrandName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationBrandName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationBrandName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationBrandName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationBrandName_LT?: InputMaybe<Scalars["Int"]>;
	preparationBrandName_LTE?: InputMaybe<Scalars["Int"]>;
	preparationBrandName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationBrandName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationBrandName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationBrandName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationBrandName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	preparationGenericName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	preparationGenericName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	preparationGenericName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	preparationGenericName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	preparationGenericName_EQUAL?: InputMaybe<Scalars["String"]>;
	preparationGenericName_GT?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_GTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_LT?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_LTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	tenantId_EQUAL?: InputMaybe<Scalars["String"]>;
	tenantId_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	unlimited_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	unlimited_EQUAL?: InputMaybe<Scalars["Int"]>;
	unlimited_GT?: InputMaybe<Scalars["Int"]>;
	unlimited_GTE?: InputMaybe<Scalars["Int"]>;
	unlimited_LT?: InputMaybe<Scalars["Int"]>;
	unlimited_LTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_GT?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_LT?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_GT?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_LT?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	uuid_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	uuid_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	uuid_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	uuid_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	uuid_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	uuid_EQUAL?: InputMaybe<Scalars["String"]>;
	uuid_GT?: InputMaybe<Scalars["Int"]>;
	uuid_GTE?: InputMaybe<Scalars["Int"]>;
	uuid_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	uuid_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	uuid_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	uuid_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	uuid_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	uuid_LT?: InputMaybe<Scalars["Int"]>;
	uuid_LTE?: InputMaybe<Scalars["Int"]>;
	uuid_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	uuid_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	uuid_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	uuid_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	uuid_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type DiscontinuationNoteFormRelationship = {
	__typename?: "DiscontinuationNoteFormRelationship";
	cursor: Scalars["String"];
	node: Form;
};

export type DiscontinuationNoteFormUpdateConnectionInput = {
	node?: InputMaybe<FormUpdateInput>;
};

export type DiscontinuationNoteFormUpdateFieldInput = {
	connect?: InputMaybe<DiscontinuationNoteFormConnectFieldInput>;
	create?: InputMaybe<DiscontinuationNoteFormCreateFieldInput>;
	delete?: InputMaybe<DiscontinuationNoteFormDeleteFieldInput>;
	disconnect?: InputMaybe<DiscontinuationNoteFormDisconnectFieldInput>;
	update?: InputMaybe<DiscontinuationNoteFormUpdateConnectionInput>;
	where?: InputMaybe<DiscontinuationNoteFormConnectionWhere>;
};

export type DiscontinuationNoteInput = {
	assessmentDate: Scalars["Date"];
	caseId?: InputMaybe<Scalars["String"]>;
	coverageRequestId: Scalars["ID"];
	formId?: InputMaybe<Scalars["ID"]>;
	id: Scalars["ID"];
	isPatientEnrolledInTreatment: Scalars["Boolean"];
	occurrence?: InputMaybe<OccurrenceEnum>;
	reasonForDiscontinuation?: InputMaybe<ReasonsForDiscontinuation>;
	status?: InputMaybe<FormStatus>;
};

export type DiscontinuationNoteOptions = {
	limit?: InputMaybe<Scalars["Int"]>;
	offset?: InputMaybe<Scalars["Int"]>;
	/** Specify one or more DiscontinuationNoteSort objects to sort DiscontinuationNotes by. The sorts will be applied in the order in which they are arranged in the array. */
	sort?: InputMaybe<Array<InputMaybe<DiscontinuationNoteSort>>>;
};

/** Fields to sort DiscontinuationNotes by. The order in which sorts are applied is not guaranteed when specifying many fields in one DiscontinuationNoteSort object. */
export type DiscontinuationNoteSort = {
	assessmentDate?: InputMaybe<SortDirection>;
	createdOn?: InputMaybe<SortDirection>;
	id?: InputMaybe<SortDirection>;
	isArchived?: InputMaybe<SortDirection>;
	isDeleted?: InputMaybe<SortDirection>;
	isPatientEnrolledInTreatment?: InputMaybe<SortDirection>;
	reasonForDiscontinuation?: InputMaybe<SortDirection>;
	status?: InputMaybe<SortDirection>;
	submissionDate?: InputMaybe<SortDirection>;
	tenantId?: InputMaybe<SortDirection>;
};

export type DiscontinuationNoteUpdateInput = {
	assessmentDate?: InputMaybe<Scalars["Date"]>;
	coverageRequest?: InputMaybe<DiscontinuationNoteCoverageRequestUpdateFieldInput>;
	createdOn?: InputMaybe<Scalars["DateTime"]>;
	form?: InputMaybe<DiscontinuationNoteFormUpdateFieldInput>;
	id?: InputMaybe<Scalars["ID"]>;
	isArchived?: InputMaybe<Scalars["Boolean"]>;
	isDeleted?: InputMaybe<Scalars["Boolean"]>;
	isPatientEnrolledInTreatment?: InputMaybe<Scalars["Boolean"]>;
	reasonForDiscontinuation?: InputMaybe<ReasonsForDiscontinuation>;
	status?: InputMaybe<FormStatus>;
	submissionDate?: InputMaybe<Scalars["DateTime"]>;
	tenantId?: InputMaybe<Scalars["String"]>;
};

export type DiscontinuationNoteWhere = {
	AND?: InputMaybe<Array<DiscontinuationNoteWhere>>;
	OR?: InputMaybe<Array<DiscontinuationNoteWhere>>;
	assessmentDate?: InputMaybe<Scalars["Date"]>;
	assessmentDate_GT?: InputMaybe<Scalars["Date"]>;
	assessmentDate_GTE?: InputMaybe<Scalars["Date"]>;
	assessmentDate_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
	assessmentDate_LT?: InputMaybe<Scalars["Date"]>;
	assessmentDate_LTE?: InputMaybe<Scalars["Date"]>;
	assessmentDate_NOT?: InputMaybe<Scalars["Date"]>;
	assessmentDate_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
	coverageRequest?: InputMaybe<CoverageRequestWhere>;
	coverageRequestAggregate?: InputMaybe<DiscontinuationNoteCoverageRequestAggregateInput>;
	coverageRequestConnection?: InputMaybe<DiscontinuationNoteCoverageRequestConnectionWhere>;
	coverageRequestConnection_NOT?: InputMaybe<DiscontinuationNoteCoverageRequestConnectionWhere>;
	coverageRequest_NOT?: InputMaybe<CoverageRequestWhere>;
	createdOn?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_IN?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]>>>;
	createdOn_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_NOT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]>>>;
	form?: InputMaybe<FormWhere>;
	formAggregate?: InputMaybe<DiscontinuationNoteFormAggregateInput>;
	formConnection?: InputMaybe<DiscontinuationNoteFormConnectionWhere>;
	formConnection_NOT?: InputMaybe<DiscontinuationNoteFormConnectionWhere>;
	form_NOT?: InputMaybe<FormWhere>;
	id?: InputMaybe<Scalars["ID"]>;
	id_CONTAINS?: InputMaybe<Scalars["ID"]>;
	id_ENDS_WITH?: InputMaybe<Scalars["ID"]>;
	id_IN?: InputMaybe<Array<InputMaybe<Scalars["ID"]>>>;
	id_MATCHES?: InputMaybe<Scalars["String"]>;
	id_NOT?: InputMaybe<Scalars["ID"]>;
	id_NOT_CONTAINS?: InputMaybe<Scalars["ID"]>;
	id_NOT_ENDS_WITH?: InputMaybe<Scalars["ID"]>;
	id_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["ID"]>>>;
	id_NOT_STARTS_WITH?: InputMaybe<Scalars["ID"]>;
	id_STARTS_WITH?: InputMaybe<Scalars["ID"]>;
	isArchived?: InputMaybe<Scalars["Boolean"]>;
	isArchived_NOT?: InputMaybe<Scalars["Boolean"]>;
	isDeleted?: InputMaybe<Scalars["Boolean"]>;
	isDeleted_NOT?: InputMaybe<Scalars["Boolean"]>;
	isPatientEnrolledInTreatment?: InputMaybe<Scalars["Boolean"]>;
	isPatientEnrolledInTreatment_NOT?: InputMaybe<Scalars["Boolean"]>;
	reasonForDiscontinuation?: InputMaybe<ReasonsForDiscontinuation>;
	reasonForDiscontinuation_IN?: InputMaybe<Array<InputMaybe<ReasonsForDiscontinuation>>>;
	reasonForDiscontinuation_NOT?: InputMaybe<ReasonsForDiscontinuation>;
	reasonForDiscontinuation_NOT_IN?: InputMaybe<Array<InputMaybe<ReasonsForDiscontinuation>>>;
	status?: InputMaybe<FormStatus>;
	status_IN?: InputMaybe<Array<InputMaybe<FormStatus>>>;
	status_NOT?: InputMaybe<FormStatus>;
	status_NOT_IN?: InputMaybe<Array<InputMaybe<FormStatus>>>;
	submissionDate?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_GT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_GTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_IN?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]>>>;
	submissionDate_LT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_LTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_NOT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]>>>;
	tenantId?: InputMaybe<Scalars["String"]>;
	tenantId_CONTAINS?: InputMaybe<Scalars["String"]>;
	tenantId_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	tenantId_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	tenantId_MATCHES?: InputMaybe<Scalars["String"]>;
	tenantId_NOT?: InputMaybe<Scalars["String"]>;
	tenantId_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	tenantId_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	tenantId_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	tenantId_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	tenantId_STARTS_WITH?: InputMaybe<Scalars["String"]>;
};

export type Disease = {
	__typename?: "Disease";
	Icd10Code: Scalars["String"];
	Name: Scalars["String"];
};

export type DiseaseAggregateSelection = {
	__typename?: "DiseaseAggregateSelection";
	Icd10Code: StringAggregateSelection;
	Name: StringAggregateSelection;
	count: Scalars["Int"];
};

export type DiseaseConnectWhere = {
	node: DiseaseWhere;
};

export type DiseaseCreateInput = {
	Icd10Code: Scalars["String"];
	Name: Scalars["String"];
};

export type DiseaseOptions = {
	limit?: InputMaybe<Scalars["Int"]>;
	offset?: InputMaybe<Scalars["Int"]>;
	/** Specify one or more DiseaseSort objects to sort Diseases by. The sorts will be applied in the order in which they are arranged in the array. */
	sort?: InputMaybe<Array<InputMaybe<DiseaseSort>>>;
};

/** Fields to sort Diseases by. The order in which sorts are applied is not guaranteed when specifying many fields in one DiseaseSort object. */
export type DiseaseSort = {
	Icd10Code?: InputMaybe<SortDirection>;
	Name?: InputMaybe<SortDirection>;
};

export type DiseaseUpdateInput = {
	Icd10Code?: InputMaybe<Scalars["String"]>;
	Name?: InputMaybe<Scalars["String"]>;
};

export type DiseaseWhere = {
	AND?: InputMaybe<Array<DiseaseWhere>>;
	Icd10Code?: InputMaybe<Scalars["String"]>;
	Icd10Code_CONTAINS?: InputMaybe<Scalars["String"]>;
	Icd10Code_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	Icd10Code_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	Icd10Code_MATCHES?: InputMaybe<Scalars["String"]>;
	Icd10Code_NOT?: InputMaybe<Scalars["String"]>;
	Icd10Code_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	Icd10Code_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	Icd10Code_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	Icd10Code_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	Icd10Code_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	Name?: InputMaybe<Scalars["String"]>;
	Name_CONTAINS?: InputMaybe<Scalars["String"]>;
	Name_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	Name_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	Name_MATCHES?: InputMaybe<Scalars["String"]>;
	Name_NOT?: InputMaybe<Scalars["String"]>;
	Name_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	Name_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	Name_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	Name_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	Name_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	OR?: InputMaybe<Array<DiseaseWhere>>;
};

export type Document = {
	__typename?: "Document";
	agreementBuyerInvoiceInfo?: Maybe<Organization>;
	agreementSellerInvoiceInfo?: Maybe<Organization>;
	agreementsWithoutUserAccess: Array<BaseAgreement>;
	assignedTo?: Maybe<Array<Maybe<User>>>;
	assignedToConnection: DocumentAssignedToConnection;
	canAssignUser?: Maybe<Scalars["Boolean"]>;
	canUserDelete: Scalars["Boolean"];
	counterParties?: Maybe<Scalars["String"]>;
	coveragePeriod?: Maybe<Scalars["String"]>;
	coveragePeriodEnd?: Maybe<Scalars["Date"]>;
	coveragePeriodStart?: Maybe<Scalars["Date"]>;
	createdBy: Scalars["String"];
	createdOn: Scalars["DateTime"];
	creatorOrgName?: Maybe<Scalars["String"]>;
	creatorTenantId?: Maybe<Scalars["String"]>;
	formattedTags: Scalars["String"];
	id: Scalars["ID"];
	invoiceAmount?: Maybe<Scalars["Int"]>;
	isAgreementBuyer?: Maybe<Scalars["Boolean"]>;
	isAgreementOwner?: Maybe<Scalars["Boolean"]>;
	isAgreementSeller?: Maybe<Scalars["Boolean"]>;
	isAssignee?: Maybe<Scalars["Boolean"]>;
	isConfirmedBySeller?: Maybe<Scalars["Boolean"]>;
	isDeleted?: Maybe<Scalars["Boolean"]>;
	issuedOn?: Maybe<Scalars["DateTime"]>;
	lastUpdatedOn?: Maybe<Scalars["DateTime"]>;
	product: Scalars["String"];
	refunds: Array<Refund>;
	refundsConnection: DocumentRefundsConnection;
	settledOn?: Maybe<Scalars["Date"]>;
	status?: Maybe<DocumentStatus>;
	tags: Array<AgreementTag>;
	tagsConnection: DocumentTagsConnection;
	tenantIds: Array<Scalars["String"]>;
	type?: Maybe<DocumentType>;
	unlimited?: Maybe<Scalars["Int"]>;
};

export type DocumentAssignedToArgs = {
	options?: InputMaybe<UserOptions>;
	where?: InputMaybe<UserWhere>;
};

export type DocumentAssignedToConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<DocumentAssignedToConnectionSort>>;
	where?: InputMaybe<DocumentAssignedToConnectionWhere>;
};

export type DocumentRefundsArgs = {
	options?: InputMaybe<RefundOptions>;
	where?: InputMaybe<RefundWhere>;
};

export type DocumentRefundsConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<DocumentRefundsConnectionSort>>;
	where?: InputMaybe<DocumentRefundsConnectionWhere>;
};

export type DocumentTagsArgs = {
	options?: InputMaybe<AgreementTagOptions>;
	where?: InputMaybe<AgreementTagWhere>;
};

export type DocumentTagsConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<DocumentTagsConnectionSort>>;
	where?: InputMaybe<DocumentTagsConnectionWhere>;
};

export type DocumentAggregateSelection = {
	__typename?: "DocumentAggregateSelection";
	count: Scalars["Int"];
	counterParties: StringAggregateSelection;
	coveragePeriod: StringAggregateSelection;
	createdBy: StringAggregateSelection;
	createdOn: DateTimeAggregateSelection;
	creatorOrgName: StringAggregateSelection;
	creatorTenantId: StringAggregateSelection;
	formattedTags: StringAggregateSelection;
	id: IdAggregateSelection;
	invoiceAmount: IntAggregateSelection;
	issuedOn: DateTimeAggregateSelection;
	lastUpdatedOn: DateTimeAggregateSelection;
	product: StringAggregateSelection;
	unlimited: IntAggregateSelection;
};

export type DocumentAssignedToAggregateInput = {
	AND?: InputMaybe<Array<DocumentAssignedToAggregateInput>>;
	OR?: InputMaybe<Array<DocumentAssignedToAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<DocumentAssignedToNodeAggregationWhereInput>;
};

export type DocumentAssignedToConnectFieldInput = {
	connect?: InputMaybe<Array<UserConnectInput>>;
	where?: InputMaybe<UserConnectWhere>;
};

export type DocumentAssignedToConnection = {
	__typename?: "DocumentAssignedToConnection";
	edges: Array<DocumentAssignedToRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type DocumentAssignedToConnectionSort = {
	node?: InputMaybe<UserSort>;
};

export type DocumentAssignedToConnectionWhere = {
	AND?: InputMaybe<Array<DocumentAssignedToConnectionWhere>>;
	OR?: InputMaybe<Array<DocumentAssignedToConnectionWhere>>;
	node?: InputMaybe<UserWhere>;
	node_NOT?: InputMaybe<UserWhere>;
};

export type DocumentAssignedToCreateFieldInput = {
	node: UserCreateInput;
};

export type DocumentAssignedToDeleteFieldInput = {
	delete?: InputMaybe<UserDeleteInput>;
	where?: InputMaybe<DocumentAssignedToConnectionWhere>;
};

export type DocumentAssignedToDisconnectFieldInput = {
	disconnect?: InputMaybe<UserDisconnectInput>;
	where?: InputMaybe<DocumentAssignedToConnectionWhere>;
};

export type DocumentAssignedToFieldInput = {
	connect?: InputMaybe<Array<DocumentAssignedToConnectFieldInput>>;
	create?: InputMaybe<Array<DocumentAssignedToCreateFieldInput>>;
};

export type DocumentAssignedToNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<DocumentAssignedToNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<DocumentAssignedToNodeAggregationWhereInput>>;
	email_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	email_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	email_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	email_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	email_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	email_EQUAL?: InputMaybe<Scalars["String"]>;
	email_GT?: InputMaybe<Scalars["Int"]>;
	email_GTE?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	email_LT?: InputMaybe<Scalars["Int"]>;
	email_LTE?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	firstName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	firstName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	firstName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	firstName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	firstName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	firstName_EQUAL?: InputMaybe<Scalars["String"]>;
	firstName_GT?: InputMaybe<Scalars["Int"]>;
	firstName_GTE?: InputMaybe<Scalars["Int"]>;
	firstName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	firstName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	firstName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	firstName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	firstName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	firstName_LT?: InputMaybe<Scalars["Int"]>;
	firstName_LTE?: InputMaybe<Scalars["Int"]>;
	firstName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	firstName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	firstName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	firstName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	firstName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	lastName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	lastName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	lastName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	lastName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	lastName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	lastName_EQUAL?: InputMaybe<Scalars["String"]>;
	lastName_GT?: InputMaybe<Scalars["Int"]>;
	lastName_GTE?: InputMaybe<Scalars["Int"]>;
	lastName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	lastName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	lastName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	lastName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	lastName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	lastName_LT?: InputMaybe<Scalars["Int"]>;
	lastName_LTE?: InputMaybe<Scalars["Int"]>;
	lastName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	lastName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	lastName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	lastName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	lastName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	preferredLanguage_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	preferredLanguage_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	preferredLanguage_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	preferredLanguage_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	preferredLanguage_EQUAL?: InputMaybe<Scalars["String"]>;
	preferredLanguage_GT?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_GTE?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LT?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LTE?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	tenantId_EQUAL?: InputMaybe<Scalars["String"]>;
	tenantId_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type DocumentAssignedToRelationship = {
	__typename?: "DocumentAssignedToRelationship";
	cursor: Scalars["String"];
	node: User;
};

export type DocumentAssignedToUpdateConnectionInput = {
	node?: InputMaybe<UserUpdateInput>;
};

export type DocumentAssignedToUpdateFieldInput = {
	connect?: InputMaybe<Array<DocumentAssignedToConnectFieldInput>>;
	create?: InputMaybe<Array<DocumentAssignedToCreateFieldInput>>;
	delete?: InputMaybe<Array<DocumentAssignedToDeleteFieldInput>>;
	disconnect?: InputMaybe<Array<DocumentAssignedToDisconnectFieldInput>>;
	update?: InputMaybe<DocumentAssignedToUpdateConnectionInput>;
	where?: InputMaybe<DocumentAssignedToConnectionWhere>;
};

export type DocumentConnectInput = {
	assignedTo?: InputMaybe<Array<DocumentAssignedToConnectFieldInput>>;
	refunds?: InputMaybe<Array<DocumentRefundsConnectFieldInput>>;
	tags?: InputMaybe<Array<DocumentTagsConnectFieldInput>>;
};

export type DocumentConnectWhere = {
	node: DocumentWhere;
};

export type DocumentCreateInput = {
	assignedTo?: InputMaybe<DocumentAssignedToFieldInput>;
	counterParties?: InputMaybe<Scalars["String"]>;
	coveragePeriod?: InputMaybe<Scalars["String"]>;
	coveragePeriodEnd?: InputMaybe<Scalars["Date"]>;
	coveragePeriodStart?: InputMaybe<Scalars["Date"]>;
	createdBy: Scalars["String"];
	createdOn: Scalars["DateTime"];
	creatorOrgName?: InputMaybe<Scalars["String"]>;
	creatorTenantId?: InputMaybe<Scalars["String"]>;
	formattedTags: Scalars["String"];
	id: Scalars["ID"];
	invoiceAmount?: InputMaybe<Scalars["Int"]>;
	isConfirmedBySeller?: InputMaybe<Scalars["Boolean"]>;
	isDeleted?: InputMaybe<Scalars["Boolean"]>;
	issuedOn?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn?: InputMaybe<Scalars["DateTime"]>;
	product: Scalars["String"];
	refunds?: InputMaybe<DocumentRefundsFieldInput>;
	settledOn?: InputMaybe<Scalars["Date"]>;
	status?: InputMaybe<DocumentStatus>;
	tags?: InputMaybe<DocumentTagsFieldInput>;
	tenantIds: Array<Scalars["String"]>;
	type?: InputMaybe<DocumentType>;
	unlimited?: InputMaybe<Scalars["Int"]>;
};

export type DocumentDeleteInput = {
	assignedTo?: InputMaybe<Array<DocumentAssignedToDeleteFieldInput>>;
	refunds?: InputMaybe<Array<DocumentRefundsDeleteFieldInput>>;
	tags?: InputMaybe<Array<DocumentTagsDeleteFieldInput>>;
};

export type DocumentDisconnectInput = {
	assignedTo?: InputMaybe<Array<DocumentAssignedToDisconnectFieldInput>>;
	refunds?: InputMaybe<Array<DocumentRefundsDisconnectFieldInput>>;
	tags?: InputMaybe<Array<DocumentTagsDisconnectFieldInput>>;
};

export type DocumentOptions = {
	limit?: InputMaybe<Scalars["Int"]>;
	offset?: InputMaybe<Scalars["Int"]>;
	/** Specify one or more DocumentSort objects to sort Documents by. The sorts will be applied in the order in which they are arranged in the array. */
	sort?: InputMaybe<Array<InputMaybe<DocumentSort>>>;
};

export type DocumentRefundsAggregateInput = {
	AND?: InputMaybe<Array<DocumentRefundsAggregateInput>>;
	OR?: InputMaybe<Array<DocumentRefundsAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<DocumentRefundsNodeAggregationWhereInput>;
};

export type DocumentRefundsConnectFieldInput = {
	connect?: InputMaybe<Array<RefundConnectInput>>;
	where?: InputMaybe<RefundConnectWhere>;
};

export type DocumentRefundsConnection = {
	__typename?: "DocumentRefundsConnection";
	edges: Array<DocumentRefundsRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type DocumentRefundsConnectionSort = {
	node?: InputMaybe<RefundSort>;
};

export type DocumentRefundsConnectionWhere = {
	AND?: InputMaybe<Array<DocumentRefundsConnectionWhere>>;
	OR?: InputMaybe<Array<DocumentRefundsConnectionWhere>>;
	node?: InputMaybe<RefundWhere>;
	node_NOT?: InputMaybe<RefundWhere>;
};

export type DocumentRefundsCreateFieldInput = {
	node: RefundCreateInput;
};

export type DocumentRefundsDeleteFieldInput = {
	delete?: InputMaybe<RefundDeleteInput>;
	where?: InputMaybe<DocumentRefundsConnectionWhere>;
};

export type DocumentRefundsDisconnectFieldInput = {
	disconnect?: InputMaybe<RefundDisconnectInput>;
	where?: InputMaybe<DocumentRefundsConnectionWhere>;
};

export type DocumentRefundsFieldInput = {
	connect?: InputMaybe<Array<DocumentRefundsConnectFieldInput>>;
	create?: InputMaybe<Array<DocumentRefundsCreateFieldInput>>;
};

export type DocumentRefundsNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<DocumentRefundsNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<DocumentRefundsNodeAggregationWhereInput>>;
	agreementName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	agreementName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	agreementName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	agreementName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	agreementName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	agreementName_EQUAL?: InputMaybe<Scalars["String"]>;
	agreementName_GT?: InputMaybe<Scalars["Int"]>;
	agreementName_GTE?: InputMaybe<Scalars["Int"]>;
	agreementName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	agreementName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	agreementName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	agreementName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	agreementName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	agreementName_LT?: InputMaybe<Scalars["Int"]>;
	agreementName_LTE?: InputMaybe<Scalars["Int"]>;
	agreementName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	agreementName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	agreementName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	agreementName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	agreementName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	amount_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	amount_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	amount_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	amount_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	amount_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	amount_EQUAL?: InputMaybe<Scalars["Float"]>;
	amount_GT?: InputMaybe<Scalars["Float"]>;
	amount_GTE?: InputMaybe<Scalars["Float"]>;
	amount_LT?: InputMaybe<Scalars["Float"]>;
	amount_LTE?: InputMaybe<Scalars["Float"]>;
	amount_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	amount_MAX_GT?: InputMaybe<Scalars["Float"]>;
	amount_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	amount_MAX_LT?: InputMaybe<Scalars["Float"]>;
	amount_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	amount_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	amount_MIN_GT?: InputMaybe<Scalars["Float"]>;
	amount_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	amount_MIN_LT?: InputMaybe<Scalars["Float"]>;
	amount_MIN_LTE?: InputMaybe<Scalars["Float"]>;
	caseId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	caseId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	caseId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	caseId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	caseId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	caseId_EQUAL?: InputMaybe<Scalars["String"]>;
	caseId_GT?: InputMaybe<Scalars["Int"]>;
	caseId_GTE?: InputMaybe<Scalars["Int"]>;
	caseId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	caseId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	caseId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	caseId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	caseId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	caseId_LT?: InputMaybe<Scalars["Int"]>;
	caseId_LTE?: InputMaybe<Scalars["Int"]>;
	caseId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	caseId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	caseId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	caseId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	caseId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	counterParties_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	counterParties_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	counterParties_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	counterParties_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	counterParties_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	counterParties_EQUAL?: InputMaybe<Scalars["String"]>;
	counterParties_GT?: InputMaybe<Scalars["Int"]>;
	counterParties_GTE?: InputMaybe<Scalars["Int"]>;
	counterParties_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	counterParties_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	counterParties_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	counterParties_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	counterParties_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	counterParties_LT?: InputMaybe<Scalars["Int"]>;
	counterParties_LTE?: InputMaybe<Scalars["Int"]>;
	counterParties_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	counterParties_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	counterParties_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	counterParties_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	counterParties_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	currency_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	currency_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	currency_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	currency_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	currency_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	currency_EQUAL?: InputMaybe<Scalars["String"]>;
	currency_GT?: InputMaybe<Scalars["Int"]>;
	currency_GTE?: InputMaybe<Scalars["Int"]>;
	currency_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	currency_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	currency_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	currency_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	currency_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	currency_LT?: InputMaybe<Scalars["Int"]>;
	currency_LTE?: InputMaybe<Scalars["Int"]>;
	currency_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	currency_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	currency_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	currency_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	currency_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	formattedTags_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	formattedTags_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	formattedTags_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	formattedTags_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	formattedTags_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	formattedTags_EQUAL?: InputMaybe<Scalars["String"]>;
	formattedTags_GT?: InputMaybe<Scalars["Int"]>;
	formattedTags_GTE?: InputMaybe<Scalars["Int"]>;
	formattedTags_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedTags_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedTags_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedTags_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedTags_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	formattedTags_LT?: InputMaybe<Scalars["Int"]>;
	formattedTags_LTE?: InputMaybe<Scalars["Int"]>;
	formattedTags_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedTags_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedTags_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedTags_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedTags_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	iin_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	iin_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	iin_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	iin_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	iin_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	iin_EQUAL?: InputMaybe<Scalars["String"]>;
	iin_GT?: InputMaybe<Scalars["Int"]>;
	iin_GTE?: InputMaybe<Scalars["Int"]>;
	iin_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	iin_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	iin_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	iin_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	iin_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	iin_LT?: InputMaybe<Scalars["Int"]>;
	iin_LTE?: InputMaybe<Scalars["Int"]>;
	iin_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	iin_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	iin_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	iin_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	iin_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	product_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	product_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	product_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	product_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	product_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	product_EQUAL?: InputMaybe<Scalars["String"]>;
	product_GT?: InputMaybe<Scalars["Int"]>;
	product_GTE?: InputMaybe<Scalars["Int"]>;
	product_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	product_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	product_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	product_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	product_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	product_LT?: InputMaybe<Scalars["Int"]>;
	product_LTE?: InputMaybe<Scalars["Int"]>;
	product_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	product_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	product_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	product_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	product_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	unlimited_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	unlimited_EQUAL?: InputMaybe<Scalars["Int"]>;
	unlimited_GT?: InputMaybe<Scalars["Int"]>;
	unlimited_GTE?: InputMaybe<Scalars["Int"]>;
	unlimited_LT?: InputMaybe<Scalars["Int"]>;
	unlimited_LTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_GT?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_LT?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_GT?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_LT?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_LTE?: InputMaybe<Scalars["Int"]>;
};

export type DocumentRefundsRelationship = {
	__typename?: "DocumentRefundsRelationship";
	cursor: Scalars["String"];
	node: Refund;
};

export type DocumentRefundsUpdateConnectionInput = {
	node?: InputMaybe<RefundUpdateInput>;
};

export type DocumentRefundsUpdateFieldInput = {
	connect?: InputMaybe<Array<DocumentRefundsConnectFieldInput>>;
	create?: InputMaybe<Array<DocumentRefundsCreateFieldInput>>;
	delete?: InputMaybe<Array<DocumentRefundsDeleteFieldInput>>;
	disconnect?: InputMaybe<Array<DocumentRefundsDisconnectFieldInput>>;
	update?: InputMaybe<DocumentRefundsUpdateConnectionInput>;
	where?: InputMaybe<DocumentRefundsConnectionWhere>;
};

/** Fields to sort Documents by. The order in which sorts are applied is not guaranteed when specifying many fields in one DocumentSort object. */
export type DocumentSort = {
	counterParties?: InputMaybe<SortDirection>;
	coveragePeriod?: InputMaybe<SortDirection>;
	coveragePeriodEnd?: InputMaybe<SortDirection>;
	coveragePeriodStart?: InputMaybe<SortDirection>;
	createdBy?: InputMaybe<SortDirection>;
	createdOn?: InputMaybe<SortDirection>;
	creatorOrgName?: InputMaybe<SortDirection>;
	creatorTenantId?: InputMaybe<SortDirection>;
	formattedTags?: InputMaybe<SortDirection>;
	id?: InputMaybe<SortDirection>;
	invoiceAmount?: InputMaybe<SortDirection>;
	isConfirmedBySeller?: InputMaybe<SortDirection>;
	isDeleted?: InputMaybe<SortDirection>;
	issuedOn?: InputMaybe<SortDirection>;
	lastUpdatedOn?: InputMaybe<SortDirection>;
	product?: InputMaybe<SortDirection>;
	settledOn?: InputMaybe<SortDirection>;
	status?: InputMaybe<SortDirection>;
	type?: InputMaybe<SortDirection>;
	unlimited?: InputMaybe<SortDirection>;
};

export enum DocumentStatus {
	InReview = "IN_REVIEW",
	Issued = "ISSUED",
	Settled = "SETTLED",
	WorkingDraft = "WORKING_DRAFT",
}

export type DocumentTagsAggregateInput = {
	AND?: InputMaybe<Array<DocumentTagsAggregateInput>>;
	OR?: InputMaybe<Array<DocumentTagsAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<DocumentTagsNodeAggregationWhereInput>;
};

export type DocumentTagsConnectFieldInput = {
	connect?: InputMaybe<Array<AgreementTagConnectInput>>;
	where?: InputMaybe<AgreementTagConnectWhere>;
};

export type DocumentTagsConnection = {
	__typename?: "DocumentTagsConnection";
	edges: Array<DocumentTagsRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type DocumentTagsConnectionSort = {
	node?: InputMaybe<AgreementTagSort>;
};

export type DocumentTagsConnectionWhere = {
	AND?: InputMaybe<Array<DocumentTagsConnectionWhere>>;
	OR?: InputMaybe<Array<DocumentTagsConnectionWhere>>;
	node?: InputMaybe<AgreementTagWhere>;
	node_NOT?: InputMaybe<AgreementTagWhere>;
};

export type DocumentTagsCreateFieldInput = {
	node: AgreementTagCreateInput;
};

export type DocumentTagsDeleteFieldInput = {
	delete?: InputMaybe<AgreementTagDeleteInput>;
	where?: InputMaybe<DocumentTagsConnectionWhere>;
};

export type DocumentTagsDisconnectFieldInput = {
	disconnect?: InputMaybe<AgreementTagDisconnectInput>;
	where?: InputMaybe<DocumentTagsConnectionWhere>;
};

export type DocumentTagsFieldInput = {
	connect?: InputMaybe<Array<DocumentTagsConnectFieldInput>>;
	create?: InputMaybe<Array<DocumentTagsCreateFieldInput>>;
};

export type DocumentTagsNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<DocumentTagsNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<DocumentTagsNodeAggregationWhereInput>>;
	id_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	id_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	id_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	id_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	id_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	id_EQUAL?: InputMaybe<Scalars["Int"]>;
	id_GT?: InputMaybe<Scalars["Int"]>;
	id_GTE?: InputMaybe<Scalars["Int"]>;
	id_LT?: InputMaybe<Scalars["Int"]>;
	id_LTE?: InputMaybe<Scalars["Int"]>;
	id_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	id_MAX_GT?: InputMaybe<Scalars["Int"]>;
	id_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	id_MAX_LT?: InputMaybe<Scalars["Int"]>;
	id_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	id_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	id_MIN_GT?: InputMaybe<Scalars["Int"]>;
	id_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	id_MIN_LT?: InputMaybe<Scalars["Int"]>;
	id_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	name_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	name_EQUAL?: InputMaybe<Scalars["String"]>;
	name_GT?: InputMaybe<Scalars["Int"]>;
	name_GTE?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	name_LT?: InputMaybe<Scalars["Int"]>;
	name_LTE?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type DocumentTagsRelationship = {
	__typename?: "DocumentTagsRelationship";
	cursor: Scalars["String"];
	node: AgreementTag;
};

export type DocumentTagsUpdateConnectionInput = {
	node?: InputMaybe<AgreementTagUpdateInput>;
};

export type DocumentTagsUpdateFieldInput = {
	connect?: InputMaybe<Array<DocumentTagsConnectFieldInput>>;
	create?: InputMaybe<Array<DocumentTagsCreateFieldInput>>;
	delete?: InputMaybe<Array<DocumentTagsDeleteFieldInput>>;
	disconnect?: InputMaybe<Array<DocumentTagsDisconnectFieldInput>>;
	update?: InputMaybe<DocumentTagsUpdateConnectionInput>;
	where?: InputMaybe<DocumentTagsConnectionWhere>;
};

export enum DocumentType {
	Invoice = "INVOICE",
}

export type DocumentUpdateInput = {
	assignedTo?: InputMaybe<Array<DocumentAssignedToUpdateFieldInput>>;
	counterParties?: InputMaybe<Scalars["String"]>;
	coveragePeriod?: InputMaybe<Scalars["String"]>;
	coveragePeriodEnd?: InputMaybe<Scalars["Date"]>;
	coveragePeriodStart?: InputMaybe<Scalars["Date"]>;
	createdBy?: InputMaybe<Scalars["String"]>;
	createdOn?: InputMaybe<Scalars["DateTime"]>;
	creatorOrgName?: InputMaybe<Scalars["String"]>;
	creatorTenantId?: InputMaybe<Scalars["String"]>;
	formattedTags?: InputMaybe<Scalars["String"]>;
	id?: InputMaybe<Scalars["ID"]>;
	invoiceAmount?: InputMaybe<Scalars["Int"]>;
	isConfirmedBySeller?: InputMaybe<Scalars["Boolean"]>;
	isDeleted?: InputMaybe<Scalars["Boolean"]>;
	issuedOn?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn?: InputMaybe<Scalars["DateTime"]>;
	product?: InputMaybe<Scalars["String"]>;
	refunds?: InputMaybe<Array<DocumentRefundsUpdateFieldInput>>;
	settledOn?: InputMaybe<Scalars["Date"]>;
	status?: InputMaybe<DocumentStatus>;
	tags?: InputMaybe<Array<DocumentTagsUpdateFieldInput>>;
	tenantIds?: InputMaybe<Array<Scalars["String"]>>;
	type?: InputMaybe<DocumentType>;
	unlimited?: InputMaybe<Scalars["Int"]>;
};

export type DocumentWhere = {
	AND?: InputMaybe<Array<DocumentWhere>>;
	OR?: InputMaybe<Array<DocumentWhere>>;
	assignedTo?: InputMaybe<UserWhere>;
	assignedToAggregate?: InputMaybe<DocumentAssignedToAggregateInput>;
	assignedToConnection?: InputMaybe<DocumentAssignedToConnectionWhere>;
	assignedToConnection_NOT?: InputMaybe<DocumentAssignedToConnectionWhere>;
	assignedTo_NOT?: InputMaybe<UserWhere>;
	counterParties?: InputMaybe<Scalars["String"]>;
	counterParties_CONTAINS?: InputMaybe<Scalars["String"]>;
	counterParties_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	counterParties_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	counterParties_MATCHES?: InputMaybe<Scalars["String"]>;
	counterParties_NOT?: InputMaybe<Scalars["String"]>;
	counterParties_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	counterParties_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	counterParties_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	counterParties_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	counterParties_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	coveragePeriod?: InputMaybe<Scalars["String"]>;
	coveragePeriodEnd?: InputMaybe<Scalars["Date"]>;
	coveragePeriodEnd_GT?: InputMaybe<Scalars["Date"]>;
	coveragePeriodEnd_GTE?: InputMaybe<Scalars["Date"]>;
	coveragePeriodEnd_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
	coveragePeriodEnd_LT?: InputMaybe<Scalars["Date"]>;
	coveragePeriodEnd_LTE?: InputMaybe<Scalars["Date"]>;
	coveragePeriodEnd_NOT?: InputMaybe<Scalars["Date"]>;
	coveragePeriodEnd_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
	coveragePeriodStart?: InputMaybe<Scalars["Date"]>;
	coveragePeriodStart_GT?: InputMaybe<Scalars["Date"]>;
	coveragePeriodStart_GTE?: InputMaybe<Scalars["Date"]>;
	coveragePeriodStart_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
	coveragePeriodStart_LT?: InputMaybe<Scalars["Date"]>;
	coveragePeriodStart_LTE?: InputMaybe<Scalars["Date"]>;
	coveragePeriodStart_NOT?: InputMaybe<Scalars["Date"]>;
	coveragePeriodStart_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
	coveragePeriod_CONTAINS?: InputMaybe<Scalars["String"]>;
	coveragePeriod_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	coveragePeriod_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	coveragePeriod_MATCHES?: InputMaybe<Scalars["String"]>;
	coveragePeriod_NOT?: InputMaybe<Scalars["String"]>;
	coveragePeriod_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	coveragePeriod_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	coveragePeriod_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	coveragePeriod_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	coveragePeriod_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	createdBy?: InputMaybe<Scalars["String"]>;
	createdBy_CONTAINS?: InputMaybe<Scalars["String"]>;
	createdBy_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	createdBy_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	createdBy_MATCHES?: InputMaybe<Scalars["String"]>;
	createdBy_NOT?: InputMaybe<Scalars["String"]>;
	createdBy_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	createdBy_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	createdBy_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	createdBy_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	createdBy_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	createdOn?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_IN?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]>>>;
	createdOn_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_NOT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]>>>;
	creatorOrgName?: InputMaybe<Scalars["String"]>;
	creatorOrgName_CONTAINS?: InputMaybe<Scalars["String"]>;
	creatorOrgName_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	creatorOrgName_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	creatorOrgName_MATCHES?: InputMaybe<Scalars["String"]>;
	creatorOrgName_NOT?: InputMaybe<Scalars["String"]>;
	creatorOrgName_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	creatorOrgName_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	creatorOrgName_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	creatorOrgName_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	creatorOrgName_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	creatorTenantId?: InputMaybe<Scalars["String"]>;
	creatorTenantId_CONTAINS?: InputMaybe<Scalars["String"]>;
	creatorTenantId_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	creatorTenantId_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	creatorTenantId_MATCHES?: InputMaybe<Scalars["String"]>;
	creatorTenantId_NOT?: InputMaybe<Scalars["String"]>;
	creatorTenantId_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	creatorTenantId_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	creatorTenantId_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	creatorTenantId_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	creatorTenantId_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	formattedTags?: InputMaybe<Scalars["String"]>;
	formattedTags_CONTAINS?: InputMaybe<Scalars["String"]>;
	formattedTags_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	formattedTags_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	formattedTags_MATCHES?: InputMaybe<Scalars["String"]>;
	formattedTags_NOT?: InputMaybe<Scalars["String"]>;
	formattedTags_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	formattedTags_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	formattedTags_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	formattedTags_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	formattedTags_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	id?: InputMaybe<Scalars["ID"]>;
	id_CONTAINS?: InputMaybe<Scalars["ID"]>;
	id_ENDS_WITH?: InputMaybe<Scalars["ID"]>;
	id_IN?: InputMaybe<Array<InputMaybe<Scalars["ID"]>>>;
	id_MATCHES?: InputMaybe<Scalars["String"]>;
	id_NOT?: InputMaybe<Scalars["ID"]>;
	id_NOT_CONTAINS?: InputMaybe<Scalars["ID"]>;
	id_NOT_ENDS_WITH?: InputMaybe<Scalars["ID"]>;
	id_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["ID"]>>>;
	id_NOT_STARTS_WITH?: InputMaybe<Scalars["ID"]>;
	id_STARTS_WITH?: InputMaybe<Scalars["ID"]>;
	invoiceAmount?: InputMaybe<Scalars["Int"]>;
	invoiceAmount_GT?: InputMaybe<Scalars["Int"]>;
	invoiceAmount_GTE?: InputMaybe<Scalars["Int"]>;
	invoiceAmount_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	invoiceAmount_LT?: InputMaybe<Scalars["Int"]>;
	invoiceAmount_LTE?: InputMaybe<Scalars["Int"]>;
	invoiceAmount_NOT?: InputMaybe<Scalars["Int"]>;
	invoiceAmount_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	isConfirmedBySeller?: InputMaybe<Scalars["Boolean"]>;
	isConfirmedBySeller_NOT?: InputMaybe<Scalars["Boolean"]>;
	isDeleted?: InputMaybe<Scalars["Boolean"]>;
	isDeleted_NOT?: InputMaybe<Scalars["Boolean"]>;
	issuedOn?: InputMaybe<Scalars["DateTime"]>;
	issuedOn_GT?: InputMaybe<Scalars["DateTime"]>;
	issuedOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	issuedOn_IN?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]>>>;
	issuedOn_LT?: InputMaybe<Scalars["DateTime"]>;
	issuedOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	issuedOn_NOT?: InputMaybe<Scalars["DateTime"]>;
	issuedOn_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]>>>;
	lastUpdatedOn?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_GT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_IN?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]>>>;
	lastUpdatedOn_LT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_NOT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]>>>;
	product?: InputMaybe<Scalars["String"]>;
	product_CONTAINS?: InputMaybe<Scalars["String"]>;
	product_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	product_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	product_MATCHES?: InputMaybe<Scalars["String"]>;
	product_NOT?: InputMaybe<Scalars["String"]>;
	product_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	product_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	product_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	product_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	product_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	refunds?: InputMaybe<RefundWhere>;
	refundsAggregate?: InputMaybe<DocumentRefundsAggregateInput>;
	refundsConnection?: InputMaybe<DocumentRefundsConnectionWhere>;
	refundsConnection_NOT?: InputMaybe<DocumentRefundsConnectionWhere>;
	refunds_NOT?: InputMaybe<RefundWhere>;
	settledOn?: InputMaybe<Scalars["Date"]>;
	settledOn_GT?: InputMaybe<Scalars["Date"]>;
	settledOn_GTE?: InputMaybe<Scalars["Date"]>;
	settledOn_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
	settledOn_LT?: InputMaybe<Scalars["Date"]>;
	settledOn_LTE?: InputMaybe<Scalars["Date"]>;
	settledOn_NOT?: InputMaybe<Scalars["Date"]>;
	settledOn_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
	status?: InputMaybe<DocumentStatus>;
	status_IN?: InputMaybe<Array<InputMaybe<DocumentStatus>>>;
	status_NOT?: InputMaybe<DocumentStatus>;
	status_NOT_IN?: InputMaybe<Array<InputMaybe<DocumentStatus>>>;
	tags?: InputMaybe<AgreementTagWhere>;
	tagsAggregate?: InputMaybe<DocumentTagsAggregateInput>;
	tagsConnection?: InputMaybe<DocumentTagsConnectionWhere>;
	tagsConnection_NOT?: InputMaybe<DocumentTagsConnectionWhere>;
	tags_NOT?: InputMaybe<AgreementTagWhere>;
	tenantIds?: InputMaybe<Array<Scalars["String"]>>;
	tenantIds_INCLUDES?: InputMaybe<Scalars["String"]>;
	tenantIds_NOT?: InputMaybe<Array<Scalars["String"]>>;
	tenantIds_NOT_INCLUDES?: InputMaybe<Scalars["String"]>;
	type?: InputMaybe<DocumentType>;
	type_IN?: InputMaybe<Array<InputMaybe<DocumentType>>>;
	type_NOT?: InputMaybe<DocumentType>;
	type_NOT_IN?: InputMaybe<Array<InputMaybe<DocumentType>>>;
	unlimited?: InputMaybe<Scalars["Int"]>;
	unlimited_GT?: InputMaybe<Scalars["Int"]>;
	unlimited_GTE?: InputMaybe<Scalars["Int"]>;
	unlimited_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	unlimited_LT?: InputMaybe<Scalars["Int"]>;
	unlimited_LTE?: InputMaybe<Scalars["Int"]>;
	unlimited_NOT?: InputMaybe<Scalars["Int"]>;
	unlimited_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
};

export enum DurationUom {
	Days = "DAYS",
}

export type EligibilityConditionSet = {
	__typename?: "EligibilityConditionSet";
	code: Scalars["String"];
	inputLabel?: Maybe<Scalars["String"]>;
	name: Scalars["String"];
};

export type EligibilityConditionSetAggregateSelection = {
	__typename?: "EligibilityConditionSetAggregateSelection";
	code: StringAggregateSelection;
	count: Scalars["Int"];
	inputLabel: StringAggregateSelection;
	name: StringAggregateSelection;
};

export type EligibilityConditionSetConnectWhere = {
	node: EligibilityConditionSetWhere;
};

export type EligibilityConditionSetCreateInput = {
	code: Scalars["String"];
	inputLabel?: InputMaybe<Scalars["String"]>;
	name: Scalars["String"];
};

export type EligibilityConditionSetOptions = {
	limit?: InputMaybe<Scalars["Int"]>;
	offset?: InputMaybe<Scalars["Int"]>;
	/** Specify one or more EligibilityConditionSetSort objects to sort EligibilityConditionSets by. The sorts will be applied in the order in which they are arranged in the array. */
	sort?: InputMaybe<Array<InputMaybe<EligibilityConditionSetSort>>>;
};

/** Fields to sort EligibilityConditionSets by. The order in which sorts are applied is not guaranteed when specifying many fields in one EligibilityConditionSetSort object. */
export type EligibilityConditionSetSort = {
	code?: InputMaybe<SortDirection>;
	inputLabel?: InputMaybe<SortDirection>;
	name?: InputMaybe<SortDirection>;
};

export type EligibilityConditionSetUpdateInput = {
	code?: InputMaybe<Scalars["String"]>;
	inputLabel?: InputMaybe<Scalars["String"]>;
	name?: InputMaybe<Scalars["String"]>;
};

export type EligibilityConditionSetWhere = {
	AND?: InputMaybe<Array<EligibilityConditionSetWhere>>;
	OR?: InputMaybe<Array<EligibilityConditionSetWhere>>;
	code?: InputMaybe<Scalars["String"]>;
	code_CONTAINS?: InputMaybe<Scalars["String"]>;
	code_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	code_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	code_MATCHES?: InputMaybe<Scalars["String"]>;
	code_NOT?: InputMaybe<Scalars["String"]>;
	code_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	code_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	code_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	code_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	code_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	inputLabel?: InputMaybe<Scalars["String"]>;
	inputLabel_CONTAINS?: InputMaybe<Scalars["String"]>;
	inputLabel_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	inputLabel_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	inputLabel_MATCHES?: InputMaybe<Scalars["String"]>;
	inputLabel_NOT?: InputMaybe<Scalars["String"]>;
	inputLabel_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	inputLabel_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	inputLabel_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	inputLabel_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	inputLabel_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	name?: InputMaybe<Scalars["String"]>;
	name_CONTAINS?: InputMaybe<Scalars["String"]>;
	name_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	name_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	name_MATCHES?: InputMaybe<Scalars["String"]>;
	name_NOT?: InputMaybe<Scalars["String"]>;
	name_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	name_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	name_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	name_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	name_STARTS_WITH?: InputMaybe<Scalars["String"]>;
};

export type EnrollingConditionDiseaseRelationship = {
	Score?: Maybe<Scalars["Float"]>;
};

export type EnrollingConditionDiseaseRelationshipCreateInput = {
	Score?: InputMaybe<Scalars["Float"]>;
};

export type EnrollingConditionDiseaseRelationshipSort = {
	Score?: InputMaybe<SortDirection>;
};

export type EnrollingConditionDiseaseRelationshipUpdateInput = {
	Score?: InputMaybe<Scalars["Float"]>;
};

export type EnrollingConditionDiseaseRelationshipWhere = {
	AND?: InputMaybe<Array<EnrollingConditionDiseaseRelationshipWhere>>;
	OR?: InputMaybe<Array<EnrollingConditionDiseaseRelationshipWhere>>;
	Score?: InputMaybe<Scalars["Float"]>;
	Score_GT?: InputMaybe<Scalars["Float"]>;
	Score_GTE?: InputMaybe<Scalars["Float"]>;
	Score_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	Score_LT?: InputMaybe<Scalars["Float"]>;
	Score_LTE?: InputMaybe<Scalars["Float"]>;
	Score_NOT?: InputMaybe<Scalars["Float"]>;
	Score_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
};

export type EnrollingConditionSet = {
	__typename?: "EnrollingConditionSet";
	agreement: BaseAgreement;
	agreementConnection: EnrollingConditionSetAgreementConnection;
	code: Scalars["String"];
	diseases: Array<Disease>;
	diseasesConnection: EnrollingConditionSetDiseasesConnection;
	indications: Array<Indication>;
	indicationsConnection: EnrollingConditionSetIndicationsConnection;
	isDeleted: Scalars["Boolean"];
	isExtended?: Maybe<Scalars["Boolean"]>;
	preparationConditionLogicalOperator: ConditionLogicalOperator;
	preparations: Array<Preparation>;
	preparationsConnection: EnrollingConditionSetPreparationsConnection;
	tenantIds?: Maybe<Array<Scalars["String"]>>;
	treatments: Array<Treatment>;
	treatmentsConnection: EnrollingConditionSetTreatmentsConnection;
};

export type EnrollingConditionSetAgreementArgs = {
	options?: InputMaybe<BaseAgreementOptions>;
	where?: InputMaybe<BaseAgreementWhere>;
};

export type EnrollingConditionSetAgreementConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<EnrollingConditionSetAgreementConnectionSort>>;
	where?: InputMaybe<EnrollingConditionSetAgreementConnectionWhere>;
};

export type EnrollingConditionSetDiseasesArgs = {
	options?: InputMaybe<DiseaseOptions>;
	where?: InputMaybe<DiseaseWhere>;
};

export type EnrollingConditionSetDiseasesConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<EnrollingConditionSetDiseasesConnectionSort>>;
	where?: InputMaybe<EnrollingConditionSetDiseasesConnectionWhere>;
};

export type EnrollingConditionSetIndicationsArgs = {
	options?: InputMaybe<IndicationOptions>;
	where?: InputMaybe<IndicationWhere>;
};

export type EnrollingConditionSetIndicationsConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<EnrollingConditionSetIndicationsConnectionSort>>;
	where?: InputMaybe<EnrollingConditionSetIndicationsConnectionWhere>;
};

export type EnrollingConditionSetPreparationsArgs = {
	options?: InputMaybe<PreparationOptions>;
	where?: InputMaybe<PreparationWhere>;
};

export type EnrollingConditionSetPreparationsConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<EnrollingConditionSetPreparationsConnectionSort>>;
	where?: InputMaybe<EnrollingConditionSetPreparationsConnectionWhere>;
};

export type EnrollingConditionSetTreatmentsArgs = {
	options?: InputMaybe<TreatmentOptions>;
	where?: InputMaybe<TreatmentWhere>;
};

export type EnrollingConditionSetTreatmentsConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<EnrollingConditionSetTreatmentsConnectionSort>>;
	where?: InputMaybe<EnrollingConditionSetTreatmentsConnectionWhere>;
};

export type EnrollingConditionSetAggregateSelection = {
	__typename?: "EnrollingConditionSetAggregateSelection";
	code: StringAggregateSelection;
	count: Scalars["Int"];
};

export type EnrollingConditionSetAgreementAggregateInput = {
	AND?: InputMaybe<Array<EnrollingConditionSetAgreementAggregateInput>>;
	OR?: InputMaybe<Array<EnrollingConditionSetAgreementAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<EnrollingConditionSetAgreementNodeAggregationWhereInput>;
};

export type EnrollingConditionSetAgreementConnectFieldInput = {
	connect?: InputMaybe<BaseAgreementConnectInput>;
	where?: InputMaybe<BaseAgreementConnectWhere>;
};

export type EnrollingConditionSetAgreementConnection = {
	__typename?: "EnrollingConditionSetAgreementConnection";
	edges: Array<EnrollingConditionSetAgreementRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type EnrollingConditionSetAgreementConnectionSort = {
	node?: InputMaybe<BaseAgreementSort>;
};

export type EnrollingConditionSetAgreementConnectionWhere = {
	AND?: InputMaybe<Array<EnrollingConditionSetAgreementConnectionWhere>>;
	OR?: InputMaybe<Array<EnrollingConditionSetAgreementConnectionWhere>>;
	node?: InputMaybe<BaseAgreementWhere>;
	node_NOT?: InputMaybe<BaseAgreementWhere>;
};

export type EnrollingConditionSetAgreementCreateFieldInput = {
	node: BaseAgreementCreateInput;
};

export type EnrollingConditionSetAgreementDeleteFieldInput = {
	delete?: InputMaybe<BaseAgreementDeleteInput>;
	where?: InputMaybe<EnrollingConditionSetAgreementConnectionWhere>;
};

export type EnrollingConditionSetAgreementDisconnectFieldInput = {
	disconnect?: InputMaybe<BaseAgreementDisconnectInput>;
	where?: InputMaybe<EnrollingConditionSetAgreementConnectionWhere>;
};

export type EnrollingConditionSetAgreementFieldInput = {
	connect?: InputMaybe<EnrollingConditionSetAgreementConnectFieldInput>;
	create?: InputMaybe<EnrollingConditionSetAgreementCreateFieldInput>;
};

export type EnrollingConditionSetAgreementNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<EnrollingConditionSetAgreementNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<EnrollingConditionSetAgreementNodeAggregationWhereInput>>;
	coveringFormWaitInterval_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	coveringFormWaitInterval_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	coveringFormWaitInterval_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	coveringFormWaitInterval_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	coveringFormWaitInterval_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	coveringFormWaitInterval_EQUAL?: InputMaybe<Scalars["Int"]>;
	coveringFormWaitInterval_GT?: InputMaybe<Scalars["Int"]>;
	coveringFormWaitInterval_GTE?: InputMaybe<Scalars["Int"]>;
	coveringFormWaitInterval_LT?: InputMaybe<Scalars["Int"]>;
	coveringFormWaitInterval_LTE?: InputMaybe<Scalars["Int"]>;
	coveringFormWaitInterval_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	coveringFormWaitInterval_MAX_GT?: InputMaybe<Scalars["Int"]>;
	coveringFormWaitInterval_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	coveringFormWaitInterval_MAX_LT?: InputMaybe<Scalars["Int"]>;
	coveringFormWaitInterval_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	coveringFormWaitInterval_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	coveringFormWaitInterval_MIN_GT?: InputMaybe<Scalars["Int"]>;
	coveringFormWaitInterval_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	coveringFormWaitInterval_MIN_LT?: InputMaybe<Scalars["Int"]>;
	coveringFormWaitInterval_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	createdOn_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_GT?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_GTE?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_LT?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_LTE?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	formattedAmount_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	formattedAmount_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	formattedAmount_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	formattedAmount_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	formattedAmount_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	formattedAmount_EQUAL?: InputMaybe<Scalars["String"]>;
	formattedAmount_GT?: InputMaybe<Scalars["Int"]>;
	formattedAmount_GTE?: InputMaybe<Scalars["Int"]>;
	formattedAmount_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedAmount_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedAmount_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedAmount_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedAmount_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	formattedAmount_LT?: InputMaybe<Scalars["Int"]>;
	formattedAmount_LTE?: InputMaybe<Scalars["Int"]>;
	formattedAmount_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedAmount_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedAmount_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedAmount_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedAmount_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	formattedCounterparties_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	formattedCounterparties_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	formattedCounterparties_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	formattedCounterparties_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	formattedCounterparties_EQUAL?: InputMaybe<Scalars["String"]>;
	formattedCounterparties_GT?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_GTE?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_LT?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_LTE?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	formattedProducts_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	formattedProducts_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	formattedProducts_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	formattedProducts_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	formattedProducts_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	formattedProducts_EQUAL?: InputMaybe<Scalars["String"]>;
	formattedProducts_GT?: InputMaybe<Scalars["Int"]>;
	formattedProducts_GTE?: InputMaybe<Scalars["Int"]>;
	formattedProducts_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedProducts_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedProducts_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedProducts_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedProducts_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	formattedProducts_LT?: InputMaybe<Scalars["Int"]>;
	formattedProducts_LTE?: InputMaybe<Scalars["Int"]>;
	formattedProducts_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedProducts_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedProducts_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedProducts_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedProducts_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	formattedTags_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	formattedTags_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	formattedTags_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	formattedTags_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	formattedTags_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	formattedTags_EQUAL?: InputMaybe<Scalars["String"]>;
	formattedTags_GT?: InputMaybe<Scalars["Int"]>;
	formattedTags_GTE?: InputMaybe<Scalars["Int"]>;
	formattedTags_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedTags_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedTags_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedTags_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedTags_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	formattedTags_LT?: InputMaybe<Scalars["Int"]>;
	formattedTags_LTE?: InputMaybe<Scalars["Int"]>;
	formattedTags_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedTags_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedTags_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedTags_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedTags_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	formattedValidityPeriod_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	formattedValidityPeriod_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	formattedValidityPeriod_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	formattedValidityPeriod_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	formattedValidityPeriod_EQUAL?: InputMaybe<Scalars["String"]>;
	formattedValidityPeriod_GT?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_GTE?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_LT?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_LTE?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	initialVersionId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	initialVersionId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	initialVersionId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	initialVersionId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	initialVersionId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	initialVersionId_EQUAL?: InputMaybe<Scalars["String"]>;
	initialVersionId_GT?: InputMaybe<Scalars["Int"]>;
	initialVersionId_GTE?: InputMaybe<Scalars["Int"]>;
	initialVersionId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	initialVersionId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	initialVersionId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	initialVersionId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	initialVersionId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	initialVersionId_LT?: InputMaybe<Scalars["Int"]>;
	initialVersionId_LTE?: InputMaybe<Scalars["Int"]>;
	initialVersionId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	initialVersionId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	initialVersionId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	initialVersionId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	initialVersionId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	lastExecutionDate_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_GT?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_LT?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_LTE?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	name_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	name_EQUAL?: InputMaybe<Scalars["String"]>;
	name_GT?: InputMaybe<Scalars["Int"]>;
	name_GTE?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	name_LT?: InputMaybe<Scalars["Int"]>;
	name_LTE?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	pushedOn_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	pushedOn_GT?: InputMaybe<Scalars["DateTime"]>;
	pushedOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	pushedOn_LT?: InputMaybe<Scalars["DateTime"]>;
	pushedOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	pushedOn_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	pushedOn_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	pushedOn_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	pushedOn_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	pushedOn_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	pushedOn_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	pushedOn_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	pushedOn_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	pushedOn_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	pushedOn_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	version_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	version_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	version_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	version_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	version_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	version_EQUAL?: InputMaybe<Scalars["Int"]>;
	version_GT?: InputMaybe<Scalars["Int"]>;
	version_GTE?: InputMaybe<Scalars["Int"]>;
	version_LT?: InputMaybe<Scalars["Int"]>;
	version_LTE?: InputMaybe<Scalars["Int"]>;
	version_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	version_MAX_GT?: InputMaybe<Scalars["Int"]>;
	version_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	version_MAX_LT?: InputMaybe<Scalars["Int"]>;
	version_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	version_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	version_MIN_GT?: InputMaybe<Scalars["Int"]>;
	version_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	version_MIN_LT?: InputMaybe<Scalars["Int"]>;
	version_MIN_LTE?: InputMaybe<Scalars["Int"]>;
};

export type EnrollingConditionSetAgreementRelationship = {
	__typename?: "EnrollingConditionSetAgreementRelationship";
	cursor: Scalars["String"];
	node: BaseAgreement;
};

export type EnrollingConditionSetAgreementUpdateConnectionInput = {
	node?: InputMaybe<BaseAgreementUpdateInput>;
};

export type EnrollingConditionSetAgreementUpdateFieldInput = {
	connect?: InputMaybe<EnrollingConditionSetAgreementConnectFieldInput>;
	create?: InputMaybe<EnrollingConditionSetAgreementCreateFieldInput>;
	delete?: InputMaybe<EnrollingConditionSetAgreementDeleteFieldInput>;
	disconnect?: InputMaybe<EnrollingConditionSetAgreementDisconnectFieldInput>;
	update?: InputMaybe<EnrollingConditionSetAgreementUpdateConnectionInput>;
	where?: InputMaybe<EnrollingConditionSetAgreementConnectionWhere>;
};

export type EnrollingConditionSetConnectInput = {
	agreement?: InputMaybe<EnrollingConditionSetAgreementConnectFieldInput>;
	diseases?: InputMaybe<Array<EnrollingConditionSetDiseasesConnectFieldInput>>;
	indications?: InputMaybe<Array<EnrollingConditionSetIndicationsConnectFieldInput>>;
	preparations?: InputMaybe<Array<EnrollingConditionSetPreparationsConnectFieldInput>>;
	treatments?: InputMaybe<Array<EnrollingConditionSetTreatmentsConnectFieldInput>>;
};

export type EnrollingConditionSetConnectWhere = {
	node: EnrollingConditionSetWhere;
};

export type EnrollingConditionSetCreateInput = {
	agreement?: InputMaybe<EnrollingConditionSetAgreementFieldInput>;
	code: Scalars["String"];
	diseases?: InputMaybe<EnrollingConditionSetDiseasesFieldInput>;
	indications?: InputMaybe<EnrollingConditionSetIndicationsFieldInput>;
	isDeleted: Scalars["Boolean"];
	isExtended?: InputMaybe<Scalars["Boolean"]>;
	preparationConditionLogicalOperator: ConditionLogicalOperator;
	preparations?: InputMaybe<EnrollingConditionSetPreparationsFieldInput>;
	tenantIds?: InputMaybe<Array<Scalars["String"]>>;
	treatments?: InputMaybe<EnrollingConditionSetTreatmentsFieldInput>;
};

export type EnrollingConditionSetDeleteInput = {
	agreement?: InputMaybe<EnrollingConditionSetAgreementDeleteFieldInput>;
	diseases?: InputMaybe<Array<EnrollingConditionSetDiseasesDeleteFieldInput>>;
	indications?: InputMaybe<Array<EnrollingConditionSetIndicationsDeleteFieldInput>>;
	preparations?: InputMaybe<Array<EnrollingConditionSetPreparationsDeleteFieldInput>>;
	treatments?: InputMaybe<Array<EnrollingConditionSetTreatmentsDeleteFieldInput>>;
};

export type EnrollingConditionSetDisconnectInput = {
	agreement?: InputMaybe<EnrollingConditionSetAgreementDisconnectFieldInput>;
	diseases?: InputMaybe<Array<EnrollingConditionSetDiseasesDisconnectFieldInput>>;
	indications?: InputMaybe<Array<EnrollingConditionSetIndicationsDisconnectFieldInput>>;
	preparations?: InputMaybe<Array<EnrollingConditionSetPreparationsDisconnectFieldInput>>;
	treatments?: InputMaybe<Array<EnrollingConditionSetTreatmentsDisconnectFieldInput>>;
};

export type EnrollingConditionSetDiseasesAggregateInput = {
	AND?: InputMaybe<Array<EnrollingConditionSetDiseasesAggregateInput>>;
	OR?: InputMaybe<Array<EnrollingConditionSetDiseasesAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	edge?: InputMaybe<EnrollingConditionSetDiseasesEdgeAggregationWhereInput>;
	node?: InputMaybe<EnrollingConditionSetDiseasesNodeAggregationWhereInput>;
};

export type EnrollingConditionSetDiseasesConnectFieldInput = {
	edge?: InputMaybe<EnrollingConditionDiseaseRelationshipCreateInput>;
	where?: InputMaybe<DiseaseConnectWhere>;
};

export type EnrollingConditionSetDiseasesConnection = {
	__typename?: "EnrollingConditionSetDiseasesConnection";
	edges: Array<EnrollingConditionSetDiseasesRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type EnrollingConditionSetDiseasesConnectionSort = {
	edge?: InputMaybe<EnrollingConditionDiseaseRelationshipSort>;
	node?: InputMaybe<DiseaseSort>;
};

export type EnrollingConditionSetDiseasesConnectionWhere = {
	AND?: InputMaybe<Array<EnrollingConditionSetDiseasesConnectionWhere>>;
	OR?: InputMaybe<Array<EnrollingConditionSetDiseasesConnectionWhere>>;
	edge?: InputMaybe<EnrollingConditionDiseaseRelationshipWhere>;
	edge_NOT?: InputMaybe<EnrollingConditionDiseaseRelationshipWhere>;
	node?: InputMaybe<DiseaseWhere>;
	node_NOT?: InputMaybe<DiseaseWhere>;
};

export type EnrollingConditionSetDiseasesCreateFieldInput = {
	edge?: InputMaybe<EnrollingConditionDiseaseRelationshipCreateInput>;
	node: DiseaseCreateInput;
};

export type EnrollingConditionSetDiseasesDeleteFieldInput = {
	where?: InputMaybe<EnrollingConditionSetDiseasesConnectionWhere>;
};

export type EnrollingConditionSetDiseasesDisconnectFieldInput = {
	where?: InputMaybe<EnrollingConditionSetDiseasesConnectionWhere>;
};

export type EnrollingConditionSetDiseasesEdgeAggregationWhereInput = {
	AND?: InputMaybe<Array<EnrollingConditionSetDiseasesEdgeAggregationWhereInput>>;
	OR?: InputMaybe<Array<EnrollingConditionSetDiseasesEdgeAggregationWhereInput>>;
	Score_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	Score_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	Score_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	Score_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	Score_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	Score_EQUAL?: InputMaybe<Scalars["Float"]>;
	Score_GT?: InputMaybe<Scalars["Float"]>;
	Score_GTE?: InputMaybe<Scalars["Float"]>;
	Score_LT?: InputMaybe<Scalars["Float"]>;
	Score_LTE?: InputMaybe<Scalars["Float"]>;
	Score_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	Score_MAX_GT?: InputMaybe<Scalars["Float"]>;
	Score_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	Score_MAX_LT?: InputMaybe<Scalars["Float"]>;
	Score_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	Score_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	Score_MIN_GT?: InputMaybe<Scalars["Float"]>;
	Score_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	Score_MIN_LT?: InputMaybe<Scalars["Float"]>;
	Score_MIN_LTE?: InputMaybe<Scalars["Float"]>;
};

export type EnrollingConditionSetDiseasesFieldInput = {
	connect?: InputMaybe<Array<EnrollingConditionSetDiseasesConnectFieldInput>>;
	create?: InputMaybe<Array<EnrollingConditionSetDiseasesCreateFieldInput>>;
};

export type EnrollingConditionSetDiseasesNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<EnrollingConditionSetDiseasesNodeAggregationWhereInput>>;
	Icd10Code_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	Icd10Code_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	Icd10Code_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	Icd10Code_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	Icd10Code_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	Icd10Code_EQUAL?: InputMaybe<Scalars["String"]>;
	Icd10Code_GT?: InputMaybe<Scalars["Int"]>;
	Icd10Code_GTE?: InputMaybe<Scalars["Int"]>;
	Icd10Code_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Icd10Code_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	Icd10Code_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	Icd10Code_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	Icd10Code_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	Icd10Code_LT?: InputMaybe<Scalars["Int"]>;
	Icd10Code_LTE?: InputMaybe<Scalars["Int"]>;
	Icd10Code_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Icd10Code_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	Icd10Code_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	Icd10Code_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	Icd10Code_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	Name_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	Name_EQUAL?: InputMaybe<Scalars["String"]>;
	Name_GT?: InputMaybe<Scalars["Int"]>;
	Name_GTE?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	Name_LT?: InputMaybe<Scalars["Int"]>;
	Name_LTE?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	OR?: InputMaybe<Array<EnrollingConditionSetDiseasesNodeAggregationWhereInput>>;
};

export type EnrollingConditionSetDiseasesRelationship = EnrollingConditionDiseaseRelationship & {
	__typename?: "EnrollingConditionSetDiseasesRelationship";
	Score?: Maybe<Scalars["Float"]>;
	cursor: Scalars["String"];
	node: Disease;
};

export type EnrollingConditionSetDiseasesUpdateConnectionInput = {
	edge?: InputMaybe<EnrollingConditionDiseaseRelationshipUpdateInput>;
	node?: InputMaybe<DiseaseUpdateInput>;
};

export type EnrollingConditionSetDiseasesUpdateFieldInput = {
	connect?: InputMaybe<Array<EnrollingConditionSetDiseasesConnectFieldInput>>;
	create?: InputMaybe<Array<EnrollingConditionSetDiseasesCreateFieldInput>>;
	delete?: InputMaybe<Array<EnrollingConditionSetDiseasesDeleteFieldInput>>;
	disconnect?: InputMaybe<Array<EnrollingConditionSetDiseasesDisconnectFieldInput>>;
	update?: InputMaybe<EnrollingConditionSetDiseasesUpdateConnectionInput>;
	where?: InputMaybe<EnrollingConditionSetDiseasesConnectionWhere>;
};

export type EnrollingConditionSetIndicationsAggregateInput = {
	AND?: InputMaybe<Array<EnrollingConditionSetIndicationsAggregateInput>>;
	OR?: InputMaybe<Array<EnrollingConditionSetIndicationsAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<EnrollingConditionSetIndicationsNodeAggregationWhereInput>;
};

export type EnrollingConditionSetIndicationsConnectFieldInput = {
	where?: InputMaybe<IndicationConnectWhere>;
};

export type EnrollingConditionSetIndicationsConnection = {
	__typename?: "EnrollingConditionSetIndicationsConnection";
	edges: Array<EnrollingConditionSetIndicationsRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type EnrollingConditionSetIndicationsConnectionSort = {
	node?: InputMaybe<IndicationSort>;
};

export type EnrollingConditionSetIndicationsConnectionWhere = {
	AND?: InputMaybe<Array<EnrollingConditionSetIndicationsConnectionWhere>>;
	OR?: InputMaybe<Array<EnrollingConditionSetIndicationsConnectionWhere>>;
	node?: InputMaybe<IndicationWhere>;
	node_NOT?: InputMaybe<IndicationWhere>;
};

export type EnrollingConditionSetIndicationsCreateFieldInput = {
	node: IndicationCreateInput;
};

export type EnrollingConditionSetIndicationsDeleteFieldInput = {
	where?: InputMaybe<EnrollingConditionSetIndicationsConnectionWhere>;
};

export type EnrollingConditionSetIndicationsDisconnectFieldInput = {
	where?: InputMaybe<EnrollingConditionSetIndicationsConnectionWhere>;
};

export type EnrollingConditionSetIndicationsFieldInput = {
	connect?: InputMaybe<Array<EnrollingConditionSetIndicationsConnectFieldInput>>;
	create?: InputMaybe<Array<EnrollingConditionSetIndicationsCreateFieldInput>>;
};

export type EnrollingConditionSetIndicationsNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<EnrollingConditionSetIndicationsNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<EnrollingConditionSetIndicationsNodeAggregationWhereInput>>;
	bagCode_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	bagCode_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	bagCode_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	bagCode_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	bagCode_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	bagCode_EQUAL?: InputMaybe<Scalars["String"]>;
	bagCode_GT?: InputMaybe<Scalars["Int"]>;
	bagCode_GTE?: InputMaybe<Scalars["Int"]>;
	bagCode_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	bagCode_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	bagCode_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	bagCode_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	bagCode_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	bagCode_LT?: InputMaybe<Scalars["Int"]>;
	bagCode_LTE?: InputMaybe<Scalars["Int"]>;
	bagCode_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	bagCode_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	bagCode_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	bagCode_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	bagCode_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	code_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	code_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	code_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	code_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	code_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	code_EQUAL?: InputMaybe<Scalars["String"]>;
	code_GT?: InputMaybe<Scalars["Int"]>;
	code_GTE?: InputMaybe<Scalars["Int"]>;
	code_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	code_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	code_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	code_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	code_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	code_LT?: InputMaybe<Scalars["Int"]>;
	code_LTE?: InputMaybe<Scalars["Int"]>;
	code_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	code_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	code_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	code_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	code_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	intent_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	intent_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	intent_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	intent_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	intent_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	intent_EQUAL?: InputMaybe<Scalars["String"]>;
	intent_GT?: InputMaybe<Scalars["Int"]>;
	intent_GTE?: InputMaybe<Scalars["Int"]>;
	intent_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	intent_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	intent_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	intent_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	intent_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	intent_LT?: InputMaybe<Scalars["Int"]>;
	intent_LTE?: InputMaybe<Scalars["Int"]>;
	intent_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	intent_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	intent_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	intent_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	intent_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	line_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	line_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	line_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	line_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	line_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	line_EQUAL?: InputMaybe<Scalars["String"]>;
	line_GT?: InputMaybe<Scalars["Int"]>;
	line_GTE?: InputMaybe<Scalars["Int"]>;
	line_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	line_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	line_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	line_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	line_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	line_LT?: InputMaybe<Scalars["Int"]>;
	line_LTE?: InputMaybe<Scalars["Int"]>;
	line_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	line_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	line_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	line_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	line_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	mutation_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	mutation_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	mutation_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	mutation_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	mutation_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	mutation_EQUAL?: InputMaybe<Scalars["String"]>;
	mutation_GT?: InputMaybe<Scalars["Int"]>;
	mutation_GTE?: InputMaybe<Scalars["Int"]>;
	mutation_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	mutation_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	mutation_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	mutation_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	mutation_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	mutation_LT?: InputMaybe<Scalars["Int"]>;
	mutation_LTE?: InputMaybe<Scalars["Int"]>;
	mutation_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	mutation_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	mutation_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	mutation_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	mutation_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	type_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	type_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	type_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	type_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	type_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	type_EQUAL?: InputMaybe<Scalars["String"]>;
	type_GT?: InputMaybe<Scalars["Int"]>;
	type_GTE?: InputMaybe<Scalars["Int"]>;
	type_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	type_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	type_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	type_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	type_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	type_LT?: InputMaybe<Scalars["Int"]>;
	type_LTE?: InputMaybe<Scalars["Int"]>;
	type_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	type_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	type_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	type_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	type_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type EnrollingConditionSetIndicationsRelationship = {
	__typename?: "EnrollingConditionSetIndicationsRelationship";
	cursor: Scalars["String"];
	node: Indication;
};

export type EnrollingConditionSetIndicationsUpdateConnectionInput = {
	node?: InputMaybe<IndicationUpdateInput>;
};

export type EnrollingConditionSetIndicationsUpdateFieldInput = {
	connect?: InputMaybe<Array<EnrollingConditionSetIndicationsConnectFieldInput>>;
	create?: InputMaybe<Array<EnrollingConditionSetIndicationsCreateFieldInput>>;
	delete?: InputMaybe<Array<EnrollingConditionSetIndicationsDeleteFieldInput>>;
	disconnect?: InputMaybe<Array<EnrollingConditionSetIndicationsDisconnectFieldInput>>;
	update?: InputMaybe<EnrollingConditionSetIndicationsUpdateConnectionInput>;
	where?: InputMaybe<EnrollingConditionSetIndicationsConnectionWhere>;
};

export type EnrollingConditionSetOptions = {
	limit?: InputMaybe<Scalars["Int"]>;
	offset?: InputMaybe<Scalars["Int"]>;
	/** Specify one or more EnrollingConditionSetSort objects to sort EnrollingConditionSets by. The sorts will be applied in the order in which they are arranged in the array. */
	sort?: InputMaybe<Array<InputMaybe<EnrollingConditionSetSort>>>;
};

export type EnrollingConditionSetPreparationsAggregateInput = {
	AND?: InputMaybe<Array<EnrollingConditionSetPreparationsAggregateInput>>;
	OR?: InputMaybe<Array<EnrollingConditionSetPreparationsAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<EnrollingConditionSetPreparationsNodeAggregationWhereInput>;
};

export type EnrollingConditionSetPreparationsConnectFieldInput = {
	connect?: InputMaybe<Array<PreparationConnectInput>>;
	where?: InputMaybe<PreparationConnectWhere>;
};

export type EnrollingConditionSetPreparationsConnection = {
	__typename?: "EnrollingConditionSetPreparationsConnection";
	edges: Array<EnrollingConditionSetPreparationsRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type EnrollingConditionSetPreparationsConnectionSort = {
	node?: InputMaybe<PreparationSort>;
};

export type EnrollingConditionSetPreparationsConnectionWhere = {
	AND?: InputMaybe<Array<EnrollingConditionSetPreparationsConnectionWhere>>;
	OR?: InputMaybe<Array<EnrollingConditionSetPreparationsConnectionWhere>>;
	node?: InputMaybe<PreparationWhere>;
	node_NOT?: InputMaybe<PreparationWhere>;
};

export type EnrollingConditionSetPreparationsCreateFieldInput = {
	node: PreparationCreateInput;
};

export type EnrollingConditionSetPreparationsDeleteFieldInput = {
	delete?: InputMaybe<PreparationDeleteInput>;
	where?: InputMaybe<EnrollingConditionSetPreparationsConnectionWhere>;
};

export type EnrollingConditionSetPreparationsDisconnectFieldInput = {
	disconnect?: InputMaybe<PreparationDisconnectInput>;
	where?: InputMaybe<EnrollingConditionSetPreparationsConnectionWhere>;
};

export type EnrollingConditionSetPreparationsFieldInput = {
	connect?: InputMaybe<Array<EnrollingConditionSetPreparationsConnectFieldInput>>;
	create?: InputMaybe<Array<EnrollingConditionSetPreparationsCreateFieldInput>>;
};

export type EnrollingConditionSetPreparationsNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<EnrollingConditionSetPreparationsNodeAggregationWhereInput>>;
	AtcCode_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	AtcCode_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	AtcCode_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	AtcCode_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	AtcCode_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	AtcCode_EQUAL?: InputMaybe<Scalars["String"]>;
	AtcCode_GT?: InputMaybe<Scalars["Int"]>;
	AtcCode_GTE?: InputMaybe<Scalars["Int"]>;
	AtcCode_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	AtcCode_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	AtcCode_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	AtcCode_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	AtcCode_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	AtcCode_LT?: InputMaybe<Scalars["Int"]>;
	AtcCode_LTE?: InputMaybe<Scalars["Int"]>;
	AtcCode_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	AtcCode_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	AtcCode_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	AtcCode_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	AtcCode_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	BrandName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	BrandName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	BrandName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	BrandName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	BrandName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	BrandName_EQUAL?: InputMaybe<Scalars["String"]>;
	BrandName_GT?: InputMaybe<Scalars["Int"]>;
	BrandName_GTE?: InputMaybe<Scalars["Int"]>;
	BrandName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	BrandName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	BrandName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	BrandName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	BrandName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	BrandName_LT?: InputMaybe<Scalars["Int"]>;
	BrandName_LTE?: InputMaybe<Scalars["Int"]>;
	BrandName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	BrandName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	BrandName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	BrandName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	BrandName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	DescriptionDe_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	DescriptionDe_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	DescriptionDe_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	DescriptionDe_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	DescriptionDe_EQUAL?: InputMaybe<Scalars["String"]>;
	DescriptionDe_GT?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_GTE?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_LT?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_LTE?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	GenericName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	GenericName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	GenericName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	GenericName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	GenericName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	GenericName_EQUAL?: InputMaybe<Scalars["String"]>;
	GenericName_GT?: InputMaybe<Scalars["Int"]>;
	GenericName_GTE?: InputMaybe<Scalars["Int"]>;
	GenericName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	GenericName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	GenericName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	GenericName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	GenericName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	GenericName_LT?: InputMaybe<Scalars["Int"]>;
	GenericName_LTE?: InputMaybe<Scalars["Int"]>;
	GenericName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	GenericName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	GenericName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	GenericName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	GenericName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	OR?: InputMaybe<Array<EnrollingConditionSetPreparationsNodeAggregationWhereInput>>;
	SwissmedicNo5_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo5_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo5_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo5_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo5_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo5_EQUAL?: InputMaybe<Scalars["String"]>;
	SwissmedicNo5_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo5_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo5_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo5_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo5_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo5_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo5_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo5_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo5_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo5_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo5_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo5_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo5_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo5_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
};

export type EnrollingConditionSetPreparationsRelationship = {
	__typename?: "EnrollingConditionSetPreparationsRelationship";
	cursor: Scalars["String"];
	node: Preparation;
};

export type EnrollingConditionSetPreparationsUpdateConnectionInput = {
	node?: InputMaybe<PreparationUpdateInput>;
};

export type EnrollingConditionSetPreparationsUpdateFieldInput = {
	connect?: InputMaybe<Array<EnrollingConditionSetPreparationsConnectFieldInput>>;
	create?: InputMaybe<Array<EnrollingConditionSetPreparationsCreateFieldInput>>;
	delete?: InputMaybe<Array<EnrollingConditionSetPreparationsDeleteFieldInput>>;
	disconnect?: InputMaybe<Array<EnrollingConditionSetPreparationsDisconnectFieldInput>>;
	update?: InputMaybe<EnrollingConditionSetPreparationsUpdateConnectionInput>;
	where?: InputMaybe<EnrollingConditionSetPreparationsConnectionWhere>;
};

/** Fields to sort EnrollingConditionSets by. The order in which sorts are applied is not guaranteed when specifying many fields in one EnrollingConditionSetSort object. */
export type EnrollingConditionSetSort = {
	code?: InputMaybe<SortDirection>;
	isDeleted?: InputMaybe<SortDirection>;
	isExtended?: InputMaybe<SortDirection>;
	preparationConditionLogicalOperator?: InputMaybe<SortDirection>;
};

export type EnrollingConditionSetTreatmentsAggregateInput = {
	AND?: InputMaybe<Array<EnrollingConditionSetTreatmentsAggregateInput>>;
	OR?: InputMaybe<Array<EnrollingConditionSetTreatmentsAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<EnrollingConditionSetTreatmentsNodeAggregationWhereInput>;
};

export type EnrollingConditionSetTreatmentsConnectFieldInput = {
	connect?: InputMaybe<Array<TreatmentConnectInput>>;
	where?: InputMaybe<TreatmentConnectWhere>;
};

export type EnrollingConditionSetTreatmentsConnection = {
	__typename?: "EnrollingConditionSetTreatmentsConnection";
	edges: Array<EnrollingConditionSetTreatmentsRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type EnrollingConditionSetTreatmentsConnectionSort = {
	node?: InputMaybe<TreatmentSort>;
};

export type EnrollingConditionSetTreatmentsConnectionWhere = {
	AND?: InputMaybe<Array<EnrollingConditionSetTreatmentsConnectionWhere>>;
	OR?: InputMaybe<Array<EnrollingConditionSetTreatmentsConnectionWhere>>;
	node?: InputMaybe<TreatmentWhere>;
	node_NOT?: InputMaybe<TreatmentWhere>;
};

export type EnrollingConditionSetTreatmentsCreateFieldInput = {
	node: TreatmentCreateInput;
};

export type EnrollingConditionSetTreatmentsDeleteFieldInput = {
	delete?: InputMaybe<TreatmentDeleteInput>;
	where?: InputMaybe<EnrollingConditionSetTreatmentsConnectionWhere>;
};

export type EnrollingConditionSetTreatmentsDisconnectFieldInput = {
	disconnect?: InputMaybe<TreatmentDisconnectInput>;
	where?: InputMaybe<EnrollingConditionSetTreatmentsConnectionWhere>;
};

export type EnrollingConditionSetTreatmentsFieldInput = {
	connect?: InputMaybe<Array<EnrollingConditionSetTreatmentsConnectFieldInput>>;
	create?: InputMaybe<Array<EnrollingConditionSetTreatmentsCreateFieldInput>>;
};

export type EnrollingConditionSetTreatmentsNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<EnrollingConditionSetTreatmentsNodeAggregationWhereInput>>;
	BagDossierNo_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	BagDossierNo_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	BagDossierNo_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	BagDossierNo_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	BagDossierNo_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	BagDossierNo_EQUAL?: InputMaybe<Scalars["String"]>;
	BagDossierNo_GT?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_GTE?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LT?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LTE?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	Code_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	Code_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	Code_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	Code_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	Code_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	Code_EQUAL?: InputMaybe<Scalars["String"]>;
	Code_GT?: InputMaybe<Scalars["Int"]>;
	Code_GTE?: InputMaybe<Scalars["Int"]>;
	Code_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Code_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	Code_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	Code_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	Code_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	Code_LT?: InputMaybe<Scalars["Int"]>;
	Code_LTE?: InputMaybe<Scalars["Int"]>;
	Code_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Code_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	Code_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	Code_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	Code_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	FlagModal_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	FlagModal_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	FlagModal_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	FlagModal_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	FlagModal_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	FlagModal_EQUAL?: InputMaybe<Scalars["String"]>;
	FlagModal_GT?: InputMaybe<Scalars["Int"]>;
	FlagModal_GTE?: InputMaybe<Scalars["Int"]>;
	FlagModal_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	FlagModal_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	FlagModal_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	FlagModal_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	FlagModal_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	FlagModal_LT?: InputMaybe<Scalars["Int"]>;
	FlagModal_LTE?: InputMaybe<Scalars["Int"]>;
	FlagModal_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	FlagModal_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	FlagModal_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	FlagModal_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	FlagModal_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	FlagNarcosis_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	FlagNarcosis_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	FlagNarcosis_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	FlagNarcosis_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	FlagNarcosis_EQUAL?: InputMaybe<Scalars["String"]>;
	FlagNarcosis_GT?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_GTE?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LT?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LTE?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	GTIN_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	GTIN_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	GTIN_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	GTIN_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	GTIN_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	GTIN_EQUAL?: InputMaybe<Scalars["String"]>;
	GTIN_GT?: InputMaybe<Scalars["Int"]>;
	GTIN_GTE?: InputMaybe<Scalars["Int"]>;
	GTIN_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	GTIN_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	GTIN_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	GTIN_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	GTIN_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	GTIN_LT?: InputMaybe<Scalars["Int"]>;
	GTIN_LTE?: InputMaybe<Scalars["Int"]>;
	GTIN_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	GTIN_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	GTIN_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	GTIN_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	GTIN_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	LOT_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	LOT_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	LOT_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	LOT_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	LOT_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	LOT_EQUAL?: InputMaybe<Scalars["String"]>;
	LOT_GT?: InputMaybe<Scalars["Int"]>;
	LOT_GTE?: InputMaybe<Scalars["Int"]>;
	LOT_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	LOT_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	LOT_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	LOT_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	LOT_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	LOT_LT?: InputMaybe<Scalars["Int"]>;
	LOT_LTE?: InputMaybe<Scalars["Int"]>;
	LOT_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	LOT_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	LOT_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	LOT_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	LOT_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	Name_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	Name_EQUAL?: InputMaybe<Scalars["String"]>;
	Name_GT?: InputMaybe<Scalars["Int"]>;
	Name_GTE?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	Name_LT?: InputMaybe<Scalars["Int"]>;
	Name_LTE?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	OR?: InputMaybe<Array<EnrollingConditionSetTreatmentsNodeAggregationWhereInput>>;
	PharmaCode_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	PharmaCode_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	PharmaCode_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	PharmaCode_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	PharmaCode_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	PharmaCode_EQUAL?: InputMaybe<Scalars["String"]>;
	PharmaCode_GT?: InputMaybe<Scalars["Int"]>;
	PharmaCode_GTE?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LT?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LTE?: InputMaybe<Scalars["Int"]>;
	PharmaCode_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	PharmaCode_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	PharmaCode_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	PharmaCode_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	PharmaCode_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	PrevPharmacode_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	PrevPharmacode_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	PrevPharmacode_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	PrevPharmacode_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	PrevPharmacode_EQUAL?: InputMaybe<Scalars["String"]>;
	PrevPharmacode_GT?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_GTE?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LT?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LTE?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	REF_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	REF_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	REF_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	REF_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	REF_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	REF_EQUAL?: InputMaybe<Scalars["String"]>;
	REF_GT?: InputMaybe<Scalars["Int"]>;
	REF_GTE?: InputMaybe<Scalars["Int"]>;
	REF_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	REF_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	REF_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	REF_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	REF_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	REF_LT?: InputMaybe<Scalars["Int"]>;
	REF_LTE?: InputMaybe<Scalars["Int"]>;
	REF_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	REF_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	REF_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	REF_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	REF_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	SwissmedicCategory_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	SwissmedicCategory_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	SwissmedicCategory_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	SwissmedicCategory_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	SwissmedicCategory_EQUAL?: InputMaybe<Scalars["String"]>;
	SwissmedicCategory_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo8_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo8_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo8_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo8_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo8_EQUAL?: InputMaybe<Scalars["String"]>;
	SwissmedicNo8_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	UDI_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	UDI_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	UDI_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	UDI_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	UDI_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	UDI_EQUAL?: InputMaybe<Scalars["String"]>;
	UDI_GT?: InputMaybe<Scalars["Int"]>;
	UDI_GTE?: InputMaybe<Scalars["Int"]>;
	UDI_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	UDI_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	UDI_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	UDI_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	UDI_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	UDI_LT?: InputMaybe<Scalars["Int"]>;
	UDI_LTE?: InputMaybe<Scalars["Int"]>;
	UDI_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	UDI_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	UDI_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	UDI_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	UDI_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	classificationSystem_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	classificationSystem_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	classificationSystem_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	classificationSystem_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	classificationSystem_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	classificationSystem_EQUAL?: InputMaybe<Scalars["String"]>;
	classificationSystem_GT?: InputMaybe<Scalars["Int"]>;
	classificationSystem_GTE?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LT?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LTE?: InputMaybe<Scalars["Int"]>;
	classificationSystem_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	classificationSystem_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	classificationSystem_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	classificationSystem_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	classificationSystem_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type EnrollingConditionSetTreatmentsRelationship = {
	__typename?: "EnrollingConditionSetTreatmentsRelationship";
	cursor: Scalars["String"];
	node: Treatment;
};

export type EnrollingConditionSetTreatmentsUpdateConnectionInput = {
	node?: InputMaybe<TreatmentUpdateInput>;
};

export type EnrollingConditionSetTreatmentsUpdateFieldInput = {
	connect?: InputMaybe<Array<EnrollingConditionSetTreatmentsConnectFieldInput>>;
	create?: InputMaybe<Array<EnrollingConditionSetTreatmentsCreateFieldInput>>;
	delete?: InputMaybe<Array<EnrollingConditionSetTreatmentsDeleteFieldInput>>;
	disconnect?: InputMaybe<Array<EnrollingConditionSetTreatmentsDisconnectFieldInput>>;
	update?: InputMaybe<EnrollingConditionSetTreatmentsUpdateConnectionInput>;
	where?: InputMaybe<EnrollingConditionSetTreatmentsConnectionWhere>;
};

export type EnrollingConditionSetUpdateInput = {
	agreement?: InputMaybe<EnrollingConditionSetAgreementUpdateFieldInput>;
	code?: InputMaybe<Scalars["String"]>;
	diseases?: InputMaybe<Array<EnrollingConditionSetDiseasesUpdateFieldInput>>;
	indications?: InputMaybe<Array<EnrollingConditionSetIndicationsUpdateFieldInput>>;
	isDeleted?: InputMaybe<Scalars["Boolean"]>;
	isExtended?: InputMaybe<Scalars["Boolean"]>;
	preparationConditionLogicalOperator?: InputMaybe<ConditionLogicalOperator>;
	preparations?: InputMaybe<Array<EnrollingConditionSetPreparationsUpdateFieldInput>>;
	tenantIds?: InputMaybe<Array<Scalars["String"]>>;
	treatments?: InputMaybe<Array<EnrollingConditionSetTreatmentsUpdateFieldInput>>;
};

export type EnrollingConditionSetWhere = {
	AND?: InputMaybe<Array<EnrollingConditionSetWhere>>;
	OR?: InputMaybe<Array<EnrollingConditionSetWhere>>;
	agreement?: InputMaybe<BaseAgreementWhere>;
	agreementAggregate?: InputMaybe<EnrollingConditionSetAgreementAggregateInput>;
	agreementConnection?: InputMaybe<EnrollingConditionSetAgreementConnectionWhere>;
	agreementConnection_NOT?: InputMaybe<EnrollingConditionSetAgreementConnectionWhere>;
	agreement_NOT?: InputMaybe<BaseAgreementWhere>;
	code?: InputMaybe<Scalars["String"]>;
	code_CONTAINS?: InputMaybe<Scalars["String"]>;
	code_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	code_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	code_MATCHES?: InputMaybe<Scalars["String"]>;
	code_NOT?: InputMaybe<Scalars["String"]>;
	code_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	code_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	code_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	code_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	code_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	diseases?: InputMaybe<DiseaseWhere>;
	diseasesAggregate?: InputMaybe<EnrollingConditionSetDiseasesAggregateInput>;
	diseasesConnection?: InputMaybe<EnrollingConditionSetDiseasesConnectionWhere>;
	diseasesConnection_NOT?: InputMaybe<EnrollingConditionSetDiseasesConnectionWhere>;
	diseases_NOT?: InputMaybe<DiseaseWhere>;
	indications?: InputMaybe<IndicationWhere>;
	indicationsAggregate?: InputMaybe<EnrollingConditionSetIndicationsAggregateInput>;
	indicationsConnection?: InputMaybe<EnrollingConditionSetIndicationsConnectionWhere>;
	indicationsConnection_NOT?: InputMaybe<EnrollingConditionSetIndicationsConnectionWhere>;
	indications_NOT?: InputMaybe<IndicationWhere>;
	isDeleted?: InputMaybe<Scalars["Boolean"]>;
	isDeleted_NOT?: InputMaybe<Scalars["Boolean"]>;
	isExtended?: InputMaybe<Scalars["Boolean"]>;
	isExtended_NOT?: InputMaybe<Scalars["Boolean"]>;
	preparationConditionLogicalOperator?: InputMaybe<ConditionLogicalOperator>;
	preparationConditionLogicalOperator_IN?: InputMaybe<Array<InputMaybe<ConditionLogicalOperator>>>;
	preparationConditionLogicalOperator_NOT?: InputMaybe<ConditionLogicalOperator>;
	preparationConditionLogicalOperator_NOT_IN?: InputMaybe<Array<InputMaybe<ConditionLogicalOperator>>>;
	preparations?: InputMaybe<PreparationWhere>;
	preparationsAggregate?: InputMaybe<EnrollingConditionSetPreparationsAggregateInput>;
	preparationsConnection?: InputMaybe<EnrollingConditionSetPreparationsConnectionWhere>;
	preparationsConnection_NOT?: InputMaybe<EnrollingConditionSetPreparationsConnectionWhere>;
	preparations_NOT?: InputMaybe<PreparationWhere>;
	tenantIds?: InputMaybe<Array<Scalars["String"]>>;
	tenantIds_INCLUDES?: InputMaybe<Scalars["String"]>;
	tenantIds_NOT?: InputMaybe<Array<Scalars["String"]>>;
	tenantIds_NOT_INCLUDES?: InputMaybe<Scalars["String"]>;
	treatments?: InputMaybe<TreatmentWhere>;
	treatmentsAggregate?: InputMaybe<EnrollingConditionSetTreatmentsAggregateInput>;
	treatmentsConnection?: InputMaybe<EnrollingConditionSetTreatmentsConnectionWhere>;
	treatmentsConnection_NOT?: InputMaybe<EnrollingConditionSetTreatmentsConnectionWhere>;
	treatments_NOT?: InputMaybe<TreatmentWhere>;
};

export type EnrollingPeriod = {
	__typename?: "EnrollingPeriod";
	from: Scalars["Date"];
	to: Scalars["Date"];
};

export type EnrollingPeriodAggregateSelection = {
	__typename?: "EnrollingPeriodAggregateSelection";
	count: Scalars["Int"];
};

export type EnrollingPeriodConnectWhere = {
	node: EnrollingPeriodWhere;
};

export type EnrollingPeriodCreateInput = {
	from: Scalars["Date"];
	to: Scalars["Date"];
};

export type EnrollingPeriodOptions = {
	limit?: InputMaybe<Scalars["Int"]>;
	offset?: InputMaybe<Scalars["Int"]>;
	/** Specify one or more EnrollingPeriodSort objects to sort EnrollingPeriods by. The sorts will be applied in the order in which they are arranged in the array. */
	sort?: InputMaybe<Array<InputMaybe<EnrollingPeriodSort>>>;
};

/** Fields to sort EnrollingPeriods by. The order in which sorts are applied is not guaranteed when specifying many fields in one EnrollingPeriodSort object. */
export type EnrollingPeriodSort = {
	from?: InputMaybe<SortDirection>;
	to?: InputMaybe<SortDirection>;
};

export type EnrollingPeriodUpdateInput = {
	from?: InputMaybe<Scalars["Date"]>;
	to?: InputMaybe<Scalars["Date"]>;
};

export type EnrollingPeriodWhere = {
	AND?: InputMaybe<Array<EnrollingPeriodWhere>>;
	OR?: InputMaybe<Array<EnrollingPeriodWhere>>;
	from?: InputMaybe<Scalars["Date"]>;
	from_GT?: InputMaybe<Scalars["Date"]>;
	from_GTE?: InputMaybe<Scalars["Date"]>;
	from_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
	from_LT?: InputMaybe<Scalars["Date"]>;
	from_LTE?: InputMaybe<Scalars["Date"]>;
	from_NOT?: InputMaybe<Scalars["Date"]>;
	from_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
	to?: InputMaybe<Scalars["Date"]>;
	to_GT?: InputMaybe<Scalars["Date"]>;
	to_GTE?: InputMaybe<Scalars["Date"]>;
	to_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
	to_LT?: InputMaybe<Scalars["Date"]>;
	to_LTE?: InputMaybe<Scalars["Date"]>;
	to_NOT?: InputMaybe<Scalars["Date"]>;
	to_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
};

export type ExFactoryPrice = {
	__typename?: "ExFactoryPrice";
	Price?: Maybe<Scalars["String"]>;
	ValidFromDate?: Maybe<Scalars["Date"]>;
};

export type ExFactoryPriceAggregateSelection = {
	__typename?: "ExFactoryPriceAggregateSelection";
	Price: StringAggregateSelection;
	count: Scalars["Int"];
};

export type ExFactoryPriceConnectWhere = {
	node: ExFactoryPriceWhere;
};

export type ExFactoryPriceCreateInput = {
	Price?: InputMaybe<Scalars["String"]>;
	ValidFromDate?: InputMaybe<Scalars["Date"]>;
};

export type ExFactoryPriceOptions = {
	limit?: InputMaybe<Scalars["Int"]>;
	offset?: InputMaybe<Scalars["Int"]>;
	/** Specify one or more ExFactoryPriceSort objects to sort ExFactoryPrices by. The sorts will be applied in the order in which they are arranged in the array. */
	sort?: InputMaybe<Array<InputMaybe<ExFactoryPriceSort>>>;
};

/** Fields to sort ExFactoryPrices by. The order in which sorts are applied is not guaranteed when specifying many fields in one ExFactoryPriceSort object. */
export type ExFactoryPriceSort = {
	Price?: InputMaybe<SortDirection>;
	ValidFromDate?: InputMaybe<SortDirection>;
};

export type ExFactoryPriceUpdateInput = {
	Price?: InputMaybe<Scalars["String"]>;
	ValidFromDate?: InputMaybe<Scalars["Date"]>;
};

export type ExFactoryPriceWhere = {
	AND?: InputMaybe<Array<ExFactoryPriceWhere>>;
	OR?: InputMaybe<Array<ExFactoryPriceWhere>>;
	Price?: InputMaybe<Scalars["String"]>;
	Price_CONTAINS?: InputMaybe<Scalars["String"]>;
	Price_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	Price_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	Price_MATCHES?: InputMaybe<Scalars["String"]>;
	Price_NOT?: InputMaybe<Scalars["String"]>;
	Price_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	Price_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	Price_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	Price_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	Price_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	ValidFromDate?: InputMaybe<Scalars["Date"]>;
	ValidFromDate_GT?: InputMaybe<Scalars["Date"]>;
	ValidFromDate_GTE?: InputMaybe<Scalars["Date"]>;
	ValidFromDate_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
	ValidFromDate_LT?: InputMaybe<Scalars["Date"]>;
	ValidFromDate_LTE?: InputMaybe<Scalars["Date"]>;
	ValidFromDate_NOT?: InputMaybe<Scalars["Date"]>;
	ValidFromDate_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
};

export type FinancialDataPoint = {
	__typename?: "FinancialDataPoint";
	agreement?: Maybe<Agreement>;
	agreementConnection: FinancialDataPointAgreementConnection;
	basePrice?: Maybe<Scalars["Float"]>;
	claim?: Maybe<Claim>;
	claimConnection: FinancialDataPointClaimConnection;
	continuousBenefit?: Maybe<ContinuousBenefit>;
	continuousBenefitConnection: FinancialDataPointContinuousBenefitConnection;
	coverageRequest?: Maybe<CoverageRequest>;
	coverageRequestConnection: FinancialDataPointCoverageRequestConnection;
	currencyCode?: Maybe<Scalars["String"]>;
	date: Scalars["Date"];
	evaluationSnapshot?: Maybe<Scalars["String"]>;
	generatedUuid: Scalars["ID"];
	includedIn: Case;
	includedInConnection: FinancialDataPointIncludedInConnection;
	intervention?: Maybe<Intervention>;
	interventionConnection: FinancialDataPointInterventionConnection;
	isDeleted: Scalars["Boolean"];
	isLast: Scalars["Boolean"];
	payable?: Maybe<Scalars["Float"]>;
	payablePercentage?: Maybe<Scalars["Float"]>;
	prescriptionDate: Scalars["Date"];
	quantity: Scalars["Float"];
	refundable?: Maybe<Scalars["Float"]>;
	refundablePercentage?: Maybe<Scalars["Float"]>;
	sourceRefund?: Maybe<Refund>;
	sourceRefundConnection: FinancialDataPointSourceRefundConnection;
	treatment?: Maybe<Treatment>;
	treatmentConnection: FinancialDataPointTreatmentConnection;
	uuid: Scalars["ID"];
	variable?: Maybe<Scalars["Float"]>;
	variablePercentage?: Maybe<Scalars["Float"]>;
};

export type FinancialDataPointAgreementArgs = {
	options?: InputMaybe<AgreementOptions>;
	where?: InputMaybe<AgreementWhere>;
};

export type FinancialDataPointAgreementConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<FinancialDataPointAgreementConnectionSort>>;
	where?: InputMaybe<FinancialDataPointAgreementConnectionWhere>;
};

export type FinancialDataPointClaimArgs = {
	options?: InputMaybe<ClaimOptions>;
	where?: InputMaybe<ClaimWhere>;
};

export type FinancialDataPointClaimConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<FinancialDataPointClaimConnectionSort>>;
	where?: InputMaybe<FinancialDataPointClaimConnectionWhere>;
};

export type FinancialDataPointContinuousBenefitArgs = {
	options?: InputMaybe<ContinuousBenefitOptions>;
	where?: InputMaybe<ContinuousBenefitWhere>;
};

export type FinancialDataPointContinuousBenefitConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<FinancialDataPointContinuousBenefitConnectionSort>>;
	where?: InputMaybe<FinancialDataPointContinuousBenefitConnectionWhere>;
};

export type FinancialDataPointCoverageRequestArgs = {
	options?: InputMaybe<CoverageRequestOptions>;
	where?: InputMaybe<CoverageRequestWhere>;
};

export type FinancialDataPointCoverageRequestConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<FinancialDataPointCoverageRequestConnectionSort>>;
	where?: InputMaybe<FinancialDataPointCoverageRequestConnectionWhere>;
};

export type FinancialDataPointIncludedInArgs = {
	options?: InputMaybe<CaseOptions>;
	where?: InputMaybe<CaseWhere>;
};

export type FinancialDataPointIncludedInConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<FinancialDataPointIncludedInConnectionSort>>;
	where?: InputMaybe<FinancialDataPointIncludedInConnectionWhere>;
};

export type FinancialDataPointInterventionArgs = {
	options?: InputMaybe<InterventionOptions>;
	where?: InputMaybe<InterventionWhere>;
};

export type FinancialDataPointInterventionConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<FinancialDataPointInterventionConnectionSort>>;
	where?: InputMaybe<FinancialDataPointInterventionConnectionWhere>;
};

export type FinancialDataPointSourceRefundArgs = {
	options?: InputMaybe<RefundOptions>;
	where?: InputMaybe<RefundWhere>;
};

export type FinancialDataPointSourceRefundConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<FinancialDataPointSourceRefundConnectionSort>>;
	where?: InputMaybe<FinancialDataPointSourceRefundConnectionWhere>;
};

export type FinancialDataPointTreatmentArgs = {
	options?: InputMaybe<TreatmentOptions>;
	where?: InputMaybe<TreatmentWhere>;
};

export type FinancialDataPointTreatmentConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<FinancialDataPointTreatmentConnectionSort>>;
	where?: InputMaybe<FinancialDataPointTreatmentConnectionWhere>;
};

export type FinancialDataPointAggregateSelection = {
	__typename?: "FinancialDataPointAggregateSelection";
	basePrice: FloatAggregateSelection;
	count: Scalars["Int"];
	currencyCode: StringAggregateSelection;
	evaluationSnapshot: StringAggregateSelection;
	generatedUuid: IdAggregateSelection;
	payable: FloatAggregateSelection;
	payablePercentage: FloatAggregateSelection;
	quantity: FloatAggregateSelection;
	refundable: FloatAggregateSelection;
	refundablePercentage: FloatAggregateSelection;
	uuid: IdAggregateSelection;
	variable: FloatAggregateSelection;
	variablePercentage: FloatAggregateSelection;
};

export type FinancialDataPointAgreementAggregateInput = {
	AND?: InputMaybe<Array<FinancialDataPointAgreementAggregateInput>>;
	OR?: InputMaybe<Array<FinancialDataPointAgreementAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<FinancialDataPointAgreementNodeAggregationWhereInput>;
};

export type FinancialDataPointAgreementConnectFieldInput = {
	connect?: InputMaybe<AgreementConnectInput>;
	where?: InputMaybe<AgreementConnectWhere>;
};

export type FinancialDataPointAgreementConnection = {
	__typename?: "FinancialDataPointAgreementConnection";
	edges: Array<FinancialDataPointAgreementRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type FinancialDataPointAgreementConnectionSort = {
	node?: InputMaybe<AgreementSort>;
};

export type FinancialDataPointAgreementConnectionWhere = {
	AND?: InputMaybe<Array<FinancialDataPointAgreementConnectionWhere>>;
	OR?: InputMaybe<Array<FinancialDataPointAgreementConnectionWhere>>;
	node?: InputMaybe<AgreementWhere>;
	node_NOT?: InputMaybe<AgreementWhere>;
};

export type FinancialDataPointAgreementCreateFieldInput = {
	node: AgreementCreateInput;
};

export type FinancialDataPointAgreementDeleteFieldInput = {
	delete?: InputMaybe<AgreementDeleteInput>;
	where?: InputMaybe<FinancialDataPointAgreementConnectionWhere>;
};

export type FinancialDataPointAgreementDisconnectFieldInput = {
	disconnect?: InputMaybe<AgreementDisconnectInput>;
	where?: InputMaybe<FinancialDataPointAgreementConnectionWhere>;
};

export type FinancialDataPointAgreementFieldInput = {
	connect?: InputMaybe<FinancialDataPointAgreementConnectFieldInput>;
	create?: InputMaybe<FinancialDataPointAgreementCreateFieldInput>;
};

export type FinancialDataPointAgreementNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<FinancialDataPointAgreementNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<FinancialDataPointAgreementNodeAggregationWhereInput>>;
	description_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	description_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	description_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	description_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	description_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	description_EQUAL?: InputMaybe<Scalars["String"]>;
	description_GT?: InputMaybe<Scalars["Int"]>;
	description_GTE?: InputMaybe<Scalars["Int"]>;
	description_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	description_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	description_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	description_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	description_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	description_LT?: InputMaybe<Scalars["Int"]>;
	description_LTE?: InputMaybe<Scalars["Int"]>;
	description_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	description_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	description_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	description_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	description_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	formattedAmount_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	formattedAmount_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	formattedAmount_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	formattedAmount_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	formattedAmount_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	formattedAmount_EQUAL?: InputMaybe<Scalars["String"]>;
	formattedAmount_GT?: InputMaybe<Scalars["Int"]>;
	formattedAmount_GTE?: InputMaybe<Scalars["Int"]>;
	formattedAmount_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedAmount_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedAmount_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedAmount_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedAmount_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	formattedAmount_LT?: InputMaybe<Scalars["Int"]>;
	formattedAmount_LTE?: InputMaybe<Scalars["Int"]>;
	formattedAmount_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedAmount_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedAmount_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedAmount_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedAmount_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	formattedCounterparties_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	formattedCounterparties_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	formattedCounterparties_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	formattedCounterparties_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	formattedCounterparties_EQUAL?: InputMaybe<Scalars["String"]>;
	formattedCounterparties_GT?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_GTE?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_LT?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_LTE?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	formattedProducts_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	formattedProducts_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	formattedProducts_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	formattedProducts_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	formattedProducts_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	formattedProducts_EQUAL?: InputMaybe<Scalars["String"]>;
	formattedProducts_GT?: InputMaybe<Scalars["Int"]>;
	formattedProducts_GTE?: InputMaybe<Scalars["Int"]>;
	formattedProducts_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedProducts_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedProducts_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedProducts_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedProducts_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	formattedProducts_LT?: InputMaybe<Scalars["Int"]>;
	formattedProducts_LTE?: InputMaybe<Scalars["Int"]>;
	formattedProducts_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedProducts_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedProducts_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedProducts_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedProducts_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	formattedTags_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	formattedTags_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	formattedTags_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	formattedTags_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	formattedTags_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	formattedTags_EQUAL?: InputMaybe<Scalars["String"]>;
	formattedTags_GT?: InputMaybe<Scalars["Int"]>;
	formattedTags_GTE?: InputMaybe<Scalars["Int"]>;
	formattedTags_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedTags_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedTags_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedTags_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedTags_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	formattedTags_LT?: InputMaybe<Scalars["Int"]>;
	formattedTags_LTE?: InputMaybe<Scalars["Int"]>;
	formattedTags_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedTags_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedTags_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedTags_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedTags_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	formattedValidityPeriod_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	formattedValidityPeriod_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	formattedValidityPeriod_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	formattedValidityPeriod_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	formattedValidityPeriod_EQUAL?: InputMaybe<Scalars["String"]>;
	formattedValidityPeriod_GT?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_GTE?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_LT?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_LTE?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	initialVersionId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	initialVersionId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	initialVersionId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	initialVersionId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	initialVersionId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	initialVersionId_EQUAL?: InputMaybe<Scalars["String"]>;
	initialVersionId_GT?: InputMaybe<Scalars["Int"]>;
	initialVersionId_GTE?: InputMaybe<Scalars["Int"]>;
	initialVersionId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	initialVersionId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	initialVersionId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	initialVersionId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	initialVersionId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	initialVersionId_LT?: InputMaybe<Scalars["Int"]>;
	initialVersionId_LTE?: InputMaybe<Scalars["Int"]>;
	initialVersionId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	initialVersionId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	initialVersionId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	initialVersionId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	initialVersionId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	name_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	name_EQUAL?: InputMaybe<Scalars["String"]>;
	name_GT?: InputMaybe<Scalars["Int"]>;
	name_GTE?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	name_LT?: InputMaybe<Scalars["Int"]>;
	name_LTE?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	totalAmount_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	totalAmount_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	totalAmount_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	totalAmount_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	totalAmount_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	totalAmount_EQUAL?: InputMaybe<Scalars["Float"]>;
	totalAmount_GT?: InputMaybe<Scalars["Float"]>;
	totalAmount_GTE?: InputMaybe<Scalars["Float"]>;
	totalAmount_LT?: InputMaybe<Scalars["Float"]>;
	totalAmount_LTE?: InputMaybe<Scalars["Float"]>;
	totalAmount_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	totalAmount_MAX_GT?: InputMaybe<Scalars["Float"]>;
	totalAmount_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	totalAmount_MAX_LT?: InputMaybe<Scalars["Float"]>;
	totalAmount_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	totalAmount_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	totalAmount_MIN_GT?: InputMaybe<Scalars["Float"]>;
	totalAmount_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	totalAmount_MIN_LT?: InputMaybe<Scalars["Float"]>;
	totalAmount_MIN_LTE?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	unlimited_EQUAL?: InputMaybe<Scalars["Int"]>;
	unlimited_GT?: InputMaybe<Scalars["Int"]>;
	unlimited_GTE?: InputMaybe<Scalars["Int"]>;
	unlimited_LT?: InputMaybe<Scalars["Int"]>;
	unlimited_LTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_GT?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_LT?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_GT?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_LT?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_LTE?: InputMaybe<Scalars["Int"]>;
};

export type FinancialDataPointAgreementRelationship = {
	__typename?: "FinancialDataPointAgreementRelationship";
	cursor: Scalars["String"];
	node: Agreement;
};

export type FinancialDataPointAgreementUpdateConnectionInput = {
	node?: InputMaybe<AgreementUpdateInput>;
};

export type FinancialDataPointAgreementUpdateFieldInput = {
	connect?: InputMaybe<FinancialDataPointAgreementConnectFieldInput>;
	create?: InputMaybe<FinancialDataPointAgreementCreateFieldInput>;
	delete?: InputMaybe<FinancialDataPointAgreementDeleteFieldInput>;
	disconnect?: InputMaybe<FinancialDataPointAgreementDisconnectFieldInput>;
	update?: InputMaybe<FinancialDataPointAgreementUpdateConnectionInput>;
	where?: InputMaybe<FinancialDataPointAgreementConnectionWhere>;
};

export type FinancialDataPointClaimAggregateInput = {
	AND?: InputMaybe<Array<FinancialDataPointClaimAggregateInput>>;
	OR?: InputMaybe<Array<FinancialDataPointClaimAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<FinancialDataPointClaimNodeAggregationWhereInput>;
};

export type FinancialDataPointClaimConnectFieldInput = {
	connect?: InputMaybe<ClaimConnectInput>;
	where?: InputMaybe<ClaimConnectWhere>;
};

export type FinancialDataPointClaimConnection = {
	__typename?: "FinancialDataPointClaimConnection";
	edges: Array<FinancialDataPointClaimRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type FinancialDataPointClaimConnectionSort = {
	node?: InputMaybe<ClaimSort>;
};

export type FinancialDataPointClaimConnectionWhere = {
	AND?: InputMaybe<Array<FinancialDataPointClaimConnectionWhere>>;
	OR?: InputMaybe<Array<FinancialDataPointClaimConnectionWhere>>;
	node?: InputMaybe<ClaimWhere>;
	node_NOT?: InputMaybe<ClaimWhere>;
};

export type FinancialDataPointClaimCreateFieldInput = {
	node: ClaimCreateInput;
};

export type FinancialDataPointClaimDeleteFieldInput = {
	delete?: InputMaybe<ClaimDeleteInput>;
	where?: InputMaybe<FinancialDataPointClaimConnectionWhere>;
};

export type FinancialDataPointClaimDisconnectFieldInput = {
	disconnect?: InputMaybe<ClaimDisconnectInput>;
	where?: InputMaybe<FinancialDataPointClaimConnectionWhere>;
};

export type FinancialDataPointClaimFieldInput = {
	connect?: InputMaybe<FinancialDataPointClaimConnectFieldInput>;
	create?: InputMaybe<FinancialDataPointClaimCreateFieldInput>;
};

export type FinancialDataPointClaimNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<FinancialDataPointClaimNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<FinancialDataPointClaimNodeAggregationWhereInput>>;
	administrationDate_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	administrationDate_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	administrationDate_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	administrationDate_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	administrationDate_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	administrationDate_EQUAL?: InputMaybe<Scalars["String"]>;
	administrationDate_GT?: InputMaybe<Scalars["Int"]>;
	administrationDate_GTE?: InputMaybe<Scalars["Int"]>;
	administrationDate_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	administrationDate_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	administrationDate_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	administrationDate_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	administrationDate_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	administrationDate_LT?: InputMaybe<Scalars["Int"]>;
	administrationDate_LTE?: InputMaybe<Scalars["Int"]>;
	administrationDate_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	administrationDate_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	administrationDate_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	administrationDate_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	administrationDate_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	assignee_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	assignee_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	assignee_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	assignee_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	assignee_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	assignee_EQUAL?: InputMaybe<Scalars["String"]>;
	assignee_GT?: InputMaybe<Scalars["Int"]>;
	assignee_GTE?: InputMaybe<Scalars["Int"]>;
	assignee_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	assignee_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	assignee_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	assignee_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	assignee_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	assignee_LT?: InputMaybe<Scalars["Int"]>;
	assignee_LTE?: InputMaybe<Scalars["Int"]>;
	assignee_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	assignee_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	assignee_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	assignee_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	assignee_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	claimId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	claimId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	claimId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	claimId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	claimId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	claimId_EQUAL?: InputMaybe<Scalars["String"]>;
	claimId_GT?: InputMaybe<Scalars["Int"]>;
	claimId_GTE?: InputMaybe<Scalars["Int"]>;
	claimId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	claimId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	claimId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	claimId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	claimId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	claimId_LT?: InputMaybe<Scalars["Int"]>;
	claimId_LTE?: InputMaybe<Scalars["Int"]>;
	claimId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	claimId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	claimId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	claimId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	claimId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	createdOn_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	invoiceAmount_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	invoiceAmount_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	invoiceAmount_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	invoiceAmount_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	invoiceAmount_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	invoiceAmount_EQUAL?: InputMaybe<Scalars["String"]>;
	invoiceAmount_GT?: InputMaybe<Scalars["Int"]>;
	invoiceAmount_GTE?: InputMaybe<Scalars["Int"]>;
	invoiceAmount_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	invoiceAmount_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	invoiceAmount_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	invoiceAmount_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	invoiceAmount_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	invoiceAmount_LT?: InputMaybe<Scalars["Int"]>;
	invoiceAmount_LTE?: InputMaybe<Scalars["Int"]>;
	invoiceAmount_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	invoiceAmount_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	invoiceAmount_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	invoiceAmount_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	invoiceAmount_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	invoiceDate_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	invoiceDate_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	invoiceDate_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	invoiceDate_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	invoiceDate_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	invoiceDate_EQUAL?: InputMaybe<Scalars["String"]>;
	invoiceDate_GT?: InputMaybe<Scalars["Int"]>;
	invoiceDate_GTE?: InputMaybe<Scalars["Int"]>;
	invoiceDate_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	invoiceDate_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	invoiceDate_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	invoiceDate_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	invoiceDate_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	invoiceDate_LT?: InputMaybe<Scalars["Int"]>;
	invoiceDate_LTE?: InputMaybe<Scalars["Int"]>;
	invoiceDate_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	invoiceDate_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	invoiceDate_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	invoiceDate_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	invoiceDate_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	invoiceNumber_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	invoiceNumber_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	invoiceNumber_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	invoiceNumber_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	invoiceNumber_EQUAL?: InputMaybe<Scalars["String"]>;
	invoiceNumber_GT?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_GTE?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_LT?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_LTE?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationIdType_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	preparationIdType_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	preparationIdType_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	preparationIdType_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	preparationIdType_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	preparationIdType_EQUAL?: InputMaybe<Scalars["String"]>;
	preparationIdType_GT?: InputMaybe<Scalars["Int"]>;
	preparationIdType_GTE?: InputMaybe<Scalars["Int"]>;
	preparationIdType_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationIdType_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationIdType_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationIdType_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationIdType_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationIdType_LT?: InputMaybe<Scalars["Int"]>;
	preparationIdType_LTE?: InputMaybe<Scalars["Int"]>;
	preparationIdType_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationIdType_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationIdType_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationIdType_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationIdType_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	preparationId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	preparationId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	preparationId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	preparationId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	preparationId_EQUAL?: InputMaybe<Scalars["String"]>;
	preparationId_GT?: InputMaybe<Scalars["Int"]>;
	preparationId_GTE?: InputMaybe<Scalars["Int"]>;
	preparationId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationId_LT?: InputMaybe<Scalars["Int"]>;
	preparationId_LTE?: InputMaybe<Scalars["Int"]>;
	preparationId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	providerId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	providerId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	providerId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	providerId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	providerId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	providerId_EQUAL?: InputMaybe<Scalars["String"]>;
	providerId_GT?: InputMaybe<Scalars["Int"]>;
	providerId_GTE?: InputMaybe<Scalars["Int"]>;
	providerId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	providerId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	providerId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	providerId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	providerId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	providerId_LT?: InputMaybe<Scalars["Int"]>;
	providerId_LTE?: InputMaybe<Scalars["Int"]>;
	providerId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	providerId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	providerId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	providerId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	providerId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	providerName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	providerName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	providerName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	providerName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	providerName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	providerName_EQUAL?: InputMaybe<Scalars["String"]>;
	providerName_GT?: InputMaybe<Scalars["Int"]>;
	providerName_GTE?: InputMaybe<Scalars["Int"]>;
	providerName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	providerName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	providerName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	providerName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	providerName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	providerName_LT?: InputMaybe<Scalars["Int"]>;
	providerName_LTE?: InputMaybe<Scalars["Int"]>;
	providerName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	providerName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	providerName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	providerName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	providerName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	quantity_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	quantity_EQUAL?: InputMaybe<Scalars["String"]>;
	quantity_GT?: InputMaybe<Scalars["Int"]>;
	quantity_GTE?: InputMaybe<Scalars["Int"]>;
	quantity_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	quantity_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	quantity_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	quantity_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	quantity_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	quantity_LT?: InputMaybe<Scalars["Int"]>;
	quantity_LTE?: InputMaybe<Scalars["Int"]>;
	quantity_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	quantity_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	quantity_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	quantity_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	quantity_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	tenantId_EQUAL?: InputMaybe<Scalars["String"]>;
	tenantId_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type FinancialDataPointClaimRelationship = {
	__typename?: "FinancialDataPointClaimRelationship";
	cursor: Scalars["String"];
	node: Claim;
};

export type FinancialDataPointClaimUpdateConnectionInput = {
	node?: InputMaybe<ClaimUpdateInput>;
};

export type FinancialDataPointClaimUpdateFieldInput = {
	connect?: InputMaybe<FinancialDataPointClaimConnectFieldInput>;
	create?: InputMaybe<FinancialDataPointClaimCreateFieldInput>;
	delete?: InputMaybe<FinancialDataPointClaimDeleteFieldInput>;
	disconnect?: InputMaybe<FinancialDataPointClaimDisconnectFieldInput>;
	update?: InputMaybe<FinancialDataPointClaimUpdateConnectionInput>;
	where?: InputMaybe<FinancialDataPointClaimConnectionWhere>;
};

export type FinancialDataPointConnectInput = {
	agreement?: InputMaybe<FinancialDataPointAgreementConnectFieldInput>;
	claim?: InputMaybe<FinancialDataPointClaimConnectFieldInput>;
	continuousBenefit?: InputMaybe<FinancialDataPointContinuousBenefitConnectFieldInput>;
	coverageRequest?: InputMaybe<FinancialDataPointCoverageRequestConnectFieldInput>;
	includedIn?: InputMaybe<FinancialDataPointIncludedInConnectFieldInput>;
	intervention?: InputMaybe<FinancialDataPointInterventionConnectFieldInput>;
	sourceRefund?: InputMaybe<FinancialDataPointSourceRefundConnectFieldInput>;
	treatment?: InputMaybe<FinancialDataPointTreatmentConnectFieldInput>;
};

export type FinancialDataPointConnectWhere = {
	node: FinancialDataPointWhere;
};

export type FinancialDataPointContinuousBenefitAggregateInput = {
	AND?: InputMaybe<Array<FinancialDataPointContinuousBenefitAggregateInput>>;
	OR?: InputMaybe<Array<FinancialDataPointContinuousBenefitAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<FinancialDataPointContinuousBenefitNodeAggregationWhereInput>;
};

export type FinancialDataPointContinuousBenefitConnectFieldInput = {
	connect?: InputMaybe<ContinuousBenefitConnectInput>;
	where?: InputMaybe<ContinuousBenefitConnectWhere>;
};

export type FinancialDataPointContinuousBenefitConnection = {
	__typename?: "FinancialDataPointContinuousBenefitConnection";
	edges: Array<FinancialDataPointContinuousBenefitRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type FinancialDataPointContinuousBenefitConnectionSort = {
	node?: InputMaybe<ContinuousBenefitSort>;
};

export type FinancialDataPointContinuousBenefitConnectionWhere = {
	AND?: InputMaybe<Array<FinancialDataPointContinuousBenefitConnectionWhere>>;
	OR?: InputMaybe<Array<FinancialDataPointContinuousBenefitConnectionWhere>>;
	node?: InputMaybe<ContinuousBenefitWhere>;
	node_NOT?: InputMaybe<ContinuousBenefitWhere>;
};

export type FinancialDataPointContinuousBenefitCreateFieldInput = {
	node: ContinuousBenefitCreateInput;
};

export type FinancialDataPointContinuousBenefitDeleteFieldInput = {
	delete?: InputMaybe<ContinuousBenefitDeleteInput>;
	where?: InputMaybe<FinancialDataPointContinuousBenefitConnectionWhere>;
};

export type FinancialDataPointContinuousBenefitDisconnectFieldInput = {
	disconnect?: InputMaybe<ContinuousBenefitDisconnectInput>;
	where?: InputMaybe<FinancialDataPointContinuousBenefitConnectionWhere>;
};

export type FinancialDataPointContinuousBenefitFieldInput = {
	connect?: InputMaybe<FinancialDataPointContinuousBenefitConnectFieldInput>;
	create?: InputMaybe<FinancialDataPointContinuousBenefitCreateFieldInput>;
};

export type FinancialDataPointContinuousBenefitNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<FinancialDataPointContinuousBenefitNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<FinancialDataPointContinuousBenefitNodeAggregationWhereInput>>;
	createdOn_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	submissionDate_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_GT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_GTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_LT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_LTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	tenantId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	tenantId_EQUAL?: InputMaybe<Scalars["String"]>;
	tenantId_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type FinancialDataPointContinuousBenefitRelationship = {
	__typename?: "FinancialDataPointContinuousBenefitRelationship";
	cursor: Scalars["String"];
	node: ContinuousBenefit;
};

export type FinancialDataPointContinuousBenefitUpdateConnectionInput = {
	node?: InputMaybe<ContinuousBenefitUpdateInput>;
};

export type FinancialDataPointContinuousBenefitUpdateFieldInput = {
	connect?: InputMaybe<FinancialDataPointContinuousBenefitConnectFieldInput>;
	create?: InputMaybe<FinancialDataPointContinuousBenefitCreateFieldInput>;
	delete?: InputMaybe<FinancialDataPointContinuousBenefitDeleteFieldInput>;
	disconnect?: InputMaybe<FinancialDataPointContinuousBenefitDisconnectFieldInput>;
	update?: InputMaybe<FinancialDataPointContinuousBenefitUpdateConnectionInput>;
	where?: InputMaybe<FinancialDataPointContinuousBenefitConnectionWhere>;
};

export type FinancialDataPointCoverageRequestAggregateInput = {
	AND?: InputMaybe<Array<FinancialDataPointCoverageRequestAggregateInput>>;
	OR?: InputMaybe<Array<FinancialDataPointCoverageRequestAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<FinancialDataPointCoverageRequestNodeAggregationWhereInput>;
};

export type FinancialDataPointCoverageRequestConnectFieldInput = {
	connect?: InputMaybe<CoverageRequestConnectInput>;
	where?: InputMaybe<CoverageRequestConnectWhere>;
};

export type FinancialDataPointCoverageRequestConnection = {
	__typename?: "FinancialDataPointCoverageRequestConnection";
	edges: Array<FinancialDataPointCoverageRequestRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type FinancialDataPointCoverageRequestConnectionSort = {
	node?: InputMaybe<CoverageRequestSort>;
};

export type FinancialDataPointCoverageRequestConnectionWhere = {
	AND?: InputMaybe<Array<FinancialDataPointCoverageRequestConnectionWhere>>;
	OR?: InputMaybe<Array<FinancialDataPointCoverageRequestConnectionWhere>>;
	node?: InputMaybe<CoverageRequestWhere>;
	node_NOT?: InputMaybe<CoverageRequestWhere>;
};

export type FinancialDataPointCoverageRequestCreateFieldInput = {
	node: CoverageRequestCreateInput;
};

export type FinancialDataPointCoverageRequestDeleteFieldInput = {
	delete?: InputMaybe<CoverageRequestDeleteInput>;
	where?: InputMaybe<FinancialDataPointCoverageRequestConnectionWhere>;
};

export type FinancialDataPointCoverageRequestDisconnectFieldInput = {
	disconnect?: InputMaybe<CoverageRequestDisconnectInput>;
	where?: InputMaybe<FinancialDataPointCoverageRequestConnectionWhere>;
};

export type FinancialDataPointCoverageRequestFieldInput = {
	connect?: InputMaybe<FinancialDataPointCoverageRequestConnectFieldInput>;
	create?: InputMaybe<FinancialDataPointCoverageRequestCreateFieldInput>;
};

export type FinancialDataPointCoverageRequestNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<FinancialDataPointCoverageRequestNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<FinancialDataPointCoverageRequestNodeAggregationWhereInput>>;
	createdOn_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	duration_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	duration_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	duration_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	duration_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	duration_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	duration_EQUAL?: InputMaybe<Scalars["Int"]>;
	duration_GT?: InputMaybe<Scalars["Int"]>;
	duration_GTE?: InputMaybe<Scalars["Int"]>;
	duration_LT?: InputMaybe<Scalars["Int"]>;
	duration_LTE?: InputMaybe<Scalars["Int"]>;
	duration_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	duration_MAX_GT?: InputMaybe<Scalars["Int"]>;
	duration_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	duration_MAX_LT?: InputMaybe<Scalars["Int"]>;
	duration_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	duration_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	duration_MIN_GT?: InputMaybe<Scalars["Int"]>;
	duration_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	duration_MIN_LT?: InputMaybe<Scalars["Int"]>;
	duration_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	lastUpdatedOn_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_GT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_LT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_GT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_GTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_LT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_LTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	tenantId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	tenantId_EQUAL?: InputMaybe<Scalars["String"]>;
	tenantId_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type FinancialDataPointCoverageRequestRelationship = {
	__typename?: "FinancialDataPointCoverageRequestRelationship";
	cursor: Scalars["String"];
	node: CoverageRequest;
};

export type FinancialDataPointCoverageRequestUpdateConnectionInput = {
	node?: InputMaybe<CoverageRequestUpdateInput>;
};

export type FinancialDataPointCoverageRequestUpdateFieldInput = {
	connect?: InputMaybe<FinancialDataPointCoverageRequestConnectFieldInput>;
	create?: InputMaybe<FinancialDataPointCoverageRequestCreateFieldInput>;
	delete?: InputMaybe<FinancialDataPointCoverageRequestDeleteFieldInput>;
	disconnect?: InputMaybe<FinancialDataPointCoverageRequestDisconnectFieldInput>;
	update?: InputMaybe<FinancialDataPointCoverageRequestUpdateConnectionInput>;
	where?: InputMaybe<FinancialDataPointCoverageRequestConnectionWhere>;
};

export type FinancialDataPointCreateInput = {
	agreement?: InputMaybe<FinancialDataPointAgreementFieldInput>;
	basePrice?: InputMaybe<Scalars["Float"]>;
	claim?: InputMaybe<FinancialDataPointClaimFieldInput>;
	continuousBenefit?: InputMaybe<FinancialDataPointContinuousBenefitFieldInput>;
	coverageRequest?: InputMaybe<FinancialDataPointCoverageRequestFieldInput>;
	currencyCode?: InputMaybe<Scalars["String"]>;
	date: Scalars["Date"];
	evaluationSnapshot?: InputMaybe<Scalars["String"]>;
	generatedUuid: Scalars["ID"];
	includedIn?: InputMaybe<FinancialDataPointIncludedInFieldInput>;
	intervention?: InputMaybe<FinancialDataPointInterventionFieldInput>;
	isDeleted: Scalars["Boolean"];
	isLast: Scalars["Boolean"];
	payable?: InputMaybe<Scalars["Float"]>;
	payablePercentage?: InputMaybe<Scalars["Float"]>;
	prescriptionDate: Scalars["Date"];
	quantity: Scalars["Float"];
	refundable?: InputMaybe<Scalars["Float"]>;
	refundablePercentage?: InputMaybe<Scalars["Float"]>;
	sourceRefund?: InputMaybe<FinancialDataPointSourceRefundFieldInput>;
	treatment?: InputMaybe<FinancialDataPointTreatmentFieldInput>;
	uuid: Scalars["ID"];
	variable?: InputMaybe<Scalars["Float"]>;
	variablePercentage?: InputMaybe<Scalars["Float"]>;
};

export type FinancialDataPointDeleteInput = {
	agreement?: InputMaybe<FinancialDataPointAgreementDeleteFieldInput>;
	claim?: InputMaybe<FinancialDataPointClaimDeleteFieldInput>;
	continuousBenefit?: InputMaybe<FinancialDataPointContinuousBenefitDeleteFieldInput>;
	coverageRequest?: InputMaybe<FinancialDataPointCoverageRequestDeleteFieldInput>;
	includedIn?: InputMaybe<FinancialDataPointIncludedInDeleteFieldInput>;
	intervention?: InputMaybe<FinancialDataPointInterventionDeleteFieldInput>;
	sourceRefund?: InputMaybe<FinancialDataPointSourceRefundDeleteFieldInput>;
	treatment?: InputMaybe<FinancialDataPointTreatmentDeleteFieldInput>;
};

export type FinancialDataPointDisconnectInput = {
	agreement?: InputMaybe<FinancialDataPointAgreementDisconnectFieldInput>;
	claim?: InputMaybe<FinancialDataPointClaimDisconnectFieldInput>;
	continuousBenefit?: InputMaybe<FinancialDataPointContinuousBenefitDisconnectFieldInput>;
	coverageRequest?: InputMaybe<FinancialDataPointCoverageRequestDisconnectFieldInput>;
	includedIn?: InputMaybe<FinancialDataPointIncludedInDisconnectFieldInput>;
	intervention?: InputMaybe<FinancialDataPointInterventionDisconnectFieldInput>;
	sourceRefund?: InputMaybe<FinancialDataPointSourceRefundDisconnectFieldInput>;
	treatment?: InputMaybe<FinancialDataPointTreatmentDisconnectFieldInput>;
};

export type FinancialDataPointIncludedInAggregateInput = {
	AND?: InputMaybe<Array<FinancialDataPointIncludedInAggregateInput>>;
	OR?: InputMaybe<Array<FinancialDataPointIncludedInAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<FinancialDataPointIncludedInNodeAggregationWhereInput>;
};

export type FinancialDataPointIncludedInConnectFieldInput = {
	connect?: InputMaybe<CaseConnectInput>;
	where?: InputMaybe<CaseConnectWhere>;
};

export type FinancialDataPointIncludedInConnection = {
	__typename?: "FinancialDataPointIncludedInConnection";
	edges: Array<FinancialDataPointIncludedInRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type FinancialDataPointIncludedInConnectionSort = {
	node?: InputMaybe<CaseSort>;
};

export type FinancialDataPointIncludedInConnectionWhere = {
	AND?: InputMaybe<Array<FinancialDataPointIncludedInConnectionWhere>>;
	OR?: InputMaybe<Array<FinancialDataPointIncludedInConnectionWhere>>;
	node?: InputMaybe<CaseWhere>;
	node_NOT?: InputMaybe<CaseWhere>;
};

export type FinancialDataPointIncludedInCreateFieldInput = {
	node: CaseCreateInput;
};

export type FinancialDataPointIncludedInDeleteFieldInput = {
	delete?: InputMaybe<CaseDeleteInput>;
	where?: InputMaybe<FinancialDataPointIncludedInConnectionWhere>;
};

export type FinancialDataPointIncludedInDisconnectFieldInput = {
	disconnect?: InputMaybe<CaseDisconnectInput>;
	where?: InputMaybe<FinancialDataPointIncludedInConnectionWhere>;
};

export type FinancialDataPointIncludedInFieldInput = {
	connect?: InputMaybe<FinancialDataPointIncludedInConnectFieldInput>;
	create?: InputMaybe<FinancialDataPointIncludedInCreateFieldInput>;
};

export type FinancialDataPointIncludedInNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<FinancialDataPointIncludedInNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<FinancialDataPointIncludedInNodeAggregationWhereInput>>;
	actualAgreementId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	actualAgreementId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	actualAgreementId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	actualAgreementId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	actualAgreementId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	actualAgreementId_EQUAL?: InputMaybe<Scalars["String"]>;
	actualAgreementId_GT?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_GTE?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_LT?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_LTE?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	agreementName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	agreementName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	agreementName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	agreementName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	agreementName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	agreementName_EQUAL?: InputMaybe<Scalars["String"]>;
	agreementName_GT?: InputMaybe<Scalars["Int"]>;
	agreementName_GTE?: InputMaybe<Scalars["Int"]>;
	agreementName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	agreementName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	agreementName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	agreementName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	agreementName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	agreementName_LT?: InputMaybe<Scalars["Int"]>;
	agreementName_LTE?: InputMaybe<Scalars["Int"]>;
	agreementName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	agreementName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	agreementName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	agreementName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	agreementName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	patientInitials_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	patientInitials_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	patientInitials_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	patientInitials_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	patientInitials_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	patientInitials_EQUAL?: InputMaybe<Scalars["String"]>;
	patientInitials_GT?: InputMaybe<Scalars["Int"]>;
	patientInitials_GTE?: InputMaybe<Scalars["Int"]>;
	patientInitials_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	patientInitials_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	patientInitials_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	patientInitials_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	patientInitials_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	patientInitials_LT?: InputMaybe<Scalars["Int"]>;
	patientInitials_LTE?: InputMaybe<Scalars["Int"]>;
	patientInitials_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	patientInitials_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	patientInitials_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	patientInitials_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	patientInitials_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	patientInsuranceId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	patientInsuranceId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	patientInsuranceId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	patientInsuranceId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	patientInsuranceId_EQUAL?: InputMaybe<Scalars["String"]>;
	patientInsuranceId_GT?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_GTE?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_LT?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_LTE?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationBandName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	preparationBandName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	preparationBandName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	preparationBandName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	preparationBandName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	preparationBandName_EQUAL?: InputMaybe<Scalars["String"]>;
	preparationBandName_GT?: InputMaybe<Scalars["Int"]>;
	preparationBandName_GTE?: InputMaybe<Scalars["Int"]>;
	preparationBandName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationBandName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationBandName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationBandName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationBandName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationBandName_LT?: InputMaybe<Scalars["Int"]>;
	preparationBandName_LTE?: InputMaybe<Scalars["Int"]>;
	preparationBandName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationBandName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationBandName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationBandName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationBandName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	preparationGenericName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	preparationGenericName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	preparationGenericName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	preparationGenericName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	preparationGenericName_EQUAL?: InputMaybe<Scalars["String"]>;
	preparationGenericName_GT?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_GTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_LT?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_LTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	sourceTenantId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	sourceTenantId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	sourceTenantId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	sourceTenantId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	sourceTenantId_EQUAL?: InputMaybe<Scalars["String"]>;
	sourceTenantId_GT?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_GTE?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_LT?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_LTE?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	submissionDate_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_GT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_GTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_LT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_LTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	totalAmount_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	totalAmount_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	totalAmount_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	totalAmount_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	totalAmount_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	totalAmount_EQUAL?: InputMaybe<Scalars["Float"]>;
	totalAmount_GT?: InputMaybe<Scalars["Float"]>;
	totalAmount_GTE?: InputMaybe<Scalars["Float"]>;
	totalAmount_LT?: InputMaybe<Scalars["Float"]>;
	totalAmount_LTE?: InputMaybe<Scalars["Float"]>;
	totalAmount_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	totalAmount_MAX_GT?: InputMaybe<Scalars["Float"]>;
	totalAmount_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	totalAmount_MAX_LT?: InputMaybe<Scalars["Float"]>;
	totalAmount_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	totalAmount_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	totalAmount_MIN_GT?: InputMaybe<Scalars["Float"]>;
	totalAmount_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	totalAmount_MIN_LT?: InputMaybe<Scalars["Float"]>;
	totalAmount_MIN_LTE?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	unlimited_EQUAL?: InputMaybe<Scalars["Int"]>;
	unlimited_GT?: InputMaybe<Scalars["Int"]>;
	unlimited_GTE?: InputMaybe<Scalars["Int"]>;
	unlimited_LT?: InputMaybe<Scalars["Int"]>;
	unlimited_LTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_GT?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_LT?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_GT?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_LT?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_LTE?: InputMaybe<Scalars["Int"]>;
};

export type FinancialDataPointIncludedInRelationship = {
	__typename?: "FinancialDataPointIncludedInRelationship";
	cursor: Scalars["String"];
	node: Case;
};

export type FinancialDataPointIncludedInUpdateConnectionInput = {
	node?: InputMaybe<CaseUpdateInput>;
};

export type FinancialDataPointIncludedInUpdateFieldInput = {
	connect?: InputMaybe<FinancialDataPointIncludedInConnectFieldInput>;
	create?: InputMaybe<FinancialDataPointIncludedInCreateFieldInput>;
	delete?: InputMaybe<FinancialDataPointIncludedInDeleteFieldInput>;
	disconnect?: InputMaybe<FinancialDataPointIncludedInDisconnectFieldInput>;
	update?: InputMaybe<FinancialDataPointIncludedInUpdateConnectionInput>;
	where?: InputMaybe<FinancialDataPointIncludedInConnectionWhere>;
};

export type FinancialDataPointInput = {
	amount?: InputMaybe<Scalars["Int"]>;
	caseId: Scalars["ID"];
	refundId: Scalars["ID"];
	status?: InputMaybe<FinancialDataPointStatus>;
	uuid: Scalars["String"];
};

export type FinancialDataPointInterventionAggregateInput = {
	AND?: InputMaybe<Array<FinancialDataPointInterventionAggregateInput>>;
	OR?: InputMaybe<Array<FinancialDataPointInterventionAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<FinancialDataPointInterventionNodeAggregationWhereInput>;
};

export type FinancialDataPointInterventionConnectFieldInput = {
	connect?: InputMaybe<InterventionConnectInput>;
	where?: InputMaybe<InterventionConnectWhere>;
};

export type FinancialDataPointInterventionConnection = {
	__typename?: "FinancialDataPointInterventionConnection";
	edges: Array<FinancialDataPointInterventionRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type FinancialDataPointInterventionConnectionSort = {
	node?: InputMaybe<InterventionSort>;
};

export type FinancialDataPointInterventionConnectionWhere = {
	AND?: InputMaybe<Array<FinancialDataPointInterventionConnectionWhere>>;
	OR?: InputMaybe<Array<FinancialDataPointInterventionConnectionWhere>>;
	node?: InputMaybe<InterventionWhere>;
	node_NOT?: InputMaybe<InterventionWhere>;
};

export type FinancialDataPointInterventionCreateFieldInput = {
	node: InterventionCreateInput;
};

export type FinancialDataPointInterventionDeleteFieldInput = {
	delete?: InputMaybe<InterventionDeleteInput>;
	where?: InputMaybe<FinancialDataPointInterventionConnectionWhere>;
};

export type FinancialDataPointInterventionDisconnectFieldInput = {
	disconnect?: InputMaybe<InterventionDisconnectInput>;
	where?: InputMaybe<FinancialDataPointInterventionConnectionWhere>;
};

export type FinancialDataPointInterventionFieldInput = {
	connect?: InputMaybe<FinancialDataPointInterventionConnectFieldInput>;
	create?: InputMaybe<FinancialDataPointInterventionCreateFieldInput>;
};

export type FinancialDataPointInterventionNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<FinancialDataPointInterventionNodeAggregationWhereInput>>;
	LAPressure_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	LAPressure_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	LAPressure_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	LAPressure_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	LAPressure_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	LAPressure_EQUAL?: InputMaybe<Scalars["Int"]>;
	LAPressure_GT?: InputMaybe<Scalars["Int"]>;
	LAPressure_GTE?: InputMaybe<Scalars["Int"]>;
	LAPressure_LT?: InputMaybe<Scalars["Int"]>;
	LAPressure_LTE?: InputMaybe<Scalars["Int"]>;
	LAPressure_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	LAPressure_MAX_GT?: InputMaybe<Scalars["Int"]>;
	LAPressure_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	LAPressure_MAX_LT?: InputMaybe<Scalars["Int"]>;
	LAPressure_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	LAPressure_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	LAPressure_MIN_GT?: InputMaybe<Scalars["Int"]>;
	LAPressure_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	LAPressure_MIN_LT?: InputMaybe<Scalars["Int"]>;
	LAPressure_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	LAVolume_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	LAVolume_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	LAVolume_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	LAVolume_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	LAVolume_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	LAVolume_EQUAL?: InputMaybe<Scalars["Int"]>;
	LAVolume_GT?: InputMaybe<Scalars["Int"]>;
	LAVolume_GTE?: InputMaybe<Scalars["Int"]>;
	LAVolume_LT?: InputMaybe<Scalars["Int"]>;
	LAVolume_LTE?: InputMaybe<Scalars["Int"]>;
	LAVolume_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	LAVolume_MAX_GT?: InputMaybe<Scalars["Int"]>;
	LAVolume_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	LAVolume_MAX_LT?: InputMaybe<Scalars["Int"]>;
	LAVolume_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	LAVolume_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	LAVolume_MIN_GT?: InputMaybe<Scalars["Int"]>;
	LAVolume_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	LAVolume_MIN_LT?: InputMaybe<Scalars["Int"]>;
	LAVolume_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	OR?: InputMaybe<Array<FinancialDataPointInterventionNodeAggregationWhereInput>>;
	createdOn_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	lastUpdatedOn_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_GT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_LT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_GT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_GTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_LT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_LTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	tenantId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	tenantId_EQUAL?: InputMaybe<Scalars["String"]>;
	tenantId_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type FinancialDataPointInterventionRelationship = {
	__typename?: "FinancialDataPointInterventionRelationship";
	cursor: Scalars["String"];
	node: Intervention;
};

export type FinancialDataPointInterventionUpdateConnectionInput = {
	node?: InputMaybe<InterventionUpdateInput>;
};

export type FinancialDataPointInterventionUpdateFieldInput = {
	connect?: InputMaybe<FinancialDataPointInterventionConnectFieldInput>;
	create?: InputMaybe<FinancialDataPointInterventionCreateFieldInput>;
	delete?: InputMaybe<FinancialDataPointInterventionDeleteFieldInput>;
	disconnect?: InputMaybe<FinancialDataPointInterventionDisconnectFieldInput>;
	update?: InputMaybe<FinancialDataPointInterventionUpdateConnectionInput>;
	where?: InputMaybe<FinancialDataPointInterventionConnectionWhere>;
};

export type FinancialDataPointOptions = {
	limit?: InputMaybe<Scalars["Int"]>;
	offset?: InputMaybe<Scalars["Int"]>;
	/** Specify one or more FinancialDataPointSort objects to sort FinancialDataPoints by. The sorts will be applied in the order in which they are arranged in the array. */
	sort?: InputMaybe<Array<InputMaybe<FinancialDataPointSort>>>;
};

/** Fields to sort FinancialDataPoints by. The order in which sorts are applied is not guaranteed when specifying many fields in one FinancialDataPointSort object. */
export type FinancialDataPointSort = {
	basePrice?: InputMaybe<SortDirection>;
	currencyCode?: InputMaybe<SortDirection>;
	date?: InputMaybe<SortDirection>;
	evaluationSnapshot?: InputMaybe<SortDirection>;
	generatedUuid?: InputMaybe<SortDirection>;
	isDeleted?: InputMaybe<SortDirection>;
	isLast?: InputMaybe<SortDirection>;
	payable?: InputMaybe<SortDirection>;
	payablePercentage?: InputMaybe<SortDirection>;
	prescriptionDate?: InputMaybe<SortDirection>;
	quantity?: InputMaybe<SortDirection>;
	refundable?: InputMaybe<SortDirection>;
	refundablePercentage?: InputMaybe<SortDirection>;
	uuid?: InputMaybe<SortDirection>;
	variable?: InputMaybe<SortDirection>;
	variablePercentage?: InputMaybe<SortDirection>;
};

export type FinancialDataPointSourceRefundAggregateInput = {
	AND?: InputMaybe<Array<FinancialDataPointSourceRefundAggregateInput>>;
	OR?: InputMaybe<Array<FinancialDataPointSourceRefundAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<FinancialDataPointSourceRefundNodeAggregationWhereInput>;
};

export type FinancialDataPointSourceRefundConnectFieldInput = {
	connect?: InputMaybe<RefundConnectInput>;
	where?: InputMaybe<RefundConnectWhere>;
};

export type FinancialDataPointSourceRefundConnection = {
	__typename?: "FinancialDataPointSourceRefundConnection";
	edges: Array<FinancialDataPointSourceRefundRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type FinancialDataPointSourceRefundConnectionSort = {
	node?: InputMaybe<RefundSort>;
};

export type FinancialDataPointSourceRefundConnectionWhere = {
	AND?: InputMaybe<Array<FinancialDataPointSourceRefundConnectionWhere>>;
	OR?: InputMaybe<Array<FinancialDataPointSourceRefundConnectionWhere>>;
	node?: InputMaybe<RefundWhere>;
	node_NOT?: InputMaybe<RefundWhere>;
};

export type FinancialDataPointSourceRefundCreateFieldInput = {
	node: RefundCreateInput;
};

export type FinancialDataPointSourceRefundDeleteFieldInput = {
	delete?: InputMaybe<RefundDeleteInput>;
	where?: InputMaybe<FinancialDataPointSourceRefundConnectionWhere>;
};

export type FinancialDataPointSourceRefundDisconnectFieldInput = {
	disconnect?: InputMaybe<RefundDisconnectInput>;
	where?: InputMaybe<FinancialDataPointSourceRefundConnectionWhere>;
};

export type FinancialDataPointSourceRefundFieldInput = {
	connect?: InputMaybe<FinancialDataPointSourceRefundConnectFieldInput>;
	create?: InputMaybe<FinancialDataPointSourceRefundCreateFieldInput>;
};

export type FinancialDataPointSourceRefundNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<FinancialDataPointSourceRefundNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<FinancialDataPointSourceRefundNodeAggregationWhereInput>>;
	agreementName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	agreementName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	agreementName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	agreementName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	agreementName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	agreementName_EQUAL?: InputMaybe<Scalars["String"]>;
	agreementName_GT?: InputMaybe<Scalars["Int"]>;
	agreementName_GTE?: InputMaybe<Scalars["Int"]>;
	agreementName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	agreementName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	agreementName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	agreementName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	agreementName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	agreementName_LT?: InputMaybe<Scalars["Int"]>;
	agreementName_LTE?: InputMaybe<Scalars["Int"]>;
	agreementName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	agreementName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	agreementName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	agreementName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	agreementName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	amount_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	amount_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	amount_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	amount_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	amount_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	amount_EQUAL?: InputMaybe<Scalars["Float"]>;
	amount_GT?: InputMaybe<Scalars["Float"]>;
	amount_GTE?: InputMaybe<Scalars["Float"]>;
	amount_LT?: InputMaybe<Scalars["Float"]>;
	amount_LTE?: InputMaybe<Scalars["Float"]>;
	amount_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	amount_MAX_GT?: InputMaybe<Scalars["Float"]>;
	amount_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	amount_MAX_LT?: InputMaybe<Scalars["Float"]>;
	amount_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	amount_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	amount_MIN_GT?: InputMaybe<Scalars["Float"]>;
	amount_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	amount_MIN_LT?: InputMaybe<Scalars["Float"]>;
	amount_MIN_LTE?: InputMaybe<Scalars["Float"]>;
	caseId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	caseId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	caseId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	caseId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	caseId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	caseId_EQUAL?: InputMaybe<Scalars["String"]>;
	caseId_GT?: InputMaybe<Scalars["Int"]>;
	caseId_GTE?: InputMaybe<Scalars["Int"]>;
	caseId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	caseId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	caseId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	caseId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	caseId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	caseId_LT?: InputMaybe<Scalars["Int"]>;
	caseId_LTE?: InputMaybe<Scalars["Int"]>;
	caseId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	caseId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	caseId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	caseId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	caseId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	counterParties_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	counterParties_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	counterParties_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	counterParties_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	counterParties_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	counterParties_EQUAL?: InputMaybe<Scalars["String"]>;
	counterParties_GT?: InputMaybe<Scalars["Int"]>;
	counterParties_GTE?: InputMaybe<Scalars["Int"]>;
	counterParties_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	counterParties_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	counterParties_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	counterParties_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	counterParties_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	counterParties_LT?: InputMaybe<Scalars["Int"]>;
	counterParties_LTE?: InputMaybe<Scalars["Int"]>;
	counterParties_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	counterParties_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	counterParties_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	counterParties_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	counterParties_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	currency_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	currency_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	currency_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	currency_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	currency_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	currency_EQUAL?: InputMaybe<Scalars["String"]>;
	currency_GT?: InputMaybe<Scalars["Int"]>;
	currency_GTE?: InputMaybe<Scalars["Int"]>;
	currency_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	currency_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	currency_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	currency_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	currency_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	currency_LT?: InputMaybe<Scalars["Int"]>;
	currency_LTE?: InputMaybe<Scalars["Int"]>;
	currency_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	currency_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	currency_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	currency_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	currency_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	formattedTags_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	formattedTags_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	formattedTags_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	formattedTags_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	formattedTags_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	formattedTags_EQUAL?: InputMaybe<Scalars["String"]>;
	formattedTags_GT?: InputMaybe<Scalars["Int"]>;
	formattedTags_GTE?: InputMaybe<Scalars["Int"]>;
	formattedTags_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedTags_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedTags_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedTags_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedTags_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	formattedTags_LT?: InputMaybe<Scalars["Int"]>;
	formattedTags_LTE?: InputMaybe<Scalars["Int"]>;
	formattedTags_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedTags_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedTags_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedTags_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedTags_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	iin_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	iin_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	iin_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	iin_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	iin_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	iin_EQUAL?: InputMaybe<Scalars["String"]>;
	iin_GT?: InputMaybe<Scalars["Int"]>;
	iin_GTE?: InputMaybe<Scalars["Int"]>;
	iin_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	iin_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	iin_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	iin_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	iin_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	iin_LT?: InputMaybe<Scalars["Int"]>;
	iin_LTE?: InputMaybe<Scalars["Int"]>;
	iin_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	iin_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	iin_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	iin_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	iin_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	product_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	product_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	product_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	product_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	product_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	product_EQUAL?: InputMaybe<Scalars["String"]>;
	product_GT?: InputMaybe<Scalars["Int"]>;
	product_GTE?: InputMaybe<Scalars["Int"]>;
	product_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	product_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	product_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	product_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	product_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	product_LT?: InputMaybe<Scalars["Int"]>;
	product_LTE?: InputMaybe<Scalars["Int"]>;
	product_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	product_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	product_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	product_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	product_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	unlimited_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	unlimited_EQUAL?: InputMaybe<Scalars["Int"]>;
	unlimited_GT?: InputMaybe<Scalars["Int"]>;
	unlimited_GTE?: InputMaybe<Scalars["Int"]>;
	unlimited_LT?: InputMaybe<Scalars["Int"]>;
	unlimited_LTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_GT?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_LT?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_GT?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_LT?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_LTE?: InputMaybe<Scalars["Int"]>;
};

export type FinancialDataPointSourceRefundRelationship = {
	__typename?: "FinancialDataPointSourceRefundRelationship";
	cursor: Scalars["String"];
	node: Refund;
};

export type FinancialDataPointSourceRefundUpdateConnectionInput = {
	node?: InputMaybe<RefundUpdateInput>;
};

export type FinancialDataPointSourceRefundUpdateFieldInput = {
	connect?: InputMaybe<FinancialDataPointSourceRefundConnectFieldInput>;
	create?: InputMaybe<FinancialDataPointSourceRefundCreateFieldInput>;
	delete?: InputMaybe<FinancialDataPointSourceRefundDeleteFieldInput>;
	disconnect?: InputMaybe<FinancialDataPointSourceRefundDisconnectFieldInput>;
	update?: InputMaybe<FinancialDataPointSourceRefundUpdateConnectionInput>;
	where?: InputMaybe<FinancialDataPointSourceRefundConnectionWhere>;
};

export enum FinancialDataPointStatus {
	Approved = "APPROVED",
	Declined = "DECLINED",
	Removed = "REMOVED",
	Undecided = "UNDECIDED",
}

export type FinancialDataPointTreatmentAggregateInput = {
	AND?: InputMaybe<Array<FinancialDataPointTreatmentAggregateInput>>;
	OR?: InputMaybe<Array<FinancialDataPointTreatmentAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<FinancialDataPointTreatmentNodeAggregationWhereInput>;
};

export type FinancialDataPointTreatmentConnectFieldInput = {
	connect?: InputMaybe<TreatmentConnectInput>;
	where?: InputMaybe<TreatmentConnectWhere>;
};

export type FinancialDataPointTreatmentConnection = {
	__typename?: "FinancialDataPointTreatmentConnection";
	edges: Array<FinancialDataPointTreatmentRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type FinancialDataPointTreatmentConnectionSort = {
	node?: InputMaybe<TreatmentSort>;
};

export type FinancialDataPointTreatmentConnectionWhere = {
	AND?: InputMaybe<Array<FinancialDataPointTreatmentConnectionWhere>>;
	OR?: InputMaybe<Array<FinancialDataPointTreatmentConnectionWhere>>;
	node?: InputMaybe<TreatmentWhere>;
	node_NOT?: InputMaybe<TreatmentWhere>;
};

export type FinancialDataPointTreatmentCreateFieldInput = {
	node: TreatmentCreateInput;
};

export type FinancialDataPointTreatmentDeleteFieldInput = {
	delete?: InputMaybe<TreatmentDeleteInput>;
	where?: InputMaybe<FinancialDataPointTreatmentConnectionWhere>;
};

export type FinancialDataPointTreatmentDisconnectFieldInput = {
	disconnect?: InputMaybe<TreatmentDisconnectInput>;
	where?: InputMaybe<FinancialDataPointTreatmentConnectionWhere>;
};

export type FinancialDataPointTreatmentFieldInput = {
	connect?: InputMaybe<FinancialDataPointTreatmentConnectFieldInput>;
	create?: InputMaybe<FinancialDataPointTreatmentCreateFieldInput>;
};

export type FinancialDataPointTreatmentNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<FinancialDataPointTreatmentNodeAggregationWhereInput>>;
	BagDossierNo_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	BagDossierNo_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	BagDossierNo_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	BagDossierNo_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	BagDossierNo_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	BagDossierNo_EQUAL?: InputMaybe<Scalars["String"]>;
	BagDossierNo_GT?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_GTE?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LT?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LTE?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	Code_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	Code_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	Code_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	Code_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	Code_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	Code_EQUAL?: InputMaybe<Scalars["String"]>;
	Code_GT?: InputMaybe<Scalars["Int"]>;
	Code_GTE?: InputMaybe<Scalars["Int"]>;
	Code_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Code_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	Code_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	Code_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	Code_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	Code_LT?: InputMaybe<Scalars["Int"]>;
	Code_LTE?: InputMaybe<Scalars["Int"]>;
	Code_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Code_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	Code_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	Code_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	Code_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	FlagModal_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	FlagModal_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	FlagModal_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	FlagModal_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	FlagModal_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	FlagModal_EQUAL?: InputMaybe<Scalars["String"]>;
	FlagModal_GT?: InputMaybe<Scalars["Int"]>;
	FlagModal_GTE?: InputMaybe<Scalars["Int"]>;
	FlagModal_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	FlagModal_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	FlagModal_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	FlagModal_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	FlagModal_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	FlagModal_LT?: InputMaybe<Scalars["Int"]>;
	FlagModal_LTE?: InputMaybe<Scalars["Int"]>;
	FlagModal_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	FlagModal_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	FlagModal_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	FlagModal_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	FlagModal_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	FlagNarcosis_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	FlagNarcosis_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	FlagNarcosis_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	FlagNarcosis_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	FlagNarcosis_EQUAL?: InputMaybe<Scalars["String"]>;
	FlagNarcosis_GT?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_GTE?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LT?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LTE?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	GTIN_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	GTIN_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	GTIN_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	GTIN_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	GTIN_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	GTIN_EQUAL?: InputMaybe<Scalars["String"]>;
	GTIN_GT?: InputMaybe<Scalars["Int"]>;
	GTIN_GTE?: InputMaybe<Scalars["Int"]>;
	GTIN_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	GTIN_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	GTIN_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	GTIN_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	GTIN_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	GTIN_LT?: InputMaybe<Scalars["Int"]>;
	GTIN_LTE?: InputMaybe<Scalars["Int"]>;
	GTIN_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	GTIN_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	GTIN_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	GTIN_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	GTIN_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	LOT_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	LOT_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	LOT_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	LOT_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	LOT_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	LOT_EQUAL?: InputMaybe<Scalars["String"]>;
	LOT_GT?: InputMaybe<Scalars["Int"]>;
	LOT_GTE?: InputMaybe<Scalars["Int"]>;
	LOT_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	LOT_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	LOT_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	LOT_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	LOT_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	LOT_LT?: InputMaybe<Scalars["Int"]>;
	LOT_LTE?: InputMaybe<Scalars["Int"]>;
	LOT_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	LOT_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	LOT_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	LOT_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	LOT_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	Name_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	Name_EQUAL?: InputMaybe<Scalars["String"]>;
	Name_GT?: InputMaybe<Scalars["Int"]>;
	Name_GTE?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	Name_LT?: InputMaybe<Scalars["Int"]>;
	Name_LTE?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	OR?: InputMaybe<Array<FinancialDataPointTreatmentNodeAggregationWhereInput>>;
	PharmaCode_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	PharmaCode_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	PharmaCode_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	PharmaCode_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	PharmaCode_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	PharmaCode_EQUAL?: InputMaybe<Scalars["String"]>;
	PharmaCode_GT?: InputMaybe<Scalars["Int"]>;
	PharmaCode_GTE?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LT?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LTE?: InputMaybe<Scalars["Int"]>;
	PharmaCode_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	PharmaCode_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	PharmaCode_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	PharmaCode_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	PharmaCode_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	PrevPharmacode_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	PrevPharmacode_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	PrevPharmacode_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	PrevPharmacode_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	PrevPharmacode_EQUAL?: InputMaybe<Scalars["String"]>;
	PrevPharmacode_GT?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_GTE?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LT?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LTE?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	REF_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	REF_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	REF_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	REF_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	REF_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	REF_EQUAL?: InputMaybe<Scalars["String"]>;
	REF_GT?: InputMaybe<Scalars["Int"]>;
	REF_GTE?: InputMaybe<Scalars["Int"]>;
	REF_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	REF_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	REF_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	REF_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	REF_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	REF_LT?: InputMaybe<Scalars["Int"]>;
	REF_LTE?: InputMaybe<Scalars["Int"]>;
	REF_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	REF_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	REF_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	REF_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	REF_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	SwissmedicCategory_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	SwissmedicCategory_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	SwissmedicCategory_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	SwissmedicCategory_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	SwissmedicCategory_EQUAL?: InputMaybe<Scalars["String"]>;
	SwissmedicCategory_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo8_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo8_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo8_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo8_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo8_EQUAL?: InputMaybe<Scalars["String"]>;
	SwissmedicNo8_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	UDI_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	UDI_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	UDI_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	UDI_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	UDI_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	UDI_EQUAL?: InputMaybe<Scalars["String"]>;
	UDI_GT?: InputMaybe<Scalars["Int"]>;
	UDI_GTE?: InputMaybe<Scalars["Int"]>;
	UDI_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	UDI_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	UDI_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	UDI_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	UDI_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	UDI_LT?: InputMaybe<Scalars["Int"]>;
	UDI_LTE?: InputMaybe<Scalars["Int"]>;
	UDI_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	UDI_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	UDI_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	UDI_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	UDI_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	classificationSystem_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	classificationSystem_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	classificationSystem_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	classificationSystem_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	classificationSystem_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	classificationSystem_EQUAL?: InputMaybe<Scalars["String"]>;
	classificationSystem_GT?: InputMaybe<Scalars["Int"]>;
	classificationSystem_GTE?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LT?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LTE?: InputMaybe<Scalars["Int"]>;
	classificationSystem_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	classificationSystem_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	classificationSystem_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	classificationSystem_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	classificationSystem_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type FinancialDataPointTreatmentRelationship = {
	__typename?: "FinancialDataPointTreatmentRelationship";
	cursor: Scalars["String"];
	node: Treatment;
};

export type FinancialDataPointTreatmentUpdateConnectionInput = {
	node?: InputMaybe<TreatmentUpdateInput>;
};

export type FinancialDataPointTreatmentUpdateFieldInput = {
	connect?: InputMaybe<FinancialDataPointTreatmentConnectFieldInput>;
	create?: InputMaybe<FinancialDataPointTreatmentCreateFieldInput>;
	delete?: InputMaybe<FinancialDataPointTreatmentDeleteFieldInput>;
	disconnect?: InputMaybe<FinancialDataPointTreatmentDisconnectFieldInput>;
	update?: InputMaybe<FinancialDataPointTreatmentUpdateConnectionInput>;
	where?: InputMaybe<FinancialDataPointTreatmentConnectionWhere>;
};

export type FinancialDataPointUpdateInput = {
	agreement?: InputMaybe<FinancialDataPointAgreementUpdateFieldInput>;
	basePrice?: InputMaybe<Scalars["Float"]>;
	claim?: InputMaybe<FinancialDataPointClaimUpdateFieldInput>;
	continuousBenefit?: InputMaybe<FinancialDataPointContinuousBenefitUpdateFieldInput>;
	coverageRequest?: InputMaybe<FinancialDataPointCoverageRequestUpdateFieldInput>;
	currencyCode?: InputMaybe<Scalars["String"]>;
	date?: InputMaybe<Scalars["Date"]>;
	evaluationSnapshot?: InputMaybe<Scalars["String"]>;
	generatedUuid?: InputMaybe<Scalars["ID"]>;
	includedIn?: InputMaybe<FinancialDataPointIncludedInUpdateFieldInput>;
	intervention?: InputMaybe<FinancialDataPointInterventionUpdateFieldInput>;
	isDeleted?: InputMaybe<Scalars["Boolean"]>;
	isLast?: InputMaybe<Scalars["Boolean"]>;
	payable?: InputMaybe<Scalars["Float"]>;
	payablePercentage?: InputMaybe<Scalars["Float"]>;
	prescriptionDate?: InputMaybe<Scalars["Date"]>;
	quantity?: InputMaybe<Scalars["Float"]>;
	refundable?: InputMaybe<Scalars["Float"]>;
	refundablePercentage?: InputMaybe<Scalars["Float"]>;
	sourceRefund?: InputMaybe<FinancialDataPointSourceRefundUpdateFieldInput>;
	treatment?: InputMaybe<FinancialDataPointTreatmentUpdateFieldInput>;
	uuid?: InputMaybe<Scalars["ID"]>;
	variable?: InputMaybe<Scalars["Float"]>;
	variablePercentage?: InputMaybe<Scalars["Float"]>;
};

export type FinancialDataPointWhere = {
	AND?: InputMaybe<Array<FinancialDataPointWhere>>;
	OR?: InputMaybe<Array<FinancialDataPointWhere>>;
	agreement?: InputMaybe<AgreementWhere>;
	agreementAggregate?: InputMaybe<FinancialDataPointAgreementAggregateInput>;
	agreementConnection?: InputMaybe<FinancialDataPointAgreementConnectionWhere>;
	agreementConnection_NOT?: InputMaybe<FinancialDataPointAgreementConnectionWhere>;
	agreement_NOT?: InputMaybe<AgreementWhere>;
	basePrice?: InputMaybe<Scalars["Float"]>;
	basePrice_GT?: InputMaybe<Scalars["Float"]>;
	basePrice_GTE?: InputMaybe<Scalars["Float"]>;
	basePrice_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	basePrice_LT?: InputMaybe<Scalars["Float"]>;
	basePrice_LTE?: InputMaybe<Scalars["Float"]>;
	basePrice_NOT?: InputMaybe<Scalars["Float"]>;
	basePrice_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	claim?: InputMaybe<ClaimWhere>;
	claimAggregate?: InputMaybe<FinancialDataPointClaimAggregateInput>;
	claimConnection?: InputMaybe<FinancialDataPointClaimConnectionWhere>;
	claimConnection_NOT?: InputMaybe<FinancialDataPointClaimConnectionWhere>;
	claim_NOT?: InputMaybe<ClaimWhere>;
	continuousBenefit?: InputMaybe<ContinuousBenefitWhere>;
	continuousBenefitAggregate?: InputMaybe<FinancialDataPointContinuousBenefitAggregateInput>;
	continuousBenefitConnection?: InputMaybe<FinancialDataPointContinuousBenefitConnectionWhere>;
	continuousBenefitConnection_NOT?: InputMaybe<FinancialDataPointContinuousBenefitConnectionWhere>;
	continuousBenefit_NOT?: InputMaybe<ContinuousBenefitWhere>;
	coverageRequest?: InputMaybe<CoverageRequestWhere>;
	coverageRequestAggregate?: InputMaybe<FinancialDataPointCoverageRequestAggregateInput>;
	coverageRequestConnection?: InputMaybe<FinancialDataPointCoverageRequestConnectionWhere>;
	coverageRequestConnection_NOT?: InputMaybe<FinancialDataPointCoverageRequestConnectionWhere>;
	coverageRequest_NOT?: InputMaybe<CoverageRequestWhere>;
	currencyCode?: InputMaybe<Scalars["String"]>;
	currencyCode_CONTAINS?: InputMaybe<Scalars["String"]>;
	currencyCode_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	currencyCode_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	currencyCode_MATCHES?: InputMaybe<Scalars["String"]>;
	currencyCode_NOT?: InputMaybe<Scalars["String"]>;
	currencyCode_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	currencyCode_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	currencyCode_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	currencyCode_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	currencyCode_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	date?: InputMaybe<Scalars["Date"]>;
	date_GT?: InputMaybe<Scalars["Date"]>;
	date_GTE?: InputMaybe<Scalars["Date"]>;
	date_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
	date_LT?: InputMaybe<Scalars["Date"]>;
	date_LTE?: InputMaybe<Scalars["Date"]>;
	date_NOT?: InputMaybe<Scalars["Date"]>;
	date_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
	evaluationSnapshot?: InputMaybe<Scalars["String"]>;
	evaluationSnapshot_CONTAINS?: InputMaybe<Scalars["String"]>;
	evaluationSnapshot_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	evaluationSnapshot_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	evaluationSnapshot_MATCHES?: InputMaybe<Scalars["String"]>;
	evaluationSnapshot_NOT?: InputMaybe<Scalars["String"]>;
	evaluationSnapshot_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	evaluationSnapshot_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	evaluationSnapshot_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	evaluationSnapshot_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	evaluationSnapshot_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	generatedUuid?: InputMaybe<Scalars["ID"]>;
	generatedUuid_CONTAINS?: InputMaybe<Scalars["ID"]>;
	generatedUuid_ENDS_WITH?: InputMaybe<Scalars["ID"]>;
	generatedUuid_IN?: InputMaybe<Array<InputMaybe<Scalars["ID"]>>>;
	generatedUuid_MATCHES?: InputMaybe<Scalars["String"]>;
	generatedUuid_NOT?: InputMaybe<Scalars["ID"]>;
	generatedUuid_NOT_CONTAINS?: InputMaybe<Scalars["ID"]>;
	generatedUuid_NOT_ENDS_WITH?: InputMaybe<Scalars["ID"]>;
	generatedUuid_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["ID"]>>>;
	generatedUuid_NOT_STARTS_WITH?: InputMaybe<Scalars["ID"]>;
	generatedUuid_STARTS_WITH?: InputMaybe<Scalars["ID"]>;
	includedIn?: InputMaybe<CaseWhere>;
	includedInAggregate?: InputMaybe<FinancialDataPointIncludedInAggregateInput>;
	includedInConnection?: InputMaybe<FinancialDataPointIncludedInConnectionWhere>;
	includedInConnection_NOT?: InputMaybe<FinancialDataPointIncludedInConnectionWhere>;
	includedIn_NOT?: InputMaybe<CaseWhere>;
	intervention?: InputMaybe<InterventionWhere>;
	interventionAggregate?: InputMaybe<FinancialDataPointInterventionAggregateInput>;
	interventionConnection?: InputMaybe<FinancialDataPointInterventionConnectionWhere>;
	interventionConnection_NOT?: InputMaybe<FinancialDataPointInterventionConnectionWhere>;
	intervention_NOT?: InputMaybe<InterventionWhere>;
	isDeleted?: InputMaybe<Scalars["Boolean"]>;
	isDeleted_NOT?: InputMaybe<Scalars["Boolean"]>;
	isLast?: InputMaybe<Scalars["Boolean"]>;
	isLast_NOT?: InputMaybe<Scalars["Boolean"]>;
	payable?: InputMaybe<Scalars["Float"]>;
	payablePercentage?: InputMaybe<Scalars["Float"]>;
	payablePercentage_GT?: InputMaybe<Scalars["Float"]>;
	payablePercentage_GTE?: InputMaybe<Scalars["Float"]>;
	payablePercentage_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	payablePercentage_LT?: InputMaybe<Scalars["Float"]>;
	payablePercentage_LTE?: InputMaybe<Scalars["Float"]>;
	payablePercentage_NOT?: InputMaybe<Scalars["Float"]>;
	payablePercentage_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	payable_GT?: InputMaybe<Scalars["Float"]>;
	payable_GTE?: InputMaybe<Scalars["Float"]>;
	payable_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	payable_LT?: InputMaybe<Scalars["Float"]>;
	payable_LTE?: InputMaybe<Scalars["Float"]>;
	payable_NOT?: InputMaybe<Scalars["Float"]>;
	payable_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	prescriptionDate?: InputMaybe<Scalars["Date"]>;
	prescriptionDate_GT?: InputMaybe<Scalars["Date"]>;
	prescriptionDate_GTE?: InputMaybe<Scalars["Date"]>;
	prescriptionDate_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
	prescriptionDate_LT?: InputMaybe<Scalars["Date"]>;
	prescriptionDate_LTE?: InputMaybe<Scalars["Date"]>;
	prescriptionDate_NOT?: InputMaybe<Scalars["Date"]>;
	prescriptionDate_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
	quantity?: InputMaybe<Scalars["Float"]>;
	quantity_GT?: InputMaybe<Scalars["Float"]>;
	quantity_GTE?: InputMaybe<Scalars["Float"]>;
	quantity_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	quantity_LT?: InputMaybe<Scalars["Float"]>;
	quantity_LTE?: InputMaybe<Scalars["Float"]>;
	quantity_NOT?: InputMaybe<Scalars["Float"]>;
	quantity_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	refundable?: InputMaybe<Scalars["Float"]>;
	refundablePercentage?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_GT?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_GTE?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	refundablePercentage_LT?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_LTE?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_NOT?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	refundable_GT?: InputMaybe<Scalars["Float"]>;
	refundable_GTE?: InputMaybe<Scalars["Float"]>;
	refundable_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	refundable_LT?: InputMaybe<Scalars["Float"]>;
	refundable_LTE?: InputMaybe<Scalars["Float"]>;
	refundable_NOT?: InputMaybe<Scalars["Float"]>;
	refundable_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	sourceRefund?: InputMaybe<RefundWhere>;
	sourceRefundAggregate?: InputMaybe<FinancialDataPointSourceRefundAggregateInput>;
	sourceRefundConnection?: InputMaybe<FinancialDataPointSourceRefundConnectionWhere>;
	sourceRefundConnection_NOT?: InputMaybe<FinancialDataPointSourceRefundConnectionWhere>;
	sourceRefund_NOT?: InputMaybe<RefundWhere>;
	treatment?: InputMaybe<TreatmentWhere>;
	treatmentAggregate?: InputMaybe<FinancialDataPointTreatmentAggregateInput>;
	treatmentConnection?: InputMaybe<FinancialDataPointTreatmentConnectionWhere>;
	treatmentConnection_NOT?: InputMaybe<FinancialDataPointTreatmentConnectionWhere>;
	treatment_NOT?: InputMaybe<TreatmentWhere>;
	uuid?: InputMaybe<Scalars["ID"]>;
	uuid_CONTAINS?: InputMaybe<Scalars["ID"]>;
	uuid_ENDS_WITH?: InputMaybe<Scalars["ID"]>;
	uuid_IN?: InputMaybe<Array<InputMaybe<Scalars["ID"]>>>;
	uuid_MATCHES?: InputMaybe<Scalars["String"]>;
	uuid_NOT?: InputMaybe<Scalars["ID"]>;
	uuid_NOT_CONTAINS?: InputMaybe<Scalars["ID"]>;
	uuid_NOT_ENDS_WITH?: InputMaybe<Scalars["ID"]>;
	uuid_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["ID"]>>>;
	uuid_NOT_STARTS_WITH?: InputMaybe<Scalars["ID"]>;
	uuid_STARTS_WITH?: InputMaybe<Scalars["ID"]>;
	variable?: InputMaybe<Scalars["Float"]>;
	variablePercentage?: InputMaybe<Scalars["Float"]>;
	variablePercentage_GT?: InputMaybe<Scalars["Float"]>;
	variablePercentage_GTE?: InputMaybe<Scalars["Float"]>;
	variablePercentage_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	variablePercentage_LT?: InputMaybe<Scalars["Float"]>;
	variablePercentage_LTE?: InputMaybe<Scalars["Float"]>;
	variablePercentage_NOT?: InputMaybe<Scalars["Float"]>;
	variablePercentage_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	variable_GT?: InputMaybe<Scalars["Float"]>;
	variable_GTE?: InputMaybe<Scalars["Float"]>;
	variable_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	variable_LT?: InputMaybe<Scalars["Float"]>;
	variable_LTE?: InputMaybe<Scalars["Float"]>;
	variable_NOT?: InputMaybe<Scalars["Float"]>;
	variable_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
};

export type FinancialReportDataPoint = {
	__typename?: "FinancialReportDataPoint";
	date: Scalars["Date"];
	discountAmount: Scalars["Float"];
	grossAmount: Scalars["Float"];
	netAmount: Scalars["Float"];
	variableAmount: Scalars["Float"];
};

export type FinancialReportDataPointAggregateSelection = {
	__typename?: "FinancialReportDataPointAggregateSelection";
	count: Scalars["Int"];
	discountAmount: FloatAggregateSelection;
	grossAmount: FloatAggregateSelection;
	netAmount: FloatAggregateSelection;
	variableAmount: FloatAggregateSelection;
};

export type FinancialReportDataPointOptions = {
	limit?: InputMaybe<Scalars["Int"]>;
	offset?: InputMaybe<Scalars["Int"]>;
	/** Specify one or more FinancialReportDataPointSort objects to sort FinancialReportDataPoints by. The sorts will be applied in the order in which they are arranged in the array. */
	sort?: InputMaybe<Array<InputMaybe<FinancialReportDataPointSort>>>;
};

/** Fields to sort FinancialReportDataPoints by. The order in which sorts are applied is not guaranteed when specifying many fields in one FinancialReportDataPointSort object. */
export type FinancialReportDataPointSort = {
	date?: InputMaybe<SortDirection>;
	discountAmount?: InputMaybe<SortDirection>;
	grossAmount?: InputMaybe<SortDirection>;
	netAmount?: InputMaybe<SortDirection>;
	variableAmount?: InputMaybe<SortDirection>;
};

export type FinancialReportDataPointWhere = {
	AND?: InputMaybe<Array<FinancialReportDataPointWhere>>;
	OR?: InputMaybe<Array<FinancialReportDataPointWhere>>;
	date?: InputMaybe<Scalars["Date"]>;
	date_GT?: InputMaybe<Scalars["Date"]>;
	date_GTE?: InputMaybe<Scalars["Date"]>;
	date_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
	date_LT?: InputMaybe<Scalars["Date"]>;
	date_LTE?: InputMaybe<Scalars["Date"]>;
	date_NOT?: InputMaybe<Scalars["Date"]>;
	date_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
	discountAmount?: InputMaybe<Scalars["Float"]>;
	discountAmount_GT?: InputMaybe<Scalars["Float"]>;
	discountAmount_GTE?: InputMaybe<Scalars["Float"]>;
	discountAmount_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	discountAmount_LT?: InputMaybe<Scalars["Float"]>;
	discountAmount_LTE?: InputMaybe<Scalars["Float"]>;
	discountAmount_NOT?: InputMaybe<Scalars["Float"]>;
	discountAmount_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	grossAmount?: InputMaybe<Scalars["Float"]>;
	grossAmount_GT?: InputMaybe<Scalars["Float"]>;
	grossAmount_GTE?: InputMaybe<Scalars["Float"]>;
	grossAmount_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	grossAmount_LT?: InputMaybe<Scalars["Float"]>;
	grossAmount_LTE?: InputMaybe<Scalars["Float"]>;
	grossAmount_NOT?: InputMaybe<Scalars["Float"]>;
	grossAmount_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	netAmount?: InputMaybe<Scalars["Float"]>;
	netAmount_GT?: InputMaybe<Scalars["Float"]>;
	netAmount_GTE?: InputMaybe<Scalars["Float"]>;
	netAmount_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	netAmount_LT?: InputMaybe<Scalars["Float"]>;
	netAmount_LTE?: InputMaybe<Scalars["Float"]>;
	netAmount_NOT?: InputMaybe<Scalars["Float"]>;
	netAmount_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	variableAmount?: InputMaybe<Scalars["Float"]>;
	variableAmount_GT?: InputMaybe<Scalars["Float"]>;
	variableAmount_GTE?: InputMaybe<Scalars["Float"]>;
	variableAmount_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	variableAmount_LT?: InputMaybe<Scalars["Float"]>;
	variableAmount_LTE?: InputMaybe<Scalars["Float"]>;
	variableAmount_NOT?: InputMaybe<Scalars["Float"]>;
	variableAmount_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
};

export type FinancialSummaryColumn = {
	__typename?: "FinancialSummaryColumn";
	id: Scalars["ID"];
	name: FinancialSummaryColumnName;
};

export type FinancialSummaryColumnAggregateSelection = {
	__typename?: "FinancialSummaryColumnAggregateSelection";
	count: Scalars["Int"];
	id: IdAggregateSelection;
};

export type FinancialSummaryColumnConnectWhere = {
	node: FinancialSummaryColumnWhere;
};

export type FinancialSummaryColumnCreateInput = {
	id: Scalars["ID"];
	name: FinancialSummaryColumnName;
};

export enum FinancialSummaryColumnName {
	BaselinePrice = "BASELINE_PRICE",
	Discounts = "DISCOUNTS",
	ExFactoryPrice = "EX_FACTORY_PRICE",
	GrossAmount = "GROSS_AMOUNT",
	NetAmount = "NET_AMOUNT",
	NetAvgDiscountRate = "NET_AVG_DISCOUNT_RATE",
	NetAvgPrice = "NET_AVG_PRICE",
	NetPrice = "NET_PRICE",
	Product = "PRODUCT",
	PublicPrice = "PUBLIC_PRICE",
	Quantity = "QUANTITY",
	TotalDiscounts = "TOTAL_DISCOUNTS",
	Variable = "VARIABLE",
}

export type FinancialSummaryColumnOptions = {
	limit?: InputMaybe<Scalars["Int"]>;
	offset?: InputMaybe<Scalars["Int"]>;
	/** Specify one or more FinancialSummaryColumnSort objects to sort FinancialSummaryColumns by. The sorts will be applied in the order in which they are arranged in the array. */
	sort?: InputMaybe<Array<InputMaybe<FinancialSummaryColumnSort>>>;
};

/** Fields to sort FinancialSummaryColumns by. The order in which sorts are applied is not guaranteed when specifying many fields in one FinancialSummaryColumnSort object. */
export type FinancialSummaryColumnSort = {
	id?: InputMaybe<SortDirection>;
	name?: InputMaybe<SortDirection>;
};

export type FinancialSummaryColumnUpdateInput = {
	id?: InputMaybe<Scalars["ID"]>;
	name?: InputMaybe<FinancialSummaryColumnName>;
};

export type FinancialSummaryColumnWhere = {
	AND?: InputMaybe<Array<FinancialSummaryColumnWhere>>;
	OR?: InputMaybe<Array<FinancialSummaryColumnWhere>>;
	id?: InputMaybe<Scalars["ID"]>;
	id_CONTAINS?: InputMaybe<Scalars["ID"]>;
	id_ENDS_WITH?: InputMaybe<Scalars["ID"]>;
	id_IN?: InputMaybe<Array<InputMaybe<Scalars["ID"]>>>;
	id_MATCHES?: InputMaybe<Scalars["String"]>;
	id_NOT?: InputMaybe<Scalars["ID"]>;
	id_NOT_CONTAINS?: InputMaybe<Scalars["ID"]>;
	id_NOT_ENDS_WITH?: InputMaybe<Scalars["ID"]>;
	id_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["ID"]>>>;
	id_NOT_STARTS_WITH?: InputMaybe<Scalars["ID"]>;
	id_STARTS_WITH?: InputMaybe<Scalars["ID"]>;
	name?: InputMaybe<FinancialSummaryColumnName>;
	name_IN?: InputMaybe<Array<InputMaybe<FinancialSummaryColumnName>>>;
	name_NOT?: InputMaybe<FinancialSummaryColumnName>;
	name_NOT_IN?: InputMaybe<Array<InputMaybe<FinancialSummaryColumnName>>>;
};

export type FinancialSummaryRow = {
	__typename?: "FinancialSummaryRow";
	baselinePrice: Scalars["Float"];
	discountAmount: Scalars["Float"];
	discountPercentage?: Maybe<Scalars["Float"]>;
	exFactoryPrice: Scalars["Float"];
	grossAmount: Scalars["Float"];
	name: Scalars["String"];
	nestedRows: Array<FinancialSummaryRow>;
	netAmount: Scalars["Float"];
	netAvgDiscountRate: Scalars["Float"];
	netAvgPrice: Scalars["Float"];
	netPrice?: Maybe<Scalars["Float"]>;
	publicPrice: Scalars["Float"];
	quantity: Scalars["Float"];
	variableAmount: Scalars["Float"];
};

export type FinancialSummaryRowAggregateSelection = {
	__typename?: "FinancialSummaryRowAggregateSelection";
	baselinePrice: FloatAggregateSelection;
	count: Scalars["Int"];
	discountAmount: FloatAggregateSelection;
	discountPercentage: FloatAggregateSelection;
	exFactoryPrice: FloatAggregateSelection;
	grossAmount: FloatAggregateSelection;
	name: StringAggregateSelection;
	netAmount: FloatAggregateSelection;
	netAvgDiscountRate: FloatAggregateSelection;
	netAvgPrice: FloatAggregateSelection;
	netPrice: FloatAggregateSelection;
	publicPrice: FloatAggregateSelection;
	quantity: FloatAggregateSelection;
	variableAmount: FloatAggregateSelection;
};

export type FinancialSummaryRowOptions = {
	limit?: InputMaybe<Scalars["Int"]>;
	offset?: InputMaybe<Scalars["Int"]>;
	/** Specify one or more FinancialSummaryRowSort objects to sort FinancialSummaryRows by. The sorts will be applied in the order in which they are arranged in the array. */
	sort?: InputMaybe<Array<InputMaybe<FinancialSummaryRowSort>>>;
};

/** Fields to sort FinancialSummaryRows by. The order in which sorts are applied is not guaranteed when specifying many fields in one FinancialSummaryRowSort object. */
export type FinancialSummaryRowSort = {
	baselinePrice?: InputMaybe<SortDirection>;
	discountAmount?: InputMaybe<SortDirection>;
	discountPercentage?: InputMaybe<SortDirection>;
	exFactoryPrice?: InputMaybe<SortDirection>;
	grossAmount?: InputMaybe<SortDirection>;
	name?: InputMaybe<SortDirection>;
	netAmount?: InputMaybe<SortDirection>;
	netAvgDiscountRate?: InputMaybe<SortDirection>;
	netAvgPrice?: InputMaybe<SortDirection>;
	netPrice?: InputMaybe<SortDirection>;
	publicPrice?: InputMaybe<SortDirection>;
	quantity?: InputMaybe<SortDirection>;
	variableAmount?: InputMaybe<SortDirection>;
};

export type FinancialSummaryRowWhere = {
	AND?: InputMaybe<Array<FinancialSummaryRowWhere>>;
	OR?: InputMaybe<Array<FinancialSummaryRowWhere>>;
	baselinePrice?: InputMaybe<Scalars["Float"]>;
	baselinePrice_GT?: InputMaybe<Scalars["Float"]>;
	baselinePrice_GTE?: InputMaybe<Scalars["Float"]>;
	baselinePrice_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	baselinePrice_LT?: InputMaybe<Scalars["Float"]>;
	baselinePrice_LTE?: InputMaybe<Scalars["Float"]>;
	baselinePrice_NOT?: InputMaybe<Scalars["Float"]>;
	baselinePrice_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	discountAmount?: InputMaybe<Scalars["Float"]>;
	discountAmount_GT?: InputMaybe<Scalars["Float"]>;
	discountAmount_GTE?: InputMaybe<Scalars["Float"]>;
	discountAmount_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	discountAmount_LT?: InputMaybe<Scalars["Float"]>;
	discountAmount_LTE?: InputMaybe<Scalars["Float"]>;
	discountAmount_NOT?: InputMaybe<Scalars["Float"]>;
	discountAmount_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	discountPercentage?: InputMaybe<Scalars["Float"]>;
	discountPercentage_GT?: InputMaybe<Scalars["Float"]>;
	discountPercentage_GTE?: InputMaybe<Scalars["Float"]>;
	discountPercentage_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	discountPercentage_LT?: InputMaybe<Scalars["Float"]>;
	discountPercentage_LTE?: InputMaybe<Scalars["Float"]>;
	discountPercentage_NOT?: InputMaybe<Scalars["Float"]>;
	discountPercentage_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	exFactoryPrice?: InputMaybe<Scalars["Float"]>;
	exFactoryPrice_GT?: InputMaybe<Scalars["Float"]>;
	exFactoryPrice_GTE?: InputMaybe<Scalars["Float"]>;
	exFactoryPrice_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	exFactoryPrice_LT?: InputMaybe<Scalars["Float"]>;
	exFactoryPrice_LTE?: InputMaybe<Scalars["Float"]>;
	exFactoryPrice_NOT?: InputMaybe<Scalars["Float"]>;
	exFactoryPrice_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	grossAmount?: InputMaybe<Scalars["Float"]>;
	grossAmount_GT?: InputMaybe<Scalars["Float"]>;
	grossAmount_GTE?: InputMaybe<Scalars["Float"]>;
	grossAmount_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	grossAmount_LT?: InputMaybe<Scalars["Float"]>;
	grossAmount_LTE?: InputMaybe<Scalars["Float"]>;
	grossAmount_NOT?: InputMaybe<Scalars["Float"]>;
	grossAmount_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	name?: InputMaybe<Scalars["String"]>;
	name_CONTAINS?: InputMaybe<Scalars["String"]>;
	name_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	name_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	name_MATCHES?: InputMaybe<Scalars["String"]>;
	name_NOT?: InputMaybe<Scalars["String"]>;
	name_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	name_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	name_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	name_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	name_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	netAmount?: InputMaybe<Scalars["Float"]>;
	netAmount_GT?: InputMaybe<Scalars["Float"]>;
	netAmount_GTE?: InputMaybe<Scalars["Float"]>;
	netAmount_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	netAmount_LT?: InputMaybe<Scalars["Float"]>;
	netAmount_LTE?: InputMaybe<Scalars["Float"]>;
	netAmount_NOT?: InputMaybe<Scalars["Float"]>;
	netAmount_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	netAvgDiscountRate?: InputMaybe<Scalars["Float"]>;
	netAvgDiscountRate_GT?: InputMaybe<Scalars["Float"]>;
	netAvgDiscountRate_GTE?: InputMaybe<Scalars["Float"]>;
	netAvgDiscountRate_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	netAvgDiscountRate_LT?: InputMaybe<Scalars["Float"]>;
	netAvgDiscountRate_LTE?: InputMaybe<Scalars["Float"]>;
	netAvgDiscountRate_NOT?: InputMaybe<Scalars["Float"]>;
	netAvgDiscountRate_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	netAvgPrice?: InputMaybe<Scalars["Float"]>;
	netAvgPrice_GT?: InputMaybe<Scalars["Float"]>;
	netAvgPrice_GTE?: InputMaybe<Scalars["Float"]>;
	netAvgPrice_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	netAvgPrice_LT?: InputMaybe<Scalars["Float"]>;
	netAvgPrice_LTE?: InputMaybe<Scalars["Float"]>;
	netAvgPrice_NOT?: InputMaybe<Scalars["Float"]>;
	netAvgPrice_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	netPrice?: InputMaybe<Scalars["Float"]>;
	netPrice_GT?: InputMaybe<Scalars["Float"]>;
	netPrice_GTE?: InputMaybe<Scalars["Float"]>;
	netPrice_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	netPrice_LT?: InputMaybe<Scalars["Float"]>;
	netPrice_LTE?: InputMaybe<Scalars["Float"]>;
	netPrice_NOT?: InputMaybe<Scalars["Float"]>;
	netPrice_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	publicPrice?: InputMaybe<Scalars["Float"]>;
	publicPrice_GT?: InputMaybe<Scalars["Float"]>;
	publicPrice_GTE?: InputMaybe<Scalars["Float"]>;
	publicPrice_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	publicPrice_LT?: InputMaybe<Scalars["Float"]>;
	publicPrice_LTE?: InputMaybe<Scalars["Float"]>;
	publicPrice_NOT?: InputMaybe<Scalars["Float"]>;
	publicPrice_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	quantity?: InputMaybe<Scalars["Float"]>;
	quantity_GT?: InputMaybe<Scalars["Float"]>;
	quantity_GTE?: InputMaybe<Scalars["Float"]>;
	quantity_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	quantity_LT?: InputMaybe<Scalars["Float"]>;
	quantity_LTE?: InputMaybe<Scalars["Float"]>;
	quantity_NOT?: InputMaybe<Scalars["Float"]>;
	quantity_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	variableAmount?: InputMaybe<Scalars["Float"]>;
	variableAmount_GT?: InputMaybe<Scalars["Float"]>;
	variableAmount_GTE?: InputMaybe<Scalars["Float"]>;
	variableAmount_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	variableAmount_LT?: InputMaybe<Scalars["Float"]>;
	variableAmount_LTE?: InputMaybe<Scalars["Float"]>;
	variableAmount_NOT?: InputMaybe<Scalars["Float"]>;
	variableAmount_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
};

export enum FlexContainerType {
	Form = "FORM",
	Record = "RECORD",
}

export type FlexEntity = {
	__typename?: "FlexEntity";
	administrationDate?: Maybe<Scalars["DateTime"]>;
	cases: Array<Case>;
	casesConnection: FlexEntityCasesConnection;
	children: Array<FlexEntity>;
	childrenConnection: FlexEntityChildrenConnection;
	containerType: FlexContainerType;
	createdBy: User;
	createdByConnection: FlexEntityCreatedByConnection;
	createdByName: Scalars["String"];
	createdOn: Scalars["DateTime"];
	data: Scalars["String"];
	financialDataPoints: Array<FlexFinancialDataPoint>;
	dataPointsConnection: FlexEntityDataPointsConnection;
	id: Scalars["ID"];
	isArchived: Scalars["Boolean"];
	isDeleted: Scalars["Boolean"];
	isStartingPoint: Scalars["Boolean"];
	lastUpdatedOn?: Maybe<Scalars["DateTime"]>;
	occurrence?: Maybe<OccurrenceEnum>;
	patient?: Maybe<Patient>;
	patientConnection: FlexEntityPatientConnection;
	patientId?: Maybe<Scalars["String"]>;
	preparationBrandNames?: Maybe<Scalars["String"]>;
	preparationGenericNames?: Maybe<Scalars["String"]>;
	prescriptionDate?: Maybe<Scalars["Date"]>;
	quantity?: Maybe<Scalars["Int"]>;
	rating?: Maybe<CoverageRequestRating>;
	source?: Maybe<FlexEntity>;
	sourceConnection: FlexEntitySourceConnection;
	startingPoint?: Maybe<FlexEntity>;
	startingPointConnection: FlexEntityStartingPointConnection;
	status?: Maybe<FlexFormStatus>;
	tenantId: Scalars["String"];
	type: FlexEntityType;
	typeConnection: FlexEntityTypeConnection;
	unlimited?: Maybe<Scalars["Int"]>;
	uuid?: Maybe<Scalars["String"]>;
};

export type FlexEntityCasesArgs = {
	options?: InputMaybe<CaseOptions>;
	where?: InputMaybe<CaseWhere>;
};

export type FlexEntityCasesConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<FlexEntityCasesConnectionSort>>;
	where?: InputMaybe<FlexEntityCasesConnectionWhere>;
};

export type FlexEntityChildrenArgs = {
	options?: InputMaybe<FlexEntityOptions>;
	where?: InputMaybe<FlexEntityWhere>;
};

export type FlexEntityChildrenConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<FlexEntityChildrenConnectionSort>>;
	where?: InputMaybe<FlexEntityChildrenConnectionWhere>;
};

export type FlexEntityCreatedByArgs = {
	options?: InputMaybe<UserOptions>;
	where?: InputMaybe<UserWhere>;
};

export type FlexEntityCreatedByConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<FlexEntityCreatedByConnectionSort>>;
	where?: InputMaybe<FlexEntityCreatedByConnectionWhere>;
};

export type FlexEntityDataPointsArgs = {
	options?: InputMaybe<FlexFinancialDataPointOptions>;
	where?: InputMaybe<FlexFinancialDataPointWhere>;
};

export type FlexEntityDataPointsConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<FlexEntityDataPointsConnectionSort>>;
	where?: InputMaybe<FlexEntityDataPointsConnectionWhere>;
};

export type FlexEntityPatientArgs = {
	options?: InputMaybe<PatientOptions>;
	where?: InputMaybe<PatientWhere>;
};

export type FlexEntityPatientConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<FlexEntityPatientConnectionSort>>;
	where?: InputMaybe<FlexEntityPatientConnectionWhere>;
};

export type FlexEntitySourceArgs = {
	options?: InputMaybe<FlexEntityOptions>;
	where?: InputMaybe<FlexEntityWhere>;
};

export type FlexEntitySourceConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<FlexEntitySourceConnectionSort>>;
	where?: InputMaybe<FlexEntitySourceConnectionWhere>;
};

export type FlexEntityStartingPointArgs = {
	options?: InputMaybe<FlexEntityOptions>;
	where?: InputMaybe<FlexEntityWhere>;
};

export type FlexEntityStartingPointConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<FlexEntityStartingPointConnectionSort>>;
	where?: InputMaybe<FlexEntityStartingPointConnectionWhere>;
};

export type FlexEntityTypeArgs = {
	options?: InputMaybe<FlexEntityTypeOptions>;
	where?: InputMaybe<FlexEntityTypeWhere>;
};

export type FlexEntityTypeConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<FlexEntityTypeConnectionSort>>;
	where?: InputMaybe<FlexEntityTypeConnectionWhere>;
};

export type FlexEntityAggregateSelection = {
	__typename?: "FlexEntityAggregateSelection";
	administrationDate: DateTimeAggregateSelection;
	count: Scalars["Int"];
	createdByName: StringAggregateSelection;
	createdOn: DateTimeAggregateSelection;
	data: StringAggregateSelection;
	id: IdAggregateSelection;
	lastUpdatedOn: DateTimeAggregateSelection;
	patientId: StringAggregateSelection;
	preparationBrandNames: StringAggregateSelection;
	preparationGenericNames: StringAggregateSelection;
	quantity: IntAggregateSelection;
	tenantId: StringAggregateSelection;
	unlimited: IntAggregateSelection;
	uuid: StringAggregateSelection;
};

export type FlexEntityCasesAggregateInput = {
	AND?: InputMaybe<Array<FlexEntityCasesAggregateInput>>;
	OR?: InputMaybe<Array<FlexEntityCasesAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<FlexEntityCasesNodeAggregationWhereInput>;
};

export type FlexEntityCasesConnectFieldInput = {
	connect?: InputMaybe<Array<CaseConnectInput>>;
	where?: InputMaybe<CaseConnectWhere>;
};

export type FlexEntityCasesConnection = {
	__typename?: "FlexEntityCasesConnection";
	edges: Array<FlexEntityCasesRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type FlexEntityCasesConnectionSort = {
	node?: InputMaybe<CaseSort>;
};

export type FlexEntityCasesConnectionWhere = {
	AND?: InputMaybe<Array<FlexEntityCasesConnectionWhere>>;
	OR?: InputMaybe<Array<FlexEntityCasesConnectionWhere>>;
	node?: InputMaybe<CaseWhere>;
	node_NOT?: InputMaybe<CaseWhere>;
};

export type FlexEntityCasesCreateFieldInput = {
	node: CaseCreateInput;
};

export type FlexEntityCasesDeleteFieldInput = {
	delete?: InputMaybe<CaseDeleteInput>;
	where?: InputMaybe<FlexEntityCasesConnectionWhere>;
};

export type FlexEntityCasesDisconnectFieldInput = {
	disconnect?: InputMaybe<CaseDisconnectInput>;
	where?: InputMaybe<FlexEntityCasesConnectionWhere>;
};

export type FlexEntityCasesFieldInput = {
	connect?: InputMaybe<Array<FlexEntityCasesConnectFieldInput>>;
	create?: InputMaybe<Array<FlexEntityCasesCreateFieldInput>>;
};

export type FlexEntityCasesNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<FlexEntityCasesNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<FlexEntityCasesNodeAggregationWhereInput>>;
	actualAgreementId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	actualAgreementId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	actualAgreementId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	actualAgreementId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	actualAgreementId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	actualAgreementId_EQUAL?: InputMaybe<Scalars["String"]>;
	actualAgreementId_GT?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_GTE?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_LT?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_LTE?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	agreementName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	agreementName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	agreementName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	agreementName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	agreementName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	agreementName_EQUAL?: InputMaybe<Scalars["String"]>;
	agreementName_GT?: InputMaybe<Scalars["Int"]>;
	agreementName_GTE?: InputMaybe<Scalars["Int"]>;
	agreementName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	agreementName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	agreementName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	agreementName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	agreementName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	agreementName_LT?: InputMaybe<Scalars["Int"]>;
	agreementName_LTE?: InputMaybe<Scalars["Int"]>;
	agreementName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	agreementName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	agreementName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	agreementName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	agreementName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	patientInitials_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	patientInitials_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	patientInitials_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	patientInitials_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	patientInitials_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	patientInitials_EQUAL?: InputMaybe<Scalars["String"]>;
	patientInitials_GT?: InputMaybe<Scalars["Int"]>;
	patientInitials_GTE?: InputMaybe<Scalars["Int"]>;
	patientInitials_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	patientInitials_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	patientInitials_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	patientInitials_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	patientInitials_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	patientInitials_LT?: InputMaybe<Scalars["Int"]>;
	patientInitials_LTE?: InputMaybe<Scalars["Int"]>;
	patientInitials_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	patientInitials_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	patientInitials_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	patientInitials_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	patientInitials_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	patientInsuranceId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	patientInsuranceId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	patientInsuranceId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	patientInsuranceId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	patientInsuranceId_EQUAL?: InputMaybe<Scalars["String"]>;
	patientInsuranceId_GT?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_GTE?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_LT?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_LTE?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationBandName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	preparationBandName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	preparationBandName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	preparationBandName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	preparationBandName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	preparationBandName_EQUAL?: InputMaybe<Scalars["String"]>;
	preparationBandName_GT?: InputMaybe<Scalars["Int"]>;
	preparationBandName_GTE?: InputMaybe<Scalars["Int"]>;
	preparationBandName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationBandName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationBandName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationBandName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationBandName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationBandName_LT?: InputMaybe<Scalars["Int"]>;
	preparationBandName_LTE?: InputMaybe<Scalars["Int"]>;
	preparationBandName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationBandName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationBandName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationBandName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationBandName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	preparationGenericName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	preparationGenericName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	preparationGenericName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	preparationGenericName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	preparationGenericName_EQUAL?: InputMaybe<Scalars["String"]>;
	preparationGenericName_GT?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_GTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_LT?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_LTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	sourceTenantId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	sourceTenantId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	sourceTenantId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	sourceTenantId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	sourceTenantId_EQUAL?: InputMaybe<Scalars["String"]>;
	sourceTenantId_GT?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_GTE?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_LT?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_LTE?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	submissionDate_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_GT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_GTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_LT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_LTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	totalAmount_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	totalAmount_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	totalAmount_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	totalAmount_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	totalAmount_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	totalAmount_EQUAL?: InputMaybe<Scalars["Float"]>;
	totalAmount_GT?: InputMaybe<Scalars["Float"]>;
	totalAmount_GTE?: InputMaybe<Scalars["Float"]>;
	totalAmount_LT?: InputMaybe<Scalars["Float"]>;
	totalAmount_LTE?: InputMaybe<Scalars["Float"]>;
	totalAmount_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	totalAmount_MAX_GT?: InputMaybe<Scalars["Float"]>;
	totalAmount_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	totalAmount_MAX_LT?: InputMaybe<Scalars["Float"]>;
	totalAmount_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	totalAmount_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	totalAmount_MIN_GT?: InputMaybe<Scalars["Float"]>;
	totalAmount_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	totalAmount_MIN_LT?: InputMaybe<Scalars["Float"]>;
	totalAmount_MIN_LTE?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	unlimited_EQUAL?: InputMaybe<Scalars["Int"]>;
	unlimited_GT?: InputMaybe<Scalars["Int"]>;
	unlimited_GTE?: InputMaybe<Scalars["Int"]>;
	unlimited_LT?: InputMaybe<Scalars["Int"]>;
	unlimited_LTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_GT?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_LT?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_GT?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_LT?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_LTE?: InputMaybe<Scalars["Int"]>;
};

export type FlexEntityCasesRelationship = {
	__typename?: "FlexEntityCasesRelationship";
	cursor: Scalars["String"];
	node: Case;
};

export type FlexEntityCasesUpdateConnectionInput = {
	node?: InputMaybe<CaseUpdateInput>;
};

export type FlexEntityCasesUpdateFieldInput = {
	connect?: InputMaybe<Array<FlexEntityCasesConnectFieldInput>>;
	create?: InputMaybe<Array<FlexEntityCasesCreateFieldInput>>;
	delete?: InputMaybe<Array<FlexEntityCasesDeleteFieldInput>>;
	disconnect?: InputMaybe<Array<FlexEntityCasesDisconnectFieldInput>>;
	update?: InputMaybe<FlexEntityCasesUpdateConnectionInput>;
	where?: InputMaybe<FlexEntityCasesConnectionWhere>;
};

export type FlexEntityChildrenAggregateInput = {
	AND?: InputMaybe<Array<FlexEntityChildrenAggregateInput>>;
	OR?: InputMaybe<Array<FlexEntityChildrenAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<FlexEntityChildrenNodeAggregationWhereInput>;
};

export type FlexEntityChildrenConnectFieldInput = {
	connect?: InputMaybe<Array<FlexEntityConnectInput>>;
	where?: InputMaybe<FlexEntityConnectWhere>;
};

export type FlexEntityChildrenConnection = {
	__typename?: "FlexEntityChildrenConnection";
	edges: Array<FlexEntityChildrenRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type FlexEntityChildrenConnectionSort = {
	node?: InputMaybe<FlexEntitySort>;
};

export type FlexEntityChildrenConnectionWhere = {
	AND?: InputMaybe<Array<FlexEntityChildrenConnectionWhere>>;
	OR?: InputMaybe<Array<FlexEntityChildrenConnectionWhere>>;
	node?: InputMaybe<FlexEntityWhere>;
	node_NOT?: InputMaybe<FlexEntityWhere>;
};

export type FlexEntityChildrenCreateFieldInput = {
	node: FlexEntityCreateInput;
};

export type FlexEntityChildrenDeleteFieldInput = {
	delete?: InputMaybe<FlexEntityDeleteInput>;
	where?: InputMaybe<FlexEntityChildrenConnectionWhere>;
};

export type FlexEntityChildrenDisconnectFieldInput = {
	disconnect?: InputMaybe<FlexEntityDisconnectInput>;
	where?: InputMaybe<FlexEntityChildrenConnectionWhere>;
};

export type FlexEntityChildrenFieldInput = {
	connect?: InputMaybe<Array<FlexEntityChildrenConnectFieldInput>>;
	create?: InputMaybe<Array<FlexEntityChildrenCreateFieldInput>>;
};

export type FlexEntityChildrenNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<FlexEntityChildrenNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<FlexEntityChildrenNodeAggregationWhereInput>>;
	administrationDate_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_GT?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_GTE?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_LT?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_LTE?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdByName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	createdByName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	createdByName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	createdByName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	createdByName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	createdByName_EQUAL?: InputMaybe<Scalars["String"]>;
	createdByName_GT?: InputMaybe<Scalars["Int"]>;
	createdByName_GTE?: InputMaybe<Scalars["Int"]>;
	createdByName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	createdByName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	createdByName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	createdByName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	createdByName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	createdByName_LT?: InputMaybe<Scalars["Int"]>;
	createdByName_LTE?: InputMaybe<Scalars["Int"]>;
	createdByName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	createdByName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	createdByName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	createdByName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	createdByName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	createdOn_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	data_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	data_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	data_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	data_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	data_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	data_EQUAL?: InputMaybe<Scalars["String"]>;
	data_GT?: InputMaybe<Scalars["Int"]>;
	data_GTE?: InputMaybe<Scalars["Int"]>;
	data_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	data_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	data_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	data_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	data_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	data_LT?: InputMaybe<Scalars["Int"]>;
	data_LTE?: InputMaybe<Scalars["Int"]>;
	data_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	data_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	data_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	data_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	data_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	lastUpdatedOn_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_GT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_LT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	patientId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	patientId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	patientId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	patientId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	patientId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	patientId_EQUAL?: InputMaybe<Scalars["String"]>;
	patientId_GT?: InputMaybe<Scalars["Int"]>;
	patientId_GTE?: InputMaybe<Scalars["Int"]>;
	patientId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	patientId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	patientId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	patientId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	patientId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	patientId_LT?: InputMaybe<Scalars["Int"]>;
	patientId_LTE?: InputMaybe<Scalars["Int"]>;
	patientId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	patientId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	patientId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	patientId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	patientId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	preparationBrandNames_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	preparationBrandNames_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	preparationBrandNames_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	preparationBrandNames_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	preparationBrandNames_EQUAL?: InputMaybe<Scalars["String"]>;
	preparationBrandNames_GT?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_GTE?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_LT?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_LTE?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	preparationGenericNames_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	preparationGenericNames_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	preparationGenericNames_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	preparationGenericNames_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	preparationGenericNames_EQUAL?: InputMaybe<Scalars["String"]>;
	preparationGenericNames_GT?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_GTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_LT?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_LTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	quantity_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	quantity_EQUAL?: InputMaybe<Scalars["Int"]>;
	quantity_GT?: InputMaybe<Scalars["Int"]>;
	quantity_GTE?: InputMaybe<Scalars["Int"]>;
	quantity_LT?: InputMaybe<Scalars["Int"]>;
	quantity_LTE?: InputMaybe<Scalars["Int"]>;
	quantity_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	quantity_MAX_GT?: InputMaybe<Scalars["Int"]>;
	quantity_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	quantity_MAX_LT?: InputMaybe<Scalars["Int"]>;
	quantity_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	quantity_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	quantity_MIN_GT?: InputMaybe<Scalars["Int"]>;
	quantity_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	quantity_MIN_LT?: InputMaybe<Scalars["Int"]>;
	quantity_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	tenantId_EQUAL?: InputMaybe<Scalars["String"]>;
	tenantId_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	unlimited_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	unlimited_EQUAL?: InputMaybe<Scalars["Int"]>;
	unlimited_GT?: InputMaybe<Scalars["Int"]>;
	unlimited_GTE?: InputMaybe<Scalars["Int"]>;
	unlimited_LT?: InputMaybe<Scalars["Int"]>;
	unlimited_LTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_GT?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_LT?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_GT?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_LT?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	uuid_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	uuid_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	uuid_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	uuid_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	uuid_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	uuid_EQUAL?: InputMaybe<Scalars["String"]>;
	uuid_GT?: InputMaybe<Scalars["Int"]>;
	uuid_GTE?: InputMaybe<Scalars["Int"]>;
	uuid_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	uuid_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	uuid_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	uuid_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	uuid_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	uuid_LT?: InputMaybe<Scalars["Int"]>;
	uuid_LTE?: InputMaybe<Scalars["Int"]>;
	uuid_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	uuid_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	uuid_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	uuid_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	uuid_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type FlexEntityChildrenRelationship = {
	__typename?: "FlexEntityChildrenRelationship";
	cursor: Scalars["String"];
	node: FlexEntity;
};

export type FlexEntityChildrenUpdateConnectionInput = {
	node?: InputMaybe<FlexEntityUpdateInput>;
};

export type FlexEntityChildrenUpdateFieldInput = {
	connect?: InputMaybe<Array<FlexEntityChildrenConnectFieldInput>>;
	create?: InputMaybe<Array<FlexEntityChildrenCreateFieldInput>>;
	delete?: InputMaybe<Array<FlexEntityChildrenDeleteFieldInput>>;
	disconnect?: InputMaybe<Array<FlexEntityChildrenDisconnectFieldInput>>;
	update?: InputMaybe<FlexEntityChildrenUpdateConnectionInput>;
	where?: InputMaybe<FlexEntityChildrenConnectionWhere>;
};

export type FlexEntityConnectInput = {
	cases?: InputMaybe<Array<FlexEntityCasesConnectFieldInput>>;
	children?: InputMaybe<Array<FlexEntityChildrenConnectFieldInput>>;
	createdBy?: InputMaybe<FlexEntityCreatedByConnectFieldInput>;
	financialDataPoints?: InputMaybe<Array<FlexEntityDataPointsConnectFieldInput>>;
	patient?: InputMaybe<FlexEntityPatientConnectFieldInput>;
	source?: InputMaybe<FlexEntitySourceConnectFieldInput>;
	startingPoint?: InputMaybe<FlexEntityStartingPointConnectFieldInput>;
	type?: InputMaybe<FlexEntityTypeConnectFieldInput>;
};

export type FlexEntityConnectWhere = {
	node: FlexEntityWhere;
};

export type FlexEntityCreateInput = {
	administrationDate?: InputMaybe<Scalars["DateTime"]>;
	cases?: InputMaybe<FlexEntityCasesFieldInput>;
	children?: InputMaybe<FlexEntityChildrenFieldInput>;
	containerType: FlexContainerType;
	createdBy?: InputMaybe<FlexEntityCreatedByFieldInput>;
	createdByName: Scalars["String"];
	createdOn: Scalars["DateTime"];
	data: Scalars["String"];
	financialDataPoints?: InputMaybe<FlexEntityDataPointsFieldInput>;
	id: Scalars["ID"];
	isArchived: Scalars["Boolean"];
	isDeleted: Scalars["Boolean"];
	isStartingPoint: Scalars["Boolean"];
	lastUpdatedOn?: InputMaybe<Scalars["DateTime"]>;
	occurrence?: InputMaybe<OccurrenceEnum>;
	patient?: InputMaybe<FlexEntityPatientFieldInput>;
	patientId?: InputMaybe<Scalars["String"]>;
	preparationBrandNames?: InputMaybe<Scalars["String"]>;
	preparationGenericNames?: InputMaybe<Scalars["String"]>;
	prescriptionDate?: InputMaybe<Scalars["Date"]>;
	quantity?: InputMaybe<Scalars["Int"]>;
	rating?: InputMaybe<CoverageRequestRating>;
	source?: InputMaybe<FlexEntitySourceFieldInput>;
	startingPoint?: InputMaybe<FlexEntityStartingPointFieldInput>;
	status?: InputMaybe<FlexFormStatus>;
	tenantId: Scalars["String"];
	type?: InputMaybe<FlexEntityTypeFieldInput>;
	unlimited?: InputMaybe<Scalars["Int"]>;
	uuid?: InputMaybe<Scalars["String"]>;
};

export type FlexEntityCreatedByAggregateInput = {
	AND?: InputMaybe<Array<FlexEntityCreatedByAggregateInput>>;
	OR?: InputMaybe<Array<FlexEntityCreatedByAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<FlexEntityCreatedByNodeAggregationWhereInput>;
};

export type FlexEntityCreatedByConnectFieldInput = {
	connect?: InputMaybe<UserConnectInput>;
	where?: InputMaybe<UserConnectWhere>;
};

export type FlexEntityCreatedByConnection = {
	__typename?: "FlexEntityCreatedByConnection";
	edges: Array<FlexEntityCreatedByRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type FlexEntityCreatedByConnectionSort = {
	node?: InputMaybe<UserSort>;
};

export type FlexEntityCreatedByConnectionWhere = {
	AND?: InputMaybe<Array<FlexEntityCreatedByConnectionWhere>>;
	OR?: InputMaybe<Array<FlexEntityCreatedByConnectionWhere>>;
	node?: InputMaybe<UserWhere>;
	node_NOT?: InputMaybe<UserWhere>;
};

export type FlexEntityCreatedByCreateFieldInput = {
	node: UserCreateInput;
};

export type FlexEntityCreatedByDeleteFieldInput = {
	delete?: InputMaybe<UserDeleteInput>;
	where?: InputMaybe<FlexEntityCreatedByConnectionWhere>;
};

export type FlexEntityCreatedByDisconnectFieldInput = {
	disconnect?: InputMaybe<UserDisconnectInput>;
	where?: InputMaybe<FlexEntityCreatedByConnectionWhere>;
};

export type FlexEntityCreatedByFieldInput = {
	connect?: InputMaybe<FlexEntityCreatedByConnectFieldInput>;
	create?: InputMaybe<FlexEntityCreatedByCreateFieldInput>;
};

export type FlexEntityCreatedByNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<FlexEntityCreatedByNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<FlexEntityCreatedByNodeAggregationWhereInput>>;
	email_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	email_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	email_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	email_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	email_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	email_EQUAL?: InputMaybe<Scalars["String"]>;
	email_GT?: InputMaybe<Scalars["Int"]>;
	email_GTE?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	email_LT?: InputMaybe<Scalars["Int"]>;
	email_LTE?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	firstName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	firstName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	firstName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	firstName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	firstName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	firstName_EQUAL?: InputMaybe<Scalars["String"]>;
	firstName_GT?: InputMaybe<Scalars["Int"]>;
	firstName_GTE?: InputMaybe<Scalars["Int"]>;
	firstName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	firstName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	firstName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	firstName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	firstName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	firstName_LT?: InputMaybe<Scalars["Int"]>;
	firstName_LTE?: InputMaybe<Scalars["Int"]>;
	firstName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	firstName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	firstName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	firstName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	firstName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	lastName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	lastName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	lastName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	lastName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	lastName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	lastName_EQUAL?: InputMaybe<Scalars["String"]>;
	lastName_GT?: InputMaybe<Scalars["Int"]>;
	lastName_GTE?: InputMaybe<Scalars["Int"]>;
	lastName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	lastName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	lastName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	lastName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	lastName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	lastName_LT?: InputMaybe<Scalars["Int"]>;
	lastName_LTE?: InputMaybe<Scalars["Int"]>;
	lastName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	lastName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	lastName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	lastName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	lastName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	preferredLanguage_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	preferredLanguage_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	preferredLanguage_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	preferredLanguage_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	preferredLanguage_EQUAL?: InputMaybe<Scalars["String"]>;
	preferredLanguage_GT?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_GTE?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LT?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LTE?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	tenantId_EQUAL?: InputMaybe<Scalars["String"]>;
	tenantId_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type FlexEntityCreatedByRelationship = {
	__typename?: "FlexEntityCreatedByRelationship";
	cursor: Scalars["String"];
	node: User;
};

export type FlexEntityCreatedByUpdateConnectionInput = {
	node?: InputMaybe<UserUpdateInput>;
};

export type FlexEntityCreatedByUpdateFieldInput = {
	connect?: InputMaybe<FlexEntityCreatedByConnectFieldInput>;
	create?: InputMaybe<FlexEntityCreatedByCreateFieldInput>;
	delete?: InputMaybe<FlexEntityCreatedByDeleteFieldInput>;
	disconnect?: InputMaybe<FlexEntityCreatedByDisconnectFieldInput>;
	update?: InputMaybe<FlexEntityCreatedByUpdateConnectionInput>;
	where?: InputMaybe<FlexEntityCreatedByConnectionWhere>;
};

export type FlexEntityDataPointsAggregateInput = {
	AND?: InputMaybe<Array<FlexEntityDataPointsAggregateInput>>;
	OR?: InputMaybe<Array<FlexEntityDataPointsAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<FlexEntityDataPointsNodeAggregationWhereInput>;
};

export type FlexEntityDataPointsConnectFieldInput = {
	connect?: InputMaybe<Array<FlexFinancialDataPointConnectInput>>;
	where?: InputMaybe<FlexFinancialDataPointConnectWhere>;
};

export type FlexEntityDataPointsConnection = {
	__typename?: "FlexEntityDataPointsConnection";
	edges: Array<FlexEntityDataPointsRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type FlexEntityDataPointsConnectionSort = {
	node?: InputMaybe<FlexFinancialDataPointSort>;
};

export type FlexEntityDataPointsConnectionWhere = {
	AND?: InputMaybe<Array<FlexEntityDataPointsConnectionWhere>>;
	OR?: InputMaybe<Array<FlexEntityDataPointsConnectionWhere>>;
	node?: InputMaybe<FlexFinancialDataPointWhere>;
	node_NOT?: InputMaybe<FlexFinancialDataPointWhere>;
};

export type FlexEntityDataPointsCreateFieldInput = {
	node: FlexFinancialDataPointCreateInput;
};

export type FlexEntityDataPointsDeleteFieldInput = {
	delete?: InputMaybe<FlexFinancialDataPointDeleteInput>;
	where?: InputMaybe<FlexEntityDataPointsConnectionWhere>;
};

export type FlexEntityDataPointsDisconnectFieldInput = {
	disconnect?: InputMaybe<FlexFinancialDataPointDisconnectInput>;
	where?: InputMaybe<FlexEntityDataPointsConnectionWhere>;
};

export type FlexEntityDataPointsFieldInput = {
	connect?: InputMaybe<Array<FlexEntityDataPointsConnectFieldInput>>;
	create?: InputMaybe<Array<FlexEntityDataPointsCreateFieldInput>>;
};

export type FlexEntityDataPointsNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<FlexEntityDataPointsNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<FlexEntityDataPointsNodeAggregationWhereInput>>;
	basePrice_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	basePrice_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	basePrice_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	basePrice_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	basePrice_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	basePrice_EQUAL?: InputMaybe<Scalars["Float"]>;
	basePrice_GT?: InputMaybe<Scalars["Float"]>;
	basePrice_GTE?: InputMaybe<Scalars["Float"]>;
	basePrice_LT?: InputMaybe<Scalars["Float"]>;
	basePrice_LTE?: InputMaybe<Scalars["Float"]>;
	basePrice_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	basePrice_MAX_GT?: InputMaybe<Scalars["Float"]>;
	basePrice_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	basePrice_MAX_LT?: InputMaybe<Scalars["Float"]>;
	basePrice_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	basePrice_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	basePrice_MIN_GT?: InputMaybe<Scalars["Float"]>;
	basePrice_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	basePrice_MIN_LT?: InputMaybe<Scalars["Float"]>;
	basePrice_MIN_LTE?: InputMaybe<Scalars["Float"]>;
	currencyCode_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	currencyCode_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	currencyCode_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	currencyCode_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	currencyCode_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	currencyCode_EQUAL?: InputMaybe<Scalars["String"]>;
	currencyCode_GT?: InputMaybe<Scalars["Int"]>;
	currencyCode_GTE?: InputMaybe<Scalars["Int"]>;
	currencyCode_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	currencyCode_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	currencyCode_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	currencyCode_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	currencyCode_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	currencyCode_LT?: InputMaybe<Scalars["Int"]>;
	currencyCode_LTE?: InputMaybe<Scalars["Int"]>;
	currencyCode_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	currencyCode_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	currencyCode_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	currencyCode_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	currencyCode_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	evaluationSnapshot_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	evaluationSnapshot_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	evaluationSnapshot_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	evaluationSnapshot_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	evaluationSnapshot_EQUAL?: InputMaybe<Scalars["String"]>;
	evaluationSnapshot_GT?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_GTE?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_LT?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_LTE?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	generatedUuid_EQUAL?: InputMaybe<Scalars["ID"]>;
	payablePercentage_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	payablePercentage_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	payablePercentage_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	payablePercentage_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	payablePercentage_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	payablePercentage_EQUAL?: InputMaybe<Scalars["Float"]>;
	payablePercentage_GT?: InputMaybe<Scalars["Float"]>;
	payablePercentage_GTE?: InputMaybe<Scalars["Float"]>;
	payablePercentage_LT?: InputMaybe<Scalars["Float"]>;
	payablePercentage_LTE?: InputMaybe<Scalars["Float"]>;
	payablePercentage_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	payablePercentage_MAX_GT?: InputMaybe<Scalars["Float"]>;
	payablePercentage_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	payablePercentage_MAX_LT?: InputMaybe<Scalars["Float"]>;
	payablePercentage_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	payablePercentage_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	payablePercentage_MIN_GT?: InputMaybe<Scalars["Float"]>;
	payablePercentage_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	payablePercentage_MIN_LT?: InputMaybe<Scalars["Float"]>;
	payablePercentage_MIN_LTE?: InputMaybe<Scalars["Float"]>;
	payable_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	payable_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	payable_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	payable_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	payable_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	payable_EQUAL?: InputMaybe<Scalars["Float"]>;
	payable_GT?: InputMaybe<Scalars["Float"]>;
	payable_GTE?: InputMaybe<Scalars["Float"]>;
	payable_LT?: InputMaybe<Scalars["Float"]>;
	payable_LTE?: InputMaybe<Scalars["Float"]>;
	payable_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	payable_MAX_GT?: InputMaybe<Scalars["Float"]>;
	payable_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	payable_MAX_LT?: InputMaybe<Scalars["Float"]>;
	payable_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	payable_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	payable_MIN_GT?: InputMaybe<Scalars["Float"]>;
	payable_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	payable_MIN_LT?: InputMaybe<Scalars["Float"]>;
	payable_MIN_LTE?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	quantity_EQUAL?: InputMaybe<Scalars["Float"]>;
	quantity_GT?: InputMaybe<Scalars["Float"]>;
	quantity_GTE?: InputMaybe<Scalars["Float"]>;
	quantity_LT?: InputMaybe<Scalars["Float"]>;
	quantity_LTE?: InputMaybe<Scalars["Float"]>;
	quantity_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	quantity_MAX_GT?: InputMaybe<Scalars["Float"]>;
	quantity_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	quantity_MAX_LT?: InputMaybe<Scalars["Float"]>;
	quantity_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	quantity_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	quantity_MIN_GT?: InputMaybe<Scalars["Float"]>;
	quantity_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	quantity_MIN_LT?: InputMaybe<Scalars["Float"]>;
	quantity_MIN_LTE?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_EQUAL?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_GT?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_GTE?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_LT?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_LTE?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_MAX_GT?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_MAX_LT?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_MIN_GT?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_MIN_LT?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_MIN_LTE?: InputMaybe<Scalars["Float"]>;
	refundable_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	refundable_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	refundable_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	refundable_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	refundable_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	refundable_EQUAL?: InputMaybe<Scalars["Float"]>;
	refundable_GT?: InputMaybe<Scalars["Float"]>;
	refundable_GTE?: InputMaybe<Scalars["Float"]>;
	refundable_LT?: InputMaybe<Scalars["Float"]>;
	refundable_LTE?: InputMaybe<Scalars["Float"]>;
	refundable_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	refundable_MAX_GT?: InputMaybe<Scalars["Float"]>;
	refundable_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	refundable_MAX_LT?: InputMaybe<Scalars["Float"]>;
	refundable_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	refundable_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	refundable_MIN_GT?: InputMaybe<Scalars["Float"]>;
	refundable_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	refundable_MIN_LT?: InputMaybe<Scalars["Float"]>;
	refundable_MIN_LTE?: InputMaybe<Scalars["Float"]>;
	uuid_EQUAL?: InputMaybe<Scalars["ID"]>;
	variablePercentage_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	variablePercentage_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	variablePercentage_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	variablePercentage_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	variablePercentage_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	variablePercentage_EQUAL?: InputMaybe<Scalars["Float"]>;
	variablePercentage_GT?: InputMaybe<Scalars["Float"]>;
	variablePercentage_GTE?: InputMaybe<Scalars["Float"]>;
	variablePercentage_LT?: InputMaybe<Scalars["Float"]>;
	variablePercentage_LTE?: InputMaybe<Scalars["Float"]>;
	variablePercentage_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	variablePercentage_MAX_GT?: InputMaybe<Scalars["Float"]>;
	variablePercentage_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	variablePercentage_MAX_LT?: InputMaybe<Scalars["Float"]>;
	variablePercentage_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	variablePercentage_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	variablePercentage_MIN_GT?: InputMaybe<Scalars["Float"]>;
	variablePercentage_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	variablePercentage_MIN_LT?: InputMaybe<Scalars["Float"]>;
	variablePercentage_MIN_LTE?: InputMaybe<Scalars["Float"]>;
	variable_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	variable_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	variable_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	variable_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	variable_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	variable_EQUAL?: InputMaybe<Scalars["Float"]>;
	variable_GT?: InputMaybe<Scalars["Float"]>;
	variable_GTE?: InputMaybe<Scalars["Float"]>;
	variable_LT?: InputMaybe<Scalars["Float"]>;
	variable_LTE?: InputMaybe<Scalars["Float"]>;
	variable_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	variable_MAX_GT?: InputMaybe<Scalars["Float"]>;
	variable_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	variable_MAX_LT?: InputMaybe<Scalars["Float"]>;
	variable_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	variable_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	variable_MIN_GT?: InputMaybe<Scalars["Float"]>;
	variable_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	variable_MIN_LT?: InputMaybe<Scalars["Float"]>;
	variable_MIN_LTE?: InputMaybe<Scalars["Float"]>;
};

export type FlexEntityDataPointsRelationship = {
	__typename?: "FlexEntityDataPointsRelationship";
	cursor: Scalars["String"];
	node: FlexFinancialDataPoint;
};

export type FlexEntityDataPointsUpdateConnectionInput = {
	node?: InputMaybe<FlexFinancialDataPointUpdateInput>;
};

export type FlexEntityDataPointsUpdateFieldInput = {
	connect?: InputMaybe<Array<FlexEntityDataPointsConnectFieldInput>>;
	create?: InputMaybe<Array<FlexEntityDataPointsCreateFieldInput>>;
	delete?: InputMaybe<Array<FlexEntityDataPointsDeleteFieldInput>>;
	disconnect?: InputMaybe<Array<FlexEntityDataPointsDisconnectFieldInput>>;
	update?: InputMaybe<FlexEntityDataPointsUpdateConnectionInput>;
	where?: InputMaybe<FlexEntityDataPointsConnectionWhere>;
};

export type FlexEntityDeleteInput = {
	cases?: InputMaybe<Array<FlexEntityCasesDeleteFieldInput>>;
	children?: InputMaybe<Array<FlexEntityChildrenDeleteFieldInput>>;
	createdBy?: InputMaybe<FlexEntityCreatedByDeleteFieldInput>;
	financialDataPoints?: InputMaybe<Array<FlexEntityDataPointsDeleteFieldInput>>;
	patient?: InputMaybe<FlexEntityPatientDeleteFieldInput>;
	source?: InputMaybe<FlexEntitySourceDeleteFieldInput>;
	startingPoint?: InputMaybe<FlexEntityStartingPointDeleteFieldInput>;
	type?: InputMaybe<FlexEntityTypeDeleteFieldInput>;
};

export type FlexEntityDisconnectInput = {
	cases?: InputMaybe<Array<FlexEntityCasesDisconnectFieldInput>>;
	children?: InputMaybe<Array<FlexEntityChildrenDisconnectFieldInput>>;
	createdBy?: InputMaybe<FlexEntityCreatedByDisconnectFieldInput>;
	financialDataPoints?: InputMaybe<Array<FlexEntityDataPointsDisconnectFieldInput>>;
	patient?: InputMaybe<FlexEntityPatientDisconnectFieldInput>;
	source?: InputMaybe<FlexEntitySourceDisconnectFieldInput>;
	startingPoint?: InputMaybe<FlexEntityStartingPointDisconnectFieldInput>;
	type?: InputMaybe<FlexEntityTypeDisconnectFieldInput>;
};

export enum FlexEntityFeature {
	Deletion = "DELETION",
	Saving = "SAVING",
	Submission = "SUBMISSION",
}

export type FlexEntityOptions = {
	limit?: InputMaybe<Scalars["Int"]>;
	offset?: InputMaybe<Scalars["Int"]>;
	/** Specify one or more FlexEntitySort objects to sort FlexEntities by. The sorts will be applied in the order in which they are arranged in the array. */
	sort?: InputMaybe<Array<InputMaybe<FlexEntitySort>>>;
};

export type SimulatorOptions = {
	limit?: InputMaybe<Scalars["Int"]>;
	offset?: InputMaybe<Scalars["Int"]>;
	/** Specify one or more FlexEntitySort objects to sort FlexEntities by. The sorts will be applied in the order in which they are arranged in the array. */
	sort?: InputMaybe<Array<InputMaybe<FlexEntitySort>>>;
};

export type FlexEntityPatientAggregateInput = {
	AND?: InputMaybe<Array<FlexEntityPatientAggregateInput>>;
	OR?: InputMaybe<Array<FlexEntityPatientAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<FlexEntityPatientNodeAggregationWhereInput>;
};

export type FlexEntityPatientConnectFieldInput = {
	connect?: InputMaybe<PatientConnectInput>;
	where?: InputMaybe<PatientConnectWhere>;
};

export type FlexEntityPatientConnection = {
	__typename?: "FlexEntityPatientConnection";
	edges: Array<FlexEntityPatientRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type FlexEntityPatientConnectionSort = {
	node?: InputMaybe<PatientSort>;
};

export type FlexEntityPatientConnectionWhere = {
	AND?: InputMaybe<Array<FlexEntityPatientConnectionWhere>>;
	OR?: InputMaybe<Array<FlexEntityPatientConnectionWhere>>;
	node?: InputMaybe<PatientWhere>;
	node_NOT?: InputMaybe<PatientWhere>;
};

export type FlexEntityPatientCreateFieldInput = {
	node: PatientCreateInput;
};

export type FlexEntityPatientDeleteFieldInput = {
	delete?: InputMaybe<PatientDeleteInput>;
	where?: InputMaybe<FlexEntityPatientConnectionWhere>;
};

export type FlexEntityPatientDisconnectFieldInput = {
	disconnect?: InputMaybe<PatientDisconnectInput>;
	where?: InputMaybe<FlexEntityPatientConnectionWhere>;
};

export type FlexEntityPatientFieldInput = {
	connect?: InputMaybe<FlexEntityPatientConnectFieldInput>;
	create?: InputMaybe<FlexEntityPatientCreateFieldInput>;
};

export type FlexEntityPatientNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<FlexEntityPatientNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<FlexEntityPatientNodeAggregationWhereInput>>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	initials_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	initials_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	initials_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	initials_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	initials_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	initials_EQUAL?: InputMaybe<Scalars["String"]>;
	initials_GT?: InputMaybe<Scalars["Int"]>;
	initials_GTE?: InputMaybe<Scalars["Int"]>;
	initials_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	initials_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	initials_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	initials_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	initials_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	initials_LT?: InputMaybe<Scalars["Int"]>;
	initials_LTE?: InputMaybe<Scalars["Int"]>;
	initials_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	initials_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	initials_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	initials_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	initials_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	insuranceId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	insuranceId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	insuranceId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	insuranceId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	insuranceId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	insuranceId_EQUAL?: InputMaybe<Scalars["String"]>;
	insuranceId_GT?: InputMaybe<Scalars["Int"]>;
	insuranceId_GTE?: InputMaybe<Scalars["Int"]>;
	insuranceId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	insuranceId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	insuranceId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	insuranceId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	insuranceId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	insuranceId_LT?: InputMaybe<Scalars["Int"]>;
	insuranceId_LTE?: InputMaybe<Scalars["Int"]>;
	insuranceId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	insuranceId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	insuranceId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	insuranceId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	insuranceId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	tenantId_EQUAL?: InputMaybe<Scalars["String"]>;
	tenantId_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	timeStamp_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	timeStamp_GT?: InputMaybe<Scalars["DateTime"]>;
	timeStamp_GTE?: InputMaybe<Scalars["DateTime"]>;
	timeStamp_LT?: InputMaybe<Scalars["DateTime"]>;
	timeStamp_LTE?: InputMaybe<Scalars["DateTime"]>;
	timeStamp_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	timeStamp_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	timeStamp_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	timeStamp_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	timeStamp_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	timeStamp_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	timeStamp_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	timeStamp_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	timeStamp_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	timeStamp_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	yearOfBirth_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	yearOfBirth_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	yearOfBirth_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	yearOfBirth_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	yearOfBirth_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	yearOfBirth_EQUAL?: InputMaybe<Scalars["Int"]>;
	yearOfBirth_GT?: InputMaybe<Scalars["Int"]>;
	yearOfBirth_GTE?: InputMaybe<Scalars["Int"]>;
	yearOfBirth_LT?: InputMaybe<Scalars["Int"]>;
	yearOfBirth_LTE?: InputMaybe<Scalars["Int"]>;
	yearOfBirth_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	yearOfBirth_MAX_GT?: InputMaybe<Scalars["Int"]>;
	yearOfBirth_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	yearOfBirth_MAX_LT?: InputMaybe<Scalars["Int"]>;
	yearOfBirth_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	yearOfBirth_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	yearOfBirth_MIN_GT?: InputMaybe<Scalars["Int"]>;
	yearOfBirth_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	yearOfBirth_MIN_LT?: InputMaybe<Scalars["Int"]>;
	yearOfBirth_MIN_LTE?: InputMaybe<Scalars["Int"]>;
};

export type FlexEntityPatientRelationship = {
	__typename?: "FlexEntityPatientRelationship";
	cursor: Scalars["String"];
	node: Patient;
};

export type FlexEntityPatientUpdateConnectionInput = {
	node?: InputMaybe<PatientUpdateInput>;
};

export type FlexEntityPatientUpdateFieldInput = {
	connect?: InputMaybe<FlexEntityPatientConnectFieldInput>;
	create?: InputMaybe<FlexEntityPatientCreateFieldInput>;
	delete?: InputMaybe<FlexEntityPatientDeleteFieldInput>;
	disconnect?: InputMaybe<FlexEntityPatientDisconnectFieldInput>;
	update?: InputMaybe<FlexEntityPatientUpdateConnectionInput>;
	where?: InputMaybe<FlexEntityPatientConnectionWhere>;
};

/** Fields to sort FlexEntities by. The order in which sorts are applied is not guaranteed when specifying many fields in one FlexEntitySort object. */
export type FlexEntitySort = {
	administrationDate?: InputMaybe<SortDirection>;
	containerType?: InputMaybe<SortDirection>;
	createdByName?: InputMaybe<SortDirection>;
	createdOn?: InputMaybe<SortDirection>;
	data?: InputMaybe<SortDirection>;
	id?: InputMaybe<SortDirection>;
	isArchived?: InputMaybe<SortDirection>;
	isDeleted?: InputMaybe<SortDirection>;
	isStartingPoint?: InputMaybe<SortDirection>;
	lastUpdatedOn?: InputMaybe<SortDirection>;
	occurrence?: InputMaybe<SortDirection>;
	patientId?: InputMaybe<SortDirection>;
	preparationBrandNames?: InputMaybe<SortDirection>;
	preparationGenericNames?: InputMaybe<SortDirection>;
	prescriptionDate?: InputMaybe<SortDirection>;
	quantity?: InputMaybe<SortDirection>;
	rating?: InputMaybe<SortDirection>;
	status?: InputMaybe<SortDirection>;
	tenantId?: InputMaybe<SortDirection>;
	unlimited?: InputMaybe<SortDirection>;
	uuid?: InputMaybe<SortDirection>;
};

export type FlexEntitySourceAggregateInput = {
	AND?: InputMaybe<Array<FlexEntitySourceAggregateInput>>;
	OR?: InputMaybe<Array<FlexEntitySourceAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<FlexEntitySourceNodeAggregationWhereInput>;
};

export type FlexEntitySourceConnectFieldInput = {
	connect?: InputMaybe<FlexEntityConnectInput>;
	where?: InputMaybe<FlexEntityConnectWhere>;
};

export type FlexEntitySourceConnection = {
	__typename?: "FlexEntitySourceConnection";
	edges: Array<FlexEntitySourceRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type FlexEntitySourceConnectionSort = {
	node?: InputMaybe<FlexEntitySort>;
};

export type FlexEntitySourceConnectionWhere = {
	AND?: InputMaybe<Array<FlexEntitySourceConnectionWhere>>;
	OR?: InputMaybe<Array<FlexEntitySourceConnectionWhere>>;
	node?: InputMaybe<FlexEntityWhere>;
	node_NOT?: InputMaybe<FlexEntityWhere>;
};

export type FlexEntitySourceCreateFieldInput = {
	node: FlexEntityCreateInput;
};

export type FlexEntitySourceDeleteFieldInput = {
	delete?: InputMaybe<FlexEntityDeleteInput>;
	where?: InputMaybe<FlexEntitySourceConnectionWhere>;
};

export type FlexEntitySourceDisconnectFieldInput = {
	disconnect?: InputMaybe<FlexEntityDisconnectInput>;
	where?: InputMaybe<FlexEntitySourceConnectionWhere>;
};

export type FlexEntitySourceFieldInput = {
	connect?: InputMaybe<FlexEntitySourceConnectFieldInput>;
	create?: InputMaybe<FlexEntitySourceCreateFieldInput>;
};

export type FlexEntitySourceNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<FlexEntitySourceNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<FlexEntitySourceNodeAggregationWhereInput>>;
	administrationDate_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_GT?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_GTE?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_LT?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_LTE?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdByName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	createdByName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	createdByName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	createdByName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	createdByName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	createdByName_EQUAL?: InputMaybe<Scalars["String"]>;
	createdByName_GT?: InputMaybe<Scalars["Int"]>;
	createdByName_GTE?: InputMaybe<Scalars["Int"]>;
	createdByName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	createdByName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	createdByName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	createdByName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	createdByName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	createdByName_LT?: InputMaybe<Scalars["Int"]>;
	createdByName_LTE?: InputMaybe<Scalars["Int"]>;
	createdByName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	createdByName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	createdByName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	createdByName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	createdByName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	createdOn_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	data_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	data_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	data_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	data_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	data_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	data_EQUAL?: InputMaybe<Scalars["String"]>;
	data_GT?: InputMaybe<Scalars["Int"]>;
	data_GTE?: InputMaybe<Scalars["Int"]>;
	data_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	data_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	data_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	data_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	data_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	data_LT?: InputMaybe<Scalars["Int"]>;
	data_LTE?: InputMaybe<Scalars["Int"]>;
	data_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	data_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	data_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	data_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	data_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	lastUpdatedOn_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_GT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_LT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	patientId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	patientId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	patientId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	patientId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	patientId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	patientId_EQUAL?: InputMaybe<Scalars["String"]>;
	patientId_GT?: InputMaybe<Scalars["Int"]>;
	patientId_GTE?: InputMaybe<Scalars["Int"]>;
	patientId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	patientId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	patientId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	patientId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	patientId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	patientId_LT?: InputMaybe<Scalars["Int"]>;
	patientId_LTE?: InputMaybe<Scalars["Int"]>;
	patientId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	patientId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	patientId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	patientId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	patientId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	preparationBrandNames_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	preparationBrandNames_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	preparationBrandNames_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	preparationBrandNames_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	preparationBrandNames_EQUAL?: InputMaybe<Scalars["String"]>;
	preparationBrandNames_GT?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_GTE?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_LT?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_LTE?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	preparationGenericNames_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	preparationGenericNames_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	preparationGenericNames_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	preparationGenericNames_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	preparationGenericNames_EQUAL?: InputMaybe<Scalars["String"]>;
	preparationGenericNames_GT?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_GTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_LT?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_LTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	quantity_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	quantity_EQUAL?: InputMaybe<Scalars["Int"]>;
	quantity_GT?: InputMaybe<Scalars["Int"]>;
	quantity_GTE?: InputMaybe<Scalars["Int"]>;
	quantity_LT?: InputMaybe<Scalars["Int"]>;
	quantity_LTE?: InputMaybe<Scalars["Int"]>;
	quantity_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	quantity_MAX_GT?: InputMaybe<Scalars["Int"]>;
	quantity_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	quantity_MAX_LT?: InputMaybe<Scalars["Int"]>;
	quantity_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	quantity_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	quantity_MIN_GT?: InputMaybe<Scalars["Int"]>;
	quantity_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	quantity_MIN_LT?: InputMaybe<Scalars["Int"]>;
	quantity_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	tenantId_EQUAL?: InputMaybe<Scalars["String"]>;
	tenantId_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	unlimited_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	unlimited_EQUAL?: InputMaybe<Scalars["Int"]>;
	unlimited_GT?: InputMaybe<Scalars["Int"]>;
	unlimited_GTE?: InputMaybe<Scalars["Int"]>;
	unlimited_LT?: InputMaybe<Scalars["Int"]>;
	unlimited_LTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_GT?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_LT?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_GT?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_LT?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	uuid_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	uuid_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	uuid_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	uuid_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	uuid_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	uuid_EQUAL?: InputMaybe<Scalars["String"]>;
	uuid_GT?: InputMaybe<Scalars["Int"]>;
	uuid_GTE?: InputMaybe<Scalars["Int"]>;
	uuid_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	uuid_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	uuid_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	uuid_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	uuid_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	uuid_LT?: InputMaybe<Scalars["Int"]>;
	uuid_LTE?: InputMaybe<Scalars["Int"]>;
	uuid_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	uuid_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	uuid_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	uuid_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	uuid_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type FlexEntitySourceRelationship = {
	__typename?: "FlexEntitySourceRelationship";
	cursor: Scalars["String"];
	node: FlexEntity;
};

export type FlexEntitySourceUpdateConnectionInput = {
	node?: InputMaybe<FlexEntityUpdateInput>;
};

export type FlexEntitySourceUpdateFieldInput = {
	connect?: InputMaybe<FlexEntitySourceConnectFieldInput>;
	create?: InputMaybe<FlexEntitySourceCreateFieldInput>;
	delete?: InputMaybe<FlexEntitySourceDeleteFieldInput>;
	disconnect?: InputMaybe<FlexEntitySourceDisconnectFieldInput>;
	update?: InputMaybe<FlexEntitySourceUpdateConnectionInput>;
	where?: InputMaybe<FlexEntitySourceConnectionWhere>;
};

export type FlexEntityStartingPointAggregateInput = {
	AND?: InputMaybe<Array<FlexEntityStartingPointAggregateInput>>;
	OR?: InputMaybe<Array<FlexEntityStartingPointAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<FlexEntityStartingPointNodeAggregationWhereInput>;
};

export type FlexEntityStartingPointConnectFieldInput = {
	connect?: InputMaybe<FlexEntityConnectInput>;
	where?: InputMaybe<FlexEntityConnectWhere>;
};

export type FlexEntityStartingPointConnection = {
	__typename?: "FlexEntityStartingPointConnection";
	edges: Array<FlexEntityStartingPointRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type FlexEntityStartingPointConnectionSort = {
	node?: InputMaybe<FlexEntitySort>;
};

export type FlexEntityStartingPointConnectionWhere = {
	AND?: InputMaybe<Array<FlexEntityStartingPointConnectionWhere>>;
	OR?: InputMaybe<Array<FlexEntityStartingPointConnectionWhere>>;
	node?: InputMaybe<FlexEntityWhere>;
	node_NOT?: InputMaybe<FlexEntityWhere>;
};

export type FlexEntityStartingPointCreateFieldInput = {
	node: FlexEntityCreateInput;
};

export type FlexEntityStartingPointDeleteFieldInput = {
	delete?: InputMaybe<FlexEntityDeleteInput>;
	where?: InputMaybe<FlexEntityStartingPointConnectionWhere>;
};

export type FlexEntityStartingPointDisconnectFieldInput = {
	disconnect?: InputMaybe<FlexEntityDisconnectInput>;
	where?: InputMaybe<FlexEntityStartingPointConnectionWhere>;
};

export type FlexEntityStartingPointFieldInput = {
	connect?: InputMaybe<FlexEntityStartingPointConnectFieldInput>;
	create?: InputMaybe<FlexEntityStartingPointCreateFieldInput>;
};

export type FlexEntityStartingPointNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<FlexEntityStartingPointNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<FlexEntityStartingPointNodeAggregationWhereInput>>;
	administrationDate_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_GT?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_GTE?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_LT?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_LTE?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdByName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	createdByName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	createdByName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	createdByName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	createdByName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	createdByName_EQUAL?: InputMaybe<Scalars["String"]>;
	createdByName_GT?: InputMaybe<Scalars["Int"]>;
	createdByName_GTE?: InputMaybe<Scalars["Int"]>;
	createdByName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	createdByName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	createdByName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	createdByName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	createdByName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	createdByName_LT?: InputMaybe<Scalars["Int"]>;
	createdByName_LTE?: InputMaybe<Scalars["Int"]>;
	createdByName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	createdByName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	createdByName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	createdByName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	createdByName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	createdOn_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	data_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	data_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	data_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	data_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	data_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	data_EQUAL?: InputMaybe<Scalars["String"]>;
	data_GT?: InputMaybe<Scalars["Int"]>;
	data_GTE?: InputMaybe<Scalars["Int"]>;
	data_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	data_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	data_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	data_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	data_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	data_LT?: InputMaybe<Scalars["Int"]>;
	data_LTE?: InputMaybe<Scalars["Int"]>;
	data_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	data_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	data_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	data_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	data_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	lastUpdatedOn_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_GT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_LT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	patientId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	patientId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	patientId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	patientId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	patientId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	patientId_EQUAL?: InputMaybe<Scalars["String"]>;
	patientId_GT?: InputMaybe<Scalars["Int"]>;
	patientId_GTE?: InputMaybe<Scalars["Int"]>;
	patientId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	patientId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	patientId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	patientId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	patientId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	patientId_LT?: InputMaybe<Scalars["Int"]>;
	patientId_LTE?: InputMaybe<Scalars["Int"]>;
	patientId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	patientId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	patientId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	patientId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	patientId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	preparationBrandNames_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	preparationBrandNames_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	preparationBrandNames_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	preparationBrandNames_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	preparationBrandNames_EQUAL?: InputMaybe<Scalars["String"]>;
	preparationBrandNames_GT?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_GTE?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_LT?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_LTE?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	preparationGenericNames_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	preparationGenericNames_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	preparationGenericNames_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	preparationGenericNames_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	preparationGenericNames_EQUAL?: InputMaybe<Scalars["String"]>;
	preparationGenericNames_GT?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_GTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_LT?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_LTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	quantity_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	quantity_EQUAL?: InputMaybe<Scalars["Int"]>;
	quantity_GT?: InputMaybe<Scalars["Int"]>;
	quantity_GTE?: InputMaybe<Scalars["Int"]>;
	quantity_LT?: InputMaybe<Scalars["Int"]>;
	quantity_LTE?: InputMaybe<Scalars["Int"]>;
	quantity_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	quantity_MAX_GT?: InputMaybe<Scalars["Int"]>;
	quantity_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	quantity_MAX_LT?: InputMaybe<Scalars["Int"]>;
	quantity_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	quantity_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	quantity_MIN_GT?: InputMaybe<Scalars["Int"]>;
	quantity_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	quantity_MIN_LT?: InputMaybe<Scalars["Int"]>;
	quantity_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	tenantId_EQUAL?: InputMaybe<Scalars["String"]>;
	tenantId_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	unlimited_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	unlimited_EQUAL?: InputMaybe<Scalars["Int"]>;
	unlimited_GT?: InputMaybe<Scalars["Int"]>;
	unlimited_GTE?: InputMaybe<Scalars["Int"]>;
	unlimited_LT?: InputMaybe<Scalars["Int"]>;
	unlimited_LTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_GT?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_LT?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_GT?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_LT?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	uuid_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	uuid_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	uuid_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	uuid_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	uuid_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	uuid_EQUAL?: InputMaybe<Scalars["String"]>;
	uuid_GT?: InputMaybe<Scalars["Int"]>;
	uuid_GTE?: InputMaybe<Scalars["Int"]>;
	uuid_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	uuid_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	uuid_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	uuid_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	uuid_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	uuid_LT?: InputMaybe<Scalars["Int"]>;
	uuid_LTE?: InputMaybe<Scalars["Int"]>;
	uuid_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	uuid_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	uuid_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	uuid_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	uuid_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type FlexEntityStartingPointRelationship = {
	__typename?: "FlexEntityStartingPointRelationship";
	cursor: Scalars["String"];
	node: FlexEntity;
};

export type FlexEntityStartingPointUpdateConnectionInput = {
	node?: InputMaybe<FlexEntityUpdateInput>;
};

export type FlexEntityStartingPointUpdateFieldInput = {
	connect?: InputMaybe<FlexEntityStartingPointConnectFieldInput>;
	create?: InputMaybe<FlexEntityStartingPointCreateFieldInput>;
	delete?: InputMaybe<FlexEntityStartingPointDeleteFieldInput>;
	disconnect?: InputMaybe<FlexEntityStartingPointDisconnectFieldInput>;
	update?: InputMaybe<FlexEntityStartingPointUpdateConnectionInput>;
	where?: InputMaybe<FlexEntityStartingPointConnectionWhere>;
};

export type FlexEntityType = {
	__typename?: "FlexEntityType";
	addedBy: User;
	addedByConnection: FlexEntityTypeAddedByConnection;
	addedByName: Scalars["String"];
	attributeCount: Scalars["Int"];
	containerType: FlexContainerType;
	createdOn: Scalars["DateTime"];
	creationWays: Array<DataContainerCreationWay>;
	data: Scalars["String"];
	description: Scalars["String"];
	features: Array<FlexEntityFeature>;
	id: Scalars["ID"];
	idPrefix: Scalars["String"];
	instances: Array<FlexEntity>;
	instancesConnection: FlexEntityTypeInstancesConnection;
	isArchived: Scalars["Boolean"];
	isOptional: Scalars["Boolean"];
	isStartingPoint: Scalars["Boolean"];
	name: Scalars["String"];
	tooltipText?: Maybe<Scalars["String"]>;
};

export type FlexEntityTypeAddedByArgs = {
	options?: InputMaybe<UserOptions>;
	where?: InputMaybe<UserWhere>;
};

export type FlexEntityTypeAddedByConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<FlexEntityTypeAddedByConnectionSort>>;
	where?: InputMaybe<FlexEntityTypeAddedByConnectionWhere>;
};

export type FlexEntityTypeInstancesArgs = {
	options?: InputMaybe<FlexEntityOptions>;
	where?: InputMaybe<FlexEntityWhere>;
};

export type FlexEntityTypeInstancesConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<FlexEntityTypeInstancesConnectionSort>>;
	where?: InputMaybe<FlexEntityTypeInstancesConnectionWhere>;
};

export type FlexEntityTypeAddedByAggregateInput = {
	AND?: InputMaybe<Array<FlexEntityTypeAddedByAggregateInput>>;
	OR?: InputMaybe<Array<FlexEntityTypeAddedByAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<FlexEntityTypeAddedByNodeAggregationWhereInput>;
};

export type FlexEntityTypeAddedByConnectFieldInput = {
	connect?: InputMaybe<UserConnectInput>;
	where?: InputMaybe<UserConnectWhere>;
};

export type FlexEntityTypeAddedByConnection = {
	__typename?: "FlexEntityTypeAddedByConnection";
	edges: Array<FlexEntityTypeAddedByRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type FlexEntityTypeAddedByConnectionSort = {
	node?: InputMaybe<UserSort>;
};

export type FlexEntityTypeAddedByConnectionWhere = {
	AND?: InputMaybe<Array<FlexEntityTypeAddedByConnectionWhere>>;
	OR?: InputMaybe<Array<FlexEntityTypeAddedByConnectionWhere>>;
	node?: InputMaybe<UserWhere>;
	node_NOT?: InputMaybe<UserWhere>;
};

export type FlexEntityTypeAddedByCreateFieldInput = {
	node: UserCreateInput;
};

export type FlexEntityTypeAddedByDeleteFieldInput = {
	delete?: InputMaybe<UserDeleteInput>;
	where?: InputMaybe<FlexEntityTypeAddedByConnectionWhere>;
};

export type FlexEntityTypeAddedByDisconnectFieldInput = {
	disconnect?: InputMaybe<UserDisconnectInput>;
	where?: InputMaybe<FlexEntityTypeAddedByConnectionWhere>;
};

export type FlexEntityTypeAddedByFieldInput = {
	connect?: InputMaybe<FlexEntityTypeAddedByConnectFieldInput>;
	create?: InputMaybe<FlexEntityTypeAddedByCreateFieldInput>;
};

export type FlexEntityTypeAddedByNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<FlexEntityTypeAddedByNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<FlexEntityTypeAddedByNodeAggregationWhereInput>>;
	email_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	email_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	email_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	email_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	email_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	email_EQUAL?: InputMaybe<Scalars["String"]>;
	email_GT?: InputMaybe<Scalars["Int"]>;
	email_GTE?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	email_LT?: InputMaybe<Scalars["Int"]>;
	email_LTE?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	firstName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	firstName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	firstName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	firstName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	firstName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	firstName_EQUAL?: InputMaybe<Scalars["String"]>;
	firstName_GT?: InputMaybe<Scalars["Int"]>;
	firstName_GTE?: InputMaybe<Scalars["Int"]>;
	firstName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	firstName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	firstName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	firstName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	firstName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	firstName_LT?: InputMaybe<Scalars["Int"]>;
	firstName_LTE?: InputMaybe<Scalars["Int"]>;
	firstName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	firstName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	firstName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	firstName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	firstName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	lastName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	lastName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	lastName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	lastName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	lastName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	lastName_EQUAL?: InputMaybe<Scalars["String"]>;
	lastName_GT?: InputMaybe<Scalars["Int"]>;
	lastName_GTE?: InputMaybe<Scalars["Int"]>;
	lastName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	lastName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	lastName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	lastName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	lastName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	lastName_LT?: InputMaybe<Scalars["Int"]>;
	lastName_LTE?: InputMaybe<Scalars["Int"]>;
	lastName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	lastName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	lastName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	lastName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	lastName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	preferredLanguage_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	preferredLanguage_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	preferredLanguage_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	preferredLanguage_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	preferredLanguage_EQUAL?: InputMaybe<Scalars["String"]>;
	preferredLanguage_GT?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_GTE?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LT?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LTE?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	tenantId_EQUAL?: InputMaybe<Scalars["String"]>;
	tenantId_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type FlexEntityTypeAddedByRelationship = {
	__typename?: "FlexEntityTypeAddedByRelationship";
	cursor: Scalars["String"];
	node: User;
};

export type FlexEntityTypeAddedByUpdateConnectionInput = {
	node?: InputMaybe<UserUpdateInput>;
};

export type FlexEntityTypeAddedByUpdateFieldInput = {
	connect?: InputMaybe<FlexEntityTypeAddedByConnectFieldInput>;
	create?: InputMaybe<FlexEntityTypeAddedByCreateFieldInput>;
	delete?: InputMaybe<FlexEntityTypeAddedByDeleteFieldInput>;
	disconnect?: InputMaybe<FlexEntityTypeAddedByDisconnectFieldInput>;
	update?: InputMaybe<FlexEntityTypeAddedByUpdateConnectionInput>;
	where?: InputMaybe<FlexEntityTypeAddedByConnectionWhere>;
};

export type FlexEntityTypeAggregateInput = {
	AND?: InputMaybe<Array<FlexEntityTypeAggregateInput>>;
	OR?: InputMaybe<Array<FlexEntityTypeAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<FlexEntityTypeNodeAggregationWhereInput>;
};

export type FlexEntityTypeAggregateSelection = {
	__typename?: "FlexEntityTypeAggregateSelection";
	addedByName: StringAggregateSelection;
	attributeCount: IntAggregateSelection;
	count: Scalars["Int"];
	createdOn: DateTimeAggregateSelection;
	data: StringAggregateSelection;
	description: StringAggregateSelection;
	id: IdAggregateSelection;
	idPrefix: StringAggregateSelection;
	name: StringAggregateSelection;
	tooltipText: StringAggregateSelection;
};

export type FlexEntityTypeConnectFieldInput = {
	connect?: InputMaybe<FlexEntityTypeConnectInput>;
	where?: InputMaybe<FlexEntityTypeConnectWhere>;
};

export type FlexEntityTypeConnectInput = {
	addedBy?: InputMaybe<FlexEntityTypeAddedByConnectFieldInput>;
	instances?: InputMaybe<Array<FlexEntityTypeInstancesConnectFieldInput>>;
};

export type FlexEntityTypeConnectWhere = {
	node: FlexEntityTypeWhere;
};

export type FlexEntityTypeConnection = {
	__typename?: "FlexEntityTypeConnection";
	edges: Array<FlexEntityTypeRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type FlexEntityTypeConnectionSort = {
	node?: InputMaybe<FlexEntityTypeSort>;
};

export type FlexEntityTypeConnectionWhere = {
	AND?: InputMaybe<Array<FlexEntityTypeConnectionWhere>>;
	OR?: InputMaybe<Array<FlexEntityTypeConnectionWhere>>;
	node?: InputMaybe<FlexEntityTypeWhere>;
	node_NOT?: InputMaybe<FlexEntityTypeWhere>;
};

export type FlexEntityTypeCreateFieldInput = {
	node: FlexEntityTypeCreateInput;
};

export type FlexEntityTypeCreateInput = {
	addedBy?: InputMaybe<FlexEntityTypeAddedByFieldInput>;
	addedByName: Scalars["String"];
	attributeCount: Scalars["Int"];
	containerType: FlexContainerType;
	createdOn: Scalars["DateTime"];
	creationWays: Array<DataContainerCreationWay>;
	data: Scalars["String"];
	description: Scalars["String"];
	features: Array<FlexEntityFeature>;
	id: Scalars["ID"];
	idPrefix: Scalars["String"];
	instances?: InputMaybe<FlexEntityTypeInstancesFieldInput>;
	isArchived: Scalars["Boolean"];
	isOptional: Scalars["Boolean"];
	isStartingPoint: Scalars["Boolean"];
	name: Scalars["String"];
	tooltipText?: InputMaybe<Scalars["String"]>;
};

export type FlexEntityTypeDeleteFieldInput = {
	delete?: InputMaybe<FlexEntityTypeDeleteInput>;
	where?: InputMaybe<FlexEntityTypeConnectionWhere>;
};

export type FlexEntityTypeDeleteInput = {
	addedBy?: InputMaybe<FlexEntityTypeAddedByDeleteFieldInput>;
	instances?: InputMaybe<Array<FlexEntityTypeInstancesDeleteFieldInput>>;
};

export type FlexEntityTypeDisconnectFieldInput = {
	disconnect?: InputMaybe<FlexEntityTypeDisconnectInput>;
	where?: InputMaybe<FlexEntityTypeConnectionWhere>;
};

export type FlexEntityTypeDisconnectInput = {
	addedBy?: InputMaybe<FlexEntityTypeAddedByDisconnectFieldInput>;
	instances?: InputMaybe<Array<FlexEntityTypeInstancesDisconnectFieldInput>>;
};

export type FlexEntityTypeFieldInput = {
	connect?: InputMaybe<FlexEntityTypeConnectFieldInput>;
	create?: InputMaybe<FlexEntityTypeCreateFieldInput>;
};

export type FlexEntityTypeInstancesAggregateInput = {
	AND?: InputMaybe<Array<FlexEntityTypeInstancesAggregateInput>>;
	OR?: InputMaybe<Array<FlexEntityTypeInstancesAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<FlexEntityTypeInstancesNodeAggregationWhereInput>;
};

export type FlexEntityTypeInstancesConnectFieldInput = {
	connect?: InputMaybe<Array<FlexEntityConnectInput>>;
	where?: InputMaybe<FlexEntityConnectWhere>;
};

export type FlexEntityTypeInstancesConnection = {
	__typename?: "FlexEntityTypeInstancesConnection";
	edges: Array<FlexEntityTypeInstancesRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type FlexEntityTypeInstancesConnectionSort = {
	node?: InputMaybe<FlexEntitySort>;
};

export type FlexEntityTypeInstancesConnectionWhere = {
	AND?: InputMaybe<Array<FlexEntityTypeInstancesConnectionWhere>>;
	OR?: InputMaybe<Array<FlexEntityTypeInstancesConnectionWhere>>;
	node?: InputMaybe<FlexEntityWhere>;
	node_NOT?: InputMaybe<FlexEntityWhere>;
};

export type FlexEntityTypeInstancesCreateFieldInput = {
	node: FlexEntityCreateInput;
};

export type FlexEntityTypeInstancesDeleteFieldInput = {
	delete?: InputMaybe<FlexEntityDeleteInput>;
	where?: InputMaybe<FlexEntityTypeInstancesConnectionWhere>;
};

export type FlexEntityTypeInstancesDisconnectFieldInput = {
	disconnect?: InputMaybe<FlexEntityDisconnectInput>;
	where?: InputMaybe<FlexEntityTypeInstancesConnectionWhere>;
};

export type FlexEntityTypeInstancesFieldInput = {
	connect?: InputMaybe<Array<FlexEntityTypeInstancesConnectFieldInput>>;
	create?: InputMaybe<Array<FlexEntityTypeInstancesCreateFieldInput>>;
};

export type FlexEntityTypeInstancesNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<FlexEntityTypeInstancesNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<FlexEntityTypeInstancesNodeAggregationWhereInput>>;
	administrationDate_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_GT?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_GTE?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_LT?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_LTE?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdByName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	createdByName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	createdByName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	createdByName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	createdByName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	createdByName_EQUAL?: InputMaybe<Scalars["String"]>;
	createdByName_GT?: InputMaybe<Scalars["Int"]>;
	createdByName_GTE?: InputMaybe<Scalars["Int"]>;
	createdByName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	createdByName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	createdByName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	createdByName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	createdByName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	createdByName_LT?: InputMaybe<Scalars["Int"]>;
	createdByName_LTE?: InputMaybe<Scalars["Int"]>;
	createdByName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	createdByName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	createdByName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	createdByName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	createdByName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	createdOn_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	data_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	data_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	data_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	data_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	data_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	data_EQUAL?: InputMaybe<Scalars["String"]>;
	data_GT?: InputMaybe<Scalars["Int"]>;
	data_GTE?: InputMaybe<Scalars["Int"]>;
	data_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	data_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	data_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	data_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	data_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	data_LT?: InputMaybe<Scalars["Int"]>;
	data_LTE?: InputMaybe<Scalars["Int"]>;
	data_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	data_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	data_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	data_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	data_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	lastUpdatedOn_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_GT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_LT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	patientId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	patientId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	patientId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	patientId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	patientId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	patientId_EQUAL?: InputMaybe<Scalars["String"]>;
	patientId_GT?: InputMaybe<Scalars["Int"]>;
	patientId_GTE?: InputMaybe<Scalars["Int"]>;
	patientId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	patientId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	patientId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	patientId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	patientId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	patientId_LT?: InputMaybe<Scalars["Int"]>;
	patientId_LTE?: InputMaybe<Scalars["Int"]>;
	patientId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	patientId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	patientId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	patientId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	patientId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	preparationBrandNames_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	preparationBrandNames_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	preparationBrandNames_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	preparationBrandNames_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	preparationBrandNames_EQUAL?: InputMaybe<Scalars["String"]>;
	preparationBrandNames_GT?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_GTE?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_LT?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_LTE?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	preparationGenericNames_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	preparationGenericNames_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	preparationGenericNames_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	preparationGenericNames_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	preparationGenericNames_EQUAL?: InputMaybe<Scalars["String"]>;
	preparationGenericNames_GT?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_GTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_LT?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_LTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	quantity_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	quantity_EQUAL?: InputMaybe<Scalars["Int"]>;
	quantity_GT?: InputMaybe<Scalars["Int"]>;
	quantity_GTE?: InputMaybe<Scalars["Int"]>;
	quantity_LT?: InputMaybe<Scalars["Int"]>;
	quantity_LTE?: InputMaybe<Scalars["Int"]>;
	quantity_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	quantity_MAX_GT?: InputMaybe<Scalars["Int"]>;
	quantity_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	quantity_MAX_LT?: InputMaybe<Scalars["Int"]>;
	quantity_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	quantity_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	quantity_MIN_GT?: InputMaybe<Scalars["Int"]>;
	quantity_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	quantity_MIN_LT?: InputMaybe<Scalars["Int"]>;
	quantity_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	tenantId_EQUAL?: InputMaybe<Scalars["String"]>;
	tenantId_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	unlimited_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	unlimited_EQUAL?: InputMaybe<Scalars["Int"]>;
	unlimited_GT?: InputMaybe<Scalars["Int"]>;
	unlimited_GTE?: InputMaybe<Scalars["Int"]>;
	unlimited_LT?: InputMaybe<Scalars["Int"]>;
	unlimited_LTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_GT?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_LT?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_GT?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_LT?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	uuid_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	uuid_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	uuid_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	uuid_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	uuid_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	uuid_EQUAL?: InputMaybe<Scalars["String"]>;
	uuid_GT?: InputMaybe<Scalars["Int"]>;
	uuid_GTE?: InputMaybe<Scalars["Int"]>;
	uuid_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	uuid_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	uuid_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	uuid_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	uuid_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	uuid_LT?: InputMaybe<Scalars["Int"]>;
	uuid_LTE?: InputMaybe<Scalars["Int"]>;
	uuid_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	uuid_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	uuid_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	uuid_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	uuid_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type FlexEntityTypeInstancesRelationship = {
	__typename?: "FlexEntityTypeInstancesRelationship";
	cursor: Scalars["String"];
	node: FlexEntity;
};

export type FlexEntityTypeInstancesUpdateConnectionInput = {
	node?: InputMaybe<FlexEntityUpdateInput>;
};

export type FlexEntityTypeInstancesUpdateFieldInput = {
	connect?: InputMaybe<Array<FlexEntityTypeInstancesConnectFieldInput>>;
	create?: InputMaybe<Array<FlexEntityTypeInstancesCreateFieldInput>>;
	delete?: InputMaybe<Array<FlexEntityTypeInstancesDeleteFieldInput>>;
	disconnect?: InputMaybe<Array<FlexEntityTypeInstancesDisconnectFieldInput>>;
	update?: InputMaybe<FlexEntityTypeInstancesUpdateConnectionInput>;
	where?: InputMaybe<FlexEntityTypeInstancesConnectionWhere>;
};

export type FlexEntityTypeNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<FlexEntityTypeNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<FlexEntityTypeNodeAggregationWhereInput>>;
	addedByName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	addedByName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	addedByName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	addedByName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	addedByName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	addedByName_EQUAL?: InputMaybe<Scalars["String"]>;
	addedByName_GT?: InputMaybe<Scalars["Int"]>;
	addedByName_GTE?: InputMaybe<Scalars["Int"]>;
	addedByName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	addedByName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	addedByName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	addedByName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	addedByName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	addedByName_LT?: InputMaybe<Scalars["Int"]>;
	addedByName_LTE?: InputMaybe<Scalars["Int"]>;
	addedByName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	addedByName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	addedByName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	addedByName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	addedByName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	attributeCount_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	attributeCount_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	attributeCount_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	attributeCount_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	attributeCount_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	attributeCount_EQUAL?: InputMaybe<Scalars["Int"]>;
	attributeCount_GT?: InputMaybe<Scalars["Int"]>;
	attributeCount_GTE?: InputMaybe<Scalars["Int"]>;
	attributeCount_LT?: InputMaybe<Scalars["Int"]>;
	attributeCount_LTE?: InputMaybe<Scalars["Int"]>;
	attributeCount_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	attributeCount_MAX_GT?: InputMaybe<Scalars["Int"]>;
	attributeCount_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	attributeCount_MAX_LT?: InputMaybe<Scalars["Int"]>;
	attributeCount_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	attributeCount_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	attributeCount_MIN_GT?: InputMaybe<Scalars["Int"]>;
	attributeCount_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	attributeCount_MIN_LT?: InputMaybe<Scalars["Int"]>;
	attributeCount_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	createdOn_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	data_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	data_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	data_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	data_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	data_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	data_EQUAL?: InputMaybe<Scalars["String"]>;
	data_GT?: InputMaybe<Scalars["Int"]>;
	data_GTE?: InputMaybe<Scalars["Int"]>;
	data_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	data_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	data_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	data_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	data_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	data_LT?: InputMaybe<Scalars["Int"]>;
	data_LTE?: InputMaybe<Scalars["Int"]>;
	data_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	data_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	data_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	data_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	data_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	description_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	description_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	description_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	description_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	description_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	description_EQUAL?: InputMaybe<Scalars["String"]>;
	description_GT?: InputMaybe<Scalars["Int"]>;
	description_GTE?: InputMaybe<Scalars["Int"]>;
	description_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	description_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	description_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	description_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	description_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	description_LT?: InputMaybe<Scalars["Int"]>;
	description_LTE?: InputMaybe<Scalars["Int"]>;
	description_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	description_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	description_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	description_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	description_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	idPrefix_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	idPrefix_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	idPrefix_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	idPrefix_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	idPrefix_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	idPrefix_EQUAL?: InputMaybe<Scalars["String"]>;
	idPrefix_GT?: InputMaybe<Scalars["Int"]>;
	idPrefix_GTE?: InputMaybe<Scalars["Int"]>;
	idPrefix_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	idPrefix_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	idPrefix_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	idPrefix_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	idPrefix_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	idPrefix_LT?: InputMaybe<Scalars["Int"]>;
	idPrefix_LTE?: InputMaybe<Scalars["Int"]>;
	idPrefix_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	idPrefix_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	idPrefix_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	idPrefix_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	idPrefix_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	name_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	name_EQUAL?: InputMaybe<Scalars["String"]>;
	name_GT?: InputMaybe<Scalars["Int"]>;
	name_GTE?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	name_LT?: InputMaybe<Scalars["Int"]>;
	name_LTE?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	tooltipText_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	tooltipText_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	tooltipText_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	tooltipText_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	tooltipText_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	tooltipText_EQUAL?: InputMaybe<Scalars["String"]>;
	tooltipText_GT?: InputMaybe<Scalars["Int"]>;
	tooltipText_GTE?: InputMaybe<Scalars["Int"]>;
	tooltipText_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tooltipText_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	tooltipText_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	tooltipText_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	tooltipText_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	tooltipText_LT?: InputMaybe<Scalars["Int"]>;
	tooltipText_LTE?: InputMaybe<Scalars["Int"]>;
	tooltipText_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tooltipText_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	tooltipText_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	tooltipText_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	tooltipText_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type FlexEntityTypeOptions = {
	limit?: InputMaybe<Scalars["Int"]>;
	offset?: InputMaybe<Scalars["Int"]>;
	/** Specify one or more FlexEntityTypeSort objects to sort FlexEntityTypes by. The sorts will be applied in the order in which they are arranged in the array. */
	sort?: InputMaybe<Array<InputMaybe<FlexEntityTypeSort>>>;
};

export type FlexEntityTypeRelationship = {
	__typename?: "FlexEntityTypeRelationship";
	cursor: Scalars["String"];
	node: FlexEntityType;
};

/** Fields to sort FlexEntityTypes by. The order in which sorts are applied is not guaranteed when specifying many fields in one FlexEntityTypeSort object. */
export type FlexEntityTypeSort = {
	addedByName?: InputMaybe<SortDirection>;
	attributeCount?: InputMaybe<SortDirection>;
	containerType?: InputMaybe<SortDirection>;
	createdOn?: InputMaybe<SortDirection>;
	data?: InputMaybe<SortDirection>;
	description?: InputMaybe<SortDirection>;
	id?: InputMaybe<SortDirection>;
	idPrefix?: InputMaybe<SortDirection>;
	isArchived?: InputMaybe<SortDirection>;
	isOptional?: InputMaybe<SortDirection>;
	isStartingPoint?: InputMaybe<SortDirection>;
	name?: InputMaybe<SortDirection>;
	tooltipText?: InputMaybe<SortDirection>;
};

export type FlexEntityTypeUpdateConnectionInput = {
	node?: InputMaybe<FlexEntityTypeUpdateInput>;
};

export type FlexEntityTypeUpdateFieldInput = {
	connect?: InputMaybe<FlexEntityTypeConnectFieldInput>;
	create?: InputMaybe<FlexEntityTypeCreateFieldInput>;
	delete?: InputMaybe<FlexEntityTypeDeleteFieldInput>;
	disconnect?: InputMaybe<FlexEntityTypeDisconnectFieldInput>;
	update?: InputMaybe<FlexEntityTypeUpdateConnectionInput>;
	where?: InputMaybe<FlexEntityTypeConnectionWhere>;
};

export type FlexEntityTypeUpdateInput = {
	addedBy?: InputMaybe<FlexEntityTypeAddedByUpdateFieldInput>;
	addedByName?: InputMaybe<Scalars["String"]>;
	attributeCount?: InputMaybe<Scalars["Int"]>;
	containerType?: InputMaybe<FlexContainerType>;
	createdOn?: InputMaybe<Scalars["DateTime"]>;
	creationWays?: InputMaybe<Array<DataContainerCreationWay>>;
	data?: InputMaybe<Scalars["String"]>;
	description?: InputMaybe<Scalars["String"]>;
	features?: InputMaybe<Array<FlexEntityFeature>>;
	id?: InputMaybe<Scalars["ID"]>;
	idPrefix?: InputMaybe<Scalars["String"]>;
	instances?: InputMaybe<Array<FlexEntityTypeInstancesUpdateFieldInput>>;
	isArchived?: InputMaybe<Scalars["Boolean"]>;
	isOptional?: InputMaybe<Scalars["Boolean"]>;
	isStartingPoint?: InputMaybe<Scalars["Boolean"]>;
	name?: InputMaybe<Scalars["String"]>;
	tooltipText?: InputMaybe<Scalars["String"]>;
};

export type FlexEntityTypeWhere = {
	AND?: InputMaybe<Array<FlexEntityTypeWhere>>;
	OR?: InputMaybe<Array<FlexEntityTypeWhere>>;
	addedBy?: InputMaybe<UserWhere>;
	addedByAggregate?: InputMaybe<FlexEntityTypeAddedByAggregateInput>;
	addedByConnection?: InputMaybe<FlexEntityTypeAddedByConnectionWhere>;
	addedByConnection_NOT?: InputMaybe<FlexEntityTypeAddedByConnectionWhere>;
	addedByName?: InputMaybe<Scalars["String"]>;
	addedByName_CONTAINS?: InputMaybe<Scalars["String"]>;
	addedByName_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	addedByName_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	addedByName_MATCHES?: InputMaybe<Scalars["String"]>;
	addedByName_NOT?: InputMaybe<Scalars["String"]>;
	addedByName_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	addedByName_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	addedByName_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	addedByName_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	addedByName_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	addedBy_NOT?: InputMaybe<UserWhere>;
	attributeCount?: InputMaybe<Scalars["Int"]>;
	attributeCount_GT?: InputMaybe<Scalars["Int"]>;
	attributeCount_GTE?: InputMaybe<Scalars["Int"]>;
	attributeCount_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	attributeCount_LT?: InputMaybe<Scalars["Int"]>;
	attributeCount_LTE?: InputMaybe<Scalars["Int"]>;
	attributeCount_NOT?: InputMaybe<Scalars["Int"]>;
	attributeCount_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	containerType?: InputMaybe<FlexContainerType>;
	containerType_IN?: InputMaybe<Array<InputMaybe<FlexContainerType>>>;
	containerType_NOT?: InputMaybe<FlexContainerType>;
	containerType_NOT_IN?: InputMaybe<Array<InputMaybe<FlexContainerType>>>;
	createdOn?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_IN?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]>>>;
	createdOn_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_NOT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]>>>;
	creationWays?: InputMaybe<Array<DataContainerCreationWay>>;
	creationWays_INCLUDES?: InputMaybe<DataContainerCreationWay>;
	creationWays_NOT?: InputMaybe<Array<DataContainerCreationWay>>;
	creationWays_NOT_INCLUDES?: InputMaybe<DataContainerCreationWay>;
	data?: InputMaybe<Scalars["String"]>;
	data_CONTAINS?: InputMaybe<Scalars["String"]>;
	data_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	data_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	data_MATCHES?: InputMaybe<Scalars["String"]>;
	data_NOT?: InputMaybe<Scalars["String"]>;
	data_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	data_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	data_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	data_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	data_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	description?: InputMaybe<Scalars["String"]>;
	description_CONTAINS?: InputMaybe<Scalars["String"]>;
	description_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	description_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	description_MATCHES?: InputMaybe<Scalars["String"]>;
	description_NOT?: InputMaybe<Scalars["String"]>;
	description_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	description_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	description_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	description_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	description_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	features?: InputMaybe<Array<FlexEntityFeature>>;
	features_INCLUDES?: InputMaybe<FlexEntityFeature>;
	features_NOT?: InputMaybe<Array<FlexEntityFeature>>;
	features_NOT_INCLUDES?: InputMaybe<FlexEntityFeature>;
	id?: InputMaybe<Scalars["ID"]>;
	idPrefix?: InputMaybe<Scalars["String"]>;
	idPrefix_CONTAINS?: InputMaybe<Scalars["String"]>;
	idPrefix_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	idPrefix_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	idPrefix_MATCHES?: InputMaybe<Scalars["String"]>;
	idPrefix_NOT?: InputMaybe<Scalars["String"]>;
	idPrefix_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	idPrefix_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	idPrefix_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	idPrefix_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	idPrefix_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	id_CONTAINS?: InputMaybe<Scalars["ID"]>;
	id_ENDS_WITH?: InputMaybe<Scalars["ID"]>;
	id_IN?: InputMaybe<Array<InputMaybe<Scalars["ID"]>>>;
	id_MATCHES?: InputMaybe<Scalars["String"]>;
	id_NOT?: InputMaybe<Scalars["ID"]>;
	id_NOT_CONTAINS?: InputMaybe<Scalars["ID"]>;
	id_NOT_ENDS_WITH?: InputMaybe<Scalars["ID"]>;
	id_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["ID"]>>>;
	id_NOT_STARTS_WITH?: InputMaybe<Scalars["ID"]>;
	id_STARTS_WITH?: InputMaybe<Scalars["ID"]>;
	instances?: InputMaybe<FlexEntityWhere>;
	instancesAggregate?: InputMaybe<FlexEntityTypeInstancesAggregateInput>;
	instancesConnection?: InputMaybe<FlexEntityTypeInstancesConnectionWhere>;
	instancesConnection_NOT?: InputMaybe<FlexEntityTypeInstancesConnectionWhere>;
	instances_NOT?: InputMaybe<FlexEntityWhere>;
	isArchived?: InputMaybe<Scalars["Boolean"]>;
	isArchived_NOT?: InputMaybe<Scalars["Boolean"]>;
	isOptional?: InputMaybe<Scalars["Boolean"]>;
	isOptional_NOT?: InputMaybe<Scalars["Boolean"]>;
	isStartingPoint?: InputMaybe<Scalars["Boolean"]>;
	isStartingPoint_NOT?: InputMaybe<Scalars["Boolean"]>;
	name?: InputMaybe<Scalars["String"]>;
	name_CONTAINS?: InputMaybe<Scalars["String"]>;
	name_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	name_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	name_MATCHES?: InputMaybe<Scalars["String"]>;
	name_NOT?: InputMaybe<Scalars["String"]>;
	name_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	name_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	name_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	name_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	name_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	tooltipText?: InputMaybe<Scalars["String"]>;
	tooltipText_CONTAINS?: InputMaybe<Scalars["String"]>;
	tooltipText_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	tooltipText_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	tooltipText_MATCHES?: InputMaybe<Scalars["String"]>;
	tooltipText_NOT?: InputMaybe<Scalars["String"]>;
	tooltipText_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	tooltipText_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	tooltipText_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	tooltipText_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	tooltipText_STARTS_WITH?: InputMaybe<Scalars["String"]>;
};

export type FlexEntityUpdateInput = {
	administrationDate?: InputMaybe<Scalars["DateTime"]>;
	cases?: InputMaybe<Array<FlexEntityCasesUpdateFieldInput>>;
	children?: InputMaybe<Array<FlexEntityChildrenUpdateFieldInput>>;
	containerType?: InputMaybe<FlexContainerType>;
	createdBy?: InputMaybe<FlexEntityCreatedByUpdateFieldInput>;
	createdByName?: InputMaybe<Scalars["String"]>;
	createdOn?: InputMaybe<Scalars["DateTime"]>;
	data?: InputMaybe<Scalars["String"]>;
	financialDataPoints?: InputMaybe<Array<FlexEntityDataPointsUpdateFieldInput>>;
	id?: InputMaybe<Scalars["ID"]>;
	isArchived?: InputMaybe<Scalars["Boolean"]>;
	isDeleted?: InputMaybe<Scalars["Boolean"]>;
	isStartingPoint?: InputMaybe<Scalars["Boolean"]>;
	lastUpdatedOn?: InputMaybe<Scalars["DateTime"]>;
	occurrence?: InputMaybe<OccurrenceEnum>;
	patient?: InputMaybe<FlexEntityPatientUpdateFieldInput>;
	patientId?: InputMaybe<Scalars["String"]>;
	preparationBrandNames?: InputMaybe<Scalars["String"]>;
	preparationGenericNames?: InputMaybe<Scalars["String"]>;
	prescriptionDate?: InputMaybe<Scalars["Date"]>;
	quantity?: InputMaybe<Scalars["Int"]>;
	rating?: InputMaybe<CoverageRequestRating>;
	source?: InputMaybe<FlexEntitySourceUpdateFieldInput>;
	startingPoint?: InputMaybe<FlexEntityStartingPointUpdateFieldInput>;
	status?: InputMaybe<FlexFormStatus>;
	tenantId?: InputMaybe<Scalars["String"]>;
	type?: InputMaybe<FlexEntityTypeUpdateFieldInput>;
	unlimited?: InputMaybe<Scalars["Int"]>;
	uuid?: InputMaybe<Scalars["String"]>;
};

export type FlexEntityWhere = {
	AND?: InputMaybe<Array<FlexEntityWhere>>;
	OR?: InputMaybe<Array<FlexEntityWhere>>;
	administrationDate?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_GT?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_GTE?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_IN?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]>>>;
	administrationDate_LT?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_LTE?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_NOT?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]>>>;
	cases?: InputMaybe<CaseWhere>;
	casesAggregate?: InputMaybe<FlexEntityCasesAggregateInput>;
	casesConnection?: InputMaybe<FlexEntityCasesConnectionWhere>;
	casesConnection_NOT?: InputMaybe<FlexEntityCasesConnectionWhere>;
	cases_NOT?: InputMaybe<CaseWhere>;
	children?: InputMaybe<FlexEntityWhere>;
	childrenAggregate?: InputMaybe<FlexEntityChildrenAggregateInput>;
	childrenConnection?: InputMaybe<FlexEntityChildrenConnectionWhere>;
	childrenConnection_NOT?: InputMaybe<FlexEntityChildrenConnectionWhere>;
	children_NOT?: InputMaybe<FlexEntityWhere>;
	containerType?: InputMaybe<FlexContainerType>;
	containerType_IN?: InputMaybe<Array<InputMaybe<FlexContainerType>>>;
	containerType_NOT?: InputMaybe<FlexContainerType>;
	containerType_NOT_IN?: InputMaybe<Array<InputMaybe<FlexContainerType>>>;
	createdBy?: InputMaybe<UserWhere>;
	createdByAggregate?: InputMaybe<FlexEntityCreatedByAggregateInput>;
	createdByConnection?: InputMaybe<FlexEntityCreatedByConnectionWhere>;
	createdByConnection_NOT?: InputMaybe<FlexEntityCreatedByConnectionWhere>;
	createdByName?: InputMaybe<Scalars["String"]>;
	createdByName_CONTAINS?: InputMaybe<Scalars["String"]>;
	createdByName_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	createdByName_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	createdByName_MATCHES?: InputMaybe<Scalars["String"]>;
	createdByName_NOT?: InputMaybe<Scalars["String"]>;
	createdByName_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	createdByName_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	createdByName_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	createdByName_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	createdByName_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	createdBy_NOT?: InputMaybe<UserWhere>;
	createdOn?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_IN?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]>>>;
	createdOn_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_NOT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]>>>;
	data?: InputMaybe<Scalars["String"]>;
	financialDataPoints?: InputMaybe<FlexFinancialDataPointWhere>;
	dataPointsAggregate?: InputMaybe<FlexEntityDataPointsAggregateInput>;
	dataPointsConnection?: InputMaybe<FlexEntityDataPointsConnectionWhere>;
	dataPointsConnection_NOT?: InputMaybe<FlexEntityDataPointsConnectionWhere>;
	dataPoints_NOT?: InputMaybe<FlexFinancialDataPointWhere>;
	data_CONTAINS?: InputMaybe<Scalars["String"]>;
	data_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	data_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	data_MATCHES?: InputMaybe<Scalars["String"]>;
	data_NOT?: InputMaybe<Scalars["String"]>;
	data_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	data_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	data_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	data_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	data_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	id?: InputMaybe<Scalars["ID"]>;
	id_CONTAINS?: InputMaybe<Scalars["ID"]>;
	id_ENDS_WITH?: InputMaybe<Scalars["ID"]>;
	id_IN?: InputMaybe<Array<InputMaybe<Scalars["ID"]>>>;
	id_MATCHES?: InputMaybe<Scalars["String"]>;
	id_NOT?: InputMaybe<Scalars["ID"]>;
	id_NOT_CONTAINS?: InputMaybe<Scalars["ID"]>;
	id_NOT_ENDS_WITH?: InputMaybe<Scalars["ID"]>;
	id_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["ID"]>>>;
	id_NOT_STARTS_WITH?: InputMaybe<Scalars["ID"]>;
	id_STARTS_WITH?: InputMaybe<Scalars["ID"]>;
	isArchived?: InputMaybe<Scalars["Boolean"]>;
	isArchived_NOT?: InputMaybe<Scalars["Boolean"]>;
	isDeleted?: InputMaybe<Scalars["Boolean"]>;
	isDeleted_NOT?: InputMaybe<Scalars["Boolean"]>;
	isStartingPoint?: InputMaybe<Scalars["Boolean"]>;
	isStartingPoint_NOT?: InputMaybe<Scalars["Boolean"]>;
	lastUpdatedOn?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_GT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_IN?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]>>>;
	lastUpdatedOn_LT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_NOT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]>>>;
	occurrence?: InputMaybe<OccurrenceEnum>;
	occurrence_IN?: InputMaybe<Array<InputMaybe<OccurrenceEnum>>>;
	occurrence_NOT?: InputMaybe<OccurrenceEnum>;
	occurrence_NOT_IN?: InputMaybe<Array<InputMaybe<OccurrenceEnum>>>;
	patient?: InputMaybe<PatientWhere>;
	patientAggregate?: InputMaybe<FlexEntityPatientAggregateInput>;
	patientConnection?: InputMaybe<FlexEntityPatientConnectionWhere>;
	patientConnection_NOT?: InputMaybe<FlexEntityPatientConnectionWhere>;
	patientId?: InputMaybe<Scalars["String"]>;
	patientId_CONTAINS?: InputMaybe<Scalars["String"]>;
	patientId_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	patientId_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	patientId_MATCHES?: InputMaybe<Scalars["String"]>;
	patientId_NOT?: InputMaybe<Scalars["String"]>;
	patientId_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	patientId_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	patientId_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	patientId_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	patientId_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	patient_NOT?: InputMaybe<PatientWhere>;
	preparationBrandNames?: InputMaybe<Scalars["String"]>;
	preparationBrandNames_CONTAINS?: InputMaybe<Scalars["String"]>;
	preparationBrandNames_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	preparationBrandNames_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	preparationBrandNames_MATCHES?: InputMaybe<Scalars["String"]>;
	preparationBrandNames_NOT?: InputMaybe<Scalars["String"]>;
	preparationBrandNames_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	preparationBrandNames_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	preparationBrandNames_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	preparationBrandNames_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	preparationBrandNames_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	preparationGenericNames?: InputMaybe<Scalars["String"]>;
	preparationGenericNames_CONTAINS?: InputMaybe<Scalars["String"]>;
	preparationGenericNames_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	preparationGenericNames_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	preparationGenericNames_MATCHES?: InputMaybe<Scalars["String"]>;
	preparationGenericNames_NOT?: InputMaybe<Scalars["String"]>;
	preparationGenericNames_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	preparationGenericNames_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	preparationGenericNames_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	preparationGenericNames_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	preparationGenericNames_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	prescriptionDate?: InputMaybe<Scalars["Date"]>;
	prescriptionDate_GT?: InputMaybe<Scalars["Date"]>;
	prescriptionDate_GTE?: InputMaybe<Scalars["Date"]>;
	prescriptionDate_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
	prescriptionDate_LT?: InputMaybe<Scalars["Date"]>;
	prescriptionDate_LTE?: InputMaybe<Scalars["Date"]>;
	prescriptionDate_NOT?: InputMaybe<Scalars["Date"]>;
	prescriptionDate_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
	quantity?: InputMaybe<Scalars["Int"]>;
	quantity_GT?: InputMaybe<Scalars["Int"]>;
	quantity_GTE?: InputMaybe<Scalars["Int"]>;
	quantity_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	quantity_LT?: InputMaybe<Scalars["Int"]>;
	quantity_LTE?: InputMaybe<Scalars["Int"]>;
	quantity_NOT?: InputMaybe<Scalars["Int"]>;
	quantity_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	rating?: InputMaybe<CoverageRequestRating>;
	rating_IN?: InputMaybe<Array<InputMaybe<CoverageRequestRating>>>;
	rating_NOT?: InputMaybe<CoverageRequestRating>;
	rating_NOT_IN?: InputMaybe<Array<InputMaybe<CoverageRequestRating>>>;
	source?: InputMaybe<FlexEntityWhere>;
	sourceAggregate?: InputMaybe<FlexEntitySourceAggregateInput>;
	sourceConnection?: InputMaybe<FlexEntitySourceConnectionWhere>;
	sourceConnection_NOT?: InputMaybe<FlexEntitySourceConnectionWhere>;
	source_NOT?: InputMaybe<FlexEntityWhere>;
	startingPoint?: InputMaybe<FlexEntityWhere>;
	startingPointAggregate?: InputMaybe<FlexEntityStartingPointAggregateInput>;
	startingPointConnection?: InputMaybe<FlexEntityStartingPointConnectionWhere>;
	startingPointConnection_NOT?: InputMaybe<FlexEntityStartingPointConnectionWhere>;
	startingPoint_NOT?: InputMaybe<FlexEntityWhere>;
	status?: InputMaybe<FlexFormStatus>;
	status_IN?: InputMaybe<Array<InputMaybe<FlexFormStatus>>>;
	status_NOT?: InputMaybe<FlexFormStatus>;
	status_NOT_IN?: InputMaybe<Array<InputMaybe<FlexFormStatus>>>;
	tenantId?: InputMaybe<Scalars["String"]>;
	tenantId_CONTAINS?: InputMaybe<Scalars["String"]>;
	tenantId_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	tenantId_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	tenantId_MATCHES?: InputMaybe<Scalars["String"]>;
	tenantId_NOT?: InputMaybe<Scalars["String"]>;
	tenantId_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	tenantId_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	tenantId_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	tenantId_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	tenantId_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	type?: InputMaybe<FlexEntityTypeWhere>;
	typeAggregate?: InputMaybe<FlexEntityTypeAggregateInput>;
	typeConnection?: InputMaybe<FlexEntityTypeConnectionWhere>;
	typeConnection_NOT?: InputMaybe<FlexEntityTypeConnectionWhere>;
	type_NOT?: InputMaybe<FlexEntityTypeWhere>;
	unlimited?: InputMaybe<Scalars["Int"]>;
	unlimited_GT?: InputMaybe<Scalars["Int"]>;
	unlimited_GTE?: InputMaybe<Scalars["Int"]>;
	unlimited_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	unlimited_LT?: InputMaybe<Scalars["Int"]>;
	unlimited_LTE?: InputMaybe<Scalars["Int"]>;
	unlimited_NOT?: InputMaybe<Scalars["Int"]>;
	unlimited_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	uuid?: InputMaybe<Scalars["String"]>;
	uuid_CONTAINS?: InputMaybe<Scalars["String"]>;
	uuid_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	uuid_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	uuid_MATCHES?: InputMaybe<Scalars["String"]>;
	uuid_NOT?: InputMaybe<Scalars["String"]>;
	uuid_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	uuid_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	uuid_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	uuid_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	uuid_STARTS_WITH?: InputMaybe<Scalars["String"]>;
};

export type FlexFinancialDataPoint = {
	__typename?: "FlexFinancialDataPoint";
	agreement?: Maybe<Agreement>;
	agreementConnection: FlexFinancialDataPointAgreementConnection;
	basePrice?: Maybe<Scalars["Float"]>;
	currencyCode?: Maybe<Scalars["String"]>;
	date: Scalars["Date"];
	evaluates: FlexEntity;
	evaluatesConnection: FlexFinancialDataPointEvaluatesConnection;
	evaluationSnapshot?: Maybe<Scalars["String"]>;
	generatedUuid: Scalars["ID"];
	includedIn: Case;
	includedInConnection: FlexFinancialDataPointIncludedInConnection;
	isDeleted: Scalars["Boolean"];
	isLast: Scalars["Boolean"];
	payable?: Maybe<Scalars["Float"]>;
	payablePercentage?: Maybe<Scalars["Float"]>;
	prescriptionDate: Scalars["Date"];
	quantity: Scalars["Float"];
	refundable?: Maybe<Scalars["Float"]>;
	refundablePercentage?: Maybe<Scalars["Float"]>;
	sourceRefund?: Maybe<Refund>;
	sourceRefundConnection: FlexFinancialDataPointSourceRefundConnection;
	startingPoint: FlexEntity;
	startingPointConnection: FlexFinancialDataPointStartingPointConnection;
	treatment?: Maybe<Treatment>;
	treatmentConnection: FlexFinancialDataPointTreatmentConnection;
	uuid: Scalars["ID"];
	variable?: Maybe<Scalars["Float"]>;
	variablePercentage?: Maybe<Scalars["Float"]>;
};

export type FlexFinancialDataPointAgreementArgs = {
	options?: InputMaybe<AgreementOptions>;
	where?: InputMaybe<AgreementWhere>;
};

export type FlexFinancialDataPointAgreementConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<FlexFinancialDataPointAgreementConnectionSort>>;
	where?: InputMaybe<FlexFinancialDataPointAgreementConnectionWhere>;
};

export type FlexFinancialDataPointEvaluatesArgs = {
	options?: InputMaybe<FlexEntityOptions>;
	where?: InputMaybe<FlexEntityWhere>;
};

export type FlexFinancialDataPointEvaluatesConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<FlexFinancialDataPointEvaluatesConnectionSort>>;
	where?: InputMaybe<FlexFinancialDataPointEvaluatesConnectionWhere>;
};

export type FlexFinancialDataPointIncludedInArgs = {
	options?: InputMaybe<CaseOptions>;
	where?: InputMaybe<CaseWhere>;
};

export type FlexFinancialDataPointIncludedInConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<FlexFinancialDataPointIncludedInConnectionSort>>;
	where?: InputMaybe<FlexFinancialDataPointIncludedInConnectionWhere>;
};

export type FlexFinancialDataPointSourceRefundArgs = {
	options?: InputMaybe<RefundOptions>;
	where?: InputMaybe<RefundWhere>;
};

export type FlexFinancialDataPointSourceRefundConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<FlexFinancialDataPointSourceRefundConnectionSort>>;
	where?: InputMaybe<FlexFinancialDataPointSourceRefundConnectionWhere>;
};

export type FlexFinancialDataPointStartingPointArgs = {
	options?: InputMaybe<FlexEntityOptions>;
	where?: InputMaybe<FlexEntityWhere>;
};

export type FlexFinancialDataPointStartingPointConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<FlexFinancialDataPointStartingPointConnectionSort>>;
	where?: InputMaybe<FlexFinancialDataPointStartingPointConnectionWhere>;
};

export type FlexFinancialDataPointTreatmentArgs = {
	options?: InputMaybe<TreatmentOptions>;
	where?: InputMaybe<TreatmentWhere>;
};

export type FlexFinancialDataPointTreatmentConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<FlexFinancialDataPointTreatmentConnectionSort>>;
	where?: InputMaybe<FlexFinancialDataPointTreatmentConnectionWhere>;
};

export type FlexFinancialDataPointAggregateSelection = {
	__typename?: "FlexFinancialDataPointAggregateSelection";
	basePrice: FloatAggregateSelection;
	count: Scalars["Int"];
	currencyCode: StringAggregateSelection;
	evaluationSnapshot: StringAggregateSelection;
	generatedUuid: IdAggregateSelection;
	payable: FloatAggregateSelection;
	payablePercentage: FloatAggregateSelection;
	quantity: FloatAggregateSelection;
	refundable: FloatAggregateSelection;
	refundablePercentage: FloatAggregateSelection;
	uuid: IdAggregateSelection;
	variable: FloatAggregateSelection;
	variablePercentage: FloatAggregateSelection;
};

export type FlexFinancialDataPointAgreementAggregateInput = {
	AND?: InputMaybe<Array<FlexFinancialDataPointAgreementAggregateInput>>;
	OR?: InputMaybe<Array<FlexFinancialDataPointAgreementAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<FlexFinancialDataPointAgreementNodeAggregationWhereInput>;
};

export type FlexFinancialDataPointAgreementConnectFieldInput = {
	connect?: InputMaybe<AgreementConnectInput>;
	where?: InputMaybe<AgreementConnectWhere>;
};

export type FlexFinancialDataPointAgreementConnection = {
	__typename?: "FlexFinancialDataPointAgreementConnection";
	edges: Array<FlexFinancialDataPointAgreementRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type FlexFinancialDataPointAgreementConnectionSort = {
	node?: InputMaybe<AgreementSort>;
};

export type FlexFinancialDataPointAgreementConnectionWhere = {
	AND?: InputMaybe<Array<FlexFinancialDataPointAgreementConnectionWhere>>;
	OR?: InputMaybe<Array<FlexFinancialDataPointAgreementConnectionWhere>>;
	node?: InputMaybe<AgreementWhere>;
	node_NOT?: InputMaybe<AgreementWhere>;
};

export type FlexFinancialDataPointAgreementCreateFieldInput = {
	node: AgreementCreateInput;
};

export type FlexFinancialDataPointAgreementDeleteFieldInput = {
	delete?: InputMaybe<AgreementDeleteInput>;
	where?: InputMaybe<FlexFinancialDataPointAgreementConnectionWhere>;
};

export type FlexFinancialDataPointAgreementDisconnectFieldInput = {
	disconnect?: InputMaybe<AgreementDisconnectInput>;
	where?: InputMaybe<FlexFinancialDataPointAgreementConnectionWhere>;
};

export type FlexFinancialDataPointAgreementFieldInput = {
	connect?: InputMaybe<FlexFinancialDataPointAgreementConnectFieldInput>;
	create?: InputMaybe<FlexFinancialDataPointAgreementCreateFieldInput>;
};

export type FlexFinancialDataPointAgreementNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<FlexFinancialDataPointAgreementNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<FlexFinancialDataPointAgreementNodeAggregationWhereInput>>;
	description_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	description_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	description_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	description_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	description_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	description_EQUAL?: InputMaybe<Scalars["String"]>;
	description_GT?: InputMaybe<Scalars["Int"]>;
	description_GTE?: InputMaybe<Scalars["Int"]>;
	description_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	description_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	description_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	description_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	description_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	description_LT?: InputMaybe<Scalars["Int"]>;
	description_LTE?: InputMaybe<Scalars["Int"]>;
	description_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	description_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	description_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	description_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	description_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	formattedAmount_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	formattedAmount_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	formattedAmount_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	formattedAmount_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	formattedAmount_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	formattedAmount_EQUAL?: InputMaybe<Scalars["String"]>;
	formattedAmount_GT?: InputMaybe<Scalars["Int"]>;
	formattedAmount_GTE?: InputMaybe<Scalars["Int"]>;
	formattedAmount_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedAmount_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedAmount_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedAmount_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedAmount_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	formattedAmount_LT?: InputMaybe<Scalars["Int"]>;
	formattedAmount_LTE?: InputMaybe<Scalars["Int"]>;
	formattedAmount_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedAmount_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedAmount_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedAmount_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedAmount_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	formattedCounterparties_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	formattedCounterparties_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	formattedCounterparties_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	formattedCounterparties_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	formattedCounterparties_EQUAL?: InputMaybe<Scalars["String"]>;
	formattedCounterparties_GT?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_GTE?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_LT?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_LTE?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	formattedProducts_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	formattedProducts_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	formattedProducts_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	formattedProducts_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	formattedProducts_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	formattedProducts_EQUAL?: InputMaybe<Scalars["String"]>;
	formattedProducts_GT?: InputMaybe<Scalars["Int"]>;
	formattedProducts_GTE?: InputMaybe<Scalars["Int"]>;
	formattedProducts_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedProducts_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedProducts_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedProducts_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedProducts_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	formattedProducts_LT?: InputMaybe<Scalars["Int"]>;
	formattedProducts_LTE?: InputMaybe<Scalars["Int"]>;
	formattedProducts_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedProducts_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedProducts_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedProducts_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedProducts_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	formattedTags_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	formattedTags_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	formattedTags_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	formattedTags_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	formattedTags_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	formattedTags_EQUAL?: InputMaybe<Scalars["String"]>;
	formattedTags_GT?: InputMaybe<Scalars["Int"]>;
	formattedTags_GTE?: InputMaybe<Scalars["Int"]>;
	formattedTags_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedTags_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedTags_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedTags_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedTags_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	formattedTags_LT?: InputMaybe<Scalars["Int"]>;
	formattedTags_LTE?: InputMaybe<Scalars["Int"]>;
	formattedTags_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedTags_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedTags_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedTags_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedTags_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	formattedValidityPeriod_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	formattedValidityPeriod_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	formattedValidityPeriod_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	formattedValidityPeriod_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	formattedValidityPeriod_EQUAL?: InputMaybe<Scalars["String"]>;
	formattedValidityPeriod_GT?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_GTE?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_LT?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_LTE?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	initialVersionId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	initialVersionId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	initialVersionId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	initialVersionId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	initialVersionId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	initialVersionId_EQUAL?: InputMaybe<Scalars["String"]>;
	initialVersionId_GT?: InputMaybe<Scalars["Int"]>;
	initialVersionId_GTE?: InputMaybe<Scalars["Int"]>;
	initialVersionId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	initialVersionId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	initialVersionId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	initialVersionId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	initialVersionId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	initialVersionId_LT?: InputMaybe<Scalars["Int"]>;
	initialVersionId_LTE?: InputMaybe<Scalars["Int"]>;
	initialVersionId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	initialVersionId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	initialVersionId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	initialVersionId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	initialVersionId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	name_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	name_EQUAL?: InputMaybe<Scalars["String"]>;
	name_GT?: InputMaybe<Scalars["Int"]>;
	name_GTE?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	name_LT?: InputMaybe<Scalars["Int"]>;
	name_LTE?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	totalAmount_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	totalAmount_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	totalAmount_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	totalAmount_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	totalAmount_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	totalAmount_EQUAL?: InputMaybe<Scalars["Float"]>;
	totalAmount_GT?: InputMaybe<Scalars["Float"]>;
	totalAmount_GTE?: InputMaybe<Scalars["Float"]>;
	totalAmount_LT?: InputMaybe<Scalars["Float"]>;
	totalAmount_LTE?: InputMaybe<Scalars["Float"]>;
	totalAmount_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	totalAmount_MAX_GT?: InputMaybe<Scalars["Float"]>;
	totalAmount_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	totalAmount_MAX_LT?: InputMaybe<Scalars["Float"]>;
	totalAmount_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	totalAmount_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	totalAmount_MIN_GT?: InputMaybe<Scalars["Float"]>;
	totalAmount_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	totalAmount_MIN_LT?: InputMaybe<Scalars["Float"]>;
	totalAmount_MIN_LTE?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	unlimited_EQUAL?: InputMaybe<Scalars["Int"]>;
	unlimited_GT?: InputMaybe<Scalars["Int"]>;
	unlimited_GTE?: InputMaybe<Scalars["Int"]>;
	unlimited_LT?: InputMaybe<Scalars["Int"]>;
	unlimited_LTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_GT?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_LT?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_GT?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_LT?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_LTE?: InputMaybe<Scalars["Int"]>;
};

export type FlexFinancialDataPointAgreementRelationship = {
	__typename?: "FlexFinancialDataPointAgreementRelationship";
	cursor: Scalars["String"];
	node: Agreement;
};

export type FlexFinancialDataPointAgreementUpdateConnectionInput = {
	node?: InputMaybe<AgreementUpdateInput>;
};

export type FlexFinancialDataPointAgreementUpdateFieldInput = {
	connect?: InputMaybe<FlexFinancialDataPointAgreementConnectFieldInput>;
	create?: InputMaybe<FlexFinancialDataPointAgreementCreateFieldInput>;
	delete?: InputMaybe<FlexFinancialDataPointAgreementDeleteFieldInput>;
	disconnect?: InputMaybe<FlexFinancialDataPointAgreementDisconnectFieldInput>;
	update?: InputMaybe<FlexFinancialDataPointAgreementUpdateConnectionInput>;
	where?: InputMaybe<FlexFinancialDataPointAgreementConnectionWhere>;
};

export type FlexFinancialDataPointConnectInput = {
	agreement?: InputMaybe<FlexFinancialDataPointAgreementConnectFieldInput>;
	evaluates?: InputMaybe<FlexFinancialDataPointEvaluatesConnectFieldInput>;
	includedIn?: InputMaybe<FlexFinancialDataPointIncludedInConnectFieldInput>;
	sourceRefund?: InputMaybe<FlexFinancialDataPointSourceRefundConnectFieldInput>;
	startingPoint?: InputMaybe<FlexFinancialDataPointStartingPointConnectFieldInput>;
	treatment?: InputMaybe<FlexFinancialDataPointTreatmentConnectFieldInput>;
};

export type FlexFinancialDataPointConnectWhere = {
	node: FlexFinancialDataPointWhere;
};

export type FlexFinancialDataPointCreateInput = {
	agreement?: InputMaybe<FlexFinancialDataPointAgreementFieldInput>;
	basePrice?: InputMaybe<Scalars["Float"]>;
	currencyCode?: InputMaybe<Scalars["String"]>;
	date: Scalars["Date"];
	evaluates?: InputMaybe<FlexFinancialDataPointEvaluatesFieldInput>;
	evaluationSnapshot?: InputMaybe<Scalars["String"]>;
	generatedUuid: Scalars["ID"];
	includedIn?: InputMaybe<FlexFinancialDataPointIncludedInFieldInput>;
	isDeleted: Scalars["Boolean"];
	isLast: Scalars["Boolean"];
	payable?: InputMaybe<Scalars["Float"]>;
	payablePercentage?: InputMaybe<Scalars["Float"]>;
	prescriptionDate: Scalars["Date"];
	quantity: Scalars["Float"];
	refundable?: InputMaybe<Scalars["Float"]>;
	refundablePercentage?: InputMaybe<Scalars["Float"]>;
	sourceRefund?: InputMaybe<FlexFinancialDataPointSourceRefundFieldInput>;
	startingPoint?: InputMaybe<FlexFinancialDataPointStartingPointFieldInput>;
	treatment?: InputMaybe<FlexFinancialDataPointTreatmentFieldInput>;
	uuid: Scalars["ID"];
	variable?: InputMaybe<Scalars["Float"]>;
	variablePercentage?: InputMaybe<Scalars["Float"]>;
};

export type FlexFinancialDataPointDeleteInput = {
	agreement?: InputMaybe<FlexFinancialDataPointAgreementDeleteFieldInput>;
	evaluates?: InputMaybe<FlexFinancialDataPointEvaluatesDeleteFieldInput>;
	includedIn?: InputMaybe<FlexFinancialDataPointIncludedInDeleteFieldInput>;
	sourceRefund?: InputMaybe<FlexFinancialDataPointSourceRefundDeleteFieldInput>;
	startingPoint?: InputMaybe<FlexFinancialDataPointStartingPointDeleteFieldInput>;
	treatment?: InputMaybe<FlexFinancialDataPointTreatmentDeleteFieldInput>;
};

export type FlexFinancialDataPointDisconnectInput = {
	agreement?: InputMaybe<FlexFinancialDataPointAgreementDisconnectFieldInput>;
	evaluates?: InputMaybe<FlexFinancialDataPointEvaluatesDisconnectFieldInput>;
	includedIn?: InputMaybe<FlexFinancialDataPointIncludedInDisconnectFieldInput>;
	sourceRefund?: InputMaybe<FlexFinancialDataPointSourceRefundDisconnectFieldInput>;
	startingPoint?: InputMaybe<FlexFinancialDataPointStartingPointDisconnectFieldInput>;
	treatment?: InputMaybe<FlexFinancialDataPointTreatmentDisconnectFieldInput>;
};

export type FlexFinancialDataPointEvaluatesAggregateInput = {
	AND?: InputMaybe<Array<FlexFinancialDataPointEvaluatesAggregateInput>>;
	OR?: InputMaybe<Array<FlexFinancialDataPointEvaluatesAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<FlexFinancialDataPointEvaluatesNodeAggregationWhereInput>;
};

export type FlexFinancialDataPointEvaluatesConnectFieldInput = {
	connect?: InputMaybe<FlexEntityConnectInput>;
	where?: InputMaybe<FlexEntityConnectWhere>;
};

export type FlexFinancialDataPointEvaluatesConnection = {
	__typename?: "FlexFinancialDataPointEvaluatesConnection";
	edges: Array<FlexFinancialDataPointEvaluatesRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type FlexFinancialDataPointEvaluatesConnectionSort = {
	node?: InputMaybe<FlexEntitySort>;
};

export type FlexFinancialDataPointEvaluatesConnectionWhere = {
	AND?: InputMaybe<Array<FlexFinancialDataPointEvaluatesConnectionWhere>>;
	OR?: InputMaybe<Array<FlexFinancialDataPointEvaluatesConnectionWhere>>;
	node?: InputMaybe<FlexEntityWhere>;
	node_NOT?: InputMaybe<FlexEntityWhere>;
};

export type FlexFinancialDataPointEvaluatesCreateFieldInput = {
	node: FlexEntityCreateInput;
};

export type FlexFinancialDataPointEvaluatesDeleteFieldInput = {
	delete?: InputMaybe<FlexEntityDeleteInput>;
	where?: InputMaybe<FlexFinancialDataPointEvaluatesConnectionWhere>;
};

export type FlexFinancialDataPointEvaluatesDisconnectFieldInput = {
	disconnect?: InputMaybe<FlexEntityDisconnectInput>;
	where?: InputMaybe<FlexFinancialDataPointEvaluatesConnectionWhere>;
};

export type FlexFinancialDataPointEvaluatesFieldInput = {
	connect?: InputMaybe<FlexFinancialDataPointEvaluatesConnectFieldInput>;
	create?: InputMaybe<FlexFinancialDataPointEvaluatesCreateFieldInput>;
};

export type FlexFinancialDataPointEvaluatesNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<FlexFinancialDataPointEvaluatesNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<FlexFinancialDataPointEvaluatesNodeAggregationWhereInput>>;
	administrationDate_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_GT?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_GTE?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_LT?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_LTE?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdByName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	createdByName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	createdByName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	createdByName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	createdByName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	createdByName_EQUAL?: InputMaybe<Scalars["String"]>;
	createdByName_GT?: InputMaybe<Scalars["Int"]>;
	createdByName_GTE?: InputMaybe<Scalars["Int"]>;
	createdByName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	createdByName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	createdByName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	createdByName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	createdByName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	createdByName_LT?: InputMaybe<Scalars["Int"]>;
	createdByName_LTE?: InputMaybe<Scalars["Int"]>;
	createdByName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	createdByName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	createdByName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	createdByName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	createdByName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	createdOn_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	data_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	data_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	data_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	data_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	data_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	data_EQUAL?: InputMaybe<Scalars["String"]>;
	data_GT?: InputMaybe<Scalars["Int"]>;
	data_GTE?: InputMaybe<Scalars["Int"]>;
	data_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	data_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	data_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	data_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	data_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	data_LT?: InputMaybe<Scalars["Int"]>;
	data_LTE?: InputMaybe<Scalars["Int"]>;
	data_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	data_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	data_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	data_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	data_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	lastUpdatedOn_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_GT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_LT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	patientId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	patientId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	patientId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	patientId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	patientId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	patientId_EQUAL?: InputMaybe<Scalars["String"]>;
	patientId_GT?: InputMaybe<Scalars["Int"]>;
	patientId_GTE?: InputMaybe<Scalars["Int"]>;
	patientId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	patientId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	patientId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	patientId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	patientId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	patientId_LT?: InputMaybe<Scalars["Int"]>;
	patientId_LTE?: InputMaybe<Scalars["Int"]>;
	patientId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	patientId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	patientId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	patientId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	patientId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	preparationBrandNames_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	preparationBrandNames_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	preparationBrandNames_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	preparationBrandNames_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	preparationBrandNames_EQUAL?: InputMaybe<Scalars["String"]>;
	preparationBrandNames_GT?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_GTE?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_LT?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_LTE?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	preparationGenericNames_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	preparationGenericNames_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	preparationGenericNames_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	preparationGenericNames_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	preparationGenericNames_EQUAL?: InputMaybe<Scalars["String"]>;
	preparationGenericNames_GT?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_GTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_LT?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_LTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	quantity_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	quantity_EQUAL?: InputMaybe<Scalars["Int"]>;
	quantity_GT?: InputMaybe<Scalars["Int"]>;
	quantity_GTE?: InputMaybe<Scalars["Int"]>;
	quantity_LT?: InputMaybe<Scalars["Int"]>;
	quantity_LTE?: InputMaybe<Scalars["Int"]>;
	quantity_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	quantity_MAX_GT?: InputMaybe<Scalars["Int"]>;
	quantity_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	quantity_MAX_LT?: InputMaybe<Scalars["Int"]>;
	quantity_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	quantity_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	quantity_MIN_GT?: InputMaybe<Scalars["Int"]>;
	quantity_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	quantity_MIN_LT?: InputMaybe<Scalars["Int"]>;
	quantity_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	tenantId_EQUAL?: InputMaybe<Scalars["String"]>;
	tenantId_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	unlimited_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	unlimited_EQUAL?: InputMaybe<Scalars["Int"]>;
	unlimited_GT?: InputMaybe<Scalars["Int"]>;
	unlimited_GTE?: InputMaybe<Scalars["Int"]>;
	unlimited_LT?: InputMaybe<Scalars["Int"]>;
	unlimited_LTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_GT?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_LT?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_GT?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_LT?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	uuid_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	uuid_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	uuid_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	uuid_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	uuid_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	uuid_EQUAL?: InputMaybe<Scalars["String"]>;
	uuid_GT?: InputMaybe<Scalars["Int"]>;
	uuid_GTE?: InputMaybe<Scalars["Int"]>;
	uuid_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	uuid_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	uuid_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	uuid_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	uuid_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	uuid_LT?: InputMaybe<Scalars["Int"]>;
	uuid_LTE?: InputMaybe<Scalars["Int"]>;
	uuid_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	uuid_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	uuid_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	uuid_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	uuid_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type FlexFinancialDataPointEvaluatesRelationship = {
	__typename?: "FlexFinancialDataPointEvaluatesRelationship";
	cursor: Scalars["String"];
	node: FlexEntity;
};

export type FlexFinancialDataPointEvaluatesUpdateConnectionInput = {
	node?: InputMaybe<FlexEntityUpdateInput>;
};

export type FlexFinancialDataPointEvaluatesUpdateFieldInput = {
	connect?: InputMaybe<FlexFinancialDataPointEvaluatesConnectFieldInput>;
	create?: InputMaybe<FlexFinancialDataPointEvaluatesCreateFieldInput>;
	delete?: InputMaybe<FlexFinancialDataPointEvaluatesDeleteFieldInput>;
	disconnect?: InputMaybe<FlexFinancialDataPointEvaluatesDisconnectFieldInput>;
	update?: InputMaybe<FlexFinancialDataPointEvaluatesUpdateConnectionInput>;
	where?: InputMaybe<FlexFinancialDataPointEvaluatesConnectionWhere>;
};

export type FlexFinancialDataPointIncludedInAggregateInput = {
	AND?: InputMaybe<Array<FlexFinancialDataPointIncludedInAggregateInput>>;
	OR?: InputMaybe<Array<FlexFinancialDataPointIncludedInAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<FlexFinancialDataPointIncludedInNodeAggregationWhereInput>;
};

export type FlexFinancialDataPointIncludedInConnectFieldInput = {
	connect?: InputMaybe<CaseConnectInput>;
	where?: InputMaybe<CaseConnectWhere>;
};

export type FlexFinancialDataPointIncludedInConnection = {
	__typename?: "FlexFinancialDataPointIncludedInConnection";
	edges: Array<FlexFinancialDataPointIncludedInRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type FlexFinancialDataPointIncludedInConnectionSort = {
	node?: InputMaybe<CaseSort>;
};

export type FlexFinancialDataPointIncludedInConnectionWhere = {
	AND?: InputMaybe<Array<FlexFinancialDataPointIncludedInConnectionWhere>>;
	OR?: InputMaybe<Array<FlexFinancialDataPointIncludedInConnectionWhere>>;
	node?: InputMaybe<CaseWhere>;
	node_NOT?: InputMaybe<CaseWhere>;
};

export type FlexFinancialDataPointIncludedInCreateFieldInput = {
	node: CaseCreateInput;
};

export type FlexFinancialDataPointIncludedInDeleteFieldInput = {
	delete?: InputMaybe<CaseDeleteInput>;
	where?: InputMaybe<FlexFinancialDataPointIncludedInConnectionWhere>;
};

export type FlexFinancialDataPointIncludedInDisconnectFieldInput = {
	disconnect?: InputMaybe<CaseDisconnectInput>;
	where?: InputMaybe<FlexFinancialDataPointIncludedInConnectionWhere>;
};

export type FlexFinancialDataPointIncludedInFieldInput = {
	connect?: InputMaybe<FlexFinancialDataPointIncludedInConnectFieldInput>;
	create?: InputMaybe<FlexFinancialDataPointIncludedInCreateFieldInput>;
};

export type FlexFinancialDataPointIncludedInNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<FlexFinancialDataPointIncludedInNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<FlexFinancialDataPointIncludedInNodeAggregationWhereInput>>;
	actualAgreementId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	actualAgreementId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	actualAgreementId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	actualAgreementId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	actualAgreementId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	actualAgreementId_EQUAL?: InputMaybe<Scalars["String"]>;
	actualAgreementId_GT?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_GTE?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_LT?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_LTE?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	agreementName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	agreementName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	agreementName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	agreementName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	agreementName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	agreementName_EQUAL?: InputMaybe<Scalars["String"]>;
	agreementName_GT?: InputMaybe<Scalars["Int"]>;
	agreementName_GTE?: InputMaybe<Scalars["Int"]>;
	agreementName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	agreementName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	agreementName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	agreementName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	agreementName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	agreementName_LT?: InputMaybe<Scalars["Int"]>;
	agreementName_LTE?: InputMaybe<Scalars["Int"]>;
	agreementName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	agreementName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	agreementName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	agreementName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	agreementName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	patientInitials_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	patientInitials_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	patientInitials_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	patientInitials_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	patientInitials_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	patientInitials_EQUAL?: InputMaybe<Scalars["String"]>;
	patientInitials_GT?: InputMaybe<Scalars["Int"]>;
	patientInitials_GTE?: InputMaybe<Scalars["Int"]>;
	patientInitials_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	patientInitials_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	patientInitials_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	patientInitials_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	patientInitials_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	patientInitials_LT?: InputMaybe<Scalars["Int"]>;
	patientInitials_LTE?: InputMaybe<Scalars["Int"]>;
	patientInitials_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	patientInitials_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	patientInitials_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	patientInitials_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	patientInitials_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	patientInsuranceId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	patientInsuranceId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	patientInsuranceId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	patientInsuranceId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	patientInsuranceId_EQUAL?: InputMaybe<Scalars["String"]>;
	patientInsuranceId_GT?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_GTE?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_LT?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_LTE?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationBandName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	preparationBandName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	preparationBandName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	preparationBandName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	preparationBandName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	preparationBandName_EQUAL?: InputMaybe<Scalars["String"]>;
	preparationBandName_GT?: InputMaybe<Scalars["Int"]>;
	preparationBandName_GTE?: InputMaybe<Scalars["Int"]>;
	preparationBandName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationBandName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationBandName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationBandName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationBandName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationBandName_LT?: InputMaybe<Scalars["Int"]>;
	preparationBandName_LTE?: InputMaybe<Scalars["Int"]>;
	preparationBandName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationBandName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationBandName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationBandName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationBandName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	preparationGenericName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	preparationGenericName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	preparationGenericName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	preparationGenericName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	preparationGenericName_EQUAL?: InputMaybe<Scalars["String"]>;
	preparationGenericName_GT?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_GTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_LT?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_LTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	sourceTenantId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	sourceTenantId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	sourceTenantId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	sourceTenantId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	sourceTenantId_EQUAL?: InputMaybe<Scalars["String"]>;
	sourceTenantId_GT?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_GTE?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_LT?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_LTE?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	submissionDate_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_GT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_GTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_LT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_LTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	totalAmount_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	totalAmount_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	totalAmount_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	totalAmount_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	totalAmount_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	totalAmount_EQUAL?: InputMaybe<Scalars["Float"]>;
	totalAmount_GT?: InputMaybe<Scalars["Float"]>;
	totalAmount_GTE?: InputMaybe<Scalars["Float"]>;
	totalAmount_LT?: InputMaybe<Scalars["Float"]>;
	totalAmount_LTE?: InputMaybe<Scalars["Float"]>;
	totalAmount_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	totalAmount_MAX_GT?: InputMaybe<Scalars["Float"]>;
	totalAmount_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	totalAmount_MAX_LT?: InputMaybe<Scalars["Float"]>;
	totalAmount_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	totalAmount_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	totalAmount_MIN_GT?: InputMaybe<Scalars["Float"]>;
	totalAmount_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	totalAmount_MIN_LT?: InputMaybe<Scalars["Float"]>;
	totalAmount_MIN_LTE?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	unlimited_EQUAL?: InputMaybe<Scalars["Int"]>;
	unlimited_GT?: InputMaybe<Scalars["Int"]>;
	unlimited_GTE?: InputMaybe<Scalars["Int"]>;
	unlimited_LT?: InputMaybe<Scalars["Int"]>;
	unlimited_LTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_GT?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_LT?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_GT?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_LT?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_LTE?: InputMaybe<Scalars["Int"]>;
};

export type FlexFinancialDataPointIncludedInRelationship = {
	__typename?: "FlexFinancialDataPointIncludedInRelationship";
	cursor: Scalars["String"];
	node: Case;
};

export type FlexFinancialDataPointIncludedInUpdateConnectionInput = {
	node?: InputMaybe<CaseUpdateInput>;
};

export type FlexFinancialDataPointIncludedInUpdateFieldInput = {
	connect?: InputMaybe<FlexFinancialDataPointIncludedInConnectFieldInput>;
	create?: InputMaybe<FlexFinancialDataPointIncludedInCreateFieldInput>;
	delete?: InputMaybe<FlexFinancialDataPointIncludedInDeleteFieldInput>;
	disconnect?: InputMaybe<FlexFinancialDataPointIncludedInDisconnectFieldInput>;
	update?: InputMaybe<FlexFinancialDataPointIncludedInUpdateConnectionInput>;
	where?: InputMaybe<FlexFinancialDataPointIncludedInConnectionWhere>;
};

export type FlexFinancialDataPointOptions = {
	limit?: InputMaybe<Scalars["Int"]>;
	offset?: InputMaybe<Scalars["Int"]>;
	/** Specify one or more FlexFinancialDataPointSort objects to sort FlexFinancialDataPoints by. The sorts will be applied in the order in which they are arranged in the array. */
	sort?: InputMaybe<Array<InputMaybe<FlexFinancialDataPointSort>>>;
};

/** Fields to sort FlexFinancialDataPoints by. The order in which sorts are applied is not guaranteed when specifying many fields in one FlexFinancialDataPointSort object. */
export type FlexFinancialDataPointSort = {
	basePrice?: InputMaybe<SortDirection>;
	currencyCode?: InputMaybe<SortDirection>;
	date?: InputMaybe<SortDirection>;
	evaluationSnapshot?: InputMaybe<SortDirection>;
	generatedUuid?: InputMaybe<SortDirection>;
	isDeleted?: InputMaybe<SortDirection>;
	isLast?: InputMaybe<SortDirection>;
	payable?: InputMaybe<SortDirection>;
	payablePercentage?: InputMaybe<SortDirection>;
	prescriptionDate?: InputMaybe<SortDirection>;
	quantity?: InputMaybe<SortDirection>;
	refundable?: InputMaybe<SortDirection>;
	refundablePercentage?: InputMaybe<SortDirection>;
	uuid?: InputMaybe<SortDirection>;
	variable?: InputMaybe<SortDirection>;
	variablePercentage?: InputMaybe<SortDirection>;
};

export type FlexFinancialDataPointSourceRefundAggregateInput = {
	AND?: InputMaybe<Array<FlexFinancialDataPointSourceRefundAggregateInput>>;
	OR?: InputMaybe<Array<FlexFinancialDataPointSourceRefundAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<FlexFinancialDataPointSourceRefundNodeAggregationWhereInput>;
};

export type FlexFinancialDataPointSourceRefundConnectFieldInput = {
	connect?: InputMaybe<RefundConnectInput>;
	where?: InputMaybe<RefundConnectWhere>;
};

export type FlexFinancialDataPointSourceRefundConnection = {
	__typename?: "FlexFinancialDataPointSourceRefundConnection";
	edges: Array<FlexFinancialDataPointSourceRefundRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type FlexFinancialDataPointSourceRefundConnectionSort = {
	node?: InputMaybe<RefundSort>;
};

export type FlexFinancialDataPointSourceRefundConnectionWhere = {
	AND?: InputMaybe<Array<FlexFinancialDataPointSourceRefundConnectionWhere>>;
	OR?: InputMaybe<Array<FlexFinancialDataPointSourceRefundConnectionWhere>>;
	node?: InputMaybe<RefundWhere>;
	node_NOT?: InputMaybe<RefundWhere>;
};

export type FlexFinancialDataPointSourceRefundCreateFieldInput = {
	node: RefundCreateInput;
};

export type FlexFinancialDataPointSourceRefundDeleteFieldInput = {
	delete?: InputMaybe<RefundDeleteInput>;
	where?: InputMaybe<FlexFinancialDataPointSourceRefundConnectionWhere>;
};

export type FlexFinancialDataPointSourceRefundDisconnectFieldInput = {
	disconnect?: InputMaybe<RefundDisconnectInput>;
	where?: InputMaybe<FlexFinancialDataPointSourceRefundConnectionWhere>;
};

export type FlexFinancialDataPointSourceRefundFieldInput = {
	connect?: InputMaybe<FlexFinancialDataPointSourceRefundConnectFieldInput>;
	create?: InputMaybe<FlexFinancialDataPointSourceRefundCreateFieldInput>;
};

export type FlexFinancialDataPointSourceRefundNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<FlexFinancialDataPointSourceRefundNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<FlexFinancialDataPointSourceRefundNodeAggregationWhereInput>>;
	agreementName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	agreementName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	agreementName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	agreementName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	agreementName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	agreementName_EQUAL?: InputMaybe<Scalars["String"]>;
	agreementName_GT?: InputMaybe<Scalars["Int"]>;
	agreementName_GTE?: InputMaybe<Scalars["Int"]>;
	agreementName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	agreementName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	agreementName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	agreementName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	agreementName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	agreementName_LT?: InputMaybe<Scalars["Int"]>;
	agreementName_LTE?: InputMaybe<Scalars["Int"]>;
	agreementName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	agreementName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	agreementName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	agreementName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	agreementName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	amount_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	amount_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	amount_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	amount_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	amount_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	amount_EQUAL?: InputMaybe<Scalars["Float"]>;
	amount_GT?: InputMaybe<Scalars["Float"]>;
	amount_GTE?: InputMaybe<Scalars["Float"]>;
	amount_LT?: InputMaybe<Scalars["Float"]>;
	amount_LTE?: InputMaybe<Scalars["Float"]>;
	amount_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	amount_MAX_GT?: InputMaybe<Scalars["Float"]>;
	amount_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	amount_MAX_LT?: InputMaybe<Scalars["Float"]>;
	amount_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	amount_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	amount_MIN_GT?: InputMaybe<Scalars["Float"]>;
	amount_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	amount_MIN_LT?: InputMaybe<Scalars["Float"]>;
	amount_MIN_LTE?: InputMaybe<Scalars["Float"]>;
	caseId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	caseId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	caseId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	caseId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	caseId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	caseId_EQUAL?: InputMaybe<Scalars["String"]>;
	caseId_GT?: InputMaybe<Scalars["Int"]>;
	caseId_GTE?: InputMaybe<Scalars["Int"]>;
	caseId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	caseId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	caseId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	caseId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	caseId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	caseId_LT?: InputMaybe<Scalars["Int"]>;
	caseId_LTE?: InputMaybe<Scalars["Int"]>;
	caseId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	caseId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	caseId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	caseId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	caseId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	counterParties_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	counterParties_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	counterParties_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	counterParties_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	counterParties_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	counterParties_EQUAL?: InputMaybe<Scalars["String"]>;
	counterParties_GT?: InputMaybe<Scalars["Int"]>;
	counterParties_GTE?: InputMaybe<Scalars["Int"]>;
	counterParties_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	counterParties_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	counterParties_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	counterParties_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	counterParties_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	counterParties_LT?: InputMaybe<Scalars["Int"]>;
	counterParties_LTE?: InputMaybe<Scalars["Int"]>;
	counterParties_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	counterParties_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	counterParties_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	counterParties_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	counterParties_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	currency_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	currency_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	currency_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	currency_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	currency_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	currency_EQUAL?: InputMaybe<Scalars["String"]>;
	currency_GT?: InputMaybe<Scalars["Int"]>;
	currency_GTE?: InputMaybe<Scalars["Int"]>;
	currency_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	currency_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	currency_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	currency_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	currency_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	currency_LT?: InputMaybe<Scalars["Int"]>;
	currency_LTE?: InputMaybe<Scalars["Int"]>;
	currency_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	currency_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	currency_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	currency_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	currency_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	formattedTags_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	formattedTags_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	formattedTags_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	formattedTags_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	formattedTags_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	formattedTags_EQUAL?: InputMaybe<Scalars["String"]>;
	formattedTags_GT?: InputMaybe<Scalars["Int"]>;
	formattedTags_GTE?: InputMaybe<Scalars["Int"]>;
	formattedTags_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedTags_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedTags_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedTags_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedTags_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	formattedTags_LT?: InputMaybe<Scalars["Int"]>;
	formattedTags_LTE?: InputMaybe<Scalars["Int"]>;
	formattedTags_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedTags_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedTags_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedTags_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedTags_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	iin_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	iin_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	iin_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	iin_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	iin_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	iin_EQUAL?: InputMaybe<Scalars["String"]>;
	iin_GT?: InputMaybe<Scalars["Int"]>;
	iin_GTE?: InputMaybe<Scalars["Int"]>;
	iin_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	iin_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	iin_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	iin_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	iin_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	iin_LT?: InputMaybe<Scalars["Int"]>;
	iin_LTE?: InputMaybe<Scalars["Int"]>;
	iin_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	iin_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	iin_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	iin_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	iin_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	product_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	product_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	product_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	product_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	product_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	product_EQUAL?: InputMaybe<Scalars["String"]>;
	product_GT?: InputMaybe<Scalars["Int"]>;
	product_GTE?: InputMaybe<Scalars["Int"]>;
	product_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	product_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	product_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	product_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	product_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	product_LT?: InputMaybe<Scalars["Int"]>;
	product_LTE?: InputMaybe<Scalars["Int"]>;
	product_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	product_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	product_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	product_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	product_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	unlimited_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	unlimited_EQUAL?: InputMaybe<Scalars["Int"]>;
	unlimited_GT?: InputMaybe<Scalars["Int"]>;
	unlimited_GTE?: InputMaybe<Scalars["Int"]>;
	unlimited_LT?: InputMaybe<Scalars["Int"]>;
	unlimited_LTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_GT?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_LT?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_GT?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_LT?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_LTE?: InputMaybe<Scalars["Int"]>;
};

export type FlexFinancialDataPointSourceRefundRelationship = {
	__typename?: "FlexFinancialDataPointSourceRefundRelationship";
	cursor: Scalars["String"];
	node: Refund;
};

export type FlexFinancialDataPointSourceRefundUpdateConnectionInput = {
	node?: InputMaybe<RefundUpdateInput>;
};

export type FlexFinancialDataPointSourceRefundUpdateFieldInput = {
	connect?: InputMaybe<FlexFinancialDataPointSourceRefundConnectFieldInput>;
	create?: InputMaybe<FlexFinancialDataPointSourceRefundCreateFieldInput>;
	delete?: InputMaybe<FlexFinancialDataPointSourceRefundDeleteFieldInput>;
	disconnect?: InputMaybe<FlexFinancialDataPointSourceRefundDisconnectFieldInput>;
	update?: InputMaybe<FlexFinancialDataPointSourceRefundUpdateConnectionInput>;
	where?: InputMaybe<FlexFinancialDataPointSourceRefundConnectionWhere>;
};

export type FlexFinancialDataPointStartingPointAggregateInput = {
	AND?: InputMaybe<Array<FlexFinancialDataPointStartingPointAggregateInput>>;
	OR?: InputMaybe<Array<FlexFinancialDataPointStartingPointAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<FlexFinancialDataPointStartingPointNodeAggregationWhereInput>;
};

export type FlexFinancialDataPointStartingPointConnectFieldInput = {
	connect?: InputMaybe<FlexEntityConnectInput>;
	where?: InputMaybe<FlexEntityConnectWhere>;
};

export type FlexFinancialDataPointStartingPointConnection = {
	__typename?: "FlexFinancialDataPointStartingPointConnection";
	edges: Array<FlexFinancialDataPointStartingPointRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type FlexFinancialDataPointStartingPointConnectionSort = {
	node?: InputMaybe<FlexEntitySort>;
};

export type FlexFinancialDataPointStartingPointConnectionWhere = {
	AND?: InputMaybe<Array<FlexFinancialDataPointStartingPointConnectionWhere>>;
	OR?: InputMaybe<Array<FlexFinancialDataPointStartingPointConnectionWhere>>;
	node?: InputMaybe<FlexEntityWhere>;
	node_NOT?: InputMaybe<FlexEntityWhere>;
};

export type FlexFinancialDataPointStartingPointCreateFieldInput = {
	node: FlexEntityCreateInput;
};

export type FlexFinancialDataPointStartingPointDeleteFieldInput = {
	delete?: InputMaybe<FlexEntityDeleteInput>;
	where?: InputMaybe<FlexFinancialDataPointStartingPointConnectionWhere>;
};

export type FlexFinancialDataPointStartingPointDisconnectFieldInput = {
	disconnect?: InputMaybe<FlexEntityDisconnectInput>;
	where?: InputMaybe<FlexFinancialDataPointStartingPointConnectionWhere>;
};

export type FlexFinancialDataPointStartingPointFieldInput = {
	connect?: InputMaybe<FlexFinancialDataPointStartingPointConnectFieldInput>;
	create?: InputMaybe<FlexFinancialDataPointStartingPointCreateFieldInput>;
};

export type FlexFinancialDataPointStartingPointNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<FlexFinancialDataPointStartingPointNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<FlexFinancialDataPointStartingPointNodeAggregationWhereInput>>;
	administrationDate_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_GT?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_GTE?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_LT?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_LTE?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdByName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	createdByName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	createdByName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	createdByName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	createdByName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	createdByName_EQUAL?: InputMaybe<Scalars["String"]>;
	createdByName_GT?: InputMaybe<Scalars["Int"]>;
	createdByName_GTE?: InputMaybe<Scalars["Int"]>;
	createdByName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	createdByName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	createdByName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	createdByName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	createdByName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	createdByName_LT?: InputMaybe<Scalars["Int"]>;
	createdByName_LTE?: InputMaybe<Scalars["Int"]>;
	createdByName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	createdByName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	createdByName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	createdByName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	createdByName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	createdOn_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	data_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	data_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	data_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	data_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	data_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	data_EQUAL?: InputMaybe<Scalars["String"]>;
	data_GT?: InputMaybe<Scalars["Int"]>;
	data_GTE?: InputMaybe<Scalars["Int"]>;
	data_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	data_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	data_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	data_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	data_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	data_LT?: InputMaybe<Scalars["Int"]>;
	data_LTE?: InputMaybe<Scalars["Int"]>;
	data_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	data_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	data_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	data_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	data_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	lastUpdatedOn_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_GT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_LT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	patientId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	patientId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	patientId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	patientId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	patientId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	patientId_EQUAL?: InputMaybe<Scalars["String"]>;
	patientId_GT?: InputMaybe<Scalars["Int"]>;
	patientId_GTE?: InputMaybe<Scalars["Int"]>;
	patientId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	patientId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	patientId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	patientId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	patientId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	patientId_LT?: InputMaybe<Scalars["Int"]>;
	patientId_LTE?: InputMaybe<Scalars["Int"]>;
	patientId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	patientId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	patientId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	patientId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	patientId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	preparationBrandNames_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	preparationBrandNames_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	preparationBrandNames_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	preparationBrandNames_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	preparationBrandNames_EQUAL?: InputMaybe<Scalars["String"]>;
	preparationBrandNames_GT?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_GTE?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_LT?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_LTE?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	preparationGenericNames_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	preparationGenericNames_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	preparationGenericNames_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	preparationGenericNames_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	preparationGenericNames_EQUAL?: InputMaybe<Scalars["String"]>;
	preparationGenericNames_GT?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_GTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_LT?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_LTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	quantity_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	quantity_EQUAL?: InputMaybe<Scalars["Int"]>;
	quantity_GT?: InputMaybe<Scalars["Int"]>;
	quantity_GTE?: InputMaybe<Scalars["Int"]>;
	quantity_LT?: InputMaybe<Scalars["Int"]>;
	quantity_LTE?: InputMaybe<Scalars["Int"]>;
	quantity_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	quantity_MAX_GT?: InputMaybe<Scalars["Int"]>;
	quantity_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	quantity_MAX_LT?: InputMaybe<Scalars["Int"]>;
	quantity_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	quantity_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	quantity_MIN_GT?: InputMaybe<Scalars["Int"]>;
	quantity_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	quantity_MIN_LT?: InputMaybe<Scalars["Int"]>;
	quantity_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	tenantId_EQUAL?: InputMaybe<Scalars["String"]>;
	tenantId_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	unlimited_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	unlimited_EQUAL?: InputMaybe<Scalars["Int"]>;
	unlimited_GT?: InputMaybe<Scalars["Int"]>;
	unlimited_GTE?: InputMaybe<Scalars["Int"]>;
	unlimited_LT?: InputMaybe<Scalars["Int"]>;
	unlimited_LTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_GT?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_LT?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_GT?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_LT?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	uuid_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	uuid_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	uuid_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	uuid_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	uuid_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	uuid_EQUAL?: InputMaybe<Scalars["String"]>;
	uuid_GT?: InputMaybe<Scalars["Int"]>;
	uuid_GTE?: InputMaybe<Scalars["Int"]>;
	uuid_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	uuid_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	uuid_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	uuid_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	uuid_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	uuid_LT?: InputMaybe<Scalars["Int"]>;
	uuid_LTE?: InputMaybe<Scalars["Int"]>;
	uuid_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	uuid_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	uuid_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	uuid_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	uuid_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type FlexFinancialDataPointStartingPointRelationship = {
	__typename?: "FlexFinancialDataPointStartingPointRelationship";
	cursor: Scalars["String"];
	node: FlexEntity;
};

export type FlexFinancialDataPointStartingPointUpdateConnectionInput = {
	node?: InputMaybe<FlexEntityUpdateInput>;
};

export type FlexFinancialDataPointStartingPointUpdateFieldInput = {
	connect?: InputMaybe<FlexFinancialDataPointStartingPointConnectFieldInput>;
	create?: InputMaybe<FlexFinancialDataPointStartingPointCreateFieldInput>;
	delete?: InputMaybe<FlexFinancialDataPointStartingPointDeleteFieldInput>;
	disconnect?: InputMaybe<FlexFinancialDataPointStartingPointDisconnectFieldInput>;
	update?: InputMaybe<FlexFinancialDataPointStartingPointUpdateConnectionInput>;
	where?: InputMaybe<FlexFinancialDataPointStartingPointConnectionWhere>;
};

export type FlexFinancialDataPointTreatmentAggregateInput = {
	AND?: InputMaybe<Array<FlexFinancialDataPointTreatmentAggregateInput>>;
	OR?: InputMaybe<Array<FlexFinancialDataPointTreatmentAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<FlexFinancialDataPointTreatmentNodeAggregationWhereInput>;
};

export type FlexFinancialDataPointTreatmentConnectFieldInput = {
	connect?: InputMaybe<TreatmentConnectInput>;
	where?: InputMaybe<TreatmentConnectWhere>;
};

export type FlexFinancialDataPointTreatmentConnection = {
	__typename?: "FlexFinancialDataPointTreatmentConnection";
	edges: Array<FlexFinancialDataPointTreatmentRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type FlexFinancialDataPointTreatmentConnectionSort = {
	node?: InputMaybe<TreatmentSort>;
};

export type FlexFinancialDataPointTreatmentConnectionWhere = {
	AND?: InputMaybe<Array<FlexFinancialDataPointTreatmentConnectionWhere>>;
	OR?: InputMaybe<Array<FlexFinancialDataPointTreatmentConnectionWhere>>;
	node?: InputMaybe<TreatmentWhere>;
	node_NOT?: InputMaybe<TreatmentWhere>;
};

export type FlexFinancialDataPointTreatmentCreateFieldInput = {
	node: TreatmentCreateInput;
};

export type FlexFinancialDataPointTreatmentDeleteFieldInput = {
	delete?: InputMaybe<TreatmentDeleteInput>;
	where?: InputMaybe<FlexFinancialDataPointTreatmentConnectionWhere>;
};

export type FlexFinancialDataPointTreatmentDisconnectFieldInput = {
	disconnect?: InputMaybe<TreatmentDisconnectInput>;
	where?: InputMaybe<FlexFinancialDataPointTreatmentConnectionWhere>;
};

export type FlexFinancialDataPointTreatmentFieldInput = {
	connect?: InputMaybe<FlexFinancialDataPointTreatmentConnectFieldInput>;
	create?: InputMaybe<FlexFinancialDataPointTreatmentCreateFieldInput>;
};

export type FlexFinancialDataPointTreatmentNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<FlexFinancialDataPointTreatmentNodeAggregationWhereInput>>;
	BagDossierNo_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	BagDossierNo_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	BagDossierNo_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	BagDossierNo_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	BagDossierNo_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	BagDossierNo_EQUAL?: InputMaybe<Scalars["String"]>;
	BagDossierNo_GT?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_GTE?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LT?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LTE?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	Code_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	Code_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	Code_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	Code_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	Code_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	Code_EQUAL?: InputMaybe<Scalars["String"]>;
	Code_GT?: InputMaybe<Scalars["Int"]>;
	Code_GTE?: InputMaybe<Scalars["Int"]>;
	Code_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Code_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	Code_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	Code_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	Code_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	Code_LT?: InputMaybe<Scalars["Int"]>;
	Code_LTE?: InputMaybe<Scalars["Int"]>;
	Code_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Code_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	Code_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	Code_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	Code_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	FlagModal_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	FlagModal_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	FlagModal_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	FlagModal_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	FlagModal_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	FlagModal_EQUAL?: InputMaybe<Scalars["String"]>;
	FlagModal_GT?: InputMaybe<Scalars["Int"]>;
	FlagModal_GTE?: InputMaybe<Scalars["Int"]>;
	FlagModal_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	FlagModal_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	FlagModal_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	FlagModal_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	FlagModal_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	FlagModal_LT?: InputMaybe<Scalars["Int"]>;
	FlagModal_LTE?: InputMaybe<Scalars["Int"]>;
	FlagModal_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	FlagModal_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	FlagModal_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	FlagModal_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	FlagModal_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	FlagNarcosis_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	FlagNarcosis_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	FlagNarcosis_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	FlagNarcosis_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	FlagNarcosis_EQUAL?: InputMaybe<Scalars["String"]>;
	FlagNarcosis_GT?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_GTE?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LT?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LTE?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	GTIN_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	GTIN_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	GTIN_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	GTIN_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	GTIN_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	GTIN_EQUAL?: InputMaybe<Scalars["String"]>;
	GTIN_GT?: InputMaybe<Scalars["Int"]>;
	GTIN_GTE?: InputMaybe<Scalars["Int"]>;
	GTIN_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	GTIN_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	GTIN_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	GTIN_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	GTIN_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	GTIN_LT?: InputMaybe<Scalars["Int"]>;
	GTIN_LTE?: InputMaybe<Scalars["Int"]>;
	GTIN_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	GTIN_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	GTIN_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	GTIN_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	GTIN_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	LOT_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	LOT_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	LOT_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	LOT_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	LOT_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	LOT_EQUAL?: InputMaybe<Scalars["String"]>;
	LOT_GT?: InputMaybe<Scalars["Int"]>;
	LOT_GTE?: InputMaybe<Scalars["Int"]>;
	LOT_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	LOT_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	LOT_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	LOT_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	LOT_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	LOT_LT?: InputMaybe<Scalars["Int"]>;
	LOT_LTE?: InputMaybe<Scalars["Int"]>;
	LOT_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	LOT_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	LOT_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	LOT_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	LOT_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	Name_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	Name_EQUAL?: InputMaybe<Scalars["String"]>;
	Name_GT?: InputMaybe<Scalars["Int"]>;
	Name_GTE?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	Name_LT?: InputMaybe<Scalars["Int"]>;
	Name_LTE?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	OR?: InputMaybe<Array<FlexFinancialDataPointTreatmentNodeAggregationWhereInput>>;
	PharmaCode_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	PharmaCode_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	PharmaCode_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	PharmaCode_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	PharmaCode_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	PharmaCode_EQUAL?: InputMaybe<Scalars["String"]>;
	PharmaCode_GT?: InputMaybe<Scalars["Int"]>;
	PharmaCode_GTE?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LT?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LTE?: InputMaybe<Scalars["Int"]>;
	PharmaCode_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	PharmaCode_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	PharmaCode_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	PharmaCode_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	PharmaCode_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	PrevPharmacode_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	PrevPharmacode_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	PrevPharmacode_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	PrevPharmacode_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	PrevPharmacode_EQUAL?: InputMaybe<Scalars["String"]>;
	PrevPharmacode_GT?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_GTE?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LT?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LTE?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	REF_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	REF_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	REF_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	REF_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	REF_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	REF_EQUAL?: InputMaybe<Scalars["String"]>;
	REF_GT?: InputMaybe<Scalars["Int"]>;
	REF_GTE?: InputMaybe<Scalars["Int"]>;
	REF_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	REF_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	REF_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	REF_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	REF_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	REF_LT?: InputMaybe<Scalars["Int"]>;
	REF_LTE?: InputMaybe<Scalars["Int"]>;
	REF_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	REF_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	REF_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	REF_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	REF_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	SwissmedicCategory_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	SwissmedicCategory_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	SwissmedicCategory_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	SwissmedicCategory_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	SwissmedicCategory_EQUAL?: InputMaybe<Scalars["String"]>;
	SwissmedicCategory_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo8_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo8_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo8_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo8_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo8_EQUAL?: InputMaybe<Scalars["String"]>;
	SwissmedicNo8_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	UDI_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	UDI_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	UDI_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	UDI_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	UDI_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	UDI_EQUAL?: InputMaybe<Scalars["String"]>;
	UDI_GT?: InputMaybe<Scalars["Int"]>;
	UDI_GTE?: InputMaybe<Scalars["Int"]>;
	UDI_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	UDI_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	UDI_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	UDI_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	UDI_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	UDI_LT?: InputMaybe<Scalars["Int"]>;
	UDI_LTE?: InputMaybe<Scalars["Int"]>;
	UDI_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	UDI_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	UDI_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	UDI_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	UDI_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	classificationSystem_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	classificationSystem_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	classificationSystem_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	classificationSystem_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	classificationSystem_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	classificationSystem_EQUAL?: InputMaybe<Scalars["String"]>;
	classificationSystem_GT?: InputMaybe<Scalars["Int"]>;
	classificationSystem_GTE?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LT?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LTE?: InputMaybe<Scalars["Int"]>;
	classificationSystem_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	classificationSystem_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	classificationSystem_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	classificationSystem_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	classificationSystem_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type FlexFinancialDataPointTreatmentRelationship = {
	__typename?: "FlexFinancialDataPointTreatmentRelationship";
	cursor: Scalars["String"];
	node: Treatment;
};

export type FlexFinancialDataPointTreatmentUpdateConnectionInput = {
	node?: InputMaybe<TreatmentUpdateInput>;
};

export type FlexFinancialDataPointTreatmentUpdateFieldInput = {
	connect?: InputMaybe<FlexFinancialDataPointTreatmentConnectFieldInput>;
	create?: InputMaybe<FlexFinancialDataPointTreatmentCreateFieldInput>;
	delete?: InputMaybe<FlexFinancialDataPointTreatmentDeleteFieldInput>;
	disconnect?: InputMaybe<FlexFinancialDataPointTreatmentDisconnectFieldInput>;
	update?: InputMaybe<FlexFinancialDataPointTreatmentUpdateConnectionInput>;
	where?: InputMaybe<FlexFinancialDataPointTreatmentConnectionWhere>;
};

export type FlexFinancialDataPointUpdateInput = {
	agreement?: InputMaybe<FlexFinancialDataPointAgreementUpdateFieldInput>;
	basePrice?: InputMaybe<Scalars["Float"]>;
	currencyCode?: InputMaybe<Scalars["String"]>;
	date?: InputMaybe<Scalars["Date"]>;
	evaluates?: InputMaybe<FlexFinancialDataPointEvaluatesUpdateFieldInput>;
	evaluationSnapshot?: InputMaybe<Scalars["String"]>;
	generatedUuid?: InputMaybe<Scalars["ID"]>;
	includedIn?: InputMaybe<FlexFinancialDataPointIncludedInUpdateFieldInput>;
	isDeleted?: InputMaybe<Scalars["Boolean"]>;
	isLast?: InputMaybe<Scalars["Boolean"]>;
	payable?: InputMaybe<Scalars["Float"]>;
	payablePercentage?: InputMaybe<Scalars["Float"]>;
	prescriptionDate?: InputMaybe<Scalars["Date"]>;
	quantity?: InputMaybe<Scalars["Float"]>;
	refundable?: InputMaybe<Scalars["Float"]>;
	refundablePercentage?: InputMaybe<Scalars["Float"]>;
	sourceRefund?: InputMaybe<FlexFinancialDataPointSourceRefundUpdateFieldInput>;
	startingPoint?: InputMaybe<FlexFinancialDataPointStartingPointUpdateFieldInput>;
	treatment?: InputMaybe<FlexFinancialDataPointTreatmentUpdateFieldInput>;
	uuid?: InputMaybe<Scalars["ID"]>;
	variable?: InputMaybe<Scalars["Float"]>;
	variablePercentage?: InputMaybe<Scalars["Float"]>;
};

export type FlexFinancialDataPointWhere = {
	AND?: InputMaybe<Array<FlexFinancialDataPointWhere>>;
	OR?: InputMaybe<Array<FlexFinancialDataPointWhere>>;
	agreement?: InputMaybe<AgreementWhere>;
	agreementAggregate?: InputMaybe<FlexFinancialDataPointAgreementAggregateInput>;
	agreementConnection?: InputMaybe<FlexFinancialDataPointAgreementConnectionWhere>;
	agreementConnection_NOT?: InputMaybe<FlexFinancialDataPointAgreementConnectionWhere>;
	agreement_NOT?: InputMaybe<AgreementWhere>;
	basePrice?: InputMaybe<Scalars["Float"]>;
	basePrice_GT?: InputMaybe<Scalars["Float"]>;
	basePrice_GTE?: InputMaybe<Scalars["Float"]>;
	basePrice_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	basePrice_LT?: InputMaybe<Scalars["Float"]>;
	basePrice_LTE?: InputMaybe<Scalars["Float"]>;
	basePrice_NOT?: InputMaybe<Scalars["Float"]>;
	basePrice_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	currencyCode?: InputMaybe<Scalars["String"]>;
	currencyCode_CONTAINS?: InputMaybe<Scalars["String"]>;
	currencyCode_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	currencyCode_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	currencyCode_MATCHES?: InputMaybe<Scalars["String"]>;
	currencyCode_NOT?: InputMaybe<Scalars["String"]>;
	currencyCode_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	currencyCode_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	currencyCode_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	currencyCode_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	currencyCode_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	date?: InputMaybe<Scalars["Date"]>;
	date_GT?: InputMaybe<Scalars["Date"]>;
	date_GTE?: InputMaybe<Scalars["Date"]>;
	date_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
	date_LT?: InputMaybe<Scalars["Date"]>;
	date_LTE?: InputMaybe<Scalars["Date"]>;
	date_NOT?: InputMaybe<Scalars["Date"]>;
	date_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
	evaluates?: InputMaybe<FlexEntityWhere>;
	evaluatesAggregate?: InputMaybe<FlexFinancialDataPointEvaluatesAggregateInput>;
	evaluatesConnection?: InputMaybe<FlexFinancialDataPointEvaluatesConnectionWhere>;
	evaluatesConnection_NOT?: InputMaybe<FlexFinancialDataPointEvaluatesConnectionWhere>;
	evaluates_NOT?: InputMaybe<FlexEntityWhere>;
	evaluationSnapshot?: InputMaybe<Scalars["String"]>;
	evaluationSnapshot_CONTAINS?: InputMaybe<Scalars["String"]>;
	evaluationSnapshot_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	evaluationSnapshot_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	evaluationSnapshot_MATCHES?: InputMaybe<Scalars["String"]>;
	evaluationSnapshot_NOT?: InputMaybe<Scalars["String"]>;
	evaluationSnapshot_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	evaluationSnapshot_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	evaluationSnapshot_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	evaluationSnapshot_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	evaluationSnapshot_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	generatedUuid?: InputMaybe<Scalars["ID"]>;
	generatedUuid_CONTAINS?: InputMaybe<Scalars["ID"]>;
	generatedUuid_ENDS_WITH?: InputMaybe<Scalars["ID"]>;
	generatedUuid_IN?: InputMaybe<Array<InputMaybe<Scalars["ID"]>>>;
	generatedUuid_MATCHES?: InputMaybe<Scalars["String"]>;
	generatedUuid_NOT?: InputMaybe<Scalars["ID"]>;
	generatedUuid_NOT_CONTAINS?: InputMaybe<Scalars["ID"]>;
	generatedUuid_NOT_ENDS_WITH?: InputMaybe<Scalars["ID"]>;
	generatedUuid_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["ID"]>>>;
	generatedUuid_NOT_STARTS_WITH?: InputMaybe<Scalars["ID"]>;
	generatedUuid_STARTS_WITH?: InputMaybe<Scalars["ID"]>;
	includedIn?: InputMaybe<CaseWhere>;
	includedInAggregate?: InputMaybe<FlexFinancialDataPointIncludedInAggregateInput>;
	includedInConnection?: InputMaybe<FlexFinancialDataPointIncludedInConnectionWhere>;
	includedInConnection_NOT?: InputMaybe<FlexFinancialDataPointIncludedInConnectionWhere>;
	includedIn_NOT?: InputMaybe<CaseWhere>;
	isDeleted?: InputMaybe<Scalars["Boolean"]>;
	isDeleted_NOT?: InputMaybe<Scalars["Boolean"]>;
	isLast?: InputMaybe<Scalars["Boolean"]>;
	isLast_NOT?: InputMaybe<Scalars["Boolean"]>;
	payable?: InputMaybe<Scalars["Float"]>;
	payablePercentage?: InputMaybe<Scalars["Float"]>;
	payablePercentage_GT?: InputMaybe<Scalars["Float"]>;
	payablePercentage_GTE?: InputMaybe<Scalars["Float"]>;
	payablePercentage_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	payablePercentage_LT?: InputMaybe<Scalars["Float"]>;
	payablePercentage_LTE?: InputMaybe<Scalars["Float"]>;
	payablePercentage_NOT?: InputMaybe<Scalars["Float"]>;
	payablePercentage_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	payable_GT?: InputMaybe<Scalars["Float"]>;
	payable_GTE?: InputMaybe<Scalars["Float"]>;
	payable_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	payable_LT?: InputMaybe<Scalars["Float"]>;
	payable_LTE?: InputMaybe<Scalars["Float"]>;
	payable_NOT?: InputMaybe<Scalars["Float"]>;
	payable_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	prescriptionDate?: InputMaybe<Scalars["Date"]>;
	prescriptionDate_GT?: InputMaybe<Scalars["Date"]>;
	prescriptionDate_GTE?: InputMaybe<Scalars["Date"]>;
	prescriptionDate_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
	prescriptionDate_LT?: InputMaybe<Scalars["Date"]>;
	prescriptionDate_LTE?: InputMaybe<Scalars["Date"]>;
	prescriptionDate_NOT?: InputMaybe<Scalars["Date"]>;
	prescriptionDate_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
	quantity?: InputMaybe<Scalars["Float"]>;
	quantity_GT?: InputMaybe<Scalars["Float"]>;
	quantity_GTE?: InputMaybe<Scalars["Float"]>;
	quantity_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	quantity_LT?: InputMaybe<Scalars["Float"]>;
	quantity_LTE?: InputMaybe<Scalars["Float"]>;
	quantity_NOT?: InputMaybe<Scalars["Float"]>;
	quantity_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	refundable?: InputMaybe<Scalars["Float"]>;
	refundablePercentage?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_GT?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_GTE?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	refundablePercentage_LT?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_LTE?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_NOT?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	refundable_GT?: InputMaybe<Scalars["Float"]>;
	refundable_GTE?: InputMaybe<Scalars["Float"]>;
	refundable_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	refundable_LT?: InputMaybe<Scalars["Float"]>;
	refundable_LTE?: InputMaybe<Scalars["Float"]>;
	refundable_NOT?: InputMaybe<Scalars["Float"]>;
	refundable_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	sourceRefund?: InputMaybe<RefundWhere>;
	sourceRefundAggregate?: InputMaybe<FlexFinancialDataPointSourceRefundAggregateInput>;
	sourceRefundConnection?: InputMaybe<FlexFinancialDataPointSourceRefundConnectionWhere>;
	sourceRefundConnection_NOT?: InputMaybe<FlexFinancialDataPointSourceRefundConnectionWhere>;
	sourceRefund_NOT?: InputMaybe<RefundWhere>;
	startingPoint?: InputMaybe<FlexEntityWhere>;
	startingPointAggregate?: InputMaybe<FlexFinancialDataPointStartingPointAggregateInput>;
	startingPointConnection?: InputMaybe<FlexFinancialDataPointStartingPointConnectionWhere>;
	startingPointConnection_NOT?: InputMaybe<FlexFinancialDataPointStartingPointConnectionWhere>;
	startingPoint_NOT?: InputMaybe<FlexEntityWhere>;
	treatment?: InputMaybe<TreatmentWhere>;
	treatmentAggregate?: InputMaybe<FlexFinancialDataPointTreatmentAggregateInput>;
	treatmentConnection?: InputMaybe<FlexFinancialDataPointTreatmentConnectionWhere>;
	treatmentConnection_NOT?: InputMaybe<FlexFinancialDataPointTreatmentConnectionWhere>;
	treatment_NOT?: InputMaybe<TreatmentWhere>;
	uuid?: InputMaybe<Scalars["ID"]>;
	uuid_CONTAINS?: InputMaybe<Scalars["ID"]>;
	uuid_ENDS_WITH?: InputMaybe<Scalars["ID"]>;
	uuid_IN?: InputMaybe<Array<InputMaybe<Scalars["ID"]>>>;
	uuid_MATCHES?: InputMaybe<Scalars["String"]>;
	uuid_NOT?: InputMaybe<Scalars["ID"]>;
	uuid_NOT_CONTAINS?: InputMaybe<Scalars["ID"]>;
	uuid_NOT_ENDS_WITH?: InputMaybe<Scalars["ID"]>;
	uuid_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["ID"]>>>;
	uuid_NOT_STARTS_WITH?: InputMaybe<Scalars["ID"]>;
	uuid_STARTS_WITH?: InputMaybe<Scalars["ID"]>;
	variable?: InputMaybe<Scalars["Float"]>;
	variablePercentage?: InputMaybe<Scalars["Float"]>;
	variablePercentage_GT?: InputMaybe<Scalars["Float"]>;
	variablePercentage_GTE?: InputMaybe<Scalars["Float"]>;
	variablePercentage_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	variablePercentage_LT?: InputMaybe<Scalars["Float"]>;
	variablePercentage_LTE?: InputMaybe<Scalars["Float"]>;
	variablePercentage_NOT?: InputMaybe<Scalars["Float"]>;
	variablePercentage_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	variable_GT?: InputMaybe<Scalars["Float"]>;
	variable_GTE?: InputMaybe<Scalars["Float"]>;
	variable_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	variable_LT?: InputMaybe<Scalars["Float"]>;
	variable_LTE?: InputMaybe<Scalars["Float"]>;
	variable_NOT?: InputMaybe<Scalars["Float"]>;
	variable_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
};

export enum FlexFormStatus {
	CoolingPeriod = "COOLING_PERIOD",
	Draft = "DRAFT",
	Matched = "MATCHED",
	Submitted = "SUBMITTED",
	Unmatched = "UNMATCHED",
}

export type FloatAggregateSelection = {
	__typename?: "FloatAggregateSelection";
	average: Scalars["Float"];
	max: Scalars["Float"];
	min: Scalars["Float"];
};

export type Form = {
	__typename?: "Form";
	case?: Maybe<Case>;
	continuousBenefit?: Maybe<ContinuousBenefit>;
	continuousBenefitConnection: FormContinuousBenefitConnection;
	coverageRequest?: Maybe<CoverageRequest>;
	coverageRequestConnection: FormCoverageRequestConnection;
	createdBy?: Maybe<Scalars["String"]>;
	createdByName?: Maybe<Scalars["String"]>;
	createdOn: Scalars["DateTime"];
	discontinuationNote?: Maybe<DiscontinuationNote>;
	discontinuationNoteConnection: FormDiscontinuationNoteConnection;
	id: Scalars["ID"];
	initialResponse?: Maybe<InitialResponse>;
	initialResponseConnection: FormInitialResponseConnection;
	insuranceId?: Maybe<Scalars["String"]>;
	isArchived: Scalars["Boolean"];
	isDeleted: Scalars["Boolean"];
	lastUpdatedOn?: Maybe<Scalars["DateTime"]>;
	occurrence?: Maybe<OccurrenceEnum>;
	preparationBrandName?: Maybe<Scalars["String"]>;
	preparationGenericName?: Maybe<Scalars["String"]>;
	primaryIntervention?: Maybe<Intervention>;
	primaryInterventionConnection: FormPrimaryInterventionConnection;
	status?: Maybe<FormStatus>;
	subsequentIntervention?: Maybe<Intervention>;
	subsequentInterventionConnection: FormSubsequentInterventionConnection;
	tenantId: Scalars["String"];
	type?: Maybe<FormType>;
	unlimited?: Maybe<Scalars["Int"]>;
	uuid?: Maybe<Scalars["String"]>;
};

export type FormContinuousBenefitArgs = {
	options?: InputMaybe<ContinuousBenefitOptions>;
	where?: InputMaybe<ContinuousBenefitWhere>;
};

export type FormContinuousBenefitConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<FormContinuousBenefitConnectionSort>>;
	where?: InputMaybe<FormContinuousBenefitConnectionWhere>;
};

export type FormCoverageRequestArgs = {
	options?: InputMaybe<CoverageRequestOptions>;
	where?: InputMaybe<CoverageRequestWhere>;
};

export type FormCoverageRequestConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<FormCoverageRequestConnectionSort>>;
	where?: InputMaybe<FormCoverageRequestConnectionWhere>;
};

export type FormDiscontinuationNoteArgs = {
	options?: InputMaybe<DiscontinuationNoteOptions>;
	where?: InputMaybe<DiscontinuationNoteWhere>;
};

export type FormDiscontinuationNoteConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<FormDiscontinuationNoteConnectionSort>>;
	where?: InputMaybe<FormDiscontinuationNoteConnectionWhere>;
};

export type FormInitialResponseArgs = {
	options?: InputMaybe<InitialResponseOptions>;
	where?: InputMaybe<InitialResponseWhere>;
};

export type FormInitialResponseConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<FormInitialResponseConnectionSort>>;
	where?: InputMaybe<FormInitialResponseConnectionWhere>;
};

export type FormPrimaryInterventionArgs = {
	options?: InputMaybe<InterventionOptions>;
	where?: InputMaybe<InterventionWhere>;
};

export type FormPrimaryInterventionConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<FormPrimaryInterventionConnectionSort>>;
	where?: InputMaybe<FormPrimaryInterventionConnectionWhere>;
};

export type FormSubsequentInterventionArgs = {
	options?: InputMaybe<InterventionOptions>;
	where?: InputMaybe<InterventionWhere>;
};

export type FormSubsequentInterventionConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<FormSubsequentInterventionConnectionSort>>;
	where?: InputMaybe<FormSubsequentInterventionConnectionWhere>;
};

export type FormAggregateSelection = {
	__typename?: "FormAggregateSelection";
	count: Scalars["Int"];
	createdBy: StringAggregateSelection;
	createdByName: StringAggregateSelection;
	createdOn: DateTimeAggregateSelection;
	id: IdAggregateSelection;
	insuranceId: StringAggregateSelection;
	lastUpdatedOn: DateTimeAggregateSelection;
	preparationBrandName: StringAggregateSelection;
	preparationGenericName: StringAggregateSelection;
	tenantId: StringAggregateSelection;
	unlimited: IntAggregateSelection;
	uuid: StringAggregateSelection;
};

export type FormConnectInput = {
	continuousBenefit?: InputMaybe<FormContinuousBenefitConnectFieldInput>;
	coverageRequest?: InputMaybe<FormCoverageRequestConnectFieldInput>;
	discontinuationNote?: InputMaybe<FormDiscontinuationNoteConnectFieldInput>;
	initialResponse?: InputMaybe<FormInitialResponseConnectFieldInput>;
	primaryIntervention?: InputMaybe<FormPrimaryInterventionConnectFieldInput>;
	subsequentIntervention?: InputMaybe<FormSubsequentInterventionConnectFieldInput>;
};

export type FormConnectWhere = {
	node: FormWhere;
};

export type FormContinuousBenefitAggregateInput = {
	AND?: InputMaybe<Array<FormContinuousBenefitAggregateInput>>;
	OR?: InputMaybe<Array<FormContinuousBenefitAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<FormContinuousBenefitNodeAggregationWhereInput>;
};

export type FormContinuousBenefitConnectFieldInput = {
	connect?: InputMaybe<ContinuousBenefitConnectInput>;
	where?: InputMaybe<ContinuousBenefitConnectWhere>;
};

export type FormContinuousBenefitConnection = {
	__typename?: "FormContinuousBenefitConnection";
	edges: Array<FormContinuousBenefitRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type FormContinuousBenefitConnectionSort = {
	node?: InputMaybe<ContinuousBenefitSort>;
};

export type FormContinuousBenefitConnectionWhere = {
	AND?: InputMaybe<Array<FormContinuousBenefitConnectionWhere>>;
	OR?: InputMaybe<Array<FormContinuousBenefitConnectionWhere>>;
	node?: InputMaybe<ContinuousBenefitWhere>;
	node_NOT?: InputMaybe<ContinuousBenefitWhere>;
};

export type FormContinuousBenefitCreateFieldInput = {
	node: ContinuousBenefitCreateInput;
};

export type FormContinuousBenefitDeleteFieldInput = {
	delete?: InputMaybe<ContinuousBenefitDeleteInput>;
	where?: InputMaybe<FormContinuousBenefitConnectionWhere>;
};

export type FormContinuousBenefitDisconnectFieldInput = {
	disconnect?: InputMaybe<ContinuousBenefitDisconnectInput>;
	where?: InputMaybe<FormContinuousBenefitConnectionWhere>;
};

export type FormContinuousBenefitFieldInput = {
	connect?: InputMaybe<FormContinuousBenefitConnectFieldInput>;
	create?: InputMaybe<FormContinuousBenefitCreateFieldInput>;
};

export type FormContinuousBenefitNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<FormContinuousBenefitNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<FormContinuousBenefitNodeAggregationWhereInput>>;
	createdOn_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	submissionDate_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_GT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_GTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_LT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_LTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	tenantId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	tenantId_EQUAL?: InputMaybe<Scalars["String"]>;
	tenantId_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type FormContinuousBenefitRelationship = {
	__typename?: "FormContinuousBenefitRelationship";
	cursor: Scalars["String"];
	node: ContinuousBenefit;
};

export type FormContinuousBenefitUpdateConnectionInput = {
	node?: InputMaybe<ContinuousBenefitUpdateInput>;
};

export type FormContinuousBenefitUpdateFieldInput = {
	connect?: InputMaybe<FormContinuousBenefitConnectFieldInput>;
	create?: InputMaybe<FormContinuousBenefitCreateFieldInput>;
	delete?: InputMaybe<FormContinuousBenefitDeleteFieldInput>;
	disconnect?: InputMaybe<FormContinuousBenefitDisconnectFieldInput>;
	update?: InputMaybe<FormContinuousBenefitUpdateConnectionInput>;
	where?: InputMaybe<FormContinuousBenefitConnectionWhere>;
};

export type FormCoverageRequestAggregateInput = {
	AND?: InputMaybe<Array<FormCoverageRequestAggregateInput>>;
	OR?: InputMaybe<Array<FormCoverageRequestAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<FormCoverageRequestNodeAggregationWhereInput>;
};

export type FormCoverageRequestConnectFieldInput = {
	connect?: InputMaybe<CoverageRequestConnectInput>;
	where?: InputMaybe<CoverageRequestConnectWhere>;
};

export type FormCoverageRequestConnection = {
	__typename?: "FormCoverageRequestConnection";
	edges: Array<FormCoverageRequestRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type FormCoverageRequestConnectionSort = {
	node?: InputMaybe<CoverageRequestSort>;
};

export type FormCoverageRequestConnectionWhere = {
	AND?: InputMaybe<Array<FormCoverageRequestConnectionWhere>>;
	OR?: InputMaybe<Array<FormCoverageRequestConnectionWhere>>;
	node?: InputMaybe<CoverageRequestWhere>;
	node_NOT?: InputMaybe<CoverageRequestWhere>;
};

export type FormCoverageRequestCreateFieldInput = {
	node: CoverageRequestCreateInput;
};

export type FormCoverageRequestDeleteFieldInput = {
	delete?: InputMaybe<CoverageRequestDeleteInput>;
	where?: InputMaybe<FormCoverageRequestConnectionWhere>;
};

export type FormCoverageRequestDisconnectFieldInput = {
	disconnect?: InputMaybe<CoverageRequestDisconnectInput>;
	where?: InputMaybe<FormCoverageRequestConnectionWhere>;
};

export type FormCoverageRequestFieldInput = {
	connect?: InputMaybe<FormCoverageRequestConnectFieldInput>;
	create?: InputMaybe<FormCoverageRequestCreateFieldInput>;
};

export type FormCoverageRequestNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<FormCoverageRequestNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<FormCoverageRequestNodeAggregationWhereInput>>;
	createdOn_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	duration_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	duration_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	duration_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	duration_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	duration_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	duration_EQUAL?: InputMaybe<Scalars["Int"]>;
	duration_GT?: InputMaybe<Scalars["Int"]>;
	duration_GTE?: InputMaybe<Scalars["Int"]>;
	duration_LT?: InputMaybe<Scalars["Int"]>;
	duration_LTE?: InputMaybe<Scalars["Int"]>;
	duration_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	duration_MAX_GT?: InputMaybe<Scalars["Int"]>;
	duration_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	duration_MAX_LT?: InputMaybe<Scalars["Int"]>;
	duration_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	duration_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	duration_MIN_GT?: InputMaybe<Scalars["Int"]>;
	duration_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	duration_MIN_LT?: InputMaybe<Scalars["Int"]>;
	duration_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	lastUpdatedOn_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_GT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_LT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_GT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_GTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_LT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_LTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	tenantId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	tenantId_EQUAL?: InputMaybe<Scalars["String"]>;
	tenantId_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type FormCoverageRequestRelationship = {
	__typename?: "FormCoverageRequestRelationship";
	cursor: Scalars["String"];
	node: CoverageRequest;
};

export type FormCoverageRequestUpdateConnectionInput = {
	node?: InputMaybe<CoverageRequestUpdateInput>;
};

export type FormCoverageRequestUpdateFieldInput = {
	connect?: InputMaybe<FormCoverageRequestConnectFieldInput>;
	create?: InputMaybe<FormCoverageRequestCreateFieldInput>;
	delete?: InputMaybe<FormCoverageRequestDeleteFieldInput>;
	disconnect?: InputMaybe<FormCoverageRequestDisconnectFieldInput>;
	update?: InputMaybe<FormCoverageRequestUpdateConnectionInput>;
	where?: InputMaybe<FormCoverageRequestConnectionWhere>;
};

export type FormCreateInput = {
	continuousBenefit?: InputMaybe<FormContinuousBenefitFieldInput>;
	coverageRequest?: InputMaybe<FormCoverageRequestFieldInput>;
	createdBy?: InputMaybe<Scalars["String"]>;
	createdByName?: InputMaybe<Scalars["String"]>;
	createdOn: Scalars["DateTime"];
	discontinuationNote?: InputMaybe<FormDiscontinuationNoteFieldInput>;
	id: Scalars["ID"];
	initialResponse?: InputMaybe<FormInitialResponseFieldInput>;
	insuranceId?: InputMaybe<Scalars["String"]>;
	isArchived: Scalars["Boolean"];
	isDeleted: Scalars["Boolean"];
	lastUpdatedOn?: InputMaybe<Scalars["DateTime"]>;
	occurrence?: InputMaybe<OccurrenceEnum>;
	preparationBrandName?: InputMaybe<Scalars["String"]>;
	preparationGenericName?: InputMaybe<Scalars["String"]>;
	primaryIntervention?: InputMaybe<FormPrimaryInterventionFieldInput>;
	status?: InputMaybe<FormStatus>;
	subsequentIntervention?: InputMaybe<FormSubsequentInterventionFieldInput>;
	tenantId: Scalars["String"];
	type?: InputMaybe<FormType>;
	unlimited?: InputMaybe<Scalars["Int"]>;
	uuid?: InputMaybe<Scalars["String"]>;
};

export type FormDeleteInput = {
	continuousBenefit?: InputMaybe<FormContinuousBenefitDeleteFieldInput>;
	coverageRequest?: InputMaybe<FormCoverageRequestDeleteFieldInput>;
	discontinuationNote?: InputMaybe<FormDiscontinuationNoteDeleteFieldInput>;
	initialResponse?: InputMaybe<FormInitialResponseDeleteFieldInput>;
	primaryIntervention?: InputMaybe<FormPrimaryInterventionDeleteFieldInput>;
	subsequentIntervention?: InputMaybe<FormSubsequentInterventionDeleteFieldInput>;
};

export type FormDisconnectInput = {
	continuousBenefit?: InputMaybe<FormContinuousBenefitDisconnectFieldInput>;
	coverageRequest?: InputMaybe<FormCoverageRequestDisconnectFieldInput>;
	discontinuationNote?: InputMaybe<FormDiscontinuationNoteDisconnectFieldInput>;
	initialResponse?: InputMaybe<FormInitialResponseDisconnectFieldInput>;
	primaryIntervention?: InputMaybe<FormPrimaryInterventionDisconnectFieldInput>;
	subsequentIntervention?: InputMaybe<FormSubsequentInterventionDisconnectFieldInput>;
};

export type FormDiscontinuationNoteAggregateInput = {
	AND?: InputMaybe<Array<FormDiscontinuationNoteAggregateInput>>;
	OR?: InputMaybe<Array<FormDiscontinuationNoteAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<FormDiscontinuationNoteNodeAggregationWhereInput>;
};

export type FormDiscontinuationNoteConnectFieldInput = {
	connect?: InputMaybe<DiscontinuationNoteConnectInput>;
	where?: InputMaybe<DiscontinuationNoteConnectWhere>;
};

export type FormDiscontinuationNoteConnection = {
	__typename?: "FormDiscontinuationNoteConnection";
	edges: Array<FormDiscontinuationNoteRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type FormDiscontinuationNoteConnectionSort = {
	node?: InputMaybe<DiscontinuationNoteSort>;
};

export type FormDiscontinuationNoteConnectionWhere = {
	AND?: InputMaybe<Array<FormDiscontinuationNoteConnectionWhere>>;
	OR?: InputMaybe<Array<FormDiscontinuationNoteConnectionWhere>>;
	node?: InputMaybe<DiscontinuationNoteWhere>;
	node_NOT?: InputMaybe<DiscontinuationNoteWhere>;
};

export type FormDiscontinuationNoteCreateFieldInput = {
	node: DiscontinuationNoteCreateInput;
};

export type FormDiscontinuationNoteDeleteFieldInput = {
	delete?: InputMaybe<DiscontinuationNoteDeleteInput>;
	where?: InputMaybe<FormDiscontinuationNoteConnectionWhere>;
};

export type FormDiscontinuationNoteDisconnectFieldInput = {
	disconnect?: InputMaybe<DiscontinuationNoteDisconnectInput>;
	where?: InputMaybe<FormDiscontinuationNoteConnectionWhere>;
};

export type FormDiscontinuationNoteFieldInput = {
	connect?: InputMaybe<FormDiscontinuationNoteConnectFieldInput>;
	create?: InputMaybe<FormDiscontinuationNoteCreateFieldInput>;
};

export type FormDiscontinuationNoteNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<FormDiscontinuationNoteNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<FormDiscontinuationNoteNodeAggregationWhereInput>>;
	createdOn_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	submissionDate_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_GT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_GTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_LT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_LTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	tenantId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	tenantId_EQUAL?: InputMaybe<Scalars["String"]>;
	tenantId_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type FormDiscontinuationNoteRelationship = {
	__typename?: "FormDiscontinuationNoteRelationship";
	cursor: Scalars["String"];
	node: DiscontinuationNote;
};

export type FormDiscontinuationNoteUpdateConnectionInput = {
	node?: InputMaybe<DiscontinuationNoteUpdateInput>;
};

export type FormDiscontinuationNoteUpdateFieldInput = {
	connect?: InputMaybe<FormDiscontinuationNoteConnectFieldInput>;
	create?: InputMaybe<FormDiscontinuationNoteCreateFieldInput>;
	delete?: InputMaybe<FormDiscontinuationNoteDeleteFieldInput>;
	disconnect?: InputMaybe<FormDiscontinuationNoteDisconnectFieldInput>;
	update?: InputMaybe<FormDiscontinuationNoteUpdateConnectionInput>;
	where?: InputMaybe<FormDiscontinuationNoteConnectionWhere>;
};

export type FormInitialResponseAggregateInput = {
	AND?: InputMaybe<Array<FormInitialResponseAggregateInput>>;
	OR?: InputMaybe<Array<FormInitialResponseAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<FormInitialResponseNodeAggregationWhereInput>;
};

export type FormInitialResponseConnectFieldInput = {
	connect?: InputMaybe<InitialResponseConnectInput>;
	where?: InputMaybe<InitialResponseConnectWhere>;
};

export type FormInitialResponseConnection = {
	__typename?: "FormInitialResponseConnection";
	edges: Array<FormInitialResponseRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type FormInitialResponseConnectionSort = {
	node?: InputMaybe<InitialResponseSort>;
};

export type FormInitialResponseConnectionWhere = {
	AND?: InputMaybe<Array<FormInitialResponseConnectionWhere>>;
	OR?: InputMaybe<Array<FormInitialResponseConnectionWhere>>;
	node?: InputMaybe<InitialResponseWhere>;
	node_NOT?: InputMaybe<InitialResponseWhere>;
};

export type FormInitialResponseCreateFieldInput = {
	node: InitialResponseCreateInput;
};

export type FormInitialResponseDeleteFieldInput = {
	delete?: InputMaybe<InitialResponseDeleteInput>;
	where?: InputMaybe<FormInitialResponseConnectionWhere>;
};

export type FormInitialResponseDisconnectFieldInput = {
	disconnect?: InputMaybe<InitialResponseDisconnectInput>;
	where?: InputMaybe<FormInitialResponseConnectionWhere>;
};

export type FormInitialResponseFieldInput = {
	connect?: InputMaybe<FormInitialResponseConnectFieldInput>;
	create?: InputMaybe<FormInitialResponseCreateFieldInput>;
};

export type FormInitialResponseNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<FormInitialResponseNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<FormInitialResponseNodeAggregationWhereInput>>;
	createdOn_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	numberOfPrescriptionsToDate_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	numberOfPrescriptionsToDate_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	numberOfPrescriptionsToDate_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	numberOfPrescriptionsToDate_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	numberOfPrescriptionsToDate_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	numberOfPrescriptionsToDate_EQUAL?: InputMaybe<Scalars["Int"]>;
	numberOfPrescriptionsToDate_GT?: InputMaybe<Scalars["Int"]>;
	numberOfPrescriptionsToDate_GTE?: InputMaybe<Scalars["Int"]>;
	numberOfPrescriptionsToDate_LT?: InputMaybe<Scalars["Int"]>;
	numberOfPrescriptionsToDate_LTE?: InputMaybe<Scalars["Int"]>;
	numberOfPrescriptionsToDate_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	numberOfPrescriptionsToDate_MAX_GT?: InputMaybe<Scalars["Int"]>;
	numberOfPrescriptionsToDate_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	numberOfPrescriptionsToDate_MAX_LT?: InputMaybe<Scalars["Int"]>;
	numberOfPrescriptionsToDate_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	numberOfPrescriptionsToDate_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	numberOfPrescriptionsToDate_MIN_GT?: InputMaybe<Scalars["Int"]>;
	numberOfPrescriptionsToDate_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	numberOfPrescriptionsToDate_MIN_LT?: InputMaybe<Scalars["Int"]>;
	numberOfPrescriptionsToDate_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	submissionDate_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_GT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_GTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_LT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_LTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	tenantId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	tenantId_EQUAL?: InputMaybe<Scalars["String"]>;
	tenantId_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type FormInitialResponseRelationship = {
	__typename?: "FormInitialResponseRelationship";
	cursor: Scalars["String"];
	node: InitialResponse;
};

export type FormInitialResponseUpdateConnectionInput = {
	node?: InputMaybe<InitialResponseUpdateInput>;
};

export type FormInitialResponseUpdateFieldInput = {
	connect?: InputMaybe<FormInitialResponseConnectFieldInput>;
	create?: InputMaybe<FormInitialResponseCreateFieldInput>;
	delete?: InputMaybe<FormInitialResponseDeleteFieldInput>;
	disconnect?: InputMaybe<FormInitialResponseDisconnectFieldInput>;
	update?: InputMaybe<FormInitialResponseUpdateConnectionInput>;
	where?: InputMaybe<FormInitialResponseConnectionWhere>;
};

export type FormOptions = {
	limit?: InputMaybe<Scalars["Int"]>;
	offset?: InputMaybe<Scalars["Int"]>;
	/** Specify one or more FormSort objects to sort Forms by. The sorts will be applied in the order in which they are arranged in the array. */
	sort?: InputMaybe<Array<InputMaybe<FormSort>>>;
};

export type FormPrimaryInterventionAggregateInput = {
	AND?: InputMaybe<Array<FormPrimaryInterventionAggregateInput>>;
	OR?: InputMaybe<Array<FormPrimaryInterventionAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<FormPrimaryInterventionNodeAggregationWhereInput>;
};

export type FormPrimaryInterventionConnectFieldInput = {
	connect?: InputMaybe<InterventionConnectInput>;
	where?: InputMaybe<InterventionConnectWhere>;
};

export type FormPrimaryInterventionConnection = {
	__typename?: "FormPrimaryInterventionConnection";
	edges: Array<FormPrimaryInterventionRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type FormPrimaryInterventionConnectionSort = {
	node?: InputMaybe<InterventionSort>;
};

export type FormPrimaryInterventionConnectionWhere = {
	AND?: InputMaybe<Array<FormPrimaryInterventionConnectionWhere>>;
	OR?: InputMaybe<Array<FormPrimaryInterventionConnectionWhere>>;
	node?: InputMaybe<InterventionWhere>;
	node_NOT?: InputMaybe<InterventionWhere>;
};

export type FormPrimaryInterventionCreateFieldInput = {
	node: InterventionCreateInput;
};

export type FormPrimaryInterventionDeleteFieldInput = {
	delete?: InputMaybe<InterventionDeleteInput>;
	where?: InputMaybe<FormPrimaryInterventionConnectionWhere>;
};

export type FormPrimaryInterventionDisconnectFieldInput = {
	disconnect?: InputMaybe<InterventionDisconnectInput>;
	where?: InputMaybe<FormPrimaryInterventionConnectionWhere>;
};

export type FormPrimaryInterventionFieldInput = {
	connect?: InputMaybe<FormPrimaryInterventionConnectFieldInput>;
	create?: InputMaybe<FormPrimaryInterventionCreateFieldInput>;
};

export type FormPrimaryInterventionNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<FormPrimaryInterventionNodeAggregationWhereInput>>;
	LAPressure_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	LAPressure_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	LAPressure_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	LAPressure_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	LAPressure_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	LAPressure_EQUAL?: InputMaybe<Scalars["Int"]>;
	LAPressure_GT?: InputMaybe<Scalars["Int"]>;
	LAPressure_GTE?: InputMaybe<Scalars["Int"]>;
	LAPressure_LT?: InputMaybe<Scalars["Int"]>;
	LAPressure_LTE?: InputMaybe<Scalars["Int"]>;
	LAPressure_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	LAPressure_MAX_GT?: InputMaybe<Scalars["Int"]>;
	LAPressure_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	LAPressure_MAX_LT?: InputMaybe<Scalars["Int"]>;
	LAPressure_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	LAPressure_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	LAPressure_MIN_GT?: InputMaybe<Scalars["Int"]>;
	LAPressure_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	LAPressure_MIN_LT?: InputMaybe<Scalars["Int"]>;
	LAPressure_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	LAVolume_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	LAVolume_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	LAVolume_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	LAVolume_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	LAVolume_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	LAVolume_EQUAL?: InputMaybe<Scalars["Int"]>;
	LAVolume_GT?: InputMaybe<Scalars["Int"]>;
	LAVolume_GTE?: InputMaybe<Scalars["Int"]>;
	LAVolume_LT?: InputMaybe<Scalars["Int"]>;
	LAVolume_LTE?: InputMaybe<Scalars["Int"]>;
	LAVolume_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	LAVolume_MAX_GT?: InputMaybe<Scalars["Int"]>;
	LAVolume_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	LAVolume_MAX_LT?: InputMaybe<Scalars["Int"]>;
	LAVolume_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	LAVolume_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	LAVolume_MIN_GT?: InputMaybe<Scalars["Int"]>;
	LAVolume_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	LAVolume_MIN_LT?: InputMaybe<Scalars["Int"]>;
	LAVolume_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	OR?: InputMaybe<Array<FormPrimaryInterventionNodeAggregationWhereInput>>;
	createdOn_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	lastUpdatedOn_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_GT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_LT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_GT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_GTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_LT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_LTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	tenantId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	tenantId_EQUAL?: InputMaybe<Scalars["String"]>;
	tenantId_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type FormPrimaryInterventionRelationship = {
	__typename?: "FormPrimaryInterventionRelationship";
	cursor: Scalars["String"];
	node: Intervention;
};

export type FormPrimaryInterventionUpdateConnectionInput = {
	node?: InputMaybe<InterventionUpdateInput>;
};

export type FormPrimaryInterventionUpdateFieldInput = {
	connect?: InputMaybe<FormPrimaryInterventionConnectFieldInput>;
	create?: InputMaybe<FormPrimaryInterventionCreateFieldInput>;
	delete?: InputMaybe<FormPrimaryInterventionDeleteFieldInput>;
	disconnect?: InputMaybe<FormPrimaryInterventionDisconnectFieldInput>;
	update?: InputMaybe<FormPrimaryInterventionUpdateConnectionInput>;
	where?: InputMaybe<FormPrimaryInterventionConnectionWhere>;
};

/** Fields to sort Forms by. The order in which sorts are applied is not guaranteed when specifying many fields in one FormSort object. */
export type FormSort = {
	createdBy?: InputMaybe<SortDirection>;
	createdByName?: InputMaybe<SortDirection>;
	createdOn?: InputMaybe<SortDirection>;
	id?: InputMaybe<SortDirection>;
	insuranceId?: InputMaybe<SortDirection>;
	isArchived?: InputMaybe<SortDirection>;
	isDeleted?: InputMaybe<SortDirection>;
	lastUpdatedOn?: InputMaybe<SortDirection>;
	occurrence?: InputMaybe<SortDirection>;
	preparationBrandName?: InputMaybe<SortDirection>;
	preparationGenericName?: InputMaybe<SortDirection>;
	status?: InputMaybe<SortDirection>;
	tenantId?: InputMaybe<SortDirection>;
	type?: InputMaybe<SortDirection>;
	unlimited?: InputMaybe<SortDirection>;
	uuid?: InputMaybe<SortDirection>;
};

export enum FormStatus {
	Draft = "DRAFT",
	Submitted = "SUBMITTED",
}

export type FormSubsequentInterventionAggregateInput = {
	AND?: InputMaybe<Array<FormSubsequentInterventionAggregateInput>>;
	OR?: InputMaybe<Array<FormSubsequentInterventionAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<FormSubsequentInterventionNodeAggregationWhereInput>;
};

export type FormSubsequentInterventionConnectFieldInput = {
	connect?: InputMaybe<InterventionConnectInput>;
	where?: InputMaybe<InterventionConnectWhere>;
};

export type FormSubsequentInterventionConnection = {
	__typename?: "FormSubsequentInterventionConnection";
	edges: Array<FormSubsequentInterventionRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type FormSubsequentInterventionConnectionSort = {
	node?: InputMaybe<InterventionSort>;
};

export type FormSubsequentInterventionConnectionWhere = {
	AND?: InputMaybe<Array<FormSubsequentInterventionConnectionWhere>>;
	OR?: InputMaybe<Array<FormSubsequentInterventionConnectionWhere>>;
	node?: InputMaybe<InterventionWhere>;
	node_NOT?: InputMaybe<InterventionWhere>;
};

export type FormSubsequentInterventionCreateFieldInput = {
	node: InterventionCreateInput;
};

export type FormSubsequentInterventionDeleteFieldInput = {
	delete?: InputMaybe<InterventionDeleteInput>;
	where?: InputMaybe<FormSubsequentInterventionConnectionWhere>;
};

export type FormSubsequentInterventionDisconnectFieldInput = {
	disconnect?: InputMaybe<InterventionDisconnectInput>;
	where?: InputMaybe<FormSubsequentInterventionConnectionWhere>;
};

export type FormSubsequentInterventionFieldInput = {
	connect?: InputMaybe<FormSubsequentInterventionConnectFieldInput>;
	create?: InputMaybe<FormSubsequentInterventionCreateFieldInput>;
};

export type FormSubsequentInterventionNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<FormSubsequentInterventionNodeAggregationWhereInput>>;
	LAPressure_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	LAPressure_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	LAPressure_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	LAPressure_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	LAPressure_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	LAPressure_EQUAL?: InputMaybe<Scalars["Int"]>;
	LAPressure_GT?: InputMaybe<Scalars["Int"]>;
	LAPressure_GTE?: InputMaybe<Scalars["Int"]>;
	LAPressure_LT?: InputMaybe<Scalars["Int"]>;
	LAPressure_LTE?: InputMaybe<Scalars["Int"]>;
	LAPressure_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	LAPressure_MAX_GT?: InputMaybe<Scalars["Int"]>;
	LAPressure_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	LAPressure_MAX_LT?: InputMaybe<Scalars["Int"]>;
	LAPressure_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	LAPressure_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	LAPressure_MIN_GT?: InputMaybe<Scalars["Int"]>;
	LAPressure_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	LAPressure_MIN_LT?: InputMaybe<Scalars["Int"]>;
	LAPressure_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	LAVolume_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	LAVolume_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	LAVolume_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	LAVolume_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	LAVolume_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	LAVolume_EQUAL?: InputMaybe<Scalars["Int"]>;
	LAVolume_GT?: InputMaybe<Scalars["Int"]>;
	LAVolume_GTE?: InputMaybe<Scalars["Int"]>;
	LAVolume_LT?: InputMaybe<Scalars["Int"]>;
	LAVolume_LTE?: InputMaybe<Scalars["Int"]>;
	LAVolume_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	LAVolume_MAX_GT?: InputMaybe<Scalars["Int"]>;
	LAVolume_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	LAVolume_MAX_LT?: InputMaybe<Scalars["Int"]>;
	LAVolume_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	LAVolume_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	LAVolume_MIN_GT?: InputMaybe<Scalars["Int"]>;
	LAVolume_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	LAVolume_MIN_LT?: InputMaybe<Scalars["Int"]>;
	LAVolume_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	OR?: InputMaybe<Array<FormSubsequentInterventionNodeAggregationWhereInput>>;
	createdOn_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	lastUpdatedOn_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_GT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_LT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_GT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_GTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_LT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_LTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	tenantId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	tenantId_EQUAL?: InputMaybe<Scalars["String"]>;
	tenantId_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type FormSubsequentInterventionRelationship = {
	__typename?: "FormSubsequentInterventionRelationship";
	cursor: Scalars["String"];
	node: Intervention;
};

export type FormSubsequentInterventionUpdateConnectionInput = {
	node?: InputMaybe<InterventionUpdateInput>;
};

export type FormSubsequentInterventionUpdateFieldInput = {
	connect?: InputMaybe<FormSubsequentInterventionConnectFieldInput>;
	create?: InputMaybe<FormSubsequentInterventionCreateFieldInput>;
	delete?: InputMaybe<FormSubsequentInterventionDeleteFieldInput>;
	disconnect?: InputMaybe<FormSubsequentInterventionDisconnectFieldInput>;
	update?: InputMaybe<FormSubsequentInterventionUpdateConnectionInput>;
	where?: InputMaybe<FormSubsequentInterventionConnectionWhere>;
};

export enum FormType {
	ContinuousBenefit = "CONTINUOUS_BENEFIT",
	CoverageRequest = "COVERAGE_REQUEST",
	DiscontinuationNote = "DISCONTINUATION_NOTE",
	InitialResponse = "INITIAL_RESPONSE",
	PrimaryIntervention = "PRIMARY_INTERVENTION",
	SubsequentIntervention = "SUBSEQUENT_INTERVENTION",
}

export type FormUpdateInput = {
	continuousBenefit?: InputMaybe<FormContinuousBenefitUpdateFieldInput>;
	coverageRequest?: InputMaybe<FormCoverageRequestUpdateFieldInput>;
	createdBy?: InputMaybe<Scalars["String"]>;
	createdByName?: InputMaybe<Scalars["String"]>;
	createdOn?: InputMaybe<Scalars["DateTime"]>;
	discontinuationNote?: InputMaybe<FormDiscontinuationNoteUpdateFieldInput>;
	id?: InputMaybe<Scalars["ID"]>;
	initialResponse?: InputMaybe<FormInitialResponseUpdateFieldInput>;
	insuranceId?: InputMaybe<Scalars["String"]>;
	isArchived?: InputMaybe<Scalars["Boolean"]>;
	isDeleted?: InputMaybe<Scalars["Boolean"]>;
	lastUpdatedOn?: InputMaybe<Scalars["DateTime"]>;
	occurrence?: InputMaybe<OccurrenceEnum>;
	preparationBrandName?: InputMaybe<Scalars["String"]>;
	preparationGenericName?: InputMaybe<Scalars["String"]>;
	primaryIntervention?: InputMaybe<FormPrimaryInterventionUpdateFieldInput>;
	status?: InputMaybe<FormStatus>;
	subsequentIntervention?: InputMaybe<FormSubsequentInterventionUpdateFieldInput>;
	tenantId?: InputMaybe<Scalars["String"]>;
	type?: InputMaybe<FormType>;
	unlimited?: InputMaybe<Scalars["Int"]>;
	uuid?: InputMaybe<Scalars["String"]>;
};

export type FormWhere = {
	AND?: InputMaybe<Array<FormWhere>>;
	OR?: InputMaybe<Array<FormWhere>>;
	continuousBenefit?: InputMaybe<ContinuousBenefitWhere>;
	continuousBenefitAggregate?: InputMaybe<FormContinuousBenefitAggregateInput>;
	continuousBenefitConnection?: InputMaybe<FormContinuousBenefitConnectionWhere>;
	continuousBenefitConnection_NOT?: InputMaybe<FormContinuousBenefitConnectionWhere>;
	continuousBenefit_NOT?: InputMaybe<ContinuousBenefitWhere>;
	coverageRequest?: InputMaybe<CoverageRequestWhere>;
	coverageRequestAggregate?: InputMaybe<FormCoverageRequestAggregateInput>;
	coverageRequestConnection?: InputMaybe<FormCoverageRequestConnectionWhere>;
	coverageRequestConnection_NOT?: InputMaybe<FormCoverageRequestConnectionWhere>;
	coverageRequest_NOT?: InputMaybe<CoverageRequestWhere>;
	createdBy?: InputMaybe<Scalars["String"]>;
	createdByName?: InputMaybe<Scalars["String"]>;
	createdByName_CONTAINS?: InputMaybe<Scalars["String"]>;
	createdByName_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	createdByName_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	createdByName_MATCHES?: InputMaybe<Scalars["String"]>;
	createdByName_NOT?: InputMaybe<Scalars["String"]>;
	createdByName_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	createdByName_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	createdByName_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	createdByName_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	createdByName_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	createdBy_CONTAINS?: InputMaybe<Scalars["String"]>;
	createdBy_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	createdBy_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	createdBy_MATCHES?: InputMaybe<Scalars["String"]>;
	createdBy_NOT?: InputMaybe<Scalars["String"]>;
	createdBy_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	createdBy_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	createdBy_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	createdBy_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	createdBy_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	createdOn?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_IN?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]>>>;
	createdOn_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_NOT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]>>>;
	discontinuationNote?: InputMaybe<DiscontinuationNoteWhere>;
	discontinuationNoteAggregate?: InputMaybe<FormDiscontinuationNoteAggregateInput>;
	discontinuationNoteConnection?: InputMaybe<FormDiscontinuationNoteConnectionWhere>;
	discontinuationNoteConnection_NOT?: InputMaybe<FormDiscontinuationNoteConnectionWhere>;
	discontinuationNote_NOT?: InputMaybe<DiscontinuationNoteWhere>;
	id?: InputMaybe<Scalars["ID"]>;
	id_CONTAINS?: InputMaybe<Scalars["ID"]>;
	id_ENDS_WITH?: InputMaybe<Scalars["ID"]>;
	id_IN?: InputMaybe<Array<InputMaybe<Scalars["ID"]>>>;
	id_MATCHES?: InputMaybe<Scalars["String"]>;
	id_NOT?: InputMaybe<Scalars["ID"]>;
	id_NOT_CONTAINS?: InputMaybe<Scalars["ID"]>;
	id_NOT_ENDS_WITH?: InputMaybe<Scalars["ID"]>;
	id_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["ID"]>>>;
	id_NOT_STARTS_WITH?: InputMaybe<Scalars["ID"]>;
	id_STARTS_WITH?: InputMaybe<Scalars["ID"]>;
	initialResponse?: InputMaybe<InitialResponseWhere>;
	initialResponseAggregate?: InputMaybe<FormInitialResponseAggregateInput>;
	initialResponseConnection?: InputMaybe<FormInitialResponseConnectionWhere>;
	initialResponseConnection_NOT?: InputMaybe<FormInitialResponseConnectionWhere>;
	initialResponse_NOT?: InputMaybe<InitialResponseWhere>;
	insuranceId?: InputMaybe<Scalars["String"]>;
	insuranceId_CONTAINS?: InputMaybe<Scalars["String"]>;
	insuranceId_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	insuranceId_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	insuranceId_MATCHES?: InputMaybe<Scalars["String"]>;
	insuranceId_NOT?: InputMaybe<Scalars["String"]>;
	insuranceId_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	insuranceId_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	insuranceId_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	insuranceId_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	insuranceId_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	isArchived?: InputMaybe<Scalars["Boolean"]>;
	isArchived_NOT?: InputMaybe<Scalars["Boolean"]>;
	isDeleted?: InputMaybe<Scalars["Boolean"]>;
	isDeleted_NOT?: InputMaybe<Scalars["Boolean"]>;
	lastUpdatedOn?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_GT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_IN?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]>>>;
	lastUpdatedOn_LT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_NOT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]>>>;
	occurrence?: InputMaybe<OccurrenceEnum>;
	occurrence_IN?: InputMaybe<Array<InputMaybe<OccurrenceEnum>>>;
	occurrence_NOT?: InputMaybe<OccurrenceEnum>;
	occurrence_NOT_IN?: InputMaybe<Array<InputMaybe<OccurrenceEnum>>>;
	preparationBrandName?: InputMaybe<Scalars["String"]>;
	preparationBrandName_CONTAINS?: InputMaybe<Scalars["String"]>;
	preparationBrandName_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	preparationBrandName_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	preparationBrandName_MATCHES?: InputMaybe<Scalars["String"]>;
	preparationBrandName_NOT?: InputMaybe<Scalars["String"]>;
	preparationBrandName_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	preparationBrandName_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	preparationBrandName_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	preparationBrandName_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	preparationBrandName_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	preparationGenericName?: InputMaybe<Scalars["String"]>;
	preparationGenericName_CONTAINS?: InputMaybe<Scalars["String"]>;
	preparationGenericName_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	preparationGenericName_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	preparationGenericName_MATCHES?: InputMaybe<Scalars["String"]>;
	preparationGenericName_NOT?: InputMaybe<Scalars["String"]>;
	preparationGenericName_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	preparationGenericName_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	preparationGenericName_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	preparationGenericName_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	preparationGenericName_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	primaryIntervention?: InputMaybe<InterventionWhere>;
	primaryInterventionAggregate?: InputMaybe<FormPrimaryInterventionAggregateInput>;
	primaryInterventionConnection?: InputMaybe<FormPrimaryInterventionConnectionWhere>;
	primaryInterventionConnection_NOT?: InputMaybe<FormPrimaryInterventionConnectionWhere>;
	primaryIntervention_NOT?: InputMaybe<InterventionWhere>;
	status?: InputMaybe<FormStatus>;
	status_IN?: InputMaybe<Array<InputMaybe<FormStatus>>>;
	status_NOT?: InputMaybe<FormStatus>;
	status_NOT_IN?: InputMaybe<Array<InputMaybe<FormStatus>>>;
	subsequentIntervention?: InputMaybe<InterventionWhere>;
	subsequentInterventionAggregate?: InputMaybe<FormSubsequentInterventionAggregateInput>;
	subsequentInterventionConnection?: InputMaybe<FormSubsequentInterventionConnectionWhere>;
	subsequentInterventionConnection_NOT?: InputMaybe<FormSubsequentInterventionConnectionWhere>;
	subsequentIntervention_NOT?: InputMaybe<InterventionWhere>;
	tenantId?: InputMaybe<Scalars["String"]>;
	tenantId_CONTAINS?: InputMaybe<Scalars["String"]>;
	tenantId_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	tenantId_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	tenantId_MATCHES?: InputMaybe<Scalars["String"]>;
	tenantId_NOT?: InputMaybe<Scalars["String"]>;
	tenantId_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	tenantId_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	tenantId_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	tenantId_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	tenantId_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	type?: InputMaybe<FormType>;
	type_IN?: InputMaybe<Array<InputMaybe<FormType>>>;
	type_NOT?: InputMaybe<FormType>;
	type_NOT_IN?: InputMaybe<Array<InputMaybe<FormType>>>;
	unlimited?: InputMaybe<Scalars["Int"]>;
	unlimited_GT?: InputMaybe<Scalars["Int"]>;
	unlimited_GTE?: InputMaybe<Scalars["Int"]>;
	unlimited_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	unlimited_LT?: InputMaybe<Scalars["Int"]>;
	unlimited_LTE?: InputMaybe<Scalars["Int"]>;
	unlimited_NOT?: InputMaybe<Scalars["Int"]>;
	unlimited_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	uuid?: InputMaybe<Scalars["String"]>;
	uuid_CONTAINS?: InputMaybe<Scalars["String"]>;
	uuid_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	uuid_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	uuid_MATCHES?: InputMaybe<Scalars["String"]>;
	uuid_NOT?: InputMaybe<Scalars["String"]>;
	uuid_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	uuid_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	uuid_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	uuid_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	uuid_STARTS_WITH?: InputMaybe<Scalars["String"]>;
};

export type GqlBaseResponse = {
	message?: Maybe<Scalars["String"]>;
	responseStatus?: Maybe<GqlResponseStatus>;
};

export enum GqlResponseStatus {
	Error = "ERROR",
	Success = "SUCCESS",
}

export type IdAggregateSelection = {
	__typename?: "IDAggregateSelection";
	longest: Scalars["ID"];
	shortest: Scalars["ID"];
};

export type IOrdered = {
	order: Scalars["Int"];
};

export enum IrAdverseEventDoseModifications {
	NoModification = "NO_MODIFICATION",
	PermanentlyDiscontinue = "PERMANENTLY_DISCONTINUE",
	ReduceDose = "REDUCE_DOSE",
	WithholdDose = "WITHHOLD_DOSE",
}

export enum IrAdverseEventGrades {
	I = "I",
	Ii = "II",
	Iii = "III",
	Iv = "IV",
}

export enum IrAdverseEvents {
	AcuteHepatitis = "ACUTE_HEPATITIS",
	AltIncreased = "ALT_INCREASED",
	AstIncreased = "AST_INCREASED",
	Colitis = "COLITIS",
	Diarrhoea = "DIARRHOEA",
	Hypopituitarism = "HYPOPITUITARISM",
	InterstitialLungDisease = "INTERSTITIAL_LUNG_DISEASE",
	Pneumonitis = "PNEUMONITIS",
	Pyrexia = "PYREXIA",
}

export enum IrResultOptions {
	CompleteResponse = "COMPLETE_RESPONSE",
	PartialResponse = "PARTIAL_RESPONSE",
	ProgressiveDisease = "PROGRESSIVE_DISEASE",
	StableDisease = "STABLE_DISEASE",
}

export type ITimeframe = {
	timeframeEnd?: Maybe<Scalars["Int"]>;
	timeframeEndDate?: Maybe<Scalars["Date"]>;
	timeframeRangeType?: Maybe<TimeframeRangeType>;
	timeframeStart?: Maybe<Scalars["Int"]>;
	timeframeStartDate?: Maybe<Scalars["Date"]>;
};

export type ITreatmentState = {
	assessmentDate?: Maybe<Scalars["Date"]>;
	isPatientEnrolledInTreatment: Scalars["Boolean"];
	reasonForDiscontinuation?: Maybe<ReasonsForDiscontinuation>;
	submissionDate?: Maybe<Scalars["DateTime"]>;
};

export type Indication = {
	__typename?: "Indication";
	bagCode?: Maybe<Scalars["String"]>;
	code: Scalars["String"];
	intent?: Maybe<Scalars["String"]>;
	line?: Maybe<Scalars["String"]>;
	mutation?: Maybe<Scalars["String"]>;
	type?: Maybe<Scalars["String"]>;
};

export type IndicationAggregateSelection = {
	__typename?: "IndicationAggregateSelection";
	bagCode: StringAggregateSelection;
	code: StringAggregateSelection;
	count: Scalars["Int"];
	intent: StringAggregateSelection;
	line: StringAggregateSelection;
	mutation: StringAggregateSelection;
	type: StringAggregateSelection;
};

export type IndicationConnectWhere = {
	node: IndicationWhere;
};

export type IndicationCreateInput = {
	bagCode?: InputMaybe<Scalars["String"]>;
	code: Scalars["String"];
	intent?: InputMaybe<Scalars["String"]>;
	line?: InputMaybe<Scalars["String"]>;
	mutation?: InputMaybe<Scalars["String"]>;
	type?: InputMaybe<Scalars["String"]>;
};

export type IndicationOptions = {
	limit?: InputMaybe<Scalars["Int"]>;
	offset?: InputMaybe<Scalars["Int"]>;
	/** Specify one or more IndicationSort objects to sort Indications by. The sorts will be applied in the order in which they are arranged in the array. */
	sort?: InputMaybe<Array<InputMaybe<IndicationSort>>>;
};

/** Fields to sort Indications by. The order in which sorts are applied is not guaranteed when specifying many fields in one IndicationSort object. */
export type IndicationSort = {
	bagCode?: InputMaybe<SortDirection>;
	code?: InputMaybe<SortDirection>;
	intent?: InputMaybe<SortDirection>;
	line?: InputMaybe<SortDirection>;
	mutation?: InputMaybe<SortDirection>;
	type?: InputMaybe<SortDirection>;
};

export type IndicationUpdateInput = {
	bagCode?: InputMaybe<Scalars["String"]>;
	code?: InputMaybe<Scalars["String"]>;
	intent?: InputMaybe<Scalars["String"]>;
	line?: InputMaybe<Scalars["String"]>;
	mutation?: InputMaybe<Scalars["String"]>;
	type?: InputMaybe<Scalars["String"]>;
};

export type IndicationWhere = {
	AND?: InputMaybe<Array<IndicationWhere>>;
	OR?: InputMaybe<Array<IndicationWhere>>;
	bagCode?: InputMaybe<Scalars["String"]>;
	bagCode_CONTAINS?: InputMaybe<Scalars["String"]>;
	bagCode_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	bagCode_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	bagCode_MATCHES?: InputMaybe<Scalars["String"]>;
	bagCode_NOT?: InputMaybe<Scalars["String"]>;
	bagCode_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	bagCode_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	bagCode_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	bagCode_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	bagCode_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	code?: InputMaybe<Scalars["String"]>;
	code_CONTAINS?: InputMaybe<Scalars["String"]>;
	code_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	code_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	code_MATCHES?: InputMaybe<Scalars["String"]>;
	code_NOT?: InputMaybe<Scalars["String"]>;
	code_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	code_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	code_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	code_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	code_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	intent?: InputMaybe<Scalars["String"]>;
	intent_CONTAINS?: InputMaybe<Scalars["String"]>;
	intent_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	intent_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	intent_MATCHES?: InputMaybe<Scalars["String"]>;
	intent_NOT?: InputMaybe<Scalars["String"]>;
	intent_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	intent_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	intent_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	intent_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	intent_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	line?: InputMaybe<Scalars["String"]>;
	line_CONTAINS?: InputMaybe<Scalars["String"]>;
	line_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	line_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	line_MATCHES?: InputMaybe<Scalars["String"]>;
	line_NOT?: InputMaybe<Scalars["String"]>;
	line_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	line_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	line_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	line_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	line_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	mutation?: InputMaybe<Scalars["String"]>;
	mutation_CONTAINS?: InputMaybe<Scalars["String"]>;
	mutation_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	mutation_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	mutation_MATCHES?: InputMaybe<Scalars["String"]>;
	mutation_NOT?: InputMaybe<Scalars["String"]>;
	mutation_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	mutation_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	mutation_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	mutation_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	mutation_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	type?: InputMaybe<Scalars["String"]>;
	type_CONTAINS?: InputMaybe<Scalars["String"]>;
	type_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	type_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	type_MATCHES?: InputMaybe<Scalars["String"]>;
	type_NOT?: InputMaybe<Scalars["String"]>;
	type_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	type_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	type_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	type_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	type_STARTS_WITH?: InputMaybe<Scalars["String"]>;
};

export type InitialResponse = ITreatmentState & {
	__typename?: "InitialResponse";
	adverseEvents: Array<AdverseEvent>;
	adverseEventsConnection: InitialResponseAdverseEventsConnection;
	assessmentDate: Scalars["Date"];
	continuousBenefit: Array<ContinuousBenefit>;
	continuousBenefitConnection: InitialResponseContinuousBenefitConnection;
	coverageRequest?: Maybe<CoverageRequest>;
	coverageRequestConnection: InitialResponseCoverageRequestConnection;
	createdOn: Scalars["DateTime"];
	form?: Maybe<Form>;
	formConnection: InitialResponseFormConnection;
	id: Scalars["ID"];
	isArchived: Scalars["Boolean"];
	isDeleted: Scalars["Boolean"];
	isPatientEnrolledInTreatment: Scalars["Boolean"];
	isResponseReceived: Scalars["Boolean"];
	numberOfPrescriptionsToDate?: Maybe<Scalars["Int"]>;
	reasonForDiscontinuation?: Maybe<ReasonsForDiscontinuation>;
	result?: Maybe<ResponseType>;
	status?: Maybe<FormStatus>;
	submissionDate?: Maybe<Scalars["DateTime"]>;
	tenantId: Scalars["String"];
	therapyStartDate?: Maybe<Scalars["Date"]>;
	treatingPhysician?: Maybe<TreatingPhysician>;
	treatingPhysicianConnection: InitialResponseTreatingPhysicianConnection;
};

export type InitialResponseAdverseEventsArgs = {
	options?: InputMaybe<AdverseEventOptions>;
	where?: InputMaybe<AdverseEventWhere>;
};

export type InitialResponseAdverseEventsConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<InitialResponseAdverseEventsConnectionSort>>;
	where?: InputMaybe<InitialResponseAdverseEventsConnectionWhere>;
};

export type InitialResponseContinuousBenefitArgs = {
	options?: InputMaybe<ContinuousBenefitOptions>;
	where?: InputMaybe<ContinuousBenefitWhere>;
};

export type InitialResponseContinuousBenefitConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<InitialResponseContinuousBenefitConnectionSort>>;
	where?: InputMaybe<InitialResponseContinuousBenefitConnectionWhere>;
};

export type InitialResponseCoverageRequestArgs = {
	options?: InputMaybe<CoverageRequestOptions>;
	where?: InputMaybe<CoverageRequestWhere>;
};

export type InitialResponseCoverageRequestConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<InitialResponseCoverageRequestConnectionSort>>;
	where?: InputMaybe<InitialResponseCoverageRequestConnectionWhere>;
};

export type InitialResponseFormArgs = {
	options?: InputMaybe<FormOptions>;
	where?: InputMaybe<FormWhere>;
};

export type InitialResponseFormConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<InitialResponseFormConnectionSort>>;
	where?: InputMaybe<InitialResponseFormConnectionWhere>;
};

export type InitialResponseTreatingPhysicianArgs = {
	options?: InputMaybe<TreatingPhysicianOptions>;
	where?: InputMaybe<TreatingPhysicianWhere>;
};

export type InitialResponseTreatingPhysicianConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<InitialResponseTreatingPhysicianConnectionSort>>;
	where?: InputMaybe<InitialResponseTreatingPhysicianConnectionWhere>;
};

export type InitialResponseAdverseEventsAggregateInput = {
	AND?: InputMaybe<Array<InitialResponseAdverseEventsAggregateInput>>;
	OR?: InputMaybe<Array<InitialResponseAdverseEventsAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<InitialResponseAdverseEventsNodeAggregationWhereInput>;
};

export type InitialResponseAdverseEventsConnectFieldInput = {
	connect?: InputMaybe<Array<AdverseEventConnectInput>>;
	where?: InputMaybe<AdverseEventConnectWhere>;
};

export type InitialResponseAdverseEventsConnection = {
	__typename?: "InitialResponseAdverseEventsConnection";
	edges: Array<InitialResponseAdverseEventsRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type InitialResponseAdverseEventsConnectionSort = {
	node?: InputMaybe<AdverseEventSort>;
};

export type InitialResponseAdverseEventsConnectionWhere = {
	AND?: InputMaybe<Array<InitialResponseAdverseEventsConnectionWhere>>;
	OR?: InputMaybe<Array<InitialResponseAdverseEventsConnectionWhere>>;
	node?: InputMaybe<AdverseEventWhere>;
	node_NOT?: InputMaybe<AdverseEventWhere>;
};

export type InitialResponseAdverseEventsCreateFieldInput = {
	node: AdverseEventCreateInput;
};

export type InitialResponseAdverseEventsDeleteFieldInput = {
	delete?: InputMaybe<AdverseEventDeleteInput>;
	where?: InputMaybe<InitialResponseAdverseEventsConnectionWhere>;
};

export type InitialResponseAdverseEventsDisconnectFieldInput = {
	disconnect?: InputMaybe<AdverseEventDisconnectInput>;
	where?: InputMaybe<InitialResponseAdverseEventsConnectionWhere>;
};

export type InitialResponseAdverseEventsFieldInput = {
	connect?: InputMaybe<Array<InitialResponseAdverseEventsConnectFieldInput>>;
	create?: InputMaybe<Array<InitialResponseAdverseEventsCreateFieldInput>>;
};

export type InitialResponseAdverseEventsNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<InitialResponseAdverseEventsNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<InitialResponseAdverseEventsNodeAggregationWhereInput>>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	tenantId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	tenantId_EQUAL?: InputMaybe<Scalars["String"]>;
	tenantId_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type InitialResponseAdverseEventsRelationship = {
	__typename?: "InitialResponseAdverseEventsRelationship";
	cursor: Scalars["String"];
	node: AdverseEvent;
};

export type InitialResponseAdverseEventsUpdateConnectionInput = {
	node?: InputMaybe<AdverseEventUpdateInput>;
};

export type InitialResponseAdverseEventsUpdateFieldInput = {
	connect?: InputMaybe<Array<InitialResponseAdverseEventsConnectFieldInput>>;
	create?: InputMaybe<Array<InitialResponseAdverseEventsCreateFieldInput>>;
	delete?: InputMaybe<Array<InitialResponseAdverseEventsDeleteFieldInput>>;
	disconnect?: InputMaybe<Array<InitialResponseAdverseEventsDisconnectFieldInput>>;
	update?: InputMaybe<InitialResponseAdverseEventsUpdateConnectionInput>;
	where?: InputMaybe<InitialResponseAdverseEventsConnectionWhere>;
};

export type InitialResponseAggregateSelection = {
	__typename?: "InitialResponseAggregateSelection";
	count: Scalars["Int"];
	createdOn: DateTimeAggregateSelection;
	id: IdAggregateSelection;
	numberOfPrescriptionsToDate: IntAggregateSelection;
	submissionDate: DateTimeAggregateSelection;
	tenantId: StringAggregateSelection;
};

export type InitialResponseConnectInput = {
	adverseEvents?: InputMaybe<Array<InitialResponseAdverseEventsConnectFieldInput>>;
	continuousBenefit?: InputMaybe<Array<InitialResponseContinuousBenefitConnectFieldInput>>;
	coverageRequest?: InputMaybe<InitialResponseCoverageRequestConnectFieldInput>;
	form?: InputMaybe<InitialResponseFormConnectFieldInput>;
	treatingPhysician?: InputMaybe<InitialResponseTreatingPhysicianConnectFieldInput>;
};

export type InitialResponseConnectWhere = {
	node: InitialResponseWhere;
};

export type InitialResponseContinuousBenefitAggregateInput = {
	AND?: InputMaybe<Array<InitialResponseContinuousBenefitAggregateInput>>;
	OR?: InputMaybe<Array<InitialResponseContinuousBenefitAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<InitialResponseContinuousBenefitNodeAggregationWhereInput>;
};

export type InitialResponseContinuousBenefitConnectFieldInput = {
	connect?: InputMaybe<Array<ContinuousBenefitConnectInput>>;
	where?: InputMaybe<ContinuousBenefitConnectWhere>;
};

export type InitialResponseContinuousBenefitConnection = {
	__typename?: "InitialResponseContinuousBenefitConnection";
	edges: Array<InitialResponseContinuousBenefitRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type InitialResponseContinuousBenefitConnectionSort = {
	node?: InputMaybe<ContinuousBenefitSort>;
};

export type InitialResponseContinuousBenefitConnectionWhere = {
	AND?: InputMaybe<Array<InitialResponseContinuousBenefitConnectionWhere>>;
	OR?: InputMaybe<Array<InitialResponseContinuousBenefitConnectionWhere>>;
	node?: InputMaybe<ContinuousBenefitWhere>;
	node_NOT?: InputMaybe<ContinuousBenefitWhere>;
};

export type InitialResponseContinuousBenefitCreateFieldInput = {
	node: ContinuousBenefitCreateInput;
};

export type InitialResponseContinuousBenefitDeleteFieldInput = {
	delete?: InputMaybe<ContinuousBenefitDeleteInput>;
	where?: InputMaybe<InitialResponseContinuousBenefitConnectionWhere>;
};

export type InitialResponseContinuousBenefitDisconnectFieldInput = {
	disconnect?: InputMaybe<ContinuousBenefitDisconnectInput>;
	where?: InputMaybe<InitialResponseContinuousBenefitConnectionWhere>;
};

export type InitialResponseContinuousBenefitFieldInput = {
	connect?: InputMaybe<Array<InitialResponseContinuousBenefitConnectFieldInput>>;
	create?: InputMaybe<Array<InitialResponseContinuousBenefitCreateFieldInput>>;
};

export type InitialResponseContinuousBenefitNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<InitialResponseContinuousBenefitNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<InitialResponseContinuousBenefitNodeAggregationWhereInput>>;
	createdOn_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	submissionDate_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_GT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_GTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_LT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_LTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	tenantId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	tenantId_EQUAL?: InputMaybe<Scalars["String"]>;
	tenantId_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type InitialResponseContinuousBenefitRelationship = {
	__typename?: "InitialResponseContinuousBenefitRelationship";
	cursor: Scalars["String"];
	node: ContinuousBenefit;
};

export type InitialResponseContinuousBenefitUpdateConnectionInput = {
	node?: InputMaybe<ContinuousBenefitUpdateInput>;
};

export type InitialResponseContinuousBenefitUpdateFieldInput = {
	connect?: InputMaybe<Array<InitialResponseContinuousBenefitConnectFieldInput>>;
	create?: InputMaybe<Array<InitialResponseContinuousBenefitCreateFieldInput>>;
	delete?: InputMaybe<Array<InitialResponseContinuousBenefitDeleteFieldInput>>;
	disconnect?: InputMaybe<Array<InitialResponseContinuousBenefitDisconnectFieldInput>>;
	update?: InputMaybe<InitialResponseContinuousBenefitUpdateConnectionInput>;
	where?: InputMaybe<InitialResponseContinuousBenefitConnectionWhere>;
};

export type InitialResponseCoverageRequestAggregateInput = {
	AND?: InputMaybe<Array<InitialResponseCoverageRequestAggregateInput>>;
	OR?: InputMaybe<Array<InitialResponseCoverageRequestAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<InitialResponseCoverageRequestNodeAggregationWhereInput>;
};

export type InitialResponseCoverageRequestConnectFieldInput = {
	connect?: InputMaybe<CoverageRequestConnectInput>;
	where?: InputMaybe<CoverageRequestConnectWhere>;
};

export type InitialResponseCoverageRequestConnection = {
	__typename?: "InitialResponseCoverageRequestConnection";
	edges: Array<InitialResponseCoverageRequestRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type InitialResponseCoverageRequestConnectionSort = {
	node?: InputMaybe<CoverageRequestSort>;
};

export type InitialResponseCoverageRequestConnectionWhere = {
	AND?: InputMaybe<Array<InitialResponseCoverageRequestConnectionWhere>>;
	OR?: InputMaybe<Array<InitialResponseCoverageRequestConnectionWhere>>;
	node?: InputMaybe<CoverageRequestWhere>;
	node_NOT?: InputMaybe<CoverageRequestWhere>;
};

export type InitialResponseCoverageRequestCreateFieldInput = {
	node: CoverageRequestCreateInput;
};

export type InitialResponseCoverageRequestDeleteFieldInput = {
	delete?: InputMaybe<CoverageRequestDeleteInput>;
	where?: InputMaybe<InitialResponseCoverageRequestConnectionWhere>;
};

export type InitialResponseCoverageRequestDisconnectFieldInput = {
	disconnect?: InputMaybe<CoverageRequestDisconnectInput>;
	where?: InputMaybe<InitialResponseCoverageRequestConnectionWhere>;
};

export type InitialResponseCoverageRequestFieldInput = {
	connect?: InputMaybe<InitialResponseCoverageRequestConnectFieldInput>;
	create?: InputMaybe<InitialResponseCoverageRequestCreateFieldInput>;
};

export type InitialResponseCoverageRequestNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<InitialResponseCoverageRequestNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<InitialResponseCoverageRequestNodeAggregationWhereInput>>;
	createdOn_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	duration_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	duration_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	duration_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	duration_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	duration_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	duration_EQUAL?: InputMaybe<Scalars["Int"]>;
	duration_GT?: InputMaybe<Scalars["Int"]>;
	duration_GTE?: InputMaybe<Scalars["Int"]>;
	duration_LT?: InputMaybe<Scalars["Int"]>;
	duration_LTE?: InputMaybe<Scalars["Int"]>;
	duration_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	duration_MAX_GT?: InputMaybe<Scalars["Int"]>;
	duration_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	duration_MAX_LT?: InputMaybe<Scalars["Int"]>;
	duration_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	duration_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	duration_MIN_GT?: InputMaybe<Scalars["Int"]>;
	duration_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	duration_MIN_LT?: InputMaybe<Scalars["Int"]>;
	duration_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	lastUpdatedOn_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_GT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_LT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_GT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_GTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_LT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_LTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	tenantId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	tenantId_EQUAL?: InputMaybe<Scalars["String"]>;
	tenantId_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type InitialResponseCoverageRequestRelationship = {
	__typename?: "InitialResponseCoverageRequestRelationship";
	cursor: Scalars["String"];
	node: CoverageRequest;
};

export type InitialResponseCoverageRequestUpdateConnectionInput = {
	node?: InputMaybe<CoverageRequestUpdateInput>;
};

export type InitialResponseCoverageRequestUpdateFieldInput = {
	connect?: InputMaybe<InitialResponseCoverageRequestConnectFieldInput>;
	create?: InputMaybe<InitialResponseCoverageRequestCreateFieldInput>;
	delete?: InputMaybe<InitialResponseCoverageRequestDeleteFieldInput>;
	disconnect?: InputMaybe<InitialResponseCoverageRequestDisconnectFieldInput>;
	update?: InputMaybe<InitialResponseCoverageRequestUpdateConnectionInput>;
	where?: InputMaybe<InitialResponseCoverageRequestConnectionWhere>;
};

export type InitialResponseCreateInput = {
	adverseEvents?: InputMaybe<InitialResponseAdverseEventsFieldInput>;
	assessmentDate: Scalars["Date"];
	continuousBenefit?: InputMaybe<InitialResponseContinuousBenefitFieldInput>;
	coverageRequest?: InputMaybe<InitialResponseCoverageRequestFieldInput>;
	createdOn: Scalars["DateTime"];
	form?: InputMaybe<InitialResponseFormFieldInput>;
	id: Scalars["ID"];
	isArchived: Scalars["Boolean"];
	isDeleted: Scalars["Boolean"];
	isPatientEnrolledInTreatment: Scalars["Boolean"];
	isResponseReceived: Scalars["Boolean"];
	numberOfPrescriptionsToDate?: InputMaybe<Scalars["Int"]>;
	reasonForDiscontinuation?: InputMaybe<ReasonsForDiscontinuation>;
	result?: InputMaybe<ResponseType>;
	status?: InputMaybe<FormStatus>;
	submissionDate?: InputMaybe<Scalars["DateTime"]>;
	tenantId: Scalars["String"];
	therapyStartDate?: InputMaybe<Scalars["Date"]>;
	treatingPhysician?: InputMaybe<InitialResponseTreatingPhysicianFieldInput>;
};

export type InitialResponseDeleteInput = {
	adverseEvents?: InputMaybe<Array<InitialResponseAdverseEventsDeleteFieldInput>>;
	continuousBenefit?: InputMaybe<Array<InitialResponseContinuousBenefitDeleteFieldInput>>;
	coverageRequest?: InputMaybe<InitialResponseCoverageRequestDeleteFieldInput>;
	form?: InputMaybe<InitialResponseFormDeleteFieldInput>;
	treatingPhysician?: InputMaybe<InitialResponseTreatingPhysicianDeleteFieldInput>;
};

export type InitialResponseDisconnectInput = {
	adverseEvents?: InputMaybe<Array<InitialResponseAdverseEventsDisconnectFieldInput>>;
	continuousBenefit?: InputMaybe<Array<InitialResponseContinuousBenefitDisconnectFieldInput>>;
	coverageRequest?: InputMaybe<InitialResponseCoverageRequestDisconnectFieldInput>;
	form?: InputMaybe<InitialResponseFormDisconnectFieldInput>;
	treatingPhysician?: InputMaybe<InitialResponseTreatingPhysicianDisconnectFieldInput>;
};

export type InitialResponseFormAggregateInput = {
	AND?: InputMaybe<Array<InitialResponseFormAggregateInput>>;
	OR?: InputMaybe<Array<InitialResponseFormAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<InitialResponseFormNodeAggregationWhereInput>;
};

export type InitialResponseFormConnectFieldInput = {
	connect?: InputMaybe<FormConnectInput>;
	where?: InputMaybe<FormConnectWhere>;
};

export type InitialResponseFormConnection = {
	__typename?: "InitialResponseFormConnection";
	edges: Array<InitialResponseFormRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type InitialResponseFormConnectionSort = {
	node?: InputMaybe<FormSort>;
};

export type InitialResponseFormConnectionWhere = {
	AND?: InputMaybe<Array<InitialResponseFormConnectionWhere>>;
	OR?: InputMaybe<Array<InitialResponseFormConnectionWhere>>;
	node?: InputMaybe<FormWhere>;
	node_NOT?: InputMaybe<FormWhere>;
};

export type InitialResponseFormCreateFieldInput = {
	node: FormCreateInput;
};

export type InitialResponseFormDeleteFieldInput = {
	delete?: InputMaybe<FormDeleteInput>;
	where?: InputMaybe<InitialResponseFormConnectionWhere>;
};

export type InitialResponseFormDisconnectFieldInput = {
	disconnect?: InputMaybe<FormDisconnectInput>;
	where?: InputMaybe<InitialResponseFormConnectionWhere>;
};

export type InitialResponseFormFieldInput = {
	connect?: InputMaybe<InitialResponseFormConnectFieldInput>;
	create?: InputMaybe<InitialResponseFormCreateFieldInput>;
};

export type InitialResponseFormNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<InitialResponseFormNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<InitialResponseFormNodeAggregationWhereInput>>;
	createdByName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	createdByName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	createdByName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	createdByName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	createdByName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	createdByName_EQUAL?: InputMaybe<Scalars["String"]>;
	createdByName_GT?: InputMaybe<Scalars["Int"]>;
	createdByName_GTE?: InputMaybe<Scalars["Int"]>;
	createdByName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	createdByName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	createdByName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	createdByName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	createdByName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	createdByName_LT?: InputMaybe<Scalars["Int"]>;
	createdByName_LTE?: InputMaybe<Scalars["Int"]>;
	createdByName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	createdByName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	createdByName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	createdByName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	createdByName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	createdBy_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	createdBy_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	createdBy_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	createdBy_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	createdBy_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	createdBy_EQUAL?: InputMaybe<Scalars["String"]>;
	createdBy_GT?: InputMaybe<Scalars["Int"]>;
	createdBy_GTE?: InputMaybe<Scalars["Int"]>;
	createdBy_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	createdBy_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	createdBy_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	createdBy_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	createdBy_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	createdBy_LT?: InputMaybe<Scalars["Int"]>;
	createdBy_LTE?: InputMaybe<Scalars["Int"]>;
	createdBy_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	createdBy_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	createdBy_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	createdBy_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	createdBy_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	createdOn_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	insuranceId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	insuranceId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	insuranceId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	insuranceId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	insuranceId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	insuranceId_EQUAL?: InputMaybe<Scalars["String"]>;
	insuranceId_GT?: InputMaybe<Scalars["Int"]>;
	insuranceId_GTE?: InputMaybe<Scalars["Int"]>;
	insuranceId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	insuranceId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	insuranceId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	insuranceId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	insuranceId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	insuranceId_LT?: InputMaybe<Scalars["Int"]>;
	insuranceId_LTE?: InputMaybe<Scalars["Int"]>;
	insuranceId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	insuranceId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	insuranceId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	insuranceId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	insuranceId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	lastUpdatedOn_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_GT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_LT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	preparationBrandName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	preparationBrandName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	preparationBrandName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	preparationBrandName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	preparationBrandName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	preparationBrandName_EQUAL?: InputMaybe<Scalars["String"]>;
	preparationBrandName_GT?: InputMaybe<Scalars["Int"]>;
	preparationBrandName_GTE?: InputMaybe<Scalars["Int"]>;
	preparationBrandName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationBrandName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationBrandName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationBrandName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationBrandName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationBrandName_LT?: InputMaybe<Scalars["Int"]>;
	preparationBrandName_LTE?: InputMaybe<Scalars["Int"]>;
	preparationBrandName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationBrandName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationBrandName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationBrandName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationBrandName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	preparationGenericName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	preparationGenericName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	preparationGenericName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	preparationGenericName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	preparationGenericName_EQUAL?: InputMaybe<Scalars["String"]>;
	preparationGenericName_GT?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_GTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_LT?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_LTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	tenantId_EQUAL?: InputMaybe<Scalars["String"]>;
	tenantId_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	unlimited_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	unlimited_EQUAL?: InputMaybe<Scalars["Int"]>;
	unlimited_GT?: InputMaybe<Scalars["Int"]>;
	unlimited_GTE?: InputMaybe<Scalars["Int"]>;
	unlimited_LT?: InputMaybe<Scalars["Int"]>;
	unlimited_LTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_GT?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_LT?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_GT?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_LT?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	uuid_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	uuid_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	uuid_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	uuid_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	uuid_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	uuid_EQUAL?: InputMaybe<Scalars["String"]>;
	uuid_GT?: InputMaybe<Scalars["Int"]>;
	uuid_GTE?: InputMaybe<Scalars["Int"]>;
	uuid_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	uuid_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	uuid_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	uuid_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	uuid_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	uuid_LT?: InputMaybe<Scalars["Int"]>;
	uuid_LTE?: InputMaybe<Scalars["Int"]>;
	uuid_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	uuid_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	uuid_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	uuid_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	uuid_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type InitialResponseFormRelationship = {
	__typename?: "InitialResponseFormRelationship";
	cursor: Scalars["String"];
	node: Form;
};

export type InitialResponseFormUpdateConnectionInput = {
	node?: InputMaybe<FormUpdateInput>;
};

export type InitialResponseFormUpdateFieldInput = {
	connect?: InputMaybe<InitialResponseFormConnectFieldInput>;
	create?: InputMaybe<InitialResponseFormCreateFieldInput>;
	delete?: InputMaybe<InitialResponseFormDeleteFieldInput>;
	disconnect?: InputMaybe<InitialResponseFormDisconnectFieldInput>;
	update?: InputMaybe<InitialResponseFormUpdateConnectionInput>;
	where?: InputMaybe<InitialResponseFormConnectionWhere>;
};

export type InitialResponseInput = {
	adverseEvents?: InputMaybe<Array<InputMaybe<AdverseEventInput>>>;
	assessmentDate: Scalars["Date"];
	caseId?: InputMaybe<Scalars["String"]>;
	coverageRequestId: Scalars["ID"];
	formId?: InputMaybe<Scalars["ID"]>;
	id: Scalars["ID"];
	isPatientEnrolledInTreatment: Scalars["Boolean"];
	isResponseReceived: Scalars["Boolean"];
	numberOfPrescriptionsToDate?: InputMaybe<Scalars["Int"]>;
	occurrence?: InputMaybe<OccurrenceEnum>;
	reasonForDiscontinuation?: InputMaybe<ReasonsForDiscontinuation>;
	result?: InputMaybe<IrResultOptions>;
	status?: InputMaybe<FormStatus>;
	therapyStartDate?: InputMaybe<Scalars["Date"]>;
	treatingPhysician?: InputMaybe<TreatingPhysicianInput>;
};

export type InitialResponseOptions = {
	limit?: InputMaybe<Scalars["Int"]>;
	offset?: InputMaybe<Scalars["Int"]>;
	/** Specify one or more InitialResponseSort objects to sort InitialResponses by. The sorts will be applied in the order in which they are arranged in the array. */
	sort?: InputMaybe<Array<InputMaybe<InitialResponseSort>>>;
};

export type InitialResponseReviewReport = {
	__typename?: "InitialResponseReviewReport";
	count?: Maybe<Scalars["Int"]>;
	order?: Maybe<Scalars["Int"]>;
	rate?: Maybe<Scalars["Float"]>;
	result?: Maybe<ResponseType>;
};

export type InitialResponseReviewReportAggregateSelection = {
	__typename?: "InitialResponseReviewReportAggregateSelection";
	count: IntAggregateSelection;
	order: IntAggregateSelection;
	rate: FloatAggregateSelection;
};

export type InitialResponseReviewReportCreateInput = {
	count?: InputMaybe<Scalars["Int"]>;
	order?: InputMaybe<Scalars["Int"]>;
	rate?: InputMaybe<Scalars["Float"]>;
	result?: InputMaybe<ResponseType>;
};

export type InitialResponseReviewReportOptions = {
	limit?: InputMaybe<Scalars["Int"]>;
	offset?: InputMaybe<Scalars["Int"]>;
	/** Specify one or more InitialResponseReviewReportSort objects to sort InitialResponseReviewReports by. The sorts will be applied in the order in which they are arranged in the array. */
	sort?: InputMaybe<Array<InputMaybe<InitialResponseReviewReportSort>>>;
};

/** Fields to sort InitialResponseReviewReports by. The order in which sorts are applied is not guaranteed when specifying many fields in one InitialResponseReviewReportSort object. */
export type InitialResponseReviewReportSort = {
	count?: InputMaybe<SortDirection>;
	order?: InputMaybe<SortDirection>;
	rate?: InputMaybe<SortDirection>;
	result?: InputMaybe<SortDirection>;
};

export type InitialResponseReviewReportUpdateInput = {
	count?: InputMaybe<Scalars["Int"]>;
	order?: InputMaybe<Scalars["Int"]>;
	rate?: InputMaybe<Scalars["Float"]>;
	result?: InputMaybe<ResponseType>;
};

export type InitialResponseReviewReportWhere = {
	AND?: InputMaybe<Array<InitialResponseReviewReportWhere>>;
	OR?: InputMaybe<Array<InitialResponseReviewReportWhere>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	count_NOT?: InputMaybe<Scalars["Int"]>;
	count_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	order?: InputMaybe<Scalars["Int"]>;
	order_GT?: InputMaybe<Scalars["Int"]>;
	order_GTE?: InputMaybe<Scalars["Int"]>;
	order_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	order_LT?: InputMaybe<Scalars["Int"]>;
	order_LTE?: InputMaybe<Scalars["Int"]>;
	order_NOT?: InputMaybe<Scalars["Int"]>;
	order_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	rate?: InputMaybe<Scalars["Float"]>;
	rate_GT?: InputMaybe<Scalars["Float"]>;
	rate_GTE?: InputMaybe<Scalars["Float"]>;
	rate_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	rate_LT?: InputMaybe<Scalars["Float"]>;
	rate_LTE?: InputMaybe<Scalars["Float"]>;
	rate_NOT?: InputMaybe<Scalars["Float"]>;
	rate_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	result?: InputMaybe<ResponseType>;
	result_IN?: InputMaybe<Array<InputMaybe<ResponseType>>>;
	result_NOT?: InputMaybe<ResponseType>;
	result_NOT_IN?: InputMaybe<Array<InputMaybe<ResponseType>>>;
};

/** Fields to sort InitialResponses by. The order in which sorts are applied is not guaranteed when specifying many fields in one InitialResponseSort object. */
export type InitialResponseSort = {
	assessmentDate?: InputMaybe<SortDirection>;
	createdOn?: InputMaybe<SortDirection>;
	id?: InputMaybe<SortDirection>;
	isArchived?: InputMaybe<SortDirection>;
	isDeleted?: InputMaybe<SortDirection>;
	isPatientEnrolledInTreatment?: InputMaybe<SortDirection>;
	isResponseReceived?: InputMaybe<SortDirection>;
	numberOfPrescriptionsToDate?: InputMaybe<SortDirection>;
	reasonForDiscontinuation?: InputMaybe<SortDirection>;
	result?: InputMaybe<SortDirection>;
	status?: InputMaybe<SortDirection>;
	submissionDate?: InputMaybe<SortDirection>;
	tenantId?: InputMaybe<SortDirection>;
	therapyStartDate?: InputMaybe<SortDirection>;
};

export type InitialResponseTreatingPhysicianAggregateInput = {
	AND?: InputMaybe<Array<InitialResponseTreatingPhysicianAggregateInput>>;
	OR?: InputMaybe<Array<InitialResponseTreatingPhysicianAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<InitialResponseTreatingPhysicianNodeAggregationWhereInput>;
};

export type InitialResponseTreatingPhysicianConnectFieldInput = {
	where?: InputMaybe<TreatingPhysicianConnectWhere>;
};

export type InitialResponseTreatingPhysicianConnection = {
	__typename?: "InitialResponseTreatingPhysicianConnection";
	edges: Array<InitialResponseTreatingPhysicianRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type InitialResponseTreatingPhysicianConnectionSort = {
	node?: InputMaybe<TreatingPhysicianSort>;
};

export type InitialResponseTreatingPhysicianConnectionWhere = {
	AND?: InputMaybe<Array<InitialResponseTreatingPhysicianConnectionWhere>>;
	OR?: InputMaybe<Array<InitialResponseTreatingPhysicianConnectionWhere>>;
	node?: InputMaybe<TreatingPhysicianWhere>;
	node_NOT?: InputMaybe<TreatingPhysicianWhere>;
};

export type InitialResponseTreatingPhysicianCreateFieldInput = {
	node: TreatingPhysicianCreateInput;
};

export type InitialResponseTreatingPhysicianDeleteFieldInput = {
	where?: InputMaybe<InitialResponseTreatingPhysicianConnectionWhere>;
};

export type InitialResponseTreatingPhysicianDisconnectFieldInput = {
	where?: InputMaybe<InitialResponseTreatingPhysicianConnectionWhere>;
};

export type InitialResponseTreatingPhysicianFieldInput = {
	connect?: InputMaybe<InitialResponseTreatingPhysicianConnectFieldInput>;
	create?: InputMaybe<InitialResponseTreatingPhysicianCreateFieldInput>;
};

export type InitialResponseTreatingPhysicianNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<InitialResponseTreatingPhysicianNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<InitialResponseTreatingPhysicianNodeAggregationWhereInput>>;
	department_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	department_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	department_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	department_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	department_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	department_EQUAL?: InputMaybe<Scalars["String"]>;
	department_GT?: InputMaybe<Scalars["Int"]>;
	department_GTE?: InputMaybe<Scalars["Int"]>;
	department_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	department_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	department_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	department_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	department_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	department_LT?: InputMaybe<Scalars["Int"]>;
	department_LTE?: InputMaybe<Scalars["Int"]>;
	department_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	department_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	department_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	department_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	department_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	email_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	email_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	email_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	email_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	email_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	email_EQUAL?: InputMaybe<Scalars["String"]>;
	email_GT?: InputMaybe<Scalars["Int"]>;
	email_GTE?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	email_LT?: InputMaybe<Scalars["Int"]>;
	email_LTE?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	firstName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	firstName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	firstName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	firstName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	firstName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	firstName_EQUAL?: InputMaybe<Scalars["String"]>;
	firstName_GT?: InputMaybe<Scalars["Int"]>;
	firstName_GTE?: InputMaybe<Scalars["Int"]>;
	firstName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	firstName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	firstName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	firstName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	firstName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	firstName_LT?: InputMaybe<Scalars["Int"]>;
	firstName_LTE?: InputMaybe<Scalars["Int"]>;
	firstName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	firstName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	firstName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	firstName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	firstName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	hospitalName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	hospitalName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	hospitalName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	hospitalName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	hospitalName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	hospitalName_EQUAL?: InputMaybe<Scalars["String"]>;
	hospitalName_GT?: InputMaybe<Scalars["Int"]>;
	hospitalName_GTE?: InputMaybe<Scalars["Int"]>;
	hospitalName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	hospitalName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	hospitalName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	hospitalName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	hospitalName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	hospitalName_LT?: InputMaybe<Scalars["Int"]>;
	hospitalName_LTE?: InputMaybe<Scalars["Int"]>;
	hospitalName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	hospitalName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	hospitalName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	hospitalName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	hospitalName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	lastName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	lastName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	lastName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	lastName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	lastName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	lastName_EQUAL?: InputMaybe<Scalars["String"]>;
	lastName_GT?: InputMaybe<Scalars["Int"]>;
	lastName_GTE?: InputMaybe<Scalars["Int"]>;
	lastName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	lastName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	lastName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	lastName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	lastName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	lastName_LT?: InputMaybe<Scalars["Int"]>;
	lastName_LTE?: InputMaybe<Scalars["Int"]>;
	lastName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	lastName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	lastName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	lastName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	lastName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	nr_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	nr_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	nr_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	nr_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	nr_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	nr_EQUAL?: InputMaybe<Scalars["String"]>;
	nr_GT?: InputMaybe<Scalars["Int"]>;
	nr_GTE?: InputMaybe<Scalars["Int"]>;
	nr_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	nr_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	nr_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	nr_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	nr_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	nr_LT?: InputMaybe<Scalars["Int"]>;
	nr_LTE?: InputMaybe<Scalars["Int"]>;
	nr_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	nr_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	nr_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	nr_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	nr_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	phoneNo_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	phoneNo_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	phoneNo_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	phoneNo_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	phoneNo_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	phoneNo_EQUAL?: InputMaybe<Scalars["String"]>;
	phoneNo_GT?: InputMaybe<Scalars["Int"]>;
	phoneNo_GTE?: InputMaybe<Scalars["Int"]>;
	phoneNo_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	phoneNo_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	phoneNo_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	phoneNo_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	phoneNo_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	phoneNo_LT?: InputMaybe<Scalars["Int"]>;
	phoneNo_LTE?: InputMaybe<Scalars["Int"]>;
	phoneNo_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	phoneNo_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	phoneNo_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	phoneNo_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	phoneNo_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	place_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	place_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	place_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	place_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	place_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	place_EQUAL?: InputMaybe<Scalars["String"]>;
	place_GT?: InputMaybe<Scalars["Int"]>;
	place_GTE?: InputMaybe<Scalars["Int"]>;
	place_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	place_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	place_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	place_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	place_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	place_LT?: InputMaybe<Scalars["Int"]>;
	place_LTE?: InputMaybe<Scalars["Int"]>;
	place_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	place_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	place_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	place_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	place_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	postcode_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	postcode_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	postcode_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	postcode_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	postcode_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	postcode_EQUAL?: InputMaybe<Scalars["String"]>;
	postcode_GT?: InputMaybe<Scalars["Int"]>;
	postcode_GTE?: InputMaybe<Scalars["Int"]>;
	postcode_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	postcode_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	postcode_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	postcode_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	postcode_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	postcode_LT?: InputMaybe<Scalars["Int"]>;
	postcode_LTE?: InputMaybe<Scalars["Int"]>;
	postcode_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	postcode_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	postcode_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	postcode_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	postcode_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	street_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	street_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	street_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	street_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	street_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	street_EQUAL?: InputMaybe<Scalars["String"]>;
	street_GT?: InputMaybe<Scalars["Int"]>;
	street_GTE?: InputMaybe<Scalars["Int"]>;
	street_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	street_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	street_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	street_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	street_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	street_LT?: InputMaybe<Scalars["Int"]>;
	street_LTE?: InputMaybe<Scalars["Int"]>;
	street_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	street_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	street_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	street_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	street_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type InitialResponseTreatingPhysicianRelationship = {
	__typename?: "InitialResponseTreatingPhysicianRelationship";
	cursor: Scalars["String"];
	node: TreatingPhysician;
};

export type InitialResponseTreatingPhysicianUpdateConnectionInput = {
	node?: InputMaybe<TreatingPhysicianUpdateInput>;
};

export type InitialResponseTreatingPhysicianUpdateFieldInput = {
	connect?: InputMaybe<InitialResponseTreatingPhysicianConnectFieldInput>;
	create?: InputMaybe<InitialResponseTreatingPhysicianCreateFieldInput>;
	delete?: InputMaybe<InitialResponseTreatingPhysicianDeleteFieldInput>;
	disconnect?: InputMaybe<InitialResponseTreatingPhysicianDisconnectFieldInput>;
	update?: InputMaybe<InitialResponseTreatingPhysicianUpdateConnectionInput>;
	where?: InputMaybe<InitialResponseTreatingPhysicianConnectionWhere>;
};

export type InitialResponseUpdateInput = {
	adverseEvents?: InputMaybe<Array<InitialResponseAdverseEventsUpdateFieldInput>>;
	assessmentDate?: InputMaybe<Scalars["Date"]>;
	continuousBenefit?: InputMaybe<Array<InitialResponseContinuousBenefitUpdateFieldInput>>;
	coverageRequest?: InputMaybe<InitialResponseCoverageRequestUpdateFieldInput>;
	createdOn?: InputMaybe<Scalars["DateTime"]>;
	form?: InputMaybe<InitialResponseFormUpdateFieldInput>;
	id?: InputMaybe<Scalars["ID"]>;
	isArchived?: InputMaybe<Scalars["Boolean"]>;
	isDeleted?: InputMaybe<Scalars["Boolean"]>;
	isPatientEnrolledInTreatment?: InputMaybe<Scalars["Boolean"]>;
	isResponseReceived?: InputMaybe<Scalars["Boolean"]>;
	numberOfPrescriptionsToDate?: InputMaybe<Scalars["Int"]>;
	reasonForDiscontinuation?: InputMaybe<ReasonsForDiscontinuation>;
	result?: InputMaybe<ResponseType>;
	status?: InputMaybe<FormStatus>;
	submissionDate?: InputMaybe<Scalars["DateTime"]>;
	tenantId?: InputMaybe<Scalars["String"]>;
	therapyStartDate?: InputMaybe<Scalars["Date"]>;
	treatingPhysician?: InputMaybe<InitialResponseTreatingPhysicianUpdateFieldInput>;
};

export type InitialResponseWhere = {
	AND?: InputMaybe<Array<InitialResponseWhere>>;
	OR?: InputMaybe<Array<InitialResponseWhere>>;
	adverseEvents?: InputMaybe<AdverseEventWhere>;
	adverseEventsAggregate?: InputMaybe<InitialResponseAdverseEventsAggregateInput>;
	adverseEventsConnection?: InputMaybe<InitialResponseAdverseEventsConnectionWhere>;
	adverseEventsConnection_NOT?: InputMaybe<InitialResponseAdverseEventsConnectionWhere>;
	adverseEvents_NOT?: InputMaybe<AdverseEventWhere>;
	assessmentDate?: InputMaybe<Scalars["Date"]>;
	assessmentDate_GT?: InputMaybe<Scalars["Date"]>;
	assessmentDate_GTE?: InputMaybe<Scalars["Date"]>;
	assessmentDate_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
	assessmentDate_LT?: InputMaybe<Scalars["Date"]>;
	assessmentDate_LTE?: InputMaybe<Scalars["Date"]>;
	assessmentDate_NOT?: InputMaybe<Scalars["Date"]>;
	assessmentDate_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
	continuousBenefit?: InputMaybe<ContinuousBenefitWhere>;
	continuousBenefitAggregate?: InputMaybe<InitialResponseContinuousBenefitAggregateInput>;
	continuousBenefitConnection?: InputMaybe<InitialResponseContinuousBenefitConnectionWhere>;
	continuousBenefitConnection_NOT?: InputMaybe<InitialResponseContinuousBenefitConnectionWhere>;
	continuousBenefit_NOT?: InputMaybe<ContinuousBenefitWhere>;
	coverageRequest?: InputMaybe<CoverageRequestWhere>;
	coverageRequestAggregate?: InputMaybe<InitialResponseCoverageRequestAggregateInput>;
	coverageRequestConnection?: InputMaybe<InitialResponseCoverageRequestConnectionWhere>;
	coverageRequestConnection_NOT?: InputMaybe<InitialResponseCoverageRequestConnectionWhere>;
	coverageRequest_NOT?: InputMaybe<CoverageRequestWhere>;
	createdOn?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_IN?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]>>>;
	createdOn_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_NOT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]>>>;
	form?: InputMaybe<FormWhere>;
	formAggregate?: InputMaybe<InitialResponseFormAggregateInput>;
	formConnection?: InputMaybe<InitialResponseFormConnectionWhere>;
	formConnection_NOT?: InputMaybe<InitialResponseFormConnectionWhere>;
	form_NOT?: InputMaybe<FormWhere>;
	id?: InputMaybe<Scalars["ID"]>;
	id_CONTAINS?: InputMaybe<Scalars["ID"]>;
	id_ENDS_WITH?: InputMaybe<Scalars["ID"]>;
	id_IN?: InputMaybe<Array<InputMaybe<Scalars["ID"]>>>;
	id_MATCHES?: InputMaybe<Scalars["String"]>;
	id_NOT?: InputMaybe<Scalars["ID"]>;
	id_NOT_CONTAINS?: InputMaybe<Scalars["ID"]>;
	id_NOT_ENDS_WITH?: InputMaybe<Scalars["ID"]>;
	id_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["ID"]>>>;
	id_NOT_STARTS_WITH?: InputMaybe<Scalars["ID"]>;
	id_STARTS_WITH?: InputMaybe<Scalars["ID"]>;
	isArchived?: InputMaybe<Scalars["Boolean"]>;
	isArchived_NOT?: InputMaybe<Scalars["Boolean"]>;
	isDeleted?: InputMaybe<Scalars["Boolean"]>;
	isDeleted_NOT?: InputMaybe<Scalars["Boolean"]>;
	isPatientEnrolledInTreatment?: InputMaybe<Scalars["Boolean"]>;
	isPatientEnrolledInTreatment_NOT?: InputMaybe<Scalars["Boolean"]>;
	isResponseReceived?: InputMaybe<Scalars["Boolean"]>;
	isResponseReceived_NOT?: InputMaybe<Scalars["Boolean"]>;
	numberOfPrescriptionsToDate?: InputMaybe<Scalars["Int"]>;
	numberOfPrescriptionsToDate_GT?: InputMaybe<Scalars["Int"]>;
	numberOfPrescriptionsToDate_GTE?: InputMaybe<Scalars["Int"]>;
	numberOfPrescriptionsToDate_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	numberOfPrescriptionsToDate_LT?: InputMaybe<Scalars["Int"]>;
	numberOfPrescriptionsToDate_LTE?: InputMaybe<Scalars["Int"]>;
	numberOfPrescriptionsToDate_NOT?: InputMaybe<Scalars["Int"]>;
	numberOfPrescriptionsToDate_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	reasonForDiscontinuation?: InputMaybe<ReasonsForDiscontinuation>;
	reasonForDiscontinuation_IN?: InputMaybe<Array<InputMaybe<ReasonsForDiscontinuation>>>;
	reasonForDiscontinuation_NOT?: InputMaybe<ReasonsForDiscontinuation>;
	reasonForDiscontinuation_NOT_IN?: InputMaybe<Array<InputMaybe<ReasonsForDiscontinuation>>>;
	result?: InputMaybe<ResponseType>;
	result_IN?: InputMaybe<Array<InputMaybe<ResponseType>>>;
	result_NOT?: InputMaybe<ResponseType>;
	result_NOT_IN?: InputMaybe<Array<InputMaybe<ResponseType>>>;
	status?: InputMaybe<FormStatus>;
	status_IN?: InputMaybe<Array<InputMaybe<FormStatus>>>;
	status_NOT?: InputMaybe<FormStatus>;
	status_NOT_IN?: InputMaybe<Array<InputMaybe<FormStatus>>>;
	submissionDate?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_GT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_GTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_IN?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]>>>;
	submissionDate_LT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_LTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_NOT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]>>>;
	tenantId?: InputMaybe<Scalars["String"]>;
	tenantId_CONTAINS?: InputMaybe<Scalars["String"]>;
	tenantId_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	tenantId_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	tenantId_MATCHES?: InputMaybe<Scalars["String"]>;
	tenantId_NOT?: InputMaybe<Scalars["String"]>;
	tenantId_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	tenantId_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	tenantId_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	tenantId_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	tenantId_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	therapyStartDate?: InputMaybe<Scalars["Date"]>;
	therapyStartDate_GT?: InputMaybe<Scalars["Date"]>;
	therapyStartDate_GTE?: InputMaybe<Scalars["Date"]>;
	therapyStartDate_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
	therapyStartDate_LT?: InputMaybe<Scalars["Date"]>;
	therapyStartDate_LTE?: InputMaybe<Scalars["Date"]>;
	therapyStartDate_NOT?: InputMaybe<Scalars["Date"]>;
	therapyStartDate_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
	treatingPhysician?: InputMaybe<TreatingPhysicianWhere>;
	treatingPhysicianAggregate?: InputMaybe<InitialResponseTreatingPhysicianAggregateInput>;
	treatingPhysicianConnection?: InputMaybe<InitialResponseTreatingPhysicianConnectionWhere>;
	treatingPhysicianConnection_NOT?: InputMaybe<InitialResponseTreatingPhysicianConnectionWhere>;
	treatingPhysician_NOT?: InputMaybe<TreatingPhysicianWhere>;
};

export type IntAggregateSelection = {
	__typename?: "IntAggregateSelection";
	average: Scalars["Float"];
	max: Scalars["Int"];
	min: Scalars["Int"];
};

export type Intervention = {
	__typename?: "Intervention";
	LAPressure?: Maybe<Scalars["Int"]>;
	LAVolume?: Maybe<Scalars["Int"]>;
	case?: Maybe<Case>;
	caseConnection: InterventionCaseConnection;
	createdBy: User;
	createdByConnection: InterventionCreatedByConnection;
	createdOn: Scalars["DateTime"];
	disease?: Maybe<Disease>;
	diseaseConnection: InterventionDiseaseConnection;
	financialDataPoints: Array<FinancialDataPoint>;
	financialDataPointsConnection: InterventionFinancialDataPointsConnection;
	firstAblationDate?: Maybe<Scalars["Date"]>;
	form?: Maybe<Form>;
	formConnection: InterventionFormConnection;
	id: Scalars["ID"];
	isAdheringToCloseProtocol: Scalars["Boolean"];
	isArchived: Scalars["Boolean"];
	isCTILineAblated: Scalars["Boolean"];
	isDeletable?: Maybe<Scalars["Boolean"]>;
	isDeleted: Scalars["Boolean"];
	isLowVoltageZone: Scalars["Boolean"];
	isPrimary: Scalars["Boolean"];
	lastUpdatedOn?: Maybe<Scalars["DateTime"]>;
	legalEntity?: Maybe<Organization>;
	legalEntityConnection: InterventionLegalEntityConnection;
	mainItem?: Maybe<Treatment>;
	mainItemConnection: InterventionMainItemConnection;
	patient?: Maybe<Patient>;
	patientConnection: InterventionPatientConnection;
	programCoverEndDate?: Maybe<Scalars["Date"]>;
	recurrenceDate?: Maybe<Scalars["Date"]>;
	reportStatus: RefundStatus;
	responsiblePhysicianAlias: CaobPhysician;
	secondAblationDate?: Maybe<Scalars["Date"]>;
	status: FormStatus;
	submissionDate?: Maybe<Scalars["DateTime"]>;
	subsequentIntervention: Array<Intervention>;
	subsequentInterventionConnection: InterventionSubsequentInterventionConnection;
	supportingItem: Array<Treatment>;
	supportingItemConnection: InterventionSupportingItemConnection;
	tenantId: Scalars["String"];
};

export type InterventionCaseArgs = {
	options?: InputMaybe<CaseOptions>;
	where?: InputMaybe<CaseWhere>;
};

export type InterventionCaseConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<InterventionCaseConnectionSort>>;
	where?: InputMaybe<InterventionCaseConnectionWhere>;
};

export type InterventionCreatedByArgs = {
	options?: InputMaybe<UserOptions>;
	where?: InputMaybe<UserWhere>;
};

export type InterventionCreatedByConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<InterventionCreatedByConnectionSort>>;
	where?: InputMaybe<InterventionCreatedByConnectionWhere>;
};

export type InterventionDiseaseArgs = {
	options?: InputMaybe<DiseaseOptions>;
	where?: InputMaybe<DiseaseWhere>;
};

export type InterventionDiseaseConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<InterventionDiseaseConnectionSort>>;
	where?: InputMaybe<InterventionDiseaseConnectionWhere>;
};

export type InterventionFinancialDataPointsArgs = {
	options?: InputMaybe<FinancialDataPointOptions>;
	where?: InputMaybe<FinancialDataPointWhere>;
};

export type InterventionFinancialDataPointsConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<InterventionFinancialDataPointsConnectionSort>>;
	where?: InputMaybe<InterventionFinancialDataPointsConnectionWhere>;
};

export type InterventionFormArgs = {
	options?: InputMaybe<FormOptions>;
	where?: InputMaybe<FormWhere>;
};

export type InterventionFormConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<InterventionFormConnectionSort>>;
	where?: InputMaybe<InterventionFormConnectionWhere>;
};

export type InterventionLegalEntityArgs = {
	options?: InputMaybe<OrganizationOptions>;
	where?: InputMaybe<OrganizationWhere>;
};

export type InterventionLegalEntityConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<InterventionLegalEntityConnectionSort>>;
	where?: InputMaybe<InterventionLegalEntityConnectionWhere>;
};

export type InterventionMainItemArgs = {
	options?: InputMaybe<TreatmentOptions>;
	where?: InputMaybe<TreatmentWhere>;
};

export type InterventionMainItemConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<InterventionMainItemConnectionSort>>;
	where?: InputMaybe<InterventionMainItemConnectionWhere>;
};

export type InterventionPatientArgs = {
	options?: InputMaybe<PatientOptions>;
	where?: InputMaybe<PatientWhere>;
};

export type InterventionPatientConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<InterventionPatientConnectionSort>>;
	where?: InputMaybe<InterventionPatientConnectionWhere>;
};

export type InterventionSubsequentInterventionArgs = {
	options?: InputMaybe<InterventionOptions>;
	where?: InputMaybe<InterventionWhere>;
};

export type InterventionSubsequentInterventionConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<InterventionSubsequentInterventionConnectionSort>>;
	where?: InputMaybe<InterventionSubsequentInterventionConnectionWhere>;
};

export type InterventionSupportingItemArgs = {
	options?: InputMaybe<TreatmentOptions>;
	where?: InputMaybe<TreatmentWhere>;
};

export type InterventionSupportingItemConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<InterventionSupportingItemConnectionSort>>;
	where?: InputMaybe<InterventionSupportingItemConnectionWhere>;
};

export type InterventionAggregateSelection = {
	__typename?: "InterventionAggregateSelection";
	LAPressure: IntAggregateSelection;
	LAVolume: IntAggregateSelection;
	count: Scalars["Int"];
	createdOn: DateTimeAggregateSelection;
	id: IdAggregateSelection;
	lastUpdatedOn: DateTimeAggregateSelection;
	submissionDate: DateTimeAggregateSelection;
	tenantId: StringAggregateSelection;
};

export type InterventionCaseAggregateInput = {
	AND?: InputMaybe<Array<InterventionCaseAggregateInput>>;
	OR?: InputMaybe<Array<InterventionCaseAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<InterventionCaseNodeAggregationWhereInput>;
};

export type InterventionCaseConnectFieldInput = {
	connect?: InputMaybe<CaseConnectInput>;
	where?: InputMaybe<CaseConnectWhere>;
};

export type InterventionCaseConnection = {
	__typename?: "InterventionCaseConnection";
	edges: Array<InterventionCaseRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type InterventionCaseConnectionSort = {
	node?: InputMaybe<CaseSort>;
};

export type InterventionCaseConnectionWhere = {
	AND?: InputMaybe<Array<InterventionCaseConnectionWhere>>;
	OR?: InputMaybe<Array<InterventionCaseConnectionWhere>>;
	node?: InputMaybe<CaseWhere>;
	node_NOT?: InputMaybe<CaseWhere>;
};

export type InterventionCaseCreateFieldInput = {
	node: CaseCreateInput;
};

export type InterventionCaseDeleteFieldInput = {
	delete?: InputMaybe<CaseDeleteInput>;
	where?: InputMaybe<InterventionCaseConnectionWhere>;
};

export type InterventionCaseDisconnectFieldInput = {
	disconnect?: InputMaybe<CaseDisconnectInput>;
	where?: InputMaybe<InterventionCaseConnectionWhere>;
};

export type InterventionCaseFieldInput = {
	connect?: InputMaybe<InterventionCaseConnectFieldInput>;
	create?: InputMaybe<InterventionCaseCreateFieldInput>;
};

export type InterventionCaseNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<InterventionCaseNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<InterventionCaseNodeAggregationWhereInput>>;
	actualAgreementId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	actualAgreementId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	actualAgreementId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	actualAgreementId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	actualAgreementId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	actualAgreementId_EQUAL?: InputMaybe<Scalars["String"]>;
	actualAgreementId_GT?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_GTE?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_LT?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_LTE?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	agreementName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	agreementName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	agreementName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	agreementName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	agreementName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	agreementName_EQUAL?: InputMaybe<Scalars["String"]>;
	agreementName_GT?: InputMaybe<Scalars["Int"]>;
	agreementName_GTE?: InputMaybe<Scalars["Int"]>;
	agreementName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	agreementName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	agreementName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	agreementName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	agreementName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	agreementName_LT?: InputMaybe<Scalars["Int"]>;
	agreementName_LTE?: InputMaybe<Scalars["Int"]>;
	agreementName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	agreementName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	agreementName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	agreementName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	agreementName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	patientInitials_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	patientInitials_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	patientInitials_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	patientInitials_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	patientInitials_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	patientInitials_EQUAL?: InputMaybe<Scalars["String"]>;
	patientInitials_GT?: InputMaybe<Scalars["Int"]>;
	patientInitials_GTE?: InputMaybe<Scalars["Int"]>;
	patientInitials_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	patientInitials_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	patientInitials_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	patientInitials_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	patientInitials_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	patientInitials_LT?: InputMaybe<Scalars["Int"]>;
	patientInitials_LTE?: InputMaybe<Scalars["Int"]>;
	patientInitials_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	patientInitials_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	patientInitials_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	patientInitials_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	patientInitials_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	patientInsuranceId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	patientInsuranceId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	patientInsuranceId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	patientInsuranceId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	patientInsuranceId_EQUAL?: InputMaybe<Scalars["String"]>;
	patientInsuranceId_GT?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_GTE?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_LT?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_LTE?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationBandName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	preparationBandName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	preparationBandName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	preparationBandName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	preparationBandName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	preparationBandName_EQUAL?: InputMaybe<Scalars["String"]>;
	preparationBandName_GT?: InputMaybe<Scalars["Int"]>;
	preparationBandName_GTE?: InputMaybe<Scalars["Int"]>;
	preparationBandName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationBandName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationBandName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationBandName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationBandName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationBandName_LT?: InputMaybe<Scalars["Int"]>;
	preparationBandName_LTE?: InputMaybe<Scalars["Int"]>;
	preparationBandName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationBandName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationBandName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationBandName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationBandName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	preparationGenericName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	preparationGenericName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	preparationGenericName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	preparationGenericName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	preparationGenericName_EQUAL?: InputMaybe<Scalars["String"]>;
	preparationGenericName_GT?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_GTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_LT?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_LTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	sourceTenantId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	sourceTenantId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	sourceTenantId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	sourceTenantId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	sourceTenantId_EQUAL?: InputMaybe<Scalars["String"]>;
	sourceTenantId_GT?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_GTE?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_LT?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_LTE?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	submissionDate_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_GT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_GTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_LT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_LTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	totalAmount_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	totalAmount_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	totalAmount_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	totalAmount_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	totalAmount_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	totalAmount_EQUAL?: InputMaybe<Scalars["Float"]>;
	totalAmount_GT?: InputMaybe<Scalars["Float"]>;
	totalAmount_GTE?: InputMaybe<Scalars["Float"]>;
	totalAmount_LT?: InputMaybe<Scalars["Float"]>;
	totalAmount_LTE?: InputMaybe<Scalars["Float"]>;
	totalAmount_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	totalAmount_MAX_GT?: InputMaybe<Scalars["Float"]>;
	totalAmount_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	totalAmount_MAX_LT?: InputMaybe<Scalars["Float"]>;
	totalAmount_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	totalAmount_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	totalAmount_MIN_GT?: InputMaybe<Scalars["Float"]>;
	totalAmount_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	totalAmount_MIN_LT?: InputMaybe<Scalars["Float"]>;
	totalAmount_MIN_LTE?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	unlimited_EQUAL?: InputMaybe<Scalars["Int"]>;
	unlimited_GT?: InputMaybe<Scalars["Int"]>;
	unlimited_GTE?: InputMaybe<Scalars["Int"]>;
	unlimited_LT?: InputMaybe<Scalars["Int"]>;
	unlimited_LTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_GT?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_LT?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_GT?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_LT?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_LTE?: InputMaybe<Scalars["Int"]>;
};

export type InterventionCaseRelationship = {
	__typename?: "InterventionCaseRelationship";
	cursor: Scalars["String"];
	node: Case;
};

export type InterventionConnectInput = {
	case?: InputMaybe<InterventionCaseConnectFieldInput>;
	createdBy?: InputMaybe<InterventionCreatedByConnectFieldInput>;
	disease?: InputMaybe<InterventionDiseaseConnectFieldInput>;
	financialDataPoints?: InputMaybe<Array<InterventionFinancialDataPointsConnectFieldInput>>;
	form?: InputMaybe<InterventionFormConnectFieldInput>;
	legalEntity?: InputMaybe<InterventionLegalEntityConnectFieldInput>;
	mainItem?: InputMaybe<InterventionMainItemConnectFieldInput>;
	patient?: InputMaybe<InterventionPatientConnectFieldInput>;
	subsequentIntervention?: InputMaybe<Array<InterventionSubsequentInterventionConnectFieldInput>>;
	supportingItem?: InputMaybe<Array<InterventionSupportingItemConnectFieldInput>>;
};

export type InterventionConnectWhere = {
	node: InterventionWhere;
};

export type InterventionCreateInput = {
	LAPressure?: InputMaybe<Scalars["Int"]>;
	LAVolume?: InputMaybe<Scalars["Int"]>;
	case?: InputMaybe<InterventionCaseFieldInput>;
	createdBy?: InputMaybe<InterventionCreatedByFieldInput>;
	createdOn: Scalars["DateTime"];
	disease?: InputMaybe<InterventionDiseaseFieldInput>;
	financialDataPoints?: InputMaybe<InterventionFinancialDataPointsFieldInput>;
	firstAblationDate?: InputMaybe<Scalars["Date"]>;
	form?: InputMaybe<InterventionFormFieldInput>;
	id: Scalars["ID"];
	isAdheringToCloseProtocol: Scalars["Boolean"];
	isArchived: Scalars["Boolean"];
	isCTILineAblated: Scalars["Boolean"];
	isDeletable?: InputMaybe<Scalars["Boolean"]>;
	isDeleted: Scalars["Boolean"];
	isLowVoltageZone: Scalars["Boolean"];
	isPrimary: Scalars["Boolean"];
	lastUpdatedOn?: InputMaybe<Scalars["DateTime"]>;
	legalEntity?: InputMaybe<InterventionLegalEntityFieldInput>;
	mainItem?: InputMaybe<InterventionMainItemFieldInput>;
	patient?: InputMaybe<InterventionPatientFieldInput>;
	programCoverEndDate?: InputMaybe<Scalars["Date"]>;
	recurrenceDate?: InputMaybe<Scalars["Date"]>;
	reportStatus: RefundStatus;
	responsiblePhysicianAlias: CaobPhysician;
	secondAblationDate?: InputMaybe<Scalars["Date"]>;
	status: FormStatus;
	submissionDate?: InputMaybe<Scalars["DateTime"]>;
	subsequentIntervention?: InputMaybe<InterventionSubsequentInterventionFieldInput>;
	supportingItem?: InputMaybe<InterventionSupportingItemFieldInput>;
	tenantId: Scalars["String"];
};

export type InterventionCreatedByAggregateInput = {
	AND?: InputMaybe<Array<InterventionCreatedByAggregateInput>>;
	OR?: InputMaybe<Array<InterventionCreatedByAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<InterventionCreatedByNodeAggregationWhereInput>;
};

export type InterventionCreatedByConnectFieldInput = {
	connect?: InputMaybe<UserConnectInput>;
	where?: InputMaybe<UserConnectWhere>;
};

export type InterventionCreatedByConnection = {
	__typename?: "InterventionCreatedByConnection";
	edges: Array<InterventionCreatedByRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type InterventionCreatedByConnectionSort = {
	node?: InputMaybe<UserSort>;
};

export type InterventionCreatedByConnectionWhere = {
	AND?: InputMaybe<Array<InterventionCreatedByConnectionWhere>>;
	OR?: InputMaybe<Array<InterventionCreatedByConnectionWhere>>;
	node?: InputMaybe<UserWhere>;
	node_NOT?: InputMaybe<UserWhere>;
};

export type InterventionCreatedByCreateFieldInput = {
	node: UserCreateInput;
};

export type InterventionCreatedByDeleteFieldInput = {
	delete?: InputMaybe<UserDeleteInput>;
	where?: InputMaybe<InterventionCreatedByConnectionWhere>;
};

export type InterventionCreatedByDisconnectFieldInput = {
	disconnect?: InputMaybe<UserDisconnectInput>;
	where?: InputMaybe<InterventionCreatedByConnectionWhere>;
};

export type InterventionCreatedByFieldInput = {
	connect?: InputMaybe<InterventionCreatedByConnectFieldInput>;
	create?: InputMaybe<InterventionCreatedByCreateFieldInput>;
};

export type InterventionCreatedByNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<InterventionCreatedByNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<InterventionCreatedByNodeAggregationWhereInput>>;
	email_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	email_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	email_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	email_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	email_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	email_EQUAL?: InputMaybe<Scalars["String"]>;
	email_GT?: InputMaybe<Scalars["Int"]>;
	email_GTE?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	email_LT?: InputMaybe<Scalars["Int"]>;
	email_LTE?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	firstName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	firstName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	firstName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	firstName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	firstName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	firstName_EQUAL?: InputMaybe<Scalars["String"]>;
	firstName_GT?: InputMaybe<Scalars["Int"]>;
	firstName_GTE?: InputMaybe<Scalars["Int"]>;
	firstName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	firstName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	firstName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	firstName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	firstName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	firstName_LT?: InputMaybe<Scalars["Int"]>;
	firstName_LTE?: InputMaybe<Scalars["Int"]>;
	firstName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	firstName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	firstName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	firstName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	firstName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	lastName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	lastName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	lastName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	lastName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	lastName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	lastName_EQUAL?: InputMaybe<Scalars["String"]>;
	lastName_GT?: InputMaybe<Scalars["Int"]>;
	lastName_GTE?: InputMaybe<Scalars["Int"]>;
	lastName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	lastName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	lastName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	lastName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	lastName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	lastName_LT?: InputMaybe<Scalars["Int"]>;
	lastName_LTE?: InputMaybe<Scalars["Int"]>;
	lastName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	lastName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	lastName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	lastName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	lastName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	preferredLanguage_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	preferredLanguage_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	preferredLanguage_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	preferredLanguage_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	preferredLanguage_EQUAL?: InputMaybe<Scalars["String"]>;
	preferredLanguage_GT?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_GTE?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LT?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LTE?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	tenantId_EQUAL?: InputMaybe<Scalars["String"]>;
	tenantId_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type InterventionCreatedByRelationship = {
	__typename?: "InterventionCreatedByRelationship";
	cursor: Scalars["String"];
	node: User;
};

export type InterventionDeleteInput = {
	case?: InputMaybe<InterventionCaseDeleteFieldInput>;
	createdBy?: InputMaybe<InterventionCreatedByDeleteFieldInput>;
	disease?: InputMaybe<InterventionDiseaseDeleteFieldInput>;
	financialDataPoints?: InputMaybe<Array<InterventionFinancialDataPointsDeleteFieldInput>>;
	form?: InputMaybe<InterventionFormDeleteFieldInput>;
	legalEntity?: InputMaybe<InterventionLegalEntityDeleteFieldInput>;
	mainItem?: InputMaybe<InterventionMainItemDeleteFieldInput>;
	patient?: InputMaybe<InterventionPatientDeleteFieldInput>;
	subsequentIntervention?: InputMaybe<Array<InterventionSubsequentInterventionDeleteFieldInput>>;
	supportingItem?: InputMaybe<Array<InterventionSupportingItemDeleteFieldInput>>;
};

export type InterventionDisconnectInput = {
	case?: InputMaybe<InterventionCaseDisconnectFieldInput>;
	createdBy?: InputMaybe<InterventionCreatedByDisconnectFieldInput>;
	disease?: InputMaybe<InterventionDiseaseDisconnectFieldInput>;
	financialDataPoints?: InputMaybe<Array<InterventionFinancialDataPointsDisconnectFieldInput>>;
	form?: InputMaybe<InterventionFormDisconnectFieldInput>;
	legalEntity?: InputMaybe<InterventionLegalEntityDisconnectFieldInput>;
	mainItem?: InputMaybe<InterventionMainItemDisconnectFieldInput>;
	patient?: InputMaybe<InterventionPatientDisconnectFieldInput>;
	subsequentIntervention?: InputMaybe<Array<InterventionSubsequentInterventionDisconnectFieldInput>>;
	supportingItem?: InputMaybe<Array<InterventionSupportingItemDisconnectFieldInput>>;
};

export type InterventionDiseaseAggregateInput = {
	AND?: InputMaybe<Array<InterventionDiseaseAggregateInput>>;
	OR?: InputMaybe<Array<InterventionDiseaseAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<InterventionDiseaseNodeAggregationWhereInput>;
};

export type InterventionDiseaseConnectFieldInput = {
	where?: InputMaybe<DiseaseConnectWhere>;
};

export type InterventionDiseaseConnection = {
	__typename?: "InterventionDiseaseConnection";
	edges: Array<InterventionDiseaseRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type InterventionDiseaseConnectionSort = {
	node?: InputMaybe<DiseaseSort>;
};

export type InterventionDiseaseConnectionWhere = {
	AND?: InputMaybe<Array<InterventionDiseaseConnectionWhere>>;
	OR?: InputMaybe<Array<InterventionDiseaseConnectionWhere>>;
	node?: InputMaybe<DiseaseWhere>;
	node_NOT?: InputMaybe<DiseaseWhere>;
};

export type InterventionDiseaseCreateFieldInput = {
	node: DiseaseCreateInput;
};

export type InterventionDiseaseDeleteFieldInput = {
	where?: InputMaybe<InterventionDiseaseConnectionWhere>;
};

export type InterventionDiseaseDisconnectFieldInput = {
	where?: InputMaybe<InterventionDiseaseConnectionWhere>;
};

export type InterventionDiseaseFieldInput = {
	connect?: InputMaybe<InterventionDiseaseConnectFieldInput>;
	create?: InputMaybe<InterventionDiseaseCreateFieldInput>;
};

export type InterventionDiseaseNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<InterventionDiseaseNodeAggregationWhereInput>>;
	Icd10Code_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	Icd10Code_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	Icd10Code_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	Icd10Code_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	Icd10Code_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	Icd10Code_EQUAL?: InputMaybe<Scalars["String"]>;
	Icd10Code_GT?: InputMaybe<Scalars["Int"]>;
	Icd10Code_GTE?: InputMaybe<Scalars["Int"]>;
	Icd10Code_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Icd10Code_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	Icd10Code_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	Icd10Code_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	Icd10Code_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	Icd10Code_LT?: InputMaybe<Scalars["Int"]>;
	Icd10Code_LTE?: InputMaybe<Scalars["Int"]>;
	Icd10Code_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Icd10Code_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	Icd10Code_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	Icd10Code_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	Icd10Code_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	Name_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	Name_EQUAL?: InputMaybe<Scalars["String"]>;
	Name_GT?: InputMaybe<Scalars["Int"]>;
	Name_GTE?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	Name_LT?: InputMaybe<Scalars["Int"]>;
	Name_LTE?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	OR?: InputMaybe<Array<InterventionDiseaseNodeAggregationWhereInput>>;
};

export type InterventionDiseaseRelationship = {
	__typename?: "InterventionDiseaseRelationship";
	cursor: Scalars["String"];
	node: Disease;
};

export type InterventionFinancialDataPointsAggregateInput = {
	AND?: InputMaybe<Array<InterventionFinancialDataPointsAggregateInput>>;
	OR?: InputMaybe<Array<InterventionFinancialDataPointsAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<InterventionFinancialDataPointsNodeAggregationWhereInput>;
};

export type InterventionFinancialDataPointsConnectFieldInput = {
	connect?: InputMaybe<Array<FinancialDataPointConnectInput>>;
	where?: InputMaybe<FinancialDataPointConnectWhere>;
};

export type InterventionFinancialDataPointsConnection = {
	__typename?: "InterventionFinancialDataPointsConnection";
	edges: Array<InterventionFinancialDataPointsRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type InterventionFinancialDataPointsConnectionSort = {
	node?: InputMaybe<FinancialDataPointSort>;
};

export type InterventionFinancialDataPointsConnectionWhere = {
	AND?: InputMaybe<Array<InterventionFinancialDataPointsConnectionWhere>>;
	OR?: InputMaybe<Array<InterventionFinancialDataPointsConnectionWhere>>;
	node?: InputMaybe<FinancialDataPointWhere>;
	node_NOT?: InputMaybe<FinancialDataPointWhere>;
};

export type InterventionFinancialDataPointsCreateFieldInput = {
	node: FinancialDataPointCreateInput;
};

export type InterventionFinancialDataPointsDeleteFieldInput = {
	delete?: InputMaybe<FinancialDataPointDeleteInput>;
	where?: InputMaybe<InterventionFinancialDataPointsConnectionWhere>;
};

export type InterventionFinancialDataPointsDisconnectFieldInput = {
	disconnect?: InputMaybe<FinancialDataPointDisconnectInput>;
	where?: InputMaybe<InterventionFinancialDataPointsConnectionWhere>;
};

export type InterventionFinancialDataPointsFieldInput = {
	connect?: InputMaybe<Array<InterventionFinancialDataPointsConnectFieldInput>>;
	create?: InputMaybe<Array<InterventionFinancialDataPointsCreateFieldInput>>;
};

export type InterventionFinancialDataPointsNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<InterventionFinancialDataPointsNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<InterventionFinancialDataPointsNodeAggregationWhereInput>>;
	basePrice_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	basePrice_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	basePrice_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	basePrice_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	basePrice_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	basePrice_EQUAL?: InputMaybe<Scalars["Float"]>;
	basePrice_GT?: InputMaybe<Scalars["Float"]>;
	basePrice_GTE?: InputMaybe<Scalars["Float"]>;
	basePrice_LT?: InputMaybe<Scalars["Float"]>;
	basePrice_LTE?: InputMaybe<Scalars["Float"]>;
	basePrice_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	basePrice_MAX_GT?: InputMaybe<Scalars["Float"]>;
	basePrice_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	basePrice_MAX_LT?: InputMaybe<Scalars["Float"]>;
	basePrice_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	basePrice_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	basePrice_MIN_GT?: InputMaybe<Scalars["Float"]>;
	basePrice_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	basePrice_MIN_LT?: InputMaybe<Scalars["Float"]>;
	basePrice_MIN_LTE?: InputMaybe<Scalars["Float"]>;
	currencyCode_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	currencyCode_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	currencyCode_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	currencyCode_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	currencyCode_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	currencyCode_EQUAL?: InputMaybe<Scalars["String"]>;
	currencyCode_GT?: InputMaybe<Scalars["Int"]>;
	currencyCode_GTE?: InputMaybe<Scalars["Int"]>;
	currencyCode_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	currencyCode_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	currencyCode_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	currencyCode_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	currencyCode_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	currencyCode_LT?: InputMaybe<Scalars["Int"]>;
	currencyCode_LTE?: InputMaybe<Scalars["Int"]>;
	currencyCode_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	currencyCode_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	currencyCode_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	currencyCode_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	currencyCode_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	evaluationSnapshot_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	evaluationSnapshot_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	evaluationSnapshot_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	evaluationSnapshot_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	evaluationSnapshot_EQUAL?: InputMaybe<Scalars["String"]>;
	evaluationSnapshot_GT?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_GTE?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_LT?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_LTE?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	generatedUuid_EQUAL?: InputMaybe<Scalars["ID"]>;
	payablePercentage_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	payablePercentage_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	payablePercentage_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	payablePercentage_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	payablePercentage_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	payablePercentage_EQUAL?: InputMaybe<Scalars["Float"]>;
	payablePercentage_GT?: InputMaybe<Scalars["Float"]>;
	payablePercentage_GTE?: InputMaybe<Scalars["Float"]>;
	payablePercentage_LT?: InputMaybe<Scalars["Float"]>;
	payablePercentage_LTE?: InputMaybe<Scalars["Float"]>;
	payablePercentage_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	payablePercentage_MAX_GT?: InputMaybe<Scalars["Float"]>;
	payablePercentage_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	payablePercentage_MAX_LT?: InputMaybe<Scalars["Float"]>;
	payablePercentage_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	payablePercentage_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	payablePercentage_MIN_GT?: InputMaybe<Scalars["Float"]>;
	payablePercentage_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	payablePercentage_MIN_LT?: InputMaybe<Scalars["Float"]>;
	payablePercentage_MIN_LTE?: InputMaybe<Scalars["Float"]>;
	payable_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	payable_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	payable_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	payable_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	payable_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	payable_EQUAL?: InputMaybe<Scalars["Float"]>;
	payable_GT?: InputMaybe<Scalars["Float"]>;
	payable_GTE?: InputMaybe<Scalars["Float"]>;
	payable_LT?: InputMaybe<Scalars["Float"]>;
	payable_LTE?: InputMaybe<Scalars["Float"]>;
	payable_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	payable_MAX_GT?: InputMaybe<Scalars["Float"]>;
	payable_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	payable_MAX_LT?: InputMaybe<Scalars["Float"]>;
	payable_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	payable_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	payable_MIN_GT?: InputMaybe<Scalars["Float"]>;
	payable_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	payable_MIN_LT?: InputMaybe<Scalars["Float"]>;
	payable_MIN_LTE?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	quantity_EQUAL?: InputMaybe<Scalars["Float"]>;
	quantity_GT?: InputMaybe<Scalars["Float"]>;
	quantity_GTE?: InputMaybe<Scalars["Float"]>;
	quantity_LT?: InputMaybe<Scalars["Float"]>;
	quantity_LTE?: InputMaybe<Scalars["Float"]>;
	quantity_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	quantity_MAX_GT?: InputMaybe<Scalars["Float"]>;
	quantity_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	quantity_MAX_LT?: InputMaybe<Scalars["Float"]>;
	quantity_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	quantity_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	quantity_MIN_GT?: InputMaybe<Scalars["Float"]>;
	quantity_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	quantity_MIN_LT?: InputMaybe<Scalars["Float"]>;
	quantity_MIN_LTE?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_EQUAL?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_GT?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_GTE?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_LT?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_LTE?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_MAX_GT?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_MAX_LT?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_MIN_GT?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_MIN_LT?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_MIN_LTE?: InputMaybe<Scalars["Float"]>;
	refundable_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	refundable_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	refundable_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	refundable_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	refundable_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	refundable_EQUAL?: InputMaybe<Scalars["Float"]>;
	refundable_GT?: InputMaybe<Scalars["Float"]>;
	refundable_GTE?: InputMaybe<Scalars["Float"]>;
	refundable_LT?: InputMaybe<Scalars["Float"]>;
	refundable_LTE?: InputMaybe<Scalars["Float"]>;
	refundable_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	refundable_MAX_GT?: InputMaybe<Scalars["Float"]>;
	refundable_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	refundable_MAX_LT?: InputMaybe<Scalars["Float"]>;
	refundable_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	refundable_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	refundable_MIN_GT?: InputMaybe<Scalars["Float"]>;
	refundable_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	refundable_MIN_LT?: InputMaybe<Scalars["Float"]>;
	refundable_MIN_LTE?: InputMaybe<Scalars["Float"]>;
	uuid_EQUAL?: InputMaybe<Scalars["ID"]>;
	variablePercentage_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	variablePercentage_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	variablePercentage_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	variablePercentage_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	variablePercentage_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	variablePercentage_EQUAL?: InputMaybe<Scalars["Float"]>;
	variablePercentage_GT?: InputMaybe<Scalars["Float"]>;
	variablePercentage_GTE?: InputMaybe<Scalars["Float"]>;
	variablePercentage_LT?: InputMaybe<Scalars["Float"]>;
	variablePercentage_LTE?: InputMaybe<Scalars["Float"]>;
	variablePercentage_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	variablePercentage_MAX_GT?: InputMaybe<Scalars["Float"]>;
	variablePercentage_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	variablePercentage_MAX_LT?: InputMaybe<Scalars["Float"]>;
	variablePercentage_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	variablePercentage_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	variablePercentage_MIN_GT?: InputMaybe<Scalars["Float"]>;
	variablePercentage_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	variablePercentage_MIN_LT?: InputMaybe<Scalars["Float"]>;
	variablePercentage_MIN_LTE?: InputMaybe<Scalars["Float"]>;
	variable_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	variable_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	variable_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	variable_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	variable_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	variable_EQUAL?: InputMaybe<Scalars["Float"]>;
	variable_GT?: InputMaybe<Scalars["Float"]>;
	variable_GTE?: InputMaybe<Scalars["Float"]>;
	variable_LT?: InputMaybe<Scalars["Float"]>;
	variable_LTE?: InputMaybe<Scalars["Float"]>;
	variable_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	variable_MAX_GT?: InputMaybe<Scalars["Float"]>;
	variable_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	variable_MAX_LT?: InputMaybe<Scalars["Float"]>;
	variable_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	variable_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	variable_MIN_GT?: InputMaybe<Scalars["Float"]>;
	variable_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	variable_MIN_LT?: InputMaybe<Scalars["Float"]>;
	variable_MIN_LTE?: InputMaybe<Scalars["Float"]>;
};

export type InterventionFinancialDataPointsRelationship = {
	__typename?: "InterventionFinancialDataPointsRelationship";
	cursor: Scalars["String"];
	node: FinancialDataPoint;
};

export type InterventionFormAggregateInput = {
	AND?: InputMaybe<Array<InterventionFormAggregateInput>>;
	OR?: InputMaybe<Array<InterventionFormAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<InterventionFormNodeAggregationWhereInput>;
};

export type InterventionFormConnectFieldInput = {
	connect?: InputMaybe<FormConnectInput>;
	where?: InputMaybe<FormConnectWhere>;
};

export type InterventionFormConnection = {
	__typename?: "InterventionFormConnection";
	edges: Array<InterventionFormRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type InterventionFormConnectionSort = {
	node?: InputMaybe<FormSort>;
};

export type InterventionFormConnectionWhere = {
	AND?: InputMaybe<Array<InterventionFormConnectionWhere>>;
	OR?: InputMaybe<Array<InterventionFormConnectionWhere>>;
	node?: InputMaybe<FormWhere>;
	node_NOT?: InputMaybe<FormWhere>;
};

export type InterventionFormCreateFieldInput = {
	node: FormCreateInput;
};

export type InterventionFormDeleteFieldInput = {
	delete?: InputMaybe<FormDeleteInput>;
	where?: InputMaybe<InterventionFormConnectionWhere>;
};

export type InterventionFormDisconnectFieldInput = {
	disconnect?: InputMaybe<FormDisconnectInput>;
	where?: InputMaybe<InterventionFormConnectionWhere>;
};

export type InterventionFormFieldInput = {
	connect?: InputMaybe<InterventionFormConnectFieldInput>;
	create?: InputMaybe<InterventionFormCreateFieldInput>;
};

export type InterventionFormNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<InterventionFormNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<InterventionFormNodeAggregationWhereInput>>;
	createdByName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	createdByName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	createdByName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	createdByName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	createdByName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	createdByName_EQUAL?: InputMaybe<Scalars["String"]>;
	createdByName_GT?: InputMaybe<Scalars["Int"]>;
	createdByName_GTE?: InputMaybe<Scalars["Int"]>;
	createdByName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	createdByName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	createdByName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	createdByName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	createdByName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	createdByName_LT?: InputMaybe<Scalars["Int"]>;
	createdByName_LTE?: InputMaybe<Scalars["Int"]>;
	createdByName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	createdByName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	createdByName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	createdByName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	createdByName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	createdBy_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	createdBy_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	createdBy_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	createdBy_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	createdBy_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	createdBy_EQUAL?: InputMaybe<Scalars["String"]>;
	createdBy_GT?: InputMaybe<Scalars["Int"]>;
	createdBy_GTE?: InputMaybe<Scalars["Int"]>;
	createdBy_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	createdBy_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	createdBy_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	createdBy_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	createdBy_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	createdBy_LT?: InputMaybe<Scalars["Int"]>;
	createdBy_LTE?: InputMaybe<Scalars["Int"]>;
	createdBy_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	createdBy_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	createdBy_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	createdBy_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	createdBy_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	createdOn_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	insuranceId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	insuranceId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	insuranceId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	insuranceId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	insuranceId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	insuranceId_EQUAL?: InputMaybe<Scalars["String"]>;
	insuranceId_GT?: InputMaybe<Scalars["Int"]>;
	insuranceId_GTE?: InputMaybe<Scalars["Int"]>;
	insuranceId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	insuranceId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	insuranceId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	insuranceId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	insuranceId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	insuranceId_LT?: InputMaybe<Scalars["Int"]>;
	insuranceId_LTE?: InputMaybe<Scalars["Int"]>;
	insuranceId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	insuranceId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	insuranceId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	insuranceId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	insuranceId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	lastUpdatedOn_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_GT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_LT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	preparationBrandName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	preparationBrandName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	preparationBrandName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	preparationBrandName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	preparationBrandName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	preparationBrandName_EQUAL?: InputMaybe<Scalars["String"]>;
	preparationBrandName_GT?: InputMaybe<Scalars["Int"]>;
	preparationBrandName_GTE?: InputMaybe<Scalars["Int"]>;
	preparationBrandName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationBrandName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationBrandName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationBrandName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationBrandName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationBrandName_LT?: InputMaybe<Scalars["Int"]>;
	preparationBrandName_LTE?: InputMaybe<Scalars["Int"]>;
	preparationBrandName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationBrandName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationBrandName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationBrandName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationBrandName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	preparationGenericName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	preparationGenericName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	preparationGenericName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	preparationGenericName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	preparationGenericName_EQUAL?: InputMaybe<Scalars["String"]>;
	preparationGenericName_GT?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_GTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_LT?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_LTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	tenantId_EQUAL?: InputMaybe<Scalars["String"]>;
	tenantId_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	unlimited_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	unlimited_EQUAL?: InputMaybe<Scalars["Int"]>;
	unlimited_GT?: InputMaybe<Scalars["Int"]>;
	unlimited_GTE?: InputMaybe<Scalars["Int"]>;
	unlimited_LT?: InputMaybe<Scalars["Int"]>;
	unlimited_LTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_GT?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_LT?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_GT?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_LT?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	uuid_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	uuid_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	uuid_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	uuid_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	uuid_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	uuid_EQUAL?: InputMaybe<Scalars["String"]>;
	uuid_GT?: InputMaybe<Scalars["Int"]>;
	uuid_GTE?: InputMaybe<Scalars["Int"]>;
	uuid_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	uuid_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	uuid_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	uuid_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	uuid_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	uuid_LT?: InputMaybe<Scalars["Int"]>;
	uuid_LTE?: InputMaybe<Scalars["Int"]>;
	uuid_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	uuid_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	uuid_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	uuid_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	uuid_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type InterventionFormRelationship = {
	__typename?: "InterventionFormRelationship";
	cursor: Scalars["String"];
	node: Form;
};

export type InterventionInput = {
	LAPressure?: InputMaybe<Scalars["Int"]>;
	LAVolume?: InputMaybe<Scalars["Int"]>;
	caseId?: InputMaybe<Scalars["ID"]>;
	createdOn?: InputMaybe<Scalars["Float"]>;
	diseaseCode?: InputMaybe<Scalars["String"]>;
	firstAblationDate?: InputMaybe<Scalars["Date"]>;
	isAdheringToCloseProtocol: Scalars["Boolean"];
	isCTILineAblated: Scalars["Boolean"];
	isLowVoltageZone: Scalars["Boolean"];
	isPrimary: Scalars["Boolean"];
	lastUpdatedOn?: InputMaybe<Scalars["Float"]>;
	mainItem?: InputMaybe<InterventionItemInput>;
	patientAlias: Scalars["String"];
	primaryInterventionId?: InputMaybe<Scalars["String"]>;
	programCoverEndDate?: InputMaybe<Scalars["Date"]>;
	recurrenceDate?: InputMaybe<Scalars["Date"]>;
	responsiblePhysicianAlias: CaobPhysician;
	secondAblationDate?: InputMaybe<Scalars["Date"]>;
	status: FormStatus;
	submissionDate?: InputMaybe<Scalars["Float"]>;
	supportingItems?: InputMaybe<Array<InputMaybe<InterventionItemInput>>>;
};

export type InterventionItemInput = {
	LOT?: InputMaybe<Scalars["String"]>;
	REF?: InputMaybe<Scalars["String"]>;
	code?: InputMaybe<Scalars["String"]>;
};

export type InterventionLegalEntityAggregateInput = {
	AND?: InputMaybe<Array<InterventionLegalEntityAggregateInput>>;
	OR?: InputMaybe<Array<InterventionLegalEntityAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<InterventionLegalEntityNodeAggregationWhereInput>;
};

export type InterventionLegalEntityConnectFieldInput = {
	where?: InputMaybe<OrganizationConnectWhere>;
};

export type InterventionLegalEntityConnection = {
	__typename?: "InterventionLegalEntityConnection";
	edges: Array<InterventionLegalEntityRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type InterventionLegalEntityConnectionSort = {
	node?: InputMaybe<OrganizationSort>;
};

export type InterventionLegalEntityConnectionWhere = {
	AND?: InputMaybe<Array<InterventionLegalEntityConnectionWhere>>;
	OR?: InputMaybe<Array<InterventionLegalEntityConnectionWhere>>;
	node?: InputMaybe<OrganizationWhere>;
	node_NOT?: InputMaybe<OrganizationWhere>;
};

export type InterventionLegalEntityCreateFieldInput = {
	node: OrganizationCreateInput;
};

export type InterventionLegalEntityDeleteFieldInput = {
	where?: InputMaybe<InterventionLegalEntityConnectionWhere>;
};

export type InterventionLegalEntityDisconnectFieldInput = {
	where?: InputMaybe<InterventionLegalEntityConnectionWhere>;
};

export type InterventionLegalEntityFieldInput = {
	connect?: InputMaybe<InterventionLegalEntityConnectFieldInput>;
	create?: InputMaybe<InterventionLegalEntityCreateFieldInput>;
};

export type InterventionLegalEntityNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<InterventionLegalEntityNodeAggregationWhereInput>>;
	IBAN_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	IBAN_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	IBAN_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	IBAN_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	IBAN_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	IBAN_EQUAL?: InputMaybe<Scalars["String"]>;
	IBAN_GT?: InputMaybe<Scalars["Int"]>;
	IBAN_GTE?: InputMaybe<Scalars["Int"]>;
	IBAN_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	IBAN_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	IBAN_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	IBAN_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	IBAN_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	IBAN_LT?: InputMaybe<Scalars["Int"]>;
	IBAN_LTE?: InputMaybe<Scalars["Int"]>;
	IBAN_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	IBAN_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	IBAN_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	IBAN_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	IBAN_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	OR?: InputMaybe<Array<InterventionLegalEntityNodeAggregationWhereInput>>;
	billingAddress_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	billingAddress_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	billingAddress_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	billingAddress_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	billingAddress_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	billingAddress_EQUAL?: InputMaybe<Scalars["String"]>;
	billingAddress_GT?: InputMaybe<Scalars["Int"]>;
	billingAddress_GTE?: InputMaybe<Scalars["Int"]>;
	billingAddress_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	billingAddress_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	billingAddress_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	billingAddress_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	billingAddress_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	billingAddress_LT?: InputMaybe<Scalars["Int"]>;
	billingAddress_LTE?: InputMaybe<Scalars["Int"]>;
	billingAddress_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	billingAddress_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	billingAddress_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	billingAddress_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	billingAddress_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	contactEmail_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	contactEmail_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	contactEmail_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	contactEmail_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	contactEmail_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	contactEmail_EQUAL?: InputMaybe<Scalars["String"]>;
	contactEmail_GT?: InputMaybe<Scalars["Int"]>;
	contactEmail_GTE?: InputMaybe<Scalars["Int"]>;
	contactEmail_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	contactEmail_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	contactEmail_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	contactEmail_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	contactEmail_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	contactEmail_LT?: InputMaybe<Scalars["Int"]>;
	contactEmail_LTE?: InputMaybe<Scalars["Int"]>;
	contactEmail_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	contactEmail_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	contactEmail_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	contactEmail_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	contactEmail_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	contactFirstName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	contactFirstName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	contactFirstName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	contactFirstName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	contactFirstName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	contactFirstName_EQUAL?: InputMaybe<Scalars["String"]>;
	contactFirstName_GT?: InputMaybe<Scalars["Int"]>;
	contactFirstName_GTE?: InputMaybe<Scalars["Int"]>;
	contactFirstName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	contactFirstName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	contactFirstName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	contactFirstName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	contactFirstName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	contactFirstName_LT?: InputMaybe<Scalars["Int"]>;
	contactFirstName_LTE?: InputMaybe<Scalars["Int"]>;
	contactFirstName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	contactFirstName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	contactFirstName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	contactFirstName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	contactFirstName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	contactLastName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	contactLastName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	contactLastName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	contactLastName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	contactLastName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	contactLastName_EQUAL?: InputMaybe<Scalars["String"]>;
	contactLastName_GT?: InputMaybe<Scalars["Int"]>;
	contactLastName_GTE?: InputMaybe<Scalars["Int"]>;
	contactLastName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	contactLastName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	contactLastName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	contactLastName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	contactLastName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	contactLastName_LT?: InputMaybe<Scalars["Int"]>;
	contactLastName_LTE?: InputMaybe<Scalars["Int"]>;
	contactLastName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	contactLastName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	contactLastName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	contactLastName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	contactLastName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	contactOccupation_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	contactOccupation_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	contactOccupation_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	contactOccupation_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	contactOccupation_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	contactOccupation_EQUAL?: InputMaybe<Scalars["String"]>;
	contactOccupation_GT?: InputMaybe<Scalars["Int"]>;
	contactOccupation_GTE?: InputMaybe<Scalars["Int"]>;
	contactOccupation_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	contactOccupation_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	contactOccupation_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	contactOccupation_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	contactOccupation_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	contactOccupation_LT?: InputMaybe<Scalars["Int"]>;
	contactOccupation_LTE?: InputMaybe<Scalars["Int"]>;
	contactOccupation_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	contactOccupation_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	contactOccupation_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	contactOccupation_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	contactOccupation_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	contactPhone_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	contactPhone_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	contactPhone_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	contactPhone_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	contactPhone_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	contactPhone_EQUAL?: InputMaybe<Scalars["String"]>;
	contactPhone_GT?: InputMaybe<Scalars["Int"]>;
	contactPhone_GTE?: InputMaybe<Scalars["Int"]>;
	contactPhone_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	contactPhone_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	contactPhone_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	contactPhone_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	contactPhone_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	contactPhone_LT?: InputMaybe<Scalars["Int"]>;
	contactPhone_LTE?: InputMaybe<Scalars["Int"]>;
	contactPhone_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	contactPhone_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	contactPhone_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	contactPhone_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	contactPhone_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	domicile_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	domicile_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	domicile_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	domicile_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	domicile_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	domicile_EQUAL?: InputMaybe<Scalars["String"]>;
	domicile_GT?: InputMaybe<Scalars["Int"]>;
	domicile_GTE?: InputMaybe<Scalars["Int"]>;
	domicile_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	domicile_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	domicile_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	domicile_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	domicile_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	domicile_LT?: InputMaybe<Scalars["Int"]>;
	domicile_LTE?: InputMaybe<Scalars["Int"]>;
	domicile_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	domicile_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	domicile_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	domicile_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	domicile_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	eIN_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	eIN_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	eIN_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	eIN_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	eIN_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	eIN_EQUAL?: InputMaybe<Scalars["String"]>;
	eIN_GT?: InputMaybe<Scalars["Int"]>;
	eIN_GTE?: InputMaybe<Scalars["Int"]>;
	eIN_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	eIN_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	eIN_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	eIN_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	eIN_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	eIN_LT?: InputMaybe<Scalars["Int"]>;
	eIN_LTE?: InputMaybe<Scalars["Int"]>;
	eIN_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	eIN_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	eIN_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	eIN_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	eIN_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	fax_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	fax_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	fax_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	fax_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	fax_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	fax_EQUAL?: InputMaybe<Scalars["String"]>;
	fax_GT?: InputMaybe<Scalars["Int"]>;
	fax_GTE?: InputMaybe<Scalars["Int"]>;
	fax_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	fax_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	fax_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	fax_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	fax_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	fax_LT?: InputMaybe<Scalars["Int"]>;
	fax_LTE?: InputMaybe<Scalars["Int"]>;
	fax_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	fax_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	fax_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	fax_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	fax_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	legalName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	legalName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	legalName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	legalName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	legalName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	legalName_EQUAL?: InputMaybe<Scalars["String"]>;
	legalName_GT?: InputMaybe<Scalars["Int"]>;
	legalName_GTE?: InputMaybe<Scalars["Int"]>;
	legalName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	legalName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	legalName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	legalName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	legalName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	legalName_LT?: InputMaybe<Scalars["Int"]>;
	legalName_LTE?: InputMaybe<Scalars["Int"]>;
	legalName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	legalName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	legalName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	legalName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	legalName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	logo_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	logo_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	logo_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	logo_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	logo_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	logo_EQUAL?: InputMaybe<Scalars["String"]>;
	logo_GT?: InputMaybe<Scalars["Int"]>;
	logo_GTE?: InputMaybe<Scalars["Int"]>;
	logo_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	logo_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	logo_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	logo_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	logo_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	logo_LT?: InputMaybe<Scalars["Int"]>;
	logo_LTE?: InputMaybe<Scalars["Int"]>;
	logo_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	logo_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	logo_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	logo_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	logo_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	name_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	name_EQUAL?: InputMaybe<Scalars["String"]>;
	name_GT?: InputMaybe<Scalars["Int"]>;
	name_GTE?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	name_LT?: InputMaybe<Scalars["Int"]>;
	name_LTE?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	phone_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	phone_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	phone_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	phone_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	phone_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	phone_EQUAL?: InputMaybe<Scalars["String"]>;
	phone_GT?: InputMaybe<Scalars["Int"]>;
	phone_GTE?: InputMaybe<Scalars["Int"]>;
	phone_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	phone_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	phone_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	phone_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	phone_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	phone_LT?: InputMaybe<Scalars["Int"]>;
	phone_LTE?: InputMaybe<Scalars["Int"]>;
	phone_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	phone_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	phone_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	phone_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	phone_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	tenantId_EQUAL?: InputMaybe<Scalars["String"]>;
	tenantId_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	website_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	website_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	website_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	website_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	website_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	website_EQUAL?: InputMaybe<Scalars["String"]>;
	website_GT?: InputMaybe<Scalars["Int"]>;
	website_GTE?: InputMaybe<Scalars["Int"]>;
	website_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	website_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	website_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	website_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	website_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	website_LT?: InputMaybe<Scalars["Int"]>;
	website_LTE?: InputMaybe<Scalars["Int"]>;
	website_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	website_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	website_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	website_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	website_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type InterventionLegalEntityRelationship = {
	__typename?: "InterventionLegalEntityRelationship";
	cursor: Scalars["String"];
	node: Organization;
};

export type InterventionMainItemAggregateInput = {
	AND?: InputMaybe<Array<InterventionMainItemAggregateInput>>;
	OR?: InputMaybe<Array<InterventionMainItemAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	edge?: InputMaybe<InterventionMainItemEdgeAggregationWhereInput>;
	node?: InputMaybe<InterventionMainItemNodeAggregationWhereInput>;
};

export type InterventionMainItemConnectFieldInput = {
	connect?: InputMaybe<TreatmentConnectInput>;
	edge?: InputMaybe<InterventionTreatmentRelationshipCreateInput>;
	where?: InputMaybe<TreatmentConnectWhere>;
};

export type InterventionMainItemConnection = {
	__typename?: "InterventionMainItemConnection";
	edges: Array<InterventionMainItemRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type InterventionMainItemConnectionSort = {
	edge?: InputMaybe<InterventionTreatmentRelationshipSort>;
	node?: InputMaybe<TreatmentSort>;
};

export type InterventionMainItemConnectionWhere = {
	AND?: InputMaybe<Array<InterventionMainItemConnectionWhere>>;
	OR?: InputMaybe<Array<InterventionMainItemConnectionWhere>>;
	edge?: InputMaybe<InterventionTreatmentRelationshipWhere>;
	edge_NOT?: InputMaybe<InterventionTreatmentRelationshipWhere>;
	node?: InputMaybe<TreatmentWhere>;
	node_NOT?: InputMaybe<TreatmentWhere>;
};

export type InterventionMainItemCreateFieldInput = {
	edge?: InputMaybe<InterventionTreatmentRelationshipCreateInput>;
	node: TreatmentCreateInput;
};

export type InterventionMainItemDeleteFieldInput = {
	delete?: InputMaybe<TreatmentDeleteInput>;
	where?: InputMaybe<InterventionMainItemConnectionWhere>;
};

export type InterventionMainItemDisconnectFieldInput = {
	disconnect?: InputMaybe<TreatmentDisconnectInput>;
	where?: InputMaybe<InterventionMainItemConnectionWhere>;
};

export type InterventionMainItemEdgeAggregationWhereInput = {
	AND?: InputMaybe<Array<InterventionMainItemEdgeAggregationWhereInput>>;
	LOT_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	LOT_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	LOT_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	LOT_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	LOT_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	LOT_EQUAL?: InputMaybe<Scalars["String"]>;
	LOT_GT?: InputMaybe<Scalars["Int"]>;
	LOT_GTE?: InputMaybe<Scalars["Int"]>;
	LOT_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	LOT_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	LOT_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	LOT_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	LOT_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	LOT_LT?: InputMaybe<Scalars["Int"]>;
	LOT_LTE?: InputMaybe<Scalars["Int"]>;
	LOT_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	LOT_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	LOT_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	LOT_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	LOT_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	OR?: InputMaybe<Array<InterventionMainItemEdgeAggregationWhereInput>>;
	REF_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	REF_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	REF_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	REF_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	REF_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	REF_EQUAL?: InputMaybe<Scalars["String"]>;
	REF_GT?: InputMaybe<Scalars["Int"]>;
	REF_GTE?: InputMaybe<Scalars["Int"]>;
	REF_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	REF_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	REF_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	REF_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	REF_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	REF_LT?: InputMaybe<Scalars["Int"]>;
	REF_LTE?: InputMaybe<Scalars["Int"]>;
	REF_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	REF_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	REF_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	REF_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	REF_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type InterventionMainItemFieldInput = {
	connect?: InputMaybe<InterventionMainItemConnectFieldInput>;
	create?: InputMaybe<InterventionMainItemCreateFieldInput>;
};

export type InterventionMainItemNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<InterventionMainItemNodeAggregationWhereInput>>;
	BagDossierNo_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	BagDossierNo_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	BagDossierNo_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	BagDossierNo_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	BagDossierNo_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	BagDossierNo_EQUAL?: InputMaybe<Scalars["String"]>;
	BagDossierNo_GT?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_GTE?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LT?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LTE?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	Code_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	Code_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	Code_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	Code_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	Code_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	Code_EQUAL?: InputMaybe<Scalars["String"]>;
	Code_GT?: InputMaybe<Scalars["Int"]>;
	Code_GTE?: InputMaybe<Scalars["Int"]>;
	Code_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Code_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	Code_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	Code_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	Code_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	Code_LT?: InputMaybe<Scalars["Int"]>;
	Code_LTE?: InputMaybe<Scalars["Int"]>;
	Code_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Code_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	Code_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	Code_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	Code_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	FlagModal_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	FlagModal_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	FlagModal_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	FlagModal_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	FlagModal_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	FlagModal_EQUAL?: InputMaybe<Scalars["String"]>;
	FlagModal_GT?: InputMaybe<Scalars["Int"]>;
	FlagModal_GTE?: InputMaybe<Scalars["Int"]>;
	FlagModal_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	FlagModal_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	FlagModal_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	FlagModal_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	FlagModal_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	FlagModal_LT?: InputMaybe<Scalars["Int"]>;
	FlagModal_LTE?: InputMaybe<Scalars["Int"]>;
	FlagModal_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	FlagModal_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	FlagModal_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	FlagModal_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	FlagModal_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	FlagNarcosis_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	FlagNarcosis_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	FlagNarcosis_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	FlagNarcosis_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	FlagNarcosis_EQUAL?: InputMaybe<Scalars["String"]>;
	FlagNarcosis_GT?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_GTE?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LT?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LTE?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	GTIN_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	GTIN_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	GTIN_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	GTIN_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	GTIN_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	GTIN_EQUAL?: InputMaybe<Scalars["String"]>;
	GTIN_GT?: InputMaybe<Scalars["Int"]>;
	GTIN_GTE?: InputMaybe<Scalars["Int"]>;
	GTIN_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	GTIN_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	GTIN_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	GTIN_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	GTIN_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	GTIN_LT?: InputMaybe<Scalars["Int"]>;
	GTIN_LTE?: InputMaybe<Scalars["Int"]>;
	GTIN_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	GTIN_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	GTIN_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	GTIN_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	GTIN_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	LOT_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	LOT_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	LOT_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	LOT_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	LOT_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	LOT_EQUAL?: InputMaybe<Scalars["String"]>;
	LOT_GT?: InputMaybe<Scalars["Int"]>;
	LOT_GTE?: InputMaybe<Scalars["Int"]>;
	LOT_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	LOT_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	LOT_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	LOT_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	LOT_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	LOT_LT?: InputMaybe<Scalars["Int"]>;
	LOT_LTE?: InputMaybe<Scalars["Int"]>;
	LOT_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	LOT_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	LOT_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	LOT_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	LOT_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	Name_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	Name_EQUAL?: InputMaybe<Scalars["String"]>;
	Name_GT?: InputMaybe<Scalars["Int"]>;
	Name_GTE?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	Name_LT?: InputMaybe<Scalars["Int"]>;
	Name_LTE?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	OR?: InputMaybe<Array<InterventionMainItemNodeAggregationWhereInput>>;
	PharmaCode_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	PharmaCode_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	PharmaCode_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	PharmaCode_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	PharmaCode_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	PharmaCode_EQUAL?: InputMaybe<Scalars["String"]>;
	PharmaCode_GT?: InputMaybe<Scalars["Int"]>;
	PharmaCode_GTE?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LT?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LTE?: InputMaybe<Scalars["Int"]>;
	PharmaCode_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	PharmaCode_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	PharmaCode_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	PharmaCode_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	PharmaCode_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	PrevPharmacode_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	PrevPharmacode_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	PrevPharmacode_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	PrevPharmacode_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	PrevPharmacode_EQUAL?: InputMaybe<Scalars["String"]>;
	PrevPharmacode_GT?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_GTE?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LT?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LTE?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	REF_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	REF_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	REF_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	REF_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	REF_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	REF_EQUAL?: InputMaybe<Scalars["String"]>;
	REF_GT?: InputMaybe<Scalars["Int"]>;
	REF_GTE?: InputMaybe<Scalars["Int"]>;
	REF_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	REF_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	REF_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	REF_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	REF_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	REF_LT?: InputMaybe<Scalars["Int"]>;
	REF_LTE?: InputMaybe<Scalars["Int"]>;
	REF_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	REF_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	REF_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	REF_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	REF_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	SwissmedicCategory_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	SwissmedicCategory_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	SwissmedicCategory_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	SwissmedicCategory_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	SwissmedicCategory_EQUAL?: InputMaybe<Scalars["String"]>;
	SwissmedicCategory_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo8_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo8_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo8_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo8_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo8_EQUAL?: InputMaybe<Scalars["String"]>;
	SwissmedicNo8_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	UDI_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	UDI_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	UDI_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	UDI_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	UDI_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	UDI_EQUAL?: InputMaybe<Scalars["String"]>;
	UDI_GT?: InputMaybe<Scalars["Int"]>;
	UDI_GTE?: InputMaybe<Scalars["Int"]>;
	UDI_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	UDI_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	UDI_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	UDI_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	UDI_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	UDI_LT?: InputMaybe<Scalars["Int"]>;
	UDI_LTE?: InputMaybe<Scalars["Int"]>;
	UDI_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	UDI_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	UDI_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	UDI_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	UDI_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	classificationSystem_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	classificationSystem_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	classificationSystem_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	classificationSystem_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	classificationSystem_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	classificationSystem_EQUAL?: InputMaybe<Scalars["String"]>;
	classificationSystem_GT?: InputMaybe<Scalars["Int"]>;
	classificationSystem_GTE?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LT?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LTE?: InputMaybe<Scalars["Int"]>;
	classificationSystem_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	classificationSystem_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	classificationSystem_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	classificationSystem_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	classificationSystem_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type InterventionMainItemRelationship = InterventionTreatmentRelationship & {
	__typename?: "InterventionMainItemRelationship";
	LOT?: Maybe<Scalars["String"]>;
	REF?: Maybe<Scalars["String"]>;
	cursor: Scalars["String"];
	node: Treatment;
};

export enum InterventionOccurrence {
	FirstSurgeryDate = "FIRST_SURGERY_DATE",
}

export type InterventionOptions = {
	limit?: InputMaybe<Scalars["Int"]>;
	offset?: InputMaybe<Scalars["Int"]>;
	/** Specify one or more InterventionSort objects to sort Interventions by. The sorts will be applied in the order in which they are arranged in the array. */
	sort?: InputMaybe<Array<InputMaybe<InterventionSort>>>;
};

export type InterventionPatientAggregateInput = {
	AND?: InputMaybe<Array<InterventionPatientAggregateInput>>;
	OR?: InputMaybe<Array<InterventionPatientAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<InterventionPatientNodeAggregationWhereInput>;
};

export type InterventionPatientConnectFieldInput = {
	connect?: InputMaybe<PatientConnectInput>;
	where?: InputMaybe<PatientConnectWhere>;
};

export type InterventionPatientConnection = {
	__typename?: "InterventionPatientConnection";
	edges: Array<InterventionPatientRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type InterventionPatientConnectionSort = {
	node?: InputMaybe<PatientSort>;
};

export type InterventionPatientConnectionWhere = {
	AND?: InputMaybe<Array<InterventionPatientConnectionWhere>>;
	OR?: InputMaybe<Array<InterventionPatientConnectionWhere>>;
	node?: InputMaybe<PatientWhere>;
	node_NOT?: InputMaybe<PatientWhere>;
};

export type InterventionPatientCreateFieldInput = {
	node: PatientCreateInput;
};

export type InterventionPatientDeleteFieldInput = {
	delete?: InputMaybe<PatientDeleteInput>;
	where?: InputMaybe<InterventionPatientConnectionWhere>;
};

export type InterventionPatientDisconnectFieldInput = {
	disconnect?: InputMaybe<PatientDisconnectInput>;
	where?: InputMaybe<InterventionPatientConnectionWhere>;
};

export type InterventionPatientFieldInput = {
	connect?: InputMaybe<InterventionPatientConnectFieldInput>;
	create?: InputMaybe<InterventionPatientCreateFieldInput>;
};

export type InterventionPatientNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<InterventionPatientNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<InterventionPatientNodeAggregationWhereInput>>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	initials_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	initials_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	initials_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	initials_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	initials_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	initials_EQUAL?: InputMaybe<Scalars["String"]>;
	initials_GT?: InputMaybe<Scalars["Int"]>;
	initials_GTE?: InputMaybe<Scalars["Int"]>;
	initials_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	initials_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	initials_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	initials_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	initials_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	initials_LT?: InputMaybe<Scalars["Int"]>;
	initials_LTE?: InputMaybe<Scalars["Int"]>;
	initials_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	initials_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	initials_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	initials_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	initials_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	insuranceId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	insuranceId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	insuranceId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	insuranceId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	insuranceId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	insuranceId_EQUAL?: InputMaybe<Scalars["String"]>;
	insuranceId_GT?: InputMaybe<Scalars["Int"]>;
	insuranceId_GTE?: InputMaybe<Scalars["Int"]>;
	insuranceId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	insuranceId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	insuranceId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	insuranceId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	insuranceId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	insuranceId_LT?: InputMaybe<Scalars["Int"]>;
	insuranceId_LTE?: InputMaybe<Scalars["Int"]>;
	insuranceId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	insuranceId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	insuranceId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	insuranceId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	insuranceId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	tenantId_EQUAL?: InputMaybe<Scalars["String"]>;
	tenantId_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	timeStamp_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	timeStamp_GT?: InputMaybe<Scalars["DateTime"]>;
	timeStamp_GTE?: InputMaybe<Scalars["DateTime"]>;
	timeStamp_LT?: InputMaybe<Scalars["DateTime"]>;
	timeStamp_LTE?: InputMaybe<Scalars["DateTime"]>;
	timeStamp_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	timeStamp_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	timeStamp_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	timeStamp_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	timeStamp_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	timeStamp_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	timeStamp_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	timeStamp_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	timeStamp_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	timeStamp_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	yearOfBirth_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	yearOfBirth_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	yearOfBirth_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	yearOfBirth_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	yearOfBirth_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	yearOfBirth_EQUAL?: InputMaybe<Scalars["Int"]>;
	yearOfBirth_GT?: InputMaybe<Scalars["Int"]>;
	yearOfBirth_GTE?: InputMaybe<Scalars["Int"]>;
	yearOfBirth_LT?: InputMaybe<Scalars["Int"]>;
	yearOfBirth_LTE?: InputMaybe<Scalars["Int"]>;
	yearOfBirth_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	yearOfBirth_MAX_GT?: InputMaybe<Scalars["Int"]>;
	yearOfBirth_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	yearOfBirth_MAX_LT?: InputMaybe<Scalars["Int"]>;
	yearOfBirth_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	yearOfBirth_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	yearOfBirth_MIN_GT?: InputMaybe<Scalars["Int"]>;
	yearOfBirth_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	yearOfBirth_MIN_LT?: InputMaybe<Scalars["Int"]>;
	yearOfBirth_MIN_LTE?: InputMaybe<Scalars["Int"]>;
};

export type InterventionPatientRelationship = {
	__typename?: "InterventionPatientRelationship";
	cursor: Scalars["String"];
	node: Patient;
};

export type InterventionReportStatusResponse = GqlBaseResponse & {
	__typename?: "InterventionReportStatusResponse";
	message?: Maybe<Scalars["String"]>;
	responseStatus?: Maybe<GqlResponseStatus>;
};

export type InterventionReportStatusResponseAggregateSelection = {
	__typename?: "InterventionReportStatusResponseAggregateSelection";
	count: Scalars["Int"];
	message: StringAggregateSelection;
};

export type InterventionReportStatusResponseOptions = {
	limit?: InputMaybe<Scalars["Int"]>;
	offset?: InputMaybe<Scalars["Int"]>;
	/** Specify one or more InterventionReportStatusResponseSort objects to sort InterventionReportStatusResponses by. The sorts will be applied in the order in which they are arranged in the array. */
	sort?: InputMaybe<Array<InputMaybe<InterventionReportStatusResponseSort>>>;
};

/** Fields to sort InterventionReportStatusResponses by. The order in which sorts are applied is not guaranteed when specifying many fields in one InterventionReportStatusResponseSort object. */
export type InterventionReportStatusResponseSort = {
	message?: InputMaybe<SortDirection>;
	responseStatus?: InputMaybe<SortDirection>;
};

export type InterventionReportStatusResponseWhere = {
	AND?: InputMaybe<Array<InterventionReportStatusResponseWhere>>;
	OR?: InputMaybe<Array<InterventionReportStatusResponseWhere>>;
	message?: InputMaybe<Scalars["String"]>;
	message_CONTAINS?: InputMaybe<Scalars["String"]>;
	message_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	message_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	message_MATCHES?: InputMaybe<Scalars["String"]>;
	message_NOT?: InputMaybe<Scalars["String"]>;
	message_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	message_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	message_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	message_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	message_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	responseStatus?: InputMaybe<GqlResponseStatus>;
	responseStatus_IN?: InputMaybe<Array<InputMaybe<GqlResponseStatus>>>;
	responseStatus_NOT?: InputMaybe<GqlResponseStatus>;
	responseStatus_NOT_IN?: InputMaybe<Array<InputMaybe<GqlResponseStatus>>>;
};

export type InterventionReportStatusUpdateInput = {
	formId: Scalars["String"];
	reportStatus: RefundStatus;
};

/** Fields to sort Interventions by. The order in which sorts are applied is not guaranteed when specifying many fields in one InterventionSort object. */
export type InterventionSort = {
	LAPressure?: InputMaybe<SortDirection>;
	LAVolume?: InputMaybe<SortDirection>;
	createdOn?: InputMaybe<SortDirection>;
	firstAblationDate?: InputMaybe<SortDirection>;
	id?: InputMaybe<SortDirection>;
	isAdheringToCloseProtocol?: InputMaybe<SortDirection>;
	isArchived?: InputMaybe<SortDirection>;
	isCTILineAblated?: InputMaybe<SortDirection>;
	isDeletable?: InputMaybe<SortDirection>;
	isDeleted?: InputMaybe<SortDirection>;
	isLowVoltageZone?: InputMaybe<SortDirection>;
	isPrimary?: InputMaybe<SortDirection>;
	lastUpdatedOn?: InputMaybe<SortDirection>;
	programCoverEndDate?: InputMaybe<SortDirection>;
	recurrenceDate?: InputMaybe<SortDirection>;
	reportStatus?: InputMaybe<SortDirection>;
	responsiblePhysicianAlias?: InputMaybe<SortDirection>;
	secondAblationDate?: InputMaybe<SortDirection>;
	status?: InputMaybe<SortDirection>;
	submissionDate?: InputMaybe<SortDirection>;
	tenantId?: InputMaybe<SortDirection>;
};

export type InterventionSubsequentInterventionAggregateInput = {
	AND?: InputMaybe<Array<InterventionSubsequentInterventionAggregateInput>>;
	OR?: InputMaybe<Array<InterventionSubsequentInterventionAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<InterventionSubsequentInterventionNodeAggregationWhereInput>;
};

export type InterventionSubsequentInterventionConnectFieldInput = {
	connect?: InputMaybe<Array<InterventionConnectInput>>;
	where?: InputMaybe<InterventionConnectWhere>;
};

export type InterventionSubsequentInterventionConnection = {
	__typename?: "InterventionSubsequentInterventionConnection";
	edges: Array<InterventionSubsequentInterventionRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type InterventionSubsequentInterventionConnectionSort = {
	node?: InputMaybe<InterventionSort>;
};

export type InterventionSubsequentInterventionConnectionWhere = {
	AND?: InputMaybe<Array<InterventionSubsequentInterventionConnectionWhere>>;
	OR?: InputMaybe<Array<InterventionSubsequentInterventionConnectionWhere>>;
	node?: InputMaybe<InterventionWhere>;
	node_NOT?: InputMaybe<InterventionWhere>;
};

export type InterventionSubsequentInterventionCreateFieldInput = {
	node: InterventionCreateInput;
};

export type InterventionSubsequentInterventionDeleteFieldInput = {
	delete?: InputMaybe<InterventionDeleteInput>;
	where?: InputMaybe<InterventionSubsequentInterventionConnectionWhere>;
};

export type InterventionSubsequentInterventionDisconnectFieldInput = {
	disconnect?: InputMaybe<InterventionDisconnectInput>;
	where?: InputMaybe<InterventionSubsequentInterventionConnectionWhere>;
};

export type InterventionSubsequentInterventionFieldInput = {
	connect?: InputMaybe<Array<InterventionSubsequentInterventionConnectFieldInput>>;
	create?: InputMaybe<Array<InterventionSubsequentInterventionCreateFieldInput>>;
};

export type InterventionSubsequentInterventionNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<InterventionSubsequentInterventionNodeAggregationWhereInput>>;
	LAPressure_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	LAPressure_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	LAPressure_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	LAPressure_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	LAPressure_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	LAPressure_EQUAL?: InputMaybe<Scalars["Int"]>;
	LAPressure_GT?: InputMaybe<Scalars["Int"]>;
	LAPressure_GTE?: InputMaybe<Scalars["Int"]>;
	LAPressure_LT?: InputMaybe<Scalars["Int"]>;
	LAPressure_LTE?: InputMaybe<Scalars["Int"]>;
	LAPressure_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	LAPressure_MAX_GT?: InputMaybe<Scalars["Int"]>;
	LAPressure_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	LAPressure_MAX_LT?: InputMaybe<Scalars["Int"]>;
	LAPressure_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	LAPressure_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	LAPressure_MIN_GT?: InputMaybe<Scalars["Int"]>;
	LAPressure_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	LAPressure_MIN_LT?: InputMaybe<Scalars["Int"]>;
	LAPressure_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	LAVolume_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	LAVolume_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	LAVolume_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	LAVolume_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	LAVolume_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	LAVolume_EQUAL?: InputMaybe<Scalars["Int"]>;
	LAVolume_GT?: InputMaybe<Scalars["Int"]>;
	LAVolume_GTE?: InputMaybe<Scalars["Int"]>;
	LAVolume_LT?: InputMaybe<Scalars["Int"]>;
	LAVolume_LTE?: InputMaybe<Scalars["Int"]>;
	LAVolume_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	LAVolume_MAX_GT?: InputMaybe<Scalars["Int"]>;
	LAVolume_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	LAVolume_MAX_LT?: InputMaybe<Scalars["Int"]>;
	LAVolume_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	LAVolume_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	LAVolume_MIN_GT?: InputMaybe<Scalars["Int"]>;
	LAVolume_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	LAVolume_MIN_LT?: InputMaybe<Scalars["Int"]>;
	LAVolume_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	OR?: InputMaybe<Array<InterventionSubsequentInterventionNodeAggregationWhereInput>>;
	createdOn_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	lastUpdatedOn_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_GT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_LT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_GT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_GTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_LT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_LTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	tenantId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	tenantId_EQUAL?: InputMaybe<Scalars["String"]>;
	tenantId_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type InterventionSubsequentInterventionRelationship = {
	__typename?: "InterventionSubsequentInterventionRelationship";
	cursor: Scalars["String"];
	node: Intervention;
};

export type InterventionSupportingItemAggregateInput = {
	AND?: InputMaybe<Array<InterventionSupportingItemAggregateInput>>;
	OR?: InputMaybe<Array<InterventionSupportingItemAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	edge?: InputMaybe<InterventionSupportingItemEdgeAggregationWhereInput>;
	node?: InputMaybe<InterventionSupportingItemNodeAggregationWhereInput>;
};

export type InterventionSupportingItemConnectFieldInput = {
	connect?: InputMaybe<Array<TreatmentConnectInput>>;
	edge?: InputMaybe<InterventionTreatmentRelationshipCreateInput>;
	where?: InputMaybe<TreatmentConnectWhere>;
};

export type InterventionSupportingItemConnection = {
	__typename?: "InterventionSupportingItemConnection";
	edges: Array<InterventionSupportingItemRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type InterventionSupportingItemConnectionSort = {
	edge?: InputMaybe<InterventionTreatmentRelationshipSort>;
	node?: InputMaybe<TreatmentSort>;
};

export type InterventionSupportingItemConnectionWhere = {
	AND?: InputMaybe<Array<InterventionSupportingItemConnectionWhere>>;
	OR?: InputMaybe<Array<InterventionSupportingItemConnectionWhere>>;
	edge?: InputMaybe<InterventionTreatmentRelationshipWhere>;
	edge_NOT?: InputMaybe<InterventionTreatmentRelationshipWhere>;
	node?: InputMaybe<TreatmentWhere>;
	node_NOT?: InputMaybe<TreatmentWhere>;
};

export type InterventionSupportingItemCreateFieldInput = {
	edge?: InputMaybe<InterventionTreatmentRelationshipCreateInput>;
	node: TreatmentCreateInput;
};

export type InterventionSupportingItemDeleteFieldInput = {
	delete?: InputMaybe<TreatmentDeleteInput>;
	where?: InputMaybe<InterventionSupportingItemConnectionWhere>;
};

export type InterventionSupportingItemDisconnectFieldInput = {
	disconnect?: InputMaybe<TreatmentDisconnectInput>;
	where?: InputMaybe<InterventionSupportingItemConnectionWhere>;
};

export type InterventionSupportingItemEdgeAggregationWhereInput = {
	AND?: InputMaybe<Array<InterventionSupportingItemEdgeAggregationWhereInput>>;
	LOT_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	LOT_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	LOT_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	LOT_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	LOT_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	LOT_EQUAL?: InputMaybe<Scalars["String"]>;
	LOT_GT?: InputMaybe<Scalars["Int"]>;
	LOT_GTE?: InputMaybe<Scalars["Int"]>;
	LOT_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	LOT_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	LOT_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	LOT_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	LOT_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	LOT_LT?: InputMaybe<Scalars["Int"]>;
	LOT_LTE?: InputMaybe<Scalars["Int"]>;
	LOT_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	LOT_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	LOT_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	LOT_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	LOT_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	OR?: InputMaybe<Array<InterventionSupportingItemEdgeAggregationWhereInput>>;
	REF_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	REF_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	REF_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	REF_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	REF_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	REF_EQUAL?: InputMaybe<Scalars["String"]>;
	REF_GT?: InputMaybe<Scalars["Int"]>;
	REF_GTE?: InputMaybe<Scalars["Int"]>;
	REF_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	REF_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	REF_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	REF_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	REF_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	REF_LT?: InputMaybe<Scalars["Int"]>;
	REF_LTE?: InputMaybe<Scalars["Int"]>;
	REF_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	REF_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	REF_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	REF_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	REF_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type InterventionSupportingItemFieldInput = {
	connect?: InputMaybe<Array<InterventionSupportingItemConnectFieldInput>>;
	create?: InputMaybe<Array<InterventionSupportingItemCreateFieldInput>>;
};

export type InterventionSupportingItemNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<InterventionSupportingItemNodeAggregationWhereInput>>;
	BagDossierNo_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	BagDossierNo_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	BagDossierNo_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	BagDossierNo_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	BagDossierNo_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	BagDossierNo_EQUAL?: InputMaybe<Scalars["String"]>;
	BagDossierNo_GT?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_GTE?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LT?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LTE?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	Code_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	Code_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	Code_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	Code_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	Code_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	Code_EQUAL?: InputMaybe<Scalars["String"]>;
	Code_GT?: InputMaybe<Scalars["Int"]>;
	Code_GTE?: InputMaybe<Scalars["Int"]>;
	Code_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Code_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	Code_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	Code_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	Code_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	Code_LT?: InputMaybe<Scalars["Int"]>;
	Code_LTE?: InputMaybe<Scalars["Int"]>;
	Code_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Code_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	Code_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	Code_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	Code_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	FlagModal_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	FlagModal_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	FlagModal_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	FlagModal_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	FlagModal_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	FlagModal_EQUAL?: InputMaybe<Scalars["String"]>;
	FlagModal_GT?: InputMaybe<Scalars["Int"]>;
	FlagModal_GTE?: InputMaybe<Scalars["Int"]>;
	FlagModal_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	FlagModal_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	FlagModal_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	FlagModal_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	FlagModal_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	FlagModal_LT?: InputMaybe<Scalars["Int"]>;
	FlagModal_LTE?: InputMaybe<Scalars["Int"]>;
	FlagModal_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	FlagModal_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	FlagModal_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	FlagModal_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	FlagModal_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	FlagNarcosis_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	FlagNarcosis_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	FlagNarcosis_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	FlagNarcosis_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	FlagNarcosis_EQUAL?: InputMaybe<Scalars["String"]>;
	FlagNarcosis_GT?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_GTE?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LT?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LTE?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	GTIN_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	GTIN_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	GTIN_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	GTIN_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	GTIN_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	GTIN_EQUAL?: InputMaybe<Scalars["String"]>;
	GTIN_GT?: InputMaybe<Scalars["Int"]>;
	GTIN_GTE?: InputMaybe<Scalars["Int"]>;
	GTIN_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	GTIN_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	GTIN_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	GTIN_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	GTIN_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	GTIN_LT?: InputMaybe<Scalars["Int"]>;
	GTIN_LTE?: InputMaybe<Scalars["Int"]>;
	GTIN_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	GTIN_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	GTIN_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	GTIN_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	GTIN_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	LOT_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	LOT_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	LOT_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	LOT_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	LOT_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	LOT_EQUAL?: InputMaybe<Scalars["String"]>;
	LOT_GT?: InputMaybe<Scalars["Int"]>;
	LOT_GTE?: InputMaybe<Scalars["Int"]>;
	LOT_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	LOT_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	LOT_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	LOT_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	LOT_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	LOT_LT?: InputMaybe<Scalars["Int"]>;
	LOT_LTE?: InputMaybe<Scalars["Int"]>;
	LOT_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	LOT_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	LOT_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	LOT_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	LOT_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	Name_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	Name_EQUAL?: InputMaybe<Scalars["String"]>;
	Name_GT?: InputMaybe<Scalars["Int"]>;
	Name_GTE?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	Name_LT?: InputMaybe<Scalars["Int"]>;
	Name_LTE?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	OR?: InputMaybe<Array<InterventionSupportingItemNodeAggregationWhereInput>>;
	PharmaCode_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	PharmaCode_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	PharmaCode_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	PharmaCode_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	PharmaCode_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	PharmaCode_EQUAL?: InputMaybe<Scalars["String"]>;
	PharmaCode_GT?: InputMaybe<Scalars["Int"]>;
	PharmaCode_GTE?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LT?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LTE?: InputMaybe<Scalars["Int"]>;
	PharmaCode_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	PharmaCode_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	PharmaCode_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	PharmaCode_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	PharmaCode_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	PrevPharmacode_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	PrevPharmacode_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	PrevPharmacode_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	PrevPharmacode_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	PrevPharmacode_EQUAL?: InputMaybe<Scalars["String"]>;
	PrevPharmacode_GT?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_GTE?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LT?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LTE?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	REF_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	REF_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	REF_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	REF_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	REF_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	REF_EQUAL?: InputMaybe<Scalars["String"]>;
	REF_GT?: InputMaybe<Scalars["Int"]>;
	REF_GTE?: InputMaybe<Scalars["Int"]>;
	REF_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	REF_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	REF_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	REF_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	REF_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	REF_LT?: InputMaybe<Scalars["Int"]>;
	REF_LTE?: InputMaybe<Scalars["Int"]>;
	REF_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	REF_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	REF_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	REF_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	REF_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	SwissmedicCategory_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	SwissmedicCategory_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	SwissmedicCategory_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	SwissmedicCategory_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	SwissmedicCategory_EQUAL?: InputMaybe<Scalars["String"]>;
	SwissmedicCategory_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo8_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo8_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo8_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo8_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo8_EQUAL?: InputMaybe<Scalars["String"]>;
	SwissmedicNo8_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	UDI_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	UDI_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	UDI_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	UDI_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	UDI_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	UDI_EQUAL?: InputMaybe<Scalars["String"]>;
	UDI_GT?: InputMaybe<Scalars["Int"]>;
	UDI_GTE?: InputMaybe<Scalars["Int"]>;
	UDI_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	UDI_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	UDI_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	UDI_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	UDI_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	UDI_LT?: InputMaybe<Scalars["Int"]>;
	UDI_LTE?: InputMaybe<Scalars["Int"]>;
	UDI_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	UDI_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	UDI_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	UDI_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	UDI_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	classificationSystem_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	classificationSystem_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	classificationSystem_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	classificationSystem_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	classificationSystem_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	classificationSystem_EQUAL?: InputMaybe<Scalars["String"]>;
	classificationSystem_GT?: InputMaybe<Scalars["Int"]>;
	classificationSystem_GTE?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LT?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LTE?: InputMaybe<Scalars["Int"]>;
	classificationSystem_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	classificationSystem_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	classificationSystem_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	classificationSystem_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	classificationSystem_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type InterventionSupportingItemRelationship = InterventionTreatmentRelationship & {
	__typename?: "InterventionSupportingItemRelationship";
	LOT?: Maybe<Scalars["String"]>;
	REF?: Maybe<Scalars["String"]>;
	cursor: Scalars["String"];
	node: Treatment;
};

export type InterventionTreatmentRelationship = {
	LOT?: Maybe<Scalars["String"]>;
	REF?: Maybe<Scalars["String"]>;
};

export type InterventionTreatmentRelationshipCreateInput = {
	LOT?: InputMaybe<Scalars["String"]>;
	REF?: InputMaybe<Scalars["String"]>;
};

export type InterventionTreatmentRelationshipSort = {
	LOT?: InputMaybe<SortDirection>;
	REF?: InputMaybe<SortDirection>;
};

export type InterventionTreatmentRelationshipWhere = {
	AND?: InputMaybe<Array<InterventionTreatmentRelationshipWhere>>;
	LOT?: InputMaybe<Scalars["String"]>;
	LOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	LOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	LOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	LOT_MATCHES?: InputMaybe<Scalars["String"]>;
	LOT_NOT?: InputMaybe<Scalars["String"]>;
	LOT_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	LOT_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	LOT_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	LOT_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	LOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	OR?: InputMaybe<Array<InterventionTreatmentRelationshipWhere>>;
	REF?: InputMaybe<Scalars["String"]>;
	REF_CONTAINS?: InputMaybe<Scalars["String"]>;
	REF_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	REF_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	REF_MATCHES?: InputMaybe<Scalars["String"]>;
	REF_NOT?: InputMaybe<Scalars["String"]>;
	REF_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	REF_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	REF_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	REF_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	REF_STARTS_WITH?: InputMaybe<Scalars["String"]>;
};

export enum InterventionType {
	RelatedToPaf = "RELATED_TO_PAF",
}

export type InterventionUpdateInput = {
	LAPressure?: InputMaybe<Scalars["Int"]>;
	LAVolume?: InputMaybe<Scalars["Int"]>;
	caseId?: InputMaybe<Scalars["ID"]>;
	diseaseCode?: InputMaybe<Scalars["String"]>;
	firstAblationDate?: InputMaybe<Scalars["DateTime"]>;
	formId: Scalars["ID"];
	isAdheringToCloseProtocol: Scalars["Boolean"];
	isCTILineAblated: Scalars["Boolean"];
	isLowVoltageZone: Scalars["Boolean"];
	isPrimary: Scalars["Boolean"];
	lastUpdatedOn?: InputMaybe<Scalars["Float"]>;
	mainItem?: InputMaybe<InterventionItemInput>;
	patientAlias: Scalars["String"];
	programCoverEndDate?: InputMaybe<Scalars["DateTime"]>;
	recurrenceDate?: InputMaybe<Scalars["DateTime"]>;
	responsiblePhysicianAlias: CaobPhysician;
	secondAblationDate?: InputMaybe<Scalars["DateTime"]>;
	status: FormStatus;
	submissionDate?: InputMaybe<Scalars["Float"]>;
	supportingItems?: InputMaybe<Array<InputMaybe<InterventionItemInput>>>;
};

export type InterventionWhere = {
	AND?: InputMaybe<Array<InterventionWhere>>;
	LAPressure?: InputMaybe<Scalars["Int"]>;
	LAPressure_GT?: InputMaybe<Scalars["Int"]>;
	LAPressure_GTE?: InputMaybe<Scalars["Int"]>;
	LAPressure_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	LAPressure_LT?: InputMaybe<Scalars["Int"]>;
	LAPressure_LTE?: InputMaybe<Scalars["Int"]>;
	LAPressure_NOT?: InputMaybe<Scalars["Int"]>;
	LAPressure_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	LAVolume?: InputMaybe<Scalars["Int"]>;
	LAVolume_GT?: InputMaybe<Scalars["Int"]>;
	LAVolume_GTE?: InputMaybe<Scalars["Int"]>;
	LAVolume_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	LAVolume_LT?: InputMaybe<Scalars["Int"]>;
	LAVolume_LTE?: InputMaybe<Scalars["Int"]>;
	LAVolume_NOT?: InputMaybe<Scalars["Int"]>;
	LAVolume_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	OR?: InputMaybe<Array<InterventionWhere>>;
	case?: InputMaybe<CaseWhere>;
	caseAggregate?: InputMaybe<InterventionCaseAggregateInput>;
	caseConnection?: InputMaybe<InterventionCaseConnectionWhere>;
	caseConnection_NOT?: InputMaybe<InterventionCaseConnectionWhere>;
	case_NOT?: InputMaybe<CaseWhere>;
	createdBy?: InputMaybe<UserWhere>;
	createdByAggregate?: InputMaybe<InterventionCreatedByAggregateInput>;
	createdByConnection?: InputMaybe<InterventionCreatedByConnectionWhere>;
	createdByConnection_NOT?: InputMaybe<InterventionCreatedByConnectionWhere>;
	createdBy_NOT?: InputMaybe<UserWhere>;
	createdOn?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_IN?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]>>>;
	createdOn_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_NOT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]>>>;
	disease?: InputMaybe<DiseaseWhere>;
	diseaseAggregate?: InputMaybe<InterventionDiseaseAggregateInput>;
	diseaseConnection?: InputMaybe<InterventionDiseaseConnectionWhere>;
	diseaseConnection_NOT?: InputMaybe<InterventionDiseaseConnectionWhere>;
	disease_NOT?: InputMaybe<DiseaseWhere>;
	financialDataPoints?: InputMaybe<FinancialDataPointWhere>;
	financialDataPointsAggregate?: InputMaybe<InterventionFinancialDataPointsAggregateInput>;
	financialDataPointsConnection?: InputMaybe<InterventionFinancialDataPointsConnectionWhere>;
	financialDataPointsConnection_NOT?: InputMaybe<InterventionFinancialDataPointsConnectionWhere>;
	financialDataPoints_NOT?: InputMaybe<FinancialDataPointWhere>;
	firstAblationDate?: InputMaybe<Scalars["Date"]>;
	firstAblationDate_GT?: InputMaybe<Scalars["Date"]>;
	firstAblationDate_GTE?: InputMaybe<Scalars["Date"]>;
	firstAblationDate_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
	firstAblationDate_LT?: InputMaybe<Scalars["Date"]>;
	firstAblationDate_LTE?: InputMaybe<Scalars["Date"]>;
	firstAblationDate_NOT?: InputMaybe<Scalars["Date"]>;
	firstAblationDate_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
	form?: InputMaybe<FormWhere>;
	formAggregate?: InputMaybe<InterventionFormAggregateInput>;
	formConnection?: InputMaybe<InterventionFormConnectionWhere>;
	formConnection_NOT?: InputMaybe<InterventionFormConnectionWhere>;
	form_NOT?: InputMaybe<FormWhere>;
	id?: InputMaybe<Scalars["ID"]>;
	id_CONTAINS?: InputMaybe<Scalars["ID"]>;
	id_ENDS_WITH?: InputMaybe<Scalars["ID"]>;
	id_IN?: InputMaybe<Array<InputMaybe<Scalars["ID"]>>>;
	id_MATCHES?: InputMaybe<Scalars["String"]>;
	id_NOT?: InputMaybe<Scalars["ID"]>;
	id_NOT_CONTAINS?: InputMaybe<Scalars["ID"]>;
	id_NOT_ENDS_WITH?: InputMaybe<Scalars["ID"]>;
	id_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["ID"]>>>;
	id_NOT_STARTS_WITH?: InputMaybe<Scalars["ID"]>;
	id_STARTS_WITH?: InputMaybe<Scalars["ID"]>;
	isAdheringToCloseProtocol?: InputMaybe<Scalars["Boolean"]>;
	isAdheringToCloseProtocol_NOT?: InputMaybe<Scalars["Boolean"]>;
	isArchived?: InputMaybe<Scalars["Boolean"]>;
	isArchived_NOT?: InputMaybe<Scalars["Boolean"]>;
	isCTILineAblated?: InputMaybe<Scalars["Boolean"]>;
	isCTILineAblated_NOT?: InputMaybe<Scalars["Boolean"]>;
	isDeletable?: InputMaybe<Scalars["Boolean"]>;
	isDeletable_NOT?: InputMaybe<Scalars["Boolean"]>;
	isDeleted?: InputMaybe<Scalars["Boolean"]>;
	isDeleted_NOT?: InputMaybe<Scalars["Boolean"]>;
	isLowVoltageZone?: InputMaybe<Scalars["Boolean"]>;
	isLowVoltageZone_NOT?: InputMaybe<Scalars["Boolean"]>;
	isPrimary?: InputMaybe<Scalars["Boolean"]>;
	isPrimary_NOT?: InputMaybe<Scalars["Boolean"]>;
	lastUpdatedOn?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_GT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_IN?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]>>>;
	lastUpdatedOn_LT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_NOT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]>>>;
	legalEntity?: InputMaybe<OrganizationWhere>;
	legalEntityAggregate?: InputMaybe<InterventionLegalEntityAggregateInput>;
	legalEntityConnection?: InputMaybe<InterventionLegalEntityConnectionWhere>;
	legalEntityConnection_NOT?: InputMaybe<InterventionLegalEntityConnectionWhere>;
	legalEntity_NOT?: InputMaybe<OrganizationWhere>;
	mainItem?: InputMaybe<TreatmentWhere>;
	mainItemAggregate?: InputMaybe<InterventionMainItemAggregateInput>;
	mainItemConnection?: InputMaybe<InterventionMainItemConnectionWhere>;
	mainItemConnection_NOT?: InputMaybe<InterventionMainItemConnectionWhere>;
	mainItem_NOT?: InputMaybe<TreatmentWhere>;
	patient?: InputMaybe<PatientWhere>;
	patientAggregate?: InputMaybe<InterventionPatientAggregateInput>;
	patientConnection?: InputMaybe<InterventionPatientConnectionWhere>;
	patientConnection_NOT?: InputMaybe<InterventionPatientConnectionWhere>;
	patient_NOT?: InputMaybe<PatientWhere>;
	programCoverEndDate?: InputMaybe<Scalars["Date"]>;
	programCoverEndDate_GT?: InputMaybe<Scalars["Date"]>;
	programCoverEndDate_GTE?: InputMaybe<Scalars["Date"]>;
	programCoverEndDate_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
	programCoverEndDate_LT?: InputMaybe<Scalars["Date"]>;
	programCoverEndDate_LTE?: InputMaybe<Scalars["Date"]>;
	programCoverEndDate_NOT?: InputMaybe<Scalars["Date"]>;
	programCoverEndDate_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
	recurrenceDate?: InputMaybe<Scalars["Date"]>;
	recurrenceDate_GT?: InputMaybe<Scalars["Date"]>;
	recurrenceDate_GTE?: InputMaybe<Scalars["Date"]>;
	recurrenceDate_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
	recurrenceDate_LT?: InputMaybe<Scalars["Date"]>;
	recurrenceDate_LTE?: InputMaybe<Scalars["Date"]>;
	recurrenceDate_NOT?: InputMaybe<Scalars["Date"]>;
	recurrenceDate_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
	reportStatus?: InputMaybe<RefundStatus>;
	reportStatus_IN?: InputMaybe<Array<InputMaybe<RefundStatus>>>;
	reportStatus_NOT?: InputMaybe<RefundStatus>;
	reportStatus_NOT_IN?: InputMaybe<Array<InputMaybe<RefundStatus>>>;
	responsiblePhysicianAlias?: InputMaybe<CaobPhysician>;
	responsiblePhysicianAlias_IN?: InputMaybe<Array<InputMaybe<CaobPhysician>>>;
	responsiblePhysicianAlias_NOT?: InputMaybe<CaobPhysician>;
	responsiblePhysicianAlias_NOT_IN?: InputMaybe<Array<InputMaybe<CaobPhysician>>>;
	secondAblationDate?: InputMaybe<Scalars["Date"]>;
	secondAblationDate_GT?: InputMaybe<Scalars["Date"]>;
	secondAblationDate_GTE?: InputMaybe<Scalars["Date"]>;
	secondAblationDate_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
	secondAblationDate_LT?: InputMaybe<Scalars["Date"]>;
	secondAblationDate_LTE?: InputMaybe<Scalars["Date"]>;
	secondAblationDate_NOT?: InputMaybe<Scalars["Date"]>;
	secondAblationDate_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
	status?: InputMaybe<FormStatus>;
	status_IN?: InputMaybe<Array<InputMaybe<FormStatus>>>;
	status_NOT?: InputMaybe<FormStatus>;
	status_NOT_IN?: InputMaybe<Array<InputMaybe<FormStatus>>>;
	submissionDate?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_GT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_GTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_IN?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]>>>;
	submissionDate_LT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_LTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_NOT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]>>>;
	subsequentIntervention?: InputMaybe<InterventionWhere>;
	subsequentInterventionAggregate?: InputMaybe<InterventionSubsequentInterventionAggregateInput>;
	subsequentInterventionConnection?: InputMaybe<InterventionSubsequentInterventionConnectionWhere>;
	subsequentInterventionConnection_NOT?: InputMaybe<InterventionSubsequentInterventionConnectionWhere>;
	subsequentIntervention_NOT?: InputMaybe<InterventionWhere>;
	supportingItem?: InputMaybe<TreatmentWhere>;
	supportingItemAggregate?: InputMaybe<InterventionSupportingItemAggregateInput>;
	supportingItemConnection?: InputMaybe<InterventionSupportingItemConnectionWhere>;
	supportingItemConnection_NOT?: InputMaybe<InterventionSupportingItemConnectionWhere>;
	supportingItem_NOT?: InputMaybe<TreatmentWhere>;
	tenantId?: InputMaybe<Scalars["String"]>;
	tenantId_CONTAINS?: InputMaybe<Scalars["String"]>;
	tenantId_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	tenantId_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	tenantId_MATCHES?: InputMaybe<Scalars["String"]>;
	tenantId_NOT?: InputMaybe<Scalars["String"]>;
	tenantId_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	tenantId_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	tenantId_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	tenantId_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	tenantId_STARTS_WITH?: InputMaybe<Scalars["String"]>;
};

export type InvoiceRefundFinancialDataPoint = {
	id: Scalars["Int"];
	status?: Maybe<FinancialDataPointStatus>;
};

export type InvoiceRefundFinancialDataPointCreateInput = {
	id: Scalars["Int"];
	status?: InputMaybe<FinancialDataPointStatus>;
};

export type InvoiceRefundFinancialDataPointSort = {
	id?: InputMaybe<SortDirection>;
	status?: InputMaybe<SortDirection>;
};

export type InvoiceRefundFinancialDataPointUpdateInput = {
	id?: InputMaybe<Scalars["Int"]>;
	status?: InputMaybe<FinancialDataPointStatus>;
};

export type InvoiceRefundFinancialDataPointWhere = {
	AND?: InputMaybe<Array<InvoiceRefundFinancialDataPointWhere>>;
	OR?: InputMaybe<Array<InvoiceRefundFinancialDataPointWhere>>;
	id?: InputMaybe<Scalars["Int"]>;
	id_GT?: InputMaybe<Scalars["Int"]>;
	id_GTE?: InputMaybe<Scalars["Int"]>;
	id_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	id_LT?: InputMaybe<Scalars["Int"]>;
	id_LTE?: InputMaybe<Scalars["Int"]>;
	id_NOT?: InputMaybe<Scalars["Int"]>;
	id_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	status?: InputMaybe<FinancialDataPointStatus>;
	status_IN?: InputMaybe<Array<InputMaybe<FinancialDataPointStatus>>>;
	status_NOT?: InputMaybe<FinancialDataPointStatus>;
	status_NOT_IN?: InputMaybe<Array<InputMaybe<FinancialDataPointStatus>>>;
};

export type IssueInvoiceWithoutReviewInput = {
	assignees?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	coveragePeriod?: InputMaybe<Scalars["String"]>;
	financialDataPoints: Array<FinancialDataPointInput>;
	invoiceAmount: Scalars["Int"];
	invoiceId: Scalars["ID"];
	invoiceStatus: DocumentStatus;
	operation?: InputMaybe<Scalars["String"]>;
};

export enum ItemScope {
	All = "ALL",
	Repetingitems = "REPETINGITEMS",
	Specific = "SPECIFIC",
}

export type ItemUsedDataPoint = {
	__typename?: "ItemUsedDataPoint";
	PICount: Scalars["Int"];
	SICount: Scalars["Int"];
	item: Scalars["String"];
	patientPopulation: ReportItemsUsedFilter;
};

export type ItemUsedDataPointAggregateSelection = {
	__typename?: "ItemUsedDataPointAggregateSelection";
	PICount: IntAggregateSelection;
	SICount: IntAggregateSelection;
	count: Scalars["Int"];
	item: StringAggregateSelection;
};

export type ItemUsedDataPointOptions = {
	limit?: InputMaybe<Scalars["Int"]>;
	offset?: InputMaybe<Scalars["Int"]>;
	/** Specify one or more ItemUsedDataPointSort objects to sort ItemUsedDataPoints by. The sorts will be applied in the order in which they are arranged in the array. */
	sort?: InputMaybe<Array<InputMaybe<ItemUsedDataPointSort>>>;
};

/** Fields to sort ItemUsedDataPoints by. The order in which sorts are applied is not guaranteed when specifying many fields in one ItemUsedDataPointSort object. */
export type ItemUsedDataPointSort = {
	PICount?: InputMaybe<SortDirection>;
	SICount?: InputMaybe<SortDirection>;
	item?: InputMaybe<SortDirection>;
	patientPopulation?: InputMaybe<SortDirection>;
};

export type ItemUsedDataPointWhere = {
	AND?: InputMaybe<Array<ItemUsedDataPointWhere>>;
	OR?: InputMaybe<Array<ItemUsedDataPointWhere>>;
	PICount?: InputMaybe<Scalars["Int"]>;
	PICount_GT?: InputMaybe<Scalars["Int"]>;
	PICount_GTE?: InputMaybe<Scalars["Int"]>;
	PICount_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	PICount_LT?: InputMaybe<Scalars["Int"]>;
	PICount_LTE?: InputMaybe<Scalars["Int"]>;
	PICount_NOT?: InputMaybe<Scalars["Int"]>;
	PICount_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	SICount?: InputMaybe<Scalars["Int"]>;
	SICount_GT?: InputMaybe<Scalars["Int"]>;
	SICount_GTE?: InputMaybe<Scalars["Int"]>;
	SICount_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	SICount_LT?: InputMaybe<Scalars["Int"]>;
	SICount_LTE?: InputMaybe<Scalars["Int"]>;
	SICount_NOT?: InputMaybe<Scalars["Int"]>;
	SICount_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	item?: InputMaybe<Scalars["String"]>;
	item_CONTAINS?: InputMaybe<Scalars["String"]>;
	item_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	item_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	item_MATCHES?: InputMaybe<Scalars["String"]>;
	item_NOT?: InputMaybe<Scalars["String"]>;
	item_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	item_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	item_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	item_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	item_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	patientPopulation?: InputMaybe<ReportItemsUsedFilter>;
	patientPopulation_IN?: InputMaybe<Array<InputMaybe<ReportItemsUsedFilter>>>;
	patientPopulation_NOT?: InputMaybe<ReportItemsUsedFilter>;
	patientPopulation_NOT_IN?: InputMaybe<Array<InputMaybe<ReportItemsUsedFilter>>>;
};

export type Limitation = {
	__typename?: "Limitation";
	Code?: Maybe<Scalars["String"]>;
	DescriptionDe?: Maybe<Scalars["String"]>;
	DescriptionEn?: Maybe<Scalars["String"]>;
	Niveau?: Maybe<Scalars["String"]>;
	Type?: Maybe<Scalars["String"]>;
	ValidFromDate?: Maybe<Scalars["Date"]>;
	ValidThruDate?: Maybe<Scalars["Date"]>;
	limitsPreparations: Array<Preparation>;
	limitsPreparationsConnection: LimitationLimitsPreparationsConnection;
	limitsTreatment: Array<Treatment>;
	limitsTreatmentConnection: LimitationLimitsTreatmentConnection;
	uuid: Scalars["ID"];
};

export type LimitationLimitsPreparationsArgs = {
	options?: InputMaybe<PreparationOptions>;
	where?: InputMaybe<PreparationWhere>;
};

export type LimitationLimitsPreparationsConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<LimitationLimitsPreparationsConnectionSort>>;
	where?: InputMaybe<LimitationLimitsPreparationsConnectionWhere>;
};

export type LimitationLimitsTreatmentArgs = {
	options?: InputMaybe<TreatmentOptions>;
	where?: InputMaybe<TreatmentWhere>;
};

export type LimitationLimitsTreatmentConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<LimitationLimitsTreatmentConnectionSort>>;
	where?: InputMaybe<LimitationLimitsTreatmentConnectionWhere>;
};

export type LimitationAggregateSelection = {
	__typename?: "LimitationAggregateSelection";
	Code: StringAggregateSelection;
	DescriptionDe: StringAggregateSelection;
	DescriptionEn: StringAggregateSelection;
	Niveau: StringAggregateSelection;
	Type: StringAggregateSelection;
	count: Scalars["Int"];
	uuid: IdAggregateSelection;
};

export type LimitationConnectInput = {
	limitsPreparations?: InputMaybe<Array<LimitationLimitsPreparationsConnectFieldInput>>;
	limitsTreatment?: InputMaybe<Array<LimitationLimitsTreatmentConnectFieldInput>>;
};

export type LimitationConnectWhere = {
	node: LimitationWhere;
};

export type LimitationCreateInput = {
	Code?: InputMaybe<Scalars["String"]>;
	DescriptionDe?: InputMaybe<Scalars["String"]>;
	DescriptionEn?: InputMaybe<Scalars["String"]>;
	Niveau?: InputMaybe<Scalars["String"]>;
	Type?: InputMaybe<Scalars["String"]>;
	ValidFromDate?: InputMaybe<Scalars["Date"]>;
	ValidThruDate?: InputMaybe<Scalars["Date"]>;
	limitsPreparations?: InputMaybe<LimitationLimitsPreparationsFieldInput>;
	limitsTreatment?: InputMaybe<LimitationLimitsTreatmentFieldInput>;
	uuid: Scalars["ID"];
};

export type LimitationDeleteInput = {
	limitsPreparations?: InputMaybe<Array<LimitationLimitsPreparationsDeleteFieldInput>>;
	limitsTreatment?: InputMaybe<Array<LimitationLimitsTreatmentDeleteFieldInput>>;
};

export type LimitationDisconnectInput = {
	limitsPreparations?: InputMaybe<Array<LimitationLimitsPreparationsDisconnectFieldInput>>;
	limitsTreatment?: InputMaybe<Array<LimitationLimitsTreatmentDisconnectFieldInput>>;
};

export type LimitationLimitsPreparationsAggregateInput = {
	AND?: InputMaybe<Array<LimitationLimitsPreparationsAggregateInput>>;
	OR?: InputMaybe<Array<LimitationLimitsPreparationsAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<LimitationLimitsPreparationsNodeAggregationWhereInput>;
};

export type LimitationLimitsPreparationsConnectFieldInput = {
	connect?: InputMaybe<Array<PreparationConnectInput>>;
	where?: InputMaybe<PreparationConnectWhere>;
};

export type LimitationLimitsPreparationsConnection = {
	__typename?: "LimitationLimitsPreparationsConnection";
	edges: Array<LimitationLimitsPreparationsRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type LimitationLimitsPreparationsConnectionSort = {
	node?: InputMaybe<PreparationSort>;
};

export type LimitationLimitsPreparationsConnectionWhere = {
	AND?: InputMaybe<Array<LimitationLimitsPreparationsConnectionWhere>>;
	OR?: InputMaybe<Array<LimitationLimitsPreparationsConnectionWhere>>;
	node?: InputMaybe<PreparationWhere>;
	node_NOT?: InputMaybe<PreparationWhere>;
};

export type LimitationLimitsPreparationsCreateFieldInput = {
	node: PreparationCreateInput;
};

export type LimitationLimitsPreparationsDeleteFieldInput = {
	delete?: InputMaybe<PreparationDeleteInput>;
	where?: InputMaybe<LimitationLimitsPreparationsConnectionWhere>;
};

export type LimitationLimitsPreparationsDisconnectFieldInput = {
	disconnect?: InputMaybe<PreparationDisconnectInput>;
	where?: InputMaybe<LimitationLimitsPreparationsConnectionWhere>;
};

export type LimitationLimitsPreparationsFieldInput = {
	connect?: InputMaybe<Array<LimitationLimitsPreparationsConnectFieldInput>>;
	create?: InputMaybe<Array<LimitationLimitsPreparationsCreateFieldInput>>;
};

export type LimitationLimitsPreparationsNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<LimitationLimitsPreparationsNodeAggregationWhereInput>>;
	AtcCode_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	AtcCode_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	AtcCode_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	AtcCode_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	AtcCode_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	AtcCode_EQUAL?: InputMaybe<Scalars["String"]>;
	AtcCode_GT?: InputMaybe<Scalars["Int"]>;
	AtcCode_GTE?: InputMaybe<Scalars["Int"]>;
	AtcCode_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	AtcCode_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	AtcCode_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	AtcCode_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	AtcCode_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	AtcCode_LT?: InputMaybe<Scalars["Int"]>;
	AtcCode_LTE?: InputMaybe<Scalars["Int"]>;
	AtcCode_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	AtcCode_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	AtcCode_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	AtcCode_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	AtcCode_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	BrandName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	BrandName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	BrandName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	BrandName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	BrandName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	BrandName_EQUAL?: InputMaybe<Scalars["String"]>;
	BrandName_GT?: InputMaybe<Scalars["Int"]>;
	BrandName_GTE?: InputMaybe<Scalars["Int"]>;
	BrandName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	BrandName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	BrandName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	BrandName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	BrandName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	BrandName_LT?: InputMaybe<Scalars["Int"]>;
	BrandName_LTE?: InputMaybe<Scalars["Int"]>;
	BrandName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	BrandName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	BrandName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	BrandName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	BrandName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	DescriptionDe_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	DescriptionDe_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	DescriptionDe_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	DescriptionDe_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	DescriptionDe_EQUAL?: InputMaybe<Scalars["String"]>;
	DescriptionDe_GT?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_GTE?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_LT?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_LTE?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	GenericName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	GenericName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	GenericName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	GenericName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	GenericName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	GenericName_EQUAL?: InputMaybe<Scalars["String"]>;
	GenericName_GT?: InputMaybe<Scalars["Int"]>;
	GenericName_GTE?: InputMaybe<Scalars["Int"]>;
	GenericName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	GenericName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	GenericName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	GenericName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	GenericName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	GenericName_LT?: InputMaybe<Scalars["Int"]>;
	GenericName_LTE?: InputMaybe<Scalars["Int"]>;
	GenericName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	GenericName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	GenericName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	GenericName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	GenericName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	OR?: InputMaybe<Array<LimitationLimitsPreparationsNodeAggregationWhereInput>>;
	SwissmedicNo5_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo5_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo5_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo5_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo5_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo5_EQUAL?: InputMaybe<Scalars["String"]>;
	SwissmedicNo5_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo5_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo5_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo5_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo5_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo5_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo5_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo5_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo5_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo5_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo5_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo5_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo5_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo5_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
};

export type LimitationLimitsPreparationsRelationship = {
	__typename?: "LimitationLimitsPreparationsRelationship";
	cursor: Scalars["String"];
	node: Preparation;
};

export type LimitationLimitsPreparationsUpdateConnectionInput = {
	node?: InputMaybe<PreparationUpdateInput>;
};

export type LimitationLimitsPreparationsUpdateFieldInput = {
	connect?: InputMaybe<Array<LimitationLimitsPreparationsConnectFieldInput>>;
	create?: InputMaybe<Array<LimitationLimitsPreparationsCreateFieldInput>>;
	delete?: InputMaybe<Array<LimitationLimitsPreparationsDeleteFieldInput>>;
	disconnect?: InputMaybe<Array<LimitationLimitsPreparationsDisconnectFieldInput>>;
	update?: InputMaybe<LimitationLimitsPreparationsUpdateConnectionInput>;
	where?: InputMaybe<LimitationLimitsPreparationsConnectionWhere>;
};

export type LimitationLimitsTreatmentAggregateInput = {
	AND?: InputMaybe<Array<LimitationLimitsTreatmentAggregateInput>>;
	OR?: InputMaybe<Array<LimitationLimitsTreatmentAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<LimitationLimitsTreatmentNodeAggregationWhereInput>;
};

export type LimitationLimitsTreatmentConnectFieldInput = {
	connect?: InputMaybe<Array<TreatmentConnectInput>>;
	where?: InputMaybe<TreatmentConnectWhere>;
};

export type LimitationLimitsTreatmentConnection = {
	__typename?: "LimitationLimitsTreatmentConnection";
	edges: Array<LimitationLimitsTreatmentRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type LimitationLimitsTreatmentConnectionSort = {
	node?: InputMaybe<TreatmentSort>;
};

export type LimitationLimitsTreatmentConnectionWhere = {
	AND?: InputMaybe<Array<LimitationLimitsTreatmentConnectionWhere>>;
	OR?: InputMaybe<Array<LimitationLimitsTreatmentConnectionWhere>>;
	node?: InputMaybe<TreatmentWhere>;
	node_NOT?: InputMaybe<TreatmentWhere>;
};

export type LimitationLimitsTreatmentCreateFieldInput = {
	node: TreatmentCreateInput;
};

export type LimitationLimitsTreatmentDeleteFieldInput = {
	delete?: InputMaybe<TreatmentDeleteInput>;
	where?: InputMaybe<LimitationLimitsTreatmentConnectionWhere>;
};

export type LimitationLimitsTreatmentDisconnectFieldInput = {
	disconnect?: InputMaybe<TreatmentDisconnectInput>;
	where?: InputMaybe<LimitationLimitsTreatmentConnectionWhere>;
};

export type LimitationLimitsTreatmentFieldInput = {
	connect?: InputMaybe<Array<LimitationLimitsTreatmentConnectFieldInput>>;
	create?: InputMaybe<Array<LimitationLimitsTreatmentCreateFieldInput>>;
};

export type LimitationLimitsTreatmentNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<LimitationLimitsTreatmentNodeAggregationWhereInput>>;
	BagDossierNo_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	BagDossierNo_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	BagDossierNo_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	BagDossierNo_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	BagDossierNo_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	BagDossierNo_EQUAL?: InputMaybe<Scalars["String"]>;
	BagDossierNo_GT?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_GTE?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LT?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LTE?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	Code_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	Code_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	Code_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	Code_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	Code_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	Code_EQUAL?: InputMaybe<Scalars["String"]>;
	Code_GT?: InputMaybe<Scalars["Int"]>;
	Code_GTE?: InputMaybe<Scalars["Int"]>;
	Code_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Code_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	Code_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	Code_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	Code_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	Code_LT?: InputMaybe<Scalars["Int"]>;
	Code_LTE?: InputMaybe<Scalars["Int"]>;
	Code_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Code_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	Code_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	Code_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	Code_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	FlagModal_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	FlagModal_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	FlagModal_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	FlagModal_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	FlagModal_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	FlagModal_EQUAL?: InputMaybe<Scalars["String"]>;
	FlagModal_GT?: InputMaybe<Scalars["Int"]>;
	FlagModal_GTE?: InputMaybe<Scalars["Int"]>;
	FlagModal_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	FlagModal_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	FlagModal_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	FlagModal_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	FlagModal_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	FlagModal_LT?: InputMaybe<Scalars["Int"]>;
	FlagModal_LTE?: InputMaybe<Scalars["Int"]>;
	FlagModal_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	FlagModal_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	FlagModal_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	FlagModal_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	FlagModal_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	FlagNarcosis_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	FlagNarcosis_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	FlagNarcosis_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	FlagNarcosis_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	FlagNarcosis_EQUAL?: InputMaybe<Scalars["String"]>;
	FlagNarcosis_GT?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_GTE?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LT?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LTE?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	GTIN_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	GTIN_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	GTIN_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	GTIN_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	GTIN_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	GTIN_EQUAL?: InputMaybe<Scalars["String"]>;
	GTIN_GT?: InputMaybe<Scalars["Int"]>;
	GTIN_GTE?: InputMaybe<Scalars["Int"]>;
	GTIN_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	GTIN_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	GTIN_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	GTIN_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	GTIN_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	GTIN_LT?: InputMaybe<Scalars["Int"]>;
	GTIN_LTE?: InputMaybe<Scalars["Int"]>;
	GTIN_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	GTIN_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	GTIN_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	GTIN_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	GTIN_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	LOT_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	LOT_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	LOT_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	LOT_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	LOT_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	LOT_EQUAL?: InputMaybe<Scalars["String"]>;
	LOT_GT?: InputMaybe<Scalars["Int"]>;
	LOT_GTE?: InputMaybe<Scalars["Int"]>;
	LOT_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	LOT_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	LOT_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	LOT_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	LOT_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	LOT_LT?: InputMaybe<Scalars["Int"]>;
	LOT_LTE?: InputMaybe<Scalars["Int"]>;
	LOT_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	LOT_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	LOT_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	LOT_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	LOT_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	Name_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	Name_EQUAL?: InputMaybe<Scalars["String"]>;
	Name_GT?: InputMaybe<Scalars["Int"]>;
	Name_GTE?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	Name_LT?: InputMaybe<Scalars["Int"]>;
	Name_LTE?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	OR?: InputMaybe<Array<LimitationLimitsTreatmentNodeAggregationWhereInput>>;
	PharmaCode_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	PharmaCode_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	PharmaCode_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	PharmaCode_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	PharmaCode_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	PharmaCode_EQUAL?: InputMaybe<Scalars["String"]>;
	PharmaCode_GT?: InputMaybe<Scalars["Int"]>;
	PharmaCode_GTE?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LT?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LTE?: InputMaybe<Scalars["Int"]>;
	PharmaCode_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	PharmaCode_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	PharmaCode_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	PharmaCode_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	PharmaCode_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	PrevPharmacode_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	PrevPharmacode_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	PrevPharmacode_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	PrevPharmacode_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	PrevPharmacode_EQUAL?: InputMaybe<Scalars["String"]>;
	PrevPharmacode_GT?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_GTE?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LT?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LTE?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	REF_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	REF_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	REF_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	REF_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	REF_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	REF_EQUAL?: InputMaybe<Scalars["String"]>;
	REF_GT?: InputMaybe<Scalars["Int"]>;
	REF_GTE?: InputMaybe<Scalars["Int"]>;
	REF_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	REF_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	REF_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	REF_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	REF_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	REF_LT?: InputMaybe<Scalars["Int"]>;
	REF_LTE?: InputMaybe<Scalars["Int"]>;
	REF_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	REF_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	REF_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	REF_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	REF_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	SwissmedicCategory_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	SwissmedicCategory_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	SwissmedicCategory_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	SwissmedicCategory_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	SwissmedicCategory_EQUAL?: InputMaybe<Scalars["String"]>;
	SwissmedicCategory_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo8_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo8_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo8_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo8_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo8_EQUAL?: InputMaybe<Scalars["String"]>;
	SwissmedicNo8_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	UDI_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	UDI_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	UDI_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	UDI_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	UDI_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	UDI_EQUAL?: InputMaybe<Scalars["String"]>;
	UDI_GT?: InputMaybe<Scalars["Int"]>;
	UDI_GTE?: InputMaybe<Scalars["Int"]>;
	UDI_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	UDI_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	UDI_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	UDI_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	UDI_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	UDI_LT?: InputMaybe<Scalars["Int"]>;
	UDI_LTE?: InputMaybe<Scalars["Int"]>;
	UDI_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	UDI_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	UDI_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	UDI_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	UDI_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	classificationSystem_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	classificationSystem_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	classificationSystem_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	classificationSystem_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	classificationSystem_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	classificationSystem_EQUAL?: InputMaybe<Scalars["String"]>;
	classificationSystem_GT?: InputMaybe<Scalars["Int"]>;
	classificationSystem_GTE?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LT?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LTE?: InputMaybe<Scalars["Int"]>;
	classificationSystem_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	classificationSystem_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	classificationSystem_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	classificationSystem_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	classificationSystem_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type LimitationLimitsTreatmentRelationship = {
	__typename?: "LimitationLimitsTreatmentRelationship";
	cursor: Scalars["String"];
	node: Treatment;
};

export type LimitationLimitsTreatmentUpdateConnectionInput = {
	node?: InputMaybe<TreatmentUpdateInput>;
};

export type LimitationLimitsTreatmentUpdateFieldInput = {
	connect?: InputMaybe<Array<LimitationLimitsTreatmentConnectFieldInput>>;
	create?: InputMaybe<Array<LimitationLimitsTreatmentCreateFieldInput>>;
	delete?: InputMaybe<Array<LimitationLimitsTreatmentDeleteFieldInput>>;
	disconnect?: InputMaybe<Array<LimitationLimitsTreatmentDisconnectFieldInput>>;
	update?: InputMaybe<LimitationLimitsTreatmentUpdateConnectionInput>;
	where?: InputMaybe<LimitationLimitsTreatmentConnectionWhere>;
};

export type LimitationOptions = {
	limit?: InputMaybe<Scalars["Int"]>;
	offset?: InputMaybe<Scalars["Int"]>;
	/** Specify one or more LimitationSort objects to sort Limitations by. The sorts will be applied in the order in which they are arranged in the array. */
	sort?: InputMaybe<Array<InputMaybe<LimitationSort>>>;
};

/** Fields to sort Limitations by. The order in which sorts are applied is not guaranteed when specifying many fields in one LimitationSort object. */
export type LimitationSort = {
	Code?: InputMaybe<SortDirection>;
	DescriptionDe?: InputMaybe<SortDirection>;
	DescriptionEn?: InputMaybe<SortDirection>;
	Niveau?: InputMaybe<SortDirection>;
	Type?: InputMaybe<SortDirection>;
	ValidFromDate?: InputMaybe<SortDirection>;
	ValidThruDate?: InputMaybe<SortDirection>;
	uuid?: InputMaybe<SortDirection>;
};

export type LimitationUpdateInput = {
	Code?: InputMaybe<Scalars["String"]>;
	DescriptionDe?: InputMaybe<Scalars["String"]>;
	DescriptionEn?: InputMaybe<Scalars["String"]>;
	Niveau?: InputMaybe<Scalars["String"]>;
	Type?: InputMaybe<Scalars["String"]>;
	ValidFromDate?: InputMaybe<Scalars["Date"]>;
	ValidThruDate?: InputMaybe<Scalars["Date"]>;
	limitsPreparations?: InputMaybe<Array<LimitationLimitsPreparationsUpdateFieldInput>>;
	limitsTreatment?: InputMaybe<Array<LimitationLimitsTreatmentUpdateFieldInput>>;
	uuid?: InputMaybe<Scalars["ID"]>;
};

export type LimitationWhere = {
	AND?: InputMaybe<Array<LimitationWhere>>;
	Code?: InputMaybe<Scalars["String"]>;
	Code_CONTAINS?: InputMaybe<Scalars["String"]>;
	Code_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	Code_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	Code_MATCHES?: InputMaybe<Scalars["String"]>;
	Code_NOT?: InputMaybe<Scalars["String"]>;
	Code_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	Code_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	Code_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	Code_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	Code_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	DescriptionDe?: InputMaybe<Scalars["String"]>;
	DescriptionDe_CONTAINS?: InputMaybe<Scalars["String"]>;
	DescriptionDe_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	DescriptionDe_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	DescriptionDe_MATCHES?: InputMaybe<Scalars["String"]>;
	DescriptionDe_NOT?: InputMaybe<Scalars["String"]>;
	DescriptionDe_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	DescriptionDe_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	DescriptionDe_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	DescriptionDe_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	DescriptionDe_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	DescriptionEn?: InputMaybe<Scalars["String"]>;
	DescriptionEn_CONTAINS?: InputMaybe<Scalars["String"]>;
	DescriptionEn_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	DescriptionEn_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	DescriptionEn_MATCHES?: InputMaybe<Scalars["String"]>;
	DescriptionEn_NOT?: InputMaybe<Scalars["String"]>;
	DescriptionEn_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	DescriptionEn_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	DescriptionEn_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	DescriptionEn_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	DescriptionEn_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	Niveau?: InputMaybe<Scalars["String"]>;
	Niveau_CONTAINS?: InputMaybe<Scalars["String"]>;
	Niveau_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	Niveau_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	Niveau_MATCHES?: InputMaybe<Scalars["String"]>;
	Niveau_NOT?: InputMaybe<Scalars["String"]>;
	Niveau_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	Niveau_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	Niveau_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	Niveau_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	Niveau_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	OR?: InputMaybe<Array<LimitationWhere>>;
	Type?: InputMaybe<Scalars["String"]>;
	Type_CONTAINS?: InputMaybe<Scalars["String"]>;
	Type_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	Type_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	Type_MATCHES?: InputMaybe<Scalars["String"]>;
	Type_NOT?: InputMaybe<Scalars["String"]>;
	Type_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	Type_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	Type_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	Type_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	Type_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	ValidFromDate?: InputMaybe<Scalars["Date"]>;
	ValidFromDate_GT?: InputMaybe<Scalars["Date"]>;
	ValidFromDate_GTE?: InputMaybe<Scalars["Date"]>;
	ValidFromDate_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
	ValidFromDate_LT?: InputMaybe<Scalars["Date"]>;
	ValidFromDate_LTE?: InputMaybe<Scalars["Date"]>;
	ValidFromDate_NOT?: InputMaybe<Scalars["Date"]>;
	ValidFromDate_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
	ValidThruDate?: InputMaybe<Scalars["Date"]>;
	ValidThruDate_GT?: InputMaybe<Scalars["Date"]>;
	ValidThruDate_GTE?: InputMaybe<Scalars["Date"]>;
	ValidThruDate_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
	ValidThruDate_LT?: InputMaybe<Scalars["Date"]>;
	ValidThruDate_LTE?: InputMaybe<Scalars["Date"]>;
	ValidThruDate_NOT?: InputMaybe<Scalars["Date"]>;
	ValidThruDate_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
	limitsPreparations?: InputMaybe<PreparationWhere>;
	limitsPreparationsAggregate?: InputMaybe<LimitationLimitsPreparationsAggregateInput>;
	limitsPreparationsConnection?: InputMaybe<LimitationLimitsPreparationsConnectionWhere>;
	limitsPreparationsConnection_NOT?: InputMaybe<LimitationLimitsPreparationsConnectionWhere>;
	limitsPreparations_NOT?: InputMaybe<PreparationWhere>;
	limitsTreatment?: InputMaybe<TreatmentWhere>;
	limitsTreatmentAggregate?: InputMaybe<LimitationLimitsTreatmentAggregateInput>;
	limitsTreatmentConnection?: InputMaybe<LimitationLimitsTreatmentConnectionWhere>;
	limitsTreatmentConnection_NOT?: InputMaybe<LimitationLimitsTreatmentConnectionWhere>;
	limitsTreatment_NOT?: InputMaybe<TreatmentWhere>;
	uuid?: InputMaybe<Scalars["ID"]>;
	uuid_CONTAINS?: InputMaybe<Scalars["ID"]>;
	uuid_ENDS_WITH?: InputMaybe<Scalars["ID"]>;
	uuid_IN?: InputMaybe<Array<InputMaybe<Scalars["ID"]>>>;
	uuid_MATCHES?: InputMaybe<Scalars["String"]>;
	uuid_NOT?: InputMaybe<Scalars["ID"]>;
	uuid_NOT_CONTAINS?: InputMaybe<Scalars["ID"]>;
	uuid_NOT_ENDS_WITH?: InputMaybe<Scalars["ID"]>;
	uuid_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["ID"]>>>;
	uuid_NOT_STARTS_WITH?: InputMaybe<Scalars["ID"]>;
	uuid_STARTS_WITH?: InputMaybe<Scalars["ID"]>;
};

export enum LogicalCondition {
	And = "AND",
	Or = "OR",
}

export type Message = {
	__typename?: "Message";
	content?: Maybe<Scalars["String"]>;
	createdOn?: Maybe<Scalars["Float"]>;
	mentions?: Maybe<Array<Maybe<User>>>;
	mentionsConnection: MessageMentionsConnection;
	refund: Refund;
	refundConnection: MessageRefundConnection;
	sentBy: User;
	sentByConnection: MessageSentByConnection;
	tenantIds: Array<Scalars["String"]>;
};

export type MessageMentionsArgs = {
	options?: InputMaybe<UserOptions>;
	where?: InputMaybe<UserWhere>;
};

export type MessageMentionsConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<MessageMentionsConnectionSort>>;
	where?: InputMaybe<MessageMentionsConnectionWhere>;
};

export type MessageRefundArgs = {
	options?: InputMaybe<RefundOptions>;
	where?: InputMaybe<RefundWhere>;
};

export type MessageRefundConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<MessageRefundConnectionSort>>;
	where?: InputMaybe<MessageRefundConnectionWhere>;
};

export type MessageSentByArgs = {
	options?: InputMaybe<UserOptions>;
	where?: InputMaybe<UserWhere>;
};

export type MessageSentByConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<MessageSentByConnectionSort>>;
	where?: InputMaybe<MessageSentByConnectionWhere>;
};

export type MessageAggregateSelection = {
	__typename?: "MessageAggregateSelection";
	content: StringAggregateSelection;
	count: Scalars["Int"];
	createdOn: FloatAggregateSelection;
};

export type MessageConnectInput = {
	mentions?: InputMaybe<Array<MessageMentionsConnectFieldInput>>;
	refund?: InputMaybe<MessageRefundConnectFieldInput>;
	sentBy?: InputMaybe<MessageSentByConnectFieldInput>;
};

export type MessageConnectWhere = {
	node: MessageWhere;
};

export type MessageCreateInput = {
	content?: InputMaybe<Scalars["String"]>;
	createdOn?: InputMaybe<Scalars["Float"]>;
	mentions?: InputMaybe<MessageMentionsFieldInput>;
	refund?: InputMaybe<MessageRefundFieldInput>;
	sentBy?: InputMaybe<MessageSentByFieldInput>;
	tenantIds: Array<Scalars["String"]>;
};

export type MessageDeleteInput = {
	mentions?: InputMaybe<Array<MessageMentionsDeleteFieldInput>>;
	refund?: InputMaybe<MessageRefundDeleteFieldInput>;
	sentBy?: InputMaybe<MessageSentByDeleteFieldInput>;
};

export type MessageDisconnectInput = {
	mentions?: InputMaybe<Array<MessageMentionsDisconnectFieldInput>>;
	refund?: InputMaybe<MessageRefundDisconnectFieldInput>;
	sentBy?: InputMaybe<MessageSentByDisconnectFieldInput>;
};

export type MessageMentionsAggregateInput = {
	AND?: InputMaybe<Array<MessageMentionsAggregateInput>>;
	OR?: InputMaybe<Array<MessageMentionsAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<MessageMentionsNodeAggregationWhereInput>;
};

export type MessageMentionsConnectFieldInput = {
	connect?: InputMaybe<Array<UserConnectInput>>;
	where?: InputMaybe<UserConnectWhere>;
};

export type MessageMentionsConnection = {
	__typename?: "MessageMentionsConnection";
	edges: Array<MessageMentionsRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type MessageMentionsConnectionSort = {
	node?: InputMaybe<UserSort>;
};

export type MessageMentionsConnectionWhere = {
	AND?: InputMaybe<Array<MessageMentionsConnectionWhere>>;
	OR?: InputMaybe<Array<MessageMentionsConnectionWhere>>;
	node?: InputMaybe<UserWhere>;
	node_NOT?: InputMaybe<UserWhere>;
};

export type MessageMentionsCreateFieldInput = {
	node: UserCreateInput;
};

export type MessageMentionsDeleteFieldInput = {
	delete?: InputMaybe<UserDeleteInput>;
	where?: InputMaybe<MessageMentionsConnectionWhere>;
};

export type MessageMentionsDisconnectFieldInput = {
	disconnect?: InputMaybe<UserDisconnectInput>;
	where?: InputMaybe<MessageMentionsConnectionWhere>;
};

export type MessageMentionsFieldInput = {
	connect?: InputMaybe<Array<MessageMentionsConnectFieldInput>>;
	create?: InputMaybe<Array<MessageMentionsCreateFieldInput>>;
};

export type MessageMentionsNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<MessageMentionsNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<MessageMentionsNodeAggregationWhereInput>>;
	email_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	email_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	email_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	email_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	email_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	email_EQUAL?: InputMaybe<Scalars["String"]>;
	email_GT?: InputMaybe<Scalars["Int"]>;
	email_GTE?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	email_LT?: InputMaybe<Scalars["Int"]>;
	email_LTE?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	firstName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	firstName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	firstName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	firstName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	firstName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	firstName_EQUAL?: InputMaybe<Scalars["String"]>;
	firstName_GT?: InputMaybe<Scalars["Int"]>;
	firstName_GTE?: InputMaybe<Scalars["Int"]>;
	firstName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	firstName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	firstName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	firstName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	firstName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	firstName_LT?: InputMaybe<Scalars["Int"]>;
	firstName_LTE?: InputMaybe<Scalars["Int"]>;
	firstName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	firstName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	firstName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	firstName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	firstName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	lastName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	lastName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	lastName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	lastName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	lastName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	lastName_EQUAL?: InputMaybe<Scalars["String"]>;
	lastName_GT?: InputMaybe<Scalars["Int"]>;
	lastName_GTE?: InputMaybe<Scalars["Int"]>;
	lastName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	lastName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	lastName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	lastName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	lastName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	lastName_LT?: InputMaybe<Scalars["Int"]>;
	lastName_LTE?: InputMaybe<Scalars["Int"]>;
	lastName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	lastName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	lastName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	lastName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	lastName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	preferredLanguage_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	preferredLanguage_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	preferredLanguage_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	preferredLanguage_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	preferredLanguage_EQUAL?: InputMaybe<Scalars["String"]>;
	preferredLanguage_GT?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_GTE?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LT?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LTE?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	tenantId_EQUAL?: InputMaybe<Scalars["String"]>;
	tenantId_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type MessageMentionsRelationship = {
	__typename?: "MessageMentionsRelationship";
	cursor: Scalars["String"];
	node: User;
};

export type MessageMentionsUpdateConnectionInput = {
	node?: InputMaybe<UserUpdateInput>;
};

export type MessageMentionsUpdateFieldInput = {
	connect?: InputMaybe<Array<MessageMentionsConnectFieldInput>>;
	create?: InputMaybe<Array<MessageMentionsCreateFieldInput>>;
	delete?: InputMaybe<Array<MessageMentionsDeleteFieldInput>>;
	disconnect?: InputMaybe<Array<MessageMentionsDisconnectFieldInput>>;
	update?: InputMaybe<MessageMentionsUpdateConnectionInput>;
	where?: InputMaybe<MessageMentionsConnectionWhere>;
};

export type MessageOptions = {
	limit?: InputMaybe<Scalars["Int"]>;
	offset?: InputMaybe<Scalars["Int"]>;
	/** Specify one or more MessageSort objects to sort Messages by. The sorts will be applied in the order in which they are arranged in the array. */
	sort?: InputMaybe<Array<InputMaybe<MessageSort>>>;
};

export type MessageRefundAggregateInput = {
	AND?: InputMaybe<Array<MessageRefundAggregateInput>>;
	OR?: InputMaybe<Array<MessageRefundAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<MessageRefundNodeAggregationWhereInput>;
};

export type MessageRefundConnectFieldInput = {
	connect?: InputMaybe<RefundConnectInput>;
	where?: InputMaybe<RefundConnectWhere>;
};

export type MessageRefundConnection = {
	__typename?: "MessageRefundConnection";
	edges: Array<MessageRefundRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type MessageRefundConnectionSort = {
	node?: InputMaybe<RefundSort>;
};

export type MessageRefundConnectionWhere = {
	AND?: InputMaybe<Array<MessageRefundConnectionWhere>>;
	OR?: InputMaybe<Array<MessageRefundConnectionWhere>>;
	node?: InputMaybe<RefundWhere>;
	node_NOT?: InputMaybe<RefundWhere>;
};

export type MessageRefundCreateFieldInput = {
	node: RefundCreateInput;
};

export type MessageRefundDeleteFieldInput = {
	delete?: InputMaybe<RefundDeleteInput>;
	where?: InputMaybe<MessageRefundConnectionWhere>;
};

export type MessageRefundDisconnectFieldInput = {
	disconnect?: InputMaybe<RefundDisconnectInput>;
	where?: InputMaybe<MessageRefundConnectionWhere>;
};

export type MessageRefundFieldInput = {
	connect?: InputMaybe<MessageRefundConnectFieldInput>;
	create?: InputMaybe<MessageRefundCreateFieldInput>;
};

export type MessageRefundNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<MessageRefundNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<MessageRefundNodeAggregationWhereInput>>;
	agreementName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	agreementName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	agreementName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	agreementName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	agreementName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	agreementName_EQUAL?: InputMaybe<Scalars["String"]>;
	agreementName_GT?: InputMaybe<Scalars["Int"]>;
	agreementName_GTE?: InputMaybe<Scalars["Int"]>;
	agreementName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	agreementName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	agreementName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	agreementName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	agreementName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	agreementName_LT?: InputMaybe<Scalars["Int"]>;
	agreementName_LTE?: InputMaybe<Scalars["Int"]>;
	agreementName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	agreementName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	agreementName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	agreementName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	agreementName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	amount_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	amount_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	amount_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	amount_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	amount_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	amount_EQUAL?: InputMaybe<Scalars["Float"]>;
	amount_GT?: InputMaybe<Scalars["Float"]>;
	amount_GTE?: InputMaybe<Scalars["Float"]>;
	amount_LT?: InputMaybe<Scalars["Float"]>;
	amount_LTE?: InputMaybe<Scalars["Float"]>;
	amount_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	amount_MAX_GT?: InputMaybe<Scalars["Float"]>;
	amount_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	amount_MAX_LT?: InputMaybe<Scalars["Float"]>;
	amount_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	amount_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	amount_MIN_GT?: InputMaybe<Scalars["Float"]>;
	amount_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	amount_MIN_LT?: InputMaybe<Scalars["Float"]>;
	amount_MIN_LTE?: InputMaybe<Scalars["Float"]>;
	caseId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	caseId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	caseId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	caseId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	caseId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	caseId_EQUAL?: InputMaybe<Scalars["String"]>;
	caseId_GT?: InputMaybe<Scalars["Int"]>;
	caseId_GTE?: InputMaybe<Scalars["Int"]>;
	caseId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	caseId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	caseId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	caseId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	caseId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	caseId_LT?: InputMaybe<Scalars["Int"]>;
	caseId_LTE?: InputMaybe<Scalars["Int"]>;
	caseId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	caseId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	caseId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	caseId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	caseId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	counterParties_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	counterParties_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	counterParties_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	counterParties_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	counterParties_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	counterParties_EQUAL?: InputMaybe<Scalars["String"]>;
	counterParties_GT?: InputMaybe<Scalars["Int"]>;
	counterParties_GTE?: InputMaybe<Scalars["Int"]>;
	counterParties_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	counterParties_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	counterParties_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	counterParties_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	counterParties_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	counterParties_LT?: InputMaybe<Scalars["Int"]>;
	counterParties_LTE?: InputMaybe<Scalars["Int"]>;
	counterParties_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	counterParties_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	counterParties_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	counterParties_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	counterParties_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	currency_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	currency_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	currency_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	currency_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	currency_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	currency_EQUAL?: InputMaybe<Scalars["String"]>;
	currency_GT?: InputMaybe<Scalars["Int"]>;
	currency_GTE?: InputMaybe<Scalars["Int"]>;
	currency_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	currency_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	currency_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	currency_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	currency_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	currency_LT?: InputMaybe<Scalars["Int"]>;
	currency_LTE?: InputMaybe<Scalars["Int"]>;
	currency_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	currency_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	currency_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	currency_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	currency_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	formattedTags_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	formattedTags_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	formattedTags_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	formattedTags_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	formattedTags_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	formattedTags_EQUAL?: InputMaybe<Scalars["String"]>;
	formattedTags_GT?: InputMaybe<Scalars["Int"]>;
	formattedTags_GTE?: InputMaybe<Scalars["Int"]>;
	formattedTags_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedTags_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedTags_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedTags_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedTags_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	formattedTags_LT?: InputMaybe<Scalars["Int"]>;
	formattedTags_LTE?: InputMaybe<Scalars["Int"]>;
	formattedTags_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedTags_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedTags_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedTags_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedTags_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	iin_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	iin_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	iin_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	iin_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	iin_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	iin_EQUAL?: InputMaybe<Scalars["String"]>;
	iin_GT?: InputMaybe<Scalars["Int"]>;
	iin_GTE?: InputMaybe<Scalars["Int"]>;
	iin_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	iin_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	iin_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	iin_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	iin_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	iin_LT?: InputMaybe<Scalars["Int"]>;
	iin_LTE?: InputMaybe<Scalars["Int"]>;
	iin_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	iin_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	iin_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	iin_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	iin_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	product_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	product_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	product_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	product_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	product_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	product_EQUAL?: InputMaybe<Scalars["String"]>;
	product_GT?: InputMaybe<Scalars["Int"]>;
	product_GTE?: InputMaybe<Scalars["Int"]>;
	product_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	product_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	product_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	product_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	product_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	product_LT?: InputMaybe<Scalars["Int"]>;
	product_LTE?: InputMaybe<Scalars["Int"]>;
	product_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	product_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	product_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	product_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	product_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	unlimited_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	unlimited_EQUAL?: InputMaybe<Scalars["Int"]>;
	unlimited_GT?: InputMaybe<Scalars["Int"]>;
	unlimited_GTE?: InputMaybe<Scalars["Int"]>;
	unlimited_LT?: InputMaybe<Scalars["Int"]>;
	unlimited_LTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_GT?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_LT?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_GT?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_LT?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_LTE?: InputMaybe<Scalars["Int"]>;
};

export type MessageRefundRelationship = {
	__typename?: "MessageRefundRelationship";
	cursor: Scalars["String"];
	node: Refund;
};

export type MessageRefundUpdateConnectionInput = {
	node?: InputMaybe<RefundUpdateInput>;
};

export type MessageRefundUpdateFieldInput = {
	connect?: InputMaybe<MessageRefundConnectFieldInput>;
	create?: InputMaybe<MessageRefundCreateFieldInput>;
	delete?: InputMaybe<MessageRefundDeleteFieldInput>;
	disconnect?: InputMaybe<MessageRefundDisconnectFieldInput>;
	update?: InputMaybe<MessageRefundUpdateConnectionInput>;
	where?: InputMaybe<MessageRefundConnectionWhere>;
};

export type MessageSentByAggregateInput = {
	AND?: InputMaybe<Array<MessageSentByAggregateInput>>;
	OR?: InputMaybe<Array<MessageSentByAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<MessageSentByNodeAggregationWhereInput>;
};

export type MessageSentByConnectFieldInput = {
	connect?: InputMaybe<UserConnectInput>;
	where?: InputMaybe<UserConnectWhere>;
};

export type MessageSentByConnection = {
	__typename?: "MessageSentByConnection";
	edges: Array<MessageSentByRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type MessageSentByConnectionSort = {
	node?: InputMaybe<UserSort>;
};

export type MessageSentByConnectionWhere = {
	AND?: InputMaybe<Array<MessageSentByConnectionWhere>>;
	OR?: InputMaybe<Array<MessageSentByConnectionWhere>>;
	node?: InputMaybe<UserWhere>;
	node_NOT?: InputMaybe<UserWhere>;
};

export type MessageSentByCreateFieldInput = {
	node: UserCreateInput;
};

export type MessageSentByDeleteFieldInput = {
	delete?: InputMaybe<UserDeleteInput>;
	where?: InputMaybe<MessageSentByConnectionWhere>;
};

export type MessageSentByDisconnectFieldInput = {
	disconnect?: InputMaybe<UserDisconnectInput>;
	where?: InputMaybe<MessageSentByConnectionWhere>;
};

export type MessageSentByFieldInput = {
	connect?: InputMaybe<MessageSentByConnectFieldInput>;
	create?: InputMaybe<MessageSentByCreateFieldInput>;
};

export type MessageSentByNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<MessageSentByNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<MessageSentByNodeAggregationWhereInput>>;
	email_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	email_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	email_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	email_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	email_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	email_EQUAL?: InputMaybe<Scalars["String"]>;
	email_GT?: InputMaybe<Scalars["Int"]>;
	email_GTE?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	email_LT?: InputMaybe<Scalars["Int"]>;
	email_LTE?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	firstName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	firstName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	firstName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	firstName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	firstName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	firstName_EQUAL?: InputMaybe<Scalars["String"]>;
	firstName_GT?: InputMaybe<Scalars["Int"]>;
	firstName_GTE?: InputMaybe<Scalars["Int"]>;
	firstName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	firstName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	firstName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	firstName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	firstName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	firstName_LT?: InputMaybe<Scalars["Int"]>;
	firstName_LTE?: InputMaybe<Scalars["Int"]>;
	firstName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	firstName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	firstName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	firstName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	firstName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	lastName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	lastName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	lastName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	lastName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	lastName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	lastName_EQUAL?: InputMaybe<Scalars["String"]>;
	lastName_GT?: InputMaybe<Scalars["Int"]>;
	lastName_GTE?: InputMaybe<Scalars["Int"]>;
	lastName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	lastName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	lastName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	lastName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	lastName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	lastName_LT?: InputMaybe<Scalars["Int"]>;
	lastName_LTE?: InputMaybe<Scalars["Int"]>;
	lastName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	lastName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	lastName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	lastName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	lastName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	preferredLanguage_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	preferredLanguage_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	preferredLanguage_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	preferredLanguage_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	preferredLanguage_EQUAL?: InputMaybe<Scalars["String"]>;
	preferredLanguage_GT?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_GTE?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LT?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LTE?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	tenantId_EQUAL?: InputMaybe<Scalars["String"]>;
	tenantId_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type MessageSentByRelationship = {
	__typename?: "MessageSentByRelationship";
	cursor: Scalars["String"];
	node: User;
};

export type MessageSentByUpdateConnectionInput = {
	node?: InputMaybe<UserUpdateInput>;
};

export type MessageSentByUpdateFieldInput = {
	connect?: InputMaybe<MessageSentByConnectFieldInput>;
	create?: InputMaybe<MessageSentByCreateFieldInput>;
	delete?: InputMaybe<MessageSentByDeleteFieldInput>;
	disconnect?: InputMaybe<MessageSentByDisconnectFieldInput>;
	update?: InputMaybe<MessageSentByUpdateConnectionInput>;
	where?: InputMaybe<MessageSentByConnectionWhere>;
};

/** Fields to sort Messages by. The order in which sorts are applied is not guaranteed when specifying many fields in one MessageSort object. */
export type MessageSort = {
	content?: InputMaybe<SortDirection>;
	createdOn?: InputMaybe<SortDirection>;
};

export type MessageUpdateInput = {
	content?: InputMaybe<Scalars["String"]>;
	createdOn?: InputMaybe<Scalars["Float"]>;
	mentions?: InputMaybe<Array<MessageMentionsUpdateFieldInput>>;
	refund?: InputMaybe<MessageRefundUpdateFieldInput>;
	sentBy?: InputMaybe<MessageSentByUpdateFieldInput>;
	tenantIds?: InputMaybe<Array<Scalars["String"]>>;
};

export type MessageWhere = {
	AND?: InputMaybe<Array<MessageWhere>>;
	OR?: InputMaybe<Array<MessageWhere>>;
	content?: InputMaybe<Scalars["String"]>;
	content_CONTAINS?: InputMaybe<Scalars["String"]>;
	content_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	content_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	content_MATCHES?: InputMaybe<Scalars["String"]>;
	content_NOT?: InputMaybe<Scalars["String"]>;
	content_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	content_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	content_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	content_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	content_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	createdOn?: InputMaybe<Scalars["Float"]>;
	createdOn_GT?: InputMaybe<Scalars["Float"]>;
	createdOn_GTE?: InputMaybe<Scalars["Float"]>;
	createdOn_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	createdOn_LT?: InputMaybe<Scalars["Float"]>;
	createdOn_LTE?: InputMaybe<Scalars["Float"]>;
	createdOn_NOT?: InputMaybe<Scalars["Float"]>;
	createdOn_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	mentions?: InputMaybe<UserWhere>;
	mentionsAggregate?: InputMaybe<MessageMentionsAggregateInput>;
	mentionsConnection?: InputMaybe<MessageMentionsConnectionWhere>;
	mentionsConnection_NOT?: InputMaybe<MessageMentionsConnectionWhere>;
	mentions_NOT?: InputMaybe<UserWhere>;
	refund?: InputMaybe<RefundWhere>;
	refundAggregate?: InputMaybe<MessageRefundAggregateInput>;
	refundConnection?: InputMaybe<MessageRefundConnectionWhere>;
	refundConnection_NOT?: InputMaybe<MessageRefundConnectionWhere>;
	refund_NOT?: InputMaybe<RefundWhere>;
	sentBy?: InputMaybe<UserWhere>;
	sentByAggregate?: InputMaybe<MessageSentByAggregateInput>;
	sentByConnection?: InputMaybe<MessageSentByConnectionWhere>;
	sentByConnection_NOT?: InputMaybe<MessageSentByConnectionWhere>;
	sentBy_NOT?: InputMaybe<UserWhere>;
	tenantIds?: InputMaybe<Array<Scalars["String"]>>;
	tenantIds_INCLUDES?: InputMaybe<Scalars["String"]>;
	tenantIds_NOT?: InputMaybe<Array<Scalars["String"]>>;
	tenantIds_NOT_INCLUDES?: InputMaybe<Scalars["String"]>;
};

export type MicroContent = {
	__typename?: "MicroContent";
	amount: Scalars["Int"];
	type: MicroContentType;
};

export type MicroContentAggregateSelection = {
	__typename?: "MicroContentAggregateSelection";
	amount: IntAggregateSelection;
	count: Scalars["Int"];
};

export type MicroContentOptions = {
	limit?: InputMaybe<Scalars["Int"]>;
	offset?: InputMaybe<Scalars["Int"]>;
	/** Specify one or more MicroContentSort objects to sort MicroContents by. The sorts will be applied in the order in which they are arranged in the array. */
	sort?: InputMaybe<Array<InputMaybe<MicroContentSort>>>;
};

/** Fields to sort MicroContents by. The order in which sorts are applied is not guaranteed when specifying many fields in one MicroContentSort object. */
export type MicroContentSort = {
	amount?: InputMaybe<SortDirection>;
	type?: InputMaybe<SortDirection>;
};

export enum MicroContentType {
	NewCases = "NEW_CASES",
	TherapyTrials = "THERAPY_TRIALS",
	TreatmentContinuation = "TREATMENT_CONTINUATION",
}

export type MicroContentWhere = {
	AND?: InputMaybe<Array<MicroContentWhere>>;
	OR?: InputMaybe<Array<MicroContentWhere>>;
	amount?: InputMaybe<Scalars["Int"]>;
	amount_GT?: InputMaybe<Scalars["Int"]>;
	amount_GTE?: InputMaybe<Scalars["Int"]>;
	amount_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	amount_LT?: InputMaybe<Scalars["Int"]>;
	amount_LTE?: InputMaybe<Scalars["Int"]>;
	amount_NOT?: InputMaybe<Scalars["Int"]>;
	amount_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	type?: InputMaybe<MicroContentType>;
	type_IN?: InputMaybe<Array<InputMaybe<MicroContentType>>>;
	type_NOT?: InputMaybe<MicroContentType>;
	type_NOT_IN?: InputMaybe<Array<InputMaybe<MicroContentType>>>;
};

export type Module = {
	__typename?: "Module";
	code: Scalars["String"];
	id: Scalars["Int"];
	name?: Maybe<Scalars["String"]>;
};

export type ModuleAggregateSelection = {
	__typename?: "ModuleAggregateSelection";
	code: StringAggregateSelection;
	count: Scalars["Int"];
	id: IntAggregateSelection;
	name: StringAggregateSelection;
};

export type ModuleInput = {
	code: Scalars["String"];
	id: Scalars["Int"];
	name?: InputMaybe<Scalars["String"]>;
};

export type ModuleOptions = {
	limit?: InputMaybe<Scalars["Int"]>;
	offset?: InputMaybe<Scalars["Int"]>;
	/** Specify one or more ModuleSort objects to sort Modules by. The sorts will be applied in the order in which they are arranged in the array. */
	sort?: InputMaybe<Array<InputMaybe<ModuleSort>>>;
};

/** Fields to sort Modules by. The order in which sorts are applied is not guaranteed when specifying many fields in one ModuleSort object. */
export type ModuleSort = {
	code?: InputMaybe<SortDirection>;
	id?: InputMaybe<SortDirection>;
	name?: InputMaybe<SortDirection>;
};

export type ModuleWhere = {
	AND?: InputMaybe<Array<ModuleWhere>>;
	OR?: InputMaybe<Array<ModuleWhere>>;
	code?: InputMaybe<Scalars["String"]>;
	code_CONTAINS?: InputMaybe<Scalars["String"]>;
	code_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	code_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	code_MATCHES?: InputMaybe<Scalars["String"]>;
	code_NOT?: InputMaybe<Scalars["String"]>;
	code_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	code_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	code_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	code_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	code_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	id?: InputMaybe<Scalars["Int"]>;
	id_GT?: InputMaybe<Scalars["Int"]>;
	id_GTE?: InputMaybe<Scalars["Int"]>;
	id_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	id_LT?: InputMaybe<Scalars["Int"]>;
	id_LTE?: InputMaybe<Scalars["Int"]>;
	id_NOT?: InputMaybe<Scalars["Int"]>;
	id_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	name?: InputMaybe<Scalars["String"]>;
	name_CONTAINS?: InputMaybe<Scalars["String"]>;
	name_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	name_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	name_MATCHES?: InputMaybe<Scalars["String"]>;
	name_NOT?: InputMaybe<Scalars["String"]>;
	name_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	name_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	name_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	name_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	name_STARTS_WITH?: InputMaybe<Scalars["String"]>;
};

export type Mutation = {
	__typename?: "Mutation";
	AddAgreementDecision?: Maybe<Scalars["Int"]>;
	AddContinuousBenefit?: Maybe<ContinuousBenefit>;
	AddCoverageRequest?: Maybe<CoverageRequest>;
	AddDiscontinuationNote?: Maybe<DiscontinuationNote>;
	AddInitialResponse?: Maybe<InitialResponse>;
	AddIntervention?: Maybe<Intervention>;
	AddModule?: Maybe<Scalars["Boolean"]>;
	AddUserSubscribed?: Maybe<Scalars["Int"]>;
	AddUserSubscribedNotifications?: Maybe<Array<Maybe<Scalars["Int"]>>>;
	AssignInvoiceToUser?: Maybe<Scalars["ID"]>;
	CancelTermination?: Maybe<Scalars["Int"]>;
	CreateInvoice?: Maybe<Scalars["ID"]>;
	CreateRefundThreadMessage?: Maybe<Message>;
	DeleteCoverageRequest?: Maybe<Scalars["Int"]>;
	DeleteDiscontinuationNote?: Maybe<Scalars["Int"]>;
	DeleteFlexEntity?: Maybe<Scalars["Int"]>;
	DeleteIntervention?: Maybe<Scalars["Int"]>;
	DeleteInvoice?: Maybe<Scalars["ID"]>;
	DeleteRefundThreadMessage?: Maybe<Scalars["Float"]>;
	ExecuteBaseAgreement?: Maybe<Scalars["Int"]>;
	ExecuteStobContract: ContractStatus;
	IssueInvoice?: Maybe<Scalars["ID"]>;
	IssueInvoiceWithoutReview?: Maybe<Scalars["ID"]>;
	ProcessWorkflowParticipantDecision?: Maybe<ContractStatus>;
	RecallToDraft?: Maybe<Scalars["ID"]>;
	RemoveModule?: Maybe<Scalars["Boolean"]>;
	RemoveUserSubscribed?: Maybe<Scalars["Int"]>;
	RemoveUserSubscribedNotifications?: Maybe<Array<Maybe<Scalars["Int"]>>>;
	RenewCaobAgreements?: Maybe<Scalars["Int"]>;
	SaveFlexEntity?: Maybe<FlexEntity>;
	SaveReviewedInvoice?: Maybe<Scalars["ID"]>;
	SendInvoiceForReview?: Maybe<Scalars["ID"]>;
	SetStepAmended?: Maybe<Scalars["Int"]>;
	StoreWorkflows?: Maybe<Scalars["Int"]>;
	UndoDeleteCoverageRequest?: Maybe<Scalars["Int"]>;
	UpdateAgreementAssignee?: Maybe<Array<Maybe<Scalars["Int"]>>>;
	UpdateAgreementUserRoles?: Maybe<Array<Maybe<Scalars["Int"]>>>;
	UpdateCaseAssignee?: Maybe<Case>;
	UpdateContinuousBenefit?: Maybe<ContinuousBenefit>;
	UpdateContractNotifications?: Maybe<Scalars["ID"]>;
	UpdateCoverageRequest?: Maybe<CoverageRequest>;
	UpdateCurrentUserPersonalInfo?: Maybe<UserPersonalInfo>;
	UpdateDefaultUserRole?: Maybe<Scalars["Boolean"]>;
	UpdateDiscontinuationNote?: Maybe<DiscontinuationNote>;
	UpdateInitialResponse?: Maybe<InitialResponse>;
	UpdateIntervention?: Maybe<Intervention>;
	UpdateInterventionReportStatus?: Maybe<InterventionReportStatusResponse>;
	UpdateScenarioInsightsUserContext?: Maybe<Scalars["Int"]>;
	UpdateStobBasicInfo?: Maybe<Scalars["ID"]>;
	UpdateStobDataGuidance?: Maybe<Scalars["ID"]>;
	UpdateStobEligibility?: Maybe<Scalars["ID"]>;
	UpdateStobMeasures?: Maybe<Scalars["ID"]>;
	UpdateStobPricing?: Maybe<Scalars["ID"]>;
	UpdateUserContextFiltersAgreements?: Maybe<Scalars["Int"]>;
	UpdateUserContextFiltersCases?: Maybe<Scalars["Int"]>;
	UpdateUserContextFiltersDataForms?: Maybe<Scalars["Int"]>;
	UpdateUserContextFiltersDataRecords?: Maybe<Scalars["Int"]>;
	UpdateUserContextFiltersDocuments?: Maybe<Scalars["Int"]>;
	UpdateUserContextFiltersRefunds?: Maybe<Scalars["Int"]>;
	UpdateUserRole?: Maybe<Scalars["Boolean"]>;
	UploadClaims?: Maybe<Scalars["Int"]>;
	UploadDeviceRecords?: Maybe<Scalars["Int"]>;
	createAdverseEventsOccurenceReports: CreateAdverseEventsOccurenceReportsMutationResponse;
	createInitialResponseReviewReports: CreateInitialResponseReviewReportsMutationResponse;
	createReasonOfTreatmentDiscontinuationReports: CreateReasonOfTreatmentDiscontinuationReportsMutationResponse;
	createUsers: CreateUsersMutationResponse;
	deleteAdverseEventsOccurenceReports: DeleteInfo;
	deleteInitialResponseReviewReports: DeleteInfo;
	deleteReasonOfTreatmentDiscontinuationReports: DeleteInfo;
	deleteUsers: DeleteInfo;
	updateAdverseEventsOccurenceReports: UpdateAdverseEventsOccurenceReportsMutationResponse;
	updateInitialResponseReviewReports: UpdateInitialResponseReviewReportsMutationResponse;
	updateReasonOfTreatmentDiscontinuationReports: UpdateReasonOfTreatmentDiscontinuationReportsMutationResponse;
	updateUsers: UpdateUsersMutationResponse;
};

export type MutationAddAgreementDecisionArgs = {
	input: AgreementDecisionInput;
};

export type MutationAddContinuousBenefitArgs = {
	request: ContinuousBenefitInput;
};

export type MutationAddCoverageRequestArgs = {
	input: CoverageRequestInput;
};

export type MutationAddDiscontinuationNoteArgs = {
	request: DiscontinuationNoteInput;
};

export type MutationAddInitialResponseArgs = {
	request: InitialResponseInput;
};

export type MutationAddInterventionArgs = {
	input?: InputMaybe<InterventionInput>;
};

export type MutationAddModuleArgs = {
	id: Scalars["String"];
	input?: InputMaybe<ModuleInput>;
};

export type MutationAddUserSubscribedArgs = {
	notificationId: Scalars["Int"];
	userId: Scalars["ID"];
};

export type MutationAddUserSubscribedNotificationsArgs = {
	notificationIds?: InputMaybe<Array<Scalars["Int"]>>;
	userId: Scalars["ID"];
};

export type MutationAssignInvoiceToUserArgs = {
	request?: InputMaybe<AssignInvoiceToUserInput>;
};

export type MutationCancelTerminationArgs = {
	contractAddress: Scalars["ID"];
};

export type MutationCreateInvoiceArgs = {
	request?: InputMaybe<Array<InputMaybe<Scalars["ID"]>>>;
};

export type MutationCreateRefundThreadMessageArgs = {
	req?: InputMaybe<CreateRefundThreadMessageInput>;
};

export type MutationDeleteCoverageRequestArgs = {
	id: Scalars["ID"];
};

export type MutationDeleteDiscontinuationNoteArgs = {
	id: Scalars["ID"];
};

export type MutationDeleteFlexEntityArgs = {
	id: Scalars["ID"];
};

export type MutationDeleteInterventionArgs = {
	id: Scalars["ID"];
	isPrimary: Scalars["Boolean"];
};

export type MutationDeleteInvoiceArgs = {
	request?: InputMaybe<DeleteInvoiceInput>;
};

export type MutationDeleteRefundThreadMessageArgs = {
	req?: InputMaybe<DeleteRefundThreadMessageInput>;
};

export type MutationExecuteBaseAgreementArgs = {
	executionDate?: InputMaybe<Scalars["String"]>;
	id: Scalars["ID"];
};

export type MutationExecuteStobContractArgs = {
	executionDate?: InputMaybe<Scalars["String"]>;
	id: Scalars["ID"];
};

export type MutationIssueInvoiceArgs = {
	request?: InputMaybe<SaveReviewedInvoiceInput>;
};

export type MutationIssueInvoiceWithoutReviewArgs = {
	request?: InputMaybe<IssueInvoiceWithoutReviewInput>;
};

export type MutationProcessWorkflowParticipantDecisionArgs = {
	request: WorkflowParticipantDecisionInput;
};

export type MutationRecallToDraftArgs = {
	request?: InputMaybe<RecallToDraftInput>;
};

export type MutationRemoveModuleArgs = {
	id: Scalars["String"];
	moduleId?: InputMaybe<Scalars["Int"]>;
};

export type MutationRemoveUserSubscribedArgs = {
	notificationId: Scalars["Int"];
	userId: Scalars["ID"];
};

export type MutationRemoveUserSubscribedNotificationsArgs = {
	notificationIds?: InputMaybe<Array<Scalars["Int"]>>;
	userId: Scalars["ID"];
};

export type MutationRenewCaobAgreementsArgs = {
	input?: InputMaybe<Array<CaobAgreementRenewalInput>>;
};

export type MutationSaveFlexEntityArgs = {
	data?: InputMaybe<Scalars["String"]>;
	id?: InputMaybe<Scalars["ID"]>;
	startingPointId?: InputMaybe<Scalars["ID"]>;
	status: FlexFormStatus;
	typeId: Scalars["ID"];
};

export type MutationSaveReviewedInvoiceArgs = {
	request?: InputMaybe<SaveReviewedInvoiceInput>;
};

export type MutationSendInvoiceForReviewArgs = {
	request?: InputMaybe<UpdateInvoiceForReviewInput>;
};

export type MutationSetStepAmendedArgs = {
	contractAddress: Scalars["ID"];
	part: ContractPartType;
};

export type MutationStoreWorkflowsArgs = {
	contractAddress: Scalars["String"];
	workflows: Array<ContractWorkflowInput>;
};

export type MutationUndoDeleteCoverageRequestArgs = {
	id: Scalars["ID"];
};

export type MutationUpdateAgreementAssigneeArgs = {
	agreementId: Scalars["String"];
	isAssignee: Scalars["Boolean"];
	userId: Scalars["String"];
};

export type MutationUpdateAgreementUserRolesArgs = {
	input?: InputMaybe<UserRoleRequestUpdateInput>;
};

export type MutationUpdateCaseAssigneeArgs = {
	req: UpdateCaseAssigneeInput;
};

export type MutationUpdateContinuousBenefitArgs = {
	request: ContinuousBenefitInput;
};

export type MutationUpdateContractNotificationsArgs = {
	request: ContractNotificationsInput;
};

export type MutationUpdateCoverageRequestArgs = {
	input: CoverageRequestUpdateInput;
};

export type MutationUpdateCurrentUserPersonalInfoArgs = {
	personalInfo?: InputMaybe<UserPersonalInfoInput>;
};

export type MutationUpdateDefaultUserRoleArgs = {
	input?: InputMaybe<DefaultUserRoleUpdateInput>;
};

export type MutationUpdateDiscontinuationNoteArgs = {
	request: DiscontinuationNoteInput;
};

export type MutationUpdateInitialResponseArgs = {
	request: InitialResponseInput;
};

export type MutationUpdateInterventionArgs = {
	input?: InputMaybe<InterventionUpdateInput>;
};

export type MutationUpdateInterventionReportStatusArgs = {
	input: InterventionReportStatusUpdateInput;
};

export type MutationUpdateScenarioInsightsUserContextArgs = {
	agreementId: Scalars["ID"];
	groups?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	input?: InputMaybe<ScenarioInsightsUserContextInput>;
	timeframeLabel?: InputMaybe<Scalars["String"]>;
};

export type MutationUpdateStobBasicInfoArgs = {
	request: StobContractBasicInfoInput;
};

export type MutationUpdateStobDataGuidanceArgs = {
	id: Scalars["ID"];
	request?: InputMaybe<Array<RecommendedFormInput>>;
};

export type MutationUpdateStobEligibilityArgs = {
	request: StobContractEligibilityInput;
};

export type MutationUpdateStobMeasuresArgs = {
	request: StobMeasuresInput;
};

export type MutationUpdateStobPricingArgs = {
	request: StobPricingInput;
};

export type MutationUpdateUserContextFiltersAgreementsArgs = {
	req?: InputMaybe<Scalars["String"]>;
};

export type MutationUpdateUserContextFiltersCasesArgs = {
	req?: InputMaybe<Scalars["String"]>;
};

export type MutationUpdateUserContextFiltersDataFormsArgs = {
	req?: InputMaybe<Scalars["String"]>;
};

export type MutationUpdateUserContextFiltersDataRecordsArgs = {
	req?: InputMaybe<Scalars["String"]>;
};

export type MutationUpdateUserContextFiltersDocumentsArgs = {
	req?: InputMaybe<Scalars["String"]>;
};

export type MutationUpdateUserContextFiltersRefundsArgs = {
	req?: InputMaybe<Scalars["String"]>;
};

export type MutationUpdateUserRoleArgs = {
	id: Scalars["String"];
	isAdmin?: InputMaybe<Scalars["Boolean"]>;
};

export type MutationUploadClaimsArgs = {
	claims?: InputMaybe<Array<InputMaybe<UploadClaimsInput>>>;
};

export type MutationUploadDeviceRecordsArgs = {
	records?: InputMaybe<Array<InputMaybe<UploadDeviceRecordsInput>>>;
};

export type MutationCreateAdverseEventsOccurenceReportsArgs = {
	input: Array<AdverseEventsOccurenceReportCreateInput>;
};

export type MutationCreateInitialResponseReviewReportsArgs = {
	input: Array<InitialResponseReviewReportCreateInput>;
};

export type MutationCreateReasonOfTreatmentDiscontinuationReportsArgs = {
	input: Array<ReasonOfTreatmentDiscontinuationReportCreateInput>;
};

export type MutationCreateUsersArgs = {
	input: Array<UserCreateInput>;
};

export type MutationDeleteAdverseEventsOccurenceReportsArgs = {
	where?: InputMaybe<AdverseEventsOccurenceReportWhere>;
};

export type MutationDeleteInitialResponseReviewReportsArgs = {
	where?: InputMaybe<InitialResponseReviewReportWhere>;
};

export type MutationDeleteReasonOfTreatmentDiscontinuationReportsArgs = {
	where?: InputMaybe<ReasonOfTreatmentDiscontinuationReportWhere>;
};

export type MutationDeleteUsersArgs = {
	delete?: InputMaybe<UserDeleteInput>;
	where?: InputMaybe<UserWhere>;
};

export type MutationUpdateAdverseEventsOccurenceReportsArgs = {
	update?: InputMaybe<AdverseEventsOccurenceReportUpdateInput>;
	where?: InputMaybe<AdverseEventsOccurenceReportWhere>;
};

export type MutationUpdateInitialResponseReviewReportsArgs = {
	update?: InputMaybe<InitialResponseReviewReportUpdateInput>;
	where?: InputMaybe<InitialResponseReviewReportWhere>;
};

export type MutationUpdateReasonOfTreatmentDiscontinuationReportsArgs = {
	update?: InputMaybe<ReasonOfTreatmentDiscontinuationReportUpdateInput>;
	where?: InputMaybe<ReasonOfTreatmentDiscontinuationReportWhere>;
};

export type MutationUpdateUsersArgs = {
	connect?: InputMaybe<UserConnectInput>;
	create?: InputMaybe<UserRelationInput>;
	delete?: InputMaybe<UserDeleteInput>;
	disconnect?: InputMaybe<UserDisconnectInput>;
	update?: InputMaybe<UserUpdateInput>;
	where?: InputMaybe<UserWhere>;
};

export type NetRevenueByOrganization = {
	__typename?: "NetRevenueByOrganization";
	name: Scalars["String"];
	netAmount: Scalars["Float"];
};

export type NetRevenueByOrganizationAggregateSelection = {
	__typename?: "NetRevenueByOrganizationAggregateSelection";
	count: Scalars["Int"];
	name: StringAggregateSelection;
	netAmount: FloatAggregateSelection;
};

export type NetRevenueByOrganizationOptions = {
	limit?: InputMaybe<Scalars["Int"]>;
	offset?: InputMaybe<Scalars["Int"]>;
	/** Specify one or more NetRevenueByOrganizationSort objects to sort NetRevenueByOrganizations by. The sorts will be applied in the order in which they are arranged in the array. */
	sort?: InputMaybe<Array<InputMaybe<NetRevenueByOrganizationSort>>>;
};

/** Fields to sort NetRevenueByOrganizations by. The order in which sorts are applied is not guaranteed when specifying many fields in one NetRevenueByOrganizationSort object. */
export type NetRevenueByOrganizationSort = {
	name?: InputMaybe<SortDirection>;
	netAmount?: InputMaybe<SortDirection>;
};

export type NetRevenueByOrganizationWhere = {
	AND?: InputMaybe<Array<NetRevenueByOrganizationWhere>>;
	OR?: InputMaybe<Array<NetRevenueByOrganizationWhere>>;
	name?: InputMaybe<Scalars["String"]>;
	name_CONTAINS?: InputMaybe<Scalars["String"]>;
	name_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	name_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	name_MATCHES?: InputMaybe<Scalars["String"]>;
	name_NOT?: InputMaybe<Scalars["String"]>;
	name_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	name_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	name_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	name_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	name_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	netAmount?: InputMaybe<Scalars["Float"]>;
	netAmount_GT?: InputMaybe<Scalars["Float"]>;
	netAmount_GTE?: InputMaybe<Scalars["Float"]>;
	netAmount_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	netAmount_LT?: InputMaybe<Scalars["Float"]>;
	netAmount_LTE?: InputMaybe<Scalars["Float"]>;
	netAmount_NOT?: InputMaybe<Scalars["Float"]>;
	netAmount_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
};

export type Notification = {
	__typename?: "Notification";
	due: Array<User>;
	dueConnection: NotificationDueConnection;
	id: Scalars["Int"];
	name: Scalars["String"];
	notified: Array<User>;
	notifiedConnection: NotificationNotifiedConnection;
	subscribed: Array<User>;
	subscribedConnection: NotificationSubscribedConnection;
	type: NotificationType;
};

export type NotificationDueArgs = {
	options?: InputMaybe<UserOptions>;
	where?: InputMaybe<UserWhere>;
};

export type NotificationDueConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<NotificationDueConnectionSort>>;
	where?: InputMaybe<NotificationDueConnectionWhere>;
};

export type NotificationNotifiedArgs = {
	options?: InputMaybe<UserOptions>;
	where?: InputMaybe<UserWhere>;
};

export type NotificationNotifiedConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<NotificationNotifiedConnectionSort>>;
	where?: InputMaybe<NotificationNotifiedConnectionWhere>;
};

export type NotificationSubscribedArgs = {
	options?: InputMaybe<UserOptions>;
	where?: InputMaybe<UserWhere>;
};

export type NotificationSubscribedConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<NotificationSubscribedConnectionSort>>;
	where?: InputMaybe<NotificationSubscribedConnectionWhere>;
};

export type NotificationAggregateSelection = {
	__typename?: "NotificationAggregateSelection";
	count: Scalars["Int"];
	id: IntAggregateSelection;
	name: StringAggregateSelection;
};

export type NotificationConnectInput = {
	due?: InputMaybe<Array<NotificationDueConnectFieldInput>>;
	notified?: InputMaybe<Array<NotificationNotifiedConnectFieldInput>>;
	subscribed?: InputMaybe<Array<NotificationSubscribedConnectFieldInput>>;
};

export type NotificationConnectWhere = {
	node: NotificationWhere;
};

export type NotificationCreateInput = {
	due?: InputMaybe<NotificationDueFieldInput>;
	id: Scalars["Int"];
	name: Scalars["String"];
	notified?: InputMaybe<NotificationNotifiedFieldInput>;
	subscribed?: InputMaybe<NotificationSubscribedFieldInput>;
	type: NotificationType;
};

export type NotificationDeleteInput = {
	due?: InputMaybe<Array<NotificationDueDeleteFieldInput>>;
	notified?: InputMaybe<Array<NotificationNotifiedDeleteFieldInput>>;
	subscribed?: InputMaybe<Array<NotificationSubscribedDeleteFieldInput>>;
};

export type NotificationDisconnectInput = {
	due?: InputMaybe<Array<NotificationDueDisconnectFieldInput>>;
	notified?: InputMaybe<Array<NotificationNotifiedDisconnectFieldInput>>;
	subscribed?: InputMaybe<Array<NotificationSubscribedDisconnectFieldInput>>;
};

export type NotificationDueAggregateInput = {
	AND?: InputMaybe<Array<NotificationDueAggregateInput>>;
	OR?: InputMaybe<Array<NotificationDueAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	edge?: InputMaybe<NotificationDueEdgeAggregationWhereInput>;
	node?: InputMaybe<NotificationDueNodeAggregationWhereInput>;
};

export type NotificationDueConnectFieldInput = {
	connect?: InputMaybe<Array<UserConnectInput>>;
	edge: SummaryNotificationDueCreateInput;
	where?: InputMaybe<UserConnectWhere>;
};

export type NotificationDueConnection = {
	__typename?: "NotificationDueConnection";
	edges: Array<NotificationDueRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type NotificationDueConnectionSort = {
	edge?: InputMaybe<SummaryNotificationDueSort>;
	node?: InputMaybe<UserSort>;
};

export type NotificationDueConnectionWhere = {
	AND?: InputMaybe<Array<NotificationDueConnectionWhere>>;
	OR?: InputMaybe<Array<NotificationDueConnectionWhere>>;
	edge?: InputMaybe<SummaryNotificationDueWhere>;
	edge_NOT?: InputMaybe<SummaryNotificationDueWhere>;
	node?: InputMaybe<UserWhere>;
	node_NOT?: InputMaybe<UserWhere>;
};

export type NotificationDueCreateFieldInput = {
	edge: SummaryNotificationDueCreateInput;
	node: UserCreateInput;
};

export type NotificationDueDeleteFieldInput = {
	delete?: InputMaybe<UserDeleteInput>;
	where?: InputMaybe<NotificationDueConnectionWhere>;
};

export type NotificationDueDisconnectFieldInput = {
	disconnect?: InputMaybe<UserDisconnectInput>;
	where?: InputMaybe<NotificationDueConnectionWhere>;
};

export type NotificationDueEdgeAggregationWhereInput = {
	AND?: InputMaybe<Array<NotificationDueEdgeAggregationWhereInput>>;
	OR?: InputMaybe<Array<NotificationDueEdgeAggregationWhereInput>>;
	message_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	message_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	message_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	message_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	message_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	message_EQUAL?: InputMaybe<Scalars["String"]>;
	message_GT?: InputMaybe<Scalars["Int"]>;
	message_GTE?: InputMaybe<Scalars["Int"]>;
	message_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	message_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	message_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	message_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	message_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	message_LT?: InputMaybe<Scalars["Int"]>;
	message_LTE?: InputMaybe<Scalars["Int"]>;
	message_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	message_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	message_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	message_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	message_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	timeStamp_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	timeStamp_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	timeStamp_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	timeStamp_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	timeStamp_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	timeStamp_EQUAL?: InputMaybe<Scalars["Float"]>;
	timeStamp_GT?: InputMaybe<Scalars["Float"]>;
	timeStamp_GTE?: InputMaybe<Scalars["Float"]>;
	timeStamp_LT?: InputMaybe<Scalars["Float"]>;
	timeStamp_LTE?: InputMaybe<Scalars["Float"]>;
	timeStamp_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	timeStamp_MAX_GT?: InputMaybe<Scalars["Float"]>;
	timeStamp_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	timeStamp_MAX_LT?: InputMaybe<Scalars["Float"]>;
	timeStamp_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	timeStamp_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	timeStamp_MIN_GT?: InputMaybe<Scalars["Float"]>;
	timeStamp_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	timeStamp_MIN_LT?: InputMaybe<Scalars["Float"]>;
	timeStamp_MIN_LTE?: InputMaybe<Scalars["Float"]>;
};

export type NotificationDueFieldInput = {
	connect?: InputMaybe<Array<NotificationDueConnectFieldInput>>;
	create?: InputMaybe<Array<NotificationDueCreateFieldInput>>;
};

export type NotificationDueNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<NotificationDueNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<NotificationDueNodeAggregationWhereInput>>;
	email_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	email_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	email_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	email_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	email_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	email_EQUAL?: InputMaybe<Scalars["String"]>;
	email_GT?: InputMaybe<Scalars["Int"]>;
	email_GTE?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	email_LT?: InputMaybe<Scalars["Int"]>;
	email_LTE?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	firstName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	firstName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	firstName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	firstName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	firstName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	firstName_EQUAL?: InputMaybe<Scalars["String"]>;
	firstName_GT?: InputMaybe<Scalars["Int"]>;
	firstName_GTE?: InputMaybe<Scalars["Int"]>;
	firstName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	firstName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	firstName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	firstName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	firstName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	firstName_LT?: InputMaybe<Scalars["Int"]>;
	firstName_LTE?: InputMaybe<Scalars["Int"]>;
	firstName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	firstName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	firstName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	firstName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	firstName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	lastName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	lastName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	lastName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	lastName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	lastName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	lastName_EQUAL?: InputMaybe<Scalars["String"]>;
	lastName_GT?: InputMaybe<Scalars["Int"]>;
	lastName_GTE?: InputMaybe<Scalars["Int"]>;
	lastName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	lastName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	lastName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	lastName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	lastName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	lastName_LT?: InputMaybe<Scalars["Int"]>;
	lastName_LTE?: InputMaybe<Scalars["Int"]>;
	lastName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	lastName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	lastName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	lastName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	lastName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	preferredLanguage_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	preferredLanguage_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	preferredLanguage_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	preferredLanguage_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	preferredLanguage_EQUAL?: InputMaybe<Scalars["String"]>;
	preferredLanguage_GT?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_GTE?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LT?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LTE?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	tenantId_EQUAL?: InputMaybe<Scalars["String"]>;
	tenantId_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type NotificationDueRelationship = SummaryNotificationDue & {
	__typename?: "NotificationDueRelationship";
	cursor: Scalars["String"];
	dueDate: Scalars["Date"];
	message: Scalars["String"];
	node: User;
	timeStamp: Scalars["Float"];
};

export type NotificationDueUpdateConnectionInput = {
	edge?: InputMaybe<SummaryNotificationDueUpdateInput>;
	node?: InputMaybe<UserUpdateInput>;
};

export type NotificationDueUpdateFieldInput = {
	connect?: InputMaybe<Array<NotificationDueConnectFieldInput>>;
	create?: InputMaybe<Array<NotificationDueCreateFieldInput>>;
	delete?: InputMaybe<Array<NotificationDueDeleteFieldInput>>;
	disconnect?: InputMaybe<Array<NotificationDueDisconnectFieldInput>>;
	update?: InputMaybe<NotificationDueUpdateConnectionInput>;
	where?: InputMaybe<NotificationDueConnectionWhere>;
};

export type NotificationNotifiedAggregateInput = {
	AND?: InputMaybe<Array<NotificationNotifiedAggregateInput>>;
	OR?: InputMaybe<Array<NotificationNotifiedAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	edge?: InputMaybe<NotificationNotifiedEdgeAggregationWhereInput>;
	node?: InputMaybe<NotificationNotifiedNodeAggregationWhereInput>;
};

export type NotificationNotifiedConnectFieldInput = {
	connect?: InputMaybe<Array<UserConnectInput>>;
	edge: UserNotificationRelationshipCreateInput;
	where?: InputMaybe<UserConnectWhere>;
};

export type NotificationNotifiedConnection = {
	__typename?: "NotificationNotifiedConnection";
	edges: Array<NotificationNotifiedRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type NotificationNotifiedConnectionSort = {
	edge?: InputMaybe<UserNotificationRelationshipSort>;
	node?: InputMaybe<UserSort>;
};

export type NotificationNotifiedConnectionWhere = {
	AND?: InputMaybe<Array<NotificationNotifiedConnectionWhere>>;
	OR?: InputMaybe<Array<NotificationNotifiedConnectionWhere>>;
	edge?: InputMaybe<UserNotificationRelationshipWhere>;
	edge_NOT?: InputMaybe<UserNotificationRelationshipWhere>;
	node?: InputMaybe<UserWhere>;
	node_NOT?: InputMaybe<UserWhere>;
};

export type NotificationNotifiedCreateFieldInput = {
	edge: UserNotificationRelationshipCreateInput;
	node: UserCreateInput;
};

export type NotificationNotifiedDeleteFieldInput = {
	delete?: InputMaybe<UserDeleteInput>;
	where?: InputMaybe<NotificationNotifiedConnectionWhere>;
};

export type NotificationNotifiedDisconnectFieldInput = {
	disconnect?: InputMaybe<UserDisconnectInput>;
	where?: InputMaybe<NotificationNotifiedConnectionWhere>;
};

export type NotificationNotifiedEdgeAggregationWhereInput = {
	AND?: InputMaybe<Array<NotificationNotifiedEdgeAggregationWhereInput>>;
	OR?: InputMaybe<Array<NotificationNotifiedEdgeAggregationWhereInput>>;
	data_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	data_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	data_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	data_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	data_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	data_EQUAL?: InputMaybe<Scalars["String"]>;
	data_GT?: InputMaybe<Scalars["Int"]>;
	data_GTE?: InputMaybe<Scalars["Int"]>;
	data_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	data_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	data_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	data_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	data_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	data_LT?: InputMaybe<Scalars["Int"]>;
	data_LTE?: InputMaybe<Scalars["Int"]>;
	data_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	data_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	data_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	data_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	data_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	message_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	message_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	message_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	message_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	message_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	message_EQUAL?: InputMaybe<Scalars["String"]>;
	message_GT?: InputMaybe<Scalars["Int"]>;
	message_GTE?: InputMaybe<Scalars["Int"]>;
	message_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	message_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	message_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	message_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	message_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	message_LT?: InputMaybe<Scalars["Int"]>;
	message_LTE?: InputMaybe<Scalars["Int"]>;
	message_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	message_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	message_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	message_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	message_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	timeStamp_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	timeStamp_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	timeStamp_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	timeStamp_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	timeStamp_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	timeStamp_EQUAL?: InputMaybe<Scalars["Float"]>;
	timeStamp_GT?: InputMaybe<Scalars["Float"]>;
	timeStamp_GTE?: InputMaybe<Scalars["Float"]>;
	timeStamp_LT?: InputMaybe<Scalars["Float"]>;
	timeStamp_LTE?: InputMaybe<Scalars["Float"]>;
	timeStamp_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	timeStamp_MAX_GT?: InputMaybe<Scalars["Float"]>;
	timeStamp_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	timeStamp_MAX_LT?: InputMaybe<Scalars["Float"]>;
	timeStamp_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	timeStamp_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	timeStamp_MIN_GT?: InputMaybe<Scalars["Float"]>;
	timeStamp_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	timeStamp_MIN_LT?: InputMaybe<Scalars["Float"]>;
	timeStamp_MIN_LTE?: InputMaybe<Scalars["Float"]>;
};

export type NotificationNotifiedFieldInput = {
	connect?: InputMaybe<Array<NotificationNotifiedConnectFieldInput>>;
	create?: InputMaybe<Array<NotificationNotifiedCreateFieldInput>>;
};

export type NotificationNotifiedNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<NotificationNotifiedNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<NotificationNotifiedNodeAggregationWhereInput>>;
	email_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	email_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	email_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	email_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	email_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	email_EQUAL?: InputMaybe<Scalars["String"]>;
	email_GT?: InputMaybe<Scalars["Int"]>;
	email_GTE?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	email_LT?: InputMaybe<Scalars["Int"]>;
	email_LTE?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	firstName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	firstName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	firstName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	firstName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	firstName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	firstName_EQUAL?: InputMaybe<Scalars["String"]>;
	firstName_GT?: InputMaybe<Scalars["Int"]>;
	firstName_GTE?: InputMaybe<Scalars["Int"]>;
	firstName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	firstName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	firstName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	firstName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	firstName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	firstName_LT?: InputMaybe<Scalars["Int"]>;
	firstName_LTE?: InputMaybe<Scalars["Int"]>;
	firstName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	firstName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	firstName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	firstName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	firstName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	lastName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	lastName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	lastName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	lastName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	lastName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	lastName_EQUAL?: InputMaybe<Scalars["String"]>;
	lastName_GT?: InputMaybe<Scalars["Int"]>;
	lastName_GTE?: InputMaybe<Scalars["Int"]>;
	lastName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	lastName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	lastName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	lastName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	lastName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	lastName_LT?: InputMaybe<Scalars["Int"]>;
	lastName_LTE?: InputMaybe<Scalars["Int"]>;
	lastName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	lastName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	lastName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	lastName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	lastName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	preferredLanguage_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	preferredLanguage_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	preferredLanguage_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	preferredLanguage_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	preferredLanguage_EQUAL?: InputMaybe<Scalars["String"]>;
	preferredLanguage_GT?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_GTE?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LT?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LTE?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	tenantId_EQUAL?: InputMaybe<Scalars["String"]>;
	tenantId_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type NotificationNotifiedRelationship = UserNotificationRelationship & {
	__typename?: "NotificationNotifiedRelationship";
	cursor: Scalars["String"];
	data?: Maybe<Scalars["String"]>;
	emailSentDate?: Maybe<Scalars["Date"]>;
	message: Scalars["String"];
	node: User;
	timeStamp: Scalars["Float"];
};

export type NotificationNotifiedUpdateConnectionInput = {
	edge?: InputMaybe<UserNotificationRelationshipUpdateInput>;
	node?: InputMaybe<UserUpdateInput>;
};

export type NotificationNotifiedUpdateFieldInput = {
	connect?: InputMaybe<Array<NotificationNotifiedConnectFieldInput>>;
	create?: InputMaybe<Array<NotificationNotifiedCreateFieldInput>>;
	delete?: InputMaybe<Array<NotificationNotifiedDeleteFieldInput>>;
	disconnect?: InputMaybe<Array<NotificationNotifiedDisconnectFieldInput>>;
	update?: InputMaybe<NotificationNotifiedUpdateConnectionInput>;
	where?: InputMaybe<NotificationNotifiedConnectionWhere>;
};

export type NotificationOptions = {
	limit?: InputMaybe<Scalars["Int"]>;
	offset?: InputMaybe<Scalars["Int"]>;
	/** Specify one or more NotificationSort objects to sort Notifications by. The sorts will be applied in the order in which they are arranged in the array. */
	sort?: InputMaybe<Array<InputMaybe<NotificationSort>>>;
};

/** Fields to sort Notifications by. The order in which sorts are applied is not guaranteed when specifying many fields in one NotificationSort object. */
export type NotificationSort = {
	id?: InputMaybe<SortDirection>;
	name?: InputMaybe<SortDirection>;
	type?: InputMaybe<SortDirection>;
};

export type NotificationSubscribedAggregateInput = {
	AND?: InputMaybe<Array<NotificationSubscribedAggregateInput>>;
	OR?: InputMaybe<Array<NotificationSubscribedAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<NotificationSubscribedNodeAggregationWhereInput>;
};

export type NotificationSubscribedConnectFieldInput = {
	connect?: InputMaybe<Array<UserConnectInput>>;
	where?: InputMaybe<UserConnectWhere>;
};

export type NotificationSubscribedConnection = {
	__typename?: "NotificationSubscribedConnection";
	edges: Array<NotificationSubscribedRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type NotificationSubscribedConnectionSort = {
	node?: InputMaybe<UserSort>;
};

export type NotificationSubscribedConnectionWhere = {
	AND?: InputMaybe<Array<NotificationSubscribedConnectionWhere>>;
	OR?: InputMaybe<Array<NotificationSubscribedConnectionWhere>>;
	node?: InputMaybe<UserWhere>;
	node_NOT?: InputMaybe<UserWhere>;
};

export type NotificationSubscribedCreateFieldInput = {
	node: UserCreateInput;
};

export type NotificationSubscribedDeleteFieldInput = {
	delete?: InputMaybe<UserDeleteInput>;
	where?: InputMaybe<NotificationSubscribedConnectionWhere>;
};

export type NotificationSubscribedDisconnectFieldInput = {
	disconnect?: InputMaybe<UserDisconnectInput>;
	where?: InputMaybe<NotificationSubscribedConnectionWhere>;
};

export type NotificationSubscribedFieldInput = {
	connect?: InputMaybe<Array<NotificationSubscribedConnectFieldInput>>;
	create?: InputMaybe<Array<NotificationSubscribedCreateFieldInput>>;
};

export type NotificationSubscribedNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<NotificationSubscribedNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<NotificationSubscribedNodeAggregationWhereInput>>;
	email_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	email_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	email_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	email_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	email_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	email_EQUAL?: InputMaybe<Scalars["String"]>;
	email_GT?: InputMaybe<Scalars["Int"]>;
	email_GTE?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	email_LT?: InputMaybe<Scalars["Int"]>;
	email_LTE?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	firstName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	firstName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	firstName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	firstName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	firstName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	firstName_EQUAL?: InputMaybe<Scalars["String"]>;
	firstName_GT?: InputMaybe<Scalars["Int"]>;
	firstName_GTE?: InputMaybe<Scalars["Int"]>;
	firstName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	firstName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	firstName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	firstName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	firstName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	firstName_LT?: InputMaybe<Scalars["Int"]>;
	firstName_LTE?: InputMaybe<Scalars["Int"]>;
	firstName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	firstName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	firstName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	firstName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	firstName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	lastName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	lastName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	lastName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	lastName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	lastName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	lastName_EQUAL?: InputMaybe<Scalars["String"]>;
	lastName_GT?: InputMaybe<Scalars["Int"]>;
	lastName_GTE?: InputMaybe<Scalars["Int"]>;
	lastName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	lastName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	lastName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	lastName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	lastName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	lastName_LT?: InputMaybe<Scalars["Int"]>;
	lastName_LTE?: InputMaybe<Scalars["Int"]>;
	lastName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	lastName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	lastName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	lastName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	lastName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	preferredLanguage_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	preferredLanguage_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	preferredLanguage_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	preferredLanguage_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	preferredLanguage_EQUAL?: InputMaybe<Scalars["String"]>;
	preferredLanguage_GT?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_GTE?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LT?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LTE?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	tenantId_EQUAL?: InputMaybe<Scalars["String"]>;
	tenantId_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type NotificationSubscribedRelationship = {
	__typename?: "NotificationSubscribedRelationship";
	cursor: Scalars["String"];
	node: User;
};

export type NotificationSubscribedUpdateConnectionInput = {
	node?: InputMaybe<UserUpdateInput>;
};

export type NotificationSubscribedUpdateFieldInput = {
	connect?: InputMaybe<Array<NotificationSubscribedConnectFieldInput>>;
	create?: InputMaybe<Array<NotificationSubscribedCreateFieldInput>>;
	delete?: InputMaybe<Array<NotificationSubscribedDeleteFieldInput>>;
	disconnect?: InputMaybe<Array<NotificationSubscribedDisconnectFieldInput>>;
	update?: InputMaybe<NotificationSubscribedUpdateConnectionInput>;
	where?: InputMaybe<NotificationSubscribedConnectionWhere>;
};

export type NotificationTrigger = {
	__typename?: "NotificationTrigger";
	act?: Maybe<NotificationTriggerAct>;
	aspect: NotificationTriggerAspect;
	order: Scalars["Int"];
	previouslyDispatchedOn?: Maybe<Scalars["String"]>;
	subject: NotificationTriggerSubject;
	value?: Maybe<Scalars["String"]>;
};

export enum NotificationTriggerAct {
	Changed = "CHANGED",
	Reached = "REACHED",
}

export type NotificationTriggerAggregateSelection = {
	__typename?: "NotificationTriggerAggregateSelection";
	count: Scalars["Int"];
	order: IntAggregateSelection;
	previouslyDispatchedOn: StringAggregateSelection;
	value: StringAggregateSelection;
};

export enum NotificationTriggerAspect {
	AdverseEvent = "ADVERSE_EVENT",
	Enrolled = "ENROLLED",
	InPayable = "IN_PAYABLE",
	InRefundable = "IN_REFUNDABLE",
	InTotal = "IN_TOTAL",
	None = "NONE",
	PacientDeceased = "PACIENT_DECEASED",
	ProgressiveDisease = "PROGRESSIVE_DISEASE",
	WithAeGrade_3Or_4 = "WITH_AE_GRADE_3_OR_4",
	WithCr = "WITH_CR",
	WithCrPrSd = "WITH_CR_PR_SD",
	WithGrade_3 = "WITH_GRADE_3",
	WithGrade_4 = "WITH_GRADE_4",
	WithPr = "WITH_PR",
	WithSd = "WITH_SD",
}

export type NotificationTriggerConnectWhere = {
	node: NotificationTriggerWhere;
};

export type NotificationTriggerCreateInput = {
	act?: InputMaybe<NotificationTriggerAct>;
	aspect: NotificationTriggerAspect;
	order: Scalars["Int"];
	previouslyDispatchedOn?: InputMaybe<Scalars["String"]>;
	subject: NotificationTriggerSubject;
	value?: InputMaybe<Scalars["String"]>;
};

export type NotificationTriggerInput = {
	act?: InputMaybe<NotificationTriggerAct>;
	aspect: NotificationTriggerAspect;
	order: Scalars["Int"];
	subject: NotificationTriggerSubject;
	value?: InputMaybe<Scalars["String"]>;
};

export type NotificationTriggerOptions = {
	limit?: InputMaybe<Scalars["Int"]>;
	offset?: InputMaybe<Scalars["Int"]>;
	/** Specify one or more NotificationTriggerSort objects to sort NotificationTriggers by. The sorts will be applied in the order in which they are arranged in the array. */
	sort?: InputMaybe<Array<InputMaybe<NotificationTriggerSort>>>;
};

/** Fields to sort NotificationTriggers by. The order in which sorts are applied is not guaranteed when specifying many fields in one NotificationTriggerSort object. */
export type NotificationTriggerSort = {
	act?: InputMaybe<SortDirection>;
	aspect?: InputMaybe<SortDirection>;
	order?: InputMaybe<SortDirection>;
	previouslyDispatchedOn?: InputMaybe<SortDirection>;
	subject?: InputMaybe<SortDirection>;
	value?: InputMaybe<SortDirection>;
};

export enum NotificationTriggerSubject {
	AgreementAmount = "AGREEMENT_AMOUNT",
	DurationOfTreatment = "DURATION_OF_TREATMENT",
	NumberOfCases = "NUMBER_OF_CASES",
	NumberOfPatients = "NUMBER_OF_PATIENTS",
	NumberOfTraes = "NUMBER_OF_TRAES",
	TreatmentsDiscontinuedDueTo = "TREATMENTS_DISCONTINUED_DUE_TO",
}

export type NotificationTriggerUpdateInput = {
	act?: InputMaybe<NotificationTriggerAct>;
	aspect?: InputMaybe<NotificationTriggerAspect>;
	order?: InputMaybe<Scalars["Int"]>;
	previouslyDispatchedOn?: InputMaybe<Scalars["String"]>;
	subject?: InputMaybe<NotificationTriggerSubject>;
	value?: InputMaybe<Scalars["String"]>;
};

export type NotificationTriggerWhere = {
	AND?: InputMaybe<Array<NotificationTriggerWhere>>;
	OR?: InputMaybe<Array<NotificationTriggerWhere>>;
	act?: InputMaybe<NotificationTriggerAct>;
	act_IN?: InputMaybe<Array<InputMaybe<NotificationTriggerAct>>>;
	act_NOT?: InputMaybe<NotificationTriggerAct>;
	act_NOT_IN?: InputMaybe<Array<InputMaybe<NotificationTriggerAct>>>;
	aspect?: InputMaybe<NotificationTriggerAspect>;
	aspect_IN?: InputMaybe<Array<InputMaybe<NotificationTriggerAspect>>>;
	aspect_NOT?: InputMaybe<NotificationTriggerAspect>;
	aspect_NOT_IN?: InputMaybe<Array<InputMaybe<NotificationTriggerAspect>>>;
	order?: InputMaybe<Scalars["Int"]>;
	order_GT?: InputMaybe<Scalars["Int"]>;
	order_GTE?: InputMaybe<Scalars["Int"]>;
	order_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	order_LT?: InputMaybe<Scalars["Int"]>;
	order_LTE?: InputMaybe<Scalars["Int"]>;
	order_NOT?: InputMaybe<Scalars["Int"]>;
	order_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	previouslyDispatchedOn?: InputMaybe<Scalars["String"]>;
	previouslyDispatchedOn_CONTAINS?: InputMaybe<Scalars["String"]>;
	previouslyDispatchedOn_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	previouslyDispatchedOn_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	previouslyDispatchedOn_MATCHES?: InputMaybe<Scalars["String"]>;
	previouslyDispatchedOn_NOT?: InputMaybe<Scalars["String"]>;
	previouslyDispatchedOn_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	previouslyDispatchedOn_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	previouslyDispatchedOn_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	previouslyDispatchedOn_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	previouslyDispatchedOn_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	subject?: InputMaybe<NotificationTriggerSubject>;
	subject_IN?: InputMaybe<Array<InputMaybe<NotificationTriggerSubject>>>;
	subject_NOT?: InputMaybe<NotificationTriggerSubject>;
	subject_NOT_IN?: InputMaybe<Array<InputMaybe<NotificationTriggerSubject>>>;
	value?: InputMaybe<Scalars["String"]>;
	value_CONTAINS?: InputMaybe<Scalars["String"]>;
	value_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	value_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	value_MATCHES?: InputMaybe<Scalars["String"]>;
	value_NOT?: InputMaybe<Scalars["String"]>;
	value_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	value_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	value_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	value_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	value_STARTS_WITH?: InputMaybe<Scalars["String"]>;
};

export enum NotificationType {
	Individual = "INDIVIDUAL",
	Summary = "SUMMARY",
}

export type NotificationUpdateInput = {
	due?: InputMaybe<Array<NotificationDueUpdateFieldInput>>;
	id?: InputMaybe<Scalars["Int"]>;
	name?: InputMaybe<Scalars["String"]>;
	notified?: InputMaybe<Array<NotificationNotifiedUpdateFieldInput>>;
	subscribed?: InputMaybe<Array<NotificationSubscribedUpdateFieldInput>>;
	type?: InputMaybe<NotificationType>;
};

export type NotificationWhere = {
	AND?: InputMaybe<Array<NotificationWhere>>;
	OR?: InputMaybe<Array<NotificationWhere>>;
	due?: InputMaybe<UserWhere>;
	dueAggregate?: InputMaybe<NotificationDueAggregateInput>;
	dueConnection?: InputMaybe<NotificationDueConnectionWhere>;
	dueConnection_NOT?: InputMaybe<NotificationDueConnectionWhere>;
	due_NOT?: InputMaybe<UserWhere>;
	id?: InputMaybe<Scalars["Int"]>;
	id_GT?: InputMaybe<Scalars["Int"]>;
	id_GTE?: InputMaybe<Scalars["Int"]>;
	id_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	id_LT?: InputMaybe<Scalars["Int"]>;
	id_LTE?: InputMaybe<Scalars["Int"]>;
	id_NOT?: InputMaybe<Scalars["Int"]>;
	id_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	name?: InputMaybe<Scalars["String"]>;
	name_CONTAINS?: InputMaybe<Scalars["String"]>;
	name_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	name_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	name_MATCHES?: InputMaybe<Scalars["String"]>;
	name_NOT?: InputMaybe<Scalars["String"]>;
	name_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	name_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	name_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	name_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	name_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	notified?: InputMaybe<UserWhere>;
	notifiedAggregate?: InputMaybe<NotificationNotifiedAggregateInput>;
	notifiedConnection?: InputMaybe<NotificationNotifiedConnectionWhere>;
	notifiedConnection_NOT?: InputMaybe<NotificationNotifiedConnectionWhere>;
	notified_NOT?: InputMaybe<UserWhere>;
	subscribed?: InputMaybe<UserWhere>;
	subscribedAggregate?: InputMaybe<NotificationSubscribedAggregateInput>;
	subscribedConnection?: InputMaybe<NotificationSubscribedConnectionWhere>;
	subscribedConnection_NOT?: InputMaybe<NotificationSubscribedConnectionWhere>;
	subscribed_NOT?: InputMaybe<UserWhere>;
	type?: InputMaybe<NotificationType>;
	type_IN?: InputMaybe<Array<InputMaybe<NotificationType>>>;
	type_NOT?: InputMaybe<NotificationType>;
	type_NOT_IN?: InputMaybe<Array<InputMaybe<NotificationType>>>;
};

export enum Occurrence {
	ForTheFirstTime = "FOR_THE_FIRST_TIME",
	ForTheFourthTime = "FOR_THE_FOURTH_TIME",
	ForTheSecondTime = "FOR_THE_SECOND_TIME",
	ForTheThirdTime = "FOR_THE_THIRD_TIME",
}

export enum OccurrenceEnum {
	FormEntry = "FORM_ENTRY",
	RecordEntry = "RECORD_ENTRY",
	RecordImport = "RECORD_IMPORT",
	RecordUpload = "RECORD_UPLOAD",
}

export type Organization = {
	__typename?: "Organization";
	IBAN?: Maybe<Scalars["String"]>;
	billingAddress?: Maybe<Scalars["String"]>;
	contactEmail?: Maybe<Scalars["String"]>;
	contactFirstName?: Maybe<Scalars["String"]>;
	contactLastName?: Maybe<Scalars["String"]>;
	contactOccupation?: Maybe<Scalars["String"]>;
	contactPhone?: Maybe<Scalars["String"]>;
	customTranslations: Array<Maybe<Translations>>;
	domicile?: Maybe<Scalars["String"]>;
	eIN?: Maybe<Scalars["String"]>;
	fax?: Maybe<Scalars["String"]>;
	id: Scalars["ID"];
	legalName?: Maybe<Scalars["String"]>;
	logo: Scalars["String"];
	name: Scalars["String"];
	phone?: Maybe<Scalars["String"]>;
	tenantId?: Maybe<Scalars["String"]>;
	website?: Maybe<Scalars["String"]>;
};

export type OrganizationAggregateSelection = {
	__typename?: "OrganizationAggregateSelection";
	IBAN: StringAggregateSelection;
	billingAddress: StringAggregateSelection;
	contactEmail: StringAggregateSelection;
	contactFirstName: StringAggregateSelection;
	contactLastName: StringAggregateSelection;
	contactOccupation: StringAggregateSelection;
	contactPhone: StringAggregateSelection;
	count: Scalars["Int"];
	domicile: StringAggregateSelection;
	eIN: StringAggregateSelection;
	fax: StringAggregateSelection;
	id: IdAggregateSelection;
	legalName: StringAggregateSelection;
	logo: StringAggregateSelection;
	name: StringAggregateSelection;
	phone: StringAggregateSelection;
	tenantId: StringAggregateSelection;
	website: StringAggregateSelection;
};

export type OrganizationConnectWhere = {
	node: OrganizationWhere;
};

export type OrganizationCreateInput = {
	IBAN?: InputMaybe<Scalars["String"]>;
	billingAddress?: InputMaybe<Scalars["String"]>;
	contactEmail?: InputMaybe<Scalars["String"]>;
	contactFirstName?: InputMaybe<Scalars["String"]>;
	contactLastName?: InputMaybe<Scalars["String"]>;
	contactOccupation?: InputMaybe<Scalars["String"]>;
	contactPhone?: InputMaybe<Scalars["String"]>;
	customTranslations: Array<InputMaybe<Translations>>;
	domicile?: InputMaybe<Scalars["String"]>;
	eIN?: InputMaybe<Scalars["String"]>;
	fax?: InputMaybe<Scalars["String"]>;
	id: Scalars["ID"];
	legalName?: InputMaybe<Scalars["String"]>;
	logo: Scalars["String"];
	name: Scalars["String"];
	phone?: InputMaybe<Scalars["String"]>;
	tenantId?: InputMaybe<Scalars["String"]>;
	website?: InputMaybe<Scalars["String"]>;
};

export type OrganizationInput = {
	id: Scalars["ID"];
	name: Scalars["String"];
};

export type OrganizationOptions = {
	limit?: InputMaybe<Scalars["Int"]>;
	offset?: InputMaybe<Scalars["Int"]>;
	/** Specify one or more OrganizationSort objects to sort Organizations by. The sorts will be applied in the order in which they are arranged in the array. */
	sort?: InputMaybe<Array<InputMaybe<OrganizationSort>>>;
};

/** Fields to sort Organizations by. The order in which sorts are applied is not guaranteed when specifying many fields in one OrganizationSort object. */
export type OrganizationSort = {
	IBAN?: InputMaybe<SortDirection>;
	billingAddress?: InputMaybe<SortDirection>;
	contactEmail?: InputMaybe<SortDirection>;
	contactFirstName?: InputMaybe<SortDirection>;
	contactLastName?: InputMaybe<SortDirection>;
	contactOccupation?: InputMaybe<SortDirection>;
	contactPhone?: InputMaybe<SortDirection>;
	domicile?: InputMaybe<SortDirection>;
	eIN?: InputMaybe<SortDirection>;
	fax?: InputMaybe<SortDirection>;
	id?: InputMaybe<SortDirection>;
	legalName?: InputMaybe<SortDirection>;
	logo?: InputMaybe<SortDirection>;
	name?: InputMaybe<SortDirection>;
	phone?: InputMaybe<SortDirection>;
	tenantId?: InputMaybe<SortDirection>;
	website?: InputMaybe<SortDirection>;
};

export type OrganizationUpdateInput = {
	IBAN?: InputMaybe<Scalars["String"]>;
	billingAddress?: InputMaybe<Scalars["String"]>;
	contactEmail?: InputMaybe<Scalars["String"]>;
	contactFirstName?: InputMaybe<Scalars["String"]>;
	contactLastName?: InputMaybe<Scalars["String"]>;
	contactOccupation?: InputMaybe<Scalars["String"]>;
	contactPhone?: InputMaybe<Scalars["String"]>;
	customTranslations?: InputMaybe<Array<InputMaybe<Translations>>>;
	domicile?: InputMaybe<Scalars["String"]>;
	eIN?: InputMaybe<Scalars["String"]>;
	fax?: InputMaybe<Scalars["String"]>;
	id?: InputMaybe<Scalars["ID"]>;
	legalName?: InputMaybe<Scalars["String"]>;
	logo?: InputMaybe<Scalars["String"]>;
	name?: InputMaybe<Scalars["String"]>;
	phone?: InputMaybe<Scalars["String"]>;
	tenantId?: InputMaybe<Scalars["String"]>;
	website?: InputMaybe<Scalars["String"]>;
};

export type OrganizationWhere = {
	AND?: InputMaybe<Array<OrganizationWhere>>;
	IBAN?: InputMaybe<Scalars["String"]>;
	IBAN_CONTAINS?: InputMaybe<Scalars["String"]>;
	IBAN_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	IBAN_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	IBAN_MATCHES?: InputMaybe<Scalars["String"]>;
	IBAN_NOT?: InputMaybe<Scalars["String"]>;
	IBAN_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	IBAN_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	IBAN_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	IBAN_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	IBAN_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	OR?: InputMaybe<Array<OrganizationWhere>>;
	billingAddress?: InputMaybe<Scalars["String"]>;
	billingAddress_CONTAINS?: InputMaybe<Scalars["String"]>;
	billingAddress_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	billingAddress_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	billingAddress_MATCHES?: InputMaybe<Scalars["String"]>;
	billingAddress_NOT?: InputMaybe<Scalars["String"]>;
	billingAddress_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	billingAddress_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	billingAddress_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	billingAddress_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	billingAddress_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	contactEmail?: InputMaybe<Scalars["String"]>;
	contactEmail_CONTAINS?: InputMaybe<Scalars["String"]>;
	contactEmail_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	contactEmail_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	contactEmail_MATCHES?: InputMaybe<Scalars["String"]>;
	contactEmail_NOT?: InputMaybe<Scalars["String"]>;
	contactEmail_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	contactEmail_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	contactEmail_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	contactEmail_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	contactEmail_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	contactFirstName?: InputMaybe<Scalars["String"]>;
	contactFirstName_CONTAINS?: InputMaybe<Scalars["String"]>;
	contactFirstName_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	contactFirstName_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	contactFirstName_MATCHES?: InputMaybe<Scalars["String"]>;
	contactFirstName_NOT?: InputMaybe<Scalars["String"]>;
	contactFirstName_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	contactFirstName_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	contactFirstName_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	contactFirstName_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	contactFirstName_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	contactLastName?: InputMaybe<Scalars["String"]>;
	contactLastName_CONTAINS?: InputMaybe<Scalars["String"]>;
	contactLastName_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	contactLastName_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	contactLastName_MATCHES?: InputMaybe<Scalars["String"]>;
	contactLastName_NOT?: InputMaybe<Scalars["String"]>;
	contactLastName_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	contactLastName_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	contactLastName_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	contactLastName_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	contactLastName_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	contactOccupation?: InputMaybe<Scalars["String"]>;
	contactOccupation_CONTAINS?: InputMaybe<Scalars["String"]>;
	contactOccupation_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	contactOccupation_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	contactOccupation_MATCHES?: InputMaybe<Scalars["String"]>;
	contactOccupation_NOT?: InputMaybe<Scalars["String"]>;
	contactOccupation_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	contactOccupation_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	contactOccupation_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	contactOccupation_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	contactOccupation_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	contactPhone?: InputMaybe<Scalars["String"]>;
	contactPhone_CONTAINS?: InputMaybe<Scalars["String"]>;
	contactPhone_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	contactPhone_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	contactPhone_MATCHES?: InputMaybe<Scalars["String"]>;
	contactPhone_NOT?: InputMaybe<Scalars["String"]>;
	contactPhone_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	contactPhone_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	contactPhone_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	contactPhone_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	contactPhone_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	customTranslations?: InputMaybe<Array<InputMaybe<Translations>>>;
	customTranslations_INCLUDES?: InputMaybe<Translations>;
	customTranslations_NOT?: InputMaybe<Array<InputMaybe<Translations>>>;
	customTranslations_NOT_INCLUDES?: InputMaybe<Translations>;
	domicile?: InputMaybe<Scalars["String"]>;
	domicile_CONTAINS?: InputMaybe<Scalars["String"]>;
	domicile_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	domicile_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	domicile_MATCHES?: InputMaybe<Scalars["String"]>;
	domicile_NOT?: InputMaybe<Scalars["String"]>;
	domicile_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	domicile_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	domicile_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	domicile_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	domicile_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	eIN?: InputMaybe<Scalars["String"]>;
	eIN_CONTAINS?: InputMaybe<Scalars["String"]>;
	eIN_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	eIN_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	eIN_MATCHES?: InputMaybe<Scalars["String"]>;
	eIN_NOT?: InputMaybe<Scalars["String"]>;
	eIN_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	eIN_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	eIN_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	eIN_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	eIN_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	fax?: InputMaybe<Scalars["String"]>;
	fax_CONTAINS?: InputMaybe<Scalars["String"]>;
	fax_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	fax_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	fax_MATCHES?: InputMaybe<Scalars["String"]>;
	fax_NOT?: InputMaybe<Scalars["String"]>;
	fax_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	fax_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	fax_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	fax_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	fax_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	id?: InputMaybe<Scalars["ID"]>;
	id_CONTAINS?: InputMaybe<Scalars["ID"]>;
	id_ENDS_WITH?: InputMaybe<Scalars["ID"]>;
	id_IN?: InputMaybe<Array<InputMaybe<Scalars["ID"]>>>;
	id_MATCHES?: InputMaybe<Scalars["String"]>;
	id_NOT?: InputMaybe<Scalars["ID"]>;
	id_NOT_CONTAINS?: InputMaybe<Scalars["ID"]>;
	id_NOT_ENDS_WITH?: InputMaybe<Scalars["ID"]>;
	id_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["ID"]>>>;
	id_NOT_STARTS_WITH?: InputMaybe<Scalars["ID"]>;
	id_STARTS_WITH?: InputMaybe<Scalars["ID"]>;
	legalName?: InputMaybe<Scalars["String"]>;
	legalName_CONTAINS?: InputMaybe<Scalars["String"]>;
	legalName_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	legalName_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	legalName_MATCHES?: InputMaybe<Scalars["String"]>;
	legalName_NOT?: InputMaybe<Scalars["String"]>;
	legalName_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	legalName_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	legalName_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	legalName_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	legalName_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	logo?: InputMaybe<Scalars["String"]>;
	logo_CONTAINS?: InputMaybe<Scalars["String"]>;
	logo_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	logo_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	logo_MATCHES?: InputMaybe<Scalars["String"]>;
	logo_NOT?: InputMaybe<Scalars["String"]>;
	logo_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	logo_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	logo_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	logo_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	logo_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	name?: InputMaybe<Scalars["String"]>;
	name_CONTAINS?: InputMaybe<Scalars["String"]>;
	name_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	name_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	name_MATCHES?: InputMaybe<Scalars["String"]>;
	name_NOT?: InputMaybe<Scalars["String"]>;
	name_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	name_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	name_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	name_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	name_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	phone?: InputMaybe<Scalars["String"]>;
	phone_CONTAINS?: InputMaybe<Scalars["String"]>;
	phone_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	phone_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	phone_MATCHES?: InputMaybe<Scalars["String"]>;
	phone_NOT?: InputMaybe<Scalars["String"]>;
	phone_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	phone_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	phone_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	phone_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	phone_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	tenantId?: InputMaybe<Scalars["String"]>;
	tenantId_CONTAINS?: InputMaybe<Scalars["String"]>;
	tenantId_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	tenantId_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	tenantId_MATCHES?: InputMaybe<Scalars["String"]>;
	tenantId_NOT?: InputMaybe<Scalars["String"]>;
	tenantId_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	tenantId_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	tenantId_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	tenantId_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	tenantId_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	website?: InputMaybe<Scalars["String"]>;
	website_CONTAINS?: InputMaybe<Scalars["String"]>;
	website_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	website_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	website_MATCHES?: InputMaybe<Scalars["String"]>;
	website_NOT?: InputMaybe<Scalars["String"]>;
	website_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	website_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	website_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	website_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	website_STARTS_WITH?: InputMaybe<Scalars["String"]>;
};

export enum OutcomeBasedStatus {
	NonTreatmentRelated = "NON_TREATMENT_RELATED",
	TreatmentRelated = "TREATMENT_RELATED",
}

export type OutcomebasedAgreementReport = {
	__typename?: "OutcomebasedAgreementReport";
	adverseEventsOccurenceData: Array<AdverseEventsOccurenceReport>;
	discountAmount?: Maybe<Scalars["Float"]>;
	discountAmountDelta?: Maybe<Scalars["Float"]>;
	discountRatio?: Maybe<Scalars["Float"]>;
	discountRatioDelta?: Maybe<Scalars["Float"]>;
	discountsPerCase?: Maybe<Scalars["Float"]>;
	discountsPerCaseDiscontinued?: Maybe<Scalars["Float"]>;
	durationMonths?: Maybe<Scalars["Int"]>;
	durationMonthsDiscontinued?: Maybe<Scalars["Int"]>;
	financialSummaryRows: Array<FinancialSummaryRow>;
	grossAmountPerCase?: Maybe<Scalars["Float"]>;
	grossAmountPerCaseDiscontinued?: Maybe<Scalars["Float"]>;
	initialResponseReviewData: Array<InitialResponseReviewReport>;
	netAmountPerCase?: Maybe<Scalars["Float"]>;
	netAmountPerCaseDiscontinued?: Maybe<Scalars["Float"]>;
	patientReportDataPoints: Array<PatientReportDataPoint>;
	patientsWithAE?: Maybe<Scalars["Float"]>;
	progressionFreePatients?: Maybe<Scalars["Float"]>;
	reasonOfTreatmentDiscontinuationData: Array<ReasonOfTreatmentDiscontinuationReport>;
	totalPatients?: Maybe<Scalars["Int"]>;
	totalResponse?: Maybe<Scalars["Int"]>;
	treatmentDurationData: Array<CaseReportDataPoint>;
};

export type OutcomebasedAgreementReportAggregateSelection = {
	__typename?: "OutcomebasedAgreementReportAggregateSelection";
	count: Scalars["Int"];
	discountAmount: FloatAggregateSelection;
	discountAmountDelta: FloatAggregateSelection;
	discountRatio: FloatAggregateSelection;
	discountRatioDelta: FloatAggregateSelection;
	discountsPerCase: FloatAggregateSelection;
	discountsPerCaseDiscontinued: FloatAggregateSelection;
	durationMonths: IntAggregateSelection;
	durationMonthsDiscontinued: IntAggregateSelection;
	grossAmountPerCase: FloatAggregateSelection;
	grossAmountPerCaseDiscontinued: FloatAggregateSelection;
	netAmountPerCase: FloatAggregateSelection;
	netAmountPerCaseDiscontinued: FloatAggregateSelection;
	patientsWithAE: FloatAggregateSelection;
	progressionFreePatients: FloatAggregateSelection;
	totalPatients: IntAggregateSelection;
	totalResponse: IntAggregateSelection;
};

export type OutcomebasedAgreementReportOptions = {
	limit?: InputMaybe<Scalars["Int"]>;
	offset?: InputMaybe<Scalars["Int"]>;
	/** Specify one or more OutcomebasedAgreementReportSort objects to sort OutcomebasedAgreementReports by. The sorts will be applied in the order in which they are arranged in the array. */
	sort?: InputMaybe<Array<InputMaybe<OutcomebasedAgreementReportSort>>>;
};

/** Fields to sort OutcomebasedAgreementReports by. The order in which sorts are applied is not guaranteed when specifying many fields in one OutcomebasedAgreementReportSort object. */
export type OutcomebasedAgreementReportSort = {
	discountAmount?: InputMaybe<SortDirection>;
	discountAmountDelta?: InputMaybe<SortDirection>;
	discountRatio?: InputMaybe<SortDirection>;
	discountRatioDelta?: InputMaybe<SortDirection>;
	discountsPerCase?: InputMaybe<SortDirection>;
	discountsPerCaseDiscontinued?: InputMaybe<SortDirection>;
	durationMonths?: InputMaybe<SortDirection>;
	durationMonthsDiscontinued?: InputMaybe<SortDirection>;
	grossAmountPerCase?: InputMaybe<SortDirection>;
	grossAmountPerCaseDiscontinued?: InputMaybe<SortDirection>;
	netAmountPerCase?: InputMaybe<SortDirection>;
	netAmountPerCaseDiscontinued?: InputMaybe<SortDirection>;
	patientsWithAE?: InputMaybe<SortDirection>;
	progressionFreePatients?: InputMaybe<SortDirection>;
	totalPatients?: InputMaybe<SortDirection>;
	totalResponse?: InputMaybe<SortDirection>;
};

export type OutcomebasedAgreementReportWhere = {
	AND?: InputMaybe<Array<OutcomebasedAgreementReportWhere>>;
	OR?: InputMaybe<Array<OutcomebasedAgreementReportWhere>>;
	discountAmount?: InputMaybe<Scalars["Float"]>;
	discountAmountDelta?: InputMaybe<Scalars["Float"]>;
	discountAmountDelta_GT?: InputMaybe<Scalars["Float"]>;
	discountAmountDelta_GTE?: InputMaybe<Scalars["Float"]>;
	discountAmountDelta_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	discountAmountDelta_LT?: InputMaybe<Scalars["Float"]>;
	discountAmountDelta_LTE?: InputMaybe<Scalars["Float"]>;
	discountAmountDelta_NOT?: InputMaybe<Scalars["Float"]>;
	discountAmountDelta_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	discountAmount_GT?: InputMaybe<Scalars["Float"]>;
	discountAmount_GTE?: InputMaybe<Scalars["Float"]>;
	discountAmount_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	discountAmount_LT?: InputMaybe<Scalars["Float"]>;
	discountAmount_LTE?: InputMaybe<Scalars["Float"]>;
	discountAmount_NOT?: InputMaybe<Scalars["Float"]>;
	discountAmount_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	discountRatio?: InputMaybe<Scalars["Float"]>;
	discountRatioDelta?: InputMaybe<Scalars["Float"]>;
	discountRatioDelta_GT?: InputMaybe<Scalars["Float"]>;
	discountRatioDelta_GTE?: InputMaybe<Scalars["Float"]>;
	discountRatioDelta_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	discountRatioDelta_LT?: InputMaybe<Scalars["Float"]>;
	discountRatioDelta_LTE?: InputMaybe<Scalars["Float"]>;
	discountRatioDelta_NOT?: InputMaybe<Scalars["Float"]>;
	discountRatioDelta_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	discountRatio_GT?: InputMaybe<Scalars["Float"]>;
	discountRatio_GTE?: InputMaybe<Scalars["Float"]>;
	discountRatio_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	discountRatio_LT?: InputMaybe<Scalars["Float"]>;
	discountRatio_LTE?: InputMaybe<Scalars["Float"]>;
	discountRatio_NOT?: InputMaybe<Scalars["Float"]>;
	discountRatio_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	discountsPerCase?: InputMaybe<Scalars["Float"]>;
	discountsPerCaseDiscontinued?: InputMaybe<Scalars["Float"]>;
	discountsPerCaseDiscontinued_GT?: InputMaybe<Scalars["Float"]>;
	discountsPerCaseDiscontinued_GTE?: InputMaybe<Scalars["Float"]>;
	discountsPerCaseDiscontinued_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	discountsPerCaseDiscontinued_LT?: InputMaybe<Scalars["Float"]>;
	discountsPerCaseDiscontinued_LTE?: InputMaybe<Scalars["Float"]>;
	discountsPerCaseDiscontinued_NOT?: InputMaybe<Scalars["Float"]>;
	discountsPerCaseDiscontinued_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	discountsPerCase_GT?: InputMaybe<Scalars["Float"]>;
	discountsPerCase_GTE?: InputMaybe<Scalars["Float"]>;
	discountsPerCase_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	discountsPerCase_LT?: InputMaybe<Scalars["Float"]>;
	discountsPerCase_LTE?: InputMaybe<Scalars["Float"]>;
	discountsPerCase_NOT?: InputMaybe<Scalars["Float"]>;
	discountsPerCase_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	durationMonths?: InputMaybe<Scalars["Int"]>;
	durationMonthsDiscontinued?: InputMaybe<Scalars["Int"]>;
	durationMonthsDiscontinued_GT?: InputMaybe<Scalars["Int"]>;
	durationMonthsDiscontinued_GTE?: InputMaybe<Scalars["Int"]>;
	durationMonthsDiscontinued_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	durationMonthsDiscontinued_LT?: InputMaybe<Scalars["Int"]>;
	durationMonthsDiscontinued_LTE?: InputMaybe<Scalars["Int"]>;
	durationMonthsDiscontinued_NOT?: InputMaybe<Scalars["Int"]>;
	durationMonthsDiscontinued_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	durationMonths_GT?: InputMaybe<Scalars["Int"]>;
	durationMonths_GTE?: InputMaybe<Scalars["Int"]>;
	durationMonths_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	durationMonths_LT?: InputMaybe<Scalars["Int"]>;
	durationMonths_LTE?: InputMaybe<Scalars["Int"]>;
	durationMonths_NOT?: InputMaybe<Scalars["Int"]>;
	durationMonths_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	grossAmountPerCase?: InputMaybe<Scalars["Float"]>;
	grossAmountPerCaseDiscontinued?: InputMaybe<Scalars["Float"]>;
	grossAmountPerCaseDiscontinued_GT?: InputMaybe<Scalars["Float"]>;
	grossAmountPerCaseDiscontinued_GTE?: InputMaybe<Scalars["Float"]>;
	grossAmountPerCaseDiscontinued_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	grossAmountPerCaseDiscontinued_LT?: InputMaybe<Scalars["Float"]>;
	grossAmountPerCaseDiscontinued_LTE?: InputMaybe<Scalars["Float"]>;
	grossAmountPerCaseDiscontinued_NOT?: InputMaybe<Scalars["Float"]>;
	grossAmountPerCaseDiscontinued_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	grossAmountPerCase_GT?: InputMaybe<Scalars["Float"]>;
	grossAmountPerCase_GTE?: InputMaybe<Scalars["Float"]>;
	grossAmountPerCase_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	grossAmountPerCase_LT?: InputMaybe<Scalars["Float"]>;
	grossAmountPerCase_LTE?: InputMaybe<Scalars["Float"]>;
	grossAmountPerCase_NOT?: InputMaybe<Scalars["Float"]>;
	grossAmountPerCase_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	netAmountPerCase?: InputMaybe<Scalars["Float"]>;
	netAmountPerCaseDiscontinued?: InputMaybe<Scalars["Float"]>;
	netAmountPerCaseDiscontinued_GT?: InputMaybe<Scalars["Float"]>;
	netAmountPerCaseDiscontinued_GTE?: InputMaybe<Scalars["Float"]>;
	netAmountPerCaseDiscontinued_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	netAmountPerCaseDiscontinued_LT?: InputMaybe<Scalars["Float"]>;
	netAmountPerCaseDiscontinued_LTE?: InputMaybe<Scalars["Float"]>;
	netAmountPerCaseDiscontinued_NOT?: InputMaybe<Scalars["Float"]>;
	netAmountPerCaseDiscontinued_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	netAmountPerCase_GT?: InputMaybe<Scalars["Float"]>;
	netAmountPerCase_GTE?: InputMaybe<Scalars["Float"]>;
	netAmountPerCase_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	netAmountPerCase_LT?: InputMaybe<Scalars["Float"]>;
	netAmountPerCase_LTE?: InputMaybe<Scalars["Float"]>;
	netAmountPerCase_NOT?: InputMaybe<Scalars["Float"]>;
	netAmountPerCase_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	patientsWithAE?: InputMaybe<Scalars["Float"]>;
	patientsWithAE_GT?: InputMaybe<Scalars["Float"]>;
	patientsWithAE_GTE?: InputMaybe<Scalars["Float"]>;
	patientsWithAE_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	patientsWithAE_LT?: InputMaybe<Scalars["Float"]>;
	patientsWithAE_LTE?: InputMaybe<Scalars["Float"]>;
	patientsWithAE_NOT?: InputMaybe<Scalars["Float"]>;
	patientsWithAE_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	progressionFreePatients?: InputMaybe<Scalars["Float"]>;
	progressionFreePatients_GT?: InputMaybe<Scalars["Float"]>;
	progressionFreePatients_GTE?: InputMaybe<Scalars["Float"]>;
	progressionFreePatients_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	progressionFreePatients_LT?: InputMaybe<Scalars["Float"]>;
	progressionFreePatients_LTE?: InputMaybe<Scalars["Float"]>;
	progressionFreePatients_NOT?: InputMaybe<Scalars["Float"]>;
	progressionFreePatients_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	totalPatients?: InputMaybe<Scalars["Int"]>;
	totalPatients_GT?: InputMaybe<Scalars["Int"]>;
	totalPatients_GTE?: InputMaybe<Scalars["Int"]>;
	totalPatients_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	totalPatients_LT?: InputMaybe<Scalars["Int"]>;
	totalPatients_LTE?: InputMaybe<Scalars["Int"]>;
	totalPatients_NOT?: InputMaybe<Scalars["Int"]>;
	totalPatients_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	totalResponse?: InputMaybe<Scalars["Int"]>;
	totalResponse_GT?: InputMaybe<Scalars["Int"]>;
	totalResponse_GTE?: InputMaybe<Scalars["Int"]>;
	totalResponse_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	totalResponse_LT?: InputMaybe<Scalars["Int"]>;
	totalResponse_LTE?: InputMaybe<Scalars["Int"]>;
	totalResponse_NOT?: InputMaybe<Scalars["Int"]>;
	totalResponse_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
};

export type PiRecurrenceSiDataPoint = {
	__typename?: "PIRecurrenceSIDataPoint";
	averagePIToRecurrence: Scalars["Float"];
	averageRecurrenceToSI: Scalars["Float"];
	isConditionMet: Scalars["Boolean"];
};

export type PiRecurrenceSiDataPointAggregateSelection = {
	__typename?: "PIRecurrenceSIDataPointAggregateSelection";
	averagePIToRecurrence: FloatAggregateSelection;
	averageRecurrenceToSI: FloatAggregateSelection;
	count: Scalars["Int"];
};

export type PiRecurrenceSiDataPointOptions = {
	limit?: InputMaybe<Scalars["Int"]>;
	offset?: InputMaybe<Scalars["Int"]>;
	/** Specify one or more PIRecurrenceSIDataPointSort objects to sort PIRecurrenceSIDataPoints by. The sorts will be applied in the order in which they are arranged in the array. */
	sort?: InputMaybe<Array<InputMaybe<PiRecurrenceSiDataPointSort>>>;
};

/** Fields to sort PIRecurrenceSIDataPoints by. The order in which sorts are applied is not guaranteed when specifying many fields in one PIRecurrenceSIDataPointSort object. */
export type PiRecurrenceSiDataPointSort = {
	averagePIToRecurrence?: InputMaybe<SortDirection>;
	averageRecurrenceToSI?: InputMaybe<SortDirection>;
	isConditionMet?: InputMaybe<SortDirection>;
};

export type PiRecurrenceSiDataPointWhere = {
	AND?: InputMaybe<Array<PiRecurrenceSiDataPointWhere>>;
	OR?: InputMaybe<Array<PiRecurrenceSiDataPointWhere>>;
	averagePIToRecurrence?: InputMaybe<Scalars["Float"]>;
	averagePIToRecurrence_GT?: InputMaybe<Scalars["Float"]>;
	averagePIToRecurrence_GTE?: InputMaybe<Scalars["Float"]>;
	averagePIToRecurrence_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	averagePIToRecurrence_LT?: InputMaybe<Scalars["Float"]>;
	averagePIToRecurrence_LTE?: InputMaybe<Scalars["Float"]>;
	averagePIToRecurrence_NOT?: InputMaybe<Scalars["Float"]>;
	averagePIToRecurrence_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	averageRecurrenceToSI?: InputMaybe<Scalars["Float"]>;
	averageRecurrenceToSI_GT?: InputMaybe<Scalars["Float"]>;
	averageRecurrenceToSI_GTE?: InputMaybe<Scalars["Float"]>;
	averageRecurrenceToSI_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	averageRecurrenceToSI_LT?: InputMaybe<Scalars["Float"]>;
	averageRecurrenceToSI_LTE?: InputMaybe<Scalars["Float"]>;
	averageRecurrenceToSI_NOT?: InputMaybe<Scalars["Float"]>;
	averageRecurrenceToSI_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	isConditionMet?: InputMaybe<Scalars["Boolean"]>;
	isConditionMet_NOT?: InputMaybe<Scalars["Boolean"]>;
};

/** Pagination information (Relay) */
export type PageInfo = {
	__typename?: "PageInfo";
	endCursor?: Maybe<Scalars["String"]>;
	hasNextPage: Scalars["Boolean"];
	hasPreviousPage: Scalars["Boolean"];
	startCursor?: Maybe<Scalars["String"]>;
};

export type Partner = {
	__typename?: "Partner";
	Description?: Maybe<Scalars["String"]>;
	PartnerType?: Maybe<Scalars["String"]>;
	Phone?: Maybe<Scalars["String"]>;
	Place?: Maybe<Scalars["String"]>;
	Street?: Maybe<Scalars["String"]>;
	ZipCode?: Maybe<Scalars["Int"]>;
	treatment?: Maybe<Treatment>;
	treatmentConnection: PartnerTreatmentConnection;
};

export type PartnerTreatmentArgs = {
	options?: InputMaybe<TreatmentOptions>;
	where?: InputMaybe<TreatmentWhere>;
};

export type PartnerTreatmentConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<PartnerTreatmentConnectionSort>>;
	where?: InputMaybe<PartnerTreatmentConnectionWhere>;
};

export type PartnerAggregateSelection = {
	__typename?: "PartnerAggregateSelection";
	Description: StringAggregateSelection;
	PartnerType: StringAggregateSelection;
	Phone: StringAggregateSelection;
	Place: StringAggregateSelection;
	Street: StringAggregateSelection;
	ZipCode: IntAggregateSelection;
	count: Scalars["Int"];
};

export type PartnerConnectInput = {
	treatment?: InputMaybe<PartnerTreatmentConnectFieldInput>;
};

export type PartnerConnectWhere = {
	node: PartnerWhere;
};

export type PartnerCreateInput = {
	Description?: InputMaybe<Scalars["String"]>;
	PartnerType?: InputMaybe<Scalars["String"]>;
	Phone?: InputMaybe<Scalars["String"]>;
	Place?: InputMaybe<Scalars["String"]>;
	Street?: InputMaybe<Scalars["String"]>;
	ZipCode?: InputMaybe<Scalars["Int"]>;
	treatment?: InputMaybe<PartnerTreatmentFieldInput>;
};

export type PartnerDeleteInput = {
	treatment?: InputMaybe<PartnerTreatmentDeleteFieldInput>;
};

export type PartnerDisconnectInput = {
	treatment?: InputMaybe<PartnerTreatmentDisconnectFieldInput>;
};

export type PartnerOptions = {
	limit?: InputMaybe<Scalars["Int"]>;
	offset?: InputMaybe<Scalars["Int"]>;
	/** Specify one or more PartnerSort objects to sort Partners by. The sorts will be applied in the order in which they are arranged in the array. */
	sort?: InputMaybe<Array<InputMaybe<PartnerSort>>>;
};

/** Fields to sort Partners by. The order in which sorts are applied is not guaranteed when specifying many fields in one PartnerSort object. */
export type PartnerSort = {
	Description?: InputMaybe<SortDirection>;
	PartnerType?: InputMaybe<SortDirection>;
	Phone?: InputMaybe<SortDirection>;
	Place?: InputMaybe<SortDirection>;
	Street?: InputMaybe<SortDirection>;
	ZipCode?: InputMaybe<SortDirection>;
};

export type PartnerTreatmentAggregateInput = {
	AND?: InputMaybe<Array<PartnerTreatmentAggregateInput>>;
	OR?: InputMaybe<Array<PartnerTreatmentAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<PartnerTreatmentNodeAggregationWhereInput>;
};

export type PartnerTreatmentConnectFieldInput = {
	connect?: InputMaybe<TreatmentConnectInput>;
	where?: InputMaybe<TreatmentConnectWhere>;
};

export type PartnerTreatmentConnection = {
	__typename?: "PartnerTreatmentConnection";
	edges: Array<PartnerTreatmentRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type PartnerTreatmentConnectionSort = {
	node?: InputMaybe<TreatmentSort>;
};

export type PartnerTreatmentConnectionWhere = {
	AND?: InputMaybe<Array<PartnerTreatmentConnectionWhere>>;
	OR?: InputMaybe<Array<PartnerTreatmentConnectionWhere>>;
	node?: InputMaybe<TreatmentWhere>;
	node_NOT?: InputMaybe<TreatmentWhere>;
};

export type PartnerTreatmentCreateFieldInput = {
	node: TreatmentCreateInput;
};

export type PartnerTreatmentDeleteFieldInput = {
	delete?: InputMaybe<TreatmentDeleteInput>;
	where?: InputMaybe<PartnerTreatmentConnectionWhere>;
};

export type PartnerTreatmentDisconnectFieldInput = {
	disconnect?: InputMaybe<TreatmentDisconnectInput>;
	where?: InputMaybe<PartnerTreatmentConnectionWhere>;
};

export type PartnerTreatmentFieldInput = {
	connect?: InputMaybe<PartnerTreatmentConnectFieldInput>;
	create?: InputMaybe<PartnerTreatmentCreateFieldInput>;
};

export type PartnerTreatmentNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<PartnerTreatmentNodeAggregationWhereInput>>;
	BagDossierNo_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	BagDossierNo_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	BagDossierNo_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	BagDossierNo_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	BagDossierNo_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	BagDossierNo_EQUAL?: InputMaybe<Scalars["String"]>;
	BagDossierNo_GT?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_GTE?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LT?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LTE?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	Code_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	Code_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	Code_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	Code_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	Code_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	Code_EQUAL?: InputMaybe<Scalars["String"]>;
	Code_GT?: InputMaybe<Scalars["Int"]>;
	Code_GTE?: InputMaybe<Scalars["Int"]>;
	Code_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Code_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	Code_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	Code_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	Code_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	Code_LT?: InputMaybe<Scalars["Int"]>;
	Code_LTE?: InputMaybe<Scalars["Int"]>;
	Code_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Code_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	Code_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	Code_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	Code_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	FlagModal_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	FlagModal_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	FlagModal_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	FlagModal_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	FlagModal_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	FlagModal_EQUAL?: InputMaybe<Scalars["String"]>;
	FlagModal_GT?: InputMaybe<Scalars["Int"]>;
	FlagModal_GTE?: InputMaybe<Scalars["Int"]>;
	FlagModal_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	FlagModal_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	FlagModal_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	FlagModal_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	FlagModal_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	FlagModal_LT?: InputMaybe<Scalars["Int"]>;
	FlagModal_LTE?: InputMaybe<Scalars["Int"]>;
	FlagModal_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	FlagModal_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	FlagModal_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	FlagModal_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	FlagModal_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	FlagNarcosis_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	FlagNarcosis_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	FlagNarcosis_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	FlagNarcosis_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	FlagNarcosis_EQUAL?: InputMaybe<Scalars["String"]>;
	FlagNarcosis_GT?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_GTE?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LT?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LTE?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	GTIN_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	GTIN_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	GTIN_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	GTIN_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	GTIN_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	GTIN_EQUAL?: InputMaybe<Scalars["String"]>;
	GTIN_GT?: InputMaybe<Scalars["Int"]>;
	GTIN_GTE?: InputMaybe<Scalars["Int"]>;
	GTIN_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	GTIN_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	GTIN_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	GTIN_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	GTIN_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	GTIN_LT?: InputMaybe<Scalars["Int"]>;
	GTIN_LTE?: InputMaybe<Scalars["Int"]>;
	GTIN_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	GTIN_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	GTIN_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	GTIN_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	GTIN_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	LOT_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	LOT_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	LOT_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	LOT_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	LOT_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	LOT_EQUAL?: InputMaybe<Scalars["String"]>;
	LOT_GT?: InputMaybe<Scalars["Int"]>;
	LOT_GTE?: InputMaybe<Scalars["Int"]>;
	LOT_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	LOT_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	LOT_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	LOT_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	LOT_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	LOT_LT?: InputMaybe<Scalars["Int"]>;
	LOT_LTE?: InputMaybe<Scalars["Int"]>;
	LOT_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	LOT_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	LOT_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	LOT_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	LOT_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	Name_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	Name_EQUAL?: InputMaybe<Scalars["String"]>;
	Name_GT?: InputMaybe<Scalars["Int"]>;
	Name_GTE?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	Name_LT?: InputMaybe<Scalars["Int"]>;
	Name_LTE?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	OR?: InputMaybe<Array<PartnerTreatmentNodeAggregationWhereInput>>;
	PharmaCode_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	PharmaCode_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	PharmaCode_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	PharmaCode_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	PharmaCode_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	PharmaCode_EQUAL?: InputMaybe<Scalars["String"]>;
	PharmaCode_GT?: InputMaybe<Scalars["Int"]>;
	PharmaCode_GTE?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LT?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LTE?: InputMaybe<Scalars["Int"]>;
	PharmaCode_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	PharmaCode_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	PharmaCode_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	PharmaCode_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	PharmaCode_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	PrevPharmacode_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	PrevPharmacode_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	PrevPharmacode_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	PrevPharmacode_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	PrevPharmacode_EQUAL?: InputMaybe<Scalars["String"]>;
	PrevPharmacode_GT?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_GTE?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LT?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LTE?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	REF_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	REF_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	REF_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	REF_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	REF_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	REF_EQUAL?: InputMaybe<Scalars["String"]>;
	REF_GT?: InputMaybe<Scalars["Int"]>;
	REF_GTE?: InputMaybe<Scalars["Int"]>;
	REF_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	REF_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	REF_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	REF_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	REF_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	REF_LT?: InputMaybe<Scalars["Int"]>;
	REF_LTE?: InputMaybe<Scalars["Int"]>;
	REF_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	REF_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	REF_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	REF_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	REF_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	SwissmedicCategory_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	SwissmedicCategory_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	SwissmedicCategory_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	SwissmedicCategory_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	SwissmedicCategory_EQUAL?: InputMaybe<Scalars["String"]>;
	SwissmedicCategory_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo8_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo8_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo8_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo8_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo8_EQUAL?: InputMaybe<Scalars["String"]>;
	SwissmedicNo8_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	UDI_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	UDI_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	UDI_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	UDI_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	UDI_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	UDI_EQUAL?: InputMaybe<Scalars["String"]>;
	UDI_GT?: InputMaybe<Scalars["Int"]>;
	UDI_GTE?: InputMaybe<Scalars["Int"]>;
	UDI_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	UDI_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	UDI_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	UDI_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	UDI_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	UDI_LT?: InputMaybe<Scalars["Int"]>;
	UDI_LTE?: InputMaybe<Scalars["Int"]>;
	UDI_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	UDI_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	UDI_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	UDI_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	UDI_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	classificationSystem_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	classificationSystem_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	classificationSystem_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	classificationSystem_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	classificationSystem_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	classificationSystem_EQUAL?: InputMaybe<Scalars["String"]>;
	classificationSystem_GT?: InputMaybe<Scalars["Int"]>;
	classificationSystem_GTE?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LT?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LTE?: InputMaybe<Scalars["Int"]>;
	classificationSystem_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	classificationSystem_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	classificationSystem_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	classificationSystem_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	classificationSystem_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type PartnerTreatmentRelationship = {
	__typename?: "PartnerTreatmentRelationship";
	cursor: Scalars["String"];
	node: Treatment;
};

export type PartnerTreatmentUpdateConnectionInput = {
	node?: InputMaybe<TreatmentUpdateInput>;
};

export type PartnerTreatmentUpdateFieldInput = {
	connect?: InputMaybe<PartnerTreatmentConnectFieldInput>;
	create?: InputMaybe<PartnerTreatmentCreateFieldInput>;
	delete?: InputMaybe<PartnerTreatmentDeleteFieldInput>;
	disconnect?: InputMaybe<PartnerTreatmentDisconnectFieldInput>;
	update?: InputMaybe<PartnerTreatmentUpdateConnectionInput>;
	where?: InputMaybe<PartnerTreatmentConnectionWhere>;
};

export type PartnerUpdateInput = {
	Description?: InputMaybe<Scalars["String"]>;
	PartnerType?: InputMaybe<Scalars["String"]>;
	Phone?: InputMaybe<Scalars["String"]>;
	Place?: InputMaybe<Scalars["String"]>;
	Street?: InputMaybe<Scalars["String"]>;
	ZipCode?: InputMaybe<Scalars["Int"]>;
	treatment?: InputMaybe<PartnerTreatmentUpdateFieldInput>;
};

export type PartnerWhere = {
	AND?: InputMaybe<Array<PartnerWhere>>;
	Description?: InputMaybe<Scalars["String"]>;
	Description_CONTAINS?: InputMaybe<Scalars["String"]>;
	Description_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	Description_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	Description_MATCHES?: InputMaybe<Scalars["String"]>;
	Description_NOT?: InputMaybe<Scalars["String"]>;
	Description_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	Description_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	Description_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	Description_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	Description_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	OR?: InputMaybe<Array<PartnerWhere>>;
	PartnerType?: InputMaybe<Scalars["String"]>;
	PartnerType_CONTAINS?: InputMaybe<Scalars["String"]>;
	PartnerType_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	PartnerType_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	PartnerType_MATCHES?: InputMaybe<Scalars["String"]>;
	PartnerType_NOT?: InputMaybe<Scalars["String"]>;
	PartnerType_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	PartnerType_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	PartnerType_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	PartnerType_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	PartnerType_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	Phone?: InputMaybe<Scalars["String"]>;
	Phone_CONTAINS?: InputMaybe<Scalars["String"]>;
	Phone_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	Phone_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	Phone_MATCHES?: InputMaybe<Scalars["String"]>;
	Phone_NOT?: InputMaybe<Scalars["String"]>;
	Phone_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	Phone_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	Phone_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	Phone_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	Phone_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	Place?: InputMaybe<Scalars["String"]>;
	Place_CONTAINS?: InputMaybe<Scalars["String"]>;
	Place_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	Place_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	Place_MATCHES?: InputMaybe<Scalars["String"]>;
	Place_NOT?: InputMaybe<Scalars["String"]>;
	Place_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	Place_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	Place_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	Place_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	Place_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	Street?: InputMaybe<Scalars["String"]>;
	Street_CONTAINS?: InputMaybe<Scalars["String"]>;
	Street_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	Street_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	Street_MATCHES?: InputMaybe<Scalars["String"]>;
	Street_NOT?: InputMaybe<Scalars["String"]>;
	Street_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	Street_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	Street_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	Street_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	Street_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	ZipCode?: InputMaybe<Scalars["Int"]>;
	ZipCode_GT?: InputMaybe<Scalars["Int"]>;
	ZipCode_GTE?: InputMaybe<Scalars["Int"]>;
	ZipCode_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	ZipCode_LT?: InputMaybe<Scalars["Int"]>;
	ZipCode_LTE?: InputMaybe<Scalars["Int"]>;
	ZipCode_NOT?: InputMaybe<Scalars["Int"]>;
	ZipCode_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	treatment?: InputMaybe<TreatmentWhere>;
	treatmentAggregate?: InputMaybe<PartnerTreatmentAggregateInput>;
	treatmentConnection?: InputMaybe<PartnerTreatmentConnectionWhere>;
	treatmentConnection_NOT?: InputMaybe<PartnerTreatmentConnectionWhere>;
	treatment_NOT?: InputMaybe<TreatmentWhere>;
};

export type Patient = {
	__typename?: "Patient";
	assignedFlexEntities: Array<FlexEntity>;
	assignedFlexEntitiesConnection: PatientAssignedFlexEntitiesConnection;
	cases: Array<Case>;
	casesConnection: PatientCasesConnection;
	claims: Array<Claim>;
	claimsConnection: PatientClaimsConnection;
	coverageRequests: Array<CoverageRequest>;
	coverageRequestsConnection: PatientCoverageRequestsConnection;
	id: Scalars["ID"];
	initials?: Maybe<Scalars["String"]>;
	insuranceId?: Maybe<Scalars["String"]>;
	primaryIntervention?: Maybe<Intervention>;
	primaryInterventionConnection: PatientPrimaryInterventionConnection;
	sentClaim: Array<Claim>;
	sentClaimConnection: PatientSentClaimConnection;
	tenantId?: Maybe<Scalars["String"]>;
	timeStamp: Scalars["DateTime"];
	yearOfBirth?: Maybe<Scalars["Int"]>;
};

export type PatientAssignedFlexEntitiesArgs = {
	options?: InputMaybe<FlexEntityOptions>;
	where?: InputMaybe<FlexEntityWhere>;
};

export type PatientAssignedFlexEntitiesConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<PatientAssignedFlexEntitiesConnectionSort>>;
	where?: InputMaybe<PatientAssignedFlexEntitiesConnectionWhere>;
};

export type PatientCasesArgs = {
	options?: InputMaybe<CaseOptions>;
	where?: InputMaybe<CaseWhere>;
};

export type PatientCasesConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<PatientCasesConnectionSort>>;
	where?: InputMaybe<PatientCasesConnectionWhere>;
};

export type PatientClaimsArgs = {
	options?: InputMaybe<ClaimOptions>;
	where?: InputMaybe<ClaimWhere>;
};

export type PatientClaimsConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<PatientClaimsConnectionSort>>;
	where?: InputMaybe<PatientClaimsConnectionWhere>;
};

export type PatientCoverageRequestsArgs = {
	options?: InputMaybe<CoverageRequestOptions>;
	where?: InputMaybe<CoverageRequestWhere>;
};

export type PatientCoverageRequestsConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<PatientCoverageRequestsConnectionSort>>;
	where?: InputMaybe<PatientCoverageRequestsConnectionWhere>;
};

export type PatientPrimaryInterventionArgs = {
	options?: InputMaybe<InterventionOptions>;
	where?: InputMaybe<InterventionWhere>;
};

export type PatientPrimaryInterventionConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<PatientPrimaryInterventionConnectionSort>>;
	where?: InputMaybe<PatientPrimaryInterventionConnectionWhere>;
};

export type PatientSentClaimArgs = {
	options?: InputMaybe<ClaimOptions>;
	where?: InputMaybe<ClaimWhere>;
};

export type PatientSentClaimConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<PatientSentClaimConnectionSort>>;
	where?: InputMaybe<PatientSentClaimConnectionWhere>;
};

export type PatientAggregateSelection = {
	__typename?: "PatientAggregateSelection";
	count: Scalars["Int"];
	id: IdAggregateSelection;
	initials: StringAggregateSelection;
	insuranceId: StringAggregateSelection;
	tenantId: StringAggregateSelection;
	timeStamp: DateTimeAggregateSelection;
	yearOfBirth: IntAggregateSelection;
};

export type PatientAssignedFlexEntitiesAggregateInput = {
	AND?: InputMaybe<Array<PatientAssignedFlexEntitiesAggregateInput>>;
	OR?: InputMaybe<Array<PatientAssignedFlexEntitiesAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<PatientAssignedFlexEntitiesNodeAggregationWhereInput>;
};

export type PatientAssignedFlexEntitiesConnectFieldInput = {
	connect?: InputMaybe<Array<FlexEntityConnectInput>>;
	where?: InputMaybe<FlexEntityConnectWhere>;
};

export type PatientAssignedFlexEntitiesConnection = {
	__typename?: "PatientAssignedFlexEntitiesConnection";
	edges: Array<PatientAssignedFlexEntitiesRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type PatientAssignedFlexEntitiesConnectionSort = {
	node?: InputMaybe<FlexEntitySort>;
};

export type PatientAssignedFlexEntitiesConnectionWhere = {
	AND?: InputMaybe<Array<PatientAssignedFlexEntitiesConnectionWhere>>;
	OR?: InputMaybe<Array<PatientAssignedFlexEntitiesConnectionWhere>>;
	node?: InputMaybe<FlexEntityWhere>;
	node_NOT?: InputMaybe<FlexEntityWhere>;
};

export type PatientAssignedFlexEntitiesCreateFieldInput = {
	node: FlexEntityCreateInput;
};

export type PatientAssignedFlexEntitiesDeleteFieldInput = {
	delete?: InputMaybe<FlexEntityDeleteInput>;
	where?: InputMaybe<PatientAssignedFlexEntitiesConnectionWhere>;
};

export type PatientAssignedFlexEntitiesDisconnectFieldInput = {
	disconnect?: InputMaybe<FlexEntityDisconnectInput>;
	where?: InputMaybe<PatientAssignedFlexEntitiesConnectionWhere>;
};

export type PatientAssignedFlexEntitiesFieldInput = {
	connect?: InputMaybe<Array<PatientAssignedFlexEntitiesConnectFieldInput>>;
	create?: InputMaybe<Array<PatientAssignedFlexEntitiesCreateFieldInput>>;
};

export type PatientAssignedFlexEntitiesNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<PatientAssignedFlexEntitiesNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<PatientAssignedFlexEntitiesNodeAggregationWhereInput>>;
	administrationDate_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_GT?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_GTE?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_LT?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_LTE?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdByName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	createdByName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	createdByName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	createdByName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	createdByName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	createdByName_EQUAL?: InputMaybe<Scalars["String"]>;
	createdByName_GT?: InputMaybe<Scalars["Int"]>;
	createdByName_GTE?: InputMaybe<Scalars["Int"]>;
	createdByName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	createdByName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	createdByName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	createdByName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	createdByName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	createdByName_LT?: InputMaybe<Scalars["Int"]>;
	createdByName_LTE?: InputMaybe<Scalars["Int"]>;
	createdByName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	createdByName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	createdByName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	createdByName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	createdByName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	createdOn_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	data_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	data_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	data_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	data_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	data_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	data_EQUAL?: InputMaybe<Scalars["String"]>;
	data_GT?: InputMaybe<Scalars["Int"]>;
	data_GTE?: InputMaybe<Scalars["Int"]>;
	data_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	data_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	data_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	data_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	data_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	data_LT?: InputMaybe<Scalars["Int"]>;
	data_LTE?: InputMaybe<Scalars["Int"]>;
	data_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	data_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	data_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	data_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	data_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	lastUpdatedOn_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_GT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_LT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	patientId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	patientId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	patientId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	patientId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	patientId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	patientId_EQUAL?: InputMaybe<Scalars["String"]>;
	patientId_GT?: InputMaybe<Scalars["Int"]>;
	patientId_GTE?: InputMaybe<Scalars["Int"]>;
	patientId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	patientId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	patientId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	patientId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	patientId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	patientId_LT?: InputMaybe<Scalars["Int"]>;
	patientId_LTE?: InputMaybe<Scalars["Int"]>;
	patientId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	patientId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	patientId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	patientId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	patientId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	preparationBrandNames_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	preparationBrandNames_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	preparationBrandNames_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	preparationBrandNames_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	preparationBrandNames_EQUAL?: InputMaybe<Scalars["String"]>;
	preparationBrandNames_GT?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_GTE?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_LT?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_LTE?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationBrandNames_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	preparationGenericNames_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	preparationGenericNames_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	preparationGenericNames_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	preparationGenericNames_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	preparationGenericNames_EQUAL?: InputMaybe<Scalars["String"]>;
	preparationGenericNames_GT?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_GTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_LT?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_LTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationGenericNames_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	quantity_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	quantity_EQUAL?: InputMaybe<Scalars["Int"]>;
	quantity_GT?: InputMaybe<Scalars["Int"]>;
	quantity_GTE?: InputMaybe<Scalars["Int"]>;
	quantity_LT?: InputMaybe<Scalars["Int"]>;
	quantity_LTE?: InputMaybe<Scalars["Int"]>;
	quantity_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	quantity_MAX_GT?: InputMaybe<Scalars["Int"]>;
	quantity_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	quantity_MAX_LT?: InputMaybe<Scalars["Int"]>;
	quantity_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	quantity_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	quantity_MIN_GT?: InputMaybe<Scalars["Int"]>;
	quantity_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	quantity_MIN_LT?: InputMaybe<Scalars["Int"]>;
	quantity_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	tenantId_EQUAL?: InputMaybe<Scalars["String"]>;
	tenantId_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	unlimited_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	unlimited_EQUAL?: InputMaybe<Scalars["Int"]>;
	unlimited_GT?: InputMaybe<Scalars["Int"]>;
	unlimited_GTE?: InputMaybe<Scalars["Int"]>;
	unlimited_LT?: InputMaybe<Scalars["Int"]>;
	unlimited_LTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_GT?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_LT?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_GT?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_LT?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	uuid_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	uuid_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	uuid_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	uuid_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	uuid_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	uuid_EQUAL?: InputMaybe<Scalars["String"]>;
	uuid_GT?: InputMaybe<Scalars["Int"]>;
	uuid_GTE?: InputMaybe<Scalars["Int"]>;
	uuid_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	uuid_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	uuid_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	uuid_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	uuid_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	uuid_LT?: InputMaybe<Scalars["Int"]>;
	uuid_LTE?: InputMaybe<Scalars["Int"]>;
	uuid_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	uuid_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	uuid_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	uuid_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	uuid_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type PatientAssignedFlexEntitiesRelationship = {
	__typename?: "PatientAssignedFlexEntitiesRelationship";
	cursor: Scalars["String"];
	node: FlexEntity;
};

export type PatientAssignedFlexEntitiesUpdateConnectionInput = {
	node?: InputMaybe<FlexEntityUpdateInput>;
};

export type PatientAssignedFlexEntitiesUpdateFieldInput = {
	connect?: InputMaybe<Array<PatientAssignedFlexEntitiesConnectFieldInput>>;
	create?: InputMaybe<Array<PatientAssignedFlexEntitiesCreateFieldInput>>;
	delete?: InputMaybe<Array<PatientAssignedFlexEntitiesDeleteFieldInput>>;
	disconnect?: InputMaybe<Array<PatientAssignedFlexEntitiesDisconnectFieldInput>>;
	update?: InputMaybe<PatientAssignedFlexEntitiesUpdateConnectionInput>;
	where?: InputMaybe<PatientAssignedFlexEntitiesConnectionWhere>;
};

export type PatientCasesAggregateInput = {
	AND?: InputMaybe<Array<PatientCasesAggregateInput>>;
	OR?: InputMaybe<Array<PatientCasesAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<PatientCasesNodeAggregationWhereInput>;
};

export type PatientCasesConnectFieldInput = {
	connect?: InputMaybe<Array<CaseConnectInput>>;
	where?: InputMaybe<CaseConnectWhere>;
};

export type PatientCasesConnection = {
	__typename?: "PatientCasesConnection";
	edges: Array<PatientCasesRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type PatientCasesConnectionSort = {
	node?: InputMaybe<CaseSort>;
};

export type PatientCasesConnectionWhere = {
	AND?: InputMaybe<Array<PatientCasesConnectionWhere>>;
	OR?: InputMaybe<Array<PatientCasesConnectionWhere>>;
	node?: InputMaybe<CaseWhere>;
	node_NOT?: InputMaybe<CaseWhere>;
};

export type PatientCasesCreateFieldInput = {
	node: CaseCreateInput;
};

export type PatientCasesDeleteFieldInput = {
	delete?: InputMaybe<CaseDeleteInput>;
	where?: InputMaybe<PatientCasesConnectionWhere>;
};

export type PatientCasesDisconnectFieldInput = {
	disconnect?: InputMaybe<CaseDisconnectInput>;
	where?: InputMaybe<PatientCasesConnectionWhere>;
};

export type PatientCasesFieldInput = {
	connect?: InputMaybe<Array<PatientCasesConnectFieldInput>>;
	create?: InputMaybe<Array<PatientCasesCreateFieldInput>>;
};

export type PatientCasesNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<PatientCasesNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<PatientCasesNodeAggregationWhereInput>>;
	actualAgreementId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	actualAgreementId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	actualAgreementId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	actualAgreementId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	actualAgreementId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	actualAgreementId_EQUAL?: InputMaybe<Scalars["String"]>;
	actualAgreementId_GT?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_GTE?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_LT?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_LTE?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	agreementName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	agreementName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	agreementName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	agreementName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	agreementName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	agreementName_EQUAL?: InputMaybe<Scalars["String"]>;
	agreementName_GT?: InputMaybe<Scalars["Int"]>;
	agreementName_GTE?: InputMaybe<Scalars["Int"]>;
	agreementName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	agreementName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	agreementName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	agreementName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	agreementName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	agreementName_LT?: InputMaybe<Scalars["Int"]>;
	agreementName_LTE?: InputMaybe<Scalars["Int"]>;
	agreementName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	agreementName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	agreementName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	agreementName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	agreementName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	patientInitials_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	patientInitials_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	patientInitials_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	patientInitials_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	patientInitials_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	patientInitials_EQUAL?: InputMaybe<Scalars["String"]>;
	patientInitials_GT?: InputMaybe<Scalars["Int"]>;
	patientInitials_GTE?: InputMaybe<Scalars["Int"]>;
	patientInitials_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	patientInitials_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	patientInitials_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	patientInitials_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	patientInitials_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	patientInitials_LT?: InputMaybe<Scalars["Int"]>;
	patientInitials_LTE?: InputMaybe<Scalars["Int"]>;
	patientInitials_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	patientInitials_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	patientInitials_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	patientInitials_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	patientInitials_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	patientInsuranceId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	patientInsuranceId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	patientInsuranceId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	patientInsuranceId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	patientInsuranceId_EQUAL?: InputMaybe<Scalars["String"]>;
	patientInsuranceId_GT?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_GTE?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_LT?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_LTE?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationBandName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	preparationBandName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	preparationBandName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	preparationBandName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	preparationBandName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	preparationBandName_EQUAL?: InputMaybe<Scalars["String"]>;
	preparationBandName_GT?: InputMaybe<Scalars["Int"]>;
	preparationBandName_GTE?: InputMaybe<Scalars["Int"]>;
	preparationBandName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationBandName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationBandName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationBandName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationBandName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationBandName_LT?: InputMaybe<Scalars["Int"]>;
	preparationBandName_LTE?: InputMaybe<Scalars["Int"]>;
	preparationBandName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationBandName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationBandName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationBandName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationBandName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	preparationGenericName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	preparationGenericName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	preparationGenericName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	preparationGenericName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	preparationGenericName_EQUAL?: InputMaybe<Scalars["String"]>;
	preparationGenericName_GT?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_GTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_LT?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_LTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	sourceTenantId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	sourceTenantId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	sourceTenantId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	sourceTenantId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	sourceTenantId_EQUAL?: InputMaybe<Scalars["String"]>;
	sourceTenantId_GT?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_GTE?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_LT?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_LTE?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	submissionDate_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_GT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_GTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_LT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_LTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	totalAmount_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	totalAmount_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	totalAmount_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	totalAmount_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	totalAmount_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	totalAmount_EQUAL?: InputMaybe<Scalars["Float"]>;
	totalAmount_GT?: InputMaybe<Scalars["Float"]>;
	totalAmount_GTE?: InputMaybe<Scalars["Float"]>;
	totalAmount_LT?: InputMaybe<Scalars["Float"]>;
	totalAmount_LTE?: InputMaybe<Scalars["Float"]>;
	totalAmount_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	totalAmount_MAX_GT?: InputMaybe<Scalars["Float"]>;
	totalAmount_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	totalAmount_MAX_LT?: InputMaybe<Scalars["Float"]>;
	totalAmount_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	totalAmount_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	totalAmount_MIN_GT?: InputMaybe<Scalars["Float"]>;
	totalAmount_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	totalAmount_MIN_LT?: InputMaybe<Scalars["Float"]>;
	totalAmount_MIN_LTE?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	unlimited_EQUAL?: InputMaybe<Scalars["Int"]>;
	unlimited_GT?: InputMaybe<Scalars["Int"]>;
	unlimited_GTE?: InputMaybe<Scalars["Int"]>;
	unlimited_LT?: InputMaybe<Scalars["Int"]>;
	unlimited_LTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_GT?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_LT?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_GT?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_LT?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_LTE?: InputMaybe<Scalars["Int"]>;
};

export type PatientCasesRelationship = {
	__typename?: "PatientCasesRelationship";
	cursor: Scalars["String"];
	node: Case;
};

export type PatientCasesUpdateConnectionInput = {
	node?: InputMaybe<CaseUpdateInput>;
};

export type PatientCasesUpdateFieldInput = {
	connect?: InputMaybe<Array<PatientCasesConnectFieldInput>>;
	create?: InputMaybe<Array<PatientCasesCreateFieldInput>>;
	delete?: InputMaybe<Array<PatientCasesDeleteFieldInput>>;
	disconnect?: InputMaybe<Array<PatientCasesDisconnectFieldInput>>;
	update?: InputMaybe<PatientCasesUpdateConnectionInput>;
	where?: InputMaybe<PatientCasesConnectionWhere>;
};

export type PatientClaimsAggregateInput = {
	AND?: InputMaybe<Array<PatientClaimsAggregateInput>>;
	OR?: InputMaybe<Array<PatientClaimsAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<PatientClaimsNodeAggregationWhereInput>;
};

export type PatientClaimsConnectFieldInput = {
	connect?: InputMaybe<Array<ClaimConnectInput>>;
	where?: InputMaybe<ClaimConnectWhere>;
};

export type PatientClaimsConnection = {
	__typename?: "PatientClaimsConnection";
	edges: Array<PatientClaimsRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type PatientClaimsConnectionSort = {
	node?: InputMaybe<ClaimSort>;
};

export type PatientClaimsConnectionWhere = {
	AND?: InputMaybe<Array<PatientClaimsConnectionWhere>>;
	OR?: InputMaybe<Array<PatientClaimsConnectionWhere>>;
	node?: InputMaybe<ClaimWhere>;
	node_NOT?: InputMaybe<ClaimWhere>;
};

export type PatientClaimsCreateFieldInput = {
	node: ClaimCreateInput;
};

export type PatientClaimsDeleteFieldInput = {
	delete?: InputMaybe<ClaimDeleteInput>;
	where?: InputMaybe<PatientClaimsConnectionWhere>;
};

export type PatientClaimsDisconnectFieldInput = {
	disconnect?: InputMaybe<ClaimDisconnectInput>;
	where?: InputMaybe<PatientClaimsConnectionWhere>;
};

export type PatientClaimsFieldInput = {
	connect?: InputMaybe<Array<PatientClaimsConnectFieldInput>>;
	create?: InputMaybe<Array<PatientClaimsCreateFieldInput>>;
};

export type PatientClaimsNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<PatientClaimsNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<PatientClaimsNodeAggregationWhereInput>>;
	administrationDate_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	administrationDate_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	administrationDate_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	administrationDate_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	administrationDate_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	administrationDate_EQUAL?: InputMaybe<Scalars["String"]>;
	administrationDate_GT?: InputMaybe<Scalars["Int"]>;
	administrationDate_GTE?: InputMaybe<Scalars["Int"]>;
	administrationDate_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	administrationDate_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	administrationDate_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	administrationDate_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	administrationDate_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	administrationDate_LT?: InputMaybe<Scalars["Int"]>;
	administrationDate_LTE?: InputMaybe<Scalars["Int"]>;
	administrationDate_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	administrationDate_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	administrationDate_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	administrationDate_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	administrationDate_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	assignee_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	assignee_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	assignee_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	assignee_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	assignee_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	assignee_EQUAL?: InputMaybe<Scalars["String"]>;
	assignee_GT?: InputMaybe<Scalars["Int"]>;
	assignee_GTE?: InputMaybe<Scalars["Int"]>;
	assignee_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	assignee_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	assignee_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	assignee_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	assignee_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	assignee_LT?: InputMaybe<Scalars["Int"]>;
	assignee_LTE?: InputMaybe<Scalars["Int"]>;
	assignee_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	assignee_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	assignee_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	assignee_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	assignee_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	claimId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	claimId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	claimId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	claimId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	claimId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	claimId_EQUAL?: InputMaybe<Scalars["String"]>;
	claimId_GT?: InputMaybe<Scalars["Int"]>;
	claimId_GTE?: InputMaybe<Scalars["Int"]>;
	claimId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	claimId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	claimId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	claimId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	claimId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	claimId_LT?: InputMaybe<Scalars["Int"]>;
	claimId_LTE?: InputMaybe<Scalars["Int"]>;
	claimId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	claimId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	claimId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	claimId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	claimId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	createdOn_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	invoiceAmount_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	invoiceAmount_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	invoiceAmount_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	invoiceAmount_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	invoiceAmount_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	invoiceAmount_EQUAL?: InputMaybe<Scalars["String"]>;
	invoiceAmount_GT?: InputMaybe<Scalars["Int"]>;
	invoiceAmount_GTE?: InputMaybe<Scalars["Int"]>;
	invoiceAmount_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	invoiceAmount_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	invoiceAmount_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	invoiceAmount_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	invoiceAmount_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	invoiceAmount_LT?: InputMaybe<Scalars["Int"]>;
	invoiceAmount_LTE?: InputMaybe<Scalars["Int"]>;
	invoiceAmount_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	invoiceAmount_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	invoiceAmount_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	invoiceAmount_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	invoiceAmount_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	invoiceDate_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	invoiceDate_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	invoiceDate_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	invoiceDate_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	invoiceDate_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	invoiceDate_EQUAL?: InputMaybe<Scalars["String"]>;
	invoiceDate_GT?: InputMaybe<Scalars["Int"]>;
	invoiceDate_GTE?: InputMaybe<Scalars["Int"]>;
	invoiceDate_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	invoiceDate_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	invoiceDate_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	invoiceDate_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	invoiceDate_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	invoiceDate_LT?: InputMaybe<Scalars["Int"]>;
	invoiceDate_LTE?: InputMaybe<Scalars["Int"]>;
	invoiceDate_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	invoiceDate_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	invoiceDate_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	invoiceDate_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	invoiceDate_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	invoiceNumber_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	invoiceNumber_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	invoiceNumber_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	invoiceNumber_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	invoiceNumber_EQUAL?: InputMaybe<Scalars["String"]>;
	invoiceNumber_GT?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_GTE?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_LT?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_LTE?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationIdType_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	preparationIdType_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	preparationIdType_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	preparationIdType_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	preparationIdType_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	preparationIdType_EQUAL?: InputMaybe<Scalars["String"]>;
	preparationIdType_GT?: InputMaybe<Scalars["Int"]>;
	preparationIdType_GTE?: InputMaybe<Scalars["Int"]>;
	preparationIdType_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationIdType_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationIdType_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationIdType_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationIdType_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationIdType_LT?: InputMaybe<Scalars["Int"]>;
	preparationIdType_LTE?: InputMaybe<Scalars["Int"]>;
	preparationIdType_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationIdType_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationIdType_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationIdType_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationIdType_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	preparationId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	preparationId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	preparationId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	preparationId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	preparationId_EQUAL?: InputMaybe<Scalars["String"]>;
	preparationId_GT?: InputMaybe<Scalars["Int"]>;
	preparationId_GTE?: InputMaybe<Scalars["Int"]>;
	preparationId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationId_LT?: InputMaybe<Scalars["Int"]>;
	preparationId_LTE?: InputMaybe<Scalars["Int"]>;
	preparationId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	providerId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	providerId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	providerId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	providerId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	providerId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	providerId_EQUAL?: InputMaybe<Scalars["String"]>;
	providerId_GT?: InputMaybe<Scalars["Int"]>;
	providerId_GTE?: InputMaybe<Scalars["Int"]>;
	providerId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	providerId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	providerId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	providerId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	providerId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	providerId_LT?: InputMaybe<Scalars["Int"]>;
	providerId_LTE?: InputMaybe<Scalars["Int"]>;
	providerId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	providerId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	providerId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	providerId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	providerId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	providerName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	providerName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	providerName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	providerName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	providerName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	providerName_EQUAL?: InputMaybe<Scalars["String"]>;
	providerName_GT?: InputMaybe<Scalars["Int"]>;
	providerName_GTE?: InputMaybe<Scalars["Int"]>;
	providerName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	providerName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	providerName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	providerName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	providerName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	providerName_LT?: InputMaybe<Scalars["Int"]>;
	providerName_LTE?: InputMaybe<Scalars["Int"]>;
	providerName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	providerName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	providerName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	providerName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	providerName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	quantity_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	quantity_EQUAL?: InputMaybe<Scalars["String"]>;
	quantity_GT?: InputMaybe<Scalars["Int"]>;
	quantity_GTE?: InputMaybe<Scalars["Int"]>;
	quantity_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	quantity_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	quantity_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	quantity_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	quantity_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	quantity_LT?: InputMaybe<Scalars["Int"]>;
	quantity_LTE?: InputMaybe<Scalars["Int"]>;
	quantity_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	quantity_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	quantity_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	quantity_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	quantity_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	tenantId_EQUAL?: InputMaybe<Scalars["String"]>;
	tenantId_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type PatientClaimsRelationship = {
	__typename?: "PatientClaimsRelationship";
	cursor: Scalars["String"];
	node: Claim;
};

export type PatientClaimsUpdateConnectionInput = {
	node?: InputMaybe<ClaimUpdateInput>;
};

export type PatientClaimsUpdateFieldInput = {
	connect?: InputMaybe<Array<PatientClaimsConnectFieldInput>>;
	create?: InputMaybe<Array<PatientClaimsCreateFieldInput>>;
	delete?: InputMaybe<Array<PatientClaimsDeleteFieldInput>>;
	disconnect?: InputMaybe<Array<PatientClaimsDisconnectFieldInput>>;
	update?: InputMaybe<PatientClaimsUpdateConnectionInput>;
	where?: InputMaybe<PatientClaimsConnectionWhere>;
};

export type PatientConnectInput = {
	assignedFlexEntities?: InputMaybe<Array<PatientAssignedFlexEntitiesConnectFieldInput>>;
	cases?: InputMaybe<Array<PatientCasesConnectFieldInput>>;
	claims?: InputMaybe<Array<PatientClaimsConnectFieldInput>>;
	coverageRequests?: InputMaybe<Array<PatientCoverageRequestsConnectFieldInput>>;
	primaryIntervention?: InputMaybe<PatientPrimaryInterventionConnectFieldInput>;
	sentClaim?: InputMaybe<Array<PatientSentClaimConnectFieldInput>>;
};

export type PatientConnectWhere = {
	node: PatientWhere;
};

export type PatientCountDataPoint = {
	__typename?: "PatientCountDataPoint";
	PIAndSIPatientCount: Scalars["Int"];
	PIOnlyPatientCount: Scalars["Int"];
	isConditionMet: Scalars["Boolean"];
};

export type PatientCountDataPointAggregateSelection = {
	__typename?: "PatientCountDataPointAggregateSelection";
	PIAndSIPatientCount: IntAggregateSelection;
	PIOnlyPatientCount: IntAggregateSelection;
	count: Scalars["Int"];
};

export type PatientCountDataPointOptions = {
	limit?: InputMaybe<Scalars["Int"]>;
	offset?: InputMaybe<Scalars["Int"]>;
	/** Specify one or more PatientCountDataPointSort objects to sort PatientCountDataPoints by. The sorts will be applied in the order in which they are arranged in the array. */
	sort?: InputMaybe<Array<InputMaybe<PatientCountDataPointSort>>>;
};

/** Fields to sort PatientCountDataPoints by. The order in which sorts are applied is not guaranteed when specifying many fields in one PatientCountDataPointSort object. */
export type PatientCountDataPointSort = {
	PIAndSIPatientCount?: InputMaybe<SortDirection>;
	PIOnlyPatientCount?: InputMaybe<SortDirection>;
	isConditionMet?: InputMaybe<SortDirection>;
};

export type PatientCountDataPointWhere = {
	AND?: InputMaybe<Array<PatientCountDataPointWhere>>;
	OR?: InputMaybe<Array<PatientCountDataPointWhere>>;
	PIAndSIPatientCount?: InputMaybe<Scalars["Int"]>;
	PIAndSIPatientCount_GT?: InputMaybe<Scalars["Int"]>;
	PIAndSIPatientCount_GTE?: InputMaybe<Scalars["Int"]>;
	PIAndSIPatientCount_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	PIAndSIPatientCount_LT?: InputMaybe<Scalars["Int"]>;
	PIAndSIPatientCount_LTE?: InputMaybe<Scalars["Int"]>;
	PIAndSIPatientCount_NOT?: InputMaybe<Scalars["Int"]>;
	PIAndSIPatientCount_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	PIOnlyPatientCount?: InputMaybe<Scalars["Int"]>;
	PIOnlyPatientCount_GT?: InputMaybe<Scalars["Int"]>;
	PIOnlyPatientCount_GTE?: InputMaybe<Scalars["Int"]>;
	PIOnlyPatientCount_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	PIOnlyPatientCount_LT?: InputMaybe<Scalars["Int"]>;
	PIOnlyPatientCount_LTE?: InputMaybe<Scalars["Int"]>;
	PIOnlyPatientCount_NOT?: InputMaybe<Scalars["Int"]>;
	PIOnlyPatientCount_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	isConditionMet?: InputMaybe<Scalars["Boolean"]>;
	isConditionMet_NOT?: InputMaybe<Scalars["Boolean"]>;
};

export type PatientCoverageRequestsAggregateInput = {
	AND?: InputMaybe<Array<PatientCoverageRequestsAggregateInput>>;
	OR?: InputMaybe<Array<PatientCoverageRequestsAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<PatientCoverageRequestsNodeAggregationWhereInput>;
};

export type PatientCoverageRequestsConnectFieldInput = {
	connect?: InputMaybe<Array<CoverageRequestConnectInput>>;
	where?: InputMaybe<CoverageRequestConnectWhere>;
};

export type PatientCoverageRequestsConnection = {
	__typename?: "PatientCoverageRequestsConnection";
	edges: Array<PatientCoverageRequestsRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type PatientCoverageRequestsConnectionSort = {
	node?: InputMaybe<CoverageRequestSort>;
};

export type PatientCoverageRequestsConnectionWhere = {
	AND?: InputMaybe<Array<PatientCoverageRequestsConnectionWhere>>;
	OR?: InputMaybe<Array<PatientCoverageRequestsConnectionWhere>>;
	node?: InputMaybe<CoverageRequestWhere>;
	node_NOT?: InputMaybe<CoverageRequestWhere>;
};

export type PatientCoverageRequestsCreateFieldInput = {
	node: CoverageRequestCreateInput;
};

export type PatientCoverageRequestsDeleteFieldInput = {
	delete?: InputMaybe<CoverageRequestDeleteInput>;
	where?: InputMaybe<PatientCoverageRequestsConnectionWhere>;
};

export type PatientCoverageRequestsDisconnectFieldInput = {
	disconnect?: InputMaybe<CoverageRequestDisconnectInput>;
	where?: InputMaybe<PatientCoverageRequestsConnectionWhere>;
};

export type PatientCoverageRequestsFieldInput = {
	connect?: InputMaybe<Array<PatientCoverageRequestsConnectFieldInput>>;
	create?: InputMaybe<Array<PatientCoverageRequestsCreateFieldInput>>;
};

export type PatientCoverageRequestsNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<PatientCoverageRequestsNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<PatientCoverageRequestsNodeAggregationWhereInput>>;
	createdOn_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	duration_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	duration_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	duration_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	duration_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	duration_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	duration_EQUAL?: InputMaybe<Scalars["Int"]>;
	duration_GT?: InputMaybe<Scalars["Int"]>;
	duration_GTE?: InputMaybe<Scalars["Int"]>;
	duration_LT?: InputMaybe<Scalars["Int"]>;
	duration_LTE?: InputMaybe<Scalars["Int"]>;
	duration_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	duration_MAX_GT?: InputMaybe<Scalars["Int"]>;
	duration_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	duration_MAX_LT?: InputMaybe<Scalars["Int"]>;
	duration_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	duration_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	duration_MIN_GT?: InputMaybe<Scalars["Int"]>;
	duration_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	duration_MIN_LT?: InputMaybe<Scalars["Int"]>;
	duration_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	lastUpdatedOn_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_GT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_LT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_GT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_GTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_LT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_LTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	tenantId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	tenantId_EQUAL?: InputMaybe<Scalars["String"]>;
	tenantId_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type PatientCoverageRequestsRelationship = {
	__typename?: "PatientCoverageRequestsRelationship";
	cursor: Scalars["String"];
	node: CoverageRequest;
};

export type PatientCoverageRequestsUpdateConnectionInput = {
	node?: InputMaybe<CoverageRequestUpdateInput>;
};

export type PatientCoverageRequestsUpdateFieldInput = {
	connect?: InputMaybe<Array<PatientCoverageRequestsConnectFieldInput>>;
	create?: InputMaybe<Array<PatientCoverageRequestsCreateFieldInput>>;
	delete?: InputMaybe<Array<PatientCoverageRequestsDeleteFieldInput>>;
	disconnect?: InputMaybe<Array<PatientCoverageRequestsDisconnectFieldInput>>;
	update?: InputMaybe<PatientCoverageRequestsUpdateConnectionInput>;
	where?: InputMaybe<PatientCoverageRequestsConnectionWhere>;
};

export type PatientCreateInput = {
	assignedFlexEntities?: InputMaybe<PatientAssignedFlexEntitiesFieldInput>;
	cases?: InputMaybe<PatientCasesFieldInput>;
	claims?: InputMaybe<PatientClaimsFieldInput>;
	coverageRequests?: InputMaybe<PatientCoverageRequestsFieldInput>;
	id: Scalars["ID"];
	initials?: InputMaybe<Scalars["String"]>;
	insuranceId?: InputMaybe<Scalars["String"]>;
	primaryIntervention?: InputMaybe<PatientPrimaryInterventionFieldInput>;
	sentClaim?: InputMaybe<PatientSentClaimFieldInput>;
	tenantId?: InputMaybe<Scalars["String"]>;
	timeStamp: Scalars["DateTime"];
	yearOfBirth?: InputMaybe<Scalars["Int"]>;
};

export type PatientDeleteInput = {
	assignedFlexEntities?: InputMaybe<Array<PatientAssignedFlexEntitiesDeleteFieldInput>>;
	cases?: InputMaybe<Array<PatientCasesDeleteFieldInput>>;
	claims?: InputMaybe<Array<PatientClaimsDeleteFieldInput>>;
	coverageRequests?: InputMaybe<Array<PatientCoverageRequestsDeleteFieldInput>>;
	primaryIntervention?: InputMaybe<PatientPrimaryInterventionDeleteFieldInput>;
	sentClaim?: InputMaybe<Array<PatientSentClaimDeleteFieldInput>>;
};

export type PatientDisconnectInput = {
	assignedFlexEntities?: InputMaybe<Array<PatientAssignedFlexEntitiesDisconnectFieldInput>>;
	cases?: InputMaybe<Array<PatientCasesDisconnectFieldInput>>;
	claims?: InputMaybe<Array<PatientClaimsDisconnectFieldInput>>;
	coverageRequests?: InputMaybe<Array<PatientCoverageRequestsDisconnectFieldInput>>;
	primaryIntervention?: InputMaybe<PatientPrimaryInterventionDisconnectFieldInput>;
	sentClaim?: InputMaybe<Array<PatientSentClaimDisconnectFieldInput>>;
};

export type PatientOptions = {
	limit?: InputMaybe<Scalars["Int"]>;
	offset?: InputMaybe<Scalars["Int"]>;
	/** Specify one or more PatientSort objects to sort Patients by. The sorts will be applied in the order in which they are arranged in the array. */
	sort?: InputMaybe<Array<InputMaybe<PatientSort>>>;
};

export type PatientPrimaryInterventionAggregateInput = {
	AND?: InputMaybe<Array<PatientPrimaryInterventionAggregateInput>>;
	OR?: InputMaybe<Array<PatientPrimaryInterventionAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<PatientPrimaryInterventionNodeAggregationWhereInput>;
};

export type PatientPrimaryInterventionConnectFieldInput = {
	connect?: InputMaybe<InterventionConnectInput>;
	where?: InputMaybe<InterventionConnectWhere>;
};

export type PatientPrimaryInterventionConnection = {
	__typename?: "PatientPrimaryInterventionConnection";
	edges: Array<PatientPrimaryInterventionRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type PatientPrimaryInterventionConnectionSort = {
	node?: InputMaybe<InterventionSort>;
};

export type PatientPrimaryInterventionConnectionWhere = {
	AND?: InputMaybe<Array<PatientPrimaryInterventionConnectionWhere>>;
	OR?: InputMaybe<Array<PatientPrimaryInterventionConnectionWhere>>;
	node?: InputMaybe<InterventionWhere>;
	node_NOT?: InputMaybe<InterventionWhere>;
};

export type PatientPrimaryInterventionCreateFieldInput = {
	node: InterventionCreateInput;
};

export type PatientPrimaryInterventionDeleteFieldInput = {
	delete?: InputMaybe<InterventionDeleteInput>;
	where?: InputMaybe<PatientPrimaryInterventionConnectionWhere>;
};

export type PatientPrimaryInterventionDisconnectFieldInput = {
	disconnect?: InputMaybe<InterventionDisconnectInput>;
	where?: InputMaybe<PatientPrimaryInterventionConnectionWhere>;
};

export type PatientPrimaryInterventionFieldInput = {
	connect?: InputMaybe<PatientPrimaryInterventionConnectFieldInput>;
	create?: InputMaybe<PatientPrimaryInterventionCreateFieldInput>;
};

export type PatientPrimaryInterventionNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<PatientPrimaryInterventionNodeAggregationWhereInput>>;
	LAPressure_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	LAPressure_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	LAPressure_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	LAPressure_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	LAPressure_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	LAPressure_EQUAL?: InputMaybe<Scalars["Int"]>;
	LAPressure_GT?: InputMaybe<Scalars["Int"]>;
	LAPressure_GTE?: InputMaybe<Scalars["Int"]>;
	LAPressure_LT?: InputMaybe<Scalars["Int"]>;
	LAPressure_LTE?: InputMaybe<Scalars["Int"]>;
	LAPressure_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	LAPressure_MAX_GT?: InputMaybe<Scalars["Int"]>;
	LAPressure_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	LAPressure_MAX_LT?: InputMaybe<Scalars["Int"]>;
	LAPressure_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	LAPressure_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	LAPressure_MIN_GT?: InputMaybe<Scalars["Int"]>;
	LAPressure_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	LAPressure_MIN_LT?: InputMaybe<Scalars["Int"]>;
	LAPressure_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	LAVolume_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	LAVolume_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	LAVolume_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	LAVolume_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	LAVolume_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	LAVolume_EQUAL?: InputMaybe<Scalars["Int"]>;
	LAVolume_GT?: InputMaybe<Scalars["Int"]>;
	LAVolume_GTE?: InputMaybe<Scalars["Int"]>;
	LAVolume_LT?: InputMaybe<Scalars["Int"]>;
	LAVolume_LTE?: InputMaybe<Scalars["Int"]>;
	LAVolume_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	LAVolume_MAX_GT?: InputMaybe<Scalars["Int"]>;
	LAVolume_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	LAVolume_MAX_LT?: InputMaybe<Scalars["Int"]>;
	LAVolume_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	LAVolume_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	LAVolume_MIN_GT?: InputMaybe<Scalars["Int"]>;
	LAVolume_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	LAVolume_MIN_LT?: InputMaybe<Scalars["Int"]>;
	LAVolume_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	OR?: InputMaybe<Array<PatientPrimaryInterventionNodeAggregationWhereInput>>;
	createdOn_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	lastUpdatedOn_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_GT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_LT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_GT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_GTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_LT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_LTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	tenantId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	tenantId_EQUAL?: InputMaybe<Scalars["String"]>;
	tenantId_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type PatientPrimaryInterventionRelationship = {
	__typename?: "PatientPrimaryInterventionRelationship";
	cursor: Scalars["String"];
	node: Intervention;
};

export type PatientPrimaryInterventionUpdateConnectionInput = {
	node?: InputMaybe<InterventionUpdateInput>;
};

export type PatientPrimaryInterventionUpdateFieldInput = {
	connect?: InputMaybe<PatientPrimaryInterventionConnectFieldInput>;
	create?: InputMaybe<PatientPrimaryInterventionCreateFieldInput>;
	delete?: InputMaybe<PatientPrimaryInterventionDeleteFieldInput>;
	disconnect?: InputMaybe<PatientPrimaryInterventionDisconnectFieldInput>;
	update?: InputMaybe<PatientPrimaryInterventionUpdateConnectionInput>;
	where?: InputMaybe<PatientPrimaryInterventionConnectionWhere>;
};

export type PatientReportDataPoint = {
	__typename?: "PatientReportDataPoint";
	date: Scalars["Date"];
	enrolledNumber: Scalars["Int"];
};

export type PatientReportDataPointAggregateSelection = {
	__typename?: "PatientReportDataPointAggregateSelection";
	count: Scalars["Int"];
	enrolledNumber: IntAggregateSelection;
};

export type PatientReportDataPointOptions = {
	limit?: InputMaybe<Scalars["Int"]>;
	offset?: InputMaybe<Scalars["Int"]>;
	/** Specify one or more PatientReportDataPointSort objects to sort PatientReportDataPoints by. The sorts will be applied in the order in which they are arranged in the array. */
	sort?: InputMaybe<Array<InputMaybe<PatientReportDataPointSort>>>;
};

/** Fields to sort PatientReportDataPoints by. The order in which sorts are applied is not guaranteed when specifying many fields in one PatientReportDataPointSort object. */
export type PatientReportDataPointSort = {
	date?: InputMaybe<SortDirection>;
	enrolledNumber?: InputMaybe<SortDirection>;
};

export type PatientReportDataPointWhere = {
	AND?: InputMaybe<Array<PatientReportDataPointWhere>>;
	OR?: InputMaybe<Array<PatientReportDataPointWhere>>;
	date?: InputMaybe<Scalars["Date"]>;
	date_GT?: InputMaybe<Scalars["Date"]>;
	date_GTE?: InputMaybe<Scalars["Date"]>;
	date_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
	date_LT?: InputMaybe<Scalars["Date"]>;
	date_LTE?: InputMaybe<Scalars["Date"]>;
	date_NOT?: InputMaybe<Scalars["Date"]>;
	date_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
	enrolledNumber?: InputMaybe<Scalars["Int"]>;
	enrolledNumber_GT?: InputMaybe<Scalars["Int"]>;
	enrolledNumber_GTE?: InputMaybe<Scalars["Int"]>;
	enrolledNumber_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	enrolledNumber_LT?: InputMaybe<Scalars["Int"]>;
	enrolledNumber_LTE?: InputMaybe<Scalars["Int"]>;
	enrolledNumber_NOT?: InputMaybe<Scalars["Int"]>;
	enrolledNumber_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
};

export type PatientSentClaimAggregateInput = {
	AND?: InputMaybe<Array<PatientSentClaimAggregateInput>>;
	OR?: InputMaybe<Array<PatientSentClaimAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	edge?: InputMaybe<PatientSentClaimEdgeAggregationWhereInput>;
	node?: InputMaybe<PatientSentClaimNodeAggregationWhereInput>;
};

export type PatientSentClaimConnectFieldInput = {
	connect?: InputMaybe<Array<ClaimConnectInput>>;
	edge?: InputMaybe<SentClaimRelationshipCreateInput>;
	where?: InputMaybe<ClaimConnectWhere>;
};

export type PatientSentClaimConnection = {
	__typename?: "PatientSentClaimConnection";
	edges: Array<PatientSentClaimRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type PatientSentClaimConnectionSort = {
	edge?: InputMaybe<SentClaimRelationshipSort>;
	node?: InputMaybe<ClaimSort>;
};

export type PatientSentClaimConnectionWhere = {
	AND?: InputMaybe<Array<PatientSentClaimConnectionWhere>>;
	OR?: InputMaybe<Array<PatientSentClaimConnectionWhere>>;
	edge?: InputMaybe<SentClaimRelationshipWhere>;
	edge_NOT?: InputMaybe<SentClaimRelationshipWhere>;
	node?: InputMaybe<ClaimWhere>;
	node_NOT?: InputMaybe<ClaimWhere>;
};

export type PatientSentClaimCreateFieldInput = {
	edge?: InputMaybe<SentClaimRelationshipCreateInput>;
	node: ClaimCreateInput;
};

export type PatientSentClaimDeleteFieldInput = {
	delete?: InputMaybe<ClaimDeleteInput>;
	where?: InputMaybe<PatientSentClaimConnectionWhere>;
};

export type PatientSentClaimDisconnectFieldInput = {
	disconnect?: InputMaybe<ClaimDisconnectInput>;
	where?: InputMaybe<PatientSentClaimConnectionWhere>;
};

export type PatientSentClaimEdgeAggregationWhereInput = {
	AND?: InputMaybe<Array<PatientSentClaimEdgeAggregationWhereInput>>;
	OR?: InputMaybe<Array<PatientSentClaimEdgeAggregationWhereInput>>;
	date_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	date_GT?: InputMaybe<Scalars["DateTime"]>;
	date_GTE?: InputMaybe<Scalars["DateTime"]>;
	date_LT?: InputMaybe<Scalars["DateTime"]>;
	date_LTE?: InputMaybe<Scalars["DateTime"]>;
	date_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	date_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	date_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	date_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	date_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	date_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	date_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	date_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	date_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	date_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	timeStamp_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	timeStamp_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	timeStamp_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	timeStamp_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	timeStamp_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	timeStamp_EQUAL?: InputMaybe<Scalars["Float"]>;
	timeStamp_GT?: InputMaybe<Scalars["Float"]>;
	timeStamp_GTE?: InputMaybe<Scalars["Float"]>;
	timeStamp_LT?: InputMaybe<Scalars["Float"]>;
	timeStamp_LTE?: InputMaybe<Scalars["Float"]>;
	timeStamp_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	timeStamp_MAX_GT?: InputMaybe<Scalars["Float"]>;
	timeStamp_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	timeStamp_MAX_LT?: InputMaybe<Scalars["Float"]>;
	timeStamp_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	timeStamp_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	timeStamp_MIN_GT?: InputMaybe<Scalars["Float"]>;
	timeStamp_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	timeStamp_MIN_LT?: InputMaybe<Scalars["Float"]>;
	timeStamp_MIN_LTE?: InputMaybe<Scalars["Float"]>;
};

export type PatientSentClaimFieldInput = {
	connect?: InputMaybe<Array<PatientSentClaimConnectFieldInput>>;
	create?: InputMaybe<Array<PatientSentClaimCreateFieldInput>>;
};

export type PatientSentClaimNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<PatientSentClaimNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<PatientSentClaimNodeAggregationWhereInput>>;
	administrationDate_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	administrationDate_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	administrationDate_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	administrationDate_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	administrationDate_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	administrationDate_EQUAL?: InputMaybe<Scalars["String"]>;
	administrationDate_GT?: InputMaybe<Scalars["Int"]>;
	administrationDate_GTE?: InputMaybe<Scalars["Int"]>;
	administrationDate_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	administrationDate_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	administrationDate_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	administrationDate_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	administrationDate_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	administrationDate_LT?: InputMaybe<Scalars["Int"]>;
	administrationDate_LTE?: InputMaybe<Scalars["Int"]>;
	administrationDate_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	administrationDate_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	administrationDate_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	administrationDate_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	administrationDate_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	assignee_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	assignee_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	assignee_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	assignee_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	assignee_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	assignee_EQUAL?: InputMaybe<Scalars["String"]>;
	assignee_GT?: InputMaybe<Scalars["Int"]>;
	assignee_GTE?: InputMaybe<Scalars["Int"]>;
	assignee_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	assignee_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	assignee_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	assignee_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	assignee_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	assignee_LT?: InputMaybe<Scalars["Int"]>;
	assignee_LTE?: InputMaybe<Scalars["Int"]>;
	assignee_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	assignee_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	assignee_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	assignee_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	assignee_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	claimId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	claimId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	claimId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	claimId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	claimId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	claimId_EQUAL?: InputMaybe<Scalars["String"]>;
	claimId_GT?: InputMaybe<Scalars["Int"]>;
	claimId_GTE?: InputMaybe<Scalars["Int"]>;
	claimId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	claimId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	claimId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	claimId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	claimId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	claimId_LT?: InputMaybe<Scalars["Int"]>;
	claimId_LTE?: InputMaybe<Scalars["Int"]>;
	claimId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	claimId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	claimId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	claimId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	claimId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	createdOn_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	invoiceAmount_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	invoiceAmount_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	invoiceAmount_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	invoiceAmount_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	invoiceAmount_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	invoiceAmount_EQUAL?: InputMaybe<Scalars["String"]>;
	invoiceAmount_GT?: InputMaybe<Scalars["Int"]>;
	invoiceAmount_GTE?: InputMaybe<Scalars["Int"]>;
	invoiceAmount_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	invoiceAmount_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	invoiceAmount_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	invoiceAmount_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	invoiceAmount_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	invoiceAmount_LT?: InputMaybe<Scalars["Int"]>;
	invoiceAmount_LTE?: InputMaybe<Scalars["Int"]>;
	invoiceAmount_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	invoiceAmount_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	invoiceAmount_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	invoiceAmount_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	invoiceAmount_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	invoiceDate_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	invoiceDate_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	invoiceDate_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	invoiceDate_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	invoiceDate_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	invoiceDate_EQUAL?: InputMaybe<Scalars["String"]>;
	invoiceDate_GT?: InputMaybe<Scalars["Int"]>;
	invoiceDate_GTE?: InputMaybe<Scalars["Int"]>;
	invoiceDate_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	invoiceDate_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	invoiceDate_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	invoiceDate_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	invoiceDate_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	invoiceDate_LT?: InputMaybe<Scalars["Int"]>;
	invoiceDate_LTE?: InputMaybe<Scalars["Int"]>;
	invoiceDate_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	invoiceDate_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	invoiceDate_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	invoiceDate_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	invoiceDate_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	invoiceNumber_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	invoiceNumber_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	invoiceNumber_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	invoiceNumber_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	invoiceNumber_EQUAL?: InputMaybe<Scalars["String"]>;
	invoiceNumber_GT?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_GTE?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_LT?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_LTE?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationIdType_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	preparationIdType_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	preparationIdType_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	preparationIdType_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	preparationIdType_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	preparationIdType_EQUAL?: InputMaybe<Scalars["String"]>;
	preparationIdType_GT?: InputMaybe<Scalars["Int"]>;
	preparationIdType_GTE?: InputMaybe<Scalars["Int"]>;
	preparationIdType_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationIdType_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationIdType_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationIdType_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationIdType_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationIdType_LT?: InputMaybe<Scalars["Int"]>;
	preparationIdType_LTE?: InputMaybe<Scalars["Int"]>;
	preparationIdType_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationIdType_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationIdType_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationIdType_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationIdType_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	preparationId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	preparationId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	preparationId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	preparationId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	preparationId_EQUAL?: InputMaybe<Scalars["String"]>;
	preparationId_GT?: InputMaybe<Scalars["Int"]>;
	preparationId_GTE?: InputMaybe<Scalars["Int"]>;
	preparationId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationId_LT?: InputMaybe<Scalars["Int"]>;
	preparationId_LTE?: InputMaybe<Scalars["Int"]>;
	preparationId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	providerId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	providerId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	providerId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	providerId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	providerId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	providerId_EQUAL?: InputMaybe<Scalars["String"]>;
	providerId_GT?: InputMaybe<Scalars["Int"]>;
	providerId_GTE?: InputMaybe<Scalars["Int"]>;
	providerId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	providerId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	providerId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	providerId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	providerId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	providerId_LT?: InputMaybe<Scalars["Int"]>;
	providerId_LTE?: InputMaybe<Scalars["Int"]>;
	providerId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	providerId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	providerId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	providerId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	providerId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	providerName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	providerName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	providerName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	providerName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	providerName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	providerName_EQUAL?: InputMaybe<Scalars["String"]>;
	providerName_GT?: InputMaybe<Scalars["Int"]>;
	providerName_GTE?: InputMaybe<Scalars["Int"]>;
	providerName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	providerName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	providerName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	providerName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	providerName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	providerName_LT?: InputMaybe<Scalars["Int"]>;
	providerName_LTE?: InputMaybe<Scalars["Int"]>;
	providerName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	providerName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	providerName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	providerName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	providerName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	quantity_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	quantity_EQUAL?: InputMaybe<Scalars["String"]>;
	quantity_GT?: InputMaybe<Scalars["Int"]>;
	quantity_GTE?: InputMaybe<Scalars["Int"]>;
	quantity_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	quantity_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	quantity_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	quantity_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	quantity_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	quantity_LT?: InputMaybe<Scalars["Int"]>;
	quantity_LTE?: InputMaybe<Scalars["Int"]>;
	quantity_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	quantity_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	quantity_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	quantity_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	quantity_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	tenantId_EQUAL?: InputMaybe<Scalars["String"]>;
	tenantId_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type PatientSentClaimRelationship = SentClaimRelationship & {
	__typename?: "PatientSentClaimRelationship";
	cursor: Scalars["String"];
	date?: Maybe<Scalars["DateTime"]>;
	node: Claim;
	timeStamp?: Maybe<Scalars["Float"]>;
};

export type PatientSentClaimUpdateConnectionInput = {
	edge?: InputMaybe<SentClaimRelationshipUpdateInput>;
	node?: InputMaybe<ClaimUpdateInput>;
};

export type PatientSentClaimUpdateFieldInput = {
	connect?: InputMaybe<Array<PatientSentClaimConnectFieldInput>>;
	create?: InputMaybe<Array<PatientSentClaimCreateFieldInput>>;
	delete?: InputMaybe<Array<PatientSentClaimDeleteFieldInput>>;
	disconnect?: InputMaybe<Array<PatientSentClaimDisconnectFieldInput>>;
	update?: InputMaybe<PatientSentClaimUpdateConnectionInput>;
	where?: InputMaybe<PatientSentClaimConnectionWhere>;
};

/** Fields to sort Patients by. The order in which sorts are applied is not guaranteed when specifying many fields in one PatientSort object. */
export type PatientSort = {
	id?: InputMaybe<SortDirection>;
	initials?: InputMaybe<SortDirection>;
	insuranceId?: InputMaybe<SortDirection>;
	tenantId?: InputMaybe<SortDirection>;
	timeStamp?: InputMaybe<SortDirection>;
	yearOfBirth?: InputMaybe<SortDirection>;
};

export type PatientStatusDistribution = {
	__typename?: "PatientStatusDistribution";
	conditionsMissedCount: Scalars["Int"];
	outcomeNotReachedCount: Scalars["Int"];
	outcomeReachedCount: Scalars["Int"];
	possibleToReachOutcomeCount: Scalars["Int"];
};

export type PatientStatusDistributionAggregateSelection = {
	__typename?: "PatientStatusDistributionAggregateSelection";
	conditionsMissedCount: IntAggregateSelection;
	count: Scalars["Int"];
	outcomeNotReachedCount: IntAggregateSelection;
	outcomeReachedCount: IntAggregateSelection;
	possibleToReachOutcomeCount: IntAggregateSelection;
};

export type PatientStatusDistributionOptions = {
	limit?: InputMaybe<Scalars["Int"]>;
	offset?: InputMaybe<Scalars["Int"]>;
	/** Specify one or more PatientStatusDistributionSort objects to sort PatientStatusDistributions by. The sorts will be applied in the order in which they are arranged in the array. */
	sort?: InputMaybe<Array<InputMaybe<PatientStatusDistributionSort>>>;
};

/** Fields to sort PatientStatusDistributions by. The order in which sorts are applied is not guaranteed when specifying many fields in one PatientStatusDistributionSort object. */
export type PatientStatusDistributionSort = {
	conditionsMissedCount?: InputMaybe<SortDirection>;
	outcomeNotReachedCount?: InputMaybe<SortDirection>;
	outcomeReachedCount?: InputMaybe<SortDirection>;
	possibleToReachOutcomeCount?: InputMaybe<SortDirection>;
};

export type PatientStatusDistributionWhere = {
	AND?: InputMaybe<Array<PatientStatusDistributionWhere>>;
	OR?: InputMaybe<Array<PatientStatusDistributionWhere>>;
	conditionsMissedCount?: InputMaybe<Scalars["Int"]>;
	conditionsMissedCount_GT?: InputMaybe<Scalars["Int"]>;
	conditionsMissedCount_GTE?: InputMaybe<Scalars["Int"]>;
	conditionsMissedCount_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	conditionsMissedCount_LT?: InputMaybe<Scalars["Int"]>;
	conditionsMissedCount_LTE?: InputMaybe<Scalars["Int"]>;
	conditionsMissedCount_NOT?: InputMaybe<Scalars["Int"]>;
	conditionsMissedCount_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	outcomeNotReachedCount?: InputMaybe<Scalars["Int"]>;
	outcomeNotReachedCount_GT?: InputMaybe<Scalars["Int"]>;
	outcomeNotReachedCount_GTE?: InputMaybe<Scalars["Int"]>;
	outcomeNotReachedCount_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	outcomeNotReachedCount_LT?: InputMaybe<Scalars["Int"]>;
	outcomeNotReachedCount_LTE?: InputMaybe<Scalars["Int"]>;
	outcomeNotReachedCount_NOT?: InputMaybe<Scalars["Int"]>;
	outcomeNotReachedCount_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	outcomeReachedCount?: InputMaybe<Scalars["Int"]>;
	outcomeReachedCount_GT?: InputMaybe<Scalars["Int"]>;
	outcomeReachedCount_GTE?: InputMaybe<Scalars["Int"]>;
	outcomeReachedCount_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	outcomeReachedCount_LT?: InputMaybe<Scalars["Int"]>;
	outcomeReachedCount_LTE?: InputMaybe<Scalars["Int"]>;
	outcomeReachedCount_NOT?: InputMaybe<Scalars["Int"]>;
	outcomeReachedCount_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	possibleToReachOutcomeCount?: InputMaybe<Scalars["Int"]>;
	possibleToReachOutcomeCount_GT?: InputMaybe<Scalars["Int"]>;
	possibleToReachOutcomeCount_GTE?: InputMaybe<Scalars["Int"]>;
	possibleToReachOutcomeCount_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	possibleToReachOutcomeCount_LT?: InputMaybe<Scalars["Int"]>;
	possibleToReachOutcomeCount_LTE?: InputMaybe<Scalars["Int"]>;
	possibleToReachOutcomeCount_NOT?: InputMaybe<Scalars["Int"]>;
	possibleToReachOutcomeCount_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
};

export type PatientUpdateInput = {
	assignedFlexEntities?: InputMaybe<Array<PatientAssignedFlexEntitiesUpdateFieldInput>>;
	cases?: InputMaybe<Array<PatientCasesUpdateFieldInput>>;
	claims?: InputMaybe<Array<PatientClaimsUpdateFieldInput>>;
	coverageRequests?: InputMaybe<Array<PatientCoverageRequestsUpdateFieldInput>>;
	id?: InputMaybe<Scalars["ID"]>;
	initials?: InputMaybe<Scalars["String"]>;
	insuranceId?: InputMaybe<Scalars["String"]>;
	primaryIntervention?: InputMaybe<PatientPrimaryInterventionUpdateFieldInput>;
	sentClaim?: InputMaybe<Array<PatientSentClaimUpdateFieldInput>>;
	tenantId?: InputMaybe<Scalars["String"]>;
	timeStamp?: InputMaybe<Scalars["DateTime"]>;
	yearOfBirth?: InputMaybe<Scalars["Int"]>;
};

export type PatientWhere = {
	AND?: InputMaybe<Array<PatientWhere>>;
	OR?: InputMaybe<Array<PatientWhere>>;
	assignedFlexEntities?: InputMaybe<FlexEntityWhere>;
	assignedFlexEntitiesAggregate?: InputMaybe<PatientAssignedFlexEntitiesAggregateInput>;
	assignedFlexEntitiesConnection?: InputMaybe<PatientAssignedFlexEntitiesConnectionWhere>;
	assignedFlexEntitiesConnection_NOT?: InputMaybe<PatientAssignedFlexEntitiesConnectionWhere>;
	assignedFlexEntities_NOT?: InputMaybe<FlexEntityWhere>;
	cases?: InputMaybe<CaseWhere>;
	casesAggregate?: InputMaybe<PatientCasesAggregateInput>;
	casesConnection?: InputMaybe<PatientCasesConnectionWhere>;
	casesConnection_NOT?: InputMaybe<PatientCasesConnectionWhere>;
	cases_NOT?: InputMaybe<CaseWhere>;
	claims?: InputMaybe<ClaimWhere>;
	claimsAggregate?: InputMaybe<PatientClaimsAggregateInput>;
	claimsConnection?: InputMaybe<PatientClaimsConnectionWhere>;
	claimsConnection_NOT?: InputMaybe<PatientClaimsConnectionWhere>;
	claims_NOT?: InputMaybe<ClaimWhere>;
	coverageRequests?: InputMaybe<CoverageRequestWhere>;
	coverageRequestsAggregate?: InputMaybe<PatientCoverageRequestsAggregateInput>;
	coverageRequestsConnection?: InputMaybe<PatientCoverageRequestsConnectionWhere>;
	coverageRequestsConnection_NOT?: InputMaybe<PatientCoverageRequestsConnectionWhere>;
	coverageRequests_NOT?: InputMaybe<CoverageRequestWhere>;
	id?: InputMaybe<Scalars["ID"]>;
	id_CONTAINS?: InputMaybe<Scalars["ID"]>;
	id_ENDS_WITH?: InputMaybe<Scalars["ID"]>;
	id_IN?: InputMaybe<Array<InputMaybe<Scalars["ID"]>>>;
	id_MATCHES?: InputMaybe<Scalars["String"]>;
	id_NOT?: InputMaybe<Scalars["ID"]>;
	id_NOT_CONTAINS?: InputMaybe<Scalars["ID"]>;
	id_NOT_ENDS_WITH?: InputMaybe<Scalars["ID"]>;
	id_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["ID"]>>>;
	id_NOT_STARTS_WITH?: InputMaybe<Scalars["ID"]>;
	id_STARTS_WITH?: InputMaybe<Scalars["ID"]>;
	initials?: InputMaybe<Scalars["String"]>;
	initials_CONTAINS?: InputMaybe<Scalars["String"]>;
	initials_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	initials_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	initials_MATCHES?: InputMaybe<Scalars["String"]>;
	initials_NOT?: InputMaybe<Scalars["String"]>;
	initials_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	initials_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	initials_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	initials_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	initials_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	insuranceId?: InputMaybe<Scalars["String"]>;
	insuranceId_CONTAINS?: InputMaybe<Scalars["String"]>;
	insuranceId_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	insuranceId_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	insuranceId_MATCHES?: InputMaybe<Scalars["String"]>;
	insuranceId_NOT?: InputMaybe<Scalars["String"]>;
	insuranceId_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	insuranceId_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	insuranceId_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	insuranceId_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	insuranceId_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	primaryIntervention?: InputMaybe<InterventionWhere>;
	primaryInterventionAggregate?: InputMaybe<PatientPrimaryInterventionAggregateInput>;
	primaryInterventionConnection?: InputMaybe<PatientPrimaryInterventionConnectionWhere>;
	primaryInterventionConnection_NOT?: InputMaybe<PatientPrimaryInterventionConnectionWhere>;
	primaryIntervention_NOT?: InputMaybe<InterventionWhere>;
	sentClaim?: InputMaybe<ClaimWhere>;
	sentClaimAggregate?: InputMaybe<PatientSentClaimAggregateInput>;
	sentClaimConnection?: InputMaybe<PatientSentClaimConnectionWhere>;
	sentClaimConnection_NOT?: InputMaybe<PatientSentClaimConnectionWhere>;
	sentClaim_NOT?: InputMaybe<ClaimWhere>;
	tenantId?: InputMaybe<Scalars["String"]>;
	tenantId_CONTAINS?: InputMaybe<Scalars["String"]>;
	tenantId_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	tenantId_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	tenantId_MATCHES?: InputMaybe<Scalars["String"]>;
	tenantId_NOT?: InputMaybe<Scalars["String"]>;
	tenantId_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	tenantId_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	tenantId_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	tenantId_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	tenantId_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	timeStamp?: InputMaybe<Scalars["DateTime"]>;
	timeStamp_GT?: InputMaybe<Scalars["DateTime"]>;
	timeStamp_GTE?: InputMaybe<Scalars["DateTime"]>;
	timeStamp_IN?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]>>>;
	timeStamp_LT?: InputMaybe<Scalars["DateTime"]>;
	timeStamp_LTE?: InputMaybe<Scalars["DateTime"]>;
	timeStamp_NOT?: InputMaybe<Scalars["DateTime"]>;
	timeStamp_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]>>>;
	yearOfBirth?: InputMaybe<Scalars["Int"]>;
	yearOfBirth_GT?: InputMaybe<Scalars["Int"]>;
	yearOfBirth_GTE?: InputMaybe<Scalars["Int"]>;
	yearOfBirth_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	yearOfBirth_LT?: InputMaybe<Scalars["Int"]>;
	yearOfBirth_LTE?: InputMaybe<Scalars["Int"]>;
	yearOfBirth_NOT?: InputMaybe<Scalars["Int"]>;
	yearOfBirth_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
};

export type PatientsPerMonthDataPoint = {
	__typename?: "PatientsPerMonthDataPoint";
	month: Scalars["String"];
	patientCount: Scalars["Int"];
};

export type PatientsPerMonthDataPointAggregateSelection = {
	__typename?: "PatientsPerMonthDataPointAggregateSelection";
	count: Scalars["Int"];
	month: StringAggregateSelection;
	patientCount: IntAggregateSelection;
};

export type PatientsPerMonthDataPointOptions = {
	limit?: InputMaybe<Scalars["Int"]>;
	offset?: InputMaybe<Scalars["Int"]>;
	/** Specify one or more PatientsPerMonthDataPointSort objects to sort PatientsPerMonthDataPoints by. The sorts will be applied in the order in which they are arranged in the array. */
	sort?: InputMaybe<Array<InputMaybe<PatientsPerMonthDataPointSort>>>;
};

/** Fields to sort PatientsPerMonthDataPoints by. The order in which sorts are applied is not guaranteed when specifying many fields in one PatientsPerMonthDataPointSort object. */
export type PatientsPerMonthDataPointSort = {
	month?: InputMaybe<SortDirection>;
	patientCount?: InputMaybe<SortDirection>;
};

export type PatientsPerMonthDataPointWhere = {
	AND?: InputMaybe<Array<PatientsPerMonthDataPointWhere>>;
	OR?: InputMaybe<Array<PatientsPerMonthDataPointWhere>>;
	month?: InputMaybe<Scalars["String"]>;
	month_CONTAINS?: InputMaybe<Scalars["String"]>;
	month_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	month_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	month_MATCHES?: InputMaybe<Scalars["String"]>;
	month_NOT?: InputMaybe<Scalars["String"]>;
	month_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	month_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	month_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	month_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	month_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	patientCount?: InputMaybe<Scalars["Int"]>;
	patientCount_GT?: InputMaybe<Scalars["Int"]>;
	patientCount_GTE?: InputMaybe<Scalars["Int"]>;
	patientCount_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	patientCount_LT?: InputMaybe<Scalars["Int"]>;
	patientCount_LTE?: InputMaybe<Scalars["Int"]>;
	patientCount_NOT?: InputMaybe<Scalars["Int"]>;
	patientCount_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
};

export type Preparation = {
	__typename?: "Preparation";
	AtcCode?: Maybe<Scalars["String"]>;
	BrandName: Scalars["String"];
	DescriptionDe?: Maybe<Scalars["String"]>;
	GenericName?: Maybe<Scalars["String"]>;
	ReleaseDate?: Maybe<Scalars["Date"]>;
	SubjectMatter: AgreementSubjectMatter;
	SwissmedicNo5?: Maybe<Scalars["String"]>;
	brand: Brand;
	brandConnection: PreparationBrandConnection;
	coverageRequest: Array<CoverageRequest>;
	coverageRequestCombined: Array<CoverageRequest>;
	coverageRequestCombinedConnection: PreparationCoverageRequestCombinedConnection;
	coverageRequestConnection: PreparationCoverageRequestConnection;
	hasLimitations: Array<Limitation>;
	hasLimitationsConnection: PreparationHasLimitationsConnection;
	id: Scalars["ID"];
	regulates: Array<Treatment>;
	regulatesConnection: PreparationRegulatesConnection;
};

export type PreparationBrandArgs = {
	options?: InputMaybe<BrandOptions>;
	where?: InputMaybe<BrandWhere>;
};

export type PreparationBrandConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<PreparationBrandConnectionSort>>;
	where?: InputMaybe<PreparationBrandConnectionWhere>;
};

export type PreparationCoverageRequestArgs = {
	options?: InputMaybe<CoverageRequestOptions>;
	where?: InputMaybe<CoverageRequestWhere>;
};

export type PreparationCoverageRequestCombinedArgs = {
	options?: InputMaybe<CoverageRequestOptions>;
	where?: InputMaybe<CoverageRequestWhere>;
};

export type PreparationCoverageRequestCombinedConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<PreparationCoverageRequestCombinedConnectionSort>>;
	where?: InputMaybe<PreparationCoverageRequestCombinedConnectionWhere>;
};

export type PreparationCoverageRequestConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<PreparationCoverageRequestConnectionSort>>;
	where?: InputMaybe<PreparationCoverageRequestConnectionWhere>;
};

export type PreparationHasLimitationsArgs = {
	options?: InputMaybe<LimitationOptions>;
	where?: InputMaybe<LimitationWhere>;
};

export type PreparationHasLimitationsConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<PreparationHasLimitationsConnectionSort>>;
	where?: InputMaybe<PreparationHasLimitationsConnectionWhere>;
};

export type PreparationRegulatesArgs = {
	options?: InputMaybe<TreatmentOptions>;
	where?: InputMaybe<TreatmentWhere>;
};

export type PreparationRegulatesConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<PreparationRegulatesConnectionSort>>;
	where?: InputMaybe<PreparationRegulatesConnectionWhere>;
};

export type PreparationAggregateSelection = {
	__typename?: "PreparationAggregateSelection";
	AtcCode: StringAggregateSelection;
	BrandName: StringAggregateSelection;
	DescriptionDe: StringAggregateSelection;
	GenericName: StringAggregateSelection;
	SwissmedicNo5: StringAggregateSelection;
	count: Scalars["Int"];
	id: IdAggregateSelection;
};

export type PreparationBrandAggregateInput = {
	AND?: InputMaybe<Array<PreparationBrandAggregateInput>>;
	OR?: InputMaybe<Array<PreparationBrandAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<PreparationBrandNodeAggregationWhereInput>;
};

export type PreparationBrandConnectFieldInput = {
	connect?: InputMaybe<BrandConnectInput>;
	where?: InputMaybe<BrandConnectWhere>;
};

export type PreparationBrandConnection = {
	__typename?: "PreparationBrandConnection";
	edges: Array<PreparationBrandRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type PreparationBrandConnectionSort = {
	node?: InputMaybe<BrandSort>;
};

export type PreparationBrandConnectionWhere = {
	AND?: InputMaybe<Array<PreparationBrandConnectionWhere>>;
	OR?: InputMaybe<Array<PreparationBrandConnectionWhere>>;
	node?: InputMaybe<BrandWhere>;
	node_NOT?: InputMaybe<BrandWhere>;
};

export type PreparationBrandCreateFieldInput = {
	node: BrandCreateInput;
};

export type PreparationBrandDeleteFieldInput = {
	delete?: InputMaybe<BrandDeleteInput>;
	where?: InputMaybe<PreparationBrandConnectionWhere>;
};

export type PreparationBrandDisconnectFieldInput = {
	disconnect?: InputMaybe<BrandDisconnectInput>;
	where?: InputMaybe<PreparationBrandConnectionWhere>;
};

export type PreparationBrandFieldInput = {
	connect?: InputMaybe<PreparationBrandConnectFieldInput>;
	create?: InputMaybe<PreparationBrandCreateFieldInput>;
};

export type PreparationBrandNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<PreparationBrandNodeAggregationWhereInput>>;
	Name_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	Name_EQUAL?: InputMaybe<Scalars["String"]>;
	Name_GT?: InputMaybe<Scalars["Int"]>;
	Name_GTE?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	Name_LT?: InputMaybe<Scalars["Int"]>;
	Name_LTE?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	OR?: InputMaybe<Array<PreparationBrandNodeAggregationWhereInput>>;
};

export type PreparationBrandRelationship = {
	__typename?: "PreparationBrandRelationship";
	cursor: Scalars["String"];
	node: Brand;
};

export type PreparationBrandUpdateConnectionInput = {
	node?: InputMaybe<BrandUpdateInput>;
};

export type PreparationBrandUpdateFieldInput = {
	connect?: InputMaybe<PreparationBrandConnectFieldInput>;
	create?: InputMaybe<PreparationBrandCreateFieldInput>;
	delete?: InputMaybe<PreparationBrandDeleteFieldInput>;
	disconnect?: InputMaybe<PreparationBrandDisconnectFieldInput>;
	update?: InputMaybe<PreparationBrandUpdateConnectionInput>;
	where?: InputMaybe<PreparationBrandConnectionWhere>;
};

export type PreparationConnectInput = {
	brand?: InputMaybe<PreparationBrandConnectFieldInput>;
	coverageRequest?: InputMaybe<Array<PreparationCoverageRequestConnectFieldInput>>;
	coverageRequestCombined?: InputMaybe<Array<PreparationCoverageRequestCombinedConnectFieldInput>>;
	hasLimitations?: InputMaybe<Array<PreparationHasLimitationsConnectFieldInput>>;
	regulates?: InputMaybe<Array<PreparationRegulatesConnectFieldInput>>;
};

export type PreparationConnectWhere = {
	node: PreparationWhere;
};

export type PreparationCoverageRequestAggregateInput = {
	AND?: InputMaybe<Array<PreparationCoverageRequestAggregateInput>>;
	OR?: InputMaybe<Array<PreparationCoverageRequestAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<PreparationCoverageRequestNodeAggregationWhereInput>;
};

export type PreparationCoverageRequestCombinedAggregateInput = {
	AND?: InputMaybe<Array<PreparationCoverageRequestCombinedAggregateInput>>;
	OR?: InputMaybe<Array<PreparationCoverageRequestCombinedAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<PreparationCoverageRequestCombinedNodeAggregationWhereInput>;
};

export type PreparationCoverageRequestCombinedConnectFieldInput = {
	connect?: InputMaybe<Array<CoverageRequestConnectInput>>;
	where?: InputMaybe<CoverageRequestConnectWhere>;
};

export type PreparationCoverageRequestCombinedConnection = {
	__typename?: "PreparationCoverageRequestCombinedConnection";
	edges: Array<PreparationCoverageRequestCombinedRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type PreparationCoverageRequestCombinedConnectionSort = {
	node?: InputMaybe<CoverageRequestSort>;
};

export type PreparationCoverageRequestCombinedConnectionWhere = {
	AND?: InputMaybe<Array<PreparationCoverageRequestCombinedConnectionWhere>>;
	OR?: InputMaybe<Array<PreparationCoverageRequestCombinedConnectionWhere>>;
	node?: InputMaybe<CoverageRequestWhere>;
	node_NOT?: InputMaybe<CoverageRequestWhere>;
};

export type PreparationCoverageRequestCombinedCreateFieldInput = {
	node: CoverageRequestCreateInput;
};

export type PreparationCoverageRequestCombinedDeleteFieldInput = {
	delete?: InputMaybe<CoverageRequestDeleteInput>;
	where?: InputMaybe<PreparationCoverageRequestCombinedConnectionWhere>;
};

export type PreparationCoverageRequestCombinedDisconnectFieldInput = {
	disconnect?: InputMaybe<CoverageRequestDisconnectInput>;
	where?: InputMaybe<PreparationCoverageRequestCombinedConnectionWhere>;
};

export type PreparationCoverageRequestCombinedFieldInput = {
	connect?: InputMaybe<Array<PreparationCoverageRequestCombinedConnectFieldInput>>;
	create?: InputMaybe<Array<PreparationCoverageRequestCombinedCreateFieldInput>>;
};

export type PreparationCoverageRequestCombinedNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<PreparationCoverageRequestCombinedNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<PreparationCoverageRequestCombinedNodeAggregationWhereInput>>;
	createdOn_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	duration_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	duration_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	duration_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	duration_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	duration_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	duration_EQUAL?: InputMaybe<Scalars["Int"]>;
	duration_GT?: InputMaybe<Scalars["Int"]>;
	duration_GTE?: InputMaybe<Scalars["Int"]>;
	duration_LT?: InputMaybe<Scalars["Int"]>;
	duration_LTE?: InputMaybe<Scalars["Int"]>;
	duration_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	duration_MAX_GT?: InputMaybe<Scalars["Int"]>;
	duration_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	duration_MAX_LT?: InputMaybe<Scalars["Int"]>;
	duration_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	duration_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	duration_MIN_GT?: InputMaybe<Scalars["Int"]>;
	duration_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	duration_MIN_LT?: InputMaybe<Scalars["Int"]>;
	duration_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	lastUpdatedOn_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_GT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_LT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_GT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_GTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_LT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_LTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	tenantId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	tenantId_EQUAL?: InputMaybe<Scalars["String"]>;
	tenantId_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type PreparationCoverageRequestCombinedRelationship = {
	__typename?: "PreparationCoverageRequestCombinedRelationship";
	cursor: Scalars["String"];
	node: CoverageRequest;
};

export type PreparationCoverageRequestCombinedUpdateConnectionInput = {
	node?: InputMaybe<CoverageRequestUpdateInput>;
};

export type PreparationCoverageRequestCombinedUpdateFieldInput = {
	connect?: InputMaybe<Array<PreparationCoverageRequestCombinedConnectFieldInput>>;
	create?: InputMaybe<Array<PreparationCoverageRequestCombinedCreateFieldInput>>;
	delete?: InputMaybe<Array<PreparationCoverageRequestCombinedDeleteFieldInput>>;
	disconnect?: InputMaybe<Array<PreparationCoverageRequestCombinedDisconnectFieldInput>>;
	update?: InputMaybe<PreparationCoverageRequestCombinedUpdateConnectionInput>;
	where?: InputMaybe<PreparationCoverageRequestCombinedConnectionWhere>;
};

export type PreparationCoverageRequestConnectFieldInput = {
	connect?: InputMaybe<Array<CoverageRequestConnectInput>>;
	where?: InputMaybe<CoverageRequestConnectWhere>;
};

export type PreparationCoverageRequestConnection = {
	__typename?: "PreparationCoverageRequestConnection";
	edges: Array<PreparationCoverageRequestRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type PreparationCoverageRequestConnectionSort = {
	node?: InputMaybe<CoverageRequestSort>;
};

export type PreparationCoverageRequestConnectionWhere = {
	AND?: InputMaybe<Array<PreparationCoverageRequestConnectionWhere>>;
	OR?: InputMaybe<Array<PreparationCoverageRequestConnectionWhere>>;
	node?: InputMaybe<CoverageRequestWhere>;
	node_NOT?: InputMaybe<CoverageRequestWhere>;
};

export type PreparationCoverageRequestCreateFieldInput = {
	node: CoverageRequestCreateInput;
};

export type PreparationCoverageRequestDeleteFieldInput = {
	delete?: InputMaybe<CoverageRequestDeleteInput>;
	where?: InputMaybe<PreparationCoverageRequestConnectionWhere>;
};

export type PreparationCoverageRequestDisconnectFieldInput = {
	disconnect?: InputMaybe<CoverageRequestDisconnectInput>;
	where?: InputMaybe<PreparationCoverageRequestConnectionWhere>;
};

export type PreparationCoverageRequestFieldInput = {
	connect?: InputMaybe<Array<PreparationCoverageRequestConnectFieldInput>>;
	create?: InputMaybe<Array<PreparationCoverageRequestCreateFieldInput>>;
};

export type PreparationCoverageRequestNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<PreparationCoverageRequestNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<PreparationCoverageRequestNodeAggregationWhereInput>>;
	createdOn_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	duration_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	duration_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	duration_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	duration_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	duration_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	duration_EQUAL?: InputMaybe<Scalars["Int"]>;
	duration_GT?: InputMaybe<Scalars["Int"]>;
	duration_GTE?: InputMaybe<Scalars["Int"]>;
	duration_LT?: InputMaybe<Scalars["Int"]>;
	duration_LTE?: InputMaybe<Scalars["Int"]>;
	duration_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	duration_MAX_GT?: InputMaybe<Scalars["Int"]>;
	duration_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	duration_MAX_LT?: InputMaybe<Scalars["Int"]>;
	duration_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	duration_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	duration_MIN_GT?: InputMaybe<Scalars["Int"]>;
	duration_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	duration_MIN_LT?: InputMaybe<Scalars["Int"]>;
	duration_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	lastUpdatedOn_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_GT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_LT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_GT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_GTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_LT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_LTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	tenantId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	tenantId_EQUAL?: InputMaybe<Scalars["String"]>;
	tenantId_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type PreparationCoverageRequestRelationship = {
	__typename?: "PreparationCoverageRequestRelationship";
	cursor: Scalars["String"];
	node: CoverageRequest;
};

export type PreparationCoverageRequestUpdateConnectionInput = {
	node?: InputMaybe<CoverageRequestUpdateInput>;
};

export type PreparationCoverageRequestUpdateFieldInput = {
	connect?: InputMaybe<Array<PreparationCoverageRequestConnectFieldInput>>;
	create?: InputMaybe<Array<PreparationCoverageRequestCreateFieldInput>>;
	delete?: InputMaybe<Array<PreparationCoverageRequestDeleteFieldInput>>;
	disconnect?: InputMaybe<Array<PreparationCoverageRequestDisconnectFieldInput>>;
	update?: InputMaybe<PreparationCoverageRequestUpdateConnectionInput>;
	where?: InputMaybe<PreparationCoverageRequestConnectionWhere>;
};

export type PreparationCreateInput = {
	AtcCode?: InputMaybe<Scalars["String"]>;
	BrandName: Scalars["String"];
	DescriptionDe?: InputMaybe<Scalars["String"]>;
	GenericName?: InputMaybe<Scalars["String"]>;
	ReleaseDate?: InputMaybe<Scalars["Date"]>;
	SubjectMatter: AgreementSubjectMatter;
	SwissmedicNo5?: InputMaybe<Scalars["String"]>;
	brand?: InputMaybe<PreparationBrandFieldInput>;
	coverageRequest?: InputMaybe<PreparationCoverageRequestFieldInput>;
	coverageRequestCombined?: InputMaybe<PreparationCoverageRequestCombinedFieldInput>;
	hasLimitations?: InputMaybe<PreparationHasLimitationsFieldInput>;
	id: Scalars["ID"];
	regulates?: InputMaybe<PreparationRegulatesFieldInput>;
};

export type PreparationDeleteInput = {
	brand?: InputMaybe<PreparationBrandDeleteFieldInput>;
	coverageRequest?: InputMaybe<Array<PreparationCoverageRequestDeleteFieldInput>>;
	coverageRequestCombined?: InputMaybe<Array<PreparationCoverageRequestCombinedDeleteFieldInput>>;
	hasLimitations?: InputMaybe<Array<PreparationHasLimitationsDeleteFieldInput>>;
	regulates?: InputMaybe<Array<PreparationRegulatesDeleteFieldInput>>;
};

export type PreparationDisconnectInput = {
	brand?: InputMaybe<PreparationBrandDisconnectFieldInput>;
	coverageRequest?: InputMaybe<Array<PreparationCoverageRequestDisconnectFieldInput>>;
	coverageRequestCombined?: InputMaybe<Array<PreparationCoverageRequestCombinedDisconnectFieldInput>>;
	hasLimitations?: InputMaybe<Array<PreparationHasLimitationsDisconnectFieldInput>>;
	regulates?: InputMaybe<Array<PreparationRegulatesDisconnectFieldInput>>;
};

export type PreparationHasLimitationsAggregateInput = {
	AND?: InputMaybe<Array<PreparationHasLimitationsAggregateInput>>;
	OR?: InputMaybe<Array<PreparationHasLimitationsAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<PreparationHasLimitationsNodeAggregationWhereInput>;
};

export type PreparationHasLimitationsConnectFieldInput = {
	connect?: InputMaybe<Array<LimitationConnectInput>>;
	where?: InputMaybe<LimitationConnectWhere>;
};

export type PreparationHasLimitationsConnection = {
	__typename?: "PreparationHasLimitationsConnection";
	edges: Array<PreparationHasLimitationsRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type PreparationHasLimitationsConnectionSort = {
	node?: InputMaybe<LimitationSort>;
};

export type PreparationHasLimitationsConnectionWhere = {
	AND?: InputMaybe<Array<PreparationHasLimitationsConnectionWhere>>;
	OR?: InputMaybe<Array<PreparationHasLimitationsConnectionWhere>>;
	node?: InputMaybe<LimitationWhere>;
	node_NOT?: InputMaybe<LimitationWhere>;
};

export type PreparationHasLimitationsCreateFieldInput = {
	node: LimitationCreateInput;
};

export type PreparationHasLimitationsDeleteFieldInput = {
	delete?: InputMaybe<LimitationDeleteInput>;
	where?: InputMaybe<PreparationHasLimitationsConnectionWhere>;
};

export type PreparationHasLimitationsDisconnectFieldInput = {
	disconnect?: InputMaybe<LimitationDisconnectInput>;
	where?: InputMaybe<PreparationHasLimitationsConnectionWhere>;
};

export type PreparationHasLimitationsFieldInput = {
	connect?: InputMaybe<Array<PreparationHasLimitationsConnectFieldInput>>;
	create?: InputMaybe<Array<PreparationHasLimitationsCreateFieldInput>>;
};

export type PreparationHasLimitationsNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<PreparationHasLimitationsNodeAggregationWhereInput>>;
	Code_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	Code_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	Code_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	Code_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	Code_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	Code_EQUAL?: InputMaybe<Scalars["String"]>;
	Code_GT?: InputMaybe<Scalars["Int"]>;
	Code_GTE?: InputMaybe<Scalars["Int"]>;
	Code_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Code_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	Code_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	Code_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	Code_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	Code_LT?: InputMaybe<Scalars["Int"]>;
	Code_LTE?: InputMaybe<Scalars["Int"]>;
	Code_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Code_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	Code_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	Code_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	Code_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	DescriptionDe_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	DescriptionDe_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	DescriptionDe_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	DescriptionDe_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	DescriptionDe_EQUAL?: InputMaybe<Scalars["String"]>;
	DescriptionDe_GT?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_GTE?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_LT?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_LTE?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	DescriptionEn_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	DescriptionEn_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	DescriptionEn_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	DescriptionEn_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	DescriptionEn_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	DescriptionEn_EQUAL?: InputMaybe<Scalars["String"]>;
	DescriptionEn_GT?: InputMaybe<Scalars["Int"]>;
	DescriptionEn_GTE?: InputMaybe<Scalars["Int"]>;
	DescriptionEn_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	DescriptionEn_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	DescriptionEn_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	DescriptionEn_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	DescriptionEn_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	DescriptionEn_LT?: InputMaybe<Scalars["Int"]>;
	DescriptionEn_LTE?: InputMaybe<Scalars["Int"]>;
	DescriptionEn_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	DescriptionEn_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	DescriptionEn_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	DescriptionEn_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	DescriptionEn_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	Niveau_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	Niveau_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	Niveau_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	Niveau_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	Niveau_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	Niveau_EQUAL?: InputMaybe<Scalars["String"]>;
	Niveau_GT?: InputMaybe<Scalars["Int"]>;
	Niveau_GTE?: InputMaybe<Scalars["Int"]>;
	Niveau_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Niveau_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	Niveau_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	Niveau_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	Niveau_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	Niveau_LT?: InputMaybe<Scalars["Int"]>;
	Niveau_LTE?: InputMaybe<Scalars["Int"]>;
	Niveau_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Niveau_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	Niveau_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	Niveau_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	Niveau_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	OR?: InputMaybe<Array<PreparationHasLimitationsNodeAggregationWhereInput>>;
	Type_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	Type_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	Type_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	Type_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	Type_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	Type_EQUAL?: InputMaybe<Scalars["String"]>;
	Type_GT?: InputMaybe<Scalars["Int"]>;
	Type_GTE?: InputMaybe<Scalars["Int"]>;
	Type_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Type_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	Type_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	Type_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	Type_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	Type_LT?: InputMaybe<Scalars["Int"]>;
	Type_LTE?: InputMaybe<Scalars["Int"]>;
	Type_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Type_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	Type_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	Type_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	Type_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	uuid_EQUAL?: InputMaybe<Scalars["ID"]>;
};

export type PreparationHasLimitationsRelationship = {
	__typename?: "PreparationHasLimitationsRelationship";
	cursor: Scalars["String"];
	node: Limitation;
};

export type PreparationHasLimitationsUpdateConnectionInput = {
	node?: InputMaybe<LimitationUpdateInput>;
};

export type PreparationHasLimitationsUpdateFieldInput = {
	connect?: InputMaybe<Array<PreparationHasLimitationsConnectFieldInput>>;
	create?: InputMaybe<Array<PreparationHasLimitationsCreateFieldInput>>;
	delete?: InputMaybe<Array<PreparationHasLimitationsDeleteFieldInput>>;
	disconnect?: InputMaybe<Array<PreparationHasLimitationsDisconnectFieldInput>>;
	update?: InputMaybe<PreparationHasLimitationsUpdateConnectionInput>;
	where?: InputMaybe<PreparationHasLimitationsConnectionWhere>;
};

export type PreparationOptions = {
	limit?: InputMaybe<Scalars["Int"]>;
	offset?: InputMaybe<Scalars["Int"]>;
	/** Specify one or more PreparationSort objects to sort Preparations by. The sorts will be applied in the order in which they are arranged in the array. */
	sort?: InputMaybe<Array<InputMaybe<PreparationSort>>>;
};

export type PreparationRegulatesAggregateInput = {
	AND?: InputMaybe<Array<PreparationRegulatesAggregateInput>>;
	OR?: InputMaybe<Array<PreparationRegulatesAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<PreparationRegulatesNodeAggregationWhereInput>;
};

export type PreparationRegulatesConnectFieldInput = {
	connect?: InputMaybe<Array<TreatmentConnectInput>>;
	where?: InputMaybe<TreatmentConnectWhere>;
};

export type PreparationRegulatesConnection = {
	__typename?: "PreparationRegulatesConnection";
	edges: Array<PreparationRegulatesRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type PreparationRegulatesConnectionSort = {
	node?: InputMaybe<TreatmentSort>;
};

export type PreparationRegulatesConnectionWhere = {
	AND?: InputMaybe<Array<PreparationRegulatesConnectionWhere>>;
	OR?: InputMaybe<Array<PreparationRegulatesConnectionWhere>>;
	node?: InputMaybe<TreatmentWhere>;
	node_NOT?: InputMaybe<TreatmentWhere>;
};

export type PreparationRegulatesCreateFieldInput = {
	node: TreatmentCreateInput;
};

export type PreparationRegulatesDeleteFieldInput = {
	delete?: InputMaybe<TreatmentDeleteInput>;
	where?: InputMaybe<PreparationRegulatesConnectionWhere>;
};

export type PreparationRegulatesDisconnectFieldInput = {
	disconnect?: InputMaybe<TreatmentDisconnectInput>;
	where?: InputMaybe<PreparationRegulatesConnectionWhere>;
};

export type PreparationRegulatesFieldInput = {
	connect?: InputMaybe<Array<PreparationRegulatesConnectFieldInput>>;
	create?: InputMaybe<Array<PreparationRegulatesCreateFieldInput>>;
};

export type PreparationRegulatesNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<PreparationRegulatesNodeAggregationWhereInput>>;
	BagDossierNo_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	BagDossierNo_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	BagDossierNo_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	BagDossierNo_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	BagDossierNo_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	BagDossierNo_EQUAL?: InputMaybe<Scalars["String"]>;
	BagDossierNo_GT?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_GTE?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LT?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LTE?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	Code_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	Code_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	Code_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	Code_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	Code_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	Code_EQUAL?: InputMaybe<Scalars["String"]>;
	Code_GT?: InputMaybe<Scalars["Int"]>;
	Code_GTE?: InputMaybe<Scalars["Int"]>;
	Code_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Code_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	Code_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	Code_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	Code_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	Code_LT?: InputMaybe<Scalars["Int"]>;
	Code_LTE?: InputMaybe<Scalars["Int"]>;
	Code_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Code_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	Code_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	Code_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	Code_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	FlagModal_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	FlagModal_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	FlagModal_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	FlagModal_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	FlagModal_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	FlagModal_EQUAL?: InputMaybe<Scalars["String"]>;
	FlagModal_GT?: InputMaybe<Scalars["Int"]>;
	FlagModal_GTE?: InputMaybe<Scalars["Int"]>;
	FlagModal_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	FlagModal_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	FlagModal_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	FlagModal_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	FlagModal_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	FlagModal_LT?: InputMaybe<Scalars["Int"]>;
	FlagModal_LTE?: InputMaybe<Scalars["Int"]>;
	FlagModal_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	FlagModal_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	FlagModal_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	FlagModal_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	FlagModal_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	FlagNarcosis_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	FlagNarcosis_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	FlagNarcosis_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	FlagNarcosis_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	FlagNarcosis_EQUAL?: InputMaybe<Scalars["String"]>;
	FlagNarcosis_GT?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_GTE?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LT?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LTE?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	GTIN_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	GTIN_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	GTIN_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	GTIN_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	GTIN_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	GTIN_EQUAL?: InputMaybe<Scalars["String"]>;
	GTIN_GT?: InputMaybe<Scalars["Int"]>;
	GTIN_GTE?: InputMaybe<Scalars["Int"]>;
	GTIN_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	GTIN_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	GTIN_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	GTIN_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	GTIN_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	GTIN_LT?: InputMaybe<Scalars["Int"]>;
	GTIN_LTE?: InputMaybe<Scalars["Int"]>;
	GTIN_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	GTIN_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	GTIN_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	GTIN_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	GTIN_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	LOT_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	LOT_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	LOT_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	LOT_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	LOT_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	LOT_EQUAL?: InputMaybe<Scalars["String"]>;
	LOT_GT?: InputMaybe<Scalars["Int"]>;
	LOT_GTE?: InputMaybe<Scalars["Int"]>;
	LOT_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	LOT_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	LOT_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	LOT_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	LOT_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	LOT_LT?: InputMaybe<Scalars["Int"]>;
	LOT_LTE?: InputMaybe<Scalars["Int"]>;
	LOT_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	LOT_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	LOT_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	LOT_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	LOT_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	Name_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	Name_EQUAL?: InputMaybe<Scalars["String"]>;
	Name_GT?: InputMaybe<Scalars["Int"]>;
	Name_GTE?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	Name_LT?: InputMaybe<Scalars["Int"]>;
	Name_LTE?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	OR?: InputMaybe<Array<PreparationRegulatesNodeAggregationWhereInput>>;
	PharmaCode_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	PharmaCode_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	PharmaCode_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	PharmaCode_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	PharmaCode_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	PharmaCode_EQUAL?: InputMaybe<Scalars["String"]>;
	PharmaCode_GT?: InputMaybe<Scalars["Int"]>;
	PharmaCode_GTE?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LT?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LTE?: InputMaybe<Scalars["Int"]>;
	PharmaCode_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	PharmaCode_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	PharmaCode_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	PharmaCode_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	PharmaCode_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	PrevPharmacode_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	PrevPharmacode_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	PrevPharmacode_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	PrevPharmacode_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	PrevPharmacode_EQUAL?: InputMaybe<Scalars["String"]>;
	PrevPharmacode_GT?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_GTE?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LT?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LTE?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	REF_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	REF_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	REF_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	REF_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	REF_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	REF_EQUAL?: InputMaybe<Scalars["String"]>;
	REF_GT?: InputMaybe<Scalars["Int"]>;
	REF_GTE?: InputMaybe<Scalars["Int"]>;
	REF_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	REF_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	REF_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	REF_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	REF_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	REF_LT?: InputMaybe<Scalars["Int"]>;
	REF_LTE?: InputMaybe<Scalars["Int"]>;
	REF_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	REF_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	REF_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	REF_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	REF_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	SwissmedicCategory_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	SwissmedicCategory_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	SwissmedicCategory_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	SwissmedicCategory_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	SwissmedicCategory_EQUAL?: InputMaybe<Scalars["String"]>;
	SwissmedicCategory_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo8_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo8_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo8_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo8_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo8_EQUAL?: InputMaybe<Scalars["String"]>;
	SwissmedicNo8_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	UDI_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	UDI_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	UDI_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	UDI_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	UDI_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	UDI_EQUAL?: InputMaybe<Scalars["String"]>;
	UDI_GT?: InputMaybe<Scalars["Int"]>;
	UDI_GTE?: InputMaybe<Scalars["Int"]>;
	UDI_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	UDI_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	UDI_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	UDI_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	UDI_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	UDI_LT?: InputMaybe<Scalars["Int"]>;
	UDI_LTE?: InputMaybe<Scalars["Int"]>;
	UDI_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	UDI_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	UDI_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	UDI_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	UDI_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	classificationSystem_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	classificationSystem_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	classificationSystem_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	classificationSystem_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	classificationSystem_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	classificationSystem_EQUAL?: InputMaybe<Scalars["String"]>;
	classificationSystem_GT?: InputMaybe<Scalars["Int"]>;
	classificationSystem_GTE?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LT?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LTE?: InputMaybe<Scalars["Int"]>;
	classificationSystem_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	classificationSystem_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	classificationSystem_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	classificationSystem_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	classificationSystem_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type PreparationRegulatesRelationship = {
	__typename?: "PreparationRegulatesRelationship";
	cursor: Scalars["String"];
	node: Treatment;
};

export type PreparationRegulatesUpdateConnectionInput = {
	node?: InputMaybe<TreatmentUpdateInput>;
};

export type PreparationRegulatesUpdateFieldInput = {
	connect?: InputMaybe<Array<PreparationRegulatesConnectFieldInput>>;
	create?: InputMaybe<Array<PreparationRegulatesCreateFieldInput>>;
	delete?: InputMaybe<Array<PreparationRegulatesDeleteFieldInput>>;
	disconnect?: InputMaybe<Array<PreparationRegulatesDisconnectFieldInput>>;
	update?: InputMaybe<PreparationRegulatesUpdateConnectionInput>;
	where?: InputMaybe<PreparationRegulatesConnectionWhere>;
};

/** Fields to sort Preparations by. The order in which sorts are applied is not guaranteed when specifying many fields in one PreparationSort object. */
export type PreparationSort = {
	AtcCode?: InputMaybe<SortDirection>;
	BrandName?: InputMaybe<SortDirection>;
	DescriptionDe?: InputMaybe<SortDirection>;
	GenericName?: InputMaybe<SortDirection>;
	ReleaseDate?: InputMaybe<SortDirection>;
	SubjectMatter?: InputMaybe<SortDirection>;
	SwissmedicNo5?: InputMaybe<SortDirection>;
	id?: InputMaybe<SortDirection>;
};

export type PreparationStatus = {
	__typename?: "PreparationStatus";
	FlagApd?: Maybe<Scalars["String"]>;
	IntegrationDate: Scalars["Date"];
	StatusTypeCodeSl?: Maybe<Scalars["String"]>;
	StatusTypeDescriptionSl?: Maybe<Scalars["String"]>;
	ValidFromDate: Scalars["Date"];
	ValidThruDate: Scalars["Date"];
	preparation?: Maybe<Preparation>;
	preparationConnection: PreparationStatusPreparationConnection;
};

export type PreparationStatusPreparationArgs = {
	options?: InputMaybe<PreparationOptions>;
	where?: InputMaybe<PreparationWhere>;
};

export type PreparationStatusPreparationConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<PreparationStatusPreparationConnectionSort>>;
	where?: InputMaybe<PreparationStatusPreparationConnectionWhere>;
};

export type PreparationStatusAggregateSelection = {
	__typename?: "PreparationStatusAggregateSelection";
	FlagApd: StringAggregateSelection;
	StatusTypeCodeSl: StringAggregateSelection;
	StatusTypeDescriptionSl: StringAggregateSelection;
	count: Scalars["Int"];
};

export type PreparationStatusConnectInput = {
	preparation?: InputMaybe<PreparationStatusPreparationConnectFieldInput>;
};

export type PreparationStatusConnectWhere = {
	node: PreparationStatusWhere;
};

export type PreparationStatusCreateInput = {
	FlagApd?: InputMaybe<Scalars["String"]>;
	IntegrationDate: Scalars["Date"];
	StatusTypeCodeSl?: InputMaybe<Scalars["String"]>;
	StatusTypeDescriptionSl?: InputMaybe<Scalars["String"]>;
	ValidFromDate: Scalars["Date"];
	ValidThruDate: Scalars["Date"];
	preparation?: InputMaybe<PreparationStatusPreparationFieldInput>;
};

export type PreparationStatusDeleteInput = {
	preparation?: InputMaybe<PreparationStatusPreparationDeleteFieldInput>;
};

export type PreparationStatusDisconnectInput = {
	preparation?: InputMaybe<PreparationStatusPreparationDisconnectFieldInput>;
};

export type PreparationStatusOptions = {
	limit?: InputMaybe<Scalars["Int"]>;
	offset?: InputMaybe<Scalars["Int"]>;
	/** Specify one or more PreparationStatusSort objects to sort PreparationStatuses by. The sorts will be applied in the order in which they are arranged in the array. */
	sort?: InputMaybe<Array<InputMaybe<PreparationStatusSort>>>;
};

export type PreparationStatusPreparationAggregateInput = {
	AND?: InputMaybe<Array<PreparationStatusPreparationAggregateInput>>;
	OR?: InputMaybe<Array<PreparationStatusPreparationAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<PreparationStatusPreparationNodeAggregationWhereInput>;
};

export type PreparationStatusPreparationConnectFieldInput = {
	connect?: InputMaybe<PreparationConnectInput>;
	where?: InputMaybe<PreparationConnectWhere>;
};

export type PreparationStatusPreparationConnection = {
	__typename?: "PreparationStatusPreparationConnection";
	edges: Array<PreparationStatusPreparationRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type PreparationStatusPreparationConnectionSort = {
	node?: InputMaybe<PreparationSort>;
};

export type PreparationStatusPreparationConnectionWhere = {
	AND?: InputMaybe<Array<PreparationStatusPreparationConnectionWhere>>;
	OR?: InputMaybe<Array<PreparationStatusPreparationConnectionWhere>>;
	node?: InputMaybe<PreparationWhere>;
	node_NOT?: InputMaybe<PreparationWhere>;
};

export type PreparationStatusPreparationCreateFieldInput = {
	node: PreparationCreateInput;
};

export type PreparationStatusPreparationDeleteFieldInput = {
	delete?: InputMaybe<PreparationDeleteInput>;
	where?: InputMaybe<PreparationStatusPreparationConnectionWhere>;
};

export type PreparationStatusPreparationDisconnectFieldInput = {
	disconnect?: InputMaybe<PreparationDisconnectInput>;
	where?: InputMaybe<PreparationStatusPreparationConnectionWhere>;
};

export type PreparationStatusPreparationFieldInput = {
	connect?: InputMaybe<PreparationStatusPreparationConnectFieldInput>;
	create?: InputMaybe<PreparationStatusPreparationCreateFieldInput>;
};

export type PreparationStatusPreparationNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<PreparationStatusPreparationNodeAggregationWhereInput>>;
	AtcCode_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	AtcCode_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	AtcCode_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	AtcCode_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	AtcCode_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	AtcCode_EQUAL?: InputMaybe<Scalars["String"]>;
	AtcCode_GT?: InputMaybe<Scalars["Int"]>;
	AtcCode_GTE?: InputMaybe<Scalars["Int"]>;
	AtcCode_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	AtcCode_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	AtcCode_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	AtcCode_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	AtcCode_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	AtcCode_LT?: InputMaybe<Scalars["Int"]>;
	AtcCode_LTE?: InputMaybe<Scalars["Int"]>;
	AtcCode_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	AtcCode_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	AtcCode_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	AtcCode_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	AtcCode_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	BrandName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	BrandName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	BrandName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	BrandName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	BrandName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	BrandName_EQUAL?: InputMaybe<Scalars["String"]>;
	BrandName_GT?: InputMaybe<Scalars["Int"]>;
	BrandName_GTE?: InputMaybe<Scalars["Int"]>;
	BrandName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	BrandName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	BrandName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	BrandName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	BrandName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	BrandName_LT?: InputMaybe<Scalars["Int"]>;
	BrandName_LTE?: InputMaybe<Scalars["Int"]>;
	BrandName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	BrandName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	BrandName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	BrandName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	BrandName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	DescriptionDe_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	DescriptionDe_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	DescriptionDe_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	DescriptionDe_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	DescriptionDe_EQUAL?: InputMaybe<Scalars["String"]>;
	DescriptionDe_GT?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_GTE?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_LT?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_LTE?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	GenericName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	GenericName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	GenericName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	GenericName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	GenericName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	GenericName_EQUAL?: InputMaybe<Scalars["String"]>;
	GenericName_GT?: InputMaybe<Scalars["Int"]>;
	GenericName_GTE?: InputMaybe<Scalars["Int"]>;
	GenericName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	GenericName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	GenericName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	GenericName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	GenericName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	GenericName_LT?: InputMaybe<Scalars["Int"]>;
	GenericName_LTE?: InputMaybe<Scalars["Int"]>;
	GenericName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	GenericName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	GenericName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	GenericName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	GenericName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	OR?: InputMaybe<Array<PreparationStatusPreparationNodeAggregationWhereInput>>;
	SwissmedicNo5_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo5_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo5_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo5_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo5_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo5_EQUAL?: InputMaybe<Scalars["String"]>;
	SwissmedicNo5_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo5_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo5_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo5_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo5_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo5_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo5_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo5_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo5_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo5_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo5_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo5_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo5_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo5_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
};

export type PreparationStatusPreparationRelationship = {
	__typename?: "PreparationStatusPreparationRelationship";
	cursor: Scalars["String"];
	node: Preparation;
};

export type PreparationStatusPreparationUpdateConnectionInput = {
	node?: InputMaybe<PreparationUpdateInput>;
};

export type PreparationStatusPreparationUpdateFieldInput = {
	connect?: InputMaybe<PreparationStatusPreparationConnectFieldInput>;
	create?: InputMaybe<PreparationStatusPreparationCreateFieldInput>;
	delete?: InputMaybe<PreparationStatusPreparationDeleteFieldInput>;
	disconnect?: InputMaybe<PreparationStatusPreparationDisconnectFieldInput>;
	update?: InputMaybe<PreparationStatusPreparationUpdateConnectionInput>;
	where?: InputMaybe<PreparationStatusPreparationConnectionWhere>;
};

/** Fields to sort PreparationStatuses by. The order in which sorts are applied is not guaranteed when specifying many fields in one PreparationStatusSort object. */
export type PreparationStatusSort = {
	FlagApd?: InputMaybe<SortDirection>;
	IntegrationDate?: InputMaybe<SortDirection>;
	StatusTypeCodeSl?: InputMaybe<SortDirection>;
	StatusTypeDescriptionSl?: InputMaybe<SortDirection>;
	ValidFromDate?: InputMaybe<SortDirection>;
	ValidThruDate?: InputMaybe<SortDirection>;
};

export type PreparationStatusUpdateInput = {
	FlagApd?: InputMaybe<Scalars["String"]>;
	IntegrationDate?: InputMaybe<Scalars["Date"]>;
	StatusTypeCodeSl?: InputMaybe<Scalars["String"]>;
	StatusTypeDescriptionSl?: InputMaybe<Scalars["String"]>;
	ValidFromDate?: InputMaybe<Scalars["Date"]>;
	ValidThruDate?: InputMaybe<Scalars["Date"]>;
	preparation?: InputMaybe<PreparationStatusPreparationUpdateFieldInput>;
};

export type PreparationStatusWhere = {
	AND?: InputMaybe<Array<PreparationStatusWhere>>;
	FlagApd?: InputMaybe<Scalars["String"]>;
	FlagApd_CONTAINS?: InputMaybe<Scalars["String"]>;
	FlagApd_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	FlagApd_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	FlagApd_MATCHES?: InputMaybe<Scalars["String"]>;
	FlagApd_NOT?: InputMaybe<Scalars["String"]>;
	FlagApd_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	FlagApd_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	FlagApd_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	FlagApd_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	FlagApd_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	IntegrationDate?: InputMaybe<Scalars["Date"]>;
	IntegrationDate_GT?: InputMaybe<Scalars["Date"]>;
	IntegrationDate_GTE?: InputMaybe<Scalars["Date"]>;
	IntegrationDate_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
	IntegrationDate_LT?: InputMaybe<Scalars["Date"]>;
	IntegrationDate_LTE?: InputMaybe<Scalars["Date"]>;
	IntegrationDate_NOT?: InputMaybe<Scalars["Date"]>;
	IntegrationDate_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
	OR?: InputMaybe<Array<PreparationStatusWhere>>;
	StatusTypeCodeSl?: InputMaybe<Scalars["String"]>;
	StatusTypeCodeSl_CONTAINS?: InputMaybe<Scalars["String"]>;
	StatusTypeCodeSl_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	StatusTypeCodeSl_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	StatusTypeCodeSl_MATCHES?: InputMaybe<Scalars["String"]>;
	StatusTypeCodeSl_NOT?: InputMaybe<Scalars["String"]>;
	StatusTypeCodeSl_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	StatusTypeCodeSl_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	StatusTypeCodeSl_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	StatusTypeCodeSl_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	StatusTypeCodeSl_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	StatusTypeDescriptionSl?: InputMaybe<Scalars["String"]>;
	StatusTypeDescriptionSl_CONTAINS?: InputMaybe<Scalars["String"]>;
	StatusTypeDescriptionSl_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	StatusTypeDescriptionSl_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	StatusTypeDescriptionSl_MATCHES?: InputMaybe<Scalars["String"]>;
	StatusTypeDescriptionSl_NOT?: InputMaybe<Scalars["String"]>;
	StatusTypeDescriptionSl_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	StatusTypeDescriptionSl_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	StatusTypeDescriptionSl_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	StatusTypeDescriptionSl_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	StatusTypeDescriptionSl_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	ValidFromDate?: InputMaybe<Scalars["Date"]>;
	ValidFromDate_GT?: InputMaybe<Scalars["Date"]>;
	ValidFromDate_GTE?: InputMaybe<Scalars["Date"]>;
	ValidFromDate_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
	ValidFromDate_LT?: InputMaybe<Scalars["Date"]>;
	ValidFromDate_LTE?: InputMaybe<Scalars["Date"]>;
	ValidFromDate_NOT?: InputMaybe<Scalars["Date"]>;
	ValidFromDate_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
	ValidThruDate?: InputMaybe<Scalars["Date"]>;
	ValidThruDate_GT?: InputMaybe<Scalars["Date"]>;
	ValidThruDate_GTE?: InputMaybe<Scalars["Date"]>;
	ValidThruDate_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
	ValidThruDate_LT?: InputMaybe<Scalars["Date"]>;
	ValidThruDate_LTE?: InputMaybe<Scalars["Date"]>;
	ValidThruDate_NOT?: InputMaybe<Scalars["Date"]>;
	ValidThruDate_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
	preparation?: InputMaybe<PreparationWhere>;
	preparationAggregate?: InputMaybe<PreparationStatusPreparationAggregateInput>;
	preparationConnection?: InputMaybe<PreparationStatusPreparationConnectionWhere>;
	preparationConnection_NOT?: InputMaybe<PreparationStatusPreparationConnectionWhere>;
	preparation_NOT?: InputMaybe<PreparationWhere>;
};

export type PreparationUpdateInput = {
	AtcCode?: InputMaybe<Scalars["String"]>;
	BrandName?: InputMaybe<Scalars["String"]>;
	DescriptionDe?: InputMaybe<Scalars["String"]>;
	GenericName?: InputMaybe<Scalars["String"]>;
	ReleaseDate?: InputMaybe<Scalars["Date"]>;
	SubjectMatter?: InputMaybe<AgreementSubjectMatter>;
	SwissmedicNo5?: InputMaybe<Scalars["String"]>;
	brand?: InputMaybe<PreparationBrandUpdateFieldInput>;
	coverageRequest?: InputMaybe<Array<PreparationCoverageRequestUpdateFieldInput>>;
	coverageRequestCombined?: InputMaybe<Array<PreparationCoverageRequestCombinedUpdateFieldInput>>;
	hasLimitations?: InputMaybe<Array<PreparationHasLimitationsUpdateFieldInput>>;
	id?: InputMaybe<Scalars["ID"]>;
	regulates?: InputMaybe<Array<PreparationRegulatesUpdateFieldInput>>;
};

export type PreparationWhere = {
	AND?: InputMaybe<Array<PreparationWhere>>;
	AtcCode?: InputMaybe<Scalars["String"]>;
	AtcCode_CONTAINS?: InputMaybe<Scalars["String"]>;
	AtcCode_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	AtcCode_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	AtcCode_MATCHES?: InputMaybe<Scalars["String"]>;
	AtcCode_NOT?: InputMaybe<Scalars["String"]>;
	AtcCode_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	AtcCode_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	AtcCode_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	AtcCode_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	AtcCode_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	BrandName?: InputMaybe<Scalars["String"]>;
	BrandName_CONTAINS?: InputMaybe<Scalars["String"]>;
	BrandName_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	BrandName_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	BrandName_MATCHES?: InputMaybe<Scalars["String"]>;
	BrandName_NOT?: InputMaybe<Scalars["String"]>;
	BrandName_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	BrandName_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	BrandName_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	BrandName_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	BrandName_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	DescriptionDe?: InputMaybe<Scalars["String"]>;
	DescriptionDe_CONTAINS?: InputMaybe<Scalars["String"]>;
	DescriptionDe_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	DescriptionDe_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	DescriptionDe_MATCHES?: InputMaybe<Scalars["String"]>;
	DescriptionDe_NOT?: InputMaybe<Scalars["String"]>;
	DescriptionDe_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	DescriptionDe_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	DescriptionDe_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	DescriptionDe_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	DescriptionDe_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	GenericName?: InputMaybe<Scalars["String"]>;
	GenericName_CONTAINS?: InputMaybe<Scalars["String"]>;
	GenericName_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	GenericName_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	GenericName_MATCHES?: InputMaybe<Scalars["String"]>;
	GenericName_NOT?: InputMaybe<Scalars["String"]>;
	GenericName_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	GenericName_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	GenericName_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	GenericName_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	GenericName_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	OR?: InputMaybe<Array<PreparationWhere>>;
	ReleaseDate?: InputMaybe<Scalars["Date"]>;
	ReleaseDate_GT?: InputMaybe<Scalars["Date"]>;
	ReleaseDate_GTE?: InputMaybe<Scalars["Date"]>;
	ReleaseDate_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
	ReleaseDate_LT?: InputMaybe<Scalars["Date"]>;
	ReleaseDate_LTE?: InputMaybe<Scalars["Date"]>;
	ReleaseDate_NOT?: InputMaybe<Scalars["Date"]>;
	ReleaseDate_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
	SubjectMatter?: InputMaybe<AgreementSubjectMatter>;
	SubjectMatter_IN?: InputMaybe<Array<InputMaybe<AgreementSubjectMatter>>>;
	SubjectMatter_NOT?: InputMaybe<AgreementSubjectMatter>;
	SubjectMatter_NOT_IN?: InputMaybe<Array<InputMaybe<AgreementSubjectMatter>>>;
	SwissmedicNo5?: InputMaybe<Scalars["String"]>;
	SwissmedicNo5_CONTAINS?: InputMaybe<Scalars["String"]>;
	SwissmedicNo5_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	SwissmedicNo5_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	SwissmedicNo5_MATCHES?: InputMaybe<Scalars["String"]>;
	SwissmedicNo5_NOT?: InputMaybe<Scalars["String"]>;
	SwissmedicNo5_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	SwissmedicNo5_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	SwissmedicNo5_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	SwissmedicNo5_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	SwissmedicNo5_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	brand?: InputMaybe<BrandWhere>;
	brandAggregate?: InputMaybe<PreparationBrandAggregateInput>;
	brandConnection?: InputMaybe<PreparationBrandConnectionWhere>;
	brandConnection_NOT?: InputMaybe<PreparationBrandConnectionWhere>;
	brand_NOT?: InputMaybe<BrandWhere>;
	coverageRequest?: InputMaybe<CoverageRequestWhere>;
	coverageRequestAggregate?: InputMaybe<PreparationCoverageRequestAggregateInput>;
	coverageRequestCombined?: InputMaybe<CoverageRequestWhere>;
	coverageRequestCombinedAggregate?: InputMaybe<PreparationCoverageRequestCombinedAggregateInput>;
	coverageRequestCombinedConnection?: InputMaybe<PreparationCoverageRequestCombinedConnectionWhere>;
	coverageRequestCombinedConnection_NOT?: InputMaybe<PreparationCoverageRequestCombinedConnectionWhere>;
	coverageRequestCombined_NOT?: InputMaybe<CoverageRequestWhere>;
	coverageRequestConnection?: InputMaybe<PreparationCoverageRequestConnectionWhere>;
	coverageRequestConnection_NOT?: InputMaybe<PreparationCoverageRequestConnectionWhere>;
	coverageRequest_NOT?: InputMaybe<CoverageRequestWhere>;
	hasLimitations?: InputMaybe<LimitationWhere>;
	hasLimitationsAggregate?: InputMaybe<PreparationHasLimitationsAggregateInput>;
	hasLimitationsConnection?: InputMaybe<PreparationHasLimitationsConnectionWhere>;
	hasLimitationsConnection_NOT?: InputMaybe<PreparationHasLimitationsConnectionWhere>;
	hasLimitations_NOT?: InputMaybe<LimitationWhere>;
	id?: InputMaybe<Scalars["ID"]>;
	id_CONTAINS?: InputMaybe<Scalars["ID"]>;
	id_ENDS_WITH?: InputMaybe<Scalars["ID"]>;
	id_IN?: InputMaybe<Array<InputMaybe<Scalars["ID"]>>>;
	id_MATCHES?: InputMaybe<Scalars["String"]>;
	id_NOT?: InputMaybe<Scalars["ID"]>;
	id_NOT_CONTAINS?: InputMaybe<Scalars["ID"]>;
	id_NOT_ENDS_WITH?: InputMaybe<Scalars["ID"]>;
	id_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["ID"]>>>;
	id_NOT_STARTS_WITH?: InputMaybe<Scalars["ID"]>;
	id_STARTS_WITH?: InputMaybe<Scalars["ID"]>;
	regulates?: InputMaybe<TreatmentWhere>;
	regulatesAggregate?: InputMaybe<PreparationRegulatesAggregateInput>;
	regulatesConnection?: InputMaybe<PreparationRegulatesConnectionWhere>;
	regulatesConnection_NOT?: InputMaybe<PreparationRegulatesConnectionWhere>;
	regulates_NOT?: InputMaybe<TreatmentWhere>;
};

export enum PatientScope {
	PerAgreement = "PER_AGREEMENT",
	PerPatient = "PER_PATIENT",
}

export type Price = {
	__typename?: "Price";
	Price?: Maybe<Scalars["String"]>;
	PriceChangeTypeCode?: Maybe<Scalars["String"]>;
	PriceChangeTypeDescriptionDe?: Maybe<Scalars["String"]>;
	PriceTypeCode?: Maybe<Scalars["String"]>;
	PriceTypeDescriptionDe?: Maybe<Scalars["String"]>;
	ValidFromDate?: Maybe<Scalars["Date"]>;
	treatment?: Maybe<Treatment>;
	treatmentConnection: PriceTreatmentConnection;
};

export type PriceTreatmentArgs = {
	options?: InputMaybe<TreatmentOptions>;
	where?: InputMaybe<TreatmentWhere>;
};

export type PriceTreatmentConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<PriceTreatmentConnectionSort>>;
	where?: InputMaybe<PriceTreatmentConnectionWhere>;
};

export type PriceAggregateSelection = {
	__typename?: "PriceAggregateSelection";
	Price: StringAggregateSelection;
	PriceChangeTypeCode: StringAggregateSelection;
	PriceChangeTypeDescriptionDe: StringAggregateSelection;
	PriceTypeCode: StringAggregateSelection;
	PriceTypeDescriptionDe: StringAggregateSelection;
	count: Scalars["Int"];
};

export type PriceOptions = {
	limit?: InputMaybe<Scalars["Int"]>;
	offset?: InputMaybe<Scalars["Int"]>;
	/** Specify one or more PriceSort objects to sort Prices by. The sorts will be applied in the order in which they are arranged in the array. */
	sort?: InputMaybe<Array<InputMaybe<PriceSort>>>;
};

/** Fields to sort Prices by. The order in which sorts are applied is not guaranteed when specifying many fields in one PriceSort object. */
export type PriceSort = {
	Price?: InputMaybe<SortDirection>;
	PriceChangeTypeCode?: InputMaybe<SortDirection>;
	PriceChangeTypeDescriptionDe?: InputMaybe<SortDirection>;
	PriceTypeCode?: InputMaybe<SortDirection>;
	PriceTypeDescriptionDe?: InputMaybe<SortDirection>;
	ValidFromDate?: InputMaybe<SortDirection>;
};

export type PriceTreatmentAggregateInput = {
	AND?: InputMaybe<Array<PriceTreatmentAggregateInput>>;
	OR?: InputMaybe<Array<PriceTreatmentAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<PriceTreatmentNodeAggregationWhereInput>;
};

export type PriceTreatmentConnection = {
	__typename?: "PriceTreatmentConnection";
	edges: Array<PriceTreatmentRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type PriceTreatmentConnectionSort = {
	node?: InputMaybe<TreatmentSort>;
};

export type PriceTreatmentConnectionWhere = {
	AND?: InputMaybe<Array<PriceTreatmentConnectionWhere>>;
	OR?: InputMaybe<Array<PriceTreatmentConnectionWhere>>;
	node?: InputMaybe<TreatmentWhere>;
	node_NOT?: InputMaybe<TreatmentWhere>;
};

export type PriceTreatmentNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<PriceTreatmentNodeAggregationWhereInput>>;
	BagDossierNo_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	BagDossierNo_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	BagDossierNo_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	BagDossierNo_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	BagDossierNo_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	BagDossierNo_EQUAL?: InputMaybe<Scalars["String"]>;
	BagDossierNo_GT?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_GTE?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LT?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LTE?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	Code_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	Code_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	Code_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	Code_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	Code_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	Code_EQUAL?: InputMaybe<Scalars["String"]>;
	Code_GT?: InputMaybe<Scalars["Int"]>;
	Code_GTE?: InputMaybe<Scalars["Int"]>;
	Code_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Code_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	Code_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	Code_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	Code_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	Code_LT?: InputMaybe<Scalars["Int"]>;
	Code_LTE?: InputMaybe<Scalars["Int"]>;
	Code_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Code_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	Code_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	Code_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	Code_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	FlagModal_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	FlagModal_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	FlagModal_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	FlagModal_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	FlagModal_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	FlagModal_EQUAL?: InputMaybe<Scalars["String"]>;
	FlagModal_GT?: InputMaybe<Scalars["Int"]>;
	FlagModal_GTE?: InputMaybe<Scalars["Int"]>;
	FlagModal_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	FlagModal_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	FlagModal_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	FlagModal_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	FlagModal_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	FlagModal_LT?: InputMaybe<Scalars["Int"]>;
	FlagModal_LTE?: InputMaybe<Scalars["Int"]>;
	FlagModal_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	FlagModal_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	FlagModal_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	FlagModal_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	FlagModal_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	FlagNarcosis_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	FlagNarcosis_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	FlagNarcosis_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	FlagNarcosis_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	FlagNarcosis_EQUAL?: InputMaybe<Scalars["String"]>;
	FlagNarcosis_GT?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_GTE?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LT?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LTE?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	GTIN_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	GTIN_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	GTIN_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	GTIN_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	GTIN_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	GTIN_EQUAL?: InputMaybe<Scalars["String"]>;
	GTIN_GT?: InputMaybe<Scalars["Int"]>;
	GTIN_GTE?: InputMaybe<Scalars["Int"]>;
	GTIN_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	GTIN_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	GTIN_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	GTIN_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	GTIN_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	GTIN_LT?: InputMaybe<Scalars["Int"]>;
	GTIN_LTE?: InputMaybe<Scalars["Int"]>;
	GTIN_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	GTIN_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	GTIN_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	GTIN_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	GTIN_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	LOT_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	LOT_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	LOT_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	LOT_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	LOT_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	LOT_EQUAL?: InputMaybe<Scalars["String"]>;
	LOT_GT?: InputMaybe<Scalars["Int"]>;
	LOT_GTE?: InputMaybe<Scalars["Int"]>;
	LOT_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	LOT_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	LOT_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	LOT_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	LOT_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	LOT_LT?: InputMaybe<Scalars["Int"]>;
	LOT_LTE?: InputMaybe<Scalars["Int"]>;
	LOT_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	LOT_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	LOT_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	LOT_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	LOT_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	Name_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	Name_EQUAL?: InputMaybe<Scalars["String"]>;
	Name_GT?: InputMaybe<Scalars["Int"]>;
	Name_GTE?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	Name_LT?: InputMaybe<Scalars["Int"]>;
	Name_LTE?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	OR?: InputMaybe<Array<PriceTreatmentNodeAggregationWhereInput>>;
	PharmaCode_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	PharmaCode_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	PharmaCode_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	PharmaCode_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	PharmaCode_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	PharmaCode_EQUAL?: InputMaybe<Scalars["String"]>;
	PharmaCode_GT?: InputMaybe<Scalars["Int"]>;
	PharmaCode_GTE?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LT?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LTE?: InputMaybe<Scalars["Int"]>;
	PharmaCode_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	PharmaCode_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	PharmaCode_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	PharmaCode_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	PharmaCode_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	PrevPharmacode_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	PrevPharmacode_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	PrevPharmacode_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	PrevPharmacode_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	PrevPharmacode_EQUAL?: InputMaybe<Scalars["String"]>;
	PrevPharmacode_GT?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_GTE?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LT?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LTE?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	REF_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	REF_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	REF_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	REF_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	REF_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	REF_EQUAL?: InputMaybe<Scalars["String"]>;
	REF_GT?: InputMaybe<Scalars["Int"]>;
	REF_GTE?: InputMaybe<Scalars["Int"]>;
	REF_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	REF_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	REF_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	REF_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	REF_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	REF_LT?: InputMaybe<Scalars["Int"]>;
	REF_LTE?: InputMaybe<Scalars["Int"]>;
	REF_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	REF_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	REF_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	REF_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	REF_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	SwissmedicCategory_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	SwissmedicCategory_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	SwissmedicCategory_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	SwissmedicCategory_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	SwissmedicCategory_EQUAL?: InputMaybe<Scalars["String"]>;
	SwissmedicCategory_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo8_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo8_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo8_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo8_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo8_EQUAL?: InputMaybe<Scalars["String"]>;
	SwissmedicNo8_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	UDI_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	UDI_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	UDI_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	UDI_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	UDI_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	UDI_EQUAL?: InputMaybe<Scalars["String"]>;
	UDI_GT?: InputMaybe<Scalars["Int"]>;
	UDI_GTE?: InputMaybe<Scalars["Int"]>;
	UDI_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	UDI_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	UDI_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	UDI_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	UDI_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	UDI_LT?: InputMaybe<Scalars["Int"]>;
	UDI_LTE?: InputMaybe<Scalars["Int"]>;
	UDI_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	UDI_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	UDI_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	UDI_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	UDI_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	classificationSystem_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	classificationSystem_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	classificationSystem_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	classificationSystem_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	classificationSystem_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	classificationSystem_EQUAL?: InputMaybe<Scalars["String"]>;
	classificationSystem_GT?: InputMaybe<Scalars["Int"]>;
	classificationSystem_GTE?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LT?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LTE?: InputMaybe<Scalars["Int"]>;
	classificationSystem_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	classificationSystem_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	classificationSystem_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	classificationSystem_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	classificationSystem_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type PriceTreatmentRelationship = {
	__typename?: "PriceTreatmentRelationship";
	cursor: Scalars["String"];
	node: Treatment;
};

export enum PriceType {
	CustomPricePercent = "CUSTOM_PRICE_PERCENT",
	ExFactoryPricePercent = "EX_FACTORY_PRICE_PERCENT",
	FixedFeePerCase = "FIXED_FEE_PER_CASE",
	FixedFeePerRecord = "FIXED_FEE_PER_RECORD",
	PublicPricePercent = "PUBLIC_PRICE_PERCENT",
	RecordDiscountPercent = "RECORD_DISCOUNT_PERCENT",
	RecordPricePercent = "RECORD_PRICE_PERCENT",
}

export type PriceWhere = {
	AND?: InputMaybe<Array<PriceWhere>>;
	OR?: InputMaybe<Array<PriceWhere>>;
	Price?: InputMaybe<Scalars["String"]>;
	PriceChangeTypeCode?: InputMaybe<Scalars["String"]>;
	PriceChangeTypeCode_CONTAINS?: InputMaybe<Scalars["String"]>;
	PriceChangeTypeCode_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	PriceChangeTypeCode_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	PriceChangeTypeCode_MATCHES?: InputMaybe<Scalars["String"]>;
	PriceChangeTypeCode_NOT?: InputMaybe<Scalars["String"]>;
	PriceChangeTypeCode_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	PriceChangeTypeCode_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	PriceChangeTypeCode_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	PriceChangeTypeCode_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	PriceChangeTypeCode_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	PriceChangeTypeDescriptionDe?: InputMaybe<Scalars["String"]>;
	PriceChangeTypeDescriptionDe_CONTAINS?: InputMaybe<Scalars["String"]>;
	PriceChangeTypeDescriptionDe_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	PriceChangeTypeDescriptionDe_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	PriceChangeTypeDescriptionDe_MATCHES?: InputMaybe<Scalars["String"]>;
	PriceChangeTypeDescriptionDe_NOT?: InputMaybe<Scalars["String"]>;
	PriceChangeTypeDescriptionDe_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	PriceChangeTypeDescriptionDe_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	PriceChangeTypeDescriptionDe_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	PriceChangeTypeDescriptionDe_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	PriceChangeTypeDescriptionDe_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	PriceTypeCode?: InputMaybe<Scalars["String"]>;
	PriceTypeCode_CONTAINS?: InputMaybe<Scalars["String"]>;
	PriceTypeCode_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	PriceTypeCode_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	PriceTypeCode_MATCHES?: InputMaybe<Scalars["String"]>;
	PriceTypeCode_NOT?: InputMaybe<Scalars["String"]>;
	PriceTypeCode_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	PriceTypeCode_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	PriceTypeCode_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	PriceTypeCode_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	PriceTypeCode_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	PriceTypeDescriptionDe?: InputMaybe<Scalars["String"]>;
	PriceTypeDescriptionDe_CONTAINS?: InputMaybe<Scalars["String"]>;
	PriceTypeDescriptionDe_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	PriceTypeDescriptionDe_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	PriceTypeDescriptionDe_MATCHES?: InputMaybe<Scalars["String"]>;
	PriceTypeDescriptionDe_NOT?: InputMaybe<Scalars["String"]>;
	PriceTypeDescriptionDe_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	PriceTypeDescriptionDe_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	PriceTypeDescriptionDe_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	PriceTypeDescriptionDe_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	PriceTypeDescriptionDe_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	Price_CONTAINS?: InputMaybe<Scalars["String"]>;
	Price_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	Price_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	Price_MATCHES?: InputMaybe<Scalars["String"]>;
	Price_NOT?: InputMaybe<Scalars["String"]>;
	Price_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	Price_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	Price_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	Price_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	Price_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	ValidFromDate?: InputMaybe<Scalars["Date"]>;
	ValidFromDate_GT?: InputMaybe<Scalars["Date"]>;
	ValidFromDate_GTE?: InputMaybe<Scalars["Date"]>;
	ValidFromDate_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
	ValidFromDate_LT?: InputMaybe<Scalars["Date"]>;
	ValidFromDate_LTE?: InputMaybe<Scalars["Date"]>;
	ValidFromDate_NOT?: InputMaybe<Scalars["Date"]>;
	ValidFromDate_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
	treatment?: InputMaybe<TreatmentWhere>;
	treatmentAggregate?: InputMaybe<PriceTreatmentAggregateInput>;
	treatmentConnection?: InputMaybe<PriceTreatmentConnectionWhere>;
	treatmentConnection_NOT?: InputMaybe<PriceTreatmentConnectionWhere>;
	treatment_NOT?: InputMaybe<TreatmentWhere>;
};

export type ProcessedDeviceRecord = {
	__typename?: "ProcessedDeviceRecord";
	agreement: BaseAgreement;
	agreementConnection: ProcessedDeviceRecordAgreementConnection;
	deviceRecord?: Maybe<DeviceRecord>;
	deviceRecordConnection: ProcessedDeviceRecordDeviceRecordConnection;
	financialDataPoints: Array<DeviceFinancialDataPoint>;
	financialDataPointsConnection: ProcessedDeviceRecordFinancialDataPointsConnection;
	lastProcessingDate: Scalars["Date"];
};

export type ProcessedDeviceRecordAgreementArgs = {
	options?: InputMaybe<BaseAgreementOptions>;
	where?: InputMaybe<BaseAgreementWhere>;
};

export type ProcessedDeviceRecordAgreementConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<ProcessedDeviceRecordAgreementConnectionSort>>;
	where?: InputMaybe<ProcessedDeviceRecordAgreementConnectionWhere>;
};

export type ProcessedDeviceRecordDeviceRecordArgs = {
	options?: InputMaybe<DeviceRecordOptions>;
	where?: InputMaybe<DeviceRecordWhere>;
};

export type ProcessedDeviceRecordDeviceRecordConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<ProcessedDeviceRecordDeviceRecordConnectionSort>>;
	where?: InputMaybe<ProcessedDeviceRecordDeviceRecordConnectionWhere>;
};

export type ProcessedDeviceRecordFinancialDataPointsArgs = {
	options?: InputMaybe<DeviceFinancialDataPointOptions>;
	where?: InputMaybe<DeviceFinancialDataPointWhere>;
};

export type ProcessedDeviceRecordFinancialDataPointsConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<ProcessedDeviceRecordFinancialDataPointsConnectionSort>>;
	where?: InputMaybe<ProcessedDeviceRecordFinancialDataPointsConnectionWhere>;
};

export type ProcessedDeviceRecordAggregateSelection = {
	__typename?: "ProcessedDeviceRecordAggregateSelection";
	count: Scalars["Int"];
};

export type ProcessedDeviceRecordAgreementAggregateInput = {
	AND?: InputMaybe<Array<ProcessedDeviceRecordAgreementAggregateInput>>;
	OR?: InputMaybe<Array<ProcessedDeviceRecordAgreementAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<ProcessedDeviceRecordAgreementNodeAggregationWhereInput>;
};

export type ProcessedDeviceRecordAgreementConnectFieldInput = {
	connect?: InputMaybe<BaseAgreementConnectInput>;
	where?: InputMaybe<BaseAgreementConnectWhere>;
};

export type ProcessedDeviceRecordAgreementConnection = {
	__typename?: "ProcessedDeviceRecordAgreementConnection";
	edges: Array<ProcessedDeviceRecordAgreementRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type ProcessedDeviceRecordAgreementConnectionSort = {
	node?: InputMaybe<BaseAgreementSort>;
};

export type ProcessedDeviceRecordAgreementConnectionWhere = {
	AND?: InputMaybe<Array<ProcessedDeviceRecordAgreementConnectionWhere>>;
	OR?: InputMaybe<Array<ProcessedDeviceRecordAgreementConnectionWhere>>;
	node?: InputMaybe<BaseAgreementWhere>;
	node_NOT?: InputMaybe<BaseAgreementWhere>;
};

export type ProcessedDeviceRecordAgreementCreateFieldInput = {
	node: BaseAgreementCreateInput;
};

export type ProcessedDeviceRecordAgreementDeleteFieldInput = {
	delete?: InputMaybe<BaseAgreementDeleteInput>;
	where?: InputMaybe<ProcessedDeviceRecordAgreementConnectionWhere>;
};

export type ProcessedDeviceRecordAgreementDisconnectFieldInput = {
	disconnect?: InputMaybe<BaseAgreementDisconnectInput>;
	where?: InputMaybe<ProcessedDeviceRecordAgreementConnectionWhere>;
};

export type ProcessedDeviceRecordAgreementFieldInput = {
	connect?: InputMaybe<ProcessedDeviceRecordAgreementConnectFieldInput>;
	create?: InputMaybe<ProcessedDeviceRecordAgreementCreateFieldInput>;
};

export type ProcessedDeviceRecordAgreementNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<ProcessedDeviceRecordAgreementNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<ProcessedDeviceRecordAgreementNodeAggregationWhereInput>>;
	coveringFormWaitInterval_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	coveringFormWaitInterval_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	coveringFormWaitInterval_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	coveringFormWaitInterval_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	coveringFormWaitInterval_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	coveringFormWaitInterval_EQUAL?: InputMaybe<Scalars["Int"]>;
	coveringFormWaitInterval_GT?: InputMaybe<Scalars["Int"]>;
	coveringFormWaitInterval_GTE?: InputMaybe<Scalars["Int"]>;
	coveringFormWaitInterval_LT?: InputMaybe<Scalars["Int"]>;
	coveringFormWaitInterval_LTE?: InputMaybe<Scalars["Int"]>;
	coveringFormWaitInterval_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	coveringFormWaitInterval_MAX_GT?: InputMaybe<Scalars["Int"]>;
	coveringFormWaitInterval_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	coveringFormWaitInterval_MAX_LT?: InputMaybe<Scalars["Int"]>;
	coveringFormWaitInterval_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	coveringFormWaitInterval_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	coveringFormWaitInterval_MIN_GT?: InputMaybe<Scalars["Int"]>;
	coveringFormWaitInterval_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	coveringFormWaitInterval_MIN_LT?: InputMaybe<Scalars["Int"]>;
	coveringFormWaitInterval_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	createdOn_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_GT?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_GTE?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_LT?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_LTE?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	formattedAmount_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	formattedAmount_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	formattedAmount_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	formattedAmount_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	formattedAmount_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	formattedAmount_EQUAL?: InputMaybe<Scalars["String"]>;
	formattedAmount_GT?: InputMaybe<Scalars["Int"]>;
	formattedAmount_GTE?: InputMaybe<Scalars["Int"]>;
	formattedAmount_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedAmount_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedAmount_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedAmount_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedAmount_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	formattedAmount_LT?: InputMaybe<Scalars["Int"]>;
	formattedAmount_LTE?: InputMaybe<Scalars["Int"]>;
	formattedAmount_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedAmount_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedAmount_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedAmount_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedAmount_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	formattedCounterparties_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	formattedCounterparties_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	formattedCounterparties_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	formattedCounterparties_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	formattedCounterparties_EQUAL?: InputMaybe<Scalars["String"]>;
	formattedCounterparties_GT?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_GTE?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_LT?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_LTE?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	formattedProducts_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	formattedProducts_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	formattedProducts_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	formattedProducts_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	formattedProducts_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	formattedProducts_EQUAL?: InputMaybe<Scalars["String"]>;
	formattedProducts_GT?: InputMaybe<Scalars["Int"]>;
	formattedProducts_GTE?: InputMaybe<Scalars["Int"]>;
	formattedProducts_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedProducts_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedProducts_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedProducts_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedProducts_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	formattedProducts_LT?: InputMaybe<Scalars["Int"]>;
	formattedProducts_LTE?: InputMaybe<Scalars["Int"]>;
	formattedProducts_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedProducts_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedProducts_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedProducts_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedProducts_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	formattedTags_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	formattedTags_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	formattedTags_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	formattedTags_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	formattedTags_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	formattedTags_EQUAL?: InputMaybe<Scalars["String"]>;
	formattedTags_GT?: InputMaybe<Scalars["Int"]>;
	formattedTags_GTE?: InputMaybe<Scalars["Int"]>;
	formattedTags_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedTags_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedTags_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedTags_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedTags_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	formattedTags_LT?: InputMaybe<Scalars["Int"]>;
	formattedTags_LTE?: InputMaybe<Scalars["Int"]>;
	formattedTags_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedTags_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedTags_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedTags_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedTags_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	formattedValidityPeriod_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	formattedValidityPeriod_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	formattedValidityPeriod_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	formattedValidityPeriod_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	formattedValidityPeriod_EQUAL?: InputMaybe<Scalars["String"]>;
	formattedValidityPeriod_GT?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_GTE?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_LT?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_LTE?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	initialVersionId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	initialVersionId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	initialVersionId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	initialVersionId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	initialVersionId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	initialVersionId_EQUAL?: InputMaybe<Scalars["String"]>;
	initialVersionId_GT?: InputMaybe<Scalars["Int"]>;
	initialVersionId_GTE?: InputMaybe<Scalars["Int"]>;
	initialVersionId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	initialVersionId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	initialVersionId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	initialVersionId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	initialVersionId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	initialVersionId_LT?: InputMaybe<Scalars["Int"]>;
	initialVersionId_LTE?: InputMaybe<Scalars["Int"]>;
	initialVersionId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	initialVersionId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	initialVersionId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	initialVersionId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	initialVersionId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	lastExecutionDate_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_GT?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_LT?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_LTE?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	name_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	name_EQUAL?: InputMaybe<Scalars["String"]>;
	name_GT?: InputMaybe<Scalars["Int"]>;
	name_GTE?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	name_LT?: InputMaybe<Scalars["Int"]>;
	name_LTE?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	pushedOn_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	pushedOn_GT?: InputMaybe<Scalars["DateTime"]>;
	pushedOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	pushedOn_LT?: InputMaybe<Scalars["DateTime"]>;
	pushedOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	pushedOn_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	pushedOn_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	pushedOn_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	pushedOn_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	pushedOn_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	pushedOn_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	pushedOn_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	pushedOn_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	pushedOn_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	pushedOn_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	version_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	version_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	version_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	version_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	version_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	version_EQUAL?: InputMaybe<Scalars["Int"]>;
	version_GT?: InputMaybe<Scalars["Int"]>;
	version_GTE?: InputMaybe<Scalars["Int"]>;
	version_LT?: InputMaybe<Scalars["Int"]>;
	version_LTE?: InputMaybe<Scalars["Int"]>;
	version_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	version_MAX_GT?: InputMaybe<Scalars["Int"]>;
	version_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	version_MAX_LT?: InputMaybe<Scalars["Int"]>;
	version_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	version_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	version_MIN_GT?: InputMaybe<Scalars["Int"]>;
	version_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	version_MIN_LT?: InputMaybe<Scalars["Int"]>;
	version_MIN_LTE?: InputMaybe<Scalars["Int"]>;
};

export type ProcessedDeviceRecordAgreementRelationship = {
	__typename?: "ProcessedDeviceRecordAgreementRelationship";
	cursor: Scalars["String"];
	node: BaseAgreement;
};

export type ProcessedDeviceRecordAgreementUpdateConnectionInput = {
	node?: InputMaybe<BaseAgreementUpdateInput>;
};

export type ProcessedDeviceRecordAgreementUpdateFieldInput = {
	connect?: InputMaybe<ProcessedDeviceRecordAgreementConnectFieldInput>;
	create?: InputMaybe<ProcessedDeviceRecordAgreementCreateFieldInput>;
	delete?: InputMaybe<ProcessedDeviceRecordAgreementDeleteFieldInput>;
	disconnect?: InputMaybe<ProcessedDeviceRecordAgreementDisconnectFieldInput>;
	update?: InputMaybe<ProcessedDeviceRecordAgreementUpdateConnectionInput>;
	where?: InputMaybe<ProcessedDeviceRecordAgreementConnectionWhere>;
};

export type ProcessedDeviceRecordConnectInput = {
	agreement?: InputMaybe<ProcessedDeviceRecordAgreementConnectFieldInput>;
	deviceRecord?: InputMaybe<ProcessedDeviceRecordDeviceRecordConnectFieldInput>;
	financialDataPoints?: InputMaybe<Array<ProcessedDeviceRecordFinancialDataPointsConnectFieldInput>>;
};

export type ProcessedDeviceRecordConnectWhere = {
	node: ProcessedDeviceRecordWhere;
};

export type ProcessedDeviceRecordCreateInput = {
	agreement?: InputMaybe<ProcessedDeviceRecordAgreementFieldInput>;
	deviceRecord?: InputMaybe<ProcessedDeviceRecordDeviceRecordFieldInput>;
	financialDataPoints?: InputMaybe<ProcessedDeviceRecordFinancialDataPointsFieldInput>;
	lastProcessingDate: Scalars["Date"];
};

export type ProcessedDeviceRecordDeleteInput = {
	agreement?: InputMaybe<ProcessedDeviceRecordAgreementDeleteFieldInput>;
	deviceRecord?: InputMaybe<ProcessedDeviceRecordDeviceRecordDeleteFieldInput>;
	financialDataPoints?: InputMaybe<Array<ProcessedDeviceRecordFinancialDataPointsDeleteFieldInput>>;
};

export type ProcessedDeviceRecordDeviceRecordAggregateInput = {
	AND?: InputMaybe<Array<ProcessedDeviceRecordDeviceRecordAggregateInput>>;
	OR?: InputMaybe<Array<ProcessedDeviceRecordDeviceRecordAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<ProcessedDeviceRecordDeviceRecordNodeAggregationWhereInput>;
};

export type ProcessedDeviceRecordDeviceRecordConnectFieldInput = {
	connect?: InputMaybe<DeviceRecordConnectInput>;
	where?: InputMaybe<DeviceRecordConnectWhere>;
};

export type ProcessedDeviceRecordDeviceRecordConnection = {
	__typename?: "ProcessedDeviceRecordDeviceRecordConnection";
	edges: Array<ProcessedDeviceRecordDeviceRecordRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type ProcessedDeviceRecordDeviceRecordConnectionSort = {
	node?: InputMaybe<DeviceRecordSort>;
};

export type ProcessedDeviceRecordDeviceRecordConnectionWhere = {
	AND?: InputMaybe<Array<ProcessedDeviceRecordDeviceRecordConnectionWhere>>;
	OR?: InputMaybe<Array<ProcessedDeviceRecordDeviceRecordConnectionWhere>>;
	node?: InputMaybe<DeviceRecordWhere>;
	node_NOT?: InputMaybe<DeviceRecordWhere>;
};

export type ProcessedDeviceRecordDeviceRecordCreateFieldInput = {
	node: DeviceRecordCreateInput;
};

export type ProcessedDeviceRecordDeviceRecordDeleteFieldInput = {
	delete?: InputMaybe<DeviceRecordDeleteInput>;
	where?: InputMaybe<ProcessedDeviceRecordDeviceRecordConnectionWhere>;
};

export type ProcessedDeviceRecordDeviceRecordDisconnectFieldInput = {
	disconnect?: InputMaybe<DeviceRecordDisconnectInput>;
	where?: InputMaybe<ProcessedDeviceRecordDeviceRecordConnectionWhere>;
};

export type ProcessedDeviceRecordDeviceRecordFieldInput = {
	connect?: InputMaybe<ProcessedDeviceRecordDeviceRecordConnectFieldInput>;
	create?: InputMaybe<ProcessedDeviceRecordDeviceRecordCreateFieldInput>;
};

export type ProcessedDeviceRecordDeviceRecordNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<ProcessedDeviceRecordDeviceRecordNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<ProcessedDeviceRecordDeviceRecordNodeAggregationWhereInput>>;
	deviceId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	deviceId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	deviceId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	deviceId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	deviceId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	deviceId_EQUAL?: InputMaybe<Scalars["String"]>;
	deviceId_GT?: InputMaybe<Scalars["Int"]>;
	deviceId_GTE?: InputMaybe<Scalars["Int"]>;
	deviceId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	deviceId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	deviceId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	deviceId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	deviceId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	deviceId_LT?: InputMaybe<Scalars["Int"]>;
	deviceId_LTE?: InputMaybe<Scalars["Int"]>;
	deviceId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	deviceId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	deviceId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	deviceId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	deviceId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	deviceRef_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	deviceRef_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	deviceRef_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	deviceRef_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	deviceRef_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	deviceRef_EQUAL?: InputMaybe<Scalars["String"]>;
	deviceRef_GT?: InputMaybe<Scalars["Int"]>;
	deviceRef_GTE?: InputMaybe<Scalars["Int"]>;
	deviceRef_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	deviceRef_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	deviceRef_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	deviceRef_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	deviceRef_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	deviceRef_LT?: InputMaybe<Scalars["Int"]>;
	deviceRef_LTE?: InputMaybe<Scalars["Int"]>;
	deviceRef_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	deviceRef_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	deviceRef_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	deviceRef_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	deviceRef_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	invoicedSales_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	invoicedSales_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	invoicedSales_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	invoicedSales_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	invoicedSales_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	invoicedSales_EQUAL?: InputMaybe<Scalars["Float"]>;
	invoicedSales_GT?: InputMaybe<Scalars["Float"]>;
	invoicedSales_GTE?: InputMaybe<Scalars["Float"]>;
	invoicedSales_LT?: InputMaybe<Scalars["Float"]>;
	invoicedSales_LTE?: InputMaybe<Scalars["Float"]>;
	invoicedSales_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	invoicedSales_MAX_GT?: InputMaybe<Scalars["Float"]>;
	invoicedSales_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	invoicedSales_MAX_LT?: InputMaybe<Scalars["Float"]>;
	invoicedSales_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	invoicedSales_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	invoicedSales_MIN_GT?: InputMaybe<Scalars["Float"]>;
	invoicedSales_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	invoicedSales_MIN_LT?: InputMaybe<Scalars["Float"]>;
	invoicedSales_MIN_LTE?: InputMaybe<Scalars["Float"]>;
	orderLineNumber_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	orderLineNumber_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	orderLineNumber_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	orderLineNumber_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	orderLineNumber_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	orderLineNumber_EQUAL?: InputMaybe<Scalars["Int"]>;
	orderLineNumber_GT?: InputMaybe<Scalars["Int"]>;
	orderLineNumber_GTE?: InputMaybe<Scalars["Int"]>;
	orderLineNumber_LT?: InputMaybe<Scalars["Int"]>;
	orderLineNumber_LTE?: InputMaybe<Scalars["Int"]>;
	orderLineNumber_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	orderLineNumber_MAX_GT?: InputMaybe<Scalars["Int"]>;
	orderLineNumber_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	orderLineNumber_MAX_LT?: InputMaybe<Scalars["Int"]>;
	orderLineNumber_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	orderLineNumber_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	orderLineNumber_MIN_GT?: InputMaybe<Scalars["Int"]>;
	orderLineNumber_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	orderLineNumber_MIN_LT?: InputMaybe<Scalars["Int"]>;
	orderLineNumber_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	orderNumber_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	orderNumber_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	orderNumber_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	orderNumber_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	orderNumber_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	orderNumber_EQUAL?: InputMaybe<Scalars["Int"]>;
	orderNumber_GT?: InputMaybe<Scalars["Int"]>;
	orderNumber_GTE?: InputMaybe<Scalars["Int"]>;
	orderNumber_LT?: InputMaybe<Scalars["Int"]>;
	orderNumber_LTE?: InputMaybe<Scalars["Int"]>;
	orderNumber_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	orderNumber_MAX_GT?: InputMaybe<Scalars["Int"]>;
	orderNumber_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	orderNumber_MAX_LT?: InputMaybe<Scalars["Int"]>;
	orderNumber_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	orderNumber_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	orderNumber_MIN_GT?: InputMaybe<Scalars["Int"]>;
	orderNumber_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	orderNumber_MIN_LT?: InputMaybe<Scalars["Int"]>;
	orderNumber_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	price_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	price_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	price_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	price_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	price_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	price_EQUAL?: InputMaybe<Scalars["Float"]>;
	price_GT?: InputMaybe<Scalars["Float"]>;
	price_GTE?: InputMaybe<Scalars["Float"]>;
	price_LT?: InputMaybe<Scalars["Float"]>;
	price_LTE?: InputMaybe<Scalars["Float"]>;
	price_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	price_MAX_GT?: InputMaybe<Scalars["Float"]>;
	price_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	price_MAX_LT?: InputMaybe<Scalars["Float"]>;
	price_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	price_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	price_MIN_GT?: InputMaybe<Scalars["Float"]>;
	price_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	price_MIN_LT?: InputMaybe<Scalars["Float"]>;
	price_MIN_LTE?: InputMaybe<Scalars["Float"]>;
	productName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	productName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	productName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	productName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	productName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	productName_EQUAL?: InputMaybe<Scalars["String"]>;
	productName_GT?: InputMaybe<Scalars["Int"]>;
	productName_GTE?: InputMaybe<Scalars["Int"]>;
	productName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	productName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	productName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	productName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	productName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	productName_LT?: InputMaybe<Scalars["Int"]>;
	productName_LTE?: InputMaybe<Scalars["Int"]>;
	productName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	productName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	productName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	productName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	productName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	quantity_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	quantity_EQUAL?: InputMaybe<Scalars["Int"]>;
	quantity_GT?: InputMaybe<Scalars["Int"]>;
	quantity_GTE?: InputMaybe<Scalars["Int"]>;
	quantity_LT?: InputMaybe<Scalars["Int"]>;
	quantity_LTE?: InputMaybe<Scalars["Int"]>;
	quantity_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	quantity_MAX_GT?: InputMaybe<Scalars["Int"]>;
	quantity_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	quantity_MAX_LT?: InputMaybe<Scalars["Int"]>;
	quantity_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	quantity_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	quantity_MIN_GT?: InputMaybe<Scalars["Int"]>;
	quantity_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	quantity_MIN_LT?: InputMaybe<Scalars["Int"]>;
	quantity_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	refundPercentage_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	refundPercentage_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	refundPercentage_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	refundPercentage_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	refundPercentage_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	refundPercentage_EQUAL?: InputMaybe<Scalars["Float"]>;
	refundPercentage_GT?: InputMaybe<Scalars["Float"]>;
	refundPercentage_GTE?: InputMaybe<Scalars["Float"]>;
	refundPercentage_LT?: InputMaybe<Scalars["Float"]>;
	refundPercentage_LTE?: InputMaybe<Scalars["Float"]>;
	refundPercentage_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	refundPercentage_MAX_GT?: InputMaybe<Scalars["Float"]>;
	refundPercentage_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	refundPercentage_MAX_LT?: InputMaybe<Scalars["Float"]>;
	refundPercentage_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	refundPercentage_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	refundPercentage_MIN_GT?: InputMaybe<Scalars["Float"]>;
	refundPercentage_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	refundPercentage_MIN_LT?: InputMaybe<Scalars["Float"]>;
	refundPercentage_MIN_LTE?: InputMaybe<Scalars["Float"]>;
	saleDate_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	saleDate_GT?: InputMaybe<Scalars["DateTime"]>;
	saleDate_GTE?: InputMaybe<Scalars["DateTime"]>;
	saleDate_LT?: InputMaybe<Scalars["DateTime"]>;
	saleDate_LTE?: InputMaybe<Scalars["DateTime"]>;
	saleDate_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	saleDate_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	saleDate_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	saleDate_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	saleDate_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	saleDate_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	saleDate_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	saleDate_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	saleDate_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	saleDate_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	tenantId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	tenantId_EQUAL?: InputMaybe<Scalars["String"]>;
	tenantId_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type ProcessedDeviceRecordDeviceRecordRelationship = {
	__typename?: "ProcessedDeviceRecordDeviceRecordRelationship";
	cursor: Scalars["String"];
	node: DeviceRecord;
};

export type ProcessedDeviceRecordDeviceRecordUpdateConnectionInput = {
	node?: InputMaybe<DeviceRecordUpdateInput>;
};

export type ProcessedDeviceRecordDeviceRecordUpdateFieldInput = {
	connect?: InputMaybe<ProcessedDeviceRecordDeviceRecordConnectFieldInput>;
	create?: InputMaybe<ProcessedDeviceRecordDeviceRecordCreateFieldInput>;
	delete?: InputMaybe<ProcessedDeviceRecordDeviceRecordDeleteFieldInput>;
	disconnect?: InputMaybe<ProcessedDeviceRecordDeviceRecordDisconnectFieldInput>;
	update?: InputMaybe<ProcessedDeviceRecordDeviceRecordUpdateConnectionInput>;
	where?: InputMaybe<ProcessedDeviceRecordDeviceRecordConnectionWhere>;
};

export type ProcessedDeviceRecordDisconnectInput = {
	agreement?: InputMaybe<ProcessedDeviceRecordAgreementDisconnectFieldInput>;
	deviceRecord?: InputMaybe<ProcessedDeviceRecordDeviceRecordDisconnectFieldInput>;
	financialDataPoints?: InputMaybe<Array<ProcessedDeviceRecordFinancialDataPointsDisconnectFieldInput>>;
};

export type ProcessedDeviceRecordFinancialDataPointsAggregateInput = {
	AND?: InputMaybe<Array<ProcessedDeviceRecordFinancialDataPointsAggregateInput>>;
	OR?: InputMaybe<Array<ProcessedDeviceRecordFinancialDataPointsAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<ProcessedDeviceRecordFinancialDataPointsNodeAggregationWhereInput>;
};

export type ProcessedDeviceRecordFinancialDataPointsConnectFieldInput = {
	connect?: InputMaybe<Array<DeviceFinancialDataPointConnectInput>>;
	where?: InputMaybe<DeviceFinancialDataPointConnectWhere>;
};

export type ProcessedDeviceRecordFinancialDataPointsConnection = {
	__typename?: "ProcessedDeviceRecordFinancialDataPointsConnection";
	edges: Array<ProcessedDeviceRecordFinancialDataPointsRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type ProcessedDeviceRecordFinancialDataPointsConnectionSort = {
	node?: InputMaybe<DeviceFinancialDataPointSort>;
};

export type ProcessedDeviceRecordFinancialDataPointsConnectionWhere = {
	AND?: InputMaybe<Array<ProcessedDeviceRecordFinancialDataPointsConnectionWhere>>;
	OR?: InputMaybe<Array<ProcessedDeviceRecordFinancialDataPointsConnectionWhere>>;
	node?: InputMaybe<DeviceFinancialDataPointWhere>;
	node_NOT?: InputMaybe<DeviceFinancialDataPointWhere>;
};

export type ProcessedDeviceRecordFinancialDataPointsCreateFieldInput = {
	node: DeviceFinancialDataPointCreateInput;
};

export type ProcessedDeviceRecordFinancialDataPointsDeleteFieldInput = {
	delete?: InputMaybe<DeviceFinancialDataPointDeleteInput>;
	where?: InputMaybe<ProcessedDeviceRecordFinancialDataPointsConnectionWhere>;
};

export type ProcessedDeviceRecordFinancialDataPointsDisconnectFieldInput = {
	disconnect?: InputMaybe<DeviceFinancialDataPointDisconnectInput>;
	where?: InputMaybe<ProcessedDeviceRecordFinancialDataPointsConnectionWhere>;
};

export type ProcessedDeviceRecordFinancialDataPointsFieldInput = {
	connect?: InputMaybe<Array<ProcessedDeviceRecordFinancialDataPointsConnectFieldInput>>;
	create?: InputMaybe<Array<ProcessedDeviceRecordFinancialDataPointsCreateFieldInput>>;
};

export type ProcessedDeviceRecordFinancialDataPointsNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<ProcessedDeviceRecordFinancialDataPointsNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<ProcessedDeviceRecordFinancialDataPointsNodeAggregationWhereInput>>;
	basePrice_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	basePrice_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	basePrice_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	basePrice_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	basePrice_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	basePrice_EQUAL?: InputMaybe<Scalars["Float"]>;
	basePrice_GT?: InputMaybe<Scalars["Float"]>;
	basePrice_GTE?: InputMaybe<Scalars["Float"]>;
	basePrice_LT?: InputMaybe<Scalars["Float"]>;
	basePrice_LTE?: InputMaybe<Scalars["Float"]>;
	basePrice_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	basePrice_MAX_GT?: InputMaybe<Scalars["Float"]>;
	basePrice_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	basePrice_MAX_LT?: InputMaybe<Scalars["Float"]>;
	basePrice_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	basePrice_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	basePrice_MIN_GT?: InputMaybe<Scalars["Float"]>;
	basePrice_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	basePrice_MIN_LT?: InputMaybe<Scalars["Float"]>;
	basePrice_MIN_LTE?: InputMaybe<Scalars["Float"]>;
	evaluationSnapshot_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	evaluationSnapshot_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	evaluationSnapshot_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	evaluationSnapshot_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	evaluationSnapshot_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	evaluationSnapshot_EQUAL?: InputMaybe<Scalars["String"]>;
	evaluationSnapshot_GT?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_GTE?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_LT?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_LTE?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	payablePercentage_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	payablePercentage_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	payablePercentage_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	payablePercentage_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	payablePercentage_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	payablePercentage_EQUAL?: InputMaybe<Scalars["Float"]>;
	payablePercentage_GT?: InputMaybe<Scalars["Float"]>;
	payablePercentage_GTE?: InputMaybe<Scalars["Float"]>;
	payablePercentage_LT?: InputMaybe<Scalars["Float"]>;
	payablePercentage_LTE?: InputMaybe<Scalars["Float"]>;
	payablePercentage_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	payablePercentage_MAX_GT?: InputMaybe<Scalars["Float"]>;
	payablePercentage_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	payablePercentage_MAX_LT?: InputMaybe<Scalars["Float"]>;
	payablePercentage_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	payablePercentage_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	payablePercentage_MIN_GT?: InputMaybe<Scalars["Float"]>;
	payablePercentage_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	payablePercentage_MIN_LT?: InputMaybe<Scalars["Float"]>;
	payablePercentage_MIN_LTE?: InputMaybe<Scalars["Float"]>;
	payable_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	payable_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	payable_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	payable_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	payable_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	payable_EQUAL?: InputMaybe<Scalars["Float"]>;
	payable_GT?: InputMaybe<Scalars["Float"]>;
	payable_GTE?: InputMaybe<Scalars["Float"]>;
	payable_LT?: InputMaybe<Scalars["Float"]>;
	payable_LTE?: InputMaybe<Scalars["Float"]>;
	payable_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	payable_MAX_GT?: InputMaybe<Scalars["Float"]>;
	payable_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	payable_MAX_LT?: InputMaybe<Scalars["Float"]>;
	payable_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	payable_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	payable_MIN_GT?: InputMaybe<Scalars["Float"]>;
	payable_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	payable_MIN_LT?: InputMaybe<Scalars["Float"]>;
	payable_MIN_LTE?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	quantity_EQUAL?: InputMaybe<Scalars["Int"]>;
	quantity_GT?: InputMaybe<Scalars["Int"]>;
	quantity_GTE?: InputMaybe<Scalars["Int"]>;
	quantity_LT?: InputMaybe<Scalars["Int"]>;
	quantity_LTE?: InputMaybe<Scalars["Int"]>;
	quantity_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	quantity_MAX_GT?: InputMaybe<Scalars["Int"]>;
	quantity_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	quantity_MAX_LT?: InputMaybe<Scalars["Int"]>;
	quantity_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	quantity_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	quantity_MIN_GT?: InputMaybe<Scalars["Int"]>;
	quantity_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	quantity_MIN_LT?: InputMaybe<Scalars["Int"]>;
	quantity_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	refundablePercentage_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_EQUAL?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_GT?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_GTE?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_LT?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_LTE?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_MAX_GT?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_MAX_LT?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_MIN_GT?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_MIN_LT?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_MIN_LTE?: InputMaybe<Scalars["Float"]>;
	refundable_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	refundable_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	refundable_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	refundable_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	refundable_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	refundable_EQUAL?: InputMaybe<Scalars["Float"]>;
	refundable_GT?: InputMaybe<Scalars["Float"]>;
	refundable_GTE?: InputMaybe<Scalars["Float"]>;
	refundable_LT?: InputMaybe<Scalars["Float"]>;
	refundable_LTE?: InputMaybe<Scalars["Float"]>;
	refundable_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	refundable_MAX_GT?: InputMaybe<Scalars["Float"]>;
	refundable_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	refundable_MAX_LT?: InputMaybe<Scalars["Float"]>;
	refundable_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	refundable_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	refundable_MIN_GT?: InputMaybe<Scalars["Float"]>;
	refundable_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	refundable_MIN_LT?: InputMaybe<Scalars["Float"]>;
	refundable_MIN_LTE?: InputMaybe<Scalars["Float"]>;
	variablePercentage_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	variablePercentage_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	variablePercentage_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	variablePercentage_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	variablePercentage_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	variablePercentage_EQUAL?: InputMaybe<Scalars["Float"]>;
	variablePercentage_GT?: InputMaybe<Scalars["Float"]>;
	variablePercentage_GTE?: InputMaybe<Scalars["Float"]>;
	variablePercentage_LT?: InputMaybe<Scalars["Float"]>;
	variablePercentage_LTE?: InputMaybe<Scalars["Float"]>;
	variablePercentage_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	variablePercentage_MAX_GT?: InputMaybe<Scalars["Float"]>;
	variablePercentage_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	variablePercentage_MAX_LT?: InputMaybe<Scalars["Float"]>;
	variablePercentage_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	variablePercentage_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	variablePercentage_MIN_GT?: InputMaybe<Scalars["Float"]>;
	variablePercentage_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	variablePercentage_MIN_LT?: InputMaybe<Scalars["Float"]>;
	variablePercentage_MIN_LTE?: InputMaybe<Scalars["Float"]>;
	variable_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	variable_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	variable_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	variable_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	variable_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	variable_EQUAL?: InputMaybe<Scalars["Float"]>;
	variable_GT?: InputMaybe<Scalars["Float"]>;
	variable_GTE?: InputMaybe<Scalars["Float"]>;
	variable_LT?: InputMaybe<Scalars["Float"]>;
	variable_LTE?: InputMaybe<Scalars["Float"]>;
	variable_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	variable_MAX_GT?: InputMaybe<Scalars["Float"]>;
	variable_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	variable_MAX_LT?: InputMaybe<Scalars["Float"]>;
	variable_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	variable_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	variable_MIN_GT?: InputMaybe<Scalars["Float"]>;
	variable_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	variable_MIN_LT?: InputMaybe<Scalars["Float"]>;
	variable_MIN_LTE?: InputMaybe<Scalars["Float"]>;
};

export type ProcessedDeviceRecordFinancialDataPointsRelationship = {
	__typename?: "ProcessedDeviceRecordFinancialDataPointsRelationship";
	cursor: Scalars["String"];
	node: DeviceFinancialDataPoint;
};

export type ProcessedDeviceRecordFinancialDataPointsUpdateConnectionInput = {
	node?: InputMaybe<DeviceFinancialDataPointUpdateInput>;
};

export type ProcessedDeviceRecordFinancialDataPointsUpdateFieldInput = {
	connect?: InputMaybe<Array<ProcessedDeviceRecordFinancialDataPointsConnectFieldInput>>;
	create?: InputMaybe<Array<ProcessedDeviceRecordFinancialDataPointsCreateFieldInput>>;
	delete?: InputMaybe<Array<ProcessedDeviceRecordFinancialDataPointsDeleteFieldInput>>;
	disconnect?: InputMaybe<Array<ProcessedDeviceRecordFinancialDataPointsDisconnectFieldInput>>;
	update?: InputMaybe<ProcessedDeviceRecordFinancialDataPointsUpdateConnectionInput>;
	where?: InputMaybe<ProcessedDeviceRecordFinancialDataPointsConnectionWhere>;
};

export type ProcessedDeviceRecordOptions = {
	limit?: InputMaybe<Scalars["Int"]>;
	offset?: InputMaybe<Scalars["Int"]>;
	/** Specify one or more ProcessedDeviceRecordSort objects to sort ProcessedDeviceRecords by. The sorts will be applied in the order in which they are arranged in the array. */
	sort?: InputMaybe<Array<InputMaybe<ProcessedDeviceRecordSort>>>;
};

/** Fields to sort ProcessedDeviceRecords by. The order in which sorts are applied is not guaranteed when specifying many fields in one ProcessedDeviceRecordSort object. */
export type ProcessedDeviceRecordSort = {
	lastProcessingDate?: InputMaybe<SortDirection>;
};

export type ProcessedDeviceRecordUpdateInput = {
	agreement?: InputMaybe<ProcessedDeviceRecordAgreementUpdateFieldInput>;
	deviceRecord?: InputMaybe<ProcessedDeviceRecordDeviceRecordUpdateFieldInput>;
	financialDataPoints?: InputMaybe<Array<ProcessedDeviceRecordFinancialDataPointsUpdateFieldInput>>;
	lastProcessingDate?: InputMaybe<Scalars["Date"]>;
};

export type ProcessedDeviceRecordWhere = {
	AND?: InputMaybe<Array<ProcessedDeviceRecordWhere>>;
	OR?: InputMaybe<Array<ProcessedDeviceRecordWhere>>;
	agreement?: InputMaybe<BaseAgreementWhere>;
	agreementAggregate?: InputMaybe<ProcessedDeviceRecordAgreementAggregateInput>;
	agreementConnection?: InputMaybe<ProcessedDeviceRecordAgreementConnectionWhere>;
	agreementConnection_NOT?: InputMaybe<ProcessedDeviceRecordAgreementConnectionWhere>;
	agreement_NOT?: InputMaybe<BaseAgreementWhere>;
	deviceRecord?: InputMaybe<DeviceRecordWhere>;
	deviceRecordAggregate?: InputMaybe<ProcessedDeviceRecordDeviceRecordAggregateInput>;
	deviceRecordConnection?: InputMaybe<ProcessedDeviceRecordDeviceRecordConnectionWhere>;
	deviceRecordConnection_NOT?: InputMaybe<ProcessedDeviceRecordDeviceRecordConnectionWhere>;
	deviceRecord_NOT?: InputMaybe<DeviceRecordWhere>;
	financialDataPoints?: InputMaybe<DeviceFinancialDataPointWhere>;
	financialDataPointsAggregate?: InputMaybe<ProcessedDeviceRecordFinancialDataPointsAggregateInput>;
	financialDataPointsConnection?: InputMaybe<ProcessedDeviceRecordFinancialDataPointsConnectionWhere>;
	financialDataPointsConnection_NOT?: InputMaybe<ProcessedDeviceRecordFinancialDataPointsConnectionWhere>;
	financialDataPoints_NOT?: InputMaybe<DeviceFinancialDataPointWhere>;
	lastProcessingDate?: InputMaybe<Scalars["Date"]>;
	lastProcessingDate_GT?: InputMaybe<Scalars["Date"]>;
	lastProcessingDate_GTE?: InputMaybe<Scalars["Date"]>;
	lastProcessingDate_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
	lastProcessingDate_LT?: InputMaybe<Scalars["Date"]>;
	lastProcessingDate_LTE?: InputMaybe<Scalars["Date"]>;
	lastProcessingDate_NOT?: InputMaybe<Scalars["Date"]>;
	lastProcessingDate_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
};

export type PublicPrice = {
	__typename?: "PublicPrice";
	Price?: Maybe<Scalars["String"]>;
	ValidFromDate?: Maybe<Scalars["Date"]>;
};

export type PublicPriceAggregateSelection = {
	__typename?: "PublicPriceAggregateSelection";
	Price: StringAggregateSelection;
	count: Scalars["Int"];
};

export type PublicPriceConnectWhere = {
	node: PublicPriceWhere;
};

export type PublicPriceCreateInput = {
	Price?: InputMaybe<Scalars["String"]>;
	ValidFromDate?: InputMaybe<Scalars["Date"]>;
};

export type PublicPriceOptions = {
	limit?: InputMaybe<Scalars["Int"]>;
	offset?: InputMaybe<Scalars["Int"]>;
	/** Specify one or more PublicPriceSort objects to sort PublicPrices by. The sorts will be applied in the order in which they are arranged in the array. */
	sort?: InputMaybe<Array<InputMaybe<PublicPriceSort>>>;
};

/** Fields to sort PublicPrices by. The order in which sorts are applied is not guaranteed when specifying many fields in one PublicPriceSort object. */
export type PublicPriceSort = {
	Price?: InputMaybe<SortDirection>;
	ValidFromDate?: InputMaybe<SortDirection>;
};

export type PublicPriceUpdateInput = {
	Price?: InputMaybe<Scalars["String"]>;
	ValidFromDate?: InputMaybe<Scalars["Date"]>;
};

export type PublicPriceWhere = {
	AND?: InputMaybe<Array<PublicPriceWhere>>;
	OR?: InputMaybe<Array<PublicPriceWhere>>;
	Price?: InputMaybe<Scalars["String"]>;
	Price_CONTAINS?: InputMaybe<Scalars["String"]>;
	Price_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	Price_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	Price_MATCHES?: InputMaybe<Scalars["String"]>;
	Price_NOT?: InputMaybe<Scalars["String"]>;
	Price_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	Price_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	Price_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	Price_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	Price_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	ValidFromDate?: InputMaybe<Scalars["Date"]>;
	ValidFromDate_GT?: InputMaybe<Scalars["Date"]>;
	ValidFromDate_GTE?: InputMaybe<Scalars["Date"]>;
	ValidFromDate_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
	ValidFromDate_LT?: InputMaybe<Scalars["Date"]>;
	ValidFromDate_LTE?: InputMaybe<Scalars["Date"]>;
	ValidFromDate_NOT?: InputMaybe<Scalars["Date"]>;
	ValidFromDate_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
};

export type Query = {
	__typename?: "Query";
	CheckCB: Array<Organization>;
	CheckIR: Array<Organization>;
	CurrentOrganization: Organization;
	GetAgreementIdFromInvoiceId?: Maybe<Scalars["ID"]>;
	GetAgreementProcessedDeviceRecords?: Maybe<Array<Maybe<ProcessedDeviceRecord>>>;
	GetAgreementReportData: AgreementReport;
	GetAgreementsCount?: Maybe<Scalars["Int"]>;
	GetAgreementsForSelectedUser: Array<AgreementSpecificRole>;
	GetAllBaseAgreementVersions?: Maybe<Array<BaseAgreement>>;
	GetAllDataPointsByDate?: Maybe<Array<FinancialDataPoint>>;
	GetAllDataPointsByPrescriptionDate?: Maybe<Array<FinancialDataPoint>>;
	GetAllUsersFromOrganization: Array<UserOrganizationInfo>;
	GetAssignee?: Maybe<User>;
	GetAvailableCaseAssignees?: Maybe<Array<Maybe<User>>>;
	GetCAOBAgreementReportData: CaobAgreementReport;
	GetCBAdverseEventData?: Maybe<AdverseEventReport>;
	GetCaseCount?: Maybe<Scalars["Int"]>;
	GetClaims?: Maybe<Array<Maybe<Claim>>>;
	GetDefaultAgreementRoles: Array<AgreementTag>;
	GetDeviceRecords?: Maybe<Array<Maybe<DeviceRecord>>>;
	GetDocumentCount?: Maybe<Scalars["Int"]>;
	GetDuplicateClaims?: Maybe<Array<Maybe<Record>>>;
	GetDuplicateDeviceRecords?: Maybe<Array<Maybe<DeviceRecord>>>;
	GetFlexEntitiesCount?: Maybe<Scalars["Int"]>;
	GetFormsCount?: Maybe<Scalars["Int"]>;
	GetIRAdverseEventData?: Maybe<AdverseEventReport>;
	GetOrganizationAgreementTags: Array<Scalars["String"]>;
	GetOutcomeBasedAgreementReportData: OutcomebasedAgreementReport;
	GetPotentialCounterparties: Array<Organization>;
	GetRecordsCount?: Maybe<Scalars["Int"]>;
	GetRefundCount?: Maybe<Scalars["Int"]>;
	GetRefundXlsInvoice?: Maybe<Array<Maybe<Document>>>;
	GetReportingSummary?: Maybe<ReportingSummary>;
	GetTranslations: TranslationsResult;
	GetUnknownPreparationIds?: Maybe<Array<Maybe<Scalars["String"]>>>;
	GetUserContextFiltersAgreements?: Maybe<Scalars["String"]>;
	GetUserContextFiltersCases?: Maybe<Scalars["String"]>;
	GetUserContextFiltersDataForms?: Maybe<Scalars["String"]>;
	GetUserFiltersDataSimulations?: Maybe<Scalars["String"]>;
	GetUserContextFiltersDataRecords?: Maybe<Scalars["String"]>;
	GetUserContextFiltersDocuments?: Maybe<Scalars["String"]>;
	GetUserContextFiltersRefunds?: Maybe<Scalars["String"]>;
	GetUserRoleAndDataModule: UserOrgSettingsData;
	GetUsersToMentionOnMessage?: Maybe<Array<Maybe<User>>>;
	GetWorkflows?: Maybe<Array<ContractWorkflow>>;
	InvoiceCounterPartiesUsers?: Maybe<Array<Maybe<User>>>;
	OrganizationFromTenantId: Organization;
	adverseEventCounterparties: Array<AdverseEventCounterparties>;
	adverseEventCounterpartiesAggregate: AdverseEventCounterpartiesAggregateSelection;
	adverseEventCounterpartiesCount: Scalars["Int"];
	adverseEventReports: Array<AdverseEventReport>;
	adverseEventReportsAggregate: AdverseEventReportAggregateSelection;
	adverseEventReportsCount: Scalars["Int"];
	adverseEvents: Array<AdverseEvent>;
	adverseEventsAggregate: AdverseEventAggregateSelection;
	adverseEventsCount: Scalars["Int"];
	adverseEventsOccurenceReports: Array<AdverseEventsOccurenceReport>;
	adverseEventsOccurenceReportsAggregate: AdverseEventsOccurenceReportAggregateSelection;
	adverseEventsOccurenceReportsCount: Scalars["Int"];
	agreementDecisions: Array<AgreementDecision>;
	agreementDecisionsAggregate: AgreementDecisionAggregateSelection;
	agreementDecisionsCount: Scalars["Int"];
	agreementReports: Array<AgreementReport>;
	agreementReportsAggregate: AgreementReportAggregateSelection;
	agreementReportsCount: Scalars["Int"];
	agreementSpecificRoles: Array<AgreementSpecificRole>;
	agreementSpecificRolesAggregate: AgreementSpecificRoleAggregateSelection;
	agreementSpecificRolesCount: Scalars["Int"];
	agreementStatusTransitions: Array<AgreementStatusTransition>;
	agreementStatusTransitionsAggregate: AgreementStatusTransitionAggregateSelection;
	agreementStatusTransitionsCount: Scalars["Int"];
	agreementTags: Array<AgreementTag>;
	agreementTagsAggregate: AgreementTagAggregateSelection;
	agreementTagsCount: Scalars["Int"];
	agreements: Array<Agreement>;
	agreementsAggregate: AgreementAggregateSelection;
	agreementsCount: Scalars["Int"];
	averageLaPressureAndLaVolumeRows: Array<AverageLaPressureAndLaVolumeRow>;
	averageLaPressureAndLaVolumeRowsAggregate: AverageLaPressureAndLaVolumeRowAggregateSelection;
	averageLaPressureAndLaVolumeRowsCount: Scalars["Int"];
	baseAgreements: Array<BaseAgreement>;
	baseAgreementsAggregate: BaseAgreementAggregateSelection;
	baseAgreementsCount: Scalars["Int"];
	brands: Array<Brand>;
	brandsAggregate: BrandAggregateSelection;
	brandsCount: Scalars["Int"];
	caobAgreementReports: Array<CaobAgreementReport>;
	caobAgreementReportsAggregate: CaobAgreementReportAggregateSelection;
	caobAgreementReportsCount: Scalars["Int"];
	caobRefundSummaryRows: Array<CaobRefundSummaryRow>;
	caobRefundSummaryRowsAggregate: CaobRefundSummaryRowAggregateSelection;
	caobRefundSummaryRowsCount: Scalars["Int"];
	caseReportDataPoints: Array<CaseReportDataPoint>;
	caseReportDataPointsAggregate: CaseReportDataPointAggregateSelection;
	caseReportDataPointsCount: Scalars["Int"];
	cases: Array<Case>;
	casesAggregate: CaseAggregateSelection;
	casesCount: Scalars["Int"];
	claims: Array<Claim>;
	claimsAggregate: ClaimAggregateSelection;
	claimsCount: Scalars["Int"];
	continuousBenefits: Array<ContinuousBenefit>;
	continuousBenefitsAggregate: ContinuousBenefitAggregateSelection;
	continuousBenefitsCount: Scalars["Int"];
	contractNotifications: Array<ContractNotification>;
	contractNotificationsAggregate: ContractNotificationAggregateSelection;
	contractNotificationsCount: Scalars["Int"];
	contractWorkflowSteps: Array<ContractWorkflowStep>;
	contractWorkflowStepsAggregate: ContractWorkflowStepAggregateSelection;
	contractWorkflowStepsCount: Scalars["Int"];
	contractWorkflows: Array<ContractWorkflow>;
	contractWorkflowsAggregate: ContractWorkflowAggregateSelection;
	contractWorkflowsCount: Scalars["Int"];
	coverageRequests: Array<CoverageRequest>;
	coverageRequestsAggregate: CoverageRequestAggregateSelection;
	coverageRequestsCount: Scalars["Int"];
	currencies: Array<Currency>;
	currenciesAggregate: CurrencyAggregateSelection;
	currenciesCount: Scalars["Int"];
	dataContainers: Array<DataContainer>;
	dataContainersAggregate: DataContainerAggregateSelection;
	dataContainersCount: Scalars["Int"];
	dataSources: Array<DataSource>;
	dataSourcesAggregate: DataSourceAggregateSelection;
	dataSourcesCount: Scalars["Int"];
	deviceAlternatives: Array<DeviceAlternative>;
	deviceAlternativesAggregate: DeviceAlternativeAggregateSelection;
	deviceAlternativesCount: Scalars["Int"];
	deviceFinancialDataPoints: Array<DeviceFinancialDataPoint>;
	deviceFinancialDataPointsAggregate: DeviceFinancialDataPointAggregateSelection;
	deviceFinancialDataPointsCount: Scalars["Int"];
	deviceKits: Array<DeviceKit>;
	deviceKitsAggregate: DeviceKitAggregateSelection;
	deviceKitsCount: Scalars["Int"];
	deviceProductCategories: Array<DeviceProductCategory>;
	deviceProductCategoriesAggregate: DeviceProductCategoryAggregateSelection;
	deviceProductCategoriesCount: Scalars["Int"];
	deviceProviders: Array<DeviceProvider>;
	deviceProvidersAggregate: DeviceProviderAggregateSelection;
	deviceProvidersCount: Scalars["Int"];
	deviceRecords: Array<DeviceRecord>;
	deviceRecordsAggregate: DeviceRecordAggregateSelection;
	deviceRecordsCount: Scalars["Int"];
	discontinuationNotes: Array<DiscontinuationNote>;
	discontinuationNotesAggregate: DiscontinuationNoteAggregateSelection;
	discontinuationNotesCount: Scalars["Int"];
	diseases: Array<Disease>;
	diseasesAggregate: DiseaseAggregateSelection;
	diseasesCount: Scalars["Int"];
	documents: Array<Document>;
	documentsAggregate: DocumentAggregateSelection;
	documentsCount: Scalars["Int"];
	eligibilityConditionSets: Array<EligibilityConditionSet>;
	eligibilityConditionSetsAggregate: EligibilityConditionSetAggregateSelection;
	eligibilityConditionSetsCount: Scalars["Int"];
	enrollingConditionSets: Array<EnrollingConditionSet>;
	enrollingConditionSetsAggregate: EnrollingConditionSetAggregateSelection;
	enrollingConditionSetsCount: Scalars["Int"];
	enrollingPeriods: Array<EnrollingPeriod>;
	enrollingPeriodsAggregate: EnrollingPeriodAggregateSelection;
	enrollingPeriodsCount: Scalars["Int"];
	exFactoryPrices: Array<ExFactoryPrice>;
	exFactoryPricesAggregate: ExFactoryPriceAggregateSelection;
	exFactoryPricesCount: Scalars["Int"];
	financialDataPointsAggregate: FinancialDataPointAggregateSelection;
	financialDataPointsCount: Scalars["Int"];
	financialReportDataPoints: Array<FinancialReportDataPoint>;
	financialReportDataPointsAggregate: FinancialReportDataPointAggregateSelection;
	financialReportDataPointsCount: Scalars["Int"];
	financialSummaryColumns: Array<FinancialSummaryColumn>;
	financialSummaryColumnsAggregate: FinancialSummaryColumnAggregateSelection;
	financialSummaryColumnsCount: Scalars["Int"];
	financialSummaryRows: Array<FinancialSummaryRow>;
	financialSummaryRowsAggregate: FinancialSummaryRowAggregateSelection;
	financialSummaryRowsCount: Scalars["Int"];
	flexEntities: Array<FlexEntity>;
	flexEntitiesAggregate: FlexEntityAggregateSelection;
	flexEntitiesCount: Scalars["Int"];
	flexEntityTypes: Array<FlexEntityType>;
	flexEntityTypesAggregate: FlexEntityTypeAggregateSelection;
	flexEntityTypesCount: Scalars["Int"];
	financialDataPoints: Array<FlexFinancialDataPoint>;
	flexFinancialDataPointsAggregate: FlexFinancialDataPointAggregateSelection;
	flexFinancialDataPointsCount: Scalars["Int"];
	forms: Array<Form>;
	formsAggregate: FormAggregateSelection;
	formsCount: Scalars["Int"];
	indications: Array<Indication>;
	indicationsAggregate: IndicationAggregateSelection;
	indicationsCount: Scalars["Int"];
	initialResponseReviewReports: Array<InitialResponseReviewReport>;
	initialResponseReviewReportsAggregate: InitialResponseReviewReportAggregateSelection;
	initialResponseReviewReportsCount: Scalars["Int"];
	initialResponses: Array<InitialResponse>;
	initialResponsesAggregate: InitialResponseAggregateSelection;
	initialResponsesCount: Scalars["Int"];
	interventionReportStatusResponses: Array<InterventionReportStatusResponse>;
	interventionReportStatusResponsesAggregate: InterventionReportStatusResponseAggregateSelection;
	interventionReportStatusResponsesCount: Scalars["Int"];
	interventions: Array<Intervention>;
	interventionsAggregate: InterventionAggregateSelection;
	interventionsCount: Scalars["Int"];
	itemUsedDataPoints: Array<ItemUsedDataPoint>;
	itemUsedDataPointsAggregate: ItemUsedDataPointAggregateSelection;
	itemUsedDataPointsCount: Scalars["Int"];
	limitations: Array<Limitation>;
	limitationsAggregate: LimitationAggregateSelection;
	limitationsCount: Scalars["Int"];
	messages: Array<Message>;
	messagesAggregate: MessageAggregateSelection;
	messagesCount: Scalars["Int"];
	microContents: Array<MicroContent>;
	microContentsAggregate: MicroContentAggregateSelection;
	microContentsCount: Scalars["Int"];
	modules: Array<Module>;
	modulesAggregate: ModuleAggregateSelection;
	modulesCount: Scalars["Int"];
	netRevenueByOrganizations: Array<NetRevenueByOrganization>;
	netRevenueByOrganizationsAggregate: NetRevenueByOrganizationAggregateSelection;
	netRevenueByOrganizationsCount: Scalars["Int"];
	notificationTriggers: Array<NotificationTrigger>;
	notificationTriggersAggregate: NotificationTriggerAggregateSelection;
	notificationTriggersCount: Scalars["Int"];
	notifications: Array<Notification>;
	notificationsAggregate: NotificationAggregateSelection;
	notificationsCount: Scalars["Int"];
	organizations: Array<Organization>;
	organizationsAggregate: OrganizationAggregateSelection;
	organizationsCount: Scalars["Int"];
	outcomebasedAgreementReports: Array<OutcomebasedAgreementReport>;
	outcomebasedAgreementReportsAggregate: OutcomebasedAgreementReportAggregateSelection;
	outcomebasedAgreementReportsCount: Scalars["Int"];
	partners: Array<Partner>;
	partnersAggregate: PartnerAggregateSelection;
	partnersCount: Scalars["Int"];
	patientCountDataPoints: Array<PatientCountDataPoint>;
	patientCountDataPointsAggregate: PatientCountDataPointAggregateSelection;
	patientCountDataPointsCount: Scalars["Int"];
	patientReportDataPoints: Array<PatientReportDataPoint>;
	patientReportDataPointsAggregate: PatientReportDataPointAggregateSelection;
	patientReportDataPointsCount: Scalars["Int"];
	patientStatusDistributions: Array<PatientStatusDistribution>;
	patientStatusDistributionsAggregate: PatientStatusDistributionAggregateSelection;
	patientStatusDistributionsCount: Scalars["Int"];
	patients: Array<Patient>;
	patientsAggregate: PatientAggregateSelection;
	patientsCount: Scalars["Int"];
	patientsPerMonthDataPoints: Array<PatientsPerMonthDataPoint>;
	patientsPerMonthDataPointsAggregate: PatientsPerMonthDataPointAggregateSelection;
	patientsPerMonthDataPointsCount: Scalars["Int"];
	piRecurrenceSiDataPoints: Array<PiRecurrenceSiDataPoint>;
	piRecurrenceSiDataPointsAggregate: PiRecurrenceSiDataPointAggregateSelection;
	piRecurrenceSiDataPointsCount: Scalars["Int"];
	preparationStatuses: Array<PreparationStatus>;
	preparationStatusesAggregate: PreparationStatusAggregateSelection;
	preparationStatusesCount: Scalars["Int"];
	preparations: Array<Preparation>;
	preparationsAggregate: PreparationAggregateSelection;
	preparationsCount: Scalars["Int"];
	prices: Array<Price>;
	pricesAggregate: PriceAggregateSelection;
	pricesCount: Scalars["Int"];
	processedDeviceRecords: Array<ProcessedDeviceRecord>;
	processedDeviceRecordsAggregate: ProcessedDeviceRecordAggregateSelection;
	processedDeviceRecordsCount: Scalars["Int"];
	publicPrices: Array<PublicPrice>;
	publicPricesAggregate: PublicPriceAggregateSelection;
	publicPricesCount: Scalars["Int"];
	reasonOfTreatmentDiscontinuationReports: Array<ReasonOfTreatmentDiscontinuationReport>;
	reasonOfTreatmentDiscontinuationReportsAggregate: ReasonOfTreatmentDiscontinuationReportAggregateSelection;
	reasonOfTreatmentDiscontinuationReportsCount: Scalars["Int"];
	recommendedForms: Array<RecommendedForm>;
	recommendedFormsAggregate: RecommendedFormAggregateSelection;
	recommendedFormsCount: Scalars["Int"];
	recordBatches: Array<RecordBatch>;
	recordBatchesAggregate: RecordBatchAggregateSelection;
	recordBatchesCount: Scalars["Int"];
	records: Array<Record>;
	recordsAggregate: RecordAggregateSelection;
	recordsCount: Scalars["Int"];
	refunds: Array<Refund>;
	refundsAggregate: RefundAggregateSelection;
	refundsCount: Scalars["Int"];
	reportingSummaries: Array<ReportingSummary>;
	reportingSummariesAggregate: ReportingSummaryAggregateSelection;
	reportingSummariesCount: Scalars["Int"];
	scenarioActions: Array<ScenarioAction>;
	scenarioActionsAggregate: ScenarioActionAggregateSelection;
	scenarioActionsCount: Scalars["Int"];
	scenarioConditions: Array<ScenarioCondition>;
	scenarioConditionsAggregate: ScenarioConditionAggregateSelection;
	scenarioConditionsCount: Scalars["Int"];
	scenarios: Array<Scenario>;
	scenariosAggregate: ScenarioAggregateSelection;
	scenariosCount: Scalars["Int"];
	stobActions: Array<StobAction>;
	stobActionsAggregate: StobActionAggregateSelection;
	stobActionsCount: Scalars["Int"];
	stobConditions: Array<StobCondition>;
	stobConditionsAggregate: StobConditionAggregateSelection;
	stobConditionsCount: Scalars["Int"];
	stobContracts: Array<StobContract>;
	stobContractsAggregate: StobContractAggregateSelection;
	stobContractsCount: Scalars["Int"];
	stobScenarios: Array<StobScenario>;
	stobScenariosAggregate: StobScenarioAggregateSelection;
	stobScenariosCount: Scalars["Int"];
	stobStatistics: Array<StobStatistics>;
	stobStatisticsAggregate: StobStatisticsAggregateSelection;
	stobStatisticsCount: Scalars["Int"];
	tasks: Array<Task>;
	tasksAggregate: TaskAggregateSelection;
	tasksCount: Scalars["Int"];
	timeframes: Array<Timeframe>;
	timeframesAggregate: TimeframeAggregateSelection;
	timeframesCount: Scalars["Int"];
	translations: Array<Translation>;
	translationsAggregate: TranslationAggregateSelection;
	translationsCount: Scalars["Int"];
	translationsResults: Array<TranslationsResult>;
	translationsResultsAggregate: TranslationsResultAggregateSelection;
	translationsResultsCount: Scalars["Int"];
	treatingPhysicians: Array<TreatingPhysician>;
	treatingPhysiciansAggregate: TreatingPhysicianAggregateSelection;
	treatingPhysiciansCount: Scalars["Int"];
	treatmentPatients: Array<TreatmentPatient>;
	treatmentPatientsAggregate: TreatmentPatientAggregateSelection;
	treatmentPatientsCount: Scalars["Int"];
	treatments: Array<Treatment>;
	treatmentsAggregate: TreatmentAggregateSelection;
	treatmentsCount: Scalars["Int"];
	userContexts: Array<UserContext>;
	userContextsAggregate: UserContextAggregateSelection;
	userContextsCount: Scalars["Int"];
	userOrgSettingsData: Array<UserOrgSettingsData>;
	userOrgSettingsDataAggregate: UserOrgSettingsDataAggregateSelection;
	userOrgSettingsDataCount: Scalars["Int"];
	userOrganizationInfos: Array<UserOrganizationInfo>;
	userOrganizationInfosAggregate: UserOrganizationInfoAggregateSelection;
	userOrganizationInfosCount: Scalars["Int"];
	userPersonalInfos: Array<UserPersonalInfo>;
	userPersonalInfosAggregate: UserPersonalInfoAggregateSelection;
	userPersonalInfosCount: Scalars["Int"];
	users: Array<User>;
	usersAggregate: UserAggregateSelection;
	usersCount: Scalars["Int"];
};

export type QueryCheckCbArgs = {
	id: Scalars["String"];
};

export type QueryCheckIrArgs = {
	id: Scalars["String"];
};

export type QueryGetAgreementIdFromInvoiceIdArgs = {
	invoiceId: Scalars["ID"];
};

export type QueryGetAgreementProcessedDeviceRecordsArgs = {
	agreementId: Scalars["ID"];
	endDate: Scalars["DateTime"];
	startDate: Scalars["DateTime"];
};

export type QueryGetAgreementReportDataArgs = {
	from?: InputMaybe<Scalars["Date"]>;
	id: Scalars["ID"];
	to?: InputMaybe<Scalars["Date"]>;
};

export type QueryGetAgreementsForSelectedUserArgs = {
	id: Scalars["String"];
};

export type QueryGetAllBaseAgreementVersionsArgs = {
	id: Scalars["ID"];
};

export type QueryGetAllDataPointsByDateArgs = {
	endDate: Scalars["String"];
	id: Scalars["ID"];
	startDate: Scalars["String"];
};

export type QueryGetAllDataPointsByPrescriptionDateArgs = {
	endDate: Scalars["String"];
	id: Scalars["ID"];
	startDate: Scalars["String"];
};

export type QueryGetAssigneeArgs = {
	invoiceId: Scalars["ID"];
	tenantId: Scalars["String"];
};

export type QueryGetAvailableCaseAssigneesArgs = {
	caseId: Scalars["ID"];
};

export type QueryGetCaobAgreementReportDataArgs = {
	from?: InputMaybe<Scalars["Date"]>;
	id: Scalars["ID"];
	to?: InputMaybe<Scalars["Date"]>;
};

export type QueryGetCbAdverseEventDataArgs = {
	id: Scalars["String"];
};

export type QueryGetDefaultAgreementRolesArgs = {
	tags: Array<Scalars["String"]>;
};

export type QueryGetDuplicateClaimsArgs = {
	ids?: InputMaybe<Array<InputMaybe<UniqueClaimsIdentifiers>>>;
};

export type QueryGetDuplicateDeviceRecordsArgs = {
	ids?: InputMaybe<Array<InputMaybe<UniqueDeviceRecordIdentifiersInput>>>;
};

export type QueryGetIrAdverseEventDataArgs = {
	id: Scalars["String"];
};

export type QueryGetOutcomeBasedAgreementReportDataArgs = {
	from?: InputMaybe<Scalars["Date"]>;
	id: Scalars["ID"];
	to?: InputMaybe<Scalars["Date"]>;
};

export type QueryGetRefundXlsInvoiceArgs = {
	invoiceId: Scalars["ID"];
};

export type QueryGetReportingSummaryArgs = {
	from?: InputMaybe<Scalars["Date"]>;
	to?: InputMaybe<Scalars["Date"]>;
};

export type QueryGetUnknownPreparationIdsArgs = {
	ids?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
};

export type QueryGetUserRoleAndDataModuleArgs = {
	id?: InputMaybe<Scalars["String"]>;
};

export type QueryGetUsersToMentionOnMessageArgs = {
	refundId?: InputMaybe<Scalars["ID"]>;
};

export type QueryGetWorkflowsArgs = {
	contractId: Scalars["String"];
};

export type QueryInvoiceCounterPartiesUsersArgs = {
	input?: InputMaybe<SearchUserEmailByNameInput>;
	limit?: InputMaybe<Scalars["Int"]>;
};

export type QueryOrganizationFromTenantIdArgs = {
	tenantId?: InputMaybe<Scalars["String"]>;
};

export type QueryAdverseEventCounterpartiesArgs = {
	options?: InputMaybe<AdverseEventCounterpartiesOptions>;
	where?: InputMaybe<AdverseEventCounterpartiesWhere>;
};

export type QueryAdverseEventCounterpartiesAggregateArgs = {
	where?: InputMaybe<AdverseEventCounterpartiesWhere>;
};

export type QueryAdverseEventCounterpartiesCountArgs = {
	where?: InputMaybe<AdverseEventCounterpartiesWhere>;
};

export type QueryAdverseEventReportsArgs = {
	options?: InputMaybe<AdverseEventReportOptions>;
	where?: InputMaybe<AdverseEventReportWhere>;
};

export type QueryAdverseEventReportsAggregateArgs = {
	where?: InputMaybe<AdverseEventReportWhere>;
};

export type QueryAdverseEventReportsCountArgs = {
	where?: InputMaybe<AdverseEventReportWhere>;
};

export type QueryAdverseEventsArgs = {
	options?: InputMaybe<AdverseEventOptions>;
	where?: InputMaybe<AdverseEventWhere>;
};

export type QueryAdverseEventsAggregateArgs = {
	where?: InputMaybe<AdverseEventWhere>;
};

export type QueryAdverseEventsCountArgs = {
	where?: InputMaybe<AdverseEventWhere>;
};

export type QueryAdverseEventsOccurenceReportsArgs = {
	options?: InputMaybe<AdverseEventsOccurenceReportOptions>;
	where?: InputMaybe<AdverseEventsOccurenceReportWhere>;
};

export type QueryAdverseEventsOccurenceReportsAggregateArgs = {
	where?: InputMaybe<AdverseEventsOccurenceReportWhere>;
};

export type QueryAdverseEventsOccurenceReportsCountArgs = {
	where?: InputMaybe<AdverseEventsOccurenceReportWhere>;
};

export type QueryAgreementDecisionsArgs = {
	options?: InputMaybe<AgreementDecisionOptions>;
	where?: InputMaybe<AgreementDecisionWhere>;
};

export type QueryAgreementDecisionsAggregateArgs = {
	where?: InputMaybe<AgreementDecisionWhere>;
};

export type QueryAgreementDecisionsCountArgs = {
	where?: InputMaybe<AgreementDecisionWhere>;
};

export type QueryAgreementReportsArgs = {
	options?: InputMaybe<AgreementReportOptions>;
	where?: InputMaybe<AgreementReportWhere>;
};

export type QueryAgreementReportsAggregateArgs = {
	where?: InputMaybe<AgreementReportWhere>;
};

export type QueryAgreementReportsCountArgs = {
	where?: InputMaybe<AgreementReportWhere>;
};

export type QueryAgreementSpecificRolesArgs = {
	options?: InputMaybe<AgreementSpecificRoleOptions>;
	where?: InputMaybe<AgreementSpecificRoleWhere>;
};

export type QueryAgreementSpecificRolesAggregateArgs = {
	where?: InputMaybe<AgreementSpecificRoleWhere>;
};

export type QueryAgreementSpecificRolesCountArgs = {
	where?: InputMaybe<AgreementSpecificRoleWhere>;
};

export type QueryAgreementStatusTransitionsArgs = {
	options?: InputMaybe<AgreementStatusTransitionOptions>;
	where?: InputMaybe<AgreementStatusTransitionWhere>;
};

export type QueryAgreementStatusTransitionsAggregateArgs = {
	where?: InputMaybe<AgreementStatusTransitionWhere>;
};

export type QueryAgreementStatusTransitionsCountArgs = {
	where?: InputMaybe<AgreementStatusTransitionWhere>;
};

export type QueryAgreementTagsArgs = {
	options?: InputMaybe<AgreementTagOptions>;
	where?: InputMaybe<AgreementTagWhere>;
};

export type QueryAgreementTagsAggregateArgs = {
	where?: InputMaybe<AgreementTagWhere>;
};

export type QueryAgreementTagsCountArgs = {
	where?: InputMaybe<AgreementTagWhere>;
};

export type QueryAgreementsArgs = {
	options?: InputMaybe<AgreementOptions>;
	where?: InputMaybe<AgreementWhere>;
};

export type QueryAgreementsAggregateArgs = {
	where?: InputMaybe<AgreementWhere>;
};

export type QueryAgreementsCountArgs = {
	where?: InputMaybe<AgreementWhere>;
};

export type QueryAverageLaPressureAndLaVolumeRowsArgs = {
	options?: InputMaybe<AverageLaPressureAndLaVolumeRowOptions>;
	where?: InputMaybe<AverageLaPressureAndLaVolumeRowWhere>;
};

export type QueryAverageLaPressureAndLaVolumeRowsAggregateArgs = {
	where?: InputMaybe<AverageLaPressureAndLaVolumeRowWhere>;
};

export type QueryAverageLaPressureAndLaVolumeRowsCountArgs = {
	where?: InputMaybe<AverageLaPressureAndLaVolumeRowWhere>;
};

export type QueryBaseAgreementsArgs = {
	options?: InputMaybe<BaseAgreementOptions>;
	where?: InputMaybe<BaseAgreementWhere>;
};

export type QueryBaseAgreementsAggregateArgs = {
	where?: InputMaybe<BaseAgreementWhere>;
};

export type QueryBaseAgreementsCountArgs = {
	where?: InputMaybe<BaseAgreementWhere>;
};

export type QueryBrandsArgs = {
	options?: InputMaybe<BrandOptions>;
	where?: InputMaybe<BrandWhere>;
};

export type QueryBrandsAggregateArgs = {
	where?: InputMaybe<BrandWhere>;
};

export type QueryBrandsCountArgs = {
	where?: InputMaybe<BrandWhere>;
};

export type QueryCaobAgreementReportsArgs = {
	options?: InputMaybe<CaobAgreementReportOptions>;
	where?: InputMaybe<CaobAgreementReportWhere>;
};

export type QueryCaobAgreementReportsAggregateArgs = {
	where?: InputMaybe<CaobAgreementReportWhere>;
};

export type QueryCaobAgreementReportsCountArgs = {
	where?: InputMaybe<CaobAgreementReportWhere>;
};

export type QueryCaobRefundSummaryRowsArgs = {
	options?: InputMaybe<CaobRefundSummaryRowOptions>;
	where?: InputMaybe<CaobRefundSummaryRowWhere>;
};

export type QueryCaobRefundSummaryRowsAggregateArgs = {
	where?: InputMaybe<CaobRefundSummaryRowWhere>;
};

export type QueryCaobRefundSummaryRowsCountArgs = {
	where?: InputMaybe<CaobRefundSummaryRowWhere>;
};

export type QueryCaseReportDataPointsArgs = {
	options?: InputMaybe<CaseReportDataPointOptions>;
	where?: InputMaybe<CaseReportDataPointWhere>;
};

export type QueryCaseReportDataPointsAggregateArgs = {
	where?: InputMaybe<CaseReportDataPointWhere>;
};

export type QueryCaseReportDataPointsCountArgs = {
	where?: InputMaybe<CaseReportDataPointWhere>;
};

export type QueryCasesArgs = {
	options?: InputMaybe<CaseOptions>;
	where?: InputMaybe<CaseWhere>;
};

export type QueryCasesAggregateArgs = {
	where?: InputMaybe<CaseWhere>;
};

export type QueryCasesCountArgs = {
	where?: InputMaybe<CaseWhere>;
};

export type QueryClaimsArgs = {
	options?: InputMaybe<ClaimOptions>;
	where?: InputMaybe<ClaimWhere>;
};

export type QueryClaimsAggregateArgs = {
	where?: InputMaybe<ClaimWhere>;
};

export type QueryClaimsCountArgs = {
	where?: InputMaybe<ClaimWhere>;
};

export type QueryContinuousBenefitsArgs = {
	options?: InputMaybe<ContinuousBenefitOptions>;
	where?: InputMaybe<ContinuousBenefitWhere>;
};

export type QueryContinuousBenefitsAggregateArgs = {
	where?: InputMaybe<ContinuousBenefitWhere>;
};

export type QueryContinuousBenefitsCountArgs = {
	where?: InputMaybe<ContinuousBenefitWhere>;
};

export type QueryContractNotificationsArgs = {
	options?: InputMaybe<ContractNotificationOptions>;
	where?: InputMaybe<ContractNotificationWhere>;
};

export type QueryContractNotificationsAggregateArgs = {
	where?: InputMaybe<ContractNotificationWhere>;
};

export type QueryContractNotificationsCountArgs = {
	where?: InputMaybe<ContractNotificationWhere>;
};

export type QueryContractWorkflowStepsArgs = {
	options?: InputMaybe<ContractWorkflowStepOptions>;
	where?: InputMaybe<ContractWorkflowStepWhere>;
};

export type QueryContractWorkflowStepsAggregateArgs = {
	where?: InputMaybe<ContractWorkflowStepWhere>;
};

export type QueryContractWorkflowStepsCountArgs = {
	where?: InputMaybe<ContractWorkflowStepWhere>;
};

export type QueryContractWorkflowsArgs = {
	options?: InputMaybe<ContractWorkflowOptions>;
	where?: InputMaybe<ContractWorkflowWhere>;
};

export type QueryContractWorkflowsAggregateArgs = {
	where?: InputMaybe<ContractWorkflowWhere>;
};

export type QueryContractWorkflowsCountArgs = {
	where?: InputMaybe<ContractWorkflowWhere>;
};

export type QueryCoverageRequestsArgs = {
	options?: InputMaybe<CoverageRequestOptions>;
	where?: InputMaybe<CoverageRequestWhere>;
};

export type QueryCoverageRequestsAggregateArgs = {
	where?: InputMaybe<CoverageRequestWhere>;
};

export type QueryCoverageRequestsCountArgs = {
	where?: InputMaybe<CoverageRequestWhere>;
};

export type QueryCurrenciesArgs = {
	options?: InputMaybe<CurrencyOptions>;
	where?: InputMaybe<CurrencyWhere>;
};

export type QueryCurrenciesAggregateArgs = {
	where?: InputMaybe<CurrencyWhere>;
};

export type QueryCurrenciesCountArgs = {
	where?: InputMaybe<CurrencyWhere>;
};

export type QueryDataContainersArgs = {
	options?: InputMaybe<DataContainerOptions>;
	where?: InputMaybe<DataContainerWhere>;
};

export type QueryDataContainersAggregateArgs = {
	where?: InputMaybe<DataContainerWhere>;
};

export type QueryDataContainersCountArgs = {
	where?: InputMaybe<DataContainerWhere>;
};

export type QueryDataSourcesArgs = {
	options?: InputMaybe<DataSourceOptions>;
	where?: InputMaybe<DataSourceWhere>;
};

export type QueryDataSourcesAggregateArgs = {
	where?: InputMaybe<DataSourceWhere>;
};

export type QueryDataSourcesCountArgs = {
	where?: InputMaybe<DataSourceWhere>;
};

export type QueryDeviceAlternativesArgs = {
	options?: InputMaybe<DeviceAlternativeOptions>;
	where?: InputMaybe<DeviceAlternativeWhere>;
};

export type QueryDeviceAlternativesAggregateArgs = {
	where?: InputMaybe<DeviceAlternativeWhere>;
};

export type QueryDeviceAlternativesCountArgs = {
	where?: InputMaybe<DeviceAlternativeWhere>;
};

export type QueryDeviceFinancialDataPointsArgs = {
	options?: InputMaybe<DeviceFinancialDataPointOptions>;
	where?: InputMaybe<DeviceFinancialDataPointWhere>;
};

export type QueryDeviceFinancialDataPointsAggregateArgs = {
	where?: InputMaybe<DeviceFinancialDataPointWhere>;
};

export type QueryDeviceFinancialDataPointsCountArgs = {
	where?: InputMaybe<DeviceFinancialDataPointWhere>;
};

export type QueryDeviceKitsArgs = {
	options?: InputMaybe<DeviceKitOptions>;
	where?: InputMaybe<DeviceKitWhere>;
};

export type QueryDeviceKitsAggregateArgs = {
	where?: InputMaybe<DeviceKitWhere>;
};

export type QueryDeviceKitsCountArgs = {
	where?: InputMaybe<DeviceKitWhere>;
};

export type QueryDeviceProductCategoriesArgs = {
	options?: InputMaybe<DeviceProductCategoryOptions>;
	where?: InputMaybe<DeviceProductCategoryWhere>;
};

export type QueryDeviceProductCategoriesAggregateArgs = {
	where?: InputMaybe<DeviceProductCategoryWhere>;
};

export type QueryDeviceProductCategoriesCountArgs = {
	where?: InputMaybe<DeviceProductCategoryWhere>;
};

export type QueryDeviceProvidersArgs = {
	options?: InputMaybe<DeviceProviderOptions>;
	where?: InputMaybe<DeviceProviderWhere>;
};

export type QueryDeviceProvidersAggregateArgs = {
	where?: InputMaybe<DeviceProviderWhere>;
};

export type QueryDeviceProvidersCountArgs = {
	where?: InputMaybe<DeviceProviderWhere>;
};

export type QueryDeviceRecordsArgs = {
	options?: InputMaybe<DeviceRecordOptions>;
	where?: InputMaybe<DeviceRecordWhere>;
};

export type QueryDeviceRecordsAggregateArgs = {
	where?: InputMaybe<DeviceRecordWhere>;
};

export type QueryDeviceRecordsCountArgs = {
	where?: InputMaybe<DeviceRecordWhere>;
};

export type QueryDiscontinuationNotesArgs = {
	options?: InputMaybe<DiscontinuationNoteOptions>;
	where?: InputMaybe<DiscontinuationNoteWhere>;
};

export type QueryDiscontinuationNotesAggregateArgs = {
	where?: InputMaybe<DiscontinuationNoteWhere>;
};

export type QueryDiscontinuationNotesCountArgs = {
	where?: InputMaybe<DiscontinuationNoteWhere>;
};

export type QueryDiseasesArgs = {
	options?: InputMaybe<DiseaseOptions>;
	where?: InputMaybe<DiseaseWhere>;
};

export type QueryDiseasesAggregateArgs = {
	where?: InputMaybe<DiseaseWhere>;
};

export type QueryDiseasesCountArgs = {
	where?: InputMaybe<DiseaseWhere>;
};

export type QueryDocumentsArgs = {
	options?: InputMaybe<DocumentOptions>;
	where?: InputMaybe<DocumentWhere>;
};

export type QueryDocumentsAggregateArgs = {
	where?: InputMaybe<DocumentWhere>;
};

export type QueryDocumentsCountArgs = {
	where?: InputMaybe<DocumentWhere>;
};

export type QueryEligibilityConditionSetsArgs = {
	options?: InputMaybe<EligibilityConditionSetOptions>;
	where?: InputMaybe<EligibilityConditionSetWhere>;
};

export type QueryEligibilityConditionSetsAggregateArgs = {
	where?: InputMaybe<EligibilityConditionSetWhere>;
};

export type QueryEligibilityConditionSetsCountArgs = {
	where?: InputMaybe<EligibilityConditionSetWhere>;
};

export type QueryEnrollingConditionSetsArgs = {
	options?: InputMaybe<EnrollingConditionSetOptions>;
	where?: InputMaybe<EnrollingConditionSetWhere>;
};

export type QueryEnrollingConditionSetsAggregateArgs = {
	where?: InputMaybe<EnrollingConditionSetWhere>;
};

export type QueryEnrollingConditionSetsCountArgs = {
	where?: InputMaybe<EnrollingConditionSetWhere>;
};

export type QueryEnrollingPeriodsArgs = {
	options?: InputMaybe<EnrollingPeriodOptions>;
	where?: InputMaybe<EnrollingPeriodWhere>;
};

export type QueryEnrollingPeriodsAggregateArgs = {
	where?: InputMaybe<EnrollingPeriodWhere>;
};

export type QueryEnrollingPeriodsCountArgs = {
	where?: InputMaybe<EnrollingPeriodWhere>;
};

export type QueryExFactoryPricesArgs = {
	options?: InputMaybe<ExFactoryPriceOptions>;
	where?: InputMaybe<ExFactoryPriceWhere>;
};

export type QueryExFactoryPricesAggregateArgs = {
	where?: InputMaybe<ExFactoryPriceWhere>;
};

export type QueryExFactoryPricesCountArgs = {
	where?: InputMaybe<ExFactoryPriceWhere>;
};

export type QueryFinancialDataPointsArgs = {
	options?: InputMaybe<FinancialDataPointOptions>;
	where?: InputMaybe<FinancialDataPointWhere>;
};

export type QueryFinancialDataPointsAggregateArgs = {
	where?: InputMaybe<FinancialDataPointWhere>;
};

export type QueryFinancialDataPointsCountArgs = {
	where?: InputMaybe<FinancialDataPointWhere>;
};

export type QueryFinancialReportDataPointsArgs = {
	options?: InputMaybe<FinancialReportDataPointOptions>;
	where?: InputMaybe<FinancialReportDataPointWhere>;
};

export type QueryFinancialReportDataPointsAggregateArgs = {
	where?: InputMaybe<FinancialReportDataPointWhere>;
};

export type QueryFinancialReportDataPointsCountArgs = {
	where?: InputMaybe<FinancialReportDataPointWhere>;
};

export type QueryFinancialSummaryColumnsArgs = {
	options?: InputMaybe<FinancialSummaryColumnOptions>;
	where?: InputMaybe<FinancialSummaryColumnWhere>;
};

export type QueryFinancialSummaryColumnsAggregateArgs = {
	where?: InputMaybe<FinancialSummaryColumnWhere>;
};

export type QueryFinancialSummaryColumnsCountArgs = {
	where?: InputMaybe<FinancialSummaryColumnWhere>;
};

export type QueryFinancialSummaryRowsArgs = {
	options?: InputMaybe<FinancialSummaryRowOptions>;
	where?: InputMaybe<FinancialSummaryRowWhere>;
};

export type QueryFinancialSummaryRowsAggregateArgs = {
	where?: InputMaybe<FinancialSummaryRowWhere>;
};

export type QueryFinancialSummaryRowsCountArgs = {
	where?: InputMaybe<FinancialSummaryRowWhere>;
};

export type QueryFlexEntitiesArgs = {
	options?: InputMaybe<FlexEntityOptions>;
	where?: InputMaybe<FlexEntityWhere>;
};

export type QueryFlexEntitiesAggregateArgs = {
	where?: InputMaybe<FlexEntityWhere>;
};

export type QueryFlexEntitiesCountArgs = {
	where?: InputMaybe<FlexEntityWhere>;
};

export type QueryFlexEntityTypesArgs = {
	options?: InputMaybe<FlexEntityTypeOptions>;
	where?: InputMaybe<FlexEntityTypeWhere>;
};

export type QueryFlexEntityTypesAggregateArgs = {
	where?: InputMaybe<FlexEntityTypeWhere>;
};

export type QueryFlexEntityTypesCountArgs = {
	where?: InputMaybe<FlexEntityTypeWhere>;
};

export type QueryFlexFinancialDataPointsArgs = {
	options?: InputMaybe<FlexFinancialDataPointOptions>;
	where?: InputMaybe<FlexFinancialDataPointWhere>;
};

export type QueryFlexFinancialDataPointsAggregateArgs = {
	where?: InputMaybe<FlexFinancialDataPointWhere>;
};

export type QueryFlexFinancialDataPointsCountArgs = {
	where?: InputMaybe<FlexFinancialDataPointWhere>;
};

export type QueryFormsArgs = {
	options?: InputMaybe<FormOptions>;
	where?: InputMaybe<FormWhere>;
};

export type QueryFormsAggregateArgs = {
	where?: InputMaybe<FormWhere>;
};

export type QueryFormsCountArgs = {
	where?: InputMaybe<FormWhere>;
};

export type QueryIndicationsArgs = {
	options?: InputMaybe<IndicationOptions>;
	where?: InputMaybe<IndicationWhere>;
};

export type QueryIndicationsAggregateArgs = {
	where?: InputMaybe<IndicationWhere>;
};

export type QueryIndicationsCountArgs = {
	where?: InputMaybe<IndicationWhere>;
};

export type QueryInitialResponseReviewReportsArgs = {
	options?: InputMaybe<InitialResponseReviewReportOptions>;
	where?: InputMaybe<InitialResponseReviewReportWhere>;
};

export type QueryInitialResponseReviewReportsAggregateArgs = {
	where?: InputMaybe<InitialResponseReviewReportWhere>;
};

export type QueryInitialResponseReviewReportsCountArgs = {
	where?: InputMaybe<InitialResponseReviewReportWhere>;
};

export type QueryInitialResponsesArgs = {
	options?: InputMaybe<InitialResponseOptions>;
	where?: InputMaybe<InitialResponseWhere>;
};

export type QueryInitialResponsesAggregateArgs = {
	where?: InputMaybe<InitialResponseWhere>;
};

export type QueryInitialResponsesCountArgs = {
	where?: InputMaybe<InitialResponseWhere>;
};

export type QueryInterventionReportStatusResponsesArgs = {
	options?: InputMaybe<InterventionReportStatusResponseOptions>;
	where?: InputMaybe<InterventionReportStatusResponseWhere>;
};

export type QueryInterventionReportStatusResponsesAggregateArgs = {
	where?: InputMaybe<InterventionReportStatusResponseWhere>;
};

export type QueryInterventionReportStatusResponsesCountArgs = {
	where?: InputMaybe<InterventionReportStatusResponseWhere>;
};

export type QueryInterventionsArgs = {
	options?: InputMaybe<InterventionOptions>;
	where?: InputMaybe<InterventionWhere>;
};

export type QueryInterventionsAggregateArgs = {
	where?: InputMaybe<InterventionWhere>;
};

export type QueryInterventionsCountArgs = {
	where?: InputMaybe<InterventionWhere>;
};

export type QueryItemUsedDataPointsArgs = {
	options?: InputMaybe<ItemUsedDataPointOptions>;
	where?: InputMaybe<ItemUsedDataPointWhere>;
};

export type QueryItemUsedDataPointsAggregateArgs = {
	where?: InputMaybe<ItemUsedDataPointWhere>;
};

export type QueryItemUsedDataPointsCountArgs = {
	where?: InputMaybe<ItemUsedDataPointWhere>;
};

export type QueryLimitationsArgs = {
	options?: InputMaybe<LimitationOptions>;
	where?: InputMaybe<LimitationWhere>;
};

export type QueryLimitationsAggregateArgs = {
	where?: InputMaybe<LimitationWhere>;
};

export type QueryLimitationsCountArgs = {
	where?: InputMaybe<LimitationWhere>;
};

export type QueryMessagesArgs = {
	options?: InputMaybe<MessageOptions>;
	where?: InputMaybe<MessageWhere>;
};

export type QueryMessagesAggregateArgs = {
	where?: InputMaybe<MessageWhere>;
};

export type QueryMessagesCountArgs = {
	where?: InputMaybe<MessageWhere>;
};

export type QueryMicroContentsArgs = {
	options?: InputMaybe<MicroContentOptions>;
	where?: InputMaybe<MicroContentWhere>;
};

export type QueryMicroContentsAggregateArgs = {
	where?: InputMaybe<MicroContentWhere>;
};

export type QueryMicroContentsCountArgs = {
	where?: InputMaybe<MicroContentWhere>;
};

export type QueryModulesArgs = {
	options?: InputMaybe<ModuleOptions>;
	where?: InputMaybe<ModuleWhere>;
};

export type QueryModulesAggregateArgs = {
	where?: InputMaybe<ModuleWhere>;
};

export type QueryModulesCountArgs = {
	where?: InputMaybe<ModuleWhere>;
};

export type QueryNetRevenueByOrganizationsArgs = {
	options?: InputMaybe<NetRevenueByOrganizationOptions>;
	where?: InputMaybe<NetRevenueByOrganizationWhere>;
};

export type QueryNetRevenueByOrganizationsAggregateArgs = {
	where?: InputMaybe<NetRevenueByOrganizationWhere>;
};

export type QueryNetRevenueByOrganizationsCountArgs = {
	where?: InputMaybe<NetRevenueByOrganizationWhere>;
};

export type QueryNotificationTriggersArgs = {
	options?: InputMaybe<NotificationTriggerOptions>;
	where?: InputMaybe<NotificationTriggerWhere>;
};

export type QueryNotificationTriggersAggregateArgs = {
	where?: InputMaybe<NotificationTriggerWhere>;
};

export type QueryNotificationTriggersCountArgs = {
	where?: InputMaybe<NotificationTriggerWhere>;
};

export type QueryNotificationsArgs = {
	options?: InputMaybe<NotificationOptions>;
	where?: InputMaybe<NotificationWhere>;
};

export type QueryNotificationsAggregateArgs = {
	where?: InputMaybe<NotificationWhere>;
};

export type QueryNotificationsCountArgs = {
	where?: InputMaybe<NotificationWhere>;
};

export type QueryOrganizationsArgs = {
	options?: InputMaybe<OrganizationOptions>;
	where?: InputMaybe<OrganizationWhere>;
};

export type QueryOrganizationsAggregateArgs = {
	where?: InputMaybe<OrganizationWhere>;
};

export type QueryOrganizationsCountArgs = {
	where?: InputMaybe<OrganizationWhere>;
};

export type QueryOutcomebasedAgreementReportsArgs = {
	options?: InputMaybe<OutcomebasedAgreementReportOptions>;
	where?: InputMaybe<OutcomebasedAgreementReportWhere>;
};

export type QueryOutcomebasedAgreementReportsAggregateArgs = {
	where?: InputMaybe<OutcomebasedAgreementReportWhere>;
};

export type QueryOutcomebasedAgreementReportsCountArgs = {
	where?: InputMaybe<OutcomebasedAgreementReportWhere>;
};

export type QueryPartnersArgs = {
	options?: InputMaybe<PartnerOptions>;
	where?: InputMaybe<PartnerWhere>;
};

export type QueryPartnersAggregateArgs = {
	where?: InputMaybe<PartnerWhere>;
};

export type QueryPartnersCountArgs = {
	where?: InputMaybe<PartnerWhere>;
};

export type QueryPatientCountDataPointsArgs = {
	options?: InputMaybe<PatientCountDataPointOptions>;
	where?: InputMaybe<PatientCountDataPointWhere>;
};

export type QueryPatientCountDataPointsAggregateArgs = {
	where?: InputMaybe<PatientCountDataPointWhere>;
};

export type QueryPatientCountDataPointsCountArgs = {
	where?: InputMaybe<PatientCountDataPointWhere>;
};

export type QueryPatientReportDataPointsArgs = {
	options?: InputMaybe<PatientReportDataPointOptions>;
	where?: InputMaybe<PatientReportDataPointWhere>;
};

export type QueryPatientReportDataPointsAggregateArgs = {
	where?: InputMaybe<PatientReportDataPointWhere>;
};

export type QueryPatientReportDataPointsCountArgs = {
	where?: InputMaybe<PatientReportDataPointWhere>;
};

export type QueryPatientStatusDistributionsArgs = {
	options?: InputMaybe<PatientStatusDistributionOptions>;
	where?: InputMaybe<PatientStatusDistributionWhere>;
};

export type QueryPatientStatusDistributionsAggregateArgs = {
	where?: InputMaybe<PatientStatusDistributionWhere>;
};

export type QueryPatientStatusDistributionsCountArgs = {
	where?: InputMaybe<PatientStatusDistributionWhere>;
};

export type QueryPatientsArgs = {
	options?: InputMaybe<PatientOptions>;
	where?: InputMaybe<PatientWhere>;
};

export type QueryPatientsAggregateArgs = {
	where?: InputMaybe<PatientWhere>;
};

export type QueryPatientsCountArgs = {
	where?: InputMaybe<PatientWhere>;
};

export type QueryPatientsPerMonthDataPointsArgs = {
	options?: InputMaybe<PatientsPerMonthDataPointOptions>;
	where?: InputMaybe<PatientsPerMonthDataPointWhere>;
};

export type QueryPatientsPerMonthDataPointsAggregateArgs = {
	where?: InputMaybe<PatientsPerMonthDataPointWhere>;
};

export type QueryPatientsPerMonthDataPointsCountArgs = {
	where?: InputMaybe<PatientsPerMonthDataPointWhere>;
};

export type QueryPiRecurrenceSiDataPointsArgs = {
	options?: InputMaybe<PiRecurrenceSiDataPointOptions>;
	where?: InputMaybe<PiRecurrenceSiDataPointWhere>;
};

export type QueryPiRecurrenceSiDataPointsAggregateArgs = {
	where?: InputMaybe<PiRecurrenceSiDataPointWhere>;
};

export type QueryPiRecurrenceSiDataPointsCountArgs = {
	where?: InputMaybe<PiRecurrenceSiDataPointWhere>;
};

export type QueryPreparationStatusesArgs = {
	options?: InputMaybe<PreparationStatusOptions>;
	where?: InputMaybe<PreparationStatusWhere>;
};

export type QueryPreparationStatusesAggregateArgs = {
	where?: InputMaybe<PreparationStatusWhere>;
};

export type QueryPreparationStatusesCountArgs = {
	where?: InputMaybe<PreparationStatusWhere>;
};

export type QueryPreparationsArgs = {
	options?: InputMaybe<PreparationOptions>;
	where?: InputMaybe<PreparationWhere>;
};

export type QueryPreparationsAggregateArgs = {
	where?: InputMaybe<PreparationWhere>;
};

export type QueryPreparationsCountArgs = {
	where?: InputMaybe<PreparationWhere>;
};

export type QueryPricesArgs = {
	options?: InputMaybe<PriceOptions>;
	where?: InputMaybe<PriceWhere>;
};

export type QueryPricesAggregateArgs = {
	where?: InputMaybe<PriceWhere>;
};

export type QueryPricesCountArgs = {
	where?: InputMaybe<PriceWhere>;
};

export type QueryProcessedDeviceRecordsArgs = {
	options?: InputMaybe<ProcessedDeviceRecordOptions>;
	where?: InputMaybe<ProcessedDeviceRecordWhere>;
};

export type QueryProcessedDeviceRecordsAggregateArgs = {
	where?: InputMaybe<ProcessedDeviceRecordWhere>;
};

export type QueryProcessedDeviceRecordsCountArgs = {
	where?: InputMaybe<ProcessedDeviceRecordWhere>;
};

export type QueryPublicPricesArgs = {
	options?: InputMaybe<PublicPriceOptions>;
	where?: InputMaybe<PublicPriceWhere>;
};

export type QueryPublicPricesAggregateArgs = {
	where?: InputMaybe<PublicPriceWhere>;
};

export type QueryPublicPricesCountArgs = {
	where?: InputMaybe<PublicPriceWhere>;
};

export type QueryReasonOfTreatmentDiscontinuationReportsArgs = {
	options?: InputMaybe<ReasonOfTreatmentDiscontinuationReportOptions>;
	where?: InputMaybe<ReasonOfTreatmentDiscontinuationReportWhere>;
};

export type QueryReasonOfTreatmentDiscontinuationReportsAggregateArgs = {
	where?: InputMaybe<ReasonOfTreatmentDiscontinuationReportWhere>;
};

export type QueryReasonOfTreatmentDiscontinuationReportsCountArgs = {
	where?: InputMaybe<ReasonOfTreatmentDiscontinuationReportWhere>;
};

export type QueryRecommendedFormsArgs = {
	options?: InputMaybe<RecommendedFormOptions>;
	where?: InputMaybe<RecommendedFormWhere>;
};

export type QueryRecommendedFormsAggregateArgs = {
	where?: InputMaybe<RecommendedFormWhere>;
};

export type QueryRecommendedFormsCountArgs = {
	where?: InputMaybe<RecommendedFormWhere>;
};

export type QueryRecordBatchesArgs = {
	options?: InputMaybe<RecordBatchOptions>;
	where?: InputMaybe<RecordBatchWhere>;
};

export type QueryRecordBatchesAggregateArgs = {
	where?: InputMaybe<RecordBatchWhere>;
};

export type QueryRecordBatchesCountArgs = {
	where?: InputMaybe<RecordBatchWhere>;
};

export type QueryRecordsArgs = {
	options?: InputMaybe<RecordOptions>;
	where?: InputMaybe<RecordWhere>;
};

export type QueryRecordsAggregateArgs = {
	where?: InputMaybe<RecordWhere>;
};

export type QueryRecordsCountArgs = {
	where?: InputMaybe<RecordWhere>;
};

export type QueryRefundsArgs = {
	options?: InputMaybe<RefundOptions>;
	where?: InputMaybe<RefundWhere>;
};

export type QueryRefundsAggregateArgs = {
	where?: InputMaybe<RefundWhere>;
};

export type QueryRefundsCountArgs = {
	where?: InputMaybe<RefundWhere>;
};

export type QueryReportingSummariesArgs = {
	options?: InputMaybe<ReportingSummaryOptions>;
	where?: InputMaybe<ReportingSummaryWhere>;
};

export type QueryReportingSummariesAggregateArgs = {
	where?: InputMaybe<ReportingSummaryWhere>;
};

export type QueryReportingSummariesCountArgs = {
	where?: InputMaybe<ReportingSummaryWhere>;
};

export type QueryScenarioActionsArgs = {
	options?: InputMaybe<ScenarioActionOptions>;
	where?: InputMaybe<ScenarioActionWhere>;
};

export type QueryScenarioActionsAggregateArgs = {
	where?: InputMaybe<ScenarioActionWhere>;
};

export type QueryScenarioActionsCountArgs = {
	where?: InputMaybe<ScenarioActionWhere>;
};

export type QueryScenarioConditionsArgs = {
	options?: InputMaybe<ScenarioConditionOptions>;
	where?: InputMaybe<ScenarioConditionWhere>;
};

export type QueryScenarioConditionsAggregateArgs = {
	where?: InputMaybe<ScenarioConditionWhere>;
};

export type QueryScenarioConditionsCountArgs = {
	where?: InputMaybe<ScenarioConditionWhere>;
};

export type QueryScenariosArgs = {
	options?: InputMaybe<ScenarioOptions>;
	where?: InputMaybe<ScenarioWhere>;
};

export type QueryScenariosAggregateArgs = {
	where?: InputMaybe<ScenarioWhere>;
};

export type QueryScenariosCountArgs = {
	where?: InputMaybe<ScenarioWhere>;
};

export type QueryStobActionsArgs = {
	options?: InputMaybe<StobActionOptions>;
	where?: InputMaybe<StobActionWhere>;
};

export type QueryStobActionsAggregateArgs = {
	where?: InputMaybe<StobActionWhere>;
};

export type QueryStobActionsCountArgs = {
	where?: InputMaybe<StobActionWhere>;
};

export type QueryStobConditionsArgs = {
	options?: InputMaybe<StobConditionOptions>;
	where?: InputMaybe<StobConditionWhere>;
};

export type QueryStobConditionsAggregateArgs = {
	where?: InputMaybe<StobConditionWhere>;
};

export type QueryStobConditionsCountArgs = {
	where?: InputMaybe<StobConditionWhere>;
};

export type QueryStobContractsArgs = {
	options?: InputMaybe<StobContractOptions>;
	where?: InputMaybe<StobContractWhere>;
};

export type QueryStobContractsAggregateArgs = {
	where?: InputMaybe<StobContractWhere>;
};

export type QueryStobContractsCountArgs = {
	where?: InputMaybe<StobContractWhere>;
};

export type QueryStobScenariosArgs = {
	options?: InputMaybe<StobScenarioOptions>;
	where?: InputMaybe<StobScenarioWhere>;
};

export type QueryStobScenariosAggregateArgs = {
	where?: InputMaybe<StobScenarioWhere>;
};

export type QueryStobScenariosCountArgs = {
	where?: InputMaybe<StobScenarioWhere>;
};

export type QueryStobStatisticsArgs = {
	options?: InputMaybe<StobStatisticsOptions>;
	where?: InputMaybe<StobStatisticsWhere>;
};

export type QueryStobStatisticsAggregateArgs = {
	where?: InputMaybe<StobStatisticsWhere>;
};

export type QueryStobStatisticsCountArgs = {
	where?: InputMaybe<StobStatisticsWhere>;
};

export type QueryTasksArgs = {
	options?: InputMaybe<TaskOptions>;
	where?: InputMaybe<TaskWhere>;
};

export type QueryTasksAggregateArgs = {
	where?: InputMaybe<TaskWhere>;
};

export type QueryTasksCountArgs = {
	where?: InputMaybe<TaskWhere>;
};

export type QueryTimeframesArgs = {
	options?: InputMaybe<TimeframeOptions>;
	where?: InputMaybe<TimeframeWhere>;
};

export type QueryTimeframesAggregateArgs = {
	where?: InputMaybe<TimeframeWhere>;
};

export type QueryTimeframesCountArgs = {
	where?: InputMaybe<TimeframeWhere>;
};

export type QueryTranslationsArgs = {
	options?: InputMaybe<TranslationOptions>;
	where?: InputMaybe<TranslationWhere>;
};

export type QueryTranslationsAggregateArgs = {
	where?: InputMaybe<TranslationWhere>;
};

export type QueryTranslationsCountArgs = {
	where?: InputMaybe<TranslationWhere>;
};

export type QueryTranslationsResultsArgs = {
	options?: InputMaybe<TranslationsResultOptions>;
	where?: InputMaybe<TranslationsResultWhere>;
};

export type QueryTranslationsResultsAggregateArgs = {
	where?: InputMaybe<TranslationsResultWhere>;
};

export type QueryTranslationsResultsCountArgs = {
	where?: InputMaybe<TranslationsResultWhere>;
};

export type QueryTreatingPhysiciansArgs = {
	options?: InputMaybe<TreatingPhysicianOptions>;
	where?: InputMaybe<TreatingPhysicianWhere>;
};

export type QueryTreatingPhysiciansAggregateArgs = {
	where?: InputMaybe<TreatingPhysicianWhere>;
};

export type QueryTreatingPhysiciansCountArgs = {
	where?: InputMaybe<TreatingPhysicianWhere>;
};

export type QueryTreatmentPatientsArgs = {
	options?: InputMaybe<TreatmentPatientOptions>;
	where?: InputMaybe<TreatmentPatientWhere>;
};

export type QueryTreatmentPatientsAggregateArgs = {
	where?: InputMaybe<TreatmentPatientWhere>;
};

export type QueryTreatmentPatientsCountArgs = {
	where?: InputMaybe<TreatmentPatientWhere>;
};

export type QueryTreatmentsArgs = {
	options?: InputMaybe<TreatmentOptions>;
	where?: InputMaybe<TreatmentWhere>;
};

export type QueryTreatmentsAggregateArgs = {
	where?: InputMaybe<TreatmentWhere>;
};

export type QueryTreatmentsCountArgs = {
	where?: InputMaybe<TreatmentWhere>;
};

export type QueryUserContextsArgs = {
	options?: InputMaybe<UserContextOptions>;
	where?: InputMaybe<UserContextWhere>;
};

export type QueryUserContextsAggregateArgs = {
	where?: InputMaybe<UserContextWhere>;
};

export type QueryUserContextsCountArgs = {
	where?: InputMaybe<UserContextWhere>;
};

export type QueryUserOrgSettingsDataArgs = {
	options?: InputMaybe<UserOrgSettingsDataOptions>;
	where?: InputMaybe<UserOrgSettingsDataWhere>;
};

export type QueryUserOrgSettingsDataAggregateArgs = {
	where?: InputMaybe<UserOrgSettingsDataWhere>;
};

export type QueryUserOrgSettingsDataCountArgs = {
	where?: InputMaybe<UserOrgSettingsDataWhere>;
};

export type QueryUserOrganizationInfosArgs = {
	options?: InputMaybe<UserOrganizationInfoOptions>;
	where?: InputMaybe<UserOrganizationInfoWhere>;
};

export type QueryUserOrganizationInfosAggregateArgs = {
	where?: InputMaybe<UserOrganizationInfoWhere>;
};

export type QueryUserOrganizationInfosCountArgs = {
	where?: InputMaybe<UserOrganizationInfoWhere>;
};

export type QueryUserPersonalInfosArgs = {
	options?: InputMaybe<UserPersonalInfoOptions>;
	where?: InputMaybe<UserPersonalInfoWhere>;
};

export type QueryUserPersonalInfosAggregateArgs = {
	where?: InputMaybe<UserPersonalInfoWhere>;
};

export type QueryUserPersonalInfosCountArgs = {
	where?: InputMaybe<UserPersonalInfoWhere>;
};

export type QueryUsersArgs = {
	options?: InputMaybe<UserOptions>;
	where?: InputMaybe<UserWhere>;
};

export type QueryUsersAggregateArgs = {
	where?: InputMaybe<UserWhere>;
};

export type QueryUsersCountArgs = {
	where?: InputMaybe<UserWhere>;
};

export type ReasonOfTreatmentDiscontinuationReport = {
	__typename?: "ReasonOfTreatmentDiscontinuationReport";
	count?: Maybe<Scalars["Int"]>;
	result?: Maybe<ReasonsForDiscontinuation>;
};

export type ReasonOfTreatmentDiscontinuationReportAggregateSelection = {
	__typename?: "ReasonOfTreatmentDiscontinuationReportAggregateSelection";
	count: IntAggregateSelection;
};

export type ReasonOfTreatmentDiscontinuationReportCreateInput = {
	count?: InputMaybe<Scalars["Int"]>;
	result?: InputMaybe<ReasonsForDiscontinuation>;
};

export type ReasonOfTreatmentDiscontinuationReportOptions = {
	limit?: InputMaybe<Scalars["Int"]>;
	offset?: InputMaybe<Scalars["Int"]>;
	/** Specify one or more ReasonOfTreatmentDiscontinuationReportSort objects to sort ReasonOfTreatmentDiscontinuationReports by. The sorts will be applied in the order in which they are arranged in the array. */
	sort?: InputMaybe<Array<InputMaybe<ReasonOfTreatmentDiscontinuationReportSort>>>;
};

/** Fields to sort ReasonOfTreatmentDiscontinuationReports by. The order in which sorts are applied is not guaranteed when specifying many fields in one ReasonOfTreatmentDiscontinuationReportSort object. */
export type ReasonOfTreatmentDiscontinuationReportSort = {
	count?: InputMaybe<SortDirection>;
	result?: InputMaybe<SortDirection>;
};

export type ReasonOfTreatmentDiscontinuationReportUpdateInput = {
	count?: InputMaybe<Scalars["Int"]>;
	result?: InputMaybe<ReasonsForDiscontinuation>;
};

export type ReasonOfTreatmentDiscontinuationReportWhere = {
	AND?: InputMaybe<Array<ReasonOfTreatmentDiscontinuationReportWhere>>;
	OR?: InputMaybe<Array<ReasonOfTreatmentDiscontinuationReportWhere>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	count_NOT?: InputMaybe<Scalars["Int"]>;
	count_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	result?: InputMaybe<ReasonsForDiscontinuation>;
	result_IN?: InputMaybe<Array<InputMaybe<ReasonsForDiscontinuation>>>;
	result_NOT?: InputMaybe<ReasonsForDiscontinuation>;
	result_NOT_IN?: InputMaybe<Array<InputMaybe<ReasonsForDiscontinuation>>>;
};

export enum ReasonsForDiscontinuation {
	AdverseEvent = "ADVERSE_EVENT",
	Death = "DEATH",
	NoInfo = "NO_INFO",
	ProgressiveDisease = "PROGRESSIVE_DISEASE",
}

export type RecallToDraftInput = {
	invoiceId: Scalars["ID"];
};

export type RecommendedForm = IOrdered &
	TimeframeRelatedEntity & {
		__typename?: "RecommendedForm";
		formType?: Maybe<FormType>;
		order: Scalars["Int"];
		timeframeEnd?: Maybe<Scalars["Int"]>;
		timeframeRelation: StobTimeframeRelation;
		timeframeStart: Scalars["Int"];
		timeframeStartingPoint: StobTimeframeStartingPoint;
	};

export type RecommendedFormAggregateSelection = {
	__typename?: "RecommendedFormAggregateSelection";
	count: Scalars["Int"];
	order: IntAggregateSelection;
	timeframeEnd: IntAggregateSelection;
	timeframeStart: IntAggregateSelection;
};

export type RecommendedFormConnectWhere = {
	node: RecommendedFormWhere;
};

export type RecommendedFormCreateInput = {
	formType?: InputMaybe<FormType>;
	order: Scalars["Int"];
	timeframeEnd?: InputMaybe<Scalars["Int"]>;
	timeframeRelation: StobTimeframeRelation;
	timeframeStart: Scalars["Int"];
	timeframeStartingPoint: StobTimeframeStartingPoint;
};

export type RecommendedFormInput = {
	formType?: InputMaybe<FormType>;
	order: Scalars["Int"];
	timeframeEnd?: InputMaybe<Scalars["Int"]>;
	timeframeRelation: StobTimeframeRelation;
	timeframeStart?: InputMaybe<Scalars["Int"]>;
	timeframeStartingPoint: StobTimeframeStartingPoint;
};

export type RecommendedFormOptions = {
	limit?: InputMaybe<Scalars["Int"]>;
	offset?: InputMaybe<Scalars["Int"]>;
	/** Specify one or more RecommendedFormSort objects to sort RecommendedForms by. The sorts will be applied in the order in which they are arranged in the array. */
	sort?: InputMaybe<Array<InputMaybe<RecommendedFormSort>>>;
};

/** Fields to sort RecommendedForms by. The order in which sorts are applied is not guaranteed when specifying many fields in one RecommendedFormSort object. */
export type RecommendedFormSort = {
	formType?: InputMaybe<SortDirection>;
	order?: InputMaybe<SortDirection>;
	timeframeEnd?: InputMaybe<SortDirection>;
	timeframeRelation?: InputMaybe<SortDirection>;
	timeframeStart?: InputMaybe<SortDirection>;
	timeframeStartingPoint?: InputMaybe<SortDirection>;
};

export type RecommendedFormUpdateInput = {
	formType?: InputMaybe<FormType>;
	order?: InputMaybe<Scalars["Int"]>;
	timeframeEnd?: InputMaybe<Scalars["Int"]>;
	timeframeRelation?: InputMaybe<StobTimeframeRelation>;
	timeframeStart?: InputMaybe<Scalars["Int"]>;
	timeframeStartingPoint?: InputMaybe<StobTimeframeStartingPoint>;
};

export type RecommendedFormWhere = {
	AND?: InputMaybe<Array<RecommendedFormWhere>>;
	OR?: InputMaybe<Array<RecommendedFormWhere>>;
	formType?: InputMaybe<FormType>;
	formType_IN?: InputMaybe<Array<InputMaybe<FormType>>>;
	formType_NOT?: InputMaybe<FormType>;
	formType_NOT_IN?: InputMaybe<Array<InputMaybe<FormType>>>;
	order?: InputMaybe<Scalars["Int"]>;
	order_GT?: InputMaybe<Scalars["Int"]>;
	order_GTE?: InputMaybe<Scalars["Int"]>;
	order_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	order_LT?: InputMaybe<Scalars["Int"]>;
	order_LTE?: InputMaybe<Scalars["Int"]>;
	order_NOT?: InputMaybe<Scalars["Int"]>;
	order_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	timeframeEnd?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_GT?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_GTE?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	timeframeEnd_LT?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_LTE?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_NOT?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	timeframeRelation?: InputMaybe<StobTimeframeRelation>;
	timeframeRelation_IN?: InputMaybe<Array<InputMaybe<StobTimeframeRelation>>>;
	timeframeRelation_NOT?: InputMaybe<StobTimeframeRelation>;
	timeframeRelation_NOT_IN?: InputMaybe<Array<InputMaybe<StobTimeframeRelation>>>;
	timeframeStart?: InputMaybe<Scalars["Int"]>;
	timeframeStart_GT?: InputMaybe<Scalars["Int"]>;
	timeframeStart_GTE?: InputMaybe<Scalars["Int"]>;
	timeframeStart_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	timeframeStart_LT?: InputMaybe<Scalars["Int"]>;
	timeframeStart_LTE?: InputMaybe<Scalars["Int"]>;
	timeframeStart_NOT?: InputMaybe<Scalars["Int"]>;
	timeframeStart_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	timeframeStartingPoint?: InputMaybe<StobTimeframeStartingPoint>;
	timeframeStartingPoint_IN?: InputMaybe<Array<InputMaybe<StobTimeframeStartingPoint>>>;
	timeframeStartingPoint_NOT?: InputMaybe<StobTimeframeStartingPoint>;
	timeframeStartingPoint_NOT_IN?: InputMaybe<Array<InputMaybe<StobTimeframeStartingPoint>>>;
};

export type Record = {
	__typename?: "Record";
	administrationDate?: Maybe<Scalars["DateTime"]>;
	claimId?: Maybe<Scalars["String"]>;
	createdBy?: Maybe<Scalars["String"]>;
	createdByName?: Maybe<Scalars["String"]>;
	createdOn: Scalars["DateTime"];
	deviceRecord?: Maybe<DeviceRecord>;
	deviceRecordConnection: RecordDeviceRecordConnection;
	id: Scalars["ID"];
	insuranceId?: Maybe<Scalars["String"]>;
	invoiceDate?: Maybe<Scalars["DateTime"]>;
	invoiceNumber?: Maybe<Scalars["String"]>;
	isArchived: Scalars["Boolean"];
	isDeleted: Scalars["Boolean"];
	occurrence?: Maybe<OccurrenceEnum>;
	preparationBrandNames?: Maybe<Scalars["String"]>;
	preparationGenericNames?: Maybe<Scalars["String"]>;
	preparationId?: Maybe<Scalars["String"]>;
	prescriptionDate?: Maybe<Scalars["Date"]>;
	quantity?: Maybe<Scalars["Int"]>;
	status?: Maybe<FlexFormStatus>;
	tenantId: Scalars["String"];
	treatmentName?: Maybe<Scalars["String"]>;
	type?: Maybe<RecordsTypeEnum>;
	unlimited?: Maybe<Scalars["Int"]>;
	uuid?: Maybe<Scalars["String"]>;
};

export type RecordDeviceRecordArgs = {
	options?: InputMaybe<DeviceRecordOptions>;
	where?: InputMaybe<DeviceRecordWhere>;
};

export type RecordDeviceRecordConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<RecordDeviceRecordConnectionSort>>;
	where?: InputMaybe<RecordDeviceRecordConnectionWhere>;
};

export type RecordAggregateSelection = {
	__typename?: "RecordAggregateSelection";
	administrationDate: DateTimeAggregateSelection;
	claimId: StringAggregateSelection;
	count: Scalars["Int"];
	createdBy: StringAggregateSelection;
	createdByName: StringAggregateSelection;
	createdOn: DateTimeAggregateSelection;
	id: IdAggregateSelection;
	insuranceId: StringAggregateSelection;
	invoiceDate: DateTimeAggregateSelection;
	invoiceNumber: StringAggregateSelection;
	preparationBrandNames: StringAggregateSelection;
	preparationGenericNames: StringAggregateSelection;
	preparationId: StringAggregateSelection;
	quantity: IntAggregateSelection;
	tenantId: StringAggregateSelection;
	treatmentName: StringAggregateSelection;
	unlimited: IntAggregateSelection;
	uuid: StringAggregateSelection;
};

export type RecordBatch = {
	__typename?: "RecordBatch";
	createdOn?: Maybe<Scalars["DateTime"]>;
	evaluationSnapshot?: Maybe<Scalars["String"]>;
	financialDataPoints: Array<FlexFinancialDataPoint>;
	financialDataPointsConnection: RecordBatchFinancialDataPointsConnection;
	status: RecordBatchStatus;
};

export type RecordBatchFinancialDataPointsArgs = {
	options?: InputMaybe<FlexFinancialDataPointOptions>;
	where?: InputMaybe<FlexFinancialDataPointWhere>;
};

export type RecordBatchFinancialDataPointsConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<RecordBatchFinancialDataPointsConnectionSort>>;
	where?: InputMaybe<RecordBatchFinancialDataPointsConnectionWhere>;
};

export type RecordBatchAggregateSelection = {
	__typename?: "RecordBatchAggregateSelection";
	count: Scalars["Int"];
	createdOn: DateTimeAggregateSelection;
	evaluationSnapshot: StringAggregateSelection;
};

export type RecordBatchConnectInput = {
	financialDataPoints?: InputMaybe<Array<RecordBatchFinancialDataPointsConnectFieldInput>>;
};

export type RecordBatchConnectWhere = {
	node: RecordBatchWhere;
};

export type RecordBatchCreateInput = {
	createdOn?: InputMaybe<Scalars["DateTime"]>;
	evaluationSnapshot?: InputMaybe<Scalars["String"]>;
	financialDataPoints?: InputMaybe<RecordBatchFinancialDataPointsFieldInput>;
	status: RecordBatchStatus;
};

export type RecordBatchDeleteInput = {
	financialDataPoints?: InputMaybe<Array<RecordBatchFinancialDataPointsDeleteFieldInput>>;
};

export type RecordBatchDisconnectInput = {
	financialDataPoints?: InputMaybe<Array<RecordBatchFinancialDataPointsDisconnectFieldInput>>;
};

export type RecordBatchFinancialDataPointsAggregateInput = {
	AND?: InputMaybe<Array<RecordBatchFinancialDataPointsAggregateInput>>;
	OR?: InputMaybe<Array<RecordBatchFinancialDataPointsAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<RecordBatchFinancialDataPointsNodeAggregationWhereInput>;
};

export type RecordBatchFinancialDataPointsConnectFieldInput = {
	connect?: InputMaybe<Array<FlexFinancialDataPointConnectInput>>;
	where?: InputMaybe<FlexFinancialDataPointConnectWhere>;
};

export type RecordBatchFinancialDataPointsConnection = {
	__typename?: "RecordBatchFinancialDataPointsConnection";
	edges: Array<RecordBatchFinancialDataPointsRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type RecordBatchFinancialDataPointsConnectionSort = {
	node?: InputMaybe<FlexFinancialDataPointSort>;
};

export type RecordBatchFinancialDataPointsConnectionWhere = {
	AND?: InputMaybe<Array<RecordBatchFinancialDataPointsConnectionWhere>>;
	OR?: InputMaybe<Array<RecordBatchFinancialDataPointsConnectionWhere>>;
	node?: InputMaybe<FlexFinancialDataPointWhere>;
	node_NOT?: InputMaybe<FlexFinancialDataPointWhere>;
};

export type RecordBatchFinancialDataPointsCreateFieldInput = {
	node: FlexFinancialDataPointCreateInput;
};

export type RecordBatchFinancialDataPointsDeleteFieldInput = {
	delete?: InputMaybe<FlexFinancialDataPointDeleteInput>;
	where?: InputMaybe<RecordBatchFinancialDataPointsConnectionWhere>;
};

export type RecordBatchFinancialDataPointsDisconnectFieldInput = {
	disconnect?: InputMaybe<FlexFinancialDataPointDisconnectInput>;
	where?: InputMaybe<RecordBatchFinancialDataPointsConnectionWhere>;
};

export type RecordBatchFinancialDataPointsFieldInput = {
	connect?: InputMaybe<Array<RecordBatchFinancialDataPointsConnectFieldInput>>;
	create?: InputMaybe<Array<RecordBatchFinancialDataPointsCreateFieldInput>>;
};

export type RecordBatchFinancialDataPointsNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<RecordBatchFinancialDataPointsNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<RecordBatchFinancialDataPointsNodeAggregationWhereInput>>;
	basePrice_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	basePrice_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	basePrice_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	basePrice_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	basePrice_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	basePrice_EQUAL?: InputMaybe<Scalars["Float"]>;
	basePrice_GT?: InputMaybe<Scalars["Float"]>;
	basePrice_GTE?: InputMaybe<Scalars["Float"]>;
	basePrice_LT?: InputMaybe<Scalars["Float"]>;
	basePrice_LTE?: InputMaybe<Scalars["Float"]>;
	basePrice_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	basePrice_MAX_GT?: InputMaybe<Scalars["Float"]>;
	basePrice_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	basePrice_MAX_LT?: InputMaybe<Scalars["Float"]>;
	basePrice_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	basePrice_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	basePrice_MIN_GT?: InputMaybe<Scalars["Float"]>;
	basePrice_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	basePrice_MIN_LT?: InputMaybe<Scalars["Float"]>;
	basePrice_MIN_LTE?: InputMaybe<Scalars["Float"]>;
	currencyCode_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	currencyCode_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	currencyCode_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	currencyCode_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	currencyCode_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	currencyCode_EQUAL?: InputMaybe<Scalars["String"]>;
	currencyCode_GT?: InputMaybe<Scalars["Int"]>;
	currencyCode_GTE?: InputMaybe<Scalars["Int"]>;
	currencyCode_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	currencyCode_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	currencyCode_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	currencyCode_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	currencyCode_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	currencyCode_LT?: InputMaybe<Scalars["Int"]>;
	currencyCode_LTE?: InputMaybe<Scalars["Int"]>;
	currencyCode_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	currencyCode_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	currencyCode_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	currencyCode_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	currencyCode_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	evaluationSnapshot_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	evaluationSnapshot_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	evaluationSnapshot_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	evaluationSnapshot_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	evaluationSnapshot_EQUAL?: InputMaybe<Scalars["String"]>;
	evaluationSnapshot_GT?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_GTE?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_LT?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_LTE?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	generatedUuid_EQUAL?: InputMaybe<Scalars["ID"]>;
	payablePercentage_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	payablePercentage_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	payablePercentage_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	payablePercentage_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	payablePercentage_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	payablePercentage_EQUAL?: InputMaybe<Scalars["Float"]>;
	payablePercentage_GT?: InputMaybe<Scalars["Float"]>;
	payablePercentage_GTE?: InputMaybe<Scalars["Float"]>;
	payablePercentage_LT?: InputMaybe<Scalars["Float"]>;
	payablePercentage_LTE?: InputMaybe<Scalars["Float"]>;
	payablePercentage_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	payablePercentage_MAX_GT?: InputMaybe<Scalars["Float"]>;
	payablePercentage_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	payablePercentage_MAX_LT?: InputMaybe<Scalars["Float"]>;
	payablePercentage_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	payablePercentage_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	payablePercentage_MIN_GT?: InputMaybe<Scalars["Float"]>;
	payablePercentage_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	payablePercentage_MIN_LT?: InputMaybe<Scalars["Float"]>;
	payablePercentage_MIN_LTE?: InputMaybe<Scalars["Float"]>;
	payable_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	payable_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	payable_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	payable_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	payable_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	payable_EQUAL?: InputMaybe<Scalars["Float"]>;
	payable_GT?: InputMaybe<Scalars["Float"]>;
	payable_GTE?: InputMaybe<Scalars["Float"]>;
	payable_LT?: InputMaybe<Scalars["Float"]>;
	payable_LTE?: InputMaybe<Scalars["Float"]>;
	payable_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	payable_MAX_GT?: InputMaybe<Scalars["Float"]>;
	payable_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	payable_MAX_LT?: InputMaybe<Scalars["Float"]>;
	payable_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	payable_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	payable_MIN_GT?: InputMaybe<Scalars["Float"]>;
	payable_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	payable_MIN_LT?: InputMaybe<Scalars["Float"]>;
	payable_MIN_LTE?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	quantity_EQUAL?: InputMaybe<Scalars["Float"]>;
	quantity_GT?: InputMaybe<Scalars["Float"]>;
	quantity_GTE?: InputMaybe<Scalars["Float"]>;
	quantity_LT?: InputMaybe<Scalars["Float"]>;
	quantity_LTE?: InputMaybe<Scalars["Float"]>;
	quantity_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	quantity_MAX_GT?: InputMaybe<Scalars["Float"]>;
	quantity_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	quantity_MAX_LT?: InputMaybe<Scalars["Float"]>;
	quantity_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	quantity_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	quantity_MIN_GT?: InputMaybe<Scalars["Float"]>;
	quantity_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	quantity_MIN_LT?: InputMaybe<Scalars["Float"]>;
	quantity_MIN_LTE?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_EQUAL?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_GT?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_GTE?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_LT?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_LTE?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_MAX_GT?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_MAX_LT?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_MIN_GT?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_MIN_LT?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_MIN_LTE?: InputMaybe<Scalars["Float"]>;
	refundable_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	refundable_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	refundable_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	refundable_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	refundable_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	refundable_EQUAL?: InputMaybe<Scalars["Float"]>;
	refundable_GT?: InputMaybe<Scalars["Float"]>;
	refundable_GTE?: InputMaybe<Scalars["Float"]>;
	refundable_LT?: InputMaybe<Scalars["Float"]>;
	refundable_LTE?: InputMaybe<Scalars["Float"]>;
	refundable_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	refundable_MAX_GT?: InputMaybe<Scalars["Float"]>;
	refundable_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	refundable_MAX_LT?: InputMaybe<Scalars["Float"]>;
	refundable_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	refundable_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	refundable_MIN_GT?: InputMaybe<Scalars["Float"]>;
	refundable_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	refundable_MIN_LT?: InputMaybe<Scalars["Float"]>;
	refundable_MIN_LTE?: InputMaybe<Scalars["Float"]>;
	uuid_EQUAL?: InputMaybe<Scalars["ID"]>;
	variablePercentage_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	variablePercentage_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	variablePercentage_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	variablePercentage_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	variablePercentage_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	variablePercentage_EQUAL?: InputMaybe<Scalars["Float"]>;
	variablePercentage_GT?: InputMaybe<Scalars["Float"]>;
	variablePercentage_GTE?: InputMaybe<Scalars["Float"]>;
	variablePercentage_LT?: InputMaybe<Scalars["Float"]>;
	variablePercentage_LTE?: InputMaybe<Scalars["Float"]>;
	variablePercentage_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	variablePercentage_MAX_GT?: InputMaybe<Scalars["Float"]>;
	variablePercentage_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	variablePercentage_MAX_LT?: InputMaybe<Scalars["Float"]>;
	variablePercentage_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	variablePercentage_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	variablePercentage_MIN_GT?: InputMaybe<Scalars["Float"]>;
	variablePercentage_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	variablePercentage_MIN_LT?: InputMaybe<Scalars["Float"]>;
	variablePercentage_MIN_LTE?: InputMaybe<Scalars["Float"]>;
	variable_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	variable_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	variable_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	variable_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	variable_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	variable_EQUAL?: InputMaybe<Scalars["Float"]>;
	variable_GT?: InputMaybe<Scalars["Float"]>;
	variable_GTE?: InputMaybe<Scalars["Float"]>;
	variable_LT?: InputMaybe<Scalars["Float"]>;
	variable_LTE?: InputMaybe<Scalars["Float"]>;
	variable_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	variable_MAX_GT?: InputMaybe<Scalars["Float"]>;
	variable_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	variable_MAX_LT?: InputMaybe<Scalars["Float"]>;
	variable_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	variable_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	variable_MIN_GT?: InputMaybe<Scalars["Float"]>;
	variable_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	variable_MIN_LT?: InputMaybe<Scalars["Float"]>;
	variable_MIN_LTE?: InputMaybe<Scalars["Float"]>;
};

export type RecordBatchFinancialDataPointsRelationship = {
	__typename?: "RecordBatchFinancialDataPointsRelationship";
	cursor: Scalars["String"];
	node: FlexFinancialDataPoint;
};

export type RecordBatchFinancialDataPointsUpdateConnectionInput = {
	node?: InputMaybe<FlexFinancialDataPointUpdateInput>;
};

export type RecordBatchFinancialDataPointsUpdateFieldInput = {
	connect?: InputMaybe<Array<RecordBatchFinancialDataPointsConnectFieldInput>>;
	create?: InputMaybe<Array<RecordBatchFinancialDataPointsCreateFieldInput>>;
	delete?: InputMaybe<Array<RecordBatchFinancialDataPointsDeleteFieldInput>>;
	disconnect?: InputMaybe<Array<RecordBatchFinancialDataPointsDisconnectFieldInput>>;
	update?: InputMaybe<RecordBatchFinancialDataPointsUpdateConnectionInput>;
	where?: InputMaybe<RecordBatchFinancialDataPointsConnectionWhere>;
};

export type RecordBatchOptions = {
	limit?: InputMaybe<Scalars["Int"]>;
	offset?: InputMaybe<Scalars["Int"]>;
	/** Specify one or more RecordBatchSort objects to sort RecordBatches by. The sorts will be applied in the order in which they are arranged in the array. */
	sort?: InputMaybe<Array<InputMaybe<RecordBatchSort>>>;
};

/** Fields to sort RecordBatches by. The order in which sorts are applied is not guaranteed when specifying many fields in one RecordBatchSort object. */
export type RecordBatchSort = {
	createdOn?: InputMaybe<SortDirection>;
	evaluationSnapshot?: InputMaybe<SortDirection>;
	status?: InputMaybe<SortDirection>;
};

export enum RecordBatchStatus {
	Closed = "CLOSED",
	Open = "OPEN",
}

export type RecordBatchUpdateInput = {
	createdOn?: InputMaybe<Scalars["DateTime"]>;
	evaluationSnapshot?: InputMaybe<Scalars["String"]>;
	financialDataPoints?: InputMaybe<Array<RecordBatchFinancialDataPointsUpdateFieldInput>>;
	status?: InputMaybe<RecordBatchStatus>;
};

export type RecordBatchWhere = {
	AND?: InputMaybe<Array<RecordBatchWhere>>;
	OR?: InputMaybe<Array<RecordBatchWhere>>;
	createdOn?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_IN?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]>>>;
	createdOn_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_NOT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]>>>;
	evaluationSnapshot?: InputMaybe<Scalars["String"]>;
	evaluationSnapshot_CONTAINS?: InputMaybe<Scalars["String"]>;
	evaluationSnapshot_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	evaluationSnapshot_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	evaluationSnapshot_MATCHES?: InputMaybe<Scalars["String"]>;
	evaluationSnapshot_NOT?: InputMaybe<Scalars["String"]>;
	evaluationSnapshot_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	evaluationSnapshot_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	evaluationSnapshot_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	evaluationSnapshot_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	evaluationSnapshot_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	financialDataPoints?: InputMaybe<FlexFinancialDataPointWhere>;
	financialDataPointsAggregate?: InputMaybe<RecordBatchFinancialDataPointsAggregateInput>;
	financialDataPointsConnection?: InputMaybe<RecordBatchFinancialDataPointsConnectionWhere>;
	financialDataPointsConnection_NOT?: InputMaybe<RecordBatchFinancialDataPointsConnectionWhere>;
	financialDataPoints_NOT?: InputMaybe<FlexFinancialDataPointWhere>;
	status?: InputMaybe<RecordBatchStatus>;
	status_IN?: InputMaybe<Array<InputMaybe<RecordBatchStatus>>>;
	status_NOT?: InputMaybe<RecordBatchStatus>;
	status_NOT_IN?: InputMaybe<Array<InputMaybe<RecordBatchStatus>>>;
};

export type RecordConnectInput = {
	deviceRecord?: InputMaybe<RecordDeviceRecordConnectFieldInput>;
};

export type RecordConnectWhere = {
	node: RecordWhere;
};

export type RecordCreateInput = {
	administrationDate?: InputMaybe<Scalars["DateTime"]>;
	claimId?: InputMaybe<Scalars["String"]>;
	createdBy?: InputMaybe<Scalars["String"]>;
	createdByName?: InputMaybe<Scalars["String"]>;
	createdOn: Scalars["DateTime"];
	deviceRecord?: InputMaybe<RecordDeviceRecordFieldInput>;
	id: Scalars["ID"];
	insuranceId?: InputMaybe<Scalars["String"]>;
	invoiceDate?: InputMaybe<Scalars["DateTime"]>;
	invoiceNumber?: InputMaybe<Scalars["String"]>;
	isArchived: Scalars["Boolean"];
	isDeleted: Scalars["Boolean"];
	occurrence?: InputMaybe<OccurrenceEnum>;
	preparationBrandNames?: InputMaybe<Scalars["String"]>;
	preparationGenericNames?: InputMaybe<Scalars["String"]>;
	preparationId?: InputMaybe<Scalars["String"]>;
	prescriptionDate?: InputMaybe<Scalars["Date"]>;
	quantity?: InputMaybe<Scalars["Int"]>;
	status?: InputMaybe<FlexFormStatus>;
	tenantId: Scalars["String"];
	treatmentName?: InputMaybe<Scalars["String"]>;
	type?: InputMaybe<RecordsTypeEnum>;
	unlimited?: InputMaybe<Scalars["Int"]>;
	uuid?: InputMaybe<Scalars["String"]>;
};

export type RecordDeleteInput = {
	deviceRecord?: InputMaybe<RecordDeviceRecordDeleteFieldInput>;
};

export type RecordDeviceRecordAggregateInput = {
	AND?: InputMaybe<Array<RecordDeviceRecordAggregateInput>>;
	OR?: InputMaybe<Array<RecordDeviceRecordAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<RecordDeviceRecordNodeAggregationWhereInput>;
};

export type RecordDeviceRecordConnectFieldInput = {
	connect?: InputMaybe<DeviceRecordConnectInput>;
	where?: InputMaybe<DeviceRecordConnectWhere>;
};

export type RecordDeviceRecordConnection = {
	__typename?: "RecordDeviceRecordConnection";
	edges: Array<RecordDeviceRecordRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type RecordDeviceRecordConnectionSort = {
	node?: InputMaybe<DeviceRecordSort>;
};

export type RecordDeviceRecordConnectionWhere = {
	AND?: InputMaybe<Array<RecordDeviceRecordConnectionWhere>>;
	OR?: InputMaybe<Array<RecordDeviceRecordConnectionWhere>>;
	node?: InputMaybe<DeviceRecordWhere>;
	node_NOT?: InputMaybe<DeviceRecordWhere>;
};

export type RecordDeviceRecordCreateFieldInput = {
	node: DeviceRecordCreateInput;
};

export type RecordDeviceRecordDeleteFieldInput = {
	delete?: InputMaybe<DeviceRecordDeleteInput>;
	where?: InputMaybe<RecordDeviceRecordConnectionWhere>;
};

export type RecordDeviceRecordDisconnectFieldInput = {
	disconnect?: InputMaybe<DeviceRecordDisconnectInput>;
	where?: InputMaybe<RecordDeviceRecordConnectionWhere>;
};

export type RecordDeviceRecordFieldInput = {
	connect?: InputMaybe<RecordDeviceRecordConnectFieldInput>;
	create?: InputMaybe<RecordDeviceRecordCreateFieldInput>;
};

export type RecordDeviceRecordNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<RecordDeviceRecordNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<RecordDeviceRecordNodeAggregationWhereInput>>;
	deviceId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	deviceId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	deviceId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	deviceId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	deviceId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	deviceId_EQUAL?: InputMaybe<Scalars["String"]>;
	deviceId_GT?: InputMaybe<Scalars["Int"]>;
	deviceId_GTE?: InputMaybe<Scalars["Int"]>;
	deviceId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	deviceId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	deviceId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	deviceId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	deviceId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	deviceId_LT?: InputMaybe<Scalars["Int"]>;
	deviceId_LTE?: InputMaybe<Scalars["Int"]>;
	deviceId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	deviceId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	deviceId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	deviceId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	deviceId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	deviceRef_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	deviceRef_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	deviceRef_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	deviceRef_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	deviceRef_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	deviceRef_EQUAL?: InputMaybe<Scalars["String"]>;
	deviceRef_GT?: InputMaybe<Scalars["Int"]>;
	deviceRef_GTE?: InputMaybe<Scalars["Int"]>;
	deviceRef_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	deviceRef_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	deviceRef_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	deviceRef_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	deviceRef_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	deviceRef_LT?: InputMaybe<Scalars["Int"]>;
	deviceRef_LTE?: InputMaybe<Scalars["Int"]>;
	deviceRef_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	deviceRef_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	deviceRef_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	deviceRef_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	deviceRef_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	invoicedSales_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	invoicedSales_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	invoicedSales_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	invoicedSales_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	invoicedSales_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	invoicedSales_EQUAL?: InputMaybe<Scalars["Float"]>;
	invoicedSales_GT?: InputMaybe<Scalars["Float"]>;
	invoicedSales_GTE?: InputMaybe<Scalars["Float"]>;
	invoicedSales_LT?: InputMaybe<Scalars["Float"]>;
	invoicedSales_LTE?: InputMaybe<Scalars["Float"]>;
	invoicedSales_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	invoicedSales_MAX_GT?: InputMaybe<Scalars["Float"]>;
	invoicedSales_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	invoicedSales_MAX_LT?: InputMaybe<Scalars["Float"]>;
	invoicedSales_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	invoicedSales_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	invoicedSales_MIN_GT?: InputMaybe<Scalars["Float"]>;
	invoicedSales_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	invoicedSales_MIN_LT?: InputMaybe<Scalars["Float"]>;
	invoicedSales_MIN_LTE?: InputMaybe<Scalars["Float"]>;
	orderLineNumber_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	orderLineNumber_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	orderLineNumber_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	orderLineNumber_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	orderLineNumber_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	orderLineNumber_EQUAL?: InputMaybe<Scalars["Int"]>;
	orderLineNumber_GT?: InputMaybe<Scalars["Int"]>;
	orderLineNumber_GTE?: InputMaybe<Scalars["Int"]>;
	orderLineNumber_LT?: InputMaybe<Scalars["Int"]>;
	orderLineNumber_LTE?: InputMaybe<Scalars["Int"]>;
	orderLineNumber_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	orderLineNumber_MAX_GT?: InputMaybe<Scalars["Int"]>;
	orderLineNumber_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	orderLineNumber_MAX_LT?: InputMaybe<Scalars["Int"]>;
	orderLineNumber_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	orderLineNumber_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	orderLineNumber_MIN_GT?: InputMaybe<Scalars["Int"]>;
	orderLineNumber_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	orderLineNumber_MIN_LT?: InputMaybe<Scalars["Int"]>;
	orderLineNumber_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	orderNumber_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	orderNumber_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	orderNumber_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	orderNumber_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	orderNumber_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	orderNumber_EQUAL?: InputMaybe<Scalars["Int"]>;
	orderNumber_GT?: InputMaybe<Scalars["Int"]>;
	orderNumber_GTE?: InputMaybe<Scalars["Int"]>;
	orderNumber_LT?: InputMaybe<Scalars["Int"]>;
	orderNumber_LTE?: InputMaybe<Scalars["Int"]>;
	orderNumber_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	orderNumber_MAX_GT?: InputMaybe<Scalars["Int"]>;
	orderNumber_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	orderNumber_MAX_LT?: InputMaybe<Scalars["Int"]>;
	orderNumber_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	orderNumber_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	orderNumber_MIN_GT?: InputMaybe<Scalars["Int"]>;
	orderNumber_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	orderNumber_MIN_LT?: InputMaybe<Scalars["Int"]>;
	orderNumber_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	price_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	price_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	price_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	price_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	price_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	price_EQUAL?: InputMaybe<Scalars["Float"]>;
	price_GT?: InputMaybe<Scalars["Float"]>;
	price_GTE?: InputMaybe<Scalars["Float"]>;
	price_LT?: InputMaybe<Scalars["Float"]>;
	price_LTE?: InputMaybe<Scalars["Float"]>;
	price_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	price_MAX_GT?: InputMaybe<Scalars["Float"]>;
	price_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	price_MAX_LT?: InputMaybe<Scalars["Float"]>;
	price_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	price_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	price_MIN_GT?: InputMaybe<Scalars["Float"]>;
	price_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	price_MIN_LT?: InputMaybe<Scalars["Float"]>;
	price_MIN_LTE?: InputMaybe<Scalars["Float"]>;
	productName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	productName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	productName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	productName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	productName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	productName_EQUAL?: InputMaybe<Scalars["String"]>;
	productName_GT?: InputMaybe<Scalars["Int"]>;
	productName_GTE?: InputMaybe<Scalars["Int"]>;
	productName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	productName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	productName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	productName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	productName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	productName_LT?: InputMaybe<Scalars["Int"]>;
	productName_LTE?: InputMaybe<Scalars["Int"]>;
	productName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	productName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	productName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	productName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	productName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	quantity_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	quantity_EQUAL?: InputMaybe<Scalars["Int"]>;
	quantity_GT?: InputMaybe<Scalars["Int"]>;
	quantity_GTE?: InputMaybe<Scalars["Int"]>;
	quantity_LT?: InputMaybe<Scalars["Int"]>;
	quantity_LTE?: InputMaybe<Scalars["Int"]>;
	quantity_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	quantity_MAX_GT?: InputMaybe<Scalars["Int"]>;
	quantity_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	quantity_MAX_LT?: InputMaybe<Scalars["Int"]>;
	quantity_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	quantity_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	quantity_MIN_GT?: InputMaybe<Scalars["Int"]>;
	quantity_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	quantity_MIN_LT?: InputMaybe<Scalars["Int"]>;
	quantity_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	refundPercentage_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	refundPercentage_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	refundPercentage_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	refundPercentage_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	refundPercentage_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	refundPercentage_EQUAL?: InputMaybe<Scalars["Float"]>;
	refundPercentage_GT?: InputMaybe<Scalars["Float"]>;
	refundPercentage_GTE?: InputMaybe<Scalars["Float"]>;
	refundPercentage_LT?: InputMaybe<Scalars["Float"]>;
	refundPercentage_LTE?: InputMaybe<Scalars["Float"]>;
	refundPercentage_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	refundPercentage_MAX_GT?: InputMaybe<Scalars["Float"]>;
	refundPercentage_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	refundPercentage_MAX_LT?: InputMaybe<Scalars["Float"]>;
	refundPercentage_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	refundPercentage_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	refundPercentage_MIN_GT?: InputMaybe<Scalars["Float"]>;
	refundPercentage_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	refundPercentage_MIN_LT?: InputMaybe<Scalars["Float"]>;
	refundPercentage_MIN_LTE?: InputMaybe<Scalars["Float"]>;
	saleDate_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	saleDate_GT?: InputMaybe<Scalars["DateTime"]>;
	saleDate_GTE?: InputMaybe<Scalars["DateTime"]>;
	saleDate_LT?: InputMaybe<Scalars["DateTime"]>;
	saleDate_LTE?: InputMaybe<Scalars["DateTime"]>;
	saleDate_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	saleDate_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	saleDate_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	saleDate_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	saleDate_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	saleDate_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	saleDate_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	saleDate_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	saleDate_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	saleDate_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	tenantId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	tenantId_EQUAL?: InputMaybe<Scalars["String"]>;
	tenantId_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type RecordDeviceRecordRelationship = {
	__typename?: "RecordDeviceRecordRelationship";
	cursor: Scalars["String"];
	node: DeviceRecord;
};

export type RecordDeviceRecordUpdateConnectionInput = {
	node?: InputMaybe<DeviceRecordUpdateInput>;
};

export type RecordDeviceRecordUpdateFieldInput = {
	connect?: InputMaybe<RecordDeviceRecordConnectFieldInput>;
	create?: InputMaybe<RecordDeviceRecordCreateFieldInput>;
	delete?: InputMaybe<RecordDeviceRecordDeleteFieldInput>;
	disconnect?: InputMaybe<RecordDeviceRecordDisconnectFieldInput>;
	update?: InputMaybe<RecordDeviceRecordUpdateConnectionInput>;
	where?: InputMaybe<RecordDeviceRecordConnectionWhere>;
};

export type RecordDisconnectInput = {
	deviceRecord?: InputMaybe<RecordDeviceRecordDisconnectFieldInput>;
};

export enum RecordNature {
	Administered = "ADMINISTERED",
	Prescribed = "PRESCRIBED",
}

export type RecordOptions = {
	limit?: InputMaybe<Scalars["Int"]>;
	offset?: InputMaybe<Scalars["Int"]>;
	/** Specify one or more RecordSort objects to sort Records by. The sorts will be applied in the order in which they are arranged in the array. */
	sort?: InputMaybe<Array<InputMaybe<RecordSort>>>;
};

/** Fields to sort Records by. The order in which sorts are applied is not guaranteed when specifying many fields in one RecordSort object. */
export type RecordSort = {
	administrationDate?: InputMaybe<SortDirection>;
	claimId?: InputMaybe<SortDirection>;
	createdBy?: InputMaybe<SortDirection>;
	createdByName?: InputMaybe<SortDirection>;
	createdOn?: InputMaybe<SortDirection>;
	id?: InputMaybe<SortDirection>;
	insuranceId?: InputMaybe<SortDirection>;
	invoiceDate?: InputMaybe<SortDirection>;
	invoiceNumber?: InputMaybe<SortDirection>;
	isArchived?: InputMaybe<SortDirection>;
	isDeleted?: InputMaybe<SortDirection>;
	occurrence?: InputMaybe<SortDirection>;
	preparationBrandNames?: InputMaybe<SortDirection>;
	preparationGenericNames?: InputMaybe<SortDirection>;
	preparationId?: InputMaybe<SortDirection>;
	prescriptionDate?: InputMaybe<SortDirection>;
	quantity?: InputMaybe<SortDirection>;
	status?: InputMaybe<SortDirection>;
	tenantId?: InputMaybe<SortDirection>;
	treatmentName?: InputMaybe<SortDirection>;
	type?: InputMaybe<SortDirection>;
	unlimited?: InputMaybe<SortDirection>;
	uuid?: InputMaybe<SortDirection>;
};

export enum RecordStatus {
	CoolingPeriod = "COOLING_PERIOD",
	Draft = "DRAFT",
	Matched = "MATCHED",
	Submitted = "SUBMITTED",
	Unmatched = "UNMATCHED",
}

export enum RecordType {
	Claim = "CLAIM",
	Device = "DEVICE",
	Prescription = "PRESCRIPTION",
}

export type RecordUpdateInput = {
	administrationDate?: InputMaybe<Scalars["DateTime"]>;
	claimId?: InputMaybe<Scalars["String"]>;
	createdBy?: InputMaybe<Scalars["String"]>;
	createdByName?: InputMaybe<Scalars["String"]>;
	createdOn?: InputMaybe<Scalars["DateTime"]>;
	deviceRecord?: InputMaybe<RecordDeviceRecordUpdateFieldInput>;
	id?: InputMaybe<Scalars["ID"]>;
	insuranceId?: InputMaybe<Scalars["String"]>;
	invoiceDate?: InputMaybe<Scalars["DateTime"]>;
	invoiceNumber?: InputMaybe<Scalars["String"]>;
	isArchived?: InputMaybe<Scalars["Boolean"]>;
	isDeleted?: InputMaybe<Scalars["Boolean"]>;
	occurrence?: InputMaybe<OccurrenceEnum>;
	preparationBrandNames?: InputMaybe<Scalars["String"]>;
	preparationGenericNames?: InputMaybe<Scalars["String"]>;
	preparationId?: InputMaybe<Scalars["String"]>;
	prescriptionDate?: InputMaybe<Scalars["Date"]>;
	quantity?: InputMaybe<Scalars["Int"]>;
	status?: InputMaybe<FlexFormStatus>;
	tenantId?: InputMaybe<Scalars["String"]>;
	treatmentName?: InputMaybe<Scalars["String"]>;
	type?: InputMaybe<RecordsTypeEnum>;
	unlimited?: InputMaybe<Scalars["Int"]>;
	uuid?: InputMaybe<Scalars["String"]>;
};

export type RecordWhere = {
	AND?: InputMaybe<Array<RecordWhere>>;
	OR?: InputMaybe<Array<RecordWhere>>;
	administrationDate?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_GT?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_GTE?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_IN?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]>>>;
	administrationDate_LT?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_LTE?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_NOT?: InputMaybe<Scalars["DateTime"]>;
	administrationDate_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]>>>;
	claimId?: InputMaybe<Scalars["String"]>;
	claimId_CONTAINS?: InputMaybe<Scalars["String"]>;
	claimId_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	claimId_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	claimId_MATCHES?: InputMaybe<Scalars["String"]>;
	claimId_NOT?: InputMaybe<Scalars["String"]>;
	claimId_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	claimId_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	claimId_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	claimId_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	claimId_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	createdBy?: InputMaybe<Scalars["String"]>;
	createdByName?: InputMaybe<Scalars["String"]>;
	createdByName_CONTAINS?: InputMaybe<Scalars["String"]>;
	createdByName_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	createdByName_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	createdByName_MATCHES?: InputMaybe<Scalars["String"]>;
	createdByName_NOT?: InputMaybe<Scalars["String"]>;
	createdByName_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	createdByName_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	createdByName_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	createdByName_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	createdByName_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	createdBy_CONTAINS?: InputMaybe<Scalars["String"]>;
	createdBy_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	createdBy_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	createdBy_MATCHES?: InputMaybe<Scalars["String"]>;
	createdBy_NOT?: InputMaybe<Scalars["String"]>;
	createdBy_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	createdBy_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	createdBy_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	createdBy_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	createdBy_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	createdOn?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_IN?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]>>>;
	createdOn_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_NOT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]>>>;
	deviceRecord?: InputMaybe<DeviceRecordWhere>;
	deviceRecordAggregate?: InputMaybe<RecordDeviceRecordAggregateInput>;
	deviceRecordConnection?: InputMaybe<RecordDeviceRecordConnectionWhere>;
	deviceRecordConnection_NOT?: InputMaybe<RecordDeviceRecordConnectionWhere>;
	deviceRecord_NOT?: InputMaybe<DeviceRecordWhere>;
	id?: InputMaybe<Scalars["ID"]>;
	id_CONTAINS?: InputMaybe<Scalars["ID"]>;
	id_ENDS_WITH?: InputMaybe<Scalars["ID"]>;
	id_IN?: InputMaybe<Array<InputMaybe<Scalars["ID"]>>>;
	id_MATCHES?: InputMaybe<Scalars["String"]>;
	id_NOT?: InputMaybe<Scalars["ID"]>;
	id_NOT_CONTAINS?: InputMaybe<Scalars["ID"]>;
	id_NOT_ENDS_WITH?: InputMaybe<Scalars["ID"]>;
	id_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["ID"]>>>;
	id_NOT_STARTS_WITH?: InputMaybe<Scalars["ID"]>;
	id_STARTS_WITH?: InputMaybe<Scalars["ID"]>;
	insuranceId?: InputMaybe<Scalars["String"]>;
	insuranceId_CONTAINS?: InputMaybe<Scalars["String"]>;
	insuranceId_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	insuranceId_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	insuranceId_MATCHES?: InputMaybe<Scalars["String"]>;
	insuranceId_NOT?: InputMaybe<Scalars["String"]>;
	insuranceId_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	insuranceId_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	insuranceId_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	insuranceId_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	insuranceId_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	invoiceDate?: InputMaybe<Scalars["DateTime"]>;
	invoiceDate_GT?: InputMaybe<Scalars["DateTime"]>;
	invoiceDate_GTE?: InputMaybe<Scalars["DateTime"]>;
	invoiceDate_IN?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]>>>;
	invoiceDate_LT?: InputMaybe<Scalars["DateTime"]>;
	invoiceDate_LTE?: InputMaybe<Scalars["DateTime"]>;
	invoiceDate_NOT?: InputMaybe<Scalars["DateTime"]>;
	invoiceDate_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]>>>;
	invoiceNumber?: InputMaybe<Scalars["String"]>;
	invoiceNumber_CONTAINS?: InputMaybe<Scalars["String"]>;
	invoiceNumber_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	invoiceNumber_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	invoiceNumber_MATCHES?: InputMaybe<Scalars["String"]>;
	invoiceNumber_NOT?: InputMaybe<Scalars["String"]>;
	invoiceNumber_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	invoiceNumber_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	invoiceNumber_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	invoiceNumber_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	invoiceNumber_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	isArchived?: InputMaybe<Scalars["Boolean"]>;
	isArchived_NOT?: InputMaybe<Scalars["Boolean"]>;
	isDeleted?: InputMaybe<Scalars["Boolean"]>;
	isDeleted_NOT?: InputMaybe<Scalars["Boolean"]>;
	occurrence?: InputMaybe<OccurrenceEnum>;
	occurrence_IN?: InputMaybe<Array<InputMaybe<OccurrenceEnum>>>;
	occurrence_NOT?: InputMaybe<OccurrenceEnum>;
	occurrence_NOT_IN?: InputMaybe<Array<InputMaybe<OccurrenceEnum>>>;
	preparationBrandNames?: InputMaybe<Scalars["String"]>;
	preparationBrandNames_CONTAINS?: InputMaybe<Scalars["String"]>;
	preparationBrandNames_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	preparationBrandNames_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	preparationBrandNames_MATCHES?: InputMaybe<Scalars["String"]>;
	preparationBrandNames_NOT?: InputMaybe<Scalars["String"]>;
	preparationBrandNames_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	preparationBrandNames_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	preparationBrandNames_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	preparationBrandNames_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	preparationBrandNames_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	preparationGenericNames?: InputMaybe<Scalars["String"]>;
	preparationGenericNames_CONTAINS?: InputMaybe<Scalars["String"]>;
	preparationGenericNames_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	preparationGenericNames_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	preparationGenericNames_MATCHES?: InputMaybe<Scalars["String"]>;
	preparationGenericNames_NOT?: InputMaybe<Scalars["String"]>;
	preparationGenericNames_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	preparationGenericNames_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	preparationGenericNames_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	preparationGenericNames_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	preparationGenericNames_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	preparationId?: InputMaybe<Scalars["String"]>;
	preparationId_CONTAINS?: InputMaybe<Scalars["String"]>;
	preparationId_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	preparationId_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	preparationId_MATCHES?: InputMaybe<Scalars["String"]>;
	preparationId_NOT?: InputMaybe<Scalars["String"]>;
	preparationId_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	preparationId_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	preparationId_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	preparationId_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	preparationId_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	prescriptionDate?: InputMaybe<Scalars["Date"]>;
	prescriptionDate_GT?: InputMaybe<Scalars["Date"]>;
	prescriptionDate_GTE?: InputMaybe<Scalars["Date"]>;
	prescriptionDate_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
	prescriptionDate_LT?: InputMaybe<Scalars["Date"]>;
	prescriptionDate_LTE?: InputMaybe<Scalars["Date"]>;
	prescriptionDate_NOT?: InputMaybe<Scalars["Date"]>;
	prescriptionDate_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
	quantity?: InputMaybe<Scalars["Int"]>;
	quantity_GT?: InputMaybe<Scalars["Int"]>;
	quantity_GTE?: InputMaybe<Scalars["Int"]>;
	quantity_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	quantity_LT?: InputMaybe<Scalars["Int"]>;
	quantity_LTE?: InputMaybe<Scalars["Int"]>;
	quantity_NOT?: InputMaybe<Scalars["Int"]>;
	quantity_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	status?: InputMaybe<FlexFormStatus>;
	status_IN?: InputMaybe<Array<InputMaybe<FlexFormStatus>>>;
	status_NOT?: InputMaybe<FlexFormStatus>;
	status_NOT_IN?: InputMaybe<Array<InputMaybe<FlexFormStatus>>>;
	tenantId?: InputMaybe<Scalars["String"]>;
	tenantId_CONTAINS?: InputMaybe<Scalars["String"]>;
	tenantId_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	tenantId_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	tenantId_MATCHES?: InputMaybe<Scalars["String"]>;
	tenantId_NOT?: InputMaybe<Scalars["String"]>;
	tenantId_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	tenantId_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	tenantId_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	tenantId_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	tenantId_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	treatmentName?: InputMaybe<Scalars["String"]>;
	treatmentName_CONTAINS?: InputMaybe<Scalars["String"]>;
	treatmentName_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	treatmentName_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	treatmentName_MATCHES?: InputMaybe<Scalars["String"]>;
	treatmentName_NOT?: InputMaybe<Scalars["String"]>;
	treatmentName_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	treatmentName_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	treatmentName_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	treatmentName_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	treatmentName_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	type?: InputMaybe<RecordsTypeEnum>;
	type_IN?: InputMaybe<Array<InputMaybe<RecordsTypeEnum>>>;
	type_NOT?: InputMaybe<RecordsTypeEnum>;
	type_NOT_IN?: InputMaybe<Array<InputMaybe<RecordsTypeEnum>>>;
	unlimited?: InputMaybe<Scalars["Int"]>;
	unlimited_GT?: InputMaybe<Scalars["Int"]>;
	unlimited_GTE?: InputMaybe<Scalars["Int"]>;
	unlimited_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	unlimited_LT?: InputMaybe<Scalars["Int"]>;
	unlimited_LTE?: InputMaybe<Scalars["Int"]>;
	unlimited_NOT?: InputMaybe<Scalars["Int"]>;
	unlimited_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	uuid?: InputMaybe<Scalars["String"]>;
	uuid_CONTAINS?: InputMaybe<Scalars["String"]>;
	uuid_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	uuid_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	uuid_MATCHES?: InputMaybe<Scalars["String"]>;
	uuid_NOT?: InputMaybe<Scalars["String"]>;
	uuid_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	uuid_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	uuid_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	uuid_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	uuid_STARTS_WITH?: InputMaybe<Scalars["String"]>;
};

export enum RecordsTypeEnum {
	Claim = "CLAIM",
	Device = "DEVICE",
	Prescription = "PRESCRIPTION",
}

export type Refund = {
	__typename?: "Refund";
	agreementName: Scalars["String"];
	amount: Scalars["Float"];
	canUserCreateDocument: Scalars["Boolean"];
	case: Case;
	caseConnection: RefundCaseConnection;
	caseId: Scalars["String"];
	counterParties: Scalars["String"];
	createdOn: Scalars["Date"];
	currency?: Maybe<Scalars["String"]>;
	formattedTags: Scalars["String"];
	id: Scalars["ID"];
	iin: Scalars["String"];
	invoiceFinancialDataPoints: Array<FinancialDataPoint>;
	invoiceFinancialDataPointsConnection: RefundInvoiceFinancialDataPointsConnection;
	invoices?: Maybe<Document>;
	invoicesConnection: RefundInvoicesConnection;
	isAgreementBuyer?: Maybe<Scalars["Boolean"]>;
	isDeleted?: Maybe<Scalars["Boolean"]>;
	message?: Maybe<Message>;
	messageConnection: RefundMessageConnection;
	messageCount?: Maybe<Scalars["Int"]>;
	nonObserverTenantIds?: Maybe<Array<Scalars["String"]>>;
	product: Scalars["String"];
	sourceFinancialDataPoints: Array<FinancialDataPoint>;
	sourceFinancialDataPointsConnection: RefundSourceFinancialDataPointsConnection;
	status: RefundStatus;
	tags: Array<AgreementTag>;
	tagsConnection: RefundTagsConnection;
	tenantIds: Array<Scalars["String"]>;
	unlimited?: Maybe<Scalars["Int"]>;
};

export type RefundCaseArgs = {
	options?: InputMaybe<CaseOptions>;
	where?: InputMaybe<CaseWhere>;
};

export type RefundCaseConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<RefundCaseConnectionSort>>;
	where?: InputMaybe<RefundCaseConnectionWhere>;
};

export type RefundInvoiceFinancialDataPointsArgs = {
	options?: InputMaybe<FinancialDataPointOptions>;
	where?: InputMaybe<FinancialDataPointWhere>;
};

export type RefundInvoiceFinancialDataPointsConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<RefundInvoiceFinancialDataPointsConnectionSort>>;
	where?: InputMaybe<RefundInvoiceFinancialDataPointsConnectionWhere>;
};

export type RefundInvoicesArgs = {
	options?: InputMaybe<DocumentOptions>;
	where?: InputMaybe<DocumentWhere>;
};

export type RefundInvoicesConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<RefundInvoicesConnectionSort>>;
	where?: InputMaybe<RefundInvoicesConnectionWhere>;
};

export type RefundMessageArgs = {
	options?: InputMaybe<MessageOptions>;
	where?: InputMaybe<MessageWhere>;
};

export type RefundMessageConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<RefundMessageConnectionSort>>;
	where?: InputMaybe<RefundMessageConnectionWhere>;
};

export type RefundSourceFinancialDataPointsArgs = {
	options?: InputMaybe<FinancialDataPointOptions>;
	where?: InputMaybe<FinancialDataPointWhere>;
};

export type RefundSourceFinancialDataPointsConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<RefundSourceFinancialDataPointsConnectionSort>>;
	where?: InputMaybe<RefundSourceFinancialDataPointsConnectionWhere>;
};

export type RefundTagsArgs = {
	options?: InputMaybe<AgreementTagOptions>;
	where?: InputMaybe<AgreementTagWhere>;
};

export type RefundTagsConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<RefundTagsConnectionSort>>;
	where?: InputMaybe<RefundTagsConnectionWhere>;
};

export type RefundAggregateSelection = {
	__typename?: "RefundAggregateSelection";
	agreementName: StringAggregateSelection;
	amount: FloatAggregateSelection;
	caseId: StringAggregateSelection;
	count: Scalars["Int"];
	counterParties: StringAggregateSelection;
	currency: StringAggregateSelection;
	formattedTags: StringAggregateSelection;
	id: IdAggregateSelection;
	iin: StringAggregateSelection;
	product: StringAggregateSelection;
	unlimited: IntAggregateSelection;
};

export type RefundCaseAggregateInput = {
	AND?: InputMaybe<Array<RefundCaseAggregateInput>>;
	OR?: InputMaybe<Array<RefundCaseAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<RefundCaseNodeAggregationWhereInput>;
};

export type RefundCaseConnectFieldInput = {
	connect?: InputMaybe<CaseConnectInput>;
	where?: InputMaybe<CaseConnectWhere>;
};

export type RefundCaseConnection = {
	__typename?: "RefundCaseConnection";
	edges: Array<RefundCaseRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type RefundCaseConnectionSort = {
	node?: InputMaybe<CaseSort>;
};

export type RefundCaseConnectionWhere = {
	AND?: InputMaybe<Array<RefundCaseConnectionWhere>>;
	OR?: InputMaybe<Array<RefundCaseConnectionWhere>>;
	node?: InputMaybe<CaseWhere>;
	node_NOT?: InputMaybe<CaseWhere>;
};

export type RefundCaseCreateFieldInput = {
	node: CaseCreateInput;
};

export type RefundCaseDeleteFieldInput = {
	delete?: InputMaybe<CaseDeleteInput>;
	where?: InputMaybe<RefundCaseConnectionWhere>;
};

export type RefundCaseDisconnectFieldInput = {
	disconnect?: InputMaybe<CaseDisconnectInput>;
	where?: InputMaybe<RefundCaseConnectionWhere>;
};

export type RefundCaseFieldInput = {
	connect?: InputMaybe<RefundCaseConnectFieldInput>;
	create?: InputMaybe<RefundCaseCreateFieldInput>;
};

export type RefundCaseNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<RefundCaseNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<RefundCaseNodeAggregationWhereInput>>;
	actualAgreementId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	actualAgreementId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	actualAgreementId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	actualAgreementId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	actualAgreementId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	actualAgreementId_EQUAL?: InputMaybe<Scalars["String"]>;
	actualAgreementId_GT?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_GTE?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_LT?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_LTE?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	agreementName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	agreementName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	agreementName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	agreementName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	agreementName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	agreementName_EQUAL?: InputMaybe<Scalars["String"]>;
	agreementName_GT?: InputMaybe<Scalars["Int"]>;
	agreementName_GTE?: InputMaybe<Scalars["Int"]>;
	agreementName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	agreementName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	agreementName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	agreementName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	agreementName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	agreementName_LT?: InputMaybe<Scalars["Int"]>;
	agreementName_LTE?: InputMaybe<Scalars["Int"]>;
	agreementName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	agreementName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	agreementName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	agreementName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	agreementName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	patientInitials_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	patientInitials_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	patientInitials_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	patientInitials_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	patientInitials_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	patientInitials_EQUAL?: InputMaybe<Scalars["String"]>;
	patientInitials_GT?: InputMaybe<Scalars["Int"]>;
	patientInitials_GTE?: InputMaybe<Scalars["Int"]>;
	patientInitials_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	patientInitials_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	patientInitials_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	patientInitials_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	patientInitials_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	patientInitials_LT?: InputMaybe<Scalars["Int"]>;
	patientInitials_LTE?: InputMaybe<Scalars["Int"]>;
	patientInitials_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	patientInitials_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	patientInitials_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	patientInitials_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	patientInitials_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	patientInsuranceId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	patientInsuranceId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	patientInsuranceId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	patientInsuranceId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	patientInsuranceId_EQUAL?: InputMaybe<Scalars["String"]>;
	patientInsuranceId_GT?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_GTE?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_LT?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_LTE?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationBandName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	preparationBandName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	preparationBandName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	preparationBandName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	preparationBandName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	preparationBandName_EQUAL?: InputMaybe<Scalars["String"]>;
	preparationBandName_GT?: InputMaybe<Scalars["Int"]>;
	preparationBandName_GTE?: InputMaybe<Scalars["Int"]>;
	preparationBandName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationBandName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationBandName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationBandName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationBandName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationBandName_LT?: InputMaybe<Scalars["Int"]>;
	preparationBandName_LTE?: InputMaybe<Scalars["Int"]>;
	preparationBandName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationBandName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationBandName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationBandName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationBandName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	preparationGenericName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	preparationGenericName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	preparationGenericName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	preparationGenericName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	preparationGenericName_EQUAL?: InputMaybe<Scalars["String"]>;
	preparationGenericName_GT?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_GTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_LT?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_LTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	sourceTenantId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	sourceTenantId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	sourceTenantId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	sourceTenantId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	sourceTenantId_EQUAL?: InputMaybe<Scalars["String"]>;
	sourceTenantId_GT?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_GTE?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_LT?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_LTE?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	submissionDate_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_GT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_GTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_LT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_LTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	totalAmount_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	totalAmount_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	totalAmount_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	totalAmount_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	totalAmount_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	totalAmount_EQUAL?: InputMaybe<Scalars["Float"]>;
	totalAmount_GT?: InputMaybe<Scalars["Float"]>;
	totalAmount_GTE?: InputMaybe<Scalars["Float"]>;
	totalAmount_LT?: InputMaybe<Scalars["Float"]>;
	totalAmount_LTE?: InputMaybe<Scalars["Float"]>;
	totalAmount_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	totalAmount_MAX_GT?: InputMaybe<Scalars["Float"]>;
	totalAmount_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	totalAmount_MAX_LT?: InputMaybe<Scalars["Float"]>;
	totalAmount_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	totalAmount_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	totalAmount_MIN_GT?: InputMaybe<Scalars["Float"]>;
	totalAmount_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	totalAmount_MIN_LT?: InputMaybe<Scalars["Float"]>;
	totalAmount_MIN_LTE?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	unlimited_EQUAL?: InputMaybe<Scalars["Int"]>;
	unlimited_GT?: InputMaybe<Scalars["Int"]>;
	unlimited_GTE?: InputMaybe<Scalars["Int"]>;
	unlimited_LT?: InputMaybe<Scalars["Int"]>;
	unlimited_LTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_GT?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_LT?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_GT?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_LT?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_LTE?: InputMaybe<Scalars["Int"]>;
};

export type RefundCaseRelationship = {
	__typename?: "RefundCaseRelationship";
	cursor: Scalars["String"];
	node: Case;
};

export type RefundCaseUpdateConnectionInput = {
	node?: InputMaybe<CaseUpdateInput>;
};

export type RefundCaseUpdateFieldInput = {
	connect?: InputMaybe<RefundCaseConnectFieldInput>;
	create?: InputMaybe<RefundCaseCreateFieldInput>;
	delete?: InputMaybe<RefundCaseDeleteFieldInput>;
	disconnect?: InputMaybe<RefundCaseDisconnectFieldInput>;
	update?: InputMaybe<RefundCaseUpdateConnectionInput>;
	where?: InputMaybe<RefundCaseConnectionWhere>;
};

export type RefundConnectInput = {
	case?: InputMaybe<RefundCaseConnectFieldInput>;
	invoiceFinancialDataPoints?: InputMaybe<Array<RefundInvoiceFinancialDataPointsConnectFieldInput>>;
	invoices?: InputMaybe<RefundInvoicesConnectFieldInput>;
	message?: InputMaybe<RefundMessageConnectFieldInput>;
	sourceFinancialDataPoints?: InputMaybe<Array<RefundSourceFinancialDataPointsConnectFieldInput>>;
	tags?: InputMaybe<Array<RefundTagsConnectFieldInput>>;
};

export type RefundConnectWhere = {
	node: RefundWhere;
};

export type RefundCreateInput = {
	agreementName: Scalars["String"];
	amount: Scalars["Float"];
	case?: InputMaybe<RefundCaseFieldInput>;
	caseId: Scalars["String"];
	counterParties: Scalars["String"];
	createdOn: Scalars["Date"];
	currency?: InputMaybe<Scalars["String"]>;
	formattedTags: Scalars["String"];
	id: Scalars["ID"];
	iin: Scalars["String"];
	invoiceFinancialDataPoints?: InputMaybe<RefundInvoiceFinancialDataPointsFieldInput>;
	invoices?: InputMaybe<RefundInvoicesFieldInput>;
	isDeleted?: InputMaybe<Scalars["Boolean"]>;
	message?: InputMaybe<RefundMessageFieldInput>;
	product: Scalars["String"];
	sourceFinancialDataPoints?: InputMaybe<RefundSourceFinancialDataPointsFieldInput>;
	status: RefundStatus;
	tags?: InputMaybe<RefundTagsFieldInput>;
	tenantIds: Array<Scalars["String"]>;
	unlimited?: InputMaybe<Scalars["Int"]>;
};

export type RefundDeleteInput = {
	case?: InputMaybe<RefundCaseDeleteFieldInput>;
	invoiceFinancialDataPoints?: InputMaybe<Array<RefundInvoiceFinancialDataPointsDeleteFieldInput>>;
	invoices?: InputMaybe<RefundInvoicesDeleteFieldInput>;
	message?: InputMaybe<RefundMessageDeleteFieldInput>;
	sourceFinancialDataPoints?: InputMaybe<Array<RefundSourceFinancialDataPointsDeleteFieldInput>>;
	tags?: InputMaybe<Array<RefundTagsDeleteFieldInput>>;
};

export type RefundDisconnectInput = {
	case?: InputMaybe<RefundCaseDisconnectFieldInput>;
	invoiceFinancialDataPoints?: InputMaybe<Array<RefundInvoiceFinancialDataPointsDisconnectFieldInput>>;
	invoices?: InputMaybe<RefundInvoicesDisconnectFieldInput>;
	message?: InputMaybe<RefundMessageDisconnectFieldInput>;
	sourceFinancialDataPoints?: InputMaybe<Array<RefundSourceFinancialDataPointsDisconnectFieldInput>>;
	tags?: InputMaybe<Array<RefundTagsDisconnectFieldInput>>;
};

export type RefundInvoiceFinancialDataPointsAggregateInput = {
	AND?: InputMaybe<Array<RefundInvoiceFinancialDataPointsAggregateInput>>;
	OR?: InputMaybe<Array<RefundInvoiceFinancialDataPointsAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	edge?: InputMaybe<RefundInvoiceFinancialDataPointsEdgeAggregationWhereInput>;
	node?: InputMaybe<RefundInvoiceFinancialDataPointsNodeAggregationWhereInput>;
};

export type RefundInvoiceFinancialDataPointsConnectFieldInput = {
	connect?: InputMaybe<Array<FinancialDataPointConnectInput>>;
	edge: InvoiceRefundFinancialDataPointCreateInput;
	where?: InputMaybe<FinancialDataPointConnectWhere>;
};

export type RefundInvoiceFinancialDataPointsConnection = {
	__typename?: "RefundInvoiceFinancialDataPointsConnection";
	edges: Array<RefundInvoiceFinancialDataPointsRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type RefundInvoiceFinancialDataPointsConnectionSort = {
	edge?: InputMaybe<InvoiceRefundFinancialDataPointSort>;
	node?: InputMaybe<FinancialDataPointSort>;
};

export type RefundInvoiceFinancialDataPointsConnectionWhere = {
	AND?: InputMaybe<Array<RefundInvoiceFinancialDataPointsConnectionWhere>>;
	OR?: InputMaybe<Array<RefundInvoiceFinancialDataPointsConnectionWhere>>;
	edge?: InputMaybe<InvoiceRefundFinancialDataPointWhere>;
	edge_NOT?: InputMaybe<InvoiceRefundFinancialDataPointWhere>;
	node?: InputMaybe<FinancialDataPointWhere>;
	node_NOT?: InputMaybe<FinancialDataPointWhere>;
};

export type RefundInvoiceFinancialDataPointsCreateFieldInput = {
	edge: InvoiceRefundFinancialDataPointCreateInput;
	node: FinancialDataPointCreateInput;
};

export type RefundInvoiceFinancialDataPointsDeleteFieldInput = {
	delete?: InputMaybe<FinancialDataPointDeleteInput>;
	where?: InputMaybe<RefundInvoiceFinancialDataPointsConnectionWhere>;
};

export type RefundInvoiceFinancialDataPointsDisconnectFieldInput = {
	disconnect?: InputMaybe<FinancialDataPointDisconnectInput>;
	where?: InputMaybe<RefundInvoiceFinancialDataPointsConnectionWhere>;
};

export type RefundInvoiceFinancialDataPointsEdgeAggregationWhereInput = {
	AND?: InputMaybe<Array<RefundInvoiceFinancialDataPointsEdgeAggregationWhereInput>>;
	OR?: InputMaybe<Array<RefundInvoiceFinancialDataPointsEdgeAggregationWhereInput>>;
	id_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	id_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	id_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	id_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	id_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	id_EQUAL?: InputMaybe<Scalars["Int"]>;
	id_GT?: InputMaybe<Scalars["Int"]>;
	id_GTE?: InputMaybe<Scalars["Int"]>;
	id_LT?: InputMaybe<Scalars["Int"]>;
	id_LTE?: InputMaybe<Scalars["Int"]>;
	id_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	id_MAX_GT?: InputMaybe<Scalars["Int"]>;
	id_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	id_MAX_LT?: InputMaybe<Scalars["Int"]>;
	id_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	id_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	id_MIN_GT?: InputMaybe<Scalars["Int"]>;
	id_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	id_MIN_LT?: InputMaybe<Scalars["Int"]>;
	id_MIN_LTE?: InputMaybe<Scalars["Int"]>;
};

export type RefundInvoiceFinancialDataPointsFieldInput = {
	connect?: InputMaybe<Array<RefundInvoiceFinancialDataPointsConnectFieldInput>>;
	create?: InputMaybe<Array<RefundInvoiceFinancialDataPointsCreateFieldInput>>;
};

export type RefundInvoiceFinancialDataPointsNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<RefundInvoiceFinancialDataPointsNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<RefundInvoiceFinancialDataPointsNodeAggregationWhereInput>>;
	basePrice_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	basePrice_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	basePrice_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	basePrice_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	basePrice_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	basePrice_EQUAL?: InputMaybe<Scalars["Float"]>;
	basePrice_GT?: InputMaybe<Scalars["Float"]>;
	basePrice_GTE?: InputMaybe<Scalars["Float"]>;
	basePrice_LT?: InputMaybe<Scalars["Float"]>;
	basePrice_LTE?: InputMaybe<Scalars["Float"]>;
	basePrice_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	basePrice_MAX_GT?: InputMaybe<Scalars["Float"]>;
	basePrice_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	basePrice_MAX_LT?: InputMaybe<Scalars["Float"]>;
	basePrice_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	basePrice_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	basePrice_MIN_GT?: InputMaybe<Scalars["Float"]>;
	basePrice_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	basePrice_MIN_LT?: InputMaybe<Scalars["Float"]>;
	basePrice_MIN_LTE?: InputMaybe<Scalars["Float"]>;
	currencyCode_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	currencyCode_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	currencyCode_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	currencyCode_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	currencyCode_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	currencyCode_EQUAL?: InputMaybe<Scalars["String"]>;
	currencyCode_GT?: InputMaybe<Scalars["Int"]>;
	currencyCode_GTE?: InputMaybe<Scalars["Int"]>;
	currencyCode_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	currencyCode_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	currencyCode_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	currencyCode_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	currencyCode_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	currencyCode_LT?: InputMaybe<Scalars["Int"]>;
	currencyCode_LTE?: InputMaybe<Scalars["Int"]>;
	currencyCode_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	currencyCode_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	currencyCode_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	currencyCode_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	currencyCode_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	evaluationSnapshot_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	evaluationSnapshot_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	evaluationSnapshot_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	evaluationSnapshot_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	evaluationSnapshot_EQUAL?: InputMaybe<Scalars["String"]>;
	evaluationSnapshot_GT?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_GTE?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_LT?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_LTE?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	generatedUuid_EQUAL?: InputMaybe<Scalars["ID"]>;
	payablePercentage_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	payablePercentage_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	payablePercentage_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	payablePercentage_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	payablePercentage_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	payablePercentage_EQUAL?: InputMaybe<Scalars["Float"]>;
	payablePercentage_GT?: InputMaybe<Scalars["Float"]>;
	payablePercentage_GTE?: InputMaybe<Scalars["Float"]>;
	payablePercentage_LT?: InputMaybe<Scalars["Float"]>;
	payablePercentage_LTE?: InputMaybe<Scalars["Float"]>;
	payablePercentage_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	payablePercentage_MAX_GT?: InputMaybe<Scalars["Float"]>;
	payablePercentage_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	payablePercentage_MAX_LT?: InputMaybe<Scalars["Float"]>;
	payablePercentage_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	payablePercentage_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	payablePercentage_MIN_GT?: InputMaybe<Scalars["Float"]>;
	payablePercentage_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	payablePercentage_MIN_LT?: InputMaybe<Scalars["Float"]>;
	payablePercentage_MIN_LTE?: InputMaybe<Scalars["Float"]>;
	payable_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	payable_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	payable_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	payable_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	payable_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	payable_EQUAL?: InputMaybe<Scalars["Float"]>;
	payable_GT?: InputMaybe<Scalars["Float"]>;
	payable_GTE?: InputMaybe<Scalars["Float"]>;
	payable_LT?: InputMaybe<Scalars["Float"]>;
	payable_LTE?: InputMaybe<Scalars["Float"]>;
	payable_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	payable_MAX_GT?: InputMaybe<Scalars["Float"]>;
	payable_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	payable_MAX_LT?: InputMaybe<Scalars["Float"]>;
	payable_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	payable_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	payable_MIN_GT?: InputMaybe<Scalars["Float"]>;
	payable_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	payable_MIN_LT?: InputMaybe<Scalars["Float"]>;
	payable_MIN_LTE?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	quantity_EQUAL?: InputMaybe<Scalars["Float"]>;
	quantity_GT?: InputMaybe<Scalars["Float"]>;
	quantity_GTE?: InputMaybe<Scalars["Float"]>;
	quantity_LT?: InputMaybe<Scalars["Float"]>;
	quantity_LTE?: InputMaybe<Scalars["Float"]>;
	quantity_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	quantity_MAX_GT?: InputMaybe<Scalars["Float"]>;
	quantity_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	quantity_MAX_LT?: InputMaybe<Scalars["Float"]>;
	quantity_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	quantity_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	quantity_MIN_GT?: InputMaybe<Scalars["Float"]>;
	quantity_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	quantity_MIN_LT?: InputMaybe<Scalars["Float"]>;
	quantity_MIN_LTE?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_EQUAL?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_GT?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_GTE?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_LT?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_LTE?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_MAX_GT?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_MAX_LT?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_MIN_GT?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_MIN_LT?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_MIN_LTE?: InputMaybe<Scalars["Float"]>;
	refundable_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	refundable_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	refundable_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	refundable_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	refundable_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	refundable_EQUAL?: InputMaybe<Scalars["Float"]>;
	refundable_GT?: InputMaybe<Scalars["Float"]>;
	refundable_GTE?: InputMaybe<Scalars["Float"]>;
	refundable_LT?: InputMaybe<Scalars["Float"]>;
	refundable_LTE?: InputMaybe<Scalars["Float"]>;
	refundable_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	refundable_MAX_GT?: InputMaybe<Scalars["Float"]>;
	refundable_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	refundable_MAX_LT?: InputMaybe<Scalars["Float"]>;
	refundable_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	refundable_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	refundable_MIN_GT?: InputMaybe<Scalars["Float"]>;
	refundable_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	refundable_MIN_LT?: InputMaybe<Scalars["Float"]>;
	refundable_MIN_LTE?: InputMaybe<Scalars["Float"]>;
	uuid_EQUAL?: InputMaybe<Scalars["ID"]>;
	variablePercentage_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	variablePercentage_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	variablePercentage_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	variablePercentage_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	variablePercentage_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	variablePercentage_EQUAL?: InputMaybe<Scalars["Float"]>;
	variablePercentage_GT?: InputMaybe<Scalars["Float"]>;
	variablePercentage_GTE?: InputMaybe<Scalars["Float"]>;
	variablePercentage_LT?: InputMaybe<Scalars["Float"]>;
	variablePercentage_LTE?: InputMaybe<Scalars["Float"]>;
	variablePercentage_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	variablePercentage_MAX_GT?: InputMaybe<Scalars["Float"]>;
	variablePercentage_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	variablePercentage_MAX_LT?: InputMaybe<Scalars["Float"]>;
	variablePercentage_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	variablePercentage_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	variablePercentage_MIN_GT?: InputMaybe<Scalars["Float"]>;
	variablePercentage_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	variablePercentage_MIN_LT?: InputMaybe<Scalars["Float"]>;
	variablePercentage_MIN_LTE?: InputMaybe<Scalars["Float"]>;
	variable_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	variable_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	variable_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	variable_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	variable_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	variable_EQUAL?: InputMaybe<Scalars["Float"]>;
	variable_GT?: InputMaybe<Scalars["Float"]>;
	variable_GTE?: InputMaybe<Scalars["Float"]>;
	variable_LT?: InputMaybe<Scalars["Float"]>;
	variable_LTE?: InputMaybe<Scalars["Float"]>;
	variable_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	variable_MAX_GT?: InputMaybe<Scalars["Float"]>;
	variable_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	variable_MAX_LT?: InputMaybe<Scalars["Float"]>;
	variable_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	variable_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	variable_MIN_GT?: InputMaybe<Scalars["Float"]>;
	variable_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	variable_MIN_LT?: InputMaybe<Scalars["Float"]>;
	variable_MIN_LTE?: InputMaybe<Scalars["Float"]>;
};

export type RefundInvoiceFinancialDataPointsRelationship = InvoiceRefundFinancialDataPoint & {
	__typename?: "RefundInvoiceFinancialDataPointsRelationship";
	cursor: Scalars["String"];
	id: Scalars["Int"];
	node: FinancialDataPoint;
	status?: Maybe<FinancialDataPointStatus>;
};

export type RefundInvoiceFinancialDataPointsUpdateConnectionInput = {
	edge?: InputMaybe<InvoiceRefundFinancialDataPointUpdateInput>;
	node?: InputMaybe<FinancialDataPointUpdateInput>;
};

export type RefundInvoiceFinancialDataPointsUpdateFieldInput = {
	connect?: InputMaybe<Array<RefundInvoiceFinancialDataPointsConnectFieldInput>>;
	create?: InputMaybe<Array<RefundInvoiceFinancialDataPointsCreateFieldInput>>;
	delete?: InputMaybe<Array<RefundInvoiceFinancialDataPointsDeleteFieldInput>>;
	disconnect?: InputMaybe<Array<RefundInvoiceFinancialDataPointsDisconnectFieldInput>>;
	update?: InputMaybe<RefundInvoiceFinancialDataPointsUpdateConnectionInput>;
	where?: InputMaybe<RefundInvoiceFinancialDataPointsConnectionWhere>;
};

export type RefundInvoicesAggregateInput = {
	AND?: InputMaybe<Array<RefundInvoicesAggregateInput>>;
	OR?: InputMaybe<Array<RefundInvoicesAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<RefundInvoicesNodeAggregationWhereInput>;
};

export type RefundInvoicesConnectFieldInput = {
	connect?: InputMaybe<DocumentConnectInput>;
	where?: InputMaybe<DocumentConnectWhere>;
};

export type RefundInvoicesConnection = {
	__typename?: "RefundInvoicesConnection";
	edges: Array<RefundInvoicesRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type RefundInvoicesConnectionSort = {
	node?: InputMaybe<DocumentSort>;
};

export type RefundInvoicesConnectionWhere = {
	AND?: InputMaybe<Array<RefundInvoicesConnectionWhere>>;
	OR?: InputMaybe<Array<RefundInvoicesConnectionWhere>>;
	node?: InputMaybe<DocumentWhere>;
	node_NOT?: InputMaybe<DocumentWhere>;
};

export type RefundInvoicesCreateFieldInput = {
	node: DocumentCreateInput;
};

export type RefundInvoicesDeleteFieldInput = {
	delete?: InputMaybe<DocumentDeleteInput>;
	where?: InputMaybe<RefundInvoicesConnectionWhere>;
};

export type RefundInvoicesDisconnectFieldInput = {
	disconnect?: InputMaybe<DocumentDisconnectInput>;
	where?: InputMaybe<RefundInvoicesConnectionWhere>;
};

export type RefundInvoicesFieldInput = {
	connect?: InputMaybe<RefundInvoicesConnectFieldInput>;
	create?: InputMaybe<RefundInvoicesCreateFieldInput>;
};

export type RefundInvoicesNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<RefundInvoicesNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<RefundInvoicesNodeAggregationWhereInput>>;
	counterParties_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	counterParties_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	counterParties_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	counterParties_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	counterParties_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	counterParties_EQUAL?: InputMaybe<Scalars["String"]>;
	counterParties_GT?: InputMaybe<Scalars["Int"]>;
	counterParties_GTE?: InputMaybe<Scalars["Int"]>;
	counterParties_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	counterParties_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	counterParties_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	counterParties_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	counterParties_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	counterParties_LT?: InputMaybe<Scalars["Int"]>;
	counterParties_LTE?: InputMaybe<Scalars["Int"]>;
	counterParties_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	counterParties_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	counterParties_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	counterParties_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	counterParties_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	coveragePeriod_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	coveragePeriod_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	coveragePeriod_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	coveragePeriod_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	coveragePeriod_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	coveragePeriod_EQUAL?: InputMaybe<Scalars["String"]>;
	coveragePeriod_GT?: InputMaybe<Scalars["Int"]>;
	coveragePeriod_GTE?: InputMaybe<Scalars["Int"]>;
	coveragePeriod_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	coveragePeriod_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	coveragePeriod_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	coveragePeriod_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	coveragePeriod_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	coveragePeriod_LT?: InputMaybe<Scalars["Int"]>;
	coveragePeriod_LTE?: InputMaybe<Scalars["Int"]>;
	coveragePeriod_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	coveragePeriod_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	coveragePeriod_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	coveragePeriod_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	coveragePeriod_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	createdBy_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	createdBy_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	createdBy_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	createdBy_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	createdBy_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	createdBy_EQUAL?: InputMaybe<Scalars["String"]>;
	createdBy_GT?: InputMaybe<Scalars["Int"]>;
	createdBy_GTE?: InputMaybe<Scalars["Int"]>;
	createdBy_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	createdBy_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	createdBy_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	createdBy_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	createdBy_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	createdBy_LT?: InputMaybe<Scalars["Int"]>;
	createdBy_LTE?: InputMaybe<Scalars["Int"]>;
	createdBy_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	createdBy_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	createdBy_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	createdBy_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	createdBy_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	createdOn_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	creatorOrgName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	creatorOrgName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	creatorOrgName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	creatorOrgName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	creatorOrgName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	creatorOrgName_EQUAL?: InputMaybe<Scalars["String"]>;
	creatorOrgName_GT?: InputMaybe<Scalars["Int"]>;
	creatorOrgName_GTE?: InputMaybe<Scalars["Int"]>;
	creatorOrgName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	creatorOrgName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	creatorOrgName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	creatorOrgName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	creatorOrgName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	creatorOrgName_LT?: InputMaybe<Scalars["Int"]>;
	creatorOrgName_LTE?: InputMaybe<Scalars["Int"]>;
	creatorOrgName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	creatorOrgName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	creatorOrgName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	creatorOrgName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	creatorOrgName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	creatorTenantId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	creatorTenantId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	creatorTenantId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	creatorTenantId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	creatorTenantId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	creatorTenantId_EQUAL?: InputMaybe<Scalars["String"]>;
	creatorTenantId_GT?: InputMaybe<Scalars["Int"]>;
	creatorTenantId_GTE?: InputMaybe<Scalars["Int"]>;
	creatorTenantId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	creatorTenantId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	creatorTenantId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	creatorTenantId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	creatorTenantId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	creatorTenantId_LT?: InputMaybe<Scalars["Int"]>;
	creatorTenantId_LTE?: InputMaybe<Scalars["Int"]>;
	creatorTenantId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	creatorTenantId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	creatorTenantId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	creatorTenantId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	creatorTenantId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	formattedTags_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	formattedTags_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	formattedTags_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	formattedTags_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	formattedTags_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	formattedTags_EQUAL?: InputMaybe<Scalars["String"]>;
	formattedTags_GT?: InputMaybe<Scalars["Int"]>;
	formattedTags_GTE?: InputMaybe<Scalars["Int"]>;
	formattedTags_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedTags_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedTags_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedTags_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedTags_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	formattedTags_LT?: InputMaybe<Scalars["Int"]>;
	formattedTags_LTE?: InputMaybe<Scalars["Int"]>;
	formattedTags_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedTags_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedTags_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedTags_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedTags_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	invoiceAmount_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	invoiceAmount_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	invoiceAmount_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	invoiceAmount_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	invoiceAmount_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	invoiceAmount_EQUAL?: InputMaybe<Scalars["Int"]>;
	invoiceAmount_GT?: InputMaybe<Scalars["Int"]>;
	invoiceAmount_GTE?: InputMaybe<Scalars["Int"]>;
	invoiceAmount_LT?: InputMaybe<Scalars["Int"]>;
	invoiceAmount_LTE?: InputMaybe<Scalars["Int"]>;
	invoiceAmount_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	invoiceAmount_MAX_GT?: InputMaybe<Scalars["Int"]>;
	invoiceAmount_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	invoiceAmount_MAX_LT?: InputMaybe<Scalars["Int"]>;
	invoiceAmount_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	invoiceAmount_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	invoiceAmount_MIN_GT?: InputMaybe<Scalars["Int"]>;
	invoiceAmount_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	invoiceAmount_MIN_LT?: InputMaybe<Scalars["Int"]>;
	invoiceAmount_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	issuedOn_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	issuedOn_GT?: InputMaybe<Scalars["DateTime"]>;
	issuedOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	issuedOn_LT?: InputMaybe<Scalars["DateTime"]>;
	issuedOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	issuedOn_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	issuedOn_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	issuedOn_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	issuedOn_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	issuedOn_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	issuedOn_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	issuedOn_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	issuedOn_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	issuedOn_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	issuedOn_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_GT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_LT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	product_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	product_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	product_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	product_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	product_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	product_EQUAL?: InputMaybe<Scalars["String"]>;
	product_GT?: InputMaybe<Scalars["Int"]>;
	product_GTE?: InputMaybe<Scalars["Int"]>;
	product_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	product_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	product_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	product_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	product_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	product_LT?: InputMaybe<Scalars["Int"]>;
	product_LTE?: InputMaybe<Scalars["Int"]>;
	product_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	product_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	product_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	product_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	product_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	unlimited_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	unlimited_EQUAL?: InputMaybe<Scalars["Int"]>;
	unlimited_GT?: InputMaybe<Scalars["Int"]>;
	unlimited_GTE?: InputMaybe<Scalars["Int"]>;
	unlimited_LT?: InputMaybe<Scalars["Int"]>;
	unlimited_LTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_GT?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_LT?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_GT?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_LT?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_LTE?: InputMaybe<Scalars["Int"]>;
};

export type RefundInvoicesRelationship = {
	__typename?: "RefundInvoicesRelationship";
	cursor: Scalars["String"];
	node: Document;
};

export type RefundInvoicesUpdateConnectionInput = {
	node?: InputMaybe<DocumentUpdateInput>;
};

export type RefundInvoicesUpdateFieldInput = {
	connect?: InputMaybe<RefundInvoicesConnectFieldInput>;
	create?: InputMaybe<RefundInvoicesCreateFieldInput>;
	delete?: InputMaybe<RefundInvoicesDeleteFieldInput>;
	disconnect?: InputMaybe<RefundInvoicesDisconnectFieldInput>;
	update?: InputMaybe<RefundInvoicesUpdateConnectionInput>;
	where?: InputMaybe<RefundInvoicesConnectionWhere>;
};

export type RefundMessageAggregateInput = {
	AND?: InputMaybe<Array<RefundMessageAggregateInput>>;
	OR?: InputMaybe<Array<RefundMessageAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<RefundMessageNodeAggregationWhereInput>;
};

export type RefundMessageConnectFieldInput = {
	connect?: InputMaybe<MessageConnectInput>;
	where?: InputMaybe<MessageConnectWhere>;
};

export type RefundMessageConnection = {
	__typename?: "RefundMessageConnection";
	edges: Array<RefundMessageRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type RefundMessageConnectionSort = {
	node?: InputMaybe<MessageSort>;
};

export type RefundMessageConnectionWhere = {
	AND?: InputMaybe<Array<RefundMessageConnectionWhere>>;
	OR?: InputMaybe<Array<RefundMessageConnectionWhere>>;
	node?: InputMaybe<MessageWhere>;
	node_NOT?: InputMaybe<MessageWhere>;
};

export type RefundMessageCreateFieldInput = {
	node: MessageCreateInput;
};

export type RefundMessageDeleteFieldInput = {
	delete?: InputMaybe<MessageDeleteInput>;
	where?: InputMaybe<RefundMessageConnectionWhere>;
};

export type RefundMessageDisconnectFieldInput = {
	disconnect?: InputMaybe<MessageDisconnectInput>;
	where?: InputMaybe<RefundMessageConnectionWhere>;
};

export type RefundMessageFieldInput = {
	connect?: InputMaybe<RefundMessageConnectFieldInput>;
	create?: InputMaybe<RefundMessageCreateFieldInput>;
};

export type RefundMessageNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<RefundMessageNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<RefundMessageNodeAggregationWhereInput>>;
	content_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	content_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	content_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	content_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	content_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	content_EQUAL?: InputMaybe<Scalars["String"]>;
	content_GT?: InputMaybe<Scalars["Int"]>;
	content_GTE?: InputMaybe<Scalars["Int"]>;
	content_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	content_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	content_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	content_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	content_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	content_LT?: InputMaybe<Scalars["Int"]>;
	content_LTE?: InputMaybe<Scalars["Int"]>;
	content_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	content_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	content_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	content_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	content_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	createdOn_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	createdOn_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	createdOn_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	createdOn_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	createdOn_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	createdOn_EQUAL?: InputMaybe<Scalars["Float"]>;
	createdOn_GT?: InputMaybe<Scalars["Float"]>;
	createdOn_GTE?: InputMaybe<Scalars["Float"]>;
	createdOn_LT?: InputMaybe<Scalars["Float"]>;
	createdOn_LTE?: InputMaybe<Scalars["Float"]>;
	createdOn_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	createdOn_MAX_GT?: InputMaybe<Scalars["Float"]>;
	createdOn_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	createdOn_MAX_LT?: InputMaybe<Scalars["Float"]>;
	createdOn_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	createdOn_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	createdOn_MIN_GT?: InputMaybe<Scalars["Float"]>;
	createdOn_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	createdOn_MIN_LT?: InputMaybe<Scalars["Float"]>;
	createdOn_MIN_LTE?: InputMaybe<Scalars["Float"]>;
};

export type RefundMessageRelationship = {
	__typename?: "RefundMessageRelationship";
	cursor: Scalars["String"];
	node: Message;
};

export type RefundMessageUpdateConnectionInput = {
	node?: InputMaybe<MessageUpdateInput>;
};

export type RefundMessageUpdateFieldInput = {
	connect?: InputMaybe<RefundMessageConnectFieldInput>;
	create?: InputMaybe<RefundMessageCreateFieldInput>;
	delete?: InputMaybe<RefundMessageDeleteFieldInput>;
	disconnect?: InputMaybe<RefundMessageDisconnectFieldInput>;
	update?: InputMaybe<RefundMessageUpdateConnectionInput>;
	where?: InputMaybe<RefundMessageConnectionWhere>;
};

export type RefundOptions = {
	limit?: InputMaybe<Scalars["Int"]>;
	offset?: InputMaybe<Scalars["Int"]>;
	/** Specify one or more RefundSort objects to sort Refunds by. The sorts will be applied in the order in which they are arranged in the array. */
	sort?: InputMaybe<Array<InputMaybe<RefundSort>>>;
};

/** Fields to sort Refunds by. The order in which sorts are applied is not guaranteed when specifying many fields in one RefundSort object. */
export type RefundSort = {
	agreementName?: InputMaybe<SortDirection>;
	amount?: InputMaybe<SortDirection>;
	caseId?: InputMaybe<SortDirection>;
	counterParties?: InputMaybe<SortDirection>;
	createdOn?: InputMaybe<SortDirection>;
	currency?: InputMaybe<SortDirection>;
	formattedTags?: InputMaybe<SortDirection>;
	id?: InputMaybe<SortDirection>;
	iin?: InputMaybe<SortDirection>;
	isDeleted?: InputMaybe<SortDirection>;
	product?: InputMaybe<SortDirection>;
	status?: InputMaybe<SortDirection>;
	unlimited?: InputMaybe<SortDirection>;
};

export type RefundSourceFinancialDataPointsAggregateInput = {
	AND?: InputMaybe<Array<RefundSourceFinancialDataPointsAggregateInput>>;
	OR?: InputMaybe<Array<RefundSourceFinancialDataPointsAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<RefundSourceFinancialDataPointsNodeAggregationWhereInput>;
};

export type RefundSourceFinancialDataPointsConnectFieldInput = {
	connect?: InputMaybe<Array<FinancialDataPointConnectInput>>;
	where?: InputMaybe<FinancialDataPointConnectWhere>;
};

export type RefundSourceFinancialDataPointsConnection = {
	__typename?: "RefundSourceFinancialDataPointsConnection";
	edges: Array<RefundSourceFinancialDataPointsRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type RefundSourceFinancialDataPointsConnectionSort = {
	node?: InputMaybe<FinancialDataPointSort>;
};

export type RefundSourceFinancialDataPointsConnectionWhere = {
	AND?: InputMaybe<Array<RefundSourceFinancialDataPointsConnectionWhere>>;
	OR?: InputMaybe<Array<RefundSourceFinancialDataPointsConnectionWhere>>;
	node?: InputMaybe<FinancialDataPointWhere>;
	node_NOT?: InputMaybe<FinancialDataPointWhere>;
};

export type RefundSourceFinancialDataPointsCreateFieldInput = {
	node: FinancialDataPointCreateInput;
};

export type RefundSourceFinancialDataPointsDeleteFieldInput = {
	delete?: InputMaybe<FinancialDataPointDeleteInput>;
	where?: InputMaybe<RefundSourceFinancialDataPointsConnectionWhere>;
};

export type RefundSourceFinancialDataPointsDisconnectFieldInput = {
	disconnect?: InputMaybe<FinancialDataPointDisconnectInput>;
	where?: InputMaybe<RefundSourceFinancialDataPointsConnectionWhere>;
};

export type RefundSourceFinancialDataPointsFieldInput = {
	connect?: InputMaybe<Array<RefundSourceFinancialDataPointsConnectFieldInput>>;
	create?: InputMaybe<Array<RefundSourceFinancialDataPointsCreateFieldInput>>;
};

export type RefundSourceFinancialDataPointsNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<RefundSourceFinancialDataPointsNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<RefundSourceFinancialDataPointsNodeAggregationWhereInput>>;
	basePrice_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	basePrice_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	basePrice_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	basePrice_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	basePrice_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	basePrice_EQUAL?: InputMaybe<Scalars["Float"]>;
	basePrice_GT?: InputMaybe<Scalars["Float"]>;
	basePrice_GTE?: InputMaybe<Scalars["Float"]>;
	basePrice_LT?: InputMaybe<Scalars["Float"]>;
	basePrice_LTE?: InputMaybe<Scalars["Float"]>;
	basePrice_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	basePrice_MAX_GT?: InputMaybe<Scalars["Float"]>;
	basePrice_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	basePrice_MAX_LT?: InputMaybe<Scalars["Float"]>;
	basePrice_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	basePrice_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	basePrice_MIN_GT?: InputMaybe<Scalars["Float"]>;
	basePrice_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	basePrice_MIN_LT?: InputMaybe<Scalars["Float"]>;
	basePrice_MIN_LTE?: InputMaybe<Scalars["Float"]>;
	currencyCode_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	currencyCode_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	currencyCode_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	currencyCode_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	currencyCode_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	currencyCode_EQUAL?: InputMaybe<Scalars["String"]>;
	currencyCode_GT?: InputMaybe<Scalars["Int"]>;
	currencyCode_GTE?: InputMaybe<Scalars["Int"]>;
	currencyCode_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	currencyCode_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	currencyCode_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	currencyCode_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	currencyCode_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	currencyCode_LT?: InputMaybe<Scalars["Int"]>;
	currencyCode_LTE?: InputMaybe<Scalars["Int"]>;
	currencyCode_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	currencyCode_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	currencyCode_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	currencyCode_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	currencyCode_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	evaluationSnapshot_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	evaluationSnapshot_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	evaluationSnapshot_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	evaluationSnapshot_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	evaluationSnapshot_EQUAL?: InputMaybe<Scalars["String"]>;
	evaluationSnapshot_GT?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_GTE?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_LT?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_LTE?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	evaluationSnapshot_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	generatedUuid_EQUAL?: InputMaybe<Scalars["ID"]>;
	payablePercentage_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	payablePercentage_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	payablePercentage_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	payablePercentage_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	payablePercentage_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	payablePercentage_EQUAL?: InputMaybe<Scalars["Float"]>;
	payablePercentage_GT?: InputMaybe<Scalars["Float"]>;
	payablePercentage_GTE?: InputMaybe<Scalars["Float"]>;
	payablePercentage_LT?: InputMaybe<Scalars["Float"]>;
	payablePercentage_LTE?: InputMaybe<Scalars["Float"]>;
	payablePercentage_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	payablePercentage_MAX_GT?: InputMaybe<Scalars["Float"]>;
	payablePercentage_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	payablePercentage_MAX_LT?: InputMaybe<Scalars["Float"]>;
	payablePercentage_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	payablePercentage_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	payablePercentage_MIN_GT?: InputMaybe<Scalars["Float"]>;
	payablePercentage_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	payablePercentage_MIN_LT?: InputMaybe<Scalars["Float"]>;
	payablePercentage_MIN_LTE?: InputMaybe<Scalars["Float"]>;
	payable_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	payable_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	payable_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	payable_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	payable_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	payable_EQUAL?: InputMaybe<Scalars["Float"]>;
	payable_GT?: InputMaybe<Scalars["Float"]>;
	payable_GTE?: InputMaybe<Scalars["Float"]>;
	payable_LT?: InputMaybe<Scalars["Float"]>;
	payable_LTE?: InputMaybe<Scalars["Float"]>;
	payable_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	payable_MAX_GT?: InputMaybe<Scalars["Float"]>;
	payable_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	payable_MAX_LT?: InputMaybe<Scalars["Float"]>;
	payable_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	payable_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	payable_MIN_GT?: InputMaybe<Scalars["Float"]>;
	payable_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	payable_MIN_LT?: InputMaybe<Scalars["Float"]>;
	payable_MIN_LTE?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	quantity_EQUAL?: InputMaybe<Scalars["Float"]>;
	quantity_GT?: InputMaybe<Scalars["Float"]>;
	quantity_GTE?: InputMaybe<Scalars["Float"]>;
	quantity_LT?: InputMaybe<Scalars["Float"]>;
	quantity_LTE?: InputMaybe<Scalars["Float"]>;
	quantity_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	quantity_MAX_GT?: InputMaybe<Scalars["Float"]>;
	quantity_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	quantity_MAX_LT?: InputMaybe<Scalars["Float"]>;
	quantity_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	quantity_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	quantity_MIN_GT?: InputMaybe<Scalars["Float"]>;
	quantity_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	quantity_MIN_LT?: InputMaybe<Scalars["Float"]>;
	quantity_MIN_LTE?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_EQUAL?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_GT?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_GTE?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_LT?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_LTE?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_MAX_GT?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_MAX_LT?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_MIN_GT?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_MIN_LT?: InputMaybe<Scalars["Float"]>;
	refundablePercentage_MIN_LTE?: InputMaybe<Scalars["Float"]>;
	refundable_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	refundable_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	refundable_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	refundable_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	refundable_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	refundable_EQUAL?: InputMaybe<Scalars["Float"]>;
	refundable_GT?: InputMaybe<Scalars["Float"]>;
	refundable_GTE?: InputMaybe<Scalars["Float"]>;
	refundable_LT?: InputMaybe<Scalars["Float"]>;
	refundable_LTE?: InputMaybe<Scalars["Float"]>;
	refundable_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	refundable_MAX_GT?: InputMaybe<Scalars["Float"]>;
	refundable_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	refundable_MAX_LT?: InputMaybe<Scalars["Float"]>;
	refundable_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	refundable_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	refundable_MIN_GT?: InputMaybe<Scalars["Float"]>;
	refundable_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	refundable_MIN_LT?: InputMaybe<Scalars["Float"]>;
	refundable_MIN_LTE?: InputMaybe<Scalars["Float"]>;
	uuid_EQUAL?: InputMaybe<Scalars["ID"]>;
	variablePercentage_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	variablePercentage_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	variablePercentage_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	variablePercentage_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	variablePercentage_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	variablePercentage_EQUAL?: InputMaybe<Scalars["Float"]>;
	variablePercentage_GT?: InputMaybe<Scalars["Float"]>;
	variablePercentage_GTE?: InputMaybe<Scalars["Float"]>;
	variablePercentage_LT?: InputMaybe<Scalars["Float"]>;
	variablePercentage_LTE?: InputMaybe<Scalars["Float"]>;
	variablePercentage_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	variablePercentage_MAX_GT?: InputMaybe<Scalars["Float"]>;
	variablePercentage_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	variablePercentage_MAX_LT?: InputMaybe<Scalars["Float"]>;
	variablePercentage_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	variablePercentage_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	variablePercentage_MIN_GT?: InputMaybe<Scalars["Float"]>;
	variablePercentage_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	variablePercentage_MIN_LT?: InputMaybe<Scalars["Float"]>;
	variablePercentage_MIN_LTE?: InputMaybe<Scalars["Float"]>;
	variable_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	variable_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	variable_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	variable_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	variable_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	variable_EQUAL?: InputMaybe<Scalars["Float"]>;
	variable_GT?: InputMaybe<Scalars["Float"]>;
	variable_GTE?: InputMaybe<Scalars["Float"]>;
	variable_LT?: InputMaybe<Scalars["Float"]>;
	variable_LTE?: InputMaybe<Scalars["Float"]>;
	variable_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	variable_MAX_GT?: InputMaybe<Scalars["Float"]>;
	variable_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	variable_MAX_LT?: InputMaybe<Scalars["Float"]>;
	variable_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	variable_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	variable_MIN_GT?: InputMaybe<Scalars["Float"]>;
	variable_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	variable_MIN_LT?: InputMaybe<Scalars["Float"]>;
	variable_MIN_LTE?: InputMaybe<Scalars["Float"]>;
};

export type RefundSourceFinancialDataPointsRelationship = {
	__typename?: "RefundSourceFinancialDataPointsRelationship";
	cursor: Scalars["String"];
	node: FinancialDataPoint;
};

export type RefundSourceFinancialDataPointsUpdateConnectionInput = {
	node?: InputMaybe<FinancialDataPointUpdateInput>;
};

export type RefundSourceFinancialDataPointsUpdateFieldInput = {
	connect?: InputMaybe<Array<RefundSourceFinancialDataPointsConnectFieldInput>>;
	create?: InputMaybe<Array<RefundSourceFinancialDataPointsCreateFieldInput>>;
	delete?: InputMaybe<Array<RefundSourceFinancialDataPointsDeleteFieldInput>>;
	disconnect?: InputMaybe<Array<RefundSourceFinancialDataPointsDisconnectFieldInput>>;
	update?: InputMaybe<RefundSourceFinancialDataPointsUpdateConnectionInput>;
	where?: InputMaybe<RefundSourceFinancialDataPointsConnectionWhere>;
};

export enum RefundStatus {
	Invoiced = "INVOICED",
	New = "NEW",
	Pending = "PENDING",
	Settled = "SETTLED",
}

export type RefundTagsAggregateInput = {
	AND?: InputMaybe<Array<RefundTagsAggregateInput>>;
	OR?: InputMaybe<Array<RefundTagsAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<RefundTagsNodeAggregationWhereInput>;
};

export type RefundTagsConnectFieldInput = {
	connect?: InputMaybe<Array<AgreementTagConnectInput>>;
	where?: InputMaybe<AgreementTagConnectWhere>;
};

export type RefundTagsConnection = {
	__typename?: "RefundTagsConnection";
	edges: Array<RefundTagsRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type RefundTagsConnectionSort = {
	node?: InputMaybe<AgreementTagSort>;
};

export type RefundTagsConnectionWhere = {
	AND?: InputMaybe<Array<RefundTagsConnectionWhere>>;
	OR?: InputMaybe<Array<RefundTagsConnectionWhere>>;
	node?: InputMaybe<AgreementTagWhere>;
	node_NOT?: InputMaybe<AgreementTagWhere>;
};

export type RefundTagsCreateFieldInput = {
	node: AgreementTagCreateInput;
};

export type RefundTagsDeleteFieldInput = {
	delete?: InputMaybe<AgreementTagDeleteInput>;
	where?: InputMaybe<RefundTagsConnectionWhere>;
};

export type RefundTagsDisconnectFieldInput = {
	disconnect?: InputMaybe<AgreementTagDisconnectInput>;
	where?: InputMaybe<RefundTagsConnectionWhere>;
};

export type RefundTagsFieldInput = {
	connect?: InputMaybe<Array<RefundTagsConnectFieldInput>>;
	create?: InputMaybe<Array<RefundTagsCreateFieldInput>>;
};

export type RefundTagsNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<RefundTagsNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<RefundTagsNodeAggregationWhereInput>>;
	id_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	id_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	id_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	id_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	id_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	id_EQUAL?: InputMaybe<Scalars["Int"]>;
	id_GT?: InputMaybe<Scalars["Int"]>;
	id_GTE?: InputMaybe<Scalars["Int"]>;
	id_LT?: InputMaybe<Scalars["Int"]>;
	id_LTE?: InputMaybe<Scalars["Int"]>;
	id_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	id_MAX_GT?: InputMaybe<Scalars["Int"]>;
	id_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	id_MAX_LT?: InputMaybe<Scalars["Int"]>;
	id_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	id_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	id_MIN_GT?: InputMaybe<Scalars["Int"]>;
	id_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	id_MIN_LT?: InputMaybe<Scalars["Int"]>;
	id_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	name_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	name_EQUAL?: InputMaybe<Scalars["String"]>;
	name_GT?: InputMaybe<Scalars["Int"]>;
	name_GTE?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	name_LT?: InputMaybe<Scalars["Int"]>;
	name_LTE?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type RefundTagsRelationship = {
	__typename?: "RefundTagsRelationship";
	cursor: Scalars["String"];
	node: AgreementTag;
};

export type RefundTagsUpdateConnectionInput = {
	node?: InputMaybe<AgreementTagUpdateInput>;
};

export type RefundTagsUpdateFieldInput = {
	connect?: InputMaybe<Array<RefundTagsConnectFieldInput>>;
	create?: InputMaybe<Array<RefundTagsCreateFieldInput>>;
	delete?: InputMaybe<Array<RefundTagsDeleteFieldInput>>;
	disconnect?: InputMaybe<Array<RefundTagsDisconnectFieldInput>>;
	update?: InputMaybe<RefundTagsUpdateConnectionInput>;
	where?: InputMaybe<RefundTagsConnectionWhere>;
};

export type RefundUpdateInput = {
	agreementName?: InputMaybe<Scalars["String"]>;
	amount?: InputMaybe<Scalars["Float"]>;
	case?: InputMaybe<RefundCaseUpdateFieldInput>;
	caseId?: InputMaybe<Scalars["String"]>;
	counterParties?: InputMaybe<Scalars["String"]>;
	createdOn?: InputMaybe<Scalars["Date"]>;
	currency?: InputMaybe<Scalars["String"]>;
	formattedTags?: InputMaybe<Scalars["String"]>;
	id?: InputMaybe<Scalars["ID"]>;
	iin?: InputMaybe<Scalars["String"]>;
	invoiceFinancialDataPoints?: InputMaybe<Array<RefundInvoiceFinancialDataPointsUpdateFieldInput>>;
	invoices?: InputMaybe<RefundInvoicesUpdateFieldInput>;
	isDeleted?: InputMaybe<Scalars["Boolean"]>;
	message?: InputMaybe<RefundMessageUpdateFieldInput>;
	product?: InputMaybe<Scalars["String"]>;
	sourceFinancialDataPoints?: InputMaybe<Array<RefundSourceFinancialDataPointsUpdateFieldInput>>;
	status?: InputMaybe<RefundStatus>;
	tags?: InputMaybe<Array<RefundTagsUpdateFieldInput>>;
	tenantIds?: InputMaybe<Array<Scalars["String"]>>;
	unlimited?: InputMaybe<Scalars["Int"]>;
};

export type RefundWhere = {
	AND?: InputMaybe<Array<RefundWhere>>;
	OR?: InputMaybe<Array<RefundWhere>>;
	agreementName?: InputMaybe<Scalars["String"]>;
	agreementName_CONTAINS?: InputMaybe<Scalars["String"]>;
	agreementName_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	agreementName_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	agreementName_MATCHES?: InputMaybe<Scalars["String"]>;
	agreementName_NOT?: InputMaybe<Scalars["String"]>;
	agreementName_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	agreementName_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	agreementName_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	agreementName_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	agreementName_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	amount?: InputMaybe<Scalars["Float"]>;
	amount_GT?: InputMaybe<Scalars["Float"]>;
	amount_GTE?: InputMaybe<Scalars["Float"]>;
	amount_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	amount_LT?: InputMaybe<Scalars["Float"]>;
	amount_LTE?: InputMaybe<Scalars["Float"]>;
	amount_NOT?: InputMaybe<Scalars["Float"]>;
	amount_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	case?: InputMaybe<CaseWhere>;
	caseAggregate?: InputMaybe<RefundCaseAggregateInput>;
	caseConnection?: InputMaybe<RefundCaseConnectionWhere>;
	caseConnection_NOT?: InputMaybe<RefundCaseConnectionWhere>;
	caseId?: InputMaybe<Scalars["String"]>;
	caseId_CONTAINS?: InputMaybe<Scalars["String"]>;
	caseId_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	caseId_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	caseId_MATCHES?: InputMaybe<Scalars["String"]>;
	caseId_NOT?: InputMaybe<Scalars["String"]>;
	caseId_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	caseId_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	caseId_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	caseId_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	caseId_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	case_NOT?: InputMaybe<CaseWhere>;
	counterParties?: InputMaybe<Scalars["String"]>;
	counterParties_CONTAINS?: InputMaybe<Scalars["String"]>;
	counterParties_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	counterParties_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	counterParties_MATCHES?: InputMaybe<Scalars["String"]>;
	counterParties_NOT?: InputMaybe<Scalars["String"]>;
	counterParties_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	counterParties_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	counterParties_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	counterParties_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	counterParties_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	createdOn?: InputMaybe<Scalars["Date"]>;
	createdOn_GT?: InputMaybe<Scalars["Date"]>;
	createdOn_GTE?: InputMaybe<Scalars["Date"]>;
	createdOn_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
	createdOn_LT?: InputMaybe<Scalars["Date"]>;
	createdOn_LTE?: InputMaybe<Scalars["Date"]>;
	createdOn_NOT?: InputMaybe<Scalars["Date"]>;
	createdOn_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
	currency?: InputMaybe<Scalars["String"]>;
	currency_CONTAINS?: InputMaybe<Scalars["String"]>;
	currency_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	currency_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	currency_MATCHES?: InputMaybe<Scalars["String"]>;
	currency_NOT?: InputMaybe<Scalars["String"]>;
	currency_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	currency_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	currency_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	currency_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	currency_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	formattedTags?: InputMaybe<Scalars["String"]>;
	formattedTags_CONTAINS?: InputMaybe<Scalars["String"]>;
	formattedTags_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	formattedTags_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	formattedTags_MATCHES?: InputMaybe<Scalars["String"]>;
	formattedTags_NOT?: InputMaybe<Scalars["String"]>;
	formattedTags_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	formattedTags_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	formattedTags_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	formattedTags_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	formattedTags_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	id?: InputMaybe<Scalars["ID"]>;
	id_CONTAINS?: InputMaybe<Scalars["ID"]>;
	id_ENDS_WITH?: InputMaybe<Scalars["ID"]>;
	id_IN?: InputMaybe<Array<InputMaybe<Scalars["ID"]>>>;
	id_MATCHES?: InputMaybe<Scalars["String"]>;
	id_NOT?: InputMaybe<Scalars["ID"]>;
	id_NOT_CONTAINS?: InputMaybe<Scalars["ID"]>;
	id_NOT_ENDS_WITH?: InputMaybe<Scalars["ID"]>;
	id_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["ID"]>>>;
	id_NOT_STARTS_WITH?: InputMaybe<Scalars["ID"]>;
	id_STARTS_WITH?: InputMaybe<Scalars["ID"]>;
	iin?: InputMaybe<Scalars["String"]>;
	iin_CONTAINS?: InputMaybe<Scalars["String"]>;
	iin_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	iin_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	iin_MATCHES?: InputMaybe<Scalars["String"]>;
	iin_NOT?: InputMaybe<Scalars["String"]>;
	iin_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	iin_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	iin_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	iin_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	iin_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	invoiceFinancialDataPoints?: InputMaybe<FinancialDataPointWhere>;
	invoiceFinancialDataPointsAggregate?: InputMaybe<RefundInvoiceFinancialDataPointsAggregateInput>;
	invoiceFinancialDataPointsConnection?: InputMaybe<RefundInvoiceFinancialDataPointsConnectionWhere>;
	invoiceFinancialDataPointsConnection_NOT?: InputMaybe<RefundInvoiceFinancialDataPointsConnectionWhere>;
	invoiceFinancialDataPoints_NOT?: InputMaybe<FinancialDataPointWhere>;
	invoices?: InputMaybe<DocumentWhere>;
	invoicesAggregate?: InputMaybe<RefundInvoicesAggregateInput>;
	invoicesConnection?: InputMaybe<RefundInvoicesConnectionWhere>;
	invoicesConnection_NOT?: InputMaybe<RefundInvoicesConnectionWhere>;
	invoices_NOT?: InputMaybe<DocumentWhere>;
	isDeleted?: InputMaybe<Scalars["Boolean"]>;
	isDeleted_NOT?: InputMaybe<Scalars["Boolean"]>;
	message?: InputMaybe<MessageWhere>;
	messageAggregate?: InputMaybe<RefundMessageAggregateInput>;
	messageConnection?: InputMaybe<RefundMessageConnectionWhere>;
	messageConnection_NOT?: InputMaybe<RefundMessageConnectionWhere>;
	message_NOT?: InputMaybe<MessageWhere>;
	product?: InputMaybe<Scalars["String"]>;
	product_CONTAINS?: InputMaybe<Scalars["String"]>;
	product_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	product_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	product_MATCHES?: InputMaybe<Scalars["String"]>;
	product_NOT?: InputMaybe<Scalars["String"]>;
	product_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	product_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	product_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	product_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	product_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	sourceFinancialDataPoints?: InputMaybe<FinancialDataPointWhere>;
	sourceFinancialDataPointsAggregate?: InputMaybe<RefundSourceFinancialDataPointsAggregateInput>;
	sourceFinancialDataPointsConnection?: InputMaybe<RefundSourceFinancialDataPointsConnectionWhere>;
	sourceFinancialDataPointsConnection_NOT?: InputMaybe<RefundSourceFinancialDataPointsConnectionWhere>;
	sourceFinancialDataPoints_NOT?: InputMaybe<FinancialDataPointWhere>;
	status?: InputMaybe<RefundStatus>;
	status_IN?: InputMaybe<Array<InputMaybe<RefundStatus>>>;
	status_NOT?: InputMaybe<RefundStatus>;
	status_NOT_IN?: InputMaybe<Array<InputMaybe<RefundStatus>>>;
	tags?: InputMaybe<AgreementTagWhere>;
	tagsAggregate?: InputMaybe<RefundTagsAggregateInput>;
	tagsConnection?: InputMaybe<RefundTagsConnectionWhere>;
	tagsConnection_NOT?: InputMaybe<RefundTagsConnectionWhere>;
	tags_NOT?: InputMaybe<AgreementTagWhere>;
	tenantIds?: InputMaybe<Array<Scalars["String"]>>;
	tenantIds_INCLUDES?: InputMaybe<Scalars["String"]>;
	tenantIds_NOT?: InputMaybe<Array<Scalars["String"]>>;
	tenantIds_NOT_INCLUDES?: InputMaybe<Scalars["String"]>;
	unlimited?: InputMaybe<Scalars["Int"]>;
	unlimited_GT?: InputMaybe<Scalars["Int"]>;
	unlimited_GTE?: InputMaybe<Scalars["Int"]>;
	unlimited_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	unlimited_LT?: InputMaybe<Scalars["Int"]>;
	unlimited_LTE?: InputMaybe<Scalars["Int"]>;
	unlimited_NOT?: InputMaybe<Scalars["Int"]>;
	unlimited_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
};

export enum Reintervention {
	DidNotOccur = "DID_NOT_OCCUR",
	Occured = "OCCURED",
}

export enum ReportInterventionType {
	PrimaryIntervention = "PRIMARY_INTERVENTION",
	SecondaryIntervention = "SECONDARY_INTERVENTION",
}

export enum ReportItemsUsedFilter {
	All = "ALL",
	PrimaryAndSecondaryIntervention = "PRIMARY_AND_SECONDARY_INTERVENTION",
	PrimaryInterventionOnly = "PRIMARY_INTERVENTION_ONLY",
}

export type ReportingSummary = {
	__typename?: "ReportingSummary";
	averageDiscountPerCase?: Maybe<Scalars["Float"]>;
	averageDiscountPerCaseDelta?: Maybe<Scalars["Float"]>;
	discountAmount?: Maybe<Scalars["Float"]>;
	discountAmountDelta?: Maybe<Scalars["Float"]>;
	discountsTurnover?: Maybe<Scalars["Float"]>;
	grossAmount?: Maybe<Scalars["Float"]>;
	grossAmountDelta?: Maybe<Scalars["Float"]>;
	grossTurnover?: Maybe<Scalars["Float"]>;
	grossVariable?: Maybe<Scalars["Float"]>;
	netTurnover?: Maybe<Scalars["Float"]>;
	patientReportDataPoints: Array<PatientReportDataPoint>;
	randomMicrocontentContent?: Maybe<MicroContent>;
	variableTurnover?: Maybe<Scalars["Float"]>;
};

export type ReportingSummaryAggregateSelection = {
	__typename?: "ReportingSummaryAggregateSelection";
	averageDiscountPerCase: FloatAggregateSelection;
	averageDiscountPerCaseDelta: FloatAggregateSelection;
	count: Scalars["Int"];
	discountAmount: FloatAggregateSelection;
	discountAmountDelta: FloatAggregateSelection;
	discountsTurnover: FloatAggregateSelection;
	grossAmount: FloatAggregateSelection;
	grossAmountDelta: FloatAggregateSelection;
	grossTurnover: FloatAggregateSelection;
	grossVariable: FloatAggregateSelection;
	netTurnover: FloatAggregateSelection;
	variableTurnover: FloatAggregateSelection;
};

export type ReportingSummaryOptions = {
	limit?: InputMaybe<Scalars["Int"]>;
	offset?: InputMaybe<Scalars["Int"]>;
	/** Specify one or more ReportingSummarySort objects to sort ReportingSummaries by. The sorts will be applied in the order in which they are arranged in the array. */
	sort?: InputMaybe<Array<InputMaybe<ReportingSummarySort>>>;
};

/** Fields to sort ReportingSummaries by. The order in which sorts are applied is not guaranteed when specifying many fields in one ReportingSummarySort object. */
export type ReportingSummarySort = {
	averageDiscountPerCase?: InputMaybe<SortDirection>;
	averageDiscountPerCaseDelta?: InputMaybe<SortDirection>;
	discountAmount?: InputMaybe<SortDirection>;
	discountAmountDelta?: InputMaybe<SortDirection>;
	discountsTurnover?: InputMaybe<SortDirection>;
	grossAmount?: InputMaybe<SortDirection>;
	grossAmountDelta?: InputMaybe<SortDirection>;
	grossTurnover?: InputMaybe<SortDirection>;
	grossVariable?: InputMaybe<SortDirection>;
	netTurnover?: InputMaybe<SortDirection>;
	variableTurnover?: InputMaybe<SortDirection>;
};

export type ReportingSummaryWhere = {
	AND?: InputMaybe<Array<ReportingSummaryWhere>>;
	OR?: InputMaybe<Array<ReportingSummaryWhere>>;
	averageDiscountPerCase?: InputMaybe<Scalars["Float"]>;
	averageDiscountPerCaseDelta?: InputMaybe<Scalars["Float"]>;
	averageDiscountPerCaseDelta_GT?: InputMaybe<Scalars["Float"]>;
	averageDiscountPerCaseDelta_GTE?: InputMaybe<Scalars["Float"]>;
	averageDiscountPerCaseDelta_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	averageDiscountPerCaseDelta_LT?: InputMaybe<Scalars["Float"]>;
	averageDiscountPerCaseDelta_LTE?: InputMaybe<Scalars["Float"]>;
	averageDiscountPerCaseDelta_NOT?: InputMaybe<Scalars["Float"]>;
	averageDiscountPerCaseDelta_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	averageDiscountPerCase_GT?: InputMaybe<Scalars["Float"]>;
	averageDiscountPerCase_GTE?: InputMaybe<Scalars["Float"]>;
	averageDiscountPerCase_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	averageDiscountPerCase_LT?: InputMaybe<Scalars["Float"]>;
	averageDiscountPerCase_LTE?: InputMaybe<Scalars["Float"]>;
	averageDiscountPerCase_NOT?: InputMaybe<Scalars["Float"]>;
	averageDiscountPerCase_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	discountAmount?: InputMaybe<Scalars["Float"]>;
	discountAmountDelta?: InputMaybe<Scalars["Float"]>;
	discountAmountDelta_GT?: InputMaybe<Scalars["Float"]>;
	discountAmountDelta_GTE?: InputMaybe<Scalars["Float"]>;
	discountAmountDelta_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	discountAmountDelta_LT?: InputMaybe<Scalars["Float"]>;
	discountAmountDelta_LTE?: InputMaybe<Scalars["Float"]>;
	discountAmountDelta_NOT?: InputMaybe<Scalars["Float"]>;
	discountAmountDelta_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	discountAmount_GT?: InputMaybe<Scalars["Float"]>;
	discountAmount_GTE?: InputMaybe<Scalars["Float"]>;
	discountAmount_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	discountAmount_LT?: InputMaybe<Scalars["Float"]>;
	discountAmount_LTE?: InputMaybe<Scalars["Float"]>;
	discountAmount_NOT?: InputMaybe<Scalars["Float"]>;
	discountAmount_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	discountsTurnover?: InputMaybe<Scalars["Float"]>;
	discountsTurnover_GT?: InputMaybe<Scalars["Float"]>;
	discountsTurnover_GTE?: InputMaybe<Scalars["Float"]>;
	discountsTurnover_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	discountsTurnover_LT?: InputMaybe<Scalars["Float"]>;
	discountsTurnover_LTE?: InputMaybe<Scalars["Float"]>;
	discountsTurnover_NOT?: InputMaybe<Scalars["Float"]>;
	discountsTurnover_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	grossAmount?: InputMaybe<Scalars["Float"]>;
	grossAmountDelta?: InputMaybe<Scalars["Float"]>;
	grossAmountDelta_GT?: InputMaybe<Scalars["Float"]>;
	grossAmountDelta_GTE?: InputMaybe<Scalars["Float"]>;
	grossAmountDelta_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	grossAmountDelta_LT?: InputMaybe<Scalars["Float"]>;
	grossAmountDelta_LTE?: InputMaybe<Scalars["Float"]>;
	grossAmountDelta_NOT?: InputMaybe<Scalars["Float"]>;
	grossAmountDelta_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	grossAmount_GT?: InputMaybe<Scalars["Float"]>;
	grossAmount_GTE?: InputMaybe<Scalars["Float"]>;
	grossAmount_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	grossAmount_LT?: InputMaybe<Scalars["Float"]>;
	grossAmount_LTE?: InputMaybe<Scalars["Float"]>;
	grossAmount_NOT?: InputMaybe<Scalars["Float"]>;
	grossAmount_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	grossTurnover?: InputMaybe<Scalars["Float"]>;
	grossTurnover_GT?: InputMaybe<Scalars["Float"]>;
	grossTurnover_GTE?: InputMaybe<Scalars["Float"]>;
	grossTurnover_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	grossTurnover_LT?: InputMaybe<Scalars["Float"]>;
	grossTurnover_LTE?: InputMaybe<Scalars["Float"]>;
	grossTurnover_NOT?: InputMaybe<Scalars["Float"]>;
	grossTurnover_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	grossVariable?: InputMaybe<Scalars["Float"]>;
	grossVariable_GT?: InputMaybe<Scalars["Float"]>;
	grossVariable_GTE?: InputMaybe<Scalars["Float"]>;
	grossVariable_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	grossVariable_LT?: InputMaybe<Scalars["Float"]>;
	grossVariable_LTE?: InputMaybe<Scalars["Float"]>;
	grossVariable_NOT?: InputMaybe<Scalars["Float"]>;
	grossVariable_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	netTurnover?: InputMaybe<Scalars["Float"]>;
	netTurnover_GT?: InputMaybe<Scalars["Float"]>;
	netTurnover_GTE?: InputMaybe<Scalars["Float"]>;
	netTurnover_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	netTurnover_LT?: InputMaybe<Scalars["Float"]>;
	netTurnover_LTE?: InputMaybe<Scalars["Float"]>;
	netTurnover_NOT?: InputMaybe<Scalars["Float"]>;
	netTurnover_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	variableTurnover?: InputMaybe<Scalars["Float"]>;
	variableTurnover_GT?: InputMaybe<Scalars["Float"]>;
	variableTurnover_GTE?: InputMaybe<Scalars["Float"]>;
	variableTurnover_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	variableTurnover_LT?: InputMaybe<Scalars["Float"]>;
	variableTurnover_LTE?: InputMaybe<Scalars["Float"]>;
	variableTurnover_NOT?: InputMaybe<Scalars["Float"]>;
	variableTurnover_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
};

export enum ResponseInclusionType {
	Is = "IS",
	IsNot = "IS_NOT",
}

export enum ResponseType {
	CompleteResponse = "COMPLETE_RESPONSE",
	NoInfo = "NO_INFO",
	PartialResponse = "PARTIAL_RESPONSE",
	PathologicalCompleteResponse = "PATHOLOGICAL_COMPLETE_RESPONSE",
	ProgressiveDisease = "PROGRESSIVE_DISEASE",
	StableDisease = "STABLE_DISEASE",
}

export type SaveReviewedInvoiceInput = {
	assignees?: InputMaybe<Array<InputMaybe<AssigneeInput>>>;
	confirmedBySeller?: InputMaybe<Scalars["Boolean"]>;
	financialDataPoints?: InputMaybe<Array<InputMaybe<FinancialDataPointInput>>>;
	invoiceId: Scalars["ID"];
	invoiceStatus: DocumentStatus;
	settledOn?: InputMaybe<Scalars["String"]>;
};

export type Scenario = {
	__typename?: "Scenario";
	actions: Array<ScenarioAction>;
	actionsConnection: ScenarioActionsConnection;
	agreement: BaseAgreement;
	agreementConnection: ScenarioAgreementConnection;
	conditions: Array<ScenarioCondition>;
	conditionsConnection: ScenarioConditionsConnection;
	group?: Maybe<Scalars["Int"]>;
	isForged?: Maybe<Scalars["Boolean"]>;
	isGrouped?: Maybe<Scalars["Boolean"]>;
	operator: ConditionLogicalOperator;
	order: Scalars["Int"];
};

export type ScenarioActionsArgs = {
	options?: InputMaybe<ScenarioActionOptions>;
	where?: InputMaybe<ScenarioActionWhere>;
};

export type ScenarioActionsConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<ScenarioActionsConnectionSort>>;
	where?: InputMaybe<ScenarioActionsConnectionWhere>;
};

export type ScenarioAgreementArgs = {
	options?: InputMaybe<BaseAgreementOptions>;
	where?: InputMaybe<BaseAgreementWhere>;
};

export type ScenarioAgreementConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<ScenarioAgreementConnectionSort>>;
	where?: InputMaybe<ScenarioAgreementConnectionWhere>;
};

export type ScenarioConditionsArgs = {
	options?: InputMaybe<ScenarioConditionOptions>;
	where?: InputMaybe<ScenarioConditionWhere>;
};

export type ScenarioConditionsConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<ScenarioConditionsConnectionSort>>;
	where?: InputMaybe<ScenarioConditionsConnectionWhere>;
};

export type ScenarioAction = ITimeframe & {
	__typename?: "ScenarioAction";
	actionType: ActionType;
	brand?: Maybe<Brand>;
	brandConnection: ScenarioActionBrandConnection;
	categories: Array<DeviceProductCategory>;
	categoriesConnection: ScenarioActionCategoriesConnection;
	combinedItemBrands: Array<Brand>;
	combinedItemBrandsConnection: ScenarioActionCombinedItemBrandsConnection;
	combinedItemTimeframeEnd?: Maybe<Scalars["Int"]>;
	combinedItemTimeframeRangeType?: Maybe<TimeframeRangeType>;
	combinedItemTimeframeStart?: Maybe<Scalars["Int"]>;
	combinedItemTreatments: Array<Treatment>;
	combinedItemTreatmentsConnection: ScenarioActionCombinedItemTreatmentsConnection;
	deviceKits: Array<DeviceKit>;
	deviceKitsConnection: ScenarioActionDeviceKitsConnection;
	endItemNumber?: Maybe<Scalars["Int"]>;
	itemCombinationRelation?: Maybe<ActionItemCombinationRelation>;
	itemCombinationRule?: Maybe<ActionItemCombinationRule>;
	itemRangeType?: Maybe<ActionItemRangeType>;
	itemScope: ItemScope;
	order: Scalars["Int"];
	priceType: PriceType;
	recordNature?: Maybe<RecordNature>;
	scenario: Scenario;
	scenarioConnection: ScenarioActionScenarioConnection;
	startItemNumber?: Maybe<Scalars["Int"]>;
	startingPoint?: Maybe<TimeframeStartingPoint>;
	timeframe?: Maybe<Timeframe>;
	timeframeConnection: ScenarioActionTimeframeConnection;
	timeframeEnd?: Maybe<Scalars["Int"]>;
	timeframeEndDate?: Maybe<Scalars["Date"]>;
	timeframeRangeType?: Maybe<TimeframeRangeType>;
	timeframeStart?: Maybe<Scalars["Int"]>;
	timeframeStartDate?: Maybe<Scalars["Date"]>;
	treatment?: Maybe<Treatment>;
	treatmentConnection: ScenarioActionTreatmentConnection;
	value: Scalars["Float"];
};

export type ScenarioActionBrandArgs = {
	options?: InputMaybe<BrandOptions>;
	where?: InputMaybe<BrandWhere>;
};

export type ScenarioActionBrandConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<ScenarioActionBrandConnectionSort>>;
	where?: InputMaybe<ScenarioActionBrandConnectionWhere>;
};

export type ScenarioActionCategoriesArgs = {
	options?: InputMaybe<DeviceProductCategoryOptions>;
	where?: InputMaybe<DeviceProductCategoryWhere>;
};

export type ScenarioActionCategoriesConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<ScenarioActionCategoriesConnectionSort>>;
	where?: InputMaybe<ScenarioActionCategoriesConnectionWhere>;
};

export type ScenarioActionCombinedItemBrandsArgs = {
	options?: InputMaybe<BrandOptions>;
	where?: InputMaybe<BrandWhere>;
};

export type ScenarioActionCombinedItemBrandsConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<ScenarioActionCombinedItemBrandsConnectionSort>>;
	where?: InputMaybe<ScenarioActionCombinedItemBrandsConnectionWhere>;
};

export type ScenarioActionCombinedItemTreatmentsArgs = {
	options?: InputMaybe<TreatmentOptions>;
	where?: InputMaybe<TreatmentWhere>;
};

export type ScenarioActionCombinedItemTreatmentsConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<ScenarioActionCombinedItemTreatmentsConnectionSort>>;
	where?: InputMaybe<ScenarioActionCombinedItemTreatmentsConnectionWhere>;
};

export type ScenarioActionDeviceKitsArgs = {
	options?: InputMaybe<DeviceKitOptions>;
	where?: InputMaybe<DeviceKitWhere>;
};

export type ScenarioActionDeviceKitsConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<ScenarioActionDeviceKitsConnectionSort>>;
	where?: InputMaybe<ScenarioActionDeviceKitsConnectionWhere>;
};

export type ScenarioActionScenarioArgs = {
	options?: InputMaybe<ScenarioOptions>;
	where?: InputMaybe<ScenarioWhere>;
};

export type ScenarioActionScenarioConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<ScenarioActionScenarioConnectionSort>>;
	where?: InputMaybe<ScenarioActionScenarioConnectionWhere>;
};

export type ScenarioActionTimeframeArgs = {
	options?: InputMaybe<TimeframeOptions>;
	where?: InputMaybe<TimeframeWhere>;
};

export type ScenarioActionTimeframeConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<ScenarioActionTimeframeConnectionSort>>;
	where?: InputMaybe<ScenarioActionTimeframeConnectionWhere>;
};

export type ScenarioActionTreatmentArgs = {
	options?: InputMaybe<TreatmentOptions>;
	where?: InputMaybe<TreatmentWhere>;
};

export type ScenarioActionTreatmentConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<ScenarioActionTreatmentConnectionSort>>;
	where?: InputMaybe<ScenarioActionTreatmentConnectionWhere>;
};

export type ScenarioActionAggregateSelection = {
	__typename?: "ScenarioActionAggregateSelection";
	combinedItemTimeframeEnd: IntAggregateSelection;
	combinedItemTimeframeStart: IntAggregateSelection;
	count: Scalars["Int"];
	endItemNumber: IntAggregateSelection;
	order: IntAggregateSelection;
	startItemNumber: IntAggregateSelection;
	timeframeEnd: IntAggregateSelection;
	timeframeStart: IntAggregateSelection;
	value: FloatAggregateSelection;
};

export type ScenarioActionBrandAggregateInput = {
	AND?: InputMaybe<Array<ScenarioActionBrandAggregateInput>>;
	OR?: InputMaybe<Array<ScenarioActionBrandAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<ScenarioActionBrandNodeAggregationWhereInput>;
};

export type ScenarioActionBrandConnectFieldInput = {
	connect?: InputMaybe<BrandConnectInput>;
	where?: InputMaybe<BrandConnectWhere>;
};

export type ScenarioActionBrandConnection = {
	__typename?: "ScenarioActionBrandConnection";
	edges: Array<ScenarioActionBrandRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type ScenarioActionBrandConnectionSort = {
	node?: InputMaybe<BrandSort>;
};

export type ScenarioActionBrandConnectionWhere = {
	AND?: InputMaybe<Array<ScenarioActionBrandConnectionWhere>>;
	OR?: InputMaybe<Array<ScenarioActionBrandConnectionWhere>>;
	node?: InputMaybe<BrandWhere>;
	node_NOT?: InputMaybe<BrandWhere>;
};

export type ScenarioActionBrandCreateFieldInput = {
	node: BrandCreateInput;
};

export type ScenarioActionBrandDeleteFieldInput = {
	delete?: InputMaybe<BrandDeleteInput>;
	where?: InputMaybe<ScenarioActionBrandConnectionWhere>;
};

export type ScenarioActionBrandDisconnectFieldInput = {
	disconnect?: InputMaybe<BrandDisconnectInput>;
	where?: InputMaybe<ScenarioActionBrandConnectionWhere>;
};

export type ScenarioActionBrandFieldInput = {
	connect?: InputMaybe<ScenarioActionBrandConnectFieldInput>;
	create?: InputMaybe<ScenarioActionBrandCreateFieldInput>;
};

export type ScenarioActionBrandNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<ScenarioActionBrandNodeAggregationWhereInput>>;
	Name_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	Name_EQUAL?: InputMaybe<Scalars["String"]>;
	Name_GT?: InputMaybe<Scalars["Int"]>;
	Name_GTE?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	Name_LT?: InputMaybe<Scalars["Int"]>;
	Name_LTE?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	OR?: InputMaybe<Array<ScenarioActionBrandNodeAggregationWhereInput>>;
};

export type ScenarioActionBrandRelationship = {
	__typename?: "ScenarioActionBrandRelationship";
	cursor: Scalars["String"];
	node: Brand;
};

export type ScenarioActionBrandUpdateConnectionInput = {
	node?: InputMaybe<BrandUpdateInput>;
};

export type ScenarioActionBrandUpdateFieldInput = {
	connect?: InputMaybe<ScenarioActionBrandConnectFieldInput>;
	create?: InputMaybe<ScenarioActionBrandCreateFieldInput>;
	delete?: InputMaybe<ScenarioActionBrandDeleteFieldInput>;
	disconnect?: InputMaybe<ScenarioActionBrandDisconnectFieldInput>;
	update?: InputMaybe<ScenarioActionBrandUpdateConnectionInput>;
	where?: InputMaybe<ScenarioActionBrandConnectionWhere>;
};

export type ScenarioActionCategoriesAggregateInput = {
	AND?: InputMaybe<Array<ScenarioActionCategoriesAggregateInput>>;
	OR?: InputMaybe<Array<ScenarioActionCategoriesAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<ScenarioActionCategoriesNodeAggregationWhereInput>;
};

export type ScenarioActionCategoriesConnectFieldInput = {
	connect?: InputMaybe<Array<DeviceProductCategoryConnectInput>>;
	where?: InputMaybe<DeviceProductCategoryConnectWhere>;
};

export type ScenarioActionCategoriesConnection = {
	__typename?: "ScenarioActionCategoriesConnection";
	edges: Array<ScenarioActionCategoriesRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type ScenarioActionCategoriesConnectionSort = {
	node?: InputMaybe<DeviceProductCategorySort>;
};

export type ScenarioActionCategoriesConnectionWhere = {
	AND?: InputMaybe<Array<ScenarioActionCategoriesConnectionWhere>>;
	OR?: InputMaybe<Array<ScenarioActionCategoriesConnectionWhere>>;
	node?: InputMaybe<DeviceProductCategoryWhere>;
	node_NOT?: InputMaybe<DeviceProductCategoryWhere>;
};

export type ScenarioActionCategoriesCreateFieldInput = {
	node: DeviceProductCategoryCreateInput;
};

export type ScenarioActionCategoriesDeleteFieldInput = {
	delete?: InputMaybe<DeviceProductCategoryDeleteInput>;
	where?: InputMaybe<ScenarioActionCategoriesConnectionWhere>;
};

export type ScenarioActionCategoriesDisconnectFieldInput = {
	disconnect?: InputMaybe<DeviceProductCategoryDisconnectInput>;
	where?: InputMaybe<ScenarioActionCategoriesConnectionWhere>;
};

export type ScenarioActionCategoriesFieldInput = {
	connect?: InputMaybe<Array<ScenarioActionCategoriesConnectFieldInput>>;
	create?: InputMaybe<Array<ScenarioActionCategoriesCreateFieldInput>>;
};

export type ScenarioActionCategoriesNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<ScenarioActionCategoriesNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<ScenarioActionCategoriesNodeAggregationWhereInput>>;
	code_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	code_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	code_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	code_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	code_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	code_EQUAL?: InputMaybe<Scalars["String"]>;
	code_GT?: InputMaybe<Scalars["Int"]>;
	code_GTE?: InputMaybe<Scalars["Int"]>;
	code_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	code_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	code_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	code_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	code_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	code_LT?: InputMaybe<Scalars["Int"]>;
	code_LTE?: InputMaybe<Scalars["Int"]>;
	code_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	code_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	code_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	code_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	code_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	level_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	level_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	level_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	level_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	level_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	level_EQUAL?: InputMaybe<Scalars["Int"]>;
	level_GT?: InputMaybe<Scalars["Int"]>;
	level_GTE?: InputMaybe<Scalars["Int"]>;
	level_LT?: InputMaybe<Scalars["Int"]>;
	level_LTE?: InputMaybe<Scalars["Int"]>;
	level_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	level_MAX_GT?: InputMaybe<Scalars["Int"]>;
	level_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	level_MAX_LT?: InputMaybe<Scalars["Int"]>;
	level_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	level_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	level_MIN_GT?: InputMaybe<Scalars["Int"]>;
	level_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	level_MIN_LT?: InputMaybe<Scalars["Int"]>;
	level_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	name_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	name_EQUAL?: InputMaybe<Scalars["String"]>;
	name_GT?: InputMaybe<Scalars["Int"]>;
	name_GTE?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	name_LT?: InputMaybe<Scalars["Int"]>;
	name_LTE?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	tenantId_EQUAL?: InputMaybe<Scalars["String"]>;
	tenantId_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type ScenarioActionCategoriesRelationship = {
	__typename?: "ScenarioActionCategoriesRelationship";
	cursor: Scalars["String"];
	node: DeviceProductCategory;
};

export type ScenarioActionCategoriesUpdateConnectionInput = {
	node?: InputMaybe<DeviceProductCategoryUpdateInput>;
};

export type ScenarioActionCategoriesUpdateFieldInput = {
	connect?: InputMaybe<Array<ScenarioActionCategoriesConnectFieldInput>>;
	create?: InputMaybe<Array<ScenarioActionCategoriesCreateFieldInput>>;
	delete?: InputMaybe<Array<ScenarioActionCategoriesDeleteFieldInput>>;
	disconnect?: InputMaybe<Array<ScenarioActionCategoriesDisconnectFieldInput>>;
	update?: InputMaybe<ScenarioActionCategoriesUpdateConnectionInput>;
	where?: InputMaybe<ScenarioActionCategoriesConnectionWhere>;
};

export type ScenarioActionCombinedItemBrandsAggregateInput = {
	AND?: InputMaybe<Array<ScenarioActionCombinedItemBrandsAggregateInput>>;
	OR?: InputMaybe<Array<ScenarioActionCombinedItemBrandsAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<ScenarioActionCombinedItemBrandsNodeAggregationWhereInput>;
};

export type ScenarioActionCombinedItemBrandsConnectFieldInput = {
	connect?: InputMaybe<Array<BrandConnectInput>>;
	where?: InputMaybe<BrandConnectWhere>;
};

export type ScenarioActionCombinedItemBrandsConnection = {
	__typename?: "ScenarioActionCombinedItemBrandsConnection";
	edges: Array<ScenarioActionCombinedItemBrandsRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type ScenarioActionCombinedItemBrandsConnectionSort = {
	node?: InputMaybe<BrandSort>;
};

export type ScenarioActionCombinedItemBrandsConnectionWhere = {
	AND?: InputMaybe<Array<ScenarioActionCombinedItemBrandsConnectionWhere>>;
	OR?: InputMaybe<Array<ScenarioActionCombinedItemBrandsConnectionWhere>>;
	node?: InputMaybe<BrandWhere>;
	node_NOT?: InputMaybe<BrandWhere>;
};

export type ScenarioActionCombinedItemBrandsCreateFieldInput = {
	node: BrandCreateInput;
};

export type ScenarioActionCombinedItemBrandsDeleteFieldInput = {
	delete?: InputMaybe<BrandDeleteInput>;
	where?: InputMaybe<ScenarioActionCombinedItemBrandsConnectionWhere>;
};

export type ScenarioActionCombinedItemBrandsDisconnectFieldInput = {
	disconnect?: InputMaybe<BrandDisconnectInput>;
	where?: InputMaybe<ScenarioActionCombinedItemBrandsConnectionWhere>;
};

export type ScenarioActionCombinedItemBrandsFieldInput = {
	connect?: InputMaybe<Array<ScenarioActionCombinedItemBrandsConnectFieldInput>>;
	create?: InputMaybe<Array<ScenarioActionCombinedItemBrandsCreateFieldInput>>;
};

export type ScenarioActionCombinedItemBrandsNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<ScenarioActionCombinedItemBrandsNodeAggregationWhereInput>>;
	Name_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	Name_EQUAL?: InputMaybe<Scalars["String"]>;
	Name_GT?: InputMaybe<Scalars["Int"]>;
	Name_GTE?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	Name_LT?: InputMaybe<Scalars["Int"]>;
	Name_LTE?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	OR?: InputMaybe<Array<ScenarioActionCombinedItemBrandsNodeAggregationWhereInput>>;
};

export type ScenarioActionCombinedItemBrandsRelationship = {
	__typename?: "ScenarioActionCombinedItemBrandsRelationship";
	cursor: Scalars["String"];
	node: Brand;
};

export type ScenarioActionCombinedItemBrandsUpdateConnectionInput = {
	node?: InputMaybe<BrandUpdateInput>;
};

export type ScenarioActionCombinedItemBrandsUpdateFieldInput = {
	connect?: InputMaybe<Array<ScenarioActionCombinedItemBrandsConnectFieldInput>>;
	create?: InputMaybe<Array<ScenarioActionCombinedItemBrandsCreateFieldInput>>;
	delete?: InputMaybe<Array<ScenarioActionCombinedItemBrandsDeleteFieldInput>>;
	disconnect?: InputMaybe<Array<ScenarioActionCombinedItemBrandsDisconnectFieldInput>>;
	update?: InputMaybe<ScenarioActionCombinedItemBrandsUpdateConnectionInput>;
	where?: InputMaybe<ScenarioActionCombinedItemBrandsConnectionWhere>;
};

export type ScenarioActionCombinedItemTreatmentsAggregateInput = {
	AND?: InputMaybe<Array<ScenarioActionCombinedItemTreatmentsAggregateInput>>;
	OR?: InputMaybe<Array<ScenarioActionCombinedItemTreatmentsAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<ScenarioActionCombinedItemTreatmentsNodeAggregationWhereInput>;
};

export type ScenarioActionCombinedItemTreatmentsConnectFieldInput = {
	connect?: InputMaybe<Array<TreatmentConnectInput>>;
	where?: InputMaybe<TreatmentConnectWhere>;
};

export type ScenarioActionCombinedItemTreatmentsConnection = {
	__typename?: "ScenarioActionCombinedItemTreatmentsConnection";
	edges: Array<ScenarioActionCombinedItemTreatmentsRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type ScenarioActionCombinedItemTreatmentsConnectionSort = {
	node?: InputMaybe<TreatmentSort>;
};

export type ScenarioActionCombinedItemTreatmentsConnectionWhere = {
	AND?: InputMaybe<Array<ScenarioActionCombinedItemTreatmentsConnectionWhere>>;
	OR?: InputMaybe<Array<ScenarioActionCombinedItemTreatmentsConnectionWhere>>;
	node?: InputMaybe<TreatmentWhere>;
	node_NOT?: InputMaybe<TreatmentWhere>;
};

export type ScenarioActionCombinedItemTreatmentsCreateFieldInput = {
	node: TreatmentCreateInput;
};

export type ScenarioActionCombinedItemTreatmentsDeleteFieldInput = {
	delete?: InputMaybe<TreatmentDeleteInput>;
	where?: InputMaybe<ScenarioActionCombinedItemTreatmentsConnectionWhere>;
};

export type ScenarioActionCombinedItemTreatmentsDisconnectFieldInput = {
	disconnect?: InputMaybe<TreatmentDisconnectInput>;
	where?: InputMaybe<ScenarioActionCombinedItemTreatmentsConnectionWhere>;
};

export type ScenarioActionCombinedItemTreatmentsFieldInput = {
	connect?: InputMaybe<Array<ScenarioActionCombinedItemTreatmentsConnectFieldInput>>;
	create?: InputMaybe<Array<ScenarioActionCombinedItemTreatmentsCreateFieldInput>>;
};

export type ScenarioActionCombinedItemTreatmentsNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<ScenarioActionCombinedItemTreatmentsNodeAggregationWhereInput>>;
	BagDossierNo_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	BagDossierNo_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	BagDossierNo_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	BagDossierNo_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	BagDossierNo_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	BagDossierNo_EQUAL?: InputMaybe<Scalars["String"]>;
	BagDossierNo_GT?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_GTE?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LT?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LTE?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	Code_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	Code_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	Code_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	Code_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	Code_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	Code_EQUAL?: InputMaybe<Scalars["String"]>;
	Code_GT?: InputMaybe<Scalars["Int"]>;
	Code_GTE?: InputMaybe<Scalars["Int"]>;
	Code_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Code_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	Code_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	Code_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	Code_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	Code_LT?: InputMaybe<Scalars["Int"]>;
	Code_LTE?: InputMaybe<Scalars["Int"]>;
	Code_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Code_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	Code_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	Code_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	Code_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	FlagModal_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	FlagModal_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	FlagModal_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	FlagModal_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	FlagModal_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	FlagModal_EQUAL?: InputMaybe<Scalars["String"]>;
	FlagModal_GT?: InputMaybe<Scalars["Int"]>;
	FlagModal_GTE?: InputMaybe<Scalars["Int"]>;
	FlagModal_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	FlagModal_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	FlagModal_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	FlagModal_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	FlagModal_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	FlagModal_LT?: InputMaybe<Scalars["Int"]>;
	FlagModal_LTE?: InputMaybe<Scalars["Int"]>;
	FlagModal_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	FlagModal_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	FlagModal_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	FlagModal_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	FlagModal_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	FlagNarcosis_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	FlagNarcosis_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	FlagNarcosis_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	FlagNarcosis_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	FlagNarcosis_EQUAL?: InputMaybe<Scalars["String"]>;
	FlagNarcosis_GT?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_GTE?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LT?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LTE?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	GTIN_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	GTIN_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	GTIN_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	GTIN_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	GTIN_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	GTIN_EQUAL?: InputMaybe<Scalars["String"]>;
	GTIN_GT?: InputMaybe<Scalars["Int"]>;
	GTIN_GTE?: InputMaybe<Scalars["Int"]>;
	GTIN_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	GTIN_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	GTIN_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	GTIN_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	GTIN_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	GTIN_LT?: InputMaybe<Scalars["Int"]>;
	GTIN_LTE?: InputMaybe<Scalars["Int"]>;
	GTIN_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	GTIN_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	GTIN_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	GTIN_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	GTIN_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	LOT_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	LOT_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	LOT_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	LOT_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	LOT_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	LOT_EQUAL?: InputMaybe<Scalars["String"]>;
	LOT_GT?: InputMaybe<Scalars["Int"]>;
	LOT_GTE?: InputMaybe<Scalars["Int"]>;
	LOT_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	LOT_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	LOT_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	LOT_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	LOT_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	LOT_LT?: InputMaybe<Scalars["Int"]>;
	LOT_LTE?: InputMaybe<Scalars["Int"]>;
	LOT_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	LOT_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	LOT_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	LOT_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	LOT_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	Name_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	Name_EQUAL?: InputMaybe<Scalars["String"]>;
	Name_GT?: InputMaybe<Scalars["Int"]>;
	Name_GTE?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	Name_LT?: InputMaybe<Scalars["Int"]>;
	Name_LTE?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	OR?: InputMaybe<Array<ScenarioActionCombinedItemTreatmentsNodeAggregationWhereInput>>;
	PharmaCode_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	PharmaCode_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	PharmaCode_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	PharmaCode_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	PharmaCode_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	PharmaCode_EQUAL?: InputMaybe<Scalars["String"]>;
	PharmaCode_GT?: InputMaybe<Scalars["Int"]>;
	PharmaCode_GTE?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LT?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LTE?: InputMaybe<Scalars["Int"]>;
	PharmaCode_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	PharmaCode_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	PharmaCode_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	PharmaCode_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	PharmaCode_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	PrevPharmacode_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	PrevPharmacode_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	PrevPharmacode_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	PrevPharmacode_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	PrevPharmacode_EQUAL?: InputMaybe<Scalars["String"]>;
	PrevPharmacode_GT?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_GTE?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LT?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LTE?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	REF_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	REF_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	REF_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	REF_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	REF_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	REF_EQUAL?: InputMaybe<Scalars["String"]>;
	REF_GT?: InputMaybe<Scalars["Int"]>;
	REF_GTE?: InputMaybe<Scalars["Int"]>;
	REF_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	REF_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	REF_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	REF_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	REF_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	REF_LT?: InputMaybe<Scalars["Int"]>;
	REF_LTE?: InputMaybe<Scalars["Int"]>;
	REF_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	REF_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	REF_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	REF_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	REF_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	SwissmedicCategory_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	SwissmedicCategory_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	SwissmedicCategory_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	SwissmedicCategory_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	SwissmedicCategory_EQUAL?: InputMaybe<Scalars["String"]>;
	SwissmedicCategory_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo8_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo8_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo8_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo8_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo8_EQUAL?: InputMaybe<Scalars["String"]>;
	SwissmedicNo8_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	UDI_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	UDI_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	UDI_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	UDI_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	UDI_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	UDI_EQUAL?: InputMaybe<Scalars["String"]>;
	UDI_GT?: InputMaybe<Scalars["Int"]>;
	UDI_GTE?: InputMaybe<Scalars["Int"]>;
	UDI_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	UDI_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	UDI_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	UDI_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	UDI_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	UDI_LT?: InputMaybe<Scalars["Int"]>;
	UDI_LTE?: InputMaybe<Scalars["Int"]>;
	UDI_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	UDI_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	UDI_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	UDI_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	UDI_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	classificationSystem_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	classificationSystem_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	classificationSystem_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	classificationSystem_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	classificationSystem_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	classificationSystem_EQUAL?: InputMaybe<Scalars["String"]>;
	classificationSystem_GT?: InputMaybe<Scalars["Int"]>;
	classificationSystem_GTE?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LT?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LTE?: InputMaybe<Scalars["Int"]>;
	classificationSystem_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	classificationSystem_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	classificationSystem_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	classificationSystem_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	classificationSystem_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type ScenarioActionCombinedItemTreatmentsRelationship = {
	__typename?: "ScenarioActionCombinedItemTreatmentsRelationship";
	cursor: Scalars["String"];
	node: Treatment;
};

export type ScenarioActionCombinedItemTreatmentsUpdateConnectionInput = {
	node?: InputMaybe<TreatmentUpdateInput>;
};

export type ScenarioActionCombinedItemTreatmentsUpdateFieldInput = {
	connect?: InputMaybe<Array<ScenarioActionCombinedItemTreatmentsConnectFieldInput>>;
	create?: InputMaybe<Array<ScenarioActionCombinedItemTreatmentsCreateFieldInput>>;
	delete?: InputMaybe<Array<ScenarioActionCombinedItemTreatmentsDeleteFieldInput>>;
	disconnect?: InputMaybe<Array<ScenarioActionCombinedItemTreatmentsDisconnectFieldInput>>;
	update?: InputMaybe<ScenarioActionCombinedItemTreatmentsUpdateConnectionInput>;
	where?: InputMaybe<ScenarioActionCombinedItemTreatmentsConnectionWhere>;
};

export type ScenarioActionConnectInput = {
	brand?: InputMaybe<ScenarioActionBrandConnectFieldInput>;
	categories?: InputMaybe<Array<ScenarioActionCategoriesConnectFieldInput>>;
	combinedItemBrands?: InputMaybe<Array<ScenarioActionCombinedItemBrandsConnectFieldInput>>;
	combinedItemTreatments?: InputMaybe<Array<ScenarioActionCombinedItemTreatmentsConnectFieldInput>>;
	deviceKits?: InputMaybe<Array<ScenarioActionDeviceKitsConnectFieldInput>>;
	scenario?: InputMaybe<ScenarioActionScenarioConnectFieldInput>;
	timeframe?: InputMaybe<ScenarioActionTimeframeConnectFieldInput>;
	treatment?: InputMaybe<ScenarioActionTreatmentConnectFieldInput>;
};

export type ScenarioActionConnectWhere = {
	node: ScenarioActionWhere;
};

export type ScenarioActionCreateInput = {
	actionType: ActionType;
	brand?: InputMaybe<ScenarioActionBrandFieldInput>;
	categories?: InputMaybe<ScenarioActionCategoriesFieldInput>;
	combinedItemBrands?: InputMaybe<ScenarioActionCombinedItemBrandsFieldInput>;
	combinedItemTimeframeEnd?: InputMaybe<Scalars["Int"]>;
	combinedItemTimeframeRangeType?: InputMaybe<TimeframeRangeType>;
	combinedItemTimeframeStart?: InputMaybe<Scalars["Int"]>;
	combinedItemTreatments?: InputMaybe<ScenarioActionCombinedItemTreatmentsFieldInput>;
	deviceKits?: InputMaybe<ScenarioActionDeviceKitsFieldInput>;
	endItemNumber?: InputMaybe<Scalars["Int"]>;
	itemCombinationRelation?: InputMaybe<ActionItemCombinationRelation>;
	itemCombinationRule?: InputMaybe<ActionItemCombinationRule>;
	itemRangeType?: InputMaybe<ActionItemRangeType>;
	itemScope: ItemScope;
	order: Scalars["Int"];
	priceType: PriceType;
	recordNature?: InputMaybe<RecordNature>;
	scenario?: InputMaybe<ScenarioActionScenarioFieldInput>;
	startItemNumber?: InputMaybe<Scalars["Int"]>;
	startingPoint?: InputMaybe<TimeframeStartingPoint>;
	timeframe?: InputMaybe<ScenarioActionTimeframeFieldInput>;
	timeframeEnd?: InputMaybe<Scalars["Int"]>;
	timeframeEndDate?: InputMaybe<Scalars["Date"]>;
	timeframeRangeType?: InputMaybe<TimeframeRangeType>;
	timeframeStart?: InputMaybe<Scalars["Int"]>;
	timeframeStartDate?: InputMaybe<Scalars["Date"]>;
	treatment?: InputMaybe<ScenarioActionTreatmentFieldInput>;
	value: Scalars["Float"];
};

export type ScenarioActionDeleteInput = {
	brand?: InputMaybe<ScenarioActionBrandDeleteFieldInput>;
	categories?: InputMaybe<Array<ScenarioActionCategoriesDeleteFieldInput>>;
	combinedItemBrands?: InputMaybe<Array<ScenarioActionCombinedItemBrandsDeleteFieldInput>>;
	combinedItemTreatments?: InputMaybe<Array<ScenarioActionCombinedItemTreatmentsDeleteFieldInput>>;
	deviceKits?: InputMaybe<Array<ScenarioActionDeviceKitsDeleteFieldInput>>;
	scenario?: InputMaybe<ScenarioActionScenarioDeleteFieldInput>;
	timeframe?: InputMaybe<ScenarioActionTimeframeDeleteFieldInput>;
	treatment?: InputMaybe<ScenarioActionTreatmentDeleteFieldInput>;
};

export type ScenarioActionDeviceKitsAggregateInput = {
	AND?: InputMaybe<Array<ScenarioActionDeviceKitsAggregateInput>>;
	OR?: InputMaybe<Array<ScenarioActionDeviceKitsAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<ScenarioActionDeviceKitsNodeAggregationWhereInput>;
};

export type ScenarioActionDeviceKitsConnectFieldInput = {
	where?: InputMaybe<DeviceKitConnectWhere>;
};

export type ScenarioActionDeviceKitsConnection = {
	__typename?: "ScenarioActionDeviceKitsConnection";
	edges: Array<ScenarioActionDeviceKitsRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type ScenarioActionDeviceKitsConnectionSort = {
	node?: InputMaybe<DeviceKitSort>;
};

export type ScenarioActionDeviceKitsConnectionWhere = {
	AND?: InputMaybe<Array<ScenarioActionDeviceKitsConnectionWhere>>;
	OR?: InputMaybe<Array<ScenarioActionDeviceKitsConnectionWhere>>;
	node?: InputMaybe<DeviceKitWhere>;
	node_NOT?: InputMaybe<DeviceKitWhere>;
};

export type ScenarioActionDeviceKitsCreateFieldInput = {
	node: DeviceKitCreateInput;
};

export type ScenarioActionDeviceKitsDeleteFieldInput = {
	where?: InputMaybe<ScenarioActionDeviceKitsConnectionWhere>;
};

export type ScenarioActionDeviceKitsDisconnectFieldInput = {
	where?: InputMaybe<ScenarioActionDeviceKitsConnectionWhere>;
};

export type ScenarioActionDeviceKitsFieldInput = {
	connect?: InputMaybe<Array<ScenarioActionDeviceKitsConnectFieldInput>>;
	create?: InputMaybe<Array<ScenarioActionDeviceKitsCreateFieldInput>>;
};

export type ScenarioActionDeviceKitsNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<ScenarioActionDeviceKitsNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<ScenarioActionDeviceKitsNodeAggregationWhereInput>>;
	name_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	name_EQUAL?: InputMaybe<Scalars["String"]>;
	name_GT?: InputMaybe<Scalars["Int"]>;
	name_GTE?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	name_LT?: InputMaybe<Scalars["Int"]>;
	name_LTE?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	ref_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	ref_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	ref_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	ref_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	ref_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	ref_EQUAL?: InputMaybe<Scalars["String"]>;
	ref_GT?: InputMaybe<Scalars["Int"]>;
	ref_GTE?: InputMaybe<Scalars["Int"]>;
	ref_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	ref_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	ref_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	ref_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	ref_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	ref_LT?: InputMaybe<Scalars["Int"]>;
	ref_LTE?: InputMaybe<Scalars["Int"]>;
	ref_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	ref_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	ref_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	ref_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	ref_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	tenantId_EQUAL?: InputMaybe<Scalars["String"]>;
	tenantId_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type ScenarioActionDeviceKitsRelationship = {
	__typename?: "ScenarioActionDeviceKitsRelationship";
	cursor: Scalars["String"];
	node: DeviceKit;
};

export type ScenarioActionDeviceKitsUpdateConnectionInput = {
	node?: InputMaybe<DeviceKitUpdateInput>;
};

export type ScenarioActionDeviceKitsUpdateFieldInput = {
	connect?: InputMaybe<Array<ScenarioActionDeviceKitsConnectFieldInput>>;
	create?: InputMaybe<Array<ScenarioActionDeviceKitsCreateFieldInput>>;
	delete?: InputMaybe<Array<ScenarioActionDeviceKitsDeleteFieldInput>>;
	disconnect?: InputMaybe<Array<ScenarioActionDeviceKitsDisconnectFieldInput>>;
	update?: InputMaybe<ScenarioActionDeviceKitsUpdateConnectionInput>;
	where?: InputMaybe<ScenarioActionDeviceKitsConnectionWhere>;
};

export type ScenarioActionDisconnectInput = {
	brand?: InputMaybe<ScenarioActionBrandDisconnectFieldInput>;
	categories?: InputMaybe<Array<ScenarioActionCategoriesDisconnectFieldInput>>;
	combinedItemBrands?: InputMaybe<Array<ScenarioActionCombinedItemBrandsDisconnectFieldInput>>;
	combinedItemTreatments?: InputMaybe<Array<ScenarioActionCombinedItemTreatmentsDisconnectFieldInput>>;
	deviceKits?: InputMaybe<Array<ScenarioActionDeviceKitsDisconnectFieldInput>>;
	scenario?: InputMaybe<ScenarioActionScenarioDisconnectFieldInput>;
	timeframe?: InputMaybe<ScenarioActionTimeframeDisconnectFieldInput>;
	treatment?: InputMaybe<ScenarioActionTreatmentDisconnectFieldInput>;
};

export type ScenarioActionOptions = {
	limit?: InputMaybe<Scalars["Int"]>;
	offset?: InputMaybe<Scalars["Int"]>;
	/** Specify one or more ScenarioActionSort objects to sort ScenarioActions by. The sorts will be applied in the order in which they are arranged in the array. */
	sort?: InputMaybe<Array<InputMaybe<ScenarioActionSort>>>;
};

export type ScenarioActionScenarioAggregateInput = {
	AND?: InputMaybe<Array<ScenarioActionScenarioAggregateInput>>;
	OR?: InputMaybe<Array<ScenarioActionScenarioAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<ScenarioActionScenarioNodeAggregationWhereInput>;
};

export type ScenarioActionScenarioConnectFieldInput = {
	connect?: InputMaybe<ScenarioConnectInput>;
	where?: InputMaybe<ScenarioConnectWhere>;
};

export type ScenarioActionScenarioConnection = {
	__typename?: "ScenarioActionScenarioConnection";
	edges: Array<ScenarioActionScenarioRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type ScenarioActionScenarioConnectionSort = {
	node?: InputMaybe<ScenarioSort>;
};

export type ScenarioActionScenarioConnectionWhere = {
	AND?: InputMaybe<Array<ScenarioActionScenarioConnectionWhere>>;
	OR?: InputMaybe<Array<ScenarioActionScenarioConnectionWhere>>;
	node?: InputMaybe<ScenarioWhere>;
	node_NOT?: InputMaybe<ScenarioWhere>;
};

export type ScenarioActionScenarioCreateFieldInput = {
	node: ScenarioCreateInput;
};

export type ScenarioActionScenarioDeleteFieldInput = {
	delete?: InputMaybe<ScenarioDeleteInput>;
	where?: InputMaybe<ScenarioActionScenarioConnectionWhere>;
};

export type ScenarioActionScenarioDisconnectFieldInput = {
	disconnect?: InputMaybe<ScenarioDisconnectInput>;
	where?: InputMaybe<ScenarioActionScenarioConnectionWhere>;
};

export type ScenarioActionScenarioFieldInput = {
	connect?: InputMaybe<ScenarioActionScenarioConnectFieldInput>;
	create?: InputMaybe<ScenarioActionScenarioCreateFieldInput>;
};

export type ScenarioActionScenarioNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<ScenarioActionScenarioNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<ScenarioActionScenarioNodeAggregationWhereInput>>;
	group_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	group_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	group_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	group_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	group_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	group_EQUAL?: InputMaybe<Scalars["Int"]>;
	group_GT?: InputMaybe<Scalars["Int"]>;
	group_GTE?: InputMaybe<Scalars["Int"]>;
	group_LT?: InputMaybe<Scalars["Int"]>;
	group_LTE?: InputMaybe<Scalars["Int"]>;
	group_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	group_MAX_GT?: InputMaybe<Scalars["Int"]>;
	group_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	group_MAX_LT?: InputMaybe<Scalars["Int"]>;
	group_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	group_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	group_MIN_GT?: InputMaybe<Scalars["Int"]>;
	group_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	group_MIN_LT?: InputMaybe<Scalars["Int"]>;
	group_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	order_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	order_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	order_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	order_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	order_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	order_EQUAL?: InputMaybe<Scalars["Int"]>;
	order_GT?: InputMaybe<Scalars["Int"]>;
	order_GTE?: InputMaybe<Scalars["Int"]>;
	order_LT?: InputMaybe<Scalars["Int"]>;
	order_LTE?: InputMaybe<Scalars["Int"]>;
	order_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	order_MAX_GT?: InputMaybe<Scalars["Int"]>;
	order_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	order_MAX_LT?: InputMaybe<Scalars["Int"]>;
	order_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	order_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	order_MIN_GT?: InputMaybe<Scalars["Int"]>;
	order_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	order_MIN_LT?: InputMaybe<Scalars["Int"]>;
	order_MIN_LTE?: InputMaybe<Scalars["Int"]>;
};

export type ScenarioActionScenarioRelationship = {
	__typename?: "ScenarioActionScenarioRelationship";
	cursor: Scalars["String"];
	node: Scenario;
};

export type ScenarioActionScenarioUpdateConnectionInput = {
	node?: InputMaybe<ScenarioUpdateInput>;
};

export type ScenarioActionScenarioUpdateFieldInput = {
	connect?: InputMaybe<ScenarioActionScenarioConnectFieldInput>;
	create?: InputMaybe<ScenarioActionScenarioCreateFieldInput>;
	delete?: InputMaybe<ScenarioActionScenarioDeleteFieldInput>;
	disconnect?: InputMaybe<ScenarioActionScenarioDisconnectFieldInput>;
	update?: InputMaybe<ScenarioActionScenarioUpdateConnectionInput>;
	where?: InputMaybe<ScenarioActionScenarioConnectionWhere>;
};

/** Fields to sort ScenarioActions by. The order in which sorts are applied is not guaranteed when specifying many fields in one ScenarioActionSort object. */
export type ScenarioActionSort = {
	actionType?: InputMaybe<SortDirection>;
	combinedItemTimeframeEnd?: InputMaybe<SortDirection>;
	combinedItemTimeframeRangeType?: InputMaybe<SortDirection>;
	combinedItemTimeframeStart?: InputMaybe<SortDirection>;
	endItemNumber?: InputMaybe<SortDirection>;
	itemCombinationRelation?: InputMaybe<SortDirection>;
	itemCombinationRule?: InputMaybe<SortDirection>;
	itemRangeType?: InputMaybe<SortDirection>;
	itemScope?: InputMaybe<SortDirection>;
	order?: InputMaybe<SortDirection>;
	priceType?: InputMaybe<SortDirection>;
	recordNature?: InputMaybe<SortDirection>;
	startItemNumber?: InputMaybe<SortDirection>;
	startingPoint?: InputMaybe<SortDirection>;
	timeframeEnd?: InputMaybe<SortDirection>;
	timeframeEndDate?: InputMaybe<SortDirection>;
	timeframeRangeType?: InputMaybe<SortDirection>;
	timeframeStart?: InputMaybe<SortDirection>;
	timeframeStartDate?: InputMaybe<SortDirection>;
	value?: InputMaybe<SortDirection>;
};

export type ScenarioActionTimeframeAggregateInput = {
	AND?: InputMaybe<Array<ScenarioActionTimeframeAggregateInput>>;
	OR?: InputMaybe<Array<ScenarioActionTimeframeAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<ScenarioActionTimeframeNodeAggregationWhereInput>;
};

export type ScenarioActionTimeframeConnectFieldInput = {
	where?: InputMaybe<TimeframeConnectWhere>;
};

export type ScenarioActionTimeframeConnection = {
	__typename?: "ScenarioActionTimeframeConnection";
	edges: Array<ScenarioActionTimeframeRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type ScenarioActionTimeframeConnectionSort = {
	node?: InputMaybe<TimeframeSort>;
};

export type ScenarioActionTimeframeConnectionWhere = {
	AND?: InputMaybe<Array<ScenarioActionTimeframeConnectionWhere>>;
	OR?: InputMaybe<Array<ScenarioActionTimeframeConnectionWhere>>;
	node?: InputMaybe<TimeframeWhere>;
	node_NOT?: InputMaybe<TimeframeWhere>;
};

export type ScenarioActionTimeframeCreateFieldInput = {
	node: TimeframeCreateInput;
};

export type ScenarioActionTimeframeDeleteFieldInput = {
	where?: InputMaybe<ScenarioActionTimeframeConnectionWhere>;
};

export type ScenarioActionTimeframeDisconnectFieldInput = {
	where?: InputMaybe<ScenarioActionTimeframeConnectionWhere>;
};

export type ScenarioActionTimeframeFieldInput = {
	connect?: InputMaybe<ScenarioActionTimeframeConnectFieldInput>;
	create?: InputMaybe<ScenarioActionTimeframeCreateFieldInput>;
};

export type ScenarioActionTimeframeNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<ScenarioActionTimeframeNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<ScenarioActionTimeframeNodeAggregationWhereInput>>;
	name_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	name_EQUAL?: InputMaybe<Scalars["String"]>;
	name_GT?: InputMaybe<Scalars["Int"]>;
	name_GTE?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	name_LT?: InputMaybe<Scalars["Int"]>;
	name_LTE?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type ScenarioActionTimeframeRelationship = {
	__typename?: "ScenarioActionTimeframeRelationship";
	cursor: Scalars["String"];
	node: Timeframe;
};

export type ScenarioActionTimeframeUpdateConnectionInput = {
	node?: InputMaybe<TimeframeUpdateInput>;
};

export type ScenarioActionTimeframeUpdateFieldInput = {
	connect?: InputMaybe<ScenarioActionTimeframeConnectFieldInput>;
	create?: InputMaybe<ScenarioActionTimeframeCreateFieldInput>;
	delete?: InputMaybe<ScenarioActionTimeframeDeleteFieldInput>;
	disconnect?: InputMaybe<ScenarioActionTimeframeDisconnectFieldInput>;
	update?: InputMaybe<ScenarioActionTimeframeUpdateConnectionInput>;
	where?: InputMaybe<ScenarioActionTimeframeConnectionWhere>;
};

export type ScenarioActionTreatmentAggregateInput = {
	AND?: InputMaybe<Array<ScenarioActionTreatmentAggregateInput>>;
	OR?: InputMaybe<Array<ScenarioActionTreatmentAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<ScenarioActionTreatmentNodeAggregationWhereInput>;
};

export type ScenarioActionTreatmentConnectFieldInput = {
	connect?: InputMaybe<TreatmentConnectInput>;
	where?: InputMaybe<TreatmentConnectWhere>;
};

export type ScenarioActionTreatmentConnection = {
	__typename?: "ScenarioActionTreatmentConnection";
	edges: Array<ScenarioActionTreatmentRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type ScenarioActionTreatmentConnectionSort = {
	node?: InputMaybe<TreatmentSort>;
};

export type ScenarioActionTreatmentConnectionWhere = {
	AND?: InputMaybe<Array<ScenarioActionTreatmentConnectionWhere>>;
	OR?: InputMaybe<Array<ScenarioActionTreatmentConnectionWhere>>;
	node?: InputMaybe<TreatmentWhere>;
	node_NOT?: InputMaybe<TreatmentWhere>;
};

export type ScenarioActionTreatmentCreateFieldInput = {
	node: TreatmentCreateInput;
};

export type ScenarioActionTreatmentDeleteFieldInput = {
	delete?: InputMaybe<TreatmentDeleteInput>;
	where?: InputMaybe<ScenarioActionTreatmentConnectionWhere>;
};

export type ScenarioActionTreatmentDisconnectFieldInput = {
	disconnect?: InputMaybe<TreatmentDisconnectInput>;
	where?: InputMaybe<ScenarioActionTreatmentConnectionWhere>;
};

export type ScenarioActionTreatmentFieldInput = {
	connect?: InputMaybe<ScenarioActionTreatmentConnectFieldInput>;
	create?: InputMaybe<ScenarioActionTreatmentCreateFieldInput>;
};

export type ScenarioActionTreatmentNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<ScenarioActionTreatmentNodeAggregationWhereInput>>;
	BagDossierNo_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	BagDossierNo_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	BagDossierNo_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	BagDossierNo_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	BagDossierNo_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	BagDossierNo_EQUAL?: InputMaybe<Scalars["String"]>;
	BagDossierNo_GT?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_GTE?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LT?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LTE?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	Code_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	Code_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	Code_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	Code_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	Code_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	Code_EQUAL?: InputMaybe<Scalars["String"]>;
	Code_GT?: InputMaybe<Scalars["Int"]>;
	Code_GTE?: InputMaybe<Scalars["Int"]>;
	Code_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Code_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	Code_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	Code_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	Code_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	Code_LT?: InputMaybe<Scalars["Int"]>;
	Code_LTE?: InputMaybe<Scalars["Int"]>;
	Code_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Code_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	Code_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	Code_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	Code_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	FlagModal_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	FlagModal_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	FlagModal_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	FlagModal_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	FlagModal_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	FlagModal_EQUAL?: InputMaybe<Scalars["String"]>;
	FlagModal_GT?: InputMaybe<Scalars["Int"]>;
	FlagModal_GTE?: InputMaybe<Scalars["Int"]>;
	FlagModal_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	FlagModal_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	FlagModal_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	FlagModal_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	FlagModal_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	FlagModal_LT?: InputMaybe<Scalars["Int"]>;
	FlagModal_LTE?: InputMaybe<Scalars["Int"]>;
	FlagModal_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	FlagModal_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	FlagModal_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	FlagModal_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	FlagModal_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	FlagNarcosis_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	FlagNarcosis_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	FlagNarcosis_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	FlagNarcosis_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	FlagNarcosis_EQUAL?: InputMaybe<Scalars["String"]>;
	FlagNarcosis_GT?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_GTE?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LT?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LTE?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	GTIN_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	GTIN_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	GTIN_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	GTIN_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	GTIN_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	GTIN_EQUAL?: InputMaybe<Scalars["String"]>;
	GTIN_GT?: InputMaybe<Scalars["Int"]>;
	GTIN_GTE?: InputMaybe<Scalars["Int"]>;
	GTIN_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	GTIN_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	GTIN_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	GTIN_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	GTIN_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	GTIN_LT?: InputMaybe<Scalars["Int"]>;
	GTIN_LTE?: InputMaybe<Scalars["Int"]>;
	GTIN_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	GTIN_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	GTIN_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	GTIN_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	GTIN_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	LOT_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	LOT_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	LOT_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	LOT_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	LOT_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	LOT_EQUAL?: InputMaybe<Scalars["String"]>;
	LOT_GT?: InputMaybe<Scalars["Int"]>;
	LOT_GTE?: InputMaybe<Scalars["Int"]>;
	LOT_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	LOT_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	LOT_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	LOT_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	LOT_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	LOT_LT?: InputMaybe<Scalars["Int"]>;
	LOT_LTE?: InputMaybe<Scalars["Int"]>;
	LOT_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	LOT_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	LOT_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	LOT_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	LOT_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	Name_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	Name_EQUAL?: InputMaybe<Scalars["String"]>;
	Name_GT?: InputMaybe<Scalars["Int"]>;
	Name_GTE?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	Name_LT?: InputMaybe<Scalars["Int"]>;
	Name_LTE?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	OR?: InputMaybe<Array<ScenarioActionTreatmentNodeAggregationWhereInput>>;
	PharmaCode_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	PharmaCode_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	PharmaCode_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	PharmaCode_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	PharmaCode_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	PharmaCode_EQUAL?: InputMaybe<Scalars["String"]>;
	PharmaCode_GT?: InputMaybe<Scalars["Int"]>;
	PharmaCode_GTE?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LT?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LTE?: InputMaybe<Scalars["Int"]>;
	PharmaCode_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	PharmaCode_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	PharmaCode_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	PharmaCode_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	PharmaCode_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	PrevPharmacode_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	PrevPharmacode_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	PrevPharmacode_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	PrevPharmacode_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	PrevPharmacode_EQUAL?: InputMaybe<Scalars["String"]>;
	PrevPharmacode_GT?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_GTE?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LT?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LTE?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	REF_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	REF_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	REF_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	REF_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	REF_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	REF_EQUAL?: InputMaybe<Scalars["String"]>;
	REF_GT?: InputMaybe<Scalars["Int"]>;
	REF_GTE?: InputMaybe<Scalars["Int"]>;
	REF_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	REF_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	REF_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	REF_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	REF_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	REF_LT?: InputMaybe<Scalars["Int"]>;
	REF_LTE?: InputMaybe<Scalars["Int"]>;
	REF_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	REF_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	REF_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	REF_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	REF_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	SwissmedicCategory_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	SwissmedicCategory_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	SwissmedicCategory_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	SwissmedicCategory_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	SwissmedicCategory_EQUAL?: InputMaybe<Scalars["String"]>;
	SwissmedicCategory_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo8_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo8_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo8_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo8_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo8_EQUAL?: InputMaybe<Scalars["String"]>;
	SwissmedicNo8_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	UDI_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	UDI_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	UDI_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	UDI_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	UDI_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	UDI_EQUAL?: InputMaybe<Scalars["String"]>;
	UDI_GT?: InputMaybe<Scalars["Int"]>;
	UDI_GTE?: InputMaybe<Scalars["Int"]>;
	UDI_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	UDI_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	UDI_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	UDI_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	UDI_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	UDI_LT?: InputMaybe<Scalars["Int"]>;
	UDI_LTE?: InputMaybe<Scalars["Int"]>;
	UDI_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	UDI_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	UDI_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	UDI_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	UDI_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	classificationSystem_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	classificationSystem_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	classificationSystem_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	classificationSystem_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	classificationSystem_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	classificationSystem_EQUAL?: InputMaybe<Scalars["String"]>;
	classificationSystem_GT?: InputMaybe<Scalars["Int"]>;
	classificationSystem_GTE?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LT?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LTE?: InputMaybe<Scalars["Int"]>;
	classificationSystem_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	classificationSystem_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	classificationSystem_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	classificationSystem_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	classificationSystem_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type ScenarioActionTreatmentRelationship = {
	__typename?: "ScenarioActionTreatmentRelationship";
	cursor: Scalars["String"];
	node: Treatment;
};

export type ScenarioActionTreatmentUpdateConnectionInput = {
	node?: InputMaybe<TreatmentUpdateInput>;
};

export type ScenarioActionTreatmentUpdateFieldInput = {
	connect?: InputMaybe<ScenarioActionTreatmentConnectFieldInput>;
	create?: InputMaybe<ScenarioActionTreatmentCreateFieldInput>;
	delete?: InputMaybe<ScenarioActionTreatmentDeleteFieldInput>;
	disconnect?: InputMaybe<ScenarioActionTreatmentDisconnectFieldInput>;
	update?: InputMaybe<ScenarioActionTreatmentUpdateConnectionInput>;
	where?: InputMaybe<ScenarioActionTreatmentConnectionWhere>;
};

export type ScenarioActionUpdateInput = {
	actionType?: InputMaybe<ActionType>;
	brand?: InputMaybe<ScenarioActionBrandUpdateFieldInput>;
	categories?: InputMaybe<Array<ScenarioActionCategoriesUpdateFieldInput>>;
	combinedItemBrands?: InputMaybe<Array<ScenarioActionCombinedItemBrandsUpdateFieldInput>>;
	combinedItemTimeframeEnd?: InputMaybe<Scalars["Int"]>;
	combinedItemTimeframeRangeType?: InputMaybe<TimeframeRangeType>;
	combinedItemTimeframeStart?: InputMaybe<Scalars["Int"]>;
	combinedItemTreatments?: InputMaybe<Array<ScenarioActionCombinedItemTreatmentsUpdateFieldInput>>;
	deviceKits?: InputMaybe<Array<ScenarioActionDeviceKitsUpdateFieldInput>>;
	endItemNumber?: InputMaybe<Scalars["Int"]>;
	itemCombinationRelation?: InputMaybe<ActionItemCombinationRelation>;
	itemCombinationRule?: InputMaybe<ActionItemCombinationRule>;
	itemRangeType?: InputMaybe<ActionItemRangeType>;
	itemScope?: InputMaybe<ItemScope>;
	order?: InputMaybe<Scalars["Int"]>;
	priceType?: InputMaybe<PriceType>;
	recordNature?: InputMaybe<RecordNature>;
	scenario?: InputMaybe<ScenarioActionScenarioUpdateFieldInput>;
	startItemNumber?: InputMaybe<Scalars["Int"]>;
	startingPoint?: InputMaybe<TimeframeStartingPoint>;
	timeframe?: InputMaybe<ScenarioActionTimeframeUpdateFieldInput>;
	timeframeEnd?: InputMaybe<Scalars["Int"]>;
	timeframeEndDate?: InputMaybe<Scalars["Date"]>;
	timeframeRangeType?: InputMaybe<TimeframeRangeType>;
	timeframeStart?: InputMaybe<Scalars["Int"]>;
	timeframeStartDate?: InputMaybe<Scalars["Date"]>;
	treatment?: InputMaybe<ScenarioActionTreatmentUpdateFieldInput>;
	value?: InputMaybe<Scalars["Float"]>;
};

export type ScenarioActionWhere = {
	AND?: InputMaybe<Array<ScenarioActionWhere>>;
	OR?: InputMaybe<Array<ScenarioActionWhere>>;
	actionType?: InputMaybe<ActionType>;
	actionType_IN?: InputMaybe<Array<InputMaybe<ActionType>>>;
	actionType_NOT?: InputMaybe<ActionType>;
	actionType_NOT_IN?: InputMaybe<Array<InputMaybe<ActionType>>>;
	brand?: InputMaybe<BrandWhere>;
	brandAggregate?: InputMaybe<ScenarioActionBrandAggregateInput>;
	brandConnection?: InputMaybe<ScenarioActionBrandConnectionWhere>;
	brandConnection_NOT?: InputMaybe<ScenarioActionBrandConnectionWhere>;
	brand_NOT?: InputMaybe<BrandWhere>;
	categories?: InputMaybe<DeviceProductCategoryWhere>;
	categoriesAggregate?: InputMaybe<ScenarioActionCategoriesAggregateInput>;
	categoriesConnection?: InputMaybe<ScenarioActionCategoriesConnectionWhere>;
	categoriesConnection_NOT?: InputMaybe<ScenarioActionCategoriesConnectionWhere>;
	categories_NOT?: InputMaybe<DeviceProductCategoryWhere>;
	combinedItemBrands?: InputMaybe<BrandWhere>;
	combinedItemBrandsAggregate?: InputMaybe<ScenarioActionCombinedItemBrandsAggregateInput>;
	combinedItemBrandsConnection?: InputMaybe<ScenarioActionCombinedItemBrandsConnectionWhere>;
	combinedItemBrandsConnection_NOT?: InputMaybe<ScenarioActionCombinedItemBrandsConnectionWhere>;
	combinedItemBrands_NOT?: InputMaybe<BrandWhere>;
	combinedItemTimeframeEnd?: InputMaybe<Scalars["Int"]>;
	combinedItemTimeframeEnd_GT?: InputMaybe<Scalars["Int"]>;
	combinedItemTimeframeEnd_GTE?: InputMaybe<Scalars["Int"]>;
	combinedItemTimeframeEnd_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	combinedItemTimeframeEnd_LT?: InputMaybe<Scalars["Int"]>;
	combinedItemTimeframeEnd_LTE?: InputMaybe<Scalars["Int"]>;
	combinedItemTimeframeEnd_NOT?: InputMaybe<Scalars["Int"]>;
	combinedItemTimeframeEnd_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	combinedItemTimeframeRangeType?: InputMaybe<TimeframeRangeType>;
	combinedItemTimeframeRangeType_IN?: InputMaybe<Array<InputMaybe<TimeframeRangeType>>>;
	combinedItemTimeframeRangeType_NOT?: InputMaybe<TimeframeRangeType>;
	combinedItemTimeframeRangeType_NOT_IN?: InputMaybe<Array<InputMaybe<TimeframeRangeType>>>;
	combinedItemTimeframeStart?: InputMaybe<Scalars["Int"]>;
	combinedItemTimeframeStart_GT?: InputMaybe<Scalars["Int"]>;
	combinedItemTimeframeStart_GTE?: InputMaybe<Scalars["Int"]>;
	combinedItemTimeframeStart_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	combinedItemTimeframeStart_LT?: InputMaybe<Scalars["Int"]>;
	combinedItemTimeframeStart_LTE?: InputMaybe<Scalars["Int"]>;
	combinedItemTimeframeStart_NOT?: InputMaybe<Scalars["Int"]>;
	combinedItemTimeframeStart_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	combinedItemTreatments?: InputMaybe<TreatmentWhere>;
	combinedItemTreatmentsAggregate?: InputMaybe<ScenarioActionCombinedItemTreatmentsAggregateInput>;
	combinedItemTreatmentsConnection?: InputMaybe<ScenarioActionCombinedItemTreatmentsConnectionWhere>;
	combinedItemTreatmentsConnection_NOT?: InputMaybe<ScenarioActionCombinedItemTreatmentsConnectionWhere>;
	combinedItemTreatments_NOT?: InputMaybe<TreatmentWhere>;
	deviceKits?: InputMaybe<DeviceKitWhere>;
	deviceKitsAggregate?: InputMaybe<ScenarioActionDeviceKitsAggregateInput>;
	deviceKitsConnection?: InputMaybe<ScenarioActionDeviceKitsConnectionWhere>;
	deviceKitsConnection_NOT?: InputMaybe<ScenarioActionDeviceKitsConnectionWhere>;
	deviceKits_NOT?: InputMaybe<DeviceKitWhere>;
	endItemNumber?: InputMaybe<Scalars["Int"]>;
	endItemNumber_GT?: InputMaybe<Scalars["Int"]>;
	endItemNumber_GTE?: InputMaybe<Scalars["Int"]>;
	endItemNumber_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	endItemNumber_LT?: InputMaybe<Scalars["Int"]>;
	endItemNumber_LTE?: InputMaybe<Scalars["Int"]>;
	endItemNumber_NOT?: InputMaybe<Scalars["Int"]>;
	endItemNumber_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	itemCombinationRelation?: InputMaybe<ActionItemCombinationRelation>;
	itemCombinationRelation_IN?: InputMaybe<Array<InputMaybe<ActionItemCombinationRelation>>>;
	itemCombinationRelation_NOT?: InputMaybe<ActionItemCombinationRelation>;
	itemCombinationRelation_NOT_IN?: InputMaybe<Array<InputMaybe<ActionItemCombinationRelation>>>;
	itemCombinationRule?: InputMaybe<ActionItemCombinationRule>;
	itemCombinationRule_IN?: InputMaybe<Array<InputMaybe<ActionItemCombinationRule>>>;
	itemCombinationRule_NOT?: InputMaybe<ActionItemCombinationRule>;
	itemCombinationRule_NOT_IN?: InputMaybe<Array<InputMaybe<ActionItemCombinationRule>>>;
	itemRangeType?: InputMaybe<ActionItemRangeType>;
	itemRangeType_IN?: InputMaybe<Array<InputMaybe<ActionItemRangeType>>>;
	itemRangeType_NOT?: InputMaybe<ActionItemRangeType>;
	itemRangeType_NOT_IN?: InputMaybe<Array<InputMaybe<ActionItemRangeType>>>;
	itemScope?: InputMaybe<ItemScope>;
	itemScope_IN?: InputMaybe<Array<InputMaybe<ItemScope>>>;
	itemScope_NOT?: InputMaybe<ItemScope>;
	itemScope_NOT_IN?: InputMaybe<Array<InputMaybe<ItemScope>>>;
	order?: InputMaybe<Scalars["Int"]>;
	order_GT?: InputMaybe<Scalars["Int"]>;
	order_GTE?: InputMaybe<Scalars["Int"]>;
	order_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	order_LT?: InputMaybe<Scalars["Int"]>;
	order_LTE?: InputMaybe<Scalars["Int"]>;
	order_NOT?: InputMaybe<Scalars["Int"]>;
	order_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	priceType?: InputMaybe<PriceType>;
	priceType_IN?: InputMaybe<Array<InputMaybe<PriceType>>>;
	priceType_NOT?: InputMaybe<PriceType>;
	priceType_NOT_IN?: InputMaybe<Array<InputMaybe<PriceType>>>;
	recordNature?: InputMaybe<RecordNature>;
	recordNature_IN?: InputMaybe<Array<InputMaybe<RecordNature>>>;
	recordNature_NOT?: InputMaybe<RecordNature>;
	recordNature_NOT_IN?: InputMaybe<Array<InputMaybe<RecordNature>>>;
	scenario?: InputMaybe<ScenarioWhere>;
	scenarioAggregate?: InputMaybe<ScenarioActionScenarioAggregateInput>;
	scenarioConnection?: InputMaybe<ScenarioActionScenarioConnectionWhere>;
	scenarioConnection_NOT?: InputMaybe<ScenarioActionScenarioConnectionWhere>;
	scenario_NOT?: InputMaybe<ScenarioWhere>;
	startItemNumber?: InputMaybe<Scalars["Int"]>;
	startItemNumber_GT?: InputMaybe<Scalars["Int"]>;
	startItemNumber_GTE?: InputMaybe<Scalars["Int"]>;
	startItemNumber_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	startItemNumber_LT?: InputMaybe<Scalars["Int"]>;
	startItemNumber_LTE?: InputMaybe<Scalars["Int"]>;
	startItemNumber_NOT?: InputMaybe<Scalars["Int"]>;
	startItemNumber_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	startingPoint?: InputMaybe<TimeframeStartingPoint>;
	startingPoint_IN?: InputMaybe<Array<InputMaybe<TimeframeStartingPoint>>>;
	startingPoint_NOT?: InputMaybe<TimeframeStartingPoint>;
	startingPoint_NOT_IN?: InputMaybe<Array<InputMaybe<TimeframeStartingPoint>>>;
	timeframe?: InputMaybe<TimeframeWhere>;
	timeframeAggregate?: InputMaybe<ScenarioActionTimeframeAggregateInput>;
	timeframeConnection?: InputMaybe<ScenarioActionTimeframeConnectionWhere>;
	timeframeConnection_NOT?: InputMaybe<ScenarioActionTimeframeConnectionWhere>;
	timeframeEnd?: InputMaybe<Scalars["Int"]>;
	timeframeEndDate?: InputMaybe<Scalars["Date"]>;
	timeframeEndDate_GT?: InputMaybe<Scalars["Date"]>;
	timeframeEndDate_GTE?: InputMaybe<Scalars["Date"]>;
	timeframeEndDate_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
	timeframeEndDate_LT?: InputMaybe<Scalars["Date"]>;
	timeframeEndDate_LTE?: InputMaybe<Scalars["Date"]>;
	timeframeEndDate_NOT?: InputMaybe<Scalars["Date"]>;
	timeframeEndDate_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
	timeframeEnd_GT?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_GTE?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	timeframeEnd_LT?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_LTE?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_NOT?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	timeframeRangeType?: InputMaybe<TimeframeRangeType>;
	timeframeRangeType_IN?: InputMaybe<Array<InputMaybe<TimeframeRangeType>>>;
	timeframeRangeType_NOT?: InputMaybe<TimeframeRangeType>;
	timeframeRangeType_NOT_IN?: InputMaybe<Array<InputMaybe<TimeframeRangeType>>>;
	timeframeStart?: InputMaybe<Scalars["Int"]>;
	timeframeStartDate?: InputMaybe<Scalars["Date"]>;
	timeframeStartDate_GT?: InputMaybe<Scalars["Date"]>;
	timeframeStartDate_GTE?: InputMaybe<Scalars["Date"]>;
	timeframeStartDate_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
	timeframeStartDate_LT?: InputMaybe<Scalars["Date"]>;
	timeframeStartDate_LTE?: InputMaybe<Scalars["Date"]>;
	timeframeStartDate_NOT?: InputMaybe<Scalars["Date"]>;
	timeframeStartDate_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
	timeframeStart_GT?: InputMaybe<Scalars["Int"]>;
	timeframeStart_GTE?: InputMaybe<Scalars["Int"]>;
	timeframeStart_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	timeframeStart_LT?: InputMaybe<Scalars["Int"]>;
	timeframeStart_LTE?: InputMaybe<Scalars["Int"]>;
	timeframeStart_NOT?: InputMaybe<Scalars["Int"]>;
	timeframeStart_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	timeframe_NOT?: InputMaybe<TimeframeWhere>;
	treatment?: InputMaybe<TreatmentWhere>;
	treatmentAggregate?: InputMaybe<ScenarioActionTreatmentAggregateInput>;
	treatmentConnection?: InputMaybe<ScenarioActionTreatmentConnectionWhere>;
	treatmentConnection_NOT?: InputMaybe<ScenarioActionTreatmentConnectionWhere>;
	treatment_NOT?: InputMaybe<TreatmentWhere>;
	value?: InputMaybe<Scalars["Float"]>;
	value_GT?: InputMaybe<Scalars["Float"]>;
	value_GTE?: InputMaybe<Scalars["Float"]>;
	value_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	value_LT?: InputMaybe<Scalars["Float"]>;
	value_LTE?: InputMaybe<Scalars["Float"]>;
	value_NOT?: InputMaybe<Scalars["Float"]>;
	value_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
};

export type ScenarioActionsAggregateInput = {
	AND?: InputMaybe<Array<ScenarioActionsAggregateInput>>;
	OR?: InputMaybe<Array<ScenarioActionsAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<ScenarioActionsNodeAggregationWhereInput>;
};

export type ScenarioActionsConnectFieldInput = {
	connect?: InputMaybe<Array<ScenarioActionConnectInput>>;
	where?: InputMaybe<ScenarioActionConnectWhere>;
};

export type ScenarioActionsConnection = {
	__typename?: "ScenarioActionsConnection";
	edges: Array<ScenarioActionsRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type ScenarioActionsConnectionSort = {
	node?: InputMaybe<ScenarioActionSort>;
};

export type ScenarioActionsConnectionWhere = {
	AND?: InputMaybe<Array<ScenarioActionsConnectionWhere>>;
	OR?: InputMaybe<Array<ScenarioActionsConnectionWhere>>;
	node?: InputMaybe<ScenarioActionWhere>;
	node_NOT?: InputMaybe<ScenarioActionWhere>;
};

export type ScenarioActionsCreateFieldInput = {
	node: ScenarioActionCreateInput;
};

export type ScenarioActionsDeleteFieldInput = {
	delete?: InputMaybe<ScenarioActionDeleteInput>;
	where?: InputMaybe<ScenarioActionsConnectionWhere>;
};

export type ScenarioActionsDisconnectFieldInput = {
	disconnect?: InputMaybe<ScenarioActionDisconnectInput>;
	where?: InputMaybe<ScenarioActionsConnectionWhere>;
};

export type ScenarioActionsFieldInput = {
	connect?: InputMaybe<Array<ScenarioActionsConnectFieldInput>>;
	create?: InputMaybe<Array<ScenarioActionsCreateFieldInput>>;
};

export type ScenarioActionsNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<ScenarioActionsNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<ScenarioActionsNodeAggregationWhereInput>>;
	combinedItemTimeframeEnd_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	combinedItemTimeframeEnd_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	combinedItemTimeframeEnd_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	combinedItemTimeframeEnd_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	combinedItemTimeframeEnd_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	combinedItemTimeframeEnd_EQUAL?: InputMaybe<Scalars["Int"]>;
	combinedItemTimeframeEnd_GT?: InputMaybe<Scalars["Int"]>;
	combinedItemTimeframeEnd_GTE?: InputMaybe<Scalars["Int"]>;
	combinedItemTimeframeEnd_LT?: InputMaybe<Scalars["Int"]>;
	combinedItemTimeframeEnd_LTE?: InputMaybe<Scalars["Int"]>;
	combinedItemTimeframeEnd_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	combinedItemTimeframeEnd_MAX_GT?: InputMaybe<Scalars["Int"]>;
	combinedItemTimeframeEnd_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	combinedItemTimeframeEnd_MAX_LT?: InputMaybe<Scalars["Int"]>;
	combinedItemTimeframeEnd_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	combinedItemTimeframeEnd_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	combinedItemTimeframeEnd_MIN_GT?: InputMaybe<Scalars["Int"]>;
	combinedItemTimeframeEnd_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	combinedItemTimeframeEnd_MIN_LT?: InputMaybe<Scalars["Int"]>;
	combinedItemTimeframeEnd_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	combinedItemTimeframeStart_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	combinedItemTimeframeStart_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	combinedItemTimeframeStart_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	combinedItemTimeframeStart_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	combinedItemTimeframeStart_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	combinedItemTimeframeStart_EQUAL?: InputMaybe<Scalars["Int"]>;
	combinedItemTimeframeStart_GT?: InputMaybe<Scalars["Int"]>;
	combinedItemTimeframeStart_GTE?: InputMaybe<Scalars["Int"]>;
	combinedItemTimeframeStart_LT?: InputMaybe<Scalars["Int"]>;
	combinedItemTimeframeStart_LTE?: InputMaybe<Scalars["Int"]>;
	combinedItemTimeframeStart_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	combinedItemTimeframeStart_MAX_GT?: InputMaybe<Scalars["Int"]>;
	combinedItemTimeframeStart_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	combinedItemTimeframeStart_MAX_LT?: InputMaybe<Scalars["Int"]>;
	combinedItemTimeframeStart_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	combinedItemTimeframeStart_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	combinedItemTimeframeStart_MIN_GT?: InputMaybe<Scalars["Int"]>;
	combinedItemTimeframeStart_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	combinedItemTimeframeStart_MIN_LT?: InputMaybe<Scalars["Int"]>;
	combinedItemTimeframeStart_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	endItemNumber_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	endItemNumber_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	endItemNumber_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	endItemNumber_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	endItemNumber_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	endItemNumber_EQUAL?: InputMaybe<Scalars["Int"]>;
	endItemNumber_GT?: InputMaybe<Scalars["Int"]>;
	endItemNumber_GTE?: InputMaybe<Scalars["Int"]>;
	endItemNumber_LT?: InputMaybe<Scalars["Int"]>;
	endItemNumber_LTE?: InputMaybe<Scalars["Int"]>;
	endItemNumber_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	endItemNumber_MAX_GT?: InputMaybe<Scalars["Int"]>;
	endItemNumber_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	endItemNumber_MAX_LT?: InputMaybe<Scalars["Int"]>;
	endItemNumber_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	endItemNumber_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	endItemNumber_MIN_GT?: InputMaybe<Scalars["Int"]>;
	endItemNumber_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	endItemNumber_MIN_LT?: InputMaybe<Scalars["Int"]>;
	endItemNumber_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	order_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	order_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	order_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	order_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	order_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	order_EQUAL?: InputMaybe<Scalars["Int"]>;
	order_GT?: InputMaybe<Scalars["Int"]>;
	order_GTE?: InputMaybe<Scalars["Int"]>;
	order_LT?: InputMaybe<Scalars["Int"]>;
	order_LTE?: InputMaybe<Scalars["Int"]>;
	order_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	order_MAX_GT?: InputMaybe<Scalars["Int"]>;
	order_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	order_MAX_LT?: InputMaybe<Scalars["Int"]>;
	order_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	order_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	order_MIN_GT?: InputMaybe<Scalars["Int"]>;
	order_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	order_MIN_LT?: InputMaybe<Scalars["Int"]>;
	order_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	startItemNumber_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	startItemNumber_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	startItemNumber_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	startItemNumber_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	startItemNumber_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	startItemNumber_EQUAL?: InputMaybe<Scalars["Int"]>;
	startItemNumber_GT?: InputMaybe<Scalars["Int"]>;
	startItemNumber_GTE?: InputMaybe<Scalars["Int"]>;
	startItemNumber_LT?: InputMaybe<Scalars["Int"]>;
	startItemNumber_LTE?: InputMaybe<Scalars["Int"]>;
	startItemNumber_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	startItemNumber_MAX_GT?: InputMaybe<Scalars["Int"]>;
	startItemNumber_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	startItemNumber_MAX_LT?: InputMaybe<Scalars["Int"]>;
	startItemNumber_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	startItemNumber_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	startItemNumber_MIN_GT?: InputMaybe<Scalars["Int"]>;
	startItemNumber_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	startItemNumber_MIN_LT?: InputMaybe<Scalars["Int"]>;
	startItemNumber_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	timeframeEnd_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	timeframeEnd_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	timeframeEnd_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	timeframeEnd_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	timeframeEnd_EQUAL?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_GT?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_GTE?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_LT?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_LTE?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_MAX_GT?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_MAX_LT?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_MIN_GT?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_MIN_LT?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	timeframeStart_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	timeframeStart_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	timeframeStart_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	timeframeStart_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	timeframeStart_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	timeframeStart_EQUAL?: InputMaybe<Scalars["Int"]>;
	timeframeStart_GT?: InputMaybe<Scalars["Int"]>;
	timeframeStart_GTE?: InputMaybe<Scalars["Int"]>;
	timeframeStart_LT?: InputMaybe<Scalars["Int"]>;
	timeframeStart_LTE?: InputMaybe<Scalars["Int"]>;
	timeframeStart_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	timeframeStart_MAX_GT?: InputMaybe<Scalars["Int"]>;
	timeframeStart_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	timeframeStart_MAX_LT?: InputMaybe<Scalars["Int"]>;
	timeframeStart_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	timeframeStart_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	timeframeStart_MIN_GT?: InputMaybe<Scalars["Int"]>;
	timeframeStart_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	timeframeStart_MIN_LT?: InputMaybe<Scalars["Int"]>;
	timeframeStart_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	value_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	value_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	value_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	value_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	value_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	value_EQUAL?: InputMaybe<Scalars["Float"]>;
	value_GT?: InputMaybe<Scalars["Float"]>;
	value_GTE?: InputMaybe<Scalars["Float"]>;
	value_LT?: InputMaybe<Scalars["Float"]>;
	value_LTE?: InputMaybe<Scalars["Float"]>;
	value_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	value_MAX_GT?: InputMaybe<Scalars["Float"]>;
	value_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	value_MAX_LT?: InputMaybe<Scalars["Float"]>;
	value_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	value_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	value_MIN_GT?: InputMaybe<Scalars["Float"]>;
	value_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	value_MIN_LT?: InputMaybe<Scalars["Float"]>;
	value_MIN_LTE?: InputMaybe<Scalars["Float"]>;
};

export type ScenarioActionsRelationship = {
	__typename?: "ScenarioActionsRelationship";
	cursor: Scalars["String"];
	node: ScenarioAction;
};

export type ScenarioActionsUpdateConnectionInput = {
	node?: InputMaybe<ScenarioActionUpdateInput>;
};

export type ScenarioActionsUpdateFieldInput = {
	connect?: InputMaybe<Array<ScenarioActionsConnectFieldInput>>;
	create?: InputMaybe<Array<ScenarioActionsCreateFieldInput>>;
	delete?: InputMaybe<Array<ScenarioActionsDeleteFieldInput>>;
	disconnect?: InputMaybe<Array<ScenarioActionsDisconnectFieldInput>>;
	update?: InputMaybe<ScenarioActionsUpdateConnectionInput>;
	where?: InputMaybe<ScenarioActionsConnectionWhere>;
};

export type ScenarioAggregateSelection = {
	__typename?: "ScenarioAggregateSelection";
	count: Scalars["Int"];
	group: IntAggregateSelection;
	order: IntAggregateSelection;
};

export type ScenarioAgreementAggregateInput = {
	AND?: InputMaybe<Array<ScenarioAgreementAggregateInput>>;
	OR?: InputMaybe<Array<ScenarioAgreementAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<ScenarioAgreementNodeAggregationWhereInput>;
};

export type ScenarioAgreementConnectFieldInput = {
	connect?: InputMaybe<BaseAgreementConnectInput>;
	where?: InputMaybe<BaseAgreementConnectWhere>;
};

export type ScenarioAgreementConnection = {
	__typename?: "ScenarioAgreementConnection";
	edges: Array<ScenarioAgreementRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type ScenarioAgreementConnectionSort = {
	node?: InputMaybe<BaseAgreementSort>;
};

export type ScenarioAgreementConnectionWhere = {
	AND?: InputMaybe<Array<ScenarioAgreementConnectionWhere>>;
	OR?: InputMaybe<Array<ScenarioAgreementConnectionWhere>>;
	node?: InputMaybe<BaseAgreementWhere>;
	node_NOT?: InputMaybe<BaseAgreementWhere>;
};

export type ScenarioAgreementCreateFieldInput = {
	node: BaseAgreementCreateInput;
};

export type ScenarioAgreementDeleteFieldInput = {
	delete?: InputMaybe<BaseAgreementDeleteInput>;
	where?: InputMaybe<ScenarioAgreementConnectionWhere>;
};

export type ScenarioAgreementDisconnectFieldInput = {
	disconnect?: InputMaybe<BaseAgreementDisconnectInput>;
	where?: InputMaybe<ScenarioAgreementConnectionWhere>;
};

export type ScenarioAgreementFieldInput = {
	connect?: InputMaybe<ScenarioAgreementConnectFieldInput>;
	create?: InputMaybe<ScenarioAgreementCreateFieldInput>;
};

export type ScenarioAgreementNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<ScenarioAgreementNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<ScenarioAgreementNodeAggregationWhereInput>>;
	coveringFormWaitInterval_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	coveringFormWaitInterval_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	coveringFormWaitInterval_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	coveringFormWaitInterval_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	coveringFormWaitInterval_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	coveringFormWaitInterval_EQUAL?: InputMaybe<Scalars["Int"]>;
	coveringFormWaitInterval_GT?: InputMaybe<Scalars["Int"]>;
	coveringFormWaitInterval_GTE?: InputMaybe<Scalars["Int"]>;
	coveringFormWaitInterval_LT?: InputMaybe<Scalars["Int"]>;
	coveringFormWaitInterval_LTE?: InputMaybe<Scalars["Int"]>;
	coveringFormWaitInterval_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	coveringFormWaitInterval_MAX_GT?: InputMaybe<Scalars["Int"]>;
	coveringFormWaitInterval_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	coveringFormWaitInterval_MAX_LT?: InputMaybe<Scalars["Int"]>;
	coveringFormWaitInterval_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	coveringFormWaitInterval_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	coveringFormWaitInterval_MIN_GT?: InputMaybe<Scalars["Int"]>;
	coveringFormWaitInterval_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	coveringFormWaitInterval_MIN_LT?: InputMaybe<Scalars["Int"]>;
	coveringFormWaitInterval_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	createdOn_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_GT?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_GTE?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_LT?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_LTE?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	formattedAmount_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	formattedAmount_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	formattedAmount_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	formattedAmount_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	formattedAmount_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	formattedAmount_EQUAL?: InputMaybe<Scalars["String"]>;
	formattedAmount_GT?: InputMaybe<Scalars["Int"]>;
	formattedAmount_GTE?: InputMaybe<Scalars["Int"]>;
	formattedAmount_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedAmount_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedAmount_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedAmount_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedAmount_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	formattedAmount_LT?: InputMaybe<Scalars["Int"]>;
	formattedAmount_LTE?: InputMaybe<Scalars["Int"]>;
	formattedAmount_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedAmount_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedAmount_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedAmount_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedAmount_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	formattedCounterparties_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	formattedCounterparties_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	formattedCounterparties_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	formattedCounterparties_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	formattedCounterparties_EQUAL?: InputMaybe<Scalars["String"]>;
	formattedCounterparties_GT?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_GTE?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_LT?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_LTE?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	formattedProducts_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	formattedProducts_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	formattedProducts_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	formattedProducts_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	formattedProducts_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	formattedProducts_EQUAL?: InputMaybe<Scalars["String"]>;
	formattedProducts_GT?: InputMaybe<Scalars["Int"]>;
	formattedProducts_GTE?: InputMaybe<Scalars["Int"]>;
	formattedProducts_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedProducts_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedProducts_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedProducts_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedProducts_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	formattedProducts_LT?: InputMaybe<Scalars["Int"]>;
	formattedProducts_LTE?: InputMaybe<Scalars["Int"]>;
	formattedProducts_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedProducts_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedProducts_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedProducts_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedProducts_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	formattedTags_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	formattedTags_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	formattedTags_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	formattedTags_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	formattedTags_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	formattedTags_EQUAL?: InputMaybe<Scalars["String"]>;
	formattedTags_GT?: InputMaybe<Scalars["Int"]>;
	formattedTags_GTE?: InputMaybe<Scalars["Int"]>;
	formattedTags_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedTags_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedTags_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedTags_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedTags_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	formattedTags_LT?: InputMaybe<Scalars["Int"]>;
	formattedTags_LTE?: InputMaybe<Scalars["Int"]>;
	formattedTags_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedTags_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedTags_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedTags_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedTags_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	formattedValidityPeriod_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	formattedValidityPeriod_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	formattedValidityPeriod_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	formattedValidityPeriod_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	formattedValidityPeriod_EQUAL?: InputMaybe<Scalars["String"]>;
	formattedValidityPeriod_GT?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_GTE?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_LT?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_LTE?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	initialVersionId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	initialVersionId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	initialVersionId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	initialVersionId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	initialVersionId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	initialVersionId_EQUAL?: InputMaybe<Scalars["String"]>;
	initialVersionId_GT?: InputMaybe<Scalars["Int"]>;
	initialVersionId_GTE?: InputMaybe<Scalars["Int"]>;
	initialVersionId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	initialVersionId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	initialVersionId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	initialVersionId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	initialVersionId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	initialVersionId_LT?: InputMaybe<Scalars["Int"]>;
	initialVersionId_LTE?: InputMaybe<Scalars["Int"]>;
	initialVersionId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	initialVersionId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	initialVersionId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	initialVersionId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	initialVersionId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	lastExecutionDate_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_GT?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_LT?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_LTE?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	name_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	name_EQUAL?: InputMaybe<Scalars["String"]>;
	name_GT?: InputMaybe<Scalars["Int"]>;
	name_GTE?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	name_LT?: InputMaybe<Scalars["Int"]>;
	name_LTE?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	pushedOn_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	pushedOn_GT?: InputMaybe<Scalars["DateTime"]>;
	pushedOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	pushedOn_LT?: InputMaybe<Scalars["DateTime"]>;
	pushedOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	pushedOn_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	pushedOn_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	pushedOn_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	pushedOn_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	pushedOn_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	pushedOn_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	pushedOn_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	pushedOn_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	pushedOn_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	pushedOn_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	version_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	version_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	version_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	version_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	version_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	version_EQUAL?: InputMaybe<Scalars["Int"]>;
	version_GT?: InputMaybe<Scalars["Int"]>;
	version_GTE?: InputMaybe<Scalars["Int"]>;
	version_LT?: InputMaybe<Scalars["Int"]>;
	version_LTE?: InputMaybe<Scalars["Int"]>;
	version_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	version_MAX_GT?: InputMaybe<Scalars["Int"]>;
	version_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	version_MAX_LT?: InputMaybe<Scalars["Int"]>;
	version_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	version_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	version_MIN_GT?: InputMaybe<Scalars["Int"]>;
	version_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	version_MIN_LT?: InputMaybe<Scalars["Int"]>;
	version_MIN_LTE?: InputMaybe<Scalars["Int"]>;
};

export type ScenarioAgreementRelationship = {
	__typename?: "ScenarioAgreementRelationship";
	cursor: Scalars["String"];
	node: BaseAgreement;
};

export type ScenarioAgreementUpdateConnectionInput = {
	node?: InputMaybe<BaseAgreementUpdateInput>;
};

export type ScenarioAgreementUpdateFieldInput = {
	connect?: InputMaybe<ScenarioAgreementConnectFieldInput>;
	create?: InputMaybe<ScenarioAgreementCreateFieldInput>;
	delete?: InputMaybe<ScenarioAgreementDeleteFieldInput>;
	disconnect?: InputMaybe<ScenarioAgreementDisconnectFieldInput>;
	update?: InputMaybe<ScenarioAgreementUpdateConnectionInput>;
	where?: InputMaybe<ScenarioAgreementConnectionWhere>;
};

export type ScenarioCondition = ITimeframe & {
	__typename?: "ScenarioCondition";
	adverseEvents?: Maybe<Array<AdverseEventType>>;
	brand?: Maybe<Brand>;
	brandConnection: ScenarioConditionBrandConnection;
	categories: Array<DeviceProductCategory>;
	conditionStatus?: Maybe<Array<OutcomeBasedStatus>>;
	conditionType: ConditionType;
	consideredRating?: Maybe<ConditionConsideredRating>;
	consideredSecInterventionRate?: Maybe<ConditionConsideredSecIntervention>;
	deviceKits: Array<DeviceKit>;
	deviceKitsConnection: ScenarioConditionDeviceKitsConnection;
	discontinuationReason?: Maybe<TreatmentDiscontinuationReason>;
	endRangeValue?: Maybe<Scalars["Float"]>;
	grades?: Maybe<Array<AdverseEventGrades>>;
	intervention?: Maybe<InterventionType>;
	interventionOccurrence?: Maybe<InterventionOccurrence>;
	occurence?: Maybe<Occurrence>;
	operator?: Maybe<ArithmeticalOperator>;
	order: Scalars["Int"];
	patientScope?: Maybe<PatientScope>;
	reintervention?: Maybe<Reintervention>;
	responseInclusionType?: Maybe<ResponseInclusionType>;
	responseType?: Maybe<ResponseType>;
	scenario: Scenario;
	scenarioConnection: ScenarioConditionScenarioConnection;
	startingPoint?: Maybe<TimeframeStartingPoint>;
	timeframe?: Maybe<Timeframe>;
	timeframeConnection: ScenarioConditionTimeframeConnection;
	timeframeEnd?: Maybe<Scalars["Int"]>;
	timeframeEndDate?: Maybe<Scalars["Date"]>;
	timeframeRangeType?: Maybe<TimeframeRangeType>;
	timeframeStart?: Maybe<Scalars["Int"]>;
	timeframeStartDate?: Maybe<Scalars["Date"]>;
	treatment?: Maybe<Treatment>;
	treatmentConnection: ScenarioConditionTreatmentConnection;
	treatmentDurationAspect?: Maybe<TreatmentDurationConditionAspect>;
	value?: Maybe<Scalars["Float"]>;
};

export type ScenarioConditionBrandArgs = {
	options?: InputMaybe<BrandOptions>;
	where?: InputMaybe<BrandWhere>;
};

export type ScenarioConditionBrandConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<ScenarioConditionBrandConnectionSort>>;
	where?: InputMaybe<ScenarioConditionBrandConnectionWhere>;
};

export type ScenarioConditionDeviceKitsArgs = {
	options?: InputMaybe<DeviceKitOptions>;
	where?: InputMaybe<DeviceKitWhere>;
};

export type ScenarioConditionDeviceKitsConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<ScenarioConditionDeviceKitsConnectionSort>>;
	where?: InputMaybe<ScenarioConditionDeviceKitsConnectionWhere>;
};

export type ScenarioConditionScenarioArgs = {
	options?: InputMaybe<ScenarioOptions>;
	where?: InputMaybe<ScenarioWhere>;
};

export type ScenarioConditionScenarioConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<ScenarioConditionScenarioConnectionSort>>;
	where?: InputMaybe<ScenarioConditionScenarioConnectionWhere>;
};

export type ScenarioConditionTimeframeArgs = {
	options?: InputMaybe<TimeframeOptions>;
	where?: InputMaybe<TimeframeWhere>;
};

export type ScenarioConditionTimeframeConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<ScenarioConditionTimeframeConnectionSort>>;
	where?: InputMaybe<ScenarioConditionTimeframeConnectionWhere>;
};

export type ScenarioConditionTreatmentArgs = {
	options?: InputMaybe<TreatmentOptions>;
	where?: InputMaybe<TreatmentWhere>;
};

export type ScenarioConditionTreatmentConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<ScenarioConditionTreatmentConnectionSort>>;
	where?: InputMaybe<ScenarioConditionTreatmentConnectionWhere>;
};

export type ScenarioConditionAggregateSelection = {
	__typename?: "ScenarioConditionAggregateSelection";
	count: Scalars["Int"];
	endRangeValue: FloatAggregateSelection;
	order: IntAggregateSelection;
	timeframeEnd: IntAggregateSelection;
	timeframeStart: IntAggregateSelection;
	value: FloatAggregateSelection;
};

export type ScenarioConditionBrandAggregateInput = {
	AND?: InputMaybe<Array<ScenarioConditionBrandAggregateInput>>;
	OR?: InputMaybe<Array<ScenarioConditionBrandAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<ScenarioConditionBrandNodeAggregationWhereInput>;
};

export type ScenarioConditionBrandConnectFieldInput = {
	connect?: InputMaybe<BrandConnectInput>;
	where?: InputMaybe<BrandConnectWhere>;
};

export type ScenarioConditionBrandConnection = {
	__typename?: "ScenarioConditionBrandConnection";
	edges: Array<ScenarioConditionBrandRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type ScenarioConditionBrandConnectionSort = {
	node?: InputMaybe<BrandSort>;
};

export type ScenarioConditionBrandConnectionWhere = {
	AND?: InputMaybe<Array<ScenarioConditionBrandConnectionWhere>>;
	OR?: InputMaybe<Array<ScenarioConditionBrandConnectionWhere>>;
	node?: InputMaybe<BrandWhere>;
	node_NOT?: InputMaybe<BrandWhere>;
};

export type ScenarioConditionBrandCreateFieldInput = {
	node: BrandCreateInput;
};

export type ScenarioConditionBrandDeleteFieldInput = {
	delete?: InputMaybe<BrandDeleteInput>;
	where?: InputMaybe<ScenarioConditionBrandConnectionWhere>;
};

export type ScenarioConditionBrandDisconnectFieldInput = {
	disconnect?: InputMaybe<BrandDisconnectInput>;
	where?: InputMaybe<ScenarioConditionBrandConnectionWhere>;
};

export type ScenarioConditionBrandFieldInput = {
	connect?: InputMaybe<ScenarioConditionBrandConnectFieldInput>;
	create?: InputMaybe<ScenarioConditionBrandCreateFieldInput>;
};

export type ScenarioConditionBrandNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<ScenarioConditionBrandNodeAggregationWhereInput>>;
	Name_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	Name_EQUAL?: InputMaybe<Scalars["String"]>;
	Name_GT?: InputMaybe<Scalars["Int"]>;
	Name_GTE?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	Name_LT?: InputMaybe<Scalars["Int"]>;
	Name_LTE?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	OR?: InputMaybe<Array<ScenarioConditionBrandNodeAggregationWhereInput>>;
};

export type ScenarioConditionBrandRelationship = {
	__typename?: "ScenarioConditionBrandRelationship";
	cursor: Scalars["String"];
	node: Brand;
};

export type ScenarioConditionBrandUpdateConnectionInput = {
	node?: InputMaybe<BrandUpdateInput>;
};

export type ScenarioConditionBrandUpdateFieldInput = {
	connect?: InputMaybe<ScenarioConditionBrandConnectFieldInput>;
	create?: InputMaybe<ScenarioConditionBrandCreateFieldInput>;
	delete?: InputMaybe<ScenarioConditionBrandDeleteFieldInput>;
	disconnect?: InputMaybe<ScenarioConditionBrandDisconnectFieldInput>;
	update?: InputMaybe<ScenarioConditionBrandUpdateConnectionInput>;
	where?: InputMaybe<ScenarioConditionBrandConnectionWhere>;
};

export type ScenarioConditionConnectInput = {
	brand?: InputMaybe<ScenarioConditionBrandConnectFieldInput>;
	deviceKits?: InputMaybe<Array<ScenarioConditionDeviceKitsConnectFieldInput>>;
	scenario?: InputMaybe<ScenarioConditionScenarioConnectFieldInput>;
	timeframe?: InputMaybe<ScenarioConditionTimeframeConnectFieldInput>;
	treatment?: InputMaybe<ScenarioConditionTreatmentConnectFieldInput>;
};

export type ScenarioConditionConnectWhere = {
	node: ScenarioConditionWhere;
};

export type ScenarioConditionCreateInput = {
	adverseEvents?: InputMaybe<Array<AdverseEventType>>;
	brand?: InputMaybe<ScenarioConditionBrandFieldInput>;
	conditionStatus?: InputMaybe<Array<OutcomeBasedStatus>>;
	conditionType: ConditionType;
	consideredRating?: InputMaybe<ConditionConsideredRating>;
	consideredSecInterventionRate?: InputMaybe<ConditionConsideredSecIntervention>;
	deviceKits?: InputMaybe<ScenarioConditionDeviceKitsFieldInput>;
	discontinuationReason?: InputMaybe<TreatmentDiscontinuationReason>;
	endRangeValue?: InputMaybe<Scalars["Float"]>;
	grades?: InputMaybe<Array<AdverseEventGrades>>;
	intervention?: InputMaybe<InterventionType>;
	interventionOccurrence?: InputMaybe<InterventionOccurrence>;
	occurence?: InputMaybe<Occurrence>;
	operator?: InputMaybe<ArithmeticalOperator>;
	order: Scalars["Int"];
	patientScope?: InputMaybe<PatientScope>;
	reintervention?: InputMaybe<Reintervention>;
	responseInclusionType?: InputMaybe<ResponseInclusionType>;
	responseType?: InputMaybe<ResponseType>;
	scenario?: InputMaybe<ScenarioConditionScenarioFieldInput>;
	startingPoint?: InputMaybe<TimeframeStartingPoint>;
	timeframe?: InputMaybe<ScenarioConditionTimeframeFieldInput>;
	timeframeEnd?: InputMaybe<Scalars["Int"]>;
	timeframeEndDate?: InputMaybe<Scalars["Date"]>;
	timeframeRangeType?: InputMaybe<TimeframeRangeType>;
	timeframeStart?: InputMaybe<Scalars["Int"]>;
	timeframeStartDate?: InputMaybe<Scalars["Date"]>;
	treatment?: InputMaybe<ScenarioConditionTreatmentFieldInput>;
	treatmentDurationAspect?: InputMaybe<TreatmentDurationConditionAspect>;
	value?: InputMaybe<Scalars["Float"]>;
};

export type ScenarioConditionDeleteInput = {
	brand?: InputMaybe<ScenarioConditionBrandDeleteFieldInput>;
	deviceKits?: InputMaybe<Array<ScenarioConditionDeviceKitsDeleteFieldInput>>;
	scenario?: InputMaybe<ScenarioConditionScenarioDeleteFieldInput>;
	timeframe?: InputMaybe<ScenarioConditionTimeframeDeleteFieldInput>;
	treatment?: InputMaybe<ScenarioConditionTreatmentDeleteFieldInput>;
};

export type ScenarioConditionDeviceKitsAggregateInput = {
	AND?: InputMaybe<Array<ScenarioConditionDeviceKitsAggregateInput>>;
	OR?: InputMaybe<Array<ScenarioConditionDeviceKitsAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<ScenarioConditionDeviceKitsNodeAggregationWhereInput>;
};

export type ScenarioConditionDeviceKitsConnectFieldInput = {
	where?: InputMaybe<DeviceKitConnectWhere>;
};

export type ScenarioConditionDeviceKitsConnection = {
	__typename?: "ScenarioConditionDeviceKitsConnection";
	edges: Array<ScenarioConditionDeviceKitsRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type ScenarioConditionDeviceKitsConnectionSort = {
	node?: InputMaybe<DeviceKitSort>;
};

export type ScenarioConditionDeviceKitsConnectionWhere = {
	AND?: InputMaybe<Array<ScenarioConditionDeviceKitsConnectionWhere>>;
	OR?: InputMaybe<Array<ScenarioConditionDeviceKitsConnectionWhere>>;
	node?: InputMaybe<DeviceKitWhere>;
	node_NOT?: InputMaybe<DeviceKitWhere>;
};

export type ScenarioConditionDeviceKitsCreateFieldInput = {
	node: DeviceKitCreateInput;
};

export type ScenarioConditionDeviceKitsDeleteFieldInput = {
	where?: InputMaybe<ScenarioConditionDeviceKitsConnectionWhere>;
};

export type ScenarioConditionDeviceKitsDisconnectFieldInput = {
	where?: InputMaybe<ScenarioConditionDeviceKitsConnectionWhere>;
};

export type ScenarioConditionDeviceKitsFieldInput = {
	connect?: InputMaybe<Array<ScenarioConditionDeviceKitsConnectFieldInput>>;
	create?: InputMaybe<Array<ScenarioConditionDeviceKitsCreateFieldInput>>;
};

export type ScenarioConditionDeviceKitsNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<ScenarioConditionDeviceKitsNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<ScenarioConditionDeviceKitsNodeAggregationWhereInput>>;
	name_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	name_EQUAL?: InputMaybe<Scalars["String"]>;
	name_GT?: InputMaybe<Scalars["Int"]>;
	name_GTE?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	name_LT?: InputMaybe<Scalars["Int"]>;
	name_LTE?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	ref_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	ref_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	ref_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	ref_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	ref_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	ref_EQUAL?: InputMaybe<Scalars["String"]>;
	ref_GT?: InputMaybe<Scalars["Int"]>;
	ref_GTE?: InputMaybe<Scalars["Int"]>;
	ref_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	ref_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	ref_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	ref_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	ref_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	ref_LT?: InputMaybe<Scalars["Int"]>;
	ref_LTE?: InputMaybe<Scalars["Int"]>;
	ref_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	ref_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	ref_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	ref_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	ref_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	tenantId_EQUAL?: InputMaybe<Scalars["String"]>;
	tenantId_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type ScenarioConditionDeviceKitsRelationship = {
	__typename?: "ScenarioConditionDeviceKitsRelationship";
	cursor: Scalars["String"];
	node: DeviceKit;
};

export type ScenarioConditionDeviceKitsUpdateConnectionInput = {
	node?: InputMaybe<DeviceKitUpdateInput>;
};

export type ScenarioConditionDeviceKitsUpdateFieldInput = {
	connect?: InputMaybe<Array<ScenarioConditionDeviceKitsConnectFieldInput>>;
	create?: InputMaybe<Array<ScenarioConditionDeviceKitsCreateFieldInput>>;
	delete?: InputMaybe<Array<ScenarioConditionDeviceKitsDeleteFieldInput>>;
	disconnect?: InputMaybe<Array<ScenarioConditionDeviceKitsDisconnectFieldInput>>;
	update?: InputMaybe<ScenarioConditionDeviceKitsUpdateConnectionInput>;
	where?: InputMaybe<ScenarioConditionDeviceKitsConnectionWhere>;
};

export type ScenarioConditionDisconnectInput = {
	brand?: InputMaybe<ScenarioConditionBrandDisconnectFieldInput>;
	deviceKits?: InputMaybe<Array<ScenarioConditionDeviceKitsDisconnectFieldInput>>;
	scenario?: InputMaybe<ScenarioConditionScenarioDisconnectFieldInput>;
	timeframe?: InputMaybe<ScenarioConditionTimeframeDisconnectFieldInput>;
	treatment?: InputMaybe<ScenarioConditionTreatmentDisconnectFieldInput>;
};

export type ScenarioConditionOptions = {
	limit?: InputMaybe<Scalars["Int"]>;
	offset?: InputMaybe<Scalars["Int"]>;
	/** Specify one or more ScenarioConditionSort objects to sort ScenarioConditions by. The sorts will be applied in the order in which they are arranged in the array. */
	sort?: InputMaybe<Array<InputMaybe<ScenarioConditionSort>>>;
};

export type ScenarioConditionScenarioAggregateInput = {
	AND?: InputMaybe<Array<ScenarioConditionScenarioAggregateInput>>;
	OR?: InputMaybe<Array<ScenarioConditionScenarioAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<ScenarioConditionScenarioNodeAggregationWhereInput>;
};

export type ScenarioConditionScenarioConnectFieldInput = {
	connect?: InputMaybe<ScenarioConnectInput>;
	where?: InputMaybe<ScenarioConnectWhere>;
};

export type ScenarioConditionScenarioConnection = {
	__typename?: "ScenarioConditionScenarioConnection";
	edges: Array<ScenarioConditionScenarioRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type ScenarioConditionScenarioConnectionSort = {
	node?: InputMaybe<ScenarioSort>;
};

export type ScenarioConditionScenarioConnectionWhere = {
	AND?: InputMaybe<Array<ScenarioConditionScenarioConnectionWhere>>;
	OR?: InputMaybe<Array<ScenarioConditionScenarioConnectionWhere>>;
	node?: InputMaybe<ScenarioWhere>;
	node_NOT?: InputMaybe<ScenarioWhere>;
};

export type ScenarioConditionScenarioCreateFieldInput = {
	node: ScenarioCreateInput;
};

export type ScenarioConditionScenarioDeleteFieldInput = {
	delete?: InputMaybe<ScenarioDeleteInput>;
	where?: InputMaybe<ScenarioConditionScenarioConnectionWhere>;
};

export type ScenarioConditionScenarioDisconnectFieldInput = {
	disconnect?: InputMaybe<ScenarioDisconnectInput>;
	where?: InputMaybe<ScenarioConditionScenarioConnectionWhere>;
};

export type ScenarioConditionScenarioFieldInput = {
	connect?: InputMaybe<ScenarioConditionScenarioConnectFieldInput>;
	create?: InputMaybe<ScenarioConditionScenarioCreateFieldInput>;
};

export type ScenarioConditionScenarioNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<ScenarioConditionScenarioNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<ScenarioConditionScenarioNodeAggregationWhereInput>>;
	group_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	group_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	group_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	group_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	group_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	group_EQUAL?: InputMaybe<Scalars["Int"]>;
	group_GT?: InputMaybe<Scalars["Int"]>;
	group_GTE?: InputMaybe<Scalars["Int"]>;
	group_LT?: InputMaybe<Scalars["Int"]>;
	group_LTE?: InputMaybe<Scalars["Int"]>;
	group_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	group_MAX_GT?: InputMaybe<Scalars["Int"]>;
	group_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	group_MAX_LT?: InputMaybe<Scalars["Int"]>;
	group_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	group_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	group_MIN_GT?: InputMaybe<Scalars["Int"]>;
	group_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	group_MIN_LT?: InputMaybe<Scalars["Int"]>;
	group_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	order_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	order_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	order_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	order_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	order_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	order_EQUAL?: InputMaybe<Scalars["Int"]>;
	order_GT?: InputMaybe<Scalars["Int"]>;
	order_GTE?: InputMaybe<Scalars["Int"]>;
	order_LT?: InputMaybe<Scalars["Int"]>;
	order_LTE?: InputMaybe<Scalars["Int"]>;
	order_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	order_MAX_GT?: InputMaybe<Scalars["Int"]>;
	order_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	order_MAX_LT?: InputMaybe<Scalars["Int"]>;
	order_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	order_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	order_MIN_GT?: InputMaybe<Scalars["Int"]>;
	order_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	order_MIN_LT?: InputMaybe<Scalars["Int"]>;
	order_MIN_LTE?: InputMaybe<Scalars["Int"]>;
};

export type ScenarioConditionScenarioRelationship = {
	__typename?: "ScenarioConditionScenarioRelationship";
	cursor: Scalars["String"];
	node: Scenario;
};

export type ScenarioConditionScenarioUpdateConnectionInput = {
	node?: InputMaybe<ScenarioUpdateInput>;
};

export type ScenarioConditionScenarioUpdateFieldInput = {
	connect?: InputMaybe<ScenarioConditionScenarioConnectFieldInput>;
	create?: InputMaybe<ScenarioConditionScenarioCreateFieldInput>;
	delete?: InputMaybe<ScenarioConditionScenarioDeleteFieldInput>;
	disconnect?: InputMaybe<ScenarioConditionScenarioDisconnectFieldInput>;
	update?: InputMaybe<ScenarioConditionScenarioUpdateConnectionInput>;
	where?: InputMaybe<ScenarioConditionScenarioConnectionWhere>;
};

/** Fields to sort ScenarioConditions by. The order in which sorts are applied is not guaranteed when specifying many fields in one ScenarioConditionSort object. */
export type ScenarioConditionSort = {
	conditionType?: InputMaybe<SortDirection>;
	consideredRating?: InputMaybe<SortDirection>;
	consideredSecInterventionRate?: InputMaybe<SortDirection>;
	discontinuationReason?: InputMaybe<SortDirection>;
	endRangeValue?: InputMaybe<SortDirection>;
	intervention?: InputMaybe<SortDirection>;
	interventionOccurrence?: InputMaybe<SortDirection>;
	occurence?: InputMaybe<SortDirection>;
	operator?: InputMaybe<SortDirection>;
	order?: InputMaybe<SortDirection>;
	patientScope?: InputMaybe<SortDirection>;
	reintervention?: InputMaybe<SortDirection>;
	responseInclusionType?: InputMaybe<SortDirection>;
	responseType?: InputMaybe<SortDirection>;
	startingPoint?: InputMaybe<SortDirection>;
	timeframeEnd?: InputMaybe<SortDirection>;
	timeframeEndDate?: InputMaybe<SortDirection>;
	timeframeRangeType?: InputMaybe<SortDirection>;
	timeframeStart?: InputMaybe<SortDirection>;
	timeframeStartDate?: InputMaybe<SortDirection>;
	treatmentDurationAspect?: InputMaybe<SortDirection>;
	value?: InputMaybe<SortDirection>;
};

export type ScenarioConditionTimeframeAggregateInput = {
	AND?: InputMaybe<Array<ScenarioConditionTimeframeAggregateInput>>;
	OR?: InputMaybe<Array<ScenarioConditionTimeframeAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<ScenarioConditionTimeframeNodeAggregationWhereInput>;
};

export type ScenarioConditionTimeframeConnectFieldInput = {
	where?: InputMaybe<TimeframeConnectWhere>;
};

export type ScenarioConditionTimeframeConnection = {
	__typename?: "ScenarioConditionTimeframeConnection";
	edges: Array<ScenarioConditionTimeframeRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type ScenarioConditionTimeframeConnectionSort = {
	node?: InputMaybe<TimeframeSort>;
};

export type ScenarioConditionTimeframeConnectionWhere = {
	AND?: InputMaybe<Array<ScenarioConditionTimeframeConnectionWhere>>;
	OR?: InputMaybe<Array<ScenarioConditionTimeframeConnectionWhere>>;
	node?: InputMaybe<TimeframeWhere>;
	node_NOT?: InputMaybe<TimeframeWhere>;
};

export type ScenarioConditionTimeframeCreateFieldInput = {
	node: TimeframeCreateInput;
};

export type ScenarioConditionTimeframeDeleteFieldInput = {
	where?: InputMaybe<ScenarioConditionTimeframeConnectionWhere>;
};

export type ScenarioConditionTimeframeDisconnectFieldInput = {
	where?: InputMaybe<ScenarioConditionTimeframeConnectionWhere>;
};

export type ScenarioConditionTimeframeFieldInput = {
	connect?: InputMaybe<ScenarioConditionTimeframeConnectFieldInput>;
	create?: InputMaybe<ScenarioConditionTimeframeCreateFieldInput>;
};

export type ScenarioConditionTimeframeNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<ScenarioConditionTimeframeNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<ScenarioConditionTimeframeNodeAggregationWhereInput>>;
	name_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	name_EQUAL?: InputMaybe<Scalars["String"]>;
	name_GT?: InputMaybe<Scalars["Int"]>;
	name_GTE?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	name_LT?: InputMaybe<Scalars["Int"]>;
	name_LTE?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type ScenarioConditionTimeframeRelationship = {
	__typename?: "ScenarioConditionTimeframeRelationship";
	cursor: Scalars["String"];
	node: Timeframe;
};

export type ScenarioConditionTimeframeUpdateConnectionInput = {
	node?: InputMaybe<TimeframeUpdateInput>;
};

export type ScenarioConditionTimeframeUpdateFieldInput = {
	connect?: InputMaybe<ScenarioConditionTimeframeConnectFieldInput>;
	create?: InputMaybe<ScenarioConditionTimeframeCreateFieldInput>;
	delete?: InputMaybe<ScenarioConditionTimeframeDeleteFieldInput>;
	disconnect?: InputMaybe<ScenarioConditionTimeframeDisconnectFieldInput>;
	update?: InputMaybe<ScenarioConditionTimeframeUpdateConnectionInput>;
	where?: InputMaybe<ScenarioConditionTimeframeConnectionWhere>;
};

export type ScenarioConditionTreatmentAggregateInput = {
	AND?: InputMaybe<Array<ScenarioConditionTreatmentAggregateInput>>;
	OR?: InputMaybe<Array<ScenarioConditionTreatmentAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<ScenarioConditionTreatmentNodeAggregationWhereInput>;
};

export type ScenarioConditionTreatmentConnectFieldInput = {
	connect?: InputMaybe<TreatmentConnectInput>;
	where?: InputMaybe<TreatmentConnectWhere>;
};

export type ScenarioConditionTreatmentConnection = {
	__typename?: "ScenarioConditionTreatmentConnection";
	edges: Array<ScenarioConditionTreatmentRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type ScenarioConditionTreatmentConnectionSort = {
	node?: InputMaybe<TreatmentSort>;
};

export type ScenarioConditionTreatmentConnectionWhere = {
	AND?: InputMaybe<Array<ScenarioConditionTreatmentConnectionWhere>>;
	OR?: InputMaybe<Array<ScenarioConditionTreatmentConnectionWhere>>;
	node?: InputMaybe<TreatmentWhere>;
	node_NOT?: InputMaybe<TreatmentWhere>;
};

export type ScenarioConditionTreatmentCreateFieldInput = {
	node: TreatmentCreateInput;
};

export type ScenarioConditionTreatmentDeleteFieldInput = {
	delete?: InputMaybe<TreatmentDeleteInput>;
	where?: InputMaybe<ScenarioConditionTreatmentConnectionWhere>;
};

export type ScenarioConditionTreatmentDisconnectFieldInput = {
	disconnect?: InputMaybe<TreatmentDisconnectInput>;
	where?: InputMaybe<ScenarioConditionTreatmentConnectionWhere>;
};

export type ScenarioConditionTreatmentFieldInput = {
	connect?: InputMaybe<ScenarioConditionTreatmentConnectFieldInput>;
	create?: InputMaybe<ScenarioConditionTreatmentCreateFieldInput>;
};

export type ScenarioConditionTreatmentNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<ScenarioConditionTreatmentNodeAggregationWhereInput>>;
	BagDossierNo_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	BagDossierNo_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	BagDossierNo_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	BagDossierNo_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	BagDossierNo_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	BagDossierNo_EQUAL?: InputMaybe<Scalars["String"]>;
	BagDossierNo_GT?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_GTE?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LT?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LTE?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	Code_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	Code_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	Code_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	Code_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	Code_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	Code_EQUAL?: InputMaybe<Scalars["String"]>;
	Code_GT?: InputMaybe<Scalars["Int"]>;
	Code_GTE?: InputMaybe<Scalars["Int"]>;
	Code_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Code_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	Code_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	Code_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	Code_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	Code_LT?: InputMaybe<Scalars["Int"]>;
	Code_LTE?: InputMaybe<Scalars["Int"]>;
	Code_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Code_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	Code_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	Code_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	Code_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	FlagModal_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	FlagModal_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	FlagModal_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	FlagModal_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	FlagModal_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	FlagModal_EQUAL?: InputMaybe<Scalars["String"]>;
	FlagModal_GT?: InputMaybe<Scalars["Int"]>;
	FlagModal_GTE?: InputMaybe<Scalars["Int"]>;
	FlagModal_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	FlagModal_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	FlagModal_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	FlagModal_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	FlagModal_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	FlagModal_LT?: InputMaybe<Scalars["Int"]>;
	FlagModal_LTE?: InputMaybe<Scalars["Int"]>;
	FlagModal_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	FlagModal_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	FlagModal_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	FlagModal_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	FlagModal_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	FlagNarcosis_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	FlagNarcosis_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	FlagNarcosis_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	FlagNarcosis_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	FlagNarcosis_EQUAL?: InputMaybe<Scalars["String"]>;
	FlagNarcosis_GT?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_GTE?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LT?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LTE?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	GTIN_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	GTIN_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	GTIN_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	GTIN_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	GTIN_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	GTIN_EQUAL?: InputMaybe<Scalars["String"]>;
	GTIN_GT?: InputMaybe<Scalars["Int"]>;
	GTIN_GTE?: InputMaybe<Scalars["Int"]>;
	GTIN_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	GTIN_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	GTIN_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	GTIN_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	GTIN_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	GTIN_LT?: InputMaybe<Scalars["Int"]>;
	GTIN_LTE?: InputMaybe<Scalars["Int"]>;
	GTIN_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	GTIN_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	GTIN_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	GTIN_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	GTIN_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	LOT_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	LOT_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	LOT_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	LOT_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	LOT_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	LOT_EQUAL?: InputMaybe<Scalars["String"]>;
	LOT_GT?: InputMaybe<Scalars["Int"]>;
	LOT_GTE?: InputMaybe<Scalars["Int"]>;
	LOT_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	LOT_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	LOT_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	LOT_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	LOT_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	LOT_LT?: InputMaybe<Scalars["Int"]>;
	LOT_LTE?: InputMaybe<Scalars["Int"]>;
	LOT_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	LOT_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	LOT_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	LOT_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	LOT_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	Name_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	Name_EQUAL?: InputMaybe<Scalars["String"]>;
	Name_GT?: InputMaybe<Scalars["Int"]>;
	Name_GTE?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	Name_LT?: InputMaybe<Scalars["Int"]>;
	Name_LTE?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	OR?: InputMaybe<Array<ScenarioConditionTreatmentNodeAggregationWhereInput>>;
	PharmaCode_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	PharmaCode_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	PharmaCode_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	PharmaCode_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	PharmaCode_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	PharmaCode_EQUAL?: InputMaybe<Scalars["String"]>;
	PharmaCode_GT?: InputMaybe<Scalars["Int"]>;
	PharmaCode_GTE?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LT?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LTE?: InputMaybe<Scalars["Int"]>;
	PharmaCode_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	PharmaCode_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	PharmaCode_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	PharmaCode_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	PharmaCode_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	PrevPharmacode_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	PrevPharmacode_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	PrevPharmacode_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	PrevPharmacode_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	PrevPharmacode_EQUAL?: InputMaybe<Scalars["String"]>;
	PrevPharmacode_GT?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_GTE?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LT?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LTE?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	REF_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	REF_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	REF_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	REF_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	REF_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	REF_EQUAL?: InputMaybe<Scalars["String"]>;
	REF_GT?: InputMaybe<Scalars["Int"]>;
	REF_GTE?: InputMaybe<Scalars["Int"]>;
	REF_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	REF_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	REF_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	REF_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	REF_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	REF_LT?: InputMaybe<Scalars["Int"]>;
	REF_LTE?: InputMaybe<Scalars["Int"]>;
	REF_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	REF_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	REF_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	REF_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	REF_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	SwissmedicCategory_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	SwissmedicCategory_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	SwissmedicCategory_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	SwissmedicCategory_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	SwissmedicCategory_EQUAL?: InputMaybe<Scalars["String"]>;
	SwissmedicCategory_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo8_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo8_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo8_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo8_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo8_EQUAL?: InputMaybe<Scalars["String"]>;
	SwissmedicNo8_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	UDI_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	UDI_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	UDI_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	UDI_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	UDI_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	UDI_EQUAL?: InputMaybe<Scalars["String"]>;
	UDI_GT?: InputMaybe<Scalars["Int"]>;
	UDI_GTE?: InputMaybe<Scalars["Int"]>;
	UDI_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	UDI_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	UDI_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	UDI_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	UDI_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	UDI_LT?: InputMaybe<Scalars["Int"]>;
	UDI_LTE?: InputMaybe<Scalars["Int"]>;
	UDI_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	UDI_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	UDI_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	UDI_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	UDI_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	classificationSystem_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	classificationSystem_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	classificationSystem_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	classificationSystem_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	classificationSystem_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	classificationSystem_EQUAL?: InputMaybe<Scalars["String"]>;
	classificationSystem_GT?: InputMaybe<Scalars["Int"]>;
	classificationSystem_GTE?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LT?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LTE?: InputMaybe<Scalars["Int"]>;
	classificationSystem_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	classificationSystem_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	classificationSystem_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	classificationSystem_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	classificationSystem_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type ScenarioConditionTreatmentRelationship = {
	__typename?: "ScenarioConditionTreatmentRelationship";
	cursor: Scalars["String"];
	node: Treatment;
};

export type ScenarioConditionTreatmentUpdateConnectionInput = {
	node?: InputMaybe<TreatmentUpdateInput>;
};

export type ScenarioConditionTreatmentUpdateFieldInput = {
	connect?: InputMaybe<ScenarioConditionTreatmentConnectFieldInput>;
	create?: InputMaybe<ScenarioConditionTreatmentCreateFieldInput>;
	delete?: InputMaybe<ScenarioConditionTreatmentDeleteFieldInput>;
	disconnect?: InputMaybe<ScenarioConditionTreatmentDisconnectFieldInput>;
	update?: InputMaybe<ScenarioConditionTreatmentUpdateConnectionInput>;
	where?: InputMaybe<ScenarioConditionTreatmentConnectionWhere>;
};

export type ScenarioConditionUpdateInput = {
	adverseEvents?: InputMaybe<Array<AdverseEventType>>;
	brand?: InputMaybe<ScenarioConditionBrandUpdateFieldInput>;
	conditionStatus?: InputMaybe<Array<OutcomeBasedStatus>>;
	conditionType?: InputMaybe<ConditionType>;
	consideredRating?: InputMaybe<ConditionConsideredRating>;
	consideredSecInterventionRate?: InputMaybe<ConditionConsideredSecIntervention>;
	deviceKits?: InputMaybe<Array<ScenarioConditionDeviceKitsUpdateFieldInput>>;
	discontinuationReason?: InputMaybe<TreatmentDiscontinuationReason>;
	endRangeValue?: InputMaybe<Scalars["Float"]>;
	grades?: InputMaybe<Array<AdverseEventGrades>>;
	intervention?: InputMaybe<InterventionType>;
	interventionOccurrence?: InputMaybe<InterventionOccurrence>;
	occurence?: InputMaybe<Occurrence>;
	operator?: InputMaybe<ArithmeticalOperator>;
	order?: InputMaybe<Scalars["Int"]>;
	patientScope?: InputMaybe<PatientScope>;
	reintervention?: InputMaybe<Reintervention>;
	responseInclusionType?: InputMaybe<ResponseInclusionType>;
	responseType?: InputMaybe<ResponseType>;
	scenario?: InputMaybe<ScenarioConditionScenarioUpdateFieldInput>;
	startingPoint?: InputMaybe<TimeframeStartingPoint>;
	timeframe?: InputMaybe<ScenarioConditionTimeframeUpdateFieldInput>;
	timeframeEnd?: InputMaybe<Scalars["Int"]>;
	timeframeEndDate?: InputMaybe<Scalars["Date"]>;
	timeframeRangeType?: InputMaybe<TimeframeRangeType>;
	timeframeStart?: InputMaybe<Scalars["Int"]>;
	timeframeStartDate?: InputMaybe<Scalars["Date"]>;
	treatment?: InputMaybe<ScenarioConditionTreatmentUpdateFieldInput>;
	treatmentDurationAspect?: InputMaybe<TreatmentDurationConditionAspect>;
	value?: InputMaybe<Scalars["Float"]>;
};

export type ScenarioConditionWhere = {
	AND?: InputMaybe<Array<ScenarioConditionWhere>>;
	OR?: InputMaybe<Array<ScenarioConditionWhere>>;
	adverseEvents?: InputMaybe<Array<AdverseEventType>>;
	adverseEvents_INCLUDES?: InputMaybe<AdverseEventType>;
	adverseEvents_NOT?: InputMaybe<Array<AdverseEventType>>;
	adverseEvents_NOT_INCLUDES?: InputMaybe<AdverseEventType>;
	brand?: InputMaybe<BrandWhere>;
	brandAggregate?: InputMaybe<ScenarioConditionBrandAggregateInput>;
	brandConnection?: InputMaybe<ScenarioConditionBrandConnectionWhere>;
	brandConnection_NOT?: InputMaybe<ScenarioConditionBrandConnectionWhere>;
	brand_NOT?: InputMaybe<BrandWhere>;
	conditionStatus?: InputMaybe<Array<OutcomeBasedStatus>>;
	conditionStatus_INCLUDES?: InputMaybe<OutcomeBasedStatus>;
	conditionStatus_NOT?: InputMaybe<Array<OutcomeBasedStatus>>;
	conditionStatus_NOT_INCLUDES?: InputMaybe<OutcomeBasedStatus>;
	conditionType?: InputMaybe<ConditionType>;
	conditionType_IN?: InputMaybe<Array<InputMaybe<ConditionType>>>;
	conditionType_NOT?: InputMaybe<ConditionType>;
	conditionType_NOT_IN?: InputMaybe<Array<InputMaybe<ConditionType>>>;
	consideredRating?: InputMaybe<ConditionConsideredRating>;
	consideredRating_IN?: InputMaybe<Array<InputMaybe<ConditionConsideredRating>>>;
	consideredRating_NOT?: InputMaybe<ConditionConsideredRating>;
	consideredRating_NOT_IN?: InputMaybe<Array<InputMaybe<ConditionConsideredRating>>>;
	consideredSecInterventionRate?: InputMaybe<ConditionConsideredSecIntervention>;
	consideredSecInterventionRate_IN?: InputMaybe<Array<InputMaybe<ConditionConsideredSecIntervention>>>;
	consideredSecInterventionRate_NOT?: InputMaybe<ConditionConsideredSecIntervention>;
	consideredSecInterventionRate_NOT_IN?: InputMaybe<Array<InputMaybe<ConditionConsideredSecIntervention>>>;
	deviceKits?: InputMaybe<DeviceKitWhere>;
	deviceKitsAggregate?: InputMaybe<ScenarioConditionDeviceKitsAggregateInput>;
	deviceKitsConnection?: InputMaybe<ScenarioConditionDeviceKitsConnectionWhere>;
	deviceKitsConnection_NOT?: InputMaybe<ScenarioConditionDeviceKitsConnectionWhere>;
	deviceKits_NOT?: InputMaybe<DeviceKitWhere>;
	discontinuationReason?: InputMaybe<TreatmentDiscontinuationReason>;
	discontinuationReason_IN?: InputMaybe<Array<InputMaybe<TreatmentDiscontinuationReason>>>;
	discontinuationReason_NOT?: InputMaybe<TreatmentDiscontinuationReason>;
	discontinuationReason_NOT_IN?: InputMaybe<Array<InputMaybe<TreatmentDiscontinuationReason>>>;
	endRangeValue?: InputMaybe<Scalars["Float"]>;
	endRangeValue_GT?: InputMaybe<Scalars["Float"]>;
	endRangeValue_GTE?: InputMaybe<Scalars["Float"]>;
	endRangeValue_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	endRangeValue_LT?: InputMaybe<Scalars["Float"]>;
	endRangeValue_LTE?: InputMaybe<Scalars["Float"]>;
	endRangeValue_NOT?: InputMaybe<Scalars["Float"]>;
	endRangeValue_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	grades?: InputMaybe<Array<AdverseEventGrades>>;
	grades_INCLUDES?: InputMaybe<AdverseEventGrades>;
	grades_NOT?: InputMaybe<Array<AdverseEventGrades>>;
	grades_NOT_INCLUDES?: InputMaybe<AdverseEventGrades>;
	intervention?: InputMaybe<InterventionType>;
	interventionOccurrence?: InputMaybe<InterventionOccurrence>;
	interventionOccurrence_IN?: InputMaybe<Array<InputMaybe<InterventionOccurrence>>>;
	interventionOccurrence_NOT?: InputMaybe<InterventionOccurrence>;
	interventionOccurrence_NOT_IN?: InputMaybe<Array<InputMaybe<InterventionOccurrence>>>;
	intervention_IN?: InputMaybe<Array<InputMaybe<InterventionType>>>;
	intervention_NOT?: InputMaybe<InterventionType>;
	intervention_NOT_IN?: InputMaybe<Array<InputMaybe<InterventionType>>>;
	occurence?: InputMaybe<Occurrence>;
	occurence_IN?: InputMaybe<Array<InputMaybe<Occurrence>>>;
	occurence_NOT?: InputMaybe<Occurrence>;
	occurence_NOT_IN?: InputMaybe<Array<InputMaybe<Occurrence>>>;
	operator?: InputMaybe<ArithmeticalOperator>;
	operator_IN?: InputMaybe<Array<InputMaybe<ArithmeticalOperator>>>;
	operator_NOT?: InputMaybe<ArithmeticalOperator>;
	operator_NOT_IN?: InputMaybe<Array<InputMaybe<ArithmeticalOperator>>>;
	order?: InputMaybe<Scalars["Int"]>;
	order_GT?: InputMaybe<Scalars["Int"]>;
	order_GTE?: InputMaybe<Scalars["Int"]>;
	order_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	order_LT?: InputMaybe<Scalars["Int"]>;
	order_LTE?: InputMaybe<Scalars["Int"]>;
	order_NOT?: InputMaybe<Scalars["Int"]>;
	order_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	patientScope?: InputMaybe<PatientScope>;
	patientScope_IN?: InputMaybe<Array<InputMaybe<PatientScope>>>;
	patientScope_NOT?: InputMaybe<PatientScope>;
	patientScope_NOT_IN?: InputMaybe<Array<InputMaybe<PatientScope>>>;
	reintervention?: InputMaybe<Reintervention>;
	reintervention_IN?: InputMaybe<Array<InputMaybe<Reintervention>>>;
	reintervention_NOT?: InputMaybe<Reintervention>;
	reintervention_NOT_IN?: InputMaybe<Array<InputMaybe<Reintervention>>>;
	responseInclusionType?: InputMaybe<ResponseInclusionType>;
	responseInclusionType_IN?: InputMaybe<Array<InputMaybe<ResponseInclusionType>>>;
	responseInclusionType_NOT?: InputMaybe<ResponseInclusionType>;
	responseInclusionType_NOT_IN?: InputMaybe<Array<InputMaybe<ResponseInclusionType>>>;
	responseType?: InputMaybe<ResponseType>;
	responseType_IN?: InputMaybe<Array<InputMaybe<ResponseType>>>;
	responseType_NOT?: InputMaybe<ResponseType>;
	responseType_NOT_IN?: InputMaybe<Array<InputMaybe<ResponseType>>>;
	scenario?: InputMaybe<ScenarioWhere>;
	scenarioAggregate?: InputMaybe<ScenarioConditionScenarioAggregateInput>;
	scenarioConnection?: InputMaybe<ScenarioConditionScenarioConnectionWhere>;
	scenarioConnection_NOT?: InputMaybe<ScenarioConditionScenarioConnectionWhere>;
	scenario_NOT?: InputMaybe<ScenarioWhere>;
	startingPoint?: InputMaybe<TimeframeStartingPoint>;
	startingPoint_IN?: InputMaybe<Array<InputMaybe<TimeframeStartingPoint>>>;
	startingPoint_NOT?: InputMaybe<TimeframeStartingPoint>;
	startingPoint_NOT_IN?: InputMaybe<Array<InputMaybe<TimeframeStartingPoint>>>;
	timeframe?: InputMaybe<TimeframeWhere>;
	timeframeAggregate?: InputMaybe<ScenarioConditionTimeframeAggregateInput>;
	timeframeConnection?: InputMaybe<ScenarioConditionTimeframeConnectionWhere>;
	timeframeConnection_NOT?: InputMaybe<ScenarioConditionTimeframeConnectionWhere>;
	timeframeEnd?: InputMaybe<Scalars["Int"]>;
	timeframeEndDate?: InputMaybe<Scalars["Date"]>;
	timeframeEndDate_GT?: InputMaybe<Scalars["Date"]>;
	timeframeEndDate_GTE?: InputMaybe<Scalars["Date"]>;
	timeframeEndDate_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
	timeframeEndDate_LT?: InputMaybe<Scalars["Date"]>;
	timeframeEndDate_LTE?: InputMaybe<Scalars["Date"]>;
	timeframeEndDate_NOT?: InputMaybe<Scalars["Date"]>;
	timeframeEndDate_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
	timeframeEnd_GT?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_GTE?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	timeframeEnd_LT?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_LTE?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_NOT?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	timeframeRangeType?: InputMaybe<TimeframeRangeType>;
	timeframeRangeType_IN?: InputMaybe<Array<InputMaybe<TimeframeRangeType>>>;
	timeframeRangeType_NOT?: InputMaybe<TimeframeRangeType>;
	timeframeRangeType_NOT_IN?: InputMaybe<Array<InputMaybe<TimeframeRangeType>>>;
	timeframeStart?: InputMaybe<Scalars["Int"]>;
	timeframeStartDate?: InputMaybe<Scalars["Date"]>;
	timeframeStartDate_GT?: InputMaybe<Scalars["Date"]>;
	timeframeStartDate_GTE?: InputMaybe<Scalars["Date"]>;
	timeframeStartDate_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
	timeframeStartDate_LT?: InputMaybe<Scalars["Date"]>;
	timeframeStartDate_LTE?: InputMaybe<Scalars["Date"]>;
	timeframeStartDate_NOT?: InputMaybe<Scalars["Date"]>;
	timeframeStartDate_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
	timeframeStart_GT?: InputMaybe<Scalars["Int"]>;
	timeframeStart_GTE?: InputMaybe<Scalars["Int"]>;
	timeframeStart_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	timeframeStart_LT?: InputMaybe<Scalars["Int"]>;
	timeframeStart_LTE?: InputMaybe<Scalars["Int"]>;
	timeframeStart_NOT?: InputMaybe<Scalars["Int"]>;
	timeframeStart_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	timeframe_NOT?: InputMaybe<TimeframeWhere>;
	treatment?: InputMaybe<TreatmentWhere>;
	treatmentAggregate?: InputMaybe<ScenarioConditionTreatmentAggregateInput>;
	treatmentConnection?: InputMaybe<ScenarioConditionTreatmentConnectionWhere>;
	treatmentConnection_NOT?: InputMaybe<ScenarioConditionTreatmentConnectionWhere>;
	treatmentDurationAspect?: InputMaybe<TreatmentDurationConditionAspect>;
	treatmentDurationAspect_IN?: InputMaybe<Array<InputMaybe<TreatmentDurationConditionAspect>>>;
	treatmentDurationAspect_NOT?: InputMaybe<TreatmentDurationConditionAspect>;
	treatmentDurationAspect_NOT_IN?: InputMaybe<Array<InputMaybe<TreatmentDurationConditionAspect>>>;
	treatment_NOT?: InputMaybe<TreatmentWhere>;
	value?: InputMaybe<Scalars["Float"]>;
	value_GT?: InputMaybe<Scalars["Float"]>;
	value_GTE?: InputMaybe<Scalars["Float"]>;
	value_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	value_LT?: InputMaybe<Scalars["Float"]>;
	value_LTE?: InputMaybe<Scalars["Float"]>;
	value_NOT?: InputMaybe<Scalars["Float"]>;
	value_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
};

export type ScenarioConditionsAggregateInput = {
	AND?: InputMaybe<Array<ScenarioConditionsAggregateInput>>;
	OR?: InputMaybe<Array<ScenarioConditionsAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<ScenarioConditionsNodeAggregationWhereInput>;
};

export type ScenarioConditionsConnectFieldInput = {
	connect?: InputMaybe<Array<ScenarioConditionConnectInput>>;
	where?: InputMaybe<ScenarioConditionConnectWhere>;
};

export type ScenarioConditionsConnection = {
	__typename?: "ScenarioConditionsConnection";
	edges: Array<ScenarioConditionsRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type ScenarioConditionsConnectionSort = {
	node?: InputMaybe<ScenarioConditionSort>;
};

export type ScenarioConditionsConnectionWhere = {
	AND?: InputMaybe<Array<ScenarioConditionsConnectionWhere>>;
	OR?: InputMaybe<Array<ScenarioConditionsConnectionWhere>>;
	node?: InputMaybe<ScenarioConditionWhere>;
	node_NOT?: InputMaybe<ScenarioConditionWhere>;
};

export type ScenarioConditionsCreateFieldInput = {
	node: ScenarioConditionCreateInput;
};

export type ScenarioConditionsDeleteFieldInput = {
	delete?: InputMaybe<ScenarioConditionDeleteInput>;
	where?: InputMaybe<ScenarioConditionsConnectionWhere>;
};

export type ScenarioConditionsDisconnectFieldInput = {
	disconnect?: InputMaybe<ScenarioConditionDisconnectInput>;
	where?: InputMaybe<ScenarioConditionsConnectionWhere>;
};

export type ScenarioConditionsFieldInput = {
	connect?: InputMaybe<Array<ScenarioConditionsConnectFieldInput>>;
	create?: InputMaybe<Array<ScenarioConditionsCreateFieldInput>>;
};

export type ScenarioConditionsNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<ScenarioConditionsNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<ScenarioConditionsNodeAggregationWhereInput>>;
	endRangeValue_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	endRangeValue_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	endRangeValue_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	endRangeValue_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	endRangeValue_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	endRangeValue_EQUAL?: InputMaybe<Scalars["Float"]>;
	endRangeValue_GT?: InputMaybe<Scalars["Float"]>;
	endRangeValue_GTE?: InputMaybe<Scalars["Float"]>;
	endRangeValue_LT?: InputMaybe<Scalars["Float"]>;
	endRangeValue_LTE?: InputMaybe<Scalars["Float"]>;
	endRangeValue_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	endRangeValue_MAX_GT?: InputMaybe<Scalars["Float"]>;
	endRangeValue_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	endRangeValue_MAX_LT?: InputMaybe<Scalars["Float"]>;
	endRangeValue_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	endRangeValue_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	endRangeValue_MIN_GT?: InputMaybe<Scalars["Float"]>;
	endRangeValue_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	endRangeValue_MIN_LT?: InputMaybe<Scalars["Float"]>;
	endRangeValue_MIN_LTE?: InputMaybe<Scalars["Float"]>;
	order_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	order_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	order_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	order_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	order_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	order_EQUAL?: InputMaybe<Scalars["Int"]>;
	order_GT?: InputMaybe<Scalars["Int"]>;
	order_GTE?: InputMaybe<Scalars["Int"]>;
	order_LT?: InputMaybe<Scalars["Int"]>;
	order_LTE?: InputMaybe<Scalars["Int"]>;
	order_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	order_MAX_GT?: InputMaybe<Scalars["Int"]>;
	order_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	order_MAX_LT?: InputMaybe<Scalars["Int"]>;
	order_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	order_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	order_MIN_GT?: InputMaybe<Scalars["Int"]>;
	order_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	order_MIN_LT?: InputMaybe<Scalars["Int"]>;
	order_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	timeframeEnd_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	timeframeEnd_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	timeframeEnd_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	timeframeEnd_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	timeframeEnd_EQUAL?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_GT?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_GTE?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_LT?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_LTE?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_MAX_GT?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_MAX_LT?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_MIN_GT?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_MIN_LT?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	timeframeStart_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	timeframeStart_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	timeframeStart_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	timeframeStart_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	timeframeStart_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	timeframeStart_EQUAL?: InputMaybe<Scalars["Int"]>;
	timeframeStart_GT?: InputMaybe<Scalars["Int"]>;
	timeframeStart_GTE?: InputMaybe<Scalars["Int"]>;
	timeframeStart_LT?: InputMaybe<Scalars["Int"]>;
	timeframeStart_LTE?: InputMaybe<Scalars["Int"]>;
	timeframeStart_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	timeframeStart_MAX_GT?: InputMaybe<Scalars["Int"]>;
	timeframeStart_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	timeframeStart_MAX_LT?: InputMaybe<Scalars["Int"]>;
	timeframeStart_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	timeframeStart_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	timeframeStart_MIN_GT?: InputMaybe<Scalars["Int"]>;
	timeframeStart_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	timeframeStart_MIN_LT?: InputMaybe<Scalars["Int"]>;
	timeframeStart_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	value_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	value_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	value_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	value_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	value_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	value_EQUAL?: InputMaybe<Scalars["Float"]>;
	value_GT?: InputMaybe<Scalars["Float"]>;
	value_GTE?: InputMaybe<Scalars["Float"]>;
	value_LT?: InputMaybe<Scalars["Float"]>;
	value_LTE?: InputMaybe<Scalars["Float"]>;
	value_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	value_MAX_GT?: InputMaybe<Scalars["Float"]>;
	value_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	value_MAX_LT?: InputMaybe<Scalars["Float"]>;
	value_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	value_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	value_MIN_GT?: InputMaybe<Scalars["Float"]>;
	value_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	value_MIN_LT?: InputMaybe<Scalars["Float"]>;
	value_MIN_LTE?: InputMaybe<Scalars["Float"]>;
};

export type ScenarioConditionsRelationship = {
	__typename?: "ScenarioConditionsRelationship";
	cursor: Scalars["String"];
	node: ScenarioCondition;
};

export type ScenarioConditionsUpdateConnectionInput = {
	node?: InputMaybe<ScenarioConditionUpdateInput>;
};

export type ScenarioConditionsUpdateFieldInput = {
	connect?: InputMaybe<Array<ScenarioConditionsConnectFieldInput>>;
	create?: InputMaybe<Array<ScenarioConditionsCreateFieldInput>>;
	delete?: InputMaybe<Array<ScenarioConditionsDeleteFieldInput>>;
	disconnect?: InputMaybe<Array<ScenarioConditionsDisconnectFieldInput>>;
	update?: InputMaybe<ScenarioConditionsUpdateConnectionInput>;
	where?: InputMaybe<ScenarioConditionsConnectionWhere>;
};

export type ScenarioConnectInput = {
	actions?: InputMaybe<Array<ScenarioActionsConnectFieldInput>>;
	agreement?: InputMaybe<ScenarioAgreementConnectFieldInput>;
	conditions?: InputMaybe<Array<ScenarioConditionsConnectFieldInput>>;
};

export type ScenarioConnectWhere = {
	node: ScenarioWhere;
};

export type ScenarioCreateInput = {
	actions?: InputMaybe<ScenarioActionsFieldInput>;
	agreement?: InputMaybe<ScenarioAgreementFieldInput>;
	conditions?: InputMaybe<ScenarioConditionsFieldInput>;
	group?: InputMaybe<Scalars["Int"]>;
	isForged?: InputMaybe<Scalars["Boolean"]>;
	isGrouped?: InputMaybe<Scalars["Boolean"]>;
	operator: ConditionLogicalOperator;
	order: Scalars["Int"];
};

export type ScenarioDeleteInput = {
	actions?: InputMaybe<Array<ScenarioActionsDeleteFieldInput>>;
	agreement?: InputMaybe<ScenarioAgreementDeleteFieldInput>;
	conditions?: InputMaybe<Array<ScenarioConditionsDeleteFieldInput>>;
};

export type ScenarioDisconnectInput = {
	actions?: InputMaybe<Array<ScenarioActionsDisconnectFieldInput>>;
	agreement?: InputMaybe<ScenarioAgreementDisconnectFieldInput>;
	conditions?: InputMaybe<Array<ScenarioConditionsDisconnectFieldInput>>;
};

export type ScenarioInsightsUserContext = {
	categoryInput?: Maybe<Scalars["String"]>;
	groups?: Maybe<Array<Maybe<Scalars["Int"]>>>;
	rebateObjective?: Maybe<Scalars["String"]>;
	timeframeLabel: Scalars["String"];
};

export type ScenarioInsightsUserContextCreateInput = {
	categoryInput?: InputMaybe<Scalars["String"]>;
	groups?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	rebateObjective?: InputMaybe<Scalars["String"]>;
	timeframeLabel: Scalars["String"];
};

export type ScenarioInsightsUserContextInput = {
	categoryInput?: InputMaybe<Scalars["String"]>;
	rebateObjective?: InputMaybe<Scalars["String"]>;
};

export type ScenarioInsightsUserContextSort = {
	categoryInput?: InputMaybe<SortDirection>;
	groups?: InputMaybe<SortDirection>;
	rebateObjective?: InputMaybe<SortDirection>;
	timeframeLabel?: InputMaybe<SortDirection>;
};

export type ScenarioInsightsUserContextUpdateInput = {
	categoryInput?: InputMaybe<Scalars["String"]>;
	groups?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	rebateObjective?: InputMaybe<Scalars["String"]>;
	timeframeLabel?: InputMaybe<Scalars["String"]>;
};

export type ScenarioInsightsUserContextWhere = {
	AND?: InputMaybe<Array<ScenarioInsightsUserContextWhere>>;
	OR?: InputMaybe<Array<ScenarioInsightsUserContextWhere>>;
	categoryInput?: InputMaybe<Scalars["String"]>;
	categoryInput_CONTAINS?: InputMaybe<Scalars["String"]>;
	categoryInput_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	categoryInput_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	categoryInput_MATCHES?: InputMaybe<Scalars["String"]>;
	categoryInput_NOT?: InputMaybe<Scalars["String"]>;
	categoryInput_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	categoryInput_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	categoryInput_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	categoryInput_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	categoryInput_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	groups?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	groups_INCLUDES?: InputMaybe<Scalars["Int"]>;
	groups_NOT?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	groups_NOT_INCLUDES?: InputMaybe<Scalars["Int"]>;
	rebateObjective?: InputMaybe<Scalars["String"]>;
	rebateObjective_CONTAINS?: InputMaybe<Scalars["String"]>;
	rebateObjective_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	rebateObjective_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	rebateObjective_MATCHES?: InputMaybe<Scalars["String"]>;
	rebateObjective_NOT?: InputMaybe<Scalars["String"]>;
	rebateObjective_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	rebateObjective_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	rebateObjective_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	rebateObjective_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	rebateObjective_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	timeframeLabel?: InputMaybe<Scalars["String"]>;
	timeframeLabel_CONTAINS?: InputMaybe<Scalars["String"]>;
	timeframeLabel_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	timeframeLabel_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	timeframeLabel_MATCHES?: InputMaybe<Scalars["String"]>;
	timeframeLabel_NOT?: InputMaybe<Scalars["String"]>;
	timeframeLabel_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	timeframeLabel_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	timeframeLabel_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	timeframeLabel_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	timeframeLabel_STARTS_WITH?: InputMaybe<Scalars["String"]>;
};

export type ScenarioOptions = {
	limit?: InputMaybe<Scalars["Int"]>;
	offset?: InputMaybe<Scalars["Int"]>;
	/** Specify one or more ScenarioSort objects to sort Scenarios by. The sorts will be applied in the order in which they are arranged in the array. */
	sort?: InputMaybe<Array<InputMaybe<ScenarioSort>>>;
};

/** Fields to sort Scenarios by. The order in which sorts are applied is not guaranteed when specifying many fields in one ScenarioSort object. */
export type ScenarioSort = {
	group?: InputMaybe<SortDirection>;
	isForged?: InputMaybe<SortDirection>;
	isGrouped?: InputMaybe<SortDirection>;
	operator?: InputMaybe<SortDirection>;
	order?: InputMaybe<SortDirection>;
};

export type ScenarioUpdateInput = {
	actions?: InputMaybe<Array<ScenarioActionsUpdateFieldInput>>;
	agreement?: InputMaybe<ScenarioAgreementUpdateFieldInput>;
	conditions?: InputMaybe<Array<ScenarioConditionsUpdateFieldInput>>;
	group?: InputMaybe<Scalars["Int"]>;
	isForged?: InputMaybe<Scalars["Boolean"]>;
	isGrouped?: InputMaybe<Scalars["Boolean"]>;
	operator?: InputMaybe<ConditionLogicalOperator>;
	order?: InputMaybe<Scalars["Int"]>;
};

export type ScenarioWhere = {
	AND?: InputMaybe<Array<ScenarioWhere>>;
	OR?: InputMaybe<Array<ScenarioWhere>>;
	actions?: InputMaybe<ScenarioActionWhere>;
	actionsAggregate?: InputMaybe<ScenarioActionsAggregateInput>;
	actionsConnection?: InputMaybe<ScenarioActionsConnectionWhere>;
	actionsConnection_NOT?: InputMaybe<ScenarioActionsConnectionWhere>;
	actions_NOT?: InputMaybe<ScenarioActionWhere>;
	agreement?: InputMaybe<BaseAgreementWhere>;
	agreementAggregate?: InputMaybe<ScenarioAgreementAggregateInput>;
	agreementConnection?: InputMaybe<ScenarioAgreementConnectionWhere>;
	agreementConnection_NOT?: InputMaybe<ScenarioAgreementConnectionWhere>;
	agreement_NOT?: InputMaybe<BaseAgreementWhere>;
	conditions?: InputMaybe<ScenarioConditionWhere>;
	conditionsAggregate?: InputMaybe<ScenarioConditionsAggregateInput>;
	conditionsConnection?: InputMaybe<ScenarioConditionsConnectionWhere>;
	conditionsConnection_NOT?: InputMaybe<ScenarioConditionsConnectionWhere>;
	conditions_NOT?: InputMaybe<ScenarioConditionWhere>;
	group?: InputMaybe<Scalars["Int"]>;
	group_GT?: InputMaybe<Scalars["Int"]>;
	group_GTE?: InputMaybe<Scalars["Int"]>;
	group_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	group_LT?: InputMaybe<Scalars["Int"]>;
	group_LTE?: InputMaybe<Scalars["Int"]>;
	group_NOT?: InputMaybe<Scalars["Int"]>;
	group_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	isForged?: InputMaybe<Scalars["Boolean"]>;
	isForged_NOT?: InputMaybe<Scalars["Boolean"]>;
	isGrouped?: InputMaybe<Scalars["Boolean"]>;
	isGrouped_NOT?: InputMaybe<Scalars["Boolean"]>;
	operator?: InputMaybe<ConditionLogicalOperator>;
	operator_IN?: InputMaybe<Array<InputMaybe<ConditionLogicalOperator>>>;
	operator_NOT?: InputMaybe<ConditionLogicalOperator>;
	operator_NOT_IN?: InputMaybe<Array<InputMaybe<ConditionLogicalOperator>>>;
	order?: InputMaybe<Scalars["Int"]>;
	order_GT?: InputMaybe<Scalars["Int"]>;
	order_GTE?: InputMaybe<Scalars["Int"]>;
	order_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	order_LT?: InputMaybe<Scalars["Int"]>;
	order_LTE?: InputMaybe<Scalars["Int"]>;
	order_NOT?: InputMaybe<Scalars["Int"]>;
	order_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
};

export type SearchUserEmailByNameInput = {
	invoiceId: Scalars["ID"];
	searchString?: InputMaybe<Scalars["String"]>;
	targetTenantId?: InputMaybe<Scalars["String"]>;
};

export type SentClaimRelationship = {
	date?: Maybe<Scalars["DateTime"]>;
	timeStamp?: Maybe<Scalars["Float"]>;
};

export type SentClaimRelationshipCreateInput = {
	date?: InputMaybe<Scalars["DateTime"]>;
	timeStamp?: InputMaybe<Scalars["Float"]>;
};

export type SentClaimRelationshipSort = {
	date?: InputMaybe<SortDirection>;
	timeStamp?: InputMaybe<SortDirection>;
};

export type SentClaimRelationshipUpdateInput = {
	date?: InputMaybe<Scalars["DateTime"]>;
	timeStamp?: InputMaybe<Scalars["Float"]>;
};

export type SentClaimRelationshipWhere = {
	AND?: InputMaybe<Array<SentClaimRelationshipWhere>>;
	OR?: InputMaybe<Array<SentClaimRelationshipWhere>>;
	date?: InputMaybe<Scalars["DateTime"]>;
	date_GT?: InputMaybe<Scalars["DateTime"]>;
	date_GTE?: InputMaybe<Scalars["DateTime"]>;
	date_IN?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]>>>;
	date_LT?: InputMaybe<Scalars["DateTime"]>;
	date_LTE?: InputMaybe<Scalars["DateTime"]>;
	date_NOT?: InputMaybe<Scalars["DateTime"]>;
	date_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]>>>;
	timeStamp?: InputMaybe<Scalars["Float"]>;
	timeStamp_GT?: InputMaybe<Scalars["Float"]>;
	timeStamp_GTE?: InputMaybe<Scalars["Float"]>;
	timeStamp_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	timeStamp_LT?: InputMaybe<Scalars["Float"]>;
	timeStamp_LTE?: InputMaybe<Scalars["Float"]>;
	timeStamp_NOT?: InputMaybe<Scalars["Float"]>;
	timeStamp_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
};

export enum SortDirection {
	/** Sort by field values in ascending order. */
	Asc = "ASC",
	/** Sort by field values in descending order. */
	Desc = "DESC",
}

export type StobAction = IOrdered &
	TimeframeRelatedEntity & {
		__typename?: "StobAction";
		actionObject?: Maybe<StobActionObject>;
		actionType?: Maybe<StobActionType>;
		measureUnit?: Maybe<StobActionMeasureUnit>;
		order: Scalars["Int"];
		scenario: StobScenario;
		scenarioConnection: StobActionScenarioConnection;
		timeframeEnd?: Maybe<Scalars["Int"]>;
		timeframeRelation: StobTimeframeRelation;
		timeframeStart: Scalars["Int"];
		timeframeStartingPoint: StobTimeframeStartingPoint;
		value: Scalars["Float"];
	};

export type StobActionScenarioArgs = {
	options?: InputMaybe<StobScenarioOptions>;
	where?: InputMaybe<StobScenarioWhere>;
};

export type StobActionScenarioConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<StobActionScenarioConnectionSort>>;
	where?: InputMaybe<StobActionScenarioConnectionWhere>;
};

export type StobActionAggregateSelection = {
	__typename?: "StobActionAggregateSelection";
	count: Scalars["Int"];
	order: IntAggregateSelection;
	timeframeEnd: IntAggregateSelection;
	timeframeStart: IntAggregateSelection;
	value: FloatAggregateSelection;
};

export type StobActionConnectInput = {
	scenario?: InputMaybe<StobActionScenarioConnectFieldInput>;
};

export type StobActionConnectWhere = {
	node: StobActionWhere;
};

export type StobActionCreateInput = {
	actionObject?: InputMaybe<StobActionObject>;
	actionType?: InputMaybe<StobActionType>;
	measureUnit?: InputMaybe<StobActionMeasureUnit>;
	order: Scalars["Int"];
	scenario?: InputMaybe<StobActionScenarioFieldInput>;
	timeframeEnd?: InputMaybe<Scalars["Int"]>;
	timeframeRelation: StobTimeframeRelation;
	timeframeStart: Scalars["Int"];
	timeframeStartingPoint: StobTimeframeStartingPoint;
	value: Scalars["Float"];
};

export type StobActionDeleteInput = {
	scenario?: InputMaybe<StobActionScenarioDeleteFieldInput>;
};

export type StobActionDisconnectInput = {
	scenario?: InputMaybe<StobActionScenarioDisconnectFieldInput>;
};

export type StobActionInput = {
	actionObject?: InputMaybe<StobActionObject>;
	actionType?: InputMaybe<StobActionType>;
	measureUnit?: InputMaybe<StobActionMeasureUnit>;
	order: Scalars["Int"];
	timeframeEnd?: InputMaybe<Scalars["Int"]>;
	timeframeRelation: StobTimeframeRelation;
	timeframeStart?: InputMaybe<Scalars["Int"]>;
	timeframeStartingPoint: StobTimeframeStartingPoint;
	value?: InputMaybe<Scalars["Float"]>;
};

export enum StobActionMeasureUnit {
	BasePricePercent = "BASE_PRICE_PERCENT",
}

export enum StobActionObject {
	AllPackages = "ALL_PACKAGES",
}

export type StobActionOptions = {
	limit?: InputMaybe<Scalars["Int"]>;
	offset?: InputMaybe<Scalars["Int"]>;
	/** Specify one or more StobActionSort objects to sort StobActions by. The sorts will be applied in the order in which they are arranged in the array. */
	sort?: InputMaybe<Array<InputMaybe<StobActionSort>>>;
};

export type StobActionScenarioAggregateInput = {
	AND?: InputMaybe<Array<StobActionScenarioAggregateInput>>;
	OR?: InputMaybe<Array<StobActionScenarioAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<StobActionScenarioNodeAggregationWhereInput>;
};

export type StobActionScenarioConnectFieldInput = {
	connect?: InputMaybe<StobScenarioConnectInput>;
	where?: InputMaybe<StobScenarioConnectWhere>;
};

export type StobActionScenarioConnection = {
	__typename?: "StobActionScenarioConnection";
	edges: Array<StobActionScenarioRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type StobActionScenarioConnectionSort = {
	node?: InputMaybe<StobScenarioSort>;
};

export type StobActionScenarioConnectionWhere = {
	AND?: InputMaybe<Array<StobActionScenarioConnectionWhere>>;
	OR?: InputMaybe<Array<StobActionScenarioConnectionWhere>>;
	node?: InputMaybe<StobScenarioWhere>;
	node_NOT?: InputMaybe<StobScenarioWhere>;
};

export type StobActionScenarioCreateFieldInput = {
	node: StobScenarioCreateInput;
};

export type StobActionScenarioDeleteFieldInput = {
	delete?: InputMaybe<StobScenarioDeleteInput>;
	where?: InputMaybe<StobActionScenarioConnectionWhere>;
};

export type StobActionScenarioDisconnectFieldInput = {
	disconnect?: InputMaybe<StobScenarioDisconnectInput>;
	where?: InputMaybe<StobActionScenarioConnectionWhere>;
};

export type StobActionScenarioFieldInput = {
	connect?: InputMaybe<StobActionScenarioConnectFieldInput>;
	create?: InputMaybe<StobActionScenarioCreateFieldInput>;
};

export type StobActionScenarioNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<StobActionScenarioNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<StobActionScenarioNodeAggregationWhereInput>>;
	order_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	order_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	order_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	order_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	order_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	order_EQUAL?: InputMaybe<Scalars["Int"]>;
	order_GT?: InputMaybe<Scalars["Int"]>;
	order_GTE?: InputMaybe<Scalars["Int"]>;
	order_LT?: InputMaybe<Scalars["Int"]>;
	order_LTE?: InputMaybe<Scalars["Int"]>;
	order_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	order_MAX_GT?: InputMaybe<Scalars["Int"]>;
	order_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	order_MAX_LT?: InputMaybe<Scalars["Int"]>;
	order_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	order_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	order_MIN_GT?: InputMaybe<Scalars["Int"]>;
	order_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	order_MIN_LT?: InputMaybe<Scalars["Int"]>;
	order_MIN_LTE?: InputMaybe<Scalars["Int"]>;
};

export type StobActionScenarioRelationship = {
	__typename?: "StobActionScenarioRelationship";
	cursor: Scalars["String"];
	node: StobScenario;
};

export type StobActionScenarioUpdateConnectionInput = {
	node?: InputMaybe<StobScenarioUpdateInput>;
};

export type StobActionScenarioUpdateFieldInput = {
	connect?: InputMaybe<StobActionScenarioConnectFieldInput>;
	create?: InputMaybe<StobActionScenarioCreateFieldInput>;
	delete?: InputMaybe<StobActionScenarioDeleteFieldInput>;
	disconnect?: InputMaybe<StobActionScenarioDisconnectFieldInput>;
	update?: InputMaybe<StobActionScenarioUpdateConnectionInput>;
	where?: InputMaybe<StobActionScenarioConnectionWhere>;
};

/** Fields to sort StobActions by. The order in which sorts are applied is not guaranteed when specifying many fields in one StobActionSort object. */
export type StobActionSort = {
	actionObject?: InputMaybe<SortDirection>;
	actionType?: InputMaybe<SortDirection>;
	measureUnit?: InputMaybe<SortDirection>;
	order?: InputMaybe<SortDirection>;
	timeframeEnd?: InputMaybe<SortDirection>;
	timeframeRelation?: InputMaybe<SortDirection>;
	timeframeStart?: InputMaybe<SortDirection>;
	timeframeStartingPoint?: InputMaybe<SortDirection>;
	value?: InputMaybe<SortDirection>;
};

export enum StobActionType {
	Apply = "APPLY",
	Deduct = "DEDUCT",
}

export type StobActionUpdateInput = {
	actionObject?: InputMaybe<StobActionObject>;
	actionType?: InputMaybe<StobActionType>;
	measureUnit?: InputMaybe<StobActionMeasureUnit>;
	order?: InputMaybe<Scalars["Int"]>;
	scenario?: InputMaybe<StobActionScenarioUpdateFieldInput>;
	timeframeEnd?: InputMaybe<Scalars["Int"]>;
	timeframeRelation?: InputMaybe<StobTimeframeRelation>;
	timeframeStart?: InputMaybe<Scalars["Int"]>;
	timeframeStartingPoint?: InputMaybe<StobTimeframeStartingPoint>;
	value?: InputMaybe<Scalars["Float"]>;
};

export type StobActionWhere = {
	AND?: InputMaybe<Array<StobActionWhere>>;
	OR?: InputMaybe<Array<StobActionWhere>>;
	actionObject?: InputMaybe<StobActionObject>;
	actionObject_IN?: InputMaybe<Array<InputMaybe<StobActionObject>>>;
	actionObject_NOT?: InputMaybe<StobActionObject>;
	actionObject_NOT_IN?: InputMaybe<Array<InputMaybe<StobActionObject>>>;
	actionType?: InputMaybe<StobActionType>;
	actionType_IN?: InputMaybe<Array<InputMaybe<StobActionType>>>;
	actionType_NOT?: InputMaybe<StobActionType>;
	actionType_NOT_IN?: InputMaybe<Array<InputMaybe<StobActionType>>>;
	measureUnit?: InputMaybe<StobActionMeasureUnit>;
	measureUnit_IN?: InputMaybe<Array<InputMaybe<StobActionMeasureUnit>>>;
	measureUnit_NOT?: InputMaybe<StobActionMeasureUnit>;
	measureUnit_NOT_IN?: InputMaybe<Array<InputMaybe<StobActionMeasureUnit>>>;
	order?: InputMaybe<Scalars["Int"]>;
	order_GT?: InputMaybe<Scalars["Int"]>;
	order_GTE?: InputMaybe<Scalars["Int"]>;
	order_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	order_LT?: InputMaybe<Scalars["Int"]>;
	order_LTE?: InputMaybe<Scalars["Int"]>;
	order_NOT?: InputMaybe<Scalars["Int"]>;
	order_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	scenario?: InputMaybe<StobScenarioWhere>;
	scenarioAggregate?: InputMaybe<StobActionScenarioAggregateInput>;
	scenarioConnection?: InputMaybe<StobActionScenarioConnectionWhere>;
	scenarioConnection_NOT?: InputMaybe<StobActionScenarioConnectionWhere>;
	scenario_NOT?: InputMaybe<StobScenarioWhere>;
	timeframeEnd?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_GT?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_GTE?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	timeframeEnd_LT?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_LTE?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_NOT?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	timeframeRelation?: InputMaybe<StobTimeframeRelation>;
	timeframeRelation_IN?: InputMaybe<Array<InputMaybe<StobTimeframeRelation>>>;
	timeframeRelation_NOT?: InputMaybe<StobTimeframeRelation>;
	timeframeRelation_NOT_IN?: InputMaybe<Array<InputMaybe<StobTimeframeRelation>>>;
	timeframeStart?: InputMaybe<Scalars["Int"]>;
	timeframeStart_GT?: InputMaybe<Scalars["Int"]>;
	timeframeStart_GTE?: InputMaybe<Scalars["Int"]>;
	timeframeStart_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	timeframeStart_LT?: InputMaybe<Scalars["Int"]>;
	timeframeStart_LTE?: InputMaybe<Scalars["Int"]>;
	timeframeStart_NOT?: InputMaybe<Scalars["Int"]>;
	timeframeStart_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	timeframeStartingPoint?: InputMaybe<StobTimeframeStartingPoint>;
	timeframeStartingPoint_IN?: InputMaybe<Array<InputMaybe<StobTimeframeStartingPoint>>>;
	timeframeStartingPoint_NOT?: InputMaybe<StobTimeframeStartingPoint>;
	timeframeStartingPoint_NOT_IN?: InputMaybe<Array<InputMaybe<StobTimeframeStartingPoint>>>;
	value?: InputMaybe<Scalars["Float"]>;
	value_GT?: InputMaybe<Scalars["Float"]>;
	value_GTE?: InputMaybe<Scalars["Float"]>;
	value_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	value_LT?: InputMaybe<Scalars["Float"]>;
	value_LTE?: InputMaybe<Scalars["Float"]>;
	value_NOT?: InputMaybe<Scalars["Float"]>;
	value_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
};

export type StobCondition = IOrdered &
	TimeframeRelatedEntity & {
		__typename?: "StobCondition";
		conditionType: StobMeasureType;
		isNegative: Scalars["Boolean"];
		logicalCondition?: Maybe<LogicalCondition>;
		order: Scalars["Int"];
		responseType?: Maybe<IrResultOptions>;
		scenario: StobScenario;
		scenarioConnection: StobConditionScenarioConnection;
		timeframeEnd?: Maybe<Scalars["Int"]>;
		timeframeRelation: StobTimeframeRelation;
		timeframeStart: Scalars["Int"];
		timeframeStartingPoint: StobTimeframeStartingPoint;
	};

export type StobConditionScenarioArgs = {
	options?: InputMaybe<StobScenarioOptions>;
	where?: InputMaybe<StobScenarioWhere>;
};

export type StobConditionScenarioConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<StobConditionScenarioConnectionSort>>;
	where?: InputMaybe<StobConditionScenarioConnectionWhere>;
};

export type StobConditionAggregateSelection = {
	__typename?: "StobConditionAggregateSelection";
	count: Scalars["Int"];
	order: IntAggregateSelection;
	timeframeEnd: IntAggregateSelection;
	timeframeStart: IntAggregateSelection;
};

export type StobConditionConnectInput = {
	scenario?: InputMaybe<StobConditionScenarioConnectFieldInput>;
};

export type StobConditionConnectWhere = {
	node: StobConditionWhere;
};

export type StobConditionCreateInput = {
	conditionType: StobMeasureType;
	isNegative: Scalars["Boolean"];
	logicalCondition?: InputMaybe<LogicalCondition>;
	order: Scalars["Int"];
	responseType?: InputMaybe<IrResultOptions>;
	scenario?: InputMaybe<StobConditionScenarioFieldInput>;
	timeframeEnd?: InputMaybe<Scalars["Int"]>;
	timeframeRelation: StobTimeframeRelation;
	timeframeStart: Scalars["Int"];
	timeframeStartingPoint: StobTimeframeStartingPoint;
};

export type StobConditionDeleteInput = {
	scenario?: InputMaybe<StobConditionScenarioDeleteFieldInput>;
};

export type StobConditionDisconnectInput = {
	scenario?: InputMaybe<StobConditionScenarioDisconnectFieldInput>;
};

export type StobConditionInput = {
	conditionType: StobMeasureType;
	isNegative: Scalars["Boolean"];
	logicalCondition?: InputMaybe<LogicalCondition>;
	order: Scalars["Int"];
	responseType?: InputMaybe<IrResultOptions>;
	timeframeEnd?: InputMaybe<Scalars["Int"]>;
	timeframeRelation: StobTimeframeRelation;
	timeframeStart?: InputMaybe<Scalars["Int"]>;
	timeframeStartingPoint: StobTimeframeStartingPoint;
};

export type StobConditionOptions = {
	limit?: InputMaybe<Scalars["Int"]>;
	offset?: InputMaybe<Scalars["Int"]>;
	/** Specify one or more StobConditionSort objects to sort StobConditions by. The sorts will be applied in the order in which they are arranged in the array. */
	sort?: InputMaybe<Array<InputMaybe<StobConditionSort>>>;
};

export type StobConditionScenarioAggregateInput = {
	AND?: InputMaybe<Array<StobConditionScenarioAggregateInput>>;
	OR?: InputMaybe<Array<StobConditionScenarioAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<StobConditionScenarioNodeAggregationWhereInput>;
};

export type StobConditionScenarioConnectFieldInput = {
	connect?: InputMaybe<StobScenarioConnectInput>;
	where?: InputMaybe<StobScenarioConnectWhere>;
};

export type StobConditionScenarioConnection = {
	__typename?: "StobConditionScenarioConnection";
	edges: Array<StobConditionScenarioRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type StobConditionScenarioConnectionSort = {
	node?: InputMaybe<StobScenarioSort>;
};

export type StobConditionScenarioConnectionWhere = {
	AND?: InputMaybe<Array<StobConditionScenarioConnectionWhere>>;
	OR?: InputMaybe<Array<StobConditionScenarioConnectionWhere>>;
	node?: InputMaybe<StobScenarioWhere>;
	node_NOT?: InputMaybe<StobScenarioWhere>;
};

export type StobConditionScenarioCreateFieldInput = {
	node: StobScenarioCreateInput;
};

export type StobConditionScenarioDeleteFieldInput = {
	delete?: InputMaybe<StobScenarioDeleteInput>;
	where?: InputMaybe<StobConditionScenarioConnectionWhere>;
};

export type StobConditionScenarioDisconnectFieldInput = {
	disconnect?: InputMaybe<StobScenarioDisconnectInput>;
	where?: InputMaybe<StobConditionScenarioConnectionWhere>;
};

export type StobConditionScenarioFieldInput = {
	connect?: InputMaybe<StobConditionScenarioConnectFieldInput>;
	create?: InputMaybe<StobConditionScenarioCreateFieldInput>;
};

export type StobConditionScenarioNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<StobConditionScenarioNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<StobConditionScenarioNodeAggregationWhereInput>>;
	order_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	order_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	order_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	order_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	order_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	order_EQUAL?: InputMaybe<Scalars["Int"]>;
	order_GT?: InputMaybe<Scalars["Int"]>;
	order_GTE?: InputMaybe<Scalars["Int"]>;
	order_LT?: InputMaybe<Scalars["Int"]>;
	order_LTE?: InputMaybe<Scalars["Int"]>;
	order_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	order_MAX_GT?: InputMaybe<Scalars["Int"]>;
	order_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	order_MAX_LT?: InputMaybe<Scalars["Int"]>;
	order_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	order_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	order_MIN_GT?: InputMaybe<Scalars["Int"]>;
	order_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	order_MIN_LT?: InputMaybe<Scalars["Int"]>;
	order_MIN_LTE?: InputMaybe<Scalars["Int"]>;
};

export type StobConditionScenarioRelationship = {
	__typename?: "StobConditionScenarioRelationship";
	cursor: Scalars["String"];
	node: StobScenario;
};

export type StobConditionScenarioUpdateConnectionInput = {
	node?: InputMaybe<StobScenarioUpdateInput>;
};

export type StobConditionScenarioUpdateFieldInput = {
	connect?: InputMaybe<StobConditionScenarioConnectFieldInput>;
	create?: InputMaybe<StobConditionScenarioCreateFieldInput>;
	delete?: InputMaybe<StobConditionScenarioDeleteFieldInput>;
	disconnect?: InputMaybe<StobConditionScenarioDisconnectFieldInput>;
	update?: InputMaybe<StobConditionScenarioUpdateConnectionInput>;
	where?: InputMaybe<StobConditionScenarioConnectionWhere>;
};

/** Fields to sort StobConditions by. The order in which sorts are applied is not guaranteed when specifying many fields in one StobConditionSort object. */
export type StobConditionSort = {
	conditionType?: InputMaybe<SortDirection>;
	isNegative?: InputMaybe<SortDirection>;
	logicalCondition?: InputMaybe<SortDirection>;
	order?: InputMaybe<SortDirection>;
	responseType?: InputMaybe<SortDirection>;
	timeframeEnd?: InputMaybe<SortDirection>;
	timeframeRelation?: InputMaybe<SortDirection>;
	timeframeStart?: InputMaybe<SortDirection>;
	timeframeStartingPoint?: InputMaybe<SortDirection>;
};

export type StobConditionUpdateInput = {
	conditionType?: InputMaybe<StobMeasureType>;
	isNegative?: InputMaybe<Scalars["Boolean"]>;
	logicalCondition?: InputMaybe<LogicalCondition>;
	order?: InputMaybe<Scalars["Int"]>;
	responseType?: InputMaybe<IrResultOptions>;
	scenario?: InputMaybe<StobConditionScenarioUpdateFieldInput>;
	timeframeEnd?: InputMaybe<Scalars["Int"]>;
	timeframeRelation?: InputMaybe<StobTimeframeRelation>;
	timeframeStart?: InputMaybe<Scalars["Int"]>;
	timeframeStartingPoint?: InputMaybe<StobTimeframeStartingPoint>;
};

export type StobConditionWhere = {
	AND?: InputMaybe<Array<StobConditionWhere>>;
	OR?: InputMaybe<Array<StobConditionWhere>>;
	conditionType?: InputMaybe<StobMeasureType>;
	conditionType_IN?: InputMaybe<Array<InputMaybe<StobMeasureType>>>;
	conditionType_NOT?: InputMaybe<StobMeasureType>;
	conditionType_NOT_IN?: InputMaybe<Array<InputMaybe<StobMeasureType>>>;
	isNegative?: InputMaybe<Scalars["Boolean"]>;
	isNegative_NOT?: InputMaybe<Scalars["Boolean"]>;
	logicalCondition?: InputMaybe<LogicalCondition>;
	logicalCondition_IN?: InputMaybe<Array<InputMaybe<LogicalCondition>>>;
	logicalCondition_NOT?: InputMaybe<LogicalCondition>;
	logicalCondition_NOT_IN?: InputMaybe<Array<InputMaybe<LogicalCondition>>>;
	order?: InputMaybe<Scalars["Int"]>;
	order_GT?: InputMaybe<Scalars["Int"]>;
	order_GTE?: InputMaybe<Scalars["Int"]>;
	order_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	order_LT?: InputMaybe<Scalars["Int"]>;
	order_LTE?: InputMaybe<Scalars["Int"]>;
	order_NOT?: InputMaybe<Scalars["Int"]>;
	order_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	responseType?: InputMaybe<IrResultOptions>;
	responseType_IN?: InputMaybe<Array<InputMaybe<IrResultOptions>>>;
	responseType_NOT?: InputMaybe<IrResultOptions>;
	responseType_NOT_IN?: InputMaybe<Array<InputMaybe<IrResultOptions>>>;
	scenario?: InputMaybe<StobScenarioWhere>;
	scenarioAggregate?: InputMaybe<StobConditionScenarioAggregateInput>;
	scenarioConnection?: InputMaybe<StobConditionScenarioConnectionWhere>;
	scenarioConnection_NOT?: InputMaybe<StobConditionScenarioConnectionWhere>;
	scenario_NOT?: InputMaybe<StobScenarioWhere>;
	timeframeEnd?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_GT?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_GTE?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	timeframeEnd_LT?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_LTE?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_NOT?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	timeframeRelation?: InputMaybe<StobTimeframeRelation>;
	timeframeRelation_IN?: InputMaybe<Array<InputMaybe<StobTimeframeRelation>>>;
	timeframeRelation_NOT?: InputMaybe<StobTimeframeRelation>;
	timeframeRelation_NOT_IN?: InputMaybe<Array<InputMaybe<StobTimeframeRelation>>>;
	timeframeStart?: InputMaybe<Scalars["Int"]>;
	timeframeStart_GT?: InputMaybe<Scalars["Int"]>;
	timeframeStart_GTE?: InputMaybe<Scalars["Int"]>;
	timeframeStart_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	timeframeStart_LT?: InputMaybe<Scalars["Int"]>;
	timeframeStart_LTE?: InputMaybe<Scalars["Int"]>;
	timeframeStart_NOT?: InputMaybe<Scalars["Int"]>;
	timeframeStart_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	timeframeStartingPoint?: InputMaybe<StobTimeframeStartingPoint>;
	timeframeStartingPoint_IN?: InputMaybe<Array<InputMaybe<StobTimeframeStartingPoint>>>;
	timeframeStartingPoint_NOT?: InputMaybe<StobTimeframeStartingPoint>;
	timeframeStartingPoint_NOT_IN?: InputMaybe<Array<InputMaybe<StobTimeframeStartingPoint>>>;
};

export type StobContract = {
	__typename?: "StobContract";
	adverseEvents?: Maybe<Array<IrAdverseEvents>>;
	adverseEventsMeasureName?: Maybe<Scalars["String"]>;
	buyerContractNumber?: Maybe<Scalars["String"]>;
	cases: Array<Case>;
	casesConnection: StobContractCasesConnection;
	creatorOrganization: Organization;
	creatorOrganizationConnection: StobContractCreatorOrganizationConnection;
	currency?: Maybe<Currency>;
	currencyConnection: StobContractCurrencyConnection;
	customerNumber?: Maybe<Scalars["String"]>;
	description?: Maybe<Scalars["String"]>;
	detailsUrl?: Maybe<Scalars["String"]>;
	disease?: Maybe<Disease>;
	diseaseConnection: StobContractDiseaseConnection;
	documentationGapDays?: Maybe<Scalars["Int"]>;
	firstExecutionDate?: Maybe<Scalars["DateTime"]>;
	formattedAmount?: Maybe<Scalars["String"]>;
	formattedCounterparties?: Maybe<Scalars["String"]>;
	formattedProducts?: Maybe<Scalars["String"]>;
	formattedTags: Scalars["String"];
	formattedValidityPeriod?: Maybe<Scalars["String"]>;
	grades?: Maybe<Array<IrAdverseEventGrades>>;
	id: Scalars["ID"];
	indication?: Maybe<Indication>;
	indicationConnection: StobContractIndicationConnection;
	initialVersionId: Scalars["String"];
	lastExecutionDate?: Maybe<Scalars["DateTime"]>;
	maxPatientNumber?: Maybe<Scalars["Int"]>;
	maxTargetValue?: Maybe<Scalars["Float"]>;
	name: Scalars["String"];
	notifications?: Maybe<Array<Maybe<ContractNotification>>>;
	notificationsConnection: StobContractNotificationsConnection;
	partner?: Maybe<Organization>;
	partnerConnection: StobContractPartnerConnection;
	recommendedForms?: Maybe<Array<RecommendedForm>>;
	recommendedFormsConnection: StobContractRecommendedFormsConnection;
	requiredForms?: Maybe<Array<FormType>>;
	responseEvaluationMeasureName?: Maybe<Scalars["String"]>;
	responseTypes?: Maybe<Array<IrResultOptions>>;
	scenarios: Array<StobScenario>;
	scenariosConnection: StobContractScenariosConnection;
	statistics?: Maybe<StobStatistics>;
	statisticsConnection: StobContractStatisticsConnection;
	status?: Maybe<ContractStatus>;
	tags: Array<AgreementTag>;
	tagsConnection: StobContractTagsConnection;
	tenantIds?: Maybe<Array<Scalars["String"]>>;
	therapyDecisions?: Maybe<Array<StobTherapyDecision>>;
	treatmentBasePrice?: Maybe<Scalars["Float"]>;
	treatmentPrices: Array<Treatment>;
	treatmentPricesConnection: StobContractTreatmentPricesConnection;
	validFromDate: Scalars["Date"];
	validToDate: Scalars["Date"];
	vendorContractNumber?: Maybe<Scalars["String"]>;
	vendorNumber?: Maybe<Scalars["String"]>;
};

export type StobContractCasesArgs = {
	options?: InputMaybe<CaseOptions>;
	where?: InputMaybe<CaseWhere>;
};

export type StobContractCasesConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<StobContractCasesConnectionSort>>;
	where?: InputMaybe<StobContractCasesConnectionWhere>;
};

export type StobContractCreatorOrganizationArgs = {
	options?: InputMaybe<OrganizationOptions>;
	where?: InputMaybe<OrganizationWhere>;
};

export type StobContractCreatorOrganizationConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<StobContractCreatorOrganizationConnectionSort>>;
	where?: InputMaybe<StobContractCreatorOrganizationConnectionWhere>;
};

export type StobContractCurrencyArgs = {
	options?: InputMaybe<CurrencyOptions>;
	where?: InputMaybe<CurrencyWhere>;
};

export type StobContractCurrencyConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<StobContractCurrencyConnectionSort>>;
	where?: InputMaybe<StobContractCurrencyConnectionWhere>;
};

export type StobContractDiseaseArgs = {
	options?: InputMaybe<DiseaseOptions>;
	where?: InputMaybe<DiseaseWhere>;
};

export type StobContractDiseaseConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<StobContractDiseaseConnectionSort>>;
	where?: InputMaybe<StobContractDiseaseConnectionWhere>;
};

export type StobContractIndicationArgs = {
	options?: InputMaybe<IndicationOptions>;
	where?: InputMaybe<IndicationWhere>;
};

export type StobContractIndicationConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<StobContractIndicationConnectionSort>>;
	where?: InputMaybe<StobContractIndicationConnectionWhere>;
};

export type StobContractNotificationsArgs = {
	options?: InputMaybe<ContractNotificationOptions>;
	where?: InputMaybe<ContractNotificationWhere>;
};

export type StobContractNotificationsConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<StobContractNotificationsConnectionSort>>;
	where?: InputMaybe<StobContractNotificationsConnectionWhere>;
};

export type StobContractPartnerArgs = {
	options?: InputMaybe<OrganizationOptions>;
	where?: InputMaybe<OrganizationWhere>;
};

export type StobContractPartnerConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<StobContractPartnerConnectionSort>>;
	where?: InputMaybe<StobContractPartnerConnectionWhere>;
};

export type StobContractRecommendedFormsArgs = {
	options?: InputMaybe<RecommendedFormOptions>;
	where?: InputMaybe<RecommendedFormWhere>;
};

export type StobContractRecommendedFormsConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<StobContractRecommendedFormsConnectionSort>>;
	where?: InputMaybe<StobContractRecommendedFormsConnectionWhere>;
};

export type StobContractScenariosArgs = {
	options?: InputMaybe<StobScenarioOptions>;
	where?: InputMaybe<StobScenarioWhere>;
};

export type StobContractScenariosConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<StobContractScenariosConnectionSort>>;
	where?: InputMaybe<StobContractScenariosConnectionWhere>;
};

export type StobContractStatisticsArgs = {
	options?: InputMaybe<StobStatisticsOptions>;
	where?: InputMaybe<StobStatisticsWhere>;
};

export type StobContractStatisticsConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<StobContractStatisticsConnectionSort>>;
	where?: InputMaybe<StobContractStatisticsConnectionWhere>;
};

export type StobContractTagsArgs = {
	options?: InputMaybe<AgreementTagOptions>;
	where?: InputMaybe<AgreementTagWhere>;
};

export type StobContractTagsConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<StobContractTagsConnectionSort>>;
	where?: InputMaybe<StobContractTagsConnectionWhere>;
};

export type StobContractTreatmentPricesArgs = {
	options?: InputMaybe<TreatmentOptions>;
	where?: InputMaybe<TreatmentWhere>;
};

export type StobContractTreatmentPricesConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<StobContractTreatmentPricesConnectionSort>>;
	where?: InputMaybe<StobContractTreatmentPricesConnectionWhere>;
};

export type StobContractAggregateSelection = {
	__typename?: "StobContractAggregateSelection";
	adverseEventsMeasureName: StringAggregateSelection;
	buyerContractNumber: StringAggregateSelection;
	count: Scalars["Int"];
	customerNumber: StringAggregateSelection;
	description: StringAggregateSelection;
	detailsUrl: StringAggregateSelection;
	documentationGapDays: IntAggregateSelection;
	firstExecutionDate: DateTimeAggregateSelection;
	formattedAmount: StringAggregateSelection;
	formattedCounterparties: StringAggregateSelection;
	formattedProducts: StringAggregateSelection;
	formattedTags: StringAggregateSelection;
	formattedValidityPeriod: StringAggregateSelection;
	id: IdAggregateSelection;
	initialVersionId: StringAggregateSelection;
	lastExecutionDate: DateTimeAggregateSelection;
	maxPatientNumber: IntAggregateSelection;
	maxTargetValue: FloatAggregateSelection;
	name: StringAggregateSelection;
	responseEvaluationMeasureName: StringAggregateSelection;
	treatmentBasePrice: FloatAggregateSelection;
	vendorContractNumber: StringAggregateSelection;
	vendorNumber: StringAggregateSelection;
};

export type StobContractBasicInfoInput = {
	buyerContractNumber?: InputMaybe<Scalars["String"]>;
	creatorOrganization: OrganizationInput;
	currency: CurrencyInput;
	customerNumber?: InputMaybe<Scalars["String"]>;
	description: Scalars["String"];
	id: Scalars["ID"];
	initialVersionId: Scalars["String"];
	maxPatientNumber?: InputMaybe<Scalars["Int"]>;
	maxTargetValue?: InputMaybe<Scalars["Float"]>;
	name: Scalars["String"];
	partner?: InputMaybe<OrganizationInput>;
	validFromDate: Scalars["String"];
	validToDate: Scalars["String"];
	vendorContractNumber?: InputMaybe<Scalars["String"]>;
	vendorNumber?: InputMaybe<Scalars["String"]>;
};

export type StobContractCasesAggregateInput = {
	AND?: InputMaybe<Array<StobContractCasesAggregateInput>>;
	OR?: InputMaybe<Array<StobContractCasesAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<StobContractCasesNodeAggregationWhereInput>;
};

export type StobContractCasesConnectFieldInput = {
	connect?: InputMaybe<Array<CaseConnectInput>>;
	where?: InputMaybe<CaseConnectWhere>;
};

export type StobContractCasesConnection = {
	__typename?: "StobContractCasesConnection";
	edges: Array<StobContractCasesRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type StobContractCasesConnectionSort = {
	node?: InputMaybe<CaseSort>;
};

export type StobContractCasesConnectionWhere = {
	AND?: InputMaybe<Array<StobContractCasesConnectionWhere>>;
	OR?: InputMaybe<Array<StobContractCasesConnectionWhere>>;
	node?: InputMaybe<CaseWhere>;
	node_NOT?: InputMaybe<CaseWhere>;
};

export type StobContractCasesCreateFieldInput = {
	node: CaseCreateInput;
};

export type StobContractCasesDeleteFieldInput = {
	delete?: InputMaybe<CaseDeleteInput>;
	where?: InputMaybe<StobContractCasesConnectionWhere>;
};

export type StobContractCasesDisconnectFieldInput = {
	disconnect?: InputMaybe<CaseDisconnectInput>;
	where?: InputMaybe<StobContractCasesConnectionWhere>;
};

export type StobContractCasesFieldInput = {
	connect?: InputMaybe<Array<StobContractCasesConnectFieldInput>>;
	create?: InputMaybe<Array<StobContractCasesCreateFieldInput>>;
};

export type StobContractCasesNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<StobContractCasesNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<StobContractCasesNodeAggregationWhereInput>>;
	actualAgreementId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	actualAgreementId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	actualAgreementId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	actualAgreementId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	actualAgreementId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	actualAgreementId_EQUAL?: InputMaybe<Scalars["String"]>;
	actualAgreementId_GT?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_GTE?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_LT?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_LTE?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	agreementName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	agreementName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	agreementName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	agreementName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	agreementName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	agreementName_EQUAL?: InputMaybe<Scalars["String"]>;
	agreementName_GT?: InputMaybe<Scalars["Int"]>;
	agreementName_GTE?: InputMaybe<Scalars["Int"]>;
	agreementName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	agreementName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	agreementName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	agreementName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	agreementName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	agreementName_LT?: InputMaybe<Scalars["Int"]>;
	agreementName_LTE?: InputMaybe<Scalars["Int"]>;
	agreementName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	agreementName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	agreementName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	agreementName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	agreementName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	patientInitials_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	patientInitials_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	patientInitials_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	patientInitials_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	patientInitials_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	patientInitials_EQUAL?: InputMaybe<Scalars["String"]>;
	patientInitials_GT?: InputMaybe<Scalars["Int"]>;
	patientInitials_GTE?: InputMaybe<Scalars["Int"]>;
	patientInitials_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	patientInitials_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	patientInitials_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	patientInitials_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	patientInitials_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	patientInitials_LT?: InputMaybe<Scalars["Int"]>;
	patientInitials_LTE?: InputMaybe<Scalars["Int"]>;
	patientInitials_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	patientInitials_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	patientInitials_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	patientInitials_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	patientInitials_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	patientInsuranceId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	patientInsuranceId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	patientInsuranceId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	patientInsuranceId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	patientInsuranceId_EQUAL?: InputMaybe<Scalars["String"]>;
	patientInsuranceId_GT?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_GTE?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_LT?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_LTE?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationBandName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	preparationBandName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	preparationBandName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	preparationBandName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	preparationBandName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	preparationBandName_EQUAL?: InputMaybe<Scalars["String"]>;
	preparationBandName_GT?: InputMaybe<Scalars["Int"]>;
	preparationBandName_GTE?: InputMaybe<Scalars["Int"]>;
	preparationBandName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationBandName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationBandName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationBandName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationBandName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationBandName_LT?: InputMaybe<Scalars["Int"]>;
	preparationBandName_LTE?: InputMaybe<Scalars["Int"]>;
	preparationBandName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationBandName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationBandName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationBandName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationBandName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	preparationGenericName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	preparationGenericName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	preparationGenericName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	preparationGenericName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	preparationGenericName_EQUAL?: InputMaybe<Scalars["String"]>;
	preparationGenericName_GT?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_GTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_LT?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_LTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	sourceTenantId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	sourceTenantId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	sourceTenantId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	sourceTenantId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	sourceTenantId_EQUAL?: InputMaybe<Scalars["String"]>;
	sourceTenantId_GT?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_GTE?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_LT?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_LTE?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	submissionDate_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_GT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_GTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_LT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_LTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	totalAmount_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	totalAmount_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	totalAmount_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	totalAmount_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	totalAmount_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	totalAmount_EQUAL?: InputMaybe<Scalars["Float"]>;
	totalAmount_GT?: InputMaybe<Scalars["Float"]>;
	totalAmount_GTE?: InputMaybe<Scalars["Float"]>;
	totalAmount_LT?: InputMaybe<Scalars["Float"]>;
	totalAmount_LTE?: InputMaybe<Scalars["Float"]>;
	totalAmount_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	totalAmount_MAX_GT?: InputMaybe<Scalars["Float"]>;
	totalAmount_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	totalAmount_MAX_LT?: InputMaybe<Scalars["Float"]>;
	totalAmount_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	totalAmount_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	totalAmount_MIN_GT?: InputMaybe<Scalars["Float"]>;
	totalAmount_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	totalAmount_MIN_LT?: InputMaybe<Scalars["Float"]>;
	totalAmount_MIN_LTE?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	unlimited_EQUAL?: InputMaybe<Scalars["Int"]>;
	unlimited_GT?: InputMaybe<Scalars["Int"]>;
	unlimited_GTE?: InputMaybe<Scalars["Int"]>;
	unlimited_LT?: InputMaybe<Scalars["Int"]>;
	unlimited_LTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_GT?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_LT?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_GT?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_LT?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_LTE?: InputMaybe<Scalars["Int"]>;
};

export type StobContractCasesRelationship = {
	__typename?: "StobContractCasesRelationship";
	cursor: Scalars["String"];
	node: Case;
};

export type StobContractCasesUpdateConnectionInput = {
	node?: InputMaybe<CaseUpdateInput>;
};

export type StobContractCasesUpdateFieldInput = {
	connect?: InputMaybe<Array<StobContractCasesConnectFieldInput>>;
	create?: InputMaybe<Array<StobContractCasesCreateFieldInput>>;
	delete?: InputMaybe<Array<StobContractCasesDeleteFieldInput>>;
	disconnect?: InputMaybe<Array<StobContractCasesDisconnectFieldInput>>;
	update?: InputMaybe<StobContractCasesUpdateConnectionInput>;
	where?: InputMaybe<StobContractCasesConnectionWhere>;
};

export type StobContractConnectInput = {
	cases?: InputMaybe<Array<StobContractCasesConnectFieldInput>>;
	creatorOrganization?: InputMaybe<StobContractCreatorOrganizationConnectFieldInput>;
	currency?: InputMaybe<StobContractCurrencyConnectFieldInput>;
	disease?: InputMaybe<StobContractDiseaseConnectFieldInput>;
	indication?: InputMaybe<StobContractIndicationConnectFieldInput>;
	notifications?: InputMaybe<Array<StobContractNotificationsConnectFieldInput>>;
	partner?: InputMaybe<StobContractPartnerConnectFieldInput>;
	recommendedForms?: InputMaybe<Array<StobContractRecommendedFormsConnectFieldInput>>;
	scenarios?: InputMaybe<Array<StobContractScenariosConnectFieldInput>>;
	statistics?: InputMaybe<StobContractStatisticsConnectFieldInput>;
	tags?: InputMaybe<Array<StobContractTagsConnectFieldInput>>;
	treatmentPrices?: InputMaybe<Array<StobContractTreatmentPricesConnectFieldInput>>;
};

export type StobContractConnectWhere = {
	node: StobContractWhere;
};

export type StobContractCreateInput = {
	adverseEvents?: InputMaybe<Array<IrAdverseEvents>>;
	adverseEventsMeasureName?: InputMaybe<Scalars["String"]>;
	buyerContractNumber?: InputMaybe<Scalars["String"]>;
	cases?: InputMaybe<StobContractCasesFieldInput>;
	creatorOrganization?: InputMaybe<StobContractCreatorOrganizationFieldInput>;
	currency?: InputMaybe<StobContractCurrencyFieldInput>;
	customerNumber?: InputMaybe<Scalars["String"]>;
	description?: InputMaybe<Scalars["String"]>;
	detailsUrl?: InputMaybe<Scalars["String"]>;
	disease?: InputMaybe<StobContractDiseaseFieldInput>;
	documentationGapDays?: InputMaybe<Scalars["Int"]>;
	firstExecutionDate?: InputMaybe<Scalars["DateTime"]>;
	formattedAmount?: InputMaybe<Scalars["String"]>;
	formattedCounterparties?: InputMaybe<Scalars["String"]>;
	formattedProducts?: InputMaybe<Scalars["String"]>;
	formattedTags: Scalars["String"];
	formattedValidityPeriod?: InputMaybe<Scalars["String"]>;
	grades?: InputMaybe<Array<IrAdverseEventGrades>>;
	id: Scalars["ID"];
	indication?: InputMaybe<StobContractIndicationFieldInput>;
	initialVersionId: Scalars["String"];
	lastExecutionDate?: InputMaybe<Scalars["DateTime"]>;
	maxPatientNumber?: InputMaybe<Scalars["Int"]>;
	maxTargetValue?: InputMaybe<Scalars["Float"]>;
	name: Scalars["String"];
	notifications?: InputMaybe<StobContractNotificationsFieldInput>;
	partner?: InputMaybe<StobContractPartnerFieldInput>;
	recommendedForms?: InputMaybe<StobContractRecommendedFormsFieldInput>;
	requiredForms?: InputMaybe<Array<FormType>>;
	responseEvaluationMeasureName?: InputMaybe<Scalars["String"]>;
	responseTypes?: InputMaybe<Array<IrResultOptions>>;
	scenarios?: InputMaybe<StobContractScenariosFieldInput>;
	statistics?: InputMaybe<StobContractStatisticsFieldInput>;
	status?: InputMaybe<ContractStatus>;
	tags?: InputMaybe<StobContractTagsFieldInput>;
	tenantIds?: InputMaybe<Array<Scalars["String"]>>;
	therapyDecisions?: InputMaybe<Array<StobTherapyDecision>>;
	treatmentBasePrice?: InputMaybe<Scalars["Float"]>;
	treatmentPrices?: InputMaybe<StobContractTreatmentPricesFieldInput>;
	validFromDate: Scalars["Date"];
	validToDate: Scalars["Date"];
	vendorContractNumber?: InputMaybe<Scalars["String"]>;
	vendorNumber?: InputMaybe<Scalars["String"]>;
};

export type StobContractCreatorOrganizationAggregateInput = {
	AND?: InputMaybe<Array<StobContractCreatorOrganizationAggregateInput>>;
	OR?: InputMaybe<Array<StobContractCreatorOrganizationAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<StobContractCreatorOrganizationNodeAggregationWhereInput>;
};

export type StobContractCreatorOrganizationConnectFieldInput = {
	where?: InputMaybe<OrganizationConnectWhere>;
};

export type StobContractCreatorOrganizationConnection = {
	__typename?: "StobContractCreatorOrganizationConnection";
	edges: Array<StobContractCreatorOrganizationRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type StobContractCreatorOrganizationConnectionSort = {
	node?: InputMaybe<OrganizationSort>;
};

export type StobContractCreatorOrganizationConnectionWhere = {
	AND?: InputMaybe<Array<StobContractCreatorOrganizationConnectionWhere>>;
	OR?: InputMaybe<Array<StobContractCreatorOrganizationConnectionWhere>>;
	node?: InputMaybe<OrganizationWhere>;
	node_NOT?: InputMaybe<OrganizationWhere>;
};

export type StobContractCreatorOrganizationCreateFieldInput = {
	node: OrganizationCreateInput;
};

export type StobContractCreatorOrganizationDeleteFieldInput = {
	where?: InputMaybe<StobContractCreatorOrganizationConnectionWhere>;
};

export type StobContractCreatorOrganizationDisconnectFieldInput = {
	where?: InputMaybe<StobContractCreatorOrganizationConnectionWhere>;
};

export type StobContractCreatorOrganizationFieldInput = {
	connect?: InputMaybe<StobContractCreatorOrganizationConnectFieldInput>;
	create?: InputMaybe<StobContractCreatorOrganizationCreateFieldInput>;
};

export type StobContractCreatorOrganizationNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<StobContractCreatorOrganizationNodeAggregationWhereInput>>;
	IBAN_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	IBAN_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	IBAN_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	IBAN_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	IBAN_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	IBAN_EQUAL?: InputMaybe<Scalars["String"]>;
	IBAN_GT?: InputMaybe<Scalars["Int"]>;
	IBAN_GTE?: InputMaybe<Scalars["Int"]>;
	IBAN_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	IBAN_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	IBAN_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	IBAN_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	IBAN_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	IBAN_LT?: InputMaybe<Scalars["Int"]>;
	IBAN_LTE?: InputMaybe<Scalars["Int"]>;
	IBAN_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	IBAN_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	IBAN_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	IBAN_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	IBAN_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	OR?: InputMaybe<Array<StobContractCreatorOrganizationNodeAggregationWhereInput>>;
	billingAddress_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	billingAddress_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	billingAddress_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	billingAddress_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	billingAddress_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	billingAddress_EQUAL?: InputMaybe<Scalars["String"]>;
	billingAddress_GT?: InputMaybe<Scalars["Int"]>;
	billingAddress_GTE?: InputMaybe<Scalars["Int"]>;
	billingAddress_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	billingAddress_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	billingAddress_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	billingAddress_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	billingAddress_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	billingAddress_LT?: InputMaybe<Scalars["Int"]>;
	billingAddress_LTE?: InputMaybe<Scalars["Int"]>;
	billingAddress_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	billingAddress_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	billingAddress_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	billingAddress_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	billingAddress_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	contactEmail_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	contactEmail_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	contactEmail_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	contactEmail_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	contactEmail_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	contactEmail_EQUAL?: InputMaybe<Scalars["String"]>;
	contactEmail_GT?: InputMaybe<Scalars["Int"]>;
	contactEmail_GTE?: InputMaybe<Scalars["Int"]>;
	contactEmail_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	contactEmail_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	contactEmail_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	contactEmail_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	contactEmail_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	contactEmail_LT?: InputMaybe<Scalars["Int"]>;
	contactEmail_LTE?: InputMaybe<Scalars["Int"]>;
	contactEmail_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	contactEmail_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	contactEmail_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	contactEmail_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	contactEmail_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	contactFirstName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	contactFirstName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	contactFirstName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	contactFirstName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	contactFirstName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	contactFirstName_EQUAL?: InputMaybe<Scalars["String"]>;
	contactFirstName_GT?: InputMaybe<Scalars["Int"]>;
	contactFirstName_GTE?: InputMaybe<Scalars["Int"]>;
	contactFirstName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	contactFirstName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	contactFirstName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	contactFirstName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	contactFirstName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	contactFirstName_LT?: InputMaybe<Scalars["Int"]>;
	contactFirstName_LTE?: InputMaybe<Scalars["Int"]>;
	contactFirstName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	contactFirstName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	contactFirstName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	contactFirstName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	contactFirstName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	contactLastName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	contactLastName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	contactLastName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	contactLastName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	contactLastName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	contactLastName_EQUAL?: InputMaybe<Scalars["String"]>;
	contactLastName_GT?: InputMaybe<Scalars["Int"]>;
	contactLastName_GTE?: InputMaybe<Scalars["Int"]>;
	contactLastName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	contactLastName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	contactLastName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	contactLastName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	contactLastName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	contactLastName_LT?: InputMaybe<Scalars["Int"]>;
	contactLastName_LTE?: InputMaybe<Scalars["Int"]>;
	contactLastName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	contactLastName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	contactLastName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	contactLastName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	contactLastName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	contactOccupation_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	contactOccupation_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	contactOccupation_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	contactOccupation_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	contactOccupation_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	contactOccupation_EQUAL?: InputMaybe<Scalars["String"]>;
	contactOccupation_GT?: InputMaybe<Scalars["Int"]>;
	contactOccupation_GTE?: InputMaybe<Scalars["Int"]>;
	contactOccupation_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	contactOccupation_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	contactOccupation_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	contactOccupation_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	contactOccupation_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	contactOccupation_LT?: InputMaybe<Scalars["Int"]>;
	contactOccupation_LTE?: InputMaybe<Scalars["Int"]>;
	contactOccupation_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	contactOccupation_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	contactOccupation_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	contactOccupation_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	contactOccupation_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	contactPhone_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	contactPhone_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	contactPhone_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	contactPhone_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	contactPhone_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	contactPhone_EQUAL?: InputMaybe<Scalars["String"]>;
	contactPhone_GT?: InputMaybe<Scalars["Int"]>;
	contactPhone_GTE?: InputMaybe<Scalars["Int"]>;
	contactPhone_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	contactPhone_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	contactPhone_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	contactPhone_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	contactPhone_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	contactPhone_LT?: InputMaybe<Scalars["Int"]>;
	contactPhone_LTE?: InputMaybe<Scalars["Int"]>;
	contactPhone_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	contactPhone_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	contactPhone_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	contactPhone_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	contactPhone_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	domicile_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	domicile_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	domicile_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	domicile_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	domicile_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	domicile_EQUAL?: InputMaybe<Scalars["String"]>;
	domicile_GT?: InputMaybe<Scalars["Int"]>;
	domicile_GTE?: InputMaybe<Scalars["Int"]>;
	domicile_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	domicile_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	domicile_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	domicile_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	domicile_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	domicile_LT?: InputMaybe<Scalars["Int"]>;
	domicile_LTE?: InputMaybe<Scalars["Int"]>;
	domicile_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	domicile_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	domicile_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	domicile_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	domicile_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	eIN_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	eIN_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	eIN_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	eIN_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	eIN_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	eIN_EQUAL?: InputMaybe<Scalars["String"]>;
	eIN_GT?: InputMaybe<Scalars["Int"]>;
	eIN_GTE?: InputMaybe<Scalars["Int"]>;
	eIN_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	eIN_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	eIN_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	eIN_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	eIN_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	eIN_LT?: InputMaybe<Scalars["Int"]>;
	eIN_LTE?: InputMaybe<Scalars["Int"]>;
	eIN_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	eIN_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	eIN_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	eIN_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	eIN_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	fax_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	fax_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	fax_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	fax_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	fax_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	fax_EQUAL?: InputMaybe<Scalars["String"]>;
	fax_GT?: InputMaybe<Scalars["Int"]>;
	fax_GTE?: InputMaybe<Scalars["Int"]>;
	fax_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	fax_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	fax_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	fax_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	fax_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	fax_LT?: InputMaybe<Scalars["Int"]>;
	fax_LTE?: InputMaybe<Scalars["Int"]>;
	fax_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	fax_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	fax_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	fax_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	fax_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	legalName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	legalName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	legalName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	legalName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	legalName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	legalName_EQUAL?: InputMaybe<Scalars["String"]>;
	legalName_GT?: InputMaybe<Scalars["Int"]>;
	legalName_GTE?: InputMaybe<Scalars["Int"]>;
	legalName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	legalName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	legalName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	legalName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	legalName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	legalName_LT?: InputMaybe<Scalars["Int"]>;
	legalName_LTE?: InputMaybe<Scalars["Int"]>;
	legalName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	legalName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	legalName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	legalName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	legalName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	logo_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	logo_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	logo_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	logo_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	logo_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	logo_EQUAL?: InputMaybe<Scalars["String"]>;
	logo_GT?: InputMaybe<Scalars["Int"]>;
	logo_GTE?: InputMaybe<Scalars["Int"]>;
	logo_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	logo_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	logo_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	logo_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	logo_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	logo_LT?: InputMaybe<Scalars["Int"]>;
	logo_LTE?: InputMaybe<Scalars["Int"]>;
	logo_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	logo_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	logo_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	logo_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	logo_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	name_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	name_EQUAL?: InputMaybe<Scalars["String"]>;
	name_GT?: InputMaybe<Scalars["Int"]>;
	name_GTE?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	name_LT?: InputMaybe<Scalars["Int"]>;
	name_LTE?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	phone_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	phone_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	phone_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	phone_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	phone_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	phone_EQUAL?: InputMaybe<Scalars["String"]>;
	phone_GT?: InputMaybe<Scalars["Int"]>;
	phone_GTE?: InputMaybe<Scalars["Int"]>;
	phone_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	phone_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	phone_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	phone_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	phone_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	phone_LT?: InputMaybe<Scalars["Int"]>;
	phone_LTE?: InputMaybe<Scalars["Int"]>;
	phone_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	phone_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	phone_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	phone_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	phone_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	tenantId_EQUAL?: InputMaybe<Scalars["String"]>;
	tenantId_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	website_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	website_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	website_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	website_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	website_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	website_EQUAL?: InputMaybe<Scalars["String"]>;
	website_GT?: InputMaybe<Scalars["Int"]>;
	website_GTE?: InputMaybe<Scalars["Int"]>;
	website_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	website_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	website_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	website_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	website_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	website_LT?: InputMaybe<Scalars["Int"]>;
	website_LTE?: InputMaybe<Scalars["Int"]>;
	website_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	website_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	website_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	website_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	website_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type StobContractCreatorOrganizationRelationship = {
	__typename?: "StobContractCreatorOrganizationRelationship";
	cursor: Scalars["String"];
	node: Organization;
};

export type StobContractCreatorOrganizationUpdateConnectionInput = {
	node?: InputMaybe<OrganizationUpdateInput>;
};

export type StobContractCreatorOrganizationUpdateFieldInput = {
	connect?: InputMaybe<StobContractCreatorOrganizationConnectFieldInput>;
	create?: InputMaybe<StobContractCreatorOrganizationCreateFieldInput>;
	delete?: InputMaybe<StobContractCreatorOrganizationDeleteFieldInput>;
	disconnect?: InputMaybe<StobContractCreatorOrganizationDisconnectFieldInput>;
	update?: InputMaybe<StobContractCreatorOrganizationUpdateConnectionInput>;
	where?: InputMaybe<StobContractCreatorOrganizationConnectionWhere>;
};

export type StobContractCurrencyAggregateInput = {
	AND?: InputMaybe<Array<StobContractCurrencyAggregateInput>>;
	OR?: InputMaybe<Array<StobContractCurrencyAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<StobContractCurrencyNodeAggregationWhereInput>;
};

export type StobContractCurrencyConnectFieldInput = {
	where?: InputMaybe<CurrencyConnectWhere>;
};

export type StobContractCurrencyConnection = {
	__typename?: "StobContractCurrencyConnection";
	edges: Array<StobContractCurrencyRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type StobContractCurrencyConnectionSort = {
	node?: InputMaybe<CurrencySort>;
};

export type StobContractCurrencyConnectionWhere = {
	AND?: InputMaybe<Array<StobContractCurrencyConnectionWhere>>;
	OR?: InputMaybe<Array<StobContractCurrencyConnectionWhere>>;
	node?: InputMaybe<CurrencyWhere>;
	node_NOT?: InputMaybe<CurrencyWhere>;
};

export type StobContractCurrencyCreateFieldInput = {
	node: CurrencyCreateInput;
};

export type StobContractCurrencyDeleteFieldInput = {
	where?: InputMaybe<StobContractCurrencyConnectionWhere>;
};

export type StobContractCurrencyDisconnectFieldInput = {
	where?: InputMaybe<StobContractCurrencyConnectionWhere>;
};

export type StobContractCurrencyFieldInput = {
	connect?: InputMaybe<StobContractCurrencyConnectFieldInput>;
	create?: InputMaybe<StobContractCurrencyCreateFieldInput>;
};

export type StobContractCurrencyNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<StobContractCurrencyNodeAggregationWhereInput>>;
	Code_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	Code_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	Code_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	Code_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	Code_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	Code_EQUAL?: InputMaybe<Scalars["String"]>;
	Code_GT?: InputMaybe<Scalars["Int"]>;
	Code_GTE?: InputMaybe<Scalars["Int"]>;
	Code_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Code_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	Code_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	Code_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	Code_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	Code_LT?: InputMaybe<Scalars["Int"]>;
	Code_LTE?: InputMaybe<Scalars["Int"]>;
	Code_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Code_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	Code_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	Code_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	Code_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	Name_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	Name_EQUAL?: InputMaybe<Scalars["String"]>;
	Name_GT?: InputMaybe<Scalars["Int"]>;
	Name_GTE?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	Name_LT?: InputMaybe<Scalars["Int"]>;
	Name_LTE?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	OR?: InputMaybe<Array<StobContractCurrencyNodeAggregationWhereInput>>;
	symbol_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	symbol_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	symbol_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	symbol_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	symbol_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	symbol_EQUAL?: InputMaybe<Scalars["String"]>;
	symbol_GT?: InputMaybe<Scalars["Int"]>;
	symbol_GTE?: InputMaybe<Scalars["Int"]>;
	symbol_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	symbol_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	symbol_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	symbol_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	symbol_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	symbol_LT?: InputMaybe<Scalars["Int"]>;
	symbol_LTE?: InputMaybe<Scalars["Int"]>;
	symbol_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	symbol_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	symbol_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	symbol_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	symbol_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type StobContractCurrencyRelationship = {
	__typename?: "StobContractCurrencyRelationship";
	cursor: Scalars["String"];
	node: Currency;
};

export type StobContractCurrencyUpdateConnectionInput = {
	node?: InputMaybe<CurrencyUpdateInput>;
};

export type StobContractCurrencyUpdateFieldInput = {
	connect?: InputMaybe<StobContractCurrencyConnectFieldInput>;
	create?: InputMaybe<StobContractCurrencyCreateFieldInput>;
	delete?: InputMaybe<StobContractCurrencyDeleteFieldInput>;
	disconnect?: InputMaybe<StobContractCurrencyDisconnectFieldInput>;
	update?: InputMaybe<StobContractCurrencyUpdateConnectionInput>;
	where?: InputMaybe<StobContractCurrencyConnectionWhere>;
};

export type StobContractDeleteInput = {
	cases?: InputMaybe<Array<StobContractCasesDeleteFieldInput>>;
	creatorOrganization?: InputMaybe<StobContractCreatorOrganizationDeleteFieldInput>;
	currency?: InputMaybe<StobContractCurrencyDeleteFieldInput>;
	disease?: InputMaybe<StobContractDiseaseDeleteFieldInput>;
	indication?: InputMaybe<StobContractIndicationDeleteFieldInput>;
	notifications?: InputMaybe<Array<StobContractNotificationsDeleteFieldInput>>;
	partner?: InputMaybe<StobContractPartnerDeleteFieldInput>;
	recommendedForms?: InputMaybe<Array<StobContractRecommendedFormsDeleteFieldInput>>;
	scenarios?: InputMaybe<Array<StobContractScenariosDeleteFieldInput>>;
	statistics?: InputMaybe<StobContractStatisticsDeleteFieldInput>;
	tags?: InputMaybe<Array<StobContractTagsDeleteFieldInput>>;
	treatmentPrices?: InputMaybe<Array<StobContractTreatmentPricesDeleteFieldInput>>;
};

export type StobContractDisconnectInput = {
	cases?: InputMaybe<Array<StobContractCasesDisconnectFieldInput>>;
	creatorOrganization?: InputMaybe<StobContractCreatorOrganizationDisconnectFieldInput>;
	currency?: InputMaybe<StobContractCurrencyDisconnectFieldInput>;
	disease?: InputMaybe<StobContractDiseaseDisconnectFieldInput>;
	indication?: InputMaybe<StobContractIndicationDisconnectFieldInput>;
	notifications?: InputMaybe<Array<StobContractNotificationsDisconnectFieldInput>>;
	partner?: InputMaybe<StobContractPartnerDisconnectFieldInput>;
	recommendedForms?: InputMaybe<Array<StobContractRecommendedFormsDisconnectFieldInput>>;
	scenarios?: InputMaybe<Array<StobContractScenariosDisconnectFieldInput>>;
	statistics?: InputMaybe<StobContractStatisticsDisconnectFieldInput>;
	tags?: InputMaybe<Array<StobContractTagsDisconnectFieldInput>>;
	treatmentPrices?: InputMaybe<Array<StobContractTreatmentPricesDisconnectFieldInput>>;
};

export type StobContractDiseaseAggregateInput = {
	AND?: InputMaybe<Array<StobContractDiseaseAggregateInput>>;
	OR?: InputMaybe<Array<StobContractDiseaseAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<StobContractDiseaseNodeAggregationWhereInput>;
};

export type StobContractDiseaseConnectFieldInput = {
	where?: InputMaybe<DiseaseConnectWhere>;
};

export type StobContractDiseaseConnection = {
	__typename?: "StobContractDiseaseConnection";
	edges: Array<StobContractDiseaseRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type StobContractDiseaseConnectionSort = {
	node?: InputMaybe<DiseaseSort>;
};

export type StobContractDiseaseConnectionWhere = {
	AND?: InputMaybe<Array<StobContractDiseaseConnectionWhere>>;
	OR?: InputMaybe<Array<StobContractDiseaseConnectionWhere>>;
	node?: InputMaybe<DiseaseWhere>;
	node_NOT?: InputMaybe<DiseaseWhere>;
};

export type StobContractDiseaseCreateFieldInput = {
	node: DiseaseCreateInput;
};

export type StobContractDiseaseDeleteFieldInput = {
	where?: InputMaybe<StobContractDiseaseConnectionWhere>;
};

export type StobContractDiseaseDisconnectFieldInput = {
	where?: InputMaybe<StobContractDiseaseConnectionWhere>;
};

export type StobContractDiseaseFieldInput = {
	connect?: InputMaybe<StobContractDiseaseConnectFieldInput>;
	create?: InputMaybe<StobContractDiseaseCreateFieldInput>;
};

export type StobContractDiseaseNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<StobContractDiseaseNodeAggregationWhereInput>>;
	Icd10Code_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	Icd10Code_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	Icd10Code_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	Icd10Code_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	Icd10Code_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	Icd10Code_EQUAL?: InputMaybe<Scalars["String"]>;
	Icd10Code_GT?: InputMaybe<Scalars["Int"]>;
	Icd10Code_GTE?: InputMaybe<Scalars["Int"]>;
	Icd10Code_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Icd10Code_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	Icd10Code_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	Icd10Code_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	Icd10Code_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	Icd10Code_LT?: InputMaybe<Scalars["Int"]>;
	Icd10Code_LTE?: InputMaybe<Scalars["Int"]>;
	Icd10Code_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Icd10Code_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	Icd10Code_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	Icd10Code_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	Icd10Code_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	Name_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	Name_EQUAL?: InputMaybe<Scalars["String"]>;
	Name_GT?: InputMaybe<Scalars["Int"]>;
	Name_GTE?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	Name_LT?: InputMaybe<Scalars["Int"]>;
	Name_LTE?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	OR?: InputMaybe<Array<StobContractDiseaseNodeAggregationWhereInput>>;
};

export type StobContractDiseaseRelationship = {
	__typename?: "StobContractDiseaseRelationship";
	cursor: Scalars["String"];
	node: Disease;
};

export type StobContractDiseaseUpdateConnectionInput = {
	node?: InputMaybe<DiseaseUpdateInput>;
};

export type StobContractDiseaseUpdateFieldInput = {
	connect?: InputMaybe<StobContractDiseaseConnectFieldInput>;
	create?: InputMaybe<StobContractDiseaseCreateFieldInput>;
	delete?: InputMaybe<StobContractDiseaseDeleteFieldInput>;
	disconnect?: InputMaybe<StobContractDiseaseDisconnectFieldInput>;
	update?: InputMaybe<StobContractDiseaseUpdateConnectionInput>;
	where?: InputMaybe<StobContractDiseaseConnectionWhere>;
};

export type StobContractEligibilityInput = {
	diseaseCode: Scalars["String"];
	documentationGapDays?: InputMaybe<Scalars["Int"]>;
	id: Scalars["ID"];
	indicationCode: Scalars["String"];
	requiredForms?: InputMaybe<Array<FormType>>;
	therapyDecisions?: InputMaybe<Array<StobTherapyDecision>>;
	treatmentCodes: Array<Scalars["String"]>;
};

export type StobContractIndicationAggregateInput = {
	AND?: InputMaybe<Array<StobContractIndicationAggregateInput>>;
	OR?: InputMaybe<Array<StobContractIndicationAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<StobContractIndicationNodeAggregationWhereInput>;
};

export type StobContractIndicationConnectFieldInput = {
	where?: InputMaybe<IndicationConnectWhere>;
};

export type StobContractIndicationConnection = {
	__typename?: "StobContractIndicationConnection";
	edges: Array<StobContractIndicationRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type StobContractIndicationConnectionSort = {
	node?: InputMaybe<IndicationSort>;
};

export type StobContractIndicationConnectionWhere = {
	AND?: InputMaybe<Array<StobContractIndicationConnectionWhere>>;
	OR?: InputMaybe<Array<StobContractIndicationConnectionWhere>>;
	node?: InputMaybe<IndicationWhere>;
	node_NOT?: InputMaybe<IndicationWhere>;
};

export type StobContractIndicationCreateFieldInput = {
	node: IndicationCreateInput;
};

export type StobContractIndicationDeleteFieldInput = {
	where?: InputMaybe<StobContractIndicationConnectionWhere>;
};

export type StobContractIndicationDisconnectFieldInput = {
	where?: InputMaybe<StobContractIndicationConnectionWhere>;
};

export type StobContractIndicationFieldInput = {
	connect?: InputMaybe<StobContractIndicationConnectFieldInput>;
	create?: InputMaybe<StobContractIndicationCreateFieldInput>;
};

export type StobContractIndicationNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<StobContractIndicationNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<StobContractIndicationNodeAggregationWhereInput>>;
	bagCode_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	bagCode_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	bagCode_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	bagCode_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	bagCode_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	bagCode_EQUAL?: InputMaybe<Scalars["String"]>;
	bagCode_GT?: InputMaybe<Scalars["Int"]>;
	bagCode_GTE?: InputMaybe<Scalars["Int"]>;
	bagCode_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	bagCode_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	bagCode_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	bagCode_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	bagCode_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	bagCode_LT?: InputMaybe<Scalars["Int"]>;
	bagCode_LTE?: InputMaybe<Scalars["Int"]>;
	bagCode_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	bagCode_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	bagCode_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	bagCode_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	bagCode_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	code_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	code_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	code_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	code_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	code_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	code_EQUAL?: InputMaybe<Scalars["String"]>;
	code_GT?: InputMaybe<Scalars["Int"]>;
	code_GTE?: InputMaybe<Scalars["Int"]>;
	code_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	code_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	code_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	code_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	code_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	code_LT?: InputMaybe<Scalars["Int"]>;
	code_LTE?: InputMaybe<Scalars["Int"]>;
	code_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	code_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	code_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	code_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	code_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	intent_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	intent_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	intent_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	intent_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	intent_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	intent_EQUAL?: InputMaybe<Scalars["String"]>;
	intent_GT?: InputMaybe<Scalars["Int"]>;
	intent_GTE?: InputMaybe<Scalars["Int"]>;
	intent_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	intent_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	intent_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	intent_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	intent_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	intent_LT?: InputMaybe<Scalars["Int"]>;
	intent_LTE?: InputMaybe<Scalars["Int"]>;
	intent_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	intent_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	intent_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	intent_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	intent_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	line_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	line_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	line_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	line_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	line_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	line_EQUAL?: InputMaybe<Scalars["String"]>;
	line_GT?: InputMaybe<Scalars["Int"]>;
	line_GTE?: InputMaybe<Scalars["Int"]>;
	line_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	line_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	line_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	line_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	line_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	line_LT?: InputMaybe<Scalars["Int"]>;
	line_LTE?: InputMaybe<Scalars["Int"]>;
	line_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	line_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	line_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	line_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	line_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	mutation_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	mutation_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	mutation_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	mutation_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	mutation_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	mutation_EQUAL?: InputMaybe<Scalars["String"]>;
	mutation_GT?: InputMaybe<Scalars["Int"]>;
	mutation_GTE?: InputMaybe<Scalars["Int"]>;
	mutation_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	mutation_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	mutation_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	mutation_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	mutation_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	mutation_LT?: InputMaybe<Scalars["Int"]>;
	mutation_LTE?: InputMaybe<Scalars["Int"]>;
	mutation_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	mutation_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	mutation_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	mutation_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	mutation_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	type_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	type_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	type_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	type_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	type_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	type_EQUAL?: InputMaybe<Scalars["String"]>;
	type_GT?: InputMaybe<Scalars["Int"]>;
	type_GTE?: InputMaybe<Scalars["Int"]>;
	type_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	type_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	type_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	type_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	type_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	type_LT?: InputMaybe<Scalars["Int"]>;
	type_LTE?: InputMaybe<Scalars["Int"]>;
	type_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	type_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	type_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	type_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	type_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type StobContractIndicationRelationship = {
	__typename?: "StobContractIndicationRelationship";
	cursor: Scalars["String"];
	node: Indication;
};

export type StobContractIndicationUpdateConnectionInput = {
	node?: InputMaybe<IndicationUpdateInput>;
};

export type StobContractIndicationUpdateFieldInput = {
	connect?: InputMaybe<StobContractIndicationConnectFieldInput>;
	create?: InputMaybe<StobContractIndicationCreateFieldInput>;
	delete?: InputMaybe<StobContractIndicationDeleteFieldInput>;
	disconnect?: InputMaybe<StobContractIndicationDisconnectFieldInput>;
	update?: InputMaybe<StobContractIndicationUpdateConnectionInput>;
	where?: InputMaybe<StobContractIndicationConnectionWhere>;
};

export type StobContractNotificationsAggregateInput = {
	AND?: InputMaybe<Array<StobContractNotificationsAggregateInput>>;
	OR?: InputMaybe<Array<StobContractNotificationsAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<StobContractNotificationsNodeAggregationWhereInput>;
};

export type StobContractNotificationsConnectFieldInput = {
	connect?: InputMaybe<Array<ContractNotificationConnectInput>>;
	where?: InputMaybe<ContractNotificationConnectWhere>;
};

export type StobContractNotificationsConnection = {
	__typename?: "StobContractNotificationsConnection";
	edges: Array<StobContractNotificationsRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type StobContractNotificationsConnectionSort = {
	node?: InputMaybe<ContractNotificationSort>;
};

export type StobContractNotificationsConnectionWhere = {
	AND?: InputMaybe<Array<StobContractNotificationsConnectionWhere>>;
	OR?: InputMaybe<Array<StobContractNotificationsConnectionWhere>>;
	node?: InputMaybe<ContractNotificationWhere>;
	node_NOT?: InputMaybe<ContractNotificationWhere>;
};

export type StobContractNotificationsCreateFieldInput = {
	node: ContractNotificationCreateInput;
};

export type StobContractNotificationsDeleteFieldInput = {
	delete?: InputMaybe<ContractNotificationDeleteInput>;
	where?: InputMaybe<StobContractNotificationsConnectionWhere>;
};

export type StobContractNotificationsDisconnectFieldInput = {
	disconnect?: InputMaybe<ContractNotificationDisconnectInput>;
	where?: InputMaybe<StobContractNotificationsConnectionWhere>;
};

export type StobContractNotificationsFieldInput = {
	connect?: InputMaybe<Array<StobContractNotificationsConnectFieldInput>>;
	create?: InputMaybe<Array<StobContractNotificationsCreateFieldInput>>;
};

export type StobContractNotificationsNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<StobContractNotificationsNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<StobContractNotificationsNodeAggregationWhereInput>>;
	order_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	order_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	order_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	order_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	order_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	order_EQUAL?: InputMaybe<Scalars["Int"]>;
	order_GT?: InputMaybe<Scalars["Int"]>;
	order_GTE?: InputMaybe<Scalars["Int"]>;
	order_LT?: InputMaybe<Scalars["Int"]>;
	order_LTE?: InputMaybe<Scalars["Int"]>;
	order_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	order_MAX_GT?: InputMaybe<Scalars["Int"]>;
	order_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	order_MAX_LT?: InputMaybe<Scalars["Int"]>;
	order_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	order_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	order_MIN_GT?: InputMaybe<Scalars["Int"]>;
	order_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	order_MIN_LT?: InputMaybe<Scalars["Int"]>;
	order_MIN_LTE?: InputMaybe<Scalars["Int"]>;
};

export type StobContractNotificationsRelationship = {
	__typename?: "StobContractNotificationsRelationship";
	cursor: Scalars["String"];
	node: ContractNotification;
};

export type StobContractNotificationsUpdateConnectionInput = {
	node?: InputMaybe<ContractNotificationUpdateInput>;
};

export type StobContractNotificationsUpdateFieldInput = {
	connect?: InputMaybe<Array<StobContractNotificationsConnectFieldInput>>;
	create?: InputMaybe<Array<StobContractNotificationsCreateFieldInput>>;
	delete?: InputMaybe<Array<StobContractNotificationsDeleteFieldInput>>;
	disconnect?: InputMaybe<Array<StobContractNotificationsDisconnectFieldInput>>;
	update?: InputMaybe<StobContractNotificationsUpdateConnectionInput>;
	where?: InputMaybe<StobContractNotificationsConnectionWhere>;
};

export type StobContractOptions = {
	limit?: InputMaybe<Scalars["Int"]>;
	offset?: InputMaybe<Scalars["Int"]>;
	/** Specify one or more StobContractSort objects to sort StobContracts by. The sorts will be applied in the order in which they are arranged in the array. */
	sort?: InputMaybe<Array<InputMaybe<StobContractSort>>>;
};

export type StobContractPartnerAggregateInput = {
	AND?: InputMaybe<Array<StobContractPartnerAggregateInput>>;
	OR?: InputMaybe<Array<StobContractPartnerAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<StobContractPartnerNodeAggregationWhereInput>;
};

export type StobContractPartnerConnectFieldInput = {
	where?: InputMaybe<OrganizationConnectWhere>;
};

export type StobContractPartnerConnection = {
	__typename?: "StobContractPartnerConnection";
	edges: Array<StobContractPartnerRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type StobContractPartnerConnectionSort = {
	node?: InputMaybe<OrganizationSort>;
};

export type StobContractPartnerConnectionWhere = {
	AND?: InputMaybe<Array<StobContractPartnerConnectionWhere>>;
	OR?: InputMaybe<Array<StobContractPartnerConnectionWhere>>;
	node?: InputMaybe<OrganizationWhere>;
	node_NOT?: InputMaybe<OrganizationWhere>;
};

export type StobContractPartnerCreateFieldInput = {
	node: OrganizationCreateInput;
};

export type StobContractPartnerDeleteFieldInput = {
	where?: InputMaybe<StobContractPartnerConnectionWhere>;
};

export type StobContractPartnerDisconnectFieldInput = {
	where?: InputMaybe<StobContractPartnerConnectionWhere>;
};

export type StobContractPartnerFieldInput = {
	connect?: InputMaybe<StobContractPartnerConnectFieldInput>;
	create?: InputMaybe<StobContractPartnerCreateFieldInput>;
};

export type StobContractPartnerNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<StobContractPartnerNodeAggregationWhereInput>>;
	IBAN_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	IBAN_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	IBAN_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	IBAN_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	IBAN_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	IBAN_EQUAL?: InputMaybe<Scalars["String"]>;
	IBAN_GT?: InputMaybe<Scalars["Int"]>;
	IBAN_GTE?: InputMaybe<Scalars["Int"]>;
	IBAN_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	IBAN_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	IBAN_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	IBAN_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	IBAN_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	IBAN_LT?: InputMaybe<Scalars["Int"]>;
	IBAN_LTE?: InputMaybe<Scalars["Int"]>;
	IBAN_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	IBAN_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	IBAN_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	IBAN_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	IBAN_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	OR?: InputMaybe<Array<StobContractPartnerNodeAggregationWhereInput>>;
	billingAddress_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	billingAddress_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	billingAddress_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	billingAddress_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	billingAddress_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	billingAddress_EQUAL?: InputMaybe<Scalars["String"]>;
	billingAddress_GT?: InputMaybe<Scalars["Int"]>;
	billingAddress_GTE?: InputMaybe<Scalars["Int"]>;
	billingAddress_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	billingAddress_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	billingAddress_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	billingAddress_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	billingAddress_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	billingAddress_LT?: InputMaybe<Scalars["Int"]>;
	billingAddress_LTE?: InputMaybe<Scalars["Int"]>;
	billingAddress_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	billingAddress_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	billingAddress_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	billingAddress_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	billingAddress_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	contactEmail_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	contactEmail_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	contactEmail_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	contactEmail_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	contactEmail_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	contactEmail_EQUAL?: InputMaybe<Scalars["String"]>;
	contactEmail_GT?: InputMaybe<Scalars["Int"]>;
	contactEmail_GTE?: InputMaybe<Scalars["Int"]>;
	contactEmail_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	contactEmail_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	contactEmail_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	contactEmail_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	contactEmail_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	contactEmail_LT?: InputMaybe<Scalars["Int"]>;
	contactEmail_LTE?: InputMaybe<Scalars["Int"]>;
	contactEmail_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	contactEmail_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	contactEmail_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	contactEmail_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	contactEmail_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	contactFirstName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	contactFirstName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	contactFirstName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	contactFirstName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	contactFirstName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	contactFirstName_EQUAL?: InputMaybe<Scalars["String"]>;
	contactFirstName_GT?: InputMaybe<Scalars["Int"]>;
	contactFirstName_GTE?: InputMaybe<Scalars["Int"]>;
	contactFirstName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	contactFirstName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	contactFirstName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	contactFirstName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	contactFirstName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	contactFirstName_LT?: InputMaybe<Scalars["Int"]>;
	contactFirstName_LTE?: InputMaybe<Scalars["Int"]>;
	contactFirstName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	contactFirstName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	contactFirstName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	contactFirstName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	contactFirstName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	contactLastName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	contactLastName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	contactLastName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	contactLastName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	contactLastName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	contactLastName_EQUAL?: InputMaybe<Scalars["String"]>;
	contactLastName_GT?: InputMaybe<Scalars["Int"]>;
	contactLastName_GTE?: InputMaybe<Scalars["Int"]>;
	contactLastName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	contactLastName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	contactLastName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	contactLastName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	contactLastName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	contactLastName_LT?: InputMaybe<Scalars["Int"]>;
	contactLastName_LTE?: InputMaybe<Scalars["Int"]>;
	contactLastName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	contactLastName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	contactLastName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	contactLastName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	contactLastName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	contactOccupation_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	contactOccupation_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	contactOccupation_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	contactOccupation_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	contactOccupation_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	contactOccupation_EQUAL?: InputMaybe<Scalars["String"]>;
	contactOccupation_GT?: InputMaybe<Scalars["Int"]>;
	contactOccupation_GTE?: InputMaybe<Scalars["Int"]>;
	contactOccupation_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	contactOccupation_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	contactOccupation_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	contactOccupation_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	contactOccupation_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	contactOccupation_LT?: InputMaybe<Scalars["Int"]>;
	contactOccupation_LTE?: InputMaybe<Scalars["Int"]>;
	contactOccupation_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	contactOccupation_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	contactOccupation_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	contactOccupation_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	contactOccupation_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	contactPhone_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	contactPhone_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	contactPhone_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	contactPhone_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	contactPhone_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	contactPhone_EQUAL?: InputMaybe<Scalars["String"]>;
	contactPhone_GT?: InputMaybe<Scalars["Int"]>;
	contactPhone_GTE?: InputMaybe<Scalars["Int"]>;
	contactPhone_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	contactPhone_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	contactPhone_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	contactPhone_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	contactPhone_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	contactPhone_LT?: InputMaybe<Scalars["Int"]>;
	contactPhone_LTE?: InputMaybe<Scalars["Int"]>;
	contactPhone_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	contactPhone_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	contactPhone_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	contactPhone_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	contactPhone_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	domicile_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	domicile_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	domicile_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	domicile_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	domicile_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	domicile_EQUAL?: InputMaybe<Scalars["String"]>;
	domicile_GT?: InputMaybe<Scalars["Int"]>;
	domicile_GTE?: InputMaybe<Scalars["Int"]>;
	domicile_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	domicile_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	domicile_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	domicile_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	domicile_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	domicile_LT?: InputMaybe<Scalars["Int"]>;
	domicile_LTE?: InputMaybe<Scalars["Int"]>;
	domicile_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	domicile_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	domicile_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	domicile_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	domicile_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	eIN_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	eIN_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	eIN_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	eIN_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	eIN_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	eIN_EQUAL?: InputMaybe<Scalars["String"]>;
	eIN_GT?: InputMaybe<Scalars["Int"]>;
	eIN_GTE?: InputMaybe<Scalars["Int"]>;
	eIN_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	eIN_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	eIN_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	eIN_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	eIN_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	eIN_LT?: InputMaybe<Scalars["Int"]>;
	eIN_LTE?: InputMaybe<Scalars["Int"]>;
	eIN_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	eIN_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	eIN_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	eIN_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	eIN_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	fax_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	fax_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	fax_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	fax_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	fax_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	fax_EQUAL?: InputMaybe<Scalars["String"]>;
	fax_GT?: InputMaybe<Scalars["Int"]>;
	fax_GTE?: InputMaybe<Scalars["Int"]>;
	fax_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	fax_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	fax_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	fax_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	fax_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	fax_LT?: InputMaybe<Scalars["Int"]>;
	fax_LTE?: InputMaybe<Scalars["Int"]>;
	fax_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	fax_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	fax_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	fax_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	fax_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	legalName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	legalName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	legalName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	legalName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	legalName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	legalName_EQUAL?: InputMaybe<Scalars["String"]>;
	legalName_GT?: InputMaybe<Scalars["Int"]>;
	legalName_GTE?: InputMaybe<Scalars["Int"]>;
	legalName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	legalName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	legalName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	legalName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	legalName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	legalName_LT?: InputMaybe<Scalars["Int"]>;
	legalName_LTE?: InputMaybe<Scalars["Int"]>;
	legalName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	legalName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	legalName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	legalName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	legalName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	logo_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	logo_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	logo_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	logo_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	logo_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	logo_EQUAL?: InputMaybe<Scalars["String"]>;
	logo_GT?: InputMaybe<Scalars["Int"]>;
	logo_GTE?: InputMaybe<Scalars["Int"]>;
	logo_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	logo_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	logo_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	logo_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	logo_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	logo_LT?: InputMaybe<Scalars["Int"]>;
	logo_LTE?: InputMaybe<Scalars["Int"]>;
	logo_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	logo_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	logo_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	logo_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	logo_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	name_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	name_EQUAL?: InputMaybe<Scalars["String"]>;
	name_GT?: InputMaybe<Scalars["Int"]>;
	name_GTE?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	name_LT?: InputMaybe<Scalars["Int"]>;
	name_LTE?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	phone_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	phone_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	phone_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	phone_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	phone_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	phone_EQUAL?: InputMaybe<Scalars["String"]>;
	phone_GT?: InputMaybe<Scalars["Int"]>;
	phone_GTE?: InputMaybe<Scalars["Int"]>;
	phone_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	phone_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	phone_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	phone_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	phone_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	phone_LT?: InputMaybe<Scalars["Int"]>;
	phone_LTE?: InputMaybe<Scalars["Int"]>;
	phone_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	phone_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	phone_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	phone_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	phone_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	tenantId_EQUAL?: InputMaybe<Scalars["String"]>;
	tenantId_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	website_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	website_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	website_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	website_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	website_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	website_EQUAL?: InputMaybe<Scalars["String"]>;
	website_GT?: InputMaybe<Scalars["Int"]>;
	website_GTE?: InputMaybe<Scalars["Int"]>;
	website_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	website_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	website_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	website_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	website_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	website_LT?: InputMaybe<Scalars["Int"]>;
	website_LTE?: InputMaybe<Scalars["Int"]>;
	website_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	website_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	website_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	website_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	website_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type StobContractPartnerRelationship = {
	__typename?: "StobContractPartnerRelationship";
	cursor: Scalars["String"];
	node: Organization;
};

export type StobContractPartnerUpdateConnectionInput = {
	node?: InputMaybe<OrganizationUpdateInput>;
};

export type StobContractPartnerUpdateFieldInput = {
	connect?: InputMaybe<StobContractPartnerConnectFieldInput>;
	create?: InputMaybe<StobContractPartnerCreateFieldInput>;
	delete?: InputMaybe<StobContractPartnerDeleteFieldInput>;
	disconnect?: InputMaybe<StobContractPartnerDisconnectFieldInput>;
	update?: InputMaybe<StobContractPartnerUpdateConnectionInput>;
	where?: InputMaybe<StobContractPartnerConnectionWhere>;
};

export type StobContractRecommendedFormsAggregateInput = {
	AND?: InputMaybe<Array<StobContractRecommendedFormsAggregateInput>>;
	OR?: InputMaybe<Array<StobContractRecommendedFormsAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<StobContractRecommendedFormsNodeAggregationWhereInput>;
};

export type StobContractRecommendedFormsConnectFieldInput = {
	where?: InputMaybe<RecommendedFormConnectWhere>;
};

export type StobContractRecommendedFormsConnection = {
	__typename?: "StobContractRecommendedFormsConnection";
	edges: Array<StobContractRecommendedFormsRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type StobContractRecommendedFormsConnectionSort = {
	node?: InputMaybe<RecommendedFormSort>;
};

export type StobContractRecommendedFormsConnectionWhere = {
	AND?: InputMaybe<Array<StobContractRecommendedFormsConnectionWhere>>;
	OR?: InputMaybe<Array<StobContractRecommendedFormsConnectionWhere>>;
	node?: InputMaybe<RecommendedFormWhere>;
	node_NOT?: InputMaybe<RecommendedFormWhere>;
};

export type StobContractRecommendedFormsCreateFieldInput = {
	node: RecommendedFormCreateInput;
};

export type StobContractRecommendedFormsDeleteFieldInput = {
	where?: InputMaybe<StobContractRecommendedFormsConnectionWhere>;
};

export type StobContractRecommendedFormsDisconnectFieldInput = {
	where?: InputMaybe<StobContractRecommendedFormsConnectionWhere>;
};

export type StobContractRecommendedFormsFieldInput = {
	connect?: InputMaybe<Array<StobContractRecommendedFormsConnectFieldInput>>;
	create?: InputMaybe<Array<StobContractRecommendedFormsCreateFieldInput>>;
};

export type StobContractRecommendedFormsNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<StobContractRecommendedFormsNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<StobContractRecommendedFormsNodeAggregationWhereInput>>;
	order_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	order_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	order_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	order_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	order_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	order_EQUAL?: InputMaybe<Scalars["Int"]>;
	order_GT?: InputMaybe<Scalars["Int"]>;
	order_GTE?: InputMaybe<Scalars["Int"]>;
	order_LT?: InputMaybe<Scalars["Int"]>;
	order_LTE?: InputMaybe<Scalars["Int"]>;
	order_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	order_MAX_GT?: InputMaybe<Scalars["Int"]>;
	order_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	order_MAX_LT?: InputMaybe<Scalars["Int"]>;
	order_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	order_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	order_MIN_GT?: InputMaybe<Scalars["Int"]>;
	order_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	order_MIN_LT?: InputMaybe<Scalars["Int"]>;
	order_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	timeframeEnd_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	timeframeEnd_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	timeframeEnd_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	timeframeEnd_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	timeframeEnd_EQUAL?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_GT?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_GTE?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_LT?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_LTE?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_MAX_GT?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_MAX_LT?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_MIN_GT?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_MIN_LT?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	timeframeStart_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	timeframeStart_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	timeframeStart_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	timeframeStart_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	timeframeStart_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	timeframeStart_EQUAL?: InputMaybe<Scalars["Int"]>;
	timeframeStart_GT?: InputMaybe<Scalars["Int"]>;
	timeframeStart_GTE?: InputMaybe<Scalars["Int"]>;
	timeframeStart_LT?: InputMaybe<Scalars["Int"]>;
	timeframeStart_LTE?: InputMaybe<Scalars["Int"]>;
	timeframeStart_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	timeframeStart_MAX_GT?: InputMaybe<Scalars["Int"]>;
	timeframeStart_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	timeframeStart_MAX_LT?: InputMaybe<Scalars["Int"]>;
	timeframeStart_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	timeframeStart_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	timeframeStart_MIN_GT?: InputMaybe<Scalars["Int"]>;
	timeframeStart_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	timeframeStart_MIN_LT?: InputMaybe<Scalars["Int"]>;
	timeframeStart_MIN_LTE?: InputMaybe<Scalars["Int"]>;
};

export type StobContractRecommendedFormsRelationship = {
	__typename?: "StobContractRecommendedFormsRelationship";
	cursor: Scalars["String"];
	node: RecommendedForm;
};

export type StobContractRecommendedFormsUpdateConnectionInput = {
	node?: InputMaybe<RecommendedFormUpdateInput>;
};

export type StobContractRecommendedFormsUpdateFieldInput = {
	connect?: InputMaybe<Array<StobContractRecommendedFormsConnectFieldInput>>;
	create?: InputMaybe<Array<StobContractRecommendedFormsCreateFieldInput>>;
	delete?: InputMaybe<Array<StobContractRecommendedFormsDeleteFieldInput>>;
	disconnect?: InputMaybe<Array<StobContractRecommendedFormsDisconnectFieldInput>>;
	update?: InputMaybe<StobContractRecommendedFormsUpdateConnectionInput>;
	where?: InputMaybe<StobContractRecommendedFormsConnectionWhere>;
};

export type StobContractScenariosAggregateInput = {
	AND?: InputMaybe<Array<StobContractScenariosAggregateInput>>;
	OR?: InputMaybe<Array<StobContractScenariosAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<StobContractScenariosNodeAggregationWhereInput>;
};

export type StobContractScenariosConnectFieldInput = {
	connect?: InputMaybe<Array<StobScenarioConnectInput>>;
	where?: InputMaybe<StobScenarioConnectWhere>;
};

export type StobContractScenariosConnection = {
	__typename?: "StobContractScenariosConnection";
	edges: Array<StobContractScenariosRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type StobContractScenariosConnectionSort = {
	node?: InputMaybe<StobScenarioSort>;
};

export type StobContractScenariosConnectionWhere = {
	AND?: InputMaybe<Array<StobContractScenariosConnectionWhere>>;
	OR?: InputMaybe<Array<StobContractScenariosConnectionWhere>>;
	node?: InputMaybe<StobScenarioWhere>;
	node_NOT?: InputMaybe<StobScenarioWhere>;
};

export type StobContractScenariosCreateFieldInput = {
	node: StobScenarioCreateInput;
};

export type StobContractScenariosDeleteFieldInput = {
	delete?: InputMaybe<StobScenarioDeleteInput>;
	where?: InputMaybe<StobContractScenariosConnectionWhere>;
};

export type StobContractScenariosDisconnectFieldInput = {
	disconnect?: InputMaybe<StobScenarioDisconnectInput>;
	where?: InputMaybe<StobContractScenariosConnectionWhere>;
};

export type StobContractScenariosFieldInput = {
	connect?: InputMaybe<Array<StobContractScenariosConnectFieldInput>>;
	create?: InputMaybe<Array<StobContractScenariosCreateFieldInput>>;
};

export type StobContractScenariosNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<StobContractScenariosNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<StobContractScenariosNodeAggregationWhereInput>>;
	order_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	order_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	order_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	order_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	order_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	order_EQUAL?: InputMaybe<Scalars["Int"]>;
	order_GT?: InputMaybe<Scalars["Int"]>;
	order_GTE?: InputMaybe<Scalars["Int"]>;
	order_LT?: InputMaybe<Scalars["Int"]>;
	order_LTE?: InputMaybe<Scalars["Int"]>;
	order_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	order_MAX_GT?: InputMaybe<Scalars["Int"]>;
	order_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	order_MAX_LT?: InputMaybe<Scalars["Int"]>;
	order_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	order_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	order_MIN_GT?: InputMaybe<Scalars["Int"]>;
	order_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	order_MIN_LT?: InputMaybe<Scalars["Int"]>;
	order_MIN_LTE?: InputMaybe<Scalars["Int"]>;
};

export type StobContractScenariosRelationship = {
	__typename?: "StobContractScenariosRelationship";
	cursor: Scalars["String"];
	node: StobScenario;
};

export type StobContractScenariosUpdateConnectionInput = {
	node?: InputMaybe<StobScenarioUpdateInput>;
};

export type StobContractScenariosUpdateFieldInput = {
	connect?: InputMaybe<Array<StobContractScenariosConnectFieldInput>>;
	create?: InputMaybe<Array<StobContractScenariosCreateFieldInput>>;
	delete?: InputMaybe<Array<StobContractScenariosDeleteFieldInput>>;
	disconnect?: InputMaybe<Array<StobContractScenariosDisconnectFieldInput>>;
	update?: InputMaybe<StobContractScenariosUpdateConnectionInput>;
	where?: InputMaybe<StobContractScenariosConnectionWhere>;
};

/** Fields to sort StobContracts by. The order in which sorts are applied is not guaranteed when specifying many fields in one StobContractSort object. */
export type StobContractSort = {
	adverseEventsMeasureName?: InputMaybe<SortDirection>;
	buyerContractNumber?: InputMaybe<SortDirection>;
	customerNumber?: InputMaybe<SortDirection>;
	description?: InputMaybe<SortDirection>;
	detailsUrl?: InputMaybe<SortDirection>;
	documentationGapDays?: InputMaybe<SortDirection>;
	firstExecutionDate?: InputMaybe<SortDirection>;
	formattedAmount?: InputMaybe<SortDirection>;
	formattedCounterparties?: InputMaybe<SortDirection>;
	formattedProducts?: InputMaybe<SortDirection>;
	formattedTags?: InputMaybe<SortDirection>;
	formattedValidityPeriod?: InputMaybe<SortDirection>;
	id?: InputMaybe<SortDirection>;
	initialVersionId?: InputMaybe<SortDirection>;
	lastExecutionDate?: InputMaybe<SortDirection>;
	maxPatientNumber?: InputMaybe<SortDirection>;
	maxTargetValue?: InputMaybe<SortDirection>;
	name?: InputMaybe<SortDirection>;
	responseEvaluationMeasureName?: InputMaybe<SortDirection>;
	status?: InputMaybe<SortDirection>;
	treatmentBasePrice?: InputMaybe<SortDirection>;
	validFromDate?: InputMaybe<SortDirection>;
	validToDate?: InputMaybe<SortDirection>;
	vendorContractNumber?: InputMaybe<SortDirection>;
	vendorNumber?: InputMaybe<SortDirection>;
};

export type StobContractStatisticsAggregateInput = {
	AND?: InputMaybe<Array<StobContractStatisticsAggregateInput>>;
	OR?: InputMaybe<Array<StobContractStatisticsAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<StobContractStatisticsNodeAggregationWhereInput>;
};

export type StobContractStatisticsConnectFieldInput = {
	where?: InputMaybe<StobStatisticsConnectWhere>;
};

export type StobContractStatisticsConnection = {
	__typename?: "StobContractStatisticsConnection";
	edges: Array<StobContractStatisticsRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type StobContractStatisticsConnectionSort = {
	node?: InputMaybe<StobStatisticsSort>;
};

export type StobContractStatisticsConnectionWhere = {
	AND?: InputMaybe<Array<StobContractStatisticsConnectionWhere>>;
	OR?: InputMaybe<Array<StobContractStatisticsConnectionWhere>>;
	node?: InputMaybe<StobStatisticsWhere>;
	node_NOT?: InputMaybe<StobStatisticsWhere>;
};

export type StobContractStatisticsCreateFieldInput = {
	node: StobStatisticsCreateInput;
};

export type StobContractStatisticsDeleteFieldInput = {
	where?: InputMaybe<StobContractStatisticsConnectionWhere>;
};

export type StobContractStatisticsDisconnectFieldInput = {
	where?: InputMaybe<StobContractStatisticsConnectionWhere>;
};

export type StobContractStatisticsFieldInput = {
	connect?: InputMaybe<StobContractStatisticsConnectFieldInput>;
	create?: InputMaybe<StobContractStatisticsCreateFieldInput>;
};

export type StobContractStatisticsNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<StobContractStatisticsNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<StobContractStatisticsNodeAggregationWhereInput>>;
	crCases_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	crCases_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	crCases_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	crCases_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	crCases_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	crCases_EQUAL?: InputMaybe<Scalars["Int"]>;
	crCases_GT?: InputMaybe<Scalars["Int"]>;
	crCases_GTE?: InputMaybe<Scalars["Int"]>;
	crCases_LT?: InputMaybe<Scalars["Int"]>;
	crCases_LTE?: InputMaybe<Scalars["Int"]>;
	crCases_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	crCases_MAX_GT?: InputMaybe<Scalars["Int"]>;
	crCases_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	crCases_MAX_LT?: InputMaybe<Scalars["Int"]>;
	crCases_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	crCases_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	crCases_MIN_GT?: InputMaybe<Scalars["Int"]>;
	crCases_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	crCases_MIN_LT?: InputMaybe<Scalars["Int"]>;
	crCases_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	patientsEnrolled_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	patientsEnrolled_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	patientsEnrolled_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	patientsEnrolled_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	patientsEnrolled_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	patientsEnrolled_EQUAL?: InputMaybe<Scalars["Int"]>;
	patientsEnrolled_GT?: InputMaybe<Scalars["Int"]>;
	patientsEnrolled_GTE?: InputMaybe<Scalars["Int"]>;
	patientsEnrolled_LT?: InputMaybe<Scalars["Int"]>;
	patientsEnrolled_LTE?: InputMaybe<Scalars["Int"]>;
	patientsEnrolled_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	patientsEnrolled_MAX_GT?: InputMaybe<Scalars["Int"]>;
	patientsEnrolled_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	patientsEnrolled_MAX_LT?: InputMaybe<Scalars["Int"]>;
	patientsEnrolled_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	patientsEnrolled_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	patientsEnrolled_MIN_GT?: InputMaybe<Scalars["Int"]>;
	patientsEnrolled_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	patientsEnrolled_MIN_LT?: InputMaybe<Scalars["Int"]>;
	patientsEnrolled_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	patientsWithAe3and4_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	patientsWithAe3and4_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	patientsWithAe3and4_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	patientsWithAe3and4_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	patientsWithAe3and4_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	patientsWithAe3and4_EQUAL?: InputMaybe<Scalars["Int"]>;
	patientsWithAe3and4_GT?: InputMaybe<Scalars["Int"]>;
	patientsWithAe3and4_GTE?: InputMaybe<Scalars["Int"]>;
	patientsWithAe3and4_LT?: InputMaybe<Scalars["Int"]>;
	patientsWithAe3and4_LTE?: InputMaybe<Scalars["Int"]>;
	patientsWithAe3and4_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	patientsWithAe3and4_MAX_GT?: InputMaybe<Scalars["Int"]>;
	patientsWithAe3and4_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	patientsWithAe3and4_MAX_LT?: InputMaybe<Scalars["Int"]>;
	patientsWithAe3and4_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	patientsWithAe3and4_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	patientsWithAe3and4_MIN_GT?: InputMaybe<Scalars["Int"]>;
	patientsWithAe3and4_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	patientsWithAe3and4_MIN_LT?: InputMaybe<Scalars["Int"]>;
	patientsWithAe3and4_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	patientsWithCrPrSd_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	patientsWithCrPrSd_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	patientsWithCrPrSd_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	patientsWithCrPrSd_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	patientsWithCrPrSd_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	patientsWithCrPrSd_EQUAL?: InputMaybe<Scalars["Int"]>;
	patientsWithCrPrSd_GT?: InputMaybe<Scalars["Int"]>;
	patientsWithCrPrSd_GTE?: InputMaybe<Scalars["Int"]>;
	patientsWithCrPrSd_LT?: InputMaybe<Scalars["Int"]>;
	patientsWithCrPrSd_LTE?: InputMaybe<Scalars["Int"]>;
	patientsWithCrPrSd_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	patientsWithCrPrSd_MAX_GT?: InputMaybe<Scalars["Int"]>;
	patientsWithCrPrSd_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	patientsWithCrPrSd_MAX_LT?: InputMaybe<Scalars["Int"]>;
	patientsWithCrPrSd_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	patientsWithCrPrSd_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	patientsWithCrPrSd_MIN_GT?: InputMaybe<Scalars["Int"]>;
	patientsWithCrPrSd_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	patientsWithCrPrSd_MIN_LT?: InputMaybe<Scalars["Int"]>;
	patientsWithCrPrSd_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	payableAgreementAmount_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	payableAgreementAmount_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	payableAgreementAmount_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	payableAgreementAmount_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	payableAgreementAmount_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	payableAgreementAmount_EQUAL?: InputMaybe<Scalars["Int"]>;
	payableAgreementAmount_GT?: InputMaybe<Scalars["Int"]>;
	payableAgreementAmount_GTE?: InputMaybe<Scalars["Int"]>;
	payableAgreementAmount_LT?: InputMaybe<Scalars["Int"]>;
	payableAgreementAmount_LTE?: InputMaybe<Scalars["Int"]>;
	payableAgreementAmount_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	payableAgreementAmount_MAX_GT?: InputMaybe<Scalars["Int"]>;
	payableAgreementAmount_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	payableAgreementAmount_MAX_LT?: InputMaybe<Scalars["Int"]>;
	payableAgreementAmount_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	payableAgreementAmount_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	payableAgreementAmount_MIN_GT?: InputMaybe<Scalars["Int"]>;
	payableAgreementAmount_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	payableAgreementAmount_MIN_LT?: InputMaybe<Scalars["Int"]>;
	payableAgreementAmount_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	prCases_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	prCases_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	prCases_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	prCases_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	prCases_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	prCases_EQUAL?: InputMaybe<Scalars["Int"]>;
	prCases_GT?: InputMaybe<Scalars["Int"]>;
	prCases_GTE?: InputMaybe<Scalars["Int"]>;
	prCases_LT?: InputMaybe<Scalars["Int"]>;
	prCases_LTE?: InputMaybe<Scalars["Int"]>;
	prCases_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	prCases_MAX_GT?: InputMaybe<Scalars["Int"]>;
	prCases_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	prCases_MAX_LT?: InputMaybe<Scalars["Int"]>;
	prCases_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	prCases_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	prCases_MIN_GT?: InputMaybe<Scalars["Int"]>;
	prCases_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	prCases_MIN_LT?: InputMaybe<Scalars["Int"]>;
	prCases_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	refundableAgreementAmount_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	refundableAgreementAmount_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	refundableAgreementAmount_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	refundableAgreementAmount_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	refundableAgreementAmount_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	refundableAgreementAmount_EQUAL?: InputMaybe<Scalars["Int"]>;
	refundableAgreementAmount_GT?: InputMaybe<Scalars["Int"]>;
	refundableAgreementAmount_GTE?: InputMaybe<Scalars["Int"]>;
	refundableAgreementAmount_LT?: InputMaybe<Scalars["Int"]>;
	refundableAgreementAmount_LTE?: InputMaybe<Scalars["Int"]>;
	refundableAgreementAmount_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	refundableAgreementAmount_MAX_GT?: InputMaybe<Scalars["Int"]>;
	refundableAgreementAmount_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	refundableAgreementAmount_MAX_LT?: InputMaybe<Scalars["Int"]>;
	refundableAgreementAmount_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	refundableAgreementAmount_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	refundableAgreementAmount_MIN_GT?: InputMaybe<Scalars["Int"]>;
	refundableAgreementAmount_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	refundableAgreementAmount_MIN_LT?: InputMaybe<Scalars["Int"]>;
	refundableAgreementAmount_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	sdCases_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	sdCases_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	sdCases_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	sdCases_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	sdCases_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	sdCases_EQUAL?: InputMaybe<Scalars["Int"]>;
	sdCases_GT?: InputMaybe<Scalars["Int"]>;
	sdCases_GTE?: InputMaybe<Scalars["Int"]>;
	sdCases_LT?: InputMaybe<Scalars["Int"]>;
	sdCases_LTE?: InputMaybe<Scalars["Int"]>;
	sdCases_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	sdCases_MAX_GT?: InputMaybe<Scalars["Int"]>;
	sdCases_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	sdCases_MAX_LT?: InputMaybe<Scalars["Int"]>;
	sdCases_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	sdCases_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	sdCases_MIN_GT?: InputMaybe<Scalars["Int"]>;
	sdCases_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	sdCases_MIN_LT?: InputMaybe<Scalars["Int"]>;
	sdCases_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	totalAgreementAmount_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	totalAgreementAmount_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	totalAgreementAmount_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	totalAgreementAmount_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	totalAgreementAmount_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	totalAgreementAmount_EQUAL?: InputMaybe<Scalars["Int"]>;
	totalAgreementAmount_GT?: InputMaybe<Scalars["Int"]>;
	totalAgreementAmount_GTE?: InputMaybe<Scalars["Int"]>;
	totalAgreementAmount_LT?: InputMaybe<Scalars["Int"]>;
	totalAgreementAmount_LTE?: InputMaybe<Scalars["Int"]>;
	totalAgreementAmount_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	totalAgreementAmount_MAX_GT?: InputMaybe<Scalars["Int"]>;
	totalAgreementAmount_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	totalAgreementAmount_MAX_LT?: InputMaybe<Scalars["Int"]>;
	totalAgreementAmount_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	totalAgreementAmount_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	totalAgreementAmount_MIN_GT?: InputMaybe<Scalars["Int"]>;
	totalAgreementAmount_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	totalAgreementAmount_MIN_LT?: InputMaybe<Scalars["Int"]>;
	totalAgreementAmount_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	totalCases_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	totalCases_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	totalCases_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	totalCases_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	totalCases_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	totalCases_EQUAL?: InputMaybe<Scalars["Int"]>;
	totalCases_GT?: InputMaybe<Scalars["Int"]>;
	totalCases_GTE?: InputMaybe<Scalars["Int"]>;
	totalCases_LT?: InputMaybe<Scalars["Int"]>;
	totalCases_LTE?: InputMaybe<Scalars["Int"]>;
	totalCases_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	totalCases_MAX_GT?: InputMaybe<Scalars["Int"]>;
	totalCases_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	totalCases_MAX_LT?: InputMaybe<Scalars["Int"]>;
	totalCases_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	totalCases_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	totalCases_MIN_GT?: InputMaybe<Scalars["Int"]>;
	totalCases_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	totalCases_MIN_LT?: InputMaybe<Scalars["Int"]>;
	totalCases_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	traesGrade3_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	traesGrade3_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	traesGrade3_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	traesGrade3_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	traesGrade3_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	traesGrade3_EQUAL?: InputMaybe<Scalars["Int"]>;
	traesGrade3_GT?: InputMaybe<Scalars["Int"]>;
	traesGrade3_GTE?: InputMaybe<Scalars["Int"]>;
	traesGrade3_LT?: InputMaybe<Scalars["Int"]>;
	traesGrade3_LTE?: InputMaybe<Scalars["Int"]>;
	traesGrade3_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	traesGrade3_MAX_GT?: InputMaybe<Scalars["Int"]>;
	traesGrade3_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	traesGrade3_MAX_LT?: InputMaybe<Scalars["Int"]>;
	traesGrade3_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	traesGrade3_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	traesGrade3_MIN_GT?: InputMaybe<Scalars["Int"]>;
	traesGrade3_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	traesGrade3_MIN_LT?: InputMaybe<Scalars["Int"]>;
	traesGrade3_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	traesGrade4_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	traesGrade4_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	traesGrade4_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	traesGrade4_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	traesGrade4_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	traesGrade4_EQUAL?: InputMaybe<Scalars["Int"]>;
	traesGrade4_GT?: InputMaybe<Scalars["Int"]>;
	traesGrade4_GTE?: InputMaybe<Scalars["Int"]>;
	traesGrade4_LT?: InputMaybe<Scalars["Int"]>;
	traesGrade4_LTE?: InputMaybe<Scalars["Int"]>;
	traesGrade4_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	traesGrade4_MAX_GT?: InputMaybe<Scalars["Int"]>;
	traesGrade4_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	traesGrade4_MAX_LT?: InputMaybe<Scalars["Int"]>;
	traesGrade4_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	traesGrade4_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	traesGrade4_MIN_GT?: InputMaybe<Scalars["Int"]>;
	traesGrade4_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	traesGrade4_MIN_LT?: InputMaybe<Scalars["Int"]>;
	traesGrade4_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	treatmentDiscontinuedAe_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	treatmentDiscontinuedAe_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	treatmentDiscontinuedAe_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	treatmentDiscontinuedAe_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	treatmentDiscontinuedAe_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	treatmentDiscontinuedAe_EQUAL?: InputMaybe<Scalars["Int"]>;
	treatmentDiscontinuedAe_GT?: InputMaybe<Scalars["Int"]>;
	treatmentDiscontinuedAe_GTE?: InputMaybe<Scalars["Int"]>;
	treatmentDiscontinuedAe_LT?: InputMaybe<Scalars["Int"]>;
	treatmentDiscontinuedAe_LTE?: InputMaybe<Scalars["Int"]>;
	treatmentDiscontinuedAe_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	treatmentDiscontinuedAe_MAX_GT?: InputMaybe<Scalars["Int"]>;
	treatmentDiscontinuedAe_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	treatmentDiscontinuedAe_MAX_LT?: InputMaybe<Scalars["Int"]>;
	treatmentDiscontinuedAe_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	treatmentDiscontinuedAe_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	treatmentDiscontinuedAe_MIN_GT?: InputMaybe<Scalars["Int"]>;
	treatmentDiscontinuedAe_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	treatmentDiscontinuedAe_MIN_LT?: InputMaybe<Scalars["Int"]>;
	treatmentDiscontinuedAe_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	treatmentDiscontinuedPatientDeceased_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	treatmentDiscontinuedPatientDeceased_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	treatmentDiscontinuedPatientDeceased_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	treatmentDiscontinuedPatientDeceased_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	treatmentDiscontinuedPatientDeceased_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	treatmentDiscontinuedPatientDeceased_EQUAL?: InputMaybe<Scalars["Int"]>;
	treatmentDiscontinuedPatientDeceased_GT?: InputMaybe<Scalars["Int"]>;
	treatmentDiscontinuedPatientDeceased_GTE?: InputMaybe<Scalars["Int"]>;
	treatmentDiscontinuedPatientDeceased_LT?: InputMaybe<Scalars["Int"]>;
	treatmentDiscontinuedPatientDeceased_LTE?: InputMaybe<Scalars["Int"]>;
	treatmentDiscontinuedPatientDeceased_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	treatmentDiscontinuedPatientDeceased_MAX_GT?: InputMaybe<Scalars["Int"]>;
	treatmentDiscontinuedPatientDeceased_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	treatmentDiscontinuedPatientDeceased_MAX_LT?: InputMaybe<Scalars["Int"]>;
	treatmentDiscontinuedPatientDeceased_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	treatmentDiscontinuedPatientDeceased_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	treatmentDiscontinuedPatientDeceased_MIN_GT?: InputMaybe<Scalars["Int"]>;
	treatmentDiscontinuedPatientDeceased_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	treatmentDiscontinuedPatientDeceased_MIN_LT?: InputMaybe<Scalars["Int"]>;
	treatmentDiscontinuedPatientDeceased_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	treatmentDiscontinuedProgressiveDisease_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	treatmentDiscontinuedProgressiveDisease_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	treatmentDiscontinuedProgressiveDisease_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	treatmentDiscontinuedProgressiveDisease_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	treatmentDiscontinuedProgressiveDisease_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	treatmentDiscontinuedProgressiveDisease_EQUAL?: InputMaybe<Scalars["Int"]>;
	treatmentDiscontinuedProgressiveDisease_GT?: InputMaybe<Scalars["Int"]>;
	treatmentDiscontinuedProgressiveDisease_GTE?: InputMaybe<Scalars["Int"]>;
	treatmentDiscontinuedProgressiveDisease_LT?: InputMaybe<Scalars["Int"]>;
	treatmentDiscontinuedProgressiveDisease_LTE?: InputMaybe<Scalars["Int"]>;
	treatmentDiscontinuedProgressiveDisease_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	treatmentDiscontinuedProgressiveDisease_MAX_GT?: InputMaybe<Scalars["Int"]>;
	treatmentDiscontinuedProgressiveDisease_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	treatmentDiscontinuedProgressiveDisease_MAX_LT?: InputMaybe<Scalars["Int"]>;
	treatmentDiscontinuedProgressiveDisease_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	treatmentDiscontinuedProgressiveDisease_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	treatmentDiscontinuedProgressiveDisease_MIN_GT?: InputMaybe<Scalars["Int"]>;
	treatmentDiscontinuedProgressiveDisease_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	treatmentDiscontinuedProgressiveDisease_MIN_LT?: InputMaybe<Scalars["Int"]>;
	treatmentDiscontinuedProgressiveDisease_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	treatmentDurationMonths_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	treatmentDurationMonths_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	treatmentDurationMonths_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	treatmentDurationMonths_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	treatmentDurationMonths_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	treatmentDurationMonths_EQUAL?: InputMaybe<Scalars["Int"]>;
	treatmentDurationMonths_GT?: InputMaybe<Scalars["Int"]>;
	treatmentDurationMonths_GTE?: InputMaybe<Scalars["Int"]>;
	treatmentDurationMonths_LT?: InputMaybe<Scalars["Int"]>;
	treatmentDurationMonths_LTE?: InputMaybe<Scalars["Int"]>;
	treatmentDurationMonths_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	treatmentDurationMonths_MAX_GT?: InputMaybe<Scalars["Int"]>;
	treatmentDurationMonths_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	treatmentDurationMonths_MAX_LT?: InputMaybe<Scalars["Int"]>;
	treatmentDurationMonths_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	treatmentDurationMonths_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	treatmentDurationMonths_MIN_GT?: InputMaybe<Scalars["Int"]>;
	treatmentDurationMonths_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	treatmentDurationMonths_MIN_LT?: InputMaybe<Scalars["Int"]>;
	treatmentDurationMonths_MIN_LTE?: InputMaybe<Scalars["Int"]>;
};

export type StobContractStatisticsRelationship = {
	__typename?: "StobContractStatisticsRelationship";
	cursor: Scalars["String"];
	node: StobStatistics;
};

export type StobContractStatisticsUpdateConnectionInput = {
	node?: InputMaybe<StobStatisticsUpdateInput>;
};

export type StobContractStatisticsUpdateFieldInput = {
	connect?: InputMaybe<StobContractStatisticsConnectFieldInput>;
	create?: InputMaybe<StobContractStatisticsCreateFieldInput>;
	delete?: InputMaybe<StobContractStatisticsDeleteFieldInput>;
	disconnect?: InputMaybe<StobContractStatisticsDisconnectFieldInput>;
	update?: InputMaybe<StobContractStatisticsUpdateConnectionInput>;
	where?: InputMaybe<StobContractStatisticsConnectionWhere>;
};

export type StobContractTagsAggregateInput = {
	AND?: InputMaybe<Array<StobContractTagsAggregateInput>>;
	OR?: InputMaybe<Array<StobContractTagsAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<StobContractTagsNodeAggregationWhereInput>;
};

export type StobContractTagsConnectFieldInput = {
	connect?: InputMaybe<Array<AgreementTagConnectInput>>;
	where?: InputMaybe<AgreementTagConnectWhere>;
};

export type StobContractTagsConnection = {
	__typename?: "StobContractTagsConnection";
	edges: Array<StobContractTagsRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type StobContractTagsConnectionSort = {
	node?: InputMaybe<AgreementTagSort>;
};

export type StobContractTagsConnectionWhere = {
	AND?: InputMaybe<Array<StobContractTagsConnectionWhere>>;
	OR?: InputMaybe<Array<StobContractTagsConnectionWhere>>;
	node?: InputMaybe<AgreementTagWhere>;
	node_NOT?: InputMaybe<AgreementTagWhere>;
};

export type StobContractTagsCreateFieldInput = {
	node: AgreementTagCreateInput;
};

export type StobContractTagsDeleteFieldInput = {
	delete?: InputMaybe<AgreementTagDeleteInput>;
	where?: InputMaybe<StobContractTagsConnectionWhere>;
};

export type StobContractTagsDisconnectFieldInput = {
	disconnect?: InputMaybe<AgreementTagDisconnectInput>;
	where?: InputMaybe<StobContractTagsConnectionWhere>;
};

export type StobContractTagsFieldInput = {
	connect?: InputMaybe<Array<StobContractTagsConnectFieldInput>>;
	create?: InputMaybe<Array<StobContractTagsCreateFieldInput>>;
};

export type StobContractTagsNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<StobContractTagsNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<StobContractTagsNodeAggregationWhereInput>>;
	id_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	id_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	id_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	id_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	id_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	id_EQUAL?: InputMaybe<Scalars["Int"]>;
	id_GT?: InputMaybe<Scalars["Int"]>;
	id_GTE?: InputMaybe<Scalars["Int"]>;
	id_LT?: InputMaybe<Scalars["Int"]>;
	id_LTE?: InputMaybe<Scalars["Int"]>;
	id_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	id_MAX_GT?: InputMaybe<Scalars["Int"]>;
	id_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	id_MAX_LT?: InputMaybe<Scalars["Int"]>;
	id_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	id_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	id_MIN_GT?: InputMaybe<Scalars["Int"]>;
	id_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	id_MIN_LT?: InputMaybe<Scalars["Int"]>;
	id_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	name_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	name_EQUAL?: InputMaybe<Scalars["String"]>;
	name_GT?: InputMaybe<Scalars["Int"]>;
	name_GTE?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	name_LT?: InputMaybe<Scalars["Int"]>;
	name_LTE?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type StobContractTagsRelationship = {
	__typename?: "StobContractTagsRelationship";
	cursor: Scalars["String"];
	node: AgreementTag;
};

export type StobContractTagsUpdateConnectionInput = {
	node?: InputMaybe<AgreementTagUpdateInput>;
};

export type StobContractTagsUpdateFieldInput = {
	connect?: InputMaybe<Array<StobContractTagsConnectFieldInput>>;
	create?: InputMaybe<Array<StobContractTagsCreateFieldInput>>;
	delete?: InputMaybe<Array<StobContractTagsDeleteFieldInput>>;
	disconnect?: InputMaybe<Array<StobContractTagsDisconnectFieldInput>>;
	update?: InputMaybe<StobContractTagsUpdateConnectionInput>;
	where?: InputMaybe<StobContractTagsConnectionWhere>;
};

export type StobContractTreatmentPriceRelationship = {
	price?: Maybe<Scalars["Float"]>;
};

export type StobContractTreatmentPriceRelationshipCreateInput = {
	price?: InputMaybe<Scalars["Float"]>;
};

export type StobContractTreatmentPriceRelationshipSort = {
	price?: InputMaybe<SortDirection>;
};

export type StobContractTreatmentPriceRelationshipUpdateInput = {
	price?: InputMaybe<Scalars["Float"]>;
};

export type StobContractTreatmentPriceRelationshipWhere = {
	AND?: InputMaybe<Array<StobContractTreatmentPriceRelationshipWhere>>;
	OR?: InputMaybe<Array<StobContractTreatmentPriceRelationshipWhere>>;
	price?: InputMaybe<Scalars["Float"]>;
	price_GT?: InputMaybe<Scalars["Float"]>;
	price_GTE?: InputMaybe<Scalars["Float"]>;
	price_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	price_LT?: InputMaybe<Scalars["Float"]>;
	price_LTE?: InputMaybe<Scalars["Float"]>;
	price_NOT?: InputMaybe<Scalars["Float"]>;
	price_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
};

export type StobContractTreatmentPricesAggregateInput = {
	AND?: InputMaybe<Array<StobContractTreatmentPricesAggregateInput>>;
	OR?: InputMaybe<Array<StobContractTreatmentPricesAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	edge?: InputMaybe<StobContractTreatmentPricesEdgeAggregationWhereInput>;
	node?: InputMaybe<StobContractTreatmentPricesNodeAggregationWhereInput>;
};

export type StobContractTreatmentPricesConnectFieldInput = {
	connect?: InputMaybe<Array<TreatmentConnectInput>>;
	edge?: InputMaybe<StobContractTreatmentPriceRelationshipCreateInput>;
	where?: InputMaybe<TreatmentConnectWhere>;
};

export type StobContractTreatmentPricesConnection = {
	__typename?: "StobContractTreatmentPricesConnection";
	edges: Array<StobContractTreatmentPricesRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type StobContractTreatmentPricesConnectionSort = {
	edge?: InputMaybe<StobContractTreatmentPriceRelationshipSort>;
	node?: InputMaybe<TreatmentSort>;
};

export type StobContractTreatmentPricesConnectionWhere = {
	AND?: InputMaybe<Array<StobContractTreatmentPricesConnectionWhere>>;
	OR?: InputMaybe<Array<StobContractTreatmentPricesConnectionWhere>>;
	edge?: InputMaybe<StobContractTreatmentPriceRelationshipWhere>;
	edge_NOT?: InputMaybe<StobContractTreatmentPriceRelationshipWhere>;
	node?: InputMaybe<TreatmentWhere>;
	node_NOT?: InputMaybe<TreatmentWhere>;
};

export type StobContractTreatmentPricesCreateFieldInput = {
	edge?: InputMaybe<StobContractTreatmentPriceRelationshipCreateInput>;
	node: TreatmentCreateInput;
};

export type StobContractTreatmentPricesDeleteFieldInput = {
	delete?: InputMaybe<TreatmentDeleteInput>;
	where?: InputMaybe<StobContractTreatmentPricesConnectionWhere>;
};

export type StobContractTreatmentPricesDisconnectFieldInput = {
	disconnect?: InputMaybe<TreatmentDisconnectInput>;
	where?: InputMaybe<StobContractTreatmentPricesConnectionWhere>;
};

export type StobContractTreatmentPricesEdgeAggregationWhereInput = {
	AND?: InputMaybe<Array<StobContractTreatmentPricesEdgeAggregationWhereInput>>;
	OR?: InputMaybe<Array<StobContractTreatmentPricesEdgeAggregationWhereInput>>;
	price_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	price_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	price_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	price_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	price_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	price_EQUAL?: InputMaybe<Scalars["Float"]>;
	price_GT?: InputMaybe<Scalars["Float"]>;
	price_GTE?: InputMaybe<Scalars["Float"]>;
	price_LT?: InputMaybe<Scalars["Float"]>;
	price_LTE?: InputMaybe<Scalars["Float"]>;
	price_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	price_MAX_GT?: InputMaybe<Scalars["Float"]>;
	price_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	price_MAX_LT?: InputMaybe<Scalars["Float"]>;
	price_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	price_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	price_MIN_GT?: InputMaybe<Scalars["Float"]>;
	price_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	price_MIN_LT?: InputMaybe<Scalars["Float"]>;
	price_MIN_LTE?: InputMaybe<Scalars["Float"]>;
};

export type StobContractTreatmentPricesFieldInput = {
	connect?: InputMaybe<Array<StobContractTreatmentPricesConnectFieldInput>>;
	create?: InputMaybe<Array<StobContractTreatmentPricesCreateFieldInput>>;
};

export type StobContractTreatmentPricesNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<StobContractTreatmentPricesNodeAggregationWhereInput>>;
	BagDossierNo_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	BagDossierNo_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	BagDossierNo_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	BagDossierNo_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	BagDossierNo_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	BagDossierNo_EQUAL?: InputMaybe<Scalars["String"]>;
	BagDossierNo_GT?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_GTE?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LT?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_LTE?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	BagDossierNo_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	Code_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	Code_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	Code_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	Code_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	Code_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	Code_EQUAL?: InputMaybe<Scalars["String"]>;
	Code_GT?: InputMaybe<Scalars["Int"]>;
	Code_GTE?: InputMaybe<Scalars["Int"]>;
	Code_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Code_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	Code_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	Code_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	Code_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	Code_LT?: InputMaybe<Scalars["Int"]>;
	Code_LTE?: InputMaybe<Scalars["Int"]>;
	Code_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Code_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	Code_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	Code_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	Code_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	FlagModal_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	FlagModal_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	FlagModal_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	FlagModal_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	FlagModal_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	FlagModal_EQUAL?: InputMaybe<Scalars["String"]>;
	FlagModal_GT?: InputMaybe<Scalars["Int"]>;
	FlagModal_GTE?: InputMaybe<Scalars["Int"]>;
	FlagModal_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	FlagModal_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	FlagModal_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	FlagModal_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	FlagModal_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	FlagModal_LT?: InputMaybe<Scalars["Int"]>;
	FlagModal_LTE?: InputMaybe<Scalars["Int"]>;
	FlagModal_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	FlagModal_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	FlagModal_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	FlagModal_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	FlagModal_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	FlagNarcosis_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	FlagNarcosis_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	FlagNarcosis_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	FlagNarcosis_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	FlagNarcosis_EQUAL?: InputMaybe<Scalars["String"]>;
	FlagNarcosis_GT?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_GTE?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LT?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_LTE?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	FlagNarcosis_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	GTIN_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	GTIN_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	GTIN_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	GTIN_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	GTIN_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	GTIN_EQUAL?: InputMaybe<Scalars["String"]>;
	GTIN_GT?: InputMaybe<Scalars["Int"]>;
	GTIN_GTE?: InputMaybe<Scalars["Int"]>;
	GTIN_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	GTIN_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	GTIN_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	GTIN_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	GTIN_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	GTIN_LT?: InputMaybe<Scalars["Int"]>;
	GTIN_LTE?: InputMaybe<Scalars["Int"]>;
	GTIN_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	GTIN_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	GTIN_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	GTIN_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	GTIN_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	LOT_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	LOT_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	LOT_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	LOT_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	LOT_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	LOT_EQUAL?: InputMaybe<Scalars["String"]>;
	LOT_GT?: InputMaybe<Scalars["Int"]>;
	LOT_GTE?: InputMaybe<Scalars["Int"]>;
	LOT_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	LOT_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	LOT_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	LOT_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	LOT_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	LOT_LT?: InputMaybe<Scalars["Int"]>;
	LOT_LTE?: InputMaybe<Scalars["Int"]>;
	LOT_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	LOT_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	LOT_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	LOT_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	LOT_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	Name_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	Name_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	Name_EQUAL?: InputMaybe<Scalars["String"]>;
	Name_GT?: InputMaybe<Scalars["Int"]>;
	Name_GTE?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	Name_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	Name_LT?: InputMaybe<Scalars["Int"]>;
	Name_LTE?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	Name_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	OR?: InputMaybe<Array<StobContractTreatmentPricesNodeAggregationWhereInput>>;
	PharmaCode_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	PharmaCode_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	PharmaCode_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	PharmaCode_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	PharmaCode_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	PharmaCode_EQUAL?: InputMaybe<Scalars["String"]>;
	PharmaCode_GT?: InputMaybe<Scalars["Int"]>;
	PharmaCode_GTE?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LT?: InputMaybe<Scalars["Int"]>;
	PharmaCode_LTE?: InputMaybe<Scalars["Int"]>;
	PharmaCode_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	PharmaCode_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	PharmaCode_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	PharmaCode_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	PharmaCode_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	PrevPharmacode_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	PrevPharmacode_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	PrevPharmacode_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	PrevPharmacode_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	PrevPharmacode_EQUAL?: InputMaybe<Scalars["String"]>;
	PrevPharmacode_GT?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_GTE?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LT?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_LTE?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	PrevPharmacode_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	REF_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	REF_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	REF_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	REF_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	REF_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	REF_EQUAL?: InputMaybe<Scalars["String"]>;
	REF_GT?: InputMaybe<Scalars["Int"]>;
	REF_GTE?: InputMaybe<Scalars["Int"]>;
	REF_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	REF_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	REF_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	REF_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	REF_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	REF_LT?: InputMaybe<Scalars["Int"]>;
	REF_LTE?: InputMaybe<Scalars["Int"]>;
	REF_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	REF_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	REF_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	REF_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	REF_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	SwissmedicCategory_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	SwissmedicCategory_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	SwissmedicCategory_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	SwissmedicCategory_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	SwissmedicCategory_EQUAL?: InputMaybe<Scalars["String"]>;
	SwissmedicCategory_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicCategory_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo8_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo8_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo8_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo8_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo8_EQUAL?: InputMaybe<Scalars["String"]>;
	SwissmedicNo8_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo8_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	UDI_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	UDI_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	UDI_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	UDI_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	UDI_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	UDI_EQUAL?: InputMaybe<Scalars["String"]>;
	UDI_GT?: InputMaybe<Scalars["Int"]>;
	UDI_GTE?: InputMaybe<Scalars["Int"]>;
	UDI_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	UDI_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	UDI_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	UDI_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	UDI_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	UDI_LT?: InputMaybe<Scalars["Int"]>;
	UDI_LTE?: InputMaybe<Scalars["Int"]>;
	UDI_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	UDI_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	UDI_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	UDI_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	UDI_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	classificationSystem_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	classificationSystem_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	classificationSystem_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	classificationSystem_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	classificationSystem_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	classificationSystem_EQUAL?: InputMaybe<Scalars["String"]>;
	classificationSystem_GT?: InputMaybe<Scalars["Int"]>;
	classificationSystem_GTE?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LT?: InputMaybe<Scalars["Int"]>;
	classificationSystem_LTE?: InputMaybe<Scalars["Int"]>;
	classificationSystem_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	classificationSystem_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	classificationSystem_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	classificationSystem_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	classificationSystem_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type StobContractTreatmentPricesRelationship = StobContractTreatmentPriceRelationship & {
	__typename?: "StobContractTreatmentPricesRelationship";
	cursor: Scalars["String"];
	node: Treatment;
	price?: Maybe<Scalars["Float"]>;
};

export type StobContractTreatmentPricesUpdateConnectionInput = {
	edge?: InputMaybe<StobContractTreatmentPriceRelationshipUpdateInput>;
	node?: InputMaybe<TreatmentUpdateInput>;
};

export type StobContractTreatmentPricesUpdateFieldInput = {
	connect?: InputMaybe<Array<StobContractTreatmentPricesConnectFieldInput>>;
	create?: InputMaybe<Array<StobContractTreatmentPricesCreateFieldInput>>;
	delete?: InputMaybe<Array<StobContractTreatmentPricesDeleteFieldInput>>;
	disconnect?: InputMaybe<Array<StobContractTreatmentPricesDisconnectFieldInput>>;
	update?: InputMaybe<StobContractTreatmentPricesUpdateConnectionInput>;
	where?: InputMaybe<StobContractTreatmentPricesConnectionWhere>;
};

export type StobContractUpdateInput = {
	adverseEvents?: InputMaybe<Array<IrAdverseEvents>>;
	adverseEventsMeasureName?: InputMaybe<Scalars["String"]>;
	buyerContractNumber?: InputMaybe<Scalars["String"]>;
	cases?: InputMaybe<Array<StobContractCasesUpdateFieldInput>>;
	creatorOrganization?: InputMaybe<StobContractCreatorOrganizationUpdateFieldInput>;
	currency?: InputMaybe<StobContractCurrencyUpdateFieldInput>;
	customerNumber?: InputMaybe<Scalars["String"]>;
	description?: InputMaybe<Scalars["String"]>;
	detailsUrl?: InputMaybe<Scalars["String"]>;
	disease?: InputMaybe<StobContractDiseaseUpdateFieldInput>;
	documentationGapDays?: InputMaybe<Scalars["Int"]>;
	firstExecutionDate?: InputMaybe<Scalars["DateTime"]>;
	formattedAmount?: InputMaybe<Scalars["String"]>;
	formattedCounterparties?: InputMaybe<Scalars["String"]>;
	formattedProducts?: InputMaybe<Scalars["String"]>;
	formattedTags?: InputMaybe<Scalars["String"]>;
	formattedValidityPeriod?: InputMaybe<Scalars["String"]>;
	grades?: InputMaybe<Array<IrAdverseEventGrades>>;
	id?: InputMaybe<Scalars["ID"]>;
	indication?: InputMaybe<StobContractIndicationUpdateFieldInput>;
	initialVersionId?: InputMaybe<Scalars["String"]>;
	lastExecutionDate?: InputMaybe<Scalars["DateTime"]>;
	maxPatientNumber?: InputMaybe<Scalars["Int"]>;
	maxTargetValue?: InputMaybe<Scalars["Float"]>;
	name?: InputMaybe<Scalars["String"]>;
	notifications?: InputMaybe<Array<StobContractNotificationsUpdateFieldInput>>;
	partner?: InputMaybe<StobContractPartnerUpdateFieldInput>;
	recommendedForms?: InputMaybe<Array<StobContractRecommendedFormsUpdateFieldInput>>;
	requiredForms?: InputMaybe<Array<FormType>>;
	responseEvaluationMeasureName?: InputMaybe<Scalars["String"]>;
	responseTypes?: InputMaybe<Array<IrResultOptions>>;
	scenarios?: InputMaybe<Array<StobContractScenariosUpdateFieldInput>>;
	statistics?: InputMaybe<StobContractStatisticsUpdateFieldInput>;
	status?: InputMaybe<ContractStatus>;
	tags?: InputMaybe<Array<StobContractTagsUpdateFieldInput>>;
	tenantIds?: InputMaybe<Array<Scalars["String"]>>;
	therapyDecisions?: InputMaybe<Array<StobTherapyDecision>>;
	treatmentBasePrice?: InputMaybe<Scalars["Float"]>;
	treatmentPrices?: InputMaybe<Array<StobContractTreatmentPricesUpdateFieldInput>>;
	validFromDate?: InputMaybe<Scalars["Date"]>;
	validToDate?: InputMaybe<Scalars["Date"]>;
	vendorContractNumber?: InputMaybe<Scalars["String"]>;
	vendorNumber?: InputMaybe<Scalars["String"]>;
};

export type StobContractWhere = {
	AND?: InputMaybe<Array<StobContractWhere>>;
	OR?: InputMaybe<Array<StobContractWhere>>;
	adverseEvents?: InputMaybe<Array<IrAdverseEvents>>;
	adverseEventsMeasureName?: InputMaybe<Scalars["String"]>;
	adverseEventsMeasureName_CONTAINS?: InputMaybe<Scalars["String"]>;
	adverseEventsMeasureName_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	adverseEventsMeasureName_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	adverseEventsMeasureName_MATCHES?: InputMaybe<Scalars["String"]>;
	adverseEventsMeasureName_NOT?: InputMaybe<Scalars["String"]>;
	adverseEventsMeasureName_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	adverseEventsMeasureName_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	adverseEventsMeasureName_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	adverseEventsMeasureName_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	adverseEventsMeasureName_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	adverseEvents_INCLUDES?: InputMaybe<IrAdverseEvents>;
	adverseEvents_NOT?: InputMaybe<Array<IrAdverseEvents>>;
	adverseEvents_NOT_INCLUDES?: InputMaybe<IrAdverseEvents>;
	buyerContractNumber?: InputMaybe<Scalars["String"]>;
	buyerContractNumber_CONTAINS?: InputMaybe<Scalars["String"]>;
	buyerContractNumber_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	buyerContractNumber_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	buyerContractNumber_MATCHES?: InputMaybe<Scalars["String"]>;
	buyerContractNumber_NOT?: InputMaybe<Scalars["String"]>;
	buyerContractNumber_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	buyerContractNumber_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	buyerContractNumber_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	buyerContractNumber_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	buyerContractNumber_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	cases?: InputMaybe<CaseWhere>;
	casesAggregate?: InputMaybe<StobContractCasesAggregateInput>;
	casesConnection?: InputMaybe<StobContractCasesConnectionWhere>;
	casesConnection_NOT?: InputMaybe<StobContractCasesConnectionWhere>;
	cases_NOT?: InputMaybe<CaseWhere>;
	creatorOrganization?: InputMaybe<OrganizationWhere>;
	creatorOrganizationAggregate?: InputMaybe<StobContractCreatorOrganizationAggregateInput>;
	creatorOrganizationConnection?: InputMaybe<StobContractCreatorOrganizationConnectionWhere>;
	creatorOrganizationConnection_NOT?: InputMaybe<StobContractCreatorOrganizationConnectionWhere>;
	creatorOrganization_NOT?: InputMaybe<OrganizationWhere>;
	currency?: InputMaybe<CurrencyWhere>;
	currencyAggregate?: InputMaybe<StobContractCurrencyAggregateInput>;
	currencyConnection?: InputMaybe<StobContractCurrencyConnectionWhere>;
	currencyConnection_NOT?: InputMaybe<StobContractCurrencyConnectionWhere>;
	currency_NOT?: InputMaybe<CurrencyWhere>;
	customerNumber?: InputMaybe<Scalars["String"]>;
	customerNumber_CONTAINS?: InputMaybe<Scalars["String"]>;
	customerNumber_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	customerNumber_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	customerNumber_MATCHES?: InputMaybe<Scalars["String"]>;
	customerNumber_NOT?: InputMaybe<Scalars["String"]>;
	customerNumber_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	customerNumber_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	customerNumber_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	customerNumber_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	customerNumber_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	description?: InputMaybe<Scalars["String"]>;
	description_CONTAINS?: InputMaybe<Scalars["String"]>;
	description_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	description_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	description_MATCHES?: InputMaybe<Scalars["String"]>;
	description_NOT?: InputMaybe<Scalars["String"]>;
	description_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	description_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	description_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	description_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	description_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	detailsUrl?: InputMaybe<Scalars["String"]>;
	detailsUrl_CONTAINS?: InputMaybe<Scalars["String"]>;
	detailsUrl_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	detailsUrl_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	detailsUrl_MATCHES?: InputMaybe<Scalars["String"]>;
	detailsUrl_NOT?: InputMaybe<Scalars["String"]>;
	detailsUrl_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	detailsUrl_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	detailsUrl_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	detailsUrl_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	detailsUrl_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	disease?: InputMaybe<DiseaseWhere>;
	diseaseAggregate?: InputMaybe<StobContractDiseaseAggregateInput>;
	diseaseConnection?: InputMaybe<StobContractDiseaseConnectionWhere>;
	diseaseConnection_NOT?: InputMaybe<StobContractDiseaseConnectionWhere>;
	disease_NOT?: InputMaybe<DiseaseWhere>;
	documentationGapDays?: InputMaybe<Scalars["Int"]>;
	documentationGapDays_GT?: InputMaybe<Scalars["Int"]>;
	documentationGapDays_GTE?: InputMaybe<Scalars["Int"]>;
	documentationGapDays_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	documentationGapDays_LT?: InputMaybe<Scalars["Int"]>;
	documentationGapDays_LTE?: InputMaybe<Scalars["Int"]>;
	documentationGapDays_NOT?: InputMaybe<Scalars["Int"]>;
	documentationGapDays_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	firstExecutionDate?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_GT?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_GTE?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_IN?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]>>>;
	firstExecutionDate_LT?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_LTE?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_NOT?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]>>>;
	formattedAmount?: InputMaybe<Scalars["String"]>;
	formattedAmount_CONTAINS?: InputMaybe<Scalars["String"]>;
	formattedAmount_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	formattedAmount_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	formattedAmount_MATCHES?: InputMaybe<Scalars["String"]>;
	formattedAmount_NOT?: InputMaybe<Scalars["String"]>;
	formattedAmount_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	formattedAmount_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	formattedAmount_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	formattedAmount_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	formattedAmount_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	formattedCounterparties?: InputMaybe<Scalars["String"]>;
	formattedCounterparties_CONTAINS?: InputMaybe<Scalars["String"]>;
	formattedCounterparties_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	formattedCounterparties_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	formattedCounterparties_MATCHES?: InputMaybe<Scalars["String"]>;
	formattedCounterparties_NOT?: InputMaybe<Scalars["String"]>;
	formattedCounterparties_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	formattedCounterparties_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	formattedCounterparties_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	formattedCounterparties_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	formattedCounterparties_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	formattedProducts?: InputMaybe<Scalars["String"]>;
	formattedProducts_CONTAINS?: InputMaybe<Scalars["String"]>;
	formattedProducts_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	formattedProducts_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	formattedProducts_MATCHES?: InputMaybe<Scalars["String"]>;
	formattedProducts_NOT?: InputMaybe<Scalars["String"]>;
	formattedProducts_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	formattedProducts_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	formattedProducts_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	formattedProducts_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	formattedProducts_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	formattedTags?: InputMaybe<Scalars["String"]>;
	formattedTags_CONTAINS?: InputMaybe<Scalars["String"]>;
	formattedTags_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	formattedTags_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	formattedTags_MATCHES?: InputMaybe<Scalars["String"]>;
	formattedTags_NOT?: InputMaybe<Scalars["String"]>;
	formattedTags_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	formattedTags_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	formattedTags_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	formattedTags_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	formattedTags_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	formattedValidityPeriod?: InputMaybe<Scalars["String"]>;
	formattedValidityPeriod_CONTAINS?: InputMaybe<Scalars["String"]>;
	formattedValidityPeriod_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	formattedValidityPeriod_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	formattedValidityPeriod_MATCHES?: InputMaybe<Scalars["String"]>;
	formattedValidityPeriod_NOT?: InputMaybe<Scalars["String"]>;
	formattedValidityPeriod_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	formattedValidityPeriod_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	formattedValidityPeriod_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	formattedValidityPeriod_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	formattedValidityPeriod_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	grades?: InputMaybe<Array<IrAdverseEventGrades>>;
	grades_INCLUDES?: InputMaybe<IrAdverseEventGrades>;
	grades_NOT?: InputMaybe<Array<IrAdverseEventGrades>>;
	grades_NOT_INCLUDES?: InputMaybe<IrAdverseEventGrades>;
	id?: InputMaybe<Scalars["ID"]>;
	id_CONTAINS?: InputMaybe<Scalars["ID"]>;
	id_ENDS_WITH?: InputMaybe<Scalars["ID"]>;
	id_IN?: InputMaybe<Array<InputMaybe<Scalars["ID"]>>>;
	id_MATCHES?: InputMaybe<Scalars["String"]>;
	id_NOT?: InputMaybe<Scalars["ID"]>;
	id_NOT_CONTAINS?: InputMaybe<Scalars["ID"]>;
	id_NOT_ENDS_WITH?: InputMaybe<Scalars["ID"]>;
	id_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["ID"]>>>;
	id_NOT_STARTS_WITH?: InputMaybe<Scalars["ID"]>;
	id_STARTS_WITH?: InputMaybe<Scalars["ID"]>;
	indication?: InputMaybe<IndicationWhere>;
	indicationAggregate?: InputMaybe<StobContractIndicationAggregateInput>;
	indicationConnection?: InputMaybe<StobContractIndicationConnectionWhere>;
	indicationConnection_NOT?: InputMaybe<StobContractIndicationConnectionWhere>;
	indication_NOT?: InputMaybe<IndicationWhere>;
	initialVersionId?: InputMaybe<Scalars["String"]>;
	initialVersionId_CONTAINS?: InputMaybe<Scalars["String"]>;
	initialVersionId_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	initialVersionId_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	initialVersionId_MATCHES?: InputMaybe<Scalars["String"]>;
	initialVersionId_NOT?: InputMaybe<Scalars["String"]>;
	initialVersionId_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	initialVersionId_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	initialVersionId_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	initialVersionId_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	initialVersionId_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	lastExecutionDate?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_GT?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_IN?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]>>>;
	lastExecutionDate_LT?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_LTE?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_NOT?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]>>>;
	maxPatientNumber?: InputMaybe<Scalars["Int"]>;
	maxPatientNumber_GT?: InputMaybe<Scalars["Int"]>;
	maxPatientNumber_GTE?: InputMaybe<Scalars["Int"]>;
	maxPatientNumber_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	maxPatientNumber_LT?: InputMaybe<Scalars["Int"]>;
	maxPatientNumber_LTE?: InputMaybe<Scalars["Int"]>;
	maxPatientNumber_NOT?: InputMaybe<Scalars["Int"]>;
	maxPatientNumber_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	maxTargetValue?: InputMaybe<Scalars["Float"]>;
	maxTargetValue_GT?: InputMaybe<Scalars["Float"]>;
	maxTargetValue_GTE?: InputMaybe<Scalars["Float"]>;
	maxTargetValue_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	maxTargetValue_LT?: InputMaybe<Scalars["Float"]>;
	maxTargetValue_LTE?: InputMaybe<Scalars["Float"]>;
	maxTargetValue_NOT?: InputMaybe<Scalars["Float"]>;
	maxTargetValue_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	name?: InputMaybe<Scalars["String"]>;
	name_CONTAINS?: InputMaybe<Scalars["String"]>;
	name_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	name_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	name_MATCHES?: InputMaybe<Scalars["String"]>;
	name_NOT?: InputMaybe<Scalars["String"]>;
	name_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	name_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	name_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	name_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	name_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	notifications?: InputMaybe<ContractNotificationWhere>;
	notificationsAggregate?: InputMaybe<StobContractNotificationsAggregateInput>;
	notificationsConnection?: InputMaybe<StobContractNotificationsConnectionWhere>;
	notificationsConnection_NOT?: InputMaybe<StobContractNotificationsConnectionWhere>;
	notifications_NOT?: InputMaybe<ContractNotificationWhere>;
	partner?: InputMaybe<OrganizationWhere>;
	partnerAggregate?: InputMaybe<StobContractPartnerAggregateInput>;
	partnerConnection?: InputMaybe<StobContractPartnerConnectionWhere>;
	partnerConnection_NOT?: InputMaybe<StobContractPartnerConnectionWhere>;
	partner_NOT?: InputMaybe<OrganizationWhere>;
	recommendedForms?: InputMaybe<RecommendedFormWhere>;
	recommendedFormsAggregate?: InputMaybe<StobContractRecommendedFormsAggregateInput>;
	recommendedFormsConnection?: InputMaybe<StobContractRecommendedFormsConnectionWhere>;
	recommendedFormsConnection_NOT?: InputMaybe<StobContractRecommendedFormsConnectionWhere>;
	recommendedForms_NOT?: InputMaybe<RecommendedFormWhere>;
	requiredForms?: InputMaybe<Array<FormType>>;
	requiredForms_INCLUDES?: InputMaybe<FormType>;
	requiredForms_NOT?: InputMaybe<Array<FormType>>;
	requiredForms_NOT_INCLUDES?: InputMaybe<FormType>;
	responseEvaluationMeasureName?: InputMaybe<Scalars["String"]>;
	responseEvaluationMeasureName_CONTAINS?: InputMaybe<Scalars["String"]>;
	responseEvaluationMeasureName_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	responseEvaluationMeasureName_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	responseEvaluationMeasureName_MATCHES?: InputMaybe<Scalars["String"]>;
	responseEvaluationMeasureName_NOT?: InputMaybe<Scalars["String"]>;
	responseEvaluationMeasureName_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	responseEvaluationMeasureName_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	responseEvaluationMeasureName_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	responseEvaluationMeasureName_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	responseEvaluationMeasureName_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	responseTypes?: InputMaybe<Array<IrResultOptions>>;
	responseTypes_INCLUDES?: InputMaybe<IrResultOptions>;
	responseTypes_NOT?: InputMaybe<Array<IrResultOptions>>;
	responseTypes_NOT_INCLUDES?: InputMaybe<IrResultOptions>;
	scenarios?: InputMaybe<StobScenarioWhere>;
	scenariosAggregate?: InputMaybe<StobContractScenariosAggregateInput>;
	scenariosConnection?: InputMaybe<StobContractScenariosConnectionWhere>;
	scenariosConnection_NOT?: InputMaybe<StobContractScenariosConnectionWhere>;
	scenarios_NOT?: InputMaybe<StobScenarioWhere>;
	statistics?: InputMaybe<StobStatisticsWhere>;
	statisticsAggregate?: InputMaybe<StobContractStatisticsAggregateInput>;
	statisticsConnection?: InputMaybe<StobContractStatisticsConnectionWhere>;
	statisticsConnection_NOT?: InputMaybe<StobContractStatisticsConnectionWhere>;
	statistics_NOT?: InputMaybe<StobStatisticsWhere>;
	status?: InputMaybe<ContractStatus>;
	status_IN?: InputMaybe<Array<InputMaybe<ContractStatus>>>;
	status_NOT?: InputMaybe<ContractStatus>;
	status_NOT_IN?: InputMaybe<Array<InputMaybe<ContractStatus>>>;
	tags?: InputMaybe<AgreementTagWhere>;
	tagsAggregate?: InputMaybe<StobContractTagsAggregateInput>;
	tagsConnection?: InputMaybe<StobContractTagsConnectionWhere>;
	tagsConnection_NOT?: InputMaybe<StobContractTagsConnectionWhere>;
	tags_NOT?: InputMaybe<AgreementTagWhere>;
	tenantIds?: InputMaybe<Array<Scalars["String"]>>;
	tenantIds_INCLUDES?: InputMaybe<Scalars["String"]>;
	tenantIds_NOT?: InputMaybe<Array<Scalars["String"]>>;
	tenantIds_NOT_INCLUDES?: InputMaybe<Scalars["String"]>;
	therapyDecisions?: InputMaybe<Array<StobTherapyDecision>>;
	therapyDecisions_INCLUDES?: InputMaybe<StobTherapyDecision>;
	therapyDecisions_NOT?: InputMaybe<Array<StobTherapyDecision>>;
	therapyDecisions_NOT_INCLUDES?: InputMaybe<StobTherapyDecision>;
	treatmentBasePrice?: InputMaybe<Scalars["Float"]>;
	treatmentBasePrice_GT?: InputMaybe<Scalars["Float"]>;
	treatmentBasePrice_GTE?: InputMaybe<Scalars["Float"]>;
	treatmentBasePrice_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	treatmentBasePrice_LT?: InputMaybe<Scalars["Float"]>;
	treatmentBasePrice_LTE?: InputMaybe<Scalars["Float"]>;
	treatmentBasePrice_NOT?: InputMaybe<Scalars["Float"]>;
	treatmentBasePrice_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	treatmentPrices?: InputMaybe<TreatmentWhere>;
	treatmentPricesAggregate?: InputMaybe<StobContractTreatmentPricesAggregateInput>;
	treatmentPricesConnection?: InputMaybe<StobContractTreatmentPricesConnectionWhere>;
	treatmentPricesConnection_NOT?: InputMaybe<StobContractTreatmentPricesConnectionWhere>;
	treatmentPrices_NOT?: InputMaybe<TreatmentWhere>;
	validFromDate?: InputMaybe<Scalars["Date"]>;
	validFromDate_GT?: InputMaybe<Scalars["Date"]>;
	validFromDate_GTE?: InputMaybe<Scalars["Date"]>;
	validFromDate_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
	validFromDate_LT?: InputMaybe<Scalars["Date"]>;
	validFromDate_LTE?: InputMaybe<Scalars["Date"]>;
	validFromDate_NOT?: InputMaybe<Scalars["Date"]>;
	validFromDate_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
	validToDate?: InputMaybe<Scalars["Date"]>;
	validToDate_GT?: InputMaybe<Scalars["Date"]>;
	validToDate_GTE?: InputMaybe<Scalars["Date"]>;
	validToDate_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
	validToDate_LT?: InputMaybe<Scalars["Date"]>;
	validToDate_LTE?: InputMaybe<Scalars["Date"]>;
	validToDate_NOT?: InputMaybe<Scalars["Date"]>;
	validToDate_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
	vendorContractNumber?: InputMaybe<Scalars["String"]>;
	vendorContractNumber_CONTAINS?: InputMaybe<Scalars["String"]>;
	vendorContractNumber_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	vendorContractNumber_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	vendorContractNumber_MATCHES?: InputMaybe<Scalars["String"]>;
	vendorContractNumber_NOT?: InputMaybe<Scalars["String"]>;
	vendorContractNumber_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	vendorContractNumber_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	vendorContractNumber_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	vendorContractNumber_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	vendorContractNumber_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	vendorNumber?: InputMaybe<Scalars["String"]>;
	vendorNumber_CONTAINS?: InputMaybe<Scalars["String"]>;
	vendorNumber_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	vendorNumber_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	vendorNumber_MATCHES?: InputMaybe<Scalars["String"]>;
	vendorNumber_NOT?: InputMaybe<Scalars["String"]>;
	vendorNumber_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	vendorNumber_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	vendorNumber_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	vendorNumber_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	vendorNumber_STARTS_WITH?: InputMaybe<Scalars["String"]>;
};

export enum StobMeasureType {
	ResponseEvaluation = "RESPONSE_EVALUATION",
	Trae = "TRAE",
}

export type StobMeasuresInput = {
	adverseEvents?: InputMaybe<Array<IrAdverseEvents>>;
	adverseEventsMeasureName?: InputMaybe<Scalars["String"]>;
	grades?: InputMaybe<Array<IrAdverseEventGrades>>;
	id: Scalars["ID"];
	responseEvaluationMeasureName?: InputMaybe<Scalars["String"]>;
	responseTypes?: InputMaybe<Array<IrResultOptions>>;
	therapyDecisions?: InputMaybe<Array<StobTherapyDecision>>;
};

export type StobPricingInput = {
	id: Scalars["ID"];
	prices: Array<StobTreatmentPriceInput>;
	scenarios: Array<StobScenarioInput>;
};

export type StobScenario = IOrdered & {
	__typename?: "StobScenario";
	actions: Array<StobAction>;
	actionsConnection: StobScenarioActionsConnection;
	conditions: Array<StobCondition>;
	conditionsConnection: StobScenarioConditionsConnection;
	order: Scalars["Int"];
};

export type StobScenarioActionsArgs = {
	options?: InputMaybe<StobActionOptions>;
	where?: InputMaybe<StobActionWhere>;
};

export type StobScenarioActionsConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<StobScenarioActionsConnectionSort>>;
	where?: InputMaybe<StobScenarioActionsConnectionWhere>;
};

export type StobScenarioConditionsArgs = {
	options?: InputMaybe<StobConditionOptions>;
	where?: InputMaybe<StobConditionWhere>;
};

export type StobScenarioConditionsConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<StobScenarioConditionsConnectionSort>>;
	where?: InputMaybe<StobScenarioConditionsConnectionWhere>;
};

export type StobScenarioActionsAggregateInput = {
	AND?: InputMaybe<Array<StobScenarioActionsAggregateInput>>;
	OR?: InputMaybe<Array<StobScenarioActionsAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<StobScenarioActionsNodeAggregationWhereInput>;
};

export type StobScenarioActionsConnectFieldInput = {
	connect?: InputMaybe<Array<StobActionConnectInput>>;
	where?: InputMaybe<StobActionConnectWhere>;
};

export type StobScenarioActionsConnection = {
	__typename?: "StobScenarioActionsConnection";
	edges: Array<StobScenarioActionsRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type StobScenarioActionsConnectionSort = {
	node?: InputMaybe<StobActionSort>;
};

export type StobScenarioActionsConnectionWhere = {
	AND?: InputMaybe<Array<StobScenarioActionsConnectionWhere>>;
	OR?: InputMaybe<Array<StobScenarioActionsConnectionWhere>>;
	node?: InputMaybe<StobActionWhere>;
	node_NOT?: InputMaybe<StobActionWhere>;
};

export type StobScenarioActionsCreateFieldInput = {
	node: StobActionCreateInput;
};

export type StobScenarioActionsDeleteFieldInput = {
	delete?: InputMaybe<StobActionDeleteInput>;
	where?: InputMaybe<StobScenarioActionsConnectionWhere>;
};

export type StobScenarioActionsDisconnectFieldInput = {
	disconnect?: InputMaybe<StobActionDisconnectInput>;
	where?: InputMaybe<StobScenarioActionsConnectionWhere>;
};

export type StobScenarioActionsFieldInput = {
	connect?: InputMaybe<Array<StobScenarioActionsConnectFieldInput>>;
	create?: InputMaybe<Array<StobScenarioActionsCreateFieldInput>>;
};

export type StobScenarioActionsNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<StobScenarioActionsNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<StobScenarioActionsNodeAggregationWhereInput>>;
	order_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	order_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	order_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	order_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	order_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	order_EQUAL?: InputMaybe<Scalars["Int"]>;
	order_GT?: InputMaybe<Scalars["Int"]>;
	order_GTE?: InputMaybe<Scalars["Int"]>;
	order_LT?: InputMaybe<Scalars["Int"]>;
	order_LTE?: InputMaybe<Scalars["Int"]>;
	order_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	order_MAX_GT?: InputMaybe<Scalars["Int"]>;
	order_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	order_MAX_LT?: InputMaybe<Scalars["Int"]>;
	order_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	order_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	order_MIN_GT?: InputMaybe<Scalars["Int"]>;
	order_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	order_MIN_LT?: InputMaybe<Scalars["Int"]>;
	order_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	timeframeEnd_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	timeframeEnd_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	timeframeEnd_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	timeframeEnd_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	timeframeEnd_EQUAL?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_GT?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_GTE?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_LT?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_LTE?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_MAX_GT?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_MAX_LT?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_MIN_GT?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_MIN_LT?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	timeframeStart_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	timeframeStart_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	timeframeStart_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	timeframeStart_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	timeframeStart_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	timeframeStart_EQUAL?: InputMaybe<Scalars["Int"]>;
	timeframeStart_GT?: InputMaybe<Scalars["Int"]>;
	timeframeStart_GTE?: InputMaybe<Scalars["Int"]>;
	timeframeStart_LT?: InputMaybe<Scalars["Int"]>;
	timeframeStart_LTE?: InputMaybe<Scalars["Int"]>;
	timeframeStart_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	timeframeStart_MAX_GT?: InputMaybe<Scalars["Int"]>;
	timeframeStart_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	timeframeStart_MAX_LT?: InputMaybe<Scalars["Int"]>;
	timeframeStart_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	timeframeStart_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	timeframeStart_MIN_GT?: InputMaybe<Scalars["Int"]>;
	timeframeStart_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	timeframeStart_MIN_LT?: InputMaybe<Scalars["Int"]>;
	timeframeStart_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	value_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	value_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	value_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	value_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	value_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	value_EQUAL?: InputMaybe<Scalars["Float"]>;
	value_GT?: InputMaybe<Scalars["Float"]>;
	value_GTE?: InputMaybe<Scalars["Float"]>;
	value_LT?: InputMaybe<Scalars["Float"]>;
	value_LTE?: InputMaybe<Scalars["Float"]>;
	value_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	value_MAX_GT?: InputMaybe<Scalars["Float"]>;
	value_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	value_MAX_LT?: InputMaybe<Scalars["Float"]>;
	value_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	value_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	value_MIN_GT?: InputMaybe<Scalars["Float"]>;
	value_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	value_MIN_LT?: InputMaybe<Scalars["Float"]>;
	value_MIN_LTE?: InputMaybe<Scalars["Float"]>;
};

export type StobScenarioActionsRelationship = {
	__typename?: "StobScenarioActionsRelationship";
	cursor: Scalars["String"];
	node: StobAction;
};

export type StobScenarioActionsUpdateConnectionInput = {
	node?: InputMaybe<StobActionUpdateInput>;
};

export type StobScenarioActionsUpdateFieldInput = {
	connect?: InputMaybe<Array<StobScenarioActionsConnectFieldInput>>;
	create?: InputMaybe<Array<StobScenarioActionsCreateFieldInput>>;
	delete?: InputMaybe<Array<StobScenarioActionsDeleteFieldInput>>;
	disconnect?: InputMaybe<Array<StobScenarioActionsDisconnectFieldInput>>;
	update?: InputMaybe<StobScenarioActionsUpdateConnectionInput>;
	where?: InputMaybe<StobScenarioActionsConnectionWhere>;
};

export type StobScenarioAggregateSelection = {
	__typename?: "StobScenarioAggregateSelection";
	count: Scalars["Int"];
	order: IntAggregateSelection;
};

export type StobScenarioConditionsAggregateInput = {
	AND?: InputMaybe<Array<StobScenarioConditionsAggregateInput>>;
	OR?: InputMaybe<Array<StobScenarioConditionsAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<StobScenarioConditionsNodeAggregationWhereInput>;
};

export type StobScenarioConditionsConnectFieldInput = {
	connect?: InputMaybe<Array<StobConditionConnectInput>>;
	where?: InputMaybe<StobConditionConnectWhere>;
};

export type StobScenarioConditionsConnection = {
	__typename?: "StobScenarioConditionsConnection";
	edges: Array<StobScenarioConditionsRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type StobScenarioConditionsConnectionSort = {
	node?: InputMaybe<StobConditionSort>;
};

export type StobScenarioConditionsConnectionWhere = {
	AND?: InputMaybe<Array<StobScenarioConditionsConnectionWhere>>;
	OR?: InputMaybe<Array<StobScenarioConditionsConnectionWhere>>;
	node?: InputMaybe<StobConditionWhere>;
	node_NOT?: InputMaybe<StobConditionWhere>;
};

export type StobScenarioConditionsCreateFieldInput = {
	node: StobConditionCreateInput;
};

export type StobScenarioConditionsDeleteFieldInput = {
	delete?: InputMaybe<StobConditionDeleteInput>;
	where?: InputMaybe<StobScenarioConditionsConnectionWhere>;
};

export type StobScenarioConditionsDisconnectFieldInput = {
	disconnect?: InputMaybe<StobConditionDisconnectInput>;
	where?: InputMaybe<StobScenarioConditionsConnectionWhere>;
};

export type StobScenarioConditionsFieldInput = {
	connect?: InputMaybe<Array<StobScenarioConditionsConnectFieldInput>>;
	create?: InputMaybe<Array<StobScenarioConditionsCreateFieldInput>>;
};

export type StobScenarioConditionsNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<StobScenarioConditionsNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<StobScenarioConditionsNodeAggregationWhereInput>>;
	order_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	order_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	order_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	order_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	order_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	order_EQUAL?: InputMaybe<Scalars["Int"]>;
	order_GT?: InputMaybe<Scalars["Int"]>;
	order_GTE?: InputMaybe<Scalars["Int"]>;
	order_LT?: InputMaybe<Scalars["Int"]>;
	order_LTE?: InputMaybe<Scalars["Int"]>;
	order_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	order_MAX_GT?: InputMaybe<Scalars["Int"]>;
	order_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	order_MAX_LT?: InputMaybe<Scalars["Int"]>;
	order_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	order_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	order_MIN_GT?: InputMaybe<Scalars["Int"]>;
	order_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	order_MIN_LT?: InputMaybe<Scalars["Int"]>;
	order_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	timeframeEnd_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	timeframeEnd_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	timeframeEnd_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	timeframeEnd_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	timeframeEnd_EQUAL?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_GT?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_GTE?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_LT?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_LTE?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_MAX_GT?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_MAX_LT?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_MIN_GT?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_MIN_LT?: InputMaybe<Scalars["Int"]>;
	timeframeEnd_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	timeframeStart_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	timeframeStart_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	timeframeStart_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	timeframeStart_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	timeframeStart_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	timeframeStart_EQUAL?: InputMaybe<Scalars["Int"]>;
	timeframeStart_GT?: InputMaybe<Scalars["Int"]>;
	timeframeStart_GTE?: InputMaybe<Scalars["Int"]>;
	timeframeStart_LT?: InputMaybe<Scalars["Int"]>;
	timeframeStart_LTE?: InputMaybe<Scalars["Int"]>;
	timeframeStart_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	timeframeStart_MAX_GT?: InputMaybe<Scalars["Int"]>;
	timeframeStart_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	timeframeStart_MAX_LT?: InputMaybe<Scalars["Int"]>;
	timeframeStart_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	timeframeStart_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	timeframeStart_MIN_GT?: InputMaybe<Scalars["Int"]>;
	timeframeStart_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	timeframeStart_MIN_LT?: InputMaybe<Scalars["Int"]>;
	timeframeStart_MIN_LTE?: InputMaybe<Scalars["Int"]>;
};

export type StobScenarioConditionsRelationship = {
	__typename?: "StobScenarioConditionsRelationship";
	cursor: Scalars["String"];
	node: StobCondition;
};

export type StobScenarioConditionsUpdateConnectionInput = {
	node?: InputMaybe<StobConditionUpdateInput>;
};

export type StobScenarioConditionsUpdateFieldInput = {
	connect?: InputMaybe<Array<StobScenarioConditionsConnectFieldInput>>;
	create?: InputMaybe<Array<StobScenarioConditionsCreateFieldInput>>;
	delete?: InputMaybe<Array<StobScenarioConditionsDeleteFieldInput>>;
	disconnect?: InputMaybe<Array<StobScenarioConditionsDisconnectFieldInput>>;
	update?: InputMaybe<StobScenarioConditionsUpdateConnectionInput>;
	where?: InputMaybe<StobScenarioConditionsConnectionWhere>;
};

export type StobScenarioConnectInput = {
	actions?: InputMaybe<Array<StobScenarioActionsConnectFieldInput>>;
	conditions?: InputMaybe<Array<StobScenarioConditionsConnectFieldInput>>;
};

export type StobScenarioConnectWhere = {
	node: StobScenarioWhere;
};

export type StobScenarioCreateInput = {
	actions?: InputMaybe<StobScenarioActionsFieldInput>;
	conditions?: InputMaybe<StobScenarioConditionsFieldInput>;
	order: Scalars["Int"];
};

export type StobScenarioDeleteInput = {
	actions?: InputMaybe<Array<StobScenarioActionsDeleteFieldInput>>;
	conditions?: InputMaybe<Array<StobScenarioConditionsDeleteFieldInput>>;
};

export type StobScenarioDisconnectInput = {
	actions?: InputMaybe<Array<StobScenarioActionsDisconnectFieldInput>>;
	conditions?: InputMaybe<Array<StobScenarioConditionsDisconnectFieldInput>>;
};

export type StobScenarioInput = {
	actions?: InputMaybe<Array<InputMaybe<StobActionInput>>>;
	conditions?: InputMaybe<Array<InputMaybe<StobConditionInput>>>;
	order: Scalars["Int"];
};

export type StobScenarioOptions = {
	limit?: InputMaybe<Scalars["Int"]>;
	offset?: InputMaybe<Scalars["Int"]>;
	/** Specify one or more StobScenarioSort objects to sort StobScenarios by. The sorts will be applied in the order in which they are arranged in the array. */
	sort?: InputMaybe<Array<InputMaybe<StobScenarioSort>>>;
};

/** Fields to sort StobScenarios by. The order in which sorts are applied is not guaranteed when specifying many fields in one StobScenarioSort object. */
export type StobScenarioSort = {
	order?: InputMaybe<SortDirection>;
};

export type StobScenarioUpdateInput = {
	actions?: InputMaybe<Array<StobScenarioActionsUpdateFieldInput>>;
	conditions?: InputMaybe<Array<StobScenarioConditionsUpdateFieldInput>>;
	order?: InputMaybe<Scalars["Int"]>;
};

export type StobScenarioWhere = {
	AND?: InputMaybe<Array<StobScenarioWhere>>;
	OR?: InputMaybe<Array<StobScenarioWhere>>;
	actions?: InputMaybe<StobActionWhere>;
	actionsAggregate?: InputMaybe<StobScenarioActionsAggregateInput>;
	actionsConnection?: InputMaybe<StobScenarioActionsConnectionWhere>;
	actionsConnection_NOT?: InputMaybe<StobScenarioActionsConnectionWhere>;
	actions_NOT?: InputMaybe<StobActionWhere>;
	conditions?: InputMaybe<StobConditionWhere>;
	conditionsAggregate?: InputMaybe<StobScenarioConditionsAggregateInput>;
	conditionsConnection?: InputMaybe<StobScenarioConditionsConnectionWhere>;
	conditionsConnection_NOT?: InputMaybe<StobScenarioConditionsConnectionWhere>;
	conditions_NOT?: InputMaybe<StobConditionWhere>;
	order?: InputMaybe<Scalars["Int"]>;
	order_GT?: InputMaybe<Scalars["Int"]>;
	order_GTE?: InputMaybe<Scalars["Int"]>;
	order_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	order_LT?: InputMaybe<Scalars["Int"]>;
	order_LTE?: InputMaybe<Scalars["Int"]>;
	order_NOT?: InputMaybe<Scalars["Int"]>;
	order_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
};

export type StobStatistics = {
	__typename?: "StobStatistics";
	crCases?: Maybe<Scalars["Int"]>;
	patientsEnrolled?: Maybe<Scalars["Int"]>;
	patientsWithAe3and4?: Maybe<Scalars["Int"]>;
	patientsWithCrPrSd?: Maybe<Scalars["Int"]>;
	payableAgreementAmount?: Maybe<Scalars["Int"]>;
	prCases?: Maybe<Scalars["Int"]>;
	refundableAgreementAmount?: Maybe<Scalars["Int"]>;
	sdCases?: Maybe<Scalars["Int"]>;
	totalAgreementAmount?: Maybe<Scalars["Int"]>;
	totalCases?: Maybe<Scalars["Int"]>;
	traesGrade3?: Maybe<Scalars["Int"]>;
	traesGrade4?: Maybe<Scalars["Int"]>;
	treatmentDiscontinuedAe?: Maybe<Scalars["Int"]>;
	treatmentDiscontinuedPatientDeceased?: Maybe<Scalars["Int"]>;
	treatmentDiscontinuedProgressiveDisease?: Maybe<Scalars["Int"]>;
	treatmentDurationMonths?: Maybe<Scalars["Int"]>;
};

export type StobStatisticsAggregateSelection = {
	__typename?: "StobStatisticsAggregateSelection";
	count: Scalars["Int"];
	crCases: IntAggregateSelection;
	patientsEnrolled: IntAggregateSelection;
	patientsWithAe3and4: IntAggregateSelection;
	patientsWithCrPrSd: IntAggregateSelection;
	payableAgreementAmount: IntAggregateSelection;
	prCases: IntAggregateSelection;
	refundableAgreementAmount: IntAggregateSelection;
	sdCases: IntAggregateSelection;
	totalAgreementAmount: IntAggregateSelection;
	totalCases: IntAggregateSelection;
	traesGrade3: IntAggregateSelection;
	traesGrade4: IntAggregateSelection;
	treatmentDiscontinuedAe: IntAggregateSelection;
	treatmentDiscontinuedPatientDeceased: IntAggregateSelection;
	treatmentDiscontinuedProgressiveDisease: IntAggregateSelection;
	treatmentDurationMonths: IntAggregateSelection;
};

export type StobStatisticsConnectWhere = {
	node: StobStatisticsWhere;
};

export type StobStatisticsCreateInput = {
	crCases?: InputMaybe<Scalars["Int"]>;
	patientsEnrolled?: InputMaybe<Scalars["Int"]>;
	patientsWithAe3and4?: InputMaybe<Scalars["Int"]>;
	patientsWithCrPrSd?: InputMaybe<Scalars["Int"]>;
	payableAgreementAmount?: InputMaybe<Scalars["Int"]>;
	prCases?: InputMaybe<Scalars["Int"]>;
	refundableAgreementAmount?: InputMaybe<Scalars["Int"]>;
	sdCases?: InputMaybe<Scalars["Int"]>;
	totalAgreementAmount?: InputMaybe<Scalars["Int"]>;
	totalCases?: InputMaybe<Scalars["Int"]>;
	traesGrade3?: InputMaybe<Scalars["Int"]>;
	traesGrade4?: InputMaybe<Scalars["Int"]>;
	treatmentDiscontinuedAe?: InputMaybe<Scalars["Int"]>;
	treatmentDiscontinuedPatientDeceased?: InputMaybe<Scalars["Int"]>;
	treatmentDiscontinuedProgressiveDisease?: InputMaybe<Scalars["Int"]>;
	treatmentDurationMonths?: InputMaybe<Scalars["Int"]>;
};

export type StobStatisticsOptions = {
	limit?: InputMaybe<Scalars["Int"]>;
	offset?: InputMaybe<Scalars["Int"]>;
	/** Specify one or more StobStatisticsSort objects to sort StobStatistics by. The sorts will be applied in the order in which they are arranged in the array. */
	sort?: InputMaybe<Array<InputMaybe<StobStatisticsSort>>>;
};

/** Fields to sort StobStatistics by. The order in which sorts are applied is not guaranteed when specifying many fields in one StobStatisticsSort object. */
export type StobStatisticsSort = {
	crCases?: InputMaybe<SortDirection>;
	patientsEnrolled?: InputMaybe<SortDirection>;
	patientsWithAe3and4?: InputMaybe<SortDirection>;
	patientsWithCrPrSd?: InputMaybe<SortDirection>;
	payableAgreementAmount?: InputMaybe<SortDirection>;
	prCases?: InputMaybe<SortDirection>;
	refundableAgreementAmount?: InputMaybe<SortDirection>;
	sdCases?: InputMaybe<SortDirection>;
	totalAgreementAmount?: InputMaybe<SortDirection>;
	totalCases?: InputMaybe<SortDirection>;
	traesGrade3?: InputMaybe<SortDirection>;
	traesGrade4?: InputMaybe<SortDirection>;
	treatmentDiscontinuedAe?: InputMaybe<SortDirection>;
	treatmentDiscontinuedPatientDeceased?: InputMaybe<SortDirection>;
	treatmentDiscontinuedProgressiveDisease?: InputMaybe<SortDirection>;
	treatmentDurationMonths?: InputMaybe<SortDirection>;
};

export type StobStatisticsUpdateInput = {
	crCases?: InputMaybe<Scalars["Int"]>;
	patientsEnrolled?: InputMaybe<Scalars["Int"]>;
	patientsWithAe3and4?: InputMaybe<Scalars["Int"]>;
	patientsWithCrPrSd?: InputMaybe<Scalars["Int"]>;
	payableAgreementAmount?: InputMaybe<Scalars["Int"]>;
	prCases?: InputMaybe<Scalars["Int"]>;
	refundableAgreementAmount?: InputMaybe<Scalars["Int"]>;
	sdCases?: InputMaybe<Scalars["Int"]>;
	totalAgreementAmount?: InputMaybe<Scalars["Int"]>;
	totalCases?: InputMaybe<Scalars["Int"]>;
	traesGrade3?: InputMaybe<Scalars["Int"]>;
	traesGrade4?: InputMaybe<Scalars["Int"]>;
	treatmentDiscontinuedAe?: InputMaybe<Scalars["Int"]>;
	treatmentDiscontinuedPatientDeceased?: InputMaybe<Scalars["Int"]>;
	treatmentDiscontinuedProgressiveDisease?: InputMaybe<Scalars["Int"]>;
	treatmentDurationMonths?: InputMaybe<Scalars["Int"]>;
};

export type StobStatisticsWhere = {
	AND?: InputMaybe<Array<StobStatisticsWhere>>;
	OR?: InputMaybe<Array<StobStatisticsWhere>>;
	crCases?: InputMaybe<Scalars["Int"]>;
	crCases_GT?: InputMaybe<Scalars["Int"]>;
	crCases_GTE?: InputMaybe<Scalars["Int"]>;
	crCases_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	crCases_LT?: InputMaybe<Scalars["Int"]>;
	crCases_LTE?: InputMaybe<Scalars["Int"]>;
	crCases_NOT?: InputMaybe<Scalars["Int"]>;
	crCases_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	patientsEnrolled?: InputMaybe<Scalars["Int"]>;
	patientsEnrolled_GT?: InputMaybe<Scalars["Int"]>;
	patientsEnrolled_GTE?: InputMaybe<Scalars["Int"]>;
	patientsEnrolled_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	patientsEnrolled_LT?: InputMaybe<Scalars["Int"]>;
	patientsEnrolled_LTE?: InputMaybe<Scalars["Int"]>;
	patientsEnrolled_NOT?: InputMaybe<Scalars["Int"]>;
	patientsEnrolled_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	patientsWithAe3and4?: InputMaybe<Scalars["Int"]>;
	patientsWithAe3and4_GT?: InputMaybe<Scalars["Int"]>;
	patientsWithAe3and4_GTE?: InputMaybe<Scalars["Int"]>;
	patientsWithAe3and4_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	patientsWithAe3and4_LT?: InputMaybe<Scalars["Int"]>;
	patientsWithAe3and4_LTE?: InputMaybe<Scalars["Int"]>;
	patientsWithAe3and4_NOT?: InputMaybe<Scalars["Int"]>;
	patientsWithAe3and4_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	patientsWithCrPrSd?: InputMaybe<Scalars["Int"]>;
	patientsWithCrPrSd_GT?: InputMaybe<Scalars["Int"]>;
	patientsWithCrPrSd_GTE?: InputMaybe<Scalars["Int"]>;
	patientsWithCrPrSd_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	patientsWithCrPrSd_LT?: InputMaybe<Scalars["Int"]>;
	patientsWithCrPrSd_LTE?: InputMaybe<Scalars["Int"]>;
	patientsWithCrPrSd_NOT?: InputMaybe<Scalars["Int"]>;
	patientsWithCrPrSd_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	payableAgreementAmount?: InputMaybe<Scalars["Int"]>;
	payableAgreementAmount_GT?: InputMaybe<Scalars["Int"]>;
	payableAgreementAmount_GTE?: InputMaybe<Scalars["Int"]>;
	payableAgreementAmount_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	payableAgreementAmount_LT?: InputMaybe<Scalars["Int"]>;
	payableAgreementAmount_LTE?: InputMaybe<Scalars["Int"]>;
	payableAgreementAmount_NOT?: InputMaybe<Scalars["Int"]>;
	payableAgreementAmount_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	prCases?: InputMaybe<Scalars["Int"]>;
	prCases_GT?: InputMaybe<Scalars["Int"]>;
	prCases_GTE?: InputMaybe<Scalars["Int"]>;
	prCases_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	prCases_LT?: InputMaybe<Scalars["Int"]>;
	prCases_LTE?: InputMaybe<Scalars["Int"]>;
	prCases_NOT?: InputMaybe<Scalars["Int"]>;
	prCases_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	refundableAgreementAmount?: InputMaybe<Scalars["Int"]>;
	refundableAgreementAmount_GT?: InputMaybe<Scalars["Int"]>;
	refundableAgreementAmount_GTE?: InputMaybe<Scalars["Int"]>;
	refundableAgreementAmount_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	refundableAgreementAmount_LT?: InputMaybe<Scalars["Int"]>;
	refundableAgreementAmount_LTE?: InputMaybe<Scalars["Int"]>;
	refundableAgreementAmount_NOT?: InputMaybe<Scalars["Int"]>;
	refundableAgreementAmount_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	sdCases?: InputMaybe<Scalars["Int"]>;
	sdCases_GT?: InputMaybe<Scalars["Int"]>;
	sdCases_GTE?: InputMaybe<Scalars["Int"]>;
	sdCases_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	sdCases_LT?: InputMaybe<Scalars["Int"]>;
	sdCases_LTE?: InputMaybe<Scalars["Int"]>;
	sdCases_NOT?: InputMaybe<Scalars["Int"]>;
	sdCases_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	totalAgreementAmount?: InputMaybe<Scalars["Int"]>;
	totalAgreementAmount_GT?: InputMaybe<Scalars["Int"]>;
	totalAgreementAmount_GTE?: InputMaybe<Scalars["Int"]>;
	totalAgreementAmount_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	totalAgreementAmount_LT?: InputMaybe<Scalars["Int"]>;
	totalAgreementAmount_LTE?: InputMaybe<Scalars["Int"]>;
	totalAgreementAmount_NOT?: InputMaybe<Scalars["Int"]>;
	totalAgreementAmount_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	totalCases?: InputMaybe<Scalars["Int"]>;
	totalCases_GT?: InputMaybe<Scalars["Int"]>;
	totalCases_GTE?: InputMaybe<Scalars["Int"]>;
	totalCases_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	totalCases_LT?: InputMaybe<Scalars["Int"]>;
	totalCases_LTE?: InputMaybe<Scalars["Int"]>;
	totalCases_NOT?: InputMaybe<Scalars["Int"]>;
	totalCases_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	traesGrade3?: InputMaybe<Scalars["Int"]>;
	traesGrade3_GT?: InputMaybe<Scalars["Int"]>;
	traesGrade3_GTE?: InputMaybe<Scalars["Int"]>;
	traesGrade3_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	traesGrade3_LT?: InputMaybe<Scalars["Int"]>;
	traesGrade3_LTE?: InputMaybe<Scalars["Int"]>;
	traesGrade3_NOT?: InputMaybe<Scalars["Int"]>;
	traesGrade3_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	traesGrade4?: InputMaybe<Scalars["Int"]>;
	traesGrade4_GT?: InputMaybe<Scalars["Int"]>;
	traesGrade4_GTE?: InputMaybe<Scalars["Int"]>;
	traesGrade4_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	traesGrade4_LT?: InputMaybe<Scalars["Int"]>;
	traesGrade4_LTE?: InputMaybe<Scalars["Int"]>;
	traesGrade4_NOT?: InputMaybe<Scalars["Int"]>;
	traesGrade4_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	treatmentDiscontinuedAe?: InputMaybe<Scalars["Int"]>;
	treatmentDiscontinuedAe_GT?: InputMaybe<Scalars["Int"]>;
	treatmentDiscontinuedAe_GTE?: InputMaybe<Scalars["Int"]>;
	treatmentDiscontinuedAe_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	treatmentDiscontinuedAe_LT?: InputMaybe<Scalars["Int"]>;
	treatmentDiscontinuedAe_LTE?: InputMaybe<Scalars["Int"]>;
	treatmentDiscontinuedAe_NOT?: InputMaybe<Scalars["Int"]>;
	treatmentDiscontinuedAe_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	treatmentDiscontinuedPatientDeceased?: InputMaybe<Scalars["Int"]>;
	treatmentDiscontinuedPatientDeceased_GT?: InputMaybe<Scalars["Int"]>;
	treatmentDiscontinuedPatientDeceased_GTE?: InputMaybe<Scalars["Int"]>;
	treatmentDiscontinuedPatientDeceased_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	treatmentDiscontinuedPatientDeceased_LT?: InputMaybe<Scalars["Int"]>;
	treatmentDiscontinuedPatientDeceased_LTE?: InputMaybe<Scalars["Int"]>;
	treatmentDiscontinuedPatientDeceased_NOT?: InputMaybe<Scalars["Int"]>;
	treatmentDiscontinuedPatientDeceased_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	treatmentDiscontinuedProgressiveDisease?: InputMaybe<Scalars["Int"]>;
	treatmentDiscontinuedProgressiveDisease_GT?: InputMaybe<Scalars["Int"]>;
	treatmentDiscontinuedProgressiveDisease_GTE?: InputMaybe<Scalars["Int"]>;
	treatmentDiscontinuedProgressiveDisease_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	treatmentDiscontinuedProgressiveDisease_LT?: InputMaybe<Scalars["Int"]>;
	treatmentDiscontinuedProgressiveDisease_LTE?: InputMaybe<Scalars["Int"]>;
	treatmentDiscontinuedProgressiveDisease_NOT?: InputMaybe<Scalars["Int"]>;
	treatmentDiscontinuedProgressiveDisease_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	treatmentDurationMonths?: InputMaybe<Scalars["Int"]>;
	treatmentDurationMonths_GT?: InputMaybe<Scalars["Int"]>;
	treatmentDurationMonths_GTE?: InputMaybe<Scalars["Int"]>;
	treatmentDurationMonths_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	treatmentDurationMonths_LT?: InputMaybe<Scalars["Int"]>;
	treatmentDurationMonths_LTE?: InputMaybe<Scalars["Int"]>;
	treatmentDurationMonths_NOT?: InputMaybe<Scalars["Int"]>;
	treatmentDurationMonths_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
};

export enum StobTherapyDecision {
	RatingBApproved = "RATING_B_APPROVED",
	RatingCTrial = "RATING_C_TRIAL",
}

export enum StobTimeframeRelation {
	After = "AFTER",
	Within = "WITHIN",
}

export enum StobTimeframeStartingPoint {
	CoverageStartDate = "COVERAGE_START_DATE",
	TreatmentStartDate = "TREATMENT_START_DATE",
}

export type StobTreatmentPriceInput = {
	price: Scalars["Float"];
	treatmentCode: Scalars["String"];
};

export type StringAggregateSelection = {
	__typename?: "StringAggregateSelection";
	longest: Scalars["String"];
	shortest: Scalars["String"];
};

export type Subscription = {
	__typename?: "Subscription";
	agreementCreated: Array<Scalars["String"]>;
	agreementRun: Scalars["String"];
	caseCreated: Array<Scalars["String"]>;
	documentCreated: Array<Scalars["String"]>;
	formCreated: Array<Scalars["String"]>;
	recordUpdated: Array<Scalars["String"]>;
	refundCreated: Array<Maybe<Scalars["String"]>>;
	refundThreadUpdated: Array<Scalars["String"]>;
	taskUpdated: Array<Scalars["String"]>;
};

export type SummaryNotificationDue = {
	dueDate: Scalars["Date"];
	message: Scalars["String"];
	timeStamp: Scalars["Float"];
};

export type SummaryNotificationDueCreateInput = {
	dueDate: Scalars["Date"];
	message: Scalars["String"];
	timeStamp: Scalars["Float"];
};

export type SummaryNotificationDueSort = {
	dueDate?: InputMaybe<SortDirection>;
	message?: InputMaybe<SortDirection>;
	timeStamp?: InputMaybe<SortDirection>;
};

export type SummaryNotificationDueUpdateInput = {
	dueDate?: InputMaybe<Scalars["Date"]>;
	message?: InputMaybe<Scalars["String"]>;
	timeStamp?: InputMaybe<Scalars["Float"]>;
};

export type SummaryNotificationDueWhere = {
	AND?: InputMaybe<Array<SummaryNotificationDueWhere>>;
	OR?: InputMaybe<Array<SummaryNotificationDueWhere>>;
	dueDate?: InputMaybe<Scalars["Date"]>;
	dueDate_GT?: InputMaybe<Scalars["Date"]>;
	dueDate_GTE?: InputMaybe<Scalars["Date"]>;
	dueDate_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
	dueDate_LT?: InputMaybe<Scalars["Date"]>;
	dueDate_LTE?: InputMaybe<Scalars["Date"]>;
	dueDate_NOT?: InputMaybe<Scalars["Date"]>;
	dueDate_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
	message?: InputMaybe<Scalars["String"]>;
	message_CONTAINS?: InputMaybe<Scalars["String"]>;
	message_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	message_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	message_MATCHES?: InputMaybe<Scalars["String"]>;
	message_NOT?: InputMaybe<Scalars["String"]>;
	message_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	message_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	message_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	message_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	message_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	timeStamp?: InputMaybe<Scalars["Float"]>;
	timeStamp_GT?: InputMaybe<Scalars["Float"]>;
	timeStamp_GTE?: InputMaybe<Scalars["Float"]>;
	timeStamp_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	timeStamp_LT?: InputMaybe<Scalars["Float"]>;
	timeStamp_LTE?: InputMaybe<Scalars["Float"]>;
	timeStamp_NOT?: InputMaybe<Scalars["Float"]>;
	timeStamp_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
};

export type Task = {
	__typename?: "Task";
	agreement?: Maybe<Agreement>;
	agreementConnection: TaskAgreementConnection;
	case?: Maybe<Case>;
	caseConnection: TaskCaseConnection;
	document?: Maybe<Document>;
	documentConnection: TaskDocumentConnection;
	id: Scalars["ID"];
	message?: Maybe<Message>;
	messageConnection: TaskMessageConnection;
	tenantIds: Array<Scalars["String"]>;
	timeStamp: Scalars["Float"];
	triggerEventId: Scalars["Int"];
	usersRelationship: Array<User>;
	usersRelationshipConnection: TaskUsersRelationshipConnection;
};

export type TaskAgreementArgs = {
	options?: InputMaybe<AgreementOptions>;
	where?: InputMaybe<AgreementWhere>;
};

export type TaskAgreementConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<TaskAgreementConnectionSort>>;
	where?: InputMaybe<TaskAgreementConnectionWhere>;
};

export type TaskCaseArgs = {
	options?: InputMaybe<CaseOptions>;
	where?: InputMaybe<CaseWhere>;
};

export type TaskCaseConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<TaskCaseConnectionSort>>;
	where?: InputMaybe<TaskCaseConnectionWhere>;
};

export type TaskDocumentArgs = {
	options?: InputMaybe<DocumentOptions>;
	where?: InputMaybe<DocumentWhere>;
};

export type TaskDocumentConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<TaskDocumentConnectionSort>>;
	where?: InputMaybe<TaskDocumentConnectionWhere>;
};

export type TaskMessageArgs = {
	options?: InputMaybe<MessageOptions>;
	where?: InputMaybe<MessageWhere>;
};

export type TaskMessageConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<TaskMessageConnectionSort>>;
	where?: InputMaybe<TaskMessageConnectionWhere>;
};

export type TaskUsersRelationshipArgs = {
	options?: InputMaybe<UserOptions>;
	where?: InputMaybe<UserWhere>;
};

export type TaskUsersRelationshipConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<TaskUsersRelationshipConnectionSort>>;
	where?: InputMaybe<TaskUsersRelationshipConnectionWhere>;
};

export type TaskAggregateSelection = {
	__typename?: "TaskAggregateSelection";
	count: Scalars["Int"];
	id: IdAggregateSelection;
	timeStamp: FloatAggregateSelection;
	triggerEventId: IntAggregateSelection;
};

export type TaskAgreementAggregateInput = {
	AND?: InputMaybe<Array<TaskAgreementAggregateInput>>;
	OR?: InputMaybe<Array<TaskAgreementAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<TaskAgreementNodeAggregationWhereInput>;
};

export type TaskAgreementConnectFieldInput = {
	connect?: InputMaybe<AgreementConnectInput>;
	where?: InputMaybe<AgreementConnectWhere>;
};

export type TaskAgreementConnection = {
	__typename?: "TaskAgreementConnection";
	edges: Array<TaskAgreementRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type TaskAgreementConnectionSort = {
	node?: InputMaybe<AgreementSort>;
};

export type TaskAgreementConnectionWhere = {
	AND?: InputMaybe<Array<TaskAgreementConnectionWhere>>;
	OR?: InputMaybe<Array<TaskAgreementConnectionWhere>>;
	node?: InputMaybe<AgreementWhere>;
	node_NOT?: InputMaybe<AgreementWhere>;
};

export type TaskAgreementCreateFieldInput = {
	node: AgreementCreateInput;
};

export type TaskAgreementDeleteFieldInput = {
	delete?: InputMaybe<AgreementDeleteInput>;
	where?: InputMaybe<TaskAgreementConnectionWhere>;
};

export type TaskAgreementDisconnectFieldInput = {
	disconnect?: InputMaybe<AgreementDisconnectInput>;
	where?: InputMaybe<TaskAgreementConnectionWhere>;
};

export type TaskAgreementFieldInput = {
	connect?: InputMaybe<TaskAgreementConnectFieldInput>;
	create?: InputMaybe<TaskAgreementCreateFieldInput>;
};

export type TaskAgreementNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<TaskAgreementNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<TaskAgreementNodeAggregationWhereInput>>;
	description_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	description_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	description_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	description_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	description_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	description_EQUAL?: InputMaybe<Scalars["String"]>;
	description_GT?: InputMaybe<Scalars["Int"]>;
	description_GTE?: InputMaybe<Scalars["Int"]>;
	description_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	description_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	description_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	description_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	description_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	description_LT?: InputMaybe<Scalars["Int"]>;
	description_LTE?: InputMaybe<Scalars["Int"]>;
	description_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	description_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	description_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	description_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	description_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	formattedAmount_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	formattedAmount_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	formattedAmount_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	formattedAmount_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	formattedAmount_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	formattedAmount_EQUAL?: InputMaybe<Scalars["String"]>;
	formattedAmount_GT?: InputMaybe<Scalars["Int"]>;
	formattedAmount_GTE?: InputMaybe<Scalars["Int"]>;
	formattedAmount_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedAmount_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedAmount_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedAmount_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedAmount_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	formattedAmount_LT?: InputMaybe<Scalars["Int"]>;
	formattedAmount_LTE?: InputMaybe<Scalars["Int"]>;
	formattedAmount_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedAmount_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedAmount_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedAmount_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedAmount_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	formattedCounterparties_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	formattedCounterparties_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	formattedCounterparties_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	formattedCounterparties_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	formattedCounterparties_EQUAL?: InputMaybe<Scalars["String"]>;
	formattedCounterparties_GT?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_GTE?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_LT?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_LTE?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	formattedProducts_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	formattedProducts_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	formattedProducts_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	formattedProducts_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	formattedProducts_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	formattedProducts_EQUAL?: InputMaybe<Scalars["String"]>;
	formattedProducts_GT?: InputMaybe<Scalars["Int"]>;
	formattedProducts_GTE?: InputMaybe<Scalars["Int"]>;
	formattedProducts_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedProducts_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedProducts_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedProducts_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedProducts_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	formattedProducts_LT?: InputMaybe<Scalars["Int"]>;
	formattedProducts_LTE?: InputMaybe<Scalars["Int"]>;
	formattedProducts_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedProducts_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedProducts_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedProducts_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedProducts_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	formattedTags_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	formattedTags_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	formattedTags_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	formattedTags_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	formattedTags_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	formattedTags_EQUAL?: InputMaybe<Scalars["String"]>;
	formattedTags_GT?: InputMaybe<Scalars["Int"]>;
	formattedTags_GTE?: InputMaybe<Scalars["Int"]>;
	formattedTags_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedTags_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedTags_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedTags_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedTags_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	formattedTags_LT?: InputMaybe<Scalars["Int"]>;
	formattedTags_LTE?: InputMaybe<Scalars["Int"]>;
	formattedTags_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedTags_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedTags_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedTags_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedTags_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	formattedValidityPeriod_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	formattedValidityPeriod_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	formattedValidityPeriod_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	formattedValidityPeriod_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	formattedValidityPeriod_EQUAL?: InputMaybe<Scalars["String"]>;
	formattedValidityPeriod_GT?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_GTE?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_LT?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_LTE?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	initialVersionId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	initialVersionId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	initialVersionId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	initialVersionId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	initialVersionId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	initialVersionId_EQUAL?: InputMaybe<Scalars["String"]>;
	initialVersionId_GT?: InputMaybe<Scalars["Int"]>;
	initialVersionId_GTE?: InputMaybe<Scalars["Int"]>;
	initialVersionId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	initialVersionId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	initialVersionId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	initialVersionId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	initialVersionId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	initialVersionId_LT?: InputMaybe<Scalars["Int"]>;
	initialVersionId_LTE?: InputMaybe<Scalars["Int"]>;
	initialVersionId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	initialVersionId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	initialVersionId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	initialVersionId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	initialVersionId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	name_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	name_EQUAL?: InputMaybe<Scalars["String"]>;
	name_GT?: InputMaybe<Scalars["Int"]>;
	name_GTE?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	name_LT?: InputMaybe<Scalars["Int"]>;
	name_LTE?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	totalAmount_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	totalAmount_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	totalAmount_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	totalAmount_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	totalAmount_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	totalAmount_EQUAL?: InputMaybe<Scalars["Float"]>;
	totalAmount_GT?: InputMaybe<Scalars["Float"]>;
	totalAmount_GTE?: InputMaybe<Scalars["Float"]>;
	totalAmount_LT?: InputMaybe<Scalars["Float"]>;
	totalAmount_LTE?: InputMaybe<Scalars["Float"]>;
	totalAmount_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	totalAmount_MAX_GT?: InputMaybe<Scalars["Float"]>;
	totalAmount_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	totalAmount_MAX_LT?: InputMaybe<Scalars["Float"]>;
	totalAmount_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	totalAmount_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	totalAmount_MIN_GT?: InputMaybe<Scalars["Float"]>;
	totalAmount_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	totalAmount_MIN_LT?: InputMaybe<Scalars["Float"]>;
	totalAmount_MIN_LTE?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	unlimited_EQUAL?: InputMaybe<Scalars["Int"]>;
	unlimited_GT?: InputMaybe<Scalars["Int"]>;
	unlimited_GTE?: InputMaybe<Scalars["Int"]>;
	unlimited_LT?: InputMaybe<Scalars["Int"]>;
	unlimited_LTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_GT?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_LT?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_GT?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_LT?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_LTE?: InputMaybe<Scalars["Int"]>;
};

export type TaskAgreementRelationship = {
	__typename?: "TaskAgreementRelationship";
	cursor: Scalars["String"];
	node: Agreement;
};

export type TaskAgreementUpdateConnectionInput = {
	node?: InputMaybe<AgreementUpdateInput>;
};

export type TaskAgreementUpdateFieldInput = {
	connect?: InputMaybe<TaskAgreementConnectFieldInput>;
	create?: InputMaybe<TaskAgreementCreateFieldInput>;
	delete?: InputMaybe<TaskAgreementDeleteFieldInput>;
	disconnect?: InputMaybe<TaskAgreementDisconnectFieldInput>;
	update?: InputMaybe<TaskAgreementUpdateConnectionInput>;
	where?: InputMaybe<TaskAgreementConnectionWhere>;
};

export type TaskCaseAggregateInput = {
	AND?: InputMaybe<Array<TaskCaseAggregateInput>>;
	OR?: InputMaybe<Array<TaskCaseAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<TaskCaseNodeAggregationWhereInput>;
};

export type TaskCaseConnectFieldInput = {
	connect?: InputMaybe<CaseConnectInput>;
	edge?: InputMaybe<CaseTaskRelationshipCreateInput>;
	where?: InputMaybe<CaseConnectWhere>;
};

export type TaskCaseConnection = {
	__typename?: "TaskCaseConnection";
	edges: Array<TaskCaseRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type TaskCaseConnectionSort = {
	edge?: InputMaybe<CaseTaskRelationshipSort>;
	node?: InputMaybe<CaseSort>;
};

export type TaskCaseConnectionWhere = {
	AND?: InputMaybe<Array<TaskCaseConnectionWhere>>;
	OR?: InputMaybe<Array<TaskCaseConnectionWhere>>;
	edge?: InputMaybe<CaseTaskRelationshipWhere>;
	edge_NOT?: InputMaybe<CaseTaskRelationshipWhere>;
	node?: InputMaybe<CaseWhere>;
	node_NOT?: InputMaybe<CaseWhere>;
};

export type TaskCaseCreateFieldInput = {
	edge?: InputMaybe<CaseTaskRelationshipCreateInput>;
	node: CaseCreateInput;
};

export type TaskCaseDeleteFieldInput = {
	delete?: InputMaybe<CaseDeleteInput>;
	where?: InputMaybe<TaskCaseConnectionWhere>;
};

export type TaskCaseDisconnectFieldInput = {
	disconnect?: InputMaybe<CaseDisconnectInput>;
	where?: InputMaybe<TaskCaseConnectionWhere>;
};

export type TaskCaseFieldInput = {
	connect?: InputMaybe<TaskCaseConnectFieldInput>;
	create?: InputMaybe<TaskCaseCreateFieldInput>;
};

export type TaskCaseNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<TaskCaseNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<TaskCaseNodeAggregationWhereInput>>;
	actualAgreementId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	actualAgreementId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	actualAgreementId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	actualAgreementId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	actualAgreementId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	actualAgreementId_EQUAL?: InputMaybe<Scalars["String"]>;
	actualAgreementId_GT?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_GTE?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_LT?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_LTE?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	actualAgreementId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	agreementName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	agreementName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	agreementName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	agreementName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	agreementName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	agreementName_EQUAL?: InputMaybe<Scalars["String"]>;
	agreementName_GT?: InputMaybe<Scalars["Int"]>;
	agreementName_GTE?: InputMaybe<Scalars["Int"]>;
	agreementName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	agreementName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	agreementName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	agreementName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	agreementName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	agreementName_LT?: InputMaybe<Scalars["Int"]>;
	agreementName_LTE?: InputMaybe<Scalars["Int"]>;
	agreementName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	agreementName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	agreementName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	agreementName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	agreementName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	patientInitials_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	patientInitials_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	patientInitials_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	patientInitials_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	patientInitials_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	patientInitials_EQUAL?: InputMaybe<Scalars["String"]>;
	patientInitials_GT?: InputMaybe<Scalars["Int"]>;
	patientInitials_GTE?: InputMaybe<Scalars["Int"]>;
	patientInitials_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	patientInitials_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	patientInitials_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	patientInitials_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	patientInitials_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	patientInitials_LT?: InputMaybe<Scalars["Int"]>;
	patientInitials_LTE?: InputMaybe<Scalars["Int"]>;
	patientInitials_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	patientInitials_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	patientInitials_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	patientInitials_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	patientInitials_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	patientInsuranceId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	patientInsuranceId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	patientInsuranceId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	patientInsuranceId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	patientInsuranceId_EQUAL?: InputMaybe<Scalars["String"]>;
	patientInsuranceId_GT?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_GTE?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_LT?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_LTE?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	patientInsuranceId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationBandName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	preparationBandName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	preparationBandName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	preparationBandName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	preparationBandName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	preparationBandName_EQUAL?: InputMaybe<Scalars["String"]>;
	preparationBandName_GT?: InputMaybe<Scalars["Int"]>;
	preparationBandName_GTE?: InputMaybe<Scalars["Int"]>;
	preparationBandName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationBandName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationBandName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationBandName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationBandName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationBandName_LT?: InputMaybe<Scalars["Int"]>;
	preparationBandName_LTE?: InputMaybe<Scalars["Int"]>;
	preparationBandName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationBandName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationBandName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationBandName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationBandName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	preparationGenericName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	preparationGenericName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	preparationGenericName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	preparationGenericName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	preparationGenericName_EQUAL?: InputMaybe<Scalars["String"]>;
	preparationGenericName_GT?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_GTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_LT?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_LTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationGenericName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	sourceTenantId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	sourceTenantId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	sourceTenantId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	sourceTenantId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	sourceTenantId_EQUAL?: InputMaybe<Scalars["String"]>;
	sourceTenantId_GT?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_GTE?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_LT?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_LTE?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	sourceTenantId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	submissionDate_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_GT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_GTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_LT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_LTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	submissionDate_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	totalAmount_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	totalAmount_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	totalAmount_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	totalAmount_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	totalAmount_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	totalAmount_EQUAL?: InputMaybe<Scalars["Float"]>;
	totalAmount_GT?: InputMaybe<Scalars["Float"]>;
	totalAmount_GTE?: InputMaybe<Scalars["Float"]>;
	totalAmount_LT?: InputMaybe<Scalars["Float"]>;
	totalAmount_LTE?: InputMaybe<Scalars["Float"]>;
	totalAmount_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	totalAmount_MAX_GT?: InputMaybe<Scalars["Float"]>;
	totalAmount_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	totalAmount_MAX_LT?: InputMaybe<Scalars["Float"]>;
	totalAmount_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	totalAmount_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	totalAmount_MIN_GT?: InputMaybe<Scalars["Float"]>;
	totalAmount_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	totalAmount_MIN_LT?: InputMaybe<Scalars["Float"]>;
	totalAmount_MIN_LTE?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	unlimited_EQUAL?: InputMaybe<Scalars["Int"]>;
	unlimited_GT?: InputMaybe<Scalars["Int"]>;
	unlimited_GTE?: InputMaybe<Scalars["Int"]>;
	unlimited_LT?: InputMaybe<Scalars["Int"]>;
	unlimited_LTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_GT?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_LT?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_GT?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_LT?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_LTE?: InputMaybe<Scalars["Int"]>;
};

export type TaskCaseRelationship = CaseTaskRelationship & {
	__typename?: "TaskCaseRelationship";
	cursor: Scalars["String"];
	formDueOrOverdue?: Maybe<FormType>;
	node: Case;
};

export type TaskCaseUpdateConnectionInput = {
	edge?: InputMaybe<CaseTaskRelationshipUpdateInput>;
	node?: InputMaybe<CaseUpdateInput>;
};

export type TaskCaseUpdateFieldInput = {
	connect?: InputMaybe<TaskCaseConnectFieldInput>;
	create?: InputMaybe<TaskCaseCreateFieldInput>;
	delete?: InputMaybe<TaskCaseDeleteFieldInput>;
	disconnect?: InputMaybe<TaskCaseDisconnectFieldInput>;
	update?: InputMaybe<TaskCaseUpdateConnectionInput>;
	where?: InputMaybe<TaskCaseConnectionWhere>;
};

export type TaskConnectInput = {
	agreement?: InputMaybe<TaskAgreementConnectFieldInput>;
	case?: InputMaybe<TaskCaseConnectFieldInput>;
	document?: InputMaybe<TaskDocumentConnectFieldInput>;
	message?: InputMaybe<TaskMessageConnectFieldInput>;
	usersRelationship?: InputMaybe<Array<TaskUsersRelationshipConnectFieldInput>>;
};

export type TaskConnectWhere = {
	node: TaskWhere;
};

export type TaskCreateInput = {
	agreement?: InputMaybe<TaskAgreementFieldInput>;
	case?: InputMaybe<TaskCaseFieldInput>;
	document?: InputMaybe<TaskDocumentFieldInput>;
	id: Scalars["ID"];
	message?: InputMaybe<TaskMessageFieldInput>;
	tenantIds: Array<Scalars["String"]>;
	timeStamp: Scalars["Float"];
	triggerEventId: Scalars["Int"];
	usersRelationship?: InputMaybe<TaskUsersRelationshipFieldInput>;
};

export type TaskDeleteInput = {
	agreement?: InputMaybe<TaskAgreementDeleteFieldInput>;
	case?: InputMaybe<TaskCaseDeleteFieldInput>;
	document?: InputMaybe<TaskDocumentDeleteFieldInput>;
	message?: InputMaybe<TaskMessageDeleteFieldInput>;
	usersRelationship?: InputMaybe<Array<TaskUsersRelationshipDeleteFieldInput>>;
};

export type TaskDisconnectInput = {
	agreement?: InputMaybe<TaskAgreementDisconnectFieldInput>;
	case?: InputMaybe<TaskCaseDisconnectFieldInput>;
	document?: InputMaybe<TaskDocumentDisconnectFieldInput>;
	message?: InputMaybe<TaskMessageDisconnectFieldInput>;
	usersRelationship?: InputMaybe<Array<TaskUsersRelationshipDisconnectFieldInput>>;
};

export type TaskDocumentAggregateInput = {
	AND?: InputMaybe<Array<TaskDocumentAggregateInput>>;
	OR?: InputMaybe<Array<TaskDocumentAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<TaskDocumentNodeAggregationWhereInput>;
};

export type TaskDocumentConnectFieldInput = {
	connect?: InputMaybe<DocumentConnectInput>;
	where?: InputMaybe<DocumentConnectWhere>;
};

export type TaskDocumentConnection = {
	__typename?: "TaskDocumentConnection";
	edges: Array<TaskDocumentRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type TaskDocumentConnectionSort = {
	node?: InputMaybe<DocumentSort>;
};

export type TaskDocumentConnectionWhere = {
	AND?: InputMaybe<Array<TaskDocumentConnectionWhere>>;
	OR?: InputMaybe<Array<TaskDocumentConnectionWhere>>;
	node?: InputMaybe<DocumentWhere>;
	node_NOT?: InputMaybe<DocumentWhere>;
};

export type TaskDocumentCreateFieldInput = {
	node: DocumentCreateInput;
};

export type TaskDocumentDeleteFieldInput = {
	delete?: InputMaybe<DocumentDeleteInput>;
	where?: InputMaybe<TaskDocumentConnectionWhere>;
};

export type TaskDocumentDisconnectFieldInput = {
	disconnect?: InputMaybe<DocumentDisconnectInput>;
	where?: InputMaybe<TaskDocumentConnectionWhere>;
};

export type TaskDocumentFieldInput = {
	connect?: InputMaybe<TaskDocumentConnectFieldInput>;
	create?: InputMaybe<TaskDocumentCreateFieldInput>;
};

export type TaskDocumentNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<TaskDocumentNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<TaskDocumentNodeAggregationWhereInput>>;
	counterParties_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	counterParties_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	counterParties_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	counterParties_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	counterParties_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	counterParties_EQUAL?: InputMaybe<Scalars["String"]>;
	counterParties_GT?: InputMaybe<Scalars["Int"]>;
	counterParties_GTE?: InputMaybe<Scalars["Int"]>;
	counterParties_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	counterParties_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	counterParties_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	counterParties_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	counterParties_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	counterParties_LT?: InputMaybe<Scalars["Int"]>;
	counterParties_LTE?: InputMaybe<Scalars["Int"]>;
	counterParties_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	counterParties_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	counterParties_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	counterParties_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	counterParties_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	coveragePeriod_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	coveragePeriod_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	coveragePeriod_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	coveragePeriod_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	coveragePeriod_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	coveragePeriod_EQUAL?: InputMaybe<Scalars["String"]>;
	coveragePeriod_GT?: InputMaybe<Scalars["Int"]>;
	coveragePeriod_GTE?: InputMaybe<Scalars["Int"]>;
	coveragePeriod_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	coveragePeriod_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	coveragePeriod_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	coveragePeriod_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	coveragePeriod_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	coveragePeriod_LT?: InputMaybe<Scalars["Int"]>;
	coveragePeriod_LTE?: InputMaybe<Scalars["Int"]>;
	coveragePeriod_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	coveragePeriod_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	coveragePeriod_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	coveragePeriod_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	coveragePeriod_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	createdBy_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	createdBy_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	createdBy_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	createdBy_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	createdBy_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	createdBy_EQUAL?: InputMaybe<Scalars["String"]>;
	createdBy_GT?: InputMaybe<Scalars["Int"]>;
	createdBy_GTE?: InputMaybe<Scalars["Int"]>;
	createdBy_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	createdBy_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	createdBy_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	createdBy_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	createdBy_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	createdBy_LT?: InputMaybe<Scalars["Int"]>;
	createdBy_LTE?: InputMaybe<Scalars["Int"]>;
	createdBy_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	createdBy_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	createdBy_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	createdBy_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	createdBy_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	createdOn_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	creatorOrgName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	creatorOrgName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	creatorOrgName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	creatorOrgName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	creatorOrgName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	creatorOrgName_EQUAL?: InputMaybe<Scalars["String"]>;
	creatorOrgName_GT?: InputMaybe<Scalars["Int"]>;
	creatorOrgName_GTE?: InputMaybe<Scalars["Int"]>;
	creatorOrgName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	creatorOrgName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	creatorOrgName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	creatorOrgName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	creatorOrgName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	creatorOrgName_LT?: InputMaybe<Scalars["Int"]>;
	creatorOrgName_LTE?: InputMaybe<Scalars["Int"]>;
	creatorOrgName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	creatorOrgName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	creatorOrgName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	creatorOrgName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	creatorOrgName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	creatorTenantId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	creatorTenantId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	creatorTenantId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	creatorTenantId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	creatorTenantId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	creatorTenantId_EQUAL?: InputMaybe<Scalars["String"]>;
	creatorTenantId_GT?: InputMaybe<Scalars["Int"]>;
	creatorTenantId_GTE?: InputMaybe<Scalars["Int"]>;
	creatorTenantId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	creatorTenantId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	creatorTenantId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	creatorTenantId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	creatorTenantId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	creatorTenantId_LT?: InputMaybe<Scalars["Int"]>;
	creatorTenantId_LTE?: InputMaybe<Scalars["Int"]>;
	creatorTenantId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	creatorTenantId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	creatorTenantId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	creatorTenantId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	creatorTenantId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	formattedTags_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	formattedTags_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	formattedTags_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	formattedTags_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	formattedTags_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	formattedTags_EQUAL?: InputMaybe<Scalars["String"]>;
	formattedTags_GT?: InputMaybe<Scalars["Int"]>;
	formattedTags_GTE?: InputMaybe<Scalars["Int"]>;
	formattedTags_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedTags_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedTags_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedTags_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedTags_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	formattedTags_LT?: InputMaybe<Scalars["Int"]>;
	formattedTags_LTE?: InputMaybe<Scalars["Int"]>;
	formattedTags_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedTags_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedTags_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedTags_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedTags_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	invoiceAmount_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	invoiceAmount_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	invoiceAmount_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	invoiceAmount_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	invoiceAmount_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	invoiceAmount_EQUAL?: InputMaybe<Scalars["Int"]>;
	invoiceAmount_GT?: InputMaybe<Scalars["Int"]>;
	invoiceAmount_GTE?: InputMaybe<Scalars["Int"]>;
	invoiceAmount_LT?: InputMaybe<Scalars["Int"]>;
	invoiceAmount_LTE?: InputMaybe<Scalars["Int"]>;
	invoiceAmount_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	invoiceAmount_MAX_GT?: InputMaybe<Scalars["Int"]>;
	invoiceAmount_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	invoiceAmount_MAX_LT?: InputMaybe<Scalars["Int"]>;
	invoiceAmount_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	invoiceAmount_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	invoiceAmount_MIN_GT?: InputMaybe<Scalars["Int"]>;
	invoiceAmount_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	invoiceAmount_MIN_LT?: InputMaybe<Scalars["Int"]>;
	invoiceAmount_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	issuedOn_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	issuedOn_GT?: InputMaybe<Scalars["DateTime"]>;
	issuedOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	issuedOn_LT?: InputMaybe<Scalars["DateTime"]>;
	issuedOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	issuedOn_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	issuedOn_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	issuedOn_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	issuedOn_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	issuedOn_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	issuedOn_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	issuedOn_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	issuedOn_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	issuedOn_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	issuedOn_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_GT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_LT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	product_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	product_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	product_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	product_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	product_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	product_EQUAL?: InputMaybe<Scalars["String"]>;
	product_GT?: InputMaybe<Scalars["Int"]>;
	product_GTE?: InputMaybe<Scalars["Int"]>;
	product_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	product_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	product_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	product_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	product_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	product_LT?: InputMaybe<Scalars["Int"]>;
	product_LTE?: InputMaybe<Scalars["Int"]>;
	product_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	product_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	product_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	product_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	product_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	unlimited_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	unlimited_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	unlimited_EQUAL?: InputMaybe<Scalars["Int"]>;
	unlimited_GT?: InputMaybe<Scalars["Int"]>;
	unlimited_GTE?: InputMaybe<Scalars["Int"]>;
	unlimited_LT?: InputMaybe<Scalars["Int"]>;
	unlimited_LTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_GT?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_LT?: InputMaybe<Scalars["Int"]>;
	unlimited_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_GT?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_LT?: InputMaybe<Scalars["Int"]>;
	unlimited_MIN_LTE?: InputMaybe<Scalars["Int"]>;
};

export type TaskDocumentRelationship = {
	__typename?: "TaskDocumentRelationship";
	cursor: Scalars["String"];
	node: Document;
};

export type TaskDocumentUpdateConnectionInput = {
	node?: InputMaybe<DocumentUpdateInput>;
};

export type TaskDocumentUpdateFieldInput = {
	connect?: InputMaybe<TaskDocumentConnectFieldInput>;
	create?: InputMaybe<TaskDocumentCreateFieldInput>;
	delete?: InputMaybe<TaskDocumentDeleteFieldInput>;
	disconnect?: InputMaybe<TaskDocumentDisconnectFieldInput>;
	update?: InputMaybe<TaskDocumentUpdateConnectionInput>;
	where?: InputMaybe<TaskDocumentConnectionWhere>;
};

export type TaskMessageAggregateInput = {
	AND?: InputMaybe<Array<TaskMessageAggregateInput>>;
	OR?: InputMaybe<Array<TaskMessageAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	edge?: InputMaybe<TaskMessageEdgeAggregationWhereInput>;
	node?: InputMaybe<TaskMessageNodeAggregationWhereInput>;
};

export type TaskMessageConnectFieldInput = {
	connect?: InputMaybe<MessageConnectInput>;
	edge?: InputMaybe<UserMessageRelationshipCreateInput>;
	where?: InputMaybe<MessageConnectWhere>;
};

export type TaskMessageConnection = {
	__typename?: "TaskMessageConnection";
	edges: Array<TaskMessageRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type TaskMessageConnectionSort = {
	edge?: InputMaybe<UserMessageRelationshipSort>;
	node?: InputMaybe<MessageSort>;
};

export type TaskMessageConnectionWhere = {
	AND?: InputMaybe<Array<TaskMessageConnectionWhere>>;
	OR?: InputMaybe<Array<TaskMessageConnectionWhere>>;
	edge?: InputMaybe<UserMessageRelationshipWhere>;
	edge_NOT?: InputMaybe<UserMessageRelationshipWhere>;
	node?: InputMaybe<MessageWhere>;
	node_NOT?: InputMaybe<MessageWhere>;
};

export type TaskMessageCreateFieldInput = {
	edge?: InputMaybe<UserMessageRelationshipCreateInput>;
	node: MessageCreateInput;
};

export type TaskMessageDeleteFieldInput = {
	delete?: InputMaybe<MessageDeleteInput>;
	where?: InputMaybe<TaskMessageConnectionWhere>;
};

export type TaskMessageDisconnectFieldInput = {
	disconnect?: InputMaybe<MessageDisconnectInput>;
	where?: InputMaybe<TaskMessageConnectionWhere>;
};

export type TaskMessageEdgeAggregationWhereInput = {
	AND?: InputMaybe<Array<TaskMessageEdgeAggregationWhereInput>>;
	OR?: InputMaybe<Array<TaskMessageEdgeAggregationWhereInput>>;
	invoiceId_EQUAL?: InputMaybe<Scalars["ID"]>;
	refundId_EQUAL?: InputMaybe<Scalars["ID"]>;
};

export type TaskMessageFieldInput = {
	connect?: InputMaybe<TaskMessageConnectFieldInput>;
	create?: InputMaybe<TaskMessageCreateFieldInput>;
};

export type TaskMessageNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<TaskMessageNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<TaskMessageNodeAggregationWhereInput>>;
	content_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	content_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	content_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	content_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	content_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	content_EQUAL?: InputMaybe<Scalars["String"]>;
	content_GT?: InputMaybe<Scalars["Int"]>;
	content_GTE?: InputMaybe<Scalars["Int"]>;
	content_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	content_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	content_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	content_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	content_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	content_LT?: InputMaybe<Scalars["Int"]>;
	content_LTE?: InputMaybe<Scalars["Int"]>;
	content_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	content_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	content_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	content_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	content_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	createdOn_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	createdOn_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	createdOn_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	createdOn_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	createdOn_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	createdOn_EQUAL?: InputMaybe<Scalars["Float"]>;
	createdOn_GT?: InputMaybe<Scalars["Float"]>;
	createdOn_GTE?: InputMaybe<Scalars["Float"]>;
	createdOn_LT?: InputMaybe<Scalars["Float"]>;
	createdOn_LTE?: InputMaybe<Scalars["Float"]>;
	createdOn_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	createdOn_MAX_GT?: InputMaybe<Scalars["Float"]>;
	createdOn_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	createdOn_MAX_LT?: InputMaybe<Scalars["Float"]>;
	createdOn_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	createdOn_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	createdOn_MIN_GT?: InputMaybe<Scalars["Float"]>;
	createdOn_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	createdOn_MIN_LT?: InputMaybe<Scalars["Float"]>;
	createdOn_MIN_LTE?: InputMaybe<Scalars["Float"]>;
};

export type TaskMessageRelationship = UserMessageRelationship & {
	__typename?: "TaskMessageRelationship";
	cursor: Scalars["String"];
	invoiceId?: Maybe<Scalars["ID"]>;
	node: Message;
	refundId?: Maybe<Scalars["ID"]>;
};

export type TaskMessageUpdateConnectionInput = {
	edge?: InputMaybe<UserMessageRelationshipUpdateInput>;
	node?: InputMaybe<MessageUpdateInput>;
};

export type TaskMessageUpdateFieldInput = {
	connect?: InputMaybe<TaskMessageConnectFieldInput>;
	create?: InputMaybe<TaskMessageCreateFieldInput>;
	delete?: InputMaybe<TaskMessageDeleteFieldInput>;
	disconnect?: InputMaybe<TaskMessageDisconnectFieldInput>;
	update?: InputMaybe<TaskMessageUpdateConnectionInput>;
	where?: InputMaybe<TaskMessageConnectionWhere>;
};

export type TaskOptions = {
	limit?: InputMaybe<Scalars["Int"]>;
	offset?: InputMaybe<Scalars["Int"]>;
	/** Specify one or more TaskSort objects to sort Tasks by. The sorts will be applied in the order in which they are arranged in the array. */
	sort?: InputMaybe<Array<InputMaybe<TaskSort>>>;
};

/** Fields to sort Tasks by. The order in which sorts are applied is not guaranteed when specifying many fields in one TaskSort object. */
export type TaskSort = {
	id?: InputMaybe<SortDirection>;
	timeStamp?: InputMaybe<SortDirection>;
	triggerEventId?: InputMaybe<SortDirection>;
};

export type TaskUpdateInput = {
	agreement?: InputMaybe<TaskAgreementUpdateFieldInput>;
	case?: InputMaybe<TaskCaseUpdateFieldInput>;
	document?: InputMaybe<TaskDocumentUpdateFieldInput>;
	id?: InputMaybe<Scalars["ID"]>;
	message?: InputMaybe<TaskMessageUpdateFieldInput>;
	tenantIds?: InputMaybe<Array<Scalars["String"]>>;
	timeStamp?: InputMaybe<Scalars["Float"]>;
	triggerEventId?: InputMaybe<Scalars["Int"]>;
	usersRelationship?: InputMaybe<Array<TaskUsersRelationshipUpdateFieldInput>>;
};

export type TaskUsersRelationshipAggregateInput = {
	AND?: InputMaybe<Array<TaskUsersRelationshipAggregateInput>>;
	OR?: InputMaybe<Array<TaskUsersRelationshipAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<TaskUsersRelationshipNodeAggregationWhereInput>;
};

export type TaskUsersRelationshipConnectFieldInput = {
	connect?: InputMaybe<Array<UserConnectInput>>;
	edge: UserTaskRelationshipCreateInput;
	where?: InputMaybe<UserConnectWhere>;
};

export type TaskUsersRelationshipConnection = {
	__typename?: "TaskUsersRelationshipConnection";
	edges: Array<TaskUsersRelationshipRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type TaskUsersRelationshipConnectionSort = {
	edge?: InputMaybe<UserTaskRelationshipSort>;
	node?: InputMaybe<UserSort>;
};

export type TaskUsersRelationshipConnectionWhere = {
	AND?: InputMaybe<Array<TaskUsersRelationshipConnectionWhere>>;
	OR?: InputMaybe<Array<TaskUsersRelationshipConnectionWhere>>;
	edge?: InputMaybe<UserTaskRelationshipWhere>;
	edge_NOT?: InputMaybe<UserTaskRelationshipWhere>;
	node?: InputMaybe<UserWhere>;
	node_NOT?: InputMaybe<UserWhere>;
};

export type TaskUsersRelationshipCreateFieldInput = {
	edge: UserTaskRelationshipCreateInput;
	node: UserCreateInput;
};

export type TaskUsersRelationshipDeleteFieldInput = {
	delete?: InputMaybe<UserDeleteInput>;
	where?: InputMaybe<TaskUsersRelationshipConnectionWhere>;
};

export type TaskUsersRelationshipDisconnectFieldInput = {
	disconnect?: InputMaybe<UserDisconnectInput>;
	where?: InputMaybe<TaskUsersRelationshipConnectionWhere>;
};

export type TaskUsersRelationshipFieldInput = {
	connect?: InputMaybe<Array<TaskUsersRelationshipConnectFieldInput>>;
	create?: InputMaybe<Array<TaskUsersRelationshipCreateFieldInput>>;
};

export type TaskUsersRelationshipNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<TaskUsersRelationshipNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<TaskUsersRelationshipNodeAggregationWhereInput>>;
	email_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	email_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	email_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	email_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	email_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	email_EQUAL?: InputMaybe<Scalars["String"]>;
	email_GT?: InputMaybe<Scalars["Int"]>;
	email_GTE?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	email_LT?: InputMaybe<Scalars["Int"]>;
	email_LTE?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	firstName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	firstName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	firstName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	firstName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	firstName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	firstName_EQUAL?: InputMaybe<Scalars["String"]>;
	firstName_GT?: InputMaybe<Scalars["Int"]>;
	firstName_GTE?: InputMaybe<Scalars["Int"]>;
	firstName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	firstName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	firstName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	firstName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	firstName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	firstName_LT?: InputMaybe<Scalars["Int"]>;
	firstName_LTE?: InputMaybe<Scalars["Int"]>;
	firstName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	firstName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	firstName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	firstName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	firstName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	lastName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	lastName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	lastName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	lastName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	lastName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	lastName_EQUAL?: InputMaybe<Scalars["String"]>;
	lastName_GT?: InputMaybe<Scalars["Int"]>;
	lastName_GTE?: InputMaybe<Scalars["Int"]>;
	lastName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	lastName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	lastName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	lastName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	lastName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	lastName_LT?: InputMaybe<Scalars["Int"]>;
	lastName_LTE?: InputMaybe<Scalars["Int"]>;
	lastName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	lastName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	lastName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	lastName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	lastName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	preferredLanguage_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	preferredLanguage_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	preferredLanguage_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	preferredLanguage_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	preferredLanguage_EQUAL?: InputMaybe<Scalars["String"]>;
	preferredLanguage_GT?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_GTE?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LT?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_LTE?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	preferredLanguage_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	tenantId_EQUAL?: InputMaybe<Scalars["String"]>;
	tenantId_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type TaskUsersRelationshipRelationship = UserTaskRelationship & {
	__typename?: "TaskUsersRelationshipRelationship";
	cursor: Scalars["String"];
	isCompleted: Scalars["Boolean"];
	node: User;
};

export type TaskUsersRelationshipUpdateConnectionInput = {
	edge?: InputMaybe<UserTaskRelationshipUpdateInput>;
	node?: InputMaybe<UserUpdateInput>;
};

export type TaskUsersRelationshipUpdateFieldInput = {
	connect?: InputMaybe<Array<TaskUsersRelationshipConnectFieldInput>>;
	create?: InputMaybe<Array<TaskUsersRelationshipCreateFieldInput>>;
	delete?: InputMaybe<Array<TaskUsersRelationshipDeleteFieldInput>>;
	disconnect?: InputMaybe<Array<TaskUsersRelationshipDisconnectFieldInput>>;
	update?: InputMaybe<TaskUsersRelationshipUpdateConnectionInput>;
	where?: InputMaybe<TaskUsersRelationshipConnectionWhere>;
};

export type TaskWhere = {
	AND?: InputMaybe<Array<TaskWhere>>;
	OR?: InputMaybe<Array<TaskWhere>>;
	agreement?: InputMaybe<AgreementWhere>;
	agreementAggregate?: InputMaybe<TaskAgreementAggregateInput>;
	agreementConnection?: InputMaybe<TaskAgreementConnectionWhere>;
	agreementConnection_NOT?: InputMaybe<TaskAgreementConnectionWhere>;
	agreement_NOT?: InputMaybe<AgreementWhere>;
	case?: InputMaybe<CaseWhere>;
	caseAggregate?: InputMaybe<TaskCaseAggregateInput>;
	caseConnection?: InputMaybe<TaskCaseConnectionWhere>;
	caseConnection_NOT?: InputMaybe<TaskCaseConnectionWhere>;
	case_NOT?: InputMaybe<CaseWhere>;
	document?: InputMaybe<DocumentWhere>;
	documentAggregate?: InputMaybe<TaskDocumentAggregateInput>;
	documentConnection?: InputMaybe<TaskDocumentConnectionWhere>;
	documentConnection_NOT?: InputMaybe<TaskDocumentConnectionWhere>;
	document_NOT?: InputMaybe<DocumentWhere>;
	id?: InputMaybe<Scalars["ID"]>;
	id_CONTAINS?: InputMaybe<Scalars["ID"]>;
	id_ENDS_WITH?: InputMaybe<Scalars["ID"]>;
	id_IN?: InputMaybe<Array<InputMaybe<Scalars["ID"]>>>;
	id_MATCHES?: InputMaybe<Scalars["String"]>;
	id_NOT?: InputMaybe<Scalars["ID"]>;
	id_NOT_CONTAINS?: InputMaybe<Scalars["ID"]>;
	id_NOT_ENDS_WITH?: InputMaybe<Scalars["ID"]>;
	id_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["ID"]>>>;
	id_NOT_STARTS_WITH?: InputMaybe<Scalars["ID"]>;
	id_STARTS_WITH?: InputMaybe<Scalars["ID"]>;
	message?: InputMaybe<MessageWhere>;
	messageAggregate?: InputMaybe<TaskMessageAggregateInput>;
	messageConnection?: InputMaybe<TaskMessageConnectionWhere>;
	messageConnection_NOT?: InputMaybe<TaskMessageConnectionWhere>;
	message_NOT?: InputMaybe<MessageWhere>;
	tenantIds?: InputMaybe<Array<Scalars["String"]>>;
	tenantIds_INCLUDES?: InputMaybe<Scalars["String"]>;
	tenantIds_NOT?: InputMaybe<Array<Scalars["String"]>>;
	tenantIds_NOT_INCLUDES?: InputMaybe<Scalars["String"]>;
	timeStamp?: InputMaybe<Scalars["Float"]>;
	timeStamp_GT?: InputMaybe<Scalars["Float"]>;
	timeStamp_GTE?: InputMaybe<Scalars["Float"]>;
	timeStamp_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	timeStamp_LT?: InputMaybe<Scalars["Float"]>;
	timeStamp_LTE?: InputMaybe<Scalars["Float"]>;
	timeStamp_NOT?: InputMaybe<Scalars["Float"]>;
	timeStamp_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	triggerEventId?: InputMaybe<Scalars["Int"]>;
	triggerEventId_GT?: InputMaybe<Scalars["Int"]>;
	triggerEventId_GTE?: InputMaybe<Scalars["Int"]>;
	triggerEventId_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	triggerEventId_LT?: InputMaybe<Scalars["Int"]>;
	triggerEventId_LTE?: InputMaybe<Scalars["Int"]>;
	triggerEventId_NOT?: InputMaybe<Scalars["Int"]>;
	triggerEventId_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	usersRelationship?: InputMaybe<UserWhere>;
	usersRelationshipAggregate?: InputMaybe<TaskUsersRelationshipAggregateInput>;
	usersRelationshipConnection?: InputMaybe<TaskUsersRelationshipConnectionWhere>;
	usersRelationshipConnection_NOT?: InputMaybe<TaskUsersRelationshipConnectionWhere>;
	usersRelationship_NOT?: InputMaybe<UserWhere>;
};

export type Timeframe = {
	__typename?: "Timeframe";
	name: Scalars["String"];
	timeframeEnd: Scalars["Date"];
	timeframeStart: Scalars["Date"];
};

export type TimeframeAggregateSelection = {
	__typename?: "TimeframeAggregateSelection";
	count: Scalars["Int"];
	name: StringAggregateSelection;
};

export type TimeframeConnectWhere = {
	node: TimeframeWhere;
};

export type TimeframeCreateInput = {
	name: Scalars["String"];
	timeframeEnd: Scalars["Date"];
	timeframeStart: Scalars["Date"];
};

export type TimeframeOptions = {
	limit?: InputMaybe<Scalars["Int"]>;
	offset?: InputMaybe<Scalars["Int"]>;
	/** Specify one or more TimeframeSort objects to sort Timeframes by. The sorts will be applied in the order in which they are arranged in the array. */
	sort?: InputMaybe<Array<InputMaybe<TimeframeSort>>>;
};

export enum TimeframeRangeType {
	After = "AFTER",
	Ever = "EVER",
	UpTo = "UP_TO",
	Within = "WITHIN",
	WithinTherapyTrial = "WITHIN_THERAPY_TRIAL",
	WithinTheCoveragePeriod = "WITHIN_THE_COVERAGE_PERIOD",
}

export type TimeframeRelatedEntity = {
	timeframeEnd?: Maybe<Scalars["Int"]>;
	timeframeRelation: StobTimeframeRelation;
	timeframeStart: Scalars["Int"];
	timeframeStartingPoint: StobTimeframeStartingPoint;
};

/** Fields to sort Timeframes by. The order in which sorts are applied is not guaranteed when specifying many fields in one TimeframeSort object. */
export type TimeframeSort = {
	name?: InputMaybe<SortDirection>;
	timeframeEnd?: InputMaybe<SortDirection>;
	timeframeStart?: InputMaybe<SortDirection>;
};

export enum TimeframeStartingPoint {
	AgreementStartDate = "AGREEMENT_START_DATE",
	CoveragePeriodStart = "COVERAGE_PERIOD_START",
	FirstAdministrationDate = "FIRST_ADMINISTRATION_DATE",
	FirstPrescriptionDate = "FIRST_PRESCRIPTION_DATE",
	IntendedStartDate = "INTENDED_START_DATE",
	ProgressionDate = "PROGRESSION_DATE",
	RequestReceiptDate = "REQUEST_RECEIPT_DATE",
	TreatmentStartDate = "TREATMENT_START_DATE",
}

export type TimeframeUpdateInput = {
	name?: InputMaybe<Scalars["String"]>;
	timeframeEnd?: InputMaybe<Scalars["Date"]>;
	timeframeStart?: InputMaybe<Scalars["Date"]>;
};

export type TimeframeWhere = {
	AND?: InputMaybe<Array<TimeframeWhere>>;
	OR?: InputMaybe<Array<TimeframeWhere>>;
	name?: InputMaybe<Scalars["String"]>;
	name_CONTAINS?: InputMaybe<Scalars["String"]>;
	name_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	name_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	name_MATCHES?: InputMaybe<Scalars["String"]>;
	name_NOT?: InputMaybe<Scalars["String"]>;
	name_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	name_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	name_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	name_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	name_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	timeframeEnd?: InputMaybe<Scalars["Date"]>;
	timeframeEnd_GT?: InputMaybe<Scalars["Date"]>;
	timeframeEnd_GTE?: InputMaybe<Scalars["Date"]>;
	timeframeEnd_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
	timeframeEnd_LT?: InputMaybe<Scalars["Date"]>;
	timeframeEnd_LTE?: InputMaybe<Scalars["Date"]>;
	timeframeEnd_NOT?: InputMaybe<Scalars["Date"]>;
	timeframeEnd_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
	timeframeStart?: InputMaybe<Scalars["Date"]>;
	timeframeStart_GT?: InputMaybe<Scalars["Date"]>;
	timeframeStart_GTE?: InputMaybe<Scalars["Date"]>;
	timeframeStart_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
	timeframeStart_LT?: InputMaybe<Scalars["Date"]>;
	timeframeStart_LTE?: InputMaybe<Scalars["Date"]>;
	timeframeStart_NOT?: InputMaybe<Scalars["Date"]>;
	timeframeStart_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
};

export type Translation = {
	__typename?: "Translation";
	key: Scalars["String"];
	languageCode: Scalars["String"];
	value: Scalars["String"];
};

export type TranslationAggregateSelection = {
	__typename?: "TranslationAggregateSelection";
	count: Scalars["Int"];
	key: StringAggregateSelection;
	languageCode: StringAggregateSelection;
	value: StringAggregateSelection;
};

export type TranslationOptions = {
	limit?: InputMaybe<Scalars["Int"]>;
	offset?: InputMaybe<Scalars["Int"]>;
	/** Specify one or more TranslationSort objects to sort Translations by. The sorts will be applied in the order in which they are arranged in the array. */
	sort?: InputMaybe<Array<InputMaybe<TranslationSort>>>;
};

/** Fields to sort Translations by. The order in which sorts are applied is not guaranteed when specifying many fields in one TranslationSort object. */
export type TranslationSort = {
	key?: InputMaybe<SortDirection>;
	languageCode?: InputMaybe<SortDirection>;
	value?: InputMaybe<SortDirection>;
};

export type TranslationWhere = {
	AND?: InputMaybe<Array<TranslationWhere>>;
	OR?: InputMaybe<Array<TranslationWhere>>;
	key?: InputMaybe<Scalars["String"]>;
	key_CONTAINS?: InputMaybe<Scalars["String"]>;
	key_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	key_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	key_MATCHES?: InputMaybe<Scalars["String"]>;
	key_NOT?: InputMaybe<Scalars["String"]>;
	key_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	key_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	key_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	key_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	key_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	languageCode?: InputMaybe<Scalars["String"]>;
	languageCode_CONTAINS?: InputMaybe<Scalars["String"]>;
	languageCode_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	languageCode_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	languageCode_MATCHES?: InputMaybe<Scalars["String"]>;
	languageCode_NOT?: InputMaybe<Scalars["String"]>;
	languageCode_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	languageCode_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	languageCode_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	languageCode_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	languageCode_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	value?: InputMaybe<Scalars["String"]>;
	value_CONTAINS?: InputMaybe<Scalars["String"]>;
	value_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	value_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	value_MATCHES?: InputMaybe<Scalars["String"]>;
	value_NOT?: InputMaybe<Scalars["String"]>;
	value_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	value_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	value_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	value_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	value_STARTS_WITH?: InputMaybe<Scalars["String"]>;
};

export enum Translations {
	De = "DE",
	En = "EN",
}

export type TranslationsResult = {
	__typename?: "TranslationsResult";
	de: Scalars["String"];
	en: Scalars["String"];
};

export type TranslationsResultAggregateSelection = {
	__typename?: "TranslationsResultAggregateSelection";
	count: Scalars["Int"];
	de: StringAggregateSelection;
	en: StringAggregateSelection;
};

export type TranslationsResultOptions = {
	limit?: InputMaybe<Scalars["Int"]>;
	offset?: InputMaybe<Scalars["Int"]>;
	/** Specify one or more TranslationsResultSort objects to sort TranslationsResults by. The sorts will be applied in the order in which they are arranged in the array. */
	sort?: InputMaybe<Array<InputMaybe<TranslationsResultSort>>>;
};

/** Fields to sort TranslationsResults by. The order in which sorts are applied is not guaranteed when specifying many fields in one TranslationsResultSort object. */
export type TranslationsResultSort = {
	de?: InputMaybe<SortDirection>;
	en?: InputMaybe<SortDirection>;
};

export type TranslationsResultWhere = {
	AND?: InputMaybe<Array<TranslationsResultWhere>>;
	OR?: InputMaybe<Array<TranslationsResultWhere>>;
	de?: InputMaybe<Scalars["String"]>;
	de_CONTAINS?: InputMaybe<Scalars["String"]>;
	de_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	de_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	de_MATCHES?: InputMaybe<Scalars["String"]>;
	de_NOT?: InputMaybe<Scalars["String"]>;
	de_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	de_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	de_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	de_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	de_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	en?: InputMaybe<Scalars["String"]>;
	en_CONTAINS?: InputMaybe<Scalars["String"]>;
	en_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	en_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	en_MATCHES?: InputMaybe<Scalars["String"]>;
	en_NOT?: InputMaybe<Scalars["String"]>;
	en_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	en_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	en_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	en_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	en_STARTS_WITH?: InputMaybe<Scalars["String"]>;
};

export type TreatingPhysician = {
	__typename?: "TreatingPhysician";
	department?: Maybe<Scalars["String"]>;
	email?: Maybe<Scalars["String"]>;
	firstName: Scalars["String"];
	hospitalName?: Maybe<Scalars["String"]>;
	lastName: Scalars["String"];
	nr?: Maybe<Scalars["String"]>;
	phoneNo?: Maybe<Scalars["String"]>;
	place?: Maybe<Scalars["String"]>;
	postcode?: Maybe<Scalars["String"]>;
	street?: Maybe<Scalars["String"]>;
	title?: Maybe<TreatingPhysicianTitle>;
};

export type TreatingPhysicianAggregateSelection = {
	__typename?: "TreatingPhysicianAggregateSelection";
	count: Scalars["Int"];
	department: StringAggregateSelection;
	email: StringAggregateSelection;
	firstName: StringAggregateSelection;
	hospitalName: StringAggregateSelection;
	lastName: StringAggregateSelection;
	nr: StringAggregateSelection;
	phoneNo: StringAggregateSelection;
	place: StringAggregateSelection;
	postcode: StringAggregateSelection;
	street: StringAggregateSelection;
};

export type TreatingPhysicianConnectWhere = {
	node: TreatingPhysicianWhere;
};

export type TreatingPhysicianCreateInput = {
	department?: InputMaybe<Scalars["String"]>;
	email?: InputMaybe<Scalars["String"]>;
	firstName: Scalars["String"];
	hospitalName?: InputMaybe<Scalars["String"]>;
	lastName: Scalars["String"];
	nr?: InputMaybe<Scalars["String"]>;
	phoneNo?: InputMaybe<Scalars["String"]>;
	place?: InputMaybe<Scalars["String"]>;
	postcode?: InputMaybe<Scalars["String"]>;
	street?: InputMaybe<Scalars["String"]>;
	title?: InputMaybe<TreatingPhysicianTitle>;
};

export type TreatingPhysicianInput = {
	department?: InputMaybe<Scalars["String"]>;
	email?: InputMaybe<Scalars["String"]>;
	firstName?: InputMaybe<Scalars["String"]>;
	hospitalName?: InputMaybe<Scalars["String"]>;
	lastName?: InputMaybe<Scalars["String"]>;
	nr?: InputMaybe<Scalars["String"]>;
	phoneNo?: InputMaybe<Scalars["String"]>;
	place?: InputMaybe<Scalars["String"]>;
	postcode?: InputMaybe<Scalars["String"]>;
	street?: InputMaybe<Scalars["String"]>;
	title?: InputMaybe<TreatingPhysicianTitle>;
};

export type TreatingPhysicianOptions = {
	limit?: InputMaybe<Scalars["Int"]>;
	offset?: InputMaybe<Scalars["Int"]>;
	/** Specify one or more TreatingPhysicianSort objects to sort TreatingPhysicians by. The sorts will be applied in the order in which they are arranged in the array. */
	sort?: InputMaybe<Array<InputMaybe<TreatingPhysicianSort>>>;
};

/** Fields to sort TreatingPhysicians by. The order in which sorts are applied is not guaranteed when specifying many fields in one TreatingPhysicianSort object. */
export type TreatingPhysicianSort = {
	department?: InputMaybe<SortDirection>;
	email?: InputMaybe<SortDirection>;
	firstName?: InputMaybe<SortDirection>;
	hospitalName?: InputMaybe<SortDirection>;
	lastName?: InputMaybe<SortDirection>;
	nr?: InputMaybe<SortDirection>;
	phoneNo?: InputMaybe<SortDirection>;
	place?: InputMaybe<SortDirection>;
	postcode?: InputMaybe<SortDirection>;
	street?: InputMaybe<SortDirection>;
	title?: InputMaybe<SortDirection>;
};

export enum TreatingPhysicianTitle {
	Doctor = "DOCTOR",
	Professor = "PROFESSOR",
}

export type TreatingPhysicianUpdateInput = {
	department?: InputMaybe<Scalars["String"]>;
	email?: InputMaybe<Scalars["String"]>;
	firstName?: InputMaybe<Scalars["String"]>;
	hospitalName?: InputMaybe<Scalars["String"]>;
	lastName?: InputMaybe<Scalars["String"]>;
	nr?: InputMaybe<Scalars["String"]>;
	phoneNo?: InputMaybe<Scalars["String"]>;
	place?: InputMaybe<Scalars["String"]>;
	postcode?: InputMaybe<Scalars["String"]>;
	street?: InputMaybe<Scalars["String"]>;
	title?: InputMaybe<TreatingPhysicianTitle>;
};

export type TreatingPhysicianWhere = {
	AND?: InputMaybe<Array<TreatingPhysicianWhere>>;
	OR?: InputMaybe<Array<TreatingPhysicianWhere>>;
	department?: InputMaybe<Scalars["String"]>;
	department_CONTAINS?: InputMaybe<Scalars["String"]>;
	department_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	department_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	department_MATCHES?: InputMaybe<Scalars["String"]>;
	department_NOT?: InputMaybe<Scalars["String"]>;
	department_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	department_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	department_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	department_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	department_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	email?: InputMaybe<Scalars["String"]>;
	email_CONTAINS?: InputMaybe<Scalars["String"]>;
	email_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	email_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	email_MATCHES?: InputMaybe<Scalars["String"]>;
	email_NOT?: InputMaybe<Scalars["String"]>;
	email_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	email_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	email_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	email_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	email_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	firstName?: InputMaybe<Scalars["String"]>;
	firstName_CONTAINS?: InputMaybe<Scalars["String"]>;
	firstName_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	firstName_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	firstName_MATCHES?: InputMaybe<Scalars["String"]>;
	firstName_NOT?: InputMaybe<Scalars["String"]>;
	firstName_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	firstName_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	firstName_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	firstName_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	firstName_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	hospitalName?: InputMaybe<Scalars["String"]>;
	hospitalName_CONTAINS?: InputMaybe<Scalars["String"]>;
	hospitalName_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	hospitalName_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	hospitalName_MATCHES?: InputMaybe<Scalars["String"]>;
	hospitalName_NOT?: InputMaybe<Scalars["String"]>;
	hospitalName_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	hospitalName_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	hospitalName_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	hospitalName_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	hospitalName_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	lastName?: InputMaybe<Scalars["String"]>;
	lastName_CONTAINS?: InputMaybe<Scalars["String"]>;
	lastName_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	lastName_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	lastName_MATCHES?: InputMaybe<Scalars["String"]>;
	lastName_NOT?: InputMaybe<Scalars["String"]>;
	lastName_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	lastName_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	lastName_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	lastName_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	lastName_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	nr?: InputMaybe<Scalars["String"]>;
	nr_CONTAINS?: InputMaybe<Scalars["String"]>;
	nr_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	nr_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	nr_MATCHES?: InputMaybe<Scalars["String"]>;
	nr_NOT?: InputMaybe<Scalars["String"]>;
	nr_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	nr_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	nr_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	nr_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	nr_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	phoneNo?: InputMaybe<Scalars["String"]>;
	phoneNo_CONTAINS?: InputMaybe<Scalars["String"]>;
	phoneNo_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	phoneNo_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	phoneNo_MATCHES?: InputMaybe<Scalars["String"]>;
	phoneNo_NOT?: InputMaybe<Scalars["String"]>;
	phoneNo_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	phoneNo_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	phoneNo_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	phoneNo_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	phoneNo_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	place?: InputMaybe<Scalars["String"]>;
	place_CONTAINS?: InputMaybe<Scalars["String"]>;
	place_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	place_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	place_MATCHES?: InputMaybe<Scalars["String"]>;
	place_NOT?: InputMaybe<Scalars["String"]>;
	place_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	place_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	place_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	place_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	place_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	postcode?: InputMaybe<Scalars["String"]>;
	postcode_CONTAINS?: InputMaybe<Scalars["String"]>;
	postcode_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	postcode_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	postcode_MATCHES?: InputMaybe<Scalars["String"]>;
	postcode_NOT?: InputMaybe<Scalars["String"]>;
	postcode_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	postcode_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	postcode_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	postcode_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	postcode_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	street?: InputMaybe<Scalars["String"]>;
	street_CONTAINS?: InputMaybe<Scalars["String"]>;
	street_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	street_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	street_MATCHES?: InputMaybe<Scalars["String"]>;
	street_NOT?: InputMaybe<Scalars["String"]>;
	street_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	street_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	street_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	street_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	street_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	title?: InputMaybe<TreatingPhysicianTitle>;
	title_IN?: InputMaybe<Array<InputMaybe<TreatingPhysicianTitle>>>;
	title_NOT?: InputMaybe<TreatingPhysicianTitle>;
	title_NOT_IN?: InputMaybe<Array<InputMaybe<TreatingPhysicianTitle>>>;
};

export type Treatment = {
	__typename?: "Treatment";
	BagDossierNo?: Maybe<Scalars["String"]>;
	Code: Scalars["String"];
	FlagModal?: Maybe<Scalars["String"]>;
	FlagNarcosis?: Maybe<Scalars["String"]>;
	GTIN?: Maybe<Scalars["String"]>;
	LOT?: Maybe<Scalars["String"]>;
	Name?: Maybe<Scalars["String"]>;
	Partners: Array<Partner>;
	PartnersConnection: TreatmentPartnersConnection;
	PharmaCode?: Maybe<Scalars["String"]>;
	PrevPharmacode?: Maybe<Scalars["String"]>;
	REF?: Maybe<Scalars["String"]>;
	Status?: Maybe<PreparationStatus>;
	StatusConnection: TreatmentStatusConnection;
	SwissmedicCategory?: Maybe<Scalars["String"]>;
	SwissmedicNo8?: Maybe<Scalars["String"]>;
	UDI?: Maybe<Scalars["String"]>;
	canBeMain?: Maybe<Scalars["Boolean"]>;
	claim: Array<Claim>;
	claimConnection: TreatmentClaimConnection;
	classificationSystem?: Maybe<Scalars["String"]>;
	exFactoryPrices: Array<ExFactoryPrice>;
	exFactoryPricesConnection: TreatmentExFactoryPricesConnection;
	hasLimitations: Array<Limitation>;
	hasLimitationsConnection: TreatmentHasLimitationsConnection;
	publicPrices: Array<PublicPrice>;
	publicPricesConnection: TreatmentPublicPricesConnection;
	regulatedBy: Preparation;
	regulatedByConnection: TreatmentRegulatedByConnection;
};

export type TreatmentPartnersArgs = {
	options?: InputMaybe<PartnerOptions>;
	where?: InputMaybe<PartnerWhere>;
};

export type TreatmentPartnersConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<TreatmentPartnersConnectionSort>>;
	where?: InputMaybe<TreatmentPartnersConnectionWhere>;
};

export type TreatmentStatusArgs = {
	options?: InputMaybe<PreparationStatusOptions>;
	where?: InputMaybe<PreparationStatusWhere>;
};

export type TreatmentStatusConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<TreatmentStatusConnectionSort>>;
	where?: InputMaybe<TreatmentStatusConnectionWhere>;
};

export type TreatmentClaimArgs = {
	options?: InputMaybe<ClaimOptions>;
	where?: InputMaybe<ClaimWhere>;
};

export type TreatmentClaimConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<TreatmentClaimConnectionSort>>;
	where?: InputMaybe<TreatmentClaimConnectionWhere>;
};

export type TreatmentExFactoryPricesArgs = {
	options?: InputMaybe<ExFactoryPriceOptions>;
	where?: InputMaybe<ExFactoryPriceWhere>;
};

export type TreatmentExFactoryPricesConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<TreatmentExFactoryPricesConnectionSort>>;
	where?: InputMaybe<TreatmentExFactoryPricesConnectionWhere>;
};

export type TreatmentHasLimitationsArgs = {
	options?: InputMaybe<LimitationOptions>;
	where?: InputMaybe<LimitationWhere>;
};

export type TreatmentHasLimitationsConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<TreatmentHasLimitationsConnectionSort>>;
	where?: InputMaybe<TreatmentHasLimitationsConnectionWhere>;
};

export type TreatmentPublicPricesArgs = {
	options?: InputMaybe<PublicPriceOptions>;
	where?: InputMaybe<PublicPriceWhere>;
};

export type TreatmentPublicPricesConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<TreatmentPublicPricesConnectionSort>>;
	where?: InputMaybe<TreatmentPublicPricesConnectionWhere>;
};

export type TreatmentRegulatedByArgs = {
	options?: InputMaybe<PreparationOptions>;
	where?: InputMaybe<PreparationWhere>;
};

export type TreatmentRegulatedByConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<TreatmentRegulatedByConnectionSort>>;
	where?: InputMaybe<TreatmentRegulatedByConnectionWhere>;
};

export type TreatmentAggregateSelection = {
	__typename?: "TreatmentAggregateSelection";
	BagDossierNo: StringAggregateSelection;
	Code: StringAggregateSelection;
	FlagModal: StringAggregateSelection;
	FlagNarcosis: StringAggregateSelection;
	GTIN: StringAggregateSelection;
	LOT: StringAggregateSelection;
	Name: StringAggregateSelection;
	PharmaCode: StringAggregateSelection;
	PrevPharmacode: StringAggregateSelection;
	REF: StringAggregateSelection;
	SwissmedicCategory: StringAggregateSelection;
	SwissmedicNo8: StringAggregateSelection;
	UDI: StringAggregateSelection;
	classificationSystem: StringAggregateSelection;
	count: Scalars["Int"];
};

export type TreatmentClaimAggregateInput = {
	AND?: InputMaybe<Array<TreatmentClaimAggregateInput>>;
	OR?: InputMaybe<Array<TreatmentClaimAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<TreatmentClaimNodeAggregationWhereInput>;
};

export type TreatmentClaimConnectFieldInput = {
	connect?: InputMaybe<Array<ClaimConnectInput>>;
	where?: InputMaybe<ClaimConnectWhere>;
};

export type TreatmentClaimConnection = {
	__typename?: "TreatmentClaimConnection";
	edges: Array<TreatmentClaimRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type TreatmentClaimConnectionSort = {
	node?: InputMaybe<ClaimSort>;
};

export type TreatmentClaimConnectionWhere = {
	AND?: InputMaybe<Array<TreatmentClaimConnectionWhere>>;
	OR?: InputMaybe<Array<TreatmentClaimConnectionWhere>>;
	node?: InputMaybe<ClaimWhere>;
	node_NOT?: InputMaybe<ClaimWhere>;
};

export type TreatmentClaimCreateFieldInput = {
	node: ClaimCreateInput;
};

export type TreatmentClaimDeleteFieldInput = {
	delete?: InputMaybe<ClaimDeleteInput>;
	where?: InputMaybe<TreatmentClaimConnectionWhere>;
};

export type TreatmentClaimDisconnectFieldInput = {
	disconnect?: InputMaybe<ClaimDisconnectInput>;
	where?: InputMaybe<TreatmentClaimConnectionWhere>;
};

export type TreatmentClaimFieldInput = {
	connect?: InputMaybe<Array<TreatmentClaimConnectFieldInput>>;
	create?: InputMaybe<Array<TreatmentClaimCreateFieldInput>>;
};

export type TreatmentClaimNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<TreatmentClaimNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<TreatmentClaimNodeAggregationWhereInput>>;
	administrationDate_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	administrationDate_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	administrationDate_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	administrationDate_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	administrationDate_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	administrationDate_EQUAL?: InputMaybe<Scalars["String"]>;
	administrationDate_GT?: InputMaybe<Scalars["Int"]>;
	administrationDate_GTE?: InputMaybe<Scalars["Int"]>;
	administrationDate_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	administrationDate_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	administrationDate_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	administrationDate_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	administrationDate_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	administrationDate_LT?: InputMaybe<Scalars["Int"]>;
	administrationDate_LTE?: InputMaybe<Scalars["Int"]>;
	administrationDate_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	administrationDate_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	administrationDate_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	administrationDate_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	administrationDate_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	assignee_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	assignee_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	assignee_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	assignee_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	assignee_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	assignee_EQUAL?: InputMaybe<Scalars["String"]>;
	assignee_GT?: InputMaybe<Scalars["Int"]>;
	assignee_GTE?: InputMaybe<Scalars["Int"]>;
	assignee_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	assignee_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	assignee_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	assignee_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	assignee_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	assignee_LT?: InputMaybe<Scalars["Int"]>;
	assignee_LTE?: InputMaybe<Scalars["Int"]>;
	assignee_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	assignee_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	assignee_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	assignee_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	assignee_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	claimId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	claimId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	claimId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	claimId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	claimId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	claimId_EQUAL?: InputMaybe<Scalars["String"]>;
	claimId_GT?: InputMaybe<Scalars["Int"]>;
	claimId_GTE?: InputMaybe<Scalars["Int"]>;
	claimId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	claimId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	claimId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	claimId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	claimId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	claimId_LT?: InputMaybe<Scalars["Int"]>;
	claimId_LTE?: InputMaybe<Scalars["Int"]>;
	claimId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	claimId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	claimId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	claimId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	claimId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	createdOn_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	invoiceAmount_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	invoiceAmount_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	invoiceAmount_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	invoiceAmount_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	invoiceAmount_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	invoiceAmount_EQUAL?: InputMaybe<Scalars["String"]>;
	invoiceAmount_GT?: InputMaybe<Scalars["Int"]>;
	invoiceAmount_GTE?: InputMaybe<Scalars["Int"]>;
	invoiceAmount_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	invoiceAmount_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	invoiceAmount_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	invoiceAmount_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	invoiceAmount_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	invoiceAmount_LT?: InputMaybe<Scalars["Int"]>;
	invoiceAmount_LTE?: InputMaybe<Scalars["Int"]>;
	invoiceAmount_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	invoiceAmount_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	invoiceAmount_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	invoiceAmount_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	invoiceAmount_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	invoiceDate_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	invoiceDate_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	invoiceDate_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	invoiceDate_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	invoiceDate_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	invoiceDate_EQUAL?: InputMaybe<Scalars["String"]>;
	invoiceDate_GT?: InputMaybe<Scalars["Int"]>;
	invoiceDate_GTE?: InputMaybe<Scalars["Int"]>;
	invoiceDate_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	invoiceDate_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	invoiceDate_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	invoiceDate_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	invoiceDate_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	invoiceDate_LT?: InputMaybe<Scalars["Int"]>;
	invoiceDate_LTE?: InputMaybe<Scalars["Int"]>;
	invoiceDate_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	invoiceDate_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	invoiceDate_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	invoiceDate_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	invoiceDate_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	invoiceNumber_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	invoiceNumber_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	invoiceNumber_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	invoiceNumber_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	invoiceNumber_EQUAL?: InputMaybe<Scalars["String"]>;
	invoiceNumber_GT?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_GTE?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_LT?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_LTE?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationIdType_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	preparationIdType_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	preparationIdType_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	preparationIdType_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	preparationIdType_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	preparationIdType_EQUAL?: InputMaybe<Scalars["String"]>;
	preparationIdType_GT?: InputMaybe<Scalars["Int"]>;
	preparationIdType_GTE?: InputMaybe<Scalars["Int"]>;
	preparationIdType_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationIdType_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationIdType_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationIdType_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationIdType_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationIdType_LT?: InputMaybe<Scalars["Int"]>;
	preparationIdType_LTE?: InputMaybe<Scalars["Int"]>;
	preparationIdType_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationIdType_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationIdType_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationIdType_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationIdType_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	preparationId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	preparationId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	preparationId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	preparationId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	preparationId_EQUAL?: InputMaybe<Scalars["String"]>;
	preparationId_GT?: InputMaybe<Scalars["Int"]>;
	preparationId_GTE?: InputMaybe<Scalars["Int"]>;
	preparationId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationId_LT?: InputMaybe<Scalars["Int"]>;
	preparationId_LTE?: InputMaybe<Scalars["Int"]>;
	preparationId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	providerId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	providerId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	providerId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	providerId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	providerId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	providerId_EQUAL?: InputMaybe<Scalars["String"]>;
	providerId_GT?: InputMaybe<Scalars["Int"]>;
	providerId_GTE?: InputMaybe<Scalars["Int"]>;
	providerId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	providerId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	providerId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	providerId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	providerId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	providerId_LT?: InputMaybe<Scalars["Int"]>;
	providerId_LTE?: InputMaybe<Scalars["Int"]>;
	providerId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	providerId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	providerId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	providerId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	providerId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	providerName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	providerName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	providerName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	providerName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	providerName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	providerName_EQUAL?: InputMaybe<Scalars["String"]>;
	providerName_GT?: InputMaybe<Scalars["Int"]>;
	providerName_GTE?: InputMaybe<Scalars["Int"]>;
	providerName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	providerName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	providerName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	providerName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	providerName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	providerName_LT?: InputMaybe<Scalars["Int"]>;
	providerName_LTE?: InputMaybe<Scalars["Int"]>;
	providerName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	providerName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	providerName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	providerName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	providerName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	quantity_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	quantity_EQUAL?: InputMaybe<Scalars["String"]>;
	quantity_GT?: InputMaybe<Scalars["Int"]>;
	quantity_GTE?: InputMaybe<Scalars["Int"]>;
	quantity_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	quantity_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	quantity_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	quantity_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	quantity_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	quantity_LT?: InputMaybe<Scalars["Int"]>;
	quantity_LTE?: InputMaybe<Scalars["Int"]>;
	quantity_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	quantity_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	quantity_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	quantity_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	quantity_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	tenantId_EQUAL?: InputMaybe<Scalars["String"]>;
	tenantId_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type TreatmentClaimRelationship = {
	__typename?: "TreatmentClaimRelationship";
	cursor: Scalars["String"];
	node: Claim;
};

export type TreatmentClaimUpdateConnectionInput = {
	node?: InputMaybe<ClaimUpdateInput>;
};

export type TreatmentClaimUpdateFieldInput = {
	connect?: InputMaybe<Array<TreatmentClaimConnectFieldInput>>;
	create?: InputMaybe<Array<TreatmentClaimCreateFieldInput>>;
	delete?: InputMaybe<Array<TreatmentClaimDeleteFieldInput>>;
	disconnect?: InputMaybe<Array<TreatmentClaimDisconnectFieldInput>>;
	update?: InputMaybe<TreatmentClaimUpdateConnectionInput>;
	where?: InputMaybe<TreatmentClaimConnectionWhere>;
};

export type TreatmentConnectInput = {
	Partners?: InputMaybe<Array<TreatmentPartnersConnectFieldInput>>;
	Status?: InputMaybe<TreatmentStatusConnectFieldInput>;
	claim?: InputMaybe<Array<TreatmentClaimConnectFieldInput>>;
	exFactoryPrices?: InputMaybe<Array<TreatmentExFactoryPricesConnectFieldInput>>;
	hasLimitations?: InputMaybe<Array<TreatmentHasLimitationsConnectFieldInput>>;
	publicPrices?: InputMaybe<Array<TreatmentPublicPricesConnectFieldInput>>;
	regulatedBy?: InputMaybe<TreatmentRegulatedByConnectFieldInput>;
};

export type TreatmentConnectWhere = {
	node: TreatmentWhere;
};

export type TreatmentCreateInput = {
	BagDossierNo?: InputMaybe<Scalars["String"]>;
	Code: Scalars["String"];
	FlagModal?: InputMaybe<Scalars["String"]>;
	FlagNarcosis?: InputMaybe<Scalars["String"]>;
	GTIN?: InputMaybe<Scalars["String"]>;
	LOT?: InputMaybe<Scalars["String"]>;
	Name?: InputMaybe<Scalars["String"]>;
	Partners?: InputMaybe<TreatmentPartnersFieldInput>;
	PharmaCode?: InputMaybe<Scalars["String"]>;
	PrevPharmacode?: InputMaybe<Scalars["String"]>;
	REF?: InputMaybe<Scalars["String"]>;
	Status?: InputMaybe<TreatmentStatusFieldInput>;
	SwissmedicCategory?: InputMaybe<Scalars["String"]>;
	SwissmedicNo8?: InputMaybe<Scalars["String"]>;
	UDI?: InputMaybe<Scalars["String"]>;
	canBeMain?: InputMaybe<Scalars["Boolean"]>;
	claim?: InputMaybe<TreatmentClaimFieldInput>;
	classificationSystem?: InputMaybe<Scalars["String"]>;
	exFactoryPrices?: InputMaybe<TreatmentExFactoryPricesFieldInput>;
	hasLimitations?: InputMaybe<TreatmentHasLimitationsFieldInput>;
	publicPrices?: InputMaybe<TreatmentPublicPricesFieldInput>;
	regulatedBy?: InputMaybe<TreatmentRegulatedByFieldInput>;
};

export type TreatmentDeleteInput = {
	Partners?: InputMaybe<Array<TreatmentPartnersDeleteFieldInput>>;
	Status?: InputMaybe<TreatmentStatusDeleteFieldInput>;
	claim?: InputMaybe<Array<TreatmentClaimDeleteFieldInput>>;
	exFactoryPrices?: InputMaybe<Array<TreatmentExFactoryPricesDeleteFieldInput>>;
	hasLimitations?: InputMaybe<Array<TreatmentHasLimitationsDeleteFieldInput>>;
	publicPrices?: InputMaybe<Array<TreatmentPublicPricesDeleteFieldInput>>;
	regulatedBy?: InputMaybe<TreatmentRegulatedByDeleteFieldInput>;
};

export type TreatmentDisconnectInput = {
	Partners?: InputMaybe<Array<TreatmentPartnersDisconnectFieldInput>>;
	Status?: InputMaybe<TreatmentStatusDisconnectFieldInput>;
	claim?: InputMaybe<Array<TreatmentClaimDisconnectFieldInput>>;
	exFactoryPrices?: InputMaybe<Array<TreatmentExFactoryPricesDisconnectFieldInput>>;
	hasLimitations?: InputMaybe<Array<TreatmentHasLimitationsDisconnectFieldInput>>;
	publicPrices?: InputMaybe<Array<TreatmentPublicPricesDisconnectFieldInput>>;
	regulatedBy?: InputMaybe<TreatmentRegulatedByDisconnectFieldInput>;
};

export enum TreatmentDiscontinuationReason {
	Any = "ANY",
	NoInfo = "NO_INFO",
	PatientDeath = "PATIENT_DEATH",
	Trae = "TRAE",
}

export enum TreatmentDurationConditionAspect {
	Discontinued = "DISCONTINUED",
	Lasted = "LASTED",
}

export type TreatmentExFactoryPricesAggregateInput = {
	AND?: InputMaybe<Array<TreatmentExFactoryPricesAggregateInput>>;
	OR?: InputMaybe<Array<TreatmentExFactoryPricesAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<TreatmentExFactoryPricesNodeAggregationWhereInput>;
};

export type TreatmentExFactoryPricesConnectFieldInput = {
	where?: InputMaybe<ExFactoryPriceConnectWhere>;
};

export type TreatmentExFactoryPricesConnection = {
	__typename?: "TreatmentExFactoryPricesConnection";
	edges: Array<TreatmentExFactoryPricesRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type TreatmentExFactoryPricesConnectionSort = {
	node?: InputMaybe<ExFactoryPriceSort>;
};

export type TreatmentExFactoryPricesConnectionWhere = {
	AND?: InputMaybe<Array<TreatmentExFactoryPricesConnectionWhere>>;
	OR?: InputMaybe<Array<TreatmentExFactoryPricesConnectionWhere>>;
	node?: InputMaybe<ExFactoryPriceWhere>;
	node_NOT?: InputMaybe<ExFactoryPriceWhere>;
};

export type TreatmentExFactoryPricesCreateFieldInput = {
	node: ExFactoryPriceCreateInput;
};

export type TreatmentExFactoryPricesDeleteFieldInput = {
	where?: InputMaybe<TreatmentExFactoryPricesConnectionWhere>;
};

export type TreatmentExFactoryPricesDisconnectFieldInput = {
	where?: InputMaybe<TreatmentExFactoryPricesConnectionWhere>;
};

export type TreatmentExFactoryPricesFieldInput = {
	connect?: InputMaybe<Array<TreatmentExFactoryPricesConnectFieldInput>>;
	create?: InputMaybe<Array<TreatmentExFactoryPricesCreateFieldInput>>;
};

export type TreatmentExFactoryPricesNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<TreatmentExFactoryPricesNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<TreatmentExFactoryPricesNodeAggregationWhereInput>>;
	Price_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	Price_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	Price_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	Price_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	Price_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	Price_EQUAL?: InputMaybe<Scalars["String"]>;
	Price_GT?: InputMaybe<Scalars["Int"]>;
	Price_GTE?: InputMaybe<Scalars["Int"]>;
	Price_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Price_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	Price_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	Price_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	Price_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	Price_LT?: InputMaybe<Scalars["Int"]>;
	Price_LTE?: InputMaybe<Scalars["Int"]>;
	Price_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Price_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	Price_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	Price_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	Price_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type TreatmentExFactoryPricesRelationship = {
	__typename?: "TreatmentExFactoryPricesRelationship";
	cursor: Scalars["String"];
	node: ExFactoryPrice;
};

export type TreatmentExFactoryPricesUpdateConnectionInput = {
	node?: InputMaybe<ExFactoryPriceUpdateInput>;
};

export type TreatmentExFactoryPricesUpdateFieldInput = {
	connect?: InputMaybe<Array<TreatmentExFactoryPricesConnectFieldInput>>;
	create?: InputMaybe<Array<TreatmentExFactoryPricesCreateFieldInput>>;
	delete?: InputMaybe<Array<TreatmentExFactoryPricesDeleteFieldInput>>;
	disconnect?: InputMaybe<Array<TreatmentExFactoryPricesDisconnectFieldInput>>;
	update?: InputMaybe<TreatmentExFactoryPricesUpdateConnectionInput>;
	where?: InputMaybe<TreatmentExFactoryPricesConnectionWhere>;
};

export type TreatmentHasLimitationsAggregateInput = {
	AND?: InputMaybe<Array<TreatmentHasLimitationsAggregateInput>>;
	OR?: InputMaybe<Array<TreatmentHasLimitationsAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<TreatmentHasLimitationsNodeAggregationWhereInput>;
};

export type TreatmentHasLimitationsConnectFieldInput = {
	connect?: InputMaybe<Array<LimitationConnectInput>>;
	where?: InputMaybe<LimitationConnectWhere>;
};

export type TreatmentHasLimitationsConnection = {
	__typename?: "TreatmentHasLimitationsConnection";
	edges: Array<TreatmentHasLimitationsRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type TreatmentHasLimitationsConnectionSort = {
	node?: InputMaybe<LimitationSort>;
};

export type TreatmentHasLimitationsConnectionWhere = {
	AND?: InputMaybe<Array<TreatmentHasLimitationsConnectionWhere>>;
	OR?: InputMaybe<Array<TreatmentHasLimitationsConnectionWhere>>;
	node?: InputMaybe<LimitationWhere>;
	node_NOT?: InputMaybe<LimitationWhere>;
};

export type TreatmentHasLimitationsCreateFieldInput = {
	node: LimitationCreateInput;
};

export type TreatmentHasLimitationsDeleteFieldInput = {
	delete?: InputMaybe<LimitationDeleteInput>;
	where?: InputMaybe<TreatmentHasLimitationsConnectionWhere>;
};

export type TreatmentHasLimitationsDisconnectFieldInput = {
	disconnect?: InputMaybe<LimitationDisconnectInput>;
	where?: InputMaybe<TreatmentHasLimitationsConnectionWhere>;
};

export type TreatmentHasLimitationsFieldInput = {
	connect?: InputMaybe<Array<TreatmentHasLimitationsConnectFieldInput>>;
	create?: InputMaybe<Array<TreatmentHasLimitationsCreateFieldInput>>;
};

export type TreatmentHasLimitationsNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<TreatmentHasLimitationsNodeAggregationWhereInput>>;
	Code_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	Code_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	Code_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	Code_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	Code_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	Code_EQUAL?: InputMaybe<Scalars["String"]>;
	Code_GT?: InputMaybe<Scalars["Int"]>;
	Code_GTE?: InputMaybe<Scalars["Int"]>;
	Code_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Code_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	Code_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	Code_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	Code_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	Code_LT?: InputMaybe<Scalars["Int"]>;
	Code_LTE?: InputMaybe<Scalars["Int"]>;
	Code_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Code_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	Code_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	Code_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	Code_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	DescriptionDe_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	DescriptionDe_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	DescriptionDe_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	DescriptionDe_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	DescriptionDe_EQUAL?: InputMaybe<Scalars["String"]>;
	DescriptionDe_GT?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_GTE?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_LT?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_LTE?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	DescriptionEn_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	DescriptionEn_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	DescriptionEn_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	DescriptionEn_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	DescriptionEn_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	DescriptionEn_EQUAL?: InputMaybe<Scalars["String"]>;
	DescriptionEn_GT?: InputMaybe<Scalars["Int"]>;
	DescriptionEn_GTE?: InputMaybe<Scalars["Int"]>;
	DescriptionEn_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	DescriptionEn_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	DescriptionEn_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	DescriptionEn_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	DescriptionEn_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	DescriptionEn_LT?: InputMaybe<Scalars["Int"]>;
	DescriptionEn_LTE?: InputMaybe<Scalars["Int"]>;
	DescriptionEn_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	DescriptionEn_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	DescriptionEn_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	DescriptionEn_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	DescriptionEn_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	Niveau_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	Niveau_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	Niveau_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	Niveau_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	Niveau_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	Niveau_EQUAL?: InputMaybe<Scalars["String"]>;
	Niveau_GT?: InputMaybe<Scalars["Int"]>;
	Niveau_GTE?: InputMaybe<Scalars["Int"]>;
	Niveau_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Niveau_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	Niveau_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	Niveau_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	Niveau_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	Niveau_LT?: InputMaybe<Scalars["Int"]>;
	Niveau_LTE?: InputMaybe<Scalars["Int"]>;
	Niveau_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Niveau_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	Niveau_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	Niveau_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	Niveau_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	OR?: InputMaybe<Array<TreatmentHasLimitationsNodeAggregationWhereInput>>;
	Type_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	Type_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	Type_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	Type_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	Type_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	Type_EQUAL?: InputMaybe<Scalars["String"]>;
	Type_GT?: InputMaybe<Scalars["Int"]>;
	Type_GTE?: InputMaybe<Scalars["Int"]>;
	Type_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Type_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	Type_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	Type_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	Type_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	Type_LT?: InputMaybe<Scalars["Int"]>;
	Type_LTE?: InputMaybe<Scalars["Int"]>;
	Type_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Type_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	Type_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	Type_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	Type_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	uuid_EQUAL?: InputMaybe<Scalars["ID"]>;
};

export type TreatmentHasLimitationsRelationship = {
	__typename?: "TreatmentHasLimitationsRelationship";
	cursor: Scalars["String"];
	node: Limitation;
};

export type TreatmentHasLimitationsUpdateConnectionInput = {
	node?: InputMaybe<LimitationUpdateInput>;
};

export type TreatmentHasLimitationsUpdateFieldInput = {
	connect?: InputMaybe<Array<TreatmentHasLimitationsConnectFieldInput>>;
	create?: InputMaybe<Array<TreatmentHasLimitationsCreateFieldInput>>;
	delete?: InputMaybe<Array<TreatmentHasLimitationsDeleteFieldInput>>;
	disconnect?: InputMaybe<Array<TreatmentHasLimitationsDisconnectFieldInput>>;
	update?: InputMaybe<TreatmentHasLimitationsUpdateConnectionInput>;
	where?: InputMaybe<TreatmentHasLimitationsConnectionWhere>;
};

export type TreatmentOptions = {
	limit?: InputMaybe<Scalars["Int"]>;
	offset?: InputMaybe<Scalars["Int"]>;
	/** Specify one or more TreatmentSort objects to sort Treatments by. The sorts will be applied in the order in which they are arranged in the array. */
	sort?: InputMaybe<Array<InputMaybe<TreatmentSort>>>;
};

export type TreatmentPartnersAggregateInput = {
	AND?: InputMaybe<Array<TreatmentPartnersAggregateInput>>;
	OR?: InputMaybe<Array<TreatmentPartnersAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<TreatmentPartnersNodeAggregationWhereInput>;
};

export type TreatmentPartnersConnectFieldInput = {
	connect?: InputMaybe<Array<PartnerConnectInput>>;
	where?: InputMaybe<PartnerConnectWhere>;
};

export type TreatmentPartnersConnection = {
	__typename?: "TreatmentPartnersConnection";
	edges: Array<TreatmentPartnersRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type TreatmentPartnersConnectionSort = {
	node?: InputMaybe<PartnerSort>;
};

export type TreatmentPartnersConnectionWhere = {
	AND?: InputMaybe<Array<TreatmentPartnersConnectionWhere>>;
	OR?: InputMaybe<Array<TreatmentPartnersConnectionWhere>>;
	node?: InputMaybe<PartnerWhere>;
	node_NOT?: InputMaybe<PartnerWhere>;
};

export type TreatmentPartnersCreateFieldInput = {
	node: PartnerCreateInput;
};

export type TreatmentPartnersDeleteFieldInput = {
	delete?: InputMaybe<PartnerDeleteInput>;
	where?: InputMaybe<TreatmentPartnersConnectionWhere>;
};

export type TreatmentPartnersDisconnectFieldInput = {
	disconnect?: InputMaybe<PartnerDisconnectInput>;
	where?: InputMaybe<TreatmentPartnersConnectionWhere>;
};

export type TreatmentPartnersFieldInput = {
	connect?: InputMaybe<Array<TreatmentPartnersConnectFieldInput>>;
	create?: InputMaybe<Array<TreatmentPartnersCreateFieldInput>>;
};

export type TreatmentPartnersNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<TreatmentPartnersNodeAggregationWhereInput>>;
	Description_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	Description_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	Description_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	Description_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	Description_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	Description_EQUAL?: InputMaybe<Scalars["String"]>;
	Description_GT?: InputMaybe<Scalars["Int"]>;
	Description_GTE?: InputMaybe<Scalars["Int"]>;
	Description_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Description_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	Description_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	Description_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	Description_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	Description_LT?: InputMaybe<Scalars["Int"]>;
	Description_LTE?: InputMaybe<Scalars["Int"]>;
	Description_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Description_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	Description_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	Description_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	Description_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	OR?: InputMaybe<Array<TreatmentPartnersNodeAggregationWhereInput>>;
	PartnerType_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	PartnerType_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	PartnerType_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	PartnerType_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	PartnerType_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	PartnerType_EQUAL?: InputMaybe<Scalars["String"]>;
	PartnerType_GT?: InputMaybe<Scalars["Int"]>;
	PartnerType_GTE?: InputMaybe<Scalars["Int"]>;
	PartnerType_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	PartnerType_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	PartnerType_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	PartnerType_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	PartnerType_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	PartnerType_LT?: InputMaybe<Scalars["Int"]>;
	PartnerType_LTE?: InputMaybe<Scalars["Int"]>;
	PartnerType_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	PartnerType_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	PartnerType_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	PartnerType_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	PartnerType_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	Phone_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	Phone_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	Phone_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	Phone_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	Phone_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	Phone_EQUAL?: InputMaybe<Scalars["String"]>;
	Phone_GT?: InputMaybe<Scalars["Int"]>;
	Phone_GTE?: InputMaybe<Scalars["Int"]>;
	Phone_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Phone_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	Phone_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	Phone_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	Phone_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	Phone_LT?: InputMaybe<Scalars["Int"]>;
	Phone_LTE?: InputMaybe<Scalars["Int"]>;
	Phone_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Phone_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	Phone_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	Phone_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	Phone_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	Place_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	Place_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	Place_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	Place_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	Place_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	Place_EQUAL?: InputMaybe<Scalars["String"]>;
	Place_GT?: InputMaybe<Scalars["Int"]>;
	Place_GTE?: InputMaybe<Scalars["Int"]>;
	Place_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Place_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	Place_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	Place_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	Place_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	Place_LT?: InputMaybe<Scalars["Int"]>;
	Place_LTE?: InputMaybe<Scalars["Int"]>;
	Place_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Place_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	Place_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	Place_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	Place_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	Street_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	Street_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	Street_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	Street_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	Street_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	Street_EQUAL?: InputMaybe<Scalars["String"]>;
	Street_GT?: InputMaybe<Scalars["Int"]>;
	Street_GTE?: InputMaybe<Scalars["Int"]>;
	Street_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Street_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	Street_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	Street_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	Street_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	Street_LT?: InputMaybe<Scalars["Int"]>;
	Street_LTE?: InputMaybe<Scalars["Int"]>;
	Street_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Street_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	Street_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	Street_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	Street_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	ZipCode_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	ZipCode_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	ZipCode_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	ZipCode_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	ZipCode_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	ZipCode_EQUAL?: InputMaybe<Scalars["Int"]>;
	ZipCode_GT?: InputMaybe<Scalars["Int"]>;
	ZipCode_GTE?: InputMaybe<Scalars["Int"]>;
	ZipCode_LT?: InputMaybe<Scalars["Int"]>;
	ZipCode_LTE?: InputMaybe<Scalars["Int"]>;
	ZipCode_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	ZipCode_MAX_GT?: InputMaybe<Scalars["Int"]>;
	ZipCode_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	ZipCode_MAX_LT?: InputMaybe<Scalars["Int"]>;
	ZipCode_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	ZipCode_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	ZipCode_MIN_GT?: InputMaybe<Scalars["Int"]>;
	ZipCode_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	ZipCode_MIN_LT?: InputMaybe<Scalars["Int"]>;
	ZipCode_MIN_LTE?: InputMaybe<Scalars["Int"]>;
};

export type TreatmentPartnersRelationship = {
	__typename?: "TreatmentPartnersRelationship";
	cursor: Scalars["String"];
	node: Partner;
};

export type TreatmentPartnersUpdateConnectionInput = {
	node?: InputMaybe<PartnerUpdateInput>;
};

export type TreatmentPartnersUpdateFieldInput = {
	connect?: InputMaybe<Array<TreatmentPartnersConnectFieldInput>>;
	create?: InputMaybe<Array<TreatmentPartnersCreateFieldInput>>;
	delete?: InputMaybe<Array<TreatmentPartnersDeleteFieldInput>>;
	disconnect?: InputMaybe<Array<TreatmentPartnersDisconnectFieldInput>>;
	update?: InputMaybe<TreatmentPartnersUpdateConnectionInput>;
	where?: InputMaybe<TreatmentPartnersConnectionWhere>;
};

export type TreatmentPatient = {
	__typename?: "TreatmentPatient";
	months: Scalars["Int"];
	noInactivePatients: Scalars["Int"];
	noPatients: Scalars["Int"];
};

export type TreatmentPatientAggregateSelection = {
	__typename?: "TreatmentPatientAggregateSelection";
	count: Scalars["Int"];
	months: IntAggregateSelection;
	noInactivePatients: IntAggregateSelection;
	noPatients: IntAggregateSelection;
};

export type TreatmentPatientOptions = {
	limit?: InputMaybe<Scalars["Int"]>;
	offset?: InputMaybe<Scalars["Int"]>;
	/** Specify one or more TreatmentPatientSort objects to sort TreatmentPatients by. The sorts will be applied in the order in which they are arranged in the array. */
	sort?: InputMaybe<Array<InputMaybe<TreatmentPatientSort>>>;
};

/** Fields to sort TreatmentPatients by. The order in which sorts are applied is not guaranteed when specifying many fields in one TreatmentPatientSort object. */
export type TreatmentPatientSort = {
	months?: InputMaybe<SortDirection>;
	noInactivePatients?: InputMaybe<SortDirection>;
	noPatients?: InputMaybe<SortDirection>;
};

export type TreatmentPatientWhere = {
	AND?: InputMaybe<Array<TreatmentPatientWhere>>;
	OR?: InputMaybe<Array<TreatmentPatientWhere>>;
	months?: InputMaybe<Scalars["Int"]>;
	months_GT?: InputMaybe<Scalars["Int"]>;
	months_GTE?: InputMaybe<Scalars["Int"]>;
	months_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	months_LT?: InputMaybe<Scalars["Int"]>;
	months_LTE?: InputMaybe<Scalars["Int"]>;
	months_NOT?: InputMaybe<Scalars["Int"]>;
	months_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	noInactivePatients?: InputMaybe<Scalars["Int"]>;
	noInactivePatients_GT?: InputMaybe<Scalars["Int"]>;
	noInactivePatients_GTE?: InputMaybe<Scalars["Int"]>;
	noInactivePatients_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	noInactivePatients_LT?: InputMaybe<Scalars["Int"]>;
	noInactivePatients_LTE?: InputMaybe<Scalars["Int"]>;
	noInactivePatients_NOT?: InputMaybe<Scalars["Int"]>;
	noInactivePatients_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	noPatients?: InputMaybe<Scalars["Int"]>;
	noPatients_GT?: InputMaybe<Scalars["Int"]>;
	noPatients_GTE?: InputMaybe<Scalars["Int"]>;
	noPatients_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	noPatients_LT?: InputMaybe<Scalars["Int"]>;
	noPatients_LTE?: InputMaybe<Scalars["Int"]>;
	noPatients_NOT?: InputMaybe<Scalars["Int"]>;
	noPatients_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
};

export type TreatmentPrescriptionRelationship = {
	date?: Maybe<Scalars["Date"]>;
	quantity?: Maybe<Scalars["Int"]>;
	status?: Maybe<RecordStatus>;
	uuid: Scalars["ID"];
};

export type TreatmentPrescriptionRelationshipCreateInput = {
	date?: InputMaybe<Scalars["Date"]>;
	quantity?: InputMaybe<Scalars["Int"]>;
	status?: InputMaybe<RecordStatus>;
	uuid: Scalars["ID"];
};

export type TreatmentPrescriptionRelationshipInput = {
	date?: InputMaybe<Scalars["Date"]>;
	from?: InputMaybe<Scalars["String"]>;
	quantity?: InputMaybe<Scalars["Int"]>;
	to?: InputMaybe<Scalars["String"]>;
};

export type TreatmentPrescriptionRelationshipSort = {
	date?: InputMaybe<SortDirection>;
	quantity?: InputMaybe<SortDirection>;
	status?: InputMaybe<SortDirection>;
	uuid?: InputMaybe<SortDirection>;
};

export type TreatmentPrescriptionRelationshipUpdateInput = {
	date?: InputMaybe<Scalars["Date"]>;
	quantity?: InputMaybe<Scalars["Int"]>;
	status?: InputMaybe<RecordStatus>;
	uuid?: InputMaybe<Scalars["ID"]>;
};

export type TreatmentPrescriptionRelationshipWhere = {
	AND?: InputMaybe<Array<TreatmentPrescriptionRelationshipWhere>>;
	OR?: InputMaybe<Array<TreatmentPrescriptionRelationshipWhere>>;
	date?: InputMaybe<Scalars["Date"]>;
	date_GT?: InputMaybe<Scalars["Date"]>;
	date_GTE?: InputMaybe<Scalars["Date"]>;
	date_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
	date_LT?: InputMaybe<Scalars["Date"]>;
	date_LTE?: InputMaybe<Scalars["Date"]>;
	date_NOT?: InputMaybe<Scalars["Date"]>;
	date_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
	quantity?: InputMaybe<Scalars["Int"]>;
	quantity_GT?: InputMaybe<Scalars["Int"]>;
	quantity_GTE?: InputMaybe<Scalars["Int"]>;
	quantity_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	quantity_LT?: InputMaybe<Scalars["Int"]>;
	quantity_LTE?: InputMaybe<Scalars["Int"]>;
	quantity_NOT?: InputMaybe<Scalars["Int"]>;
	quantity_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
	status?: InputMaybe<RecordStatus>;
	status_IN?: InputMaybe<Array<InputMaybe<RecordStatus>>>;
	status_NOT?: InputMaybe<RecordStatus>;
	status_NOT_IN?: InputMaybe<Array<InputMaybe<RecordStatus>>>;
	uuid?: InputMaybe<Scalars["ID"]>;
	uuid_CONTAINS?: InputMaybe<Scalars["ID"]>;
	uuid_ENDS_WITH?: InputMaybe<Scalars["ID"]>;
	uuid_IN?: InputMaybe<Array<InputMaybe<Scalars["ID"]>>>;
	uuid_MATCHES?: InputMaybe<Scalars["String"]>;
	uuid_NOT?: InputMaybe<Scalars["ID"]>;
	uuid_NOT_CONTAINS?: InputMaybe<Scalars["ID"]>;
	uuid_NOT_ENDS_WITH?: InputMaybe<Scalars["ID"]>;
	uuid_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["ID"]>>>;
	uuid_NOT_STARTS_WITH?: InputMaybe<Scalars["ID"]>;
	uuid_STARTS_WITH?: InputMaybe<Scalars["ID"]>;
};

export type TreatmentPublicPricesAggregateInput = {
	AND?: InputMaybe<Array<TreatmentPublicPricesAggregateInput>>;
	OR?: InputMaybe<Array<TreatmentPublicPricesAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<TreatmentPublicPricesNodeAggregationWhereInput>;
};

export type TreatmentPublicPricesConnectFieldInput = {
	where?: InputMaybe<PublicPriceConnectWhere>;
};

export type TreatmentPublicPricesConnection = {
	__typename?: "TreatmentPublicPricesConnection";
	edges: Array<TreatmentPublicPricesRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type TreatmentPublicPricesConnectionSort = {
	node?: InputMaybe<PublicPriceSort>;
};

export type TreatmentPublicPricesConnectionWhere = {
	AND?: InputMaybe<Array<TreatmentPublicPricesConnectionWhere>>;
	OR?: InputMaybe<Array<TreatmentPublicPricesConnectionWhere>>;
	node?: InputMaybe<PublicPriceWhere>;
	node_NOT?: InputMaybe<PublicPriceWhere>;
};

export type TreatmentPublicPricesCreateFieldInput = {
	node: PublicPriceCreateInput;
};

export type TreatmentPublicPricesDeleteFieldInput = {
	where?: InputMaybe<TreatmentPublicPricesConnectionWhere>;
};

export type TreatmentPublicPricesDisconnectFieldInput = {
	where?: InputMaybe<TreatmentPublicPricesConnectionWhere>;
};

export type TreatmentPublicPricesFieldInput = {
	connect?: InputMaybe<Array<TreatmentPublicPricesConnectFieldInput>>;
	create?: InputMaybe<Array<TreatmentPublicPricesCreateFieldInput>>;
};

export type TreatmentPublicPricesNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<TreatmentPublicPricesNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<TreatmentPublicPricesNodeAggregationWhereInput>>;
	Price_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	Price_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	Price_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	Price_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	Price_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	Price_EQUAL?: InputMaybe<Scalars["String"]>;
	Price_GT?: InputMaybe<Scalars["Int"]>;
	Price_GTE?: InputMaybe<Scalars["Int"]>;
	Price_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Price_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	Price_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	Price_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	Price_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	Price_LT?: InputMaybe<Scalars["Int"]>;
	Price_LTE?: InputMaybe<Scalars["Int"]>;
	Price_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	Price_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	Price_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	Price_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	Price_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type TreatmentPublicPricesRelationship = {
	__typename?: "TreatmentPublicPricesRelationship";
	cursor: Scalars["String"];
	node: PublicPrice;
};

export type TreatmentPublicPricesUpdateConnectionInput = {
	node?: InputMaybe<PublicPriceUpdateInput>;
};

export type TreatmentPublicPricesUpdateFieldInput = {
	connect?: InputMaybe<Array<TreatmentPublicPricesConnectFieldInput>>;
	create?: InputMaybe<Array<TreatmentPublicPricesCreateFieldInput>>;
	delete?: InputMaybe<Array<TreatmentPublicPricesDeleteFieldInput>>;
	disconnect?: InputMaybe<Array<TreatmentPublicPricesDisconnectFieldInput>>;
	update?: InputMaybe<TreatmentPublicPricesUpdateConnectionInput>;
	where?: InputMaybe<TreatmentPublicPricesConnectionWhere>;
};

export type TreatmentRegulatedByAggregateInput = {
	AND?: InputMaybe<Array<TreatmentRegulatedByAggregateInput>>;
	OR?: InputMaybe<Array<TreatmentRegulatedByAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<TreatmentRegulatedByNodeAggregationWhereInput>;
};

export type TreatmentRegulatedByConnectFieldInput = {
	connect?: InputMaybe<PreparationConnectInput>;
	where?: InputMaybe<PreparationConnectWhere>;
};

export type TreatmentRegulatedByConnection = {
	__typename?: "TreatmentRegulatedByConnection";
	edges: Array<TreatmentRegulatedByRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type TreatmentRegulatedByConnectionSort = {
	node?: InputMaybe<PreparationSort>;
};

export type TreatmentRegulatedByConnectionWhere = {
	AND?: InputMaybe<Array<TreatmentRegulatedByConnectionWhere>>;
	OR?: InputMaybe<Array<TreatmentRegulatedByConnectionWhere>>;
	node?: InputMaybe<PreparationWhere>;
	node_NOT?: InputMaybe<PreparationWhere>;
};

export type TreatmentRegulatedByCreateFieldInput = {
	node: PreparationCreateInput;
};

export type TreatmentRegulatedByDeleteFieldInput = {
	delete?: InputMaybe<PreparationDeleteInput>;
	where?: InputMaybe<TreatmentRegulatedByConnectionWhere>;
};

export type TreatmentRegulatedByDisconnectFieldInput = {
	disconnect?: InputMaybe<PreparationDisconnectInput>;
	where?: InputMaybe<TreatmentRegulatedByConnectionWhere>;
};

export type TreatmentRegulatedByFieldInput = {
	connect?: InputMaybe<TreatmentRegulatedByConnectFieldInput>;
	create?: InputMaybe<TreatmentRegulatedByCreateFieldInput>;
};

export type TreatmentRegulatedByNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<TreatmentRegulatedByNodeAggregationWhereInput>>;
	AtcCode_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	AtcCode_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	AtcCode_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	AtcCode_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	AtcCode_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	AtcCode_EQUAL?: InputMaybe<Scalars["String"]>;
	AtcCode_GT?: InputMaybe<Scalars["Int"]>;
	AtcCode_GTE?: InputMaybe<Scalars["Int"]>;
	AtcCode_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	AtcCode_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	AtcCode_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	AtcCode_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	AtcCode_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	AtcCode_LT?: InputMaybe<Scalars["Int"]>;
	AtcCode_LTE?: InputMaybe<Scalars["Int"]>;
	AtcCode_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	AtcCode_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	AtcCode_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	AtcCode_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	AtcCode_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	BrandName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	BrandName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	BrandName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	BrandName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	BrandName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	BrandName_EQUAL?: InputMaybe<Scalars["String"]>;
	BrandName_GT?: InputMaybe<Scalars["Int"]>;
	BrandName_GTE?: InputMaybe<Scalars["Int"]>;
	BrandName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	BrandName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	BrandName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	BrandName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	BrandName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	BrandName_LT?: InputMaybe<Scalars["Int"]>;
	BrandName_LTE?: InputMaybe<Scalars["Int"]>;
	BrandName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	BrandName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	BrandName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	BrandName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	BrandName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	DescriptionDe_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	DescriptionDe_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	DescriptionDe_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	DescriptionDe_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	DescriptionDe_EQUAL?: InputMaybe<Scalars["String"]>;
	DescriptionDe_GT?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_GTE?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_LT?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_LTE?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	DescriptionDe_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	GenericName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	GenericName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	GenericName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	GenericName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	GenericName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	GenericName_EQUAL?: InputMaybe<Scalars["String"]>;
	GenericName_GT?: InputMaybe<Scalars["Int"]>;
	GenericName_GTE?: InputMaybe<Scalars["Int"]>;
	GenericName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	GenericName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	GenericName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	GenericName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	GenericName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	GenericName_LT?: InputMaybe<Scalars["Int"]>;
	GenericName_LTE?: InputMaybe<Scalars["Int"]>;
	GenericName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	GenericName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	GenericName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	GenericName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	GenericName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	OR?: InputMaybe<Array<TreatmentRegulatedByNodeAggregationWhereInput>>;
	SwissmedicNo5_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo5_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo5_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo5_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo5_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	SwissmedicNo5_EQUAL?: InputMaybe<Scalars["String"]>;
	SwissmedicNo5_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo5_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo5_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo5_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo5_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo5_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo5_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo5_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo5_LTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo5_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo5_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo5_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo5_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	SwissmedicNo5_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
};

export type TreatmentRegulatedByRelationship = {
	__typename?: "TreatmentRegulatedByRelationship";
	cursor: Scalars["String"];
	node: Preparation;
};

export type TreatmentRegulatedByUpdateConnectionInput = {
	node?: InputMaybe<PreparationUpdateInput>;
};

export type TreatmentRegulatedByUpdateFieldInput = {
	connect?: InputMaybe<TreatmentRegulatedByConnectFieldInput>;
	create?: InputMaybe<TreatmentRegulatedByCreateFieldInput>;
	delete?: InputMaybe<TreatmentRegulatedByDeleteFieldInput>;
	disconnect?: InputMaybe<TreatmentRegulatedByDisconnectFieldInput>;
	update?: InputMaybe<TreatmentRegulatedByUpdateConnectionInput>;
	where?: InputMaybe<TreatmentRegulatedByConnectionWhere>;
};

/** Fields to sort Treatments by. The order in which sorts are applied is not guaranteed when specifying many fields in one TreatmentSort object. */
export type TreatmentSort = {
	BagDossierNo?: InputMaybe<SortDirection>;
	Code?: InputMaybe<SortDirection>;
	FlagModal?: InputMaybe<SortDirection>;
	FlagNarcosis?: InputMaybe<SortDirection>;
	GTIN?: InputMaybe<SortDirection>;
	LOT?: InputMaybe<SortDirection>;
	Name?: InputMaybe<SortDirection>;
	PharmaCode?: InputMaybe<SortDirection>;
	PrevPharmacode?: InputMaybe<SortDirection>;
	REF?: InputMaybe<SortDirection>;
	SwissmedicCategory?: InputMaybe<SortDirection>;
	SwissmedicNo8?: InputMaybe<SortDirection>;
	UDI?: InputMaybe<SortDirection>;
	canBeMain?: InputMaybe<SortDirection>;
	classificationSystem?: InputMaybe<SortDirection>;
};

export type TreatmentStatusAggregateInput = {
	AND?: InputMaybe<Array<TreatmentStatusAggregateInput>>;
	OR?: InputMaybe<Array<TreatmentStatusAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<TreatmentStatusNodeAggregationWhereInput>;
};

export type TreatmentStatusConnectFieldInput = {
	connect?: InputMaybe<PreparationStatusConnectInput>;
	where?: InputMaybe<PreparationStatusConnectWhere>;
};

export type TreatmentStatusConnection = {
	__typename?: "TreatmentStatusConnection";
	edges: Array<TreatmentStatusRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type TreatmentStatusConnectionSort = {
	node?: InputMaybe<PreparationStatusSort>;
};

export type TreatmentStatusConnectionWhere = {
	AND?: InputMaybe<Array<TreatmentStatusConnectionWhere>>;
	OR?: InputMaybe<Array<TreatmentStatusConnectionWhere>>;
	node?: InputMaybe<PreparationStatusWhere>;
	node_NOT?: InputMaybe<PreparationStatusWhere>;
};

export type TreatmentStatusCreateFieldInput = {
	node: PreparationStatusCreateInput;
};

export type TreatmentStatusDeleteFieldInput = {
	delete?: InputMaybe<PreparationStatusDeleteInput>;
	where?: InputMaybe<TreatmentStatusConnectionWhere>;
};

export type TreatmentStatusDisconnectFieldInput = {
	disconnect?: InputMaybe<PreparationStatusDisconnectInput>;
	where?: InputMaybe<TreatmentStatusConnectionWhere>;
};

export type TreatmentStatusFieldInput = {
	connect?: InputMaybe<TreatmentStatusConnectFieldInput>;
	create?: InputMaybe<TreatmentStatusCreateFieldInput>;
};

export type TreatmentStatusNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<TreatmentStatusNodeAggregationWhereInput>>;
	FlagApd_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	FlagApd_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	FlagApd_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	FlagApd_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	FlagApd_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	FlagApd_EQUAL?: InputMaybe<Scalars["String"]>;
	FlagApd_GT?: InputMaybe<Scalars["Int"]>;
	FlagApd_GTE?: InputMaybe<Scalars["Int"]>;
	FlagApd_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	FlagApd_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	FlagApd_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	FlagApd_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	FlagApd_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	FlagApd_LT?: InputMaybe<Scalars["Int"]>;
	FlagApd_LTE?: InputMaybe<Scalars["Int"]>;
	FlagApd_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	FlagApd_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	FlagApd_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	FlagApd_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	FlagApd_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	OR?: InputMaybe<Array<TreatmentStatusNodeAggregationWhereInput>>;
	StatusTypeCodeSl_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	StatusTypeCodeSl_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	StatusTypeCodeSl_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	StatusTypeCodeSl_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	StatusTypeCodeSl_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	StatusTypeCodeSl_EQUAL?: InputMaybe<Scalars["String"]>;
	StatusTypeCodeSl_GT?: InputMaybe<Scalars["Int"]>;
	StatusTypeCodeSl_GTE?: InputMaybe<Scalars["Int"]>;
	StatusTypeCodeSl_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	StatusTypeCodeSl_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	StatusTypeCodeSl_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	StatusTypeCodeSl_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	StatusTypeCodeSl_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	StatusTypeCodeSl_LT?: InputMaybe<Scalars["Int"]>;
	StatusTypeCodeSl_LTE?: InputMaybe<Scalars["Int"]>;
	StatusTypeCodeSl_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	StatusTypeCodeSl_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	StatusTypeCodeSl_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	StatusTypeCodeSl_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	StatusTypeCodeSl_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	StatusTypeDescriptionSl_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	StatusTypeDescriptionSl_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	StatusTypeDescriptionSl_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	StatusTypeDescriptionSl_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	StatusTypeDescriptionSl_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	StatusTypeDescriptionSl_EQUAL?: InputMaybe<Scalars["String"]>;
	StatusTypeDescriptionSl_GT?: InputMaybe<Scalars["Int"]>;
	StatusTypeDescriptionSl_GTE?: InputMaybe<Scalars["Int"]>;
	StatusTypeDescriptionSl_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	StatusTypeDescriptionSl_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	StatusTypeDescriptionSl_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	StatusTypeDescriptionSl_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	StatusTypeDescriptionSl_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	StatusTypeDescriptionSl_LT?: InputMaybe<Scalars["Int"]>;
	StatusTypeDescriptionSl_LTE?: InputMaybe<Scalars["Int"]>;
	StatusTypeDescriptionSl_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	StatusTypeDescriptionSl_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	StatusTypeDescriptionSl_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	StatusTypeDescriptionSl_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	StatusTypeDescriptionSl_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type TreatmentStatusRelationship = {
	__typename?: "TreatmentStatusRelationship";
	cursor: Scalars["String"];
	node: PreparationStatus;
};

export type TreatmentStatusUpdateConnectionInput = {
	node?: InputMaybe<PreparationStatusUpdateInput>;
};

export type TreatmentStatusUpdateFieldInput = {
	connect?: InputMaybe<TreatmentStatusConnectFieldInput>;
	create?: InputMaybe<TreatmentStatusCreateFieldInput>;
	delete?: InputMaybe<TreatmentStatusDeleteFieldInput>;
	disconnect?: InputMaybe<TreatmentStatusDisconnectFieldInput>;
	update?: InputMaybe<TreatmentStatusUpdateConnectionInput>;
	where?: InputMaybe<TreatmentStatusConnectionWhere>;
};

export type TreatmentUpdateInput = {
	BagDossierNo?: InputMaybe<Scalars["String"]>;
	Code?: InputMaybe<Scalars["String"]>;
	FlagModal?: InputMaybe<Scalars["String"]>;
	FlagNarcosis?: InputMaybe<Scalars["String"]>;
	GTIN?: InputMaybe<Scalars["String"]>;
	LOT?: InputMaybe<Scalars["String"]>;
	Name?: InputMaybe<Scalars["String"]>;
	Partners?: InputMaybe<Array<TreatmentPartnersUpdateFieldInput>>;
	PharmaCode?: InputMaybe<Scalars["String"]>;
	PrevPharmacode?: InputMaybe<Scalars["String"]>;
	REF?: InputMaybe<Scalars["String"]>;
	Status?: InputMaybe<TreatmentStatusUpdateFieldInput>;
	SwissmedicCategory?: InputMaybe<Scalars["String"]>;
	SwissmedicNo8?: InputMaybe<Scalars["String"]>;
	UDI?: InputMaybe<Scalars["String"]>;
	canBeMain?: InputMaybe<Scalars["Boolean"]>;
	claim?: InputMaybe<Array<TreatmentClaimUpdateFieldInput>>;
	classificationSystem?: InputMaybe<Scalars["String"]>;
	exFactoryPrices?: InputMaybe<Array<TreatmentExFactoryPricesUpdateFieldInput>>;
	hasLimitations?: InputMaybe<Array<TreatmentHasLimitationsUpdateFieldInput>>;
	publicPrices?: InputMaybe<Array<TreatmentPublicPricesUpdateFieldInput>>;
	regulatedBy?: InputMaybe<TreatmentRegulatedByUpdateFieldInput>;
};

export type TreatmentWhere = {
	AND?: InputMaybe<Array<TreatmentWhere>>;
	BagDossierNo?: InputMaybe<Scalars["String"]>;
	BagDossierNo_CONTAINS?: InputMaybe<Scalars["String"]>;
	BagDossierNo_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	BagDossierNo_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	BagDossierNo_MATCHES?: InputMaybe<Scalars["String"]>;
	BagDossierNo_NOT?: InputMaybe<Scalars["String"]>;
	BagDossierNo_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	BagDossierNo_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	BagDossierNo_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	BagDossierNo_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	BagDossierNo_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	Code?: InputMaybe<Scalars["String"]>;
	Code_CONTAINS?: InputMaybe<Scalars["String"]>;
	Code_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	Code_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	Code_MATCHES?: InputMaybe<Scalars["String"]>;
	Code_NOT?: InputMaybe<Scalars["String"]>;
	Code_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	Code_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	Code_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	Code_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	Code_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	FlagModal?: InputMaybe<Scalars["String"]>;
	FlagModal_CONTAINS?: InputMaybe<Scalars["String"]>;
	FlagModal_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	FlagModal_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	FlagModal_MATCHES?: InputMaybe<Scalars["String"]>;
	FlagModal_NOT?: InputMaybe<Scalars["String"]>;
	FlagModal_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	FlagModal_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	FlagModal_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	FlagModal_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	FlagModal_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	FlagNarcosis?: InputMaybe<Scalars["String"]>;
	FlagNarcosis_CONTAINS?: InputMaybe<Scalars["String"]>;
	FlagNarcosis_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	FlagNarcosis_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	FlagNarcosis_MATCHES?: InputMaybe<Scalars["String"]>;
	FlagNarcosis_NOT?: InputMaybe<Scalars["String"]>;
	FlagNarcosis_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	FlagNarcosis_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	FlagNarcosis_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	FlagNarcosis_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	FlagNarcosis_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	GTIN?: InputMaybe<Scalars["String"]>;
	GTIN_CONTAINS?: InputMaybe<Scalars["String"]>;
	GTIN_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	GTIN_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	GTIN_MATCHES?: InputMaybe<Scalars["String"]>;
	GTIN_NOT?: InputMaybe<Scalars["String"]>;
	GTIN_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	GTIN_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	GTIN_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	GTIN_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	GTIN_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	LOT?: InputMaybe<Scalars["String"]>;
	LOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	LOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	LOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	LOT_MATCHES?: InputMaybe<Scalars["String"]>;
	LOT_NOT?: InputMaybe<Scalars["String"]>;
	LOT_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	LOT_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	LOT_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	LOT_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	LOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	Name?: InputMaybe<Scalars["String"]>;
	Name_CONTAINS?: InputMaybe<Scalars["String"]>;
	Name_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	Name_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	Name_MATCHES?: InputMaybe<Scalars["String"]>;
	Name_NOT?: InputMaybe<Scalars["String"]>;
	Name_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	Name_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	Name_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	Name_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	Name_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	OR?: InputMaybe<Array<TreatmentWhere>>;
	Partners?: InputMaybe<PartnerWhere>;
	PartnersAggregate?: InputMaybe<TreatmentPartnersAggregateInput>;
	PartnersConnection?: InputMaybe<TreatmentPartnersConnectionWhere>;
	PartnersConnection_NOT?: InputMaybe<TreatmentPartnersConnectionWhere>;
	Partners_NOT?: InputMaybe<PartnerWhere>;
	PharmaCode?: InputMaybe<Scalars["String"]>;
	PharmaCode_CONTAINS?: InputMaybe<Scalars["String"]>;
	PharmaCode_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	PharmaCode_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	PharmaCode_MATCHES?: InputMaybe<Scalars["String"]>;
	PharmaCode_NOT?: InputMaybe<Scalars["String"]>;
	PharmaCode_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	PharmaCode_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	PharmaCode_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	PharmaCode_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	PharmaCode_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	PrevPharmacode?: InputMaybe<Scalars["String"]>;
	PrevPharmacode_CONTAINS?: InputMaybe<Scalars["String"]>;
	PrevPharmacode_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	PrevPharmacode_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	PrevPharmacode_MATCHES?: InputMaybe<Scalars["String"]>;
	PrevPharmacode_NOT?: InputMaybe<Scalars["String"]>;
	PrevPharmacode_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	PrevPharmacode_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	PrevPharmacode_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	PrevPharmacode_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	PrevPharmacode_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	REF?: InputMaybe<Scalars["String"]>;
	REF_CONTAINS?: InputMaybe<Scalars["String"]>;
	REF_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	REF_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	REF_MATCHES?: InputMaybe<Scalars["String"]>;
	REF_NOT?: InputMaybe<Scalars["String"]>;
	REF_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	REF_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	REF_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	REF_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	REF_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	Status?: InputMaybe<PreparationStatusWhere>;
	StatusAggregate?: InputMaybe<TreatmentStatusAggregateInput>;
	StatusConnection?: InputMaybe<TreatmentStatusConnectionWhere>;
	StatusConnection_NOT?: InputMaybe<TreatmentStatusConnectionWhere>;
	Status_NOT?: InputMaybe<PreparationStatusWhere>;
	SwissmedicCategory?: InputMaybe<Scalars["String"]>;
	SwissmedicCategory_CONTAINS?: InputMaybe<Scalars["String"]>;
	SwissmedicCategory_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	SwissmedicCategory_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	SwissmedicCategory_MATCHES?: InputMaybe<Scalars["String"]>;
	SwissmedicCategory_NOT?: InputMaybe<Scalars["String"]>;
	SwissmedicCategory_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	SwissmedicCategory_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	SwissmedicCategory_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	SwissmedicCategory_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	SwissmedicCategory_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	SwissmedicNo8?: InputMaybe<Scalars["String"]>;
	SwissmedicNo8_CONTAINS?: InputMaybe<Scalars["String"]>;
	SwissmedicNo8_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	SwissmedicNo8_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	SwissmedicNo8_MATCHES?: InputMaybe<Scalars["String"]>;
	SwissmedicNo8_NOT?: InputMaybe<Scalars["String"]>;
	SwissmedicNo8_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	SwissmedicNo8_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	SwissmedicNo8_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	SwissmedicNo8_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	SwissmedicNo8_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	UDI?: InputMaybe<Scalars["String"]>;
	UDI_CONTAINS?: InputMaybe<Scalars["String"]>;
	UDI_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	UDI_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	UDI_MATCHES?: InputMaybe<Scalars["String"]>;
	UDI_NOT?: InputMaybe<Scalars["String"]>;
	UDI_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	UDI_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	UDI_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	UDI_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	UDI_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	canBeMain?: InputMaybe<Scalars["Boolean"]>;
	canBeMain_NOT?: InputMaybe<Scalars["Boolean"]>;
	claim?: InputMaybe<ClaimWhere>;
	claimAggregate?: InputMaybe<TreatmentClaimAggregateInput>;
	claimConnection?: InputMaybe<TreatmentClaimConnectionWhere>;
	claimConnection_NOT?: InputMaybe<TreatmentClaimConnectionWhere>;
	claim_NOT?: InputMaybe<ClaimWhere>;
	classificationSystem?: InputMaybe<Scalars["String"]>;
	classificationSystem_CONTAINS?: InputMaybe<Scalars["String"]>;
	classificationSystem_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	classificationSystem_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	classificationSystem_MATCHES?: InputMaybe<Scalars["String"]>;
	classificationSystem_NOT?: InputMaybe<Scalars["String"]>;
	classificationSystem_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	classificationSystem_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	classificationSystem_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	classificationSystem_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	classificationSystem_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	exFactoryPrices?: InputMaybe<ExFactoryPriceWhere>;
	exFactoryPricesAggregate?: InputMaybe<TreatmentExFactoryPricesAggregateInput>;
	exFactoryPricesConnection?: InputMaybe<TreatmentExFactoryPricesConnectionWhere>;
	exFactoryPricesConnection_NOT?: InputMaybe<TreatmentExFactoryPricesConnectionWhere>;
	exFactoryPrices_NOT?: InputMaybe<ExFactoryPriceWhere>;
	hasLimitations?: InputMaybe<LimitationWhere>;
	hasLimitationsAggregate?: InputMaybe<TreatmentHasLimitationsAggregateInput>;
	hasLimitationsConnection?: InputMaybe<TreatmentHasLimitationsConnectionWhere>;
	hasLimitationsConnection_NOT?: InputMaybe<TreatmentHasLimitationsConnectionWhere>;
	hasLimitations_NOT?: InputMaybe<LimitationWhere>;
	publicPrices?: InputMaybe<PublicPriceWhere>;
	publicPricesAggregate?: InputMaybe<TreatmentPublicPricesAggregateInput>;
	publicPricesConnection?: InputMaybe<TreatmentPublicPricesConnectionWhere>;
	publicPricesConnection_NOT?: InputMaybe<TreatmentPublicPricesConnectionWhere>;
	publicPrices_NOT?: InputMaybe<PublicPriceWhere>;
	regulatedBy?: InputMaybe<PreparationWhere>;
	regulatedByAggregate?: InputMaybe<TreatmentRegulatedByAggregateInput>;
	regulatedByConnection?: InputMaybe<TreatmentRegulatedByConnectionWhere>;
	regulatedByConnection_NOT?: InputMaybe<TreatmentRegulatedByConnectionWhere>;
	regulatedBy_NOT?: InputMaybe<PreparationWhere>;
};

export type UniqueClaimsIdentifiers = {
	administrationDate?: InputMaybe<Scalars["String"]>;
	invoiceDate?: InputMaybe<Scalars["String"]>;
	invoiceNumber?: InputMaybe<Scalars["String"]>;
	preparationId?: InputMaybe<Scalars["String"]>;
};

export type UniqueDeviceRecordIdentifiersInput = {
	deviceId: Scalars["String"];
	orderLineNumber: Scalars["Int"];
	orderNumber: Scalars["Int"];
	saleDate: Scalars["String"];
};

export type UpdateAdverseEventsOccurenceReportsMutationResponse = {
	__typename?: "UpdateAdverseEventsOccurenceReportsMutationResponse";
	adverseEventsOccurenceReports: Array<AdverseEventsOccurenceReport>;
	info: UpdateInfo;
};

export type UpdateCaseAssigneeInput = {
	caseId: Scalars["ID"];
	email?: InputMaybe<Scalars["String"]>;
	userId: Scalars["String"];
};

export type UpdateInfo = {
	__typename?: "UpdateInfo";
	bookmark?: Maybe<Scalars["String"]>;
	nodesCreated: Scalars["Int"];
	nodesDeleted: Scalars["Int"];
	relationshipsCreated: Scalars["Int"];
	relationshipsDeleted: Scalars["Int"];
};

export type UpdateInitialResponseReviewReportsMutationResponse = {
	__typename?: "UpdateInitialResponseReviewReportsMutationResponse";
	info: UpdateInfo;
	initialResponseReviewReports: Array<InitialResponseReviewReport>;
};

export type UpdateInvoiceForReviewInput = {
	deletedRefunds?: InputMaybe<Array<InputMaybe<Scalars["ID"]>>>;
	invoiceAmount: Scalars["Int"];
	invoiceId: Scalars["ID"];
	refunds: Array<Scalars["ID"]>;
};

export type UpdateReasonOfTreatmentDiscontinuationReportsMutationResponse = {
	__typename?: "UpdateReasonOfTreatmentDiscontinuationReportsMutationResponse";
	info: UpdateInfo;
	reasonOfTreatmentDiscontinuationReports: Array<ReasonOfTreatmentDiscontinuationReport>;
};

export type UpdateUsersMutationResponse = {
	__typename?: "UpdateUsersMutationResponse";
	info: UpdateInfo;
	users: Array<User>;
};

export type UploadClaimsInput = {
	administrationDate?: InputMaybe<Scalars["DateTime"]>;
	id: Scalars["ID"];
	insuranceId: Scalars["String"];
	invoiceAmount?: InputMaybe<Scalars["String"]>;
	invoiceDate?: InputMaybe<Scalars["DateTime"]>;
	invoiceNumber?: InputMaybe<Scalars["String"]>;
	patientId?: InputMaybe<Scalars["String"]>;
	preparationId: Scalars["String"];
	preparationIdType?: InputMaybe<Scalars["String"]>;
	providerId?: InputMaybe<Scalars["String"]>;
	providerName?: InputMaybe<Scalars["String"]>;
	quantity?: InputMaybe<Scalars["String"]>;
};

export type UploadDeviceRecordsInput = {
	deviceId: Scalars["String"];
	deviceName: Scalars["String"];
	deviceRef?: InputMaybe<Scalars["String"]>;
	id: Scalars["ID"];
	invoicedSales: Scalars["Float"];
	orderLineNumber: Scalars["Int"];
	orderNumber: Scalars["Int"];
	price: Scalars["Float"];
	productCategoryNameFirstLevel?: InputMaybe<Scalars["String"]>;
	productCategoryNameSecLevel: Scalars["String"];
	productCategoryNameThirdLevel?: InputMaybe<Scalars["String"]>;
	productSecCategoryCode: Scalars["String"];
	providerId: Scalars["String"];
	providerName?: InputMaybe<Scalars["String"]>;
	quantity: Scalars["Int"];
	refundPercentage?: InputMaybe<Scalars["Float"]>;
	saleDate: Scalars["String"];
};

export type User = {
	__typename?: "User";
	claims: Array<Maybe<Claim>>;
	claimsConnection: UserClaimsConnection;
	context?: Maybe<UserContext>;
	contextConnection: UserContextConnection;
	email: Scalars["String"];
	firstName: Scalars["String"];
	id: Scalars["ID"];
	lastName: Scalars["String"];
	mentions?: Maybe<Array<Maybe<Message>>>;
	mentionsConnection: UserMentionsConnection;
	notificationDue: Array<Notification>;
	notificationDueConnection: UserNotificationDueConnection;
	notified: Array<Notification>;
	notifiedConnection: UserNotifiedConnection;
	organization: Organization;
	patients: Array<Maybe<Patient>>;
	patientsConnection: UserPatientsConnection;
	preferredLanguage: Scalars["String"];
	reads: Array<Scalars["String"]>;
	sentMessage?: Maybe<Message>;
	sentMessageConnection: UserSentMessageConnection;
	subscribed: Array<Notification>;
	subscribedConnection: UserSubscribedConnection;
	tasks: Array<Task>;
	tasksConnection: UserTasksConnection;
	tenantId: Scalars["String"];
	writes: Array<Scalars["String"]>;
};

export type UserClaimsArgs = {
	options?: InputMaybe<ClaimOptions>;
	where?: InputMaybe<ClaimWhere>;
};

export type UserClaimsConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<UserClaimsConnectionSort>>;
	where?: InputMaybe<UserClaimsConnectionWhere>;
};

export type UserContextArgs = {
	options?: InputMaybe<UserContextOptions>;
	where?: InputMaybe<UserContextWhere>;
};

export type UserContextConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<UserContextConnectionSort>>;
	where?: InputMaybe<UserContextConnectionWhere>;
};

export type UserMentionsArgs = {
	options?: InputMaybe<MessageOptions>;
	where?: InputMaybe<MessageWhere>;
};

export type UserMentionsConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<UserMentionsConnectionSort>>;
	where?: InputMaybe<UserMentionsConnectionWhere>;
};

export type UserNotificationDueArgs = {
	options?: InputMaybe<NotificationOptions>;
	where?: InputMaybe<NotificationWhere>;
};

export type UserNotificationDueConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<UserNotificationDueConnectionSort>>;
	where?: InputMaybe<UserNotificationDueConnectionWhere>;
};

export type UserNotifiedArgs = {
	options?: InputMaybe<NotificationOptions>;
	where?: InputMaybe<NotificationWhere>;
};

export type UserNotifiedConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<UserNotifiedConnectionSort>>;
	where?: InputMaybe<UserNotifiedConnectionWhere>;
};

export type UserPatientsArgs = {
	options?: InputMaybe<PatientOptions>;
	where?: InputMaybe<PatientWhere>;
};

export type UserPatientsConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<UserPatientsConnectionSort>>;
	where?: InputMaybe<UserPatientsConnectionWhere>;
};

export type UserSentMessageArgs = {
	options?: InputMaybe<MessageOptions>;
	where?: InputMaybe<MessageWhere>;
};

export type UserSentMessageConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<UserSentMessageConnectionSort>>;
	where?: InputMaybe<UserSentMessageConnectionWhere>;
};

export type UserSubscribedArgs = {
	options?: InputMaybe<NotificationOptions>;
	where?: InputMaybe<NotificationWhere>;
};

export type UserSubscribedConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<UserSubscribedConnectionSort>>;
	where?: InputMaybe<UserSubscribedConnectionWhere>;
};

export type UserTasksArgs = {
	options?: InputMaybe<TaskOptions>;
	where?: InputMaybe<TaskWhere>;
};

export type UserTasksConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<UserTasksConnectionSort>>;
	where?: InputMaybe<UserTasksConnectionWhere>;
};

export type UserAggregateSelection = {
	__typename?: "UserAggregateSelection";
	count: Scalars["Int"];
	email: StringAggregateSelection;
	firstName: StringAggregateSelection;
	id: IdAggregateSelection;
	lastName: StringAggregateSelection;
	preferredLanguage: StringAggregateSelection;
	tenantId: StringAggregateSelection;
};

export type UserClaimsAggregateInput = {
	AND?: InputMaybe<Array<UserClaimsAggregateInput>>;
	OR?: InputMaybe<Array<UserClaimsAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<UserClaimsNodeAggregationWhereInput>;
};

export type UserClaimsConnectFieldInput = {
	connect?: InputMaybe<Array<ClaimConnectInput>>;
	where?: InputMaybe<ClaimConnectWhere>;
};

export type UserClaimsConnection = {
	__typename?: "UserClaimsConnection";
	edges: Array<UserClaimsRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type UserClaimsConnectionSort = {
	node?: InputMaybe<ClaimSort>;
};

export type UserClaimsConnectionWhere = {
	AND?: InputMaybe<Array<UserClaimsConnectionWhere>>;
	OR?: InputMaybe<Array<UserClaimsConnectionWhere>>;
	node?: InputMaybe<ClaimWhere>;
	node_NOT?: InputMaybe<ClaimWhere>;
};

export type UserClaimsCreateFieldInput = {
	node: ClaimCreateInput;
};

export type UserClaimsDeleteFieldInput = {
	delete?: InputMaybe<ClaimDeleteInput>;
	where?: InputMaybe<UserClaimsConnectionWhere>;
};

export type UserClaimsDisconnectFieldInput = {
	disconnect?: InputMaybe<ClaimDisconnectInput>;
	where?: InputMaybe<UserClaimsConnectionWhere>;
};

export type UserClaimsFieldInput = {
	connect?: InputMaybe<Array<UserClaimsConnectFieldInput>>;
	create?: InputMaybe<Array<UserClaimsCreateFieldInput>>;
};

export type UserClaimsNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<UserClaimsNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<UserClaimsNodeAggregationWhereInput>>;
	administrationDate_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	administrationDate_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	administrationDate_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	administrationDate_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	administrationDate_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	administrationDate_EQUAL?: InputMaybe<Scalars["String"]>;
	administrationDate_GT?: InputMaybe<Scalars["Int"]>;
	administrationDate_GTE?: InputMaybe<Scalars["Int"]>;
	administrationDate_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	administrationDate_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	administrationDate_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	administrationDate_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	administrationDate_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	administrationDate_LT?: InputMaybe<Scalars["Int"]>;
	administrationDate_LTE?: InputMaybe<Scalars["Int"]>;
	administrationDate_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	administrationDate_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	administrationDate_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	administrationDate_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	administrationDate_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	assignee_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	assignee_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	assignee_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	assignee_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	assignee_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	assignee_EQUAL?: InputMaybe<Scalars["String"]>;
	assignee_GT?: InputMaybe<Scalars["Int"]>;
	assignee_GTE?: InputMaybe<Scalars["Int"]>;
	assignee_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	assignee_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	assignee_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	assignee_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	assignee_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	assignee_LT?: InputMaybe<Scalars["Int"]>;
	assignee_LTE?: InputMaybe<Scalars["Int"]>;
	assignee_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	assignee_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	assignee_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	assignee_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	assignee_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	claimId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	claimId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	claimId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	claimId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	claimId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	claimId_EQUAL?: InputMaybe<Scalars["String"]>;
	claimId_GT?: InputMaybe<Scalars["Int"]>;
	claimId_GTE?: InputMaybe<Scalars["Int"]>;
	claimId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	claimId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	claimId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	claimId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	claimId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	claimId_LT?: InputMaybe<Scalars["Int"]>;
	claimId_LTE?: InputMaybe<Scalars["Int"]>;
	claimId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	claimId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	claimId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	claimId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	claimId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	createdOn_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	invoiceAmount_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	invoiceAmount_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	invoiceAmount_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	invoiceAmount_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	invoiceAmount_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	invoiceAmount_EQUAL?: InputMaybe<Scalars["String"]>;
	invoiceAmount_GT?: InputMaybe<Scalars["Int"]>;
	invoiceAmount_GTE?: InputMaybe<Scalars["Int"]>;
	invoiceAmount_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	invoiceAmount_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	invoiceAmount_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	invoiceAmount_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	invoiceAmount_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	invoiceAmount_LT?: InputMaybe<Scalars["Int"]>;
	invoiceAmount_LTE?: InputMaybe<Scalars["Int"]>;
	invoiceAmount_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	invoiceAmount_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	invoiceAmount_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	invoiceAmount_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	invoiceAmount_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	invoiceDate_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	invoiceDate_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	invoiceDate_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	invoiceDate_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	invoiceDate_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	invoiceDate_EQUAL?: InputMaybe<Scalars["String"]>;
	invoiceDate_GT?: InputMaybe<Scalars["Int"]>;
	invoiceDate_GTE?: InputMaybe<Scalars["Int"]>;
	invoiceDate_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	invoiceDate_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	invoiceDate_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	invoiceDate_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	invoiceDate_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	invoiceDate_LT?: InputMaybe<Scalars["Int"]>;
	invoiceDate_LTE?: InputMaybe<Scalars["Int"]>;
	invoiceDate_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	invoiceDate_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	invoiceDate_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	invoiceDate_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	invoiceDate_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	invoiceNumber_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	invoiceNumber_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	invoiceNumber_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	invoiceNumber_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	invoiceNumber_EQUAL?: InputMaybe<Scalars["String"]>;
	invoiceNumber_GT?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_GTE?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_LT?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_LTE?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	invoiceNumber_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationIdType_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	preparationIdType_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	preparationIdType_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	preparationIdType_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	preparationIdType_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	preparationIdType_EQUAL?: InputMaybe<Scalars["String"]>;
	preparationIdType_GT?: InputMaybe<Scalars["Int"]>;
	preparationIdType_GTE?: InputMaybe<Scalars["Int"]>;
	preparationIdType_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationIdType_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationIdType_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationIdType_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationIdType_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationIdType_LT?: InputMaybe<Scalars["Int"]>;
	preparationIdType_LTE?: InputMaybe<Scalars["Int"]>;
	preparationIdType_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationIdType_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationIdType_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationIdType_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationIdType_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	preparationId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	preparationId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	preparationId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	preparationId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	preparationId_EQUAL?: InputMaybe<Scalars["String"]>;
	preparationId_GT?: InputMaybe<Scalars["Int"]>;
	preparationId_GTE?: InputMaybe<Scalars["Int"]>;
	preparationId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	preparationId_LT?: InputMaybe<Scalars["Int"]>;
	preparationId_LTE?: InputMaybe<Scalars["Int"]>;
	preparationId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	preparationId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	preparationId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	preparationId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	preparationId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	providerId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	providerId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	providerId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	providerId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	providerId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	providerId_EQUAL?: InputMaybe<Scalars["String"]>;
	providerId_GT?: InputMaybe<Scalars["Int"]>;
	providerId_GTE?: InputMaybe<Scalars["Int"]>;
	providerId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	providerId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	providerId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	providerId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	providerId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	providerId_LT?: InputMaybe<Scalars["Int"]>;
	providerId_LTE?: InputMaybe<Scalars["Int"]>;
	providerId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	providerId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	providerId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	providerId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	providerId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	providerName_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	providerName_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	providerName_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	providerName_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	providerName_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	providerName_EQUAL?: InputMaybe<Scalars["String"]>;
	providerName_GT?: InputMaybe<Scalars["Int"]>;
	providerName_GTE?: InputMaybe<Scalars["Int"]>;
	providerName_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	providerName_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	providerName_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	providerName_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	providerName_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	providerName_LT?: InputMaybe<Scalars["Int"]>;
	providerName_LTE?: InputMaybe<Scalars["Int"]>;
	providerName_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	providerName_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	providerName_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	providerName_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	providerName_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	quantity_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	quantity_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	quantity_EQUAL?: InputMaybe<Scalars["String"]>;
	quantity_GT?: InputMaybe<Scalars["Int"]>;
	quantity_GTE?: InputMaybe<Scalars["Int"]>;
	quantity_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	quantity_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	quantity_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	quantity_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	quantity_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	quantity_LT?: InputMaybe<Scalars["Int"]>;
	quantity_LTE?: InputMaybe<Scalars["Int"]>;
	quantity_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	quantity_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	quantity_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	quantity_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	quantity_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	tenantId_EQUAL?: InputMaybe<Scalars["String"]>;
	tenantId_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type UserClaimsRelationship = {
	__typename?: "UserClaimsRelationship";
	cursor: Scalars["String"];
	node: Claim;
};

export type UserClaimsUpdateConnectionInput = {
	node?: InputMaybe<ClaimUpdateInput>;
};

export type UserClaimsUpdateFieldInput = {
	connect?: InputMaybe<Array<UserClaimsConnectFieldInput>>;
	create?: InputMaybe<Array<UserClaimsCreateFieldInput>>;
	delete?: InputMaybe<Array<UserClaimsDeleteFieldInput>>;
	disconnect?: InputMaybe<Array<UserClaimsDisconnectFieldInput>>;
	update?: InputMaybe<UserClaimsUpdateConnectionInput>;
	where?: InputMaybe<UserClaimsConnectionWhere>;
};

export type UserConnectInput = {
	claims?: InputMaybe<Array<UserClaimsConnectFieldInput>>;
	context?: InputMaybe<UserContextConnectFieldInput>;
	mentions?: InputMaybe<Array<UserMentionsConnectFieldInput>>;
	notificationDue?: InputMaybe<Array<UserNotificationDueConnectFieldInput>>;
	notified?: InputMaybe<Array<UserNotifiedConnectFieldInput>>;
	patients?: InputMaybe<Array<UserPatientsConnectFieldInput>>;
	sentMessage?: InputMaybe<UserSentMessageConnectFieldInput>;
	subscribed?: InputMaybe<Array<UserSubscribedConnectFieldInput>>;
	tasks?: InputMaybe<Array<UserTasksConnectFieldInput>>;
};

export type UserConnectWhere = {
	node: UserWhere;
};

export type UserContext = {
	__typename?: "UserContext";
	baseAgreementContext: Array<BaseAgreement>;
	baseAgreementContextConnection: UserContextBaseAgreementContextConnection;
	email: Scalars["String"];
	filtersAgreements?: Maybe<Scalars["String"]>;
	filtersCases?: Maybe<Scalars["String"]>;
	filtersDataForms?: Maybe<Scalars["String"]>;
	filtersDataRecords?: Maybe<Scalars["String"]>;
	filtersDocuments?: Maybe<Scalars["String"]>;
	filtersRefunds?: Maybe<Scalars["String"]>;
	scenarios: Array<Scenario>;
	scenariosConnection: UserContextScenariosConnection;
};

export type UserContextBaseAgreementContextArgs = {
	options?: InputMaybe<BaseAgreementOptions>;
	where?: InputMaybe<BaseAgreementWhere>;
};

export type UserContextBaseAgreementContextConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<UserContextBaseAgreementContextConnectionSort>>;
	where?: InputMaybe<UserContextBaseAgreementContextConnectionWhere>;
};

export type UserContextScenariosArgs = {
	options?: InputMaybe<ScenarioOptions>;
	where?: InputMaybe<ScenarioWhere>;
};

export type UserContextScenariosConnectionArgs = {
	after?: InputMaybe<Scalars["String"]>;
	first?: InputMaybe<Scalars["Int"]>;
	sort?: InputMaybe<Array<UserContextScenariosConnectionSort>>;
	where?: InputMaybe<UserContextScenariosConnectionWhere>;
};

export type UserContextAggregateInput = {
	AND?: InputMaybe<Array<UserContextAggregateInput>>;
	OR?: InputMaybe<Array<UserContextAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<UserContextNodeAggregationWhereInput>;
};

export type UserContextAggregateSelection = {
	__typename?: "UserContextAggregateSelection";
	count: Scalars["Int"];
	email: StringAggregateSelection;
	filtersAgreements: StringAggregateSelection;
	filtersCases: StringAggregateSelection;
	filtersDataForms: StringAggregateSelection;
	filtersDataRecords: StringAggregateSelection;
	filtersDocuments: StringAggregateSelection;
	filtersRefunds: StringAggregateSelection;
};

export type UserContextBaseAgreementContextAggregateInput = {
	AND?: InputMaybe<Array<UserContextBaseAgreementContextAggregateInput>>;
	OR?: InputMaybe<Array<UserContextBaseAgreementContextAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	edge?: InputMaybe<UserContextBaseAgreementContextEdgeAggregationWhereInput>;
	node?: InputMaybe<UserContextBaseAgreementContextNodeAggregationWhereInput>;
};

export type UserContextBaseAgreementContextConnectFieldInput = {
	connect?: InputMaybe<Array<BaseAgreementConnectInput>>;
	edge: ScenarioInsightsUserContextCreateInput;
	where?: InputMaybe<BaseAgreementConnectWhere>;
};

export type UserContextBaseAgreementContextConnection = {
	__typename?: "UserContextBaseAgreementContextConnection";
	edges: Array<UserContextBaseAgreementContextRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type UserContextBaseAgreementContextConnectionSort = {
	edge?: InputMaybe<ScenarioInsightsUserContextSort>;
	node?: InputMaybe<BaseAgreementSort>;
};

export type UserContextBaseAgreementContextConnectionWhere = {
	AND?: InputMaybe<Array<UserContextBaseAgreementContextConnectionWhere>>;
	OR?: InputMaybe<Array<UserContextBaseAgreementContextConnectionWhere>>;
	edge?: InputMaybe<ScenarioInsightsUserContextWhere>;
	edge_NOT?: InputMaybe<ScenarioInsightsUserContextWhere>;
	node?: InputMaybe<BaseAgreementWhere>;
	node_NOT?: InputMaybe<BaseAgreementWhere>;
};

export type UserContextBaseAgreementContextCreateFieldInput = {
	edge: ScenarioInsightsUserContextCreateInput;
	node: BaseAgreementCreateInput;
};

export type UserContextBaseAgreementContextDeleteFieldInput = {
	delete?: InputMaybe<BaseAgreementDeleteInput>;
	where?: InputMaybe<UserContextBaseAgreementContextConnectionWhere>;
};

export type UserContextBaseAgreementContextDisconnectFieldInput = {
	disconnect?: InputMaybe<BaseAgreementDisconnectInput>;
	where?: InputMaybe<UserContextBaseAgreementContextConnectionWhere>;
};

export type UserContextBaseAgreementContextEdgeAggregationWhereInput = {
	AND?: InputMaybe<Array<UserContextBaseAgreementContextEdgeAggregationWhereInput>>;
	OR?: InputMaybe<Array<UserContextBaseAgreementContextEdgeAggregationWhereInput>>;
	categoryInput_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	categoryInput_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	categoryInput_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	categoryInput_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	categoryInput_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	categoryInput_EQUAL?: InputMaybe<Scalars["String"]>;
	categoryInput_GT?: InputMaybe<Scalars["Int"]>;
	categoryInput_GTE?: InputMaybe<Scalars["Int"]>;
	categoryInput_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	categoryInput_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	categoryInput_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	categoryInput_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	categoryInput_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	categoryInput_LT?: InputMaybe<Scalars["Int"]>;
	categoryInput_LTE?: InputMaybe<Scalars["Int"]>;
	categoryInput_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	categoryInput_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	categoryInput_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	categoryInput_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	categoryInput_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	rebateObjective_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	rebateObjective_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	rebateObjective_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	rebateObjective_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	rebateObjective_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	rebateObjective_EQUAL?: InputMaybe<Scalars["String"]>;
	rebateObjective_GT?: InputMaybe<Scalars["Int"]>;
	rebateObjective_GTE?: InputMaybe<Scalars["Int"]>;
	rebateObjective_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	rebateObjective_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	rebateObjective_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	rebateObjective_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	rebateObjective_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	rebateObjective_LT?: InputMaybe<Scalars["Int"]>;
	rebateObjective_LTE?: InputMaybe<Scalars["Int"]>;
	rebateObjective_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	rebateObjective_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	rebateObjective_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	rebateObjective_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	rebateObjective_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	timeframeLabel_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	timeframeLabel_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	timeframeLabel_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	timeframeLabel_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	timeframeLabel_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	timeframeLabel_EQUAL?: InputMaybe<Scalars["String"]>;
	timeframeLabel_GT?: InputMaybe<Scalars["Int"]>;
	timeframeLabel_GTE?: InputMaybe<Scalars["Int"]>;
	timeframeLabel_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	timeframeLabel_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	timeframeLabel_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	timeframeLabel_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	timeframeLabel_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	timeframeLabel_LT?: InputMaybe<Scalars["Int"]>;
	timeframeLabel_LTE?: InputMaybe<Scalars["Int"]>;
	timeframeLabel_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	timeframeLabel_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	timeframeLabel_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	timeframeLabel_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	timeframeLabel_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type UserContextBaseAgreementContextFieldInput = {
	connect?: InputMaybe<Array<UserContextBaseAgreementContextConnectFieldInput>>;
	create?: InputMaybe<Array<UserContextBaseAgreementContextCreateFieldInput>>;
};

export type UserContextBaseAgreementContextNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<UserContextBaseAgreementContextNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<UserContextBaseAgreementContextNodeAggregationWhereInput>>;
	coveringFormWaitInterval_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	coveringFormWaitInterval_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	coveringFormWaitInterval_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	coveringFormWaitInterval_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	coveringFormWaitInterval_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	coveringFormWaitInterval_EQUAL?: InputMaybe<Scalars["Int"]>;
	coveringFormWaitInterval_GT?: InputMaybe<Scalars["Int"]>;
	coveringFormWaitInterval_GTE?: InputMaybe<Scalars["Int"]>;
	coveringFormWaitInterval_LT?: InputMaybe<Scalars["Int"]>;
	coveringFormWaitInterval_LTE?: InputMaybe<Scalars["Int"]>;
	coveringFormWaitInterval_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	coveringFormWaitInterval_MAX_GT?: InputMaybe<Scalars["Int"]>;
	coveringFormWaitInterval_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	coveringFormWaitInterval_MAX_LT?: InputMaybe<Scalars["Int"]>;
	coveringFormWaitInterval_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	coveringFormWaitInterval_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	coveringFormWaitInterval_MIN_GT?: InputMaybe<Scalars["Int"]>;
	coveringFormWaitInterval_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	coveringFormWaitInterval_MIN_LT?: InputMaybe<Scalars["Int"]>;
	coveringFormWaitInterval_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	createdOn_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	createdOn_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_GT?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_GTE?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_LT?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_LTE?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	firstExecutionDate_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	formattedAmount_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	formattedAmount_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	formattedAmount_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	formattedAmount_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	formattedAmount_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	formattedAmount_EQUAL?: InputMaybe<Scalars["String"]>;
	formattedAmount_GT?: InputMaybe<Scalars["Int"]>;
	formattedAmount_GTE?: InputMaybe<Scalars["Int"]>;
	formattedAmount_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedAmount_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedAmount_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedAmount_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedAmount_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	formattedAmount_LT?: InputMaybe<Scalars["Int"]>;
	formattedAmount_LTE?: InputMaybe<Scalars["Int"]>;
	formattedAmount_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedAmount_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedAmount_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedAmount_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedAmount_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	formattedCounterparties_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	formattedCounterparties_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	formattedCounterparties_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	formattedCounterparties_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	formattedCounterparties_EQUAL?: InputMaybe<Scalars["String"]>;
	formattedCounterparties_GT?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_GTE?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_LT?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_LTE?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedCounterparties_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	formattedProducts_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	formattedProducts_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	formattedProducts_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	formattedProducts_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	formattedProducts_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	formattedProducts_EQUAL?: InputMaybe<Scalars["String"]>;
	formattedProducts_GT?: InputMaybe<Scalars["Int"]>;
	formattedProducts_GTE?: InputMaybe<Scalars["Int"]>;
	formattedProducts_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedProducts_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedProducts_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedProducts_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedProducts_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	formattedProducts_LT?: InputMaybe<Scalars["Int"]>;
	formattedProducts_LTE?: InputMaybe<Scalars["Int"]>;
	formattedProducts_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedProducts_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedProducts_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedProducts_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedProducts_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	formattedTags_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	formattedTags_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	formattedTags_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	formattedTags_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	formattedTags_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	formattedTags_EQUAL?: InputMaybe<Scalars["String"]>;
	formattedTags_GT?: InputMaybe<Scalars["Int"]>;
	formattedTags_GTE?: InputMaybe<Scalars["Int"]>;
	formattedTags_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedTags_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedTags_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedTags_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedTags_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	formattedTags_LT?: InputMaybe<Scalars["Int"]>;
	formattedTags_LTE?: InputMaybe<Scalars["Int"]>;
	formattedTags_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedTags_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedTags_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedTags_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedTags_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	formattedValidityPeriod_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	formattedValidityPeriod_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	formattedValidityPeriod_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	formattedValidityPeriod_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	formattedValidityPeriod_EQUAL?: InputMaybe<Scalars["String"]>;
	formattedValidityPeriod_GT?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_GTE?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_LT?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_LTE?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	formattedValidityPeriod_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	initialVersionId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	initialVersionId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	initialVersionId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	initialVersionId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	initialVersionId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	initialVersionId_EQUAL?: InputMaybe<Scalars["String"]>;
	initialVersionId_GT?: InputMaybe<Scalars["Int"]>;
	initialVersionId_GTE?: InputMaybe<Scalars["Int"]>;
	initialVersionId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	initialVersionId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	initialVersionId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	initialVersionId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	initialVersionId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	initialVersionId_LT?: InputMaybe<Scalars["Int"]>;
	initialVersionId_LTE?: InputMaybe<Scalars["Int"]>;
	initialVersionId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	initialVersionId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	initialVersionId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	initialVersionId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	initialVersionId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	lastExecutionDate_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_GT?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_LT?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_LTE?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	lastExecutionDate_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	name_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	name_EQUAL?: InputMaybe<Scalars["String"]>;
	name_GT?: InputMaybe<Scalars["Int"]>;
	name_GTE?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	name_LT?: InputMaybe<Scalars["Int"]>;
	name_LTE?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	pushedOn_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	pushedOn_GT?: InputMaybe<Scalars["DateTime"]>;
	pushedOn_GTE?: InputMaybe<Scalars["DateTime"]>;
	pushedOn_LT?: InputMaybe<Scalars["DateTime"]>;
	pushedOn_LTE?: InputMaybe<Scalars["DateTime"]>;
	pushedOn_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	pushedOn_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	pushedOn_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	pushedOn_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	pushedOn_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	pushedOn_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	pushedOn_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	pushedOn_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	pushedOn_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	pushedOn_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	version_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	version_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	version_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	version_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	version_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	version_EQUAL?: InputMaybe<Scalars["Int"]>;
	version_GT?: InputMaybe<Scalars["Int"]>;
	version_GTE?: InputMaybe<Scalars["Int"]>;
	version_LT?: InputMaybe<Scalars["Int"]>;
	version_LTE?: InputMaybe<Scalars["Int"]>;
	version_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	version_MAX_GT?: InputMaybe<Scalars["Int"]>;
	version_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	version_MAX_LT?: InputMaybe<Scalars["Int"]>;
	version_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	version_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	version_MIN_GT?: InputMaybe<Scalars["Int"]>;
	version_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	version_MIN_LT?: InputMaybe<Scalars["Int"]>;
	version_MIN_LTE?: InputMaybe<Scalars["Int"]>;
};

export type UserContextBaseAgreementContextRelationship = ScenarioInsightsUserContext & {
	__typename?: "UserContextBaseAgreementContextRelationship";
	categoryInput?: Maybe<Scalars["String"]>;
	cursor: Scalars["String"];
	groups?: Maybe<Array<Maybe<Scalars["Int"]>>>;
	node: BaseAgreement;
	rebateObjective?: Maybe<Scalars["String"]>;
	timeframeLabel: Scalars["String"];
};

export type UserContextBaseAgreementContextUpdateConnectionInput = {
	edge?: InputMaybe<ScenarioInsightsUserContextUpdateInput>;
	node?: InputMaybe<BaseAgreementUpdateInput>;
};

export type UserContextBaseAgreementContextUpdateFieldInput = {
	connect?: InputMaybe<Array<UserContextBaseAgreementContextConnectFieldInput>>;
	create?: InputMaybe<Array<UserContextBaseAgreementContextCreateFieldInput>>;
	delete?: InputMaybe<Array<UserContextBaseAgreementContextDeleteFieldInput>>;
	disconnect?: InputMaybe<Array<UserContextBaseAgreementContextDisconnectFieldInput>>;
	update?: InputMaybe<UserContextBaseAgreementContextUpdateConnectionInput>;
	where?: InputMaybe<UserContextBaseAgreementContextConnectionWhere>;
};

export type UserContextConnectFieldInput = {
	connect?: InputMaybe<UserContextConnectInput>;
	where?: InputMaybe<UserContextConnectWhere>;
};

export type UserContextConnectInput = {
	baseAgreementContext?: InputMaybe<Array<UserContextBaseAgreementContextConnectFieldInput>>;
	scenarios?: InputMaybe<Array<UserContextScenariosConnectFieldInput>>;
};

export type UserContextConnectWhere = {
	node: UserContextWhere;
};

export type UserContextConnection = {
	__typename?: "UserContextConnection";
	edges: Array<UserContextRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type UserContextConnectionSort = {
	node?: InputMaybe<UserContextSort>;
};

export type UserContextConnectionWhere = {
	AND?: InputMaybe<Array<UserContextConnectionWhere>>;
	OR?: InputMaybe<Array<UserContextConnectionWhere>>;
	node?: InputMaybe<UserContextWhere>;
	node_NOT?: InputMaybe<UserContextWhere>;
};

export type UserContextCreateFieldInput = {
	node: UserContextCreateInput;
};

export type UserContextCreateInput = {
	baseAgreementContext?: InputMaybe<UserContextBaseAgreementContextFieldInput>;
	email: Scalars["String"];
	filtersAgreements?: InputMaybe<Scalars["String"]>;
	filtersCases?: InputMaybe<Scalars["String"]>;
	filtersDataForms?: InputMaybe<Scalars["String"]>;
	filtersDataRecords?: InputMaybe<Scalars["String"]>;
	filtersDocuments?: InputMaybe<Scalars["String"]>;
	filtersRefunds?: InputMaybe<Scalars["String"]>;
	scenarios?: InputMaybe<UserContextScenariosFieldInput>;
};

export type UserContextDeleteFieldInput = {
	delete?: InputMaybe<UserContextDeleteInput>;
	where?: InputMaybe<UserContextConnectionWhere>;
};

export type UserContextDeleteInput = {
	baseAgreementContext?: InputMaybe<Array<UserContextBaseAgreementContextDeleteFieldInput>>;
	scenarios?: InputMaybe<Array<UserContextScenariosDeleteFieldInput>>;
};

export type UserContextDisconnectFieldInput = {
	disconnect?: InputMaybe<UserContextDisconnectInput>;
	where?: InputMaybe<UserContextConnectionWhere>;
};

export type UserContextDisconnectInput = {
	baseAgreementContext?: InputMaybe<Array<UserContextBaseAgreementContextDisconnectFieldInput>>;
	scenarios?: InputMaybe<Array<UserContextScenariosDisconnectFieldInput>>;
};

export type UserContextFieldInput = {
	connect?: InputMaybe<UserContextConnectFieldInput>;
	create?: InputMaybe<UserContextCreateFieldInput>;
};

export type UserContextNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<UserContextNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<UserContextNodeAggregationWhereInput>>;
	email_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	email_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	email_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	email_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	email_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	email_EQUAL?: InputMaybe<Scalars["String"]>;
	email_GT?: InputMaybe<Scalars["Int"]>;
	email_GTE?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	email_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	email_LT?: InputMaybe<Scalars["Int"]>;
	email_LTE?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	email_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	filtersAgreements_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	filtersAgreements_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	filtersAgreements_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	filtersAgreements_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	filtersAgreements_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	filtersAgreements_EQUAL?: InputMaybe<Scalars["String"]>;
	filtersAgreements_GT?: InputMaybe<Scalars["Int"]>;
	filtersAgreements_GTE?: InputMaybe<Scalars["Int"]>;
	filtersAgreements_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	filtersAgreements_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	filtersAgreements_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	filtersAgreements_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	filtersAgreements_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	filtersAgreements_LT?: InputMaybe<Scalars["Int"]>;
	filtersAgreements_LTE?: InputMaybe<Scalars["Int"]>;
	filtersAgreements_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	filtersAgreements_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	filtersAgreements_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	filtersAgreements_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	filtersAgreements_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	filtersCases_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	filtersCases_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	filtersCases_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	filtersCases_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	filtersCases_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	filtersCases_EQUAL?: InputMaybe<Scalars["String"]>;
	filtersCases_GT?: InputMaybe<Scalars["Int"]>;
	filtersCases_GTE?: InputMaybe<Scalars["Int"]>;
	filtersCases_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	filtersCases_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	filtersCases_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	filtersCases_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	filtersCases_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	filtersCases_LT?: InputMaybe<Scalars["Int"]>;
	filtersCases_LTE?: InputMaybe<Scalars["Int"]>;
	filtersCases_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	filtersCases_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	filtersCases_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	filtersCases_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	filtersCases_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	filtersDataForms_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	filtersDataForms_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	filtersDataForms_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	filtersDataForms_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	filtersDataForms_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	filtersDataForms_EQUAL?: InputMaybe<Scalars["String"]>;
	filtersDataForms_GT?: InputMaybe<Scalars["Int"]>;
	filtersDataForms_GTE?: InputMaybe<Scalars["Int"]>;
	filtersDataForms_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	filtersDataForms_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	filtersDataForms_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	filtersDataForms_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	filtersDataForms_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	filtersDataForms_LT?: InputMaybe<Scalars["Int"]>;
	filtersDataForms_LTE?: InputMaybe<Scalars["Int"]>;
	filtersDataForms_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	filtersDataForms_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	filtersDataForms_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	filtersDataForms_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	filtersDataForms_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	filtersDataRecords_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	filtersDataRecords_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	filtersDataRecords_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	filtersDataRecords_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	filtersDataRecords_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	filtersDataRecords_EQUAL?: InputMaybe<Scalars["String"]>;
	filtersDataRecords_GT?: InputMaybe<Scalars["Int"]>;
	filtersDataRecords_GTE?: InputMaybe<Scalars["Int"]>;
	filtersDataRecords_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	filtersDataRecords_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	filtersDataRecords_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	filtersDataRecords_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	filtersDataRecords_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	filtersDataRecords_LT?: InputMaybe<Scalars["Int"]>;
	filtersDataRecords_LTE?: InputMaybe<Scalars["Int"]>;
	filtersDataRecords_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	filtersDataRecords_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	filtersDataRecords_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	filtersDataRecords_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	filtersDataRecords_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	filtersDocuments_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	filtersDocuments_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	filtersDocuments_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	filtersDocuments_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	filtersDocuments_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	filtersDocuments_EQUAL?: InputMaybe<Scalars["String"]>;
	filtersDocuments_GT?: InputMaybe<Scalars["Int"]>;
	filtersDocuments_GTE?: InputMaybe<Scalars["Int"]>;
	filtersDocuments_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	filtersDocuments_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	filtersDocuments_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	filtersDocuments_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	filtersDocuments_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	filtersDocuments_LT?: InputMaybe<Scalars["Int"]>;
	filtersDocuments_LTE?: InputMaybe<Scalars["Int"]>;
	filtersDocuments_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	filtersDocuments_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	filtersDocuments_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	filtersDocuments_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	filtersDocuments_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	filtersRefunds_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	filtersRefunds_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	filtersRefunds_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	filtersRefunds_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	filtersRefunds_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	filtersRefunds_EQUAL?: InputMaybe<Scalars["String"]>;
	filtersRefunds_GT?: InputMaybe<Scalars["Int"]>;
	filtersRefunds_GTE?: InputMaybe<Scalars["Int"]>;
	filtersRefunds_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	filtersRefunds_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	filtersRefunds_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	filtersRefunds_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	filtersRefunds_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	filtersRefunds_LT?: InputMaybe<Scalars["Int"]>;
	filtersRefunds_LTE?: InputMaybe<Scalars["Int"]>;
	filtersRefunds_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	filtersRefunds_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	filtersRefunds_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	filtersRefunds_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	filtersRefunds_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type UserContextOptions = {
	limit?: InputMaybe<Scalars["Int"]>;
	offset?: InputMaybe<Scalars["Int"]>;
	/** Specify one or more UserContextSort objects to sort UserContexts by. The sorts will be applied in the order in which they are arranged in the array. */
	sort?: InputMaybe<Array<InputMaybe<UserContextSort>>>;
};

export type UserContextRelationship = {
	__typename?: "UserContextRelationship";
	cursor: Scalars["String"];
	node: UserContext;
};

export type UserContextScenariosAggregateInput = {
	AND?: InputMaybe<Array<UserContextScenariosAggregateInput>>;
	OR?: InputMaybe<Array<UserContextScenariosAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	edge?: InputMaybe<UserContextScenariosEdgeAggregationWhereInput>;
	node?: InputMaybe<UserContextScenariosNodeAggregationWhereInput>;
};

export type UserContextScenariosConnectFieldInput = {
	connect?: InputMaybe<Array<ScenarioConnectInput>>;
	edge: ScenarioInsightsUserContextCreateInput;
	where?: InputMaybe<ScenarioConnectWhere>;
};

export type UserContextScenariosConnection = {
	__typename?: "UserContextScenariosConnection";
	edges: Array<UserContextScenariosRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type UserContextScenariosConnectionSort = {
	edge?: InputMaybe<ScenarioInsightsUserContextSort>;
	node?: InputMaybe<ScenarioSort>;
};

export type UserContextScenariosConnectionWhere = {
	AND?: InputMaybe<Array<UserContextScenariosConnectionWhere>>;
	OR?: InputMaybe<Array<UserContextScenariosConnectionWhere>>;
	edge?: InputMaybe<ScenarioInsightsUserContextWhere>;
	edge_NOT?: InputMaybe<ScenarioInsightsUserContextWhere>;
	node?: InputMaybe<ScenarioWhere>;
	node_NOT?: InputMaybe<ScenarioWhere>;
};

export type UserContextScenariosCreateFieldInput = {
	edge: ScenarioInsightsUserContextCreateInput;
	node: ScenarioCreateInput;
};

export type UserContextScenariosDeleteFieldInput = {
	delete?: InputMaybe<ScenarioDeleteInput>;
	where?: InputMaybe<UserContextScenariosConnectionWhere>;
};

export type UserContextScenariosDisconnectFieldInput = {
	disconnect?: InputMaybe<ScenarioDisconnectInput>;
	where?: InputMaybe<UserContextScenariosConnectionWhere>;
};

export type UserContextScenariosEdgeAggregationWhereInput = {
	AND?: InputMaybe<Array<UserContextScenariosEdgeAggregationWhereInput>>;
	OR?: InputMaybe<Array<UserContextScenariosEdgeAggregationWhereInput>>;
	categoryInput_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	categoryInput_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	categoryInput_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	categoryInput_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	categoryInput_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	categoryInput_EQUAL?: InputMaybe<Scalars["String"]>;
	categoryInput_GT?: InputMaybe<Scalars["Int"]>;
	categoryInput_GTE?: InputMaybe<Scalars["Int"]>;
	categoryInput_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	categoryInput_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	categoryInput_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	categoryInput_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	categoryInput_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	categoryInput_LT?: InputMaybe<Scalars["Int"]>;
	categoryInput_LTE?: InputMaybe<Scalars["Int"]>;
	categoryInput_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	categoryInput_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	categoryInput_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	categoryInput_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	categoryInput_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	rebateObjective_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	rebateObjective_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	rebateObjective_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	rebateObjective_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	rebateObjective_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	rebateObjective_EQUAL?: InputMaybe<Scalars["String"]>;
	rebateObjective_GT?: InputMaybe<Scalars["Int"]>;
	rebateObjective_GTE?: InputMaybe<Scalars["Int"]>;
	rebateObjective_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	rebateObjective_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	rebateObjective_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	rebateObjective_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	rebateObjective_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	rebateObjective_LT?: InputMaybe<Scalars["Int"]>;
	rebateObjective_LTE?: InputMaybe<Scalars["Int"]>;
	rebateObjective_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	rebateObjective_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	rebateObjective_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	rebateObjective_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	rebateObjective_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	timeframeLabel_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	timeframeLabel_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	timeframeLabel_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	timeframeLabel_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	timeframeLabel_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	timeframeLabel_EQUAL?: InputMaybe<Scalars["String"]>;
	timeframeLabel_GT?: InputMaybe<Scalars["Int"]>;
	timeframeLabel_GTE?: InputMaybe<Scalars["Int"]>;
	timeframeLabel_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	timeframeLabel_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	timeframeLabel_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	timeframeLabel_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	timeframeLabel_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	timeframeLabel_LT?: InputMaybe<Scalars["Int"]>;
	timeframeLabel_LTE?: InputMaybe<Scalars["Int"]>;
	timeframeLabel_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	timeframeLabel_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	timeframeLabel_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	timeframeLabel_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	timeframeLabel_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type UserContextScenariosFieldInput = {
	connect?: InputMaybe<Array<UserContextScenariosConnectFieldInput>>;
	create?: InputMaybe<Array<UserContextScenariosCreateFieldInput>>;
};

export type UserContextScenariosNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<UserContextScenariosNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<UserContextScenariosNodeAggregationWhereInput>>;
	group_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	group_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	group_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	group_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	group_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	group_EQUAL?: InputMaybe<Scalars["Int"]>;
	group_GT?: InputMaybe<Scalars["Int"]>;
	group_GTE?: InputMaybe<Scalars["Int"]>;
	group_LT?: InputMaybe<Scalars["Int"]>;
	group_LTE?: InputMaybe<Scalars["Int"]>;
	group_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	group_MAX_GT?: InputMaybe<Scalars["Int"]>;
	group_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	group_MAX_LT?: InputMaybe<Scalars["Int"]>;
	group_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	group_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	group_MIN_GT?: InputMaybe<Scalars["Int"]>;
	group_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	group_MIN_LT?: InputMaybe<Scalars["Int"]>;
	group_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	order_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	order_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	order_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	order_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	order_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	order_EQUAL?: InputMaybe<Scalars["Int"]>;
	order_GT?: InputMaybe<Scalars["Int"]>;
	order_GTE?: InputMaybe<Scalars["Int"]>;
	order_LT?: InputMaybe<Scalars["Int"]>;
	order_LTE?: InputMaybe<Scalars["Int"]>;
	order_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	order_MAX_GT?: InputMaybe<Scalars["Int"]>;
	order_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	order_MAX_LT?: InputMaybe<Scalars["Int"]>;
	order_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	order_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	order_MIN_GT?: InputMaybe<Scalars["Int"]>;
	order_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	order_MIN_LT?: InputMaybe<Scalars["Int"]>;
	order_MIN_LTE?: InputMaybe<Scalars["Int"]>;
};

export type UserContextScenariosRelationship = ScenarioInsightsUserContext & {
	__typename?: "UserContextScenariosRelationship";
	categoryInput?: Maybe<Scalars["String"]>;
	cursor: Scalars["String"];
	groups?: Maybe<Array<Maybe<Scalars["Int"]>>>;
	node: Scenario;
	rebateObjective?: Maybe<Scalars["String"]>;
	timeframeLabel: Scalars["String"];
};

export type UserContextScenariosUpdateConnectionInput = {
	edge?: InputMaybe<ScenarioInsightsUserContextUpdateInput>;
	node?: InputMaybe<ScenarioUpdateInput>;
};

export type UserContextScenariosUpdateFieldInput = {
	connect?: InputMaybe<Array<UserContextScenariosConnectFieldInput>>;
	create?: InputMaybe<Array<UserContextScenariosCreateFieldInput>>;
	delete?: InputMaybe<Array<UserContextScenariosDeleteFieldInput>>;
	disconnect?: InputMaybe<Array<UserContextScenariosDisconnectFieldInput>>;
	update?: InputMaybe<UserContextScenariosUpdateConnectionInput>;
	where?: InputMaybe<UserContextScenariosConnectionWhere>;
};

/** Fields to sort UserContexts by. The order in which sorts are applied is not guaranteed when specifying many fields in one UserContextSort object. */
export type UserContextSort = {
	email?: InputMaybe<SortDirection>;
	filtersAgreements?: InputMaybe<SortDirection>;
	filtersCases?: InputMaybe<SortDirection>;
	filtersDataForms?: InputMaybe<SortDirection>;
	filtersDataRecords?: InputMaybe<SortDirection>;
	filtersDocuments?: InputMaybe<SortDirection>;
	filtersRefunds?: InputMaybe<SortDirection>;
};

export type UserContextUpdateConnectionInput = {
	node?: InputMaybe<UserContextUpdateInput>;
};

export type UserContextUpdateFieldInput = {
	connect?: InputMaybe<UserContextConnectFieldInput>;
	create?: InputMaybe<UserContextCreateFieldInput>;
	delete?: InputMaybe<UserContextDeleteFieldInput>;
	disconnect?: InputMaybe<UserContextDisconnectFieldInput>;
	update?: InputMaybe<UserContextUpdateConnectionInput>;
	where?: InputMaybe<UserContextConnectionWhere>;
};

export type UserContextUpdateInput = {
	baseAgreementContext?: InputMaybe<Array<UserContextBaseAgreementContextUpdateFieldInput>>;
	email?: InputMaybe<Scalars["String"]>;
	filtersAgreements?: InputMaybe<Scalars["String"]>;
	filtersCases?: InputMaybe<Scalars["String"]>;
	filtersDataForms?: InputMaybe<Scalars["String"]>;
	filtersDataRecords?: InputMaybe<Scalars["String"]>;
	filtersDocuments?: InputMaybe<Scalars["String"]>;
	filtersRefunds?: InputMaybe<Scalars["String"]>;
	scenarios?: InputMaybe<Array<UserContextScenariosUpdateFieldInput>>;
};

export type UserContextWhere = {
	AND?: InputMaybe<Array<UserContextWhere>>;
	OR?: InputMaybe<Array<UserContextWhere>>;
	baseAgreementContext?: InputMaybe<BaseAgreementWhere>;
	baseAgreementContextAggregate?: InputMaybe<UserContextBaseAgreementContextAggregateInput>;
	baseAgreementContextConnection?: InputMaybe<UserContextBaseAgreementContextConnectionWhere>;
	baseAgreementContextConnection_NOT?: InputMaybe<UserContextBaseAgreementContextConnectionWhere>;
	baseAgreementContext_NOT?: InputMaybe<BaseAgreementWhere>;
	email?: InputMaybe<Scalars["String"]>;
	email_CONTAINS?: InputMaybe<Scalars["String"]>;
	email_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	email_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	email_MATCHES?: InputMaybe<Scalars["String"]>;
	email_NOT?: InputMaybe<Scalars["String"]>;
	email_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	email_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	email_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	email_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	email_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	filtersAgreements?: InputMaybe<Scalars["String"]>;
	filtersAgreements_CONTAINS?: InputMaybe<Scalars["String"]>;
	filtersAgreements_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	filtersAgreements_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	filtersAgreements_MATCHES?: InputMaybe<Scalars["String"]>;
	filtersAgreements_NOT?: InputMaybe<Scalars["String"]>;
	filtersAgreements_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	filtersAgreements_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	filtersAgreements_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	filtersAgreements_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	filtersAgreements_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	filtersCases?: InputMaybe<Scalars["String"]>;
	filtersCases_CONTAINS?: InputMaybe<Scalars["String"]>;
	filtersCases_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	filtersCases_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	filtersCases_MATCHES?: InputMaybe<Scalars["String"]>;
	filtersCases_NOT?: InputMaybe<Scalars["String"]>;
	filtersCases_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	filtersCases_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	filtersCases_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	filtersCases_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	filtersCases_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	filtersDataForms?: InputMaybe<Scalars["String"]>;
	filtersDataForms_CONTAINS?: InputMaybe<Scalars["String"]>;
	filtersDataForms_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	filtersDataForms_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	filtersDataForms_MATCHES?: InputMaybe<Scalars["String"]>;
	filtersDataForms_NOT?: InputMaybe<Scalars["String"]>;
	filtersDataForms_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	filtersDataForms_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	filtersDataForms_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	filtersDataForms_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	filtersDataForms_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	filtersDataRecords?: InputMaybe<Scalars["String"]>;
	filtersDataRecords_CONTAINS?: InputMaybe<Scalars["String"]>;
	filtersDataRecords_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	filtersDataRecords_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	filtersDataRecords_MATCHES?: InputMaybe<Scalars["String"]>;
	filtersDataRecords_NOT?: InputMaybe<Scalars["String"]>;
	filtersDataRecords_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	filtersDataRecords_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	filtersDataRecords_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	filtersDataRecords_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	filtersDataRecords_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	filtersDocuments?: InputMaybe<Scalars["String"]>;
	filtersDocuments_CONTAINS?: InputMaybe<Scalars["String"]>;
	filtersDocuments_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	filtersDocuments_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	filtersDocuments_MATCHES?: InputMaybe<Scalars["String"]>;
	filtersDocuments_NOT?: InputMaybe<Scalars["String"]>;
	filtersDocuments_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	filtersDocuments_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	filtersDocuments_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	filtersDocuments_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	filtersDocuments_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	filtersRefunds?: InputMaybe<Scalars["String"]>;
	filtersRefunds_CONTAINS?: InputMaybe<Scalars["String"]>;
	filtersRefunds_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	filtersRefunds_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	filtersRefunds_MATCHES?: InputMaybe<Scalars["String"]>;
	filtersRefunds_NOT?: InputMaybe<Scalars["String"]>;
	filtersRefunds_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	filtersRefunds_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	filtersRefunds_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	filtersRefunds_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	filtersRefunds_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	scenarios?: InputMaybe<ScenarioWhere>;
	scenariosAggregate?: InputMaybe<UserContextScenariosAggregateInput>;
	scenariosConnection?: InputMaybe<UserContextScenariosConnectionWhere>;
	scenariosConnection_NOT?: InputMaybe<UserContextScenariosConnectionWhere>;
	scenarios_NOT?: InputMaybe<ScenarioWhere>;
};

export type UserCreateInput = {
	claims?: InputMaybe<UserClaimsFieldInput>;
	context?: InputMaybe<UserContextFieldInput>;
	email: Scalars["String"];
	firstName: Scalars["String"];
	id: Scalars["ID"];
	lastName: Scalars["String"];
	mentions?: InputMaybe<UserMentionsFieldInput>;
	notificationDue?: InputMaybe<UserNotificationDueFieldInput>;
	notified?: InputMaybe<UserNotifiedFieldInput>;
	patients?: InputMaybe<UserPatientsFieldInput>;
	preferredLanguage: Scalars["String"];
	reads: Array<Scalars["String"]>;
	sentMessage?: InputMaybe<UserSentMessageFieldInput>;
	subscribed?: InputMaybe<UserSubscribedFieldInput>;
	tasks?: InputMaybe<UserTasksFieldInput>;
	tenantId: Scalars["String"];
	writes: Array<Scalars["String"]>;
};

export type UserDeleteInput = {
	claims?: InputMaybe<Array<UserClaimsDeleteFieldInput>>;
	context?: InputMaybe<UserContextDeleteFieldInput>;
	mentions?: InputMaybe<Array<UserMentionsDeleteFieldInput>>;
	notificationDue?: InputMaybe<Array<UserNotificationDueDeleteFieldInput>>;
	notified?: InputMaybe<Array<UserNotifiedDeleteFieldInput>>;
	patients?: InputMaybe<Array<UserPatientsDeleteFieldInput>>;
	sentMessage?: InputMaybe<UserSentMessageDeleteFieldInput>;
	subscribed?: InputMaybe<Array<UserSubscribedDeleteFieldInput>>;
	tasks?: InputMaybe<Array<UserTasksDeleteFieldInput>>;
};

export type UserDisconnectInput = {
	claims?: InputMaybe<Array<UserClaimsDisconnectFieldInput>>;
	context?: InputMaybe<UserContextDisconnectFieldInput>;
	mentions?: InputMaybe<Array<UserMentionsDisconnectFieldInput>>;
	notificationDue?: InputMaybe<Array<UserNotificationDueDisconnectFieldInput>>;
	notified?: InputMaybe<Array<UserNotifiedDisconnectFieldInput>>;
	patients?: InputMaybe<Array<UserPatientsDisconnectFieldInput>>;
	sentMessage?: InputMaybe<UserSentMessageDisconnectFieldInput>;
	subscribed?: InputMaybe<Array<UserSubscribedDisconnectFieldInput>>;
	tasks?: InputMaybe<Array<UserTasksDisconnectFieldInput>>;
};

export type UserInput = {
	email: Scalars["String"];
	firstName: Scalars["String"];
	lastName: Scalars["String"];
};

export type UserMentionsAggregateInput = {
	AND?: InputMaybe<Array<UserMentionsAggregateInput>>;
	OR?: InputMaybe<Array<UserMentionsAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<UserMentionsNodeAggregationWhereInput>;
};

export type UserMentionsConnectFieldInput = {
	connect?: InputMaybe<Array<MessageConnectInput>>;
	where?: InputMaybe<MessageConnectWhere>;
};

export type UserMentionsConnection = {
	__typename?: "UserMentionsConnection";
	edges: Array<UserMentionsRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type UserMentionsConnectionSort = {
	node?: InputMaybe<MessageSort>;
};

export type UserMentionsConnectionWhere = {
	AND?: InputMaybe<Array<UserMentionsConnectionWhere>>;
	OR?: InputMaybe<Array<UserMentionsConnectionWhere>>;
	node?: InputMaybe<MessageWhere>;
	node_NOT?: InputMaybe<MessageWhere>;
};

export type UserMentionsCreateFieldInput = {
	node: MessageCreateInput;
};

export type UserMentionsDeleteFieldInput = {
	delete?: InputMaybe<MessageDeleteInput>;
	where?: InputMaybe<UserMentionsConnectionWhere>;
};

export type UserMentionsDisconnectFieldInput = {
	disconnect?: InputMaybe<MessageDisconnectInput>;
	where?: InputMaybe<UserMentionsConnectionWhere>;
};

export type UserMentionsFieldInput = {
	connect?: InputMaybe<Array<UserMentionsConnectFieldInput>>;
	create?: InputMaybe<Array<UserMentionsCreateFieldInput>>;
};

export type UserMentionsNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<UserMentionsNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<UserMentionsNodeAggregationWhereInput>>;
	content_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	content_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	content_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	content_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	content_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	content_EQUAL?: InputMaybe<Scalars["String"]>;
	content_GT?: InputMaybe<Scalars["Int"]>;
	content_GTE?: InputMaybe<Scalars["Int"]>;
	content_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	content_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	content_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	content_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	content_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	content_LT?: InputMaybe<Scalars["Int"]>;
	content_LTE?: InputMaybe<Scalars["Int"]>;
	content_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	content_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	content_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	content_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	content_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	createdOn_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	createdOn_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	createdOn_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	createdOn_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	createdOn_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	createdOn_EQUAL?: InputMaybe<Scalars["Float"]>;
	createdOn_GT?: InputMaybe<Scalars["Float"]>;
	createdOn_GTE?: InputMaybe<Scalars["Float"]>;
	createdOn_LT?: InputMaybe<Scalars["Float"]>;
	createdOn_LTE?: InputMaybe<Scalars["Float"]>;
	createdOn_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	createdOn_MAX_GT?: InputMaybe<Scalars["Float"]>;
	createdOn_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	createdOn_MAX_LT?: InputMaybe<Scalars["Float"]>;
	createdOn_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	createdOn_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	createdOn_MIN_GT?: InputMaybe<Scalars["Float"]>;
	createdOn_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	createdOn_MIN_LT?: InputMaybe<Scalars["Float"]>;
	createdOn_MIN_LTE?: InputMaybe<Scalars["Float"]>;
};

export type UserMentionsRelationship = {
	__typename?: "UserMentionsRelationship";
	cursor: Scalars["String"];
	node: Message;
};

export type UserMentionsUpdateConnectionInput = {
	node?: InputMaybe<MessageUpdateInput>;
};

export type UserMentionsUpdateFieldInput = {
	connect?: InputMaybe<Array<UserMentionsConnectFieldInput>>;
	create?: InputMaybe<Array<UserMentionsCreateFieldInput>>;
	delete?: InputMaybe<Array<UserMentionsDeleteFieldInput>>;
	disconnect?: InputMaybe<Array<UserMentionsDisconnectFieldInput>>;
	update?: InputMaybe<UserMentionsUpdateConnectionInput>;
	where?: InputMaybe<UserMentionsConnectionWhere>;
};

export type UserMessageRelationship = {
	invoiceId?: Maybe<Scalars["ID"]>;
	refundId?: Maybe<Scalars["ID"]>;
};

export type UserMessageRelationshipCreateInput = {
	invoiceId?: InputMaybe<Scalars["ID"]>;
	refundId?: InputMaybe<Scalars["ID"]>;
};

export type UserMessageRelationshipSort = {
	invoiceId?: InputMaybe<SortDirection>;
	refundId?: InputMaybe<SortDirection>;
};

export type UserMessageRelationshipUpdateInput = {
	invoiceId?: InputMaybe<Scalars["ID"]>;
	refundId?: InputMaybe<Scalars["ID"]>;
};

export type UserMessageRelationshipWhere = {
	AND?: InputMaybe<Array<UserMessageRelationshipWhere>>;
	OR?: InputMaybe<Array<UserMessageRelationshipWhere>>;
	invoiceId?: InputMaybe<Scalars["ID"]>;
	invoiceId_CONTAINS?: InputMaybe<Scalars["ID"]>;
	invoiceId_ENDS_WITH?: InputMaybe<Scalars["ID"]>;
	invoiceId_IN?: InputMaybe<Array<InputMaybe<Scalars["ID"]>>>;
	invoiceId_MATCHES?: InputMaybe<Scalars["String"]>;
	invoiceId_NOT?: InputMaybe<Scalars["ID"]>;
	invoiceId_NOT_CONTAINS?: InputMaybe<Scalars["ID"]>;
	invoiceId_NOT_ENDS_WITH?: InputMaybe<Scalars["ID"]>;
	invoiceId_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["ID"]>>>;
	invoiceId_NOT_STARTS_WITH?: InputMaybe<Scalars["ID"]>;
	invoiceId_STARTS_WITH?: InputMaybe<Scalars["ID"]>;
	refundId?: InputMaybe<Scalars["ID"]>;
	refundId_CONTAINS?: InputMaybe<Scalars["ID"]>;
	refundId_ENDS_WITH?: InputMaybe<Scalars["ID"]>;
	refundId_IN?: InputMaybe<Array<InputMaybe<Scalars["ID"]>>>;
	refundId_MATCHES?: InputMaybe<Scalars["String"]>;
	refundId_NOT?: InputMaybe<Scalars["ID"]>;
	refundId_NOT_CONTAINS?: InputMaybe<Scalars["ID"]>;
	refundId_NOT_ENDS_WITH?: InputMaybe<Scalars["ID"]>;
	refundId_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["ID"]>>>;
	refundId_NOT_STARTS_WITH?: InputMaybe<Scalars["ID"]>;
	refundId_STARTS_WITH?: InputMaybe<Scalars["ID"]>;
};

export type UserNotificationDueAggregateInput = {
	AND?: InputMaybe<Array<UserNotificationDueAggregateInput>>;
	OR?: InputMaybe<Array<UserNotificationDueAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	edge?: InputMaybe<UserNotificationDueEdgeAggregationWhereInput>;
	node?: InputMaybe<UserNotificationDueNodeAggregationWhereInput>;
};

export type UserNotificationDueConnectFieldInput = {
	connect?: InputMaybe<Array<NotificationConnectInput>>;
	edge: SummaryNotificationDueCreateInput;
	where?: InputMaybe<NotificationConnectWhere>;
};

export type UserNotificationDueConnection = {
	__typename?: "UserNotificationDueConnection";
	edges: Array<UserNotificationDueRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type UserNotificationDueConnectionSort = {
	edge?: InputMaybe<SummaryNotificationDueSort>;
	node?: InputMaybe<NotificationSort>;
};

export type UserNotificationDueConnectionWhere = {
	AND?: InputMaybe<Array<UserNotificationDueConnectionWhere>>;
	OR?: InputMaybe<Array<UserNotificationDueConnectionWhere>>;
	edge?: InputMaybe<SummaryNotificationDueWhere>;
	edge_NOT?: InputMaybe<SummaryNotificationDueWhere>;
	node?: InputMaybe<NotificationWhere>;
	node_NOT?: InputMaybe<NotificationWhere>;
};

export type UserNotificationDueCreateFieldInput = {
	edge: SummaryNotificationDueCreateInput;
	node: NotificationCreateInput;
};

export type UserNotificationDueDeleteFieldInput = {
	delete?: InputMaybe<NotificationDeleteInput>;
	where?: InputMaybe<UserNotificationDueConnectionWhere>;
};

export type UserNotificationDueDisconnectFieldInput = {
	disconnect?: InputMaybe<NotificationDisconnectInput>;
	where?: InputMaybe<UserNotificationDueConnectionWhere>;
};

export type UserNotificationDueEdgeAggregationWhereInput = {
	AND?: InputMaybe<Array<UserNotificationDueEdgeAggregationWhereInput>>;
	OR?: InputMaybe<Array<UserNotificationDueEdgeAggregationWhereInput>>;
	message_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	message_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	message_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	message_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	message_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	message_EQUAL?: InputMaybe<Scalars["String"]>;
	message_GT?: InputMaybe<Scalars["Int"]>;
	message_GTE?: InputMaybe<Scalars["Int"]>;
	message_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	message_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	message_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	message_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	message_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	message_LT?: InputMaybe<Scalars["Int"]>;
	message_LTE?: InputMaybe<Scalars["Int"]>;
	message_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	message_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	message_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	message_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	message_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	timeStamp_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	timeStamp_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	timeStamp_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	timeStamp_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	timeStamp_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	timeStamp_EQUAL?: InputMaybe<Scalars["Float"]>;
	timeStamp_GT?: InputMaybe<Scalars["Float"]>;
	timeStamp_GTE?: InputMaybe<Scalars["Float"]>;
	timeStamp_LT?: InputMaybe<Scalars["Float"]>;
	timeStamp_LTE?: InputMaybe<Scalars["Float"]>;
	timeStamp_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	timeStamp_MAX_GT?: InputMaybe<Scalars["Float"]>;
	timeStamp_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	timeStamp_MAX_LT?: InputMaybe<Scalars["Float"]>;
	timeStamp_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	timeStamp_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	timeStamp_MIN_GT?: InputMaybe<Scalars["Float"]>;
	timeStamp_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	timeStamp_MIN_LT?: InputMaybe<Scalars["Float"]>;
	timeStamp_MIN_LTE?: InputMaybe<Scalars["Float"]>;
};

export type UserNotificationDueFieldInput = {
	connect?: InputMaybe<Array<UserNotificationDueConnectFieldInput>>;
	create?: InputMaybe<Array<UserNotificationDueCreateFieldInput>>;
};

export type UserNotificationDueNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<UserNotificationDueNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<UserNotificationDueNodeAggregationWhereInput>>;
	id_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	id_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	id_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	id_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	id_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	id_EQUAL?: InputMaybe<Scalars["Int"]>;
	id_GT?: InputMaybe<Scalars["Int"]>;
	id_GTE?: InputMaybe<Scalars["Int"]>;
	id_LT?: InputMaybe<Scalars["Int"]>;
	id_LTE?: InputMaybe<Scalars["Int"]>;
	id_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	id_MAX_GT?: InputMaybe<Scalars["Int"]>;
	id_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	id_MAX_LT?: InputMaybe<Scalars["Int"]>;
	id_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	id_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	id_MIN_GT?: InputMaybe<Scalars["Int"]>;
	id_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	id_MIN_LT?: InputMaybe<Scalars["Int"]>;
	id_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	name_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	name_EQUAL?: InputMaybe<Scalars["String"]>;
	name_GT?: InputMaybe<Scalars["Int"]>;
	name_GTE?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	name_LT?: InputMaybe<Scalars["Int"]>;
	name_LTE?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type UserNotificationDueRelationship = SummaryNotificationDue & {
	__typename?: "UserNotificationDueRelationship";
	cursor: Scalars["String"];
	dueDate: Scalars["Date"];
	message: Scalars["String"];
	node: Notification;
	timeStamp: Scalars["Float"];
};

export type UserNotificationDueUpdateConnectionInput = {
	edge?: InputMaybe<SummaryNotificationDueUpdateInput>;
	node?: InputMaybe<NotificationUpdateInput>;
};

export type UserNotificationDueUpdateFieldInput = {
	connect?: InputMaybe<Array<UserNotificationDueConnectFieldInput>>;
	create?: InputMaybe<Array<UserNotificationDueCreateFieldInput>>;
	delete?: InputMaybe<Array<UserNotificationDueDeleteFieldInput>>;
	disconnect?: InputMaybe<Array<UserNotificationDueDisconnectFieldInput>>;
	update?: InputMaybe<UserNotificationDueUpdateConnectionInput>;
	where?: InputMaybe<UserNotificationDueConnectionWhere>;
};

export type UserNotificationRelationship = {
	data?: Maybe<Scalars["String"]>;
	emailSentDate?: Maybe<Scalars["Date"]>;
	message: Scalars["String"];
	timeStamp: Scalars["Float"];
};

export type UserNotificationRelationshipCreateInput = {
	data?: InputMaybe<Scalars["String"]>;
	emailSentDate?: InputMaybe<Scalars["Date"]>;
	message: Scalars["String"];
	timeStamp: Scalars["Float"];
};

export type UserNotificationRelationshipSort = {
	data?: InputMaybe<SortDirection>;
	emailSentDate?: InputMaybe<SortDirection>;
	message?: InputMaybe<SortDirection>;
	timeStamp?: InputMaybe<SortDirection>;
};

export type UserNotificationRelationshipUpdateInput = {
	data?: InputMaybe<Scalars["String"]>;
	emailSentDate?: InputMaybe<Scalars["Date"]>;
	message?: InputMaybe<Scalars["String"]>;
	timeStamp?: InputMaybe<Scalars["Float"]>;
};

export type UserNotificationRelationshipWhere = {
	AND?: InputMaybe<Array<UserNotificationRelationshipWhere>>;
	OR?: InputMaybe<Array<UserNotificationRelationshipWhere>>;
	data?: InputMaybe<Scalars["String"]>;
	data_CONTAINS?: InputMaybe<Scalars["String"]>;
	data_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	data_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	data_MATCHES?: InputMaybe<Scalars["String"]>;
	data_NOT?: InputMaybe<Scalars["String"]>;
	data_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	data_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	data_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	data_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	data_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	emailSentDate?: InputMaybe<Scalars["Date"]>;
	emailSentDate_GT?: InputMaybe<Scalars["Date"]>;
	emailSentDate_GTE?: InputMaybe<Scalars["Date"]>;
	emailSentDate_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
	emailSentDate_LT?: InputMaybe<Scalars["Date"]>;
	emailSentDate_LTE?: InputMaybe<Scalars["Date"]>;
	emailSentDate_NOT?: InputMaybe<Scalars["Date"]>;
	emailSentDate_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
	message?: InputMaybe<Scalars["String"]>;
	message_CONTAINS?: InputMaybe<Scalars["String"]>;
	message_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	message_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	message_MATCHES?: InputMaybe<Scalars["String"]>;
	message_NOT?: InputMaybe<Scalars["String"]>;
	message_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	message_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	message_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	message_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	message_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	timeStamp?: InputMaybe<Scalars["Float"]>;
	timeStamp_GT?: InputMaybe<Scalars["Float"]>;
	timeStamp_GTE?: InputMaybe<Scalars["Float"]>;
	timeStamp_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
	timeStamp_LT?: InputMaybe<Scalars["Float"]>;
	timeStamp_LTE?: InputMaybe<Scalars["Float"]>;
	timeStamp_NOT?: InputMaybe<Scalars["Float"]>;
	timeStamp_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
};

export type UserNotifiedAggregateInput = {
	AND?: InputMaybe<Array<UserNotifiedAggregateInput>>;
	OR?: InputMaybe<Array<UserNotifiedAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	edge?: InputMaybe<UserNotifiedEdgeAggregationWhereInput>;
	node?: InputMaybe<UserNotifiedNodeAggregationWhereInput>;
};

export type UserNotifiedConnectFieldInput = {
	connect?: InputMaybe<Array<NotificationConnectInput>>;
	edge: UserNotificationRelationshipCreateInput;
	where?: InputMaybe<NotificationConnectWhere>;
};

export type UserNotifiedConnection = {
	__typename?: "UserNotifiedConnection";
	edges: Array<UserNotifiedRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type UserNotifiedConnectionSort = {
	edge?: InputMaybe<UserNotificationRelationshipSort>;
	node?: InputMaybe<NotificationSort>;
};

export type UserNotifiedConnectionWhere = {
	AND?: InputMaybe<Array<UserNotifiedConnectionWhere>>;
	OR?: InputMaybe<Array<UserNotifiedConnectionWhere>>;
	edge?: InputMaybe<UserNotificationRelationshipWhere>;
	edge_NOT?: InputMaybe<UserNotificationRelationshipWhere>;
	node?: InputMaybe<NotificationWhere>;
	node_NOT?: InputMaybe<NotificationWhere>;
};

export type UserNotifiedCreateFieldInput = {
	edge: UserNotificationRelationshipCreateInput;
	node: NotificationCreateInput;
};

export type UserNotifiedDeleteFieldInput = {
	delete?: InputMaybe<NotificationDeleteInput>;
	where?: InputMaybe<UserNotifiedConnectionWhere>;
};

export type UserNotifiedDisconnectFieldInput = {
	disconnect?: InputMaybe<NotificationDisconnectInput>;
	where?: InputMaybe<UserNotifiedConnectionWhere>;
};

export type UserNotifiedEdgeAggregationWhereInput = {
	AND?: InputMaybe<Array<UserNotifiedEdgeAggregationWhereInput>>;
	OR?: InputMaybe<Array<UserNotifiedEdgeAggregationWhereInput>>;
	data_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	data_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	data_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	data_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	data_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	data_EQUAL?: InputMaybe<Scalars["String"]>;
	data_GT?: InputMaybe<Scalars["Int"]>;
	data_GTE?: InputMaybe<Scalars["Int"]>;
	data_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	data_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	data_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	data_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	data_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	data_LT?: InputMaybe<Scalars["Int"]>;
	data_LTE?: InputMaybe<Scalars["Int"]>;
	data_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	data_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	data_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	data_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	data_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	message_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	message_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	message_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	message_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	message_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	message_EQUAL?: InputMaybe<Scalars["String"]>;
	message_GT?: InputMaybe<Scalars["Int"]>;
	message_GTE?: InputMaybe<Scalars["Int"]>;
	message_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	message_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	message_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	message_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	message_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	message_LT?: InputMaybe<Scalars["Int"]>;
	message_LTE?: InputMaybe<Scalars["Int"]>;
	message_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	message_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	message_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	message_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	message_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	timeStamp_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	timeStamp_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	timeStamp_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	timeStamp_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	timeStamp_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	timeStamp_EQUAL?: InputMaybe<Scalars["Float"]>;
	timeStamp_GT?: InputMaybe<Scalars["Float"]>;
	timeStamp_GTE?: InputMaybe<Scalars["Float"]>;
	timeStamp_LT?: InputMaybe<Scalars["Float"]>;
	timeStamp_LTE?: InputMaybe<Scalars["Float"]>;
	timeStamp_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	timeStamp_MAX_GT?: InputMaybe<Scalars["Float"]>;
	timeStamp_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	timeStamp_MAX_LT?: InputMaybe<Scalars["Float"]>;
	timeStamp_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	timeStamp_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	timeStamp_MIN_GT?: InputMaybe<Scalars["Float"]>;
	timeStamp_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	timeStamp_MIN_LT?: InputMaybe<Scalars["Float"]>;
	timeStamp_MIN_LTE?: InputMaybe<Scalars["Float"]>;
};

export type UserNotifiedFieldInput = {
	connect?: InputMaybe<Array<UserNotifiedConnectFieldInput>>;
	create?: InputMaybe<Array<UserNotifiedCreateFieldInput>>;
};

export type UserNotifiedNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<UserNotifiedNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<UserNotifiedNodeAggregationWhereInput>>;
	id_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	id_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	id_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	id_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	id_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	id_EQUAL?: InputMaybe<Scalars["Int"]>;
	id_GT?: InputMaybe<Scalars["Int"]>;
	id_GTE?: InputMaybe<Scalars["Int"]>;
	id_LT?: InputMaybe<Scalars["Int"]>;
	id_LTE?: InputMaybe<Scalars["Int"]>;
	id_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	id_MAX_GT?: InputMaybe<Scalars["Int"]>;
	id_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	id_MAX_LT?: InputMaybe<Scalars["Int"]>;
	id_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	id_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	id_MIN_GT?: InputMaybe<Scalars["Int"]>;
	id_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	id_MIN_LT?: InputMaybe<Scalars["Int"]>;
	id_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	name_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	name_EQUAL?: InputMaybe<Scalars["String"]>;
	name_GT?: InputMaybe<Scalars["Int"]>;
	name_GTE?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	name_LT?: InputMaybe<Scalars["Int"]>;
	name_LTE?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type UserNotifiedRelationship = UserNotificationRelationship & {
	__typename?: "UserNotifiedRelationship";
	cursor: Scalars["String"];
	data?: Maybe<Scalars["String"]>;
	emailSentDate?: Maybe<Scalars["Date"]>;
	message: Scalars["String"];
	node: Notification;
	timeStamp: Scalars["Float"];
};

export type UserNotifiedUpdateConnectionInput = {
	edge?: InputMaybe<UserNotificationRelationshipUpdateInput>;
	node?: InputMaybe<NotificationUpdateInput>;
};

export type UserNotifiedUpdateFieldInput = {
	connect?: InputMaybe<Array<UserNotifiedConnectFieldInput>>;
	create?: InputMaybe<Array<UserNotifiedCreateFieldInput>>;
	delete?: InputMaybe<Array<UserNotifiedDeleteFieldInput>>;
	disconnect?: InputMaybe<Array<UserNotifiedDisconnectFieldInput>>;
	update?: InputMaybe<UserNotifiedUpdateConnectionInput>;
	where?: InputMaybe<UserNotifiedConnectionWhere>;
};

export type UserOptions = {
	limit?: InputMaybe<Scalars["Int"]>;
	offset?: InputMaybe<Scalars["Int"]>;
	/** Specify one or more UserSort objects to sort Users by. The sorts will be applied in the order in which they are arranged in the array. */
	sort?: InputMaybe<Array<InputMaybe<UserSort>>>;
};

export type UserOrgSettingsData = {
	__typename?: "UserOrgSettingsData";
	hasOperativeDataAccess?: Maybe<Scalars["Boolean"]>;
	role?: Maybe<Scalars["String"]>;
	userId?: Maybe<Scalars["String"]>;
};

export type UserOrgSettingsDataAggregateSelection = {
	__typename?: "UserOrgSettingsDataAggregateSelection";
	count: Scalars["Int"];
	role: StringAggregateSelection;
	userId: StringAggregateSelection;
};

export type UserOrgSettingsDataOptions = {
	limit?: InputMaybe<Scalars["Int"]>;
	offset?: InputMaybe<Scalars["Int"]>;
	/** Specify one or more UserOrgSettingsDataSort objects to sort UserOrgSettingsData by. The sorts will be applied in the order in which they are arranged in the array. */
	sort?: InputMaybe<Array<InputMaybe<UserOrgSettingsDataSort>>>;
};

/** Fields to sort UserOrgSettingsData by. The order in which sorts are applied is not guaranteed when specifying many fields in one UserOrgSettingsDataSort object. */
export type UserOrgSettingsDataSort = {
	hasOperativeDataAccess?: InputMaybe<SortDirection>;
	role?: InputMaybe<SortDirection>;
	userId?: InputMaybe<SortDirection>;
};

export type UserOrgSettingsDataWhere = {
	AND?: InputMaybe<Array<UserOrgSettingsDataWhere>>;
	OR?: InputMaybe<Array<UserOrgSettingsDataWhere>>;
	hasOperativeDataAccess?: InputMaybe<Scalars["Boolean"]>;
	hasOperativeDataAccess_NOT?: InputMaybe<Scalars["Boolean"]>;
	role?: InputMaybe<Scalars["String"]>;
	role_CONTAINS?: InputMaybe<Scalars["String"]>;
	role_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	role_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	role_MATCHES?: InputMaybe<Scalars["String"]>;
	role_NOT?: InputMaybe<Scalars["String"]>;
	role_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	role_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	role_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	role_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	role_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	userId?: InputMaybe<Scalars["String"]>;
	userId_CONTAINS?: InputMaybe<Scalars["String"]>;
	userId_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	userId_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	userId_MATCHES?: InputMaybe<Scalars["String"]>;
	userId_NOT?: InputMaybe<Scalars["String"]>;
	userId_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	userId_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	userId_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	userId_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	userId_STARTS_WITH?: InputMaybe<Scalars["String"]>;
};

export type UserOrganizationInfo = {
	__typename?: "UserOrganizationInfo";
	firstName?: Maybe<Scalars["String"]>;
	id: Scalars["String"];
	lastName?: Maybe<Scalars["String"]>;
};

export type UserOrganizationInfoAggregateSelection = {
	__typename?: "UserOrganizationInfoAggregateSelection";
	count: Scalars["Int"];
	firstName: StringAggregateSelection;
	id: StringAggregateSelection;
	lastName: StringAggregateSelection;
};

export type UserOrganizationInfoOptions = {
	limit?: InputMaybe<Scalars["Int"]>;
	offset?: InputMaybe<Scalars["Int"]>;
	/** Specify one or more UserOrganizationInfoSort objects to sort UserOrganizationInfos by. The sorts will be applied in the order in which they are arranged in the array. */
	sort?: InputMaybe<Array<InputMaybe<UserOrganizationInfoSort>>>;
};

/** Fields to sort UserOrganizationInfos by. The order in which sorts are applied is not guaranteed when specifying many fields in one UserOrganizationInfoSort object. */
export type UserOrganizationInfoSort = {
	firstName?: InputMaybe<SortDirection>;
	id?: InputMaybe<SortDirection>;
	lastName?: InputMaybe<SortDirection>;
};

export type UserOrganizationInfoWhere = {
	AND?: InputMaybe<Array<UserOrganizationInfoWhere>>;
	OR?: InputMaybe<Array<UserOrganizationInfoWhere>>;
	firstName?: InputMaybe<Scalars["String"]>;
	firstName_CONTAINS?: InputMaybe<Scalars["String"]>;
	firstName_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	firstName_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	firstName_MATCHES?: InputMaybe<Scalars["String"]>;
	firstName_NOT?: InputMaybe<Scalars["String"]>;
	firstName_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	firstName_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	firstName_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	firstName_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	firstName_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	id?: InputMaybe<Scalars["String"]>;
	id_CONTAINS?: InputMaybe<Scalars["String"]>;
	id_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	id_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	id_MATCHES?: InputMaybe<Scalars["String"]>;
	id_NOT?: InputMaybe<Scalars["String"]>;
	id_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	id_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	id_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	id_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	id_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	lastName?: InputMaybe<Scalars["String"]>;
	lastName_CONTAINS?: InputMaybe<Scalars["String"]>;
	lastName_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	lastName_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	lastName_MATCHES?: InputMaybe<Scalars["String"]>;
	lastName_NOT?: InputMaybe<Scalars["String"]>;
	lastName_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	lastName_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	lastName_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	lastName_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	lastName_STARTS_WITH?: InputMaybe<Scalars["String"]>;
};

export type UserPatientsAggregateInput = {
	AND?: InputMaybe<Array<UserPatientsAggregateInput>>;
	OR?: InputMaybe<Array<UserPatientsAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<UserPatientsNodeAggregationWhereInput>;
};

export type UserPatientsConnectFieldInput = {
	connect?: InputMaybe<Array<PatientConnectInput>>;
	where?: InputMaybe<PatientConnectWhere>;
};

export type UserPatientsConnection = {
	__typename?: "UserPatientsConnection";
	edges: Array<UserPatientsRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type UserPatientsConnectionSort = {
	node?: InputMaybe<PatientSort>;
};

export type UserPatientsConnectionWhere = {
	AND?: InputMaybe<Array<UserPatientsConnectionWhere>>;
	OR?: InputMaybe<Array<UserPatientsConnectionWhere>>;
	node?: InputMaybe<PatientWhere>;
	node_NOT?: InputMaybe<PatientWhere>;
};

export type UserPatientsCreateFieldInput = {
	node: PatientCreateInput;
};

export type UserPatientsDeleteFieldInput = {
	delete?: InputMaybe<PatientDeleteInput>;
	where?: InputMaybe<UserPatientsConnectionWhere>;
};

export type UserPatientsDisconnectFieldInput = {
	disconnect?: InputMaybe<PatientDisconnectInput>;
	where?: InputMaybe<UserPatientsConnectionWhere>;
};

export type UserPatientsFieldInput = {
	connect?: InputMaybe<Array<UserPatientsConnectFieldInput>>;
	create?: InputMaybe<Array<UserPatientsCreateFieldInput>>;
};

export type UserPatientsNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<UserPatientsNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<UserPatientsNodeAggregationWhereInput>>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	initials_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	initials_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	initials_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	initials_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	initials_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	initials_EQUAL?: InputMaybe<Scalars["String"]>;
	initials_GT?: InputMaybe<Scalars["Int"]>;
	initials_GTE?: InputMaybe<Scalars["Int"]>;
	initials_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	initials_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	initials_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	initials_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	initials_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	initials_LT?: InputMaybe<Scalars["Int"]>;
	initials_LTE?: InputMaybe<Scalars["Int"]>;
	initials_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	initials_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	initials_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	initials_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	initials_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	insuranceId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	insuranceId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	insuranceId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	insuranceId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	insuranceId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	insuranceId_EQUAL?: InputMaybe<Scalars["String"]>;
	insuranceId_GT?: InputMaybe<Scalars["Int"]>;
	insuranceId_GTE?: InputMaybe<Scalars["Int"]>;
	insuranceId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	insuranceId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	insuranceId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	insuranceId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	insuranceId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	insuranceId_LT?: InputMaybe<Scalars["Int"]>;
	insuranceId_LTE?: InputMaybe<Scalars["Int"]>;
	insuranceId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	insuranceId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	insuranceId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	insuranceId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	insuranceId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	tenantId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	tenantId_EQUAL?: InputMaybe<Scalars["String"]>;
	tenantId_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_LTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	tenantId_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	timeStamp_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	timeStamp_GT?: InputMaybe<Scalars["DateTime"]>;
	timeStamp_GTE?: InputMaybe<Scalars["DateTime"]>;
	timeStamp_LT?: InputMaybe<Scalars["DateTime"]>;
	timeStamp_LTE?: InputMaybe<Scalars["DateTime"]>;
	timeStamp_MAX_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	timeStamp_MAX_GT?: InputMaybe<Scalars["DateTime"]>;
	timeStamp_MAX_GTE?: InputMaybe<Scalars["DateTime"]>;
	timeStamp_MAX_LT?: InputMaybe<Scalars["DateTime"]>;
	timeStamp_MAX_LTE?: InputMaybe<Scalars["DateTime"]>;
	timeStamp_MIN_EQUAL?: InputMaybe<Scalars["DateTime"]>;
	timeStamp_MIN_GT?: InputMaybe<Scalars["DateTime"]>;
	timeStamp_MIN_GTE?: InputMaybe<Scalars["DateTime"]>;
	timeStamp_MIN_LT?: InputMaybe<Scalars["DateTime"]>;
	timeStamp_MIN_LTE?: InputMaybe<Scalars["DateTime"]>;
	yearOfBirth_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	yearOfBirth_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	yearOfBirth_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	yearOfBirth_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	yearOfBirth_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	yearOfBirth_EQUAL?: InputMaybe<Scalars["Int"]>;
	yearOfBirth_GT?: InputMaybe<Scalars["Int"]>;
	yearOfBirth_GTE?: InputMaybe<Scalars["Int"]>;
	yearOfBirth_LT?: InputMaybe<Scalars["Int"]>;
	yearOfBirth_LTE?: InputMaybe<Scalars["Int"]>;
	yearOfBirth_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	yearOfBirth_MAX_GT?: InputMaybe<Scalars["Int"]>;
	yearOfBirth_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	yearOfBirth_MAX_LT?: InputMaybe<Scalars["Int"]>;
	yearOfBirth_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	yearOfBirth_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	yearOfBirth_MIN_GT?: InputMaybe<Scalars["Int"]>;
	yearOfBirth_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	yearOfBirth_MIN_LT?: InputMaybe<Scalars["Int"]>;
	yearOfBirth_MIN_LTE?: InputMaybe<Scalars["Int"]>;
};

export type UserPatientsRelationship = {
	__typename?: "UserPatientsRelationship";
	cursor: Scalars["String"];
	node: Patient;
};

export type UserPatientsUpdateConnectionInput = {
	node?: InputMaybe<PatientUpdateInput>;
};

export type UserPatientsUpdateFieldInput = {
	connect?: InputMaybe<Array<UserPatientsConnectFieldInput>>;
	create?: InputMaybe<Array<UserPatientsCreateFieldInput>>;
	delete?: InputMaybe<Array<UserPatientsDeleteFieldInput>>;
	disconnect?: InputMaybe<Array<UserPatientsDisconnectFieldInput>>;
	update?: InputMaybe<UserPatientsUpdateConnectionInput>;
	where?: InputMaybe<UserPatientsConnectionWhere>;
};

export type UserPersonalInfo = {
	__typename?: "UserPersonalInfo";
	firstName: Scalars["String"];
	lastName: Scalars["String"];
	preferredLanguage: Scalars["String"];
};

export type UserPersonalInfoAggregateSelection = {
	__typename?: "UserPersonalInfoAggregateSelection";
	count: Scalars["Int"];
	firstName: StringAggregateSelection;
	lastName: StringAggregateSelection;
	preferredLanguage: StringAggregateSelection;
};

export type UserPersonalInfoInput = {
	firstName: Scalars["String"];
	lastName: Scalars["String"];
	preferredLanguage: Scalars["String"];
};

export type UserPersonalInfoOptions = {
	limit?: InputMaybe<Scalars["Int"]>;
	offset?: InputMaybe<Scalars["Int"]>;
	/** Specify one or more UserPersonalInfoSort objects to sort UserPersonalInfos by. The sorts will be applied in the order in which they are arranged in the array. */
	sort?: InputMaybe<Array<InputMaybe<UserPersonalInfoSort>>>;
};

/** Fields to sort UserPersonalInfos by. The order in which sorts are applied is not guaranteed when specifying many fields in one UserPersonalInfoSort object. */
export type UserPersonalInfoSort = {
	firstName?: InputMaybe<SortDirection>;
	lastName?: InputMaybe<SortDirection>;
	preferredLanguage?: InputMaybe<SortDirection>;
};

export type UserPersonalInfoWhere = {
	AND?: InputMaybe<Array<UserPersonalInfoWhere>>;
	OR?: InputMaybe<Array<UserPersonalInfoWhere>>;
	firstName?: InputMaybe<Scalars["String"]>;
	firstName_CONTAINS?: InputMaybe<Scalars["String"]>;
	firstName_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	firstName_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	firstName_MATCHES?: InputMaybe<Scalars["String"]>;
	firstName_NOT?: InputMaybe<Scalars["String"]>;
	firstName_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	firstName_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	firstName_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	firstName_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	firstName_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	lastName?: InputMaybe<Scalars["String"]>;
	lastName_CONTAINS?: InputMaybe<Scalars["String"]>;
	lastName_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	lastName_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	lastName_MATCHES?: InputMaybe<Scalars["String"]>;
	lastName_NOT?: InputMaybe<Scalars["String"]>;
	lastName_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	lastName_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	lastName_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	lastName_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	lastName_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	preferredLanguage?: InputMaybe<Scalars["String"]>;
	preferredLanguage_CONTAINS?: InputMaybe<Scalars["String"]>;
	preferredLanguage_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	preferredLanguage_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	preferredLanguage_MATCHES?: InputMaybe<Scalars["String"]>;
	preferredLanguage_NOT?: InputMaybe<Scalars["String"]>;
	preferredLanguage_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	preferredLanguage_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	preferredLanguage_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	preferredLanguage_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	preferredLanguage_STARTS_WITH?: InputMaybe<Scalars["String"]>;
};

export type UserRelationInput = {
	claims?: InputMaybe<Array<UserClaimsCreateFieldInput>>;
	context?: InputMaybe<UserContextCreateFieldInput>;
	mentions?: InputMaybe<Array<UserMentionsCreateFieldInput>>;
	notificationDue?: InputMaybe<Array<UserNotificationDueCreateFieldInput>>;
	notified?: InputMaybe<Array<UserNotifiedCreateFieldInput>>;
	patients?: InputMaybe<Array<UserPatientsCreateFieldInput>>;
	sentMessage?: InputMaybe<UserSentMessageCreateFieldInput>;
	subscribed?: InputMaybe<Array<UserSubscribedCreateFieldInput>>;
	tasks?: InputMaybe<Array<UserTasksCreateFieldInput>>;
};

export type UserRoleRequestUpdateInput = {
	agreementId: Scalars["String"];
	agreementName: Scalars["String"];
	role: Scalars["String"];
	userId: Scalars["String"];
};

export type UserSentMessageAggregateInput = {
	AND?: InputMaybe<Array<UserSentMessageAggregateInput>>;
	OR?: InputMaybe<Array<UserSentMessageAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<UserSentMessageNodeAggregationWhereInput>;
};

export type UserSentMessageConnectFieldInput = {
	connect?: InputMaybe<MessageConnectInput>;
	where?: InputMaybe<MessageConnectWhere>;
};

export type UserSentMessageConnection = {
	__typename?: "UserSentMessageConnection";
	edges: Array<UserSentMessageRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type UserSentMessageConnectionSort = {
	node?: InputMaybe<MessageSort>;
};

export type UserSentMessageConnectionWhere = {
	AND?: InputMaybe<Array<UserSentMessageConnectionWhere>>;
	OR?: InputMaybe<Array<UserSentMessageConnectionWhere>>;
	node?: InputMaybe<MessageWhere>;
	node_NOT?: InputMaybe<MessageWhere>;
};

export type UserSentMessageCreateFieldInput = {
	node: MessageCreateInput;
};

export type UserSentMessageDeleteFieldInput = {
	delete?: InputMaybe<MessageDeleteInput>;
	where?: InputMaybe<UserSentMessageConnectionWhere>;
};

export type UserSentMessageDisconnectFieldInput = {
	disconnect?: InputMaybe<MessageDisconnectInput>;
	where?: InputMaybe<UserSentMessageConnectionWhere>;
};

export type UserSentMessageFieldInput = {
	connect?: InputMaybe<UserSentMessageConnectFieldInput>;
	create?: InputMaybe<UserSentMessageCreateFieldInput>;
};

export type UserSentMessageNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<UserSentMessageNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<UserSentMessageNodeAggregationWhereInput>>;
	content_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	content_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	content_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	content_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	content_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	content_EQUAL?: InputMaybe<Scalars["String"]>;
	content_GT?: InputMaybe<Scalars["Int"]>;
	content_GTE?: InputMaybe<Scalars["Int"]>;
	content_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	content_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	content_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	content_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	content_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	content_LT?: InputMaybe<Scalars["Int"]>;
	content_LTE?: InputMaybe<Scalars["Int"]>;
	content_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	content_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	content_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	content_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	content_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
	createdOn_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	createdOn_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	createdOn_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	createdOn_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	createdOn_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	createdOn_EQUAL?: InputMaybe<Scalars["Float"]>;
	createdOn_GT?: InputMaybe<Scalars["Float"]>;
	createdOn_GTE?: InputMaybe<Scalars["Float"]>;
	createdOn_LT?: InputMaybe<Scalars["Float"]>;
	createdOn_LTE?: InputMaybe<Scalars["Float"]>;
	createdOn_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	createdOn_MAX_GT?: InputMaybe<Scalars["Float"]>;
	createdOn_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	createdOn_MAX_LT?: InputMaybe<Scalars["Float"]>;
	createdOn_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	createdOn_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	createdOn_MIN_GT?: InputMaybe<Scalars["Float"]>;
	createdOn_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	createdOn_MIN_LT?: InputMaybe<Scalars["Float"]>;
	createdOn_MIN_LTE?: InputMaybe<Scalars["Float"]>;
};

export type UserSentMessageRelationship = {
	__typename?: "UserSentMessageRelationship";
	cursor: Scalars["String"];
	node: Message;
};

export type UserSentMessageUpdateConnectionInput = {
	node?: InputMaybe<MessageUpdateInput>;
};

export type UserSentMessageUpdateFieldInput = {
	connect?: InputMaybe<UserSentMessageConnectFieldInput>;
	create?: InputMaybe<UserSentMessageCreateFieldInput>;
	delete?: InputMaybe<UserSentMessageDeleteFieldInput>;
	disconnect?: InputMaybe<UserSentMessageDisconnectFieldInput>;
	update?: InputMaybe<UserSentMessageUpdateConnectionInput>;
	where?: InputMaybe<UserSentMessageConnectionWhere>;
};

/** Fields to sort Users by. The order in which sorts are applied is not guaranteed when specifying many fields in one UserSort object. */
export type UserSort = {
	email?: InputMaybe<SortDirection>;
	firstName?: InputMaybe<SortDirection>;
	id?: InputMaybe<SortDirection>;
	lastName?: InputMaybe<SortDirection>;
	preferredLanguage?: InputMaybe<SortDirection>;
	tenantId?: InputMaybe<SortDirection>;
};

export type UserSubscribedAggregateInput = {
	AND?: InputMaybe<Array<UserSubscribedAggregateInput>>;
	OR?: InputMaybe<Array<UserSubscribedAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<UserSubscribedNodeAggregationWhereInput>;
};

export type UserSubscribedConnectFieldInput = {
	connect?: InputMaybe<Array<NotificationConnectInput>>;
	where?: InputMaybe<NotificationConnectWhere>;
};

export type UserSubscribedConnection = {
	__typename?: "UserSubscribedConnection";
	edges: Array<UserSubscribedRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type UserSubscribedConnectionSort = {
	node?: InputMaybe<NotificationSort>;
};

export type UserSubscribedConnectionWhere = {
	AND?: InputMaybe<Array<UserSubscribedConnectionWhere>>;
	OR?: InputMaybe<Array<UserSubscribedConnectionWhere>>;
	node?: InputMaybe<NotificationWhere>;
	node_NOT?: InputMaybe<NotificationWhere>;
};

export type UserSubscribedCreateFieldInput = {
	node: NotificationCreateInput;
};

export type UserSubscribedDeleteFieldInput = {
	delete?: InputMaybe<NotificationDeleteInput>;
	where?: InputMaybe<UserSubscribedConnectionWhere>;
};

export type UserSubscribedDisconnectFieldInput = {
	disconnect?: InputMaybe<NotificationDisconnectInput>;
	where?: InputMaybe<UserSubscribedConnectionWhere>;
};

export type UserSubscribedFieldInput = {
	connect?: InputMaybe<Array<UserSubscribedConnectFieldInput>>;
	create?: InputMaybe<Array<UserSubscribedCreateFieldInput>>;
};

export type UserSubscribedNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<UserSubscribedNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<UserSubscribedNodeAggregationWhereInput>>;
	id_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	id_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	id_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	id_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	id_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	id_EQUAL?: InputMaybe<Scalars["Int"]>;
	id_GT?: InputMaybe<Scalars["Int"]>;
	id_GTE?: InputMaybe<Scalars["Int"]>;
	id_LT?: InputMaybe<Scalars["Int"]>;
	id_LTE?: InputMaybe<Scalars["Int"]>;
	id_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	id_MAX_GT?: InputMaybe<Scalars["Int"]>;
	id_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	id_MAX_LT?: InputMaybe<Scalars["Int"]>;
	id_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	id_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	id_MIN_GT?: InputMaybe<Scalars["Int"]>;
	id_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	id_MIN_LT?: InputMaybe<Scalars["Int"]>;
	id_MIN_LTE?: InputMaybe<Scalars["Int"]>;
	name_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	name_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	name_EQUAL?: InputMaybe<Scalars["String"]>;
	name_GT?: InputMaybe<Scalars["Int"]>;
	name_GTE?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_GT?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_GTE?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_LT?: InputMaybe<Scalars["Int"]>;
	name_LONGEST_LTE?: InputMaybe<Scalars["Int"]>;
	name_LT?: InputMaybe<Scalars["Int"]>;
	name_LTE?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_EQUAL?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_GT?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_GTE?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_LT?: InputMaybe<Scalars["Int"]>;
	name_SHORTEST_LTE?: InputMaybe<Scalars["Int"]>;
};

export type UserSubscribedRelationship = {
	__typename?: "UserSubscribedRelationship";
	cursor: Scalars["String"];
	node: Notification;
};

export type UserSubscribedUpdateConnectionInput = {
	node?: InputMaybe<NotificationUpdateInput>;
};

export type UserSubscribedUpdateFieldInput = {
	connect?: InputMaybe<Array<UserSubscribedConnectFieldInput>>;
	create?: InputMaybe<Array<UserSubscribedCreateFieldInput>>;
	delete?: InputMaybe<Array<UserSubscribedDeleteFieldInput>>;
	disconnect?: InputMaybe<Array<UserSubscribedDisconnectFieldInput>>;
	update?: InputMaybe<UserSubscribedUpdateConnectionInput>;
	where?: InputMaybe<UserSubscribedConnectionWhere>;
};

export type UserTaskProperties = {
	isCompleted?: Maybe<Scalars["Boolean"]>;
};

export type UserTaskPropertiesCreateInput = {
	isCompleted?: InputMaybe<Scalars["Boolean"]>;
};

export type UserTaskPropertiesSort = {
	isCompleted?: InputMaybe<SortDirection>;
};

export type UserTaskPropertiesUpdateInput = {
	isCompleted?: InputMaybe<Scalars["Boolean"]>;
};

export type UserTaskPropertiesWhere = {
	AND?: InputMaybe<Array<UserTaskPropertiesWhere>>;
	OR?: InputMaybe<Array<UserTaskPropertiesWhere>>;
	isCompleted?: InputMaybe<Scalars["Boolean"]>;
	isCompleted_NOT?: InputMaybe<Scalars["Boolean"]>;
};

export type UserTaskRelationship = {
	isCompleted: Scalars["Boolean"];
};

export type UserTaskRelationshipCreateInput = {
	isCompleted: Scalars["Boolean"];
};

export type UserTaskRelationshipSort = {
	isCompleted?: InputMaybe<SortDirection>;
};

export type UserTaskRelationshipUpdateInput = {
	isCompleted?: InputMaybe<Scalars["Boolean"]>;
};

export type UserTaskRelationshipWhere = {
	AND?: InputMaybe<Array<UserTaskRelationshipWhere>>;
	OR?: InputMaybe<Array<UserTaskRelationshipWhere>>;
	isCompleted?: InputMaybe<Scalars["Boolean"]>;
	isCompleted_NOT?: InputMaybe<Scalars["Boolean"]>;
};

export type UserTasksAggregateInput = {
	AND?: InputMaybe<Array<UserTasksAggregateInput>>;
	OR?: InputMaybe<Array<UserTasksAggregateInput>>;
	count?: InputMaybe<Scalars["Int"]>;
	count_GT?: InputMaybe<Scalars["Int"]>;
	count_GTE?: InputMaybe<Scalars["Int"]>;
	count_LT?: InputMaybe<Scalars["Int"]>;
	count_LTE?: InputMaybe<Scalars["Int"]>;
	node?: InputMaybe<UserTasksNodeAggregationWhereInput>;
};

export type UserTasksConnectFieldInput = {
	connect?: InputMaybe<Array<TaskConnectInput>>;
	edge?: InputMaybe<UserTaskPropertiesCreateInput>;
	where?: InputMaybe<TaskConnectWhere>;
};

export type UserTasksConnection = {
	__typename?: "UserTasksConnection";
	edges: Array<UserTasksRelationship>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"];
};

export type UserTasksConnectionSort = {
	edge?: InputMaybe<UserTaskPropertiesSort>;
	node?: InputMaybe<TaskSort>;
};

export type UserTasksConnectionWhere = {
	AND?: InputMaybe<Array<UserTasksConnectionWhere>>;
	OR?: InputMaybe<Array<UserTasksConnectionWhere>>;
	edge?: InputMaybe<UserTaskPropertiesWhere>;
	edge_NOT?: InputMaybe<UserTaskPropertiesWhere>;
	node?: InputMaybe<TaskWhere>;
	node_NOT?: InputMaybe<TaskWhere>;
};

export type UserTasksCreateFieldInput = {
	edge?: InputMaybe<UserTaskPropertiesCreateInput>;
	node: TaskCreateInput;
};

export type UserTasksDeleteFieldInput = {
	delete?: InputMaybe<TaskDeleteInput>;
	where?: InputMaybe<UserTasksConnectionWhere>;
};

export type UserTasksDisconnectFieldInput = {
	disconnect?: InputMaybe<TaskDisconnectInput>;
	where?: InputMaybe<UserTasksConnectionWhere>;
};

export type UserTasksFieldInput = {
	connect?: InputMaybe<Array<UserTasksConnectFieldInput>>;
	create?: InputMaybe<Array<UserTasksCreateFieldInput>>;
};

export type UserTasksNodeAggregationWhereInput = {
	AND?: InputMaybe<Array<UserTasksNodeAggregationWhereInput>>;
	OR?: InputMaybe<Array<UserTasksNodeAggregationWhereInput>>;
	id_EQUAL?: InputMaybe<Scalars["ID"]>;
	timeStamp_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	timeStamp_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	timeStamp_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	timeStamp_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	timeStamp_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	timeStamp_EQUAL?: InputMaybe<Scalars["Float"]>;
	timeStamp_GT?: InputMaybe<Scalars["Float"]>;
	timeStamp_GTE?: InputMaybe<Scalars["Float"]>;
	timeStamp_LT?: InputMaybe<Scalars["Float"]>;
	timeStamp_LTE?: InputMaybe<Scalars["Float"]>;
	timeStamp_MAX_EQUAL?: InputMaybe<Scalars["Float"]>;
	timeStamp_MAX_GT?: InputMaybe<Scalars["Float"]>;
	timeStamp_MAX_GTE?: InputMaybe<Scalars["Float"]>;
	timeStamp_MAX_LT?: InputMaybe<Scalars["Float"]>;
	timeStamp_MAX_LTE?: InputMaybe<Scalars["Float"]>;
	timeStamp_MIN_EQUAL?: InputMaybe<Scalars["Float"]>;
	timeStamp_MIN_GT?: InputMaybe<Scalars["Float"]>;
	timeStamp_MIN_GTE?: InputMaybe<Scalars["Float"]>;
	timeStamp_MIN_LT?: InputMaybe<Scalars["Float"]>;
	timeStamp_MIN_LTE?: InputMaybe<Scalars["Float"]>;
	triggerEventId_AVERAGE_EQUAL?: InputMaybe<Scalars["Float"]>;
	triggerEventId_AVERAGE_GT?: InputMaybe<Scalars["Float"]>;
	triggerEventId_AVERAGE_GTE?: InputMaybe<Scalars["Float"]>;
	triggerEventId_AVERAGE_LT?: InputMaybe<Scalars["Float"]>;
	triggerEventId_AVERAGE_LTE?: InputMaybe<Scalars["Float"]>;
	triggerEventId_EQUAL?: InputMaybe<Scalars["Int"]>;
	triggerEventId_GT?: InputMaybe<Scalars["Int"]>;
	triggerEventId_GTE?: InputMaybe<Scalars["Int"]>;
	triggerEventId_LT?: InputMaybe<Scalars["Int"]>;
	triggerEventId_LTE?: InputMaybe<Scalars["Int"]>;
	triggerEventId_MAX_EQUAL?: InputMaybe<Scalars["Int"]>;
	triggerEventId_MAX_GT?: InputMaybe<Scalars["Int"]>;
	triggerEventId_MAX_GTE?: InputMaybe<Scalars["Int"]>;
	triggerEventId_MAX_LT?: InputMaybe<Scalars["Int"]>;
	triggerEventId_MAX_LTE?: InputMaybe<Scalars["Int"]>;
	triggerEventId_MIN_EQUAL?: InputMaybe<Scalars["Int"]>;
	triggerEventId_MIN_GT?: InputMaybe<Scalars["Int"]>;
	triggerEventId_MIN_GTE?: InputMaybe<Scalars["Int"]>;
	triggerEventId_MIN_LT?: InputMaybe<Scalars["Int"]>;
	triggerEventId_MIN_LTE?: InputMaybe<Scalars["Int"]>;
};

export type UserTasksRelationship = UserTaskProperties & {
	__typename?: "UserTasksRelationship";
	cursor: Scalars["String"];
	isCompleted?: Maybe<Scalars["Boolean"]>;
	node: Task;
};

export type UserTasksUpdateConnectionInput = {
	edge?: InputMaybe<UserTaskPropertiesUpdateInput>;
	node?: InputMaybe<TaskUpdateInput>;
};

export type UserTasksUpdateFieldInput = {
	connect?: InputMaybe<Array<UserTasksConnectFieldInput>>;
	create?: InputMaybe<Array<UserTasksCreateFieldInput>>;
	delete?: InputMaybe<Array<UserTasksDeleteFieldInput>>;
	disconnect?: InputMaybe<Array<UserTasksDisconnectFieldInput>>;
	update?: InputMaybe<UserTasksUpdateConnectionInput>;
	where?: InputMaybe<UserTasksConnectionWhere>;
};

export type UserUpdateInput = {
	claims?: InputMaybe<Array<UserClaimsUpdateFieldInput>>;
	context?: InputMaybe<UserContextUpdateFieldInput>;
	email?: InputMaybe<Scalars["String"]>;
	firstName?: InputMaybe<Scalars["String"]>;
	id?: InputMaybe<Scalars["ID"]>;
	lastName?: InputMaybe<Scalars["String"]>;
	mentions?: InputMaybe<Array<UserMentionsUpdateFieldInput>>;
	notificationDue?: InputMaybe<Array<UserNotificationDueUpdateFieldInput>>;
	notified?: InputMaybe<Array<UserNotifiedUpdateFieldInput>>;
	patients?: InputMaybe<Array<UserPatientsUpdateFieldInput>>;
	preferredLanguage?: InputMaybe<Scalars["String"]>;
	reads?: InputMaybe<Array<Scalars["String"]>>;
	sentMessage?: InputMaybe<UserSentMessageUpdateFieldInput>;
	subscribed?: InputMaybe<Array<UserSubscribedUpdateFieldInput>>;
	tasks?: InputMaybe<Array<UserTasksUpdateFieldInput>>;
	tenantId?: InputMaybe<Scalars["String"]>;
	writes?: InputMaybe<Array<Scalars["String"]>>;
};

export type UserWhere = {
	AND?: InputMaybe<Array<UserWhere>>;
	OR?: InputMaybe<Array<UserWhere>>;
	claims?: InputMaybe<ClaimWhere>;
	claimsAggregate?: InputMaybe<UserClaimsAggregateInput>;
	claimsConnection?: InputMaybe<UserClaimsConnectionWhere>;
	claimsConnection_NOT?: InputMaybe<UserClaimsConnectionWhere>;
	claims_NOT?: InputMaybe<ClaimWhere>;
	context?: InputMaybe<UserContextWhere>;
	contextAggregate?: InputMaybe<UserContextAggregateInput>;
	contextConnection?: InputMaybe<UserContextConnectionWhere>;
	contextConnection_NOT?: InputMaybe<UserContextConnectionWhere>;
	context_NOT?: InputMaybe<UserContextWhere>;
	email?: InputMaybe<Scalars["String"]>;
	email_CONTAINS?: InputMaybe<Scalars["String"]>;
	email_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	email_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	email_MATCHES?: InputMaybe<Scalars["String"]>;
	email_NOT?: InputMaybe<Scalars["String"]>;
	email_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	email_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	email_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	email_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	email_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	firstName?: InputMaybe<Scalars["String"]>;
	firstName_CONTAINS?: InputMaybe<Scalars["String"]>;
	firstName_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	firstName_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	firstName_MATCHES?: InputMaybe<Scalars["String"]>;
	firstName_NOT?: InputMaybe<Scalars["String"]>;
	firstName_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	firstName_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	firstName_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	firstName_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	firstName_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	id?: InputMaybe<Scalars["ID"]>;
	id_CONTAINS?: InputMaybe<Scalars["ID"]>;
	id_ENDS_WITH?: InputMaybe<Scalars["ID"]>;
	id_IN?: InputMaybe<Array<InputMaybe<Scalars["ID"]>>>;
	id_MATCHES?: InputMaybe<Scalars["String"]>;
	id_NOT?: InputMaybe<Scalars["ID"]>;
	id_NOT_CONTAINS?: InputMaybe<Scalars["ID"]>;
	id_NOT_ENDS_WITH?: InputMaybe<Scalars["ID"]>;
	id_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["ID"]>>>;
	id_NOT_STARTS_WITH?: InputMaybe<Scalars["ID"]>;
	id_STARTS_WITH?: InputMaybe<Scalars["ID"]>;
	lastName?: InputMaybe<Scalars["String"]>;
	lastName_CONTAINS?: InputMaybe<Scalars["String"]>;
	lastName_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	lastName_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	lastName_MATCHES?: InputMaybe<Scalars["String"]>;
	lastName_NOT?: InputMaybe<Scalars["String"]>;
	lastName_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	lastName_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	lastName_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	lastName_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	lastName_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	mentions?: InputMaybe<MessageWhere>;
	mentionsAggregate?: InputMaybe<UserMentionsAggregateInput>;
	mentionsConnection?: InputMaybe<UserMentionsConnectionWhere>;
	mentionsConnection_NOT?: InputMaybe<UserMentionsConnectionWhere>;
	mentions_NOT?: InputMaybe<MessageWhere>;
	notificationDue?: InputMaybe<NotificationWhere>;
	notificationDueAggregate?: InputMaybe<UserNotificationDueAggregateInput>;
	notificationDueConnection?: InputMaybe<UserNotificationDueConnectionWhere>;
	notificationDueConnection_NOT?: InputMaybe<UserNotificationDueConnectionWhere>;
	notificationDue_NOT?: InputMaybe<NotificationWhere>;
	notified?: InputMaybe<NotificationWhere>;
	notifiedAggregate?: InputMaybe<UserNotifiedAggregateInput>;
	notifiedConnection?: InputMaybe<UserNotifiedConnectionWhere>;
	notifiedConnection_NOT?: InputMaybe<UserNotifiedConnectionWhere>;
	notified_NOT?: InputMaybe<NotificationWhere>;
	patients?: InputMaybe<PatientWhere>;
	patientsAggregate?: InputMaybe<UserPatientsAggregateInput>;
	patientsConnection?: InputMaybe<UserPatientsConnectionWhere>;
	patientsConnection_NOT?: InputMaybe<UserPatientsConnectionWhere>;
	patients_NOT?: InputMaybe<PatientWhere>;
	preferredLanguage?: InputMaybe<Scalars["String"]>;
	preferredLanguage_CONTAINS?: InputMaybe<Scalars["String"]>;
	preferredLanguage_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	preferredLanguage_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	preferredLanguage_MATCHES?: InputMaybe<Scalars["String"]>;
	preferredLanguage_NOT?: InputMaybe<Scalars["String"]>;
	preferredLanguage_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	preferredLanguage_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	preferredLanguage_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	preferredLanguage_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	preferredLanguage_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	reads?: InputMaybe<Array<Scalars["String"]>>;
	reads_INCLUDES?: InputMaybe<Scalars["String"]>;
	reads_NOT?: InputMaybe<Array<Scalars["String"]>>;
	reads_NOT_INCLUDES?: InputMaybe<Scalars["String"]>;
	sentMessage?: InputMaybe<MessageWhere>;
	sentMessageAggregate?: InputMaybe<UserSentMessageAggregateInput>;
	sentMessageConnection?: InputMaybe<UserSentMessageConnectionWhere>;
	sentMessageConnection_NOT?: InputMaybe<UserSentMessageConnectionWhere>;
	sentMessage_NOT?: InputMaybe<MessageWhere>;
	subscribed?: InputMaybe<NotificationWhere>;
	subscribedAggregate?: InputMaybe<UserSubscribedAggregateInput>;
	subscribedConnection?: InputMaybe<UserSubscribedConnectionWhere>;
	subscribedConnection_NOT?: InputMaybe<UserSubscribedConnectionWhere>;
	subscribed_NOT?: InputMaybe<NotificationWhere>;
	tasks?: InputMaybe<TaskWhere>;
	tasksAggregate?: InputMaybe<UserTasksAggregateInput>;
	tasksConnection?: InputMaybe<UserTasksConnectionWhere>;
	tasksConnection_NOT?: InputMaybe<UserTasksConnectionWhere>;
	tasks_NOT?: InputMaybe<TaskWhere>;
	tenantId?: InputMaybe<Scalars["String"]>;
	tenantId_CONTAINS?: InputMaybe<Scalars["String"]>;
	tenantId_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	tenantId_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	tenantId_MATCHES?: InputMaybe<Scalars["String"]>;
	tenantId_NOT?: InputMaybe<Scalars["String"]>;
	tenantId_NOT_CONTAINS?: InputMaybe<Scalars["String"]>;
	tenantId_NOT_ENDS_WITH?: InputMaybe<Scalars["String"]>;
	tenantId_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
	tenantId_NOT_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	tenantId_STARTS_WITH?: InputMaybe<Scalars["String"]>;
	writes?: InputMaybe<Array<Scalars["String"]>>;
	writes_INCLUDES?: InputMaybe<Scalars["String"]>;
	writes_NOT?: InputMaybe<Array<Scalars["String"]>>;
	writes_NOT_INCLUDES?: InputMaybe<Scalars["String"]>;
};

export type WorkflowParticipantDecisionInput = {
	contractAddress: Scalars["String"];
	contractWorkflowStepType: ContractWorkflowStepType;
	contractWorkflows?: InputMaybe<Array<ContractWorkflowInput>>;
	order: Scalars["Int"];
	organizationId: Scalars["String"];
	status?: InputMaybe<ContractWorkflowStatus>;
	userEmail: Scalars["String"];
	workflowType: ContractWorkflowType;
};

export type ResolverTypeWrapper<T> = Promise<T> | T;

export type ResolverWithResolve<TResult, TParent, TContext, TArgs> = {
	resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};
export type Resolver<TResult, TParent = {}, TContext = {}, TArgs = {}> =
	| ResolverFn<TResult, TParent, TContext, TArgs>
	| ResolverWithResolve<TResult, TParent, TContext, TArgs>;

export type ResolverFn<TResult, TParent, TContext, TArgs> = (
	parent: TParent,
	args: TArgs,
	context: TContext,
	info: GraphQLResolveInfo
) => Promise<TResult> | TResult;

export type SubscriptionSubscribeFn<TResult, TParent, TContext, TArgs> = (
	parent: TParent,
	args: TArgs,
	context: TContext,
	info: GraphQLResolveInfo
) => AsyncIterator<TResult> | Promise<AsyncIterator<TResult>>;

export type SubscriptionResolveFn<TResult, TParent, TContext, TArgs> = (
	parent: TParent,
	args: TArgs,
	context: TContext,
	info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

export interface SubscriptionSubscriberObject<TResult, TKey extends string, TParent, TContext, TArgs> {
	subscribe: SubscriptionSubscribeFn<{ [key in TKey]: TResult }, TParent, TContext, TArgs>;
	resolve?: SubscriptionResolveFn<TResult, { [key in TKey]: TResult }, TContext, TArgs>;
}

export interface SubscriptionResolverObject<TResult, TParent, TContext, TArgs> {
	subscribe: SubscriptionSubscribeFn<any, TParent, TContext, TArgs>;
	resolve: SubscriptionResolveFn<TResult, any, TContext, TArgs>;
}

export type SubscriptionObject<TResult, TKey extends string, TParent, TContext, TArgs> =
	| SubscriptionSubscriberObject<TResult, TKey, TParent, TContext, TArgs>
	| SubscriptionResolverObject<TResult, TParent, TContext, TArgs>;

export type SubscriptionResolver<TResult, TKey extends string, TParent = {}, TContext = {}, TArgs = {}> =
	| ((...args: any[]) => SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>)
	| SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>;

export type TypeResolveFn<TTypes, TParent = {}, TContext = {}> = (
	parent: TParent,
	context: TContext,
	info: GraphQLResolveInfo
) => Maybe<TTypes> | Promise<Maybe<TTypes>>;

export type IsTypeOfResolverFn<T = {}, TContext = {}> = (obj: T, context: TContext, info: GraphQLResolveInfo) => boolean | Promise<boolean>;

export type NextResolverFn<T> = () => Promise<T>;

export type DirectiveResolverFn<TResult = {}, TParent = {}, TContext = {}, TArgs = {}> = (
	next: NextResolverFn<TResult>,
	parent: TParent,
	args: TArgs,
	context: TContext,
	info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

/** Mapping between all available schema types and the resolvers types */
export type ResolversTypes = {
	ActionItemCombinationRelation: ActionItemCombinationRelation;
	ActionItemCombinationRule: ActionItemCombinationRule;
	ActionItemRangeType: ActionItemRangeType;
	ActionType: ActionType;
	AdverseEvent: ResolverTypeWrapper<AdverseEvent>;
	AdverseEventAggregateSelection: ResolverTypeWrapper<AdverseEventAggregateSelection>;
	AdverseEventConnectInput: AdverseEventConnectInput;
	AdverseEventConnectWhere: AdverseEventConnectWhere;
	AdverseEventCounterparties: ResolverTypeWrapper<AdverseEventCounterparties>;
	AdverseEventCounterpartiesAggregateSelection: ResolverTypeWrapper<AdverseEventCounterpartiesAggregateSelection>;
	AdverseEventCounterpartiesOptions: AdverseEventCounterpartiesOptions;
	AdverseEventCounterpartiesSort: AdverseEventCounterpartiesSort;
	AdverseEventCounterpartiesWhere: AdverseEventCounterpartiesWhere;
	AdverseEventCreateInput: AdverseEventCreateInput;
	AdverseEventDeleteInput: AdverseEventDeleteInput;
	AdverseEventDisconnectInput: AdverseEventDisconnectInput;
	AdverseEventGrades: AdverseEventGrades;
	AdverseEventInitialResponseAggregateInput: AdverseEventInitialResponseAggregateInput;
	AdverseEventInitialResponseConnectFieldInput: AdverseEventInitialResponseConnectFieldInput;
	AdverseEventInitialResponseConnection: ResolverTypeWrapper<AdverseEventInitialResponseConnection>;
	AdverseEventInitialResponseConnectionSort: AdverseEventInitialResponseConnectionSort;
	AdverseEventInitialResponseConnectionWhere: AdverseEventInitialResponseConnectionWhere;
	AdverseEventInitialResponseCreateFieldInput: AdverseEventInitialResponseCreateFieldInput;
	AdverseEventInitialResponseDeleteFieldInput: AdverseEventInitialResponseDeleteFieldInput;
	AdverseEventInitialResponseDisconnectFieldInput: AdverseEventInitialResponseDisconnectFieldInput;
	AdverseEventInitialResponseFieldInput: AdverseEventInitialResponseFieldInput;
	AdverseEventInitialResponseNodeAggregationWhereInput: AdverseEventInitialResponseNodeAggregationWhereInput;
	AdverseEventInitialResponseRelationship: ResolverTypeWrapper<AdverseEventInitialResponseRelationship>;
	AdverseEventInitialResponseUpdateConnectionInput: AdverseEventInitialResponseUpdateConnectionInput;
	AdverseEventInitialResponseUpdateFieldInput: AdverseEventInitialResponseUpdateFieldInput;
	AdverseEventInput: AdverseEventInput;
	AdverseEventOptions: AdverseEventOptions;
	AdverseEventReport: ResolverTypeWrapper<AdverseEventReport>;
	AdverseEventReportAggregateSelection: ResolverTypeWrapper<AdverseEventReportAggregateSelection>;
	AdverseEventReportOptions: AdverseEventReportOptions;
	AdverseEventReportSort: AdverseEventReportSort;
	AdverseEventReportWhere: AdverseEventReportWhere;
	AdverseEventSort: AdverseEventSort;
	AdverseEventType: AdverseEventType;
	AdverseEventUpdateInput: AdverseEventUpdateInput;
	AdverseEventWhere: AdverseEventWhere;
	AdverseEventsOccurenceReport: ResolverTypeWrapper<AdverseEventsOccurenceReport>;
	AdverseEventsOccurenceReportAggregateSelection: ResolverTypeWrapper<AdverseEventsOccurenceReportAggregateSelection>;
	AdverseEventsOccurenceReportCreateInput: AdverseEventsOccurenceReportCreateInput;
	AdverseEventsOccurenceReportOptions: AdverseEventsOccurenceReportOptions;
	AdverseEventsOccurenceReportSort: AdverseEventsOccurenceReportSort;
	AdverseEventsOccurenceReportUpdateInput: AdverseEventsOccurenceReportUpdateInput;
	AdverseEventsOccurenceReportWhere: AdverseEventsOccurenceReportWhere;
	Agreement: ResolverTypeWrapper<Agreement>;
	AgreementAggregateSelection: ResolverTypeWrapper<AgreementAggregateSelection>;
	AgreementConnectInput: AgreementConnectInput;
	AgreementConnectWhere: AgreementConnectWhere;
	AgreementCounterpartyRolesAggregateInput: AgreementCounterpartyRolesAggregateInput;
	AgreementCounterpartyRolesConnectFieldInput: AgreementCounterpartyRolesConnectFieldInput;
	AgreementCounterpartyRolesConnection: ResolverTypeWrapper<AgreementCounterpartyRolesConnection>;
	AgreementCounterpartyRolesConnectionSort: AgreementCounterpartyRolesConnectionSort;
	AgreementCounterpartyRolesConnectionWhere: AgreementCounterpartyRolesConnectionWhere;
	AgreementCounterpartyRolesCreateFieldInput: AgreementCounterpartyRolesCreateFieldInput;
	AgreementCounterpartyRolesDeleteFieldInput: AgreementCounterpartyRolesDeleteFieldInput;
	AgreementCounterpartyRolesDisconnectFieldInput: AgreementCounterpartyRolesDisconnectFieldInput;
	AgreementCounterpartyRolesFieldInput: AgreementCounterpartyRolesFieldInput;
	AgreementCounterpartyRolesNodeAggregationWhereInput: AgreementCounterpartyRolesNodeAggregationWhereInput;
	AgreementCounterpartyRolesRelationship: ResolverTypeWrapper<AgreementCounterpartyRolesRelationship>;
	AgreementCounterpartyRolesUpdateConnectionInput: AgreementCounterpartyRolesUpdateConnectionInput;
	AgreementCounterpartyRolesUpdateFieldInput: AgreementCounterpartyRolesUpdateFieldInput;
	AgreementCreateInput: AgreementCreateInput;
	AgreementCurrencyAggregateInput: AgreementCurrencyAggregateInput;
	AgreementCurrencyConnectFieldInput: AgreementCurrencyConnectFieldInput;
	AgreementCurrencyConnection: ResolverTypeWrapper<AgreementCurrencyConnection>;
	AgreementCurrencyConnectionSort: AgreementCurrencyConnectionSort;
	AgreementCurrencyConnectionWhere: AgreementCurrencyConnectionWhere;
	AgreementCurrencyCreateFieldInput: AgreementCurrencyCreateFieldInput;
	AgreementCurrencyDeleteFieldInput: AgreementCurrencyDeleteFieldInput;
	AgreementCurrencyDisconnectFieldInput: AgreementCurrencyDisconnectFieldInput;
	AgreementCurrencyFieldInput: AgreementCurrencyFieldInput;
	AgreementCurrencyNodeAggregationWhereInput: AgreementCurrencyNodeAggregationWhereInput;
	AgreementCurrencyRelationship: ResolverTypeWrapper<AgreementCurrencyRelationship>;
	AgreementCurrencyUpdateConnectionInput: AgreementCurrencyUpdateConnectionInput;
	AgreementCurrencyUpdateFieldInput: AgreementCurrencyUpdateFieldInput;
	AgreementDecision: ResolverTypeWrapper<AgreementDecision>;
	AgreementDecisionAggregateSelection: ResolverTypeWrapper<AgreementDecisionAggregateSelection>;
	AgreementDecisionAsOfAggregateInput: AgreementDecisionAsOfAggregateInput;
	AgreementDecisionAsOfConnectFieldInput: AgreementDecisionAsOfConnectFieldInput;
	AgreementDecisionAsOfConnection: ResolverTypeWrapper<AgreementDecisionAsOfConnection>;
	AgreementDecisionAsOfConnectionSort: AgreementDecisionAsOfConnectionSort;
	AgreementDecisionAsOfConnectionWhere: AgreementDecisionAsOfConnectionWhere;
	AgreementDecisionAsOfCreateFieldInput: AgreementDecisionAsOfCreateFieldInput;
	AgreementDecisionAsOfDeleteFieldInput: AgreementDecisionAsOfDeleteFieldInput;
	AgreementDecisionAsOfDisconnectFieldInput: AgreementDecisionAsOfDisconnectFieldInput;
	AgreementDecisionAsOfFieldInput: AgreementDecisionAsOfFieldInput;
	AgreementDecisionAsOfNodeAggregationWhereInput: AgreementDecisionAsOfNodeAggregationWhereInput;
	AgreementDecisionAsOfRelationship: ResolverTypeWrapper<AgreementDecisionAsOfRelationship>;
	AgreementDecisionAsOfUpdateConnectionInput: AgreementDecisionAsOfUpdateConnectionInput;
	AgreementDecisionAsOfUpdateFieldInput: AgreementDecisionAsOfUpdateFieldInput;
	AgreementDecisionConnectInput: AgreementDecisionConnectInput;
	AgreementDecisionConnectWhere: AgreementDecisionConnectWhere;
	AgreementDecisionCreateInput: AgreementDecisionCreateInput;
	AgreementDecisionDeleteInput: AgreementDecisionDeleteInput;
	AgreementDecisionDisconnectInput: AgreementDecisionDisconnectInput;
	AgreementDecisionInput: AgreementDecisionInput;
	AgreementDecisionMadeByAggregateInput: AgreementDecisionMadeByAggregateInput;
	AgreementDecisionMadeByConnectFieldInput: AgreementDecisionMadeByConnectFieldInput;
	AgreementDecisionMadeByConnection: ResolverTypeWrapper<AgreementDecisionMadeByConnection>;
	AgreementDecisionMadeByConnectionSort: AgreementDecisionMadeByConnectionSort;
	AgreementDecisionMadeByConnectionWhere: AgreementDecisionMadeByConnectionWhere;
	AgreementDecisionMadeByCreateFieldInput: AgreementDecisionMadeByCreateFieldInput;
	AgreementDecisionMadeByDeleteFieldInput: AgreementDecisionMadeByDeleteFieldInput;
	AgreementDecisionMadeByDisconnectFieldInput: AgreementDecisionMadeByDisconnectFieldInput;
	AgreementDecisionMadeByFieldInput: AgreementDecisionMadeByFieldInput;
	AgreementDecisionMadeByNodeAggregationWhereInput: AgreementDecisionMadeByNodeAggregationWhereInput;
	AgreementDecisionMadeByRelationship: ResolverTypeWrapper<AgreementDecisionMadeByRelationship>;
	AgreementDecisionMadeByUpdateConnectionInput: AgreementDecisionMadeByUpdateConnectionInput;
	AgreementDecisionMadeByUpdateFieldInput: AgreementDecisionMadeByUpdateFieldInput;
	AgreementDecisionOptions: AgreementDecisionOptions;
	AgreementDecisionSort: AgreementDecisionSort;
	AgreementDecisionUpdateInput: AgreementDecisionUpdateInput;
	AgreementDecisionWhere: AgreementDecisionWhere;
	AgreementDeleteInput: AgreementDeleteInput;
	AgreementDeviceAlternativeSetsAggregateInput: AgreementDeviceAlternativeSetsAggregateInput;
	AgreementDeviceAlternativeSetsConnectFieldInput: AgreementDeviceAlternativeSetsConnectFieldInput;
	AgreementDeviceAlternativeSetsConnection: ResolverTypeWrapper<AgreementDeviceAlternativeSetsConnection>;
	AgreementDeviceAlternativeSetsConnectionSort: AgreementDeviceAlternativeSetsConnectionSort;
	AgreementDeviceAlternativeSetsConnectionWhere: AgreementDeviceAlternativeSetsConnectionWhere;
	AgreementDeviceAlternativeSetsCreateFieldInput: AgreementDeviceAlternativeSetsCreateFieldInput;
	AgreementDeviceAlternativeSetsDeleteFieldInput: AgreementDeviceAlternativeSetsDeleteFieldInput;
	AgreementDeviceAlternativeSetsDisconnectFieldInput: AgreementDeviceAlternativeSetsDisconnectFieldInput;
	AgreementDeviceAlternativeSetsFieldInput: AgreementDeviceAlternativeSetsFieldInput;
	AgreementDeviceAlternativeSetsNodeAggregationWhereInput: AgreementDeviceAlternativeSetsNodeAggregationWhereInput;
	AgreementDeviceAlternativeSetsRelationship: ResolverTypeWrapper<AgreementDeviceAlternativeSetsRelationship>;
	AgreementDeviceAlternativeSetsUpdateConnectionInput: AgreementDeviceAlternativeSetsUpdateConnectionInput;
	AgreementDeviceAlternativeSetsUpdateFieldInput: AgreementDeviceAlternativeSetsUpdateFieldInput;
	AgreementDisconnectInput: AgreementDisconnectInput;
	AgreementFinancialSummaryColumnRelationship: ResolversTypes["BaseAgreementFinancialSummaryConfigRelationship"];
	AgreementFinancialSummaryColumnRelationshipCreateInput: AgreementFinancialSummaryColumnRelationshipCreateInput;
	AgreementFinancialSummaryColumnRelationshipSort: AgreementFinancialSummaryColumnRelationshipSort;
	AgreementFinancialSummaryColumnRelationshipUpdateInput: AgreementFinancialSummaryColumnRelationshipUpdateInput;
	AgreementFinancialSummaryColumnRelationshipWhere: AgreementFinancialSummaryColumnRelationshipWhere;
	AgreementOptions: AgreementOptions;
	AgreementReport: ResolverTypeWrapper<AgreementReport>;
	AgreementReportAggregateSelection: ResolverTypeWrapper<AgreementReportAggregateSelection>;
	AgreementReportOptions: AgreementReportOptions;
	AgreementReportSort: AgreementReportSort;
	AgreementReportWhere: AgreementReportWhere;
	AgreementSort: AgreementSort;
	AgreementSpecificRole: ResolverTypeWrapper<AgreementSpecificRole>;
	AgreementSpecificRoleAggregateSelection: ResolverTypeWrapper<AgreementSpecificRoleAggregateSelection>;
	AgreementSpecificRoleOptions: AgreementSpecificRoleOptions;
	AgreementSpecificRoleSort: AgreementSpecificRoleSort;
	AgreementSpecificRoleWhere: AgreementSpecificRoleWhere;
	AgreementStatusTransition: ResolverTypeWrapper<AgreementStatusTransition>;
	AgreementStatusTransitionAggregateSelection: ResolverTypeWrapper<AgreementStatusTransitionAggregateSelection>;
	AgreementStatusTransitionCausedByAggregateInput: AgreementStatusTransitionCausedByAggregateInput;
	AgreementStatusTransitionCausedByConnectFieldInput: AgreementStatusTransitionCausedByConnectFieldInput;
	AgreementStatusTransitionCausedByConnection: ResolverTypeWrapper<AgreementStatusTransitionCausedByConnection>;
	AgreementStatusTransitionCausedByConnectionSort: AgreementStatusTransitionCausedByConnectionSort;
	AgreementStatusTransitionCausedByConnectionWhere: AgreementStatusTransitionCausedByConnectionWhere;
	AgreementStatusTransitionCausedByCreateFieldInput: AgreementStatusTransitionCausedByCreateFieldInput;
	AgreementStatusTransitionCausedByDeleteFieldInput: AgreementStatusTransitionCausedByDeleteFieldInput;
	AgreementStatusTransitionCausedByDisconnectFieldInput: AgreementStatusTransitionCausedByDisconnectFieldInput;
	AgreementStatusTransitionCausedByFieldInput: AgreementStatusTransitionCausedByFieldInput;
	AgreementStatusTransitionCausedByNodeAggregationWhereInput: AgreementStatusTransitionCausedByNodeAggregationWhereInput;
	AgreementStatusTransitionCausedByRelationship: ResolverTypeWrapper<AgreementStatusTransitionCausedByRelationship>;
	AgreementStatusTransitionCausedByUpdateConnectionInput: AgreementStatusTransitionCausedByUpdateConnectionInput;
	AgreementStatusTransitionCausedByUpdateFieldInput: AgreementStatusTransitionCausedByUpdateFieldInput;
	AgreementStatusTransitionConnectInput: AgreementStatusTransitionConnectInput;
	AgreementStatusTransitionConnectWhere: AgreementStatusTransitionConnectWhere;
	AgreementStatusTransitionCreateInput: AgreementStatusTransitionCreateInput;
	AgreementStatusTransitionDeleteInput: AgreementStatusTransitionDeleteInput;
	AgreementStatusTransitionDisconnectInput: AgreementStatusTransitionDisconnectInput;
	AgreementStatusTransitionOptions: AgreementStatusTransitionOptions;
	AgreementStatusTransitionSort: AgreementStatusTransitionSort;
	AgreementStatusTransitionUpdateInput: AgreementStatusTransitionUpdateInput;
	AgreementStatusTransitionWhere: AgreementStatusTransitionWhere;
	AgreementSubjectMatter: AgreementSubjectMatter;
	AgreementTag: ResolverTypeWrapper<AgreementTag>;
	AgreementTagAggregateSelection: ResolverTypeWrapper<AgreementTagAggregateSelection>;
	AgreementTagConnectInput: AgreementTagConnectInput;
	AgreementTagConnectWhere: AgreementTagConnectWhere;
	AgreementTagCreateInput: AgreementTagCreateInput;
	AgreementTagDefaultUserRolesAggregateInput: AgreementTagDefaultUserRolesAggregateInput;
	AgreementTagDefaultUserRolesConnectFieldInput: AgreementTagDefaultUserRolesConnectFieldInput;
	AgreementTagDefaultUserRolesConnection: ResolverTypeWrapper<AgreementTagDefaultUserRolesConnection>;
	AgreementTagDefaultUserRolesConnectionSort: AgreementTagDefaultUserRolesConnectionSort;
	AgreementTagDefaultUserRolesConnectionWhere: AgreementTagDefaultUserRolesConnectionWhere;
	AgreementTagDefaultUserRolesCreateFieldInput: AgreementTagDefaultUserRolesCreateFieldInput;
	AgreementTagDefaultUserRolesDeleteFieldInput: AgreementTagDefaultUserRolesDeleteFieldInput;
	AgreementTagDefaultUserRolesDisconnectFieldInput: AgreementTagDefaultUserRolesDisconnectFieldInput;
	AgreementTagDefaultUserRolesFieldInput: AgreementTagDefaultUserRolesFieldInput;
	AgreementTagDefaultUserRolesNodeAggregationWhereInput: AgreementTagDefaultUserRolesNodeAggregationWhereInput;
	AgreementTagDefaultUserRolesRelationship: ResolverTypeWrapper<AgreementTagDefaultUserRolesRelationship>;
	AgreementTagDefaultUserRolesUpdateConnectionInput: AgreementTagDefaultUserRolesUpdateConnectionInput;
	AgreementTagDefaultUserRolesUpdateFieldInput: AgreementTagDefaultUserRolesUpdateFieldInput;
	AgreementTagDeleteInput: AgreementTagDeleteInput;
	AgreementTagDisconnectInput: AgreementTagDisconnectInput;
	AgreementTagOptions: AgreementTagOptions;
	AgreementTagSort: AgreementTagSort;
	AgreementTagType: AgreementTagType;
	AgreementTagUpdateInput: AgreementTagUpdateInput;
	AgreementTagUserRoleRelationship: ResolversTypes["AgreementTagDefaultUserRolesRelationship"];
	AgreementTagUserRoleRelationshipCreateInput: AgreementTagUserRoleRelationshipCreateInput;
	AgreementTagUserRoleRelationshipSort: AgreementTagUserRoleRelationshipSort;
	AgreementTagUserRoleRelationshipUpdateInput: AgreementTagUserRoleRelationshipUpdateInput;
	AgreementTagUserRoleRelationshipWhere: AgreementTagUserRoleRelationshipWhere;
	AgreementTagWhere: AgreementTagWhere;
	AgreementTagsAggregateInput: AgreementTagsAggregateInput;
	AgreementTagsConnectFieldInput: AgreementTagsConnectFieldInput;
	AgreementTagsConnection: ResolverTypeWrapper<AgreementTagsConnection>;
	AgreementTagsConnectionSort: AgreementTagsConnectionSort;
	AgreementTagsConnectionWhere: AgreementTagsConnectionWhere;
	AgreementTagsCreateFieldInput: AgreementTagsCreateFieldInput;
	AgreementTagsDeleteFieldInput: AgreementTagsDeleteFieldInput;
	AgreementTagsDisconnectFieldInput: AgreementTagsDisconnectFieldInput;
	AgreementTagsFieldInput: AgreementTagsFieldInput;
	AgreementTagsNodeAggregationWhereInput: AgreementTagsNodeAggregationWhereInput;
	AgreementTagsRelationship: ResolverTypeWrapper<AgreementTagsRelationship>;
	AgreementTagsUpdateConnectionInput: AgreementTagsUpdateConnectionInput;
	AgreementTagsUpdateFieldInput: AgreementTagsUpdateFieldInput;
	AgreementUpdateInput: AgreementUpdateInput;
	AgreementUserRole: AgreementUserRole;
	AgreementUserRoleRelationship: ResolversTypes["AgreementUserRolesRelationship"];
	AgreementUserRoleRelationshipCreateInput: AgreementUserRoleRelationshipCreateInput;
	AgreementUserRoleRelationshipSort: AgreementUserRoleRelationshipSort;
	AgreementUserRoleRelationshipUpdateInput: AgreementUserRoleRelationshipUpdateInput;
	AgreementUserRoleRelationshipWhere: AgreementUserRoleRelationshipWhere;
	AgreementUserRolesAggregateInput: AgreementUserRolesAggregateInput;
	AgreementUserRolesConnectFieldInput: AgreementUserRolesConnectFieldInput;
	AgreementUserRolesConnection: ResolverTypeWrapper<AgreementUserRolesConnection>;
	AgreementUserRolesConnectionSort: AgreementUserRolesConnectionSort;
	AgreementUserRolesConnectionWhere: AgreementUserRolesConnectionWhere;
	AgreementUserRolesCreateFieldInput: AgreementUserRolesCreateFieldInput;
	AgreementUserRolesDeleteFieldInput: AgreementUserRolesDeleteFieldInput;
	AgreementUserRolesDisconnectFieldInput: AgreementUserRolesDisconnectFieldInput;
	AgreementUserRolesFieldInput: AgreementUserRolesFieldInput;
	AgreementUserRolesNodeAggregationWhereInput: AgreementUserRolesNodeAggregationWhereInput;
	AgreementUserRolesRelationship: ResolverTypeWrapper<AgreementUserRolesRelationship>;
	AgreementUserRolesUpdateConnectionInput: AgreementUserRolesUpdateConnectionInput;
	AgreementUserRolesUpdateFieldInput: AgreementUserRolesUpdateFieldInput;
	AgreementWhere: AgreementWhere;
	AgreementWorkflowsAggregateInput: AgreementWorkflowsAggregateInput;
	AgreementWorkflowsConnectFieldInput: AgreementWorkflowsConnectFieldInput;
	AgreementWorkflowsConnection: ResolverTypeWrapper<AgreementWorkflowsConnection>;
	AgreementWorkflowsConnectionSort: AgreementWorkflowsConnectionSort;
	AgreementWorkflowsConnectionWhere: AgreementWorkflowsConnectionWhere;
	AgreementWorkflowsCreateFieldInput: AgreementWorkflowsCreateFieldInput;
	AgreementWorkflowsDeleteFieldInput: AgreementWorkflowsDeleteFieldInput;
	AgreementWorkflowsDisconnectFieldInput: AgreementWorkflowsDisconnectFieldInput;
	AgreementWorkflowsFieldInput: AgreementWorkflowsFieldInput;
	AgreementWorkflowsRelationship: ResolverTypeWrapper<AgreementWorkflowsRelationship>;
	AgreementWorkflowsUpdateConnectionInput: AgreementWorkflowsUpdateConnectionInput;
	AgreementWorkflowsUpdateFieldInput: AgreementWorkflowsUpdateFieldInput;
	ArithmeticalOperator: ArithmeticalOperator;
	AssignInvoiceToUserInput: AssignInvoiceToUserInput;
	AssigneeInput: AssigneeInput;
	AverageLAPressureAndLAVolumeRow: ResolverTypeWrapper<AverageLaPressureAndLaVolumeRow>;
	AverageLAPressureAndLAVolumeRowAggregateSelection: ResolverTypeWrapper<AverageLaPressureAndLaVolumeRowAggregateSelection>;
	AverageLAPressureAndLAVolumeRowOptions: AverageLaPressureAndLaVolumeRowOptions;
	AverageLAPressureAndLAVolumeRowSort: AverageLaPressureAndLaVolumeRowSort;
	AverageLAPressureAndLAVolumeRowWhere: AverageLaPressureAndLaVolumeRowWhere;
	BaseAgreement: ResolverTypeWrapper<BaseAgreement>;
	BaseAgreementAddedByAggregateInput: BaseAgreementAddedByAggregateInput;
	BaseAgreementAddedByConnectFieldInput: BaseAgreementAddedByConnectFieldInput;
	BaseAgreementAddedByConnection: ResolverTypeWrapper<BaseAgreementAddedByConnection>;
	BaseAgreementAddedByConnectionSort: BaseAgreementAddedByConnectionSort;
	BaseAgreementAddedByConnectionWhere: BaseAgreementAddedByConnectionWhere;
	BaseAgreementAddedByCreateFieldInput: BaseAgreementAddedByCreateFieldInput;
	BaseAgreementAddedByDeleteFieldInput: BaseAgreementAddedByDeleteFieldInput;
	BaseAgreementAddedByDisconnectFieldInput: BaseAgreementAddedByDisconnectFieldInput;
	BaseAgreementAddedByFieldInput: BaseAgreementAddedByFieldInput;
	BaseAgreementAddedByNodeAggregationWhereInput: BaseAgreementAddedByNodeAggregationWhereInput;
	BaseAgreementAddedByRelationship: ResolverTypeWrapper<BaseAgreementAddedByRelationship>;
	BaseAgreementAddedByUpdateConnectionInput: BaseAgreementAddedByUpdateConnectionInput;
	BaseAgreementAddedByUpdateFieldInput: BaseAgreementAddedByUpdateFieldInput;
	BaseAgreementAggregateSelection: ResolverTypeWrapper<BaseAgreementAggregateSelection>;
	BaseAgreementCategoriesAggregateInput: BaseAgreementCategoriesAggregateInput;
	BaseAgreementCategoriesConnectFieldInput: BaseAgreementCategoriesConnectFieldInput;
	BaseAgreementCategoriesConnection: ResolverTypeWrapper<BaseAgreementCategoriesConnection>;
	BaseAgreementCategoriesConnectionSort: BaseAgreementCategoriesConnectionSort;
	BaseAgreementCategoriesConnectionWhere: BaseAgreementCategoriesConnectionWhere;
	BaseAgreementCategoriesCreateFieldInput: BaseAgreementCategoriesCreateFieldInput;
	BaseAgreementCategoriesDeleteFieldInput: BaseAgreementCategoriesDeleteFieldInput;
	BaseAgreementCategoriesDisconnectFieldInput: BaseAgreementCategoriesDisconnectFieldInput;
	BaseAgreementCategoriesFieldInput: BaseAgreementCategoriesFieldInput;
	BaseAgreementCategoriesNodeAggregationWhereInput: BaseAgreementCategoriesNodeAggregationWhereInput;
	BaseAgreementCategoriesRelationship: ResolverTypeWrapper<BaseAgreementCategoriesRelationship>;
	BaseAgreementCategoriesUpdateConnectionInput: BaseAgreementCategoriesUpdateConnectionInput;
	BaseAgreementCategoriesUpdateFieldInput: BaseAgreementCategoriesUpdateFieldInput;
	BaseAgreementCategoryDiscountCaps: ResolversTypes["BaseAgreementDiscountCapsCategoriesRelationship"];
	BaseAgreementCategoryDiscountCapsCreateInput: BaseAgreementCategoryDiscountCapsCreateInput;
	BaseAgreementCategoryDiscountCapsSort: BaseAgreementCategoryDiscountCapsSort;
	BaseAgreementCategoryDiscountCapsUpdateInput: BaseAgreementCategoryDiscountCapsUpdateInput;
	BaseAgreementCategoryDiscountCapsWhere: BaseAgreementCategoryDiscountCapsWhere;
	BaseAgreementConnectInput: BaseAgreementConnectInput;
	BaseAgreementConnectWhere: BaseAgreementConnectWhere;
	BaseAgreementCounterpartiesAggregateInput: BaseAgreementCounterpartiesAggregateInput;
	BaseAgreementCounterpartiesConnectFieldInput: BaseAgreementCounterpartiesConnectFieldInput;
	BaseAgreementCounterpartiesConnection: ResolverTypeWrapper<BaseAgreementCounterpartiesConnection>;
	BaseAgreementCounterpartiesConnectionSort: BaseAgreementCounterpartiesConnectionSort;
	BaseAgreementCounterpartiesConnectionWhere: BaseAgreementCounterpartiesConnectionWhere;
	BaseAgreementCounterpartiesCreateFieldInput: BaseAgreementCounterpartiesCreateFieldInput;
	BaseAgreementCounterpartiesDeleteFieldInput: BaseAgreementCounterpartiesDeleteFieldInput;
	BaseAgreementCounterpartiesDisconnectFieldInput: BaseAgreementCounterpartiesDisconnectFieldInput;
	BaseAgreementCounterpartiesFieldInput: BaseAgreementCounterpartiesFieldInput;
	BaseAgreementCounterpartiesNodeAggregationWhereInput: BaseAgreementCounterpartiesNodeAggregationWhereInput;
	BaseAgreementCounterpartiesRelationship: ResolverTypeWrapper<BaseAgreementCounterpartiesRelationship>;
	BaseAgreementCounterpartiesUpdateConnectionInput: BaseAgreementCounterpartiesUpdateConnectionInput;
	BaseAgreementCounterpartiesUpdateFieldInput: BaseAgreementCounterpartiesUpdateFieldInput;
	BaseAgreementCounterpartyRelationship: ResolversTypes["BaseAgreementCounterpartiesRelationship"];
	BaseAgreementCounterpartyRelationshipCreateInput: BaseAgreementCounterpartyRelationshipCreateInput;
	BaseAgreementCounterpartyRelationshipSort: BaseAgreementCounterpartyRelationshipSort;
	BaseAgreementCounterpartyRelationshipUpdateInput: BaseAgreementCounterpartyRelationshipUpdateInput;
	BaseAgreementCounterpartyRelationshipWhere: BaseAgreementCounterpartyRelationshipWhere;
	BaseAgreementCreateInput: BaseAgreementCreateInput;
	BaseAgreementCurrencyAggregateInput: BaseAgreementCurrencyAggregateInput;
	BaseAgreementCurrencyConnectFieldInput: BaseAgreementCurrencyConnectFieldInput;
	BaseAgreementCurrencyConnection: ResolverTypeWrapper<BaseAgreementCurrencyConnection>;
	BaseAgreementCurrencyConnectionSort: BaseAgreementCurrencyConnectionSort;
	BaseAgreementCurrencyConnectionWhere: BaseAgreementCurrencyConnectionWhere;
	BaseAgreementCurrencyCreateFieldInput: BaseAgreementCurrencyCreateFieldInput;
	BaseAgreementCurrencyDeleteFieldInput: BaseAgreementCurrencyDeleteFieldInput;
	BaseAgreementCurrencyDisconnectFieldInput: BaseAgreementCurrencyDisconnectFieldInput;
	BaseAgreementCurrencyFieldInput: BaseAgreementCurrencyFieldInput;
	BaseAgreementCurrencyNodeAggregationWhereInput: BaseAgreementCurrencyNodeAggregationWhereInput;
	BaseAgreementCurrencyRelationship: ResolverTypeWrapper<BaseAgreementCurrencyRelationship>;
	BaseAgreementCurrencyUpdateConnectionInput: BaseAgreementCurrencyUpdateConnectionInput;
	BaseAgreementCurrencyUpdateFieldInput: BaseAgreementCurrencyUpdateFieldInput;
	BaseAgreementDataContainersAggregateInput: BaseAgreementDataContainersAggregateInput;
	BaseAgreementDataContainersConnectFieldInput: BaseAgreementDataContainersConnectFieldInput;
	BaseAgreementDataContainersConnection: ResolverTypeWrapper<BaseAgreementDataContainersConnection>;
	BaseAgreementDataContainersConnectionSort: BaseAgreementDataContainersConnectionSort;
	BaseAgreementDataContainersConnectionWhere: BaseAgreementDataContainersConnectionWhere;
	BaseAgreementDataContainersCreateFieldInput: BaseAgreementDataContainersCreateFieldInput;
	BaseAgreementDataContainersDeleteFieldInput: BaseAgreementDataContainersDeleteFieldInput;
	BaseAgreementDataContainersDisconnectFieldInput: BaseAgreementDataContainersDisconnectFieldInput;
	BaseAgreementDataContainersFieldInput: BaseAgreementDataContainersFieldInput;
	BaseAgreementDataContainersNodeAggregationWhereInput: BaseAgreementDataContainersNodeAggregationWhereInput;
	BaseAgreementDataContainersRelationship: ResolverTypeWrapper<BaseAgreementDataContainersRelationship>;
	BaseAgreementDataContainersUpdateConnectionInput: BaseAgreementDataContainersUpdateConnectionInput;
	BaseAgreementDataContainersUpdateFieldInput: BaseAgreementDataContainersUpdateFieldInput;
	BaseAgreementDataSourceAggregateInput: BaseAgreementDataSourceAggregateInput;
	BaseAgreementDataSourceConnectFieldInput: BaseAgreementDataSourceConnectFieldInput;
	BaseAgreementDataSourceConnection: ResolverTypeWrapper<BaseAgreementDataSourceConnection>;
	BaseAgreementDataSourceConnectionSort: BaseAgreementDataSourceConnectionSort;
	BaseAgreementDataSourceConnectionWhere: BaseAgreementDataSourceConnectionWhere;
	BaseAgreementDataSourceCreateFieldInput: BaseAgreementDataSourceCreateFieldInput;
	BaseAgreementDataSourceDeleteFieldInput: BaseAgreementDataSourceDeleteFieldInput;
	BaseAgreementDataSourceDisconnectFieldInput: BaseAgreementDataSourceDisconnectFieldInput;
	BaseAgreementDataSourceFieldInput: BaseAgreementDataSourceFieldInput;
	BaseAgreementDataSourceNodeAggregationWhereInput: BaseAgreementDataSourceNodeAggregationWhereInput;
	BaseAgreementDataSourceRelationship: ResolverTypeWrapper<BaseAgreementDataSourceRelationship>;
	BaseAgreementDataSourceUpdateConnectionInput: BaseAgreementDataSourceUpdateConnectionInput;
	BaseAgreementDataSourceUpdateFieldInput: BaseAgreementDataSourceUpdateFieldInput;
	BaseAgreementDecisionsAggregateInput: BaseAgreementDecisionsAggregateInput;
	BaseAgreementDecisionsConnectFieldInput: BaseAgreementDecisionsConnectFieldInput;
	BaseAgreementDecisionsConnection: ResolverTypeWrapper<BaseAgreementDecisionsConnection>;
	BaseAgreementDecisionsConnectionSort: BaseAgreementDecisionsConnectionSort;
	BaseAgreementDecisionsConnectionWhere: BaseAgreementDecisionsConnectionWhere;
	BaseAgreementDecisionsCreateFieldInput: BaseAgreementDecisionsCreateFieldInput;
	BaseAgreementDecisionsDeleteFieldInput: BaseAgreementDecisionsDeleteFieldInput;
	BaseAgreementDecisionsDisconnectFieldInput: BaseAgreementDecisionsDisconnectFieldInput;
	BaseAgreementDecisionsFieldInput: BaseAgreementDecisionsFieldInput;
	BaseAgreementDecisionsNodeAggregationWhereInput: BaseAgreementDecisionsNodeAggregationWhereInput;
	BaseAgreementDecisionsRelationship: ResolverTypeWrapper<BaseAgreementDecisionsRelationship>;
	BaseAgreementDecisionsUpdateConnectionInput: BaseAgreementDecisionsUpdateConnectionInput;
	BaseAgreementDecisionsUpdateFieldInput: BaseAgreementDecisionsUpdateFieldInput;
	BaseAgreementDeleteInput: BaseAgreementDeleteInput;
	BaseAgreementDeviceAlternativeSetsAggregateInput: BaseAgreementDeviceAlternativeSetsAggregateInput;
	BaseAgreementDeviceAlternativeSetsConnectFieldInput: BaseAgreementDeviceAlternativeSetsConnectFieldInput;
	BaseAgreementDeviceAlternativeSetsConnection: ResolverTypeWrapper<BaseAgreementDeviceAlternativeSetsConnection>;
	BaseAgreementDeviceAlternativeSetsConnectionSort: BaseAgreementDeviceAlternativeSetsConnectionSort;
	BaseAgreementDeviceAlternativeSetsConnectionWhere: BaseAgreementDeviceAlternativeSetsConnectionWhere;
	BaseAgreementDeviceAlternativeSetsCreateFieldInput: BaseAgreementDeviceAlternativeSetsCreateFieldInput;
	BaseAgreementDeviceAlternativeSetsDeleteFieldInput: BaseAgreementDeviceAlternativeSetsDeleteFieldInput;
	BaseAgreementDeviceAlternativeSetsDisconnectFieldInput: BaseAgreementDeviceAlternativeSetsDisconnectFieldInput;
	BaseAgreementDeviceAlternativeSetsFieldInput: BaseAgreementDeviceAlternativeSetsFieldInput;
	BaseAgreementDeviceAlternativeSetsNodeAggregationWhereInput: BaseAgreementDeviceAlternativeSetsNodeAggregationWhereInput;
	BaseAgreementDeviceAlternativeSetsRelationship: ResolverTypeWrapper<BaseAgreementDeviceAlternativeSetsRelationship>;
	BaseAgreementDeviceAlternativeSetsUpdateConnectionInput: BaseAgreementDeviceAlternativeSetsUpdateConnectionInput;
	BaseAgreementDeviceAlternativeSetsUpdateFieldInput: BaseAgreementDeviceAlternativeSetsUpdateFieldInput;
	BaseAgreementDeviceKitDiscountCaps: ResolversTypes["BaseAgreementDiscountCapsDeviceKitsRelationship"];
	BaseAgreementDeviceKitDiscountCapsCreateInput: BaseAgreementDeviceKitDiscountCapsCreateInput;
	BaseAgreementDeviceKitDiscountCapsSort: BaseAgreementDeviceKitDiscountCapsSort;
	BaseAgreementDeviceKitDiscountCapsUpdateInput: BaseAgreementDeviceKitDiscountCapsUpdateInput;
	BaseAgreementDeviceKitDiscountCapsWhere: BaseAgreementDeviceKitDiscountCapsWhere;
	BaseAgreementDisconnectInput: BaseAgreementDisconnectInput;
	BaseAgreementDiscountCapsCategoriesAggregateInput: BaseAgreementDiscountCapsCategoriesAggregateInput;
	BaseAgreementDiscountCapsCategoriesConnectFieldInput: BaseAgreementDiscountCapsCategoriesConnectFieldInput;
	BaseAgreementDiscountCapsCategoriesConnection: ResolverTypeWrapper<BaseAgreementDiscountCapsCategoriesConnection>;
	BaseAgreementDiscountCapsCategoriesConnectionSort: BaseAgreementDiscountCapsCategoriesConnectionSort;
	BaseAgreementDiscountCapsCategoriesConnectionWhere: BaseAgreementDiscountCapsCategoriesConnectionWhere;
	BaseAgreementDiscountCapsCategoriesCreateFieldInput: BaseAgreementDiscountCapsCategoriesCreateFieldInput;
	BaseAgreementDiscountCapsCategoriesDeleteFieldInput: BaseAgreementDiscountCapsCategoriesDeleteFieldInput;
	BaseAgreementDiscountCapsCategoriesDisconnectFieldInput: BaseAgreementDiscountCapsCategoriesDisconnectFieldInput;
	BaseAgreementDiscountCapsCategoriesEdgeAggregationWhereInput: BaseAgreementDiscountCapsCategoriesEdgeAggregationWhereInput;
	BaseAgreementDiscountCapsCategoriesFieldInput: BaseAgreementDiscountCapsCategoriesFieldInput;
	BaseAgreementDiscountCapsCategoriesNodeAggregationWhereInput: BaseAgreementDiscountCapsCategoriesNodeAggregationWhereInput;
	BaseAgreementDiscountCapsCategoriesRelationship: ResolverTypeWrapper<BaseAgreementDiscountCapsCategoriesRelationship>;
	BaseAgreementDiscountCapsCategoriesUpdateConnectionInput: BaseAgreementDiscountCapsCategoriesUpdateConnectionInput;
	BaseAgreementDiscountCapsCategoriesUpdateFieldInput: BaseAgreementDiscountCapsCategoriesUpdateFieldInput;
	BaseAgreementDiscountCapsDeviceKitsAggregateInput: BaseAgreementDiscountCapsDeviceKitsAggregateInput;
	BaseAgreementDiscountCapsDeviceKitsConnectFieldInput: BaseAgreementDiscountCapsDeviceKitsConnectFieldInput;
	BaseAgreementDiscountCapsDeviceKitsConnection: ResolverTypeWrapper<BaseAgreementDiscountCapsDeviceKitsConnection>;
	BaseAgreementDiscountCapsDeviceKitsConnectionSort: BaseAgreementDiscountCapsDeviceKitsConnectionSort;
	BaseAgreementDiscountCapsDeviceKitsConnectionWhere: BaseAgreementDiscountCapsDeviceKitsConnectionWhere;
	BaseAgreementDiscountCapsDeviceKitsCreateFieldInput: BaseAgreementDiscountCapsDeviceKitsCreateFieldInput;
	BaseAgreementDiscountCapsDeviceKitsDeleteFieldInput: BaseAgreementDiscountCapsDeviceKitsDeleteFieldInput;
	BaseAgreementDiscountCapsDeviceKitsDisconnectFieldInput: BaseAgreementDiscountCapsDeviceKitsDisconnectFieldInput;
	BaseAgreementDiscountCapsDeviceKitsEdgeAggregationWhereInput: BaseAgreementDiscountCapsDeviceKitsEdgeAggregationWhereInput;
	BaseAgreementDiscountCapsDeviceKitsFieldInput: BaseAgreementDiscountCapsDeviceKitsFieldInput;
	BaseAgreementDiscountCapsDeviceKitsNodeAggregationWhereInput: BaseAgreementDiscountCapsDeviceKitsNodeAggregationWhereInput;
	BaseAgreementDiscountCapsDeviceKitsRelationship: ResolverTypeWrapper<BaseAgreementDiscountCapsDeviceKitsRelationship>;
	BaseAgreementDiscountCapsDeviceKitsUpdateConnectionInput: BaseAgreementDiscountCapsDeviceKitsUpdateConnectionInput;
	BaseAgreementDiscountCapsDeviceKitsUpdateFieldInput: BaseAgreementDiscountCapsDeviceKitsUpdateFieldInput;
	BaseAgreementEligibilityConditionRelationship: ResolversTypes["BaseAgreementEligibilityConditionSetsRelationship"];
	BaseAgreementEligibilityConditionRelationshipCreateInput: BaseAgreementEligibilityConditionRelationshipCreateInput;
	BaseAgreementEligibilityConditionRelationshipSort: BaseAgreementEligibilityConditionRelationshipSort;
	BaseAgreementEligibilityConditionRelationshipUpdateInput: BaseAgreementEligibilityConditionRelationshipUpdateInput;
	BaseAgreementEligibilityConditionRelationshipWhere: BaseAgreementEligibilityConditionRelationshipWhere;
	BaseAgreementEligibilityConditionSetsAggregateInput: BaseAgreementEligibilityConditionSetsAggregateInput;
	BaseAgreementEligibilityConditionSetsConnectFieldInput: BaseAgreementEligibilityConditionSetsConnectFieldInput;
	BaseAgreementEligibilityConditionSetsConnection: ResolverTypeWrapper<BaseAgreementEligibilityConditionSetsConnection>;
	BaseAgreementEligibilityConditionSetsConnectionSort: BaseAgreementEligibilityConditionSetsConnectionSort;
	BaseAgreementEligibilityConditionSetsConnectionWhere: BaseAgreementEligibilityConditionSetsConnectionWhere;
	BaseAgreementEligibilityConditionSetsCreateFieldInput: BaseAgreementEligibilityConditionSetsCreateFieldInput;
	BaseAgreementEligibilityConditionSetsDeleteFieldInput: BaseAgreementEligibilityConditionSetsDeleteFieldInput;
	BaseAgreementEligibilityConditionSetsDisconnectFieldInput: BaseAgreementEligibilityConditionSetsDisconnectFieldInput;
	BaseAgreementEligibilityConditionSetsEdgeAggregationWhereInput: BaseAgreementEligibilityConditionSetsEdgeAggregationWhereInput;
	BaseAgreementEligibilityConditionSetsFieldInput: BaseAgreementEligibilityConditionSetsFieldInput;
	BaseAgreementEligibilityConditionSetsNodeAggregationWhereInput: BaseAgreementEligibilityConditionSetsNodeAggregationWhereInput;
	BaseAgreementEligibilityConditionSetsRelationship: ResolverTypeWrapper<BaseAgreementEligibilityConditionSetsRelationship>;
	BaseAgreementEligibilityConditionSetsUpdateConnectionInput: BaseAgreementEligibilityConditionSetsUpdateConnectionInput;
	BaseAgreementEligibilityConditionSetsUpdateFieldInput: BaseAgreementEligibilityConditionSetsUpdateFieldInput;
	BaseAgreementEnrollingConditionSetsAggregateInput: BaseAgreementEnrollingConditionSetsAggregateInput;
	BaseAgreementEnrollingConditionSetsConnectFieldInput: BaseAgreementEnrollingConditionSetsConnectFieldInput;
	BaseAgreementEnrollingConditionSetsConnection: ResolverTypeWrapper<BaseAgreementEnrollingConditionSetsConnection>;
	BaseAgreementEnrollingConditionSetsConnectionSort: BaseAgreementEnrollingConditionSetsConnectionSort;
	BaseAgreementEnrollingConditionSetsConnectionWhere: BaseAgreementEnrollingConditionSetsConnectionWhere;
	BaseAgreementEnrollingConditionSetsCreateFieldInput: BaseAgreementEnrollingConditionSetsCreateFieldInput;
	BaseAgreementEnrollingConditionSetsDeleteFieldInput: BaseAgreementEnrollingConditionSetsDeleteFieldInput;
	BaseAgreementEnrollingConditionSetsDisconnectFieldInput: BaseAgreementEnrollingConditionSetsDisconnectFieldInput;
	BaseAgreementEnrollingConditionSetsFieldInput: BaseAgreementEnrollingConditionSetsFieldInput;
	BaseAgreementEnrollingConditionSetsNodeAggregationWhereInput: BaseAgreementEnrollingConditionSetsNodeAggregationWhereInput;
	BaseAgreementEnrollingConditionSetsRelationship: ResolverTypeWrapper<BaseAgreementEnrollingConditionSetsRelationship>;
	BaseAgreementEnrollingConditionSetsUpdateConnectionInput: BaseAgreementEnrollingConditionSetsUpdateConnectionInput;
	BaseAgreementEnrollingConditionSetsUpdateFieldInput: BaseAgreementEnrollingConditionSetsUpdateFieldInput;
	BaseAgreementEnrollingPeriodsAggregateInput: BaseAgreementEnrollingPeriodsAggregateInput;
	BaseAgreementEnrollingPeriodsConnectFieldInput: BaseAgreementEnrollingPeriodsConnectFieldInput;
	BaseAgreementEnrollingPeriodsConnection: ResolverTypeWrapper<BaseAgreementEnrollingPeriodsConnection>;
	BaseAgreementEnrollingPeriodsConnectionSort: BaseAgreementEnrollingPeriodsConnectionSort;
	BaseAgreementEnrollingPeriodsConnectionWhere: BaseAgreementEnrollingPeriodsConnectionWhere;
	BaseAgreementEnrollingPeriodsCreateFieldInput: BaseAgreementEnrollingPeriodsCreateFieldInput;
	BaseAgreementEnrollingPeriodsDeleteFieldInput: BaseAgreementEnrollingPeriodsDeleteFieldInput;
	BaseAgreementEnrollingPeriodsDisconnectFieldInput: BaseAgreementEnrollingPeriodsDisconnectFieldInput;
	BaseAgreementEnrollingPeriodsFieldInput: BaseAgreementEnrollingPeriodsFieldInput;
	BaseAgreementEnrollingPeriodsRelationship: ResolverTypeWrapper<BaseAgreementEnrollingPeriodsRelationship>;
	BaseAgreementEnrollingPeriodsUpdateConnectionInput: BaseAgreementEnrollingPeriodsUpdateConnectionInput;
	BaseAgreementEnrollingPeriodsUpdateFieldInput: BaseAgreementEnrollingPeriodsUpdateFieldInput;
	BaseAgreementFinancialSummaryConfigAggregateInput: BaseAgreementFinancialSummaryConfigAggregateInput;
	BaseAgreementFinancialSummaryConfigConnectFieldInput: BaseAgreementFinancialSummaryConfigConnectFieldInput;
	BaseAgreementFinancialSummaryConfigConnection: ResolverTypeWrapper<BaseAgreementFinancialSummaryConfigConnection>;
	BaseAgreementFinancialSummaryConfigConnectionSort: BaseAgreementFinancialSummaryConfigConnectionSort;
	BaseAgreementFinancialSummaryConfigConnectionWhere: BaseAgreementFinancialSummaryConfigConnectionWhere;
	BaseAgreementFinancialSummaryConfigCreateFieldInput: BaseAgreementFinancialSummaryConfigCreateFieldInput;
	BaseAgreementFinancialSummaryConfigDeleteFieldInput: BaseAgreementFinancialSummaryConfigDeleteFieldInput;
	BaseAgreementFinancialSummaryConfigDisconnectFieldInput: BaseAgreementFinancialSummaryConfigDisconnectFieldInput;
	BaseAgreementFinancialSummaryConfigEdgeAggregationWhereInput: BaseAgreementFinancialSummaryConfigEdgeAggregationWhereInput;
	BaseAgreementFinancialSummaryConfigFieldInput: BaseAgreementFinancialSummaryConfigFieldInput;
	BaseAgreementFinancialSummaryConfigNodeAggregationWhereInput: BaseAgreementFinancialSummaryConfigNodeAggregationWhereInput;
	BaseAgreementFinancialSummaryConfigRelationship: ResolverTypeWrapper<BaseAgreementFinancialSummaryConfigRelationship>;
	BaseAgreementFinancialSummaryConfigUpdateConnectionInput: BaseAgreementFinancialSummaryConfigUpdateConnectionInput;
	BaseAgreementFinancialSummaryConfigUpdateFieldInput: BaseAgreementFinancialSummaryConfigUpdateFieldInput;
	BaseAgreementInitialVersionAggregateInput: BaseAgreementInitialVersionAggregateInput;
	BaseAgreementInitialVersionConnectFieldInput: BaseAgreementInitialVersionConnectFieldInput;
	BaseAgreementInitialVersionConnection: ResolverTypeWrapper<BaseAgreementInitialVersionConnection>;
	BaseAgreementInitialVersionConnectionSort: BaseAgreementInitialVersionConnectionSort;
	BaseAgreementInitialVersionConnectionWhere: BaseAgreementInitialVersionConnectionWhere;
	BaseAgreementInitialVersionCreateFieldInput: BaseAgreementInitialVersionCreateFieldInput;
	BaseAgreementInitialVersionDeleteFieldInput: BaseAgreementInitialVersionDeleteFieldInput;
	BaseAgreementInitialVersionDisconnectFieldInput: BaseAgreementInitialVersionDisconnectFieldInput;
	BaseAgreementInitialVersionFieldInput: BaseAgreementInitialVersionFieldInput;
	BaseAgreementInitialVersionNodeAggregationWhereInput: BaseAgreementInitialVersionNodeAggregationWhereInput;
	BaseAgreementInitialVersionRelationship: ResolverTypeWrapper<BaseAgreementInitialVersionRelationship>;
	BaseAgreementInitialVersionUpdateConnectionInput: BaseAgreementInitialVersionUpdateConnectionInput;
	BaseAgreementInitialVersionUpdateFieldInput: BaseAgreementInitialVersionUpdateFieldInput;
	BaseAgreementNamedTimeRangesAggregateInput: BaseAgreementNamedTimeRangesAggregateInput;
	BaseAgreementNamedTimeRangesConnectFieldInput: BaseAgreementNamedTimeRangesConnectFieldInput;
	BaseAgreementNamedTimeRangesConnection: ResolverTypeWrapper<BaseAgreementNamedTimeRangesConnection>;
	BaseAgreementNamedTimeRangesConnectionSort: BaseAgreementNamedTimeRangesConnectionSort;
	BaseAgreementNamedTimeRangesConnectionWhere: BaseAgreementNamedTimeRangesConnectionWhere;
	BaseAgreementNamedTimeRangesCreateFieldInput: BaseAgreementNamedTimeRangesCreateFieldInput;
	BaseAgreementNamedTimeRangesDeleteFieldInput: BaseAgreementNamedTimeRangesDeleteFieldInput;
	BaseAgreementNamedTimeRangesDisconnectFieldInput: BaseAgreementNamedTimeRangesDisconnectFieldInput;
	BaseAgreementNamedTimeRangesFieldInput: BaseAgreementNamedTimeRangesFieldInput;
	BaseAgreementNamedTimeRangesNodeAggregationWhereInput: BaseAgreementNamedTimeRangesNodeAggregationWhereInput;
	BaseAgreementNamedTimeRangesRelationship: ResolverTypeWrapper<BaseAgreementNamedTimeRangesRelationship>;
	BaseAgreementNamedTimeRangesUpdateConnectionInput: BaseAgreementNamedTimeRangesUpdateConnectionInput;
	BaseAgreementNamedTimeRangesUpdateFieldInput: BaseAgreementNamedTimeRangesUpdateFieldInput;
	BaseAgreementNextVersionsAggregateInput: BaseAgreementNextVersionsAggregateInput;
	BaseAgreementNextVersionsConnectFieldInput: BaseAgreementNextVersionsConnectFieldInput;
	BaseAgreementNextVersionsConnection: ResolverTypeWrapper<BaseAgreementNextVersionsConnection>;
	BaseAgreementNextVersionsConnectionSort: BaseAgreementNextVersionsConnectionSort;
	BaseAgreementNextVersionsConnectionWhere: BaseAgreementNextVersionsConnectionWhere;
	BaseAgreementNextVersionsCreateFieldInput: BaseAgreementNextVersionsCreateFieldInput;
	BaseAgreementNextVersionsDeleteFieldInput: BaseAgreementNextVersionsDeleteFieldInput;
	BaseAgreementNextVersionsDisconnectFieldInput: BaseAgreementNextVersionsDisconnectFieldInput;
	BaseAgreementNextVersionsFieldInput: BaseAgreementNextVersionsFieldInput;
	BaseAgreementNextVersionsNodeAggregationWhereInput: BaseAgreementNextVersionsNodeAggregationWhereInput;
	BaseAgreementNextVersionsRelationship: ResolverTypeWrapper<BaseAgreementNextVersionsRelationship>;
	BaseAgreementNextVersionsUpdateConnectionInput: BaseAgreementNextVersionsUpdateConnectionInput;
	BaseAgreementNextVersionsUpdateFieldInput: BaseAgreementNextVersionsUpdateFieldInput;
	BaseAgreementOptions: BaseAgreementOptions;
	BaseAgreementProcessedDeviceRecordsAggregateInput: BaseAgreementProcessedDeviceRecordsAggregateInput;
	BaseAgreementProcessedDeviceRecordsConnectFieldInput: BaseAgreementProcessedDeviceRecordsConnectFieldInput;
	BaseAgreementProcessedDeviceRecordsConnection: ResolverTypeWrapper<BaseAgreementProcessedDeviceRecordsConnection>;
	BaseAgreementProcessedDeviceRecordsConnectionSort: BaseAgreementProcessedDeviceRecordsConnectionSort;
	BaseAgreementProcessedDeviceRecordsConnectionWhere: BaseAgreementProcessedDeviceRecordsConnectionWhere;
	BaseAgreementProcessedDeviceRecordsCreateFieldInput: BaseAgreementProcessedDeviceRecordsCreateFieldInput;
	BaseAgreementProcessedDeviceRecordsDeleteFieldInput: BaseAgreementProcessedDeviceRecordsDeleteFieldInput;
	BaseAgreementProcessedDeviceRecordsDisconnectFieldInput: BaseAgreementProcessedDeviceRecordsDisconnectFieldInput;
	BaseAgreementProcessedDeviceRecordsFieldInput: BaseAgreementProcessedDeviceRecordsFieldInput;
	BaseAgreementProcessedDeviceRecordsRelationship: ResolverTypeWrapper<BaseAgreementProcessedDeviceRecordsRelationship>;
	BaseAgreementProcessedDeviceRecordsUpdateConnectionInput: BaseAgreementProcessedDeviceRecordsUpdateConnectionInput;
	BaseAgreementProcessedDeviceRecordsUpdateFieldInput: BaseAgreementProcessedDeviceRecordsUpdateFieldInput;
	BaseAgreementPushedByAggregateInput: BaseAgreementPushedByAggregateInput;
	BaseAgreementPushedByConnectFieldInput: BaseAgreementPushedByConnectFieldInput;
	BaseAgreementPushedByConnection: ResolverTypeWrapper<BaseAgreementPushedByConnection>;
	BaseAgreementPushedByConnectionSort: BaseAgreementPushedByConnectionSort;
	BaseAgreementPushedByConnectionWhere: BaseAgreementPushedByConnectionWhere;
	BaseAgreementPushedByCreateFieldInput: BaseAgreementPushedByCreateFieldInput;
	BaseAgreementPushedByDeleteFieldInput: BaseAgreementPushedByDeleteFieldInput;
	BaseAgreementPushedByDisconnectFieldInput: BaseAgreementPushedByDisconnectFieldInput;
	BaseAgreementPushedByFieldInput: BaseAgreementPushedByFieldInput;
	BaseAgreementPushedByNodeAggregationWhereInput: BaseAgreementPushedByNodeAggregationWhereInput;
	BaseAgreementPushedByRelationship: ResolverTypeWrapper<BaseAgreementPushedByRelationship>;
	BaseAgreementPushedByUpdateConnectionInput: BaseAgreementPushedByUpdateConnectionInput;
	BaseAgreementPushedByUpdateFieldInput: BaseAgreementPushedByUpdateFieldInput;
	BaseAgreementScenariosAggregateInput: BaseAgreementScenariosAggregateInput;
	BaseAgreementScenariosConnectFieldInput: BaseAgreementScenariosConnectFieldInput;
	BaseAgreementScenariosConnection: ResolverTypeWrapper<BaseAgreementScenariosConnection>;
	BaseAgreementScenariosConnectionSort: BaseAgreementScenariosConnectionSort;
	BaseAgreementScenariosConnectionWhere: BaseAgreementScenariosConnectionWhere;
	BaseAgreementScenariosCreateFieldInput: BaseAgreementScenariosCreateFieldInput;
	BaseAgreementScenariosDeleteFieldInput: BaseAgreementScenariosDeleteFieldInput;
	BaseAgreementScenariosDisconnectFieldInput: BaseAgreementScenariosDisconnectFieldInput;
	BaseAgreementScenariosFieldInput: BaseAgreementScenariosFieldInput;
	BaseAgreementScenariosNodeAggregationWhereInput: BaseAgreementScenariosNodeAggregationWhereInput;
	BaseAgreementScenariosRelationship: ResolverTypeWrapper<BaseAgreementScenariosRelationship>;
	BaseAgreementScenariosUpdateConnectionInput: BaseAgreementScenariosUpdateConnectionInput;
	BaseAgreementScenariosUpdateFieldInput: BaseAgreementScenariosUpdateFieldInput;
	BaseAgreementSort: BaseAgreementSort;
	BaseAgreementStatusTransitionsAggregateInput: BaseAgreementStatusTransitionsAggregateInput;
	BaseAgreementStatusTransitionsConnectFieldInput: BaseAgreementStatusTransitionsConnectFieldInput;
	BaseAgreementStatusTransitionsConnection: ResolverTypeWrapper<BaseAgreementStatusTransitionsConnection>;
	BaseAgreementStatusTransitionsConnectionSort: BaseAgreementStatusTransitionsConnectionSort;
	BaseAgreementStatusTransitionsConnectionWhere: BaseAgreementStatusTransitionsConnectionWhere;
	BaseAgreementStatusTransitionsCreateFieldInput: BaseAgreementStatusTransitionsCreateFieldInput;
	BaseAgreementStatusTransitionsDeleteFieldInput: BaseAgreementStatusTransitionsDeleteFieldInput;
	BaseAgreementStatusTransitionsDisconnectFieldInput: BaseAgreementStatusTransitionsDisconnectFieldInput;
	BaseAgreementStatusTransitionsFieldInput: BaseAgreementStatusTransitionsFieldInput;
	BaseAgreementStatusTransitionsNodeAggregationWhereInput: BaseAgreementStatusTransitionsNodeAggregationWhereInput;
	BaseAgreementStatusTransitionsRelationship: ResolverTypeWrapper<BaseAgreementStatusTransitionsRelationship>;
	BaseAgreementStatusTransitionsUpdateConnectionInput: BaseAgreementStatusTransitionsUpdateConnectionInput;
	BaseAgreementStatusTransitionsUpdateFieldInput: BaseAgreementStatusTransitionsUpdateFieldInput;
	BaseAgreementTagsAggregateInput: BaseAgreementTagsAggregateInput;
	BaseAgreementTagsConnectFieldInput: BaseAgreementTagsConnectFieldInput;
	BaseAgreementTagsConnection: ResolverTypeWrapper<BaseAgreementTagsConnection>;
	BaseAgreementTagsConnectionSort: BaseAgreementTagsConnectionSort;
	BaseAgreementTagsConnectionWhere: BaseAgreementTagsConnectionWhere;
	BaseAgreementTagsCreateFieldInput: BaseAgreementTagsCreateFieldInput;
	BaseAgreementTagsDeleteFieldInput: BaseAgreementTagsDeleteFieldInput;
	BaseAgreementTagsDisconnectFieldInput: BaseAgreementTagsDisconnectFieldInput;
	BaseAgreementTagsFieldInput: BaseAgreementTagsFieldInput;
	BaseAgreementTagsNodeAggregationWhereInput: BaseAgreementTagsNodeAggregationWhereInput;
	BaseAgreementTagsRelationship: ResolverTypeWrapper<BaseAgreementTagsRelationship>;
	BaseAgreementTagsUpdateConnectionInput: BaseAgreementTagsUpdateConnectionInput;
	BaseAgreementTagsUpdateFieldInput: BaseAgreementTagsUpdateFieldInput;
	BaseAgreementTreatmentPriceRelationship: ResolversTypes["BaseAgreementTreatmentPricesRelationship"];
	BaseAgreementTreatmentPriceRelationshipCreateInput: BaseAgreementTreatmentPriceRelationshipCreateInput;
	BaseAgreementTreatmentPriceRelationshipSort: BaseAgreementTreatmentPriceRelationshipSort;
	BaseAgreementTreatmentPriceRelationshipUpdateInput: BaseAgreementTreatmentPriceRelationshipUpdateInput;
	BaseAgreementTreatmentPriceRelationshipWhere: BaseAgreementTreatmentPriceRelationshipWhere;
	BaseAgreementTreatmentPricesAggregateInput: BaseAgreementTreatmentPricesAggregateInput;
	BaseAgreementTreatmentPricesConnectFieldInput: BaseAgreementTreatmentPricesConnectFieldInput;
	BaseAgreementTreatmentPricesConnection: ResolverTypeWrapper<BaseAgreementTreatmentPricesConnection>;
	BaseAgreementTreatmentPricesConnectionSort: BaseAgreementTreatmentPricesConnectionSort;
	BaseAgreementTreatmentPricesConnectionWhere: BaseAgreementTreatmentPricesConnectionWhere;
	BaseAgreementTreatmentPricesCreateFieldInput: BaseAgreementTreatmentPricesCreateFieldInput;
	BaseAgreementTreatmentPricesDeleteFieldInput: BaseAgreementTreatmentPricesDeleteFieldInput;
	BaseAgreementTreatmentPricesDisconnectFieldInput: BaseAgreementTreatmentPricesDisconnectFieldInput;
	BaseAgreementTreatmentPricesEdgeAggregationWhereInput: BaseAgreementTreatmentPricesEdgeAggregationWhereInput;
	BaseAgreementTreatmentPricesFieldInput: BaseAgreementTreatmentPricesFieldInput;
	BaseAgreementTreatmentPricesNodeAggregationWhereInput: BaseAgreementTreatmentPricesNodeAggregationWhereInput;
	BaseAgreementTreatmentPricesRelationship: ResolverTypeWrapper<BaseAgreementTreatmentPricesRelationship>;
	BaseAgreementTreatmentPricesUpdateConnectionInput: BaseAgreementTreatmentPricesUpdateConnectionInput;
	BaseAgreementTreatmentPricesUpdateFieldInput: BaseAgreementTreatmentPricesUpdateFieldInput;
	BaseAgreementUpdateInput: BaseAgreementUpdateInput;
	BaseAgreementUserContextsAggregateInput: BaseAgreementUserContextsAggregateInput;
	BaseAgreementUserContextsConnectFieldInput: BaseAgreementUserContextsConnectFieldInput;
	BaseAgreementUserContextsConnection: ResolverTypeWrapper<BaseAgreementUserContextsConnection>;
	BaseAgreementUserContextsConnectionSort: BaseAgreementUserContextsConnectionSort;
	BaseAgreementUserContextsConnectionWhere: BaseAgreementUserContextsConnectionWhere;
	BaseAgreementUserContextsCreateFieldInput: BaseAgreementUserContextsCreateFieldInput;
	BaseAgreementUserContextsDeleteFieldInput: BaseAgreementUserContextsDeleteFieldInput;
	BaseAgreementUserContextsDisconnectFieldInput: BaseAgreementUserContextsDisconnectFieldInput;
	BaseAgreementUserContextsEdgeAggregationWhereInput: BaseAgreementUserContextsEdgeAggregationWhereInput;
	BaseAgreementUserContextsFieldInput: BaseAgreementUserContextsFieldInput;
	BaseAgreementUserContextsNodeAggregationWhereInput: BaseAgreementUserContextsNodeAggregationWhereInput;
	BaseAgreementUserContextsRelationship: ResolverTypeWrapper<BaseAgreementUserContextsRelationship>;
	BaseAgreementUserContextsUpdateConnectionInput: BaseAgreementUserContextsUpdateConnectionInput;
	BaseAgreementUserContextsUpdateFieldInput: BaseAgreementUserContextsUpdateFieldInput;
	BaseAgreementUserRoleRelationship: ResolversTypes["BaseAgreementUserRolesRelationship"];
	BaseAgreementUserRoleRelationshipCreateInput: BaseAgreementUserRoleRelationshipCreateInput;
	BaseAgreementUserRoleRelationshipSort: BaseAgreementUserRoleRelationshipSort;
	BaseAgreementUserRoleRelationshipUpdateInput: BaseAgreementUserRoleRelationshipUpdateInput;
	BaseAgreementUserRoleRelationshipWhere: BaseAgreementUserRoleRelationshipWhere;
	BaseAgreementUserRolesAggregateInput: BaseAgreementUserRolesAggregateInput;
	BaseAgreementUserRolesConnectFieldInput: BaseAgreementUserRolesConnectFieldInput;
	BaseAgreementUserRolesConnection: ResolverTypeWrapper<BaseAgreementUserRolesConnection>;
	BaseAgreementUserRolesConnectionSort: BaseAgreementUserRolesConnectionSort;
	BaseAgreementUserRolesConnectionWhere: BaseAgreementUserRolesConnectionWhere;
	BaseAgreementUserRolesCreateFieldInput: BaseAgreementUserRolesCreateFieldInput;
	BaseAgreementUserRolesDeleteFieldInput: BaseAgreementUserRolesDeleteFieldInput;
	BaseAgreementUserRolesDisconnectFieldInput: BaseAgreementUserRolesDisconnectFieldInput;
	BaseAgreementUserRolesFieldInput: BaseAgreementUserRolesFieldInput;
	BaseAgreementUserRolesNodeAggregationWhereInput: BaseAgreementUserRolesNodeAggregationWhereInput;
	BaseAgreementUserRolesRelationship: ResolverTypeWrapper<BaseAgreementUserRolesRelationship>;
	BaseAgreementUserRolesUpdateConnectionInput: BaseAgreementUserRolesUpdateConnectionInput;
	BaseAgreementUserRolesUpdateFieldInput: BaseAgreementUserRolesUpdateFieldInput;
	BaseAgreementWhere: BaseAgreementWhere;
	Boolean: ResolverTypeWrapper<Scalars["Boolean"]>;
	Brand: ResolverTypeWrapper<Brand>;
	BrandAggregateSelection: ResolverTypeWrapper<BrandAggregateSelection>;
	BrandConnectInput: BrandConnectInput;
	BrandConnectWhere: BrandConnectWhere;
	BrandCreateInput: BrandCreateInput;
	BrandDeleteInput: BrandDeleteInput;
	BrandDisconnectInput: BrandDisconnectInput;
	BrandOptions: BrandOptions;
	BrandPreparationsAggregateInput: BrandPreparationsAggregateInput;
	BrandPreparationsConnectFieldInput: BrandPreparationsConnectFieldInput;
	BrandPreparationsConnection: ResolverTypeWrapper<BrandPreparationsConnection>;
	BrandPreparationsConnectionSort: BrandPreparationsConnectionSort;
	BrandPreparationsConnectionWhere: BrandPreparationsConnectionWhere;
	BrandPreparationsCreateFieldInput: BrandPreparationsCreateFieldInput;
	BrandPreparationsDeleteFieldInput: BrandPreparationsDeleteFieldInput;
	BrandPreparationsDisconnectFieldInput: BrandPreparationsDisconnectFieldInput;
	BrandPreparationsFieldInput: BrandPreparationsFieldInput;
	BrandPreparationsNodeAggregationWhereInput: BrandPreparationsNodeAggregationWhereInput;
	BrandPreparationsRelationship: ResolverTypeWrapper<BrandPreparationsRelationship>;
	BrandPreparationsUpdateConnectionInput: BrandPreparationsUpdateConnectionInput;
	BrandPreparationsUpdateFieldInput: BrandPreparationsUpdateFieldInput;
	BrandSort: BrandSort;
	BrandUpdateInput: BrandUpdateInput;
	BrandWhere: BrandWhere;
	CAOBAgreementReport: ResolverTypeWrapper<CaobAgreementReport>;
	CAOBAgreementReportAggregateSelection: ResolverTypeWrapper<CaobAgreementReportAggregateSelection>;
	CAOBAgreementReportOptions: CaobAgreementReportOptions;
	CAOBAgreementReportSort: CaobAgreementReportSort;
	CAOBAgreementReportWhere: CaobAgreementReportWhere;
	CAOBPhysician: CaobPhysician;
	CAOBRefundSummaryRow: ResolverTypeWrapper<CaobRefundSummaryRow>;
	CAOBRefundSummaryRowAggregateSelection: ResolverTypeWrapper<CaobRefundSummaryRowAggregateSelection>;
	CAOBRefundSummaryRowOptions: CaobRefundSummaryRowOptions;
	CAOBRefundSummaryRowSort: CaobRefundSummaryRowSort;
	CAOBRefundSummaryRowWhere: CaobRefundSummaryRowWhere;
	CaobAgreementRenewalInput: CaobAgreementRenewalInput;
	Case: ResolverTypeWrapper<Case>;
	CaseAggregateSelection: ResolverTypeWrapper<CaseAggregateSelection>;
	CaseBaseAgreementAggregateInput: CaseBaseAgreementAggregateInput;
	CaseBaseAgreementConnectFieldInput: CaseBaseAgreementConnectFieldInput;
	CaseBaseAgreementConnection: ResolverTypeWrapper<CaseBaseAgreementConnection>;
	CaseBaseAgreementConnectionSort: CaseBaseAgreementConnectionSort;
	CaseBaseAgreementConnectionWhere: CaseBaseAgreementConnectionWhere;
	CaseBaseAgreementCreateFieldInput: CaseBaseAgreementCreateFieldInput;
	CaseBaseAgreementDeleteFieldInput: CaseBaseAgreementDeleteFieldInput;
	CaseBaseAgreementDisconnectFieldInput: CaseBaseAgreementDisconnectFieldInput;
	CaseBaseAgreementFieldInput: CaseBaseAgreementFieldInput;
	CaseBaseAgreementNodeAggregationWhereInput: CaseBaseAgreementNodeAggregationWhereInput;
	CaseBaseAgreementRelationship: ResolverTypeWrapper<CaseBaseAgreementRelationship>;
	CaseBaseAgreementUpdateConnectionInput: CaseBaseAgreementUpdateConnectionInput;
	CaseBaseAgreementUpdateFieldInput: CaseBaseAgreementUpdateFieldInput;
	CaseClaimsAggregateInput: CaseClaimsAggregateInput;
	CaseClaimsConnectFieldInput: CaseClaimsConnectFieldInput;
	CaseClaimsConnection: ResolverTypeWrapper<CaseClaimsConnection>;
	CaseClaimsConnectionSort: CaseClaimsConnectionSort;
	CaseClaimsConnectionWhere: CaseClaimsConnectionWhere;
	CaseClaimsCreateFieldInput: CaseClaimsCreateFieldInput;
	CaseClaimsDeleteFieldInput: CaseClaimsDeleteFieldInput;
	CaseClaimsDisconnectFieldInput: CaseClaimsDisconnectFieldInput;
	CaseClaimsFieldInput: CaseClaimsFieldInput;
	CaseClaimsNodeAggregationWhereInput: CaseClaimsNodeAggregationWhereInput;
	CaseClaimsRelationship: ResolverTypeWrapper<CaseClaimsRelationship>;
	CaseClaimsUpdateConnectionInput: CaseClaimsUpdateConnectionInput;
	CaseClaimsUpdateFieldInput: CaseClaimsUpdateFieldInput;
	CaseCohortAggregateInput: CaseCohortAggregateInput;
	CaseCohortConnectFieldInput: CaseCohortConnectFieldInput;
	CaseCohortConnection: ResolverTypeWrapper<CaseCohortConnection>;
	CaseCohortConnectionSort: CaseCohortConnectionSort;
	CaseCohortConnectionWhere: CaseCohortConnectionWhere;
	CaseCohortCreateFieldInput: CaseCohortCreateFieldInput;
	CaseCohortDeleteFieldInput: CaseCohortDeleteFieldInput;
	CaseCohortDisconnectFieldInput: CaseCohortDisconnectFieldInput;
	CaseCohortFieldInput: CaseCohortFieldInput;
	CaseCohortRelationship: ResolverTypeWrapper<CaseCohortRelationship>;
	CaseCohortUpdateConnectionInput: CaseCohortUpdateConnectionInput;
	CaseCohortUpdateFieldInput: CaseCohortUpdateFieldInput;
	CaseConnectInput: CaseConnectInput;
	CaseConnectWhere: CaseConnectWhere;
	CaseCoverageRequestsAggregateInput: CaseCoverageRequestsAggregateInput;
	CaseCoverageRequestsConnectFieldInput: CaseCoverageRequestsConnectFieldInput;
	CaseCoverageRequestsConnection: ResolverTypeWrapper<CaseCoverageRequestsConnection>;
	CaseCoverageRequestsConnectionSort: CaseCoverageRequestsConnectionSort;
	CaseCoverageRequestsConnectionWhere: CaseCoverageRequestsConnectionWhere;
	CaseCoverageRequestsCreateFieldInput: CaseCoverageRequestsCreateFieldInput;
	CaseCoverageRequestsDeleteFieldInput: CaseCoverageRequestsDeleteFieldInput;
	CaseCoverageRequestsDisconnectFieldInput: CaseCoverageRequestsDisconnectFieldInput;
	CaseCoverageRequestsFieldInput: CaseCoverageRequestsFieldInput;
	CaseCoverageRequestsNodeAggregationWhereInput: CaseCoverageRequestsNodeAggregationWhereInput;
	CaseCoverageRequestsRelationship: ResolverTypeWrapper<CaseCoverageRequestsRelationship>;
	CaseCoverageRequestsUpdateConnectionInput: CaseCoverageRequestsUpdateConnectionInput;
	CaseCoverageRequestsUpdateFieldInput: CaseCoverageRequestsUpdateFieldInput;
	CaseCreateInput: CaseCreateInput;
	CaseDeleteInput: CaseDeleteInput;
	CaseDisconnectInput: CaseDisconnectInput;
	CaseDiseaseAggregateInput: CaseDiseaseAggregateInput;
	CaseDiseaseConnectFieldInput: CaseDiseaseConnectFieldInput;
	CaseDiseaseConnection: ResolverTypeWrapper<CaseDiseaseConnection>;
	CaseDiseaseConnectionSort: CaseDiseaseConnectionSort;
	CaseDiseaseConnectionWhere: CaseDiseaseConnectionWhere;
	CaseDiseaseCreateFieldInput: CaseDiseaseCreateFieldInput;
	CaseDiseaseDeleteFieldInput: CaseDiseaseDeleteFieldInput;
	CaseDiseaseDisconnectFieldInput: CaseDiseaseDisconnectFieldInput;
	CaseDiseaseFieldInput: CaseDiseaseFieldInput;
	CaseDiseaseNodeAggregationWhereInput: CaseDiseaseNodeAggregationWhereInput;
	CaseDiseaseRelationship: ResolverTypeWrapper<CaseDiseaseRelationship>;
	CaseDiseaseUpdateConnectionInput: CaseDiseaseUpdateConnectionInput;
	CaseDiseaseUpdateFieldInput: CaseDiseaseUpdateFieldInput;
	CaseFinancialDataPointsAggregateInput: CaseFinancialDataPointsAggregateInput;
	CaseFinancialDataPointsConnectFieldInput: CaseFinancialDataPointsConnectFieldInput;
	CaseFinancialDataPointsConnection: ResolverTypeWrapper<CaseFinancialDataPointsConnection>;
	CaseFinancialDataPointsConnectionSort: CaseFinancialDataPointsConnectionSort;
	CaseFinancialDataPointsConnectionWhere: CaseFinancialDataPointsConnectionWhere;
	CaseFinancialDataPointsCreateFieldInput: CaseFinancialDataPointsCreateFieldInput;
	CaseFinancialDataPointsDeleteFieldInput: CaseFinancialDataPointsDeleteFieldInput;
	CaseFinancialDataPointsDisconnectFieldInput: CaseFinancialDataPointsDisconnectFieldInput;
	CaseFinancialDataPointsFieldInput: CaseFinancialDataPointsFieldInput;
	CaseFinancialDataPointsNodeAggregationWhereInput: CaseFinancialDataPointsNodeAggregationWhereInput;
	CaseFinancialDataPointsRelationship: ResolverTypeWrapper<CaseFinancialDataPointsRelationship>;
	CaseFinancialDataPointsUpdateConnectionInput: CaseFinancialDataPointsUpdateConnectionInput;
	CaseFinancialDataPointsUpdateFieldInput: CaseFinancialDataPointsUpdateFieldInput;
	CaseFlexEntitiesAggregateInput: CaseFlexEntitiesAggregateInput;
	CaseFlexEntitiesConnectFieldInput: CaseFlexEntitiesConnectFieldInput;
	CaseFlexEntitiesConnection: ResolverTypeWrapper<CaseFlexEntitiesConnection>;
	CaseFlexEntitiesConnectionSort: CaseFlexEntitiesConnectionSort;
	CaseFlexEntitiesConnectionWhere: CaseFlexEntitiesConnectionWhere;
	CaseFlexEntitiesCreateFieldInput: CaseFlexEntitiesCreateFieldInput;
	CaseFlexEntitiesDeleteFieldInput: CaseFlexEntitiesDeleteFieldInput;
	CaseFlexEntitiesDisconnectFieldInput: CaseFlexEntitiesDisconnectFieldInput;
	CaseFlexEntitiesFieldInput: CaseFlexEntitiesFieldInput;
	CaseFlexEntitiesNodeAggregationWhereInput: CaseFlexEntitiesNodeAggregationWhereInput;
	CaseFlexEntitiesRelationship: ResolverTypeWrapper<CaseFlexEntitiesRelationship>;
	CaseFlexEntitiesUpdateConnectionInput: CaseFlexEntitiesUpdateConnectionInput;
	CaseFlexEntitiesUpdateFieldInput: CaseFlexEntitiesUpdateFieldInput;
	CaseFlexFinancialDataPointsAggregateInput: CaseFlexFinancialDataPointsAggregateInput;
	CaseFlexFinancialDataPointsConnectFieldInput: CaseFlexFinancialDataPointsConnectFieldInput;
	CaseFlexFinancialDataPointsConnection: ResolverTypeWrapper<CaseFlexFinancialDataPointsConnection>;
	CaseFlexFinancialDataPointsConnectionSort: CaseFlexFinancialDataPointsConnectionSort;
	CaseFlexFinancialDataPointsConnectionWhere: CaseFlexFinancialDataPointsConnectionWhere;
	CaseFlexFinancialDataPointsCreateFieldInput: CaseFlexFinancialDataPointsCreateFieldInput;
	CaseFlexFinancialDataPointsDeleteFieldInput: CaseFlexFinancialDataPointsDeleteFieldInput;
	CaseFlexFinancialDataPointsDisconnectFieldInput: CaseFlexFinancialDataPointsDisconnectFieldInput;
	CaseFlexFinancialDataPointsFieldInput: CaseFlexFinancialDataPointsFieldInput;
	CaseFlexFinancialDataPointsNodeAggregationWhereInput: CaseFlexFinancialDataPointsNodeAggregationWhereInput;
	CaseFlexFinancialDataPointsRelationship: ResolverTypeWrapper<CaseFlexFinancialDataPointsRelationship>;
	CaseFlexFinancialDataPointsUpdateConnectionInput: CaseFlexFinancialDataPointsUpdateConnectionInput;
	CaseFlexFinancialDataPointsUpdateFieldInput: CaseFlexFinancialDataPointsUpdateFieldInput;
	CaseIndicationAggregateInput: CaseIndicationAggregateInput;
	CaseIndicationConnectFieldInput: CaseIndicationConnectFieldInput;
	CaseIndicationConnection: ResolverTypeWrapper<CaseIndicationConnection>;
	CaseIndicationConnectionSort: CaseIndicationConnectionSort;
	CaseIndicationConnectionWhere: CaseIndicationConnectionWhere;
	CaseIndicationCreateFieldInput: CaseIndicationCreateFieldInput;
	CaseIndicationDeleteFieldInput: CaseIndicationDeleteFieldInput;
	CaseIndicationDisconnectFieldInput: CaseIndicationDisconnectFieldInput;
	CaseIndicationFieldInput: CaseIndicationFieldInput;
	CaseIndicationNodeAggregationWhereInput: CaseIndicationNodeAggregationWhereInput;
	CaseIndicationRelationship: ResolverTypeWrapper<CaseIndicationRelationship>;
	CaseIndicationUpdateConnectionInput: CaseIndicationUpdateConnectionInput;
	CaseIndicationUpdateFieldInput: CaseIndicationUpdateFieldInput;
	CaseLegalEntityAggregateInput: CaseLegalEntityAggregateInput;
	CaseLegalEntityConnectFieldInput: CaseLegalEntityConnectFieldInput;
	CaseLegalEntityConnection: ResolverTypeWrapper<CaseLegalEntityConnection>;
	CaseLegalEntityConnectionSort: CaseLegalEntityConnectionSort;
	CaseLegalEntityConnectionWhere: CaseLegalEntityConnectionWhere;
	CaseLegalEntityCreateFieldInput: CaseLegalEntityCreateFieldInput;
	CaseLegalEntityDeleteFieldInput: CaseLegalEntityDeleteFieldInput;
	CaseLegalEntityDisconnectFieldInput: CaseLegalEntityDisconnectFieldInput;
	CaseLegalEntityFieldInput: CaseLegalEntityFieldInput;
	CaseLegalEntityNodeAggregationWhereInput: CaseLegalEntityNodeAggregationWhereInput;
	CaseLegalEntityRelationship: ResolverTypeWrapper<CaseLegalEntityRelationship>;
	CaseLegalEntityUpdateConnectionInput: CaseLegalEntityUpdateConnectionInput;
	CaseLegalEntityUpdateFieldInput: CaseLegalEntityUpdateFieldInput;
	CaseOptions: CaseOptions;
	CasePatientAggregateInput: CasePatientAggregateInput;
	CasePatientConnectFieldInput: CasePatientConnectFieldInput;
	CasePatientConnection: ResolverTypeWrapper<CasePatientConnection>;
	CasePatientConnectionSort: CasePatientConnectionSort;
	CasePatientConnectionWhere: CasePatientConnectionWhere;
	CasePatientCreateFieldInput: CasePatientCreateFieldInput;
	CasePatientDeleteFieldInput: CasePatientDeleteFieldInput;
	CasePatientDisconnectFieldInput: CasePatientDisconnectFieldInput;
	CasePatientFieldInput: CasePatientFieldInput;
	CasePatientNodeAggregationWhereInput: CasePatientNodeAggregationWhereInput;
	CasePatientRelationship: ResolverTypeWrapper<CasePatientRelationship>;
	CasePatientUpdateConnectionInput: CasePatientUpdateConnectionInput;
	CasePatientUpdateFieldInput: CasePatientUpdateFieldInput;
	CasePreparationsAggregateInput: CasePreparationsAggregateInput;
	CasePreparationsConnectFieldInput: CasePreparationsConnectFieldInput;
	CasePreparationsConnection: ResolverTypeWrapper<CasePreparationsConnection>;
	CasePreparationsConnectionSort: CasePreparationsConnectionSort;
	CasePreparationsConnectionWhere: CasePreparationsConnectionWhere;
	CasePreparationsCreateFieldInput: CasePreparationsCreateFieldInput;
	CasePreparationsDeleteFieldInput: CasePreparationsDeleteFieldInput;
	CasePreparationsDisconnectFieldInput: CasePreparationsDisconnectFieldInput;
	CasePreparationsFieldInput: CasePreparationsFieldInput;
	CasePreparationsNodeAggregationWhereInput: CasePreparationsNodeAggregationWhereInput;
	CasePreparationsRelationship: ResolverTypeWrapper<CasePreparationsRelationship>;
	CasePreparationsUpdateConnectionInput: CasePreparationsUpdateConnectionInput;
	CasePreparationsUpdateFieldInput: CasePreparationsUpdateFieldInput;
	CasePrimaryInterventionAggregateInput: CasePrimaryInterventionAggregateInput;
	CasePrimaryInterventionConnectFieldInput: CasePrimaryInterventionConnectFieldInput;
	CasePrimaryInterventionConnection: ResolverTypeWrapper<CasePrimaryInterventionConnection>;
	CasePrimaryInterventionConnectionSort: CasePrimaryInterventionConnectionSort;
	CasePrimaryInterventionConnectionWhere: CasePrimaryInterventionConnectionWhere;
	CasePrimaryInterventionCreateFieldInput: CasePrimaryInterventionCreateFieldInput;
	CasePrimaryInterventionDeleteFieldInput: CasePrimaryInterventionDeleteFieldInput;
	CasePrimaryInterventionDisconnectFieldInput: CasePrimaryInterventionDisconnectFieldInput;
	CasePrimaryInterventionFieldInput: CasePrimaryInterventionFieldInput;
	CasePrimaryInterventionNodeAggregationWhereInput: CasePrimaryInterventionNodeAggregationWhereInput;
	CasePrimaryInterventionRelationship: ResolverTypeWrapper<CasePrimaryInterventionRelationship>;
	CasePrimaryInterventionUpdateConnectionInput: CasePrimaryInterventionUpdateConnectionInput;
	CasePrimaryInterventionUpdateFieldInput: CasePrimaryInterventionUpdateFieldInput;
	CaseRecordBatchesAggregateInput: CaseRecordBatchesAggregateInput;
	CaseRecordBatchesConnectFieldInput: CaseRecordBatchesConnectFieldInput;
	CaseRecordBatchesConnection: ResolverTypeWrapper<CaseRecordBatchesConnection>;
	CaseRecordBatchesConnectionSort: CaseRecordBatchesConnectionSort;
	CaseRecordBatchesConnectionWhere: CaseRecordBatchesConnectionWhere;
	CaseRecordBatchesCreateFieldInput: CaseRecordBatchesCreateFieldInput;
	CaseRecordBatchesDeleteFieldInput: CaseRecordBatchesDeleteFieldInput;
	CaseRecordBatchesDisconnectFieldInput: CaseRecordBatchesDisconnectFieldInput;
	CaseRecordBatchesFieldInput: CaseRecordBatchesFieldInput;
	CaseRecordBatchesNodeAggregationWhereInput: CaseRecordBatchesNodeAggregationWhereInput;
	CaseRecordBatchesRelationship: ResolverTypeWrapper<CaseRecordBatchesRelationship>;
	CaseRecordBatchesUpdateConnectionInput: CaseRecordBatchesUpdateConnectionInput;
	CaseRecordBatchesUpdateFieldInput: CaseRecordBatchesUpdateFieldInput;
	CaseReportDataPoint: ResolverTypeWrapper<CaseReportDataPoint>;
	CaseReportDataPointAggregateSelection: ResolverTypeWrapper<CaseReportDataPointAggregateSelection>;
	CaseReportDataPointOptions: CaseReportDataPointOptions;
	CaseReportDataPointSort: CaseReportDataPointSort;
	CaseReportDataPointWhere: CaseReportDataPointWhere;
	CaseSort: CaseSort;
	CaseStatus: CaseStatus;
	CaseStobContractAggregateInput: CaseStobContractAggregateInput;
	CaseStobContractConnectFieldInput: CaseStobContractConnectFieldInput;
	CaseStobContractConnection: ResolverTypeWrapper<CaseStobContractConnection>;
	CaseStobContractConnectionSort: CaseStobContractConnectionSort;
	CaseStobContractConnectionWhere: CaseStobContractConnectionWhere;
	CaseStobContractCreateFieldInput: CaseStobContractCreateFieldInput;
	CaseStobContractDeleteFieldInput: CaseStobContractDeleteFieldInput;
	CaseStobContractDisconnectFieldInput: CaseStobContractDisconnectFieldInput;
	CaseStobContractFieldInput: CaseStobContractFieldInput;
	CaseStobContractNodeAggregationWhereInput: CaseStobContractNodeAggregationWhereInput;
	CaseStobContractRelationship: ResolverTypeWrapper<CaseStobContractRelationship>;
	CaseStobContractUpdateConnectionInput: CaseStobContractUpdateConnectionInput;
	CaseStobContractUpdateFieldInput: CaseStobContractUpdateFieldInput;
	CaseTaskRelationship: ResolversTypes["TaskCaseRelationship"];
	CaseTaskRelationshipCreateInput: CaseTaskRelationshipCreateInput;
	CaseTaskRelationshipSort: CaseTaskRelationshipSort;
	CaseTaskRelationshipUpdateInput: CaseTaskRelationshipUpdateInput;
	CaseTaskRelationshipWhere: CaseTaskRelationshipWhere;
	CaseUpdateInput: CaseUpdateInput;
	CaseWhere: CaseWhere;
	Claim: ResolverTypeWrapper<Claim>;
	ClaimAggregateSelection: ResolverTypeWrapper<ClaimAggregateSelection>;
	ClaimCasesAggregateInput: ClaimCasesAggregateInput;
	ClaimCasesConnectFieldInput: ClaimCasesConnectFieldInput;
	ClaimCasesConnection: ResolverTypeWrapper<ClaimCasesConnection>;
	ClaimCasesConnectionSort: ClaimCasesConnectionSort;
	ClaimCasesConnectionWhere: ClaimCasesConnectionWhere;
	ClaimCasesCreateFieldInput: ClaimCasesCreateFieldInput;
	ClaimCasesDeleteFieldInput: ClaimCasesDeleteFieldInput;
	ClaimCasesDisconnectFieldInput: ClaimCasesDisconnectFieldInput;
	ClaimCasesFieldInput: ClaimCasesFieldInput;
	ClaimCasesNodeAggregationWhereInput: ClaimCasesNodeAggregationWhereInput;
	ClaimCasesRelationship: ResolverTypeWrapper<ClaimCasesRelationship>;
	ClaimCasesUpdateConnectionInput: ClaimCasesUpdateConnectionInput;
	ClaimCasesUpdateFieldInput: ClaimCasesUpdateFieldInput;
	ClaimConnectInput: ClaimConnectInput;
	ClaimConnectWhere: ClaimConnectWhere;
	ClaimCreateInput: ClaimCreateInput;
	ClaimDeleteInput: ClaimDeleteInput;
	ClaimDisconnectInput: ClaimDisconnectInput;
	ClaimEnrolledIntoCaseRelationship: ResolversTypes["ClaimCasesRelationship"];
	ClaimEnrolledIntoCaseRelationshipCreateInput: ClaimEnrolledIntoCaseRelationshipCreateInput;
	ClaimEnrolledIntoCaseRelationshipSort: ClaimEnrolledIntoCaseRelationshipSort;
	ClaimEnrolledIntoCaseRelationshipUpdateInput: ClaimEnrolledIntoCaseRelationshipUpdateInput;
	ClaimEnrolledIntoCaseRelationshipWhere: ClaimEnrolledIntoCaseRelationshipWhere;
	ClaimFinancialDataPointsAggregateInput: ClaimFinancialDataPointsAggregateInput;
	ClaimFinancialDataPointsConnectFieldInput: ClaimFinancialDataPointsConnectFieldInput;
	ClaimFinancialDataPointsConnection: ResolverTypeWrapper<ClaimFinancialDataPointsConnection>;
	ClaimFinancialDataPointsConnectionSort: ClaimFinancialDataPointsConnectionSort;
	ClaimFinancialDataPointsConnectionWhere: ClaimFinancialDataPointsConnectionWhere;
	ClaimFinancialDataPointsCreateFieldInput: ClaimFinancialDataPointsCreateFieldInput;
	ClaimFinancialDataPointsDeleteFieldInput: ClaimFinancialDataPointsDeleteFieldInput;
	ClaimFinancialDataPointsDisconnectFieldInput: ClaimFinancialDataPointsDisconnectFieldInput;
	ClaimFinancialDataPointsFieldInput: ClaimFinancialDataPointsFieldInput;
	ClaimFinancialDataPointsNodeAggregationWhereInput: ClaimFinancialDataPointsNodeAggregationWhereInput;
	ClaimFinancialDataPointsRelationship: ResolverTypeWrapper<ClaimFinancialDataPointsRelationship>;
	ClaimFinancialDataPointsUpdateConnectionInput: ClaimFinancialDataPointsUpdateConnectionInput;
	ClaimFinancialDataPointsUpdateFieldInput: ClaimFinancialDataPointsUpdateFieldInput;
	ClaimIncludesAggregateInput: ClaimIncludesAggregateInput;
	ClaimIncludesConnectFieldInput: ClaimIncludesConnectFieldInput;
	ClaimIncludesConnection: ResolverTypeWrapper<ClaimIncludesConnection>;
	ClaimIncludesConnectionSort: ClaimIncludesConnectionSort;
	ClaimIncludesConnectionWhere: ClaimIncludesConnectionWhere;
	ClaimIncludesCreateFieldInput: ClaimIncludesCreateFieldInput;
	ClaimIncludesDeleteFieldInput: ClaimIncludesDeleteFieldInput;
	ClaimIncludesDisconnectFieldInput: ClaimIncludesDisconnectFieldInput;
	ClaimIncludesFieldInput: ClaimIncludesFieldInput;
	ClaimIncludesNodeAggregationWhereInput: ClaimIncludesNodeAggregationWhereInput;
	ClaimIncludesRelationship: ResolverTypeWrapper<ClaimIncludesRelationship>;
	ClaimIncludesUpdateConnectionInput: ClaimIncludesUpdateConnectionInput;
	ClaimIncludesUpdateFieldInput: ClaimIncludesUpdateFieldInput;
	ClaimOptions: ClaimOptions;
	ClaimReceivedFromPatientAggregateInput: ClaimReceivedFromPatientAggregateInput;
	ClaimReceivedFromPatientConnectFieldInput: ClaimReceivedFromPatientConnectFieldInput;
	ClaimReceivedFromPatientConnection: ResolverTypeWrapper<ClaimReceivedFromPatientConnection>;
	ClaimReceivedFromPatientConnectionSort: ClaimReceivedFromPatientConnectionSort;
	ClaimReceivedFromPatientConnectionWhere: ClaimReceivedFromPatientConnectionWhere;
	ClaimReceivedFromPatientCreateFieldInput: ClaimReceivedFromPatientCreateFieldInput;
	ClaimReceivedFromPatientDeleteFieldInput: ClaimReceivedFromPatientDeleteFieldInput;
	ClaimReceivedFromPatientDisconnectFieldInput: ClaimReceivedFromPatientDisconnectFieldInput;
	ClaimReceivedFromPatientFieldInput: ClaimReceivedFromPatientFieldInput;
	ClaimReceivedFromPatientNodeAggregationWhereInput: ClaimReceivedFromPatientNodeAggregationWhereInput;
	ClaimReceivedFromPatientRelationship: ResolverTypeWrapper<ClaimReceivedFromPatientRelationship>;
	ClaimReceivedFromPatientUpdateConnectionInput: ClaimReceivedFromPatientUpdateConnectionInput;
	ClaimReceivedFromPatientUpdateFieldInput: ClaimReceivedFromPatientUpdateFieldInput;
	ClaimRecordAggregateInput: ClaimRecordAggregateInput;
	ClaimRecordConnectFieldInput: ClaimRecordConnectFieldInput;
	ClaimRecordConnection: ResolverTypeWrapper<ClaimRecordConnection>;
	ClaimRecordConnectionSort: ClaimRecordConnectionSort;
	ClaimRecordConnectionWhere: ClaimRecordConnectionWhere;
	ClaimRecordCreateFieldInput: ClaimRecordCreateFieldInput;
	ClaimRecordDeleteFieldInput: ClaimRecordDeleteFieldInput;
	ClaimRecordDisconnectFieldInput: ClaimRecordDisconnectFieldInput;
	ClaimRecordFieldInput: ClaimRecordFieldInput;
	ClaimRecordNodeAggregationWhereInput: ClaimRecordNodeAggregationWhereInput;
	ClaimRecordRelationship: ResolverTypeWrapper<ClaimRecordRelationship>;
	ClaimRecordUpdateConnectionInput: ClaimRecordUpdateConnectionInput;
	ClaimRecordUpdateFieldInput: ClaimRecordUpdateFieldInput;
	ClaimSort: ClaimSort;
	ClaimUpdateInput: ClaimUpdateInput;
	ClaimWhere: ClaimWhere;
	ConditionConsideredRating: ConditionConsideredRating;
	ConditionConsideredSecIntervention: ConditionConsideredSecIntervention;
	ConditionLogicalOperator: ConditionLogicalOperator;
	ConditionType: ConditionType;
	ContinuousBenefit: ResolverTypeWrapper<ContinuousBenefit>;
	ContinuousBenefitAdverseEventsAggregateInput: ContinuousBenefitAdverseEventsAggregateInput;
	ContinuousBenefitAdverseEventsConnectFieldInput: ContinuousBenefitAdverseEventsConnectFieldInput;
	ContinuousBenefitAdverseEventsConnection: ResolverTypeWrapper<ContinuousBenefitAdverseEventsConnection>;
	ContinuousBenefitAdverseEventsConnectionSort: ContinuousBenefitAdverseEventsConnectionSort;
	ContinuousBenefitAdverseEventsConnectionWhere: ContinuousBenefitAdverseEventsConnectionWhere;
	ContinuousBenefitAdverseEventsCreateFieldInput: ContinuousBenefitAdverseEventsCreateFieldInput;
	ContinuousBenefitAdverseEventsDeleteFieldInput: ContinuousBenefitAdverseEventsDeleteFieldInput;
	ContinuousBenefitAdverseEventsDisconnectFieldInput: ContinuousBenefitAdverseEventsDisconnectFieldInput;
	ContinuousBenefitAdverseEventsFieldInput: ContinuousBenefitAdverseEventsFieldInput;
	ContinuousBenefitAdverseEventsNodeAggregationWhereInput: ContinuousBenefitAdverseEventsNodeAggregationWhereInput;
	ContinuousBenefitAdverseEventsRelationship: ResolverTypeWrapper<ContinuousBenefitAdverseEventsRelationship>;
	ContinuousBenefitAdverseEventsUpdateConnectionInput: ContinuousBenefitAdverseEventsUpdateConnectionInput;
	ContinuousBenefitAdverseEventsUpdateFieldInput: ContinuousBenefitAdverseEventsUpdateFieldInput;
	ContinuousBenefitAggregateSelection: ResolverTypeWrapper<ContinuousBenefitAggregateSelection>;
	ContinuousBenefitConnectInput: ContinuousBenefitConnectInput;
	ContinuousBenefitConnectWhere: ContinuousBenefitConnectWhere;
	ContinuousBenefitCoverageRequestAggregateInput: ContinuousBenefitCoverageRequestAggregateInput;
	ContinuousBenefitCoverageRequestConnectFieldInput: ContinuousBenefitCoverageRequestConnectFieldInput;
	ContinuousBenefitCoverageRequestConnection: ResolverTypeWrapper<ContinuousBenefitCoverageRequestConnection>;
	ContinuousBenefitCoverageRequestConnectionSort: ContinuousBenefitCoverageRequestConnectionSort;
	ContinuousBenefitCoverageRequestConnectionWhere: ContinuousBenefitCoverageRequestConnectionWhere;
	ContinuousBenefitCoverageRequestCreateFieldInput: ContinuousBenefitCoverageRequestCreateFieldInput;
	ContinuousBenefitCoverageRequestDeleteFieldInput: ContinuousBenefitCoverageRequestDeleteFieldInput;
	ContinuousBenefitCoverageRequestDisconnectFieldInput: ContinuousBenefitCoverageRequestDisconnectFieldInput;
	ContinuousBenefitCoverageRequestFieldInput: ContinuousBenefitCoverageRequestFieldInput;
	ContinuousBenefitCoverageRequestNodeAggregationWhereInput: ContinuousBenefitCoverageRequestNodeAggregationWhereInput;
	ContinuousBenefitCoverageRequestRelationship: ResolverTypeWrapper<ContinuousBenefitCoverageRequestRelationship>;
	ContinuousBenefitCoverageRequestUpdateConnectionInput: ContinuousBenefitCoverageRequestUpdateConnectionInput;
	ContinuousBenefitCoverageRequestUpdateFieldInput: ContinuousBenefitCoverageRequestUpdateFieldInput;
	ContinuousBenefitCreateInput: ContinuousBenefitCreateInput;
	ContinuousBenefitDeleteInput: ContinuousBenefitDeleteInput;
	ContinuousBenefitDisconnectInput: ContinuousBenefitDisconnectInput;
	ContinuousBenefitFinancialDataPointsAggregateInput: ContinuousBenefitFinancialDataPointsAggregateInput;
	ContinuousBenefitFinancialDataPointsConnectFieldInput: ContinuousBenefitFinancialDataPointsConnectFieldInput;
	ContinuousBenefitFinancialDataPointsConnection: ResolverTypeWrapper<ContinuousBenefitFinancialDataPointsConnection>;
	ContinuousBenefitFinancialDataPointsConnectionSort: ContinuousBenefitFinancialDataPointsConnectionSort;
	ContinuousBenefitFinancialDataPointsConnectionWhere: ContinuousBenefitFinancialDataPointsConnectionWhere;
	ContinuousBenefitFinancialDataPointsCreateFieldInput: ContinuousBenefitFinancialDataPointsCreateFieldInput;
	ContinuousBenefitFinancialDataPointsDeleteFieldInput: ContinuousBenefitFinancialDataPointsDeleteFieldInput;
	ContinuousBenefitFinancialDataPointsDisconnectFieldInput: ContinuousBenefitFinancialDataPointsDisconnectFieldInput;
	ContinuousBenefitFinancialDataPointsFieldInput: ContinuousBenefitFinancialDataPointsFieldInput;
	ContinuousBenefitFinancialDataPointsNodeAggregationWhereInput: ContinuousBenefitFinancialDataPointsNodeAggregationWhereInput;
	ContinuousBenefitFinancialDataPointsRelationship: ResolverTypeWrapper<ContinuousBenefitFinancialDataPointsRelationship>;
	ContinuousBenefitFinancialDataPointsUpdateConnectionInput: ContinuousBenefitFinancialDataPointsUpdateConnectionInput;
	ContinuousBenefitFinancialDataPointsUpdateFieldInput: ContinuousBenefitFinancialDataPointsUpdateFieldInput;
	ContinuousBenefitFormAggregateInput: ContinuousBenefitFormAggregateInput;
	ContinuousBenefitFormConnectFieldInput: ContinuousBenefitFormConnectFieldInput;
	ContinuousBenefitFormConnection: ResolverTypeWrapper<ContinuousBenefitFormConnection>;
	ContinuousBenefitFormConnectionSort: ContinuousBenefitFormConnectionSort;
	ContinuousBenefitFormConnectionWhere: ContinuousBenefitFormConnectionWhere;
	ContinuousBenefitFormCreateFieldInput: ContinuousBenefitFormCreateFieldInput;
	ContinuousBenefitFormDeleteFieldInput: ContinuousBenefitFormDeleteFieldInput;
	ContinuousBenefitFormDisconnectFieldInput: ContinuousBenefitFormDisconnectFieldInput;
	ContinuousBenefitFormFieldInput: ContinuousBenefitFormFieldInput;
	ContinuousBenefitFormNodeAggregationWhereInput: ContinuousBenefitFormNodeAggregationWhereInput;
	ContinuousBenefitFormRelationship: ResolverTypeWrapper<ContinuousBenefitFormRelationship>;
	ContinuousBenefitFormUpdateConnectionInput: ContinuousBenefitFormUpdateConnectionInput;
	ContinuousBenefitFormUpdateFieldInput: ContinuousBenefitFormUpdateFieldInput;
	ContinuousBenefitInitialResponseAggregateInput: ContinuousBenefitInitialResponseAggregateInput;
	ContinuousBenefitInitialResponseConnectFieldInput: ContinuousBenefitInitialResponseConnectFieldInput;
	ContinuousBenefitInitialResponseConnection: ResolverTypeWrapper<ContinuousBenefitInitialResponseConnection>;
	ContinuousBenefitInitialResponseConnectionSort: ContinuousBenefitInitialResponseConnectionSort;
	ContinuousBenefitInitialResponseConnectionWhere: ContinuousBenefitInitialResponseConnectionWhere;
	ContinuousBenefitInitialResponseCreateFieldInput: ContinuousBenefitInitialResponseCreateFieldInput;
	ContinuousBenefitInitialResponseDeleteFieldInput: ContinuousBenefitInitialResponseDeleteFieldInput;
	ContinuousBenefitInitialResponseDisconnectFieldInput: ContinuousBenefitInitialResponseDisconnectFieldInput;
	ContinuousBenefitInitialResponseFieldInput: ContinuousBenefitInitialResponseFieldInput;
	ContinuousBenefitInitialResponseNodeAggregationWhereInput: ContinuousBenefitInitialResponseNodeAggregationWhereInput;
	ContinuousBenefitInitialResponseRelationship: ResolverTypeWrapper<ContinuousBenefitInitialResponseRelationship>;
	ContinuousBenefitInitialResponseUpdateConnectionInput: ContinuousBenefitInitialResponseUpdateConnectionInput;
	ContinuousBenefitInitialResponseUpdateFieldInput: ContinuousBenefitInitialResponseUpdateFieldInput;
	ContinuousBenefitInput: ContinuousBenefitInput;
	ContinuousBenefitOptions: ContinuousBenefitOptions;
	ContinuousBenefitPrescribedTreatmentsAggregateInput: ContinuousBenefitPrescribedTreatmentsAggregateInput;
	ContinuousBenefitPrescribedTreatmentsConnectFieldInput: ContinuousBenefitPrescribedTreatmentsConnectFieldInput;
	ContinuousBenefitPrescribedTreatmentsConnection: ResolverTypeWrapper<ContinuousBenefitPrescribedTreatmentsConnection>;
	ContinuousBenefitPrescribedTreatmentsConnectionSort: ContinuousBenefitPrescribedTreatmentsConnectionSort;
	ContinuousBenefitPrescribedTreatmentsConnectionWhere: ContinuousBenefitPrescribedTreatmentsConnectionWhere;
	ContinuousBenefitPrescribedTreatmentsCreateFieldInput: ContinuousBenefitPrescribedTreatmentsCreateFieldInput;
	ContinuousBenefitPrescribedTreatmentsDeleteFieldInput: ContinuousBenefitPrescribedTreatmentsDeleteFieldInput;
	ContinuousBenefitPrescribedTreatmentsDisconnectFieldInput: ContinuousBenefitPrescribedTreatmentsDisconnectFieldInput;
	ContinuousBenefitPrescribedTreatmentsEdgeAggregationWhereInput: ContinuousBenefitPrescribedTreatmentsEdgeAggregationWhereInput;
	ContinuousBenefitPrescribedTreatmentsFieldInput: ContinuousBenefitPrescribedTreatmentsFieldInput;
	ContinuousBenefitPrescribedTreatmentsNodeAggregationWhereInput: ContinuousBenefitPrescribedTreatmentsNodeAggregationWhereInput;
	ContinuousBenefitPrescribedTreatmentsRelationship: ResolverTypeWrapper<ContinuousBenefitPrescribedTreatmentsRelationship>;
	ContinuousBenefitPrescribedTreatmentsUpdateConnectionInput: ContinuousBenefitPrescribedTreatmentsUpdateConnectionInput;
	ContinuousBenefitPrescribedTreatmentsUpdateFieldInput: ContinuousBenefitPrescribedTreatmentsUpdateFieldInput;
	ContinuousBenefitRecordsAggregateInput: ContinuousBenefitRecordsAggregateInput;
	ContinuousBenefitRecordsConnectFieldInput: ContinuousBenefitRecordsConnectFieldInput;
	ContinuousBenefitRecordsConnection: ResolverTypeWrapper<ContinuousBenefitRecordsConnection>;
	ContinuousBenefitRecordsConnectionSort: ContinuousBenefitRecordsConnectionSort;
	ContinuousBenefitRecordsConnectionWhere: ContinuousBenefitRecordsConnectionWhere;
	ContinuousBenefitRecordsCreateFieldInput: ContinuousBenefitRecordsCreateFieldInput;
	ContinuousBenefitRecordsDeleteFieldInput: ContinuousBenefitRecordsDeleteFieldInput;
	ContinuousBenefitRecordsDisconnectFieldInput: ContinuousBenefitRecordsDisconnectFieldInput;
	ContinuousBenefitRecordsFieldInput: ContinuousBenefitRecordsFieldInput;
	ContinuousBenefitRecordsNodeAggregationWhereInput: ContinuousBenefitRecordsNodeAggregationWhereInput;
	ContinuousBenefitRecordsRelationship: ResolverTypeWrapper<ContinuousBenefitRecordsRelationship>;
	ContinuousBenefitRecordsUpdateConnectionInput: ContinuousBenefitRecordsUpdateConnectionInput;
	ContinuousBenefitRecordsUpdateFieldInput: ContinuousBenefitRecordsUpdateFieldInput;
	ContinuousBenefitSort: ContinuousBenefitSort;
	ContinuousBenefitTreatingPhysicianAggregateInput: ContinuousBenefitTreatingPhysicianAggregateInput;
	ContinuousBenefitTreatingPhysicianConnectFieldInput: ContinuousBenefitTreatingPhysicianConnectFieldInput;
	ContinuousBenefitTreatingPhysicianConnection: ResolverTypeWrapper<ContinuousBenefitTreatingPhysicianConnection>;
	ContinuousBenefitTreatingPhysicianConnectionSort: ContinuousBenefitTreatingPhysicianConnectionSort;
	ContinuousBenefitTreatingPhysicianConnectionWhere: ContinuousBenefitTreatingPhysicianConnectionWhere;
	ContinuousBenefitTreatingPhysicianCreateFieldInput: ContinuousBenefitTreatingPhysicianCreateFieldInput;
	ContinuousBenefitTreatingPhysicianDeleteFieldInput: ContinuousBenefitTreatingPhysicianDeleteFieldInput;
	ContinuousBenefitTreatingPhysicianDisconnectFieldInput: ContinuousBenefitTreatingPhysicianDisconnectFieldInput;
	ContinuousBenefitTreatingPhysicianFieldInput: ContinuousBenefitTreatingPhysicianFieldInput;
	ContinuousBenefitTreatingPhysicianNodeAggregationWhereInput: ContinuousBenefitTreatingPhysicianNodeAggregationWhereInput;
	ContinuousBenefitTreatingPhysicianRelationship: ResolverTypeWrapper<ContinuousBenefitTreatingPhysicianRelationship>;
	ContinuousBenefitTreatingPhysicianUpdateConnectionInput: ContinuousBenefitTreatingPhysicianUpdateConnectionInput;
	ContinuousBenefitTreatingPhysicianUpdateFieldInput: ContinuousBenefitTreatingPhysicianUpdateFieldInput;
	ContinuousBenefitUpdateInput: ContinuousBenefitUpdateInput;
	ContinuousBenefitWhere: ContinuousBenefitWhere;
	ContractNotification: ResolverTypeWrapper<ContractNotification>;
	ContractNotificationAggregateSelection: ResolverTypeWrapper<ContractNotificationAggregateSelection>;
	ContractNotificationConnectInput: ContractNotificationConnectInput;
	ContractNotificationConnectWhere: ContractNotificationConnectWhere;
	ContractNotificationCreateInput: ContractNotificationCreateInput;
	ContractNotificationDeleteInput: ContractNotificationDeleteInput;
	ContractNotificationDisconnectInput: ContractNotificationDisconnectInput;
	ContractNotificationInput: ContractNotificationInput;
	ContractNotificationOptions: ContractNotificationOptions;
	ContractNotificationSort: ContractNotificationSort;
	ContractNotificationTriggersAggregateInput: ContractNotificationTriggersAggregateInput;
	ContractNotificationTriggersConnectFieldInput: ContractNotificationTriggersConnectFieldInput;
	ContractNotificationTriggersConnection: ResolverTypeWrapper<ContractNotificationTriggersConnection>;
	ContractNotificationTriggersConnectionSort: ContractNotificationTriggersConnectionSort;
	ContractNotificationTriggersConnectionWhere: ContractNotificationTriggersConnectionWhere;
	ContractNotificationTriggersCreateFieldInput: ContractNotificationTriggersCreateFieldInput;
	ContractNotificationTriggersDeleteFieldInput: ContractNotificationTriggersDeleteFieldInput;
	ContractNotificationTriggersDisconnectFieldInput: ContractNotificationTriggersDisconnectFieldInput;
	ContractNotificationTriggersFieldInput: ContractNotificationTriggersFieldInput;
	ContractNotificationTriggersNodeAggregationWhereInput: ContractNotificationTriggersNodeAggregationWhereInput;
	ContractNotificationTriggersRelationship: ResolverTypeWrapper<ContractNotificationTriggersRelationship>;
	ContractNotificationTriggersUpdateConnectionInput: ContractNotificationTriggersUpdateConnectionInput;
	ContractNotificationTriggersUpdateFieldInput: ContractNotificationTriggersUpdateFieldInput;
	ContractNotificationUpdateInput: ContractNotificationUpdateInput;
	ContractNotificationWhere: ContractNotificationWhere;
	ContractNotificationsInput: ContractNotificationsInput;
	ContractPartType: ContractPartType;
	ContractStatus: ContractStatus;
	ContractWorkflow: ResolverTypeWrapper<ContractWorkflow>;
	ContractWorkflowAggregateSelection: ResolverTypeWrapper<ContractWorkflowAggregateSelection>;
	ContractWorkflowConnectInput: ContractWorkflowConnectInput;
	ContractWorkflowConnectWhere: ContractWorkflowConnectWhere;
	ContractWorkflowCreateInput: ContractWorkflowCreateInput;
	ContractWorkflowDeleteInput: ContractWorkflowDeleteInput;
	ContractWorkflowDisconnectInput: ContractWorkflowDisconnectInput;
	ContractWorkflowInput: ContractWorkflowInput;
	ContractWorkflowOptions: ContractWorkflowOptions;
	ContractWorkflowOrganizationAggregateInput: ContractWorkflowOrganizationAggregateInput;
	ContractWorkflowOrganizationConnectFieldInput: ContractWorkflowOrganizationConnectFieldInput;
	ContractWorkflowOrganizationConnection: ResolverTypeWrapper<ContractWorkflowOrganizationConnection>;
	ContractWorkflowOrganizationConnectionSort: ContractWorkflowOrganizationConnectionSort;
	ContractWorkflowOrganizationConnectionWhere: ContractWorkflowOrganizationConnectionWhere;
	ContractWorkflowOrganizationCreateFieldInput: ContractWorkflowOrganizationCreateFieldInput;
	ContractWorkflowOrganizationDeleteFieldInput: ContractWorkflowOrganizationDeleteFieldInput;
	ContractWorkflowOrganizationDisconnectFieldInput: ContractWorkflowOrganizationDisconnectFieldInput;
	ContractWorkflowOrganizationFieldInput: ContractWorkflowOrganizationFieldInput;
	ContractWorkflowOrganizationNodeAggregationWhereInput: ContractWorkflowOrganizationNodeAggregationWhereInput;
	ContractWorkflowOrganizationRelationship: ResolverTypeWrapper<ContractWorkflowOrganizationRelationship>;
	ContractWorkflowOrganizationUpdateConnectionInput: ContractWorkflowOrganizationUpdateConnectionInput;
	ContractWorkflowOrganizationUpdateFieldInput: ContractWorkflowOrganizationUpdateFieldInput;
	ContractWorkflowSort: ContractWorkflowSort;
	ContractWorkflowStatus: ContractWorkflowStatus;
	ContractWorkflowStep: ResolverTypeWrapper<ContractWorkflowStep>;
	ContractWorkflowStepAggregateSelection: ResolverTypeWrapper<ContractWorkflowStepAggregateSelection>;
	ContractWorkflowStepConnectInput: ContractWorkflowStepConnectInput;
	ContractWorkflowStepConnectWhere: ContractWorkflowStepConnectWhere;
	ContractWorkflowStepCreateInput: ContractWorkflowStepCreateInput;
	ContractWorkflowStepDeleteInput: ContractWorkflowStepDeleteInput;
	ContractWorkflowStepDisconnectInput: ContractWorkflowStepDisconnectInput;
	ContractWorkflowStepInput: ContractWorkflowStepInput;
	ContractWorkflowStepOptions: ContractWorkflowStepOptions;
	ContractWorkflowStepResponsiblePersonAggregateInput: ContractWorkflowStepResponsiblePersonAggregateInput;
	ContractWorkflowStepResponsiblePersonConnectFieldInput: ContractWorkflowStepResponsiblePersonConnectFieldInput;
	ContractWorkflowStepResponsiblePersonConnection: ResolverTypeWrapper<ContractWorkflowStepResponsiblePersonConnection>;
	ContractWorkflowStepResponsiblePersonConnectionSort: ContractWorkflowStepResponsiblePersonConnectionSort;
	ContractWorkflowStepResponsiblePersonConnectionWhere: ContractWorkflowStepResponsiblePersonConnectionWhere;
	ContractWorkflowStepResponsiblePersonCreateFieldInput: ContractWorkflowStepResponsiblePersonCreateFieldInput;
	ContractWorkflowStepResponsiblePersonDeleteFieldInput: ContractWorkflowStepResponsiblePersonDeleteFieldInput;
	ContractWorkflowStepResponsiblePersonDisconnectFieldInput: ContractWorkflowStepResponsiblePersonDisconnectFieldInput;
	ContractWorkflowStepResponsiblePersonFieldInput: ContractWorkflowStepResponsiblePersonFieldInput;
	ContractWorkflowStepResponsiblePersonNodeAggregationWhereInput: ContractWorkflowStepResponsiblePersonNodeAggregationWhereInput;
	ContractWorkflowStepResponsiblePersonRelationship: ResolverTypeWrapper<ContractWorkflowStepResponsiblePersonRelationship>;
	ContractWorkflowStepResponsiblePersonUpdateConnectionInput: ContractWorkflowStepResponsiblePersonUpdateConnectionInput;
	ContractWorkflowStepResponsiblePersonUpdateFieldInput: ContractWorkflowStepResponsiblePersonUpdateFieldInput;
	ContractWorkflowStepSort: ContractWorkflowStepSort;
	ContractWorkflowStepType: ContractWorkflowStepType;
	ContractWorkflowStepUpdateInput: ContractWorkflowStepUpdateInput;
	ContractWorkflowStepWhere: ContractWorkflowStepWhere;
	ContractWorkflowStepsAggregateInput: ContractWorkflowStepsAggregateInput;
	ContractWorkflowStepsConnectFieldInput: ContractWorkflowStepsConnectFieldInput;
	ContractWorkflowStepsConnection: ResolverTypeWrapper<ContractWorkflowStepsConnection>;
	ContractWorkflowStepsConnectionSort: ContractWorkflowStepsConnectionSort;
	ContractWorkflowStepsConnectionWhere: ContractWorkflowStepsConnectionWhere;
	ContractWorkflowStepsCreateFieldInput: ContractWorkflowStepsCreateFieldInput;
	ContractWorkflowStepsDeleteFieldInput: ContractWorkflowStepsDeleteFieldInput;
	ContractWorkflowStepsDisconnectFieldInput: ContractWorkflowStepsDisconnectFieldInput;
	ContractWorkflowStepsFieldInput: ContractWorkflowStepsFieldInput;
	ContractWorkflowStepsNodeAggregationWhereInput: ContractWorkflowStepsNodeAggregationWhereInput;
	ContractWorkflowStepsRelationship: ResolverTypeWrapper<ContractWorkflowStepsRelationship>;
	ContractWorkflowStepsUpdateConnectionInput: ContractWorkflowStepsUpdateConnectionInput;
	ContractWorkflowStepsUpdateFieldInput: ContractWorkflowStepsUpdateFieldInput;
	ContractWorkflowType: ContractWorkflowType;
	ContractWorkflowUpdateInput: ContractWorkflowUpdateInput;
	ContractWorkflowWhere: ContractWorkflowWhere;
	CounterpartyRole: CounterpartyRole;
	CounterpartyRoleRelationship: ResolversTypes["AgreementCounterpartyRolesRelationship"];
	CounterpartyRoleRelationshipCreateInput: CounterpartyRoleRelationshipCreateInput;
	CounterpartyRoleRelationshipSort: CounterpartyRoleRelationshipSort;
	CounterpartyRoleRelationshipUpdateInput: CounterpartyRoleRelationshipUpdateInput;
	CounterpartyRoleRelationshipWhere: CounterpartyRoleRelationshipWhere;
	CoverageRequest: ResolverTypeWrapper<CoverageRequest>;
	CoverageRequestAggregateSelection: ResolverTypeWrapper<CoverageRequestAggregateSelection>;
	CoverageRequestCaseAggregateInput: CoverageRequestCaseAggregateInput;
	CoverageRequestCaseConnectFieldInput: CoverageRequestCaseConnectFieldInput;
	CoverageRequestCaseConnection: ResolverTypeWrapper<CoverageRequestCaseConnection>;
	CoverageRequestCaseConnectionSort: CoverageRequestCaseConnectionSort;
	CoverageRequestCaseConnectionWhere: CoverageRequestCaseConnectionWhere;
	CoverageRequestCaseCreateFieldInput: CoverageRequestCaseCreateFieldInput;
	CoverageRequestCaseDeleteFieldInput: CoverageRequestCaseDeleteFieldInput;
	CoverageRequestCaseDisconnectFieldInput: CoverageRequestCaseDisconnectFieldInput;
	CoverageRequestCaseFieldInput: CoverageRequestCaseFieldInput;
	CoverageRequestCaseNodeAggregationWhereInput: CoverageRequestCaseNodeAggregationWhereInput;
	CoverageRequestCaseRelationship: ResolverTypeWrapper<CoverageRequestCaseRelationship>;
	CoverageRequestCaseUpdateConnectionInput: CoverageRequestCaseUpdateConnectionInput;
	CoverageRequestCaseUpdateFieldInput: CoverageRequestCaseUpdateFieldInput;
	CoverageRequestConnectInput: CoverageRequestConnectInput;
	CoverageRequestConnectWhere: CoverageRequestConnectWhere;
	CoverageRequestContinuousBenefitsWithDraftsAggregateInput: CoverageRequestContinuousBenefitsWithDraftsAggregateInput;
	CoverageRequestContinuousBenefitsWithDraftsConnectFieldInput: CoverageRequestContinuousBenefitsWithDraftsConnectFieldInput;
	CoverageRequestContinuousBenefitsWithDraftsConnection: ResolverTypeWrapper<CoverageRequestContinuousBenefitsWithDraftsConnection>;
	CoverageRequestContinuousBenefitsWithDraftsConnectionSort: CoverageRequestContinuousBenefitsWithDraftsConnectionSort;
	CoverageRequestContinuousBenefitsWithDraftsConnectionWhere: CoverageRequestContinuousBenefitsWithDraftsConnectionWhere;
	CoverageRequestContinuousBenefitsWithDraftsCreateFieldInput: CoverageRequestContinuousBenefitsWithDraftsCreateFieldInput;
	CoverageRequestContinuousBenefitsWithDraftsDeleteFieldInput: CoverageRequestContinuousBenefitsWithDraftsDeleteFieldInput;
	CoverageRequestContinuousBenefitsWithDraftsDisconnectFieldInput: CoverageRequestContinuousBenefitsWithDraftsDisconnectFieldInput;
	CoverageRequestContinuousBenefitsWithDraftsFieldInput: CoverageRequestContinuousBenefitsWithDraftsFieldInput;
	CoverageRequestContinuousBenefitsWithDraftsNodeAggregationWhereInput: CoverageRequestContinuousBenefitsWithDraftsNodeAggregationWhereInput;
	CoverageRequestContinuousBenefitsWithDraftsRelationship: ResolverTypeWrapper<CoverageRequestContinuousBenefitsWithDraftsRelationship>;
	CoverageRequestContinuousBenefitsWithDraftsUpdateConnectionInput: CoverageRequestContinuousBenefitsWithDraftsUpdateConnectionInput;
	CoverageRequestContinuousBenefitsWithDraftsUpdateFieldInput: CoverageRequestContinuousBenefitsWithDraftsUpdateFieldInput;
	CoverageRequestCreateInput: CoverageRequestCreateInput;
	CoverageRequestCreatedByAggregateInput: CoverageRequestCreatedByAggregateInput;
	CoverageRequestCreatedByConnectFieldInput: CoverageRequestCreatedByConnectFieldInput;
	CoverageRequestCreatedByConnection: ResolverTypeWrapper<CoverageRequestCreatedByConnection>;
	CoverageRequestCreatedByConnectionSort: CoverageRequestCreatedByConnectionSort;
	CoverageRequestCreatedByConnectionWhere: CoverageRequestCreatedByConnectionWhere;
	CoverageRequestCreatedByCreateFieldInput: CoverageRequestCreatedByCreateFieldInput;
	CoverageRequestCreatedByDeleteFieldInput: CoverageRequestCreatedByDeleteFieldInput;
	CoverageRequestCreatedByDisconnectFieldInput: CoverageRequestCreatedByDisconnectFieldInput;
	CoverageRequestCreatedByFieldInput: CoverageRequestCreatedByFieldInput;
	CoverageRequestCreatedByNodeAggregationWhereInput: CoverageRequestCreatedByNodeAggregationWhereInput;
	CoverageRequestCreatedByRelationship: ResolverTypeWrapper<CoverageRequestCreatedByRelationship>;
	CoverageRequestCreatedByUpdateConnectionInput: CoverageRequestCreatedByUpdateConnectionInput;
	CoverageRequestCreatedByUpdateFieldInput: CoverageRequestCreatedByUpdateFieldInput;
	CoverageRequestDeleteInput: CoverageRequestDeleteInput;
	CoverageRequestDisconnectInput: CoverageRequestDisconnectInput;
	CoverageRequestDiscontinuationNoteAggregateInput: CoverageRequestDiscontinuationNoteAggregateInput;
	CoverageRequestDiscontinuationNoteConnectFieldInput: CoverageRequestDiscontinuationNoteConnectFieldInput;
	CoverageRequestDiscontinuationNoteConnection: ResolverTypeWrapper<CoverageRequestDiscontinuationNoteConnection>;
	CoverageRequestDiscontinuationNoteConnectionSort: CoverageRequestDiscontinuationNoteConnectionSort;
	CoverageRequestDiscontinuationNoteConnectionWhere: CoverageRequestDiscontinuationNoteConnectionWhere;
	CoverageRequestDiscontinuationNoteCreateFieldInput: CoverageRequestDiscontinuationNoteCreateFieldInput;
	CoverageRequestDiscontinuationNoteDeleteFieldInput: CoverageRequestDiscontinuationNoteDeleteFieldInput;
	CoverageRequestDiscontinuationNoteDisconnectFieldInput: CoverageRequestDiscontinuationNoteDisconnectFieldInput;
	CoverageRequestDiscontinuationNoteFieldInput: CoverageRequestDiscontinuationNoteFieldInput;
	CoverageRequestDiscontinuationNoteNodeAggregationWhereInput: CoverageRequestDiscontinuationNoteNodeAggregationWhereInput;
	CoverageRequestDiscontinuationNoteRelationship: ResolverTypeWrapper<CoverageRequestDiscontinuationNoteRelationship>;
	CoverageRequestDiscontinuationNoteUpdateConnectionInput: CoverageRequestDiscontinuationNoteUpdateConnectionInput;
	CoverageRequestDiscontinuationNoteUpdateFieldInput: CoverageRequestDiscontinuationNoteUpdateFieldInput;
	CoverageRequestDiseaseAggregateInput: CoverageRequestDiseaseAggregateInput;
	CoverageRequestDiseaseConnectFieldInput: CoverageRequestDiseaseConnectFieldInput;
	CoverageRequestDiseaseConnection: ResolverTypeWrapper<CoverageRequestDiseaseConnection>;
	CoverageRequestDiseaseConnectionSort: CoverageRequestDiseaseConnectionSort;
	CoverageRequestDiseaseConnectionWhere: CoverageRequestDiseaseConnectionWhere;
	CoverageRequestDiseaseCreateFieldInput: CoverageRequestDiseaseCreateFieldInput;
	CoverageRequestDiseaseDeleteFieldInput: CoverageRequestDiseaseDeleteFieldInput;
	CoverageRequestDiseaseDisconnectFieldInput: CoverageRequestDiseaseDisconnectFieldInput;
	CoverageRequestDiseaseFieldInput: CoverageRequestDiseaseFieldInput;
	CoverageRequestDiseaseNodeAggregationWhereInput: CoverageRequestDiseaseNodeAggregationWhereInput;
	CoverageRequestDiseaseRelationship: ResolverTypeWrapper<CoverageRequestDiseaseRelationship>;
	CoverageRequestDiseaseUpdateConnectionInput: CoverageRequestDiseaseUpdateConnectionInput;
	CoverageRequestDiseaseUpdateFieldInput: CoverageRequestDiseaseUpdateFieldInput;
	CoverageRequestFinancialDataPointsAggregateInput: CoverageRequestFinancialDataPointsAggregateInput;
	CoverageRequestFinancialDataPointsConnectFieldInput: CoverageRequestFinancialDataPointsConnectFieldInput;
	CoverageRequestFinancialDataPointsConnection: ResolverTypeWrapper<CoverageRequestFinancialDataPointsConnection>;
	CoverageRequestFinancialDataPointsConnectionSort: CoverageRequestFinancialDataPointsConnectionSort;
	CoverageRequestFinancialDataPointsConnectionWhere: CoverageRequestFinancialDataPointsConnectionWhere;
	CoverageRequestFinancialDataPointsCreateFieldInput: CoverageRequestFinancialDataPointsCreateFieldInput;
	CoverageRequestFinancialDataPointsDeleteFieldInput: CoverageRequestFinancialDataPointsDeleteFieldInput;
	CoverageRequestFinancialDataPointsDisconnectFieldInput: CoverageRequestFinancialDataPointsDisconnectFieldInput;
	CoverageRequestFinancialDataPointsFieldInput: CoverageRequestFinancialDataPointsFieldInput;
	CoverageRequestFinancialDataPointsNodeAggregationWhereInput: CoverageRequestFinancialDataPointsNodeAggregationWhereInput;
	CoverageRequestFinancialDataPointsRelationship: ResolverTypeWrapper<CoverageRequestFinancialDataPointsRelationship>;
	CoverageRequestFinancialDataPointsUpdateConnectionInput: CoverageRequestFinancialDataPointsUpdateConnectionInput;
	CoverageRequestFinancialDataPointsUpdateFieldInput: CoverageRequestFinancialDataPointsUpdateFieldInput;
	CoverageRequestFormAggregateInput: CoverageRequestFormAggregateInput;
	CoverageRequestFormConnectFieldInput: CoverageRequestFormConnectFieldInput;
	CoverageRequestFormConnection: ResolverTypeWrapper<CoverageRequestFormConnection>;
	CoverageRequestFormConnectionSort: CoverageRequestFormConnectionSort;
	CoverageRequestFormConnectionWhere: CoverageRequestFormConnectionWhere;
	CoverageRequestFormCreateFieldInput: CoverageRequestFormCreateFieldInput;
	CoverageRequestFormDeleteFieldInput: CoverageRequestFormDeleteFieldInput;
	CoverageRequestFormDisconnectFieldInput: CoverageRequestFormDisconnectFieldInput;
	CoverageRequestFormFieldInput: CoverageRequestFormFieldInput;
	CoverageRequestFormNodeAggregationWhereInput: CoverageRequestFormNodeAggregationWhereInput;
	CoverageRequestFormRelationship: ResolverTypeWrapper<CoverageRequestFormRelationship>;
	CoverageRequestFormUpdateConnectionInput: CoverageRequestFormUpdateConnectionInput;
	CoverageRequestFormUpdateFieldInput: CoverageRequestFormUpdateFieldInput;
	CoverageRequestIndicationAggregateInput: CoverageRequestIndicationAggregateInput;
	CoverageRequestIndicationConnectFieldInput: CoverageRequestIndicationConnectFieldInput;
	CoverageRequestIndicationConnection: ResolverTypeWrapper<CoverageRequestIndicationConnection>;
	CoverageRequestIndicationConnectionSort: CoverageRequestIndicationConnectionSort;
	CoverageRequestIndicationConnectionWhere: CoverageRequestIndicationConnectionWhere;
	CoverageRequestIndicationCreateFieldInput: CoverageRequestIndicationCreateFieldInput;
	CoverageRequestIndicationDeleteFieldInput: CoverageRequestIndicationDeleteFieldInput;
	CoverageRequestIndicationDisconnectFieldInput: CoverageRequestIndicationDisconnectFieldInput;
	CoverageRequestIndicationFieldInput: CoverageRequestIndicationFieldInput;
	CoverageRequestIndicationNodeAggregationWhereInput: CoverageRequestIndicationNodeAggregationWhereInput;
	CoverageRequestIndicationRelationship: ResolverTypeWrapper<CoverageRequestIndicationRelationship>;
	CoverageRequestIndicationUpdateConnectionInput: CoverageRequestIndicationUpdateConnectionInput;
	CoverageRequestIndicationUpdateFieldInput: CoverageRequestIndicationUpdateFieldInput;
	CoverageRequestInitialResponseAggregateInput: CoverageRequestInitialResponseAggregateInput;
	CoverageRequestInitialResponseConnectFieldInput: CoverageRequestInitialResponseConnectFieldInput;
	CoverageRequestInitialResponseConnection: ResolverTypeWrapper<CoverageRequestInitialResponseConnection>;
	CoverageRequestInitialResponseConnectionSort: CoverageRequestInitialResponseConnectionSort;
	CoverageRequestInitialResponseConnectionWhere: CoverageRequestInitialResponseConnectionWhere;
	CoverageRequestInitialResponseCreateFieldInput: CoverageRequestInitialResponseCreateFieldInput;
	CoverageRequestInitialResponseDeleteFieldInput: CoverageRequestInitialResponseDeleteFieldInput;
	CoverageRequestInitialResponseDisconnectFieldInput: CoverageRequestInitialResponseDisconnectFieldInput;
	CoverageRequestInitialResponseFieldInput: CoverageRequestInitialResponseFieldInput;
	CoverageRequestInitialResponseNodeAggregationWhereInput: CoverageRequestInitialResponseNodeAggregationWhereInput;
	CoverageRequestInitialResponseRelationship: ResolverTypeWrapper<CoverageRequestInitialResponseRelationship>;
	CoverageRequestInitialResponseUpdateConnectionInput: CoverageRequestInitialResponseUpdateConnectionInput;
	CoverageRequestInitialResponseUpdateFieldInput: CoverageRequestInitialResponseUpdateFieldInput;
	CoverageRequestInput: CoverageRequestInput;
	CoverageRequestLegalEntityAggregateInput: CoverageRequestLegalEntityAggregateInput;
	CoverageRequestLegalEntityConnectFieldInput: CoverageRequestLegalEntityConnectFieldInput;
	CoverageRequestLegalEntityConnection: ResolverTypeWrapper<CoverageRequestLegalEntityConnection>;
	CoverageRequestLegalEntityConnectionSort: CoverageRequestLegalEntityConnectionSort;
	CoverageRequestLegalEntityConnectionWhere: CoverageRequestLegalEntityConnectionWhere;
	CoverageRequestLegalEntityCreateFieldInput: CoverageRequestLegalEntityCreateFieldInput;
	CoverageRequestLegalEntityDeleteFieldInput: CoverageRequestLegalEntityDeleteFieldInput;
	CoverageRequestLegalEntityDisconnectFieldInput: CoverageRequestLegalEntityDisconnectFieldInput;
	CoverageRequestLegalEntityFieldInput: CoverageRequestLegalEntityFieldInput;
	CoverageRequestLegalEntityNodeAggregationWhereInput: CoverageRequestLegalEntityNodeAggregationWhereInput;
	CoverageRequestLegalEntityRelationship: ResolverTypeWrapper<CoverageRequestLegalEntityRelationship>;
	CoverageRequestLegalEntityUpdateConnectionInput: CoverageRequestLegalEntityUpdateConnectionInput;
	CoverageRequestLegalEntityUpdateFieldInput: CoverageRequestLegalEntityUpdateFieldInput;
	CoverageRequestOptions: CoverageRequestOptions;
	CoverageRequestPatientAggregateInput: CoverageRequestPatientAggregateInput;
	CoverageRequestPatientConnectFieldInput: CoverageRequestPatientConnectFieldInput;
	CoverageRequestPatientConnection: ResolverTypeWrapper<CoverageRequestPatientConnection>;
	CoverageRequestPatientConnectionSort: CoverageRequestPatientConnectionSort;
	CoverageRequestPatientConnectionWhere: CoverageRequestPatientConnectionWhere;
	CoverageRequestPatientCreateFieldInput: CoverageRequestPatientCreateFieldInput;
	CoverageRequestPatientDeleteFieldInput: CoverageRequestPatientDeleteFieldInput;
	CoverageRequestPatientDisconnectFieldInput: CoverageRequestPatientDisconnectFieldInput;
	CoverageRequestPatientFieldInput: CoverageRequestPatientFieldInput;
	CoverageRequestPatientFormDataInput: CoverageRequestPatientFormDataInput;
	CoverageRequestPatientNodeAggregationWhereInput: CoverageRequestPatientNodeAggregationWhereInput;
	CoverageRequestPatientRelationship: ResolverTypeWrapper<CoverageRequestPatientRelationship>;
	CoverageRequestPatientUpdateConnectionInput: CoverageRequestPatientUpdateConnectionInput;
	CoverageRequestPatientUpdateFieldInput: CoverageRequestPatientUpdateFieldInput;
	CoverageRequestPreparationFormDataInput: CoverageRequestPreparationFormDataInput;
	CoverageRequestPreparationsAggregateInput: CoverageRequestPreparationsAggregateInput;
	CoverageRequestPreparationsConnectFieldInput: CoverageRequestPreparationsConnectFieldInput;
	CoverageRequestPreparationsConnection: ResolverTypeWrapper<CoverageRequestPreparationsConnection>;
	CoverageRequestPreparationsConnectionSort: CoverageRequestPreparationsConnectionSort;
	CoverageRequestPreparationsConnectionWhere: CoverageRequestPreparationsConnectionWhere;
	CoverageRequestPreparationsCreateFieldInput: CoverageRequestPreparationsCreateFieldInput;
	CoverageRequestPreparationsDeleteFieldInput: CoverageRequestPreparationsDeleteFieldInput;
	CoverageRequestPreparationsDisconnectFieldInput: CoverageRequestPreparationsDisconnectFieldInput;
	CoverageRequestPreparationsFieldInput: CoverageRequestPreparationsFieldInput;
	CoverageRequestPreparationsNodeAggregationWhereInput: CoverageRequestPreparationsNodeAggregationWhereInput;
	CoverageRequestPreparationsRelationship: ResolverTypeWrapper<CoverageRequestPreparationsRelationship>;
	CoverageRequestPreparationsUpdateConnectionInput: CoverageRequestPreparationsUpdateConnectionInput;
	CoverageRequestPreparationsUpdateFieldInput: CoverageRequestPreparationsUpdateFieldInput;
	CoverageRequestRating: CoverageRequestRating;
	CoverageRequestSort: CoverageRequestSort;
	CoverageRequestTherapyDecision: CoverageRequestTherapyDecision;
	CoverageRequestTreatingPhysicianAggregateInput: CoverageRequestTreatingPhysicianAggregateInput;
	CoverageRequestTreatingPhysicianConnectFieldInput: CoverageRequestTreatingPhysicianConnectFieldInput;
	CoverageRequestTreatingPhysicianConnection: ResolverTypeWrapper<CoverageRequestTreatingPhysicianConnection>;
	CoverageRequestTreatingPhysicianConnectionSort: CoverageRequestTreatingPhysicianConnectionSort;
	CoverageRequestTreatingPhysicianConnectionWhere: CoverageRequestTreatingPhysicianConnectionWhere;
	CoverageRequestTreatingPhysicianCreateFieldInput: CoverageRequestTreatingPhysicianCreateFieldInput;
	CoverageRequestTreatingPhysicianDeleteFieldInput: CoverageRequestTreatingPhysicianDeleteFieldInput;
	CoverageRequestTreatingPhysicianDisconnectFieldInput: CoverageRequestTreatingPhysicianDisconnectFieldInput;
	CoverageRequestTreatingPhysicianFieldInput: CoverageRequestTreatingPhysicianFieldInput;
	CoverageRequestTreatingPhysicianNodeAggregationWhereInput: CoverageRequestTreatingPhysicianNodeAggregationWhereInput;
	CoverageRequestTreatingPhysicianRelationship: ResolverTypeWrapper<CoverageRequestTreatingPhysicianRelationship>;
	CoverageRequestTreatingPhysicianUpdateConnectionInput: CoverageRequestTreatingPhysicianUpdateConnectionInput;
	CoverageRequestTreatingPhysicianUpdateFieldInput: CoverageRequestTreatingPhysicianUpdateFieldInput;
	CoverageRequestUnsortedContinuousBenefitsAggregateInput: CoverageRequestUnsortedContinuousBenefitsAggregateInput;
	CoverageRequestUnsortedContinuousBenefitsConnectFieldInput: CoverageRequestUnsortedContinuousBenefitsConnectFieldInput;
	CoverageRequestUnsortedContinuousBenefitsConnection: ResolverTypeWrapper<CoverageRequestUnsortedContinuousBenefitsConnection>;
	CoverageRequestUnsortedContinuousBenefitsConnectionSort: CoverageRequestUnsortedContinuousBenefitsConnectionSort;
	CoverageRequestUnsortedContinuousBenefitsConnectionWhere: CoverageRequestUnsortedContinuousBenefitsConnectionWhere;
	CoverageRequestUnsortedContinuousBenefitsCreateFieldInput: CoverageRequestUnsortedContinuousBenefitsCreateFieldInput;
	CoverageRequestUnsortedContinuousBenefitsDeleteFieldInput: CoverageRequestUnsortedContinuousBenefitsDeleteFieldInput;
	CoverageRequestUnsortedContinuousBenefitsDisconnectFieldInput: CoverageRequestUnsortedContinuousBenefitsDisconnectFieldInput;
	CoverageRequestUnsortedContinuousBenefitsFieldInput: CoverageRequestUnsortedContinuousBenefitsFieldInput;
	CoverageRequestUnsortedContinuousBenefitsNodeAggregationWhereInput: CoverageRequestUnsortedContinuousBenefitsNodeAggregationWhereInput;
	CoverageRequestUnsortedContinuousBenefitsRelationship: ResolverTypeWrapper<CoverageRequestUnsortedContinuousBenefitsRelationship>;
	CoverageRequestUnsortedContinuousBenefitsUpdateConnectionInput: CoverageRequestUnsortedContinuousBenefitsUpdateConnectionInput;
	CoverageRequestUnsortedContinuousBenefitsUpdateFieldInput: CoverageRequestUnsortedContinuousBenefitsUpdateFieldInput;
	CoverageRequestUpdateInput: CoverageRequestUpdateInput;
	CoverageRequestWhere: CoverageRequestWhere;
	CreateAdverseEventsOccurenceReportsMutationResponse: ResolverTypeWrapper<CreateAdverseEventsOccurenceReportsMutationResponse>;
	CreateInfo: ResolverTypeWrapper<CreateInfo>;
	CreateInitialResponseReviewReportsMutationResponse: ResolverTypeWrapper<CreateInitialResponseReviewReportsMutationResponse>;
	CreateReasonOfTreatmentDiscontinuationReportsMutationResponse: ResolverTypeWrapper<CreateReasonOfTreatmentDiscontinuationReportsMutationResponse>;
	CreateRefundThreadMessageInput: CreateRefundThreadMessageInput;
	CreateUsersMutationResponse: ResolverTypeWrapper<CreateUsersMutationResponse>;
	Currency: ResolverTypeWrapper<Currency>;
	CurrencyAggregateSelection: ResolverTypeWrapper<CurrencyAggregateSelection>;
	CurrencyConnectWhere: CurrencyConnectWhere;
	CurrencyCreateInput: CurrencyCreateInput;
	CurrencyInput: CurrencyInput;
	CurrencyOptions: CurrencyOptions;
	CurrencySort: CurrencySort;
	CurrencyUpdateInput: CurrencyUpdateInput;
	CurrencyWhere: CurrencyWhere;
	DataContainer: ResolverTypeWrapper<DataContainer>;
	DataContainerAggregateSelection: ResolverTypeWrapper<DataContainerAggregateSelection>;
	DataContainerConnectInput: DataContainerConnectInput;
	DataContainerConnectWhere: DataContainerConnectWhere;
	DataContainerCreateInput: DataContainerCreateInput;
	DataContainerCreationWay: DataContainerCreationWay;
	DataContainerDeleteInput: DataContainerDeleteInput;
	DataContainerDisconnectInput: DataContainerDisconnectInput;
	DataContainerOptions: DataContainerOptions;
	DataContainerProvidersAggregateInput: DataContainerProvidersAggregateInput;
	DataContainerProvidersConnectFieldInput: DataContainerProvidersConnectFieldInput;
	DataContainerProvidersConnection: ResolverTypeWrapper<DataContainerProvidersConnection>;
	DataContainerProvidersConnectionSort: DataContainerProvidersConnectionSort;
	DataContainerProvidersConnectionWhere: DataContainerProvidersConnectionWhere;
	DataContainerProvidersCreateFieldInput: DataContainerProvidersCreateFieldInput;
	DataContainerProvidersDeleteFieldInput: DataContainerProvidersDeleteFieldInput;
	DataContainerProvidersDisconnectFieldInput: DataContainerProvidersDisconnectFieldInput;
	DataContainerProvidersFieldInput: DataContainerProvidersFieldInput;
	DataContainerProvidersNodeAggregationWhereInput: DataContainerProvidersNodeAggregationWhereInput;
	DataContainerProvidersRelationship: ResolverTypeWrapper<DataContainerProvidersRelationship>;
	DataContainerProvidersUpdateConnectionInput: DataContainerProvidersUpdateConnectionInput;
	DataContainerProvidersUpdateFieldInput: DataContainerProvidersUpdateFieldInput;
	DataContainerSharingTrigger: DataContainerSharingTrigger;
	DataContainerSort: DataContainerSort;
	DataContainerSubType: DataContainerSubType;
	DataContainerType: DataContainerType;
	DataContainerUpdateInput: DataContainerUpdateInput;
	DataContainerWhere: DataContainerWhere;
	DataSource: ResolverTypeWrapper<DataSource>;
	DataSourceAggregateSelection: ResolverTypeWrapper<DataSourceAggregateSelection>;
	DataSourceConnectWhere: DataSourceConnectWhere;
	DataSourceCreateInput: DataSourceCreateInput;
	DataSourceOptions: DataSourceOptions;
	DataSourceSort: DataSourceSort;
	DataSourceUpdateInput: DataSourceUpdateInput;
	DataSourceWhere: DataSourceWhere;
	Date: ResolverTypeWrapper<Scalars["Date"]>;
	DateTime: ResolverTypeWrapper<Scalars["DateTime"]>;
	DateTimeAggregateSelection: ResolverTypeWrapper<DateTimeAggregateSelection>;
	Decision: Decision;
	DefaultUserRoleUpdateInput: DefaultUserRoleUpdateInput;
	DeleteInfo: ResolverTypeWrapper<DeleteInfo>;
	DeleteInvoiceInput: DeleteInvoiceInput;
	DeleteRefundThreadMessageInput: DeleteRefundThreadMessageInput;
	DeviceAlternative: ResolverTypeWrapper<DeviceAlternative>;
	DeviceAlternativeAggregateSelection: ResolverTypeWrapper<DeviceAlternativeAggregateSelection>;
	DeviceAlternativeAlternativesAggregateInput: DeviceAlternativeAlternativesAggregateInput;
	DeviceAlternativeAlternativesConnectFieldInput: DeviceAlternativeAlternativesConnectFieldInput;
	DeviceAlternativeAlternativesConnection: ResolverTypeWrapper<DeviceAlternativeAlternativesConnection>;
	DeviceAlternativeAlternativesConnectionSort: DeviceAlternativeAlternativesConnectionSort;
	DeviceAlternativeAlternativesConnectionWhere: DeviceAlternativeAlternativesConnectionWhere;
	DeviceAlternativeAlternativesCreateFieldInput: DeviceAlternativeAlternativesCreateFieldInput;
	DeviceAlternativeAlternativesDeleteFieldInput: DeviceAlternativeAlternativesDeleteFieldInput;
	DeviceAlternativeAlternativesDisconnectFieldInput: DeviceAlternativeAlternativesDisconnectFieldInput;
	DeviceAlternativeAlternativesFieldInput: DeviceAlternativeAlternativesFieldInput;
	DeviceAlternativeAlternativesNodeAggregationWhereInput: DeviceAlternativeAlternativesNodeAggregationWhereInput;
	DeviceAlternativeAlternativesRelationship: ResolverTypeWrapper<DeviceAlternativeAlternativesRelationship>;
	DeviceAlternativeAlternativesUpdateConnectionInput: DeviceAlternativeAlternativesUpdateConnectionInput;
	DeviceAlternativeAlternativesUpdateFieldInput: DeviceAlternativeAlternativesUpdateFieldInput;
	DeviceAlternativeConnectInput: DeviceAlternativeConnectInput;
	DeviceAlternativeConnectWhere: DeviceAlternativeConnectWhere;
	DeviceAlternativeCreateInput: DeviceAlternativeCreateInput;
	DeviceAlternativeDeleteInput: DeviceAlternativeDeleteInput;
	DeviceAlternativeDeviceProductAggregateInput: DeviceAlternativeDeviceProductAggregateInput;
	DeviceAlternativeDeviceProductConnectFieldInput: DeviceAlternativeDeviceProductConnectFieldInput;
	DeviceAlternativeDeviceProductConnection: ResolverTypeWrapper<DeviceAlternativeDeviceProductConnection>;
	DeviceAlternativeDeviceProductConnectionSort: DeviceAlternativeDeviceProductConnectionSort;
	DeviceAlternativeDeviceProductConnectionWhere: DeviceAlternativeDeviceProductConnectionWhere;
	DeviceAlternativeDeviceProductCreateFieldInput: DeviceAlternativeDeviceProductCreateFieldInput;
	DeviceAlternativeDeviceProductDeleteFieldInput: DeviceAlternativeDeviceProductDeleteFieldInput;
	DeviceAlternativeDeviceProductDisconnectFieldInput: DeviceAlternativeDeviceProductDisconnectFieldInput;
	DeviceAlternativeDeviceProductFieldInput: DeviceAlternativeDeviceProductFieldInput;
	DeviceAlternativeDeviceProductNodeAggregationWhereInput: DeviceAlternativeDeviceProductNodeAggregationWhereInput;
	DeviceAlternativeDeviceProductRelationship: ResolverTypeWrapper<DeviceAlternativeDeviceProductRelationship>;
	DeviceAlternativeDeviceProductUpdateConnectionInput: DeviceAlternativeDeviceProductUpdateConnectionInput;
	DeviceAlternativeDeviceProductUpdateFieldInput: DeviceAlternativeDeviceProductUpdateFieldInput;
	DeviceAlternativeDisconnectInput: DeviceAlternativeDisconnectInput;
	DeviceAlternativeOptions: DeviceAlternativeOptions;
	DeviceAlternativeSort: DeviceAlternativeSort;
	DeviceAlternativeUpdateInput: DeviceAlternativeUpdateInput;
	DeviceAlternativeWhere: DeviceAlternativeWhere;
	DeviceFinancialDataPoint: ResolverTypeWrapper<DeviceFinancialDataPoint>;
	DeviceFinancialDataPointAggregateSelection: ResolverTypeWrapper<DeviceFinancialDataPointAggregateSelection>;
	DeviceFinancialDataPointConnectInput: DeviceFinancialDataPointConnectInput;
	DeviceFinancialDataPointConnectWhere: DeviceFinancialDataPointConnectWhere;
	DeviceFinancialDataPointCreateInput: DeviceFinancialDataPointCreateInput;
	DeviceFinancialDataPointDeleteInput: DeviceFinancialDataPointDeleteInput;
	DeviceFinancialDataPointDisconnectInput: DeviceFinancialDataPointDisconnectInput;
	DeviceFinancialDataPointOptions: DeviceFinancialDataPointOptions;
	DeviceFinancialDataPointProcessedDeviceRecordAggregateInput: DeviceFinancialDataPointProcessedDeviceRecordAggregateInput;
	DeviceFinancialDataPointProcessedDeviceRecordConnectFieldInput: DeviceFinancialDataPointProcessedDeviceRecordConnectFieldInput;
	DeviceFinancialDataPointProcessedDeviceRecordConnection: ResolverTypeWrapper<DeviceFinancialDataPointProcessedDeviceRecordConnection>;
	DeviceFinancialDataPointProcessedDeviceRecordConnectionSort: DeviceFinancialDataPointProcessedDeviceRecordConnectionSort;
	DeviceFinancialDataPointProcessedDeviceRecordConnectionWhere: DeviceFinancialDataPointProcessedDeviceRecordConnectionWhere;
	DeviceFinancialDataPointProcessedDeviceRecordCreateFieldInput: DeviceFinancialDataPointProcessedDeviceRecordCreateFieldInput;
	DeviceFinancialDataPointProcessedDeviceRecordDeleteFieldInput: DeviceFinancialDataPointProcessedDeviceRecordDeleteFieldInput;
	DeviceFinancialDataPointProcessedDeviceRecordDisconnectFieldInput: DeviceFinancialDataPointProcessedDeviceRecordDisconnectFieldInput;
	DeviceFinancialDataPointProcessedDeviceRecordFieldInput: DeviceFinancialDataPointProcessedDeviceRecordFieldInput;
	DeviceFinancialDataPointProcessedDeviceRecordRelationship: ResolverTypeWrapper<DeviceFinancialDataPointProcessedDeviceRecordRelationship>;
	DeviceFinancialDataPointProcessedDeviceRecordUpdateConnectionInput: DeviceFinancialDataPointProcessedDeviceRecordUpdateConnectionInput;
	DeviceFinancialDataPointProcessedDeviceRecordUpdateFieldInput: DeviceFinancialDataPointProcessedDeviceRecordUpdateFieldInput;
	DeviceFinancialDataPointSort: DeviceFinancialDataPointSort;
	DeviceFinancialDataPointUpdateInput: DeviceFinancialDataPointUpdateInput;
	DeviceFinancialDataPointWhere: DeviceFinancialDataPointWhere;
	DeviceKit: ResolverTypeWrapper<DeviceKit>;
	DeviceKitAggregateSelection: ResolverTypeWrapper<DeviceKitAggregateSelection>;
	DeviceKitConnectWhere: DeviceKitConnectWhere;
	DeviceKitCreateInput: DeviceKitCreateInput;
	DeviceKitOptions: DeviceKitOptions;
	DeviceKitSort: DeviceKitSort;
	DeviceKitUpdateInput: DeviceKitUpdateInput;
	DeviceKitWhere: DeviceKitWhere;
	DeviceProductCategory: ResolverTypeWrapper<DeviceProductCategory>;
	DeviceProductCategoryAggregateSelection: ResolverTypeWrapper<DeviceProductCategoryAggregateSelection>;
	DeviceProductCategoryConnectInput: DeviceProductCategoryConnectInput;
	DeviceProductCategoryConnectWhere: DeviceProductCategoryConnectWhere;
	DeviceProductCategoryCreateInput: DeviceProductCategoryCreateInput;
	DeviceProductCategoryDeleteInput: DeviceProductCategoryDeleteInput;
	DeviceProductCategoryDisconnectInput: DeviceProductCategoryDisconnectInput;
	DeviceProductCategoryOptions: DeviceProductCategoryOptions;
	DeviceProductCategoryParentAggregateInput: DeviceProductCategoryParentAggregateInput;
	DeviceProductCategoryParentConnectFieldInput: DeviceProductCategoryParentConnectFieldInput;
	DeviceProductCategoryParentConnection: ResolverTypeWrapper<DeviceProductCategoryParentConnection>;
	DeviceProductCategoryParentConnectionSort: DeviceProductCategoryParentConnectionSort;
	DeviceProductCategoryParentConnectionWhere: DeviceProductCategoryParentConnectionWhere;
	DeviceProductCategoryParentCreateFieldInput: DeviceProductCategoryParentCreateFieldInput;
	DeviceProductCategoryParentDeleteFieldInput: DeviceProductCategoryParentDeleteFieldInput;
	DeviceProductCategoryParentDisconnectFieldInput: DeviceProductCategoryParentDisconnectFieldInput;
	DeviceProductCategoryParentFieldInput: DeviceProductCategoryParentFieldInput;
	DeviceProductCategoryParentNodeAggregationWhereInput: DeviceProductCategoryParentNodeAggregationWhereInput;
	DeviceProductCategoryParentRelationship: ResolverTypeWrapper<DeviceProductCategoryParentRelationship>;
	DeviceProductCategoryParentUpdateConnectionInput: DeviceProductCategoryParentUpdateConnectionInput;
	DeviceProductCategoryParentUpdateFieldInput: DeviceProductCategoryParentUpdateFieldInput;
	DeviceProductCategorySort: DeviceProductCategorySort;
	DeviceProductCategoryUpdateInput: DeviceProductCategoryUpdateInput;
	DeviceProductCategoryWhere: DeviceProductCategoryWhere;
	DeviceProvider: ResolverTypeWrapper<DeviceProvider>;
	DeviceProviderAggregateSelection: ResolverTypeWrapper<DeviceProviderAggregateSelection>;
	DeviceProviderConnectWhere: DeviceProviderConnectWhere;
	DeviceProviderCreateInput: DeviceProviderCreateInput;
	DeviceProviderOptions: DeviceProviderOptions;
	DeviceProviderSort: DeviceProviderSort;
	DeviceProviderUpdateInput: DeviceProviderUpdateInput;
	DeviceProviderWhere: DeviceProviderWhere;
	DeviceRecord: ResolverTypeWrapper<DeviceRecord>;
	DeviceRecordAggregateSelection: ResolverTypeWrapper<DeviceRecordAggregateSelection>;
	DeviceRecordCategoryAggregateInput: DeviceRecordCategoryAggregateInput;
	DeviceRecordCategoryConnectFieldInput: DeviceRecordCategoryConnectFieldInput;
	DeviceRecordCategoryConnection: ResolverTypeWrapper<DeviceRecordCategoryConnection>;
	DeviceRecordCategoryConnectionSort: DeviceRecordCategoryConnectionSort;
	DeviceRecordCategoryConnectionWhere: DeviceRecordCategoryConnectionWhere;
	DeviceRecordCategoryCreateFieldInput: DeviceRecordCategoryCreateFieldInput;
	DeviceRecordCategoryDeleteFieldInput: DeviceRecordCategoryDeleteFieldInput;
	DeviceRecordCategoryDisconnectFieldInput: DeviceRecordCategoryDisconnectFieldInput;
	DeviceRecordCategoryFieldInput: DeviceRecordCategoryFieldInput;
	DeviceRecordCategoryNodeAggregationWhereInput: DeviceRecordCategoryNodeAggregationWhereInput;
	DeviceRecordCategoryRelationship: ResolverTypeWrapper<DeviceRecordCategoryRelationship>;
	DeviceRecordCategoryUpdateConnectionInput: DeviceRecordCategoryUpdateConnectionInput;
	DeviceRecordCategoryUpdateFieldInput: DeviceRecordCategoryUpdateFieldInput;
	DeviceRecordConnectInput: DeviceRecordConnectInput;
	DeviceRecordConnectWhere: DeviceRecordConnectWhere;
	DeviceRecordCreateInput: DeviceRecordCreateInput;
	DeviceRecordDeleteInput: DeviceRecordDeleteInput;
	DeviceRecordDisconnectInput: DeviceRecordDisconnectInput;
	DeviceRecordOptions: DeviceRecordOptions;
	DeviceRecordProcessedAsAggregateInput: DeviceRecordProcessedAsAggregateInput;
	DeviceRecordProcessedAsConnectFieldInput: DeviceRecordProcessedAsConnectFieldInput;
	DeviceRecordProcessedAsConnection: ResolverTypeWrapper<DeviceRecordProcessedAsConnection>;
	DeviceRecordProcessedAsConnectionSort: DeviceRecordProcessedAsConnectionSort;
	DeviceRecordProcessedAsConnectionWhere: DeviceRecordProcessedAsConnectionWhere;
	DeviceRecordProcessedAsCreateFieldInput: DeviceRecordProcessedAsCreateFieldInput;
	DeviceRecordProcessedAsDeleteFieldInput: DeviceRecordProcessedAsDeleteFieldInput;
	DeviceRecordProcessedAsDisconnectFieldInput: DeviceRecordProcessedAsDisconnectFieldInput;
	DeviceRecordProcessedAsFieldInput: DeviceRecordProcessedAsFieldInput;
	DeviceRecordProcessedAsRelationship: ResolverTypeWrapper<DeviceRecordProcessedAsRelationship>;
	DeviceRecordProcessedAsUpdateConnectionInput: DeviceRecordProcessedAsUpdateConnectionInput;
	DeviceRecordProcessedAsUpdateFieldInput: DeviceRecordProcessedAsUpdateFieldInput;
	DeviceRecordProviderAggregateInput: DeviceRecordProviderAggregateInput;
	DeviceRecordProviderConnectFieldInput: DeviceRecordProviderConnectFieldInput;
	DeviceRecordProviderConnection: ResolverTypeWrapper<DeviceRecordProviderConnection>;
	DeviceRecordProviderConnectionSort: DeviceRecordProviderConnectionSort;
	DeviceRecordProviderConnectionWhere: DeviceRecordProviderConnectionWhere;
	DeviceRecordProviderCreateFieldInput: DeviceRecordProviderCreateFieldInput;
	DeviceRecordProviderDeleteFieldInput: DeviceRecordProviderDeleteFieldInput;
	DeviceRecordProviderDisconnectFieldInput: DeviceRecordProviderDisconnectFieldInput;
	DeviceRecordProviderFieldInput: DeviceRecordProviderFieldInput;
	DeviceRecordProviderNodeAggregationWhereInput: DeviceRecordProviderNodeAggregationWhereInput;
	DeviceRecordProviderRelationship: ResolverTypeWrapper<DeviceRecordProviderRelationship>;
	DeviceRecordProviderUpdateConnectionInput: DeviceRecordProviderUpdateConnectionInput;
	DeviceRecordProviderUpdateFieldInput: DeviceRecordProviderUpdateFieldInput;
	DeviceRecordRecordAggregateInput: DeviceRecordRecordAggregateInput;
	DeviceRecordRecordConnectFieldInput: DeviceRecordRecordConnectFieldInput;
	DeviceRecordRecordConnection: ResolverTypeWrapper<DeviceRecordRecordConnection>;
	DeviceRecordRecordConnectionSort: DeviceRecordRecordConnectionSort;
	DeviceRecordRecordConnectionWhere: DeviceRecordRecordConnectionWhere;
	DeviceRecordRecordCreateFieldInput: DeviceRecordRecordCreateFieldInput;
	DeviceRecordRecordDeleteFieldInput: DeviceRecordRecordDeleteFieldInput;
	DeviceRecordRecordDisconnectFieldInput: DeviceRecordRecordDisconnectFieldInput;
	DeviceRecordRecordFieldInput: DeviceRecordRecordFieldInput;
	DeviceRecordRecordNodeAggregationWhereInput: DeviceRecordRecordNodeAggregationWhereInput;
	DeviceRecordRecordRelationship: ResolverTypeWrapper<DeviceRecordRecordRelationship>;
	DeviceRecordRecordUpdateConnectionInput: DeviceRecordRecordUpdateConnectionInput;
	DeviceRecordRecordUpdateFieldInput: DeviceRecordRecordUpdateFieldInput;
	DeviceRecordSort: DeviceRecordSort;
	DeviceRecordUpdateInput: DeviceRecordUpdateInput;
	DeviceRecordWhere: DeviceRecordWhere;
	DiscontinuationNote: ResolverTypeWrapper<DiscontinuationNote>;
	DiscontinuationNoteAggregateSelection: ResolverTypeWrapper<DiscontinuationNoteAggregateSelection>;
	DiscontinuationNoteConnectInput: DiscontinuationNoteConnectInput;
	DiscontinuationNoteConnectWhere: DiscontinuationNoteConnectWhere;
	DiscontinuationNoteCoverageRequestAggregateInput: DiscontinuationNoteCoverageRequestAggregateInput;
	DiscontinuationNoteCoverageRequestConnectFieldInput: DiscontinuationNoteCoverageRequestConnectFieldInput;
	DiscontinuationNoteCoverageRequestConnection: ResolverTypeWrapper<DiscontinuationNoteCoverageRequestConnection>;
	DiscontinuationNoteCoverageRequestConnectionSort: DiscontinuationNoteCoverageRequestConnectionSort;
	DiscontinuationNoteCoverageRequestConnectionWhere: DiscontinuationNoteCoverageRequestConnectionWhere;
	DiscontinuationNoteCoverageRequestCreateFieldInput: DiscontinuationNoteCoverageRequestCreateFieldInput;
	DiscontinuationNoteCoverageRequestDeleteFieldInput: DiscontinuationNoteCoverageRequestDeleteFieldInput;
	DiscontinuationNoteCoverageRequestDisconnectFieldInput: DiscontinuationNoteCoverageRequestDisconnectFieldInput;
	DiscontinuationNoteCoverageRequestFieldInput: DiscontinuationNoteCoverageRequestFieldInput;
	DiscontinuationNoteCoverageRequestNodeAggregationWhereInput: DiscontinuationNoteCoverageRequestNodeAggregationWhereInput;
	DiscontinuationNoteCoverageRequestRelationship: ResolverTypeWrapper<DiscontinuationNoteCoverageRequestRelationship>;
	DiscontinuationNoteCoverageRequestUpdateConnectionInput: DiscontinuationNoteCoverageRequestUpdateConnectionInput;
	DiscontinuationNoteCoverageRequestUpdateFieldInput: DiscontinuationNoteCoverageRequestUpdateFieldInput;
	DiscontinuationNoteCreateInput: DiscontinuationNoteCreateInput;
	DiscontinuationNoteDeleteInput: DiscontinuationNoteDeleteInput;
	DiscontinuationNoteDisconnectInput: DiscontinuationNoteDisconnectInput;
	DiscontinuationNoteFormAggregateInput: DiscontinuationNoteFormAggregateInput;
	DiscontinuationNoteFormConnectFieldInput: DiscontinuationNoteFormConnectFieldInput;
	DiscontinuationNoteFormConnection: ResolverTypeWrapper<DiscontinuationNoteFormConnection>;
	DiscontinuationNoteFormConnectionSort: DiscontinuationNoteFormConnectionSort;
	DiscontinuationNoteFormConnectionWhere: DiscontinuationNoteFormConnectionWhere;
	DiscontinuationNoteFormCreateFieldInput: DiscontinuationNoteFormCreateFieldInput;
	DiscontinuationNoteFormDeleteFieldInput: DiscontinuationNoteFormDeleteFieldInput;
	DiscontinuationNoteFormDisconnectFieldInput: DiscontinuationNoteFormDisconnectFieldInput;
	DiscontinuationNoteFormFieldInput: DiscontinuationNoteFormFieldInput;
	DiscontinuationNoteFormNodeAggregationWhereInput: DiscontinuationNoteFormNodeAggregationWhereInput;
	DiscontinuationNoteFormRelationship: ResolverTypeWrapper<DiscontinuationNoteFormRelationship>;
	DiscontinuationNoteFormUpdateConnectionInput: DiscontinuationNoteFormUpdateConnectionInput;
	DiscontinuationNoteFormUpdateFieldInput: DiscontinuationNoteFormUpdateFieldInput;
	DiscontinuationNoteInput: DiscontinuationNoteInput;
	DiscontinuationNoteOptions: DiscontinuationNoteOptions;
	DiscontinuationNoteSort: DiscontinuationNoteSort;
	DiscontinuationNoteUpdateInput: DiscontinuationNoteUpdateInput;
	DiscontinuationNoteWhere: DiscontinuationNoteWhere;
	Disease: ResolverTypeWrapper<Disease>;
	DiseaseAggregateSelection: ResolverTypeWrapper<DiseaseAggregateSelection>;
	DiseaseConnectWhere: DiseaseConnectWhere;
	DiseaseCreateInput: DiseaseCreateInput;
	DiseaseOptions: DiseaseOptions;
	DiseaseSort: DiseaseSort;
	DiseaseUpdateInput: DiseaseUpdateInput;
	DiseaseWhere: DiseaseWhere;
	Document: ResolverTypeWrapper<Document>;
	DocumentAggregateSelection: ResolverTypeWrapper<DocumentAggregateSelection>;
	DocumentAssignedToAggregateInput: DocumentAssignedToAggregateInput;
	DocumentAssignedToConnectFieldInput: DocumentAssignedToConnectFieldInput;
	DocumentAssignedToConnection: ResolverTypeWrapper<DocumentAssignedToConnection>;
	DocumentAssignedToConnectionSort: DocumentAssignedToConnectionSort;
	DocumentAssignedToConnectionWhere: DocumentAssignedToConnectionWhere;
	DocumentAssignedToCreateFieldInput: DocumentAssignedToCreateFieldInput;
	DocumentAssignedToDeleteFieldInput: DocumentAssignedToDeleteFieldInput;
	DocumentAssignedToDisconnectFieldInput: DocumentAssignedToDisconnectFieldInput;
	DocumentAssignedToFieldInput: DocumentAssignedToFieldInput;
	DocumentAssignedToNodeAggregationWhereInput: DocumentAssignedToNodeAggregationWhereInput;
	DocumentAssignedToRelationship: ResolverTypeWrapper<DocumentAssignedToRelationship>;
	DocumentAssignedToUpdateConnectionInput: DocumentAssignedToUpdateConnectionInput;
	DocumentAssignedToUpdateFieldInput: DocumentAssignedToUpdateFieldInput;
	DocumentConnectInput: DocumentConnectInput;
	DocumentConnectWhere: DocumentConnectWhere;
	DocumentCreateInput: DocumentCreateInput;
	DocumentDeleteInput: DocumentDeleteInput;
	DocumentDisconnectInput: DocumentDisconnectInput;
	DocumentOptions: DocumentOptions;
	DocumentRefundsAggregateInput: DocumentRefundsAggregateInput;
	DocumentRefundsConnectFieldInput: DocumentRefundsConnectFieldInput;
	DocumentRefundsConnection: ResolverTypeWrapper<DocumentRefundsConnection>;
	DocumentRefundsConnectionSort: DocumentRefundsConnectionSort;
	DocumentRefundsConnectionWhere: DocumentRefundsConnectionWhere;
	DocumentRefundsCreateFieldInput: DocumentRefundsCreateFieldInput;
	DocumentRefundsDeleteFieldInput: DocumentRefundsDeleteFieldInput;
	DocumentRefundsDisconnectFieldInput: DocumentRefundsDisconnectFieldInput;
	DocumentRefundsFieldInput: DocumentRefundsFieldInput;
	DocumentRefundsNodeAggregationWhereInput: DocumentRefundsNodeAggregationWhereInput;
	DocumentRefundsRelationship: ResolverTypeWrapper<DocumentRefundsRelationship>;
	DocumentRefundsUpdateConnectionInput: DocumentRefundsUpdateConnectionInput;
	DocumentRefundsUpdateFieldInput: DocumentRefundsUpdateFieldInput;
	DocumentSort: DocumentSort;
	DocumentStatus: DocumentStatus;
	DocumentTagsAggregateInput: DocumentTagsAggregateInput;
	DocumentTagsConnectFieldInput: DocumentTagsConnectFieldInput;
	DocumentTagsConnection: ResolverTypeWrapper<DocumentTagsConnection>;
	DocumentTagsConnectionSort: DocumentTagsConnectionSort;
	DocumentTagsConnectionWhere: DocumentTagsConnectionWhere;
	DocumentTagsCreateFieldInput: DocumentTagsCreateFieldInput;
	DocumentTagsDeleteFieldInput: DocumentTagsDeleteFieldInput;
	DocumentTagsDisconnectFieldInput: DocumentTagsDisconnectFieldInput;
	DocumentTagsFieldInput: DocumentTagsFieldInput;
	DocumentTagsNodeAggregationWhereInput: DocumentTagsNodeAggregationWhereInput;
	DocumentTagsRelationship: ResolverTypeWrapper<DocumentTagsRelationship>;
	DocumentTagsUpdateConnectionInput: DocumentTagsUpdateConnectionInput;
	DocumentTagsUpdateFieldInput: DocumentTagsUpdateFieldInput;
	DocumentType: DocumentType;
	DocumentUpdateInput: DocumentUpdateInput;
	DocumentWhere: DocumentWhere;
	DurationUom: DurationUom;
	EligibilityConditionSet: ResolverTypeWrapper<EligibilityConditionSet>;
	EligibilityConditionSetAggregateSelection: ResolverTypeWrapper<EligibilityConditionSetAggregateSelection>;
	EligibilityConditionSetConnectWhere: EligibilityConditionSetConnectWhere;
	EligibilityConditionSetCreateInput: EligibilityConditionSetCreateInput;
	EligibilityConditionSetOptions: EligibilityConditionSetOptions;
	EligibilityConditionSetSort: EligibilityConditionSetSort;
	EligibilityConditionSetUpdateInput: EligibilityConditionSetUpdateInput;
	EligibilityConditionSetWhere: EligibilityConditionSetWhere;
	EnrollingConditionDiseaseRelationship: ResolversTypes["EnrollingConditionSetDiseasesRelationship"];
	EnrollingConditionDiseaseRelationshipCreateInput: EnrollingConditionDiseaseRelationshipCreateInput;
	EnrollingConditionDiseaseRelationshipSort: EnrollingConditionDiseaseRelationshipSort;
	EnrollingConditionDiseaseRelationshipUpdateInput: EnrollingConditionDiseaseRelationshipUpdateInput;
	EnrollingConditionDiseaseRelationshipWhere: EnrollingConditionDiseaseRelationshipWhere;
	EnrollingConditionSet: ResolverTypeWrapper<EnrollingConditionSet>;
	EnrollingConditionSetAggregateSelection: ResolverTypeWrapper<EnrollingConditionSetAggregateSelection>;
	EnrollingConditionSetAgreementAggregateInput: EnrollingConditionSetAgreementAggregateInput;
	EnrollingConditionSetAgreementConnectFieldInput: EnrollingConditionSetAgreementConnectFieldInput;
	EnrollingConditionSetAgreementConnection: ResolverTypeWrapper<EnrollingConditionSetAgreementConnection>;
	EnrollingConditionSetAgreementConnectionSort: EnrollingConditionSetAgreementConnectionSort;
	EnrollingConditionSetAgreementConnectionWhere: EnrollingConditionSetAgreementConnectionWhere;
	EnrollingConditionSetAgreementCreateFieldInput: EnrollingConditionSetAgreementCreateFieldInput;
	EnrollingConditionSetAgreementDeleteFieldInput: EnrollingConditionSetAgreementDeleteFieldInput;
	EnrollingConditionSetAgreementDisconnectFieldInput: EnrollingConditionSetAgreementDisconnectFieldInput;
	EnrollingConditionSetAgreementFieldInput: EnrollingConditionSetAgreementFieldInput;
	EnrollingConditionSetAgreementNodeAggregationWhereInput: EnrollingConditionSetAgreementNodeAggregationWhereInput;
	EnrollingConditionSetAgreementRelationship: ResolverTypeWrapper<EnrollingConditionSetAgreementRelationship>;
	EnrollingConditionSetAgreementUpdateConnectionInput: EnrollingConditionSetAgreementUpdateConnectionInput;
	EnrollingConditionSetAgreementUpdateFieldInput: EnrollingConditionSetAgreementUpdateFieldInput;
	EnrollingConditionSetConnectInput: EnrollingConditionSetConnectInput;
	EnrollingConditionSetConnectWhere: EnrollingConditionSetConnectWhere;
	EnrollingConditionSetCreateInput: EnrollingConditionSetCreateInput;
	EnrollingConditionSetDeleteInput: EnrollingConditionSetDeleteInput;
	EnrollingConditionSetDisconnectInput: EnrollingConditionSetDisconnectInput;
	EnrollingConditionSetDiseasesAggregateInput: EnrollingConditionSetDiseasesAggregateInput;
	EnrollingConditionSetDiseasesConnectFieldInput: EnrollingConditionSetDiseasesConnectFieldInput;
	EnrollingConditionSetDiseasesConnection: ResolverTypeWrapper<EnrollingConditionSetDiseasesConnection>;
	EnrollingConditionSetDiseasesConnectionSort: EnrollingConditionSetDiseasesConnectionSort;
	EnrollingConditionSetDiseasesConnectionWhere: EnrollingConditionSetDiseasesConnectionWhere;
	EnrollingConditionSetDiseasesCreateFieldInput: EnrollingConditionSetDiseasesCreateFieldInput;
	EnrollingConditionSetDiseasesDeleteFieldInput: EnrollingConditionSetDiseasesDeleteFieldInput;
	EnrollingConditionSetDiseasesDisconnectFieldInput: EnrollingConditionSetDiseasesDisconnectFieldInput;
	EnrollingConditionSetDiseasesEdgeAggregationWhereInput: EnrollingConditionSetDiseasesEdgeAggregationWhereInput;
	EnrollingConditionSetDiseasesFieldInput: EnrollingConditionSetDiseasesFieldInput;
	EnrollingConditionSetDiseasesNodeAggregationWhereInput: EnrollingConditionSetDiseasesNodeAggregationWhereInput;
	EnrollingConditionSetDiseasesRelationship: ResolverTypeWrapper<EnrollingConditionSetDiseasesRelationship>;
	EnrollingConditionSetDiseasesUpdateConnectionInput: EnrollingConditionSetDiseasesUpdateConnectionInput;
	EnrollingConditionSetDiseasesUpdateFieldInput: EnrollingConditionSetDiseasesUpdateFieldInput;
	EnrollingConditionSetIndicationsAggregateInput: EnrollingConditionSetIndicationsAggregateInput;
	EnrollingConditionSetIndicationsConnectFieldInput: EnrollingConditionSetIndicationsConnectFieldInput;
	EnrollingConditionSetIndicationsConnection: ResolverTypeWrapper<EnrollingConditionSetIndicationsConnection>;
	EnrollingConditionSetIndicationsConnectionSort: EnrollingConditionSetIndicationsConnectionSort;
	EnrollingConditionSetIndicationsConnectionWhere: EnrollingConditionSetIndicationsConnectionWhere;
	EnrollingConditionSetIndicationsCreateFieldInput: EnrollingConditionSetIndicationsCreateFieldInput;
	EnrollingConditionSetIndicationsDeleteFieldInput: EnrollingConditionSetIndicationsDeleteFieldInput;
	EnrollingConditionSetIndicationsDisconnectFieldInput: EnrollingConditionSetIndicationsDisconnectFieldInput;
	EnrollingConditionSetIndicationsFieldInput: EnrollingConditionSetIndicationsFieldInput;
	EnrollingConditionSetIndicationsNodeAggregationWhereInput: EnrollingConditionSetIndicationsNodeAggregationWhereInput;
	EnrollingConditionSetIndicationsRelationship: ResolverTypeWrapper<EnrollingConditionSetIndicationsRelationship>;
	EnrollingConditionSetIndicationsUpdateConnectionInput: EnrollingConditionSetIndicationsUpdateConnectionInput;
	EnrollingConditionSetIndicationsUpdateFieldInput: EnrollingConditionSetIndicationsUpdateFieldInput;
	EnrollingConditionSetOptions: EnrollingConditionSetOptions;
	EnrollingConditionSetPreparationsAggregateInput: EnrollingConditionSetPreparationsAggregateInput;
	EnrollingConditionSetPreparationsConnectFieldInput: EnrollingConditionSetPreparationsConnectFieldInput;
	EnrollingConditionSetPreparationsConnection: ResolverTypeWrapper<EnrollingConditionSetPreparationsConnection>;
	EnrollingConditionSetPreparationsConnectionSort: EnrollingConditionSetPreparationsConnectionSort;
	EnrollingConditionSetPreparationsConnectionWhere: EnrollingConditionSetPreparationsConnectionWhere;
	EnrollingConditionSetPreparationsCreateFieldInput: EnrollingConditionSetPreparationsCreateFieldInput;
	EnrollingConditionSetPreparationsDeleteFieldInput: EnrollingConditionSetPreparationsDeleteFieldInput;
	EnrollingConditionSetPreparationsDisconnectFieldInput: EnrollingConditionSetPreparationsDisconnectFieldInput;
	EnrollingConditionSetPreparationsFieldInput: EnrollingConditionSetPreparationsFieldInput;
	EnrollingConditionSetPreparationsNodeAggregationWhereInput: EnrollingConditionSetPreparationsNodeAggregationWhereInput;
	EnrollingConditionSetPreparationsRelationship: ResolverTypeWrapper<EnrollingConditionSetPreparationsRelationship>;
	EnrollingConditionSetPreparationsUpdateConnectionInput: EnrollingConditionSetPreparationsUpdateConnectionInput;
	EnrollingConditionSetPreparationsUpdateFieldInput: EnrollingConditionSetPreparationsUpdateFieldInput;
	EnrollingConditionSetSort: EnrollingConditionSetSort;
	EnrollingConditionSetTreatmentsAggregateInput: EnrollingConditionSetTreatmentsAggregateInput;
	EnrollingConditionSetTreatmentsConnectFieldInput: EnrollingConditionSetTreatmentsConnectFieldInput;
	EnrollingConditionSetTreatmentsConnection: ResolverTypeWrapper<EnrollingConditionSetTreatmentsConnection>;
	EnrollingConditionSetTreatmentsConnectionSort: EnrollingConditionSetTreatmentsConnectionSort;
	EnrollingConditionSetTreatmentsConnectionWhere: EnrollingConditionSetTreatmentsConnectionWhere;
	EnrollingConditionSetTreatmentsCreateFieldInput: EnrollingConditionSetTreatmentsCreateFieldInput;
	EnrollingConditionSetTreatmentsDeleteFieldInput: EnrollingConditionSetTreatmentsDeleteFieldInput;
	EnrollingConditionSetTreatmentsDisconnectFieldInput: EnrollingConditionSetTreatmentsDisconnectFieldInput;
	EnrollingConditionSetTreatmentsFieldInput: EnrollingConditionSetTreatmentsFieldInput;
	EnrollingConditionSetTreatmentsNodeAggregationWhereInput: EnrollingConditionSetTreatmentsNodeAggregationWhereInput;
	EnrollingConditionSetTreatmentsRelationship: ResolverTypeWrapper<EnrollingConditionSetTreatmentsRelationship>;
	EnrollingConditionSetTreatmentsUpdateConnectionInput: EnrollingConditionSetTreatmentsUpdateConnectionInput;
	EnrollingConditionSetTreatmentsUpdateFieldInput: EnrollingConditionSetTreatmentsUpdateFieldInput;
	EnrollingConditionSetUpdateInput: EnrollingConditionSetUpdateInput;
	EnrollingConditionSetWhere: EnrollingConditionSetWhere;
	EnrollingPeriod: ResolverTypeWrapper<EnrollingPeriod>;
	EnrollingPeriodAggregateSelection: ResolverTypeWrapper<EnrollingPeriodAggregateSelection>;
	EnrollingPeriodConnectWhere: EnrollingPeriodConnectWhere;
	EnrollingPeriodCreateInput: EnrollingPeriodCreateInput;
	EnrollingPeriodOptions: EnrollingPeriodOptions;
	EnrollingPeriodSort: EnrollingPeriodSort;
	EnrollingPeriodUpdateInput: EnrollingPeriodUpdateInput;
	EnrollingPeriodWhere: EnrollingPeriodWhere;
	ExFactoryPrice: ResolverTypeWrapper<ExFactoryPrice>;
	ExFactoryPriceAggregateSelection: ResolverTypeWrapper<ExFactoryPriceAggregateSelection>;
	ExFactoryPriceConnectWhere: ExFactoryPriceConnectWhere;
	ExFactoryPriceCreateInput: ExFactoryPriceCreateInput;
	ExFactoryPriceOptions: ExFactoryPriceOptions;
	ExFactoryPriceSort: ExFactoryPriceSort;
	ExFactoryPriceUpdateInput: ExFactoryPriceUpdateInput;
	ExFactoryPriceWhere: ExFactoryPriceWhere;
	FinancialDataPoint: ResolverTypeWrapper<FinancialDataPoint>;
	FinancialDataPointAggregateSelection: ResolverTypeWrapper<FinancialDataPointAggregateSelection>;
	FinancialDataPointAgreementAggregateInput: FinancialDataPointAgreementAggregateInput;
	FinancialDataPointAgreementConnectFieldInput: FinancialDataPointAgreementConnectFieldInput;
	FinancialDataPointAgreementConnection: ResolverTypeWrapper<FinancialDataPointAgreementConnection>;
	FinancialDataPointAgreementConnectionSort: FinancialDataPointAgreementConnectionSort;
	FinancialDataPointAgreementConnectionWhere: FinancialDataPointAgreementConnectionWhere;
	FinancialDataPointAgreementCreateFieldInput: FinancialDataPointAgreementCreateFieldInput;
	FinancialDataPointAgreementDeleteFieldInput: FinancialDataPointAgreementDeleteFieldInput;
	FinancialDataPointAgreementDisconnectFieldInput: FinancialDataPointAgreementDisconnectFieldInput;
	FinancialDataPointAgreementFieldInput: FinancialDataPointAgreementFieldInput;
	FinancialDataPointAgreementNodeAggregationWhereInput: FinancialDataPointAgreementNodeAggregationWhereInput;
	FinancialDataPointAgreementRelationship: ResolverTypeWrapper<FinancialDataPointAgreementRelationship>;
	FinancialDataPointAgreementUpdateConnectionInput: FinancialDataPointAgreementUpdateConnectionInput;
	FinancialDataPointAgreementUpdateFieldInput: FinancialDataPointAgreementUpdateFieldInput;
	FinancialDataPointClaimAggregateInput: FinancialDataPointClaimAggregateInput;
	FinancialDataPointClaimConnectFieldInput: FinancialDataPointClaimConnectFieldInput;
	FinancialDataPointClaimConnection: ResolverTypeWrapper<FinancialDataPointClaimConnection>;
	FinancialDataPointClaimConnectionSort: FinancialDataPointClaimConnectionSort;
	FinancialDataPointClaimConnectionWhere: FinancialDataPointClaimConnectionWhere;
	FinancialDataPointClaimCreateFieldInput: FinancialDataPointClaimCreateFieldInput;
	FinancialDataPointClaimDeleteFieldInput: FinancialDataPointClaimDeleteFieldInput;
	FinancialDataPointClaimDisconnectFieldInput: FinancialDataPointClaimDisconnectFieldInput;
	FinancialDataPointClaimFieldInput: FinancialDataPointClaimFieldInput;
	FinancialDataPointClaimNodeAggregationWhereInput: FinancialDataPointClaimNodeAggregationWhereInput;
	FinancialDataPointClaimRelationship: ResolverTypeWrapper<FinancialDataPointClaimRelationship>;
	FinancialDataPointClaimUpdateConnectionInput: FinancialDataPointClaimUpdateConnectionInput;
	FinancialDataPointClaimUpdateFieldInput: FinancialDataPointClaimUpdateFieldInput;
	FinancialDataPointConnectInput: FinancialDataPointConnectInput;
	FinancialDataPointConnectWhere: FinancialDataPointConnectWhere;
	FinancialDataPointContinuousBenefitAggregateInput: FinancialDataPointContinuousBenefitAggregateInput;
	FinancialDataPointContinuousBenefitConnectFieldInput: FinancialDataPointContinuousBenefitConnectFieldInput;
	FinancialDataPointContinuousBenefitConnection: ResolverTypeWrapper<FinancialDataPointContinuousBenefitConnection>;
	FinancialDataPointContinuousBenefitConnectionSort: FinancialDataPointContinuousBenefitConnectionSort;
	FinancialDataPointContinuousBenefitConnectionWhere: FinancialDataPointContinuousBenefitConnectionWhere;
	FinancialDataPointContinuousBenefitCreateFieldInput: FinancialDataPointContinuousBenefitCreateFieldInput;
	FinancialDataPointContinuousBenefitDeleteFieldInput: FinancialDataPointContinuousBenefitDeleteFieldInput;
	FinancialDataPointContinuousBenefitDisconnectFieldInput: FinancialDataPointContinuousBenefitDisconnectFieldInput;
	FinancialDataPointContinuousBenefitFieldInput: FinancialDataPointContinuousBenefitFieldInput;
	FinancialDataPointContinuousBenefitNodeAggregationWhereInput: FinancialDataPointContinuousBenefitNodeAggregationWhereInput;
	FinancialDataPointContinuousBenefitRelationship: ResolverTypeWrapper<FinancialDataPointContinuousBenefitRelationship>;
	FinancialDataPointContinuousBenefitUpdateConnectionInput: FinancialDataPointContinuousBenefitUpdateConnectionInput;
	FinancialDataPointContinuousBenefitUpdateFieldInput: FinancialDataPointContinuousBenefitUpdateFieldInput;
	FinancialDataPointCoverageRequestAggregateInput: FinancialDataPointCoverageRequestAggregateInput;
	FinancialDataPointCoverageRequestConnectFieldInput: FinancialDataPointCoverageRequestConnectFieldInput;
	FinancialDataPointCoverageRequestConnection: ResolverTypeWrapper<FinancialDataPointCoverageRequestConnection>;
	FinancialDataPointCoverageRequestConnectionSort: FinancialDataPointCoverageRequestConnectionSort;
	FinancialDataPointCoverageRequestConnectionWhere: FinancialDataPointCoverageRequestConnectionWhere;
	FinancialDataPointCoverageRequestCreateFieldInput: FinancialDataPointCoverageRequestCreateFieldInput;
	FinancialDataPointCoverageRequestDeleteFieldInput: FinancialDataPointCoverageRequestDeleteFieldInput;
	FinancialDataPointCoverageRequestDisconnectFieldInput: FinancialDataPointCoverageRequestDisconnectFieldInput;
	FinancialDataPointCoverageRequestFieldInput: FinancialDataPointCoverageRequestFieldInput;
	FinancialDataPointCoverageRequestNodeAggregationWhereInput: FinancialDataPointCoverageRequestNodeAggregationWhereInput;
	FinancialDataPointCoverageRequestRelationship: ResolverTypeWrapper<FinancialDataPointCoverageRequestRelationship>;
	FinancialDataPointCoverageRequestUpdateConnectionInput: FinancialDataPointCoverageRequestUpdateConnectionInput;
	FinancialDataPointCoverageRequestUpdateFieldInput: FinancialDataPointCoverageRequestUpdateFieldInput;
	FinancialDataPointCreateInput: FinancialDataPointCreateInput;
	FinancialDataPointDeleteInput: FinancialDataPointDeleteInput;
	FinancialDataPointDisconnectInput: FinancialDataPointDisconnectInput;
	FinancialDataPointIncludedInAggregateInput: FinancialDataPointIncludedInAggregateInput;
	FinancialDataPointIncludedInConnectFieldInput: FinancialDataPointIncludedInConnectFieldInput;
	FinancialDataPointIncludedInConnection: ResolverTypeWrapper<FinancialDataPointIncludedInConnection>;
	FinancialDataPointIncludedInConnectionSort: FinancialDataPointIncludedInConnectionSort;
	FinancialDataPointIncludedInConnectionWhere: FinancialDataPointIncludedInConnectionWhere;
	FinancialDataPointIncludedInCreateFieldInput: FinancialDataPointIncludedInCreateFieldInput;
	FinancialDataPointIncludedInDeleteFieldInput: FinancialDataPointIncludedInDeleteFieldInput;
	FinancialDataPointIncludedInDisconnectFieldInput: FinancialDataPointIncludedInDisconnectFieldInput;
	FinancialDataPointIncludedInFieldInput: FinancialDataPointIncludedInFieldInput;
	FinancialDataPointIncludedInNodeAggregationWhereInput: FinancialDataPointIncludedInNodeAggregationWhereInput;
	FinancialDataPointIncludedInRelationship: ResolverTypeWrapper<FinancialDataPointIncludedInRelationship>;
	FinancialDataPointIncludedInUpdateConnectionInput: FinancialDataPointIncludedInUpdateConnectionInput;
	FinancialDataPointIncludedInUpdateFieldInput: FinancialDataPointIncludedInUpdateFieldInput;
	FinancialDataPointInput: FinancialDataPointInput;
	FinancialDataPointInterventionAggregateInput: FinancialDataPointInterventionAggregateInput;
	FinancialDataPointInterventionConnectFieldInput: FinancialDataPointInterventionConnectFieldInput;
	FinancialDataPointInterventionConnection: ResolverTypeWrapper<FinancialDataPointInterventionConnection>;
	FinancialDataPointInterventionConnectionSort: FinancialDataPointInterventionConnectionSort;
	FinancialDataPointInterventionConnectionWhere: FinancialDataPointInterventionConnectionWhere;
	FinancialDataPointInterventionCreateFieldInput: FinancialDataPointInterventionCreateFieldInput;
	FinancialDataPointInterventionDeleteFieldInput: FinancialDataPointInterventionDeleteFieldInput;
	FinancialDataPointInterventionDisconnectFieldInput: FinancialDataPointInterventionDisconnectFieldInput;
	FinancialDataPointInterventionFieldInput: FinancialDataPointInterventionFieldInput;
	FinancialDataPointInterventionNodeAggregationWhereInput: FinancialDataPointInterventionNodeAggregationWhereInput;
	FinancialDataPointInterventionRelationship: ResolverTypeWrapper<FinancialDataPointInterventionRelationship>;
	FinancialDataPointInterventionUpdateConnectionInput: FinancialDataPointInterventionUpdateConnectionInput;
	FinancialDataPointInterventionUpdateFieldInput: FinancialDataPointInterventionUpdateFieldInput;
	FinancialDataPointOptions: FinancialDataPointOptions;
	FinancialDataPointSort: FinancialDataPointSort;
	FinancialDataPointSourceRefundAggregateInput: FinancialDataPointSourceRefundAggregateInput;
	FinancialDataPointSourceRefundConnectFieldInput: FinancialDataPointSourceRefundConnectFieldInput;
	FinancialDataPointSourceRefundConnection: ResolverTypeWrapper<FinancialDataPointSourceRefundConnection>;
	FinancialDataPointSourceRefundConnectionSort: FinancialDataPointSourceRefundConnectionSort;
	FinancialDataPointSourceRefundConnectionWhere: FinancialDataPointSourceRefundConnectionWhere;
	FinancialDataPointSourceRefundCreateFieldInput: FinancialDataPointSourceRefundCreateFieldInput;
	FinancialDataPointSourceRefundDeleteFieldInput: FinancialDataPointSourceRefundDeleteFieldInput;
	FinancialDataPointSourceRefundDisconnectFieldInput: FinancialDataPointSourceRefundDisconnectFieldInput;
	FinancialDataPointSourceRefundFieldInput: FinancialDataPointSourceRefundFieldInput;
	FinancialDataPointSourceRefundNodeAggregationWhereInput: FinancialDataPointSourceRefundNodeAggregationWhereInput;
	FinancialDataPointSourceRefundRelationship: ResolverTypeWrapper<FinancialDataPointSourceRefundRelationship>;
	FinancialDataPointSourceRefundUpdateConnectionInput: FinancialDataPointSourceRefundUpdateConnectionInput;
	FinancialDataPointSourceRefundUpdateFieldInput: FinancialDataPointSourceRefundUpdateFieldInput;
	FinancialDataPointStatus: FinancialDataPointStatus;
	FinancialDataPointTreatmentAggregateInput: FinancialDataPointTreatmentAggregateInput;
	FinancialDataPointTreatmentConnectFieldInput: FinancialDataPointTreatmentConnectFieldInput;
	FinancialDataPointTreatmentConnection: ResolverTypeWrapper<FinancialDataPointTreatmentConnection>;
	FinancialDataPointTreatmentConnectionSort: FinancialDataPointTreatmentConnectionSort;
	FinancialDataPointTreatmentConnectionWhere: FinancialDataPointTreatmentConnectionWhere;
	FinancialDataPointTreatmentCreateFieldInput: FinancialDataPointTreatmentCreateFieldInput;
	FinancialDataPointTreatmentDeleteFieldInput: FinancialDataPointTreatmentDeleteFieldInput;
	FinancialDataPointTreatmentDisconnectFieldInput: FinancialDataPointTreatmentDisconnectFieldInput;
	FinancialDataPointTreatmentFieldInput: FinancialDataPointTreatmentFieldInput;
	FinancialDataPointTreatmentNodeAggregationWhereInput: FinancialDataPointTreatmentNodeAggregationWhereInput;
	FinancialDataPointTreatmentRelationship: ResolverTypeWrapper<FinancialDataPointTreatmentRelationship>;
	FinancialDataPointTreatmentUpdateConnectionInput: FinancialDataPointTreatmentUpdateConnectionInput;
	FinancialDataPointTreatmentUpdateFieldInput: FinancialDataPointTreatmentUpdateFieldInput;
	FinancialDataPointUpdateInput: FinancialDataPointUpdateInput;
	FinancialDataPointWhere: FinancialDataPointWhere;
	FinancialReportDataPoint: ResolverTypeWrapper<FinancialReportDataPoint>;
	FinancialReportDataPointAggregateSelection: ResolverTypeWrapper<FinancialReportDataPointAggregateSelection>;
	FinancialReportDataPointOptions: FinancialReportDataPointOptions;
	FinancialReportDataPointSort: FinancialReportDataPointSort;
	FinancialReportDataPointWhere: FinancialReportDataPointWhere;
	FinancialSummaryColumn: ResolverTypeWrapper<FinancialSummaryColumn>;
	FinancialSummaryColumnAggregateSelection: ResolverTypeWrapper<FinancialSummaryColumnAggregateSelection>;
	FinancialSummaryColumnConnectWhere: FinancialSummaryColumnConnectWhere;
	FinancialSummaryColumnCreateInput: FinancialSummaryColumnCreateInput;
	FinancialSummaryColumnName: FinancialSummaryColumnName;
	FinancialSummaryColumnOptions: FinancialSummaryColumnOptions;
	FinancialSummaryColumnSort: FinancialSummaryColumnSort;
	FinancialSummaryColumnUpdateInput: FinancialSummaryColumnUpdateInput;
	FinancialSummaryColumnWhere: FinancialSummaryColumnWhere;
	FinancialSummaryRow: ResolverTypeWrapper<FinancialSummaryRow>;
	FinancialSummaryRowAggregateSelection: ResolverTypeWrapper<FinancialSummaryRowAggregateSelection>;
	FinancialSummaryRowOptions: FinancialSummaryRowOptions;
	FinancialSummaryRowSort: FinancialSummaryRowSort;
	FinancialSummaryRowWhere: FinancialSummaryRowWhere;
	FlexContainerType: FlexContainerType;
	FlexEntity: ResolverTypeWrapper<FlexEntity>;
	FlexEntityAggregateSelection: ResolverTypeWrapper<FlexEntityAggregateSelection>;
	FlexEntityCasesAggregateInput: FlexEntityCasesAggregateInput;
	FlexEntityCasesConnectFieldInput: FlexEntityCasesConnectFieldInput;
	FlexEntityCasesConnection: ResolverTypeWrapper<FlexEntityCasesConnection>;
	FlexEntityCasesConnectionSort: FlexEntityCasesConnectionSort;
	FlexEntityCasesConnectionWhere: FlexEntityCasesConnectionWhere;
	FlexEntityCasesCreateFieldInput: FlexEntityCasesCreateFieldInput;
	FlexEntityCasesDeleteFieldInput: FlexEntityCasesDeleteFieldInput;
	FlexEntityCasesDisconnectFieldInput: FlexEntityCasesDisconnectFieldInput;
	FlexEntityCasesFieldInput: FlexEntityCasesFieldInput;
	FlexEntityCasesNodeAggregationWhereInput: FlexEntityCasesNodeAggregationWhereInput;
	FlexEntityCasesRelationship: ResolverTypeWrapper<FlexEntityCasesRelationship>;
	FlexEntityCasesUpdateConnectionInput: FlexEntityCasesUpdateConnectionInput;
	FlexEntityCasesUpdateFieldInput: FlexEntityCasesUpdateFieldInput;
	FlexEntityChildrenAggregateInput: FlexEntityChildrenAggregateInput;
	FlexEntityChildrenConnectFieldInput: FlexEntityChildrenConnectFieldInput;
	FlexEntityChildrenConnection: ResolverTypeWrapper<FlexEntityChildrenConnection>;
	FlexEntityChildrenConnectionSort: FlexEntityChildrenConnectionSort;
	FlexEntityChildrenConnectionWhere: FlexEntityChildrenConnectionWhere;
	FlexEntityChildrenCreateFieldInput: FlexEntityChildrenCreateFieldInput;
	FlexEntityChildrenDeleteFieldInput: FlexEntityChildrenDeleteFieldInput;
	FlexEntityChildrenDisconnectFieldInput: FlexEntityChildrenDisconnectFieldInput;
	FlexEntityChildrenFieldInput: FlexEntityChildrenFieldInput;
	FlexEntityChildrenNodeAggregationWhereInput: FlexEntityChildrenNodeAggregationWhereInput;
	FlexEntityChildrenRelationship: ResolverTypeWrapper<FlexEntityChildrenRelationship>;
	FlexEntityChildrenUpdateConnectionInput: FlexEntityChildrenUpdateConnectionInput;
	FlexEntityChildrenUpdateFieldInput: FlexEntityChildrenUpdateFieldInput;
	FlexEntityConnectInput: FlexEntityConnectInput;
	FlexEntityConnectWhere: FlexEntityConnectWhere;
	FlexEntityCreateInput: FlexEntityCreateInput;
	FlexEntityCreatedByAggregateInput: FlexEntityCreatedByAggregateInput;
	FlexEntityCreatedByConnectFieldInput: FlexEntityCreatedByConnectFieldInput;
	FlexEntityCreatedByConnection: ResolverTypeWrapper<FlexEntityCreatedByConnection>;
	FlexEntityCreatedByConnectionSort: FlexEntityCreatedByConnectionSort;
	FlexEntityCreatedByConnectionWhere: FlexEntityCreatedByConnectionWhere;
	FlexEntityCreatedByCreateFieldInput: FlexEntityCreatedByCreateFieldInput;
	FlexEntityCreatedByDeleteFieldInput: FlexEntityCreatedByDeleteFieldInput;
	FlexEntityCreatedByDisconnectFieldInput: FlexEntityCreatedByDisconnectFieldInput;
	FlexEntityCreatedByFieldInput: FlexEntityCreatedByFieldInput;
	FlexEntityCreatedByNodeAggregationWhereInput: FlexEntityCreatedByNodeAggregationWhereInput;
	FlexEntityCreatedByRelationship: ResolverTypeWrapper<FlexEntityCreatedByRelationship>;
	FlexEntityCreatedByUpdateConnectionInput: FlexEntityCreatedByUpdateConnectionInput;
	FlexEntityCreatedByUpdateFieldInput: FlexEntityCreatedByUpdateFieldInput;
	FlexEntityDataPointsAggregateInput: FlexEntityDataPointsAggregateInput;
	FlexEntityDataPointsConnectFieldInput: FlexEntityDataPointsConnectFieldInput;
	FlexEntityDataPointsConnection: ResolverTypeWrapper<FlexEntityDataPointsConnection>;
	FlexEntityDataPointsConnectionSort: FlexEntityDataPointsConnectionSort;
	FlexEntityDataPointsConnectionWhere: FlexEntityDataPointsConnectionWhere;
	FlexEntityDataPointsCreateFieldInput: FlexEntityDataPointsCreateFieldInput;
	FlexEntityDataPointsDeleteFieldInput: FlexEntityDataPointsDeleteFieldInput;
	FlexEntityDataPointsDisconnectFieldInput: FlexEntityDataPointsDisconnectFieldInput;
	FlexEntityDataPointsFieldInput: FlexEntityDataPointsFieldInput;
	FlexEntityDataPointsNodeAggregationWhereInput: FlexEntityDataPointsNodeAggregationWhereInput;
	FlexEntityDataPointsRelationship: ResolverTypeWrapper<FlexEntityDataPointsRelationship>;
	FlexEntityDataPointsUpdateConnectionInput: FlexEntityDataPointsUpdateConnectionInput;
	FlexEntityDataPointsUpdateFieldInput: FlexEntityDataPointsUpdateFieldInput;
	FlexEntityDeleteInput: FlexEntityDeleteInput;
	FlexEntityDisconnectInput: FlexEntityDisconnectInput;
	FlexEntityFeature: FlexEntityFeature;
	FlexEntityOptions: FlexEntityOptions;
	SimulatorOptions: SimulatorOptions;
	FlexEntityPatientAggregateInput: FlexEntityPatientAggregateInput;
	FlexEntityPatientConnectFieldInput: FlexEntityPatientConnectFieldInput;
	FlexEntityPatientConnection: ResolverTypeWrapper<FlexEntityPatientConnection>;
	FlexEntityPatientConnectionSort: FlexEntityPatientConnectionSort;
	FlexEntityPatientConnectionWhere: FlexEntityPatientConnectionWhere;
	FlexEntityPatientCreateFieldInput: FlexEntityPatientCreateFieldInput;
	FlexEntityPatientDeleteFieldInput: FlexEntityPatientDeleteFieldInput;
	FlexEntityPatientDisconnectFieldInput: FlexEntityPatientDisconnectFieldInput;
	FlexEntityPatientFieldInput: FlexEntityPatientFieldInput;
	FlexEntityPatientNodeAggregationWhereInput: FlexEntityPatientNodeAggregationWhereInput;
	FlexEntityPatientRelationship: ResolverTypeWrapper<FlexEntityPatientRelationship>;
	FlexEntityPatientUpdateConnectionInput: FlexEntityPatientUpdateConnectionInput;
	FlexEntityPatientUpdateFieldInput: FlexEntityPatientUpdateFieldInput;
	FlexEntitySort: FlexEntitySort;
	FlexEntitySourceAggregateInput: FlexEntitySourceAggregateInput;
	FlexEntitySourceConnectFieldInput: FlexEntitySourceConnectFieldInput;
	FlexEntitySourceConnection: ResolverTypeWrapper<FlexEntitySourceConnection>;
	FlexEntitySourceConnectionSort: FlexEntitySourceConnectionSort;
	FlexEntitySourceConnectionWhere: FlexEntitySourceConnectionWhere;
	FlexEntitySourceCreateFieldInput: FlexEntitySourceCreateFieldInput;
	FlexEntitySourceDeleteFieldInput: FlexEntitySourceDeleteFieldInput;
	FlexEntitySourceDisconnectFieldInput: FlexEntitySourceDisconnectFieldInput;
	FlexEntitySourceFieldInput: FlexEntitySourceFieldInput;
	FlexEntitySourceNodeAggregationWhereInput: FlexEntitySourceNodeAggregationWhereInput;
	FlexEntitySourceRelationship: ResolverTypeWrapper<FlexEntitySourceRelationship>;
	FlexEntitySourceUpdateConnectionInput: FlexEntitySourceUpdateConnectionInput;
	FlexEntitySourceUpdateFieldInput: FlexEntitySourceUpdateFieldInput;
	FlexEntityStartingPointAggregateInput: FlexEntityStartingPointAggregateInput;
	FlexEntityStartingPointConnectFieldInput: FlexEntityStartingPointConnectFieldInput;
	FlexEntityStartingPointConnection: ResolverTypeWrapper<FlexEntityStartingPointConnection>;
	FlexEntityStartingPointConnectionSort: FlexEntityStartingPointConnectionSort;
	FlexEntityStartingPointConnectionWhere: FlexEntityStartingPointConnectionWhere;
	FlexEntityStartingPointCreateFieldInput: FlexEntityStartingPointCreateFieldInput;
	FlexEntityStartingPointDeleteFieldInput: FlexEntityStartingPointDeleteFieldInput;
	FlexEntityStartingPointDisconnectFieldInput: FlexEntityStartingPointDisconnectFieldInput;
	FlexEntityStartingPointFieldInput: FlexEntityStartingPointFieldInput;
	FlexEntityStartingPointNodeAggregationWhereInput: FlexEntityStartingPointNodeAggregationWhereInput;
	FlexEntityStartingPointRelationship: ResolverTypeWrapper<FlexEntityStartingPointRelationship>;
	FlexEntityStartingPointUpdateConnectionInput: FlexEntityStartingPointUpdateConnectionInput;
	FlexEntityStartingPointUpdateFieldInput: FlexEntityStartingPointUpdateFieldInput;
	FlexEntityType: ResolverTypeWrapper<FlexEntityType>;
	FlexEntityTypeAddedByAggregateInput: FlexEntityTypeAddedByAggregateInput;
	FlexEntityTypeAddedByConnectFieldInput: FlexEntityTypeAddedByConnectFieldInput;
	FlexEntityTypeAddedByConnection: ResolverTypeWrapper<FlexEntityTypeAddedByConnection>;
	FlexEntityTypeAddedByConnectionSort: FlexEntityTypeAddedByConnectionSort;
	FlexEntityTypeAddedByConnectionWhere: FlexEntityTypeAddedByConnectionWhere;
	FlexEntityTypeAddedByCreateFieldInput: FlexEntityTypeAddedByCreateFieldInput;
	FlexEntityTypeAddedByDeleteFieldInput: FlexEntityTypeAddedByDeleteFieldInput;
	FlexEntityTypeAddedByDisconnectFieldInput: FlexEntityTypeAddedByDisconnectFieldInput;
	FlexEntityTypeAddedByFieldInput: FlexEntityTypeAddedByFieldInput;
	FlexEntityTypeAddedByNodeAggregationWhereInput: FlexEntityTypeAddedByNodeAggregationWhereInput;
	FlexEntityTypeAddedByRelationship: ResolverTypeWrapper<FlexEntityTypeAddedByRelationship>;
	FlexEntityTypeAddedByUpdateConnectionInput: FlexEntityTypeAddedByUpdateConnectionInput;
	FlexEntityTypeAddedByUpdateFieldInput: FlexEntityTypeAddedByUpdateFieldInput;
	FlexEntityTypeAggregateInput: FlexEntityTypeAggregateInput;
	FlexEntityTypeAggregateSelection: ResolverTypeWrapper<FlexEntityTypeAggregateSelection>;
	FlexEntityTypeConnectFieldInput: FlexEntityTypeConnectFieldInput;
	FlexEntityTypeConnectInput: FlexEntityTypeConnectInput;
	FlexEntityTypeConnectWhere: FlexEntityTypeConnectWhere;
	FlexEntityTypeConnection: ResolverTypeWrapper<FlexEntityTypeConnection>;
	FlexEntityTypeConnectionSort: FlexEntityTypeConnectionSort;
	FlexEntityTypeConnectionWhere: FlexEntityTypeConnectionWhere;
	FlexEntityTypeCreateFieldInput: FlexEntityTypeCreateFieldInput;
	FlexEntityTypeCreateInput: FlexEntityTypeCreateInput;
	FlexEntityTypeDeleteFieldInput: FlexEntityTypeDeleteFieldInput;
	FlexEntityTypeDeleteInput: FlexEntityTypeDeleteInput;
	FlexEntityTypeDisconnectFieldInput: FlexEntityTypeDisconnectFieldInput;
	FlexEntityTypeDisconnectInput: FlexEntityTypeDisconnectInput;
	FlexEntityTypeFieldInput: FlexEntityTypeFieldInput;
	FlexEntityTypeInstancesAggregateInput: FlexEntityTypeInstancesAggregateInput;
	FlexEntityTypeInstancesConnectFieldInput: FlexEntityTypeInstancesConnectFieldInput;
	FlexEntityTypeInstancesConnection: ResolverTypeWrapper<FlexEntityTypeInstancesConnection>;
	FlexEntityTypeInstancesConnectionSort: FlexEntityTypeInstancesConnectionSort;
	FlexEntityTypeInstancesConnectionWhere: FlexEntityTypeInstancesConnectionWhere;
	FlexEntityTypeInstancesCreateFieldInput: FlexEntityTypeInstancesCreateFieldInput;
	FlexEntityTypeInstancesDeleteFieldInput: FlexEntityTypeInstancesDeleteFieldInput;
	FlexEntityTypeInstancesDisconnectFieldInput: FlexEntityTypeInstancesDisconnectFieldInput;
	FlexEntityTypeInstancesFieldInput: FlexEntityTypeInstancesFieldInput;
	FlexEntityTypeInstancesNodeAggregationWhereInput: FlexEntityTypeInstancesNodeAggregationWhereInput;
	FlexEntityTypeInstancesRelationship: ResolverTypeWrapper<FlexEntityTypeInstancesRelationship>;
	FlexEntityTypeInstancesUpdateConnectionInput: FlexEntityTypeInstancesUpdateConnectionInput;
	FlexEntityTypeInstancesUpdateFieldInput: FlexEntityTypeInstancesUpdateFieldInput;
	FlexEntityTypeNodeAggregationWhereInput: FlexEntityTypeNodeAggregationWhereInput;
	FlexEntityTypeOptions: FlexEntityTypeOptions;
	FlexEntityTypeRelationship: ResolverTypeWrapper<FlexEntityTypeRelationship>;
	FlexEntityTypeSort: FlexEntityTypeSort;
	FlexEntityTypeUpdateConnectionInput: FlexEntityTypeUpdateConnectionInput;
	FlexEntityTypeUpdateFieldInput: FlexEntityTypeUpdateFieldInput;
	FlexEntityTypeUpdateInput: FlexEntityTypeUpdateInput;
	FlexEntityTypeWhere: FlexEntityTypeWhere;
	FlexEntityUpdateInput: FlexEntityUpdateInput;
	FlexEntityWhere: FlexEntityWhere;
	FlexFinancialDataPoint: ResolverTypeWrapper<FlexFinancialDataPoint>;
	FlexFinancialDataPointAggregateSelection: ResolverTypeWrapper<FlexFinancialDataPointAggregateSelection>;
	FlexFinancialDataPointAgreementAggregateInput: FlexFinancialDataPointAgreementAggregateInput;
	FlexFinancialDataPointAgreementConnectFieldInput: FlexFinancialDataPointAgreementConnectFieldInput;
	FlexFinancialDataPointAgreementConnection: ResolverTypeWrapper<FlexFinancialDataPointAgreementConnection>;
	FlexFinancialDataPointAgreementConnectionSort: FlexFinancialDataPointAgreementConnectionSort;
	FlexFinancialDataPointAgreementConnectionWhere: FlexFinancialDataPointAgreementConnectionWhere;
	FlexFinancialDataPointAgreementCreateFieldInput: FlexFinancialDataPointAgreementCreateFieldInput;
	FlexFinancialDataPointAgreementDeleteFieldInput: FlexFinancialDataPointAgreementDeleteFieldInput;
	FlexFinancialDataPointAgreementDisconnectFieldInput: FlexFinancialDataPointAgreementDisconnectFieldInput;
	FlexFinancialDataPointAgreementFieldInput: FlexFinancialDataPointAgreementFieldInput;
	FlexFinancialDataPointAgreementNodeAggregationWhereInput: FlexFinancialDataPointAgreementNodeAggregationWhereInput;
	FlexFinancialDataPointAgreementRelationship: ResolverTypeWrapper<FlexFinancialDataPointAgreementRelationship>;
	FlexFinancialDataPointAgreementUpdateConnectionInput: FlexFinancialDataPointAgreementUpdateConnectionInput;
	FlexFinancialDataPointAgreementUpdateFieldInput: FlexFinancialDataPointAgreementUpdateFieldInput;
	FlexFinancialDataPointConnectInput: FlexFinancialDataPointConnectInput;
	FlexFinancialDataPointConnectWhere: FlexFinancialDataPointConnectWhere;
	FlexFinancialDataPointCreateInput: FlexFinancialDataPointCreateInput;
	FlexFinancialDataPointDeleteInput: FlexFinancialDataPointDeleteInput;
	FlexFinancialDataPointDisconnectInput: FlexFinancialDataPointDisconnectInput;
	FlexFinancialDataPointEvaluatesAggregateInput: FlexFinancialDataPointEvaluatesAggregateInput;
	FlexFinancialDataPointEvaluatesConnectFieldInput: FlexFinancialDataPointEvaluatesConnectFieldInput;
	FlexFinancialDataPointEvaluatesConnection: ResolverTypeWrapper<FlexFinancialDataPointEvaluatesConnection>;
	FlexFinancialDataPointEvaluatesConnectionSort: FlexFinancialDataPointEvaluatesConnectionSort;
	FlexFinancialDataPointEvaluatesConnectionWhere: FlexFinancialDataPointEvaluatesConnectionWhere;
	FlexFinancialDataPointEvaluatesCreateFieldInput: FlexFinancialDataPointEvaluatesCreateFieldInput;
	FlexFinancialDataPointEvaluatesDeleteFieldInput: FlexFinancialDataPointEvaluatesDeleteFieldInput;
	FlexFinancialDataPointEvaluatesDisconnectFieldInput: FlexFinancialDataPointEvaluatesDisconnectFieldInput;
	FlexFinancialDataPointEvaluatesFieldInput: FlexFinancialDataPointEvaluatesFieldInput;
	FlexFinancialDataPointEvaluatesNodeAggregationWhereInput: FlexFinancialDataPointEvaluatesNodeAggregationWhereInput;
	FlexFinancialDataPointEvaluatesRelationship: ResolverTypeWrapper<FlexFinancialDataPointEvaluatesRelationship>;
	FlexFinancialDataPointEvaluatesUpdateConnectionInput: FlexFinancialDataPointEvaluatesUpdateConnectionInput;
	FlexFinancialDataPointEvaluatesUpdateFieldInput: FlexFinancialDataPointEvaluatesUpdateFieldInput;
	FlexFinancialDataPointIncludedInAggregateInput: FlexFinancialDataPointIncludedInAggregateInput;
	FlexFinancialDataPointIncludedInConnectFieldInput: FlexFinancialDataPointIncludedInConnectFieldInput;
	FlexFinancialDataPointIncludedInConnection: ResolverTypeWrapper<FlexFinancialDataPointIncludedInConnection>;
	FlexFinancialDataPointIncludedInConnectionSort: FlexFinancialDataPointIncludedInConnectionSort;
	FlexFinancialDataPointIncludedInConnectionWhere: FlexFinancialDataPointIncludedInConnectionWhere;
	FlexFinancialDataPointIncludedInCreateFieldInput: FlexFinancialDataPointIncludedInCreateFieldInput;
	FlexFinancialDataPointIncludedInDeleteFieldInput: FlexFinancialDataPointIncludedInDeleteFieldInput;
	FlexFinancialDataPointIncludedInDisconnectFieldInput: FlexFinancialDataPointIncludedInDisconnectFieldInput;
	FlexFinancialDataPointIncludedInFieldInput: FlexFinancialDataPointIncludedInFieldInput;
	FlexFinancialDataPointIncludedInNodeAggregationWhereInput: FlexFinancialDataPointIncludedInNodeAggregationWhereInput;
	FlexFinancialDataPointIncludedInRelationship: ResolverTypeWrapper<FlexFinancialDataPointIncludedInRelationship>;
	FlexFinancialDataPointIncludedInUpdateConnectionInput: FlexFinancialDataPointIncludedInUpdateConnectionInput;
	FlexFinancialDataPointIncludedInUpdateFieldInput: FlexFinancialDataPointIncludedInUpdateFieldInput;
	FlexFinancialDataPointOptions: FlexFinancialDataPointOptions;
	FlexFinancialDataPointSort: FlexFinancialDataPointSort;
	FlexFinancialDataPointSourceRefundAggregateInput: FlexFinancialDataPointSourceRefundAggregateInput;
	FlexFinancialDataPointSourceRefundConnectFieldInput: FlexFinancialDataPointSourceRefundConnectFieldInput;
	FlexFinancialDataPointSourceRefundConnection: ResolverTypeWrapper<FlexFinancialDataPointSourceRefundConnection>;
	FlexFinancialDataPointSourceRefundConnectionSort: FlexFinancialDataPointSourceRefundConnectionSort;
	FlexFinancialDataPointSourceRefundConnectionWhere: FlexFinancialDataPointSourceRefundConnectionWhere;
	FlexFinancialDataPointSourceRefundCreateFieldInput: FlexFinancialDataPointSourceRefundCreateFieldInput;
	FlexFinancialDataPointSourceRefundDeleteFieldInput: FlexFinancialDataPointSourceRefundDeleteFieldInput;
	FlexFinancialDataPointSourceRefundDisconnectFieldInput: FlexFinancialDataPointSourceRefundDisconnectFieldInput;
	FlexFinancialDataPointSourceRefundFieldInput: FlexFinancialDataPointSourceRefundFieldInput;
	FlexFinancialDataPointSourceRefundNodeAggregationWhereInput: FlexFinancialDataPointSourceRefundNodeAggregationWhereInput;
	FlexFinancialDataPointSourceRefundRelationship: ResolverTypeWrapper<FlexFinancialDataPointSourceRefundRelationship>;
	FlexFinancialDataPointSourceRefundUpdateConnectionInput: FlexFinancialDataPointSourceRefundUpdateConnectionInput;
	FlexFinancialDataPointSourceRefundUpdateFieldInput: FlexFinancialDataPointSourceRefundUpdateFieldInput;
	FlexFinancialDataPointStartingPointAggregateInput: FlexFinancialDataPointStartingPointAggregateInput;
	FlexFinancialDataPointStartingPointConnectFieldInput: FlexFinancialDataPointStartingPointConnectFieldInput;
	FlexFinancialDataPointStartingPointConnection: ResolverTypeWrapper<FlexFinancialDataPointStartingPointConnection>;
	FlexFinancialDataPointStartingPointConnectionSort: FlexFinancialDataPointStartingPointConnectionSort;
	FlexFinancialDataPointStartingPointConnectionWhere: FlexFinancialDataPointStartingPointConnectionWhere;
	FlexFinancialDataPointStartingPointCreateFieldInput: FlexFinancialDataPointStartingPointCreateFieldInput;
	FlexFinancialDataPointStartingPointDeleteFieldInput: FlexFinancialDataPointStartingPointDeleteFieldInput;
	FlexFinancialDataPointStartingPointDisconnectFieldInput: FlexFinancialDataPointStartingPointDisconnectFieldInput;
	FlexFinancialDataPointStartingPointFieldInput: FlexFinancialDataPointStartingPointFieldInput;
	FlexFinancialDataPointStartingPointNodeAggregationWhereInput: FlexFinancialDataPointStartingPointNodeAggregationWhereInput;
	FlexFinancialDataPointStartingPointRelationship: ResolverTypeWrapper<FlexFinancialDataPointStartingPointRelationship>;
	FlexFinancialDataPointStartingPointUpdateConnectionInput: FlexFinancialDataPointStartingPointUpdateConnectionInput;
	FlexFinancialDataPointStartingPointUpdateFieldInput: FlexFinancialDataPointStartingPointUpdateFieldInput;
	FlexFinancialDataPointTreatmentAggregateInput: FlexFinancialDataPointTreatmentAggregateInput;
	FlexFinancialDataPointTreatmentConnectFieldInput: FlexFinancialDataPointTreatmentConnectFieldInput;
	FlexFinancialDataPointTreatmentConnection: ResolverTypeWrapper<FlexFinancialDataPointTreatmentConnection>;
	FlexFinancialDataPointTreatmentConnectionSort: FlexFinancialDataPointTreatmentConnectionSort;
	FlexFinancialDataPointTreatmentConnectionWhere: FlexFinancialDataPointTreatmentConnectionWhere;
	FlexFinancialDataPointTreatmentCreateFieldInput: FlexFinancialDataPointTreatmentCreateFieldInput;
	FlexFinancialDataPointTreatmentDeleteFieldInput: FlexFinancialDataPointTreatmentDeleteFieldInput;
	FlexFinancialDataPointTreatmentDisconnectFieldInput: FlexFinancialDataPointTreatmentDisconnectFieldInput;
	FlexFinancialDataPointTreatmentFieldInput: FlexFinancialDataPointTreatmentFieldInput;
	FlexFinancialDataPointTreatmentNodeAggregationWhereInput: FlexFinancialDataPointTreatmentNodeAggregationWhereInput;
	FlexFinancialDataPointTreatmentRelationship: ResolverTypeWrapper<FlexFinancialDataPointTreatmentRelationship>;
	FlexFinancialDataPointTreatmentUpdateConnectionInput: FlexFinancialDataPointTreatmentUpdateConnectionInput;
	FlexFinancialDataPointTreatmentUpdateFieldInput: FlexFinancialDataPointTreatmentUpdateFieldInput;
	FlexFinancialDataPointUpdateInput: FlexFinancialDataPointUpdateInput;
	FlexFinancialDataPointWhere: FlexFinancialDataPointWhere;
	FlexFormStatus: FlexFormStatus;
	Float: ResolverTypeWrapper<Scalars["Float"]>;
	FloatAggregateSelection: ResolverTypeWrapper<FloatAggregateSelection>;
	Form: ResolverTypeWrapper<Form>;
	FormAggregateSelection: ResolverTypeWrapper<FormAggregateSelection>;
	FormConnectInput: FormConnectInput;
	FormConnectWhere: FormConnectWhere;
	FormContinuousBenefitAggregateInput: FormContinuousBenefitAggregateInput;
	FormContinuousBenefitConnectFieldInput: FormContinuousBenefitConnectFieldInput;
	FormContinuousBenefitConnection: ResolverTypeWrapper<FormContinuousBenefitConnection>;
	FormContinuousBenefitConnectionSort: FormContinuousBenefitConnectionSort;
	FormContinuousBenefitConnectionWhere: FormContinuousBenefitConnectionWhere;
	FormContinuousBenefitCreateFieldInput: FormContinuousBenefitCreateFieldInput;
	FormContinuousBenefitDeleteFieldInput: FormContinuousBenefitDeleteFieldInput;
	FormContinuousBenefitDisconnectFieldInput: FormContinuousBenefitDisconnectFieldInput;
	FormContinuousBenefitFieldInput: FormContinuousBenefitFieldInput;
	FormContinuousBenefitNodeAggregationWhereInput: FormContinuousBenefitNodeAggregationWhereInput;
	FormContinuousBenefitRelationship: ResolverTypeWrapper<FormContinuousBenefitRelationship>;
	FormContinuousBenefitUpdateConnectionInput: FormContinuousBenefitUpdateConnectionInput;
	FormContinuousBenefitUpdateFieldInput: FormContinuousBenefitUpdateFieldInput;
	FormCoverageRequestAggregateInput: FormCoverageRequestAggregateInput;
	FormCoverageRequestConnectFieldInput: FormCoverageRequestConnectFieldInput;
	FormCoverageRequestConnection: ResolverTypeWrapper<FormCoverageRequestConnection>;
	FormCoverageRequestConnectionSort: FormCoverageRequestConnectionSort;
	FormCoverageRequestConnectionWhere: FormCoverageRequestConnectionWhere;
	FormCoverageRequestCreateFieldInput: FormCoverageRequestCreateFieldInput;
	FormCoverageRequestDeleteFieldInput: FormCoverageRequestDeleteFieldInput;
	FormCoverageRequestDisconnectFieldInput: FormCoverageRequestDisconnectFieldInput;
	FormCoverageRequestFieldInput: FormCoverageRequestFieldInput;
	FormCoverageRequestNodeAggregationWhereInput: FormCoverageRequestNodeAggregationWhereInput;
	FormCoverageRequestRelationship: ResolverTypeWrapper<FormCoverageRequestRelationship>;
	FormCoverageRequestUpdateConnectionInput: FormCoverageRequestUpdateConnectionInput;
	FormCoverageRequestUpdateFieldInput: FormCoverageRequestUpdateFieldInput;
	FormCreateInput: FormCreateInput;
	FormDeleteInput: FormDeleteInput;
	FormDisconnectInput: FormDisconnectInput;
	FormDiscontinuationNoteAggregateInput: FormDiscontinuationNoteAggregateInput;
	FormDiscontinuationNoteConnectFieldInput: FormDiscontinuationNoteConnectFieldInput;
	FormDiscontinuationNoteConnection: ResolverTypeWrapper<FormDiscontinuationNoteConnection>;
	FormDiscontinuationNoteConnectionSort: FormDiscontinuationNoteConnectionSort;
	FormDiscontinuationNoteConnectionWhere: FormDiscontinuationNoteConnectionWhere;
	FormDiscontinuationNoteCreateFieldInput: FormDiscontinuationNoteCreateFieldInput;
	FormDiscontinuationNoteDeleteFieldInput: FormDiscontinuationNoteDeleteFieldInput;
	FormDiscontinuationNoteDisconnectFieldInput: FormDiscontinuationNoteDisconnectFieldInput;
	FormDiscontinuationNoteFieldInput: FormDiscontinuationNoteFieldInput;
	FormDiscontinuationNoteNodeAggregationWhereInput: FormDiscontinuationNoteNodeAggregationWhereInput;
	FormDiscontinuationNoteRelationship: ResolverTypeWrapper<FormDiscontinuationNoteRelationship>;
	FormDiscontinuationNoteUpdateConnectionInput: FormDiscontinuationNoteUpdateConnectionInput;
	FormDiscontinuationNoteUpdateFieldInput: FormDiscontinuationNoteUpdateFieldInput;
	FormInitialResponseAggregateInput: FormInitialResponseAggregateInput;
	FormInitialResponseConnectFieldInput: FormInitialResponseConnectFieldInput;
	FormInitialResponseConnection: ResolverTypeWrapper<FormInitialResponseConnection>;
	FormInitialResponseConnectionSort: FormInitialResponseConnectionSort;
	FormInitialResponseConnectionWhere: FormInitialResponseConnectionWhere;
	FormInitialResponseCreateFieldInput: FormInitialResponseCreateFieldInput;
	FormInitialResponseDeleteFieldInput: FormInitialResponseDeleteFieldInput;
	FormInitialResponseDisconnectFieldInput: FormInitialResponseDisconnectFieldInput;
	FormInitialResponseFieldInput: FormInitialResponseFieldInput;
	FormInitialResponseNodeAggregationWhereInput: FormInitialResponseNodeAggregationWhereInput;
	FormInitialResponseRelationship: ResolverTypeWrapper<FormInitialResponseRelationship>;
	FormInitialResponseUpdateConnectionInput: FormInitialResponseUpdateConnectionInput;
	FormInitialResponseUpdateFieldInput: FormInitialResponseUpdateFieldInput;
	FormOptions: FormOptions;
	FormPrimaryInterventionAggregateInput: FormPrimaryInterventionAggregateInput;
	FormPrimaryInterventionConnectFieldInput: FormPrimaryInterventionConnectFieldInput;
	FormPrimaryInterventionConnection: ResolverTypeWrapper<FormPrimaryInterventionConnection>;
	FormPrimaryInterventionConnectionSort: FormPrimaryInterventionConnectionSort;
	FormPrimaryInterventionConnectionWhere: FormPrimaryInterventionConnectionWhere;
	FormPrimaryInterventionCreateFieldInput: FormPrimaryInterventionCreateFieldInput;
	FormPrimaryInterventionDeleteFieldInput: FormPrimaryInterventionDeleteFieldInput;
	FormPrimaryInterventionDisconnectFieldInput: FormPrimaryInterventionDisconnectFieldInput;
	FormPrimaryInterventionFieldInput: FormPrimaryInterventionFieldInput;
	FormPrimaryInterventionNodeAggregationWhereInput: FormPrimaryInterventionNodeAggregationWhereInput;
	FormPrimaryInterventionRelationship: ResolverTypeWrapper<FormPrimaryInterventionRelationship>;
	FormPrimaryInterventionUpdateConnectionInput: FormPrimaryInterventionUpdateConnectionInput;
	FormPrimaryInterventionUpdateFieldInput: FormPrimaryInterventionUpdateFieldInput;
	FormSort: FormSort;
	FormStatus: FormStatus;
	FormSubsequentInterventionAggregateInput: FormSubsequentInterventionAggregateInput;
	FormSubsequentInterventionConnectFieldInput: FormSubsequentInterventionConnectFieldInput;
	FormSubsequentInterventionConnection: ResolverTypeWrapper<FormSubsequentInterventionConnection>;
	FormSubsequentInterventionConnectionSort: FormSubsequentInterventionConnectionSort;
	FormSubsequentInterventionConnectionWhere: FormSubsequentInterventionConnectionWhere;
	FormSubsequentInterventionCreateFieldInput: FormSubsequentInterventionCreateFieldInput;
	FormSubsequentInterventionDeleteFieldInput: FormSubsequentInterventionDeleteFieldInput;
	FormSubsequentInterventionDisconnectFieldInput: FormSubsequentInterventionDisconnectFieldInput;
	FormSubsequentInterventionFieldInput: FormSubsequentInterventionFieldInput;
	FormSubsequentInterventionNodeAggregationWhereInput: FormSubsequentInterventionNodeAggregationWhereInput;
	FormSubsequentInterventionRelationship: ResolverTypeWrapper<FormSubsequentInterventionRelationship>;
	FormSubsequentInterventionUpdateConnectionInput: FormSubsequentInterventionUpdateConnectionInput;
	FormSubsequentInterventionUpdateFieldInput: FormSubsequentInterventionUpdateFieldInput;
	FormType: FormType;
	FormUpdateInput: FormUpdateInput;
	FormWhere: FormWhere;
	GQLBaseResponse: ResolversTypes["InterventionReportStatusResponse"];
	GQLResponseStatus: GqlResponseStatus;
	ID: ResolverTypeWrapper<Scalars["ID"]>;
	IDAggregateSelection: ResolverTypeWrapper<IdAggregateSelection>;
	IOrdered:
		| ResolversTypes["RecommendedForm"]
		| ResolversTypes["StobAction"]
		| ResolversTypes["StobCondition"]
		| ResolversTypes["StobScenario"];
	IRAdverseEventDoseModifications: IrAdverseEventDoseModifications;
	IRAdverseEventGrades: IrAdverseEventGrades;
	IRAdverseEvents: IrAdverseEvents;
	IRResultOptions: IrResultOptions;
	ITimeframe: ResolversTypes["ScenarioAction"] | ResolversTypes["ScenarioCondition"];
	ITreatmentState: ResolversTypes["ContinuousBenefit"] | ResolversTypes["DiscontinuationNote"] | ResolversTypes["InitialResponse"];
	Indication: ResolverTypeWrapper<Indication>;
	IndicationAggregateSelection: ResolverTypeWrapper<IndicationAggregateSelection>;
	IndicationConnectWhere: IndicationConnectWhere;
	IndicationCreateInput: IndicationCreateInput;
	IndicationOptions: IndicationOptions;
	IndicationSort: IndicationSort;
	IndicationUpdateInput: IndicationUpdateInput;
	IndicationWhere: IndicationWhere;
	InitialResponse: ResolverTypeWrapper<InitialResponse>;
	InitialResponseAdverseEventsAggregateInput: InitialResponseAdverseEventsAggregateInput;
	InitialResponseAdverseEventsConnectFieldInput: InitialResponseAdverseEventsConnectFieldInput;
	InitialResponseAdverseEventsConnection: ResolverTypeWrapper<InitialResponseAdverseEventsConnection>;
	InitialResponseAdverseEventsConnectionSort: InitialResponseAdverseEventsConnectionSort;
	InitialResponseAdverseEventsConnectionWhere: InitialResponseAdverseEventsConnectionWhere;
	InitialResponseAdverseEventsCreateFieldInput: InitialResponseAdverseEventsCreateFieldInput;
	InitialResponseAdverseEventsDeleteFieldInput: InitialResponseAdverseEventsDeleteFieldInput;
	InitialResponseAdverseEventsDisconnectFieldInput: InitialResponseAdverseEventsDisconnectFieldInput;
	InitialResponseAdverseEventsFieldInput: InitialResponseAdverseEventsFieldInput;
	InitialResponseAdverseEventsNodeAggregationWhereInput: InitialResponseAdverseEventsNodeAggregationWhereInput;
	InitialResponseAdverseEventsRelationship: ResolverTypeWrapper<InitialResponseAdverseEventsRelationship>;
	InitialResponseAdverseEventsUpdateConnectionInput: InitialResponseAdverseEventsUpdateConnectionInput;
	InitialResponseAdverseEventsUpdateFieldInput: InitialResponseAdverseEventsUpdateFieldInput;
	InitialResponseAggregateSelection: ResolverTypeWrapper<InitialResponseAggregateSelection>;
	InitialResponseConnectInput: InitialResponseConnectInput;
	InitialResponseConnectWhere: InitialResponseConnectWhere;
	InitialResponseContinuousBenefitAggregateInput: InitialResponseContinuousBenefitAggregateInput;
	InitialResponseContinuousBenefitConnectFieldInput: InitialResponseContinuousBenefitConnectFieldInput;
	InitialResponseContinuousBenefitConnection: ResolverTypeWrapper<InitialResponseContinuousBenefitConnection>;
	InitialResponseContinuousBenefitConnectionSort: InitialResponseContinuousBenefitConnectionSort;
	InitialResponseContinuousBenefitConnectionWhere: InitialResponseContinuousBenefitConnectionWhere;
	InitialResponseContinuousBenefitCreateFieldInput: InitialResponseContinuousBenefitCreateFieldInput;
	InitialResponseContinuousBenefitDeleteFieldInput: InitialResponseContinuousBenefitDeleteFieldInput;
	InitialResponseContinuousBenefitDisconnectFieldInput: InitialResponseContinuousBenefitDisconnectFieldInput;
	InitialResponseContinuousBenefitFieldInput: InitialResponseContinuousBenefitFieldInput;
	InitialResponseContinuousBenefitNodeAggregationWhereInput: InitialResponseContinuousBenefitNodeAggregationWhereInput;
	InitialResponseContinuousBenefitRelationship: ResolverTypeWrapper<InitialResponseContinuousBenefitRelationship>;
	InitialResponseContinuousBenefitUpdateConnectionInput: InitialResponseContinuousBenefitUpdateConnectionInput;
	InitialResponseContinuousBenefitUpdateFieldInput: InitialResponseContinuousBenefitUpdateFieldInput;
	InitialResponseCoverageRequestAggregateInput: InitialResponseCoverageRequestAggregateInput;
	InitialResponseCoverageRequestConnectFieldInput: InitialResponseCoverageRequestConnectFieldInput;
	InitialResponseCoverageRequestConnection: ResolverTypeWrapper<InitialResponseCoverageRequestConnection>;
	InitialResponseCoverageRequestConnectionSort: InitialResponseCoverageRequestConnectionSort;
	InitialResponseCoverageRequestConnectionWhere: InitialResponseCoverageRequestConnectionWhere;
	InitialResponseCoverageRequestCreateFieldInput: InitialResponseCoverageRequestCreateFieldInput;
	InitialResponseCoverageRequestDeleteFieldInput: InitialResponseCoverageRequestDeleteFieldInput;
	InitialResponseCoverageRequestDisconnectFieldInput: InitialResponseCoverageRequestDisconnectFieldInput;
	InitialResponseCoverageRequestFieldInput: InitialResponseCoverageRequestFieldInput;
	InitialResponseCoverageRequestNodeAggregationWhereInput: InitialResponseCoverageRequestNodeAggregationWhereInput;
	InitialResponseCoverageRequestRelationship: ResolverTypeWrapper<InitialResponseCoverageRequestRelationship>;
	InitialResponseCoverageRequestUpdateConnectionInput: InitialResponseCoverageRequestUpdateConnectionInput;
	InitialResponseCoverageRequestUpdateFieldInput: InitialResponseCoverageRequestUpdateFieldInput;
	InitialResponseCreateInput: InitialResponseCreateInput;
	InitialResponseDeleteInput: InitialResponseDeleteInput;
	InitialResponseDisconnectInput: InitialResponseDisconnectInput;
	InitialResponseFormAggregateInput: InitialResponseFormAggregateInput;
	InitialResponseFormConnectFieldInput: InitialResponseFormConnectFieldInput;
	InitialResponseFormConnection: ResolverTypeWrapper<InitialResponseFormConnection>;
	InitialResponseFormConnectionSort: InitialResponseFormConnectionSort;
	InitialResponseFormConnectionWhere: InitialResponseFormConnectionWhere;
	InitialResponseFormCreateFieldInput: InitialResponseFormCreateFieldInput;
	InitialResponseFormDeleteFieldInput: InitialResponseFormDeleteFieldInput;
	InitialResponseFormDisconnectFieldInput: InitialResponseFormDisconnectFieldInput;
	InitialResponseFormFieldInput: InitialResponseFormFieldInput;
	InitialResponseFormNodeAggregationWhereInput: InitialResponseFormNodeAggregationWhereInput;
	InitialResponseFormRelationship: ResolverTypeWrapper<InitialResponseFormRelationship>;
	InitialResponseFormUpdateConnectionInput: InitialResponseFormUpdateConnectionInput;
	InitialResponseFormUpdateFieldInput: InitialResponseFormUpdateFieldInput;
	InitialResponseInput: InitialResponseInput;
	InitialResponseOptions: InitialResponseOptions;
	InitialResponseReviewReport: ResolverTypeWrapper<InitialResponseReviewReport>;
	InitialResponseReviewReportAggregateSelection: ResolverTypeWrapper<InitialResponseReviewReportAggregateSelection>;
	InitialResponseReviewReportCreateInput: InitialResponseReviewReportCreateInput;
	InitialResponseReviewReportOptions: InitialResponseReviewReportOptions;
	InitialResponseReviewReportSort: InitialResponseReviewReportSort;
	InitialResponseReviewReportUpdateInput: InitialResponseReviewReportUpdateInput;
	InitialResponseReviewReportWhere: InitialResponseReviewReportWhere;
	InitialResponseSort: InitialResponseSort;
	InitialResponseTreatingPhysicianAggregateInput: InitialResponseTreatingPhysicianAggregateInput;
	InitialResponseTreatingPhysicianConnectFieldInput: InitialResponseTreatingPhysicianConnectFieldInput;
	InitialResponseTreatingPhysicianConnection: ResolverTypeWrapper<InitialResponseTreatingPhysicianConnection>;
	InitialResponseTreatingPhysicianConnectionSort: InitialResponseTreatingPhysicianConnectionSort;
	InitialResponseTreatingPhysicianConnectionWhere: InitialResponseTreatingPhysicianConnectionWhere;
	InitialResponseTreatingPhysicianCreateFieldInput: InitialResponseTreatingPhysicianCreateFieldInput;
	InitialResponseTreatingPhysicianDeleteFieldInput: InitialResponseTreatingPhysicianDeleteFieldInput;
	InitialResponseTreatingPhysicianDisconnectFieldInput: InitialResponseTreatingPhysicianDisconnectFieldInput;
	InitialResponseTreatingPhysicianFieldInput: InitialResponseTreatingPhysicianFieldInput;
	InitialResponseTreatingPhysicianNodeAggregationWhereInput: InitialResponseTreatingPhysicianNodeAggregationWhereInput;
	InitialResponseTreatingPhysicianRelationship: ResolverTypeWrapper<InitialResponseTreatingPhysicianRelationship>;
	InitialResponseTreatingPhysicianUpdateConnectionInput: InitialResponseTreatingPhysicianUpdateConnectionInput;
	InitialResponseTreatingPhysicianUpdateFieldInput: InitialResponseTreatingPhysicianUpdateFieldInput;
	InitialResponseUpdateInput: InitialResponseUpdateInput;
	InitialResponseWhere: InitialResponseWhere;
	Int: ResolverTypeWrapper<Scalars["Int"]>;
	IntAggregateSelection: ResolverTypeWrapper<IntAggregateSelection>;
	Intervention: ResolverTypeWrapper<Intervention>;
	InterventionAggregateSelection: ResolverTypeWrapper<InterventionAggregateSelection>;
	InterventionCaseAggregateInput: InterventionCaseAggregateInput;
	InterventionCaseConnectFieldInput: InterventionCaseConnectFieldInput;
	InterventionCaseConnection: ResolverTypeWrapper<InterventionCaseConnection>;
	InterventionCaseConnectionSort: InterventionCaseConnectionSort;
	InterventionCaseConnectionWhere: InterventionCaseConnectionWhere;
	InterventionCaseCreateFieldInput: InterventionCaseCreateFieldInput;
	InterventionCaseDeleteFieldInput: InterventionCaseDeleteFieldInput;
	InterventionCaseDisconnectFieldInput: InterventionCaseDisconnectFieldInput;
	InterventionCaseFieldInput: InterventionCaseFieldInput;
	InterventionCaseNodeAggregationWhereInput: InterventionCaseNodeAggregationWhereInput;
	InterventionCaseRelationship: ResolverTypeWrapper<InterventionCaseRelationship>;
	InterventionConnectInput: InterventionConnectInput;
	InterventionConnectWhere: InterventionConnectWhere;
	InterventionCreateInput: InterventionCreateInput;
	InterventionCreatedByAggregateInput: InterventionCreatedByAggregateInput;
	InterventionCreatedByConnectFieldInput: InterventionCreatedByConnectFieldInput;
	InterventionCreatedByConnection: ResolverTypeWrapper<InterventionCreatedByConnection>;
	InterventionCreatedByConnectionSort: InterventionCreatedByConnectionSort;
	InterventionCreatedByConnectionWhere: InterventionCreatedByConnectionWhere;
	InterventionCreatedByCreateFieldInput: InterventionCreatedByCreateFieldInput;
	InterventionCreatedByDeleteFieldInput: InterventionCreatedByDeleteFieldInput;
	InterventionCreatedByDisconnectFieldInput: InterventionCreatedByDisconnectFieldInput;
	InterventionCreatedByFieldInput: InterventionCreatedByFieldInput;
	InterventionCreatedByNodeAggregationWhereInput: InterventionCreatedByNodeAggregationWhereInput;
	InterventionCreatedByRelationship: ResolverTypeWrapper<InterventionCreatedByRelationship>;
	InterventionDeleteInput: InterventionDeleteInput;
	InterventionDisconnectInput: InterventionDisconnectInput;
	InterventionDiseaseAggregateInput: InterventionDiseaseAggregateInput;
	InterventionDiseaseConnectFieldInput: InterventionDiseaseConnectFieldInput;
	InterventionDiseaseConnection: ResolverTypeWrapper<InterventionDiseaseConnection>;
	InterventionDiseaseConnectionSort: InterventionDiseaseConnectionSort;
	InterventionDiseaseConnectionWhere: InterventionDiseaseConnectionWhere;
	InterventionDiseaseCreateFieldInput: InterventionDiseaseCreateFieldInput;
	InterventionDiseaseDeleteFieldInput: InterventionDiseaseDeleteFieldInput;
	InterventionDiseaseDisconnectFieldInput: InterventionDiseaseDisconnectFieldInput;
	InterventionDiseaseFieldInput: InterventionDiseaseFieldInput;
	InterventionDiseaseNodeAggregationWhereInput: InterventionDiseaseNodeAggregationWhereInput;
	InterventionDiseaseRelationship: ResolverTypeWrapper<InterventionDiseaseRelationship>;
	InterventionFinancialDataPointsAggregateInput: InterventionFinancialDataPointsAggregateInput;
	InterventionFinancialDataPointsConnectFieldInput: InterventionFinancialDataPointsConnectFieldInput;
	InterventionFinancialDataPointsConnection: ResolverTypeWrapper<InterventionFinancialDataPointsConnection>;
	InterventionFinancialDataPointsConnectionSort: InterventionFinancialDataPointsConnectionSort;
	InterventionFinancialDataPointsConnectionWhere: InterventionFinancialDataPointsConnectionWhere;
	InterventionFinancialDataPointsCreateFieldInput: InterventionFinancialDataPointsCreateFieldInput;
	InterventionFinancialDataPointsDeleteFieldInput: InterventionFinancialDataPointsDeleteFieldInput;
	InterventionFinancialDataPointsDisconnectFieldInput: InterventionFinancialDataPointsDisconnectFieldInput;
	InterventionFinancialDataPointsFieldInput: InterventionFinancialDataPointsFieldInput;
	InterventionFinancialDataPointsNodeAggregationWhereInput: InterventionFinancialDataPointsNodeAggregationWhereInput;
	InterventionFinancialDataPointsRelationship: ResolverTypeWrapper<InterventionFinancialDataPointsRelationship>;
	InterventionFormAggregateInput: InterventionFormAggregateInput;
	InterventionFormConnectFieldInput: InterventionFormConnectFieldInput;
	InterventionFormConnection: ResolverTypeWrapper<InterventionFormConnection>;
	InterventionFormConnectionSort: InterventionFormConnectionSort;
	InterventionFormConnectionWhere: InterventionFormConnectionWhere;
	InterventionFormCreateFieldInput: InterventionFormCreateFieldInput;
	InterventionFormDeleteFieldInput: InterventionFormDeleteFieldInput;
	InterventionFormDisconnectFieldInput: InterventionFormDisconnectFieldInput;
	InterventionFormFieldInput: InterventionFormFieldInput;
	InterventionFormNodeAggregationWhereInput: InterventionFormNodeAggregationWhereInput;
	InterventionFormRelationship: ResolverTypeWrapper<InterventionFormRelationship>;
	InterventionInput: InterventionInput;
	InterventionItemInput: InterventionItemInput;
	InterventionLegalEntityAggregateInput: InterventionLegalEntityAggregateInput;
	InterventionLegalEntityConnectFieldInput: InterventionLegalEntityConnectFieldInput;
	InterventionLegalEntityConnection: ResolverTypeWrapper<InterventionLegalEntityConnection>;
	InterventionLegalEntityConnectionSort: InterventionLegalEntityConnectionSort;
	InterventionLegalEntityConnectionWhere: InterventionLegalEntityConnectionWhere;
	InterventionLegalEntityCreateFieldInput: InterventionLegalEntityCreateFieldInput;
	InterventionLegalEntityDeleteFieldInput: InterventionLegalEntityDeleteFieldInput;
	InterventionLegalEntityDisconnectFieldInput: InterventionLegalEntityDisconnectFieldInput;
	InterventionLegalEntityFieldInput: InterventionLegalEntityFieldInput;
	InterventionLegalEntityNodeAggregationWhereInput: InterventionLegalEntityNodeAggregationWhereInput;
	InterventionLegalEntityRelationship: ResolverTypeWrapper<InterventionLegalEntityRelationship>;
	InterventionMainItemAggregateInput: InterventionMainItemAggregateInput;
	InterventionMainItemConnectFieldInput: InterventionMainItemConnectFieldInput;
	InterventionMainItemConnection: ResolverTypeWrapper<InterventionMainItemConnection>;
	InterventionMainItemConnectionSort: InterventionMainItemConnectionSort;
	InterventionMainItemConnectionWhere: InterventionMainItemConnectionWhere;
	InterventionMainItemCreateFieldInput: InterventionMainItemCreateFieldInput;
	InterventionMainItemDeleteFieldInput: InterventionMainItemDeleteFieldInput;
	InterventionMainItemDisconnectFieldInput: InterventionMainItemDisconnectFieldInput;
	InterventionMainItemEdgeAggregationWhereInput: InterventionMainItemEdgeAggregationWhereInput;
	InterventionMainItemFieldInput: InterventionMainItemFieldInput;
	InterventionMainItemNodeAggregationWhereInput: InterventionMainItemNodeAggregationWhereInput;
	InterventionMainItemRelationship: ResolverTypeWrapper<InterventionMainItemRelationship>;
	InterventionOccurrence: InterventionOccurrence;
	InterventionOptions: InterventionOptions;
	InterventionPatientAggregateInput: InterventionPatientAggregateInput;
	InterventionPatientConnectFieldInput: InterventionPatientConnectFieldInput;
	InterventionPatientConnection: ResolverTypeWrapper<InterventionPatientConnection>;
	InterventionPatientConnectionSort: InterventionPatientConnectionSort;
	InterventionPatientConnectionWhere: InterventionPatientConnectionWhere;
	InterventionPatientCreateFieldInput: InterventionPatientCreateFieldInput;
	InterventionPatientDeleteFieldInput: InterventionPatientDeleteFieldInput;
	InterventionPatientDisconnectFieldInput: InterventionPatientDisconnectFieldInput;
	InterventionPatientFieldInput: InterventionPatientFieldInput;
	InterventionPatientNodeAggregationWhereInput: InterventionPatientNodeAggregationWhereInput;
	InterventionPatientRelationship: ResolverTypeWrapper<InterventionPatientRelationship>;
	InterventionReportStatusResponse: ResolverTypeWrapper<InterventionReportStatusResponse>;
	InterventionReportStatusResponseAggregateSelection: ResolverTypeWrapper<InterventionReportStatusResponseAggregateSelection>;
	InterventionReportStatusResponseOptions: InterventionReportStatusResponseOptions;
	InterventionReportStatusResponseSort: InterventionReportStatusResponseSort;
	InterventionReportStatusResponseWhere: InterventionReportStatusResponseWhere;
	InterventionReportStatusUpdateInput: InterventionReportStatusUpdateInput;
	InterventionSort: InterventionSort;
	InterventionSubsequentInterventionAggregateInput: InterventionSubsequentInterventionAggregateInput;
	InterventionSubsequentInterventionConnectFieldInput: InterventionSubsequentInterventionConnectFieldInput;
	InterventionSubsequentInterventionConnection: ResolverTypeWrapper<InterventionSubsequentInterventionConnection>;
	InterventionSubsequentInterventionConnectionSort: InterventionSubsequentInterventionConnectionSort;
	InterventionSubsequentInterventionConnectionWhere: InterventionSubsequentInterventionConnectionWhere;
	InterventionSubsequentInterventionCreateFieldInput: InterventionSubsequentInterventionCreateFieldInput;
	InterventionSubsequentInterventionDeleteFieldInput: InterventionSubsequentInterventionDeleteFieldInput;
	InterventionSubsequentInterventionDisconnectFieldInput: InterventionSubsequentInterventionDisconnectFieldInput;
	InterventionSubsequentInterventionFieldInput: InterventionSubsequentInterventionFieldInput;
	InterventionSubsequentInterventionNodeAggregationWhereInput: InterventionSubsequentInterventionNodeAggregationWhereInput;
	InterventionSubsequentInterventionRelationship: ResolverTypeWrapper<InterventionSubsequentInterventionRelationship>;
	InterventionSupportingItemAggregateInput: InterventionSupportingItemAggregateInput;
	InterventionSupportingItemConnectFieldInput: InterventionSupportingItemConnectFieldInput;
	InterventionSupportingItemConnection: ResolverTypeWrapper<InterventionSupportingItemConnection>;
	InterventionSupportingItemConnectionSort: InterventionSupportingItemConnectionSort;
	InterventionSupportingItemConnectionWhere: InterventionSupportingItemConnectionWhere;
	InterventionSupportingItemCreateFieldInput: InterventionSupportingItemCreateFieldInput;
	InterventionSupportingItemDeleteFieldInput: InterventionSupportingItemDeleteFieldInput;
	InterventionSupportingItemDisconnectFieldInput: InterventionSupportingItemDisconnectFieldInput;
	InterventionSupportingItemEdgeAggregationWhereInput: InterventionSupportingItemEdgeAggregationWhereInput;
	InterventionSupportingItemFieldInput: InterventionSupportingItemFieldInput;
	InterventionSupportingItemNodeAggregationWhereInput: InterventionSupportingItemNodeAggregationWhereInput;
	InterventionSupportingItemRelationship: ResolverTypeWrapper<InterventionSupportingItemRelationship>;
	InterventionTreatmentRelationship:
		| ResolversTypes["InterventionMainItemRelationship"]
		| ResolversTypes["InterventionSupportingItemRelationship"];
	InterventionTreatmentRelationshipCreateInput: InterventionTreatmentRelationshipCreateInput;
	InterventionTreatmentRelationshipSort: InterventionTreatmentRelationshipSort;
	InterventionTreatmentRelationshipWhere: InterventionTreatmentRelationshipWhere;
	InterventionType: InterventionType;
	InterventionUpdateInput: InterventionUpdateInput;
	InterventionWhere: InterventionWhere;
	InvoiceRefundFinancialDataPoint: ResolversTypes["RefundInvoiceFinancialDataPointsRelationship"];
	InvoiceRefundFinancialDataPointCreateInput: InvoiceRefundFinancialDataPointCreateInput;
	InvoiceRefundFinancialDataPointSort: InvoiceRefundFinancialDataPointSort;
	InvoiceRefundFinancialDataPointUpdateInput: InvoiceRefundFinancialDataPointUpdateInput;
	InvoiceRefundFinancialDataPointWhere: InvoiceRefundFinancialDataPointWhere;
	IssueInvoiceWithoutReviewInput: IssueInvoiceWithoutReviewInput;
	ItemScope: ItemScope;
	ItemUsedDataPoint: ResolverTypeWrapper<ItemUsedDataPoint>;
	ItemUsedDataPointAggregateSelection: ResolverTypeWrapper<ItemUsedDataPointAggregateSelection>;
	ItemUsedDataPointOptions: ItemUsedDataPointOptions;
	ItemUsedDataPointSort: ItemUsedDataPointSort;
	ItemUsedDataPointWhere: ItemUsedDataPointWhere;
	Limitation: ResolverTypeWrapper<Limitation>;
	LimitationAggregateSelection: ResolverTypeWrapper<LimitationAggregateSelection>;
	LimitationConnectInput: LimitationConnectInput;
	LimitationConnectWhere: LimitationConnectWhere;
	LimitationCreateInput: LimitationCreateInput;
	LimitationDeleteInput: LimitationDeleteInput;
	LimitationDisconnectInput: LimitationDisconnectInput;
	LimitationLimitsPreparationsAggregateInput: LimitationLimitsPreparationsAggregateInput;
	LimitationLimitsPreparationsConnectFieldInput: LimitationLimitsPreparationsConnectFieldInput;
	LimitationLimitsPreparationsConnection: ResolverTypeWrapper<LimitationLimitsPreparationsConnection>;
	LimitationLimitsPreparationsConnectionSort: LimitationLimitsPreparationsConnectionSort;
	LimitationLimitsPreparationsConnectionWhere: LimitationLimitsPreparationsConnectionWhere;
	LimitationLimitsPreparationsCreateFieldInput: LimitationLimitsPreparationsCreateFieldInput;
	LimitationLimitsPreparationsDeleteFieldInput: LimitationLimitsPreparationsDeleteFieldInput;
	LimitationLimitsPreparationsDisconnectFieldInput: LimitationLimitsPreparationsDisconnectFieldInput;
	LimitationLimitsPreparationsFieldInput: LimitationLimitsPreparationsFieldInput;
	LimitationLimitsPreparationsNodeAggregationWhereInput: LimitationLimitsPreparationsNodeAggregationWhereInput;
	LimitationLimitsPreparationsRelationship: ResolverTypeWrapper<LimitationLimitsPreparationsRelationship>;
	LimitationLimitsPreparationsUpdateConnectionInput: LimitationLimitsPreparationsUpdateConnectionInput;
	LimitationLimitsPreparationsUpdateFieldInput: LimitationLimitsPreparationsUpdateFieldInput;
	LimitationLimitsTreatmentAggregateInput: LimitationLimitsTreatmentAggregateInput;
	LimitationLimitsTreatmentConnectFieldInput: LimitationLimitsTreatmentConnectFieldInput;
	LimitationLimitsTreatmentConnection: ResolverTypeWrapper<LimitationLimitsTreatmentConnection>;
	LimitationLimitsTreatmentConnectionSort: LimitationLimitsTreatmentConnectionSort;
	LimitationLimitsTreatmentConnectionWhere: LimitationLimitsTreatmentConnectionWhere;
	LimitationLimitsTreatmentCreateFieldInput: LimitationLimitsTreatmentCreateFieldInput;
	LimitationLimitsTreatmentDeleteFieldInput: LimitationLimitsTreatmentDeleteFieldInput;
	LimitationLimitsTreatmentDisconnectFieldInput: LimitationLimitsTreatmentDisconnectFieldInput;
	LimitationLimitsTreatmentFieldInput: LimitationLimitsTreatmentFieldInput;
	LimitationLimitsTreatmentNodeAggregationWhereInput: LimitationLimitsTreatmentNodeAggregationWhereInput;
	LimitationLimitsTreatmentRelationship: ResolverTypeWrapper<LimitationLimitsTreatmentRelationship>;
	LimitationLimitsTreatmentUpdateConnectionInput: LimitationLimitsTreatmentUpdateConnectionInput;
	LimitationLimitsTreatmentUpdateFieldInput: LimitationLimitsTreatmentUpdateFieldInput;
	LimitationOptions: LimitationOptions;
	LimitationSort: LimitationSort;
	LimitationUpdateInput: LimitationUpdateInput;
	LimitationWhere: LimitationWhere;
	LogicalCondition: LogicalCondition;
	Message: ResolverTypeWrapper<Message>;
	MessageAggregateSelection: ResolverTypeWrapper<MessageAggregateSelection>;
	MessageConnectInput: MessageConnectInput;
	MessageConnectWhere: MessageConnectWhere;
	MessageCreateInput: MessageCreateInput;
	MessageDeleteInput: MessageDeleteInput;
	MessageDisconnectInput: MessageDisconnectInput;
	MessageMentionsAggregateInput: MessageMentionsAggregateInput;
	MessageMentionsConnectFieldInput: MessageMentionsConnectFieldInput;
	MessageMentionsConnection: ResolverTypeWrapper<MessageMentionsConnection>;
	MessageMentionsConnectionSort: MessageMentionsConnectionSort;
	MessageMentionsConnectionWhere: MessageMentionsConnectionWhere;
	MessageMentionsCreateFieldInput: MessageMentionsCreateFieldInput;
	MessageMentionsDeleteFieldInput: MessageMentionsDeleteFieldInput;
	MessageMentionsDisconnectFieldInput: MessageMentionsDisconnectFieldInput;
	MessageMentionsFieldInput: MessageMentionsFieldInput;
	MessageMentionsNodeAggregationWhereInput: MessageMentionsNodeAggregationWhereInput;
	MessageMentionsRelationship: ResolverTypeWrapper<MessageMentionsRelationship>;
	MessageMentionsUpdateConnectionInput: MessageMentionsUpdateConnectionInput;
	MessageMentionsUpdateFieldInput: MessageMentionsUpdateFieldInput;
	MessageOptions: MessageOptions;
	MessageRefundAggregateInput: MessageRefundAggregateInput;
	MessageRefundConnectFieldInput: MessageRefundConnectFieldInput;
	MessageRefundConnection: ResolverTypeWrapper<MessageRefundConnection>;
	MessageRefundConnectionSort: MessageRefundConnectionSort;
	MessageRefundConnectionWhere: MessageRefundConnectionWhere;
	MessageRefundCreateFieldInput: MessageRefundCreateFieldInput;
	MessageRefundDeleteFieldInput: MessageRefundDeleteFieldInput;
	MessageRefundDisconnectFieldInput: MessageRefundDisconnectFieldInput;
	MessageRefundFieldInput: MessageRefundFieldInput;
	MessageRefundNodeAggregationWhereInput: MessageRefundNodeAggregationWhereInput;
	MessageRefundRelationship: ResolverTypeWrapper<MessageRefundRelationship>;
	MessageRefundUpdateConnectionInput: MessageRefundUpdateConnectionInput;
	MessageRefundUpdateFieldInput: MessageRefundUpdateFieldInput;
	MessageSentByAggregateInput: MessageSentByAggregateInput;
	MessageSentByConnectFieldInput: MessageSentByConnectFieldInput;
	MessageSentByConnection: ResolverTypeWrapper<MessageSentByConnection>;
	MessageSentByConnectionSort: MessageSentByConnectionSort;
	MessageSentByConnectionWhere: MessageSentByConnectionWhere;
	MessageSentByCreateFieldInput: MessageSentByCreateFieldInput;
	MessageSentByDeleteFieldInput: MessageSentByDeleteFieldInput;
	MessageSentByDisconnectFieldInput: MessageSentByDisconnectFieldInput;
	MessageSentByFieldInput: MessageSentByFieldInput;
	MessageSentByNodeAggregationWhereInput: MessageSentByNodeAggregationWhereInput;
	MessageSentByRelationship: ResolverTypeWrapper<MessageSentByRelationship>;
	MessageSentByUpdateConnectionInput: MessageSentByUpdateConnectionInput;
	MessageSentByUpdateFieldInput: MessageSentByUpdateFieldInput;
	MessageSort: MessageSort;
	MessageUpdateInput: MessageUpdateInput;
	MessageWhere: MessageWhere;
	MicroContent: ResolverTypeWrapper<MicroContent>;
	MicroContentAggregateSelection: ResolverTypeWrapper<MicroContentAggregateSelection>;
	MicroContentOptions: MicroContentOptions;
	MicroContentSort: MicroContentSort;
	MicroContentType: MicroContentType;
	MicroContentWhere: MicroContentWhere;
	Module: ResolverTypeWrapper<Module>;
	ModuleAggregateSelection: ResolverTypeWrapper<ModuleAggregateSelection>;
	ModuleInput: ModuleInput;
	ModuleOptions: ModuleOptions;
	ModuleSort: ModuleSort;
	ModuleWhere: ModuleWhere;
	Mutation: ResolverTypeWrapper<{}>;
	NetRevenueByOrganization: ResolverTypeWrapper<NetRevenueByOrganization>;
	NetRevenueByOrganizationAggregateSelection: ResolverTypeWrapper<NetRevenueByOrganizationAggregateSelection>;
	NetRevenueByOrganizationOptions: NetRevenueByOrganizationOptions;
	NetRevenueByOrganizationSort: NetRevenueByOrganizationSort;
	NetRevenueByOrganizationWhere: NetRevenueByOrganizationWhere;
	Notification: ResolverTypeWrapper<Notification>;
	NotificationAggregateSelection: ResolverTypeWrapper<NotificationAggregateSelection>;
	NotificationConnectInput: NotificationConnectInput;
	NotificationConnectWhere: NotificationConnectWhere;
	NotificationCreateInput: NotificationCreateInput;
	NotificationDeleteInput: NotificationDeleteInput;
	NotificationDisconnectInput: NotificationDisconnectInput;
	NotificationDueAggregateInput: NotificationDueAggregateInput;
	NotificationDueConnectFieldInput: NotificationDueConnectFieldInput;
	NotificationDueConnection: ResolverTypeWrapper<NotificationDueConnection>;
	NotificationDueConnectionSort: NotificationDueConnectionSort;
	NotificationDueConnectionWhere: NotificationDueConnectionWhere;
	NotificationDueCreateFieldInput: NotificationDueCreateFieldInput;
	NotificationDueDeleteFieldInput: NotificationDueDeleteFieldInput;
	NotificationDueDisconnectFieldInput: NotificationDueDisconnectFieldInput;
	NotificationDueEdgeAggregationWhereInput: NotificationDueEdgeAggregationWhereInput;
	NotificationDueFieldInput: NotificationDueFieldInput;
	NotificationDueNodeAggregationWhereInput: NotificationDueNodeAggregationWhereInput;
	NotificationDueRelationship: ResolverTypeWrapper<NotificationDueRelationship>;
	NotificationDueUpdateConnectionInput: NotificationDueUpdateConnectionInput;
	NotificationDueUpdateFieldInput: NotificationDueUpdateFieldInput;
	NotificationNotifiedAggregateInput: NotificationNotifiedAggregateInput;
	NotificationNotifiedConnectFieldInput: NotificationNotifiedConnectFieldInput;
	NotificationNotifiedConnection: ResolverTypeWrapper<NotificationNotifiedConnection>;
	NotificationNotifiedConnectionSort: NotificationNotifiedConnectionSort;
	NotificationNotifiedConnectionWhere: NotificationNotifiedConnectionWhere;
	NotificationNotifiedCreateFieldInput: NotificationNotifiedCreateFieldInput;
	NotificationNotifiedDeleteFieldInput: NotificationNotifiedDeleteFieldInput;
	NotificationNotifiedDisconnectFieldInput: NotificationNotifiedDisconnectFieldInput;
	NotificationNotifiedEdgeAggregationWhereInput: NotificationNotifiedEdgeAggregationWhereInput;
	NotificationNotifiedFieldInput: NotificationNotifiedFieldInput;
	NotificationNotifiedNodeAggregationWhereInput: NotificationNotifiedNodeAggregationWhereInput;
	NotificationNotifiedRelationship: ResolverTypeWrapper<NotificationNotifiedRelationship>;
	NotificationNotifiedUpdateConnectionInput: NotificationNotifiedUpdateConnectionInput;
	NotificationNotifiedUpdateFieldInput: NotificationNotifiedUpdateFieldInput;
	NotificationOptions: NotificationOptions;
	NotificationSort: NotificationSort;
	NotificationSubscribedAggregateInput: NotificationSubscribedAggregateInput;
	NotificationSubscribedConnectFieldInput: NotificationSubscribedConnectFieldInput;
	NotificationSubscribedConnection: ResolverTypeWrapper<NotificationSubscribedConnection>;
	NotificationSubscribedConnectionSort: NotificationSubscribedConnectionSort;
	NotificationSubscribedConnectionWhere: NotificationSubscribedConnectionWhere;
	NotificationSubscribedCreateFieldInput: NotificationSubscribedCreateFieldInput;
	NotificationSubscribedDeleteFieldInput: NotificationSubscribedDeleteFieldInput;
	NotificationSubscribedDisconnectFieldInput: NotificationSubscribedDisconnectFieldInput;
	NotificationSubscribedFieldInput: NotificationSubscribedFieldInput;
	NotificationSubscribedNodeAggregationWhereInput: NotificationSubscribedNodeAggregationWhereInput;
	NotificationSubscribedRelationship: ResolverTypeWrapper<NotificationSubscribedRelationship>;
	NotificationSubscribedUpdateConnectionInput: NotificationSubscribedUpdateConnectionInput;
	NotificationSubscribedUpdateFieldInput: NotificationSubscribedUpdateFieldInput;
	NotificationTrigger: ResolverTypeWrapper<NotificationTrigger>;
	NotificationTriggerAct: NotificationTriggerAct;
	NotificationTriggerAggregateSelection: ResolverTypeWrapper<NotificationTriggerAggregateSelection>;
	NotificationTriggerAspect: NotificationTriggerAspect;
	NotificationTriggerConnectWhere: NotificationTriggerConnectWhere;
	NotificationTriggerCreateInput: NotificationTriggerCreateInput;
	NotificationTriggerInput: NotificationTriggerInput;
	NotificationTriggerOptions: NotificationTriggerOptions;
	NotificationTriggerSort: NotificationTriggerSort;
	NotificationTriggerSubject: NotificationTriggerSubject;
	NotificationTriggerUpdateInput: NotificationTriggerUpdateInput;
	NotificationTriggerWhere: NotificationTriggerWhere;
	NotificationType: NotificationType;
	NotificationUpdateInput: NotificationUpdateInput;
	NotificationWhere: NotificationWhere;
	Occurrence: Occurrence;
	OccurrenceEnum: OccurrenceEnum;
	Organization: ResolverTypeWrapper<Organization>;
	OrganizationAggregateSelection: ResolverTypeWrapper<OrganizationAggregateSelection>;
	OrganizationConnectWhere: OrganizationConnectWhere;
	OrganizationCreateInput: OrganizationCreateInput;
	OrganizationInput: OrganizationInput;
	OrganizationOptions: OrganizationOptions;
	OrganizationSort: OrganizationSort;
	OrganizationUpdateInput: OrganizationUpdateInput;
	OrganizationWhere: OrganizationWhere;
	OutcomeBasedStatus: OutcomeBasedStatus;
	OutcomebasedAgreementReport: ResolverTypeWrapper<OutcomebasedAgreementReport>;
	OutcomebasedAgreementReportAggregateSelection: ResolverTypeWrapper<OutcomebasedAgreementReportAggregateSelection>;
	OutcomebasedAgreementReportOptions: OutcomebasedAgreementReportOptions;
	OutcomebasedAgreementReportSort: OutcomebasedAgreementReportSort;
	OutcomebasedAgreementReportWhere: OutcomebasedAgreementReportWhere;
	PIRecurrenceSIDataPoint: ResolverTypeWrapper<PiRecurrenceSiDataPoint>;
	PIRecurrenceSIDataPointAggregateSelection: ResolverTypeWrapper<PiRecurrenceSiDataPointAggregateSelection>;
	PIRecurrenceSIDataPointOptions: PiRecurrenceSiDataPointOptions;
	PIRecurrenceSIDataPointSort: PiRecurrenceSiDataPointSort;
	PIRecurrenceSIDataPointWhere: PiRecurrenceSiDataPointWhere;
	PageInfo: ResolverTypeWrapper<PageInfo>;
	Partner: ResolverTypeWrapper<Partner>;
	PartnerAggregateSelection: ResolverTypeWrapper<PartnerAggregateSelection>;
	PartnerConnectInput: PartnerConnectInput;
	PartnerConnectWhere: PartnerConnectWhere;
	PartnerCreateInput: PartnerCreateInput;
	PartnerDeleteInput: PartnerDeleteInput;
	PartnerDisconnectInput: PartnerDisconnectInput;
	PartnerOptions: PartnerOptions;
	PartnerSort: PartnerSort;
	PartnerTreatmentAggregateInput: PartnerTreatmentAggregateInput;
	PartnerTreatmentConnectFieldInput: PartnerTreatmentConnectFieldInput;
	PartnerTreatmentConnection: ResolverTypeWrapper<PartnerTreatmentConnection>;
	PartnerTreatmentConnectionSort: PartnerTreatmentConnectionSort;
	PartnerTreatmentConnectionWhere: PartnerTreatmentConnectionWhere;
	PartnerTreatmentCreateFieldInput: PartnerTreatmentCreateFieldInput;
	PartnerTreatmentDeleteFieldInput: PartnerTreatmentDeleteFieldInput;
	PartnerTreatmentDisconnectFieldInput: PartnerTreatmentDisconnectFieldInput;
	PartnerTreatmentFieldInput: PartnerTreatmentFieldInput;
	PartnerTreatmentNodeAggregationWhereInput: PartnerTreatmentNodeAggregationWhereInput;
	PartnerTreatmentRelationship: ResolverTypeWrapper<PartnerTreatmentRelationship>;
	PartnerTreatmentUpdateConnectionInput: PartnerTreatmentUpdateConnectionInput;
	PartnerTreatmentUpdateFieldInput: PartnerTreatmentUpdateFieldInput;
	PartnerUpdateInput: PartnerUpdateInput;
	PartnerWhere: PartnerWhere;
	Patient: ResolverTypeWrapper<Patient>;
	PatientAggregateSelection: ResolverTypeWrapper<PatientAggregateSelection>;
	PatientAssignedFlexEntitiesAggregateInput: PatientAssignedFlexEntitiesAggregateInput;
	PatientAssignedFlexEntitiesConnectFieldInput: PatientAssignedFlexEntitiesConnectFieldInput;
	PatientAssignedFlexEntitiesConnection: ResolverTypeWrapper<PatientAssignedFlexEntitiesConnection>;
	PatientAssignedFlexEntitiesConnectionSort: PatientAssignedFlexEntitiesConnectionSort;
	PatientAssignedFlexEntitiesConnectionWhere: PatientAssignedFlexEntitiesConnectionWhere;
	PatientAssignedFlexEntitiesCreateFieldInput: PatientAssignedFlexEntitiesCreateFieldInput;
	PatientAssignedFlexEntitiesDeleteFieldInput: PatientAssignedFlexEntitiesDeleteFieldInput;
	PatientAssignedFlexEntitiesDisconnectFieldInput: PatientAssignedFlexEntitiesDisconnectFieldInput;
	PatientAssignedFlexEntitiesFieldInput: PatientAssignedFlexEntitiesFieldInput;
	PatientAssignedFlexEntitiesNodeAggregationWhereInput: PatientAssignedFlexEntitiesNodeAggregationWhereInput;
	PatientAssignedFlexEntitiesRelationship: ResolverTypeWrapper<PatientAssignedFlexEntitiesRelationship>;
	PatientAssignedFlexEntitiesUpdateConnectionInput: PatientAssignedFlexEntitiesUpdateConnectionInput;
	PatientAssignedFlexEntitiesUpdateFieldInput: PatientAssignedFlexEntitiesUpdateFieldInput;
	PatientCasesAggregateInput: PatientCasesAggregateInput;
	PatientCasesConnectFieldInput: PatientCasesConnectFieldInput;
	PatientCasesConnection: ResolverTypeWrapper<PatientCasesConnection>;
	PatientCasesConnectionSort: PatientCasesConnectionSort;
	PatientCasesConnectionWhere: PatientCasesConnectionWhere;
	PatientCasesCreateFieldInput: PatientCasesCreateFieldInput;
	PatientCasesDeleteFieldInput: PatientCasesDeleteFieldInput;
	PatientCasesDisconnectFieldInput: PatientCasesDisconnectFieldInput;
	PatientCasesFieldInput: PatientCasesFieldInput;
	PatientCasesNodeAggregationWhereInput: PatientCasesNodeAggregationWhereInput;
	PatientCasesRelationship: ResolverTypeWrapper<PatientCasesRelationship>;
	PatientCasesUpdateConnectionInput: PatientCasesUpdateConnectionInput;
	PatientCasesUpdateFieldInput: PatientCasesUpdateFieldInput;
	PatientClaimsAggregateInput: PatientClaimsAggregateInput;
	PatientClaimsConnectFieldInput: PatientClaimsConnectFieldInput;
	PatientClaimsConnection: ResolverTypeWrapper<PatientClaimsConnection>;
	PatientClaimsConnectionSort: PatientClaimsConnectionSort;
	PatientClaimsConnectionWhere: PatientClaimsConnectionWhere;
	PatientClaimsCreateFieldInput: PatientClaimsCreateFieldInput;
	PatientClaimsDeleteFieldInput: PatientClaimsDeleteFieldInput;
	PatientClaimsDisconnectFieldInput: PatientClaimsDisconnectFieldInput;
	PatientClaimsFieldInput: PatientClaimsFieldInput;
	PatientClaimsNodeAggregationWhereInput: PatientClaimsNodeAggregationWhereInput;
	PatientClaimsRelationship: ResolverTypeWrapper<PatientClaimsRelationship>;
	PatientClaimsUpdateConnectionInput: PatientClaimsUpdateConnectionInput;
	PatientClaimsUpdateFieldInput: PatientClaimsUpdateFieldInput;
	PatientConnectInput: PatientConnectInput;
	PatientConnectWhere: PatientConnectWhere;
	PatientCountDataPoint: ResolverTypeWrapper<PatientCountDataPoint>;
	PatientCountDataPointAggregateSelection: ResolverTypeWrapper<PatientCountDataPointAggregateSelection>;
	PatientCountDataPointOptions: PatientCountDataPointOptions;
	PatientCountDataPointSort: PatientCountDataPointSort;
	PatientCountDataPointWhere: PatientCountDataPointWhere;
	PatientCoverageRequestsAggregateInput: PatientCoverageRequestsAggregateInput;
	PatientCoverageRequestsConnectFieldInput: PatientCoverageRequestsConnectFieldInput;
	PatientCoverageRequestsConnection: ResolverTypeWrapper<PatientCoverageRequestsConnection>;
	PatientCoverageRequestsConnectionSort: PatientCoverageRequestsConnectionSort;
	PatientCoverageRequestsConnectionWhere: PatientCoverageRequestsConnectionWhere;
	PatientCoverageRequestsCreateFieldInput: PatientCoverageRequestsCreateFieldInput;
	PatientCoverageRequestsDeleteFieldInput: PatientCoverageRequestsDeleteFieldInput;
	PatientCoverageRequestsDisconnectFieldInput: PatientCoverageRequestsDisconnectFieldInput;
	PatientCoverageRequestsFieldInput: PatientCoverageRequestsFieldInput;
	PatientCoverageRequestsNodeAggregationWhereInput: PatientCoverageRequestsNodeAggregationWhereInput;
	PatientCoverageRequestsRelationship: ResolverTypeWrapper<PatientCoverageRequestsRelationship>;
	PatientCoverageRequestsUpdateConnectionInput: PatientCoverageRequestsUpdateConnectionInput;
	PatientCoverageRequestsUpdateFieldInput: PatientCoverageRequestsUpdateFieldInput;
	PatientCreateInput: PatientCreateInput;
	PatientDeleteInput: PatientDeleteInput;
	PatientDisconnectInput: PatientDisconnectInput;
	PatientOptions: PatientOptions;
	PatientPrimaryInterventionAggregateInput: PatientPrimaryInterventionAggregateInput;
	PatientPrimaryInterventionConnectFieldInput: PatientPrimaryInterventionConnectFieldInput;
	PatientPrimaryInterventionConnection: ResolverTypeWrapper<PatientPrimaryInterventionConnection>;
	PatientPrimaryInterventionConnectionSort: PatientPrimaryInterventionConnectionSort;
	PatientPrimaryInterventionConnectionWhere: PatientPrimaryInterventionConnectionWhere;
	PatientPrimaryInterventionCreateFieldInput: PatientPrimaryInterventionCreateFieldInput;
	PatientPrimaryInterventionDeleteFieldInput: PatientPrimaryInterventionDeleteFieldInput;
	PatientPrimaryInterventionDisconnectFieldInput: PatientPrimaryInterventionDisconnectFieldInput;
	PatientPrimaryInterventionFieldInput: PatientPrimaryInterventionFieldInput;
	PatientPrimaryInterventionNodeAggregationWhereInput: PatientPrimaryInterventionNodeAggregationWhereInput;
	PatientPrimaryInterventionRelationship: ResolverTypeWrapper<PatientPrimaryInterventionRelationship>;
	PatientPrimaryInterventionUpdateConnectionInput: PatientPrimaryInterventionUpdateConnectionInput;
	PatientPrimaryInterventionUpdateFieldInput: PatientPrimaryInterventionUpdateFieldInput;
	PatientReportDataPoint: ResolverTypeWrapper<PatientReportDataPoint>;
	PatientReportDataPointAggregateSelection: ResolverTypeWrapper<PatientReportDataPointAggregateSelection>;
	PatientReportDataPointOptions: PatientReportDataPointOptions;
	PatientReportDataPointSort: PatientReportDataPointSort;
	PatientReportDataPointWhere: PatientReportDataPointWhere;
	PatientSentClaimAggregateInput: PatientSentClaimAggregateInput;
	PatientSentClaimConnectFieldInput: PatientSentClaimConnectFieldInput;
	PatientSentClaimConnection: ResolverTypeWrapper<PatientSentClaimConnection>;
	PatientSentClaimConnectionSort: PatientSentClaimConnectionSort;
	PatientSentClaimConnectionWhere: PatientSentClaimConnectionWhere;
	PatientSentClaimCreateFieldInput: PatientSentClaimCreateFieldInput;
	PatientSentClaimDeleteFieldInput: PatientSentClaimDeleteFieldInput;
	PatientSentClaimDisconnectFieldInput: PatientSentClaimDisconnectFieldInput;
	PatientSentClaimEdgeAggregationWhereInput: PatientSentClaimEdgeAggregationWhereInput;
	PatientSentClaimFieldInput: PatientSentClaimFieldInput;
	PatientSentClaimNodeAggregationWhereInput: PatientSentClaimNodeAggregationWhereInput;
	PatientSentClaimRelationship: ResolverTypeWrapper<PatientSentClaimRelationship>;
	PatientSentClaimUpdateConnectionInput: PatientSentClaimUpdateConnectionInput;
	PatientSentClaimUpdateFieldInput: PatientSentClaimUpdateFieldInput;
	PatientSort: PatientSort;
	PatientStatusDistribution: ResolverTypeWrapper<PatientStatusDistribution>;
	PatientStatusDistributionAggregateSelection: ResolverTypeWrapper<PatientStatusDistributionAggregateSelection>;
	PatientStatusDistributionOptions: PatientStatusDistributionOptions;
	PatientStatusDistributionSort: PatientStatusDistributionSort;
	PatientStatusDistributionWhere: PatientStatusDistributionWhere;
	PatientUpdateInput: PatientUpdateInput;
	PatientWhere: PatientWhere;
	PatientsPerMonthDataPoint: ResolverTypeWrapper<PatientsPerMonthDataPoint>;
	PatientsPerMonthDataPointAggregateSelection: ResolverTypeWrapper<PatientsPerMonthDataPointAggregateSelection>;
	PatientsPerMonthDataPointOptions: PatientsPerMonthDataPointOptions;
	PatientsPerMonthDataPointSort: PatientsPerMonthDataPointSort;
	PatientsPerMonthDataPointWhere: PatientsPerMonthDataPointWhere;
	Preparation: ResolverTypeWrapper<Preparation>;
	PreparationAggregateSelection: ResolverTypeWrapper<PreparationAggregateSelection>;
	PreparationBrandAggregateInput: PreparationBrandAggregateInput;
	PreparationBrandConnectFieldInput: PreparationBrandConnectFieldInput;
	PreparationBrandConnection: ResolverTypeWrapper<PreparationBrandConnection>;
	PreparationBrandConnectionSort: PreparationBrandConnectionSort;
	PreparationBrandConnectionWhere: PreparationBrandConnectionWhere;
	PreparationBrandCreateFieldInput: PreparationBrandCreateFieldInput;
	PreparationBrandDeleteFieldInput: PreparationBrandDeleteFieldInput;
	PreparationBrandDisconnectFieldInput: PreparationBrandDisconnectFieldInput;
	PreparationBrandFieldInput: PreparationBrandFieldInput;
	PreparationBrandNodeAggregationWhereInput: PreparationBrandNodeAggregationWhereInput;
	PreparationBrandRelationship: ResolverTypeWrapper<PreparationBrandRelationship>;
	PreparationBrandUpdateConnectionInput: PreparationBrandUpdateConnectionInput;
	PreparationBrandUpdateFieldInput: PreparationBrandUpdateFieldInput;
	PreparationConnectInput: PreparationConnectInput;
	PreparationConnectWhere: PreparationConnectWhere;
	PreparationCoverageRequestAggregateInput: PreparationCoverageRequestAggregateInput;
	PreparationCoverageRequestCombinedAggregateInput: PreparationCoverageRequestCombinedAggregateInput;
	PreparationCoverageRequestCombinedConnectFieldInput: PreparationCoverageRequestCombinedConnectFieldInput;
	PreparationCoverageRequestCombinedConnection: ResolverTypeWrapper<PreparationCoverageRequestCombinedConnection>;
	PreparationCoverageRequestCombinedConnectionSort: PreparationCoverageRequestCombinedConnectionSort;
	PreparationCoverageRequestCombinedConnectionWhere: PreparationCoverageRequestCombinedConnectionWhere;
	PreparationCoverageRequestCombinedCreateFieldInput: PreparationCoverageRequestCombinedCreateFieldInput;
	PreparationCoverageRequestCombinedDeleteFieldInput: PreparationCoverageRequestCombinedDeleteFieldInput;
	PreparationCoverageRequestCombinedDisconnectFieldInput: PreparationCoverageRequestCombinedDisconnectFieldInput;
	PreparationCoverageRequestCombinedFieldInput: PreparationCoverageRequestCombinedFieldInput;
	PreparationCoverageRequestCombinedNodeAggregationWhereInput: PreparationCoverageRequestCombinedNodeAggregationWhereInput;
	PreparationCoverageRequestCombinedRelationship: ResolverTypeWrapper<PreparationCoverageRequestCombinedRelationship>;
	PreparationCoverageRequestCombinedUpdateConnectionInput: PreparationCoverageRequestCombinedUpdateConnectionInput;
	PreparationCoverageRequestCombinedUpdateFieldInput: PreparationCoverageRequestCombinedUpdateFieldInput;
	PreparationCoverageRequestConnectFieldInput: PreparationCoverageRequestConnectFieldInput;
	PreparationCoverageRequestConnection: ResolverTypeWrapper<PreparationCoverageRequestConnection>;
	PreparationCoverageRequestConnectionSort: PreparationCoverageRequestConnectionSort;
	PreparationCoverageRequestConnectionWhere: PreparationCoverageRequestConnectionWhere;
	PreparationCoverageRequestCreateFieldInput: PreparationCoverageRequestCreateFieldInput;
	PreparationCoverageRequestDeleteFieldInput: PreparationCoverageRequestDeleteFieldInput;
	PreparationCoverageRequestDisconnectFieldInput: PreparationCoverageRequestDisconnectFieldInput;
	PreparationCoverageRequestFieldInput: PreparationCoverageRequestFieldInput;
	PreparationCoverageRequestNodeAggregationWhereInput: PreparationCoverageRequestNodeAggregationWhereInput;
	PreparationCoverageRequestRelationship: ResolverTypeWrapper<PreparationCoverageRequestRelationship>;
	PreparationCoverageRequestUpdateConnectionInput: PreparationCoverageRequestUpdateConnectionInput;
	PreparationCoverageRequestUpdateFieldInput: PreparationCoverageRequestUpdateFieldInput;
	PreparationCreateInput: PreparationCreateInput;
	PreparationDeleteInput: PreparationDeleteInput;
	PreparationDisconnectInput: PreparationDisconnectInput;
	PreparationHasLimitationsAggregateInput: PreparationHasLimitationsAggregateInput;
	PreparationHasLimitationsConnectFieldInput: PreparationHasLimitationsConnectFieldInput;
	PreparationHasLimitationsConnection: ResolverTypeWrapper<PreparationHasLimitationsConnection>;
	PreparationHasLimitationsConnectionSort: PreparationHasLimitationsConnectionSort;
	PreparationHasLimitationsConnectionWhere: PreparationHasLimitationsConnectionWhere;
	PreparationHasLimitationsCreateFieldInput: PreparationHasLimitationsCreateFieldInput;
	PreparationHasLimitationsDeleteFieldInput: PreparationHasLimitationsDeleteFieldInput;
	PreparationHasLimitationsDisconnectFieldInput: PreparationHasLimitationsDisconnectFieldInput;
	PreparationHasLimitationsFieldInput: PreparationHasLimitationsFieldInput;
	PreparationHasLimitationsNodeAggregationWhereInput: PreparationHasLimitationsNodeAggregationWhereInput;
	PreparationHasLimitationsRelationship: ResolverTypeWrapper<PreparationHasLimitationsRelationship>;
	PreparationHasLimitationsUpdateConnectionInput: PreparationHasLimitationsUpdateConnectionInput;
	PreparationHasLimitationsUpdateFieldInput: PreparationHasLimitationsUpdateFieldInput;
	PreparationOptions: PreparationOptions;
	PreparationRegulatesAggregateInput: PreparationRegulatesAggregateInput;
	PreparationRegulatesConnectFieldInput: PreparationRegulatesConnectFieldInput;
	PreparationRegulatesConnection: ResolverTypeWrapper<PreparationRegulatesConnection>;
	PreparationRegulatesConnectionSort: PreparationRegulatesConnectionSort;
	PreparationRegulatesConnectionWhere: PreparationRegulatesConnectionWhere;
	PreparationRegulatesCreateFieldInput: PreparationRegulatesCreateFieldInput;
	PreparationRegulatesDeleteFieldInput: PreparationRegulatesDeleteFieldInput;
	PreparationRegulatesDisconnectFieldInput: PreparationRegulatesDisconnectFieldInput;
	PreparationRegulatesFieldInput: PreparationRegulatesFieldInput;
	PreparationRegulatesNodeAggregationWhereInput: PreparationRegulatesNodeAggregationWhereInput;
	PreparationRegulatesRelationship: ResolverTypeWrapper<PreparationRegulatesRelationship>;
	PreparationRegulatesUpdateConnectionInput: PreparationRegulatesUpdateConnectionInput;
	PreparationRegulatesUpdateFieldInput: PreparationRegulatesUpdateFieldInput;
	PreparationSort: PreparationSort;
	PreparationStatus: ResolverTypeWrapper<PreparationStatus>;
	PreparationStatusAggregateSelection: ResolverTypeWrapper<PreparationStatusAggregateSelection>;
	PreparationStatusConnectInput: PreparationStatusConnectInput;
	PreparationStatusConnectWhere: PreparationStatusConnectWhere;
	PreparationStatusCreateInput: PreparationStatusCreateInput;
	PreparationStatusDeleteInput: PreparationStatusDeleteInput;
	PreparationStatusDisconnectInput: PreparationStatusDisconnectInput;
	PreparationStatusOptions: PreparationStatusOptions;
	PreparationStatusPreparationAggregateInput: PreparationStatusPreparationAggregateInput;
	PreparationStatusPreparationConnectFieldInput: PreparationStatusPreparationConnectFieldInput;
	PreparationStatusPreparationConnection: ResolverTypeWrapper<PreparationStatusPreparationConnection>;
	PreparationStatusPreparationConnectionSort: PreparationStatusPreparationConnectionSort;
	PreparationStatusPreparationConnectionWhere: PreparationStatusPreparationConnectionWhere;
	PreparationStatusPreparationCreateFieldInput: PreparationStatusPreparationCreateFieldInput;
	PreparationStatusPreparationDeleteFieldInput: PreparationStatusPreparationDeleteFieldInput;
	PreparationStatusPreparationDisconnectFieldInput: PreparationStatusPreparationDisconnectFieldInput;
	PreparationStatusPreparationFieldInput: PreparationStatusPreparationFieldInput;
	PreparationStatusPreparationNodeAggregationWhereInput: PreparationStatusPreparationNodeAggregationWhereInput;
	PreparationStatusPreparationRelationship: ResolverTypeWrapper<PreparationStatusPreparationRelationship>;
	PreparationStatusPreparationUpdateConnectionInput: PreparationStatusPreparationUpdateConnectionInput;
	PreparationStatusPreparationUpdateFieldInput: PreparationStatusPreparationUpdateFieldInput;
	PreparationStatusSort: PreparationStatusSort;
	PreparationStatusUpdateInput: PreparationStatusUpdateInput;
	PreparationStatusWhere: PreparationStatusWhere;
	PreparationUpdateInput: PreparationUpdateInput;
	PreparationWhere: PreparationWhere;
	PatientScope: PatientScope;
	Price: ResolverTypeWrapper<Price>;
	PriceAggregateSelection: ResolverTypeWrapper<PriceAggregateSelection>;
	PriceOptions: PriceOptions;
	PriceSort: PriceSort;
	PriceTreatmentAggregateInput: PriceTreatmentAggregateInput;
	PriceTreatmentConnection: ResolverTypeWrapper<PriceTreatmentConnection>;
	PriceTreatmentConnectionSort: PriceTreatmentConnectionSort;
	PriceTreatmentConnectionWhere: PriceTreatmentConnectionWhere;
	PriceTreatmentNodeAggregationWhereInput: PriceTreatmentNodeAggregationWhereInput;
	PriceTreatmentRelationship: ResolverTypeWrapper<PriceTreatmentRelationship>;
	PriceType: PriceType;
	PriceWhere: PriceWhere;
	ProcessedDeviceRecord: ResolverTypeWrapper<ProcessedDeviceRecord>;
	ProcessedDeviceRecordAggregateSelection: ResolverTypeWrapper<ProcessedDeviceRecordAggregateSelection>;
	ProcessedDeviceRecordAgreementAggregateInput: ProcessedDeviceRecordAgreementAggregateInput;
	ProcessedDeviceRecordAgreementConnectFieldInput: ProcessedDeviceRecordAgreementConnectFieldInput;
	ProcessedDeviceRecordAgreementConnection: ResolverTypeWrapper<ProcessedDeviceRecordAgreementConnection>;
	ProcessedDeviceRecordAgreementConnectionSort: ProcessedDeviceRecordAgreementConnectionSort;
	ProcessedDeviceRecordAgreementConnectionWhere: ProcessedDeviceRecordAgreementConnectionWhere;
	ProcessedDeviceRecordAgreementCreateFieldInput: ProcessedDeviceRecordAgreementCreateFieldInput;
	ProcessedDeviceRecordAgreementDeleteFieldInput: ProcessedDeviceRecordAgreementDeleteFieldInput;
	ProcessedDeviceRecordAgreementDisconnectFieldInput: ProcessedDeviceRecordAgreementDisconnectFieldInput;
	ProcessedDeviceRecordAgreementFieldInput: ProcessedDeviceRecordAgreementFieldInput;
	ProcessedDeviceRecordAgreementNodeAggregationWhereInput: ProcessedDeviceRecordAgreementNodeAggregationWhereInput;
	ProcessedDeviceRecordAgreementRelationship: ResolverTypeWrapper<ProcessedDeviceRecordAgreementRelationship>;
	ProcessedDeviceRecordAgreementUpdateConnectionInput: ProcessedDeviceRecordAgreementUpdateConnectionInput;
	ProcessedDeviceRecordAgreementUpdateFieldInput: ProcessedDeviceRecordAgreementUpdateFieldInput;
	ProcessedDeviceRecordConnectInput: ProcessedDeviceRecordConnectInput;
	ProcessedDeviceRecordConnectWhere: ProcessedDeviceRecordConnectWhere;
	ProcessedDeviceRecordCreateInput: ProcessedDeviceRecordCreateInput;
	ProcessedDeviceRecordDeleteInput: ProcessedDeviceRecordDeleteInput;
	ProcessedDeviceRecordDeviceRecordAggregateInput: ProcessedDeviceRecordDeviceRecordAggregateInput;
	ProcessedDeviceRecordDeviceRecordConnectFieldInput: ProcessedDeviceRecordDeviceRecordConnectFieldInput;
	ProcessedDeviceRecordDeviceRecordConnection: ResolverTypeWrapper<ProcessedDeviceRecordDeviceRecordConnection>;
	ProcessedDeviceRecordDeviceRecordConnectionSort: ProcessedDeviceRecordDeviceRecordConnectionSort;
	ProcessedDeviceRecordDeviceRecordConnectionWhere: ProcessedDeviceRecordDeviceRecordConnectionWhere;
	ProcessedDeviceRecordDeviceRecordCreateFieldInput: ProcessedDeviceRecordDeviceRecordCreateFieldInput;
	ProcessedDeviceRecordDeviceRecordDeleteFieldInput: ProcessedDeviceRecordDeviceRecordDeleteFieldInput;
	ProcessedDeviceRecordDeviceRecordDisconnectFieldInput: ProcessedDeviceRecordDeviceRecordDisconnectFieldInput;
	ProcessedDeviceRecordDeviceRecordFieldInput: ProcessedDeviceRecordDeviceRecordFieldInput;
	ProcessedDeviceRecordDeviceRecordNodeAggregationWhereInput: ProcessedDeviceRecordDeviceRecordNodeAggregationWhereInput;
	ProcessedDeviceRecordDeviceRecordRelationship: ResolverTypeWrapper<ProcessedDeviceRecordDeviceRecordRelationship>;
	ProcessedDeviceRecordDeviceRecordUpdateConnectionInput: ProcessedDeviceRecordDeviceRecordUpdateConnectionInput;
	ProcessedDeviceRecordDeviceRecordUpdateFieldInput: ProcessedDeviceRecordDeviceRecordUpdateFieldInput;
	ProcessedDeviceRecordDisconnectInput: ProcessedDeviceRecordDisconnectInput;
	ProcessedDeviceRecordFinancialDataPointsAggregateInput: ProcessedDeviceRecordFinancialDataPointsAggregateInput;
	ProcessedDeviceRecordFinancialDataPointsConnectFieldInput: ProcessedDeviceRecordFinancialDataPointsConnectFieldInput;
	ProcessedDeviceRecordFinancialDataPointsConnection: ResolverTypeWrapper<ProcessedDeviceRecordFinancialDataPointsConnection>;
	ProcessedDeviceRecordFinancialDataPointsConnectionSort: ProcessedDeviceRecordFinancialDataPointsConnectionSort;
	ProcessedDeviceRecordFinancialDataPointsConnectionWhere: ProcessedDeviceRecordFinancialDataPointsConnectionWhere;
	ProcessedDeviceRecordFinancialDataPointsCreateFieldInput: ProcessedDeviceRecordFinancialDataPointsCreateFieldInput;
	ProcessedDeviceRecordFinancialDataPointsDeleteFieldInput: ProcessedDeviceRecordFinancialDataPointsDeleteFieldInput;
	ProcessedDeviceRecordFinancialDataPointsDisconnectFieldInput: ProcessedDeviceRecordFinancialDataPointsDisconnectFieldInput;
	ProcessedDeviceRecordFinancialDataPointsFieldInput: ProcessedDeviceRecordFinancialDataPointsFieldInput;
	ProcessedDeviceRecordFinancialDataPointsNodeAggregationWhereInput: ProcessedDeviceRecordFinancialDataPointsNodeAggregationWhereInput;
	ProcessedDeviceRecordFinancialDataPointsRelationship: ResolverTypeWrapper<ProcessedDeviceRecordFinancialDataPointsRelationship>;
	ProcessedDeviceRecordFinancialDataPointsUpdateConnectionInput: ProcessedDeviceRecordFinancialDataPointsUpdateConnectionInput;
	ProcessedDeviceRecordFinancialDataPointsUpdateFieldInput: ProcessedDeviceRecordFinancialDataPointsUpdateFieldInput;
	ProcessedDeviceRecordOptions: ProcessedDeviceRecordOptions;
	ProcessedDeviceRecordSort: ProcessedDeviceRecordSort;
	ProcessedDeviceRecordUpdateInput: ProcessedDeviceRecordUpdateInput;
	ProcessedDeviceRecordWhere: ProcessedDeviceRecordWhere;
	PublicPrice: ResolverTypeWrapper<PublicPrice>;
	PublicPriceAggregateSelection: ResolverTypeWrapper<PublicPriceAggregateSelection>;
	PublicPriceConnectWhere: PublicPriceConnectWhere;
	PublicPriceCreateInput: PublicPriceCreateInput;
	PublicPriceOptions: PublicPriceOptions;
	PublicPriceSort: PublicPriceSort;
	PublicPriceUpdateInput: PublicPriceUpdateInput;
	PublicPriceWhere: PublicPriceWhere;
	Query: ResolverTypeWrapper<{}>;
	ReasonOfTreatmentDiscontinuationReport: ResolverTypeWrapper<ReasonOfTreatmentDiscontinuationReport>;
	ReasonOfTreatmentDiscontinuationReportAggregateSelection: ResolverTypeWrapper<ReasonOfTreatmentDiscontinuationReportAggregateSelection>;
	ReasonOfTreatmentDiscontinuationReportCreateInput: ReasonOfTreatmentDiscontinuationReportCreateInput;
	ReasonOfTreatmentDiscontinuationReportOptions: ReasonOfTreatmentDiscontinuationReportOptions;
	ReasonOfTreatmentDiscontinuationReportSort: ReasonOfTreatmentDiscontinuationReportSort;
	ReasonOfTreatmentDiscontinuationReportUpdateInput: ReasonOfTreatmentDiscontinuationReportUpdateInput;
	ReasonOfTreatmentDiscontinuationReportWhere: ReasonOfTreatmentDiscontinuationReportWhere;
	ReasonsForDiscontinuation: ReasonsForDiscontinuation;
	RecallToDraftInput: RecallToDraftInput;
	RecommendedForm: ResolverTypeWrapper<RecommendedForm>;
	RecommendedFormAggregateSelection: ResolverTypeWrapper<RecommendedFormAggregateSelection>;
	RecommendedFormConnectWhere: RecommendedFormConnectWhere;
	RecommendedFormCreateInput: RecommendedFormCreateInput;
	RecommendedFormInput: RecommendedFormInput;
	RecommendedFormOptions: RecommendedFormOptions;
	RecommendedFormSort: RecommendedFormSort;
	RecommendedFormUpdateInput: RecommendedFormUpdateInput;
	RecommendedFormWhere: RecommendedFormWhere;
	Record: ResolverTypeWrapper<Record>;
	RecordAggregateSelection: ResolverTypeWrapper<RecordAggregateSelection>;
	RecordBatch: ResolverTypeWrapper<RecordBatch>;
	RecordBatchAggregateSelection: ResolverTypeWrapper<RecordBatchAggregateSelection>;
	RecordBatchConnectInput: RecordBatchConnectInput;
	RecordBatchConnectWhere: RecordBatchConnectWhere;
	RecordBatchCreateInput: RecordBatchCreateInput;
	RecordBatchDeleteInput: RecordBatchDeleteInput;
	RecordBatchDisconnectInput: RecordBatchDisconnectInput;
	RecordBatchFinancialDataPointsAggregateInput: RecordBatchFinancialDataPointsAggregateInput;
	RecordBatchFinancialDataPointsConnectFieldInput: RecordBatchFinancialDataPointsConnectFieldInput;
	RecordBatchFinancialDataPointsConnection: ResolverTypeWrapper<RecordBatchFinancialDataPointsConnection>;
	RecordBatchFinancialDataPointsConnectionSort: RecordBatchFinancialDataPointsConnectionSort;
	RecordBatchFinancialDataPointsConnectionWhere: RecordBatchFinancialDataPointsConnectionWhere;
	RecordBatchFinancialDataPointsCreateFieldInput: RecordBatchFinancialDataPointsCreateFieldInput;
	RecordBatchFinancialDataPointsDeleteFieldInput: RecordBatchFinancialDataPointsDeleteFieldInput;
	RecordBatchFinancialDataPointsDisconnectFieldInput: RecordBatchFinancialDataPointsDisconnectFieldInput;
	RecordBatchFinancialDataPointsFieldInput: RecordBatchFinancialDataPointsFieldInput;
	RecordBatchFinancialDataPointsNodeAggregationWhereInput: RecordBatchFinancialDataPointsNodeAggregationWhereInput;
	RecordBatchFinancialDataPointsRelationship: ResolverTypeWrapper<RecordBatchFinancialDataPointsRelationship>;
	RecordBatchFinancialDataPointsUpdateConnectionInput: RecordBatchFinancialDataPointsUpdateConnectionInput;
	RecordBatchFinancialDataPointsUpdateFieldInput: RecordBatchFinancialDataPointsUpdateFieldInput;
	RecordBatchOptions: RecordBatchOptions;
	RecordBatchSort: RecordBatchSort;
	RecordBatchStatus: RecordBatchStatus;
	RecordBatchUpdateInput: RecordBatchUpdateInput;
	RecordBatchWhere: RecordBatchWhere;
	RecordConnectInput: RecordConnectInput;
	RecordConnectWhere: RecordConnectWhere;
	RecordCreateInput: RecordCreateInput;
	RecordDeleteInput: RecordDeleteInput;
	RecordDeviceRecordAggregateInput: RecordDeviceRecordAggregateInput;
	RecordDeviceRecordConnectFieldInput: RecordDeviceRecordConnectFieldInput;
	RecordDeviceRecordConnection: ResolverTypeWrapper<RecordDeviceRecordConnection>;
	RecordDeviceRecordConnectionSort: RecordDeviceRecordConnectionSort;
	RecordDeviceRecordConnectionWhere: RecordDeviceRecordConnectionWhere;
	RecordDeviceRecordCreateFieldInput: RecordDeviceRecordCreateFieldInput;
	RecordDeviceRecordDeleteFieldInput: RecordDeviceRecordDeleteFieldInput;
	RecordDeviceRecordDisconnectFieldInput: RecordDeviceRecordDisconnectFieldInput;
	RecordDeviceRecordFieldInput: RecordDeviceRecordFieldInput;
	RecordDeviceRecordNodeAggregationWhereInput: RecordDeviceRecordNodeAggregationWhereInput;
	RecordDeviceRecordRelationship: ResolverTypeWrapper<RecordDeviceRecordRelationship>;
	RecordDeviceRecordUpdateConnectionInput: RecordDeviceRecordUpdateConnectionInput;
	RecordDeviceRecordUpdateFieldInput: RecordDeviceRecordUpdateFieldInput;
	RecordDisconnectInput: RecordDisconnectInput;
	RecordNature: RecordNature;
	RecordOptions: RecordOptions;
	RecordSort: RecordSort;
	RecordStatus: RecordStatus;
	RecordType: RecordType;
	RecordUpdateInput: RecordUpdateInput;
	RecordWhere: RecordWhere;
	RecordsTypeEnum: RecordsTypeEnum;
	Refund: ResolverTypeWrapper<Refund>;
	RefundAggregateSelection: ResolverTypeWrapper<RefundAggregateSelection>;
	RefundCaseAggregateInput: RefundCaseAggregateInput;
	RefundCaseConnectFieldInput: RefundCaseConnectFieldInput;
	RefundCaseConnection: ResolverTypeWrapper<RefundCaseConnection>;
	RefundCaseConnectionSort: RefundCaseConnectionSort;
	RefundCaseConnectionWhere: RefundCaseConnectionWhere;
	RefundCaseCreateFieldInput: RefundCaseCreateFieldInput;
	RefundCaseDeleteFieldInput: RefundCaseDeleteFieldInput;
	RefundCaseDisconnectFieldInput: RefundCaseDisconnectFieldInput;
	RefundCaseFieldInput: RefundCaseFieldInput;
	RefundCaseNodeAggregationWhereInput: RefundCaseNodeAggregationWhereInput;
	RefundCaseRelationship: ResolverTypeWrapper<RefundCaseRelationship>;
	RefundCaseUpdateConnectionInput: RefundCaseUpdateConnectionInput;
	RefundCaseUpdateFieldInput: RefundCaseUpdateFieldInput;
	RefundConnectInput: RefundConnectInput;
	RefundConnectWhere: RefundConnectWhere;
	RefundCreateInput: RefundCreateInput;
	RefundDeleteInput: RefundDeleteInput;
	RefundDisconnectInput: RefundDisconnectInput;
	RefundInvoiceFinancialDataPointsAggregateInput: RefundInvoiceFinancialDataPointsAggregateInput;
	RefundInvoiceFinancialDataPointsConnectFieldInput: RefundInvoiceFinancialDataPointsConnectFieldInput;
	RefundInvoiceFinancialDataPointsConnection: ResolverTypeWrapper<RefundInvoiceFinancialDataPointsConnection>;
	RefundInvoiceFinancialDataPointsConnectionSort: RefundInvoiceFinancialDataPointsConnectionSort;
	RefundInvoiceFinancialDataPointsConnectionWhere: RefundInvoiceFinancialDataPointsConnectionWhere;
	RefundInvoiceFinancialDataPointsCreateFieldInput: RefundInvoiceFinancialDataPointsCreateFieldInput;
	RefundInvoiceFinancialDataPointsDeleteFieldInput: RefundInvoiceFinancialDataPointsDeleteFieldInput;
	RefundInvoiceFinancialDataPointsDisconnectFieldInput: RefundInvoiceFinancialDataPointsDisconnectFieldInput;
	RefundInvoiceFinancialDataPointsEdgeAggregationWhereInput: RefundInvoiceFinancialDataPointsEdgeAggregationWhereInput;
	RefundInvoiceFinancialDataPointsFieldInput: RefundInvoiceFinancialDataPointsFieldInput;
	RefundInvoiceFinancialDataPointsNodeAggregationWhereInput: RefundInvoiceFinancialDataPointsNodeAggregationWhereInput;
	RefundInvoiceFinancialDataPointsRelationship: ResolverTypeWrapper<RefundInvoiceFinancialDataPointsRelationship>;
	RefundInvoiceFinancialDataPointsUpdateConnectionInput: RefundInvoiceFinancialDataPointsUpdateConnectionInput;
	RefundInvoiceFinancialDataPointsUpdateFieldInput: RefundInvoiceFinancialDataPointsUpdateFieldInput;
	RefundInvoicesAggregateInput: RefundInvoicesAggregateInput;
	RefundInvoicesConnectFieldInput: RefundInvoicesConnectFieldInput;
	RefundInvoicesConnection: ResolverTypeWrapper<RefundInvoicesConnection>;
	RefundInvoicesConnectionSort: RefundInvoicesConnectionSort;
	RefundInvoicesConnectionWhere: RefundInvoicesConnectionWhere;
	RefundInvoicesCreateFieldInput: RefundInvoicesCreateFieldInput;
	RefundInvoicesDeleteFieldInput: RefundInvoicesDeleteFieldInput;
	RefundInvoicesDisconnectFieldInput: RefundInvoicesDisconnectFieldInput;
	RefundInvoicesFieldInput: RefundInvoicesFieldInput;
	RefundInvoicesNodeAggregationWhereInput: RefundInvoicesNodeAggregationWhereInput;
	RefundInvoicesRelationship: ResolverTypeWrapper<RefundInvoicesRelationship>;
	RefundInvoicesUpdateConnectionInput: RefundInvoicesUpdateConnectionInput;
	RefundInvoicesUpdateFieldInput: RefundInvoicesUpdateFieldInput;
	RefundMessageAggregateInput: RefundMessageAggregateInput;
	RefundMessageConnectFieldInput: RefundMessageConnectFieldInput;
	RefundMessageConnection: ResolverTypeWrapper<RefundMessageConnection>;
	RefundMessageConnectionSort: RefundMessageConnectionSort;
	RefundMessageConnectionWhere: RefundMessageConnectionWhere;
	RefundMessageCreateFieldInput: RefundMessageCreateFieldInput;
	RefundMessageDeleteFieldInput: RefundMessageDeleteFieldInput;
	RefundMessageDisconnectFieldInput: RefundMessageDisconnectFieldInput;
	RefundMessageFieldInput: RefundMessageFieldInput;
	RefundMessageNodeAggregationWhereInput: RefundMessageNodeAggregationWhereInput;
	RefundMessageRelationship: ResolverTypeWrapper<RefundMessageRelationship>;
	RefundMessageUpdateConnectionInput: RefundMessageUpdateConnectionInput;
	RefundMessageUpdateFieldInput: RefundMessageUpdateFieldInput;
	RefundOptions: RefundOptions;
	RefundSort: RefundSort;
	RefundSourceFinancialDataPointsAggregateInput: RefundSourceFinancialDataPointsAggregateInput;
	RefundSourceFinancialDataPointsConnectFieldInput: RefundSourceFinancialDataPointsConnectFieldInput;
	RefundSourceFinancialDataPointsConnection: ResolverTypeWrapper<RefundSourceFinancialDataPointsConnection>;
	RefundSourceFinancialDataPointsConnectionSort: RefundSourceFinancialDataPointsConnectionSort;
	RefundSourceFinancialDataPointsConnectionWhere: RefundSourceFinancialDataPointsConnectionWhere;
	RefundSourceFinancialDataPointsCreateFieldInput: RefundSourceFinancialDataPointsCreateFieldInput;
	RefundSourceFinancialDataPointsDeleteFieldInput: RefundSourceFinancialDataPointsDeleteFieldInput;
	RefundSourceFinancialDataPointsDisconnectFieldInput: RefundSourceFinancialDataPointsDisconnectFieldInput;
	RefundSourceFinancialDataPointsFieldInput: RefundSourceFinancialDataPointsFieldInput;
	RefundSourceFinancialDataPointsNodeAggregationWhereInput: RefundSourceFinancialDataPointsNodeAggregationWhereInput;
	RefundSourceFinancialDataPointsRelationship: ResolverTypeWrapper<RefundSourceFinancialDataPointsRelationship>;
	RefundSourceFinancialDataPointsUpdateConnectionInput: RefundSourceFinancialDataPointsUpdateConnectionInput;
	RefundSourceFinancialDataPointsUpdateFieldInput: RefundSourceFinancialDataPointsUpdateFieldInput;
	RefundStatus: RefundStatus;
	RefundTagsAggregateInput: RefundTagsAggregateInput;
	RefundTagsConnectFieldInput: RefundTagsConnectFieldInput;
	RefundTagsConnection: ResolverTypeWrapper<RefundTagsConnection>;
	RefundTagsConnectionSort: RefundTagsConnectionSort;
	RefundTagsConnectionWhere: RefundTagsConnectionWhere;
	RefundTagsCreateFieldInput: RefundTagsCreateFieldInput;
	RefundTagsDeleteFieldInput: RefundTagsDeleteFieldInput;
	RefundTagsDisconnectFieldInput: RefundTagsDisconnectFieldInput;
	RefundTagsFieldInput: RefundTagsFieldInput;
	RefundTagsNodeAggregationWhereInput: RefundTagsNodeAggregationWhereInput;
	RefundTagsRelationship: ResolverTypeWrapper<RefundTagsRelationship>;
	RefundTagsUpdateConnectionInput: RefundTagsUpdateConnectionInput;
	RefundTagsUpdateFieldInput: RefundTagsUpdateFieldInput;
	RefundUpdateInput: RefundUpdateInput;
	RefundWhere: RefundWhere;
	Reintervention: Reintervention;
	ReportInterventionType: ReportInterventionType;
	ReportItemsUsedFilter: ReportItemsUsedFilter;
	ReportingSummary: ResolverTypeWrapper<ReportingSummary>;
	ReportingSummaryAggregateSelection: ResolverTypeWrapper<ReportingSummaryAggregateSelection>;
	ReportingSummaryOptions: ReportingSummaryOptions;
	ReportingSummarySort: ReportingSummarySort;
	ReportingSummaryWhere: ReportingSummaryWhere;
	ResponseInclusionType: ResponseInclusionType;
	ResponseType: ResponseType;
	SaveReviewedInvoiceInput: SaveReviewedInvoiceInput;
	Scenario: ResolverTypeWrapper<Scenario>;
	ScenarioAction: ResolverTypeWrapper<ScenarioAction>;
	ScenarioActionAggregateSelection: ResolverTypeWrapper<ScenarioActionAggregateSelection>;
	ScenarioActionBrandAggregateInput: ScenarioActionBrandAggregateInput;
	ScenarioActionBrandConnectFieldInput: ScenarioActionBrandConnectFieldInput;
	ScenarioActionBrandConnection: ResolverTypeWrapper<ScenarioActionBrandConnection>;
	ScenarioActionBrandConnectionSort: ScenarioActionBrandConnectionSort;
	ScenarioActionBrandConnectionWhere: ScenarioActionBrandConnectionWhere;
	ScenarioActionBrandCreateFieldInput: ScenarioActionBrandCreateFieldInput;
	ScenarioActionBrandDeleteFieldInput: ScenarioActionBrandDeleteFieldInput;
	ScenarioActionBrandDisconnectFieldInput: ScenarioActionBrandDisconnectFieldInput;
	ScenarioActionBrandFieldInput: ScenarioActionBrandFieldInput;
	ScenarioActionBrandNodeAggregationWhereInput: ScenarioActionBrandNodeAggregationWhereInput;
	ScenarioActionBrandRelationship: ResolverTypeWrapper<ScenarioActionBrandRelationship>;
	ScenarioActionBrandUpdateConnectionInput: ScenarioActionBrandUpdateConnectionInput;
	ScenarioActionBrandUpdateFieldInput: ScenarioActionBrandUpdateFieldInput;
	ScenarioActionCategoriesAggregateInput: ScenarioActionCategoriesAggregateInput;
	ScenarioActionCategoriesConnectFieldInput: ScenarioActionCategoriesConnectFieldInput;
	ScenarioActionCategoriesConnection: ResolverTypeWrapper<ScenarioActionCategoriesConnection>;
	ScenarioActionCategoriesConnectionSort: ScenarioActionCategoriesConnectionSort;
	ScenarioActionCategoriesConnectionWhere: ScenarioActionCategoriesConnectionWhere;
	ScenarioActionCategoriesCreateFieldInput: ScenarioActionCategoriesCreateFieldInput;
	ScenarioActionCategoriesDeleteFieldInput: ScenarioActionCategoriesDeleteFieldInput;
	ScenarioActionCategoriesDisconnectFieldInput: ScenarioActionCategoriesDisconnectFieldInput;
	ScenarioActionCategoriesFieldInput: ScenarioActionCategoriesFieldInput;
	ScenarioActionCategoriesNodeAggregationWhereInput: ScenarioActionCategoriesNodeAggregationWhereInput;
	ScenarioActionCategoriesRelationship: ResolverTypeWrapper<ScenarioActionCategoriesRelationship>;
	ScenarioActionCategoriesUpdateConnectionInput: ScenarioActionCategoriesUpdateConnectionInput;
	ScenarioActionCategoriesUpdateFieldInput: ScenarioActionCategoriesUpdateFieldInput;
	ScenarioActionCombinedItemBrandsAggregateInput: ScenarioActionCombinedItemBrandsAggregateInput;
	ScenarioActionCombinedItemBrandsConnectFieldInput: ScenarioActionCombinedItemBrandsConnectFieldInput;
	ScenarioActionCombinedItemBrandsConnection: ResolverTypeWrapper<ScenarioActionCombinedItemBrandsConnection>;
	ScenarioActionCombinedItemBrandsConnectionSort: ScenarioActionCombinedItemBrandsConnectionSort;
	ScenarioActionCombinedItemBrandsConnectionWhere: ScenarioActionCombinedItemBrandsConnectionWhere;
	ScenarioActionCombinedItemBrandsCreateFieldInput: ScenarioActionCombinedItemBrandsCreateFieldInput;
	ScenarioActionCombinedItemBrandsDeleteFieldInput: ScenarioActionCombinedItemBrandsDeleteFieldInput;
	ScenarioActionCombinedItemBrandsDisconnectFieldInput: ScenarioActionCombinedItemBrandsDisconnectFieldInput;
	ScenarioActionCombinedItemBrandsFieldInput: ScenarioActionCombinedItemBrandsFieldInput;
	ScenarioActionCombinedItemBrandsNodeAggregationWhereInput: ScenarioActionCombinedItemBrandsNodeAggregationWhereInput;
	ScenarioActionCombinedItemBrandsRelationship: ResolverTypeWrapper<ScenarioActionCombinedItemBrandsRelationship>;
	ScenarioActionCombinedItemBrandsUpdateConnectionInput: ScenarioActionCombinedItemBrandsUpdateConnectionInput;
	ScenarioActionCombinedItemBrandsUpdateFieldInput: ScenarioActionCombinedItemBrandsUpdateFieldInput;
	ScenarioActionCombinedItemTreatmentsAggregateInput: ScenarioActionCombinedItemTreatmentsAggregateInput;
	ScenarioActionCombinedItemTreatmentsConnectFieldInput: ScenarioActionCombinedItemTreatmentsConnectFieldInput;
	ScenarioActionCombinedItemTreatmentsConnection: ResolverTypeWrapper<ScenarioActionCombinedItemTreatmentsConnection>;
	ScenarioActionCombinedItemTreatmentsConnectionSort: ScenarioActionCombinedItemTreatmentsConnectionSort;
	ScenarioActionCombinedItemTreatmentsConnectionWhere: ScenarioActionCombinedItemTreatmentsConnectionWhere;
	ScenarioActionCombinedItemTreatmentsCreateFieldInput: ScenarioActionCombinedItemTreatmentsCreateFieldInput;
	ScenarioActionCombinedItemTreatmentsDeleteFieldInput: ScenarioActionCombinedItemTreatmentsDeleteFieldInput;
	ScenarioActionCombinedItemTreatmentsDisconnectFieldInput: ScenarioActionCombinedItemTreatmentsDisconnectFieldInput;
	ScenarioActionCombinedItemTreatmentsFieldInput: ScenarioActionCombinedItemTreatmentsFieldInput;
	ScenarioActionCombinedItemTreatmentsNodeAggregationWhereInput: ScenarioActionCombinedItemTreatmentsNodeAggregationWhereInput;
	ScenarioActionCombinedItemTreatmentsRelationship: ResolverTypeWrapper<ScenarioActionCombinedItemTreatmentsRelationship>;
	ScenarioActionCombinedItemTreatmentsUpdateConnectionInput: ScenarioActionCombinedItemTreatmentsUpdateConnectionInput;
	ScenarioActionCombinedItemTreatmentsUpdateFieldInput: ScenarioActionCombinedItemTreatmentsUpdateFieldInput;
	ScenarioActionConnectInput: ScenarioActionConnectInput;
	ScenarioActionConnectWhere: ScenarioActionConnectWhere;
	ScenarioActionCreateInput: ScenarioActionCreateInput;
	ScenarioActionDeleteInput: ScenarioActionDeleteInput;
	ScenarioActionDeviceKitsAggregateInput: ScenarioActionDeviceKitsAggregateInput;
	ScenarioActionDeviceKitsConnectFieldInput: ScenarioActionDeviceKitsConnectFieldInput;
	ScenarioActionDeviceKitsConnection: ResolverTypeWrapper<ScenarioActionDeviceKitsConnection>;
	ScenarioActionDeviceKitsConnectionSort: ScenarioActionDeviceKitsConnectionSort;
	ScenarioActionDeviceKitsConnectionWhere: ScenarioActionDeviceKitsConnectionWhere;
	ScenarioActionDeviceKitsCreateFieldInput: ScenarioActionDeviceKitsCreateFieldInput;
	ScenarioActionDeviceKitsDeleteFieldInput: ScenarioActionDeviceKitsDeleteFieldInput;
	ScenarioActionDeviceKitsDisconnectFieldInput: ScenarioActionDeviceKitsDisconnectFieldInput;
	ScenarioActionDeviceKitsFieldInput: ScenarioActionDeviceKitsFieldInput;
	ScenarioActionDeviceKitsNodeAggregationWhereInput: ScenarioActionDeviceKitsNodeAggregationWhereInput;
	ScenarioActionDeviceKitsRelationship: ResolverTypeWrapper<ScenarioActionDeviceKitsRelationship>;
	ScenarioActionDeviceKitsUpdateConnectionInput: ScenarioActionDeviceKitsUpdateConnectionInput;
	ScenarioActionDeviceKitsUpdateFieldInput: ScenarioActionDeviceKitsUpdateFieldInput;
	ScenarioActionDisconnectInput: ScenarioActionDisconnectInput;
	ScenarioActionOptions: ScenarioActionOptions;
	ScenarioActionScenarioAggregateInput: ScenarioActionScenarioAggregateInput;
	ScenarioActionScenarioConnectFieldInput: ScenarioActionScenarioConnectFieldInput;
	ScenarioActionScenarioConnection: ResolverTypeWrapper<ScenarioActionScenarioConnection>;
	ScenarioActionScenarioConnectionSort: ScenarioActionScenarioConnectionSort;
	ScenarioActionScenarioConnectionWhere: ScenarioActionScenarioConnectionWhere;
	ScenarioActionScenarioCreateFieldInput: ScenarioActionScenarioCreateFieldInput;
	ScenarioActionScenarioDeleteFieldInput: ScenarioActionScenarioDeleteFieldInput;
	ScenarioActionScenarioDisconnectFieldInput: ScenarioActionScenarioDisconnectFieldInput;
	ScenarioActionScenarioFieldInput: ScenarioActionScenarioFieldInput;
	ScenarioActionScenarioNodeAggregationWhereInput: ScenarioActionScenarioNodeAggregationWhereInput;
	ScenarioActionScenarioRelationship: ResolverTypeWrapper<ScenarioActionScenarioRelationship>;
	ScenarioActionScenarioUpdateConnectionInput: ScenarioActionScenarioUpdateConnectionInput;
	ScenarioActionScenarioUpdateFieldInput: ScenarioActionScenarioUpdateFieldInput;
	ScenarioActionSort: ScenarioActionSort;
	ScenarioActionTimeframeAggregateInput: ScenarioActionTimeframeAggregateInput;
	ScenarioActionTimeframeConnectFieldInput: ScenarioActionTimeframeConnectFieldInput;
	ScenarioActionTimeframeConnection: ResolverTypeWrapper<ScenarioActionTimeframeConnection>;
	ScenarioActionTimeframeConnectionSort: ScenarioActionTimeframeConnectionSort;
	ScenarioActionTimeframeConnectionWhere: ScenarioActionTimeframeConnectionWhere;
	ScenarioActionTimeframeCreateFieldInput: ScenarioActionTimeframeCreateFieldInput;
	ScenarioActionTimeframeDeleteFieldInput: ScenarioActionTimeframeDeleteFieldInput;
	ScenarioActionTimeframeDisconnectFieldInput: ScenarioActionTimeframeDisconnectFieldInput;
	ScenarioActionTimeframeFieldInput: ScenarioActionTimeframeFieldInput;
	ScenarioActionTimeframeNodeAggregationWhereInput: ScenarioActionTimeframeNodeAggregationWhereInput;
	ScenarioActionTimeframeRelationship: ResolverTypeWrapper<ScenarioActionTimeframeRelationship>;
	ScenarioActionTimeframeUpdateConnectionInput: ScenarioActionTimeframeUpdateConnectionInput;
	ScenarioActionTimeframeUpdateFieldInput: ScenarioActionTimeframeUpdateFieldInput;
	ScenarioActionTreatmentAggregateInput: ScenarioActionTreatmentAggregateInput;
	ScenarioActionTreatmentConnectFieldInput: ScenarioActionTreatmentConnectFieldInput;
	ScenarioActionTreatmentConnection: ResolverTypeWrapper<ScenarioActionTreatmentConnection>;
	ScenarioActionTreatmentConnectionSort: ScenarioActionTreatmentConnectionSort;
	ScenarioActionTreatmentConnectionWhere: ScenarioActionTreatmentConnectionWhere;
	ScenarioActionTreatmentCreateFieldInput: ScenarioActionTreatmentCreateFieldInput;
	ScenarioActionTreatmentDeleteFieldInput: ScenarioActionTreatmentDeleteFieldInput;
	ScenarioActionTreatmentDisconnectFieldInput: ScenarioActionTreatmentDisconnectFieldInput;
	ScenarioActionTreatmentFieldInput: ScenarioActionTreatmentFieldInput;
	ScenarioActionTreatmentNodeAggregationWhereInput: ScenarioActionTreatmentNodeAggregationWhereInput;
	ScenarioActionTreatmentRelationship: ResolverTypeWrapper<ScenarioActionTreatmentRelationship>;
	ScenarioActionTreatmentUpdateConnectionInput: ScenarioActionTreatmentUpdateConnectionInput;
	ScenarioActionTreatmentUpdateFieldInput: ScenarioActionTreatmentUpdateFieldInput;
	ScenarioActionUpdateInput: ScenarioActionUpdateInput;
	ScenarioActionWhere: ScenarioActionWhere;
	ScenarioActionsAggregateInput: ScenarioActionsAggregateInput;
	ScenarioActionsConnectFieldInput: ScenarioActionsConnectFieldInput;
	ScenarioActionsConnection: ResolverTypeWrapper<ScenarioActionsConnection>;
	ScenarioActionsConnectionSort: ScenarioActionsConnectionSort;
	ScenarioActionsConnectionWhere: ScenarioActionsConnectionWhere;
	ScenarioActionsCreateFieldInput: ScenarioActionsCreateFieldInput;
	ScenarioActionsDeleteFieldInput: ScenarioActionsDeleteFieldInput;
	ScenarioActionsDisconnectFieldInput: ScenarioActionsDisconnectFieldInput;
	ScenarioActionsFieldInput: ScenarioActionsFieldInput;
	ScenarioActionsNodeAggregationWhereInput: ScenarioActionsNodeAggregationWhereInput;
	ScenarioActionsRelationship: ResolverTypeWrapper<ScenarioActionsRelationship>;
	ScenarioActionsUpdateConnectionInput: ScenarioActionsUpdateConnectionInput;
	ScenarioActionsUpdateFieldInput: ScenarioActionsUpdateFieldInput;
	ScenarioAggregateSelection: ResolverTypeWrapper<ScenarioAggregateSelection>;
	ScenarioAgreementAggregateInput: ScenarioAgreementAggregateInput;
	ScenarioAgreementConnectFieldInput: ScenarioAgreementConnectFieldInput;
	ScenarioAgreementConnection: ResolverTypeWrapper<ScenarioAgreementConnection>;
	ScenarioAgreementConnectionSort: ScenarioAgreementConnectionSort;
	ScenarioAgreementConnectionWhere: ScenarioAgreementConnectionWhere;
	ScenarioAgreementCreateFieldInput: ScenarioAgreementCreateFieldInput;
	ScenarioAgreementDeleteFieldInput: ScenarioAgreementDeleteFieldInput;
	ScenarioAgreementDisconnectFieldInput: ScenarioAgreementDisconnectFieldInput;
	ScenarioAgreementFieldInput: ScenarioAgreementFieldInput;
	ScenarioAgreementNodeAggregationWhereInput: ScenarioAgreementNodeAggregationWhereInput;
	ScenarioAgreementRelationship: ResolverTypeWrapper<ScenarioAgreementRelationship>;
	ScenarioAgreementUpdateConnectionInput: ScenarioAgreementUpdateConnectionInput;
	ScenarioAgreementUpdateFieldInput: ScenarioAgreementUpdateFieldInput;
	ScenarioCondition: ResolverTypeWrapper<ScenarioCondition>;
	ScenarioConditionAggregateSelection: ResolverTypeWrapper<ScenarioConditionAggregateSelection>;
	ScenarioConditionBrandAggregateInput: ScenarioConditionBrandAggregateInput;
	ScenarioConditionBrandConnectFieldInput: ScenarioConditionBrandConnectFieldInput;
	ScenarioConditionBrandConnection: ResolverTypeWrapper<ScenarioConditionBrandConnection>;
	ScenarioConditionBrandConnectionSort: ScenarioConditionBrandConnectionSort;
	ScenarioConditionBrandConnectionWhere: ScenarioConditionBrandConnectionWhere;
	ScenarioConditionBrandCreateFieldInput: ScenarioConditionBrandCreateFieldInput;
	ScenarioConditionBrandDeleteFieldInput: ScenarioConditionBrandDeleteFieldInput;
	ScenarioConditionBrandDisconnectFieldInput: ScenarioConditionBrandDisconnectFieldInput;
	ScenarioConditionBrandFieldInput: ScenarioConditionBrandFieldInput;
	ScenarioConditionBrandNodeAggregationWhereInput: ScenarioConditionBrandNodeAggregationWhereInput;
	ScenarioConditionBrandRelationship: ResolverTypeWrapper<ScenarioConditionBrandRelationship>;
	ScenarioConditionBrandUpdateConnectionInput: ScenarioConditionBrandUpdateConnectionInput;
	ScenarioConditionBrandUpdateFieldInput: ScenarioConditionBrandUpdateFieldInput;
	ScenarioConditionConnectInput: ScenarioConditionConnectInput;
	ScenarioConditionConnectWhere: ScenarioConditionConnectWhere;
	ScenarioConditionCreateInput: ScenarioConditionCreateInput;
	ScenarioConditionDeleteInput: ScenarioConditionDeleteInput;
	ScenarioConditionDeviceKitsAggregateInput: ScenarioConditionDeviceKitsAggregateInput;
	ScenarioConditionDeviceKitsConnectFieldInput: ScenarioConditionDeviceKitsConnectFieldInput;
	ScenarioConditionDeviceKitsConnection: ResolverTypeWrapper<ScenarioConditionDeviceKitsConnection>;
	ScenarioConditionDeviceKitsConnectionSort: ScenarioConditionDeviceKitsConnectionSort;
	ScenarioConditionDeviceKitsConnectionWhere: ScenarioConditionDeviceKitsConnectionWhere;
	ScenarioConditionDeviceKitsCreateFieldInput: ScenarioConditionDeviceKitsCreateFieldInput;
	ScenarioConditionDeviceKitsDeleteFieldInput: ScenarioConditionDeviceKitsDeleteFieldInput;
	ScenarioConditionDeviceKitsDisconnectFieldInput: ScenarioConditionDeviceKitsDisconnectFieldInput;
	ScenarioConditionDeviceKitsFieldInput: ScenarioConditionDeviceKitsFieldInput;
	ScenarioConditionDeviceKitsNodeAggregationWhereInput: ScenarioConditionDeviceKitsNodeAggregationWhereInput;
	ScenarioConditionDeviceKitsRelationship: ResolverTypeWrapper<ScenarioConditionDeviceKitsRelationship>;
	ScenarioConditionDeviceKitsUpdateConnectionInput: ScenarioConditionDeviceKitsUpdateConnectionInput;
	ScenarioConditionDeviceKitsUpdateFieldInput: ScenarioConditionDeviceKitsUpdateFieldInput;
	ScenarioConditionDisconnectInput: ScenarioConditionDisconnectInput;
	ScenarioConditionOptions: ScenarioConditionOptions;
	ScenarioConditionScenarioAggregateInput: ScenarioConditionScenarioAggregateInput;
	ScenarioConditionScenarioConnectFieldInput: ScenarioConditionScenarioConnectFieldInput;
	ScenarioConditionScenarioConnection: ResolverTypeWrapper<ScenarioConditionScenarioConnection>;
	ScenarioConditionScenarioConnectionSort: ScenarioConditionScenarioConnectionSort;
	ScenarioConditionScenarioConnectionWhere: ScenarioConditionScenarioConnectionWhere;
	ScenarioConditionScenarioCreateFieldInput: ScenarioConditionScenarioCreateFieldInput;
	ScenarioConditionScenarioDeleteFieldInput: ScenarioConditionScenarioDeleteFieldInput;
	ScenarioConditionScenarioDisconnectFieldInput: ScenarioConditionScenarioDisconnectFieldInput;
	ScenarioConditionScenarioFieldInput: ScenarioConditionScenarioFieldInput;
	ScenarioConditionScenarioNodeAggregationWhereInput: ScenarioConditionScenarioNodeAggregationWhereInput;
	ScenarioConditionScenarioRelationship: ResolverTypeWrapper<ScenarioConditionScenarioRelationship>;
	ScenarioConditionScenarioUpdateConnectionInput: ScenarioConditionScenarioUpdateConnectionInput;
	ScenarioConditionScenarioUpdateFieldInput: ScenarioConditionScenarioUpdateFieldInput;
	ScenarioConditionSort: ScenarioConditionSort;
	ScenarioConditionTimeframeAggregateInput: ScenarioConditionTimeframeAggregateInput;
	ScenarioConditionTimeframeConnectFieldInput: ScenarioConditionTimeframeConnectFieldInput;
	ScenarioConditionTimeframeConnection: ResolverTypeWrapper<ScenarioConditionTimeframeConnection>;
	ScenarioConditionTimeframeConnectionSort: ScenarioConditionTimeframeConnectionSort;
	ScenarioConditionTimeframeConnectionWhere: ScenarioConditionTimeframeConnectionWhere;
	ScenarioConditionTimeframeCreateFieldInput: ScenarioConditionTimeframeCreateFieldInput;
	ScenarioConditionTimeframeDeleteFieldInput: ScenarioConditionTimeframeDeleteFieldInput;
	ScenarioConditionTimeframeDisconnectFieldInput: ScenarioConditionTimeframeDisconnectFieldInput;
	ScenarioConditionTimeframeFieldInput: ScenarioConditionTimeframeFieldInput;
	ScenarioConditionTimeframeNodeAggregationWhereInput: ScenarioConditionTimeframeNodeAggregationWhereInput;
	ScenarioConditionTimeframeRelationship: ResolverTypeWrapper<ScenarioConditionTimeframeRelationship>;
	ScenarioConditionTimeframeUpdateConnectionInput: ScenarioConditionTimeframeUpdateConnectionInput;
	ScenarioConditionTimeframeUpdateFieldInput: ScenarioConditionTimeframeUpdateFieldInput;
	ScenarioConditionTreatmentAggregateInput: ScenarioConditionTreatmentAggregateInput;
	ScenarioConditionTreatmentConnectFieldInput: ScenarioConditionTreatmentConnectFieldInput;
	ScenarioConditionTreatmentConnection: ResolverTypeWrapper<ScenarioConditionTreatmentConnection>;
	ScenarioConditionTreatmentConnectionSort: ScenarioConditionTreatmentConnectionSort;
	ScenarioConditionTreatmentConnectionWhere: ScenarioConditionTreatmentConnectionWhere;
	ScenarioConditionTreatmentCreateFieldInput: ScenarioConditionTreatmentCreateFieldInput;
	ScenarioConditionTreatmentDeleteFieldInput: ScenarioConditionTreatmentDeleteFieldInput;
	ScenarioConditionTreatmentDisconnectFieldInput: ScenarioConditionTreatmentDisconnectFieldInput;
	ScenarioConditionTreatmentFieldInput: ScenarioConditionTreatmentFieldInput;
	ScenarioConditionTreatmentNodeAggregationWhereInput: ScenarioConditionTreatmentNodeAggregationWhereInput;
	ScenarioConditionTreatmentRelationship: ResolverTypeWrapper<ScenarioConditionTreatmentRelationship>;
	ScenarioConditionTreatmentUpdateConnectionInput: ScenarioConditionTreatmentUpdateConnectionInput;
	ScenarioConditionTreatmentUpdateFieldInput: ScenarioConditionTreatmentUpdateFieldInput;
	ScenarioConditionUpdateInput: ScenarioConditionUpdateInput;
	ScenarioConditionWhere: ScenarioConditionWhere;
	ScenarioConditionsAggregateInput: ScenarioConditionsAggregateInput;
	ScenarioConditionsConnectFieldInput: ScenarioConditionsConnectFieldInput;
	ScenarioConditionsConnection: ResolverTypeWrapper<ScenarioConditionsConnection>;
	ScenarioConditionsConnectionSort: ScenarioConditionsConnectionSort;
	ScenarioConditionsConnectionWhere: ScenarioConditionsConnectionWhere;
	ScenarioConditionsCreateFieldInput: ScenarioConditionsCreateFieldInput;
	ScenarioConditionsDeleteFieldInput: ScenarioConditionsDeleteFieldInput;
	ScenarioConditionsDisconnectFieldInput: ScenarioConditionsDisconnectFieldInput;
	ScenarioConditionsFieldInput: ScenarioConditionsFieldInput;
	ScenarioConditionsNodeAggregationWhereInput: ScenarioConditionsNodeAggregationWhereInput;
	ScenarioConditionsRelationship: ResolverTypeWrapper<ScenarioConditionsRelationship>;
	ScenarioConditionsUpdateConnectionInput: ScenarioConditionsUpdateConnectionInput;
	ScenarioConditionsUpdateFieldInput: ScenarioConditionsUpdateFieldInput;
	ScenarioConnectInput: ScenarioConnectInput;
	ScenarioConnectWhere: ScenarioConnectWhere;
	ScenarioCreateInput: ScenarioCreateInput;
	ScenarioDeleteInput: ScenarioDeleteInput;
	ScenarioDisconnectInput: ScenarioDisconnectInput;
	ScenarioInsightsUserContext:
		| ResolversTypes["BaseAgreementUserContextsRelationship"]
		| ResolversTypes["UserContextBaseAgreementContextRelationship"]
		| ResolversTypes["UserContextScenariosRelationship"];
	ScenarioInsightsUserContextCreateInput: ScenarioInsightsUserContextCreateInput;
	ScenarioInsightsUserContextInput: ScenarioInsightsUserContextInput;
	ScenarioInsightsUserContextSort: ScenarioInsightsUserContextSort;
	ScenarioInsightsUserContextUpdateInput: ScenarioInsightsUserContextUpdateInput;
	ScenarioInsightsUserContextWhere: ScenarioInsightsUserContextWhere;
	ScenarioOptions: ScenarioOptions;
	ScenarioSort: ScenarioSort;
	ScenarioUpdateInput: ScenarioUpdateInput;
	ScenarioWhere: ScenarioWhere;
	SearchUserEmailByNameInput: SearchUserEmailByNameInput;
	SentClaimRelationship: ResolversTypes["PatientSentClaimRelationship"];
	SentClaimRelationshipCreateInput: SentClaimRelationshipCreateInput;
	SentClaimRelationshipSort: SentClaimRelationshipSort;
	SentClaimRelationshipUpdateInput: SentClaimRelationshipUpdateInput;
	SentClaimRelationshipWhere: SentClaimRelationshipWhere;
	SortDirection: SortDirection;
	StobAction: ResolverTypeWrapper<StobAction>;
	StobActionAggregateSelection: ResolverTypeWrapper<StobActionAggregateSelection>;
	StobActionConnectInput: StobActionConnectInput;
	StobActionConnectWhere: StobActionConnectWhere;
	StobActionCreateInput: StobActionCreateInput;
	StobActionDeleteInput: StobActionDeleteInput;
	StobActionDisconnectInput: StobActionDisconnectInput;
	StobActionInput: StobActionInput;
	StobActionMeasureUnit: StobActionMeasureUnit;
	StobActionObject: StobActionObject;
	StobActionOptions: StobActionOptions;
	StobActionScenarioAggregateInput: StobActionScenarioAggregateInput;
	StobActionScenarioConnectFieldInput: StobActionScenarioConnectFieldInput;
	StobActionScenarioConnection: ResolverTypeWrapper<StobActionScenarioConnection>;
	StobActionScenarioConnectionSort: StobActionScenarioConnectionSort;
	StobActionScenarioConnectionWhere: StobActionScenarioConnectionWhere;
	StobActionScenarioCreateFieldInput: StobActionScenarioCreateFieldInput;
	StobActionScenarioDeleteFieldInput: StobActionScenarioDeleteFieldInput;
	StobActionScenarioDisconnectFieldInput: StobActionScenarioDisconnectFieldInput;
	StobActionScenarioFieldInput: StobActionScenarioFieldInput;
	StobActionScenarioNodeAggregationWhereInput: StobActionScenarioNodeAggregationWhereInput;
	StobActionScenarioRelationship: ResolverTypeWrapper<StobActionScenarioRelationship>;
	StobActionScenarioUpdateConnectionInput: StobActionScenarioUpdateConnectionInput;
	StobActionScenarioUpdateFieldInput: StobActionScenarioUpdateFieldInput;
	StobActionSort: StobActionSort;
	StobActionType: StobActionType;
	StobActionUpdateInput: StobActionUpdateInput;
	StobActionWhere: StobActionWhere;
	StobCondition: ResolverTypeWrapper<StobCondition>;
	StobConditionAggregateSelection: ResolverTypeWrapper<StobConditionAggregateSelection>;
	StobConditionConnectInput: StobConditionConnectInput;
	StobConditionConnectWhere: StobConditionConnectWhere;
	StobConditionCreateInput: StobConditionCreateInput;
	StobConditionDeleteInput: StobConditionDeleteInput;
	StobConditionDisconnectInput: StobConditionDisconnectInput;
	StobConditionInput: StobConditionInput;
	StobConditionOptions: StobConditionOptions;
	StobConditionScenarioAggregateInput: StobConditionScenarioAggregateInput;
	StobConditionScenarioConnectFieldInput: StobConditionScenarioConnectFieldInput;
	StobConditionScenarioConnection: ResolverTypeWrapper<StobConditionScenarioConnection>;
	StobConditionScenarioConnectionSort: StobConditionScenarioConnectionSort;
	StobConditionScenarioConnectionWhere: StobConditionScenarioConnectionWhere;
	StobConditionScenarioCreateFieldInput: StobConditionScenarioCreateFieldInput;
	StobConditionScenarioDeleteFieldInput: StobConditionScenarioDeleteFieldInput;
	StobConditionScenarioDisconnectFieldInput: StobConditionScenarioDisconnectFieldInput;
	StobConditionScenarioFieldInput: StobConditionScenarioFieldInput;
	StobConditionScenarioNodeAggregationWhereInput: StobConditionScenarioNodeAggregationWhereInput;
	StobConditionScenarioRelationship: ResolverTypeWrapper<StobConditionScenarioRelationship>;
	StobConditionScenarioUpdateConnectionInput: StobConditionScenarioUpdateConnectionInput;
	StobConditionScenarioUpdateFieldInput: StobConditionScenarioUpdateFieldInput;
	StobConditionSort: StobConditionSort;
	StobConditionUpdateInput: StobConditionUpdateInput;
	StobConditionWhere: StobConditionWhere;
	StobContract: ResolverTypeWrapper<StobContract>;
	StobContractAggregateSelection: ResolverTypeWrapper<StobContractAggregateSelection>;
	StobContractBasicInfoInput: StobContractBasicInfoInput;
	StobContractCasesAggregateInput: StobContractCasesAggregateInput;
	StobContractCasesConnectFieldInput: StobContractCasesConnectFieldInput;
	StobContractCasesConnection: ResolverTypeWrapper<StobContractCasesConnection>;
	StobContractCasesConnectionSort: StobContractCasesConnectionSort;
	StobContractCasesConnectionWhere: StobContractCasesConnectionWhere;
	StobContractCasesCreateFieldInput: StobContractCasesCreateFieldInput;
	StobContractCasesDeleteFieldInput: StobContractCasesDeleteFieldInput;
	StobContractCasesDisconnectFieldInput: StobContractCasesDisconnectFieldInput;
	StobContractCasesFieldInput: StobContractCasesFieldInput;
	StobContractCasesNodeAggregationWhereInput: StobContractCasesNodeAggregationWhereInput;
	StobContractCasesRelationship: ResolverTypeWrapper<StobContractCasesRelationship>;
	StobContractCasesUpdateConnectionInput: StobContractCasesUpdateConnectionInput;
	StobContractCasesUpdateFieldInput: StobContractCasesUpdateFieldInput;
	StobContractConnectInput: StobContractConnectInput;
	StobContractConnectWhere: StobContractConnectWhere;
	StobContractCreateInput: StobContractCreateInput;
	StobContractCreatorOrganizationAggregateInput: StobContractCreatorOrganizationAggregateInput;
	StobContractCreatorOrganizationConnectFieldInput: StobContractCreatorOrganizationConnectFieldInput;
	StobContractCreatorOrganizationConnection: ResolverTypeWrapper<StobContractCreatorOrganizationConnection>;
	StobContractCreatorOrganizationConnectionSort: StobContractCreatorOrganizationConnectionSort;
	StobContractCreatorOrganizationConnectionWhere: StobContractCreatorOrganizationConnectionWhere;
	StobContractCreatorOrganizationCreateFieldInput: StobContractCreatorOrganizationCreateFieldInput;
	StobContractCreatorOrganizationDeleteFieldInput: StobContractCreatorOrganizationDeleteFieldInput;
	StobContractCreatorOrganizationDisconnectFieldInput: StobContractCreatorOrganizationDisconnectFieldInput;
	StobContractCreatorOrganizationFieldInput: StobContractCreatorOrganizationFieldInput;
	StobContractCreatorOrganizationNodeAggregationWhereInput: StobContractCreatorOrganizationNodeAggregationWhereInput;
	StobContractCreatorOrganizationRelationship: ResolverTypeWrapper<StobContractCreatorOrganizationRelationship>;
	StobContractCreatorOrganizationUpdateConnectionInput: StobContractCreatorOrganizationUpdateConnectionInput;
	StobContractCreatorOrganizationUpdateFieldInput: StobContractCreatorOrganizationUpdateFieldInput;
	StobContractCurrencyAggregateInput: StobContractCurrencyAggregateInput;
	StobContractCurrencyConnectFieldInput: StobContractCurrencyConnectFieldInput;
	StobContractCurrencyConnection: ResolverTypeWrapper<StobContractCurrencyConnection>;
	StobContractCurrencyConnectionSort: StobContractCurrencyConnectionSort;
	StobContractCurrencyConnectionWhere: StobContractCurrencyConnectionWhere;
	StobContractCurrencyCreateFieldInput: StobContractCurrencyCreateFieldInput;
	StobContractCurrencyDeleteFieldInput: StobContractCurrencyDeleteFieldInput;
	StobContractCurrencyDisconnectFieldInput: StobContractCurrencyDisconnectFieldInput;
	StobContractCurrencyFieldInput: StobContractCurrencyFieldInput;
	StobContractCurrencyNodeAggregationWhereInput: StobContractCurrencyNodeAggregationWhereInput;
	StobContractCurrencyRelationship: ResolverTypeWrapper<StobContractCurrencyRelationship>;
	StobContractCurrencyUpdateConnectionInput: StobContractCurrencyUpdateConnectionInput;
	StobContractCurrencyUpdateFieldInput: StobContractCurrencyUpdateFieldInput;
	StobContractDeleteInput: StobContractDeleteInput;
	StobContractDisconnectInput: StobContractDisconnectInput;
	StobContractDiseaseAggregateInput: StobContractDiseaseAggregateInput;
	StobContractDiseaseConnectFieldInput: StobContractDiseaseConnectFieldInput;
	StobContractDiseaseConnection: ResolverTypeWrapper<StobContractDiseaseConnection>;
	StobContractDiseaseConnectionSort: StobContractDiseaseConnectionSort;
	StobContractDiseaseConnectionWhere: StobContractDiseaseConnectionWhere;
	StobContractDiseaseCreateFieldInput: StobContractDiseaseCreateFieldInput;
	StobContractDiseaseDeleteFieldInput: StobContractDiseaseDeleteFieldInput;
	StobContractDiseaseDisconnectFieldInput: StobContractDiseaseDisconnectFieldInput;
	StobContractDiseaseFieldInput: StobContractDiseaseFieldInput;
	StobContractDiseaseNodeAggregationWhereInput: StobContractDiseaseNodeAggregationWhereInput;
	StobContractDiseaseRelationship: ResolverTypeWrapper<StobContractDiseaseRelationship>;
	StobContractDiseaseUpdateConnectionInput: StobContractDiseaseUpdateConnectionInput;
	StobContractDiseaseUpdateFieldInput: StobContractDiseaseUpdateFieldInput;
	StobContractEligibilityInput: StobContractEligibilityInput;
	StobContractIndicationAggregateInput: StobContractIndicationAggregateInput;
	StobContractIndicationConnectFieldInput: StobContractIndicationConnectFieldInput;
	StobContractIndicationConnection: ResolverTypeWrapper<StobContractIndicationConnection>;
	StobContractIndicationConnectionSort: StobContractIndicationConnectionSort;
	StobContractIndicationConnectionWhere: StobContractIndicationConnectionWhere;
	StobContractIndicationCreateFieldInput: StobContractIndicationCreateFieldInput;
	StobContractIndicationDeleteFieldInput: StobContractIndicationDeleteFieldInput;
	StobContractIndicationDisconnectFieldInput: StobContractIndicationDisconnectFieldInput;
	StobContractIndicationFieldInput: StobContractIndicationFieldInput;
	StobContractIndicationNodeAggregationWhereInput: StobContractIndicationNodeAggregationWhereInput;
	StobContractIndicationRelationship: ResolverTypeWrapper<StobContractIndicationRelationship>;
	StobContractIndicationUpdateConnectionInput: StobContractIndicationUpdateConnectionInput;
	StobContractIndicationUpdateFieldInput: StobContractIndicationUpdateFieldInput;
	StobContractNotificationsAggregateInput: StobContractNotificationsAggregateInput;
	StobContractNotificationsConnectFieldInput: StobContractNotificationsConnectFieldInput;
	StobContractNotificationsConnection: ResolverTypeWrapper<StobContractNotificationsConnection>;
	StobContractNotificationsConnectionSort: StobContractNotificationsConnectionSort;
	StobContractNotificationsConnectionWhere: StobContractNotificationsConnectionWhere;
	StobContractNotificationsCreateFieldInput: StobContractNotificationsCreateFieldInput;
	StobContractNotificationsDeleteFieldInput: StobContractNotificationsDeleteFieldInput;
	StobContractNotificationsDisconnectFieldInput: StobContractNotificationsDisconnectFieldInput;
	StobContractNotificationsFieldInput: StobContractNotificationsFieldInput;
	StobContractNotificationsNodeAggregationWhereInput: StobContractNotificationsNodeAggregationWhereInput;
	StobContractNotificationsRelationship: ResolverTypeWrapper<StobContractNotificationsRelationship>;
	StobContractNotificationsUpdateConnectionInput: StobContractNotificationsUpdateConnectionInput;
	StobContractNotificationsUpdateFieldInput: StobContractNotificationsUpdateFieldInput;
	StobContractOptions: StobContractOptions;
	StobContractPartnerAggregateInput: StobContractPartnerAggregateInput;
	StobContractPartnerConnectFieldInput: StobContractPartnerConnectFieldInput;
	StobContractPartnerConnection: ResolverTypeWrapper<StobContractPartnerConnection>;
	StobContractPartnerConnectionSort: StobContractPartnerConnectionSort;
	StobContractPartnerConnectionWhere: StobContractPartnerConnectionWhere;
	StobContractPartnerCreateFieldInput: StobContractPartnerCreateFieldInput;
	StobContractPartnerDeleteFieldInput: StobContractPartnerDeleteFieldInput;
	StobContractPartnerDisconnectFieldInput: StobContractPartnerDisconnectFieldInput;
	StobContractPartnerFieldInput: StobContractPartnerFieldInput;
	StobContractPartnerNodeAggregationWhereInput: StobContractPartnerNodeAggregationWhereInput;
	StobContractPartnerRelationship: ResolverTypeWrapper<StobContractPartnerRelationship>;
	StobContractPartnerUpdateConnectionInput: StobContractPartnerUpdateConnectionInput;
	StobContractPartnerUpdateFieldInput: StobContractPartnerUpdateFieldInput;
	StobContractRecommendedFormsAggregateInput: StobContractRecommendedFormsAggregateInput;
	StobContractRecommendedFormsConnectFieldInput: StobContractRecommendedFormsConnectFieldInput;
	StobContractRecommendedFormsConnection: ResolverTypeWrapper<StobContractRecommendedFormsConnection>;
	StobContractRecommendedFormsConnectionSort: StobContractRecommendedFormsConnectionSort;
	StobContractRecommendedFormsConnectionWhere: StobContractRecommendedFormsConnectionWhere;
	StobContractRecommendedFormsCreateFieldInput: StobContractRecommendedFormsCreateFieldInput;
	StobContractRecommendedFormsDeleteFieldInput: StobContractRecommendedFormsDeleteFieldInput;
	StobContractRecommendedFormsDisconnectFieldInput: StobContractRecommendedFormsDisconnectFieldInput;
	StobContractRecommendedFormsFieldInput: StobContractRecommendedFormsFieldInput;
	StobContractRecommendedFormsNodeAggregationWhereInput: StobContractRecommendedFormsNodeAggregationWhereInput;
	StobContractRecommendedFormsRelationship: ResolverTypeWrapper<StobContractRecommendedFormsRelationship>;
	StobContractRecommendedFormsUpdateConnectionInput: StobContractRecommendedFormsUpdateConnectionInput;
	StobContractRecommendedFormsUpdateFieldInput: StobContractRecommendedFormsUpdateFieldInput;
	StobContractScenariosAggregateInput: StobContractScenariosAggregateInput;
	StobContractScenariosConnectFieldInput: StobContractScenariosConnectFieldInput;
	StobContractScenariosConnection: ResolverTypeWrapper<StobContractScenariosConnection>;
	StobContractScenariosConnectionSort: StobContractScenariosConnectionSort;
	StobContractScenariosConnectionWhere: StobContractScenariosConnectionWhere;
	StobContractScenariosCreateFieldInput: StobContractScenariosCreateFieldInput;
	StobContractScenariosDeleteFieldInput: StobContractScenariosDeleteFieldInput;
	StobContractScenariosDisconnectFieldInput: StobContractScenariosDisconnectFieldInput;
	StobContractScenariosFieldInput: StobContractScenariosFieldInput;
	StobContractScenariosNodeAggregationWhereInput: StobContractScenariosNodeAggregationWhereInput;
	StobContractScenariosRelationship: ResolverTypeWrapper<StobContractScenariosRelationship>;
	StobContractScenariosUpdateConnectionInput: StobContractScenariosUpdateConnectionInput;
	StobContractScenariosUpdateFieldInput: StobContractScenariosUpdateFieldInput;
	StobContractSort: StobContractSort;
	StobContractStatisticsAggregateInput: StobContractStatisticsAggregateInput;
	StobContractStatisticsConnectFieldInput: StobContractStatisticsConnectFieldInput;
	StobContractStatisticsConnection: ResolverTypeWrapper<StobContractStatisticsConnection>;
	StobContractStatisticsConnectionSort: StobContractStatisticsConnectionSort;
	StobContractStatisticsConnectionWhere: StobContractStatisticsConnectionWhere;
	StobContractStatisticsCreateFieldInput: StobContractStatisticsCreateFieldInput;
	StobContractStatisticsDeleteFieldInput: StobContractStatisticsDeleteFieldInput;
	StobContractStatisticsDisconnectFieldInput: StobContractStatisticsDisconnectFieldInput;
	StobContractStatisticsFieldInput: StobContractStatisticsFieldInput;
	StobContractStatisticsNodeAggregationWhereInput: StobContractStatisticsNodeAggregationWhereInput;
	StobContractStatisticsRelationship: ResolverTypeWrapper<StobContractStatisticsRelationship>;
	StobContractStatisticsUpdateConnectionInput: StobContractStatisticsUpdateConnectionInput;
	StobContractStatisticsUpdateFieldInput: StobContractStatisticsUpdateFieldInput;
	StobContractTagsAggregateInput: StobContractTagsAggregateInput;
	StobContractTagsConnectFieldInput: StobContractTagsConnectFieldInput;
	StobContractTagsConnection: ResolverTypeWrapper<StobContractTagsConnection>;
	StobContractTagsConnectionSort: StobContractTagsConnectionSort;
	StobContractTagsConnectionWhere: StobContractTagsConnectionWhere;
	StobContractTagsCreateFieldInput: StobContractTagsCreateFieldInput;
	StobContractTagsDeleteFieldInput: StobContractTagsDeleteFieldInput;
	StobContractTagsDisconnectFieldInput: StobContractTagsDisconnectFieldInput;
	StobContractTagsFieldInput: StobContractTagsFieldInput;
	StobContractTagsNodeAggregationWhereInput: StobContractTagsNodeAggregationWhereInput;
	StobContractTagsRelationship: ResolverTypeWrapper<StobContractTagsRelationship>;
	StobContractTagsUpdateConnectionInput: StobContractTagsUpdateConnectionInput;
	StobContractTagsUpdateFieldInput: StobContractTagsUpdateFieldInput;
	StobContractTreatmentPriceRelationship: ResolversTypes["StobContractTreatmentPricesRelationship"];
	StobContractTreatmentPriceRelationshipCreateInput: StobContractTreatmentPriceRelationshipCreateInput;
	StobContractTreatmentPriceRelationshipSort: StobContractTreatmentPriceRelationshipSort;
	StobContractTreatmentPriceRelationshipUpdateInput: StobContractTreatmentPriceRelationshipUpdateInput;
	StobContractTreatmentPriceRelationshipWhere: StobContractTreatmentPriceRelationshipWhere;
	StobContractTreatmentPricesAggregateInput: StobContractTreatmentPricesAggregateInput;
	StobContractTreatmentPricesConnectFieldInput: StobContractTreatmentPricesConnectFieldInput;
	StobContractTreatmentPricesConnection: ResolverTypeWrapper<StobContractTreatmentPricesConnection>;
	StobContractTreatmentPricesConnectionSort: StobContractTreatmentPricesConnectionSort;
	StobContractTreatmentPricesConnectionWhere: StobContractTreatmentPricesConnectionWhere;
	StobContractTreatmentPricesCreateFieldInput: StobContractTreatmentPricesCreateFieldInput;
	StobContractTreatmentPricesDeleteFieldInput: StobContractTreatmentPricesDeleteFieldInput;
	StobContractTreatmentPricesDisconnectFieldInput: StobContractTreatmentPricesDisconnectFieldInput;
	StobContractTreatmentPricesEdgeAggregationWhereInput: StobContractTreatmentPricesEdgeAggregationWhereInput;
	StobContractTreatmentPricesFieldInput: StobContractTreatmentPricesFieldInput;
	StobContractTreatmentPricesNodeAggregationWhereInput: StobContractTreatmentPricesNodeAggregationWhereInput;
	StobContractTreatmentPricesRelationship: ResolverTypeWrapper<StobContractTreatmentPricesRelationship>;
	StobContractTreatmentPricesUpdateConnectionInput: StobContractTreatmentPricesUpdateConnectionInput;
	StobContractTreatmentPricesUpdateFieldInput: StobContractTreatmentPricesUpdateFieldInput;
	StobContractUpdateInput: StobContractUpdateInput;
	StobContractWhere: StobContractWhere;
	StobMeasureType: StobMeasureType;
	StobMeasuresInput: StobMeasuresInput;
	StobPricingInput: StobPricingInput;
	StobScenario: ResolverTypeWrapper<StobScenario>;
	StobScenarioActionsAggregateInput: StobScenarioActionsAggregateInput;
	StobScenarioActionsConnectFieldInput: StobScenarioActionsConnectFieldInput;
	StobScenarioActionsConnection: ResolverTypeWrapper<StobScenarioActionsConnection>;
	StobScenarioActionsConnectionSort: StobScenarioActionsConnectionSort;
	StobScenarioActionsConnectionWhere: StobScenarioActionsConnectionWhere;
	StobScenarioActionsCreateFieldInput: StobScenarioActionsCreateFieldInput;
	StobScenarioActionsDeleteFieldInput: StobScenarioActionsDeleteFieldInput;
	StobScenarioActionsDisconnectFieldInput: StobScenarioActionsDisconnectFieldInput;
	StobScenarioActionsFieldInput: StobScenarioActionsFieldInput;
	StobScenarioActionsNodeAggregationWhereInput: StobScenarioActionsNodeAggregationWhereInput;
	StobScenarioActionsRelationship: ResolverTypeWrapper<StobScenarioActionsRelationship>;
	StobScenarioActionsUpdateConnectionInput: StobScenarioActionsUpdateConnectionInput;
	StobScenarioActionsUpdateFieldInput: StobScenarioActionsUpdateFieldInput;
	StobScenarioAggregateSelection: ResolverTypeWrapper<StobScenarioAggregateSelection>;
	StobScenarioConditionsAggregateInput: StobScenarioConditionsAggregateInput;
	StobScenarioConditionsConnectFieldInput: StobScenarioConditionsConnectFieldInput;
	StobScenarioConditionsConnection: ResolverTypeWrapper<StobScenarioConditionsConnection>;
	StobScenarioConditionsConnectionSort: StobScenarioConditionsConnectionSort;
	StobScenarioConditionsConnectionWhere: StobScenarioConditionsConnectionWhere;
	StobScenarioConditionsCreateFieldInput: StobScenarioConditionsCreateFieldInput;
	StobScenarioConditionsDeleteFieldInput: StobScenarioConditionsDeleteFieldInput;
	StobScenarioConditionsDisconnectFieldInput: StobScenarioConditionsDisconnectFieldInput;
	StobScenarioConditionsFieldInput: StobScenarioConditionsFieldInput;
	StobScenarioConditionsNodeAggregationWhereInput: StobScenarioConditionsNodeAggregationWhereInput;
	StobScenarioConditionsRelationship: ResolverTypeWrapper<StobScenarioConditionsRelationship>;
	StobScenarioConditionsUpdateConnectionInput: StobScenarioConditionsUpdateConnectionInput;
	StobScenarioConditionsUpdateFieldInput: StobScenarioConditionsUpdateFieldInput;
	StobScenarioConnectInput: StobScenarioConnectInput;
	StobScenarioConnectWhere: StobScenarioConnectWhere;
	StobScenarioCreateInput: StobScenarioCreateInput;
	StobScenarioDeleteInput: StobScenarioDeleteInput;
	StobScenarioDisconnectInput: StobScenarioDisconnectInput;
	StobScenarioInput: StobScenarioInput;
	StobScenarioOptions: StobScenarioOptions;
	StobScenarioSort: StobScenarioSort;
	StobScenarioUpdateInput: StobScenarioUpdateInput;
	StobScenarioWhere: StobScenarioWhere;
	StobStatistics: ResolverTypeWrapper<StobStatistics>;
	StobStatisticsAggregateSelection: ResolverTypeWrapper<StobStatisticsAggregateSelection>;
	StobStatisticsConnectWhere: StobStatisticsConnectWhere;
	StobStatisticsCreateInput: StobStatisticsCreateInput;
	StobStatisticsOptions: StobStatisticsOptions;
	StobStatisticsSort: StobStatisticsSort;
	StobStatisticsUpdateInput: StobStatisticsUpdateInput;
	StobStatisticsWhere: StobStatisticsWhere;
	StobTherapyDecision: StobTherapyDecision;
	StobTimeframeRelation: StobTimeframeRelation;
	StobTimeframeStartingPoint: StobTimeframeStartingPoint;
	StobTreatmentPriceInput: StobTreatmentPriceInput;
	String: ResolverTypeWrapper<Scalars["String"]>;
	StringAggregateSelection: ResolverTypeWrapper<StringAggregateSelection>;
	Subscription: ResolverTypeWrapper<{}>;
	SummaryNotificationDue: ResolversTypes["NotificationDueRelationship"] | ResolversTypes["UserNotificationDueRelationship"];
	SummaryNotificationDueCreateInput: SummaryNotificationDueCreateInput;
	SummaryNotificationDueSort: SummaryNotificationDueSort;
	SummaryNotificationDueUpdateInput: SummaryNotificationDueUpdateInput;
	SummaryNotificationDueWhere: SummaryNotificationDueWhere;
	Task: ResolverTypeWrapper<Task>;
	TaskAggregateSelection: ResolverTypeWrapper<TaskAggregateSelection>;
	TaskAgreementAggregateInput: TaskAgreementAggregateInput;
	TaskAgreementConnectFieldInput: TaskAgreementConnectFieldInput;
	TaskAgreementConnection: ResolverTypeWrapper<TaskAgreementConnection>;
	TaskAgreementConnectionSort: TaskAgreementConnectionSort;
	TaskAgreementConnectionWhere: TaskAgreementConnectionWhere;
	TaskAgreementCreateFieldInput: TaskAgreementCreateFieldInput;
	TaskAgreementDeleteFieldInput: TaskAgreementDeleteFieldInput;
	TaskAgreementDisconnectFieldInput: TaskAgreementDisconnectFieldInput;
	TaskAgreementFieldInput: TaskAgreementFieldInput;
	TaskAgreementNodeAggregationWhereInput: TaskAgreementNodeAggregationWhereInput;
	TaskAgreementRelationship: ResolverTypeWrapper<TaskAgreementRelationship>;
	TaskAgreementUpdateConnectionInput: TaskAgreementUpdateConnectionInput;
	TaskAgreementUpdateFieldInput: TaskAgreementUpdateFieldInput;
	TaskCaseAggregateInput: TaskCaseAggregateInput;
	TaskCaseConnectFieldInput: TaskCaseConnectFieldInput;
	TaskCaseConnection: ResolverTypeWrapper<TaskCaseConnection>;
	TaskCaseConnectionSort: TaskCaseConnectionSort;
	TaskCaseConnectionWhere: TaskCaseConnectionWhere;
	TaskCaseCreateFieldInput: TaskCaseCreateFieldInput;
	TaskCaseDeleteFieldInput: TaskCaseDeleteFieldInput;
	TaskCaseDisconnectFieldInput: TaskCaseDisconnectFieldInput;
	TaskCaseFieldInput: TaskCaseFieldInput;
	TaskCaseNodeAggregationWhereInput: TaskCaseNodeAggregationWhereInput;
	TaskCaseRelationship: ResolverTypeWrapper<TaskCaseRelationship>;
	TaskCaseUpdateConnectionInput: TaskCaseUpdateConnectionInput;
	TaskCaseUpdateFieldInput: TaskCaseUpdateFieldInput;
	TaskConnectInput: TaskConnectInput;
	TaskConnectWhere: TaskConnectWhere;
	TaskCreateInput: TaskCreateInput;
	TaskDeleteInput: TaskDeleteInput;
	TaskDisconnectInput: TaskDisconnectInput;
	TaskDocumentAggregateInput: TaskDocumentAggregateInput;
	TaskDocumentConnectFieldInput: TaskDocumentConnectFieldInput;
	TaskDocumentConnection: ResolverTypeWrapper<TaskDocumentConnection>;
	TaskDocumentConnectionSort: TaskDocumentConnectionSort;
	TaskDocumentConnectionWhere: TaskDocumentConnectionWhere;
	TaskDocumentCreateFieldInput: TaskDocumentCreateFieldInput;
	TaskDocumentDeleteFieldInput: TaskDocumentDeleteFieldInput;
	TaskDocumentDisconnectFieldInput: TaskDocumentDisconnectFieldInput;
	TaskDocumentFieldInput: TaskDocumentFieldInput;
	TaskDocumentNodeAggregationWhereInput: TaskDocumentNodeAggregationWhereInput;
	TaskDocumentRelationship: ResolverTypeWrapper<TaskDocumentRelationship>;
	TaskDocumentUpdateConnectionInput: TaskDocumentUpdateConnectionInput;
	TaskDocumentUpdateFieldInput: TaskDocumentUpdateFieldInput;
	TaskMessageAggregateInput: TaskMessageAggregateInput;
	TaskMessageConnectFieldInput: TaskMessageConnectFieldInput;
	TaskMessageConnection: ResolverTypeWrapper<TaskMessageConnection>;
	TaskMessageConnectionSort: TaskMessageConnectionSort;
	TaskMessageConnectionWhere: TaskMessageConnectionWhere;
	TaskMessageCreateFieldInput: TaskMessageCreateFieldInput;
	TaskMessageDeleteFieldInput: TaskMessageDeleteFieldInput;
	TaskMessageDisconnectFieldInput: TaskMessageDisconnectFieldInput;
	TaskMessageEdgeAggregationWhereInput: TaskMessageEdgeAggregationWhereInput;
	TaskMessageFieldInput: TaskMessageFieldInput;
	TaskMessageNodeAggregationWhereInput: TaskMessageNodeAggregationWhereInput;
	TaskMessageRelationship: ResolverTypeWrapper<TaskMessageRelationship>;
	TaskMessageUpdateConnectionInput: TaskMessageUpdateConnectionInput;
	TaskMessageUpdateFieldInput: TaskMessageUpdateFieldInput;
	TaskOptions: TaskOptions;
	TaskSort: TaskSort;
	TaskUpdateInput: TaskUpdateInput;
	TaskUsersRelationshipAggregateInput: TaskUsersRelationshipAggregateInput;
	TaskUsersRelationshipConnectFieldInput: TaskUsersRelationshipConnectFieldInput;
	TaskUsersRelationshipConnection: ResolverTypeWrapper<TaskUsersRelationshipConnection>;
	TaskUsersRelationshipConnectionSort: TaskUsersRelationshipConnectionSort;
	TaskUsersRelationshipConnectionWhere: TaskUsersRelationshipConnectionWhere;
	TaskUsersRelationshipCreateFieldInput: TaskUsersRelationshipCreateFieldInput;
	TaskUsersRelationshipDeleteFieldInput: TaskUsersRelationshipDeleteFieldInput;
	TaskUsersRelationshipDisconnectFieldInput: TaskUsersRelationshipDisconnectFieldInput;
	TaskUsersRelationshipFieldInput: TaskUsersRelationshipFieldInput;
	TaskUsersRelationshipNodeAggregationWhereInput: TaskUsersRelationshipNodeAggregationWhereInput;
	TaskUsersRelationshipRelationship: ResolverTypeWrapper<TaskUsersRelationshipRelationship>;
	TaskUsersRelationshipUpdateConnectionInput: TaskUsersRelationshipUpdateConnectionInput;
	TaskUsersRelationshipUpdateFieldInput: TaskUsersRelationshipUpdateFieldInput;
	TaskWhere: TaskWhere;
	Timeframe: ResolverTypeWrapper<Timeframe>;
	TimeframeAggregateSelection: ResolverTypeWrapper<TimeframeAggregateSelection>;
	TimeframeConnectWhere: TimeframeConnectWhere;
	TimeframeCreateInput: TimeframeCreateInput;
	TimeframeOptions: TimeframeOptions;
	TimeframeRangeType: TimeframeRangeType;
	TimeframeRelatedEntity: ResolversTypes["RecommendedForm"] | ResolversTypes["StobAction"] | ResolversTypes["StobCondition"];
	TimeframeSort: TimeframeSort;
	TimeframeStartingPoint: TimeframeStartingPoint;
	TimeframeUpdateInput: TimeframeUpdateInput;
	TimeframeWhere: TimeframeWhere;
	Translation: ResolverTypeWrapper<Translation>;
	TranslationAggregateSelection: ResolverTypeWrapper<TranslationAggregateSelection>;
	TranslationOptions: TranslationOptions;
	TranslationSort: TranslationSort;
	TranslationWhere: TranslationWhere;
	Translations: Translations;
	TranslationsResult: ResolverTypeWrapper<TranslationsResult>;
	TranslationsResultAggregateSelection: ResolverTypeWrapper<TranslationsResultAggregateSelection>;
	TranslationsResultOptions: TranslationsResultOptions;
	TranslationsResultSort: TranslationsResultSort;
	TranslationsResultWhere: TranslationsResultWhere;
	TreatingPhysician: ResolverTypeWrapper<TreatingPhysician>;
	TreatingPhysicianAggregateSelection: ResolverTypeWrapper<TreatingPhysicianAggregateSelection>;
	TreatingPhysicianConnectWhere: TreatingPhysicianConnectWhere;
	TreatingPhysicianCreateInput: TreatingPhysicianCreateInput;
	TreatingPhysicianInput: TreatingPhysicianInput;
	TreatingPhysicianOptions: TreatingPhysicianOptions;
	TreatingPhysicianSort: TreatingPhysicianSort;
	TreatingPhysicianTitle: TreatingPhysicianTitle;
	TreatingPhysicianUpdateInput: TreatingPhysicianUpdateInput;
	TreatingPhysicianWhere: TreatingPhysicianWhere;
	Treatment: ResolverTypeWrapper<Treatment>;
	TreatmentAggregateSelection: ResolverTypeWrapper<TreatmentAggregateSelection>;
	TreatmentClaimAggregateInput: TreatmentClaimAggregateInput;
	TreatmentClaimConnectFieldInput: TreatmentClaimConnectFieldInput;
	TreatmentClaimConnection: ResolverTypeWrapper<TreatmentClaimConnection>;
	TreatmentClaimConnectionSort: TreatmentClaimConnectionSort;
	TreatmentClaimConnectionWhere: TreatmentClaimConnectionWhere;
	TreatmentClaimCreateFieldInput: TreatmentClaimCreateFieldInput;
	TreatmentClaimDeleteFieldInput: TreatmentClaimDeleteFieldInput;
	TreatmentClaimDisconnectFieldInput: TreatmentClaimDisconnectFieldInput;
	TreatmentClaimFieldInput: TreatmentClaimFieldInput;
	TreatmentClaimNodeAggregationWhereInput: TreatmentClaimNodeAggregationWhereInput;
	TreatmentClaimRelationship: ResolverTypeWrapper<TreatmentClaimRelationship>;
	TreatmentClaimUpdateConnectionInput: TreatmentClaimUpdateConnectionInput;
	TreatmentClaimUpdateFieldInput: TreatmentClaimUpdateFieldInput;
	TreatmentConnectInput: TreatmentConnectInput;
	TreatmentConnectWhere: TreatmentConnectWhere;
	TreatmentCreateInput: TreatmentCreateInput;
	TreatmentDeleteInput: TreatmentDeleteInput;
	TreatmentDisconnectInput: TreatmentDisconnectInput;
	TreatmentDiscontinuationReason: TreatmentDiscontinuationReason;
	TreatmentDurationConditionAspect: TreatmentDurationConditionAspect;
	TreatmentExFactoryPricesAggregateInput: TreatmentExFactoryPricesAggregateInput;
	TreatmentExFactoryPricesConnectFieldInput: TreatmentExFactoryPricesConnectFieldInput;
	TreatmentExFactoryPricesConnection: ResolverTypeWrapper<TreatmentExFactoryPricesConnection>;
	TreatmentExFactoryPricesConnectionSort: TreatmentExFactoryPricesConnectionSort;
	TreatmentExFactoryPricesConnectionWhere: TreatmentExFactoryPricesConnectionWhere;
	TreatmentExFactoryPricesCreateFieldInput: TreatmentExFactoryPricesCreateFieldInput;
	TreatmentExFactoryPricesDeleteFieldInput: TreatmentExFactoryPricesDeleteFieldInput;
	TreatmentExFactoryPricesDisconnectFieldInput: TreatmentExFactoryPricesDisconnectFieldInput;
	TreatmentExFactoryPricesFieldInput: TreatmentExFactoryPricesFieldInput;
	TreatmentExFactoryPricesNodeAggregationWhereInput: TreatmentExFactoryPricesNodeAggregationWhereInput;
	TreatmentExFactoryPricesRelationship: ResolverTypeWrapper<TreatmentExFactoryPricesRelationship>;
	TreatmentExFactoryPricesUpdateConnectionInput: TreatmentExFactoryPricesUpdateConnectionInput;
	TreatmentExFactoryPricesUpdateFieldInput: TreatmentExFactoryPricesUpdateFieldInput;
	TreatmentHasLimitationsAggregateInput: TreatmentHasLimitationsAggregateInput;
	TreatmentHasLimitationsConnectFieldInput: TreatmentHasLimitationsConnectFieldInput;
	TreatmentHasLimitationsConnection: ResolverTypeWrapper<TreatmentHasLimitationsConnection>;
	TreatmentHasLimitationsConnectionSort: TreatmentHasLimitationsConnectionSort;
	TreatmentHasLimitationsConnectionWhere: TreatmentHasLimitationsConnectionWhere;
	TreatmentHasLimitationsCreateFieldInput: TreatmentHasLimitationsCreateFieldInput;
	TreatmentHasLimitationsDeleteFieldInput: TreatmentHasLimitationsDeleteFieldInput;
	TreatmentHasLimitationsDisconnectFieldInput: TreatmentHasLimitationsDisconnectFieldInput;
	TreatmentHasLimitationsFieldInput: TreatmentHasLimitationsFieldInput;
	TreatmentHasLimitationsNodeAggregationWhereInput: TreatmentHasLimitationsNodeAggregationWhereInput;
	TreatmentHasLimitationsRelationship: ResolverTypeWrapper<TreatmentHasLimitationsRelationship>;
	TreatmentHasLimitationsUpdateConnectionInput: TreatmentHasLimitationsUpdateConnectionInput;
	TreatmentHasLimitationsUpdateFieldInput: TreatmentHasLimitationsUpdateFieldInput;
	TreatmentOptions: TreatmentOptions;
	TreatmentPartnersAggregateInput: TreatmentPartnersAggregateInput;
	TreatmentPartnersConnectFieldInput: TreatmentPartnersConnectFieldInput;
	TreatmentPartnersConnection: ResolverTypeWrapper<TreatmentPartnersConnection>;
	TreatmentPartnersConnectionSort: TreatmentPartnersConnectionSort;
	TreatmentPartnersConnectionWhere: TreatmentPartnersConnectionWhere;
	TreatmentPartnersCreateFieldInput: TreatmentPartnersCreateFieldInput;
	TreatmentPartnersDeleteFieldInput: TreatmentPartnersDeleteFieldInput;
	TreatmentPartnersDisconnectFieldInput: TreatmentPartnersDisconnectFieldInput;
	TreatmentPartnersFieldInput: TreatmentPartnersFieldInput;
	TreatmentPartnersNodeAggregationWhereInput: TreatmentPartnersNodeAggregationWhereInput;
	TreatmentPartnersRelationship: ResolverTypeWrapper<TreatmentPartnersRelationship>;
	TreatmentPartnersUpdateConnectionInput: TreatmentPartnersUpdateConnectionInput;
	TreatmentPartnersUpdateFieldInput: TreatmentPartnersUpdateFieldInput;
	TreatmentPatient: ResolverTypeWrapper<TreatmentPatient>;
	TreatmentPatientAggregateSelection: ResolverTypeWrapper<TreatmentPatientAggregateSelection>;
	TreatmentPatientOptions: TreatmentPatientOptions;
	TreatmentPatientSort: TreatmentPatientSort;
	TreatmentPatientWhere: TreatmentPatientWhere;
	TreatmentPrescriptionRelationship: ResolversTypes["ContinuousBenefitPrescribedTreatmentsRelationship"];
	TreatmentPrescriptionRelationshipCreateInput: TreatmentPrescriptionRelationshipCreateInput;
	TreatmentPrescriptionRelationshipInput: TreatmentPrescriptionRelationshipInput;
	TreatmentPrescriptionRelationshipSort: TreatmentPrescriptionRelationshipSort;
	TreatmentPrescriptionRelationshipUpdateInput: TreatmentPrescriptionRelationshipUpdateInput;
	TreatmentPrescriptionRelationshipWhere: TreatmentPrescriptionRelationshipWhere;
	TreatmentPublicPricesAggregateInput: TreatmentPublicPricesAggregateInput;
	TreatmentPublicPricesConnectFieldInput: TreatmentPublicPricesConnectFieldInput;
	TreatmentPublicPricesConnection: ResolverTypeWrapper<TreatmentPublicPricesConnection>;
	TreatmentPublicPricesConnectionSort: TreatmentPublicPricesConnectionSort;
	TreatmentPublicPricesConnectionWhere: TreatmentPublicPricesConnectionWhere;
	TreatmentPublicPricesCreateFieldInput: TreatmentPublicPricesCreateFieldInput;
	TreatmentPublicPricesDeleteFieldInput: TreatmentPublicPricesDeleteFieldInput;
	TreatmentPublicPricesDisconnectFieldInput: TreatmentPublicPricesDisconnectFieldInput;
	TreatmentPublicPricesFieldInput: TreatmentPublicPricesFieldInput;
	TreatmentPublicPricesNodeAggregationWhereInput: TreatmentPublicPricesNodeAggregationWhereInput;
	TreatmentPublicPricesRelationship: ResolverTypeWrapper<TreatmentPublicPricesRelationship>;
	TreatmentPublicPricesUpdateConnectionInput: TreatmentPublicPricesUpdateConnectionInput;
	TreatmentPublicPricesUpdateFieldInput: TreatmentPublicPricesUpdateFieldInput;
	TreatmentRegulatedByAggregateInput: TreatmentRegulatedByAggregateInput;
	TreatmentRegulatedByConnectFieldInput: TreatmentRegulatedByConnectFieldInput;
	TreatmentRegulatedByConnection: ResolverTypeWrapper<TreatmentRegulatedByConnection>;
	TreatmentRegulatedByConnectionSort: TreatmentRegulatedByConnectionSort;
	TreatmentRegulatedByConnectionWhere: TreatmentRegulatedByConnectionWhere;
	TreatmentRegulatedByCreateFieldInput: TreatmentRegulatedByCreateFieldInput;
	TreatmentRegulatedByDeleteFieldInput: TreatmentRegulatedByDeleteFieldInput;
	TreatmentRegulatedByDisconnectFieldInput: TreatmentRegulatedByDisconnectFieldInput;
	TreatmentRegulatedByFieldInput: TreatmentRegulatedByFieldInput;
	TreatmentRegulatedByNodeAggregationWhereInput: TreatmentRegulatedByNodeAggregationWhereInput;
	TreatmentRegulatedByRelationship: ResolverTypeWrapper<TreatmentRegulatedByRelationship>;
	TreatmentRegulatedByUpdateConnectionInput: TreatmentRegulatedByUpdateConnectionInput;
	TreatmentRegulatedByUpdateFieldInput: TreatmentRegulatedByUpdateFieldInput;
	TreatmentSort: TreatmentSort;
	TreatmentStatusAggregateInput: TreatmentStatusAggregateInput;
	TreatmentStatusConnectFieldInput: TreatmentStatusConnectFieldInput;
	TreatmentStatusConnection: ResolverTypeWrapper<TreatmentStatusConnection>;
	TreatmentStatusConnectionSort: TreatmentStatusConnectionSort;
	TreatmentStatusConnectionWhere: TreatmentStatusConnectionWhere;
	TreatmentStatusCreateFieldInput: TreatmentStatusCreateFieldInput;
	TreatmentStatusDeleteFieldInput: TreatmentStatusDeleteFieldInput;
	TreatmentStatusDisconnectFieldInput: TreatmentStatusDisconnectFieldInput;
	TreatmentStatusFieldInput: TreatmentStatusFieldInput;
	TreatmentStatusNodeAggregationWhereInput: TreatmentStatusNodeAggregationWhereInput;
	TreatmentStatusRelationship: ResolverTypeWrapper<TreatmentStatusRelationship>;
	TreatmentStatusUpdateConnectionInput: TreatmentStatusUpdateConnectionInput;
	TreatmentStatusUpdateFieldInput: TreatmentStatusUpdateFieldInput;
	TreatmentUpdateInput: TreatmentUpdateInput;
	TreatmentWhere: TreatmentWhere;
	UniqueClaimsIdentifiers: UniqueClaimsIdentifiers;
	UniqueDeviceRecordIdentifiersInput: UniqueDeviceRecordIdentifiersInput;
	UpdateAdverseEventsOccurenceReportsMutationResponse: ResolverTypeWrapper<UpdateAdverseEventsOccurenceReportsMutationResponse>;
	UpdateCaseAssigneeInput: UpdateCaseAssigneeInput;
	UpdateInfo: ResolverTypeWrapper<UpdateInfo>;
	UpdateInitialResponseReviewReportsMutationResponse: ResolverTypeWrapper<UpdateInitialResponseReviewReportsMutationResponse>;
	UpdateInvoiceForReviewInput: UpdateInvoiceForReviewInput;
	UpdateReasonOfTreatmentDiscontinuationReportsMutationResponse: ResolverTypeWrapper<UpdateReasonOfTreatmentDiscontinuationReportsMutationResponse>;
	UpdateUsersMutationResponse: ResolverTypeWrapper<UpdateUsersMutationResponse>;
	UploadClaimsInput: UploadClaimsInput;
	UploadDeviceRecordsInput: UploadDeviceRecordsInput;
	User: ResolverTypeWrapper<User>;
	UserAggregateSelection: ResolverTypeWrapper<UserAggregateSelection>;
	UserClaimsAggregateInput: UserClaimsAggregateInput;
	UserClaimsConnectFieldInput: UserClaimsConnectFieldInput;
	UserClaimsConnection: ResolverTypeWrapper<UserClaimsConnection>;
	UserClaimsConnectionSort: UserClaimsConnectionSort;
	UserClaimsConnectionWhere: UserClaimsConnectionWhere;
	UserClaimsCreateFieldInput: UserClaimsCreateFieldInput;
	UserClaimsDeleteFieldInput: UserClaimsDeleteFieldInput;
	UserClaimsDisconnectFieldInput: UserClaimsDisconnectFieldInput;
	UserClaimsFieldInput: UserClaimsFieldInput;
	UserClaimsNodeAggregationWhereInput: UserClaimsNodeAggregationWhereInput;
	UserClaimsRelationship: ResolverTypeWrapper<UserClaimsRelationship>;
	UserClaimsUpdateConnectionInput: UserClaimsUpdateConnectionInput;
	UserClaimsUpdateFieldInput: UserClaimsUpdateFieldInput;
	UserConnectInput: UserConnectInput;
	UserConnectWhere: UserConnectWhere;
	UserContext: ResolverTypeWrapper<UserContext>;
	UserContextAggregateInput: UserContextAggregateInput;
	UserContextAggregateSelection: ResolverTypeWrapper<UserContextAggregateSelection>;
	UserContextBaseAgreementContextAggregateInput: UserContextBaseAgreementContextAggregateInput;
	UserContextBaseAgreementContextConnectFieldInput: UserContextBaseAgreementContextConnectFieldInput;
	UserContextBaseAgreementContextConnection: ResolverTypeWrapper<UserContextBaseAgreementContextConnection>;
	UserContextBaseAgreementContextConnectionSort: UserContextBaseAgreementContextConnectionSort;
	UserContextBaseAgreementContextConnectionWhere: UserContextBaseAgreementContextConnectionWhere;
	UserContextBaseAgreementContextCreateFieldInput: UserContextBaseAgreementContextCreateFieldInput;
	UserContextBaseAgreementContextDeleteFieldInput: UserContextBaseAgreementContextDeleteFieldInput;
	UserContextBaseAgreementContextDisconnectFieldInput: UserContextBaseAgreementContextDisconnectFieldInput;
	UserContextBaseAgreementContextEdgeAggregationWhereInput: UserContextBaseAgreementContextEdgeAggregationWhereInput;
	UserContextBaseAgreementContextFieldInput: UserContextBaseAgreementContextFieldInput;
	UserContextBaseAgreementContextNodeAggregationWhereInput: UserContextBaseAgreementContextNodeAggregationWhereInput;
	UserContextBaseAgreementContextRelationship: ResolverTypeWrapper<UserContextBaseAgreementContextRelationship>;
	UserContextBaseAgreementContextUpdateConnectionInput: UserContextBaseAgreementContextUpdateConnectionInput;
	UserContextBaseAgreementContextUpdateFieldInput: UserContextBaseAgreementContextUpdateFieldInput;
	UserContextConnectFieldInput: UserContextConnectFieldInput;
	UserContextConnectInput: UserContextConnectInput;
	UserContextConnectWhere: UserContextConnectWhere;
	UserContextConnection: ResolverTypeWrapper<UserContextConnection>;
	UserContextConnectionSort: UserContextConnectionSort;
	UserContextConnectionWhere: UserContextConnectionWhere;
	UserContextCreateFieldInput: UserContextCreateFieldInput;
	UserContextCreateInput: UserContextCreateInput;
	UserContextDeleteFieldInput: UserContextDeleteFieldInput;
	UserContextDeleteInput: UserContextDeleteInput;
	UserContextDisconnectFieldInput: UserContextDisconnectFieldInput;
	UserContextDisconnectInput: UserContextDisconnectInput;
	UserContextFieldInput: UserContextFieldInput;
	UserContextNodeAggregationWhereInput: UserContextNodeAggregationWhereInput;
	UserContextOptions: UserContextOptions;
	UserContextRelationship: ResolverTypeWrapper<UserContextRelationship>;
	UserContextScenariosAggregateInput: UserContextScenariosAggregateInput;
	UserContextScenariosConnectFieldInput: UserContextScenariosConnectFieldInput;
	UserContextScenariosConnection: ResolverTypeWrapper<UserContextScenariosConnection>;
	UserContextScenariosConnectionSort: UserContextScenariosConnectionSort;
	UserContextScenariosConnectionWhere: UserContextScenariosConnectionWhere;
	UserContextScenariosCreateFieldInput: UserContextScenariosCreateFieldInput;
	UserContextScenariosDeleteFieldInput: UserContextScenariosDeleteFieldInput;
	UserContextScenariosDisconnectFieldInput: UserContextScenariosDisconnectFieldInput;
	UserContextScenariosEdgeAggregationWhereInput: UserContextScenariosEdgeAggregationWhereInput;
	UserContextScenariosFieldInput: UserContextScenariosFieldInput;
	UserContextScenariosNodeAggregationWhereInput: UserContextScenariosNodeAggregationWhereInput;
	UserContextScenariosRelationship: ResolverTypeWrapper<UserContextScenariosRelationship>;
	UserContextScenariosUpdateConnectionInput: UserContextScenariosUpdateConnectionInput;
	UserContextScenariosUpdateFieldInput: UserContextScenariosUpdateFieldInput;
	UserContextSort: UserContextSort;
	UserContextUpdateConnectionInput: UserContextUpdateConnectionInput;
	UserContextUpdateFieldInput: UserContextUpdateFieldInput;
	UserContextUpdateInput: UserContextUpdateInput;
	UserContextWhere: UserContextWhere;
	UserCreateInput: UserCreateInput;
	UserDeleteInput: UserDeleteInput;
	UserDisconnectInput: UserDisconnectInput;
	UserInput: UserInput;
	UserMentionsAggregateInput: UserMentionsAggregateInput;
	UserMentionsConnectFieldInput: UserMentionsConnectFieldInput;
	UserMentionsConnection: ResolverTypeWrapper<UserMentionsConnection>;
	UserMentionsConnectionSort: UserMentionsConnectionSort;
	UserMentionsConnectionWhere: UserMentionsConnectionWhere;
	UserMentionsCreateFieldInput: UserMentionsCreateFieldInput;
	UserMentionsDeleteFieldInput: UserMentionsDeleteFieldInput;
	UserMentionsDisconnectFieldInput: UserMentionsDisconnectFieldInput;
	UserMentionsFieldInput: UserMentionsFieldInput;
	UserMentionsNodeAggregationWhereInput: UserMentionsNodeAggregationWhereInput;
	UserMentionsRelationship: ResolverTypeWrapper<UserMentionsRelationship>;
	UserMentionsUpdateConnectionInput: UserMentionsUpdateConnectionInput;
	UserMentionsUpdateFieldInput: UserMentionsUpdateFieldInput;
	UserMessageRelationship: ResolversTypes["TaskMessageRelationship"];
	UserMessageRelationshipCreateInput: UserMessageRelationshipCreateInput;
	UserMessageRelationshipSort: UserMessageRelationshipSort;
	UserMessageRelationshipUpdateInput: UserMessageRelationshipUpdateInput;
	UserMessageRelationshipWhere: UserMessageRelationshipWhere;
	UserNotificationDueAggregateInput: UserNotificationDueAggregateInput;
	UserNotificationDueConnectFieldInput: UserNotificationDueConnectFieldInput;
	UserNotificationDueConnection: ResolverTypeWrapper<UserNotificationDueConnection>;
	UserNotificationDueConnectionSort: UserNotificationDueConnectionSort;
	UserNotificationDueConnectionWhere: UserNotificationDueConnectionWhere;
	UserNotificationDueCreateFieldInput: UserNotificationDueCreateFieldInput;
	UserNotificationDueDeleteFieldInput: UserNotificationDueDeleteFieldInput;
	UserNotificationDueDisconnectFieldInput: UserNotificationDueDisconnectFieldInput;
	UserNotificationDueEdgeAggregationWhereInput: UserNotificationDueEdgeAggregationWhereInput;
	UserNotificationDueFieldInput: UserNotificationDueFieldInput;
	UserNotificationDueNodeAggregationWhereInput: UserNotificationDueNodeAggregationWhereInput;
	UserNotificationDueRelationship: ResolverTypeWrapper<UserNotificationDueRelationship>;
	UserNotificationDueUpdateConnectionInput: UserNotificationDueUpdateConnectionInput;
	UserNotificationDueUpdateFieldInput: UserNotificationDueUpdateFieldInput;
	UserNotificationRelationship: ResolversTypes["NotificationNotifiedRelationship"] | ResolversTypes["UserNotifiedRelationship"];
	UserNotificationRelationshipCreateInput: UserNotificationRelationshipCreateInput;
	UserNotificationRelationshipSort: UserNotificationRelationshipSort;
	UserNotificationRelationshipUpdateInput: UserNotificationRelationshipUpdateInput;
	UserNotificationRelationshipWhere: UserNotificationRelationshipWhere;
	UserNotifiedAggregateInput: UserNotifiedAggregateInput;
	UserNotifiedConnectFieldInput: UserNotifiedConnectFieldInput;
	UserNotifiedConnection: ResolverTypeWrapper<UserNotifiedConnection>;
	UserNotifiedConnectionSort: UserNotifiedConnectionSort;
	UserNotifiedConnectionWhere: UserNotifiedConnectionWhere;
	UserNotifiedCreateFieldInput: UserNotifiedCreateFieldInput;
	UserNotifiedDeleteFieldInput: UserNotifiedDeleteFieldInput;
	UserNotifiedDisconnectFieldInput: UserNotifiedDisconnectFieldInput;
	UserNotifiedEdgeAggregationWhereInput: UserNotifiedEdgeAggregationWhereInput;
	UserNotifiedFieldInput: UserNotifiedFieldInput;
	UserNotifiedNodeAggregationWhereInput: UserNotifiedNodeAggregationWhereInput;
	UserNotifiedRelationship: ResolverTypeWrapper<UserNotifiedRelationship>;
	UserNotifiedUpdateConnectionInput: UserNotifiedUpdateConnectionInput;
	UserNotifiedUpdateFieldInput: UserNotifiedUpdateFieldInput;
	UserOptions: UserOptions;
	UserOrgSettingsData: ResolverTypeWrapper<UserOrgSettingsData>;
	UserOrgSettingsDataAggregateSelection: ResolverTypeWrapper<UserOrgSettingsDataAggregateSelection>;
	UserOrgSettingsDataOptions: UserOrgSettingsDataOptions;
	UserOrgSettingsDataSort: UserOrgSettingsDataSort;
	UserOrgSettingsDataWhere: UserOrgSettingsDataWhere;
	UserOrganizationInfo: ResolverTypeWrapper<UserOrganizationInfo>;
	UserOrganizationInfoAggregateSelection: ResolverTypeWrapper<UserOrganizationInfoAggregateSelection>;
	UserOrganizationInfoOptions: UserOrganizationInfoOptions;
	UserOrganizationInfoSort: UserOrganizationInfoSort;
	UserOrganizationInfoWhere: UserOrganizationInfoWhere;
	UserPatientsAggregateInput: UserPatientsAggregateInput;
	UserPatientsConnectFieldInput: UserPatientsConnectFieldInput;
	UserPatientsConnection: ResolverTypeWrapper<UserPatientsConnection>;
	UserPatientsConnectionSort: UserPatientsConnectionSort;
	UserPatientsConnectionWhere: UserPatientsConnectionWhere;
	UserPatientsCreateFieldInput: UserPatientsCreateFieldInput;
	UserPatientsDeleteFieldInput: UserPatientsDeleteFieldInput;
	UserPatientsDisconnectFieldInput: UserPatientsDisconnectFieldInput;
	UserPatientsFieldInput: UserPatientsFieldInput;
	UserPatientsNodeAggregationWhereInput: UserPatientsNodeAggregationWhereInput;
	UserPatientsRelationship: ResolverTypeWrapper<UserPatientsRelationship>;
	UserPatientsUpdateConnectionInput: UserPatientsUpdateConnectionInput;
	UserPatientsUpdateFieldInput: UserPatientsUpdateFieldInput;
	UserPersonalInfo: ResolverTypeWrapper<UserPersonalInfo>;
	UserPersonalInfoAggregateSelection: ResolverTypeWrapper<UserPersonalInfoAggregateSelection>;
	UserPersonalInfoInput: UserPersonalInfoInput;
	UserPersonalInfoOptions: UserPersonalInfoOptions;
	UserPersonalInfoSort: UserPersonalInfoSort;
	UserPersonalInfoWhere: UserPersonalInfoWhere;
	UserRelationInput: UserRelationInput;
	UserRoleRequestUpdateInput: UserRoleRequestUpdateInput;
	UserSentMessageAggregateInput: UserSentMessageAggregateInput;
	UserSentMessageConnectFieldInput: UserSentMessageConnectFieldInput;
	UserSentMessageConnection: ResolverTypeWrapper<UserSentMessageConnection>;
	UserSentMessageConnectionSort: UserSentMessageConnectionSort;
	UserSentMessageConnectionWhere: UserSentMessageConnectionWhere;
	UserSentMessageCreateFieldInput: UserSentMessageCreateFieldInput;
	UserSentMessageDeleteFieldInput: UserSentMessageDeleteFieldInput;
	UserSentMessageDisconnectFieldInput: UserSentMessageDisconnectFieldInput;
	UserSentMessageFieldInput: UserSentMessageFieldInput;
	UserSentMessageNodeAggregationWhereInput: UserSentMessageNodeAggregationWhereInput;
	UserSentMessageRelationship: ResolverTypeWrapper<UserSentMessageRelationship>;
	UserSentMessageUpdateConnectionInput: UserSentMessageUpdateConnectionInput;
	UserSentMessageUpdateFieldInput: UserSentMessageUpdateFieldInput;
	UserSort: UserSort;
	UserSubscribedAggregateInput: UserSubscribedAggregateInput;
	UserSubscribedConnectFieldInput: UserSubscribedConnectFieldInput;
	UserSubscribedConnection: ResolverTypeWrapper<UserSubscribedConnection>;
	UserSubscribedConnectionSort: UserSubscribedConnectionSort;
	UserSubscribedConnectionWhere: UserSubscribedConnectionWhere;
	UserSubscribedCreateFieldInput: UserSubscribedCreateFieldInput;
	UserSubscribedDeleteFieldInput: UserSubscribedDeleteFieldInput;
	UserSubscribedDisconnectFieldInput: UserSubscribedDisconnectFieldInput;
	UserSubscribedFieldInput: UserSubscribedFieldInput;
	UserSubscribedNodeAggregationWhereInput: UserSubscribedNodeAggregationWhereInput;
	UserSubscribedRelationship: ResolverTypeWrapper<UserSubscribedRelationship>;
	UserSubscribedUpdateConnectionInput: UserSubscribedUpdateConnectionInput;
	UserSubscribedUpdateFieldInput: UserSubscribedUpdateFieldInput;
	UserTaskProperties: ResolversTypes["UserTasksRelationship"];
	UserTaskPropertiesCreateInput: UserTaskPropertiesCreateInput;
	UserTaskPropertiesSort: UserTaskPropertiesSort;
	UserTaskPropertiesUpdateInput: UserTaskPropertiesUpdateInput;
	UserTaskPropertiesWhere: UserTaskPropertiesWhere;
	UserTaskRelationship: ResolversTypes["TaskUsersRelationshipRelationship"];
	UserTaskRelationshipCreateInput: UserTaskRelationshipCreateInput;
	UserTaskRelationshipSort: UserTaskRelationshipSort;
	UserTaskRelationshipUpdateInput: UserTaskRelationshipUpdateInput;
	UserTaskRelationshipWhere: UserTaskRelationshipWhere;
	UserTasksAggregateInput: UserTasksAggregateInput;
	UserTasksConnectFieldInput: UserTasksConnectFieldInput;
	UserTasksConnection: ResolverTypeWrapper<UserTasksConnection>;
	UserTasksConnectionSort: UserTasksConnectionSort;
	UserTasksConnectionWhere: UserTasksConnectionWhere;
	UserTasksCreateFieldInput: UserTasksCreateFieldInput;
	UserTasksDeleteFieldInput: UserTasksDeleteFieldInput;
	UserTasksDisconnectFieldInput: UserTasksDisconnectFieldInput;
	UserTasksFieldInput: UserTasksFieldInput;
	UserTasksNodeAggregationWhereInput: UserTasksNodeAggregationWhereInput;
	UserTasksRelationship: ResolverTypeWrapper<UserTasksRelationship>;
	UserTasksUpdateConnectionInput: UserTasksUpdateConnectionInput;
	UserTasksUpdateFieldInput: UserTasksUpdateFieldInput;
	UserUpdateInput: UserUpdateInput;
	UserWhere: UserWhere;
	WorkflowParticipantDecisionInput: WorkflowParticipantDecisionInput;
};

/** Mapping between all available schema types and the resolvers parents */
export type ResolversParentTypes = {
	AdverseEvent: AdverseEvent;
	AdverseEventAggregateSelection: AdverseEventAggregateSelection;
	AdverseEventConnectInput: AdverseEventConnectInput;
	AdverseEventConnectWhere: AdverseEventConnectWhere;
	AdverseEventCounterparties: AdverseEventCounterparties;
	AdverseEventCounterpartiesAggregateSelection: AdverseEventCounterpartiesAggregateSelection;
	AdverseEventCounterpartiesOptions: AdverseEventCounterpartiesOptions;
	AdverseEventCounterpartiesSort: AdverseEventCounterpartiesSort;
	AdverseEventCounterpartiesWhere: AdverseEventCounterpartiesWhere;
	AdverseEventCreateInput: AdverseEventCreateInput;
	AdverseEventDeleteInput: AdverseEventDeleteInput;
	AdverseEventDisconnectInput: AdverseEventDisconnectInput;
	AdverseEventInitialResponseAggregateInput: AdverseEventInitialResponseAggregateInput;
	AdverseEventInitialResponseConnectFieldInput: AdverseEventInitialResponseConnectFieldInput;
	AdverseEventInitialResponseConnection: AdverseEventInitialResponseConnection;
	AdverseEventInitialResponseConnectionSort: AdverseEventInitialResponseConnectionSort;
	AdverseEventInitialResponseConnectionWhere: AdverseEventInitialResponseConnectionWhere;
	AdverseEventInitialResponseCreateFieldInput: AdverseEventInitialResponseCreateFieldInput;
	AdverseEventInitialResponseDeleteFieldInput: AdverseEventInitialResponseDeleteFieldInput;
	AdverseEventInitialResponseDisconnectFieldInput: AdverseEventInitialResponseDisconnectFieldInput;
	AdverseEventInitialResponseFieldInput: AdverseEventInitialResponseFieldInput;
	AdverseEventInitialResponseNodeAggregationWhereInput: AdverseEventInitialResponseNodeAggregationWhereInput;
	AdverseEventInitialResponseRelationship: AdverseEventInitialResponseRelationship;
	AdverseEventInitialResponseUpdateConnectionInput: AdverseEventInitialResponseUpdateConnectionInput;
	AdverseEventInitialResponseUpdateFieldInput: AdverseEventInitialResponseUpdateFieldInput;
	AdverseEventInput: AdverseEventInput;
	AdverseEventOptions: AdverseEventOptions;
	AdverseEventReport: AdverseEventReport;
	AdverseEventReportAggregateSelection: AdverseEventReportAggregateSelection;
	AdverseEventReportOptions: AdverseEventReportOptions;
	AdverseEventReportSort: AdverseEventReportSort;
	AdverseEventReportWhere: AdverseEventReportWhere;
	AdverseEventSort: AdverseEventSort;
	AdverseEventUpdateInput: AdverseEventUpdateInput;
	AdverseEventWhere: AdverseEventWhere;
	AdverseEventsOccurenceReport: AdverseEventsOccurenceReport;
	AdverseEventsOccurenceReportAggregateSelection: AdverseEventsOccurenceReportAggregateSelection;
	AdverseEventsOccurenceReportCreateInput: AdverseEventsOccurenceReportCreateInput;
	AdverseEventsOccurenceReportOptions: AdverseEventsOccurenceReportOptions;
	AdverseEventsOccurenceReportSort: AdverseEventsOccurenceReportSort;
	AdverseEventsOccurenceReportUpdateInput: AdverseEventsOccurenceReportUpdateInput;
	AdverseEventsOccurenceReportWhere: AdverseEventsOccurenceReportWhere;
	Agreement: Agreement;
	AgreementAggregateSelection: AgreementAggregateSelection;
	AgreementConnectInput: AgreementConnectInput;
	AgreementConnectWhere: AgreementConnectWhere;
	AgreementCounterpartyRolesAggregateInput: AgreementCounterpartyRolesAggregateInput;
	AgreementCounterpartyRolesConnectFieldInput: AgreementCounterpartyRolesConnectFieldInput;
	AgreementCounterpartyRolesConnection: AgreementCounterpartyRolesConnection;
	AgreementCounterpartyRolesConnectionSort: AgreementCounterpartyRolesConnectionSort;
	AgreementCounterpartyRolesConnectionWhere: AgreementCounterpartyRolesConnectionWhere;
	AgreementCounterpartyRolesCreateFieldInput: AgreementCounterpartyRolesCreateFieldInput;
	AgreementCounterpartyRolesDeleteFieldInput: AgreementCounterpartyRolesDeleteFieldInput;
	AgreementCounterpartyRolesDisconnectFieldInput: AgreementCounterpartyRolesDisconnectFieldInput;
	AgreementCounterpartyRolesFieldInput: AgreementCounterpartyRolesFieldInput;
	AgreementCounterpartyRolesNodeAggregationWhereInput: AgreementCounterpartyRolesNodeAggregationWhereInput;
	AgreementCounterpartyRolesRelationship: AgreementCounterpartyRolesRelationship;
	AgreementCounterpartyRolesUpdateConnectionInput: AgreementCounterpartyRolesUpdateConnectionInput;
	AgreementCounterpartyRolesUpdateFieldInput: AgreementCounterpartyRolesUpdateFieldInput;
	AgreementCreateInput: AgreementCreateInput;
	AgreementCurrencyAggregateInput: AgreementCurrencyAggregateInput;
	AgreementCurrencyConnectFieldInput: AgreementCurrencyConnectFieldInput;
	AgreementCurrencyConnection: AgreementCurrencyConnection;
	AgreementCurrencyConnectionSort: AgreementCurrencyConnectionSort;
	AgreementCurrencyConnectionWhere: AgreementCurrencyConnectionWhere;
	AgreementCurrencyCreateFieldInput: AgreementCurrencyCreateFieldInput;
	AgreementCurrencyDeleteFieldInput: AgreementCurrencyDeleteFieldInput;
	AgreementCurrencyDisconnectFieldInput: AgreementCurrencyDisconnectFieldInput;
	AgreementCurrencyFieldInput: AgreementCurrencyFieldInput;
	AgreementCurrencyNodeAggregationWhereInput: AgreementCurrencyNodeAggregationWhereInput;
	AgreementCurrencyRelationship: AgreementCurrencyRelationship;
	AgreementCurrencyUpdateConnectionInput: AgreementCurrencyUpdateConnectionInput;
	AgreementCurrencyUpdateFieldInput: AgreementCurrencyUpdateFieldInput;
	AgreementDecision: AgreementDecision;
	AgreementDecisionAggregateSelection: AgreementDecisionAggregateSelection;
	AgreementDecisionAsOfAggregateInput: AgreementDecisionAsOfAggregateInput;
	AgreementDecisionAsOfConnectFieldInput: AgreementDecisionAsOfConnectFieldInput;
	AgreementDecisionAsOfConnection: AgreementDecisionAsOfConnection;
	AgreementDecisionAsOfConnectionSort: AgreementDecisionAsOfConnectionSort;
	AgreementDecisionAsOfConnectionWhere: AgreementDecisionAsOfConnectionWhere;
	AgreementDecisionAsOfCreateFieldInput: AgreementDecisionAsOfCreateFieldInput;
	AgreementDecisionAsOfDeleteFieldInput: AgreementDecisionAsOfDeleteFieldInput;
	AgreementDecisionAsOfDisconnectFieldInput: AgreementDecisionAsOfDisconnectFieldInput;
	AgreementDecisionAsOfFieldInput: AgreementDecisionAsOfFieldInput;
	AgreementDecisionAsOfNodeAggregationWhereInput: AgreementDecisionAsOfNodeAggregationWhereInput;
	AgreementDecisionAsOfRelationship: AgreementDecisionAsOfRelationship;
	AgreementDecisionAsOfUpdateConnectionInput: AgreementDecisionAsOfUpdateConnectionInput;
	AgreementDecisionAsOfUpdateFieldInput: AgreementDecisionAsOfUpdateFieldInput;
	AgreementDecisionConnectInput: AgreementDecisionConnectInput;
	AgreementDecisionConnectWhere: AgreementDecisionConnectWhere;
	AgreementDecisionCreateInput: AgreementDecisionCreateInput;
	AgreementDecisionDeleteInput: AgreementDecisionDeleteInput;
	AgreementDecisionDisconnectInput: AgreementDecisionDisconnectInput;
	AgreementDecisionInput: AgreementDecisionInput;
	AgreementDecisionMadeByAggregateInput: AgreementDecisionMadeByAggregateInput;
	AgreementDecisionMadeByConnectFieldInput: AgreementDecisionMadeByConnectFieldInput;
	AgreementDecisionMadeByConnection: AgreementDecisionMadeByConnection;
	AgreementDecisionMadeByConnectionSort: AgreementDecisionMadeByConnectionSort;
	AgreementDecisionMadeByConnectionWhere: AgreementDecisionMadeByConnectionWhere;
	AgreementDecisionMadeByCreateFieldInput: AgreementDecisionMadeByCreateFieldInput;
	AgreementDecisionMadeByDeleteFieldInput: AgreementDecisionMadeByDeleteFieldInput;
	AgreementDecisionMadeByDisconnectFieldInput: AgreementDecisionMadeByDisconnectFieldInput;
	AgreementDecisionMadeByFieldInput: AgreementDecisionMadeByFieldInput;
	AgreementDecisionMadeByNodeAggregationWhereInput: AgreementDecisionMadeByNodeAggregationWhereInput;
	AgreementDecisionMadeByRelationship: AgreementDecisionMadeByRelationship;
	AgreementDecisionMadeByUpdateConnectionInput: AgreementDecisionMadeByUpdateConnectionInput;
	AgreementDecisionMadeByUpdateFieldInput: AgreementDecisionMadeByUpdateFieldInput;
	AgreementDecisionOptions: AgreementDecisionOptions;
	AgreementDecisionSort: AgreementDecisionSort;
	AgreementDecisionUpdateInput: AgreementDecisionUpdateInput;
	AgreementDecisionWhere: AgreementDecisionWhere;
	AgreementDeleteInput: AgreementDeleteInput;
	AgreementDeviceAlternativeSetsAggregateInput: AgreementDeviceAlternativeSetsAggregateInput;
	AgreementDeviceAlternativeSetsConnectFieldInput: AgreementDeviceAlternativeSetsConnectFieldInput;
	AgreementDeviceAlternativeSetsConnection: AgreementDeviceAlternativeSetsConnection;
	AgreementDeviceAlternativeSetsConnectionSort: AgreementDeviceAlternativeSetsConnectionSort;
	AgreementDeviceAlternativeSetsConnectionWhere: AgreementDeviceAlternativeSetsConnectionWhere;
	AgreementDeviceAlternativeSetsCreateFieldInput: AgreementDeviceAlternativeSetsCreateFieldInput;
	AgreementDeviceAlternativeSetsDeleteFieldInput: AgreementDeviceAlternativeSetsDeleteFieldInput;
	AgreementDeviceAlternativeSetsDisconnectFieldInput: AgreementDeviceAlternativeSetsDisconnectFieldInput;
	AgreementDeviceAlternativeSetsFieldInput: AgreementDeviceAlternativeSetsFieldInput;
	AgreementDeviceAlternativeSetsNodeAggregationWhereInput: AgreementDeviceAlternativeSetsNodeAggregationWhereInput;
	AgreementDeviceAlternativeSetsRelationship: AgreementDeviceAlternativeSetsRelationship;
	AgreementDeviceAlternativeSetsUpdateConnectionInput: AgreementDeviceAlternativeSetsUpdateConnectionInput;
	AgreementDeviceAlternativeSetsUpdateFieldInput: AgreementDeviceAlternativeSetsUpdateFieldInput;
	AgreementDisconnectInput: AgreementDisconnectInput;
	AgreementFinancialSummaryColumnRelationship: ResolversParentTypes["BaseAgreementFinancialSummaryConfigRelationship"];
	AgreementFinancialSummaryColumnRelationshipCreateInput: AgreementFinancialSummaryColumnRelationshipCreateInput;
	AgreementFinancialSummaryColumnRelationshipSort: AgreementFinancialSummaryColumnRelationshipSort;
	AgreementFinancialSummaryColumnRelationshipUpdateInput: AgreementFinancialSummaryColumnRelationshipUpdateInput;
	AgreementFinancialSummaryColumnRelationshipWhere: AgreementFinancialSummaryColumnRelationshipWhere;
	AgreementOptions: AgreementOptions;
	AgreementReport: AgreementReport;
	AgreementReportAggregateSelection: AgreementReportAggregateSelection;
	AgreementReportOptions: AgreementReportOptions;
	AgreementReportSort: AgreementReportSort;
	AgreementReportWhere: AgreementReportWhere;
	AgreementSort: AgreementSort;
	AgreementSpecificRole: AgreementSpecificRole;
	AgreementSpecificRoleAggregateSelection: AgreementSpecificRoleAggregateSelection;
	AgreementSpecificRoleOptions: AgreementSpecificRoleOptions;
	AgreementSpecificRoleSort: AgreementSpecificRoleSort;
	AgreementSpecificRoleWhere: AgreementSpecificRoleWhere;
	AgreementStatusTransition: AgreementStatusTransition;
	AgreementStatusTransitionAggregateSelection: AgreementStatusTransitionAggregateSelection;
	AgreementStatusTransitionCausedByAggregateInput: AgreementStatusTransitionCausedByAggregateInput;
	AgreementStatusTransitionCausedByConnectFieldInput: AgreementStatusTransitionCausedByConnectFieldInput;
	AgreementStatusTransitionCausedByConnection: AgreementStatusTransitionCausedByConnection;
	AgreementStatusTransitionCausedByConnectionSort: AgreementStatusTransitionCausedByConnectionSort;
	AgreementStatusTransitionCausedByConnectionWhere: AgreementStatusTransitionCausedByConnectionWhere;
	AgreementStatusTransitionCausedByCreateFieldInput: AgreementStatusTransitionCausedByCreateFieldInput;
	AgreementStatusTransitionCausedByDeleteFieldInput: AgreementStatusTransitionCausedByDeleteFieldInput;
	AgreementStatusTransitionCausedByDisconnectFieldInput: AgreementStatusTransitionCausedByDisconnectFieldInput;
	AgreementStatusTransitionCausedByFieldInput: AgreementStatusTransitionCausedByFieldInput;
	AgreementStatusTransitionCausedByNodeAggregationWhereInput: AgreementStatusTransitionCausedByNodeAggregationWhereInput;
	AgreementStatusTransitionCausedByRelationship: AgreementStatusTransitionCausedByRelationship;
	AgreementStatusTransitionCausedByUpdateConnectionInput: AgreementStatusTransitionCausedByUpdateConnectionInput;
	AgreementStatusTransitionCausedByUpdateFieldInput: AgreementStatusTransitionCausedByUpdateFieldInput;
	AgreementStatusTransitionConnectInput: AgreementStatusTransitionConnectInput;
	AgreementStatusTransitionConnectWhere: AgreementStatusTransitionConnectWhere;
	AgreementStatusTransitionCreateInput: AgreementStatusTransitionCreateInput;
	AgreementStatusTransitionDeleteInput: AgreementStatusTransitionDeleteInput;
	AgreementStatusTransitionDisconnectInput: AgreementStatusTransitionDisconnectInput;
	AgreementStatusTransitionOptions: AgreementStatusTransitionOptions;
	AgreementStatusTransitionSort: AgreementStatusTransitionSort;
	AgreementStatusTransitionUpdateInput: AgreementStatusTransitionUpdateInput;
	AgreementStatusTransitionWhere: AgreementStatusTransitionWhere;
	AgreementTag: AgreementTag;
	AgreementTagAggregateSelection: AgreementTagAggregateSelection;
	AgreementTagConnectInput: AgreementTagConnectInput;
	AgreementTagConnectWhere: AgreementTagConnectWhere;
	AgreementTagCreateInput: AgreementTagCreateInput;
	AgreementTagDefaultUserRolesAggregateInput: AgreementTagDefaultUserRolesAggregateInput;
	AgreementTagDefaultUserRolesConnectFieldInput: AgreementTagDefaultUserRolesConnectFieldInput;
	AgreementTagDefaultUserRolesConnection: AgreementTagDefaultUserRolesConnection;
	AgreementTagDefaultUserRolesConnectionSort: AgreementTagDefaultUserRolesConnectionSort;
	AgreementTagDefaultUserRolesConnectionWhere: AgreementTagDefaultUserRolesConnectionWhere;
	AgreementTagDefaultUserRolesCreateFieldInput: AgreementTagDefaultUserRolesCreateFieldInput;
	AgreementTagDefaultUserRolesDeleteFieldInput: AgreementTagDefaultUserRolesDeleteFieldInput;
	AgreementTagDefaultUserRolesDisconnectFieldInput: AgreementTagDefaultUserRolesDisconnectFieldInput;
	AgreementTagDefaultUserRolesFieldInput: AgreementTagDefaultUserRolesFieldInput;
	AgreementTagDefaultUserRolesNodeAggregationWhereInput: AgreementTagDefaultUserRolesNodeAggregationWhereInput;
	AgreementTagDefaultUserRolesRelationship: AgreementTagDefaultUserRolesRelationship;
	AgreementTagDefaultUserRolesUpdateConnectionInput: AgreementTagDefaultUserRolesUpdateConnectionInput;
	AgreementTagDefaultUserRolesUpdateFieldInput: AgreementTagDefaultUserRolesUpdateFieldInput;
	AgreementTagDeleteInput: AgreementTagDeleteInput;
	AgreementTagDisconnectInput: AgreementTagDisconnectInput;
	AgreementTagOptions: AgreementTagOptions;
	AgreementTagSort: AgreementTagSort;
	AgreementTagUpdateInput: AgreementTagUpdateInput;
	AgreementTagUserRoleRelationship: ResolversParentTypes["AgreementTagDefaultUserRolesRelationship"];
	AgreementTagUserRoleRelationshipCreateInput: AgreementTagUserRoleRelationshipCreateInput;
	AgreementTagUserRoleRelationshipSort: AgreementTagUserRoleRelationshipSort;
	AgreementTagUserRoleRelationshipUpdateInput: AgreementTagUserRoleRelationshipUpdateInput;
	AgreementTagUserRoleRelationshipWhere: AgreementTagUserRoleRelationshipWhere;
	AgreementTagWhere: AgreementTagWhere;
	AgreementTagsAggregateInput: AgreementTagsAggregateInput;
	AgreementTagsConnectFieldInput: AgreementTagsConnectFieldInput;
	AgreementTagsConnection: AgreementTagsConnection;
	AgreementTagsConnectionSort: AgreementTagsConnectionSort;
	AgreementTagsConnectionWhere: AgreementTagsConnectionWhere;
	AgreementTagsCreateFieldInput: AgreementTagsCreateFieldInput;
	AgreementTagsDeleteFieldInput: AgreementTagsDeleteFieldInput;
	AgreementTagsDisconnectFieldInput: AgreementTagsDisconnectFieldInput;
	AgreementTagsFieldInput: AgreementTagsFieldInput;
	AgreementTagsNodeAggregationWhereInput: AgreementTagsNodeAggregationWhereInput;
	AgreementTagsRelationship: AgreementTagsRelationship;
	AgreementTagsUpdateConnectionInput: AgreementTagsUpdateConnectionInput;
	AgreementTagsUpdateFieldInput: AgreementTagsUpdateFieldInput;
	AgreementUpdateInput: AgreementUpdateInput;
	AgreementUserRoleRelationship: ResolversParentTypes["AgreementUserRolesRelationship"];
	AgreementUserRoleRelationshipCreateInput: AgreementUserRoleRelationshipCreateInput;
	AgreementUserRoleRelationshipSort: AgreementUserRoleRelationshipSort;
	AgreementUserRoleRelationshipUpdateInput: AgreementUserRoleRelationshipUpdateInput;
	AgreementUserRoleRelationshipWhere: AgreementUserRoleRelationshipWhere;
	AgreementUserRolesAggregateInput: AgreementUserRolesAggregateInput;
	AgreementUserRolesConnectFieldInput: AgreementUserRolesConnectFieldInput;
	AgreementUserRolesConnection: AgreementUserRolesConnection;
	AgreementUserRolesConnectionSort: AgreementUserRolesConnectionSort;
	AgreementUserRolesConnectionWhere: AgreementUserRolesConnectionWhere;
	AgreementUserRolesCreateFieldInput: AgreementUserRolesCreateFieldInput;
	AgreementUserRolesDeleteFieldInput: AgreementUserRolesDeleteFieldInput;
	AgreementUserRolesDisconnectFieldInput: AgreementUserRolesDisconnectFieldInput;
	AgreementUserRolesFieldInput: AgreementUserRolesFieldInput;
	AgreementUserRolesNodeAggregationWhereInput: AgreementUserRolesNodeAggregationWhereInput;
	AgreementUserRolesRelationship: AgreementUserRolesRelationship;
	AgreementUserRolesUpdateConnectionInput: AgreementUserRolesUpdateConnectionInput;
	AgreementUserRolesUpdateFieldInput: AgreementUserRolesUpdateFieldInput;
	AgreementWhere: AgreementWhere;
	AgreementWorkflowsAggregateInput: AgreementWorkflowsAggregateInput;
	AgreementWorkflowsConnectFieldInput: AgreementWorkflowsConnectFieldInput;
	AgreementWorkflowsConnection: AgreementWorkflowsConnection;
	AgreementWorkflowsConnectionSort: AgreementWorkflowsConnectionSort;
	AgreementWorkflowsConnectionWhere: AgreementWorkflowsConnectionWhere;
	AgreementWorkflowsCreateFieldInput: AgreementWorkflowsCreateFieldInput;
	AgreementWorkflowsDeleteFieldInput: AgreementWorkflowsDeleteFieldInput;
	AgreementWorkflowsDisconnectFieldInput: AgreementWorkflowsDisconnectFieldInput;
	AgreementWorkflowsFieldInput: AgreementWorkflowsFieldInput;
	AgreementWorkflowsRelationship: AgreementWorkflowsRelationship;
	AgreementWorkflowsUpdateConnectionInput: AgreementWorkflowsUpdateConnectionInput;
	AgreementWorkflowsUpdateFieldInput: AgreementWorkflowsUpdateFieldInput;
	AssignInvoiceToUserInput: AssignInvoiceToUserInput;
	AssigneeInput: AssigneeInput;
	AverageLAPressureAndLAVolumeRow: AverageLaPressureAndLaVolumeRow;
	AverageLAPressureAndLAVolumeRowAggregateSelection: AverageLaPressureAndLaVolumeRowAggregateSelection;
	AverageLAPressureAndLAVolumeRowOptions: AverageLaPressureAndLaVolumeRowOptions;
	AverageLAPressureAndLAVolumeRowSort: AverageLaPressureAndLaVolumeRowSort;
	AverageLAPressureAndLAVolumeRowWhere: AverageLaPressureAndLaVolumeRowWhere;
	BaseAgreement: BaseAgreement;
	BaseAgreementAddedByAggregateInput: BaseAgreementAddedByAggregateInput;
	BaseAgreementAddedByConnectFieldInput: BaseAgreementAddedByConnectFieldInput;
	BaseAgreementAddedByConnection: BaseAgreementAddedByConnection;
	BaseAgreementAddedByConnectionSort: BaseAgreementAddedByConnectionSort;
	BaseAgreementAddedByConnectionWhere: BaseAgreementAddedByConnectionWhere;
	BaseAgreementAddedByCreateFieldInput: BaseAgreementAddedByCreateFieldInput;
	BaseAgreementAddedByDeleteFieldInput: BaseAgreementAddedByDeleteFieldInput;
	BaseAgreementAddedByDisconnectFieldInput: BaseAgreementAddedByDisconnectFieldInput;
	BaseAgreementAddedByFieldInput: BaseAgreementAddedByFieldInput;
	BaseAgreementAddedByNodeAggregationWhereInput: BaseAgreementAddedByNodeAggregationWhereInput;
	BaseAgreementAddedByRelationship: BaseAgreementAddedByRelationship;
	BaseAgreementAddedByUpdateConnectionInput: BaseAgreementAddedByUpdateConnectionInput;
	BaseAgreementAddedByUpdateFieldInput: BaseAgreementAddedByUpdateFieldInput;
	BaseAgreementAggregateSelection: BaseAgreementAggregateSelection;
	BaseAgreementCategoriesAggregateInput: BaseAgreementCategoriesAggregateInput;
	BaseAgreementCategoriesConnectFieldInput: BaseAgreementCategoriesConnectFieldInput;
	BaseAgreementCategoriesConnection: BaseAgreementCategoriesConnection;
	BaseAgreementCategoriesConnectionSort: BaseAgreementCategoriesConnectionSort;
	BaseAgreementCategoriesConnectionWhere: BaseAgreementCategoriesConnectionWhere;
	BaseAgreementCategoriesCreateFieldInput: BaseAgreementCategoriesCreateFieldInput;
	BaseAgreementCategoriesDeleteFieldInput: BaseAgreementCategoriesDeleteFieldInput;
	BaseAgreementCategoriesDisconnectFieldInput: BaseAgreementCategoriesDisconnectFieldInput;
	BaseAgreementCategoriesFieldInput: BaseAgreementCategoriesFieldInput;
	BaseAgreementCategoriesNodeAggregationWhereInput: BaseAgreementCategoriesNodeAggregationWhereInput;
	BaseAgreementCategoriesRelationship: BaseAgreementCategoriesRelationship;
	BaseAgreementCategoriesUpdateConnectionInput: BaseAgreementCategoriesUpdateConnectionInput;
	BaseAgreementCategoriesUpdateFieldInput: BaseAgreementCategoriesUpdateFieldInput;
	BaseAgreementCategoryDiscountCaps: ResolversParentTypes["BaseAgreementDiscountCapsCategoriesRelationship"];
	BaseAgreementCategoryDiscountCapsCreateInput: BaseAgreementCategoryDiscountCapsCreateInput;
	BaseAgreementCategoryDiscountCapsSort: BaseAgreementCategoryDiscountCapsSort;
	BaseAgreementCategoryDiscountCapsUpdateInput: BaseAgreementCategoryDiscountCapsUpdateInput;
	BaseAgreementCategoryDiscountCapsWhere: BaseAgreementCategoryDiscountCapsWhere;
	BaseAgreementConnectInput: BaseAgreementConnectInput;
	BaseAgreementConnectWhere: BaseAgreementConnectWhere;
	BaseAgreementCounterpartiesAggregateInput: BaseAgreementCounterpartiesAggregateInput;
	BaseAgreementCounterpartiesConnectFieldInput: BaseAgreementCounterpartiesConnectFieldInput;
	BaseAgreementCounterpartiesConnection: BaseAgreementCounterpartiesConnection;
	BaseAgreementCounterpartiesConnectionSort: BaseAgreementCounterpartiesConnectionSort;
	BaseAgreementCounterpartiesConnectionWhere: BaseAgreementCounterpartiesConnectionWhere;
	BaseAgreementCounterpartiesCreateFieldInput: BaseAgreementCounterpartiesCreateFieldInput;
	BaseAgreementCounterpartiesDeleteFieldInput: BaseAgreementCounterpartiesDeleteFieldInput;
	BaseAgreementCounterpartiesDisconnectFieldInput: BaseAgreementCounterpartiesDisconnectFieldInput;
	BaseAgreementCounterpartiesFieldInput: BaseAgreementCounterpartiesFieldInput;
	BaseAgreementCounterpartiesNodeAggregationWhereInput: BaseAgreementCounterpartiesNodeAggregationWhereInput;
	BaseAgreementCounterpartiesRelationship: BaseAgreementCounterpartiesRelationship;
	BaseAgreementCounterpartiesUpdateConnectionInput: BaseAgreementCounterpartiesUpdateConnectionInput;
	BaseAgreementCounterpartiesUpdateFieldInput: BaseAgreementCounterpartiesUpdateFieldInput;
	BaseAgreementCounterpartyRelationship: ResolversParentTypes["BaseAgreementCounterpartiesRelationship"];
	BaseAgreementCounterpartyRelationshipCreateInput: BaseAgreementCounterpartyRelationshipCreateInput;
	BaseAgreementCounterpartyRelationshipSort: BaseAgreementCounterpartyRelationshipSort;
	BaseAgreementCounterpartyRelationshipUpdateInput: BaseAgreementCounterpartyRelationshipUpdateInput;
	BaseAgreementCounterpartyRelationshipWhere: BaseAgreementCounterpartyRelationshipWhere;
	BaseAgreementCreateInput: BaseAgreementCreateInput;
	BaseAgreementCurrencyAggregateInput: BaseAgreementCurrencyAggregateInput;
	BaseAgreementCurrencyConnectFieldInput: BaseAgreementCurrencyConnectFieldInput;
	BaseAgreementCurrencyConnection: BaseAgreementCurrencyConnection;
	BaseAgreementCurrencyConnectionSort: BaseAgreementCurrencyConnectionSort;
	BaseAgreementCurrencyConnectionWhere: BaseAgreementCurrencyConnectionWhere;
	BaseAgreementCurrencyCreateFieldInput: BaseAgreementCurrencyCreateFieldInput;
	BaseAgreementCurrencyDeleteFieldInput: BaseAgreementCurrencyDeleteFieldInput;
	BaseAgreementCurrencyDisconnectFieldInput: BaseAgreementCurrencyDisconnectFieldInput;
	BaseAgreementCurrencyFieldInput: BaseAgreementCurrencyFieldInput;
	BaseAgreementCurrencyNodeAggregationWhereInput: BaseAgreementCurrencyNodeAggregationWhereInput;
	BaseAgreementCurrencyRelationship: BaseAgreementCurrencyRelationship;
	BaseAgreementCurrencyUpdateConnectionInput: BaseAgreementCurrencyUpdateConnectionInput;
	BaseAgreementCurrencyUpdateFieldInput: BaseAgreementCurrencyUpdateFieldInput;
	BaseAgreementDataContainersAggregateInput: BaseAgreementDataContainersAggregateInput;
	BaseAgreementDataContainersConnectFieldInput: BaseAgreementDataContainersConnectFieldInput;
	BaseAgreementDataContainersConnection: BaseAgreementDataContainersConnection;
	BaseAgreementDataContainersConnectionSort: BaseAgreementDataContainersConnectionSort;
	BaseAgreementDataContainersConnectionWhere: BaseAgreementDataContainersConnectionWhere;
	BaseAgreementDataContainersCreateFieldInput: BaseAgreementDataContainersCreateFieldInput;
	BaseAgreementDataContainersDeleteFieldInput: BaseAgreementDataContainersDeleteFieldInput;
	BaseAgreementDataContainersDisconnectFieldInput: BaseAgreementDataContainersDisconnectFieldInput;
	BaseAgreementDataContainersFieldInput: BaseAgreementDataContainersFieldInput;
	BaseAgreementDataContainersNodeAggregationWhereInput: BaseAgreementDataContainersNodeAggregationWhereInput;
	BaseAgreementDataContainersRelationship: BaseAgreementDataContainersRelationship;
	BaseAgreementDataContainersUpdateConnectionInput: BaseAgreementDataContainersUpdateConnectionInput;
	BaseAgreementDataContainersUpdateFieldInput: BaseAgreementDataContainersUpdateFieldInput;
	BaseAgreementDataSourceAggregateInput: BaseAgreementDataSourceAggregateInput;
	BaseAgreementDataSourceConnectFieldInput: BaseAgreementDataSourceConnectFieldInput;
	BaseAgreementDataSourceConnection: BaseAgreementDataSourceConnection;
	BaseAgreementDataSourceConnectionSort: BaseAgreementDataSourceConnectionSort;
	BaseAgreementDataSourceConnectionWhere: BaseAgreementDataSourceConnectionWhere;
	BaseAgreementDataSourceCreateFieldInput: BaseAgreementDataSourceCreateFieldInput;
	BaseAgreementDataSourceDeleteFieldInput: BaseAgreementDataSourceDeleteFieldInput;
	BaseAgreementDataSourceDisconnectFieldInput: BaseAgreementDataSourceDisconnectFieldInput;
	BaseAgreementDataSourceFieldInput: BaseAgreementDataSourceFieldInput;
	BaseAgreementDataSourceNodeAggregationWhereInput: BaseAgreementDataSourceNodeAggregationWhereInput;
	BaseAgreementDataSourceRelationship: BaseAgreementDataSourceRelationship;
	BaseAgreementDataSourceUpdateConnectionInput: BaseAgreementDataSourceUpdateConnectionInput;
	BaseAgreementDataSourceUpdateFieldInput: BaseAgreementDataSourceUpdateFieldInput;
	BaseAgreementDecisionsAggregateInput: BaseAgreementDecisionsAggregateInput;
	BaseAgreementDecisionsConnectFieldInput: BaseAgreementDecisionsConnectFieldInput;
	BaseAgreementDecisionsConnection: BaseAgreementDecisionsConnection;
	BaseAgreementDecisionsConnectionSort: BaseAgreementDecisionsConnectionSort;
	BaseAgreementDecisionsConnectionWhere: BaseAgreementDecisionsConnectionWhere;
	BaseAgreementDecisionsCreateFieldInput: BaseAgreementDecisionsCreateFieldInput;
	BaseAgreementDecisionsDeleteFieldInput: BaseAgreementDecisionsDeleteFieldInput;
	BaseAgreementDecisionsDisconnectFieldInput: BaseAgreementDecisionsDisconnectFieldInput;
	BaseAgreementDecisionsFieldInput: BaseAgreementDecisionsFieldInput;
	BaseAgreementDecisionsNodeAggregationWhereInput: BaseAgreementDecisionsNodeAggregationWhereInput;
	BaseAgreementDecisionsRelationship: BaseAgreementDecisionsRelationship;
	BaseAgreementDecisionsUpdateConnectionInput: BaseAgreementDecisionsUpdateConnectionInput;
	BaseAgreementDecisionsUpdateFieldInput: BaseAgreementDecisionsUpdateFieldInput;
	BaseAgreementDeleteInput: BaseAgreementDeleteInput;
	BaseAgreementDeviceAlternativeSetsAggregateInput: BaseAgreementDeviceAlternativeSetsAggregateInput;
	BaseAgreementDeviceAlternativeSetsConnectFieldInput: BaseAgreementDeviceAlternativeSetsConnectFieldInput;
	BaseAgreementDeviceAlternativeSetsConnection: BaseAgreementDeviceAlternativeSetsConnection;
	BaseAgreementDeviceAlternativeSetsConnectionSort: BaseAgreementDeviceAlternativeSetsConnectionSort;
	BaseAgreementDeviceAlternativeSetsConnectionWhere: BaseAgreementDeviceAlternativeSetsConnectionWhere;
	BaseAgreementDeviceAlternativeSetsCreateFieldInput: BaseAgreementDeviceAlternativeSetsCreateFieldInput;
	BaseAgreementDeviceAlternativeSetsDeleteFieldInput: BaseAgreementDeviceAlternativeSetsDeleteFieldInput;
	BaseAgreementDeviceAlternativeSetsDisconnectFieldInput: BaseAgreementDeviceAlternativeSetsDisconnectFieldInput;
	BaseAgreementDeviceAlternativeSetsFieldInput: BaseAgreementDeviceAlternativeSetsFieldInput;
	BaseAgreementDeviceAlternativeSetsNodeAggregationWhereInput: BaseAgreementDeviceAlternativeSetsNodeAggregationWhereInput;
	BaseAgreementDeviceAlternativeSetsRelationship: BaseAgreementDeviceAlternativeSetsRelationship;
	BaseAgreementDeviceAlternativeSetsUpdateConnectionInput: BaseAgreementDeviceAlternativeSetsUpdateConnectionInput;
	BaseAgreementDeviceAlternativeSetsUpdateFieldInput: BaseAgreementDeviceAlternativeSetsUpdateFieldInput;
	BaseAgreementDeviceKitDiscountCaps: ResolversParentTypes["BaseAgreementDiscountCapsDeviceKitsRelationship"];
	BaseAgreementDeviceKitDiscountCapsCreateInput: BaseAgreementDeviceKitDiscountCapsCreateInput;
	BaseAgreementDeviceKitDiscountCapsSort: BaseAgreementDeviceKitDiscountCapsSort;
	BaseAgreementDeviceKitDiscountCapsUpdateInput: BaseAgreementDeviceKitDiscountCapsUpdateInput;
	BaseAgreementDeviceKitDiscountCapsWhere: BaseAgreementDeviceKitDiscountCapsWhere;
	BaseAgreementDisconnectInput: BaseAgreementDisconnectInput;
	BaseAgreementDiscountCapsCategoriesAggregateInput: BaseAgreementDiscountCapsCategoriesAggregateInput;
	BaseAgreementDiscountCapsCategoriesConnectFieldInput: BaseAgreementDiscountCapsCategoriesConnectFieldInput;
	BaseAgreementDiscountCapsCategoriesConnection: BaseAgreementDiscountCapsCategoriesConnection;
	BaseAgreementDiscountCapsCategoriesConnectionSort: BaseAgreementDiscountCapsCategoriesConnectionSort;
	BaseAgreementDiscountCapsCategoriesConnectionWhere: BaseAgreementDiscountCapsCategoriesConnectionWhere;
	BaseAgreementDiscountCapsCategoriesCreateFieldInput: BaseAgreementDiscountCapsCategoriesCreateFieldInput;
	BaseAgreementDiscountCapsCategoriesDeleteFieldInput: BaseAgreementDiscountCapsCategoriesDeleteFieldInput;
	BaseAgreementDiscountCapsCategoriesDisconnectFieldInput: BaseAgreementDiscountCapsCategoriesDisconnectFieldInput;
	BaseAgreementDiscountCapsCategoriesEdgeAggregationWhereInput: BaseAgreementDiscountCapsCategoriesEdgeAggregationWhereInput;
	BaseAgreementDiscountCapsCategoriesFieldInput: BaseAgreementDiscountCapsCategoriesFieldInput;
	BaseAgreementDiscountCapsCategoriesNodeAggregationWhereInput: BaseAgreementDiscountCapsCategoriesNodeAggregationWhereInput;
	BaseAgreementDiscountCapsCategoriesRelationship: BaseAgreementDiscountCapsCategoriesRelationship;
	BaseAgreementDiscountCapsCategoriesUpdateConnectionInput: BaseAgreementDiscountCapsCategoriesUpdateConnectionInput;
	BaseAgreementDiscountCapsCategoriesUpdateFieldInput: BaseAgreementDiscountCapsCategoriesUpdateFieldInput;
	BaseAgreementDiscountCapsDeviceKitsAggregateInput: BaseAgreementDiscountCapsDeviceKitsAggregateInput;
	BaseAgreementDiscountCapsDeviceKitsConnectFieldInput: BaseAgreementDiscountCapsDeviceKitsConnectFieldInput;
	BaseAgreementDiscountCapsDeviceKitsConnection: BaseAgreementDiscountCapsDeviceKitsConnection;
	BaseAgreementDiscountCapsDeviceKitsConnectionSort: BaseAgreementDiscountCapsDeviceKitsConnectionSort;
	BaseAgreementDiscountCapsDeviceKitsConnectionWhere: BaseAgreementDiscountCapsDeviceKitsConnectionWhere;
	BaseAgreementDiscountCapsDeviceKitsCreateFieldInput: BaseAgreementDiscountCapsDeviceKitsCreateFieldInput;
	BaseAgreementDiscountCapsDeviceKitsDeleteFieldInput: BaseAgreementDiscountCapsDeviceKitsDeleteFieldInput;
	BaseAgreementDiscountCapsDeviceKitsDisconnectFieldInput: BaseAgreementDiscountCapsDeviceKitsDisconnectFieldInput;
	BaseAgreementDiscountCapsDeviceKitsEdgeAggregationWhereInput: BaseAgreementDiscountCapsDeviceKitsEdgeAggregationWhereInput;
	BaseAgreementDiscountCapsDeviceKitsFieldInput: BaseAgreementDiscountCapsDeviceKitsFieldInput;
	BaseAgreementDiscountCapsDeviceKitsNodeAggregationWhereInput: BaseAgreementDiscountCapsDeviceKitsNodeAggregationWhereInput;
	BaseAgreementDiscountCapsDeviceKitsRelationship: BaseAgreementDiscountCapsDeviceKitsRelationship;
	BaseAgreementDiscountCapsDeviceKitsUpdateConnectionInput: BaseAgreementDiscountCapsDeviceKitsUpdateConnectionInput;
	BaseAgreementDiscountCapsDeviceKitsUpdateFieldInput: BaseAgreementDiscountCapsDeviceKitsUpdateFieldInput;
	BaseAgreementEligibilityConditionRelationship: ResolversParentTypes["BaseAgreementEligibilityConditionSetsRelationship"];
	BaseAgreementEligibilityConditionRelationshipCreateInput: BaseAgreementEligibilityConditionRelationshipCreateInput;
	BaseAgreementEligibilityConditionRelationshipSort: BaseAgreementEligibilityConditionRelationshipSort;
	BaseAgreementEligibilityConditionRelationshipUpdateInput: BaseAgreementEligibilityConditionRelationshipUpdateInput;
	BaseAgreementEligibilityConditionRelationshipWhere: BaseAgreementEligibilityConditionRelationshipWhere;
	BaseAgreementEligibilityConditionSetsAggregateInput: BaseAgreementEligibilityConditionSetsAggregateInput;
	BaseAgreementEligibilityConditionSetsConnectFieldInput: BaseAgreementEligibilityConditionSetsConnectFieldInput;
	BaseAgreementEligibilityConditionSetsConnection: BaseAgreementEligibilityConditionSetsConnection;
	BaseAgreementEligibilityConditionSetsConnectionSort: BaseAgreementEligibilityConditionSetsConnectionSort;
	BaseAgreementEligibilityConditionSetsConnectionWhere: BaseAgreementEligibilityConditionSetsConnectionWhere;
	BaseAgreementEligibilityConditionSetsCreateFieldInput: BaseAgreementEligibilityConditionSetsCreateFieldInput;
	BaseAgreementEligibilityConditionSetsDeleteFieldInput: BaseAgreementEligibilityConditionSetsDeleteFieldInput;
	BaseAgreementEligibilityConditionSetsDisconnectFieldInput: BaseAgreementEligibilityConditionSetsDisconnectFieldInput;
	BaseAgreementEligibilityConditionSetsEdgeAggregationWhereInput: BaseAgreementEligibilityConditionSetsEdgeAggregationWhereInput;
	BaseAgreementEligibilityConditionSetsFieldInput: BaseAgreementEligibilityConditionSetsFieldInput;
	BaseAgreementEligibilityConditionSetsNodeAggregationWhereInput: BaseAgreementEligibilityConditionSetsNodeAggregationWhereInput;
	BaseAgreementEligibilityConditionSetsRelationship: BaseAgreementEligibilityConditionSetsRelationship;
	BaseAgreementEligibilityConditionSetsUpdateConnectionInput: BaseAgreementEligibilityConditionSetsUpdateConnectionInput;
	BaseAgreementEligibilityConditionSetsUpdateFieldInput: BaseAgreementEligibilityConditionSetsUpdateFieldInput;
	BaseAgreementEnrollingConditionSetsAggregateInput: BaseAgreementEnrollingConditionSetsAggregateInput;
	BaseAgreementEnrollingConditionSetsConnectFieldInput: BaseAgreementEnrollingConditionSetsConnectFieldInput;
	BaseAgreementEnrollingConditionSetsConnection: BaseAgreementEnrollingConditionSetsConnection;
	BaseAgreementEnrollingConditionSetsConnectionSort: BaseAgreementEnrollingConditionSetsConnectionSort;
	BaseAgreementEnrollingConditionSetsConnectionWhere: BaseAgreementEnrollingConditionSetsConnectionWhere;
	BaseAgreementEnrollingConditionSetsCreateFieldInput: BaseAgreementEnrollingConditionSetsCreateFieldInput;
	BaseAgreementEnrollingConditionSetsDeleteFieldInput: BaseAgreementEnrollingConditionSetsDeleteFieldInput;
	BaseAgreementEnrollingConditionSetsDisconnectFieldInput: BaseAgreementEnrollingConditionSetsDisconnectFieldInput;
	BaseAgreementEnrollingConditionSetsFieldInput: BaseAgreementEnrollingConditionSetsFieldInput;
	BaseAgreementEnrollingConditionSetsNodeAggregationWhereInput: BaseAgreementEnrollingConditionSetsNodeAggregationWhereInput;
	BaseAgreementEnrollingConditionSetsRelationship: BaseAgreementEnrollingConditionSetsRelationship;
	BaseAgreementEnrollingConditionSetsUpdateConnectionInput: BaseAgreementEnrollingConditionSetsUpdateConnectionInput;
	BaseAgreementEnrollingConditionSetsUpdateFieldInput: BaseAgreementEnrollingConditionSetsUpdateFieldInput;
	BaseAgreementEnrollingPeriodsAggregateInput: BaseAgreementEnrollingPeriodsAggregateInput;
	BaseAgreementEnrollingPeriodsConnectFieldInput: BaseAgreementEnrollingPeriodsConnectFieldInput;
	BaseAgreementEnrollingPeriodsConnection: BaseAgreementEnrollingPeriodsConnection;
	BaseAgreementEnrollingPeriodsConnectionSort: BaseAgreementEnrollingPeriodsConnectionSort;
	BaseAgreementEnrollingPeriodsConnectionWhere: BaseAgreementEnrollingPeriodsConnectionWhere;
	BaseAgreementEnrollingPeriodsCreateFieldInput: BaseAgreementEnrollingPeriodsCreateFieldInput;
	BaseAgreementEnrollingPeriodsDeleteFieldInput: BaseAgreementEnrollingPeriodsDeleteFieldInput;
	BaseAgreementEnrollingPeriodsDisconnectFieldInput: BaseAgreementEnrollingPeriodsDisconnectFieldInput;
	BaseAgreementEnrollingPeriodsFieldInput: BaseAgreementEnrollingPeriodsFieldInput;
	BaseAgreementEnrollingPeriodsRelationship: BaseAgreementEnrollingPeriodsRelationship;
	BaseAgreementEnrollingPeriodsUpdateConnectionInput: BaseAgreementEnrollingPeriodsUpdateConnectionInput;
	BaseAgreementEnrollingPeriodsUpdateFieldInput: BaseAgreementEnrollingPeriodsUpdateFieldInput;
	BaseAgreementFinancialSummaryConfigAggregateInput: BaseAgreementFinancialSummaryConfigAggregateInput;
	BaseAgreementFinancialSummaryConfigConnectFieldInput: BaseAgreementFinancialSummaryConfigConnectFieldInput;
	BaseAgreementFinancialSummaryConfigConnection: BaseAgreementFinancialSummaryConfigConnection;
	BaseAgreementFinancialSummaryConfigConnectionSort: BaseAgreementFinancialSummaryConfigConnectionSort;
	BaseAgreementFinancialSummaryConfigConnectionWhere: BaseAgreementFinancialSummaryConfigConnectionWhere;
	BaseAgreementFinancialSummaryConfigCreateFieldInput: BaseAgreementFinancialSummaryConfigCreateFieldInput;
	BaseAgreementFinancialSummaryConfigDeleteFieldInput: BaseAgreementFinancialSummaryConfigDeleteFieldInput;
	BaseAgreementFinancialSummaryConfigDisconnectFieldInput: BaseAgreementFinancialSummaryConfigDisconnectFieldInput;
	BaseAgreementFinancialSummaryConfigEdgeAggregationWhereInput: BaseAgreementFinancialSummaryConfigEdgeAggregationWhereInput;
	BaseAgreementFinancialSummaryConfigFieldInput: BaseAgreementFinancialSummaryConfigFieldInput;
	BaseAgreementFinancialSummaryConfigNodeAggregationWhereInput: BaseAgreementFinancialSummaryConfigNodeAggregationWhereInput;
	BaseAgreementFinancialSummaryConfigRelationship: BaseAgreementFinancialSummaryConfigRelationship;
	BaseAgreementFinancialSummaryConfigUpdateConnectionInput: BaseAgreementFinancialSummaryConfigUpdateConnectionInput;
	BaseAgreementFinancialSummaryConfigUpdateFieldInput: BaseAgreementFinancialSummaryConfigUpdateFieldInput;
	BaseAgreementInitialVersionAggregateInput: BaseAgreementInitialVersionAggregateInput;
	BaseAgreementInitialVersionConnectFieldInput: BaseAgreementInitialVersionConnectFieldInput;
	BaseAgreementInitialVersionConnection: BaseAgreementInitialVersionConnection;
	BaseAgreementInitialVersionConnectionSort: BaseAgreementInitialVersionConnectionSort;
	BaseAgreementInitialVersionConnectionWhere: BaseAgreementInitialVersionConnectionWhere;
	BaseAgreementInitialVersionCreateFieldInput: BaseAgreementInitialVersionCreateFieldInput;
	BaseAgreementInitialVersionDeleteFieldInput: BaseAgreementInitialVersionDeleteFieldInput;
	BaseAgreementInitialVersionDisconnectFieldInput: BaseAgreementInitialVersionDisconnectFieldInput;
	BaseAgreementInitialVersionFieldInput: BaseAgreementInitialVersionFieldInput;
	BaseAgreementInitialVersionNodeAggregationWhereInput: BaseAgreementInitialVersionNodeAggregationWhereInput;
	BaseAgreementInitialVersionRelationship: BaseAgreementInitialVersionRelationship;
	BaseAgreementInitialVersionUpdateConnectionInput: BaseAgreementInitialVersionUpdateConnectionInput;
	BaseAgreementInitialVersionUpdateFieldInput: BaseAgreementInitialVersionUpdateFieldInput;
	BaseAgreementNamedTimeRangesAggregateInput: BaseAgreementNamedTimeRangesAggregateInput;
	BaseAgreementNamedTimeRangesConnectFieldInput: BaseAgreementNamedTimeRangesConnectFieldInput;
	BaseAgreementNamedTimeRangesConnection: BaseAgreementNamedTimeRangesConnection;
	BaseAgreementNamedTimeRangesConnectionSort: BaseAgreementNamedTimeRangesConnectionSort;
	BaseAgreementNamedTimeRangesConnectionWhere: BaseAgreementNamedTimeRangesConnectionWhere;
	BaseAgreementNamedTimeRangesCreateFieldInput: BaseAgreementNamedTimeRangesCreateFieldInput;
	BaseAgreementNamedTimeRangesDeleteFieldInput: BaseAgreementNamedTimeRangesDeleteFieldInput;
	BaseAgreementNamedTimeRangesDisconnectFieldInput: BaseAgreementNamedTimeRangesDisconnectFieldInput;
	BaseAgreementNamedTimeRangesFieldInput: BaseAgreementNamedTimeRangesFieldInput;
	BaseAgreementNamedTimeRangesNodeAggregationWhereInput: BaseAgreementNamedTimeRangesNodeAggregationWhereInput;
	BaseAgreementNamedTimeRangesRelationship: BaseAgreementNamedTimeRangesRelationship;
	BaseAgreementNamedTimeRangesUpdateConnectionInput: BaseAgreementNamedTimeRangesUpdateConnectionInput;
	BaseAgreementNamedTimeRangesUpdateFieldInput: BaseAgreementNamedTimeRangesUpdateFieldInput;
	BaseAgreementNextVersionsAggregateInput: BaseAgreementNextVersionsAggregateInput;
	BaseAgreementNextVersionsConnectFieldInput: BaseAgreementNextVersionsConnectFieldInput;
	BaseAgreementNextVersionsConnection: BaseAgreementNextVersionsConnection;
	BaseAgreementNextVersionsConnectionSort: BaseAgreementNextVersionsConnectionSort;
	BaseAgreementNextVersionsConnectionWhere: BaseAgreementNextVersionsConnectionWhere;
	BaseAgreementNextVersionsCreateFieldInput: BaseAgreementNextVersionsCreateFieldInput;
	BaseAgreementNextVersionsDeleteFieldInput: BaseAgreementNextVersionsDeleteFieldInput;
	BaseAgreementNextVersionsDisconnectFieldInput: BaseAgreementNextVersionsDisconnectFieldInput;
	BaseAgreementNextVersionsFieldInput: BaseAgreementNextVersionsFieldInput;
	BaseAgreementNextVersionsNodeAggregationWhereInput: BaseAgreementNextVersionsNodeAggregationWhereInput;
	BaseAgreementNextVersionsRelationship: BaseAgreementNextVersionsRelationship;
	BaseAgreementNextVersionsUpdateConnectionInput: BaseAgreementNextVersionsUpdateConnectionInput;
	BaseAgreementNextVersionsUpdateFieldInput: BaseAgreementNextVersionsUpdateFieldInput;
	BaseAgreementOptions: BaseAgreementOptions;
	BaseAgreementProcessedDeviceRecordsAggregateInput: BaseAgreementProcessedDeviceRecordsAggregateInput;
	BaseAgreementProcessedDeviceRecordsConnectFieldInput: BaseAgreementProcessedDeviceRecordsConnectFieldInput;
	BaseAgreementProcessedDeviceRecordsConnection: BaseAgreementProcessedDeviceRecordsConnection;
	BaseAgreementProcessedDeviceRecordsConnectionSort: BaseAgreementProcessedDeviceRecordsConnectionSort;
	BaseAgreementProcessedDeviceRecordsConnectionWhere: BaseAgreementProcessedDeviceRecordsConnectionWhere;
	BaseAgreementProcessedDeviceRecordsCreateFieldInput: BaseAgreementProcessedDeviceRecordsCreateFieldInput;
	BaseAgreementProcessedDeviceRecordsDeleteFieldInput: BaseAgreementProcessedDeviceRecordsDeleteFieldInput;
	BaseAgreementProcessedDeviceRecordsDisconnectFieldInput: BaseAgreementProcessedDeviceRecordsDisconnectFieldInput;
	BaseAgreementProcessedDeviceRecordsFieldInput: BaseAgreementProcessedDeviceRecordsFieldInput;
	BaseAgreementProcessedDeviceRecordsRelationship: BaseAgreementProcessedDeviceRecordsRelationship;
	BaseAgreementProcessedDeviceRecordsUpdateConnectionInput: BaseAgreementProcessedDeviceRecordsUpdateConnectionInput;
	BaseAgreementProcessedDeviceRecordsUpdateFieldInput: BaseAgreementProcessedDeviceRecordsUpdateFieldInput;
	BaseAgreementPushedByAggregateInput: BaseAgreementPushedByAggregateInput;
	BaseAgreementPushedByConnectFieldInput: BaseAgreementPushedByConnectFieldInput;
	BaseAgreementPushedByConnection: BaseAgreementPushedByConnection;
	BaseAgreementPushedByConnectionSort: BaseAgreementPushedByConnectionSort;
	BaseAgreementPushedByConnectionWhere: BaseAgreementPushedByConnectionWhere;
	BaseAgreementPushedByCreateFieldInput: BaseAgreementPushedByCreateFieldInput;
	BaseAgreementPushedByDeleteFieldInput: BaseAgreementPushedByDeleteFieldInput;
	BaseAgreementPushedByDisconnectFieldInput: BaseAgreementPushedByDisconnectFieldInput;
	BaseAgreementPushedByFieldInput: BaseAgreementPushedByFieldInput;
	BaseAgreementPushedByNodeAggregationWhereInput: BaseAgreementPushedByNodeAggregationWhereInput;
	BaseAgreementPushedByRelationship: BaseAgreementPushedByRelationship;
	BaseAgreementPushedByUpdateConnectionInput: BaseAgreementPushedByUpdateConnectionInput;
	BaseAgreementPushedByUpdateFieldInput: BaseAgreementPushedByUpdateFieldInput;
	BaseAgreementScenariosAggregateInput: BaseAgreementScenariosAggregateInput;
	BaseAgreementScenariosConnectFieldInput: BaseAgreementScenariosConnectFieldInput;
	BaseAgreementScenariosConnection: BaseAgreementScenariosConnection;
	BaseAgreementScenariosConnectionSort: BaseAgreementScenariosConnectionSort;
	BaseAgreementScenariosConnectionWhere: BaseAgreementScenariosConnectionWhere;
	BaseAgreementScenariosCreateFieldInput: BaseAgreementScenariosCreateFieldInput;
	BaseAgreementScenariosDeleteFieldInput: BaseAgreementScenariosDeleteFieldInput;
	BaseAgreementScenariosDisconnectFieldInput: BaseAgreementScenariosDisconnectFieldInput;
	BaseAgreementScenariosFieldInput: BaseAgreementScenariosFieldInput;
	BaseAgreementScenariosNodeAggregationWhereInput: BaseAgreementScenariosNodeAggregationWhereInput;
	BaseAgreementScenariosRelationship: BaseAgreementScenariosRelationship;
	BaseAgreementScenariosUpdateConnectionInput: BaseAgreementScenariosUpdateConnectionInput;
	BaseAgreementScenariosUpdateFieldInput: BaseAgreementScenariosUpdateFieldInput;
	BaseAgreementSort: BaseAgreementSort;
	BaseAgreementStatusTransitionsAggregateInput: BaseAgreementStatusTransitionsAggregateInput;
	BaseAgreementStatusTransitionsConnectFieldInput: BaseAgreementStatusTransitionsConnectFieldInput;
	BaseAgreementStatusTransitionsConnection: BaseAgreementStatusTransitionsConnection;
	BaseAgreementStatusTransitionsConnectionSort: BaseAgreementStatusTransitionsConnectionSort;
	BaseAgreementStatusTransitionsConnectionWhere: BaseAgreementStatusTransitionsConnectionWhere;
	BaseAgreementStatusTransitionsCreateFieldInput: BaseAgreementStatusTransitionsCreateFieldInput;
	BaseAgreementStatusTransitionsDeleteFieldInput: BaseAgreementStatusTransitionsDeleteFieldInput;
	BaseAgreementStatusTransitionsDisconnectFieldInput: BaseAgreementStatusTransitionsDisconnectFieldInput;
	BaseAgreementStatusTransitionsFieldInput: BaseAgreementStatusTransitionsFieldInput;
	BaseAgreementStatusTransitionsNodeAggregationWhereInput: BaseAgreementStatusTransitionsNodeAggregationWhereInput;
	BaseAgreementStatusTransitionsRelationship: BaseAgreementStatusTransitionsRelationship;
	BaseAgreementStatusTransitionsUpdateConnectionInput: BaseAgreementStatusTransitionsUpdateConnectionInput;
	BaseAgreementStatusTransitionsUpdateFieldInput: BaseAgreementStatusTransitionsUpdateFieldInput;
	BaseAgreementTagsAggregateInput: BaseAgreementTagsAggregateInput;
	BaseAgreementTagsConnectFieldInput: BaseAgreementTagsConnectFieldInput;
	BaseAgreementTagsConnection: BaseAgreementTagsConnection;
	BaseAgreementTagsConnectionSort: BaseAgreementTagsConnectionSort;
	BaseAgreementTagsConnectionWhere: BaseAgreementTagsConnectionWhere;
	BaseAgreementTagsCreateFieldInput: BaseAgreementTagsCreateFieldInput;
	BaseAgreementTagsDeleteFieldInput: BaseAgreementTagsDeleteFieldInput;
	BaseAgreementTagsDisconnectFieldInput: BaseAgreementTagsDisconnectFieldInput;
	BaseAgreementTagsFieldInput: BaseAgreementTagsFieldInput;
	BaseAgreementTagsNodeAggregationWhereInput: BaseAgreementTagsNodeAggregationWhereInput;
	BaseAgreementTagsRelationship: BaseAgreementTagsRelationship;
	BaseAgreementTagsUpdateConnectionInput: BaseAgreementTagsUpdateConnectionInput;
	BaseAgreementTagsUpdateFieldInput: BaseAgreementTagsUpdateFieldInput;
	BaseAgreementTreatmentPriceRelationship: ResolversParentTypes["BaseAgreementTreatmentPricesRelationship"];
	BaseAgreementTreatmentPriceRelationshipCreateInput: BaseAgreementTreatmentPriceRelationshipCreateInput;
	BaseAgreementTreatmentPriceRelationshipSort: BaseAgreementTreatmentPriceRelationshipSort;
	BaseAgreementTreatmentPriceRelationshipUpdateInput: BaseAgreementTreatmentPriceRelationshipUpdateInput;
	BaseAgreementTreatmentPriceRelationshipWhere: BaseAgreementTreatmentPriceRelationshipWhere;
	BaseAgreementTreatmentPricesAggregateInput: BaseAgreementTreatmentPricesAggregateInput;
	BaseAgreementTreatmentPricesConnectFieldInput: BaseAgreementTreatmentPricesConnectFieldInput;
	BaseAgreementTreatmentPricesConnection: BaseAgreementTreatmentPricesConnection;
	BaseAgreementTreatmentPricesConnectionSort: BaseAgreementTreatmentPricesConnectionSort;
	BaseAgreementTreatmentPricesConnectionWhere: BaseAgreementTreatmentPricesConnectionWhere;
	BaseAgreementTreatmentPricesCreateFieldInput: BaseAgreementTreatmentPricesCreateFieldInput;
	BaseAgreementTreatmentPricesDeleteFieldInput: BaseAgreementTreatmentPricesDeleteFieldInput;
	BaseAgreementTreatmentPricesDisconnectFieldInput: BaseAgreementTreatmentPricesDisconnectFieldInput;
	BaseAgreementTreatmentPricesEdgeAggregationWhereInput: BaseAgreementTreatmentPricesEdgeAggregationWhereInput;
	BaseAgreementTreatmentPricesFieldInput: BaseAgreementTreatmentPricesFieldInput;
	BaseAgreementTreatmentPricesNodeAggregationWhereInput: BaseAgreementTreatmentPricesNodeAggregationWhereInput;
	BaseAgreementTreatmentPricesRelationship: BaseAgreementTreatmentPricesRelationship;
	BaseAgreementTreatmentPricesUpdateConnectionInput: BaseAgreementTreatmentPricesUpdateConnectionInput;
	BaseAgreementTreatmentPricesUpdateFieldInput: BaseAgreementTreatmentPricesUpdateFieldInput;
	BaseAgreementUpdateInput: BaseAgreementUpdateInput;
	BaseAgreementUserContextsAggregateInput: BaseAgreementUserContextsAggregateInput;
	BaseAgreementUserContextsConnectFieldInput: BaseAgreementUserContextsConnectFieldInput;
	BaseAgreementUserContextsConnection: BaseAgreementUserContextsConnection;
	BaseAgreementUserContextsConnectionSort: BaseAgreementUserContextsConnectionSort;
	BaseAgreementUserContextsConnectionWhere: BaseAgreementUserContextsConnectionWhere;
	BaseAgreementUserContextsCreateFieldInput: BaseAgreementUserContextsCreateFieldInput;
	BaseAgreementUserContextsDeleteFieldInput: BaseAgreementUserContextsDeleteFieldInput;
	BaseAgreementUserContextsDisconnectFieldInput: BaseAgreementUserContextsDisconnectFieldInput;
	BaseAgreementUserContextsEdgeAggregationWhereInput: BaseAgreementUserContextsEdgeAggregationWhereInput;
	BaseAgreementUserContextsFieldInput: BaseAgreementUserContextsFieldInput;
	BaseAgreementUserContextsNodeAggregationWhereInput: BaseAgreementUserContextsNodeAggregationWhereInput;
	BaseAgreementUserContextsRelationship: BaseAgreementUserContextsRelationship;
	BaseAgreementUserContextsUpdateConnectionInput: BaseAgreementUserContextsUpdateConnectionInput;
	BaseAgreementUserContextsUpdateFieldInput: BaseAgreementUserContextsUpdateFieldInput;
	BaseAgreementUserRoleRelationship: ResolversParentTypes["BaseAgreementUserRolesRelationship"];
	BaseAgreementUserRoleRelationshipCreateInput: BaseAgreementUserRoleRelationshipCreateInput;
	BaseAgreementUserRoleRelationshipSort: BaseAgreementUserRoleRelationshipSort;
	BaseAgreementUserRoleRelationshipUpdateInput: BaseAgreementUserRoleRelationshipUpdateInput;
	BaseAgreementUserRoleRelationshipWhere: BaseAgreementUserRoleRelationshipWhere;
	BaseAgreementUserRolesAggregateInput: BaseAgreementUserRolesAggregateInput;
	BaseAgreementUserRolesConnectFieldInput: BaseAgreementUserRolesConnectFieldInput;
	BaseAgreementUserRolesConnection: BaseAgreementUserRolesConnection;
	BaseAgreementUserRolesConnectionSort: BaseAgreementUserRolesConnectionSort;
	BaseAgreementUserRolesConnectionWhere: BaseAgreementUserRolesConnectionWhere;
	BaseAgreementUserRolesCreateFieldInput: BaseAgreementUserRolesCreateFieldInput;
	BaseAgreementUserRolesDeleteFieldInput: BaseAgreementUserRolesDeleteFieldInput;
	BaseAgreementUserRolesDisconnectFieldInput: BaseAgreementUserRolesDisconnectFieldInput;
	BaseAgreementUserRolesFieldInput: BaseAgreementUserRolesFieldInput;
	BaseAgreementUserRolesNodeAggregationWhereInput: BaseAgreementUserRolesNodeAggregationWhereInput;
	BaseAgreementUserRolesRelationship: BaseAgreementUserRolesRelationship;
	BaseAgreementUserRolesUpdateConnectionInput: BaseAgreementUserRolesUpdateConnectionInput;
	BaseAgreementUserRolesUpdateFieldInput: BaseAgreementUserRolesUpdateFieldInput;
	BaseAgreementWhere: BaseAgreementWhere;
	Boolean: Scalars["Boolean"];
	Brand: Brand;
	BrandAggregateSelection: BrandAggregateSelection;
	BrandConnectInput: BrandConnectInput;
	BrandConnectWhere: BrandConnectWhere;
	BrandCreateInput: BrandCreateInput;
	BrandDeleteInput: BrandDeleteInput;
	BrandDisconnectInput: BrandDisconnectInput;
	BrandOptions: BrandOptions;
	BrandPreparationsAggregateInput: BrandPreparationsAggregateInput;
	BrandPreparationsConnectFieldInput: BrandPreparationsConnectFieldInput;
	BrandPreparationsConnection: BrandPreparationsConnection;
	BrandPreparationsConnectionSort: BrandPreparationsConnectionSort;
	BrandPreparationsConnectionWhere: BrandPreparationsConnectionWhere;
	BrandPreparationsCreateFieldInput: BrandPreparationsCreateFieldInput;
	BrandPreparationsDeleteFieldInput: BrandPreparationsDeleteFieldInput;
	BrandPreparationsDisconnectFieldInput: BrandPreparationsDisconnectFieldInput;
	BrandPreparationsFieldInput: BrandPreparationsFieldInput;
	BrandPreparationsNodeAggregationWhereInput: BrandPreparationsNodeAggregationWhereInput;
	BrandPreparationsRelationship: BrandPreparationsRelationship;
	BrandPreparationsUpdateConnectionInput: BrandPreparationsUpdateConnectionInput;
	BrandPreparationsUpdateFieldInput: BrandPreparationsUpdateFieldInput;
	BrandSort: BrandSort;
	BrandUpdateInput: BrandUpdateInput;
	BrandWhere: BrandWhere;
	CAOBAgreementReport: CaobAgreementReport;
	CAOBAgreementReportAggregateSelection: CaobAgreementReportAggregateSelection;
	CAOBAgreementReportOptions: CaobAgreementReportOptions;
	CAOBAgreementReportSort: CaobAgreementReportSort;
	CAOBAgreementReportWhere: CaobAgreementReportWhere;
	CAOBRefundSummaryRow: CaobRefundSummaryRow;
	CAOBRefundSummaryRowAggregateSelection: CaobRefundSummaryRowAggregateSelection;
	CAOBRefundSummaryRowOptions: CaobRefundSummaryRowOptions;
	CAOBRefundSummaryRowSort: CaobRefundSummaryRowSort;
	CAOBRefundSummaryRowWhere: CaobRefundSummaryRowWhere;
	CaobAgreementRenewalInput: CaobAgreementRenewalInput;
	Case: Case;
	CaseAggregateSelection: CaseAggregateSelection;
	CaseBaseAgreementAggregateInput: CaseBaseAgreementAggregateInput;
	CaseBaseAgreementConnectFieldInput: CaseBaseAgreementConnectFieldInput;
	CaseBaseAgreementConnection: CaseBaseAgreementConnection;
	CaseBaseAgreementConnectionSort: CaseBaseAgreementConnectionSort;
	CaseBaseAgreementConnectionWhere: CaseBaseAgreementConnectionWhere;
	CaseBaseAgreementCreateFieldInput: CaseBaseAgreementCreateFieldInput;
	CaseBaseAgreementDeleteFieldInput: CaseBaseAgreementDeleteFieldInput;
	CaseBaseAgreementDisconnectFieldInput: CaseBaseAgreementDisconnectFieldInput;
	CaseBaseAgreementFieldInput: CaseBaseAgreementFieldInput;
	CaseBaseAgreementNodeAggregationWhereInput: CaseBaseAgreementNodeAggregationWhereInput;
	CaseBaseAgreementRelationship: CaseBaseAgreementRelationship;
	CaseBaseAgreementUpdateConnectionInput: CaseBaseAgreementUpdateConnectionInput;
	CaseBaseAgreementUpdateFieldInput: CaseBaseAgreementUpdateFieldInput;
	CaseClaimsAggregateInput: CaseClaimsAggregateInput;
	CaseClaimsConnectFieldInput: CaseClaimsConnectFieldInput;
	CaseClaimsConnection: CaseClaimsConnection;
	CaseClaimsConnectionSort: CaseClaimsConnectionSort;
	CaseClaimsConnectionWhere: CaseClaimsConnectionWhere;
	CaseClaimsCreateFieldInput: CaseClaimsCreateFieldInput;
	CaseClaimsDeleteFieldInput: CaseClaimsDeleteFieldInput;
	CaseClaimsDisconnectFieldInput: CaseClaimsDisconnectFieldInput;
	CaseClaimsFieldInput: CaseClaimsFieldInput;
	CaseClaimsNodeAggregationWhereInput: CaseClaimsNodeAggregationWhereInput;
	CaseClaimsRelationship: CaseClaimsRelationship;
	CaseClaimsUpdateConnectionInput: CaseClaimsUpdateConnectionInput;
	CaseClaimsUpdateFieldInput: CaseClaimsUpdateFieldInput;
	CaseCohortAggregateInput: CaseCohortAggregateInput;
	CaseCohortConnectFieldInput: CaseCohortConnectFieldInput;
	CaseCohortConnection: CaseCohortConnection;
	CaseCohortConnectionSort: CaseCohortConnectionSort;
	CaseCohortConnectionWhere: CaseCohortConnectionWhere;
	CaseCohortCreateFieldInput: CaseCohortCreateFieldInput;
	CaseCohortDeleteFieldInput: CaseCohortDeleteFieldInput;
	CaseCohortDisconnectFieldInput: CaseCohortDisconnectFieldInput;
	CaseCohortFieldInput: CaseCohortFieldInput;
	CaseCohortRelationship: CaseCohortRelationship;
	CaseCohortUpdateConnectionInput: CaseCohortUpdateConnectionInput;
	CaseCohortUpdateFieldInput: CaseCohortUpdateFieldInput;
	CaseConnectInput: CaseConnectInput;
	CaseConnectWhere: CaseConnectWhere;
	CaseCoverageRequestsAggregateInput: CaseCoverageRequestsAggregateInput;
	CaseCoverageRequestsConnectFieldInput: CaseCoverageRequestsConnectFieldInput;
	CaseCoverageRequestsConnection: CaseCoverageRequestsConnection;
	CaseCoverageRequestsConnectionSort: CaseCoverageRequestsConnectionSort;
	CaseCoverageRequestsConnectionWhere: CaseCoverageRequestsConnectionWhere;
	CaseCoverageRequestsCreateFieldInput: CaseCoverageRequestsCreateFieldInput;
	CaseCoverageRequestsDeleteFieldInput: CaseCoverageRequestsDeleteFieldInput;
	CaseCoverageRequestsDisconnectFieldInput: CaseCoverageRequestsDisconnectFieldInput;
	CaseCoverageRequestsFieldInput: CaseCoverageRequestsFieldInput;
	CaseCoverageRequestsNodeAggregationWhereInput: CaseCoverageRequestsNodeAggregationWhereInput;
	CaseCoverageRequestsRelationship: CaseCoverageRequestsRelationship;
	CaseCoverageRequestsUpdateConnectionInput: CaseCoverageRequestsUpdateConnectionInput;
	CaseCoverageRequestsUpdateFieldInput: CaseCoverageRequestsUpdateFieldInput;
	CaseCreateInput: CaseCreateInput;
	CaseDeleteInput: CaseDeleteInput;
	CaseDisconnectInput: CaseDisconnectInput;
	CaseDiseaseAggregateInput: CaseDiseaseAggregateInput;
	CaseDiseaseConnectFieldInput: CaseDiseaseConnectFieldInput;
	CaseDiseaseConnection: CaseDiseaseConnection;
	CaseDiseaseConnectionSort: CaseDiseaseConnectionSort;
	CaseDiseaseConnectionWhere: CaseDiseaseConnectionWhere;
	CaseDiseaseCreateFieldInput: CaseDiseaseCreateFieldInput;
	CaseDiseaseDeleteFieldInput: CaseDiseaseDeleteFieldInput;
	CaseDiseaseDisconnectFieldInput: CaseDiseaseDisconnectFieldInput;
	CaseDiseaseFieldInput: CaseDiseaseFieldInput;
	CaseDiseaseNodeAggregationWhereInput: CaseDiseaseNodeAggregationWhereInput;
	CaseDiseaseRelationship: CaseDiseaseRelationship;
	CaseDiseaseUpdateConnectionInput: CaseDiseaseUpdateConnectionInput;
	CaseDiseaseUpdateFieldInput: CaseDiseaseUpdateFieldInput;
	CaseFinancialDataPointsAggregateInput: CaseFinancialDataPointsAggregateInput;
	CaseFinancialDataPointsConnectFieldInput: CaseFinancialDataPointsConnectFieldInput;
	CaseFinancialDataPointsConnection: CaseFinancialDataPointsConnection;
	CaseFinancialDataPointsConnectionSort: CaseFinancialDataPointsConnectionSort;
	CaseFinancialDataPointsConnectionWhere: CaseFinancialDataPointsConnectionWhere;
	CaseFinancialDataPointsCreateFieldInput: CaseFinancialDataPointsCreateFieldInput;
	CaseFinancialDataPointsDeleteFieldInput: CaseFinancialDataPointsDeleteFieldInput;
	CaseFinancialDataPointsDisconnectFieldInput: CaseFinancialDataPointsDisconnectFieldInput;
	CaseFinancialDataPointsFieldInput: CaseFinancialDataPointsFieldInput;
	CaseFinancialDataPointsNodeAggregationWhereInput: CaseFinancialDataPointsNodeAggregationWhereInput;
	CaseFinancialDataPointsRelationship: CaseFinancialDataPointsRelationship;
	CaseFinancialDataPointsUpdateConnectionInput: CaseFinancialDataPointsUpdateConnectionInput;
	CaseFinancialDataPointsUpdateFieldInput: CaseFinancialDataPointsUpdateFieldInput;
	CaseFlexEntitiesAggregateInput: CaseFlexEntitiesAggregateInput;
	CaseFlexEntitiesConnectFieldInput: CaseFlexEntitiesConnectFieldInput;
	CaseFlexEntitiesConnection: CaseFlexEntitiesConnection;
	CaseFlexEntitiesConnectionSort: CaseFlexEntitiesConnectionSort;
	CaseFlexEntitiesConnectionWhere: CaseFlexEntitiesConnectionWhere;
	CaseFlexEntitiesCreateFieldInput: CaseFlexEntitiesCreateFieldInput;
	CaseFlexEntitiesDeleteFieldInput: CaseFlexEntitiesDeleteFieldInput;
	CaseFlexEntitiesDisconnectFieldInput: CaseFlexEntitiesDisconnectFieldInput;
	CaseFlexEntitiesFieldInput: CaseFlexEntitiesFieldInput;
	CaseFlexEntitiesNodeAggregationWhereInput: CaseFlexEntitiesNodeAggregationWhereInput;
	CaseFlexEntitiesRelationship: CaseFlexEntitiesRelationship;
	CaseFlexEntitiesUpdateConnectionInput: CaseFlexEntitiesUpdateConnectionInput;
	CaseFlexEntitiesUpdateFieldInput: CaseFlexEntitiesUpdateFieldInput;
	CaseFlexFinancialDataPointsAggregateInput: CaseFlexFinancialDataPointsAggregateInput;
	CaseFlexFinancialDataPointsConnectFieldInput: CaseFlexFinancialDataPointsConnectFieldInput;
	CaseFlexFinancialDataPointsConnection: CaseFlexFinancialDataPointsConnection;
	CaseFlexFinancialDataPointsConnectionSort: CaseFlexFinancialDataPointsConnectionSort;
	CaseFlexFinancialDataPointsConnectionWhere: CaseFlexFinancialDataPointsConnectionWhere;
	CaseFlexFinancialDataPointsCreateFieldInput: CaseFlexFinancialDataPointsCreateFieldInput;
	CaseFlexFinancialDataPointsDeleteFieldInput: CaseFlexFinancialDataPointsDeleteFieldInput;
	CaseFlexFinancialDataPointsDisconnectFieldInput: CaseFlexFinancialDataPointsDisconnectFieldInput;
	CaseFlexFinancialDataPointsFieldInput: CaseFlexFinancialDataPointsFieldInput;
	CaseFlexFinancialDataPointsNodeAggregationWhereInput: CaseFlexFinancialDataPointsNodeAggregationWhereInput;
	CaseFlexFinancialDataPointsRelationship: CaseFlexFinancialDataPointsRelationship;
	CaseFlexFinancialDataPointsUpdateConnectionInput: CaseFlexFinancialDataPointsUpdateConnectionInput;
	CaseFlexFinancialDataPointsUpdateFieldInput: CaseFlexFinancialDataPointsUpdateFieldInput;
	CaseIndicationAggregateInput: CaseIndicationAggregateInput;
	CaseIndicationConnectFieldInput: CaseIndicationConnectFieldInput;
	CaseIndicationConnection: CaseIndicationConnection;
	CaseIndicationConnectionSort: CaseIndicationConnectionSort;
	CaseIndicationConnectionWhere: CaseIndicationConnectionWhere;
	CaseIndicationCreateFieldInput: CaseIndicationCreateFieldInput;
	CaseIndicationDeleteFieldInput: CaseIndicationDeleteFieldInput;
	CaseIndicationDisconnectFieldInput: CaseIndicationDisconnectFieldInput;
	CaseIndicationFieldInput: CaseIndicationFieldInput;
	CaseIndicationNodeAggregationWhereInput: CaseIndicationNodeAggregationWhereInput;
	CaseIndicationRelationship: CaseIndicationRelationship;
	CaseIndicationUpdateConnectionInput: CaseIndicationUpdateConnectionInput;
	CaseIndicationUpdateFieldInput: CaseIndicationUpdateFieldInput;
	CaseLegalEntityAggregateInput: CaseLegalEntityAggregateInput;
	CaseLegalEntityConnectFieldInput: CaseLegalEntityConnectFieldInput;
	CaseLegalEntityConnection: CaseLegalEntityConnection;
	CaseLegalEntityConnectionSort: CaseLegalEntityConnectionSort;
	CaseLegalEntityConnectionWhere: CaseLegalEntityConnectionWhere;
	CaseLegalEntityCreateFieldInput: CaseLegalEntityCreateFieldInput;
	CaseLegalEntityDeleteFieldInput: CaseLegalEntityDeleteFieldInput;
	CaseLegalEntityDisconnectFieldInput: CaseLegalEntityDisconnectFieldInput;
	CaseLegalEntityFieldInput: CaseLegalEntityFieldInput;
	CaseLegalEntityNodeAggregationWhereInput: CaseLegalEntityNodeAggregationWhereInput;
	CaseLegalEntityRelationship: CaseLegalEntityRelationship;
	CaseLegalEntityUpdateConnectionInput: CaseLegalEntityUpdateConnectionInput;
	CaseLegalEntityUpdateFieldInput: CaseLegalEntityUpdateFieldInput;
	CaseOptions: CaseOptions;
	CasePatientAggregateInput: CasePatientAggregateInput;
	CasePatientConnectFieldInput: CasePatientConnectFieldInput;
	CasePatientConnection: CasePatientConnection;
	CasePatientConnectionSort: CasePatientConnectionSort;
	CasePatientConnectionWhere: CasePatientConnectionWhere;
	CasePatientCreateFieldInput: CasePatientCreateFieldInput;
	CasePatientDeleteFieldInput: CasePatientDeleteFieldInput;
	CasePatientDisconnectFieldInput: CasePatientDisconnectFieldInput;
	CasePatientFieldInput: CasePatientFieldInput;
	CasePatientNodeAggregationWhereInput: CasePatientNodeAggregationWhereInput;
	CasePatientRelationship: CasePatientRelationship;
	CasePatientUpdateConnectionInput: CasePatientUpdateConnectionInput;
	CasePatientUpdateFieldInput: CasePatientUpdateFieldInput;
	CasePreparationsAggregateInput: CasePreparationsAggregateInput;
	CasePreparationsConnectFieldInput: CasePreparationsConnectFieldInput;
	CasePreparationsConnection: CasePreparationsConnection;
	CasePreparationsConnectionSort: CasePreparationsConnectionSort;
	CasePreparationsConnectionWhere: CasePreparationsConnectionWhere;
	CasePreparationsCreateFieldInput: CasePreparationsCreateFieldInput;
	CasePreparationsDeleteFieldInput: CasePreparationsDeleteFieldInput;
	CasePreparationsDisconnectFieldInput: CasePreparationsDisconnectFieldInput;
	CasePreparationsFieldInput: CasePreparationsFieldInput;
	CasePreparationsNodeAggregationWhereInput: CasePreparationsNodeAggregationWhereInput;
	CasePreparationsRelationship: CasePreparationsRelationship;
	CasePreparationsUpdateConnectionInput: CasePreparationsUpdateConnectionInput;
	CasePreparationsUpdateFieldInput: CasePreparationsUpdateFieldInput;
	CasePrimaryInterventionAggregateInput: CasePrimaryInterventionAggregateInput;
	CasePrimaryInterventionConnectFieldInput: CasePrimaryInterventionConnectFieldInput;
	CasePrimaryInterventionConnection: CasePrimaryInterventionConnection;
	CasePrimaryInterventionConnectionSort: CasePrimaryInterventionConnectionSort;
	CasePrimaryInterventionConnectionWhere: CasePrimaryInterventionConnectionWhere;
	CasePrimaryInterventionCreateFieldInput: CasePrimaryInterventionCreateFieldInput;
	CasePrimaryInterventionDeleteFieldInput: CasePrimaryInterventionDeleteFieldInput;
	CasePrimaryInterventionDisconnectFieldInput: CasePrimaryInterventionDisconnectFieldInput;
	CasePrimaryInterventionFieldInput: CasePrimaryInterventionFieldInput;
	CasePrimaryInterventionNodeAggregationWhereInput: CasePrimaryInterventionNodeAggregationWhereInput;
	CasePrimaryInterventionRelationship: CasePrimaryInterventionRelationship;
	CasePrimaryInterventionUpdateConnectionInput: CasePrimaryInterventionUpdateConnectionInput;
	CasePrimaryInterventionUpdateFieldInput: CasePrimaryInterventionUpdateFieldInput;
	CaseRecordBatchesAggregateInput: CaseRecordBatchesAggregateInput;
	CaseRecordBatchesConnectFieldInput: CaseRecordBatchesConnectFieldInput;
	CaseRecordBatchesConnection: CaseRecordBatchesConnection;
	CaseRecordBatchesConnectionSort: CaseRecordBatchesConnectionSort;
	CaseRecordBatchesConnectionWhere: CaseRecordBatchesConnectionWhere;
	CaseRecordBatchesCreateFieldInput: CaseRecordBatchesCreateFieldInput;
	CaseRecordBatchesDeleteFieldInput: CaseRecordBatchesDeleteFieldInput;
	CaseRecordBatchesDisconnectFieldInput: CaseRecordBatchesDisconnectFieldInput;
	CaseRecordBatchesFieldInput: CaseRecordBatchesFieldInput;
	CaseRecordBatchesNodeAggregationWhereInput: CaseRecordBatchesNodeAggregationWhereInput;
	CaseRecordBatchesRelationship: CaseRecordBatchesRelationship;
	CaseRecordBatchesUpdateConnectionInput: CaseRecordBatchesUpdateConnectionInput;
	CaseRecordBatchesUpdateFieldInput: CaseRecordBatchesUpdateFieldInput;
	CaseReportDataPoint: CaseReportDataPoint;
	CaseReportDataPointAggregateSelection: CaseReportDataPointAggregateSelection;
	CaseReportDataPointOptions: CaseReportDataPointOptions;
	CaseReportDataPointSort: CaseReportDataPointSort;
	CaseReportDataPointWhere: CaseReportDataPointWhere;
	CaseSort: CaseSort;
	CaseStobContractAggregateInput: CaseStobContractAggregateInput;
	CaseStobContractConnectFieldInput: CaseStobContractConnectFieldInput;
	CaseStobContractConnection: CaseStobContractConnection;
	CaseStobContractConnectionSort: CaseStobContractConnectionSort;
	CaseStobContractConnectionWhere: CaseStobContractConnectionWhere;
	CaseStobContractCreateFieldInput: CaseStobContractCreateFieldInput;
	CaseStobContractDeleteFieldInput: CaseStobContractDeleteFieldInput;
	CaseStobContractDisconnectFieldInput: CaseStobContractDisconnectFieldInput;
	CaseStobContractFieldInput: CaseStobContractFieldInput;
	CaseStobContractNodeAggregationWhereInput: CaseStobContractNodeAggregationWhereInput;
	CaseStobContractRelationship: CaseStobContractRelationship;
	CaseStobContractUpdateConnectionInput: CaseStobContractUpdateConnectionInput;
	CaseStobContractUpdateFieldInput: CaseStobContractUpdateFieldInput;
	CaseTaskRelationship: ResolversParentTypes["TaskCaseRelationship"];
	CaseTaskRelationshipCreateInput: CaseTaskRelationshipCreateInput;
	CaseTaskRelationshipSort: CaseTaskRelationshipSort;
	CaseTaskRelationshipUpdateInput: CaseTaskRelationshipUpdateInput;
	CaseTaskRelationshipWhere: CaseTaskRelationshipWhere;
	CaseUpdateInput: CaseUpdateInput;
	CaseWhere: CaseWhere;
	Claim: Claim;
	ClaimAggregateSelection: ClaimAggregateSelection;
	ClaimCasesAggregateInput: ClaimCasesAggregateInput;
	ClaimCasesConnectFieldInput: ClaimCasesConnectFieldInput;
	ClaimCasesConnection: ClaimCasesConnection;
	ClaimCasesConnectionSort: ClaimCasesConnectionSort;
	ClaimCasesConnectionWhere: ClaimCasesConnectionWhere;
	ClaimCasesCreateFieldInput: ClaimCasesCreateFieldInput;
	ClaimCasesDeleteFieldInput: ClaimCasesDeleteFieldInput;
	ClaimCasesDisconnectFieldInput: ClaimCasesDisconnectFieldInput;
	ClaimCasesFieldInput: ClaimCasesFieldInput;
	ClaimCasesNodeAggregationWhereInput: ClaimCasesNodeAggregationWhereInput;
	ClaimCasesRelationship: ClaimCasesRelationship;
	ClaimCasesUpdateConnectionInput: ClaimCasesUpdateConnectionInput;
	ClaimCasesUpdateFieldInput: ClaimCasesUpdateFieldInput;
	ClaimConnectInput: ClaimConnectInput;
	ClaimConnectWhere: ClaimConnectWhere;
	ClaimCreateInput: ClaimCreateInput;
	ClaimDeleteInput: ClaimDeleteInput;
	ClaimDisconnectInput: ClaimDisconnectInput;
	ClaimEnrolledIntoCaseRelationship: ResolversParentTypes["ClaimCasesRelationship"];
	ClaimEnrolledIntoCaseRelationshipCreateInput: ClaimEnrolledIntoCaseRelationshipCreateInput;
	ClaimEnrolledIntoCaseRelationshipSort: ClaimEnrolledIntoCaseRelationshipSort;
	ClaimEnrolledIntoCaseRelationshipUpdateInput: ClaimEnrolledIntoCaseRelationshipUpdateInput;
	ClaimEnrolledIntoCaseRelationshipWhere: ClaimEnrolledIntoCaseRelationshipWhere;
	ClaimFinancialDataPointsAggregateInput: ClaimFinancialDataPointsAggregateInput;
	ClaimFinancialDataPointsConnectFieldInput: ClaimFinancialDataPointsConnectFieldInput;
	ClaimFinancialDataPointsConnection: ClaimFinancialDataPointsConnection;
	ClaimFinancialDataPointsConnectionSort: ClaimFinancialDataPointsConnectionSort;
	ClaimFinancialDataPointsConnectionWhere: ClaimFinancialDataPointsConnectionWhere;
	ClaimFinancialDataPointsCreateFieldInput: ClaimFinancialDataPointsCreateFieldInput;
	ClaimFinancialDataPointsDeleteFieldInput: ClaimFinancialDataPointsDeleteFieldInput;
	ClaimFinancialDataPointsDisconnectFieldInput: ClaimFinancialDataPointsDisconnectFieldInput;
	ClaimFinancialDataPointsFieldInput: ClaimFinancialDataPointsFieldInput;
	ClaimFinancialDataPointsNodeAggregationWhereInput: ClaimFinancialDataPointsNodeAggregationWhereInput;
	ClaimFinancialDataPointsRelationship: ClaimFinancialDataPointsRelationship;
	ClaimFinancialDataPointsUpdateConnectionInput: ClaimFinancialDataPointsUpdateConnectionInput;
	ClaimFinancialDataPointsUpdateFieldInput: ClaimFinancialDataPointsUpdateFieldInput;
	ClaimIncludesAggregateInput: ClaimIncludesAggregateInput;
	ClaimIncludesConnectFieldInput: ClaimIncludesConnectFieldInput;
	ClaimIncludesConnection: ClaimIncludesConnection;
	ClaimIncludesConnectionSort: ClaimIncludesConnectionSort;
	ClaimIncludesConnectionWhere: ClaimIncludesConnectionWhere;
	ClaimIncludesCreateFieldInput: ClaimIncludesCreateFieldInput;
	ClaimIncludesDeleteFieldInput: ClaimIncludesDeleteFieldInput;
	ClaimIncludesDisconnectFieldInput: ClaimIncludesDisconnectFieldInput;
	ClaimIncludesFieldInput: ClaimIncludesFieldInput;
	ClaimIncludesNodeAggregationWhereInput: ClaimIncludesNodeAggregationWhereInput;
	ClaimIncludesRelationship: ClaimIncludesRelationship;
	ClaimIncludesUpdateConnectionInput: ClaimIncludesUpdateConnectionInput;
	ClaimIncludesUpdateFieldInput: ClaimIncludesUpdateFieldInput;
	ClaimOptions: ClaimOptions;
	ClaimReceivedFromPatientAggregateInput: ClaimReceivedFromPatientAggregateInput;
	ClaimReceivedFromPatientConnectFieldInput: ClaimReceivedFromPatientConnectFieldInput;
	ClaimReceivedFromPatientConnection: ClaimReceivedFromPatientConnection;
	ClaimReceivedFromPatientConnectionSort: ClaimReceivedFromPatientConnectionSort;
	ClaimReceivedFromPatientConnectionWhere: ClaimReceivedFromPatientConnectionWhere;
	ClaimReceivedFromPatientCreateFieldInput: ClaimReceivedFromPatientCreateFieldInput;
	ClaimReceivedFromPatientDeleteFieldInput: ClaimReceivedFromPatientDeleteFieldInput;
	ClaimReceivedFromPatientDisconnectFieldInput: ClaimReceivedFromPatientDisconnectFieldInput;
	ClaimReceivedFromPatientFieldInput: ClaimReceivedFromPatientFieldInput;
	ClaimReceivedFromPatientNodeAggregationWhereInput: ClaimReceivedFromPatientNodeAggregationWhereInput;
	ClaimReceivedFromPatientRelationship: ClaimReceivedFromPatientRelationship;
	ClaimReceivedFromPatientUpdateConnectionInput: ClaimReceivedFromPatientUpdateConnectionInput;
	ClaimReceivedFromPatientUpdateFieldInput: ClaimReceivedFromPatientUpdateFieldInput;
	ClaimRecordAggregateInput: ClaimRecordAggregateInput;
	ClaimRecordConnectFieldInput: ClaimRecordConnectFieldInput;
	ClaimRecordConnection: ClaimRecordConnection;
	ClaimRecordConnectionSort: ClaimRecordConnectionSort;
	ClaimRecordConnectionWhere: ClaimRecordConnectionWhere;
	ClaimRecordCreateFieldInput: ClaimRecordCreateFieldInput;
	ClaimRecordDeleteFieldInput: ClaimRecordDeleteFieldInput;
	ClaimRecordDisconnectFieldInput: ClaimRecordDisconnectFieldInput;
	ClaimRecordFieldInput: ClaimRecordFieldInput;
	ClaimRecordNodeAggregationWhereInput: ClaimRecordNodeAggregationWhereInput;
	ClaimRecordRelationship: ClaimRecordRelationship;
	ClaimRecordUpdateConnectionInput: ClaimRecordUpdateConnectionInput;
	ClaimRecordUpdateFieldInput: ClaimRecordUpdateFieldInput;
	ClaimSort: ClaimSort;
	ClaimUpdateInput: ClaimUpdateInput;
	ClaimWhere: ClaimWhere;
	ContinuousBenefit: ContinuousBenefit;
	ContinuousBenefitAdverseEventsAggregateInput: ContinuousBenefitAdverseEventsAggregateInput;
	ContinuousBenefitAdverseEventsConnectFieldInput: ContinuousBenefitAdverseEventsConnectFieldInput;
	ContinuousBenefitAdverseEventsConnection: ContinuousBenefitAdverseEventsConnection;
	ContinuousBenefitAdverseEventsConnectionSort: ContinuousBenefitAdverseEventsConnectionSort;
	ContinuousBenefitAdverseEventsConnectionWhere: ContinuousBenefitAdverseEventsConnectionWhere;
	ContinuousBenefitAdverseEventsCreateFieldInput: ContinuousBenefitAdverseEventsCreateFieldInput;
	ContinuousBenefitAdverseEventsDeleteFieldInput: ContinuousBenefitAdverseEventsDeleteFieldInput;
	ContinuousBenefitAdverseEventsDisconnectFieldInput: ContinuousBenefitAdverseEventsDisconnectFieldInput;
	ContinuousBenefitAdverseEventsFieldInput: ContinuousBenefitAdverseEventsFieldInput;
	ContinuousBenefitAdverseEventsNodeAggregationWhereInput: ContinuousBenefitAdverseEventsNodeAggregationWhereInput;
	ContinuousBenefitAdverseEventsRelationship: ContinuousBenefitAdverseEventsRelationship;
	ContinuousBenefitAdverseEventsUpdateConnectionInput: ContinuousBenefitAdverseEventsUpdateConnectionInput;
	ContinuousBenefitAdverseEventsUpdateFieldInput: ContinuousBenefitAdverseEventsUpdateFieldInput;
	ContinuousBenefitAggregateSelection: ContinuousBenefitAggregateSelection;
	ContinuousBenefitConnectInput: ContinuousBenefitConnectInput;
	ContinuousBenefitConnectWhere: ContinuousBenefitConnectWhere;
	ContinuousBenefitCoverageRequestAggregateInput: ContinuousBenefitCoverageRequestAggregateInput;
	ContinuousBenefitCoverageRequestConnectFieldInput: ContinuousBenefitCoverageRequestConnectFieldInput;
	ContinuousBenefitCoverageRequestConnection: ContinuousBenefitCoverageRequestConnection;
	ContinuousBenefitCoverageRequestConnectionSort: ContinuousBenefitCoverageRequestConnectionSort;
	ContinuousBenefitCoverageRequestConnectionWhere: ContinuousBenefitCoverageRequestConnectionWhere;
	ContinuousBenefitCoverageRequestCreateFieldInput: ContinuousBenefitCoverageRequestCreateFieldInput;
	ContinuousBenefitCoverageRequestDeleteFieldInput: ContinuousBenefitCoverageRequestDeleteFieldInput;
	ContinuousBenefitCoverageRequestDisconnectFieldInput: ContinuousBenefitCoverageRequestDisconnectFieldInput;
	ContinuousBenefitCoverageRequestFieldInput: ContinuousBenefitCoverageRequestFieldInput;
	ContinuousBenefitCoverageRequestNodeAggregationWhereInput: ContinuousBenefitCoverageRequestNodeAggregationWhereInput;
	ContinuousBenefitCoverageRequestRelationship: ContinuousBenefitCoverageRequestRelationship;
	ContinuousBenefitCoverageRequestUpdateConnectionInput: ContinuousBenefitCoverageRequestUpdateConnectionInput;
	ContinuousBenefitCoverageRequestUpdateFieldInput: ContinuousBenefitCoverageRequestUpdateFieldInput;
	ContinuousBenefitCreateInput: ContinuousBenefitCreateInput;
	ContinuousBenefitDeleteInput: ContinuousBenefitDeleteInput;
	ContinuousBenefitDisconnectInput: ContinuousBenefitDisconnectInput;
	ContinuousBenefitFinancialDataPointsAggregateInput: ContinuousBenefitFinancialDataPointsAggregateInput;
	ContinuousBenefitFinancialDataPointsConnectFieldInput: ContinuousBenefitFinancialDataPointsConnectFieldInput;
	ContinuousBenefitFinancialDataPointsConnection: ContinuousBenefitFinancialDataPointsConnection;
	ContinuousBenefitFinancialDataPointsConnectionSort: ContinuousBenefitFinancialDataPointsConnectionSort;
	ContinuousBenefitFinancialDataPointsConnectionWhere: ContinuousBenefitFinancialDataPointsConnectionWhere;
	ContinuousBenefitFinancialDataPointsCreateFieldInput: ContinuousBenefitFinancialDataPointsCreateFieldInput;
	ContinuousBenefitFinancialDataPointsDeleteFieldInput: ContinuousBenefitFinancialDataPointsDeleteFieldInput;
	ContinuousBenefitFinancialDataPointsDisconnectFieldInput: ContinuousBenefitFinancialDataPointsDisconnectFieldInput;
	ContinuousBenefitFinancialDataPointsFieldInput: ContinuousBenefitFinancialDataPointsFieldInput;
	ContinuousBenefitFinancialDataPointsNodeAggregationWhereInput: ContinuousBenefitFinancialDataPointsNodeAggregationWhereInput;
	ContinuousBenefitFinancialDataPointsRelationship: ContinuousBenefitFinancialDataPointsRelationship;
	ContinuousBenefitFinancialDataPointsUpdateConnectionInput: ContinuousBenefitFinancialDataPointsUpdateConnectionInput;
	ContinuousBenefitFinancialDataPointsUpdateFieldInput: ContinuousBenefitFinancialDataPointsUpdateFieldInput;
	ContinuousBenefitFormAggregateInput: ContinuousBenefitFormAggregateInput;
	ContinuousBenefitFormConnectFieldInput: ContinuousBenefitFormConnectFieldInput;
	ContinuousBenefitFormConnection: ContinuousBenefitFormConnection;
	ContinuousBenefitFormConnectionSort: ContinuousBenefitFormConnectionSort;
	ContinuousBenefitFormConnectionWhere: ContinuousBenefitFormConnectionWhere;
	ContinuousBenefitFormCreateFieldInput: ContinuousBenefitFormCreateFieldInput;
	ContinuousBenefitFormDeleteFieldInput: ContinuousBenefitFormDeleteFieldInput;
	ContinuousBenefitFormDisconnectFieldInput: ContinuousBenefitFormDisconnectFieldInput;
	ContinuousBenefitFormFieldInput: ContinuousBenefitFormFieldInput;
	ContinuousBenefitFormNodeAggregationWhereInput: ContinuousBenefitFormNodeAggregationWhereInput;
	ContinuousBenefitFormRelationship: ContinuousBenefitFormRelationship;
	ContinuousBenefitFormUpdateConnectionInput: ContinuousBenefitFormUpdateConnectionInput;
	ContinuousBenefitFormUpdateFieldInput: ContinuousBenefitFormUpdateFieldInput;
	ContinuousBenefitInitialResponseAggregateInput: ContinuousBenefitInitialResponseAggregateInput;
	ContinuousBenefitInitialResponseConnectFieldInput: ContinuousBenefitInitialResponseConnectFieldInput;
	ContinuousBenefitInitialResponseConnection: ContinuousBenefitInitialResponseConnection;
	ContinuousBenefitInitialResponseConnectionSort: ContinuousBenefitInitialResponseConnectionSort;
	ContinuousBenefitInitialResponseConnectionWhere: ContinuousBenefitInitialResponseConnectionWhere;
	ContinuousBenefitInitialResponseCreateFieldInput: ContinuousBenefitInitialResponseCreateFieldInput;
	ContinuousBenefitInitialResponseDeleteFieldInput: ContinuousBenefitInitialResponseDeleteFieldInput;
	ContinuousBenefitInitialResponseDisconnectFieldInput: ContinuousBenefitInitialResponseDisconnectFieldInput;
	ContinuousBenefitInitialResponseFieldInput: ContinuousBenefitInitialResponseFieldInput;
	ContinuousBenefitInitialResponseNodeAggregationWhereInput: ContinuousBenefitInitialResponseNodeAggregationWhereInput;
	ContinuousBenefitInitialResponseRelationship: ContinuousBenefitInitialResponseRelationship;
	ContinuousBenefitInitialResponseUpdateConnectionInput: ContinuousBenefitInitialResponseUpdateConnectionInput;
	ContinuousBenefitInitialResponseUpdateFieldInput: ContinuousBenefitInitialResponseUpdateFieldInput;
	ContinuousBenefitInput: ContinuousBenefitInput;
	ContinuousBenefitOptions: ContinuousBenefitOptions;
	ContinuousBenefitPrescribedTreatmentsAggregateInput: ContinuousBenefitPrescribedTreatmentsAggregateInput;
	ContinuousBenefitPrescribedTreatmentsConnectFieldInput: ContinuousBenefitPrescribedTreatmentsConnectFieldInput;
	ContinuousBenefitPrescribedTreatmentsConnection: ContinuousBenefitPrescribedTreatmentsConnection;
	ContinuousBenefitPrescribedTreatmentsConnectionSort: ContinuousBenefitPrescribedTreatmentsConnectionSort;
	ContinuousBenefitPrescribedTreatmentsConnectionWhere: ContinuousBenefitPrescribedTreatmentsConnectionWhere;
	ContinuousBenefitPrescribedTreatmentsCreateFieldInput: ContinuousBenefitPrescribedTreatmentsCreateFieldInput;
	ContinuousBenefitPrescribedTreatmentsDeleteFieldInput: ContinuousBenefitPrescribedTreatmentsDeleteFieldInput;
	ContinuousBenefitPrescribedTreatmentsDisconnectFieldInput: ContinuousBenefitPrescribedTreatmentsDisconnectFieldInput;
	ContinuousBenefitPrescribedTreatmentsEdgeAggregationWhereInput: ContinuousBenefitPrescribedTreatmentsEdgeAggregationWhereInput;
	ContinuousBenefitPrescribedTreatmentsFieldInput: ContinuousBenefitPrescribedTreatmentsFieldInput;
	ContinuousBenefitPrescribedTreatmentsNodeAggregationWhereInput: ContinuousBenefitPrescribedTreatmentsNodeAggregationWhereInput;
	ContinuousBenefitPrescribedTreatmentsRelationship: ContinuousBenefitPrescribedTreatmentsRelationship;
	ContinuousBenefitPrescribedTreatmentsUpdateConnectionInput: ContinuousBenefitPrescribedTreatmentsUpdateConnectionInput;
	ContinuousBenefitPrescribedTreatmentsUpdateFieldInput: ContinuousBenefitPrescribedTreatmentsUpdateFieldInput;
	ContinuousBenefitRecordsAggregateInput: ContinuousBenefitRecordsAggregateInput;
	ContinuousBenefitRecordsConnectFieldInput: ContinuousBenefitRecordsConnectFieldInput;
	ContinuousBenefitRecordsConnection: ContinuousBenefitRecordsConnection;
	ContinuousBenefitRecordsConnectionSort: ContinuousBenefitRecordsConnectionSort;
	ContinuousBenefitRecordsConnectionWhere: ContinuousBenefitRecordsConnectionWhere;
	ContinuousBenefitRecordsCreateFieldInput: ContinuousBenefitRecordsCreateFieldInput;
	ContinuousBenefitRecordsDeleteFieldInput: ContinuousBenefitRecordsDeleteFieldInput;
	ContinuousBenefitRecordsDisconnectFieldInput: ContinuousBenefitRecordsDisconnectFieldInput;
	ContinuousBenefitRecordsFieldInput: ContinuousBenefitRecordsFieldInput;
	ContinuousBenefitRecordsNodeAggregationWhereInput: ContinuousBenefitRecordsNodeAggregationWhereInput;
	ContinuousBenefitRecordsRelationship: ContinuousBenefitRecordsRelationship;
	ContinuousBenefitRecordsUpdateConnectionInput: ContinuousBenefitRecordsUpdateConnectionInput;
	ContinuousBenefitRecordsUpdateFieldInput: ContinuousBenefitRecordsUpdateFieldInput;
	ContinuousBenefitSort: ContinuousBenefitSort;
	ContinuousBenefitTreatingPhysicianAggregateInput: ContinuousBenefitTreatingPhysicianAggregateInput;
	ContinuousBenefitTreatingPhysicianConnectFieldInput: ContinuousBenefitTreatingPhysicianConnectFieldInput;
	ContinuousBenefitTreatingPhysicianConnection: ContinuousBenefitTreatingPhysicianConnection;
	ContinuousBenefitTreatingPhysicianConnectionSort: ContinuousBenefitTreatingPhysicianConnectionSort;
	ContinuousBenefitTreatingPhysicianConnectionWhere: ContinuousBenefitTreatingPhysicianConnectionWhere;
	ContinuousBenefitTreatingPhysicianCreateFieldInput: ContinuousBenefitTreatingPhysicianCreateFieldInput;
	ContinuousBenefitTreatingPhysicianDeleteFieldInput: ContinuousBenefitTreatingPhysicianDeleteFieldInput;
	ContinuousBenefitTreatingPhysicianDisconnectFieldInput: ContinuousBenefitTreatingPhysicianDisconnectFieldInput;
	ContinuousBenefitTreatingPhysicianFieldInput: ContinuousBenefitTreatingPhysicianFieldInput;
	ContinuousBenefitTreatingPhysicianNodeAggregationWhereInput: ContinuousBenefitTreatingPhysicianNodeAggregationWhereInput;
	ContinuousBenefitTreatingPhysicianRelationship: ContinuousBenefitTreatingPhysicianRelationship;
	ContinuousBenefitTreatingPhysicianUpdateConnectionInput: ContinuousBenefitTreatingPhysicianUpdateConnectionInput;
	ContinuousBenefitTreatingPhysicianUpdateFieldInput: ContinuousBenefitTreatingPhysicianUpdateFieldInput;
	ContinuousBenefitUpdateInput: ContinuousBenefitUpdateInput;
	ContinuousBenefitWhere: ContinuousBenefitWhere;
	ContractNotification: ContractNotification;
	ContractNotificationAggregateSelection: ContractNotificationAggregateSelection;
	ContractNotificationConnectInput: ContractNotificationConnectInput;
	ContractNotificationConnectWhere: ContractNotificationConnectWhere;
	ContractNotificationCreateInput: ContractNotificationCreateInput;
	ContractNotificationDeleteInput: ContractNotificationDeleteInput;
	ContractNotificationDisconnectInput: ContractNotificationDisconnectInput;
	ContractNotificationInput: ContractNotificationInput;
	ContractNotificationOptions: ContractNotificationOptions;
	ContractNotificationSort: ContractNotificationSort;
	ContractNotificationTriggersAggregateInput: ContractNotificationTriggersAggregateInput;
	ContractNotificationTriggersConnectFieldInput: ContractNotificationTriggersConnectFieldInput;
	ContractNotificationTriggersConnection: ContractNotificationTriggersConnection;
	ContractNotificationTriggersConnectionSort: ContractNotificationTriggersConnectionSort;
	ContractNotificationTriggersConnectionWhere: ContractNotificationTriggersConnectionWhere;
	ContractNotificationTriggersCreateFieldInput: ContractNotificationTriggersCreateFieldInput;
	ContractNotificationTriggersDeleteFieldInput: ContractNotificationTriggersDeleteFieldInput;
	ContractNotificationTriggersDisconnectFieldInput: ContractNotificationTriggersDisconnectFieldInput;
	ContractNotificationTriggersFieldInput: ContractNotificationTriggersFieldInput;
	ContractNotificationTriggersNodeAggregationWhereInput: ContractNotificationTriggersNodeAggregationWhereInput;
	ContractNotificationTriggersRelationship: ContractNotificationTriggersRelationship;
	ContractNotificationTriggersUpdateConnectionInput: ContractNotificationTriggersUpdateConnectionInput;
	ContractNotificationTriggersUpdateFieldInput: ContractNotificationTriggersUpdateFieldInput;
	ContractNotificationUpdateInput: ContractNotificationUpdateInput;
	ContractNotificationWhere: ContractNotificationWhere;
	ContractNotificationsInput: ContractNotificationsInput;
	ContractWorkflow: ContractWorkflow;
	ContractWorkflowAggregateSelection: ContractWorkflowAggregateSelection;
	ContractWorkflowConnectInput: ContractWorkflowConnectInput;
	ContractWorkflowConnectWhere: ContractWorkflowConnectWhere;
	ContractWorkflowCreateInput: ContractWorkflowCreateInput;
	ContractWorkflowDeleteInput: ContractWorkflowDeleteInput;
	ContractWorkflowDisconnectInput: ContractWorkflowDisconnectInput;
	ContractWorkflowInput: ContractWorkflowInput;
	ContractWorkflowOptions: ContractWorkflowOptions;
	ContractWorkflowOrganizationAggregateInput: ContractWorkflowOrganizationAggregateInput;
	ContractWorkflowOrganizationConnectFieldInput: ContractWorkflowOrganizationConnectFieldInput;
	ContractWorkflowOrganizationConnection: ContractWorkflowOrganizationConnection;
	ContractWorkflowOrganizationConnectionSort: ContractWorkflowOrganizationConnectionSort;
	ContractWorkflowOrganizationConnectionWhere: ContractWorkflowOrganizationConnectionWhere;
	ContractWorkflowOrganizationCreateFieldInput: ContractWorkflowOrganizationCreateFieldInput;
	ContractWorkflowOrganizationDeleteFieldInput: ContractWorkflowOrganizationDeleteFieldInput;
	ContractWorkflowOrganizationDisconnectFieldInput: ContractWorkflowOrganizationDisconnectFieldInput;
	ContractWorkflowOrganizationFieldInput: ContractWorkflowOrganizationFieldInput;
	ContractWorkflowOrganizationNodeAggregationWhereInput: ContractWorkflowOrganizationNodeAggregationWhereInput;
	ContractWorkflowOrganizationRelationship: ContractWorkflowOrganizationRelationship;
	ContractWorkflowOrganizationUpdateConnectionInput: ContractWorkflowOrganizationUpdateConnectionInput;
	ContractWorkflowOrganizationUpdateFieldInput: ContractWorkflowOrganizationUpdateFieldInput;
	ContractWorkflowSort: ContractWorkflowSort;
	ContractWorkflowStep: ContractWorkflowStep;
	ContractWorkflowStepAggregateSelection: ContractWorkflowStepAggregateSelection;
	ContractWorkflowStepConnectInput: ContractWorkflowStepConnectInput;
	ContractWorkflowStepConnectWhere: ContractWorkflowStepConnectWhere;
	ContractWorkflowStepCreateInput: ContractWorkflowStepCreateInput;
	ContractWorkflowStepDeleteInput: ContractWorkflowStepDeleteInput;
	ContractWorkflowStepDisconnectInput: ContractWorkflowStepDisconnectInput;
	ContractWorkflowStepInput: ContractWorkflowStepInput;
	ContractWorkflowStepOptions: ContractWorkflowStepOptions;
	ContractWorkflowStepResponsiblePersonAggregateInput: ContractWorkflowStepResponsiblePersonAggregateInput;
	ContractWorkflowStepResponsiblePersonConnectFieldInput: ContractWorkflowStepResponsiblePersonConnectFieldInput;
	ContractWorkflowStepResponsiblePersonConnection: ContractWorkflowStepResponsiblePersonConnection;
	ContractWorkflowStepResponsiblePersonConnectionSort: ContractWorkflowStepResponsiblePersonConnectionSort;
	ContractWorkflowStepResponsiblePersonConnectionWhere: ContractWorkflowStepResponsiblePersonConnectionWhere;
	ContractWorkflowStepResponsiblePersonCreateFieldInput: ContractWorkflowStepResponsiblePersonCreateFieldInput;
	ContractWorkflowStepResponsiblePersonDeleteFieldInput: ContractWorkflowStepResponsiblePersonDeleteFieldInput;
	ContractWorkflowStepResponsiblePersonDisconnectFieldInput: ContractWorkflowStepResponsiblePersonDisconnectFieldInput;
	ContractWorkflowStepResponsiblePersonFieldInput: ContractWorkflowStepResponsiblePersonFieldInput;
	ContractWorkflowStepResponsiblePersonNodeAggregationWhereInput: ContractWorkflowStepResponsiblePersonNodeAggregationWhereInput;
	ContractWorkflowStepResponsiblePersonRelationship: ContractWorkflowStepResponsiblePersonRelationship;
	ContractWorkflowStepResponsiblePersonUpdateConnectionInput: ContractWorkflowStepResponsiblePersonUpdateConnectionInput;
	ContractWorkflowStepResponsiblePersonUpdateFieldInput: ContractWorkflowStepResponsiblePersonUpdateFieldInput;
	ContractWorkflowStepSort: ContractWorkflowStepSort;
	ContractWorkflowStepUpdateInput: ContractWorkflowStepUpdateInput;
	ContractWorkflowStepWhere: ContractWorkflowStepWhere;
	ContractWorkflowStepsAggregateInput: ContractWorkflowStepsAggregateInput;
	ContractWorkflowStepsConnectFieldInput: ContractWorkflowStepsConnectFieldInput;
	ContractWorkflowStepsConnection: ContractWorkflowStepsConnection;
	ContractWorkflowStepsConnectionSort: ContractWorkflowStepsConnectionSort;
	ContractWorkflowStepsConnectionWhere: ContractWorkflowStepsConnectionWhere;
	ContractWorkflowStepsCreateFieldInput: ContractWorkflowStepsCreateFieldInput;
	ContractWorkflowStepsDeleteFieldInput: ContractWorkflowStepsDeleteFieldInput;
	ContractWorkflowStepsDisconnectFieldInput: ContractWorkflowStepsDisconnectFieldInput;
	ContractWorkflowStepsFieldInput: ContractWorkflowStepsFieldInput;
	ContractWorkflowStepsNodeAggregationWhereInput: ContractWorkflowStepsNodeAggregationWhereInput;
	ContractWorkflowStepsRelationship: ContractWorkflowStepsRelationship;
	ContractWorkflowStepsUpdateConnectionInput: ContractWorkflowStepsUpdateConnectionInput;
	ContractWorkflowStepsUpdateFieldInput: ContractWorkflowStepsUpdateFieldInput;
	ContractWorkflowUpdateInput: ContractWorkflowUpdateInput;
	ContractWorkflowWhere: ContractWorkflowWhere;
	CounterpartyRoleRelationship: ResolversParentTypes["AgreementCounterpartyRolesRelationship"];
	CounterpartyRoleRelationshipCreateInput: CounterpartyRoleRelationshipCreateInput;
	CounterpartyRoleRelationshipSort: CounterpartyRoleRelationshipSort;
	CounterpartyRoleRelationshipUpdateInput: CounterpartyRoleRelationshipUpdateInput;
	CounterpartyRoleRelationshipWhere: CounterpartyRoleRelationshipWhere;
	CoverageRequest: CoverageRequest;
	CoverageRequestAggregateSelection: CoverageRequestAggregateSelection;
	CoverageRequestCaseAggregateInput: CoverageRequestCaseAggregateInput;
	CoverageRequestCaseConnectFieldInput: CoverageRequestCaseConnectFieldInput;
	CoverageRequestCaseConnection: CoverageRequestCaseConnection;
	CoverageRequestCaseConnectionSort: CoverageRequestCaseConnectionSort;
	CoverageRequestCaseConnectionWhere: CoverageRequestCaseConnectionWhere;
	CoverageRequestCaseCreateFieldInput: CoverageRequestCaseCreateFieldInput;
	CoverageRequestCaseDeleteFieldInput: CoverageRequestCaseDeleteFieldInput;
	CoverageRequestCaseDisconnectFieldInput: CoverageRequestCaseDisconnectFieldInput;
	CoverageRequestCaseFieldInput: CoverageRequestCaseFieldInput;
	CoverageRequestCaseNodeAggregationWhereInput: CoverageRequestCaseNodeAggregationWhereInput;
	CoverageRequestCaseRelationship: CoverageRequestCaseRelationship;
	CoverageRequestCaseUpdateConnectionInput: CoverageRequestCaseUpdateConnectionInput;
	CoverageRequestCaseUpdateFieldInput: CoverageRequestCaseUpdateFieldInput;
	CoverageRequestConnectInput: CoverageRequestConnectInput;
	CoverageRequestConnectWhere: CoverageRequestConnectWhere;
	CoverageRequestContinuousBenefitsWithDraftsAggregateInput: CoverageRequestContinuousBenefitsWithDraftsAggregateInput;
	CoverageRequestContinuousBenefitsWithDraftsConnectFieldInput: CoverageRequestContinuousBenefitsWithDraftsConnectFieldInput;
	CoverageRequestContinuousBenefitsWithDraftsConnection: CoverageRequestContinuousBenefitsWithDraftsConnection;
	CoverageRequestContinuousBenefitsWithDraftsConnectionSort: CoverageRequestContinuousBenefitsWithDraftsConnectionSort;
	CoverageRequestContinuousBenefitsWithDraftsConnectionWhere: CoverageRequestContinuousBenefitsWithDraftsConnectionWhere;
	CoverageRequestContinuousBenefitsWithDraftsCreateFieldInput: CoverageRequestContinuousBenefitsWithDraftsCreateFieldInput;
	CoverageRequestContinuousBenefitsWithDraftsDeleteFieldInput: CoverageRequestContinuousBenefitsWithDraftsDeleteFieldInput;
	CoverageRequestContinuousBenefitsWithDraftsDisconnectFieldInput: CoverageRequestContinuousBenefitsWithDraftsDisconnectFieldInput;
	CoverageRequestContinuousBenefitsWithDraftsFieldInput: CoverageRequestContinuousBenefitsWithDraftsFieldInput;
	CoverageRequestContinuousBenefitsWithDraftsNodeAggregationWhereInput: CoverageRequestContinuousBenefitsWithDraftsNodeAggregationWhereInput;
	CoverageRequestContinuousBenefitsWithDraftsRelationship: CoverageRequestContinuousBenefitsWithDraftsRelationship;
	CoverageRequestContinuousBenefitsWithDraftsUpdateConnectionInput: CoverageRequestContinuousBenefitsWithDraftsUpdateConnectionInput;
	CoverageRequestContinuousBenefitsWithDraftsUpdateFieldInput: CoverageRequestContinuousBenefitsWithDraftsUpdateFieldInput;
	CoverageRequestCreateInput: CoverageRequestCreateInput;
	CoverageRequestCreatedByAggregateInput: CoverageRequestCreatedByAggregateInput;
	CoverageRequestCreatedByConnectFieldInput: CoverageRequestCreatedByConnectFieldInput;
	CoverageRequestCreatedByConnection: CoverageRequestCreatedByConnection;
	CoverageRequestCreatedByConnectionSort: CoverageRequestCreatedByConnectionSort;
	CoverageRequestCreatedByConnectionWhere: CoverageRequestCreatedByConnectionWhere;
	CoverageRequestCreatedByCreateFieldInput: CoverageRequestCreatedByCreateFieldInput;
	CoverageRequestCreatedByDeleteFieldInput: CoverageRequestCreatedByDeleteFieldInput;
	CoverageRequestCreatedByDisconnectFieldInput: CoverageRequestCreatedByDisconnectFieldInput;
	CoverageRequestCreatedByFieldInput: CoverageRequestCreatedByFieldInput;
	CoverageRequestCreatedByNodeAggregationWhereInput: CoverageRequestCreatedByNodeAggregationWhereInput;
	CoverageRequestCreatedByRelationship: CoverageRequestCreatedByRelationship;
	CoverageRequestCreatedByUpdateConnectionInput: CoverageRequestCreatedByUpdateConnectionInput;
	CoverageRequestCreatedByUpdateFieldInput: CoverageRequestCreatedByUpdateFieldInput;
	CoverageRequestDeleteInput: CoverageRequestDeleteInput;
	CoverageRequestDisconnectInput: CoverageRequestDisconnectInput;
	CoverageRequestDiscontinuationNoteAggregateInput: CoverageRequestDiscontinuationNoteAggregateInput;
	CoverageRequestDiscontinuationNoteConnectFieldInput: CoverageRequestDiscontinuationNoteConnectFieldInput;
	CoverageRequestDiscontinuationNoteConnection: CoverageRequestDiscontinuationNoteConnection;
	CoverageRequestDiscontinuationNoteConnectionSort: CoverageRequestDiscontinuationNoteConnectionSort;
	CoverageRequestDiscontinuationNoteConnectionWhere: CoverageRequestDiscontinuationNoteConnectionWhere;
	CoverageRequestDiscontinuationNoteCreateFieldInput: CoverageRequestDiscontinuationNoteCreateFieldInput;
	CoverageRequestDiscontinuationNoteDeleteFieldInput: CoverageRequestDiscontinuationNoteDeleteFieldInput;
	CoverageRequestDiscontinuationNoteDisconnectFieldInput: CoverageRequestDiscontinuationNoteDisconnectFieldInput;
	CoverageRequestDiscontinuationNoteFieldInput: CoverageRequestDiscontinuationNoteFieldInput;
	CoverageRequestDiscontinuationNoteNodeAggregationWhereInput: CoverageRequestDiscontinuationNoteNodeAggregationWhereInput;
	CoverageRequestDiscontinuationNoteRelationship: CoverageRequestDiscontinuationNoteRelationship;
	CoverageRequestDiscontinuationNoteUpdateConnectionInput: CoverageRequestDiscontinuationNoteUpdateConnectionInput;
	CoverageRequestDiscontinuationNoteUpdateFieldInput: CoverageRequestDiscontinuationNoteUpdateFieldInput;
	CoverageRequestDiseaseAggregateInput: CoverageRequestDiseaseAggregateInput;
	CoverageRequestDiseaseConnectFieldInput: CoverageRequestDiseaseConnectFieldInput;
	CoverageRequestDiseaseConnection: CoverageRequestDiseaseConnection;
	CoverageRequestDiseaseConnectionSort: CoverageRequestDiseaseConnectionSort;
	CoverageRequestDiseaseConnectionWhere: CoverageRequestDiseaseConnectionWhere;
	CoverageRequestDiseaseCreateFieldInput: CoverageRequestDiseaseCreateFieldInput;
	CoverageRequestDiseaseDeleteFieldInput: CoverageRequestDiseaseDeleteFieldInput;
	CoverageRequestDiseaseDisconnectFieldInput: CoverageRequestDiseaseDisconnectFieldInput;
	CoverageRequestDiseaseFieldInput: CoverageRequestDiseaseFieldInput;
	CoverageRequestDiseaseNodeAggregationWhereInput: CoverageRequestDiseaseNodeAggregationWhereInput;
	CoverageRequestDiseaseRelationship: CoverageRequestDiseaseRelationship;
	CoverageRequestDiseaseUpdateConnectionInput: CoverageRequestDiseaseUpdateConnectionInput;
	CoverageRequestDiseaseUpdateFieldInput: CoverageRequestDiseaseUpdateFieldInput;
	CoverageRequestFinancialDataPointsAggregateInput: CoverageRequestFinancialDataPointsAggregateInput;
	CoverageRequestFinancialDataPointsConnectFieldInput: CoverageRequestFinancialDataPointsConnectFieldInput;
	CoverageRequestFinancialDataPointsConnection: CoverageRequestFinancialDataPointsConnection;
	CoverageRequestFinancialDataPointsConnectionSort: CoverageRequestFinancialDataPointsConnectionSort;
	CoverageRequestFinancialDataPointsConnectionWhere: CoverageRequestFinancialDataPointsConnectionWhere;
	CoverageRequestFinancialDataPointsCreateFieldInput: CoverageRequestFinancialDataPointsCreateFieldInput;
	CoverageRequestFinancialDataPointsDeleteFieldInput: CoverageRequestFinancialDataPointsDeleteFieldInput;
	CoverageRequestFinancialDataPointsDisconnectFieldInput: CoverageRequestFinancialDataPointsDisconnectFieldInput;
	CoverageRequestFinancialDataPointsFieldInput: CoverageRequestFinancialDataPointsFieldInput;
	CoverageRequestFinancialDataPointsNodeAggregationWhereInput: CoverageRequestFinancialDataPointsNodeAggregationWhereInput;
	CoverageRequestFinancialDataPointsRelationship: CoverageRequestFinancialDataPointsRelationship;
	CoverageRequestFinancialDataPointsUpdateConnectionInput: CoverageRequestFinancialDataPointsUpdateConnectionInput;
	CoverageRequestFinancialDataPointsUpdateFieldInput: CoverageRequestFinancialDataPointsUpdateFieldInput;
	CoverageRequestFormAggregateInput: CoverageRequestFormAggregateInput;
	CoverageRequestFormConnectFieldInput: CoverageRequestFormConnectFieldInput;
	CoverageRequestFormConnection: CoverageRequestFormConnection;
	CoverageRequestFormConnectionSort: CoverageRequestFormConnectionSort;
	CoverageRequestFormConnectionWhere: CoverageRequestFormConnectionWhere;
	CoverageRequestFormCreateFieldInput: CoverageRequestFormCreateFieldInput;
	CoverageRequestFormDeleteFieldInput: CoverageRequestFormDeleteFieldInput;
	CoverageRequestFormDisconnectFieldInput: CoverageRequestFormDisconnectFieldInput;
	CoverageRequestFormFieldInput: CoverageRequestFormFieldInput;
	CoverageRequestFormNodeAggregationWhereInput: CoverageRequestFormNodeAggregationWhereInput;
	CoverageRequestFormRelationship: CoverageRequestFormRelationship;
	CoverageRequestFormUpdateConnectionInput: CoverageRequestFormUpdateConnectionInput;
	CoverageRequestFormUpdateFieldInput: CoverageRequestFormUpdateFieldInput;
	CoverageRequestIndicationAggregateInput: CoverageRequestIndicationAggregateInput;
	CoverageRequestIndicationConnectFieldInput: CoverageRequestIndicationConnectFieldInput;
	CoverageRequestIndicationConnection: CoverageRequestIndicationConnection;
	CoverageRequestIndicationConnectionSort: CoverageRequestIndicationConnectionSort;
	CoverageRequestIndicationConnectionWhere: CoverageRequestIndicationConnectionWhere;
	CoverageRequestIndicationCreateFieldInput: CoverageRequestIndicationCreateFieldInput;
	CoverageRequestIndicationDeleteFieldInput: CoverageRequestIndicationDeleteFieldInput;
	CoverageRequestIndicationDisconnectFieldInput: CoverageRequestIndicationDisconnectFieldInput;
	CoverageRequestIndicationFieldInput: CoverageRequestIndicationFieldInput;
	CoverageRequestIndicationNodeAggregationWhereInput: CoverageRequestIndicationNodeAggregationWhereInput;
	CoverageRequestIndicationRelationship: CoverageRequestIndicationRelationship;
	CoverageRequestIndicationUpdateConnectionInput: CoverageRequestIndicationUpdateConnectionInput;
	CoverageRequestIndicationUpdateFieldInput: CoverageRequestIndicationUpdateFieldInput;
	CoverageRequestInitialResponseAggregateInput: CoverageRequestInitialResponseAggregateInput;
	CoverageRequestInitialResponseConnectFieldInput: CoverageRequestInitialResponseConnectFieldInput;
	CoverageRequestInitialResponseConnection: CoverageRequestInitialResponseConnection;
	CoverageRequestInitialResponseConnectionSort: CoverageRequestInitialResponseConnectionSort;
	CoverageRequestInitialResponseConnectionWhere: CoverageRequestInitialResponseConnectionWhere;
	CoverageRequestInitialResponseCreateFieldInput: CoverageRequestInitialResponseCreateFieldInput;
	CoverageRequestInitialResponseDeleteFieldInput: CoverageRequestInitialResponseDeleteFieldInput;
	CoverageRequestInitialResponseDisconnectFieldInput: CoverageRequestInitialResponseDisconnectFieldInput;
	CoverageRequestInitialResponseFieldInput: CoverageRequestInitialResponseFieldInput;
	CoverageRequestInitialResponseNodeAggregationWhereInput: CoverageRequestInitialResponseNodeAggregationWhereInput;
	CoverageRequestInitialResponseRelationship: CoverageRequestInitialResponseRelationship;
	CoverageRequestInitialResponseUpdateConnectionInput: CoverageRequestInitialResponseUpdateConnectionInput;
	CoverageRequestInitialResponseUpdateFieldInput: CoverageRequestInitialResponseUpdateFieldInput;
	CoverageRequestInput: CoverageRequestInput;
	CoverageRequestLegalEntityAggregateInput: CoverageRequestLegalEntityAggregateInput;
	CoverageRequestLegalEntityConnectFieldInput: CoverageRequestLegalEntityConnectFieldInput;
	CoverageRequestLegalEntityConnection: CoverageRequestLegalEntityConnection;
	CoverageRequestLegalEntityConnectionSort: CoverageRequestLegalEntityConnectionSort;
	CoverageRequestLegalEntityConnectionWhere: CoverageRequestLegalEntityConnectionWhere;
	CoverageRequestLegalEntityCreateFieldInput: CoverageRequestLegalEntityCreateFieldInput;
	CoverageRequestLegalEntityDeleteFieldInput: CoverageRequestLegalEntityDeleteFieldInput;
	CoverageRequestLegalEntityDisconnectFieldInput: CoverageRequestLegalEntityDisconnectFieldInput;
	CoverageRequestLegalEntityFieldInput: CoverageRequestLegalEntityFieldInput;
	CoverageRequestLegalEntityNodeAggregationWhereInput: CoverageRequestLegalEntityNodeAggregationWhereInput;
	CoverageRequestLegalEntityRelationship: CoverageRequestLegalEntityRelationship;
	CoverageRequestLegalEntityUpdateConnectionInput: CoverageRequestLegalEntityUpdateConnectionInput;
	CoverageRequestLegalEntityUpdateFieldInput: CoverageRequestLegalEntityUpdateFieldInput;
	CoverageRequestOptions: CoverageRequestOptions;
	CoverageRequestPatientAggregateInput: CoverageRequestPatientAggregateInput;
	CoverageRequestPatientConnectFieldInput: CoverageRequestPatientConnectFieldInput;
	CoverageRequestPatientConnection: CoverageRequestPatientConnection;
	CoverageRequestPatientConnectionSort: CoverageRequestPatientConnectionSort;
	CoverageRequestPatientConnectionWhere: CoverageRequestPatientConnectionWhere;
	CoverageRequestPatientCreateFieldInput: CoverageRequestPatientCreateFieldInput;
	CoverageRequestPatientDeleteFieldInput: CoverageRequestPatientDeleteFieldInput;
	CoverageRequestPatientDisconnectFieldInput: CoverageRequestPatientDisconnectFieldInput;
	CoverageRequestPatientFieldInput: CoverageRequestPatientFieldInput;
	CoverageRequestPatientFormDataInput: CoverageRequestPatientFormDataInput;
	CoverageRequestPatientNodeAggregationWhereInput: CoverageRequestPatientNodeAggregationWhereInput;
	CoverageRequestPatientRelationship: CoverageRequestPatientRelationship;
	CoverageRequestPatientUpdateConnectionInput: CoverageRequestPatientUpdateConnectionInput;
	CoverageRequestPatientUpdateFieldInput: CoverageRequestPatientUpdateFieldInput;
	CoverageRequestPreparationFormDataInput: CoverageRequestPreparationFormDataInput;
	CoverageRequestPreparationsAggregateInput: CoverageRequestPreparationsAggregateInput;
	CoverageRequestPreparationsConnectFieldInput: CoverageRequestPreparationsConnectFieldInput;
	CoverageRequestPreparationsConnection: CoverageRequestPreparationsConnection;
	CoverageRequestPreparationsConnectionSort: CoverageRequestPreparationsConnectionSort;
	CoverageRequestPreparationsConnectionWhere: CoverageRequestPreparationsConnectionWhere;
	CoverageRequestPreparationsCreateFieldInput: CoverageRequestPreparationsCreateFieldInput;
	CoverageRequestPreparationsDeleteFieldInput: CoverageRequestPreparationsDeleteFieldInput;
	CoverageRequestPreparationsDisconnectFieldInput: CoverageRequestPreparationsDisconnectFieldInput;
	CoverageRequestPreparationsFieldInput: CoverageRequestPreparationsFieldInput;
	CoverageRequestPreparationsNodeAggregationWhereInput: CoverageRequestPreparationsNodeAggregationWhereInput;
	CoverageRequestPreparationsRelationship: CoverageRequestPreparationsRelationship;
	CoverageRequestPreparationsUpdateConnectionInput: CoverageRequestPreparationsUpdateConnectionInput;
	CoverageRequestPreparationsUpdateFieldInput: CoverageRequestPreparationsUpdateFieldInput;
	CoverageRequestSort: CoverageRequestSort;
	CoverageRequestTreatingPhysicianAggregateInput: CoverageRequestTreatingPhysicianAggregateInput;
	CoverageRequestTreatingPhysicianConnectFieldInput: CoverageRequestTreatingPhysicianConnectFieldInput;
	CoverageRequestTreatingPhysicianConnection: CoverageRequestTreatingPhysicianConnection;
	CoverageRequestTreatingPhysicianConnectionSort: CoverageRequestTreatingPhysicianConnectionSort;
	CoverageRequestTreatingPhysicianConnectionWhere: CoverageRequestTreatingPhysicianConnectionWhere;
	CoverageRequestTreatingPhysicianCreateFieldInput: CoverageRequestTreatingPhysicianCreateFieldInput;
	CoverageRequestTreatingPhysicianDeleteFieldInput: CoverageRequestTreatingPhysicianDeleteFieldInput;
	CoverageRequestTreatingPhysicianDisconnectFieldInput: CoverageRequestTreatingPhysicianDisconnectFieldInput;
	CoverageRequestTreatingPhysicianFieldInput: CoverageRequestTreatingPhysicianFieldInput;
	CoverageRequestTreatingPhysicianNodeAggregationWhereInput: CoverageRequestTreatingPhysicianNodeAggregationWhereInput;
	CoverageRequestTreatingPhysicianRelationship: CoverageRequestTreatingPhysicianRelationship;
	CoverageRequestTreatingPhysicianUpdateConnectionInput: CoverageRequestTreatingPhysicianUpdateConnectionInput;
	CoverageRequestTreatingPhysicianUpdateFieldInput: CoverageRequestTreatingPhysicianUpdateFieldInput;
	CoverageRequestUnsortedContinuousBenefitsAggregateInput: CoverageRequestUnsortedContinuousBenefitsAggregateInput;
	CoverageRequestUnsortedContinuousBenefitsConnectFieldInput: CoverageRequestUnsortedContinuousBenefitsConnectFieldInput;
	CoverageRequestUnsortedContinuousBenefitsConnection: CoverageRequestUnsortedContinuousBenefitsConnection;
	CoverageRequestUnsortedContinuousBenefitsConnectionSort: CoverageRequestUnsortedContinuousBenefitsConnectionSort;
	CoverageRequestUnsortedContinuousBenefitsConnectionWhere: CoverageRequestUnsortedContinuousBenefitsConnectionWhere;
	CoverageRequestUnsortedContinuousBenefitsCreateFieldInput: CoverageRequestUnsortedContinuousBenefitsCreateFieldInput;
	CoverageRequestUnsortedContinuousBenefitsDeleteFieldInput: CoverageRequestUnsortedContinuousBenefitsDeleteFieldInput;
	CoverageRequestUnsortedContinuousBenefitsDisconnectFieldInput: CoverageRequestUnsortedContinuousBenefitsDisconnectFieldInput;
	CoverageRequestUnsortedContinuousBenefitsFieldInput: CoverageRequestUnsortedContinuousBenefitsFieldInput;
	CoverageRequestUnsortedContinuousBenefitsNodeAggregationWhereInput: CoverageRequestUnsortedContinuousBenefitsNodeAggregationWhereInput;
	CoverageRequestUnsortedContinuousBenefitsRelationship: CoverageRequestUnsortedContinuousBenefitsRelationship;
	CoverageRequestUnsortedContinuousBenefitsUpdateConnectionInput: CoverageRequestUnsortedContinuousBenefitsUpdateConnectionInput;
	CoverageRequestUnsortedContinuousBenefitsUpdateFieldInput: CoverageRequestUnsortedContinuousBenefitsUpdateFieldInput;
	CoverageRequestUpdateInput: CoverageRequestUpdateInput;
	CoverageRequestWhere: CoverageRequestWhere;
	CreateAdverseEventsOccurenceReportsMutationResponse: CreateAdverseEventsOccurenceReportsMutationResponse;
	CreateInfo: CreateInfo;
	CreateInitialResponseReviewReportsMutationResponse: CreateInitialResponseReviewReportsMutationResponse;
	CreateReasonOfTreatmentDiscontinuationReportsMutationResponse: CreateReasonOfTreatmentDiscontinuationReportsMutationResponse;
	CreateRefundThreadMessageInput: CreateRefundThreadMessageInput;
	CreateUsersMutationResponse: CreateUsersMutationResponse;
	Currency: Currency;
	CurrencyAggregateSelection: CurrencyAggregateSelection;
	CurrencyConnectWhere: CurrencyConnectWhere;
	CurrencyCreateInput: CurrencyCreateInput;
	CurrencyInput: CurrencyInput;
	CurrencyOptions: CurrencyOptions;
	CurrencySort: CurrencySort;
	CurrencyUpdateInput: CurrencyUpdateInput;
	CurrencyWhere: CurrencyWhere;
	DataContainer: DataContainer;
	DataContainerAggregateSelection: DataContainerAggregateSelection;
	DataContainerConnectInput: DataContainerConnectInput;
	DataContainerConnectWhere: DataContainerConnectWhere;
	DataContainerCreateInput: DataContainerCreateInput;
	DataContainerDeleteInput: DataContainerDeleteInput;
	DataContainerDisconnectInput: DataContainerDisconnectInput;
	DataContainerOptions: DataContainerOptions;
	DataContainerProvidersAggregateInput: DataContainerProvidersAggregateInput;
	DataContainerProvidersConnectFieldInput: DataContainerProvidersConnectFieldInput;
	DataContainerProvidersConnection: DataContainerProvidersConnection;
	DataContainerProvidersConnectionSort: DataContainerProvidersConnectionSort;
	DataContainerProvidersConnectionWhere: DataContainerProvidersConnectionWhere;
	DataContainerProvidersCreateFieldInput: DataContainerProvidersCreateFieldInput;
	DataContainerProvidersDeleteFieldInput: DataContainerProvidersDeleteFieldInput;
	DataContainerProvidersDisconnectFieldInput: DataContainerProvidersDisconnectFieldInput;
	DataContainerProvidersFieldInput: DataContainerProvidersFieldInput;
	DataContainerProvidersNodeAggregationWhereInput: DataContainerProvidersNodeAggregationWhereInput;
	DataContainerProvidersRelationship: DataContainerProvidersRelationship;
	DataContainerProvidersUpdateConnectionInput: DataContainerProvidersUpdateConnectionInput;
	DataContainerProvidersUpdateFieldInput: DataContainerProvidersUpdateFieldInput;
	DataContainerSort: DataContainerSort;
	DataContainerUpdateInput: DataContainerUpdateInput;
	DataContainerWhere: DataContainerWhere;
	DataSource: DataSource;
	DataSourceAggregateSelection: DataSourceAggregateSelection;
	DataSourceConnectWhere: DataSourceConnectWhere;
	DataSourceCreateInput: DataSourceCreateInput;
	DataSourceOptions: DataSourceOptions;
	DataSourceSort: DataSourceSort;
	DataSourceUpdateInput: DataSourceUpdateInput;
	DataSourceWhere: DataSourceWhere;
	Date: Scalars["Date"];
	DateTime: Scalars["DateTime"];
	DateTimeAggregateSelection: DateTimeAggregateSelection;
	DefaultUserRoleUpdateInput: DefaultUserRoleUpdateInput;
	DeleteInfo: DeleteInfo;
	DeleteInvoiceInput: DeleteInvoiceInput;
	DeleteRefundThreadMessageInput: DeleteRefundThreadMessageInput;
	DeviceAlternative: DeviceAlternative;
	DeviceAlternativeAggregateSelection: DeviceAlternativeAggregateSelection;
	DeviceAlternativeAlternativesAggregateInput: DeviceAlternativeAlternativesAggregateInput;
	DeviceAlternativeAlternativesConnectFieldInput: DeviceAlternativeAlternativesConnectFieldInput;
	DeviceAlternativeAlternativesConnection: DeviceAlternativeAlternativesConnection;
	DeviceAlternativeAlternativesConnectionSort: DeviceAlternativeAlternativesConnectionSort;
	DeviceAlternativeAlternativesConnectionWhere: DeviceAlternativeAlternativesConnectionWhere;
	DeviceAlternativeAlternativesCreateFieldInput: DeviceAlternativeAlternativesCreateFieldInput;
	DeviceAlternativeAlternativesDeleteFieldInput: DeviceAlternativeAlternativesDeleteFieldInput;
	DeviceAlternativeAlternativesDisconnectFieldInput: DeviceAlternativeAlternativesDisconnectFieldInput;
	DeviceAlternativeAlternativesFieldInput: DeviceAlternativeAlternativesFieldInput;
	DeviceAlternativeAlternativesNodeAggregationWhereInput: DeviceAlternativeAlternativesNodeAggregationWhereInput;
	DeviceAlternativeAlternativesRelationship: DeviceAlternativeAlternativesRelationship;
	DeviceAlternativeAlternativesUpdateConnectionInput: DeviceAlternativeAlternativesUpdateConnectionInput;
	DeviceAlternativeAlternativesUpdateFieldInput: DeviceAlternativeAlternativesUpdateFieldInput;
	DeviceAlternativeConnectInput: DeviceAlternativeConnectInput;
	DeviceAlternativeConnectWhere: DeviceAlternativeConnectWhere;
	DeviceAlternativeCreateInput: DeviceAlternativeCreateInput;
	DeviceAlternativeDeleteInput: DeviceAlternativeDeleteInput;
	DeviceAlternativeDeviceProductAggregateInput: DeviceAlternativeDeviceProductAggregateInput;
	DeviceAlternativeDeviceProductConnectFieldInput: DeviceAlternativeDeviceProductConnectFieldInput;
	DeviceAlternativeDeviceProductConnection: DeviceAlternativeDeviceProductConnection;
	DeviceAlternativeDeviceProductConnectionSort: DeviceAlternativeDeviceProductConnectionSort;
	DeviceAlternativeDeviceProductConnectionWhere: DeviceAlternativeDeviceProductConnectionWhere;
	DeviceAlternativeDeviceProductCreateFieldInput: DeviceAlternativeDeviceProductCreateFieldInput;
	DeviceAlternativeDeviceProductDeleteFieldInput: DeviceAlternativeDeviceProductDeleteFieldInput;
	DeviceAlternativeDeviceProductDisconnectFieldInput: DeviceAlternativeDeviceProductDisconnectFieldInput;
	DeviceAlternativeDeviceProductFieldInput: DeviceAlternativeDeviceProductFieldInput;
	DeviceAlternativeDeviceProductNodeAggregationWhereInput: DeviceAlternativeDeviceProductNodeAggregationWhereInput;
	DeviceAlternativeDeviceProductRelationship: DeviceAlternativeDeviceProductRelationship;
	DeviceAlternativeDeviceProductUpdateConnectionInput: DeviceAlternativeDeviceProductUpdateConnectionInput;
	DeviceAlternativeDeviceProductUpdateFieldInput: DeviceAlternativeDeviceProductUpdateFieldInput;
	DeviceAlternativeDisconnectInput: DeviceAlternativeDisconnectInput;
	DeviceAlternativeOptions: DeviceAlternativeOptions;
	DeviceAlternativeSort: DeviceAlternativeSort;
	DeviceAlternativeUpdateInput: DeviceAlternativeUpdateInput;
	DeviceAlternativeWhere: DeviceAlternativeWhere;
	DeviceFinancialDataPoint: DeviceFinancialDataPoint;
	DeviceFinancialDataPointAggregateSelection: DeviceFinancialDataPointAggregateSelection;
	DeviceFinancialDataPointConnectInput: DeviceFinancialDataPointConnectInput;
	DeviceFinancialDataPointConnectWhere: DeviceFinancialDataPointConnectWhere;
	DeviceFinancialDataPointCreateInput: DeviceFinancialDataPointCreateInput;
	DeviceFinancialDataPointDeleteInput: DeviceFinancialDataPointDeleteInput;
	DeviceFinancialDataPointDisconnectInput: DeviceFinancialDataPointDisconnectInput;
	DeviceFinancialDataPointOptions: DeviceFinancialDataPointOptions;
	DeviceFinancialDataPointProcessedDeviceRecordAggregateInput: DeviceFinancialDataPointProcessedDeviceRecordAggregateInput;
	DeviceFinancialDataPointProcessedDeviceRecordConnectFieldInput: DeviceFinancialDataPointProcessedDeviceRecordConnectFieldInput;
	DeviceFinancialDataPointProcessedDeviceRecordConnection: DeviceFinancialDataPointProcessedDeviceRecordConnection;
	DeviceFinancialDataPointProcessedDeviceRecordConnectionSort: DeviceFinancialDataPointProcessedDeviceRecordConnectionSort;
	DeviceFinancialDataPointProcessedDeviceRecordConnectionWhere: DeviceFinancialDataPointProcessedDeviceRecordConnectionWhere;
	DeviceFinancialDataPointProcessedDeviceRecordCreateFieldInput: DeviceFinancialDataPointProcessedDeviceRecordCreateFieldInput;
	DeviceFinancialDataPointProcessedDeviceRecordDeleteFieldInput: DeviceFinancialDataPointProcessedDeviceRecordDeleteFieldInput;
	DeviceFinancialDataPointProcessedDeviceRecordDisconnectFieldInput: DeviceFinancialDataPointProcessedDeviceRecordDisconnectFieldInput;
	DeviceFinancialDataPointProcessedDeviceRecordFieldInput: DeviceFinancialDataPointProcessedDeviceRecordFieldInput;
	DeviceFinancialDataPointProcessedDeviceRecordRelationship: DeviceFinancialDataPointProcessedDeviceRecordRelationship;
	DeviceFinancialDataPointProcessedDeviceRecordUpdateConnectionInput: DeviceFinancialDataPointProcessedDeviceRecordUpdateConnectionInput;
	DeviceFinancialDataPointProcessedDeviceRecordUpdateFieldInput: DeviceFinancialDataPointProcessedDeviceRecordUpdateFieldInput;
	DeviceFinancialDataPointSort: DeviceFinancialDataPointSort;
	DeviceFinancialDataPointUpdateInput: DeviceFinancialDataPointUpdateInput;
	DeviceFinancialDataPointWhere: DeviceFinancialDataPointWhere;
	DeviceKit: DeviceKit;
	DeviceKitAggregateSelection: DeviceKitAggregateSelection;
	DeviceKitConnectWhere: DeviceKitConnectWhere;
	DeviceKitCreateInput: DeviceKitCreateInput;
	DeviceKitOptions: DeviceKitOptions;
	DeviceKitSort: DeviceKitSort;
	DeviceKitUpdateInput: DeviceKitUpdateInput;
	DeviceKitWhere: DeviceKitWhere;
	DeviceProductCategory: DeviceProductCategory;
	DeviceProductCategoryAggregateSelection: DeviceProductCategoryAggregateSelection;
	DeviceProductCategoryConnectInput: DeviceProductCategoryConnectInput;
	DeviceProductCategoryConnectWhere: DeviceProductCategoryConnectWhere;
	DeviceProductCategoryCreateInput: DeviceProductCategoryCreateInput;
	DeviceProductCategoryDeleteInput: DeviceProductCategoryDeleteInput;
	DeviceProductCategoryDisconnectInput: DeviceProductCategoryDisconnectInput;
	DeviceProductCategoryOptions: DeviceProductCategoryOptions;
	DeviceProductCategoryParentAggregateInput: DeviceProductCategoryParentAggregateInput;
	DeviceProductCategoryParentConnectFieldInput: DeviceProductCategoryParentConnectFieldInput;
	DeviceProductCategoryParentConnection: DeviceProductCategoryParentConnection;
	DeviceProductCategoryParentConnectionSort: DeviceProductCategoryParentConnectionSort;
	DeviceProductCategoryParentConnectionWhere: DeviceProductCategoryParentConnectionWhere;
	DeviceProductCategoryParentCreateFieldInput: DeviceProductCategoryParentCreateFieldInput;
	DeviceProductCategoryParentDeleteFieldInput: DeviceProductCategoryParentDeleteFieldInput;
	DeviceProductCategoryParentDisconnectFieldInput: DeviceProductCategoryParentDisconnectFieldInput;
	DeviceProductCategoryParentFieldInput: DeviceProductCategoryParentFieldInput;
	DeviceProductCategoryParentNodeAggregationWhereInput: DeviceProductCategoryParentNodeAggregationWhereInput;
	DeviceProductCategoryParentRelationship: DeviceProductCategoryParentRelationship;
	DeviceProductCategoryParentUpdateConnectionInput: DeviceProductCategoryParentUpdateConnectionInput;
	DeviceProductCategoryParentUpdateFieldInput: DeviceProductCategoryParentUpdateFieldInput;
	DeviceProductCategorySort: DeviceProductCategorySort;
	DeviceProductCategoryUpdateInput: DeviceProductCategoryUpdateInput;
	DeviceProductCategoryWhere: DeviceProductCategoryWhere;
	DeviceProvider: DeviceProvider;
	DeviceProviderAggregateSelection: DeviceProviderAggregateSelection;
	DeviceProviderConnectWhere: DeviceProviderConnectWhere;
	DeviceProviderCreateInput: DeviceProviderCreateInput;
	DeviceProviderOptions: DeviceProviderOptions;
	DeviceProviderSort: DeviceProviderSort;
	DeviceProviderUpdateInput: DeviceProviderUpdateInput;
	DeviceProviderWhere: DeviceProviderWhere;
	DeviceRecord: DeviceRecord;
	DeviceRecordAggregateSelection: DeviceRecordAggregateSelection;
	DeviceRecordCategoryAggregateInput: DeviceRecordCategoryAggregateInput;
	DeviceRecordCategoryConnectFieldInput: DeviceRecordCategoryConnectFieldInput;
	DeviceRecordCategoryConnection: DeviceRecordCategoryConnection;
	DeviceRecordCategoryConnectionSort: DeviceRecordCategoryConnectionSort;
	DeviceRecordCategoryConnectionWhere: DeviceRecordCategoryConnectionWhere;
	DeviceRecordCategoryCreateFieldInput: DeviceRecordCategoryCreateFieldInput;
	DeviceRecordCategoryDeleteFieldInput: DeviceRecordCategoryDeleteFieldInput;
	DeviceRecordCategoryDisconnectFieldInput: DeviceRecordCategoryDisconnectFieldInput;
	DeviceRecordCategoryFieldInput: DeviceRecordCategoryFieldInput;
	DeviceRecordCategoryNodeAggregationWhereInput: DeviceRecordCategoryNodeAggregationWhereInput;
	DeviceRecordCategoryRelationship: DeviceRecordCategoryRelationship;
	DeviceRecordCategoryUpdateConnectionInput: DeviceRecordCategoryUpdateConnectionInput;
	DeviceRecordCategoryUpdateFieldInput: DeviceRecordCategoryUpdateFieldInput;
	DeviceRecordConnectInput: DeviceRecordConnectInput;
	DeviceRecordConnectWhere: DeviceRecordConnectWhere;
	DeviceRecordCreateInput: DeviceRecordCreateInput;
	DeviceRecordDeleteInput: DeviceRecordDeleteInput;
	DeviceRecordDisconnectInput: DeviceRecordDisconnectInput;
	DeviceRecordOptions: DeviceRecordOptions;
	DeviceRecordProcessedAsAggregateInput: DeviceRecordProcessedAsAggregateInput;
	DeviceRecordProcessedAsConnectFieldInput: DeviceRecordProcessedAsConnectFieldInput;
	DeviceRecordProcessedAsConnection: DeviceRecordProcessedAsConnection;
	DeviceRecordProcessedAsConnectionSort: DeviceRecordProcessedAsConnectionSort;
	DeviceRecordProcessedAsConnectionWhere: DeviceRecordProcessedAsConnectionWhere;
	DeviceRecordProcessedAsCreateFieldInput: DeviceRecordProcessedAsCreateFieldInput;
	DeviceRecordProcessedAsDeleteFieldInput: DeviceRecordProcessedAsDeleteFieldInput;
	DeviceRecordProcessedAsDisconnectFieldInput: DeviceRecordProcessedAsDisconnectFieldInput;
	DeviceRecordProcessedAsFieldInput: DeviceRecordProcessedAsFieldInput;
	DeviceRecordProcessedAsRelationship: DeviceRecordProcessedAsRelationship;
	DeviceRecordProcessedAsUpdateConnectionInput: DeviceRecordProcessedAsUpdateConnectionInput;
	DeviceRecordProcessedAsUpdateFieldInput: DeviceRecordProcessedAsUpdateFieldInput;
	DeviceRecordProviderAggregateInput: DeviceRecordProviderAggregateInput;
	DeviceRecordProviderConnectFieldInput: DeviceRecordProviderConnectFieldInput;
	DeviceRecordProviderConnection: DeviceRecordProviderConnection;
	DeviceRecordProviderConnectionSort: DeviceRecordProviderConnectionSort;
	DeviceRecordProviderConnectionWhere: DeviceRecordProviderConnectionWhere;
	DeviceRecordProviderCreateFieldInput: DeviceRecordProviderCreateFieldInput;
	DeviceRecordProviderDeleteFieldInput: DeviceRecordProviderDeleteFieldInput;
	DeviceRecordProviderDisconnectFieldInput: DeviceRecordProviderDisconnectFieldInput;
	DeviceRecordProviderFieldInput: DeviceRecordProviderFieldInput;
	DeviceRecordProviderNodeAggregationWhereInput: DeviceRecordProviderNodeAggregationWhereInput;
	DeviceRecordProviderRelationship: DeviceRecordProviderRelationship;
	DeviceRecordProviderUpdateConnectionInput: DeviceRecordProviderUpdateConnectionInput;
	DeviceRecordProviderUpdateFieldInput: DeviceRecordProviderUpdateFieldInput;
	DeviceRecordRecordAggregateInput: DeviceRecordRecordAggregateInput;
	DeviceRecordRecordConnectFieldInput: DeviceRecordRecordConnectFieldInput;
	DeviceRecordRecordConnection: DeviceRecordRecordConnection;
	DeviceRecordRecordConnectionSort: DeviceRecordRecordConnectionSort;
	DeviceRecordRecordConnectionWhere: DeviceRecordRecordConnectionWhere;
	DeviceRecordRecordCreateFieldInput: DeviceRecordRecordCreateFieldInput;
	DeviceRecordRecordDeleteFieldInput: DeviceRecordRecordDeleteFieldInput;
	DeviceRecordRecordDisconnectFieldInput: DeviceRecordRecordDisconnectFieldInput;
	DeviceRecordRecordFieldInput: DeviceRecordRecordFieldInput;
	DeviceRecordRecordNodeAggregationWhereInput: DeviceRecordRecordNodeAggregationWhereInput;
	DeviceRecordRecordRelationship: DeviceRecordRecordRelationship;
	DeviceRecordRecordUpdateConnectionInput: DeviceRecordRecordUpdateConnectionInput;
	DeviceRecordRecordUpdateFieldInput: DeviceRecordRecordUpdateFieldInput;
	DeviceRecordSort: DeviceRecordSort;
	DeviceRecordUpdateInput: DeviceRecordUpdateInput;
	DeviceRecordWhere: DeviceRecordWhere;
	DiscontinuationNote: DiscontinuationNote;
	DiscontinuationNoteAggregateSelection: DiscontinuationNoteAggregateSelection;
	DiscontinuationNoteConnectInput: DiscontinuationNoteConnectInput;
	DiscontinuationNoteConnectWhere: DiscontinuationNoteConnectWhere;
	DiscontinuationNoteCoverageRequestAggregateInput: DiscontinuationNoteCoverageRequestAggregateInput;
	DiscontinuationNoteCoverageRequestConnectFieldInput: DiscontinuationNoteCoverageRequestConnectFieldInput;
	DiscontinuationNoteCoverageRequestConnection: DiscontinuationNoteCoverageRequestConnection;
	DiscontinuationNoteCoverageRequestConnectionSort: DiscontinuationNoteCoverageRequestConnectionSort;
	DiscontinuationNoteCoverageRequestConnectionWhere: DiscontinuationNoteCoverageRequestConnectionWhere;
	DiscontinuationNoteCoverageRequestCreateFieldInput: DiscontinuationNoteCoverageRequestCreateFieldInput;
	DiscontinuationNoteCoverageRequestDeleteFieldInput: DiscontinuationNoteCoverageRequestDeleteFieldInput;
	DiscontinuationNoteCoverageRequestDisconnectFieldInput: DiscontinuationNoteCoverageRequestDisconnectFieldInput;
	DiscontinuationNoteCoverageRequestFieldInput: DiscontinuationNoteCoverageRequestFieldInput;
	DiscontinuationNoteCoverageRequestNodeAggregationWhereInput: DiscontinuationNoteCoverageRequestNodeAggregationWhereInput;
	DiscontinuationNoteCoverageRequestRelationship: DiscontinuationNoteCoverageRequestRelationship;
	DiscontinuationNoteCoverageRequestUpdateConnectionInput: DiscontinuationNoteCoverageRequestUpdateConnectionInput;
	DiscontinuationNoteCoverageRequestUpdateFieldInput: DiscontinuationNoteCoverageRequestUpdateFieldInput;
	DiscontinuationNoteCreateInput: DiscontinuationNoteCreateInput;
	DiscontinuationNoteDeleteInput: DiscontinuationNoteDeleteInput;
	DiscontinuationNoteDisconnectInput: DiscontinuationNoteDisconnectInput;
	DiscontinuationNoteFormAggregateInput: DiscontinuationNoteFormAggregateInput;
	DiscontinuationNoteFormConnectFieldInput: DiscontinuationNoteFormConnectFieldInput;
	DiscontinuationNoteFormConnection: DiscontinuationNoteFormConnection;
	DiscontinuationNoteFormConnectionSort: DiscontinuationNoteFormConnectionSort;
	DiscontinuationNoteFormConnectionWhere: DiscontinuationNoteFormConnectionWhere;
	DiscontinuationNoteFormCreateFieldInput: DiscontinuationNoteFormCreateFieldInput;
	DiscontinuationNoteFormDeleteFieldInput: DiscontinuationNoteFormDeleteFieldInput;
	DiscontinuationNoteFormDisconnectFieldInput: DiscontinuationNoteFormDisconnectFieldInput;
	DiscontinuationNoteFormFieldInput: DiscontinuationNoteFormFieldInput;
	DiscontinuationNoteFormNodeAggregationWhereInput: DiscontinuationNoteFormNodeAggregationWhereInput;
	DiscontinuationNoteFormRelationship: DiscontinuationNoteFormRelationship;
	DiscontinuationNoteFormUpdateConnectionInput: DiscontinuationNoteFormUpdateConnectionInput;
	DiscontinuationNoteFormUpdateFieldInput: DiscontinuationNoteFormUpdateFieldInput;
	DiscontinuationNoteInput: DiscontinuationNoteInput;
	DiscontinuationNoteOptions: DiscontinuationNoteOptions;
	DiscontinuationNoteSort: DiscontinuationNoteSort;
	DiscontinuationNoteUpdateInput: DiscontinuationNoteUpdateInput;
	DiscontinuationNoteWhere: DiscontinuationNoteWhere;
	Disease: Disease;
	DiseaseAggregateSelection: DiseaseAggregateSelection;
	DiseaseConnectWhere: DiseaseConnectWhere;
	DiseaseCreateInput: DiseaseCreateInput;
	DiseaseOptions: DiseaseOptions;
	DiseaseSort: DiseaseSort;
	DiseaseUpdateInput: DiseaseUpdateInput;
	DiseaseWhere: DiseaseWhere;
	Document: Document;
	DocumentAggregateSelection: DocumentAggregateSelection;
	DocumentAssignedToAggregateInput: DocumentAssignedToAggregateInput;
	DocumentAssignedToConnectFieldInput: DocumentAssignedToConnectFieldInput;
	DocumentAssignedToConnection: DocumentAssignedToConnection;
	DocumentAssignedToConnectionSort: DocumentAssignedToConnectionSort;
	DocumentAssignedToConnectionWhere: DocumentAssignedToConnectionWhere;
	DocumentAssignedToCreateFieldInput: DocumentAssignedToCreateFieldInput;
	DocumentAssignedToDeleteFieldInput: DocumentAssignedToDeleteFieldInput;
	DocumentAssignedToDisconnectFieldInput: DocumentAssignedToDisconnectFieldInput;
	DocumentAssignedToFieldInput: DocumentAssignedToFieldInput;
	DocumentAssignedToNodeAggregationWhereInput: DocumentAssignedToNodeAggregationWhereInput;
	DocumentAssignedToRelationship: DocumentAssignedToRelationship;
	DocumentAssignedToUpdateConnectionInput: DocumentAssignedToUpdateConnectionInput;
	DocumentAssignedToUpdateFieldInput: DocumentAssignedToUpdateFieldInput;
	DocumentConnectInput: DocumentConnectInput;
	DocumentConnectWhere: DocumentConnectWhere;
	DocumentCreateInput: DocumentCreateInput;
	DocumentDeleteInput: DocumentDeleteInput;
	DocumentDisconnectInput: DocumentDisconnectInput;
	DocumentOptions: DocumentOptions;
	DocumentRefundsAggregateInput: DocumentRefundsAggregateInput;
	DocumentRefundsConnectFieldInput: DocumentRefundsConnectFieldInput;
	DocumentRefundsConnection: DocumentRefundsConnection;
	DocumentRefundsConnectionSort: DocumentRefundsConnectionSort;
	DocumentRefundsConnectionWhere: DocumentRefundsConnectionWhere;
	DocumentRefundsCreateFieldInput: DocumentRefundsCreateFieldInput;
	DocumentRefundsDeleteFieldInput: DocumentRefundsDeleteFieldInput;
	DocumentRefundsDisconnectFieldInput: DocumentRefundsDisconnectFieldInput;
	DocumentRefundsFieldInput: DocumentRefundsFieldInput;
	DocumentRefundsNodeAggregationWhereInput: DocumentRefundsNodeAggregationWhereInput;
	DocumentRefundsRelationship: DocumentRefundsRelationship;
	DocumentRefundsUpdateConnectionInput: DocumentRefundsUpdateConnectionInput;
	DocumentRefundsUpdateFieldInput: DocumentRefundsUpdateFieldInput;
	DocumentSort: DocumentSort;
	DocumentTagsAggregateInput: DocumentTagsAggregateInput;
	DocumentTagsConnectFieldInput: DocumentTagsConnectFieldInput;
	DocumentTagsConnection: DocumentTagsConnection;
	DocumentTagsConnectionSort: DocumentTagsConnectionSort;
	DocumentTagsConnectionWhere: DocumentTagsConnectionWhere;
	DocumentTagsCreateFieldInput: DocumentTagsCreateFieldInput;
	DocumentTagsDeleteFieldInput: DocumentTagsDeleteFieldInput;
	DocumentTagsDisconnectFieldInput: DocumentTagsDisconnectFieldInput;
	DocumentTagsFieldInput: DocumentTagsFieldInput;
	DocumentTagsNodeAggregationWhereInput: DocumentTagsNodeAggregationWhereInput;
	DocumentTagsRelationship: DocumentTagsRelationship;
	DocumentTagsUpdateConnectionInput: DocumentTagsUpdateConnectionInput;
	DocumentTagsUpdateFieldInput: DocumentTagsUpdateFieldInput;
	DocumentUpdateInput: DocumentUpdateInput;
	DocumentWhere: DocumentWhere;
	EligibilityConditionSet: EligibilityConditionSet;
	EligibilityConditionSetAggregateSelection: EligibilityConditionSetAggregateSelection;
	EligibilityConditionSetConnectWhere: EligibilityConditionSetConnectWhere;
	EligibilityConditionSetCreateInput: EligibilityConditionSetCreateInput;
	EligibilityConditionSetOptions: EligibilityConditionSetOptions;
	EligibilityConditionSetSort: EligibilityConditionSetSort;
	EligibilityConditionSetUpdateInput: EligibilityConditionSetUpdateInput;
	EligibilityConditionSetWhere: EligibilityConditionSetWhere;
	EnrollingConditionDiseaseRelationship: ResolversParentTypes["EnrollingConditionSetDiseasesRelationship"];
	EnrollingConditionDiseaseRelationshipCreateInput: EnrollingConditionDiseaseRelationshipCreateInput;
	EnrollingConditionDiseaseRelationshipSort: EnrollingConditionDiseaseRelationshipSort;
	EnrollingConditionDiseaseRelationshipUpdateInput: EnrollingConditionDiseaseRelationshipUpdateInput;
	EnrollingConditionDiseaseRelationshipWhere: EnrollingConditionDiseaseRelationshipWhere;
	EnrollingConditionSet: EnrollingConditionSet;
	EnrollingConditionSetAggregateSelection: EnrollingConditionSetAggregateSelection;
	EnrollingConditionSetAgreementAggregateInput: EnrollingConditionSetAgreementAggregateInput;
	EnrollingConditionSetAgreementConnectFieldInput: EnrollingConditionSetAgreementConnectFieldInput;
	EnrollingConditionSetAgreementConnection: EnrollingConditionSetAgreementConnection;
	EnrollingConditionSetAgreementConnectionSort: EnrollingConditionSetAgreementConnectionSort;
	EnrollingConditionSetAgreementConnectionWhere: EnrollingConditionSetAgreementConnectionWhere;
	EnrollingConditionSetAgreementCreateFieldInput: EnrollingConditionSetAgreementCreateFieldInput;
	EnrollingConditionSetAgreementDeleteFieldInput: EnrollingConditionSetAgreementDeleteFieldInput;
	EnrollingConditionSetAgreementDisconnectFieldInput: EnrollingConditionSetAgreementDisconnectFieldInput;
	EnrollingConditionSetAgreementFieldInput: EnrollingConditionSetAgreementFieldInput;
	EnrollingConditionSetAgreementNodeAggregationWhereInput: EnrollingConditionSetAgreementNodeAggregationWhereInput;
	EnrollingConditionSetAgreementRelationship: EnrollingConditionSetAgreementRelationship;
	EnrollingConditionSetAgreementUpdateConnectionInput: EnrollingConditionSetAgreementUpdateConnectionInput;
	EnrollingConditionSetAgreementUpdateFieldInput: EnrollingConditionSetAgreementUpdateFieldInput;
	EnrollingConditionSetConnectInput: EnrollingConditionSetConnectInput;
	EnrollingConditionSetConnectWhere: EnrollingConditionSetConnectWhere;
	EnrollingConditionSetCreateInput: EnrollingConditionSetCreateInput;
	EnrollingConditionSetDeleteInput: EnrollingConditionSetDeleteInput;
	EnrollingConditionSetDisconnectInput: EnrollingConditionSetDisconnectInput;
	EnrollingConditionSetDiseasesAggregateInput: EnrollingConditionSetDiseasesAggregateInput;
	EnrollingConditionSetDiseasesConnectFieldInput: EnrollingConditionSetDiseasesConnectFieldInput;
	EnrollingConditionSetDiseasesConnection: EnrollingConditionSetDiseasesConnection;
	EnrollingConditionSetDiseasesConnectionSort: EnrollingConditionSetDiseasesConnectionSort;
	EnrollingConditionSetDiseasesConnectionWhere: EnrollingConditionSetDiseasesConnectionWhere;
	EnrollingConditionSetDiseasesCreateFieldInput: EnrollingConditionSetDiseasesCreateFieldInput;
	EnrollingConditionSetDiseasesDeleteFieldInput: EnrollingConditionSetDiseasesDeleteFieldInput;
	EnrollingConditionSetDiseasesDisconnectFieldInput: EnrollingConditionSetDiseasesDisconnectFieldInput;
	EnrollingConditionSetDiseasesEdgeAggregationWhereInput: EnrollingConditionSetDiseasesEdgeAggregationWhereInput;
	EnrollingConditionSetDiseasesFieldInput: EnrollingConditionSetDiseasesFieldInput;
	EnrollingConditionSetDiseasesNodeAggregationWhereInput: EnrollingConditionSetDiseasesNodeAggregationWhereInput;
	EnrollingConditionSetDiseasesRelationship: EnrollingConditionSetDiseasesRelationship;
	EnrollingConditionSetDiseasesUpdateConnectionInput: EnrollingConditionSetDiseasesUpdateConnectionInput;
	EnrollingConditionSetDiseasesUpdateFieldInput: EnrollingConditionSetDiseasesUpdateFieldInput;
	EnrollingConditionSetIndicationsAggregateInput: EnrollingConditionSetIndicationsAggregateInput;
	EnrollingConditionSetIndicationsConnectFieldInput: EnrollingConditionSetIndicationsConnectFieldInput;
	EnrollingConditionSetIndicationsConnection: EnrollingConditionSetIndicationsConnection;
	EnrollingConditionSetIndicationsConnectionSort: EnrollingConditionSetIndicationsConnectionSort;
	EnrollingConditionSetIndicationsConnectionWhere: EnrollingConditionSetIndicationsConnectionWhere;
	EnrollingConditionSetIndicationsCreateFieldInput: EnrollingConditionSetIndicationsCreateFieldInput;
	EnrollingConditionSetIndicationsDeleteFieldInput: EnrollingConditionSetIndicationsDeleteFieldInput;
	EnrollingConditionSetIndicationsDisconnectFieldInput: EnrollingConditionSetIndicationsDisconnectFieldInput;
	EnrollingConditionSetIndicationsFieldInput: EnrollingConditionSetIndicationsFieldInput;
	EnrollingConditionSetIndicationsNodeAggregationWhereInput: EnrollingConditionSetIndicationsNodeAggregationWhereInput;
	EnrollingConditionSetIndicationsRelationship: EnrollingConditionSetIndicationsRelationship;
	EnrollingConditionSetIndicationsUpdateConnectionInput: EnrollingConditionSetIndicationsUpdateConnectionInput;
	EnrollingConditionSetIndicationsUpdateFieldInput: EnrollingConditionSetIndicationsUpdateFieldInput;
	EnrollingConditionSetOptions: EnrollingConditionSetOptions;
	EnrollingConditionSetPreparationsAggregateInput: EnrollingConditionSetPreparationsAggregateInput;
	EnrollingConditionSetPreparationsConnectFieldInput: EnrollingConditionSetPreparationsConnectFieldInput;
	EnrollingConditionSetPreparationsConnection: EnrollingConditionSetPreparationsConnection;
	EnrollingConditionSetPreparationsConnectionSort: EnrollingConditionSetPreparationsConnectionSort;
	EnrollingConditionSetPreparationsConnectionWhere: EnrollingConditionSetPreparationsConnectionWhere;
	EnrollingConditionSetPreparationsCreateFieldInput: EnrollingConditionSetPreparationsCreateFieldInput;
	EnrollingConditionSetPreparationsDeleteFieldInput: EnrollingConditionSetPreparationsDeleteFieldInput;
	EnrollingConditionSetPreparationsDisconnectFieldInput: EnrollingConditionSetPreparationsDisconnectFieldInput;
	EnrollingConditionSetPreparationsFieldInput: EnrollingConditionSetPreparationsFieldInput;
	EnrollingConditionSetPreparationsNodeAggregationWhereInput: EnrollingConditionSetPreparationsNodeAggregationWhereInput;
	EnrollingConditionSetPreparationsRelationship: EnrollingConditionSetPreparationsRelationship;
	EnrollingConditionSetPreparationsUpdateConnectionInput: EnrollingConditionSetPreparationsUpdateConnectionInput;
	EnrollingConditionSetPreparationsUpdateFieldInput: EnrollingConditionSetPreparationsUpdateFieldInput;
	EnrollingConditionSetSort: EnrollingConditionSetSort;
	EnrollingConditionSetTreatmentsAggregateInput: EnrollingConditionSetTreatmentsAggregateInput;
	EnrollingConditionSetTreatmentsConnectFieldInput: EnrollingConditionSetTreatmentsConnectFieldInput;
	EnrollingConditionSetTreatmentsConnection: EnrollingConditionSetTreatmentsConnection;
	EnrollingConditionSetTreatmentsConnectionSort: EnrollingConditionSetTreatmentsConnectionSort;
	EnrollingConditionSetTreatmentsConnectionWhere: EnrollingConditionSetTreatmentsConnectionWhere;
	EnrollingConditionSetTreatmentsCreateFieldInput: EnrollingConditionSetTreatmentsCreateFieldInput;
	EnrollingConditionSetTreatmentsDeleteFieldInput: EnrollingConditionSetTreatmentsDeleteFieldInput;
	EnrollingConditionSetTreatmentsDisconnectFieldInput: EnrollingConditionSetTreatmentsDisconnectFieldInput;
	EnrollingConditionSetTreatmentsFieldInput: EnrollingConditionSetTreatmentsFieldInput;
	EnrollingConditionSetTreatmentsNodeAggregationWhereInput: EnrollingConditionSetTreatmentsNodeAggregationWhereInput;
	EnrollingConditionSetTreatmentsRelationship: EnrollingConditionSetTreatmentsRelationship;
	EnrollingConditionSetTreatmentsUpdateConnectionInput: EnrollingConditionSetTreatmentsUpdateConnectionInput;
	EnrollingConditionSetTreatmentsUpdateFieldInput: EnrollingConditionSetTreatmentsUpdateFieldInput;
	EnrollingConditionSetUpdateInput: EnrollingConditionSetUpdateInput;
	EnrollingConditionSetWhere: EnrollingConditionSetWhere;
	EnrollingPeriod: EnrollingPeriod;
	EnrollingPeriodAggregateSelection: EnrollingPeriodAggregateSelection;
	EnrollingPeriodConnectWhere: EnrollingPeriodConnectWhere;
	EnrollingPeriodCreateInput: EnrollingPeriodCreateInput;
	EnrollingPeriodOptions: EnrollingPeriodOptions;
	EnrollingPeriodSort: EnrollingPeriodSort;
	EnrollingPeriodUpdateInput: EnrollingPeriodUpdateInput;
	EnrollingPeriodWhere: EnrollingPeriodWhere;
	ExFactoryPrice: ExFactoryPrice;
	ExFactoryPriceAggregateSelection: ExFactoryPriceAggregateSelection;
	ExFactoryPriceConnectWhere: ExFactoryPriceConnectWhere;
	ExFactoryPriceCreateInput: ExFactoryPriceCreateInput;
	ExFactoryPriceOptions: ExFactoryPriceOptions;
	ExFactoryPriceSort: ExFactoryPriceSort;
	ExFactoryPriceUpdateInput: ExFactoryPriceUpdateInput;
	ExFactoryPriceWhere: ExFactoryPriceWhere;
	FinancialDataPoint: FinancialDataPoint;
	FinancialDataPointAggregateSelection: FinancialDataPointAggregateSelection;
	FinancialDataPointAgreementAggregateInput: FinancialDataPointAgreementAggregateInput;
	FinancialDataPointAgreementConnectFieldInput: FinancialDataPointAgreementConnectFieldInput;
	FinancialDataPointAgreementConnection: FinancialDataPointAgreementConnection;
	FinancialDataPointAgreementConnectionSort: FinancialDataPointAgreementConnectionSort;
	FinancialDataPointAgreementConnectionWhere: FinancialDataPointAgreementConnectionWhere;
	FinancialDataPointAgreementCreateFieldInput: FinancialDataPointAgreementCreateFieldInput;
	FinancialDataPointAgreementDeleteFieldInput: FinancialDataPointAgreementDeleteFieldInput;
	FinancialDataPointAgreementDisconnectFieldInput: FinancialDataPointAgreementDisconnectFieldInput;
	FinancialDataPointAgreementFieldInput: FinancialDataPointAgreementFieldInput;
	FinancialDataPointAgreementNodeAggregationWhereInput: FinancialDataPointAgreementNodeAggregationWhereInput;
	FinancialDataPointAgreementRelationship: FinancialDataPointAgreementRelationship;
	FinancialDataPointAgreementUpdateConnectionInput: FinancialDataPointAgreementUpdateConnectionInput;
	FinancialDataPointAgreementUpdateFieldInput: FinancialDataPointAgreementUpdateFieldInput;
	FinancialDataPointClaimAggregateInput: FinancialDataPointClaimAggregateInput;
	FinancialDataPointClaimConnectFieldInput: FinancialDataPointClaimConnectFieldInput;
	FinancialDataPointClaimConnection: FinancialDataPointClaimConnection;
	FinancialDataPointClaimConnectionSort: FinancialDataPointClaimConnectionSort;
	FinancialDataPointClaimConnectionWhere: FinancialDataPointClaimConnectionWhere;
	FinancialDataPointClaimCreateFieldInput: FinancialDataPointClaimCreateFieldInput;
	FinancialDataPointClaimDeleteFieldInput: FinancialDataPointClaimDeleteFieldInput;
	FinancialDataPointClaimDisconnectFieldInput: FinancialDataPointClaimDisconnectFieldInput;
	FinancialDataPointClaimFieldInput: FinancialDataPointClaimFieldInput;
	FinancialDataPointClaimNodeAggregationWhereInput: FinancialDataPointClaimNodeAggregationWhereInput;
	FinancialDataPointClaimRelationship: FinancialDataPointClaimRelationship;
	FinancialDataPointClaimUpdateConnectionInput: FinancialDataPointClaimUpdateConnectionInput;
	FinancialDataPointClaimUpdateFieldInput: FinancialDataPointClaimUpdateFieldInput;
	FinancialDataPointConnectInput: FinancialDataPointConnectInput;
	FinancialDataPointConnectWhere: FinancialDataPointConnectWhere;
	FinancialDataPointContinuousBenefitAggregateInput: FinancialDataPointContinuousBenefitAggregateInput;
	FinancialDataPointContinuousBenefitConnectFieldInput: FinancialDataPointContinuousBenefitConnectFieldInput;
	FinancialDataPointContinuousBenefitConnection: FinancialDataPointContinuousBenefitConnection;
	FinancialDataPointContinuousBenefitConnectionSort: FinancialDataPointContinuousBenefitConnectionSort;
	FinancialDataPointContinuousBenefitConnectionWhere: FinancialDataPointContinuousBenefitConnectionWhere;
	FinancialDataPointContinuousBenefitCreateFieldInput: FinancialDataPointContinuousBenefitCreateFieldInput;
	FinancialDataPointContinuousBenefitDeleteFieldInput: FinancialDataPointContinuousBenefitDeleteFieldInput;
	FinancialDataPointContinuousBenefitDisconnectFieldInput: FinancialDataPointContinuousBenefitDisconnectFieldInput;
	FinancialDataPointContinuousBenefitFieldInput: FinancialDataPointContinuousBenefitFieldInput;
	FinancialDataPointContinuousBenefitNodeAggregationWhereInput: FinancialDataPointContinuousBenefitNodeAggregationWhereInput;
	FinancialDataPointContinuousBenefitRelationship: FinancialDataPointContinuousBenefitRelationship;
	FinancialDataPointContinuousBenefitUpdateConnectionInput: FinancialDataPointContinuousBenefitUpdateConnectionInput;
	FinancialDataPointContinuousBenefitUpdateFieldInput: FinancialDataPointContinuousBenefitUpdateFieldInput;
	FinancialDataPointCoverageRequestAggregateInput: FinancialDataPointCoverageRequestAggregateInput;
	FinancialDataPointCoverageRequestConnectFieldInput: FinancialDataPointCoverageRequestConnectFieldInput;
	FinancialDataPointCoverageRequestConnection: FinancialDataPointCoverageRequestConnection;
	FinancialDataPointCoverageRequestConnectionSort: FinancialDataPointCoverageRequestConnectionSort;
	FinancialDataPointCoverageRequestConnectionWhere: FinancialDataPointCoverageRequestConnectionWhere;
	FinancialDataPointCoverageRequestCreateFieldInput: FinancialDataPointCoverageRequestCreateFieldInput;
	FinancialDataPointCoverageRequestDeleteFieldInput: FinancialDataPointCoverageRequestDeleteFieldInput;
	FinancialDataPointCoverageRequestDisconnectFieldInput: FinancialDataPointCoverageRequestDisconnectFieldInput;
	FinancialDataPointCoverageRequestFieldInput: FinancialDataPointCoverageRequestFieldInput;
	FinancialDataPointCoverageRequestNodeAggregationWhereInput: FinancialDataPointCoverageRequestNodeAggregationWhereInput;
	FinancialDataPointCoverageRequestRelationship: FinancialDataPointCoverageRequestRelationship;
	FinancialDataPointCoverageRequestUpdateConnectionInput: FinancialDataPointCoverageRequestUpdateConnectionInput;
	FinancialDataPointCoverageRequestUpdateFieldInput: FinancialDataPointCoverageRequestUpdateFieldInput;
	FinancialDataPointCreateInput: FinancialDataPointCreateInput;
	FinancialDataPointDeleteInput: FinancialDataPointDeleteInput;
	FinancialDataPointDisconnectInput: FinancialDataPointDisconnectInput;
	FinancialDataPointIncludedInAggregateInput: FinancialDataPointIncludedInAggregateInput;
	FinancialDataPointIncludedInConnectFieldInput: FinancialDataPointIncludedInConnectFieldInput;
	FinancialDataPointIncludedInConnection: FinancialDataPointIncludedInConnection;
	FinancialDataPointIncludedInConnectionSort: FinancialDataPointIncludedInConnectionSort;
	FinancialDataPointIncludedInConnectionWhere: FinancialDataPointIncludedInConnectionWhere;
	FinancialDataPointIncludedInCreateFieldInput: FinancialDataPointIncludedInCreateFieldInput;
	FinancialDataPointIncludedInDeleteFieldInput: FinancialDataPointIncludedInDeleteFieldInput;
	FinancialDataPointIncludedInDisconnectFieldInput: FinancialDataPointIncludedInDisconnectFieldInput;
	FinancialDataPointIncludedInFieldInput: FinancialDataPointIncludedInFieldInput;
	FinancialDataPointIncludedInNodeAggregationWhereInput: FinancialDataPointIncludedInNodeAggregationWhereInput;
	FinancialDataPointIncludedInRelationship: FinancialDataPointIncludedInRelationship;
	FinancialDataPointIncludedInUpdateConnectionInput: FinancialDataPointIncludedInUpdateConnectionInput;
	FinancialDataPointIncludedInUpdateFieldInput: FinancialDataPointIncludedInUpdateFieldInput;
	FinancialDataPointInput: FinancialDataPointInput;
	FinancialDataPointInterventionAggregateInput: FinancialDataPointInterventionAggregateInput;
	FinancialDataPointInterventionConnectFieldInput: FinancialDataPointInterventionConnectFieldInput;
	FinancialDataPointInterventionConnection: FinancialDataPointInterventionConnection;
	FinancialDataPointInterventionConnectionSort: FinancialDataPointInterventionConnectionSort;
	FinancialDataPointInterventionConnectionWhere: FinancialDataPointInterventionConnectionWhere;
	FinancialDataPointInterventionCreateFieldInput: FinancialDataPointInterventionCreateFieldInput;
	FinancialDataPointInterventionDeleteFieldInput: FinancialDataPointInterventionDeleteFieldInput;
	FinancialDataPointInterventionDisconnectFieldInput: FinancialDataPointInterventionDisconnectFieldInput;
	FinancialDataPointInterventionFieldInput: FinancialDataPointInterventionFieldInput;
	FinancialDataPointInterventionNodeAggregationWhereInput: FinancialDataPointInterventionNodeAggregationWhereInput;
	FinancialDataPointInterventionRelationship: FinancialDataPointInterventionRelationship;
	FinancialDataPointInterventionUpdateConnectionInput: FinancialDataPointInterventionUpdateConnectionInput;
	FinancialDataPointInterventionUpdateFieldInput: FinancialDataPointInterventionUpdateFieldInput;
	FinancialDataPointOptions: FinancialDataPointOptions;
	FinancialDataPointSort: FinancialDataPointSort;
	FinancialDataPointSourceRefundAggregateInput: FinancialDataPointSourceRefundAggregateInput;
	FinancialDataPointSourceRefundConnectFieldInput: FinancialDataPointSourceRefundConnectFieldInput;
	FinancialDataPointSourceRefundConnection: FinancialDataPointSourceRefundConnection;
	FinancialDataPointSourceRefundConnectionSort: FinancialDataPointSourceRefundConnectionSort;
	FinancialDataPointSourceRefundConnectionWhere: FinancialDataPointSourceRefundConnectionWhere;
	FinancialDataPointSourceRefundCreateFieldInput: FinancialDataPointSourceRefundCreateFieldInput;
	FinancialDataPointSourceRefundDeleteFieldInput: FinancialDataPointSourceRefundDeleteFieldInput;
	FinancialDataPointSourceRefundDisconnectFieldInput: FinancialDataPointSourceRefundDisconnectFieldInput;
	FinancialDataPointSourceRefundFieldInput: FinancialDataPointSourceRefundFieldInput;
	FinancialDataPointSourceRefundNodeAggregationWhereInput: FinancialDataPointSourceRefundNodeAggregationWhereInput;
	FinancialDataPointSourceRefundRelationship: FinancialDataPointSourceRefundRelationship;
	FinancialDataPointSourceRefundUpdateConnectionInput: FinancialDataPointSourceRefundUpdateConnectionInput;
	FinancialDataPointSourceRefundUpdateFieldInput: FinancialDataPointSourceRefundUpdateFieldInput;
	FinancialDataPointTreatmentAggregateInput: FinancialDataPointTreatmentAggregateInput;
	FinancialDataPointTreatmentConnectFieldInput: FinancialDataPointTreatmentConnectFieldInput;
	FinancialDataPointTreatmentConnection: FinancialDataPointTreatmentConnection;
	FinancialDataPointTreatmentConnectionSort: FinancialDataPointTreatmentConnectionSort;
	FinancialDataPointTreatmentConnectionWhere: FinancialDataPointTreatmentConnectionWhere;
	FinancialDataPointTreatmentCreateFieldInput: FinancialDataPointTreatmentCreateFieldInput;
	FinancialDataPointTreatmentDeleteFieldInput: FinancialDataPointTreatmentDeleteFieldInput;
	FinancialDataPointTreatmentDisconnectFieldInput: FinancialDataPointTreatmentDisconnectFieldInput;
	FinancialDataPointTreatmentFieldInput: FinancialDataPointTreatmentFieldInput;
	FinancialDataPointTreatmentNodeAggregationWhereInput: FinancialDataPointTreatmentNodeAggregationWhereInput;
	FinancialDataPointTreatmentRelationship: FinancialDataPointTreatmentRelationship;
	FinancialDataPointTreatmentUpdateConnectionInput: FinancialDataPointTreatmentUpdateConnectionInput;
	FinancialDataPointTreatmentUpdateFieldInput: FinancialDataPointTreatmentUpdateFieldInput;
	FinancialDataPointUpdateInput: FinancialDataPointUpdateInput;
	FinancialDataPointWhere: FinancialDataPointWhere;
	FinancialReportDataPoint: FinancialReportDataPoint;
	FinancialReportDataPointAggregateSelection: FinancialReportDataPointAggregateSelection;
	FinancialReportDataPointOptions: FinancialReportDataPointOptions;
	FinancialReportDataPointSort: FinancialReportDataPointSort;
	FinancialReportDataPointWhere: FinancialReportDataPointWhere;
	FinancialSummaryColumn: FinancialSummaryColumn;
	FinancialSummaryColumnAggregateSelection: FinancialSummaryColumnAggregateSelection;
	FinancialSummaryColumnConnectWhere: FinancialSummaryColumnConnectWhere;
	FinancialSummaryColumnCreateInput: FinancialSummaryColumnCreateInput;
	FinancialSummaryColumnOptions: FinancialSummaryColumnOptions;
	FinancialSummaryColumnSort: FinancialSummaryColumnSort;
	FinancialSummaryColumnUpdateInput: FinancialSummaryColumnUpdateInput;
	FinancialSummaryColumnWhere: FinancialSummaryColumnWhere;
	FinancialSummaryRow: FinancialSummaryRow;
	FinancialSummaryRowAggregateSelection: FinancialSummaryRowAggregateSelection;
	FinancialSummaryRowOptions: FinancialSummaryRowOptions;
	FinancialSummaryRowSort: FinancialSummaryRowSort;
	FinancialSummaryRowWhere: FinancialSummaryRowWhere;
	FlexEntity: FlexEntity;
	FlexEntityAggregateSelection: FlexEntityAggregateSelection;
	FlexEntityCasesAggregateInput: FlexEntityCasesAggregateInput;
	FlexEntityCasesConnectFieldInput: FlexEntityCasesConnectFieldInput;
	FlexEntityCasesConnection: FlexEntityCasesConnection;
	FlexEntityCasesConnectionSort: FlexEntityCasesConnectionSort;
	FlexEntityCasesConnectionWhere: FlexEntityCasesConnectionWhere;
	FlexEntityCasesCreateFieldInput: FlexEntityCasesCreateFieldInput;
	FlexEntityCasesDeleteFieldInput: FlexEntityCasesDeleteFieldInput;
	FlexEntityCasesDisconnectFieldInput: FlexEntityCasesDisconnectFieldInput;
	FlexEntityCasesFieldInput: FlexEntityCasesFieldInput;
	FlexEntityCasesNodeAggregationWhereInput: FlexEntityCasesNodeAggregationWhereInput;
	FlexEntityCasesRelationship: FlexEntityCasesRelationship;
	FlexEntityCasesUpdateConnectionInput: FlexEntityCasesUpdateConnectionInput;
	FlexEntityCasesUpdateFieldInput: FlexEntityCasesUpdateFieldInput;
	FlexEntityChildrenAggregateInput: FlexEntityChildrenAggregateInput;
	FlexEntityChildrenConnectFieldInput: FlexEntityChildrenConnectFieldInput;
	FlexEntityChildrenConnection: FlexEntityChildrenConnection;
	FlexEntityChildrenConnectionSort: FlexEntityChildrenConnectionSort;
	FlexEntityChildrenConnectionWhere: FlexEntityChildrenConnectionWhere;
	FlexEntityChildrenCreateFieldInput: FlexEntityChildrenCreateFieldInput;
	FlexEntityChildrenDeleteFieldInput: FlexEntityChildrenDeleteFieldInput;
	FlexEntityChildrenDisconnectFieldInput: FlexEntityChildrenDisconnectFieldInput;
	FlexEntityChildrenFieldInput: FlexEntityChildrenFieldInput;
	FlexEntityChildrenNodeAggregationWhereInput: FlexEntityChildrenNodeAggregationWhereInput;
	FlexEntityChildrenRelationship: FlexEntityChildrenRelationship;
	FlexEntityChildrenUpdateConnectionInput: FlexEntityChildrenUpdateConnectionInput;
	FlexEntityChildrenUpdateFieldInput: FlexEntityChildrenUpdateFieldInput;
	FlexEntityConnectInput: FlexEntityConnectInput;
	FlexEntityConnectWhere: FlexEntityConnectWhere;
	FlexEntityCreateInput: FlexEntityCreateInput;
	FlexEntityCreatedByAggregateInput: FlexEntityCreatedByAggregateInput;
	FlexEntityCreatedByConnectFieldInput: FlexEntityCreatedByConnectFieldInput;
	FlexEntityCreatedByConnection: FlexEntityCreatedByConnection;
	FlexEntityCreatedByConnectionSort: FlexEntityCreatedByConnectionSort;
	FlexEntityCreatedByConnectionWhere: FlexEntityCreatedByConnectionWhere;
	FlexEntityCreatedByCreateFieldInput: FlexEntityCreatedByCreateFieldInput;
	FlexEntityCreatedByDeleteFieldInput: FlexEntityCreatedByDeleteFieldInput;
	FlexEntityCreatedByDisconnectFieldInput: FlexEntityCreatedByDisconnectFieldInput;
	FlexEntityCreatedByFieldInput: FlexEntityCreatedByFieldInput;
	FlexEntityCreatedByNodeAggregationWhereInput: FlexEntityCreatedByNodeAggregationWhereInput;
	FlexEntityCreatedByRelationship: FlexEntityCreatedByRelationship;
	FlexEntityCreatedByUpdateConnectionInput: FlexEntityCreatedByUpdateConnectionInput;
	FlexEntityCreatedByUpdateFieldInput: FlexEntityCreatedByUpdateFieldInput;
	FlexEntityDataPointsAggregateInput: FlexEntityDataPointsAggregateInput;
	FlexEntityDataPointsConnectFieldInput: FlexEntityDataPointsConnectFieldInput;
	FlexEntityDataPointsConnection: FlexEntityDataPointsConnection;
	FlexEntityDataPointsConnectionSort: FlexEntityDataPointsConnectionSort;
	FlexEntityDataPointsConnectionWhere: FlexEntityDataPointsConnectionWhere;
	FlexEntityDataPointsCreateFieldInput: FlexEntityDataPointsCreateFieldInput;
	FlexEntityDataPointsDeleteFieldInput: FlexEntityDataPointsDeleteFieldInput;
	FlexEntityDataPointsDisconnectFieldInput: FlexEntityDataPointsDisconnectFieldInput;
	FlexEntityDataPointsFieldInput: FlexEntityDataPointsFieldInput;
	FlexEntityDataPointsNodeAggregationWhereInput: FlexEntityDataPointsNodeAggregationWhereInput;
	FlexEntityDataPointsRelationship: FlexEntityDataPointsRelationship;
	FlexEntityDataPointsUpdateConnectionInput: FlexEntityDataPointsUpdateConnectionInput;
	FlexEntityDataPointsUpdateFieldInput: FlexEntityDataPointsUpdateFieldInput;
	FlexEntityDeleteInput: FlexEntityDeleteInput;
	FlexEntityDisconnectInput: FlexEntityDisconnectInput;
	FlexEntityOptions: FlexEntityOptions;
	SimulatorOptions: SimulatorOptions;
	FlexEntityPatientAggregateInput: FlexEntityPatientAggregateInput;
	FlexEntityPatientConnectFieldInput: FlexEntityPatientConnectFieldInput;
	FlexEntityPatientConnection: FlexEntityPatientConnection;
	FlexEntityPatientConnectionSort: FlexEntityPatientConnectionSort;
	FlexEntityPatientConnectionWhere: FlexEntityPatientConnectionWhere;
	FlexEntityPatientCreateFieldInput: FlexEntityPatientCreateFieldInput;
	FlexEntityPatientDeleteFieldInput: FlexEntityPatientDeleteFieldInput;
	FlexEntityPatientDisconnectFieldInput: FlexEntityPatientDisconnectFieldInput;
	FlexEntityPatientFieldInput: FlexEntityPatientFieldInput;
	FlexEntityPatientNodeAggregationWhereInput: FlexEntityPatientNodeAggregationWhereInput;
	FlexEntityPatientRelationship: FlexEntityPatientRelationship;
	FlexEntityPatientUpdateConnectionInput: FlexEntityPatientUpdateConnectionInput;
	FlexEntityPatientUpdateFieldInput: FlexEntityPatientUpdateFieldInput;
	FlexEntitySort: FlexEntitySort;
	FlexEntitySourceAggregateInput: FlexEntitySourceAggregateInput;
	FlexEntitySourceConnectFieldInput: FlexEntitySourceConnectFieldInput;
	FlexEntitySourceConnection: FlexEntitySourceConnection;
	FlexEntitySourceConnectionSort: FlexEntitySourceConnectionSort;
	FlexEntitySourceConnectionWhere: FlexEntitySourceConnectionWhere;
	FlexEntitySourceCreateFieldInput: FlexEntitySourceCreateFieldInput;
	FlexEntitySourceDeleteFieldInput: FlexEntitySourceDeleteFieldInput;
	FlexEntitySourceDisconnectFieldInput: FlexEntitySourceDisconnectFieldInput;
	FlexEntitySourceFieldInput: FlexEntitySourceFieldInput;
	FlexEntitySourceNodeAggregationWhereInput: FlexEntitySourceNodeAggregationWhereInput;
	FlexEntitySourceRelationship: FlexEntitySourceRelationship;
	FlexEntitySourceUpdateConnectionInput: FlexEntitySourceUpdateConnectionInput;
	FlexEntitySourceUpdateFieldInput: FlexEntitySourceUpdateFieldInput;
	FlexEntityStartingPointAggregateInput: FlexEntityStartingPointAggregateInput;
	FlexEntityStartingPointConnectFieldInput: FlexEntityStartingPointConnectFieldInput;
	FlexEntityStartingPointConnection: FlexEntityStartingPointConnection;
	FlexEntityStartingPointConnectionSort: FlexEntityStartingPointConnectionSort;
	FlexEntityStartingPointConnectionWhere: FlexEntityStartingPointConnectionWhere;
	FlexEntityStartingPointCreateFieldInput: FlexEntityStartingPointCreateFieldInput;
	FlexEntityStartingPointDeleteFieldInput: FlexEntityStartingPointDeleteFieldInput;
	FlexEntityStartingPointDisconnectFieldInput: FlexEntityStartingPointDisconnectFieldInput;
	FlexEntityStartingPointFieldInput: FlexEntityStartingPointFieldInput;
	FlexEntityStartingPointNodeAggregationWhereInput: FlexEntityStartingPointNodeAggregationWhereInput;
	FlexEntityStartingPointRelationship: FlexEntityStartingPointRelationship;
	FlexEntityStartingPointUpdateConnectionInput: FlexEntityStartingPointUpdateConnectionInput;
	FlexEntityStartingPointUpdateFieldInput: FlexEntityStartingPointUpdateFieldInput;
	FlexEntityType: FlexEntityType;
	FlexEntityTypeAddedByAggregateInput: FlexEntityTypeAddedByAggregateInput;
	FlexEntityTypeAddedByConnectFieldInput: FlexEntityTypeAddedByConnectFieldInput;
	FlexEntityTypeAddedByConnection: FlexEntityTypeAddedByConnection;
	FlexEntityTypeAddedByConnectionSort: FlexEntityTypeAddedByConnectionSort;
	FlexEntityTypeAddedByConnectionWhere: FlexEntityTypeAddedByConnectionWhere;
	FlexEntityTypeAddedByCreateFieldInput: FlexEntityTypeAddedByCreateFieldInput;
	FlexEntityTypeAddedByDeleteFieldInput: FlexEntityTypeAddedByDeleteFieldInput;
	FlexEntityTypeAddedByDisconnectFieldInput: FlexEntityTypeAddedByDisconnectFieldInput;
	FlexEntityTypeAddedByFieldInput: FlexEntityTypeAddedByFieldInput;
	FlexEntityTypeAddedByNodeAggregationWhereInput: FlexEntityTypeAddedByNodeAggregationWhereInput;
	FlexEntityTypeAddedByRelationship: FlexEntityTypeAddedByRelationship;
	FlexEntityTypeAddedByUpdateConnectionInput: FlexEntityTypeAddedByUpdateConnectionInput;
	FlexEntityTypeAddedByUpdateFieldInput: FlexEntityTypeAddedByUpdateFieldInput;
	FlexEntityTypeAggregateInput: FlexEntityTypeAggregateInput;
	FlexEntityTypeAggregateSelection: FlexEntityTypeAggregateSelection;
	FlexEntityTypeConnectFieldInput: FlexEntityTypeConnectFieldInput;
	FlexEntityTypeConnectInput: FlexEntityTypeConnectInput;
	FlexEntityTypeConnectWhere: FlexEntityTypeConnectWhere;
	FlexEntityTypeConnection: FlexEntityTypeConnection;
	FlexEntityTypeConnectionSort: FlexEntityTypeConnectionSort;
	FlexEntityTypeConnectionWhere: FlexEntityTypeConnectionWhere;
	FlexEntityTypeCreateFieldInput: FlexEntityTypeCreateFieldInput;
	FlexEntityTypeCreateInput: FlexEntityTypeCreateInput;
	FlexEntityTypeDeleteFieldInput: FlexEntityTypeDeleteFieldInput;
	FlexEntityTypeDeleteInput: FlexEntityTypeDeleteInput;
	FlexEntityTypeDisconnectFieldInput: FlexEntityTypeDisconnectFieldInput;
	FlexEntityTypeDisconnectInput: FlexEntityTypeDisconnectInput;
	FlexEntityTypeFieldInput: FlexEntityTypeFieldInput;
	FlexEntityTypeInstancesAggregateInput: FlexEntityTypeInstancesAggregateInput;
	FlexEntityTypeInstancesConnectFieldInput: FlexEntityTypeInstancesConnectFieldInput;
	FlexEntityTypeInstancesConnection: FlexEntityTypeInstancesConnection;
	FlexEntityTypeInstancesConnectionSort: FlexEntityTypeInstancesConnectionSort;
	FlexEntityTypeInstancesConnectionWhere: FlexEntityTypeInstancesConnectionWhere;
	FlexEntityTypeInstancesCreateFieldInput: FlexEntityTypeInstancesCreateFieldInput;
	FlexEntityTypeInstancesDeleteFieldInput: FlexEntityTypeInstancesDeleteFieldInput;
	FlexEntityTypeInstancesDisconnectFieldInput: FlexEntityTypeInstancesDisconnectFieldInput;
	FlexEntityTypeInstancesFieldInput: FlexEntityTypeInstancesFieldInput;
	FlexEntityTypeInstancesNodeAggregationWhereInput: FlexEntityTypeInstancesNodeAggregationWhereInput;
	FlexEntityTypeInstancesRelationship: FlexEntityTypeInstancesRelationship;
	FlexEntityTypeInstancesUpdateConnectionInput: FlexEntityTypeInstancesUpdateConnectionInput;
	FlexEntityTypeInstancesUpdateFieldInput: FlexEntityTypeInstancesUpdateFieldInput;
	FlexEntityTypeNodeAggregationWhereInput: FlexEntityTypeNodeAggregationWhereInput;
	FlexEntityTypeOptions: FlexEntityTypeOptions;
	FlexEntityTypeRelationship: FlexEntityTypeRelationship;
	FlexEntityTypeSort: FlexEntityTypeSort;
	FlexEntityTypeUpdateConnectionInput: FlexEntityTypeUpdateConnectionInput;
	FlexEntityTypeUpdateFieldInput: FlexEntityTypeUpdateFieldInput;
	FlexEntityTypeUpdateInput: FlexEntityTypeUpdateInput;
	FlexEntityTypeWhere: FlexEntityTypeWhere;
	FlexEntityUpdateInput: FlexEntityUpdateInput;
	FlexEntityWhere: FlexEntityWhere;
	FlexFinancialDataPoint: FlexFinancialDataPoint;
	FlexFinancialDataPointAggregateSelection: FlexFinancialDataPointAggregateSelection;
	FlexFinancialDataPointAgreementAggregateInput: FlexFinancialDataPointAgreementAggregateInput;
	FlexFinancialDataPointAgreementConnectFieldInput: FlexFinancialDataPointAgreementConnectFieldInput;
	FlexFinancialDataPointAgreementConnection: FlexFinancialDataPointAgreementConnection;
	FlexFinancialDataPointAgreementConnectionSort: FlexFinancialDataPointAgreementConnectionSort;
	FlexFinancialDataPointAgreementConnectionWhere: FlexFinancialDataPointAgreementConnectionWhere;
	FlexFinancialDataPointAgreementCreateFieldInput: FlexFinancialDataPointAgreementCreateFieldInput;
	FlexFinancialDataPointAgreementDeleteFieldInput: FlexFinancialDataPointAgreementDeleteFieldInput;
	FlexFinancialDataPointAgreementDisconnectFieldInput: FlexFinancialDataPointAgreementDisconnectFieldInput;
	FlexFinancialDataPointAgreementFieldInput: FlexFinancialDataPointAgreementFieldInput;
	FlexFinancialDataPointAgreementNodeAggregationWhereInput: FlexFinancialDataPointAgreementNodeAggregationWhereInput;
	FlexFinancialDataPointAgreementRelationship: FlexFinancialDataPointAgreementRelationship;
	FlexFinancialDataPointAgreementUpdateConnectionInput: FlexFinancialDataPointAgreementUpdateConnectionInput;
	FlexFinancialDataPointAgreementUpdateFieldInput: FlexFinancialDataPointAgreementUpdateFieldInput;
	FlexFinancialDataPointConnectInput: FlexFinancialDataPointConnectInput;
	FlexFinancialDataPointConnectWhere: FlexFinancialDataPointConnectWhere;
	FlexFinancialDataPointCreateInput: FlexFinancialDataPointCreateInput;
	FlexFinancialDataPointDeleteInput: FlexFinancialDataPointDeleteInput;
	FlexFinancialDataPointDisconnectInput: FlexFinancialDataPointDisconnectInput;
	FlexFinancialDataPointEvaluatesAggregateInput: FlexFinancialDataPointEvaluatesAggregateInput;
	FlexFinancialDataPointEvaluatesConnectFieldInput: FlexFinancialDataPointEvaluatesConnectFieldInput;
	FlexFinancialDataPointEvaluatesConnection: FlexFinancialDataPointEvaluatesConnection;
	FlexFinancialDataPointEvaluatesConnectionSort: FlexFinancialDataPointEvaluatesConnectionSort;
	FlexFinancialDataPointEvaluatesConnectionWhere: FlexFinancialDataPointEvaluatesConnectionWhere;
	FlexFinancialDataPointEvaluatesCreateFieldInput: FlexFinancialDataPointEvaluatesCreateFieldInput;
	FlexFinancialDataPointEvaluatesDeleteFieldInput: FlexFinancialDataPointEvaluatesDeleteFieldInput;
	FlexFinancialDataPointEvaluatesDisconnectFieldInput: FlexFinancialDataPointEvaluatesDisconnectFieldInput;
	FlexFinancialDataPointEvaluatesFieldInput: FlexFinancialDataPointEvaluatesFieldInput;
	FlexFinancialDataPointEvaluatesNodeAggregationWhereInput: FlexFinancialDataPointEvaluatesNodeAggregationWhereInput;
	FlexFinancialDataPointEvaluatesRelationship: FlexFinancialDataPointEvaluatesRelationship;
	FlexFinancialDataPointEvaluatesUpdateConnectionInput: FlexFinancialDataPointEvaluatesUpdateConnectionInput;
	FlexFinancialDataPointEvaluatesUpdateFieldInput: FlexFinancialDataPointEvaluatesUpdateFieldInput;
	FlexFinancialDataPointIncludedInAggregateInput: FlexFinancialDataPointIncludedInAggregateInput;
	FlexFinancialDataPointIncludedInConnectFieldInput: FlexFinancialDataPointIncludedInConnectFieldInput;
	FlexFinancialDataPointIncludedInConnection: FlexFinancialDataPointIncludedInConnection;
	FlexFinancialDataPointIncludedInConnectionSort: FlexFinancialDataPointIncludedInConnectionSort;
	FlexFinancialDataPointIncludedInConnectionWhere: FlexFinancialDataPointIncludedInConnectionWhere;
	FlexFinancialDataPointIncludedInCreateFieldInput: FlexFinancialDataPointIncludedInCreateFieldInput;
	FlexFinancialDataPointIncludedInDeleteFieldInput: FlexFinancialDataPointIncludedInDeleteFieldInput;
	FlexFinancialDataPointIncludedInDisconnectFieldInput: FlexFinancialDataPointIncludedInDisconnectFieldInput;
	FlexFinancialDataPointIncludedInFieldInput: FlexFinancialDataPointIncludedInFieldInput;
	FlexFinancialDataPointIncludedInNodeAggregationWhereInput: FlexFinancialDataPointIncludedInNodeAggregationWhereInput;
	FlexFinancialDataPointIncludedInRelationship: FlexFinancialDataPointIncludedInRelationship;
	FlexFinancialDataPointIncludedInUpdateConnectionInput: FlexFinancialDataPointIncludedInUpdateConnectionInput;
	FlexFinancialDataPointIncludedInUpdateFieldInput: FlexFinancialDataPointIncludedInUpdateFieldInput;
	FlexFinancialDataPointOptions: FlexFinancialDataPointOptions;
	FlexFinancialDataPointSort: FlexFinancialDataPointSort;
	FlexFinancialDataPointSourceRefundAggregateInput: FlexFinancialDataPointSourceRefundAggregateInput;
	FlexFinancialDataPointSourceRefundConnectFieldInput: FlexFinancialDataPointSourceRefundConnectFieldInput;
	FlexFinancialDataPointSourceRefundConnection: FlexFinancialDataPointSourceRefundConnection;
	FlexFinancialDataPointSourceRefundConnectionSort: FlexFinancialDataPointSourceRefundConnectionSort;
	FlexFinancialDataPointSourceRefundConnectionWhere: FlexFinancialDataPointSourceRefundConnectionWhere;
	FlexFinancialDataPointSourceRefundCreateFieldInput: FlexFinancialDataPointSourceRefundCreateFieldInput;
	FlexFinancialDataPointSourceRefundDeleteFieldInput: FlexFinancialDataPointSourceRefundDeleteFieldInput;
	FlexFinancialDataPointSourceRefundDisconnectFieldInput: FlexFinancialDataPointSourceRefundDisconnectFieldInput;
	FlexFinancialDataPointSourceRefundFieldInput: FlexFinancialDataPointSourceRefundFieldInput;
	FlexFinancialDataPointSourceRefundNodeAggregationWhereInput: FlexFinancialDataPointSourceRefundNodeAggregationWhereInput;
	FlexFinancialDataPointSourceRefundRelationship: FlexFinancialDataPointSourceRefundRelationship;
	FlexFinancialDataPointSourceRefundUpdateConnectionInput: FlexFinancialDataPointSourceRefundUpdateConnectionInput;
	FlexFinancialDataPointSourceRefundUpdateFieldInput: FlexFinancialDataPointSourceRefundUpdateFieldInput;
	FlexFinancialDataPointStartingPointAggregateInput: FlexFinancialDataPointStartingPointAggregateInput;
	FlexFinancialDataPointStartingPointConnectFieldInput: FlexFinancialDataPointStartingPointConnectFieldInput;
	FlexFinancialDataPointStartingPointConnection: FlexFinancialDataPointStartingPointConnection;
	FlexFinancialDataPointStartingPointConnectionSort: FlexFinancialDataPointStartingPointConnectionSort;
	FlexFinancialDataPointStartingPointConnectionWhere: FlexFinancialDataPointStartingPointConnectionWhere;
	FlexFinancialDataPointStartingPointCreateFieldInput: FlexFinancialDataPointStartingPointCreateFieldInput;
	FlexFinancialDataPointStartingPointDeleteFieldInput: FlexFinancialDataPointStartingPointDeleteFieldInput;
	FlexFinancialDataPointStartingPointDisconnectFieldInput: FlexFinancialDataPointStartingPointDisconnectFieldInput;
	FlexFinancialDataPointStartingPointFieldInput: FlexFinancialDataPointStartingPointFieldInput;
	FlexFinancialDataPointStartingPointNodeAggregationWhereInput: FlexFinancialDataPointStartingPointNodeAggregationWhereInput;
	FlexFinancialDataPointStartingPointRelationship: FlexFinancialDataPointStartingPointRelationship;
	FlexFinancialDataPointStartingPointUpdateConnectionInput: FlexFinancialDataPointStartingPointUpdateConnectionInput;
	FlexFinancialDataPointStartingPointUpdateFieldInput: FlexFinancialDataPointStartingPointUpdateFieldInput;
	FlexFinancialDataPointTreatmentAggregateInput: FlexFinancialDataPointTreatmentAggregateInput;
	FlexFinancialDataPointTreatmentConnectFieldInput: FlexFinancialDataPointTreatmentConnectFieldInput;
	FlexFinancialDataPointTreatmentConnection: FlexFinancialDataPointTreatmentConnection;
	FlexFinancialDataPointTreatmentConnectionSort: FlexFinancialDataPointTreatmentConnectionSort;
	FlexFinancialDataPointTreatmentConnectionWhere: FlexFinancialDataPointTreatmentConnectionWhere;
	FlexFinancialDataPointTreatmentCreateFieldInput: FlexFinancialDataPointTreatmentCreateFieldInput;
	FlexFinancialDataPointTreatmentDeleteFieldInput: FlexFinancialDataPointTreatmentDeleteFieldInput;
	FlexFinancialDataPointTreatmentDisconnectFieldInput: FlexFinancialDataPointTreatmentDisconnectFieldInput;
	FlexFinancialDataPointTreatmentFieldInput: FlexFinancialDataPointTreatmentFieldInput;
	FlexFinancialDataPointTreatmentNodeAggregationWhereInput: FlexFinancialDataPointTreatmentNodeAggregationWhereInput;
	FlexFinancialDataPointTreatmentRelationship: FlexFinancialDataPointTreatmentRelationship;
	FlexFinancialDataPointTreatmentUpdateConnectionInput: FlexFinancialDataPointTreatmentUpdateConnectionInput;
	FlexFinancialDataPointTreatmentUpdateFieldInput: FlexFinancialDataPointTreatmentUpdateFieldInput;
	FlexFinancialDataPointUpdateInput: FlexFinancialDataPointUpdateInput;
	FlexFinancialDataPointWhere: FlexFinancialDataPointWhere;
	Float: Scalars["Float"];
	FloatAggregateSelection: FloatAggregateSelection;
	Form: Form;
	FormAggregateSelection: FormAggregateSelection;
	FormConnectInput: FormConnectInput;
	FormConnectWhere: FormConnectWhere;
	FormContinuousBenefitAggregateInput: FormContinuousBenefitAggregateInput;
	FormContinuousBenefitConnectFieldInput: FormContinuousBenefitConnectFieldInput;
	FormContinuousBenefitConnection: FormContinuousBenefitConnection;
	FormContinuousBenefitConnectionSort: FormContinuousBenefitConnectionSort;
	FormContinuousBenefitConnectionWhere: FormContinuousBenefitConnectionWhere;
	FormContinuousBenefitCreateFieldInput: FormContinuousBenefitCreateFieldInput;
	FormContinuousBenefitDeleteFieldInput: FormContinuousBenefitDeleteFieldInput;
	FormContinuousBenefitDisconnectFieldInput: FormContinuousBenefitDisconnectFieldInput;
	FormContinuousBenefitFieldInput: FormContinuousBenefitFieldInput;
	FormContinuousBenefitNodeAggregationWhereInput: FormContinuousBenefitNodeAggregationWhereInput;
	FormContinuousBenefitRelationship: FormContinuousBenefitRelationship;
	FormContinuousBenefitUpdateConnectionInput: FormContinuousBenefitUpdateConnectionInput;
	FormContinuousBenefitUpdateFieldInput: FormContinuousBenefitUpdateFieldInput;
	FormCoverageRequestAggregateInput: FormCoverageRequestAggregateInput;
	FormCoverageRequestConnectFieldInput: FormCoverageRequestConnectFieldInput;
	FormCoverageRequestConnection: FormCoverageRequestConnection;
	FormCoverageRequestConnectionSort: FormCoverageRequestConnectionSort;
	FormCoverageRequestConnectionWhere: FormCoverageRequestConnectionWhere;
	FormCoverageRequestCreateFieldInput: FormCoverageRequestCreateFieldInput;
	FormCoverageRequestDeleteFieldInput: FormCoverageRequestDeleteFieldInput;
	FormCoverageRequestDisconnectFieldInput: FormCoverageRequestDisconnectFieldInput;
	FormCoverageRequestFieldInput: FormCoverageRequestFieldInput;
	FormCoverageRequestNodeAggregationWhereInput: FormCoverageRequestNodeAggregationWhereInput;
	FormCoverageRequestRelationship: FormCoverageRequestRelationship;
	FormCoverageRequestUpdateConnectionInput: FormCoverageRequestUpdateConnectionInput;
	FormCoverageRequestUpdateFieldInput: FormCoverageRequestUpdateFieldInput;
	FormCreateInput: FormCreateInput;
	FormDeleteInput: FormDeleteInput;
	FormDisconnectInput: FormDisconnectInput;
	FormDiscontinuationNoteAggregateInput: FormDiscontinuationNoteAggregateInput;
	FormDiscontinuationNoteConnectFieldInput: FormDiscontinuationNoteConnectFieldInput;
	FormDiscontinuationNoteConnection: FormDiscontinuationNoteConnection;
	FormDiscontinuationNoteConnectionSort: FormDiscontinuationNoteConnectionSort;
	FormDiscontinuationNoteConnectionWhere: FormDiscontinuationNoteConnectionWhere;
	FormDiscontinuationNoteCreateFieldInput: FormDiscontinuationNoteCreateFieldInput;
	FormDiscontinuationNoteDeleteFieldInput: FormDiscontinuationNoteDeleteFieldInput;
	FormDiscontinuationNoteDisconnectFieldInput: FormDiscontinuationNoteDisconnectFieldInput;
	FormDiscontinuationNoteFieldInput: FormDiscontinuationNoteFieldInput;
	FormDiscontinuationNoteNodeAggregationWhereInput: FormDiscontinuationNoteNodeAggregationWhereInput;
	FormDiscontinuationNoteRelationship: FormDiscontinuationNoteRelationship;
	FormDiscontinuationNoteUpdateConnectionInput: FormDiscontinuationNoteUpdateConnectionInput;
	FormDiscontinuationNoteUpdateFieldInput: FormDiscontinuationNoteUpdateFieldInput;
	FormInitialResponseAggregateInput: FormInitialResponseAggregateInput;
	FormInitialResponseConnectFieldInput: FormInitialResponseConnectFieldInput;
	FormInitialResponseConnection: FormInitialResponseConnection;
	FormInitialResponseConnectionSort: FormInitialResponseConnectionSort;
	FormInitialResponseConnectionWhere: FormInitialResponseConnectionWhere;
	FormInitialResponseCreateFieldInput: FormInitialResponseCreateFieldInput;
	FormInitialResponseDeleteFieldInput: FormInitialResponseDeleteFieldInput;
	FormInitialResponseDisconnectFieldInput: FormInitialResponseDisconnectFieldInput;
	FormInitialResponseFieldInput: FormInitialResponseFieldInput;
	FormInitialResponseNodeAggregationWhereInput: FormInitialResponseNodeAggregationWhereInput;
	FormInitialResponseRelationship: FormInitialResponseRelationship;
	FormInitialResponseUpdateConnectionInput: FormInitialResponseUpdateConnectionInput;
	FormInitialResponseUpdateFieldInput: FormInitialResponseUpdateFieldInput;
	FormOptions: FormOptions;
	FormPrimaryInterventionAggregateInput: FormPrimaryInterventionAggregateInput;
	FormPrimaryInterventionConnectFieldInput: FormPrimaryInterventionConnectFieldInput;
	FormPrimaryInterventionConnection: FormPrimaryInterventionConnection;
	FormPrimaryInterventionConnectionSort: FormPrimaryInterventionConnectionSort;
	FormPrimaryInterventionConnectionWhere: FormPrimaryInterventionConnectionWhere;
	FormPrimaryInterventionCreateFieldInput: FormPrimaryInterventionCreateFieldInput;
	FormPrimaryInterventionDeleteFieldInput: FormPrimaryInterventionDeleteFieldInput;
	FormPrimaryInterventionDisconnectFieldInput: FormPrimaryInterventionDisconnectFieldInput;
	FormPrimaryInterventionFieldInput: FormPrimaryInterventionFieldInput;
	FormPrimaryInterventionNodeAggregationWhereInput: FormPrimaryInterventionNodeAggregationWhereInput;
	FormPrimaryInterventionRelationship: FormPrimaryInterventionRelationship;
	FormPrimaryInterventionUpdateConnectionInput: FormPrimaryInterventionUpdateConnectionInput;
	FormPrimaryInterventionUpdateFieldInput: FormPrimaryInterventionUpdateFieldInput;
	FormSort: FormSort;
	FormSubsequentInterventionAggregateInput: FormSubsequentInterventionAggregateInput;
	FormSubsequentInterventionConnectFieldInput: FormSubsequentInterventionConnectFieldInput;
	FormSubsequentInterventionConnection: FormSubsequentInterventionConnection;
	FormSubsequentInterventionConnectionSort: FormSubsequentInterventionConnectionSort;
	FormSubsequentInterventionConnectionWhere: FormSubsequentInterventionConnectionWhere;
	FormSubsequentInterventionCreateFieldInput: FormSubsequentInterventionCreateFieldInput;
	FormSubsequentInterventionDeleteFieldInput: FormSubsequentInterventionDeleteFieldInput;
	FormSubsequentInterventionDisconnectFieldInput: FormSubsequentInterventionDisconnectFieldInput;
	FormSubsequentInterventionFieldInput: FormSubsequentInterventionFieldInput;
	FormSubsequentInterventionNodeAggregationWhereInput: FormSubsequentInterventionNodeAggregationWhereInput;
	FormSubsequentInterventionRelationship: FormSubsequentInterventionRelationship;
	FormSubsequentInterventionUpdateConnectionInput: FormSubsequentInterventionUpdateConnectionInput;
	FormSubsequentInterventionUpdateFieldInput: FormSubsequentInterventionUpdateFieldInput;
	FormUpdateInput: FormUpdateInput;
	FormWhere: FormWhere;
	GQLBaseResponse: ResolversParentTypes["InterventionReportStatusResponse"];
	ID: Scalars["ID"];
	IDAggregateSelection: IdAggregateSelection;
	IOrdered:
		| ResolversParentTypes["RecommendedForm"]
		| ResolversParentTypes["StobAction"]
		| ResolversParentTypes["StobCondition"]
		| ResolversParentTypes["StobScenario"];
	ITimeframe: ResolversParentTypes["ScenarioAction"] | ResolversParentTypes["ScenarioCondition"];
	ITreatmentState:
		| ResolversParentTypes["ContinuousBenefit"]
		| ResolversParentTypes["DiscontinuationNote"]
		| ResolversParentTypes["InitialResponse"];
	Indication: Indication;
	IndicationAggregateSelection: IndicationAggregateSelection;
	IndicationConnectWhere: IndicationConnectWhere;
	IndicationCreateInput: IndicationCreateInput;
	IndicationOptions: IndicationOptions;
	IndicationSort: IndicationSort;
	IndicationUpdateInput: IndicationUpdateInput;
	IndicationWhere: IndicationWhere;
	InitialResponse: InitialResponse;
	InitialResponseAdverseEventsAggregateInput: InitialResponseAdverseEventsAggregateInput;
	InitialResponseAdverseEventsConnectFieldInput: InitialResponseAdverseEventsConnectFieldInput;
	InitialResponseAdverseEventsConnection: InitialResponseAdverseEventsConnection;
	InitialResponseAdverseEventsConnectionSort: InitialResponseAdverseEventsConnectionSort;
	InitialResponseAdverseEventsConnectionWhere: InitialResponseAdverseEventsConnectionWhere;
	InitialResponseAdverseEventsCreateFieldInput: InitialResponseAdverseEventsCreateFieldInput;
	InitialResponseAdverseEventsDeleteFieldInput: InitialResponseAdverseEventsDeleteFieldInput;
	InitialResponseAdverseEventsDisconnectFieldInput: InitialResponseAdverseEventsDisconnectFieldInput;
	InitialResponseAdverseEventsFieldInput: InitialResponseAdverseEventsFieldInput;
	InitialResponseAdverseEventsNodeAggregationWhereInput: InitialResponseAdverseEventsNodeAggregationWhereInput;
	InitialResponseAdverseEventsRelationship: InitialResponseAdverseEventsRelationship;
	InitialResponseAdverseEventsUpdateConnectionInput: InitialResponseAdverseEventsUpdateConnectionInput;
	InitialResponseAdverseEventsUpdateFieldInput: InitialResponseAdverseEventsUpdateFieldInput;
	InitialResponseAggregateSelection: InitialResponseAggregateSelection;
	InitialResponseConnectInput: InitialResponseConnectInput;
	InitialResponseConnectWhere: InitialResponseConnectWhere;
	InitialResponseContinuousBenefitAggregateInput: InitialResponseContinuousBenefitAggregateInput;
	InitialResponseContinuousBenefitConnectFieldInput: InitialResponseContinuousBenefitConnectFieldInput;
	InitialResponseContinuousBenefitConnection: InitialResponseContinuousBenefitConnection;
	InitialResponseContinuousBenefitConnectionSort: InitialResponseContinuousBenefitConnectionSort;
	InitialResponseContinuousBenefitConnectionWhere: InitialResponseContinuousBenefitConnectionWhere;
	InitialResponseContinuousBenefitCreateFieldInput: InitialResponseContinuousBenefitCreateFieldInput;
	InitialResponseContinuousBenefitDeleteFieldInput: InitialResponseContinuousBenefitDeleteFieldInput;
	InitialResponseContinuousBenefitDisconnectFieldInput: InitialResponseContinuousBenefitDisconnectFieldInput;
	InitialResponseContinuousBenefitFieldInput: InitialResponseContinuousBenefitFieldInput;
	InitialResponseContinuousBenefitNodeAggregationWhereInput: InitialResponseContinuousBenefitNodeAggregationWhereInput;
	InitialResponseContinuousBenefitRelationship: InitialResponseContinuousBenefitRelationship;
	InitialResponseContinuousBenefitUpdateConnectionInput: InitialResponseContinuousBenefitUpdateConnectionInput;
	InitialResponseContinuousBenefitUpdateFieldInput: InitialResponseContinuousBenefitUpdateFieldInput;
	InitialResponseCoverageRequestAggregateInput: InitialResponseCoverageRequestAggregateInput;
	InitialResponseCoverageRequestConnectFieldInput: InitialResponseCoverageRequestConnectFieldInput;
	InitialResponseCoverageRequestConnection: InitialResponseCoverageRequestConnection;
	InitialResponseCoverageRequestConnectionSort: InitialResponseCoverageRequestConnectionSort;
	InitialResponseCoverageRequestConnectionWhere: InitialResponseCoverageRequestConnectionWhere;
	InitialResponseCoverageRequestCreateFieldInput: InitialResponseCoverageRequestCreateFieldInput;
	InitialResponseCoverageRequestDeleteFieldInput: InitialResponseCoverageRequestDeleteFieldInput;
	InitialResponseCoverageRequestDisconnectFieldInput: InitialResponseCoverageRequestDisconnectFieldInput;
	InitialResponseCoverageRequestFieldInput: InitialResponseCoverageRequestFieldInput;
	InitialResponseCoverageRequestNodeAggregationWhereInput: InitialResponseCoverageRequestNodeAggregationWhereInput;
	InitialResponseCoverageRequestRelationship: InitialResponseCoverageRequestRelationship;
	InitialResponseCoverageRequestUpdateConnectionInput: InitialResponseCoverageRequestUpdateConnectionInput;
	InitialResponseCoverageRequestUpdateFieldInput: InitialResponseCoverageRequestUpdateFieldInput;
	InitialResponseCreateInput: InitialResponseCreateInput;
	InitialResponseDeleteInput: InitialResponseDeleteInput;
	InitialResponseDisconnectInput: InitialResponseDisconnectInput;
	InitialResponseFormAggregateInput: InitialResponseFormAggregateInput;
	InitialResponseFormConnectFieldInput: InitialResponseFormConnectFieldInput;
	InitialResponseFormConnection: InitialResponseFormConnection;
	InitialResponseFormConnectionSort: InitialResponseFormConnectionSort;
	InitialResponseFormConnectionWhere: InitialResponseFormConnectionWhere;
	InitialResponseFormCreateFieldInput: InitialResponseFormCreateFieldInput;
	InitialResponseFormDeleteFieldInput: InitialResponseFormDeleteFieldInput;
	InitialResponseFormDisconnectFieldInput: InitialResponseFormDisconnectFieldInput;
	InitialResponseFormFieldInput: InitialResponseFormFieldInput;
	InitialResponseFormNodeAggregationWhereInput: InitialResponseFormNodeAggregationWhereInput;
	InitialResponseFormRelationship: InitialResponseFormRelationship;
	InitialResponseFormUpdateConnectionInput: InitialResponseFormUpdateConnectionInput;
	InitialResponseFormUpdateFieldInput: InitialResponseFormUpdateFieldInput;
	InitialResponseInput: InitialResponseInput;
	InitialResponseOptions: InitialResponseOptions;
	InitialResponseReviewReport: InitialResponseReviewReport;
	InitialResponseReviewReportAggregateSelection: InitialResponseReviewReportAggregateSelection;
	InitialResponseReviewReportCreateInput: InitialResponseReviewReportCreateInput;
	InitialResponseReviewReportOptions: InitialResponseReviewReportOptions;
	InitialResponseReviewReportSort: InitialResponseReviewReportSort;
	InitialResponseReviewReportUpdateInput: InitialResponseReviewReportUpdateInput;
	InitialResponseReviewReportWhere: InitialResponseReviewReportWhere;
	InitialResponseSort: InitialResponseSort;
	InitialResponseTreatingPhysicianAggregateInput: InitialResponseTreatingPhysicianAggregateInput;
	InitialResponseTreatingPhysicianConnectFieldInput: InitialResponseTreatingPhysicianConnectFieldInput;
	InitialResponseTreatingPhysicianConnection: InitialResponseTreatingPhysicianConnection;
	InitialResponseTreatingPhysicianConnectionSort: InitialResponseTreatingPhysicianConnectionSort;
	InitialResponseTreatingPhysicianConnectionWhere: InitialResponseTreatingPhysicianConnectionWhere;
	InitialResponseTreatingPhysicianCreateFieldInput: InitialResponseTreatingPhysicianCreateFieldInput;
	InitialResponseTreatingPhysicianDeleteFieldInput: InitialResponseTreatingPhysicianDeleteFieldInput;
	InitialResponseTreatingPhysicianDisconnectFieldInput: InitialResponseTreatingPhysicianDisconnectFieldInput;
	InitialResponseTreatingPhysicianFieldInput: InitialResponseTreatingPhysicianFieldInput;
	InitialResponseTreatingPhysicianNodeAggregationWhereInput: InitialResponseTreatingPhysicianNodeAggregationWhereInput;
	InitialResponseTreatingPhysicianRelationship: InitialResponseTreatingPhysicianRelationship;
	InitialResponseTreatingPhysicianUpdateConnectionInput: InitialResponseTreatingPhysicianUpdateConnectionInput;
	InitialResponseTreatingPhysicianUpdateFieldInput: InitialResponseTreatingPhysicianUpdateFieldInput;
	InitialResponseUpdateInput: InitialResponseUpdateInput;
	InitialResponseWhere: InitialResponseWhere;
	Int: Scalars["Int"];
	IntAggregateSelection: IntAggregateSelection;
	Intervention: Intervention;
	InterventionAggregateSelection: InterventionAggregateSelection;
	InterventionCaseAggregateInput: InterventionCaseAggregateInput;
	InterventionCaseConnectFieldInput: InterventionCaseConnectFieldInput;
	InterventionCaseConnection: InterventionCaseConnection;
	InterventionCaseConnectionSort: InterventionCaseConnectionSort;
	InterventionCaseConnectionWhere: InterventionCaseConnectionWhere;
	InterventionCaseCreateFieldInput: InterventionCaseCreateFieldInput;
	InterventionCaseDeleteFieldInput: InterventionCaseDeleteFieldInput;
	InterventionCaseDisconnectFieldInput: InterventionCaseDisconnectFieldInput;
	InterventionCaseFieldInput: InterventionCaseFieldInput;
	InterventionCaseNodeAggregationWhereInput: InterventionCaseNodeAggregationWhereInput;
	InterventionCaseRelationship: InterventionCaseRelationship;
	InterventionConnectInput: InterventionConnectInput;
	InterventionConnectWhere: InterventionConnectWhere;
	InterventionCreateInput: InterventionCreateInput;
	InterventionCreatedByAggregateInput: InterventionCreatedByAggregateInput;
	InterventionCreatedByConnectFieldInput: InterventionCreatedByConnectFieldInput;
	InterventionCreatedByConnection: InterventionCreatedByConnection;
	InterventionCreatedByConnectionSort: InterventionCreatedByConnectionSort;
	InterventionCreatedByConnectionWhere: InterventionCreatedByConnectionWhere;
	InterventionCreatedByCreateFieldInput: InterventionCreatedByCreateFieldInput;
	InterventionCreatedByDeleteFieldInput: InterventionCreatedByDeleteFieldInput;
	InterventionCreatedByDisconnectFieldInput: InterventionCreatedByDisconnectFieldInput;
	InterventionCreatedByFieldInput: InterventionCreatedByFieldInput;
	InterventionCreatedByNodeAggregationWhereInput: InterventionCreatedByNodeAggregationWhereInput;
	InterventionCreatedByRelationship: InterventionCreatedByRelationship;
	InterventionDeleteInput: InterventionDeleteInput;
	InterventionDisconnectInput: InterventionDisconnectInput;
	InterventionDiseaseAggregateInput: InterventionDiseaseAggregateInput;
	InterventionDiseaseConnectFieldInput: InterventionDiseaseConnectFieldInput;
	InterventionDiseaseConnection: InterventionDiseaseConnection;
	InterventionDiseaseConnectionSort: InterventionDiseaseConnectionSort;
	InterventionDiseaseConnectionWhere: InterventionDiseaseConnectionWhere;
	InterventionDiseaseCreateFieldInput: InterventionDiseaseCreateFieldInput;
	InterventionDiseaseDeleteFieldInput: InterventionDiseaseDeleteFieldInput;
	InterventionDiseaseDisconnectFieldInput: InterventionDiseaseDisconnectFieldInput;
	InterventionDiseaseFieldInput: InterventionDiseaseFieldInput;
	InterventionDiseaseNodeAggregationWhereInput: InterventionDiseaseNodeAggregationWhereInput;
	InterventionDiseaseRelationship: InterventionDiseaseRelationship;
	InterventionFinancialDataPointsAggregateInput: InterventionFinancialDataPointsAggregateInput;
	InterventionFinancialDataPointsConnectFieldInput: InterventionFinancialDataPointsConnectFieldInput;
	InterventionFinancialDataPointsConnection: InterventionFinancialDataPointsConnection;
	InterventionFinancialDataPointsConnectionSort: InterventionFinancialDataPointsConnectionSort;
	InterventionFinancialDataPointsConnectionWhere: InterventionFinancialDataPointsConnectionWhere;
	InterventionFinancialDataPointsCreateFieldInput: InterventionFinancialDataPointsCreateFieldInput;
	InterventionFinancialDataPointsDeleteFieldInput: InterventionFinancialDataPointsDeleteFieldInput;
	InterventionFinancialDataPointsDisconnectFieldInput: InterventionFinancialDataPointsDisconnectFieldInput;
	InterventionFinancialDataPointsFieldInput: InterventionFinancialDataPointsFieldInput;
	InterventionFinancialDataPointsNodeAggregationWhereInput: InterventionFinancialDataPointsNodeAggregationWhereInput;
	InterventionFinancialDataPointsRelationship: InterventionFinancialDataPointsRelationship;
	InterventionFormAggregateInput: InterventionFormAggregateInput;
	InterventionFormConnectFieldInput: InterventionFormConnectFieldInput;
	InterventionFormConnection: InterventionFormConnection;
	InterventionFormConnectionSort: InterventionFormConnectionSort;
	InterventionFormConnectionWhere: InterventionFormConnectionWhere;
	InterventionFormCreateFieldInput: InterventionFormCreateFieldInput;
	InterventionFormDeleteFieldInput: InterventionFormDeleteFieldInput;
	InterventionFormDisconnectFieldInput: InterventionFormDisconnectFieldInput;
	InterventionFormFieldInput: InterventionFormFieldInput;
	InterventionFormNodeAggregationWhereInput: InterventionFormNodeAggregationWhereInput;
	InterventionFormRelationship: InterventionFormRelationship;
	InterventionInput: InterventionInput;
	InterventionItemInput: InterventionItemInput;
	InterventionLegalEntityAggregateInput: InterventionLegalEntityAggregateInput;
	InterventionLegalEntityConnectFieldInput: InterventionLegalEntityConnectFieldInput;
	InterventionLegalEntityConnection: InterventionLegalEntityConnection;
	InterventionLegalEntityConnectionSort: InterventionLegalEntityConnectionSort;
	InterventionLegalEntityConnectionWhere: InterventionLegalEntityConnectionWhere;
	InterventionLegalEntityCreateFieldInput: InterventionLegalEntityCreateFieldInput;
	InterventionLegalEntityDeleteFieldInput: InterventionLegalEntityDeleteFieldInput;
	InterventionLegalEntityDisconnectFieldInput: InterventionLegalEntityDisconnectFieldInput;
	InterventionLegalEntityFieldInput: InterventionLegalEntityFieldInput;
	InterventionLegalEntityNodeAggregationWhereInput: InterventionLegalEntityNodeAggregationWhereInput;
	InterventionLegalEntityRelationship: InterventionLegalEntityRelationship;
	InterventionMainItemAggregateInput: InterventionMainItemAggregateInput;
	InterventionMainItemConnectFieldInput: InterventionMainItemConnectFieldInput;
	InterventionMainItemConnection: InterventionMainItemConnection;
	InterventionMainItemConnectionSort: InterventionMainItemConnectionSort;
	InterventionMainItemConnectionWhere: InterventionMainItemConnectionWhere;
	InterventionMainItemCreateFieldInput: InterventionMainItemCreateFieldInput;
	InterventionMainItemDeleteFieldInput: InterventionMainItemDeleteFieldInput;
	InterventionMainItemDisconnectFieldInput: InterventionMainItemDisconnectFieldInput;
	InterventionMainItemEdgeAggregationWhereInput: InterventionMainItemEdgeAggregationWhereInput;
	InterventionMainItemFieldInput: InterventionMainItemFieldInput;
	InterventionMainItemNodeAggregationWhereInput: InterventionMainItemNodeAggregationWhereInput;
	InterventionMainItemRelationship: InterventionMainItemRelationship;
	InterventionOptions: InterventionOptions;
	InterventionPatientAggregateInput: InterventionPatientAggregateInput;
	InterventionPatientConnectFieldInput: InterventionPatientConnectFieldInput;
	InterventionPatientConnection: InterventionPatientConnection;
	InterventionPatientConnectionSort: InterventionPatientConnectionSort;
	InterventionPatientConnectionWhere: InterventionPatientConnectionWhere;
	InterventionPatientCreateFieldInput: InterventionPatientCreateFieldInput;
	InterventionPatientDeleteFieldInput: InterventionPatientDeleteFieldInput;
	InterventionPatientDisconnectFieldInput: InterventionPatientDisconnectFieldInput;
	InterventionPatientFieldInput: InterventionPatientFieldInput;
	InterventionPatientNodeAggregationWhereInput: InterventionPatientNodeAggregationWhereInput;
	InterventionPatientRelationship: InterventionPatientRelationship;
	InterventionReportStatusResponse: InterventionReportStatusResponse;
	InterventionReportStatusResponseAggregateSelection: InterventionReportStatusResponseAggregateSelection;
	InterventionReportStatusResponseOptions: InterventionReportStatusResponseOptions;
	InterventionReportStatusResponseSort: InterventionReportStatusResponseSort;
	InterventionReportStatusResponseWhere: InterventionReportStatusResponseWhere;
	InterventionReportStatusUpdateInput: InterventionReportStatusUpdateInput;
	InterventionSort: InterventionSort;
	InterventionSubsequentInterventionAggregateInput: InterventionSubsequentInterventionAggregateInput;
	InterventionSubsequentInterventionConnectFieldInput: InterventionSubsequentInterventionConnectFieldInput;
	InterventionSubsequentInterventionConnection: InterventionSubsequentInterventionConnection;
	InterventionSubsequentInterventionConnectionSort: InterventionSubsequentInterventionConnectionSort;
	InterventionSubsequentInterventionConnectionWhere: InterventionSubsequentInterventionConnectionWhere;
	InterventionSubsequentInterventionCreateFieldInput: InterventionSubsequentInterventionCreateFieldInput;
	InterventionSubsequentInterventionDeleteFieldInput: InterventionSubsequentInterventionDeleteFieldInput;
	InterventionSubsequentInterventionDisconnectFieldInput: InterventionSubsequentInterventionDisconnectFieldInput;
	InterventionSubsequentInterventionFieldInput: InterventionSubsequentInterventionFieldInput;
	InterventionSubsequentInterventionNodeAggregationWhereInput: InterventionSubsequentInterventionNodeAggregationWhereInput;
	InterventionSubsequentInterventionRelationship: InterventionSubsequentInterventionRelationship;
	InterventionSupportingItemAggregateInput: InterventionSupportingItemAggregateInput;
	InterventionSupportingItemConnectFieldInput: InterventionSupportingItemConnectFieldInput;
	InterventionSupportingItemConnection: InterventionSupportingItemConnection;
	InterventionSupportingItemConnectionSort: InterventionSupportingItemConnectionSort;
	InterventionSupportingItemConnectionWhere: InterventionSupportingItemConnectionWhere;
	InterventionSupportingItemCreateFieldInput: InterventionSupportingItemCreateFieldInput;
	InterventionSupportingItemDeleteFieldInput: InterventionSupportingItemDeleteFieldInput;
	InterventionSupportingItemDisconnectFieldInput: InterventionSupportingItemDisconnectFieldInput;
	InterventionSupportingItemEdgeAggregationWhereInput: InterventionSupportingItemEdgeAggregationWhereInput;
	InterventionSupportingItemFieldInput: InterventionSupportingItemFieldInput;
	InterventionSupportingItemNodeAggregationWhereInput: InterventionSupportingItemNodeAggregationWhereInput;
	InterventionSupportingItemRelationship: InterventionSupportingItemRelationship;
	InterventionTreatmentRelationship:
		| ResolversParentTypes["InterventionMainItemRelationship"]
		| ResolversParentTypes["InterventionSupportingItemRelationship"];
	InterventionTreatmentRelationshipCreateInput: InterventionTreatmentRelationshipCreateInput;
	InterventionTreatmentRelationshipSort: InterventionTreatmentRelationshipSort;
	InterventionTreatmentRelationshipWhere: InterventionTreatmentRelationshipWhere;
	InterventionUpdateInput: InterventionUpdateInput;
	InterventionWhere: InterventionWhere;
	InvoiceRefundFinancialDataPoint: ResolversParentTypes["RefundInvoiceFinancialDataPointsRelationship"];
	InvoiceRefundFinancialDataPointCreateInput: InvoiceRefundFinancialDataPointCreateInput;
	InvoiceRefundFinancialDataPointSort: InvoiceRefundFinancialDataPointSort;
	InvoiceRefundFinancialDataPointUpdateInput: InvoiceRefundFinancialDataPointUpdateInput;
	InvoiceRefundFinancialDataPointWhere: InvoiceRefundFinancialDataPointWhere;
	IssueInvoiceWithoutReviewInput: IssueInvoiceWithoutReviewInput;
	ItemUsedDataPoint: ItemUsedDataPoint;
	ItemUsedDataPointAggregateSelection: ItemUsedDataPointAggregateSelection;
	ItemUsedDataPointOptions: ItemUsedDataPointOptions;
	ItemUsedDataPointSort: ItemUsedDataPointSort;
	ItemUsedDataPointWhere: ItemUsedDataPointWhere;
	Limitation: Limitation;
	LimitationAggregateSelection: LimitationAggregateSelection;
	LimitationConnectInput: LimitationConnectInput;
	LimitationConnectWhere: LimitationConnectWhere;
	LimitationCreateInput: LimitationCreateInput;
	LimitationDeleteInput: LimitationDeleteInput;
	LimitationDisconnectInput: LimitationDisconnectInput;
	LimitationLimitsPreparationsAggregateInput: LimitationLimitsPreparationsAggregateInput;
	LimitationLimitsPreparationsConnectFieldInput: LimitationLimitsPreparationsConnectFieldInput;
	LimitationLimitsPreparationsConnection: LimitationLimitsPreparationsConnection;
	LimitationLimitsPreparationsConnectionSort: LimitationLimitsPreparationsConnectionSort;
	LimitationLimitsPreparationsConnectionWhere: LimitationLimitsPreparationsConnectionWhere;
	LimitationLimitsPreparationsCreateFieldInput: LimitationLimitsPreparationsCreateFieldInput;
	LimitationLimitsPreparationsDeleteFieldInput: LimitationLimitsPreparationsDeleteFieldInput;
	LimitationLimitsPreparationsDisconnectFieldInput: LimitationLimitsPreparationsDisconnectFieldInput;
	LimitationLimitsPreparationsFieldInput: LimitationLimitsPreparationsFieldInput;
	LimitationLimitsPreparationsNodeAggregationWhereInput: LimitationLimitsPreparationsNodeAggregationWhereInput;
	LimitationLimitsPreparationsRelationship: LimitationLimitsPreparationsRelationship;
	LimitationLimitsPreparationsUpdateConnectionInput: LimitationLimitsPreparationsUpdateConnectionInput;
	LimitationLimitsPreparationsUpdateFieldInput: LimitationLimitsPreparationsUpdateFieldInput;
	LimitationLimitsTreatmentAggregateInput: LimitationLimitsTreatmentAggregateInput;
	LimitationLimitsTreatmentConnectFieldInput: LimitationLimitsTreatmentConnectFieldInput;
	LimitationLimitsTreatmentConnection: LimitationLimitsTreatmentConnection;
	LimitationLimitsTreatmentConnectionSort: LimitationLimitsTreatmentConnectionSort;
	LimitationLimitsTreatmentConnectionWhere: LimitationLimitsTreatmentConnectionWhere;
	LimitationLimitsTreatmentCreateFieldInput: LimitationLimitsTreatmentCreateFieldInput;
	LimitationLimitsTreatmentDeleteFieldInput: LimitationLimitsTreatmentDeleteFieldInput;
	LimitationLimitsTreatmentDisconnectFieldInput: LimitationLimitsTreatmentDisconnectFieldInput;
	LimitationLimitsTreatmentFieldInput: LimitationLimitsTreatmentFieldInput;
	LimitationLimitsTreatmentNodeAggregationWhereInput: LimitationLimitsTreatmentNodeAggregationWhereInput;
	LimitationLimitsTreatmentRelationship: LimitationLimitsTreatmentRelationship;
	LimitationLimitsTreatmentUpdateConnectionInput: LimitationLimitsTreatmentUpdateConnectionInput;
	LimitationLimitsTreatmentUpdateFieldInput: LimitationLimitsTreatmentUpdateFieldInput;
	LimitationOptions: LimitationOptions;
	LimitationSort: LimitationSort;
	LimitationUpdateInput: LimitationUpdateInput;
	LimitationWhere: LimitationWhere;
	Message: Message;
	MessageAggregateSelection: MessageAggregateSelection;
	MessageConnectInput: MessageConnectInput;
	MessageConnectWhere: MessageConnectWhere;
	MessageCreateInput: MessageCreateInput;
	MessageDeleteInput: MessageDeleteInput;
	MessageDisconnectInput: MessageDisconnectInput;
	MessageMentionsAggregateInput: MessageMentionsAggregateInput;
	MessageMentionsConnectFieldInput: MessageMentionsConnectFieldInput;
	MessageMentionsConnection: MessageMentionsConnection;
	MessageMentionsConnectionSort: MessageMentionsConnectionSort;
	MessageMentionsConnectionWhere: MessageMentionsConnectionWhere;
	MessageMentionsCreateFieldInput: MessageMentionsCreateFieldInput;
	MessageMentionsDeleteFieldInput: MessageMentionsDeleteFieldInput;
	MessageMentionsDisconnectFieldInput: MessageMentionsDisconnectFieldInput;
	MessageMentionsFieldInput: MessageMentionsFieldInput;
	MessageMentionsNodeAggregationWhereInput: MessageMentionsNodeAggregationWhereInput;
	MessageMentionsRelationship: MessageMentionsRelationship;
	MessageMentionsUpdateConnectionInput: MessageMentionsUpdateConnectionInput;
	MessageMentionsUpdateFieldInput: MessageMentionsUpdateFieldInput;
	MessageOptions: MessageOptions;
	MessageRefundAggregateInput: MessageRefundAggregateInput;
	MessageRefundConnectFieldInput: MessageRefundConnectFieldInput;
	MessageRefundConnection: MessageRefundConnection;
	MessageRefundConnectionSort: MessageRefundConnectionSort;
	MessageRefundConnectionWhere: MessageRefundConnectionWhere;
	MessageRefundCreateFieldInput: MessageRefundCreateFieldInput;
	MessageRefundDeleteFieldInput: MessageRefundDeleteFieldInput;
	MessageRefundDisconnectFieldInput: MessageRefundDisconnectFieldInput;
	MessageRefundFieldInput: MessageRefundFieldInput;
	MessageRefundNodeAggregationWhereInput: MessageRefundNodeAggregationWhereInput;
	MessageRefundRelationship: MessageRefundRelationship;
	MessageRefundUpdateConnectionInput: MessageRefundUpdateConnectionInput;
	MessageRefundUpdateFieldInput: MessageRefundUpdateFieldInput;
	MessageSentByAggregateInput: MessageSentByAggregateInput;
	MessageSentByConnectFieldInput: MessageSentByConnectFieldInput;
	MessageSentByConnection: MessageSentByConnection;
	MessageSentByConnectionSort: MessageSentByConnectionSort;
	MessageSentByConnectionWhere: MessageSentByConnectionWhere;
	MessageSentByCreateFieldInput: MessageSentByCreateFieldInput;
	MessageSentByDeleteFieldInput: MessageSentByDeleteFieldInput;
	MessageSentByDisconnectFieldInput: MessageSentByDisconnectFieldInput;
	MessageSentByFieldInput: MessageSentByFieldInput;
	MessageSentByNodeAggregationWhereInput: MessageSentByNodeAggregationWhereInput;
	MessageSentByRelationship: MessageSentByRelationship;
	MessageSentByUpdateConnectionInput: MessageSentByUpdateConnectionInput;
	MessageSentByUpdateFieldInput: MessageSentByUpdateFieldInput;
	MessageSort: MessageSort;
	MessageUpdateInput: MessageUpdateInput;
	MessageWhere: MessageWhere;
	MicroContent: MicroContent;
	MicroContentAggregateSelection: MicroContentAggregateSelection;
	MicroContentOptions: MicroContentOptions;
	MicroContentSort: MicroContentSort;
	MicroContentWhere: MicroContentWhere;
	Module: Module;
	ModuleAggregateSelection: ModuleAggregateSelection;
	ModuleInput: ModuleInput;
	ModuleOptions: ModuleOptions;
	ModuleSort: ModuleSort;
	ModuleWhere: ModuleWhere;
	Mutation: {};
	NetRevenueByOrganization: NetRevenueByOrganization;
	NetRevenueByOrganizationAggregateSelection: NetRevenueByOrganizationAggregateSelection;
	NetRevenueByOrganizationOptions: NetRevenueByOrganizationOptions;
	NetRevenueByOrganizationSort: NetRevenueByOrganizationSort;
	NetRevenueByOrganizationWhere: NetRevenueByOrganizationWhere;
	Notification: Notification;
	NotificationAggregateSelection: NotificationAggregateSelection;
	NotificationConnectInput: NotificationConnectInput;
	NotificationConnectWhere: NotificationConnectWhere;
	NotificationCreateInput: NotificationCreateInput;
	NotificationDeleteInput: NotificationDeleteInput;
	NotificationDisconnectInput: NotificationDisconnectInput;
	NotificationDueAggregateInput: NotificationDueAggregateInput;
	NotificationDueConnectFieldInput: NotificationDueConnectFieldInput;
	NotificationDueConnection: NotificationDueConnection;
	NotificationDueConnectionSort: NotificationDueConnectionSort;
	NotificationDueConnectionWhere: NotificationDueConnectionWhere;
	NotificationDueCreateFieldInput: NotificationDueCreateFieldInput;
	NotificationDueDeleteFieldInput: NotificationDueDeleteFieldInput;
	NotificationDueDisconnectFieldInput: NotificationDueDisconnectFieldInput;
	NotificationDueEdgeAggregationWhereInput: NotificationDueEdgeAggregationWhereInput;
	NotificationDueFieldInput: NotificationDueFieldInput;
	NotificationDueNodeAggregationWhereInput: NotificationDueNodeAggregationWhereInput;
	NotificationDueRelationship: NotificationDueRelationship;
	NotificationDueUpdateConnectionInput: NotificationDueUpdateConnectionInput;
	NotificationDueUpdateFieldInput: NotificationDueUpdateFieldInput;
	NotificationNotifiedAggregateInput: NotificationNotifiedAggregateInput;
	NotificationNotifiedConnectFieldInput: NotificationNotifiedConnectFieldInput;
	NotificationNotifiedConnection: NotificationNotifiedConnection;
	NotificationNotifiedConnectionSort: NotificationNotifiedConnectionSort;
	NotificationNotifiedConnectionWhere: NotificationNotifiedConnectionWhere;
	NotificationNotifiedCreateFieldInput: NotificationNotifiedCreateFieldInput;
	NotificationNotifiedDeleteFieldInput: NotificationNotifiedDeleteFieldInput;
	NotificationNotifiedDisconnectFieldInput: NotificationNotifiedDisconnectFieldInput;
	NotificationNotifiedEdgeAggregationWhereInput: NotificationNotifiedEdgeAggregationWhereInput;
	NotificationNotifiedFieldInput: NotificationNotifiedFieldInput;
	NotificationNotifiedNodeAggregationWhereInput: NotificationNotifiedNodeAggregationWhereInput;
	NotificationNotifiedRelationship: NotificationNotifiedRelationship;
	NotificationNotifiedUpdateConnectionInput: NotificationNotifiedUpdateConnectionInput;
	NotificationNotifiedUpdateFieldInput: NotificationNotifiedUpdateFieldInput;
	NotificationOptions: NotificationOptions;
	NotificationSort: NotificationSort;
	NotificationSubscribedAggregateInput: NotificationSubscribedAggregateInput;
	NotificationSubscribedConnectFieldInput: NotificationSubscribedConnectFieldInput;
	NotificationSubscribedConnection: NotificationSubscribedConnection;
	NotificationSubscribedConnectionSort: NotificationSubscribedConnectionSort;
	NotificationSubscribedConnectionWhere: NotificationSubscribedConnectionWhere;
	NotificationSubscribedCreateFieldInput: NotificationSubscribedCreateFieldInput;
	NotificationSubscribedDeleteFieldInput: NotificationSubscribedDeleteFieldInput;
	NotificationSubscribedDisconnectFieldInput: NotificationSubscribedDisconnectFieldInput;
	NotificationSubscribedFieldInput: NotificationSubscribedFieldInput;
	NotificationSubscribedNodeAggregationWhereInput: NotificationSubscribedNodeAggregationWhereInput;
	NotificationSubscribedRelationship: NotificationSubscribedRelationship;
	NotificationSubscribedUpdateConnectionInput: NotificationSubscribedUpdateConnectionInput;
	NotificationSubscribedUpdateFieldInput: NotificationSubscribedUpdateFieldInput;
	NotificationTrigger: NotificationTrigger;
	NotificationTriggerAggregateSelection: NotificationTriggerAggregateSelection;
	NotificationTriggerConnectWhere: NotificationTriggerConnectWhere;
	NotificationTriggerCreateInput: NotificationTriggerCreateInput;
	NotificationTriggerInput: NotificationTriggerInput;
	NotificationTriggerOptions: NotificationTriggerOptions;
	NotificationTriggerSort: NotificationTriggerSort;
	NotificationTriggerUpdateInput: NotificationTriggerUpdateInput;
	NotificationTriggerWhere: NotificationTriggerWhere;
	NotificationUpdateInput: NotificationUpdateInput;
	NotificationWhere: NotificationWhere;
	Organization: Organization;
	OrganizationAggregateSelection: OrganizationAggregateSelection;
	OrganizationConnectWhere: OrganizationConnectWhere;
	OrganizationCreateInput: OrganizationCreateInput;
	OrganizationInput: OrganizationInput;
	OrganizationOptions: OrganizationOptions;
	OrganizationSort: OrganizationSort;
	OrganizationUpdateInput: OrganizationUpdateInput;
	OrganizationWhere: OrganizationWhere;
	OutcomebasedAgreementReport: OutcomebasedAgreementReport;
	OutcomebasedAgreementReportAggregateSelection: OutcomebasedAgreementReportAggregateSelection;
	OutcomebasedAgreementReportOptions: OutcomebasedAgreementReportOptions;
	OutcomebasedAgreementReportSort: OutcomebasedAgreementReportSort;
	OutcomebasedAgreementReportWhere: OutcomebasedAgreementReportWhere;
	PIRecurrenceSIDataPoint: PiRecurrenceSiDataPoint;
	PIRecurrenceSIDataPointAggregateSelection: PiRecurrenceSiDataPointAggregateSelection;
	PIRecurrenceSIDataPointOptions: PiRecurrenceSiDataPointOptions;
	PIRecurrenceSIDataPointSort: PiRecurrenceSiDataPointSort;
	PIRecurrenceSIDataPointWhere: PiRecurrenceSiDataPointWhere;
	PageInfo: PageInfo;
	Partner: Partner;
	PartnerAggregateSelection: PartnerAggregateSelection;
	PartnerConnectInput: PartnerConnectInput;
	PartnerConnectWhere: PartnerConnectWhere;
	PartnerCreateInput: PartnerCreateInput;
	PartnerDeleteInput: PartnerDeleteInput;
	PartnerDisconnectInput: PartnerDisconnectInput;
	PartnerOptions: PartnerOptions;
	PartnerSort: PartnerSort;
	PartnerTreatmentAggregateInput: PartnerTreatmentAggregateInput;
	PartnerTreatmentConnectFieldInput: PartnerTreatmentConnectFieldInput;
	PartnerTreatmentConnection: PartnerTreatmentConnection;
	PartnerTreatmentConnectionSort: PartnerTreatmentConnectionSort;
	PartnerTreatmentConnectionWhere: PartnerTreatmentConnectionWhere;
	PartnerTreatmentCreateFieldInput: PartnerTreatmentCreateFieldInput;
	PartnerTreatmentDeleteFieldInput: PartnerTreatmentDeleteFieldInput;
	PartnerTreatmentDisconnectFieldInput: PartnerTreatmentDisconnectFieldInput;
	PartnerTreatmentFieldInput: PartnerTreatmentFieldInput;
	PartnerTreatmentNodeAggregationWhereInput: PartnerTreatmentNodeAggregationWhereInput;
	PartnerTreatmentRelationship: PartnerTreatmentRelationship;
	PartnerTreatmentUpdateConnectionInput: PartnerTreatmentUpdateConnectionInput;
	PartnerTreatmentUpdateFieldInput: PartnerTreatmentUpdateFieldInput;
	PartnerUpdateInput: PartnerUpdateInput;
	PartnerWhere: PartnerWhere;
	Patient: Patient;
	PatientAggregateSelection: PatientAggregateSelection;
	PatientAssignedFlexEntitiesAggregateInput: PatientAssignedFlexEntitiesAggregateInput;
	PatientAssignedFlexEntitiesConnectFieldInput: PatientAssignedFlexEntitiesConnectFieldInput;
	PatientAssignedFlexEntitiesConnection: PatientAssignedFlexEntitiesConnection;
	PatientAssignedFlexEntitiesConnectionSort: PatientAssignedFlexEntitiesConnectionSort;
	PatientAssignedFlexEntitiesConnectionWhere: PatientAssignedFlexEntitiesConnectionWhere;
	PatientAssignedFlexEntitiesCreateFieldInput: PatientAssignedFlexEntitiesCreateFieldInput;
	PatientAssignedFlexEntitiesDeleteFieldInput: PatientAssignedFlexEntitiesDeleteFieldInput;
	PatientAssignedFlexEntitiesDisconnectFieldInput: PatientAssignedFlexEntitiesDisconnectFieldInput;
	PatientAssignedFlexEntitiesFieldInput: PatientAssignedFlexEntitiesFieldInput;
	PatientAssignedFlexEntitiesNodeAggregationWhereInput: PatientAssignedFlexEntitiesNodeAggregationWhereInput;
	PatientAssignedFlexEntitiesRelationship: PatientAssignedFlexEntitiesRelationship;
	PatientAssignedFlexEntitiesUpdateConnectionInput: PatientAssignedFlexEntitiesUpdateConnectionInput;
	PatientAssignedFlexEntitiesUpdateFieldInput: PatientAssignedFlexEntitiesUpdateFieldInput;
	PatientCasesAggregateInput: PatientCasesAggregateInput;
	PatientCasesConnectFieldInput: PatientCasesConnectFieldInput;
	PatientCasesConnection: PatientCasesConnection;
	PatientCasesConnectionSort: PatientCasesConnectionSort;
	PatientCasesConnectionWhere: PatientCasesConnectionWhere;
	PatientCasesCreateFieldInput: PatientCasesCreateFieldInput;
	PatientCasesDeleteFieldInput: PatientCasesDeleteFieldInput;
	PatientCasesDisconnectFieldInput: PatientCasesDisconnectFieldInput;
	PatientCasesFieldInput: PatientCasesFieldInput;
	PatientCasesNodeAggregationWhereInput: PatientCasesNodeAggregationWhereInput;
	PatientCasesRelationship: PatientCasesRelationship;
	PatientCasesUpdateConnectionInput: PatientCasesUpdateConnectionInput;
	PatientCasesUpdateFieldInput: PatientCasesUpdateFieldInput;
	PatientClaimsAggregateInput: PatientClaimsAggregateInput;
	PatientClaimsConnectFieldInput: PatientClaimsConnectFieldInput;
	PatientClaimsConnection: PatientClaimsConnection;
	PatientClaimsConnectionSort: PatientClaimsConnectionSort;
	PatientClaimsConnectionWhere: PatientClaimsConnectionWhere;
	PatientClaimsCreateFieldInput: PatientClaimsCreateFieldInput;
	PatientClaimsDeleteFieldInput: PatientClaimsDeleteFieldInput;
	PatientClaimsDisconnectFieldInput: PatientClaimsDisconnectFieldInput;
	PatientClaimsFieldInput: PatientClaimsFieldInput;
	PatientClaimsNodeAggregationWhereInput: PatientClaimsNodeAggregationWhereInput;
	PatientClaimsRelationship: PatientClaimsRelationship;
	PatientClaimsUpdateConnectionInput: PatientClaimsUpdateConnectionInput;
	PatientClaimsUpdateFieldInput: PatientClaimsUpdateFieldInput;
	PatientConnectInput: PatientConnectInput;
	PatientConnectWhere: PatientConnectWhere;
	PatientCountDataPoint: PatientCountDataPoint;
	PatientCountDataPointAggregateSelection: PatientCountDataPointAggregateSelection;
	PatientCountDataPointOptions: PatientCountDataPointOptions;
	PatientCountDataPointSort: PatientCountDataPointSort;
	PatientCountDataPointWhere: PatientCountDataPointWhere;
	PatientCoverageRequestsAggregateInput: PatientCoverageRequestsAggregateInput;
	PatientCoverageRequestsConnectFieldInput: PatientCoverageRequestsConnectFieldInput;
	PatientCoverageRequestsConnection: PatientCoverageRequestsConnection;
	PatientCoverageRequestsConnectionSort: PatientCoverageRequestsConnectionSort;
	PatientCoverageRequestsConnectionWhere: PatientCoverageRequestsConnectionWhere;
	PatientCoverageRequestsCreateFieldInput: PatientCoverageRequestsCreateFieldInput;
	PatientCoverageRequestsDeleteFieldInput: PatientCoverageRequestsDeleteFieldInput;
	PatientCoverageRequestsDisconnectFieldInput: PatientCoverageRequestsDisconnectFieldInput;
	PatientCoverageRequestsFieldInput: PatientCoverageRequestsFieldInput;
	PatientCoverageRequestsNodeAggregationWhereInput: PatientCoverageRequestsNodeAggregationWhereInput;
	PatientCoverageRequestsRelationship: PatientCoverageRequestsRelationship;
	PatientCoverageRequestsUpdateConnectionInput: PatientCoverageRequestsUpdateConnectionInput;
	PatientCoverageRequestsUpdateFieldInput: PatientCoverageRequestsUpdateFieldInput;
	PatientCreateInput: PatientCreateInput;
	PatientDeleteInput: PatientDeleteInput;
	PatientDisconnectInput: PatientDisconnectInput;
	PatientOptions: PatientOptions;
	PatientPrimaryInterventionAggregateInput: PatientPrimaryInterventionAggregateInput;
	PatientPrimaryInterventionConnectFieldInput: PatientPrimaryInterventionConnectFieldInput;
	PatientPrimaryInterventionConnection: PatientPrimaryInterventionConnection;
	PatientPrimaryInterventionConnectionSort: PatientPrimaryInterventionConnectionSort;
	PatientPrimaryInterventionConnectionWhere: PatientPrimaryInterventionConnectionWhere;
	PatientPrimaryInterventionCreateFieldInput: PatientPrimaryInterventionCreateFieldInput;
	PatientPrimaryInterventionDeleteFieldInput: PatientPrimaryInterventionDeleteFieldInput;
	PatientPrimaryInterventionDisconnectFieldInput: PatientPrimaryInterventionDisconnectFieldInput;
	PatientPrimaryInterventionFieldInput: PatientPrimaryInterventionFieldInput;
	PatientPrimaryInterventionNodeAggregationWhereInput: PatientPrimaryInterventionNodeAggregationWhereInput;
	PatientPrimaryInterventionRelationship: PatientPrimaryInterventionRelationship;
	PatientPrimaryInterventionUpdateConnectionInput: PatientPrimaryInterventionUpdateConnectionInput;
	PatientPrimaryInterventionUpdateFieldInput: PatientPrimaryInterventionUpdateFieldInput;
	PatientReportDataPoint: PatientReportDataPoint;
	PatientReportDataPointAggregateSelection: PatientReportDataPointAggregateSelection;
	PatientReportDataPointOptions: PatientReportDataPointOptions;
	PatientReportDataPointSort: PatientReportDataPointSort;
	PatientReportDataPointWhere: PatientReportDataPointWhere;
	PatientSentClaimAggregateInput: PatientSentClaimAggregateInput;
	PatientSentClaimConnectFieldInput: PatientSentClaimConnectFieldInput;
	PatientSentClaimConnection: PatientSentClaimConnection;
	PatientSentClaimConnectionSort: PatientSentClaimConnectionSort;
	PatientSentClaimConnectionWhere: PatientSentClaimConnectionWhere;
	PatientSentClaimCreateFieldInput: PatientSentClaimCreateFieldInput;
	PatientSentClaimDeleteFieldInput: PatientSentClaimDeleteFieldInput;
	PatientSentClaimDisconnectFieldInput: PatientSentClaimDisconnectFieldInput;
	PatientSentClaimEdgeAggregationWhereInput: PatientSentClaimEdgeAggregationWhereInput;
	PatientSentClaimFieldInput: PatientSentClaimFieldInput;
	PatientSentClaimNodeAggregationWhereInput: PatientSentClaimNodeAggregationWhereInput;
	PatientSentClaimRelationship: PatientSentClaimRelationship;
	PatientSentClaimUpdateConnectionInput: PatientSentClaimUpdateConnectionInput;
	PatientSentClaimUpdateFieldInput: PatientSentClaimUpdateFieldInput;
	PatientSort: PatientSort;
	PatientStatusDistribution: PatientStatusDistribution;
	PatientStatusDistributionAggregateSelection: PatientStatusDistributionAggregateSelection;
	PatientStatusDistributionOptions: PatientStatusDistributionOptions;
	PatientStatusDistributionSort: PatientStatusDistributionSort;
	PatientStatusDistributionWhere: PatientStatusDistributionWhere;
	PatientUpdateInput: PatientUpdateInput;
	PatientWhere: PatientWhere;
	PatientsPerMonthDataPoint: PatientsPerMonthDataPoint;
	PatientsPerMonthDataPointAggregateSelection: PatientsPerMonthDataPointAggregateSelection;
	PatientsPerMonthDataPointOptions: PatientsPerMonthDataPointOptions;
	PatientsPerMonthDataPointSort: PatientsPerMonthDataPointSort;
	PatientsPerMonthDataPointWhere: PatientsPerMonthDataPointWhere;
	Preparation: Preparation;
	PreparationAggregateSelection: PreparationAggregateSelection;
	PreparationBrandAggregateInput: PreparationBrandAggregateInput;
	PreparationBrandConnectFieldInput: PreparationBrandConnectFieldInput;
	PreparationBrandConnection: PreparationBrandConnection;
	PreparationBrandConnectionSort: PreparationBrandConnectionSort;
	PreparationBrandConnectionWhere: PreparationBrandConnectionWhere;
	PreparationBrandCreateFieldInput: PreparationBrandCreateFieldInput;
	PreparationBrandDeleteFieldInput: PreparationBrandDeleteFieldInput;
	PreparationBrandDisconnectFieldInput: PreparationBrandDisconnectFieldInput;
	PreparationBrandFieldInput: PreparationBrandFieldInput;
	PreparationBrandNodeAggregationWhereInput: PreparationBrandNodeAggregationWhereInput;
	PreparationBrandRelationship: PreparationBrandRelationship;
	PreparationBrandUpdateConnectionInput: PreparationBrandUpdateConnectionInput;
	PreparationBrandUpdateFieldInput: PreparationBrandUpdateFieldInput;
	PreparationConnectInput: PreparationConnectInput;
	PreparationConnectWhere: PreparationConnectWhere;
	PreparationCoverageRequestAggregateInput: PreparationCoverageRequestAggregateInput;
	PreparationCoverageRequestCombinedAggregateInput: PreparationCoverageRequestCombinedAggregateInput;
	PreparationCoverageRequestCombinedConnectFieldInput: PreparationCoverageRequestCombinedConnectFieldInput;
	PreparationCoverageRequestCombinedConnection: PreparationCoverageRequestCombinedConnection;
	PreparationCoverageRequestCombinedConnectionSort: PreparationCoverageRequestCombinedConnectionSort;
	PreparationCoverageRequestCombinedConnectionWhere: PreparationCoverageRequestCombinedConnectionWhere;
	PreparationCoverageRequestCombinedCreateFieldInput: PreparationCoverageRequestCombinedCreateFieldInput;
	PreparationCoverageRequestCombinedDeleteFieldInput: PreparationCoverageRequestCombinedDeleteFieldInput;
	PreparationCoverageRequestCombinedDisconnectFieldInput: PreparationCoverageRequestCombinedDisconnectFieldInput;
	PreparationCoverageRequestCombinedFieldInput: PreparationCoverageRequestCombinedFieldInput;
	PreparationCoverageRequestCombinedNodeAggregationWhereInput: PreparationCoverageRequestCombinedNodeAggregationWhereInput;
	PreparationCoverageRequestCombinedRelationship: PreparationCoverageRequestCombinedRelationship;
	PreparationCoverageRequestCombinedUpdateConnectionInput: PreparationCoverageRequestCombinedUpdateConnectionInput;
	PreparationCoverageRequestCombinedUpdateFieldInput: PreparationCoverageRequestCombinedUpdateFieldInput;
	PreparationCoverageRequestConnectFieldInput: PreparationCoverageRequestConnectFieldInput;
	PreparationCoverageRequestConnection: PreparationCoverageRequestConnection;
	PreparationCoverageRequestConnectionSort: PreparationCoverageRequestConnectionSort;
	PreparationCoverageRequestConnectionWhere: PreparationCoverageRequestConnectionWhere;
	PreparationCoverageRequestCreateFieldInput: PreparationCoverageRequestCreateFieldInput;
	PreparationCoverageRequestDeleteFieldInput: PreparationCoverageRequestDeleteFieldInput;
	PreparationCoverageRequestDisconnectFieldInput: PreparationCoverageRequestDisconnectFieldInput;
	PreparationCoverageRequestFieldInput: PreparationCoverageRequestFieldInput;
	PreparationCoverageRequestNodeAggregationWhereInput: PreparationCoverageRequestNodeAggregationWhereInput;
	PreparationCoverageRequestRelationship: PreparationCoverageRequestRelationship;
	PreparationCoverageRequestUpdateConnectionInput: PreparationCoverageRequestUpdateConnectionInput;
	PreparationCoverageRequestUpdateFieldInput: PreparationCoverageRequestUpdateFieldInput;
	PreparationCreateInput: PreparationCreateInput;
	PreparationDeleteInput: PreparationDeleteInput;
	PreparationDisconnectInput: PreparationDisconnectInput;
	PreparationHasLimitationsAggregateInput: PreparationHasLimitationsAggregateInput;
	PreparationHasLimitationsConnectFieldInput: PreparationHasLimitationsConnectFieldInput;
	PreparationHasLimitationsConnection: PreparationHasLimitationsConnection;
	PreparationHasLimitationsConnectionSort: PreparationHasLimitationsConnectionSort;
	PreparationHasLimitationsConnectionWhere: PreparationHasLimitationsConnectionWhere;
	PreparationHasLimitationsCreateFieldInput: PreparationHasLimitationsCreateFieldInput;
	PreparationHasLimitationsDeleteFieldInput: PreparationHasLimitationsDeleteFieldInput;
	PreparationHasLimitationsDisconnectFieldInput: PreparationHasLimitationsDisconnectFieldInput;
	PreparationHasLimitationsFieldInput: PreparationHasLimitationsFieldInput;
	PreparationHasLimitationsNodeAggregationWhereInput: PreparationHasLimitationsNodeAggregationWhereInput;
	PreparationHasLimitationsRelationship: PreparationHasLimitationsRelationship;
	PreparationHasLimitationsUpdateConnectionInput: PreparationHasLimitationsUpdateConnectionInput;
	PreparationHasLimitationsUpdateFieldInput: PreparationHasLimitationsUpdateFieldInput;
	PreparationOptions: PreparationOptions;
	PreparationRegulatesAggregateInput: PreparationRegulatesAggregateInput;
	PreparationRegulatesConnectFieldInput: PreparationRegulatesConnectFieldInput;
	PreparationRegulatesConnection: PreparationRegulatesConnection;
	PreparationRegulatesConnectionSort: PreparationRegulatesConnectionSort;
	PreparationRegulatesConnectionWhere: PreparationRegulatesConnectionWhere;
	PreparationRegulatesCreateFieldInput: PreparationRegulatesCreateFieldInput;
	PreparationRegulatesDeleteFieldInput: PreparationRegulatesDeleteFieldInput;
	PreparationRegulatesDisconnectFieldInput: PreparationRegulatesDisconnectFieldInput;
	PreparationRegulatesFieldInput: PreparationRegulatesFieldInput;
	PreparationRegulatesNodeAggregationWhereInput: PreparationRegulatesNodeAggregationWhereInput;
	PreparationRegulatesRelationship: PreparationRegulatesRelationship;
	PreparationRegulatesUpdateConnectionInput: PreparationRegulatesUpdateConnectionInput;
	PreparationRegulatesUpdateFieldInput: PreparationRegulatesUpdateFieldInput;
	PreparationSort: PreparationSort;
	PreparationStatus: PreparationStatus;
	PreparationStatusAggregateSelection: PreparationStatusAggregateSelection;
	PreparationStatusConnectInput: PreparationStatusConnectInput;
	PreparationStatusConnectWhere: PreparationStatusConnectWhere;
	PreparationStatusCreateInput: PreparationStatusCreateInput;
	PreparationStatusDeleteInput: PreparationStatusDeleteInput;
	PreparationStatusDisconnectInput: PreparationStatusDisconnectInput;
	PreparationStatusOptions: PreparationStatusOptions;
	PreparationStatusPreparationAggregateInput: PreparationStatusPreparationAggregateInput;
	PreparationStatusPreparationConnectFieldInput: PreparationStatusPreparationConnectFieldInput;
	PreparationStatusPreparationConnection: PreparationStatusPreparationConnection;
	PreparationStatusPreparationConnectionSort: PreparationStatusPreparationConnectionSort;
	PreparationStatusPreparationConnectionWhere: PreparationStatusPreparationConnectionWhere;
	PreparationStatusPreparationCreateFieldInput: PreparationStatusPreparationCreateFieldInput;
	PreparationStatusPreparationDeleteFieldInput: PreparationStatusPreparationDeleteFieldInput;
	PreparationStatusPreparationDisconnectFieldInput: PreparationStatusPreparationDisconnectFieldInput;
	PreparationStatusPreparationFieldInput: PreparationStatusPreparationFieldInput;
	PreparationStatusPreparationNodeAggregationWhereInput: PreparationStatusPreparationNodeAggregationWhereInput;
	PreparationStatusPreparationRelationship: PreparationStatusPreparationRelationship;
	PreparationStatusPreparationUpdateConnectionInput: PreparationStatusPreparationUpdateConnectionInput;
	PreparationStatusPreparationUpdateFieldInput: PreparationStatusPreparationUpdateFieldInput;
	PreparationStatusSort: PreparationStatusSort;
	PreparationStatusUpdateInput: PreparationStatusUpdateInput;
	PreparationStatusWhere: PreparationStatusWhere;
	PreparationUpdateInput: PreparationUpdateInput;
	PreparationWhere: PreparationWhere;
	Price: Price;
	PriceAggregateSelection: PriceAggregateSelection;
	PriceOptions: PriceOptions;
	PriceSort: PriceSort;
	PriceTreatmentAggregateInput: PriceTreatmentAggregateInput;
	PriceTreatmentConnection: PriceTreatmentConnection;
	PriceTreatmentConnectionSort: PriceTreatmentConnectionSort;
	PriceTreatmentConnectionWhere: PriceTreatmentConnectionWhere;
	PriceTreatmentNodeAggregationWhereInput: PriceTreatmentNodeAggregationWhereInput;
	PriceTreatmentRelationship: PriceTreatmentRelationship;
	PriceWhere: PriceWhere;
	ProcessedDeviceRecord: ProcessedDeviceRecord;
	ProcessedDeviceRecordAggregateSelection: ProcessedDeviceRecordAggregateSelection;
	ProcessedDeviceRecordAgreementAggregateInput: ProcessedDeviceRecordAgreementAggregateInput;
	ProcessedDeviceRecordAgreementConnectFieldInput: ProcessedDeviceRecordAgreementConnectFieldInput;
	ProcessedDeviceRecordAgreementConnection: ProcessedDeviceRecordAgreementConnection;
	ProcessedDeviceRecordAgreementConnectionSort: ProcessedDeviceRecordAgreementConnectionSort;
	ProcessedDeviceRecordAgreementConnectionWhere: ProcessedDeviceRecordAgreementConnectionWhere;
	ProcessedDeviceRecordAgreementCreateFieldInput: ProcessedDeviceRecordAgreementCreateFieldInput;
	ProcessedDeviceRecordAgreementDeleteFieldInput: ProcessedDeviceRecordAgreementDeleteFieldInput;
	ProcessedDeviceRecordAgreementDisconnectFieldInput: ProcessedDeviceRecordAgreementDisconnectFieldInput;
	ProcessedDeviceRecordAgreementFieldInput: ProcessedDeviceRecordAgreementFieldInput;
	ProcessedDeviceRecordAgreementNodeAggregationWhereInput: ProcessedDeviceRecordAgreementNodeAggregationWhereInput;
	ProcessedDeviceRecordAgreementRelationship: ProcessedDeviceRecordAgreementRelationship;
	ProcessedDeviceRecordAgreementUpdateConnectionInput: ProcessedDeviceRecordAgreementUpdateConnectionInput;
	ProcessedDeviceRecordAgreementUpdateFieldInput: ProcessedDeviceRecordAgreementUpdateFieldInput;
	ProcessedDeviceRecordConnectInput: ProcessedDeviceRecordConnectInput;
	ProcessedDeviceRecordConnectWhere: ProcessedDeviceRecordConnectWhere;
	ProcessedDeviceRecordCreateInput: ProcessedDeviceRecordCreateInput;
	ProcessedDeviceRecordDeleteInput: ProcessedDeviceRecordDeleteInput;
	ProcessedDeviceRecordDeviceRecordAggregateInput: ProcessedDeviceRecordDeviceRecordAggregateInput;
	ProcessedDeviceRecordDeviceRecordConnectFieldInput: ProcessedDeviceRecordDeviceRecordConnectFieldInput;
	ProcessedDeviceRecordDeviceRecordConnection: ProcessedDeviceRecordDeviceRecordConnection;
	ProcessedDeviceRecordDeviceRecordConnectionSort: ProcessedDeviceRecordDeviceRecordConnectionSort;
	ProcessedDeviceRecordDeviceRecordConnectionWhere: ProcessedDeviceRecordDeviceRecordConnectionWhere;
	ProcessedDeviceRecordDeviceRecordCreateFieldInput: ProcessedDeviceRecordDeviceRecordCreateFieldInput;
	ProcessedDeviceRecordDeviceRecordDeleteFieldInput: ProcessedDeviceRecordDeviceRecordDeleteFieldInput;
	ProcessedDeviceRecordDeviceRecordDisconnectFieldInput: ProcessedDeviceRecordDeviceRecordDisconnectFieldInput;
	ProcessedDeviceRecordDeviceRecordFieldInput: ProcessedDeviceRecordDeviceRecordFieldInput;
	ProcessedDeviceRecordDeviceRecordNodeAggregationWhereInput: ProcessedDeviceRecordDeviceRecordNodeAggregationWhereInput;
	ProcessedDeviceRecordDeviceRecordRelationship: ProcessedDeviceRecordDeviceRecordRelationship;
	ProcessedDeviceRecordDeviceRecordUpdateConnectionInput: ProcessedDeviceRecordDeviceRecordUpdateConnectionInput;
	ProcessedDeviceRecordDeviceRecordUpdateFieldInput: ProcessedDeviceRecordDeviceRecordUpdateFieldInput;
	ProcessedDeviceRecordDisconnectInput: ProcessedDeviceRecordDisconnectInput;
	ProcessedDeviceRecordFinancialDataPointsAggregateInput: ProcessedDeviceRecordFinancialDataPointsAggregateInput;
	ProcessedDeviceRecordFinancialDataPointsConnectFieldInput: ProcessedDeviceRecordFinancialDataPointsConnectFieldInput;
	ProcessedDeviceRecordFinancialDataPointsConnection: ProcessedDeviceRecordFinancialDataPointsConnection;
	ProcessedDeviceRecordFinancialDataPointsConnectionSort: ProcessedDeviceRecordFinancialDataPointsConnectionSort;
	ProcessedDeviceRecordFinancialDataPointsConnectionWhere: ProcessedDeviceRecordFinancialDataPointsConnectionWhere;
	ProcessedDeviceRecordFinancialDataPointsCreateFieldInput: ProcessedDeviceRecordFinancialDataPointsCreateFieldInput;
	ProcessedDeviceRecordFinancialDataPointsDeleteFieldInput: ProcessedDeviceRecordFinancialDataPointsDeleteFieldInput;
	ProcessedDeviceRecordFinancialDataPointsDisconnectFieldInput: ProcessedDeviceRecordFinancialDataPointsDisconnectFieldInput;
	ProcessedDeviceRecordFinancialDataPointsFieldInput: ProcessedDeviceRecordFinancialDataPointsFieldInput;
	ProcessedDeviceRecordFinancialDataPointsNodeAggregationWhereInput: ProcessedDeviceRecordFinancialDataPointsNodeAggregationWhereInput;
	ProcessedDeviceRecordFinancialDataPointsRelationship: ProcessedDeviceRecordFinancialDataPointsRelationship;
	ProcessedDeviceRecordFinancialDataPointsUpdateConnectionInput: ProcessedDeviceRecordFinancialDataPointsUpdateConnectionInput;
	ProcessedDeviceRecordFinancialDataPointsUpdateFieldInput: ProcessedDeviceRecordFinancialDataPointsUpdateFieldInput;
	ProcessedDeviceRecordOptions: ProcessedDeviceRecordOptions;
	ProcessedDeviceRecordSort: ProcessedDeviceRecordSort;
	ProcessedDeviceRecordUpdateInput: ProcessedDeviceRecordUpdateInput;
	ProcessedDeviceRecordWhere: ProcessedDeviceRecordWhere;
	PublicPrice: PublicPrice;
	PublicPriceAggregateSelection: PublicPriceAggregateSelection;
	PublicPriceConnectWhere: PublicPriceConnectWhere;
	PublicPriceCreateInput: PublicPriceCreateInput;
	PublicPriceOptions: PublicPriceOptions;
	PublicPriceSort: PublicPriceSort;
	PublicPriceUpdateInput: PublicPriceUpdateInput;
	PublicPriceWhere: PublicPriceWhere;
	Query: {};
	ReasonOfTreatmentDiscontinuationReport: ReasonOfTreatmentDiscontinuationReport;
	ReasonOfTreatmentDiscontinuationReportAggregateSelection: ReasonOfTreatmentDiscontinuationReportAggregateSelection;
	ReasonOfTreatmentDiscontinuationReportCreateInput: ReasonOfTreatmentDiscontinuationReportCreateInput;
	ReasonOfTreatmentDiscontinuationReportOptions: ReasonOfTreatmentDiscontinuationReportOptions;
	ReasonOfTreatmentDiscontinuationReportSort: ReasonOfTreatmentDiscontinuationReportSort;
	ReasonOfTreatmentDiscontinuationReportUpdateInput: ReasonOfTreatmentDiscontinuationReportUpdateInput;
	ReasonOfTreatmentDiscontinuationReportWhere: ReasonOfTreatmentDiscontinuationReportWhere;
	RecallToDraftInput: RecallToDraftInput;
	RecommendedForm: RecommendedForm;
	RecommendedFormAggregateSelection: RecommendedFormAggregateSelection;
	RecommendedFormConnectWhere: RecommendedFormConnectWhere;
	RecommendedFormCreateInput: RecommendedFormCreateInput;
	RecommendedFormInput: RecommendedFormInput;
	RecommendedFormOptions: RecommendedFormOptions;
	RecommendedFormSort: RecommendedFormSort;
	RecommendedFormUpdateInput: RecommendedFormUpdateInput;
	RecommendedFormWhere: RecommendedFormWhere;
	Record: Record;
	RecordAggregateSelection: RecordAggregateSelection;
	RecordBatch: RecordBatch;
	RecordBatchAggregateSelection: RecordBatchAggregateSelection;
	RecordBatchConnectInput: RecordBatchConnectInput;
	RecordBatchConnectWhere: RecordBatchConnectWhere;
	RecordBatchCreateInput: RecordBatchCreateInput;
	RecordBatchDeleteInput: RecordBatchDeleteInput;
	RecordBatchDisconnectInput: RecordBatchDisconnectInput;
	RecordBatchFinancialDataPointsAggregateInput: RecordBatchFinancialDataPointsAggregateInput;
	RecordBatchFinancialDataPointsConnectFieldInput: RecordBatchFinancialDataPointsConnectFieldInput;
	RecordBatchFinancialDataPointsConnection: RecordBatchFinancialDataPointsConnection;
	RecordBatchFinancialDataPointsConnectionSort: RecordBatchFinancialDataPointsConnectionSort;
	RecordBatchFinancialDataPointsConnectionWhere: RecordBatchFinancialDataPointsConnectionWhere;
	RecordBatchFinancialDataPointsCreateFieldInput: RecordBatchFinancialDataPointsCreateFieldInput;
	RecordBatchFinancialDataPointsDeleteFieldInput: RecordBatchFinancialDataPointsDeleteFieldInput;
	RecordBatchFinancialDataPointsDisconnectFieldInput: RecordBatchFinancialDataPointsDisconnectFieldInput;
	RecordBatchFinancialDataPointsFieldInput: RecordBatchFinancialDataPointsFieldInput;
	RecordBatchFinancialDataPointsNodeAggregationWhereInput: RecordBatchFinancialDataPointsNodeAggregationWhereInput;
	RecordBatchFinancialDataPointsRelationship: RecordBatchFinancialDataPointsRelationship;
	RecordBatchFinancialDataPointsUpdateConnectionInput: RecordBatchFinancialDataPointsUpdateConnectionInput;
	RecordBatchFinancialDataPointsUpdateFieldInput: RecordBatchFinancialDataPointsUpdateFieldInput;
	RecordBatchOptions: RecordBatchOptions;
	RecordBatchSort: RecordBatchSort;
	RecordBatchUpdateInput: RecordBatchUpdateInput;
	RecordBatchWhere: RecordBatchWhere;
	RecordConnectInput: RecordConnectInput;
	RecordConnectWhere: RecordConnectWhere;
	RecordCreateInput: RecordCreateInput;
	RecordDeleteInput: RecordDeleteInput;
	RecordDeviceRecordAggregateInput: RecordDeviceRecordAggregateInput;
	RecordDeviceRecordConnectFieldInput: RecordDeviceRecordConnectFieldInput;
	RecordDeviceRecordConnection: RecordDeviceRecordConnection;
	RecordDeviceRecordConnectionSort: RecordDeviceRecordConnectionSort;
	RecordDeviceRecordConnectionWhere: RecordDeviceRecordConnectionWhere;
	RecordDeviceRecordCreateFieldInput: RecordDeviceRecordCreateFieldInput;
	RecordDeviceRecordDeleteFieldInput: RecordDeviceRecordDeleteFieldInput;
	RecordDeviceRecordDisconnectFieldInput: RecordDeviceRecordDisconnectFieldInput;
	RecordDeviceRecordFieldInput: RecordDeviceRecordFieldInput;
	RecordDeviceRecordNodeAggregationWhereInput: RecordDeviceRecordNodeAggregationWhereInput;
	RecordDeviceRecordRelationship: RecordDeviceRecordRelationship;
	RecordDeviceRecordUpdateConnectionInput: RecordDeviceRecordUpdateConnectionInput;
	RecordDeviceRecordUpdateFieldInput: RecordDeviceRecordUpdateFieldInput;
	RecordDisconnectInput: RecordDisconnectInput;
	RecordOptions: RecordOptions;
	RecordSort: RecordSort;
	RecordUpdateInput: RecordUpdateInput;
	RecordWhere: RecordWhere;
	Refund: Refund;
	RefundAggregateSelection: RefundAggregateSelection;
	RefundCaseAggregateInput: RefundCaseAggregateInput;
	RefundCaseConnectFieldInput: RefundCaseConnectFieldInput;
	RefundCaseConnection: RefundCaseConnection;
	RefundCaseConnectionSort: RefundCaseConnectionSort;
	RefundCaseConnectionWhere: RefundCaseConnectionWhere;
	RefundCaseCreateFieldInput: RefundCaseCreateFieldInput;
	RefundCaseDeleteFieldInput: RefundCaseDeleteFieldInput;
	RefundCaseDisconnectFieldInput: RefundCaseDisconnectFieldInput;
	RefundCaseFieldInput: RefundCaseFieldInput;
	RefundCaseNodeAggregationWhereInput: RefundCaseNodeAggregationWhereInput;
	RefundCaseRelationship: RefundCaseRelationship;
	RefundCaseUpdateConnectionInput: RefundCaseUpdateConnectionInput;
	RefundCaseUpdateFieldInput: RefundCaseUpdateFieldInput;
	RefundConnectInput: RefundConnectInput;
	RefundConnectWhere: RefundConnectWhere;
	RefundCreateInput: RefundCreateInput;
	RefundDeleteInput: RefundDeleteInput;
	RefundDisconnectInput: RefundDisconnectInput;
	RefundInvoiceFinancialDataPointsAggregateInput: RefundInvoiceFinancialDataPointsAggregateInput;
	RefundInvoiceFinancialDataPointsConnectFieldInput: RefundInvoiceFinancialDataPointsConnectFieldInput;
	RefundInvoiceFinancialDataPointsConnection: RefundInvoiceFinancialDataPointsConnection;
	RefundInvoiceFinancialDataPointsConnectionSort: RefundInvoiceFinancialDataPointsConnectionSort;
	RefundInvoiceFinancialDataPointsConnectionWhere: RefundInvoiceFinancialDataPointsConnectionWhere;
	RefundInvoiceFinancialDataPointsCreateFieldInput: RefundInvoiceFinancialDataPointsCreateFieldInput;
	RefundInvoiceFinancialDataPointsDeleteFieldInput: RefundInvoiceFinancialDataPointsDeleteFieldInput;
	RefundInvoiceFinancialDataPointsDisconnectFieldInput: RefundInvoiceFinancialDataPointsDisconnectFieldInput;
	RefundInvoiceFinancialDataPointsEdgeAggregationWhereInput: RefundInvoiceFinancialDataPointsEdgeAggregationWhereInput;
	RefundInvoiceFinancialDataPointsFieldInput: RefundInvoiceFinancialDataPointsFieldInput;
	RefundInvoiceFinancialDataPointsNodeAggregationWhereInput: RefundInvoiceFinancialDataPointsNodeAggregationWhereInput;
	RefundInvoiceFinancialDataPointsRelationship: RefundInvoiceFinancialDataPointsRelationship;
	RefundInvoiceFinancialDataPointsUpdateConnectionInput: RefundInvoiceFinancialDataPointsUpdateConnectionInput;
	RefundInvoiceFinancialDataPointsUpdateFieldInput: RefundInvoiceFinancialDataPointsUpdateFieldInput;
	RefundInvoicesAggregateInput: RefundInvoicesAggregateInput;
	RefundInvoicesConnectFieldInput: RefundInvoicesConnectFieldInput;
	RefundInvoicesConnection: RefundInvoicesConnection;
	RefundInvoicesConnectionSort: RefundInvoicesConnectionSort;
	RefundInvoicesConnectionWhere: RefundInvoicesConnectionWhere;
	RefundInvoicesCreateFieldInput: RefundInvoicesCreateFieldInput;
	RefundInvoicesDeleteFieldInput: RefundInvoicesDeleteFieldInput;
	RefundInvoicesDisconnectFieldInput: RefundInvoicesDisconnectFieldInput;
	RefundInvoicesFieldInput: RefundInvoicesFieldInput;
	RefundInvoicesNodeAggregationWhereInput: RefundInvoicesNodeAggregationWhereInput;
	RefundInvoicesRelationship: RefundInvoicesRelationship;
	RefundInvoicesUpdateConnectionInput: RefundInvoicesUpdateConnectionInput;
	RefundInvoicesUpdateFieldInput: RefundInvoicesUpdateFieldInput;
	RefundMessageAggregateInput: RefundMessageAggregateInput;
	RefundMessageConnectFieldInput: RefundMessageConnectFieldInput;
	RefundMessageConnection: RefundMessageConnection;
	RefundMessageConnectionSort: RefundMessageConnectionSort;
	RefundMessageConnectionWhere: RefundMessageConnectionWhere;
	RefundMessageCreateFieldInput: RefundMessageCreateFieldInput;
	RefundMessageDeleteFieldInput: RefundMessageDeleteFieldInput;
	RefundMessageDisconnectFieldInput: RefundMessageDisconnectFieldInput;
	RefundMessageFieldInput: RefundMessageFieldInput;
	RefundMessageNodeAggregationWhereInput: RefundMessageNodeAggregationWhereInput;
	RefundMessageRelationship: RefundMessageRelationship;
	RefundMessageUpdateConnectionInput: RefundMessageUpdateConnectionInput;
	RefundMessageUpdateFieldInput: RefundMessageUpdateFieldInput;
	RefundOptions: RefundOptions;
	RefundSort: RefundSort;
	RefundSourceFinancialDataPointsAggregateInput: RefundSourceFinancialDataPointsAggregateInput;
	RefundSourceFinancialDataPointsConnectFieldInput: RefundSourceFinancialDataPointsConnectFieldInput;
	RefundSourceFinancialDataPointsConnection: RefundSourceFinancialDataPointsConnection;
	RefundSourceFinancialDataPointsConnectionSort: RefundSourceFinancialDataPointsConnectionSort;
	RefundSourceFinancialDataPointsConnectionWhere: RefundSourceFinancialDataPointsConnectionWhere;
	RefundSourceFinancialDataPointsCreateFieldInput: RefundSourceFinancialDataPointsCreateFieldInput;
	RefundSourceFinancialDataPointsDeleteFieldInput: RefundSourceFinancialDataPointsDeleteFieldInput;
	RefundSourceFinancialDataPointsDisconnectFieldInput: RefundSourceFinancialDataPointsDisconnectFieldInput;
	RefundSourceFinancialDataPointsFieldInput: RefundSourceFinancialDataPointsFieldInput;
	RefundSourceFinancialDataPointsNodeAggregationWhereInput: RefundSourceFinancialDataPointsNodeAggregationWhereInput;
	RefundSourceFinancialDataPointsRelationship: RefundSourceFinancialDataPointsRelationship;
	RefundSourceFinancialDataPointsUpdateConnectionInput: RefundSourceFinancialDataPointsUpdateConnectionInput;
	RefundSourceFinancialDataPointsUpdateFieldInput: RefundSourceFinancialDataPointsUpdateFieldInput;
	RefundTagsAggregateInput: RefundTagsAggregateInput;
	RefundTagsConnectFieldInput: RefundTagsConnectFieldInput;
	RefundTagsConnection: RefundTagsConnection;
	RefundTagsConnectionSort: RefundTagsConnectionSort;
	RefundTagsConnectionWhere: RefundTagsConnectionWhere;
	RefundTagsCreateFieldInput: RefundTagsCreateFieldInput;
	RefundTagsDeleteFieldInput: RefundTagsDeleteFieldInput;
	RefundTagsDisconnectFieldInput: RefundTagsDisconnectFieldInput;
	RefundTagsFieldInput: RefundTagsFieldInput;
	RefundTagsNodeAggregationWhereInput: RefundTagsNodeAggregationWhereInput;
	RefundTagsRelationship: RefundTagsRelationship;
	RefundTagsUpdateConnectionInput: RefundTagsUpdateConnectionInput;
	RefundTagsUpdateFieldInput: RefundTagsUpdateFieldInput;
	RefundUpdateInput: RefundUpdateInput;
	RefundWhere: RefundWhere;
	ReportingSummary: ReportingSummary;
	ReportingSummaryAggregateSelection: ReportingSummaryAggregateSelection;
	ReportingSummaryOptions: ReportingSummaryOptions;
	ReportingSummarySort: ReportingSummarySort;
	ReportingSummaryWhere: ReportingSummaryWhere;
	SaveReviewedInvoiceInput: SaveReviewedInvoiceInput;
	Scenario: Scenario;
	ScenarioAction: ScenarioAction;
	ScenarioActionAggregateSelection: ScenarioActionAggregateSelection;
	ScenarioActionBrandAggregateInput: ScenarioActionBrandAggregateInput;
	ScenarioActionBrandConnectFieldInput: ScenarioActionBrandConnectFieldInput;
	ScenarioActionBrandConnection: ScenarioActionBrandConnection;
	ScenarioActionBrandConnectionSort: ScenarioActionBrandConnectionSort;
	ScenarioActionBrandConnectionWhere: ScenarioActionBrandConnectionWhere;
	ScenarioActionBrandCreateFieldInput: ScenarioActionBrandCreateFieldInput;
	ScenarioActionBrandDeleteFieldInput: ScenarioActionBrandDeleteFieldInput;
	ScenarioActionBrandDisconnectFieldInput: ScenarioActionBrandDisconnectFieldInput;
	ScenarioActionBrandFieldInput: ScenarioActionBrandFieldInput;
	ScenarioActionBrandNodeAggregationWhereInput: ScenarioActionBrandNodeAggregationWhereInput;
	ScenarioActionBrandRelationship: ScenarioActionBrandRelationship;
	ScenarioActionBrandUpdateConnectionInput: ScenarioActionBrandUpdateConnectionInput;
	ScenarioActionBrandUpdateFieldInput: ScenarioActionBrandUpdateFieldInput;
	ScenarioActionCategoriesAggregateInput: ScenarioActionCategoriesAggregateInput;
	ScenarioActionCategoriesConnectFieldInput: ScenarioActionCategoriesConnectFieldInput;
	ScenarioActionCategoriesConnection: ScenarioActionCategoriesConnection;
	ScenarioActionCategoriesConnectionSort: ScenarioActionCategoriesConnectionSort;
	ScenarioActionCategoriesConnectionWhere: ScenarioActionCategoriesConnectionWhere;
	ScenarioActionCategoriesCreateFieldInput: ScenarioActionCategoriesCreateFieldInput;
	ScenarioActionCategoriesDeleteFieldInput: ScenarioActionCategoriesDeleteFieldInput;
	ScenarioActionCategoriesDisconnectFieldInput: ScenarioActionCategoriesDisconnectFieldInput;
	ScenarioActionCategoriesFieldInput: ScenarioActionCategoriesFieldInput;
	ScenarioActionCategoriesNodeAggregationWhereInput: ScenarioActionCategoriesNodeAggregationWhereInput;
	ScenarioActionCategoriesRelationship: ScenarioActionCategoriesRelationship;
	ScenarioActionCategoriesUpdateConnectionInput: ScenarioActionCategoriesUpdateConnectionInput;
	ScenarioActionCategoriesUpdateFieldInput: ScenarioActionCategoriesUpdateFieldInput;
	ScenarioActionCombinedItemBrandsAggregateInput: ScenarioActionCombinedItemBrandsAggregateInput;
	ScenarioActionCombinedItemBrandsConnectFieldInput: ScenarioActionCombinedItemBrandsConnectFieldInput;
	ScenarioActionCombinedItemBrandsConnection: ScenarioActionCombinedItemBrandsConnection;
	ScenarioActionCombinedItemBrandsConnectionSort: ScenarioActionCombinedItemBrandsConnectionSort;
	ScenarioActionCombinedItemBrandsConnectionWhere: ScenarioActionCombinedItemBrandsConnectionWhere;
	ScenarioActionCombinedItemBrandsCreateFieldInput: ScenarioActionCombinedItemBrandsCreateFieldInput;
	ScenarioActionCombinedItemBrandsDeleteFieldInput: ScenarioActionCombinedItemBrandsDeleteFieldInput;
	ScenarioActionCombinedItemBrandsDisconnectFieldInput: ScenarioActionCombinedItemBrandsDisconnectFieldInput;
	ScenarioActionCombinedItemBrandsFieldInput: ScenarioActionCombinedItemBrandsFieldInput;
	ScenarioActionCombinedItemBrandsNodeAggregationWhereInput: ScenarioActionCombinedItemBrandsNodeAggregationWhereInput;
	ScenarioActionCombinedItemBrandsRelationship: ScenarioActionCombinedItemBrandsRelationship;
	ScenarioActionCombinedItemBrandsUpdateConnectionInput: ScenarioActionCombinedItemBrandsUpdateConnectionInput;
	ScenarioActionCombinedItemBrandsUpdateFieldInput: ScenarioActionCombinedItemBrandsUpdateFieldInput;
	ScenarioActionCombinedItemTreatmentsAggregateInput: ScenarioActionCombinedItemTreatmentsAggregateInput;
	ScenarioActionCombinedItemTreatmentsConnectFieldInput: ScenarioActionCombinedItemTreatmentsConnectFieldInput;
	ScenarioActionCombinedItemTreatmentsConnection: ScenarioActionCombinedItemTreatmentsConnection;
	ScenarioActionCombinedItemTreatmentsConnectionSort: ScenarioActionCombinedItemTreatmentsConnectionSort;
	ScenarioActionCombinedItemTreatmentsConnectionWhere: ScenarioActionCombinedItemTreatmentsConnectionWhere;
	ScenarioActionCombinedItemTreatmentsCreateFieldInput: ScenarioActionCombinedItemTreatmentsCreateFieldInput;
	ScenarioActionCombinedItemTreatmentsDeleteFieldInput: ScenarioActionCombinedItemTreatmentsDeleteFieldInput;
	ScenarioActionCombinedItemTreatmentsDisconnectFieldInput: ScenarioActionCombinedItemTreatmentsDisconnectFieldInput;
	ScenarioActionCombinedItemTreatmentsFieldInput: ScenarioActionCombinedItemTreatmentsFieldInput;
	ScenarioActionCombinedItemTreatmentsNodeAggregationWhereInput: ScenarioActionCombinedItemTreatmentsNodeAggregationWhereInput;
	ScenarioActionCombinedItemTreatmentsRelationship: ScenarioActionCombinedItemTreatmentsRelationship;
	ScenarioActionCombinedItemTreatmentsUpdateConnectionInput: ScenarioActionCombinedItemTreatmentsUpdateConnectionInput;
	ScenarioActionCombinedItemTreatmentsUpdateFieldInput: ScenarioActionCombinedItemTreatmentsUpdateFieldInput;
	ScenarioActionConnectInput: ScenarioActionConnectInput;
	ScenarioActionConnectWhere: ScenarioActionConnectWhere;
	ScenarioActionCreateInput: ScenarioActionCreateInput;
	ScenarioActionDeleteInput: ScenarioActionDeleteInput;
	ScenarioActionDeviceKitsAggregateInput: ScenarioActionDeviceKitsAggregateInput;
	ScenarioActionDeviceKitsConnectFieldInput: ScenarioActionDeviceKitsConnectFieldInput;
	ScenarioActionDeviceKitsConnection: ScenarioActionDeviceKitsConnection;
	ScenarioActionDeviceKitsConnectionSort: ScenarioActionDeviceKitsConnectionSort;
	ScenarioActionDeviceKitsConnectionWhere: ScenarioActionDeviceKitsConnectionWhere;
	ScenarioActionDeviceKitsCreateFieldInput: ScenarioActionDeviceKitsCreateFieldInput;
	ScenarioActionDeviceKitsDeleteFieldInput: ScenarioActionDeviceKitsDeleteFieldInput;
	ScenarioActionDeviceKitsDisconnectFieldInput: ScenarioActionDeviceKitsDisconnectFieldInput;
	ScenarioActionDeviceKitsFieldInput: ScenarioActionDeviceKitsFieldInput;
	ScenarioActionDeviceKitsNodeAggregationWhereInput: ScenarioActionDeviceKitsNodeAggregationWhereInput;
	ScenarioActionDeviceKitsRelationship: ScenarioActionDeviceKitsRelationship;
	ScenarioActionDeviceKitsUpdateConnectionInput: ScenarioActionDeviceKitsUpdateConnectionInput;
	ScenarioActionDeviceKitsUpdateFieldInput: ScenarioActionDeviceKitsUpdateFieldInput;
	ScenarioActionDisconnectInput: ScenarioActionDisconnectInput;
	ScenarioActionOptions: ScenarioActionOptions;
	ScenarioActionScenarioAggregateInput: ScenarioActionScenarioAggregateInput;
	ScenarioActionScenarioConnectFieldInput: ScenarioActionScenarioConnectFieldInput;
	ScenarioActionScenarioConnection: ScenarioActionScenarioConnection;
	ScenarioActionScenarioConnectionSort: ScenarioActionScenarioConnectionSort;
	ScenarioActionScenarioConnectionWhere: ScenarioActionScenarioConnectionWhere;
	ScenarioActionScenarioCreateFieldInput: ScenarioActionScenarioCreateFieldInput;
	ScenarioActionScenarioDeleteFieldInput: ScenarioActionScenarioDeleteFieldInput;
	ScenarioActionScenarioDisconnectFieldInput: ScenarioActionScenarioDisconnectFieldInput;
	ScenarioActionScenarioFieldInput: ScenarioActionScenarioFieldInput;
	ScenarioActionScenarioNodeAggregationWhereInput: ScenarioActionScenarioNodeAggregationWhereInput;
	ScenarioActionScenarioRelationship: ScenarioActionScenarioRelationship;
	ScenarioActionScenarioUpdateConnectionInput: ScenarioActionScenarioUpdateConnectionInput;
	ScenarioActionScenarioUpdateFieldInput: ScenarioActionScenarioUpdateFieldInput;
	ScenarioActionSort: ScenarioActionSort;
	ScenarioActionTimeframeAggregateInput: ScenarioActionTimeframeAggregateInput;
	ScenarioActionTimeframeConnectFieldInput: ScenarioActionTimeframeConnectFieldInput;
	ScenarioActionTimeframeConnection: ScenarioActionTimeframeConnection;
	ScenarioActionTimeframeConnectionSort: ScenarioActionTimeframeConnectionSort;
	ScenarioActionTimeframeConnectionWhere: ScenarioActionTimeframeConnectionWhere;
	ScenarioActionTimeframeCreateFieldInput: ScenarioActionTimeframeCreateFieldInput;
	ScenarioActionTimeframeDeleteFieldInput: ScenarioActionTimeframeDeleteFieldInput;
	ScenarioActionTimeframeDisconnectFieldInput: ScenarioActionTimeframeDisconnectFieldInput;
	ScenarioActionTimeframeFieldInput: ScenarioActionTimeframeFieldInput;
	ScenarioActionTimeframeNodeAggregationWhereInput: ScenarioActionTimeframeNodeAggregationWhereInput;
	ScenarioActionTimeframeRelationship: ScenarioActionTimeframeRelationship;
	ScenarioActionTimeframeUpdateConnectionInput: ScenarioActionTimeframeUpdateConnectionInput;
	ScenarioActionTimeframeUpdateFieldInput: ScenarioActionTimeframeUpdateFieldInput;
	ScenarioActionTreatmentAggregateInput: ScenarioActionTreatmentAggregateInput;
	ScenarioActionTreatmentConnectFieldInput: ScenarioActionTreatmentConnectFieldInput;
	ScenarioActionTreatmentConnection: ScenarioActionTreatmentConnection;
	ScenarioActionTreatmentConnectionSort: ScenarioActionTreatmentConnectionSort;
	ScenarioActionTreatmentConnectionWhere: ScenarioActionTreatmentConnectionWhere;
	ScenarioActionTreatmentCreateFieldInput: ScenarioActionTreatmentCreateFieldInput;
	ScenarioActionTreatmentDeleteFieldInput: ScenarioActionTreatmentDeleteFieldInput;
	ScenarioActionTreatmentDisconnectFieldInput: ScenarioActionTreatmentDisconnectFieldInput;
	ScenarioActionTreatmentFieldInput: ScenarioActionTreatmentFieldInput;
	ScenarioActionTreatmentNodeAggregationWhereInput: ScenarioActionTreatmentNodeAggregationWhereInput;
	ScenarioActionTreatmentRelationship: ScenarioActionTreatmentRelationship;
	ScenarioActionTreatmentUpdateConnectionInput: ScenarioActionTreatmentUpdateConnectionInput;
	ScenarioActionTreatmentUpdateFieldInput: ScenarioActionTreatmentUpdateFieldInput;
	ScenarioActionUpdateInput: ScenarioActionUpdateInput;
	ScenarioActionWhere: ScenarioActionWhere;
	ScenarioActionsAggregateInput: ScenarioActionsAggregateInput;
	ScenarioActionsConnectFieldInput: ScenarioActionsConnectFieldInput;
	ScenarioActionsConnection: ScenarioActionsConnection;
	ScenarioActionsConnectionSort: ScenarioActionsConnectionSort;
	ScenarioActionsConnectionWhere: ScenarioActionsConnectionWhere;
	ScenarioActionsCreateFieldInput: ScenarioActionsCreateFieldInput;
	ScenarioActionsDeleteFieldInput: ScenarioActionsDeleteFieldInput;
	ScenarioActionsDisconnectFieldInput: ScenarioActionsDisconnectFieldInput;
	ScenarioActionsFieldInput: ScenarioActionsFieldInput;
	ScenarioActionsNodeAggregationWhereInput: ScenarioActionsNodeAggregationWhereInput;
	ScenarioActionsRelationship: ScenarioActionsRelationship;
	ScenarioActionsUpdateConnectionInput: ScenarioActionsUpdateConnectionInput;
	ScenarioActionsUpdateFieldInput: ScenarioActionsUpdateFieldInput;
	ScenarioAggregateSelection: ScenarioAggregateSelection;
	ScenarioAgreementAggregateInput: ScenarioAgreementAggregateInput;
	ScenarioAgreementConnectFieldInput: ScenarioAgreementConnectFieldInput;
	ScenarioAgreementConnection: ScenarioAgreementConnection;
	ScenarioAgreementConnectionSort: ScenarioAgreementConnectionSort;
	ScenarioAgreementConnectionWhere: ScenarioAgreementConnectionWhere;
	ScenarioAgreementCreateFieldInput: ScenarioAgreementCreateFieldInput;
	ScenarioAgreementDeleteFieldInput: ScenarioAgreementDeleteFieldInput;
	ScenarioAgreementDisconnectFieldInput: ScenarioAgreementDisconnectFieldInput;
	ScenarioAgreementFieldInput: ScenarioAgreementFieldInput;
	ScenarioAgreementNodeAggregationWhereInput: ScenarioAgreementNodeAggregationWhereInput;
	ScenarioAgreementRelationship: ScenarioAgreementRelationship;
	ScenarioAgreementUpdateConnectionInput: ScenarioAgreementUpdateConnectionInput;
	ScenarioAgreementUpdateFieldInput: ScenarioAgreementUpdateFieldInput;
	ScenarioCondition: ScenarioCondition;
	ScenarioConditionAggregateSelection: ScenarioConditionAggregateSelection;
	ScenarioConditionBrandAggregateInput: ScenarioConditionBrandAggregateInput;
	ScenarioConditionBrandConnectFieldInput: ScenarioConditionBrandConnectFieldInput;
	ScenarioConditionBrandConnection: ScenarioConditionBrandConnection;
	ScenarioConditionBrandConnectionSort: ScenarioConditionBrandConnectionSort;
	ScenarioConditionBrandConnectionWhere: ScenarioConditionBrandConnectionWhere;
	ScenarioConditionBrandCreateFieldInput: ScenarioConditionBrandCreateFieldInput;
	ScenarioConditionBrandDeleteFieldInput: ScenarioConditionBrandDeleteFieldInput;
	ScenarioConditionBrandDisconnectFieldInput: ScenarioConditionBrandDisconnectFieldInput;
	ScenarioConditionBrandFieldInput: ScenarioConditionBrandFieldInput;
	ScenarioConditionBrandNodeAggregationWhereInput: ScenarioConditionBrandNodeAggregationWhereInput;
	ScenarioConditionBrandRelationship: ScenarioConditionBrandRelationship;
	ScenarioConditionBrandUpdateConnectionInput: ScenarioConditionBrandUpdateConnectionInput;
	ScenarioConditionBrandUpdateFieldInput: ScenarioConditionBrandUpdateFieldInput;
	ScenarioConditionConnectInput: ScenarioConditionConnectInput;
	ScenarioConditionConnectWhere: ScenarioConditionConnectWhere;
	ScenarioConditionCreateInput: ScenarioConditionCreateInput;
	ScenarioConditionDeleteInput: ScenarioConditionDeleteInput;
	ScenarioConditionDeviceKitsAggregateInput: ScenarioConditionDeviceKitsAggregateInput;
	ScenarioConditionDeviceKitsConnectFieldInput: ScenarioConditionDeviceKitsConnectFieldInput;
	ScenarioConditionDeviceKitsConnection: ScenarioConditionDeviceKitsConnection;
	ScenarioConditionDeviceKitsConnectionSort: ScenarioConditionDeviceKitsConnectionSort;
	ScenarioConditionDeviceKitsConnectionWhere: ScenarioConditionDeviceKitsConnectionWhere;
	ScenarioConditionDeviceKitsCreateFieldInput: ScenarioConditionDeviceKitsCreateFieldInput;
	ScenarioConditionDeviceKitsDeleteFieldInput: ScenarioConditionDeviceKitsDeleteFieldInput;
	ScenarioConditionDeviceKitsDisconnectFieldInput: ScenarioConditionDeviceKitsDisconnectFieldInput;
	ScenarioConditionDeviceKitsFieldInput: ScenarioConditionDeviceKitsFieldInput;
	ScenarioConditionDeviceKitsNodeAggregationWhereInput: ScenarioConditionDeviceKitsNodeAggregationWhereInput;
	ScenarioConditionDeviceKitsRelationship: ScenarioConditionDeviceKitsRelationship;
	ScenarioConditionDeviceKitsUpdateConnectionInput: ScenarioConditionDeviceKitsUpdateConnectionInput;
	ScenarioConditionDeviceKitsUpdateFieldInput: ScenarioConditionDeviceKitsUpdateFieldInput;
	ScenarioConditionDisconnectInput: ScenarioConditionDisconnectInput;
	ScenarioConditionOptions: ScenarioConditionOptions;
	ScenarioConditionScenarioAggregateInput: ScenarioConditionScenarioAggregateInput;
	ScenarioConditionScenarioConnectFieldInput: ScenarioConditionScenarioConnectFieldInput;
	ScenarioConditionScenarioConnection: ScenarioConditionScenarioConnection;
	ScenarioConditionScenarioConnectionSort: ScenarioConditionScenarioConnectionSort;
	ScenarioConditionScenarioConnectionWhere: ScenarioConditionScenarioConnectionWhere;
	ScenarioConditionScenarioCreateFieldInput: ScenarioConditionScenarioCreateFieldInput;
	ScenarioConditionScenarioDeleteFieldInput: ScenarioConditionScenarioDeleteFieldInput;
	ScenarioConditionScenarioDisconnectFieldInput: ScenarioConditionScenarioDisconnectFieldInput;
	ScenarioConditionScenarioFieldInput: ScenarioConditionScenarioFieldInput;
	ScenarioConditionScenarioNodeAggregationWhereInput: ScenarioConditionScenarioNodeAggregationWhereInput;
	ScenarioConditionScenarioRelationship: ScenarioConditionScenarioRelationship;
	ScenarioConditionScenarioUpdateConnectionInput: ScenarioConditionScenarioUpdateConnectionInput;
	ScenarioConditionScenarioUpdateFieldInput: ScenarioConditionScenarioUpdateFieldInput;
	ScenarioConditionSort: ScenarioConditionSort;
	ScenarioConditionTimeframeAggregateInput: ScenarioConditionTimeframeAggregateInput;
	ScenarioConditionTimeframeConnectFieldInput: ScenarioConditionTimeframeConnectFieldInput;
	ScenarioConditionTimeframeConnection: ScenarioConditionTimeframeConnection;
	ScenarioConditionTimeframeConnectionSort: ScenarioConditionTimeframeConnectionSort;
	ScenarioConditionTimeframeConnectionWhere: ScenarioConditionTimeframeConnectionWhere;
	ScenarioConditionTimeframeCreateFieldInput: ScenarioConditionTimeframeCreateFieldInput;
	ScenarioConditionTimeframeDeleteFieldInput: ScenarioConditionTimeframeDeleteFieldInput;
	ScenarioConditionTimeframeDisconnectFieldInput: ScenarioConditionTimeframeDisconnectFieldInput;
	ScenarioConditionTimeframeFieldInput: ScenarioConditionTimeframeFieldInput;
	ScenarioConditionTimeframeNodeAggregationWhereInput: ScenarioConditionTimeframeNodeAggregationWhereInput;
	ScenarioConditionTimeframeRelationship: ScenarioConditionTimeframeRelationship;
	ScenarioConditionTimeframeUpdateConnectionInput: ScenarioConditionTimeframeUpdateConnectionInput;
	ScenarioConditionTimeframeUpdateFieldInput: ScenarioConditionTimeframeUpdateFieldInput;
	ScenarioConditionTreatmentAggregateInput: ScenarioConditionTreatmentAggregateInput;
	ScenarioConditionTreatmentConnectFieldInput: ScenarioConditionTreatmentConnectFieldInput;
	ScenarioConditionTreatmentConnection: ScenarioConditionTreatmentConnection;
	ScenarioConditionTreatmentConnectionSort: ScenarioConditionTreatmentConnectionSort;
	ScenarioConditionTreatmentConnectionWhere: ScenarioConditionTreatmentConnectionWhere;
	ScenarioConditionTreatmentCreateFieldInput: ScenarioConditionTreatmentCreateFieldInput;
	ScenarioConditionTreatmentDeleteFieldInput: ScenarioConditionTreatmentDeleteFieldInput;
	ScenarioConditionTreatmentDisconnectFieldInput: ScenarioConditionTreatmentDisconnectFieldInput;
	ScenarioConditionTreatmentFieldInput: ScenarioConditionTreatmentFieldInput;
	ScenarioConditionTreatmentNodeAggregationWhereInput: ScenarioConditionTreatmentNodeAggregationWhereInput;
	ScenarioConditionTreatmentRelationship: ScenarioConditionTreatmentRelationship;
	ScenarioConditionTreatmentUpdateConnectionInput: ScenarioConditionTreatmentUpdateConnectionInput;
	ScenarioConditionTreatmentUpdateFieldInput: ScenarioConditionTreatmentUpdateFieldInput;
	ScenarioConditionUpdateInput: ScenarioConditionUpdateInput;
	ScenarioConditionWhere: ScenarioConditionWhere;
	ScenarioConditionsAggregateInput: ScenarioConditionsAggregateInput;
	ScenarioConditionsConnectFieldInput: ScenarioConditionsConnectFieldInput;
	ScenarioConditionsConnection: ScenarioConditionsConnection;
	ScenarioConditionsConnectionSort: ScenarioConditionsConnectionSort;
	ScenarioConditionsConnectionWhere: ScenarioConditionsConnectionWhere;
	ScenarioConditionsCreateFieldInput: ScenarioConditionsCreateFieldInput;
	ScenarioConditionsDeleteFieldInput: ScenarioConditionsDeleteFieldInput;
	ScenarioConditionsDisconnectFieldInput: ScenarioConditionsDisconnectFieldInput;
	ScenarioConditionsFieldInput: ScenarioConditionsFieldInput;
	ScenarioConditionsNodeAggregationWhereInput: ScenarioConditionsNodeAggregationWhereInput;
	ScenarioConditionsRelationship: ScenarioConditionsRelationship;
	ScenarioConditionsUpdateConnectionInput: ScenarioConditionsUpdateConnectionInput;
	ScenarioConditionsUpdateFieldInput: ScenarioConditionsUpdateFieldInput;
	ScenarioConnectInput: ScenarioConnectInput;
	ScenarioConnectWhere: ScenarioConnectWhere;
	ScenarioCreateInput: ScenarioCreateInput;
	ScenarioDeleteInput: ScenarioDeleteInput;
	ScenarioDisconnectInput: ScenarioDisconnectInput;
	ScenarioInsightsUserContext:
		| ResolversParentTypes["BaseAgreementUserContextsRelationship"]
		| ResolversParentTypes["UserContextBaseAgreementContextRelationship"]
		| ResolversParentTypes["UserContextScenariosRelationship"];
	ScenarioInsightsUserContextCreateInput: ScenarioInsightsUserContextCreateInput;
	ScenarioInsightsUserContextInput: ScenarioInsightsUserContextInput;
	ScenarioInsightsUserContextSort: ScenarioInsightsUserContextSort;
	ScenarioInsightsUserContextUpdateInput: ScenarioInsightsUserContextUpdateInput;
	ScenarioInsightsUserContextWhere: ScenarioInsightsUserContextWhere;
	ScenarioOptions: ScenarioOptions;
	ScenarioSort: ScenarioSort;
	ScenarioUpdateInput: ScenarioUpdateInput;
	ScenarioWhere: ScenarioWhere;
	SearchUserEmailByNameInput: SearchUserEmailByNameInput;
	SentClaimRelationship: ResolversParentTypes["PatientSentClaimRelationship"];
	SentClaimRelationshipCreateInput: SentClaimRelationshipCreateInput;
	SentClaimRelationshipSort: SentClaimRelationshipSort;
	SentClaimRelationshipUpdateInput: SentClaimRelationshipUpdateInput;
	SentClaimRelationshipWhere: SentClaimRelationshipWhere;
	StobAction: StobAction;
	StobActionAggregateSelection: StobActionAggregateSelection;
	StobActionConnectInput: StobActionConnectInput;
	StobActionConnectWhere: StobActionConnectWhere;
	StobActionCreateInput: StobActionCreateInput;
	StobActionDeleteInput: StobActionDeleteInput;
	StobActionDisconnectInput: StobActionDisconnectInput;
	StobActionInput: StobActionInput;
	StobActionOptions: StobActionOptions;
	StobActionScenarioAggregateInput: StobActionScenarioAggregateInput;
	StobActionScenarioConnectFieldInput: StobActionScenarioConnectFieldInput;
	StobActionScenarioConnection: StobActionScenarioConnection;
	StobActionScenarioConnectionSort: StobActionScenarioConnectionSort;
	StobActionScenarioConnectionWhere: StobActionScenarioConnectionWhere;
	StobActionScenarioCreateFieldInput: StobActionScenarioCreateFieldInput;
	StobActionScenarioDeleteFieldInput: StobActionScenarioDeleteFieldInput;
	StobActionScenarioDisconnectFieldInput: StobActionScenarioDisconnectFieldInput;
	StobActionScenarioFieldInput: StobActionScenarioFieldInput;
	StobActionScenarioNodeAggregationWhereInput: StobActionScenarioNodeAggregationWhereInput;
	StobActionScenarioRelationship: StobActionScenarioRelationship;
	StobActionScenarioUpdateConnectionInput: StobActionScenarioUpdateConnectionInput;
	StobActionScenarioUpdateFieldInput: StobActionScenarioUpdateFieldInput;
	StobActionSort: StobActionSort;
	StobActionUpdateInput: StobActionUpdateInput;
	StobActionWhere: StobActionWhere;
	StobCondition: StobCondition;
	StobConditionAggregateSelection: StobConditionAggregateSelection;
	StobConditionConnectInput: StobConditionConnectInput;
	StobConditionConnectWhere: StobConditionConnectWhere;
	StobConditionCreateInput: StobConditionCreateInput;
	StobConditionDeleteInput: StobConditionDeleteInput;
	StobConditionDisconnectInput: StobConditionDisconnectInput;
	StobConditionInput: StobConditionInput;
	StobConditionOptions: StobConditionOptions;
	StobConditionScenarioAggregateInput: StobConditionScenarioAggregateInput;
	StobConditionScenarioConnectFieldInput: StobConditionScenarioConnectFieldInput;
	StobConditionScenarioConnection: StobConditionScenarioConnection;
	StobConditionScenarioConnectionSort: StobConditionScenarioConnectionSort;
	StobConditionScenarioConnectionWhere: StobConditionScenarioConnectionWhere;
	StobConditionScenarioCreateFieldInput: StobConditionScenarioCreateFieldInput;
	StobConditionScenarioDeleteFieldInput: StobConditionScenarioDeleteFieldInput;
	StobConditionScenarioDisconnectFieldInput: StobConditionScenarioDisconnectFieldInput;
	StobConditionScenarioFieldInput: StobConditionScenarioFieldInput;
	StobConditionScenarioNodeAggregationWhereInput: StobConditionScenarioNodeAggregationWhereInput;
	StobConditionScenarioRelationship: StobConditionScenarioRelationship;
	StobConditionScenarioUpdateConnectionInput: StobConditionScenarioUpdateConnectionInput;
	StobConditionScenarioUpdateFieldInput: StobConditionScenarioUpdateFieldInput;
	StobConditionSort: StobConditionSort;
	StobConditionUpdateInput: StobConditionUpdateInput;
	StobConditionWhere: StobConditionWhere;
	StobContract: StobContract;
	StobContractAggregateSelection: StobContractAggregateSelection;
	StobContractBasicInfoInput: StobContractBasicInfoInput;
	StobContractCasesAggregateInput: StobContractCasesAggregateInput;
	StobContractCasesConnectFieldInput: StobContractCasesConnectFieldInput;
	StobContractCasesConnection: StobContractCasesConnection;
	StobContractCasesConnectionSort: StobContractCasesConnectionSort;
	StobContractCasesConnectionWhere: StobContractCasesConnectionWhere;
	StobContractCasesCreateFieldInput: StobContractCasesCreateFieldInput;
	StobContractCasesDeleteFieldInput: StobContractCasesDeleteFieldInput;
	StobContractCasesDisconnectFieldInput: StobContractCasesDisconnectFieldInput;
	StobContractCasesFieldInput: StobContractCasesFieldInput;
	StobContractCasesNodeAggregationWhereInput: StobContractCasesNodeAggregationWhereInput;
	StobContractCasesRelationship: StobContractCasesRelationship;
	StobContractCasesUpdateConnectionInput: StobContractCasesUpdateConnectionInput;
	StobContractCasesUpdateFieldInput: StobContractCasesUpdateFieldInput;
	StobContractConnectInput: StobContractConnectInput;
	StobContractConnectWhere: StobContractConnectWhere;
	StobContractCreateInput: StobContractCreateInput;
	StobContractCreatorOrganizationAggregateInput: StobContractCreatorOrganizationAggregateInput;
	StobContractCreatorOrganizationConnectFieldInput: StobContractCreatorOrganizationConnectFieldInput;
	StobContractCreatorOrganizationConnection: StobContractCreatorOrganizationConnection;
	StobContractCreatorOrganizationConnectionSort: StobContractCreatorOrganizationConnectionSort;
	StobContractCreatorOrganizationConnectionWhere: StobContractCreatorOrganizationConnectionWhere;
	StobContractCreatorOrganizationCreateFieldInput: StobContractCreatorOrganizationCreateFieldInput;
	StobContractCreatorOrganizationDeleteFieldInput: StobContractCreatorOrganizationDeleteFieldInput;
	StobContractCreatorOrganizationDisconnectFieldInput: StobContractCreatorOrganizationDisconnectFieldInput;
	StobContractCreatorOrganizationFieldInput: StobContractCreatorOrganizationFieldInput;
	StobContractCreatorOrganizationNodeAggregationWhereInput: StobContractCreatorOrganizationNodeAggregationWhereInput;
	StobContractCreatorOrganizationRelationship: StobContractCreatorOrganizationRelationship;
	StobContractCreatorOrganizationUpdateConnectionInput: StobContractCreatorOrganizationUpdateConnectionInput;
	StobContractCreatorOrganizationUpdateFieldInput: StobContractCreatorOrganizationUpdateFieldInput;
	StobContractCurrencyAggregateInput: StobContractCurrencyAggregateInput;
	StobContractCurrencyConnectFieldInput: StobContractCurrencyConnectFieldInput;
	StobContractCurrencyConnection: StobContractCurrencyConnection;
	StobContractCurrencyConnectionSort: StobContractCurrencyConnectionSort;
	StobContractCurrencyConnectionWhere: StobContractCurrencyConnectionWhere;
	StobContractCurrencyCreateFieldInput: StobContractCurrencyCreateFieldInput;
	StobContractCurrencyDeleteFieldInput: StobContractCurrencyDeleteFieldInput;
	StobContractCurrencyDisconnectFieldInput: StobContractCurrencyDisconnectFieldInput;
	StobContractCurrencyFieldInput: StobContractCurrencyFieldInput;
	StobContractCurrencyNodeAggregationWhereInput: StobContractCurrencyNodeAggregationWhereInput;
	StobContractCurrencyRelationship: StobContractCurrencyRelationship;
	StobContractCurrencyUpdateConnectionInput: StobContractCurrencyUpdateConnectionInput;
	StobContractCurrencyUpdateFieldInput: StobContractCurrencyUpdateFieldInput;
	StobContractDeleteInput: StobContractDeleteInput;
	StobContractDisconnectInput: StobContractDisconnectInput;
	StobContractDiseaseAggregateInput: StobContractDiseaseAggregateInput;
	StobContractDiseaseConnectFieldInput: StobContractDiseaseConnectFieldInput;
	StobContractDiseaseConnection: StobContractDiseaseConnection;
	StobContractDiseaseConnectionSort: StobContractDiseaseConnectionSort;
	StobContractDiseaseConnectionWhere: StobContractDiseaseConnectionWhere;
	StobContractDiseaseCreateFieldInput: StobContractDiseaseCreateFieldInput;
	StobContractDiseaseDeleteFieldInput: StobContractDiseaseDeleteFieldInput;
	StobContractDiseaseDisconnectFieldInput: StobContractDiseaseDisconnectFieldInput;
	StobContractDiseaseFieldInput: StobContractDiseaseFieldInput;
	StobContractDiseaseNodeAggregationWhereInput: StobContractDiseaseNodeAggregationWhereInput;
	StobContractDiseaseRelationship: StobContractDiseaseRelationship;
	StobContractDiseaseUpdateConnectionInput: StobContractDiseaseUpdateConnectionInput;
	StobContractDiseaseUpdateFieldInput: StobContractDiseaseUpdateFieldInput;
	StobContractEligibilityInput: StobContractEligibilityInput;
	StobContractIndicationAggregateInput: StobContractIndicationAggregateInput;
	StobContractIndicationConnectFieldInput: StobContractIndicationConnectFieldInput;
	StobContractIndicationConnection: StobContractIndicationConnection;
	StobContractIndicationConnectionSort: StobContractIndicationConnectionSort;
	StobContractIndicationConnectionWhere: StobContractIndicationConnectionWhere;
	StobContractIndicationCreateFieldInput: StobContractIndicationCreateFieldInput;
	StobContractIndicationDeleteFieldInput: StobContractIndicationDeleteFieldInput;
	StobContractIndicationDisconnectFieldInput: StobContractIndicationDisconnectFieldInput;
	StobContractIndicationFieldInput: StobContractIndicationFieldInput;
	StobContractIndicationNodeAggregationWhereInput: StobContractIndicationNodeAggregationWhereInput;
	StobContractIndicationRelationship: StobContractIndicationRelationship;
	StobContractIndicationUpdateConnectionInput: StobContractIndicationUpdateConnectionInput;
	StobContractIndicationUpdateFieldInput: StobContractIndicationUpdateFieldInput;
	StobContractNotificationsAggregateInput: StobContractNotificationsAggregateInput;
	StobContractNotificationsConnectFieldInput: StobContractNotificationsConnectFieldInput;
	StobContractNotificationsConnection: StobContractNotificationsConnection;
	StobContractNotificationsConnectionSort: StobContractNotificationsConnectionSort;
	StobContractNotificationsConnectionWhere: StobContractNotificationsConnectionWhere;
	StobContractNotificationsCreateFieldInput: StobContractNotificationsCreateFieldInput;
	StobContractNotificationsDeleteFieldInput: StobContractNotificationsDeleteFieldInput;
	StobContractNotificationsDisconnectFieldInput: StobContractNotificationsDisconnectFieldInput;
	StobContractNotificationsFieldInput: StobContractNotificationsFieldInput;
	StobContractNotificationsNodeAggregationWhereInput: StobContractNotificationsNodeAggregationWhereInput;
	StobContractNotificationsRelationship: StobContractNotificationsRelationship;
	StobContractNotificationsUpdateConnectionInput: StobContractNotificationsUpdateConnectionInput;
	StobContractNotificationsUpdateFieldInput: StobContractNotificationsUpdateFieldInput;
	StobContractOptions: StobContractOptions;
	StobContractPartnerAggregateInput: StobContractPartnerAggregateInput;
	StobContractPartnerConnectFieldInput: StobContractPartnerConnectFieldInput;
	StobContractPartnerConnection: StobContractPartnerConnection;
	StobContractPartnerConnectionSort: StobContractPartnerConnectionSort;
	StobContractPartnerConnectionWhere: StobContractPartnerConnectionWhere;
	StobContractPartnerCreateFieldInput: StobContractPartnerCreateFieldInput;
	StobContractPartnerDeleteFieldInput: StobContractPartnerDeleteFieldInput;
	StobContractPartnerDisconnectFieldInput: StobContractPartnerDisconnectFieldInput;
	StobContractPartnerFieldInput: StobContractPartnerFieldInput;
	StobContractPartnerNodeAggregationWhereInput: StobContractPartnerNodeAggregationWhereInput;
	StobContractPartnerRelationship: StobContractPartnerRelationship;
	StobContractPartnerUpdateConnectionInput: StobContractPartnerUpdateConnectionInput;
	StobContractPartnerUpdateFieldInput: StobContractPartnerUpdateFieldInput;
	StobContractRecommendedFormsAggregateInput: StobContractRecommendedFormsAggregateInput;
	StobContractRecommendedFormsConnectFieldInput: StobContractRecommendedFormsConnectFieldInput;
	StobContractRecommendedFormsConnection: StobContractRecommendedFormsConnection;
	StobContractRecommendedFormsConnectionSort: StobContractRecommendedFormsConnectionSort;
	StobContractRecommendedFormsConnectionWhere: StobContractRecommendedFormsConnectionWhere;
	StobContractRecommendedFormsCreateFieldInput: StobContractRecommendedFormsCreateFieldInput;
	StobContractRecommendedFormsDeleteFieldInput: StobContractRecommendedFormsDeleteFieldInput;
	StobContractRecommendedFormsDisconnectFieldInput: StobContractRecommendedFormsDisconnectFieldInput;
	StobContractRecommendedFormsFieldInput: StobContractRecommendedFormsFieldInput;
	StobContractRecommendedFormsNodeAggregationWhereInput: StobContractRecommendedFormsNodeAggregationWhereInput;
	StobContractRecommendedFormsRelationship: StobContractRecommendedFormsRelationship;
	StobContractRecommendedFormsUpdateConnectionInput: StobContractRecommendedFormsUpdateConnectionInput;
	StobContractRecommendedFormsUpdateFieldInput: StobContractRecommendedFormsUpdateFieldInput;
	StobContractScenariosAggregateInput: StobContractScenariosAggregateInput;
	StobContractScenariosConnectFieldInput: StobContractScenariosConnectFieldInput;
	StobContractScenariosConnection: StobContractScenariosConnection;
	StobContractScenariosConnectionSort: StobContractScenariosConnectionSort;
	StobContractScenariosConnectionWhere: StobContractScenariosConnectionWhere;
	StobContractScenariosCreateFieldInput: StobContractScenariosCreateFieldInput;
	StobContractScenariosDeleteFieldInput: StobContractScenariosDeleteFieldInput;
	StobContractScenariosDisconnectFieldInput: StobContractScenariosDisconnectFieldInput;
	StobContractScenariosFieldInput: StobContractScenariosFieldInput;
	StobContractScenariosNodeAggregationWhereInput: StobContractScenariosNodeAggregationWhereInput;
	StobContractScenariosRelationship: StobContractScenariosRelationship;
	StobContractScenariosUpdateConnectionInput: StobContractScenariosUpdateConnectionInput;
	StobContractScenariosUpdateFieldInput: StobContractScenariosUpdateFieldInput;
	StobContractSort: StobContractSort;
	StobContractStatisticsAggregateInput: StobContractStatisticsAggregateInput;
	StobContractStatisticsConnectFieldInput: StobContractStatisticsConnectFieldInput;
	StobContractStatisticsConnection: StobContractStatisticsConnection;
	StobContractStatisticsConnectionSort: StobContractStatisticsConnectionSort;
	StobContractStatisticsConnectionWhere: StobContractStatisticsConnectionWhere;
	StobContractStatisticsCreateFieldInput: StobContractStatisticsCreateFieldInput;
	StobContractStatisticsDeleteFieldInput: StobContractStatisticsDeleteFieldInput;
	StobContractStatisticsDisconnectFieldInput: StobContractStatisticsDisconnectFieldInput;
	StobContractStatisticsFieldInput: StobContractStatisticsFieldInput;
	StobContractStatisticsNodeAggregationWhereInput: StobContractStatisticsNodeAggregationWhereInput;
	StobContractStatisticsRelationship: StobContractStatisticsRelationship;
	StobContractStatisticsUpdateConnectionInput: StobContractStatisticsUpdateConnectionInput;
	StobContractStatisticsUpdateFieldInput: StobContractStatisticsUpdateFieldInput;
	StobContractTagsAggregateInput: StobContractTagsAggregateInput;
	StobContractTagsConnectFieldInput: StobContractTagsConnectFieldInput;
	StobContractTagsConnection: StobContractTagsConnection;
	StobContractTagsConnectionSort: StobContractTagsConnectionSort;
	StobContractTagsConnectionWhere: StobContractTagsConnectionWhere;
	StobContractTagsCreateFieldInput: StobContractTagsCreateFieldInput;
	StobContractTagsDeleteFieldInput: StobContractTagsDeleteFieldInput;
	StobContractTagsDisconnectFieldInput: StobContractTagsDisconnectFieldInput;
	StobContractTagsFieldInput: StobContractTagsFieldInput;
	StobContractTagsNodeAggregationWhereInput: StobContractTagsNodeAggregationWhereInput;
	StobContractTagsRelationship: StobContractTagsRelationship;
	StobContractTagsUpdateConnectionInput: StobContractTagsUpdateConnectionInput;
	StobContractTagsUpdateFieldInput: StobContractTagsUpdateFieldInput;
	StobContractTreatmentPriceRelationship: ResolversParentTypes["StobContractTreatmentPricesRelationship"];
	StobContractTreatmentPriceRelationshipCreateInput: StobContractTreatmentPriceRelationshipCreateInput;
	StobContractTreatmentPriceRelationshipSort: StobContractTreatmentPriceRelationshipSort;
	StobContractTreatmentPriceRelationshipUpdateInput: StobContractTreatmentPriceRelationshipUpdateInput;
	StobContractTreatmentPriceRelationshipWhere: StobContractTreatmentPriceRelationshipWhere;
	StobContractTreatmentPricesAggregateInput: StobContractTreatmentPricesAggregateInput;
	StobContractTreatmentPricesConnectFieldInput: StobContractTreatmentPricesConnectFieldInput;
	StobContractTreatmentPricesConnection: StobContractTreatmentPricesConnection;
	StobContractTreatmentPricesConnectionSort: StobContractTreatmentPricesConnectionSort;
	StobContractTreatmentPricesConnectionWhere: StobContractTreatmentPricesConnectionWhere;
	StobContractTreatmentPricesCreateFieldInput: StobContractTreatmentPricesCreateFieldInput;
	StobContractTreatmentPricesDeleteFieldInput: StobContractTreatmentPricesDeleteFieldInput;
	StobContractTreatmentPricesDisconnectFieldInput: StobContractTreatmentPricesDisconnectFieldInput;
	StobContractTreatmentPricesEdgeAggregationWhereInput: StobContractTreatmentPricesEdgeAggregationWhereInput;
	StobContractTreatmentPricesFieldInput: StobContractTreatmentPricesFieldInput;
	StobContractTreatmentPricesNodeAggregationWhereInput: StobContractTreatmentPricesNodeAggregationWhereInput;
	StobContractTreatmentPricesRelationship: StobContractTreatmentPricesRelationship;
	StobContractTreatmentPricesUpdateConnectionInput: StobContractTreatmentPricesUpdateConnectionInput;
	StobContractTreatmentPricesUpdateFieldInput: StobContractTreatmentPricesUpdateFieldInput;
	StobContractUpdateInput: StobContractUpdateInput;
	StobContractWhere: StobContractWhere;
	StobMeasuresInput: StobMeasuresInput;
	StobPricingInput: StobPricingInput;
	StobScenario: StobScenario;
	StobScenarioActionsAggregateInput: StobScenarioActionsAggregateInput;
	StobScenarioActionsConnectFieldInput: StobScenarioActionsConnectFieldInput;
	StobScenarioActionsConnection: StobScenarioActionsConnection;
	StobScenarioActionsConnectionSort: StobScenarioActionsConnectionSort;
	StobScenarioActionsConnectionWhere: StobScenarioActionsConnectionWhere;
	StobScenarioActionsCreateFieldInput: StobScenarioActionsCreateFieldInput;
	StobScenarioActionsDeleteFieldInput: StobScenarioActionsDeleteFieldInput;
	StobScenarioActionsDisconnectFieldInput: StobScenarioActionsDisconnectFieldInput;
	StobScenarioActionsFieldInput: StobScenarioActionsFieldInput;
	StobScenarioActionsNodeAggregationWhereInput: StobScenarioActionsNodeAggregationWhereInput;
	StobScenarioActionsRelationship: StobScenarioActionsRelationship;
	StobScenarioActionsUpdateConnectionInput: StobScenarioActionsUpdateConnectionInput;
	StobScenarioActionsUpdateFieldInput: StobScenarioActionsUpdateFieldInput;
	StobScenarioAggregateSelection: StobScenarioAggregateSelection;
	StobScenarioConditionsAggregateInput: StobScenarioConditionsAggregateInput;
	StobScenarioConditionsConnectFieldInput: StobScenarioConditionsConnectFieldInput;
	StobScenarioConditionsConnection: StobScenarioConditionsConnection;
	StobScenarioConditionsConnectionSort: StobScenarioConditionsConnectionSort;
	StobScenarioConditionsConnectionWhere: StobScenarioConditionsConnectionWhere;
	StobScenarioConditionsCreateFieldInput: StobScenarioConditionsCreateFieldInput;
	StobScenarioConditionsDeleteFieldInput: StobScenarioConditionsDeleteFieldInput;
	StobScenarioConditionsDisconnectFieldInput: StobScenarioConditionsDisconnectFieldInput;
	StobScenarioConditionsFieldInput: StobScenarioConditionsFieldInput;
	StobScenarioConditionsNodeAggregationWhereInput: StobScenarioConditionsNodeAggregationWhereInput;
	StobScenarioConditionsRelationship: StobScenarioConditionsRelationship;
	StobScenarioConditionsUpdateConnectionInput: StobScenarioConditionsUpdateConnectionInput;
	StobScenarioConditionsUpdateFieldInput: StobScenarioConditionsUpdateFieldInput;
	StobScenarioConnectInput: StobScenarioConnectInput;
	StobScenarioConnectWhere: StobScenarioConnectWhere;
	StobScenarioCreateInput: StobScenarioCreateInput;
	StobScenarioDeleteInput: StobScenarioDeleteInput;
	StobScenarioDisconnectInput: StobScenarioDisconnectInput;
	StobScenarioInput: StobScenarioInput;
	StobScenarioOptions: StobScenarioOptions;
	StobScenarioSort: StobScenarioSort;
	StobScenarioUpdateInput: StobScenarioUpdateInput;
	StobScenarioWhere: StobScenarioWhere;
	StobStatistics: StobStatistics;
	StobStatisticsAggregateSelection: StobStatisticsAggregateSelection;
	StobStatisticsConnectWhere: StobStatisticsConnectWhere;
	StobStatisticsCreateInput: StobStatisticsCreateInput;
	StobStatisticsOptions: StobStatisticsOptions;
	StobStatisticsSort: StobStatisticsSort;
	StobStatisticsUpdateInput: StobStatisticsUpdateInput;
	StobStatisticsWhere: StobStatisticsWhere;
	StobTreatmentPriceInput: StobTreatmentPriceInput;
	String: Scalars["String"];
	StringAggregateSelection: StringAggregateSelection;
	Subscription: {};
	SummaryNotificationDue: ResolversParentTypes["NotificationDueRelationship"] | ResolversParentTypes["UserNotificationDueRelationship"];
	SummaryNotificationDueCreateInput: SummaryNotificationDueCreateInput;
	SummaryNotificationDueSort: SummaryNotificationDueSort;
	SummaryNotificationDueUpdateInput: SummaryNotificationDueUpdateInput;
	SummaryNotificationDueWhere: SummaryNotificationDueWhere;
	Task: Task;
	TaskAggregateSelection: TaskAggregateSelection;
	TaskAgreementAggregateInput: TaskAgreementAggregateInput;
	TaskAgreementConnectFieldInput: TaskAgreementConnectFieldInput;
	TaskAgreementConnection: TaskAgreementConnection;
	TaskAgreementConnectionSort: TaskAgreementConnectionSort;
	TaskAgreementConnectionWhere: TaskAgreementConnectionWhere;
	TaskAgreementCreateFieldInput: TaskAgreementCreateFieldInput;
	TaskAgreementDeleteFieldInput: TaskAgreementDeleteFieldInput;
	TaskAgreementDisconnectFieldInput: TaskAgreementDisconnectFieldInput;
	TaskAgreementFieldInput: TaskAgreementFieldInput;
	TaskAgreementNodeAggregationWhereInput: TaskAgreementNodeAggregationWhereInput;
	TaskAgreementRelationship: TaskAgreementRelationship;
	TaskAgreementUpdateConnectionInput: TaskAgreementUpdateConnectionInput;
	TaskAgreementUpdateFieldInput: TaskAgreementUpdateFieldInput;
	TaskCaseAggregateInput: TaskCaseAggregateInput;
	TaskCaseConnectFieldInput: TaskCaseConnectFieldInput;
	TaskCaseConnection: TaskCaseConnection;
	TaskCaseConnectionSort: TaskCaseConnectionSort;
	TaskCaseConnectionWhere: TaskCaseConnectionWhere;
	TaskCaseCreateFieldInput: TaskCaseCreateFieldInput;
	TaskCaseDeleteFieldInput: TaskCaseDeleteFieldInput;
	TaskCaseDisconnectFieldInput: TaskCaseDisconnectFieldInput;
	TaskCaseFieldInput: TaskCaseFieldInput;
	TaskCaseNodeAggregationWhereInput: TaskCaseNodeAggregationWhereInput;
	TaskCaseRelationship: TaskCaseRelationship;
	TaskCaseUpdateConnectionInput: TaskCaseUpdateConnectionInput;
	TaskCaseUpdateFieldInput: TaskCaseUpdateFieldInput;
	TaskConnectInput: TaskConnectInput;
	TaskConnectWhere: TaskConnectWhere;
	TaskCreateInput: TaskCreateInput;
	TaskDeleteInput: TaskDeleteInput;
	TaskDisconnectInput: TaskDisconnectInput;
	TaskDocumentAggregateInput: TaskDocumentAggregateInput;
	TaskDocumentConnectFieldInput: TaskDocumentConnectFieldInput;
	TaskDocumentConnection: TaskDocumentConnection;
	TaskDocumentConnectionSort: TaskDocumentConnectionSort;
	TaskDocumentConnectionWhere: TaskDocumentConnectionWhere;
	TaskDocumentCreateFieldInput: TaskDocumentCreateFieldInput;
	TaskDocumentDeleteFieldInput: TaskDocumentDeleteFieldInput;
	TaskDocumentDisconnectFieldInput: TaskDocumentDisconnectFieldInput;
	TaskDocumentFieldInput: TaskDocumentFieldInput;
	TaskDocumentNodeAggregationWhereInput: TaskDocumentNodeAggregationWhereInput;
	TaskDocumentRelationship: TaskDocumentRelationship;
	TaskDocumentUpdateConnectionInput: TaskDocumentUpdateConnectionInput;
	TaskDocumentUpdateFieldInput: TaskDocumentUpdateFieldInput;
	TaskMessageAggregateInput: TaskMessageAggregateInput;
	TaskMessageConnectFieldInput: TaskMessageConnectFieldInput;
	TaskMessageConnection: TaskMessageConnection;
	TaskMessageConnectionSort: TaskMessageConnectionSort;
	TaskMessageConnectionWhere: TaskMessageConnectionWhere;
	TaskMessageCreateFieldInput: TaskMessageCreateFieldInput;
	TaskMessageDeleteFieldInput: TaskMessageDeleteFieldInput;
	TaskMessageDisconnectFieldInput: TaskMessageDisconnectFieldInput;
	TaskMessageEdgeAggregationWhereInput: TaskMessageEdgeAggregationWhereInput;
	TaskMessageFieldInput: TaskMessageFieldInput;
	TaskMessageNodeAggregationWhereInput: TaskMessageNodeAggregationWhereInput;
	TaskMessageRelationship: TaskMessageRelationship;
	TaskMessageUpdateConnectionInput: TaskMessageUpdateConnectionInput;
	TaskMessageUpdateFieldInput: TaskMessageUpdateFieldInput;
	TaskOptions: TaskOptions;
	TaskSort: TaskSort;
	TaskUpdateInput: TaskUpdateInput;
	TaskUsersRelationshipAggregateInput: TaskUsersRelationshipAggregateInput;
	TaskUsersRelationshipConnectFieldInput: TaskUsersRelationshipConnectFieldInput;
	TaskUsersRelationshipConnection: TaskUsersRelationshipConnection;
	TaskUsersRelationshipConnectionSort: TaskUsersRelationshipConnectionSort;
	TaskUsersRelationshipConnectionWhere: TaskUsersRelationshipConnectionWhere;
	TaskUsersRelationshipCreateFieldInput: TaskUsersRelationshipCreateFieldInput;
	TaskUsersRelationshipDeleteFieldInput: TaskUsersRelationshipDeleteFieldInput;
	TaskUsersRelationshipDisconnectFieldInput: TaskUsersRelationshipDisconnectFieldInput;
	TaskUsersRelationshipFieldInput: TaskUsersRelationshipFieldInput;
	TaskUsersRelationshipNodeAggregationWhereInput: TaskUsersRelationshipNodeAggregationWhereInput;
	TaskUsersRelationshipRelationship: TaskUsersRelationshipRelationship;
	TaskUsersRelationshipUpdateConnectionInput: TaskUsersRelationshipUpdateConnectionInput;
	TaskUsersRelationshipUpdateFieldInput: TaskUsersRelationshipUpdateFieldInput;
	TaskWhere: TaskWhere;
	Timeframe: Timeframe;
	TimeframeAggregateSelection: TimeframeAggregateSelection;
	TimeframeConnectWhere: TimeframeConnectWhere;
	TimeframeCreateInput: TimeframeCreateInput;
	TimeframeOptions: TimeframeOptions;
	TimeframeRelatedEntity:
		| ResolversParentTypes["RecommendedForm"]
		| ResolversParentTypes["StobAction"]
		| ResolversParentTypes["StobCondition"];
	TimeframeSort: TimeframeSort;
	TimeframeUpdateInput: TimeframeUpdateInput;
	TimeframeWhere: TimeframeWhere;
	Translation: Translation;
	TranslationAggregateSelection: TranslationAggregateSelection;
	TranslationOptions: TranslationOptions;
	TranslationSort: TranslationSort;
	TranslationWhere: TranslationWhere;
	TranslationsResult: TranslationsResult;
	TranslationsResultAggregateSelection: TranslationsResultAggregateSelection;
	TranslationsResultOptions: TranslationsResultOptions;
	TranslationsResultSort: TranslationsResultSort;
	TranslationsResultWhere: TranslationsResultWhere;
	TreatingPhysician: TreatingPhysician;
	TreatingPhysicianAggregateSelection: TreatingPhysicianAggregateSelection;
	TreatingPhysicianConnectWhere: TreatingPhysicianConnectWhere;
	TreatingPhysicianCreateInput: TreatingPhysicianCreateInput;
	TreatingPhysicianInput: TreatingPhysicianInput;
	TreatingPhysicianOptions: TreatingPhysicianOptions;
	TreatingPhysicianSort: TreatingPhysicianSort;
	TreatingPhysicianUpdateInput: TreatingPhysicianUpdateInput;
	TreatingPhysicianWhere: TreatingPhysicianWhere;
	Treatment: Treatment;
	TreatmentAggregateSelection: TreatmentAggregateSelection;
	TreatmentClaimAggregateInput: TreatmentClaimAggregateInput;
	TreatmentClaimConnectFieldInput: TreatmentClaimConnectFieldInput;
	TreatmentClaimConnection: TreatmentClaimConnection;
	TreatmentClaimConnectionSort: TreatmentClaimConnectionSort;
	TreatmentClaimConnectionWhere: TreatmentClaimConnectionWhere;
	TreatmentClaimCreateFieldInput: TreatmentClaimCreateFieldInput;
	TreatmentClaimDeleteFieldInput: TreatmentClaimDeleteFieldInput;
	TreatmentClaimDisconnectFieldInput: TreatmentClaimDisconnectFieldInput;
	TreatmentClaimFieldInput: TreatmentClaimFieldInput;
	TreatmentClaimNodeAggregationWhereInput: TreatmentClaimNodeAggregationWhereInput;
	TreatmentClaimRelationship: TreatmentClaimRelationship;
	TreatmentClaimUpdateConnectionInput: TreatmentClaimUpdateConnectionInput;
	TreatmentClaimUpdateFieldInput: TreatmentClaimUpdateFieldInput;
	TreatmentConnectInput: TreatmentConnectInput;
	TreatmentConnectWhere: TreatmentConnectWhere;
	TreatmentCreateInput: TreatmentCreateInput;
	TreatmentDeleteInput: TreatmentDeleteInput;
	TreatmentDisconnectInput: TreatmentDisconnectInput;
	TreatmentExFactoryPricesAggregateInput: TreatmentExFactoryPricesAggregateInput;
	TreatmentExFactoryPricesConnectFieldInput: TreatmentExFactoryPricesConnectFieldInput;
	TreatmentExFactoryPricesConnection: TreatmentExFactoryPricesConnection;
	TreatmentExFactoryPricesConnectionSort: TreatmentExFactoryPricesConnectionSort;
	TreatmentExFactoryPricesConnectionWhere: TreatmentExFactoryPricesConnectionWhere;
	TreatmentExFactoryPricesCreateFieldInput: TreatmentExFactoryPricesCreateFieldInput;
	TreatmentExFactoryPricesDeleteFieldInput: TreatmentExFactoryPricesDeleteFieldInput;
	TreatmentExFactoryPricesDisconnectFieldInput: TreatmentExFactoryPricesDisconnectFieldInput;
	TreatmentExFactoryPricesFieldInput: TreatmentExFactoryPricesFieldInput;
	TreatmentExFactoryPricesNodeAggregationWhereInput: TreatmentExFactoryPricesNodeAggregationWhereInput;
	TreatmentExFactoryPricesRelationship: TreatmentExFactoryPricesRelationship;
	TreatmentExFactoryPricesUpdateConnectionInput: TreatmentExFactoryPricesUpdateConnectionInput;
	TreatmentExFactoryPricesUpdateFieldInput: TreatmentExFactoryPricesUpdateFieldInput;
	TreatmentHasLimitationsAggregateInput: TreatmentHasLimitationsAggregateInput;
	TreatmentHasLimitationsConnectFieldInput: TreatmentHasLimitationsConnectFieldInput;
	TreatmentHasLimitationsConnection: TreatmentHasLimitationsConnection;
	TreatmentHasLimitationsConnectionSort: TreatmentHasLimitationsConnectionSort;
	TreatmentHasLimitationsConnectionWhere: TreatmentHasLimitationsConnectionWhere;
	TreatmentHasLimitationsCreateFieldInput: TreatmentHasLimitationsCreateFieldInput;
	TreatmentHasLimitationsDeleteFieldInput: TreatmentHasLimitationsDeleteFieldInput;
	TreatmentHasLimitationsDisconnectFieldInput: TreatmentHasLimitationsDisconnectFieldInput;
	TreatmentHasLimitationsFieldInput: TreatmentHasLimitationsFieldInput;
	TreatmentHasLimitationsNodeAggregationWhereInput: TreatmentHasLimitationsNodeAggregationWhereInput;
	TreatmentHasLimitationsRelationship: TreatmentHasLimitationsRelationship;
	TreatmentHasLimitationsUpdateConnectionInput: TreatmentHasLimitationsUpdateConnectionInput;
	TreatmentHasLimitationsUpdateFieldInput: TreatmentHasLimitationsUpdateFieldInput;
	TreatmentOptions: TreatmentOptions;
	TreatmentPartnersAggregateInput: TreatmentPartnersAggregateInput;
	TreatmentPartnersConnectFieldInput: TreatmentPartnersConnectFieldInput;
	TreatmentPartnersConnection: TreatmentPartnersConnection;
	TreatmentPartnersConnectionSort: TreatmentPartnersConnectionSort;
	TreatmentPartnersConnectionWhere: TreatmentPartnersConnectionWhere;
	TreatmentPartnersCreateFieldInput: TreatmentPartnersCreateFieldInput;
	TreatmentPartnersDeleteFieldInput: TreatmentPartnersDeleteFieldInput;
	TreatmentPartnersDisconnectFieldInput: TreatmentPartnersDisconnectFieldInput;
	TreatmentPartnersFieldInput: TreatmentPartnersFieldInput;
	TreatmentPartnersNodeAggregationWhereInput: TreatmentPartnersNodeAggregationWhereInput;
	TreatmentPartnersRelationship: TreatmentPartnersRelationship;
	TreatmentPartnersUpdateConnectionInput: TreatmentPartnersUpdateConnectionInput;
	TreatmentPartnersUpdateFieldInput: TreatmentPartnersUpdateFieldInput;
	TreatmentPatient: TreatmentPatient;
	TreatmentPatientAggregateSelection: TreatmentPatientAggregateSelection;
	TreatmentPatientOptions: TreatmentPatientOptions;
	TreatmentPatientSort: TreatmentPatientSort;
	TreatmentPatientWhere: TreatmentPatientWhere;
	TreatmentPrescriptionRelationship: ResolversParentTypes["ContinuousBenefitPrescribedTreatmentsRelationship"];
	TreatmentPrescriptionRelationshipCreateInput: TreatmentPrescriptionRelationshipCreateInput;
	TreatmentPrescriptionRelationshipInput: TreatmentPrescriptionRelationshipInput;
	TreatmentPrescriptionRelationshipSort: TreatmentPrescriptionRelationshipSort;
	TreatmentPrescriptionRelationshipUpdateInput: TreatmentPrescriptionRelationshipUpdateInput;
	TreatmentPrescriptionRelationshipWhere: TreatmentPrescriptionRelationshipWhere;
	TreatmentPublicPricesAggregateInput: TreatmentPublicPricesAggregateInput;
	TreatmentPublicPricesConnectFieldInput: TreatmentPublicPricesConnectFieldInput;
	TreatmentPublicPricesConnection: TreatmentPublicPricesConnection;
	TreatmentPublicPricesConnectionSort: TreatmentPublicPricesConnectionSort;
	TreatmentPublicPricesConnectionWhere: TreatmentPublicPricesConnectionWhere;
	TreatmentPublicPricesCreateFieldInput: TreatmentPublicPricesCreateFieldInput;
	TreatmentPublicPricesDeleteFieldInput: TreatmentPublicPricesDeleteFieldInput;
	TreatmentPublicPricesDisconnectFieldInput: TreatmentPublicPricesDisconnectFieldInput;
	TreatmentPublicPricesFieldInput: TreatmentPublicPricesFieldInput;
	TreatmentPublicPricesNodeAggregationWhereInput: TreatmentPublicPricesNodeAggregationWhereInput;
	TreatmentPublicPricesRelationship: TreatmentPublicPricesRelationship;
	TreatmentPublicPricesUpdateConnectionInput: TreatmentPublicPricesUpdateConnectionInput;
	TreatmentPublicPricesUpdateFieldInput: TreatmentPublicPricesUpdateFieldInput;
	TreatmentRegulatedByAggregateInput: TreatmentRegulatedByAggregateInput;
	TreatmentRegulatedByConnectFieldInput: TreatmentRegulatedByConnectFieldInput;
	TreatmentRegulatedByConnection: TreatmentRegulatedByConnection;
	TreatmentRegulatedByConnectionSort: TreatmentRegulatedByConnectionSort;
	TreatmentRegulatedByConnectionWhere: TreatmentRegulatedByConnectionWhere;
	TreatmentRegulatedByCreateFieldInput: TreatmentRegulatedByCreateFieldInput;
	TreatmentRegulatedByDeleteFieldInput: TreatmentRegulatedByDeleteFieldInput;
	TreatmentRegulatedByDisconnectFieldInput: TreatmentRegulatedByDisconnectFieldInput;
	TreatmentRegulatedByFieldInput: TreatmentRegulatedByFieldInput;
	TreatmentRegulatedByNodeAggregationWhereInput: TreatmentRegulatedByNodeAggregationWhereInput;
	TreatmentRegulatedByRelationship: TreatmentRegulatedByRelationship;
	TreatmentRegulatedByUpdateConnectionInput: TreatmentRegulatedByUpdateConnectionInput;
	TreatmentRegulatedByUpdateFieldInput: TreatmentRegulatedByUpdateFieldInput;
	TreatmentSort: TreatmentSort;
	TreatmentStatusAggregateInput: TreatmentStatusAggregateInput;
	TreatmentStatusConnectFieldInput: TreatmentStatusConnectFieldInput;
	TreatmentStatusConnection: TreatmentStatusConnection;
	TreatmentStatusConnectionSort: TreatmentStatusConnectionSort;
	TreatmentStatusConnectionWhere: TreatmentStatusConnectionWhere;
	TreatmentStatusCreateFieldInput: TreatmentStatusCreateFieldInput;
	TreatmentStatusDeleteFieldInput: TreatmentStatusDeleteFieldInput;
	TreatmentStatusDisconnectFieldInput: TreatmentStatusDisconnectFieldInput;
	TreatmentStatusFieldInput: TreatmentStatusFieldInput;
	TreatmentStatusNodeAggregationWhereInput: TreatmentStatusNodeAggregationWhereInput;
	TreatmentStatusRelationship: TreatmentStatusRelationship;
	TreatmentStatusUpdateConnectionInput: TreatmentStatusUpdateConnectionInput;
	TreatmentStatusUpdateFieldInput: TreatmentStatusUpdateFieldInput;
	TreatmentUpdateInput: TreatmentUpdateInput;
	TreatmentWhere: TreatmentWhere;
	UniqueClaimsIdentifiers: UniqueClaimsIdentifiers;
	UniqueDeviceRecordIdentifiersInput: UniqueDeviceRecordIdentifiersInput;
	UpdateAdverseEventsOccurenceReportsMutationResponse: UpdateAdverseEventsOccurenceReportsMutationResponse;
	UpdateCaseAssigneeInput: UpdateCaseAssigneeInput;
	UpdateInfo: UpdateInfo;
	UpdateInitialResponseReviewReportsMutationResponse: UpdateInitialResponseReviewReportsMutationResponse;
	UpdateInvoiceForReviewInput: UpdateInvoiceForReviewInput;
	UpdateReasonOfTreatmentDiscontinuationReportsMutationResponse: UpdateReasonOfTreatmentDiscontinuationReportsMutationResponse;
	UpdateUsersMutationResponse: UpdateUsersMutationResponse;
	UploadClaimsInput: UploadClaimsInput;
	UploadDeviceRecordsInput: UploadDeviceRecordsInput;
	User: User;
	UserAggregateSelection: UserAggregateSelection;
	UserClaimsAggregateInput: UserClaimsAggregateInput;
	UserClaimsConnectFieldInput: UserClaimsConnectFieldInput;
	UserClaimsConnection: UserClaimsConnection;
	UserClaimsConnectionSort: UserClaimsConnectionSort;
	UserClaimsConnectionWhere: UserClaimsConnectionWhere;
	UserClaimsCreateFieldInput: UserClaimsCreateFieldInput;
	UserClaimsDeleteFieldInput: UserClaimsDeleteFieldInput;
	UserClaimsDisconnectFieldInput: UserClaimsDisconnectFieldInput;
	UserClaimsFieldInput: UserClaimsFieldInput;
	UserClaimsNodeAggregationWhereInput: UserClaimsNodeAggregationWhereInput;
	UserClaimsRelationship: UserClaimsRelationship;
	UserClaimsUpdateConnectionInput: UserClaimsUpdateConnectionInput;
	UserClaimsUpdateFieldInput: UserClaimsUpdateFieldInput;
	UserConnectInput: UserConnectInput;
	UserConnectWhere: UserConnectWhere;
	UserContext: UserContext;
	UserContextAggregateInput: UserContextAggregateInput;
	UserContextAggregateSelection: UserContextAggregateSelection;
	UserContextBaseAgreementContextAggregateInput: UserContextBaseAgreementContextAggregateInput;
	UserContextBaseAgreementContextConnectFieldInput: UserContextBaseAgreementContextConnectFieldInput;
	UserContextBaseAgreementContextConnection: UserContextBaseAgreementContextConnection;
	UserContextBaseAgreementContextConnectionSort: UserContextBaseAgreementContextConnectionSort;
	UserContextBaseAgreementContextConnectionWhere: UserContextBaseAgreementContextConnectionWhere;
	UserContextBaseAgreementContextCreateFieldInput: UserContextBaseAgreementContextCreateFieldInput;
	UserContextBaseAgreementContextDeleteFieldInput: UserContextBaseAgreementContextDeleteFieldInput;
	UserContextBaseAgreementContextDisconnectFieldInput: UserContextBaseAgreementContextDisconnectFieldInput;
	UserContextBaseAgreementContextEdgeAggregationWhereInput: UserContextBaseAgreementContextEdgeAggregationWhereInput;
	UserContextBaseAgreementContextFieldInput: UserContextBaseAgreementContextFieldInput;
	UserContextBaseAgreementContextNodeAggregationWhereInput: UserContextBaseAgreementContextNodeAggregationWhereInput;
	UserContextBaseAgreementContextRelationship: UserContextBaseAgreementContextRelationship;
	UserContextBaseAgreementContextUpdateConnectionInput: UserContextBaseAgreementContextUpdateConnectionInput;
	UserContextBaseAgreementContextUpdateFieldInput: UserContextBaseAgreementContextUpdateFieldInput;
	UserContextConnectFieldInput: UserContextConnectFieldInput;
	UserContextConnectInput: UserContextConnectInput;
	UserContextConnectWhere: UserContextConnectWhere;
	UserContextConnection: UserContextConnection;
	UserContextConnectionSort: UserContextConnectionSort;
	UserContextConnectionWhere: UserContextConnectionWhere;
	UserContextCreateFieldInput: UserContextCreateFieldInput;
	UserContextCreateInput: UserContextCreateInput;
	UserContextDeleteFieldInput: UserContextDeleteFieldInput;
	UserContextDeleteInput: UserContextDeleteInput;
	UserContextDisconnectFieldInput: UserContextDisconnectFieldInput;
	UserContextDisconnectInput: UserContextDisconnectInput;
	UserContextFieldInput: UserContextFieldInput;
	UserContextNodeAggregationWhereInput: UserContextNodeAggregationWhereInput;
	UserContextOptions: UserContextOptions;
	UserContextRelationship: UserContextRelationship;
	UserContextScenariosAggregateInput: UserContextScenariosAggregateInput;
	UserContextScenariosConnectFieldInput: UserContextScenariosConnectFieldInput;
	UserContextScenariosConnection: UserContextScenariosConnection;
	UserContextScenariosConnectionSort: UserContextScenariosConnectionSort;
	UserContextScenariosConnectionWhere: UserContextScenariosConnectionWhere;
	UserContextScenariosCreateFieldInput: UserContextScenariosCreateFieldInput;
	UserContextScenariosDeleteFieldInput: UserContextScenariosDeleteFieldInput;
	UserContextScenariosDisconnectFieldInput: UserContextScenariosDisconnectFieldInput;
	UserContextScenariosEdgeAggregationWhereInput: UserContextScenariosEdgeAggregationWhereInput;
	UserContextScenariosFieldInput: UserContextScenariosFieldInput;
	UserContextScenariosNodeAggregationWhereInput: UserContextScenariosNodeAggregationWhereInput;
	UserContextScenariosRelationship: UserContextScenariosRelationship;
	UserContextScenariosUpdateConnectionInput: UserContextScenariosUpdateConnectionInput;
	UserContextScenariosUpdateFieldInput: UserContextScenariosUpdateFieldInput;
	UserContextSort: UserContextSort;
	UserContextUpdateConnectionInput: UserContextUpdateConnectionInput;
	UserContextUpdateFieldInput: UserContextUpdateFieldInput;
	UserContextUpdateInput: UserContextUpdateInput;
	UserContextWhere: UserContextWhere;
	UserCreateInput: UserCreateInput;
	UserDeleteInput: UserDeleteInput;
	UserDisconnectInput: UserDisconnectInput;
	UserInput: UserInput;
	UserMentionsAggregateInput: UserMentionsAggregateInput;
	UserMentionsConnectFieldInput: UserMentionsConnectFieldInput;
	UserMentionsConnection: UserMentionsConnection;
	UserMentionsConnectionSort: UserMentionsConnectionSort;
	UserMentionsConnectionWhere: UserMentionsConnectionWhere;
	UserMentionsCreateFieldInput: UserMentionsCreateFieldInput;
	UserMentionsDeleteFieldInput: UserMentionsDeleteFieldInput;
	UserMentionsDisconnectFieldInput: UserMentionsDisconnectFieldInput;
	UserMentionsFieldInput: UserMentionsFieldInput;
	UserMentionsNodeAggregationWhereInput: UserMentionsNodeAggregationWhereInput;
	UserMentionsRelationship: UserMentionsRelationship;
	UserMentionsUpdateConnectionInput: UserMentionsUpdateConnectionInput;
	UserMentionsUpdateFieldInput: UserMentionsUpdateFieldInput;
	UserMessageRelationship: ResolversParentTypes["TaskMessageRelationship"];
	UserMessageRelationshipCreateInput: UserMessageRelationshipCreateInput;
	UserMessageRelationshipSort: UserMessageRelationshipSort;
	UserMessageRelationshipUpdateInput: UserMessageRelationshipUpdateInput;
	UserMessageRelationshipWhere: UserMessageRelationshipWhere;
	UserNotificationDueAggregateInput: UserNotificationDueAggregateInput;
	UserNotificationDueConnectFieldInput: UserNotificationDueConnectFieldInput;
	UserNotificationDueConnection: UserNotificationDueConnection;
	UserNotificationDueConnectionSort: UserNotificationDueConnectionSort;
	UserNotificationDueConnectionWhere: UserNotificationDueConnectionWhere;
	UserNotificationDueCreateFieldInput: UserNotificationDueCreateFieldInput;
	UserNotificationDueDeleteFieldInput: UserNotificationDueDeleteFieldInput;
	UserNotificationDueDisconnectFieldInput: UserNotificationDueDisconnectFieldInput;
	UserNotificationDueEdgeAggregationWhereInput: UserNotificationDueEdgeAggregationWhereInput;
	UserNotificationDueFieldInput: UserNotificationDueFieldInput;
	UserNotificationDueNodeAggregationWhereInput: UserNotificationDueNodeAggregationWhereInput;
	UserNotificationDueRelationship: UserNotificationDueRelationship;
	UserNotificationDueUpdateConnectionInput: UserNotificationDueUpdateConnectionInput;
	UserNotificationDueUpdateFieldInput: UserNotificationDueUpdateFieldInput;
	UserNotificationRelationship:
		| ResolversParentTypes["NotificationNotifiedRelationship"]
		| ResolversParentTypes["UserNotifiedRelationship"];
	UserNotificationRelationshipCreateInput: UserNotificationRelationshipCreateInput;
	UserNotificationRelationshipSort: UserNotificationRelationshipSort;
	UserNotificationRelationshipUpdateInput: UserNotificationRelationshipUpdateInput;
	UserNotificationRelationshipWhere: UserNotificationRelationshipWhere;
	UserNotifiedAggregateInput: UserNotifiedAggregateInput;
	UserNotifiedConnectFieldInput: UserNotifiedConnectFieldInput;
	UserNotifiedConnection: UserNotifiedConnection;
	UserNotifiedConnectionSort: UserNotifiedConnectionSort;
	UserNotifiedConnectionWhere: UserNotifiedConnectionWhere;
	UserNotifiedCreateFieldInput: UserNotifiedCreateFieldInput;
	UserNotifiedDeleteFieldInput: UserNotifiedDeleteFieldInput;
	UserNotifiedDisconnectFieldInput: UserNotifiedDisconnectFieldInput;
	UserNotifiedEdgeAggregationWhereInput: UserNotifiedEdgeAggregationWhereInput;
	UserNotifiedFieldInput: UserNotifiedFieldInput;
	UserNotifiedNodeAggregationWhereInput: UserNotifiedNodeAggregationWhereInput;
	UserNotifiedRelationship: UserNotifiedRelationship;
	UserNotifiedUpdateConnectionInput: UserNotifiedUpdateConnectionInput;
	UserNotifiedUpdateFieldInput: UserNotifiedUpdateFieldInput;
	UserOptions: UserOptions;
	UserOrgSettingsData: UserOrgSettingsData;
	UserOrgSettingsDataAggregateSelection: UserOrgSettingsDataAggregateSelection;
	UserOrgSettingsDataOptions: UserOrgSettingsDataOptions;
	UserOrgSettingsDataSort: UserOrgSettingsDataSort;
	UserOrgSettingsDataWhere: UserOrgSettingsDataWhere;
	UserOrganizationInfo: UserOrganizationInfo;
	UserOrganizationInfoAggregateSelection: UserOrganizationInfoAggregateSelection;
	UserOrganizationInfoOptions: UserOrganizationInfoOptions;
	UserOrganizationInfoSort: UserOrganizationInfoSort;
	UserOrganizationInfoWhere: UserOrganizationInfoWhere;
	UserPatientsAggregateInput: UserPatientsAggregateInput;
	UserPatientsConnectFieldInput: UserPatientsConnectFieldInput;
	UserPatientsConnection: UserPatientsConnection;
	UserPatientsConnectionSort: UserPatientsConnectionSort;
	UserPatientsConnectionWhere: UserPatientsConnectionWhere;
	UserPatientsCreateFieldInput: UserPatientsCreateFieldInput;
	UserPatientsDeleteFieldInput: UserPatientsDeleteFieldInput;
	UserPatientsDisconnectFieldInput: UserPatientsDisconnectFieldInput;
	UserPatientsFieldInput: UserPatientsFieldInput;
	UserPatientsNodeAggregationWhereInput: UserPatientsNodeAggregationWhereInput;
	UserPatientsRelationship: UserPatientsRelationship;
	UserPatientsUpdateConnectionInput: UserPatientsUpdateConnectionInput;
	UserPatientsUpdateFieldInput: UserPatientsUpdateFieldInput;
	UserPersonalInfo: UserPersonalInfo;
	UserPersonalInfoAggregateSelection: UserPersonalInfoAggregateSelection;
	UserPersonalInfoInput: UserPersonalInfoInput;
	UserPersonalInfoOptions: UserPersonalInfoOptions;
	UserPersonalInfoSort: UserPersonalInfoSort;
	UserPersonalInfoWhere: UserPersonalInfoWhere;
	UserRelationInput: UserRelationInput;
	UserRoleRequestUpdateInput: UserRoleRequestUpdateInput;
	UserSentMessageAggregateInput: UserSentMessageAggregateInput;
	UserSentMessageConnectFieldInput: UserSentMessageConnectFieldInput;
	UserSentMessageConnection: UserSentMessageConnection;
	UserSentMessageConnectionSort: UserSentMessageConnectionSort;
	UserSentMessageConnectionWhere: UserSentMessageConnectionWhere;
	UserSentMessageCreateFieldInput: UserSentMessageCreateFieldInput;
	UserSentMessageDeleteFieldInput: UserSentMessageDeleteFieldInput;
	UserSentMessageDisconnectFieldInput: UserSentMessageDisconnectFieldInput;
	UserSentMessageFieldInput: UserSentMessageFieldInput;
	UserSentMessageNodeAggregationWhereInput: UserSentMessageNodeAggregationWhereInput;
	UserSentMessageRelationship: UserSentMessageRelationship;
	UserSentMessageUpdateConnectionInput: UserSentMessageUpdateConnectionInput;
	UserSentMessageUpdateFieldInput: UserSentMessageUpdateFieldInput;
	UserSort: UserSort;
	UserSubscribedAggregateInput: UserSubscribedAggregateInput;
	UserSubscribedConnectFieldInput: UserSubscribedConnectFieldInput;
	UserSubscribedConnection: UserSubscribedConnection;
	UserSubscribedConnectionSort: UserSubscribedConnectionSort;
	UserSubscribedConnectionWhere: UserSubscribedConnectionWhere;
	UserSubscribedCreateFieldInput: UserSubscribedCreateFieldInput;
	UserSubscribedDeleteFieldInput: UserSubscribedDeleteFieldInput;
	UserSubscribedDisconnectFieldInput: UserSubscribedDisconnectFieldInput;
	UserSubscribedFieldInput: UserSubscribedFieldInput;
	UserSubscribedNodeAggregationWhereInput: UserSubscribedNodeAggregationWhereInput;
	UserSubscribedRelationship: UserSubscribedRelationship;
	UserSubscribedUpdateConnectionInput: UserSubscribedUpdateConnectionInput;
	UserSubscribedUpdateFieldInput: UserSubscribedUpdateFieldInput;
	UserTaskProperties: ResolversParentTypes["UserTasksRelationship"];
	UserTaskPropertiesCreateInput: UserTaskPropertiesCreateInput;
	UserTaskPropertiesSort: UserTaskPropertiesSort;
	UserTaskPropertiesUpdateInput: UserTaskPropertiesUpdateInput;
	UserTaskPropertiesWhere: UserTaskPropertiesWhere;
	UserTaskRelationship: ResolversParentTypes["TaskUsersRelationshipRelationship"];
	UserTaskRelationshipCreateInput: UserTaskRelationshipCreateInput;
	UserTaskRelationshipSort: UserTaskRelationshipSort;
	UserTaskRelationshipUpdateInput: UserTaskRelationshipUpdateInput;
	UserTaskRelationshipWhere: UserTaskRelationshipWhere;
	UserTasksAggregateInput: UserTasksAggregateInput;
	UserTasksConnectFieldInput: UserTasksConnectFieldInput;
	UserTasksConnection: UserTasksConnection;
	UserTasksConnectionSort: UserTasksConnectionSort;
	UserTasksConnectionWhere: UserTasksConnectionWhere;
	UserTasksCreateFieldInput: UserTasksCreateFieldInput;
	UserTasksDeleteFieldInput: UserTasksDeleteFieldInput;
	UserTasksDisconnectFieldInput: UserTasksDisconnectFieldInput;
	UserTasksFieldInput: UserTasksFieldInput;
	UserTasksNodeAggregationWhereInput: UserTasksNodeAggregationWhereInput;
	UserTasksRelationship: UserTasksRelationship;
	UserTasksUpdateConnectionInput: UserTasksUpdateConnectionInput;
	UserTasksUpdateFieldInput: UserTasksUpdateFieldInput;
	UserUpdateInput: UserUpdateInput;
	UserWhere: UserWhere;
	WorkflowParticipantDecisionInput: WorkflowParticipantDecisionInput;
};

export type DataGuidanceDirectiveArgs = {};

export type DataGuidanceDirectiveResolver<Result, Parent, ContextType = any, Args = DataGuidanceDirectiveArgs> = DirectiveResolverFn<
	Result,
	Parent,
	ContextType,
	Args
>;

export type AdverseEventResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["AdverseEvent"] = ResolversParentTypes["AdverseEvent"]
> = {
	TRAE?: Resolver<Maybe<ResolversTypes["Boolean"]>, ParentType, ContextType>;
	adverseEvent?: Resolver<Maybe<ResolversTypes["AdverseEventType"]>, ParentType, ContextType>;
	assessmentDate?: Resolver<Maybe<ResolversTypes["Date"]>, ParentType, ContextType>;
	doseModification?: Resolver<Maybe<ResolversTypes["IRAdverseEventDoseModifications"]>, ParentType, ContextType>;
	grade?: Resolver<Maybe<ResolversTypes["AdverseEventGrades"]>, ParentType, ContextType>;
	id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
	initialResponse?: Resolver<
		Maybe<ResolversTypes["InitialResponse"]>,
		ParentType,
		ContextType,
		RequireFields<AdverseEventInitialResponseArgs, never>
	>;
	initialResponseConnection?: Resolver<
		ResolversTypes["AdverseEventInitialResponseConnection"],
		ParentType,
		ContextType,
		RequireFields<AdverseEventInitialResponseConnectionArgs, never>
	>;
	status?: Resolver<Maybe<ResolversTypes["RecordStatus"]>, ParentType, ContextType>;
	tenantId?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AdverseEventAggregateSelectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["AdverseEventAggregateSelection"] = ResolversParentTypes["AdverseEventAggregateSelection"]
> = {
	count?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	id?: Resolver<ResolversTypes["IDAggregateSelection"], ParentType, ContextType>;
	tenantId?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AdverseEventCounterpartiesResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["AdverseEventCounterparties"] = ResolversParentTypes["AdverseEventCounterparties"]
> = {
	id?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	name?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	role?: Resolver<ResolversTypes["CounterpartyRole"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AdverseEventCounterpartiesAggregateSelectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["AdverseEventCounterpartiesAggregateSelection"] = ResolversParentTypes["AdverseEventCounterpartiesAggregateSelection"]
> = {
	count?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	id?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	name?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AdverseEventInitialResponseConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["AdverseEventInitialResponseConnection"] = ResolversParentTypes["AdverseEventInitialResponseConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["AdverseEventInitialResponseRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AdverseEventInitialResponseRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["AdverseEventInitialResponseRelationship"] = ResolversParentTypes["AdverseEventInitialResponseRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["InitialResponse"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AdverseEventReportResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["AdverseEventReport"] = ResolversParentTypes["AdverseEventReport"]
> = {
	adverseEvents?: Resolver<Array<ResolversTypes["AdverseEvent"]>, ParentType, ContextType>;
	agreementId?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	agreementName?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	caseId?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	diseaseName?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	formPreparationBrandName?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	id?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	indicationCode?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	initials?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	preparationBrandName?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	tags?: Resolver<Array<ResolversTypes["AgreementTag"]>, ParentType, ContextType>;
	therapyStartDate?: Resolver<Maybe<ResolversTypes["Date"]>, ParentType, ContextType>;
	treatingPhysician?: Resolver<Maybe<ResolversTypes["TreatingPhysician"]>, ParentType, ContextType>;
	yearOfBirth?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AdverseEventReportAggregateSelectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["AdverseEventReportAggregateSelection"] = ResolversParentTypes["AdverseEventReportAggregateSelection"]
> = {
	agreementId?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	agreementName?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	caseId?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	count?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	diseaseName?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	formPreparationBrandName?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	id?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	indicationCode?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	initials?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	preparationBrandName?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	yearOfBirth?: Resolver<ResolversTypes["IntAggregateSelection"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AdverseEventsOccurenceReportResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["AdverseEventsOccurenceReport"] = ResolversParentTypes["AdverseEventsOccurenceReport"]
> = {
	adverseEvent?: Resolver<Maybe<ResolversTypes["AdverseEventType"]>, ParentType, ContextType>;
	gradeICount?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
	gradeIICount?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
	gradeIIICount?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
	gradeIVCount?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AdverseEventsOccurenceReportAggregateSelectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["AdverseEventsOccurenceReportAggregateSelection"] = ResolversParentTypes["AdverseEventsOccurenceReportAggregateSelection"]
> = {
	count?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	gradeICount?: Resolver<ResolversTypes["IntAggregateSelection"], ParentType, ContextType>;
	gradeIICount?: Resolver<ResolversTypes["IntAggregateSelection"], ParentType, ContextType>;
	gradeIIICount?: Resolver<ResolversTypes["IntAggregateSelection"], ParentType, ContextType>;
	gradeIVCount?: Resolver<ResolversTypes["IntAggregateSelection"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["Agreement"] = ResolversParentTypes["Agreement"]
> = {
	allowedForms?: Resolver<Maybe<Array<ResolversTypes["FormType"]>>, ParentType, ContextType>;
	canParticipateInApproval?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
	canUserViewFinancials?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
	counterpartyRoles?: Resolver<
		Array<ResolversTypes["Organization"]>,
		ParentType,
		ContextType,
		RequireFields<AgreementCounterpartyRolesArgs, never>
	>;
	counterpartyRolesConnection?: Resolver<
		ResolversTypes["AgreementCounterpartyRolesConnection"],
		ParentType,
		ContextType,
		RequireFields<AgreementCounterpartyRolesConnectionArgs, never>
	>;
	currency?: Resolver<Maybe<ResolversTypes["Currency"]>, ParentType, ContextType, RequireFields<AgreementCurrencyArgs, never>>;
	currencyConnection?: Resolver<
		ResolversTypes["AgreementCurrencyConnection"],
		ParentType,
		ContextType,
		RequireFields<AgreementCurrencyConnectionArgs, never>
	>;
	description?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	deviceAlternativeSets?: Resolver<
		Array<ResolversTypes["DeviceAlternative"]>,
		ParentType,
		ContextType,
		RequireFields<AgreementDeviceAlternativeSetsArgs, never>
	>;
	deviceAlternativeSetsConnection?: Resolver<
		ResolversTypes["AgreementDeviceAlternativeSetsConnection"],
		ParentType,
		ContextType,
		RequireFields<AgreementDeviceAlternativeSetsConnectionArgs, never>
	>;
	formattedAmount?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	formattedCounterparties?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	formattedProducts?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	formattedTags?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	formattedValidityPeriod?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
	initialVersionId?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	isApprovedByOrganization?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
	isArchived?: Resolver<Maybe<ResolversTypes["Boolean"]>, ParentType, ContextType>;
	isDeleted?: Resolver<Maybe<ResolversTypes["Boolean"]>, ParentType, ContextType>;
	isFirstVersion?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
	isHidden?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
	isInsightsAvailable?: Resolver<Maybe<ResolversTypes["Boolean"]>, ParentType, ContextType>;
	isLastVersion?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
	isRatingEnabled?: Resolver<Maybe<ResolversTypes["Boolean"]>, ParentType, ContextType>;
	isStobContract?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
	isTherapyDecisionEnabled?: Resolver<Maybe<ResolversTypes["Boolean"]>, ParentType, ContextType>;
	lastVersionValidToDate?: Resolver<Maybe<ResolversTypes["Date"]>, ParentType, ContextType>;
	name?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	status?: Resolver<Maybe<ResolversTypes["ContractStatus"]>, ParentType, ContextType>;
	tags?: Resolver<Array<ResolversTypes["AgreementTag"]>, ParentType, ContextType, RequireFields<AgreementTagsArgs, never>>;
	tagsConnection?: Resolver<
		ResolversTypes["AgreementTagsConnection"],
		ParentType,
		ContextType,
		RequireFields<AgreementTagsConnectionArgs, never>
	>;
	tenantIds?: Resolver<Maybe<Array<ResolversTypes["String"]>>, ParentType, ContextType>;
	totalAmount?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
	unlimited?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
	userOrganizationRole?: Resolver<Maybe<ResolversTypes["CounterpartyRole"]>, ParentType, ContextType>;
	userRoles?: Resolver<Array<ResolversTypes["User"]>, ParentType, ContextType, RequireFields<AgreementUserRolesArgs, never>>;
	userRolesConnection?: Resolver<
		ResolversTypes["AgreementUserRolesConnection"],
		ParentType,
		ContextType,
		RequireFields<AgreementUserRolesConnectionArgs, never>
	>;
	validFromDate?: Resolver<ResolversTypes["Date"], ParentType, ContextType>;
	validToDate?: Resolver<Maybe<ResolversTypes["Date"]>, ParentType, ContextType>;
	workflows?: Resolver<Array<ResolversTypes["ContractWorkflow"]>, ParentType, ContextType, RequireFields<AgreementWorkflowsArgs, never>>;
	workflowsConnection?: Resolver<
		ResolversTypes["AgreementWorkflowsConnection"],
		ParentType,
		ContextType,
		RequireFields<AgreementWorkflowsConnectionArgs, never>
	>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementAggregateSelectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["AgreementAggregateSelection"] = ResolversParentTypes["AgreementAggregateSelection"]
> = {
	count?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	description?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	formattedAmount?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	formattedCounterparties?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	formattedProducts?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	formattedTags?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	formattedValidityPeriod?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	id?: Resolver<ResolversTypes["IDAggregateSelection"], ParentType, ContextType>;
	initialVersionId?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	name?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	totalAmount?: Resolver<ResolversTypes["FloatAggregateSelection"], ParentType, ContextType>;
	unlimited?: Resolver<ResolversTypes["IntAggregateSelection"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementCounterpartyRolesConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["AgreementCounterpartyRolesConnection"] = ResolversParentTypes["AgreementCounterpartyRolesConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["AgreementCounterpartyRolesRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementCounterpartyRolesRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["AgreementCounterpartyRolesRelationship"] = ResolversParentTypes["AgreementCounterpartyRolesRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["Organization"], ParentType, ContextType>;
	role?: Resolver<ResolversTypes["CounterpartyRole"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementCurrencyConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["AgreementCurrencyConnection"] = ResolversParentTypes["AgreementCurrencyConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["AgreementCurrencyRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementCurrencyRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["AgreementCurrencyRelationship"] = ResolversParentTypes["AgreementCurrencyRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["Currency"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementDecisionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["AgreementDecision"] = ResolversParentTypes["AgreementDecision"]
> = {
	asOf?: Resolver<ResolversTypes["Organization"], ParentType, ContextType, RequireFields<AgreementDecisionAsOfArgs, never>>;
	asOfConnection?: Resolver<
		ResolversTypes["AgreementDecisionAsOfConnection"],
		ParentType,
		ContextType,
		RequireFields<AgreementDecisionAsOfConnectionArgs, never>
	>;
	createdOn?: Resolver<ResolversTypes["DateTime"], ParentType, ContextType>;
	decision?: Resolver<ResolversTypes["Decision"], ParentType, ContextType>;
	isArchived?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
	madeBy?: Resolver<ResolversTypes["User"], ParentType, ContextType, RequireFields<AgreementDecisionMadeByArgs, never>>;
	madeByConnection?: Resolver<
		ResolversTypes["AgreementDecisionMadeByConnection"],
		ParentType,
		ContextType,
		RequireFields<AgreementDecisionMadeByConnectionArgs, never>
	>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementDecisionAggregateSelectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["AgreementDecisionAggregateSelection"] = ResolversParentTypes["AgreementDecisionAggregateSelection"]
> = {
	count?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	createdOn?: Resolver<ResolversTypes["DateTimeAggregateSelection"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementDecisionAsOfConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["AgreementDecisionAsOfConnection"] = ResolversParentTypes["AgreementDecisionAsOfConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["AgreementDecisionAsOfRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementDecisionAsOfRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["AgreementDecisionAsOfRelationship"] = ResolversParentTypes["AgreementDecisionAsOfRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["Organization"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementDecisionMadeByConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["AgreementDecisionMadeByConnection"] = ResolversParentTypes["AgreementDecisionMadeByConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["AgreementDecisionMadeByRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementDecisionMadeByRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["AgreementDecisionMadeByRelationship"] = ResolversParentTypes["AgreementDecisionMadeByRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["User"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementDeviceAlternativeSetsConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["AgreementDeviceAlternativeSetsConnection"] = ResolversParentTypes["AgreementDeviceAlternativeSetsConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["AgreementDeviceAlternativeSetsRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementDeviceAlternativeSetsRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["AgreementDeviceAlternativeSetsRelationship"] = ResolversParentTypes["AgreementDeviceAlternativeSetsRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["DeviceAlternative"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementFinancialSummaryColumnRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["AgreementFinancialSummaryColumnRelationship"] = ResolversParentTypes["AgreementFinancialSummaryColumnRelationship"]
> = {
	__resolveType: TypeResolveFn<"BaseAgreementFinancialSummaryConfigRelationship", ParentType, ContextType>;
	hasHelpMessage?: Resolver<Maybe<ResolversTypes["Boolean"]>, ParentType, ContextType>;
	isIncluded?: Resolver<Maybe<ResolversTypes["Boolean"]>, ParentType, ContextType>;
	localizationKey?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	position?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
};

export type AgreementReportResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["AgreementReport"] = ResolversParentTypes["AgreementReport"]
> = {
	discountAmount?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
	discountAmountDelta?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
	discountRatio?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
	discountRatioDelta?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
	discountsPerCase?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
	discountsPerCaseDiscontinued?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
	durationMonths?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
	durationMonthsDiscontinued?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
	financialReportDataPoints?: Resolver<Array<ResolversTypes["FinancialReportDataPoint"]>, ParentType, ContextType>;
	financialSummaryRows?: Resolver<Array<ResolversTypes["FinancialSummaryRow"]>, ParentType, ContextType>;
	grossAmount?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
	grossAmountDelta?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
	grossAmountPerCase?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
	grossAmountPerCaseDiscontinued?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
	netAmount?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
	netAmountPerCase?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
	netAmountPerCaseDiscontinued?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
	organizationNetRevenues?: Resolver<Array<ResolversTypes["NetRevenueByOrganization"]>, ParentType, ContextType>;
	patientReportDataPoints?: Resolver<Array<ResolversTypes["PatientReportDataPoint"]>, ParentType, ContextType>;
	treatmentDurationData?: Resolver<Array<ResolversTypes["CaseReportDataPoint"]>, ParentType, ContextType>;
	treatmentPatients?: Resolver<Array<ResolversTypes["TreatmentPatient"]>, ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementReportAggregateSelectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["AgreementReportAggregateSelection"] = ResolversParentTypes["AgreementReportAggregateSelection"]
> = {
	count?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	discountAmount?: Resolver<ResolversTypes["FloatAggregateSelection"], ParentType, ContextType>;
	discountAmountDelta?: Resolver<ResolversTypes["FloatAggregateSelection"], ParentType, ContextType>;
	discountRatio?: Resolver<ResolversTypes["FloatAggregateSelection"], ParentType, ContextType>;
	discountRatioDelta?: Resolver<ResolversTypes["FloatAggregateSelection"], ParentType, ContextType>;
	discountsPerCase?: Resolver<ResolversTypes["FloatAggregateSelection"], ParentType, ContextType>;
	discountsPerCaseDiscontinued?: Resolver<ResolversTypes["FloatAggregateSelection"], ParentType, ContextType>;
	durationMonths?: Resolver<ResolversTypes["IntAggregateSelection"], ParentType, ContextType>;
	durationMonthsDiscontinued?: Resolver<ResolversTypes["IntAggregateSelection"], ParentType, ContextType>;
	grossAmount?: Resolver<ResolversTypes["FloatAggregateSelection"], ParentType, ContextType>;
	grossAmountDelta?: Resolver<ResolversTypes["FloatAggregateSelection"], ParentType, ContextType>;
	grossAmountPerCase?: Resolver<ResolversTypes["FloatAggregateSelection"], ParentType, ContextType>;
	grossAmountPerCaseDiscontinued?: Resolver<ResolversTypes["FloatAggregateSelection"], ParentType, ContextType>;
	netAmount?: Resolver<ResolversTypes["FloatAggregateSelection"], ParentType, ContextType>;
	netAmountPerCase?: Resolver<ResolversTypes["FloatAggregateSelection"], ParentType, ContextType>;
	netAmountPerCaseDiscontinued?: Resolver<ResolversTypes["FloatAggregateSelection"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementSpecificRoleResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["AgreementSpecificRole"] = ResolversParentTypes["AgreementSpecificRole"]
> = {
	agreementId?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
	agreementName?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	agreementTags?: Resolver<Array<ResolversTypes["String"]>, ParentType, ContextType>;
	agreementUserRole?: Resolver<Maybe<ResolversTypes["AgreementUserRole"]>, ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementSpecificRoleAggregateSelectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["AgreementSpecificRoleAggregateSelection"] = ResolversParentTypes["AgreementSpecificRoleAggregateSelection"]
> = {
	agreementId?: Resolver<ResolversTypes["IDAggregateSelection"], ParentType, ContextType>;
	agreementName?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	count?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementStatusTransitionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["AgreementStatusTransition"] = ResolversParentTypes["AgreementStatusTransition"]
> = {
	causedBy?: Resolver<
		Maybe<ResolversTypes["User"]>,
		ParentType,
		ContextType,
		RequireFields<AgreementStatusTransitionCausedByArgs, never>
	>;
	causedByConnection?: Resolver<
		ResolversTypes["AgreementStatusTransitionCausedByConnection"],
		ParentType,
		ContextType,
		RequireFields<AgreementStatusTransitionCausedByConnectionArgs, never>
	>;
	createdOn?: Resolver<ResolversTypes["DateTime"], ParentType, ContextType>;
	from?: Resolver<Maybe<ResolversTypes["ContractStatus"]>, ParentType, ContextType>;
	to?: Resolver<ResolversTypes["ContractStatus"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementStatusTransitionAggregateSelectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["AgreementStatusTransitionAggregateSelection"] = ResolversParentTypes["AgreementStatusTransitionAggregateSelection"]
> = {
	count?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	createdOn?: Resolver<ResolversTypes["DateTimeAggregateSelection"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementStatusTransitionCausedByConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["AgreementStatusTransitionCausedByConnection"] = ResolversParentTypes["AgreementStatusTransitionCausedByConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["AgreementStatusTransitionCausedByRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementStatusTransitionCausedByRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["AgreementStatusTransitionCausedByRelationship"] = ResolversParentTypes["AgreementStatusTransitionCausedByRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["User"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTagResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["AgreementTag"] = ResolversParentTypes["AgreementTag"]
> = {
	defaultUserRoles?: Resolver<
		Array<ResolversTypes["User"]>,
		ParentType,
		ContextType,
		RequireFields<AgreementTagDefaultUserRolesArgs, never>
	>;
	defaultUserRolesConnection?: Resolver<
		ResolversTypes["AgreementTagDefaultUserRolesConnection"],
		ParentType,
		ContextType,
		RequireFields<AgreementTagDefaultUserRolesConnectionArgs, never>
	>;
	id?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	name?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	type?: Resolver<ResolversTypes["AgreementTagType"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTagAggregateSelectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["AgreementTagAggregateSelection"] = ResolversParentTypes["AgreementTagAggregateSelection"]
> = {
	count?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	id?: Resolver<ResolversTypes["IntAggregateSelection"], ParentType, ContextType>;
	name?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTagDefaultUserRolesConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["AgreementTagDefaultUserRolesConnection"] = ResolversParentTypes["AgreementTagDefaultUserRolesConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["AgreementTagDefaultUserRolesRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTagDefaultUserRolesRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["AgreementTagDefaultUserRolesRelationship"] = ResolversParentTypes["AgreementTagDefaultUserRolesRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["User"], ParentType, ContextType>;
	role?: Resolver<ResolversTypes["AgreementUserRole"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTagUserRoleRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["AgreementTagUserRoleRelationship"] = ResolversParentTypes["AgreementTagUserRoleRelationship"]
> = {
	__resolveType: TypeResolveFn<"AgreementTagDefaultUserRolesRelationship", ParentType, ContextType>;
	role?: Resolver<ResolversTypes["AgreementUserRole"], ParentType, ContextType>;
};

export type AgreementTagsConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["AgreementTagsConnection"] = ResolversParentTypes["AgreementTagsConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["AgreementTagsRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTagsRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["AgreementTagsRelationship"] = ResolversParentTypes["AgreementTagsRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["AgreementTag"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementUserRoleRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["AgreementUserRoleRelationship"] = ResolversParentTypes["AgreementUserRoleRelationship"]
> = {
	__resolveType: TypeResolveFn<"AgreementUserRolesRelationship", ParentType, ContextType>;
	canApprove?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
	canModifyFinancials?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
	canViewFinancials?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
	isAssignee?: Resolver<Maybe<ResolversTypes["Boolean"]>, ParentType, ContextType>;
	role?: Resolver<ResolversTypes["AgreementUserRole"], ParentType, ContextType>;
};

export type AgreementUserRolesConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["AgreementUserRolesConnection"] = ResolversParentTypes["AgreementUserRolesConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["AgreementUserRolesRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementUserRolesRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["AgreementUserRolesRelationship"] = ResolversParentTypes["AgreementUserRolesRelationship"]
> = {
	canApprove?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
	canModifyFinancials?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
	canViewFinancials?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	isAssignee?: Resolver<Maybe<ResolversTypes["Boolean"]>, ParentType, ContextType>;
	node?: Resolver<ResolversTypes["User"], ParentType, ContextType>;
	role?: Resolver<ResolversTypes["AgreementUserRole"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementWorkflowsConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["AgreementWorkflowsConnection"] = ResolversParentTypes["AgreementWorkflowsConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["AgreementWorkflowsRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementWorkflowsRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["AgreementWorkflowsRelationship"] = ResolversParentTypes["AgreementWorkflowsRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["ContractWorkflow"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AverageLaPressureAndLaVolumeRowResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["AverageLAPressureAndLAVolumeRow"] = ResolversParentTypes["AverageLAPressureAndLAVolumeRow"]
> = {
	averageLAPressure?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
	averageLAVolume?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
	interventionType?: Resolver<ResolversTypes["ReportInterventionType"], ParentType, ContextType>;
	maxLAPressure?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
	maxLAVolume?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
	minLAPressure?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
	minLAVolume?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AverageLaPressureAndLaVolumeRowAggregateSelectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["AverageLAPressureAndLAVolumeRowAggregateSelection"] = ResolversParentTypes["AverageLAPressureAndLAVolumeRowAggregateSelection"]
> = {
	averageLAPressure?: Resolver<ResolversTypes["FloatAggregateSelection"], ParentType, ContextType>;
	averageLAVolume?: Resolver<ResolversTypes["FloatAggregateSelection"], ParentType, ContextType>;
	count?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	maxLAPressure?: Resolver<ResolversTypes["FloatAggregateSelection"], ParentType, ContextType>;
	maxLAVolume?: Resolver<ResolversTypes["FloatAggregateSelection"], ParentType, ContextType>;
	minLAPressure?: Resolver<ResolversTypes["FloatAggregateSelection"], ParentType, ContextType>;
	minLAVolume?: Resolver<ResolversTypes["FloatAggregateSelection"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["BaseAgreement"] = ResolversParentTypes["BaseAgreement"]
> = {
	addedBy?: Resolver<ResolversTypes["User"], ParentType, ContextType, RequireFields<BaseAgreementAddedByArgs, never>>;
	addedByConnection?: Resolver<
		ResolversTypes["BaseAgreementAddedByConnection"],
		ParentType,
		ContextType,
		RequireFields<BaseAgreementAddedByConnectionArgs, never>
	>;
	allowedForms?: Resolver<Maybe<Array<ResolversTypes["FormType"]>>, ParentType, ContextType>;
	allowedRecords?: Resolver<Maybe<Array<ResolversTypes["RecordType"]>>, ParentType, ContextType>;
	canUserViewFinancials?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
	categories?: Resolver<
		Array<ResolversTypes["DeviceProductCategory"]>,
		ParentType,
		ContextType,
		RequireFields<BaseAgreementCategoriesArgs, never>
	>;
	categoriesConnection?: Resolver<
		ResolversTypes["BaseAgreementCategoriesConnection"],
		ParentType,
		ContextType,
		RequireFields<BaseAgreementCategoriesConnectionArgs, never>
	>;
	counterparties?: Resolver<
		Array<ResolversTypes["Organization"]>,
		ParentType,
		ContextType,
		RequireFields<BaseAgreementCounterpartiesArgs, never>
	>;
	counterpartiesConnection?: Resolver<
		ResolversTypes["BaseAgreementCounterpartiesConnection"],
		ParentType,
		ContextType,
		RequireFields<BaseAgreementCounterpartiesConnectionArgs, never>
	>;
	coveringFormWaitInterval?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
	createdOn?: Resolver<ResolversTypes["DateTime"], ParentType, ContextType>;
	currency?: Resolver<Maybe<ResolversTypes["Currency"]>, ParentType, ContextType, RequireFields<BaseAgreementCurrencyArgs, never>>;
	currencyConnection?: Resolver<
		ResolversTypes["BaseAgreementCurrencyConnection"],
		ParentType,
		ContextType,
		RequireFields<BaseAgreementCurrencyConnectionArgs, never>
	>;
	dataContainers?: Resolver<
		Array<ResolversTypes["DataContainer"]>,
		ParentType,
		ContextType,
		RequireFields<BaseAgreementDataContainersArgs, never>
	>;
	dataContainersConnection?: Resolver<
		ResolversTypes["BaseAgreementDataContainersConnection"],
		ParentType,
		ContextType,
		RequireFields<BaseAgreementDataContainersConnectionArgs, never>
	>;
	dataSource?: Resolver<ResolversTypes["DataSource"], ParentType, ContextType, RequireFields<BaseAgreementDataSourceArgs, never>>;
	dataSourceConnection?: Resolver<
		ResolversTypes["BaseAgreementDataSourceConnection"],
		ParentType,
		ContextType,
		RequireFields<BaseAgreementDataSourceConnectionArgs, never>
	>;
	decisions?: Resolver<
		Array<ResolversTypes["AgreementDecision"]>,
		ParentType,
		ContextType,
		RequireFields<BaseAgreementDecisionsArgs, never>
	>;
	decisionsConnection?: Resolver<
		ResolversTypes["BaseAgreementDecisionsConnection"],
		ParentType,
		ContextType,
		RequireFields<BaseAgreementDecisionsConnectionArgs, never>
	>;
	deviceAlternativeSets?: Resolver<
		Array<ResolversTypes["DeviceAlternative"]>,
		ParentType,
		ContextType,
		RequireFields<BaseAgreementDeviceAlternativeSetsArgs, never>
	>;
	deviceAlternativeSetsConnection?: Resolver<
		ResolversTypes["BaseAgreementDeviceAlternativeSetsConnection"],
		ParentType,
		ContextType,
		RequireFields<BaseAgreementDeviceAlternativeSetsConnectionArgs, never>
	>;
	discountCapsCategories?: Resolver<
		Maybe<Array<ResolversTypes["DeviceProductCategory"]>>,
		ParentType,
		ContextType,
		RequireFields<BaseAgreementDiscountCapsCategoriesArgs, never>
	>;
	discountCapsCategoriesConnection?: Resolver<
		ResolversTypes["BaseAgreementDiscountCapsCategoriesConnection"],
		ParentType,
		ContextType,
		RequireFields<BaseAgreementDiscountCapsCategoriesConnectionArgs, never>
	>;
	discountCapsDeviceKits?: Resolver<
		Maybe<Array<ResolversTypes["DeviceKit"]>>,
		ParentType,
		ContextType,
		RequireFields<BaseAgreementDiscountCapsDeviceKitsArgs, never>
	>;
	discountCapsDeviceKitsConnection?: Resolver<
		ResolversTypes["BaseAgreementDiscountCapsDeviceKitsConnection"],
		ParentType,
		ContextType,
		RequireFields<BaseAgreementDiscountCapsDeviceKitsConnectionArgs, never>
	>;
	eligibilityConditionSets?: Resolver<
		Array<ResolversTypes["EligibilityConditionSet"]>,
		ParentType,
		ContextType,
		RequireFields<BaseAgreementEligibilityConditionSetsArgs, never>
	>;
	eligibilityConditionSetsConnection?: Resolver<
		ResolversTypes["BaseAgreementEligibilityConditionSetsConnection"],
		ParentType,
		ContextType,
		RequireFields<BaseAgreementEligibilityConditionSetsConnectionArgs, never>
	>;
	enrollingConditionSets?: Resolver<
		Array<ResolversTypes["EnrollingConditionSet"]>,
		ParentType,
		ContextType,
		RequireFields<BaseAgreementEnrollingConditionSetsArgs, never>
	>;
	enrollingConditionSetsConnection?: Resolver<
		ResolversTypes["BaseAgreementEnrollingConditionSetsConnection"],
		ParentType,
		ContextType,
		RequireFields<BaseAgreementEnrollingConditionSetsConnectionArgs, never>
	>;
	enrollingPeriods?: Resolver<
		Maybe<Array<ResolversTypes["EnrollingPeriod"]>>,
		ParentType,
		ContextType,
		RequireFields<BaseAgreementEnrollingPeriodsArgs, never>
	>;
	enrollingPeriodsConnection?: Resolver<
		ResolversTypes["BaseAgreementEnrollingPeriodsConnection"],
		ParentType,
		ContextType,
		RequireFields<BaseAgreementEnrollingPeriodsConnectionArgs, never>
	>;
	financialSummaryConfig?: Resolver<
		Array<ResolversTypes["FinancialSummaryColumn"]>,
		ParentType,
		ContextType,
		RequireFields<BaseAgreementFinancialSummaryConfigArgs, never>
	>;
	financialSummaryConfigConnection?: Resolver<
		ResolversTypes["BaseAgreementFinancialSummaryConfigConnection"],
		ParentType,
		ContextType,
		RequireFields<BaseAgreementFinancialSummaryConfigConnectionArgs, never>
	>;
	firstExecutionDate?: Resolver<Maybe<ResolversTypes["DateTime"]>, ParentType, ContextType>;
	formattedAmount?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	formattedCounterparties?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	formattedProducts?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	formattedTags?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	formattedValidityPeriod?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
	initialVersion?: Resolver<
		ResolversTypes["BaseAgreement"],
		ParentType,
		ContextType,
		RequireFields<BaseAgreementInitialVersionArgs, never>
	>;
	initialVersionConnection?: Resolver<
		ResolversTypes["BaseAgreementInitialVersionConnection"],
		ParentType,
		ContextType,
		RequireFields<BaseAgreementInitialVersionConnectionArgs, never>
	>;
	initialVersionId?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	isAllowedFormsEnabled?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
	isAllowedRecordsEnabled?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
	isCoveringIntervalEnabled?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
	isDeleted?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
	isExtended?: Resolver<Maybe<ResolversTypes["Boolean"]>, ParentType, ContextType>;
	isFirstVersion?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
	isHidden?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
	isInsightsAvailable?: Resolver<Maybe<ResolversTypes["Boolean"]>, ParentType, ContextType>;
	isLastVersion?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
	isRatingEnabled?: Resolver<Maybe<ResolversTypes["Boolean"]>, ParentType, ContextType>;
	isRequiredFormsEnabled?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
	isRequiredRecordsEnabled?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
	isTherapyDecisionEnabled?: Resolver<Maybe<ResolversTypes["Boolean"]>, ParentType, ContextType>;
	lastExecutionDate?: Resolver<Maybe<ResolversTypes["DateTime"]>, ParentType, ContextType>;
	name?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	namedTimeRanges?: Resolver<
		Array<ResolversTypes["Timeframe"]>,
		ParentType,
		ContextType,
		RequireFields<BaseAgreementNamedTimeRangesArgs, never>
	>;
	namedTimeRangesConnection?: Resolver<
		ResolversTypes["BaseAgreementNamedTimeRangesConnection"],
		ParentType,
		ContextType,
		RequireFields<BaseAgreementNamedTimeRangesConnectionArgs, never>
	>;
	nextVersions?: Resolver<
		Array<ResolversTypes["BaseAgreement"]>,
		ParentType,
		ContextType,
		RequireFields<BaseAgreementNextVersionsArgs, never>
	>;
	nextVersionsConnection?: Resolver<
		ResolversTypes["BaseAgreementNextVersionsConnection"],
		ParentType,
		ContextType,
		RequireFields<BaseAgreementNextVersionsConnectionArgs, never>
	>;
	processedDeviceRecords?: Resolver<
		Array<ResolversTypes["ProcessedDeviceRecord"]>,
		ParentType,
		ContextType,
		RequireFields<BaseAgreementProcessedDeviceRecordsArgs, never>
	>;
	processedDeviceRecordsConnection?: Resolver<
		ResolversTypes["BaseAgreementProcessedDeviceRecordsConnection"],
		ParentType,
		ContextType,
		RequireFields<BaseAgreementProcessedDeviceRecordsConnectionArgs, never>
	>;
	pushedBy?: Resolver<Maybe<ResolversTypes["User"]>, ParentType, ContextType, RequireFields<BaseAgreementPushedByArgs, never>>;
	pushedByConnection?: Resolver<
		ResolversTypes["BaseAgreementPushedByConnection"],
		ParentType,
		ContextType,
		RequireFields<BaseAgreementPushedByConnectionArgs, never>
	>;
	pushedOn?: Resolver<Maybe<ResolversTypes["DateTime"]>, ParentType, ContextType>;
	rating?: Resolver<Maybe<Array<ResolversTypes["CoverageRequestRating"]>>, ParentType, ContextType>;
	requiredForms?: Resolver<Maybe<Array<ResolversTypes["FormType"]>>, ParentType, ContextType>;
	requiredRecords?: Resolver<Maybe<Array<ResolversTypes["RecordType"]>>, ParentType, ContextType>;
	scenarios?: Resolver<Array<ResolversTypes["Scenario"]>, ParentType, ContextType, RequireFields<BaseAgreementScenariosArgs, never>>;
	scenariosConnection?: Resolver<
		ResolversTypes["BaseAgreementScenariosConnection"],
		ParentType,
		ContextType,
		RequireFields<BaseAgreementScenariosConnectionArgs, never>
	>;
	status?: Resolver<ResolversTypes["ContractStatus"], ParentType, ContextType>;
	statusTransitions?: Resolver<
		Array<ResolversTypes["AgreementStatusTransition"]>,
		ParentType,
		ContextType,
		RequireFields<BaseAgreementStatusTransitionsArgs, never>
	>;
	statusTransitionsConnection?: Resolver<
		ResolversTypes["BaseAgreementStatusTransitionsConnection"],
		ParentType,
		ContextType,
		RequireFields<BaseAgreementStatusTransitionsConnectionArgs, never>
	>;
	subjectMatter?: Resolver<ResolversTypes["AgreementSubjectMatter"], ParentType, ContextType>;
	tags?: Resolver<Array<ResolversTypes["AgreementTag"]>, ParentType, ContextType, RequireFields<BaseAgreementTagsArgs, never>>;
	tagsConnection?: Resolver<
		ResolversTypes["BaseAgreementTagsConnection"],
		ParentType,
		ContextType,
		RequireFields<BaseAgreementTagsConnectionArgs, never>
	>;
	tenantIds?: Resolver<Maybe<Array<ResolversTypes["String"]>>, ParentType, ContextType>;
	therapyDecision?: Resolver<Maybe<Array<ResolversTypes["CoverageRequestTherapyDecision"]>>, ParentType, ContextType>;
	treatmentPrices?: Resolver<
		Array<ResolversTypes["Treatment"]>,
		ParentType,
		ContextType,
		RequireFields<BaseAgreementTreatmentPricesArgs, never>
	>;
	treatmentPricesConnection?: Resolver<
		ResolversTypes["BaseAgreementTreatmentPricesConnection"],
		ParentType,
		ContextType,
		RequireFields<BaseAgreementTreatmentPricesConnectionArgs, never>
	>;
	userContexts?: Resolver<
		Array<ResolversTypes["UserContext"]>,
		ParentType,
		ContextType,
		RequireFields<BaseAgreementUserContextsArgs, never>
	>;
	userContextsConnection?: Resolver<
		ResolversTypes["BaseAgreementUserContextsConnection"],
		ParentType,
		ContextType,
		RequireFields<BaseAgreementUserContextsConnectionArgs, never>
	>;
	userOrganizationRole?: Resolver<Maybe<ResolversTypes["CounterpartyRole"]>, ParentType, ContextType>;
	userRoles?: Resolver<Array<ResolversTypes["User"]>, ParentType, ContextType, RequireFields<BaseAgreementUserRolesArgs, never>>;
	userRolesConnection?: Resolver<
		ResolversTypes["BaseAgreementUserRolesConnection"],
		ParentType,
		ContextType,
		RequireFields<BaseAgreementUserRolesConnectionArgs, never>
	>;
	validFromDate?: Resolver<ResolversTypes["Date"], ParentType, ContextType>;
	validToDate?: Resolver<Maybe<ResolversTypes["Date"]>, ParentType, ContextType>;
	version?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementAddedByConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["BaseAgreementAddedByConnection"] = ResolversParentTypes["BaseAgreementAddedByConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["BaseAgreementAddedByRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementAddedByRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["BaseAgreementAddedByRelationship"] = ResolversParentTypes["BaseAgreementAddedByRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["User"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementAggregateSelectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["BaseAgreementAggregateSelection"] = ResolversParentTypes["BaseAgreementAggregateSelection"]
> = {
	count?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	coveringFormWaitInterval?: Resolver<ResolversTypes["IntAggregateSelection"], ParentType, ContextType>;
	createdOn?: Resolver<ResolversTypes["DateTimeAggregateSelection"], ParentType, ContextType>;
	firstExecutionDate?: Resolver<ResolversTypes["DateTimeAggregateSelection"], ParentType, ContextType>;
	formattedAmount?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	formattedCounterparties?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	formattedProducts?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	formattedTags?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	formattedValidityPeriod?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	id?: Resolver<ResolversTypes["IDAggregateSelection"], ParentType, ContextType>;
	initialVersionId?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	lastExecutionDate?: Resolver<ResolversTypes["DateTimeAggregateSelection"], ParentType, ContextType>;
	name?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	pushedOn?: Resolver<ResolversTypes["DateTimeAggregateSelection"], ParentType, ContextType>;
	version?: Resolver<ResolversTypes["IntAggregateSelection"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementCategoriesConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["BaseAgreementCategoriesConnection"] = ResolversParentTypes["BaseAgreementCategoriesConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["BaseAgreementCategoriesRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementCategoriesRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["BaseAgreementCategoriesRelationship"] = ResolversParentTypes["BaseAgreementCategoriesRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["DeviceProductCategory"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementCategoryDiscountCapsResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["BaseAgreementCategoryDiscountCaps"] = ResolversParentTypes["BaseAgreementCategoryDiscountCaps"]
> = {
	__resolveType: TypeResolveFn<"BaseAgreementDiscountCapsCategoriesRelationship", ParentType, ContextType>;
	higherCap?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
	lowerCap?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
};

export type BaseAgreementCounterpartiesConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["BaseAgreementCounterpartiesConnection"] = ResolversParentTypes["BaseAgreementCounterpartiesConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["BaseAgreementCounterpartiesRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementCounterpartiesRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["BaseAgreementCounterpartiesRelationship"] = ResolversParentTypes["BaseAgreementCounterpartiesRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	isApprovalRequired?: Resolver<Maybe<ResolversTypes["Boolean"]>, ParentType, ContextType>;
	node?: Resolver<ResolversTypes["Organization"], ParentType, ContextType>;
	role?: Resolver<ResolversTypes["CounterpartyRole"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementCounterpartyRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["BaseAgreementCounterpartyRelationship"] = ResolversParentTypes["BaseAgreementCounterpartyRelationship"]
> = {
	__resolveType: TypeResolveFn<"BaseAgreementCounterpartiesRelationship", ParentType, ContextType>;
	isApprovalRequired?: Resolver<Maybe<ResolversTypes["Boolean"]>, ParentType, ContextType>;
	role?: Resolver<ResolversTypes["CounterpartyRole"], ParentType, ContextType>;
};

export type BaseAgreementCurrencyConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["BaseAgreementCurrencyConnection"] = ResolversParentTypes["BaseAgreementCurrencyConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["BaseAgreementCurrencyRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementCurrencyRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["BaseAgreementCurrencyRelationship"] = ResolversParentTypes["BaseAgreementCurrencyRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["Currency"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementDataContainersConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["BaseAgreementDataContainersConnection"] = ResolversParentTypes["BaseAgreementDataContainersConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["BaseAgreementDataContainersRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementDataContainersRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["BaseAgreementDataContainersRelationship"] = ResolversParentTypes["BaseAgreementDataContainersRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["DataContainer"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementDataSourceConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["BaseAgreementDataSourceConnection"] = ResolversParentTypes["BaseAgreementDataSourceConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["BaseAgreementDataSourceRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementDataSourceRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["BaseAgreementDataSourceRelationship"] = ResolversParentTypes["BaseAgreementDataSourceRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["DataSource"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementDecisionsConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["BaseAgreementDecisionsConnection"] = ResolversParentTypes["BaseAgreementDecisionsConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["BaseAgreementDecisionsRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementDecisionsRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["BaseAgreementDecisionsRelationship"] = ResolversParentTypes["BaseAgreementDecisionsRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["AgreementDecision"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementDeviceAlternativeSetsConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["BaseAgreementDeviceAlternativeSetsConnection"] = ResolversParentTypes["BaseAgreementDeviceAlternativeSetsConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["BaseAgreementDeviceAlternativeSetsRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementDeviceAlternativeSetsRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["BaseAgreementDeviceAlternativeSetsRelationship"] = ResolversParentTypes["BaseAgreementDeviceAlternativeSetsRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["DeviceAlternative"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementDeviceKitDiscountCapsResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["BaseAgreementDeviceKitDiscountCaps"] = ResolversParentTypes["BaseAgreementDeviceKitDiscountCaps"]
> = {
	__resolveType: TypeResolveFn<"BaseAgreementDiscountCapsDeviceKitsRelationship", ParentType, ContextType>;
	higherCap?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
	lowerCap?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
};

export type BaseAgreementDiscountCapsCategoriesConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["BaseAgreementDiscountCapsCategoriesConnection"] = ResolversParentTypes["BaseAgreementDiscountCapsCategoriesConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["BaseAgreementDiscountCapsCategoriesRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementDiscountCapsCategoriesRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["BaseAgreementDiscountCapsCategoriesRelationship"] = ResolversParentTypes["BaseAgreementDiscountCapsCategoriesRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	higherCap?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
	lowerCap?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
	node?: Resolver<ResolversTypes["DeviceProductCategory"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementDiscountCapsDeviceKitsConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["BaseAgreementDiscountCapsDeviceKitsConnection"] = ResolversParentTypes["BaseAgreementDiscountCapsDeviceKitsConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["BaseAgreementDiscountCapsDeviceKitsRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementDiscountCapsDeviceKitsRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["BaseAgreementDiscountCapsDeviceKitsRelationship"] = ResolversParentTypes["BaseAgreementDiscountCapsDeviceKitsRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	higherCap?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
	lowerCap?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
	node?: Resolver<ResolversTypes["DeviceKit"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementEligibilityConditionRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["BaseAgreementEligibilityConditionRelationship"] = ResolversParentTypes["BaseAgreementEligibilityConditionRelationship"]
> = {
	__resolveType: TypeResolveFn<"BaseAgreementEligibilityConditionSetsRelationship", ParentType, ContextType>;
	value?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
};

export type BaseAgreementEligibilityConditionSetsConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["BaseAgreementEligibilityConditionSetsConnection"] = ResolversParentTypes["BaseAgreementEligibilityConditionSetsConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["BaseAgreementEligibilityConditionSetsRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementEligibilityConditionSetsRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["BaseAgreementEligibilityConditionSetsRelationship"] = ResolversParentTypes["BaseAgreementEligibilityConditionSetsRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["EligibilityConditionSet"], ParentType, ContextType>;
	value?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementEnrollingConditionSetsConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["BaseAgreementEnrollingConditionSetsConnection"] = ResolversParentTypes["BaseAgreementEnrollingConditionSetsConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["BaseAgreementEnrollingConditionSetsRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementEnrollingConditionSetsRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["BaseAgreementEnrollingConditionSetsRelationship"] = ResolversParentTypes["BaseAgreementEnrollingConditionSetsRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["EnrollingConditionSet"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementEnrollingPeriodsConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["BaseAgreementEnrollingPeriodsConnection"] = ResolversParentTypes["BaseAgreementEnrollingPeriodsConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["BaseAgreementEnrollingPeriodsRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementEnrollingPeriodsRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["BaseAgreementEnrollingPeriodsRelationship"] = ResolversParentTypes["BaseAgreementEnrollingPeriodsRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["EnrollingPeriod"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementFinancialSummaryConfigConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["BaseAgreementFinancialSummaryConfigConnection"] = ResolversParentTypes["BaseAgreementFinancialSummaryConfigConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["BaseAgreementFinancialSummaryConfigRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementFinancialSummaryConfigRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["BaseAgreementFinancialSummaryConfigRelationship"] = ResolversParentTypes["BaseAgreementFinancialSummaryConfigRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	hasHelpMessage?: Resolver<Maybe<ResolversTypes["Boolean"]>, ParentType, ContextType>;
	isIncluded?: Resolver<Maybe<ResolversTypes["Boolean"]>, ParentType, ContextType>;
	localizationKey?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	node?: Resolver<ResolversTypes["FinancialSummaryColumn"], ParentType, ContextType>;
	position?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementInitialVersionConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["BaseAgreementInitialVersionConnection"] = ResolversParentTypes["BaseAgreementInitialVersionConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["BaseAgreementInitialVersionRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementInitialVersionRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["BaseAgreementInitialVersionRelationship"] = ResolversParentTypes["BaseAgreementInitialVersionRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["BaseAgreement"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementNamedTimeRangesConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["BaseAgreementNamedTimeRangesConnection"] = ResolversParentTypes["BaseAgreementNamedTimeRangesConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["BaseAgreementNamedTimeRangesRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementNamedTimeRangesRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["BaseAgreementNamedTimeRangesRelationship"] = ResolversParentTypes["BaseAgreementNamedTimeRangesRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["Timeframe"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementNextVersionsConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["BaseAgreementNextVersionsConnection"] = ResolversParentTypes["BaseAgreementNextVersionsConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["BaseAgreementNextVersionsRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementNextVersionsRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["BaseAgreementNextVersionsRelationship"] = ResolversParentTypes["BaseAgreementNextVersionsRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["BaseAgreement"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementProcessedDeviceRecordsConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["BaseAgreementProcessedDeviceRecordsConnection"] = ResolversParentTypes["BaseAgreementProcessedDeviceRecordsConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["BaseAgreementProcessedDeviceRecordsRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementProcessedDeviceRecordsRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["BaseAgreementProcessedDeviceRecordsRelationship"] = ResolversParentTypes["BaseAgreementProcessedDeviceRecordsRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["ProcessedDeviceRecord"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementPushedByConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["BaseAgreementPushedByConnection"] = ResolversParentTypes["BaseAgreementPushedByConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["BaseAgreementPushedByRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementPushedByRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["BaseAgreementPushedByRelationship"] = ResolversParentTypes["BaseAgreementPushedByRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["User"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementScenariosConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["BaseAgreementScenariosConnection"] = ResolversParentTypes["BaseAgreementScenariosConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["BaseAgreementScenariosRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementScenariosRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["BaseAgreementScenariosRelationship"] = ResolversParentTypes["BaseAgreementScenariosRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["Scenario"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementStatusTransitionsConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["BaseAgreementStatusTransitionsConnection"] = ResolversParentTypes["BaseAgreementStatusTransitionsConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["BaseAgreementStatusTransitionsRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementStatusTransitionsRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["BaseAgreementStatusTransitionsRelationship"] = ResolversParentTypes["BaseAgreementStatusTransitionsRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["AgreementStatusTransition"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementTagsConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["BaseAgreementTagsConnection"] = ResolversParentTypes["BaseAgreementTagsConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["BaseAgreementTagsRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementTagsRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["BaseAgreementTagsRelationship"] = ResolversParentTypes["BaseAgreementTagsRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["AgreementTag"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementTreatmentPriceRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["BaseAgreementTreatmentPriceRelationship"] = ResolversParentTypes["BaseAgreementTreatmentPriceRelationship"]
> = {
	__resolveType: TypeResolveFn<"BaseAgreementTreatmentPricesRelationship", ParentType, ContextType>;
	price?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
};

export type BaseAgreementTreatmentPricesConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["BaseAgreementTreatmentPricesConnection"] = ResolversParentTypes["BaseAgreementTreatmentPricesConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["BaseAgreementTreatmentPricesRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementTreatmentPricesRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["BaseAgreementTreatmentPricesRelationship"] = ResolversParentTypes["BaseAgreementTreatmentPricesRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["Treatment"], ParentType, ContextType>;
	price?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementUserContextsConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["BaseAgreementUserContextsConnection"] = ResolversParentTypes["BaseAgreementUserContextsConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["BaseAgreementUserContextsRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementUserContextsRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["BaseAgreementUserContextsRelationship"] = ResolversParentTypes["BaseAgreementUserContextsRelationship"]
> = {
	categoryInput?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	groups?: Resolver<Maybe<Array<Maybe<ResolversTypes["Int"]>>>, ParentType, ContextType>;
	node?: Resolver<ResolversTypes["UserContext"], ParentType, ContextType>;
	rebateObjective?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	timeframeLabel?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementUserRoleRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["BaseAgreementUserRoleRelationship"] = ResolversParentTypes["BaseAgreementUserRoleRelationship"]
> = {
	__resolveType: TypeResolveFn<"BaseAgreementUserRolesRelationship", ParentType, ContextType>;
	canApprove?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
	canModifyFinancials?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
	canViewFinancials?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
	isAssignee?: Resolver<Maybe<ResolversTypes["Boolean"]>, ParentType, ContextType>;
	role?: Resolver<ResolversTypes["AgreementUserRole"], ParentType, ContextType>;
};

export type BaseAgreementUserRolesConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["BaseAgreementUserRolesConnection"] = ResolversParentTypes["BaseAgreementUserRolesConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["BaseAgreementUserRolesRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementUserRolesRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["BaseAgreementUserRolesRelationship"] = ResolversParentTypes["BaseAgreementUserRolesRelationship"]
> = {
	canApprove?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
	canModifyFinancials?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
	canViewFinancials?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	isAssignee?: Resolver<Maybe<ResolversTypes["Boolean"]>, ParentType, ContextType>;
	node?: Resolver<ResolversTypes["User"], ParentType, ContextType>;
	role?: Resolver<ResolversTypes["AgreementUserRole"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BrandResolvers<ContextType = any, ParentType extends ResolversParentTypes["Brand"] = ResolversParentTypes["Brand"]> = {
	Name?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	preparations?: Resolver<Array<ResolversTypes["Preparation"]>, ParentType, ContextType, RequireFields<BrandPreparationsArgs, never>>;
	preparationsConnection?: Resolver<
		ResolversTypes["BrandPreparationsConnection"],
		ParentType,
		ContextType,
		RequireFields<BrandPreparationsConnectionArgs, never>
	>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BrandAggregateSelectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["BrandAggregateSelection"] = ResolversParentTypes["BrandAggregateSelection"]
> = {
	Name?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	count?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BrandPreparationsConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["BrandPreparationsConnection"] = ResolversParentTypes["BrandPreparationsConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["BrandPreparationsRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BrandPreparationsRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["BrandPreparationsRelationship"] = ResolversParentTypes["BrandPreparationsRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["Preparation"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaobAgreementReportResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["CAOBAgreementReport"] = ResolversParentTypes["CAOBAgreementReport"]
> = {
	PIToSIRange?: Resolver<Array<ResolversTypes["Float"]>, ParentType, ContextType>;
	SICount?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
	averageMonthlyPatients?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
	averagePIToRecurrenceTime?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
	averagePIToSITime?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
	averageRecurrenceToSITime?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
	averageRefundPerSI?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
	averageTimePIRecurrenceSiCTI?: Resolver<Array<ResolversTypes["PIRecurrenceSIDataPoint"]>, ParentType, ContextType>;
	averageTimePIRecurrenceSiLVZ?: Resolver<Array<ResolversTypes["PIRecurrenceSIDataPoint"]>, ParentType, ContextType>;
	itemsUsed?: Resolver<Array<ResolversTypes["ItemUsedDataPoint"]>, ParentType, ContextType>;
	monthlyPatientEnrollment?: Resolver<Array<ResolversTypes["PatientsPerMonthDataPoint"]>, ParentType, ContextType>;
	patientCount?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
	patientCountCTILineAblated?: Resolver<Array<ResolversTypes["PatientCountDataPoint"]>, ParentType, ContextType>;
	patientCountLVZ?: Resolver<Array<ResolversTypes["PatientCountDataPoint"]>, ParentType, ContextType>;
	patientStatusDistribution?: Resolver<Maybe<ResolversTypes["PatientStatusDistribution"]>, ParentType, ContextType>;
	primaryAverageLAPressureAndLAVolume?: Resolver<Array<ResolversTypes["AverageLAPressureAndLAVolumeRow"]>, ParentType, ContextType>;
	recurringSuccessRate?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
	refundSummaryRows?: Resolver<Array<ResolversTypes["CAOBRefundSummaryRow"]>, ParentType, ContextType>;
	secondaryAverageLAPressureAndLAVolume?: Resolver<ResolversTypes["AverageLAPressureAndLAVolumeRow"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaobAgreementReportAggregateSelectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["CAOBAgreementReportAggregateSelection"] = ResolversParentTypes["CAOBAgreementReportAggregateSelection"]
> = {
	SICount?: Resolver<ResolversTypes["FloatAggregateSelection"], ParentType, ContextType>;
	averageMonthlyPatients?: Resolver<ResolversTypes["FloatAggregateSelection"], ParentType, ContextType>;
	averagePIToRecurrenceTime?: Resolver<ResolversTypes["FloatAggregateSelection"], ParentType, ContextType>;
	averagePIToSITime?: Resolver<ResolversTypes["FloatAggregateSelection"], ParentType, ContextType>;
	averageRecurrenceToSITime?: Resolver<ResolversTypes["FloatAggregateSelection"], ParentType, ContextType>;
	averageRefundPerSI?: Resolver<ResolversTypes["FloatAggregateSelection"], ParentType, ContextType>;
	count?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	patientCount?: Resolver<ResolversTypes["FloatAggregateSelection"], ParentType, ContextType>;
	recurringSuccessRate?: Resolver<ResolversTypes["FloatAggregateSelection"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaobRefundSummaryRowResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["CAOBRefundSummaryRow"] = ResolversParentTypes["CAOBRefundSummaryRow"]
> = {
	discountDate?: Resolver<ResolversTypes["Date"], ParentType, ContextType>;
	discountRate?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
	eligibleItems?: Resolver<Array<ResolversTypes["String"]>, ParentType, ContextType>;
	formId?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	interventionType?: Resolver<ResolversTypes["ReportInterventionType"], ParentType, ContextType>;
	patientId?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	status?: Resolver<ResolversTypes["RefundStatus"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaobRefundSummaryRowAggregateSelectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["CAOBRefundSummaryRowAggregateSelection"] = ResolversParentTypes["CAOBRefundSummaryRowAggregateSelection"]
> = {
	count?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	discountRate?: Resolver<ResolversTypes["FloatAggregateSelection"], ParentType, ContextType>;
	formId?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	patientId?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseResolvers<ContextType = any, ParentType extends ResolversParentTypes["Case"] = ResolversParentTypes["Case"]> = {
	actualAgreementId?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	agreement?: Resolver<Maybe<ResolversTypes["Agreement"]>, ParentType, ContextType>;
	agreementName?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	agreementTag?: Resolver<Maybe<Array<Maybe<ResolversTypes["String"]>>>, ParentType, ContextType>;
	assignedTo?: Resolver<Maybe<ResolversTypes["User"]>, ParentType, ContextType>;
	baseAgreement?: Resolver<Maybe<ResolversTypes["BaseAgreement"]>, ParentType, ContextType, RequireFields<CaseBaseAgreementArgs, never>>;
	baseAgreementConnection?: Resolver<
		ResolversTypes["CaseBaseAgreementConnection"],
		ParentType,
		ContextType,
		RequireFields<CaseBaseAgreementConnectionArgs, never>
	>;
	canUserViewFinancials?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
	claims?: Resolver<Array<ResolversTypes["Claim"]>, ParentType, ContextType, RequireFields<CaseClaimsArgs, never>>;
	claimsConnection?: Resolver<
		ResolversTypes["CaseClaimsConnection"],
		ParentType,
		ContextType,
		RequireFields<CaseClaimsConnectionArgs, never>
	>;
	cohort?: Resolver<Maybe<ResolversTypes["EnrollingPeriod"]>, ParentType, ContextType, RequireFields<CaseCohortArgs, never>>;
	cohortConnection?: Resolver<
		ResolversTypes["CaseCohortConnection"],
		ParentType,
		ContextType,
		RequireFields<CaseCohortConnectionArgs, never>
	>;
	coverageRequests?: Resolver<
		Array<ResolversTypes["CoverageRequest"]>,
		ParentType,
		ContextType,
		RequireFields<CaseCoverageRequestsArgs, never>
	>;
	coverageRequestsConnection?: Resolver<
		ResolversTypes["CaseCoverageRequestsConnection"],
		ParentType,
		ContextType,
		RequireFields<CaseCoverageRequestsConnectionArgs, never>
	>;
	creationDate?: Resolver<ResolversTypes["Date"], ParentType, ContextType>;
	disease?: Resolver<Maybe<ResolversTypes["Disease"]>, ParentType, ContextType, RequireFields<CaseDiseaseArgs, never>>;
	diseaseConnection?: Resolver<
		ResolversTypes["CaseDiseaseConnection"],
		ParentType,
		ContextType,
		RequireFields<CaseDiseaseConnectionArgs, never>
	>;
	financialDataPointsConnection?: Resolver<
		ResolversTypes["CaseFinancialDataPointsConnection"],
		ParentType,
		ContextType,
		RequireFields<CaseFinancialDataPointsConnectionArgs, never>
	>;
	flexEntities?: Resolver<Array<ResolversTypes["FlexEntity"]>, ParentType, ContextType, RequireFields<CaseFlexEntitiesArgs, never>>;
	flexEntitiesConnection?: Resolver<
		ResolversTypes["CaseFlexEntitiesConnection"],
		ParentType,
		ContextType,
		RequireFields<CaseFlexEntitiesConnectionArgs, never>
	>;
	financialDataPoints?: Resolver<
		Array<ResolversTypes["FlexFinancialDataPoint"]>,
		ParentType,
		ContextType,
		RequireFields<CaseFlexFinancialDataPointsArgs, never>
	>;
	flexFinancialDataPointsConnection?: Resolver<
		ResolversTypes["CaseFlexFinancialDataPointsConnection"],
		ParentType,
		ContextType,
		RequireFields<CaseFlexFinancialDataPointsConnectionArgs, never>
	>;
	id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
	indication?: Resolver<Maybe<ResolversTypes["Indication"]>, ParentType, ContextType, RequireFields<CaseIndicationArgs, never>>;
	indicationConnection?: Resolver<
		ResolversTypes["CaseIndicationConnection"],
		ParentType,
		ContextType,
		RequireFields<CaseIndicationConnectionArgs, never>
	>;
	isArchived?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
	isDeleted?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
	isFormOwner?: Resolver<Maybe<ResolversTypes["Boolean"]>, ParentType, ContextType>;
	legalEntity?: Resolver<Maybe<ResolversTypes["Organization"]>, ParentType, ContextType, RequireFields<CaseLegalEntityArgs, never>>;
	legalEntityConnection?: Resolver<
		ResolversTypes["CaseLegalEntityConnection"],
		ParentType,
		ContextType,
		RequireFields<CaseLegalEntityConnectionArgs, never>
	>;
	patient?: Resolver<Maybe<ResolversTypes["Patient"]>, ParentType, ContextType, RequireFields<CasePatientArgs, never>>;
	patientConnection?: Resolver<
		ResolversTypes["CasePatientConnection"],
		ParentType,
		ContextType,
		RequireFields<CasePatientConnectionArgs, never>
	>;
	patientInitials?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	patientInsuranceId?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	preparationBandName?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	preparationGenericName?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	preparations?: Resolver<Array<ResolversTypes["Preparation"]>, ParentType, ContextType, RequireFields<CasePreparationsArgs, never>>;
	preparationsConnection?: Resolver<
		ResolversTypes["CasePreparationsConnection"],
		ParentType,
		ContextType,
		RequireFields<CasePreparationsConnectionArgs, never>
	>;
	primaryIntervention?: Resolver<
		Maybe<ResolversTypes["Intervention"]>,
		ParentType,
		ContextType,
		RequireFields<CasePrimaryInterventionArgs, never>
	>;
	primaryInterventionConnection?: Resolver<
		ResolversTypes["CasePrimaryInterventionConnection"],
		ParentType,
		ContextType,
		RequireFields<CasePrimaryInterventionConnectionArgs, never>
	>;
	recordBatches?: Resolver<Array<ResolversTypes["RecordBatch"]>, ParentType, ContextType, RequireFields<CaseRecordBatchesArgs, never>>;
	recordBatchesConnection?: Resolver<
		ResolversTypes["CaseRecordBatchesConnection"],
		ParentType,
		ContextType,
		RequireFields<CaseRecordBatchesConnectionArgs, never>
	>;
	sharedCoverageRequests?: Resolver<Array<ResolversTypes["CoverageRequest"]>, ParentType, ContextType>;
	sourceTenantId?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	stobContract?: Resolver<Maybe<ResolversTypes["StobContract"]>, ParentType, ContextType, RequireFields<CaseStobContractArgs, never>>;
	stobContractConnection?: Resolver<
		ResolversTypes["CaseStobContractConnection"],
		ParentType,
		ContextType,
		RequireFields<CaseStobContractConnectionArgs, never>
	>;
	submissionDate?: Resolver<Maybe<ResolversTypes["DateTime"]>, ParentType, ContextType>;
	tenantIds?: Resolver<Maybe<Array<ResolversTypes["String"]>>, ParentType, ContextType>;
	totalAmount?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
	unlimited?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseAggregateSelectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["CaseAggregateSelection"] = ResolversParentTypes["CaseAggregateSelection"]
> = {
	actualAgreementId?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	agreementName?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	count?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	id?: Resolver<ResolversTypes["IDAggregateSelection"], ParentType, ContextType>;
	patientInitials?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	patientInsuranceId?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	preparationBandName?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	preparationGenericName?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	sourceTenantId?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	submissionDate?: Resolver<ResolversTypes["DateTimeAggregateSelection"], ParentType, ContextType>;
	totalAmount?: Resolver<ResolversTypes["FloatAggregateSelection"], ParentType, ContextType>;
	unlimited?: Resolver<ResolversTypes["IntAggregateSelection"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseBaseAgreementConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["CaseBaseAgreementConnection"] = ResolversParentTypes["CaseBaseAgreementConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["CaseBaseAgreementRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseBaseAgreementRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["CaseBaseAgreementRelationship"] = ResolversParentTypes["CaseBaseAgreementRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["BaseAgreement"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseClaimsConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["CaseClaimsConnection"] = ResolversParentTypes["CaseClaimsConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["CaseClaimsRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseClaimsRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["CaseClaimsRelationship"] = ResolversParentTypes["CaseClaimsRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["Claim"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseCohortConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["CaseCohortConnection"] = ResolversParentTypes["CaseCohortConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["CaseCohortRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseCohortRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["CaseCohortRelationship"] = ResolversParentTypes["CaseCohortRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["EnrollingPeriod"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseCoverageRequestsConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["CaseCoverageRequestsConnection"] = ResolversParentTypes["CaseCoverageRequestsConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["CaseCoverageRequestsRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseCoverageRequestsRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["CaseCoverageRequestsRelationship"] = ResolversParentTypes["CaseCoverageRequestsRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["CoverageRequest"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseDiseaseConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["CaseDiseaseConnection"] = ResolversParentTypes["CaseDiseaseConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["CaseDiseaseRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseDiseaseRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["CaseDiseaseRelationship"] = ResolversParentTypes["CaseDiseaseRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["Disease"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseFinancialDataPointsConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["CaseFinancialDataPointsConnection"] = ResolversParentTypes["CaseFinancialDataPointsConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["CaseFinancialDataPointsRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseFinancialDataPointsRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["CaseFinancialDataPointsRelationship"] = ResolversParentTypes["CaseFinancialDataPointsRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["FinancialDataPoint"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseFlexEntitiesConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["CaseFlexEntitiesConnection"] = ResolversParentTypes["CaseFlexEntitiesConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["CaseFlexEntitiesRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseFlexEntitiesRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["CaseFlexEntitiesRelationship"] = ResolversParentTypes["CaseFlexEntitiesRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["FlexEntity"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseFlexFinancialDataPointsConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["CaseFlexFinancialDataPointsConnection"] = ResolversParentTypes["CaseFlexFinancialDataPointsConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["CaseFlexFinancialDataPointsRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseFlexFinancialDataPointsRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["CaseFlexFinancialDataPointsRelationship"] = ResolversParentTypes["CaseFlexFinancialDataPointsRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["FlexFinancialDataPoint"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseIndicationConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["CaseIndicationConnection"] = ResolversParentTypes["CaseIndicationConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["CaseIndicationRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseIndicationRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["CaseIndicationRelationship"] = ResolversParentTypes["CaseIndicationRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["Indication"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseLegalEntityConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["CaseLegalEntityConnection"] = ResolversParentTypes["CaseLegalEntityConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["CaseLegalEntityRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseLegalEntityRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["CaseLegalEntityRelationship"] = ResolversParentTypes["CaseLegalEntityRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["Organization"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CasePatientConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["CasePatientConnection"] = ResolversParentTypes["CasePatientConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["CasePatientRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CasePatientRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["CasePatientRelationship"] = ResolversParentTypes["CasePatientRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["Patient"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CasePreparationsConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["CasePreparationsConnection"] = ResolversParentTypes["CasePreparationsConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["CasePreparationsRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CasePreparationsRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["CasePreparationsRelationship"] = ResolversParentTypes["CasePreparationsRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["Preparation"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CasePrimaryInterventionConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["CasePrimaryInterventionConnection"] = ResolversParentTypes["CasePrimaryInterventionConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["CasePrimaryInterventionRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CasePrimaryInterventionRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["CasePrimaryInterventionRelationship"] = ResolversParentTypes["CasePrimaryInterventionRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["Intervention"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseRecordBatchesConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["CaseRecordBatchesConnection"] = ResolversParentTypes["CaseRecordBatchesConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["CaseRecordBatchesRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseRecordBatchesRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["CaseRecordBatchesRelationship"] = ResolversParentTypes["CaseRecordBatchesRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["RecordBatch"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseReportDataPointResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["CaseReportDataPoint"] = ResolversParentTypes["CaseReportDataPoint"]
> = {
	caseId?: Resolver<Maybe<ResolversTypes["ID"]>, ParentType, ContextType>;
	durationMonths?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
	lastClaimReceived?: Resolver<Maybe<ResolversTypes["Date"]>, ParentType, ContextType>;
	reasonOfDiscontinuation?: Resolver<Maybe<ResolversTypes["ReasonsForDiscontinuation"]>, ParentType, ContextType>;
	state?: Resolver<Maybe<ResolversTypes["CaseStatus"]>, ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseReportDataPointAggregateSelectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["CaseReportDataPointAggregateSelection"] = ResolversParentTypes["CaseReportDataPointAggregateSelection"]
> = {
	caseId?: Resolver<ResolversTypes["IDAggregateSelection"], ParentType, ContextType>;
	count?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	durationMonths?: Resolver<ResolversTypes["IntAggregateSelection"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseStobContractConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["CaseStobContractConnection"] = ResolversParentTypes["CaseStobContractConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["CaseStobContractRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseStobContractRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["CaseStobContractRelationship"] = ResolversParentTypes["CaseStobContractRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["StobContract"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseTaskRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["CaseTaskRelationship"] = ResolversParentTypes["CaseTaskRelationship"]
> = {
	__resolveType: TypeResolveFn<"TaskCaseRelationship", ParentType, ContextType>;
	formDueOrOverdue?: Resolver<Maybe<ResolversTypes["FormType"]>, ParentType, ContextType>;
};

export type ClaimResolvers<ContextType = any, ParentType extends ResolversParentTypes["Claim"] = ResolversParentTypes["Claim"]> = {
	administrationDate?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	assignee?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	cases?: Resolver<Array<ResolversTypes["Case"]>, ParentType, ContextType, RequireFields<ClaimCasesArgs, never>>;
	casesConnection?: Resolver<
		ResolversTypes["ClaimCasesConnection"],
		ParentType,
		ContextType,
		RequireFields<ClaimCasesConnectionArgs, never>
	>;
	claimId?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	createdOn?: Resolver<ResolversTypes["DateTime"], ParentType, ContextType>;
	financialDataPoints?: Resolver<
		Array<ResolversTypes["FinancialDataPoint"]>,
		ParentType,
		ContextType,
		RequireFields<ClaimFinancialDataPointsArgs, never>
	>;
	financialDataPointsConnection?: Resolver<
		ResolversTypes["ClaimFinancialDataPointsConnection"],
		ParentType,
		ContextType,
		RequireFields<ClaimFinancialDataPointsConnectionArgs, never>
	>;
	id?: Resolver<Maybe<ResolversTypes["ID"]>, ParentType, ContextType>;
	includes?: Resolver<Array<ResolversTypes["Treatment"]>, ParentType, ContextType, RequireFields<ClaimIncludesArgs, never>>;
	includesConnection?: Resolver<
		ResolversTypes["ClaimIncludesConnection"],
		ParentType,
		ContextType,
		RequireFields<ClaimIncludesConnectionArgs, never>
	>;
	invoiceAmount?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	invoiceDate?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	invoiceNumber?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	isArchived?: Resolver<Maybe<ResolversTypes["Boolean"]>, ParentType, ContextType>;
	isDeleted?: Resolver<Maybe<ResolversTypes["Boolean"]>, ParentType, ContextType>;
	preparationId?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	preparationIdType?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	providerId?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	providerName?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	quantity?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	receivedFromPatient?: Resolver<
		Maybe<ResolversTypes["Patient"]>,
		ParentType,
		ContextType,
		RequireFields<ClaimReceivedFromPatientArgs, never>
	>;
	receivedFromPatientConnection?: Resolver<
		ResolversTypes["ClaimReceivedFromPatientConnection"],
		ParentType,
		ContextType,
		RequireFields<ClaimReceivedFromPatientConnectionArgs, never>
	>;
	record?: Resolver<ResolversTypes["Record"], ParentType, ContextType, RequireFields<ClaimRecordArgs, never>>;
	recordConnection?: Resolver<
		ResolversTypes["ClaimRecordConnection"],
		ParentType,
		ContextType,
		RequireFields<ClaimRecordConnectionArgs, never>
	>;
	tenantId?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ClaimAggregateSelectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["ClaimAggregateSelection"] = ResolversParentTypes["ClaimAggregateSelection"]
> = {
	administrationDate?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	assignee?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	claimId?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	count?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	createdOn?: Resolver<ResolversTypes["DateTimeAggregateSelection"], ParentType, ContextType>;
	id?: Resolver<ResolversTypes["IDAggregateSelection"], ParentType, ContextType>;
	invoiceAmount?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	invoiceDate?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	invoiceNumber?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	preparationId?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	preparationIdType?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	providerId?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	providerName?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	quantity?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	tenantId?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ClaimCasesConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["ClaimCasesConnection"] = ResolversParentTypes["ClaimCasesConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["ClaimCasesRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ClaimCasesRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["ClaimCasesRelationship"] = ResolversParentTypes["ClaimCasesRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	lastProcessingDate?: Resolver<Maybe<ResolversTypes["Date"]>, ParentType, ContextType>;
	node?: Resolver<ResolversTypes["Case"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ClaimEnrolledIntoCaseRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["ClaimEnrolledIntoCaseRelationship"] = ResolversParentTypes["ClaimEnrolledIntoCaseRelationship"]
> = {
	__resolveType: TypeResolveFn<"ClaimCasesRelationship", ParentType, ContextType>;
	lastProcessingDate?: Resolver<Maybe<ResolversTypes["Date"]>, ParentType, ContextType>;
};

export type ClaimFinancialDataPointsConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["ClaimFinancialDataPointsConnection"] = ResolversParentTypes["ClaimFinancialDataPointsConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["ClaimFinancialDataPointsRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ClaimFinancialDataPointsRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["ClaimFinancialDataPointsRelationship"] = ResolversParentTypes["ClaimFinancialDataPointsRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["FinancialDataPoint"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ClaimIncludesConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["ClaimIncludesConnection"] = ResolversParentTypes["ClaimIncludesConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["ClaimIncludesRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ClaimIncludesRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["ClaimIncludesRelationship"] = ResolversParentTypes["ClaimIncludesRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["Treatment"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ClaimReceivedFromPatientConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["ClaimReceivedFromPatientConnection"] = ResolversParentTypes["ClaimReceivedFromPatientConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["ClaimReceivedFromPatientRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ClaimReceivedFromPatientRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["ClaimReceivedFromPatientRelationship"] = ResolversParentTypes["ClaimReceivedFromPatientRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["Patient"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ClaimRecordConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["ClaimRecordConnection"] = ResolversParentTypes["ClaimRecordConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["ClaimRecordRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ClaimRecordRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["ClaimRecordRelationship"] = ResolversParentTypes["ClaimRecordRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["Record"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ContinuousBenefitResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["ContinuousBenefit"] = ResolversParentTypes["ContinuousBenefit"]
> = {
	adverseEvents?: Resolver<
		Array<ResolversTypes["AdverseEvent"]>,
		ParentType,
		ContextType,
		RequireFields<ContinuousBenefitAdverseEventsArgs, never>
	>;
	adverseEventsConnection?: Resolver<
		ResolversTypes["ContinuousBenefitAdverseEventsConnection"],
		ParentType,
		ContextType,
		RequireFields<ContinuousBenefitAdverseEventsConnectionArgs, never>
	>;
	assessmentDate?: Resolver<Maybe<ResolversTypes["Date"]>, ParentType, ContextType>;
	coverageRequest?: Resolver<
		ResolversTypes["CoverageRequest"],
		ParentType,
		ContextType,
		RequireFields<ContinuousBenefitCoverageRequestArgs, never>
	>;
	coverageRequestConnection?: Resolver<
		ResolversTypes["ContinuousBenefitCoverageRequestConnection"],
		ParentType,
		ContextType,
		RequireFields<ContinuousBenefitCoverageRequestConnectionArgs, never>
	>;
	createdOn?: Resolver<ResolversTypes["DateTime"], ParentType, ContextType>;
	financialDataPoints?: Resolver<
		Array<ResolversTypes["FinancialDataPoint"]>,
		ParentType,
		ContextType,
		RequireFields<ContinuousBenefitFinancialDataPointsArgs, never>
	>;
	financialDataPointsConnection?: Resolver<
		ResolversTypes["ContinuousBenefitFinancialDataPointsConnection"],
		ParentType,
		ContextType,
		RequireFields<ContinuousBenefitFinancialDataPointsConnectionArgs, never>
	>;
	form?: Resolver<Maybe<ResolversTypes["Form"]>, ParentType, ContextType, RequireFields<ContinuousBenefitFormArgs, never>>;
	formConnection?: Resolver<
		ResolversTypes["ContinuousBenefitFormConnection"],
		ParentType,
		ContextType,
		RequireFields<ContinuousBenefitFormConnectionArgs, never>
	>;
	id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
	initialResponse?: Resolver<
		ResolversTypes["InitialResponse"],
		ParentType,
		ContextType,
		RequireFields<ContinuousBenefitInitialResponseArgs, never>
	>;
	initialResponseConnection?: Resolver<
		ResolversTypes["ContinuousBenefitInitialResponseConnection"],
		ParentType,
		ContextType,
		RequireFields<ContinuousBenefitInitialResponseConnectionArgs, never>
	>;
	isArchived?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
	isDeleted?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
	isPatientEnrolledInTreatment?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
	lastPrescriptionDate?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	preparationPrescribedToAssessmentDate?: Resolver<Maybe<ResolversTypes["Boolean"]>, ParentType, ContextType>;
	prescribedTreatments?: Resolver<
		Array<ResolversTypes["Treatment"]>,
		ParentType,
		ContextType,
		RequireFields<ContinuousBenefitPrescribedTreatmentsArgs, never>
	>;
	prescribedTreatmentsConnection?: Resolver<
		ResolversTypes["ContinuousBenefitPrescribedTreatmentsConnection"],
		ParentType,
		ContextType,
		RequireFields<ContinuousBenefitPrescribedTreatmentsConnectionArgs, never>
	>;
	previousContinuousBenefitFormId?: Resolver<Maybe<ResolversTypes["ID"]>, ParentType, ContextType>;
	reasonForDiscontinuation?: Resolver<Maybe<ResolversTypes["ReasonsForDiscontinuation"]>, ParentType, ContextType>;
	records?: Resolver<
		Maybe<Array<Maybe<ResolversTypes["Record"]>>>,
		ParentType,
		ContextType,
		RequireFields<ContinuousBenefitRecordsArgs, never>
	>;
	recordsConnection?: Resolver<
		ResolversTypes["ContinuousBenefitRecordsConnection"],
		ParentType,
		ContextType,
		RequireFields<ContinuousBenefitRecordsConnectionArgs, never>
	>;
	status?: Resolver<Maybe<ResolversTypes["FormStatus"]>, ParentType, ContextType>;
	submissionDate?: Resolver<Maybe<ResolversTypes["DateTime"]>, ParentType, ContextType>;
	tenantId?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	treatingPhysician?: Resolver<
		Maybe<ResolversTypes["TreatingPhysician"]>,
		ParentType,
		ContextType,
		RequireFields<ContinuousBenefitTreatingPhysicianArgs, never>
	>;
	treatingPhysicianConnection?: Resolver<
		ResolversTypes["ContinuousBenefitTreatingPhysicianConnection"],
		ParentType,
		ContextType,
		RequireFields<ContinuousBenefitTreatingPhysicianConnectionArgs, never>
	>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ContinuousBenefitAdverseEventsConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["ContinuousBenefitAdverseEventsConnection"] = ResolversParentTypes["ContinuousBenefitAdverseEventsConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["ContinuousBenefitAdverseEventsRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ContinuousBenefitAdverseEventsRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["ContinuousBenefitAdverseEventsRelationship"] = ResolversParentTypes["ContinuousBenefitAdverseEventsRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["AdverseEvent"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ContinuousBenefitAggregateSelectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["ContinuousBenefitAggregateSelection"] = ResolversParentTypes["ContinuousBenefitAggregateSelection"]
> = {
	count?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	createdOn?: Resolver<ResolversTypes["DateTimeAggregateSelection"], ParentType, ContextType>;
	id?: Resolver<ResolversTypes["IDAggregateSelection"], ParentType, ContextType>;
	submissionDate?: Resolver<ResolversTypes["DateTimeAggregateSelection"], ParentType, ContextType>;
	tenantId?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ContinuousBenefitCoverageRequestConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["ContinuousBenefitCoverageRequestConnection"] = ResolversParentTypes["ContinuousBenefitCoverageRequestConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["ContinuousBenefitCoverageRequestRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ContinuousBenefitCoverageRequestRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["ContinuousBenefitCoverageRequestRelationship"] = ResolversParentTypes["ContinuousBenefitCoverageRequestRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["CoverageRequest"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ContinuousBenefitFinancialDataPointsConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["ContinuousBenefitFinancialDataPointsConnection"] = ResolversParentTypes["ContinuousBenefitFinancialDataPointsConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["ContinuousBenefitFinancialDataPointsRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ContinuousBenefitFinancialDataPointsRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["ContinuousBenefitFinancialDataPointsRelationship"] = ResolversParentTypes["ContinuousBenefitFinancialDataPointsRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["FinancialDataPoint"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ContinuousBenefitFormConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["ContinuousBenefitFormConnection"] = ResolversParentTypes["ContinuousBenefitFormConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["ContinuousBenefitFormRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ContinuousBenefitFormRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["ContinuousBenefitFormRelationship"] = ResolversParentTypes["ContinuousBenefitFormRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["Form"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ContinuousBenefitInitialResponseConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["ContinuousBenefitInitialResponseConnection"] = ResolversParentTypes["ContinuousBenefitInitialResponseConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["ContinuousBenefitInitialResponseRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ContinuousBenefitInitialResponseRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["ContinuousBenefitInitialResponseRelationship"] = ResolversParentTypes["ContinuousBenefitInitialResponseRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["InitialResponse"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ContinuousBenefitPrescribedTreatmentsConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["ContinuousBenefitPrescribedTreatmentsConnection"] = ResolversParentTypes["ContinuousBenefitPrescribedTreatmentsConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["ContinuousBenefitPrescribedTreatmentsRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ContinuousBenefitPrescribedTreatmentsRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["ContinuousBenefitPrescribedTreatmentsRelationship"] = ResolversParentTypes["ContinuousBenefitPrescribedTreatmentsRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	date?: Resolver<Maybe<ResolversTypes["Date"]>, ParentType, ContextType>;
	node?: Resolver<ResolversTypes["Treatment"], ParentType, ContextType>;
	quantity?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
	status?: Resolver<Maybe<ResolversTypes["RecordStatus"]>, ParentType, ContextType>;
	uuid?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ContinuousBenefitRecordsConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["ContinuousBenefitRecordsConnection"] = ResolversParentTypes["ContinuousBenefitRecordsConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["ContinuousBenefitRecordsRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ContinuousBenefitRecordsRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["ContinuousBenefitRecordsRelationship"] = ResolversParentTypes["ContinuousBenefitRecordsRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["Record"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ContinuousBenefitTreatingPhysicianConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["ContinuousBenefitTreatingPhysicianConnection"] = ResolversParentTypes["ContinuousBenefitTreatingPhysicianConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["ContinuousBenefitTreatingPhysicianRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ContinuousBenefitTreatingPhysicianRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["ContinuousBenefitTreatingPhysicianRelationship"] = ResolversParentTypes["ContinuousBenefitTreatingPhysicianRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["TreatingPhysician"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ContractNotificationResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["ContractNotification"] = ResolversParentTypes["ContractNotification"]
> = {
	order?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	triggers?: Resolver<
		Array<ResolversTypes["NotificationTrigger"]>,
		ParentType,
		ContextType,
		RequireFields<ContractNotificationTriggersArgs, never>
	>;
	triggersConnection?: Resolver<
		ResolversTypes["ContractNotificationTriggersConnection"],
		ParentType,
		ContextType,
		RequireFields<ContractNotificationTriggersConnectionArgs, never>
	>;
	userEmails?: Resolver<Array<Maybe<ResolversTypes["String"]>>, ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ContractNotificationAggregateSelectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["ContractNotificationAggregateSelection"] = ResolversParentTypes["ContractNotificationAggregateSelection"]
> = {
	count?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	order?: Resolver<ResolversTypes["IntAggregateSelection"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ContractNotificationTriggersConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["ContractNotificationTriggersConnection"] = ResolversParentTypes["ContractNotificationTriggersConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["ContractNotificationTriggersRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ContractNotificationTriggersRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["ContractNotificationTriggersRelationship"] = ResolversParentTypes["ContractNotificationTriggersRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["NotificationTrigger"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ContractWorkflowResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["ContractWorkflow"] = ResolversParentTypes["ContractWorkflow"]
> = {
	organization?: Resolver<
		ResolversTypes["Organization"],
		ParentType,
		ContextType,
		RequireFields<ContractWorkflowOrganizationArgs, never>
	>;
	organizationConnection?: Resolver<
		ResolversTypes["ContractWorkflowOrganizationConnection"],
		ParentType,
		ContextType,
		RequireFields<ContractWorkflowOrganizationConnectionArgs, never>
	>;
	status?: Resolver<Maybe<ResolversTypes["ContractWorkflowStatus"]>, ParentType, ContextType>;
	steps?: Resolver<
		Array<ResolversTypes["ContractWorkflowStep"]>,
		ParentType,
		ContextType,
		RequireFields<ContractWorkflowStepsArgs, never>
	>;
	stepsAreOrdered?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
	stepsConnection?: Resolver<
		ResolversTypes["ContractWorkflowStepsConnection"],
		ParentType,
		ContextType,
		RequireFields<ContractWorkflowStepsConnectionArgs, never>
	>;
	workflowType?: Resolver<ResolversTypes["ContractWorkflowType"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ContractWorkflowAggregateSelectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["ContractWorkflowAggregateSelection"] = ResolversParentTypes["ContractWorkflowAggregateSelection"]
> = {
	count?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ContractWorkflowOrganizationConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["ContractWorkflowOrganizationConnection"] = ResolversParentTypes["ContractWorkflowOrganizationConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["ContractWorkflowOrganizationRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ContractWorkflowOrganizationRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["ContractWorkflowOrganizationRelationship"] = ResolversParentTypes["ContractWorkflowOrganizationRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["Organization"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ContractWorkflowStepResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["ContractWorkflowStep"] = ResolversParentTypes["ContractWorkflowStep"]
> = {
	contractPartType?: Resolver<Maybe<ResolversTypes["ContractPartType"]>, ParentType, ContextType>;
	contractWorkflowStepType?: Resolver<ResolversTypes["ContractWorkflowStepType"], ParentType, ContextType>;
	isAmended?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
	order?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	responsiblePerson?: Resolver<
		ResolversTypes["User"],
		ParentType,
		ContextType,
		RequireFields<ContractWorkflowStepResponsiblePersonArgs, never>
	>;
	responsiblePersonConnection?: Resolver<
		ResolversTypes["ContractWorkflowStepResponsiblePersonConnection"],
		ParentType,
		ContextType,
		RequireFields<ContractWorkflowStepResponsiblePersonConnectionArgs, never>
	>;
	status?: Resolver<Maybe<ResolversTypes["ContractWorkflowStatus"]>, ParentType, ContextType>;
	title?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ContractWorkflowStepAggregateSelectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["ContractWorkflowStepAggregateSelection"] = ResolversParentTypes["ContractWorkflowStepAggregateSelection"]
> = {
	count?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	order?: Resolver<ResolversTypes["IntAggregateSelection"], ParentType, ContextType>;
	title?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ContractWorkflowStepResponsiblePersonConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["ContractWorkflowStepResponsiblePersonConnection"] = ResolversParentTypes["ContractWorkflowStepResponsiblePersonConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["ContractWorkflowStepResponsiblePersonRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ContractWorkflowStepResponsiblePersonRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["ContractWorkflowStepResponsiblePersonRelationship"] = ResolversParentTypes["ContractWorkflowStepResponsiblePersonRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["User"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ContractWorkflowStepsConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["ContractWorkflowStepsConnection"] = ResolversParentTypes["ContractWorkflowStepsConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["ContractWorkflowStepsRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ContractWorkflowStepsRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["ContractWorkflowStepsRelationship"] = ResolversParentTypes["ContractWorkflowStepsRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["ContractWorkflowStep"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CounterpartyRoleRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["CounterpartyRoleRelationship"] = ResolversParentTypes["CounterpartyRoleRelationship"]
> = {
	__resolveType: TypeResolveFn<"AgreementCounterpartyRolesRelationship", ParentType, ContextType>;
	role?: Resolver<ResolversTypes["CounterpartyRole"], ParentType, ContextType>;
};

export type CoverageRequestResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["CoverageRequest"] = ResolversParentTypes["CoverageRequest"]
> = {
	canBeDeleted?: Resolver<Maybe<ResolversTypes["Boolean"]>, ParentType, ContextType>;
	case?: Resolver<Maybe<ResolversTypes["Case"]>, ParentType, ContextType, RequireFields<CoverageRequestCaseArgs, never>>;
	caseConnection?: Resolver<
		ResolversTypes["CoverageRequestCaseConnection"],
		ParentType,
		ContextType,
		RequireFields<CoverageRequestCaseConnectionArgs, never>
	>;
	continuousBenefits?: Resolver<Array<ResolversTypes["ContinuousBenefit"]>, ParentType, ContextType>;
	continuousBenefitsWithDrafts?: Resolver<
		Array<ResolversTypes["ContinuousBenefit"]>,
		ParentType,
		ContextType,
		RequireFields<CoverageRequestContinuousBenefitsWithDraftsArgs, never>
	>;
	continuousBenefitsWithDraftsConnection?: Resolver<
		ResolversTypes["CoverageRequestContinuousBenefitsWithDraftsConnection"],
		ParentType,
		ContextType,
		RequireFields<CoverageRequestContinuousBenefitsWithDraftsConnectionArgs, never>
	>;
	coverageEndDate?: Resolver<Maybe<ResolversTypes["Date"]>, ParentType, ContextType>;
	coverageStartDate?: Resolver<Maybe<ResolversTypes["Date"]>, ParentType, ContextType>;
	createdBy?: Resolver<ResolversTypes["User"], ParentType, ContextType, RequireFields<CoverageRequestCreatedByArgs, never>>;
	createdByConnection?: Resolver<
		ResolversTypes["CoverageRequestCreatedByConnection"],
		ParentType,
		ContextType,
		RequireFields<CoverageRequestCreatedByConnectionArgs, never>
	>;
	createdOn?: Resolver<ResolversTypes["DateTime"], ParentType, ContextType>;
	decisionCommunicatedOn?: Resolver<Maybe<ResolversTypes["Date"]>, ParentType, ContextType>;
	discontinuationNote?: Resolver<
		Maybe<ResolversTypes["DiscontinuationNote"]>,
		ParentType,
		ContextType,
		RequireFields<CoverageRequestDiscontinuationNoteArgs, never>
	>;
	discontinuationNoteConnection?: Resolver<
		ResolversTypes["CoverageRequestDiscontinuationNoteConnection"],
		ParentType,
		ContextType,
		RequireFields<CoverageRequestDiscontinuationNoteConnectionArgs, never>
	>;
	disease?: Resolver<ResolversTypes["Disease"], ParentType, ContextType, RequireFields<CoverageRequestDiseaseArgs, never>>;
	diseaseConnection?: Resolver<
		ResolversTypes["CoverageRequestDiseaseConnection"],
		ParentType,
		ContextType,
		RequireFields<CoverageRequestDiseaseConnectionArgs, never>
	>;
	duration?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
	durationUom?: Resolver<Maybe<ResolversTypes["DurationUom"]>, ParentType, ContextType>;
	financialDataPoints?: Resolver<
		Array<ResolversTypes["FinancialDataPoint"]>,
		ParentType,
		ContextType,
		RequireFields<CoverageRequestFinancialDataPointsArgs, never>
	>;
	financialDataPointsConnection?: Resolver<
		ResolversTypes["CoverageRequestFinancialDataPointsConnection"],
		ParentType,
		ContextType,
		RequireFields<CoverageRequestFinancialDataPointsConnectionArgs, never>
	>;
	form?: Resolver<Maybe<ResolversTypes["Form"]>, ParentType, ContextType, RequireFields<CoverageRequestFormArgs, never>>;
	formConnection?: Resolver<
		ResolversTypes["CoverageRequestFormConnection"],
		ParentType,
		ContextType,
		RequireFields<CoverageRequestFormConnectionArgs, never>
	>;
	id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
	indication?: Resolver<ResolversTypes["Indication"], ParentType, ContextType, RequireFields<CoverageRequestIndicationArgs, never>>;
	indicationConnection?: Resolver<
		ResolversTypes["CoverageRequestIndicationConnection"],
		ParentType,
		ContextType,
		RequireFields<CoverageRequestIndicationConnectionArgs, never>
	>;
	initialResponse?: Resolver<
		Maybe<ResolversTypes["InitialResponse"]>,
		ParentType,
		ContextType,
		RequireFields<CoverageRequestInitialResponseArgs, never>
	>;
	initialResponseConnection?: Resolver<
		ResolversTypes["CoverageRequestInitialResponseConnection"],
		ParentType,
		ContextType,
		RequireFields<CoverageRequestInitialResponseConnectionArgs, never>
	>;
	intendedStartDate?: Resolver<Maybe<ResolversTypes["Date"]>, ParentType, ContextType>;
	isArchived?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
	isDeleted?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
	isPatientEnrolledInTreatment?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
	lastPrescriptionDate?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	lastUpdatedOn?: Resolver<Maybe<ResolversTypes["DateTime"]>, ParentType, ContextType>;
	legalEntity?: Resolver<
		Maybe<ResolversTypes["Organization"]>,
		ParentType,
		ContextType,
		RequireFields<CoverageRequestLegalEntityArgs, never>
	>;
	legalEntityConnection?: Resolver<
		ResolversTypes["CoverageRequestLegalEntityConnection"],
		ParentType,
		ContextType,
		RequireFields<CoverageRequestLegalEntityConnectionArgs, never>
	>;
	patient?: Resolver<Maybe<ResolversTypes["Patient"]>, ParentType, ContextType, RequireFields<CoverageRequestPatientArgs, never>>;
	patientConnection?: Resolver<
		ResolversTypes["CoverageRequestPatientConnection"],
		ParentType,
		ContextType,
		RequireFields<CoverageRequestPatientConnectionArgs, never>
	>;
	preparations?: Resolver<
		Array<ResolversTypes["Preparation"]>,
		ParentType,
		ContextType,
		RequireFields<CoverageRequestPreparationsArgs, never>
	>;
	preparationsConnection?: Resolver<
		ResolversTypes["CoverageRequestPreparationsConnection"],
		ParentType,
		ContextType,
		RequireFields<CoverageRequestPreparationsConnectionArgs, never>
	>;
	rating?: Resolver<Maybe<ResolversTypes["CoverageRequestRating"]>, ParentType, ContextType>;
	requestReceiptDate?: Resolver<ResolversTypes["Date"], ParentType, ContextType>;
	status?: Resolver<ResolversTypes["FormStatus"], ParentType, ContextType>;
	submissionDate?: Resolver<Maybe<ResolversTypes["DateTime"]>, ParentType, ContextType>;
	tenantId?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	therapyDecision?: Resolver<Maybe<ResolversTypes["CoverageRequestTherapyDecision"]>, ParentType, ContextType>;
	treatingPhysician?: Resolver<
		Maybe<ResolversTypes["TreatingPhysician"]>,
		ParentType,
		ContextType,
		RequireFields<CoverageRequestTreatingPhysicianArgs, never>
	>;
	treatingPhysicianConnection?: Resolver<
		ResolversTypes["CoverageRequestTreatingPhysicianConnection"],
		ParentType,
		ContextType,
		RequireFields<CoverageRequestTreatingPhysicianConnectionArgs, never>
	>;
	unsortedContinuousBenefits?: Resolver<
		Array<ResolversTypes["ContinuousBenefit"]>,
		ParentType,
		ContextType,
		RequireFields<CoverageRequestUnsortedContinuousBenefitsArgs, never>
	>;
	unsortedContinuousBenefitsConnection?: Resolver<
		ResolversTypes["CoverageRequestUnsortedContinuousBenefitsConnection"],
		ParentType,
		ContextType,
		RequireFields<CoverageRequestUnsortedContinuousBenefitsConnectionArgs, never>
	>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CoverageRequestAggregateSelectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["CoverageRequestAggregateSelection"] = ResolversParentTypes["CoverageRequestAggregateSelection"]
> = {
	count?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	createdOn?: Resolver<ResolversTypes["DateTimeAggregateSelection"], ParentType, ContextType>;
	duration?: Resolver<ResolversTypes["IntAggregateSelection"], ParentType, ContextType>;
	id?: Resolver<ResolversTypes["IDAggregateSelection"], ParentType, ContextType>;
	lastUpdatedOn?: Resolver<ResolversTypes["DateTimeAggregateSelection"], ParentType, ContextType>;
	submissionDate?: Resolver<ResolversTypes["DateTimeAggregateSelection"], ParentType, ContextType>;
	tenantId?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CoverageRequestCaseConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["CoverageRequestCaseConnection"] = ResolversParentTypes["CoverageRequestCaseConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["CoverageRequestCaseRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CoverageRequestCaseRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["CoverageRequestCaseRelationship"] = ResolversParentTypes["CoverageRequestCaseRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["Case"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CoverageRequestContinuousBenefitsWithDraftsConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["CoverageRequestContinuousBenefitsWithDraftsConnection"] = ResolversParentTypes["CoverageRequestContinuousBenefitsWithDraftsConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["CoverageRequestContinuousBenefitsWithDraftsRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CoverageRequestContinuousBenefitsWithDraftsRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["CoverageRequestContinuousBenefitsWithDraftsRelationship"] = ResolversParentTypes["CoverageRequestContinuousBenefitsWithDraftsRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["ContinuousBenefit"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CoverageRequestCreatedByConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["CoverageRequestCreatedByConnection"] = ResolversParentTypes["CoverageRequestCreatedByConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["CoverageRequestCreatedByRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CoverageRequestCreatedByRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["CoverageRequestCreatedByRelationship"] = ResolversParentTypes["CoverageRequestCreatedByRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["User"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CoverageRequestDiscontinuationNoteConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["CoverageRequestDiscontinuationNoteConnection"] = ResolversParentTypes["CoverageRequestDiscontinuationNoteConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["CoverageRequestDiscontinuationNoteRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CoverageRequestDiscontinuationNoteRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["CoverageRequestDiscontinuationNoteRelationship"] = ResolversParentTypes["CoverageRequestDiscontinuationNoteRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["DiscontinuationNote"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CoverageRequestDiseaseConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["CoverageRequestDiseaseConnection"] = ResolversParentTypes["CoverageRequestDiseaseConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["CoverageRequestDiseaseRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CoverageRequestDiseaseRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["CoverageRequestDiseaseRelationship"] = ResolversParentTypes["CoverageRequestDiseaseRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["Disease"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CoverageRequestFinancialDataPointsConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["CoverageRequestFinancialDataPointsConnection"] = ResolversParentTypes["CoverageRequestFinancialDataPointsConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["CoverageRequestFinancialDataPointsRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CoverageRequestFinancialDataPointsRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["CoverageRequestFinancialDataPointsRelationship"] = ResolversParentTypes["CoverageRequestFinancialDataPointsRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["FinancialDataPoint"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CoverageRequestFormConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["CoverageRequestFormConnection"] = ResolversParentTypes["CoverageRequestFormConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["CoverageRequestFormRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CoverageRequestFormRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["CoverageRequestFormRelationship"] = ResolversParentTypes["CoverageRequestFormRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["Form"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CoverageRequestIndicationConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["CoverageRequestIndicationConnection"] = ResolversParentTypes["CoverageRequestIndicationConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["CoverageRequestIndicationRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CoverageRequestIndicationRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["CoverageRequestIndicationRelationship"] = ResolversParentTypes["CoverageRequestIndicationRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["Indication"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CoverageRequestInitialResponseConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["CoverageRequestInitialResponseConnection"] = ResolversParentTypes["CoverageRequestInitialResponseConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["CoverageRequestInitialResponseRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CoverageRequestInitialResponseRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["CoverageRequestInitialResponseRelationship"] = ResolversParentTypes["CoverageRequestInitialResponseRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["InitialResponse"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CoverageRequestLegalEntityConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["CoverageRequestLegalEntityConnection"] = ResolversParentTypes["CoverageRequestLegalEntityConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["CoverageRequestLegalEntityRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CoverageRequestLegalEntityRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["CoverageRequestLegalEntityRelationship"] = ResolversParentTypes["CoverageRequestLegalEntityRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["Organization"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CoverageRequestPatientConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["CoverageRequestPatientConnection"] = ResolversParentTypes["CoverageRequestPatientConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["CoverageRequestPatientRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CoverageRequestPatientRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["CoverageRequestPatientRelationship"] = ResolversParentTypes["CoverageRequestPatientRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["Patient"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CoverageRequestPreparationsConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["CoverageRequestPreparationsConnection"] = ResolversParentTypes["CoverageRequestPreparationsConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["CoverageRequestPreparationsRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CoverageRequestPreparationsRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["CoverageRequestPreparationsRelationship"] = ResolversParentTypes["CoverageRequestPreparationsRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["Preparation"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CoverageRequestTreatingPhysicianConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["CoverageRequestTreatingPhysicianConnection"] = ResolversParentTypes["CoverageRequestTreatingPhysicianConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["CoverageRequestTreatingPhysicianRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CoverageRequestTreatingPhysicianRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["CoverageRequestTreatingPhysicianRelationship"] = ResolversParentTypes["CoverageRequestTreatingPhysicianRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["TreatingPhysician"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CoverageRequestUnsortedContinuousBenefitsConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["CoverageRequestUnsortedContinuousBenefitsConnection"] = ResolversParentTypes["CoverageRequestUnsortedContinuousBenefitsConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["CoverageRequestUnsortedContinuousBenefitsRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CoverageRequestUnsortedContinuousBenefitsRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["CoverageRequestUnsortedContinuousBenefitsRelationship"] = ResolversParentTypes["CoverageRequestUnsortedContinuousBenefitsRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["ContinuousBenefit"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateAdverseEventsOccurenceReportsMutationResponseResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["CreateAdverseEventsOccurenceReportsMutationResponse"] = ResolversParentTypes["CreateAdverseEventsOccurenceReportsMutationResponse"]
> = {
	adverseEventsOccurenceReports?: Resolver<Array<ResolversTypes["AdverseEventsOccurenceReport"]>, ParentType, ContextType>;
	info?: Resolver<ResolversTypes["CreateInfo"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateInfoResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["CreateInfo"] = ResolversParentTypes["CreateInfo"]
> = {
	bookmark?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	nodesCreated?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	relationshipsCreated?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateInitialResponseReviewReportsMutationResponseResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["CreateInitialResponseReviewReportsMutationResponse"] = ResolversParentTypes["CreateInitialResponseReviewReportsMutationResponse"]
> = {
	info?: Resolver<ResolversTypes["CreateInfo"], ParentType, ContextType>;
	initialResponseReviewReports?: Resolver<Array<ResolversTypes["InitialResponseReviewReport"]>, ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateReasonOfTreatmentDiscontinuationReportsMutationResponseResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["CreateReasonOfTreatmentDiscontinuationReportsMutationResponse"] = ResolversParentTypes["CreateReasonOfTreatmentDiscontinuationReportsMutationResponse"]
> = {
	info?: Resolver<ResolversTypes["CreateInfo"], ParentType, ContextType>;
	reasonOfTreatmentDiscontinuationReports?: Resolver<
		Array<ResolversTypes["ReasonOfTreatmentDiscontinuationReport"]>,
		ParentType,
		ContextType
	>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateUsersMutationResponseResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["CreateUsersMutationResponse"] = ResolversParentTypes["CreateUsersMutationResponse"]
> = {
	info?: Resolver<ResolversTypes["CreateInfo"], ParentType, ContextType>;
	users?: Resolver<Array<ResolversTypes["User"]>, ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CurrencyResolvers<ContextType = any, ParentType extends ResolversParentTypes["Currency"] = ResolversParentTypes["Currency"]> = {
	Code?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	Name?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	symbol?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CurrencyAggregateSelectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["CurrencyAggregateSelection"] = ResolversParentTypes["CurrencyAggregateSelection"]
> = {
	Code?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	Name?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	count?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	symbol?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DataContainerResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["DataContainer"] = ResolversParentTypes["DataContainer"]
> = {
	creationWays?: Resolver<Maybe<Array<ResolversTypes["DataContainerCreationWay"]>>, ParentType, ContextType>;
	isStartingPoint?: Resolver<Maybe<ResolversTypes["Boolean"]>, ParentType, ContextType>;
	providers?: Resolver<Array<ResolversTypes["Organization"]>, ParentType, ContextType, RequireFields<DataContainerProvidersArgs, never>>;
	providersConnection?: Resolver<
		ResolversTypes["DataContainerProvidersConnection"],
		ParentType,
		ContextType,
		RequireFields<DataContainerProvidersConnectionArgs, never>
	>;
	restrictedDataPointNames?: Resolver<Maybe<Array<ResolversTypes["String"]>>, ParentType, ContextType>;
	sharedDataPointNames?: Resolver<Maybe<Array<ResolversTypes["String"]>>, ParentType, ContextType>;
	sharingTrigger?: Resolver<ResolversTypes["DataContainerSharingTrigger"], ParentType, ContextType>;
	subType?: Resolver<Maybe<ResolversTypes["DataContainerSubType"]>, ParentType, ContextType>;
	timeframeEnd?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
	timeframeRangeType?: Resolver<Maybe<ResolversTypes["TimeframeRangeType"]>, ParentType, ContextType>;
	timeframeStart?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
	timeframeStartingPoint?: Resolver<Maybe<ResolversTypes["TimeframeStartingPoint"]>, ParentType, ContextType>;
	type?: Resolver<ResolversTypes["DataContainerType"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DataContainerAggregateSelectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["DataContainerAggregateSelection"] = ResolversParentTypes["DataContainerAggregateSelection"]
> = {
	count?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	timeframeEnd?: Resolver<ResolversTypes["IntAggregateSelection"], ParentType, ContextType>;
	timeframeStart?: Resolver<ResolversTypes["IntAggregateSelection"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DataContainerProvidersConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["DataContainerProvidersConnection"] = ResolversParentTypes["DataContainerProvidersConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["DataContainerProvidersRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DataContainerProvidersRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["DataContainerProvidersRelationship"] = ResolversParentTypes["DataContainerProvidersRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["Organization"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DataSourceResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["DataSource"] = ResolversParentTypes["DataSource"]
> = {
	id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
	name?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DataSourceAggregateSelectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["DataSourceAggregateSelection"] = ResolversParentTypes["DataSourceAggregateSelection"]
> = {
	count?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	id?: Resolver<ResolversTypes["IDAggregateSelection"], ParentType, ContextType>;
	name?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface DateScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes["Date"], any> {
	name: "Date";
}

export interface DateTimeScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes["DateTime"], any> {
	name: "DateTime";
}

export type DateTimeAggregateSelectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["DateTimeAggregateSelection"] = ResolversParentTypes["DateTimeAggregateSelection"]
> = {
	max?: Resolver<ResolversTypes["DateTime"], ParentType, ContextType>;
	min?: Resolver<ResolversTypes["DateTime"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteInfoResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["DeleteInfo"] = ResolversParentTypes["DeleteInfo"]
> = {
	bookmark?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	nodesDeleted?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	relationshipsDeleted?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeviceAlternativeResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["DeviceAlternative"] = ResolversParentTypes["DeviceAlternative"]
> = {
	alternatives?: Resolver<
		Array<ResolversTypes["Treatment"]>,
		ParentType,
		ContextType,
		RequireFields<DeviceAlternativeAlternativesArgs, never>
	>;
	alternativesConnection?: Resolver<
		ResolversTypes["DeviceAlternativeAlternativesConnection"],
		ParentType,
		ContextType,
		RequireFields<DeviceAlternativeAlternativesConnectionArgs, never>
	>;
	code?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	deviceProduct?: Resolver<
		ResolversTypes["Treatment"],
		ParentType,
		ContextType,
		RequireFields<DeviceAlternativeDeviceProductArgs, never>
	>;
	deviceProductConnection?: Resolver<
		ResolversTypes["DeviceAlternativeDeviceProductConnection"],
		ParentType,
		ContextType,
		RequireFields<DeviceAlternativeDeviceProductConnectionArgs, never>
	>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeviceAlternativeAggregateSelectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["DeviceAlternativeAggregateSelection"] = ResolversParentTypes["DeviceAlternativeAggregateSelection"]
> = {
	code?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	count?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeviceAlternativeAlternativesConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["DeviceAlternativeAlternativesConnection"] = ResolversParentTypes["DeviceAlternativeAlternativesConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["DeviceAlternativeAlternativesRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeviceAlternativeAlternativesRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["DeviceAlternativeAlternativesRelationship"] = ResolversParentTypes["DeviceAlternativeAlternativesRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["Treatment"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeviceAlternativeDeviceProductConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["DeviceAlternativeDeviceProductConnection"] = ResolversParentTypes["DeviceAlternativeDeviceProductConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["DeviceAlternativeDeviceProductRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeviceAlternativeDeviceProductRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["DeviceAlternativeDeviceProductRelationship"] = ResolversParentTypes["DeviceAlternativeDeviceProductRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["Treatment"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeviceFinancialDataPointResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["DeviceFinancialDataPoint"] = ResolversParentTypes["DeviceFinancialDataPoint"]
> = {
	basePrice?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
	date?: Resolver<ResolversTypes["Date"], ParentType, ContextType>;
	evaluationSnapshot?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	isLast?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
	payable?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
	payablePercentage?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
	processedDeviceRecord?: Resolver<
		ResolversTypes["ProcessedDeviceRecord"],
		ParentType,
		ContextType,
		RequireFields<DeviceFinancialDataPointProcessedDeviceRecordArgs, never>
	>;
	processedDeviceRecordConnection?: Resolver<
		ResolversTypes["DeviceFinancialDataPointProcessedDeviceRecordConnection"],
		ParentType,
		ContextType,
		RequireFields<DeviceFinancialDataPointProcessedDeviceRecordConnectionArgs, never>
	>;
	quantity?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	refundable?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
	refundablePercentage?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
	variable?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
	variablePercentage?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeviceFinancialDataPointAggregateSelectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["DeviceFinancialDataPointAggregateSelection"] = ResolversParentTypes["DeviceFinancialDataPointAggregateSelection"]
> = {
	basePrice?: Resolver<ResolversTypes["FloatAggregateSelection"], ParentType, ContextType>;
	count?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	evaluationSnapshot?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	payable?: Resolver<ResolversTypes["FloatAggregateSelection"], ParentType, ContextType>;
	payablePercentage?: Resolver<ResolversTypes["FloatAggregateSelection"], ParentType, ContextType>;
	quantity?: Resolver<ResolversTypes["IntAggregateSelection"], ParentType, ContextType>;
	refundable?: Resolver<ResolversTypes["FloatAggregateSelection"], ParentType, ContextType>;
	refundablePercentage?: Resolver<ResolversTypes["FloatAggregateSelection"], ParentType, ContextType>;
	variable?: Resolver<ResolversTypes["FloatAggregateSelection"], ParentType, ContextType>;
	variablePercentage?: Resolver<ResolversTypes["FloatAggregateSelection"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeviceFinancialDataPointProcessedDeviceRecordConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["DeviceFinancialDataPointProcessedDeviceRecordConnection"] = ResolversParentTypes["DeviceFinancialDataPointProcessedDeviceRecordConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["DeviceFinancialDataPointProcessedDeviceRecordRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeviceFinancialDataPointProcessedDeviceRecordRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["DeviceFinancialDataPointProcessedDeviceRecordRelationship"] = ResolversParentTypes["DeviceFinancialDataPointProcessedDeviceRecordRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["ProcessedDeviceRecord"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeviceKitResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["DeviceKit"] = ResolversParentTypes["DeviceKit"]
> = {
	name?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	ref?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	tenantId?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeviceKitAggregateSelectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["DeviceKitAggregateSelection"] = ResolversParentTypes["DeviceKitAggregateSelection"]
> = {
	count?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	name?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	ref?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	tenantId?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeviceProductCategoryResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["DeviceProductCategory"] = ResolversParentTypes["DeviceProductCategory"]
> = {
	code?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	level?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	name?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	parent?: Resolver<
		Maybe<ResolversTypes["DeviceProductCategory"]>,
		ParentType,
		ContextType,
		RequireFields<DeviceProductCategoryParentArgs, never>
	>;
	parentConnection?: Resolver<
		ResolversTypes["DeviceProductCategoryParentConnection"],
		ParentType,
		ContextType,
		RequireFields<DeviceProductCategoryParentConnectionArgs, never>
	>;
	tenantId?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeviceProductCategoryAggregateSelectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["DeviceProductCategoryAggregateSelection"] = ResolversParentTypes["DeviceProductCategoryAggregateSelection"]
> = {
	code?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	count?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	level?: Resolver<ResolversTypes["IntAggregateSelection"], ParentType, ContextType>;
	name?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	tenantId?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeviceProductCategoryParentConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["DeviceProductCategoryParentConnection"] = ResolversParentTypes["DeviceProductCategoryParentConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["DeviceProductCategoryParentRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeviceProductCategoryParentRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["DeviceProductCategoryParentRelationship"] = ResolversParentTypes["DeviceProductCategoryParentRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["DeviceProductCategory"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeviceProviderResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["DeviceProvider"] = ResolversParentTypes["DeviceProvider"]
> = {
	id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
	name?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeviceProviderAggregateSelectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["DeviceProviderAggregateSelection"] = ResolversParentTypes["DeviceProviderAggregateSelection"]
> = {
	count?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	id?: Resolver<ResolversTypes["IDAggregateSelection"], ParentType, ContextType>;
	name?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeviceRecordResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["DeviceRecord"] = ResolversParentTypes["DeviceRecord"]
> = {
	category?: Resolver<ResolversTypes["DeviceProductCategory"], ParentType, ContextType, RequireFields<DeviceRecordCategoryArgs, never>>;
	categoryConnection?: Resolver<
		ResolversTypes["DeviceRecordCategoryConnection"],
		ParentType,
		ContextType,
		RequireFields<DeviceRecordCategoryConnectionArgs, never>
	>;
	deviceId?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	deviceRef?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
	invoicedSales?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
	orderLineNumber?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	orderNumber?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	price?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
	processedAs?: Resolver<
		Maybe<ResolversTypes["ProcessedDeviceRecord"]>,
		ParentType,
		ContextType,
		RequireFields<DeviceRecordProcessedAsArgs, never>
	>;
	processedAsConnection?: Resolver<
		ResolversTypes["DeviceRecordProcessedAsConnection"],
		ParentType,
		ContextType,
		RequireFields<DeviceRecordProcessedAsConnectionArgs, never>
	>;
	productName?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	provider?: Resolver<Maybe<ResolversTypes["DeviceProvider"]>, ParentType, ContextType, RequireFields<DeviceRecordProviderArgs, never>>;
	providerConnection?: Resolver<
		ResolversTypes["DeviceRecordProviderConnection"],
		ParentType,
		ContextType,
		RequireFields<DeviceRecordProviderConnectionArgs, never>
	>;
	quantity?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	record?: Resolver<ResolversTypes["Record"], ParentType, ContextType, RequireFields<DeviceRecordRecordArgs, never>>;
	recordConnection?: Resolver<
		ResolversTypes["DeviceRecordRecordConnection"],
		ParentType,
		ContextType,
		RequireFields<DeviceRecordRecordConnectionArgs, never>
	>;
	refundPercentage?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
	saleDate?: Resolver<ResolversTypes["DateTime"], ParentType, ContextType>;
	tenantId?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeviceRecordAggregateSelectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["DeviceRecordAggregateSelection"] = ResolversParentTypes["DeviceRecordAggregateSelection"]
> = {
	count?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	deviceId?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	deviceRef?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	id?: Resolver<ResolversTypes["IDAggregateSelection"], ParentType, ContextType>;
	invoicedSales?: Resolver<ResolversTypes["FloatAggregateSelection"], ParentType, ContextType>;
	orderLineNumber?: Resolver<ResolversTypes["IntAggregateSelection"], ParentType, ContextType>;
	orderNumber?: Resolver<ResolversTypes["IntAggregateSelection"], ParentType, ContextType>;
	price?: Resolver<ResolversTypes["FloatAggregateSelection"], ParentType, ContextType>;
	productName?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	quantity?: Resolver<ResolversTypes["IntAggregateSelection"], ParentType, ContextType>;
	refundPercentage?: Resolver<ResolversTypes["FloatAggregateSelection"], ParentType, ContextType>;
	saleDate?: Resolver<ResolversTypes["DateTimeAggregateSelection"], ParentType, ContextType>;
	tenantId?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeviceRecordCategoryConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["DeviceRecordCategoryConnection"] = ResolversParentTypes["DeviceRecordCategoryConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["DeviceRecordCategoryRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeviceRecordCategoryRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["DeviceRecordCategoryRelationship"] = ResolversParentTypes["DeviceRecordCategoryRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["DeviceProductCategory"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeviceRecordProcessedAsConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["DeviceRecordProcessedAsConnection"] = ResolversParentTypes["DeviceRecordProcessedAsConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["DeviceRecordProcessedAsRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeviceRecordProcessedAsRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["DeviceRecordProcessedAsRelationship"] = ResolversParentTypes["DeviceRecordProcessedAsRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["ProcessedDeviceRecord"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeviceRecordProviderConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["DeviceRecordProviderConnection"] = ResolversParentTypes["DeviceRecordProviderConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["DeviceRecordProviderRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeviceRecordProviderRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["DeviceRecordProviderRelationship"] = ResolversParentTypes["DeviceRecordProviderRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["DeviceProvider"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeviceRecordRecordConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["DeviceRecordRecordConnection"] = ResolversParentTypes["DeviceRecordRecordConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["DeviceRecordRecordRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeviceRecordRecordRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["DeviceRecordRecordRelationship"] = ResolversParentTypes["DeviceRecordRecordRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["Record"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DiscontinuationNoteResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["DiscontinuationNote"] = ResolversParentTypes["DiscontinuationNote"]
> = {
	assessmentDate?: Resolver<ResolversTypes["Date"], ParentType, ContextType>;
	coverageRequest?: Resolver<
		Maybe<ResolversTypes["CoverageRequest"]>,
		ParentType,
		ContextType,
		RequireFields<DiscontinuationNoteCoverageRequestArgs, never>
	>;
	coverageRequestConnection?: Resolver<
		ResolversTypes["DiscontinuationNoteCoverageRequestConnection"],
		ParentType,
		ContextType,
		RequireFields<DiscontinuationNoteCoverageRequestConnectionArgs, never>
	>;
	createdOn?: Resolver<ResolversTypes["DateTime"], ParentType, ContextType>;
	form?: Resolver<Maybe<ResolversTypes["Form"]>, ParentType, ContextType, RequireFields<DiscontinuationNoteFormArgs, never>>;
	formConnection?: Resolver<
		ResolversTypes["DiscontinuationNoteFormConnection"],
		ParentType,
		ContextType,
		RequireFields<DiscontinuationNoteFormConnectionArgs, never>
	>;
	id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
	isArchived?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
	isDeleted?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
	isPatientEnrolledInTreatment?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
	reasonForDiscontinuation?: Resolver<Maybe<ResolversTypes["ReasonsForDiscontinuation"]>, ParentType, ContextType>;
	status?: Resolver<Maybe<ResolversTypes["FormStatus"]>, ParentType, ContextType>;
	submissionDate?: Resolver<Maybe<ResolversTypes["DateTime"]>, ParentType, ContextType>;
	tenantId?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DiscontinuationNoteAggregateSelectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["DiscontinuationNoteAggregateSelection"] = ResolversParentTypes["DiscontinuationNoteAggregateSelection"]
> = {
	count?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	createdOn?: Resolver<ResolversTypes["DateTimeAggregateSelection"], ParentType, ContextType>;
	id?: Resolver<ResolversTypes["IDAggregateSelection"], ParentType, ContextType>;
	submissionDate?: Resolver<ResolversTypes["DateTimeAggregateSelection"], ParentType, ContextType>;
	tenantId?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DiscontinuationNoteCoverageRequestConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["DiscontinuationNoteCoverageRequestConnection"] = ResolversParentTypes["DiscontinuationNoteCoverageRequestConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["DiscontinuationNoteCoverageRequestRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DiscontinuationNoteCoverageRequestRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["DiscontinuationNoteCoverageRequestRelationship"] = ResolversParentTypes["DiscontinuationNoteCoverageRequestRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["CoverageRequest"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DiscontinuationNoteFormConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["DiscontinuationNoteFormConnection"] = ResolversParentTypes["DiscontinuationNoteFormConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["DiscontinuationNoteFormRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DiscontinuationNoteFormRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["DiscontinuationNoteFormRelationship"] = ResolversParentTypes["DiscontinuationNoteFormRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["Form"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DiseaseResolvers<ContextType = any, ParentType extends ResolversParentTypes["Disease"] = ResolversParentTypes["Disease"]> = {
	Icd10Code?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	Name?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DiseaseAggregateSelectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["DiseaseAggregateSelection"] = ResolversParentTypes["DiseaseAggregateSelection"]
> = {
	Icd10Code?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	Name?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	count?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DocumentResolvers<ContextType = any, ParentType extends ResolversParentTypes["Document"] = ResolversParentTypes["Document"]> = {
	agreementBuyerInvoiceInfo?: Resolver<Maybe<ResolversTypes["Organization"]>, ParentType, ContextType>;
	agreementSellerInvoiceInfo?: Resolver<Maybe<ResolversTypes["Organization"]>, ParentType, ContextType>;
	agreementsWithoutUserAccess?: Resolver<Array<ResolversTypes["BaseAgreement"]>, ParentType, ContextType>;
	assignedTo?: Resolver<
		Maybe<Array<Maybe<ResolversTypes["User"]>>>,
		ParentType,
		ContextType,
		RequireFields<DocumentAssignedToArgs, never>
	>;
	assignedToConnection?: Resolver<
		ResolversTypes["DocumentAssignedToConnection"],
		ParentType,
		ContextType,
		RequireFields<DocumentAssignedToConnectionArgs, never>
	>;
	canAssignUser?: Resolver<Maybe<ResolversTypes["Boolean"]>, ParentType, ContextType>;
	canUserDelete?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
	counterParties?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	coveragePeriod?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	coveragePeriodEnd?: Resolver<Maybe<ResolversTypes["Date"]>, ParentType, ContextType>;
	coveragePeriodStart?: Resolver<Maybe<ResolversTypes["Date"]>, ParentType, ContextType>;
	createdBy?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	createdOn?: Resolver<ResolversTypes["DateTime"], ParentType, ContextType>;
	creatorOrgName?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	creatorTenantId?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	formattedTags?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
	invoiceAmount?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
	isAgreementBuyer?: Resolver<Maybe<ResolversTypes["Boolean"]>, ParentType, ContextType>;
	isAgreementOwner?: Resolver<Maybe<ResolversTypes["Boolean"]>, ParentType, ContextType>;
	isAgreementSeller?: Resolver<Maybe<ResolversTypes["Boolean"]>, ParentType, ContextType>;
	isAssignee?: Resolver<Maybe<ResolversTypes["Boolean"]>, ParentType, ContextType>;
	isConfirmedBySeller?: Resolver<Maybe<ResolversTypes["Boolean"]>, ParentType, ContextType>;
	isDeleted?: Resolver<Maybe<ResolversTypes["Boolean"]>, ParentType, ContextType>;
	issuedOn?: Resolver<Maybe<ResolversTypes["DateTime"]>, ParentType, ContextType>;
	lastUpdatedOn?: Resolver<Maybe<ResolversTypes["DateTime"]>, ParentType, ContextType>;
	product?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	refunds?: Resolver<Array<ResolversTypes["Refund"]>, ParentType, ContextType, RequireFields<DocumentRefundsArgs, never>>;
	refundsConnection?: Resolver<
		ResolversTypes["DocumentRefundsConnection"],
		ParentType,
		ContextType,
		RequireFields<DocumentRefundsConnectionArgs, never>
	>;
	settledOn?: Resolver<Maybe<ResolversTypes["Date"]>, ParentType, ContextType>;
	status?: Resolver<Maybe<ResolversTypes["DocumentStatus"]>, ParentType, ContextType>;
	tags?: Resolver<Array<ResolversTypes["AgreementTag"]>, ParentType, ContextType, RequireFields<DocumentTagsArgs, never>>;
	tagsConnection?: Resolver<
		ResolversTypes["DocumentTagsConnection"],
		ParentType,
		ContextType,
		RequireFields<DocumentTagsConnectionArgs, never>
	>;
	tenantIds?: Resolver<Array<ResolversTypes["String"]>, ParentType, ContextType>;
	type?: Resolver<Maybe<ResolversTypes["DocumentType"]>, ParentType, ContextType>;
	unlimited?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DocumentAggregateSelectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["DocumentAggregateSelection"] = ResolversParentTypes["DocumentAggregateSelection"]
> = {
	count?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	counterParties?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	coveragePeriod?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	createdBy?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	createdOn?: Resolver<ResolversTypes["DateTimeAggregateSelection"], ParentType, ContextType>;
	creatorOrgName?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	creatorTenantId?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	formattedTags?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	id?: Resolver<ResolversTypes["IDAggregateSelection"], ParentType, ContextType>;
	invoiceAmount?: Resolver<ResolversTypes["IntAggregateSelection"], ParentType, ContextType>;
	issuedOn?: Resolver<ResolversTypes["DateTimeAggregateSelection"], ParentType, ContextType>;
	lastUpdatedOn?: Resolver<ResolversTypes["DateTimeAggregateSelection"], ParentType, ContextType>;
	product?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	unlimited?: Resolver<ResolversTypes["IntAggregateSelection"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DocumentAssignedToConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["DocumentAssignedToConnection"] = ResolversParentTypes["DocumentAssignedToConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["DocumentAssignedToRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DocumentAssignedToRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["DocumentAssignedToRelationship"] = ResolversParentTypes["DocumentAssignedToRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["User"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DocumentRefundsConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["DocumentRefundsConnection"] = ResolversParentTypes["DocumentRefundsConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["DocumentRefundsRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DocumentRefundsRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["DocumentRefundsRelationship"] = ResolversParentTypes["DocumentRefundsRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["Refund"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DocumentTagsConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["DocumentTagsConnection"] = ResolversParentTypes["DocumentTagsConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["DocumentTagsRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DocumentTagsRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["DocumentTagsRelationship"] = ResolversParentTypes["DocumentTagsRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["AgreementTag"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EligibilityConditionSetResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["EligibilityConditionSet"] = ResolversParentTypes["EligibilityConditionSet"]
> = {
	code?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	inputLabel?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	name?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EligibilityConditionSetAggregateSelectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["EligibilityConditionSetAggregateSelection"] = ResolversParentTypes["EligibilityConditionSetAggregateSelection"]
> = {
	code?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	count?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	inputLabel?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	name?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EnrollingConditionDiseaseRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["EnrollingConditionDiseaseRelationship"] = ResolversParentTypes["EnrollingConditionDiseaseRelationship"]
> = {
	__resolveType: TypeResolveFn<"EnrollingConditionSetDiseasesRelationship", ParentType, ContextType>;
	Score?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
};

export type EnrollingConditionSetResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["EnrollingConditionSet"] = ResolversParentTypes["EnrollingConditionSet"]
> = {
	agreement?: Resolver<
		ResolversTypes["BaseAgreement"],
		ParentType,
		ContextType,
		RequireFields<EnrollingConditionSetAgreementArgs, never>
	>;
	agreementConnection?: Resolver<
		ResolversTypes["EnrollingConditionSetAgreementConnection"],
		ParentType,
		ContextType,
		RequireFields<EnrollingConditionSetAgreementConnectionArgs, never>
	>;
	code?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	diseases?: Resolver<Array<ResolversTypes["Disease"]>, ParentType, ContextType, RequireFields<EnrollingConditionSetDiseasesArgs, never>>;
	diseasesConnection?: Resolver<
		ResolversTypes["EnrollingConditionSetDiseasesConnection"],
		ParentType,
		ContextType,
		RequireFields<EnrollingConditionSetDiseasesConnectionArgs, never>
	>;
	indications?: Resolver<
		Array<ResolversTypes["Indication"]>,
		ParentType,
		ContextType,
		RequireFields<EnrollingConditionSetIndicationsArgs, never>
	>;
	indicationsConnection?: Resolver<
		ResolversTypes["EnrollingConditionSetIndicationsConnection"],
		ParentType,
		ContextType,
		RequireFields<EnrollingConditionSetIndicationsConnectionArgs, never>
	>;
	isDeleted?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
	isExtended?: Resolver<Maybe<ResolversTypes["Boolean"]>, ParentType, ContextType>;
	preparationConditionLogicalOperator?: Resolver<ResolversTypes["ConditionLogicalOperator"], ParentType, ContextType>;
	preparations?: Resolver<
		Array<ResolversTypes["Preparation"]>,
		ParentType,
		ContextType,
		RequireFields<EnrollingConditionSetPreparationsArgs, never>
	>;
	preparationsConnection?: Resolver<
		ResolversTypes["EnrollingConditionSetPreparationsConnection"],
		ParentType,
		ContextType,
		RequireFields<EnrollingConditionSetPreparationsConnectionArgs, never>
	>;
	tenantIds?: Resolver<Maybe<Array<ResolversTypes["String"]>>, ParentType, ContextType>;
	treatments?: Resolver<
		Array<ResolversTypes["Treatment"]>,
		ParentType,
		ContextType,
		RequireFields<EnrollingConditionSetTreatmentsArgs, never>
	>;
	treatmentsConnection?: Resolver<
		ResolversTypes["EnrollingConditionSetTreatmentsConnection"],
		ParentType,
		ContextType,
		RequireFields<EnrollingConditionSetTreatmentsConnectionArgs, never>
	>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EnrollingConditionSetAggregateSelectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["EnrollingConditionSetAggregateSelection"] = ResolversParentTypes["EnrollingConditionSetAggregateSelection"]
> = {
	code?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	count?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EnrollingConditionSetAgreementConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["EnrollingConditionSetAgreementConnection"] = ResolversParentTypes["EnrollingConditionSetAgreementConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["EnrollingConditionSetAgreementRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EnrollingConditionSetAgreementRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["EnrollingConditionSetAgreementRelationship"] = ResolversParentTypes["EnrollingConditionSetAgreementRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["BaseAgreement"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EnrollingConditionSetDiseasesConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["EnrollingConditionSetDiseasesConnection"] = ResolversParentTypes["EnrollingConditionSetDiseasesConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["EnrollingConditionSetDiseasesRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EnrollingConditionSetDiseasesRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["EnrollingConditionSetDiseasesRelationship"] = ResolversParentTypes["EnrollingConditionSetDiseasesRelationship"]
> = {
	Score?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["Disease"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EnrollingConditionSetIndicationsConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["EnrollingConditionSetIndicationsConnection"] = ResolversParentTypes["EnrollingConditionSetIndicationsConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["EnrollingConditionSetIndicationsRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EnrollingConditionSetIndicationsRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["EnrollingConditionSetIndicationsRelationship"] = ResolversParentTypes["EnrollingConditionSetIndicationsRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["Indication"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EnrollingConditionSetPreparationsConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["EnrollingConditionSetPreparationsConnection"] = ResolversParentTypes["EnrollingConditionSetPreparationsConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["EnrollingConditionSetPreparationsRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EnrollingConditionSetPreparationsRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["EnrollingConditionSetPreparationsRelationship"] = ResolversParentTypes["EnrollingConditionSetPreparationsRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["Preparation"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EnrollingConditionSetTreatmentsConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["EnrollingConditionSetTreatmentsConnection"] = ResolversParentTypes["EnrollingConditionSetTreatmentsConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["EnrollingConditionSetTreatmentsRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EnrollingConditionSetTreatmentsRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["EnrollingConditionSetTreatmentsRelationship"] = ResolversParentTypes["EnrollingConditionSetTreatmentsRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["Treatment"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EnrollingPeriodResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["EnrollingPeriod"] = ResolversParentTypes["EnrollingPeriod"]
> = {
	from?: Resolver<ResolversTypes["Date"], ParentType, ContextType>;
	to?: Resolver<ResolversTypes["Date"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EnrollingPeriodAggregateSelectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["EnrollingPeriodAggregateSelection"] = ResolversParentTypes["EnrollingPeriodAggregateSelection"]
> = {
	count?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExFactoryPriceResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["ExFactoryPrice"] = ResolversParentTypes["ExFactoryPrice"]
> = {
	Price?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	ValidFromDate?: Resolver<Maybe<ResolversTypes["Date"]>, ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExFactoryPriceAggregateSelectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["ExFactoryPriceAggregateSelection"] = ResolversParentTypes["ExFactoryPriceAggregateSelection"]
> = {
	Price?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	count?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FinancialDataPointResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["FinancialDataPoint"] = ResolversParentTypes["FinancialDataPoint"]
> = {
	agreement?: Resolver<
		Maybe<ResolversTypes["Agreement"]>,
		ParentType,
		ContextType,
		RequireFields<FinancialDataPointAgreementArgs, never>
	>;
	agreementConnection?: Resolver<
		ResolversTypes["FinancialDataPointAgreementConnection"],
		ParentType,
		ContextType,
		RequireFields<FinancialDataPointAgreementConnectionArgs, never>
	>;
	basePrice?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
	claim?: Resolver<Maybe<ResolversTypes["Claim"]>, ParentType, ContextType, RequireFields<FinancialDataPointClaimArgs, never>>;
	claimConnection?: Resolver<
		ResolversTypes["FinancialDataPointClaimConnection"],
		ParentType,
		ContextType,
		RequireFields<FinancialDataPointClaimConnectionArgs, never>
	>;
	continuousBenefit?: Resolver<
		Maybe<ResolversTypes["ContinuousBenefit"]>,
		ParentType,
		ContextType,
		RequireFields<FinancialDataPointContinuousBenefitArgs, never>
	>;
	continuousBenefitConnection?: Resolver<
		ResolversTypes["FinancialDataPointContinuousBenefitConnection"],
		ParentType,
		ContextType,
		RequireFields<FinancialDataPointContinuousBenefitConnectionArgs, never>
	>;
	coverageRequest?: Resolver<
		Maybe<ResolversTypes["CoverageRequest"]>,
		ParentType,
		ContextType,
		RequireFields<FinancialDataPointCoverageRequestArgs, never>
	>;
	coverageRequestConnection?: Resolver<
		ResolversTypes["FinancialDataPointCoverageRequestConnection"],
		ParentType,
		ContextType,
		RequireFields<FinancialDataPointCoverageRequestConnectionArgs, never>
	>;
	currencyCode?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	date?: Resolver<ResolversTypes["Date"], ParentType, ContextType>;
	evaluationSnapshot?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	generatedUuid?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
	includedIn?: Resolver<ResolversTypes["Case"], ParentType, ContextType, RequireFields<FinancialDataPointIncludedInArgs, never>>;
	includedInConnection?: Resolver<
		ResolversTypes["FinancialDataPointIncludedInConnection"],
		ParentType,
		ContextType,
		RequireFields<FinancialDataPointIncludedInConnectionArgs, never>
	>;
	intervention?: Resolver<
		Maybe<ResolversTypes["Intervention"]>,
		ParentType,
		ContextType,
		RequireFields<FinancialDataPointInterventionArgs, never>
	>;
	interventionConnection?: Resolver<
		ResolversTypes["FinancialDataPointInterventionConnection"],
		ParentType,
		ContextType,
		RequireFields<FinancialDataPointInterventionConnectionArgs, never>
	>;
	isDeleted?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
	isLast?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
	payable?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
	payablePercentage?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
	prescriptionDate?: Resolver<ResolversTypes["Date"], ParentType, ContextType>;
	quantity?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
	refundable?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
	refundablePercentage?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
	sourceRefund?: Resolver<
		Maybe<ResolversTypes["Refund"]>,
		ParentType,
		ContextType,
		RequireFields<FinancialDataPointSourceRefundArgs, never>
	>;
	sourceRefundConnection?: Resolver<
		ResolversTypes["FinancialDataPointSourceRefundConnection"],
		ParentType,
		ContextType,
		RequireFields<FinancialDataPointSourceRefundConnectionArgs, never>
	>;
	treatment?: Resolver<
		Maybe<ResolversTypes["Treatment"]>,
		ParentType,
		ContextType,
		RequireFields<FinancialDataPointTreatmentArgs, never>
	>;
	treatmentConnection?: Resolver<
		ResolversTypes["FinancialDataPointTreatmentConnection"],
		ParentType,
		ContextType,
		RequireFields<FinancialDataPointTreatmentConnectionArgs, never>
	>;
	uuid?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
	variable?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
	variablePercentage?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FinancialDataPointAggregateSelectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["FinancialDataPointAggregateSelection"] = ResolversParentTypes["FinancialDataPointAggregateSelection"]
> = {
	basePrice?: Resolver<ResolversTypes["FloatAggregateSelection"], ParentType, ContextType>;
	count?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	currencyCode?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	evaluationSnapshot?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	generatedUuid?: Resolver<ResolversTypes["IDAggregateSelection"], ParentType, ContextType>;
	payable?: Resolver<ResolversTypes["FloatAggregateSelection"], ParentType, ContextType>;
	payablePercentage?: Resolver<ResolversTypes["FloatAggregateSelection"], ParentType, ContextType>;
	quantity?: Resolver<ResolversTypes["FloatAggregateSelection"], ParentType, ContextType>;
	refundable?: Resolver<ResolversTypes["FloatAggregateSelection"], ParentType, ContextType>;
	refundablePercentage?: Resolver<ResolversTypes["FloatAggregateSelection"], ParentType, ContextType>;
	uuid?: Resolver<ResolversTypes["IDAggregateSelection"], ParentType, ContextType>;
	variable?: Resolver<ResolversTypes["FloatAggregateSelection"], ParentType, ContextType>;
	variablePercentage?: Resolver<ResolversTypes["FloatAggregateSelection"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FinancialDataPointAgreementConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["FinancialDataPointAgreementConnection"] = ResolversParentTypes["FinancialDataPointAgreementConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["FinancialDataPointAgreementRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FinancialDataPointAgreementRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["FinancialDataPointAgreementRelationship"] = ResolversParentTypes["FinancialDataPointAgreementRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["Agreement"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FinancialDataPointClaimConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["FinancialDataPointClaimConnection"] = ResolversParentTypes["FinancialDataPointClaimConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["FinancialDataPointClaimRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FinancialDataPointClaimRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["FinancialDataPointClaimRelationship"] = ResolversParentTypes["FinancialDataPointClaimRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["Claim"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FinancialDataPointContinuousBenefitConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["FinancialDataPointContinuousBenefitConnection"] = ResolversParentTypes["FinancialDataPointContinuousBenefitConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["FinancialDataPointContinuousBenefitRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FinancialDataPointContinuousBenefitRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["FinancialDataPointContinuousBenefitRelationship"] = ResolversParentTypes["FinancialDataPointContinuousBenefitRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["ContinuousBenefit"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FinancialDataPointCoverageRequestConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["FinancialDataPointCoverageRequestConnection"] = ResolversParentTypes["FinancialDataPointCoverageRequestConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["FinancialDataPointCoverageRequestRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FinancialDataPointCoverageRequestRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["FinancialDataPointCoverageRequestRelationship"] = ResolversParentTypes["FinancialDataPointCoverageRequestRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["CoverageRequest"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FinancialDataPointIncludedInConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["FinancialDataPointIncludedInConnection"] = ResolversParentTypes["FinancialDataPointIncludedInConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["FinancialDataPointIncludedInRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FinancialDataPointIncludedInRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["FinancialDataPointIncludedInRelationship"] = ResolversParentTypes["FinancialDataPointIncludedInRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["Case"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FinancialDataPointInterventionConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["FinancialDataPointInterventionConnection"] = ResolversParentTypes["FinancialDataPointInterventionConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["FinancialDataPointInterventionRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FinancialDataPointInterventionRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["FinancialDataPointInterventionRelationship"] = ResolversParentTypes["FinancialDataPointInterventionRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["Intervention"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FinancialDataPointSourceRefundConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["FinancialDataPointSourceRefundConnection"] = ResolversParentTypes["FinancialDataPointSourceRefundConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["FinancialDataPointSourceRefundRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FinancialDataPointSourceRefundRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["FinancialDataPointSourceRefundRelationship"] = ResolversParentTypes["FinancialDataPointSourceRefundRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["Refund"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FinancialDataPointTreatmentConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["FinancialDataPointTreatmentConnection"] = ResolversParentTypes["FinancialDataPointTreatmentConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["FinancialDataPointTreatmentRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FinancialDataPointTreatmentRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["FinancialDataPointTreatmentRelationship"] = ResolversParentTypes["FinancialDataPointTreatmentRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["Treatment"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FinancialReportDataPointResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["FinancialReportDataPoint"] = ResolversParentTypes["FinancialReportDataPoint"]
> = {
	date?: Resolver<ResolversTypes["Date"], ParentType, ContextType>;
	discountAmount?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
	grossAmount?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
	netAmount?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
	variableAmount?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FinancialReportDataPointAggregateSelectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["FinancialReportDataPointAggregateSelection"] = ResolversParentTypes["FinancialReportDataPointAggregateSelection"]
> = {
	count?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	discountAmount?: Resolver<ResolversTypes["FloatAggregateSelection"], ParentType, ContextType>;
	grossAmount?: Resolver<ResolversTypes["FloatAggregateSelection"], ParentType, ContextType>;
	netAmount?: Resolver<ResolversTypes["FloatAggregateSelection"], ParentType, ContextType>;
	variableAmount?: Resolver<ResolversTypes["FloatAggregateSelection"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FinancialSummaryColumnResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["FinancialSummaryColumn"] = ResolversParentTypes["FinancialSummaryColumn"]
> = {
	id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
	name?: Resolver<ResolversTypes["FinancialSummaryColumnName"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FinancialSummaryColumnAggregateSelectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["FinancialSummaryColumnAggregateSelection"] = ResolversParentTypes["FinancialSummaryColumnAggregateSelection"]
> = {
	count?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	id?: Resolver<ResolversTypes["IDAggregateSelection"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FinancialSummaryRowResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["FinancialSummaryRow"] = ResolversParentTypes["FinancialSummaryRow"]
> = {
	baselinePrice?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
	discountAmount?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
	discountPercentage?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
	exFactoryPrice?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
	grossAmount?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
	name?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	nestedRows?: Resolver<Array<ResolversTypes["FinancialSummaryRow"]>, ParentType, ContextType>;
	netAmount?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
	netAvgDiscountRate?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
	netAvgPrice?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
	netPrice?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
	publicPrice?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
	quantity?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
	variableAmount?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FinancialSummaryRowAggregateSelectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["FinancialSummaryRowAggregateSelection"] = ResolversParentTypes["FinancialSummaryRowAggregateSelection"]
> = {
	baselinePrice?: Resolver<ResolversTypes["FloatAggregateSelection"], ParentType, ContextType>;
	count?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	discountAmount?: Resolver<ResolversTypes["FloatAggregateSelection"], ParentType, ContextType>;
	discountPercentage?: Resolver<ResolversTypes["FloatAggregateSelection"], ParentType, ContextType>;
	exFactoryPrice?: Resolver<ResolversTypes["FloatAggregateSelection"], ParentType, ContextType>;
	grossAmount?: Resolver<ResolversTypes["FloatAggregateSelection"], ParentType, ContextType>;
	name?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	netAmount?: Resolver<ResolversTypes["FloatAggregateSelection"], ParentType, ContextType>;
	netAvgDiscountRate?: Resolver<ResolversTypes["FloatAggregateSelection"], ParentType, ContextType>;
	netAvgPrice?: Resolver<ResolversTypes["FloatAggregateSelection"], ParentType, ContextType>;
	netPrice?: Resolver<ResolversTypes["FloatAggregateSelection"], ParentType, ContextType>;
	publicPrice?: Resolver<ResolversTypes["FloatAggregateSelection"], ParentType, ContextType>;
	quantity?: Resolver<ResolversTypes["FloatAggregateSelection"], ParentType, ContextType>;
	variableAmount?: Resolver<ResolversTypes["FloatAggregateSelection"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexEntityResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["FlexEntity"] = ResolversParentTypes["FlexEntity"]
> = {
	administrationDate?: Resolver<Maybe<ResolversTypes["DateTime"]>, ParentType, ContextType>;
	cases?: Resolver<Array<ResolversTypes["Case"]>, ParentType, ContextType, RequireFields<FlexEntityCasesArgs, never>>;
	casesConnection?: Resolver<
		ResolversTypes["FlexEntityCasesConnection"],
		ParentType,
		ContextType,
		RequireFields<FlexEntityCasesConnectionArgs, never>
	>;
	children?: Resolver<Array<ResolversTypes["FlexEntity"]>, ParentType, ContextType, RequireFields<FlexEntityChildrenArgs, never>>;
	childrenConnection?: Resolver<
		ResolversTypes["FlexEntityChildrenConnection"],
		ParentType,
		ContextType,
		RequireFields<FlexEntityChildrenConnectionArgs, never>
	>;
	containerType?: Resolver<ResolversTypes["FlexContainerType"], ParentType, ContextType>;
	createdBy?: Resolver<ResolversTypes["User"], ParentType, ContextType, RequireFields<FlexEntityCreatedByArgs, never>>;
	createdByConnection?: Resolver<
		ResolversTypes["FlexEntityCreatedByConnection"],
		ParentType,
		ContextType,
		RequireFields<FlexEntityCreatedByConnectionArgs, never>
	>;
	createdByName?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	createdOn?: Resolver<ResolversTypes["DateTime"], ParentType, ContextType>;
	data?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	financialDataPoints?: Resolver<
		Array<ResolversTypes["FlexFinancialDataPoint"]>,
		ParentType,
		ContextType,
		RequireFields<FlexEntityDataPointsArgs, never>
	>;
	dataPointsConnection?: Resolver<
		ResolversTypes["FlexEntityDataPointsConnection"],
		ParentType,
		ContextType,
		RequireFields<FlexEntityDataPointsConnectionArgs, never>
	>;
	id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
	isArchived?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
	isDeleted?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
	isStartingPoint?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
	lastUpdatedOn?: Resolver<Maybe<ResolversTypes["DateTime"]>, ParentType, ContextType>;
	occurrence?: Resolver<Maybe<ResolversTypes["OccurrenceEnum"]>, ParentType, ContextType>;
	patient?: Resolver<Maybe<ResolversTypes["Patient"]>, ParentType, ContextType, RequireFields<FlexEntityPatientArgs, never>>;
	patientConnection?: Resolver<
		ResolversTypes["FlexEntityPatientConnection"],
		ParentType,
		ContextType,
		RequireFields<FlexEntityPatientConnectionArgs, never>
	>;
	patientId?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	preparationBrandNames?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	preparationGenericNames?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	prescriptionDate?: Resolver<Maybe<ResolversTypes["Date"]>, ParentType, ContextType>;
	quantity?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
	rating?: Resolver<Maybe<ResolversTypes["CoverageRequestRating"]>, ParentType, ContextType>;
	source?: Resolver<Maybe<ResolversTypes["FlexEntity"]>, ParentType, ContextType, RequireFields<FlexEntitySourceArgs, never>>;
	sourceConnection?: Resolver<
		ResolversTypes["FlexEntitySourceConnection"],
		ParentType,
		ContextType,
		RequireFields<FlexEntitySourceConnectionArgs, never>
	>;
	startingPoint?: Resolver<
		Maybe<ResolversTypes["FlexEntity"]>,
		ParentType,
		ContextType,
		RequireFields<FlexEntityStartingPointArgs, never>
	>;
	startingPointConnection?: Resolver<
		ResolversTypes["FlexEntityStartingPointConnection"],
		ParentType,
		ContextType,
		RequireFields<FlexEntityStartingPointConnectionArgs, never>
	>;
	status?: Resolver<Maybe<ResolversTypes["FlexFormStatus"]>, ParentType, ContextType>;
	tenantId?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	type?: Resolver<ResolversTypes["FlexEntityType"], ParentType, ContextType, RequireFields<FlexEntityTypeArgs, never>>;
	typeConnection?: Resolver<
		ResolversTypes["FlexEntityTypeConnection"],
		ParentType,
		ContextType,
		RequireFields<FlexEntityTypeConnectionArgs, never>
	>;
	unlimited?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
	uuid?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexEntityAggregateSelectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["FlexEntityAggregateSelection"] = ResolversParentTypes["FlexEntityAggregateSelection"]
> = {
	administrationDate?: Resolver<ResolversTypes["DateTimeAggregateSelection"], ParentType, ContextType>;
	count?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	createdByName?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	createdOn?: Resolver<ResolversTypes["DateTimeAggregateSelection"], ParentType, ContextType>;
	data?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	id?: Resolver<ResolversTypes["IDAggregateSelection"], ParentType, ContextType>;
	lastUpdatedOn?: Resolver<ResolversTypes["DateTimeAggregateSelection"], ParentType, ContextType>;
	patientId?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	preparationBrandNames?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	preparationGenericNames?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	quantity?: Resolver<ResolversTypes["IntAggregateSelection"], ParentType, ContextType>;
	tenantId?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	unlimited?: Resolver<ResolversTypes["IntAggregateSelection"], ParentType, ContextType>;
	uuid?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexEntityCasesConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["FlexEntityCasesConnection"] = ResolversParentTypes["FlexEntityCasesConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["FlexEntityCasesRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexEntityCasesRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["FlexEntityCasesRelationship"] = ResolversParentTypes["FlexEntityCasesRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["Case"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexEntityChildrenConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["FlexEntityChildrenConnection"] = ResolversParentTypes["FlexEntityChildrenConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["FlexEntityChildrenRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexEntityChildrenRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["FlexEntityChildrenRelationship"] = ResolversParentTypes["FlexEntityChildrenRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["FlexEntity"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexEntityCreatedByConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["FlexEntityCreatedByConnection"] = ResolversParentTypes["FlexEntityCreatedByConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["FlexEntityCreatedByRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexEntityCreatedByRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["FlexEntityCreatedByRelationship"] = ResolversParentTypes["FlexEntityCreatedByRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["User"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexEntityDataPointsConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["FlexEntityDataPointsConnection"] = ResolversParentTypes["FlexEntityDataPointsConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["FlexEntityDataPointsRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexEntityDataPointsRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["FlexEntityDataPointsRelationship"] = ResolversParentTypes["FlexEntityDataPointsRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["FlexFinancialDataPoint"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexEntityPatientConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["FlexEntityPatientConnection"] = ResolversParentTypes["FlexEntityPatientConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["FlexEntityPatientRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexEntityPatientRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["FlexEntityPatientRelationship"] = ResolversParentTypes["FlexEntityPatientRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["Patient"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexEntitySourceConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["FlexEntitySourceConnection"] = ResolversParentTypes["FlexEntitySourceConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["FlexEntitySourceRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexEntitySourceRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["FlexEntitySourceRelationship"] = ResolversParentTypes["FlexEntitySourceRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["FlexEntity"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexEntityStartingPointConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["FlexEntityStartingPointConnection"] = ResolversParentTypes["FlexEntityStartingPointConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["FlexEntityStartingPointRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexEntityStartingPointRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["FlexEntityStartingPointRelationship"] = ResolversParentTypes["FlexEntityStartingPointRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["FlexEntity"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexEntityTypeResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["FlexEntityType"] = ResolversParentTypes["FlexEntityType"]
> = {
	addedBy?: Resolver<ResolversTypes["User"], ParentType, ContextType, RequireFields<FlexEntityTypeAddedByArgs, never>>;
	addedByConnection?: Resolver<
		ResolversTypes["FlexEntityTypeAddedByConnection"],
		ParentType,
		ContextType,
		RequireFields<FlexEntityTypeAddedByConnectionArgs, never>
	>;
	addedByName?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	attributeCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	containerType?: Resolver<ResolversTypes["FlexContainerType"], ParentType, ContextType>;
	createdOn?: Resolver<ResolversTypes["DateTime"], ParentType, ContextType>;
	creationWays?: Resolver<Array<ResolversTypes["DataContainerCreationWay"]>, ParentType, ContextType>;
	data?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	description?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	features?: Resolver<Array<ResolversTypes["FlexEntityFeature"]>, ParentType, ContextType>;
	id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
	idPrefix?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	instances?: Resolver<Array<ResolversTypes["FlexEntity"]>, ParentType, ContextType, RequireFields<FlexEntityTypeInstancesArgs, never>>;
	instancesConnection?: Resolver<
		ResolversTypes["FlexEntityTypeInstancesConnection"],
		ParentType,
		ContextType,
		RequireFields<FlexEntityTypeInstancesConnectionArgs, never>
	>;
	isArchived?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
	isOptional?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
	isStartingPoint?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
	name?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	tooltipText?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexEntityTypeAddedByConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["FlexEntityTypeAddedByConnection"] = ResolversParentTypes["FlexEntityTypeAddedByConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["FlexEntityTypeAddedByRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexEntityTypeAddedByRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["FlexEntityTypeAddedByRelationship"] = ResolversParentTypes["FlexEntityTypeAddedByRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["User"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexEntityTypeAggregateSelectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["FlexEntityTypeAggregateSelection"] = ResolversParentTypes["FlexEntityTypeAggregateSelection"]
> = {
	addedByName?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	attributeCount?: Resolver<ResolversTypes["IntAggregateSelection"], ParentType, ContextType>;
	count?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	createdOn?: Resolver<ResolversTypes["DateTimeAggregateSelection"], ParentType, ContextType>;
	data?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	description?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	id?: Resolver<ResolversTypes["IDAggregateSelection"], ParentType, ContextType>;
	idPrefix?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	name?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	tooltipText?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexEntityTypeConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["FlexEntityTypeConnection"] = ResolversParentTypes["FlexEntityTypeConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["FlexEntityTypeRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexEntityTypeInstancesConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["FlexEntityTypeInstancesConnection"] = ResolversParentTypes["FlexEntityTypeInstancesConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["FlexEntityTypeInstancesRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexEntityTypeInstancesRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["FlexEntityTypeInstancesRelationship"] = ResolversParentTypes["FlexEntityTypeInstancesRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["FlexEntity"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexEntityTypeRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["FlexEntityTypeRelationship"] = ResolversParentTypes["FlexEntityTypeRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["FlexEntityType"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexFinancialDataPointResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["FlexFinancialDataPoint"] = ResolversParentTypes["FlexFinancialDataPoint"]
> = {
	agreement?: Resolver<
		Maybe<ResolversTypes["Agreement"]>,
		ParentType,
		ContextType,
		RequireFields<FlexFinancialDataPointAgreementArgs, never>
	>;
	agreementConnection?: Resolver<
		ResolversTypes["FlexFinancialDataPointAgreementConnection"],
		ParentType,
		ContextType,
		RequireFields<FlexFinancialDataPointAgreementConnectionArgs, never>
	>;
	basePrice?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
	currencyCode?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	date?: Resolver<ResolversTypes["Date"], ParentType, ContextType>;
	evaluates?: Resolver<ResolversTypes["FlexEntity"], ParentType, ContextType, RequireFields<FlexFinancialDataPointEvaluatesArgs, never>>;
	evaluatesConnection?: Resolver<
		ResolversTypes["FlexFinancialDataPointEvaluatesConnection"],
		ParentType,
		ContextType,
		RequireFields<FlexFinancialDataPointEvaluatesConnectionArgs, never>
	>;
	evaluationSnapshot?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	generatedUuid?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
	includedIn?: Resolver<ResolversTypes["Case"], ParentType, ContextType, RequireFields<FlexFinancialDataPointIncludedInArgs, never>>;
	includedInConnection?: Resolver<
		ResolversTypes["FlexFinancialDataPointIncludedInConnection"],
		ParentType,
		ContextType,
		RequireFields<FlexFinancialDataPointIncludedInConnectionArgs, never>
	>;
	isDeleted?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
	isLast?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
	payable?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
	payablePercentage?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
	prescriptionDate?: Resolver<ResolversTypes["Date"], ParentType, ContextType>;
	quantity?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
	refundable?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
	refundablePercentage?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
	sourceRefund?: Resolver<
		Maybe<ResolversTypes["Refund"]>,
		ParentType,
		ContextType,
		RequireFields<FlexFinancialDataPointSourceRefundArgs, never>
	>;
	sourceRefundConnection?: Resolver<
		ResolversTypes["FlexFinancialDataPointSourceRefundConnection"],
		ParentType,
		ContextType,
		RequireFields<FlexFinancialDataPointSourceRefundConnectionArgs, never>
	>;
	startingPoint?: Resolver<
		ResolversTypes["FlexEntity"],
		ParentType,
		ContextType,
		RequireFields<FlexFinancialDataPointStartingPointArgs, never>
	>;
	startingPointConnection?: Resolver<
		ResolversTypes["FlexFinancialDataPointStartingPointConnection"],
		ParentType,
		ContextType,
		RequireFields<FlexFinancialDataPointStartingPointConnectionArgs, never>
	>;
	treatment?: Resolver<
		Maybe<ResolversTypes["Treatment"]>,
		ParentType,
		ContextType,
		RequireFields<FlexFinancialDataPointTreatmentArgs, never>
	>;
	treatmentConnection?: Resolver<
		ResolversTypes["FlexFinancialDataPointTreatmentConnection"],
		ParentType,
		ContextType,
		RequireFields<FlexFinancialDataPointTreatmentConnectionArgs, never>
	>;
	uuid?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
	variable?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
	variablePercentage?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexFinancialDataPointAggregateSelectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["FlexFinancialDataPointAggregateSelection"] = ResolversParentTypes["FlexFinancialDataPointAggregateSelection"]
> = {
	basePrice?: Resolver<ResolversTypes["FloatAggregateSelection"], ParentType, ContextType>;
	count?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	currencyCode?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	evaluationSnapshot?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	generatedUuid?: Resolver<ResolversTypes["IDAggregateSelection"], ParentType, ContextType>;
	payable?: Resolver<ResolversTypes["FloatAggregateSelection"], ParentType, ContextType>;
	payablePercentage?: Resolver<ResolversTypes["FloatAggregateSelection"], ParentType, ContextType>;
	quantity?: Resolver<ResolversTypes["FloatAggregateSelection"], ParentType, ContextType>;
	refundable?: Resolver<ResolversTypes["FloatAggregateSelection"], ParentType, ContextType>;
	refundablePercentage?: Resolver<ResolversTypes["FloatAggregateSelection"], ParentType, ContextType>;
	uuid?: Resolver<ResolversTypes["IDAggregateSelection"], ParentType, ContextType>;
	variable?: Resolver<ResolversTypes["FloatAggregateSelection"], ParentType, ContextType>;
	variablePercentage?: Resolver<ResolversTypes["FloatAggregateSelection"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexFinancialDataPointAgreementConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["FlexFinancialDataPointAgreementConnection"] = ResolversParentTypes["FlexFinancialDataPointAgreementConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["FlexFinancialDataPointAgreementRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexFinancialDataPointAgreementRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["FlexFinancialDataPointAgreementRelationship"] = ResolversParentTypes["FlexFinancialDataPointAgreementRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["Agreement"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexFinancialDataPointEvaluatesConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["FlexFinancialDataPointEvaluatesConnection"] = ResolversParentTypes["FlexFinancialDataPointEvaluatesConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["FlexFinancialDataPointEvaluatesRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexFinancialDataPointEvaluatesRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["FlexFinancialDataPointEvaluatesRelationship"] = ResolversParentTypes["FlexFinancialDataPointEvaluatesRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["FlexEntity"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexFinancialDataPointIncludedInConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["FlexFinancialDataPointIncludedInConnection"] = ResolversParentTypes["FlexFinancialDataPointIncludedInConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["FlexFinancialDataPointIncludedInRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexFinancialDataPointIncludedInRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["FlexFinancialDataPointIncludedInRelationship"] = ResolversParentTypes["FlexFinancialDataPointIncludedInRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["Case"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexFinancialDataPointSourceRefundConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["FlexFinancialDataPointSourceRefundConnection"] = ResolversParentTypes["FlexFinancialDataPointSourceRefundConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["FlexFinancialDataPointSourceRefundRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexFinancialDataPointSourceRefundRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["FlexFinancialDataPointSourceRefundRelationship"] = ResolversParentTypes["FlexFinancialDataPointSourceRefundRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["Refund"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexFinancialDataPointStartingPointConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["FlexFinancialDataPointStartingPointConnection"] = ResolversParentTypes["FlexFinancialDataPointStartingPointConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["FlexFinancialDataPointStartingPointRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexFinancialDataPointStartingPointRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["FlexFinancialDataPointStartingPointRelationship"] = ResolversParentTypes["FlexFinancialDataPointStartingPointRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["FlexEntity"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexFinancialDataPointTreatmentConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["FlexFinancialDataPointTreatmentConnection"] = ResolversParentTypes["FlexFinancialDataPointTreatmentConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["FlexFinancialDataPointTreatmentRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexFinancialDataPointTreatmentRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["FlexFinancialDataPointTreatmentRelationship"] = ResolversParentTypes["FlexFinancialDataPointTreatmentRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["Treatment"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FloatAggregateSelectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["FloatAggregateSelection"] = ResolversParentTypes["FloatAggregateSelection"]
> = {
	average?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
	max?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
	min?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FormResolvers<ContextType = any, ParentType extends ResolversParentTypes["Form"] = ResolversParentTypes["Form"]> = {
	case?: Resolver<Maybe<ResolversTypes["Case"]>, ParentType, ContextType>;
	continuousBenefit?: Resolver<
		Maybe<ResolversTypes["ContinuousBenefit"]>,
		ParentType,
		ContextType,
		RequireFields<FormContinuousBenefitArgs, never>
	>;
	continuousBenefitConnection?: Resolver<
		ResolversTypes["FormContinuousBenefitConnection"],
		ParentType,
		ContextType,
		RequireFields<FormContinuousBenefitConnectionArgs, never>
	>;
	coverageRequest?: Resolver<
		Maybe<ResolversTypes["CoverageRequest"]>,
		ParentType,
		ContextType,
		RequireFields<FormCoverageRequestArgs, never>
	>;
	coverageRequestConnection?: Resolver<
		ResolversTypes["FormCoverageRequestConnection"],
		ParentType,
		ContextType,
		RequireFields<FormCoverageRequestConnectionArgs, never>
	>;
	createdBy?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	createdByName?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	createdOn?: Resolver<ResolversTypes["DateTime"], ParentType, ContextType>;
	discontinuationNote?: Resolver<
		Maybe<ResolversTypes["DiscontinuationNote"]>,
		ParentType,
		ContextType,
		RequireFields<FormDiscontinuationNoteArgs, never>
	>;
	discontinuationNoteConnection?: Resolver<
		ResolversTypes["FormDiscontinuationNoteConnection"],
		ParentType,
		ContextType,
		RequireFields<FormDiscontinuationNoteConnectionArgs, never>
	>;
	id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
	initialResponse?: Resolver<
		Maybe<ResolversTypes["InitialResponse"]>,
		ParentType,
		ContextType,
		RequireFields<FormInitialResponseArgs, never>
	>;
	initialResponseConnection?: Resolver<
		ResolversTypes["FormInitialResponseConnection"],
		ParentType,
		ContextType,
		RequireFields<FormInitialResponseConnectionArgs, never>
	>;
	insuranceId?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	isArchived?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
	isDeleted?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
	lastUpdatedOn?: Resolver<Maybe<ResolversTypes["DateTime"]>, ParentType, ContextType>;
	occurrence?: Resolver<Maybe<ResolversTypes["OccurrenceEnum"]>, ParentType, ContextType>;
	preparationBrandName?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	preparationGenericName?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	primaryIntervention?: Resolver<
		Maybe<ResolversTypes["Intervention"]>,
		ParentType,
		ContextType,
		RequireFields<FormPrimaryInterventionArgs, never>
	>;
	primaryInterventionConnection?: Resolver<
		ResolversTypes["FormPrimaryInterventionConnection"],
		ParentType,
		ContextType,
		RequireFields<FormPrimaryInterventionConnectionArgs, never>
	>;
	status?: Resolver<Maybe<ResolversTypes["FormStatus"]>, ParentType, ContextType>;
	subsequentIntervention?: Resolver<
		Maybe<ResolversTypes["Intervention"]>,
		ParentType,
		ContextType,
		RequireFields<FormSubsequentInterventionArgs, never>
	>;
	subsequentInterventionConnection?: Resolver<
		ResolversTypes["FormSubsequentInterventionConnection"],
		ParentType,
		ContextType,
		RequireFields<FormSubsequentInterventionConnectionArgs, never>
	>;
	tenantId?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	type?: Resolver<Maybe<ResolversTypes["FormType"]>, ParentType, ContextType>;
	unlimited?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
	uuid?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FormAggregateSelectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["FormAggregateSelection"] = ResolversParentTypes["FormAggregateSelection"]
> = {
	count?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	createdBy?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	createdByName?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	createdOn?: Resolver<ResolversTypes["DateTimeAggregateSelection"], ParentType, ContextType>;
	id?: Resolver<ResolversTypes["IDAggregateSelection"], ParentType, ContextType>;
	insuranceId?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	lastUpdatedOn?: Resolver<ResolversTypes["DateTimeAggregateSelection"], ParentType, ContextType>;
	preparationBrandName?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	preparationGenericName?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	tenantId?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	unlimited?: Resolver<ResolversTypes["IntAggregateSelection"], ParentType, ContextType>;
	uuid?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FormContinuousBenefitConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["FormContinuousBenefitConnection"] = ResolversParentTypes["FormContinuousBenefitConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["FormContinuousBenefitRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FormContinuousBenefitRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["FormContinuousBenefitRelationship"] = ResolversParentTypes["FormContinuousBenefitRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["ContinuousBenefit"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FormCoverageRequestConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["FormCoverageRequestConnection"] = ResolversParentTypes["FormCoverageRequestConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["FormCoverageRequestRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FormCoverageRequestRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["FormCoverageRequestRelationship"] = ResolversParentTypes["FormCoverageRequestRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["CoverageRequest"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FormDiscontinuationNoteConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["FormDiscontinuationNoteConnection"] = ResolversParentTypes["FormDiscontinuationNoteConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["FormDiscontinuationNoteRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FormDiscontinuationNoteRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["FormDiscontinuationNoteRelationship"] = ResolversParentTypes["FormDiscontinuationNoteRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["DiscontinuationNote"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FormInitialResponseConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["FormInitialResponseConnection"] = ResolversParentTypes["FormInitialResponseConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["FormInitialResponseRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FormInitialResponseRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["FormInitialResponseRelationship"] = ResolversParentTypes["FormInitialResponseRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["InitialResponse"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FormPrimaryInterventionConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["FormPrimaryInterventionConnection"] = ResolversParentTypes["FormPrimaryInterventionConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["FormPrimaryInterventionRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FormPrimaryInterventionRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["FormPrimaryInterventionRelationship"] = ResolversParentTypes["FormPrimaryInterventionRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["Intervention"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FormSubsequentInterventionConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["FormSubsequentInterventionConnection"] = ResolversParentTypes["FormSubsequentInterventionConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["FormSubsequentInterventionRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FormSubsequentInterventionRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["FormSubsequentInterventionRelationship"] = ResolversParentTypes["FormSubsequentInterventionRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["Intervention"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GqlBaseResponseResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["GQLBaseResponse"] = ResolversParentTypes["GQLBaseResponse"]
> = {
	__resolveType: TypeResolveFn<"InterventionReportStatusResponse", ParentType, ContextType>;
	message?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	responseStatus?: Resolver<Maybe<ResolversTypes["GQLResponseStatus"]>, ParentType, ContextType>;
};

export type IdAggregateSelectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["IDAggregateSelection"] = ResolversParentTypes["IDAggregateSelection"]
> = {
	longest?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
	shortest?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type IOrderedResolvers<ContextType = any, ParentType extends ResolversParentTypes["IOrdered"] = ResolversParentTypes["IOrdered"]> = {
	__resolveType: TypeResolveFn<"RecommendedForm" | "StobAction" | "StobCondition" | "StobScenario", ParentType, ContextType>;
	order?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
};

export type ITimeframeResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["ITimeframe"] = ResolversParentTypes["ITimeframe"]
> = {
	__resolveType: TypeResolveFn<"ScenarioAction" | "ScenarioCondition", ParentType, ContextType>;
	timeframeEnd?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
	timeframeEndDate?: Resolver<Maybe<ResolversTypes["Date"]>, ParentType, ContextType>;
	timeframeRangeType?: Resolver<Maybe<ResolversTypes["TimeframeRangeType"]>, ParentType, ContextType>;
	timeframeStart?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
	timeframeStartDate?: Resolver<Maybe<ResolversTypes["Date"]>, ParentType, ContextType>;
};

export type ITreatmentStateResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["ITreatmentState"] = ResolversParentTypes["ITreatmentState"]
> = {
	__resolveType: TypeResolveFn<"ContinuousBenefit" | "DiscontinuationNote" | "InitialResponse", ParentType, ContextType>;
	assessmentDate?: Resolver<Maybe<ResolversTypes["Date"]>, ParentType, ContextType>;
	isPatientEnrolledInTreatment?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
	reasonForDiscontinuation?: Resolver<Maybe<ResolversTypes["ReasonsForDiscontinuation"]>, ParentType, ContextType>;
	submissionDate?: Resolver<Maybe<ResolversTypes["DateTime"]>, ParentType, ContextType>;
};

export type IndicationResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["Indication"] = ResolversParentTypes["Indication"]
> = {
	bagCode?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	code?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	intent?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	line?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	mutation?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	type?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type IndicationAggregateSelectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["IndicationAggregateSelection"] = ResolversParentTypes["IndicationAggregateSelection"]
> = {
	bagCode?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	code?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	count?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	intent?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	line?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	mutation?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	type?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InitialResponseResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["InitialResponse"] = ResolversParentTypes["InitialResponse"]
> = {
	adverseEvents?: Resolver<
		Array<ResolversTypes["AdverseEvent"]>,
		ParentType,
		ContextType,
		RequireFields<InitialResponseAdverseEventsArgs, never>
	>;
	adverseEventsConnection?: Resolver<
		ResolversTypes["InitialResponseAdverseEventsConnection"],
		ParentType,
		ContextType,
		RequireFields<InitialResponseAdverseEventsConnectionArgs, never>
	>;
	assessmentDate?: Resolver<ResolversTypes["Date"], ParentType, ContextType>;
	continuousBenefit?: Resolver<
		Array<ResolversTypes["ContinuousBenefit"]>,
		ParentType,
		ContextType,
		RequireFields<InitialResponseContinuousBenefitArgs, never>
	>;
	continuousBenefitConnection?: Resolver<
		ResolversTypes["InitialResponseContinuousBenefitConnection"],
		ParentType,
		ContextType,
		RequireFields<InitialResponseContinuousBenefitConnectionArgs, never>
	>;
	coverageRequest?: Resolver<
		Maybe<ResolversTypes["CoverageRequest"]>,
		ParentType,
		ContextType,
		RequireFields<InitialResponseCoverageRequestArgs, never>
	>;
	coverageRequestConnection?: Resolver<
		ResolversTypes["InitialResponseCoverageRequestConnection"],
		ParentType,
		ContextType,
		RequireFields<InitialResponseCoverageRequestConnectionArgs, never>
	>;
	createdOn?: Resolver<ResolversTypes["DateTime"], ParentType, ContextType>;
	form?: Resolver<Maybe<ResolversTypes["Form"]>, ParentType, ContextType, RequireFields<InitialResponseFormArgs, never>>;
	formConnection?: Resolver<
		ResolversTypes["InitialResponseFormConnection"],
		ParentType,
		ContextType,
		RequireFields<InitialResponseFormConnectionArgs, never>
	>;
	id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
	isArchived?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
	isDeleted?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
	isPatientEnrolledInTreatment?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
	isResponseReceived?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
	numberOfPrescriptionsToDate?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
	reasonForDiscontinuation?: Resolver<Maybe<ResolversTypes["ReasonsForDiscontinuation"]>, ParentType, ContextType>;
	result?: Resolver<Maybe<ResolversTypes["ResponseType"]>, ParentType, ContextType>;
	status?: Resolver<Maybe<ResolversTypes["FormStatus"]>, ParentType, ContextType>;
	submissionDate?: Resolver<Maybe<ResolversTypes["DateTime"]>, ParentType, ContextType>;
	tenantId?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	therapyStartDate?: Resolver<Maybe<ResolversTypes["Date"]>, ParentType, ContextType>;
	treatingPhysician?: Resolver<
		Maybe<ResolversTypes["TreatingPhysician"]>,
		ParentType,
		ContextType,
		RequireFields<InitialResponseTreatingPhysicianArgs, never>
	>;
	treatingPhysicianConnection?: Resolver<
		ResolversTypes["InitialResponseTreatingPhysicianConnection"],
		ParentType,
		ContextType,
		RequireFields<InitialResponseTreatingPhysicianConnectionArgs, never>
	>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InitialResponseAdverseEventsConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["InitialResponseAdverseEventsConnection"] = ResolversParentTypes["InitialResponseAdverseEventsConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["InitialResponseAdverseEventsRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InitialResponseAdverseEventsRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["InitialResponseAdverseEventsRelationship"] = ResolversParentTypes["InitialResponseAdverseEventsRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["AdverseEvent"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InitialResponseAggregateSelectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["InitialResponseAggregateSelection"] = ResolversParentTypes["InitialResponseAggregateSelection"]
> = {
	count?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	createdOn?: Resolver<ResolversTypes["DateTimeAggregateSelection"], ParentType, ContextType>;
	id?: Resolver<ResolversTypes["IDAggregateSelection"], ParentType, ContextType>;
	numberOfPrescriptionsToDate?: Resolver<ResolversTypes["IntAggregateSelection"], ParentType, ContextType>;
	submissionDate?: Resolver<ResolversTypes["DateTimeAggregateSelection"], ParentType, ContextType>;
	tenantId?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InitialResponseContinuousBenefitConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["InitialResponseContinuousBenefitConnection"] = ResolversParentTypes["InitialResponseContinuousBenefitConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["InitialResponseContinuousBenefitRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InitialResponseContinuousBenefitRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["InitialResponseContinuousBenefitRelationship"] = ResolversParentTypes["InitialResponseContinuousBenefitRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["ContinuousBenefit"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InitialResponseCoverageRequestConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["InitialResponseCoverageRequestConnection"] = ResolversParentTypes["InitialResponseCoverageRequestConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["InitialResponseCoverageRequestRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InitialResponseCoverageRequestRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["InitialResponseCoverageRequestRelationship"] = ResolversParentTypes["InitialResponseCoverageRequestRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["CoverageRequest"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InitialResponseFormConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["InitialResponseFormConnection"] = ResolversParentTypes["InitialResponseFormConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["InitialResponseFormRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InitialResponseFormRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["InitialResponseFormRelationship"] = ResolversParentTypes["InitialResponseFormRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["Form"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InitialResponseReviewReportResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["InitialResponseReviewReport"] = ResolversParentTypes["InitialResponseReviewReport"]
> = {
	count?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
	order?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
	rate?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
	result?: Resolver<Maybe<ResolversTypes["ResponseType"]>, ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InitialResponseReviewReportAggregateSelectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["InitialResponseReviewReportAggregateSelection"] = ResolversParentTypes["InitialResponseReviewReportAggregateSelection"]
> = {
	count?: Resolver<ResolversTypes["IntAggregateSelection"], ParentType, ContextType>;
	order?: Resolver<ResolversTypes["IntAggregateSelection"], ParentType, ContextType>;
	rate?: Resolver<ResolversTypes["FloatAggregateSelection"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InitialResponseTreatingPhysicianConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["InitialResponseTreatingPhysicianConnection"] = ResolversParentTypes["InitialResponseTreatingPhysicianConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["InitialResponseTreatingPhysicianRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InitialResponseTreatingPhysicianRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["InitialResponseTreatingPhysicianRelationship"] = ResolversParentTypes["InitialResponseTreatingPhysicianRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["TreatingPhysician"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type IntAggregateSelectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["IntAggregateSelection"] = ResolversParentTypes["IntAggregateSelection"]
> = {
	average?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
	max?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	min?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InterventionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["Intervention"] = ResolversParentTypes["Intervention"]
> = {
	LAPressure?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
	LAVolume?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
	case?: Resolver<Maybe<ResolversTypes["Case"]>, ParentType, ContextType, RequireFields<InterventionCaseArgs, never>>;
	caseConnection?: Resolver<
		ResolversTypes["InterventionCaseConnection"],
		ParentType,
		ContextType,
		RequireFields<InterventionCaseConnectionArgs, never>
	>;
	createdBy?: Resolver<ResolversTypes["User"], ParentType, ContextType, RequireFields<InterventionCreatedByArgs, never>>;
	createdByConnection?: Resolver<
		ResolversTypes["InterventionCreatedByConnection"],
		ParentType,
		ContextType,
		RequireFields<InterventionCreatedByConnectionArgs, never>
	>;
	createdOn?: Resolver<ResolversTypes["DateTime"], ParentType, ContextType>;
	disease?: Resolver<Maybe<ResolversTypes["Disease"]>, ParentType, ContextType, RequireFields<InterventionDiseaseArgs, never>>;
	diseaseConnection?: Resolver<
		ResolversTypes["InterventionDiseaseConnection"],
		ParentType,
		ContextType,
		RequireFields<InterventionDiseaseConnectionArgs, never>
	>;
	financialDataPoints?: Resolver<
		Array<ResolversTypes["FinancialDataPoint"]>,
		ParentType,
		ContextType,
		RequireFields<InterventionFinancialDataPointsArgs, never>
	>;
	financialDataPointsConnection?: Resolver<
		ResolversTypes["InterventionFinancialDataPointsConnection"],
		ParentType,
		ContextType,
		RequireFields<InterventionFinancialDataPointsConnectionArgs, never>
	>;
	firstAblationDate?: Resolver<Maybe<ResolversTypes["Date"]>, ParentType, ContextType>;
	form?: Resolver<Maybe<ResolversTypes["Form"]>, ParentType, ContextType, RequireFields<InterventionFormArgs, never>>;
	formConnection?: Resolver<
		ResolversTypes["InterventionFormConnection"],
		ParentType,
		ContextType,
		RequireFields<InterventionFormConnectionArgs, never>
	>;
	id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
	isAdheringToCloseProtocol?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
	isArchived?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
	isCTILineAblated?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
	isDeletable?: Resolver<Maybe<ResolversTypes["Boolean"]>, ParentType, ContextType>;
	isDeleted?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
	isLowVoltageZone?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
	isPrimary?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
	lastUpdatedOn?: Resolver<Maybe<ResolversTypes["DateTime"]>, ParentType, ContextType>;
	legalEntity?: Resolver<
		Maybe<ResolversTypes["Organization"]>,
		ParentType,
		ContextType,
		RequireFields<InterventionLegalEntityArgs, never>
	>;
	legalEntityConnection?: Resolver<
		ResolversTypes["InterventionLegalEntityConnection"],
		ParentType,
		ContextType,
		RequireFields<InterventionLegalEntityConnectionArgs, never>
	>;
	mainItem?: Resolver<Maybe<ResolversTypes["Treatment"]>, ParentType, ContextType, RequireFields<InterventionMainItemArgs, never>>;
	mainItemConnection?: Resolver<
		ResolversTypes["InterventionMainItemConnection"],
		ParentType,
		ContextType,
		RequireFields<InterventionMainItemConnectionArgs, never>
	>;
	patient?: Resolver<Maybe<ResolversTypes["Patient"]>, ParentType, ContextType, RequireFields<InterventionPatientArgs, never>>;
	patientConnection?: Resolver<
		ResolversTypes["InterventionPatientConnection"],
		ParentType,
		ContextType,
		RequireFields<InterventionPatientConnectionArgs, never>
	>;
	programCoverEndDate?: Resolver<Maybe<ResolversTypes["Date"]>, ParentType, ContextType>;
	recurrenceDate?: Resolver<Maybe<ResolversTypes["Date"]>, ParentType, ContextType>;
	reportStatus?: Resolver<ResolversTypes["RefundStatus"], ParentType, ContextType>;
	responsiblePhysicianAlias?: Resolver<ResolversTypes["CAOBPhysician"], ParentType, ContextType>;
	secondAblationDate?: Resolver<Maybe<ResolversTypes["Date"]>, ParentType, ContextType>;
	status?: Resolver<ResolversTypes["FormStatus"], ParentType, ContextType>;
	submissionDate?: Resolver<Maybe<ResolversTypes["DateTime"]>, ParentType, ContextType>;
	subsequentIntervention?: Resolver<
		Array<ResolversTypes["Intervention"]>,
		ParentType,
		ContextType,
		RequireFields<InterventionSubsequentInterventionArgs, never>
	>;
	subsequentInterventionConnection?: Resolver<
		ResolversTypes["InterventionSubsequentInterventionConnection"],
		ParentType,
		ContextType,
		RequireFields<InterventionSubsequentInterventionConnectionArgs, never>
	>;
	supportingItem?: Resolver<
		Array<ResolversTypes["Treatment"]>,
		ParentType,
		ContextType,
		RequireFields<InterventionSupportingItemArgs, never>
	>;
	supportingItemConnection?: Resolver<
		ResolversTypes["InterventionSupportingItemConnection"],
		ParentType,
		ContextType,
		RequireFields<InterventionSupportingItemConnectionArgs, never>
	>;
	tenantId?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InterventionAggregateSelectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["InterventionAggregateSelection"] = ResolversParentTypes["InterventionAggregateSelection"]
> = {
	LAPressure?: Resolver<ResolversTypes["IntAggregateSelection"], ParentType, ContextType>;
	LAVolume?: Resolver<ResolversTypes["IntAggregateSelection"], ParentType, ContextType>;
	count?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	createdOn?: Resolver<ResolversTypes["DateTimeAggregateSelection"], ParentType, ContextType>;
	id?: Resolver<ResolversTypes["IDAggregateSelection"], ParentType, ContextType>;
	lastUpdatedOn?: Resolver<ResolversTypes["DateTimeAggregateSelection"], ParentType, ContextType>;
	submissionDate?: Resolver<ResolversTypes["DateTimeAggregateSelection"], ParentType, ContextType>;
	tenantId?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InterventionCaseConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["InterventionCaseConnection"] = ResolversParentTypes["InterventionCaseConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["InterventionCaseRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InterventionCaseRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["InterventionCaseRelationship"] = ResolversParentTypes["InterventionCaseRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["Case"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InterventionCreatedByConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["InterventionCreatedByConnection"] = ResolversParentTypes["InterventionCreatedByConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["InterventionCreatedByRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InterventionCreatedByRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["InterventionCreatedByRelationship"] = ResolversParentTypes["InterventionCreatedByRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["User"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InterventionDiseaseConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["InterventionDiseaseConnection"] = ResolversParentTypes["InterventionDiseaseConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["InterventionDiseaseRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InterventionDiseaseRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["InterventionDiseaseRelationship"] = ResolversParentTypes["InterventionDiseaseRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["Disease"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InterventionFinancialDataPointsConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["InterventionFinancialDataPointsConnection"] = ResolversParentTypes["InterventionFinancialDataPointsConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["InterventionFinancialDataPointsRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InterventionFinancialDataPointsRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["InterventionFinancialDataPointsRelationship"] = ResolversParentTypes["InterventionFinancialDataPointsRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["FinancialDataPoint"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InterventionFormConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["InterventionFormConnection"] = ResolversParentTypes["InterventionFormConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["InterventionFormRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InterventionFormRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["InterventionFormRelationship"] = ResolversParentTypes["InterventionFormRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["Form"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InterventionLegalEntityConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["InterventionLegalEntityConnection"] = ResolversParentTypes["InterventionLegalEntityConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["InterventionLegalEntityRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InterventionLegalEntityRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["InterventionLegalEntityRelationship"] = ResolversParentTypes["InterventionLegalEntityRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["Organization"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InterventionMainItemConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["InterventionMainItemConnection"] = ResolversParentTypes["InterventionMainItemConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["InterventionMainItemRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InterventionMainItemRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["InterventionMainItemRelationship"] = ResolversParentTypes["InterventionMainItemRelationship"]
> = {
	LOT?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	REF?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["Treatment"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InterventionPatientConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["InterventionPatientConnection"] = ResolversParentTypes["InterventionPatientConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["InterventionPatientRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InterventionPatientRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["InterventionPatientRelationship"] = ResolversParentTypes["InterventionPatientRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["Patient"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InterventionReportStatusResponseResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["InterventionReportStatusResponse"] = ResolversParentTypes["InterventionReportStatusResponse"]
> = {
	message?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	responseStatus?: Resolver<Maybe<ResolversTypes["GQLResponseStatus"]>, ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InterventionReportStatusResponseAggregateSelectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["InterventionReportStatusResponseAggregateSelection"] = ResolversParentTypes["InterventionReportStatusResponseAggregateSelection"]
> = {
	count?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	message?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InterventionSubsequentInterventionConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["InterventionSubsequentInterventionConnection"] = ResolversParentTypes["InterventionSubsequentInterventionConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["InterventionSubsequentInterventionRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InterventionSubsequentInterventionRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["InterventionSubsequentInterventionRelationship"] = ResolversParentTypes["InterventionSubsequentInterventionRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["Intervention"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InterventionSupportingItemConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["InterventionSupportingItemConnection"] = ResolversParentTypes["InterventionSupportingItemConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["InterventionSupportingItemRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InterventionSupportingItemRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["InterventionSupportingItemRelationship"] = ResolversParentTypes["InterventionSupportingItemRelationship"]
> = {
	LOT?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	REF?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["Treatment"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InterventionTreatmentRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["InterventionTreatmentRelationship"] = ResolversParentTypes["InterventionTreatmentRelationship"]
> = {
	__resolveType: TypeResolveFn<"InterventionMainItemRelationship" | "InterventionSupportingItemRelationship", ParentType, ContextType>;
	LOT?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	REF?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
};

export type InvoiceRefundFinancialDataPointResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["InvoiceRefundFinancialDataPoint"] = ResolversParentTypes["InvoiceRefundFinancialDataPoint"]
> = {
	__resolveType: TypeResolveFn<"RefundInvoiceFinancialDataPointsRelationship", ParentType, ContextType>;
	id?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	status?: Resolver<Maybe<ResolversTypes["FinancialDataPointStatus"]>, ParentType, ContextType>;
};

export type ItemUsedDataPointResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["ItemUsedDataPoint"] = ResolversParentTypes["ItemUsedDataPoint"]
> = {
	PICount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	SICount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	item?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	patientPopulation?: Resolver<ResolversTypes["ReportItemsUsedFilter"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ItemUsedDataPointAggregateSelectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["ItemUsedDataPointAggregateSelection"] = ResolversParentTypes["ItemUsedDataPointAggregateSelection"]
> = {
	PICount?: Resolver<ResolversTypes["IntAggregateSelection"], ParentType, ContextType>;
	SICount?: Resolver<ResolversTypes["IntAggregateSelection"], ParentType, ContextType>;
	count?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	item?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LimitationResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["Limitation"] = ResolversParentTypes["Limitation"]
> = {
	Code?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	DescriptionDe?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	DescriptionEn?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	Niveau?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	Type?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	ValidFromDate?: Resolver<Maybe<ResolversTypes["Date"]>, ParentType, ContextType>;
	ValidThruDate?: Resolver<Maybe<ResolversTypes["Date"]>, ParentType, ContextType>;
	limitsPreparations?: Resolver<
		Array<ResolversTypes["Preparation"]>,
		ParentType,
		ContextType,
		RequireFields<LimitationLimitsPreparationsArgs, never>
	>;
	limitsPreparationsConnection?: Resolver<
		ResolversTypes["LimitationLimitsPreparationsConnection"],
		ParentType,
		ContextType,
		RequireFields<LimitationLimitsPreparationsConnectionArgs, never>
	>;
	limitsTreatment?: Resolver<
		Array<ResolversTypes["Treatment"]>,
		ParentType,
		ContextType,
		RequireFields<LimitationLimitsTreatmentArgs, never>
	>;
	limitsTreatmentConnection?: Resolver<
		ResolversTypes["LimitationLimitsTreatmentConnection"],
		ParentType,
		ContextType,
		RequireFields<LimitationLimitsTreatmentConnectionArgs, never>
	>;
	uuid?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LimitationAggregateSelectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["LimitationAggregateSelection"] = ResolversParentTypes["LimitationAggregateSelection"]
> = {
	Code?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	DescriptionDe?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	DescriptionEn?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	Niveau?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	Type?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	count?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	uuid?: Resolver<ResolversTypes["IDAggregateSelection"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LimitationLimitsPreparationsConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["LimitationLimitsPreparationsConnection"] = ResolversParentTypes["LimitationLimitsPreparationsConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["LimitationLimitsPreparationsRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LimitationLimitsPreparationsRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["LimitationLimitsPreparationsRelationship"] = ResolversParentTypes["LimitationLimitsPreparationsRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["Preparation"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LimitationLimitsTreatmentConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["LimitationLimitsTreatmentConnection"] = ResolversParentTypes["LimitationLimitsTreatmentConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["LimitationLimitsTreatmentRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LimitationLimitsTreatmentRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["LimitationLimitsTreatmentRelationship"] = ResolversParentTypes["LimitationLimitsTreatmentRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["Treatment"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MessageResolvers<ContextType = any, ParentType extends ResolversParentTypes["Message"] = ResolversParentTypes["Message"]> = {
	content?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	createdOn?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
	mentions?: Resolver<Maybe<Array<Maybe<ResolversTypes["User"]>>>, ParentType, ContextType, RequireFields<MessageMentionsArgs, never>>;
	mentionsConnection?: Resolver<
		ResolversTypes["MessageMentionsConnection"],
		ParentType,
		ContextType,
		RequireFields<MessageMentionsConnectionArgs, never>
	>;
	refund?: Resolver<ResolversTypes["Refund"], ParentType, ContextType, RequireFields<MessageRefundArgs, never>>;
	refundConnection?: Resolver<
		ResolversTypes["MessageRefundConnection"],
		ParentType,
		ContextType,
		RequireFields<MessageRefundConnectionArgs, never>
	>;
	sentBy?: Resolver<ResolversTypes["User"], ParentType, ContextType, RequireFields<MessageSentByArgs, never>>;
	sentByConnection?: Resolver<
		ResolversTypes["MessageSentByConnection"],
		ParentType,
		ContextType,
		RequireFields<MessageSentByConnectionArgs, never>
	>;
	tenantIds?: Resolver<Array<ResolversTypes["String"]>, ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MessageAggregateSelectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["MessageAggregateSelection"] = ResolversParentTypes["MessageAggregateSelection"]
> = {
	content?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	count?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	createdOn?: Resolver<ResolversTypes["FloatAggregateSelection"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MessageMentionsConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["MessageMentionsConnection"] = ResolversParentTypes["MessageMentionsConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["MessageMentionsRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MessageMentionsRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["MessageMentionsRelationship"] = ResolversParentTypes["MessageMentionsRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["User"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MessageRefundConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["MessageRefundConnection"] = ResolversParentTypes["MessageRefundConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["MessageRefundRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MessageRefundRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["MessageRefundRelationship"] = ResolversParentTypes["MessageRefundRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["Refund"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MessageSentByConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["MessageSentByConnection"] = ResolversParentTypes["MessageSentByConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["MessageSentByRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MessageSentByRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["MessageSentByRelationship"] = ResolversParentTypes["MessageSentByRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["User"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MicroContentResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["MicroContent"] = ResolversParentTypes["MicroContent"]
> = {
	amount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	type?: Resolver<ResolversTypes["MicroContentType"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MicroContentAggregateSelectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["MicroContentAggregateSelection"] = ResolversParentTypes["MicroContentAggregateSelection"]
> = {
	amount?: Resolver<ResolversTypes["IntAggregateSelection"], ParentType, ContextType>;
	count?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ModuleResolvers<ContextType = any, ParentType extends ResolversParentTypes["Module"] = ResolversParentTypes["Module"]> = {
	code?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	id?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	name?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ModuleAggregateSelectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["ModuleAggregateSelection"] = ResolversParentTypes["ModuleAggregateSelection"]
> = {
	code?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	count?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	id?: Resolver<ResolversTypes["IntAggregateSelection"], ParentType, ContextType>;
	name?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MutationResolvers<ContextType = any, ParentType extends ResolversParentTypes["Mutation"] = ResolversParentTypes["Mutation"]> = {
	AddAgreementDecision?: Resolver<
		Maybe<ResolversTypes["Int"]>,
		ParentType,
		ContextType,
		RequireFields<MutationAddAgreementDecisionArgs, "input">
	>;
	AddContinuousBenefit?: Resolver<
		Maybe<ResolversTypes["ContinuousBenefit"]>,
		ParentType,
		ContextType,
		RequireFields<MutationAddContinuousBenefitArgs, "request">
	>;
	AddCoverageRequest?: Resolver<
		Maybe<ResolversTypes["CoverageRequest"]>,
		ParentType,
		ContextType,
		RequireFields<MutationAddCoverageRequestArgs, "input">
	>;
	AddDiscontinuationNote?: Resolver<
		Maybe<ResolversTypes["DiscontinuationNote"]>,
		ParentType,
		ContextType,
		RequireFields<MutationAddDiscontinuationNoteArgs, "request">
	>;
	AddInitialResponse?: Resolver<
		Maybe<ResolversTypes["InitialResponse"]>,
		ParentType,
		ContextType,
		RequireFields<MutationAddInitialResponseArgs, "request">
	>;
	AddIntervention?: Resolver<
		Maybe<ResolversTypes["Intervention"]>,
		ParentType,
		ContextType,
		RequireFields<MutationAddInterventionArgs, never>
	>;
	AddModule?: Resolver<Maybe<ResolversTypes["Boolean"]>, ParentType, ContextType, RequireFields<MutationAddModuleArgs, "id">>;
	AddUserSubscribed?: Resolver<
		Maybe<ResolversTypes["Int"]>,
		ParentType,
		ContextType,
		RequireFields<MutationAddUserSubscribedArgs, "notificationId" | "userId">
	>;
	AddUserSubscribedNotifications?: Resolver<
		Maybe<Array<Maybe<ResolversTypes["Int"]>>>,
		ParentType,
		ContextType,
		RequireFields<MutationAddUserSubscribedNotificationsArgs, "userId">
	>;
	AssignInvoiceToUser?: Resolver<
		Maybe<ResolversTypes["ID"]>,
		ParentType,
		ContextType,
		RequireFields<MutationAssignInvoiceToUserArgs, never>
	>;
	CancelTermination?: Resolver<
		Maybe<ResolversTypes["Int"]>,
		ParentType,
		ContextType,
		RequireFields<MutationCancelTerminationArgs, "contractAddress">
	>;
	CreateInvoice?: Resolver<Maybe<ResolversTypes["ID"]>, ParentType, ContextType, RequireFields<MutationCreateInvoiceArgs, never>>;
	CreateRefundThreadMessage?: Resolver<
		Maybe<ResolversTypes["Message"]>,
		ParentType,
		ContextType,
		RequireFields<MutationCreateRefundThreadMessageArgs, never>
	>;
	DeleteCoverageRequest?: Resolver<
		Maybe<ResolversTypes["Int"]>,
		ParentType,
		ContextType,
		RequireFields<MutationDeleteCoverageRequestArgs, "id">
	>;
	DeleteDiscontinuationNote?: Resolver<
		Maybe<ResolversTypes["Int"]>,
		ParentType,
		ContextType,
		RequireFields<MutationDeleteDiscontinuationNoteArgs, "id">
	>;
	DeleteFlexEntity?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType, RequireFields<MutationDeleteFlexEntityArgs, "id">>;
	DeleteIntervention?: Resolver<
		Maybe<ResolversTypes["Int"]>,
		ParentType,
		ContextType,
		RequireFields<MutationDeleteInterventionArgs, "id" | "isPrimary">
	>;
	DeleteInvoice?: Resolver<Maybe<ResolversTypes["ID"]>, ParentType, ContextType, RequireFields<MutationDeleteInvoiceArgs, never>>;
	DeleteRefundThreadMessage?: Resolver<
		Maybe<ResolversTypes["Float"]>,
		ParentType,
		ContextType,
		RequireFields<MutationDeleteRefundThreadMessageArgs, never>
	>;
	ExecuteBaseAgreement?: Resolver<
		Maybe<ResolversTypes["Int"]>,
		ParentType,
		ContextType,
		RequireFields<MutationExecuteBaseAgreementArgs, "id">
	>;
	ExecuteStobContract?: Resolver<
		ResolversTypes["ContractStatus"],
		ParentType,
		ContextType,
		RequireFields<MutationExecuteStobContractArgs, "id">
	>;
	IssueInvoice?: Resolver<Maybe<ResolversTypes["ID"]>, ParentType, ContextType, RequireFields<MutationIssueInvoiceArgs, never>>;
	IssueInvoiceWithoutReview?: Resolver<
		Maybe<ResolversTypes["ID"]>,
		ParentType,
		ContextType,
		RequireFields<MutationIssueInvoiceWithoutReviewArgs, never>
	>;
	ProcessWorkflowParticipantDecision?: Resolver<
		Maybe<ResolversTypes["ContractStatus"]>,
		ParentType,
		ContextType,
		RequireFields<MutationProcessWorkflowParticipantDecisionArgs, "request">
	>;
	RecallToDraft?: Resolver<Maybe<ResolversTypes["ID"]>, ParentType, ContextType, RequireFields<MutationRecallToDraftArgs, never>>;
	RemoveModule?: Resolver<Maybe<ResolversTypes["Boolean"]>, ParentType, ContextType, RequireFields<MutationRemoveModuleArgs, "id">>;
	RemoveUserSubscribed?: Resolver<
		Maybe<ResolversTypes["Int"]>,
		ParentType,
		ContextType,
		RequireFields<MutationRemoveUserSubscribedArgs, "notificationId" | "userId">
	>;
	RemoveUserSubscribedNotifications?: Resolver<
		Maybe<Array<Maybe<ResolversTypes["Int"]>>>,
		ParentType,
		ContextType,
		RequireFields<MutationRemoveUserSubscribedNotificationsArgs, "userId">
	>;
	RenewCaobAgreements?: Resolver<
		Maybe<ResolversTypes["Int"]>,
		ParentType,
		ContextType,
		RequireFields<MutationRenewCaobAgreementsArgs, never>
	>;
	SaveFlexEntity?: Resolver<
		Maybe<ResolversTypes["FlexEntity"]>,
		ParentType,
		ContextType,
		RequireFields<MutationSaveFlexEntityArgs, "status" | "typeId">
	>;
	SaveReviewedInvoice?: Resolver<
		Maybe<ResolversTypes["ID"]>,
		ParentType,
		ContextType,
		RequireFields<MutationSaveReviewedInvoiceArgs, never>
	>;
	SendInvoiceForReview?: Resolver<
		Maybe<ResolversTypes["ID"]>,
		ParentType,
		ContextType,
		RequireFields<MutationSendInvoiceForReviewArgs, never>
	>;
	SetStepAmended?: Resolver<
		Maybe<ResolversTypes["Int"]>,
		ParentType,
		ContextType,
		RequireFields<MutationSetStepAmendedArgs, "contractAddress" | "part">
	>;
	StoreWorkflows?: Resolver<
		Maybe<ResolversTypes["Int"]>,
		ParentType,
		ContextType,
		RequireFields<MutationStoreWorkflowsArgs, "contractAddress" | "workflows">
	>;
	UndoDeleteCoverageRequest?: Resolver<
		Maybe<ResolversTypes["Int"]>,
		ParentType,
		ContextType,
		RequireFields<MutationUndoDeleteCoverageRequestArgs, "id">
	>;
	UpdateAgreementAssignee?: Resolver<
		Maybe<Array<Maybe<ResolversTypes["Int"]>>>,
		ParentType,
		ContextType,
		RequireFields<MutationUpdateAgreementAssigneeArgs, "agreementId" | "isAssignee" | "userId">
	>;
	UpdateAgreementUserRoles?: Resolver<
		Maybe<Array<Maybe<ResolversTypes["Int"]>>>,
		ParentType,
		ContextType,
		RequireFields<MutationUpdateAgreementUserRolesArgs, never>
	>;
	UpdateCaseAssignee?: Resolver<
		Maybe<ResolversTypes["Case"]>,
		ParentType,
		ContextType,
		RequireFields<MutationUpdateCaseAssigneeArgs, "req">
	>;
	UpdateContinuousBenefit?: Resolver<
		Maybe<ResolversTypes["ContinuousBenefit"]>,
		ParentType,
		ContextType,
		RequireFields<MutationUpdateContinuousBenefitArgs, "request">
	>;
	UpdateContractNotifications?: Resolver<
		Maybe<ResolversTypes["ID"]>,
		ParentType,
		ContextType,
		RequireFields<MutationUpdateContractNotificationsArgs, "request">
	>;
	UpdateCoverageRequest?: Resolver<
		Maybe<ResolversTypes["CoverageRequest"]>,
		ParentType,
		ContextType,
		RequireFields<MutationUpdateCoverageRequestArgs, "input">
	>;
	UpdateCurrentUserPersonalInfo?: Resolver<
		Maybe<ResolversTypes["UserPersonalInfo"]>,
		ParentType,
		ContextType,
		RequireFields<MutationUpdateCurrentUserPersonalInfoArgs, never>
	>;
	UpdateDefaultUserRole?: Resolver<
		Maybe<ResolversTypes["Boolean"]>,
		ParentType,
		ContextType,
		RequireFields<MutationUpdateDefaultUserRoleArgs, never>
	>;
	UpdateDiscontinuationNote?: Resolver<
		Maybe<ResolversTypes["DiscontinuationNote"]>,
		ParentType,
		ContextType,
		RequireFields<MutationUpdateDiscontinuationNoteArgs, "request">
	>;
	UpdateInitialResponse?: Resolver<
		Maybe<ResolversTypes["InitialResponse"]>,
		ParentType,
		ContextType,
		RequireFields<MutationUpdateInitialResponseArgs, "request">
	>;
	UpdateIntervention?: Resolver<
		Maybe<ResolversTypes["Intervention"]>,
		ParentType,
		ContextType,
		RequireFields<MutationUpdateInterventionArgs, never>
	>;
	UpdateInterventionReportStatus?: Resolver<
		Maybe<ResolversTypes["InterventionReportStatusResponse"]>,
		ParentType,
		ContextType,
		RequireFields<MutationUpdateInterventionReportStatusArgs, "input">
	>;
	UpdateScenarioInsightsUserContext?: Resolver<
		Maybe<ResolversTypes["Int"]>,
		ParentType,
		ContextType,
		RequireFields<MutationUpdateScenarioInsightsUserContextArgs, "agreementId">
	>;
	UpdateStobBasicInfo?: Resolver<
		Maybe<ResolversTypes["ID"]>,
		ParentType,
		ContextType,
		RequireFields<MutationUpdateStobBasicInfoArgs, "request">
	>;
	UpdateStobDataGuidance?: Resolver<
		Maybe<ResolversTypes["ID"]>,
		ParentType,
		ContextType,
		RequireFields<MutationUpdateStobDataGuidanceArgs, "id">
	>;
	UpdateStobEligibility?: Resolver<
		Maybe<ResolversTypes["ID"]>,
		ParentType,
		ContextType,
		RequireFields<MutationUpdateStobEligibilityArgs, "request">
	>;
	UpdateStobMeasures?: Resolver<
		Maybe<ResolversTypes["ID"]>,
		ParentType,
		ContextType,
		RequireFields<MutationUpdateStobMeasuresArgs, "request">
	>;
	UpdateStobPricing?: Resolver<
		Maybe<ResolversTypes["ID"]>,
		ParentType,
		ContextType,
		RequireFields<MutationUpdateStobPricingArgs, "request">
	>;
	UpdateUserContextFiltersAgreements?: Resolver<
		Maybe<ResolversTypes["Int"]>,
		ParentType,
		ContextType,
		RequireFields<MutationUpdateUserContextFiltersAgreementsArgs, never>
	>;
	UpdateUserContextFiltersCases?: Resolver<
		Maybe<ResolversTypes["Int"]>,
		ParentType,
		ContextType,
		RequireFields<MutationUpdateUserContextFiltersCasesArgs, never>
	>;
	UpdateUserContextFiltersDataForms?: Resolver<
		Maybe<ResolversTypes["Int"]>,
		ParentType,
		ContextType,
		RequireFields<MutationUpdateUserContextFiltersDataFormsArgs, never>
	>;
	UpdateUserContextFiltersDataRecords?: Resolver<
		Maybe<ResolversTypes["Int"]>,
		ParentType,
		ContextType,
		RequireFields<MutationUpdateUserContextFiltersDataRecordsArgs, never>
	>;
	UpdateUserContextFiltersDocuments?: Resolver<
		Maybe<ResolversTypes["Int"]>,
		ParentType,
		ContextType,
		RequireFields<MutationUpdateUserContextFiltersDocumentsArgs, never>
	>;
	UpdateUserContextFiltersRefunds?: Resolver<
		Maybe<ResolversTypes["Int"]>,
		ParentType,
		ContextType,
		RequireFields<MutationUpdateUserContextFiltersRefundsArgs, never>
	>;
	UpdateUserRole?: Resolver<Maybe<ResolversTypes["Boolean"]>, ParentType, ContextType, RequireFields<MutationUpdateUserRoleArgs, "id">>;
	UploadClaims?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType, RequireFields<MutationUploadClaimsArgs, never>>;
	UploadDeviceRecords?: Resolver<
		Maybe<ResolversTypes["Int"]>,
		ParentType,
		ContextType,
		RequireFields<MutationUploadDeviceRecordsArgs, never>
	>;
	createAdverseEventsOccurenceReports?: Resolver<
		ResolversTypes["CreateAdverseEventsOccurenceReportsMutationResponse"],
		ParentType,
		ContextType,
		RequireFields<MutationCreateAdverseEventsOccurenceReportsArgs, "input">
	>;
	createInitialResponseReviewReports?: Resolver<
		ResolversTypes["CreateInitialResponseReviewReportsMutationResponse"],
		ParentType,
		ContextType,
		RequireFields<MutationCreateInitialResponseReviewReportsArgs, "input">
	>;
	createReasonOfTreatmentDiscontinuationReports?: Resolver<
		ResolversTypes["CreateReasonOfTreatmentDiscontinuationReportsMutationResponse"],
		ParentType,
		ContextType,
		RequireFields<MutationCreateReasonOfTreatmentDiscontinuationReportsArgs, "input">
	>;
	createUsers?: Resolver<
		ResolversTypes["CreateUsersMutationResponse"],
		ParentType,
		ContextType,
		RequireFields<MutationCreateUsersArgs, "input">
	>;
	deleteAdverseEventsOccurenceReports?: Resolver<
		ResolversTypes["DeleteInfo"],
		ParentType,
		ContextType,
		RequireFields<MutationDeleteAdverseEventsOccurenceReportsArgs, never>
	>;
	deleteInitialResponseReviewReports?: Resolver<
		ResolversTypes["DeleteInfo"],
		ParentType,
		ContextType,
		RequireFields<MutationDeleteInitialResponseReviewReportsArgs, never>
	>;
	deleteReasonOfTreatmentDiscontinuationReports?: Resolver<
		ResolversTypes["DeleteInfo"],
		ParentType,
		ContextType,
		RequireFields<MutationDeleteReasonOfTreatmentDiscontinuationReportsArgs, never>
	>;
	deleteUsers?: Resolver<ResolversTypes["DeleteInfo"], ParentType, ContextType, RequireFields<MutationDeleteUsersArgs, never>>;
	updateAdverseEventsOccurenceReports?: Resolver<
		ResolversTypes["UpdateAdverseEventsOccurenceReportsMutationResponse"],
		ParentType,
		ContextType,
		RequireFields<MutationUpdateAdverseEventsOccurenceReportsArgs, never>
	>;
	updateInitialResponseReviewReports?: Resolver<
		ResolversTypes["UpdateInitialResponseReviewReportsMutationResponse"],
		ParentType,
		ContextType,
		RequireFields<MutationUpdateInitialResponseReviewReportsArgs, never>
	>;
	updateReasonOfTreatmentDiscontinuationReports?: Resolver<
		ResolversTypes["UpdateReasonOfTreatmentDiscontinuationReportsMutationResponse"],
		ParentType,
		ContextType,
		RequireFields<MutationUpdateReasonOfTreatmentDiscontinuationReportsArgs, never>
	>;
	updateUsers?: Resolver<
		ResolversTypes["UpdateUsersMutationResponse"],
		ParentType,
		ContextType,
		RequireFields<MutationUpdateUsersArgs, never>
	>;
};

export type NetRevenueByOrganizationResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["NetRevenueByOrganization"] = ResolversParentTypes["NetRevenueByOrganization"]
> = {
	name?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	netAmount?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NetRevenueByOrganizationAggregateSelectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["NetRevenueByOrganizationAggregateSelection"] = ResolversParentTypes["NetRevenueByOrganizationAggregateSelection"]
> = {
	count?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	name?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	netAmount?: Resolver<ResolversTypes["FloatAggregateSelection"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NotificationResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["Notification"] = ResolversParentTypes["Notification"]
> = {
	due?: Resolver<Array<ResolversTypes["User"]>, ParentType, ContextType, RequireFields<NotificationDueArgs, never>>;
	dueConnection?: Resolver<
		ResolversTypes["NotificationDueConnection"],
		ParentType,
		ContextType,
		RequireFields<NotificationDueConnectionArgs, never>
	>;
	id?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	name?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	notified?: Resolver<Array<ResolversTypes["User"]>, ParentType, ContextType, RequireFields<NotificationNotifiedArgs, never>>;
	notifiedConnection?: Resolver<
		ResolversTypes["NotificationNotifiedConnection"],
		ParentType,
		ContextType,
		RequireFields<NotificationNotifiedConnectionArgs, never>
	>;
	subscribed?: Resolver<Array<ResolversTypes["User"]>, ParentType, ContextType, RequireFields<NotificationSubscribedArgs, never>>;
	subscribedConnection?: Resolver<
		ResolversTypes["NotificationSubscribedConnection"],
		ParentType,
		ContextType,
		RequireFields<NotificationSubscribedConnectionArgs, never>
	>;
	type?: Resolver<ResolversTypes["NotificationType"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NotificationAggregateSelectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["NotificationAggregateSelection"] = ResolversParentTypes["NotificationAggregateSelection"]
> = {
	count?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	id?: Resolver<ResolversTypes["IntAggregateSelection"], ParentType, ContextType>;
	name?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NotificationDueConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["NotificationDueConnection"] = ResolversParentTypes["NotificationDueConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["NotificationDueRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NotificationDueRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["NotificationDueRelationship"] = ResolversParentTypes["NotificationDueRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	dueDate?: Resolver<ResolversTypes["Date"], ParentType, ContextType>;
	message?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["User"], ParentType, ContextType>;
	timeStamp?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NotificationNotifiedConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["NotificationNotifiedConnection"] = ResolversParentTypes["NotificationNotifiedConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["NotificationNotifiedRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NotificationNotifiedRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["NotificationNotifiedRelationship"] = ResolversParentTypes["NotificationNotifiedRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	data?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	emailSentDate?: Resolver<Maybe<ResolversTypes["Date"]>, ParentType, ContextType>;
	message?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["User"], ParentType, ContextType>;
	timeStamp?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NotificationSubscribedConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["NotificationSubscribedConnection"] = ResolversParentTypes["NotificationSubscribedConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["NotificationSubscribedRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NotificationSubscribedRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["NotificationSubscribedRelationship"] = ResolversParentTypes["NotificationSubscribedRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["User"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NotificationTriggerResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["NotificationTrigger"] = ResolversParentTypes["NotificationTrigger"]
> = {
	act?: Resolver<Maybe<ResolversTypes["NotificationTriggerAct"]>, ParentType, ContextType>;
	aspect?: Resolver<ResolversTypes["NotificationTriggerAspect"], ParentType, ContextType>;
	order?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	previouslyDispatchedOn?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	subject?: Resolver<ResolversTypes["NotificationTriggerSubject"], ParentType, ContextType>;
	value?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NotificationTriggerAggregateSelectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["NotificationTriggerAggregateSelection"] = ResolversParentTypes["NotificationTriggerAggregateSelection"]
> = {
	count?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	order?: Resolver<ResolversTypes["IntAggregateSelection"], ParentType, ContextType>;
	previouslyDispatchedOn?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	value?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrganizationResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["Organization"] = ResolversParentTypes["Organization"]
> = {
	IBAN?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	billingAddress?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	contactEmail?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	contactFirstName?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	contactLastName?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	contactOccupation?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	contactPhone?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	customTranslations?: Resolver<Array<Maybe<ResolversTypes["Translations"]>>, ParentType, ContextType>;
	domicile?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	eIN?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	fax?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
	legalName?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	logo?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	name?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	phone?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	tenantId?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	website?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrganizationAggregateSelectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["OrganizationAggregateSelection"] = ResolversParentTypes["OrganizationAggregateSelection"]
> = {
	IBAN?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	billingAddress?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	contactEmail?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	contactFirstName?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	contactLastName?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	contactOccupation?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	contactPhone?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	count?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	domicile?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	eIN?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	fax?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	id?: Resolver<ResolversTypes["IDAggregateSelection"], ParentType, ContextType>;
	legalName?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	logo?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	name?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	phone?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	tenantId?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	website?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OutcomebasedAgreementReportResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["OutcomebasedAgreementReport"] = ResolversParentTypes["OutcomebasedAgreementReport"]
> = {
	adverseEventsOccurenceData?: Resolver<Array<ResolversTypes["AdverseEventsOccurenceReport"]>, ParentType, ContextType>;
	discountAmount?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
	discountAmountDelta?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
	discountRatio?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
	discountRatioDelta?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
	discountsPerCase?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
	discountsPerCaseDiscontinued?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
	durationMonths?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
	durationMonthsDiscontinued?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
	financialSummaryRows?: Resolver<Array<ResolversTypes["FinancialSummaryRow"]>, ParentType, ContextType>;
	grossAmountPerCase?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
	grossAmountPerCaseDiscontinued?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
	initialResponseReviewData?: Resolver<Array<ResolversTypes["InitialResponseReviewReport"]>, ParentType, ContextType>;
	netAmountPerCase?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
	netAmountPerCaseDiscontinued?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
	patientReportDataPoints?: Resolver<Array<ResolversTypes["PatientReportDataPoint"]>, ParentType, ContextType>;
	patientsWithAE?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
	progressionFreePatients?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
	reasonOfTreatmentDiscontinuationData?: Resolver<
		Array<ResolversTypes["ReasonOfTreatmentDiscontinuationReport"]>,
		ParentType,
		ContextType
	>;
	totalPatients?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
	totalResponse?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
	treatmentDurationData?: Resolver<Array<ResolversTypes["CaseReportDataPoint"]>, ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OutcomebasedAgreementReportAggregateSelectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["OutcomebasedAgreementReportAggregateSelection"] = ResolversParentTypes["OutcomebasedAgreementReportAggregateSelection"]
> = {
	count?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	discountAmount?: Resolver<ResolversTypes["FloatAggregateSelection"], ParentType, ContextType>;
	discountAmountDelta?: Resolver<ResolversTypes["FloatAggregateSelection"], ParentType, ContextType>;
	discountRatio?: Resolver<ResolversTypes["FloatAggregateSelection"], ParentType, ContextType>;
	discountRatioDelta?: Resolver<ResolversTypes["FloatAggregateSelection"], ParentType, ContextType>;
	discountsPerCase?: Resolver<ResolversTypes["FloatAggregateSelection"], ParentType, ContextType>;
	discountsPerCaseDiscontinued?: Resolver<ResolversTypes["FloatAggregateSelection"], ParentType, ContextType>;
	durationMonths?: Resolver<ResolversTypes["IntAggregateSelection"], ParentType, ContextType>;
	durationMonthsDiscontinued?: Resolver<ResolversTypes["IntAggregateSelection"], ParentType, ContextType>;
	grossAmountPerCase?: Resolver<ResolversTypes["FloatAggregateSelection"], ParentType, ContextType>;
	grossAmountPerCaseDiscontinued?: Resolver<ResolversTypes["FloatAggregateSelection"], ParentType, ContextType>;
	netAmountPerCase?: Resolver<ResolversTypes["FloatAggregateSelection"], ParentType, ContextType>;
	netAmountPerCaseDiscontinued?: Resolver<ResolversTypes["FloatAggregateSelection"], ParentType, ContextType>;
	patientsWithAE?: Resolver<ResolversTypes["FloatAggregateSelection"], ParentType, ContextType>;
	progressionFreePatients?: Resolver<ResolversTypes["FloatAggregateSelection"], ParentType, ContextType>;
	totalPatients?: Resolver<ResolversTypes["IntAggregateSelection"], ParentType, ContextType>;
	totalResponse?: Resolver<ResolversTypes["IntAggregateSelection"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PiRecurrenceSiDataPointResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["PIRecurrenceSIDataPoint"] = ResolversParentTypes["PIRecurrenceSIDataPoint"]
> = {
	averagePIToRecurrence?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
	averageRecurrenceToSI?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
	isConditionMet?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PiRecurrenceSiDataPointAggregateSelectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["PIRecurrenceSIDataPointAggregateSelection"] = ResolversParentTypes["PIRecurrenceSIDataPointAggregateSelection"]
> = {
	averagePIToRecurrence?: Resolver<ResolversTypes["FloatAggregateSelection"], ParentType, ContextType>;
	averageRecurrenceToSI?: Resolver<ResolversTypes["FloatAggregateSelection"], ParentType, ContextType>;
	count?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PageInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes["PageInfo"] = ResolversParentTypes["PageInfo"]> = {
	endCursor?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	hasNextPage?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
	hasPreviousPage?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
	startCursor?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PartnerResolvers<ContextType = any, ParentType extends ResolversParentTypes["Partner"] = ResolversParentTypes["Partner"]> = {
	Description?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	PartnerType?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	Phone?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	Place?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	Street?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	ZipCode?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
	treatment?: Resolver<Maybe<ResolversTypes["Treatment"]>, ParentType, ContextType, RequireFields<PartnerTreatmentArgs, never>>;
	treatmentConnection?: Resolver<
		ResolversTypes["PartnerTreatmentConnection"],
		ParentType,
		ContextType,
		RequireFields<PartnerTreatmentConnectionArgs, never>
	>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PartnerAggregateSelectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["PartnerAggregateSelection"] = ResolversParentTypes["PartnerAggregateSelection"]
> = {
	Description?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	PartnerType?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	Phone?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	Place?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	Street?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	ZipCode?: Resolver<ResolversTypes["IntAggregateSelection"], ParentType, ContextType>;
	count?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PartnerTreatmentConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["PartnerTreatmentConnection"] = ResolversParentTypes["PartnerTreatmentConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["PartnerTreatmentRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PartnerTreatmentRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["PartnerTreatmentRelationship"] = ResolversParentTypes["PartnerTreatmentRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["Treatment"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PatientResolvers<ContextType = any, ParentType extends ResolversParentTypes["Patient"] = ResolversParentTypes["Patient"]> = {
	assignedFlexEntities?: Resolver<
		Array<ResolversTypes["FlexEntity"]>,
		ParentType,
		ContextType,
		RequireFields<PatientAssignedFlexEntitiesArgs, never>
	>;
	assignedFlexEntitiesConnection?: Resolver<
		ResolversTypes["PatientAssignedFlexEntitiesConnection"],
		ParentType,
		ContextType,
		RequireFields<PatientAssignedFlexEntitiesConnectionArgs, never>
	>;
	cases?: Resolver<Array<ResolversTypes["Case"]>, ParentType, ContextType, RequireFields<PatientCasesArgs, never>>;
	casesConnection?: Resolver<
		ResolversTypes["PatientCasesConnection"],
		ParentType,
		ContextType,
		RequireFields<PatientCasesConnectionArgs, never>
	>;
	claims?: Resolver<Array<ResolversTypes["Claim"]>, ParentType, ContextType, RequireFields<PatientClaimsArgs, never>>;
	claimsConnection?: Resolver<
		ResolversTypes["PatientClaimsConnection"],
		ParentType,
		ContextType,
		RequireFields<PatientClaimsConnectionArgs, never>
	>;
	coverageRequests?: Resolver<
		Array<ResolversTypes["CoverageRequest"]>,
		ParentType,
		ContextType,
		RequireFields<PatientCoverageRequestsArgs, never>
	>;
	coverageRequestsConnection?: Resolver<
		ResolversTypes["PatientCoverageRequestsConnection"],
		ParentType,
		ContextType,
		RequireFields<PatientCoverageRequestsConnectionArgs, never>
	>;
	id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
	initials?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	insuranceId?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	primaryIntervention?: Resolver<
		Maybe<ResolversTypes["Intervention"]>,
		ParentType,
		ContextType,
		RequireFields<PatientPrimaryInterventionArgs, never>
	>;
	primaryInterventionConnection?: Resolver<
		ResolversTypes["PatientPrimaryInterventionConnection"],
		ParentType,
		ContextType,
		RequireFields<PatientPrimaryInterventionConnectionArgs, never>
	>;
	sentClaim?: Resolver<Array<ResolversTypes["Claim"]>, ParentType, ContextType, RequireFields<PatientSentClaimArgs, never>>;
	sentClaimConnection?: Resolver<
		ResolversTypes["PatientSentClaimConnection"],
		ParentType,
		ContextType,
		RequireFields<PatientSentClaimConnectionArgs, never>
	>;
	tenantId?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	timeStamp?: Resolver<ResolversTypes["DateTime"], ParentType, ContextType>;
	yearOfBirth?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PatientAggregateSelectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["PatientAggregateSelection"] = ResolversParentTypes["PatientAggregateSelection"]
> = {
	count?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	id?: Resolver<ResolversTypes["IDAggregateSelection"], ParentType, ContextType>;
	initials?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	insuranceId?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	tenantId?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	timeStamp?: Resolver<ResolversTypes["DateTimeAggregateSelection"], ParentType, ContextType>;
	yearOfBirth?: Resolver<ResolversTypes["IntAggregateSelection"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PatientAssignedFlexEntitiesConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["PatientAssignedFlexEntitiesConnection"] = ResolversParentTypes["PatientAssignedFlexEntitiesConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["PatientAssignedFlexEntitiesRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PatientAssignedFlexEntitiesRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["PatientAssignedFlexEntitiesRelationship"] = ResolversParentTypes["PatientAssignedFlexEntitiesRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["FlexEntity"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PatientCasesConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["PatientCasesConnection"] = ResolversParentTypes["PatientCasesConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["PatientCasesRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PatientCasesRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["PatientCasesRelationship"] = ResolversParentTypes["PatientCasesRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["Case"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PatientClaimsConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["PatientClaimsConnection"] = ResolversParentTypes["PatientClaimsConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["PatientClaimsRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PatientClaimsRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["PatientClaimsRelationship"] = ResolversParentTypes["PatientClaimsRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["Claim"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PatientCountDataPointResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["PatientCountDataPoint"] = ResolversParentTypes["PatientCountDataPoint"]
> = {
	PIAndSIPatientCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	PIOnlyPatientCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	isConditionMet?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PatientCountDataPointAggregateSelectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["PatientCountDataPointAggregateSelection"] = ResolversParentTypes["PatientCountDataPointAggregateSelection"]
> = {
	PIAndSIPatientCount?: Resolver<ResolversTypes["IntAggregateSelection"], ParentType, ContextType>;
	PIOnlyPatientCount?: Resolver<ResolversTypes["IntAggregateSelection"], ParentType, ContextType>;
	count?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PatientCoverageRequestsConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["PatientCoverageRequestsConnection"] = ResolversParentTypes["PatientCoverageRequestsConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["PatientCoverageRequestsRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PatientCoverageRequestsRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["PatientCoverageRequestsRelationship"] = ResolversParentTypes["PatientCoverageRequestsRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["CoverageRequest"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PatientPrimaryInterventionConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["PatientPrimaryInterventionConnection"] = ResolversParentTypes["PatientPrimaryInterventionConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["PatientPrimaryInterventionRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PatientPrimaryInterventionRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["PatientPrimaryInterventionRelationship"] = ResolversParentTypes["PatientPrimaryInterventionRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["Intervention"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PatientReportDataPointResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["PatientReportDataPoint"] = ResolversParentTypes["PatientReportDataPoint"]
> = {
	date?: Resolver<ResolversTypes["Date"], ParentType, ContextType>;
	enrolledNumber?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PatientReportDataPointAggregateSelectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["PatientReportDataPointAggregateSelection"] = ResolversParentTypes["PatientReportDataPointAggregateSelection"]
> = {
	count?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	enrolledNumber?: Resolver<ResolversTypes["IntAggregateSelection"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PatientSentClaimConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["PatientSentClaimConnection"] = ResolversParentTypes["PatientSentClaimConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["PatientSentClaimRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PatientSentClaimRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["PatientSentClaimRelationship"] = ResolversParentTypes["PatientSentClaimRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	date?: Resolver<Maybe<ResolversTypes["DateTime"]>, ParentType, ContextType>;
	node?: Resolver<ResolversTypes["Claim"], ParentType, ContextType>;
	timeStamp?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PatientStatusDistributionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["PatientStatusDistribution"] = ResolversParentTypes["PatientStatusDistribution"]
> = {
	conditionsMissedCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	outcomeNotReachedCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	outcomeReachedCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	possibleToReachOutcomeCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PatientStatusDistributionAggregateSelectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["PatientStatusDistributionAggregateSelection"] = ResolversParentTypes["PatientStatusDistributionAggregateSelection"]
> = {
	conditionsMissedCount?: Resolver<ResolversTypes["IntAggregateSelection"], ParentType, ContextType>;
	count?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	outcomeNotReachedCount?: Resolver<ResolversTypes["IntAggregateSelection"], ParentType, ContextType>;
	outcomeReachedCount?: Resolver<ResolversTypes["IntAggregateSelection"], ParentType, ContextType>;
	possibleToReachOutcomeCount?: Resolver<ResolversTypes["IntAggregateSelection"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PatientsPerMonthDataPointResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["PatientsPerMonthDataPoint"] = ResolversParentTypes["PatientsPerMonthDataPoint"]
> = {
	month?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	patientCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PatientsPerMonthDataPointAggregateSelectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["PatientsPerMonthDataPointAggregateSelection"] = ResolversParentTypes["PatientsPerMonthDataPointAggregateSelection"]
> = {
	count?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	month?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	patientCount?: Resolver<ResolversTypes["IntAggregateSelection"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PreparationResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["Preparation"] = ResolversParentTypes["Preparation"]
> = {
	AtcCode?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	BrandName?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	DescriptionDe?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	GenericName?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	ReleaseDate?: Resolver<Maybe<ResolversTypes["Date"]>, ParentType, ContextType>;
	SubjectMatter?: Resolver<ResolversTypes["AgreementSubjectMatter"], ParentType, ContextType>;
	SwissmedicNo5?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	brand?: Resolver<ResolversTypes["Brand"], ParentType, ContextType, RequireFields<PreparationBrandArgs, never>>;
	brandConnection?: Resolver<
		ResolversTypes["PreparationBrandConnection"],
		ParentType,
		ContextType,
		RequireFields<PreparationBrandConnectionArgs, never>
	>;
	coverageRequest?: Resolver<
		Array<ResolversTypes["CoverageRequest"]>,
		ParentType,
		ContextType,
		RequireFields<PreparationCoverageRequestArgs, never>
	>;
	coverageRequestCombined?: Resolver<
		Array<ResolversTypes["CoverageRequest"]>,
		ParentType,
		ContextType,
		RequireFields<PreparationCoverageRequestCombinedArgs, never>
	>;
	coverageRequestCombinedConnection?: Resolver<
		ResolversTypes["PreparationCoverageRequestCombinedConnection"],
		ParentType,
		ContextType,
		RequireFields<PreparationCoverageRequestCombinedConnectionArgs, never>
	>;
	coverageRequestConnection?: Resolver<
		ResolversTypes["PreparationCoverageRequestConnection"],
		ParentType,
		ContextType,
		RequireFields<PreparationCoverageRequestConnectionArgs, never>
	>;
	hasLimitations?: Resolver<
		Array<ResolversTypes["Limitation"]>,
		ParentType,
		ContextType,
		RequireFields<PreparationHasLimitationsArgs, never>
	>;
	hasLimitationsConnection?: Resolver<
		ResolversTypes["PreparationHasLimitationsConnection"],
		ParentType,
		ContextType,
		RequireFields<PreparationHasLimitationsConnectionArgs, never>
	>;
	id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
	regulates?: Resolver<Array<ResolversTypes["Treatment"]>, ParentType, ContextType, RequireFields<PreparationRegulatesArgs, never>>;
	regulatesConnection?: Resolver<
		ResolversTypes["PreparationRegulatesConnection"],
		ParentType,
		ContextType,
		RequireFields<PreparationRegulatesConnectionArgs, never>
	>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PreparationAggregateSelectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["PreparationAggregateSelection"] = ResolversParentTypes["PreparationAggregateSelection"]
> = {
	AtcCode?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	BrandName?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	DescriptionDe?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	GenericName?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	SwissmedicNo5?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	count?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	id?: Resolver<ResolversTypes["IDAggregateSelection"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PreparationBrandConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["PreparationBrandConnection"] = ResolversParentTypes["PreparationBrandConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["PreparationBrandRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PreparationBrandRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["PreparationBrandRelationship"] = ResolversParentTypes["PreparationBrandRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["Brand"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PreparationCoverageRequestCombinedConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["PreparationCoverageRequestCombinedConnection"] = ResolversParentTypes["PreparationCoverageRequestCombinedConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["PreparationCoverageRequestCombinedRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PreparationCoverageRequestCombinedRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["PreparationCoverageRequestCombinedRelationship"] = ResolversParentTypes["PreparationCoverageRequestCombinedRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["CoverageRequest"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PreparationCoverageRequestConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["PreparationCoverageRequestConnection"] = ResolversParentTypes["PreparationCoverageRequestConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["PreparationCoverageRequestRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PreparationCoverageRequestRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["PreparationCoverageRequestRelationship"] = ResolversParentTypes["PreparationCoverageRequestRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["CoverageRequest"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PreparationHasLimitationsConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["PreparationHasLimitationsConnection"] = ResolversParentTypes["PreparationHasLimitationsConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["PreparationHasLimitationsRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PreparationHasLimitationsRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["PreparationHasLimitationsRelationship"] = ResolversParentTypes["PreparationHasLimitationsRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["Limitation"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PreparationRegulatesConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["PreparationRegulatesConnection"] = ResolversParentTypes["PreparationRegulatesConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["PreparationRegulatesRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PreparationRegulatesRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["PreparationRegulatesRelationship"] = ResolversParentTypes["PreparationRegulatesRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["Treatment"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PreparationStatusResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["PreparationStatus"] = ResolversParentTypes["PreparationStatus"]
> = {
	FlagApd?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	IntegrationDate?: Resolver<ResolversTypes["Date"], ParentType, ContextType>;
	StatusTypeCodeSl?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	StatusTypeDescriptionSl?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	ValidFromDate?: Resolver<ResolversTypes["Date"], ParentType, ContextType>;
	ValidThruDate?: Resolver<ResolversTypes["Date"], ParentType, ContextType>;
	preparation?: Resolver<
		Maybe<ResolversTypes["Preparation"]>,
		ParentType,
		ContextType,
		RequireFields<PreparationStatusPreparationArgs, never>
	>;
	preparationConnection?: Resolver<
		ResolversTypes["PreparationStatusPreparationConnection"],
		ParentType,
		ContextType,
		RequireFields<PreparationStatusPreparationConnectionArgs, never>
	>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PreparationStatusAggregateSelectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["PreparationStatusAggregateSelection"] = ResolversParentTypes["PreparationStatusAggregateSelection"]
> = {
	FlagApd?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	StatusTypeCodeSl?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	StatusTypeDescriptionSl?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	count?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PreparationStatusPreparationConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["PreparationStatusPreparationConnection"] = ResolversParentTypes["PreparationStatusPreparationConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["PreparationStatusPreparationRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PreparationStatusPreparationRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["PreparationStatusPreparationRelationship"] = ResolversParentTypes["PreparationStatusPreparationRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["Preparation"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PriceResolvers<ContextType = any, ParentType extends ResolversParentTypes["Price"] = ResolversParentTypes["Price"]> = {
	Price?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	PriceChangeTypeCode?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	PriceChangeTypeDescriptionDe?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	PriceTypeCode?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	PriceTypeDescriptionDe?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	ValidFromDate?: Resolver<Maybe<ResolversTypes["Date"]>, ParentType, ContextType>;
	treatment?: Resolver<Maybe<ResolversTypes["Treatment"]>, ParentType, ContextType, RequireFields<PriceTreatmentArgs, never>>;
	treatmentConnection?: Resolver<
		ResolversTypes["PriceTreatmentConnection"],
		ParentType,
		ContextType,
		RequireFields<PriceTreatmentConnectionArgs, never>
	>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PriceAggregateSelectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["PriceAggregateSelection"] = ResolversParentTypes["PriceAggregateSelection"]
> = {
	Price?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	PriceChangeTypeCode?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	PriceChangeTypeDescriptionDe?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	PriceTypeCode?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	PriceTypeDescriptionDe?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	count?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PriceTreatmentConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["PriceTreatmentConnection"] = ResolversParentTypes["PriceTreatmentConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["PriceTreatmentRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PriceTreatmentRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["PriceTreatmentRelationship"] = ResolversParentTypes["PriceTreatmentRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["Treatment"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProcessedDeviceRecordResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["ProcessedDeviceRecord"] = ResolversParentTypes["ProcessedDeviceRecord"]
> = {
	agreement?: Resolver<
		ResolversTypes["BaseAgreement"],
		ParentType,
		ContextType,
		RequireFields<ProcessedDeviceRecordAgreementArgs, never>
	>;
	agreementConnection?: Resolver<
		ResolversTypes["ProcessedDeviceRecordAgreementConnection"],
		ParentType,
		ContextType,
		RequireFields<ProcessedDeviceRecordAgreementConnectionArgs, never>
	>;
	deviceRecord?: Resolver<
		Maybe<ResolversTypes["DeviceRecord"]>,
		ParentType,
		ContextType,
		RequireFields<ProcessedDeviceRecordDeviceRecordArgs, never>
	>;
	deviceRecordConnection?: Resolver<
		ResolversTypes["ProcessedDeviceRecordDeviceRecordConnection"],
		ParentType,
		ContextType,
		RequireFields<ProcessedDeviceRecordDeviceRecordConnectionArgs, never>
	>;
	financialDataPoints?: Resolver<
		Array<ResolversTypes["DeviceFinancialDataPoint"]>,
		ParentType,
		ContextType,
		RequireFields<ProcessedDeviceRecordFinancialDataPointsArgs, never>
	>;
	financialDataPointsConnection?: Resolver<
		ResolversTypes["ProcessedDeviceRecordFinancialDataPointsConnection"],
		ParentType,
		ContextType,
		RequireFields<ProcessedDeviceRecordFinancialDataPointsConnectionArgs, never>
	>;
	lastProcessingDate?: Resolver<ResolversTypes["Date"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProcessedDeviceRecordAggregateSelectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["ProcessedDeviceRecordAggregateSelection"] = ResolversParentTypes["ProcessedDeviceRecordAggregateSelection"]
> = {
	count?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProcessedDeviceRecordAgreementConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["ProcessedDeviceRecordAgreementConnection"] = ResolversParentTypes["ProcessedDeviceRecordAgreementConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["ProcessedDeviceRecordAgreementRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProcessedDeviceRecordAgreementRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["ProcessedDeviceRecordAgreementRelationship"] = ResolversParentTypes["ProcessedDeviceRecordAgreementRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["BaseAgreement"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProcessedDeviceRecordDeviceRecordConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["ProcessedDeviceRecordDeviceRecordConnection"] = ResolversParentTypes["ProcessedDeviceRecordDeviceRecordConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["ProcessedDeviceRecordDeviceRecordRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProcessedDeviceRecordDeviceRecordRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["ProcessedDeviceRecordDeviceRecordRelationship"] = ResolversParentTypes["ProcessedDeviceRecordDeviceRecordRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["DeviceRecord"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProcessedDeviceRecordFinancialDataPointsConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["ProcessedDeviceRecordFinancialDataPointsConnection"] = ResolversParentTypes["ProcessedDeviceRecordFinancialDataPointsConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["ProcessedDeviceRecordFinancialDataPointsRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProcessedDeviceRecordFinancialDataPointsRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["ProcessedDeviceRecordFinancialDataPointsRelationship"] = ResolversParentTypes["ProcessedDeviceRecordFinancialDataPointsRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["DeviceFinancialDataPoint"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PublicPriceResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["PublicPrice"] = ResolversParentTypes["PublicPrice"]
> = {
	Price?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	ValidFromDate?: Resolver<Maybe<ResolversTypes["Date"]>, ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PublicPriceAggregateSelectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["PublicPriceAggregateSelection"] = ResolversParentTypes["PublicPriceAggregateSelection"]
> = {
	Price?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	count?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type QueryResolvers<ContextType = any, ParentType extends ResolversParentTypes["Query"] = ResolversParentTypes["Query"]> = {
	CheckCB?: Resolver<Array<ResolversTypes["Organization"]>, ParentType, ContextType, RequireFields<QueryCheckCbArgs, "id">>;
	CheckIR?: Resolver<Array<ResolversTypes["Organization"]>, ParentType, ContextType, RequireFields<QueryCheckIrArgs, "id">>;
	CurrentOrganization?: Resolver<ResolversTypes["Organization"], ParentType, ContextType>;
	GetAgreementIdFromInvoiceId?: Resolver<
		Maybe<ResolversTypes["ID"]>,
		ParentType,
		ContextType,
		RequireFields<QueryGetAgreementIdFromInvoiceIdArgs, "invoiceId">
	>;
	GetAgreementProcessedDeviceRecords?: Resolver<
		Maybe<Array<Maybe<ResolversTypes["ProcessedDeviceRecord"]>>>,
		ParentType,
		ContextType,
		RequireFields<QueryGetAgreementProcessedDeviceRecordsArgs, "agreementId" | "endDate" | "startDate">
	>;
	GetAgreementReportData?: Resolver<
		ResolversTypes["AgreementReport"],
		ParentType,
		ContextType,
		RequireFields<QueryGetAgreementReportDataArgs, "id">
	>;
	GetAgreementsCount?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
	GetAgreementsForSelectedUser?: Resolver<
		Array<ResolversTypes["AgreementSpecificRole"]>,
		ParentType,
		ContextType,
		RequireFields<QueryGetAgreementsForSelectedUserArgs, "id">
	>;
	GetAllBaseAgreementVersions?: Resolver<
		Maybe<Array<ResolversTypes["BaseAgreement"]>>,
		ParentType,
		ContextType,
		RequireFields<QueryGetAllBaseAgreementVersionsArgs, "id">
	>;
	GetAllDataPointsByDate?: Resolver<
		Maybe<Array<ResolversTypes["FinancialDataPoint"]>>,
		ParentType,
		ContextType,
		RequireFields<QueryGetAllDataPointsByDateArgs, "endDate" | "id" | "startDate">
	>;
	GetAllDataPointsByPrescriptionDate?: Resolver<
		Maybe<Array<ResolversTypes["FinancialDataPoint"]>>,
		ParentType,
		ContextType,
		RequireFields<QueryGetAllDataPointsByPrescriptionDateArgs, "endDate" | "id" | "startDate">
	>;
	GetAllUsersFromOrganization?: Resolver<Array<ResolversTypes["UserOrganizationInfo"]>, ParentType, ContextType>;
	GetAssignee?: Resolver<
		Maybe<ResolversTypes["User"]>,
		ParentType,
		ContextType,
		RequireFields<QueryGetAssigneeArgs, "invoiceId" | "tenantId">
	>;
	GetAvailableCaseAssignees?: Resolver<
		Maybe<Array<Maybe<ResolversTypes["User"]>>>,
		ParentType,
		ContextType,
		RequireFields<QueryGetAvailableCaseAssigneesArgs, "caseId">
	>;
	GetCAOBAgreementReportData?: Resolver<
		ResolversTypes["CAOBAgreementReport"],
		ParentType,
		ContextType,
		RequireFields<QueryGetCaobAgreementReportDataArgs, "id">
	>;
	GetCBAdverseEventData?: Resolver<
		Maybe<ResolversTypes["AdverseEventReport"]>,
		ParentType,
		ContextType,
		RequireFields<QueryGetCbAdverseEventDataArgs, "id">
	>;
	GetCaseCount?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
	GetClaims?: Resolver<Maybe<Array<Maybe<ResolversTypes["Claim"]>>>, ParentType, ContextType>;
	GetDefaultAgreementRoles?: Resolver<
		Array<ResolversTypes["AgreementTag"]>,
		ParentType,
		ContextType,
		RequireFields<QueryGetDefaultAgreementRolesArgs, "tags">
	>;
	GetDeviceRecords?: Resolver<Maybe<Array<Maybe<ResolversTypes["DeviceRecord"]>>>, ParentType, ContextType>;
	GetDocumentCount?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
	GetDuplicateClaims?: Resolver<
		Maybe<Array<Maybe<ResolversTypes["Record"]>>>,
		ParentType,
		ContextType,
		RequireFields<QueryGetDuplicateClaimsArgs, never>
	>;
	GetDuplicateDeviceRecords?: Resolver<
		Maybe<Array<Maybe<ResolversTypes["DeviceRecord"]>>>,
		ParentType,
		ContextType,
		RequireFields<QueryGetDuplicateDeviceRecordsArgs, never>
	>;
	GetFlexEntitiesCount?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
	GetFormsCount?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
	GetIRAdverseEventData?: Resolver<
		Maybe<ResolversTypes["AdverseEventReport"]>,
		ParentType,
		ContextType,
		RequireFields<QueryGetIrAdverseEventDataArgs, "id">
	>;
	GetOrganizationAgreementTags?: Resolver<Array<ResolversTypes["String"]>, ParentType, ContextType>;
	GetOutcomeBasedAgreementReportData?: Resolver<
		ResolversTypes["OutcomebasedAgreementReport"],
		ParentType,
		ContextType,
		RequireFields<QueryGetOutcomeBasedAgreementReportDataArgs, "id">
	>;
	GetPotentialCounterparties?: Resolver<Array<ResolversTypes["Organization"]>, ParentType, ContextType>;
	GetRecordsCount?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
	GetRefundCount?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
	GetRefundXlsInvoice?: Resolver<
		Maybe<Array<Maybe<ResolversTypes["Document"]>>>,
		ParentType,
		ContextType,
		RequireFields<QueryGetRefundXlsInvoiceArgs, "invoiceId">
	>;
	GetReportingSummary?: Resolver<
		Maybe<ResolversTypes["ReportingSummary"]>,
		ParentType,
		ContextType,
		RequireFields<QueryGetReportingSummaryArgs, never>
	>;
	GetTranslations?: Resolver<ResolversTypes["TranslationsResult"], ParentType, ContextType>;
	GetUnknownPreparationIds?: Resolver<
		Maybe<Array<Maybe<ResolversTypes["String"]>>>,
		ParentType,
		ContextType,
		RequireFields<QueryGetUnknownPreparationIdsArgs, never>
	>;
	GetUserContextFiltersAgreements?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	GetUserContextFiltersCases?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	GetUserContextFiltersDataForms?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	GetUserFiltersDataSimulations?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	GetUserContextFiltersDataRecords?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	GetUserContextFiltersDocuments?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	GetUserContextFiltersRefunds?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	GetUserRoleAndDataModule?: Resolver<
		ResolversTypes["UserOrgSettingsData"],
		ParentType,
		ContextType,
		RequireFields<QueryGetUserRoleAndDataModuleArgs, never>
	>;
	GetUsersToMentionOnMessage?: Resolver<
		Maybe<Array<Maybe<ResolversTypes["User"]>>>,
		ParentType,
		ContextType,
		RequireFields<QueryGetUsersToMentionOnMessageArgs, never>
	>;
	GetWorkflows?: Resolver<
		Maybe<Array<ResolversTypes["ContractWorkflow"]>>,
		ParentType,
		ContextType,
		RequireFields<QueryGetWorkflowsArgs, "contractId">
	>;
	InvoiceCounterPartiesUsers?: Resolver<
		Maybe<Array<Maybe<ResolversTypes["User"]>>>,
		ParentType,
		ContextType,
		RequireFields<QueryInvoiceCounterPartiesUsersArgs, never>
	>;
	OrganizationFromTenantId?: Resolver<
		ResolversTypes["Organization"],
		ParentType,
		ContextType,
		RequireFields<QueryOrganizationFromTenantIdArgs, never>
	>;
	adverseEventCounterparties?: Resolver<
		Array<ResolversTypes["AdverseEventCounterparties"]>,
		ParentType,
		ContextType,
		RequireFields<QueryAdverseEventCounterpartiesArgs, never>
	>;
	adverseEventCounterpartiesAggregate?: Resolver<
		ResolversTypes["AdverseEventCounterpartiesAggregateSelection"],
		ParentType,
		ContextType,
		RequireFields<QueryAdverseEventCounterpartiesAggregateArgs, never>
	>;
	adverseEventCounterpartiesCount?: Resolver<
		ResolversTypes["Int"],
		ParentType,
		ContextType,
		RequireFields<QueryAdverseEventCounterpartiesCountArgs, never>
	>;
	adverseEventReports?: Resolver<
		Array<ResolversTypes["AdverseEventReport"]>,
		ParentType,
		ContextType,
		RequireFields<QueryAdverseEventReportsArgs, never>
	>;
	adverseEventReportsAggregate?: Resolver<
		ResolversTypes["AdverseEventReportAggregateSelection"],
		ParentType,
		ContextType,
		RequireFields<QueryAdverseEventReportsAggregateArgs, never>
	>;
	adverseEventReportsCount?: Resolver<
		ResolversTypes["Int"],
		ParentType,
		ContextType,
		RequireFields<QueryAdverseEventReportsCountArgs, never>
	>;
	adverseEvents?: Resolver<Array<ResolversTypes["AdverseEvent"]>, ParentType, ContextType, RequireFields<QueryAdverseEventsArgs, never>>;
	adverseEventsAggregate?: Resolver<
		ResolversTypes["AdverseEventAggregateSelection"],
		ParentType,
		ContextType,
		RequireFields<QueryAdverseEventsAggregateArgs, never>
	>;
	adverseEventsCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType, RequireFields<QueryAdverseEventsCountArgs, never>>;
	adverseEventsOccurenceReports?: Resolver<
		Array<ResolversTypes["AdverseEventsOccurenceReport"]>,
		ParentType,
		ContextType,
		RequireFields<QueryAdverseEventsOccurenceReportsArgs, never>
	>;
	adverseEventsOccurenceReportsAggregate?: Resolver<
		ResolversTypes["AdverseEventsOccurenceReportAggregateSelection"],
		ParentType,
		ContextType,
		RequireFields<QueryAdverseEventsOccurenceReportsAggregateArgs, never>
	>;
	adverseEventsOccurenceReportsCount?: Resolver<
		ResolversTypes["Int"],
		ParentType,
		ContextType,
		RequireFields<QueryAdverseEventsOccurenceReportsCountArgs, never>
	>;
	agreementDecisions?: Resolver<
		Array<ResolversTypes["AgreementDecision"]>,
		ParentType,
		ContextType,
		RequireFields<QueryAgreementDecisionsArgs, never>
	>;
	agreementDecisionsAggregate?: Resolver<
		ResolversTypes["AgreementDecisionAggregateSelection"],
		ParentType,
		ContextType,
		RequireFields<QueryAgreementDecisionsAggregateArgs, never>
	>;
	agreementDecisionsCount?: Resolver<
		ResolversTypes["Int"],
		ParentType,
		ContextType,
		RequireFields<QueryAgreementDecisionsCountArgs, never>
	>;
	agreementReports?: Resolver<
		Array<ResolversTypes["AgreementReport"]>,
		ParentType,
		ContextType,
		RequireFields<QueryAgreementReportsArgs, never>
	>;
	agreementReportsAggregate?: Resolver<
		ResolversTypes["AgreementReportAggregateSelection"],
		ParentType,
		ContextType,
		RequireFields<QueryAgreementReportsAggregateArgs, never>
	>;
	agreementReportsCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType, RequireFields<QueryAgreementReportsCountArgs, never>>;
	agreementSpecificRoles?: Resolver<
		Array<ResolversTypes["AgreementSpecificRole"]>,
		ParentType,
		ContextType,
		RequireFields<QueryAgreementSpecificRolesArgs, never>
	>;
	agreementSpecificRolesAggregate?: Resolver<
		ResolversTypes["AgreementSpecificRoleAggregateSelection"],
		ParentType,
		ContextType,
		RequireFields<QueryAgreementSpecificRolesAggregateArgs, never>
	>;
	agreementSpecificRolesCount?: Resolver<
		ResolversTypes["Int"],
		ParentType,
		ContextType,
		RequireFields<QueryAgreementSpecificRolesCountArgs, never>
	>;
	agreementStatusTransitions?: Resolver<
		Array<ResolversTypes["AgreementStatusTransition"]>,
		ParentType,
		ContextType,
		RequireFields<QueryAgreementStatusTransitionsArgs, never>
	>;
	agreementStatusTransitionsAggregate?: Resolver<
		ResolversTypes["AgreementStatusTransitionAggregateSelection"],
		ParentType,
		ContextType,
		RequireFields<QueryAgreementStatusTransitionsAggregateArgs, never>
	>;
	agreementStatusTransitionsCount?: Resolver<
		ResolversTypes["Int"],
		ParentType,
		ContextType,
		RequireFields<QueryAgreementStatusTransitionsCountArgs, never>
	>;
	agreementTags?: Resolver<Array<ResolversTypes["AgreementTag"]>, ParentType, ContextType, RequireFields<QueryAgreementTagsArgs, never>>;
	agreementTagsAggregate?: Resolver<
		ResolversTypes["AgreementTagAggregateSelection"],
		ParentType,
		ContextType,
		RequireFields<QueryAgreementTagsAggregateArgs, never>
	>;
	agreementTagsCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType, RequireFields<QueryAgreementTagsCountArgs, never>>;
	agreements?: Resolver<Array<ResolversTypes["Agreement"]>, ParentType, ContextType, RequireFields<QueryAgreementsArgs, never>>;
	agreementsAggregate?: Resolver<
		ResolversTypes["AgreementAggregateSelection"],
		ParentType,
		ContextType,
		RequireFields<QueryAgreementsAggregateArgs, never>
	>;
	agreementsCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType, RequireFields<QueryAgreementsCountArgs, never>>;
	averageLaPressureAndLaVolumeRows?: Resolver<
		Array<ResolversTypes["AverageLAPressureAndLAVolumeRow"]>,
		ParentType,
		ContextType,
		RequireFields<QueryAverageLaPressureAndLaVolumeRowsArgs, never>
	>;
	averageLaPressureAndLaVolumeRowsAggregate?: Resolver<
		ResolversTypes["AverageLAPressureAndLAVolumeRowAggregateSelection"],
		ParentType,
		ContextType,
		RequireFields<QueryAverageLaPressureAndLaVolumeRowsAggregateArgs, never>
	>;
	averageLaPressureAndLaVolumeRowsCount?: Resolver<
		ResolversTypes["Int"],
		ParentType,
		ContextType,
		RequireFields<QueryAverageLaPressureAndLaVolumeRowsCountArgs, never>
	>;
	baseAgreements?: Resolver<
		Array<ResolversTypes["BaseAgreement"]>,
		ParentType,
		ContextType,
		RequireFields<QueryBaseAgreementsArgs, never>
	>;
	baseAgreementsAggregate?: Resolver<
		ResolversTypes["BaseAgreementAggregateSelection"],
		ParentType,
		ContextType,
		RequireFields<QueryBaseAgreementsAggregateArgs, never>
	>;
	baseAgreementsCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType, RequireFields<QueryBaseAgreementsCountArgs, never>>;
	brands?: Resolver<Array<ResolversTypes["Brand"]>, ParentType, ContextType, RequireFields<QueryBrandsArgs, never>>;
	brandsAggregate?: Resolver<
		ResolversTypes["BrandAggregateSelection"],
		ParentType,
		ContextType,
		RequireFields<QueryBrandsAggregateArgs, never>
	>;
	brandsCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType, RequireFields<QueryBrandsCountArgs, never>>;
	caobAgreementReports?: Resolver<
		Array<ResolversTypes["CAOBAgreementReport"]>,
		ParentType,
		ContextType,
		RequireFields<QueryCaobAgreementReportsArgs, never>
	>;
	caobAgreementReportsAggregate?: Resolver<
		ResolversTypes["CAOBAgreementReportAggregateSelection"],
		ParentType,
		ContextType,
		RequireFields<QueryCaobAgreementReportsAggregateArgs, never>
	>;
	caobAgreementReportsCount?: Resolver<
		ResolversTypes["Int"],
		ParentType,
		ContextType,
		RequireFields<QueryCaobAgreementReportsCountArgs, never>
	>;
	caobRefundSummaryRows?: Resolver<
		Array<ResolversTypes["CAOBRefundSummaryRow"]>,
		ParentType,
		ContextType,
		RequireFields<QueryCaobRefundSummaryRowsArgs, never>
	>;
	caobRefundSummaryRowsAggregate?: Resolver<
		ResolversTypes["CAOBRefundSummaryRowAggregateSelection"],
		ParentType,
		ContextType,
		RequireFields<QueryCaobRefundSummaryRowsAggregateArgs, never>
	>;
	caobRefundSummaryRowsCount?: Resolver<
		ResolversTypes["Int"],
		ParentType,
		ContextType,
		RequireFields<QueryCaobRefundSummaryRowsCountArgs, never>
	>;
	caseReportDataPoints?: Resolver<
		Array<ResolversTypes["CaseReportDataPoint"]>,
		ParentType,
		ContextType,
		RequireFields<QueryCaseReportDataPointsArgs, never>
	>;
	caseReportDataPointsAggregate?: Resolver<
		ResolversTypes["CaseReportDataPointAggregateSelection"],
		ParentType,
		ContextType,
		RequireFields<QueryCaseReportDataPointsAggregateArgs, never>
	>;
	caseReportDataPointsCount?: Resolver<
		ResolversTypes["Int"],
		ParentType,
		ContextType,
		RequireFields<QueryCaseReportDataPointsCountArgs, never>
	>;
	cases?: Resolver<Array<ResolversTypes["Case"]>, ParentType, ContextType, RequireFields<QueryCasesArgs, never>>;
	casesAggregate?: Resolver<
		ResolversTypes["CaseAggregateSelection"],
		ParentType,
		ContextType,
		RequireFields<QueryCasesAggregateArgs, never>
	>;
	casesCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType, RequireFields<QueryCasesCountArgs, never>>;
	claims?: Resolver<Array<ResolversTypes["Claim"]>, ParentType, ContextType, RequireFields<QueryClaimsArgs, never>>;
	claimsAggregate?: Resolver<
		ResolversTypes["ClaimAggregateSelection"],
		ParentType,
		ContextType,
		RequireFields<QueryClaimsAggregateArgs, never>
	>;
	claimsCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType, RequireFields<QueryClaimsCountArgs, never>>;
	continuousBenefits?: Resolver<
		Array<ResolversTypes["ContinuousBenefit"]>,
		ParentType,
		ContextType,
		RequireFields<QueryContinuousBenefitsArgs, never>
	>;
	continuousBenefitsAggregate?: Resolver<
		ResolversTypes["ContinuousBenefitAggregateSelection"],
		ParentType,
		ContextType,
		RequireFields<QueryContinuousBenefitsAggregateArgs, never>
	>;
	continuousBenefitsCount?: Resolver<
		ResolversTypes["Int"],
		ParentType,
		ContextType,
		RequireFields<QueryContinuousBenefitsCountArgs, never>
	>;
	contractNotifications?: Resolver<
		Array<ResolversTypes["ContractNotification"]>,
		ParentType,
		ContextType,
		RequireFields<QueryContractNotificationsArgs, never>
	>;
	contractNotificationsAggregate?: Resolver<
		ResolversTypes["ContractNotificationAggregateSelection"],
		ParentType,
		ContextType,
		RequireFields<QueryContractNotificationsAggregateArgs, never>
	>;
	contractNotificationsCount?: Resolver<
		ResolversTypes["Int"],
		ParentType,
		ContextType,
		RequireFields<QueryContractNotificationsCountArgs, never>
	>;
	contractWorkflowSteps?: Resolver<
		Array<ResolversTypes["ContractWorkflowStep"]>,
		ParentType,
		ContextType,
		RequireFields<QueryContractWorkflowStepsArgs, never>
	>;
	contractWorkflowStepsAggregate?: Resolver<
		ResolversTypes["ContractWorkflowStepAggregateSelection"],
		ParentType,
		ContextType,
		RequireFields<QueryContractWorkflowStepsAggregateArgs, never>
	>;
	contractWorkflowStepsCount?: Resolver<
		ResolversTypes["Int"],
		ParentType,
		ContextType,
		RequireFields<QueryContractWorkflowStepsCountArgs, never>
	>;
	contractWorkflows?: Resolver<
		Array<ResolversTypes["ContractWorkflow"]>,
		ParentType,
		ContextType,
		RequireFields<QueryContractWorkflowsArgs, never>
	>;
	contractWorkflowsAggregate?: Resolver<
		ResolversTypes["ContractWorkflowAggregateSelection"],
		ParentType,
		ContextType,
		RequireFields<QueryContractWorkflowsAggregateArgs, never>
	>;
	contractWorkflowsCount?: Resolver<
		ResolversTypes["Int"],
		ParentType,
		ContextType,
		RequireFields<QueryContractWorkflowsCountArgs, never>
	>;
	coverageRequests?: Resolver<
		Array<ResolversTypes["CoverageRequest"]>,
		ParentType,
		ContextType,
		RequireFields<QueryCoverageRequestsArgs, never>
	>;
	coverageRequestsAggregate?: Resolver<
		ResolversTypes["CoverageRequestAggregateSelection"],
		ParentType,
		ContextType,
		RequireFields<QueryCoverageRequestsAggregateArgs, never>
	>;
	coverageRequestsCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType, RequireFields<QueryCoverageRequestsCountArgs, never>>;
	currencies?: Resolver<Array<ResolversTypes["Currency"]>, ParentType, ContextType, RequireFields<QueryCurrenciesArgs, never>>;
	currenciesAggregate?: Resolver<
		ResolversTypes["CurrencyAggregateSelection"],
		ParentType,
		ContextType,
		RequireFields<QueryCurrenciesAggregateArgs, never>
	>;
	currenciesCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType, RequireFields<QueryCurrenciesCountArgs, never>>;
	dataContainers?: Resolver<
		Array<ResolversTypes["DataContainer"]>,
		ParentType,
		ContextType,
		RequireFields<QueryDataContainersArgs, never>
	>;
	dataContainersAggregate?: Resolver<
		ResolversTypes["DataContainerAggregateSelection"],
		ParentType,
		ContextType,
		RequireFields<QueryDataContainersAggregateArgs, never>
	>;
	dataContainersCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType, RequireFields<QueryDataContainersCountArgs, never>>;
	dataSources?: Resolver<Array<ResolversTypes["DataSource"]>, ParentType, ContextType, RequireFields<QueryDataSourcesArgs, never>>;
	dataSourcesAggregate?: Resolver<
		ResolversTypes["DataSourceAggregateSelection"],
		ParentType,
		ContextType,
		RequireFields<QueryDataSourcesAggregateArgs, never>
	>;
	dataSourcesCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType, RequireFields<QueryDataSourcesCountArgs, never>>;
	deviceAlternatives?: Resolver<
		Array<ResolversTypes["DeviceAlternative"]>,
		ParentType,
		ContextType,
		RequireFields<QueryDeviceAlternativesArgs, never>
	>;
	deviceAlternativesAggregate?: Resolver<
		ResolversTypes["DeviceAlternativeAggregateSelection"],
		ParentType,
		ContextType,
		RequireFields<QueryDeviceAlternativesAggregateArgs, never>
	>;
	deviceAlternativesCount?: Resolver<
		ResolversTypes["Int"],
		ParentType,
		ContextType,
		RequireFields<QueryDeviceAlternativesCountArgs, never>
	>;
	deviceFinancialDataPoints?: Resolver<
		Array<ResolversTypes["DeviceFinancialDataPoint"]>,
		ParentType,
		ContextType,
		RequireFields<QueryDeviceFinancialDataPointsArgs, never>
	>;
	deviceFinancialDataPointsAggregate?: Resolver<
		ResolversTypes["DeviceFinancialDataPointAggregateSelection"],
		ParentType,
		ContextType,
		RequireFields<QueryDeviceFinancialDataPointsAggregateArgs, never>
	>;
	deviceFinancialDataPointsCount?: Resolver<
		ResolversTypes["Int"],
		ParentType,
		ContextType,
		RequireFields<QueryDeviceFinancialDataPointsCountArgs, never>
	>;
	deviceKits?: Resolver<Array<ResolversTypes["DeviceKit"]>, ParentType, ContextType, RequireFields<QueryDeviceKitsArgs, never>>;
	deviceKitsAggregate?: Resolver<
		ResolversTypes["DeviceKitAggregateSelection"],
		ParentType,
		ContextType,
		RequireFields<QueryDeviceKitsAggregateArgs, never>
	>;
	deviceKitsCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType, RequireFields<QueryDeviceKitsCountArgs, never>>;
	deviceProductCategories?: Resolver<
		Array<ResolversTypes["DeviceProductCategory"]>,
		ParentType,
		ContextType,
		RequireFields<QueryDeviceProductCategoriesArgs, never>
	>;
	deviceProductCategoriesAggregate?: Resolver<
		ResolversTypes["DeviceProductCategoryAggregateSelection"],
		ParentType,
		ContextType,
		RequireFields<QueryDeviceProductCategoriesAggregateArgs, never>
	>;
	deviceProductCategoriesCount?: Resolver<
		ResolversTypes["Int"],
		ParentType,
		ContextType,
		RequireFields<QueryDeviceProductCategoriesCountArgs, never>
	>;
	deviceProviders?: Resolver<
		Array<ResolversTypes["DeviceProvider"]>,
		ParentType,
		ContextType,
		RequireFields<QueryDeviceProvidersArgs, never>
	>;
	deviceProvidersAggregate?: Resolver<
		ResolversTypes["DeviceProviderAggregateSelection"],
		ParentType,
		ContextType,
		RequireFields<QueryDeviceProvidersAggregateArgs, never>
	>;
	deviceProvidersCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType, RequireFields<QueryDeviceProvidersCountArgs, never>>;
	deviceRecords?: Resolver<Array<ResolversTypes["DeviceRecord"]>, ParentType, ContextType, RequireFields<QueryDeviceRecordsArgs, never>>;
	deviceRecordsAggregate?: Resolver<
		ResolversTypes["DeviceRecordAggregateSelection"],
		ParentType,
		ContextType,
		RequireFields<QueryDeviceRecordsAggregateArgs, never>
	>;
	deviceRecordsCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType, RequireFields<QueryDeviceRecordsCountArgs, never>>;
	discontinuationNotes?: Resolver<
		Array<ResolversTypes["DiscontinuationNote"]>,
		ParentType,
		ContextType,
		RequireFields<QueryDiscontinuationNotesArgs, never>
	>;
	discontinuationNotesAggregate?: Resolver<
		ResolversTypes["DiscontinuationNoteAggregateSelection"],
		ParentType,
		ContextType,
		RequireFields<QueryDiscontinuationNotesAggregateArgs, never>
	>;
	discontinuationNotesCount?: Resolver<
		ResolversTypes["Int"],
		ParentType,
		ContextType,
		RequireFields<QueryDiscontinuationNotesCountArgs, never>
	>;
	diseases?: Resolver<Array<ResolversTypes["Disease"]>, ParentType, ContextType, RequireFields<QueryDiseasesArgs, never>>;
	diseasesAggregate?: Resolver<
		ResolversTypes["DiseaseAggregateSelection"],
		ParentType,
		ContextType,
		RequireFields<QueryDiseasesAggregateArgs, never>
	>;
	diseasesCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType, RequireFields<QueryDiseasesCountArgs, never>>;
	documents?: Resolver<Array<ResolversTypes["Document"]>, ParentType, ContextType, RequireFields<QueryDocumentsArgs, never>>;
	documentsAggregate?: Resolver<
		ResolversTypes["DocumentAggregateSelection"],
		ParentType,
		ContextType,
		RequireFields<QueryDocumentsAggregateArgs, never>
	>;
	documentsCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType, RequireFields<QueryDocumentsCountArgs, never>>;
	eligibilityConditionSets?: Resolver<
		Array<ResolversTypes["EligibilityConditionSet"]>,
		ParentType,
		ContextType,
		RequireFields<QueryEligibilityConditionSetsArgs, never>
	>;
	eligibilityConditionSetsAggregate?: Resolver<
		ResolversTypes["EligibilityConditionSetAggregateSelection"],
		ParentType,
		ContextType,
		RequireFields<QueryEligibilityConditionSetsAggregateArgs, never>
	>;
	eligibilityConditionSetsCount?: Resolver<
		ResolversTypes["Int"],
		ParentType,
		ContextType,
		RequireFields<QueryEligibilityConditionSetsCountArgs, never>
	>;
	enrollingConditionSets?: Resolver<
		Array<ResolversTypes["EnrollingConditionSet"]>,
		ParentType,
		ContextType,
		RequireFields<QueryEnrollingConditionSetsArgs, never>
	>;
	enrollingConditionSetsAggregate?: Resolver<
		ResolversTypes["EnrollingConditionSetAggregateSelection"],
		ParentType,
		ContextType,
		RequireFields<QueryEnrollingConditionSetsAggregateArgs, never>
	>;
	enrollingConditionSetsCount?: Resolver<
		ResolversTypes["Int"],
		ParentType,
		ContextType,
		RequireFields<QueryEnrollingConditionSetsCountArgs, never>
	>;
	enrollingPeriods?: Resolver<
		Array<ResolversTypes["EnrollingPeriod"]>,
		ParentType,
		ContextType,
		RequireFields<QueryEnrollingPeriodsArgs, never>
	>;
	enrollingPeriodsAggregate?: Resolver<
		ResolversTypes["EnrollingPeriodAggregateSelection"],
		ParentType,
		ContextType,
		RequireFields<QueryEnrollingPeriodsAggregateArgs, never>
	>;
	enrollingPeriodsCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType, RequireFields<QueryEnrollingPeriodsCountArgs, never>>;
	exFactoryPrices?: Resolver<
		Array<ResolversTypes["ExFactoryPrice"]>,
		ParentType,
		ContextType,
		RequireFields<QueryExFactoryPricesArgs, never>
	>;
	exFactoryPricesAggregate?: Resolver<
		ResolversTypes["ExFactoryPriceAggregateSelection"],
		ParentType,
		ContextType,
		RequireFields<QueryExFactoryPricesAggregateArgs, never>
	>;
	exFactoryPricesCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType, RequireFields<QueryExFactoryPricesCountArgs, never>>;
	financialDataPointsAggregate?: Resolver<
		ResolversTypes["FinancialDataPointAggregateSelection"],
		ParentType,
		ContextType,
		RequireFields<QueryFinancialDataPointsAggregateArgs, never>
	>;
	financialDataPointsCount?: Resolver<
		ResolversTypes["Int"],
		ParentType,
		ContextType,
		RequireFields<QueryFinancialDataPointsCountArgs, never>
	>;
	financialReportDataPoints?: Resolver<
		Array<ResolversTypes["FinancialReportDataPoint"]>,
		ParentType,
		ContextType,
		RequireFields<QueryFinancialReportDataPointsArgs, never>
	>;
	financialReportDataPointsAggregate?: Resolver<
		ResolversTypes["FinancialReportDataPointAggregateSelection"],
		ParentType,
		ContextType,
		RequireFields<QueryFinancialReportDataPointsAggregateArgs, never>
	>;
	financialReportDataPointsCount?: Resolver<
		ResolversTypes["Int"],
		ParentType,
		ContextType,
		RequireFields<QueryFinancialReportDataPointsCountArgs, never>
	>;
	financialSummaryColumns?: Resolver<
		Array<ResolversTypes["FinancialSummaryColumn"]>,
		ParentType,
		ContextType,
		RequireFields<QueryFinancialSummaryColumnsArgs, never>
	>;
	financialSummaryColumnsAggregate?: Resolver<
		ResolversTypes["FinancialSummaryColumnAggregateSelection"],
		ParentType,
		ContextType,
		RequireFields<QueryFinancialSummaryColumnsAggregateArgs, never>
	>;
	financialSummaryColumnsCount?: Resolver<
		ResolversTypes["Int"],
		ParentType,
		ContextType,
		RequireFields<QueryFinancialSummaryColumnsCountArgs, never>
	>;
	financialSummaryRows?: Resolver<
		Array<ResolversTypes["FinancialSummaryRow"]>,
		ParentType,
		ContextType,
		RequireFields<QueryFinancialSummaryRowsArgs, never>
	>;
	financialSummaryRowsAggregate?: Resolver<
		ResolversTypes["FinancialSummaryRowAggregateSelection"],
		ParentType,
		ContextType,
		RequireFields<QueryFinancialSummaryRowsAggregateArgs, never>
	>;
	financialSummaryRowsCount?: Resolver<
		ResolversTypes["Int"],
		ParentType,
		ContextType,
		RequireFields<QueryFinancialSummaryRowsCountArgs, never>
	>;
	flexEntities?: Resolver<Array<ResolversTypes["FlexEntity"]>, ParentType, ContextType, RequireFields<QueryFlexEntitiesArgs, never>>;
	flexEntitiesAggregate?: Resolver<
		ResolversTypes["FlexEntityAggregateSelection"],
		ParentType,
		ContextType,
		RequireFields<QueryFlexEntitiesAggregateArgs, never>
	>;
	flexEntitiesCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType, RequireFields<QueryFlexEntitiesCountArgs, never>>;
	flexEntityTypes?: Resolver<
		Array<ResolversTypes["FlexEntityType"]>,
		ParentType,
		ContextType,
		RequireFields<QueryFlexEntityTypesArgs, never>
	>;
	flexEntityTypesAggregate?: Resolver<
		ResolversTypes["FlexEntityTypeAggregateSelection"],
		ParentType,
		ContextType,
		RequireFields<QueryFlexEntityTypesAggregateArgs, never>
	>;
	flexEntityTypesCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType, RequireFields<QueryFlexEntityTypesCountArgs, never>>;
	financialDataPoints?: Resolver<
		Array<ResolversTypes["FlexFinancialDataPoint"]>,
		ParentType,
		ContextType,
		RequireFields<QueryFlexFinancialDataPointsArgs, never>
	>;
	flexFinancialDataPointsAggregate?: Resolver<
		ResolversTypes["FlexFinancialDataPointAggregateSelection"],
		ParentType,
		ContextType,
		RequireFields<QueryFlexFinancialDataPointsAggregateArgs, never>
	>;
	flexFinancialDataPointsCount?: Resolver<
		ResolversTypes["Int"],
		ParentType,
		ContextType,
		RequireFields<QueryFlexFinancialDataPointsCountArgs, never>
	>;
	forms?: Resolver<Array<ResolversTypes["Form"]>, ParentType, ContextType, RequireFields<QueryFormsArgs, never>>;
	formsAggregate?: Resolver<
		ResolversTypes["FormAggregateSelection"],
		ParentType,
		ContextType,
		RequireFields<QueryFormsAggregateArgs, never>
	>;
	formsCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType, RequireFields<QueryFormsCountArgs, never>>;
	indications?: Resolver<Array<ResolversTypes["Indication"]>, ParentType, ContextType, RequireFields<QueryIndicationsArgs, never>>;
	indicationsAggregate?: Resolver<
		ResolversTypes["IndicationAggregateSelection"],
		ParentType,
		ContextType,
		RequireFields<QueryIndicationsAggregateArgs, never>
	>;
	indicationsCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType, RequireFields<QueryIndicationsCountArgs, never>>;
	initialResponseReviewReports?: Resolver<
		Array<ResolversTypes["InitialResponseReviewReport"]>,
		ParentType,
		ContextType,
		RequireFields<QueryInitialResponseReviewReportsArgs, never>
	>;
	initialResponseReviewReportsAggregate?: Resolver<
		ResolversTypes["InitialResponseReviewReportAggregateSelection"],
		ParentType,
		ContextType,
		RequireFields<QueryInitialResponseReviewReportsAggregateArgs, never>
	>;
	initialResponseReviewReportsCount?: Resolver<
		ResolversTypes["Int"],
		ParentType,
		ContextType,
		RequireFields<QueryInitialResponseReviewReportsCountArgs, never>
	>;
	initialResponses?: Resolver<
		Array<ResolversTypes["InitialResponse"]>,
		ParentType,
		ContextType,
		RequireFields<QueryInitialResponsesArgs, never>
	>;
	initialResponsesAggregate?: Resolver<
		ResolversTypes["InitialResponseAggregateSelection"],
		ParentType,
		ContextType,
		RequireFields<QueryInitialResponsesAggregateArgs, never>
	>;
	initialResponsesCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType, RequireFields<QueryInitialResponsesCountArgs, never>>;
	interventionReportStatusResponses?: Resolver<
		Array<ResolversTypes["InterventionReportStatusResponse"]>,
		ParentType,
		ContextType,
		RequireFields<QueryInterventionReportStatusResponsesArgs, never>
	>;
	interventionReportStatusResponsesAggregate?: Resolver<
		ResolversTypes["InterventionReportStatusResponseAggregateSelection"],
		ParentType,
		ContextType,
		RequireFields<QueryInterventionReportStatusResponsesAggregateArgs, never>
	>;
	interventionReportStatusResponsesCount?: Resolver<
		ResolversTypes["Int"],
		ParentType,
		ContextType,
		RequireFields<QueryInterventionReportStatusResponsesCountArgs, never>
	>;
	interventions?: Resolver<Array<ResolversTypes["Intervention"]>, ParentType, ContextType, RequireFields<QueryInterventionsArgs, never>>;
	interventionsAggregate?: Resolver<
		ResolversTypes["InterventionAggregateSelection"],
		ParentType,
		ContextType,
		RequireFields<QueryInterventionsAggregateArgs, never>
	>;
	interventionsCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType, RequireFields<QueryInterventionsCountArgs, never>>;
	itemUsedDataPoints?: Resolver<
		Array<ResolversTypes["ItemUsedDataPoint"]>,
		ParentType,
		ContextType,
		RequireFields<QueryItemUsedDataPointsArgs, never>
	>;
	itemUsedDataPointsAggregate?: Resolver<
		ResolversTypes["ItemUsedDataPointAggregateSelection"],
		ParentType,
		ContextType,
		RequireFields<QueryItemUsedDataPointsAggregateArgs, never>
	>;
	itemUsedDataPointsCount?: Resolver<
		ResolversTypes["Int"],
		ParentType,
		ContextType,
		RequireFields<QueryItemUsedDataPointsCountArgs, never>
	>;
	limitations?: Resolver<Array<ResolversTypes["Limitation"]>, ParentType, ContextType, RequireFields<QueryLimitationsArgs, never>>;
	limitationsAggregate?: Resolver<
		ResolversTypes["LimitationAggregateSelection"],
		ParentType,
		ContextType,
		RequireFields<QueryLimitationsAggregateArgs, never>
	>;
	limitationsCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType, RequireFields<QueryLimitationsCountArgs, never>>;
	messages?: Resolver<Array<ResolversTypes["Message"]>, ParentType, ContextType, RequireFields<QueryMessagesArgs, never>>;
	messagesAggregate?: Resolver<
		ResolversTypes["MessageAggregateSelection"],
		ParentType,
		ContextType,
		RequireFields<QueryMessagesAggregateArgs, never>
	>;
	messagesCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType, RequireFields<QueryMessagesCountArgs, never>>;
	microContents?: Resolver<Array<ResolversTypes["MicroContent"]>, ParentType, ContextType, RequireFields<QueryMicroContentsArgs, never>>;
	microContentsAggregate?: Resolver<
		ResolversTypes["MicroContentAggregateSelection"],
		ParentType,
		ContextType,
		RequireFields<QueryMicroContentsAggregateArgs, never>
	>;
	microContentsCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType, RequireFields<QueryMicroContentsCountArgs, never>>;
	modules?: Resolver<Array<ResolversTypes["Module"]>, ParentType, ContextType, RequireFields<QueryModulesArgs, never>>;
	modulesAggregate?: Resolver<
		ResolversTypes["ModuleAggregateSelection"],
		ParentType,
		ContextType,
		RequireFields<QueryModulesAggregateArgs, never>
	>;
	modulesCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType, RequireFields<QueryModulesCountArgs, never>>;
	netRevenueByOrganizations?: Resolver<
		Array<ResolversTypes["NetRevenueByOrganization"]>,
		ParentType,
		ContextType,
		RequireFields<QueryNetRevenueByOrganizationsArgs, never>
	>;
	netRevenueByOrganizationsAggregate?: Resolver<
		ResolversTypes["NetRevenueByOrganizationAggregateSelection"],
		ParentType,
		ContextType,
		RequireFields<QueryNetRevenueByOrganizationsAggregateArgs, never>
	>;
	netRevenueByOrganizationsCount?: Resolver<
		ResolversTypes["Int"],
		ParentType,
		ContextType,
		RequireFields<QueryNetRevenueByOrganizationsCountArgs, never>
	>;
	notificationTriggers?: Resolver<
		Array<ResolversTypes["NotificationTrigger"]>,
		ParentType,
		ContextType,
		RequireFields<QueryNotificationTriggersArgs, never>
	>;
	notificationTriggersAggregate?: Resolver<
		ResolversTypes["NotificationTriggerAggregateSelection"],
		ParentType,
		ContextType,
		RequireFields<QueryNotificationTriggersAggregateArgs, never>
	>;
	notificationTriggersCount?: Resolver<
		ResolversTypes["Int"],
		ParentType,
		ContextType,
		RequireFields<QueryNotificationTriggersCountArgs, never>
	>;
	notifications?: Resolver<Array<ResolversTypes["Notification"]>, ParentType, ContextType, RequireFields<QueryNotificationsArgs, never>>;
	notificationsAggregate?: Resolver<
		ResolversTypes["NotificationAggregateSelection"],
		ParentType,
		ContextType,
		RequireFields<QueryNotificationsAggregateArgs, never>
	>;
	notificationsCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType, RequireFields<QueryNotificationsCountArgs, never>>;
	organizations?: Resolver<Array<ResolversTypes["Organization"]>, ParentType, ContextType, RequireFields<QueryOrganizationsArgs, never>>;
	organizationsAggregate?: Resolver<
		ResolversTypes["OrganizationAggregateSelection"],
		ParentType,
		ContextType,
		RequireFields<QueryOrganizationsAggregateArgs, never>
	>;
	organizationsCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType, RequireFields<QueryOrganizationsCountArgs, never>>;
	outcomebasedAgreementReports?: Resolver<
		Array<ResolversTypes["OutcomebasedAgreementReport"]>,
		ParentType,
		ContextType,
		RequireFields<QueryOutcomebasedAgreementReportsArgs, never>
	>;
	outcomebasedAgreementReportsAggregate?: Resolver<
		ResolversTypes["OutcomebasedAgreementReportAggregateSelection"],
		ParentType,
		ContextType,
		RequireFields<QueryOutcomebasedAgreementReportsAggregateArgs, never>
	>;
	outcomebasedAgreementReportsCount?: Resolver<
		ResolversTypes["Int"],
		ParentType,
		ContextType,
		RequireFields<QueryOutcomebasedAgreementReportsCountArgs, never>
	>;
	partners?: Resolver<Array<ResolversTypes["Partner"]>, ParentType, ContextType, RequireFields<QueryPartnersArgs, never>>;
	partnersAggregate?: Resolver<
		ResolversTypes["PartnerAggregateSelection"],
		ParentType,
		ContextType,
		RequireFields<QueryPartnersAggregateArgs, never>
	>;
	partnersCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType, RequireFields<QueryPartnersCountArgs, never>>;
	patientCountDataPoints?: Resolver<
		Array<ResolversTypes["PatientCountDataPoint"]>,
		ParentType,
		ContextType,
		RequireFields<QueryPatientCountDataPointsArgs, never>
	>;
	patientCountDataPointsAggregate?: Resolver<
		ResolversTypes["PatientCountDataPointAggregateSelection"],
		ParentType,
		ContextType,
		RequireFields<QueryPatientCountDataPointsAggregateArgs, never>
	>;
	patientCountDataPointsCount?: Resolver<
		ResolversTypes["Int"],
		ParentType,
		ContextType,
		RequireFields<QueryPatientCountDataPointsCountArgs, never>
	>;
	patientReportDataPoints?: Resolver<
		Array<ResolversTypes["PatientReportDataPoint"]>,
		ParentType,
		ContextType,
		RequireFields<QueryPatientReportDataPointsArgs, never>
	>;
	patientReportDataPointsAggregate?: Resolver<
		ResolversTypes["PatientReportDataPointAggregateSelection"],
		ParentType,
		ContextType,
		RequireFields<QueryPatientReportDataPointsAggregateArgs, never>
	>;
	patientReportDataPointsCount?: Resolver<
		ResolversTypes["Int"],
		ParentType,
		ContextType,
		RequireFields<QueryPatientReportDataPointsCountArgs, never>
	>;
	patientStatusDistributions?: Resolver<
		Array<ResolversTypes["PatientStatusDistribution"]>,
		ParentType,
		ContextType,
		RequireFields<QueryPatientStatusDistributionsArgs, never>
	>;
	patientStatusDistributionsAggregate?: Resolver<
		ResolversTypes["PatientStatusDistributionAggregateSelection"],
		ParentType,
		ContextType,
		RequireFields<QueryPatientStatusDistributionsAggregateArgs, never>
	>;
	patientStatusDistributionsCount?: Resolver<
		ResolversTypes["Int"],
		ParentType,
		ContextType,
		RequireFields<QueryPatientStatusDistributionsCountArgs, never>
	>;
	patients?: Resolver<Array<ResolversTypes["Patient"]>, ParentType, ContextType, RequireFields<QueryPatientsArgs, never>>;
	patientsAggregate?: Resolver<
		ResolversTypes["PatientAggregateSelection"],
		ParentType,
		ContextType,
		RequireFields<QueryPatientsAggregateArgs, never>
	>;
	patientsCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType, RequireFields<QueryPatientsCountArgs, never>>;
	patientsPerMonthDataPoints?: Resolver<
		Array<ResolversTypes["PatientsPerMonthDataPoint"]>,
		ParentType,
		ContextType,
		RequireFields<QueryPatientsPerMonthDataPointsArgs, never>
	>;
	patientsPerMonthDataPointsAggregate?: Resolver<
		ResolversTypes["PatientsPerMonthDataPointAggregateSelection"],
		ParentType,
		ContextType,
		RequireFields<QueryPatientsPerMonthDataPointsAggregateArgs, never>
	>;
	patientsPerMonthDataPointsCount?: Resolver<
		ResolversTypes["Int"],
		ParentType,
		ContextType,
		RequireFields<QueryPatientsPerMonthDataPointsCountArgs, never>
	>;
	piRecurrenceSiDataPoints?: Resolver<
		Array<ResolversTypes["PIRecurrenceSIDataPoint"]>,
		ParentType,
		ContextType,
		RequireFields<QueryPiRecurrenceSiDataPointsArgs, never>
	>;
	piRecurrenceSiDataPointsAggregate?: Resolver<
		ResolversTypes["PIRecurrenceSIDataPointAggregateSelection"],
		ParentType,
		ContextType,
		RequireFields<QueryPiRecurrenceSiDataPointsAggregateArgs, never>
	>;
	piRecurrenceSiDataPointsCount?: Resolver<
		ResolversTypes["Int"],
		ParentType,
		ContextType,
		RequireFields<QueryPiRecurrenceSiDataPointsCountArgs, never>
	>;
	preparationStatuses?: Resolver<
		Array<ResolversTypes["PreparationStatus"]>,
		ParentType,
		ContextType,
		RequireFields<QueryPreparationStatusesArgs, never>
	>;
	preparationStatusesAggregate?: Resolver<
		ResolversTypes["PreparationStatusAggregateSelection"],
		ParentType,
		ContextType,
		RequireFields<QueryPreparationStatusesAggregateArgs, never>
	>;
	preparationStatusesCount?: Resolver<
		ResolversTypes["Int"],
		ParentType,
		ContextType,
		RequireFields<QueryPreparationStatusesCountArgs, never>
	>;
	preparations?: Resolver<Array<ResolversTypes["Preparation"]>, ParentType, ContextType, RequireFields<QueryPreparationsArgs, never>>;
	preparationsAggregate?: Resolver<
		ResolversTypes["PreparationAggregateSelection"],
		ParentType,
		ContextType,
		RequireFields<QueryPreparationsAggregateArgs, never>
	>;
	preparationsCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType, RequireFields<QueryPreparationsCountArgs, never>>;
	prices?: Resolver<Array<ResolversTypes["Price"]>, ParentType, ContextType, RequireFields<QueryPricesArgs, never>>;
	pricesAggregate?: Resolver<
		ResolversTypes["PriceAggregateSelection"],
		ParentType,
		ContextType,
		RequireFields<QueryPricesAggregateArgs, never>
	>;
	pricesCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType, RequireFields<QueryPricesCountArgs, never>>;
	processedDeviceRecords?: Resolver<
		Array<ResolversTypes["ProcessedDeviceRecord"]>,
		ParentType,
		ContextType,
		RequireFields<QueryProcessedDeviceRecordsArgs, never>
	>;
	processedDeviceRecordsAggregate?: Resolver<
		ResolversTypes["ProcessedDeviceRecordAggregateSelection"],
		ParentType,
		ContextType,
		RequireFields<QueryProcessedDeviceRecordsAggregateArgs, never>
	>;
	processedDeviceRecordsCount?: Resolver<
		ResolversTypes["Int"],
		ParentType,
		ContextType,
		RequireFields<QueryProcessedDeviceRecordsCountArgs, never>
	>;
	publicPrices?: Resolver<Array<ResolversTypes["PublicPrice"]>, ParentType, ContextType, RequireFields<QueryPublicPricesArgs, never>>;
	publicPricesAggregate?: Resolver<
		ResolversTypes["PublicPriceAggregateSelection"],
		ParentType,
		ContextType,
		RequireFields<QueryPublicPricesAggregateArgs, never>
	>;
	publicPricesCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType, RequireFields<QueryPublicPricesCountArgs, never>>;
	reasonOfTreatmentDiscontinuationReports?: Resolver<
		Array<ResolversTypes["ReasonOfTreatmentDiscontinuationReport"]>,
		ParentType,
		ContextType,
		RequireFields<QueryReasonOfTreatmentDiscontinuationReportsArgs, never>
	>;
	reasonOfTreatmentDiscontinuationReportsAggregate?: Resolver<
		ResolversTypes["ReasonOfTreatmentDiscontinuationReportAggregateSelection"],
		ParentType,
		ContextType,
		RequireFields<QueryReasonOfTreatmentDiscontinuationReportsAggregateArgs, never>
	>;
	reasonOfTreatmentDiscontinuationReportsCount?: Resolver<
		ResolversTypes["Int"],
		ParentType,
		ContextType,
		RequireFields<QueryReasonOfTreatmentDiscontinuationReportsCountArgs, never>
	>;
	recommendedForms?: Resolver<
		Array<ResolversTypes["RecommendedForm"]>,
		ParentType,
		ContextType,
		RequireFields<QueryRecommendedFormsArgs, never>
	>;
	recommendedFormsAggregate?: Resolver<
		ResolversTypes["RecommendedFormAggregateSelection"],
		ParentType,
		ContextType,
		RequireFields<QueryRecommendedFormsAggregateArgs, never>
	>;
	recommendedFormsCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType, RequireFields<QueryRecommendedFormsCountArgs, never>>;
	recordBatches?: Resolver<Array<ResolversTypes["RecordBatch"]>, ParentType, ContextType, RequireFields<QueryRecordBatchesArgs, never>>;
	recordBatchesAggregate?: Resolver<
		ResolversTypes["RecordBatchAggregateSelection"],
		ParentType,
		ContextType,
		RequireFields<QueryRecordBatchesAggregateArgs, never>
	>;
	recordBatchesCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType, RequireFields<QueryRecordBatchesCountArgs, never>>;
	records?: Resolver<Array<ResolversTypes["Record"]>, ParentType, ContextType, RequireFields<QueryRecordsArgs, never>>;
	recordsAggregate?: Resolver<
		ResolversTypes["RecordAggregateSelection"],
		ParentType,
		ContextType,
		RequireFields<QueryRecordsAggregateArgs, never>
	>;
	recordsCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType, RequireFields<QueryRecordsCountArgs, never>>;
	refunds?: Resolver<Array<ResolversTypes["Refund"]>, ParentType, ContextType, RequireFields<QueryRefundsArgs, never>>;
	refundsAggregate?: Resolver<
		ResolversTypes["RefundAggregateSelection"],
		ParentType,
		ContextType,
		RequireFields<QueryRefundsAggregateArgs, never>
	>;
	refundsCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType, RequireFields<QueryRefundsCountArgs, never>>;
	reportingSummaries?: Resolver<
		Array<ResolversTypes["ReportingSummary"]>,
		ParentType,
		ContextType,
		RequireFields<QueryReportingSummariesArgs, never>
	>;
	reportingSummariesAggregate?: Resolver<
		ResolversTypes["ReportingSummaryAggregateSelection"],
		ParentType,
		ContextType,
		RequireFields<QueryReportingSummariesAggregateArgs, never>
	>;
	reportingSummariesCount?: Resolver<
		ResolversTypes["Int"],
		ParentType,
		ContextType,
		RequireFields<QueryReportingSummariesCountArgs, never>
	>;
	scenarioActions?: Resolver<
		Array<ResolversTypes["ScenarioAction"]>,
		ParentType,
		ContextType,
		RequireFields<QueryScenarioActionsArgs, never>
	>;
	scenarioActionsAggregate?: Resolver<
		ResolversTypes["ScenarioActionAggregateSelection"],
		ParentType,
		ContextType,
		RequireFields<QueryScenarioActionsAggregateArgs, never>
	>;
	scenarioActionsCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType, RequireFields<QueryScenarioActionsCountArgs, never>>;
	scenarioConditions?: Resolver<
		Array<ResolversTypes["ScenarioCondition"]>,
		ParentType,
		ContextType,
		RequireFields<QueryScenarioConditionsArgs, never>
	>;
	scenarioConditionsAggregate?: Resolver<
		ResolversTypes["ScenarioConditionAggregateSelection"],
		ParentType,
		ContextType,
		RequireFields<QueryScenarioConditionsAggregateArgs, never>
	>;
	scenarioConditionsCount?: Resolver<
		ResolversTypes["Int"],
		ParentType,
		ContextType,
		RequireFields<QueryScenarioConditionsCountArgs, never>
	>;
	scenarios?: Resolver<Array<ResolversTypes["Scenario"]>, ParentType, ContextType, RequireFields<QueryScenariosArgs, never>>;
	scenariosAggregate?: Resolver<
		ResolversTypes["ScenarioAggregateSelection"],
		ParentType,
		ContextType,
		RequireFields<QueryScenariosAggregateArgs, never>
	>;
	scenariosCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType, RequireFields<QueryScenariosCountArgs, never>>;
	stobActions?: Resolver<Array<ResolversTypes["StobAction"]>, ParentType, ContextType, RequireFields<QueryStobActionsArgs, never>>;
	stobActionsAggregate?: Resolver<
		ResolversTypes["StobActionAggregateSelection"],
		ParentType,
		ContextType,
		RequireFields<QueryStobActionsAggregateArgs, never>
	>;
	stobActionsCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType, RequireFields<QueryStobActionsCountArgs, never>>;
	stobConditions?: Resolver<
		Array<ResolversTypes["StobCondition"]>,
		ParentType,
		ContextType,
		RequireFields<QueryStobConditionsArgs, never>
	>;
	stobConditionsAggregate?: Resolver<
		ResolversTypes["StobConditionAggregateSelection"],
		ParentType,
		ContextType,
		RequireFields<QueryStobConditionsAggregateArgs, never>
	>;
	stobConditionsCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType, RequireFields<QueryStobConditionsCountArgs, never>>;
	stobContracts?: Resolver<Array<ResolversTypes["StobContract"]>, ParentType, ContextType, RequireFields<QueryStobContractsArgs, never>>;
	stobContractsAggregate?: Resolver<
		ResolversTypes["StobContractAggregateSelection"],
		ParentType,
		ContextType,
		RequireFields<QueryStobContractsAggregateArgs, never>
	>;
	stobContractsCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType, RequireFields<QueryStobContractsCountArgs, never>>;
	stobScenarios?: Resolver<Array<ResolversTypes["StobScenario"]>, ParentType, ContextType, RequireFields<QueryStobScenariosArgs, never>>;
	stobScenariosAggregate?: Resolver<
		ResolversTypes["StobScenarioAggregateSelection"],
		ParentType,
		ContextType,
		RequireFields<QueryStobScenariosAggregateArgs, never>
	>;
	stobScenariosCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType, RequireFields<QueryStobScenariosCountArgs, never>>;
	stobStatistics?: Resolver<
		Array<ResolversTypes["StobStatistics"]>,
		ParentType,
		ContextType,
		RequireFields<QueryStobStatisticsArgs, never>
	>;
	stobStatisticsAggregate?: Resolver<
		ResolversTypes["StobStatisticsAggregateSelection"],
		ParentType,
		ContextType,
		RequireFields<QueryStobStatisticsAggregateArgs, never>
	>;
	stobStatisticsCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType, RequireFields<QueryStobStatisticsCountArgs, never>>;
	tasks?: Resolver<Array<ResolversTypes["Task"]>, ParentType, ContextType, RequireFields<QueryTasksArgs, never>>;
	tasksAggregate?: Resolver<
		ResolversTypes["TaskAggregateSelection"],
		ParentType,
		ContextType,
		RequireFields<QueryTasksAggregateArgs, never>
	>;
	tasksCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType, RequireFields<QueryTasksCountArgs, never>>;
	timeframes?: Resolver<Array<ResolversTypes["Timeframe"]>, ParentType, ContextType, RequireFields<QueryTimeframesArgs, never>>;
	timeframesAggregate?: Resolver<
		ResolversTypes["TimeframeAggregateSelection"],
		ParentType,
		ContextType,
		RequireFields<QueryTimeframesAggregateArgs, never>
	>;
	timeframesCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType, RequireFields<QueryTimeframesCountArgs, never>>;
	translations?: Resolver<Array<ResolversTypes["Translation"]>, ParentType, ContextType, RequireFields<QueryTranslationsArgs, never>>;
	translationsAggregate?: Resolver<
		ResolversTypes["TranslationAggregateSelection"],
		ParentType,
		ContextType,
		RequireFields<QueryTranslationsAggregateArgs, never>
	>;
	translationsCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType, RequireFields<QueryTranslationsCountArgs, never>>;
	translationsResults?: Resolver<
		Array<ResolversTypes["TranslationsResult"]>,
		ParentType,
		ContextType,
		RequireFields<QueryTranslationsResultsArgs, never>
	>;
	translationsResultsAggregate?: Resolver<
		ResolversTypes["TranslationsResultAggregateSelection"],
		ParentType,
		ContextType,
		RequireFields<QueryTranslationsResultsAggregateArgs, never>
	>;
	translationsResultsCount?: Resolver<
		ResolversTypes["Int"],
		ParentType,
		ContextType,
		RequireFields<QueryTranslationsResultsCountArgs, never>
	>;
	treatingPhysicians?: Resolver<
		Array<ResolversTypes["TreatingPhysician"]>,
		ParentType,
		ContextType,
		RequireFields<QueryTreatingPhysiciansArgs, never>
	>;
	treatingPhysiciansAggregate?: Resolver<
		ResolversTypes["TreatingPhysicianAggregateSelection"],
		ParentType,
		ContextType,
		RequireFields<QueryTreatingPhysiciansAggregateArgs, never>
	>;
	treatingPhysiciansCount?: Resolver<
		ResolversTypes["Int"],
		ParentType,
		ContextType,
		RequireFields<QueryTreatingPhysiciansCountArgs, never>
	>;
	treatmentPatients?: Resolver<
		Array<ResolversTypes["TreatmentPatient"]>,
		ParentType,
		ContextType,
		RequireFields<QueryTreatmentPatientsArgs, never>
	>;
	treatmentPatientsAggregate?: Resolver<
		ResolversTypes["TreatmentPatientAggregateSelection"],
		ParentType,
		ContextType,
		RequireFields<QueryTreatmentPatientsAggregateArgs, never>
	>;
	treatmentPatientsCount?: Resolver<
		ResolversTypes["Int"],
		ParentType,
		ContextType,
		RequireFields<QueryTreatmentPatientsCountArgs, never>
	>;
	treatments?: Resolver<Array<ResolversTypes["Treatment"]>, ParentType, ContextType, RequireFields<QueryTreatmentsArgs, never>>;
	treatmentsAggregate?: Resolver<
		ResolversTypes["TreatmentAggregateSelection"],
		ParentType,
		ContextType,
		RequireFields<QueryTreatmentsAggregateArgs, never>
	>;
	treatmentsCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType, RequireFields<QueryTreatmentsCountArgs, never>>;
	userContexts?: Resolver<Array<ResolversTypes["UserContext"]>, ParentType, ContextType, RequireFields<QueryUserContextsArgs, never>>;
	userContextsAggregate?: Resolver<
		ResolversTypes["UserContextAggregateSelection"],
		ParentType,
		ContextType,
		RequireFields<QueryUserContextsAggregateArgs, never>
	>;
	userContextsCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType, RequireFields<QueryUserContextsCountArgs, never>>;
	userOrgSettingsData?: Resolver<
		Array<ResolversTypes["UserOrgSettingsData"]>,
		ParentType,
		ContextType,
		RequireFields<QueryUserOrgSettingsDataArgs, never>
	>;
	userOrgSettingsDataAggregate?: Resolver<
		ResolversTypes["UserOrgSettingsDataAggregateSelection"],
		ParentType,
		ContextType,
		RequireFields<QueryUserOrgSettingsDataAggregateArgs, never>
	>;
	userOrgSettingsDataCount?: Resolver<
		ResolversTypes["Int"],
		ParentType,
		ContextType,
		RequireFields<QueryUserOrgSettingsDataCountArgs, never>
	>;
	userOrganizationInfos?: Resolver<
		Array<ResolversTypes["UserOrganizationInfo"]>,
		ParentType,
		ContextType,
		RequireFields<QueryUserOrganizationInfosArgs, never>
	>;
	userOrganizationInfosAggregate?: Resolver<
		ResolversTypes["UserOrganizationInfoAggregateSelection"],
		ParentType,
		ContextType,
		RequireFields<QueryUserOrganizationInfosAggregateArgs, never>
	>;
	userOrganizationInfosCount?: Resolver<
		ResolversTypes["Int"],
		ParentType,
		ContextType,
		RequireFields<QueryUserOrganizationInfosCountArgs, never>
	>;
	userPersonalInfos?: Resolver<
		Array<ResolversTypes["UserPersonalInfo"]>,
		ParentType,
		ContextType,
		RequireFields<QueryUserPersonalInfosArgs, never>
	>;
	userPersonalInfosAggregate?: Resolver<
		ResolversTypes["UserPersonalInfoAggregateSelection"],
		ParentType,
		ContextType,
		RequireFields<QueryUserPersonalInfosAggregateArgs, never>
	>;
	userPersonalInfosCount?: Resolver<
		ResolversTypes["Int"],
		ParentType,
		ContextType,
		RequireFields<QueryUserPersonalInfosCountArgs, never>
	>;
	users?: Resolver<Array<ResolversTypes["User"]>, ParentType, ContextType, RequireFields<QueryUsersArgs, never>>;
	usersAggregate?: Resolver<
		ResolversTypes["UserAggregateSelection"],
		ParentType,
		ContextType,
		RequireFields<QueryUsersAggregateArgs, never>
	>;
	usersCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType, RequireFields<QueryUsersCountArgs, never>>;
};

export type ReasonOfTreatmentDiscontinuationReportResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["ReasonOfTreatmentDiscontinuationReport"] = ResolversParentTypes["ReasonOfTreatmentDiscontinuationReport"]
> = {
	count?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
	result?: Resolver<Maybe<ResolversTypes["ReasonsForDiscontinuation"]>, ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReasonOfTreatmentDiscontinuationReportAggregateSelectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["ReasonOfTreatmentDiscontinuationReportAggregateSelection"] = ResolversParentTypes["ReasonOfTreatmentDiscontinuationReportAggregateSelection"]
> = {
	count?: Resolver<ResolversTypes["IntAggregateSelection"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RecommendedFormResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["RecommendedForm"] = ResolversParentTypes["RecommendedForm"]
> = {
	formType?: Resolver<Maybe<ResolversTypes["FormType"]>, ParentType, ContextType>;
	order?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	timeframeEnd?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
	timeframeRelation?: Resolver<ResolversTypes["StobTimeframeRelation"], ParentType, ContextType>;
	timeframeStart?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	timeframeStartingPoint?: Resolver<ResolversTypes["StobTimeframeStartingPoint"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RecommendedFormAggregateSelectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["RecommendedFormAggregateSelection"] = ResolversParentTypes["RecommendedFormAggregateSelection"]
> = {
	count?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	order?: Resolver<ResolversTypes["IntAggregateSelection"], ParentType, ContextType>;
	timeframeEnd?: Resolver<ResolversTypes["IntAggregateSelection"], ParentType, ContextType>;
	timeframeStart?: Resolver<ResolversTypes["IntAggregateSelection"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RecordResolvers<ContextType = any, ParentType extends ResolversParentTypes["Record"] = ResolversParentTypes["Record"]> = {
	administrationDate?: Resolver<Maybe<ResolversTypes["DateTime"]>, ParentType, ContextType>;
	claimId?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	createdBy?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	createdByName?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	createdOn?: Resolver<ResolversTypes["DateTime"], ParentType, ContextType>;
	deviceRecord?: Resolver<Maybe<ResolversTypes["DeviceRecord"]>, ParentType, ContextType, RequireFields<RecordDeviceRecordArgs, never>>;
	deviceRecordConnection?: Resolver<
		ResolversTypes["RecordDeviceRecordConnection"],
		ParentType,
		ContextType,
		RequireFields<RecordDeviceRecordConnectionArgs, never>
	>;
	id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
	insuranceId?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	invoiceDate?: Resolver<Maybe<ResolversTypes["DateTime"]>, ParentType, ContextType>;
	invoiceNumber?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	isArchived?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
	isDeleted?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
	occurrence?: Resolver<Maybe<ResolversTypes["OccurrenceEnum"]>, ParentType, ContextType>;
	preparationBrandNames?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	preparationGenericNames?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	preparationId?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	prescriptionDate?: Resolver<Maybe<ResolversTypes["Date"]>, ParentType, ContextType>;
	quantity?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
	status?: Resolver<Maybe<ResolversTypes["FlexFormStatus"]>, ParentType, ContextType>;
	tenantId?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	treatmentName?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	type?: Resolver<Maybe<ResolversTypes["RecordsTypeEnum"]>, ParentType, ContextType>;
	unlimited?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
	uuid?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RecordAggregateSelectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["RecordAggregateSelection"] = ResolversParentTypes["RecordAggregateSelection"]
> = {
	administrationDate?: Resolver<ResolversTypes["DateTimeAggregateSelection"], ParentType, ContextType>;
	claimId?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	count?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	createdBy?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	createdByName?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	createdOn?: Resolver<ResolversTypes["DateTimeAggregateSelection"], ParentType, ContextType>;
	id?: Resolver<ResolversTypes["IDAggregateSelection"], ParentType, ContextType>;
	insuranceId?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	invoiceDate?: Resolver<ResolversTypes["DateTimeAggregateSelection"], ParentType, ContextType>;
	invoiceNumber?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	preparationBrandNames?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	preparationGenericNames?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	preparationId?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	quantity?: Resolver<ResolversTypes["IntAggregateSelection"], ParentType, ContextType>;
	tenantId?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	treatmentName?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	unlimited?: Resolver<ResolversTypes["IntAggregateSelection"], ParentType, ContextType>;
	uuid?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RecordBatchResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["RecordBatch"] = ResolversParentTypes["RecordBatch"]
> = {
	createdOn?: Resolver<Maybe<ResolversTypes["DateTime"]>, ParentType, ContextType>;
	evaluationSnapshot?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	financialDataPoints?: Resolver<
		Array<ResolversTypes["FlexFinancialDataPoint"]>,
		ParentType,
		ContextType,
		RequireFields<RecordBatchFinancialDataPointsArgs, never>
	>;
	financialDataPointsConnection?: Resolver<
		ResolversTypes["RecordBatchFinancialDataPointsConnection"],
		ParentType,
		ContextType,
		RequireFields<RecordBatchFinancialDataPointsConnectionArgs, never>
	>;
	status?: Resolver<ResolversTypes["RecordBatchStatus"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RecordBatchAggregateSelectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["RecordBatchAggregateSelection"] = ResolversParentTypes["RecordBatchAggregateSelection"]
> = {
	count?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	createdOn?: Resolver<ResolversTypes["DateTimeAggregateSelection"], ParentType, ContextType>;
	evaluationSnapshot?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RecordBatchFinancialDataPointsConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["RecordBatchFinancialDataPointsConnection"] = ResolversParentTypes["RecordBatchFinancialDataPointsConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["RecordBatchFinancialDataPointsRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RecordBatchFinancialDataPointsRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["RecordBatchFinancialDataPointsRelationship"] = ResolversParentTypes["RecordBatchFinancialDataPointsRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["FlexFinancialDataPoint"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RecordDeviceRecordConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["RecordDeviceRecordConnection"] = ResolversParentTypes["RecordDeviceRecordConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["RecordDeviceRecordRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RecordDeviceRecordRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["RecordDeviceRecordRelationship"] = ResolversParentTypes["RecordDeviceRecordRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["DeviceRecord"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RefundResolvers<ContextType = any, ParentType extends ResolversParentTypes["Refund"] = ResolversParentTypes["Refund"]> = {
	agreementName?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	amount?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
	canUserCreateDocument?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
	case?: Resolver<ResolversTypes["Case"], ParentType, ContextType, RequireFields<RefundCaseArgs, never>>;
	caseConnection?: Resolver<
		ResolversTypes["RefundCaseConnection"],
		ParentType,
		ContextType,
		RequireFields<RefundCaseConnectionArgs, never>
	>;
	caseId?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	counterParties?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	createdOn?: Resolver<ResolversTypes["Date"], ParentType, ContextType>;
	currency?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	formattedTags?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
	iin?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	invoiceFinancialDataPoints?: Resolver<
		Array<ResolversTypes["FinancialDataPoint"]>,
		ParentType,
		ContextType,
		RequireFields<RefundInvoiceFinancialDataPointsArgs, never>
	>;
	invoiceFinancialDataPointsConnection?: Resolver<
		ResolversTypes["RefundInvoiceFinancialDataPointsConnection"],
		ParentType,
		ContextType,
		RequireFields<RefundInvoiceFinancialDataPointsConnectionArgs, never>
	>;
	invoices?: Resolver<Maybe<ResolversTypes["Document"]>, ParentType, ContextType, RequireFields<RefundInvoicesArgs, never>>;
	invoicesConnection?: Resolver<
		ResolversTypes["RefundInvoicesConnection"],
		ParentType,
		ContextType,
		RequireFields<RefundInvoicesConnectionArgs, never>
	>;
	isAgreementBuyer?: Resolver<Maybe<ResolversTypes["Boolean"]>, ParentType, ContextType>;
	isDeleted?: Resolver<Maybe<ResolversTypes["Boolean"]>, ParentType, ContextType>;
	message?: Resolver<Maybe<ResolversTypes["Message"]>, ParentType, ContextType, RequireFields<RefundMessageArgs, never>>;
	messageConnection?: Resolver<
		ResolversTypes["RefundMessageConnection"],
		ParentType,
		ContextType,
		RequireFields<RefundMessageConnectionArgs, never>
	>;
	messageCount?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
	nonObserverTenantIds?: Resolver<Maybe<Array<ResolversTypes["String"]>>, ParentType, ContextType>;
	product?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	sourceFinancialDataPoints?: Resolver<
		Array<ResolversTypes["FinancialDataPoint"]>,
		ParentType,
		ContextType,
		RequireFields<RefundSourceFinancialDataPointsArgs, never>
	>;
	sourceFinancialDataPointsConnection?: Resolver<
		ResolversTypes["RefundSourceFinancialDataPointsConnection"],
		ParentType,
		ContextType,
		RequireFields<RefundSourceFinancialDataPointsConnectionArgs, never>
	>;
	status?: Resolver<ResolversTypes["RefundStatus"], ParentType, ContextType>;
	tags?: Resolver<Array<ResolversTypes["AgreementTag"]>, ParentType, ContextType, RequireFields<RefundTagsArgs, never>>;
	tagsConnection?: Resolver<
		ResolversTypes["RefundTagsConnection"],
		ParentType,
		ContextType,
		RequireFields<RefundTagsConnectionArgs, never>
	>;
	tenantIds?: Resolver<Array<ResolversTypes["String"]>, ParentType, ContextType>;
	unlimited?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RefundAggregateSelectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["RefundAggregateSelection"] = ResolversParentTypes["RefundAggregateSelection"]
> = {
	agreementName?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	amount?: Resolver<ResolversTypes["FloatAggregateSelection"], ParentType, ContextType>;
	caseId?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	count?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	counterParties?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	currency?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	formattedTags?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	id?: Resolver<ResolversTypes["IDAggregateSelection"], ParentType, ContextType>;
	iin?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	product?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	unlimited?: Resolver<ResolversTypes["IntAggregateSelection"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RefundCaseConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["RefundCaseConnection"] = ResolversParentTypes["RefundCaseConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["RefundCaseRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RefundCaseRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["RefundCaseRelationship"] = ResolversParentTypes["RefundCaseRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["Case"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RefundInvoiceFinancialDataPointsConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["RefundInvoiceFinancialDataPointsConnection"] = ResolversParentTypes["RefundInvoiceFinancialDataPointsConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["RefundInvoiceFinancialDataPointsRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RefundInvoiceFinancialDataPointsRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["RefundInvoiceFinancialDataPointsRelationship"] = ResolversParentTypes["RefundInvoiceFinancialDataPointsRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	id?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["FinancialDataPoint"], ParentType, ContextType>;
	status?: Resolver<Maybe<ResolversTypes["FinancialDataPointStatus"]>, ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RefundInvoicesConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["RefundInvoicesConnection"] = ResolversParentTypes["RefundInvoicesConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["RefundInvoicesRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RefundInvoicesRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["RefundInvoicesRelationship"] = ResolversParentTypes["RefundInvoicesRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["Document"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RefundMessageConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["RefundMessageConnection"] = ResolversParentTypes["RefundMessageConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["RefundMessageRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RefundMessageRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["RefundMessageRelationship"] = ResolversParentTypes["RefundMessageRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["Message"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RefundSourceFinancialDataPointsConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["RefundSourceFinancialDataPointsConnection"] = ResolversParentTypes["RefundSourceFinancialDataPointsConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["RefundSourceFinancialDataPointsRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RefundSourceFinancialDataPointsRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["RefundSourceFinancialDataPointsRelationship"] = ResolversParentTypes["RefundSourceFinancialDataPointsRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["FinancialDataPoint"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RefundTagsConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["RefundTagsConnection"] = ResolversParentTypes["RefundTagsConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["RefundTagsRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RefundTagsRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["RefundTagsRelationship"] = ResolversParentTypes["RefundTagsRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["AgreementTag"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReportingSummaryResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["ReportingSummary"] = ResolversParentTypes["ReportingSummary"]
> = {
	averageDiscountPerCase?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
	averageDiscountPerCaseDelta?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
	discountAmount?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
	discountAmountDelta?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
	discountsTurnover?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
	grossAmount?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
	grossAmountDelta?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
	grossTurnover?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
	grossVariable?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
	netTurnover?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
	patientReportDataPoints?: Resolver<Array<ResolversTypes["PatientReportDataPoint"]>, ParentType, ContextType>;
	randomMicrocontentContent?: Resolver<Maybe<ResolversTypes["MicroContent"]>, ParentType, ContextType>;
	variableTurnover?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReportingSummaryAggregateSelectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["ReportingSummaryAggregateSelection"] = ResolversParentTypes["ReportingSummaryAggregateSelection"]
> = {
	averageDiscountPerCase?: Resolver<ResolversTypes["FloatAggregateSelection"], ParentType, ContextType>;
	averageDiscountPerCaseDelta?: Resolver<ResolversTypes["FloatAggregateSelection"], ParentType, ContextType>;
	count?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	discountAmount?: Resolver<ResolversTypes["FloatAggregateSelection"], ParentType, ContextType>;
	discountAmountDelta?: Resolver<ResolversTypes["FloatAggregateSelection"], ParentType, ContextType>;
	discountsTurnover?: Resolver<ResolversTypes["FloatAggregateSelection"], ParentType, ContextType>;
	grossAmount?: Resolver<ResolversTypes["FloatAggregateSelection"], ParentType, ContextType>;
	grossAmountDelta?: Resolver<ResolversTypes["FloatAggregateSelection"], ParentType, ContextType>;
	grossTurnover?: Resolver<ResolversTypes["FloatAggregateSelection"], ParentType, ContextType>;
	grossVariable?: Resolver<ResolversTypes["FloatAggregateSelection"], ParentType, ContextType>;
	netTurnover?: Resolver<ResolversTypes["FloatAggregateSelection"], ParentType, ContextType>;
	variableTurnover?: Resolver<ResolversTypes["FloatAggregateSelection"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScenarioResolvers<ContextType = any, ParentType extends ResolversParentTypes["Scenario"] = ResolversParentTypes["Scenario"]> = {
	actions?: Resolver<Array<ResolversTypes["ScenarioAction"]>, ParentType, ContextType, RequireFields<ScenarioActionsArgs, never>>;
	actionsConnection?: Resolver<
		ResolversTypes["ScenarioActionsConnection"],
		ParentType,
		ContextType,
		RequireFields<ScenarioActionsConnectionArgs, never>
	>;
	agreement?: Resolver<ResolversTypes["BaseAgreement"], ParentType, ContextType, RequireFields<ScenarioAgreementArgs, never>>;
	agreementConnection?: Resolver<
		ResolversTypes["ScenarioAgreementConnection"],
		ParentType,
		ContextType,
		RequireFields<ScenarioAgreementConnectionArgs, never>
	>;
	conditions?: Resolver<
		Array<ResolversTypes["ScenarioCondition"]>,
		ParentType,
		ContextType,
		RequireFields<ScenarioConditionsArgs, never>
	>;
	conditionsConnection?: Resolver<
		ResolversTypes["ScenarioConditionsConnection"],
		ParentType,
		ContextType,
		RequireFields<ScenarioConditionsConnectionArgs, never>
	>;
	group?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
	isForged?: Resolver<Maybe<ResolversTypes["Boolean"]>, ParentType, ContextType>;
	isGrouped?: Resolver<Maybe<ResolversTypes["Boolean"]>, ParentType, ContextType>;
	operator?: Resolver<ResolversTypes["ConditionLogicalOperator"], ParentType, ContextType>;
	order?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScenarioActionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["ScenarioAction"] = ResolversParentTypes["ScenarioAction"]
> = {
	actionType?: Resolver<ResolversTypes["ActionType"], ParentType, ContextType>;
	brand?: Resolver<Maybe<ResolversTypes["Brand"]>, ParentType, ContextType, RequireFields<ScenarioActionBrandArgs, never>>;
	brandConnection?: Resolver<
		ResolversTypes["ScenarioActionBrandConnection"],
		ParentType,
		ContextType,
		RequireFields<ScenarioActionBrandConnectionArgs, never>
	>;
	categories?: Resolver<
		Array<ResolversTypes["DeviceProductCategory"]>,
		ParentType,
		ContextType,
		RequireFields<ScenarioActionCategoriesArgs, never>
	>;
	categoriesConnection?: Resolver<
		ResolversTypes["ScenarioActionCategoriesConnection"],
		ParentType,
		ContextType,
		RequireFields<ScenarioActionCategoriesConnectionArgs, never>
	>;
	combinedItemBrands?: Resolver<
		Array<ResolversTypes["Brand"]>,
		ParentType,
		ContextType,
		RequireFields<ScenarioActionCombinedItemBrandsArgs, never>
	>;
	combinedItemBrandsConnection?: Resolver<
		ResolversTypes["ScenarioActionCombinedItemBrandsConnection"],
		ParentType,
		ContextType,
		RequireFields<ScenarioActionCombinedItemBrandsConnectionArgs, never>
	>;
	combinedItemTimeframeEnd?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
	combinedItemTimeframeRangeType?: Resolver<Maybe<ResolversTypes["TimeframeRangeType"]>, ParentType, ContextType>;
	combinedItemTimeframeStart?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
	combinedItemTreatments?: Resolver<
		Array<ResolversTypes["Treatment"]>,
		ParentType,
		ContextType,
		RequireFields<ScenarioActionCombinedItemTreatmentsArgs, never>
	>;
	combinedItemTreatmentsConnection?: Resolver<
		ResolversTypes["ScenarioActionCombinedItemTreatmentsConnection"],
		ParentType,
		ContextType,
		RequireFields<ScenarioActionCombinedItemTreatmentsConnectionArgs, never>
	>;
	deviceKits?: Resolver<Array<ResolversTypes["DeviceKit"]>, ParentType, ContextType, RequireFields<ScenarioActionDeviceKitsArgs, never>>;
	deviceKitsConnection?: Resolver<
		ResolversTypes["ScenarioActionDeviceKitsConnection"],
		ParentType,
		ContextType,
		RequireFields<ScenarioActionDeviceKitsConnectionArgs, never>
	>;
	endItemNumber?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
	itemCombinationRelation?: Resolver<Maybe<ResolversTypes["ActionItemCombinationRelation"]>, ParentType, ContextType>;
	itemCombinationRule?: Resolver<Maybe<ResolversTypes["ActionItemCombinationRule"]>, ParentType, ContextType>;
	itemRangeType?: Resolver<Maybe<ResolversTypes["ActionItemRangeType"]>, ParentType, ContextType>;
	itemScope?: Resolver<ResolversTypes["ItemScope"], ParentType, ContextType>;
	order?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	priceType?: Resolver<ResolversTypes["PriceType"], ParentType, ContextType>;
	recordNature?: Resolver<Maybe<ResolversTypes["RecordNature"]>, ParentType, ContextType>;
	scenario?: Resolver<ResolversTypes["Scenario"], ParentType, ContextType, RequireFields<ScenarioActionScenarioArgs, never>>;
	scenarioConnection?: Resolver<
		ResolversTypes["ScenarioActionScenarioConnection"],
		ParentType,
		ContextType,
		RequireFields<ScenarioActionScenarioConnectionArgs, never>
	>;
	startItemNumber?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
	startingPoint?: Resolver<Maybe<ResolversTypes["TimeframeStartingPoint"]>, ParentType, ContextType>;
	timeframe?: Resolver<Maybe<ResolversTypes["Timeframe"]>, ParentType, ContextType, RequireFields<ScenarioActionTimeframeArgs, never>>;
	timeframeConnection?: Resolver<
		ResolversTypes["ScenarioActionTimeframeConnection"],
		ParentType,
		ContextType,
		RequireFields<ScenarioActionTimeframeConnectionArgs, never>
	>;
	timeframeEnd?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
	timeframeEndDate?: Resolver<Maybe<ResolversTypes["Date"]>, ParentType, ContextType>;
	timeframeRangeType?: Resolver<Maybe<ResolversTypes["TimeframeRangeType"]>, ParentType, ContextType>;
	timeframeStart?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
	timeframeStartDate?: Resolver<Maybe<ResolversTypes["Date"]>, ParentType, ContextType>;
	treatment?: Resolver<Maybe<ResolversTypes["Treatment"]>, ParentType, ContextType, RequireFields<ScenarioActionTreatmentArgs, never>>;
	treatmentConnection?: Resolver<
		ResolversTypes["ScenarioActionTreatmentConnection"],
		ParentType,
		ContextType,
		RequireFields<ScenarioActionTreatmentConnectionArgs, never>
	>;
	value?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScenarioActionAggregateSelectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["ScenarioActionAggregateSelection"] = ResolversParentTypes["ScenarioActionAggregateSelection"]
> = {
	combinedItemTimeframeEnd?: Resolver<ResolversTypes["IntAggregateSelection"], ParentType, ContextType>;
	combinedItemTimeframeStart?: Resolver<ResolversTypes["IntAggregateSelection"], ParentType, ContextType>;
	count?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	endItemNumber?: Resolver<ResolversTypes["IntAggregateSelection"], ParentType, ContextType>;
	order?: Resolver<ResolversTypes["IntAggregateSelection"], ParentType, ContextType>;
	startItemNumber?: Resolver<ResolversTypes["IntAggregateSelection"], ParentType, ContextType>;
	timeframeEnd?: Resolver<ResolversTypes["IntAggregateSelection"], ParentType, ContextType>;
	timeframeStart?: Resolver<ResolversTypes["IntAggregateSelection"], ParentType, ContextType>;
	value?: Resolver<ResolversTypes["FloatAggregateSelection"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScenarioActionBrandConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["ScenarioActionBrandConnection"] = ResolversParentTypes["ScenarioActionBrandConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["ScenarioActionBrandRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScenarioActionBrandRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["ScenarioActionBrandRelationship"] = ResolversParentTypes["ScenarioActionBrandRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["Brand"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScenarioActionCategoriesConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["ScenarioActionCategoriesConnection"] = ResolversParentTypes["ScenarioActionCategoriesConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["ScenarioActionCategoriesRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScenarioActionCategoriesRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["ScenarioActionCategoriesRelationship"] = ResolversParentTypes["ScenarioActionCategoriesRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["DeviceProductCategory"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScenarioActionCombinedItemBrandsConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["ScenarioActionCombinedItemBrandsConnection"] = ResolversParentTypes["ScenarioActionCombinedItemBrandsConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["ScenarioActionCombinedItemBrandsRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScenarioActionCombinedItemBrandsRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["ScenarioActionCombinedItemBrandsRelationship"] = ResolversParentTypes["ScenarioActionCombinedItemBrandsRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["Brand"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScenarioActionCombinedItemTreatmentsConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["ScenarioActionCombinedItemTreatmentsConnection"] = ResolversParentTypes["ScenarioActionCombinedItemTreatmentsConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["ScenarioActionCombinedItemTreatmentsRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScenarioActionCombinedItemTreatmentsRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["ScenarioActionCombinedItemTreatmentsRelationship"] = ResolversParentTypes["ScenarioActionCombinedItemTreatmentsRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["Treatment"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScenarioActionDeviceKitsConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["ScenarioActionDeviceKitsConnection"] = ResolversParentTypes["ScenarioActionDeviceKitsConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["ScenarioActionDeviceKitsRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScenarioActionDeviceKitsRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["ScenarioActionDeviceKitsRelationship"] = ResolversParentTypes["ScenarioActionDeviceKitsRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["DeviceKit"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScenarioActionScenarioConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["ScenarioActionScenarioConnection"] = ResolversParentTypes["ScenarioActionScenarioConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["ScenarioActionScenarioRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScenarioActionScenarioRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["ScenarioActionScenarioRelationship"] = ResolversParentTypes["ScenarioActionScenarioRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["Scenario"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScenarioActionTimeframeConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["ScenarioActionTimeframeConnection"] = ResolversParentTypes["ScenarioActionTimeframeConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["ScenarioActionTimeframeRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScenarioActionTimeframeRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["ScenarioActionTimeframeRelationship"] = ResolversParentTypes["ScenarioActionTimeframeRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["Timeframe"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScenarioActionTreatmentConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["ScenarioActionTreatmentConnection"] = ResolversParentTypes["ScenarioActionTreatmentConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["ScenarioActionTreatmentRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScenarioActionTreatmentRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["ScenarioActionTreatmentRelationship"] = ResolversParentTypes["ScenarioActionTreatmentRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["Treatment"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScenarioActionsConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["ScenarioActionsConnection"] = ResolversParentTypes["ScenarioActionsConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["ScenarioActionsRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScenarioActionsRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["ScenarioActionsRelationship"] = ResolversParentTypes["ScenarioActionsRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["ScenarioAction"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScenarioAggregateSelectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["ScenarioAggregateSelection"] = ResolversParentTypes["ScenarioAggregateSelection"]
> = {
	count?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	group?: Resolver<ResolversTypes["IntAggregateSelection"], ParentType, ContextType>;
	order?: Resolver<ResolversTypes["IntAggregateSelection"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScenarioAgreementConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["ScenarioAgreementConnection"] = ResolversParentTypes["ScenarioAgreementConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["ScenarioAgreementRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScenarioAgreementRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["ScenarioAgreementRelationship"] = ResolversParentTypes["ScenarioAgreementRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["BaseAgreement"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScenarioConditionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["ScenarioCondition"] = ResolversParentTypes["ScenarioCondition"]
> = {
	adverseEvents?: Resolver<Maybe<Array<ResolversTypes["AdverseEventType"]>>, ParentType, ContextType>;
	brand?: Resolver<Maybe<ResolversTypes["Brand"]>, ParentType, ContextType, RequireFields<ScenarioConditionBrandArgs, never>>;
	brandConnection?: Resolver<
		ResolversTypes["ScenarioConditionBrandConnection"],
		ParentType,
		ContextType,
		RequireFields<ScenarioConditionBrandConnectionArgs, never>
	>;
	categories?: Resolver<Array<ResolversTypes["DeviceProductCategory"]>, ParentType, ContextType>;
	conditionStatus?: Resolver<Maybe<Array<ResolversTypes["OutcomeBasedStatus"]>>, ParentType, ContextType>;
	conditionType?: Resolver<ResolversTypes["ConditionType"], ParentType, ContextType>;
	consideredRating?: Resolver<Maybe<ResolversTypes["ConditionConsideredRating"]>, ParentType, ContextType>;
	consideredSecInterventionRate?: Resolver<Maybe<ResolversTypes["ConditionConsideredSecIntervention"]>, ParentType, ContextType>;
	deviceKits?: Resolver<
		Array<ResolversTypes["DeviceKit"]>,
		ParentType,
		ContextType,
		RequireFields<ScenarioConditionDeviceKitsArgs, never>
	>;
	deviceKitsConnection?: Resolver<
		ResolversTypes["ScenarioConditionDeviceKitsConnection"],
		ParentType,
		ContextType,
		RequireFields<ScenarioConditionDeviceKitsConnectionArgs, never>
	>;
	discontinuationReason?: Resolver<Maybe<ResolversTypes["TreatmentDiscontinuationReason"]>, ParentType, ContextType>;
	endRangeValue?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
	grades?: Resolver<Maybe<Array<ResolversTypes["AdverseEventGrades"]>>, ParentType, ContextType>;
	intervention?: Resolver<Maybe<ResolversTypes["InterventionType"]>, ParentType, ContextType>;
	interventionOccurrence?: Resolver<Maybe<ResolversTypes["InterventionOccurrence"]>, ParentType, ContextType>;
	occurence?: Resolver<Maybe<ResolversTypes["Occurrence"]>, ParentType, ContextType>;
	operator?: Resolver<Maybe<ResolversTypes["ArithmeticalOperator"]>, ParentType, ContextType>;
	order?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	patientScope?: Resolver<Maybe<ResolversTypes["PatientScope"]>, ParentType, ContextType>;
	reintervention?: Resolver<Maybe<ResolversTypes["Reintervention"]>, ParentType, ContextType>;
	responseInclusionType?: Resolver<Maybe<ResolversTypes["ResponseInclusionType"]>, ParentType, ContextType>;
	responseType?: Resolver<Maybe<ResolversTypes["ResponseType"]>, ParentType, ContextType>;
	scenario?: Resolver<ResolversTypes["Scenario"], ParentType, ContextType, RequireFields<ScenarioConditionScenarioArgs, never>>;
	scenarioConnection?: Resolver<
		ResolversTypes["ScenarioConditionScenarioConnection"],
		ParentType,
		ContextType,
		RequireFields<ScenarioConditionScenarioConnectionArgs, never>
	>;
	startingPoint?: Resolver<Maybe<ResolversTypes["TimeframeStartingPoint"]>, ParentType, ContextType>;
	timeframe?: Resolver<Maybe<ResolversTypes["Timeframe"]>, ParentType, ContextType, RequireFields<ScenarioConditionTimeframeArgs, never>>;
	timeframeConnection?: Resolver<
		ResolversTypes["ScenarioConditionTimeframeConnection"],
		ParentType,
		ContextType,
		RequireFields<ScenarioConditionTimeframeConnectionArgs, never>
	>;
	timeframeEnd?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
	timeframeEndDate?: Resolver<Maybe<ResolversTypes["Date"]>, ParentType, ContextType>;
	timeframeRangeType?: Resolver<Maybe<ResolversTypes["TimeframeRangeType"]>, ParentType, ContextType>;
	timeframeStart?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
	timeframeStartDate?: Resolver<Maybe<ResolversTypes["Date"]>, ParentType, ContextType>;
	treatment?: Resolver<Maybe<ResolversTypes["Treatment"]>, ParentType, ContextType, RequireFields<ScenarioConditionTreatmentArgs, never>>;
	treatmentConnection?: Resolver<
		ResolversTypes["ScenarioConditionTreatmentConnection"],
		ParentType,
		ContextType,
		RequireFields<ScenarioConditionTreatmentConnectionArgs, never>
	>;
	treatmentDurationAspect?: Resolver<Maybe<ResolversTypes["TreatmentDurationConditionAspect"]>, ParentType, ContextType>;
	value?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScenarioConditionAggregateSelectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["ScenarioConditionAggregateSelection"] = ResolversParentTypes["ScenarioConditionAggregateSelection"]
> = {
	count?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	endRangeValue?: Resolver<ResolversTypes["FloatAggregateSelection"], ParentType, ContextType>;
	order?: Resolver<ResolversTypes["IntAggregateSelection"], ParentType, ContextType>;
	timeframeEnd?: Resolver<ResolversTypes["IntAggregateSelection"], ParentType, ContextType>;
	timeframeStart?: Resolver<ResolversTypes["IntAggregateSelection"], ParentType, ContextType>;
	value?: Resolver<ResolversTypes["FloatAggregateSelection"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScenarioConditionBrandConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["ScenarioConditionBrandConnection"] = ResolversParentTypes["ScenarioConditionBrandConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["ScenarioConditionBrandRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScenarioConditionBrandRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["ScenarioConditionBrandRelationship"] = ResolversParentTypes["ScenarioConditionBrandRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["Brand"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScenarioConditionDeviceKitsConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["ScenarioConditionDeviceKitsConnection"] = ResolversParentTypes["ScenarioConditionDeviceKitsConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["ScenarioConditionDeviceKitsRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScenarioConditionDeviceKitsRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["ScenarioConditionDeviceKitsRelationship"] = ResolversParentTypes["ScenarioConditionDeviceKitsRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["DeviceKit"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScenarioConditionScenarioConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["ScenarioConditionScenarioConnection"] = ResolversParentTypes["ScenarioConditionScenarioConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["ScenarioConditionScenarioRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScenarioConditionScenarioRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["ScenarioConditionScenarioRelationship"] = ResolversParentTypes["ScenarioConditionScenarioRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["Scenario"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScenarioConditionTimeframeConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["ScenarioConditionTimeframeConnection"] = ResolversParentTypes["ScenarioConditionTimeframeConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["ScenarioConditionTimeframeRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScenarioConditionTimeframeRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["ScenarioConditionTimeframeRelationship"] = ResolversParentTypes["ScenarioConditionTimeframeRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["Timeframe"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScenarioConditionTreatmentConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["ScenarioConditionTreatmentConnection"] = ResolversParentTypes["ScenarioConditionTreatmentConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["ScenarioConditionTreatmentRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScenarioConditionTreatmentRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["ScenarioConditionTreatmentRelationship"] = ResolversParentTypes["ScenarioConditionTreatmentRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["Treatment"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScenarioConditionsConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["ScenarioConditionsConnection"] = ResolversParentTypes["ScenarioConditionsConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["ScenarioConditionsRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScenarioConditionsRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["ScenarioConditionsRelationship"] = ResolversParentTypes["ScenarioConditionsRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["ScenarioCondition"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScenarioInsightsUserContextResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["ScenarioInsightsUserContext"] = ResolversParentTypes["ScenarioInsightsUserContext"]
> = {
	__resolveType: TypeResolveFn<
		"BaseAgreementUserContextsRelationship" | "UserContextBaseAgreementContextRelationship" | "UserContextScenariosRelationship",
		ParentType,
		ContextType
	>;
	categoryInput?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	groups?: Resolver<Maybe<Array<Maybe<ResolversTypes["Int"]>>>, ParentType, ContextType>;
	rebateObjective?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	timeframeLabel?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
};

export type SentClaimRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["SentClaimRelationship"] = ResolversParentTypes["SentClaimRelationship"]
> = {
	__resolveType: TypeResolveFn<"PatientSentClaimRelationship", ParentType, ContextType>;
	date?: Resolver<Maybe<ResolversTypes["DateTime"]>, ParentType, ContextType>;
	timeStamp?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
};

export type StobActionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["StobAction"] = ResolversParentTypes["StobAction"]
> = {
	actionObject?: Resolver<Maybe<ResolversTypes["StobActionObject"]>, ParentType, ContextType>;
	actionType?: Resolver<Maybe<ResolversTypes["StobActionType"]>, ParentType, ContextType>;
	measureUnit?: Resolver<Maybe<ResolversTypes["StobActionMeasureUnit"]>, ParentType, ContextType>;
	order?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	scenario?: Resolver<ResolversTypes["StobScenario"], ParentType, ContextType, RequireFields<StobActionScenarioArgs, never>>;
	scenarioConnection?: Resolver<
		ResolversTypes["StobActionScenarioConnection"],
		ParentType,
		ContextType,
		RequireFields<StobActionScenarioConnectionArgs, never>
	>;
	timeframeEnd?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
	timeframeRelation?: Resolver<ResolversTypes["StobTimeframeRelation"], ParentType, ContextType>;
	timeframeStart?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	timeframeStartingPoint?: Resolver<ResolversTypes["StobTimeframeStartingPoint"], ParentType, ContextType>;
	value?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StobActionAggregateSelectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["StobActionAggregateSelection"] = ResolversParentTypes["StobActionAggregateSelection"]
> = {
	count?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	order?: Resolver<ResolversTypes["IntAggregateSelection"], ParentType, ContextType>;
	timeframeEnd?: Resolver<ResolversTypes["IntAggregateSelection"], ParentType, ContextType>;
	timeframeStart?: Resolver<ResolversTypes["IntAggregateSelection"], ParentType, ContextType>;
	value?: Resolver<ResolversTypes["FloatAggregateSelection"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StobActionScenarioConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["StobActionScenarioConnection"] = ResolversParentTypes["StobActionScenarioConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["StobActionScenarioRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StobActionScenarioRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["StobActionScenarioRelationship"] = ResolversParentTypes["StobActionScenarioRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["StobScenario"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StobConditionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["StobCondition"] = ResolversParentTypes["StobCondition"]
> = {
	conditionType?: Resolver<ResolversTypes["StobMeasureType"], ParentType, ContextType>;
	isNegative?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
	logicalCondition?: Resolver<Maybe<ResolversTypes["LogicalCondition"]>, ParentType, ContextType>;
	order?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	responseType?: Resolver<Maybe<ResolversTypes["IRResultOptions"]>, ParentType, ContextType>;
	scenario?: Resolver<ResolversTypes["StobScenario"], ParentType, ContextType, RequireFields<StobConditionScenarioArgs, never>>;
	scenarioConnection?: Resolver<
		ResolversTypes["StobConditionScenarioConnection"],
		ParentType,
		ContextType,
		RequireFields<StobConditionScenarioConnectionArgs, never>
	>;
	timeframeEnd?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
	timeframeRelation?: Resolver<ResolversTypes["StobTimeframeRelation"], ParentType, ContextType>;
	timeframeStart?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	timeframeStartingPoint?: Resolver<ResolversTypes["StobTimeframeStartingPoint"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StobConditionAggregateSelectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["StobConditionAggregateSelection"] = ResolversParentTypes["StobConditionAggregateSelection"]
> = {
	count?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	order?: Resolver<ResolversTypes["IntAggregateSelection"], ParentType, ContextType>;
	timeframeEnd?: Resolver<ResolversTypes["IntAggregateSelection"], ParentType, ContextType>;
	timeframeStart?: Resolver<ResolversTypes["IntAggregateSelection"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StobConditionScenarioConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["StobConditionScenarioConnection"] = ResolversParentTypes["StobConditionScenarioConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["StobConditionScenarioRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StobConditionScenarioRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["StobConditionScenarioRelationship"] = ResolversParentTypes["StobConditionScenarioRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["StobScenario"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StobContractResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["StobContract"] = ResolversParentTypes["StobContract"]
> = {
	adverseEvents?: Resolver<Maybe<Array<ResolversTypes["IRAdverseEvents"]>>, ParentType, ContextType>;
	adverseEventsMeasureName?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	buyerContractNumber?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	cases?: Resolver<Array<ResolversTypes["Case"]>, ParentType, ContextType, RequireFields<StobContractCasesArgs, never>>;
	casesConnection?: Resolver<
		ResolversTypes["StobContractCasesConnection"],
		ParentType,
		ContextType,
		RequireFields<StobContractCasesConnectionArgs, never>
	>;
	creatorOrganization?: Resolver<
		ResolversTypes["Organization"],
		ParentType,
		ContextType,
		RequireFields<StobContractCreatorOrganizationArgs, never>
	>;
	creatorOrganizationConnection?: Resolver<
		ResolversTypes["StobContractCreatorOrganizationConnection"],
		ParentType,
		ContextType,
		RequireFields<StobContractCreatorOrganizationConnectionArgs, never>
	>;
	currency?: Resolver<Maybe<ResolversTypes["Currency"]>, ParentType, ContextType, RequireFields<StobContractCurrencyArgs, never>>;
	currencyConnection?: Resolver<
		ResolversTypes["StobContractCurrencyConnection"],
		ParentType,
		ContextType,
		RequireFields<StobContractCurrencyConnectionArgs, never>
	>;
	customerNumber?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	description?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	detailsUrl?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	disease?: Resolver<Maybe<ResolversTypes["Disease"]>, ParentType, ContextType, RequireFields<StobContractDiseaseArgs, never>>;
	diseaseConnection?: Resolver<
		ResolversTypes["StobContractDiseaseConnection"],
		ParentType,
		ContextType,
		RequireFields<StobContractDiseaseConnectionArgs, never>
	>;
	documentationGapDays?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
	firstExecutionDate?: Resolver<Maybe<ResolversTypes["DateTime"]>, ParentType, ContextType>;
	formattedAmount?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	formattedCounterparties?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	formattedProducts?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	formattedTags?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	formattedValidityPeriod?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	grades?: Resolver<Maybe<Array<ResolversTypes["IRAdverseEventGrades"]>>, ParentType, ContextType>;
	id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
	indication?: Resolver<Maybe<ResolversTypes["Indication"]>, ParentType, ContextType, RequireFields<StobContractIndicationArgs, never>>;
	indicationConnection?: Resolver<
		ResolversTypes["StobContractIndicationConnection"],
		ParentType,
		ContextType,
		RequireFields<StobContractIndicationConnectionArgs, never>
	>;
	initialVersionId?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	lastExecutionDate?: Resolver<Maybe<ResolversTypes["DateTime"]>, ParentType, ContextType>;
	maxPatientNumber?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
	maxTargetValue?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
	name?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	notifications?: Resolver<
		Maybe<Array<Maybe<ResolversTypes["ContractNotification"]>>>,
		ParentType,
		ContextType,
		RequireFields<StobContractNotificationsArgs, never>
	>;
	notificationsConnection?: Resolver<
		ResolversTypes["StobContractNotificationsConnection"],
		ParentType,
		ContextType,
		RequireFields<StobContractNotificationsConnectionArgs, never>
	>;
	partner?: Resolver<Maybe<ResolversTypes["Organization"]>, ParentType, ContextType, RequireFields<StobContractPartnerArgs, never>>;
	partnerConnection?: Resolver<
		ResolversTypes["StobContractPartnerConnection"],
		ParentType,
		ContextType,
		RequireFields<StobContractPartnerConnectionArgs, never>
	>;
	recommendedForms?: Resolver<
		Maybe<Array<ResolversTypes["RecommendedForm"]>>,
		ParentType,
		ContextType,
		RequireFields<StobContractRecommendedFormsArgs, never>
	>;
	recommendedFormsConnection?: Resolver<
		ResolversTypes["StobContractRecommendedFormsConnection"],
		ParentType,
		ContextType,
		RequireFields<StobContractRecommendedFormsConnectionArgs, never>
	>;
	requiredForms?: Resolver<Maybe<Array<ResolversTypes["FormType"]>>, ParentType, ContextType>;
	responseEvaluationMeasureName?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	responseTypes?: Resolver<Maybe<Array<ResolversTypes["IRResultOptions"]>>, ParentType, ContextType>;
	scenarios?: Resolver<Array<ResolversTypes["StobScenario"]>, ParentType, ContextType, RequireFields<StobContractScenariosArgs, never>>;
	scenariosConnection?: Resolver<
		ResolversTypes["StobContractScenariosConnection"],
		ParentType,
		ContextType,
		RequireFields<StobContractScenariosConnectionArgs, never>
	>;
	statistics?: Resolver<
		Maybe<ResolversTypes["StobStatistics"]>,
		ParentType,
		ContextType,
		RequireFields<StobContractStatisticsArgs, never>
	>;
	statisticsConnection?: Resolver<
		ResolversTypes["StobContractStatisticsConnection"],
		ParentType,
		ContextType,
		RequireFields<StobContractStatisticsConnectionArgs, never>
	>;
	status?: Resolver<Maybe<ResolversTypes["ContractStatus"]>, ParentType, ContextType>;
	tags?: Resolver<Array<ResolversTypes["AgreementTag"]>, ParentType, ContextType, RequireFields<StobContractTagsArgs, never>>;
	tagsConnection?: Resolver<
		ResolversTypes["StobContractTagsConnection"],
		ParentType,
		ContextType,
		RequireFields<StobContractTagsConnectionArgs, never>
	>;
	tenantIds?: Resolver<Maybe<Array<ResolversTypes["String"]>>, ParentType, ContextType>;
	therapyDecisions?: Resolver<Maybe<Array<ResolversTypes["StobTherapyDecision"]>>, ParentType, ContextType>;
	treatmentBasePrice?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
	treatmentPrices?: Resolver<
		Array<ResolversTypes["Treatment"]>,
		ParentType,
		ContextType,
		RequireFields<StobContractTreatmentPricesArgs, never>
	>;
	treatmentPricesConnection?: Resolver<
		ResolversTypes["StobContractTreatmentPricesConnection"],
		ParentType,
		ContextType,
		RequireFields<StobContractTreatmentPricesConnectionArgs, never>
	>;
	validFromDate?: Resolver<ResolversTypes["Date"], ParentType, ContextType>;
	validToDate?: Resolver<ResolversTypes["Date"], ParentType, ContextType>;
	vendorContractNumber?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	vendorNumber?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StobContractAggregateSelectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["StobContractAggregateSelection"] = ResolversParentTypes["StobContractAggregateSelection"]
> = {
	adverseEventsMeasureName?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	buyerContractNumber?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	count?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	customerNumber?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	description?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	detailsUrl?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	documentationGapDays?: Resolver<ResolversTypes["IntAggregateSelection"], ParentType, ContextType>;
	firstExecutionDate?: Resolver<ResolversTypes["DateTimeAggregateSelection"], ParentType, ContextType>;
	formattedAmount?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	formattedCounterparties?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	formattedProducts?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	formattedTags?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	formattedValidityPeriod?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	id?: Resolver<ResolversTypes["IDAggregateSelection"], ParentType, ContextType>;
	initialVersionId?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	lastExecutionDate?: Resolver<ResolversTypes["DateTimeAggregateSelection"], ParentType, ContextType>;
	maxPatientNumber?: Resolver<ResolversTypes["IntAggregateSelection"], ParentType, ContextType>;
	maxTargetValue?: Resolver<ResolversTypes["FloatAggregateSelection"], ParentType, ContextType>;
	name?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	responseEvaluationMeasureName?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	treatmentBasePrice?: Resolver<ResolversTypes["FloatAggregateSelection"], ParentType, ContextType>;
	vendorContractNumber?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	vendorNumber?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StobContractCasesConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["StobContractCasesConnection"] = ResolversParentTypes["StobContractCasesConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["StobContractCasesRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StobContractCasesRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["StobContractCasesRelationship"] = ResolversParentTypes["StobContractCasesRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["Case"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StobContractCreatorOrganizationConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["StobContractCreatorOrganizationConnection"] = ResolversParentTypes["StobContractCreatorOrganizationConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["StobContractCreatorOrganizationRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StobContractCreatorOrganizationRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["StobContractCreatorOrganizationRelationship"] = ResolversParentTypes["StobContractCreatorOrganizationRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["Organization"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StobContractCurrencyConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["StobContractCurrencyConnection"] = ResolversParentTypes["StobContractCurrencyConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["StobContractCurrencyRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StobContractCurrencyRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["StobContractCurrencyRelationship"] = ResolversParentTypes["StobContractCurrencyRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["Currency"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StobContractDiseaseConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["StobContractDiseaseConnection"] = ResolversParentTypes["StobContractDiseaseConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["StobContractDiseaseRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StobContractDiseaseRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["StobContractDiseaseRelationship"] = ResolversParentTypes["StobContractDiseaseRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["Disease"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StobContractIndicationConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["StobContractIndicationConnection"] = ResolversParentTypes["StobContractIndicationConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["StobContractIndicationRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StobContractIndicationRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["StobContractIndicationRelationship"] = ResolversParentTypes["StobContractIndicationRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["Indication"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StobContractNotificationsConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["StobContractNotificationsConnection"] = ResolversParentTypes["StobContractNotificationsConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["StobContractNotificationsRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StobContractNotificationsRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["StobContractNotificationsRelationship"] = ResolversParentTypes["StobContractNotificationsRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["ContractNotification"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StobContractPartnerConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["StobContractPartnerConnection"] = ResolversParentTypes["StobContractPartnerConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["StobContractPartnerRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StobContractPartnerRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["StobContractPartnerRelationship"] = ResolversParentTypes["StobContractPartnerRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["Organization"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StobContractRecommendedFormsConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["StobContractRecommendedFormsConnection"] = ResolversParentTypes["StobContractRecommendedFormsConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["StobContractRecommendedFormsRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StobContractRecommendedFormsRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["StobContractRecommendedFormsRelationship"] = ResolversParentTypes["StobContractRecommendedFormsRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["RecommendedForm"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StobContractScenariosConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["StobContractScenariosConnection"] = ResolversParentTypes["StobContractScenariosConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["StobContractScenariosRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StobContractScenariosRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["StobContractScenariosRelationship"] = ResolversParentTypes["StobContractScenariosRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["StobScenario"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StobContractStatisticsConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["StobContractStatisticsConnection"] = ResolversParentTypes["StobContractStatisticsConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["StobContractStatisticsRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StobContractStatisticsRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["StobContractStatisticsRelationship"] = ResolversParentTypes["StobContractStatisticsRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["StobStatistics"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StobContractTagsConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["StobContractTagsConnection"] = ResolversParentTypes["StobContractTagsConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["StobContractTagsRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StobContractTagsRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["StobContractTagsRelationship"] = ResolversParentTypes["StobContractTagsRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["AgreementTag"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StobContractTreatmentPriceRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["StobContractTreatmentPriceRelationship"] = ResolversParentTypes["StobContractTreatmentPriceRelationship"]
> = {
	__resolveType: TypeResolveFn<"StobContractTreatmentPricesRelationship", ParentType, ContextType>;
	price?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
};

export type StobContractTreatmentPricesConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["StobContractTreatmentPricesConnection"] = ResolversParentTypes["StobContractTreatmentPricesConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["StobContractTreatmentPricesRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StobContractTreatmentPricesRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["StobContractTreatmentPricesRelationship"] = ResolversParentTypes["StobContractTreatmentPricesRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["Treatment"], ParentType, ContextType>;
	price?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StobScenarioResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["StobScenario"] = ResolversParentTypes["StobScenario"]
> = {
	actions?: Resolver<Array<ResolversTypes["StobAction"]>, ParentType, ContextType, RequireFields<StobScenarioActionsArgs, never>>;
	actionsConnection?: Resolver<
		ResolversTypes["StobScenarioActionsConnection"],
		ParentType,
		ContextType,
		RequireFields<StobScenarioActionsConnectionArgs, never>
	>;
	conditions?: Resolver<
		Array<ResolversTypes["StobCondition"]>,
		ParentType,
		ContextType,
		RequireFields<StobScenarioConditionsArgs, never>
	>;
	conditionsConnection?: Resolver<
		ResolversTypes["StobScenarioConditionsConnection"],
		ParentType,
		ContextType,
		RequireFields<StobScenarioConditionsConnectionArgs, never>
	>;
	order?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StobScenarioActionsConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["StobScenarioActionsConnection"] = ResolversParentTypes["StobScenarioActionsConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["StobScenarioActionsRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StobScenarioActionsRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["StobScenarioActionsRelationship"] = ResolversParentTypes["StobScenarioActionsRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["StobAction"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StobScenarioAggregateSelectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["StobScenarioAggregateSelection"] = ResolversParentTypes["StobScenarioAggregateSelection"]
> = {
	count?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	order?: Resolver<ResolversTypes["IntAggregateSelection"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StobScenarioConditionsConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["StobScenarioConditionsConnection"] = ResolversParentTypes["StobScenarioConditionsConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["StobScenarioConditionsRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StobScenarioConditionsRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["StobScenarioConditionsRelationship"] = ResolversParentTypes["StobScenarioConditionsRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["StobCondition"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StobStatisticsResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["StobStatistics"] = ResolversParentTypes["StobStatistics"]
> = {
	crCases?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
	patientsEnrolled?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
	patientsWithAe3and4?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
	patientsWithCrPrSd?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
	payableAgreementAmount?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
	prCases?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
	refundableAgreementAmount?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
	sdCases?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
	totalAgreementAmount?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
	totalCases?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
	traesGrade3?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
	traesGrade4?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
	treatmentDiscontinuedAe?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
	treatmentDiscontinuedPatientDeceased?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
	treatmentDiscontinuedProgressiveDisease?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
	treatmentDurationMonths?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StobStatisticsAggregateSelectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["StobStatisticsAggregateSelection"] = ResolversParentTypes["StobStatisticsAggregateSelection"]
> = {
	count?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	crCases?: Resolver<ResolversTypes["IntAggregateSelection"], ParentType, ContextType>;
	patientsEnrolled?: Resolver<ResolversTypes["IntAggregateSelection"], ParentType, ContextType>;
	patientsWithAe3and4?: Resolver<ResolversTypes["IntAggregateSelection"], ParentType, ContextType>;
	patientsWithCrPrSd?: Resolver<ResolversTypes["IntAggregateSelection"], ParentType, ContextType>;
	payableAgreementAmount?: Resolver<ResolversTypes["IntAggregateSelection"], ParentType, ContextType>;
	prCases?: Resolver<ResolversTypes["IntAggregateSelection"], ParentType, ContextType>;
	refundableAgreementAmount?: Resolver<ResolversTypes["IntAggregateSelection"], ParentType, ContextType>;
	sdCases?: Resolver<ResolversTypes["IntAggregateSelection"], ParentType, ContextType>;
	totalAgreementAmount?: Resolver<ResolversTypes["IntAggregateSelection"], ParentType, ContextType>;
	totalCases?: Resolver<ResolversTypes["IntAggregateSelection"], ParentType, ContextType>;
	traesGrade3?: Resolver<ResolversTypes["IntAggregateSelection"], ParentType, ContextType>;
	traesGrade4?: Resolver<ResolversTypes["IntAggregateSelection"], ParentType, ContextType>;
	treatmentDiscontinuedAe?: Resolver<ResolversTypes["IntAggregateSelection"], ParentType, ContextType>;
	treatmentDiscontinuedPatientDeceased?: Resolver<ResolversTypes["IntAggregateSelection"], ParentType, ContextType>;
	treatmentDiscontinuedProgressiveDisease?: Resolver<ResolversTypes["IntAggregateSelection"], ParentType, ContextType>;
	treatmentDurationMonths?: Resolver<ResolversTypes["IntAggregateSelection"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StringAggregateSelectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["StringAggregateSelection"] = ResolversParentTypes["StringAggregateSelection"]
> = {
	longest?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	shortest?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SubscriptionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["Subscription"] = ResolversParentTypes["Subscription"]
> = {
	agreementCreated?: SubscriptionResolver<Array<ResolversTypes["String"]>, "agreementCreated", ParentType, ContextType>;
	agreementRun?: SubscriptionResolver<ResolversTypes["String"], "agreementRun", ParentType, ContextType>;
	caseCreated?: SubscriptionResolver<Array<ResolversTypes["String"]>, "caseCreated", ParentType, ContextType>;
	documentCreated?: SubscriptionResolver<Array<ResolversTypes["String"]>, "documentCreated", ParentType, ContextType>;
	formCreated?: SubscriptionResolver<Array<ResolversTypes["String"]>, "formCreated", ParentType, ContextType>;
	recordUpdated?: SubscriptionResolver<Array<ResolversTypes["String"]>, "recordUpdated", ParentType, ContextType>;
	refundCreated?: SubscriptionResolver<Array<Maybe<ResolversTypes["String"]>>, "refundCreated", ParentType, ContextType>;
	refundThreadUpdated?: SubscriptionResolver<Array<ResolversTypes["String"]>, "refundThreadUpdated", ParentType, ContextType>;
	taskUpdated?: SubscriptionResolver<Array<ResolversTypes["String"]>, "taskUpdated", ParentType, ContextType>;
};

export type SummaryNotificationDueResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["SummaryNotificationDue"] = ResolversParentTypes["SummaryNotificationDue"]
> = {
	__resolveType: TypeResolveFn<"NotificationDueRelationship" | "UserNotificationDueRelationship", ParentType, ContextType>;
	dueDate?: Resolver<ResolversTypes["Date"], ParentType, ContextType>;
	message?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	timeStamp?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
};

export type TaskResolvers<ContextType = any, ParentType extends ResolversParentTypes["Task"] = ResolversParentTypes["Task"]> = {
	agreement?: Resolver<Maybe<ResolversTypes["Agreement"]>, ParentType, ContextType, RequireFields<TaskAgreementArgs, never>>;
	agreementConnection?: Resolver<
		ResolversTypes["TaskAgreementConnection"],
		ParentType,
		ContextType,
		RequireFields<TaskAgreementConnectionArgs, never>
	>;
	case?: Resolver<Maybe<ResolversTypes["Case"]>, ParentType, ContextType, RequireFields<TaskCaseArgs, never>>;
	caseConnection?: Resolver<ResolversTypes["TaskCaseConnection"], ParentType, ContextType, RequireFields<TaskCaseConnectionArgs, never>>;
	document?: Resolver<Maybe<ResolversTypes["Document"]>, ParentType, ContextType, RequireFields<TaskDocumentArgs, never>>;
	documentConnection?: Resolver<
		ResolversTypes["TaskDocumentConnection"],
		ParentType,
		ContextType,
		RequireFields<TaskDocumentConnectionArgs, never>
	>;
	id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
	message?: Resolver<Maybe<ResolversTypes["Message"]>, ParentType, ContextType, RequireFields<TaskMessageArgs, never>>;
	messageConnection?: Resolver<
		ResolversTypes["TaskMessageConnection"],
		ParentType,
		ContextType,
		RequireFields<TaskMessageConnectionArgs, never>
	>;
	tenantIds?: Resolver<Array<ResolversTypes["String"]>, ParentType, ContextType>;
	timeStamp?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
	triggerEventId?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	usersRelationship?: Resolver<Array<ResolversTypes["User"]>, ParentType, ContextType, RequireFields<TaskUsersRelationshipArgs, never>>;
	usersRelationshipConnection?: Resolver<
		ResolversTypes["TaskUsersRelationshipConnection"],
		ParentType,
		ContextType,
		RequireFields<TaskUsersRelationshipConnectionArgs, never>
	>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaskAggregateSelectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["TaskAggregateSelection"] = ResolversParentTypes["TaskAggregateSelection"]
> = {
	count?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	id?: Resolver<ResolversTypes["IDAggregateSelection"], ParentType, ContextType>;
	timeStamp?: Resolver<ResolversTypes["FloatAggregateSelection"], ParentType, ContextType>;
	triggerEventId?: Resolver<ResolversTypes["IntAggregateSelection"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaskAgreementConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["TaskAgreementConnection"] = ResolversParentTypes["TaskAgreementConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["TaskAgreementRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaskAgreementRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["TaskAgreementRelationship"] = ResolversParentTypes["TaskAgreementRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["Agreement"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaskCaseConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["TaskCaseConnection"] = ResolversParentTypes["TaskCaseConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["TaskCaseRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaskCaseRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["TaskCaseRelationship"] = ResolversParentTypes["TaskCaseRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	formDueOrOverdue?: Resolver<Maybe<ResolversTypes["FormType"]>, ParentType, ContextType>;
	node?: Resolver<ResolversTypes["Case"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaskDocumentConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["TaskDocumentConnection"] = ResolversParentTypes["TaskDocumentConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["TaskDocumentRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaskDocumentRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["TaskDocumentRelationship"] = ResolversParentTypes["TaskDocumentRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["Document"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaskMessageConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["TaskMessageConnection"] = ResolversParentTypes["TaskMessageConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["TaskMessageRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaskMessageRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["TaskMessageRelationship"] = ResolversParentTypes["TaskMessageRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	invoiceId?: Resolver<Maybe<ResolversTypes["ID"]>, ParentType, ContextType>;
	node?: Resolver<ResolversTypes["Message"], ParentType, ContextType>;
	refundId?: Resolver<Maybe<ResolversTypes["ID"]>, ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaskUsersRelationshipConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["TaskUsersRelationshipConnection"] = ResolversParentTypes["TaskUsersRelationshipConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["TaskUsersRelationshipRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaskUsersRelationshipRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["TaskUsersRelationshipRelationship"] = ResolversParentTypes["TaskUsersRelationshipRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	isCompleted?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["User"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TimeframeResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["Timeframe"] = ResolversParentTypes["Timeframe"]
> = {
	name?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	timeframeEnd?: Resolver<ResolversTypes["Date"], ParentType, ContextType>;
	timeframeStart?: Resolver<ResolversTypes["Date"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TimeframeAggregateSelectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["TimeframeAggregateSelection"] = ResolversParentTypes["TimeframeAggregateSelection"]
> = {
	count?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	name?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TimeframeRelatedEntityResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["TimeframeRelatedEntity"] = ResolversParentTypes["TimeframeRelatedEntity"]
> = {
	__resolveType: TypeResolveFn<"RecommendedForm" | "StobAction" | "StobCondition", ParentType, ContextType>;
	timeframeEnd?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
	timeframeRelation?: Resolver<ResolversTypes["StobTimeframeRelation"], ParentType, ContextType>;
	timeframeStart?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	timeframeStartingPoint?: Resolver<ResolversTypes["StobTimeframeStartingPoint"], ParentType, ContextType>;
};

export type TranslationResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["Translation"] = ResolversParentTypes["Translation"]
> = {
	key?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	languageCode?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	value?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TranslationAggregateSelectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["TranslationAggregateSelection"] = ResolversParentTypes["TranslationAggregateSelection"]
> = {
	count?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	key?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	languageCode?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	value?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TranslationsResultResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["TranslationsResult"] = ResolversParentTypes["TranslationsResult"]
> = {
	de?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	en?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TranslationsResultAggregateSelectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["TranslationsResultAggregateSelection"] = ResolversParentTypes["TranslationsResultAggregateSelection"]
> = {
	count?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	de?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	en?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TreatingPhysicianResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["TreatingPhysician"] = ResolversParentTypes["TreatingPhysician"]
> = {
	department?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	email?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	firstName?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	hospitalName?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	lastName?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	nr?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	phoneNo?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	place?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	postcode?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	street?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	title?: Resolver<Maybe<ResolversTypes["TreatingPhysicianTitle"]>, ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TreatingPhysicianAggregateSelectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["TreatingPhysicianAggregateSelection"] = ResolversParentTypes["TreatingPhysicianAggregateSelection"]
> = {
	count?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	department?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	email?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	firstName?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	hospitalName?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	lastName?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	nr?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	phoneNo?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	place?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	postcode?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	street?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TreatmentResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["Treatment"] = ResolversParentTypes["Treatment"]
> = {
	BagDossierNo?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	Code?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	FlagModal?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	FlagNarcosis?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	GTIN?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	LOT?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	Name?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	Partners?: Resolver<Array<ResolversTypes["Partner"]>, ParentType, ContextType, RequireFields<TreatmentPartnersArgs, never>>;
	PartnersConnection?: Resolver<
		ResolversTypes["TreatmentPartnersConnection"],
		ParentType,
		ContextType,
		RequireFields<TreatmentPartnersConnectionArgs, never>
	>;
	PharmaCode?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	PrevPharmacode?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	REF?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	Status?: Resolver<Maybe<ResolversTypes["PreparationStatus"]>, ParentType, ContextType, RequireFields<TreatmentStatusArgs, never>>;
	StatusConnection?: Resolver<
		ResolversTypes["TreatmentStatusConnection"],
		ParentType,
		ContextType,
		RequireFields<TreatmentStatusConnectionArgs, never>
	>;
	SwissmedicCategory?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	SwissmedicNo8?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	UDI?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	canBeMain?: Resolver<Maybe<ResolversTypes["Boolean"]>, ParentType, ContextType>;
	claim?: Resolver<Array<ResolversTypes["Claim"]>, ParentType, ContextType, RequireFields<TreatmentClaimArgs, never>>;
	claimConnection?: Resolver<
		ResolversTypes["TreatmentClaimConnection"],
		ParentType,
		ContextType,
		RequireFields<TreatmentClaimConnectionArgs, never>
	>;
	classificationSystem?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	exFactoryPrices?: Resolver<
		Array<ResolversTypes["ExFactoryPrice"]>,
		ParentType,
		ContextType,
		RequireFields<TreatmentExFactoryPricesArgs, never>
	>;
	exFactoryPricesConnection?: Resolver<
		ResolversTypes["TreatmentExFactoryPricesConnection"],
		ParentType,
		ContextType,
		RequireFields<TreatmentExFactoryPricesConnectionArgs, never>
	>;
	hasLimitations?: Resolver<
		Array<ResolversTypes["Limitation"]>,
		ParentType,
		ContextType,
		RequireFields<TreatmentHasLimitationsArgs, never>
	>;
	hasLimitationsConnection?: Resolver<
		ResolversTypes["TreatmentHasLimitationsConnection"],
		ParentType,
		ContextType,
		RequireFields<TreatmentHasLimitationsConnectionArgs, never>
	>;
	publicPrices?: Resolver<Array<ResolversTypes["PublicPrice"]>, ParentType, ContextType, RequireFields<TreatmentPublicPricesArgs, never>>;
	publicPricesConnection?: Resolver<
		ResolversTypes["TreatmentPublicPricesConnection"],
		ParentType,
		ContextType,
		RequireFields<TreatmentPublicPricesConnectionArgs, never>
	>;
	regulatedBy?: Resolver<ResolversTypes["Preparation"], ParentType, ContextType, RequireFields<TreatmentRegulatedByArgs, never>>;
	regulatedByConnection?: Resolver<
		ResolversTypes["TreatmentRegulatedByConnection"],
		ParentType,
		ContextType,
		RequireFields<TreatmentRegulatedByConnectionArgs, never>
	>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TreatmentAggregateSelectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["TreatmentAggregateSelection"] = ResolversParentTypes["TreatmentAggregateSelection"]
> = {
	BagDossierNo?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	Code?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	FlagModal?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	FlagNarcosis?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	GTIN?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	LOT?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	Name?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	PharmaCode?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	PrevPharmacode?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	REF?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	SwissmedicCategory?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	SwissmedicNo8?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	UDI?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	classificationSystem?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	count?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TreatmentClaimConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["TreatmentClaimConnection"] = ResolversParentTypes["TreatmentClaimConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["TreatmentClaimRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TreatmentClaimRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["TreatmentClaimRelationship"] = ResolversParentTypes["TreatmentClaimRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["Claim"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TreatmentExFactoryPricesConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["TreatmentExFactoryPricesConnection"] = ResolversParentTypes["TreatmentExFactoryPricesConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["TreatmentExFactoryPricesRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TreatmentExFactoryPricesRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["TreatmentExFactoryPricesRelationship"] = ResolversParentTypes["TreatmentExFactoryPricesRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["ExFactoryPrice"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TreatmentHasLimitationsConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["TreatmentHasLimitationsConnection"] = ResolversParentTypes["TreatmentHasLimitationsConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["TreatmentHasLimitationsRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TreatmentHasLimitationsRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["TreatmentHasLimitationsRelationship"] = ResolversParentTypes["TreatmentHasLimitationsRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["Limitation"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TreatmentPartnersConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["TreatmentPartnersConnection"] = ResolversParentTypes["TreatmentPartnersConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["TreatmentPartnersRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TreatmentPartnersRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["TreatmentPartnersRelationship"] = ResolversParentTypes["TreatmentPartnersRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["Partner"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TreatmentPatientResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["TreatmentPatient"] = ResolversParentTypes["TreatmentPatient"]
> = {
	months?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	noInactivePatients?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	noPatients?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TreatmentPatientAggregateSelectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["TreatmentPatientAggregateSelection"] = ResolversParentTypes["TreatmentPatientAggregateSelection"]
> = {
	count?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	months?: Resolver<ResolversTypes["IntAggregateSelection"], ParentType, ContextType>;
	noInactivePatients?: Resolver<ResolversTypes["IntAggregateSelection"], ParentType, ContextType>;
	noPatients?: Resolver<ResolversTypes["IntAggregateSelection"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TreatmentPrescriptionRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["TreatmentPrescriptionRelationship"] = ResolversParentTypes["TreatmentPrescriptionRelationship"]
> = {
	__resolveType: TypeResolveFn<"ContinuousBenefitPrescribedTreatmentsRelationship", ParentType, ContextType>;
	date?: Resolver<Maybe<ResolversTypes["Date"]>, ParentType, ContextType>;
	quantity?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
	status?: Resolver<Maybe<ResolversTypes["RecordStatus"]>, ParentType, ContextType>;
	uuid?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
};

export type TreatmentPublicPricesConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["TreatmentPublicPricesConnection"] = ResolversParentTypes["TreatmentPublicPricesConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["TreatmentPublicPricesRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TreatmentPublicPricesRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["TreatmentPublicPricesRelationship"] = ResolversParentTypes["TreatmentPublicPricesRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["PublicPrice"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TreatmentRegulatedByConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["TreatmentRegulatedByConnection"] = ResolversParentTypes["TreatmentRegulatedByConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["TreatmentRegulatedByRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TreatmentRegulatedByRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["TreatmentRegulatedByRelationship"] = ResolversParentTypes["TreatmentRegulatedByRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["Preparation"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TreatmentStatusConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["TreatmentStatusConnection"] = ResolversParentTypes["TreatmentStatusConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["TreatmentStatusRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TreatmentStatusRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["TreatmentStatusRelationship"] = ResolversParentTypes["TreatmentStatusRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["PreparationStatus"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateAdverseEventsOccurenceReportsMutationResponseResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["UpdateAdverseEventsOccurenceReportsMutationResponse"] = ResolversParentTypes["UpdateAdverseEventsOccurenceReportsMutationResponse"]
> = {
	adverseEventsOccurenceReports?: Resolver<Array<ResolversTypes["AdverseEventsOccurenceReport"]>, ParentType, ContextType>;
	info?: Resolver<ResolversTypes["UpdateInfo"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateInfoResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["UpdateInfo"] = ResolversParentTypes["UpdateInfo"]
> = {
	bookmark?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	nodesCreated?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	nodesDeleted?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	relationshipsCreated?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	relationshipsDeleted?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateInitialResponseReviewReportsMutationResponseResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["UpdateInitialResponseReviewReportsMutationResponse"] = ResolversParentTypes["UpdateInitialResponseReviewReportsMutationResponse"]
> = {
	info?: Resolver<ResolversTypes["UpdateInfo"], ParentType, ContextType>;
	initialResponseReviewReports?: Resolver<Array<ResolversTypes["InitialResponseReviewReport"]>, ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateReasonOfTreatmentDiscontinuationReportsMutationResponseResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["UpdateReasonOfTreatmentDiscontinuationReportsMutationResponse"] = ResolversParentTypes["UpdateReasonOfTreatmentDiscontinuationReportsMutationResponse"]
> = {
	info?: Resolver<ResolversTypes["UpdateInfo"], ParentType, ContextType>;
	reasonOfTreatmentDiscontinuationReports?: Resolver<
		Array<ResolversTypes["ReasonOfTreatmentDiscontinuationReport"]>,
		ParentType,
		ContextType
	>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateUsersMutationResponseResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["UpdateUsersMutationResponse"] = ResolversParentTypes["UpdateUsersMutationResponse"]
> = {
	info?: Resolver<ResolversTypes["UpdateInfo"], ParentType, ContextType>;
	users?: Resolver<Array<ResolversTypes["User"]>, ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserResolvers<ContextType = any, ParentType extends ResolversParentTypes["User"] = ResolversParentTypes["User"]> = {
	claims?: Resolver<Array<Maybe<ResolversTypes["Claim"]>>, ParentType, ContextType, RequireFields<UserClaimsArgs, never>>;
	claimsConnection?: Resolver<
		ResolversTypes["UserClaimsConnection"],
		ParentType,
		ContextType,
		RequireFields<UserClaimsConnectionArgs, never>
	>;
	context?: Resolver<Maybe<ResolversTypes["UserContext"]>, ParentType, ContextType, RequireFields<UserContextArgs, never>>;
	contextConnection?: Resolver<
		ResolversTypes["UserContextConnection"],
		ParentType,
		ContextType,
		RequireFields<UserContextConnectionArgs, never>
	>;
	email?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	firstName?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
	lastName?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	mentions?: Resolver<Maybe<Array<Maybe<ResolversTypes["Message"]>>>, ParentType, ContextType, RequireFields<UserMentionsArgs, never>>;
	mentionsConnection?: Resolver<
		ResolversTypes["UserMentionsConnection"],
		ParentType,
		ContextType,
		RequireFields<UserMentionsConnectionArgs, never>
	>;
	notificationDue?: Resolver<
		Array<ResolversTypes["Notification"]>,
		ParentType,
		ContextType,
		RequireFields<UserNotificationDueArgs, never>
	>;
	notificationDueConnection?: Resolver<
		ResolversTypes["UserNotificationDueConnection"],
		ParentType,
		ContextType,
		RequireFields<UserNotificationDueConnectionArgs, never>
	>;
	notified?: Resolver<Array<ResolversTypes["Notification"]>, ParentType, ContextType, RequireFields<UserNotifiedArgs, never>>;
	notifiedConnection?: Resolver<
		ResolversTypes["UserNotifiedConnection"],
		ParentType,
		ContextType,
		RequireFields<UserNotifiedConnectionArgs, never>
	>;
	organization?: Resolver<ResolversTypes["Organization"], ParentType, ContextType>;
	patients?: Resolver<Array<Maybe<ResolversTypes["Patient"]>>, ParentType, ContextType, RequireFields<UserPatientsArgs, never>>;
	patientsConnection?: Resolver<
		ResolversTypes["UserPatientsConnection"],
		ParentType,
		ContextType,
		RequireFields<UserPatientsConnectionArgs, never>
	>;
	preferredLanguage?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	reads?: Resolver<Array<ResolversTypes["String"]>, ParentType, ContextType>;
	sentMessage?: Resolver<Maybe<ResolversTypes["Message"]>, ParentType, ContextType, RequireFields<UserSentMessageArgs, never>>;
	sentMessageConnection?: Resolver<
		ResolversTypes["UserSentMessageConnection"],
		ParentType,
		ContextType,
		RequireFields<UserSentMessageConnectionArgs, never>
	>;
	subscribed?: Resolver<Array<ResolversTypes["Notification"]>, ParentType, ContextType, RequireFields<UserSubscribedArgs, never>>;
	subscribedConnection?: Resolver<
		ResolversTypes["UserSubscribedConnection"],
		ParentType,
		ContextType,
		RequireFields<UserSubscribedConnectionArgs, never>
	>;
	tasks?: Resolver<Array<ResolversTypes["Task"]>, ParentType, ContextType, RequireFields<UserTasksArgs, never>>;
	tasksConnection?: Resolver<
		ResolversTypes["UserTasksConnection"],
		ParentType,
		ContextType,
		RequireFields<UserTasksConnectionArgs, never>
	>;
	tenantId?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	writes?: Resolver<Array<ResolversTypes["String"]>, ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserAggregateSelectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["UserAggregateSelection"] = ResolversParentTypes["UserAggregateSelection"]
> = {
	count?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	email?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	firstName?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	id?: Resolver<ResolversTypes["IDAggregateSelection"], ParentType, ContextType>;
	lastName?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	preferredLanguage?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	tenantId?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserClaimsConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["UserClaimsConnection"] = ResolversParentTypes["UserClaimsConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["UserClaimsRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserClaimsRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["UserClaimsRelationship"] = ResolversParentTypes["UserClaimsRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["Claim"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserContextResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["UserContext"] = ResolversParentTypes["UserContext"]
> = {
	baseAgreementContext?: Resolver<
		Array<ResolversTypes["BaseAgreement"]>,
		ParentType,
		ContextType,
		RequireFields<UserContextBaseAgreementContextArgs, never>
	>;
	baseAgreementContextConnection?: Resolver<
		ResolversTypes["UserContextBaseAgreementContextConnection"],
		ParentType,
		ContextType,
		RequireFields<UserContextBaseAgreementContextConnectionArgs, never>
	>;
	email?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	filtersAgreements?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	filtersCases?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	filtersDataForms?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	filtersDataRecords?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	filtersDocuments?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	filtersRefunds?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	scenarios?: Resolver<Array<ResolversTypes["Scenario"]>, ParentType, ContextType, RequireFields<UserContextScenariosArgs, never>>;
	scenariosConnection?: Resolver<
		ResolversTypes["UserContextScenariosConnection"],
		ParentType,
		ContextType,
		RequireFields<UserContextScenariosConnectionArgs, never>
	>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserContextAggregateSelectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["UserContextAggregateSelection"] = ResolversParentTypes["UserContextAggregateSelection"]
> = {
	count?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	email?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	filtersAgreements?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	filtersCases?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	filtersDataForms?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	filtersDataRecords?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	filtersDocuments?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	filtersRefunds?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserContextBaseAgreementContextConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["UserContextBaseAgreementContextConnection"] = ResolversParentTypes["UserContextBaseAgreementContextConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["UserContextBaseAgreementContextRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserContextBaseAgreementContextRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["UserContextBaseAgreementContextRelationship"] = ResolversParentTypes["UserContextBaseAgreementContextRelationship"]
> = {
	categoryInput?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	groups?: Resolver<Maybe<Array<Maybe<ResolversTypes["Int"]>>>, ParentType, ContextType>;
	node?: Resolver<ResolversTypes["BaseAgreement"], ParentType, ContextType>;
	rebateObjective?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	timeframeLabel?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserContextConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["UserContextConnection"] = ResolversParentTypes["UserContextConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["UserContextRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserContextRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["UserContextRelationship"] = ResolversParentTypes["UserContextRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["UserContext"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserContextScenariosConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["UserContextScenariosConnection"] = ResolversParentTypes["UserContextScenariosConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["UserContextScenariosRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserContextScenariosRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["UserContextScenariosRelationship"] = ResolversParentTypes["UserContextScenariosRelationship"]
> = {
	categoryInput?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	groups?: Resolver<Maybe<Array<Maybe<ResolversTypes["Int"]>>>, ParentType, ContextType>;
	node?: Resolver<ResolversTypes["Scenario"], ParentType, ContextType>;
	rebateObjective?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	timeframeLabel?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserMentionsConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["UserMentionsConnection"] = ResolversParentTypes["UserMentionsConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["UserMentionsRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserMentionsRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["UserMentionsRelationship"] = ResolversParentTypes["UserMentionsRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["Message"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserMessageRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["UserMessageRelationship"] = ResolversParentTypes["UserMessageRelationship"]
> = {
	__resolveType: TypeResolveFn<"TaskMessageRelationship", ParentType, ContextType>;
	invoiceId?: Resolver<Maybe<ResolversTypes["ID"]>, ParentType, ContextType>;
	refundId?: Resolver<Maybe<ResolversTypes["ID"]>, ParentType, ContextType>;
};

export type UserNotificationDueConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["UserNotificationDueConnection"] = ResolversParentTypes["UserNotificationDueConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["UserNotificationDueRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserNotificationDueRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["UserNotificationDueRelationship"] = ResolversParentTypes["UserNotificationDueRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	dueDate?: Resolver<ResolversTypes["Date"], ParentType, ContextType>;
	message?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["Notification"], ParentType, ContextType>;
	timeStamp?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserNotificationRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["UserNotificationRelationship"] = ResolversParentTypes["UserNotificationRelationship"]
> = {
	__resolveType: TypeResolveFn<"NotificationNotifiedRelationship" | "UserNotifiedRelationship", ParentType, ContextType>;
	data?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	emailSentDate?: Resolver<Maybe<ResolversTypes["Date"]>, ParentType, ContextType>;
	message?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	timeStamp?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
};

export type UserNotifiedConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["UserNotifiedConnection"] = ResolversParentTypes["UserNotifiedConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["UserNotifiedRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserNotifiedRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["UserNotifiedRelationship"] = ResolversParentTypes["UserNotifiedRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	data?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	emailSentDate?: Resolver<Maybe<ResolversTypes["Date"]>, ParentType, ContextType>;
	message?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["Notification"], ParentType, ContextType>;
	timeStamp?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserOrgSettingsDataResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["UserOrgSettingsData"] = ResolversParentTypes["UserOrgSettingsData"]
> = {
	hasOperativeDataAccess?: Resolver<Maybe<ResolversTypes["Boolean"]>, ParentType, ContextType>;
	role?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	userId?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserOrgSettingsDataAggregateSelectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["UserOrgSettingsDataAggregateSelection"] = ResolversParentTypes["UserOrgSettingsDataAggregateSelection"]
> = {
	count?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	role?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	userId?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserOrganizationInfoResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["UserOrganizationInfo"] = ResolversParentTypes["UserOrganizationInfo"]
> = {
	firstName?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	id?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	lastName?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserOrganizationInfoAggregateSelectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["UserOrganizationInfoAggregateSelection"] = ResolversParentTypes["UserOrganizationInfoAggregateSelection"]
> = {
	count?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	firstName?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	id?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	lastName?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserPatientsConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["UserPatientsConnection"] = ResolversParentTypes["UserPatientsConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["UserPatientsRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserPatientsRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["UserPatientsRelationship"] = ResolversParentTypes["UserPatientsRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["Patient"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserPersonalInfoResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["UserPersonalInfo"] = ResolversParentTypes["UserPersonalInfo"]
> = {
	firstName?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	lastName?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	preferredLanguage?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserPersonalInfoAggregateSelectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["UserPersonalInfoAggregateSelection"] = ResolversParentTypes["UserPersonalInfoAggregateSelection"]
> = {
	count?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	firstName?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	lastName?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	preferredLanguage?: Resolver<ResolversTypes["StringAggregateSelection"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserSentMessageConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["UserSentMessageConnection"] = ResolversParentTypes["UserSentMessageConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["UserSentMessageRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserSentMessageRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["UserSentMessageRelationship"] = ResolversParentTypes["UserSentMessageRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["Message"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserSubscribedConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["UserSubscribedConnection"] = ResolversParentTypes["UserSubscribedConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["UserSubscribedRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserSubscribedRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["UserSubscribedRelationship"] = ResolversParentTypes["UserSubscribedRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	node?: Resolver<ResolversTypes["Notification"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserTaskPropertiesResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["UserTaskProperties"] = ResolversParentTypes["UserTaskProperties"]
> = {
	__resolveType: TypeResolveFn<"UserTasksRelationship", ParentType, ContextType>;
	isCompleted?: Resolver<Maybe<ResolversTypes["Boolean"]>, ParentType, ContextType>;
};

export type UserTaskRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["UserTaskRelationship"] = ResolversParentTypes["UserTaskRelationship"]
> = {
	__resolveType: TypeResolveFn<"TaskUsersRelationshipRelationship", ParentType, ContextType>;
	isCompleted?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
};

export type UserTasksConnectionResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["UserTasksConnection"] = ResolversParentTypes["UserTasksConnection"]
> = {
	edges?: Resolver<Array<ResolversTypes["UserTasksRelationship"]>, ParentType, ContextType>;
	pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
	totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserTasksRelationshipResolvers<
	ContextType = any,
	ParentType extends ResolversParentTypes["UserTasksRelationship"] = ResolversParentTypes["UserTasksRelationship"]
> = {
	cursor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
	isCompleted?: Resolver<Maybe<ResolversTypes["Boolean"]>, ParentType, ContextType>;
	node?: Resolver<ResolversTypes["Task"], ParentType, ContextType>;
	__isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Resolvers<ContextType = any> = {
	AdverseEvent?: AdverseEventResolvers<ContextType>;
	AdverseEventAggregateSelection?: AdverseEventAggregateSelectionResolvers<ContextType>;
	AdverseEventCounterparties?: AdverseEventCounterpartiesResolvers<ContextType>;
	AdverseEventCounterpartiesAggregateSelection?: AdverseEventCounterpartiesAggregateSelectionResolvers<ContextType>;
	AdverseEventInitialResponseConnection?: AdverseEventInitialResponseConnectionResolvers<ContextType>;
	AdverseEventInitialResponseRelationship?: AdverseEventInitialResponseRelationshipResolvers<ContextType>;
	AdverseEventReport?: AdverseEventReportResolvers<ContextType>;
	AdverseEventReportAggregateSelection?: AdverseEventReportAggregateSelectionResolvers<ContextType>;
	AdverseEventsOccurenceReport?: AdverseEventsOccurenceReportResolvers<ContextType>;
	AdverseEventsOccurenceReportAggregateSelection?: AdverseEventsOccurenceReportAggregateSelectionResolvers<ContextType>;
	Agreement?: AgreementResolvers<ContextType>;
	AgreementAggregateSelection?: AgreementAggregateSelectionResolvers<ContextType>;
	AgreementCounterpartyRolesConnection?: AgreementCounterpartyRolesConnectionResolvers<ContextType>;
	AgreementCounterpartyRolesRelationship?: AgreementCounterpartyRolesRelationshipResolvers<ContextType>;
	AgreementCurrencyConnection?: AgreementCurrencyConnectionResolvers<ContextType>;
	AgreementCurrencyRelationship?: AgreementCurrencyRelationshipResolvers<ContextType>;
	AgreementDecision?: AgreementDecisionResolvers<ContextType>;
	AgreementDecisionAggregateSelection?: AgreementDecisionAggregateSelectionResolvers<ContextType>;
	AgreementDecisionAsOfConnection?: AgreementDecisionAsOfConnectionResolvers<ContextType>;
	AgreementDecisionAsOfRelationship?: AgreementDecisionAsOfRelationshipResolvers<ContextType>;
	AgreementDecisionMadeByConnection?: AgreementDecisionMadeByConnectionResolvers<ContextType>;
	AgreementDecisionMadeByRelationship?: AgreementDecisionMadeByRelationshipResolvers<ContextType>;
	AgreementDeviceAlternativeSetsConnection?: AgreementDeviceAlternativeSetsConnectionResolvers<ContextType>;
	AgreementDeviceAlternativeSetsRelationship?: AgreementDeviceAlternativeSetsRelationshipResolvers<ContextType>;
	AgreementFinancialSummaryColumnRelationship?: AgreementFinancialSummaryColumnRelationshipResolvers<ContextType>;
	AgreementReport?: AgreementReportResolvers<ContextType>;
	AgreementReportAggregateSelection?: AgreementReportAggregateSelectionResolvers<ContextType>;
	AgreementSpecificRole?: AgreementSpecificRoleResolvers<ContextType>;
	AgreementSpecificRoleAggregateSelection?: AgreementSpecificRoleAggregateSelectionResolvers<ContextType>;
	AgreementStatusTransition?: AgreementStatusTransitionResolvers<ContextType>;
	AgreementStatusTransitionAggregateSelection?: AgreementStatusTransitionAggregateSelectionResolvers<ContextType>;
	AgreementStatusTransitionCausedByConnection?: AgreementStatusTransitionCausedByConnectionResolvers<ContextType>;
	AgreementStatusTransitionCausedByRelationship?: AgreementStatusTransitionCausedByRelationshipResolvers<ContextType>;
	AgreementTag?: AgreementTagResolvers<ContextType>;
	AgreementTagAggregateSelection?: AgreementTagAggregateSelectionResolvers<ContextType>;
	AgreementTagDefaultUserRolesConnection?: AgreementTagDefaultUserRolesConnectionResolvers<ContextType>;
	AgreementTagDefaultUserRolesRelationship?: AgreementTagDefaultUserRolesRelationshipResolvers<ContextType>;
	AgreementTagUserRoleRelationship?: AgreementTagUserRoleRelationshipResolvers<ContextType>;
	AgreementTagsConnection?: AgreementTagsConnectionResolvers<ContextType>;
	AgreementTagsRelationship?: AgreementTagsRelationshipResolvers<ContextType>;
	AgreementUserRoleRelationship?: AgreementUserRoleRelationshipResolvers<ContextType>;
	AgreementUserRolesConnection?: AgreementUserRolesConnectionResolvers<ContextType>;
	AgreementUserRolesRelationship?: AgreementUserRolesRelationshipResolvers<ContextType>;
	AgreementWorkflowsConnection?: AgreementWorkflowsConnectionResolvers<ContextType>;
	AgreementWorkflowsRelationship?: AgreementWorkflowsRelationshipResolvers<ContextType>;
	AverageLAPressureAndLAVolumeRow?: AverageLaPressureAndLaVolumeRowResolvers<ContextType>;
	AverageLAPressureAndLAVolumeRowAggregateSelection?: AverageLaPressureAndLaVolumeRowAggregateSelectionResolvers<ContextType>;
	BaseAgreement?: BaseAgreementResolvers<ContextType>;
	BaseAgreementAddedByConnection?: BaseAgreementAddedByConnectionResolvers<ContextType>;
	BaseAgreementAddedByRelationship?: BaseAgreementAddedByRelationshipResolvers<ContextType>;
	BaseAgreementAggregateSelection?: BaseAgreementAggregateSelectionResolvers<ContextType>;
	BaseAgreementCategoriesConnection?: BaseAgreementCategoriesConnectionResolvers<ContextType>;
	BaseAgreementCategoriesRelationship?: BaseAgreementCategoriesRelationshipResolvers<ContextType>;
	BaseAgreementCategoryDiscountCaps?: BaseAgreementCategoryDiscountCapsResolvers<ContextType>;
	BaseAgreementCounterpartiesConnection?: BaseAgreementCounterpartiesConnectionResolvers<ContextType>;
	BaseAgreementCounterpartiesRelationship?: BaseAgreementCounterpartiesRelationshipResolvers<ContextType>;
	BaseAgreementCounterpartyRelationship?: BaseAgreementCounterpartyRelationshipResolvers<ContextType>;
	BaseAgreementCurrencyConnection?: BaseAgreementCurrencyConnectionResolvers<ContextType>;
	BaseAgreementCurrencyRelationship?: BaseAgreementCurrencyRelationshipResolvers<ContextType>;
	BaseAgreementDataContainersConnection?: BaseAgreementDataContainersConnectionResolvers<ContextType>;
	BaseAgreementDataContainersRelationship?: BaseAgreementDataContainersRelationshipResolvers<ContextType>;
	BaseAgreementDataSourceConnection?: BaseAgreementDataSourceConnectionResolvers<ContextType>;
	BaseAgreementDataSourceRelationship?: BaseAgreementDataSourceRelationshipResolvers<ContextType>;
	BaseAgreementDecisionsConnection?: BaseAgreementDecisionsConnectionResolvers<ContextType>;
	BaseAgreementDecisionsRelationship?: BaseAgreementDecisionsRelationshipResolvers<ContextType>;
	BaseAgreementDeviceAlternativeSetsConnection?: BaseAgreementDeviceAlternativeSetsConnectionResolvers<ContextType>;
	BaseAgreementDeviceAlternativeSetsRelationship?: BaseAgreementDeviceAlternativeSetsRelationshipResolvers<ContextType>;
	BaseAgreementDeviceKitDiscountCaps?: BaseAgreementDeviceKitDiscountCapsResolvers<ContextType>;
	BaseAgreementDiscountCapsCategoriesConnection?: BaseAgreementDiscountCapsCategoriesConnectionResolvers<ContextType>;
	BaseAgreementDiscountCapsCategoriesRelationship?: BaseAgreementDiscountCapsCategoriesRelationshipResolvers<ContextType>;
	BaseAgreementDiscountCapsDeviceKitsConnection?: BaseAgreementDiscountCapsDeviceKitsConnectionResolvers<ContextType>;
	BaseAgreementDiscountCapsDeviceKitsRelationship?: BaseAgreementDiscountCapsDeviceKitsRelationshipResolvers<ContextType>;
	BaseAgreementEligibilityConditionRelationship?: BaseAgreementEligibilityConditionRelationshipResolvers<ContextType>;
	BaseAgreementEligibilityConditionSetsConnection?: BaseAgreementEligibilityConditionSetsConnectionResolvers<ContextType>;
	BaseAgreementEligibilityConditionSetsRelationship?: BaseAgreementEligibilityConditionSetsRelationshipResolvers<ContextType>;
	BaseAgreementEnrollingConditionSetsConnection?: BaseAgreementEnrollingConditionSetsConnectionResolvers<ContextType>;
	BaseAgreementEnrollingConditionSetsRelationship?: BaseAgreementEnrollingConditionSetsRelationshipResolvers<ContextType>;
	BaseAgreementEnrollingPeriodsConnection?: BaseAgreementEnrollingPeriodsConnectionResolvers<ContextType>;
	BaseAgreementEnrollingPeriodsRelationship?: BaseAgreementEnrollingPeriodsRelationshipResolvers<ContextType>;
	BaseAgreementFinancialSummaryConfigConnection?: BaseAgreementFinancialSummaryConfigConnectionResolvers<ContextType>;
	BaseAgreementFinancialSummaryConfigRelationship?: BaseAgreementFinancialSummaryConfigRelationshipResolvers<ContextType>;
	BaseAgreementInitialVersionConnection?: BaseAgreementInitialVersionConnectionResolvers<ContextType>;
	BaseAgreementInitialVersionRelationship?: BaseAgreementInitialVersionRelationshipResolvers<ContextType>;
	BaseAgreementNamedTimeRangesConnection?: BaseAgreementNamedTimeRangesConnectionResolvers<ContextType>;
	BaseAgreementNamedTimeRangesRelationship?: BaseAgreementNamedTimeRangesRelationshipResolvers<ContextType>;
	BaseAgreementNextVersionsConnection?: BaseAgreementNextVersionsConnectionResolvers<ContextType>;
	BaseAgreementNextVersionsRelationship?: BaseAgreementNextVersionsRelationshipResolvers<ContextType>;
	BaseAgreementProcessedDeviceRecordsConnection?: BaseAgreementProcessedDeviceRecordsConnectionResolvers<ContextType>;
	BaseAgreementProcessedDeviceRecordsRelationship?: BaseAgreementProcessedDeviceRecordsRelationshipResolvers<ContextType>;
	BaseAgreementPushedByConnection?: BaseAgreementPushedByConnectionResolvers<ContextType>;
	BaseAgreementPushedByRelationship?: BaseAgreementPushedByRelationshipResolvers<ContextType>;
	BaseAgreementScenariosConnection?: BaseAgreementScenariosConnectionResolvers<ContextType>;
	BaseAgreementScenariosRelationship?: BaseAgreementScenariosRelationshipResolvers<ContextType>;
	BaseAgreementStatusTransitionsConnection?: BaseAgreementStatusTransitionsConnectionResolvers<ContextType>;
	BaseAgreementStatusTransitionsRelationship?: BaseAgreementStatusTransitionsRelationshipResolvers<ContextType>;
	BaseAgreementTagsConnection?: BaseAgreementTagsConnectionResolvers<ContextType>;
	BaseAgreementTagsRelationship?: BaseAgreementTagsRelationshipResolvers<ContextType>;
	BaseAgreementTreatmentPriceRelationship?: BaseAgreementTreatmentPriceRelationshipResolvers<ContextType>;
	BaseAgreementTreatmentPricesConnection?: BaseAgreementTreatmentPricesConnectionResolvers<ContextType>;
	BaseAgreementTreatmentPricesRelationship?: BaseAgreementTreatmentPricesRelationshipResolvers<ContextType>;
	BaseAgreementUserContextsConnection?: BaseAgreementUserContextsConnectionResolvers<ContextType>;
	BaseAgreementUserContextsRelationship?: BaseAgreementUserContextsRelationshipResolvers<ContextType>;
	BaseAgreementUserRoleRelationship?: BaseAgreementUserRoleRelationshipResolvers<ContextType>;
	BaseAgreementUserRolesConnection?: BaseAgreementUserRolesConnectionResolvers<ContextType>;
	BaseAgreementUserRolesRelationship?: BaseAgreementUserRolesRelationshipResolvers<ContextType>;
	Brand?: BrandResolvers<ContextType>;
	BrandAggregateSelection?: BrandAggregateSelectionResolvers<ContextType>;
	BrandPreparationsConnection?: BrandPreparationsConnectionResolvers<ContextType>;
	BrandPreparationsRelationship?: BrandPreparationsRelationshipResolvers<ContextType>;
	CAOBAgreementReport?: CaobAgreementReportResolvers<ContextType>;
	CAOBAgreementReportAggregateSelection?: CaobAgreementReportAggregateSelectionResolvers<ContextType>;
	CAOBRefundSummaryRow?: CaobRefundSummaryRowResolvers<ContextType>;
	CAOBRefundSummaryRowAggregateSelection?: CaobRefundSummaryRowAggregateSelectionResolvers<ContextType>;
	Case?: CaseResolvers<ContextType>;
	CaseAggregateSelection?: CaseAggregateSelectionResolvers<ContextType>;
	CaseBaseAgreementConnection?: CaseBaseAgreementConnectionResolvers<ContextType>;
	CaseBaseAgreementRelationship?: CaseBaseAgreementRelationshipResolvers<ContextType>;
	CaseClaimsConnection?: CaseClaimsConnectionResolvers<ContextType>;
	CaseClaimsRelationship?: CaseClaimsRelationshipResolvers<ContextType>;
	CaseCohortConnection?: CaseCohortConnectionResolvers<ContextType>;
	CaseCohortRelationship?: CaseCohortRelationshipResolvers<ContextType>;
	CaseCoverageRequestsConnection?: CaseCoverageRequestsConnectionResolvers<ContextType>;
	CaseCoverageRequestsRelationship?: CaseCoverageRequestsRelationshipResolvers<ContextType>;
	CaseDiseaseConnection?: CaseDiseaseConnectionResolvers<ContextType>;
	CaseDiseaseRelationship?: CaseDiseaseRelationshipResolvers<ContextType>;
	CaseFinancialDataPointsConnection?: CaseFinancialDataPointsConnectionResolvers<ContextType>;
	CaseFinancialDataPointsRelationship?: CaseFinancialDataPointsRelationshipResolvers<ContextType>;
	CaseFlexEntitiesConnection?: CaseFlexEntitiesConnectionResolvers<ContextType>;
	CaseFlexEntitiesRelationship?: CaseFlexEntitiesRelationshipResolvers<ContextType>;
	CaseFlexFinancialDataPointsConnection?: CaseFlexFinancialDataPointsConnectionResolvers<ContextType>;
	CaseFlexFinancialDataPointsRelationship?: CaseFlexFinancialDataPointsRelationshipResolvers<ContextType>;
	CaseIndicationConnection?: CaseIndicationConnectionResolvers<ContextType>;
	CaseIndicationRelationship?: CaseIndicationRelationshipResolvers<ContextType>;
	CaseLegalEntityConnection?: CaseLegalEntityConnectionResolvers<ContextType>;
	CaseLegalEntityRelationship?: CaseLegalEntityRelationshipResolvers<ContextType>;
	CasePatientConnection?: CasePatientConnectionResolvers<ContextType>;
	CasePatientRelationship?: CasePatientRelationshipResolvers<ContextType>;
	CasePreparationsConnection?: CasePreparationsConnectionResolvers<ContextType>;
	CasePreparationsRelationship?: CasePreparationsRelationshipResolvers<ContextType>;
	CasePrimaryInterventionConnection?: CasePrimaryInterventionConnectionResolvers<ContextType>;
	CasePrimaryInterventionRelationship?: CasePrimaryInterventionRelationshipResolvers<ContextType>;
	CaseRecordBatchesConnection?: CaseRecordBatchesConnectionResolvers<ContextType>;
	CaseRecordBatchesRelationship?: CaseRecordBatchesRelationshipResolvers<ContextType>;
	CaseReportDataPoint?: CaseReportDataPointResolvers<ContextType>;
	CaseReportDataPointAggregateSelection?: CaseReportDataPointAggregateSelectionResolvers<ContextType>;
	CaseStobContractConnection?: CaseStobContractConnectionResolvers<ContextType>;
	CaseStobContractRelationship?: CaseStobContractRelationshipResolvers<ContextType>;
	CaseTaskRelationship?: CaseTaskRelationshipResolvers<ContextType>;
	Claim?: ClaimResolvers<ContextType>;
	ClaimAggregateSelection?: ClaimAggregateSelectionResolvers<ContextType>;
	ClaimCasesConnection?: ClaimCasesConnectionResolvers<ContextType>;
	ClaimCasesRelationship?: ClaimCasesRelationshipResolvers<ContextType>;
	ClaimEnrolledIntoCaseRelationship?: ClaimEnrolledIntoCaseRelationshipResolvers<ContextType>;
	ClaimFinancialDataPointsConnection?: ClaimFinancialDataPointsConnectionResolvers<ContextType>;
	ClaimFinancialDataPointsRelationship?: ClaimFinancialDataPointsRelationshipResolvers<ContextType>;
	ClaimIncludesConnection?: ClaimIncludesConnectionResolvers<ContextType>;
	ClaimIncludesRelationship?: ClaimIncludesRelationshipResolvers<ContextType>;
	ClaimReceivedFromPatientConnection?: ClaimReceivedFromPatientConnectionResolvers<ContextType>;
	ClaimReceivedFromPatientRelationship?: ClaimReceivedFromPatientRelationshipResolvers<ContextType>;
	ClaimRecordConnection?: ClaimRecordConnectionResolvers<ContextType>;
	ClaimRecordRelationship?: ClaimRecordRelationshipResolvers<ContextType>;
	ContinuousBenefit?: ContinuousBenefitResolvers<ContextType>;
	ContinuousBenefitAdverseEventsConnection?: ContinuousBenefitAdverseEventsConnectionResolvers<ContextType>;
	ContinuousBenefitAdverseEventsRelationship?: ContinuousBenefitAdverseEventsRelationshipResolvers<ContextType>;
	ContinuousBenefitAggregateSelection?: ContinuousBenefitAggregateSelectionResolvers<ContextType>;
	ContinuousBenefitCoverageRequestConnection?: ContinuousBenefitCoverageRequestConnectionResolvers<ContextType>;
	ContinuousBenefitCoverageRequestRelationship?: ContinuousBenefitCoverageRequestRelationshipResolvers<ContextType>;
	ContinuousBenefitFinancialDataPointsConnection?: ContinuousBenefitFinancialDataPointsConnectionResolvers<ContextType>;
	ContinuousBenefitFinancialDataPointsRelationship?: ContinuousBenefitFinancialDataPointsRelationshipResolvers<ContextType>;
	ContinuousBenefitFormConnection?: ContinuousBenefitFormConnectionResolvers<ContextType>;
	ContinuousBenefitFormRelationship?: ContinuousBenefitFormRelationshipResolvers<ContextType>;
	ContinuousBenefitInitialResponseConnection?: ContinuousBenefitInitialResponseConnectionResolvers<ContextType>;
	ContinuousBenefitInitialResponseRelationship?: ContinuousBenefitInitialResponseRelationshipResolvers<ContextType>;
	ContinuousBenefitPrescribedTreatmentsConnection?: ContinuousBenefitPrescribedTreatmentsConnectionResolvers<ContextType>;
	ContinuousBenefitPrescribedTreatmentsRelationship?: ContinuousBenefitPrescribedTreatmentsRelationshipResolvers<ContextType>;
	ContinuousBenefitRecordsConnection?: ContinuousBenefitRecordsConnectionResolvers<ContextType>;
	ContinuousBenefitRecordsRelationship?: ContinuousBenefitRecordsRelationshipResolvers<ContextType>;
	ContinuousBenefitTreatingPhysicianConnection?: ContinuousBenefitTreatingPhysicianConnectionResolvers<ContextType>;
	ContinuousBenefitTreatingPhysicianRelationship?: ContinuousBenefitTreatingPhysicianRelationshipResolvers<ContextType>;
	ContractNotification?: ContractNotificationResolvers<ContextType>;
	ContractNotificationAggregateSelection?: ContractNotificationAggregateSelectionResolvers<ContextType>;
	ContractNotificationTriggersConnection?: ContractNotificationTriggersConnectionResolvers<ContextType>;
	ContractNotificationTriggersRelationship?: ContractNotificationTriggersRelationshipResolvers<ContextType>;
	ContractWorkflow?: ContractWorkflowResolvers<ContextType>;
	ContractWorkflowAggregateSelection?: ContractWorkflowAggregateSelectionResolvers<ContextType>;
	ContractWorkflowOrganizationConnection?: ContractWorkflowOrganizationConnectionResolvers<ContextType>;
	ContractWorkflowOrganizationRelationship?: ContractWorkflowOrganizationRelationshipResolvers<ContextType>;
	ContractWorkflowStep?: ContractWorkflowStepResolvers<ContextType>;
	ContractWorkflowStepAggregateSelection?: ContractWorkflowStepAggregateSelectionResolvers<ContextType>;
	ContractWorkflowStepResponsiblePersonConnection?: ContractWorkflowStepResponsiblePersonConnectionResolvers<ContextType>;
	ContractWorkflowStepResponsiblePersonRelationship?: ContractWorkflowStepResponsiblePersonRelationshipResolvers<ContextType>;
	ContractWorkflowStepsConnection?: ContractWorkflowStepsConnectionResolvers<ContextType>;
	ContractWorkflowStepsRelationship?: ContractWorkflowStepsRelationshipResolvers<ContextType>;
	CounterpartyRoleRelationship?: CounterpartyRoleRelationshipResolvers<ContextType>;
	CoverageRequest?: CoverageRequestResolvers<ContextType>;
	CoverageRequestAggregateSelection?: CoverageRequestAggregateSelectionResolvers<ContextType>;
	CoverageRequestCaseConnection?: CoverageRequestCaseConnectionResolvers<ContextType>;
	CoverageRequestCaseRelationship?: CoverageRequestCaseRelationshipResolvers<ContextType>;
	CoverageRequestContinuousBenefitsWithDraftsConnection?: CoverageRequestContinuousBenefitsWithDraftsConnectionResolvers<ContextType>;
	CoverageRequestContinuousBenefitsWithDraftsRelationship?: CoverageRequestContinuousBenefitsWithDraftsRelationshipResolvers<ContextType>;
	CoverageRequestCreatedByConnection?: CoverageRequestCreatedByConnectionResolvers<ContextType>;
	CoverageRequestCreatedByRelationship?: CoverageRequestCreatedByRelationshipResolvers<ContextType>;
	CoverageRequestDiscontinuationNoteConnection?: CoverageRequestDiscontinuationNoteConnectionResolvers<ContextType>;
	CoverageRequestDiscontinuationNoteRelationship?: CoverageRequestDiscontinuationNoteRelationshipResolvers<ContextType>;
	CoverageRequestDiseaseConnection?: CoverageRequestDiseaseConnectionResolvers<ContextType>;
	CoverageRequestDiseaseRelationship?: CoverageRequestDiseaseRelationshipResolvers<ContextType>;
	CoverageRequestFinancialDataPointsConnection?: CoverageRequestFinancialDataPointsConnectionResolvers<ContextType>;
	CoverageRequestFinancialDataPointsRelationship?: CoverageRequestFinancialDataPointsRelationshipResolvers<ContextType>;
	CoverageRequestFormConnection?: CoverageRequestFormConnectionResolvers<ContextType>;
	CoverageRequestFormRelationship?: CoverageRequestFormRelationshipResolvers<ContextType>;
	CoverageRequestIndicationConnection?: CoverageRequestIndicationConnectionResolvers<ContextType>;
	CoverageRequestIndicationRelationship?: CoverageRequestIndicationRelationshipResolvers<ContextType>;
	CoverageRequestInitialResponseConnection?: CoverageRequestInitialResponseConnectionResolvers<ContextType>;
	CoverageRequestInitialResponseRelationship?: CoverageRequestInitialResponseRelationshipResolvers<ContextType>;
	CoverageRequestLegalEntityConnection?: CoverageRequestLegalEntityConnectionResolvers<ContextType>;
	CoverageRequestLegalEntityRelationship?: CoverageRequestLegalEntityRelationshipResolvers<ContextType>;
	CoverageRequestPatientConnection?: CoverageRequestPatientConnectionResolvers<ContextType>;
	CoverageRequestPatientRelationship?: CoverageRequestPatientRelationshipResolvers<ContextType>;
	CoverageRequestPreparationsConnection?: CoverageRequestPreparationsConnectionResolvers<ContextType>;
	CoverageRequestPreparationsRelationship?: CoverageRequestPreparationsRelationshipResolvers<ContextType>;
	CoverageRequestTreatingPhysicianConnection?: CoverageRequestTreatingPhysicianConnectionResolvers<ContextType>;
	CoverageRequestTreatingPhysicianRelationship?: CoverageRequestTreatingPhysicianRelationshipResolvers<ContextType>;
	CoverageRequestUnsortedContinuousBenefitsConnection?: CoverageRequestUnsortedContinuousBenefitsConnectionResolvers<ContextType>;
	CoverageRequestUnsortedContinuousBenefitsRelationship?: CoverageRequestUnsortedContinuousBenefitsRelationshipResolvers<ContextType>;
	CreateAdverseEventsOccurenceReportsMutationResponse?: CreateAdverseEventsOccurenceReportsMutationResponseResolvers<ContextType>;
	CreateInfo?: CreateInfoResolvers<ContextType>;
	CreateInitialResponseReviewReportsMutationResponse?: CreateInitialResponseReviewReportsMutationResponseResolvers<ContextType>;
	CreateReasonOfTreatmentDiscontinuationReportsMutationResponse?: CreateReasonOfTreatmentDiscontinuationReportsMutationResponseResolvers<ContextType>;
	CreateUsersMutationResponse?: CreateUsersMutationResponseResolvers<ContextType>;
	Currency?: CurrencyResolvers<ContextType>;
	CurrencyAggregateSelection?: CurrencyAggregateSelectionResolvers<ContextType>;
	DataContainer?: DataContainerResolvers<ContextType>;
	DataContainerAggregateSelection?: DataContainerAggregateSelectionResolvers<ContextType>;
	DataContainerProvidersConnection?: DataContainerProvidersConnectionResolvers<ContextType>;
	DataContainerProvidersRelationship?: DataContainerProvidersRelationshipResolvers<ContextType>;
	DataSource?: DataSourceResolvers<ContextType>;
	DataSourceAggregateSelection?: DataSourceAggregateSelectionResolvers<ContextType>;
	Date?: GraphQLScalarType;
	DateTime?: GraphQLScalarType;
	DateTimeAggregateSelection?: DateTimeAggregateSelectionResolvers<ContextType>;
	DeleteInfo?: DeleteInfoResolvers<ContextType>;
	DeviceAlternative?: DeviceAlternativeResolvers<ContextType>;
	DeviceAlternativeAggregateSelection?: DeviceAlternativeAggregateSelectionResolvers<ContextType>;
	DeviceAlternativeAlternativesConnection?: DeviceAlternativeAlternativesConnectionResolvers<ContextType>;
	DeviceAlternativeAlternativesRelationship?: DeviceAlternativeAlternativesRelationshipResolvers<ContextType>;
	DeviceAlternativeDeviceProductConnection?: DeviceAlternativeDeviceProductConnectionResolvers<ContextType>;
	DeviceAlternativeDeviceProductRelationship?: DeviceAlternativeDeviceProductRelationshipResolvers<ContextType>;
	DeviceFinancialDataPoint?: DeviceFinancialDataPointResolvers<ContextType>;
	DeviceFinancialDataPointAggregateSelection?: DeviceFinancialDataPointAggregateSelectionResolvers<ContextType>;
	DeviceFinancialDataPointProcessedDeviceRecordConnection?: DeviceFinancialDataPointProcessedDeviceRecordConnectionResolvers<ContextType>;
	DeviceFinancialDataPointProcessedDeviceRecordRelationship?: DeviceFinancialDataPointProcessedDeviceRecordRelationshipResolvers<ContextType>;
	DeviceKit?: DeviceKitResolvers<ContextType>;
	DeviceKitAggregateSelection?: DeviceKitAggregateSelectionResolvers<ContextType>;
	DeviceProductCategory?: DeviceProductCategoryResolvers<ContextType>;
	DeviceProductCategoryAggregateSelection?: DeviceProductCategoryAggregateSelectionResolvers<ContextType>;
	DeviceProductCategoryParentConnection?: DeviceProductCategoryParentConnectionResolvers<ContextType>;
	DeviceProductCategoryParentRelationship?: DeviceProductCategoryParentRelationshipResolvers<ContextType>;
	DeviceProvider?: DeviceProviderResolvers<ContextType>;
	DeviceProviderAggregateSelection?: DeviceProviderAggregateSelectionResolvers<ContextType>;
	DeviceRecord?: DeviceRecordResolvers<ContextType>;
	DeviceRecordAggregateSelection?: DeviceRecordAggregateSelectionResolvers<ContextType>;
	DeviceRecordCategoryConnection?: DeviceRecordCategoryConnectionResolvers<ContextType>;
	DeviceRecordCategoryRelationship?: DeviceRecordCategoryRelationshipResolvers<ContextType>;
	DeviceRecordProcessedAsConnection?: DeviceRecordProcessedAsConnectionResolvers<ContextType>;
	DeviceRecordProcessedAsRelationship?: DeviceRecordProcessedAsRelationshipResolvers<ContextType>;
	DeviceRecordProviderConnection?: DeviceRecordProviderConnectionResolvers<ContextType>;
	DeviceRecordProviderRelationship?: DeviceRecordProviderRelationshipResolvers<ContextType>;
	DeviceRecordRecordConnection?: DeviceRecordRecordConnectionResolvers<ContextType>;
	DeviceRecordRecordRelationship?: DeviceRecordRecordRelationshipResolvers<ContextType>;
	DiscontinuationNote?: DiscontinuationNoteResolvers<ContextType>;
	DiscontinuationNoteAggregateSelection?: DiscontinuationNoteAggregateSelectionResolvers<ContextType>;
	DiscontinuationNoteCoverageRequestConnection?: DiscontinuationNoteCoverageRequestConnectionResolvers<ContextType>;
	DiscontinuationNoteCoverageRequestRelationship?: DiscontinuationNoteCoverageRequestRelationshipResolvers<ContextType>;
	DiscontinuationNoteFormConnection?: DiscontinuationNoteFormConnectionResolvers<ContextType>;
	DiscontinuationNoteFormRelationship?: DiscontinuationNoteFormRelationshipResolvers<ContextType>;
	Disease?: DiseaseResolvers<ContextType>;
	DiseaseAggregateSelection?: DiseaseAggregateSelectionResolvers<ContextType>;
	Document?: DocumentResolvers<ContextType>;
	DocumentAggregateSelection?: DocumentAggregateSelectionResolvers<ContextType>;
	DocumentAssignedToConnection?: DocumentAssignedToConnectionResolvers<ContextType>;
	DocumentAssignedToRelationship?: DocumentAssignedToRelationshipResolvers<ContextType>;
	DocumentRefundsConnection?: DocumentRefundsConnectionResolvers<ContextType>;
	DocumentRefundsRelationship?: DocumentRefundsRelationshipResolvers<ContextType>;
	DocumentTagsConnection?: DocumentTagsConnectionResolvers<ContextType>;
	DocumentTagsRelationship?: DocumentTagsRelationshipResolvers<ContextType>;
	EligibilityConditionSet?: EligibilityConditionSetResolvers<ContextType>;
	EligibilityConditionSetAggregateSelection?: EligibilityConditionSetAggregateSelectionResolvers<ContextType>;
	EnrollingConditionDiseaseRelationship?: EnrollingConditionDiseaseRelationshipResolvers<ContextType>;
	EnrollingConditionSet?: EnrollingConditionSetResolvers<ContextType>;
	EnrollingConditionSetAggregateSelection?: EnrollingConditionSetAggregateSelectionResolvers<ContextType>;
	EnrollingConditionSetAgreementConnection?: EnrollingConditionSetAgreementConnectionResolvers<ContextType>;
	EnrollingConditionSetAgreementRelationship?: EnrollingConditionSetAgreementRelationshipResolvers<ContextType>;
	EnrollingConditionSetDiseasesConnection?: EnrollingConditionSetDiseasesConnectionResolvers<ContextType>;
	EnrollingConditionSetDiseasesRelationship?: EnrollingConditionSetDiseasesRelationshipResolvers<ContextType>;
	EnrollingConditionSetIndicationsConnection?: EnrollingConditionSetIndicationsConnectionResolvers<ContextType>;
	EnrollingConditionSetIndicationsRelationship?: EnrollingConditionSetIndicationsRelationshipResolvers<ContextType>;
	EnrollingConditionSetPreparationsConnection?: EnrollingConditionSetPreparationsConnectionResolvers<ContextType>;
	EnrollingConditionSetPreparationsRelationship?: EnrollingConditionSetPreparationsRelationshipResolvers<ContextType>;
	EnrollingConditionSetTreatmentsConnection?: EnrollingConditionSetTreatmentsConnectionResolvers<ContextType>;
	EnrollingConditionSetTreatmentsRelationship?: EnrollingConditionSetTreatmentsRelationshipResolvers<ContextType>;
	EnrollingPeriod?: EnrollingPeriodResolvers<ContextType>;
	EnrollingPeriodAggregateSelection?: EnrollingPeriodAggregateSelectionResolvers<ContextType>;
	ExFactoryPrice?: ExFactoryPriceResolvers<ContextType>;
	ExFactoryPriceAggregateSelection?: ExFactoryPriceAggregateSelectionResolvers<ContextType>;
	FinancialDataPoint?: FinancialDataPointResolvers<ContextType>;
	FinancialDataPointAggregateSelection?: FinancialDataPointAggregateSelectionResolvers<ContextType>;
	FinancialDataPointAgreementConnection?: FinancialDataPointAgreementConnectionResolvers<ContextType>;
	FinancialDataPointAgreementRelationship?: FinancialDataPointAgreementRelationshipResolvers<ContextType>;
	FinancialDataPointClaimConnection?: FinancialDataPointClaimConnectionResolvers<ContextType>;
	FinancialDataPointClaimRelationship?: FinancialDataPointClaimRelationshipResolvers<ContextType>;
	FinancialDataPointContinuousBenefitConnection?: FinancialDataPointContinuousBenefitConnectionResolvers<ContextType>;
	FinancialDataPointContinuousBenefitRelationship?: FinancialDataPointContinuousBenefitRelationshipResolvers<ContextType>;
	FinancialDataPointCoverageRequestConnection?: FinancialDataPointCoverageRequestConnectionResolvers<ContextType>;
	FinancialDataPointCoverageRequestRelationship?: FinancialDataPointCoverageRequestRelationshipResolvers<ContextType>;
	FinancialDataPointIncludedInConnection?: FinancialDataPointIncludedInConnectionResolvers<ContextType>;
	FinancialDataPointIncludedInRelationship?: FinancialDataPointIncludedInRelationshipResolvers<ContextType>;
	FinancialDataPointInterventionConnection?: FinancialDataPointInterventionConnectionResolvers<ContextType>;
	FinancialDataPointInterventionRelationship?: FinancialDataPointInterventionRelationshipResolvers<ContextType>;
	FinancialDataPointSourceRefundConnection?: FinancialDataPointSourceRefundConnectionResolvers<ContextType>;
	FinancialDataPointSourceRefundRelationship?: FinancialDataPointSourceRefundRelationshipResolvers<ContextType>;
	FinancialDataPointTreatmentConnection?: FinancialDataPointTreatmentConnectionResolvers<ContextType>;
	FinancialDataPointTreatmentRelationship?: FinancialDataPointTreatmentRelationshipResolvers<ContextType>;
	FinancialReportDataPoint?: FinancialReportDataPointResolvers<ContextType>;
	FinancialReportDataPointAggregateSelection?: FinancialReportDataPointAggregateSelectionResolvers<ContextType>;
	FinancialSummaryColumn?: FinancialSummaryColumnResolvers<ContextType>;
	FinancialSummaryColumnAggregateSelection?: FinancialSummaryColumnAggregateSelectionResolvers<ContextType>;
	FinancialSummaryRow?: FinancialSummaryRowResolvers<ContextType>;
	FinancialSummaryRowAggregateSelection?: FinancialSummaryRowAggregateSelectionResolvers<ContextType>;
	FlexEntity?: FlexEntityResolvers<ContextType>;
	FlexEntityAggregateSelection?: FlexEntityAggregateSelectionResolvers<ContextType>;
	FlexEntityCasesConnection?: FlexEntityCasesConnectionResolvers<ContextType>;
	FlexEntityCasesRelationship?: FlexEntityCasesRelationshipResolvers<ContextType>;
	FlexEntityChildrenConnection?: FlexEntityChildrenConnectionResolvers<ContextType>;
	FlexEntityChildrenRelationship?: FlexEntityChildrenRelationshipResolvers<ContextType>;
	FlexEntityCreatedByConnection?: FlexEntityCreatedByConnectionResolvers<ContextType>;
	FlexEntityCreatedByRelationship?: FlexEntityCreatedByRelationshipResolvers<ContextType>;
	FlexEntityDataPointsConnection?: FlexEntityDataPointsConnectionResolvers<ContextType>;
	FlexEntityDataPointsRelationship?: FlexEntityDataPointsRelationshipResolvers<ContextType>;
	FlexEntityPatientConnection?: FlexEntityPatientConnectionResolvers<ContextType>;
	FlexEntityPatientRelationship?: FlexEntityPatientRelationshipResolvers<ContextType>;
	FlexEntitySourceConnection?: FlexEntitySourceConnectionResolvers<ContextType>;
	FlexEntitySourceRelationship?: FlexEntitySourceRelationshipResolvers<ContextType>;
	FlexEntityStartingPointConnection?: FlexEntityStartingPointConnectionResolvers<ContextType>;
	FlexEntityStartingPointRelationship?: FlexEntityStartingPointRelationshipResolvers<ContextType>;
	FlexEntityType?: FlexEntityTypeResolvers<ContextType>;
	FlexEntityTypeAddedByConnection?: FlexEntityTypeAddedByConnectionResolvers<ContextType>;
	FlexEntityTypeAddedByRelationship?: FlexEntityTypeAddedByRelationshipResolvers<ContextType>;
	FlexEntityTypeAggregateSelection?: FlexEntityTypeAggregateSelectionResolvers<ContextType>;
	FlexEntityTypeConnection?: FlexEntityTypeConnectionResolvers<ContextType>;
	FlexEntityTypeInstancesConnection?: FlexEntityTypeInstancesConnectionResolvers<ContextType>;
	FlexEntityTypeInstancesRelationship?: FlexEntityTypeInstancesRelationshipResolvers<ContextType>;
	FlexEntityTypeRelationship?: FlexEntityTypeRelationshipResolvers<ContextType>;
	FlexFinancialDataPoint?: FlexFinancialDataPointResolvers<ContextType>;
	FlexFinancialDataPointAggregateSelection?: FlexFinancialDataPointAggregateSelectionResolvers<ContextType>;
	FlexFinancialDataPointAgreementConnection?: FlexFinancialDataPointAgreementConnectionResolvers<ContextType>;
	FlexFinancialDataPointAgreementRelationship?: FlexFinancialDataPointAgreementRelationshipResolvers<ContextType>;
	FlexFinancialDataPointEvaluatesConnection?: FlexFinancialDataPointEvaluatesConnectionResolvers<ContextType>;
	FlexFinancialDataPointEvaluatesRelationship?: FlexFinancialDataPointEvaluatesRelationshipResolvers<ContextType>;
	FlexFinancialDataPointIncludedInConnection?: FlexFinancialDataPointIncludedInConnectionResolvers<ContextType>;
	FlexFinancialDataPointIncludedInRelationship?: FlexFinancialDataPointIncludedInRelationshipResolvers<ContextType>;
	FlexFinancialDataPointSourceRefundConnection?: FlexFinancialDataPointSourceRefundConnectionResolvers<ContextType>;
	FlexFinancialDataPointSourceRefundRelationship?: FlexFinancialDataPointSourceRefundRelationshipResolvers<ContextType>;
	FlexFinancialDataPointStartingPointConnection?: FlexFinancialDataPointStartingPointConnectionResolvers<ContextType>;
	FlexFinancialDataPointStartingPointRelationship?: FlexFinancialDataPointStartingPointRelationshipResolvers<ContextType>;
	FlexFinancialDataPointTreatmentConnection?: FlexFinancialDataPointTreatmentConnectionResolvers<ContextType>;
	FlexFinancialDataPointTreatmentRelationship?: FlexFinancialDataPointTreatmentRelationshipResolvers<ContextType>;
	FloatAggregateSelection?: FloatAggregateSelectionResolvers<ContextType>;
	Form?: FormResolvers<ContextType>;
	FormAggregateSelection?: FormAggregateSelectionResolvers<ContextType>;
	FormContinuousBenefitConnection?: FormContinuousBenefitConnectionResolvers<ContextType>;
	FormContinuousBenefitRelationship?: FormContinuousBenefitRelationshipResolvers<ContextType>;
	FormCoverageRequestConnection?: FormCoverageRequestConnectionResolvers<ContextType>;
	FormCoverageRequestRelationship?: FormCoverageRequestRelationshipResolvers<ContextType>;
	FormDiscontinuationNoteConnection?: FormDiscontinuationNoteConnectionResolvers<ContextType>;
	FormDiscontinuationNoteRelationship?: FormDiscontinuationNoteRelationshipResolvers<ContextType>;
	FormInitialResponseConnection?: FormInitialResponseConnectionResolvers<ContextType>;
	FormInitialResponseRelationship?: FormInitialResponseRelationshipResolvers<ContextType>;
	FormPrimaryInterventionConnection?: FormPrimaryInterventionConnectionResolvers<ContextType>;
	FormPrimaryInterventionRelationship?: FormPrimaryInterventionRelationshipResolvers<ContextType>;
	FormSubsequentInterventionConnection?: FormSubsequentInterventionConnectionResolvers<ContextType>;
	FormSubsequentInterventionRelationship?: FormSubsequentInterventionRelationshipResolvers<ContextType>;
	GQLBaseResponse?: GqlBaseResponseResolvers<ContextType>;
	IDAggregateSelection?: IdAggregateSelectionResolvers<ContextType>;
	IOrdered?: IOrderedResolvers<ContextType>;
	ITimeframe?: ITimeframeResolvers<ContextType>;
	ITreatmentState?: ITreatmentStateResolvers<ContextType>;
	Indication?: IndicationResolvers<ContextType>;
	IndicationAggregateSelection?: IndicationAggregateSelectionResolvers<ContextType>;
	InitialResponse?: InitialResponseResolvers<ContextType>;
	InitialResponseAdverseEventsConnection?: InitialResponseAdverseEventsConnectionResolvers<ContextType>;
	InitialResponseAdverseEventsRelationship?: InitialResponseAdverseEventsRelationshipResolvers<ContextType>;
	InitialResponseAggregateSelection?: InitialResponseAggregateSelectionResolvers<ContextType>;
	InitialResponseContinuousBenefitConnection?: InitialResponseContinuousBenefitConnectionResolvers<ContextType>;
	InitialResponseContinuousBenefitRelationship?: InitialResponseContinuousBenefitRelationshipResolvers<ContextType>;
	InitialResponseCoverageRequestConnection?: InitialResponseCoverageRequestConnectionResolvers<ContextType>;
	InitialResponseCoverageRequestRelationship?: InitialResponseCoverageRequestRelationshipResolvers<ContextType>;
	InitialResponseFormConnection?: InitialResponseFormConnectionResolvers<ContextType>;
	InitialResponseFormRelationship?: InitialResponseFormRelationshipResolvers<ContextType>;
	InitialResponseReviewReport?: InitialResponseReviewReportResolvers<ContextType>;
	InitialResponseReviewReportAggregateSelection?: InitialResponseReviewReportAggregateSelectionResolvers<ContextType>;
	InitialResponseTreatingPhysicianConnection?: InitialResponseTreatingPhysicianConnectionResolvers<ContextType>;
	InitialResponseTreatingPhysicianRelationship?: InitialResponseTreatingPhysicianRelationshipResolvers<ContextType>;
	IntAggregateSelection?: IntAggregateSelectionResolvers<ContextType>;
	Intervention?: InterventionResolvers<ContextType>;
	InterventionAggregateSelection?: InterventionAggregateSelectionResolvers<ContextType>;
	InterventionCaseConnection?: InterventionCaseConnectionResolvers<ContextType>;
	InterventionCaseRelationship?: InterventionCaseRelationshipResolvers<ContextType>;
	InterventionCreatedByConnection?: InterventionCreatedByConnectionResolvers<ContextType>;
	InterventionCreatedByRelationship?: InterventionCreatedByRelationshipResolvers<ContextType>;
	InterventionDiseaseConnection?: InterventionDiseaseConnectionResolvers<ContextType>;
	InterventionDiseaseRelationship?: InterventionDiseaseRelationshipResolvers<ContextType>;
	InterventionFinancialDataPointsConnection?: InterventionFinancialDataPointsConnectionResolvers<ContextType>;
	InterventionFinancialDataPointsRelationship?: InterventionFinancialDataPointsRelationshipResolvers<ContextType>;
	InterventionFormConnection?: InterventionFormConnectionResolvers<ContextType>;
	InterventionFormRelationship?: InterventionFormRelationshipResolvers<ContextType>;
	InterventionLegalEntityConnection?: InterventionLegalEntityConnectionResolvers<ContextType>;
	InterventionLegalEntityRelationship?: InterventionLegalEntityRelationshipResolvers<ContextType>;
	InterventionMainItemConnection?: InterventionMainItemConnectionResolvers<ContextType>;
	InterventionMainItemRelationship?: InterventionMainItemRelationshipResolvers<ContextType>;
	InterventionPatientConnection?: InterventionPatientConnectionResolvers<ContextType>;
	InterventionPatientRelationship?: InterventionPatientRelationshipResolvers<ContextType>;
	InterventionReportStatusResponse?: InterventionReportStatusResponseResolvers<ContextType>;
	InterventionReportStatusResponseAggregateSelection?: InterventionReportStatusResponseAggregateSelectionResolvers<ContextType>;
	InterventionSubsequentInterventionConnection?: InterventionSubsequentInterventionConnectionResolvers<ContextType>;
	InterventionSubsequentInterventionRelationship?: InterventionSubsequentInterventionRelationshipResolvers<ContextType>;
	InterventionSupportingItemConnection?: InterventionSupportingItemConnectionResolvers<ContextType>;
	InterventionSupportingItemRelationship?: InterventionSupportingItemRelationshipResolvers<ContextType>;
	InterventionTreatmentRelationship?: InterventionTreatmentRelationshipResolvers<ContextType>;
	InvoiceRefundFinancialDataPoint?: InvoiceRefundFinancialDataPointResolvers<ContextType>;
	ItemUsedDataPoint?: ItemUsedDataPointResolvers<ContextType>;
	ItemUsedDataPointAggregateSelection?: ItemUsedDataPointAggregateSelectionResolvers<ContextType>;
	Limitation?: LimitationResolvers<ContextType>;
	LimitationAggregateSelection?: LimitationAggregateSelectionResolvers<ContextType>;
	LimitationLimitsPreparationsConnection?: LimitationLimitsPreparationsConnectionResolvers<ContextType>;
	LimitationLimitsPreparationsRelationship?: LimitationLimitsPreparationsRelationshipResolvers<ContextType>;
	LimitationLimitsTreatmentConnection?: LimitationLimitsTreatmentConnectionResolvers<ContextType>;
	LimitationLimitsTreatmentRelationship?: LimitationLimitsTreatmentRelationshipResolvers<ContextType>;
	Message?: MessageResolvers<ContextType>;
	MessageAggregateSelection?: MessageAggregateSelectionResolvers<ContextType>;
	MessageMentionsConnection?: MessageMentionsConnectionResolvers<ContextType>;
	MessageMentionsRelationship?: MessageMentionsRelationshipResolvers<ContextType>;
	MessageRefundConnection?: MessageRefundConnectionResolvers<ContextType>;
	MessageRefundRelationship?: MessageRefundRelationshipResolvers<ContextType>;
	MessageSentByConnection?: MessageSentByConnectionResolvers<ContextType>;
	MessageSentByRelationship?: MessageSentByRelationshipResolvers<ContextType>;
	MicroContent?: MicroContentResolvers<ContextType>;
	MicroContentAggregateSelection?: MicroContentAggregateSelectionResolvers<ContextType>;
	Module?: ModuleResolvers<ContextType>;
	ModuleAggregateSelection?: ModuleAggregateSelectionResolvers<ContextType>;
	Mutation?: MutationResolvers<ContextType>;
	NetRevenueByOrganization?: NetRevenueByOrganizationResolvers<ContextType>;
	NetRevenueByOrganizationAggregateSelection?: NetRevenueByOrganizationAggregateSelectionResolvers<ContextType>;
	Notification?: NotificationResolvers<ContextType>;
	NotificationAggregateSelection?: NotificationAggregateSelectionResolvers<ContextType>;
	NotificationDueConnection?: NotificationDueConnectionResolvers<ContextType>;
	NotificationDueRelationship?: NotificationDueRelationshipResolvers<ContextType>;
	NotificationNotifiedConnection?: NotificationNotifiedConnectionResolvers<ContextType>;
	NotificationNotifiedRelationship?: NotificationNotifiedRelationshipResolvers<ContextType>;
	NotificationSubscribedConnection?: NotificationSubscribedConnectionResolvers<ContextType>;
	NotificationSubscribedRelationship?: NotificationSubscribedRelationshipResolvers<ContextType>;
	NotificationTrigger?: NotificationTriggerResolvers<ContextType>;
	NotificationTriggerAggregateSelection?: NotificationTriggerAggregateSelectionResolvers<ContextType>;
	Organization?: OrganizationResolvers<ContextType>;
	OrganizationAggregateSelection?: OrganizationAggregateSelectionResolvers<ContextType>;
	OutcomebasedAgreementReport?: OutcomebasedAgreementReportResolvers<ContextType>;
	OutcomebasedAgreementReportAggregateSelection?: OutcomebasedAgreementReportAggregateSelectionResolvers<ContextType>;
	PIRecurrenceSIDataPoint?: PiRecurrenceSiDataPointResolvers<ContextType>;
	PIRecurrenceSIDataPointAggregateSelection?: PiRecurrenceSiDataPointAggregateSelectionResolvers<ContextType>;
	PageInfo?: PageInfoResolvers<ContextType>;
	Partner?: PartnerResolvers<ContextType>;
	PartnerAggregateSelection?: PartnerAggregateSelectionResolvers<ContextType>;
	PartnerTreatmentConnection?: PartnerTreatmentConnectionResolvers<ContextType>;
	PartnerTreatmentRelationship?: PartnerTreatmentRelationshipResolvers<ContextType>;
	Patient?: PatientResolvers<ContextType>;
	PatientAggregateSelection?: PatientAggregateSelectionResolvers<ContextType>;
	PatientAssignedFlexEntitiesConnection?: PatientAssignedFlexEntitiesConnectionResolvers<ContextType>;
	PatientAssignedFlexEntitiesRelationship?: PatientAssignedFlexEntitiesRelationshipResolvers<ContextType>;
	PatientCasesConnection?: PatientCasesConnectionResolvers<ContextType>;
	PatientCasesRelationship?: PatientCasesRelationshipResolvers<ContextType>;
	PatientClaimsConnection?: PatientClaimsConnectionResolvers<ContextType>;
	PatientClaimsRelationship?: PatientClaimsRelationshipResolvers<ContextType>;
	PatientCountDataPoint?: PatientCountDataPointResolvers<ContextType>;
	PatientCountDataPointAggregateSelection?: PatientCountDataPointAggregateSelectionResolvers<ContextType>;
	PatientCoverageRequestsConnection?: PatientCoverageRequestsConnectionResolvers<ContextType>;
	PatientCoverageRequestsRelationship?: PatientCoverageRequestsRelationshipResolvers<ContextType>;
	PatientPrimaryInterventionConnection?: PatientPrimaryInterventionConnectionResolvers<ContextType>;
	PatientPrimaryInterventionRelationship?: PatientPrimaryInterventionRelationshipResolvers<ContextType>;
	PatientReportDataPoint?: PatientReportDataPointResolvers<ContextType>;
	PatientReportDataPointAggregateSelection?: PatientReportDataPointAggregateSelectionResolvers<ContextType>;
	PatientSentClaimConnection?: PatientSentClaimConnectionResolvers<ContextType>;
	PatientSentClaimRelationship?: PatientSentClaimRelationshipResolvers<ContextType>;
	PatientStatusDistribution?: PatientStatusDistributionResolvers<ContextType>;
	PatientStatusDistributionAggregateSelection?: PatientStatusDistributionAggregateSelectionResolvers<ContextType>;
	PatientsPerMonthDataPoint?: PatientsPerMonthDataPointResolvers<ContextType>;
	PatientsPerMonthDataPointAggregateSelection?: PatientsPerMonthDataPointAggregateSelectionResolvers<ContextType>;
	Preparation?: PreparationResolvers<ContextType>;
	PreparationAggregateSelection?: PreparationAggregateSelectionResolvers<ContextType>;
	PreparationBrandConnection?: PreparationBrandConnectionResolvers<ContextType>;
	PreparationBrandRelationship?: PreparationBrandRelationshipResolvers<ContextType>;
	PreparationCoverageRequestCombinedConnection?: PreparationCoverageRequestCombinedConnectionResolvers<ContextType>;
	PreparationCoverageRequestCombinedRelationship?: PreparationCoverageRequestCombinedRelationshipResolvers<ContextType>;
	PreparationCoverageRequestConnection?: PreparationCoverageRequestConnectionResolvers<ContextType>;
	PreparationCoverageRequestRelationship?: PreparationCoverageRequestRelationshipResolvers<ContextType>;
	PreparationHasLimitationsConnection?: PreparationHasLimitationsConnectionResolvers<ContextType>;
	PreparationHasLimitationsRelationship?: PreparationHasLimitationsRelationshipResolvers<ContextType>;
	PreparationRegulatesConnection?: PreparationRegulatesConnectionResolvers<ContextType>;
	PreparationRegulatesRelationship?: PreparationRegulatesRelationshipResolvers<ContextType>;
	PreparationStatus?: PreparationStatusResolvers<ContextType>;
	PreparationStatusAggregateSelection?: PreparationStatusAggregateSelectionResolvers<ContextType>;
	PreparationStatusPreparationConnection?: PreparationStatusPreparationConnectionResolvers<ContextType>;
	PreparationStatusPreparationRelationship?: PreparationStatusPreparationRelationshipResolvers<ContextType>;
	Price?: PriceResolvers<ContextType>;
	PriceAggregateSelection?: PriceAggregateSelectionResolvers<ContextType>;
	PriceTreatmentConnection?: PriceTreatmentConnectionResolvers<ContextType>;
	PriceTreatmentRelationship?: PriceTreatmentRelationshipResolvers<ContextType>;
	ProcessedDeviceRecord?: ProcessedDeviceRecordResolvers<ContextType>;
	ProcessedDeviceRecordAggregateSelection?: ProcessedDeviceRecordAggregateSelectionResolvers<ContextType>;
	ProcessedDeviceRecordAgreementConnection?: ProcessedDeviceRecordAgreementConnectionResolvers<ContextType>;
	ProcessedDeviceRecordAgreementRelationship?: ProcessedDeviceRecordAgreementRelationshipResolvers<ContextType>;
	ProcessedDeviceRecordDeviceRecordConnection?: ProcessedDeviceRecordDeviceRecordConnectionResolvers<ContextType>;
	ProcessedDeviceRecordDeviceRecordRelationship?: ProcessedDeviceRecordDeviceRecordRelationshipResolvers<ContextType>;
	ProcessedDeviceRecordFinancialDataPointsConnection?: ProcessedDeviceRecordFinancialDataPointsConnectionResolvers<ContextType>;
	ProcessedDeviceRecordFinancialDataPointsRelationship?: ProcessedDeviceRecordFinancialDataPointsRelationshipResolvers<ContextType>;
	PublicPrice?: PublicPriceResolvers<ContextType>;
	PublicPriceAggregateSelection?: PublicPriceAggregateSelectionResolvers<ContextType>;
	Query?: QueryResolvers<ContextType>;
	ReasonOfTreatmentDiscontinuationReport?: ReasonOfTreatmentDiscontinuationReportResolvers<ContextType>;
	ReasonOfTreatmentDiscontinuationReportAggregateSelection?: ReasonOfTreatmentDiscontinuationReportAggregateSelectionResolvers<ContextType>;
	RecommendedForm?: RecommendedFormResolvers<ContextType>;
	RecommendedFormAggregateSelection?: RecommendedFormAggregateSelectionResolvers<ContextType>;
	Record?: RecordResolvers<ContextType>;
	RecordAggregateSelection?: RecordAggregateSelectionResolvers<ContextType>;
	RecordBatch?: RecordBatchResolvers<ContextType>;
	RecordBatchAggregateSelection?: RecordBatchAggregateSelectionResolvers<ContextType>;
	RecordBatchFinancialDataPointsConnection?: RecordBatchFinancialDataPointsConnectionResolvers<ContextType>;
	RecordBatchFinancialDataPointsRelationship?: RecordBatchFinancialDataPointsRelationshipResolvers<ContextType>;
	RecordDeviceRecordConnection?: RecordDeviceRecordConnectionResolvers<ContextType>;
	RecordDeviceRecordRelationship?: RecordDeviceRecordRelationshipResolvers<ContextType>;
	Refund?: RefundResolvers<ContextType>;
	RefundAggregateSelection?: RefundAggregateSelectionResolvers<ContextType>;
	RefundCaseConnection?: RefundCaseConnectionResolvers<ContextType>;
	RefundCaseRelationship?: RefundCaseRelationshipResolvers<ContextType>;
	RefundInvoiceFinancialDataPointsConnection?: RefundInvoiceFinancialDataPointsConnectionResolvers<ContextType>;
	RefundInvoiceFinancialDataPointsRelationship?: RefundInvoiceFinancialDataPointsRelationshipResolvers<ContextType>;
	RefundInvoicesConnection?: RefundInvoicesConnectionResolvers<ContextType>;
	RefundInvoicesRelationship?: RefundInvoicesRelationshipResolvers<ContextType>;
	RefundMessageConnection?: RefundMessageConnectionResolvers<ContextType>;
	RefundMessageRelationship?: RefundMessageRelationshipResolvers<ContextType>;
	RefundSourceFinancialDataPointsConnection?: RefundSourceFinancialDataPointsConnectionResolvers<ContextType>;
	RefundSourceFinancialDataPointsRelationship?: RefundSourceFinancialDataPointsRelationshipResolvers<ContextType>;
	RefundTagsConnection?: RefundTagsConnectionResolvers<ContextType>;
	RefundTagsRelationship?: RefundTagsRelationshipResolvers<ContextType>;
	ReportingSummary?: ReportingSummaryResolvers<ContextType>;
	ReportingSummaryAggregateSelection?: ReportingSummaryAggregateSelectionResolvers<ContextType>;
	Scenario?: ScenarioResolvers<ContextType>;
	ScenarioAction?: ScenarioActionResolvers<ContextType>;
	ScenarioActionAggregateSelection?: ScenarioActionAggregateSelectionResolvers<ContextType>;
	ScenarioActionBrandConnection?: ScenarioActionBrandConnectionResolvers<ContextType>;
	ScenarioActionBrandRelationship?: ScenarioActionBrandRelationshipResolvers<ContextType>;
	ScenarioActionCategoriesConnection?: ScenarioActionCategoriesConnectionResolvers<ContextType>;
	ScenarioActionCategoriesRelationship?: ScenarioActionCategoriesRelationshipResolvers<ContextType>;
	ScenarioActionCombinedItemBrandsConnection?: ScenarioActionCombinedItemBrandsConnectionResolvers<ContextType>;
	ScenarioActionCombinedItemBrandsRelationship?: ScenarioActionCombinedItemBrandsRelationshipResolvers<ContextType>;
	ScenarioActionCombinedItemTreatmentsConnection?: ScenarioActionCombinedItemTreatmentsConnectionResolvers<ContextType>;
	ScenarioActionCombinedItemTreatmentsRelationship?: ScenarioActionCombinedItemTreatmentsRelationshipResolvers<ContextType>;
	ScenarioActionDeviceKitsConnection?: ScenarioActionDeviceKitsConnectionResolvers<ContextType>;
	ScenarioActionDeviceKitsRelationship?: ScenarioActionDeviceKitsRelationshipResolvers<ContextType>;
	ScenarioActionScenarioConnection?: ScenarioActionScenarioConnectionResolvers<ContextType>;
	ScenarioActionScenarioRelationship?: ScenarioActionScenarioRelationshipResolvers<ContextType>;
	ScenarioActionTimeframeConnection?: ScenarioActionTimeframeConnectionResolvers<ContextType>;
	ScenarioActionTimeframeRelationship?: ScenarioActionTimeframeRelationshipResolvers<ContextType>;
	ScenarioActionTreatmentConnection?: ScenarioActionTreatmentConnectionResolvers<ContextType>;
	ScenarioActionTreatmentRelationship?: ScenarioActionTreatmentRelationshipResolvers<ContextType>;
	ScenarioActionsConnection?: ScenarioActionsConnectionResolvers<ContextType>;
	ScenarioActionsRelationship?: ScenarioActionsRelationshipResolvers<ContextType>;
	ScenarioAggregateSelection?: ScenarioAggregateSelectionResolvers<ContextType>;
	ScenarioAgreementConnection?: ScenarioAgreementConnectionResolvers<ContextType>;
	ScenarioAgreementRelationship?: ScenarioAgreementRelationshipResolvers<ContextType>;
	ScenarioCondition?: ScenarioConditionResolvers<ContextType>;
	ScenarioConditionAggregateSelection?: ScenarioConditionAggregateSelectionResolvers<ContextType>;
	ScenarioConditionBrandConnection?: ScenarioConditionBrandConnectionResolvers<ContextType>;
	ScenarioConditionBrandRelationship?: ScenarioConditionBrandRelationshipResolvers<ContextType>;
	ScenarioConditionDeviceKitsConnection?: ScenarioConditionDeviceKitsConnectionResolvers<ContextType>;
	ScenarioConditionDeviceKitsRelationship?: ScenarioConditionDeviceKitsRelationshipResolvers<ContextType>;
	ScenarioConditionScenarioConnection?: ScenarioConditionScenarioConnectionResolvers<ContextType>;
	ScenarioConditionScenarioRelationship?: ScenarioConditionScenarioRelationshipResolvers<ContextType>;
	ScenarioConditionTimeframeConnection?: ScenarioConditionTimeframeConnectionResolvers<ContextType>;
	ScenarioConditionTimeframeRelationship?: ScenarioConditionTimeframeRelationshipResolvers<ContextType>;
	ScenarioConditionTreatmentConnection?: ScenarioConditionTreatmentConnectionResolvers<ContextType>;
	ScenarioConditionTreatmentRelationship?: ScenarioConditionTreatmentRelationshipResolvers<ContextType>;
	ScenarioConditionsConnection?: ScenarioConditionsConnectionResolvers<ContextType>;
	ScenarioConditionsRelationship?: ScenarioConditionsRelationshipResolvers<ContextType>;
	ScenarioInsightsUserContext?: ScenarioInsightsUserContextResolvers<ContextType>;
	SentClaimRelationship?: SentClaimRelationshipResolvers<ContextType>;
	StobAction?: StobActionResolvers<ContextType>;
	StobActionAggregateSelection?: StobActionAggregateSelectionResolvers<ContextType>;
	StobActionScenarioConnection?: StobActionScenarioConnectionResolvers<ContextType>;
	StobActionScenarioRelationship?: StobActionScenarioRelationshipResolvers<ContextType>;
	StobCondition?: StobConditionResolvers<ContextType>;
	StobConditionAggregateSelection?: StobConditionAggregateSelectionResolvers<ContextType>;
	StobConditionScenarioConnection?: StobConditionScenarioConnectionResolvers<ContextType>;
	StobConditionScenarioRelationship?: StobConditionScenarioRelationshipResolvers<ContextType>;
	StobContract?: StobContractResolvers<ContextType>;
	StobContractAggregateSelection?: StobContractAggregateSelectionResolvers<ContextType>;
	StobContractCasesConnection?: StobContractCasesConnectionResolvers<ContextType>;
	StobContractCasesRelationship?: StobContractCasesRelationshipResolvers<ContextType>;
	StobContractCreatorOrganizationConnection?: StobContractCreatorOrganizationConnectionResolvers<ContextType>;
	StobContractCreatorOrganizationRelationship?: StobContractCreatorOrganizationRelationshipResolvers<ContextType>;
	StobContractCurrencyConnection?: StobContractCurrencyConnectionResolvers<ContextType>;
	StobContractCurrencyRelationship?: StobContractCurrencyRelationshipResolvers<ContextType>;
	StobContractDiseaseConnection?: StobContractDiseaseConnectionResolvers<ContextType>;
	StobContractDiseaseRelationship?: StobContractDiseaseRelationshipResolvers<ContextType>;
	StobContractIndicationConnection?: StobContractIndicationConnectionResolvers<ContextType>;
	StobContractIndicationRelationship?: StobContractIndicationRelationshipResolvers<ContextType>;
	StobContractNotificationsConnection?: StobContractNotificationsConnectionResolvers<ContextType>;
	StobContractNotificationsRelationship?: StobContractNotificationsRelationshipResolvers<ContextType>;
	StobContractPartnerConnection?: StobContractPartnerConnectionResolvers<ContextType>;
	StobContractPartnerRelationship?: StobContractPartnerRelationshipResolvers<ContextType>;
	StobContractRecommendedFormsConnection?: StobContractRecommendedFormsConnectionResolvers<ContextType>;
	StobContractRecommendedFormsRelationship?: StobContractRecommendedFormsRelationshipResolvers<ContextType>;
	StobContractScenariosConnection?: StobContractScenariosConnectionResolvers<ContextType>;
	StobContractScenariosRelationship?: StobContractScenariosRelationshipResolvers<ContextType>;
	StobContractStatisticsConnection?: StobContractStatisticsConnectionResolvers<ContextType>;
	StobContractStatisticsRelationship?: StobContractStatisticsRelationshipResolvers<ContextType>;
	StobContractTagsConnection?: StobContractTagsConnectionResolvers<ContextType>;
	StobContractTagsRelationship?: StobContractTagsRelationshipResolvers<ContextType>;
	StobContractTreatmentPriceRelationship?: StobContractTreatmentPriceRelationshipResolvers<ContextType>;
	StobContractTreatmentPricesConnection?: StobContractTreatmentPricesConnectionResolvers<ContextType>;
	StobContractTreatmentPricesRelationship?: StobContractTreatmentPricesRelationshipResolvers<ContextType>;
	StobScenario?: StobScenarioResolvers<ContextType>;
	StobScenarioActionsConnection?: StobScenarioActionsConnectionResolvers<ContextType>;
	StobScenarioActionsRelationship?: StobScenarioActionsRelationshipResolvers<ContextType>;
	StobScenarioAggregateSelection?: StobScenarioAggregateSelectionResolvers<ContextType>;
	StobScenarioConditionsConnection?: StobScenarioConditionsConnectionResolvers<ContextType>;
	StobScenarioConditionsRelationship?: StobScenarioConditionsRelationshipResolvers<ContextType>;
	StobStatistics?: StobStatisticsResolvers<ContextType>;
	StobStatisticsAggregateSelection?: StobStatisticsAggregateSelectionResolvers<ContextType>;
	StringAggregateSelection?: StringAggregateSelectionResolvers<ContextType>;
	Subscription?: SubscriptionResolvers<ContextType>;
	SummaryNotificationDue?: SummaryNotificationDueResolvers<ContextType>;
	Task?: TaskResolvers<ContextType>;
	TaskAggregateSelection?: TaskAggregateSelectionResolvers<ContextType>;
	TaskAgreementConnection?: TaskAgreementConnectionResolvers<ContextType>;
	TaskAgreementRelationship?: TaskAgreementRelationshipResolvers<ContextType>;
	TaskCaseConnection?: TaskCaseConnectionResolvers<ContextType>;
	TaskCaseRelationship?: TaskCaseRelationshipResolvers<ContextType>;
	TaskDocumentConnection?: TaskDocumentConnectionResolvers<ContextType>;
	TaskDocumentRelationship?: TaskDocumentRelationshipResolvers<ContextType>;
	TaskMessageConnection?: TaskMessageConnectionResolvers<ContextType>;
	TaskMessageRelationship?: TaskMessageRelationshipResolvers<ContextType>;
	TaskUsersRelationshipConnection?: TaskUsersRelationshipConnectionResolvers<ContextType>;
	TaskUsersRelationshipRelationship?: TaskUsersRelationshipRelationshipResolvers<ContextType>;
	Timeframe?: TimeframeResolvers<ContextType>;
	TimeframeAggregateSelection?: TimeframeAggregateSelectionResolvers<ContextType>;
	TimeframeRelatedEntity?: TimeframeRelatedEntityResolvers<ContextType>;
	Translation?: TranslationResolvers<ContextType>;
	TranslationAggregateSelection?: TranslationAggregateSelectionResolvers<ContextType>;
	TranslationsResult?: TranslationsResultResolvers<ContextType>;
	TranslationsResultAggregateSelection?: TranslationsResultAggregateSelectionResolvers<ContextType>;
	TreatingPhysician?: TreatingPhysicianResolvers<ContextType>;
	TreatingPhysicianAggregateSelection?: TreatingPhysicianAggregateSelectionResolvers<ContextType>;
	Treatment?: TreatmentResolvers<ContextType>;
	TreatmentAggregateSelection?: TreatmentAggregateSelectionResolvers<ContextType>;
	TreatmentClaimConnection?: TreatmentClaimConnectionResolvers<ContextType>;
	TreatmentClaimRelationship?: TreatmentClaimRelationshipResolvers<ContextType>;
	TreatmentExFactoryPricesConnection?: TreatmentExFactoryPricesConnectionResolvers<ContextType>;
	TreatmentExFactoryPricesRelationship?: TreatmentExFactoryPricesRelationshipResolvers<ContextType>;
	TreatmentHasLimitationsConnection?: TreatmentHasLimitationsConnectionResolvers<ContextType>;
	TreatmentHasLimitationsRelationship?: TreatmentHasLimitationsRelationshipResolvers<ContextType>;
	TreatmentPartnersConnection?: TreatmentPartnersConnectionResolvers<ContextType>;
	TreatmentPartnersRelationship?: TreatmentPartnersRelationshipResolvers<ContextType>;
	TreatmentPatient?: TreatmentPatientResolvers<ContextType>;
	TreatmentPatientAggregateSelection?: TreatmentPatientAggregateSelectionResolvers<ContextType>;
	TreatmentPrescriptionRelationship?: TreatmentPrescriptionRelationshipResolvers<ContextType>;
	TreatmentPublicPricesConnection?: TreatmentPublicPricesConnectionResolvers<ContextType>;
	TreatmentPublicPricesRelationship?: TreatmentPublicPricesRelationshipResolvers<ContextType>;
	TreatmentRegulatedByConnection?: TreatmentRegulatedByConnectionResolvers<ContextType>;
	TreatmentRegulatedByRelationship?: TreatmentRegulatedByRelationshipResolvers<ContextType>;
	TreatmentStatusConnection?: TreatmentStatusConnectionResolvers<ContextType>;
	TreatmentStatusRelationship?: TreatmentStatusRelationshipResolvers<ContextType>;
	UpdateAdverseEventsOccurenceReportsMutationResponse?: UpdateAdverseEventsOccurenceReportsMutationResponseResolvers<ContextType>;
	UpdateInfo?: UpdateInfoResolvers<ContextType>;
	UpdateInitialResponseReviewReportsMutationResponse?: UpdateInitialResponseReviewReportsMutationResponseResolvers<ContextType>;
	UpdateReasonOfTreatmentDiscontinuationReportsMutationResponse?: UpdateReasonOfTreatmentDiscontinuationReportsMutationResponseResolvers<ContextType>;
	UpdateUsersMutationResponse?: UpdateUsersMutationResponseResolvers<ContextType>;
	User?: UserResolvers<ContextType>;
	UserAggregateSelection?: UserAggregateSelectionResolvers<ContextType>;
	UserClaimsConnection?: UserClaimsConnectionResolvers<ContextType>;
	UserClaimsRelationship?: UserClaimsRelationshipResolvers<ContextType>;
	UserContext?: UserContextResolvers<ContextType>;
	UserContextAggregateSelection?: UserContextAggregateSelectionResolvers<ContextType>;
	UserContextBaseAgreementContextConnection?: UserContextBaseAgreementContextConnectionResolvers<ContextType>;
	UserContextBaseAgreementContextRelationship?: UserContextBaseAgreementContextRelationshipResolvers<ContextType>;
	UserContextConnection?: UserContextConnectionResolvers<ContextType>;
	UserContextRelationship?: UserContextRelationshipResolvers<ContextType>;
	UserContextScenariosConnection?: UserContextScenariosConnectionResolvers<ContextType>;
	UserContextScenariosRelationship?: UserContextScenariosRelationshipResolvers<ContextType>;
	UserMentionsConnection?: UserMentionsConnectionResolvers<ContextType>;
	UserMentionsRelationship?: UserMentionsRelationshipResolvers<ContextType>;
	UserMessageRelationship?: UserMessageRelationshipResolvers<ContextType>;
	UserNotificationDueConnection?: UserNotificationDueConnectionResolvers<ContextType>;
	UserNotificationDueRelationship?: UserNotificationDueRelationshipResolvers<ContextType>;
	UserNotificationRelationship?: UserNotificationRelationshipResolvers<ContextType>;
	UserNotifiedConnection?: UserNotifiedConnectionResolvers<ContextType>;
	UserNotifiedRelationship?: UserNotifiedRelationshipResolvers<ContextType>;
	UserOrgSettingsData?: UserOrgSettingsDataResolvers<ContextType>;
	UserOrgSettingsDataAggregateSelection?: UserOrgSettingsDataAggregateSelectionResolvers<ContextType>;
	UserOrganizationInfo?: UserOrganizationInfoResolvers<ContextType>;
	UserOrganizationInfoAggregateSelection?: UserOrganizationInfoAggregateSelectionResolvers<ContextType>;
	UserPatientsConnection?: UserPatientsConnectionResolvers<ContextType>;
	UserPatientsRelationship?: UserPatientsRelationshipResolvers<ContextType>;
	UserPersonalInfo?: UserPersonalInfoResolvers<ContextType>;
	UserPersonalInfoAggregateSelection?: UserPersonalInfoAggregateSelectionResolvers<ContextType>;
	UserSentMessageConnection?: UserSentMessageConnectionResolvers<ContextType>;
	UserSentMessageRelationship?: UserSentMessageRelationshipResolvers<ContextType>;
	UserSubscribedConnection?: UserSubscribedConnectionResolvers<ContextType>;
	UserSubscribedRelationship?: UserSubscribedRelationshipResolvers<ContextType>;
	UserTaskProperties?: UserTaskPropertiesResolvers<ContextType>;
	UserTaskRelationship?: UserTaskRelationshipResolvers<ContextType>;
	UserTasksConnection?: UserTasksConnectionResolvers<ContextType>;
	UserTasksRelationship?: UserTasksRelationshipResolvers<ContextType>;
};

export type DirectiveResolvers<ContextType = any> = {
	dataGuidance?: DataGuidanceDirectiveResolver<any, any, ContextType>;
};
